/* >>> ARQUIVO GERADO pelo montar.js a partir de src/app/ — NAO EDITE AQUI. <<<
   Edite o pedaço certo em src/app/ (um arquivo por página) e rode: node montar.js
   Cada módulo começa no carimbo "╔═══ src/app/..." — o MAPA-GERADO.md diz onde mora cada função. */

/* ╔═══ src/app/00-edicoes.js ═════════════════════════════════════════════ */
/* ============================================================================
   00 — EDIÇÕES DO APP (v486 · ampliado na v496) — "7 apps, UM MOTOR"
   (PROJETO-edicoes-do-app · EXECUTAR-edicoes-consultas-e-avalia ·
    PROJETO-os-4-apps-mev — Fase 1)

   A edição NÃO é um app separado: é o MESMO app com o menu e a home
   mostrando só as páginas dela. Corrigiu um bug → corrigiu em todas.
   NUNCA duplicar código. (O projeto dos 4 apps explica por que não dá pra
   quebrar o app.js de verdade: os 49 pedaços compartilham UM IIFE e se
   chamam aos montes. Um código, várias portas.)

   ⚠️ ONDE ESTE ARQUIVO VIVE NA MONTAGEM: o montar.js cola os pedaços em
   ordem alfabética e o IIFE grande do app abre no 01-nucleo.js e só fecha
   no 19-documentos-e-init.js. Ou seja: ESTE arquivo fica FORA daquele IIFE.
   Ele não enxerga nada de lá (toast, drawerIr, supa...) — e por isso tudo
   aqui é autossuficiente e exposto em window.*. Os módulos de dentro
   chamam com typeof-guard: se este arquivo sumir, o app volta a ser o
   completo de sempre, sem quebrar.

   DETECÇÃO (piloto, sem DNS): app.html?app=<id> grava localStorage
   mev_edicao; ?app=completo limpa. DEFAULT = completo — sem a flag NADA
   muda pra quem já usa.

   REGRA DA CASA: esconder via CLASSE no body (ed-<id>) + display:none.
   NUNCA remover elementos do DOM — pintores e handlers leem o DOM (v437,
   v443…). Página fora da edição nunca dá erro seco: abre a PORTA de
   upsell (que na v496 também leva pra tela Apps MEV — o caminho de volta).

   ⚠️ v496 — O CSS DE ESCONDER É GERADO A PARTIR DO MAPA. Com 6 edições,
   escrever regra na mão por edição não escala (e foi assim que a v437 se
   machucou). Aqui existe UMA fonte da verdade: BLOCOS + COMUNS. Página
   nova no menu? Entra num bloco (ou em COMUNS) e o resto se resolve —
   inclusive o teste da SOMA, que garante que nenhuma tela fica órfã.
   ========================================================================= */
(function(){
  'use strict';

  var ZAP='5551996417433';

  /* ==========================================================================
     ⛳ O INTERRUPTOR DO LANÇAMENTO (v497 · v500) — UMA LINHA, SÓ ESTA
     --------------------------------------------------------------------------
     true  = O APP TEM UMA CARA SÓ: o MEV Completo. A vitrine da família
             (a página "Apps MEV") não aparece pra NINGUÉM — nem pro dono.
             Motivo (pedido do Angelo, 15/08): sete cards com "Instalar" e
             "Usar" fazem o lojista achar que vai baixar sete coisas e
             perder o login. Enquanto os apps não forem produtos de
             verdade, com preço, eles não são vitrine.
     false = lançado: a página aparece pra todos os lojistas.

     O QUE CONTINUA FUNCIONANDO NA PRÉVIA (de propósito):
     · abrir /app.html?app=loja (etc.) entra na edição — é assim que você
       testa e faz piloto com quem quiser;
     · DENTRO de uma edição a página Apps MEV e os cards "Outros apps"
       continuam à mão: é o caminho de volta pro MEV Completo. Sem isso,
       quem entrasse por um link seu ficaria preso no app enxuto.
     ========================================================================== */
  var MEV_PREVIA = true;

  /* ==========================================================================
     1. O MAPA — a única fonte da verdade
     ========================================================================== */

  /* Ações SEMPRE visíveis, em qualquer porta: conta, avisos, ajuda e a
     própria tela Apps MEV (é por ela que se troca de app e se volta pro
     completo — nunca pode ficar de fora). */
  /* v556: 'cotacaovw' é COMUM pelo mesmo motivo do 'painel' — ele já é
     limitado por CONTA (só a loja do dono do MEV), e escondê-lo também por
     edição faria o Angelo perder o espelho ao entrar num MEV Loja/Vendas.
     Quem manda na visibilidade é o cotMenuSync, não a edição. */
  var COMUNS=['inicio','cadastro','notificacoes','pagamentos','suporte','termos','apps','sair','instalar',
              'painel','indicador','historico','apphome','cotacaovw'];

  /* Os blocos. As ações são os data-acao REAIS do menu (app.html) mais as
     ações internas que o drawerIr atende no mesmo assunto.
     ⚠️ 'buscaplaca' está em TODOS de propósito: a consulta de placa é o
     MOTOR de todo o resto (avaliar, cadastrar no estoque, repassar) — foi
     a mesma decisão da v486 pro MEV Avalia. O que diferencia o MEV
     Consultas são as consultas PAGAS (Consulta Plus, CPF, CNPJ e FIPE). */
  /* ⚠️ v499 (pedido): "nos apps separados não mostre os cards e campos de
     consulta". A consulta de placa saiu dos blocos Loja/Vendas/Leads/Rede
     — nesses apps a tela inicial deixa de ser a busca de placa e vira o
     PAINEL do app (05f-home-do-app.js). Ela FICA no MEV Avalia porque é
     por ela que a avaliação começa (é o motor, não uma consulta avulsa) e,
     claro, no MEV Consultas, que é o produto dela.
     Pra tirar (ou devolver) a consulta de um app: uma linha aqui. */
  var BLOCOS={
    consultas:['buscaplaca','buscaveiculo','plus','restricao','cnpj','tema','compartilhar_consultas'],
    avalia:   ['buscaplaca','avaliacoes','tema'],
    /* v537: a 'vitrine' entra no bloco da LOJA — é a tela dos carros dela.
       ⚠️ Sem esta linha o teste-v496 reprova em "nenhuma página órfã": todo
       data-acao do menu precisa pertencer a algum bloco ou aos comuns. */
    /* v659: o 'mercado' entra no bloco da LOJA — é o estoque das OUTRAS lojas,
       o mesmo assunto do Estoque visto do outro lado.
       ⚠️ Sem esta linha o teste-v496 reprova em "nenhuma página órfã": todo
       data-acao do menu precisa pertencer a algum bloco ou aos comuns. */
    loja:     ['loja','estoque','mercado','catalogo','vitrine','repasse_meu','add-estoque'],
    /* v497 (pedido): "vendas, só a página de vendas" — Avaliações saiu
       daqui; ela é o app MEV Avalia (e continua no MEV Rede, que é onde
       vira repasse). */
    vendas:   ['vendas','prerenave','vincular'],
    leads:    ['clientes','chat','posvendas','funil','dashboard','vincular'],
    rede:     ['rede_repasses','rede_seminovos','repasse_meu',
               'repasse','repasse_portal','parceiros','avaliacoes']
  };

  /* As edições. `cons` = abas da barrinha de consultas (data-cons).
     `promo` = grupo do menu que, tendo UM item só, vira item de primeiro
     nível (herança da v486, onde "Avaliações" saiu de dentro de "Loja").

     `inicial` (v497) = O QUE ABRE quando o app entra nesta edição:
       · null      → a inicial de sempre (a consulta de placa). É o caso do
                     MEV Consultas: a placa É o produto dele.
       · 'cards'   → a PÁGINA INICIAL DO APP: um painel com os cards das
                     páginas do bloco (05f-home-do-app.js).
       · <ação>    → abre DIRETO naquela página. É o caso do MEV Avalia:
                     "avaliação só vai ter a página principal" — bloco de
                     uma página só não precisa de painel.
     `destaque` = a caixinha que a grade da home ganha (o caminho de volta
     pro painel do app, ou a página principal quando não há painel). */
  var EDICOES={
    completo:null,   /* null = tudo liberado (o app de hoje) */
    consultas:{ nome:'MEV Consultas', sub:'Consultas veiculares',
      /* v613: as duas páginas novas de CPF (ações/processos e score) entram
         onde o 'cpf' já entrava — são o mesmo produto, agora em páginas
         próprias. Sem isso, a aba nasceria abrindo a porta de upsell na
         edição MEV Consultas. */
      /* v628/v629/v630: as consultas de VEÍCULO (gravame, multas RENAINF e
         RENAJUD) são produto do MEV Consultas — sem esta linha a aba nasceria
         abrindo a porta de upsell nesta edição. */
      cons:['placa','fipe','plus','cpf','cpfproc','cpfscore','cnpj','cnpjsintegra','hist',
        'recall','debitos',
            'proprietarios','gravame','multas','renajud','leilaopt','premium','especialjud'],   /* v1387 */
      /* 🔴 v1050 (pedido do Angelo, 16/09) — AQUI O DESLIZE SÓ VOLTA.
         Ele arrastou o dedo na página do resultado e caiu na Avaliação. Pediu
         duas coisas: que o deslize não troque de página no MEV Consultas, e
         que as Avaliações não sejam alcançáveis de dentro dele — "vai ficar
         disponível só no MEV Avaliações".
         ⚠️ A CHAVE MORA AQUI, e não no módulo do gesto, pela mesma razão que
         o `edPode` foi criado na v918: perguntar "é o MEV Consultas?" dentro
         do 18b espalharia o nome de UMA edição pelos arquivos de gesto. No dia
         em que o MEV Vendas também não puder deslizar entre páginas, muda-se
         esta linha e mais nada. */
      deslize:'so-voltar',
      inicial:null },
    /* ⛳ v912 TROCOU o nome de exibição: era 'MEV Avalia'. O Angelo pediu
       "mev avaliacoes" em 06/09, e o app instalado passou a se chamar
       "MEV Avaliações" (mev-avaliacoes/manifest.json) — dois nomes pro mesmo
       produto é como o cliente acha que comprou coisas diferentes.
       ⚠️ O id continua `avalia`, e isso é decisão, não preguiça: ele está nos
       links (?app=avalia), nas classes do CSS (body.ed-avalia), no BLOCOS e
       em todos os testes. É a mesma regra que a v502 aplicou quando "MEV
       Loja" virou MEV Estoque: muda-se o NOME, nunca o id.

       🔴 E ESTE COMENTÁRIO EXISTE POR UM SEGUNDO MOTIVO. Na primeira vez que
       esta linha foi trocada, eu gravei a MINHA cópia inteira deste arquivo
       por cima da v911 de outra conversa e apaguei o bloco CSS dela — 5 das
       11 verificações do teste-v911 dela ficaram vermelhas. O arquivo voltou
       do commit `6ed397b` ("antes de publicar v911") e a troca foi refeita
       COMO DELTA, que é o que o item 3 do CLAUDE.md manda. Se você vier
       mexer aqui: compare com o disco antes de gravar. */
    avalia:{ nome:'MEV Avaliações', sub:'Avaliação de veículos',
      cons:['placa','hist'], promo:[],
      inicial:null, destaque:['avaliacoes','Avaliações'] },
    /* v499 — nos quatro abaixo a TELA INICIAL é o painel do app (o
       05f monta dentro da própria home, no lugar da busca de placa), então
       `inicial` volta a ser null: abrir o app já cai no painel. O `painel`
       é a lista exata de cards, na ordem que o Angelo ditou. */
    /* ⚠️ v502 — MUDOU O NOME, NÃO O id. "MEV Loja" virou MEV ESTOQUE e
       "MEV Leads" virou MEV CRM (palavras do Angelo, 15/08). O id continua
       `loja`/`leads` de propósito: ele está nos links (?app=loja), nas
       classes do CSS (body.ed-loja), no BLOCOS e em todos os testes.
       Trocar o id renomearia meia dúzia de arquivos pra ganhar nada. */
    loja:{ nome:'MEV Estoque', sub:'Estoque, catálogo e site',
      cons:[],
      /* v497 (pedido, na ordem em que ele ditou): "estoque com estoque
         catalogo, repasses" + "minha loja". */
      inicial:null, painel:['estoque','catalogo','repasse_meu','loja'] },
    vendas:{ nome:'MEV Vendas', sub:'Cotação, documentos e venda',
      cons:[],
      inicial:'vendas', painel:['vendas'] },
    leads:{ nome:'MEV CRM', sub:'Clientes e pós-venda',   /* v502: era "MEV Leads" */
      cons:[], promo:['crm'],
      /* v497 (pedido): "leads com clientes, pos vendas, chat" →
         "chat acho que nao precisa" */
      inicial:null, painel:['clientes','posvendas'] },
    rede:{ nome:'MEV Rede', sub:'Repasse entre lojas',
      cons:[],
      inicial:null, painel:['rede_repasses','rede_seminovos','repasse_meu'] }
  };
  /* monta paginas = bloco + comuns (um lugar só; ninguém repete a lista) */
  (function(){
    /* v996 — o 'cnpjrisco' saiu do concat: o produto não existe mais. */
    EDICOES.avalia.cons=EDICOES.consultas.cons.slice();
    for(var k in EDICOES){ if(!EDICOES[k]) continue;
      EDICOES[k].paginas=(BLOCOS[k]||[]).concat(COMUNS);
    }
  })();

  /* Os GRUPOS do menu do app.html: quem é cabeçalho de quem. É daqui que
     sai a decisão de esconder o cabeçalho inteiro (grupo sem nenhum item
     da edição) ou promover o único item que sobrou. */
  var GRUPOS=[
    { id:'consultas', hi:'mdrConsultas', sub:'mdrConsSub', caret:'mdrConsCaret', rotulo:'Consultas',
      acoes:['buscaplaca','buscaveiculo','plus','restricao','cnpj'] },
    { id:'loja', hi:'mdrLoja', sub:'mdrLojaSub', caret:'mdrLojaCaret', rotulo:'Lojista',
      /* 🔴 v537: 'vitrine' precisa entrar AQUI TAMBÉM, não só no BLOCOS.
         São duas listas com trabalhos diferentes e é fácil confundir:
           · BLOCOS   = de QUAL EDIÇÃO a página é;
           · GRUPOS   = de QUAL GRUPO DO MENU o botão é.
         Eu tinha atualizado só a primeira, e o teste-v496 reprovou em "o mapa
         conhece as N ações do menu" — havia um data-acao no app.html que o
         mapa não conhecia. Na prática isso significa que o CSS das edições
         não saberia esconder o botão numa edição sem Loja. */
      acoes:['loja','estoque','mercado','prerenave','repasse_meu','catalogo','vitrine','vendas','avaliacoes'] },   /* v746: 'mercado' (v659) estava órfão aqui */
    /* v531: era `rotulo:null` porque a seção CRM não TINHA rótulo — quem
       nomeava era o próprio botão-cabeçalho. Com o botão escondido, nasceu
       o `<div class="mdr-grp">CRM</div>` no app.html, e o rótulo precisa
       constar aqui pra ganhar a classe `ed-rot-crm` e sumir junto numa
       edição sem páginas de CRM. Sem esta linha sobraria a palavra "CRM"
       sozinha, encabeçando nada. */
    { id:'crm', hi:'mdrCrm', sub:'mdrCrmSub', caret:'mdrCrmCaret', rotulo:'CRM',
      acoes:['dashboard','clientes','chat','posvendas','funil'] },
    /* v746 — os dois grupos novos do menu compacto (o rótulo agora é o próprio
       botão .mdr-hi; `rotulo` fica só pela compatibilidade do ed-rot-*) */
    { id:'rede', hi:'mdrRede', sub:'mdrRedeSub', caret:'mdrRedeCaret', rotulo:'Rede de lojistas',
      acoes:['rede_repasses','rede_seminovos','cotacaovw'] },
    { id:'conta', hi:'mdrConta', sub:'mdrContaSub', caret:'mdrContaCaret', rotulo:'Conta e suporte',
      acoes:['apps','tokens','pagamentos','tema','instalar','notificacoes','termos','suporte','compartilhar_consultas','sair'] }
  ];
  /* itens do menu que não moram em grupo nenhum */
  /* v556: 'cotacaovw' entra AQUI também, e não só no COMUNS — são listas
     com trabalhos diferentes, e confundir as duas foi o meu erro que o
     teste da soma (v496) pegou: SOLTOS é o INVENTÁRIO ("que itens existem
     no menu"), COMUNS é a PERMISSÃO ("quem aparece em toda edição"). Sem o
     inventário, a ação virava órfã: item no app.html que o mapa não conhece. */
  var SOLTOS=['inicio','cadastro','painel'];
  /* as abas da barrinha de consultas (data-cons do 05d — chaves PRÓPRIAS,
     não são data-acao; 'hist' não tem aba, entra pelo histórico da home) */
  var CONS_TODAS=['placa','fipe','plus','cpf','cnpj'];
  /* TODAS as ações que existem no menu (é o que o teste da soma confere) */
  function _todasAcoes(){
    var t=[]; GRUPOS.forEach(function(g){ t=t.concat(g.acoes); });
    return t.concat(SOLTOS);
  }

  /* Pedaços de tela que pertencem a uma ação: somem junto com ela.
     (balões, atalhos da home, item da topbar, cards do menu do veículo) */
  var UI2ACAO=[
    ['#btnSiteFab','loja'], ['#btnCatalogoFab','catalogo'], ['#btnChatFab','chat'],
    ['.ct-fabs [data-ctf="lojahub"]','loja'], ['.ct-fabs [data-ctf="site"]','loja'],
    /* 🔴 v639 — SEM O NOME DO CONTÊINER. Estas três linhas diziam
       `#homeAtalhos [data-ha="…"]`, e a v626 trocou os dois contêineres da
       home (#homeAtalhos e .ct-fabs) por um painel só (.hp-grade). O seletor
       continuou lá, bonito, apontando pra um lugar que não existe mais — e
       um seletor que não acha nada não avisa ninguém: ele só deixa de
       esconder. Resultado: o "Site" aparecia na home de quem não tem a Loja.
       Agora a regra olha o ATALHO (data-ha), não a caixa onde ele mora. */
    ['[data-ha="lojahub"]','loja'], ['[data-ha="site"]','loja'],
    ['[data-ha="clientes"]','clientes'],
    /* ⛳ v920 — A LINHA DO "Minha loja" DA LISTA DA CONTA SAIU DAQUI.
       Era: ['#mevTopbar .tb-mi[data-tbm="loja"]','loja']
       Ela NUNCA escondeu nada: o #tbMenu é pendurado no BODY (veja o
       tbMenuMontar, no 05d-abas-consultas.js), não dentro do #mevTopbar.
       Seletor que não acha nada não avisa ninguém — exatamente o defeito
       que o comentário logo acima descreve. O "Minha loja" continuou
       aparecendo no MEV Consultas por causa disso.
       🔑 Agora quem barra é a MONTAGEM da lista (_tbItens), que pergunta
       ao edPode antes de criar o botão. O item não nasce, em vez de nascer
       invisível. Nada a esconder aqui, então nada a listar aqui. */
    ['.menu-card[data-tela="seminovo"]','avaliacoes'],
    /* ⛳ v639: o card "avl" da grade da home saiu (virou o card 'avaliacoes'
       do grupo Lojista, que já obedece à edição pela homeAtalhosLista).
       A linha fica aqui, desligada, mostrando o caminho:
       ['.cons-tabs [data-cons="avl"]','avaliacoes'],   // v595 */
    ['.menu-card[data-tela="plus"]','plus'],
    ['.menu-lista .grp-h:has(.grp-saldo)','plus']
  ];

  /* ação barrada → produto sugerido na porta de upsell */
  var ACAO2PRODUTO={
    avaliacoes:'MEV Avalia',
    loja:'MEV Estoque', estoque:'MEV Estoque', catalogo:'MEV Estoque', repasse_meu:'MEV Estoque',
    vendas:'MEV Vendas', prerenave:'MEV Vendas',
    clientes:'MEV CRM', chat:'MEV CRM', posvendas:'MEV CRM',
    funil:'MEV CRM', dashboard:'MEV CRM',
    rede_repasses:'MEV Rede', rede_seminovos:'MEV Rede', repasse:'MEV Rede',
    buscaveiculo:'MEV Consultas', plus:'MEV Consultas',
    restricao:'MEV Consultas', cnpj:'MEV Consultas'
  };
  /* produto → id da edição (pra porta oferecer "usar agora", não só WhatsApp) */
  var PRODUTO2ED={ 'MEV Consultas':'consultas', 'MEV Avalia':'avalia',
    'MEV Estoque':'loja', 'MEV Vendas':'vendas', 'MEV CRM':'leads',
    'MEV Rede':'rede', 'MEV Completo':'completo' };

  /* ==========================================================================
     2. Detecção e estado
     ========================================================================== */
  /* ===== v501 (pedido: "link tá vindo MEV Avalia — quero o completo") =====
     A edição GRUDAVA: uma vez aberto com ?app=avalia, ficava gravado no
     localStorage e TODA abertura seguinte vinha naquela edição, mesmo
     abrindo o endereço normal. Foi o que aconteceu com o Angelo testando.

     Agora a edição vale por SESSÃO (sessionStorage): quem manda é o
     endereço. Sem ?app= na URL, o app abre no MEV COMPLETO — sempre.
     Com ?app=loja, fica na edição enquanto aquela aba/janela estiver
     aberta (recarregar não perde), e acaba quando fecha.

     ⚠️ Isto é o certo enquanto os apps não são produto: o link do piloto
     leva a pessoa pra edição e ninguém fica preso nela pra sempre. Quando
     existir ícone próprio por app (fase 2 dos manifests), cada ícone abre
     com o seu ?app= no start_url e o efeito é o mesmo, sem grudar.
     A faxina abaixo LIBERTA quem já ficou preso (o Angelo inclusive). */
  function _lsGet(){
    /* QUEM MANDA É O ENDEREÇO. Sem ?app= na URL, não há edição: é o MEV
       Completo. Recarregar dentro de uma edição não perde nada, porque o
       ?app= continua na barra de endereço (e o edicaoTrocar sempre recarrega
       COM ele). Nada é gravado — é por isso que não gruda mais. */
    try{
      /* v1172 — a área autenticada de consultas usa o endereço limpo do
         site. A query antiga permanece para a PWA e links já distribuídos. */
      if(/^\/consultas\/?$/.test(location.pathname||'')) return 'consultas';
      var m=/[?&]app=([a-z]+)/.exec(location.search||'');
      return (m&&m[1]!=='completo')?m[1]:'';
    }
    catch(_){ return ''; }
  }
  function _lsSet(){ /* v501: não existe mais estado gravado — ver _lsGet */ }
  (function _faxinaEdicaoAntiga(){
    /* liberta quem ficou preso numa edição das versões anteriores (o Angelo
       inclusive: "link tá vindo MEV Avalia — quero o completo") */
    try{ localStorage.removeItem('mev_edicao'); }catch(_){}
    try{ sessionStorage.removeItem('mev_edicao'); }catch(_){}
  })();
  (function(){ /* ?app= manda; sem ela vale o que ficou gravado */
    try{
      var m=/[?&]app=([a-z]+)/.exec(location.search||'');
      if(m){ var q=m[1]; if(q==='completo') _lsSet(''); else if(EDICOES[q]) _lsSet(q); }
      /* v493 — MEDIÇÃO do rodapé público (Parte A do 3em1): o link chega
         com &de=aval|catalogo|laudo dizendo QUAL página pública trouxe a
         pessoa. Só carimba; o relatório de downloads por origem vem depois. */
      var o=/[?&]de=([a-z]+)/.exec(location.search||'');
      if(o){ try{ localStorage.setItem('mev_edicao_de', o[1]); }catch(_){} }
    }catch(_){}
  })();
  function edicaoAtual(){ var e=_lsGet(); return (e&&EDICOES[e])?e:'completo'; }
  function edicaoInfo(){ var e=edicaoAtual(); return e==='completo'?null:{id:e,nome:EDICOES[e].nome,sub:EDICOES[e].sub}; }
  function _edPermite(e,acao){
    if(e==='completo') return true;
    /* v948 — além da operação Avaliações, a gaveta oferece as duas vitrines
       públicas da própria loja. `catalogo` e `repasse_meu` ganham uma rota
       especial no drawerIr: sem plano abrem somente a página pública; com
       plano elegível entram na gestão. Não liberar `estoque` aqui — isso
       ressuscitaria o app de loja inteiro dentro do MEV Avaliações. */
    if(e==='avalia') return ['avaliacoes','consultas','buscaplaca','buscaveiculo','historico','plus','restricao','cnpj','catalogo','repasse_meu','tokens','pagamentos','cadastro','tema'].indexOf(String(acao||''))!==-1;
    /* v1322 — no MEV Consultas o primeiro destino do drawer agora é a Home.
       A consulta de placa continua permitida como recurso da própria Home,
       mas deixa de ser uma entrada duplicada no menu. */
    if(acao==='inicio') return true;
    if(acao==='apps' && (MEV_EDICOES_SOZINHAS||{})[e]) return false;
    return EDICOES[e].paginas.indexOf(String(acao||''))!==-1;
  }
  function edicaoPermite(acao){ return _edPermite(edicaoAtual(),acao); }
  /* ==========================================================================
     🔴 v1050 — O DESLIZE TROCA DE PÁGINA NESTA EDIÇÃO?
     --------------------------------------------------------------------------
     Responde NÃO só onde a edição pediu (`deslize:'so-voltar'`). Sem edição,
     ou com o módulo fora de ordem, responde SIM — mesma regra do `edPode`:
     um portão que trava por acidente tira um gesto que a pessoa usa todo dia,
     então a falha cai pro lado de DEIXAR funcionar.
     ⚠️ "So voltar" é exatamente isso: o arrastar pra trás (a setinha)
     CONTINUA. O que sai é pular pra outra página do menu. */
  function edicaoDeslizaEntrePaginas(){
    try{
      var e=edicaoAtual(); if(e==='completo') return true;
      return (EDICOES[e]||{}).deslize!=='so-voltar';
    }catch(_){ return true; }
  }
  /* ==========================================================================
     🔴 v918 — edPode(): O PORTÃO QUE NUNCA EXPLODE
     --------------------------------------------------------------------------
     (PROJETO "MEV Consultas sem links para outros aplicativos", 06/09)

     O projeto pedia um helper `mevConsultasIsolado()`. Ele NÃO foi criado, e
     a razão é a que o próprio projeto dá na linha seguinte ("ou um helper
     equivalente já existente"): perguntar "é o MEV Consultas?" espalha o nome
     de UMA edição por meia dúzia de arquivos. No dia em que o MEV Vendas
     também não puder abrir o estoque, tudo isso teria que ser reescrito.

     A pergunta certa já existe e é `edicaoPermite(acao)`: "esta edição tem
     esta página?". No MEV Consultas ela já responde `false` pra estoque,
     vendas, avaliações e clientes — de graça, pelo mapa BLOCOS+COMUNS.

     🔑 O `edPode` é só o invólucro seguro dela, e existe por um motivo
     prático: quem chama mora no IIFE grande (02, 05, 05d), onde a função só
     chega por `window`. Sem `window.edicaoPermite` — módulo fora de ordem,
     boot pela metade — ele responde SIM. Portão que trava por acidente
     esconde o app inteiro; a falha tem que cair pro lado de mostrar. */
  function edPode(acao){
    try{ return (typeof window.edicaoPermite!=='function') || !!window.edicaoPermite(acao); }
    catch(_){ return true; }
  }
  function edConsPermite(key){
    var e=edicaoAtual(); if(e==='completo') return true;
    if(e==='avalia') return EDICOES.consultas.cons.indexOf(String(key||''))!==-1;   /* v996 */
    return EDICOES[e].cons.indexOf(String(key||''))!==-1;
  }
  /* v496 — a caixinha de destaque da grade da home (o "principal" do bloco).
     Devolve [acao, rótulo] ou null. O 05d desenha; a ação vai pro drawerIr. */
  function edicaoDestaque(){
    var e=edicaoAtual(); if(e==='completo') return null;
    return EDICOES[e].destaque||null;
  }
  /* v497 — o que abre ao entrar no app: null · 'cards' · uma ação */
  function edicaoInicial(){
    var e=edicaoAtual(); if(e==='completo') return null;
    return EDICOES[e].inicial||null;
  }
  /* v497 — os cards do painel do app. Sem `painel` declarado, cai no bloco
     inteiro (menos a consulta de placa, que é motor e não destino). */
  function edicaoPainel(){
    var e=edicaoAtual(); if(e==='completo') return [];
    var ed=EDICOES[e];
    if(ed.painel) return ed.painel.slice();
    return (BLOCOS[e]||[]).filter(function(a){ return a!=='buscaplaca'; });
  }
  /* ==========================================================================
     v499 (pedido) — "SE O USUÁRIO JÁ TIVER O PACOTE, JÁ ABRE O APP; SE TEM
     O PACOTE, NÃO MOSTRA LANDING PAGE"

     Hoje a conta do MEV dá acesso a TODOS os apps — a edição é FOCO, não
     cadeado. Então isto devolve `true` e ninguém que já tem o produto leva
     porta de venda na cara: a página simplesmente ABRE (e o cartãozinho de
     upsell nem aparece).

     ⛳ É AQUI que a Fase 3 do PROJETO-os-4-apps-mev (vender cada app
     separado) entra: trocar este `true` por uma pergunta ao plano do
     lojista, do mesmo jeito que o 09c-plano-repasse.js faz com o Portal do
     Repasse. A porta e as landings já estão prontas esperando esse dia.
     ========================================================================== */
  function edTemPacote(/* acao */){ return true; }
  /* usado por DENTRO: passa pelo window pra que um override (o teste, ou
     um dia o plano do lojista) valha em todo mundo de uma vez */
  function _temPacote(a){
    try{ return (typeof window.edTemPacote==='function')?window.edTemPacote(a):true; }
    catch(_){ return true; }
  }

  /* v497 — a página "Apps MEV" está visível? (o interruptor lá de cima)
     Quem já está DENTRO de uma edição sempre enxerga: é o caminho de volta
     pro MEV Completo. */
  function edAppsVisivel(/* ehDono */){
    if(edIsolada()) return false;   /* v879 */
    /* 🔴 v881 — dentro do app de loja, some pra TODA edição (inclusive o MEV
       Placas completo). O cliente comprou o app que a ficha da loja descreve;
       chegar no resto da família com dois toques é "conteúdo enganoso" pela
       régua das duas lojas. Fora da loja a porta continua, que é onde serve. */
    if(ehAppDeLoja()) return false;
    if(!MEV_PREVIA) return true;
    /* v500: nem pro dono. No MEV Completo o app tem uma cara só; a vitrine
       da família só existe DENTRO de uma edição, como caminho de volta. */
    return edicaoAtual()!=='completo';
  }
  /* ==========================================================================
     v502 — A FAIXA "COMO VOCÊ QUER TRABALHAR HOJE"
     (pedido do Angelo, 15/08: "onde eu poderia colocar cards pro lojista
      selecionar o que quer trabalhar... o que acha" → faixa na home + item
      no menu, sem mexer no FAB nem na barra superior)

     É o que a v500 combinou pra quando a troca de app voltasse: NÃO uma
     vitrine com "Instalar", e sim UMA LINHA de pílulas dizendo o que a
     pessoa quer ver na tela. Ninguém baixa nada; é a mesma conta.

     ⛳ O interruptor: `false` aqui e a faixa some das duas casas (home e
     menu) sem quebrar nada — a troca de app continua pelo ?app= e pela
     página Apps MEV de dentro de uma edição.

     ⚠️ v503 (pedido do Angelo, 15/08: "oculte, deixe só o mev completo"):
     o interruptor está DESLIGADO. Pelo mesmo motivo da v500 — enquanto os
     apps não forem produto de verdade, com preço, oferecer sete portas na
     primeira tela só cria dúvida em quem abriu o app pra consultar uma
     placa. O app volta a ter UMA cara: o MEV Completo.
     NADA foi apagado: a faixa, as sete edições, as landings e o painel de
     cada app seguem inteiros. Pra trazer de volta é esta linha, `true`.
     Com ela desligada, os cards "Outros apps" voltam a aparecer no painel
     de cada app (05f) — o caminho de volta pro Completo nunca fica sem
     dono pra quem entrar por um link ?app=.

     ⚠️ A ORDEM é a que o Angelo ditou. "Tudo" (o MEV Completo) vem PRIMEIRO
     de propósito: é o estado de hoje, é o que fica pintado quando o app
     abre, e é o CAMINHO DE VOLTA. Sem ele, quem escolhesse o MEV Estoque
     veria a consulta de placa sumir e não saberia como trazer de volta.
     ========================================================================== */
  var MEV_FAIXA = false;   /* v503 — desligada (era true na v502) */
  function edFaixaVisivel(){ return !edIsolada() && !!MEV_FAIXA; }
  function edFaixaOrdem(){
    return ['completo','consultas','avalia','loja','vendas','leads','rede'];
  }

  /* v496 — TROCAR DE APP SEM SAIR (forma 1 do projeto dos 4 apps).
     Recarrega com ?app=<id>: é o caminho que o boot inteiro já conhece
     (CSS, menu, home, splash) — repintar tudo na mão daria divergência. */
  function edicaoTrocar(id){
    id=String(id||'completo');
    if(edIsolada() && id!==edicaoAtual()) return;
    if(id!=='completo' && !EDICOES[id]) return;
    try{ location.href=location.origin+'/app.html?app='+id; }
    catch(_){ _lsSet(id==='completo'?'':id); try{ location.reload(); }catch(__){} }
  }

  /* ==========================================================================
     3. O CSS — GERADO do mapa (styles.css fica em paz)
     ========================================================================== */
  function _cssDaEdicao(id){
    var ed=EDICOES[id]; if(!ed) return '';
    var B='body.ed-'+id+' ';
    var permite=function(a){ return _edPermite(id,a); };
    var out=[];
    /* 3.1 — cada item do menu que não é desta edição */
    _todasAcoes().forEach(function(a){
      if(!permite(a)) out.push(B+'.mdr-nav [data-acao="'+a+'"]{display:none}');
    });
    /* 3.2 — os grupos: sem nenhum item, some o cabeçalho junto */
    var promo=ed.promo||[];
    GRUPOS.forEach(function(g){
      var dentro=g.acoes.filter(permite);
      if(!dentro.length){
        out.push(B+'#'+g.hi+','+B+'#'+g.sub+'{display:none}');
        if(g.rotulo) out.push(B+'.mdr-grp.ed-rot-'+g.id+'{display:none}');
        return;
      }
      /* grupo PROMOVIDO: o cabeçalho some e o que sobrou vira 1º nível
         (é o que a v486 fez com "Avaliações" dentro de "Loja") */
      if(promo.indexOf(g.id)!==-1){
        out.push(B+'#'+g.hi+'{display:none}');
        out.push(B+'#'+g.sub+'{display:block !important;visibility:visible !important}');   /* v746: o acordeão fecha por grid+visibility */
        if(g.rotulo) out.push(B+'.mdr-grp.ed-rot-'+g.id+'{display:none}');
        dentro.forEach(function(a){
          out.push(B+'#'+g.sub+'>[data-acao="'+a+'"]{padding-left:14px;font-size:14px;opacity:1}');
        });
      }
    });
    /* 3.3 — a barrinha de abas de consulta (chaves data-cons, não data-acao) */
    CONS_TODAS.forEach(function(k){
      if(ed.cons.indexOf(k)===-1) out.push(B+'.cons-tabs [data-cons="'+k+'"]{display:none}');
    });
    /* 3.4 — os pedaços de tela que acompanham cada ação */
    UI2ACAO.forEach(function(p){
      /* v499: os CARDS DO MENU DO VEÍCULO só somem de quem NÃO tem o
         pacote (pra quem tem, a página abre normalmente — a edição é foco,
         não cadeado). Balões, atalhos e topbar seguem a edição sempre. */
      if(p[0].indexOf('.menu-')===0 && _temPacote(p[1])) return;
      if(!permite(p[1])) out.push(B+p[0]+'{display:none !important}');
    });
    /* ===== 3.5 (v499, pedido) — APP SEM CONSULTA: A HOME DEIXA DE SER A
       BUSCA DE PLACA. "nos apps separados não mostre os cards e campos de
       consulta — mostre os cards pra acessar os outros apps". Some a
       coluna da busca, a barrinha de abas, o histórico de consultas e a
       grade de atalhos; no lugar entra o painel do app (#homeAppPainel,
       montado pelo 05f). Nada é removido do DOM — regra da casa. */
    if(!permite('buscaplaca')){
      out.push(B+'#consTabsHome{display:none !important}');
      out.push(B+'#telaHome .home-left{display:none !important}');
      out.push(B+'#homeHistCard{display:none !important}');
      out.push(B+'#homeAtalhos{display:none !important}');
      out.push(B+'#btnFotoFab,'+B+'#btnSaldoFab{display:none !important}');
    }
    return out.join('');
  }
  function _css(){
    if(document.getElementById('mevEdicoesCss')) return;
    var todas='';
    for(var k in EDICOES){ if(EDICOES[k]) todas+=_cssDaEdicao(k); }
    var PORTA=''+
      '.ed-porta-bg{position:fixed;inset:0;background:rgba(10,25,47,.55);z-index:12000;'+
        'display:flex;align-items:center;justify-content:center;padding:22px}'+
      '.ed-porta{background:#fff;border-radius:18px;max-width:340px;width:100%;'+
        'padding:24px 20px 18px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.35)}'+
      '.ed-porta-ic{width:52px;height:52px;border-radius:50%;margin:0 auto 10px;'+
        'display:flex;align-items:center;justify-content:center;'+
        'background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
      '.ed-porta-ic svg{width:26px;height:26px}'+
      '.ed-porta h3{margin:0 0 6px;font-size:17px;font-weight:900;color:#0a2540}'+
      '.ed-porta p{margin:0 0 14px;font-size:13.5px;line-height:1.45;color:#475569;font-weight:600}'+
      '.ed-porta-cta{display:block;width:100%;border:0;cursor:pointer;padding:13px;'+
        'border-radius:12px;font-size:14.5px;font-weight:900;color:#fff;'+
        'background:linear-gradient(135deg,#0a4da6,#1769d3);font-family:inherit}'+
      '.ed-porta-apps{display:block;width:100%;border:1.5px solid #dbe6fb;cursor:pointer;'+
        'margin-top:9px;padding:12px;border-radius:12px;font-size:13.5px;font-weight:800;'+
        'color:#0a4da6;background:#eef4ff;font-family:inherit}'+
      '.ed-porta-volta{display:block;width:100%;border:0;background:none;cursor:pointer;'+
        'margin-top:9px;padding:8px;font-size:13px;font-weight:700;color:#64748b;font-family:inherit}'+
      /* cartãozinho inline (fim de fluxo) */
      '.ed-mini-card{display:flex;align-items:center;gap:11px;width:100%;text-align:left;'+
        'border:1.5px dashed #1769d3;background:#f2f7ff;border-radius:14px;'+
        'padding:12px 14px;margin-top:10px;cursor:pointer}'+
      '.ed-mini-card .emc-ic{flex:0 0 38px;width:38px;height:38px;border-radius:50%;'+
        'display:flex;align-items:center;justify-content:center;'+
        'background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
      '.ed-mini-card .emc-ic svg{width:20px;height:20px}'+
      '.ed-mini-card b{display:block;font-size:13.5px;color:#0a2540}'+
      '.ed-mini-card small{display:block;font-size:12px;color:#475569;font-weight:600}'+
      '.ed-mini-card .emc-seta{margin-left:auto;color:#1769d3;font-weight:900}';
    /* ======================================================================
       🔴 v881 — O QUE SOME DENTRO DO APP DE LOJA (classe `body.mev-loja`)
       ----------------------------------------------------------------------
       ⚠️ CLASSE NO BODY + display:none, NUNCA remover do DOM — é a regra
       escrita lá em cima neste arquivo, e vale aqui igual: os pintores e os
       handlers do 11-uso-pagamentos leem esses elementos.

       ⚠️ ISTO É O QUE SE VÊ. O que ACONTECE está travado dentro das funções
       `abrirPacotes()` (01-nucleo) e `assinaturaPagar()` (09-portal-repasse).
       Precisa dos dois: a classe cuida do botão que aparece, a trava cuida do
       caminho que alguém abrir amanhã sem lembrar desta lista.

       🟢 O QUE **NÃO** SOME, de propósito: o chip de saldo (#btnSaldoTopo e
       #btnSaldoFab). Ele mostra quantas consultas sobraram — isso é
       INFORMAÇÃO, não compra. E tocando nele o cliente cai no recado que
       explica onde contratar, em vez de num botão morto. */
    var LOJA=''+
      'body.mev-loja .pag-compra{display:none !important}'+          /* Planos e Pacotes na página Uso e faturamento */
      'body.mev-loja #assinPay{display:none !important}'+            /* "Pagar PIX / Renovar" da assinatura */
      'body.mev-loja [data-pag-plano],body.mev-loja [data-pag-addon]{display:none !important}'+
      /* o recado que ocupa o lugar da lista de pacotes */
      '.pac-loja{margin:6px 0 2px;padding:16px 15px;border-radius:14px;'+
        'background:#f8fafc;border:1px solid #e2e8f0;text-align:left}'+
      '.pac-loja b{display:block;font-size:15px;font-weight:900;color:#0a2540;margin-bottom:7px}'+
      '.pac-loja p{margin:0 0 8px;font-size:13.5px;line-height:1.5;color:#475569;font-weight:600}'+
      '.pac-loja p:last-child{margin-bottom:0}'+
      '.pac-loja .pac-loja-site{font-weight:900;color:#0a4da6}';
    /* v911 — acabamento exclusivo do MEV Consultas. O produto passa a falar
       com público geral, vendedores e lojistas pela mesma porta, sem herdar
       superfícies operacionais do MEV Completo. Tudo é condicionado à classe
       da edição: nenhuma outra home muda. */
    var CONSULTAS=''+
      'body.ed-consultas #tbSino,body.ed-consultas #tbChat,body.ed-consultas #mdrChatBox,'+
      'body.ed-consultas.dock-barra .fab-row #btnChatFab,body.ed-consultas #chatPainel,'+
      'body.ed-consultas .mdr-nav [data-acao="notificacoes"]{display:none!important}'+
      'body.ed-consultas #mevTopbar .tb-in{max-width:1360px}'+
      'body.ed-consultas #mevTopbar .tb-user{margin-left:auto}'+
      'body.ed-consultas:not(.tela-interna):not(.md-veiculo) .wrap{max-width:1360px}'+
      'body.ed-consultas #consTabsHome{max-width:1320px;margin-left:auto!important;margin-right:auto!important}'+
      'body.ed-consultas #homePainel>.hp-grupo{border-radius:18px;box-shadow:0 8px 26px rgba(15,43,87,.055)}'+
      'body.ed-consultas #homePainel>.hp-grupo[data-g="conta"]{background:#f8fafc}'+
      'body.ed-consultas #homePainel>.hp-grupo[data-g="conta"] .hp-grade{grid-template-columns:repeat(3,minmax(0,220px))!important}'+
      'body.ed-consultas #homeHistCard{border-radius:18px;box-shadow:0 8px 26px rgba(15,43,87,.055)}'+
      '@media(min-width:1050px){'+
        'body.ed-consultas:not(.tela-interna):not(.md-veiculo) #scApp #telaHome.home-workspace{display:block!important;max-width:1320px;margin:0 auto}'+
        'body.ed-consultas:not(.tela-interna) #telaHome.home-workspace #consTabsHome,'+
        'body.ed-consultas:not(.tela-interna) #telaHome.home-workspace #homeHistCol{width:100%!important;max-width:none!important;grid-column:auto!important}'+
        'body.ed-consultas #telaHome.home-workspace #homePainel{display:grid!important;grid-template-columns:minmax(360px,.82fr) minmax(580px,1.18fr)!important;gap:18px!important;align-items:start}'+
        'body.ed-consultas #homePainel>.home-left{grid-column:1;grid-row:1;width:auto!important;min-width:0!important;max-width:none!important}'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="veicular"]{grid-column:2;grid-row:1;width:auto!important;min-width:0!important}'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="risco"]{grid-column:1 / -1;grid-row:2;width:auto!important;min-width:0!important}'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="conta"]{grid-column:1 / -1;grid-row:3;width:auto!important;min-width:0!important}'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="veicular"] .hp-grade{grid-template-columns:repeat(3,minmax(0,1fr))!important}'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="risco"] .hp-grade{grid-template-columns:repeat(5,minmax(0,1fr))!important}'+
        'body.ed-consultas #homeHistCol{margin-top:18px}'+
        'body.ed-consultas #homeHistLista{grid-template-columns:repeat(3,minmax(0,1fr))!important}'+
        'body.ed-consultas #homeHistCard .hh-fixo{position:static!important;top:auto!important}'+
      '}'+
      '@media(max-width:1049.98px){'+
        'body.ed-consultas #homePainel>.hp-grupo[data-g="conta"] .hp-grade{grid-template-columns:repeat(3,minmax(0,1fr))!important}'+
      '}'+
      '@media(max-width:420px){'+
        'body.ed-consultas #homePainel>.hp-grupo{border-radius:16px;box-shadow:0 5px 18px rgba(15,43,87,.045)}'+
      '}';
    /* v1015 — drawer premium exclusivo do MEV Consultas. Os títulos são
       separadores permanentes, não acordeões: sem seta, sem falso convite a
       toque e com cada área agrupada numa superfície própria. A densidade
       volta ao padrão do produto: cabeçalho compacto, alvos de 48 px e
       rodapé simples, sem transformar a versão num card vazio. */
    var CONSULTAS_MENU=''+
      'body.ed-consultas #mevDrawer{background:#f7f9fc}'+
      'body.ed-consultas #mevDrawer .mdr-top{position:relative;overflow:hidden;min-height:90px;padding:12px 14px 11px;'+
        'background:radial-gradient(circle at 18% 0,#2782f1 0,transparent 44%),linear-gradient(135deg,#0a4da6,#001e50);'+
        'border-bottom:1px solid rgba(255,255,255,.14);box-shadow:0 8px 22px rgba(0,30,80,.16)}'+
      'body.ed-consultas #mevDrawer .mdr-greet{border-radius:12px;padding:2px;transition:background-color 160ms ease}'+
      'body.ed-consultas #mevDrawer .mdr-greet:hover{background:rgba(255,255,255,.08)}'+
      'body.ed-consultas #mevDrawer .mdr-greet:focus-visible{outline:0;background:rgba(255,255,255,.08)}'+
      'body.ed-consultas #mevDrawer .mdr-greet:focus-visible .mdr-ava{box-shadow:0 0 0 3px #fff,0 7px 16px rgba(0,20,60,.22)}'+
      'body.ed-consultas #mevDrawer .mdr-ava{width:44px;height:44px;box-shadow:0 0 0 2px rgba(255,255,255,.6),0 7px 16px rgba(0,20,60,.22)}'+
      'body.ed-consultas #mevDrawer .mdr-t{font-size:16px;letter-spacing:-.12px}'+
      'body.ed-consultas #mevDrawer .mdr-s{font-size:11px;opacity:.76}'+
      'body.ed-consultas #mevDrawer .mdr-x{background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.22);box-shadow:inset 0 1px 0 rgba(255,255,255,.12)}'+
      'body.ed-consultas #mevDrawer .mdr-x:hover{background:rgba(255,255,255,.2)}'+
      'body.ed-consultas #mevDrawer .mdr-nav{padding:10px 10px 5px}'+
      'body.ed-consultas #mevDrawer .mdr-hi{min-height:36px;padding:8px 11px 4px!important;gap:8px;cursor:default;pointer-events:none;'+
        'border:1px solid #e6ebf3;border-bottom:0;border-radius:14px 14px 0 0;background:#fff;color:var(--azul2);letter-spacing:.72px}'+
      'body.ed-consultas #mevDrawer .mdr-hi:not(:first-of-type){margin-top:9px}'+
      'body.ed-consultas #mevDrawer .mdr-hi>svg{width:15px;height:15px;color:var(--azul2)}'+
      'body.ed-consultas #mevDrawer .mdr-hi .mdr-caret{display:none!important}'+
      'body.ed-consultas #mevDrawer .mdr-sub{background:#fff;border:1px solid #e6ebf3;border-top:0;border-radius:0 0 14px 14px;'+
        'box-shadow:0 4px 14px rgba(0,30,80,.045)}'+
      'body.ed-consultas #mevDrawer .mdr-sub-in{padding:1px 6px 6px}'+
      'body.ed-consultas #mevDrawer .mdr-sub button{min-height:48px;padding:6px 9px!important;gap:10px;border-radius:11px;font-size:13.7px;color:var(--tinta)}'+
      'body.ed-consultas #mevDrawer .mdr-sub button>svg{width:32px;height:32px;padding:7px;border-radius:9px;background:#f0f5ff;color:var(--azul2);flex:0 0 32px}'+
      'body.ed-consultas #mevDrawer .mdr-sub button:hover{background:#f8fbff}'+
      'body.ed-consultas #mevDrawer .mdr-sub button[aria-current="page"]{background:#eaf2ff;color:var(--azul2);font-weight:750;box-shadow:inset 0 0 0 1px #d8e6fb}'+
      'body.ed-consultas #mevDrawer .mdr-sub button[aria-current="page"]>svg{background:#fff}'+
      'body.ed-consultas #mevDrawer .mdr-sub button[aria-current="page"]::before{left:4px;top:11px;bottom:11px;width:3px;border-radius:999px}'+
      'body.ed-consultas #mevDrawer .mdr-rodape{flex:none;min-height:0;margin:0;padding:9px 14px calc(9px + env(safe-area-inset-bottom,0px));'+
        'border:0;border-top:1px solid #e6ebf3;border-radius:0;background:#fff;color:#64748b;box-shadow:none;line-height:1.3}'+
      '@media(prefers-reduced-motion:reduce){body.ed-consultas #mevDrawer .mdr-greet{transition:none}}';
    var st=document.createElement('style'); st.id='mevEdicoesCss';
    /* 🔴 v1062 — o resto do chat no MEV Avaliações. O botão do dock e o
       #tbChat saem do DOM (logo abaixo, no `aplicar`); estas três superfícies
       não têm como ser abertas sem eles, mas ficam escondidas por garantia —
       o `chatPainelAlterna` ainda é alcançável por outros caminhos antigos.
       ⚠️ SEM `#tbSino` e SEM o item de notificações do menu: notificação não
          é chat, e o Angelo usa o sino (está no print dele). */
    var AVALIA=''+
      'body.ed-avalia #tbChat,body.ed-avalia #mdrChatBox,body.ed-avalia #chatPainel,'+
      'body.ed-avalia .fab-row #btnChatFab{display:none!important}';
    st.textContent=todas+PORTA+LOJA+CONSULTAS+CONSULTAS.replace(/body\.ed-consultas/g,'body.ed-avalia.av-area-consultas')+CONSULTAS_MENU+AVALIA;
    (document.head||document.documentElement).appendChild(st);
  }

  /* ==========================================================================
     4. A PORTA (upsell) — nunca erro seco
     ========================================================================== */
  var ICO_CADEADO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  var ICO_CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>';
  var ICO_LOJA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><rect x="9" y="13" width="6" height="7"/></svg>';
  /* v498 — a LANDING de cada app (apps.html na raiz: um arquivo, sete
     landings). O WhatsApp continua existindo — mas agora DENTRO da
     landing, que é onde a pessoa decide. */
  function edLandingUrl(produto){
    var id=PRODUTO2ED[produto]||'';
    return location.origin+'/apps.html'+(id&&id!=='completo'?('?app='+id):(id==='completo'?'?app=completo':''));
  }
  function _zapUrl(produto){
    var info=edicaoInfo();
    var msg='Olá! Estou usando o '+(info?info.nome:'MEV Veículos')+' e quero conhecer o '+produto+'.';
    return 'https://wa.me/'+ZAP+'?text='+encodeURIComponent(msg);
  }
  function edPortaFechar(){
    var bg=document.getElementById('edPortaBg');
    if(bg&&bg.parentNode) bg.parentNode.removeChild(bg);
  }
  function edPortaMostrar(cfg){
    _css(); edPortaFechar();
    var bg=document.createElement('div'); bg.className='ed-porta-bg'; bg.id='edPortaBg';
    /* 🔴 v879 — NUMA EDIÇÃO ISOLADA A PORTA NÃO VENDE NADA. Ela deixa de ser
       upsell e vira o que a tela precisa ser ali: um aviso de que aquilo não
       faz parte deste app, e um botão pra voltar. Sem CTA, sem landing, sem
       "todos os apps". */
    var _iso=edIsolada();
    bg.innerHTML='<div class="ed-porta" role="dialog" aria-modal="true">'+
      '<div class="ed-porta-ic">'+(cfg.ico||ICO_CADEADO)+'</div>'+
      '<h3>'+(_iso?'Isso não faz parte deste app':cfg.titulo)+'</h3>'+
      '<p>'+(_iso?'Esta função não está disponível neste aplicativo.':cfg.texto)+'</p>'+
      (_iso?'':('<button type="button" class="ed-porta-cta" id="edPortaCta">'+(cfg.cta||('Conhecer o '+cfg.produto))+'</button>'+
      /* v496 — O CAMINHO DE VOLTA (pedido do projeto dos 4 apps: "de dentro
         de qualquer bloco, o caminho pra Meus apps sempre à mão").
         v498 — os DOIS botões abrem LANDING (pedido: "crie uma landing page
         pra cada botão"): o de cima a do produto, este a da família. */
      '<button type="button" class="ed-porta-apps" id="edPortaApps">Ver todos os apps MEV</button>'))+
      '<button type="button" class="ed-porta-volta" id="edPortaVolta">Voltar</button></div>';
    document.body.appendChild(bg);
    bg.onclick=function(e){ if(e.target===bg) edPortaFechar(); };
    function _abrir(u){ try{ window.open(u,'_blank','noopener'); }catch(_){ location.href=u; } }
    var c=document.getElementById('edPortaCta');
    if(c) c.onclick=function(){ _abrir(edLandingUrl(cfg.produto)); };
    var ap=document.getElementById('edPortaApps');
    if(ap) ap.onclick=function(){ _abrir(location.origin+'/apps.html'); };
    var v=document.getElementById('edPortaVolta'); if(v) v.onclick=edPortaFechar;
  }
  /* porta genérica: página fora da edição (drawerIr/consIr barrado) */
  function edPortaAbrir(acao){
    var produto=ACAO2PRODUTO[String(acao||'')]||'MEV Completo';
    edPortaMostrar({
      produto:produto,
      titulo:(produto==='MEV Completo')?'Isso mora no MEV Completo':('Isso mora no '+produto),
      texto:(produto==='MEV Completo')
        ?'Esta parte faz parte do MEV Completo — loja, estoque, clientes, vendas e site, tudo ligado na mesma conta.'
        :'Esta parte faz parte do '+produto+'. É a mesma conta — você só destrava mais um pedaço do MEV.',
      ico:ICO_CADEADO
    });
  }
  /* portas específicas de FIM DE FLUXO */
  var PORTAS={
    avalia:{ produto:'MEV Avalia', ico:ICO_CHECK,
      titulo:'Quer avaliar este carro?',
      texto:'No MEV Avalia você avalia na frente do cliente: preço certo, fotos, FIPE e link do lojista — na mesma conta.',
      cta:'Conhecer o MEV Avalia' },
    loja:{ produto:'MEV Estoque', ico:ICO_LOJA,
      titulo:'Comprou o carro?',
      texto:'No MEV Estoque ele entra no estoque e aparece no seu site e no catálogo com um toque.',
      cta:'Conhecer o MEV Estoque' }
  };
  /* cartãozinho inline (o 02-icones-e-telas usa no fim da consulta) */
  function edCardPortaHtml(tipo){
    /* v499: quem já tem o pacote não vê convite de venda — o card de
       verdade daquela ação continua na tela, do jeito que sempre esteve */
    if(_temPacote(tipo)) return '';
    if(edIsolada()) return '';   /* v879 — app vendido sozinho não oferece os irmãos */
    var p=PORTAS[tipo]; if(!p) return '';
    return '<button type="button" class="ed-mini-card" data-edporta="'+tipo+'">'+
      '<span class="emc-ic">'+p.ico+'</span><span><b>'+p.titulo+'</b>'+
      '<small>Conheça o '+p.produto+'</small></span><span class="emc-seta">›</span></button>';
  }
  /* ao salvar a avaliação (13-abrir-avaliacao chama): porta pro MEV Estoque —
     uma vez por sessão, pra não virar chateação a cada "Salvar e fechar" */
  var _fimAvaliaJa=false;
  function edPortaFimAvalia(){
    if(_temPacote('loja'))return;   /* v499: já tem o MEV Estoque — nada de vender */
    if(edicaoAtual()!=='avalia'||_fimAvaliaJa) return;
    _fimAvaliaJa=true;
    setTimeout(function(){ edPortaMostrar(PORTAS.loja); },350);
  }
  /* clique dos cartõezinhos, delegado (funciona pra HTML pintado depois) */
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var b=t.closest('[data-edporta]'); if(!b) return;
    var p=PORTAS[b.getAttribute('data-edporta')]; if(p) edPortaMostrar(p);
  });

  /* ==========================================================================
     5. Aplicar a edição na casca (classe, rótulos, splash)
     ========================================================================== */
  function _aplicar(){
    var info=edicaoInfo();
    _css();
    /* os rótulos de grupo (.mdr-grp) não têm id e o CSS não seleciona por
       texto — aqui cada um ganha a classe do seu grupo, uma vez só */
    try{
      var grps=document.querySelectorAll('.mdr-nav .mdr-grp');
      Array.prototype.forEach.call(grps,function(g){
        var txt=String(g.textContent||'').trim();
        GRUPOS.forEach(function(gr){
          if(gr.rotulo && gr.rotulo===txt) g.classList.add('ed-rot-'+gr.id);
        });
      });
    }catch(_){}
    /* 🔴 v881 — a marca da loja vem ANTES do return de baixo de propósito:
       o MEV Veículos COMPLETO também vai pra Play, e ele não tem edição. Se
       isto ficasse depois do `if(!info) return`, a compra continuaria à
       mostra justamente no app maior. */
    try{ if(ehAppDeLoja()) document.body.classList.add('mev-loja'); }catch(_){}
    if(!info) return;   /* completo: NADA muda */
    try{ document.body.classList.add('ed-'+info.id); }catch(_){}
    /* v1360 — /consultas dentro do site usa a navegação horizontal no topo.
       A edição instalada (?app=consultas) preserva a barra inferior: a
       classe distingue CONTEXTO de uso sem duplicar edição ou rota. */
    try{ document.body.classList.toggle('consultas-web',info.id==='consultas' && !!window.__mevConsultasNoSite); }catch(_){}
    /* v1013 — a porta do MEV Consultas fala com a identidade do produto
       antes mesmo do login. É só apresentação: autenticação, expiração e
       troca de aparelho continuam no controlador único de sessão. */
    /* ======================================================================
       🔴 v1033 — O CHAT SAI DO MEV CONSULTAS, INCLUSIVE DO DOCK
       ----------------------------------------------------------------------
       Pedido do Angelo (15/09): "remove o chat do app MEV Consultas".
       A v911 já escondia #tbChat, #chatPainel, #mdrChatBox e o item de
       notificações do menu — mas o botão do dock só na barra larga
       (`body.ed-consultas.dock-barra .fab-row #btnChatFab`). Na CÁPSULA do
       celular a regra da v885 traz o botão de volta com
       `display:flex !important` e VENCE por especificidade (6 classes + id
       contra 2 classes + id). Resultado: "Conversas" com 19 na tela de um app
       que não tem conversa — foi o print que o Angelo mandou.
       👉 Por isso o conserto é aqui, no DOM, e não em mais uma briga de CSS:
       o botão SAI da página. Sai junto do foco por Tab, do contador e de
       qualquer regra futura que tente ressuscitá-lo por engano.
       ⚠️ A cápsula é flex com `flex:1 1 0` em cada botão: três se redistribuem
       sozinhos, sem buraco. É a mesma propriedade que o §7 da v885 já usava
       quando o "Adicionar" não existe.
       ⚠️ Só no MEV Consultas. As outras edições e o MEV Completo não mudam. */
    /* ======================================================================
       🔴 v1062 — O CHAT SAI TAMBÉM DO MEV AVALIAÇÕES
       ----------------------------------------------------------------------
       Pedido do Angelo (17/09): "remove o chat do mev avaliacoes", com o
       print do dock mostrando "19" numa conversa que aquele app não tem.

       ⛳ E A REGRA DE ESCONDER JÁ EXISTIA: o UI2ACAO lá em cima tem
       `['#btnChatFab','chat']`, e `chat` não está na lista da edição
       `avalia`. Ela não funcionou pelo MESMO motivo da v1033: na cápsula do
       celular, a regra da v885 devolve o botão com `display:flex !important`
       e VENCE por especificidade. Duas versões seguidas tropeçando na mesma
       pedra é sinal de que o caminho do CSS não serve aqui.
       👉 Então vale a decisão da v1033, agora pras DUAS edições: o botão SAI
          da página. Sai junto do foco por Tab, do contador e de qualquer
          regra futura que tente ressuscitá-lo por engano.
       ⚠️ O SINO DE NOTIFICAÇÕES FICA. Ele não é chat, e o Angelo não pediu
          pra tirar — no MEV Consultas ele sai por outra decisão (a v911).
       ====================================================================== */
    if(info.id==='consultas' || info.id==='avalia') try{
      var _cf=document.getElementById('btnChatFab');
      if(_cf && _cf.parentNode) _cf.parentNode.removeChild(_cf);
      var _tb=document.getElementById('tbChat'); if(_tb && _tb.parentNode) _tb.parentNode.removeChild(_tb);
    }catch(_){}
    if(info.id==='consultas') try{
      var consultasNoSite=!!window.__mevConsultasNoSite;
      var cab=document.querySelector('body>header'), logo=cab&&cab.querySelector('img');
      var tit=cab&&cab.querySelector('h1'), sub=cab&&cab.querySelector('p');
      if(logo){
        logo.src=consultasNoSite?'/identidade/logo-mev-veiculos-icone-app.svg':'/mev-consultas/icone.svg';
        logo.alt=consultasNoSite?'MEV Veículos':'MEV Consultas';
      }
      if(tit) tit.textContent=consultasNoSite?'Consultas':'MEV Consultas';
      if(sub) sub.textContent=consultasNoSite
        ?'Placa, FIPE, histórico, pagamentos e resultados em um só lugar.'
        :'Consulte veículos e empresas com mais segurança.';
      var at=document.getElementById('authTitulo'), as=document.getElementById('authSub');
      var ae=document.getElementById('authEmail');
      if(at) at.textContent='Entrar';
      if(as) as.textContent=consultasNoSite
        ?'Consulte, pague e acesse seus resultados salvos.'
        :'Acesse suas consultas e resultados salvos.';
      if(ae) ae.placeholder='nome@empresa.com.br';
      /* v1382: a ação secundária vem depois do formulário também na ordem
         semântica, não só na composição visual. Nas outras edições as abas
         continuam antes dos campos, como no componente original. */
      var abas=document.querySelector('#scAuth .tabs'), campos=document.getElementById('authCampos');
      if(abas&&campos&&campos.parentNode) campos.parentNode.insertBefore(abas,campos.nextSibling);
    }catch(_){}
    /* v1416 — o MEV Avaliações adota a mesma casca de acesso do Consultas,
       sem herdar o nome genérico "Consulta de Placa". A troca é somente de
       apresentação: formulário, sessão e recuperação continuam únicos. */
    if(info.id==='avalia') try{
      var cabAv=document.querySelector('body>header'), logoAv=cabAv&&cabAv.querySelector('img');
      var titAv=cabAv&&cabAv.querySelector('h1'), subAv=cabAv&&cabAv.querySelector('p');
      if(logoAv){ logoAv.src='/mev-avaliacoes/icone.svg'; logoAv.alt='MEV Avaliações'; }
      if(titAv) titAv.textContent='MEV Avaliações';
      if(subAv) subAv.textContent='Avalie, organize e acompanhe cada negociação.';
      var atAv=document.getElementById('authTitulo'), asAv=document.getElementById('authSub');
      var aeAv=document.getElementById('authEmail');
      if(atAv) atAv.textContent='Entrar';
      if(asAv) asAv.textContent='Acesse suas avaliações, consultas e negociações salvas.';
      if(aeAv) aeAv.placeholder='nome@empresa.com.br';
      var abasAv=document.querySelector('#scAuth .tabs'), camposAv=document.getElementById('authCampos');
      if(abasAv&&camposAv&&camposAv.parentNode) camposAv.parentNode.insertBefore(abasAv,camposAv.nextSibling);
    }catch(_){}
    /* ===== v498 (pedido) — O BLOCO DO APP NASCE ABERTO ====================
       "o bloco do app vem aberto — app consultas com as paginas abertas".
       Dentro de uma edição sobram poucas páginas por grupo: deixá-las atrás
       de mais um toque só escondia o produto (é a mesma decisão que a v452
       tomou pro grupo Lojista no app completo).
       ⚠️ Isto MUDA A ROTA DO DESLIZE de propósito: o 18b/18d leem a CLASSE
       .mdr-sub.on, então as páginas do app entram na rota desde o começo.
       Abre pelo MESMO caminho do app (classe .on + caret + aria-expanded),
       então o toque de fechar continua funcionando igual. */
    /* v746: quem abre/fecha os grupos agora é o controlador único do 05d
       (mdrSync, ao abrir a gaveta) — a edição não força mais nada aqui. */
    /* splash e título da aba acompanham o nome da edição */
    try{
      var nm=document.querySelector('.splash-nm'), sb=document.querySelector('.splash-sb');
      if(nm) nm.textContent=info.nome;
      if(sb) sb.textContent=info.sub+' · família MEV Veículos';
      document.title=(info.id==='consultas' && window.__mevConsultasNoSite)
        ?'Consultas | MEV Veículos'
        :info.nome;
    }catch(_){}
  }
  if(document.body) _aplicar();
  else document.addEventListener('DOMContentLoaded',_aplicar);

  /* ==========================================================================
     6. A FAMÍLIA DE APPS (v491 · os 4 novos entraram na v496)
     Os LINKS moram AQUI, num lugar só: quando os subdomínios existirem
     (fase 2), troca-se este mapa e a página Apps MEV segue sozinha.
     ⚠️ v493: as PÁGINAS PÚBLICAS não enxergam este arquivo — o rodapé
     "baixe o app" tem um espelho do link em publico-rodape.js (raiz).
     Mudou o formato do link aqui, mude lá também.
     ========================================================================== */
  /* ⚠️ v502 — `curto` é o nome que cabe numa PÍLULA (a faixa "Como você quer
     trabalhar hoje", 05g). Fica AQUI, junto do nome grande, pra não nascer
     uma segunda tabela de nomes: renomeou um app? Renomeou nos dois. */
  /* ==========================================================================
     v831 — A OFERTA DE MÓDULOS SEPARADOS DESLIGADA
     (pedido do Angelo, 01/09: "oculta os modulos, nao vamos ofertar
      separado, por enquanto só app completo")

     É o segundo capítulo da MESMA decisão da v503. Lá ele disse "oculte,
     deixe só o mev completo" e a faixa "Como você quer trabalhar hoje" foi
     desligada. O comentário da v503 avisou, com todas as letras, que com a
     faixa fora os cards "Outros apps" voltariam a aparecer no painel de cada
     app (05f) — e foi justamente esse bloco que ele fotografou agora.

     ⛳ O INTERRUPTOR É ESTE. `true` aqui e os seis módulos voltam a ser
     oferecidos nas duas vitrines (o painel da home de cada app e a página
     "Apps MEV"). Nada foi apagado: as sete edições, as landings, o ?app= e
     a página apps.html seguem inteiros e funcionando.

     🔴 O QUE NÃO PODE SUMIR JUNTO — e por isso o filtro guarda o Completo:
     quem entra por um link `?app=consultas` fica DENTRO da edição enxuta. Se
     a vitrine sumisse inteira, essa pessoa ficaria sem caminho de volta pro
     app completo — presa num app menor, sem saber que existe mais. Então a
     oferta dos MÓDULOS some; o card do MEV Completo fica. É exatamente o que
     ele pediu: "por enquanto só app completo". */
  var MEV_OFERTA_MODULOS = false;
  /* ==========================================================================
     🔴 v879 — O MEV CONSULTAS FICA SOZINHO (pedido do Angelo, 04/09: "tem um
     app só de consulta? isole ele e não coloque chamadas pra outros apps —
     quero vender só ele por enquanto")
     --------------------------------------------------------------------------
     A edição `consultas` já existia desde a v486. O que faltava era ela deixar
     de FALAR dos outros: quem compra só o MEV Consultas não pode abrir o app e
     encontrar quatro portas pra coisas que não comprou. Isso não é upsell — é
     um produto contando pro cliente o que ele NÃO tem, toda vez que ele usa.

     ⛳ ESTE É O INTERRUPTOR. `false` aqui e tudo volta a ser como era.

     🔴 AS QUATRO PORTAS QUE ELE FECHA — e é bom que estejam listadas, porque
     fechar três de quatro é o mesmo que não fechar nenhuma:
       1. a PORTA de upsell (`edPortaMostrar`): sai o "Conhecer o MEV X" e sai
          o "Ver todos os apps MEV". Fica o aviso e o "Voltar";
       2. o CARTÃO inline no fim da consulta (`edCardPortaHtml`), que oferecia
          o MEV Avalia e o MEV Estoque;
       3. a VITRINE (`edAppsVitrine`), que ainda guardava o card do MEV
          Completo como caminho de volta;
       4. a página APPS MEV (`edAppsVisivel`) no menu.

     ⚠️ E O "CAMINHO DE VOLTA" QUE A v496 EXIGIA? Ele continua existindo, mas
     virou o que sempre foi de verdade: o endereço. `app.html?app=completo`
     limpa a edição e devolve o app inteiro — isso roda no início deste
     arquivo, antes de qualquer coisa aqui, e nenhum interruptor alcança.
     É o suficiente pra VOCÊ testar, e é invisível pro cliente que comprou só
     as consultas — que é exatamente a divisão certa.

     ⚠️ VALE SÓ PRA EDIÇÃO `consultas`. As outras seis continuam com as portas
     abertas: elas ainda não são produto vendido sozinho. Quando forem, é
     acrescentar o id nesta lista — não escrever outro interruptor. */
  /* Avaliações também é um produto isolado; não oferece troca de app. */
  var MEV_EDICOES_SOZINHAS = { consultas:true, avalia:true };
  function edIsolada(){ return !!MEV_EDICOES_SOZINHAS[edicaoAtual()]; }
  /* ==========================================================================
     🔴🔴 v881 — O APP SABE QUANDO ESTÁ RODANDO DENTRO DE UM APP DE LOJA
     (Play Store hoje; App Store amanhã)
     --------------------------------------------------------------------------
     POR QUE ISTO EXISTE, em uma frase: crédito e consulta são "bem digital".
     Se a Google entende que a COMPRA acontece dentro do app, ela exige o
     sistema de cobrança dela (15% a 30%) — e usar o Mercado Pago ali não é
     pagar comissão, é quebrar a política e sair do ar.

     ✅ A SAÍDA ESCOLHIDA PELO ANGELO (04/09/2026): dentro do app de loja NÃO
     EXISTE tela de compra. O cliente usa as consultas grátis do mês e, quando
     acabam, lê um RECADO dizendo onde contratar. A venda acontece no site,
     no Mercado Pago dele, 100% dele, ZERO de comissão nas duas lojas.

     ⚠️ E É UM RECADO, NÃO UM BOTÃO. Texto informativo as lojas toleram; botão
     que abre checkout é exatamente o que elas caçam. Não ponha link clicável
     de pagamento aqui — nem "só um".

     ⚠️ NADA DISSO VALE PRO SITE. Quem abre pelo navegador (inclusive o app
     instalado pelo Chrome/Safari, que NÃO veio de loja nenhuma) continua
     comprando como sempre. É a checagem mais importante do teste da v881:
     com `ehAppDeLoja()` falso, o app tem que ser IDÊNTICO ao de hoje.

     🔴 A ARMADILHA DO DETECTOR — e ela derruba a versão ingênua.
     O jeito de saber, no Android, é o `document.referrer` começar com
     `android-app://`. Só que o referrer **só é confiável na PRIMEIRA carga**,
     e ESTE APP RECARREGA SOZINHO: ele compara o `versao.json` e dá
     `location.reload()` quando sai versão nova. Se o referrer se perder num
     reload desses, a tela de comprar VOLTA A APARECER dentro do app da loja —
     e ninguém vai estar olhando na hora. Por isso a primeira carga deixa uma
     marca, e o detector aceita o referrer OU a marca.

     ⚠️ A MARCA É `sessionStorage`, NÃO `localStorage`: dura enquanto o app
     está aberto e morre junto. Gravar pra sempre repetiria o erro que a v501
     teve que desfazer (a edição que grudava e o Angelo ficou preso).

     ⚠️ E NÃO dá pra marcar pelo `start_url` do manifest (`?loja=1`): o mesmo
     endereço serve o app instalado pelo navegador, que não é de loja nenhuma.
     Ia esconder a compra de quem instalou pelo Chrome — e aí ninguém compra
     mais nada.

     ⛳ QUANDO CHEGAR O IPHONE: o app nativo do iOS não tem `android-app://`.
     Ele acrescenta `MEVLoja/1` ao user agent (uma linha no WKWebView), e o
     detector abaixo já lê isso. Não precisa mexer aqui.
     ========================================================================== */
  var MEV_LOJA_MARCA = 'mev_app_de_loja';
  function _lojaSinal(){
    try{ if(String(document.referrer||'').indexOf('android-app://')===0) return true; }catch(_){}
    try{ if(/MEVLoja\//.test(String(navigator.userAgent||''))) return true; }catch(_){}
    return false;
  }
  /* a primeira carga é a única confiável — marca agora, custe o que custar */
  (function(){ try{ if(_lojaSinal()) sessionStorage.setItem(MEV_LOJA_MARCA,'1'); }catch(_){} })();
  function ehAppDeLoja(){
    if(_lojaSinal()) return true;
    try{ return sessionStorage.getItem(MEV_LOJA_MARCA)==='1'; }catch(_){ return false; }
  }
  /* O RECADO que substitui a tela de compra. Fica AQUI, e não espalhado nos
     módulos, porque quando o texto mudar (e ele vai mudar quando o Angelo
     ajustar a oferta) tem que mudar num lugar só. */
  var MEV_LOJA_RECADO = {
    titulo: 'Suas consultas grátis do mês acabaram',
    linha1: 'Para continuar consultando hoje, adicione saldo em mevveiculos.com.br pelo navegador.',
    linha2: 'Depois é só voltar aqui — o saldo aparece sozinho, sem precisar entrar de novo.'
  };
  function edLojaRecado(){ return MEV_LOJA_RECADO; }
  /* ==========================================================================
     v835 — O "GERAR ARTE" SAIU DO APP
     (pedido do Angelo, 01/09: "gerar arte remova também · do app")

     ⛳ O INTERRUPTOR É ESTE. `true` aqui e a arte volta nas SEIS portas de uma
     vez — não existe uma sétima escondida:
        · menu do card no Estoque                (14-estoque)
        · painel de Marketing do veículo         (15-marketing, #artBt)
        · Portal de repasse                      (09-portal-repasse, #rvArte)
        · proposta da Venda                      (17-vendas, #vpArte)
        · tela da Avaliação                      (07-avaliacao, #avBtnArte)
        · aba pessoal "Arte de anúncio"          (18h-arte-anuncio)

     🔴 NADA FOI APAGADO. Os dois geradores continuam inteiros no repositório —
     o 15c-arte-do-veiculo.js (a arte de story/feed, v656) e o
     18h-arte-anuncio.js (a arte de anúncio 1080×1920, v823). O que sumiu é a
     porta, não a casa: ligar de volta é esta linha e mais nada.

     ⚠️ E POR QUE UM INTERRUPTOR EM VEZ DE SEIS `if` ESPALHADOS: seis lugares
     é onde se esquece um. Um botão vivo sobrando numa tela que ninguém mais
     usa vira defeito calado — a pessoa aperta e cai num lugar que o app já
     não sustenta. */
  var MEV_ARTE_VEICULO = false;
  function arteDisponivel(){ return !!MEV_ARTE_VEICULO; }
  /* ==========================================================================
     v840 — O ACESSO AOS MÓDULOS PASSA A DEPENDER DO PLANO
     (pedido do Angelo, 01/09: "bloqueie o acesso dos cards para não
      assinantes, mas ele consegue clicar e aparece um 'disponível pra
      assinantes' com as vantagens, chamando pra assinar")

     ⛳ O INTERRUPTOR É ESTE. `false` aqui e TUDO volta a abrir como antes,
     em toda porta de uma vez — card da home, item do menu e link direto.
     Nenhum card some, nenhum modal aparece, nenhuma chamada nova ao
     /api/cobranca é feita na abertura do app.

     🔴 POR QUE UM INTERRUPTOR, E NÃO SÓ O CÓDIGO: esta é a única mudança
     desta leva que pode tirar acesso de gente que HOJE usa o app de graça.
     Se amanhã ela derrubar uso ou gerar reclamação, o desfazer tem que ser
     uma linha e um deploy — não uma versão de conserto às pressas. O §15 do
     projeto pede exatamente isso ("desativar a nova composição pela feature
     flag").

     ⚠️ ELE NÃO TOCA EM CONSULTA. Placa, FIPE, CPF, CNPJ, Gravame e as demais
     continuam abertas pra quem não assina — a regra inegociável do §1 é que
     assinatura e token são produtos diferentes. Quem cuida disso é o
     05m-acesso-por-plano.js, e a tabela de lá só tem módulo de gestão. */
  var MEV_ACESSO_POR_PLANO = true;
  function edAcessoPorPlano(){ return !!MEV_ACESSO_POR_PLANO; }
  /* ==========================================================================
     v843 — AS FRASES DOS CARDS SAÍRAM
     (pedido do Angelo, 01/09, com o print da home: "remove essas frases dos
      cards")

     A v839 pôs uma descrição de uma linha em cada card ("Gravame — Banco,
     contrato e alienação"). Na tela cheia, com 22 cards, elas dobraram a
     altura da grade e o painel virou um paredão de texto — que é o contrário
     do que a grade existe pra fazer: dar UM alvo por assunto, batido de
     relance.

     ⛳ O INTERRUPTOR É ESTE. `true` e as frases voltam em todos os cards de
     uma vez. A tabela `CARD_DESC` (em 05d-abas-consultas.js) continua inteira,
     com as 26 frases escritas — nada foi apagado, e o CSS do `.vpx-ds`
     também ficou. Se um dia elas voltarem, voltam prontas.

     ⚠️ E ELAS NÃO SERVIAM PRA NADA? Serviam: "RENAJUD", "Gravame" e
     "Leilão + PT" são nome de órgão e de jargão. Quem está começando não sabe
     o que cada um entrega. A ideia continua boa; o LUGAR é que estava errado
     — vinte e duas explicações ao mesmo tempo não explicam, atrapalham. Se
     for pra voltar, o caminho provável não é este interruptor: é a frase
     aparecer ao TOCAR (no popover que já existe), ou só nos cards que
     realmente escondem o significado. */
  var MEV_CARD_DESC = false;
  function edCardDesc(){ return !!MEV_CARD_DESC; }

  /* ==========================================================================
     v845 — A PROTEÇÃO DA PLACA NAS FOTOS SAIU  (pedido do Angelo, 02/09)
     --------------------------------------------------------------------------
     "remove a função de achar a placa e colocar placa preta, não ficou bom nem
      borrar, remove"

     Sai a tela inteira que abria antes de enviar foto de veículo: a marcação da
     região, a placa preta MEV, o desfoque, e a busca automática da placa por IA
     (a `foto-ia`, da v837). A foto escolhida sobe como está.

     🔴 O QUE ISSO CUSTA, E EU NÃO VOU ESCONDER: a placa do carro passa a subir
     LEGÍVEL pro bucket `avaliacao-fotos`, que é PÚBLICO. Na prática: a foto
     vira um endereço na internet aberto pra qualquer um, com a placa dentro —
     e ela aparece no link público da avaliação, no catálogo, nas artes e na
     miniatura do WhatsApp. Era exatamente isso que a v808 existia pra impedir.
     Placa é dado pessoal do dono do carro; a decisão de publicá-la é sua, e
     está registrada aqui pra ninguém dizer depois que foi sem querer.

     ⚠️ NADA FOI APAGADO. O `13c-protecao-placa.js` continua inteiro — o
     editor, o desenho da placa MEV, o desfoque, a busca por IA. O que mudou
     é que a porta (`fotoVeiculoPreparar`) devolve as fotos SEM abrir a tela,
     os botões "Placa MEV" somem, e a exigência de revisão do `avUpload` fica
     dormindo. Uma linha aqui traz tudo de volta.

     📌 SE UM DIA VOLTAR, o caminho provável não é este interruptor de novo: é
     proteger no SERVIDOR, na hora de publicar, sem tela nenhuma no meio do
     caminho do Angelo. Foi o TRABALHO manual que reprovou, duas vezes (a v834
     já tinha tirado o "borrar"), não a ideia de proteger. */
  var MEV_PROTEGE_PLACA = false;
  function edProtegePlaca(){ return !!MEV_PROTEGE_PLACA; }

  /* ==========================================================================
     🔴 v858 (pedido do Angelo, 03/09): "tire o slide dos mais usados na
     página inicial".
     --------------------------------------------------------------------------
     A FILEIRA "Mais usados" CONTINUA NA HOME, com os mesmos cards. O que
     saiu foi só o MOVIMENTO: ela parou de deslizar sozinha. No celular, se
     não couber na largura, você rola com o dedo — como qualquer fita.

     Perguntei antes de mexer, porque "tirar o slide" tinha duas leituras
     (tirar o movimento × tirar a fileira inteira). Ele escolheu o movimento.
     Pra tirar a FILEIRA inteira um dia, o caminho é outro: é o grupo
     `maisusados` do painel, não este interruptor.

     ⛳ PRA VOLTAR A DESLIZAR: troque `false` por `true` aqui. Só isso. Todo o
     laço da v817/v819/v824 continua no 05d-abas-consultas.js, inteiro e
     comentado — inclusive o conserto do número de geração (v824), que é o
     que impedia as velocidades de se somarem. Não apaguei nada: se voltar,
     volta com os defeitos já corrigidos.
     ⚠️ E se voltar, a velocidade combinada é 18 px/s (HA_MQ_PXS lá no 05d);
     ela nasceu 36 e caiu pela metade a pedido dele na v819. */
  var MEV_MAIS_USADOS_DESLIZA = false;
  function edMaisUsadosDesliza(){ return !!MEV_MAIS_USADOS_DESLIZA; }

  /* ==========================================================================
     🔴 v880 — A FRASE DO MEV CONSULTAS NÃO PODE VENDER "MULTAS".
     --------------------------------------------------------------------------
     A consulta de multas (RENAINF) está DESLIGADA desde a v861 (a linha
     MEV_CONSULTA_MULTAS logo abaixo). Mas a frase do app, na `edApps()` e
     no apps.html, continuava anunciando "multas" como um TIPO de consulta
     que o cliente escolhe no menu — e não existe mais esse botão.
     O dado não sumiu: débitos de IPVA, licenciamento e multas vêm DENTRO do
     Total Premium. Por isso a frase agora diz "débitos" (o que ele recebe)
     e não "multas" (o botão que ele não acha). Mesma correção no apps.html.
     ⛳ SE O RENAINF VOLTAR: religue a linha e devolva a palavra às frases. */

  /* ==========================================================================
     🔴 v861 (decisão do Angelo, 03/09): "multas e renajud vou tirar do app".
     --------------------------------------------------------------------------
     As duas consultas SAEM DE VISTA: some o card da home, some a pílula da
     barrinha, some de "outras consultas". Mas o código, as páginas e as
     rotas continuam INTEIROS — é a mesma receita da v761, quando a Consulta
     Plus saiu: desligar MOSTRANDO o caminho, nunca apagando.

     🔴 POR QUE AQUI, NUMA LISTA, E NÃO COMENTANDO AS LINHAS DA CONS_TABS:
     porque a CONS_TABS é lida em cinco lugares diferentes (grade da home,
     barrinha, "outras consultas", selos, famílias). Comentar a linha resolve
     os cinco de uma vez, é verdade — mas religar exige achar a linha certa
     no meio de 120 mil caracteres. Aqui religar é trocar `false` por `true`
     num arquivo que existe pra isso.

     ⚠️ AS ROTAS CONTINUAM VALENDO: um link antigo pra /consulta/multas ou um
     favorito do RENAJUD ainda abre a página. Quem some é a OFERTA, não o
     destino — se um cliente tiver o link salvo, ele não leva 404.
     ⛳ PRA VOLTAR QUALQUER UMA: troque `false` por `true` na linha dela. */
  /* 🔴 v861 — o quadro VEÍCULO junto do resultado da consulta e no topo do
     PDF. Ele é montado SÓ com dado que o Angelo já tem (o veículo na tela, o
     histórico dele, o estoque dele) — nunca dispara consulta paga. Quando não
     acha, DIZ que não achou em vez de sumir. */
  var MEV_QUADRO_VEICULO = true;
  function edQuadroVeiculo(){ return !!MEV_QUADRO_VEICULO; }

  /* v1402 — Base Estadual/RENAINF não registrou sequer uma chamada no
     extrato do fornecedor no teste real de 08/10. A oferta fica desligada
     até a integração ser regularizada; código e histórico permanecem para
     reativação sem perda dos relatórios já salvos. */
  var MEV_CONSULTA_DEBITOS  = false;   /* Débitos e restrições */
  var MEV_CONSULTA_MULTAS   = false;   /* Multas (RENAINF) */
  var MEV_CONSULTA_RENAJUD  = false;   /* RENAJUD */
  function edConsultaLigada(chave){
    if(chave==='debitos') return !!MEV_CONSULTA_DEBITOS;
    if(chave==='multas')  return !!MEV_CONSULTA_MULTAS;
    if(chave==='renajud') return !!MEV_CONSULTA_RENAJUD;
    return true;   /* tudo o que não está nesta lista continua ligado */
  }
  function edOfertaModulos(){ return !!MEV_OFERTA_MODULOS; }
  /* a lista PRA VITRINE — a `edApps()` continua inteira pra quem precisa dos
     links e dos nomes (landing, ?app=, faixa, toasts) */
  function edAppsVitrine(){
    /* 🔴 v879 — vazia na edição isolada. O card do MEV Completo era o
       "caminho de volta" da v496; num app vendido sozinho ele é propaganda
       de algo que o cliente não comprou. O caminho de volta virou o endereço
       (?app=completo), que é o certo e ele nem vê. */
    if(edIsolada()) return [];
    var todos=edApps();
    if(edOfertaModulos()) return todos;
    return todos.filter(function(a){ return a.id==='completo'; });
  }
  function edApps(){
    var base=location.origin+'/app.html';
    return [
      { id:'consultas', nome:'MEV Consultas', curto:'Consultas', frase:'Consultas de placa, FIPE, leilão, débitos, CPF e CNPJ no celular.', link:base+'?app=consultas', ok:true },
      { id:'avalia',    nome:'MEV Avalia',    curto:'Avalia',    frase:'Avalie carros na frente do cliente: placa, FIPE, fotos e link pro lojista.', link:base+'?app=avalia', ok:true },
      { id:'loja',      nome:'MEV Estoque',   curto:'Estoque',   frase:'Estoque, catálogo e o site da sua loja.', link:base+'?app=loja', ok:true },
      { id:'vendas',    nome:'MEV Vendas',    curto:'Vendas',    frase:'Cotação, documentos e venda fechada sem papelada.', link:base+'?app=vendas', ok:true },
      { id:'leads',     nome:'MEV CRM',       curto:'CRM',       frase:'Clientes, pós-venda e atendente IA.', link:base+'?app=leads', ok:true },
      { id:'rede',      nome:'MEV Rede',      curto:'Rede',      frase:'Repasse e negociação entre lojas.', link:base+'?app=rede', ok:true },
      { id:'completo',  nome:'MEV Completo',  curto:'Tudo',      frase:'Tudo ligado na mesma conta: consultas, avaliação, loja, vendas e clientes.', link:base+'?app=completo', ok:true }
    ];
  }

  /* ==========================================================================
     7. Expõe pra dentro do IIFE grande (e pro console)
     ========================================================================== */
  window.edApps=edApps;
  window.edicaoAtual=edicaoAtual;
  window.edicaoInfo=edicaoInfo;
  window.edicaoPermite=edicaoPermite;
  window.edicaoDeslizaEntrePaginas=edicaoDeslizaEntrePaginas;   /* v1050 */
  window.edPode=edPode;                      /* v918 — o portão seguro (ver acima) */
  window.edConsPermite=edConsPermite;
  window.edicaoDestaque=edicaoDestaque;
  window.edicaoInicial=edicaoInicial;
  window.edicaoPainel=edicaoPainel;
  window.edAppsVisivel=edAppsVisivel;
  window.edFaixaVisivel=edFaixaVisivel;   /* v502 — a faixa "como trabalhar hoje" */
  window.edFaixaOrdem=edFaixaOrdem;
  window.MEV_PREVIA=MEV_PREVIA;
  window.MEV_FAIXA=MEV_FAIXA;
  window.edOfertaModulos=edOfertaModulos;    /* v831 — o interruptor da oferta */
  window.edIsolada=edIsolada;                /* v879 — a edição vendida sozinha */
  window.ehAppDeLoja=ehAppDeLoja;            /* v881 — está rodando dentro do app da loja? */
  window.edLojaRecado=edLojaRecado;          /* v881 — o texto que substitui a tela de compra */
  window.edAppsVitrine=edAppsVitrine;        /* v831 — a lista já filtrada */
  window.arteDisponivel=arteDisponivel;      /* v835 — a porta da arte do veículo */
  window.edAcessoPorPlano=edAcessoPorPlano;  /* v840 — o interruptor do acesso por plano */
  window.edCardDesc=edCardDesc;              /* v843 — as frases dos cards */
  window.edProtegePlaca=edProtegePlaca;      /* v845 — a proteção da placa nas fotos */
  window.edMaisUsadosDesliza=edMaisUsadosDesliza;  /* v858 — o deslize do "Mais usados" */
  window.edConsultaLigada=edConsultaLigada;        /* v861 — quais consultas o app oferece */
  window.edQuadroVeiculo=edQuadroVeiculo;          /* v861 — o quadro VEÍCULO na consulta e no PDF */
  window.edicaoTrocar=edicaoTrocar;
  window.edPortaAbrir=edPortaAbrir;
  window.edLandingUrl=edLandingUrl;   /* v498 — a landing de cada app */
  window.edTemPacote=edTemPacote;     /* v499 — o gancho da Fase 3 */
  window.edCardPortaHtml=edCardPortaHtml;
  window.edPortaFimAvalia=edPortaFimAvalia;
  /* pro teste da SOMA: nenhuma página do menu pode ficar órfã */
  window.edMapa=function(){ return { blocos:BLOCOS, comuns:COMUNS, edicoes:EDICOES,
    grupos:GRUPOS, soltos:SOLTOS, todas:_todasAcoes() }; };
})();

/* ╔═══ src/app/01-nucleo.js ══════════════════════════════════════════════ */
(function(){
  'use strict';
  /* Dados do MEV Veículos ficam em objetos mp_ no projeto Supabase compartilhado. */
  var URL_SUPA='https://oeirfkxwwjqkqfpwhvra.supabase.co';
  var KEY_SUPA='sb_publishable_wfdYXSXBuY-vxFlWMHKnkQ_dhqF5D40';
  /* lock "sem trava": evita o travamento do supabase-js em PWA no iPhone
     (o navigator.locks às vezes fica preso e TODAS as consultas ao banco
     ficam esperando pra sempre). Como o app roda numa aba/instância só,
     rodar direto (sem exclusão mútua) é seguro e elimina o deadlock. */
  function _semTrava(name, acquireTimeout, fn){ return fn(); }
  var supa = window.supabase.createClient(URL_SUPA, KEY_SUPA, { auth:{ persistSession:true, autoRefreshToken:true, lock:_semTrava } });
  /* Expõe o cliente como window.supa: várias funções da NUVEM (histórico de CPF/CNPJ,
     leilão, rascunho de avaliação) checam `window.supa` antes de salvar/ler. Sem isto
     elas desistiam calado e NADA era salvo na nuvem (por isso o CPF/CNPJ não sincronizava
     entre celular e PC). É seguro: usa a chave pública (anon), protegida por RLS. */
  window.supa = supa;
  /* ===== BANCO: as tabelas do Placas usam o prefixo mp_ =====
     Este "tradutor" troca o nome antigo pelo novo em TODAS as consultas — assim o
     resto do código continua escrevendo from('clientes') e funciona. */
  (function(){
    /* 15/08 — chat_lojista ENTROU AQUI. Ele era registrado la' no
       10b-chat-lojistas.js ("try{ MP_TAB.chat_lojista=1 }catch(_){}"), mas o
       MP_TAB mora DENTRO deste IIFE: de fora ele nem existe, o try engolia o
       erro em silencio e TODA chamada do chat interno ia pra tabela
       "chat_lojista" (sem mp_) -> 404 no PostgREST -> "Nao consegui enviar".
       Era por isso que a mp_chat_lojista estava vazia: nunca gravou nada. */
    /* ⚠️ v517 — `cliente_nao_duplicado` ENTRA AQUI, e não com um
       "try{ MP_TAB.x=1 }" no módulo dele. Foi exatamente esse atalho que
       deixou a mp_chat_lojista vazia por semanas (ver o aviso acima): o
       MP_TAB mora DENTRO deste IIFE, o try de fora engolia o erro em
       silêncio e as chamadas iam pra uma tabela sem prefixo → 404 calado.
       Tabela nova = uma palavra nesta lista, e ponto. */
    var MP_TAB = {assinaturas:1,atendente_ia:1,avaliacoes:1,avaliacao_cliente:1,chat_lojista:1,cliente_consulta:1,cliente_documento:1,chat_removido:1,cliente_nao_duplicado:1,clientes:1,cobranca:1,notificacoes:1,
      creditos_cliente:1,dispositivos:1,doc_consulta:1,erros:1,estoque:1,fipe_gratis_cliente:1,historico_consulta:1,loja:1,   /* v701: dispositivos FALTAVA — o app gravava os aparelhos na tabela do OUTRO app e a mp_dispositivos ficou vazia desde a v407 (o teto de 3 nunca funcionou) */
      loja_membros:1,loja_pedido:1,lojistas_repasse:1,oferta:1,ofertas:1,pagamentos_consulta:1,parceiros:1,perfil:1,
      /* v(esta) — INSPEÇÃO: as duas tabelas do projeto da aba Inspeção.
         Estão aqui, e não num `try{ MP_TAB.x=1 }` do módulo 18g, pelo
         motivo escrito no aviso da v517 logo acima: o MP_TAB mora DENTRO
         deste IIFE e o atalho de fora falha em silêncio. `inspecao_modelo`
         entra junto porque a tabela já existe no banco e é o próximo
         passo (checklist editável); hoje o checklist é constante no 18g. */
      inspecao:1,inspecao_modelo:1,
      /* 🔴 v1071 — REVISÕES: a tabela da aba de fila de contato da oficina.
         Mora AQUI, e não num `try{ MP_TAB.revisoes=1 }` no módulo 12p, pelo
         motivo que já custou caro duas vezes (v517, repetido na v810): o
         MP_TAB vive DENTRO deste IIFE, de fora ele nem existe, e o try
         engole o erro. Sem esta linha o `supa.from('revisoes')` vai pra uma
         tabela SEM o prefixo `mp_` e o PostgREST devolve 404 CALADO — foi
         assim que a mp_chat_lojista ficou vazia por semanas. */
      revisoes:1,
      /* v901 — FECHO DO DIA: a tabela do placar de comissões dele.
         Mora aqui, e não num `try{ MP_TAB.fecho=1 }` do módulo 18i, pelo
         motivo que já custou caro duas vezes: o MP_TAB vive DENTRO deste
         IIFE, de fora ele nem existe, e o try engoliria o erro. Sem esta
         palavra o `supa.from('fecho')` iria pra uma tabela "fecho" que não
         existe, o PostgREST devolveria 404 e O ERRO SERIA SILENCIOSO — foi
         assim que a mp_chat_lojista ficou vazia por semanas (v508) e que a
         mp_dispositivos ficou vazia desde a v407 (o teto de 3 aparelhos
         nunca funcionou, e só se descobriu na v701). */
      fecho:1,
      portal_membro:1,relatorio_veicular:1,resposta_padrao:1,repasse:1,venda_publica:1,vendas:1,vendedor_loja:1};
    var _from = supa.from.bind(supa);
    supa.from = function(t){ return _from(MP_TAB[t] ? ('mp_'+t) : t); };
    var _rpc = supa.rpc ? supa.rpc.bind(supa) : null;
    /* v282: entrar_na_loja e sair_da_loja precisavam entrar aqui. Sem isso o
       app chamava os nomes SEM prefixo — e como só existem com mp_, o botão
       "Entrar na loja" dava erro desde sempre. */
    var MP_RPC = {creditar_cliente:1,debitar_credito_cliente:1,get_assinatura:1,get_avaliacao:1,get_catalogo:1,registrar_assinatura:1,
      entrar_na_loja:1,sair_da_loja:1,pedido_decidir:1,
      /* v288: o Portal do Repasse deixou de ler a tabela direto. Estas duas
         funções montam a resposta campo a campo e só devolvem o PREÇO pra
         quem é dono do carro. */
      repasse_rede:1,repasse_meu:1,
      /* v298: as 10 consultas de boas-vindas */
      boas_vindas:1,
      /* v308 — "Venda seu carro". As portas do carro de particular. Elas
         montam a resposta campo a campo e NUNCA devolvem nome nem WhatsApp
         do dono antes de ele aceitar uma oferta. */
      anuncios_rede:1, anuncio_ver:1, anuncio_ofertar:1, anuncio_cancelar_oferta:1,
      /* v324 — indicador (vendedor que divulga várias lojas por comissão) */
      indicador_entrar:1, indicador_minhas_lojas:1,
      /* v457 — convite de indicador pelo sino */
      indicador_convidar:1};
    if(_rpc) supa.rpc = function(fn, args, opts){ return _rpc(MP_RPC[fn] ? ('mp_'+fn) : fn, args, opts); };
  })();
  /* ===== v248: MINI-SENTRY — todo erro do app vira uma linha na mp_erros =====
     Erro de JavaScript não tratado (ou promise rejeitada) é gravado no banco
     com versão, tela, mensagem e aparelho — você fica sabendo do bug ANTES do
     cliente reclamar. O Angelo vê tudo em Menu → "Erros do app" (a RLS só
     deixa o admin ler; qualquer um pode gravar, com tamanho limitado).
     Proteções: não grava o mesmo erro 2x na sessão e para depois de 8. */
  (function(){
    var mand=0, MAX=8, vistos={};
    var VERSAO=''; try{ var sc=document.querySelector('script[src*="app.js"]'); VERSAO=(sc&&(sc.src.match(/v=(\d+)/)||[])[1])||''; }catch(_){}
    function envia(msg, stack, extra){
      try{
        msg=String(msg||'').slice(0,1900).trim(); if(!msg) return;
        var chave=msg.slice(0,120); if(vistos[chave]||mand>=MAX) return;
        vistos[chave]=1; mand++;
        supa.from('erros').insert({
          user_id:(typeof meuId!=='undefined'&&meuId)||null,
          origem:'app', versao:VERSAO?('v'+VERSAO):'',
          url:String((location.hash||'')+' '+(document.title||'')).slice(0,480),
          msg:msg, stack:String(stack||'').slice(0,5900),
          extra:extra||null, ua:String(navigator.userAgent||'').slice(0,380)
        }).then(function(){},function(){});
      }catch(_){}
    }
    window.mevErro=function(msg, extra){ envia(String(msg||''), '', extra||null); };
    window.addEventListener('error',function(e){
      /* imagem/script que não carregou não é bug do app — ignora */
      if(e&&e.target&&e.target!==window&&(e.target.tagName==='IMG'||e.target.tagName==='SCRIPT'||e.target.tagName==='LINK')) return;
      envia((e&&e.message)||'erro', e&&e.error&&e.error.stack, {linha:(e&&e.lineno)||0, arq:String((e&&e.filename)||'').split('/').pop()});
    }, true);
    window.addEventListener('unhandledrejection',function(e){
      var r=e&&e.reason;
      envia((r&&(r.message||String(r)))||'promise rejeitada', r&&r.stack, null);
    });
  })();
  /* Reset de senha: quando o link do e-mail é clicado, o Supabase manda a pessoa
     de volta com "type=recovery" no endereço. Guardamos isso pra abrir a tela de
     "nova senha" no lugar de entrar no app. */
  var _recoveryFlag = false;
  try{
    var _recBusca=new URLSearchParams(String(location.search||''));
    /* v1268 — o fluxo PKCE volta com `?code=...`, sem `type=recovery` no
       fragmento. O marcador `recuperar=1` é colocado nos links novos; `code`
       mantém compatibilidade com os links já enviados antes desta versão. */
    _recoveryFlag = /type=recovery/.test(String(location.hash||'')) ||
      /[#&]recovery(?:$|&)/.test(String(location.hash||'')) ||
      _recBusca.get('recuperar')==='1' || !!_recBusca.get('code');
  }catch(_){}
  try{ supa.auth.onAuthStateChange(function(ev,sess){ if(ev==='PASSWORD_RECOVERY'){ _recoveryFlag=true; try{ abrirRecovery(); _recSessaoAplicar(sess); }catch(_){} } }); }catch(_){}
  /* logout À PROVA DE TRAVA: o supa.auth.signOut() pode TRAVAR se a sessão
     estiver presa — então disparamos sem esperar e limpamos a sessão do
     armazenamento na mão. Quem chama recarrega/volta pro login em seguida. */
  function _hardLogout(){
    try{ supa.auth.signOut(); }catch(_){}
    try{ for(var i=localStorage.length-1;i>=0;i--){ var k=localStorage.key(i); if(k&&(k.indexOf('sb-')===0||k.toLowerCase().indexOf('supabase')>=0)) localStorage.removeItem(k); } }catch(_){}
    token=null;
  }

  var $=function(i){return document.getElementById(i);};
  /* v1106 — o endereço do site em UM lugar (era 'mevplacas.com.br' escrito à mão em 12 módulos). Trocar = uma linha. */
  var MEV_DOMINIO='mevveiculos.com.br', MEV_SITE='https://'+MEV_DOMINIO;
  var token=null, meuId=null, meuEmail=null, meuNome='', meuFoto='', meuMeta=null, saldo=0, pacotes=[], usoTokens=null, veiculoAtual=null, pollTimer=null, modoAuth='login', tipoUsuario='cliente', ilimitado=false, histFonteTs=null, carteiraTokens='individual', politicaRecargaTokens='individual', podeRecarregarTokens=true, jaRecarregouTokens=false;
  /* ===== ACEITE LEGAL VERSIONADO =====
     Termos e Privacidade são condições contratuais de uso. Armazenamento essencial
     é informado separadamente: o app não condiciona o acesso a rastreamento opcional. */
  var LEGAL_TERMOS_VERSAO='2026.09.09';
  var LEGAL_PRIVACIDADE_VERSAO='2026.09.24';
  var LEGAL_COOKIES_VERSAO='2026.07.29';
  var LEGAL_APP_VERSAO='v206';
  var _legalGateAtivo=false;
  function legalFeature(){
    return 'legal_aceite_'+LEGAL_TERMOS_VERSAO.replace(/\W/g,'_')+'_'+LEGAL_PRIVACIDADE_VERSAO.replace(/\W/g,'_');
  }
  function legalCacheKey(){ return 'mev_legal_aceite_'+String(meuId||'')+'_'+legalFeature(); }
  function legalRegistroValido(d){
    return !!(d && d.termos_versao===LEGAL_TERMOS_VERSAO &&
      d.privacidade_versao===LEGAL_PRIVACIDADE_VERSAO &&
      d.armazenamento_essencial_ciente===true && d.aceito_em);
  }
  function legalCacheLer(){
    try{ var d=JSON.parse(localStorage.getItem(legalCacheKey())||'null'); return legalRegistroValido(d)?d:null; }catch(_){ return null; }
  }
  function legalCacheSalvar(d){ try{ localStorage.setItem(legalCacheKey(),JSON.stringify(d)); }catch(_){} }
  function legalMetaHtml(){
    return '<div class="legal-doc-meta">Versão '+LEGAL_TERMOS_VERSAO+' · última atualização em 09/09/2026</div>';
  }
  function legalTermosHtml(){
    return legalMetaHtml()+
      '<p>Estes Termos regulam o acesso e o uso do <b>MEV Veículos</b>. Ao marcar o aceite, você declara que leu e concorda com as condições abaixo. Se estiver usando o app em nome de uma loja ou empresa, declara possuir autorização para vinculá-la a estes Termos.</p>'+
      '<h3>1. O que o serviço oferece</h3>'+
      '<p>O MEV Veículos apoia rotinas de consulta, avaliação, estoque, negociação, venda e geração de documentos de veículos. Informações cadastrais, FIPE, restrições, leilão, ficha técnica e outros resultados podem vir de bases públicas e de fornecedores independentes.</p>'+
      '<div class="legal-alert"><b>Verificação obrigatória</b><span>Os resultados são auxiliares, podem estar incompletos ou desatualizados e não substituem certidões, laudos, vistoria, consulta direta ao órgão competente nem análise jurídica ou financeira.</span></div>'+
      '<h3>2. Conta e segurança</h3>'+
      '<ul><li>O acesso é destinado a pessoas maiores de 18 anos e usuários profissionais autorizados.</li><li>Você deve fornecer dados verdadeiros, manter sua senha em sigilo e avisar o suporte sobre uso indevido da conta.</li><li>As ações realizadas por usuários adicionados à sua loja são de responsabilidade da própria loja, respeitados os limites da lei.</li></ul>'+
      '<h3>3. Uso permitido e responsabilidades do usuário</h3>'+
      '<p>O app só pode ser usado para finalidade legítima relacionada à atividade veicular. É proibido consultar, inserir, compartilhar ou usar dados para perseguição, discriminação, fraude, revenda não autorizada de bases, violação de direitos, engenharia reversa, automação abusiva ou tentativa de contornar limites e segurança.</p>'+
      '<p>Ao inserir dados de clientes, funcionários, parceiros ou proprietários de veículos, você declara possuir base legal e autorização compatíveis com a LGPD, limitar a coleta ao necessário e prestar as informações exigidas aos titulares.</p>'+
      '<h3>4. Saldo, preços e pagamentos</h3>'+
      '<p>Consultas e recursos pagos são cobrados do saldo pré-pago em reais conforme o preço exibido antes da confirmação. Pagamentos podem ser processados por terceiros e a cobrança é emitida sob o CNPJ 35.180.374/0001-10. Cada recarga de saldo <b>vale 30 dias contados do crédito</b> e é consumida na ordem do vencimento, primeiro o saldo que vence antes; o prazo de cada lote é informado na tela da carteira e não é prorrogado por recargas posteriores. Valores creditados antes de 25/08/2026 permanecem sem prazo de validade, conforme a condição vigente na data da aquisição. O saldo já creditado não é devolvido nem convertido em dinheiro, ressalvado o direito de arrependimento de 7 dias do art. 49 do Código de Defesa do Consumidor para compras ainda não utilizadas. Reabrir um resultado já salvo não gera nova cobrança quando o app informar essa condição. Falhas de entrega são analisadas conforme a oferta, o Código de Defesa do Consumidor e a legislação aplicável.</p>'+
      '<h3>5. Conteúdo, documentos e inteligência artificial</h3>'+
      '<p>Você mantém a responsabilidade pelos dados, imagens e documentos enviados. Concede ao MEV autorização limitada para armazenar e processar esse conteúdo apenas para executar o recurso solicitado, inclusive por fornecedores de nuvem e, quando acionado, de inteligência artificial. Revise todo documento antes de assinar, enviar ou tomar uma decisão.</p>'+
      '<h3>6. Disponibilidade e fornecedores</h3>'+
      '<p>Buscamos manter o serviço disponível, mas podem ocorrer indisponibilidade, manutenção, atraso ou mudança em bases e integrações de terceiros. Recursos podem ser ajustados ou descontinuados com comunicação razoável quando a alteração for relevante.</p>'+
      '<h3>7. Propriedade intelectual</h3>'+
      '<p>A marca, a interface, os fluxos, os textos e o software do MEV Veículos são protegidos pela legislação aplicável. O acesso à conta não transfere direitos de propriedade nem autoriza cópia, exploração ou distribuição fora das permissões do serviço.</p>'+
      '<h3>8. Limites de responsabilidade</h3>'+
      '<p>Na medida permitida por lei, o MEV não responde por decisões tomadas sem a verificação recomendada, dados incorretos fornecidos pelo usuário ou por terceiros, uso ilícito da conta ou eventos fora de seu controle razoável. Esta cláusula não exclui direitos obrigatórios do consumidor nem responsabilidade que a lei não permita limitar.</p>'+
      '<h3>9. Suspensão e encerramento</h3>'+
      '<p>Contas podem ser suspensas para prevenir fraude, incidente de segurança, inadimplência ou violação destes Termos, com possibilidade de contato pelo suporte. Você pode pedir o encerramento da conta e a eliminação dos dados, observadas retenções legais e a necessidade de resguardar direitos.</p>'+
      '<h3>10. Alterações, lei e contato</h3>'+
      '<p>Alterações relevantes serão apresentadas para novo aceite. Aplicam-se as leis brasileiras. Eventual foro será definido pela legislação aplicável, preservado o foro do consumidor quando cabível.</p>'+
      '<p>Dúvidas, contestação de cobrança ou solicitação legal: <a href="https://wa.me/5551996417433?text=Ol%C3%A1%2C%20preciso%20falar%20sobre%20os%20Termos%20do%20MEV%20Ve%C3%ADculos." target="_blank" rel="noopener">WhatsApp +55 51 99641-7433</a>.</p>';
  }
  function legalPrivacidadeHtml(){
    return '<div class="legal-doc-meta">Versão '+LEGAL_PRIVACIDADE_VERSAO+' · última atualização em 24/09/2026</div>'+
      '<p>Esta Política explica como o responsável pela operação do <b>MEV Veículos</b>, na condição de controlador quando define as finalidades do tratamento, usa e protege dados pessoais. A identificação cadastral completa do controlador pode ser solicitada no canal de privacidade abaixo.</p>'+
      '<h3>1. Dados tratados</h3>'+
      '<ul><li><b>Conta e perfil:</b> e-mail, nome, telefone, CPF, foto, senha protegida pelo provedor de autenticação, endereço e dados profissionais.</li><li><b>Loja e equipe:</b> CNPJ, razão social, nome fantasia, integrantes, funções, remuneração e histórico de atividade.</li><li><b>Clientes e negócios:</b> contatos, endereço, documentos, dados de propostas, trocas, pagamentos, comprovantes, comissões e entrega.</li><li><b>Faturamento:</b> nome completo, CPF e telefone informados depois da confirmação do pagamento para emissão da nota fiscal da recarga.</li><li><b>Veículos e consultas:</b> placa, chassi, RENAVAM, características, imagens, histórico, resultados e documentos relacionados.</li><li><b>Uso e segurança:</b> data e hora, sessão, preferências, registros técnicos, endereço IP e informações necessárias para prevenir fraude e diagnosticar falhas.</li></ul>'+
      '<h3>2. Finalidades e bases legais</h3>'+
      '<p>Tratamos dados para criar e proteger a conta; prestar os recursos contratados; processar pagamentos e emitir documentos fiscais; salvar histórico; gerar documentos; atender suporte; cumprir obrigações legais; prevenir fraude; exercer direitos em processos; e melhorar a segurança e o funcionamento do serviço. Conforme o caso, usamos execução de contrato, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, legítimo interesse com avaliação de necessidade e impacto, proteção ao crédito e consentimento quando ele for realmente exigido.</p>'+
      '<h3>3. Compartilhamento e operadores</h3>'+
      '<p>Dados podem ser compartilhados, no limite necessário, com provedores de autenticação e banco em nuvem (como Supabase), hospedagem e execução (como Netlify), pagamento (como Mercado Pago), consultas veiculares e bases públicas, armazenamento, comunicação, suporte e inteligência artificial (como Anthropic ou Google quando um recurso de IA for usado). Também podemos compartilhar mediante obrigação legal, ordem de autoridade ou para proteção de direitos.</p>'+
      '<p>Não vendemos dados pessoais nem os disponibilizamos para publicidade comportamental.</p>'+
      '<h3>4. Transferências internacionais</h3>'+
      '<p>Alguns fornecedores podem processar dados fora do Brasil. Nesses casos, buscamos fornecedores com medidas contratuais e de segurança compatíveis e aplicamos os mecanismos previstos na LGPD e na regulamentação da ANPD.</p>'+
      '<h3>5. Armazenamento e retenção</h3>'+
      '<p>Os dados permanecem pelo tempo necessário para prestar o serviço, cumprir obrigações legais e regulatórias, prevenir fraude e resguardar direitos. Depois, são eliminados ou anonimizados quando cabível. Prazos variam conforme a categoria do dado, a finalidade e o dever legal aplicável.</p>'+
      '<h3>6. Direitos do titular</h3>'+
      '<p>Você pode solicitar confirmação e acesso; correção; anonimização, bloqueio ou eliminação quando cabível; portabilidade conforme regulamentação; informação sobre compartilhamentos; revisão de decisões automatizadas; oposição; e revogação de consentimento sem afetar tratamentos anteriores legítimos. Podemos confirmar sua identidade antes de atender ao pedido.</p>'+
      '<h3>7. Segurança e incidentes</h3>'+
      '<p>Adotamos controles técnicos e administrativos proporcionais ao risco, incluindo autenticação, restrição de acesso e proteção das integrações. Nenhum sistema é infalível. Incidentes com risco ou dano relevante serão avaliados, registrados e comunicados aos titulares e à ANPD nos casos e prazos aplicáveis.</p>'+
      '<h3>8. Dados de terceiros e menores</h3>'+
      '<p>O usuário profissional deve inserir somente dados de terceiros necessários e obtidos de forma legítima. O serviço não é direcionado a menores de 18 anos; não envie dados de crianças ou adolescentes salvo quando estritamente necessário e amparado pela legislação.</p>'+
      '<h3>9. Canal de privacidade</h3>'+
      '<p>Para exercer direitos, informar incidente ou pedir a identificação do controlador, use o <a href="https://wa.me/5551996417433?text=Ol%C3%A1%2C%20tenho%20uma%20solicita%C3%A7%C3%A3o%20de%20privacidade%20ou%20LGPD%20no%20MEV%20Ve%C3%ADculos." target="_blank" rel="noopener">WhatsApp +55 51 99641-7433</a>. Pedidos serão tratados conforme a LGPD e a regulamentação aplicável.</p>';
  }
  function legalCookiesHtml(){
    return '<div class="legal-doc-meta">Versão '+LEGAL_COOKIES_VERSAO+' · última atualização em 05/08/2026</div>'+
      '<p>O MEV Veículos usa <b>armazenamento local e tecnologias essenciais</b> para manter a sessão, proteger o acesso, lembrar preferências, preservar rascunhos, disponibilizar histórico e permitir funcionamento offline da interface. Sem esse armazenamento, o app não consegue operar corretamente.</p>'+
      '<p><b>Neste momento, o MEV não usa cookies de publicidade ou rastreamento de marketing.</b> Se tecnologias opcionais forem adicionadas, elas ficarão desativadas por padrão e serão oferecidas em controle separado, com opção equivalente de aceitar ou rejeitar e possibilidade de mudar a escolha.</p>'+
      '<p>Você pode apagar os dados locais nas configurações do navegador, mas isso pode encerrar a sessão, remover rascunhos não sincronizados e exigir um novo login.</p>';
  }
  /* ==========================================================================
     🔴🔴 19/08 — FAZER A FALHA FALAR
     (PROJETO-o-aceite-que-pede-de-novo-e-da-erro, Fases 1 e 3)

     O RELATO do Angelo: *"já dei os aceites, pediu de novo e dá erro"*, com o
     print da tela vermelha "Confira a internet e tente novamente".

     🟢 O ACEITE DELE ESTAVA GRAVADO E VÁLIDO — conferido no banco, com a
     assinatura HMAC recalculada campo a campo. Ou seja: a tela **não** era o
     sistema pedindo aceite novo. Era o sistema **não conseguindo ouvir a
     resposta que já tinha**.

     E não deu pra cravar a causa, por um motivo que é o próprio defeito:
     **o app apagava a prova.** Três buracos, de uma linha cada:

       1. a mensagem era um chute escrito à mão. O servidor DIZ o motivo —
          "Sessão inválida", "Servidor sem chave de registro legal", "conta
          incompleta" — e a linha de cima jogava tudo fora, virando "confira
          a internet". Se for a internet, acerta por acidente; nos outros
          casos manda caçar um problema que não existe;
       2. a falha não deixava rastro. O app TEM `mp_erros` e usa em tudo —
          menos aqui, na única porta obrigatória do app, a que impede a
          pessoa de trabalhar. Era a única que falhava em silêncio;
       3. a prova que o aparelho já tinha era ignorada: o cache assinado só
          era lido quando o `fetch` ESTOURAVA. Servidor respondendo 401, 500
          ou resposta cortada → `return false` sem nem olhar o cache.

     ⚠️⚠️ E O QUE **NÃO** MUDOU, DE PROPÓSITO: **o gate não afrouxou.** É um
     documento legal. A tentação é "na dúvida, deixa entrar" — não. O que
     libera continua sendo SÓ um aceite assinado pelo servidor e já
     confirmado naquele aparelho (`salvo_no_banco===true`). Não conseguir
     perguntar não libera nada, hoje nem depois.
     ========================================================================== */
  var _legalJaRegistrou=false;
  /* registra no mp_erros UMA vez por sessão — o mesmo cuidado da v272, pra o
     diagnóstico não virar enxurrada. O detalhe cru vai pra cá; pra tela vai
     só a frase que diz o que FAZER. */
  function legalRegistrarFalha(oque, r){
    try{
      if(_legalJaRegistrou) return; _legalJaRegistrou=true;
      if(typeof window.mevErro !== 'function') return;
      window.mevErro('aceite-legal: '+oque, {
        quem:String(meuId||''),
        motivo:(r&&r.motivo)||'', erro:(r&&r.erro)||'',
        rede:!!(r&&r.rede),
        termos:LEGAL_TERMOS_VERSAO, privacidade:LEGAL_PRIVACIDADE_VERSAO,
        build:(typeof MEV_BUILD!=='undefined'?MEV_BUILD:'')
      });
    }catch(_){ }
  }
  /* ⏱️ um número só, e maior. Eram 8s no status e 10s no aceitar — dois
     números medindo a mesma rede. O 4G de pátio com sinal fraco (que é o do
     print) passa disso com folga. */
  var LEGAL_ESPERA_MS=15000;
  async function legalAceiteExiste(){
    var cache=legalCacheLer();
    var r=null;
    try{
      r=await apiComTimeout('/api/aceite-legal',{acao:'status'},LEGAL_ESPERA_MS);
      var dados=r&&r.dados;
      if(r&&r.ok&&r.aceito&&legalRegistroValido(dados)){
        dados.salvo_no_banco=true; legalCacheSalvar(dados); return true;
      }
    }catch(_){ r=null; }
    /* 🔴 O CACHE AGORA É CONSULTADO SEMPRE, não só quando o fetch estoura.
       Aceite assinado pelo servidor e já confirmado NESTE aparelho é prova
       tão boa quanto perguntar de novo — e é o que impede uma oscilação de
       rede de trancar a pessoa fora do próprio trabalho.
       ⚠️ Continua exigindo `salvo_no_banco===true`: cache que nunca foi
       confirmado pelo servidor não vale nada. */
    if(cache && cache.salvo_no_banco===true){
      /* ⚠️ o servidor dizer "não" COM o cache válido aqui é um sinal que
         merece registro: ou a sessão é de outra conta, ou o gate ia abrir
         quando não devia. Sem isto ninguém nunca saberia. */
      if(r && r.ok===true && r.aceito===false) legalRegistrarFalha('servidor diz NÃO com cache válido no aparelho', r);
      return true;
    }
    if(!r || r.rede || r.erro) legalRegistrarFalha('não consegui confirmar o aceite', r);
    return false;
  }
  /* a frase que a tela mostra: a do servidor quando ela existir, e a da
     internet SÓ quando a falha for mesmo de rede.
     ⚠️ frase que diz o que FAZER — nada de despejo técnico na tela. */
  function legalMsgErro(r){
    if(r && r.rede) return 'A conexão falhou. Confira a internet e toque em Tentar de novo.';
    if(r && r.erro) return String(r.erro);
    if(!r) return 'A conexão demorou demais. Toque em Tentar de novo.';
    return 'Não foi possível registrar seu aceite agora. Toque em Tentar de novo.';
  }
  async function legalAceiteSalvar(){
    var r=null;
    try{ r=await apiComTimeout('/api/aceite-legal',{acao:'aceitar'},LEGAL_ESPERA_MS); }
    catch(_){ r=null; }
    /* ⏱️ UMA segunda tentativa antes de mostrar erro. Primeira falha em 4G de
       pátio é rotina; fazer a pessoa tocar de novo pra descobrir isso é
       trabalho que o app pode poupar. ⚠️ Só repete quando a falha foi de rede
       ou de tempo — erro que o servidor EXPLICOU não melhora repetindo, e
       repetir aceite que talvez tenha gravado é pior ainda. */
    if(r===null || (r && r.rede)){
      try{ r=await apiComTimeout('/api/aceite-legal',{acao:'aceitar'},LEGAL_ESPERA_MS); }
      catch(_){ r=null; }
    }
    if(!(r&&r.ok&&r.aceito&&legalRegistroValido(r.dados))){
      legalRegistrarFalha('não consegui registrar o aceite', r);
      var e=new Error((r&&r.erro)||'aceite não registrado');
      e.mev=legalMsgErro(r);
      throw e;
    }
    var dados=r.dados;
    dados.salvo_no_banco=true;
    legalCacheSalvar(dados);
    return dados;
  }
  function legalPrenderFoco(root,e){
    if(!root||!e||e.key!=='Tab') return;
    var itens=Array.prototype.filter.call(root.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href]'),function(el){ return el.offsetParent!==null; });
    if(!itens.length){ e.preventDefault(); return; }
    var primeiro=itens[0], ultimo=itens[itens.length-1];
    if(e.shiftKey&&document.activeElement===primeiro){ e.preventDefault(); ultimo.focus(); }
    else if(!e.shiftKey&&document.activeElement===ultimo){ e.preventDefault(); primeiro.focus(); }
  }
  function legalDocumentoAbrir(tipo){
    var antigo=$('legalDocMask'); if(antigo) antigo.remove();
    var focoAnterior=document.activeElement;
    var titulo=tipo==='privacidade'?'Política de Privacidade':(tipo==='cookies'?'Aviso de armazenamento e cookies':'Termos de Uso');
    var html=tipo==='privacidade'?legalPrivacidadeHtml():(tipo==='cookies'?legalCookiesHtml():legalTermosHtml());
    var bg=document.createElement('div'); bg.id='legalDocMask'; bg.className='legal-doc-mask';
    bg.setAttribute('role','dialog'); bg.setAttribute('aria-modal','true'); bg.setAttribute('aria-labelledby','legalDocTitulo');
    bg.innerHTML='<section class="legal-doc-card"><header><div><span>DOCUMENTO LEGAL</span><h2 id="legalDocTitulo">'+titulo+'</h2></div>'+
      '<button type="button" class="legal-icon-btn" id="legalDocFechar" aria-label="Fechar documento"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></header>'+
      '<div class="legal-doc-content">'+html+'</div><footer><button type="button" class="cad-btn" id="legalDocEntendi">Entendi</button></footer></section>';
    document.body.appendChild(bg);
    function fechar(){ try{bg.remove();}catch(_){} try{if(focoAnterior&&focoAnterior.focus) focoAnterior.focus();}catch(_){} }
    $('legalDocFechar').onclick=fechar; $('legalDocEntendi').onclick=fechar;
    bg.addEventListener('click',function(e){ if(e.target===bg) fechar(); });
    bg.addEventListener('keydown',function(e){ if(e.key==='Escape') fechar(); else legalPrenderFoco(bg,e); });
    setTimeout(function(){ try{$('legalDocFechar').focus();}catch(_){} },60);
  }
  function legalAceiteAbrir(){
    return new Promise(function(resolve){
      var antigo=$('legalGate'); if(antigo) antigo.remove();
      var bg=document.createElement('div'); bg.id='legalGate'; bg.className='legal-mask';
      bg.setAttribute('role','dialog'); bg.setAttribute('aria-modal','true'); bg.setAttribute('aria-labelledby','legalGateTitulo');
      bg.innerHTML='<section class="legal-card"><header class="legal-head"><span class="legal-head-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg></span>'+
        '<div><div class="legal-kicker">PRIVACIDADE E SEGURANÇA</div><h1 id="legalGateTitulo">Antes de continuar</h1><p>Leia e confirme os documentos do MEV Veículos.</p></div></header>'+
        '<div class="legal-body"><div class="legal-summary"><b>O que você está aceitando</b><p>Regras de uso do app, tratamento dos dados necessários ao serviço e uso de armazenamento essencial para login, preferências, histórico e rascunhos.</p></div>'+
        '<div class="legal-doc-links">'+
          '<button type="button" class="legal-doc-btn" data-legal-doc="termos"><span>Termos de Uso <small>versão '+LEGAL_TERMOS_VERSAO+'</small></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></button>'+
          '<button type="button" class="legal-doc-btn" data-legal-doc="privacidade"><span>Política de Privacidade <small>versão '+LEGAL_PRIVACIDADE_VERSAO+'</small></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></button>'+
          '<button type="button" class="legal-doc-btn" data-legal-doc="cookies"><span>Armazenamento e cookies <small>somente essenciais</small></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></button>'+
        '</div>'+
        '<label class="legal-check"><input type="checkbox" id="legalCkTermos"><span><b>Li e aceito os Termos de Uso e a Política de Privacidade.</b><small>Obrigatório para usar o serviço.</small></span></label>'+
        '<label class="legal-check"><input type="checkbox" id="legalCkCookies"><span><b>Estou ciente do armazenamento essencial.</b><small>Não usamos cookies de publicidade ou marketing neste momento.</small></span></label>'+
        '<div class="legal-error" id="legalErro" role="alert"></div>'+
        '<div class="legal-actions"><button type="button" class="legal-exit" id="legalSair">Sair da conta</button><button type="button" class="cad-btn" id="legalAceitar" disabled>Aceitar e continuar</button></div>'+
        '<p class="legal-proof">O aceite registra sua conta, data e versões dos documentos.</p></div></section>';
      document.body.appendChild(bg);
      var ck1=$('legalCkTermos'), ck2=$('legalCkCookies'), aceitar=$('legalAceitar'), erro=$('legalErro');
      function atualizar(){ aceitar.disabled=!(ck1.checked&&ck2.checked); }
      ck1.onchange=atualizar; ck2.onchange=atualizar;
      bg.addEventListener('keydown',function(e){ legalPrenderFoco(bg,e); });
      Array.prototype.forEach.call(bg.querySelectorAll('[data-legal-doc]'),function(b){ b.onclick=function(){ legalDocumentoAbrir(b.getAttribute('data-legal-doc')); }; });
      $('legalSair').onclick=function(){
        _hardLogout(); _legalGateAtivo=false; try{bg.remove();}catch(_){}
        var ba=$('btnAuth'); if(ba){ ba.disabled=false; ba.textContent=(modoAuth==='cad'?'Criar conta grátis':'Entrar'); }
        show('scAuth'); resolve(false);
      };
      aceitar.onclick=async function(){
        if(aceitar.disabled) return;
        erro.textContent=''; aceitar.disabled=true; aceitar.textContent='Salvando aceite…';
        try{
          await legalAceiteSalvar(); _legalGateAtivo=false; bg.remove(); resolve(true);
        }catch(e){
          /* 🔴 19/08 — a tela passa a dizer O MOTIVO. Antes, "Sessão inválida",
             "sua conta está incompleta" e "acabou a internet" viravam a MESMA
             frase, e as três pedem consertos diferentes. */
          erro.textContent=(e&&e.mev) || 'Não foi possível registrar seu aceite agora. Toque em Tentar de novo.';
          aceitar.disabled=false;
          /* 🔴 e o botão vira "Tentar de novo" de verdade. Até hoje o único
             OUTRO botão desta tela era "Sair da conta" — a pessoa perdia o
             acesso ao próprio trabalho por causa de uma oscilação de rede. */
          aceitar.textContent='Tentar de novo';
        }
      };
      setTimeout(function(){ try{ck1.focus();}catch(_){} },80);
    });
  }
  /* ==========================================================================
     🔴 v743 — O ACEITE LEMBRADO ABRE A PORTA; O SERVIDOR CONFERE POR TRÁS
     (FASE 5 da velocidade, item b do TXT)
     Medido em 30/08: "aceite 678 ms" a cada abertura — era a pergunta
     /api/aceite-legal {status} feita ANTES de mostrar o app, mesmo com o
     aparelho já tendo o aceite assinado pelo servidor guardado.

     Desde 19/08 esse cache (assinado, `salvo_no_banco===true`, com as
     versões dos Termos na própria chave) já valia como prova quando a rede
     falhava. Agora ele vale PRIMEIRO: abre o app na hora e pergunta ao
     servidor em 2º plano.
       · servidor "sim" → regrava o cache; ninguém viu nada;
       · servidor "NÃO" (ok===true, aceito===false: registro sumiu ou a
         regra do servidor mudou) → registra no mp_erros, APAGA o cache e
         mostra o #legalGate POR CIMA do app — a pessoa aceita de novo ou
         sai da conta, como antes;
       · rede/erro → o cache continua sendo a prova (regra de 19/08).
     ⚠️ O gate NÃO afrouxou: sem cache assinado e confirmado, o caminho é o
     de sempre (pergunta antes, gate se não houver). Termos novos = chave
     nova = sem cache = pergunta antes. Servidor continua sendo a verdade;
     só deixou de ser a fila.
     ========================================================================== */
  var _legalConferindo=false;
  async function legalConferirPorTras(){
    if(_legalConferindo) return true; _legalConferindo=true;
    var r=null;
    try{ r=await apiComTimeout('/api/aceite-legal',{acao:'status'},LEGAL_ESPERA_MS); }catch(_){ r=null; }
    _legalConferindo=false;
    if(r && r.ok && r.aceito && legalRegistroValido(r.dados)){ r.dados.salvo_no_banco=true; legalCacheSalvar(r.dados); return true; }
    if(r && r.ok===true && r.aceito===false){
      legalRegistrarFalha('servidor diz NÃO com cache válido no aparelho (v743: gate por cima)', r);
      try{ localStorage.removeItem(legalCacheKey()); }catch(_){}
      _passo('aceite-negado');
      _legalGateAtivo=true;
      var ok=await legalAceiteAbrir();
      _legalGateAtivo=false;
      return ok;
    }
    return true;   /* rede/erro: o cache assinado segue sendo a prova */
  }
  async function legalGarantirAceite(){
    if(!meuId) return false;
    var _lembrado=legalCacheLer();
    if(_lembrado && _lembrado.salvo_no_banco===true){
      _passo('aceite-local');
      legalConferirPorTras()['catch'](function(){});
      return true;
    }
    _legalGateAtivo=true;
    if(await legalAceiteExiste()){ _legalGateAtivo=false; return true; }
    return await legalAceiteAbrir();
  }
  /* corre uma promessa contra um tempo limite — evita telas presas em "Carregando" na rede ruim */
  function withTimeout(p,ms){ return Promise.race([ p, new Promise(function(_,rej){ setTimeout(function(){ rej(new Error('timeout')); }, ms||10000); }) ]); }
  /* esqueleto animado (skeleton) enquanto a lista carrega — dá sensação de rapidez */
  function skelHtml(n){ var s=''; n=n||4; for(var i=0;i<n;i++){ s+='<div class="skel-row"><div class="skel-av"></div><div class="skel-tx"><span></span><span></span></div></div>'; } return '<div class="skel-wrap">'+s+'</div>'; }
  /* estado de erro padrão, com botão "Tentar de novo" (recebe a função que recarrega) */
  function erroLista(el, recarregar){ if(!el) return; el.innerHTML='<div class="cli-empty"><b>Não consegui carregar agora</b>Verifique sua internet e tente de novo.<button type="button" class="lista-retry" style="margin-top:12px;background:#0a4da6;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">Tentar de novo</button></div>'; var b=el.querySelector('.lista-retry'); if(b&&recarregar) b.onclick=recarregar; }
  var gratisFipe=0, gratisFipeAtivo=false, gratisFipeExpiraEm=null; /* v1301: cortesia diária da recarga */
  var TEMA_CONSULTAS_CHAVE='mev_consultas_tema';
  var _temaConsultasPreferencia='escuro',_temaConsultasTrocaEm=0;
  function temaConsultasPreferenciaLer(){
    var v='';
    try{ v=sessionStorage.getItem(TEMA_CONSULTAS_CHAVE)||''; }catch(_){}
    if(v!=='claro'&&v!=='escuro'&&v!=='preto')try{ v=localStorage.getItem(TEMA_CONSULTAS_CHAVE)||''; }catch(_){}
    /* v1356: tanto o antigo azul-escuro quanto Preto profundo migram para o
       único modo Escuro, agora preto. Nenhuma escolha salva é perdida. */
    return v==='claro'?'claro':'escuro';
  }
  function temaConsultasPreferenciaSalvar(v){
    try{ localStorage.setItem(TEMA_CONSULTAS_CHAVE,v); }catch(_){}
    try{ sessionStorage.setItem(TEMA_CONSULTAS_CHAVE,v); }catch(_){}
  }
  function temaConsultasEscuro(){ return document.body.classList.contains('tema-escuro'); }
  function temaConsultasModo(){ return temaConsultasEscuro()?'escuro':'claro'; }
  function temaConsultasPintar(modo){
    /* compatibilidade: chamadas antigas ainda podem enviar booleano */
    modo=modo===true?'escuro':modo===false?'claro':String(modo||'escuro');
    if(modo!=='claro'&&modo!=='escuro') modo='escuro';
    var escuro=modo==='escuro';
    document.body.classList.toggle('tema-escuro',escuro);
    document.body.classList.toggle('tema-preto',escuro);
    var r=document.getElementById('mdrTemaRot');
    if(r) r.textContent=escuro?'Escuro':'Claro';
    var b=document.getElementById('mdrTema');
    if(b){
      b.classList.toggle('is-dark',escuro);b.classList.remove('is-deep');
      b.setAttribute('data-tema',modo);b.removeAttribute('aria-pressed');
      b.setAttribute('aria-label',escuro?'Aparência: escuro. Ativar tema claro':'Aparência: claro. Ativar tema escuro');
    }
    try{ var meta=document.querySelector('meta[name="theme-color"]'); if(meta) meta.setAttribute('content',escuro?'#02050a':'#001e50'); }catch(_){}
    try{ if(typeof tbTemaBarraSincronizar==='function') tbTemaBarraSincronizar(); }catch(_){}
  }
  function temaConsultasAlternar(){
    /* v1330 — a preferência, não a classe visual, decide a próxima opção.
       Um segundo click/tap do mesmo gesto é ignorado para o switch não
       acender e voltar imediatamente em aparelhos móveis. */
    var agora=Date.now();
    if(_temaConsultasTrocaEm&&agora-_temaConsultasTrocaEm<450) return _temaConsultasPreferencia;
    _temaConsultasTrocaEm=agora;
    _temaConsultasPreferencia=_temaConsultasPreferencia==='claro'?'escuro':'claro';
    temaConsultasPreferenciaSalvar(_temaConsultasPreferencia);
    temaConsultasPintar(_temaConsultasPreferencia);
    return _temaConsultasPreferencia;
  }
  /* v1303 — o MEV Consultas nasce escuro. Só uma escolha explícita por
     "Tema claro" substitui o padrão; a opção continua reversível no menu. */
  _temaConsultasPreferencia=temaConsultasPreferenciaLer();
  temaConsultasPintar(_temaConsultasPreferencia);
  /* iOS pode restaurar a página pelo cache de navegação sem repetir o boot.
     Ao reaparecer, repinta a escolha em memória em vez de inferir pelo DOM. */
  window.addEventListener('pageshow',function(){ temaConsultasPintar(_temaConsultasPreferencia); });
  window.addEventListener('storage',function(e){
    if(!e||e.key!==TEMA_CONSULTAS_CHAVE||(e.newValue!=='claro'&&e.newValue!=='escuro'&&e.newValue!=='preto'))return;
    _temaConsultasPreferencia=e.newValue==='claro'?'claro':'escuro';
    try{ sessionStorage.setItem(TEMA_CONSULTAS_CHAVE,_temaConsultasPreferencia); }catch(_){}
    temaConsultasPintar(_temaConsultasPreferencia);
  });
  function fmtTok(n){ n=Math.round((Number(n)||0)*100)/100; return n.toLocaleString('pt-BR',{maximumFractionDigits:2}); }
  /* ===== v971 — TODO PREÇO E TODO SALDO VISÍVEL EM REAIS
     A unidade legada continua apenas no motor interno (carteira, débitos e
     estornos), preservando saldos e pagamentos existentes. A interface nunca
     expõe essa unidade: toda saída para a pessoa passa por precoReal().
     ⛳ Esta é a função única da Fase 2 do PROJETO-cpf-tres-cards-e-preco-real
     ("R$ na interface inteira") — ela nasce aqui, no módulo base, pra que a
     Fase 2 só precise TROCAR OS TEXTOS pra chamá-la, sem reescrever conta.
     🔴 Um lugar só pro valor do token: mexeu aqui, mexeu no app inteiro. */
  var TOKEN_RS = 1.90;
  function precoReal(tokens){
    var v = (Number(tokens)||0) * TOKEN_RS;
    return 'R$ ' + v.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  var meuPapel='vendedor', _equipeHist=[], _histView='minhas';
  /* v764 (§14.7/§14.8 do projeto cards-consulta): o estado da CARGA da
     equipe, pro cartão do histórico saber a diferença entre "carregando"
     (esqueleto), "erro" (Tentar novamente) e "ok sem placas". Quem lê é o
     pintaHomeHist (05). */
  var _equipeCarga='parado';
  var HIST_DIAS=30;
  var fichaState=null, leilaoState=null, debitosState=null;   /* cache do que já foi gerado (evita cobrar de novo ao voltar) */
  var _ehMoto=false, _avCusto=[], _motoPorte='med';   /* estado da avaliação (carro x moto) */
  var sugSel='loja', valorTocado=false;    /* sugestão escolhida na avaliação */
  /* v176: liqTocado = o usuário digitou um valor de liquidez na mão.
     Enquanto for true, a conta automática NÃO mexe mais no campo.
     Apagando tudo, ele volta a false e o cálculo volta a mandar. */
  var liqTocado=false;
  /* v178: repTocado = o usuario digitou o preco do repasse na mao.
     Mesma logica da liquidez: enquanto for true, a conta automatica nao
     mexe mais nesse campo. Apagou tudo, volta a calcular sozinho.
     _repPrecoPub = o preco que esta publicado no portal AGORA (pra saber
     se o valor mudou de verdade antes de republicar). */
  var repTocado=false, _repPrecoPub=0;
  /* v243: padrao visual R$ 0.000,00 — o valor continua inteiro por dentro */
  function r$(n){ return 'R$ '+Math.round(Number(n)||0).toLocaleString('pt-BR')+',00'; }
  /* Recursos pesados não atrasam o primeiro acesso. A lista permitida fica no
     módulo local MEVAssets (mev-home.js); nenhuma URL digitada vira script. */
  function _mevCarregarRecurso(grupo, continuar){
    var assets=window.MEVAssets;
    if(!assets || typeof assets.garantir!=='function'){
      toast('Não consegui preparar este recurso agora. Atualize a página e tente novamente.');
      return false;
    }
    toast(grupo==='ia'?'Preparando leitura por IA…':(grupo==='docs'?'Preparando documentos…':'Preparando PDF…'));
    assets.garantir(grupo).then(function(){ continuar(); }).catch(function(){
      toast('Não consegui carregar este recurso agora. Tente novamente.');
    });
    return false;
  }
  function _mevPdfPronto(continuar, documentos){
    if(window.jspdf&&window.jspdf.jsPDF&&(!documentos||window.MEV_DOCPDF)) return true;
    return _mevCarregarRecurso(documentos?'docs':'pdf',continuar);
  }
  function _iaAcao(continuar, mensagem){
    if(window.MEV_IA){ if(mensagem) toast(mensagem); continuar(); return true; }
    return _mevCarregarRecurso('ia',continuar);
  }

  /* v590 — 🔴🔴 O DEFEITO QUE O CELULAR DA ESPOSA DENUNCIOU (22/08):
     `authPintarContexto()` era chamada aqui e NÃO EXISTE em nenhum dos 65
     módulos (alguma versão apagou a função e esqueceu a chamada). Resultado:
     TODO usuário DESLOGADO estourava aqui, o erro morria em catches mudos e
     o splash ficava em loop infinito — cliente novo não conseguia nem VER a
     tela de login. Ninguém percebeu porque quem testa está sempre logado
     (inclusive o robô de teste — o teste-v590 agora abre DESLOGADO).
     A chamada fica GUARDADA: se a função um dia voltar a existir, volta a
     ser chamada; se não existir, o login abre do mesmo jeito — e qualquer
     erro aqui dentro vira migalha em vez de morrer calado. */
  /* ===== v601 — A ENTRADA (o gancho mora num lugar só) ===================
     Existem SETE lugares que chamam show('scAuth') — boot sem sessão,
     logout, sessão expirada, erro de boot, troca de aparelho, fim do reset
     de senha. Enganchar em cada um seriam sete chances de esquecer um; por
     isso o gancho vai DENTRO do show().

     E vem de graça a regra "anima ao ABRIR, não a cada toque": as abas
     Entrar / Criar conta passam pelo authSelecionarModo(), que nunca chama
     show(). Movimento que se repete a cada clique encanta na primeira
     semana e irrita na terceira.

     O `void offsetWidth` existe porque tirar e devolver a classe no mesmo
     quadro não reinicia animação nenhuma — o navegador só enxerga o estado
     final. E a classe SAI no fim pra não deixar um `forwards` pendurado nos
     elementos pelo resto da sessão. */
  function _entradaAnima(el){
    if(!el) return;
    try{
      el.classList.remove('entrando');
      void el.offsetWidth;
      el.classList.add('entrando');
      clearTimeout(el.__entTm);
      el.__entTm=setTimeout(function(){ try{ el.classList.remove('entrando'); }catch(_){} }, 1200);
    }catch(_){}
  }
  function show(id){ if(id==='scAuth'){ try{ if(typeof authPintarContexto==='function') authPintarContexto(); }catch(e){ try{ window.__mevErros.push('authPintarContexto: '+String((e&&e.message)||e).slice(0,120)); }catch(_){} } } ['scLoad','scAuth','scApp'].forEach(function(s){ $(s).style.display=(s===id?'':'none'); }); $('btnSair').style.display=(id==='scApp')?'':'none'; var mb=$('btnMenu'); if(mb) mb.style.display=(id==='scApp')?'inline-flex':'none'; document.body.classList.toggle('app-on', id==='scApp'); fabFoto(id==='scApp'); if(id==='scAuth') _entradaAnima($('scAuth')); }
  function authSelecionarModo(modo, focar){
    modoAuth=(modo==='cad')?'cad':'login';
    var login=$('tabLogin'), cad=$('tabCad'), painel=$('authCampos'), botao=$('btnAuth'), senha=$('authSenha'), msg=$('authMsg');
    var consultas=false;
    try{ consultas=typeof edicaoAtual==='function'&&edicaoAtual()==='consultas'; }catch(_){}
    if(login){ login.classList.toggle('on',modoAuth==='login'); login.setAttribute('aria-selected',modoAuth==='login'?'true':'false'); login.tabIndex=modoAuth==='login'?0:-1; }
    if(cad){ cad.classList.toggle('on',modoAuth==='cad'); cad.setAttribute('aria-selected',modoAuth==='cad'?'true':'false'); cad.tabIndex=modoAuth==='cad'?0:-1; }
    if(painel) painel.setAttribute('aria-labelledby',modoAuth==='cad'?'tabCad':'tabLogin');
    if(botao) botao.textContent=modoAuth==='cad'?'Criar conta':'Entrar';
    if(senha){
      senha.setAttribute('autocomplete',modoAuth==='cad'?'new-password':'current-password');
      if(consultas) senha.placeholder=modoAuth==='cad'?'Crie uma senha (mínimo 6 caracteres)':'Digite sua senha';
    }
    if(consultas){
      var titulo=$('authTitulo'), subtitulo=$('authSub');
      var esqueceu=$('authEsqueci'), linhaEsqueceu=esqueceu&&esqueceu.parentElement;
      var consultasNoSite=!!window.__mevConsultasNoSite;
      if(titulo) titulo.textContent=modoAuth==='cad'?'Criar conta':'Entrar';
      if(linhaEsqueceu) linhaEsqueceu.hidden=modoAuth==='cad';
      if(subtitulo) subtitulo.textContent=modoAuth==='cad'
        ?(consultasNoSite?'Crie sua conta para consultar sem sair do site.':'Comece agora e mantenha suas consultas organizadas.')
        :(consultasNoSite?'Consulte, pague e acesse seus resultados salvos.':'Acesse suas consultas e resultados salvos.');
    }
    if(msg) msg.className='msg';
    if(focar){ try{ (modoAuth==='cad'?cad:login).focus(); }catch(_){} }
  }
  function limpa(p){return String(p||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);}
  function valida(p){return /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p);}
  /* ==========================================================================
     🔴🔴 v882 — A TRAVA DA PLACA, POSIÇÃO POR POSIÇÃO
     (pedido do Angelo, 04/09: "coloca uma trava quando o cliente digita a
      placa nos campos de consulta")
     --------------------------------------------------------------------------
     A REGRA, e ela é UMA SÓ pro app inteiro:

         posição   1  2  3   4   5    6  7
         aceita    A  A  A   0   A/0  0  0
                   └letra┘  núm  os   └núm┘
                                 dois

     É a `valida()` logo acima, aberta em posições — o que muda é QUANDO ela
     roda: antes valia só com os 7 caracteres na mão, agora vale a cada tecla.

     🟢 E É POR ISSO QUE NÃO EXISTE "escolher o tipo de placa": a QUINTA
     posição decide sozinha. Número ali → placa antiga (ABC1234). Letra ali →
     Mercosul (ABC1D23). O cliente não escolhe nada, e não pode escolher
     errado.

     🔴 O QUE ISTO EVITA, e é dinheiro: placa torta chegava no `buscarPlaca()`,
     que devolvia "Placa inválida" DEPOIS de a pessoa digitar as sete. Agora o
     caractere errado nem entra. Consulta paga só sai com placa que existe.

     ⚠️ NUNCA TROCAR O POR 0, I POR 1, B POR 8 OU S POR 5. Parece esperto e é
     perigoso: quem digita a placa está olhando pro carro, e "corrigir" o que
     ele viu é inventar uma placa que pode ser de outra pessoa. A regra é
     BLOQUEAR e DIZER o porquê — nunca adivinhar.

     ⚠️ NUNCA APAGAR UM CARACTERE INVÁLIDO DO MEIO E JUNTAR O RESTO. Se alguém
     colar "AB1C1D23", apagar o "1" do meio daria "ABC1D23" — uma placa VÁLIDA
     que a pessoa não digitou, e que consultaria o carro de outro. Colagem
     torta é rejeitada INTEIRA, o valor anterior fica e o aviso explica.

     ⚠️ E O TECLADO DO CELULAR CONTINUA O NATIVO. Nada de `inputmode` fixo: o
     campo alterna letra e número, então um teclado só numérico prenderia a
     pessoa na posição 4. (Já teve um mini-teclado próprio aqui e ele saiu.)

     📌 UMA FUNÇÃO PRA TODOS OS CAMPOS. A `placaLigar()` é a única fonte da
     verdade — consulta, confirmação da foto, avaliação, funil, pós-venda e
     troca. Regex copiada em cada tela é o jeito garantido de ter seis regras
     diferentes daqui a seis meses.
     ========================================================================== */
  var PLACA_POS=[/[A-Z]/,/[A-Z]/,/[A-Z]/,/[0-9]/,/[A-Z0-9]/,/[0-9]/,/[0-9]/];
  var _PLC_LETRAS='Os três primeiros caracteres devem ser letras.';
  var _PLC_NUMS='Os dois últimos caracteres devem ser números.';
  var PLACA_AVISO=[_PLC_LETRAS,_PLC_LETRAS,_PLC_LETRAS,
                   'O quarto caractere deve ser um número.',
                   '',                     /* a 5ª aceita os dois: nunca avisa */
                   _PLC_NUMS,_PLC_NUMS];
  function placaAviso(i){
    if(i>=7) return 'A placa tem 7 caracteres.';
    /* ⚠️ `PLACA_AVISO[i] || fallback` estava ERRADO e o teste pegou: a 5ª
       posição tem aviso VAZIO de propósito (ela aceita letra e número, nunca
       reclama), e string vazia é falsa em JavaScript — então ela caía no
       texto genérico e o app avisava de um erro que não existia. Aqui a
       pergunta certa é se o índice existe na lista, não se o texto é "vazio". */
    if(i>=0 && i<PLACA_AVISO.length) return PLACA_AVISO[i];
    return 'Confira a placa: use ABC1234 ou ABC1D23.';
  }
  function placaCabe(ch,i){ return i>=0 && i<7 && PLACA_POS[i].test(String(ch||'')); }
  /* Maiúscula e fora SÓ os separadores esperados (espaço, hífen, ponto).
     ⚠️ Repare no que ela NÃO faz: não apaga letra nem número fora do lugar.
     Quem julga isso é a `placaPrefixoErro`, que sabe a posição. A `limpa()`
     lá de cima varre tudo o que não é A-Z0-9 e continua servindo pro que vem
     PRONTO (histórico, servidor, leitura da foto) — aqui o assunto é o que a
     pessoa está digitando agora, e aí cada caractere importa. */
  function placaNormalizar(v){
    return String(v==null?'':v).toUpperCase().replace(/[\s\-‐-―.·]/g,'');
  }
  /* v1414 — a moldura acompanha a placa digitada. Quando a quinta posição
     já é número, o campo é uma placa antiga; quando é letra, é Mercosul. */
  function placaCampoVisualSync(input){
    if(!input) return;
    var wrap=null; try{ wrap=input.closest('.placa-wrap'); }catch(_){}
    if(!wrap) return;
    /* O exemplo animado tambem precisa obedecer ao desenho correto: ABC1D23
       e Mercosul; ABC1234 e placa antiga. O valor digitado sempre prevalece. */
    var v=placaNormalizar(input.value||input.placeholder);
    var antiga=/^[A-Z]{3}[0-9]{2,4}$/.test(v);
    wrap.classList.toggle('is-antiga',antiga);
  }
  /* Devolve o ÍNDICE do primeiro caractere fora do lugar (0 a 6), 7 se passou
     do tamanho, ou -1 se está tudo certo ATÉ AQUI — inclusive com o campo pela
     metade. É esta função que faz a trava valer a cada tecla, e não só no fim. */
  function placaPrefixoErro(v){
    v=String(v||'');
    if(v.length>7) return 7;
    for(var i=0;i<v.length;i++){ if(!placaCabe(v.charAt(i),i)) return i; }
    return -1;
  }
  function placaPrefixoOk(v){ return placaPrefixoErro(v)===-1; }
  /* a caixinha de aviso embaixo do campo (nasce junto com ele, uma vez só) */
  function _placaAvisoEl(input,dado){
    var el=null;
    if(dado) el=(typeof dado==='string')?document.getElementById(dado):dado;
    if(el) return el;
    var id=(input.id||'plc')+'Aviso';
    el=document.getElementById(id);
    if(el) return el;
    el=document.createElement('div'); el.id=id;
    el.className='plc-aviso'; el.setAttribute('aria-live','polite');
    /* ⚠️ ESTILO INLINE DE PROPÓSITO, e não no styles.css: o `flex:0 0 100%` é
       o que faz o aviso PULAR PRA LINHA DE BAIXO quando o campo mora numa
       linha flex (é o caso do pós-venda e do funil). Sem isso ele espremeria
       o campo da placa. Num pai normal o flex é ignorado e ele vira um
       parágrafo comum — os dois casos certos com uma declaração só. */
    el.style.cssText='flex:0 0 100%;width:100%;margin-top:5px;font-size:12.5px;'+
      'font-weight:700;line-height:1.35;color:#b91c1c';
    try{ input.parentNode.insertBefore(el,input.nextSibling); }catch(_){ return null; }
    return el;
  }
  /* ==========================================================================
     placaLigar(input, opcoes) — liga a trava num campo.
       opcoes.erro   : elemento (ou id) onde escrever o aviso. Sem isso, ela
                       cria um embaixo do campo.
       opcoes.pronto : function(valido, valor) — chamada a cada mudança. É por
                       aqui que a janela da foto habilita o "Buscar esta placa".
     ⚠️ IDEMPOTENTE: chamar duas vezes no mesmo campo não duplica ouvinte. Isso
     importa porque as telas do CRM repintam o HTML e chamam de novo.
     ========================================================================== */
  function placaLigar(input,opcoes){
    if(!input||input.__plcTrava) return input;
    input.__plcTrava=true;
    opcoes=opcoes||{};
    var cxAviso=_placaAvisoEl(input,opcoes.erro);
    var bom=placaNormalizar(input.value);
    if(!placaPrefixoOk(bom)) bom='';
    try{
      input.setAttribute('autocomplete','off');
      input.setAttribute('autocapitalize','characters');
      input.setAttribute('inputmode','text');
      input.setAttribute('enterkeyhint','search');
      input.setAttribute('spellcheck','false');
      input.setAttribute('maxlength','7');
      if(cxAviso&&cxAviso.id) input.setAttribute('aria-describedby',cxAviso.id);
    }catch(_){}
    function avisar(txt){
      if(cxAviso) cxAviso.textContent=txt||'';
      try{ if(txt) input.setAttribute('aria-invalid','true'); else input.removeAttribute('aria-invalid'); }catch(_){}
    }
    function ok(){ avisar(''); }
    function contar(){
      var v=String(input.value||'');
      bom=v;
      placaCampoVisualSync(input);
      if(typeof opcoes.pronto==='function'){ try{ opcoes.pronto(valida(v),v); }catch(_){} }
    }
    function escrever(v,caret){
      input.value=v;
      try{ input.setSelectionRange(caret,caret); }catch(_){}
      contar();
      /* dispara 'input' pra quem já escuta o campo continuar funcionando —
         é o que mantém de pé a busca automática da v159 e os autosaves */
      try{ input.dispatchEvent(new Event('input',{bubbles:true})); }
      catch(_){ try{ var ev=document.createEvent('Event'); ev.initEvent('input',true,true); input.dispatchEvent(ev); }catch(__){} }
    }
    function pedaco(){
      var a=input.selectionStart, b=input.selectionEnd, v=String(input.value||'');
      if(a==null) a=v.length; if(b==null) b=a;
      return {a:a,b:b,v:v};
    }
    /* ---- 1) beforeinput: impede o caractere ANTES de ele entrar ---- */
    input.addEventListener('beforeinput',function(e){
      var t=e.inputType||'';
      if(/^delete/.test(t)) return;                    /* apagar sempre pode */
      if(t==='insertFromPaste'||t==='insertFromDrop') return;   /* o 'paste' cuida */
      if(t!=='insertText'&&t!=='insertReplacementText'&&t!=='insertLineBreak') return;
      /* tomo a inserção pra mim: assim um hífen digitado some em vez de entrar,
         e o cursor para exatamente onde tem que parar */
      e.preventDefault();
      if(t==='insertLineBreak') return;
      var novo=placaNormalizar(e.data==null?'':e.data);
      if(!novo) return;                                 /* era só separador */
      var p=pedaco();
      var futuro=p.v.slice(0,p.a)+novo+p.v.slice(p.b);
      var i=placaPrefixoErro(futuro);
      if(i>=0){ avisar(placaAviso(i)); return; }
      ok(); escrever(futuro,p.a+novo.length);
    });
    /* ---- 2) colagem e arrastar: tudo ou nada ---- */
    function colar(e,texto){
      e.preventDefault();
      var novo=placaNormalizar(texto);
      var p=pedaco();
      var futuro=p.v.slice(0,p.a)+novo+p.v.slice(p.b);
      if(placaPrefixoErro(futuro)>=0){
        /* ⚠️ REJEITA INTEIRA. Aproveitar "a parte boa" seria montar uma placa
           que ninguém digitou — e ela pode ser o carro de outra pessoa. */
        avisar('Confira a placa: use ABC1234 ou ABC1D23.');
        return;
      }
      ok(); escrever(futuro,p.a+novo.length);
    }
    input.addEventListener('paste',function(e){
      var t=''; try{ t=(e.clipboardData||window.clipboardData).getData('text'); }catch(_){}
      colar(e,t);
    });
    input.addEventListener('drop',function(e){
      var t=''; try{ t=e.dataTransfer.getData('text'); }catch(_){}
      colar(e,t);
    });
    /* ---- 3) a defesa: navegador sem beforeinput, autopreenchimento, e todo
         caminho que eu não previ. Se o valor ficou torto, ele VOLTA pro último
         que estava certo — nunca "conserta" apagando do meio. ---- */
    input.addEventListener('input',function(){
      var v=placaNormalizar(input.value);
      var i=placaPrefixoErro(v);
      /* 🔴🔴 A TRAVA IMPEDE QUE CARACTERE ENTRE — NUNCA IMPEDE QUE SAIA.
         Achei isto testando de verdade no navegador, e teria passado batido
         numa leitura: apagar o "A" de "ABC1D2" deixa "BC1D2", e nessa hora o
         "1" está na 3ª posição, que é de letra. Ou seja: TODO valor no meio de
         uma edição pode ser inválido. A defesa abaixo desfazia isso e o campo
         ficava preso — a pessoa apertava Backspace no meio da placa e nada
         acontecia. Pior que o bug original.
         A regra certa: se o valor ENCOLHEU, ele passa, mesmo torto. O aviso
         aparece (ela precisa saber o que falta), mas o texto é dela. Só o que
         CRESCE é que precisa caber na posição. */
      var encolheu = v.length < bom.length;
      if(i>=0 && !encolheu){
        input.value=bom;
        placaCampoVisualSync(input);
        try{ input.setSelectionRange(bom.length,bom.length); }catch(_){}
        avisar(placaAviso(i));
        if(typeof opcoes.pronto==='function'){ try{ opcoes.pronto(valida(bom),bom); }catch(_){} }
        return;
      }
      if(v!==input.value) input.value=v;
      bom=v;
      placaCampoVisualSync(input);
      avisar(i>=0?placaAviso(i):'');
      if(typeof opcoes.pronto==='function'){ try{ opcoes.pronto(valida(v),v); }catch(_){} }
    });
    /* ⚠️ RE-SINCRONIZA AO FOCAR. Vários lugares do app escrevem no campo com
       `el.value=` direto (o autocompletar da troca, o histórico, a leitura da
       foto) — e `.value=` NÃO dispara 'input'. Sem isto, o "último valor bom"
       que a defesa usa pra desfazer ficaria velho, e um desfazer devolveria
       uma placa que já não estava mais na tela. */
    input.addEventListener('focus',function(){
      var v=placaNormalizar(input.value);
      if(placaPrefixoOk(v)){ if(v!==input.value) input.value=v; bom=v; }
      placaCampoVisualSync(input);
      /* e reavisa quem escuta: o botão "Buscar esta placa" tem que refletir o
         que ESTÁ no campo agora, não o que estava quando a trava foi ligada */
      if(typeof opcoes.pronto==='function'){ try{ opcoes.pronto(valida(String(input.value||'')),String(input.value||'')); }catch(_){} }
    });
    input.addEventListener('blur',function(){
      var v=String(input.value||'');
      if(v&&!valida(v)) avisar(v.length<7?'Digite os 7 caracteres da placa.':'Confira a placa: use ABC1234 ou ABC1D23.');
    });
    placaCampoVisualSync(input);
    if(typeof opcoes.pronto==='function'){ try{ opcoes.pronto(valida(bom),bom); }catch(_){} }
    return input;
  }
  function brl(v){if(v==null||v==='')return '—';try{return 'R$ '+Number(v).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});}catch(_){return 'R$ '+v;}}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function chassiMask(c){c=String(c||'');return c.length<10?c:c.slice(0,8)+'***'+c.slice(-3);}
  /* =====================================================================
     🔴 v1086 — QUEM DECIDE ENTRE BAIXAR E COMPARTILHAR
     ---------------------------------------------------------------------
     Pedido do Angelo (19/09, com print do visor no Mac): "tem como ao clicar
     em baixar ele já baixar direto nos downloads?"

     O botão diz "Baixar PDF". No computador dele ele NÃO baixava: abria a
     folha de compartilhamento do macOS (AirDrop, Mail, Mensagens…).

     A CONTA ANTIGA ERA `navigator.canShare`, em três lugares iguais:
         if(navigator.canShare) compart(); else baixar();
     O Mac TEM essa API. Então o Mac caía no compartilhar. A pergunta estava
     invertida.

     🔑 A PERGUNTA CERTA NÃO É "SABE COMPARTILHAR?", É "SABE BAIXAR?".
     Quem não sabe baixar é o iPhone/iPad: o Safari de lá trata o atributo
     `download` de um link como um arquivo pra ABRIR, não pra guardar, e o
     PDF some numa aba. Lá a folha nativa é o caminho certo — é ela que leva
     pro app Arquivos, exatamente como a dica escrita na tela promete.

     ⚠️ POR QUE `platform` E `maxTouchPoints`, E NÃO SÓ O userAgent: desde o
     iPadOS 13 o iPad se apresenta como "Macintosh" pra receber o site de
     computador. O que o entrega é o toque: Mac não tem tela de toque, então
     `maxTouchPoints > 1` num "Macintosh" é iPad.

     ⚠️ O QUE ISTO NÃO MUDA: o botão "Compartilhar", que continua chamando a
     folha nativa em todo aparelho que a tiver — inclusive no Mac. Quem quer
     mandar por Mail continua com um botão pra isso, do lado.
     ===================================================================== */
  function podeBaixarArquivo(){
    try{
      var ua=String((navigator && navigator.userAgent)||'');
      var toques=Number((navigator && navigator.maxTouchPoints)||0);
      var eIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && toques>1);
      return !eIOS;
    }catch(_){ return true; }
  }
  /* =====================================================================
     v515 - NOME DE ARQUIVO QUE DISTINGUE SEM ENTREGAR O DOCUMENTO
     ---------------------------------------------------------------------
     O nome de um arquivo aparece onde o CONTEUDO dele nao aparece: na lista
     da pasta aberta no telao, na previa do anexo do WhatsApp, na notificacao
     da tela bloqueada, no backup automatico da nuvem, no nome do anexo do
     e-mail. O PDF a pessoa so le se abrir; o nome ela le SEM abrir. Por isso
     o nome tem regra MAIS DURA que o conteudo.

     O que estava errado ate a v514: o PDF da consulta de CPF salvava como
     'Restricoes-42941383.pdf' - os 8 PRIMEIROS digitos de 11. Os dois
     ultimos do CPF sao verificadores, calculados a partir dos nove
     primeiros, com formula publica. Sobrava UM digito pra adivinhar: dez
     tentativas e o CPF estava reconstruido. E o PDF do provedor era pior -
     saia com os 11 digitos inteiros.

     REGRA DA CASA, daqui pra frente: documento (CPF, CNPJ, RG, chassi,
     RENAVAM) NUNCA entra em nome de arquivo. PLACA pode - e publica, e e
     como o carro e chamado.

     O que basta pra distinguir um arquivo do outro e DE QUEM E e DE QUANDO
     E. Entao: prefixo + 1o nome + ultimo sobrenome + DD-MM-AAAA + HHMM.
     Sem nome na base, sobra data e hora - que ja distinguem. NUNCA cair de
     volta no documento.

     A HORA e o desempate, e nao e enfeite: duas consultas do mesmo cliente
     no mesmo dia deixam de virar "(2)" e "(3)" do navegador, que foi a
     reclamacao que abriu este assunto.

     O nome sai SEM ACENTO de proposito: nome com acento quebra em Windows e
     em anexo de e-mail. E cada pedaco do nome e cortado em 14 letras, pra
     nao estourar o limite de nome de arquivo em sobrenome comprido.

     TRAVA: o replace(/\d/g,'') no nome da pessoa nao e limpeza, e trava - se
     algum dia alguem passar o CPF neste parametro por engano, ele SOME em
     vez de virar nome de arquivo. Nome de gente nao tem numero.
     ===================================================================== */
  var _NA_PART = /^(de|da|do|das|dos|e|di|del|della|van|von|jr|junior|filho|neto|sobrinho|segundo|terceiro)$/;
  function _naLimpa(s){
    try{ s = String(s==null?'':s).normalize('NFD').replace(/[̀-ͯ]/g,''); }
    catch(_){ s = String(s==null?'':s); }
    return s.replace(/\d/g,'').replace(/[^A-Za-z ]+/g,' ').replace(/\s+/g,' ').trim();
  }
  function nomeArquivoSeguro(prefixo, nomePessoa, ts, sufixo){
    var d; try{ d = new Date(ts||Date.now()); if(isNaN(d.getTime())) d = new Date(); }catch(_){ d = new Date(); }
    function _2(n){ return (n<10?'0':'')+n; }
    var data = _2(d.getDate())+'-'+_2(d.getMonth()+1)+'-'+d.getFullYear();
    var hora = _2(d.getHours())+_2(d.getMinutes());
    var toks = _naLimpa(nomePessoa).toUpperCase().split(' ').filter(function(p){
      return p && !_NA_PART.test(p.toLowerCase());
    });
    var quem = [];
    if(toks.length) quem.push(toks[0].slice(0,14));
    if(toks.length > 1 && toks[toks.length-1] !== toks[0]) quem.push(toks[toks.length-1].slice(0,14));
    return [String(prefixo||'Arquivo').replace(/[^A-Za-z0-9]+/g,'')]
      .concat(quem).concat([data, hora])
      .concat(sufixo ? [String(sufixo).replace(/[^A-Za-z0-9]+/g,'')] : [])
      .filter(Boolean).join('-');
  }
  /* =====================================================================
     v163 - SESSAO EXPIRADA: o app se resolve sozinho.
     Antes, quando o login vencia, o servidor devolvia 401 e a tela mostrava
     a tarja vermelha "Sessao invalida. Entre de novo." - e ficava ali,
     parada, com o app aberto e nada funcionando. Voce tinha que descobrir
     sozinho que precisava sair e entrar de novo.
     Agora, na PRIMEIRA resposta 401:
       1) o app tenta RENOVAR a sessao em silencio (o Supabase guarda um
          "refresh token" justamente pra isso) e REFAZ a chamada. Na maioria
          das vezes voce nem percebe que aconteceu;
       2) se nao der pra renovar, ele encerra a sessao e ABRE A TELA DE LOGIN
          automaticamente, ja com o aviso do motivo escrito nela.
     Como TODAS as chamadas ao servidor passam por aqui, isso vale pra tela
     toda de uma vez - nao precisou mexer em cada botao.
     ===================================================================== */
  var _sessRenovando=null, _sessCaiu=false;
  function _ehSessaoMorta(status, d){
    if(status===401) return true;
    return /sess[\u00e3a]o\s+inv[\u00e1a]lida|fa[\u00e7c]a\s+login|n[\u00e3a]o\s+autorizado/i.test(String((d&&d.erro)||''));
  }
  function _sessRenovar(){
    /* uma renovacao so, mesmo que 3 chamadas falhem juntas */
    if(_sessRenovando) return _sessRenovando;
    _sessRenovando=(async function(){
      try{
        var r=await withTimeout(supa.auth.refreshSession(), 8000);
        var sess=r&&r.data&&r.data.session;
        if(sess&&sess.access_token){ token=sess.access_token; return true; }
      }catch(_){}
      return false;
    })();
    _sessRenovando['finally'] ? _sessRenovando['finally'](function(){ setTimeout(function(){ _sessRenovando=null; },1500); })
                              : _sessRenovando.then(function(){ _sessRenovando=null; },function(){ _sessRenovando=null; });
    return _sessRenovando;
  }
  function _sessDerrubar(){
    if(_sessCaiu) return; _sessCaiu=true;
    try{ _hardLogout(); }catch(_){}
    try{ show('scAuth'); }catch(_){}
    try{ window.scrollTo(0,0); }catch(_){}
    try{ var m=$('authMsg'); if(m){ m.className='msg err'; m.textContent='Sua sess\u00e3o expirou. Entre de novo pra continuar.'; } }catch(_){}
    try{ toast('Sess\u00e3o expirada \u2014 entre de novo.'); }catch(_){}
  }
  /* motor unico de chamada ao servidor (usado pelas 3 funcoes abaixo) */
  async function _apiFetch(p,b,ms,jaTentou){
    b=b||{}; b.token=token;
    var ac=ms?new AbortController():null, tm=null;
    if(ac) tm=setTimeout(function(){ ac.abort(); }, ms);
    var r,d;
    try{
      var op={method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)};
      if(ac) op.signal=ac.signal;
      r=await fetch(p,op);
      try{ d=await r.json(); }
      catch(_){ d={ ok:false, erro:'Resposta inv\u00e1lida do servidor (HTTP '+r.status+').' }; }
    }
    /* v167: se a internet cair no meio (ou o servidor nao responder), o fetch
       ESTOURA. Antes esse estouro subia pra quem chamou e podia deixar o app
       travado no meio da operacao. Agora vira uma resposta normal de erro:
       quem chamou trata do mesmo jeito que trata qualquer outra falha. */
    catch(_){ d={ ok:false, erro:'Falha de conex\u00e3o. Confira a internet e tente de novo.', rede:true }; }
    finally { if(tm) clearTimeout(tm); }
    if(token && r && _ehSessaoMorta(r.status, d)){
      /* 1a falha: tenta renovar e refaz. 2a falha seguida: nao tem jeito. */
      if(!jaTentou && await _sessRenovar()) return await _apiFetch(p,b,ms,true);
      _sessDerrubar();
    }
    return d;
  }
  async function api(p,b){ return await _apiFetch(p,b,0,false); }
  /* igual ao api(), mas com tempo-limite por tentativa (aborta a chamada travada) */
  async function apiComTimeout(p,b,ms){ return await _apiFetch(p,b,ms||12000,false); }
  /* chamada com TIMEOUT \u2014 nunca deixa o boot preso esperando a rede pra sempre */
  async function apiTimeout(p,b,ms){ return await _apiFetch(p,b,ms||12000,false); }
  /* envia a placa pro histórico do Cotação VW (ligado pelo e-mail) — silencioso */
  /* ===== v272 — MANDA A PLACA PRO COTAÇÃO VW =====
     Isto alimenta a tela de placas do outro app. Ficou QUEBRADO desde sempre e
     ninguém viu, porque a resposta era jogada fora sem olhar: o servidor
     respondia "sessão inválida" (estava conferindo o login no projeto errado)
     e o app seguia como se tivesse dado certo.
     Agora, quando não dá certo, o motivo fica registrado no mp_erros — UMA vez
     por sessão, pra não virar enxurrada. Continua sem atrapalhar o usuário:
     esta é uma tarefa de bastidor, não pode travar a consulta dele. */
  /* ===== v276 — O SYNC ACABOU, E ISSO É UMA BOA NOTÍCIA =====
     De manhã eu consertei esta ponte (endereço 404 + projeto errado). À tarde
     ela deixou de ser necessária: o mp_historico_consulta virou uma PONTE pra
     placa_consultas, que é a tabela de placas do MEVTOOLS. Os dois apps passaram
     a ler e escrever A MESMA LINHA.

     Não existe mais "mandar a placa pro outro app": ela já nasce lá. Quem grava
     é o histSalvar() logo acima, que roda em toda consulta e chama o
     /api/historico. Um caminho só, em vez de dois fazendo a mesma coisa.

     Deixo a função existindo e vazia de propósito: ela é chamada em dois
     lugares (na consulta e ao reabrir do histórico) e apagá-la agora só criaria
     chance de erro sem ganhar nada. Ela não faz mais nenhuma chamada de rede —
     são duas viagens a menos por consulta.

     Cópia de segurança de tudo: esquema bkp_20260803 no Supabase. */
  function syncCotacao(){ /* aposentado na v276 — ver o texto acima */ }
  /* =========================================================================
     v265 — LIMPEZA DE VALORES DO TEXTO QUE VAI PRO PÚBLICO

     Custo de reparo é interno da loja. Se o lojista parceiro (ou o cliente)
     enxerga quanto a loja vai gastar pra pôr o carro em ordem, ele sabe o piso
     da negociação. Por isso todo texto LIVRE que sai daqui passa por esta
     função antes.

     Ela morava dentro do avLojPayload() e só a página da avaliação usava —
     o Portal do Repasse mandava o texto CRU pra rede inteira. Subiu pra cá
     justamente pra ser um caminho só, obrigatório, pros dois.

     A versão antiga só reconhecia "R$ 1.234,56". Tudo que a pessoa escreve
     de verdade escapava: "3000", "3 mil", "custou 2500 reais", "1.200,00".
     Agora a regra é ao contrário — na dúvida, apaga o número:
       · qualquer coisa precedida de R$ / RS / R $;
       · número com separador de milhar (2.500 · 12.500,00);
       · qualquer número de 3 dígitos ou mais;
       · "3 mil" e "2500 reais".
     A QUILOMETRAGEM é protegida antes e devolvida depois: "revisão aos
     60.000 km" continua fazendo sentido, e km não é segredo (tem campo
     próprio, que já vai pro lojista).
     ========================================================================= */
  /* ===== 🔴 v1057 — A NOTA DO AVALIEX NÃO SAI DAQUI ======================
     Pedido do Angelo: "essas observações que vem do avaliex não devem ir pra
     página do lojista". Ele viu na tela:
         "Avaliex: Mecânica 5/5 · Pintura 2/5 · Interior 5/5 · Pneus 3/5"

     De onde vem: o importador do laudo (05i) acrescenta essa linha no campo
     de observações, marcada com "Avaliex:" — o marcador existe pra não
     duplicar num segundo import, e agora serve também pra reconhecê-la aqui.

     🔴 POR QUE O CONSERTO É AQUI, E NÃO NO IMPORTADOR: essa nota é Útil pro
     Angelo, na tela dele — é a leitura do avaliador. O que não pode é SAIR.
     Tirar do importador apagaria o dado; tirar aqui guarda o dado e fecha a
     porta. E esta função é a porta: todo texto livre que vai pro lojista,
     pro Portal do Repasse ou pro anúncio passa por ela.
     ⚠️ Ou seja, isso vale PRA TODA SAÍDA, não só pra página do lojista — e é
     de propósito: "Pintura 2/5" num anúncio de venda seria pior ainda.
     ========================================================================= */
  function _semNotaAvaliex(txt){
    return String(txt||'')
      .split('\n')
      .filter(function(l){ return !/^\s*Avaliex\s*:/i.test(l); })
      .join('\n');
  }
  function obsPublica(txt){
    var s=_semNotaAvaliex(txt), guarda=[];
    function proteger(re){ s=s.replace(re, function(m){ guarda.push(m); return '\u0001'+(guarda.length-1)+'\u0001'; }); }
    /* 1) põe a salvo o que NÃO é dinheiro e não pode sumir: quilometragem
          (tem campo próprio, o lojista já vê) e anos. */
    proteger(/\b\d[\d.\s]*\s*(?:km|quil[oô]metros?)\b/gi);
    proteger(/\b(?:19|20)\d{2}(?:\s*\/\s*(?:19|20)?\d{2})?\b/g);
    /* 2) apaga dinheiro em qualquer forma que a pessoa escreva.
          A ORDEM IMPORTA: "2500 reais" tem que sair antes da regra dos números
          soltos, senão sobra a palavra "reais" órfã na tela do lojista. */
    s=s
      .replace(/\b\d+(?:[.,]\d+)?\s*mil\b/gi,' ')
      .replace(/\b\d[\d.,]*\s*reais\b/gi,' ')
      .replace(/\(?\s*[\u2212\u2013\u2014-]?\s*R\s*[S$]\s*\d[\d.,]*\s*\)?/gi,' ')
      .replace(/\(?\s*[\u2212\u2013\u2014-]?\s*\d{1,3}(?:[.\s]\d{3})+(?:,\d{1,2})?\s*\)?/g,' ')
      .replace(/\(?\s*[\u2212\u2013\u2014-]?\s*\d{3,}(?:,\d{1,2})?\s*\)?/g,' ')
      .replace(/\bR\s*[S$]\s*/gi,' ');            /* "R$" que sobrou sozinho */
    /* 3) devolve o que estava protegido */
    s=s.replace(/\u0001(\d+)\u0001/g, function(_,i){ return guarda[Number(i)]||''; });
    /* 4) arruma o que ficou solto: espaço dobrado, pontuação órfã e a
          preposição pendurada no fim ("orçamento de" -> "orçamento") */
    return s
      .replace(/[ \t]{2,}/g,' ')
      .replace(/[ \t]+([,.;:])/g,'$1')
      .replace(/([(:])\s*([,.;])/g,'$1')
      .replace(/\(\s*\)/g,'').replace(/[ \t]*\+[ \t]*(?=[.,;\n]|$)/gm,'')
      .replace(/\s+(?:de|por|em|custa|custou|ficou|sai|d[eo]s?)(?=[ \t]*(?:[.,;+\n]|$))/gim,'')
      .replace(/[:\-\u2013](?=[ \t]*(?:[.,;\n]|$))/gm,'')
      .replace(/[ \t]+\n/g,'\n').replace(/\n{3,}/g,'\n\n').trim();
  }
  /* texto de uma opção de lista SEM o custo entre parênteses no fim.
     "Não tem (+R$ 1.000)" -> "Não tem" · v265: usado também fora da avaliação */
  function semCustoNoRotulo(t){ return String(t||'').replace(/\s*\([^()]*\)\s*$/,'').trim(); }

  /* ===== v263 — O SALDO VIROU O BOTÃO DE RECARGA (pedido) =====
     Em vez de mais um FAB na barra de baixo (que já tem voltar, câmera, +, ✓ e
     menu), a recarga passou a morar onde a pessoa JÁ olha quando pensa em
     token: o próprio saldo. Tocar nele abre os pacotes. Quando o saldo fica
     baixo o número fica laranja, e zerado fica vermelho — o aviso aparece
     sozinho, sem ocupar espaço novo na tela. */
  var SALDO_BAIXO = 5;   /* daqui pra baixo o chip muda de cor */
  function _saldoPinta(){
    var txt = ilimitado ? '∞' : precoReal(saldo);
    var nivel = ilimitado ? '' : (saldo<=0 ? 'zero' : (saldo<SALDO_BAIXO ? 'baixo' : ''));
    Array.prototype.forEach.call(document.querySelectorAll('#saldoN, .saldo-chip .sc-n'), function(e){ e.textContent=txt; });
    Array.prototype.forEach.call(document.querySelectorAll('.saldo-chip'), function(c){
      c.classList.toggle('sc-baixo', nivel==='baixo');
      c.classList.toggle('sc-zero',  nivel==='zero');
      c.title = ilimitado ? 'Consultas ilimitadas' : (nivel==='zero' ? 'Sem saldo — tocar para adicionar' : 'Adicionar saldo');
    });
  }
  function setSaldo(n){ saldo=Number(n)||0; _saldoPinta(); }
  window.MEV_SALDO_ATUALIZA=function(n){ setSaldo(n); };
  /* v265: ESTA FUNÇÃO NÃO PODE SE CHAMAR avisoSaldoBaixo.
     Como os 22 arquivos viram um bloco só, um nome declarado duas vezes faz a
     ÚLTIMA declaração valer pro programa inteiro. Já existe uma
     avisoSaldoBaixo() no 09-portal-repasse.js (a faixa amarela "seus créditos
     estão acabando") e, como o 09 é colado depois do 01, era a dele que rodava
     sempre — a minha, criada na v263, era código morto. Com nome próprio, as
     duas convivem e cada uma faz a sua parte. */
  function saldoChipRepinta(){ _saldoPinta(); }
  /* qualquer chip de saldo, esteja onde estiver, abre os pacotes ao ser tocado */
  document.addEventListener('click', function(e){
    var c=e.target&&e.target.closest&&e.target.closest('.saldo-chip'); if(!c) return;
    e.preventDefault();
    if(ilimitado){ try{ toast('Sua loja está com consultas ilimitadas.'); }catch(_){} return; }
    try{ if(typeof drawerFechar==='function') drawerFechar(false); }catch(_){}
    try{ abrirPacotes(); }catch(_){}
  });

  /* ---------- INÍCIO ---------- */
  /* v589 — AS MIGALHAS DA ABERTURA. O caso do celular que "roda pra sempre"
     furou tudo: página nova confirmada (v588 na tela), zero erro de JS,
     app.js executado até o fim — e o splash preso. Ou seja: trava DENTRO da
     abertura, engolida por algum try/catch mudo. Cada passo agora deixa a
     migalha em window.__mevPasso, e erro engolido vira linha em
     window.__mevErros — o vigia do app.html manda tudo no diagnóstico. */
  /* v735 — FASE 5.0 DA VELOCIDADE: O RELÓGIO AO LADO DE CADA PASSO
     (docs/PROJETO-2026-08-29-velocidade-fase5-nucleo-e-resto.txt, §3)
     A abertura tem três esperas — executar o app.js, a sessão (Supabase) e o
     aceite legal (função Netlify, fria depois de publicar) — e ninguém sabia
     qual delas segura o splash. Agora cada _passo guarda o instante em
     window.__mevTempos (o __mevPasso continua igual: o vigia do splash lê).
     Ao chegar em 'aberto', uma linha resume tudo:
        html→js 412ms · sessão 380ms · aceite 2.140ms · abriu em 3.010ms
     vai pro console, pro localStorage (mev_perf_ultimo) e — se a URL tiver
     ?perf=1 — pra um toast de 6 s, pro Angelo ler no celular sem cabo.
     Nada vai pro servidor. É só medição; nenhum passo mudou de lugar. */
  function _passo(p){
    try{ window.__mevPasso=p; }catch(_){}
    try{
      var T=window.__mevTempos=window.__mevTempos||{}; T[p]=(window.performance&&performance.now)?Math.round(performance.now()):0;
      if(p==='aberto') _perfResumo();
    }catch(_){}
  }
  function _perfResumo(){
    var T=window.__mevTempos||{}, t0=window.__mevT0||0;
    /* a sessão é pedida DURANTE a execução do app.js (o init do 01 roda antes dos
       outros 71 módulos) e só é respondida depois que o arquivo inteiro rodou —
       então o tempo dela conta a partir do FIM do js, senão a execução dos
       módulos entraria na conta da rede */
    var jsFim=T['js-executado']||T.init||0;
    var js=jsFim-t0, ses=(T.entrar||0)-Math.max(T.sessao||0, jsFim), ace=(T.abrindo||0)-(T.aceite||0), tot=(T.aberto||0)-t0;
    var f=function(n){ return (n>=0?n:0).toLocaleString('pt-BR')+'ms'; };
    var linha='html→js '+f(js)+' · sessão '+f(ses)+' · aceite '+f(ace)+' · abriu em '+f(tot)+(T['sessao-local']?' (sessão local)':(T['sessao-local-vencida']?' (sessão local, token renovando)':''))+(T['aceite-local']?' (aceite lembrado)':'');   /* v743 */
    try{ console.log('⏱ abertura: '+linha); }catch(_){}
    try{ localStorage.setItem('mev_perf_ultimo', JSON.stringify({ quando:new Date().toISOString(), build:(typeof MEV_BUILD!=='undefined'?MEV_BUILD:''), linha:linha, tempos:T, t0:Math.round(t0) })); }catch(_){}
    try{ if(/[?&]perf=1/.test(location.search)){ var t=$('mevToast'); if(!t){ t=document.createElement('div'); t.id='mevToast'; t.className='mev-toast'; document.body.appendChild(t); } t.textContent='⏱ '+linha; t.classList.add('on'); clearTimeout(toast._t); toast._t=setTimeout(function(){ t.classList.remove('on'); },6000); } }catch(_){}
    window.__mevPerf=linha;
  }
  /* v738: a sessão que a biblioteca do Supabase guarda no aparelho
     (chave sb-<projeto>-auth-token). Só serve se tiver token, usuário e
     validade com pelo menos 60 s de folga — senão devolve null e o init
     segue pelo caminho de sempre (getSession, que renova). */
  var _SESS_KEY='sb-'+String(URL_SUPA).replace(/^https?:\/\//,'').split('.')[0]+'-auth-token';
  function _sessaoGuardada(){
    try{
      var raw=localStorage.getItem(_SESS_KEY); if(!raw) return null;
      var o=JSON.parse(raw); if(o && o.currentSession) o=o.currentSession;
      if(!o || !o.access_token || !o.user || !o.user.id) return null;
      /* v740: token VENCIDO também serve pra ENTRAR — a home não precisa dele
         (o histórico é local) e a primeira chamada ao servidor se resolve: 401
         → renova e refaz (v163). Medido no banco em 29/08: cada abertura lenta
         (4,7–11 s) era exatamente uma renovação de token, e o projeto renova a
         cada ~3 min — então a folga de 60 s da v738 quase nunca existia. O que
         continua barrando: sem token, sem usuário, ou sessão que o getSession
         disser que não existe mais (cai pro login em 2º plano). Só se o token
         venceu há mais de 7 dias a gente nem tenta (o refresh_token do
         Supabase também tem prazo; melhor ir direto pelo caminho antigo). */
      var exp=Number(o.expires_at||0)*1000; if(!exp || Date.now()-exp>7*24*3600*1000) return null;
      o._vencido=(exp-Date.now()<60000);
      return o;
    }catch(_){ return null; }
  }
  function _aplicaSessao(sess){
    token=sess.access_token; meuId=(sess.user&&sess.user.id)||null; meuEmail=(sess.user&&sess.user.email)||null;
    meuMeta=(sess.user&&sess.user.user_metadata)||{}; meuNome=meuMeta.nome||''; meuFoto=meuMeta.foto||'';
  }
  (async function init(){
    try{
      _passo('init');
      /* Veio do link de reset de senha? Abre a tela de nova senha e para por aqui. */
      if(_recoveryFlag){ try{ abrirRecovery(); return; }catch(_){} }
      _passo('sessao');
      /* 🔴 v738 — FASE 5.1 DA VELOCIDADE: A HOME NÃO ESPERA O getSession()
         (docs/PROJETO-2026-08-29-velocidade-fase5-nucleo-e-resto.txt, §4)
         Medido com o relógio da v735 no celular do Angelo (5G fraco):
           html→js 1.553ms · sessão 11.036ms · aceite 646ms · abriu 13.236ms
           html→js   187ms · sessão  4.745ms · aceite 833ms · abriu  5.766ms
           html→js   153ms · sessão      1ms · aceite 1.287ms · abriu 1.441ms
         O JavaScript não é o gargalo. O `await supa.auth.getSession()` é —
         às vezes 1 ms, às vezes 11 s (a biblioteca renova/confere o token
         com a rede, com tentativas e espera crescente quando o sinal oscila;
         com muitas abas abertas ficou pior). A sessão que ele vai devolver
         JÁ ESTÁ no aparelho (localStorage, gravada pela própria biblioteca).
         Então: se existe uma sessão guardada e ainda dentro da validade, o
         app ENTRA COM ELA NA HORA e o getSession() roda em 2º plano — se ele
         disser "não vale mais", o app cai pro login; se trouxer token novo,
         troca. Token vencido no aparelho → espera como sempre (precisa
         renovar antes de qualquer consulta). E a rede de segurança da v163
         continua: um 401 em qualquer chamada renova e refaz sozinho.
         Nada de novo é gravado; nenhuma chave muda de lugar. */
      var _local=_sessaoGuardada();
      if(_local){
        _passo(_local._vencido?'sessao-local-vencida':'sessao-local');
        _aplicaSessao(_local);
        supa.auth.getSession().then(function(s){
          var sess=s&&s.data&&s.data.session;
          if(!sess){ _sessDerrubar(); return; }
          if(sess.access_token && sess.access_token!==token) _aplicaSessao(sess);
        }).catch(function(){});
        await entrar();
        return;
      }
      var s=await supa.auth.getSession();
      var sess=s&&s.data&&s.data.session;
      if(!sess){ _passo('login'); show('scAuth'); _passo('login-ok'); return; }
      _aplicaSessao(sess);
      await entrar();
    }catch(e){
      /* v589: o erro engolido aqui era invisível — agora vira migalha (o
         comportamento não muda: segue pro login como sempre) */
      try{ window.__mevErros.push('init: '+String((e&&e.message)||e).slice(0,120)); }catch(_){}
      try{ show('scAuth'); }catch(e2){ try{ window.__mevErros.push('login não abriu: '+String((e2&&e2.message)||e2).slice(0,120)); }catch(_){} }
    }
  })();
  /* trava de segurança: o splash NUNCA fica preso — se em 8s ainda estiver
     carregando, mostra o app (se há sessão) ou a tela de login.
     v589: se a PRÓPRIA válvula estourar (o catch era MUDO — o único jeito de
     o splash ficar preso com o app.js inteiro vivo), o erro vira migalha. */
  setTimeout(function(){ try{ if(_legalGateAtivo) return; var sl=$('scLoad'); if(sl && sl.style.display!=='none'){ _passo('valvula-8s'); show(token?'scApp':'scAuth'); if(token){ mevTabSet('home'); pintaHomeHist(''); } _passo('valvula-ok'); } }catch(e){ try{ window.__mevErros.push('válvula(8s): '+String((e&&e.message)||e).slice(0,120)); }catch(_){} } }, 8000);

  /* Sessão local válida → mostra o app NA HORA. Saldo/pacotes vêm em segundo
     plano (com timeout), pra rede lenta não travar a abertura. */
  async function entrar(){
    _passo('entrar');
    show('scLoad');
    _passo('aceite');
    if(!(await legalGarantirAceite())) return;
    _passo('abrindo');
    show('scApp');
    _passo('aberto');
    try{ cloudFilaEnviar(); }catch(_){}   /* v162 — sobe o que ficou preso da última vez */
    /* v990 — e logo em seguida APAGA o histórico de consulta de CPF que
       tenha sobrado (aparelho, fila e nuvem). É aqui porque é o único
       ponto por onde TODO mundo passa depois de entrar: quem nunca abrir
       a tela de CPF também precisa ficar limpo. Idempotente — rodar de
       novo não faz nada. Ver o comentário grande em restHistLimpar. */
    try{ restHistLimpar(); }catch(_){}
    var _toolsEntrada=typeof mevToolsPaginaAbrir==='function';
    if(_toolsEntrada){mevToolsPaginaAbrir();}else{
      mevTabSet('home');
      pintaHomeHist('');
      try{ fmInlineMontar(); }catch(_){}
    }
    try{ autocorpStatusAtualizar(); }catch(_){}   /* v744: a AutoCorp está liberada pra mim? (2º plano) */
    /* v298 — AS 10 CONSULTAS DE BOAS-VINDAS.
       Chamo em TODA entrada, de propósito: quem cria a conta no celular às
       vezes confirma o e-mail em outro aparelho, e o "instante do cadastro"
       não é um momento confiável pra pendurar o presente. Chamar sempre é
       seguro porque a trava é do BANCO — a carteira tem o user_id como chave
       primária, então a linha ou nasce agora com 10, ou já existe e nada
       acontece. Não dá pra ganhar duas vezes. */
    try{ await boasVindas(); }catch(_){}
    carregarSaldo();
    histSync();
    carregarPapelEquipe();
    _dbAutoReparo();
    perfilCarregarFoto();
    membroCarregar();
    placaDoSite();
    try{ consultaDoSite(); }catch(_){}   /* v798 — ?consulta=&p= do link público: ABRE, não consulta */
    chatDoSite();      /* v532 — o link do e-mail do lead (só com sessão) */
    pagamentoDeVolta();
    /* v497 — cada app abre no que É dele: o MEV Estoque no painel de Estoque/
       Catálogo/Repasse/Minha loja, o MEV Vendas direto em Vendas, o MEV
       Avalia direto em Avaliações. Sem edição (MEV Completo) NADA muda —
       segue a consulta de placa de sempre. Vem por último de propósito:
       os carregamentos acima já partiram. */
    if(!_toolsEntrada){try{ edAbrirInicialDoApp(); }catch(_){}}
  }
  /* pede o presente e, se ganhou agora, avisa — senão o saldo aparece do nada */
  async function boasVindas(){
    try{
      var r=await withTimeout(supa.rpc('boas_vindas'),8000);
      var d=r&&r.data;
      if(d && d.ok && d.ganhou){
        try{ toast('Bem-vindo! Você ganhou 10 consultas para experimentar.'); }catch(_){}
      }
    }catch(_){}
  }
  /* v298 — A PLACA QUE VEIO DO SITE, E A CONSULTA JÁ SAI.
     Em mevveiculos.com.br a pessoa digita a placa e toca em Consultar. O site
     não consulta nada (não tem login nem saldo lá): ele manda pra cá com
     ?placa=ABC1D23, e a consulta acontece AQUI.

     Quem já estava logado não percebe nada: o app abre e o resultado vem.
     Quem não estava cai no login — e como esta função roda dentro do
     entrar(), a consulta sai sozinha assim que ele entra, sem ter que
     lembrar da placa e digitar de novo.

     A PLACA SAI DO ENDEREÇO NA HORA. Sem isso, recarregar a página (ou o
     aplicativo voltar do fundo) repetiria a consulta — e consulta repetida
     é token gasto à toa. Tiro o parâmetro ANTES de consultar, não depois. */
  /* ==========================================================================
     🔴🔴 v881 — LIMPAR A BARRA DE ENDEREÇO SEM DERRUBAR A EDIÇÃO
     --------------------------------------------------------------------------
     ACHADO CONFERINDO O PROJETO DA PLAY, e o projeto de agosto dizia o
     CONTRÁRIO: "conferi os lugares que limpam a barra e todos apagam só o
     parâmetro deles — nenhum varre a URL inteira". Deixou de ser verdade.
     Dois lugares faziam `history.replaceState(null,'',location.pathname)`, que
     joga fora a query INTEIRA:
        · aqui no 01-nucleo, depois de trocar a senha;
        · no 19-documentos-e-init, quando chega `?placa=` do site.

     🔴 POR QUE ISSO É GRAVE E SILENCIOSO: desde a v501 "quem manda é o
     endereço" — o `_lsGet()` do 00-edicoes lê a edição do `location.search` na
     hora de usar, não uma vez só. Perdeu o `?app=consultas`, o app vira o MEV
     Placas COMPLETO na próxima pergunta que alguém fizer. Dentro do app da
     loja isso é o cliente que comprou consultas caindo no estoque e no CRM,
     sem um erro na tela pra ninguém desconfiar. É a armadilha 4 do
     `PROJETO-mev-consultas-na-play-store.txt`, e ela já estava aberta.

     ⚠️ NO ERRO, DEVOLVE A URL INTEIRA. Falhar mantendo o parâmetro é chato;
     falhar apagando é o bug que a gente está consertando. */
  function urlSemParams(){
    var nomes=Array.prototype.slice.call(arguments);
    try{
      var u=new URL(location.href);
      nomes.forEach(function(n){ u.searchParams.delete(n); });
      var q=u.searchParams.toString();
      return u.pathname+(q?('?'+q):'')+(u.hash||'');
    }catch(_){ return location.pathname+location.search+(location.hash||''); }
  }
  function placaDoSite(){
    var p='';
    try{
      var m=String(location.search||'').match(/[?&]placa=([A-Za-z0-9]{7})(?![A-Za-z0-9])/);
      if(!m) return;
      p=String(m[1]).toUpperCase();
      history.replaceState(null,'',location.pathname+location.search
        .replace(/([?&])placa=[^&]*/i,'$1').replace(/&&+/g,'&')
        .replace(/[?&]+$/,'').replace(/\?&/,'?'));
    }catch(_){ return; }
    if(!p) return;
    var campo=$('placa'); if(campo) campo.value=p;
    /* espera a tela inicial aparecer: consulta rodando é pra ser vista */
    setTimeout(function(){ try{ buscarPlaca(); }catch(_){} }, 250);
  }

  /* ======================================================================
     v532 — `app.html?chat=<telefone>` ABRE A CONVERSA DAQUELE TELEFONE
     (executa o PROJETO-2026-08-16-21-54-link-do-mev-tools-no-email-do-lead)

     RELATO: *"quando recebo e-mail de que cliente voltou a chamar depois de
     inativo, está vindo o link do MEV Tools e não do MEV Veículos."*

     🔴 O LINK NÃO ERA ERRO DE DIGITAÇÃO — era o certo em 06/08, quando foi
     escrito: **o MEV Veículos não tinha chat.** O único lugar onde dava pra
     ver a conversa era o MEV Tools. Hoje o chat existe (o balão, aba
     Clientes) e o e-mail é que ficou pra trás. Não é remendo: é o produto
     que andou e a linha que não andou junto.

     🔴 E NÃO BASTAVA TROCAR O DOMÍNIO: a rota `/clientes/?tel=…&chat=1` é do
     MEV Tools e não existe aqui. Precisava de um parâmetro que ESTE app
     entendesse — é esta função.

     ⚠️ POR QUE ELA MORA DENTRO DO `entrar()`, e essa é a parte que importa:
     o `entrar()` só roda **quando já existe sessão**. Um link encaminhado
     por e-mail, aberto por quem não é da loja, cai na tela de login e para
     ali — a conversa nunca chega a ser pintada. Se este gancho rodasse na
     abertura da página, o mesmo link viraria vazamento de conversa por
     e-mail encaminhado. É a regra das páginas públicas aplicada a um
     parâmetro de URL.
     ⚠️ E quem estava DESLOGADO não perde a viagem: o login acontece na mesma
     página, sem recarregar, então o `?chat=` continua no endereço e o
     `entrar()` o encontra depois que a pessoa entra.

     ⚠️ O PARÂMETRO SAI DO ENDEREÇO NA HORA — igual ao `?placa=` acima, e
     pelo mesmo motivo somado a um: recarregar não reabre a conversa por
     cima do que a pessoa estiver fazendo, e o telefone não fica pendurado
     na barra de endereço pra ser copiado junto com o link.
     ====================================================================== */
  function chatDoSite(){
    var d='';
    try{
      var m=String(location.search||'').match(/[?&]chat=(\d{8,15})(?!\d)/);
      if(!m) return;
      d=String(m[1]);
      history.replaceState(null,'',location.pathname+location.search
        .replace(/([?&])chat=[^&]*/i,'$1').replace(/&&+/g,'&')
        .replace(/[?&]+$/,'').replace(/\?&/,'?'));
    }catch(_){ return; }
    if(!d) return;
    /* ⚠️ o painel mora no 10c, concatenado DEPOIS deste arquivo. A chamada é
       em tempo de execução e com guarda — se um dia o módulo sair do build,
       o app abre normal em vez de estourar logo na entrada. */
    setTimeout(function(){
      try{
        if(typeof chatPainelAbrirCliente==='function') chatPainelAbrirCliente(d);
        else if(typeof drawerIr==='function') drawerIr('clientes');   /* rede */
      }catch(_){}
    }, 400);
  }
  /* carrega a foto de perfil da tabela 'perfil' (não fica mais no token) */
  async function perfilCarregarFoto(){
    if(!meuId || meuFoto) return;
    try{ var r=await withTimeout(supa.from('perfil').select('foto').eq('user_id',meuId).limit(1),8000);
      var f=(r&&r.data&&r.data[0]&&r.data[0].foto)||'';
      if(f){ meuFoto=f; try{ mevGreetPinta(); }catch(_){} var av=$('cadAva'); if(av){ av.style.backgroundImage=imgFundo(f,96); av.textContent=''; } }
    }catch(_){}
  }
  /* AUTO-REPARO da sessão: faz um teste rápido no banco; se travar (sessão
     presa/expirada), tenta renovar sozinho. Se não der, desloga e pede login.
     Não desloga em caso de rede fora (timeout na renovação = provável offline). */
  var _reparoFeito=false;
  async function _dbProbe(){ try{ var r=await withTimeout(supa.from('loja').select('id').limit(1), 7000); return !(r&&r.error); }catch(_){ return false; } }
  async function _dbAutoReparo(){
    if(_reparoFeito || !meuId) return;
    _reparoFeito=true;
    /* 1) teste rápido: a sessão consegue ler o banco? */
    if(await _dbProbe()) return;
    /* 2) tenta renovar a sessão e testar de novo */
    try{ var r=await withTimeout(supa.auth.refreshSession(), 8000); if(r&&r.data&&r.data.session) token=r.data.session.access_token; }catch(_){}
    if(await _dbProbe()){ try{ toast('Reconectado ✓'); }catch(_){} return; }
    /* 3) ainda travado: a sessão está presa/corrompida no aparelho.
       Limpa tudo e volta pro login (só 1x por sessão, pra não entrar em loop). */
    try{ if(sessionStorage.getItem('mev_reconnect')) return; sessionStorage.setItem('mev_reconnect','1'); }catch(_){}
    _hardLogout();
    try{ toast('Conexão presa — entre de novo pra reconectar.'); }catch(_){}
    try{ show('scAuth'); }catch(_){}
  }
  var _saldoOk=false;
  var _retomadaPagamentoFeita=false;
  async function retomarPagamentoPendente(info){
    if(_retomadaPagamentoFeita || !info || !info.id) return;
    _retomadaPagamentoFeita=true;
    var retorno='';
    try{ retorno=(new URLSearchParams(location.search)).get('pagamento')||''; }catch(_){}
    if(retorno){
      try{ history.replaceState(null,'',location.pathname+location.hash); }catch(_){}
      try{ toast('Confirmando seu pagamento…'); }catch(_){}
    }
    var r; try{ r=await api('/api/creditos',{acao:'confirmar',payment_id:String(info.id)}); }catch(_){ r=null; }
    if(r&&r.ok&&r.pago){
      setSaldo(r.saldo);
      var pb=$('pixBody'), ps=$('pixSucesso');
      if(pb) pb.style.display='block';
      if(ps){ ps.style.display='none'; ps.innerHTML=''; }
      $('modalPix').classList.add('on');
      pixSucessoAnim(r.saldo,String(info.id),Number(r.valor||info.valor||0));
      try{ localStorage.removeItem('mev_pagamento_pendente'); }catch(_){}
    }else if(retorno==='falhou'){
      try{ toast('O pagamento não foi aprovado. Nenhum valor foi lançado.'); }catch(_){}
    }else if(retorno){
      try{ toast('Pagamento em processamento. O saldo entra automaticamente após a aprovação.'); }catch(_){}
    }
  }
  /* ===== v636 — A CARTEIRA PASSA A TER IDADE ==============================
     Os créditos agora vencem (30 dias). Estas quatro variáveis são o que a
     tela precisa saber pra DIZER isso antes de acontecer:
       tokensVenceEm      — a data do próximo vencimento (null = nada vence)
       tokensVenceQtd     — quantos tokens vencem NESSA data
       tokensSemValidade  — o saldo antigo, honrado, que nunca vence
       tokensValidadeDias — o prazo em vigor, lido do BANCO e não cravado aqui
     🔴 O prazo vem do servidor de propósito: no dia em que ele mudar, a tela
     muda junto. Número de prazo escrito no app é promessa que envelhece
     sozinha — foi assim que a tela ficou dizendo "60 dias" até hoje. */
  var tokensVenceEm=null, tokensVenceQtd=0, tokensSemValidade=0, tokensValidadeDias=30;
  function tokensVenceTexto(){
    if(!tokensVenceEm || !(tokensVenceQtd>0)) return '';
    var d=new Date(tokensVenceEm);
    if(isNaN(d.getTime())) return '';
    return precoReal(tokensVenceQtd)+' vencem em '+d.toLocaleDateString('pt-BR');
  }
  async function carregarSaldo(){
    try{
      var d=await apiTimeout('/api/creditos',{acao:'saldo'},12000);
      if(d&&d.ok){ _saldoOk=true; ilimitado=!!d.ilimitado; pacotes=d.pacotes||[]; usoTokens=d.uso_tokens||null; tipoUsuario=d.tipo||'cliente'; gratisFipe=Number(d.gratis_fipe||0); gratisFipeAtivo=d.gratis_fipe_ativo===true; gratisFipeExpiraEm=d.gratis_fipe_expira_em||null; carteiraTokens=d.carteira||'individual'; politicaRecargaTokens=d.politica_recarga||'individual'; podeRecarregarTokens=d.pode_recarregar!==false; jaRecarregouTokens=d.ja_recarregou===true;
        /* v636 — o que vence, e quando */
        tokensVenceEm=d.vence_em||null; tokensVenceQtd=Number(d.vence_qtd||0);
        tokensSemValidade=Number(d.saldo_sem_validade||0); tokensValidadeDias=Number(d.validade_dias||30);
        setSaldo(d.saldo); mevGreetPinta(); try{ avisoSaldoBaixo(); }catch(_){} try{ saldoChipRepinta(); }catch(_){}
        var pend=d.pagamento_pendente||null;
        if(!pend){ try{ pend=JSON.parse(localStorage.getItem('mev_pagamento_pendente')||'null'); }catch(_){} }
        if(pend) retomarPagamentoPendente(pend);
        return true;
      }
    }catch(_){ /* rede lenta/fora: segue usável; tenta de novo quando o usuário agir */ }
    return false;
  }

  /* Descobre o papel do usuário na loja e, se for DONO/GERENTE, traz o
     histórico de placas de TODA a equipe (o RLS do banco já libera isso).
     Vendedor não entra aqui: continua vendo só as suas placas. */
  async function carregarPapelEquipe(){
    /* v764: papel e placas antigas NÃO são zerados no começo — numa RECARGA
       que falha (Tentar novamente do cartão), o que já estava na tela fica
       (§14.8) e o gestor não vira "vendedor" por um instante. */
    _equipeCarga='carregando';
    if(!meuId){ meuPapel='vendedor'; _equipeHist=[]; _equipeCarga='parado'; return; }
    var mine=null, mineErro=false;
    try{ var r=await supa.from('loja_membros').select('loja_id,papel').eq('user_id',meuId).limit(1); mine=(r&&r.data&&r.data[0])||null; }catch(_){ mineErro=true; }
    if(!mine){ if(!mineErro){ meuPapel='vendedor'; _equipeHist=[]; } _equipeCarga=mineErro?'erro':'ok'; try{ if(mineErro) pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){} return; }
    meuPapel=mine.papel||'vendedor';
    if(meuPapel!=='dono' && meuPapel!=='gerente'){ _equipeHist=[]; _equipeCarga='ok'; return; }
    /* gestor confirmado: se a view era equipe, o cartão já pode mostrar o esqueleto */
    try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
    var nomes={};
    try{ var rm=await supa.from('loja_membros').select('user_id,nome,email').eq('loja_id',mine.loja_id); ((rm&&rm.data)||[]).forEach(function(m){ nomes[m.user_id]=m.nome||m.email||'Vendedor'; }); }catch(_){}
    try{
      var lim=Date.now()-HIST_DIAS*864e5;
      var rh=await supa.from('historico_consulta').select('user_id,placa,modelo,ts,fav,dados,ficha,fichatec,leilao').gte('ts',lim).order('ts',{ascending:false}).limit(200);
      var rows=(rh&&rh.data)||[];
      _equipeHist=rows.filter(function(x){ return x && x.placa && String(x.user_id)!==String(meuId); })
        .map(function(x){ return { placa:x.placa, modelo:x.modelo||'', ts:(+x.ts||0), fav:!!x.fav, v:x.dados||null, ficha:x.ficha||null, fichaTec:x.fichatec||null, leilao:x.leilao||null, por:(nomes[x.user_id]||'Vendedor') }; });
      _equipeCarga='ok';
    }catch(_){ _equipeCarga='erro'; }   /* v764: rede fora → o cartão oferece Tentar novamente (dados antigos, se houver, ficam — §14.8) */
    try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
  }

  /* v1358 — abertura vetorial curta somente depois de um login explícito.
     A sessão restaurada ao reabrir o PWA não passa por esta função: assim a
     marca apresenta a entrada uma vez, sem atrasar o uso diário. A Home é
     montada atrás da camada e a animação não recebe toques nem foco. */
  function mevEscudoBuscaHtml(classe){
    return '<div class="'+(classe||'mev-login-intro-marca')+'" aria-hidden="true">'
      +'<span class="mev-login-intro-luz"></span>'
      +'<svg viewBox="0 0 120 120" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">'
        +'<path class="mev-login-intro-escudo" d="M60 8 98 22v29c0 26-16 44-38 55C38 95 22 77 22 51V22L60 8Z"/>'
        +'<circle class="mev-login-intro-busca" cx="54" cy="53" r="21"/>'
        +'<path class="mev-login-intro-busca" d="m70 69 17 17"/>'
        +'<path class="mev-login-intro-detalhe" d="M44 50h20M44 57h14"/>'
      +'</svg>'
    +'</div>';
  }
  var _introLoginTimer=0;
  function introLoginMostrar(){
    try{
      if(typeof edicaoAtual==='function' && edicaoAtual()!=='consultas') return;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var anterior=document.getElementById('mevLoginIntro');
      if(anterior) anterior.remove();
      if(_introLoginTimer) clearTimeout(_introLoginTimer);

      var intro=document.createElement('div');
      intro.id='mevLoginIntro';
      intro.className='mev-login-intro';
      intro.setAttribute('role','status');
      intro.setAttribute('aria-live','polite');
      intro.setAttribute('aria-label','Acesso concluído. Abrindo o MEV Consultas.');
      intro.innerHTML='<div class="mev-login-intro-centro">'
        +mevEscudoBuscaHtml('mev-login-intro-marca')
        +'<div class="mev-login-intro-copy">'
          +'<strong>MEV Consultas</strong>'
          +'<span>Consulte com segurança</span>'
        +'</div>'
      +'</div>';
      document.body.appendChild(intro);
      requestAnimationFrame(function(){ intro.classList.add('is-playing'); });
      _introLoginTimer=setTimeout(function(){
        intro.classList.add('is-leaving');
        setTimeout(function(){ if(intro.parentNode) intro.parentNode.removeChild(intro); },260);
      },1500);
    }catch(_){}
  }

  /* ---------- AUTH ---------- */
  (function(){
    var login=$('tabLogin'), cad=$('tabCad');
    if(login) login.onclick=function(){ authSelecionarModo('login'); };
    if(cad) cad.onclick=function(){ authSelecionarModo('cad'); };
    [login,cad].filter(Boolean).forEach(function(tab){ tab.onkeydown=function(ev){
      if(['ArrowLeft','ArrowRight','Home','End'].indexOf(ev.key)<0) return;
      ev.preventDefault();
      var proximo=(ev.key==='ArrowLeft'||ev.key==='Home')?'login':'cad';
      authSelecionarModo(proximo,true);
    }; });
    /* v290 — QUEM VEM DO SITE PEDINDO CADASTRO CAI NA ABA DE CADASTRO.
       A janela "Acesso exclusivo para lojistas" do site tem dois caminhos:
       "Fazer meu cadastro" e "entrar". Sem isto, os dois abriam a MESMA tela
       de login e o lojista novo tinha que descobrir sozinho a abinha lá em
       cima — que é exatamente o passo onde as pessoas desistem. */
    var _querCadastro = false;
    try{ _querCadastro = /(^|[#?&])(criar|cadastro)\b/i.test(String(location.hash||'')+String(location.search||'')); }catch(_){}
    authSelecionarModo(_querCadastro ? 'cad' : (modoAuth||'login'));
    /* tira o #criar da barra de endereço pra não reabrir o cadastro a cada
       recarregada depois que a pessoa já entrou */
    if(_querCadastro){ try{ history.replaceState(null,'',location.pathname+location.search.replace(/([?&])(criar|cadastro)=?[^&]*/gi,'')); }catch(_){} }
  })();
  $('btnAuth').onclick=async function(){
    var email=($('authEmail').value||'').trim(), senha=$('authSenha').value||'', msg=$('authMsg'); msg.className='msg';
    if(!email||senha.length<6){ msg.className='msg err'; msg.textContent='Informe e-mail e senha (mín. 6 caracteres).'; return; }
    this.disabled=true; this.textContent='Aguarde…';
    try{
      /* ===== v446 — O CADASTRO DIZ DE QUAL APP ELE VEIO ==================
         O CASO DOUGLAS: um lojista se cadastrou aqui no MEV Veículos, usou o
         app (3 consultas, carteira criada) — e foi parar no painel do
         MEVTools como "vendedor SEM PLANO", sem ficha nenhuma do lado de cá.

         A causa não era bug do app. Os dois produtos dividem o MESMO projeto
         Supabase, e lá existe um gatilho da época em que só havia o Cotação
         VW (on_auth_user_created → public.handle_new_user) que insere em
         public.vendedores em TODO cadastro do projeto. Como o signUp daqui
         não mandava nada que identificasse a origem, o banco não tinha como
         saber por qual porta a pessoa entrou.

         Resultado: TODO lojista novo do MEV Veículos virava vendedor do
         MEVTools e sumia do nosso radar. Perda silenciosa de cliente, na
         semana do lançamento.

         A cura é esta palavra. O gatilho (migração v446
         handle_new_user_por_app) lê raw_user_meta_data->>'app' e escolhe o
         lado: 'placas' → mp_portal_membro; qualquer outra coisa →
         vendedores, exatamente como antes. O Cotação VW não manda esse
         campo, cai no else, e nada muda pra ele.

         ⚠️ Vale só pra cadastro NOVO. Quem já existia foi arrumado à mão. */
      var r = (modoAuth==='cad')
        ? await supa.auth.signUp({email:email,password:senha,options:{emailRedirectTo:authRetornoUrl(false), data:{ app:'placas' }}})
        : await supa.auth.signInWithPassword({email:email,password:senha});
      if(r.error){ msg.className='msg err'; msg.textContent=traduz(r.error.message); this.disabled=false; this.textContent=(modoAuth==='cad'?'Criar conta':'Entrar'); return; }
      var s2=await supa.auth.getSession(); var sess=s2&&s2.data&&s2.data.session;
      if(!sess){ msg.className='msg ok'; msg.textContent='Conta criada! Confirme seu e-mail e depois entre.'; this.disabled=false; authSelecionarModo('login'); return; }
      token=sess.access_token; meuId=(sess.user&&sess.user.id)||null; meuEmail=(sess.user&&sess.user.email)||null;
      meuMeta=(sess.user&&sess.user.user_metadata)||{}; meuNome=meuMeta.nome||''; meuFoto=meuMeta.foto||'';
      if(modoAuth==='login') introLoginMostrar();
      await entrar();
    }catch(e){ msg.className='msg err'; msg.textContent='Erro. Tente de novo.'; this.disabled=false; }
  };
  function segundosEsperaRecuperacao(valor, padrao){
    var direto=Number(valor&&valor.aguarde_segundos);
    if(isFinite(direto)&&direto>0) return Math.min(Math.ceil(direto),3600);
    var m=String((valor&&(valor.message||valor.msg||valor.error_description||valor.error||valor.erro||valor.code))||valor||'');
    var achou=m.match(/after\s+(\d+)\s*seconds?/i)||m.match(/(?:aguarde|em)\s+(\d+)\s*segundos?/i);
    if(achou){ var n=parseInt(achou[1],10); if(isFinite(n)&&n>0) return Math.min(n,3600); }
    if(/security purposes|rate limit|too many|over_request_rate_limit/i.test(m)) return Number(padrao)||59;
    return 0;
  }
  function traduz(m){
    m=String(m||'');
    if(/Invalid login/i.test(m)) return 'E-mail ou senha incorretos.';
    if(/already registered/i.test(m)) return 'Este e-mail já tem conta. Faça login.';
    if(/confirm/i.test(m)) return 'Confirme seu e-mail antes de entrar.';
    var espera=segundosEsperaRecuperacao(m,59);
    if(espera) return 'Por segurança, aguarde '+espera+' segundo'+(espera===1?'':'s')+' antes de solicitar um novo link de recuperação.';
    return m;
  }
  function authRetornoUrl(recovery){
    var local=/^(localhost|127\.0\.0\.1)$/i.test(String(location.hostname||''));
    var consultas=false;
    try{ consultas=!!window.__mevConsultasNoSite || (typeof edicaoAtual==='function' && edicaoAtual()==='consultas'); }catch(_){}
    /* v1197 — cada produto volta para a própria porta depois do e-mail.
       O projeto Auth é compartilhado com o MEV Tools; por isso depender da
       Site URL padrão fazia o reset do MEV Consultas cair no outro app quando
       o domínio principal não estava na allow list do Supabase. */
    var destino=local
      ? (location.origin+location.pathname+(consultas?String(location.search||''):''))
      : (MEV_SITE+(consultas?'/consultas':'/app.html'));
    /* v1210 — NÃO acrescente fragmento manual ao retorno de recuperação.
       O Supabase entrega o próprio código/token e sinaliza PASSWORD_RECOVERY.
       Um `#recovery` anterior ao fragmento do provedor fazia o Safari abrir o
       app sem o Supabase conseguir interpretar a credencial temporária. */
    if(recovery){
      try{ var du=new URL(destino); du.searchParams.set('recuperar','1'); destino=du.toString(); }
      catch(_){ destino+=(destino.indexOf('?')>=0?'&':'?')+'recuperar=1'; }
    }
    return destino;
  }
  var _authSugAceita='';   /* v1241 — o domínio que ele já disse que está certo */
  /* mostrar / ocultar senha (olho) */
  var _SVG_OLHO='<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/>';
  var _SVG_OLHO_OFF='<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>';
  (function(){ var vb=$('authVerSenha'); if(!vb) return; vb.onclick=function(){ var inp=$('authSenha'), ol=$('authOlho'); if(!inp||!ol) return; var mostra=inp.type==='password'; inp.type=mostra?'text':'password'; ol.innerHTML=mostra?_SVG_OLHO_OFF:_SVG_OLHO; vb.setAttribute('aria-label', mostra?'Ocultar senha':'Mostrar senha'); vb.setAttribute('aria-pressed',mostra?'true':'false'); try{ inp.focus(); }catch(_){} }; })();

  /* ===== v600 — O MESMO OLHO, EM QUALQUER CAMPO DE SENHA =================
     O olho de "ver a senha" existia só no login (#authVerSenha, acima).
     Quem chegava pelo link do e-mail digitava a senha nova DUAS VEZES às
     cegas — e o "As duas senhas não são iguais" só aparecia depois.
     Agora o comportamento mora numa função só: olhoSenhaHtml(id) desenha
     o botão e olhoSenhaLigar(raiz) liga todos os que estiverem dentro.
     Mesmo SVG, mesmo aria, mesma cor — só que reaproveitável. */
  /* v1289 — o print real no iPhone confirmou que a troca nativa de tipo já
     revela o valor corretamente. A linha auxiliar "Senha digitada" repetia a
     senha em texto aberto e fazia a interface parecer ter dois campos. O olho
     passa a controlar somente o próprio input: uma ação, uma visualização. */
  function olhoSenhaHtml(alvo){
    return '<button type="button" class="olho-senha" data-olho="'+alvo+'" aria-label="Mostrar senha" aria-pressed="false">'+
      '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+_SVG_OLHO+'</svg>'+
      '<span class="olho-senha-txt" aria-hidden="true">Ver</span></button>';
  }
  function olhoSenhaLigar(raiz){
    try{
      var r=raiz||document;
      Array.prototype.forEach.call(r.querySelectorAll('.olho-senha'), function(bt){
        if(bt.__olhoOn) return; bt.__olhoOn=1;
        function alternar(ev){
          /* v1223 — alguns navegadores internos do iPhone não entregam nem o
             pointerup nem o click quando o gerenciador de senhas está sobre o
             teclado. touchstart é o caminho mais cedo e confiável; pointerup
             continua cobrindo Safari normal e click preserva teclado/leitor.
             Todos passam pela mesma janela para um toque nunca alternar duas
             ou três vezes. */
          var agora=Date.now();
          var fisico=!!(ev&&(ev.type==='touchstart'||ev.type==='pointerup'));
          if(ev&&((fisico&&bt.__olhoPonteiro)||(ev.type==='click'&&bt.__olhoPonteiro))&&(agora-bt.__olhoPonteiro)<700){
            try{ ev.preventDefault(); ev.stopPropagation(); }catch(_){} return;
          }
          if(fisico) bt.__olhoPonteiro=agora;
          try{ if(ev){ ev.preventDefault(); ev.stopPropagation(); } }catch(_){}
          var inp=$(bt.getAttribute('data-olho')), ol=bt.querySelector('svg');
          if(!inp||!ol) return;
          /* aria-pressed vira a fonte do estado porque o WebKit pode manter
             `input.type` como password enquanto o preenchimento automático
             está ativo, mesmo depois de aceitar setAttribute('type','text'). */
          var mostra=bt.getAttribute('aria-pressed')!=='true';
          var valor=inp.value, ini=null, fim=null;
          try{ ini=inp.selectionStart; fim=inp.selectionEnd; }catch(_){}
          /* ====================================================================
             🔴🔴 v1231 — O OLHO MUDAVA O RÓTULO E NÃO MOSTRAVA NADA
             --------------------------------------------------------------------
             Print do Angelo, 26/09, iPhone: o botão do primeiro campo já dizia
             "Ocultar" e os pontinhos continuavam lá. Ou seja: o toque CHEGAVA
             (a v1223 resolveu isso), o que não acontecia era a revelação.

             A v600 e a v1223 tentaram três caminhos, todos em cima do MESMO
             campo: trocar `input.type`, a classe `.senha-visivel` com
             `-webkit-text-security:none!important`, e o estilo direto. No
             WebKit do iPhone, quando o gerenciador de senhas já "adotou" o
             campo, nenhum dos três vence a máscara — o campo nasceu
             `type=password` e continua desenhado como password.

             🔑 ENTÃO NÃO SE DISCUTE MAIS COM O CAMPO: TROCA-SE O CAMPO.
             Um elemento NOVO, que nunca foi um campo de senha, não carrega a
             máscara de ninguém. O `cloneNode(false)` copia id, classe,
             placeholder, autocomplete e os aria — o valor a gente copia na
             mão, porque `.value` é propriedade, não atributo.

             ⚠️ O NÓ NOVO NÃO HERDA OS OUVINTES. É de propósito que esta versão
             traz JUNTO o conferidor de 250 ms da tela de nova senha (mais
             abaixo): ele lê os campos pelo id, não pelo nó, então a troca não
             deixa a tela surda. E ainda assim disparamos um `input` no nó
             novo, pra quem estiver ouvindo em outro lugar não ficar pra trás.
             ⚠️ Vale pros DOIS sentidos (mostrar e ocultar): um caminho só é um
             comportamento só pra medir. A régua da v1231 mede os dois.
             ==================================================================== */
          /* 🔴 v1241 — A TROCA DE NÓ DA v1231 SAIU DAQUI.
             Ela era um palpite meu sobre o WebKit, custou uma versão e NÃO
             consertou o iPhone dele. Medido depois no WebKit 26 de verdade
             (mesmo motor do Safari do iPhone, na página no ar): a troca
             simples de `type` revela a senha sem ajuda nenhuma.
             E a troca trazia risco real — o nó novo perde os ouvintes, e dois
             nós com o mesmo id são um defeito silencioso esperando acontecer.
             Palpite que não paga o que custa, sai. O print real da v1288
             confirmou a revelação no próprio campo; a v1289 removeu a cópia
             visual que repetia a senha abaixo dele. */
          try{ inp.type=mostra?'text':'password'; }catch(__){}
          try{ inp.setAttribute('type',mostra?'text':'password'); }catch(__){}
          try{ inp.classList.toggle('senha-visivel',mostra); }catch(__){}
          try{ inp.style.webkitTextSecurity=mostra?'none':'disc'; }catch(__){}
          try{ if(inp.value!==valor) inp.value=valor; }catch(_){}
          ol.innerHTML=mostra?_SVG_OLHO_OFF:_SVG_OLHO;
          var tx=bt.querySelector('.olho-senha-txt'); if(tx) tx.textContent=mostra?'Ocultar':'Ver';
          bt.setAttribute('aria-label', mostra?'Ocultar senha':'Mostrar senha');
          bt.setAttribute('aria-pressed', mostra?'true':'false');
          /* No toque não reabra o teclado/gerenciador: ele pode mascarar de
             novo o valor logo após a troca. Teclado e leitor mantêm o foco. */
          if(!fisico){
            try{ inp.focus({preventScroll:true}); }catch(_){ try{ inp.focus(); }catch(__){} }
            try{ if(ini!==null&&fim!==null) inp.setSelectionRange(ini,fim); }catch(_){}
          }
        }
        bt.addEventListener('touchstart',alternar,{passive:false});
        bt.addEventListener('pointerup',alternar);
        bt.addEventListener('click',alternar);
      });
    }catch(_){}
  }
  try{ window.olhoSenhaHtml=olhoSenhaHtml; window.olhoSenhaLigar=olhoSenhaLigar; }catch(_){}
  /* v1275/v1280/v1315 — recuperação refeita do zero em três passos: e-mail, código e
     nova senha. Abrir a tela NÃO envia nada e NÃO inicia cronômetro. O tempo
     de reenvio só nasce depois que o servidor confirma que o código saiu.
     O projeto fixa o OTP de e-mail do Supabase em 6 dígitos; a tela aceita
     exatamente esse tamanho para manter troca e recuperação consistentes. */
  var EMAIL_RX=/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
  /* domínios que são erro de digitação de um domínio conhecido. A lista é
     curta de propósito: só os que doem de verdade e só quando é CERTEZA. */
  var DOM_TROCADO={
    'iclou.com':'icloud.com','iclou.com.br':'icloud.com','icloud.com.br':'icloud.com',
    'iclould.com':'icloud.com','icloude.com':'icloud.com',
    'gmail.con':'gmail.com','gmail.co':'gmail.com','gmial.com':'gmail.com','gmai.com':'gmail.com',
    'gamil.com':'gmail.com','gmail.com.br':'gmail.com',
    'hotmai.com':'hotmail.com','hotmail.co':'hotmail.com','hotmial.com':'hotmail.com',
    'outlok.com':'outlook.com','outloo.com':'outlook.com',
    'yaho.com':'yahoo.com','yahoo.co':'yahoo.com','uol.com':'uol.com.br','bol.com':'bol.com.br'
  };
  function emailSugestao(email){
    var p=String(email||'').split('@'); if(p.length!==2) return '';
    var d=String(p[1]||'').toLowerCase(), bom=DOM_TROCADO[d];
    return bom?(p[0]+'@'+bom):'';
  }
  async function enviarRecuperacaoCodigo(email){
    try{
      var rr=await fetch('/api/recuperar-senha',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ email:email }) });
      var jj=null; try{ jj=await rr.json(); }catch(_){}
      if(rr.ok&&jj&&jj.enviado) return { ok:true, entrega:String(jj.entrega||'sent') };
      if(rr.ok&&jj&&jj.existe===false) return { ok:false, existe:false };
      if(rr.status===429||(jj&&jj.limite)){
        var esperaServidor=segundosEsperaRecuperacao(jj,Number(jj&&jj.aguarde_segundos)||59);
        return { ok:false, limite:true, segundos:esperaServidor||59,
          erro:'Já houve um pedido recente. Confira seu e-mail ou tente novamente em '+(esperaServidor||59)+' segundo'+((esperaServidor||59)===1?'':'s')+'.' };
      }
      return { ok:false, erro:(jj&&jj.erro)||'Não foi possível enviar o código agora. Tente novamente.' };
    }catch(_){ return { ok:false, erro:'Sem conexão. Confira a internet e tente novamente.' }; }
  }
  var _recPedidoAberto=false, _recPedidoTimer=null;
  function abrirPedidoRecuperacao(){
    if(_recPedidoAberto) return; _recPedidoAberto=true;
    var ov=document.createElement('div'); ov.id='recPedidoBg';
    ov.innerHTML='<section class="rec-pedido-cx" role="dialog" aria-modal="true" aria-labelledby="recPedidoTitulo">'+
      '<button type="button" id="recPedidoFechar" class="rec-pedido-fechar" aria-label="Fechar recuperação de senha"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>'+
      '<div class="rec-pedido-marca" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3M12 15v2"/></svg></div>'+
      '<p class="rec-pedido-etapa" id="recPedidoEtapa">ETAPA 1 DE 3</p><h2 id="recPedidoTitulo">Recuperar senha</h2>'+
      '<p class="rec-pedido-apoio" id="recPedidoApoio">Informe o e-mail da sua conta. Enviaremos um código de 6 dígitos.</p>'+
      '<div id="recPedidoPassoEmail">'+
        '<label class="rec-pedido-label" for="recPedidoEmail">E-mail</label><input id="recPedidoEmail" class="rec-pedido-input" type="email" inputmode="email" autocomplete="email" placeholder="voce@empresa.com.br">'+
        '<button type="button" id="recPedidoEnviar" class="rec-pedido-principal">Enviar código</button>'+
      '</div>'+
      '<div id="recPedidoPassoCodigo" hidden>'+
        '<div class="rec-pedido-destino">E-mail de recuperação para <b id="recPedidoDestino"></b></div>'+
        '<label class="rec-pedido-label" for="recPedidoCodigo">Código recebido por e-mail</label><input id="recPedidoCodigo" class="rec-pedido-input rec-pedido-codigo" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="Digite o código">'+
        '<button type="button" id="recPedidoConfirmar" class="rec-pedido-principal">Confirmar código</button>'+
        '<button type="button" id="recPedidoReenviar" class="rec-pedido-secundario">Reenviar código</button>'+
        '<button type="button" id="recPedidoEditar" class="rec-pedido-link">Usar outro e-mail</button>'+
      '</div>'+
      '<div id="recPedidoMsg" class="rec-pedido-msg" role="alert" aria-live="assertive"></div>'+
    '</section>';
    document.body.appendChild(ov); document.body.classList.add('rec-pedido-aberto');
    var emailEl=$('recPedidoEmail'), enviar=$('recPedidoEnviar'), passoEmail=$('recPedidoPassoEmail'), passoCodigo=$('recPedidoPassoCodigo');
    var codigo=$('recPedidoCodigo'), confirmar=$('recPedidoConfirmar'), reenviar=$('recPedidoReenviar'), msg=$('recPedidoMsg');
    try{ emailEl.value=String((($('authEmail')||{}).value)||meuEmail||'').trim(); emailEl.focus(); }catch(_){}
    function mensagem(texto,tipo){ msg.className='rec-pedido-msg'+(tipo?' '+tipo:''); msg.textContent=texto||''; }
    function fechar(){ if(_recPedidoTimer) clearInterval(_recPedidoTimer); _recPedidoTimer=null; ov.remove(); document.body.classList.remove('rec-pedido-aberto'); _recPedidoAberto=false; }
    function cooldown(segundos){
      var ate=Date.now()+Math.max(1,Number(segundos)||59)*1000;
      if(_recPedidoTimer) clearInterval(_recPedidoTimer);
      function pinta(){ var n=Math.max(0,Math.ceil((ate-Date.now())/1000));
        if(n>0){ enviar.disabled=true; enviar.textContent='Tentar novamente em '+n+' s'; reenviar.disabled=true; reenviar.textContent='Reenviar em '+n+' s'; return; }
        clearInterval(_recPedidoTimer); _recPedidoTimer=null; enviar.disabled=false; enviar.textContent='Enviar código'; reenviar.disabled=false; reenviar.textContent='Reenviar código';
      }
      pinta(); _recPedidoTimer=setInterval(pinta,250);
    }
    async function enviarCodigo(){
      var email=String(emailEl.value||'').trim().toLowerCase(); mensagem('','');
      if(!email){ mensagem('Digite o e-mail da sua conta.','err'); emailEl.focus(); return; }
      if(!EMAIL_RX.test(email)){ mensagem('Digite um e-mail válido. Confira o @ e o final do endereço.','err'); emailEl.focus(); return; }
      var sug=emailSugestao(email); if(sug){ mensagem('Confira o endereço. Você quis dizer '+sug+'?','err'); emailEl.focus(); emailEl.select(); return; }
      enviar.disabled=true; reenviar.disabled=true; var texto=enviar.textContent; enviar.textContent='Enviando…'; reenviar.textContent='Enviando…';
      var r=await enviarRecuperacaoCodigo(email);
      enviar.disabled=false; enviar.textContent=texto;
      if(!r||!r.ok){
        if(r&&r.existe===false) mensagem('Esse e-mail não está cadastrado. Confira o endereço digitado.','err');
        else mensagem((r&&r.erro)||'Não foi possível enviar o código agora.','err');
        if(r&&r.limite) cooldown(r.segundos||59); else { reenviar.disabled=false; reenviar.textContent='Reenviar código'; }
        return;
      }
      passoEmail.hidden=true; passoCodigo.hidden=false; $('recPedidoEtapa').textContent='ETAPA 2 DE 3';
      $('recPedidoApoio').textContent='Digite o código recebido para confirmar que a conta é sua.'; $('recPedidoDestino').textContent=email;
      var aviso=r.entrega==='supabase_auth'
        ? 'Código solicitado ao Supabase Auth. Procure pelo assunto “Código para recuperar sua senha — MEV Veículos” e confira Spam e Lixo.'
        : r.entrega==='delivered'
        ? 'Entrega confirmada pelo servidor do seu e-mail. Procure por “MEV Veículos” e confira Spam e Lixo.'
        : r.entrega==='delivery_delayed'
          ? 'Seu provedor está demorando para receber o e-mail. Aguarde alguns minutos e confira Spam e Lixo.'
          : 'Código aceito para envio. Procure por “MEV Veículos” e confira Spam e Lixo.';
      mensagem(aviso,'ok'); cooldown(59); try{ codigo.focus(); }catch(_){}
    }
    enviar.onclick=enviarCodigo; reenviar.onclick=enviarCodigo;
    emailEl.onkeydown=function(e){ if(e.key==='Enter') enviarCodigo(); };
    codigo.oninput=function(){ this.value=String(this.value||'').replace(/\D/g,'').slice(0,6); mensagem('',''); };
    codigo.onkeydown=function(e){ if(e.key==='Enter') confirmar.click(); };
    confirmar.onclick=async function(){
      var email=String(emailEl.value||'').trim().toLowerCase(), tokenOtp=String(codigo.value||'').replace(/\D/g,'');
      if(tokenOtp.length!==6){ mensagem('Digite os 6 dígitos do código recebido.','err'); codigo.focus(); return; }
      confirmar.disabled=true; confirmar.textContent='Confirmando…'; mensagem('','');
      try{
        var vr=await supa.auth.verifyOtp({email:email,token:tokenOtp,type:'recovery'});
        if(vr&&vr.error) throw vr.error;
        var sess=vr&&vr.data&&vr.data.session; if(!sess||!sess.user) throw new Error('otp_expired');
        $('recPedidoEtapa').textContent='ETAPA 3 DE 3'; fechar(); _recoveryFlag=true; abrirRecovery(); _recSessaoAplicar(sess);
      }catch(e){
        confirmar.disabled=false; confirmar.textContent='Confirmar código';
        var bruto=String((e&&(e.code||e.message))||'');
        mensagem(/expired|invalid|otp/i.test(bruto)?'Código inválido ou expirado. Confira os números ou solicite outro código.':'Não foi possível confirmar o código. Tente novamente.','err');
      }
    };
    $('recPedidoEditar').onclick=function(){ passoCodigo.hidden=true; passoEmail.hidden=false; $('recPedidoEtapa').textContent='ETAPA 1 DE 3'; $('recPedidoApoio').textContent='Informe o e-mail da sua conta. Enviaremos um código de 6 dígitos.'; mensagem('',''); emailEl.focus(); };
    $('recPedidoFechar').onclick=fechar;
    ov.addEventListener('click',function(e){ if(e.target===ov) fechar(); });
    ov.addEventListener('keydown',function(e){ if(e.key==='Escape') fechar(); });
  }
  (function(){ var lk=$('authEsqueci'); if(!lk) return; lk.onclick=function(ev){ ev.preventDefault(); abrirPedidoRecuperacao(); }; })();
  /* Tela de NOVA SENHA (aberta quando a pessoa clica no link de reset do e-mail).
     O Supabase já deixa a sessão pronta pra trocar a senha, então é só definir. */
  var _recAberto=false, _recSessaoOk=false, _recSessaoTentativa=0, _recSessaoTimer=null;
  var _recCodigoTentou=false, _recCodigoErro=null, _recCodigoMudo=false;
  var _recAbertoEm=0;   /* v1255 — o relógio de parede da validação do link */
  function _recSenhaRegras(s){
    s=String(s||'');
    return { tamanho:s.length>=8, minuscula:/[a-z]/.test(s), maiuscula:/[A-Z]/.test(s), numero:/[0-9]/.test(s), simbolo:/[^A-Za-z0-9\s]/.test(s) };
  }
  function _recSenhaValida(s){ var r=_recSenhaRegras(s); return r.tamanho&&r.minuscula&&r.maiuscula&&r.numero&&r.simbolo; }
  function _recErroTexto(e){
    var m=String((e&&(e.code||e.message))||'').toLowerCase();
    if(/same.password|different.*old|new.password.*different/.test(m)) return 'Escolha uma senha diferente da senha anterior.';
    if(/weak.password|password.*weak|password should|at least|characters/.test(m)) return 'A senha não atende à política de segurança. Confira os requisitos acima.';
    if(/session.*missing|not authenticated|expired|invalid.*token|otp_expired|bad_jwt|jwt/.test(m)) return 'A recuperação expirou ou já foi usada. Solicite um novo código em “Esqueci minha senha”.';
    if(/rate.limit|too many|over_request_rate_limit/.test(m)) return 'Muitas tentativas. Aguarde um minuto e tente novamente.';
    if(/network|fetch|connection|offline/.test(m)) return 'Sem conexão com o serviço. Confira a internet e tente novamente.';
    return 'Não foi possível salvar. Confira a conexão ou solicite um novo código.';
  }
  function _recSessaoAplicar(sess){
    if(!sess||!sess.user) return false;
    _recSessaoOk=true; clearTimeout(_recSessaoTimer);
    /* O código PKCE e os tokens do fluxo implícito são credenciais de uso
       único. Depois que viram sessão, saem imediatamente da barra/histórico. */
    try{
      var ru=new URL(location.href);
      ['code','sb_flow_id','recuperar','token','token_hash','type','error','error_code','error_description'].forEach(function(k){ ru.searchParams.delete(k); });
      history.replaceState(null,'',ru.pathname+(ru.searchParams.toString()?('?'+ru.searchParams.toString()):''));
    }catch(_){}
    var st=$('recLinkStatus'); if(st){ st.className='rec-link-status ok'; st.textContent='Identidade confirmada com segurança.'; }
    try{ _recValidar(); }catch(_){}
    return true;
  }
  /* ══════════════════════════════════════════════════════════════════════════
     🔴🔴🔴 v1255 — A TELA QUE FICAVA EM "VALIDANDO O LINK SEGURO…" PRA SEMPRE
     ──────────────────────────────────────────────────────────────────────────
     Print do Angelo, 28/09, 20:06: senha digitada nos dois campos, e o aviso
     ainda dizia "Validando o link seguro…". O botão nunca liberava, e não
     havia saída nenhuma na tela — nem o "pedir novo link".

     A CAUSA, medida numa bancada (probe das duas falhas):
       · se o `getSession()` do Supabase RESPONDE sem sessão, a tela acerta:
         em 8 s ela diz "expirou" e mostra o caminho de volta. Esse caminho
         estava certo;
       · se o `getSession()` NÃO RESPONDE — a promessa fica pendurada, que é
         o que o GoTrue faz quando trava na inicialização/lock — o `await`
         nunca volta. E como o relógio das tentativas só era re-armado DEPOIS
         do await, a contagem de 8 s NUNCA COMEÇAVA. A tela ficava assim até
         o app ser fechado. Medido: 14 s e continuava "Validando…".

     🔑 A LIÇÃO, e ela vale pra todo await desta casa: **não é a resposta de
     erro que trava uma tela, é a resposta que não vem.** `try/catch` não
     pega promessa pendurada — só prazo pega. Espera sem prazo é tela morta.

     O CONSERTO TEM TRÊS PARTES:
       1. cada consulta tem prazo próprio (1,5 s) — sempre volta, com resposta
          ou com "__prazo__";
       2. a tela inteira tem um prazo de relógio de parede (12 s contados da
          abertura), em vez de um contador de tentativas que podia nem andar;
       3. quem estoura por SILÊNCIO ouve uma frase diferente de quem estoura
          por link gasto — porque não responder não é a mesma coisa que ter
          expirado, e mandar pedir um link novo quando o link está bom é
          mandar a pessoa pro lugar errado. Esse caso ganha "Tentar de novo".
     E tem a segunda fonte: o `getUser()` fala com o servidor e às vezes
     responde quando o `getSession()` está preso no cache local.
     ══════════════════════════════════════════════════════════════════════════ */
  var REC_PRAZO_CONSULTA = 1500;    /* cada pergunta ao Supabase */
  var REC_PRAZO_TOTAL    = 12000;   /* a tela inteira, do relógio de parede */
  function _recPrazo(p, ms){
    return Promise.race([
      Promise.resolve(p)['catch'](function(){ return null; }),
      new Promise(function(res){ setTimeout(function(){ res('__prazo__'); }, ms); })
    ]);
  }
  function _recDesistir(porSilencio){
    clearTimeout(_recSessaoTimer);
    var st=$('recLinkStatus');
    if(st){ st.className='rec-link-status err';
      st.textContent = porSilencio
        ? 'Não consegui confirmar a recuperação agora. Toque em "Tentar de novo".'
        : 'Esta recuperação expirou ou já foi usada. Solicite um novo código.'; }
    var voltar=$('recVoltar'); if(voltar) voltar.hidden=false;
    var re=$('recTentarDeNovo'); if(re) re.hidden=!porSilencio;
    try{ _recValidar(); }catch(_){}
  }
  function _recCodigoLer(){
    try{ return String((new URL(location.href)).searchParams.get('code')||'').trim(); }catch(_){ return ''; }
  }
  /* v1268 — o /verify do Supabase confirma o link e redireciona o navegador
     com um Auth Code. Confirmar o link NÃO cria a sessão por si só: no PKCE,
     o cliente precisa trocar esse código por uma sessão. Sem esta chamada o
     iPhone ficava para sempre em "Validando o link seguro…". */
  async function _recCodigoTrocar(){
    var codigo=_recCodigoLer();
    if(!codigo||_recCodigoTentou) return false;
    _recCodigoTentou=true; _recCodigoErro=null; _recCodigoMudo=false;
    var r=null;
    try{ r=await _recPrazo(supa.auth.exchangeCodeForSession(codigo),5000); }catch(e){ _recCodigoErro=e||new Error('invalid code'); return false; }
    if(r==='__prazo__'){ _recCodigoMudo=true; return false; }
    if(r&&r.error){ _recCodigoErro=r.error; return false; }
    return _recSessaoAplicar(r&&r.data&&r.data.session);
  }
  async function _recSessaoChecar(){
    if(_recSessaoOk||!$('recBg')) return;
    var mudo=false, r=null;
    /* A troca explícita vem antes de getSession(). Se a versão da biblioteca
       já tiver absorvido o código automaticamente, getSession abaixo encontra
       a sessão; assim não existe corrida entre os dois caminhos. */
    try{ if(await _recCodigoTrocar()) return; }catch(e){ _recCodigoErro=e||new Error('invalid code'); }
    try{ r=await _recPrazo(supa.auth.getSession(), REC_PRAZO_CONSULTA); }catch(_){ r=null; }
    if(r==='__prazo__'){
      mudo=true;
      /* segunda fonte: o servidor, não o cache local */
      var u=null;
      try{ u=await _recPrazo(supa.auth.getUser(), REC_PRAZO_CONSULTA); }catch(_){ u=null; }
      if(u && u!=='__prazo__' && u.data && u.data.user && _recSessaoAplicar({ user:u.data.user })) return;
    } else if(_recSessaoAplicar(r && r.data && r.data.session)) return;
    _recSessaoTentativa++;
    /* v1231 — eram 12 tentativas de 400 ms (4,8 s). Num celular no 4G, com
       o app.js de 4,7 MB ainda subindo, 4,8 s é apertado: o link podia ser
       dado como expirado sem nunca ter tido chance.
       v1255 — e o contador virou RELÓGIO: um contador só anda quando o await
       volta, e o defeito era exatamente o await que não voltava. */
    if(!_recAbertoEm) _recAbertoEm=Date.now();
    if((Date.now()-_recAbertoEm) < REC_PRAZO_TOTAL){ _recSessaoTimer=setTimeout(_recSessaoChecar,500); return; }
    _recDesistir(!_recCodigoErro && (mudo||_recCodigoMudo));
  }
  var REC_MIN=8;   /* v1251 — o mesmo 8 da regra e dos tracinhos, num lugar só */
  function _recSlotsPinta(n){
    var cx=$('recSlots'); if(!cx) return;
    if(cx.childNodes.length!==REC_MIN){
      cx.innerHTML=''; for(var i=0;i<REC_MIN;i++) cx.appendChild(document.createElement('u'));
    }
    var us=cx.getElementsByTagName('u');
    for(var j=0;j<us.length;j++) us[j].className = (j<n?'on':'');
    var t=$('recSlotsN');
    if(t){ t.textContent=Math.min(n,REC_MIN)+'/'+REC_MIN; t.classList.toggle('ok',n>=REC_MIN); }
  }
  function _recValidar(){
    var s1=(($('recS1')||{}).value)||'', s2=(($('recS2')||{}).value)||'', regras=_recSenhaRegras(s1);
    Object.keys(regras).forEach(function(k){ var el=$('recRegra-'+k); if(el){ el.classList.toggle('ok',!!regras[k]); el.setAttribute('aria-checked',regras[k]?'true':'false'); } });
    /* v1251 — os tracinhos do mínimo de caracteres */
    try{ _recSlotsPinta(s1.length); }catch(_){}
    var preenchida=!!s2, iguais=preenchida&&s1===s2, igual=$('recIguais');
    /* v1251 — a mensagem ganhou ícone: ele disse que "não aparece mensagem se
       as senhas conferem". Aparecia — só nunca chegava a rodar, porque o dedo
       não alcançava o campo (veja a nota do z-index). Com ícone, a resposta é
       visível de canto de olho, sem ler. */
    if(igual){
      igual.className='rec-iguais'+(preenchida?(iguais?' ok':' err'):'');
      igual.textContent=preenchida?(iguais?'\u2713 As senhas são iguais.':'\u2715 As senhas ainda são diferentes.'):'Repita a senha para confirmar.';
    }
    var qtd=Object.keys(regras).filter(function(k){ return regras[k]; }).length, barra=$('recForcaBar'), forca=$('recForcaTxt');
    if(barra) barra.style.width=(qtd*20)+'%';
    if(forca) forca.textContent=qtd<3?'Fraca':(qtd<5?'Boa':'Forte');
    var reqn=$('recReqN');
    if(reqn){ reqn.textContent=qtd+' de 5 requisitos'; reqn.classList.toggle('ok',qtd===5); }
    var b=$('recSalvar'); if(b&&!b.getAttribute('aria-busy')) b.disabled=!(_recSessaoOk&&_recSenhaValida(s1)&&iguais);
    return _recSessaoOk&&_recSenhaValida(s1)&&iguais;
  }
  /* ========================================================================
     🔴🔴🔴 v1241 — A TELA QUE NUNCA SABIA EM QUE VERSÃO ESTAVA RODANDO
     ------------------------------------------------------------------------
     No dia 27 o Angelo mandou um print desta tela com dois defeitos que a
     v1231 já tinha consertado. Eu medi a página NO AR, no motor do Safari de
     verdade: funcionava. Ou seja — o aparelho dele podia não estar rodando a
     versão que está no ar.

     E esta tela é o pior lugar possível pra isso acontecer, por um motivo
     que só vi agora: o app tem um atualizador automático (o `_mevChecaVersao`
     do 19-documentos-e-init), mas ele recarrega a página em "momento calmo".
     Quem chega pelo link do e-mail cai DIRETO aqui, com um token de uma hora
     na mão — recarregar no meio disso queimaria o link. Na prática, esta é a
     única tela do app onde a atualização automática não entra.

     🔑 Então ela passa a DIZER em que versão está. Um número no rodapé, e um
     aviso âmbar quando o servidor tem uma mais nova. Isso não conserta nada
     sozinho — o que conserta é o aviso transformar "o app está quebrado" em
     "o app está velho", que são dois problemas com soluções opostas.

     ⚠️ O botão de atualizar AVISA que vai precisar de link novo, porque vai.
     Mentir aqui seria pior que não ter botão. */
  function _recVersaoConferir(){
    var aqui='';
    try{ aqui=(typeof MEV_BUILD!=='undefined'?String(MEV_BUILD):''); }catch(_){}
    var el=$('recVersao'); if(el) el.textContent=aqui?('Versão '+aqui.replace(/^v/i,'')):'';
    if(!aqui) return;
    var nAqui=(String(aqui).match(/(\d+)/)||[])[1]; nAqui=nAqui?Number(nAqui):0;
    if(!nAqui) return;
    try{
      fetch('versao.json?_v='+Date.now(),{cache:'no-store'}).then(function(r){ return r.ok?r.json():null; }).then(function(j){
        var noAr=j&&j.build?String(j.build):''; if(!noAr) return;
        var nAr=(noAr.match(/(\d+)/)||[])[1]; nAr=nAr?Number(nAr):0;
        /* só aponta pra FRENTE — a lição da v658: servidor com resposta
           velha não pode empurrar o aparelho pra trás. */
        if(!nAr || nAr<=nAqui) return;
        var av=$('recVersaoAviso'); if(!av) return;
        av.hidden=false;
        av.innerHTML='<b>Este aparelho está com uma versão antiga do app.</b>'+
          '<span>Aqui: '+nAqui+' &middot; no ar: '+nAr+'. Erros nesta tela podem ser só isso.</span>'+
          '<button type="button" id="recAtualizar">Atualizar o app agora</button>'+
          '<small>Depois de atualizar, inicie a recuperação novamente.</small>';
        var bt=$('recAtualizar'); if(bt) bt.onclick=function(){
          bt.disabled=true; bt.textContent='Atualizando…';
          var fim=function(){ try{ location.replace(location.pathname+location.search); }catch(_){ location.reload(); } };
          try{
            if(!('caches' in window)) return fim();
            caches.keys().then(function(ks){ return Promise.all(ks.map(function(k){ return caches.delete(k); })); })
              .then(function(){ try{ return navigator.serviceWorker.getRegistrations(); }catch(_){ return []; } })
              .then(function(rs){ return Promise.all((rs||[]).map(function(x){ return x.unregister(); })); })
              .then(fim).catch(fim);
          }catch(_){ fim(); }
          setTimeout(fim, 4000);   /* nunca ficar preso em "Atualizando…" */
        };
      }).catch(function(){});
    }catch(_){}
  }
  function abrirRecovery(){
    if(_recAberto) return; _recAberto=true;
    try{ var sl=$('scLoad'); if(sl) sl.style.display='none'; }catch(_){}
    var ov=document.createElement('div');
    ov.id='recBg';
    /* ══════════════════════════════════════════════════════════════════
       🔴🔴🔴 v1251 — A TELA ESTAVA DEBAIXO DO PORTÃO DOS TERMOS
       ──────────────────────────────────────────────────────────────────
       Angelo, 28/09, print do iPhone: nenhum requisito marcado, o olho não
       mostra a senha, nenhuma mensagem dizendo se as senhas conferem.

       MEDIDO NO NAVEGADOR, nos dois motores (Chromium e WebKit), antes de
       mexer numa linha:
         · `#legalGate` é position:fixed com z-index 100010
         · `#recBg`  (esta tela) era position:fixed com z-index 100000
       Ou seja: o portão dos Termos ficava DEZ ACIMA desta tela. O
       `document.elementFromPoint` no meio do botão do olho devolvia
       `HEADER.legal-head` — o dedo tocava no portão, não no olho. O
       Playwright se recusou a clicar no botão, e estava certo.

       Com o portão fora, tudo funcionou nos dois motores na hora: os cinco
       requisitos marcaram, "As senhas são iguais." apareceu e o campo virou
       type=text. Não havia defeito
       nenhum na lógica — havia uma folha de vidro por cima dela.

       🔑 E É A PIOR TELA POSSÍVEL PRA ISSO: quem chega aqui vem do link do
       e-mail, não está logado, e é exatamente quem o portão dos Termos
       intercepta. O caminho normal do pedido de senha passava por cima do
       defeito toda vez.

       ⚠️ O NÚMERO NÃO BASTA — tem a conferência logo abaixo (_recPorCima),
       que mede de verdade quem está no ponto do botão e sobe até ganhar.
       z-index escrito à mão é promessa; elementFromPoint é fato. */
    ov.style.cssText='position:fixed;inset:0;z-index:2147483000;background:radial-gradient(circle at 50% 12%,#1976F2,#0A4DA6 55%,#031736);display:flex;align-items:flex-start;justify-content:center;padding:32px 16px;overflow:auto';
    ov.innerHTML='<div class="rec-cx">'+
      '<div class="rec-head">'+
        '<div class="rec-an rec-titulo" style="--i:0">Criar nova senha</div>'+
        '<div class="rec-an rec-sub" style="--i:1">Use uma senha forte e diferente das que você utiliza em outros sites.</div>'+
      '</div>'+
      '<div id="recLinkStatus" class="rec-an rec-link-status" style="--i:2" role="status" aria-live="polite">Confirmando sua recuperação…</div>'+
      '<div class="rec-an rec-field" style="--i:3"><label for="recS1">Nova senha</label><div class="olho-campo"><input id="recS1" type="password" placeholder="Digite a nova senha" autocomplete="new-password" autocapitalize="none" spellcheck="false" aria-describedby="recRegras recForcaTxt">'+olhoSenhaHtml('recS1')+'</div></div>'+
      '<div class="rec-an rec-regras" id="recRegras" style="--i:4" aria-label="Requisitos da senha">'+
        /* v1251 — pedido dele: "mostre um underline embaixo de cada caracter
           necessário pro usuário poder ver quantos ainda falta". São oito
           tracinhos que acendem um a um. "Faltam 3" é uma frase; oito riscos
           com cinco acesos é a MESMA informação sem precisar ler. */
        '<div id="recRegra-tamanho" role="checkbox" aria-checked="false"><i></i><span>Pelo menos 8 caracteres</span>'+
          '<b class="rec-slots" id="recSlots" aria-hidden="true"></b><em class="rec-conta" id="recSlotsN">0/8</em></div>'+
        '<div id="recRegra-minuscula" role="checkbox" aria-checked="false"><i></i><span>Uma letra minúscula</span></div>'+
        '<div id="recRegra-maiuscula" role="checkbox" aria-checked="false"><i></i><span>Uma letra maiúscula</span></div>'+
        '<div id="recRegra-numero" role="checkbox" aria-checked="false"><i></i><span>Um número de 0 a 9</span></div>'+
        '<div id="recRegra-simbolo" role="checkbox" aria-checked="false"><i></i><span>Um símbolo: ! @ #</span></div>'+
      '</div>'+
      '<div class="rec-an rec-forca" style="--i:5"><div><span>Força da senha <i class="rec-req" id="recReqN">0 de 5 requisitos</i></span><b id="recForcaTxt">Fraca</b></div><em><i id="recForcaBar"></i></em></div>'+
      '<div class="rec-an rec-field" style="--i:6"><label for="recS2">Confirmar nova senha</label><div class="olho-campo"><input id="recS2" type="password" placeholder="Digite novamente" autocomplete="new-password" autocapitalize="none" spellcheck="false" aria-describedby="recIguais">'+olhoSenhaHtml('recS2')+'</div><div id="recIguais" class="rec-iguais" aria-live="polite">Repita a senha para confirmar.</div></div>'+
      '<label class="rec-an rec-sessoes" style="--i:7"><input type="checkbox" id="recSairOutros" checked><span>Encerrar o acesso nos outros aparelhos</span></label>'+
      '<button type="button" id="recSalvar" class="rec-an rec-salvar" style="--i:8" disabled>Salvar nova senha</button>'+
      /* v1255 — quem estourou por SILÊNCIO não precisa de link novo: precisa
         de outra tentativa. Pedir e-mail novo pra um link que está bom é
         mandar a pessoa dar uma volta à toa. */
      '<button type="button" id="recTentarDeNovo" class="rec-an rec-voltar" style="--i:9" hidden>Tentar de novo</button>'+
      '<button type="button" id="recVoltar" class="rec-an rec-voltar" style="--i:10" hidden>Voltar e pedir novo código</button>'+
      '<div id="recMsg" class="rec-msg" role="alert" aria-live="assertive"></div>'+
      '<div id="recVersaoAviso" class="rec-versao-aviso" hidden></div>'+
      '<div id="recVersao" class="rec-versao"></div>'+
    '</div>';
    document.body.appendChild(ov);
    _entradaAnima(ov);   /* v601 — tela que nasce sozinha entra igual ao login */
    var b=$('recSalvar'), s1el=$('recS1'), s2el=$('recS2');
    if(s1el){ s1el.addEventListener('input',_recValidar); s1el.addEventListener('change',_recValidar); }
    if(s2el){ s2el.addEventListener('input',_recValidar); s2el.addEventListener('change',_recValidar); }
    /* ======================================================================
       🔴🔴🔴 v1231 — A TELA SÓ ACORDAVA SE A PESSOA DIGITASSE
       ----------------------------------------------------------------------
       Print do Angelo, 26/09, 13:09, iPhone: os dois campos CHEIOS, nenhum
       requisito marcado, "Repita a senha para confirmar." ainda na tela e o
       "Salvar nova senha" apagado. Ele não conseguiu trocar a senha.

       Não era o link, não era o Supabase, não era a senha fraca. Era isto:
       esta tela se atualizava SÓ pelos eventos `input` e `change`. Quando o
       gerenciador de senhas do iPhone (ou do Chrome) preenche os campos —
       que é o caminho NORMAL de quem aceita a senha forte sugerida — o valor
       entra no campo sem disparar evento nenhum. Os campos ficam cheios e a
       tela continua achando que estão vazios. Para sempre.

       Medido no navegador antes de consertar: preenchi o `recS2` com
       `campo.value='...'` e o `recIguais` continuou dizendo "Repita a senha
       para confirmar." com o campo visivelmente preenchido.

       🔑 A CORREÇÃO NÃO É OUVIR MAIS EVENTOS — é PARAR DE DEPENDER DELES.
       Evento é promessa de terceiro; o valor do campo é fato. De 250 em 250
       ms, enquanto a tela estiver aberta, a gente LÊ os dois campos e só
       reavalia se algo mudou. Nenhuma rede, nenhum desenho à toa.

       ⚠️ ELE SE DESLIGA SOZINHO, e isso é de propósito: a condição de parada
       é "o `recBg` saiu do documento", não uma lista de lugares que fecham a
       tela. Hoje são dois (o "Voltar" e o sucesso); o terceiro que alguém
       escrever amanhã nasce coberto. Cronômetro que depende de alguém lembrar
       de desligá-lo é vazamento esperando a data.
       ⚠️ Ele também é a rede de segurança do olho da v1231: quando o olho
       TROCA o campo de lugar, os ouvintes do nó antigo morrem com ele — este
       conferidor lê por id e nem percebe.
       ====================================================================== */
    var _recUltimoLido=null;
    var _recConferidor=setInterval(function(){
      if(!document.getElementById('recBg')){ clearInterval(_recConferidor); return; }
      var a=(($('recS1')||{}).value)||'', c=(($('recS2')||{}).value)||'';
      var agora=a.length+'|'+a+'\u0000'+c;
      if(agora===_recUltimoLido) return;
      _recUltimoLido=agora;
      try{ _recValidar(); }catch(_){}
    }, 250);
    var voltar=$('recVoltar'); if(voltar) voltar.onclick=function(){ clearTimeout(_recSessaoTimer); try{ history.replaceState(null,'',location.pathname+location.search); }catch(_){} ov.remove(); _recAberto=false; _recoveryFlag=false; show('scAuth'); };
    b.onclick=async function(){
      var s1=(($('recS1')||{}).value)||'', s2=(($('recS2')||{}).value)||'', m=$('recMsg');
      if(!_recValidar()) return;
      b.disabled=true; b.setAttribute('aria-busy','true'); b.textContent='Salvando…'; m.className='rec-msg'; m.textContent='';
      try{
        var ses=await supa.auth.getSession(); if(!(ses&&ses.data&&ses.data.session&&ses.data.session.user)) throw new Error('Auth session missing');
        /* getSession confirma que o link foi absorvido pelo navegador; getUser
           revalida o JWT no servidor antes de autorizar a troca sensível. */
        var usr=await supa.auth.getUser(); if(usr&&usr.error) throw usr.error;
        if(!(usr&&usr.data&&usr.data.user)) throw new Error('Auth session missing');
        var up=await supa.auth.updateUser({password:s1});
        if(up&&up.error) throw up.error;
        var outros=!!(($('recSairOutros')||{}).checked), aviso='';
        if(outros){ try{ var so=await supa.auth.signOut({scope:'others'}); if(so&&so.error) aviso=' Não foi possível encerrar os outros acessos.'; }catch(_){ aviso=' Não foi possível encerrar os outros acessos.'; } }
        m.className='rec-msg ok'; m.textContent='Senha alterada com sucesso!'+aviso+' Entrando…';
        /* v881 — era `location.pathname` e levava o `?app=` junto. O que
           precisa sumir aqui é o HASH do Supabase (#access_token…&type=
           recovery); a query não tem nada a ver com a troca de senha. */
        try{ history.replaceState(null,'',location.pathname+location.search); }catch(_){}
        setTimeout(async function(){
          try{ var s=await supa.auth.getSession(); var sess=s&&s.data&&s.data.session;
            if(sess){ token=sess.access_token; meuId=(sess.user&&sess.user.id)||null; meuEmail=(sess.user&&sess.user.email)||null; meuMeta=(sess.user&&sess.user.user_metadata)||{}; meuNome=meuMeta.nome||''; meuFoto=meuMeta.foto||''; ov.remove(); await entrar(); return; }
          }catch(_){}
          ov.remove(); show('scAuth');
        }, 900);
      }catch(e){
        b.removeAttribute('aria-busy'); b.textContent='Salvar nova senha'; m.className='rec-msg err'; m.textContent=_recErroTexto(e);
        try{ window.mevErro&&window.mevErro(e,'redefinir-senha'); }catch(_){}
        if(/session|expired|invalid|token|otp/i.test(String((e&&(e.code||e.message))||''))){ _recSessaoOk=false; if(voltar) voltar.hidden=false; }
        _recValidar();
      }
    };
    olhoSenhaLigar(ov);
    var _re=$('recTentarDeNovo');
    if(_re) _re.onclick=function(){
      _re.hidden=true; var _vt=$('recVoltar'); if(_vt) _vt.hidden=true;
      var st=$('recLinkStatus'); if(st){ st.className='rec-link-status'; st.textContent='Validando o link seguro…'; }
      _recSessaoOk=false; _recSessaoTentativa=0; _recAbertoEm=Date.now();
      _recCodigoTentou=false; _recCodigoErro=null; _recCodigoMudo=false;
      clearTimeout(_recSessaoTimer); setTimeout(_recSessaoChecar,0);
    };
    _recValidar(); _recSessaoTentativa=0; _recAbertoEm=Date.now(); setTimeout(_recSessaoChecar,0);
    try{ _recVersaoConferir(); }catch(_){}
    try{ $('recS1').focus(); }catch(_){}
  }
  /* ===== INSTALAR O APP (atalho no celular / PC) ===== */
  var _deferredInstall=null;
  try{ window.addEventListener('beforeinstallprompt', function(e){ e.preventDefault(); _deferredInstall=e; }); }catch(_){}
  try{ window.addEventListener('appinstalled', function(){ _deferredInstall=null; }); }catch(_){}
  function _instalOverlay(titulo,html){
    var bg=document.createElement('div'); bg.style.cssText='position:fixed;inset:0;background:rgba(2,20,60,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:22px';
    bg.innerHTML='<div style="background:#fff;border-radius:18px;max-width:400px;width:100%;padding:20px 18px;box-shadow:0 18px 50px rgba(0,0,0,.3)"><div style="font-size:16px;font-weight:900;color:#001e50;margin-bottom:8px">'+titulo+'</div><div style="font-size:13.5px;color:#334155;line-height:1.6">'+html+'</div><button type="button" style="margin-top:16px;width:100%;background:#001e50;color:#fff;border:none;border-radius:11px;padding:13px;font-size:14px;font-weight:800;font-family:inherit;cursor:pointer">Entendi</button></div>';
    bg.onclick=function(e){ if(e.target===bg||e.target.tagName==='BUTTON') bg.remove(); };
    document.body.appendChild(bg);
  }
  async function instalarAppAbrir(){
    var ua=navigator.userAgent||'';
    var isIOS=/iphone|ipad|ipod/i.test(ua);
    if(_deferredInstall){ try{ _deferredInstall.prompt(); await _deferredInstall.userChoice; }catch(_){} _deferredInstall=null; return; }
    if(isIOS){ _instalOverlay('Adicionar à Tela de Início',
        '<div style="display:flex;flex-direction:column;gap:13px">'+
          '<div style="display:flex;align-items:flex-start;gap:11px"><span class="instal-n">1</span><div>Toque no botão <b>Compartilhar</b> na barra de baixo do Safari:'+
            '<div style="margin-top:7px;display:inline-flex;align-items:center;gap:7px;background:#eef4ff;border:1px solid #dbe7fa;border-radius:10px;padding:6px 11px"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#0a7aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M8 7l4-4 4 4"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/></svg><span style="font-weight:800;color:#0a4da6;font-size:12.5px">Compartilhar</span></div></div></div>'+
          '<div style="display:flex;align-items:flex-start;gap:11px"><span class="instal-n">2</span><div>Role a lista pra baixo e toque em <b>Adicionar à Tela de Início</b> '+
            '<svg viewBox="0 0 24 24" width="18" height="18" style="vertical-align:middle" fill="none" stroke="#0a4da6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/></svg></div></div>'+
          '<div style="display:flex;align-items:flex-start;gap:11px"><span class="instal-n">3</span><div>Toque em <b>Adicionar</b> no canto de cima à direita.</div></div>'+
        '</div>'+
        '<div style="margin-top:13px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:9px 12px;font-size:12.5px;color:#15803d;font-weight:700">Pronto! O MEV Veículos vira um ícone na sua tela, igual a um app. 🎉</div>'); return; }
    _instalOverlay('Instalar o app','<b>No PC (Chrome ou Edge):</b> clique no ícone de instalar ⤓ na barra de endereço, ou no menu ⋮ → <b>“Instalar MEV Veículos”</b>.<br><br><b>No Android (Chrome):</b> menu ⋮ → <b>“Instalar app”</b> / “Adicionar à tela inicial”.<br><br><b>No iPhone:</b> use o Safari → Compartilhar → “Adicionar à Tela de Início”.');
  }
  (function(){
    var btn=$('btnInstalar'); if(!btn) return;
    btn.onclick=instalarAppAbrir;
  })();
  $('btnSair').onclick=function(){ _hardLogout(); location.reload(); };

  /* ---------- PACOTES ---------- */
  var _bc0=$('btnComprar'); if(_bc0) _bc0.onclick=abrirPacotes;
  $('fecharPac').onclick=function(){ $('modalPac').classList.remove('on'); };
  function abrirPacotes(){
    /* ======================================================================
       🔴🔴 v881 — DENTRO DO APP DE LOJA NÃO EXISTE TELA DE COMPRA.
       ----------------------------------------------------------------------
       A TRAVA MORA AQUI, E NÃO NAS CHAMADAS. Contei no `app.js`: esta função
       é chamada de 22 lugares, em 11 arquivos, e quase todas são o mesmo
       caso — `if(d && d.sem_saldo){ … abrirPacotes(); return; }`. Ou seja:
       ACABOU O SALDO E A TELA DE COMPRAR ABRE SOZINHA. Era exatamente isso
       que a Google veria dentro do app da Play.
       Espalhar `if(ehAppDeLoja())` nas 22 seria 22 cópias — e a 23ª porta,
       que alguém abre amanhã, nasceria desprotegida. Aqui, ela nasce certa.
       📌 Mesma lição da v551 (a regra mora em quem desenha) e da v880 (a
       trava mora no montador).

       🔴 E NÃO PODE VIRAR BECO SEM SAÍDA. Se a tela simplesmente sumisse, o
       cliente tocaria em "consultar" e NADA aconteceria — o pior defeito que
       existe, e o mesmo que a v569 consertou nos botões da notificação. Por
       isso ela não some: ela vira um RECADO, na mesma caixa, com o Fechar
       de sempre.

       ⚠️ RECADO, NÃO BOTÃO: texto sem link clicável de pagamento. É essa a
       linha que separa "informar" de "desviar a compra" na régua das lojas. */
    if(typeof ehAppDeLoja==='function' && ehAppDeLoja()){ _pacRecadoDaLoja(); return; }
    /* v1186 — o modal trata somente de adicionar saldo. A cota gratuita e a
       tabela de consumo não competem mais com a escolha da recarga. */
    /* Permite abrir o modal enquanto o saldo ainda está carregando. A resposta
       do servidor substitui estes valores na primeira atualização da conta. */
    /* v285 — ESTA LISTA ESTAVA MENTINDO ENQUANTO A REDE NÃO RESPONDIA.
       Ela é só o que aparece nos primeiros instantes, antes da resposta do
       servidor chegar — mas os números não batiam com os de verdade
       (netlify/functions/creditos.js):
           p2  R$ 49,90 / 26   →  o certo é R$ 47,90 / 25
           p3  R$ 99,90 / 53   →  o certo é R$ 92,90 / 50
           p4  R$ 149,90 / 80  →  o certo é R$ 149,90 / 100
       Ou seja: numa internet lenta o lojista via um preço e uma quantidade,
       e um segundo depois eles mudavam sozinhos na frente dele. No p4 era
       pior ao contrário — anunciava 80 tokens quando ele leva 100.
       Agora são idênticos aos do servidor. Se um dia você mudar o preço lá,
       mude aqui também. */
    /* ⚠️ v534 — A ESCADA VIROU TRÊS DEGRAUS. Este é o ESPELHO de emergência
       (só aparece se o servidor não responder); a fonte é o
       netlify/functions/_pacotes.js. Descontos de 4% e 7% não movem ninguém
       — os dois pacotes do meio saíram e os que ficaram valem 15% e 25%.
       ⚠️ IDS NOVOS (p5/p6) de propósito: id aposentado nunca é reaproveitado,
       porque é o id que vira cobrança. Ver a nota longa no _pacotes.js.
       ⚠️ Aqui só entram os que estão À VENDA — o servidor já manda filtrado.
       ⚠️ v539 — OS TAMANHOS VIRARAM 30/60/120 e o PREÇO subiu junto. Sem
       subir, o pacote pequeno viraria o mais barato por token (R$1,00) e o
       Pro morreria. IDS NOVOS OUTRA VEZ (p7/p8): o p1 tinha 2 checkouts
       abertos no dia da mudança — editá-lo cobraria o dobro do prometido.
       🔴 O p6 é o único intacto, e é ele que segura o piso de R$1,50 em que
       a escada dos PLANOS (149/249/349/449) é calculada. */
    var listaPacotes=pacotes.length?pacotes:[
      {id:'recarga4990',nome:'Recarga de saldo',valor:49.90,creditos:26.263157894736842},
      {id:'recarga9990',nome:'Recarga de saldo',valor:99.90,creditos:52.578947368421055},
      {id:'recarga29990',nome:'Recarga de saldo',valor:299.90,creditos:157.8421052631579},
      {id:'recarga49990',nome:'Recarga de saldo',valor:499.90,creditos:263.10526315789474}
    ];
    var base = Number(listaPacotes[0].valor)/(Number(listaPacotes[0].creditos)||1);
    /* ===== v1189 — UM SELO SÓ, E NO PACOTE CERTO ======================
       O destaque era o SEGUNDO pacote (i===1), que anuncia "Economize 4%" —
       o menor desconto da tela no lugar mais nobre dela. Agora ele é o
       PENÚLTIMO: o degrau que puxa o ticket sem assustar quem está
       começando. O antigo selo "MELHOR PREÇO" do último foi removido: as
       recargas têm o mesmo custo por real de saldo e o selo sugeria uma
       vantagem que não existe.
       O penúltimo (e não "o de índice 2") pra que a conta continue certa se
       um dia o servidor mandar 3 ou 5 pacotes — com 3, o destaque cai no do
       meio, e os dois selos nunca caem no mesmo card. */
    var iDest = Math.max(0, listaPacotes.length - 2);
    $('listaPac').innerHTML = listaPacotes.map(function(p,i){
      var unit = Number(p.valor)/(Number(p.creditos)||1);
      var econ = Math.round((1 - unit/base)*100);
      /* v430: o selo de economia é SEMPRE desenhado, mesmo com 0% —
         invisível, mas ocupando o lugar. Sem isso o "Comprar" do primeiro
         card sobe e nenhum card fica com a mesma cara do outro. */
      var econHtml = '<div class="econ'+(econ>0?'':' vazio')+'">'+(econ>0?('Economize '+econ+'%'):'&nbsp;')+'</div>';
      var pop  = (listaPacotes.length>1 && i===iDest) ? '<span class="tagpop">MAIS VENDIDO</span>' : '';
      return '<button class="pac'+(i===iDest?' dest':'')+'" data-p="'+p.id+'">'+
        '<div class="pac-l"><div class="nome">'+esc(p.nome)+pop+'</div>'+
        '<div class="portok">Saldo válido por 30 dias</div></div>'+
        '<div class="valbox"><div class="val">'+brl(p.valor)+'</div>'+econHtml+'<div class="pac-cta">Comprar ›</div></div>'+
        '</button>';
    }).join('');
    Array.prototype.forEach.call($('listaPac').querySelectorAll('.pac'), function(el){
      el.onclick=function(){ comprar(el.getAttribute('data-p')); };
    });
    /* v1185 — esta caixa é exclusivamente de recarga. Assinatura não é mais
       oferecida no MEV Consultas; planos de loja continuam na área própria. */
    var pacPlanos=$('pacPlanos'); if(pacPlanos){ pacPlanos.innerHTML=''; pacPlanos.style.display='none'; }
    $('modalPac').classList.add('on');
  }
  /* v881 — o recado que ocupa o lugar da lista de pacotes dentro do app de
     loja. Reaproveita a MESMA caixa (`modalPac`): um desenho novo seria mais
     uma tela pra esquecer o Fechar e o foco. O texto vem do `00-edicoes.js`
     (`edLojaRecado`), que é onde ele muda quando a oferta mudar. */
  function _pacRecadoDaLoja(){
    var r={titulo:'Suas consultas grátis do mês acabaram',
           linha1:'Para continuar consultando hoje, adicione saldo em mevveiculos.com.br pelo navegador.',
           linha2:'Depois é só voltar aqui — o saldo aparece sozinho.'};
    try{ if(typeof edLojaRecado==='function'){ var x=edLojaRecado(); if(x&&x.titulo) r=x; } }catch(_){}
    var t=$('pacTitulo'); if(t) t.textContent=r.titulo;
    var sub=t&&t.parentNode?t.parentNode.querySelector('p'):null; if(sub) sub.textContent='';
    var resumo=$('pacResumo'); if(resumo) resumo.textContent='';
    var lista=$('listaPac');
    if(lista) lista.innerHTML='<div class="pac-loja">'
      +'<b>'+esc(r.titulo)+'</b>'
      +'<p>'+esc(r.linha1).replace('mevveiculos.com.br','<span class="pac-loja-site">mevveiculos.com.br</span>')+'</p>'
      +'<p>'+esc(r.linha2)+'</p></div>';
    /* a linha "Pagamento seguro via PIX" fala de uma compra que não existe aqui */
    try{ var seg=document.querySelector('#modalPac .pac-seguro'); if(seg) seg.style.display='none'; }catch(_){}
    /* ⚠️ e o `_pacPlanos()` NÃO é chamado: ele desenha a oferta de assinatura */
    $('modalPac').classList.add('on');
  }
  /* ===== v451 — QUEM AINDA NÃO TEM PLANO VÊ OS PLANOS AQUI EMBAIXO =====
     Quem chega na tela de recarga está com a carteira vazia — é o único
     momento em que ele PENSA em token por vontade própria. Comprar avulso
     resolve o dia; o plano resolve o mês. Então logo abaixo dos pacotes
     entram o Vendedor e o Lojista, e o toque leva direto pro pagamento do
     plano (o mesmo `assinaturaPagar` do botão da tela de planos).
     ⚠️ Quem JÁ tem plano ativo não vê nada disso — e, enquanto a assinatura
     não tiver carregado, também não: mostrar oferta de plano pra quem já
     paga é pior do que não mostrar nada. Por isso o bloco só nasce depois
     que o /api/cobranca respondeu. */
  function _pacPlanos(){
    var lista=$('listaPac'); if(!lista||!lista.parentNode) return;
    var box=$('pacPlanos');
    if(!box){
      box=document.createElement('div'); box.id='pacPlanos';
      lista.parentNode.insertBefore(box, lista.nextSibling);
    }
    box.innerHTML=''; box.style.display='none';
    if(typeof _assinatura==='undefined' || !_assinatura){
      /* ainda não sei se ele tem plano — pergunto e volto aqui */
      if(typeof assinaturaCarregar==='function'){
        try{ assinaturaCarregar().then(function(){ _pacPlanosDesenha(); }); }catch(_){}
      }
      return;
    }
    _pacPlanosDesenha();
  }
  function _pacPlanosDesenha(){
    var box=$('pacPlanos'); if(!box) return;
    var temPlano=false;
    try{ temPlano=!!(typeof pagPlanoDaAssinatura==='function' && pagPlanoDaAssinatura()); }catch(_){}
    /* 🔴 v533 — ERA `_PAG_PLANOS.slice(0,2)`, ou seja, POR ÍNDICE.
       A intenção sempre foi "os dois mais baratos" (a lista-fonte é ordenada
       do mais barato pro mais caro). Só que índice em tabela de preço é a
       armadilha que a v504 já documentou uma vez: tirar o Vendedor Parceiro,
       que era o PRIMEIRO da lista, mudaria em silêncio quais dois planos
       aparecem aqui — e neste caso até daria o resultado certo por sorte, o
       que é o pior tipo de acerto, porque na próxima não daria.
       Agora a regra está escrita: à venda, ordenados pelo preço, os dois
       primeiros. Some ou entra plano, isto continua certo sozinho. */
    /* 🔴 v534 — AGORA SÃO OS DOIS PLANOS DE LOJA, não "os dois mais baratos".
       Esta listinha aparece pra quem está COMPRANDO TOKEN — ou seja, pra
       quem já usa o app pra valer. Com a escada nova, "os dois mais baratos"
       passaram a ser o Vendedor Parceiro (R$149) e o Vendedor (R$249): os
       dois planos de QUEM NÃO TEM LOJA. Oferecer isso aqui desfaz, por uma
       porta lateral, exatamente o que a vitrine em dois andares foi feita
       pra evitar — o Angelo pediu pra não queimar o plano Lojista, e esta
       tela estava fazendo isso sozinha.
       ⚠️ Continua ordenado por PREÇO, e nada por índice (a armadilha da
       v504/v533): some ou entra plano de loja, isto segue certo. */
    var planos=[];
    try{
      if(typeof _PAG_PLANOS!=='undefined' && _PAG_PLANOS){
        var _soConsultas=false; try{ _soConsultas=typeof edicaoAtual==='function' && edicaoAtual()==='consultas'; }catch(_){}
        planos=_PAG_PLANOS
          .filter(function(p){
            if(!p || p.aVenda===false) return false;
            return _soConsultas ? p.publico==='consultas' : (p.publico!=='vendedor' && p.publico!=='consultas');
          })
          .slice().sort(function(a,b){ return (Number(a.valor)||0)-(Number(b.valor)||0); })
          .slice(0,2);
      }
    }catch(_){ planos=[]; }
    if(temPlano || !planos.length){ box.innerHTML=''; box.style.display='none'; return; }
    box.style.display='';
    box.innerHTML='<div style="font-size:11px;font-weight:800;color:#94a3b8;text-transform:uppercase;letter-spacing:.4px;margin:16px 2px 7px">Ou receba saldo todo mês</div>'+
      planos.map(function(p){
        var us=(p.usuarios==null) ? 'usuários ilimitados'
             : (p.usuarios===1 ? '1 usuário' : ('até '+p.usuarios+' usuários'));
        return '<button type="button" class="pac-plano" data-plano="'+esc(p.id)+'" style="display:flex;width:100%;align-items:center;justify-content:space-between;gap:10px;text-align:left;background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:11px 13px;margin-bottom:8px;cursor:pointer">'+
          '<span style="flex:1;min-width:0">'+
            '<span style="display:block;font-size:14px;font-weight:800;color:#0f172a">'+esc(p.nome)+'</span>'+
            '<span style="display:block;font-size:11.5px;color:#64748b;margin-top:1px">'+esc(precoReal(p.tokens_mensais)+' de saldo por mês · '+us)+'</span>'+
          '</span>'+
          '<span style="flex:none;text-align:right">'+
            '<span style="display:block;font-size:15px;font-weight:900;color:#0a4da6">'+brl(p.valor)+'<small style="font-weight:700;color:#94a3b8">/mês</small></span>'+
            '<span style="display:block;font-size:11.5px;font-weight:800;color:#0a4da6;margin-top:1px">Assinar ›</span>'+
          '</span>'+
        '</button>';
      }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.pac-plano'), function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-plano');
        var m=$('modalPac'); if(m) m.classList.remove('on');
        if(typeof assinaturaPagar==='function') assinaturaPagar(id);
      };
    });
  }
  /* troca frases numa caixa com fade — usado nas animações de compra/pagamento */
  /* v263 (BUG): as frases apareciam UMA POR CIMA DA OUTRA.
     Causa: mais de um rotador podia acabar escrevendo no MESMO elemento
     (#pgFrase é usado pela compra de tokens, pelo repasse e pelos parceiros, e
     os três guardam o "parar" na mesma variável _pgFraseStop — quem chegava
     depois apagava o controle do anterior, que continuava rodando). Dois
     rotadores fora de compasso trocam o texto no meio da transição de opacidade
     e o iPhone chega a desenhar as duas frases sobrepostas.
     Conserto: o rotador passa a ser DONO do elemento — ao começar, ele para
     qualquer rotador que já estivesse naquele mesmo elemento. */
  /* ==========================================================================
     v634 — O RODÍZIO DE FRASES QUE SE SOBREPUNHA
     ==========================================================================
     Angelo, no iPhone, com o PIX de R$ 59,90 na tela: duas frases pintadas UMA
     POR CIMA DA OUTRA, embaixo do "Aguardando pagamento…".

     🔴 MEDI ANTES DE MEXER (regra da casa: pedido visual, teste que mede
     retângulo). Em tela limpa nada vazava — o que provou que o defeito não
     estava numa frase, e sim na TROCA. Três causas somadas:

       1. a troca era `setTimeout(250)` CEGO. Ele não esperava a transição de
          opacidade acabar de verdade; num aparelho ocupado (o iPhone dele
          estava com a compra rodando), o texto novo entrava enquanto o velho
          ainda estava sendo pintado;
       2. a caixa tinha ALTURA FIXA de 34px e `overflow:visible`. Frase de duas
          linhas transbordava por cima e por baixo, invadindo os vizinhos;
       3. `comprarPix` pode rodar de novo sem que o rodízio anterior tenha
          parado — e dois rodízios no mesmo elemento escrevem em tempos
          diferentes.

     O CONSERTO ATACA OS TRÊS, e o principal é o nº 1: agora o texto só muda
     quando a opacidade JÁ chegou a zero (transitionend de verdade, com o
     tempo como rede de segurança). Enquanto está sumindo, ninguém escreve.

     ⚠️ E o rodízio agora se anuncia no próprio elemento (`data-frase-on`), pra
     um segundo rodízio no mesmo lugar matar o primeiro mesmo que a referência
     de função tenha se perdido. */
  function fraseRotator(el, frases, ms){
    if(!el||!frases||!frases.length) return function(){};
    /* mata qualquer rodízio anterior NESTE elemento — pelos dois caminhos */
    try{ if(typeof el._fraseStop==='function') el._fraseStop(); }catch(_){}
    try{ el.removeAttribute('data-frase-on'); }catch(_){}
    var i=0, vivo=true, trocando=false;
    el.textContent=frases[0];
    el.style.opacity='1';
    try{ el.setAttribute('data-frase-on','1'); }catch(_){}
    function troca(){
      if(!vivo || trocando) return;
      if(frases.length<2) return;
      trocando=true;
      i=(i+1)%frases.length;
      var pronto=false;
      var escreve=function(){
        if(pronto) return; pronto=true;
        try{ el.removeEventListener('transitionend', escreve); }catch(_){}
        if(!vivo){ trocando=false; return; }
        /* 🔴 só escreve com a opacidade JÁ em zero: é isto que impede as
           duas frases de existirem na tela ao mesmo tempo */
        el.textContent=frases[i];
        el.style.opacity='1';
        trocando=false;
      };
      try{ el.addEventListener('transitionend', escreve); }catch(_){}
      el.style.opacity='0';
      /* rede de segurança: se o transitionend não vier (aba em segundo plano,
         `prefers-reduced-motion`, transição removida pelo tema), o tempo
         resolve. Nunca ficar preso com a frase invisível. */
      setTimeout(escreve, 320);
    }
    var t=setInterval(troca, ms||2300);
    var parar=function(){
      vivo=false; clearInterval(t);
      try{ el.removeAttribute('data-frase-on'); }catch(_){}
      try{ el.style.opacity='1'; }catch(_){}
      if(el._fraseStop===parar){ try{ el._fraseStop=null; }catch(_){} }
    };
    try{ el._fraseStop=parar; }catch(_){}
    return parar;
  }
  /* overlay "Gerando seu PIX" com frases de vantagem enquanto o PIX é criado */
  function pixPreparandoAbrir(){
    var ov=document.createElement('div'); ov.className='modal-bg on'; ov.style.zIndex='1001';
    ov.innerHTML='<div class="modal" style="max-width:330px"><div class="pix-prep">'+
      '<div class="pix-prep-spin"></div>'+
      '<div class="pix-prep-t">Gerando seu PIX…</div>'+
      '<div class="pix-prep-f" id="pixPrepFrase"></div></div></div>';
    document.body.appendChild(ov);
    var frases=['🔒 Pagamento 100% seguro via PIX','⚡ Seu saldo entra após o pagamento','♾️ Sem mensalidade — você paga só o que usa','📄 Relatórios completos, ficha técnica e documentos','🚗 Mais agilidade e produtividade no seu dia a dia'];
    var stop=fraseRotator(ov.querySelector('#pixPrepFrase'),frases,2000);
    return function(){ try{stop();}catch(_){} try{ov.remove();}catch(_){} };
  }
  /* ===== v305 (pedido) — A INFINITEPAY SAIU ==============================
     "remove checkout infinitepay".

     Com um caminho só de pagamento, a pergunta "Como você quer pagar?"
     perdeu a razão de existir — ela só fazia sentido pra escolher ENTRE
     dois. Voltou a ser um toque: "Comprar tokens" abre o PIX direto.

     O PIX é o caminho por onde entrou dinheiro de verdade (30/07, R$ 29,90
     aprovado, 15 tokens creditados), e a própria fatura dele aceita cartão
     lá dentro. Nada se perdeu.

     A função comprarInfinitePay continua logo abaixo, sem ninguém chamando.
     Deixei de propósito: voltar atrás é trocar esta linha, e apagar código
     que funciona pra depois reescrever é como se perde o que já foi
     testado. Quem desligou a porta de verdade foi o servidor
     (infinitepay-criar), que agora recusa. */
  function comprar(pid){ comprarPix(pid); }

  /* ===== v300 — PAGAR PELA INFINITEPAY =====
     O app manda SÓ o id do pacote. Preço e quantidade de tokens quem decide é
     o servidor, pela lista dele — se o app mandasse o valor, bastaria trocar
     o número no aparelho pra comprar 100 tokens por um real. */
  async function comprarInfinitePay(pid){
    $('modalPac').classList.remove('on');
    var fechaPrep=pixPreparandoAbrir();
    var d; try{ d=await api('/api/infinitepay-criar',{pacote:pid}); }catch(_){ d=null; }
    fechaPrep();
    if(!d||!d.ok||!d.url){ alert((d&&d.erro)||'Não consegui abrir o pagamento. Tente de novo.'); return; }
    /* guarda o pedido: se a pessoa voltar pelo botão do navegador em vez do
       "Continuar" do checkout, ainda dá pra conferir o pagamento. */
    try{ localStorage.setItem('mev_pedido_ip', d.order_nsu); }catch(_){}
    location.href = d.url;
  }
  /* ===== v300 — A VOLTA DO CHECKOUT =====
     A InfinitePay devolve a pessoa pro app com order_nsu e transaction_nsu no
     endereço. Isso é o PLANO B do aviso automático: se o webhook se perder, o
     lojista pagou e ficaria sem os tokens.

     NÃO É UM CAMINHO MAIS FRACO: manda pro MESMO endereço que a InfinitePay
     chama, e lá as cinco travas valem igual — inclusive a de perguntar pra
     InfinitePay se aquele pagamento existe mesmo. O app aqui não credita
     nada; ele só bate na campainha. */
  async function pagamentoDeVolta(){
    var q;
    try{ q=new URLSearchParams(location.search); }catch(_){ return; }
    var voltaMp=q.get('pagamento')||'';
    var order=q.get('order_nsu')||((voltaMp==='sucesso'||voltaMp==='pendente'||voltaMp==='falhou')?'':voltaMp);
    var tx=q.get('transaction_nsu')||'';
    if(!order) return;
    /* tira do endereço ANTES de conferir: recarregar a página não pode virar
       uma segunda tentativa infinita. */
    try{
      var limpo=location.search.replace(/([?&])(pagamento|order_nsu|transaction_nsu|slug|receipt_url|capture_method)=[^&]*/gi,'$1')
        .replace(/&&+/g,'&').replace(/[?&]+$/,'').replace(/\?&/,'?');
      history.replaceState(null,'',location.pathname+limpo);
    }catch(_){}
    try{ localStorage.removeItem('mev_pedido_ip'); }catch(_){}
    if(!tx){ toast('Pagamento em processamento. Assim que aprovar, o saldo entra.'); return; }
    try{
      await fetch('/api/infinitepay-webhook',{ method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ order_nsu:order, transaction_nsu:tx, slug:q.get('slug')||'' }) });
    }catch(_){}
    try{ await carregarSaldo(); }catch(_){}
    toast('Pagamento recebido — seu saldo já está na conta.');
  }
  async function comprarPix(pid){
    $('modalPac').classList.remove('on');
    var fechaPrep=pixPreparandoAbrir();
    var d; try{ d=await api('/api/creditos',{acao:'comprar',pacote:pid}); }catch(_){ d=null; }
    fechaPrep();
    if(!d||!d.ok){ alert((d&&d.erro)||'Não consegui gerar o PIX. Tente de novo.'); return; }
    try{ localStorage.setItem('mev_pagamento_pendente',JSON.stringify({id:d.payment_id,valor:Number(d.valor||0),criado_em:Date.now()})); }catch(_){}
    /* reseta o modal pro estado normal (caso a última compra tenha ficado na tela de sucesso) */
    var _pb=$('pixBody'), _ps=$('pixSucesso'); if(_pb) _pb.style.display='block'; if(_ps){ _ps.style.display='none'; _ps.innerHTML=''; }
    $('pixValor').textContent=brl(d.valor); $('pixCred').textContent=brl(d.valor)+' de saldo';
    /* ===== v263 (BUG): O QR VINHA SEMPRE VAZIO =====
       O servidor só busca o PIX no Asaas quando é avisado, e o pedido de compra
       não avisava — então o app recebia a cobrança sem QR e sem copia-e-cola, e
       mostrava um quadrado vazio com um "—" embaixo. Consertado no servidor.
       Aqui do lado do app fica a rede de segurança: o Asaas leva um instante
       pra gerar o QR, então o modal abre na hora dizendo "gerando" e o app
       pergunta de novo por alguns segundos. Se mesmo assim não vier, aparece o
       botão do link da fatura — nele dá pra pagar por PIX ou cartão. */
    var _pixCopiarHtml=function(feito){
      return feito
        ?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg><span>Copiado</span>'
        :'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3"/></svg><span>Copiar código PIX</span>';
    };
    var _pixMostra=function(qr, cod){
      var _qi=$('qrImg'); if(_qi){ _qi.src=qr?('data:image/png;base64,'+qr):''; _qi.style.display=qr?'':'none'; }
      $('copiaCola').textContent=cod||'Gerando o código do PIX…';
      var b=$('btnCopiar'); if(b){ b.disabled=!cod; b.style.opacity=cod?'':'0.5'; b.classList.add('pix-copiar'); b.innerHTML=_pixCopiarHtml(false);
        b.onclick=function(){ if(navigator.clipboard&&cod){ navigator.clipboard.writeText(cod).then(function(){ b.innerHTML=_pixCopiarHtml(true); setTimeout(function(){ b.innerHTML=_pixCopiarHtml(false); },1500); }); } }; }
    };
    var _linkFatura=function(){
      if(!d.link_pagamento) return;
      var sp=$('statusPg'); if(!sp) return;
      sp.innerHTML='<span style="color:#b45309;font-weight:800">O QR demorou pra ficar pronto.</span>'+
        '<a href="'+d.link_pagamento+'" target="_blank" rel="noopener" class="btn btn-azul" style="margin-top:8px;padding:11px 16px;text-decoration:none;display:inline-block">Abrir a fatura pra pagar ›</a>'+
        '<span style="font-size:11.5px;color:#64748b;margin-top:6px">Na fatura dá pra pagar por PIX ou cartão. A cobrança é a mesma.</span>';
    };
    _pixMostra(d.qr_code_base64||'', d.qr_code||'');
    /* v634 — a espera ganhou desenho: três pontinhos que pulsam em vez do
       aro girando sozinho. Aro girando diz "carregando"; pontinho pulsando
       diz "estou aqui esperando você" — que é o que está acontecendo. */
    $('statusPg').innerHTML='<div class="pg-row"><span class="pg-dots" aria-hidden="true"><i></i><i></i><i></i></span><span>Aguardando pagamento…</span></div><div class="pg-frase" id="pgFrase"></div>';
    $('modalPix').classList.add('on');
    pollPagamento(d.payment_id);
    /* QR ainda não veio? pergunta de novo — 4 tentativas, de 1,5 em 1,5s */
    if(!(d.qr_code_base64||d.qr_code)){
      (function(){
        var tentou=0;
        (function denovo(){
          if(!$('modalPix').classList.contains('on')) return;      /* fechou: para */
          if(tentou>=4){
            try{ if(window.mevErro) window.mevErro('pix-sem-codigo', JSON.stringify({pacote:pid, payment_id:d.payment_id||'', valor:d.valor||''})); }catch(_){}
            if(d.link_pagamento) _linkFatura();
            else $('copiaCola').textContent='Não recebi o código do PIX desta cobrança. Feche e tente de novo.';
            return;
          }
          tentou++;
          setTimeout(async function(){
            var p; try{ p=await api('/api/creditos',{acao:'pix',payment_id:d.payment_id}); }catch(_){ p=null; }
            if(p&&p.ok&&(p.qr_code||p.qr_code_base64)){
              d.qr_code=p.qr_code||''; d.qr_code_base64=p.qr_code_base64||'';
              _pixMostra(d.qr_code_base64, d.qr_code);
              return;
            }
            denovo();
          }, 1500);
        })();
      })();
    }
  }
  var _pgFraseStop=null;
  function pixFecharTudo(){ $('modalPix').classList.remove('on'); if(pollTimer){clearInterval(pollTimer);pollTimer=null;} if(_pgFraseStop){ try{_pgFraseStop();}catch(_){} _pgFraseStop=null; } }
  $('fecharPix').onclick=pixFecharTudo;
  var _fpt=$('fecharPixTopo'); if(_fpt) _fpt.onclick=pixFecharTudo;
  /* animação de sucesso: check verde + frases + saldo, dentro do próprio modal */
  function pixSucessoAnim(saldoNovo,paymentId,valorPago){
    if(_pgFraseStop){ try{_pgFraseStop();}catch(_){} _pgFraseStop=null; }
    var pb=$('pixBody'), ps=$('pixSucesso'); if(pb) pb.style.display='none'; if(!ps) return;
    ps.style.display='block';
    ps.innerHTML='<div class="pix-ok">'+
      '<div class="pix-ok-check"><svg viewBox="0 0 52 52"><circle class="pk-c" cx="26" cy="26" r="24"/><path class="pk-p" d="M15 27l7 7 15-15"/></svg></div>'+
      '<div class="pix-ok-t">Pagamento confirmado!</div>'+
      '<div class="pix-ok-s" id="pixOkFrase">Seu saldo já está disponível. Aproveite! 🚀</div>'+
      '<div class="pix-ok-saldo"><span class="pix-ok-entrada" id="pixOkEntrada">+ R$ 0,00</span><span class="pix-ok-total">Saldo atual: '+precoReal(saldoNovo)+'</span></div>'+
      '<form class="pix-nf" id="pixNfForm" novalidate>'+
        '<div class="pix-nf-t">Dados para emissão da nota fiscal</div>'+
        '<div class="pix-nf-ajuda">Preencha somente após o pagamento. Usaremos estes dados apenas para emitir a nota desta recarga.</div>'+
        '<label class="pix-nf-campo"><span>Nome completo</span><input class="cad-in" id="pixNfNome" autocomplete="name" maxlength="120" value="'+esc(meuNome||'')+'"></label>'+
        '<div class="pix-nf-grade">'+
          '<label class="pix-nf-campo"><span>CPF</span><input class="cad-in" id="pixNfCpf" inputmode="numeric" autocomplete="off" maxlength="14" placeholder="000.000.000-00"></label>'+
          '<label class="pix-nf-campo"><span>Telefone</span><input class="cad-in" id="pixNfTel" type="tel" inputmode="tel" autocomplete="tel" maxlength="18" placeholder="(51) 99999-9999"></label>'+
        '</div>'+
        '<div class="legal-error pix-nf-erro" id="pixNfErro" role="alert"></div>'+
        '<button class="btn btn-azul" id="pixNfSalvar" type="submit">Enviar dados para a nota fiscal</button>'+
      '</form>'+
      '<button class="btn pix-nf-depois" id="pixOkBtn" type="button">Agora não — começar a usar</button>'+
      '</div>';
    var frases=['Seu saldo já está disponível. Aproveite! 🚀','Já pode fazer suas consultas agora mesmo ✅','Obrigado pela confiança 💙','Bons negócios na concessionária! 🚗'];
    _pgFraseStop=fraseRotator(ps.querySelector('#pixOkFrase'),frases,2600);
    (function animarEntrada(){
      var el=ps.querySelector('#pixOkEntrada'), alvo=Math.max(0,Number(valorPago||0));
      if(!el){ return; }
      if(!alvo || (window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
        el.textContent='+ '+brl(alvo); return;
      }
      var inicio=performance.now(), duracao=700;
      function quadro(agora){
        var p=Math.min(1,(agora-inicio)/duracao), suave=1-Math.pow(1-p,3);
        el.textContent='+ '+brl(alvo*suave);
        if(p<1) requestAnimationFrame(quadro); else el.textContent='+ '+brl(alvo);
      }
      requestAnimationFrame(quadro);
    })();
    var b=ps.querySelector('#pixOkBtn'); if(b) b.onclick=function(){ pixFecharTudo(); try{ voltarHome(); }catch(_){} };
    var cpfIn=ps.querySelector('#pixNfCpf'), telIn=ps.querySelector('#pixNfTel');
    if(cpfIn) cpfIn.oninput=function(){
      var d=this.value.replace(/\D/g,'').slice(0,11);
      this.value=d.replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2');
    };
    if(telIn) telIn.oninput=function(){
      var d=this.value.replace(/\D/g,'').replace(/^55(?=\d{10,11}$)/,'').slice(0,11);
      this.value=d.length>10?d.replace(/(\d{2})(\d{5})(\d{0,4})/,'($1) $2-$3'):
        d.replace(/(\d{2})(\d{4})(\d{0,4})/,'($1) $2-$3');
    };
    var nf=ps.querySelector('#pixNfForm');
    if(nf) nf.onsubmit=async function(ev){
      ev.preventDefault();
      var bt=ps.querySelector('#pixNfSalvar'), er=ps.querySelector('#pixNfErro');
      if(er) er.textContent='';
      if(bt){ bt.disabled=true; bt.textContent='Salvando…'; }
      var r; try{ r=await api('/api/creditos',{acao:'dados_fiscais',payment_id:paymentId,
        nome:(ps.querySelector('#pixNfNome')||{}).value||'',
        cpf:(cpfIn||{}).value||'', telefone:(telIn||{}).value||''}); }catch(_){ r=null; }
      if(!r||!r.ok){ if(er) er.textContent=(r&&r.erro)||'Não foi possível salvar agora. Tente novamente.';
        if(bt){ bt.disabled=false; bt.textContent='Enviar dados para a nota fiscal'; } return; }
      nf.innerHTML='<div class="pix-nf-confirmado"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg><span><b>Dados enviados</b><small>A nota fiscal desta recarga já pode ser emitida.</small></span></div>';
      if(b) b.textContent='Começar a usar ›';
    };
  }
  function pollPagamento(pid){
    if(pollTimer) clearInterval(pollTimer);
    if(_pgFraseStop){ try{_pgFraseStop();}catch(_){} _pgFraseStop=null; }
    /* 🔴 v634 — FRASES CURTAS, DE PROPÓSITO. A antiga "Abra o app do seu
       banco e escaneie o QR (ou cole o código)" tinha 60 caracteres e ocupava
       duas linhas na caixa de 280px — era ela que transbordava. Nenhuma passa
       de ~38 caracteres agora, e o teste MEDE isso a cada versão.
       O conteúdo continua o mesmo, dito em menos palavra. */
    var frases=['O saldo entra automaticamente','Escaneie o QR no app do seu banco','Pagamento seguro pelo Mercado Pago','Pelo PIX, cai em segundos'];
    _pgFraseStop=fraseRotator($('pgFrase'),frases,3000);
    var inicio=Date.now();
    pollTimer=setInterval(async function(){
      if(Date.now()-inicio>12*60*1000){ clearInterval(pollTimer); if(_pgFraseStop){try{_pgFraseStop();}catch(_){}_pgFraseStop=null;} var sp=$('statusPg'); if(sp) sp.innerHTML='<span style="color:#b91c1c">Tempo esgotado. Se você pagou, feche e abra de novo.</span>'; return; }
      var d; try{ d=await api('/api/creditos',{acao:'confirmar',payment_id:pid}); }catch(_){ d=null; }
      if(d&&d.pago&&d.ok){ clearInterval(pollTimer); pollTimer=null; setSaldo(d.saldo); try{localStorage.removeItem('mev_pagamento_pendente');}catch(_){} pixSucessoAnim(d.saldo,pid,Number(d.valor||0)); }
    },4000);
  }

  /* ---------- CONSULTA FIPE (1 crédito) ---------- */
  /* v159: BUSCA AUTOMATICA. Nao existe mais o botao "Buscar placa".
     Assim que a pessoa termina de digitar uma placa VALIDA (ABC1234 ou ABC1D23),
     o app espera meio segundinho (pra ela poder corrigir) e ja consulta sozinho. */
  /* ==========================================================================
     🔴🔴 v883 — QUEM CONSULTA É O DEDO, NÃO O RELÓGIO
     (pedido do Angelo, 04/09: "clica pra buscar — significa que o usuário
      validou a digitação")
     --------------------------------------------------------------------------
     A v159 tirou o botão "Buscar placa" e pôs no lugar um relógio: completou
     uma placa válida, esperava 550ms e consultava SOZINHO. Era rápido, e o
     comentário de lá dizia "pra ela poder corrigir".

     🔴 SÓ QUE MEIO SEGUNDO NÃO É TEMPO DE CONFERIR NADA — e consulta custa
     token. Pior: o `_autoUlt` existia justamente pra impedir que a MESMA placa
     fosse consultada duas vezes pelo relógio, o que já era um remendo em cima
     do problema. Agora a placa completa acende a lupa, e a consulta só sai
     quando o dedo pedir. Clicar é o Angelo dizendo "é esta mesmo".

     ⛳ PRA VOLTAR A v159: o código dela está no changelog da v883. Mas repare
     que voltar significa gastar token sem confirmação.

     ⚠️ O `_autoUlt` FICA. Ele não era só do relógio: o `buscarPlaca()` grava
     nele a última placa consultada, e o atalho do histórico (v712) o usa. */
  var _autoT=null, _autoUlt='';
  (function(){
    var b=$('placaBuscar'); if(!b) return;
    b.onclick=function(){
      if(b.disabled) return;
      /* o blur fecha o teclado do celular ANTES do resultado aparecer — sem
         isso, no iPhone, a resposta nasce atrás do teclado */
      try{ $('placa').blur(); }catch(_){}
      buscarPlaca();
    };
  })();
  /* ===== v585 — A PLACA VOLTA PRO CAMPO QUANDO DÁ ERRO ===================
     (PROJETO-a-placa-fica-no-campo-quando-da-erro)
     A v159 apaga o campo ANTES da consulta (pra animação voltar) — certo
     quando dá certo. Quando dá ERRADO, a placa tem que VOLTAR, senão é
     digitar tudo de novo no pátio com o cliente esperando.
     🔴 A armadilha: o ouvinte de focus abaixo apaga o que estiver no campo.
     Então toda placa que o APP escreve de propósito entra por plDevolver(),
     que levanta a marca _plManter — e o focus respeita a marca UMA vez
     (e a consome, pro comportamento de sempre voltar no toque seguinte).
     🔴🔴 REGRA DO ANGELO, escrita pra ninguém "melhorar" depois:
     **NÃO REPETE SOZINHO.** Consulta custa token, e "falha de conexão" não
     quer dizer que não consultou (pode ter falhado na VOLTA, já cobrada).
     plDevolver() só escreve no campo — .value= não dispara 'input', logo a
     busca automática da v159 NÃO acorda. Quem consulta de novo é o dedo:
     botão "Tentar de novo" ou Enter. Nenhum timer, nenhuma retentativa
     automática de rede — nem aqui, nem no _apiFetch (o retry de 401 de lá é
     reconectar sessão, não reconsultar, e esse fica). */
  var _plManter=false;
  function plDevolver(valor){
    var el=$('placa'); if(!el) return;
    el.value=limpa(String(valor||''));
    placaCampoVisualSync(el);
    _plManter=!!el.value;
  }
  /* 🔴 v882 — A TRAVA DA PLACA NO CAMPO PRINCIPAL.
     Vem DEPOIS do ouvinte da busca automática (v159) de propósito: o
     `beforeinput` já barrou o caractere errado antes de qualquer 'input'
     acontecer, então a v159 nunca vê valor torto. E quando a trava escreve no
     campo (colagem aceita, por exemplo) ela dispara um 'input' de verdade —
     é isso que mantém a busca automática viva. */
  /* v883 — a MESMA trava da v882 agora também acende a lupa. Repare que não
     existe uma segunda regra pra "quando o botão pode buscar": é a mesma
     `valida()` que já decidia se o caractere entra. Um botão que liga por
     conta própria seria a sétima regra de placa do app. */
  try{ placaLigar($('placa'),{ erro:'placaTravaAviso', pronto:function(bom){
    var b=$('placaBuscar'); if(b) b.disabled=!bom;
  }}); }catch(_){}
  $('placa').addEventListener('focus',function(){
    /* v883 — ANTES ISTO APAGAVA QUALQUER COISA QUE ESTIVESSE NO CAMPO.
       Fazia sentido com a busca automática: o campo só tinha placa completa,
       e tocar nele queria dizer "vou digitar outra". Sem o relógio, tocar no
       campo passa a querer dizer, quase sempre, "vou corrigir um caractere" —
       e apagar as seis letras certas junto com a errada seria digitar tudo de
       novo, no pátio, com o cliente esperando.
       Agora só apaga o que era resultado de uma busca ANTERIOR: placa COMPLETA
       e válida. Meia placa é trabalho em andamento e fica onde está. */
    if(_plManter){ _plManter=false; }
    else if(valida(String(this.value||''))){ this.value=''; }
    this.placeholder='ABC1D23';
    placaCampoVisualSync(this);
    var m=$('fipeMsg'); if(m){ m.className='msg'; m.textContent=''; m.style.display=''; }
  });
  /* v1027 — foco normal: tocar na placa somente posiciona o cursor e abre o
     teclado. Sem véu, desfoque, escala, elevação ou bloqueio do restante da
     tela. O foco nativo do próprio input continua indicando onde se digita. */
  $('placa').addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); buscarPlaca(); } });
  /* ---- v157: ANIMACAO DENTRO DO CAMPO DA PLACA ----
     Enquanto o campo esta vazio e sem o cursor dentro, o proprio "placeholder"
     digita e apaga placas de exemplo (com um cursorzinho). Assim que a pessoa
     toca no campo ou digita, a animacao para na hora. Nao gasta token nem rede. */
  var _plcAnimT=null;
  var _PLC_EX=['ABC1D23','ABC1234','BRA2E19','XYZ0A00'];
  var _PLC_IDS=['placa','vpTrocaPlaca'];
  var _plcAnimSt={};
  function _plcAnimPasso(id){
    var el=document.getElementById(id); if(!el) return;
    var st=_plcAnimSt[id]||(_plcAnimSt[id]={xi:0,ci:0,apagando:false,segura:0});
    if(el.value || document.activeElement===el){ if(el.placeholder!=='ABC1D23') el.placeholder='ABC1D23'; placaCampoVisualSync(el); st.ci=0; st.apagando=false; st.segura=0; return; }
    var alvo=_PLC_EX[st.xi%_PLC_EX.length];
    if(st.segura>0){ st.segura--; }
    else if(!st.apagando){ st.ci++; if(st.ci>=alvo.length){ st.ci=alvo.length; st.apagando=true; st.segura=9; } }
    else { st.ci--; if(st.ci<=0){ st.ci=0; st.apagando=false; st.xi++; st.segura=2; } }
    el.placeholder=alvo.slice(0,st.ci)+(st.ci<alvo.length?'\u258c':'');
    placaCampoVisualSync(el);
  }
  function placaAnimIniciar(){
    if(_plcAnimT) return;
    try{ if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(_){}
    /* v159 (LGPD): placas GENERICAS de exemplo. Nunca mostrar placa de cliente. */
    /* v160: a mesma animacao vale pra TODO campo de placa do app (home + troca da
       nova venda). Cada campo tem o seu proprio "estado" (letra atual, etc). */
    _plcAnimT=setInterval(function(){
      _PLC_IDS.forEach(_plcAnimPasso);
    },170);
  }
  try{ placaAnimIniciar(); }catch(_){}
  /* ---- mini-teclado de placa (letras + números no mesmo lugar) ---- */
  var _pkbInput=null, _pkbBuscar=null;
  function _placaKb(){
    var kb=document.getElementById('placaKb'); if(kb) return kb;
    kb=document.createElement('div'); kb.id='placaKb'; kb.className='pkb';
    var rows=['1234567890','ABCDEFGHIJ','KLMNOPQRS'];
    var html='<div class="pkb-top"><b>TECLADO DE PLACA</b><button type="button" id="pkbClose">Fechar ✕</button></div>';
    rows.forEach(function(r){ html+='<div class="pkb-row">'+r.split('').map(function(ch){ return '<button type="button" class="pkb-k" data-k="'+ch+'">'+ch+'</button>'; }).join('')+'</div>'; });
    html+='<div class="pkb-row">'+'TUVWXYZ'.split('').map(function(ch){ return '<button type="button" class="pkb-k" data-k="'+ch+'">'+ch+'</button>'; }).join('')+'<button type="button" class="pkb-k del" data-k="DEL">⌫</button></div>';
    html+='<div class="pkb-row"><button type="button" class="pkb-k ok wide" data-k="OK">🔎 Buscar placa</button></div>';
    kb.innerHTML=html; document.body.appendChild(kb);
    kb.querySelector('#pkbClose').onclick=function(){ kb.classList.remove('on'); if(_pkbInput){ try{ _pkbInput.blur(); }catch(_){} } };
    Array.prototype.forEach.call(kb.querySelectorAll('.pkb-k'),function(b){
      b.addEventListener('mousedown',function(e){ e.preventDefault(); });
      b.addEventListener('touchstart',function(e){ e.preventDefault(); },{passive:false});
      b.onclick=function(){ var k=b.getAttribute('data-k'); if(!_pkbInput) return;
        if(k==='OK'){ kb.classList.remove('on'); if(typeof _pkbBuscar==='function') _pkbBuscar(); return; }
        if(k==='DEL'){ _pkbInput.value=String(_pkbInput.value||'').slice(0,-1); }
        else { if(String(_pkbInput.value||'').replace(/[^A-Za-z0-9]/g,'').length>=7) return; _pkbInput.value=String(_pkbInput.value||'')+k; }
        try{ _pkbInput.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){ try{ var ev=document.createEvent('Event'); ev.initEvent('input',true,true); _pkbInput.dispatchEvent(ev); }catch(__){} }
      };
    });
    return kb;
  }
  function placaKbAttach(input, onBuscar){
    if(!input) return; var kb=_placaKb();
    try{ input.setAttribute('inputmode','none'); }catch(_){}
    input.addEventListener('focus', function(){ _pkbInput=input; _pkbBuscar=onBuscar; kb.classList.add('on'); });
  }
  /* v1368 — teclado personalizado removido; o nativo abre no modo de texto
     porque placa mistura letras e números. A tecla de ação indica Buscar. */
  try{ var _pl=$('placa'); if(_pl){ _pl.setAttribute('inputmode','text'); _pl.setAttribute('enterkeyhint','search'); } }catch(_){}
  var _buscando=false;
  /* v167: NUMERO DE ORDEM DA BUSCA. Cada pesquisa ganha um numero. Quando a
     resposta chega, so pinta a tela se ela ainda for a pesquisa mais nova.
     Assim uma resposta atrasada nunca aparece por cima de uma placa recente. */
  var _buscaSeq=0;
  /* ===== v303 (pedido) — A BUSCA DE PLACA GANHA A ANIMAÇÃO DA FICHA =======
     A consulta de placa era a ÚNICA que ainda mostrava só uma barrinha de
     3px e a palavra "Buscando". Ficha técnica, débitos, leilão, CPF e CNPJ
     já usavam o anel com o carrinho e as frases que trocam. Agora ela usa o
     MESMO — a mesma função (ccLoaderHtml), não uma cópia parecida.

     As frases contam o que o servidor está realmente fazendo nesta consulta:
     acha a placa na base, identifica o veículo, procura o valor na tabela
     FIPE e separa as versões quando há mais de uma. Não invento etapa que
     não existe: barra de progresso que mente é pior que nenhuma. */
  var _plFrases=['Isso pode levar alguns segundos'];
  /* O timer do progresso mora aqui fora de propósito. Ele liga quando a busca
     começa e precisa DESLIGAR quando ela termina — e ela termina de quatro
     jeitos: deu certo, deu erro, faltou saldo, ou a resposta chegou
     atrasada. Guardando num lugar só, o desligamento acontece dentro do
     próprio buscaLoad(false), que é por onde todos os quatro passam. Um
     setInterval esquecido roda pra sempre e come a bateria do celular. */
  var _plLoaderTimer=null;
  function buscaLoad(on, placa){
    var c=document.querySelector('.busca-card'); if(c) c.classList.toggle('buscando', !!on);
    /* v1372 — a barra completa abaixo da placa é a fonte única de andamento.
       A lupa fica indisponível durante a chamada e comunica ocupação sem
       criar outro spinner ou repetir o progresso que já está no cartão. */
    var lupa=$('placaBuscar'), campo=$('placa');
    if(lupa){
      lupa.disabled=on?true:!valida(String((campo&&campo.value)||''));
      if(on) lupa.setAttribute('aria-busy','true'); else lupa.removeAttribute('aria-busy');
    }
    if(_plLoaderTimer){ clearInterval(_plLoaderTimer); _plLoaderTimer=null; }
    var m=$('fipeMsg'); if(!m) return;
    if(on){
      m.className='msg carregando';   /* v303: sem isso a caixa fica display:none */
      try{
        m.innerHTML=ccLoaderHtml('Consultando '+esc(placa||''), _plFrases, null, 'cc-load-placa');
        /* v1415 — o HTML sozinho deixava a barra congelada nos 6%. A consulta
           principal passa a usar o mesmo avanço estimado das outras páginas:
           anda continuamente, limita-se a 92% e mantém o brilho de espera até
           existir uma resposta real. */
        _plLoaderTimer=ccLoaderStart(_plFrases,45);
      }catch(_){
        /* rede de segurança: se por algum motivo o anel não montar, a busca
           não pode ficar SEM NENHUM sinal de que está rodando. */
        m.innerHTML='<span class="busca-tx">Buscando '+esc(placa||'')+'…</span>';
      }
    }
  }
  async function buscarPlaca(forcar){
    /* v1431 — Consultas e Avaliações compartilham também a ESPERA, não só o
       formulário e o resultado. O Avaliações criava antes uma sobreposição
       própria com `pgLoad`; ela escondia a placa e concorria com o andamento
       contínuo que `buscarPlacaExecutar` já monta no cartão. Um único caminho
       mantém placa, percentual, etapas, erro e redução de movimento iguais. */
    return buscarPlacaExecutar(forcar);
  }
  async function buscarPlacaExecutar(forcar){
    if(_buscando) return;
    var placa=limpa($('placa').value), msg=$('fipeMsg'); msg.className='msg'; msg.textContent=''; msg.style.display='';  /* v585: some o erro (e o botão) da tentativa anterior · v593: o display inline do cartão sai junto */
    if(!valida(placa)){ msg.className='msg err'; msg.textContent='Placa inválida (ABC1234 ou ABC1D23).'; return; }
    /* ==========================================================================
       🔴 v712 (pedido, 29/08, com print): "ao inves de pegar a placa do
       historico quando digitei e ja tinha pesquisado, fez uma nova consulta"
       --------------------------------------------------------------------------
       Placa que JÁ ESTÁ no histórico (30 dias) abre a consulta SALVA — de
       graça, na hora, sem rede — pelo MESMO caminho da tela de Histórico
       (abrirSalva, v390: um nome só). O cabeçalho azul já carimba
       "DO HISTÓRICO · data", e o dado fresco continua a UM dedo: o botão ⟳
       da placa chama buscarPlaca(true), que pula este atalho. Nenhuma
       consulta paga sai sem o dedo pedir (v585/v599/v707). */
    if(!forcar){
      var _sv=null; try{ _sv=histLerUm(placa); }catch(_){}
      if(_sv && _sv.v){
        _autoUlt=placa;   /* a busca automática não re-dispara esta mesma placa */
        try{ if(typeof drawerFechar==='function') drawerFechar(false); }catch(_){}
        abrirSalva(placa);
        toast('Aberta do histórico ('+histData(_sv.ts)+'), sem gastar consulta — o ⟳ na placa busca dados novos.');
        return;
      }
    }
    _buscando=true; _autoUlt=placa; var _meuSeq=++_buscaSeq;
    /* v288 — consulta rodando é pra ser VISTA. Se o menu ficou aberto (por um
       gesto solto, ou por um toque atrás de uma tela sobreposta), ele tapa o
       resultado. Toda busca de placa começa fechando o menu. */
    try{ if(typeof drawerFechar==='function') drawerFechar(false); }catch(_){}
    $('placa').blur(); $('cardVeiculo').style.display='none'; $('histBox').style.display='none';
    /* v1414: durante a espera, conserva a placa consultada no campo. Assim a
       moldura mostra o formato correto e a pessoa enxerga o que está sendo
       pesquisado. O campo continua sendo limpo após o resultado. */
    var _pl0=$('placa'); if(_pl0) placaCampoVisualSync(_pl0);
    buscaLoad(true, placa);
    var _sAntes=saldo;   /* saldo de tokens ANTES da consulta */
    /* v167: mesmo que algo estoure aqui dentro, a trava _buscando e' solta.
       Antes, um erro na hora da consulta deixava a trava presa e o campo de
       placa ficava MUDO ate fechar e abrir o aplicativo. */
    var d=null;
    try{ d=await api('/api/consultar',{produto:'fipe',placa:placa}); }
    catch(_){ d={ ok:false, erro:'Falha de conex\u00e3o. Confira a internet e tente de novo.' }; }
    _buscando=false; buscaLoad(false);
    /* v167: chegou atrasada (o usuario ja pesquisou outra placa)? joga fora. */
    if(_meuSeq!==_buscaSeq) return;
    /* v1214 — se a abertura não conseguiu carregar a carteira, uma consulta
       autorizada pelo servidor é uma confirmação suficiente do ilimitado.
       A tela passa a refletir a permissão sem esperar outra recarga. */
    if(d&&d.ilimitado){ ilimitado=true; _saldoOk=true; _saldoPinta(); }
    /* v585: as DUAS saídas de erro devolvem a placa pro campo — e PARAM.
       Quem manda tentar de novo é o dedo (botão abaixo ou Enter). */
    if(d&&d.sem_saldo){ msg.className='msg'; msg.textContent=''; plDevolver(placa); setSaldo(d.saldo); abrirPacotes(); return; }
    if(!d||!d.ok){
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      /* ===== v593 — PLACA NÃO ENCONTRADA ≠ ERRO ===========================
         Quando o servidor manda a flag nao_encontrada (v593 do consulta-placa),
         o provedor RESPONDEU: essa placa não está na base dele. "Tentar de
         novo" não resolve — o caminho é a busca por MODELO. O cartão abaixo
         explicava em uma frase e levava pra aba "Buscar por veículo" NO DEDO.
         v982: a troca de tela agora é automática a pedido do Angelo. A busca
         manual continua sem disparar consulta: primeiro a pessoa escolhe o
         tipo (Carros, Motos ou Caminhões), depois marca, ano e modelo. */
      if(d&&d.nao_encontrada){
        plDevolver(placa);
        try{
          try{ consIr('fipe'); }catch(_){ abrirBuscaVeiculo(); }
          toast('Placa não encontrada. Escolha Carros, Motos ou Caminhões para buscar manualmente.'+(d.estornado?' O valor foi devolvido ao saldo.':''));
        }catch(_){
          /* qualquer tropeço na navegação: cai no aviso simples de sempre */
          msg.style.display='';
          msg.className='msg err';
          msg.textContent='Placa não encontrada na base de consulta.'+(d.estornado?' ✓ O valor foi devolvido ao saldo.':'');
        }
        return;
      }
      msg.className='msg err'; msg.textContent=((d&&d.erro)||'Falha na consulta.')+(d&&d.estornado?' ✓ O valor foi devolvido ao saldo.':'');
      plDevolver(placa);
      /* o mesmo desenho do "Tentar de novo" do erroLista() */
      try{
        var _rt=document.createElement('button');
        _rt.type='button'; _rt.className='lista-retry'; _rt.id='plcTentar';
        _rt.style.cssText='display:block;margin-top:10px;background:#0a4da6;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit';
        _rt.textContent='Tentar de novo';
        _rt.onclick=function(){ buscarPlaca(true); };   /* v712: tentar DE NOVO é consulta de verdade */
        msg.appendChild(_rt);
      }catch(_){}
      return;
    }
    if(d.gratis_fipe!=null) gratisFipe=Number(d.gratis_fipe)||0;
    if(d.gratis_fipe_ativo!=null) gratisFipeAtivo=d.gratis_fipe_ativo===true;
    if(d.gratis_fipe_expira_em!==undefined) gratisFipeExpiraEm=d.gratis_fipe_expira_em||null;
    msg.className='msg'+(d.gratuito?' ok':'');
    /* v241: no plano ilimitado a consulta liberada é o normal — sem aviso verde */
    if(d.ilimitado) msg.textContent='';
    else if(d.gratuito) msg.textContent='';
    else if(d.cota_gratis_indisponivel) msg.textContent='A cota grátis está indisponível no momento; esta consulta custou '+precoReal(d.custo||0)+'.';
    else msg.textContent='';
    /* v1347 — sucesso gratuito não ocupa espaço com uma confirmação que não
       ajuda a decidir. Avisos de cobrança continuam visíveis quando existem. */
    msg.style.display=msg.textContent?'':'none';
    setSaldo(d.saldo);
    veiculoAtual=d.resultado; histFonteTs=null;
    /* v158: se o Angelo ja escolheu a versao certa desta placa, reaplica sozinho */
    try{ if(veiculoAtual.fipe_sug==null) veiculoAtual.fipe_sug=veiculoAtual.fipe; verAplicar(veiculoAtual); }catch(_){}
    /* extrato de tokens desta consulta: saldo antes, quanto usou, saldo final */
    var _tok=null;
    if(!ilimitado && d.saldo!=null){ var _dep=Number(d.saldo)||0; _tok={ antes:_sAntes, custo:(d.gratuito?0:Math.max(0,Math.round((_sAntes-_dep)*100)/100)), depois:_dep, gratuito:!!d.gratuito }; }
    /* v167: guardar no historico NUNCA pode impedir a tela de trocar de carro.
       Se algo falhar aqui (memoria cheia do aparelho, dado estranho), o app
       segue em frente e mostra o veiculo novo do mesmo jeito. */
    var _pl2=d.resultado.placa||placa;
    try{
      histSalvar(_pl2, ((d.resultado.marca||'')+' '+(d.resultado.modelo||'')).trim(), d.resultado, _tok);
      syncCotacao(_pl2, ((d.resultado.marca||'')+' '+(d.resultado.modelo||'')).trim(), d.resultado);
      var e=histLerUm(_pl2); fichaState=(e&&e.ficha)||null; leilaoState=(e&&e.leilao)||null; debitosState=null; fichaTecState=(e&&e.fichaTec)||null;
    }catch(_){ fichaState=null; leilaoState=null; debitosState=null; fichaTecState=null; }
    var _pl=$('placa'); if(_pl){ _pl.value=''; placaCampoVisualSync(_pl); }   /* limpa o campo p/ a próxima placa */
    /* v167: o "pedido guardado" (consulta completa / debitos pedidos sem placa)
       so vale se foi feito ha poucos minutos - ver _pendConsumir(). */
    var _pd=_pendConsumir();
    try{ abrirMenu(); }catch(_){}
    if(_pd==='completa'){ try{ abrirLeilao(); }catch(_){} }
    else if(_pd==='debitos'){ try{ abrirDebitos(); }catch(_){} }
    telaConferir(_pl2);
  }
  /* ---- v167: PEDIDO GUARDADO (com prazo de validade) ----
     Quando o Angelo pede "consulta multa/restricoes" ou "debitos" SEM ter uma
     placa aberta, o app volta pra home e guarda o pedido pra emendar assim que
     ele digitar a placa. Antes esse bilhetinho ficava guardado PARA SEMPRE: se
     ele desistisse, dias depois a proxima pesquisa era sequestrada e abria a
     tela da consulta completa (a tela do carro anterior continuava aparecendo).
     Agora o bilhete vale 3 minutos e depois disso e' jogado fora sozinho. */
  var _completaPend=false, _debitosPend=false, _pendEm=0;
  var PEND_VALIDADE=3*60*1000;
  function _pendMarcar(qual){ _pendEm=Date.now(); _completaPend=(qual!=='debitos'); _debitosPend=(qual==='debitos'); }
  function _pendLimpar(){ _completaPend=false; _debitosPend=false; _pendEm=0; }
  function _pendConsumir(){
    var vale=(Date.now()-_pendEm)<PEND_VALIDADE;
    var q=vale?(_completaPend?'completa':(_debitosPend?'debitos':'')):'';
    _pendLimpar();
    return q;
  }
  /* ---- v167: CONFERENCIA DE TELA ----
     Cinto de seguranca. Depois de pintar o resultado, o app confere se a placa
     que esta na tela e' mesmo a que acabou de ser pesquisada. Se por qualquer
     motivo a tela anterior tiver ficado no lugar, ele pinta de novo. No dia a
     dia isso nunca faz nada - e' so pra garantir que nunca mais apareca o carro
     da pesquisa passada. */
  function _soAZ09(x){ return String(x||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function telaConferir(placa){
    var alvo=_soAZ09(placa); if(!alvo) return;
    function checa(){
      try{
        var sc=$('secoes'); if(!sc) return;
        if(!veiculoAtual || _soAZ09(veiculoAtual.placa)!==alvo) return;  /* ja existe consulta mais nova */
        if(_soAZ09(sc.textContent).indexOf(alvo)>=0) return;             /* a placa esta na tela: tudo certo */
        abrirMenu();
      }catch(_){}
    }
    setTimeout(checa,60); setTimeout(checa,600);
  }

  /* ---------- Histórico de consultas ----------
     Fica SALVO NA CONTA (segue o usuário em qualquer aparelho) e também
     em cache local por usuário, pra abrir rápido e funcionar offline.
     Guarda 30 dias. */
  function histKey(){ return meuId ? ('mev_placa_hist:'+meuId) : 'mev_placa_hist'; }
  function clonar(o){ try{ return JSON.parse(JSON.stringify(o)); }catch(_){ return o; } }
  function histGrava(h){ try{ localStorage.setItem(histKey(), JSON.stringify(h.slice(0,40))); }catch(_){} }
  function histLer(){
    try{
      var h=JSON.parse(localStorage.getItem(histKey())||'[]');
      var limite=Date.now()-HIST_DIAS*864e5;                 /* 30 dias em ms */
      h=h.filter(function(x){ return x && x.ts && x.ts>=limite; });
      return h;
    }catch(_){ return []; }
  }
  function histLerUm(placa){ return histLer().filter(function(x){ return x.placa===placa; })[0]||null; }
  /* salva a CONSULTA INTEIRA (v) pra reabrir depois sem gastar crédito.
     Preserva a Ficha/Leilão/favorito já guardados pra essa placa (não recobra). */
  /* calcula o "extrato" de tokens de uma consulta: saldo antes, quanto usou, saldo depois */
  function _tokCalc(antes, saldoDepois){ if(ilimitado || saldoDepois==null) return null; var dep=Number(saldoDepois)||0; return { antes:antes, custo:Math.max(0,Math.round((antes-dep)*100)/100), depois:dep }; }
  function histSalvar(placa, modelo, v, tok){
    try{
      var atual=histLerUm(placa);
      var h=histLer().filter(function(x){ return x.placa!==placa; });
      var novoV=v?clonar(v):null;
      /* v1427 — detalhes comerciais digitados antes de compartilhar pertencem
         à placa. Uma nova consulta atualiza FIPE/modelo, mas não apaga aquilo
         que o usuário registrou manualmente para a conversa com o cliente. */
      if(novoV&&atual&&atual.v){
        ['quilometragem_compartilhamento','observacoes_compartilhamento','gastos_previstos_compartilhamento','descricao_gastos_compartilhamento'].forEach(function(k){
          if((novoV[k]===undefined||novoV[k]===null||novoV[k]==='')&&atual.v[k]!==undefined) novoV[k]=atual.v[k];
        });
      }
      var e={ placa:placa, modelo:modelo||'', ts:Date.now(), v:novoV };
      if(tok) e.tok=tok; else if(atual&&atual.tok) e.tok=atual.tok;
      if(atual&&atual.ficha) e.ficha=atual.ficha;
      if(atual&&atual.fichaTec) e.fichaTec=atual.fichaTec;
      if(atual&&atual.leilao) e.leilao=atual.leilao;
      if(atual&&atual.fav)   e.fav=atual.fav;
      h.unshift(e);
      histGrava(h);
      histPushOne(placa);
    }catch(_){}
  }
  /* ---- v158: VERSAO DA FIPE ESCOLHIDA PELO USUARIO (fica salva por placa) ----
     A API sugere uma versao; o Angelo sabe qual e a certa. A escolha dele fica
     guardada no aparelho (mev_fipe_ver:PLACA) E dentro do registro do historico,
     e e reaplicada sozinha em toda nova consulta da mesma placa. */
  function _verKey(placa){ return 'mev_fipe_ver:'+String(placa||'').toUpperCase(); }
  /* v159: a descricao da FIPE vira o MODELO do veiculo (cabecalho azul, linha
     "Modelo", ficha tecnica, PDFs...). Se a descricao ja vier com a marca na
     frente, tira pra nao ficar "VW - VolksWagen VW - VolksWagen Fox...". */
  function _verModeloDes(des, marca){
    var d=String(des||'').trim(); if(!d) return '';
    var m=String(marca||'').trim();
    if(m && d.toUpperCase().indexOf(m.toUpperCase())===0) d=d.slice(m.length).replace(/^[\s\-\u00b7\/]+/,'');
    return d.trim();
  }
  function verEscolhaLer(placa){ try{ return JSON.parse(localStorage.getItem(_verKey(placa))||'null'); }catch(_){ return null; } }
  function verEscolhaGravar(placa, obj){ try{ if(obj) localStorage.setItem(_verKey(placa), JSON.stringify(obj)); else localStorage.removeItem(_verKey(placa)); }catch(_){} }
  /* v190: sem escolha salva, o app alinha a FIPE com o ANO-MODELO do documento. */
  function fipeAnoModeloAplicar(v){
    try{
      var ops=verOps(v); if(ops.length<2) return v;
      var op=verOpDoAnoModelo(v, ops); if(!op) return v;
      var nv=Number(op.valor)||0; if(!nv) return v;
      if(Math.round(nv)===Math.round(Number(v.fipe)||0)) return v;   /* ja e' essa linha */
      if(v.fipe_sug==null) v.fipe_sug=v.fipe;
      v.fipe=nv;
      if(op.codigo_fipe) v.codigo_fipe=op.codigo_fipe;
      if(op.historico && op.historico.length>1) v.historico=op.historico;
      if(op.mes_ref) v.mes_ref=op.mes_ref;
      var des=_verModeloDes(op.descricao||'', v.marca);
      if(des){ if(v.modelo_sug==null) v.modelo_sug=v.modelo; v.modelo=des; }
      var nip=_ipvaCalc(nv, v.uf); if(nip) v.ipva=nip;
      v.fipe_ano=op.ano||'';
      v.fipe_por_ano_modelo=true;
    }catch(_){}
    return v;
  }
  function verAplicar(v){
    if(!v || !v.placa) return v;
    var e=verEscolhaLer(v.placa); if(!e) return fipeAnoModeloAplicar(v);
    var ops=(v.fipe_opcoes||[]).filter(function(o){ return o && o.valor!=null; });
    var op=null;
    if(ops.length){
      op=ops.filter(function(o){ return e.codigo_fipe && String(o.codigo_fipe||'')===String(e.codigo_fipe); })[0]
       || ops.filter(function(o){ return e.descricao && String(o.descricao||'')===String(e.descricao); })[0]
       || ops.filter(function(o){ return Math.round(Number(o.valor))===Math.round(Number(e.valor)); })[0] || null;
    }
    var val=op?(Number(op.valor)||0):(Number(e.valor)||0);
    if(!val) return v;
    if(v.fipe_sug==null) v.fipe_sug=v.fipe;
    v.fipe=val;
    var cod=(op&&op.codigo_fipe)||e.codigo_fipe||'';
    if(cod) v.codigo_fipe=cod;
    /* v159: o NOME da versao tambem passa a valer (cabecalho azul + ficha tecnica) */
    var des=_verModeloDes((op&&op.descricao)||e.descricao||'', v.marca);
    if(des){ if(v.modelo_sug==null) v.modelo_sug=v.modelo; v.modelo=des; }
    var nip=_ipvaCalc(val, v.uf); if(nip) v.ipva=nip;
    /* v190: o historico da FIPE tambem e' por versao/ano-modelo */
    if(op && op.historico && op.historico.length>1) v.historico=op.historico;
    if(op && op.ano) v.fipe_ano=op.ano;
    v.fipe_escolhida=true;
    return v;
  }
  /* =====================================================================
     v164 - ESCOLHA DA VERSAO NUM MODAL (um cartao por versao)
     Antes a lista de versoes ficava escondida dentro do card "Dados e FIPE",
     atras de um link "trocar versao" - e o app ja mostrava os valores de UMA
     versao escolhida por conta propria. Se a API sugeriu a versao errada, o
     Angelo via o preco errado sem perceber.
     Agora, quando a placa tem MAIS DE UMA versao na FIPE, o app pergunta
     primeiro: abre um modal com um cartao por versao e so segue depois que
     ele escolher (ou confirmar) a certa. E esse mesmo modal pode ser aberto
     a qualquer momento pelo botao "trocar" que fica logo abaixo da placa.
     ===================================================================== */
  var _verVisto={};   /* placas cujo modal ja apareceu nesta sessao */
  function verOps(v){ return ((v&&v.fipe_opcoes)||[]).filter(function(o){ return o && o.valor!=null; }); }
  /* v190: ANO-MODELO manda. A FIPE nao conhece ano de fabricacao — cada linha
     dela e' um ano-MODELO. Entao, quando o app precisa escolher sozinho, ele
     escolhe a linha cujo ano bate com o ano-modelo do documento do carro
     (ex.: Tera 2025/2026 -> a linha 2026, nao a 2025). */
  function _anoMod(v){ var a=parseInt(String((v&&(v.ano_modelo||v.ano))||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,4),10); return a||0; }
  function verOpDoAnoModelo(v, ops){
    var am=_anoMod(v); if(!am||!ops||!ops.length) return null;
    return ops.filter(function(o){ return parseInt(String(o.ano||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,4),10)===am; })[0]||null;
  }
  /* v190: o grafico/tabela de historico da FIPE tem que ser o da versao que
     esta valendo na tela — cada opcao traz o historico dela. */
  function verHistDe(v){
    try{
      var ops=verOps(v); if(ops.length){
        var op=verOpAtual(v, ops);
        var h=(op&&op.historico)||[];
        if(h.length>1) return h;
      }
    }catch(_){}
    return (v&&v.historico)||[];
  }
  /* qual das opcoes esta valendo agora: a que ele salvou, senao a que bate com o valor da tela */
  function verOpAtual(v, ops){
    if(!ops||!ops.length) return null;
    var e=verEscolhaLer(v&&v.placa);
    return (e&&e.codigo_fipe?ops.filter(function(o){ return String(o.codigo_fipe||'')===String(e.codigo_fipe); })[0]:null)
        || (e&&e.descricao?ops.filter(function(o){ return String(o.descricao||'')===String(e.descricao); })[0]:null)
        || ops.filter(function(o){ return Math.round(Number(o.valor))===Math.round(Number(v&&v.fipe)); })[0]
        || verOpDoAnoModelo(v, ops)   /* v190: sem escolha salva, vale o ano-modelo */
        || ops[0];
  }
  /* APLICA E SALVA a versao escolhida - um lugar so (modal, lista antiga, o que vier) */
  function verEscolherOp(nv, cod, des){
    if(!veiculoAtual) return;
    nv=Number(nv)||veiculoAtual.fipe;
    cod=cod||''; des=des||'';
    if(veiculoAtual.fipe_sug==null) veiculoAtual.fipe_sug=veiculoAtual.fipe;   /* guarda a sugerida da API */
    veiculoAtual.fipe=nv; if(cod) veiculoAtual.codigo_fipe=cod;
    var nip=_ipvaCalc(nv, veiculoAtual.uf); if(nip) veiculoAtual.ipva=nip;
    /* v190: troca tambem o historico (cada ano-modelo tem a serie dele) */
    try{ var _op=verOps(veiculoAtual).filter(function(o){ return cod?(String(o.codigo_fipe||'')===String(cod)):(Math.round(Number(o.valor))===Math.round(nv)); })[0];
      if(_op){ if(_op.historico&&_op.historico.length>1) veiculoAtual.historico=_op.historico; if(_op.ano) veiculoAtual.fipe_ano=_op.ano; } }catch(_){}
    /* v159: o nome da versao escolhida passa a ser o modelo do veiculo */
    var desLimpo=_verModeloDes(des, veiculoAtual.marca);
    if(desLimpo){ if(veiculoAtual.modelo_sug==null) veiculoAtual.modelo_sug=veiculoAtual.modelo; veiculoAtual.modelo=desLimpo; }
    veiculoAtual.fipe_escolhida=true;
    verEscolhaGravar(veiculoAtual.placa, { valor:nv, codigo_fipe:cod, descricao:des, ts:Date.now() });
    histSetVersao(veiculoAtual.placa,
      { fipe:nv, codigo_fipe:veiculoAtual.codigo_fipe, ipva:veiculoAtual.ipva, fipe_sug:veiculoAtual.fipe_sug, fipe_escolhida:true, modelo:veiculoAtual.modelo, modelo_sug:veiculoAtual.modelo_sug },
      desLimpo?{ modelo:((veiculoAtual.marca||'')+' '+veiculoAtual.modelo).trim() }:null);
    try{ syncCotacao(veiculoAtual.placa, ((veiculoAtual.marca||'')+' '+(veiculoAtual.modelo||'')).trim(), veiculoAtual); }catch(_){}
  }
  /* volta pra versao que a consulta sugeriu (apaga a escolha salva) */
  function verUsarSugerida(){
    if(!veiculoAtual) return;
    verEscolhaGravar(veiculoAtual.placa, null);
    var sug=Number(veiculoAtual.fipe_sug)||0;
    if(sug){ veiculoAtual.fipe=sug;
      var op=verOps(veiculoAtual).filter(function(o){ return Math.round(Number(o.valor))===Math.round(sug); })[0];
      if(op&&op.codigo_fipe) veiculoAtual.codigo_fipe=op.codigo_fipe;
      var nip2=_ipvaCalc(sug, veiculoAtual.uf); if(nip2) veiculoAtual.ipva=nip2; }
    if(veiculoAtual.modelo_sug) veiculoAtual.modelo=veiculoAtual.modelo_sug;
    veiculoAtual.fipe_escolhida=false;
    histSetVersao(veiculoAtual.placa,
      { fipe:veiculoAtual.fipe, codigo_fipe:veiculoAtual.codigo_fipe, ipva:veiculoAtual.ipva, fipe_escolhida:false, modelo:veiculoAtual.modelo },
      { modelo:((veiculoAtual.marca||'')+' '+(veiculoAtual.modelo||'')).trim() });
  }
  function verModalFechar(){ try{ var m=$('modalVer'); if(m) m.classList.remove('on'); }catch(_){} }
  /* auto=true quando o proprio app abriu (placa com mais de uma versao ainda nao confirmada) */
  function verModalAbrir(auto){
    var v=veiculoAtual; if(!v) return;
    var ops=verOps(v); if(ops.length<2) return;
    var box=$('modalVerBox'), bg=$('modalVer'); if(!box||!bg) return;
    _verVisto[v.placa]=1;
    var atual=verOpAtual(v, ops), salva=verEscolhaLer(v.placa);
    var cards=ops.map(function(o,i){
      var sel=(o===atual);
      var sub=[o.ano,o.combustivel].filter(Boolean).join(' \u00b7 ');
      return '<button type="button" class="vm-card'+(sel?' sel':'')+'" data-i="'+i+'">'+
        '<span class="vm-top"><span class="vm-des">'+esc(o.descricao||('Vers\u00e3o '+(i+1)))+'</span>'+
          (sel?'<span class="vm-tag">EM USO</span>':'')+'</span>'+
        (sub?('<span class="vm-sub">'+esc(sub)+'</span>'):'')+
        (o.codigo_fipe?('<span class="vm-cod">c\u00f3d. FIPE '+esc(o.codigo_fipe)+'</span>'):'')+
        '<span class="vm-val">'+esc(brl(o.valor))+'</span>'+
        '<span class="vm-cta">'+(sel?'Confirmar esta vers\u00e3o':'Usar esta vers\u00e3o')+'</span>'+
      '</button>';
    }).join('');
    box.innerHTML='<div class="vm-head"><div class="vm-h1">Qual \u00e9 a vers\u00e3o deste carro?</div>'+
        '<div class="vm-h2">A placa <b>'+esc(v.placa||'')+'</b> tem <b>'+ops.length+' vers\u00f5es</b> na tabela FIPE, '+
        'e cada uma vale um valor diferente. Toque na correta \u2014 ela fica salva nesta placa.</div></div>'+
      '<div class="vm-lista">'+cards+'</div>'+
      (salva?'<button type="button" class="vm-sug" id="vmSug">voltar pra vers\u00e3o sugerida pela consulta</button>':'')+
      '<button type="button" class="link" id="vmFechar">'+(auto?'Decidir depois':'Fechar')+'</button>';
    Array.prototype.forEach.call(box.querySelectorAll('.vm-card'), function(bt){
      bt.onclick=function(){
        var o=ops[parseInt(bt.getAttribute('data-i'),10)||0]; if(!o) return;
        verEscolherOp(o.valor, o.codigo_fipe||'', o.descricao||'');
        verModalFechar();
        try{ toast('Vers\u00e3o salva \u2713 \u2014 vou usar essa sempre nesta placa.'); }catch(_){}
        abrirMenu();
      };
    });
    var _sg=$('vmSug'); if(_sg) _sg.onclick=function(){ verUsarSugerida(); verModalFechar(); try{ toast('Voltei pra vers\u00e3o sugerida pela consulta.'); }catch(_){} abrirMenu(); };
    var _fc=$('vmFechar'); if(_fc) _fc.onclick=verModalFechar;
    bg.onclick=function(e){ if(e.target===bg) verModalFechar(); };
    bg.classList.add('on');
  }
  /* regrava os campos da versao dentro do registro salvo da placa (e manda pra nuvem) */
  function histSetVersao(placa, patch, topo){
    try{
      var h=histLer();
      for(var i=0;i<h.length;i++){ if(h[i].placa===placa){ if(!h[i].v) h[i].v={}; for(var k in patch){ if(Object.prototype.hasOwnProperty.call(patch,k)) h[i].v[k]=patch[k]; }
        /* v159: campos que ficam FORA do "v" (ex.: modelo, que a lista do historico e o card da home mostram) */
        if(topo){ for(var k2 in topo){ if(Object.prototype.hasOwnProperty.call(topo,k2)) h[i][k2]=topo[k2]; } }
        break; } }
      histGrava(h); histPushOne(placa);
      /* v158: repinta o cartão da home na hora, senão ele fica mostrando o valor antigo */
      try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
    }catch(_){}
  }
  /* grava a Ficha/Leilão gerados dentro do registro salvo da placa */
  function histSetGerado(placa, campo, val){
    try{ var h=histLer(); for(var i=0;i<h.length;i++){ if(h[i].placa===placa){ h[i][campo]=val; break; } } histGrava(h); histPushOne(placa); }catch(_){}
  }
  /* favoritar / desfavoritar (local + nuvem) */
  function histFav(placa, fav){
    try{ var h=histLer(); for(var i=0;i<h.length;i++){ if(h[i].placa===placa){ h[i].fav=!!fav; break; } } histGrava(h); }catch(_){}
    if(token){ api('/api/historico',{acao:'favoritar', placa:placa, fav:!!fav})['catch'](function(){}); }
  }
  /* apagar (local + nuvem) */
  function histApagar(placa){
    try{ histGrava(histLer().filter(function(x){ return x.placa!==placa; })); }catch(_){}
    if(token){ api('/api/historico',{acao:'apagar', placa:placa})['catch'](function(){}); }
  }
  /* v163 - APAGAR UMA CONSULTA, num lugar so.
     Antes, quando voce apagava a consulta estando DENTRO da tela daquela
     placa, o app apagava do historico mas continuava mostrando a tela do
     veiculo: voce ficava olhando uma consulta que nao existe mais, e os
     cartoes (FIPE, ficha, leilao) ainda respondiam com os dados velhos que
     tinham ficado na memoria. Agora apaga, LIMPA o que estava carregado e
     volta pra tela inicial. Se voce apagou de uma lista (home ou historico),
     continua onde estava - so a lista se redesenha. */
  function histExcluirPlaca(placa, repinta){
    histApagar(placa);
    var aberta = !!(veiculoAtual && String(veiculoAtual.placa||'')===String(placa||''));
    if(aberta){
      veiculoAtual=null; histFonteTs=null; fichaState=null; fichaTecState=null; leilaoState=null; debitosState=null;
      try{ var _pi=$('placa'); if(_pi) _pi.value=''; }catch(_){}
    }
    /* 'md-veiculo' e a marca que o app poe no <body> enquanto a TELA DA PLACA
       esta aberta (todas as outras telas internas tiram essa marca). E o jeito
       seguro de saber se e dali que precisamos sair. */
    if(aberta && document.body.classList.contains('md-veiculo')){ try{ voltarHome(); }catch(_){} }
    else if(typeof repinta==='function'){ try{ repinta(); }catch(_){} }
    try{ toast('Consulta da placa '+placa+' apagada.'); }catch(_){}
  }
  /* manda UMA placa pra nuvem (chamado ao salvar/gerar/favoritar) */
  function histPushOne(placa){
    if(!token) return;
    var it=histLerUm(placa); if(!it) return;
    api('/api/historico',{acao:'salvar', item:{ placa:it.placa, modelo:it.modelo, ts:it.ts, fav:!!it.fav, v:it.v||null, ficha:it.ficha||null, fichaTec:it.fichaTec||null, leilao:it.leilao||null, tok:it.tok||null }})['catch'](function(){});
  }
  /* junta o histórico da conta (nuvem) com o do aparelho e devolve tudo alinhado */
  async function histSync(){
    if(!token) return;
    var d; try{ d=await api('/api/historico',{acao:'listar'}); }catch(_){ return; }
    var nuvem=(d&&d.ok&&d.itens)||[];
    var local=histLer();
    /* migração única: adota o histórico antigo (chave sem usuário) neste aparelho */
    if(meuId){
      try{
        var flag='mev_placa_hist_migrado:'+meuId;
        if(!localStorage.getItem(flag)){
          var velho=JSON.parse(localStorage.getItem('mev_placa_hist')||'[]');
          if(velho&&velho.length){ local=local.concat(velho); }
          localStorage.setItem(flag,'1');
        }
      }catch(_){}
    }
    /* merge por placa: a consulta mais nova manda; preserva ficha/leilão/favorito de qualquer lado */
    var map={}, nuvemMap={};
    nuvem.forEach(function(c){ if(c&&c.placa) nuvemMap[c.placa]=c; });
    local.concat(nuvem).forEach(function(x){
      if(!x||!x.placa) return;
      var cur=map[x.placa];
      if(!cur){ map[x.placa]=clonar(x); return; }
      var base=((x.ts||0)>=(cur.ts||0))?x:cur, outro=(base===x)?cur:x, m=clonar(base);
      if(!m.v && outro.v) m.v=outro.v;
      if(!m.tok && outro.tok) m.tok=outro.tok;
      if(!m.ficha && outro.ficha) m.ficha=outro.ficha;
      if(!m.fichaTec && outro.fichaTec) m.fichaTec=outro.fichaTec;
      if(!m.leilao && outro.leilao) m.leilao=outro.leilao;
      if(outro.fav) m.fav=true;
      map[x.placa]=m;
    });
    var limite=Date.now()-HIST_DIAS*864e5;
    var merged=Object.keys(map).map(function(k){ return map[k]; })
      .filter(function(x){ return x.ts&&x.ts>=limite; })
      .sort(function(a,b){ return (b.ts||0)-(a.ts||0); }).slice(0,40);
    histGrava(merged);
    /* sobe pra nuvem só o que mudou (novo, mais recente, ou ganhou ficha/leilão/favorito) */
    var subir=merged.filter(function(m){
      var c=nuvemMap[m.placa];
      return !c || (m.ts||0)>(c.ts||0) || (m.ficha&&!c.ficha) || (m.fichaTec&&!c.fichaTec) || (m.leilao&&!c.leilao) || (!!m.fav!==!!c.fav) || (m.v&&!c.v);
    }).map(function(m){ return { placa:m.placa, modelo:m.modelo, ts:m.ts, fav:!!m.fav, v:m.v||null, ficha:m.ficha||null, fichaTec:m.fichaTec||null, leilao:m.leilao||null, tok:m.tok||null }; });
    if(subir.length){ api('/api/historico',{acao:'salvar', itens:subir})['catch'](function(){}); }
    /* se a tela de histórico estiver aberta agora, redesenha com o resultado do merge */
    if(document.getElementById('histLista')) abrirHistorico();
    try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
  }
  function histData(ts){ try{ return new Date(ts).toLocaleDateString('pt-BR'); }catch(_){ return ''; } }
  /* reabre uma consulta salva: monta as 3 colunas na hora, crédito zero */
  function abrirSalva(placa){
    var it=histLer().filter(function(x){ return x.placa===placa; })[0];
    if(!it || !it.v){ voltarHome(); $('placa').value=placa; $('placa').scrollIntoView({behavior:'smooth',block:'center'}); return; }
    veiculoAtual=it.v; histFonteTs=it.ts; fichaState=it.ficha||null; fichaTecState=it.fichaTec||null; leilaoState=it.leilao||null;
    try{ verAplicar(veiculoAtual); }catch(_){}   /* v158: mantem a versao que ele escolheu */
    var _pi=$('placa'); if(_pi) _pi.value='';   /* campo de pesquisa fica LIMPO pra próxima placa */
    abrirMenu();
  }
  (function(){ var b=$('btnHist'); if(b) b.onclick=function(){ abrirHistorico(); }; })();
  (function(){ var b=$('btnFipeModelo'); if(b) b.onclick=telaFipeModelo; })();

  /* ---------- Buscar por FOTO da placa (câmera / fototeca / arquivo) ---------- */
  /* v262 — SÓ O MENU NATIVO DO APARELHO (pedido).
     A v258 tinha criado um menu próprio dentro do app com 3 opções. Ele
     duplicava o que o celular já faz sozinho: ao tocar num input de imagem,
     o iPhone (e o Android) abrem a folha com Tirar Foto / Fototeca / Arquivo.
     Eram duas telas para a mesma escolha. Agora o botão dispara direto o
     input `fotoPlaca` (accept="image/*") e quem mostra as opções é o sistema.

     Os três inputs continuam no app.html e todos caem na MESMA tela de recorte
     (cropAbrir). Se um dia quiser um atalho que já abra a câmera, é só dar
     .click() em `fotoPlacaCam`. */
  var _FOTO_SRC=[
    { id:'fotoPlacaCam', rot:'Tirar foto',      sub:'Abre a câmera agora',
      svg:'<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>' },
    { id:'fotoPlaca',    rot:'Galeria / Fotos', sub:'Escolher uma foto já tirada',
      svg:'<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/>' },
    { id:'fotoPlacaArq', rot:'Arquivo',         sub:'Buscar nos arquivos do aparelho',
      svg:'<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>' }
  ];
  /* Abre direto o seletor do próprio aparelho. Um input de imagem SEM
     `capture` faz o iPhone/Android mostrarem a folha nativa com as opções de
     câmera, fototeca e arquivos — por isso não existe mais menu no app. */
  function fotoSrcAbrir(){
    var el=$('fotoPlaca'); if(!el) return;
    el.value='';        /* zera pra permitir escolher a MESMA foto de novo */
    el.click();
  }
  function fotoSrcFechar(){}   /* mantida vazia: outros trechos podem chamar */
  /* v1441 — a Home das edições Consultas e Avaliações mostra a câmera junto
     do campo. O FAB oculto continua como ponte para fluxos antigos; ambos
     chamam exatamente o mesmo seletor nativo. */
  (function(){ ['btnFotoFab','placaFoto'].forEach(function(id){ var b=$(id); if(b) b.onclick=fotoSrcAbrir; }); })();
  /* ==========================================================================
     🔴🔴 v883 — A FOTO VAI DIRETO PRA IA. O RECORTE SAIU DO CAMINHO.
     (pedido do Angelo, 04/09: "remove o recortar a placa quando o usuário
      busca a placa por foto — ele adiciona a foto e a IA já identifica os
      caracteres mostrando pra confirmação")
     --------------------------------------------------------------------------
     Como era: escolher a foto → arrastar um retângulo em cima da placa →
     "Usar recorte" → a IA lê → confirmar. Três telas e um gesto de precisão,
     feito de pé no pátio, com o celular numa mão.

     Como é: escolher a foto → a IA lê → confirmar. A janela "É esta a placa?"
     (v262) já existia e continua igual — ela é a confirmação que o pedido
     pede, e é ela que impede consulta de leitura torta desde a v882.

     🟢 E NÃO É CAMINHO NOVO: é exatamente o que o botão "Foto inteira" do
     recorte já fazia — `cropCanvas` com a seleção cheia, 1280px, passando pelo
     mesmo realce (contraste + nitidez) que a prévia usava. Só deixou de exigir
     o gesto. Código provado, um passo a menos.

     ⚠️ O RECORTE NÃO FOI APAGADO. `cropAbrir`, `cropUsar`, `cropWireDrag` e a
     tela deles continuam inteiros e funcionando — é a receita da casa (v761,
     v861, v872): desligar MOSTRANDO o caminho, nunca apagando. Religar é
     trocar a linha de baixo por `cropAbrir(file)`.
     ⛳ QUANDO RELIGAR: se a IA passar a errar em foto de longe, o recorte volta
     como uma OPÇÃO ("não leu? recorte a placa"), não como obrigação.
     ========================================================================== */
  var MEV_FOTO_RECORTE = false;
  _FOTO_SRC.forEach(function(o){
    var el=$(o.id); if(!el) return;
    el.onchange=function(){
      var file=this.files && this.files[0]; if(!file) return;
      if(MEV_FOTO_RECORTE){ cropAbrir(file); return; }
      fotoPlacaDireto(file);
    };
  });
  /* a foto inteira, realçada, direto pra leitura */
  async function fotoPlacaDireto(file){
    try{
      var b64=await cropCanvas(file,{x:0,y:0,w:1,h:1},1280);
      await lerPlacaBase64(b64);
    }catch(e){ toast('Não consegui processar a foto. Tente outra.'); }
  }
  /* v262 — CONFERIR A PLACA ANTES DE BUSCAR (pedido).
     A leitura por foto erra em placa suja, de lado ou com sol batendo — e o
     erro só aparecia depois, como "veículo não encontrado" ou, pior, os dados
     de OUTRO carro. Agora o app mostra o que leu num campo editável: confere,
     corrige se precisar e só então busca. Devolve a placa confirmada ou ''. */
  /* ===== v266 (pedido) — A MINIATURA DO QUE FOI LIDO =====
     Conferir uma placa de cabeça, sem ver a foto, é adivinhação: JBP6A91 e
     J8P6A9I são a mesma coisa na tela. Agora o recorte aparece do lado do
     campo — é exatamente a imagem que foi enviada pra leitura (já com o
     realce de contraste), então dá pra bater caractere por caractere.
     Tocar na miniatura amplia. */
  function placaConfirmar(lida, imagemB64){
    return new Promise(function(resolve){
      var antigo=$('plcConfBg'); if(antigo) antigo.remove();
      var bg=document.createElement('div'); bg.id='plcConfBg'; bg.className='fsrc-bg on';
      var _mini = imagemB64
        ? ('<button type="button" class="plcconf-foto" id="plcConfFoto" title="Tocar para ampliar" aria-label="Ampliar a foto lida">'+
             '<img src="data:image/jpeg;base64,'+imagemB64+'" alt="Recorte da placa que o app leu">'+
             '<span>foi isto que o app leu — toque para ampliar</span>'+
           '</button>')
        : '';
      bg.innerHTML='<div class="fsrc" role="dialog" aria-modal="true" aria-label="Confirmar a placa">'+
        '<div class="fsrc-h"><b>É esta a placa?</b><span>Confira e corrija se o app leu errado</span></div>'+
        _mini+
        '<input id="plcConfIn" class="placa-big" maxlength="7" autocomplete="off" autocapitalize="characters" '+
          'spellcheck="false" style="text-align:center;margin:2px 0 4px" value="'+esc(lida||'')+'">'+
        '<div id="plcConfErr" style="color:#b91c1c;font-size:13px;font-weight:700;text-align:center;min-height:18px"></div>'+
        '<button type="button" class="fsrc-op" id="plcConfOk" style="justify-content:center;font-weight:900">Buscar esta placa</button>'+
        '<button type="button" class="fsrc-cancel" id="plcConfX">Cancelar</button></div>';
      document.body.appendChild(bg);

      var campo=$('plcConfIn'), err=$('plcConfErr'), pronto=false;
      function fechar(valor){ if(pronto) return; pronto=true; try{ bg.remove(); }catch(_){} resolve(valor); }
      /* 🔴 v882 — A MESMA TRAVA DA CONSULTA, AQUI TAMBÉM.
         Regra diferente entre o que a pessoa digita e o que ela corrige depois
         da foto seria a pior das duas: o caminho da foto é justamente onde
         entra caractere trocado (a IA lê O por 0, I por 1). E aqui a trava
         paga a conta: enquanto a placa não estiver completa e válida, o botão
         "Buscar esta placa" fica DESLIGADO — nenhuma consulta paga sai de uma
         leitura torta.
         ⚠️ E continua sem trocar O/0 nem I/1 sozinho: quem corrige é o dedo do
         Angelo olhando pra foto, que está logo ali em cima na mesma janela. */
      try{ placaLigar(campo,{ erro:'plcConfErr', pronto:function(bom){
        var b=$('plcConfOk'); if(!b) return;
        b.disabled=!bom;
        b.style.opacity=bom?'':'0.5';
        b.style.cursor=bom?'':'not-allowed';
      }}); }catch(_){ campo.addEventListener('input',function(){ this.value=limpa(this.value); err.textContent=''; }); }
      function confirmar(){
        var p=String(campo.value||'');
        if(!valida(p)){ err.textContent=p.length<7?'Digite os 7 caracteres da placa.':'Confira a placa: use ABC1234 ou ABC1D23.'; campo.focus(); return; }
        fechar(p);
      }
      /* toque na miniatura: abre a foto em tamanho grande, por cima do modal */
      var _bf=$('plcConfFoto');
      if(_bf) _bf.onclick=function(e){
        e.stopPropagation();
        var z=document.createElement('div'); z.className='plcconf-zoom';
        z.innerHTML='<img src="data:image/jpeg;base64,'+imagemB64+'" alt="Foto lida, ampliada">';
        z.onclick=function(){ try{ z.remove(); }catch(_){} };
        document.body.appendChild(z);
      };
      $('plcConfOk').onclick=confirmar;
      $('plcConfX').onclick=function(){ fechar(''); };
      bg.addEventListener('click', function(e){ if(e.target===bg) fechar(''); });
      campo.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); confirmar(); } });
      /* sem foco automático: no iPhone o teclado subindo tapa o campo e a
         pessoa nem chega a LER o que o app detectou — que é o ponto aqui. */
    });
  }
  async function lerPlacaBase64(img){
    var msg=$('fipeMsg'); if(msg) msg.className='msg';
    var btn=$('btnFotoFab'); if(btn) btn.disabled=true; toast('Lendo a placa da foto...');
    try{
      var d=await api('/api/ler-placa-foto',{ imagemBase64:img, mimeType:'image/jpeg' });
      if(btn) btn.disabled=false;
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(d&&d.sem_saldo){ if(msg){ msg.className='msg err'; msg.textContent=d.erro||'Saldo insuficiente.'; } abrirPacotes(); return; }
      if(!d||!d.ok){ if(msg){ msg.className='msg err'; msg.textContent=(d&&d.erro)||'Não consegui ler a placa.'; } toast((d&&d.erro)||'Não consegui ler a placa.'); return; }
      var confirmada=await placaConfirmar(limpa(d.placa), img);   /* v266: a mesma imagem que foi lida */
      if(!confirmada){ if(msg){ msg.className='msg'; msg.textContent=''; } return; }   /* desistiu: não gasta consulta */
      $('placa').value=confirmada;
      if(msg){ msg.className='msg ok'; msg.textContent='Placa '+confirmada+' — consultando…'; }
      buscarPlaca();
    }catch(e){ if(btn) btn.disabled=false; if(msg){ msg.className='msg err'; msg.textContent='Não consegui processar a foto. Tente outra.'; } toast('Não consegui processar a foto.'); }
  }
  /* Recorte da placa antes de ler (arrasta um retangulo) */
  var _cropFile=null, _cropSel=null, _cropImgEl=null, _cropUrl=null;
  function cropAbrir(file){
    /* v288 — o recorte cobre a tela inteira e fica ACIMA do menu. Se o menu
       estiver aberto quando a foto chega, ele some atrás do recorte e reaparece
       depois, já em cima da consulta. Fecha antes de começar. */
    try{ if(typeof drawerFechar==='function') drawerFechar(false); }catch(_){}
    _cropFile=file; _cropSel=null;
    var bg=$('cropBg');
    if(!bg){
      bg=document.createElement('div'); bg.id='cropBg'; bg.className='crop-bg';
      bg.innerHTML='<div class="crop-top"><button type="button" class="crop-x" id="cropX">&#10005;</button><b>Recortar a placa</b><span style="width:34px"></span></div>'+
        '<div class="crop-hint">Arraste um retângulo em volta da placa (ou use a foto inteira). Confira na prévia se dá pra ler antes de buscar.</div>'+
        '<div class="crop-stage" id="cropStage"><img id="cropImg" alt=""><div class="crop-sel" id="cropSel"></div></div>'+
        /* v258: prévia do recorte — mostra AMPLIADO e já realçado exatamente o
           pedaço que vai ser enviado, pra conferir antes de gastar o token */
        '<div class="crop-prev" id="cropPrev"><span class="crop-prev-t">Prévia — é isso que o app vai ler</span><canvas id="cropPrevCv"></canvas></div>'+
        '<div class="crop-acts"><button type="button" class="b-full" id="cropFull">Foto inteira</button><button type="button" class="b-cut" id="cropCut">Recortar e buscar</button></div>';
      document.body.appendChild(bg);
      $('cropX').onclick=cropFechar;
      $('cropFull').onclick=function(){ cropUsar(false); };
      $('cropCut').onclick=function(){ cropUsar(true); };
      cropWireDrag();
    }
    _cropImgEl=$('cropImg');
    var url=URL.createObjectURL(file);
    /* a prévia desenha a partir DESTA <img>, então só some com a URL depois de
       desenhar a primeira vez (antes o revoke em 500ms podia matar o desenho) */
    _cropImgEl.onload=function(){ cropPreview(); };
    _cropImgEl.src=url;
    _cropUrl=url;
    $('cropSel').style.display='none';
    bg.classList.add('on');
  }
  function cropFechar(){
    var bg=$('cropBg'); if(bg) bg.classList.remove('on');
    if(_cropUrl){ var u=_cropUrl; _cropUrl=null; setTimeout(function(){ try{ URL.revokeObjectURL(u); }catch(_){} }, 800); }
  }
  /* v258 — PRÉVIA DO RECORTE.
     Desenha só o pedaço escolhido (ou a foto inteira, se não escolheu nada),
     ampliado e com o mesmo realce que vai pra IA. Serve pra pessoa ver se a
     placa está legível ANTES de gastar o token. */
  function cropPreview(){
    var box=$('cropPrev'), cv=$('cropPrevCv');
    if(!box||!cv||!_cropImgEl) return;
    var W=_cropImgEl.naturalWidth||0, H=_cropImgEl.naturalHeight||0;
    if(!W||!H){ box.classList.remove('on'); return; }
    var s=_cropSel;
    var sx=s?Math.round(s.x*W):0, sy=s?Math.round(s.y*H):0;
    var sw=s?Math.round(s.w*W):W,  sh=s?Math.round(s.h*H):H;
    if(sw<4||sh<4){ box.classList.remove('on'); return; }
    var maxW=Math.max(120, Math.min(420, (window.innerWidth||360)-40)), maxH=112;
    var f=Math.min(maxW/sw, maxH/sh);
    var cw=Math.max(1,Math.round(sw*f)), ch=Math.max(1,Math.round(sh*f));
    try{
      cv.width=cw; cv.height=ch;
      var cx=cv.getContext('2d'); if(cx.imageSmoothingQuality) cx.imageSmoothingQuality='high';
      cx.clearRect(0,0,cw,ch);
      cx.drawImage(_cropImgEl, sx,sy,sw,sh, 0,0,cw,ch);
      realcaCanvas(cv);
      box.classList.add('on');
    }catch(e){ box.classList.remove('on'); }
  }
  function cropWireDrag(){
    var stage=$('cropStage'), sel=$('cropSel'); var start=null, last=null;
    function pt(e){ var t=(e.touches&&e.touches[0])||e; return {x:t.clientX,y:t.clientY}; }
    function rct(){ return _cropImgEl.getBoundingClientRect(); }
    function draw(p){ last=p; var r=rct(), sr=stage.getBoundingClientRect();
      var x1=Math.min(start.x,p.x),y1=Math.min(start.y,p.y),x2=Math.max(start.x,p.x),y2=Math.max(start.y,p.y);
      x1=Math.max(x1,r.left); y1=Math.max(y1,r.top); x2=Math.min(x2,r.right); y2=Math.min(y2,r.bottom);
      sel.style.left=(x1-sr.left)+'px'; sel.style.top=(y1-sr.top)+'px'; sel.style.width=Math.max(0,x2-x1)+'px'; sel.style.height=Math.max(0,y2-y1)+'px';
    }
    function down(e){ start=pt(e); last=start; sel.style.display='block'; draw(start); if(e.cancelable)e.preventDefault(); }
    function move(e){ if(!start)return; draw(pt(e)); if(e.cancelable)e.preventDefault(); }
    function upf(){ if(!start)return; var r=rct();
      var x1=Math.min(start.x,last.x),y1=Math.min(start.y,last.y),x2=Math.max(start.x,last.x),y2=Math.max(start.y,last.y);
      x1=Math.max(x1,r.left); y1=Math.max(y1,r.top); x2=Math.min(x2,r.right); y2=Math.min(y2,r.bottom);
      if(x2-x1<12||y2-y1<12){ _cropSel=null; sel.style.display='none'; }
      else { _cropSel={x:(x1-r.left)/r.width,y:(y1-r.top)/r.height,w:(x2-x1)/r.width,h:(y2-y1)/r.height}; }
      start=null;
      cropPreview();   /* v258: soltou o dedo, a prévia já mostra o pedaço escolhido */
    }
    stage.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',upf);
    stage.addEventListener('touchstart',down,{passive:false}); stage.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',upf);
  }
  async function cropUsar(recortar){
    var file=_cropFile; if(!file){ cropFechar(); return; }
    var sel=_cropSel; cropFechar();
    try{
      /* v258: "Foto inteira" agora também passa pelo realce (contraste+nitidez),
         igualzinho à prévia — antes ia crua e lia pior. */
      var b64=(recortar&&sel)?await cropCanvas(file,sel):await cropCanvas(file,{x:0,y:0,w:1,h:1},1280);
      await lerPlacaBase64(b64);
    }catch(e){ toast('Não consegui processar a foto.'); }
  }
  /* Aprimora a foto da placa p/ leitura: contraste + nitidez (unsharp leve). */
  function realcaCanvas(cv){
    try{
      var ctx=cv.getContext('2d'), w=cv.width, h=cv.height;
      if(w<3||h<3) return;
      var img=ctx.getImageData(0,0,w,h), d=img.data, i;
      var C=1.22, I=128;
      for(i=0;i<d.length;i+=4){ d[i]=(d[i]-I)*C+I; d[i+1]=(d[i+1]-I)*C+I; d[i+2]=(d[i+2]-I)*C+I; }
      var src=new Uint8ClampedArray(d);
      var k=[0,-0.4,0,-0.4,2.6,-0.4,0,-0.4,0], y,x,c,ky,kx,s,ki,o;
      for(y=1;y<h-1;y++){ for(x=1;x<w-1;x++){ o=(y*w+x)*4;
        for(c=0;c<3;c++){ s=0; ki=0;
          for(ky=-1;ky<=1;ky++){ for(kx=-1;kx<=1;kx++){ s+=src[((y+ky)*w+(x+kx))*4+c]*k[ki++]; } }
          d[o+c]=s;
        }
      } }
      ctx.putImageData(img,0,0);
    }catch(e){}
  }
  /* maxLado (opcional): quando vem preenchido, a imagem é REDUZIDA pra caber
     nesse tamanho em vez de ser ampliada — é o caso do "Foto inteira". */
  function cropCanvas(file,selRel,maxLado){
    return new Promise(function(resolve,reject){
      var url=URL.createObjectURL(file); var im=new Image();
      im.onload=function(){ try{
        var W=im.naturalWidth,H=im.naturalHeight;
        var sx=Math.max(0,Math.round(selRel.x*W)), sy=Math.max(0,Math.round(selRel.y*H)), sw=Math.round(selRel.w*W), sh=Math.round(selRel.h*H);
        var scale=Math.min(2.4, 1100/Math.max(1,sw)); if(scale<1)scale=1;
        if(maxLado) scale=Math.min(1, maxLado/Math.max(1,Math.max(sw,sh)));
        var cw=Math.max(1,Math.round(sw*scale)), ch=Math.max(1,Math.round(sh*scale));
        var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
        var cx=cv.getContext('2d'); if(cx.imageSmoothingQuality)cx.imageSmoothingQuality='high';
        cx.drawImage(im,sx,sy,sw,sh,0,0,cw,ch);
        realcaCanvas(cv);
        URL.revokeObjectURL(url);
        resolve((cv.toDataURL('image/jpeg',0.92).split(',')[1])||'');
      }catch(e){ URL.revokeObjectURL(url); reject(e); } };
      im.onerror=function(){ URL.revokeObjectURL(url); reject(new Error('img')); };
      im.src=url;
    });
  }
  /* ===== v299 — TIRA AS FAIXAS DE FUNDO DA FOTO =====
     O PROBLEMA REAL: várias fotos que chegam de outros sistemas já vêm com
     faixas brancas coladas nas laterais — uma foto em pé colada no meio de um
     quadro deitado. Achei uma assim no estoque: 1200 pixels de largura, dos
     quais 693 eram branco puro. Nenhum ajuste de tela conserta isso, porque
     o branco É a foto: está gravado nos pixels.

     Aqui a faixa é cortada ANTES de subir. Sobra a foto de verdade, no
     formato dela — e aí o card preenche o quadro sozinho, porque ele já
     recorta o que sobra (object-fit:cover).

     COMO EU EVITO CORTAR O QUE NÃO DEVO: a coluna só conta como faixa se for
     uniforme de cima a baixo E muito clara ou muito escura. Um céu, uma
     parede ou um pátio têm variação e não passam nesse teste. Além disso só
     corto se as DUAS laterais tiverem faixa e sobrar pelo menos 30% da
     largura — assim uma foto legítima com uma borda clara de um lado só
     nunca é mexida. Na dúvida, devolve nulo e a foto sobe inteira. */
  function tirarFaixas(file){
    return new Promise(function(resolve){
      try{
        var url=URL.createObjectURL(file), im=new Image();
        im.onload=function(){
          try{
            var w=im.width, h=im.height;
            var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
            var g=cv.getContext('2d'); g.drawImage(im,0,0);
            var dados=g.getImageData(0,0,w,h).data;
            function pico(x,y){ var i=(y*w+x)*4; return [dados[i],dados[i+1],dados[i+2]]; }
            function ehFaixa(x){
              var c0=pico(x, Math.floor(h/2));
              var claro = c0[0]>238 && c0[1]>238 && c0[2]>238;
              var escuro= c0[0]<18  && c0[1]<18  && c0[2]<18;
              if(!claro && !escuro) return false;
              var passo=Math.max(1, Math.floor(h/24));
              for(var y=0; y<h; y+=passo){
                var c=pico(x,y);
                if(Math.abs(c[0]-c0[0])>10 || Math.abs(c[1]-c0[1])>10 || Math.abs(c[2]-c0[2])>10) return false;
              }
              return true;
            }
            var limite=Math.floor(w*0.42);
            var esq=0; while(esq<limite && ehFaixa(esq)) esq++;
            var dir=0; while(dir<limite && ehFaixa(w-1-dir)) dir++;
            URL.revokeObjectURL(url);
            var sobra=w-esq-dir;
            /* pouca faixa, faixa de um lado só, ou sobra pequena demais: não mexe */
            if(esq<w*0.06 || dir<w*0.06 || sobra<w*0.30){ resolve(null); return; }
            var out=document.createElement('canvas'); out.width=sobra; out.height=h;
            out.getContext('2d').drawImage(im, esq,0,sobra,h, 0,0,sobra,h);
            if(out.toBlob) out.toBlob(function(b){ resolve(b||null); },'image/jpeg',0.9);
            else resolve(null);
          }catch(_){ try{ URL.revokeObjectURL(url); }catch(__){} resolve(null); }
        };
        im.onerror=function(){ try{ URL.revokeObjectURL(url); }catch(_){} resolve(null); };
        im.src=url;
      }catch(_){ resolve(null); }
    });
  }
  /* Redimensiona a foto no navegador e devolve base64 JPEG (sem o prefixo data:) */
  function reduzirImagem(file, maxLado, q){
    return new Promise(function(resolve,reject){
      var url=URL.createObjectURL(file); var im=new Image();
      im.onload=function(){
        try{
          var w=im.width, h=im.height, esc=Math.min(1, maxLado/Math.max(w,h));
          var cw=Math.round(w*esc), ch=Math.round(h*esc);
          var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
          cv.getContext('2d').drawImage(im,0,0,cw,ch);
          var dataUrl=cv.toDataURL('image/jpeg', q||0.82);
          URL.revokeObjectURL(url);
          resolve(dataUrl.split(',')[1]||'');
        }catch(err){ URL.revokeObjectURL(url); reject(err); }
      };
      im.onerror=function(){ URL.revokeObjectURL(url); reject(new Error('img')); };
      im.src=url;
    });
  }

  /* Recorte da foto de perfil: arrastar pra posicionar + barra de zoom, dentro do círculo.
     Chama onDone(base64Jpeg) quando o usuário confirma; nada é enviado se cancelar. */
  function fotoCropAbrir(file, onDone, opts){
    /* v170: agora serve pra QUALQUER imagem, nao so' a foto de perfil.
       opts = { ar:largura/altura (1 = quadrado, 4/3 = foto de carro),
                out: largura final em pixels,
                redondo: true mostra a mascara redonda (foto de perfil),
                blob: true devolve um arquivo pronto pra enviar (em vez de base64),
                titulo / sub: textos do topo }
       'file' pode ser um arquivo escolhido no celular OU um endereco (link) de
       uma foto que ja' esta' na nuvem. */
    opts=opts||{};
    var AR=Number(opts.ar)||1;
    var SW=280, SH=Math.round(SW/AR); if(SH>340){ SH=340; SW=Math.round(SH*AR); }
    var OW=Math.round(Number(opts.out)||256), OH=Math.round(OW/AR);
    var redondo=(opts.redondo!==false)&&(AR===1);
    var ehLink=(typeof file==='string');
    var url=ehLink?file:URL.createObjectURL(file);
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox">'+
      '<div class="crop-tit">'+esc(opts.titulo||'Ajustar foto')+'</div>'+
      '<div class="crop-sub">'+esc(opts.sub||'Arraste pra posicionar · pinça, rodinha ou barra pra dar zoom · ou toque em "Selecionar área" e arraste em cima do que você quer')+'</div>'+
      /* 🔴 v1070 (pedido do Angelo): "ao clicar em enquadrar permita nao apenas
         o zoom, mas selecionar arrastando a area da foto desejada".
         Dois modos, porque o MESMO arraste não pode fazer as duas coisas:
         mover a foto e desenhar um retângulo são gestos idênticos. */
      '<div class="crop-modos" role="group" aria-label="Como ajustar a foto">'+
        '<button type="button" class="crop-md on" data-cmd="mover" aria-pressed="true">Mover</button>'+
        '<button type="button" class="crop-md" data-cmd="area" aria-pressed="false">Selecionar área</button>'+
      '</div>'+
      '<div class="crop-stage" style="width:'+SW+'px;height:'+SH+'px"><canvas id="cropCv" width="'+SW+'" height="'+SH+'"></canvas>'+(redondo?'<div class="crop-ring" style="width:'+SW+'px;height:'+SH+'px"></div>':'')+'<div class="crop-area" id="cropArea" hidden></div></div>'+
      '<div class="crop-zoom"><span>−</span><input type="range" id="cropZoom" min="1" max="3" step="0.01" value="1"><span>+</span></div>'+
      '<div class="crop-acts"><button type="button" class="crop-c" id="cropCancel">Cancelar</button><button type="button" class="crop-ok" id="cropOk">Usar foto</button></div>'+
      '</div>';
    document.body.appendChild(ov);
    var cv=ov.querySelector('#cropCv'), ctx=cv.getContext('2d'), zin=ov.querySelector('#cropZoom');
    var im=new Image(), scale=1, minScale=1, ox=0, oy=0, drag=false, lx=0, ly=0;
    if(ehLink){ try{ im.crossOrigin='anonymous'; }catch(_){} }
    function clamp(){ var w=im.width*scale, h=im.height*scale; if(ox>0)ox=0; if(oy>0)oy=0; if(ox<SW-w)ox=SW-w; if(oy<SH-h)oy=SH-h; }
    function draw(){ ctx.fillStyle='#0b1c3a'; ctx.fillRect(0,0,SW,SH); if(im.width) ctx.drawImage(im, ox, oy, im.width*scale, im.height*scale); }
    im.onload=function(){ minScale=Math.max(SW/im.width, SH/im.height); scale=minScale; zin.value=1;
      ox=(SW-im.width*scale)/2; oy=(SH-im.height*scale)/2; clamp(); draw(); };
    im.onerror=function(){ toast('Não consegui abrir essa imagem'); fechar(); };
    im.src=url;
    zin.oninput=function(){ zoomPara(minScale*(parseFloat(this.value)||1), SW/2, SH/2); };
    /* ===== v306 (pedido) — ENQUADRAR COM O DEDO ============================
       "permita arrastar pra enquadrar a foto depois do enquadramento
        automatico ... ou dando zoom e diminuindo zoom".

       Arrastar ja existia. O que faltava era o gesto que a pessoa TENTA
       primeiro num celular: a PINCA. E, no computador, a rodinha do mouse.
       Sem eles, a unica forma de dar zoom era achar a barrinha embaixo.

       Zoom sempre em torno do PONTO DO GESTO (o meio dos dois dedos, ou o
       cursor), nao do centro da tela: e assim que todo aplicativo de foto
       funciona, e e o que deixa mirar num detalhe sem perde-lo de vista. */

    /* aplica um zoom novo mantendo fixo o ponto (cx,cy) da tela */
    function zoomPara(ns, cx, cy){
      var max=minScale*3;
      if(ns<minScale) ns=minScale;      /* o minimo continua sendo PREENCHER o
                                           quadro: abaixo disso voltariam as
                                           faixas brancas que a v301 tirou */
      if(ns>max) ns=max;
      if(ns===scale) return;
      ox=cx-(cx-ox)*(ns/scale); oy=cy-(cy-oy)*(ns/scale); scale=ns;
      clamp(); draw();
      try{ zin.value=String(scale/minScale); }catch(_){}   /* a barra acompanha */
    }
    function pt(e){ var t=e.touches&&e.touches[0]; return {x:(t?t.clientX:e.clientX), y:(t?t.clientY:e.clientY)}; }
    /* distancia e meio entre dois dedos */
    function dois(e){
      var a=e.touches[0], b=e.touches[1];
      var r=cv.getBoundingClientRect();
      return { d:Math.hypot(a.clientX-b.clientX, a.clientY-b.clientY),
               x:((a.clientX+b.clientX)/2)-r.left, y:((a.clientY+b.clientY)/2)-r.top };
    }
    var pinca=null;
    /* ======================================================================
       🔴🔴 v1070 — SELECIONAR ARRASTANDO A ÁREA
       ----------------------------------------------------------------------
       🔑 A DECISÃO QUE FAZ ISTO SER BARATO: a seleção NÃO cria um segundo
       caminho de saída. Ela só traduz o retângulo desenhado em `scale`, `ox`
       e `oy` — os mesmos três números que o arraste e o zoom já usam. O
       `cropOk` não muda uma vírgula, e por isso não há um segundo jeito de a
       foto sair errada.

       ⚠️ O RETÂNGULO É PRESO NA PROPORÇÃO DE SAÍDA. Deixar desenhar livre
       seria mentira: a foto sai em `AR` de qualquer jeito, então um retângulo
       de outra forma prometeria um corte que não vai acontecer.

       ⚠️ TETO DE ZOOM. Selecionar um pedaço menor que 1/3 do quadro pediria
       mais de 3× — que é o teto que existe pra foto não sair borrada. Nesse
       caso ele vai até o teto e CENTRALIZA no que foi escolhido: entrega o
       mais perto possível, em vez de recusar o gesto.

       ⚠️ E arraste curto (menos de 18px) NÃO é seleção: é toque. Sem esse
       piso, um dedo trêmulo jogaria a foto no zoom máximo.
       ====================================================================== */
    /* 🔴🔴 O NOME NÃO PODE SER `crop-sel`, E ISSO NÃO É FRESCURA.
       Já existe uma `.crop-sel` / `#cropSel` neste mesmo arquivo: o retângulo
       do `cropAbrir` — o recorte da foto de PLACA, que a v861 desligou
       (`MEV_FOTO_RECORTE=false`) mas deixou INTEIRO de propósito ("desligar
       mostrando o caminho, nunca apagando").
       Reusar o nome não quebraria nada hoje, porque aquela tela não abre. Ele
       quebraria no dia em que alguém religasse o `MEV_FOTO_RECORTE`: a minha
       regra de CSS, por vir depois, repintaria o retângulo daquela ferramenta
       — borda branca no lugar da ciano, sem ninguém entender por quê.
       ⚠️ Quem me mostrou isto foi um MUTANTE que sobreviveu: tirei o
          `pointer-events:none` do meu bloco e a régua continuou verde, porque
          ela estava casando com a OUTRA `.crop-sel`. O mutante não achou um
          defeito no recurso; achou um defeito no NOME. */
    var modo='mover', sel=null, selBox=ov.querySelector('#cropArea');
    var SEL_MIN=18;
    function selMostra(r){
      if(!selBox) return;
      if(!r){ selBox.hidden=true; return; }
      selBox.hidden=false;
      selBox.style.left=r.x+'px'; selBox.style.top=r.y+'px';
      selBox.style.width=r.w+'px'; selBox.style.height=r.h+'px';
    }
    /* o retângulo que o dedo desenhou, já preso na proporção e dentro do quadro */
    function selRet(x0,y0,x1,y1){
      var w=Math.abs(x1-x0), h=Math.abs(y1-y0);
      if(w<SEL_MIN && h<SEL_MIN) return null;
      /* prende na proporção: manda quem for maior em relação ao alvo */
      if(w/h > SW/SH) h=w*SH/SW; else w=h*SW/SH;
      var x=(x1<x0)?(x0-w):x0, y=(y1<y0)?(y0-h):y0;
      /* não deixa sair do quadro — arrastar pra fora é comum e não pode
         virar um recorte com borda vazia */
      if(x<0) x=0; if(y<0) y=0;
      if(x+w>SW) x=SW-w; if(y+h>SH) y=SH-h;
      if(w>SW){ w=SW; h=SH; x=0; y=0; }
      return { x:x, y:y, w:w, h:h };
    }
    /* traduz o retângulo em scale/ox/oy — a única coisa que a seleção faz */
    function selAplica(r){
      if(!r || !(r.w>0)) return;
      var f=SW/r.w, alvo=scale*f, teto=minScale*3;
      if(alvo>teto) f=teto/scale;
      var cx=r.x+r.w/2, cy=r.y+r.h/2;
      /* mantém fixo o CENTRO do que foi escolhido: se o zoom bater no teto,
         o pedaço escolhido continua no meio da tela, só um pouco maior. */
      ox=(SW/2)-((cx-ox)*f); oy=(SH/2)-((cy-oy)*f);
      scale=scale*f;
      clamp(); draw();
      try{ zin.value=String(scale/minScale); }catch(_){}
    }
    function modoSet(k){
      modo=(k==='area')?'area':'mover';
      sel=null; selMostra(null);
      Array.prototype.forEach.call(ov.querySelectorAll('[data-cmd]'),function(b){
        var on=(b.getAttribute('data-cmd')===modo);
        b.classList.toggle('on',on); b.setAttribute('aria-pressed',on?'true':'false');
      });
      try{ cv.style.cursor=(modo==='area')?'crosshair':'grab'; }catch(_){}
    }
    Array.prototype.forEach.call(ov.querySelectorAll('[data-cmd]'),function(b){
      b.onclick=function(){ modoSet(b.getAttribute('data-cmd')); };
    });

    function down(e){
      if(e.touches && e.touches.length>=2){ drag=false; sel=null; selMostra(null); pinca={ base:dois(e), escala:scale }; if(e.cancelable) e.preventDefault(); return; }
      var p=pt(e), r=cv.getBoundingClientRect();
      if(modo==='area'){
        drag=false; sel={ x0:p.x-r.left, y0:p.y-r.top };
        selMostra(null); if(e.cancelable) e.preventDefault(); return;
      }
      drag=true; lx=p.x; ly=p.y; if(e.cancelable) e.preventDefault();
    }
    function move(e){
      if(e.touches && e.touches.length>=2 && pinca){
        var g=dois(e);
        if(pinca.base.d>0) zoomPara(pinca.escala*(g.d/pinca.base.d), g.x, g.y);
        if(e.cancelable) e.preventDefault();
        return;
      }
      if(sel){
        var ps=pt(e), rs=cv.getBoundingClientRect();
        sel.x1=ps.x-rs.left; sel.y1=ps.y-rs.top;
        selMostra(selRet(sel.x0,sel.y0,sel.x1,sel.y1));
        if(e.cancelable) e.preventDefault();
        return;
      }
      if(!drag) return;
      var p=pt(e); ox+=(p.x-lx); oy+=(p.y-ly); lx=p.x; ly=p.y; clamp(); draw(); if(e.cancelable) e.preventDefault();
    }
    function up(e){
      /* solta a pinca so quando SAI o segundo dedo; se solto antes, o dedo
         que ficou dava um pulo na foto ao virar arraste. */
      if(pinca && (!e || !e.touches || e.touches.length<2)) pinca=null;
      if(sel){
        var r=(sel.x1!=null)?selRet(sel.x0,sel.y0,sel.x1,sel.y1):null;
        sel=null; selMostra(null);
        if(r) selAplica(r);
        /* 🔑 VOLTA PRO "MOVER" SOZINHO. Escolher a área é um gesto de UMA vez;
           depois dele o que a pessoa quer é ajustar. Deixar o modo ligado
           faria o próximo arraste apagar a escolha que ela acabou de fazer. */
        modoSet('mover');
      }
      drag=false;
    }
    function roda(e){
      if(e.cancelable) e.preventDefault();
      var r=cv.getBoundingClientRect();
      var f=(e.deltaY<0)?1.12:(1/1.12);
      zoomPara(scale*f, e.clientX-r.left, e.clientY-r.top);
    }
    cv.addEventListener('mousedown',down); cv.addEventListener('touchstart',down,{passive:false});
    cv.addEventListener('wheel',roda,{passive:false});
    window.addEventListener('mousemove',move); window.addEventListener('touchmove',move,{passive:false});
    window.addEventListener('mouseup',up); window.addEventListener('touchend',up);
    function fechar(){ if(!ehLink){ try{ URL.revokeObjectURL(url); }catch(_){} }
      window.removeEventListener('mousemove',move); window.removeEventListener('touchmove',move);
      window.removeEventListener('mouseup',up); window.removeEventListener('touchend',up);
      try{ ov.remove(); }catch(_){}
    }
    ov.querySelector('#cropCancel').onclick=fechar;
    ov.querySelector('#cropOk').onclick=function(){
      try{ var o=document.createElement('canvas'); o.width=OW; o.height=OH; var g=o.getContext('2d'); var k=OW/SW;
        g.fillStyle='#ffffff'; g.fillRect(0,0,OW,OH);
        g.drawImage(im, ox*k, oy*k, im.width*scale*k, im.height*scale*k);
        if(opts.blob){
          if(o.toBlob){ o.toBlob(function(b){ fechar(); onDone(b||null); }, 'image/jpeg', 0.88); return; }
          fechar(); onDone(null); return;
        }
        var b64=o.toDataURL('image/jpeg',0.85).split(',')[1]||''; fechar(); onDone(b64);
      }catch(e){ fechar(); toast('Não consegui recortar a imagem'); }
    };
  }

  /* ===== v1488 — TELA ÚNICA DOS PROCESSOS ==================================
     Consultas, páginas e relatórios passam a ocupar uma página de espera
     própria. A marca abaixo reutiliza literalmente o escudo com lupa da
     entrada após o login. Na espera, o desenho reinicia enquanto a operação
     continua; não há vídeo pesado, download externo nem spinner concorrente. */
  function mevProcessoMarcaHtml(){
    var ed=''; try{ ed=typeof edicaoAtual==='function'?edicaoAtual():''; }catch(_){}
    var nome=ed==='avalia'?'MEV Avaliações':(ed==='consultas'?'MEV Consultas':'MEV Veículos');
    var frase=ed==='avalia'?'Avalie com segurança':(ed==='consultas'?'Consulte com segurança':'Informação para decisões seguras');
    return '<div class="mev-process-media" aria-hidden="true">'
      +mevEscudoBuscaHtml('mev-login-intro-marca mev-processo-escudo')
      +'<div class="mev-process-brand"><strong>'+nome+'</strong><span>'+frase+'</span></div>'
    +'</div>';
  }

  var _pgLoadSeq=0;
  function pgLoadComeca(id){
    var tentativas=0;
    function ligar(){
      var raiz=document.querySelector('[data-pg-load="'+id+'"]');
      if(!raiz){ if(tentativas++<12) setTimeout(ligar,40); return; }
      var pct=raiz.querySelector('.pg-load-pct'), fill=raiz.querySelector('.pg-load-track i'), track=raiz.querySelector('.pg-load-track');
      var inicio=Date.now(), total=12000;
      var timer=setInterval(function(){
        if(!document.documentElement.contains(raiz)){ clearInterval(timer); return; }
        var passou=Date.now()-inicio;
        var valor=Math.max(6,Math.min(92,6+(passou/total)*86));
        if(fill) fill.style.width=valor.toFixed(1)+'%';
        if(pct) pct.textContent=Math.round(valor)+'% estimado'+(valor>=92?' · Processando':'');
        if(track){ track.setAttribute('aria-valuenow',Math.round(valor)); track.setAttribute('aria-valuetext',valor>=92?'Processando, 92% estimado':Math.round(valor)+'% estimado'); }
      },240);
    }
    setTimeout(ligar,0);
  }

  /* ===== v1323/v1488 — BARRA PADRÃO DAS PÁGINAS EM CARREGAMENTO ============
     O helper continua sendo a única porta dos carregamentos genéricos, mas o
     anel com carro sai. A barra mostra andamento estimado, avança até 92% e
     permanece em processamento até a resposta real substituir a página. */
  function pgLoad(txt){
    txt=txt||'Carregando…';
    var id='pg'+(++_pgLoadSeq); pgLoadComeca(id);
    return '<div class="pg-load mev-process-page" data-pg-load="'+id+'" role="status" aria-live="polite">'+mevProcessoMarcaHtml()+'<div class="pg-load-head"><b>'+esc(txt)+'</b><span class="pg-load-pct">6% estimado</span></div><div class="pg-load-track" role="progressbar" aria-label="'+esc(txt)+'" aria-valuemin="0" aria-valuemax="100" aria-valuenow="6" aria-valuetext="6% estimado"><i style="width:6%"></i></div></div>';
  }

/* ╔═══ src/app/01b-dispositivos.js ═══════════════════════════════════════ */
  /* ==========================================================================
     01b — APARELHOS CONECTADOS + LOGIN DIÁRIO (v407, pedido)

     O navegador não deixa ler o número de série do celular (privacidade).
     Então o app cria a PRÓPRIA identidade do aparelho na primeira visita
     (mev_device_id no localStorage) e a registra na tabela mp_dispositivos.

     As regras (v479, pedido do Angelo em 15/08 — antes havia a pergunta
     "Manter conectado?", removida por ser ruído):
     1. Todo aparelho comum fica logado até 23:59. A conta proprietária do
        MEVveiculos conserva a sessão oficial no mesmo aparelho entre dias.
     2. Minha conta → Acesso lista os aparelhos da conta, com "Desconectar"
        (o aparelho desconectado cai no login na próxima abertura).

     ⚠️ Este arquivo EMBRULHA o entrar() do 01-nucleo (o app é um IIFE só,
     então reatribuir o nome vale pra todo mundo) e encosta no onclick do
     btnAuth só pra saber que o login é novo. Pra desligar tudo: apagar este
     arquivo e rodar o montar.js (o app volta ao comportamento de antes).
     ========================================================================= */

  function devId(){
    try{
      var id=localStorage.getItem('mev_device_id');
      if(!id){
        id=(typeof crypto!=='undefined'&&crypto.randomUUID)?crypto.randomUUID():('dev-'+Date.now()+'-'+Math.random().toString(36).slice(2,10));
        localStorage.setItem('mev_device_id',id);
      }
      return id;
    }catch(_){ return 'dev-sem-storage'; }
  }
  /* nome legível: "iPhone · Safari · app instalado" */
  function devNome(){
    var ua=String(navigator.userAgent||''), so='Aparelho', nav='navegador';
    if(/iPhone/i.test(ua)) so='iPhone'; else if(/iPad/i.test(ua)) so='iPad';
    else if(/Android/i.test(ua)) so='Android'; else if(/Macintosh/i.test(ua)) so='Mac';
    else if(/Windows/i.test(ua)) so='Windows'; else if(/Linux/i.test(ua)) so='Linux';
    if(/Edg\//i.test(ua)) nav='Edge'; else if(/OPR\//i.test(ua)) nav='Opera';
    else if(/SamsungBrowser/i.test(ua)) nav='Samsung Internet';
    else if(/Chrome\//i.test(ua)) nav='Chrome'; else if(/Firefox\//i.test(ua)) nav='Firefox';
    else if(/Safari\//i.test(ua)) nav='Safari';
    var inst=false; try{ inst=(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true; }catch(_){}
    return so+' · '+nav+(inst?' · app instalado':'');
  }
  /* A conta proprietária do MEVveiculos conserva a sessão do Supabase neste
     aparelho. A exceção usa o ID confirmado da sessão — nunca nome, e-mail ou
     metadata editável — e não substitui a autenticação: sair, trocar a senha,
     revogar a sessão ou desconectar o aparelho continuam encerrando o acesso. */
  var DEV_CONTA_PERSISTENTE='1b0ce2c8-9597-4340-8fa0-daf1dcfe0bc8';
  function devSessaoPermanente(){
    return String((typeof meuId!=='undefined'&&meuId)||'')===DEV_CONTA_PERSISTENTE;
  }
  /* O "dia" do login usa a data LOCAL do aparelho. A sessão vale até
     23:59:59; na primeira verificação depois de 00:00, pede a senha. */
  function devHoje(){ var d=new Date(); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  /* ===== v1012 — UMA SESSÃO POR DIA CIVIL ================================
     No MESMO aparelho, recarregar, atualizar o PWA ou voltar do segundo
     plano nunca pede senha de novo durante o dia. A validade termina na
     virada do calendário local, não 24 horas corridas depois do toque.

     Outro aparelho não herda este carimbo nem a sessão do Supabase porque
     ambos ficam no armazenamento local daquele navegador. Portanto ele
     continua exigindo o próprio login. A lista de aparelhos e o teto de
     segurança permanecem iguais.

     Migração: instalações da regra antiga de sete dias já têm
     `mev_login_em`. Transformamos esse instante em dia local uma vez. Se o
     login foi hoje, segue sem interrupção; se foi antes, pede a senha. Uma
     instalação sem qualquer carimbo adota hoje silenciosamente para que um
     deploy não derrube quem já estava autenticado. */
  function devSessaoVenceu(){
    if(devSessaoPermanente()) return false;
    var hoje=devHoje(), dia='';
    try{ dia=String(localStorage.getItem('mev_login_dia')||''); }catch(_){}
    if(!dia){
      var em=0; try{ em=Number(localStorage.getItem('mev_login_em'))||0; }catch(_){}
      if(em){
        var d=new Date(em);
        dia=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
      } else dia=hoje;
      try{ localStorage.setItem('mev_login_dia',dia); }catch(_){}
    }
    return dia!==hoje;
  }
  function devSessaoMarcarHoje(){
    try{ localStorage.setItem('mev_login_dia',devHoje()); }catch(_){}
    try{ localStorage.setItem('mev_login_em',String(Date.now())); }catch(_){}
  }
  var _devViradaTm=0;
  function devAgendarVirada(){
    try{
      clearTimeout(_devViradaTm);
      if(devSessaoPermanente()) return;
      var agora=new Date(), prox=new Date(agora.getFullYear(),agora.getMonth(),agora.getDate()+1,0,0,0,250);
      _devViradaTm=setTimeout(function(){
        if(token && devSessaoVenceu()) devSairForcado('O dia virou — entre de novo para continuar.');
      },Math.max(1000,prox.getTime()-agora.getTime()));
    }catch(_){}
  }
  /* v479 (pedido do Angelo: "remova, fica ruído"): a pergunta "Manter
     conectado?" SAIU DE CENA, junto com a preferência mev_manter. A regra
     comum continua diária; a exceção proprietária fica isolada em
     devSessaoPermanente(). */
  var _devLoginNovo=false, _devCheckTs=0;

  async function devRegistrar(){
    try{
      if(!meuId) return;
      await withTimeout(supa.from('dispositivos').upsert({
        device_id:devId(), user_id:meuId, nome:devNome(),
        manter:false, ativo:true, visto_em:new Date().toISOString()
      },{onConflict:'device_id,user_id'}),8000);
    }catch(_){}
  }

  /* o aparelho foi desconectado pela lista da Minha conta? */
  async function devChecarRemoto(){
    try{
      if(!meuId) return;
      var agora=Date.now(); if(agora-_devCheckTs<60000) return; _devCheckTs=agora;
      /* v464: a batida também atualiza o visto_em DESTE aparelho — é esse
         carimbo de hora que deixa o alarme do /admin enxergar dois aparelhos
         usando a conta NO MESMO momento (não só no mesmo dia). */
      try{ supa.from('dispositivos').update({visto_em:new Date().toISOString()}).eq('device_id',devId()).eq('user_id',meuId).then(function(){},function(){}); }catch(_){}
      var r=await withTimeout(supa.from('dispositivos').select('ativo').eq('device_id',devId()).eq('user_id',meuId).limit(1),8000);
      var row=r&&r.data&&r.data[0];
      if(row && row.ativo===false) devSairForcado('Este aparelho foi desconectado da conta.');
      /* 🔴🔴 v701 — A QUEDA PELO CARIMBO SAIU DE CENA (pedido do Angelo,
         29/08: "cada vez que subo deploy e atualiza, o app pede login
         novamente, nao peca"). O que acontecia: a sessão única da v461
         derrubava CALADA (v477) qualquer aparelho que não fosse o último a
         logar — celular entrava, computador caía; computador entrava,
         celular caía. Pro Angelo isso parecia "o deploy desloga", porque é
         na volta do deploy que ele troca de aparelho.
         O anti-empréstimo NÃO acabou — ele mudou de guarda:
           · o TETO de 3 aparelhos (v462) — que a v701 CONSERTOU: a tabela
             'dispositivos' faltava no MP_TAB e os aparelhos eram gravados
             na tabela do outro app; a mp_dispositivos estava VAZIA e o
             teto nunca tinha derrubado ninguém;
           · a lista "Aparelhos conectados" com o desconectar (ativo=false,
             checado logo acima) — o dono derruba quem quiser;
           · o código por e-mail na reincidência (v464), que só o dono tem.
         O carimbo CONTINUA sendo gravado (devSessaoCarimbar) — o /admin lê.
         ⛳ Pra voltar à sessão única: reponha aqui o
            if(pf && pf.sessao_dispositivo && pf.sessao_dispositivo!==devId()){ devQuedaSessao(); return; } */
      var r2=await withTimeout(supa.from('perfil').select('sessao_dispositivo').eq('user_id',meuId).limit(1),8000);
      if(r2 && !r2.error && Array.isArray(r2.data)){
        var pf=r2.data[0];
        if(!pf || !pf.sessao_dispositivo) devSessaoCarimbar();   /* conta antiga sem carimbo: este aparelho adota */
      }
    }catch(_){}
  }
  function devSairForcado(msg){
    try{ localStorage.removeItem('mev_manter'); }catch(_){}
    try{ toast(msg||'Sessão encerrada.'); }catch(_){}
    setTimeout(function(){ _hardLogout(); location.reload(); },900);
  }

  /* ===== v461 — SESSÃO ÚNICA (anti-empréstimo de senha) ===================
     Quem digitou a senha por último vira o DONO da sessão (carimbo no
     mp_perfil). Outro aparelho com a mesma conta cai com a mensagem
     amigável — e o botão que transforma o empréstimo em venda de assento.
     REGRAS: só derruba com resposta POSITIVA do banco (erro de rede nunca
     derruba); duas abas do MESMO computador têm o mesmo device_id e não
     caem; cada membro da equipe tem a própria conta e não é afetado. */
  async function devSessaoCarimbar(){
    try{
      if(!meuId) return;
      await withTimeout(supa.from('perfil').upsert({
        user_id:meuId, sessao_dispositivo:devId(), sessao_em:new Date().toISOString()
      },{onConflict:'user_id'}),8000);
    }catch(_){}
  }
  /* v462 — TETO DE APARELHOS (parte B): no login, mais de 3 ativos na conta
     derruba o de uso MAIS ANTIGO (update ativo=false, nunca delete) e avisa
     no aparelho novo. ⚠️ nunca 1 só — lojista usa celular + computador. */
  var DEV_TETO=3;
  async function devTeto(){
    try{
      if(!meuId) return;
      var r=await withTimeout(supa.from('dispositivos').select('device_id,nome,visto_em').eq('user_id',meuId).eq('ativo',true).order('visto_em',{ascending:false}),8000);
      if(!r || r.error || !Array.isArray(r.data)) return;   /* erro de rede não mexe em nada */
      var rows=r.data;
      if(rows.length<=DEV_TETO) return;
      var sobra=rows.slice(DEV_TETO).filter(function(d){ return d.device_id!==devId(); });
      for(var i=0;i<sobra.length;i++){
        await supa.from('dispositivos').update({ativo:false}).eq('device_id',sobra[i].device_id).eq('user_id',meuId);
        /* v917 — O AVISO SAIU DA ABERTURA (pedido do Angelo, 06/09, com print).
           O TETO CONTINUA VALENDO: o aparelho mais antigo é derrubado do mesmo
           jeito, na mesma hora. O que sumiu é só o RECADO na tela.
           Ele nascia no meio da tela inicial toda vez que a conta passava de
           DEV_TETO aparelhos — contando uma coisa que o dono da conta já sabe
           (é ele mesmo trocando de celular/computador) e sem NENHUMA ação pra
           tomar. Aviso que não pede nada e volta sempre é ruído, e ruído é o
           que ensina a pessoa a fechar o toast sem ler — inclusive no dia em
           que o toast importar.
           👉 Onde o recado TEM onde agir: Minha conta → Acesso lista os
              aparelhos da conta com o botão Desconectar. */
      }
    }catch(_){}
  }
  /* ===== v464 — SESSÃO ÚNICA parte C: código por e-mail na reincidência ====
     O /admin marca a conta suspeita (mp_perfil.reauth_exigir) e o PRÓXIMO
     login trava até a pessoa digitar o código de 6 dígitos que foi pro
     E-MAIL DO DONO. Quem pegou a senha emprestada não tem o e-mail.
     REGRAS (as mesmas da v461): só tranca com resposta POSITIVA do servidor.
     Erro de rede, function fora do ar (antes do deploy) ou e-mail sem
     configuração NUNCA viram cadeado — nesses casos o app segue normal. */
  async function devReauthChecar(){
    try{
      if(!meuId) return;
      var r=await withTimeout(supa.from('perfil').select('reauth_exigir').eq('user_id',meuId).limit(1),8000);
      if(!(r && !r.error && Array.isArray(r.data))) return;   /* rede ruim: segue */
      var pf=r.data[0];
      if(pf && pf.reauth_exigir===true) devReauthGate();
    }catch(_){}
  }
  async function _devReauthApi(body){
    try{
      var r=await fetch('/api/reauth',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify(Object.assign({token:token},body)) });
      var d=null; try{ d=await r.json(); }catch(_){}
      return d;
    }catch(_){ return null; }   /* function fora do ar = null = não tranca */
  }
  async function devReauthGate(){
    if(document.getElementById('devReauth')) return;
    var ped=await _devReauthApi({acao:'pedir'});
    if(!ped){ return; }                                   /* rede/deploy: segue */
    if(ped.dispensado){ return; }                         /* flag já caiu */
    if(ped.skipped || !ped.ok){ return; }                 /* e-mail sem config: segue */
    var bg=document.createElement('div'); bg.className='cropmask'; bg.id='devReauth';
    bg.innerHTML='<div class="cropbox dev-qd">'+
      '<div class="crop-tit">Confirme que é você 🔐</div>'+
      '<p class="dev-qd-tx">Por segurança, mandamos um código de 6 dígitos pro e-mail <b>'+esc(ped.para||'da conta')+'</b>. Digite abaixo pra continuar.</p>'+
      '<input id="devRqCode" class="cad-in" inputmode="numeric" maxlength="6" placeholder="______" autocomplete="one-time-code" style="text-align:center;letter-spacing:9px;font-size:23px;font-weight:800">'+
      '<div class="cad-msg" id="devRqMsg" style="min-height:14px"></div>'+
      '<button type="button" class="cad-btn" id="devRqOk">Confirmar</button>'+
      '<button type="button" class="link" id="devRqSair">Sair da conta</button>'+
    '</div>';
    document.body.appendChild(bg);
    var inp=document.getElementById('devRqCode');
    setTimeout(function(){ try{ inp.focus(); }catch(_){} },150);
    inp.oninput=function(){ this.value=this.value.replace(/\D/g,'').slice(0,6); };
    inp.onkeydown=function(e){ if(e.key==='Enter') document.getElementById('devRqOk').click(); };
    document.getElementById('devRqSair').onclick=function(){ try{ bg.remove(); }catch(_){} devSairForcado('Sessão encerrada.'); };
    var erros=0;
    document.getElementById('devRqOk').onclick=async function(){
      var b=this, m=document.getElementById('devRqMsg');
      var c=String(inp.value||'').replace(/\D/g,'');
      if(c.length<6){ m.className='cad-msg err'; m.textContent='Digite os 6 dígitos do código.'; return; }
      b.disabled=true; m.className='cad-msg'; m.textContent='Conferindo…';
      var d=await _devReauthApi({acao:'conferir', codigo:c});
      b.disabled=false;
      if(!d){ m.className='cad-msg err'; m.textContent='Sem conexão. Tente de novo.'; return; }
      if(d.ok){ try{ bg.remove(); }catch(_){} toast('Confirmado ✓ Bem-vindo de volta.'); return; }
      erros++;
      m.className='cad-msg err'; m.textContent=d.erro||'Código errado.';
      /* três erros de código = não é o dono: derruba (resposta POSITIVA) */
      if(d.errado && erros>=3){ try{ bg.remove(); }catch(_){} devSairForcado('Código errado três vezes. Entre de novo — e, se não foi você, troque a senha.'); }
    };
  }
  /* v477 — QUEDA SILENCIOSA (pedido do Angelo, 14/08): a tela "Sua conta
     entrou em outro aparelho", com o botão da equipe (v461), SAIU DE CENA.
     Entrou em outro aparelho? Este aqui simplesmente cai pra tela de login,
     sem aviso nenhum — quem entrou por último fica com a sessão.
     As REGRAS de segurança continuam as da v461: só derruba com resposta
     POSITIVA do banco (erro de rede nunca derruba) e duas abas do MESMO
     computador têm o mesmo device_id, então não caem.
     (o reload é indireto — _devReload — só pra dar pra testar sem recarregar) */
  var _devQuedaJa=false;
  var _devReload=function(){ location.reload(); };
  function devQuedaSessao(){
    if(_devQuedaJa) return; _devQuedaJa=true;
    try{ _hardLogout(); }catch(_){}
    setTimeout(function(){ _devReload(); },200);
  }

  /* ---------- lista "Aparelhos conectados" (Minha conta → Acesso) ---------- */
  async function devListaPinta(){
    var el=$('devLista'); if(!el||!meuId) return;
    el.innerHTML='<div style="font-size:12.5px;color:#94a3b8">Carregando…</div>';
    var rows=[];
    try{
      var r=await withTimeout(supa.from('dispositivos').select('*').eq('user_id',meuId).order('visto_em',{ascending:false}).limit(20),8000);
      rows=(r&&r.data)||[];
    }catch(_){}
    if(!rows.length){ el.innerHTML='<div style="font-size:12.5px;color:#94a3b8">Nenhum aparelho registrado ainda.</div>'; return; }
    var meu=devId();
    el.innerHTML=rows.map(function(d){
      var atual=(String(d.device_id)===meu), off=(d.ativo===false);
      var quando=''; try{ quando=new Date(d.visto_em).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}); }catch(_){}
      return '<div class="dev-row'+(off?' off':'')+'">'
        +'<div class="dev-info"><b>'+esc(d.nome||'Aparelho')+'</b>'
        +(atual?'<span class="dev-tag azul">este aparelho</span>':'')
        /* v479: a etiqueta conectado/senha-diária saiu — a regra é uma só */
        +'<small>'+(off?'desconectado':('visto '+quando))+'</small></div>'
        +(off?'':('<button type="button" class="cad-btn sec dev-x" data-dev="'+esc(String(d.device_id))+'">Desconectar</button>'))
        +'</div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.dev-x'),function(b){
      b.onclick=async function(){
        var id=b.getAttribute('data-dev');
        var ehEste=(id===meu);
        if(!confirm(ehEste?'Desconectar ESTE aparelho? Você volta pra tela de login.':'Desconectar este aparelho? Ele cai no login na próxima abertura.')) return;
        b.disabled=true;
        try{
          var r=await supa.from('dispositivos').update({ativo:false,manter:false}).eq('device_id',id).eq('user_id',meuId);
          if(r&&r.error) throw r.error;
          if(ehEste){ devSairForcado('Aparelho desconectado.'); return; }
          toast('Aparelho desconectado.');
          devListaPinta();
        }catch(_){ b.disabled=false; toast('Não consegui desconectar agora.'); }
      };
    });
  }

  /* ---------- os ganchos ---------- */
  /* marca "login novo" quando o Entrar é clicado (diferencia de sessão salva) */
  try{
    var _devBa=$('btnAuth');
    if(_devBa && _devBa.onclick){
      var _devBaOrig=_devBa.onclick;
      _devBa.onclick=function(){ _devLoginNovo=true; return _devBaOrig.apply(this,arguments); };
    }
  }catch(_){}

  /* embrulha o entrar(): checa o dia ANTES de abrir; registra/pergunta DEPOIS */
  var _devEntrarOrig=entrar;
  entrar=async function(){
    var novo=_devLoginNovo; _devLoginNovo=false;
    if(novo){
      devSessaoMarcarHoje();
    } else {
      if(devSessaoVenceu()){
        _hardLogout();
        show('scAuth');
        try{ var m=$('authMsg'); if(m){ m.className='msg'; m.textContent='Novo dia — entre de novo para continuar.'; } }catch(_){}
        return;
      }
    }
    var r=await _devEntrarOrig.apply(this,arguments);
    try{
      devRegistrar();
      if(novo){ devSessaoCarimbar(); devTeto(); devReauthChecar(); }   /* v461: dono da sessão · v462: teto de 3 · v464: código por e-mail se o admin exigiu */
      /* (v477: o atalho mev_apos_login saiu junto com a tela da queda — nada mais o gravava) */
      /* v479: sem pergunta nenhuma — faxina da preferência antiga e segue */
      try{ localStorage.removeItem('mev_manter'); }catch(_){}
      if(!novo) devChecarRemoto();
      devAgendarVirada();
    }catch(_){}
    return r;
  };

  /* app voltou do fundo: virou o dia (23:59 → 00:00)? aparelho foi desconectado? */
  try{
    document.addEventListener('visibilitychange',function(){
      if(document.visibilityState!=='visible' || !token) return;
      if(devSessaoVenceu()){ devSairForcado('O dia virou — entre de novo para continuar.'); return; }
      devChecarRemoto();
    });
  }catch(_){}

/* ╔═══ src/app/01c-guarda-fotos.js ═══════════════════════════════════════ */
  /* ===========================================================================
     v741 — A GUARDA DE TRÁFEGO DAS FOTOS (o mesmo código de
     netlify/functions/_fotos-cdn.js — quem mudar um, muda o outro; o
     teste-v741 confere que os dois são iguais).
     Qualquer <img> apontando pro storage público do Supabase passa a sair
     do redimensionador da Netlify (cache na borda = uma busca por foto), com
     volta pra original se o redimensionador falhar. Vigia a página inteira
     por MutationObserver; roda uma vez, aqui, na abertura do app.
     ======================================================================== */
  (function(){var RE=/^https:\/\/(oeirfkxwwjqkqfpwhvra\.supabase\.co\/storage\/v1\/object\/public\/|mevtools\.netlify\.app\/)/;if((location.hostname==='localhost'||location.hostname==='127.0.0.1'||location.hostname==='0.0.0.0')&&!window.__mevGuardaFotosForcar){return;}function leve(u,w){return '/.netlify/images?url='+encodeURIComponent(u)+'&w='+w+'&q=75';}function trata(im){try{if(!im||im.tagName!=='IMG')return;var u=im.getAttribute('src')||'';if(!RE.test(u)||im.hasAttribute('data-cdn-falhou'))return;var w=parseInt(im.getAttribute('data-w'),10)||1200;im.setAttribute('data-orig',u);im.setAttribute('src',leve(u,w));im.addEventListener('error',function(){var o=im.getAttribute('data-orig');if(o&&(im.getAttribute('src')||'').indexOf('/.netlify/images')>=0){im.setAttribute('data-cdn-falhou','1');im.removeAttribute('data-orig');im.setAttribute('src',o);}},{once:true});}catch(_){}}function varre(n){try{if(!n||n.nodeType!==1)return;if(n.tagName==='IMG'){trata(n);return;}var l=n.querySelectorAll?n.querySelectorAll('img'):[];for(var i=0;i<l.length;i++)trata(l[i]);}catch(_){}}varre(document.documentElement);try{new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var m=ms[i];if(m.type==='attributes'){trata(m.target);}else{for(var j=0;j<m.addedNodes.length;j++)varre(m.addedNodes[j]);}}}).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});}catch(_){}window.__mevGuardaFotos=1;})();

/* ╔═══ src/app/01d-endereco-antigo.js ════════════════════════════════════ */
/* ============================================================================
   01d-endereco-antigo.js — v1111 — "O APP MUDOU DE ENDEREÇO. REINSTALE."
   ----------------------------------------------------------------------------
   Angelo, 21/09 (print): abriu o app instalado no computador, clicou em
   "Editar página" na Linha 0 km e viu "Não consegui abrir esta versão —
   Falha de conexão". A internet estava boa. O que aconteceu:

     · o app foi instalado quando o site morava no endereço antigo, e um app
       instalado (PWA/TWA) NUNCA troca de origem sozinho — o service worker
       dele serve app.html e app.js do cache, na origem antiga;
     · toda chamada relativa ("/api/novo-admin") sai da origem antiga, cai no
       301 do netlify.toml (v1107) e o navegador recusa: POST com Authorization
       redirecionado pra outra origem é bloqueado (CORS). Pro app, "falha de
       conexão";
     · e o próprio sw.js levava 301 — o navegador não aceita worker que vem de
       redirect, então o app antigo nunca ia se atualizar. Em nenhum celular.

   O netlify.toml (v1111) passou a servir, no endereço antigo, as funções e o
   pacote do app em 200. Este arquivo é a outra metade: quando o app percebe
   que está rodando na origem antiga, mostra uma faixa fixa pedindo pra abrir
   o novo endereço e instalar de novo. Não redireciona sozinho, de propósito:
   dentro de um app instalado, ir pra outra origem abre "fora do app" e a
   pessoa não entende o que aconteceu. A faixa explica e dá o botão.

   ⚠️ Usa MEV_DOMINIO/MEV_SITE do 01-nucleo (regra da v1106: o endereço mora
   em um lugar só). ⚠️ É um <div>, não <header> (body.app-on header{display:none}).
   ========================================================================== */
(function(){
  var host=String(location.hostname||'').toLowerCase();
  if(!/(^|\.)mevplacas\.com\.br$/.test(host)) return;
  function mostrar(){
    if(!document.body || document.getElementById('mevEnderecoAntigo')) return;
    var d=document.createElement('div');
    d.id='mevEnderecoAntigo'; d.setAttribute('role','status');
    d.style.cssText='position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#001e50;color:#fff;'+
      'padding:12px 16px calc(12px + env(safe-area-inset-bottom,0px));font:600 14px/1.45 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;'+
      'display:flex;gap:12px;align-items:center;justify-content:center;flex-wrap:wrap;box-shadow:0 -6px 20px rgba(0,0,0,.25)';
    var novo=MEV_SITE+String(location.pathname||'/app.html')+String(location.search||'')+String(location.hash||'');
    var a=document.createElement('a');
    a.href=novo; a.target='_blank'; a.rel='noopener';
    a.style.cssText='background:#fff;color:#001e50;border-radius:999px;padding:8px 14px;text-decoration:none;font-weight:700;white-space:nowrap';
    a.textContent='Abrir o novo app →';
    var s=document.createElement('span');
    s.innerHTML='O MEV Veículos mudou para <b>'+MEV_DOMINIO+'</b>. Este app instalado não recebe mais atualizações: abra o novo endereço e instale de novo.';
    d.appendChild(s); d.appendChild(a);
    document.body.appendChild(d);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', mostrar);
  else mostrar();
})();

/* ╔═══ src/app/02-icones-e-telas.js ══════════════════════════════════════ */
  /* ===== Ícones SVG (padrão MEV) ===== */
  var ICO={
    carro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>',
    fipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    chassi:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10v4M11 10v4M15 10v4M19 10v4"/></svg>',
    local:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    hist:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="14 7 21 7 21 14"/></svg>',
    ficha:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h6"/></svg>',
    leilao:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14 13-7.5 7.5a2.12 2.12 0 0 1-3-3L11 10"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>',
    multa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M12 8v5"/><path d="M12 16.4v.2"/></svg>',
    aval:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="12" y2="10"/><line x1="8" y1="14" x2="12" y2="14"/><line x1="8" y1="18" x2="14" y2="18"/></svg>',
    valor:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M14.5 9a2.5 2 0 0 0-2.5-1.5c-1.4 0-2.5.7-2.5 1.8 0 2.7 5 1.3 5 4 0 1.2-1.1 1.9-2.5 1.9A2.6 2 0 0 1 9.5 15"/><path d="M12 6.5v11"/></svg>',
    motor:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
    dimensoes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 15.3 8.7 2.7a1 1 0 0 0-1.4 0L2.7 7.3a1 1 0 0 0 0 1.4l12.6 12.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z"/><path d="M14.5 12.5 12 15M11 9l-2 2M8 6 6 8M17 15l-2 2"/></svg>',
    desempenho:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
    itens:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    opcionais:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>',
    comparativo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>',
    mercado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
  };
  var CHEV='<svg class="plc-chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#0066cc" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
  var ICOback='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  var BTN_STYLE='width:100%;margin-top:8px;background:linear-gradient(135deg,#001e50,#0a4da6);color:#fff;border:none;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit';
  function kv(k,val,cls){ return val?('<div class="kv"><span class="k">'+esc(k)+'</span><span class="v'+(cls?(' '+cls):'')+'">'+esc(val)+'</span></div>'):''; }
  /* linha do card "Veículo" (label esquerda / valor direita) */
  function kvp(l,val,cls){ return (val==null||val==='')?'':('<div class="plc-kv"><span class="l">'+esc(l)+'</span><span class="v'+(cls?(' '+cls):'')+'">'+esc(val)+'</span></div>'); }
  /* cabeçalho de painel (colunas 2 e 3) */
  function panelHead(ico,cor,titulo,sub){ return '<div class="plc-panel-head"><span class="ico '+cor+'">'+ico+'</span><div><h2>'+esc(titulo)+'</h2>'+(sub?'<p>'+sub+'</p>':'')+'</div></div>'; }
  function secRow(id, ico, titulo, badge, contentHtml, sub, cor){
    return '<div class="plc-row" data-sec="'+id+'"><div class="plc-ic'+(cor?' '+cor:'')+'">'+ico+'</div>'+
      '<div class="plc-tt">'+titulo+(sub?'<div class="plc-sub">'+sub+'</div>':'')+'</div>'+(badge?('<div class="plc-badge">'+badge+'</div>'):'')+CHEV+'</div>'+
      '<div class="plc-content" id="c-'+id+'">'+contentHtml+'</div>';
  }

  /* ===== Navegação por TELAS (menu após buscar + voltar) ===== */
  /* v190: quando fabricacao e modelo sao diferentes, mostra os dois (2025/2026). */
  function subInfoDe(v){
    var af=String(v.ano||'').trim(), am=String(v.ano_modelo||'').trim();
    var ano=(af&&am&&af!==am)?(af+'/'+am):(am||af);
    return esc((((v.marca||'')+' '+(v.modelo||'')).trim())+(ano?' · '+ano:''));
  }
  /* v258: o FAB da câmera VOLTOU a aparecer (antes estava travado em display:none,
     por isso ninguém via o botão). Ele só existe na tela inicial: fabFoto(true) na
     home e fabFoto(false) em qualquer tela interna. Agora ele mora dentro da
     .fab-row, então o display certo é 'flex' (não '' nem 'block'). */
  function fabFoto(on){ var f=$('btnFotoFab'); if(f) f.style.display=on?'flex':'none'; }
  /* v349 (pedido): FAB de INÍCIO. A visibilidade é 100% CSS
     (body.tela-interna .home-fab) — aqui mora só a ação: fechar o menu se
     estiver aberto e voltar pra página inicial, o mesmo caminho do item
     "Buscar placa" do menu, mas SEM abrir o teclado. */
  (function(){ var h=$('btnHomeFab'); if(!h) return;
    h.onclick=function(){ try{ drawerFechar(false); }catch(_){} try{ mevAcoes(false); }catch(_){}
      try{ if(typeof consultaResultadoTentarSair==='function' && consultaResultadoTentarSair(false)) return; }catch(_){}
      voltarHome(); };
  })();
  function voltarHome(){
    if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia'){
      if(!avAreaSalvar()) return;
      /* v1419 — Avaliações não mantém mais uma Home paralela. Voltar sempre
         recompõe a Home única, com avaliação acima das consultas. */
      avAreaMarcar('consultas');
    }
    try{ mdrAtivoSet((typeof window.edicaoAtual==='function'&&window.edicaoAtual()==='consultas')?'inicio':'buscaplaca'); }catch(_){} /* v1322: a Home é o item ativo no MEV Consultas */ try{ verModalFechar(); }catch(_){} document.body.classList.remove('tela-interna'); document.body.classList.remove('consulta-ui-on'); /* v754 */ document.body.classList.remove('conta-on'); /* v755 */ document.body.classList.remove('loja-on'); /* v756 */ document.body.classList.remove('veh-on'); /* v757 */ document.body.classList.remove('hist-on'); /* v766 */ document.body.classList.remove('oper-on'); /* v795: as cinco telas operacionais */ document.body.classList.remove('mkd-on'); /* v870: a coluna da placa volta ao sair do Mercado */ document.body.classList.remove('resultado-veiculo-on'); /* v884 */ /* 🔴 v795: e RECALCULA. Tirar a classe `oper-on` não basta — quem acende e
    apaga o `dock-largo` (e quem zera o --consulta-ui-dock) é o
    consultaUiDockMedir. Sem esta chamada a Home voltava COM a barra do dock e
    com espaço reservado embaixo, violando o §4.1 do projeto ("Home: sem dock
    inferior"). Foi o teste-v795 que pegou: cinco telas, cinco falhas iguais. */
    try{ if(typeof consultaUiDockMedir==='function') consultaUiDockMedir(); }catch(_){ } document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='none'; $('telaHome').style.display=''; requestAnimationFrame(function(){ try{ window.scrollTo(0,0); }catch(_){} _fabPoe(); });   /* v616 */ mevTabSet('home'); fabFoto(true); voltarTab(null); mevAcoes(false); try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar('Início'); }catch(_){} try{ if(window._pdfFabSync) window._pdfFabSync(); }catch(_){} try{ fmInlineMontar(); }catch(_){} try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){} }
  /* 🔴🔴 v616 — OS FABs FLUTUANDO NO MEIO DA TELA
     ------------------------------------------------------------------------
     Print do Angelo (24/08, iPhone): a fileira de 6 botões redondos aparecia
     lá pelo MEIO da tela, por cima do card "Avaliação lojista", com meia tela
     de espaço VAZIO embaixo dela.

     O que isso NÃO é (já conferido, pra não refazer trabalho):
       · não é falta de espaço — o vazio embaixo prova que sobra;
       · não é transbordo lateral — isso a v560 já resolveu;
       · não é falta de respiro — body.tela-interna reserva 104px e o
         #cardVeiculo mais 96px, sempre ligados;
       · não é contêiner errado — o #fabRow é filho direto do <body>, e não
         existe transform/overflow em nenhum pai que pudesse prender um
         position:fixed lá dentro (conferido em .wrap, #scApp, #cardVeiculo).

     O que sobra — e é comportamento CONHECIDO do WebKit/iOS: `position:fixed`
     é resolvido contra o VIEWPORT VISUAL no instante em que o navegador
     calcula. Duas coisas mexem nesse instante ao mesmo tempo nesta tela:
       a) o teclado do campo de placa fechando (a animação do iOS leva uns
          250-300ms e é assíncrona — a consulta pode voltar antes);
       b) a troca de tela: innerHTML novo + window.scrollTo(0,0) no MESMO
          quadro.
     Se o cálculo cai no meio disso, o navegador carimba a barra numa altura
     de tela que já não existe mais — e ela fica flutuando ali até um scroll
     ou um resize mandar repintar.

     O conserto tem três camadas, da mais educada pra mais insistente:
       1. o scrollTo(0,0) espera o PRÓXIMO QUADRO, em vez de disputar o mesmo
          quadro com a troca de conteúdo;
       2. depois que a tela assenta, um cutucão de repintura na barra
          (_fabAcorda) — é o truque padrão pra "acordar" um fixed preso.
          ⚠️ v673: NÃO BASTOU. Virou _fabPoe(), que MEDE e corrige — a
          explicação inteira está no bloco da v673, logo abaixo;
       3. e o cutucão também acontece sozinho toda vez que o viewport visual
          muda de tamanho: é exatamente o que o teclado faz ao abrir e fechar.
          Essa terceira camada é a que vale, porque não depende de a gente
          adivinhar QUEM disparou.

     ⚠️ A v560 (o encolhimento horizontal dos FABs em tela estreita) NÃO foi
     tocada: ela resolve outro problema e está funcionando. */
  /* 🔴🔴 v673 — A BARRA CONFERE ONDE CAIU (o cutucão da v616 não bastou)
     ------------------------------------------------------------------------
     Print do Angelo (28/08, iPhone, aba Mercado da avaliação): a fileira de
     botões redondos OUTRA VEZ no meio da tela, por cima da faixa de preço.
     Perguntei quando acontece e ele respondeu: **"encontrei na página de
     avaliações, a qualquer momento"** — ou seja, NÃO é só depois do teclado.

     ⚠️ ISSO DERRUBA METADE DO DIAGNÓSTICO DA v616. Lá eu apostei que a causa
     era o instante do cálculo (teclado fechando + troca de tela no mesmo
     quadro) e o conserto foi um CUTUCÃO de repintura: mexer no transform pra
     obrigar o navegador a recalcular. Um cutucão só funciona se o navegador,
     ao recalcular, chegar no valor CERTO. Se ele recalcula e chega no MESMO
     valor errado, cutucar dez vezes dá dez vezes errado.

     ⚠️ E EU NÃO CONSIGO REPRODUZIR AQUI, e é honesto dizer: medi a barra no
     Chromium (iPhone 390×844, página de avaliações montada) e ela cai
     certinha em 824 de 844. O defeito é do WebKit/iOS, e o navegador que eu
     tenho pra testar não é WebKit. Então o conserto NÃO pode depender de eu
     adivinhar o que o iPhone faz por dentro.

     O QUE MUDA: a barra para de CONFIAR e passa a CONFERIR.
       1. onde ela deveria estar = fundo da tela VISÍVEL (visualViewport, que
          é o que o iOS sabe estar aparecendo) menos o respiro do CSS;
       2. onde ela CAIU = getBoundingClientRect().bottom, medido de verdade;
       3. sobrou diferença? empurra com translateY exatamente a diferença.
     Não é palpite sobre a causa: é medir o erro e descontar o erro. Se um dia
     o WebKit acertar sozinho, a diferença dá zero e nada acontece.

     ⚠️ DE BRINDE, e de propósito: com o teclado ABERTO o fundo visível sobe,
     então a barra sobe junto e para de ficar escondida atrás do teclado.

     ⚠️ NÃO CORRIJO DURANTE A ROLAGEM. O Safari congela os `position:fixed`
     enquanto o dedo arrasta e só os assenta no fim; corrigir no meio faria a
     barra tremer. Por isso o `scroll` do viewport visual espera a rolagem
     PARAR (150ms de silêncio). Barra tremendo é pior que barra parada.

     ⚠️ BARRA ESCONDIDA NÃO É CORRIGIDA (display:none mede tudo zero e o
     "conserto" viraria um empurrão de centenas de pixels guardado pra quando
     ela reaparecesse).

     ⛳ FAB_CONFERE = false volta ao comportamento da v616 (só o cutucão). */
  var FAB_CONFERE = true;
  var _FAB_FOLGA = 2;            /* menos que isso é arredondamento, não defeito */
  function _fabCutucao(r){
    /* o cutucão da v616, preservado: em navegador sem visualViewport é tudo
       o que dá pra fazer, e às vezes basta. */
    try{
      r.style.transform='translateZ(0)';
      void r.offsetHeight;
      requestAnimationFrame(function(){ try{ if(r.style.transform==='translateZ(0)') r.style.transform=''; }catch(_){} });
    }catch(_){}
  }
  function _fabPoe(){
    var r=$('fabRow'); if(!r) return;
    try{ lequeEstado(); }catch(_){}
    /* v754 — teclado aberto (viewport visual bem menor que a janela, com um
       campo em foco) vira uma classe no body: a barra compacta do padrão se
       esconde em vez de subir junto com o teclado (regra 8.2). */
    try{
      var _vv=window.visualViewport; var _ae=document.activeElement;
      var _kb=!!(_vv && (window.innerHeight-_vv.height)>120 && _ae && /^(INPUT|TEXTAREA|SELECT)$/.test(_ae.tagName));
      document.body.classList.toggle('teclado-aberto', _kb);
    }catch(_){}
    try{
      var cs=getComputedStyle(r);
      if(cs.display==='none' || cs.visibility==='hidden'){ r.style.transform=''; return; }
      var vv=window.visualViewport;
      if(!FAB_CONFERE || !vv){ _fabCutucao(r); return; }
      /* mede LIMPA: com a correção anterior no lugar, eu mediria o meu
         próprio empurrão e iria somando erro em cima de erro. */
      r.style.transform='';
      var caiu=r.getBoundingClientRect().bottom;
      /* o respiro é o que o CSS pediu (20px + a faixa de baixo do iPhone) */
      var respiro=parseFloat(cs.bottom); if(!isFinite(respiro)) respiro=0;
      var fundo=vv.offsetTop + vv.height;      /* fim da tela que o iOS vê */
      var d=Math.round((fundo - respiro) - caiu);
      if(Math.abs(d) > _FAB_FOLGA) r.style.transform='translateY('+d+'px)';
    }catch(_){ }
  }

  /* ══════════════════════════════════════════════════════════════════════
     🔴 v1242 — UM FAB SÓ NA DIREITA, E TUDO DENTRO DELE
     ──────────────────────────────────────────────────────────────────────
     Pedido do Angelo, 27/09, com print da tela do 0 km: "deixa a barra
     inferior por padrão no MEV Consultas, Completo e Avaliações, no mesmo
     padrão do MEV Consultas: fica dentro de um único FAB na direita."

     Até aqui o app tinha DOIS rodapés diferentes: quatro círculos soltos
     (v349 e companhia) e uma barra fixa de largura inteira (v754/v800/v885),
     cada tela escolhendo um. Agora, no celular, é um só.

     🔑 A REGRA QUE SEGURA ISTO EM PÉ, e ela é a mesma do CSS:
     **este código não decide QUAIS botões existem.** Cada tela continua
     ligando e desligando os seus (o Voltar some fora de tela interna, o PDF
     só na consulta, o Salvar só na edição). O leque só pergunta, na hora de
     abrir, quais estão VISÍVEIS — e empilha esses.

     Por isso ele não tem lista de telas. Uma lista aqui teria que concordar
     pra sempre com a lista do CSS, e duas listas que precisam concordar
     acabam discordando — é a lição que o §14 da v795 já tinha escrito neste
     mesmo app, quando a whitelist do dock morava em dois lugares.

     ⚠️ SÓ NO CELULAR (<900px). No computador a barra larga da v793 continua.
     ⛳ FAB_LEQUE = false devolve o app ao comportamento anterior, inteiro:
        as duas barras antigas só estão gated por `:not(.fab-leque)` no CSS.
     ══════════════════════════════════════════════════════════════════════ */
  var FAB_LEQUE = true;
  var _LEQUE_MAX = 899;
  function lequeVale(){ try{ return FAB_LEQUE && window.innerWidth<=_LEQUE_MAX; }catch(_){ return false; } }
  function lequeItens(){
    /* os botões da fileira, sem o gatilho, que a TELA deixou visíveis.
       getComputedStyle e não o atributo style: metade deles é ligada por
       classe no CSS, e ler o style inline devolveria a resposta errada. */
    var r=$('fabRow'); if(!r) return [];
    return Array.prototype.filter.call(r.querySelectorAll('.menu-fab'), function(b){
      if(b.id==='btnFabLeque') return false;
      try{ return getComputedStyle(b).display!=='none'; }catch(_){ return false; }
    });
  }
  function lequeFecha(){
    try{
      document.body.classList.remove('fab-leque-on');
      var g=$('btnFabLeque'); if(g){ g.setAttribute('aria-expanded','false'); g.setAttribute('aria-label','Abrir atalhos'); }
      var f=$('fabLequeFundo'); if(f) f.hidden=true;
    }catch(_){}
  }
  function lequeAbre(){
    try{
      var itens=lequeItens();
      /* sem nada pra mostrar, abrir seria abrir o vazio */
      if(!itens.length) return;
      /* ⚠️ O PASSO É MEDIDO, NÃO CRAVADO.
         Com quatro botões qualquer número serve. Mas há telas com oito ou
         nove (Voltar + PDF + Print + Salvar + Ações + Início + Conversas +
         Menu…), e num iPhone SE de 667px um passo fixo de 58 jogaria os
         últimos pra fora da tela — o item mais importante sumindo justo no
         aparelho menor. Então: mede o que sobra e divide.
         O piso de 46px não é estético: abaixo disso os alvos de toque
         encostam um no outro e a pessoa erra o botão. Se nem com 46 couber,
         é melhor o leque passar do topo do que eu encolher o alvo. */
      var alto=0; try{ alto=(window.visualViewport&&window.visualViewport.height)||window.innerHeight||0; }catch(_){}
      var sobra=Math.max(0, alto - 150);                 /* rodapé + gatilho + respiro */
      var passo=itens.length?Math.floor(sobra/itens.length):58;
      passo=Math.max(46, Math.min(58, passo));
      try{ document.documentElement.style.setProperty('--leque-passo', passo+'px'); }catch(_){}
      /* o degrau de cada um, contado AGORA: a tela de ontem não serve */
      itens.forEach(function(b,i){ b.style.setProperty('--leque-i', String(i+1)); });
      var f=$('fabLequeFundo'); if(f) f.hidden=false;
      document.body.classList.add('fab-leque-on');
      var g=$('btnFabLeque'); if(g){ g.setAttribute('aria-expanded','true'); g.setAttribute('aria-label','Fechar atalhos'); }
      /* o leitor de tela e o teclado vão pro primeiro item */
      try{ setTimeout(function(){ try{ itens[0].focus({preventScroll:true}); }catch(_){} }, 60); }catch(_){}
    }catch(_){}
  }
  function lequeAlterna(){
    if(document.body.classList.contains('fab-leque-on')) lequeFecha(); else lequeAbre();
  }
  /* o aviso de conversas não lidas tem que aparecer com o leque FECHADO —
     senão ninguém descobre que chegou mensagem. Copia do #chatFabN. */
  function lequeAvisaSinal(){
    try{
      var de=$('chatFabN'), pra=$('fabLequeN'); if(!pra) return;
      var t=de?String(de.textContent||'').trim():'';
      var mostra = !!t && !document.body.classList.contains('fab-leque-on');
      pra.textContent = mostra ? t : '';
      pra.style.display = mostra ? '' : 'none';
    }catch(_){}
  }
  try{ window.lequeAvisaSinal=lequeAvisaSinal; }catch(_){}
  (function(){
    function liga(){
      var g=$('btnFabLeque'); if(!g || g.__lequeOn) return; g.__lequeOn=1;
      g.addEventListener('click', function(ev){
        try{ ev.preventDefault(); ev.stopPropagation(); }catch(_){}
        lequeAlterna();
      });
      var f=$('fabLequeFundo');
      if(f) f.addEventListener('click', function(ev){ try{ ev.preventDefault(); }catch(_){} lequeFecha(); });
      /* escolher um item fecha o leque. Um só ouvinte na fileira, em vez de
         um por botão: botões entram e saem da fileira o tempo todo, e um
         ouvinte por botão viraria um esquecimento esperando acontecer. */
      var r=$('fabRow');
      if(r) r.addEventListener('click', function(ev){
        try{
          var b=ev.target&&ev.target.closest?ev.target.closest('.menu-fab'):null;
          if(b && b.id!=='btnFabLeque') lequeFecha();
        }catch(_){}
      });
      try{ document.addEventListener('keydown', function(ev){
        if(ev && ev.key==='Escape' && document.body.classList.contains('fab-leque-on')){
          lequeFecha(); try{ g.focus({preventScroll:true}); }catch(_){}
        }
      }); }catch(_){}
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', liga);
    else liga();
  })();
  /* quem liga e desliga a classe do body é o _fabPoe (abaixo), que já roda
     em toda troca de tela, giro de aparelho e mudança de viewport. Um lugar
     só decide — e é o mesmo que posiciona a fileira. */
  function lequeEstado(){
    try{
      var vale=lequeVale();
      document.body.classList.toggle('fab-leque', vale);
      /* ══════════════════════════════════════════════════════════════════
         🔴 v1252 — LEQUE DE UM ITEM SÓ NÃO É LEQUE, É UM BOTÃO A MAIS
         ──────────────────────────────────────────────────────────────────
         Angelo, 28/09, print da home: "quando for só o Menu não deixe
         duplicar, já aparece direto o menu". Na tela dele havia DOIS
         círculos — o gatilho do leque e, aberto, um único item chamado
         "Menu". Dois toques e dois alvos pra chegar num lugar só.

         🔑 Um leque existe pra RESOLVER disputa de espaço entre vários
         botões. Com um botão não há disputa: o gatilho vira uma porta na
         frente de outra porta.

         Então, com exatamente um item, o gatilho some e o item ocupa o
         lugar dele — mesmo tamanho, mesmo canto, um toque.

         ⚠️ A CLASSE `fab-leque` FICA. Ela é o que mantém a barra branca do
         celular fora de cena (v1242, `dockBarraQuer`). Se eu desligasse o
         leque inteiro pra resolver o item único, a barra voltaria numa
         tela e não na outra — trocaria um defeito visível por um
         inconsistente, que é pior. */
      var itens = vale ? lequeItens() : [];
      var solo  = vale && itens.length===1;
      document.body.classList.toggle('fab-leque-solo', solo);
      if(solo) lequeFecha();
      /* ⚠️ E COM ZERO ITENS O GATILHO TAMBÉM SOME. Isto a régua da v1252
         pegou de lambuja: com a fileira vazia o gatilho continuava desenhado,
         e o `lequeAbre` — que já se recusa a "abrir o vazio" — devolvia um
         toque sem resposta. É a MESMA doença do pedido dele: botão que
         promete e não entrega. Um item vira o próprio botão; nenhum item
         vira botão nenhum. */
      /* ⚠️ COM `important`, E ISSO NÃO É MANIA: a regra
         `body.fab-leque .fab-row #btnFabLeque{ display:flex !important }`
         ganha de estilo inline SEM important. Escrevi `g.style.display='none'`
         primeiro, a régua mediu `flex` na tela e estava certa — o gatilho
         continuava lá. É a mesma pedra da v1249 no <details>: regra com peso
         só cede pra regra com peso. */
      var g=$('btnFabLeque');
      if(g){
        if(vale && itens.length>1) g.style.removeProperty('display');
        else g.style.setProperty('display','none','important');
      }
      if(!vale) lequeFecha();
      lequeAvisaSinal();
    }catch(_){}
  }
  try{ window.lequeEstado=lequeEstado; window.lequeFecha=lequeFecha; }catch(_){}

  try{ window._fabPoe=_fabPoe; }catch(_){}
  /* o vigia do viewport visual: teclado abrindo, teclado fechando, girar o
     aparelho, a barra do Safari sumindo. Um rAF de guarda pra não recolocar a
     barra vinte vezes no mesmo quadro. */
  (function(){
    var pediu=false, paraDeRolar=0;
    function pede(){ if(pediu) return; pediu=true;
      requestAnimationFrame(function(){ pediu=false; _fabPoe(); }); }
    /* v673: a rolagem só é atendida quando PARA (ver o aviso lá em cima) */
    function pedeQuandoParar(){
      try{ clearTimeout(paraDeRolar); }catch(_){}
      paraDeRolar=setTimeout(pede,150);
    }
    try{
      if(window.visualViewport){
        window.visualViewport.addEventListener('resize', pede);
        window.visualViewport.addEventListener('scroll', pedeQuandoParar);
      }
      window.addEventListener('orientationchange', pede);
      window.addEventListener('resize', pede);
      window.addEventListener('scroll', pedeQuandoParar, {passive:true});
      /* o teclado fechando nem sempre dispara resize no iOS quando o campo
         perde o foco por código (o blur() do buscarPlaca) — por isso o
         focusout entra junto. */
      document.addEventListener('focusout', function(e){
        var t=e&&e.target; if(!t) return;
        var tag=String(t.tagName||'').toLowerCase();
        if(tag==='input'||tag==='textarea'||tag==='select') setTimeout(pede,320);
      }, true);
      /* e o teclado ABRINDO: o foco entra, a tela visível encolhe, a barra
         tem que subir junto em vez de ficar atrás do teclado. */
      document.addEventListener('focusin', function(e){
        var t=e&&e.target; if(!t) return;
        var tag=String(t.tagName||'').toLowerCase();
        if(tag==='input'||tag==='textarea'||tag==='select') setTimeout(pede,320);
      }, true);
    }catch(_){}
  })();
  function irTela(inner, backTo){
    /* v403 (pedido): o rótulo "Voltar"/"Nova consulta" do alto SAIU de todas
       as páginas — voltar é a setinha (FAB) e o deslize. O backTo continua
       valendo pro voltarTab logo abaixo. */
    var head='', rodape='';
    try{
      if(typeof edicaoAtual==='function' && ['consultas','avalia'].indexOf(edicaoAtual())>=0 && typeof mevConsultasRodapeHtml==='function' && String(inner||'').indexOf('mev-consultas-rodape')<0){
        rodape=mevConsultasRodapeHtml('pagina');
      }
    }catch(_){}
    $('secoes').innerHTML=head+inner+rodape;
    /* Resultado da PLACA: no desktop vira "duas colunas" (home à esquerda,
       resultado à direita) — marca-se com a classe md-veiculo. A telaHome deixa
       de ser escondida por inline (o CSS decide: some no celular, aparece no PC). */
    $('telaHome').style.display=''; document.body.classList.add('tela-interna'); document.body.classList.add('md-veiculo'); $('cardVeiculo').style.display='block'; fabFoto(false);
    /* v754: a barra inferior compacta só existe nas páginas do padrão (02c) */
    try{ document.body.classList.toggle('consulta-ui-on', !!$('secoes').querySelector('.consulta-ui')); }catch(_){}
    /* 🔴 v884 — a rota do RESULTADO DA PLACA, pro dock azul (§5 do projeto).
       Ela nasce e morre do mesmo jeito que a de cima: pela presença de um
       elemento na tela. A `.plc-placa` é o cartão da placa, e ele só existe
       aqui — o 18b já usava esse mesmo sinal desde a v(deslizar) pra saber que
       está no resultado. Assim a classe se limpa sozinha em QUALQUER navegação,
       sem depender de alguém lembrar de removê-la em cada saída. */
    try{ document.body.classList.toggle('resultado-veiculo-on', !!$('secoes').querySelector('.plc-placa')); }catch(_){}
    try{ if(typeof consultaUiDockMedir==='function') consultaUiDockMedir(); }catch(_){}
    /* v766: trocar de tela derruba o modo histórico — o abrirHistorico
       readiciona a classe DEPOIS do irTela quando é ele quem está abrindo */
    try{ document.body.classList.remove('hist-on'); }catch(_){}
    /* v616: o scroll espera o próximo quadro — dá tempo do navegador assentar
       o layout novo antes de mexer na rolagem — e a barra de FABs leva um
       cutucão logo depois. */
    requestAnimationFrame(function(){ try{ window.scrollTo(0,0); }catch(_){} _fabPoe(); });
    Array.prototype.forEach.call($('secoes').querySelectorAll('[data-back]'),function(b){ b.onclick=function(){ (b.getAttribute('data-back')==='home')?voltarHome():abrirMenu(); }; });
    voltarTab(backTo?((backTo==='home')?voltarHome:abrirMenu):null);
    mevAcoes(true);
    mevPrintFab(false);
    ligarComuns();
    try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar(); }catch(_){}
  }
  /* compat: qualquer chamada antiga cai no menu */
  function renderResultado(v){ if(v) veiculoAtual=v; abrirMenu(); }

  /* ---- MENU do veículo: Dados e FIPE já vêm ABERTOS + cartões das demais telas ---- */
  function abrirMenu(){
    if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia' && !avAreaConsultas()){
      return veiculoAtual?abrirAvaliacaoLojista():voltarHome();
    }
    var v=veiculoAtual; if(!v) return voltarHome();
    var eyebrow = histFonteTs ? '<div class="plc-eyebrow">DO HISTÓRICO · '+esc(histData(histFonteTs))+'</div>' : '';
    var _icoRefaz='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>';
    /* modelo + ano fab/modelo no cabeçalho azul da placa */
    var _mod=((v.marca||'')+' '+(v.modelo||'')).trim();
    var _af2=v.ano||'', _am2=v.ano_modelo||v.ano||'';
    var _anoH=(_af2||_am2)?((_af2||_am2)+'/'+(_am2||_af2)):'';
    var subH=[_mod,_anoH].filter(Boolean).join(' · ');
    /* v168: o seletor de VERSAO passou pra DENTRO do cabecalho azul da placa.
       Antes ele era um cartao branco solto embaixo do cabecalho: mais um bloco
       na tela pra pouca informacao. Por isso ele e' montado ANTES da placa. */
    var _vops=[], verChip='';
    try{
      _vops=verOps(v);
      if(_vops.length>1){ var _voa=verOpAtual(v,_vops);
        verChip='<button type="button" class="ver-chip" id="verChip"><span class="vc-l">VERSÃO '+(_vops.indexOf(_voa)+1)+' DE '+_vops.length+'</span>'+
          '<span class="vc-d">'+esc((_voa&&_voa.descricao)||'')+'</span><span class="vc-a">trocar</span></button>'; }
    }catch(_){ _vops=[]; verChip=''; }
    var plate='<div class="plc-placa'+(verChip?' has-ver':'')+'">'+eyebrow+'<div class="num">'+esc(v.placa)+'</div>'+(subH?('<div class="plc-modsub">'+esc(subH)+'</div>'):'')+'<button type="button" class="plc-refaz" id="plcRefaz" title="Refazer a pesquisa (busca os dados de novo)">'+_icoRefaz+'</button>'+verChip+'</div>';
    var alerta=(v.situacao && !/sem restri/i.test(v.situacao)) ? '<div class="plc-alerta">⚠️ '+esc(v.situacao)+'</div>' : '';
    /* v167: cada pedaco da tela e' montado dentro de um try. Se um bloco falhar
       (dado estranho vindo da base), o resto da tela ENTRA do mesmo jeito - antes
       um errinho num bloco derrubava a montagem inteira e a tela do carro
       anterior ficava no lugar. */
    /* v168: a lista virou DOIS GRUPOS. Em cima o que ja esta pago (nao gasta
       token); embaixo o que consome token, com o saldo do lado pra ele decidir
       sem sair da tela. Icone e cor tambem mudam: azul = gratis, dourado =
       gasta token, verde = ja comprado e salvo nesta placa. */
    /* ==========================================================================
       🔴🔴 v884 — O FIM DO RESULTADO PASSA A OFERECER CONSULTA, NÃO AVALIAÇÃO
       (PROJETO-2026-09-04-resultado-fipe-cards-consultas-e-dock-padronizado)
       --------------------------------------------------------------------------
       Saem daqui o título "GRÁTIS · JÁ NO SEU APP" e o card "Avaliação
       lojista". Entram Leilão + PT, Gravame e Total Premium.

       🔴 POR QUE ISSO É CERTO: quem acabou de ver a FIPE de uma placa está no
       meio de uma DECISÃO DE COMPRA — a próxima pergunta dele é "o carro tem
       gravame? passou por leilão?", não "quanto eu ofereço". A avaliação é o
       passo seguinte, e ela continua inteira no menu e na tela dela.
       ⚠️ A "Avaliação lojista" NÃO foi removida do app. Ela saiu SÓ DESTA
       posição (§3 do projeto). O `menuCard('seminovo',…)` continua existindo e
       o `abrirAvaliacaoLojista()` continua ligado no despacho lá embaixo.

       ⚠️ E OS CARDS NÃO SÃO DESENHADOS AQUI. São o componente canônico do 02c
       (`consultaUiRelacionadas`), o MESMO que já monta as consultas do fim de
       toda página de consulta. Um segundo desenho de card seria duas telas
       parecidas que divergem no primeiro ajuste — e o preço, que vem do
       `seloHtml` do 05d, deixaria de bater com o do resto do app.
       ⚠️ `somente:` e não `preferir:`: lista FECHADA. Com `preferir`, o dia em
       que alguém acrescentasse uma consulta de veículo no CONS_TABS, um quarto
       card nasceria aqui sozinho.
       ⚠️ `mostrarTodas:false`: sem o "Ver todas" — §4 do projeto.
       ⚠️ `placa:` leva a placa pro campo da próxima consulta. LEVAR NÃO É
       CONSULTAR: a página abre preenchida e o botão parado.
       ========================================================================== */
    var cards='';
    try{
      cards=consultaUiRelacionadas('placa','veiculo',{
        titulo:'CONSULTAS PARA ESTA PLACA',
        /* v1304 — a tira deixa de ser uma lista de nomes soltos e responde às
           três dúvidas naturais depois da FIPE: compra segura, financiamento
           e checagem completa. A lista continua fechada e cada card apenas
           abre a consulta preenchida; nenhum deles cobra no clique daqui. */
        somente:['leilaopt','gravame','premium'],
        mostrarTodas:false,
        placa:v.placa||'',
        contexto:{
          leilaopt:{pergunta:'Vai comprar este veículo?',descricao:'Consulte leilão, sinistro e perda total.'},
          gravame:{pergunta:'O veículo está financiado?',descricao:'Verifique banco, contrato e situação do gravame.'},
          premium:{pergunta:'Quer fechar negócio com mais segurança?',descricao:'Confira o histórico veicular completo.'}
        }
      });
    }catch(_){ cards=''; }
    var _blocoDados=''; try{ _blocoDados=dadosFipeBlock(v); }catch(_){ _blocoDados=''; }
    /* v596 — PDF da FIPE disponível NA HORA do resultado (Fase 1B do padrão
       MEV). O desenho roda só no clique, com os dados que a consulta acabou
       de devolver — nenhuma chamada nova, custo zero.
       ⚠️ SEM a classe .pdf-btn de propósito (lição da v595): no celular ela
       some e vira o FAB verde — que clica o PRIMEIRO .pdf-btn da tela.
       Botão próprio, discreto (branco/azul), logo abaixo do cartão da FIPE. */
    /* ========================================================================
       🔴 v1231 — O COMPARTILHAR DO PRINT VOLTOU PRA TELA, COMO ÍCONE
       ------------------------------------------------------------------------
       Pedido do Angelo, 26/09: "adicione um ícone svg pra compartilhar o
       print da fipe, no resultado da consulta".

       A v1475 mantém na mesma linha as quatro ações deste ponto: avaliação,
       PDF, compartilhamento e nova consulta ficam lado a lado como círculos
       de 48px. Assim nenhuma delas cria um novo andar de botão largo.

       ⚠️ O DESENHO DO ÍCONE É O MESMO do "Compartilhar" de dentro do visor
       (o `SH` do histPrintVisor, no 05). Mesma ação, mesma figura — dois
       desenhos diferentes pra mesma coisa é como se ensina que são coisas
       diferentes.
       ⚠️ E NADA de função nova: quem gera a imagem continua sendo o
       `histPrint(histItemDaConsulta(v),'compartilhar')` do 05, o mesmo
       caminho que o visor usa desde a v918.
       ⚠️ 48px de lado — regra do dedo da v567 (mínimo 44). */
    var ICO_COMPARTILHAR='<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
    var _consBts='';
    if(avAreaConsultas()) _consBts='<button type="button" id="avCriarDaConsulta" class="fipe-acao-icone fipe-acao-avaliar" aria-label="Criar avaliação" title="Criar avaliação"><span aria-hidden="true">'+ICO.aval+'</span></button>';
    var _fipeBt='';
    try{ if(v.fipe!=null) _fipeBt='<div class="fipe-acoes">'+
      _consBts+
      '<button type="button" id="fipePdfBt" class="fipe-acao-icone fipe-acao-pdf" aria-label="Baixar o PDF da FIPE" title="Baixar o PDF da FIPE"><span aria-hidden="true">'+ICO_PDF+'</span></button>'+
      '<button type="button" id="fipeShareBt" class="fipe-acao-icone fipe-share" aria-label="Compartilhar o print da FIPE" title="Compartilhar o print da FIPE"><span aria-hidden="true">'+ICO_COMPARTILHAR+'</span></button>'+
      '<button type="button" id="fipeNovaBt" class="fipe-acao-icone fipe-acao-nova" aria-label="Nova consulta" title="Nova consulta"><span aria-hidden="true">'+_CR_ICO.nova+'</span></button>'+
      '</div>'; }catch(_){}
    /* ============================================================================
       🔴 v918 — OS DOIS BOTÕES ESCUROS DE PRINT SAÍRAM DAQUI (pedido do
       Angelo, 06/09, com print da tela)
       ----------------------------------------------------------------------------
       Eles viveram da v896 até agora, logo abaixo do "Baixar o PDF da FIPE":
       "Baixar print" e "Compartilhar print", em preto, largura cheia.

       🔑 O QUE ESTAVA ERRADO NÃO ERA A FUNÇÃO, ERA O LUGAR. Três botões
       empilhados na tela do resultado — PDF, print, print — obrigavam a
       escolher ANTES de ver o que cada coisa é. E dois deles falavam de
       "print", palavra que só faz sentido depois que você viu a imagem.

       ✅ AGORA O COMPARTILHAR PRINT MORA DENTRO DO VISOR, junto do "Baixar
       PDF" e do "Compartilhar" — depois da prévia, quando a pessoa já está
       olhando o que vai mandar. Uma porta só na tela ("Baixar o PDF da FIPE"),
       três ações no visor.
       ⚠️ "Baixar print" NÃO foi pro visor de propósito: no iPhone, o
       compartilhar nativo já oferece "Salvar Imagem", e um quarto botão
       repetiria com outro nome o que o terceiro já faz.
       ⚠️ NADA de desenho novo: quem faz a imagem continua sendo o `histPrint`
       do 05, chamado com o modo 'compartilhar'. E o FAB da impressora
       (`mevPrintFab`) continua onde sempre esteve.
       ============================================================================ */
    /* v486 — EDIÇÕES: na MEV Consultas, o FIM da consulta de placa ganha o
       cartãozinho-porta "Quer avaliar este carro? → MEV Avalia" (o card
       "Avaliação lojista" some via CSS do 00-edicoes; aqui só entra a porta).
       Na MEV Avalia o CSS esconde as consultas pagas. No completo: nada. */
    var _edPorta='';
    try{
      if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='consultas'
         && typeof window.edCardPortaHtml==='function') _edPorta=window.edCardPortaHtml('avalia');
    }catch(_){}
    /* v884 — os cards canônicos trazem a própria `<section>`; embrulhá-los na
       `.menu-lista` (que é a lista de atalhos antiga) daria dois espaçamentos
       somados e o desenho não bateria com o das outras páginas de consulta. */
    /* ============================================================================
       🔴 v891 — O HISTÓRICO DA FIPE MUDOU DE CASA (pedido do Angelo, 04/09)
       ----------------------------------------------------------------------------
       "Passe o histórico da FIPE para baixo da consulta da FIPE. Tire ele de
       dentro da avaliação e coloque abaixo do botão baixar o PDF da FIPE."

       Ele era a PRIMEIRA aba da avaliação desde a v240 — e ali estava longe de
       quem acabou de consultar a placa e ainda está decidindo. Aqui ele fica a
       um rolar do valor FIPE que acabou de aparecer.
       ⚠️ NENHUMA CHAMADA NOVA: o `histFipeHtml` lê o `verHistDe(v)`, que é o
       histórico que a consulta já trouxe. Custo zero, token zero.
       ⚠️ E ele se explica sozinho quando não há dados: com menos de dois meses
       na base, mostra "Sem histórico da FIPE pra esta placa" em vez de um
       gráfico vazio.

       A ORDEM DA TELA, como o Angelo pediu:
         valor FIPE → Baixar o PDF da FIPE → HISTÓRICO DA FIPE →
         cards das consultas (v896: Leilão + PT, depois Total Premium)
       ============================================================================ */
    var _histFipe='';
    try{
      if(v && v.fipe!=null) _histFipe='<details class="plc-card plc-hf-details">'+
        '<summary class="plc-hf-summary"><span class="plc-hf-ico" aria-hidden="true">'+ICO.hist+'</span>'+
        '<span class="plc-hf-copy"><strong>Histórico da FIPE</strong><small>Ver gráfico e últimos 6 meses</small></span>'+
        '<span class="plc-hf-seta" aria-hidden="true"></span></summary>'+
        '<div class="plc-hf-body">'+histFipeHtml(v)+'</div></details>';
    }catch(_){ _histFipe=''; }

    /* 🔴 v896 — OS DOIS BOTÕES DA AUTOCORP SAÍRAM (viveram da v891 à v895).
       Eles nasceram de um pedido e morreram de outro, do mesmo Angelo, no
       mesmo dia: viraram card de novo (ver o `somente:` logo acima). O que
       fica da experiência, escrito pra não se repetir: um botão de largura
       cheia pesa MAIS na tela que um card da tira — usar botão pra "dar
       destaque" a uma consulta acabou dando destaque ao que sobrou nos cards.
       Se um dia voltarem, voltam pelo `data-cons`/`data-cons-placa` e pelo
       `consultaUiRelacionadasLigar`, nunca por listener próprio (regra v884),
       e com o preço vindo do `seloHtml`, nunca escrito à mão. */
    var _placaResultadoHtml=plate+alerta+_blocoDados+_fipeBt+_histFipe+'<div id="plcEstBox"></div>'+
      (cards?('<div style="margin-top:14px">'+cards+'</div>'):'')+_edPorta;
    var _placaResultadoSeparado=false;
    /* v1430 — a área Consultas do MEV Avaliações recebe exatamente a mesma
       página canônica de resultado do MEV Consultas. Até aqui o componente
       compartilhado já existia, mas esta porta aceitava somente a edição
       `consultas`; no `avalia` o mesmo retorno caía na composição legada. */
    try{
      var _placaEd=typeof window.edicaoAtual==='function'?window.edicaoAtual():'';
      _placaResultadoSeparado=typeof consultaResultadoAbrir==='function'&&(
        _placaEd==='consultas'||(_placaEd==='avalia'&&avAreaConsultas())
      );
    }catch(_){}
    if(_placaResultadoSeparado){
      var _placaVoltar=function(limpar){
        voltarHome();
        setTimeout(function(){ try{ var p=$('placa'); if(p){ p.value=limpar?'':String(v.placa||''); if(p.oninput) p.oninput(); } }catch(_){} },0);
      };
      var _placaCfg={ chave:'placa', placa:v.placa||'', titulo:'Consulta placa', identificacao:[_mod,_anoH,v.placa].filter(Boolean).join(' · '),
        dataHora:histFonteTs?histData(histFonteTs):histData(Date.now()),
        /* v1470 — a ficha FIPE logo abaixo já confirma o retorno e destaca o
           valor. O resumo verde repetia a mesma informação e atrasava o
           acesso aos dados relevantes nas duas edições. */
        resumoHtml:'',
        secoesHtml:consultaResultadoSecao({ titulo:'Veículo e FIPE', subtitulo:'Dados e histórico FIPE', classe:'consulta-resultado-secao-placa', html:_placaResultadoHtml }),
        origem:histFonteTs?'Resultado salvo':'',
        aoVoltar:function(){ _placaVoltar(false); }, aoNovaConsulta:function(){ _placaVoltar(true); }, acoes:[], novaConsultaInline:true };
      if(histFonteTs) consultaResultadoDoHistorico(_placaCfg); else consultaResultadoAbrir(_placaCfg);
    }else irTela(_placaResultadoHtml,'home');
    /* liga os três cards pelo caminho canônico — nada de listener paralelo */
    try{ consultaUiRelacionadasLigar($('secoes')); }catch(_){}
    mevPrintFab(true);
    if($('avCriarDaConsulta')) $('avCriarDaConsulta').onclick=function(){
      if(typeof acPortao==='function' && acPortao('avaliacoes')) return;
      avAreaMarcar('avaliacoes'); abrirAvaliacaoLojista();
    };
    var _fnb=$('fipeNovaBt'); if(_fnb) _fnb.onclick=function(){
      if(_placaResultadoSeparado && typeof consultaResultadoFechar==='function'){ consultaResultadoFechar(true); return; }
      voltarHome(); setTimeout(function(){ try{ var p=$('placa'); if(p){ p.value=''; if(p.oninput) p.oninput(); } }catch(_){} },0);
    };
    var _fpb=$('fipePdfBt'); if(_fpb) _fpb.onclick=function(){ fipePdfBaixar(); };
    /* v1231 — o ícone de compartilhar, ligado no MESMO ponto e com o MESMO
       guarda-chuva do visor: se o print não sair, a pessoa ouve o motivo em
       vez de tocar num botão que não faz nada (lição da v569). */
    var _fsb=$('fipeShareBt'); if(_fsb) _fsb.onclick=function(){
      try{
        if(typeof histPrint!=='function' || typeof histItemDaConsulta!=='function'){ toast('Não consegui gerar o print.'); return; }
        histPrint(histItemDaConsulta(v),'compartilhar');
      }catch(_){ toast('Não consegui gerar o print.'); }
    };
    /* v918 — aqui moravam os listeners dos dois botões de print. A montagem
       do item da consulta virou o `histItemDaConsulta(v)` do 05 (um lugar só),
       e quem o usa agora é o visor do PDF da FIPE (06-pdf-consulta.js). */
    var _vc=$('verChip'); if(_vc) _vc.onclick=function(){ verModalAbrir(false); };
    /* pergunta ANTES de mostrar os numeros: so quando ha mais de uma versao e ele ainda nao confirmou nenhuma */
    try{ if(_vops.length>1 && !verEscolhaLer(v.placa) && !_verVisto[v.placa]) setTimeout(function(){ verModalAbrir(true); }, 90); }catch(_){}
    /* v712: o ⟳ é O caminho do dado fresco — força a consulta de verdade,
       senão o atalho do histórico (buscarPlaca sem forçar) o devolveria
       pra esta mesma tela salva, num círculo. */
    /* ==========================================================================
       🔴🔴 v848 — O ⟳ DEIXAVA A TELA EM BRANCO (print do Angelo, 02/09, 14:49)
       --------------------------------------------------------------------------
       Ele tocou no ⟳ da placa MJW1A69, aberta do histórico, e a tela ficou
       VAZIA: só a barra de cima e a fileira de botões embaixo, com todo o meio
       em branco. Nenhum erro, nenhum aviso. O app não tinha travado — ele
       estava mostrando duas coisas escondidas ao mesmo tempo.

       O QUE ACONTECIA, e é uma armadilha de duas peças que só aparece juntas:

         1. a tela do resultado liga `body.tela-interna` + `body.md-veiculo`, e
            no celular o CSS diz `body.tela-interna #telaHome{display:none}` —
            ou seja, a tela da consulta fica ESCONDIDA por baixo;
         2. o resultado em si mora no `#cardVeiculo`, que fica por cima.

       Aí o `buscarPlaca` — que foi escrito pra rodar A PARTIR da tela da
       consulta — começa fazendo `$('cardVeiculo').style.display='none'` pra
       limpar o resultado antigo, e pinta o "Consultando…" no `#fipeMsg`, que
       vive DENTRO do #telaHome.

       Resultado: o `#cardVeiculo` foi escondido pelo buscarPlaca, o `#telaHome`
       continuava escondido pelo `tela-interna`, e o "Consultando…" foi pintado
       num lugar que ninguém estava vendo. Duas telas escondidas = tela branca.

       ✅ O CONSERTO É VOLTAR PRA CASA ANTES DE BUSCAR. O `voltarHome()` já
       existe e já sabe desfazer as duas classes, recolocar os botões e rolar
       pro topo — é exatamente o estado em que uma busca deve começar.
       ⚠️ A ORDEM IMPORTA: primeiro voltar, DEPOIS pôr a placa no campo. O
       `voltarHome()` remonta pedaços da home, e escrever no campo antes seria
       escrever num campo que vai ser repintado.
       ========================================================================== */
    var _rf=$('plcRefaz'); if(_rf) _rf.onclick=function(){
      var pl=v.placa;
      try{ voltarHome(); }catch(_){}
      var pi=$('placa'); if(pi) pi.value=pl;
      buscarPlaca(true);
    };
    /* 🔴 v918 — O DESPACHO TAMBÉM OBEDECE À EDIÇÃO
       (PROJETO "MEV Consultas sem links para outros aplicativos", §3)
       O CSS do 00-edicoes já escondia os cards que não são da edição, mas
       esconder não desliga: o `onclick` continuava ligado, e qualquer caminho
       que chegasse ao card (leitor de tela, largura diferente, um `hidden`
       que um dia falhe) abriria a avaliação ou o estoque de dentro do MEV
       Consultas. O portão fica ONDE A AÇÃO ACONTECE.
       ⚠️ Sem toast de "compre o outro app": o projeto pede pra não OFERECER,
       e um recado de porta fechada é uma oferta com outra roupa. */
    var _CARD2ACAO={ aval:'avaliacoes', seminovo:'avaliacoes', estoque:'estoque', venda:'vendas', cliente:'vincular', plus:'plus' };
    Array.prototype.forEach.call($('secoes').querySelectorAll('.menu-card'),function(c){
      c.onclick=function(){ var q=c.getAttribute('data-tela');
        var _ac=_CARD2ACAO[q];
        if(_ac){ try{ if(typeof window.edPode==='function' && !window.edPode(_ac)) return; }catch(_){} }
        if(q==='histfipe')telaHistFipe(); else if(q==='ficha')abrirFicha(); else if(q==='aval')abrirAvaliacao(); else if(q==='plus')abrirConsultaPlus(); else if(q==='cliente')vincularClienteAbrir(); else if(q==='seminovo')abrirAvaliacaoLojista(); else if(q==='estoque')estFromConsulta(); else if(q==='venda')vendaFromConsulta(); };
    });
    try{ _plcEstBoxPinta(v); }catch(_){}
  }
  /* v181: se a placa que voce acabou de consultar JA esta no estoque da loja,
     a propria tela da consulta mostra um atalho verde com os dois caminhos:
     abrir a ficha desse veiculo no estoque, ou ja comecar a venda dele.
     Antes voce consultava, reconhecia o carro, e tinha que voltar pro menu,
     entrar no Estoque e procurar a placa na mao. */
  async function _plcEstBoxPinta(v){
    if(!v||!v.placa||!meuId) return;
    /* 🔴 v918 — "JÁ NO SEU ESTOQUE" NÃO EXISTE EM EDIÇÃO SEM ESTOQUE.
       (PROJETO "MEV Consultas sem links para outros aplicativos", §3)
       O cartão verde com "Abrir no estoque" e "Iniciar a venda" era a ponte
       mais forte do resultado da placa pro app completo — e ela nascia no
       MEV Consultas, onde nenhuma das duas telas existe.
       ✅ SAI ANTES DE TUDO: sem HTML, sem os dois listeners, e sem a leitura
       do estoque no banco (o `estCarregar()` logo abaixo). Portão em cima
       economiza uma consulta que não serviria pra nada.
       ⚠️ A regra pergunta pelo ESTOQUE porque é dele que o cartão fala. Em
       edição que tem estoque mas não tem vendas, o cartão aparece e é o
       botão da venda que se resolve no despacho — não é caso hoje. */
    try{ if(typeof window.edPode==='function' && !window.edPode('estoque')) return; }catch(_){}
    if(!$('plcEstBox')) return;
    var pl=String(v.placa).toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!pl) return;
    function achar(){ return (_estoque||[]).filter(function(x){ return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===pl; })[0]; }
    var ja=achar();
    if(!ja && !(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} ja=achar(); }
    if(!ja) return;
    var box=$('plcEstBox'); if(!box) return;   /* a tela pode ter mudado enquanto carregava */
    var st=String(ja.status||'disponivel');
    var stTx=({disponivel:'Disponível',reservado:'Reservado',vendido:'Vendido'})[st]||st;
    var nome=((ja.marca||'')+' '+(ja.modelo||'')).trim()||'Veículo';
    var preco=ja.preco_anuncio?estMoney(ja.preco_anuncio):(ja.preco_minimo?estMoney(ja.preco_minimo):'');
    box.innerHTML='<div class="plc-jaest st-'+esc(st)+'">'+
      '<div class="pje-h"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg><span>Já no seu estoque</span><span class="pje-st">'+esc(stTx)+'</span></div>'+
      '<div class="pje-v"><b>'+esc(nome)+'</b>'+(preco?('<span>'+esc(preco)+'</span>'):'')+'</div>'+
      '<div class="pje-bts">'+
        '<button type="button" class="pje-bt" id="pjeEst">Abrir no estoque</button>'+
        '<button type="button" class="pje-bt p" id="pjeVen">Iniciar a venda</button>'+
      '</div>'+
    '</div>';
    var b1=$('pjeEst'); if(b1) b1.onclick=function(){ estFromConsulta(); };
    /* v190: usa a tela NOVA de venda (vendaNovaAbrir + etapas), já com o veículo do estoque
       preenchido. Se essa placa já tem uma venda aberta, reabre ela em vez de começar outra. */
    var b2=$('pjeVen'); if(b2) b2.onclick=async function(){
      try{ if(!(_vendas||[]).length) await vendaCarregar(); }catch(_){}
      var _pl=String(ja.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      var jaV=(_vendas||[]).filter(function(x){ return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===_pl; })[0];
      if(jaV){ vendaNovaAbrir(jaV.id); return; }
      vendaIniciarComVeiculo(ja.id);
    };
  }
  /* v168: a etiqueta ("3 tokens" / "✓ salvo") saiu de DENTRO do titulo e virou
     uma coluna propria, alinhada a direita. Antes ela empurrava o titulo e
     quebrava o texto em duas linhas nos aparelhos mais estreitos. */
  function menuCard(id,ico,cor,titulo,sub,cred,pronto){
    var badge = pronto ? '<span class="mc-cr done">✓ salvo</span>' : (cred?'<span class="mc-cr">'+esc(cred)+'</span>':'');
    return '<button class="menu-card" data-tela="'+id+'"><span class="ico '+cor+'">'+ico+'</span><span class="mc-tx"><span class="mc-t">'+esc(titulo)+'</span><span class="mc-s">'+esc(sub)+'</span></span>'+badge+'<span class="mc-chev">'+CHEV+'</span></button>';
  }

  /* IPVA por estado (mesmas alíquotas do backend: RS 3%, SC 2%, SP 4%) — usado ao trocar a versão da FIPE */
  function _ipvaCalc(fipe, uf){ var R={RS:3,SC:2,SP:4}; var a=R[String(uf||'').toUpperCase()]; var v=Number(fipe)||0; if(a&&v>0) return { uf:String(uf).toUpperCase(), aliquota:a, valor:Math.round(v*a)/100 }; return null; }
  /* v181: a base as vezes devolve "DESCONHECIDO" / "NAO INFORMADO" num campo.
     Isso nao e informacao — e a AUSENCIA dela. Mostrar essa linha so ocupa
     espaco e passa uma impressao ruim pro cliente que esta olhando junto.
     Entao o valor vira vazio e o kvp() ja sabe sumir com a linha inteira. */
  function _dadoUtil(x){
    var t=String(x==null?'':x).trim();
    if(!t) return '';
    var n=t.toUpperCase()
      .replace(/[ÃÂÁÀ]/g,'A').replace(/[ÉÊÈ]/g,'E').replace(/[ÍÎ]/g,'I')
      .replace(/[ÓÔÕÒ]/g,'O').replace(/[ÚÛÙ]/g,'U').replace(/Ç/g,'C')
      .replace(/[^A-Z0-9]+/g,' ').trim();
    if(!n || n==='0') return '';
    if(/^(DESCONHECID[OA]|NAO INFORMAD[OA]|NAO IDENTIFICAD[OA]|SEM INFORMACAO|NAO CONSTA|INDEFINID[OA]|NULL|UNDEFINED|N I|N A|N D)$/.test(n)) return '';
    return t;
  }
  /* ---- Bloco Dados e FIPE (card aberto: usado no menu) ---- */
  function dadosFipeBlock(v){
    var modelo=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
    var anoFab=v.ano||'', anoMod=v.ano_modelo||v.ano||'';
    var anoTxt=(anoFab||anoMod)?((anoFab||anoMod)+'/'+(anoMod||anoFab)):'';
    var veicKv=kvp('Modelo',modelo)+kvp('Ano fab. / modelo',anoTxt)+kvp('Cor',_dadoUtil(v.cor))+kvp('Combustível',_dadoUtil(v.combustivel))+
      kvp('Ref. FIPE',v.mes_ref)+kvp('Cód. FIPE',v.codigo_fipe,'mono');
    var ops=(v.fipe_opcoes||[]).filter(function(o){return o.valor!=null;}), verBox='';
    var _vEsc=verEscolhaLer(v.placa);   /* v158: versao que ELE escolheu pra esta placa */
    if(ops.length>1){
      var selOp=(_vEsc&&_vEsc.codigo_fipe?ops.filter(function(o){ return String(o.codigo_fipe||'')===String(_vEsc.codigo_fipe); })[0]:null)
        ||ops.filter(function(o){return Math.round(Number(o.valor))===Math.round(Number(v.fipe));})[0]
        ||verOpDoAnoModelo(v, ops)||ops[0];
      var selTxt=esc([selOp.descricao,selOp.ano,selOp.combustivel].filter(Boolean).join(' · '));
      var listaOps=ops.map(function(o){ var sel=(o===selOp)?' sel':''; return '<button class="ver-opt'+sel+'" data-fipe="'+o.valor+'" data-cod="'+esc(o.codigo_fipe||'')+'" data-des="'+esc(o.descricao||'')+'"><span class="vd">'+esc([o.descricao,o.ano,o.combustivel].filter(Boolean).join(' · '))+'</span><span class="vv">'+esc(brl(o.valor))+'</span></button>'; }).join('');
      /* ===== v303 (pedido) — QUANDO JÁ ESCOLHEU, ESTE BLOCO SOME ============
         O cabeçalho azul, logo acima do cartão, já diz "VERSÃO 1 DE 2 · <nome
         da versão>" e tem o "trocar". Aqui embaixo aparecia a MESMA coisa de
         novo: o nome da versão, um aviso de que ela está salva, e um segundo
         botão pra trocar. Dois botões pra mesma ação, na mesma tela.

         CONFERI ANTES DE APAGAR se alguma função se perdia junto. O botão
         "usar a sugerida" sai daqui — mas o modal que o "trocar" abre já tem
         a linha "voltar pra versão sugerida pela consulta" (01-nucleo.js), e
         ela só aparece justamente quando existe uma escolha salva. Nada se
         perde: o caminho continua, um toque mais longe, sem repetição.

         QUANDO AINDA NÃO ESCOLHEU o bloco CONTINUA. É ele que avisa que a
         placa tem mais de uma versão e convida a escolher — sem ele a tela
         ficaria muda sobre isso, e a pessoa acreditaria num valor que pode
         não ser o do carro dela. */
      if(_vEsc){
        verBox='';
      }else{
        var salvaHtml=(v.fipe_por_ano_modelo?('<div class="ver-anomod">Valor e histórico do <b>ano-modelo '+esc(String(v.ano_modelo||v.fipe_ano||''))+'</b> — a tabela FIPE não usa o ano de fabricação.</div>'):'');
        /* v164: a lista saiu daqui e virou MODAL - aqui fica so o atalho pra abrir */
        verBox='<div class="plc-ok"><span style="color:#16a34a;font-weight:900">✓</span><span>'+selTxt+'</span></div>'+salvaHtml+'<button class="ver-troca" type="button">trocar versão — '+ops.length+' opções ›</button>';
      }
    }
    /* v168: o VALOR FIPE deixou de ser uma etiqueta pequena na beirada do cartao
       e virou o destaque da tela - e' o numero que ele mostra pro cliente. O
       cartao continua sendo o mesmo botao que abre "dados e ficha" embaixo. */
    var _mesRef=String(v.mes_ref||'').trim();
    var card='<div class="plc-card fipe-hero">'+
      /* v262: os dados e a ficha já vêm ABERTOS (pedido). Antes era preciso um
         toque a mais pra ver justamente o que a pessoa foi buscar. O botão
         continua funcionando — agora ele SERVE PRA FECHAR, se quiser. */
      '<button type="button" class="plc-card-head df-toggle on">'+
        '<span class="fh-tx">'+
          '<span class="fh-lb">FIPE'+(_mesRef?(' · '+esc(_mesRef.toUpperCase())):'')+'</span>'+
          '<span class="fh-vl">'+esc(v.fipe?brl(v.fipe):'—')+'</span>'+
          '<span class="fh-go">Dados e ficha do veículo <span class="df-chev">'+CHEV+'</span></span>'+
        '</span>'+
        '<span class="ico">'+ICO.carro+'</span></button>'+
      '<div class="df-body" style="display:block">'+veicKv+verBox+'</div>'+
    '</div>';
    return card;
  }
  var _hfSeq=0;   /* v439: id único por gráfico desenhado (clipPath da animação) */
  /* v1447 — datas do histórico em linguagem de interface. O valor persistido
     continua no formato técnico AAAA-MM; só a apresentação deixa de expor
     esse formato para quem está comparando os meses. */
  var _HF_MESES_CURTOS=['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
  var _HF_MESES_LONGOS=['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  function _hfMesPartes(m){
    var q=String(m||'').match(/^(\d{4})-(\d{2})(?:\D|$)/);
    if(!q) return null;
    var n=parseInt(q[2],10);
    return n>=1&&n<=12?{ano:q[1],mes:n}:null;
  }
  function _hfMesCurto(m){ var q=_hfMesPartes(m); return q?(_HF_MESES_CURTOS[q.mes-1]+'/'+q.ano):String(m||''); }
  function _hfMesLongo(m){ var q=_hfMesPartes(m); return q?(_HF_MESES_LONGOS[q.mes-1]+' de '+q.ano):String(m||''); }
  function histFipeHtml(v){
    var h=verHistDe(v).filter(function(x){return x&&x.valor!=null;});
    if(h.length<2) return '<div class="plc-msg">Sem histórico da FIPE pra esta placa.</div>';
    h=h.slice().sort(function(a,b){ return String(b.mes||'')<String(a.mes||'')?-1:1; }); /* mais novo primeiro */
    var atual=Number(h[0].valor)||0;
    var idx12=Math.min(12, h.length-1), base12=Number(h[idx12].valor)||0;
    var d12=atual-base12, p12=base12?(d12/base12*100):0;
    var vals=h.map(function(x){return Number(x.valor)||0;});
    var max=Math.max.apply(null,vals), min=Math.min.apply(null,vals), maxI=vals.indexOf(max), minI=vals.indexOf(min);
    /* gráfico de variação (grade + eixo de valores + meses + pontos), ordem cronológica */
    var chrono=vals.slice().reverse();
    var mesesC=h.map(function(x){ return x.mes||''; }).reverse();
    var n=chrono.length, span=(max-min)||1;
    /* Reserva espaço para os rótulos completos da escala à esquerda. */
    var W=380,H=158,pL=62,pR=368,pT=12,pB=120;
    function _X(i){ return pL+(n>1?(i/(n-1)):0)*(pR-pL); }
    function _Y(val){ return pB-((val-min)/span)*(pB-pT); }
    function _mil(x){ x=Number(x)||0; if(x>=1000){ var k=x/1000; return 'R$ '+(k>=100?String(Math.round(k)):k.toFixed(1).replace('.',','))+' mil'; } return brl(x); }
    var g='';
    for(var gi=0; gi<=3; gi++){ var fr=gi/3, yy=pB-(pB-pT)*fr, vv=min+span*fr;
      g+='<line class="grid" x1="'+pL+'" y1="'+yy.toFixed(1)+'" x2="'+pR+'" y2="'+yy.toFixed(1)+'"/>'+
         '<text class="axlb" x="'+(pL-4)+'" y="'+(yy+2.8).toFixed(1)+'" text-anchor="end">'+esc(_mil(vv))+'</text>'; }
    /* ===== v439 — A ANIMAÇÃO (pedido: "consegue pôr uma animação no gráfico?")
       A grade e os rótulos ficam FORA do clip: eixo não se desenha, ele já
       está lá. O que anda é só a linha, a área e os pontos, revelados da
       esquerda pra direita por uma janelinha (clipPath) que desliza.

       ⚠️ POR QUE NÃO ANIMEI O TRAÇADO (stroke-dashoffset, o jeito clássico):
       esta linha JÁ É TRACEJADA (stroke-dasharray "4 3", v303). Animar o
       dashoffset numa linha tracejada faz o tracinho ANDAR feito esteira,
       não desenhar. A janelinha respeita o tracejado.

       ⚠️ O id do clip tem que ser ÚNICO: a mesma função pinta o gráfico em
       mais de um lugar, e dois clipPath com o mesmo id se atrapalham. */
    var _cid='hfclip'+(_hfSeq++);
    var g2='';
    var lp=chrono.map(function(val,i){ return _X(i).toFixed(1)+','+_Y(val).toFixed(1); });
    g2+='<polygon points="'+pL+','+pB+' '+lp.join(' ')+' '+pR+','+pB+'" fill="rgba(10,77,166,.09)"/>';
    /* v303 (pedido) — a linha ficou FINA e TRACEJADA. A área azul clara
       embaixo e as bolinhas (a atual, a máxima em verde e a mínima em
       vermelho) continuam iguais: são elas que dão a leitura do gráfico. */
    g2+='<polyline points="'+lp.join(' ')+'" fill="none" stroke="#0a4da6" stroke-width="1.1" stroke-dasharray="4 3" stroke-linecap="round" stroke-linejoin="round"/>';
    var maxCI=chrono.indexOf(max), minCI=chrono.indexOf(min);
    for(var pi=0; pi<n; pi++){ var cls='dot', rr=2.2;
      if(pi===n-1){ cls='dotcur'; rr=3.4; } else if(pi===maxCI){ cls='dotmax'; rr=3; } else if(pi===minCI){ cls='dotmin'; rr=3; }
      g2+='<circle class="'+cls+'" cx="'+_X(pi).toFixed(1)+'" cy="'+_Y(chrono[pi]).toFixed(1)+'" r="'+rr+'"/>'; }
    /* o anel que pisca UMA vez no ponto de hoje, quando a linha termina de
       aparecer — é o único ponto do gráfico que interessa agir sobre */
    if(n){ g2+='<circle class="dotping" cx="'+_X(n-1).toFixed(1)+'" cy="'+_Y(chrono[n-1]).toFixed(1)+'" r="3.4"/>'; }
    var idxs=n<=3?chrono.map(function(_x,i){ return i; }):[0,Math.floor((n-1)/2),n-1];
    idxs.forEach(function(ix){ var anc=ix===0?'start':(ix===n-1?'end':'middle');
      g+='<text class="mlb" x="'+_X(ix).toFixed(1)+'" y="'+(pB+13)+'" text-anchor="'+anc+'">'+esc(_hfMesCurto(mesesC[ix]))+'</text>'; });
    /* ============================================================================
       🔴 v1085 — AQUI MORAVA O ZOOM DO GRÁFICO (pedido do Angelo, 19/09:
       "remove esse zoom do grafico")
       ----------------------------------------------------------------------------
       A v896 (04/09) pôs uma janelinha que rolava na horizontal e um par de
       botões − / 1× / + embaixo do gráfico, pra esticar a linha no celular.
       Saiu inteiro: os botões, a janelinha que rolava, o ouvinte delegado e o
       CSS dos cinco nomes (.hf-zoom, .hf-zvp, .hf-zbar, .hf-znv, .hf-zb).

       ⚠️ O QUE NÃO MUDOU: o gráfico. Em 1× — o estado em que ele sempre
       nascia — o SVG já era 100% de largura e a janelinha não rolava. Tirar a
       moldura devolve exatamente a mesma imagem; só a barra de botões some.
       ============================================================================ */
    var spark='<svg class="hf-chart" viewBox="0 0 '+W+' '+H+'">'+
      '<defs><clipPath id="'+_cid+'"><rect class="hf-rev" x="0" y="-20" width="'+(W+4)+'" height="'+(H+40)+'"/></clipPath></defs>'+
      g+
      '<g clip-path="url(#'+_cid+')">'+g2+'</g>'+
      '</svg>';
    var dir=p12<-0.3?'down':(p12>0.3?'up':'flat');
    var arrow=dir==='down'?'▼':(dir==='up'?'▲':'▬');
    var periodo=idx12===1?'em 1 mês':('em '+idx12+' meses');
    var resumo='<div class="hf-top">'+
      '<span class="hf-lbl">Valor FIPE atual · '+esc(_hfMesLongo(h[0].mes))+'</span><span class="hf-big">'+esc(brl(atual))+'</span>'+
      '<div class="hf-varbox '+dir+'"><span class="hf-arr">'+arrow+'</span><span class="hf-var">'+(d12>=0?'+':'−')+esc(brl(Math.abs(d12)))+' · '+(p12>=0?'+':'−')+Math.abs(p12).toFixed(1).replace('.',',')+'%</span><span class="hf-per">'+periodo+'</span></div>'+
      spark+
      '<div class="hf-mm"><span><small>Menor valor</small><b>'+esc(brl(min))+'</b><em>'+esc(_hfMesCurto(h[minI].mes))+'</em></span><span><small>Maior valor</small><b>'+esc(brl(max))+'</b><em>'+esc(_hfMesCurto(h[maxI].mes))+'</em></span></div>'+
    '</div>';
    /* v162 — cada mês mostra o quanto subiu/caiu em REAIS e também em PORCENTAGEM
       em relação ao mês anterior (o de baixo na lista). */
    /* 🔴 v896 (pedido do Angelo): "historico, mostre os ultimos 6 meses".
       Eram 14 — quase um ano e meio de linhas pra rolar num celular. O que
       ele olha é o movimento recente; o ano inteiro continua no GRÁFICO logo
       acima e na variação de 12 meses do resumo, que não mudaram. Menos
       linha, mesma informação. */
    var rows=h.slice(0,6).map(function(x,i){
      var val=Number(x.valor)||0, prev=(i+1<h.length)?(Number(h[i+1].valor)||0):null, dHtml;
      if(prev!=null){
        var d=val-prev, c=d>0?'up':(d<0?'down':'flat');
        var pc=prev>0?(d/prev*100):0;
        var sinal=d>0?'+':(d<0?'−':'');
        var pct=(Math.abs(pc)).toFixed(2).replace('.',',');
        dHtml='<span class="hf-d '+c+'"><b>'+sinal+esc(brl(Math.abs(d)))+'</b><i>'+(d===0?'0,00%':(sinal+pct+'%'))+'</i></span>';
      }
      else dHtml='<span class="hf-d flat"><b>—</b><i>1º mês</i></span>';
      return '<div class="hf-row'+(i===0?' cur':'')+'"><span class="hf-mes">'+esc(_hfMesCurto(x.mes))+'</span><span class="hf-val">'+esc(brl(val))+'</span>'+dHtml+'</div>';
    }).join('');
    /* .hf-wrap: coluna única (resumo+gráfico em cima, extrato mensal embaixo) */
    return '<div class="hf-wrap">'+resumo+'<div class="hf-lista">'+rows+'</div></div>';
  }

  /* ---- Tela: Ficha Técnica ---- */
  function telaHistFipe(){ var v=veiculoAtual; if(!v) return abrirMenu(); irTela(panelHead(ICO.hist,'blue','Histórico da FIPE — '+esc(v.placa), subInfoDe(v))+'<div class="plc-card" style="margin-top:12px;padding:14px">'+histFipeHtml(v)+'</div>','menu'); }

/* ╔═══ src/app/02a-areas-avaliacoes.js ═══════════════════════════════════ */
  // A area e estado de navegacao, nunca uma troca de edicao ou de conta.
  var _avArea='consultas';
  function avAreaConsultas(){ return edicaoAtual()==='avalia' && _avArea==='consultas'; }
  function avAreaSalvar(){
    if(!$('avBody') || !$('cardVeiculo') || $('cardVeiculo').style.display==='none') return true;
    avFormSalvar();
    try{
      if(localStorage.getItem(avFormKey())!==JSON.stringify(avFormObj())) throw new Error('rascunho');
    }catch(_){ toast('Não consegui guardar o rascunho. Tente novamente antes de sair.'); return false; }
    clearTimeout(_avCloudTimer); avFormSalvarNuvem();
    /* v1481: trocar de área também conclui o salvamento da linha que abastece
       Minhas avaliações, ainda que a galeria esteja vazia. */
    try{ if(typeof avAvaliacaoSalvarCompleta==='function') avAvaliacaoSalvarCompleta(); }catch(_){}
    return true;
  }
  function avAreaMarcar(area){
    if(edicaoAtual()!=='avalia') return;
    _avArea=area==='consultas'?'consultas':'avaliacoes';
    document.body.classList.toggle('av-area-consultas',_avArea==='consultas');
    document.querySelectorAll('#avAreas [data-av-area]').forEach(function(b){
      b.setAttribute('aria-pressed',String(b.getAttribute('data-av-area')===_avArea));
    });
  }
  function avAreaIr(area){
    if(edicaoAtual()!=='avalia' || _buscando || $('avConsultaLoad')) return;
    if(area==='avaliacoes' && typeof acPortao==='function' && acPortao('avaliacoes')) return;
    if(!avAreaSalvar()) return;
    avAreaMarcar(area);
    $('secoes').innerHTML='';
    drawerFechar(false);
    /* v1419 — a Home do MEV Avaliações agora é uma única composição: o
       bloco Avaliações fica acima da Home completa do Consultas. A lista de
       avaliações continua sendo uma página interna, não uma segunda Home. */
    if(area==='avaliacoes'){ telaAvaliacoes(); return; }
    voltarHome();
  }
  function avAreasMontar(){
    /* v1419 — o seletor Consultas | Avaliações deixou de existir: as duas
       portas convivem na mesma Home, na ordem Avaliações → Consultas. */
    if(edicaoAtual()==='avalia') return;
    if($('avAreas') || !$('mevTopbar')) return;
    var n=document.createElement('nav'); n.id='avAreas'; n.setAttribute('aria-label','Área do aplicativo');
    /* v973 — a ordem acompanha a abertura inicial: Consultas fica à esquerda
       e Avaliações à direita. O estado real continua vindo de avAreaMarcar(),
       abaixo; estes aria-pressed são só o estado inicial do HTML recém-criado. */
    n.innerHTML='<button type="button" data-av-area="consultas" aria-pressed="true">'+_CT_ICO.placa+'<span>Consultas</span></button>'+
      '<button type="button" data-av-area="avaliacoes" aria-pressed="false">'+_CTF_ICO_AVAL+'<span>Avaliações</span></button>';
    $('scApp').insertBefore(n,$('scApp').firstChild);
    avAreaMarcar(_avArea);
    n.querySelectorAll('button').forEach(function(b){ b.onclick=function(){ avAreaIr(b.getAttribute('data-av-area')); }; });
    function medir(){ document.documentElement.style.setProperty('--av-areas-top',$('mevTopbar').getBoundingClientRect().bottom+'px'); }
    medir(); if(window.ResizeObserver) new ResizeObserver(medir).observe($('mevTopbar'));
    window.addEventListener('resize',medir);
  }

/* ╔═══ src/app/02b-icones-3d.js ══════════════════════════════════════════ */
  /* ==========================================================================
     02b — OS ÍCONES 3D SAÍRAM DO BUILD NA v764 (FASE 5 do
     PROJETO-2026-08-30-cards-consulta-svg-e-grupos)
     --------------------------------------------------------------------------
     A v762 trocou os cards da home por SVG de LINHA e a auditoria da FASE 5
     não achou nenhum consumidor do ICO3D — os ~30 KB de arte saíram do
     app.js. A ARTE NÃO FOI APAGADA: mora em amostras/icones-3d-guardados.js,
     com a receita de reativação no cabeçalho (copiar de volta pra cá e rodar
     node montar.js).
     Este toco só existe porque a conversa remota não consegue apagar arquivo
     no seu Mac — PODE APAGAR este arquivo quando quiser (o montar segue
     funcionando igual, só deixa de colar este comentário).
     ========================================================================= */

/* ╔═══ src/app/02c-padrao-consultas.js ═══════════════════════════════════ */
  /* ==========================================================================
     02c — O PADRÃO UNIFICADO DAS PÁGINAS DE CONSULTA (v747, Versão A)
     ==========================================================================
     docs/PROJETO-2026-08-29-padrao-unificado-paginas-de-consulta.txt
     Uma casca só pra todas as consultas: cabeçalho → formulário → o que
     inclui → ação principal → confiança/exemplo → resultado → outras
     consultas. Este módulo só COMPÕE HTML e estados visuais. Aqui NÃO entra
     chamada de API, débito, parsing de fornecedor, autorização, histórico
     nem PDF — isso continua nos módulos de cada consulta (03, 03d, 04, 05d).

     Versão A = componentes + tela piloto "Buscar por veículo". As outras
     famílias migram em versões próprias (Plus → veículo/AutoCorp → CPF →
     CNPJ → barra inferior), cada uma validada no celular antes da próxima.

     Preço: aparece na landing e na confirmação anterior à cobrança. O botão
     da página mantém somente a ação, sem repetir preço ou gratuidade.
     ========================================================================= */
  var _CU_CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var _CU_SPIN='<svg class="consulta-ui-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.2-8.56"/></svg>';

  /* v1405 — assinatura institucional reutilizada no menu, na Home e nas
     páginas internas do MEV Consultas. A atribuição é deliberadamente
     específica: AutoCorp é a fonte dos relatórios veiculares completos,
     não das consultas gratuitas, FIPE, CPF ou CNPJ.
     v1412 — nas páginas, a composição passa a ser idêntica à do menu e a
     versão fica visível de forma discreta. */
  function mevConsultasRodapeHtml(modo){
    var menu=modo==='menu', tag=menu?'div':'footer';
    var versao='';
    if(!menu){
      try{
        var meta=document.querySelector('meta[name="mev-build"]');
        versao=String((meta&&meta.getAttribute('content'))||'').replace(/^v/i,'');
      }catch(_){}
    }
    return '<'+tag+' class="mev-consultas-rodape'+(menu?' is-menu':'')+'"'+(menu?'':' aria-label="Sobre o MEV Consultas"')+'>'
      +'<img src="/mev-consultas/icone.svg" width="40" height="40" alt="">'
      +'<span class="mev-consultas-rodape-copy"><strong>MEV Consultas</strong><span>Informação para apoiar decisões mais seguras.</span><small>Relatórios completos: fonte AutoCorp.</small></span>'
      +(versao?'<span class="mev-consultas-rodape-versao">Versão '+esc(versao)+'</span>':'')
      +'</'+tag+'>';
  }

  /* cabeçalho da página: mesma peça do panelHead (compatível), com a classe do padrão */
  function consultaUiCabecalho(cfg){
    cfg=cfg||{};
    /* v768: selo opcional ao lado do título (ex.: GRÁTIS na Consulta CNPJ) —
       verde canônico, quebra junto com o título abaixo de 360px */
    return '<div class="plc-panel-head consulta-ui-head"><span class="ico '+esc(cfg.cor||'blue')+'" aria-hidden="true">'+(cfg.ico||'')+'</span>'
      +'<div><h2>'+esc(cfg.titulo||'')+(cfg.selo?('<span class="consulta-ui-selo">'+esc(cfg.selo)+'</span>'):'')+'</h2>'+(cfg.sub?'<p>'+esc(cfg.sub)+'</p>':'')+'</div></div>';
  }
  /* o card principal (fundo branco, borda canônica, raio 16) */
  function consultaUiCard(conteudo, opcoes){
    opcoes=opcoes||{};
    return '<section class="consulta-ui-card'+(opcoes.classe?(' '+esc(opcoes.classe)):'')+'"'+(opcoes.id?(' id="'+esc(opcoes.id)+'"'):'')+'>'+(conteudo||'')+'</section>';
  }
  /* v1044 — quando a consulta já passou por uma landing, o formulário não
     repete benefícios nem exemplo. Consultas sem landing (grátis/legadas)
     preservam o conteúdo explicativo que sempre tiveram. */
  function consultaUiTemLanding(chave){
    try{ return typeof consultaLandingEh==='function' && consultaLandingEh(chave); }catch(_){ return false; }
  }
  /* etapa numerada (número informativo, não clicável) — só quando há sequência real */
  function consultaUiEtapa(numero, titulo, conteudo, opcoes){
    opcoes=opcoes||{};
    return '<div class="consulta-ui-step'+(opcoes.classe?(' '+esc(opcoes.classe)):'')+'"'+(opcoes.id?(' id="'+esc(opcoes.id)+'"'):'')+'>'
      +'<div class="consulta-ui-step-h">'+(numero!=null?('<span class="consulta-ui-step-num" aria-hidden="true">'+esc(String(numero))+'</span>'):'')+'<span class="consulta-ui-step-t">'+esc(titulo||'')+'</span>'+(opcoes.nota?('<span class="consulta-ui-step-n">'+esc(opcoes.nota)+'</span>'):'')+'</div>'
      +(conteudo||'')+'</div>';
  }
  /* "o que a consulta inclui": até 4 linhas visíveis, SVG de linha, sem emoji */
  function consultaUiBeneficios(itens, opcoes){
    opcoes=opcoes||{}; itens=(itens||[]).map(function(t){ return String(t||'').replace(/^\s*[✅✔️✓]\s*/,''); }).filter(Boolean);
    var vis=itens.slice(0,4), resto=itens.slice(4);
    var li=function(t){ return '<li>'+_CU_CHECK+'<span>'+esc(t)+'</span></li>'; };
    return '<div class="consulta-ui-benefits">'+(opcoes.titulo!==''?('<div class="consulta-ui-benefits-t">'+esc(opcoes.titulo||'O que a consulta inclui')+'</div>'):'')
      +'<ul>'+vis.map(li).join('')+'</ul>'
      +(resto.length?('<details class="consulta-ui-benefits-mais"><summary>Ver tudo o que inclui</summary><ul>'+resto.map(li).join('')+'</ul></details>'):'')+'</div>';
  }
  /* o botão principal: ação curta; preço fica na landing/confirmação */
  function consultaUiCta(cfg){
    cfg=cfg||{};
    var rot=consultaUiCtaRotulo(cfg);
    return '<button type="button" class="consulta-ui-cta'+(cfg.classe?(' '+esc(cfg.classe)):'')+'"'+(cfg.id?(' id="'+esc(cfg.id)+'"'):'')+(cfg.disabled?' disabled':'')+' data-cu-rotulo="'+esc(rot)+'"><span class="consulta-ui-cta-tx">'+esc(rot)+'</span></button>';
  }
  function consultaUiCtaRotulo(cfg){
    cfg=cfg||{};
    if(cfg.rotulo) return cfg.rotulo;
    var verbo=cfg.verbo||'Consultar';
    return verbo;
  }
  /* estados do botão: 'pronto' | 'incompleto' | 'carregando' | 'erro' | 'salvo' | 'novamente' */
  function consultaUiEstadoCta(botao, estado, texto){
    if(!botao) return;
    var tx=botao.querySelector('.consulta-ui-cta-tx')||botao;
    var base=botao.getAttribute('data-cu-rotulo')||tx.textContent;
    botao.classList.remove('is-loading','is-error','is-saved');
    botao.removeAttribute('aria-busy');
    if(estado==='carregando'){ botao.disabled=true; botao.classList.add('is-loading'); botao.setAttribute('aria-busy','true'); tx.innerHTML=_CU_SPIN+esc(texto||'Consultando…'); return; }
    if(estado==='incompleto'){ botao.disabled=true; tx.textContent=texto||base; return; }
    if(estado==='erro'){ botao.disabled=false; botao.classList.add('is-error'); tx.textContent=texto||'Tentar novamente'; return; }
    if(estado==='salvo'){ botao.disabled=false; botao.classList.add('is-saved'); tx.textContent=texto||'Abrir consulta salva'; return; }
    if(estado==='novamente'){ botao.disabled=false; tx.textContent=texto||base.replace(/^Consultar/,'Consultar novamente'); return; }
    botao.disabled=false; tx.textContent=texto||base;   /* pronto */
  }
  /* v753 — o mesmo estado pra botão do padrão OU botão antigo (sem a classe):
     o antigo segue no caminho de sempre, disabled + texto. Serve a qualquer
     módulo (03 usa via _cpf3Cta; 04 direto). */
  function consultaUiBotao(bt, estado, texto){
    if(!bt) return;
    if(bt.classList && bt.classList.contains('consulta-ui-cta')){ try{ consultaUiEstadoCta(bt, estado, texto); return; }catch(_){} }
    if(estado==='carregando'){ bt.disabled=true; bt.textContent=texto||'Consultando…'; return; }
    bt.disabled=false; if(texto) bt.textContent=texto;
  }
  /* aviso de "veio do histórico" */
  function consultaUiAvisoHistorico(cfg){
    cfg=cfg||{};
    return '<div class="consulta-ui-hist" role="status">'+_CU_CHECK+'<span>'+esc(cfg.texto||'Consulta salva — reaberta sem custo')+(cfg.quando?(' · '+esc(cfg.quando)):'')+'</span></div>';
  }
  /* v1403 — uma porta única para resultados já pagos. O conteúdo continua
     sendo montado pelo módulo do produto; esta peça só troca a lista aberta
     por um card acessível e recolhível. */
  function consultaUiHistoricoCard(id, opcoes){
    opcoes=opcoes||{};
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v6h6"/><path d="M12 7v5l3 2"/></svg>';
    var seta='<svg class="consulta-historico-seta" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
    return '<section class="consulta-historico-card">'
      +'<button type="button" class="consulta-historico-toggle" aria-expanded="false" aria-controls="'+esc(id)+'">'
      +'<span class="consulta-historico-ico">'+ico+'</span><span class="consulta-historico-tx"><strong>Histórico</strong><small>'+esc(opcoes.texto||'Veja e reabra suas pesquisas anteriores')+'</small></span>'+seta+'</button>'
      +'<div id="'+esc(id)+'" class="consulta-historico-conteudo" hidden></div></section>';
  }
  function consultaUiHistoricoLigar(root){
    root=root||document;
    Array.prototype.forEach.call(root.querySelectorAll('.consulta-historico-toggle'),function(bt){
      bt.onclick=function(){
        var id=bt.getAttribute('aria-controls'), painel=id?$(id):null; if(!painel) return;
        var abre=bt.getAttribute('aria-expanded')!=='true';
        bt.setAttribute('aria-expanded',abre?'true':'false'); painel.hidden=!abre;
        if(abre) try{ painel.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(_){}
      };
    });
  }
  /* linha de confiança (pequena, abaixo do botão) */
  function consultaUiTrust(texto){
    return texto?('<p class="consulta-ui-trust">'+esc(texto)+'</p>'):'';
  }
  /* v775 (pedido, com print): o card "Ver exemplo (PDF)" ganhou DOIS ícones
     no lugar do ">": visualizar (olho) e baixar (seta) — e o botão
     "Baixar (em) PDF" que aparecia DEBAIXO da folha do exemplo saiu.
     Este helper monta os dois botões; quem chama liga os cliques nos ids
     idBase+'Ver' e idBase+'Bx'. Usado pelo 03 (CPF) e pelo 03d (veículo). */
  function consultaUiExemploAcoes(idBase){
    return '<span class="cpf3-ex-acts">'
      +'<button type="button" class="cpf3-ex-bt" id="'+idBase+'Ver" aria-label="Visualizar o exemplo" title="Visualizar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></button>'
      +'<button type="button" class="cpf3-ex-bt" id="'+idBase+'Bx" aria-label="Baixar o exemplo em PDF" title="Baixar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg></button>'
      +'</span>';
  }
  /* mensagem de erro/aviso ligada a um campo (aria-live) */
  function consultaUiMsg(id, texto, tipo){
    var el=$(id); if(!el) return;
    el.textContent=texto||''; el.className='consulta-ui-msg'+(tipo?(' is-'+tipo):''); el.hidden=!texto;
  }
  /* ---------- outras consultas: só da mesma família, só permitidas, sem a atual ----------
     Fonte: CONS_TABS + CONS_FAMILIA (05d) · preço: consPreco/seloHtml (05d) ·
     permissão da edição: edConsPermite (00) · AutoCorp: body.autocorp-off
     esconde [data-cons] leilaopt/premium (o mesmo mecanismo da home). */
  var _CU_DESC={
    fipe:'Versões por ano e valor de referência FIPE',
    plus:'Dados veiculares reunidos em uma consulta',
    gravame:'Banco, contrato e situação da alienação',
    recall:'Recall por placa e chassi, com FIPE atual',
    multas:'Infrações e débitos registrados no RENAINF',
    renajud:'Restrições judiciais vinculadas ao veículo',
    leilaopt:'Leilão, indenização e perda total',
    premium:'Histórico veicular mais completo',
    especialjud:'Leilão especial e bloqueios judiciais',
    cpf:'Dados cadastrais e restrições do CPF',
    cpfproc:'Processos e ações vinculados ao CPF',
    cpfscore:'Integrado à Consulta CPF',
    cnpj:'Situação cadastral e dados da empresa',
    cnpjsintegra:'Inscrição estadual e situação cadastral',
    cnpjprocessos:'Processos e ações vinculados ao CNPJ',   /* v1024 */
    /* v996 — cnpjrisco saiu do app */
  };
  /* ==========================================================================
     🔴 v884 — TRÊS OPÇÕES NOVAS, E A PRIMEIRA É A QUE IMPORTA
     --------------------------------------------------------------------------
     `somente:['gravame','leilaopt','premium']` — LISTA FECHADA. Só estas, nesta
     ordem, e mais nenhuma. É diferente do `preferir`, que só ORDENA uma lista
     aberta: com `preferir` a tela ganharia um quarto card sozinho no dia em que
     alguém acrescentasse uma consulta de veículo no CONS_TABS. O resultado da
     placa pede três, e três é o contrato.
     ⚠️ Mas `somente` NÃO fura fila: os filtros de permissão continuam valendo
     por cima. Consulta que a edição não deixa, ou que a AutoCorp não liberou
     pra esta conta, não entra na lista mesmo estando nomeada — card que leva a
     erro é pior que card que falta.

     `mostrarTodas:false` — some o "Ver todas" do cabeçalho da seção.

     `placa:'ABC1D23'` — leva a placa já consultada pro campo da próxima
     consulta. ⚠️ LEVAR NÃO É CONSULTAR: a página abre com a placa preenchida e
     o botão parado. Quem paga é o dedo (a mesma regra da lupa, v883).
     ========================================================================== */
  function consultaUiRelacionadas(atual, familia, opcoes){
    opcoes=opcoes||{};
    var so=(opcoes.somente&&opcoes.somente.length)?opcoes.somente:null;
    var lista=[];
    try{
      lista=CONS_TABS.filter(function(t){
        if(t[0]===atual) return false;
        if(so && so.indexOf(t[0])<0) return false;
        /* v772 (projeto consultas-adicionais-no-final, regra 5): "Consulta
           placa" saiu das ADICIONAIS de toda página — a página dela continua
           existindo; só o card adicional some. */
        if(t[0]==='placa') return false;
        /* v772: a porta da AutoCorp (v744) vale aqui na MONTAGEM — card que o
           body.autocorp-off esconderia não entra na conta dos 3 do desktop */
        try{ if(document.body.classList.contains('autocorp-off') && (t[0]==='leilaopt'||t[0]==='premium'||t[0]==='especialjud')) return false; }catch(_){}
        if((CONS_FAMILIA[t[0]]||'veiculo')!==familia) return false;
        try{ if(typeof window.edConsPermite==='function' && !window.edConsPermite(t[0])) return false; }catch(_){}
        return true;
      });
    }catch(_){ lista=[]; }
    if(so){
      /* a ordem do pedido é a ordem da tela — o projeto nomeia Gravame,
         Leilão + PT e Total Premium NESSA sequência */
      lista.sort(function(a,b){ return so.indexOf(a[0]) - so.indexOf(b[0]); });
    }
    else{
      /* v1403 — todas as opções da família ficam visíveis e seguem a mesma
         ordem crescente de preço da home. A preferência antiga só desempata. */
      var pref=(opcoes.preferir||[]).slice();
      lista.sort(function(a,b){
        var pa=0,pb=0; try{ pa=CONS_GRATIS[a[0]]?0:(Number(consPreco(a[0]))||0); pb=CONS_GRATIS[b[0]]?0:(Number(consPreco(b[0]))||0); }catch(_){}
        if(pa!==pb) return pa-pb;
        var ia=pref.indexOf(a[0]),ib=pref.indexOf(b[0]); if(ia<0) ia=999; if(ib<0) ib=999;
        return (ia-ib)||String(a[1]).localeCompare(String(b[1]),'pt-BR');
      });
    }
    if(!lista.length) return '';
    var cards=lista.map(function(t){
      var ico=''; try{ ico=_CT_ICO[t[0]]||''; }catch(_){}
      var selo=''; try{ selo=seloHtml(t[0]); }catch(_){}
      var contexto=(opcoes.contexto&&opcoes.contexto[t[0]])||null;
      var pergunta=contexto&&contexto.pergunta?('<span class="consulta-ui-related-pergunta">'+esc(contexto.pergunta)+'</span>'):'';
      var descricao=contexto&&contexto.descricao?contexto.descricao:(_CU_DESC[t[0]]||'Veja os dados incluídos nesta consulta');
      var _pl=opcoes.placa?(' data-cons-placa="'+esc(opcoes.placa)+'"'):'';
      return '<button type="button" class="consulta-ui-related-card" data-cons="'+esc(t[0])+'"'+_pl+'>'+selo+'<span class="consulta-ui-related-ico" aria-hidden="true">'+ico+'</span><span class="consulta-ui-related-tx">'+pergunta+'<span class="consulta-ui-related-nm">'+esc(t[1])+'</span><span class="consulta-ui-related-desc">'+esc(descricao)+'</span></span></button>';
    }).join('');
    return '<section class="consulta-ui-related consulta-ui-related-todas" aria-label="'+esc(opcoes.titulo||'Outras pesquisas')+'"><div class="consulta-ui-related-h"><span>'+esc(opcoes.titulo||'Outras pesquisas')+'</span></div>'
      +'<div class="consulta-ui-related-row">'+cards+'</div></section>';
  }
  function consultaUiRelacionadasLigar(root){
    root=root||document;
    try{
      /* 🔴 v891 — O SELETOR DEIXOU DE EXIGIR A CLASSE DO CARD.
         A tela da placa passou a ter DOIS BOTÕES (Leilão + PT e Total
         Premium) que não são cards, mas vão pro mesmo lugar. A alternativa
         era um segundo listener em paralelo — exatamente o que o comentário
         da v884 mais abaixo proíbe, e por bom motivo: dois caminhos pro mesmo
         destino divergem no primeiro ajuste. Agora QUALQUER elemento com
         `data-cons` é ligado por aqui, card ou não. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-cons]'), function(b){ b.onclick=function(){
        /* v884 — a placa viaja junto quando o card foi montado com ela. Sem
           isto, sair do resultado de ABC1D23 pro Gravame abriria um campo
           vazio e o Angelo digitaria a mesma placa de novo, no pátio. */
        try{ consIr(b.getAttribute('data-cons'), b.getAttribute('data-cons-placa')||''); }catch(_){}
      }; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-cu-todas]'), function(b){ b.onclick=function(){ try{ voltarHome(); }catch(_){} }; });
    }catch(_){}
  }
  /* ---------- a página inteira ----------
     No celular a grade grande de atalhos NÃO vem antes do formulário: as
     relacionadas ficam depois. v772 (projeto consultas-adicionais-no-final):
     no COMPUTADOR a barrinha/grade que aparecia ANTES do conteúdo SAIU —
     a página começa no cabeçalho + título + formulário, e as outras
     consultas moram SÓ no fim (consultaUiRelacionadas: 3 cards numa linha,
     o CSS corta além do 3º no desktop). */
  function consultaUiPagina(cfg, conteudo){
    cfg=cfg||{};
    try{ mevTabSet(cfg.tab||''); }catch(_){}
    var html=consultaUiCabecalho(cfg)+'<div class="consulta-ui" data-cu="'+esc(cfg.chave||'')+'">'+(conteudo||'')+'</div>';
    irTela(html, cfg.voltar||'menu');
    try{ document.body.classList.remove('md-veiculo'); }catch(_){}
    /* v754 — Versão F: a barra inferior compacta (dock) vale só nas páginas do
       padrão, no celular. A classe nasce aqui (e o irTela também a liga ao ver
       .consulta-ui) e morre em qualquer troca de tela (mevTabSet/voltarHome). */
    try{ document.body.classList.add('consulta-ui-on'); consultaUiDockMedir(); }catch(_){}
    /* v772: a injeção da barrinha no computador SAIU (era o bloco abaixo).
       consTabsInjetar continua vivo no 05d pra rollback — religar é
       descomentar estas quatro linhas.
       // try{
       //   var desk=window.innerWidth>=900;
       //   if(desk && cfg.chave){ consTabsInjetar(cfg.chave); }
       // }catch(_){} */
    try{ consultaUiRelacionadasLigar($('secoes')); }catch(_){}
    try{ consultaUiHistoricoLigar($('secoes')); }catch(_){}
    try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar(cfg.titulo||''); }catch(_){}
    /* v859 — a partir daqui a tela sabe sozinha quando foi consultada, e o
       quadro "o que inclui" + o "Ver exemplo (PDF)" saem da frente. */
    try{ consultaUiVigiaResultado($('secoes')); }catch(_){}
    try{ consultaUiSync(); }catch(_){}
    /* v767: a chamada de atenção finita do campo principal (projeto
       animacao-campos) — só nas páginas do padrão, uma vez por sessão */
    try{ consultaCampoAnimIniciar($('secoes'), cfg.chave||''); }catch(_){}
  }

  /* ==========================================================================
     v1034 — PÁGINA COMPARTILHADA DE RESULTADO
     docs/PROJETO-2026-09-15-resultados-consultas-em-pagina-separada.txt

     Esta casca só cuida de estrutura, navegação e acessibilidade. Parser,
     cobrança, persistência e PDF continuam pertencendo ao produto. O estado
     guarda callbacks em memória: voltar e "Nova consulta" nunca chamam o
     fornecedor por acidente e nunca reaproveitam um clique de confirmação.
     ========================================================================== */
  var _consultaResultadoEstado=null;
  var _CR_ICO={
    voltar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    ver:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    baixar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5M12 15V3"/></svg>',
    compartilhar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4"/></svg>',
    nova:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    sucesso:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.7 2.7L16.5 9"/></svg>',
    atencao:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.6 2.5 17a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>',
    erro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m9 9 6 6M15 9l-6 6"/></svg>',
    info:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>',
    relatorio:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6M8 13h8M8 17h6"/></svg>'
  };
  function consultaResultadoCabecalho(cfg){
    cfg=cfg||{};
    return '<header class="consulta-resultado-head">'
      +'<button type="button" class="consulta-resultado-voltar" id="consultaResultadoVoltar" aria-label="Voltar para a consulta">'+_CR_ICO.voltar+'</button>'
      +'<div class="consulta-resultado-head-tx"><span class="consulta-resultado-kicker">RESULTADO DA CONSULTA</span><h1>'+esc(cfg.titulo||'Resultado')+'</h1>'
      +(cfg.identificacao?'<p>'+esc(cfg.identificacao)+'</p>':'')+'</div>'
      +(cfg.origem==='salva'?'<span class="consulta-resultado-origem">Consulta salva</span>':'')
      +(cfg.dataHora?'<time class="consulta-resultado-data">'+esc(cfg.dataHora)+'</time>':'')+'</header>';
  }
  function consultaResultadoResumo(cfg){
    cfg=cfg||{}; var tom=cfg.tom||'info';
    return '<section class="consulta-resultado-resumo is-'+esc(tom)+'" aria-label="Resumo do resultado">'
      +'<span class="consulta-resultado-resumo-icone">'+(_CR_ICO[tom==='ok'?'sucesso':tom==='atencao'?'atencao':tom==='erro'?'erro':'info']||_CR_ICO.info)+'</span>'
      +'<div class="consulta-resultado-resumo-tx">'+(cfg.titulo?'<h2>'+esc(cfg.titulo)+'</h2>':'')+(cfg.texto?'<p>'+esc(cfg.texto)+'</p>':'')+'</div></section>';
  }
  function consultaResultadoSecao(cfg){
    cfg=cfg||{};
    return '<section class="consulta-resultado-secao'+(cfg.classe?' '+esc(cfg.classe):'')+'">'
      +(cfg.titulo?'<div class="consulta-resultado-secao-head"><span class="consulta-resultado-secao-icone">'+_CR_ICO.relatorio+'</span><div><h2>'+esc(cfg.titulo)+'</h2>'+(cfg.subtitulo?'<p>'+esc(cfg.subtitulo)+'</p>':'')+'</div></div>':'')
      +'<div class="consulta-resultado-secao-corpo">'+(cfg.html||'')+'</div></section>';
  }
  function consultaResultadoAcoes(acoes){
    acoes=acoes||[]; if(!acoes.length) return '';
    var somenteIcones=acoes.every(function(a){ return !!a.somenteIcone; });
    return '<div class="consulta-resultado-acoes'+(acoes.length===1?' is-unica':'')+(somenteIcones?' is-iconicas':'')+'" aria-label="Ações do resultado">'+acoes.map(function(a){
      var ic=_CR_ICO[a.icone]||'';
      var rot=esc(a.rotulo||'Abrir'), soIcone=!!a.somenteIcone;
      return '<button type="button" id="'+esc(a.id||'')+'" class="consulta-resultado-acao'+(a.primaria?' is-primary':'')+(a.icone==='compartilhar'?' is-share':'')+(soIcone?' is-icon-only':'')+'"'+(soIcone?' aria-label="'+rot+'" title="'+rot+'"':'')+'>'+ic+(soIcone?'':'<span>'+rot+'</span>')+'</button>';
    }).join('')+'</div>';
  }
  /* Oferta contextual, não modal e sem cobrança automática. A consulta paga
     só pode começar depois que a pessoa abre a página sugerida e confirma o
     valor no CTA normal do produto. */
  var _consultaOfertaTimer=null;
  function consultaOfertaFechar(){
    if(_consultaOfertaTimer){ clearTimeout(_consultaOfertaTimer); _consultaOfertaTimer=null; }
    var el=$('consultaOfertaToast'); if(el) el.remove();
  }
  function consultaOfertaToast(cfg){
    cfg=cfg||{}; consultaOfertaFechar();
    var el=document.createElement('aside'); el.id='consultaOfertaToast'; el.className='consulta-oferta-toast';
    el.setAttribute('role','status'); el.setAttribute('aria-live','polite');
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="M9 12l2 2 4-4"/></svg>';
    var x='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    el.innerHTML='<span class="consulta-oferta-icone">'+ico+'</span><div class="consulta-oferta-texto"><strong>'+esc(cfg.titulo||'Próxima análise')+'</strong><span>'+esc(cfg.texto||'Veja uma análise complementar antes de decidir.')+'</span></div><button type="button" class="consulta-oferta-acao" id="consultaOfertaAcao">'+esc(cfg.rotulo||'Ver análise')+'</button><button type="button" class="consulta-oferta-fechar" id="consultaOfertaFechar" aria-label="Fechar sugestão" title="Fechar sugestão">'+x+'</button>';
    /* v1374 — dentro de uma página de resultado, a recomendação participa do
       fluxo antes das ações. Assim ela não cobre acordeões, PDF nem o dock do
       MEV Consultas. Fora dessa página, conserva o toast fixo de contingência. */
    var pagina=document.querySelector('.consulta-resultado'), ancora=pagina&&pagina.querySelector('.consulta-resultado-acoes,.consulta-resultado-nova');
    if(pagina&&ancora){ el.classList.add('is-inline'); pagina.insertBefore(el,ancora); }
    else document.body.appendChild(el);
    var bt=$('consultaOfertaAcao'), fechar=$('consultaOfertaFechar');
    if(bt) bt.onclick=function(){ var ac=cfg.acao; consultaOfertaFechar(); if(typeof ac==='function') ac(); };
    if(fechar) fechar.onclick=consultaOfertaFechar;
    requestAnimationFrame(function(){ el.classList.add('is-visible'); });
    _consultaOfertaTimer=setTimeout(consultaOfertaFechar,12000);
  }
  /* v1145 — saída assistida do resultado da placa. É uma folha de decisão,
     embora o pedido a chame de toast: há conteúdo e três escolhas, então ela
     recebe semântica de diálogo, foco preso e uma saída explícita. Nenhum dos
     dois atalhos consulta ou cobra; `consIr` abre a landing/formulário com a
     placa preenchida e o botão ainda parado. */
  var _consultaSaidaFoco=null;
  function consultaResultadoSaidaHtml(cfg){
    if(!cfg || cfg.chave!=='placa') return '';
    var icoDonos='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2.5 20v-2a5.5 5.5 0 0 1 11 0v2"/><path d="M14.5 15.5a4 4 0 0 1 7 2.5v2"/></svg>';
    var icoJud='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 13 4-4M11 7l4 4M8 14l2 2M14 12l3 3"/></svg>';
    return '<div class="consulta-saida-overlay" id="consultaSaidaOverlay" hidden>'
      +'<div class="consulta-saida-sheet" role="dialog" aria-modal="true" aria-labelledby="consultaSaidaTitulo" aria-describedby="consultaSaidaTexto">'
      +'<span class="consulta-saida-kicker">ANTES DE SAIR</span>'
      +'<h2 id="consultaSaidaTitulo">Quer ver o histórico de proprietários?</h2>'
      +'<p id="consultaSaidaTexto">Use a mesma placa para conferir proprietários e transferências registradas.</p>'
      +'<button type="button" class="consulta-saida-principal" id="consultaSaidaProprietarios">'+icoDonos+'<span><strong>Ver histórico de proprietários</strong><small>A consulta só é cobrada após sua confirmação.</small></span></button>'
      +'<div class="consulta-saida-divisor"><span>Outra verificação recomendada</span></div>'
      +'<button type="button" class="consulta-saida-sugestao" id="consultaSaidaJudicial">'+icoJud+'<span><strong>Leilão Especial + Judicial</strong><small>Confira leilão especial e bloqueios judiciais.</small></span><span class="consulta-saida-seta" aria-hidden="true">›</span></button>'
      +'<button type="button" class="consulta-saida-sair" id="consultaSaidaSair">Sair do resultado</button>'
      +'</div></div>';
  }
  function consultaResultadoSaidaOcultar(){
    var ov=$('consultaSaidaOverlay'); if(!ov) return;
    ov.hidden=true; try{ document.body.classList.remove('consulta-saida-on'); }catch(_){}
    try{ if(_consultaSaidaFoco && _consultaSaidaFoco.focus) _consultaSaidaFoco.focus(); }catch(_){}
    _consultaSaidaFoco=null;
  }
  function consultaResultadoSaidaExecutar(destino){
    var st=_consultaResultadoEstado; if(!st) return;
    var placa=String(st.placa||'');
    st.saidaConfirmada=true; consultaResultadoSaidaOcultar();
    if(destino){
      consultaResultadoFechar(false);
      setTimeout(function(){ try{ consIr(destino, placa); }catch(_){} },0);
      return;
    }
    consultaResultadoFechar(!!st.saidaNova);
  }
  function consultaResultadoSaidaMostrar(nova){
    var st=_consultaResultadoEstado, ov=$('consultaSaidaOverlay');
    if(!st || st.chave!=='placa' || !ov) return false;
    st.saidaNova=!!nova; _consultaSaidaFoco=document.activeElement;
    ov.hidden=false; try{ document.body.classList.add('consulta-saida-on'); }catch(_){}
    var pri=$('consultaSaidaProprietarios'); try{ if(pri) pri.focus({preventScroll:true}); }catch(_){}
    return true;
  }
  function consultaResultadoTentarSair(nova){
    var st=_consultaResultadoEstado;
    if(!st || st.chave!=='placa' || st.saidaConfirmada) return false;
    consultaResultadoFechar(!!nova);
    return true;
  }
  function consultaResultadoFechar(nova){
    consultaOfertaFechar();
    var st=_consultaResultadoEstado; _consultaResultadoEstado=null;
    if(st && st.chave==='placa' && !st.saidaConfirmada){
      _consultaResultadoEstado=st;
      if(consultaResultadoSaidaMostrar(nova)) return;
      _consultaResultadoEstado=null;
    }
    try{ document.body.classList.remove('consulta-resultado-on'); }catch(_){}
    if(!st) return;
    try{ (nova?st.aoNovaConsulta:st.aoVoltar)(); }catch(_){ try{ voltarHome(); }catch(_){} }
  }
  function consultaResultadoAbrir(cfg){
    cfg=cfg||{}; _consultaResultadoEstado=cfg;
    var html='<main class="consulta-resultado" data-resultado-chave="'+esc(cfg.chave||'')+'">'
      +consultaResultadoCabecalho(cfg)+(cfg.resumoHtml||'')
      +'<div class="consulta-resultado-conteudo">'+(cfg.secoesHtml||'')+'</div>'
      +consultaResultadoAcoes(cfg.acoes||[])
      +(cfg.novaConsultaInline?'':'<button type="button" class="consulta-resultado-nova" id="consultaResultadoNova">'+_CR_ICO.nova+'<span>Nova consulta</span></button>')
      +consultaResultadoSaidaHtml(cfg)
      +'</main>';
    irTela(html,'home');
    try{ document.body.classList.add('consulta-ui-on','consulta-resultado-on'); consultaUiDockMedir(); }catch(_){}
    try{ voltarTab(function(){ consultaResultadoFechar(false); }); }catch(_){}
    var vb=$('consultaResultadoVoltar'), nb=$('consultaResultadoNova');
    if(vb) vb.onclick=function(){ consultaResultadoFechar(false); };
    if(nb) nb.onclick=function(){ consultaResultadoFechar(true); };
    var ov=$('consultaSaidaOverlay'), hp=$('consultaSaidaProprietarios'), hj=$('consultaSaidaJudicial'), hs=$('consultaSaidaSair');
    if(hp) hp.onclick=function(){ consultaResultadoSaidaExecutar('proprietarios'); };
    if(hj) hj.onclick=function(){ consultaResultadoSaidaExecutar('especialjud'); };
    if(hs) hs.onclick=function(){ consultaResultadoSaidaExecutar(''); };
    if(ov) ov.onclick=function(e){ if(e.target===ov) consultaResultadoSaidaOcultar(); };
    if(ov) ov.onkeydown=function(e){
      if(e.key==='Escape'){ e.preventDefault(); consultaResultadoSaidaOcultar(); return; }
      if(e.key!=='Tab') return;
      var f=ov.querySelectorAll('button:not([disabled])'); if(!f.length) return;
      var a=f[0], z=f[f.length-1];
      if(e.shiftKey && document.activeElement===a){ e.preventDefault(); z.focus(); }
      else if(!e.shiftKey && document.activeElement===z){ e.preventDefault(); a.focus(); }
    };
    (cfg.acoes||[]).forEach(function(a){ var b=$(a.id); if(b&&typeof a.acao==='function') b.onclick=a.acao; });
    try{ var h=$('secoes').querySelector('.consulta-resultado h1'); if(h){ h.setAttribute('tabindex','-1'); h.focus({preventScroll:true}); } }catch(_){}
  }
  function consultaResultadoDoHistorico(cfg){ cfg=cfg||{}; cfg.origem='salva'; consultaResultadoAbrir(cfg); }
  /* ==========================================================================
     v767 — A CHAMADA DE ATENÇÃO FINITA DOS CAMPOS DE CONSULTA
     (docs/PROJETO-2026-08-30-animacao-campos-e-cnpj.txt, Parte A)
     ==========================================================================
     A animação diz "comece aqui" e SAI DE CENA: o card entra em 220 ms, a
     borda pulsa DUAS vezes (800 ms cada) e um exemplo fictício é digitado
     UMA vez — tudo no PLACEHOLDER (a alternativa aceitável do §5.4: os
     inputs nascem em strings de 5 páginas com markups diferentes; uma
     camada posicionada sobre cada um custaria um wrapper por página).
     Placeholder nunca toca o value, nunca dispara input, nunca consulta.
     Cancela no primeiro pointerdown/focus/input/paste, com valor
     pré-preenchido (histórico reaberto) e no reduced-motion. Uma vez por
     SESSÃO (Set em memória — recarregar o app libera de novo, §5.7).
     O respiro infinito antigo (.lh-inp/.cnpj-inp "respirando" pra sempre)
     fica DESLIGADO nos campos marcados — a troca do movimento infinito
     pela chamada finita é o ponto do projeto (§5.9).
     ========================================================================= */
  var _animVistos={};
  function consultaCampoAnimVisto(chave){ return !!_animVistos[chave]; }
  function consultaCampoAnimCancelar(inp){
    try{
      if(!inp || !inp._cAnim) return;
      var st=inp._cAnim; inp._cAnim=null;
      if(st.tm){ clearInterval(st.tm); } if(st.t2){ clearTimeout(st.t2); } if(st.t0){ clearTimeout(st.t0); }
      st.evs.forEach(function(par){ try{ inp.removeEventListener(par[0], par[1]); }catch(_){} });
      inp.classList.remove('is-chamando');
      inp.placeholder=st.ph;
    }catch(_){}
  }
  function consultaCampoAnimIniciar(root, chave){
    var inp=(root||document).querySelector('input[data-consulta-anim]');
    if(!inp || !chave) return;
    if(_animVistos[chave]) return;
    _animVistos[chave]=1;   /* mesmo cancelada, não recomeça na sessão (§5.7) */
    try{ if(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(_){}
    /* a entrada do card: 220 ms, transform+opacity (mesma curva da casa) */
    try{ var card=inp.closest('.consulta-ui-card'); if(card) card.classList.add('consulta-campo-entra'); }catch(_){}
    var st={ ph:inp.getAttribute('placeholder')||'', tm:null, t2:null, t0:null, evs:[] };
    inp._cAnim=st;
    function cancela(){ consultaCampoAnimCancelar(inp); }
    /* pointerdown/input/paste cancelam SEMPRE (só um humano os dispara).
       'focus' entra com carência de 500 ms: as páginas de veículo AUTOFOCAM
       o campo em ~140 ms (veicWire, comportamento antigo) e esse foco
       programático não é o "primeiro toque" do §5.6 — sem a carência a
       chamada morreria no berço exatamente onde o projeto mais a quer. O
       foco vindo do teclado (Tab) depois da carência cancela normalmente. */
    ['pointerdown','input','paste'].forEach(function(ev){ inp.addEventListener(ev,cancela); st.evs.push([ev,cancela]); });
    setTimeout(function(){ if(inp._cAnim===st){ inp.addEventListener('focus',cancela); st.evs.push(['focus',cancela]); } },500);
    /* espera um tique: quem reabre do histórico preenche o value LOGO DEPOIS
       de montar a página — com valor no campo, nada de animação (§5.5) */
    st.t0=setTimeout(function(){
      st.t0=null;
      if(!inp.isConnected || String(inp.value||'')){ cancela(); return; }
      var tipo=inp.getAttribute('data-consulta-anim');
      var exemplo=(tipo==='cnpj')?'00.000.000/0000-00':(tipo==='cpf')?'000.000.000-00':'ABC1D23';
      inp.classList.add('consulta-campo-anim','is-chamando');   /* 2 pulsos de 800 ms (CSS) */
      var i=0, passo=Math.min(90, Math.max(40, Math.floor(1000/exemplo.length)));
      st.tm=setInterval(function(){
        i++; try{ inp.placeholder=exemplo.slice(0,i); }catch(_){}
        if(i>=exemplo.length){ clearInterval(st.tm); st.tm=null; st.t2=setTimeout(cancela, 480); }
      }, passo);
    }, 80);
  }
  /* v754 — a altura REAL da barra vira a variável do padding inferior da
     página (regra 8.2: "padding inferior calculado pela altura real da
     barra"). Medida no próximo quadro, depois que o CSS assentou. */
  /* ==========================================================================
     v795 — A WHITELIST DO DOCK DO COMPUTADOR, NUM LUGAR SÓ
     --------------------------------------------------------------------------
     PROJETO-2026-08-31-shell-desktop-padronizado, §5 e §14.

     QUEM ENTRA: as páginas internas genéricas que usam os quatro destinos
     globais — consulta, conta, loja, histórico (v793) e, a partir da v795,
     as cinco telas operacionais (Mercado, Estoque, Repasse, Vendas e
     Avaliações), todas marcadas com `oper-on`.

     QUEM FICA DE FORA, E POR QUÊ:
       veh-on ....... navegação operacional própria de cinco itens (v757).
                      ⚠️ Hoje ela está DORMENTE: o vehNavLigar() existe mas
                      nunca é chamado. Fica na lista de exclusão mesmo assim
                      — no dia em que a fase 2 dela ligar, o dock global não
                      pode atropelar uma navegação que ninguém revisou.
       crm-fx-on
       ch-fx-on ..... controlam a própria navegação (escondem a .fab-row).
       md-veiculo ... o detalhe de veículo em tela cheia.
                      ⚠️ MAS só quando a página NÃO é operacional. O irTela()
                      liga md-veiculo em toda página interna, e quatro das
                      cinco telas o desligam em seguida — o Mercado não. Sem
                      esta ressalva o Mercado ficaria de fora por um detalhe
                      de implementação, não por decisão de projeto. O detalhe
                      de veículo de verdade nunca tem `oper-on`.
     ========================================================================== */
  /* v884 — `resultado-veiculo-on` entra na lista (§5 do projeto do resultado
     FIPE). ⚠️ É uma classe PRÓPRIA, e não o `md-veiculo`: aquele atende mais de
     um contexto e ligaria a barra em tela que não deve ter. Quem acende e apaga
     esta é o `irTela` (02), pela presença da `.plc-placa` na tela — o mesmo
     jeito do `consulta-ui-on`, então ela se limpa sozinha em qualquer navegação. */
  var DOCK_LARGO_ENTRA=['consulta-ui-on','conta-on','loja-on','hist-on','oper-on','resultado-veiculo-on','veh-on'];   /* v885: a veh-on entrou */
  /* 🔴 v885 — a `veh-on` SAIU desta lista. Ela ficava de fora porque tinha
     barra própria (cinco destinos); agora a cápsula acolhe os cinco, e §7 do
     projeto do histórico manda: "páginas com os mesmos cinco destinos devem
     reutilizar a mesma classe e os mesmos tokens".
     ⚠️ A `crm-fx-on` e a `ch-fx-on` CONTINUAM fora, e não é descuido: elas
     controlam a própria navegação em tela cheia, e o §6F do projeto anterior
     diz pra não forçar a barra global por cima disso. */
  var DOCK_LARGO_FORA =['crm-fx-on','ch-fx-on'];
  function dockLargoQuer(){
    try{
      var cl=document.body.classList;
      if(!DOCK_LARGO_ENTRA.some(function(c){ return cl.contains(c); })) return false;
      if(DOCK_LARGO_FORA.some(function(c){ return cl.contains(c); })) return false;
      if(cl.contains('md-veiculo') && !cl.contains('oper-on')) return false;
      return true;
    }catch(_){ return false; }
  }
  /* ==========================================================================
     🔴 v800 (§9 do PROJETO-2026-08-31-avaliacoes-mobile): A BARRA TAMBÉM NO
     CELULAR — mas SÓ onde o projeto mandou.
     --------------------------------------------------------------------------
     Até a v799 a .fab-row virava BARRA só no computador (a v793, dentro de um
     @media min-width:900px) e no celular continuava sendo quatro círculos
     soltos flutuando POR CIMA do card — o §2.3 do projeto: eles escondiam a
     "Avaliação loja" e a data.

     🔴 A DECISÃO QUE IMPORTA: a barra do celular vale APENAS em `oper-on`.
     Não estendi a whitelist inteira porque o projeto pede esta página, e cada
     tela de fora tem motivo próprio pra continuar como está (o veh-on tem
     navegação de cinco itens, o crm-fx-on e o ch-fx-on controlam a própria).
     Mexer nelas de carona seria redesenhar telas que este projeto declarou
     fora de escopo (§16).

     ⚠️ E POR QUE A DECISÃO SAIU DO CSS E VEIO PRO JS: era um @media que
     decidia a aparência, e o JS que decidia o espaço reservado. Duas cabeças
     pro mesmo assunto — exatamente o que o §14 da v795 tirou da whitelist.
     Agora o JS decide as duas coisas e o CSS lê o resultado em `.dock-barra`.
     ========================================================================== */
  function dockBarraQuer(largo){
    try{
      var cl=document.body.classList;
      if(largo) return dockLargoQuer();
      /* 🔴 v1242 — NO CELULAR A BARRA SAIU DE CENA, e é decisão do Angelo
         (27/09, com print): "fica dentro de um único FAB na direita". As
         duas barras de celular — a branca da v754/v859 e a cápsula azul da
         v885 — continuam escritas e inteiras no styles.css, presas por um
         `:not(.fab-leque)`. Tirar o FAB_LEQUE do 02-icones traz as duas de
         volta sem mais nada.
         ⚠️ O `largo` sai ANTES desta linha de propósito: no computador nada
         muda, lá sobra espaço horizontal e a barra da v793 continua sendo o
         melhor desenho. */
      if(document.body.classList.contains('fab-leque')) return false;
      /* ==========================================================================
         🔴 v859 (pedido do Angelo, 03/09, com print): "barra fixa inferior em
         azul ... padronize nas consultas".
         --------------------------------------------------------------------------
         ⚠️ ISTO TROCA, DE PROPÓSITO, UMA DECISÃO DA v800. Está escrito logo
         abaixo, com todas as letras: "a barra do celular vale APENAS em
         `oper-on` — não estendi a whitelist inteira porque o projeto pede esta
         página". Era uma boa decisão PARA AQUELE projeto. O Angelo olhou a tela
         da AutoCorp no celular, viu os quatro círculos brancos flutuando e
         pediu a barra azul aqui também. É decisão dele, e é reversível: tire
         `consulta-ui-on` da linha abaixo e a v800 volta inteira.
         📌 As telas que a v800 deixou de fora POR MOTIVO PRÓPRIO continuam
         fora, e não é descuido: `veh-on` tem navegação de cinco itens, e
         `crm-fx-on`/`ch-fx-on` controlam a própria barra. Quem manda nisso é
         o DOCK_LARGO_FORA, logo ali — não mexi nele. */
      /* v885 — `hist-on` entra (§7 do projeto do histórico: a tela tem a
         cápsula de cinco botões). No computador ela já entrava pelo
         DOCK_LARGO_ENTRA desde a v766; faltava o celular. */
      if(!cl.contains('oper-on') && !cl.contains('consulta-ui-on')
         && !cl.contains('resultado-veiculo-on') && !cl.contains('hist-on')
         && !cl.contains('veh-on')) return false;   /* v884/v885 */
      if(DOCK_LARGO_FORA.some(function(c){ return cl.contains(c); })) return false;
      return true;
    }catch(_){ return false; }
  }

  function consultaUiDockMedir(){
    try{
      requestAnimationFrame(function(){
        try{
          var r=$('fabRow'); if(!r) return;
          var cl=document.body.classList; var comDock=cl.contains('consulta-ui-on')||cl.contains('conta-on')||cl.contains('loja-on')||cl.contains('veh-on')||cl.contains('hist-on')||cl.contains('oper-on')||cl.contains('resultado-veiculo-on');   /* v884: o resultado da placa reserva o espaço do dock igual às outras */   /* v755/v756/v757/v766: conta, loja, operação e histórico usam a mesma barra; v795: as cinco telas operacionais */
          /* 🔴 v793 (§5.5 do projeto do dock): o `innerWidth<900` mandava
             ZERO no computador porque lá a .fab-row eram quatro círculos
             soltos — não havia barra a descontar. Agora HÁ: no computador as
             páginas da whitelist ganharam o dock, e continuar devolvendo zero
             faria a barra cobrir o último campo da página.
             A conta é a mesma nos dois tamanhos: mede a altura REAL da
             .fab-row. Fora da whitelist (veh-on tem navegação própria de
             cinco itens) o computador segue em zero — lá os círculos
             continuam, e reservar espaço pra eles seria um vão sem motivo. */
          var largo=window.innerWidth>=900;
          var temDockLargo=dockLargoQuer();
          /* 🔴 v795 (§14 do projeto: "impedir divergência entre a whitelist do
             CSS e a do JavaScript"). Até a v794 a lista morava DUAS vezes —
             aqui e num seletor gigante no styles.css. Duas listas que precisam
             concordar sempre acabam discordando um dia, e o sintoma seria o
             pior possível: o dock aparece (CSS) mas o espaço não é reservado
             (JS), e a barra come o último card sem ninguém entender por quê.
             Agora a lista existe UMA vez, no dockLargoQuer() logo abaixo, e o
             CSS lê o resultado pela classe .dock-largo no body. */
          document.documentElement.classList.toggle('dock-largo-html', largo && temDockLargo);
          document.body.classList.toggle('dock-largo', largo && temDockLargo);
          /* v800 — quem manda na APARÊNCIA de barra (computador ou celular) */
          document.body.classList.toggle('dock-barra', dockBarraQuer(largo));
          var mede=comDock && (largo ? temDockLargo : true);
          var h=mede ? Math.round(r.getBoundingClientRect().height) : 0;
          document.documentElement.style.setProperty('--consulta-ui-dock', (h||0)+'px');
          try{ _fabPoe(); }catch(_){}
        }catch(_){}
      });
    }catch(_){}
  }
  /* 🔴 v800 — MEDIR DE NOVO QUANDO A TELA MUDA DE TAMANHO
     Isto conserta um buraco que já existia e ficaria PIOR agora. Antes, girar
     o aparelho ou arrastar a janela por cima dos 900px trocava a aparência na
     hora (era um @media) mas deixava o `--consulta-ui-dock` velho: a barra
     mudava de altura e o espaço reservado não. Com a decisão vindo do JS
     (acima), sem esta remedição a própria aparência ficaria velha.
     ⚠️ Com atraso de propósito: o resize dispara dezenas de vezes por
     arrasto, e medir a cada um é trabalho jogado fora.
     ⚠️ E o zoom do navegador e a fonte ampliada do sistema também disparam
     resize — que é justamente o caso que o §9 manda não deixar cobrir o
     último card. */
  var _dockRemed=null;
  function _dockRemedir(){
    clearTimeout(_dockRemed);
    _dockRemed=setTimeout(function(){ try{ consultaUiDockMedir(); }catch(_){} },160);
  }
  try{
    window.addEventListener('resize', _dockRemedir);
    window.addEventListener('orientationchange', _dockRemedir);
  }catch(_){}
  /* ==========================================================================
     🔴 v859 (pedido do Angelo, 03/09, com print): "as informações de consulta
     devem ficar acima do quadro 'o que a consulta inclui' e 'ver exemplo em
     PDF'; deve ficar oculto quando a placa for consultada, fica visível até
     fazer a consulta. Padronize nas consultas."
     --------------------------------------------------------------------------
     O QUE ELE VIU: consultou a placa e o resultado nasceu LÁ EMBAIXO, depois
     do quadro de vantagens e do card de exemplo. Pra ler a própria consulta
     ele tinha que rolar por cima de duas caixas que já tinham cumprido o
     papel delas — elas servem pra CONVENCER antes de consultar, e depois só
     atrapalham.

     COMO FOI FEITO — e por que assim: um observador só, aqui no padrão, em
     vez de mexer no HTML de cada página (03 CPF, 03d veículo, 04 CNPJ…).
     Foram quatro telas escritas em arquivos diferentes; editar as quatro à
     mão é quatro chances de errar e quatro lugares pra manter. Aqui é UM
     lugar, e toda consulta que usar o padrão 02c ganha o comportamento de
     graça — inclusive as que ainda não existem.

     A REGRA: enquanto a caixa de resultado (o [aria-live] do card) estiver
     VAZIA, está tudo como sempre foi. No instante em que ela ganha conteúdo,
     o card recebe a classe `cu-consultado` e o CSS esconde as duas caixas.
     Limpou o resultado (nova consulta, trocou a placa) → elas voltam
     sozinhas. Nada é apagado do DOM: é só esconder, e o próprio observador
     desfaz. Regra da casa.

     ⚠️ POR QUE UM OBSERVADOR E NÃO UMA CHAMADA EM CADA `mostrarResultado`:
     porque aí eu dependeria de CADA página lembrar de chamar. A caixa de
     resultado ficar cheia é o fato observável — quem escreve nela não
     precisa saber que isto existe. Uma tela nova esquece a chamada; ela não
     esquece de escrever o resultado.
     ⛳ PRA DESFAZER: apague a chamada `consultaUiVigiaResultado(...)` no
     consultaUiPagina. As caixas voltam a aparecer sempre.
     ========================================================================== */
  var _cuObs=null;
  /* ==========================================================================
     🔴 v859 — O QUE CONTA COMO "CONSULTADO" (e o defeito que os testes v751 e
     v752 pegaram antes de isto chegar no celular do Angelo)
     --------------------------------------------------------------------------
     A minha primeira versão dizia: "a caixa de resultado tem conteúdo → está
     consultado". Parecia certo e estava ERRADO, porque a MESMA caixa recebe
     mais três coisas que NÃO são resultado:

        · o relógio de carregando  (.cc-load)  — enquanto a consulta roda;
        · o recado de erro         (.plc-msg)  — "Digite uma placa válida",
                                                 "a base não respondeu";
        · os avisos do padrão      (.consulta-ui-msg).

     O estrago: a consulta dava ERRO e o "Ver exemplo (PDF)" sumia junto —
     exatamente na hora em que o lojista mais precisa dele, porque acabou de
     não conseguir consultar. Quem pegou isso foram os testes v751 e v752, que
     clicam no exemplo DEPOIS de um erro de propósito. Eles não estavam
     desatualizados: estavam certos, e eu é que estava errado.

     A regra que fica: consultado = a caixa tem pelo menos UM elemento que não
     é relógio, nem erro, nem aviso. Texto solto também não basta — resultado
     de verdade sempre vem em bloco.
     ⚠️ Se um dia nascer outro tipo de recado nessa caixa, acrescente a classe
     dele em _CU_NAO_E_RESULTADO. Esquecer disso reproduz o mesmo defeito. */
  var _CU_NAO_E_RESULTADO='.cc-load, .plc-msg, .consulta-ui-msg';
  function consultaUiMarcaConsultado(card){
    try{
      if(!card) return;
      var cx=card.querySelector('[aria-live]');
      var tem=false;
      if(cx) Array.prototype.forEach.call(cx.children, function(el){
        try{ if(!el.matches(_CU_NAO_E_RESULTADO)) tem=true; }catch(_){ tem=true; }
      });
      card.classList.toggle('cu-consultado', tem);
    }catch(_){}
  }
  function consultaUiVigiaResultado(root){
    try{
      if(_cuObs){ try{ _cuObs.disconnect(); }catch(_){} _cuObs=null; }
      var card=(root||document).querySelector('.consulta-ui-card'); if(!card) return;
      consultaUiMarcaConsultado(card);
      if(typeof MutationObserver!=='function') return;
      _cuObs=new MutationObserver(function(){ consultaUiMarcaConsultado(card); });
      _cuObs.observe(card, { childList:true, subtree:true, characterData:true });
    }catch(_){}
  }
  /* o CTA acompanha os dados: cada [data-cu-req] vazio = incompleto */
  function consultaUiSync(root){
    root=root||document;
    try{
      Array.prototype.forEach.call(root.querySelectorAll('.consulta-ui-cta[data-cu-reqs]'), function(bt){
        var ids=String(bt.getAttribute('data-cu-reqs')||'').split(/[,\s]+/).filter(Boolean);
        var falta=ids.some(function(id){ var el=$(id); if(!el) return true;
          /* v752: um checkbox na lista (o aceite LGPD do CPF) conta como "falta" enquanto não estiver marcado */
          if(el.type==='checkbox') return !el.checked;
          var v=String(el.value||'').trim(); var min=Number(el.getAttribute('data-cu-min')||1); return v.length<min; });
        if(bt.classList.contains('is-loading')) return;
        consultaUiEstadoCta(bt, falta?'incompleto':'pronto');
      });
    }catch(_){}
  }

  /* ==========================================================================
     A TELA PILOTO — BUSCAR POR VEÍCULO (FIPE por tipo, marca, ano, modelo)
     fmComboHtml / fmComboWire / carregarMarcas / carregarValor são do 11 e
     continuam iguais (mesmos IDs). Aqui só a composição: etapas 1–4 (+5
     Combustível só quando houver mais de uma opção), CTA "Buscar veículo"
     que só liga com a seleção completa, resultado e outras consultas.
     ========================================================================= */
  function consultaUiBuscaVeiculoHtml(){
    var _svgCar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';
    var _svgMoto='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="17" r="3"/><circle cx="18.5" cy="17" r="3"/><path d="M5.5 17l3-6h5l2 3h3M13 8h3"/></svg>';
    var _svgTruck='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="6" width="13" height="10" rx="1"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>';
    var tiles='<div class="fm-tiles consulta-ui-tipo" role="group" aria-label="Tipo de veículo">'+[['carros','Carros',_svgCar],['motos','Motos',_svgMoto],['caminhoes','Caminhões',_svgTruck]].map(function(t){ return '<button type="button" class="fm-tile" data-tipo="'+t[0]+'" aria-pressed="false">'+t[2]+'<span>'+t[1]+'</span></button>'; }).join('')+'</div>';
    var fechar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var voltar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
    var form='<div class="fm-guide-summary" id="fmGuideSummary">'
      +'<div><span class="fm-guide-kicker">CONSULTA GRATUITA</span><h3>Encontre o valor FIPE em poucos passos</h3><p id="fmGuideSummaryText">Escolha o tipo, a marca, o ano e a versão do veículo.</p></div>'
      +'<button type="button" class="fm-guide-open" id="fmGuideOpen" aria-haspopup="dialog">Escolher veículo</button></div>'
      +'<div class="fm-guide-overlay" id="fmGuideBg" hidden><button type="button" class="fm-guide-backdrop" id="fmGuideBackdrop" aria-label="Fechar seleção"></button>'
      +'<section class="fm-guide-sheet" role="dialog" aria-modal="true" aria-labelledby="fmGuideTitle" tabindex="-1">'
      +'<div class="fm-guide-head"><button type="button" class="fm-guide-back" id="fmGuideBack" aria-label="Voltar uma etapa" hidden>'+voltar+'</button><div><span id="fmGuideStage">Etapa 1 de 4</span><h2 id="fmGuideTitle">Buscar por veículo</h2></div><button type="button" class="fm-guide-close" id="fmGuideClose" aria-label="Fechar">'+fechar+'</button></div>'
      +'<div class="fm-guide-progress" id="fmGuideProgress" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>'
      +'<div class="fm-guide-body">'
      +'<div class="fm-guide-pane" data-fm-guide-step="1">'+consultaUiEtapa(1,'Tipo',tiles)+'</div>'
      +'<div class="fm-guide-pane" data-fm-guide-step="2" hidden>'+consultaUiEtapa(2,'Marca',fmComboHtml('fmMarca','Marca','Digite ou toque para escolher'))+'<button type="button" class="fm-guide-open fm-guide-next" id="fmMarcaContinuar" disabled>Continuar com esta marca</button></div>'
      +'<div class="fm-guide-pane" data-fm-guide-step="3" hidden>'+consultaUiEtapa(3,'Ano do modelo',fmComboHtml('fmAnoFiltro','Ano do modelo','Escolha o ano'))+'</div>'
      +'<div class="fm-guide-pane" data-fm-guide-step="4" hidden>'+consultaUiEtapa(4,'Modelo / versão',fmComboHtml('fmModelo','Modelo / versão','Digite ao menos 2 letras'))+'<p class="fm-guide-help">Digite parte do modelo para mostrar somente as versões disponíveis no ano escolhido.</p></div>'
      +'<div class="fm-guide-pane" data-fm-guide-step="5" hidden><div id="fmCombustivelWrap" style="display:none">'+consultaUiEtapa(5,'Combustível',fmComboHtml('fmAno','Combustível','Escolha o combustível'),{ nota:'quando houver mais de uma opção' })+'</div></div>'
      +'<div class="fm-guide-pane fm-guide-review" data-fm-guide-step="6" hidden><div class="fm-guide-review-head"><span>Seleção concluída</span><h3>Confira o veículo</h3></div><div id="fmGuideReview"></div>'+consultaUiCta({ id:'fmBuscarBt', verbo:'Consultar valor FIPE', rotulo:'Consultar valor FIPE', disabled:true })+'<p class="fm-guide-free">Consulta gratuita, sem uso do seu saldo.</p></div>'
      +'<div id="fmGuideMsg" class="cad-msg fm-guide-msg" aria-live="polite"></div></div></section></div>'
      +'<input type="hidden" id="fmTipo" value="">'
      +'<div class="consulta-ui-resposta"><div id="fmMsg" class="cad-msg" aria-live="polite"></div><div id="fmResult" aria-live="polite"></div></div>'
      +consultaUiBeneficios(['Valor de referência FIPE do mês, pela tabela oficial','Código FIPE, mês de referência e combustível','Sem cobrança: a busca por veículo é gratuita','Compartilhe o valor como imagem, direto do resultado'])
      +consultaUiTrust('Tabela FIPE oficial · nenhuma cobrança nesta busca');
    /* o CTA sabe quais campos precisa (o Combustível é opcional na régua: quando há uma opção só, o 11 já a escolhe sozinho) */
    form=form.replace('id="fmBuscarBt"','id="fmBuscarBt" data-cu-reqs="fmMarca,fmAnoFiltro,fmModelo,fmAno"');
    return consultaUiCard(form, { id:'fmWrap' })+consultaUiRelacionadas('fipe','veiculo',{ preferir:['placa','plus','gravame'] });
  }
  function consultaUiBuscaVeiculoLigar(root){
    root=root||document;
    /* A consulta continua usando a mesma FIPE e os mesmos campos do módulo 11.
       Esta camada só conduz a escolha numa folha compacta e acessível. */
    try{
      fmGuiaLigar(root);
      var bt=$('fmBuscarBt');
      if(bt) bt.onclick=function(){
        if(bt.disabled) return;
        var tipo=String((($('fmTipo')||{}).value)||'carros'), marca=String((($('fmMarca')||{}).value)||''), modelo=String((($('fmModelo')||{}).value)||''), ano=String((($('fmAno')||{}).value)||'');
        if(!(marca&&modelo&&ano)){ consultaUiSync(); return; }
        consultaUiEstadoCta(bt,'carregando','Buscando…');
        Promise.resolve().then(function(){ return carregarValor(tipo,marca,modelo,ano); }).then(function(ok){ consultaUiEstadoCta(bt,ok?'pronto':'erro'); if(ok) fmGuiaFechar(true); try{ var r=$('fmResult'); if(ok&&r&&r.firstChild) r.scrollIntoView({ behavior:'smooth', block:'nearest' }); }catch(_){} }, function(){ consultaUiEstadoCta(bt,'erro'); });
      };
    }catch(_){}
  }

  var _fmGuia={ etapa:1, foco:null, teclado:null };
  function fmGuiaRotulo(id){ var i=$(id+'Input'); return String((i&&i.value)||'').trim(); }
  function fmGuiaResumo(){
    var nomes=[fmGuiaRotulo('fmMarca'),fipeAnoRotulo(fmGuiaRotulo('fmAnoFiltro')),fmGuiaRotulo('fmModelo'),fmGuiaRotulo('fmAno')].filter(Boolean);
    var tx=$('fmGuideSummaryText'); if(tx) tx.textContent=nomes.length?nomes.join(' · '):'Escolha o tipo, a marca, o ano e a versão do veículo.';
    var box=$('fmGuideReview'); if(!box) return;
    var tipo=String((($('fmTipo')||{}).value)||''), tipoNome={carros:'Carro',motos:'Moto',caminhoes:'Caminhão'}[tipo]||'Veículo';
    var linhas=[['Tipo',tipoNome,1],['Marca',fmGuiaRotulo('fmMarca'),2],['Ano do modelo',fipeAnoRotulo(fmGuiaRotulo('fmAnoFiltro')),3],['Modelo / versão',fmGuiaRotulo('fmModelo'),4]];
    if(((_fmCombo.fmAno)||[]).length>1) linhas.push(['Combustível',fmGuiaRotulo('fmAno'),5]);
    box.innerHTML=linhas.map(function(x){ return '<button type="button" class="fm-guide-review-row" data-fm-edit="'+x[2]+'"><span>'+esc(x[0])+'</span><b>'+esc(x[1]||'Escolher')+'</b><i>Editar</i></button>'; }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('[data-fm-edit]'),function(b){ b.onclick=function(){ fmGuiaEtapa(Number(b.getAttribute('data-fm-edit'))||1); }; });
  }
  function fmGuiaEtapa(n){
    n=Math.max(1,Math.min(6,Number(n)||1)); _fmGuia.etapa=n;
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-guide-step]'),function(p){ p.hidden=Number(p.getAttribute('data-fm-guide-step'))!==n; });
    var temComb=((_fmCombo.fmAno)||[]).length>1, total=temComb?5:4, atual=n===6?total:Math.min(n,total);
    var st=$('fmGuideStage'); if(st) st.textContent=n===6?'Revisar seleção':('Etapa '+atual+' de '+total);
    var pr=$('fmGuideProgress'); if(pr) Array.prototype.forEach.call(pr.children,function(i,idx){ i.classList.toggle('on',idx<atual); i.hidden=!temComb&&idx===4; });
    var back=$('fmGuideBack'); if(back) back.hidden=n===1;
    if(n===6) fmGuiaResumo();
    setTimeout(function(){ try{ var p=document.querySelector('[data-fm-guide-step="'+n+'"]'); var f=p&&p.querySelector('input:not([type="hidden"]):not([disabled]),button:not([disabled])'); if(f) f.focus(); }catch(_){} },40);
  }
  function fmGuiaAbrir(n){
    var bg=$('fmGuideBg'); if(!bg) return; _fmGuia.foco=document.activeElement; bg.hidden=false; document.body.classList.add('fm-guide-on'); fmGuiaEtapa(n||_fmGuia.etapa||1); requestAnimationFrame(function(){ bg.classList.add('on'); });
  }
  function fmGuiaFechar(devolver){
    var bg=$('fmGuideBg'); if(!bg||bg.hidden) return; bg.classList.remove('on'); document.body.classList.remove('fm-guide-on'); fmGuiaResumo();
    setTimeout(function(){ if(bg&&!bg.classList.contains('on')) bg.hidden=true; },180);
    if(devolver!==false) setTimeout(function(){ try{ var f=_fmGuia.foco; if(f&&f.isConnected) f.focus(); }catch(_){} },190);
  }
  function fmGuiaDepoisTipo(){ fmGuiaEtapa(2); }
  function fmGuiaMarcaPadraoSelecionada(){
    var bt=$('fmMarcaContinuar'), cod=String((($('fmMarca')||{}).value)||''), nome=fmGuiaRotulo('fmMarca');
    if(!bt) return; bt.disabled=!(cod&&nome); bt.textContent=nome?('Continuar com '+nome):'Continuar com esta marca';
  }
  function fmGuiaDepoisEscolha(id){ if(id==='fmMarca') fmGuiaEtapa(3); else if(id==='fmAnoFiltro') fmGuiaEtapa(4); else if(id==='fmAno') fmGuiaEtapa(6); }
  function fmGuiaCombustiveis(opcoes){ if(!document.getElementById('fmGuideBg')) return; fmGuiaEtapa((opcoes||[]).length>1?5:6); }
  function fmGuiaLigar(root){
    var bg=$('fmGuideBg'), abre=$('fmGuideOpen'), fecha=$('fmGuideClose'), fundo=$('fmGuideBackdrop'), volta=$('fmGuideBack'), marcaContinuar=$('fmMarcaContinuar'); if(!bg) return;
    try{ if(_fmGuia.teclado) document.removeEventListener('keydown',_fmGuia.teclado,true); }catch(_){}
    if(abre) abre.onclick=function(){ fmGuiaAbrir(_fmGuia.etapa||1); }; if(fecha) fecha.onclick=function(){ fmGuiaFechar(true); }; if(fundo) fundo.onclick=function(){ fmGuiaFechar(true); };
    if(marcaContinuar) marcaContinuar.onclick=function(){ if(!marcaContinuar.disabled) fmGuiaEtapa(3); };
    if(volta) volta.onclick=function(){ var n=_fmGuia.etapa; if(n===6) n=((_fmCombo.fmAno)||[]).length>1?5:4; else n=Math.max(1,n-1); fmGuiaEtapa(n); };
    _fmGuia.teclado=function(e){ if(bg.hidden) return; if(e.key==='Escape'){ e.preventDefault(); fmGuiaFechar(true); return; } if(e.key!=='Tab') return; var d=bg.querySelector('.fm-guide-sheet'), fs=d.querySelectorAll('button:not([disabled]):not([hidden]),input:not([disabled]):not([type="hidden"])'); var vis=Array.prototype.filter.call(fs,function(x){ return x.offsetParent!==null; }); if(!vis.length) return; var a=vis[0],z=vis[vis.length-1]; if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();} };
    document.addEventListener('keydown',_fmGuia.teclado,true);
    fmGuiaAbrir(1);
  }

/* ╔═══ src/app/02d-operacao-veiculos.js ══════════════════════════════════ */
  /* ==========================================================================
     02d — OPERAÇÃO DE VEÍCULOS: os componentes compartilhados (v757, FASE 1)
     ==========================================================================
     docs/PROJETO-2026-08-29-redesign-operacao-veiculos.txt
     Uma linguagem só pra TODAS as listas de veículos (Mercado, Repasse,
     Estoque, Vendas, Vitrine): cabeçalho curto, busca + filtros compactos,
     card compacto com UMA ação principal e "Mais ações", estados, action
     sheet e a barra inferior. Este módulo só COMPÕE HTML e estados — nada de
     Supabase, permissão ou regra de negócio: isso continua em 20, 09, 14,
     17 e 14h, que na FASE 2+ passam a usar estas peças.

     🔴 O adaptador público (vehPublico) recebe SÓ o que o catálogo mostra:
     preço mínimo, custo, margem, observação interna NUNCA passam por aqui.
     ========================================================================= */
  var _VEH_SVG={
    lupa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>',
    filtro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h18"/><path d="M6 12h12"/><path d="M10 19h4"/></svg>',
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6 6 18"/></svg>',
    mais:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>',
    carro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>',
    voltar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>',
    alerta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>',
    ok:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
  };
  function _vehNum(v){ var n=Number(String(v==null?'':v).replace(/[^\d.,-]/g,'').replace(/\.(?=\d{3}\b)/g,'').replace(',','.')); return isNaN(n)?null:n; }
  function _vehKm(v){ var n=_vehNum(v); if(n==null) return ''; try{ return n.toLocaleString('pt-BR')+' km'; }catch(_){ return n+' km'; } }

  /* 2.1 — cabeçalho de página: ícone em quadrado azul-claro, título, descrição,
     Voltar no cabeçalho (não no dock), ação principal opcional à direita */
  function vehHeaderHtml(cfg){
    cfg=cfg||{};
    return '<div class="veh-header">'
      +(cfg.voltar?('<button type="button" class="veh-back" data-veh-back aria-label="Voltar">'+_VEH_SVG.voltar+'</button>'):'')
      +'<span class="veh-header-ico" aria-hidden="true">'+(cfg.ico||_VEH_SVG.carro)+'</span>'
      +'<div class="veh-header-tx"><h2 class="veh-header-t">'+esc(cfg.titulo||'')+'</h2>'+(cfg.desc?('<p class="veh-header-d">'+esc(cfg.desc)+'</p>'):'')+'</div>'
      +(cfg.acao?('<button type="button" class="veh-header-acao"'+(cfg.acao.id?(' id="'+esc(cfg.acao.id)+'"'):'')+'>'+esc(cfg.acao.rotulo||'')+'</button>'):'')
      +'</div>';
  }
  /* 2.2 — busca + filtros: lupa dentro do campo (≥48px), "Filtros" com contador,
     ordenação separada, "Limpar filtros" só com filtro ativo, chips removíveis */
  function vehToolbarHtml(cfg){
    cfg=cfg||{}; var ativos=Number(cfg.filtrosAtivos||0);
    var chips=(cfg.chips||[]).map(function(c){ return vehChipHtml(c); }).join('');
    return '<div class="veh-toolbar"'+(cfg.id?(' id="'+esc(cfg.id)+'"'):'')+'>'
      +'<div class="veh-toolbar-row">'
        +'<label class="veh-search"><span class="veh-search-ico">'+_VEH_SVG.lupa+'</span>'
          +'<input type="search" class="veh-search-in"'+(cfg.buscaId?(' id="'+esc(cfg.buscaId)+'"'):'')+' placeholder="'+esc(cfg.placeholder||'Buscar por nome, placa ou modelo')+'" aria-label="'+esc(cfg.buscaLabel||cfg.placeholder||'Buscar')+'" autocomplete="off" value="'+esc(cfg.valor||'')+'"></label>'
        +'<button type="button" class="veh-filter-bt"'+(cfg.filtrosId?(' id="'+esc(cfg.filtrosId)+'"'):'')+' aria-haspopup="dialog"'+(ativos?' data-ativos="'+ativos+'"':'')+'>'+_VEH_SVG.filtro+'<span>Filtros</span>'+(ativos?('<b class="veh-filter-n" aria-label="'+ativos+' filtros ativos">'+ativos+'</b>'):'')+'</button>'
        +(cfg.ordem?('<label class="veh-order"><span class="sr-only">Ordenar por</span><select class="veh-order-sel"'+(cfg.ordemId?(' id="'+esc(cfg.ordemId)+'"'):'')+' aria-label="Ordenar por">'+cfg.ordem.map(function(o){ return '<option value="'+esc(o[0])+'"'+(o[0]===cfg.ordemAtual?' selected':'')+'>'+esc(o[1])+'</option>'; }).join('')+'</select></label>'):'')
      +'</div>'
      +((chips||ativos)?('<div class="veh-filter-row" role="list">'+chips+(ativos?('<button type="button" class="veh-filter-clear" data-veh-limpar>Limpar filtros</button>'):'')+'</div>'):'')
      +'<div class="veh-count sr-only" aria-live="polite"'+(cfg.contagemId?(' id="'+esc(cfg.contagemId)+'"'):'')+'></div>'
    +'</div>';
  }
  function vehChipHtml(c){
    c=c||{}; var rem=c.removivel!==false;
    return '<span class="veh-filter-chip'+(c.on?' is-on':'')+'" role="listitem"'+(c.chave?(' data-chip="'+esc(c.chave)+'"'):'')+'><span>'+esc(c.rotulo||'')+'</span>'
      +(rem?('<button type="button" class="veh-chip-x" aria-label="Remover filtro '+esc(c.rotulo||'')+'"'+(c.chave?(' data-veh-remover="'+esc(c.chave)+'"'):'')+'>'+_VEH_SVG.x+'</button>'):'')+'</span>';
  }
  /* a contagem de resultados numa região aria-live discreta */
  function vehContagemSet(id, n, texto){ var el=$(id); if(!el) return; el.textContent=texto||(n===1?'1 veículo encontrado':(n+' veículos encontrados')); }

  /* 2.4 — foto do veículo: moldura 4:3 sempre; horizontal usa cover; vertical/
     quadrada inteira em primeiro plano com cópia desfocada no fundo (alt vazio);
     sem foto → placeholder de linha. Lazy fora da primeira tela. */
  function vehMediaHtml(v, opcoes){
    v=v||{}; opcoes=opcoes||{};
    var src=v.foto||v.foto_url||v.capa||(Array.isArray(v.fotos)&&v.fotos[0])||'';
    if(src && typeof imgCdn==='function' && !/^data:/.test(src)){ try{ src=imgCdn(src, opcoes.largura||320); }catch(_){} }
    var alt=opcoes.alt!=null?opcoes.alt:[v.marca,v.modelo,v.ano||v.ano_modelo].filter(Boolean).join(' ');
    var lazy=opcoes.eager?'':' loading="lazy" decoding="async"';
    if(!src) return '<div class="veh-media veh-media--vazia" aria-label="Sem foto"><span aria-hidden="true">'+_VEH_SVG.carro+'</span><small>Sem foto</small></div>';
    return '<div class="veh-media" data-veh-media><img class="veh-media-bg" src="'+esc(src)+'" alt="" aria-hidden="true"'+lazy+'><img class="veh-media-img" src="'+esc(src)+'" alt="'+esc(alt)+'"'+lazy+'></div>';
  }
  /* decide cover × inteira pela proporção real da foto (chamar depois de pintar a lista) */
  function vehMediaLigar(root){
    root=root||document;
    try{
      Array.prototype.forEach.call(root.querySelectorAll('[data-veh-media]'), function(box){
        if(box.getAttribute('data-veh-ok')) return;
        var img=box.querySelector('.veh-media-img'); if(!img) return;
        var decide=function(){ try{ var w=img.naturalWidth, h=img.naturalHeight; if(!w||!h) return; box.classList.toggle('is-vertical', (w/h)<1.2); box.setAttribute('data-veh-ok','1'); }catch(_){} };
        if(img.complete) decide(); else { img.addEventListener('load',decide,{once:true}); }
        img.addEventListener('error',function(){ box.classList.add('veh-media--vazia'); box.innerHTML='<span aria-hidden="true">'+_VEH_SVG.carro+'</span><small>Sem foto</small>'; },{once:true});
      });
    }catch(_){}
  }
  /* 2.3 — chips essenciais do card: ano · km · câmbio ou cor (só os que existem) */
  function vehMetaHtml(v, campos){
    v=v||{}; campos=campos||['ano','km','cambio','cor'];
    var itens=[];
    campos.forEach(function(c){
      if(c==='ano'){ var a=[v.ano_fabricacao||v.ano, v.ano_modelo].filter(Boolean); var s=a.length===2&&String(a[0])!==String(a[1])?(a[0]+'/'+a[1]):String(a[0]||''); if(s) itens.push(s); }
      else if(c==='km'){ var k=_vehKm(v.km); if(k) itens.push(k); }
      else if(c==='cambio'){ if(v.cambio) itens.push(String(v.cambio)); }
      else if(c==='cor'){ if(v.cor) itens.push(String(v.cor)); }
      else if(c==='combustivel'){ if(v.combustivel) itens.push(String(v.combustivel)); }
      else if(v[c]) itens.push(String(v[c]));
    });
    if(!itens.length) return '';
    return '<ul class="veh-meta" aria-label="Detalhes">'+itens.slice(0,3).map(function(t){ return '<li>'+esc(t)+'</li>'; }).join('')+'</ul>';
  }
  /* status: nunca só pela cor — texto sempre; cores por tom */
  var VEH_STATUS={ disponivel:['Disponível','ok'], reservado:['Reservado','alerta'], vendido:['Vendido','neutro'], negociacao:['Em negociação','alerta'], oculto:['Oculto do catálogo','neutro'], rascunho:['Rascunho','neutro'], publicado:['Publicado','ok'], pendente:['Pendente','alerta'], erro:['Com erro','erro'] };
  function vehStatusHtml(v, contexto){
    v=v||{}; var k=String(v.status||'').toLowerCase().replace(/\s+/g,'_'); var s=VEH_STATUS[k]||(v.status?[String(v.status),'neutro']:null);
    if(!s) return '';
    return '<span class="veh-status is-'+s[1]+'">'+esc(s[0])+'</span>';
  }
  function vehPrecoHtml(v){
    v=v||{}; var p=v.preco!=null&&v.preco!==''?v.preco:(v.valor!=null?v.valor:null);
    if(p==null||p==='') return '<span class="veh-price veh-price--sem">Preço a combinar</span>';
    return '<span class="veh-price">'+esc(brl(p))+'</span>';
  }
  /* 2.3 — o card interno compacto: foto 112×84 (96×72 abaixo de 360), conteúdo à
     direita, nome em 2 linhas, placa/status, chips, preço, UMA ação principal
     escrita e "Mais ações" (44×44). Sem botão aninhado: o card é um <article>
     e o clique no corpo é um botão próprio (data-veh-abrir). */
  function vehCardHtml(v, cfg){
    v=v||{}; cfg=cfg||{};
    var nome=cfg.nome||[v.marca,v.modelo,v.versao].filter(Boolean).join(' ')||'Veículo';
    var placa=cfg.placa!==false?(v.placa||''):'';
    var variante=cfg.variante?(' veh-card--'+esc(cfg.variante)):'';
    var id=v.id!=null?String(v.id):'';
    return '<article class="veh-card'+variante+'"'+(id?(' data-veh-id="'+esc(id)+'"'):'')+'>'
      +vehMediaHtml(v, cfg.media)
      +'<div class="veh-main">'
        +'<button type="button" class="veh-abrir" data-veh-abrir'+(id?(' data-veh-id="'+esc(id)+'"'):'')+'>'
          +'<span class="veh-title">'+esc(nome)+'</span>'
          +'<span class="veh-sub">'+(placa?('<span class="veh-placa">'+esc(placa)+'</span>'):'')+(cfg.status!==false?vehStatusHtml(v, cfg.contexto):'')+'</span>'
          +vehMetaHtml(v, cfg.campos)
        +'</button>'
        +'<div class="veh-foot">'+vehPrecoHtml(v)
          +'<div class="veh-acoes">'
            +(cfg.primaria?('<button type="button" class="veh-primary'+(cfg.primaria.verde?' is-verde':'')+'" data-veh-acao="'+esc(cfg.primaria.acao||'')+'"'+(id?(' data-veh-id="'+esc(id)+'"'):'')+'>'+esc(cfg.primaria.rotulo||'')+'</button>'):'')
            +(cfg.mais!==false?('<button type="button" class="veh-more" data-veh-mais'+(id?(' data-veh-id="'+esc(id)+'"'):'')+' aria-label="Mais ações de '+esc(nome)+'" aria-haspopup="dialog">'+_VEH_SVG.mais+'</button>'):'')
          +'</div>'
        +'</div>'
      +'</div>'
    +'</article>';
  }
  /* 2.5 — o adaptador PÚBLICO: só campos do catálogo, nunca o objeto interno inteiro */
  function vehPublico(row){
    row=row||{};
    return { id:row.id, marca:row.marca, modelo:row.modelo, versao:row.versao, ano:row.ano, ano_modelo:row.ano_modelo, km:row.km, cor:row.cor, cambio:row.cambio, combustivel:row.combustivel,
      preco:(row.preco_publico!=null?row.preco_publico:row.preco), status:(row.status_publico||(row.status==='vendido'?'vendido':(row.status==='reservado'?'reservado':'disponivel'))), foto:row.foto||row.capa||(Array.isArray(row.fotos)&&row.fotos[0])||'', placa:'' };
  }
  function vehCardPublicoHtml(row, cfg){
    cfg=cfg||{}; var v=vehPublico(row);
    var html=vehCardHtml(v, { variante:'public', placa:false, campos:['ano','km','cor'], primaria:{ rotulo:cfg.rotuloPrimaria||'Tenho interesse', acao:'interesse', verde:true }, mais:false, media:cfg.media });
    /* "Ver ficha completa" como ação secundária + compartilhar discreto */
    return html.replace('<div class="veh-acoes">', '<div class="veh-acoes"><button type="button" class="veh-secondary" data-veh-acao="ficha"'+(v.id!=null?(' data-veh-id="'+esc(String(v.id))+'"'):'')+'>Ver ficha completa</button>'
      +(cfg.compartilhar!==false?('<button type="button" class="veh-share" data-veh-acao="compartilhar"'+(v.id!=null?(' data-veh-id="'+esc(String(v.id))+'"'):'')+' aria-label="Compartilhar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg></button>'):''));
  }
  /* 12 — estados obrigatórios das listas */
  function vehEstadoHtml(tipo, cfg){
    cfg=cfg||{};
    if(tipo==='carregando'){ var n=cfg.n||3, sk=''; for(var i=0;i<n;i++) sk+='<div class="veh-card veh-card--sk" aria-hidden="true"><div class="veh-media veh-sk"></div><div class="veh-main"><div class="veh-sk veh-sk-l"></div><div class="veh-sk veh-sk-m"></div><div class="veh-sk veh-sk-s"></div></div></div>'; return '<div class="veh-list veh-list--sk" role="status" aria-label="Carregando veículos">'+sk+'</div>'; }
    var ico=tipo==='erro'||tipo==='offline'||tipo==='permissao'||tipo==='limite'?_VEH_SVG.alerta:_VEH_SVG.carro;
    var tit={ vazio:'Nenhum veículo por aqui ainda', filtros:'Nenhum veículo encontrado com estes filtros.', erro:'Não consegui carregar agora', offline:'Sem internet', permissao:'Você não tem permissão para ver isto', limite:'Limite do plano atingido', parcial:'Alguns dados não vieram' }[tipo]||'';
    var desc={ vazio:'Adicione o primeiro veículo para começar.', filtros:'Ajuste ou limpe os filtros para ver mais.', erro:'Verifique a conexão e tente de novo.', offline:'Assim que a conexão voltar, a lista carrega sozinha.', permissao:'Peça acesso ao dono da loja.', limite:'Veja os pacotes para continuar adicionando.', parcial:'' }[tipo]||'';
    var acoes=(cfg.acoes||[]).map(function(a){ return '<button type="button" class="veh-empty-bt'+(a.sec?' is-sec':'')+'" data-veh-acao="'+esc(a.acao||'')+'">'+esc(a.rotulo||'')+'</button>'; }).join('');
    if(tipo==='erro' && !acoes) acoes='<button type="button" class="veh-empty-bt" data-veh-acao="tentar">Tentar novamente</button>';
    if(tipo==='filtros' && !acoes) acoes='<button type="button" class="veh-empty-bt" data-veh-acao="limpar">Limpar filtros</button>';
    return '<div class="veh-empty is-'+esc(tipo)+'" role="status"><span class="veh-empty-ico" aria-hidden="true">'+ico+'</span><b>'+esc(cfg.titulo||tit)+'</b>'+((cfg.desc||desc)?('<p>'+esc(cfg.desc||desc)+'</p>'):'')+(acoes?('<div class="veh-empty-acoes">'+acoes+'</div>'):'')+'</div>';
  }

  /* 2.6 — MENU DE AÇÕES: bottom sheet no celular, popover no computador.
     Grupos: Venda · Divulgação · Estoque · Perigo (excluir separado, vermelho,
     com confirmação). Fecha por botão, Escape, toque fora e gesto pra baixo;
     prende o foco; devolve o foco ao botão que abriu.
     cfg = { titulo, grupos:[{ nome, itens:[{ rotulo, acao, ico, perigo, confirmar, desabilitado }] }], ancora, ao(acao) } */
  var _vehSheet=null;
  function openVehicleActionSheet(cfg){
    cfg=cfg||{}; closeVehicleActionSheet(false);
    var ancora=cfg.ancora||document.activeElement;
    var desk=window.innerWidth>=900;
    var wrap=document.createElement('div'); wrap.className='veh-sheet-wrap'+(desk?' is-pop':'');
    var grupos=(cfg.grupos||[]).filter(function(g){ return g&&g.itens&&g.itens.length; });
    var html='<div class="veh-sheet-bg" data-veh-fechar></div>'
      +'<div class="veh-sheet" role="dialog" aria-modal="true" aria-labelledby="vehSheetT" tabindex="-1">'
        +'<div class="veh-sheet-h"><span class="veh-sheet-grip" aria-hidden="true"></span><h3 id="vehSheetT" class="veh-sheet-t">'+esc(cfg.titulo||'Ações')+'</h3><button type="button" class="veh-sheet-x" data-veh-fechar aria-label="Fechar">'+_VEH_SVG.x+'</button></div>'
        +grupos.map(function(g){ return '<div class="veh-sheet-g'+(g.perigo?' is-perigo':'')+'"><div class="veh-sheet-gt">'+esc(g.nome||'')+'</div>'+g.itens.map(function(it){ return '<button type="button" class="veh-sheet-it'+(it.perigo||g.perigo?' is-perigo':'')+'" data-veh-sheet-acao="'+esc(it.acao||'')+'"'+(it.confirmar?' data-veh-confirmar="'+esc(typeof it.confirmar==='string'?it.confirmar:'Tem certeza?')+'"':'')+(it.desabilitado?' disabled':'')+'>'+(it.ico?('<span class="veh-sheet-ico" aria-hidden="true">'+it.ico+'</span>'):'')+'<span>'+esc(it.rotulo||'')+'</span></button>'; }).join('')+'</div>'; }).join('')
      +'</div>';
    wrap.innerHTML=html; document.body.appendChild(wrap);
    var sheet=wrap.querySelector('.veh-sheet');
    /* popover: abaixo da âncora; se não couber, acima; se nem assim, preso dentro da tela (nunca ultrapassa a viewport) */
    if(desk && ancora && ancora.getBoundingClientRect){ try{ var r=ancora.getBoundingClientRect(); var h=sheet.offsetHeight, W=window.innerWidth, H=window.innerHeight; var top=r.bottom+6; if(top+h>H-8){ top=(r.top-h-6>=8)?(r.top-h-6):Math.max(8, H-h-8); } sheet.style.top=top+'px'; sheet.style.left=Math.max(8, Math.min(W-sheet.offsetWidth-8, r.right-sheet.offsetWidth))+'px'; }catch(_){} }
    var foco=function(e){ var f=sheet.querySelectorAll('button:not([disabled])'); if(!f.length) return; var a=f[0], z=f[f.length-1]; if(e.shiftKey && document.activeElement===a){ e.preventDefault(); z.focus(); } else if(!e.shiftKey && document.activeElement===z){ e.preventDefault(); a.focus(); } };
    var teclado=function(e){ if(e.key==='Escape'){ e.preventDefault(); e.stopPropagation(); closeVehicleActionSheet(true); } else if(e.key==='Tab') foco(e); };
    document.addEventListener('keydown', teclado, true);
    wrap.addEventListener('click', function(e){
      var f=e.target.closest('[data-veh-fechar]'); if(f){ closeVehicleActionSheet(true); return; }
      var b=e.target.closest('[data-veh-sheet-acao]'); if(!b) return;
      var acao=b.getAttribute('data-veh-sheet-acao'); var conf=b.getAttribute('data-veh-confirmar');
      if(conf){ if(!_vehConfirmar(sheet, b, conf)) return; }
      closeVehicleActionSheet(true);
      try{ if(typeof cfg.ao==='function') cfg.ao(acao); }catch(_){}
    });
    /* gesto pra baixo fecha (celular) */
    var y0=null; sheet.addEventListener('touchstart',function(e){ y0=e.touches[0].clientY; sheet.style.transition='none'; },{passive:true});
    sheet.addEventListener('touchmove',function(e){ if(y0==null) return; var d=e.touches[0].clientY-y0; if(d>0) sheet.style.transform='translateY('+d+'px)'; },{passive:true});
    sheet.addEventListener('touchend',function(e){ var d=(e.changedTouches[0].clientY-(y0==null?e.changedTouches[0].clientY:y0)); sheet.style.transition=''; if(d>80) closeVehicleActionSheet(true); else sheet.style.transform=''; y0=null; },{passive:true});
    _vehSheet={ wrap:wrap, ancora:ancora, teclado:teclado };
    requestAnimationFrame(function(){ wrap.classList.add('is-on'); try{ (sheet.querySelector('.veh-sheet-it:not([disabled])')||sheet).focus(); }catch(_){} });
    return wrap;
  }
  /* confirmação INLINE do item perigoso: o primeiro toque vira "Confirmar: …"; o segundo executa */
  function _vehConfirmar(sheet, b, texto){
    if(b.getAttribute('data-veh-confirmado')==='1') return true;
    b.setAttribute('data-veh-confirmado','1'); b.classList.add('is-confirmando');
    var sp=b.querySelector('span:last-child'); if(sp){ sp.setAttribute('data-rotulo', sp.textContent); sp.textContent=texto; }
    setTimeout(function(){ if(b.isConnected && b.getAttribute('data-veh-confirmado')==='1'){ b.removeAttribute('data-veh-confirmado'); b.classList.remove('is-confirmando'); if(sp) sp.textContent=sp.getAttribute('data-rotulo')||sp.textContent; } },4000);
    return false;
  }
  function closeVehicleActionSheet(devolverFoco){
    var s=_vehSheet; if(!s) return; _vehSheet=null;
    try{ document.removeEventListener('keydown', s.teclado, true); }catch(_){}
    try{ s.wrap.classList.remove('is-on'); setTimeout(function(){ try{ s.wrap.remove(); }catch(_){} }, 200); }catch(_){ try{ s.wrap.remove(); }catch(_2){} }
    if(devolverFoco!==false){ try{ if(s.ancora && s.ancora.focus && s.ancora.isConnected) s.ancora.focus(); }catch(_){} }
  }
  /* liga os cliques genéricos de uma lista: abrir, ação principal, "Mais ações", chips, limpar */
  function vehListaLigar(root, ao){
    root=root||document; ao=ao||{};
    try{
      root.addEventListener('click', function(e){
        var b;
        if((b=e.target.closest('[data-veh-abrir]'))) { if(ao.abrir) ao.abrir(b.getAttribute('data-veh-id'), b); return; }
        if((b=e.target.closest('[data-veh-mais]'))) { if(ao.mais) ao.mais(b.getAttribute('data-veh-id'), b); return; }
        if((b=e.target.closest('[data-veh-acao]'))) { if(ao.acao) ao.acao(b.getAttribute('data-veh-acao'), b.getAttribute('data-veh-id'), b); return; }
        if((b=e.target.closest('[data-veh-remover]'))) { if(ao.remover) ao.remover(b.getAttribute('data-veh-remover'), b); return; }
        if((b=e.target.closest('[data-veh-limpar]'))) { if(ao.limpar) ao.limpar(b); return; }
        if((b=e.target.closest('[data-veh-back]'))) { if(ao.voltar) ao.voltar(b); else { try{ var bf=$('btnBackFab'); if(bf) bf.click(); }catch(_){} } return; }
      });
      vehMediaLigar(root);
    }catch(_){}
  }
  /* 9 — a barra inferior das telas operacionais: Início · Estoque · Vendas ·
     Conversas · Menu (a MESMA .fab-row; Voltar fica no cabeçalho). Só liga
     onde a FASE 2+ chamar vehNavLigar(true); nada muda nas telas de hoje. */
  function vehNavLigar(on, ativo){
    try{
      document.body.classList.toggle('veh-on', !!on);
      Array.prototype.forEach.call(document.querySelectorAll('#fabRow [data-veh-nav]'), function(b){ b.classList.toggle('is-ativo', !!on && b.getAttribute('data-veh-nav')===ativo); b.setAttribute('aria-current', (!!on && b.getAttribute('data-veh-nav')===ativo)?'page':'false'); });
      if(typeof consultaUiDockMedir==='function') consultaUiDockMedir();
    }catch(_){}
  }
  try{ window.openVehicleActionSheet=openVehicleActionSheet; window.closeVehicleActionSheet=closeVehicleActionSheet; }catch(_){}

/* ╔═══ src/app/03-ficha-tecnica.js ═══════════════════════════════════════ */
  /* ===== FICHA TÉCNICA VEICULAR (API Brasil paga · 3 tokens) ===== */
  var fichaTecState=null;
  /* v488: eram 6 frases (10,8s de ciclo) numa espera de até 150s — a
     mesma sequência 14 vezes. Agora são 11, e todas cabem em UMA linha
     (a antiga "Procurando a ficha de fábrica do modelo…" quebrava em
     duas e fazia o anel pular). */
  var _ftFrasesIA=['🔎 Procurando a ficha de fábrica…','📚 Lendo as especificações do ano…','⚙️ Motor, câmbio e desempenho…','⛽ Consumo na cidade e na estrada…','📐 Medidas, peso e tanque…','🛞 Rodas, pneus e suspensão…','🛡️ Itens de segurança…','🎛️ Conforto e tecnologia…','🛠️ Itens de série e opcionais…','🔍 Conferindo o que é do seu ano…','✅ Organizando tudo…'];
  var _mktFrasesIA=['📊 Pesquisando o mercado deste modelo…','🏷️ Comparando anúncios nos portais…','🔧 Levantando pontos de vistoria…','⚔️ Olhando os concorrentes diretos…','💡 Separando os argumentos de venda…','✅ Montando o veredicto…'];
  /* v488: a "Equipamentos de série e opcionais…" quebrava em duas
     linhas (37,8px contra 20px) e fazia o anel saltar. Encurtada. */
  var _ftFrases=['🔧 Buscando a ficha oficial…','⚙️ Lendo motor, câmbio e direção…','📊 Potência, torque e desempenho…','⛽ Consumo e autonomia…','📐 Medidas e capacidades…','🛞 Rodas, pneus e freios…','🛡️ Itens de segurança…','🛠️ Equipamentos de série…','✅ Quase lá…'];
  function abrirFicha(){
    var v=veiculoAtual; if(!v) return abrirMenu();
    irTela(panelHead(ICO.motor,'blue','Ficha Técnica — '+esc(v.placa), subInfoModelo(v))+'<div id="fichaWrap"></div>','menu');
    document.body.classList.remove('md-veiculo');   /* tela cheia: esconde a coluna da esquerda (home) */
    fichaWrapPinta();
  }
  /* v240: pinta o MIOLO da ficha técnica dentro de #fichaWrap — usado pela
     tela da consulta E pela aba "Ficha técnica" da avaliação. Como o app só
     tem uma tela por vez, o id é único e as funções de gerar (oficial e por
     IA) funcionam igual nos dois lugares: é a MESMA ficha, mesmo cache. */
  function fichaWrapPinta(){
    var w=$('fichaWrap'); if(!w) return;
    var v=veiculoAtual||{};
    var st=fichaTecState || fichaTecObter(v.placa);
    if(st){
      fichaTecState=st;
      /* v244: dentro da avaliação o "✓ Ficha técnica" saiu (pedido) — a aba
         já diz o nome. Na tela da consulta o cabeçalho verde continua. */
      var _tit=$('avBody')?'':'<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Ficha técnica</div>';
      w.innerHTML=_tit+fichaTecPanelHtml(st);
      var pb=w.querySelector('#ftPdf'); if(pb) pb.onclick=function(){ fichaTecBaixarPDF(); };
      ligarFichaOpcionais(w, v.placa);
      try{ ligarFicha(w); }catch(_){}   /* v253: blocos recolhíveis */
      return;
    }
    var naAval=!!$('avBody');   /* dentro da avaliação: só o botão, sem os textos */
    /* v946: ao iniciar uma avaliação, a ficha já corre silenciosamente em
       segundo plano. Se a pessoa abrir a aba antes de terminar, mostramos
       apenas um estado passivo — sem perguntar, cobrar ou disparar outro job. */
    if(naAval && typeof avIaAutoRodando === 'function' && avIaAutoRodando('ficha',v.placa)){
      w.innerHTML='<div class="plc-msg av-ia-preparo">Preparando ficha técnica em segundo plano…</div>';
      return;
    }
    /* Ficha e mercado continuam separados. Na avaliação, a tentativa manual
       desta fase é gratuita; fora dela, preserva-se o produto avulso pago. */
    /* v595: a descrição e a nota PRÉ-consulta saíram (regra da casa); a
       MESMA nota depois do resultado FICA — lá é conferência, não explicação. */
    w.innerHTML='<button class="ficha-btn" id="fichaIA1" style="'+BTN_STYLE+'background:#0a4da6">Gerar ficha técnica com IA — '+precoReal(1)+'</button>';
    var bia=$('fichaIA1'); if(bia) bia.onclick=function(){ _fichaIAJob(bia,true); };
  }
  /* v179 — FICHA POR IA COBRANDO 1 TOKEN.
     Por que passa pelo /api/consultar e nao direto no /api/ficha-ia? Porque o
     /api/consultar e' a "porta unica" que debita, e devolve o token sozinho
     (estorno) se a pesquisa falhar. Assim a regra de cobranca fica num lugar
     so' — e o /api/ficha-ia continua de graca quando ele so' COMPLETA uma
     ficha oficial que veio furada (aquilo o lojista ja' pagou). */
  /* ==========================================================================
     19/08 — A FICHA DE FÁBRICA CORRENDO POR FORA (para a Consulta Plus)
     Dispara o job da ficha e volta NA HORA, sem esperar. Quando a ficha
     chegar (pode levar mais de um minuto), ela entra no `fichaTecState` e a
     tela é avisada.

     🔴 POR QUE ELA NÃO ENTRA NA CONSULTA PLUS LÁ DO SERVIDOR: ela é a única
     das quatro fontes que **não paga API nenhuma**, e é a mais lenta de
     longe — job de fundo com espera de até 2,5 minutos. Prender as três
     fontes pagas esperando a de graça seria trocar 8 segundos por dois
     minutos, e ainda por cima arriscando o teto da function.

     ⚠️ ELA NUNCA DERRUBA NADA. Qualquer erro aqui é engolido de propósito:
     a Plus já entregou o que o lojista pagou antes de a ficha existir.
     ⚠️ E NÃO COBRA (`cobrar:false`): a ficha de fábrica está dentro dos 25
     tokens da Plus. Cobrar de novo aqui seria cobrar duas vezes pelo mesmo. */
  function fichaTecPedirEmParalelo(placa){
    var pl = String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!pl) return;
    return (async function(){
      try{
        var v = veiculoAtual || {};
        var veic = {};
        try{ veic = _ftVeicIA(pl, null) || {}; }catch(_){ veic = {}; }
        veic.marca = veic.marca || v.marca || ''; veic.modelo = veic.modelo || v.modelo || '';
        veic.ano = veic.ano || v.ano || ''; veic.ano_modelo = veic.ano_modelo || v.ano_modelo || '';
        var r = await _iaJobRodar({ job:true, cobrar:false, placa:pl, veiculo:veic }, 150000);
        if(!r || !r.ok || !r.resultado) return;
        var pronta = r.resultado;
        try{ fichaTecGuardar(pl, pronta); }catch(_){}
        /* O job pode terminar depois que outra avaliação foi aberta. Salva a
           placa original, mas só repinta/atualiza o estado global se ela ainda
           for a placa que está na tela. */
        var atual=String((veiculoAtual&&veiculoAtual.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
        if(atual===pl){ fichaTecState=pronta; try{ fichaWrapPinta(); }catch(_){} }
        /* avisa quem estiver na tela — se ninguém estiver, não faz nada */
        try{ if(typeof plusFichaChegou === 'function') plusFichaChegou(pl); }catch(_){}
      }catch(_){ }
    })();
  }

  /* v240: dispara um trabalho de IA em SEGUNDO PLANO e espera o resultado.
     Devolve o mesmo formato de resposta que o /api/consultar devolvia
     (ok/resultado/erro/sem_saldo/saldo), então quem chama quase não muda. */
  async function _iaJobRodar(payload, maxMs){
    var d=null;
    try{ d=await apiComTimeout('/api/ficha-ia', payload, 15000); }catch(_){ d=null; }
    if(!d||d.sem_saldo||!d.ok||!d.protocolo) return d;
    var fim=Date.now()+(maxMs||150000);
    while(Date.now()<fim){
      await new Promise(function(ok){ setTimeout(ok,3000); });
      var p=null;
      try{ p=await apiComTimeout('/api/ficha-ia',{ protocolo:d.protocolo },12000); }catch(_){ p=null; }
      if(!p||(p.ok&&p.pendente)) continue;    /* pendente ou soluço de rede: pergunta de novo */
      return p;
    }
    return { ok:false, erro:'A pesquisa está demorando mais que o normal. Tente de novo em instantes.' };
  }
  async function gerarFichaTecIA(btn){ return _fichaIAJob(btn, true); }
  /* v240 — a ficha por IA agora roda em SEGUNDO PLANO no servidor.
     O QUE TEM POR TRÁS: uma função normal do Netlify só pode viver ~26
     segundos; pesquisa de carro antigo às vezes passa disso e dava
     "a pesquisa demorou demais". Agora o app CRIA um job, um worker de
     fundo (sem esse limite) pesquisa com calma, e o app fica perguntando
     a cada 3s "ficou pronto?" por até 2,5 minutos. O token só é debitado
     no SUCESSO — falhou, nem chegou a sair do saldo. */
  async function _fichaIAJob(btn, cobrar){
    var v=veiculoAtual; if(!v) return; var content=$('fichaWrap'); if(!content) return;
    content.innerHTML=ccLoaderHtml('Pesquisando a ficha do modelo na web…',_ftFrasesIA); var lt=ccLoaderStart(_ftFrasesIA, 150);   /* v488: o prazo real do job (150s) */
    var veic={}; try{ veic=_ftVeicIA(v.placa, null)||{}; }catch(_){ veic={}; }
    veic.marca=veic.marca||v.marca||''; veic.modelo=veic.modelo||v.modelo||'';
    veic.ano=veic.ano||v.ano||''; veic.ano_modelo=veic.ano_modelo||v.ano_modelo||''; veic.cor=veic.cor||v.cor||'';
    function falhou(msg){
      clearInterval(lt); var c=$('fichaWrap'); if(!c) return;
      c.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-bottom:8px">'+esc(msg||'Não consegui montar a ficha por IA agora.')+'</div>'+
        '<button class="ficha-btn" id="fichaIA1R" style="'+BTN_STYLE+'">Tentar de novo</button>';
      var rr=$('fichaIA1R'); if(rr) rr.onclick=function(){ _fichaIAJob(rr, cobrar); };
    }
    var d=null;
    try{ d=await apiComTimeout('/api/ficha-ia',{ job:true, cobrar:!!cobrar, placa:v.placa, veiculo:veic },15000); }catch(_){ d=null; }
    if(d&&d.sem_saldo){ clearInterval(lt); setSaldo(d.saldo); if($('avBody')){ fichaWrapPinta(); }else{ abrirFicha(); } abrirPacotes(); return; }
    if(!d||!d.ok||!d.protocolo){ falhou(d&&d.erro); return; }
    /* fica perguntando "ficou pronto?" a cada 3s, por até 2,5 minutos */
    var fim=Date.now()+150000, res=null;
    while(Date.now()<fim){
      await new Promise(function(ok){ setTimeout(ok,3000); });
      if(!$('fichaWrap')){ clearInterval(lt); return; }  /* saiu da tela: para de perguntar */
      var p=null;
      try{ p=await apiComTimeout('/api/ficha-ia',{ protocolo:d.protocolo },12000); }catch(_){ p=null; }
      if(p&&p.ok&&p.pendente) continue;
      if(!p) continue;                                    /* soluço de rede: pergunta de novo */
      res=p; break;
    }
    clearInterval(lt);
    if(!$('fichaWrap')) return;
    content=$('fichaWrap');
    if(res&&res.saldo!=null) setSaldo(res.saldo);
    if(!res){ falhou('A pesquisa está demorando mais que o normal. Tente de novo em instantes.'); return; }
    if(!res.ok||!res.resultado){ falhou(res.erro); return; }
    fichaTecState=res.resultado;
    try{ fichaTecGuardar(v.placa, fichaTecState); }catch(_){}
    content.innerHTML='<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Ficha técnica</div>'+fichaTecPanelHtml(fichaTecState);
    var pbi=content.querySelector('#ftPdf'); if(pbi) pbi.onclick=function(){ fichaTecBaixarPDF(); };
    ligarFichaOpcionais(content, v.placa);
    try{ ligarFicha(content); }catch(_){}   /* v253: blocos recolhíveis */
    /* v242: a análise de mercado NÃO vem mais junto — botão próprio na
       aba Mercado (pedido: "volte a deixar separado"). */
  }
  async function gerarFichaTec(btn){
    if(!veiculoAtual) return; var content=$('fichaWrap'); if(!content) return;
    content.innerHTML=ccLoaderHtml('Consultando ficha técnica…',_ftFrases); var lt=ccLoaderStart(_ftFrases, 30);      /* v488: a base oficial leva ~30s */
    var d=await consultarComRetry({produto:'ficha_tecnica',placa:veiculoAtual.placa},1);
    clearInterval(lt);
    if(d&&d.sem_saldo){ setSaldo(d.saldo); if($('avBody')){ fichaWrapPinta(); }else{ abrirFicha(); } abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!content||!$('fichaWrap')) return;
    if(!d||!d.ok){
      /* v161: base oficial fora do ar. Em vez de só "tente de novo", ofereço a
         ficha montada por pesquisa na web — que não custa token nenhum. */
      content.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-bottom:8px">'+esc((d&&d.erro)||'Não consegui gerar a ficha agora.')+(d&&d.estornado?' O valor foi devolvido ao seu saldo.':'')+'</div>'+
        '<button class="ficha-btn" id="fichaRetry" style="'+BTN_STYLE+'">Tentar de novo</button>'+
        '<button class="ficha-btn" id="fichaIA" style="'+BTN_STYLE+'background:#0a4da6;margin-top:8px">Montar ficha por pesquisa (IA) — sem custo</button>'+
        '<div class="plc-msg" style="font-size:11px;color:#94a3b8;margin-top:6px">A IA começa pelo site, catálogo e manual oficiais da montadora e usa outras fontes confiáveis somente para completar o que faltar — confira antes de usar em documento.</div>';
      var rb=$('fichaRetry'); if(rb) rb.onclick=function(){ gerarFichaTec(rb); };
      var ib=$('fichaIA'); if(ib) ib.onclick=function(){ fichaSoIA(ib); };
      return;
    }
    /* enriquece identificação vazia (homolog) com o que já temos do veículo */
    try{
      var _ft=_ftBloco(d.resultado); var _va=veiculoAtual||{};
      if(_ft){
        if(!_ft.marca_modelo&&(_va.marca||_va.modelo)) _ft.marca_modelo=((_va.marca||'')+' '+(_va.modelo||'')).trim();
        if(!_ft.placa&&_va.placa) _ft.placa=_va.placa;
        if(!_ft.ano_fabricacao&&_va.ano) _ft.ano_fabricacao=_va.ano;
        if(!_ft.ano_modelo&&_va.ano_modelo) _ft.ano_modelo=_va.ano_modelo;
        if(!_ft.cor_veiculo&&_va.cor) _ft.cor_veiculo=_va.cor;
        if(!_ft.chassi&&_va.chassi) _ft.chassi=_va.chassi;
      }
    }catch(_){}
    fichaTecState=d.resultado;
    /* SALVA no histórico (e na nuvem) — antes ficava só na memória e sumia ao
       fechar o app / trocar de aparelho, pedindo pra pagar de novo */
    try{ fichaTecGuardar(veiculoAtual.placa, fichaTecState); }catch(_){}
    content.innerHTML='<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Ficha técnica</div>'+fichaTecPanelHtml(fichaTecState);
    var pb=content.querySelector('#ftPdf'); if(pb) pb.onclick=function(){ fichaTecBaixarPDF(); };
    ligarFichaOpcionais(content, (veiculoAtual&&veiculoAtual.placa)||'');
    try{ ligarFicha(content); }catch(_){}   /* v253: blocos recolhíveis */
    /* v161: veio zerada/sem equipamentos? completa com a pesquisa da IA (sem cobrar). */
    try{ fichaTelaCompletarIA((veiculoAtual&&veiculoAtual.placa)||''); }catch(_){}
  }
  /* v161 — roda DEPOIS que a ficha já está na tela: se faltou dado, pesquisa e
     redesenha. Como é assíncrono, o lojista já vê o que a base oficial mandou. */
  async function fichaTelaCompletarIA(placa){
    var p=null; try{ p=fichaTecParse(fichaTecState||{}); }catch(_){}
    if(!p||!_ftPrecisaIA(p)) return;
    var box=$('ftIAload');
    if(box) box.innerHTML='<div class="post-load" style="margin-top:12px"><span class="spin" style="width:18px;height:18px;border-width:3px"></span> A base oficial veio incompleta — pesquisando a ficha do modelo na web…</div>';
    var campos=await fichaIAcompletar(placa, fichaTecState, p);
    if(!$('fichaWrap')) return;                       /* saiu da tela no meio */
    if(!campos){ var b2=$('ftIAload'); if(b2) b2.innerHTML=''; return; }
    try{ fichaTecGuardar(placa, fichaTecState); }catch(_){}
    var content=$('fichaWrap'); if(!content) return;
    content.innerHTML='<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Ficha técnica</div>'+fichaTecPanelHtml(fichaTecState);
    var pb2=content.querySelector('#ftPdf'); if(pb2) pb2.onclick=function(){ fichaTecBaixarPDF(); };
    ligarFichaOpcionais(content, placa);
    try{ ligarFicha(content); }catch(_){}   /* v253: blocos recolhíveis */
  }
  /* v161 — a base oficial não respondeu NADA: monta a ficha só com a IA (grátis) */
  /* v240: o fallback grátis usa o MESMO fluxo em segundo plano (custo 0) */
  async function fichaSoIA(btn){ return _fichaIAJob(btn, false); }
  /* localiza o bloco ficha_tecnica_veicular em qualquer embrulho */
  function _ftBloco(dd){
    var base=(dd&&dd.resultado)||dd||{}; base=base.data||base;
    if(base.veicular&&base.veicular.ficha_tecnica_veicular) return base.veicular.ficha_tecnica_veicular;
    return _ftDeep(base,0);
  }
  function _ftDeep(o,d){
    if(!o||typeof o!=='object'||Array.isArray(o)||d>6) return null;
    if(o.ficha_tecnica_veicular&&typeof o.ficha_tecnica_veicular==='object') return o.ficha_tecnica_veicular;
    if((o.motor!==undefined||o.medidas!==undefined)&&(o.equipamentos!==undefined||o.medicao_combustivel!==undefined)) return o;
    for(var k in o){ if(!Object.prototype.hasOwnProperty.call(o,k))continue; var v=o[k]; if(v&&typeof v==='object'&&!Array.isArray(v)){ var f=_ftDeep(v,d+1); if(f) return f; } }
    return null;
  }
  function _ftv(x){ var s=String(x==null?'':x).trim(); return s; }
  function fichaTecParse(dd){
    var ft=_ftBloco(dd)||{};
    var mc=(Array.isArray(ft.medicao_combustivel)&&ft.medicao_combustivel[0])||{};
    var md=ft.medidas||{};
    var ident=[ ['Veículo', _ftv(ft.marca_modelo)], ['Versão', _ftv(ft.versao)], ['Placa', _ftv(ft.placa)],
      ['Ano fab./modelo', [_ftv(ft.ano_fabricacao),_ftv(ft.ano_modelo)].filter(Boolean).join('/')],
      ['Cor', _ftv(ft.cor_veiculo)], ['Chassi', _ftv(ft.chassi)], ['Segmento', _ftv(ft.segmento)],
      ['Passageiros', _ftv(ft.quantidade_passageiros)], ['Portas', (_ftv(ft.quantidade_portas)&&ft.quantidade_portas!=='0')?_ftv(ft.quantidade_portas):''] ];
    /* Carro flex: a API manda UMA medição POR COMBUSTÍVEL (álcool e gasolina).
       Quando os valores diferem, mostramos os dois lado a lado. */
    var mcs=(Array.isArray(ft.medicao_combustivel)?ft.medicao_combustivel:[]).filter(function(x){ return x&&typeof x==='object'; });
    if(!mcs.length) mcs=[mc];
    function _un(v,u){ v=_ftv(v); return v?(v+u):''; }
    function _fuel(x){ return String((x&&x.combustivel)||'').trim().toLowerCase(); }
    function _duo(campo, unid){
      var uteis=mcs.filter(function(x){ var v=_ftv(x[campo]); return v && v!=='0'; });
      if(!uteis.length) return '';
      var set={}; uteis.forEach(function(x){ set[_ftv(x[campo])]=1; });
      if(uteis.length===1 || Object.keys(set).length===1) return _un(uteis[0][campo], unid);
      return uteis.map(function(x){ var f=_fuel(x); return _ftv(x[campo])+unid+(f?(' ('+f+')'):''); }).join(' · ');
    }
    var _combTxt = mcs.length>1 ? mcs.map(function(x){ return _ftv(x.combustivel); }).filter(Boolean).join('/') : _ftv(mc.combustivel);
    var motor=[ ['Motor', _ftv(ft.motor)], ['Câmbio', _ftv(ft.cambio)||_ftv(ft.caixa_cambio)], ['Direção', _ftv(ft.direcao)], ['Tração', _ftv(ft.tipo_tracao)],
      ['Combustível', _combTxt], ['Cilindradas', _ftv(mc.cilindradas)?(_ftv(mc.cilindradas)+' cc'):''] ];
    var desemp=[ ['Potência', _duo('potencia',' cv')], ['Torque', _duo('torque',' kgfm')], ['0–100 km/h', _duo('tempo_zero_a_cem',' s')],
      ['Velocidade máx.', _duo('velocidade_maxima',' km/h')], ['Consumo cidade', _duo('consumo_cidade',' km/l')], ['Consumo estrada', _duo('consumo_estrada',' km/l')] ];
    var dim=[ ['Comprimento', _un(md.comprimento,' mm')], ['Largura', _un(md.largura,' mm')], ['Altura', _un(md.altura,' mm')], ['Entre-eixos', _un(md.entre_eixos,' mm')],
      ['Peso', _un(md.peso,' kg')], ['Porta-malas', _un(md.porta_malas,' L')], ['Tanque', _un(md.tanque_combustivel,' L')] ];
    var chassi=[ ['Freio dianteiro', _ftv(ft.freio_dianteiro)], ['Freio traseiro', _ftv(ft.freio_traseiro)], ['Suspensão dianteira', _ftv(ft.suspensao_dianteira)], ['Suspensão traseira', _ftv(ft.suspensao_traseira)] ];
    var equip=(Array.isArray(ft.equipamentos)?ft.equipamentos:[]).map(function(e){ return { nome:_ftv(e.descricao), disp:String(e.disponibilidade||'').toUpperCase().trim() }; }).filter(function(e){ return e.nome; });
    var conhecido=!!(ft.motor!==undefined||ft.medidas||ft.equipamentos||ft.medicao_combustivel);
    return { ident:ident, motor:motor, desemp:desemp, dim:dim, chassi:chassi, equip:equip, conhecido:conhecido, raw:ft };
  }
  /* v161: 'ia' e a lista de rotulos que vieram da pesquisa da IA — ganham um selinho. */
  /* =========================================================================
     v161 — FICHA TÉCNICA COMPLETADA PELA IA (pesquisa na web)
     -------------------------------------------------------------------------
     PROBLEMA: em carro mais antigo a base oficial (API Brasil) responde, mas
     com tudo ZERADO — comprimento 0, peso 0, tanque 0, nenhum equipamento.
     A tela ficava um monte de zeros e o lojista pagou 3 tokens por nada.

     SOLUÇÃO: o app percebe os buracos e chama /api/ficha-ia. Lá no servidor a
     IA pesquisa NA WEB a ficha de fábrica daquele modelo/ano e devolve os
     dados no MESMO formato do provedor. Aqui a gente encaixa SÓ nos buracos —
     o que a base oficial mandou é sempre soberano e nunca é sobrescrito.
     Cada valor que veio da IA ganha um selinho "IA" na tela.
     Não custa token nenhum: é complemento da consulta que já foi paga.
     ========================================================================= */
  /* "vazio" aqui inclui o zero puro E o zero JÁ COM A UNIDADE colada, porque a
     tela monta "0 mm", "0 kg", "0 L", "0 cc", "0 km/l" — sem isso o app acharia
     que "0 mm" é uma medida de verdade e nunca pediria ajuda pra IA. */
  function _ftVazio(x){ var t=String(x==null?'':x).trim(); return !t || /^0+([.,]0+)?(\s*[a-zA-Zº°\/]+)?$/.test(t); }
  /* rótulos iguais aos que o fichaTecParse usa — é assim que o selinho acha a linha */
  var _FT_MAPA={versao:'Versão',segmento:'Segmento',quantidade_passageiros:'Passageiros',quantidade_portas:'Portas',
    motor:'Motor',cambio:'Câmbio',direcao:'Direção',tipo_tracao:'Tração',
    freio_dianteiro:'Freio dianteiro',freio_traseiro:'Freio traseiro',
    suspensao_dianteira:'Suspensão dianteira',suspensao_traseira:'Suspensão traseira'};
  var _FT_MED={comprimento:'Comprimento',largura:'Largura',altura:'Altura',entre_eixos:'Entre-eixos',
    peso:'Peso',porta_malas:'Porta-malas',tanque_combustivel:'Tanque'};
  var _FT_MC={cilindradas:'Cilindradas',potencia:'Potência',torque:'Torque',tempo_zero_a_cem:'0–100 km/h',
    velocidade_maxima:'Velocidade máx.',consumo_cidade:'Consumo cidade',consumo_estrada:'Consumo estrada'};

  /* o que está faltando na ficha já lida (devolve os rótulos vazios) */
  function _ftFaltantes(p){
    if(!p) return [];
    function vazios(arr){ return (arr||[]).filter(function(r){ return _ftVazio(r[1]); }).map(function(r){ return r[0]; }); }
    var falta=vazios(p.dim).concat(vazios(p.desemp)).concat(vazios(p.motor)).concat(vazios(p.chassi));
    (p.ident||[]).forEach(function(r){ if(['Versão','Segmento','Passageiros','Portas'].indexOf(r[0])>=0 && _ftVazio(r[1])) falta.push(r[0]); });
    if(!(p.equip||[]).length) falta.push('Equipamentos de série e opcionais');
    return falta;
  }
  /* vale a pena chamar a IA? (só quando falta coisa DE VERDADE) */
  function _ftPrecisaIA(p){
    if(!p) return false;
    if(p.raw && p.raw._ia) return false;                      /* já completado antes */
    function nVazios(arr){ return (arr||[]).filter(function(r){ return _ftVazio(r[1]); }).length; }
    if(!(p.equip||[]).length) return true;
    if(nVazios(p.dim)>=4) return true;
    if(nVazios(p.desemp)>=4) return true;
    if(nVazios(p.motor)>=3) return true;
    return false;
  }
  /* encaixa os dados da IA SÓ onde a oficial veio vazia. Devolve os rótulos preenchidos. */
  function _ftMesclarIA(alvo, ia){
    if(!alvo||!ia) return [];
    var mudou=[];
    Object.keys(_FT_MAPA).forEach(function(k){
      var novo=String(ia[k]==null?'':ia[k]).trim(); if(!novo) return;
      var atual=alvo[k]; if(k==='cambio' && _ftVazio(atual)) atual=alvo.caixa_cambio;
      if(_ftVazio(atual)){ alvo[k]=novo; mudou.push(_FT_MAPA[k]); }
    });
    if(ia.medidas&&typeof ia.medidas==='object'){
      alvo.medidas=alvo.medidas||{};
      Object.keys(_FT_MED).forEach(function(k){
        if(!_ftVazio(ia.medidas[k]) && _ftVazio(alvo.medidas[k])){ alvo.medidas[k]=ia.medidas[k]; mudou.push(_FT_MED[k]); }
      });
    }
    var iaMc=Array.isArray(ia.medicao_combustivel)?ia.medicao_combustivel:[];
    if(iaMc.length){
      var cur=Array.isArray(alvo.medicao_combustivel)?alvo.medicao_combustivel.filter(function(x){ return x&&typeof x==='object'; }):[];
      var temAlgo=cur.some(function(x){ return Object.keys(_FT_MC).some(function(k){ return !_ftVazio(x[k]); }); });
      if(!temAlgo){
        alvo.medicao_combustivel=iaMc;
        Object.keys(_FT_MC).forEach(function(k){ if(iaMc.some(function(x){ return !_ftVazio(x[k]); })) mudou.push(_FT_MC[k]); });
      } else {
        cur.forEach(function(linha){
          var comb=String(linha.combustivel||'').trim().toLowerCase();
          var fonte=iaMc.filter(function(x){ return String(x.combustivel||'').trim().toLowerCase()===comb; })[0]||iaMc[0];
          Object.keys(_FT_MC).forEach(function(k){
            if(!_ftVazio(fonte[k]) && _ftVazio(linha[k])){ linha[k]=fonte[k]; if(mudou.indexOf(_FT_MC[k])<0) mudou.push(_FT_MC[k]); }
          });
        });
      }
    }
    var iaEq=Array.isArray(ia.equipamentos)?ia.equipamentos:[];
    var curEq=Array.isArray(alvo.equipamentos)?alvo.equipamentos:[];
    if(iaEq.length && !curEq.length){ alvo.equipamentos=iaEq; mudou.push('Equipamentos'); }
    return mudou;
  }
  /* monta marca/modelo/ano pra IA pesquisar (histórico + veículo aberto + a própria ficha) */
  function _ftVeicIA(placa, p){
    var v={};
    /* v190: a ficha de fabrica se pesquisa pelo ANO-MODELO (e' assim que a
       montadora publica). Mandamos o ano-modelo como "ano" e o de fabricacao
       separado, pra IA nao pesquisar o ano errado. */
    try{ var h=histLerUm(placa); if(h&&h.v){ v.marca=h.v.marca||''; v.modelo=h.v.modelo||''; v.ano=h.v.ano_modelo||h.v.ano||''; if(h.v.ano_modelo) v.ano_modelo=h.v.ano_modelo; if(h.v.ano) v.ano_fab=h.v.ano; v.combustivel=h.v.combustivel||''; } }catch(_){}
    try{
      var va=veiculoAtual;
      if(va && String(va.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')){
        v.marca=v.marca||va.marca||''; v.modelo=v.modelo||va.modelo||'';
        v.ano=v.ano||va.ano_modelo||va.ano||''; v.combustivel=v.combustivel||va.combustivel||'';
        if(va.ano_modelo) v.ano_modelo=v.ano_modelo||va.ano_modelo;
        if(va.ano) v.ano_fab=v.ano_fab||va.ano;
      }
    }catch(_){}
    if(p){ (p.ident||[]).forEach(function(r){
      if(r[0]==='Veículo'&&r[1]&&!v.modelo) v.modelo=r[1];
      if(r[0]==='Versão'&&r[1]&&!v.versao) v.versao=r[1];
      if(r[0]==='Ano fab./modelo'&&r[1]&&!v.ano){ var a=String(r[1]).split('/');
        var _af=(a[0]||'').trim(), _am=(a[1]||'').trim();
        v.ano=_am||_af;                      /* v190: ano-modelo na frente */
        if(_am) v.ano_modelo=_am; if(_af) v.ano_fab=_af; }
    }); }
    return v;
  }
  /* CHAMADA: pesquisa e encaixa. Devolve os rótulos preenchidos (ou null). */
  async function fichaIAcompletar(placa, envelope, p){
    var alvo=null; try{ alvo=_ftBloco(envelope); }catch(_){}
    if(!alvo) return null;
    var veic=_ftVeicIA(placa, p);
    if(!(veic.modelo||veic.marca) || !(veic.ano||veic.ano_modelo)) return null;
    var d=null;
    try{ d=await apiComTimeout('/api/ficha-ia', { placa:placa, veiculo:veic, faltando:_ftFaltantes(p) }, 34000); }catch(_){ d=null; }
    if(!d||!d.ok||!d.ficha) return null;
    var campos=_ftMesclarIA(alvo, d.ficha);
    if(!campos.length) return null;
    alvo._ia={ campos:campos, fontes:(d.fontes||[]), modelo:(d.modelo_ia||''), quando:Date.now() };
    return campos;
  }
  /* envelope vazio pra quando a base oficial NÃO responde nada */
  function _ftEnvelopeVazio(v){
    v=v||{};
    return { ficha_tecnica_veicular:{
      marca_modelo:((v.marca||'')+' '+(v.modelo||'')).trim(), placa:v.placa||'',
      ano_fabricacao:v.ano||'', ano_modelo:v.ano_modelo||v.ano||'', cor_veiculo:v.cor||'', chassi:v.chassi||'',
      /* medidas:{} garante que o fichaTecParse reconheça isso como uma ficha
         (senão, se a IA preenchesse só a Versão, a tela cairia no modo "cru") */
      medidas:{}, equipamentos:[]
    } };
  }
  /* o tarjão azul que explica de onde vieram os dados da IA */
  function _ftAvisoIA(info){
    if(!info) return '';
    var qtd=(info.campos||[]).length;
    var fontes=(info.fontes||[]).slice(0,3).map(function(u){
      var dom=''; try{ dom=String(u).split('/')[2]||u; }catch(_){ dom=u; }
      return '<a href="'+esc(u)+'" target="_blank" rel="noopener" style="color:#0a4da6;font-weight:700">'+esc(dom)+'</a>';
    }).join(' · ');
    /* v179 — quando a ficha INTEIRA foi montada pela IA (1 token), o texto muda */
    if(info.tudo){
      /* v243: tarja curta (pedido) — sem lista de fontes na tela */
      return '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid var(--azul2);border-radius:14px;padding:11px 14px;margin:8px 0 4px">'+
        '<div style="font-weight:700;color:var(--azul2);font-size:12.5px">Gerado por IA — confira os itens de série e opcionais.</div>'+
        '</div>';
    }
    return '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid #0a4da6;border-radius:14px;padding:12px 14px;margin:8px 0 4px">'+
      '<div style="font-weight:800;color:#0a4da6;font-size:13px">A base oficial veio incompleta — completei com pesquisa na web</div>'+
      '<div style="font-size:12px;color:#334155;line-height:1.45;margin-top:4px">'+
      qtd+' informação'+(qtd===1?'':'ões')+' com o selinho <span class="ft-ia">IA</span> vieram de pesquisa que prioriza fontes oficiais da montadora. '+
      'Serve muito bem pra anúncio e pra conversa de venda — <b>confira antes de usar em documento</b>.'+
      (fontes?('<div style="margin-top:5px;font-size:11.5px;color:#64748b">Fontes: '+fontes+'</div>'):'')+
      '</div></div>';
  }

  function _ftKvSec(titulo,rows,ia){
    rows=(rows||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); });
    if(!rows.length) return '';
    ia=ia||[];
    /* v184 — CADA INFORMACAO VIRA UM CARD.
       Antes era uma lista de linhas "rotulo .......... valor" dentro de uma
       caixa unica. No celular isso vira uma parede de texto. Agora sao
       cardzinhos, 2 por linha; quando o valor e' comprido (ex.: "180 km/h
       (gasolina) - 184 km/h (etanol)") o card ocupa a linha inteira. */
    return (titulo?('<div class="ftc-tit">'+esc(titulo)+'</div>'):'')+'<div class="ftc-grid">'+
      rows.map(function(r){
        var val=String(r[1]); var lng=val.length>26;
        var _ia=ia.indexOf(r[0])>=0?'<span class="ft-ia">IA</span>':'';
        return '<div class="ftc-card'+(lng?' wide':'')+'"><span class="ftc-k">'+esc(r[0])+'</span><span class="ftc-v">'+_ia+esc(val)+'</span></div>';
      }).join('')+'</div>';
  }
  function _ftEquipHtml(equip, marcados, desmarcados, porIA){
    if(!equip||!equip.length) return '';
    marcados=marcados||[]; desmarcados=desmarcados||[];
    /* v161: quando a lista veio da pesquisa da IA, o aviso muda de tom —
       ali NAO e dado oficial, e um ponto de partida pro lojista conferir. */
    var _avSerie = porIA
      ? 'Lista montada por pesquisa na web (IA) — <b>confira item por item</b> e desmarque o que este carro nao tem.'
      : 'Confirme a lista — desmarque o que este veiculo NAO tem (sai do anuncio e do PDF).';
    var _avOpc = porIA
      ? 'Opcionais que existiam nesse modelo/ano segundo a pesquisa — marque os que ESTE carro tem.'
      : 'Marque os opcionais que este veiculo tem — eles aparecem no anuncio para os lojistas.';
    var serie=equip.filter(function(e){ return !/OPCION|INDISPON/.test(e.disp); });
    var opc=equip.filter(function(e){ return /OPCION/.test(e.disp); });
    /* "Não disponíveis neste modelo" foi REMOVIDO a pedido. */
    var cores=['#dcfce7','#bbf7d0','#15803d'];
    /* Série agora é CONFERÍVEL: vem tudo marcado, e o lojista DESMARCA o que
       este carro não tem — o item some do anúncio e do PDF. */
    var serieHtml = serie.length ? ('<div style="font-size:11.5px;font-weight:800;color:'+cores[2]+';text-transform:uppercase;letter-spacing:.4px;margin:16px 2px 5px">Equipamentos de série ('+serie.length+')</div>'+
      '<div style="font-size:11.5px;color:#94a3b8;font-weight:600;margin:0 2px 7px">'+_avSerie+'</div>'+
      '<div style="background:#fff;border:1px solid '+cores[1]+';border-radius:14px;overflow:hidden;box-shadow:0 3px 12px rgba(2,20,60,.05)">'+
      serie.map(function(e,i){ var off=desmarcados.indexOf(e.nome)>=0;
        return '<label style="display:flex;align-items:center;gap:11px;padding:11px 14px;cursor:pointer;'+(i?'border-top:1px solid #f1f5f9;':'')+(off?'opacity:.45;':'')+'"><input type="checkbox" class="ft-serie-chk" data-serie="'+esc(e.nome)+'"'+(off?'':' checked')+' style="width:20px;height:20px;flex:none;accent-color:#15803d;cursor:pointer"><span style="font-size:13.5px;font-weight:400;color:#0f172a;'+(off?'text-decoration:line-through;':'')+'">'+esc(e.nome)+'</span></label>'; }).join('')+'</div>') : '';
    /* Opcionais: agora MARCÁVEIS — o lojista marca o que ESTE carro tem.
       Os marcados vão pro anúncio do repasse (junto de motor/câmbio/série). */
    var opcHtml = opc.length ? ('<div style="font-size:11.5px;font-weight:800;color:#b45309;text-transform:uppercase;letter-spacing:.4px;margin:16px 2px 5px">Opcionais deste carro</div>'+
      '<div style="font-size:11.5px;color:#94a3b8;font-weight:600;margin:0 2px 7px">'+_avOpc+'</div>'+
      '<div style="background:#fff;border:1px solid #fde68a;border-radius:14px;overflow:hidden;box-shadow:0 3px 12px rgba(2,20,60,.05)">'+
      opc.map(function(e,i){ var on=marcados.indexOf(e.nome)>=0; return '<label style="display:flex;align-items:center;gap:11px;padding:12px 14px;cursor:pointer;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><input type="checkbox" class="ft-opc-chk" data-opc="'+esc(e.nome)+'"'+(on?' checked':'')+' style="width:20px;height:20px;flex:none;accent-color:#b45309;cursor:pointer"><span style="font-size:13.5px;font-weight:400;color:#0f172a">'+esc(e.nome)+'</span></label>'; }).join('')+'</div>') : '';
    return serieHtml + opcHtml;
  }
  /* ===== v560 — O QUE DA FICHA TÉCNICA *VENDE*, NUM LUGAR SÓ =================
   * A v489 escreveu esta leitura dentro do 13 (pro pacote da avaliação); a
   * v560 precisou dela de novo no 14 (pra mensagem do veículo). Duas cópias
   * da mesma leitura é o começo de duas mensagens diferentes — o erro que a
   * v508 já teve que desfazer no chat. Então ela mora AQUI, no dono da ficha,
   * e os dois chamam.
   *
   * ⚠️ NÃO GERA NADA. `fichaTecObter` lê histórico / cache / estoque. Sem
   * ficha gerada antes, devolve {} e quem chama encolhe sozinho. Nunca gasta
   * token, nunca inventa dado.
   * ⚠️ RESPEITA O QUE O LOJISTA MEXEU: item de série que ele DESMARCOU não
   * volta, e opcional só entra se ele MARCOU (fichaResumoLer) — é a mesma
   * régua do repasse desde a v489.
   * ⚠️ É espec de fábrica: nada sensível sai daqui (regra v265). */
  function fichaVendeDe(placa){
    var o={ motor:'', cambio:'', motor_potencia:'', motor_torque:'',
            motor_cilindrada:'', motor_combustivel:'', motor_consumo:'',
            porta_malas:'', tanque:'',
            itens:[], opcionais:[], opcionais_todos:[], opcionais_marcados:[] };
    try{
      var dd=(typeof fichaTecObter==='function')?fichaTecObter(placa||''):null;
      if(!dd) return o;
      var p=fichaTecParse(dd);
      if(!p||!p.conhecido) return o;
      var pega=function(rows,nome){ var s=''; (rows||[]).forEach(function(r){ if(r[0]===nome&&r[1]!=null&&String(r[1]).trim()) s=String(r[1]).trim(); }); return s; };
      o.motor            = pega(p.motor,'Motor');
      o.cambio           = pega(p.motor,'Câmbio');
      o.motor_combustivel= pega(p.motor,'Combustível');
      o.motor_cilindrada = pega(p.motor,'Cilindradas');
      o.motor_potencia   = pega(p.desemp,'Potência');
      o.motor_torque     = pega(p.desemp,'Torque');
      var cc=pega(p.desemp,'Consumo cidade'), ce=pega(p.desemp,'Consumo estrada');
      o.motor_consumo=[cc?(cc+' cidade'):'', ce?(ce+' estrada'):''].filter(Boolean).join(' · ');
      /* v674: o porta-malas entrou na mensagem de compartilhar (pedido:
         "tá sem motorização, câmbio, dimensões"). É a ÚNICA medida que vende
         num sedan/hatch usado — comprimento e peso não convencem ninguém. */
      o.porta_malas      = pega(p.dim,'Porta-malas');
      o.tanque           = pega(p.dim,'Tanque');   /* v680: a linha 📐 da mensagem */
      var fr=fichaResumoLer(placa||'')||{}, desm=fr.desmarcados||[], marc=fr.marcados||[];
      o.itens    =(p.equip||[]).filter(function(e){ return !/OPCION|INDISPON/.test(e.disp) && desm.indexOf(e.nome)<0; }).map(function(e){ return e.nome; }).slice(0,20);
      o.opcionais=(p.equip||[]).filter(function(e){ return  /OPCION/.test(e.disp) && marc.indexOf(e.nome)>=0; }).map(function(e){ return e.nome; }).slice(0,20);
      /* v563 — os opcionais que a FÁBRICA oferecia pra este ano, marcados ou
         não. O `opcionais` acima é "o que este carro TEM" (só os marcados);
         este é "o que ele PODERIA ter" — é a lista que vira pergunta pro
         cliente ("tem teto solar? tem couro?"). São coisas diferentes e por
         isso são dois campos, não um. */
      o.opcionais_todos=(p.equip||[]).filter(function(e){ return /OPCION/.test(e.disp); }).map(function(e){ return e.nome; }).slice(0,30);
      o.opcionais_marcados=marc.slice(0);
    }catch(_){ }
    return o;
  }

  /* ===== Resumo da ficha por placa (motor/câmbio/série/opcionais) — usado no repasse ===== */
  function _fichaKey(placa){ return 'mev_ficha_marc_'+String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function fichaResumoLer(placa){ if(!placa) return null; try{ return JSON.parse(localStorage.getItem(_fichaKey(placa))||'null')||null; }catch(_){ return null; } }
  function fichaResumoSalvar(placa, resumo){ if(!placa) return; try{ localStorage.setItem(_fichaKey(placa), JSON.stringify(resumo)); }catch(_){} }
  /* monta o resumo a partir da ficha lida, preservando os opcionais já marcados */
  function _fichaResumoDaParse(p, placa){
    var prev=fichaResumoLer(placa)||{};
    var motor='', cambio='';
    (p.motor||[]).forEach(function(r){ if(r[0]==='Motor'&&r[1]) motor=r[1]; if(r[0]==='Câmbio'&&r[1]) cambio=r[1]; });
    var serie=(p.equip||[]).filter(function(e){ return !/OPCION|INDISPON/.test(e.disp); }).map(function(e){ return e.nome; });
    var opc=(p.equip||[]).filter(function(e){ return /OPCION/.test(e.disp); }).map(function(e){ return e.nome; });
    var marc=(prev.marcados||[]).filter(function(n){ return opc.indexOf(n)>=0; });   /* só marcados que ainda existem */
    var desm=(prev.desmarcados||[]).filter(function(n){ return serie.indexOf(n)>=0; }); /* série desmarcada pelo lojista */
    return { motor:motor, cambio:cambio, serie:serie, opcionais:opc, marcados:marc, desmarcados:desm };
  }
  function _fichaPlaca(p){ var pl=''; (p&&p.ident||[]).forEach(function(r){ if(r[0]==='Placa'&&r[1]) pl=r[1]; }); return pl||((veiculoAtual&&veiculoAtual.placa)||''); }
  function fichaTecPanelHtml(dd){
    var p=fichaTecParse(dd);
    if(!p.conhecido){ return '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid #0a4da6;border-radius:14px;padding:14px 16px;margin:6px 0 12px"><div style="font-weight:800;color:#0a4da6">Ficha técnica</div></div><div style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:12px 14px">'+renderVal(_cpfRawSeguro(p.raw))+'</div>'; }
    var placa=_fichaPlaca(p);
    var resumo=_fichaResumoDaParse(p, placa);
    fichaResumoSalvar(placa, resumo);   /* guarda motor/câmbio/série/opcionais (preserva marcados) */
    var _iaInfo=(p.raw&&p.raw._ia)||null;
    var _iaSet=(_iaInfo&&_iaInfo.campos)||[];
    var _eqIA=_iaSet.indexOf('Equipamentos')>=0;
    /* v244: a tarja "Gerado por IA" saiu do topo e foi pro FINAL da página (pedido) */
    /* v253: FICHA EM BLOCOS recolhíveis (pedido — igual ao MEV Tools): cada
       seção vira um cartão .fic-item (o mesmo acordeão da análise de mercado);
       só a Identificação abre por padrão. Quem pinta a ficha na tela chama
       ligarFicha(container) pra ligar os cliques. */
    function _ftBloco(titulo, corpo, cnt, aberto){
      if(!corpo) return '';
      /* v253: sem badge de contagem; ícone SVG por seção (pedido) */
      return '<div class="fic-item'+(aberto?' open':'')+'"><button type="button" class="fic-t"><span class="fic-ic">'+_ficIcoTit(titulo)+'</span><span class="fic-tt">'+esc(titulo)+'</span><span class="fic-ar">&#9656;</span></button><div class="fic-b">'+corpo+'</div></div>';
    }
    function _ftCnt(rows){ rows=(rows||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); }); return rows.length?(rows.length+' itens'):''; }
    var _serieN=(p.equip||[]).filter(function(e){ return !/OPCION|INDISPON/.test(e.disp); }).length;
    var _opcN=(p.equip||[]).filter(function(e){ return /OPCION/.test(e.disp); }).length;
    var _eqCnt=[ _serieN?(_serieN+' série'):'', _opcN?(_opcN+' opcionais'):'' ].filter(Boolean).join(' · ');
    var html='';
    html+=_ftBloco('Identificação', _ftKvSec('', p.ident, _iaSet), _ftCnt(p.ident), true);
    html+=_ftBloco('Motor e câmbio', _ftKvSec('', p.motor, _iaSet), _ftCnt(p.motor), false);
    html+=_ftBloco('Desempenho', _ftKvSec('', p.desemp, _iaSet), _ftCnt(p.desemp), false);
    html+=_ftBloco('Dimensões e capacidades', _ftKvSec('', p.dim, _iaSet), _ftCnt(p.dim), false);
    html+=_ftBloco('Freios e suspensão', _ftKvSec('', p.chassi, _iaSet), _ftCnt(p.chassi), false);
    html+=_ftBloco('Equipamentos (série e opcionais)', _ftEquipHtml(p.equip, resumo.marcados, resumo.desmarcados, _eqIA), _eqCnt, false);
    html+='<div id="ftIAload"></div>';
    html+='<button type="button" id="ftPdf" class="pdf-btn" style="margin-top:14px">'+ICO_PDF+' Baixar em PDF</button>';
    /* v243: texto de rodapé da ficha removido (pedido) — a tarja azul
       "Gerado por IA" já diz o que precisa. v244: ela fica AQUI no final. */
    html+=_ftAvisoIA(_iaInfo);
    return html;
  }
  /* liga os checkboxes de opcionais: salva o que foi marcado e (se o carro já
     estiver no repasse) atualiza o anúncio na hora. */
  function ligarFichaOpcionais(container, placa){
    if(!container||!placa) return;
    Array.prototype.forEach.call(container.querySelectorAll('.ft-opc-chk'), function(chk){
      chk.onchange=function(){
        var nome=chk.getAttribute('data-opc');
        var r=fichaResumoLer(placa)||{marcados:[]}; var m=r.marcados||[];
        if(chk.checked){ if(m.indexOf(nome)<0) m.push(nome); } else { m=m.filter(function(n){ return n!==nome; }); }
        r.marcados=m; fichaResumoSalvar(placa, r);
        try{ fichaRepasseAtualiza(placa); }catch(_){}
        /* A presença do teto solar participa da mesma régua automática de
           liquidez usada por ar e direção. Recalcula e persiste na hora. */
        try{ if(typeof calcAvaliacao==='function') calcAvaliacao(); }catch(_){}
        try{ if(typeof avFormSalvar==='function') avFormSalvar(); }catch(_){}
      };
    });
    /* série: desmarcar = "este carro não tem" (some do anúncio e do PDF) */
    Array.prototype.forEach.call(container.querySelectorAll('.ft-serie-chk'), function(chk){
      chk.onchange=function(){
        var nome=chk.getAttribute('data-serie');
        var r=fichaResumoLer(placa)||{}; var dm=r.desmarcados||[];
        if(chk.checked){ dm=dm.filter(function(n){ return n!==nome; }); }
        else { if(dm.indexOf(nome)<0) dm.push(nome); }
        r.desmarcados=dm; fichaResumoSalvar(placa, r);
        var lb=chk.closest('label'); if(lb){ lb.style.opacity=chk.checked?'':'0.45'; var sp=lb.querySelector('span'); if(sp) sp.style.textDecoration=chk.checked?'':'line-through'; }
        try{ fichaRepasseAtualiza(placa); }catch(_){}
      };
    });
  }
  /* se a placa já está publicada no repasse, atualiza o bloco da ficha no anúncio */
  async function fichaRepasseAtualiza(placa){
    if(!meuId||!placa) return;
    try{
      var ex=await repassePublicadaDaPlaca(placa); if(!ex) return;
      var cur=await supa.from('repasse').select('veiculo').eq('id',ex.id).limit(1);
      var veic=(cur&&cur.data&&cur.data[0]&&cur.data[0].veiculo)||{};
      veic.ficha=fichaParaRepasse(placa);
      await supa.from('repasse').update({ veiculo:veic, atualizado_em:new Date().toISOString() }).eq('id',ex.id);
    }catch(_){}
  }
  /* monta o objeto da ficha que vai pro anúncio (só marcados nos opcionais) */
  function fichaParaRepasse(placa){
    var r=fichaResumoLer(placa); if(!r) return null;
    var f={ motor:r.motor||'', cambio:r.cambio||'', serie:(r.serie||[]).filter(function(n){ return (r.desmarcados||[]).indexOf(n)<0; }).slice(0,20), opcionais:(r.marcados||[]) };
    if(!f.motor&&!f.cambio&&!f.serie.length&&!f.opcionais.length) return null;
    return f;
  }
  function fichaTecCanvas(dd){
    var p=fichaTecParse(dd);
    var docm=''; (p.ident||[]).forEach(function(r){ if(r[0]==='Placa'&&r[1]) docm=r[1]; });
    var modelo=''; (p.ident||[]).forEach(function(r){ if(r[0]==='Veículo'&&r[1]) modelo=r[1]; });
    var W=1000, pad=44, iw=W-2*pad;
    var cv=document.createElement('canvas'); cv.width=W; cv.height=6000; var g=cv.getContext('2d');
    g.fillStyle='#ffffff'; g.fillRect(0,0,W,6000); g.textAlign='left';
    var HH=182;
    g.fillStyle='#001e50'; g.fillRect(0,0,W,HH); g.fillStyle='#0a4da6'; g.fillRect(0,HH-6,W,6);
    g.fillStyle='#9fc3ff'; g.font='700 23px system-ui,-apple-system,Arial'; g.fillText('FICHA TÉCNICA', pad, 50);
    g.font='500 21px system-ui,-apple-system,Arial'; g.textAlign='right'; g.fillText('Gerado em '+histData(Date.now()), W-pad, 50); g.textAlign='left';
    g.fillStyle='#ffffff'; g.font='800 54px system-ui,-apple-system,Arial'; g.fillText(docm||modelo||'Veículo', pad, 118);
    g.fillStyle='#cfe0ff'; g.font='500 22px system-ui,-apple-system,Arial'; g.fillText(docm?modelo:'Especificações oficiais do modelo', pad, 154);
    var y=HH+34;
    function sec(titulo,rows){
      rows=(rows||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); });
      if(!rows.length) return;
      _accTit(g,titulo,pad,y); y+=24; var pd=18;
      var hs=rows.map(function(r){ g.font='700 21px system-ui,-apple-system,Arial'; var lng=String(r[1]).length>30; var lines=lng?_wrapLines(g,String(r[1]),iw-2*pd):[String(r[1])]; return {lng:lng,lines:lines,h: lng?(24+lines.length*26+10):46}; });
      var total=hs.reduce(function(a,b){return a+b.h;},0)+10;
      g.fillStyle='#f8fafc'; _rr(g,pad,y,iw,total,16); g.fill(); g.strokeStyle='#eef2f7'; g.lineWidth=1.5; _rr(g,pad,y,iw,total,16); g.stroke();
      var ry=y+7;
      rows.forEach(function(r,i){
        if(hs[i].lng){
          g.fillStyle='#64748b'; g.font='500 18px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(String(r[0]).toUpperCase(), pad+pd, ry+20);
          g.fillStyle='#0f172a'; g.font='700 21px system-ui,-apple-system,Arial'; var vy=ry+20+26; hs[i].lines.forEach(function(ln){ g.fillText(ln,pad+pd,vy); vy+=26; });
        } else {
          var mid=ry+23; g.fillStyle='#64748b'; g.font='500 20px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(r[0], pad+pd, mid+6);
          var vf=21; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; while(g.measureText(String(r[1])).width>iw*0.5&&vf>13){ vf--; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; }
          g.fillStyle='#0f172a'; g.textAlign='right'; g.fillText(String(r[1]), W-pad-pd, mid+6); g.textAlign='left';
        }
        if(i<rows.length-1){ g.strokeStyle='#f1f5f9'; g.lineWidth=1.5; g.beginPath(); g.moveTo(pad+pd,ry+hs[i].h-2); g.lineTo(W-pad-pd,ry+hs[i].h-2); g.stroke(); }
        ry+=hs[i].h;
      });
      y+=total+28;
    }
    sec('Identificação', p.ident);
    sec('Motor e câmbio', p.motor);
    sec('Desempenho', p.desemp);
    sec('Dimensões e capacidades', p.dim);
    sec('Freios e suspensão', p.chassi);
    if(p.equip&&p.equip.length){
      var _resPdf=fichaResumoLer(_fichaPlaca(p))||{}; var _desmPdf=_resPdf.desmarcados||[];
      var _serie=p.equip.filter(function(e){ return !/OPCION|INDISPON/.test(e.disp) && _desmPdf.indexOf(e.nome)<0; });
      var _opc=p.equip.filter(function(e){ return /OPCION/.test(e.disp); });
      var equipBloco=function(titulo, arr, cores, mark){
        if(!arr.length) return;
        _accTit(g,titulo+' ('+arr.length+')',pad,y); y+=24;
        var rH=46, ch=arr.length*rH+12;
        g.fillStyle='#f8fafc'; _rr(g,pad,y,iw,ch,16); g.fill(); g.strokeStyle='#eef2f7'; g.lineWidth=1.5; _rr(g,pad,y,iw,ch,16); g.stroke();
        var ey=y+6;
        arr.forEach(function(e,i){ var mid=ey+rH/2;
          g.fillStyle=cores[0]; g.beginPath(); g.arc(pad+30,mid,11,0,Math.PI*2); g.fill();
          g.fillStyle=cores[1]; g.font='900 15px system-ui,-apple-system,Arial'; g.textAlign='center'; g.fillText(mark,pad+30,mid+5); g.textAlign='left';
          g.fillStyle=(mark==='–'?'#94a3b8':'#0f172a'); g.font='600 21px system-ui,-apple-system,Arial'; g.fillText(e.nome, pad+52, mid+7);
          if(i<arr.length-1){ g.strokeStyle='#f1f5f9'; g.lineWidth=1.5; g.beginPath(); g.moveTo(pad+20,ey+rH); g.lineTo(W-pad-20,ey+rH); g.stroke(); }
          ey+=rH;
        });
        y+=ch+24;
      };
      equipBloco('Equipamentos de série', _serie, ['#dcfce7','#15803d'], '✓');
      equipBloco('Opcionais', _opc, ['#fef3c7','#b45309'], '◐');
    }
    g.fillStyle='#94a3b8'; g.font='400 18px system-ui,-apple-system,Arial'; g.textAlign='center';
    var _iaPdf=(p.raw&&p.raw._ia)||null;
    y=_wrapText(g,'Ficha técnica oficial do modelo.'+(_iaPdf?' Parte das informações foi obtida por pesquisa na web feita por inteligência artificial (não são dados oficiais) — confira antes de usar em documento.':'')+' Valores de fábrica podem variar por versão.', W/2, y+8, iw-40, 26)+12;
    g.textAlign='left';
    var out=document.createElement('canvas'); out.width=W; out.height=Math.min(6000,Math.max(480,y)); out.getContext('2d').drawImage(cv,0,0); return out;
  }
  /* v184 — passou a aceitar a ficha por parametro (_dd). Assim a aba
     "Ficha tecnica" do ESTOQUE tambem consegue baixar o PDF: ela manda a ficha
     daquele carro. Sem parametro, continua usando a da tela de consulta. */
  function fichaTecBaixarPDF(_dd){
    if(!_mevPdfPronto(function(){ fichaTecBaixarPDF(_dd); },false)) return;
    var _fonte=_dd||fichaTecState||{};
    try{
      var cv=fichaTecCanvas(_fonte);
      var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'pt',format:'a4'});
      var pw=pdf.internal.pageSize.getWidth(), ph=pdf.internal.pageSize.getHeight(), m=20, iw=pw-2*m;
      var pageH=Math.floor(cv.width*(ph-2*m)/iw), sy=0, first=true;
      while(sy<cv.height){
        var sh=Math.min(pageH, cv.height-sy);
        var tmp=document.createElement('canvas'); tmp.width=cv.width; tmp.height=sh;
        tmp.getContext('2d').drawImage(cv,0,sy,cv.width,sh,0,0,cv.width,sh);
        if(!first) pdf.addPage();
        pdf.addImage(tmp.toDataURL('image/jpeg',0.92),'JPEG',m,m,iw,iw*sh/cv.width);
        sy+=sh; first=false;
      }
      var pl=fichaTecParse(_fonte); var pp=''; (pl.ident||[]).forEach(function(r){ if(r[0]==='Placa'&&r[1]) pp=r[1]; });
      var nome='FichaTecnica-'+String(pp||'veiculo').replace(/[^A-Z0-9]/gi,'').slice(0,8)+'.pdf';
      /* v244: mostra o PDF na tela (visor padrão) em vez de baixar direto */
      var _blob=pdf.output('blob');
      /* 🔴 v615 — a prévia como IMAGEM, não como iframe (o iframe cortava a
         lateral no iPhone; ver a nota inteira no pdfEntregar do 06). Esta
         tela ganha de graça: o desenho da ficha JÁ é um canvas (o mesmo `cv`
         que virou as páginas do PDF acima), então é só entregar ele ao
         relatorioVisor — que por dentro ainda cai no pdfVisor se o desenho
         falhar. */
      try{ if(typeof relatorioVisor==='function'){ relatorioVisor(cv, _blob, nome); return; } }catch(_){}
      try{ if(typeof pdfVisor==='function'){ pdfVisor(_blob, nome); return; } }catch(_){}
      var u=URL.createObjectURL(_blob), a=document.createElement('a'); a.href=u; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },800);
      toast('PDF baixado.');
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }

  /* ---- Tela: Avaliação de troca ---- */
  function abrirAvaliacao(){
    var v=veiculoAtual; if(!v) return abrirMenu();
    irTela(panelHead(ICO.aval,'blue','Avaliação — '+esc(v.placa), subInfoDe(v))+avaliacaoFormHtml(v),'menu');
    atrelarAvaliacao(v);
  }

  /* ---- Tela: Consulta de Leilão ---- */
  function abrirLeilao(){
    mevTabSet('completa');
    var v=veiculoAtual; if(!v) return abrirMenu();
    var inner = leilaoState ? ('<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Consulta completa · última salva</div>'+relInlineHtml()+botaoPDF()+veicAtalhosHtml()+'<button type="button" class="gerar-btn" data-gerar="leilao" style="width:100%;margin-top:8px;background:#eef4ff;color:#0a4da6;border:1px solid #cfe0ff;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">🔄 Atualizar consulta</button>') : ('<button class="gerar-btn" data-gerar="leilao" style="'+BTN_STYLE+'">Gerar</button>');
    irTela(panelHead(ICO.leilao,'blue','Consulta multa/restrições — '+esc(v.placa), subInfoDe(v))+'<div id="leilaoWrap">'+inner+'</div>','menu');
    document.body.classList.remove('md-veiculo');   /* tela cheia: esconde a coluna da esquerda (home) */
  }

  /* ---- Tela: DÉBITOS do veículo (IPVA, licenciamento, multas com valor) ---- */
  var _DEB_ATUALIZAR='<button type="button" class="deb-btn" data-debitos="1" style="width:100%;margin-top:8px;background:#eef4ff;color:#0a4da6;border:1px solid #cfe0ff;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">🔄 Atualizar débitos</button>';
  function abrirDebitos(){
    mevTabSet('completa');
    var v=veiculoAtual;
    if(!v){ voltarHome(); _pendMarcar('debitos'); toast('Digite a placa para consultar os débitos.'); var p=$('placa'); if(p){ try{ p.focus(); }catch(_){} } return; }
    var inner = debitosState
      ? ('<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Débitos consultados</div>'+debitosPanelHtml(debitosState)+_DEB_ATUALIZAR)
      : ('<button class="deb-btn" data-debitos="1" style="'+BTN_STYLE+'">Consultar débitos</button>');
    irTela(panelHead(ICO.valor,'blue','Débitos do veículo — '+esc(v.placa), subInfoDe(v))+'<div id="debitosWrap">'+inner+'</div>','menu');
  }
  /* botão que aparece DENTRO da consulta completa quando há multas/pendências */
  function debitosBotaoHtml(){
    try{ var ex=leilaoState?relVeicExtrai(leilaoState):null; if(!ex||!ex.temAlerta) return ''; }catch(_){ return ''; }
    return '<button type="button" class="deb-btn" data-debitos="ir" style="width:100%;margin-top:8px;background:#fff1f1;color:#b91c1c;border:1px solid #fecaca;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">Consultar valores dos débitos</button>';
  }
  async function gerarDebitos(btn){
    if(!veiculoAtual) return;
    var content=$('debitosWrap'); if(!content) content=btn.parentNode;
    content.innerHTML=ccLoaderHtml('Consultando débitos…',_debFrases); var lt=ccLoaderStart(_debFrases);
    var d=await consultarComRetry({produto:'debitos',placa:veiculoAtual.placa},1);
    clearInterval(lt);
    if(d&&d.sem_saldo){ setSaldo(d.saldo); abrirDebitos(); abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){ abrirDebitos(); var w=$('debitosWrap'); if(w) w.insertAdjacentHTML('beforeend','<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Não foi possível concluir a consulta agora. Tente de novo em instantes.'+(d&&d.estornado?' O valor foi devolvido ao seu saldo.':'')+'</div>'); return; }
    debitosState=d.resultado;
    content.innerHTML='<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Débitos consultados</div>'+debitosPanelHtml(debitosState)+_DEB_ATUALIZAR;
    var _ab=content.querySelector('.deb-btn'); if(_ab) _ab.onclick=function(){ gerarDebitos(_ab); };
  }
  /* formata dinheiro e lê números vindos como número ou string "R$ 1.234,56" */
  function _brl(n){ return 'R$ '+Number(n||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function _debNum(x){
    if(x==null) return NaN;
    if(typeof x==='number') return x;
    var s=String(x).trim().replace(/r\$/ig,'').replace(/\s/g,'');
    if(/,\d{1,2}$/.test(s)){ s=s.replace(/\./g,'').replace(',','.'); } else { s=s.replace(/,/g,''); }
    var n=parseFloat(s.replace(/[^\d.-]/g,''));
    return isNaN(n)?NaN:n;
  }
  /* procura no objeto o maior campo "total*" (total de débitos) */
  function _debBuscaTotal(o){
    var found=null;
    (function walk(x){ if(!x||typeof x!=='object') return;
      Object.keys(x).forEach(function(k){ var v=x[k];
        if(/total|geral|somat/i.test(k) && (typeof v==='number'||(typeof v==='string'&&/\d/.test(v)))){ var n=_debNum(v); if(!isNaN(n)&&(found==null||n>found)) found=n; }
        else if(v&&typeof v==='object') walk(v);
      });
    })(o);
    return found;
  }
  function debitosPanelHtml(dd){
    dd=dd||{};
    var base=(dd.data&&(dd.data.debitos||dd.data))||dd.debitos||dd;
    var total=_debBuscaTotal(dd);
    var html='';
    if(total!=null){
      html+='<div style="background:#fff6f6;border:1px solid #fecaca;border-radius:14px;padding:14px;margin:6px 0 10px;text-align:center"><div style="font-size:12px;color:#991b1b;font-weight:700;text-transform:uppercase;letter-spacing:.4px">Total de débitos em aberto</div><div style="font-size:26px;font-weight:800;color:#b91c1c;margin-top:4px">'+_brl(total)+'</div></div>';
    }
    html+='<div class="kv-card" style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:12px 14px;box-shadow:0 3px 12px rgba(2,20,60,.06)">'+renderVal(base)+'</div>';
    html+='<div class="plc-msg" style="font-size:11px;color:#94a3b8;margin-top:6px">Valores informados pela base oficial na data da consulta. Confirme no DETRAN/SEFAZ antes de qualquer pagamento.</div>';
    return html;
  }

  /* ---- Tela: CONSULTE CPF / CNPJ (detalhamento negativo — restrições) ---- */
  function fmtCpfCnpj(s){
    var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,14);
    if(d.length<=11){ var o=d.slice(0,3); if(d.length>3)o+='.'+d.slice(3,6); if(d.length>6)o+='.'+d.slice(6,9); if(d.length>9)o+='-'+d.slice(9,11); return o; }
    var c=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5,8)+'/'+d.slice(8,12); if(d.length>12)c+='-'+d.slice(12,14); return c;
  }
  /* v387: o MIOLO e a FIAÇÃO da consulta de CPF viraram funções separadas,
     porque agora eles são usados em DOIS lugares: na página (celular) e na
     coluna da tela inicial (computador). A página continua igualzinha. */
  /* ===== v601 — A TELA DO CPF EM QUATRO CARDS ==========================
     (PROJETO-2026-08-24-cpf-quatro-cards-exemplo-e-historico)
     Pedido do Angelo, com print do iPhone:
       1. o campo animado de digitar o CPF nasce ESCONDIDO;
       2. o aceite LGPD desce pra baixo do card "CPF restrições";
       3. os campos RG e UF saem de dentro do card;
       4. ordem nova: CPF restrições → LGPD → Ações e processos →
          Score bancário → NOVO card Histórico;
       5. tocar em QUALQUER card é o que abre o campo pra digitar.
     Motivo por trás do 1 e do 5: a tela abria com um campo pedindo CPF
     antes de o lojista escolher O QUE quer consultar. Agora ele escolhe
     primeiro (o card), e só então o app pede o número.
     6. cada card pago ganhou "Ver exemplo (PDF)" — dados FICTÍCIOS, sem
        cobrar token nenhum e sem entrar no histórico (ver _cpf3VerExemplo). */
  /* ===== v613 — UMA CONSULTA POR PÁGINA =================================
     Pedido do Angelo (24/08): "vamos separar cada consulta em uma pagina,
     cpf, acoes e processos, score bancario ... cada pagina mesmo formato da
     consulta cpf - só fica uma consulta em cada pagina".

     A página do CPF juntava três produtos pagos numa pilha. Cada um tem
     preço, lista, exemplo e relatório próprios — juntos viravam uma parede
     de escolha. Agora são TRÊS PÁGINAS irmãs, no mesmo desenho, e cada uma
     responde uma pergunta só.

     🔑 UM DESENHO SÓ, TRÊS PÁGINAS. Nada foi duplicado: o que muda entre
     elas cabe nesta tabela, e o resto (campo do CPF, LGPD, resultado,
     histórico, exemplo, PDF) é o mesmo código de sempre. Card novo no
     futuro = uma linha aqui.
     ⚠️ Os IDs dos botões continuam os MESMOS (#restBt3 · #cpfProcBt ·
     #cpfScoreBt): a fiação, os testes e o histórico seguem valendo. */
  var CPF_PAGS = {
    restricao:{ tdoc:'', aba:'cpf', titulo:'Consulta CPF', sub:'Cadastro, pendências e score bancário',
      /* v897: `rgUf` virou false — a fonte que os pedia (antecedentes) saiu.
         A chave FICA em vez de sumir: é ela que responde "esta página tem
         campos extras?", e uma consulta nova pode precisar de outros amanhã. */
      card:'Consulta CPF', bt:'restBt3', ex:'cpfExRest', tok:8.20, rgUf:false,
      itens:['Nome, nascimento, mãe e situação na Receita Federal',
             'Pendências financeiras com credor, valor e data',
             'Protestos em cartório',
             'Ações cíveis e cheques sem fundo',
             /* v897: "Antecedentes criminais (com RG e UF)" saiu desta lista
                junto com a fonte. Esta lista é o "O QUE A CONSULTA INCLUI" da
                tela — é PROMESSA, não decoração. Deixá-la prometendo o que a
                consulta não entrega mais seria a pior sobra possível desta
                remoção, porque o lojista paga os 5 tokens contando com ela. */
             'Participação em empresas',
             'Score bancário, faixa e exposição de crédito',
             'Valores a vencer, vencidos e em prejuízo'] },
    proc:{ tdoc:'CPF_PROCESSOS', aba:'cpfproc', titulo:'Ações e processos', sub:'Processos judiciais e o polo da pessoa',
      card:'Ações e processos', bt:'cpfProcBt', ex:'cpfExProc', tok:5.43, rgUf:false,
      /* v1024 — a lista cresceu porque o RELATÓRIO cresceu: o resumo novo
         (em tramitação × arquivados, polo, ramo, valor de causa) é desenhado
         de verdade pelo cpfProcPaginas. Promessa, não decoração. */
      itens:['Quantos processos, e quantos ainda estão em tramitação',
             'Se ela é RÉU ou AUTOR em cada um',
             'Classe, assunto e ramo do direito',
             'Tribunal, vara, UF, situação, data e valor da causa'] },
    score:{ tdoc:'CPF_SCORE_BACEN', aba:'cpfscore', titulo:'Score bancário', sub:'Pontuação e operações no sistema financeiro',
      card:'Score bancário', bt:'cpfScoreBt', ex:'cpfExScore', tok:5.70, rgUf:false,
      itens:['Pontuação com a faixa (bom · regular · ruim)',
             'Total a vencer, vencido e em prejuízo',
             'Dívidas por modalidade (empréstimo, cartão, financiamento)',
             'Quantas instituições e operações, e desde quando'] }
  };
  var _cpfPagAtual='restricao';
  /* ===== v752 — PADRÃO UNIFICADO, Versão D: FAMÍLIA CPF ==================
     docs/PROJETO-2026-08-29-padrao-unificado-paginas-de-consulta.txt
     As três páginas (CPF restrições · Ações e processos · Score bancário)
     passam pra casca do 02c, como a Busca (v747), a Plus (v750) e a família
     veículo (v751). O que mudou é só a COMPOSIÇÃO — a fiação (restricaoWire),
     a porta (_cpf3Pronto: CPF completo + LGPD aceita), o histórico, o exemplo
     e os PDFs continuam os mesmos, com os MESMOS IDs.
       · etapa 1 "CPF": o campo animado de sempre (restDoc/restDocX/restProg/
         restField/restRefaz/restDocHist); RG e UF só na página de restrições;
       · etapa 2 "Proteção de dados (LGPD)": o aceite fica VISÍVEL e
         OBRIGATÓRIO, dentro do card, antes do botão — nunca escondido;
       · "O que a consulta inclui" em SVG (consultaUiBeneficios);
       · a lupa ao lado do CPF é a única ação visível. O CTA id=P.bt continua
         como controlador oculto do fluxo e dos estados, nasce desligado e só
         liga com CPF completo + LGPD marcada. A lupa espelha esse estado e
         NUNCA dispara sozinha (regra nº 1 da casa, v585);
       · "Ver exemplo (PDF)" dentro do card (não é consulta, não custa);
       · linha de confiança com a LGPD; #restResult; #restHist;
       · "Outras consultas" da família CPF DEPOIS do card, sem a própria.
     A coluna .cpf3-cards saiu: o resultado nasce no lugar de sempre
     (#restResult, logo abaixo do botão) e o card não some (_cpf3Foco e
     _cpf3Desfoca continuam no código e voltam sozinhos se a coluna voltar). */
  function restricaoInnerHtml(qual){
    var P=CPF_PAGS[qual]||CPF_PAGS.restricao;
    var jaExplicou=consultaUiTemLanding(P.aba);
    var campo='<div id="restFieldWrap" class="cpf-campo-entra" data-aberto="1">'
      +'<div style="display:flex;gap:8px;align-items:stretch">'
        +'<div class="cnpj-field" id="restField" style="flex:1;min-width:0;margin-top:0">'
          +'<input id="restDoc" class="cnpj-inp" data-consulta-anim="cpf" inputmode="numeric" autocomplete="off" placeholder="000.000.000-00" aria-label="CPF" data-cu-min="14">'
          +'<button type="button" id="restDocX" class="cpf3-x" aria-label="Limpar o CPF" title="Limpar">'
            +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6 6 18"/></svg>'
          +'</button>'
          +'<div class="cnpj-prog"><i id="restProg"></i></div>'
        +'</div>'
        +'<button type="button" id="restRefaz" class="doc-refaz" disabled title="Buscar CPF" aria-label="Buscar CPF"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.2" y2="16.2"/></svg></button>'
      +'</div>'
      +'<div id="restDocHist" class="cpf3-veio" style="display:none" role="status">'
        +'<span class="cpf3-veio-ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v6h6"/><path d="M12 7v5l3 2"/></svg></span><span>CPF trazido do histórico — confira antes de consultar</span>'
      +'</div>'
      /* 🔴 v897 — OS CAMPOS RG E UF NÃO NASCEM MAIS EM PÁGINA NENHUMA.
         Eles existiam só pra fonte de antecedentes criminais (v604/v607), que
         saiu do pacote nesta versão a pedido do Angelo. Eram dois campos numa
         linha inteira do formulário que, na prática, quase nunca eram
         preenchidos — o lojista não tem o RG do cliente na mão — e sem eles a
         fonte nem rodava. O `P.rgUf` continua sendo a chave que decide, e hoje
         nenhuma página a liga: o bloco abaixo fica pronto pra próxima consulta
         que precisar de campo extra, sem ninguém ter que reescrevê-lo. */
      +(P.rgUf
        ? ('<div class="cpf3-rg">'
            +'<div class="cnpj-field tem" style="flex:1;min-width:0;margin-top:0"><input id="restRg" class="cnpj-inp" inputmode="numeric" autocomplete="off" placeholder="RG (opcional)" aria-label="RG (opcional)" maxlength="20"></div>'
            +'<div class="cnpj-field tem cpf3-uf" style="margin-top:0"><input id="restUf" class="cnpj-inp" autocomplete="off" placeholder="UF" aria-label="UF" maxlength="2"></div>'
          +'</div>')
        : '')
    +'</div>';
    var lgpd='<div id="restLgpdWrap">'
      +'<label for="restLgpd" id="restLgpdCard" class="consulta-ui-lgpd">'
        +'<input type="checkbox" id="restLgpd"'+(_lgpdCpfAceito()?' checked':'')+'>'
        +'<span><b>Proteção de dados (LGPD).</b> Declaro ter finalidade legítima e autorização/base legal para consultar este CPF, e que usarei os dados só para essa análise, conforme a Lei nº 13.709/2018 (LGPD). Assumo a responsabilidade pelo uso das informações.</span>'
      +'</label>'
      +'<div id="restLgpdOk" class="consulta-ui-lgpd-ok" style="display:none">'
        +'<span>'+_CU_CHECK+'Proteção de dados (LGPD) aceita</span>'
        +'<button type="button" id="restLgpdRever">rever</button>'
      +'</div>'
    +'</div>';
    var form=consultaUiEtapa(1,'CPF', campo)
      +consultaUiEtapa(2,'Proteção de dados (LGPD)', lgpd, { nota:'obrigatório' })
      +(jaExplicou?'':consultaUiBeneficios(P.itens))
      /* O controlador permanece no DOM para preservar confirmação, estados e
         integrações antigas, mas a lupa é a única ação visível. */
      +consultaUiCta({ id:P.bt, preco:P.tok, disabled:true }).replace('<button ','<button hidden aria-hidden="true" tabindex="-1" ')
      /* v775: card virou <div> com os dois ícones (visualizar + baixar) */
      +(jaExplicou?'':'<div id="'+P.ex+'" class="cpf3-ex consulta-ui-exemplo">'
        +'<span class="cpf3-mini" data-ex="'+qualEsc(qual)+'"></span>'
        +'<span class="cpf3-ex-tx"><b>Ver exemplo (PDF)</b><i>dados fictícios · não cobra nada</i></span>'
        +consultaUiExemploAcoes(P.ex)
      +'</div>')
      +consultaUiTrust('Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018) · dados informados pela base na data da consulta')
      /* o botão antigo continua no DOM, escondido: é ele que o gerarRestricao desabilita/reabilita */
      +'<button class="rest-btn" style="'+BTN_STYLE+';display:none">Consultar CPF</button>'
      +'<div id="restResult" aria-live="polite"></div>'
      +consultaUiHistoricoCard('restHist',{ texto:'As consultas ficam no histórico por 24 horas e depois são removidas do histórico' });
    form=form.replace('id="'+P.bt+'"','id="'+P.bt+'" data-cu-reqs="restDoc,restLgpd"');
    var pref={ restricao:['cpfproc'], proc:['cpf'], score:['cpf','cpfproc'] }[qual]||[];
    return consultaUiCard(form, { id:'cpfWrap' })+consultaUiRelacionadas(P.aba,'cpf',{ preferir:pref });
  }
  function qualEsc(q){ return (CPF_PAGS[q]?q:'restricao'); }
  function _cpfOutrasHtml(qual){
    var outras=Object.keys(CPF_PAGS).filter(function(k){ return k!==qual; });
    if(!outras.length) return '';
    return '<div class="cpf-outras">'
      +'<div class="cpf-outras-t">Outras consultas deste CPF</div>'
      +outras.map(function(k){ var P=CPF_PAGS[k];
        return '<button type="button" class="cpf-outra" data-pag="'+k+'">'
          +'<span class="cpf-outra-nm">'+esc(P.card)+'</span>'
          +'<span class="cpf-outra-pr">'+_cpf3Tok(P.tok)+'</span>'
          +'<span class="cpf-outra-ch">›</span></button>';
      }).join('')
    +'</div>';
  }
  /* v613: a MESMA função abre as três páginas — muda o que vem da tabela
     CPF_PAGS. Chamada sem argumento (todo atalho antigo do app) continua
     abrindo a de sempre, o CPF restrições. */
  function abrirRestricao(qual){
    qual=qualEsc(qual); _cpfPagAtual=qual;
    var P=CPF_PAGS[qual];
    /* v752 — Versão D do padrão (02c): celular sem grade antes do formulário; computador com a barrinha lateral */
    consultaUiPagina({ chave:P.aba, tab:'completa', voltar:'home', ico:(typeof _CT_ICO!=='undefined'&&_CT_ICO[P.aba])||ICO.valor, cor:'blue', titulo:P.titulo, sub:P.sub },
      '<div id="restWrap">'+restricaoInnerHtml(qual)+'</div>');
    restricaoWire();
    try{ consultaUiSync(); }catch(_){}
  }
  /* v613 — pular pra outra consulta LEVANDO o CPF digitado.
     🔴 Só o número viaja, e ele cai no campo escondido do outro jeito de
     sempre: a página nova abre com o campo ABERTO e preenchido, e o toque
     seguinte é que consulta. A trava do "nada dispara sozinho" continua. */
  function cpfIrPara(qual){
    var i=$('restDoc'); var dg=i?String(i.value||'').replace(/\D/g,''):'';
    abrirRestricao(qual);
    if(dg.length===11){ try{ _cpf3DoHistorico(dg); }catch(_){} }
  }
  function restricaoWire(){
    var inp=$('restDoc'); if(inp){
      var _restAuto='';
      /* pinta o campo conforme os 11 numeros vao entrando */
      var _restPinta=function(dg){
        var f=$('restField'), pr=$('restProg'); if(!f) return;
        f.classList.toggle('tem', dg.length>0);
        if(pr) pr.style.width=Math.min(100,Math.round(dg.length/11*100))+'%';
        var cheio=(dg.length===11);
        if(cheio && !f.classList.contains('full')){ f.classList.add('full','flash'); setTimeout(function(){ f.classList.remove('flash'); },620); }
        if(!cheio) f.classList.remove('full');
      };
      /* 🔴 v599 — O DISPARO AUTOMÁTICO SAIU. Ele existia desde a v166 (11
         números + LGPD aceita = consulta na hora), e fazia sentido quando a
         página tinha UMA consulta. Com TRÊS cards pagos na mesma tela, sair
         sozinho seria escolher no lugar do lojista qual delas cobrar.
         Agora o campo só PINTA; quem consulta é o dedo, em um dos cards.
         (O `_restAuto` fica como marca do último CPF digitado — quem
         quiser reativar o automático religa a chamada aqui.) */
      var _restTry=function(){ inp.value=_fmtCpf(inp.value); var dg=inp.value.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); _restPinta(dg);
        _restAuto = (dg.length===11) ? dg : '';
        try{ _cpf3XSync(); }catch(_){}   /* v611 */
        try{ consultaUiSync(); }catch(_){}   /* v752: o botão acompanha CPF + LGPD */
        try{ _cpf3BuscaSync(); }catch(_){} };
      inp.oninput=_restTry;
      inp.addEventListener('paste',function(){ setTimeout(_restTry,0); });
      /* v387: dentro da coluna do computador ninguém "rouba" o foco da placa */
      /* v618: com o campo nascendo aberto, focar no celular jogaria o
         teclado por cima da tela na chegada. No computador o foco continua
         (lá ele só economiza um clique e não tapa nada). */
      try{ if(!(inp.closest&&inp.closest('#consCols')) && !(window.matchMedia&&matchMedia('(pointer:coarse)').matches)) inp.focus(); }catch(_){}
    }
    var chk=$('restLgpd'); if(chk) chk.onchange=function(){ try{ localStorage.setItem('mev_lgpd_cpf', chk.checked?'1':'0'); }catch(_){} _restLgpdSync(); try{ consultaUiSync(); }catch(_){} try{ _cpf3BuscaSync(); }catch(_){}
      /* v599: aceitar a LGPD NÃO dispara mais nada — só libera os três cards */
    };
    var rev=$('restLgpdRever'); if(rev) rev.onclick=function(){ var card=$('restLgpdCard'), ok=$('restLgpdOk'); if(card) card.style.display='flex'; if(ok) ok.style.display='none'; try{ $('restLgpd').focus(); }catch(_){} };
    _restLgpdSync();
    var b=$('restWrap')?$('restWrap').querySelector('.rest-btn'):null; if(b) b.onclick=function(){ gerarRestricao(b); };
    /* v599 — os TRÊS cards. Cada um confere CPF + LGPD (a mesma porta) e
       só então chama a consulta dele. Um toque = uma consulta, sempre. */
    /* 🔴 v601 — O PRIMEIRO TOQUE SÓ ABRE O CAMPO.
       O campo animado nasce escondido (#restFieldWrap). Tocar em qualquer
       um dos quatro botões REVELA o campo, rola até ele, foca — e PÁRA.
       O toque seguinte, com o campo já visível, segue o caminho de sempre
       (_cpf3Pronto valida CPF completo + LGPD). Ou seja: continua valendo a
       regra nº 1 da casa (v585) — consulta paga nunca sai sozinha; agora
       tem até um toque a mais antes dela. */
    var _bt3=$('restBt3'); if(_bt3 && b) _bt3.onclick=function(){ if(_cpf3AbrirCampo()) return; gerarRestricao(b, _bt3); };
    var _bsc=$('cpfScoreBt'); if(_bsc) _bsc.onclick=function(){ if(_cpf3AbrirCampo()) return; gerarCpfExtra('cpf_score_bacen', _bsc); };
    var _bpr=$('cpfProcBt'); if(_bpr) _bpr.onclick=function(){ if(_cpf3AbrirCampo()) return; gerarCpfExtra('cpf_processos', _bpr); };
    /* v601 — "Ver exemplo (PDF)": NÃO passa pela porta nem pelo campo.
       Não é consulta, não custa token, não grava histórico. */
    var _exr=$('cpfExRest'); if(_exr) _exr.onclick=function(){ _cpf3VerExemplo('restricao'); };
    var _exp=$('cpfExProc'); if(_exp) _exp.onclick=function(){ _cpf3VerExemplo('proc'); };
    var _exs=$('cpfExScore'); if(_exs) _exs.onclick=function(){ _cpf3VerExemplo('score'); };
    /* v775: os dois ícones de cada card do exemplo (visualizar + baixar) */
    [['cpfExRest','restricao'],['cpfExProc','proc'],['cpfExScore','score']].forEach(function(par){
      var v=$(par[0]+'Ver'); if(v) v.onclick=function(ev){ ev.stopPropagation(); _cpf3VerExemplo(par[1]); };
      var b=$(par[0]+'Bx'); if(b) b.onclick=function(ev){ ev.stopPropagation(); _cpf3BaixarExemplo(par[1]); };
    });
    /* a UF em maiúscula enquanto digita (a base recusa minúscula) */
    /* v897: a máscara do campo UF saiu junto com o campo. */
    /* v1346 — a lupa é a ação única das três páginas de CPF. O controlador
       oculto conserva a confirmação de valor, bloqueio de toque duplo e os
       estados de erro/carregamento já usados por cada produto. */
    var _bx=$('restDocX'); if(_bx) _bx.onclick=function(){ _cpf3Limpar(); };   /* v611 */
    /* v613 — os atalhos pras outras duas consultas, no pé da página */
    Array.prototype.forEach.call(document.querySelectorAll('.cpf-outra'), function(b){
      b.onclick=function(){ cpfIrPara(b.getAttribute('data-pag')); };
    });
    try{ _cpf3XSync(); }catch(_){}
    var rfz=$('restRefaz'); if(rfz) rfz.onclick=function(){
      var P=CPF_PAGS[_cpfPagAtual]||CPF_PAGS.restricao, acao=$(P.bt);
      if(!acao || acao.disabled){ _cpf3Pronto(); return; }
      try{ $('restDoc').blur(); }catch(_){}
      if(typeof acao.onclick==='function') acao.onclick();
      else acao.click();
    };
    try{ _cpf3BuscaSync(); }catch(_){}
    try{ restHistCarregarNuvem(); }catch(_){}
    restHistRender();
    try{ _cpf3Desfoca(); }catch(_){}   /* v608: tela nova = tela de escolha */
    _cpf3HistDoc='';                    /* v611: e sem número herdado */
    /* v603 — as miniaturas por último, fora do caminho da abertura da tela */
    try{ setTimeout(_cpf3MinisPintar, 0); }catch(_){}
  }
  /* mostra o card LGPD completo (se não aceito) ou a barrinha "aceito" (se marcado) */
  function _restLgpdSync(){ var card=$('restLgpdCard'), ok=$('restLgpdOk'), chk=$('restLgpd'); if(!card||!ok||!chk) return; if(chk.checked){ card.style.display='none'; ok.style.display='flex'; } else { card.style.display='flex'; ok.style.display='none'; } }
  /* ---- histórico de CPF na NUVEM (sobrevive a reinstalar o app / troca de aparelho) ---- */
  /* v162 — FILA DE REENVIO.
     Antes, se a gravação na nuvem falhasse (rede caiu, sessão expirou, algum
     caractere estranho dentro do resultado), o erro era ENGOLIDO: a consulta
     feita no computador simplesmente nunca aparecia no celular e ninguém
     ficava sabendo. Agora: 1) o resultado é limpo antes de subir; 2) qualquer
     erro aparece no console; 3) a consulta fica guardada numa fila no próprio
     aparelho e é reenviada sozinha na próxima vez que o app abre. */
  function _cloudLimpa(o){
    /* o Postgres recusa o caractere \u0000 dentro de um campo jsonb — e ele
       aparece de vez em quando no meio dos textos que vem das consultas. */
    try{ return JSON.parse(JSON.stringify(o==null?null:o).replace(/\\u0000/g,'')); }catch(_){ return null; }
  }
  /* v259 — O ERRO DA NUVEM NÃO SOME MAIS.
     Antes, quando o banco recusava a gravação, isso só aparecia no console do
     navegador (ou seja: ninguém via). Agora também vira uma linha na tabela
     mp_erros, que o Angelo lê em Menu → "Erros do app". O mini-sentry já não
     repete a mesma mensagem e para depois de 8 por sessão, então não enche. */
  function _cloudAviso(msg){
    try{ console.warn('[MEV] nuvem: '+msg); }catch(_){}
    try{ if(window.mevErro) window.mevErro('nuvem: '+msg); }catch(_){}
  }
  function _cloudFilaLer(){ try{ return JSON.parse(localStorage.getItem('mev_cloud_fila')||'[]'); }catch(_){ return []; } }
  function _cloudFilaGrava(l){ try{ localStorage.setItem('mev_cloud_fila', JSON.stringify(l.slice(-40))); }catch(_){} }
  function _cloudFilaPoe(reg){ try{ var l=_cloudFilaLer().filter(function(x){ return !(x.tipo===reg.tipo && String(x.chave)===String(reg.chave)); }); l.push(reg); _cloudFilaGrava(l); }catch(_){} }
  function _cloudFilaTira(reg){ try{ _cloudFilaGrava(_cloudFilaLer().filter(function(x){ return !(x.tipo===reg.tipo && String(x.chave)===String(reg.chave)); })); }catch(_){} }
  function cloudFilaEnviar(){
    try{
      if(!(window.supa && meuId)) return;
      var l=_cloudFilaLer(); if(!l.length) return;
      console.log('[MEV] reenviando '+l.length+' consulta(s) que não tinham subido pra nuvem');
      l.forEach(function(reg){ try{ docHistCloudSave(reg.tipo, reg.chave, reg.tipo_doc, reg.resultado, reg.ts, true); }catch(_){} });
    }catch(_){}
  }
  function docHistCloudSave(tipo, chave, tipo_doc, resultado, ts, _daFila){
    var reg={ tipo:tipo, chave:String(chave||''), tipo_doc:tipo_doc||'', resultado:_daFila?resultado:_cloudLimpa(resultado), ts:ts||Date.now() };
    try{
      if(!reg.chave) return;
      /* v1403: uma fila offline não pode ressuscitar um CPF já vencido. */
      if(reg.tipo==='cpf' && typeof CPF_HIST_MS!=='undefined' && reg.ts<=Date.now()-CPF_HIST_MS){ _cloudFilaTira(reg); return; }
      if(!(window.supa && meuId)){ _cloudFilaPoe(reg); return; }
      /* ATENÇÃO: o "builder" do supabase-js tem .then mas NÃO tem .catch —
         chamar ['catch'] dava erro silencioso e a gravação NUNCA acontecia.
         Com .then(ok, erro) a consulta executa de verdade. */
      supa.from('doc_consulta').upsert({ user_id:meuId, tipo:reg.tipo, chave:reg.chave, tipo_doc:reg.tipo_doc, resultado:reg.resultado, ts:reg.ts, atualizado_em:new Date().toISOString() }, { onConflict:'user_id,tipo,chave' })
        .then(function(r){
          if(r && r.error){ _cloudAviso('recusou gravar ('+reg.tipo+'/'+reg.chave+'): '+(r.error.message||r.error)); _cloudFilaPoe(reg); }
          else { _cloudFilaTira(reg); }
        }, function(e){ _cloudAviso('falhou ao gravar ('+reg.tipo+'/'+reg.chave+'): '+((e&&e.message)||e)); _cloudFilaPoe(reg); });
    }catch(e){ _cloudAviso('erro ao gravar ('+reg.tipo+'): '+((e&&e.message)||e)); _cloudFilaPoe(reg); }
  }
  /* v259: o callback agora recebe (linhas, deuCerto). O `deuCerto` é o que
     permite o backfill saber se a nuvem realmente respondeu — antes, uma
     falha de rede devolvia lista vazia igualzinho a "não tem nada lá". */
  function docHistCloudLoad(tipo, cb, limite){
    /* v682: o limite virou parâmetro COM 30 DE PADRÃO — esta função serve
       CPF, veículo e CNPJ; só o CNPJ pediu "guardar tudo" (decisão 28/08),
       então só ele passa um número maior. Os outros dois ficam como estavam. */
    try{ if(!(window.supa && meuId)){ cb&&cb([], false); return; }
      supa.from('doc_consulta').select('chave,tipo_doc,resultado,ts').eq('user_id',meuId).eq('tipo',tipo).order('ts',{ascending:false}).limit(Number(limite)||30).then(function(r){
        if(r && r.error){ _cloudAviso('recusou ler ('+tipo+'): '+(r.error.message||r.error)); cb&&cb([], false); return; }
        cb&&cb((r&&r.data)||[], true);
      },function(e){ _cloudAviso('falhou ao ler ('+tipo+'): '+((e&&e.message)||e)); cb&&cb([], false); });
    }catch(e){ _cloudAviso('erro ao ler ('+tipo+'): '+((e&&e.message)||e)); cb&&cb([], false); }
  }
  /* v259 — BACKFILL: sobe pra nuvem o que só existe NESTE aparelho.
     Antes, uma consulta feita antes da nuvem passar a funcionar ficava presa
     no navegador pra sempre e nunca aparecia no celular (foi o que aconteceu
     com o CPF de 25/07/2026: o PC mostrava, o celular não). Agora, toda vez
     que a tela abre, o que está aqui e não está lá é enviado.
     `rows` = o que a nuvem devolveu; `itens` = [{chave,tipo_doc,resultado,ts}]. */
  function docHistBackfill(tipo, rows, itens){
    try{
      if(!(window.supa && meuId)) return;
      var naNuvem={}; (rows||[]).forEach(function(r){ var k=String((r&&r.chave)||''); if(k) naNuvem[k]=1; });
      var faltando=(itens||[]).filter(function(it){ return it && it.chave && it.resultado && !naNuvem[String(it.chave)]; });
      if(!faltando.length) return;
      try{ console.log('[MEV] backfill '+tipo+': subindo '+faltando.length+' registro(s) que só existiam neste aparelho'); }catch(_){}
      faltando.forEach(function(it){ try{ docHistCloudSave(tipo, it.chave, it.tipo_doc, it.resultado, it.ts); }catch(_){} });
    }catch(_){}
  }
  /* v1403 — histórico temporário de CPF. Resultados de terceiros ficam
     disponíveis por no máximo 24 horas; depois são removidos do aparelho e
     a rotina agendada `cpf-historico-expirar` faz o hard delete na nuvem. */
  var CPF_HIST_MS=24*60*60*1000;
  function _restHistValido(it){ return !!(it && Number(it.ts)>Date.now()-CPF_HIST_MS); }
  function _restHistTipo(it){ return String((it&&it.resultado&&it.resultado.tipo_doc)||it&&it.tipo_doc||'CPF'); }
  function _restHistChave(it){ return String(it&&it.doc||'').replace(/\D/g,'')+'|'+_restHistTipo(it); }
  function restHistLer(){
    try{
      var todos=JSON.parse(localStorage.getItem('mev_rest_hist')||'[]'), validos=todos.filter(_restHistValido);
      if(validos.length!==todos.length) localStorage.setItem('mev_rest_hist',JSON.stringify(validos));
      return validos;
    }catch(_){ return []; }
  }
  function restHistCarregarNuvem(){
    try{ cloudFilaEnviar(); }catch(_){}
    docHistCloudLoad('cpf',function(rows){
      var agora=Date.now(), local=restHistLer(), mudou=false;
      (rows||[]).forEach(function(row){
        var ts=Number(row.ts)||0, chave=String(row.chave||''), partes=chave.split('|'), doc=partes[0].replace(/\D/g,'');
        if(ts<=agora-CPF_HIST_MS){
          try{ if(window.supa&&meuId) supa.from('doc_consulta').delete().eq('user_id',meuId).eq('tipo','cpf').eq('chave',chave).then(function(){},function(){}); }catch(_){}
          return;
        }
        if(!doc) return;
        var it={doc:doc,tipo_doc:row.tipo_doc||partes[1]||'CPF',ts:ts,resultado:row.resultado};
        if(!local.some(function(x){ return _restHistChave(x)===_restHistChave(it); })){ local.push(it); mudou=true; }
      });
      local=local.filter(_restHistValido).sort(function(a,b){ return b.ts-a.ts; }).slice(0,15);
      try{ localStorage.setItem('mev_rest_hist',JSON.stringify(local)); }catch(_){}
      if(mudou) restHistRender();
    },30);
  }
  function restHistSalvar(it){
    if(!it||!String(it.doc||'').replace(/\D/g,'')) return;
    it.ts=Number(it.ts)||Date.now();
    try{ var chave=_restHistChave(it), l=restHistLer().filter(function(x){ return _restHistChave(x)!==chave; }); l.unshift(it); localStorage.setItem('mev_rest_hist',JSON.stringify(l.slice(0,15))); }catch(_){}
    try{ docHistCloudSave('cpf',_restHistChave(it),it.tipo_doc||'CPF',it.resultado,it.ts); }catch(_){}
  }
  function restHistDestaPagina(){
    var alvo=String((CPF_PAGS[_cpfPagAtual]||{}).tdoc||'');
    return restHistLer().filter(function(it){ var td=_restHistTipo(it); return alvo?td===alvo:(td!=='CPF_PROCESSOS'&&td!=='CPF_SCORE_BACEN'); });
  }
  function restHistCards(){
    var l=restHistDestaPagina();
    if(!l.length) return '<p class="consulta-historico-vazio">Nenhum resultado disponível nas últimas 24 horas.</p>';
    return l.map(function(it,i){
      var p={}; try{ p=restParse(it.resultado||{}); }catch(_){}
      var td=_restHistTipo(it), estado='Resultado salvo';
      if(td==='CPF_PROCESSOS'){ var np=0; try{ np=cpfProcParse(it.resultado||{}).processos.length; }catch(_){} estado=np?(np+' processo'+(np===1?'':'s')):'Sem processos'; }
      else if(td==='CPF_SCORE_BACEN'){ var sc=null; try{ sc=cpfScoreParse(it.resultado||{}).score; }catch(_){} estado=sc==null?'Score disponível':'Score '+sc; }
      else estado=p.tem?'Pendências':'Nada consta';
      var falta=Math.max(1,Math.ceil((it.ts+CPF_HIST_MS-Date.now())/36e5));
      return '<button type="button" class="rest-hc" data-i="'+i+'"><span><strong>'+esc(_maskDoc(it.doc)||it.doc)+'</strong><small>'+esc(estado)+' · expira em '+falta+'h</small></span><span aria-hidden="true">›</span></button>';
    }).join('');
  }
  function restHistRender(){ var box=$('restHist'); if(!box) return; box.innerHTML=restHistCards(); _restHistLigar(box); }
  function _restHistLigar(box){
    Array.prototype.forEach.call((box||document).querySelectorAll('.rest-hc'),function(c){ c.onclick=function(){
      var it=restHistDestaPagina()[Number(c.getAttribute('data-i'))||0], res=$('restResult'); if(!it||!res) return;
      var td=_restHistTipo(it);
      if(td==='CPF_PROCESSOS'){ _cpfExtraState=it.resultado; res.innerHTML=cpfProcPanelHtml(it.resultado); }
      else if(td==='CPF_SCORE_BACEN'){ _cpfExtraState=it.resultado; res.innerHTML=cpfScorePanelHtml(it.resultado); }
      else{ _restState=it.resultado; res.innerHTML=restricaoPanelHtml(it.resultado); }
      try{ _cpfBlocosLigar(res); _cpf3DoHistorico(it.doc); res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){}
    }; });
  }
  function _lgpdCpfAceito(){ try{ return localStorage.getItem('mev_lgpd_cpf')==='1'; }catch(_){ return false; } }
  /* ===== v601 — "VER EXEMPLO (PDF)": O RELATÓRIO COM DADOS DE MENTIRA ====
     Pedido do Angelo (2º recado de 24/08): "a opção de ver um EXEMPLO do
     relatório com dados FICTÍCIOS — e dá pra visualizar esse exemplo em PDF".
     Serve pro lojista ver o que compra ANTES de pagar.

     🔴 TRÊS TRAVAS, porque isto NÃO PODE ser confundido com consulta real:
       1. não vai à API Brasil — o objeto é montado aqui, na mão;
       2. não cobra token nenhum e NÃO chama restHistSalvar (não entra no
          histórico, nem no local nem na nuvem);
       3. o nome da pessoa carrega "(DADOS FICTÍCIOS)", o protocolo é
          EXEMPLO-00000000, a tela ganha uma faixa e o PDF ganha uma linha
          de aviso (ver mev_exemplo em cpfScorePaginas/cpfProcPaginas/
          restricaoPaginas).
     Nada de gerador novo: o objeto de mentira usa os MESMOS nomes de campo
     que os leitores tolerantes (cpfScoreParse/cpfProcParse/restParse) já
     procuram, então cai no mesmo desenho de tela e no mesmo PDF de sempre. */
  /* ===== v608 — O RESULTADO EM CARDS QUE ABREM (o acordeão da ficha) =====
     Pedido do Angelo (24/08), com print: "o resultado da pesquisa mostre os
     campos como card colapsavel minimizado, mesmo formato da ficha tecnica,
     clica e abre as informacoes".
     🔑 Reaproveita o .fic-item/.fic-t/.fic-b — o MESMO acordeão da ficha
     técnica (v253) e da análise de mercado. Zero classe nova: quem já sabe
     usar a ficha já sabe usar isto. */
  /* ===== v611 — O CPF DO HISTÓRICO VEM JUNTO ============================
     Pedido do Angelo (24/08): "quando clicar num card do histórico, e depois
     clicar em acoes e processos ou score bancario, ele traz o mesmo numero de
     cpf do historico pra pesquisar, com icone de limpa".
     A ideia é a espinha do app: NINGUÉM DIGITA O MESMO NÚMERO DUAS VEZES. Se
     o lojista abriu o histórico de um CPF, o app já sabe de quem se trata.

     🔴 MAS ISSO DESARMA UMA TRAVA, E POR ISSO O ✕ NÃO É ENFEITE.
     A regra da v601 diz que o PRIMEIRO toque num card só ABRE o campo, sem
     consultar — é ela que impede a consulta paga de sair sem querer. Com o
     CPF já preenchido, o campo já está aberto: o próximo toque em "Score
     bancário" é R$ 19,00 na hora. Então o ✕ vira a rede de proteção, e a
     linha "CPF trazido do histórico" existe pra ninguém consultar o CPF
     errado achando que é o que acabou de digitar. */
  var _cpf3HistDoc='';
  function _cpf3DoHistorico(doc){
    var w=$('restFieldWrap'), i=$('restDoc'); if(!w||!i) return;
    var dg=String(doc||'').replace(/\D/g,''); if(dg.length!==11) return;
    w.style.display=''; w.setAttribute('data-aberto','1');
    i.value=_fmtCpf(dg);
    _cpf3HistDoc=dg;
    /* dispara o MESMO ouvinte de quem digita: pinta a barrinha, acende o
       verde do campo cheio e sincroniza o ✕ — sem repetir a lógica aqui. */
    try{ i.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){ _cpf3XSync(); }
    var av=$('restDocHist'); if(av) av.style.display='flex';
  }
  function _cpf3XSync(){
    var x=$('restDocX'), i=$('restDoc'), f=$('restField'); if(!x||!i) return;
    var tem=!!String(i.value||'').trim();
    x.style.display = tem ? 'inline-flex' : 'none';
    if(f) f.classList.toggle('com-x', tem);
    /* digitou outra coisa? a marca do histórico não vale mais */
    var dg=String(i.value||'').replace(/\D/g,'');
    if(_cpf3HistDoc && dg!==_cpf3HistDoc){
      _cpf3HistDoc='';
      var av=$('restDocHist'); if(av) av.style.display='none';
    }
  }
  function _cpf3Limpar(){
    var i=$('restDoc'); if(!i) return;
    i.value=''; _cpf3HistDoc='';
    try{ i.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){ _cpf3XSync(); }
    var av=$('restDocHist'); if(av) av.style.display='none';
    try{ i.focus(); }catch(_){}
  }
  /* ===== v610 — O ÍCONE DO CARD DIZ O ESTADO, SEM PRECISAR ABRIR ========
     Pedido do Angelo (24/08): "icones de verificado nos campos sem pendencia,
     e icone de alerta onde foi encontrado".
     🔴 SÓ GANHA ÍCONE DE ESTADO A SEÇÃO QUE CARREGA UM VEREDITO. Identificação,
     Endereço, Comportamento de crédito e afins são INFORMAÇÃO, não julgamento
     — pintar um ✓ verde neles seria afirmar coisa que a seção não diz. Onde o
     app não sabe, o ícone continua neutro. É a mesma régua da v450: não
     afirmar é a única resposta honesta. */
  var _CPF_ICO = {
    ok:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12.5 9.5 18 20 6.5"/></svg>',
    no:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>',
    at:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16h.01"/></svg>'
  };
  function _cpfBloco(titulo, corpo, aberto, estado){
    if(!corpo) return '';
    var ic = (estado && _CPF_ICO[estado]) ? _CPF_ICO[estado] : _ficIcoTit(titulo);
    var cls = (estado && _CPF_ICO[estado]) ? (' est-'+estado) : '';
    return '<div class="fic-item'+(aberto?' open':'')+'">'
      +'<button type="button" class="fic-t"><span class="fic-ic'+cls+'">'+ic+'</span>'
      +'<span class="fic-tt">'+esc(titulo)+'</span><span class="fic-ar">&#9656;</span></button>'
      +'<div class="fic-b">'+corpo+'</div></div>';
  }
  /* a fiação é a mesma linha do 06: clicar no título abre/fecha aquele card */
  function _cpfBlocosLigar(box){
    if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('.fic-t'), function(b){
      b.onclick=function(e){ e.stopPropagation(); b.parentNode.classList.toggle('open'); };
    });
  }
  /* ===== v608 — A TELA SE ARRUMA EM VOLTA DO RESULTADO =================
     Pedido do Angelo: "quando gerar a pesquisa, oculte o card que foi
     pesquisado, mostre a pesquisa gerada logo abaixo e abaixo da pesquisa
     gerada o botao de baixar pdf, e depois por ultimo as duas pesquisas
     adicionais que da pra fazer".
     A ordem passa a ser:  [RESULTADO + Baixar PDF] → os outros DOIS cards.
     O card consultado sai da frente (ele já cumpriu o papel), e o aceite
     LGPD também — ele é uma condição, não um destino.
     ⚠️ Nada é APAGADO: é só display:none e o #restResult mudando de lugar
     dentro do mesmo container. Consultar outro produto desfaz e refaz. */
  function _cpf3Foco(qual){
    var cx=document.querySelector('.cpf3-cards'), res=$('restResult');
    /* ========================================================================
       🔴🔴 v898 — OS BLOCOS DO RESULTADO DO CPF NÃO ABRIAM NO TOQUE.
       ------------------------------------------------------------------------
       Defeito de VERDADE, achado pelo teste-v608 depois que ele voltou a
       rodar (ele estava estourando havia meses, escondido em "não sei dizer").

       O `_cpfBlocosLigar` — que é quem liga o clique dos acordeões
       "Identificação", "Pendências / restrições" e "Receita Federal" —
       morava LÁ EMBAIXO nesta função, DEPOIS de um `if(!cx||!res) return;`.
       E a `.cpf3-cards` deixou de existir na v613/v752, quando cada consulta
       virou uma PÁGINA e o formulário virou o padrão 02c.

       Resultado: desde então, esta função voltava na primeira linha e o
       clique nunca era ligado. Na tela do CPF o lojista tocava nos blocos e
       NADA acontecia — o conteúdo estava lá, montado, invisível. Em todas as
       OUTRAS telas (CNPJ, risco, veículo) funciona, porque elas chamam o
       `_cpfBlocosLigar` direto, sem passar por aqui.

       ⚠️ O CONSERTO É A ORDEM: ligar o clique ANTES de qualquer desistência.
       Ligar acordeão não depende de coluna nenhuma — depende só do resultado
       estar na tela. O resto desta função (esconder o card consultado,
       remontar a coluna) continua condicionado à coluna existir, como deve.
       ======================================================================== */
    if(res) _cpfBlocosLigar(res);
    if(!cx||!res) return;
    /* limpa o foco anterior: quem estava escondido volta */
    Array.prototype.forEach.call(cx.querySelectorAll('.cpf3-card'), function(c){ c.classList.remove('usado'); });
    var alvo=null;
    var ids={ restricao:'restBt3', score:'cpfScoreBt', proc:'cpfProcBt' };
    var bt=$(ids[qual]||''); if(bt) alvo=bt.closest('.cpf3-card');
    /* v613: com UMA consulta por página, o card escondido é sempre o desta
       página — e o que aparece no lugar dele é o resultado. Os atalhos pras
       outras duas continuam no pé, fora da coluna. */
    if(alvo) alvo.classList.add('usado');
    cx.classList.add('com-resultado');
    /* o resultado vira o PRIMEIRO da coluna — os outros dois ficam embaixo */
    try{ if(res.parentNode!==cx || cx.firstChild!==res) cx.insertBefore(res, cx.firstChild); }catch(_){}
    /* v898: o _cpfBlocosLigar subiu pro começo da função — ver a nota lá */
  }
  /* volta a tela ao estado de escolha (nenhum resultado na frente) */
  function _cpf3Desfoca(){
    var cx=document.querySelector('.cpf3-cards'), res=$('restResult'), wrap=$('restWrap');
    if(!cx) return;
    Array.prototype.forEach.call(cx.querySelectorAll('.cpf3-card'), function(c){ c.classList.remove('usado'); });
    cx.classList.remove('com-resultado');
    /* devolve o #restResult pro lugar de origem: logo depois da coluna */
    try{ if(res && wrap && res.parentNode===cx) cx.parentNode.insertBefore(res, cx.nextSibling); }catch(_){}
  }
  /* ===== v605 — O BOTÃO VOLTA A FALAR EM TOKENS =========================
     Pedido do Angelo (24/08): "coloque o numero de tokens no consultar ao
     inves do valor real".
     A v599 tinha trocado token por R$ nos três botões (modelo híbrido). Ele
     reviu: a carteira do lojista é em TOKEN, e ver R$ no botão e token no
     saldo obriga a fazer conta de cabeça na hora de decidir. Agora o botão
     fala a mesma língua do saldo.
     ⚠️ O precoReal/TOKEN_RS do 01-nucleo FICA — a conta está certa e é a
     base da Fase 2 do projeto híbrido, se um dia ela voltar. Só não é ele
     quem escreve estes botões. */
  function _cpf3Tok(n){ return precoReal(n); }
  /* ===== v603 — O QUE VEM NO RELATÓRIO, DENTRO DO CARD ==================
     Pedido do Angelo (24/08): "dentro de cada card coloque uma lista com
     emoji de verificado com as informações que o pdf traz".
     🔴 REGRA: cada linha aqui é uma PROMESSA — só entra o que o gerador de
     PDF daquele card desenha de verdade (cpfScorePaginas · restricaoPaginas
     · cpfProcPaginas). Mexeu no gerador, confere esta lista. */
  function _cpf3Lista(itens){
    return '<ul class="cpf3-lista">'+itens.map(function(t){
      return '<li>✅ '+esc(t)+'</li>'; }).join('')+'</ul>';
  }
  var CPF_EX_DOC='11122233344';
  var CPF_EX_NOME='MARIA EXEMPLO DA SILVA (DADOS FICTÍCIOS)';
  function _cpf3ExDados(qual){
    if(qual==='score') return { documento:CPF_EX_DOC, tipo_doc:'CPF_SCORE_BACEN', mev_exemplo:true, data:{
      nome:CPF_EX_NOME, score:642,
      aVencer:12450.00, vencido:1830.55, prejuizo:0,
      quantidadeInstituicoes:3, quantidadeOperacoes:5, dataInicioRelacionamento:'03/2015',
      modalidades:[
        { modalidade:'Empréstimo pessoal', valor:8200.00, percentual:'57,3' },
        { modalidade:'Cartão de crédito', valor:2450.00, percentual:'17,1' },
        { modalidade:'Financiamento de veículo', valor:3630.55, percentual:'25,6' }
      ] } };
    /* v1024 — o exemplo passou a ter o FORMATO REAL da resposta
       (acoesProcessos.acoes.processos, com classeProcessual objeto,
       assuntosCNJ, informacoesPartePessoaConsultada e statusPj). Antes ele
       vinha no formato que o leitor QUEBRADO entendia — e por isso o PDF de
       exemplo ficava bonito enquanto a consulta paga saía vazia. Exemplo que
       não tem a forma do dado de verdade não prova nada. DADOS FICTÍCIOS. */
    if(qual==='proc') return { documento:CPF_EX_DOC, tipo_doc:'CPF_PROCESSOS', mev_exemplo:true, data:{
      cadastralCompleto:{ nome:CPF_EX_NOME, enderecos:[{ cidade:'São Paulo', uf:'SP' }] },
      acoesProcessos:{ documentoNaoEncontrado:false, possuiErro:false, acoes:{ processos:[
        { numeroProcessoUnico:'0001234-56.2024.8.26.0100',
          classeProcessual:{ codigoCnj:12377, nome:'PROCEDIMENTO COMUM CÍVEL' },
          assuntosCNJ:[{ codigo:7681, titulo:'INDENIZAÇÃO POR DANO MATERIAL', principal:true },
                       { codigo:899,  titulo:'DIREITO CIVIL', principal:false }],
          informacoesPartePessoaConsultada:[{ polo:'PASSIVO', tipo:'RÉU' }],
          statusPj:{ statusProcesso:'EM TRAMITAÇÃO', ramoDireito:'DIREITO CIVIL' },
          tribunal:'TJSP', orgaoJulgador:'3ª Vara Cível', uf:'SP', grauProcesso:'1º grau',
          dataDistribuicao:'2024-03-14 09:12:00', valorCausa:{ moeda:'BRL', valor:10000 },
          segredoJustica:false },
        { numeroProcessoUnico:'0007654-32.2022.8.26.0224',
          classeProcessual:{ codigoCnj:12378, nome:'PROCEDIMENTO DO JUIZADO ESPECIAL CÍVEL' },
          assuntosCNJ:[{ codigo:7771, titulo:'PRESTAÇÃO DE SERVIÇOS', principal:true }],
          informacoesPartePessoaConsultada:[{ polo:'ATIVO', tipo:'PROMOVENTE' }],
          statusPj:{ statusProcesso:'ARQUIVAMENTO DEFINITIVO', ramoDireito:'DIREITO DO CONSUMIDOR',
                     dataArquivamento:'2023-05-19 00:00:00' },
          tribunal:'TJSP', orgaoJulgador:'1º Juizado Especial Cível', uf:'SP', grauProcesso:'1º grau',
          dataDistribuicao:'2022-08-02 14:30:00', valorCausa:{ moeda:'BRL', valor:0 },
          segredoJustica:false }
      ] } } } };
    /* restrições */
    /* ⚠️ O EXEMPLO TEM QUE EXERCITAR TODAS AS SEÇÕES QUE O CARD PROMETE.
       O teste-v603 confere linha por linha da lista de ✅ contra o que o
       gerador REALMENTE desenha — e foi ele que pegou: sem renda/profissão
       e sem participação em empresas, as seções "Comportamento de crédito"
       e "Participação em empresas" simplesmente não nasciam na folha, e a
       lista virava promessa vazia. Mexeu na lista do card, mexe aqui. */
    var exemploCpf={ documento:CPF_EX_DOC, tipo_doc:'CPF', mev_exemplo:true, data:{ ConsultaCredito:{
      DadosCadastrais:{ Nome:CPF_EX_NOME, Cpf:CPF_EX_DOC, DataNascimento:'12/04/1985', Idade:'41',
        Sexo:'F', NomeMae:'JOANA EXEMPLO DA SILVA', Situacao:'REGULAR', Telefone:'(11) 90000-0000',
        RendaPresumida:'R$ 6.500,00', Profissao:'Comerciante', EstadoCivil:'Casada',
        Escolaridade:'Superior completo', NumeroDependentes:'2', ClasseSocial:'B2' },
      Score:{ Score:'642', Classe:'C' },
      PendenciasFinanceiras:[
        { Informante:'BANCO EXEMPLO S.A.', Valor:'1830,55', Data:'10/02/2026', TipoPendencia:'Financiamento', Cidade:'São Paulo' },
        { Informante:'LOJAS EXEMPLO LTDA', Valor:'420,00', Data:'03/11/2025', TipoPendencia:'Cartão de crédito', Cidade:'Campinas' }
      ],
      Protestos:[ { Cidade:'São Paulo', Uf:'SP', Valor:'980,00', Data:'22/07/2025', Cartorio:'2º Tabelionato de Protesto' } ],
      ParticipacaoEmEmpresas:[
        { Empresa:'EXEMPLO COMERCIO DE VEICULOS LTDA', Cnpj:'00000000000191', Funcao:'Sócia administradora', ParticipacaoEmPorcentagem:'50', DataEntrada:'08/2019' }
      ],
      ConsultasAnteriores:{ QuantidadeTotal:'7' },
      AcoesCiveis:[], ChequesSemFundo:[], ChequesSustados:[]
    } },
    /* v604 — a outra fonte que a "CPF restrições" paga (v599).
       ⚠️ Ela é IRMÃ do `data`, não filha: o servidor devolve mev_receita na
       RAIZ do resultado, e é lá que os leitores procuram. Pôr dentro do data
       (foi o meu primeiro erro aqui) faz o exemplo sair sem a seção, calado.
       🔴 v897 — O `mev_antecedentes` SAIU DO EXEMPLO junto com a fonte. Um
       exemplo é promessa: mostrar no PDF de amostra um selo de antecedentes
       que a consulta de verdade não entrega mais seria vender o que não tem.
       (O LEITOR daquele selo continua no código, de propósito — consulta
       antiga guardada ainda o traz e precisa abrir inteira.) */
    mev_receita:{ ok:true, dados:{ data:{ nome:CPF_EX_NOME, dataNascimento:'12/04/1985',
      nomeMae:'JOANA EXEMPLO DA SILVA', situacao:'REGULAR', dataSituacao:'01/03/2020' } } }
    };
    exemploCpf.mev_score={ok:true,dados:_cpf3ExDados('score')};
    exemploCpf.mev_produto='CPF_COMPLETO';
    return exemploCpf;
  }
  function _cpf3ExFaixa(){
    return '<div style="display:flex;align-items:center;gap:8px;background:#fef3c7;border:1px solid #fde68a;border-left:6px solid #f59e0b;border-radius:12px;padding:10px 13px;margin:4px 0 10px">'
      +'<b style="color:#92400e;font-size:13px">Exemplo — dados fictícios</b>'
      +'<span style="color:#b45309;font-size:11.5px">nenhuma consulta foi feita, nada foi cobrado</span></div>';
  }
  /* v603 — o exemplo agora MOSTRA A FOLHA, não o painel de tela.
     Pedido do Angelo: "quando clicar em ver exemplo pdf já deve aparecer o
     pdf na tela pra visualizar". As páginas do kit JÁ SÃO canvas — o
     kitPrevia empilha e vira uma imagem. Ou seja: o que aparece na tela é
     exatamente a folha que vai sair no arquivo, sem gerador novo e sem
     precisar do jsPDF (ele só entra na hora de BAIXAR). */
  function _cpf3ExPaginas(qual, dd){
    if(qual==='score') return cpfScorePaginas(dd);
    if(qual==='proc') return cpfProcPaginas(dd);
    var paginas=restricaoPaginas(dd);
    if(dd&&dd.mev_score&&dd.mev_score.ok&&dd.mev_score.dados){
      var scoreEx=Object.assign({},dd.mev_score.dados);
      if(!scoreEx.documento) scoreEx.documento=dd.documento;
      paginas=paginas.concat(cpfScorePaginas(scoreEx));
    }
    return paginas;
  }
  /* ===== v603 — A MINIATURA DA FOLHA DENTRO DO CARD ====================
     Pedido do Angelo: "traga uma miniatura do exemplo do pdf no card".
     É a MESMA folha do exemplo, reduzida — nada de imagem solta que possa
     desandar do relatório de verdade: se o gerador mudar, a miniatura muda
     junto, porque ela É o gerador rodando.
     ⚠️ Desenhada DEPOIS que a tela pinta (setTimeout 0): são 3 folhas A4 em
     canvas, e travar a abertura da página por causa de enfeite seria burro.
     Se qualquer uma falhar, o card simplesmente fica sem miniatura — o
     botão continua funcionando. */
  function _cpf3Mini(qual){
    try{
      var pags=_cpf3ExPaginas(qual,_cpf3ExDados(qual));
      var pg=pags&&pags[0]; if(!pg) return '';
      var W=112, H=142;                       /* proporção de folha em pé */
      var cv=document.createElement('canvas'); cv.width=W*2; cv.height=H*2;
      var g=cv.getContext('2d');
      g.fillStyle='#ffffff'; g.fillRect(0,0,cv.width,cv.height);
      /* mostra o TOPO da folha (faixa azul + veredito) — é o que identifica
         o relatório de relance; o resto vira borrão nesse tamanho. */
      var fator=cv.width/pg.width;
      var alturaFonte=Math.min(pg.height, Math.round(cv.height/fator));
      g.drawImage(pg, 0,0, pg.width, alturaFonte, 0,0, cv.width, cv.height);
      return cv.toDataURL('image/jpeg',0.82);
    }catch(_){ return ''; }
  }
  function _cpf3MinisPintar(){
    try{
      Array.prototype.forEach.call(document.querySelectorAll('.cpf3-mini[data-ex]'), function(el){
        if(el.getAttribute('data-ok')==='1') return;
        var u=_cpf3Mini(el.getAttribute('data-ex'));
        if(!u) return;
        el.innerHTML='<img alt="Exemplo do relatório" src="'+u+'">';
        el.setAttribute('data-ok','1');
      });
    }catch(_){}
  }
  function _cpf3VerExemplo(qual){
    var res=$('restResult'); if(!res) return;
    var dd=_cpf3ExDados(qual);
    if(qual==='restricao') _restState=dd; else _cpfExtraState=dd;
    var folha='';
    try{
      var cv=kitPrevia(_cpf3ExPaginas(qual,dd));
      folha='<div class="cpf3-folha"><img alt="Exemplo do relatório em PDF" src="'+cv.toDataURL('image/jpeg',0.9)+'"></div>';
    }catch(_){ folha=''; }
    res.innerHTML=_cpf3ExFaixa()
      +(folha||'<div class="plc-msg" style="color:#b45309">Não consegui desenhar a folha agora. Use o ícone de baixar no card do exemplo.</div>');
    /* v775: o botão "Baixar em PDF" SAIU daqui — o download do exemplo
       mora no ícone de baixar do próprio card (_cpf3BaixarExemplo). */
    /* v608: o exemplo NÃO esconde card nenhum — não é consulta, é amostra.
       A tela volta ao estado de escolha pra ele poder comparar os três. */
    _cpf3Desfoca();
    try{ res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){}
  }
  /* v1021 — a amostra acionada pela landing abre como PDF no visor padrão,
     sem navegar para o formulário e sem consultar nenhuma fonte. */
  function _cpf3AbrirExemploPdf(qual){
    if(!_mevPdfPronto(function(){ _cpf3AbrirExemploPdf(qual); },false)) return true;
    try{
      var dd=_cpf3ExDados(qual), blob=kitPdfBlob(_cpf3ExPaginas(qual,dd));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return false; }
      var nome=qual==='score'?'exemplo-score-bancario.pdf':qual==='proc'?'exemplo-acoes-e-processos.pdf':'exemplo-consulta-cpf.pdf';
      pdfVisor(blob,nome); return true;
    }catch(_){ toast('Não consegui abrir o exemplo em PDF agora.'); return false; }
  }
  /* v775 — o ícone de BAIXAR do card do exemplo (CPF): mesmo caminho que o
     botão removido usava — arma o estado do exemplo e baixa o PDF. */
  function _cpf3BaixarExemplo(qual){
    var dd=_cpf3ExDados(qual);
    if(qual==='restricao'){ _restState=dd; restricaoBaixarPDF(); }
    else { _cpfExtraState=dd; cpfExtraBaixarPDF(qual==='score'?'score':'proc'); }
  }
  /* ===== v601 — O CAMPO DE CPF SÓ APARECE QUANDO ALGUÉM ESCOLHE =========
     Devolve TRUE quando acabou de abrir o campo (e aí quem chamou PARA);
     FALSE quando o campo já estava aberto (e aí a consulta segue).
     Guardo a marca no próprio elemento, não numa variável do módulo: a tela
     é remontada a cada abrirRestricao() e a marca some junto, que é o certo. */
  function _cpf3AbrirCampo(){
    var w=$('restFieldWrap'); if(!w) return false;
    if(w.style.display!=='none' && w.getAttribute('data-aberto')==='1') return false;
    w.style.display='';
    w.setAttribute('data-aberto','1');
    try{ w.scrollIntoView({behavior:'smooth',block:'center'}); }catch(_){}
    try{ var i=$('restDoc'); if(i) i.focus(); }catch(_){}
    return true;
  }
  /* v599 — a porta comum dos três cards: CPF completo + LGPD aceita.
     Devolve o CPF em dígitos, ou '' (e já escreve o motivo na tela). */
  function _cpf3Pronto(){
    var inp=$('restDoc'); var doc=inp?String(inp.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''):'';
    var res=$('restResult'), chk=$('restLgpd');
    if(chk && !chk.checked){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Para consultar, marque que <b>leu e aceitou</b> o termo de proteção de dados (LGPD) acima.</div>'; try{ chk.focus(); }catch(_){} return ''; }
    if(doc.length!==11){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CPF válido (11 números).</div>'; try{ if(inp) inp.focus(); }catch(_){} return ''; }
    return doc;
  }
  /* v752 — os estados do botão do padrão (02c). Botão antigo (sem a classe)
     continua no caminho de sempre: disabled + texto. */
  function _cpf3BuscaSync(){
    var lupa=$('restRefaz'); if(!lupa) return;
    var P=CPF_PAGS[_cpfPagAtual]||CPF_PAGS.restricao, acao=$(P.bt);
    var ocupado=!!(acao&&acao.getAttribute('aria-busy')==='true');
    lupa.disabled=!acao||acao.disabled||ocupado;
    lupa.classList.toggle('is-loading',ocupado);
    if(ocupado) lupa.setAttribute('aria-busy','true'); else lupa.removeAttribute('aria-busy');
    var rot=ocupado?'Consultando CPF':'Buscar CPF — '+_cpf3Tok(P.tok);
    lupa.setAttribute('aria-label',rot); lupa.setAttribute('title',rot);
  }
  function _cpf3Cta(bt, estado, texto){ consultaUiBotao(bt, estado, texto); try{ _cpf3BuscaSync(); }catch(_){} }   /* v1346: estado também chega à lupa */
  function cpfResultadoVoltar(qual,doc,limpar){
    abrirRestricao(qual);
    if(limpar) return;
    setTimeout(function(){ try{ _cpf3DoHistorico(doc); var i=$('restDoc'); if(i) i.blur(); }catch(_){} },0);
  }
  function cpfResultadoAbrir(qual,doc,resultado,aviso,ts,reaberta){
    qual=qualEsc(qual); var P=CPF_PAGS[qual], painel='';
    if(qual==='score'){ _cpfExtraState=resultado; painel=cpfScorePanelHtml(resultado,doc); }
    else if(qual==='proc'){ _cpfExtraState=resultado; painel=cpfProcPanelHtml(resultado); }
    else {
      _restState=resultado;
      painel=restricaoPanelHtml(resultado);
      if(resultado&&resultado.mev_score){
        if(resultado.mev_score.ok&&resultado.mev_score.dados){
          painel+=cpfScorePanelHtml(resultado.mev_score.dados,doc,true);
        }
      }
    }
    if(aviso) painel+='<div class="plc-msg consulta-resultado-aviso">'+esc(aviso)+'</div>';
    var pdfAcao=function(modo){ if(qual==='restricao') restricaoPdfAcao(modo); else cpfExtraPdfAcao(qual,modo); };
    var resumoTexto=qual==='score'?'Exposição de crédito e score disponíveis.':'Resultado disponível para análise.';
    if(qual==='restricao'&&resultado&&resultado.mev_score){
      resumoTexto=resultado.mev_score.ok?'Cadastro, pendências e score disponíveis para análise.':'Cadastro e pendências disponíveis; score não verificado.';
    }
    var cfg={ chave:P.aba, titulo:P.titulo, identificacao:'CPF '+_fmtCpf(doc), dataHora:histData(ts||Date.now()), origem:reaberta?'Resultado salvo':'',
      resumoHtml:consultaResultadoResumo({ tom:'ok', titulo:'Consulta concluída', texto:resumoTexto }),
      secoesHtml:consultaResultadoSecao({ titulo:'Resultado da consulta', html:painel }),
      aoVoltar:function(){ cpfResultadoVoltar(qual,doc,false); }, aoNovaConsulta:function(){ cpfResultadoVoltar(qual,'',true); },
      acoes:[
        {id:'cpfPdfVisualizar',rotulo:'Visualizar PDF',icone:'ver',somenteIcone:true,primaria:true,acao:function(){ pdfAcao('visualizar'); }},
        {id:'cpfPdfBaixar',rotulo:'Baixar PDF',icone:'baixar',somenteIcone:true,acao:function(){ pdfAcao('baixar'); }},
        {id:'cpfPdfCompartilhar',rotulo:'Compartilhar PDF',icone:'compartilhar',somenteIcone:true,acao:function(){ pdfAcao('compartilhar'); }}
      ] };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
    var raiz=$('consultaResultadoPagina')||document, pb=raiz.querySelector(qual==='score'?'#cpfScorePdf':qual==='proc'?'#cpfProcPdf':'#restPdf');
    if(pb) pb.onclick=function(){ if(qual==='restricao') restricaoBaixarPDF(); else cpfExtraBaixarPDF(qual); };
    try{ _cpfBlocosLigar(raiz); }catch(_){}
    if(!reaberta && qual==='proc') consultaOfertaToast({
      titulo:'Quer consultar cadastro, pendências e score?',
      texto:'Abra a Consulta CPF com o mesmo documento. O valor será mostrado antes da confirmação.',
      rotulo:'Ver Consulta CPF',
      acao:function(){ consultaResultadoFechar(false); setTimeout(function(){ abrirRestricao('restricao'); setTimeout(function(){ _cpf3DoHistorico(doc); },0); },0); }
    });
  }
  async function gerarRestricao(btn, btnCard){
    var doc=_cpf3Pronto(); if(!doc) return;
    var res=$('restResult');
    /* v897: RG e UF saíram do pedido junto com a fonte de antecedentes.
       ⚠️ Mandar campo que o servidor não lê mais não é inofensivo: é dado
       pessoal viajando à toa, e a LGPD desta tela é o assunto do card logo
       acima do botão. O que não serve, não sai do aparelho. */
    var _rot=btnCard?btnCard.textContent:'';
    btn.disabled=true; btn.textContent='Consultando…';
    _cpf3Cta(btnCard,'carregando','Consultando CPF…');
    if(res) res.innerHTML=ccLoaderHtml('Consultando CPF…',_restFrases,_SVG_PESSOA); var lt=ccLoaderStart(_restFrases);
    var _sAntes=saldo;   /* saldo ANTES da consulta (pro extrato) */
    var d=await consultarComRetry({produto:'cpf_completo',documento:doc},1);
    clearInterval(lt);
    btn.disabled=false; btn.textContent='Consultar CPF';
    _cpf3Cta(btnCard,'pronto',_rot);
    if(d&&d.sem_saldo){ setSaldo(d.saldo); if(res) res.innerHTML=''; abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){ _cpf3Cta(btnCard,'erro'); if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não foi possível concluir a consulta agora. Tente de novo em instantes.')+(d&&d.estornado?' ✓ O valor foi devolvido ao seu saldo.':'')+' <br><span style="color:#64748b">Toque na lupa ao lado do CPF para tentar de novo.</span></div>'; return; }
    _cpf3Cta(btnCard,'novamente');
    _restState=d.resultado;
    try{ restHistSalvar({ doc:doc, tipo_doc:(d.resultado&&d.resultado.tipo_doc)||'', ts:Date.now(), resultado:d.resultado, tok:_tokCalc(_sAntes,d.saldo) }); restHistRender(); }catch(_){}
    /* v599: quando uma fonte não veio, o servidor devolve o pedaço dela e
       manda o aviso — mostrar isso é honestidade, não detalhe técnico. */
    cpfResultadoAbrir('restricao',doc,d.resultado,d.aviso||'',Date.now(),false);
  }
  /* ===== v599 — OS DOIS CARDS NOVOS (score bancário · ações e processos)
     Mesmo caminho do CPF Restrições: uma porta (_cpf3Pronto), um toque, uma
     consulta. O resultado tem desenho próprio, mas divide o mesmo
     #restResult e o MESMO histórico (mp_doc_consulta, tipos novos). */
  var _cpfExtraState=null;
  async function gerarCpfExtra(produto, btn){
    var doc=_cpf3Pronto(); if(!doc) return;
    var res=$('restResult');
    var ehScore = (produto==='cpf_score_bacen');
    var rot=btn?btn.textContent:'';
    _cpf3Cta(btn,'carregando',ehScore?'Consultando score…':'Consultando processos…');
    if(res) res.innerHTML=ccLoaderHtml(ehScore?'Consultando score bancário…':'Consultando ações e processos…',_restFrases,_SVG_PESSOA);
    var lt=ccLoaderStart(_restFrases);
    var _sAntes=saldo;
    var d=await consultarComRetry({produto:produto,documento:doc},1);
    clearInterval(lt);
    _cpf3Cta(btn,'pronto',rot);
    if(d&&d.sem_saldo){ setSaldo(d.saldo); if(res) res.innerHTML=''; abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){ _cpf3Cta(btn,'erro'); if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não foi possível concluir a consulta agora. Tente de novo em instantes.')+(d&&d.estornado?' ✓ O valor foi devolvido ao seu saldo.':'')+'</div>'; return; }
    _cpf3Cta(btn,'novamente');
    _cpfExtraState=d.resultado;
    try{ restHistSalvar({ doc:doc, tipo_doc:(d.resultado&&d.resultado.tipo_doc)||(ehScore?'CPF_SCORE_BACEN':'CPF_PROCESSOS'), ts:Date.now(), resultado:d.resultado, tok:_tokCalc(_sAntes,d.saldo) }); restHistRender(); }catch(_){}
    cpfResultadoAbrir(ehScore?'score':'proc',doc,d.resultado,d.aviso||'',Date.now(),false);
  }
  /* --- leitores tolerantes (a base muda o nome das chaves entre versões) ---
     🔴 NOME PRÓPRIO, DE PROPÓSITO (_cpf3*): este arquivo JÁ TEM um `_ciKey`
     mais abaixo, com OUTRA assinatura (lista de nomes, não regex). Como todos
     os módulos vivem no MESMO IIFE e declaração de função sofre hoisting, a
     ÚLTIMA vence — a primeira versão destas funções chamava-se `_ciKey` e foi
     silenciosamente substituída pela outra: o parser do score caiu inteiro no
     "sem os campos que este relatório desenha", sem erro nenhum no console.
     ⚠️ REGRA: antes de criar função no IIFE compartilhado, grep no nome. */
  function _cpf3Key(o,re){ if(!o||typeof o!=='object') return null; var ks=Object.keys(o); for(var i=0;i<ks.length;i++){ if(re.test(ks[i].toLowerCase().replace(/[^a-z0-9]/g,''))) return o[ks[i]]; } return null; }
  function _cpf3Deep(o,re,prof){ prof=prof||0; if(!o||typeof o!=='object'||prof>6) return null;
    var v=_cpf3Key(o,re); if(v!=null && typeof v!=='object') return v;
    var ks=Object.keys(o);
    for(var i=0;i<ks.length;i++){ var x=o[ks[i]]; if(x&&typeof x==='object'){ var r=_cpf3Deep(x,re,prof+1); if(r!=null) return r; } }
    return null;
  }
  function _cpfNum(v){ var n=Number(String(v==null?'':v).replace(/[^\d,.-]/g,'').replace(/\.(?=\d{3}\b)/g,'').replace(',','.')); return isNaN(n)?null:n; }
  function _scoreFaixa(n){ n=Number(n)||0; if(n>=700) return ['BOM','#15803d','#dcfce7']; if(n>=500) return ['REGULAR','#b45309','#fef3c7']; return ['RUIM','#b91c1c','#fee2e2']; }
  /* --- SCORE BANCÁRIO (scr-bacen-score) --- */
  function cpfScoreParse(dd){
    var d=(dd&&dd.data)||dd||{};
    var p={ score:null, doc:(dd&&dd.documento)||_cpf3Deep(d,/^(document|cpf)$/)||'', resumo:[], modalidades:[], relacao:'' };
    var sc=_cpf3Deep(d,/^(score|pontuacao|scorevalor)$/); if(sc!=null) p.score=_cpfNum(sc);
    ['avencer','vencido','prejuizo'].forEach(function(k){
      var v=_cpf3Deep(d,new RegExp('^'+k)); if(v!=null){ var n=_cpfNum(v); if(n!=null) p.resumo.push([k==='avencer'?'A vencer':(k==='vencido'?'Vencido':'Prejuízo'), n]); }
    });
    /* modalidades: qualquer lista com nome + valor */
    (function(){
      var listas=[]; (function cava(o,prof){ if(!o||typeof o!=='object'||prof>5) return;
        if(Array.isArray(o)){ if(o.length && typeof o[0]==='object') listas.push(o); return; }
        Object.keys(o).forEach(function(k){ cava(o[k],prof+1); }); })(d,0);
      listas.forEach(function(L){ L.slice(0,12).forEach(function(x){
        var nome=_cpf3Key(x,/^(modalidade|nome|descricao|tipo)$/), val=_cpfNum(_cpf3Key(x,/^(valor|saldo|total)$/));
        var pct=_cpf3Key(x,/^(percentual|percent|pct)$/);
        if(nome && val!=null) p.modalidades.push({ nome:String(nome), valor:val, pct:(pct!=null?String(pct):'') });
      }); });
    })();
    var inst=_cpf3Deep(d,/^(quantidadeinstituicoes|qtdinstituicoes|instituicoes)$/);
    var oper=_cpf3Deep(d,/^(quantidadeoperacoes|qtdoperacoes|operacoes)$/);
    var desde=_cpf3Deep(d,/^(datainiciorelacionamento|iniciorelacionamento|relacionamentodesde)$/);
    var partes=[]; if(inst!=null) partes.push(inst+' instituições'); if(oper!=null) partes.push(oper+' operações');
    if(desde) partes.push('relacionamento desde '+String(desde));
    p.relacao=partes.join(' · ');
    p.raw=d;
    return p;
  }
  function cpfScorePanelHtml(dd, docFallback, integrado){
    var p=cpfScoreParse(dd||{});
    var docm=_maskDoc((dd&&dd.documento)||p.doc||docFallback||'')||'';
    var html=integrado?'':'<div class="cpf-score-doc">CPF consultado: <b>'+esc(docm)+'</b></div>';
    if(p.score!=null){
      var f=_scoreFaixa(p.score);
      var tom=f[0]==='BOM'?'is-bom':(f[0]==='REGULAR'?'is-regular':'is-ruim');
      html+='<div class="cpf-score-card '+tom+'">'
        +'<div class="cpf-score-kicker">Score bancário</div>'
        +'<div class="cpf-score-valor">'+esc(String(p.score))+'</div>'
        +'<div class="cpf-score-faixa">'+f[0]+'</div></div>';
    }
    if(p.resumo.length){                                   /* v608: card que abre */
      var _rs='<div class="cpf3-kv">';
      p.resumo.forEach(function(r){ _rs+='<div class="cpf3-lin"><span>'+esc(r[0])+'</span><b>'+esc(brl(r[1]))+'</b></div>'; });
      /* v610: vencido ou prejuízo acima de zero = alerta; só "a vencer" = ✓ */
      var _ruim=p.resumo.some(function(r){ return /vencido|preju/i.test(r[0]) && Number(r[1])>0; });
      html+=_cpfBloco('Resumo consolidado', _rs+'</div>', false, _ruim?'no':'ok');
    }
    if(p.modalidades.length){
      var _md='<div class="cpf3-kv">';
      p.modalidades.forEach(function(m){ _md+='<div class="cpf3-lin"><span>'+esc(m.nome)+'</span><b>'+esc(brl(m.valor))+(m.pct?(' <span class="cpf-score-pct">· '+esc(m.pct)+'%</span>'):'')+'</b></div>'; });
      html+=_cpfBloco('Modalidades', _md+'</div>');
    }
    if(p.relacao) html+='<div class="plc-msg cpf-score-relacao">'+esc(p.relacao)+'</div>';
    if(p.score==null && !p.resumo.length && !p.modalidades.length){
      html+='<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:12px;padding:10px 13px;margin:4px 0 8px;color:#1e3a8a;font-size:12px">A base respondeu, mas sem os campos que este relatório desenha. Confira os dados abaixo.</div>'
        +'<div style="background:#fff;border:1px solid #e8eef7;border-radius:12px;padding:10px 12px">'+renderVal(_cpfRawSeguro(p.raw))+'</div>';
    }
    /* ⚠️ SEM a classe .pdf-btn (lição da v595, que o teste pegou DE NOVO
       aqui): no celular ela é escondida por CSS e vira o FAB verde, que
       clica o PRIMEIRO .pdf-btn da tela. Botão próprio, sempre visível. */
    if(!integrado){
      html+='<button type="button" id="cpfScorePdf" style="width:100%;margin-top:12px;display:flex;align-items:center;justify-content:center;gap:8px;background:#fff;color:#0a4da6;border:1.5px solid #bfdbfe;border-radius:11px;padding:12px;font-size:13.5px;font-weight:800;cursor:pointer;font-family:inherit">'+ICO_PDF+' Baixar em PDF</button>';
      html+='<div class="plc-msg cpf-score-lgpd">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018). Dados informados pela base na data da consulta.</div>';
    }
    return html;
  }
  /* ==========================================================================
     🔴🔴 v1024 — AÇÕES E PROCESSOS (acoes-processos-judiciais)
     --------------------------------------------------------------------------
     O DEFEITO QUE ESTA VERSÃO CONSERTA — e ele é do pior tipo que este app já
     teve, porque dizia "LIMPO" para quem não está.

     Desde a v599 o leitor procurava a lista de processos por ADIVINHAÇÃO: um
     array cujo primeiro item tivesse chave casando com
         /^(numeroprocesso|numero|processo)$/
     Na resposta real desta API a chave é `numeroProcessoUnico` — normalizada,
     `numeroprocessounico` — que NÃO casa com nenhuma das três. `achou` ficava
     nulo, a lista saía com ZERO processos e a tela pintava a tarja VERDE
     "✓ Nenhum processo encontrado" num CPF com três ações, uma delas criminal.
     O lojista pagou R$ 10,32 para receber informação errada, e errada para o
     lado perigoso.

     E mesmo se a lista fosse achada, quatro campos sairiam errados:
       · classe  → `classeProcessual` é OBJETO {codigoCnj,nome}: imprimia
                   "[object Object]";
       · assunto → a chave é `assuntosCNJ` (array), não "assunto": vinha vazio;
       · polo    → mora em `informacoesPartePessoaConsultada[]`, não no nível
                   do processo — sumia a ÚNICA coisa que muda a decisão do
                   lojista: RÉU ou AUTOR;
       · status  → é `statusPj.statusProcesso`, um nível abaixo.

     🔴 AS DUAS REGRAS QUE FICAM ESCRITAS AQUI:
     (1) ACHAR PELO CAMINHO, NÃO PELO PALPITE. O caminho conhecido
         (`acoesProcessos.acoes.processos`) é tentado PRIMEIRO; a busca larga
         é rede de segurança, não o plano.
     (2) SILÊNCIO NUNCA VIRA VERDE. A tarja verde só aparece quando a resposta
         VEIO e veio VAZIA — com prova disso. Lista não encontrada,
         `documentoNaoEncontrado:true` ou `possuiErro:true` viram
         "não foi possível ler o retorno desta consulta", e o servidor
         ESTORNA. É a mesma lição da v1000 ("vazio não é limpo") e do grep que
         mentiu duas vezes.

     ⚠️ ESTE LEITOR É UM SÓ, e serve CPF e CNPJ (`cnpj_processos`, v1024). O
     corpo da resposta é o MESMO; o que muda é o documento consultado e o
     rótulo da tela. Duas cópias do mesmo parser é garantia de que uma fica
     para trás.
     ========================================================================== */
  var _PROC_CHAVE=/^(numeroprocessounico|numeroprocesso|numerounico|numerocnj|numero|processo)$/;
  /* caminhos conhecidos, na ordem em que valem — o primeiro que existir ganha */
  var _PROC_CAMINHOS=['acoesProcessos.acoes.processos','acoesProcessos.processos','acoes.processos',
                      'resultado.acoesProcessos.acoes.processos','data.acoesProcessos.acoes.processos','processos'];
  function _procEm(o,caminho){
    var no=o, parts=String(caminho).split('.');
    for(var j=0;j<parts.length;j++){
      if(no && typeof no==='object' && parts[j] in no) no=no[parts[j]];
      else return undefined;
    }
    return no;
  }
  /* "aaaa-mm-dd hh:mm:ss" → dd/mm/aaaa (e deixa passar o que já vier pronto) */
  function _procData(v){
    var s=String(v==null?'':v).trim(); if(!s) return '';
    var m=s.match(/^(\d{4})-(\d{2})-(\d{2})/); if(m) return m[3]+'/'+m[2]+'/'+m[1];
    var b=s.match(/^(\d{2})\/(\d{2})\/(\d{4})/); if(b) return b[1]+'/'+b[2]+'/'+b[3];
    return s;
  }
  /* chave de ORDENAÇÃO (aaaammdd) — texto, pra comparar sem Date() e sem fuso */
  function _procOrd(v){
    var s=String(v==null?'':v).trim();
    var m=s.match(/^(\d{4})-(\d{2})-(\d{2})/); if(m) return m[1]+m[2]+m[3];
    var b=s.match(/^(\d{2})\/(\d{2})\/(\d{4})/); if(b) return b[3]+b[2]+b[1];
    return '00000000';
  }
  /* 🔴 NUNCA IMPRIMIR OBJETO CRU: se vier {codigoCnj,nome}, sai o .nome */
  function _procTexto(v){
    if(v==null) return '';
    if(Array.isArray(v)) return v.map(_procTexto).filter(Boolean).join(', ');
    if(typeof v==='object'){ var n=_cpf3Key(v,/^(nome|titulo|descricao|valor|texto)$/); return n==null?'':_procTexto(n); }
    return String(v).trim();
  }
  function _procSim(v){ if(v===true) return true; return /^(sim|true|s|1)$/i.test(String(v==null?'':v).trim()); }
  /* procura um sinalizador booleano VERDADEIRO em qualquer nível */
  function _procFlag(o,re,prof){
    prof=prof||0; if(!o||typeof o!=='object'||prof>6) return false;
    if(Array.isArray(o)){ for(var a=0;a<o.length;a++){ if(_procFlag(o[a],re,prof+1)) return true; } return false; }
    var ks=Object.keys(o), i;
    for(i=0;i<ks.length;i++){ if(re.test(ks[i].toLowerCase().replace(/[^a-z0-9]/g,'')) && _procSim(o[ks[i]])) return true; }
    for(i=0;i<ks.length;i++){ var v=o[ks[i]]; if(v&&typeof v==='object'&&_procFlag(v,re,prof+1)) return true; }
    return false;
  }
  /* 🔴 ISTO AQUI TEM NOME E TEM VÍTIMA: a busca larga da v599 aceitava
     QUALQUER array cujo primeiro item tivesse uma chave "numero" — e a lista
     de TELEFONES do bloco cadastral tem exatamente isso. Alimentado com a
     resposta real, o leitor velho devolvia "1 processo" que era um telefone,
     com classe, assunto e polo em branco. Um número de telefone desenhado na
     tela como ação judicial.
     Por isso o reconhecimento pede PROVA: uma chave que só processo tem
     (numeroProcessoUnico, numeroCNJ, classeProcessual), ou um "numero"
     ACOMPANHADO de pelo menos um campo de processo. */
  var _PROC_PROVA=/^(numeroprocessounico|numerocnj|numerounico|classeprocessual)$/;
  var _PROC_APOIO=/^(tribunal|classe|assunto|assuntos|assuntoscnj|polo|statuspj|vara|orgaojulgador|grauprocesso|datadistribuicao|dataautuacao|valorcausa|segredojustica|informacoespartepessoaconsultada)$/;
  function _procParece(x){
    if(!x || typeof x!=='object') return false;
    if(_cpf3Key(x,_PROC_PROVA)!=null) return true;
    return _cpf3Key(x,_PROC_CHAVE)!=null && _cpf3Key(x,_PROC_APOIO)!=null;
  }
  /* acha a LISTA: caminho conhecido primeiro; busca larga só como reserva */
  function _procAcharLista(d){
    for(var i=0;i<_PROC_CAMINHOS.length;i++){
      var v=_procEm(d,_PROC_CAMINHOS[i]);
      if(Array.isArray(v)) return v;
    }
    var achou=null;
    (function cava(o,prof){
      if(achou||!o||typeof o!=='object'||prof>6) return;
      if(Array.isArray(o)){
        if(o.length && typeof o[0]==='object' && _procParece(o[0])) achou=o;
        return;
      }
      Object.keys(o).forEach(function(k){ cava(o[k],prof+1); });
    })(d,0);
    return achou;
  }
  /* um processo, campo por campo, pelo NOME REAL da resposta */
  function _procUm(x){
    var o={ raw:x };
    o.numero=_procTexto(_cpf3Key(x,_PROC_CHAVE));
    o.classe=_procTexto(_cpf3Key(x,/^(classeprocessual|classe)$/));
    /* assuntos: o principal:true em destaque, os outros numa linha abaixo */
    var asr=_cpf3Key(x,/^(assuntoscnj|assuntos|assunto|assuntoprincipal)$/);
    var lista=Array.isArray(asr)?asr:(asr?[asr]:[]), princ='', outros=[];
    lista.forEach(function(a){
      var t=_procTexto((a&&typeof a==='object')?_cpf3Key(a,/^(titulo|nome|descricao|assunto)$/):a);
      if(!t) return;
      if((a&&typeof a==='object') && _procSim(_cpf3Key(a,/^(principal)$/)) && !princ) princ=t;
      else outros.push(t);
    });
    if(!princ && outros.length) princ=outros.shift();
    o.assunto=princ; o.assuntos=outros;
    /* 🔴 O POLO É O QUE MUDA A DECISÃO: réu ≠ autor. Ele mora no bloco da
       PESSOA CONSULTADA — não no nível do processo, e não em partes[] (ali
       estão TODOS, inclusive o outro lado). */
    var pol='', tip='';
    var ip=_cpf3Key(x,/^(informacoespartepessoaconsultada)$/);
    if(Array.isArray(ip)&&ip.length&&ip[0]&&typeof ip[0]==='object'){
      pol=_procTexto(_cpf3Key(ip[0],/^(polo)$/)); tip=_procTexto(_cpf3Key(ip[0],/^(tipo)$/));
    }
    if(!pol){
      var tp=_cpf3Key(x,/^(tipopartepessoaconsultada)$/);
      if(Array.isArray(tp)&&tp.length) pol=_procTexto(tp[0]); else if(tp) pol=_procTexto(tp);
    }
    if(!pol){
      var pts=_cpf3Key(x,/^(partes)$/);
      if(Array.isArray(pts)&&pts.length&&pts[0]&&typeof pts[0]==='object') pol=_procTexto(_cpf3Key(pts[0],/^(polo)$/));
    }
    o.polo=pol; o.poloTipo=tip;
    /* status mora um nível abaixo, em statusPj */
    var st=_cpf3Key(x,/^(statuspj|status|situacao)$/), julgs=null;
    if(st && typeof st==='object'){
      o.status=_procTexto(_cpf3Key(st,/^(statusprocesso|status|situacao)$/));
      o.ramo=_procTexto(_cpf3Key(st,/^(ramodireito|ramo)$/));
      o.arquivadoEm=_procData(_cpf3Key(st,/^(dataarquivamento)$/));
      julgs=_cpf3Key(st,/^(julgamentos)$/);
    } else {
      o.status=_procTexto(st); o.ramo=''; o.arquivadoEm='';
    }
    if(!julgs) julgs=_cpf3Key(x,/^(julgamentos)$/);
    o.julgamento='';
    if(Array.isArray(julgs)&&julgs.length){
      var melhor=null, melhorOrd='';
      julgs.forEach(function(j){
        if(!j||typeof j!=='object') return;
        var od=_procOrd(_cpf3Key(j,/^(datajulgamento|data)$/));
        if(!melhor || od>=melhorOrd){ melhor=j; melhorOrd=od; }
      });
      if(melhor){
        var jt=_procTexto(_cpf3Key(melhor,/^(statusjulgamento|tipojulgamento|status)$/));
        var jd=_procData(_cpf3Key(melhor,/^(datajulgamento|data)$/));
        o.julgamento=[jt,jd].filter(Boolean).join(' · ');
      }
    }
    o.tribunal=_procTexto(_cpf3Key(x,/^(tribunal)$/));
    o.uf=_procTexto(_cpf3Key(x,/^(uf|estado)$/));
    o.orgao=_procTexto(_cpf3Key(x,/^(orgaojulgador|vara|foro|orgao)$/));
    o.grau=_procTexto(_cpf3Key(x,/^(grauprocesso|grau|instancia)$/));
    o.dataBruta=_cpf3Key(x,/^(datadistribuicao|dataautuacao|dataprocessamento|data)$/);
    o.data=_procData(o.dataBruta);
    o.ord=_procOrd(o.dataBruta);
    /* valor da causa: 0 não é informação — não vira linha na tela */
    var vc=_cpf3Key(x,/^(valorcausa)$/);
    var vn=(vc&&typeof vc==='object')?_cpfNum(_cpf3Key(vc,/^(valor)$/)):_cpfNum(vc);
    o.valor=(vn!=null && vn>0)?vn:null;
    o.segredo=_procSim(_cpf3Key(x,/^(segredojustica|segredodejustica)$/));
    return o;
  }
  function _procPassivo(o){ return /r[eé]u|passiv|requerid|executad|indiciad|denunciad|autor do fato/i.test(String(o.polo||'')+' '+String(o.poloTipo||'')); }
  function _procAtivo(o){ return !_procPassivo(o) && /autor|ativ|requerent|exequent|promovent|reclamant|impetrant/i.test(String(o.polo||'')+' '+String(o.poloTipo||'')); }
  function _procArquivado(o){ return /arquiv|baixad|extint|transitad/i.test(String(o.status||'')) || !!o.arquivadoEm; }
  function cpfProcParse(dd){
    var d=(dd&&dd.data)||dd||{};
    /* 🔴 v1024 — TRÊS ESTADOS, NUNCA DOIS (mesma regra do Compliance, v1000):
         'ok'      → a lista veio e tem processos
         'vazio'   → a lista VEIO e veio vazia            → só aqui é verde
         'naolido' → não deu pra ler a resposta           → nunca é verde */
    var p={ processos:[], total:0, estado:'naolido', motivo:'', cadastral:null, raw:d,
            resumo:{ total:0, tramitando:0, arquivados:0, passivo:0, ativo:0, ramos:[], somaPassivo:0 } };
    var naoEncontrado=_procFlag(d,/^(documentonaoencontrado|documentonaolocalizado)$/);
    var possuiErro=_procFlag(d,/^(possuierro|erro|haerro)$/);
    var lista=_procAcharLista(d);
    if(naoEncontrado){ p.motivo='nao_encontrado'; return p; }
    if(possuiErro){ p.motivo='erro'; return p; }
    if(!Array.isArray(lista)){ p.motivo='sem_lista'; return p; }
    p.total=lista.length;
    var todos=[];
    lista.forEach(function(x){ if(x && typeof x==='object') todos.push(_procUm(x)); });
    /* 4.3 — do mais novo para o mais antigo pela data de distribuição */
    todos.sort(function(a,b){ return a.ord<b.ord?1:(a.ord>b.ord?-1:0); });
    p.total=todos.length;
    p.estado=todos.length?'ok':'vazio';
    /* 4.4 — trunca em 30, mas DIZ que truncou */
    p.processos=todos.slice(0,30);
    /* 4.5 — o resumo é o que o lojista compra: um processo de 2019 arquivado
       não pesa como um em andamento, e réu não é a mesma coisa que autor. */
    var r=p.resumo, vistos={};
    r.total=todos.length;
    todos.forEach(function(o){
      if(_procArquivado(o)) r.arquivados++; else if(o.status) r.tramitando++;
      if(_procPassivo(o)){ r.passivo++; if(o.valor) r.somaPassivo+=o.valor; }
      else if(_procAtivo(o)) r.ativo++;
      var rm=String(o.ramo||'').trim();
      if(rm && !vistos[rm.toLowerCase()]){ vistos[rm.toLowerCase()]=1; r.ramos.push(rm); }
    });
    /* 6(B) — do pacote cadastral guardamos SÓ nome e cidade/UF. Nome da mãe,
       nascimento, telefone e endereço não ajudam a decidir uma compra de
       veículo, e cada campo a mais é um campo a mais para vazar. */
    p.cadastral=_procCadastralCurto(d);
    return p;
  }
  /* 🔴 v1024 · LGPD, opção (B) do projeto de 15/09.
     O retorno traz um pacote cadastral inteiro: nome, NOME DA MÃE, data de
     nascimento, e-mails, telefones e endereços. Antes isso ia pra tela e pro
     PDF num despejo cru (renderVal(_cpfRawSeguro(raw))) — o _cpfRawSeguro
     mascara nome da mãe e CPF, mas deixa passar e-mail, telefone, endereço e
     nascimento. Agora sai SÓ nome e cidade/UF. Se um dia "localizar cliente"
     virar produto, que seja consulta própria, com preço e finalidade próprios. */
  function _procCadastralCurto(d){
    var c=_procEm(d,'cadastralCompleto'); if(c===undefined) c=_procEm(d,'cadastral');
    if(!c||typeof c!=='object') return null;
    var nome=_procTexto(_cpf3Key(c,/^(nome|nomecompleto|razaosocial|nomeempresarial)$/));
    var cidade='', uf='';
    var end=_cpf3Key(c,/^(enderecos|endereco)$/);
    var e0=Array.isArray(end)?end[0]:end;
    if(e0&&typeof e0==='object'){
      cidade=_procTexto(_cpf3Key(e0,/^(cidade|municipio|localidade)$/));
      uf=_procTexto(_cpf3Key(e0,/^(uf|estado|siglauf)$/));
    }
    if(!cidade) cidade=_procTexto(_cpf3Key(c,/^(cidade|municipio)$/));
    if(!uf) uf=_procTexto(_cpf3Key(c,/^(uf|estado)$/));
    if(!nome && !cidade && !uf) return null;
    return { nome:nome, cidade:cidade, uf:uf };
  }
  /* o texto do estado "não deu pra ler" — um só, tela e PDF dizem a mesma coisa */
  function _procMotivoTexto(p){
    if(p.motivo==='nao_encontrado') return 'A base não localizou este documento. Não foi possível ler o retorno desta consulta.';
    if(p.motivo==='erro') return 'A base respondeu com erro. Não foi possível ler o retorno desta consulta.';
    return 'Não foi possível ler o retorno desta consulta.';
  }
  function _procResumoLinhas(p){
    var r=p.resumo, L=[];
    if(r.tramitando) L.push(['Em tramitação', String(r.tramitando)]);
    if(r.arquivados) L.push(['Arquivados', String(r.arquivados)]);
    if(r.passivo) L.push(['Como parte passiva (réu)', String(r.passivo)]);
    if(r.ativo) L.push(['Como parte ativa (autor)', String(r.ativo)]);
    if(r.ramos.length) L.push(['Ramos do direito', r.ramos.join(', ')]);
    if(r.somaPassivo>0) L.push(['Valor de causa como parte passiva', _brl(r.somaPassivo)]);
    return L;
  }
  function _procPoloRotulo(x){
    var polo=String(x.polo||'').trim(), tipo=String(x.poloTipo||'').trim();
    if(!polo) return tipo;
    if(!tipo) return polo;
    var limpo=function(v){ return String(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,''); };
    var a=limpo(polo), b=limpo(tipo);
    if(a===b || (a.indexOf('terceirointeress')>=0 && b.indexOf('terceirointeress')>=0)) return polo;
    return polo+' · '+tipo;
  }
  /* pinta um processo — tela. `segredo` corta assunto e partes daquele item. */
  function _procCartaoHtml(x){
    var reu=_procPassivo(x), aut=_procAtivo(x);
    var rot=_procPoloRotulo(x);
    var pol = rot ? ('<span class="cpf3-polo '+(reu?'is-passivo':(aut?'is-ativo':'is-neutro'))+'">'+esc(rot.toUpperCase())+'</span>') : '';
    var sub=[x.tribunal,x.orgao,x.uf,x.grau].filter(Boolean).join(' · ');
    var sit=[];
    if(x.status) sit.push(x.status);
    if(x.arquivadoEm) sit.push('Arquivado em '+x.arquivadoEm);
    if(x.data) sit.push('Distribuído em '+x.data);
    var h='<div class="cpf3-proc">'
      +'<div class="cpf3-proc-h"><b>'+esc(x.numero||'Processo')+'</b>'+pol+'</div>';
    if(x.segredo){
      h+='<div class="cpf3-proc-l cpf3-proc-segredo">Processo em segredo de justiça — assunto e partes não são exibidos.</div>';
    } else {
      if(x.classe) h+='<div class="cpf3-proc-l"><b>'+esc(x.classe)+'</b></div>';
      if(x.assunto) h+='<div class="cpf3-proc-l">'+esc(x.assunto)+'</div>';
      if(x.assuntos&&x.assuntos.length) h+='<div class="cpf3-proc-s">Também: '+esc(x.assuntos.join(' · '))+'</div>';
    }
    if(sub) h+='<div class="cpf3-proc-s">'+esc(sub)+'</div>';
    if(sit.length) h+='<div class="cpf3-proc-s">'+esc(sit.join(' · '))+'</div>';
    if(x.ramo) h+='<div class="cpf3-proc-s">Ramo: '+esc(x.ramo)+'</div>';
    if(x.julgamento) h+='<div class="cpf3-proc-s">Julgamento: '+esc(x.julgamento)+'</div>';
    if(x.valor) h+='<div class="cpf3-proc-s">Valor da causa: '+esc(_brl(x.valor))+'</div>';
    return h+'</div>';
  }
  function cpfProcPanelHtml(dd, ehCnpj){
    var p=cpfProcParse(dd||{});
    var docm=_maskDoc((dd&&dd.documento)||'')||'';
    var n=p.processos.length, T=p.resumo.total;
    var rotDoc = ehCnpj ? 'CNPJ consultado' : 'CPF consultado';
    var quem = ehCnpj ? 'a empresa' : 'a pessoa';
    var html='<div style="font-size:11px;color:#64748b;margin:2px 0 3px">'+esc(rotDoc)+': <b>'+esc(docm)+'</b></div>';
    /* 🔴 4.6 — SILÊNCIO NUNCA VIRA VERDE */
    if(p.estado==='naolido'){
      html+='<div style="background:#fffbeb;border:1px solid #fde68a;border-left:6px solid #d97706;border-radius:12px;padding:10px 13px;margin:4px 0 10px">'
        +'<div style="font-weight:800;color:#b45309;font-size:14px">Não foi possível ler o retorno desta consulta</div>'
        +'<div style="font-size:12px;color:#92400e;margin-top:4px">'+esc(_procMotivoTexto(p))+'</div>'
        +'<div style="font-size:11.5px;color:#92400e;margin-top:4px">Isto <b>não</b> quer dizer que não existam processos — quer dizer que a base não respondeu de forma legível.</div></div>';
      html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018).</div>';
      return html;
    }
    html += T
      ? '<div class="cpf-proc-status is-alerta"><span class="cpf-proc-status-ico" aria-hidden="true">'+_CPF_ICO.no+'</span><div><strong>'+T+' processo'+(T===1?'':'s')+' encontrado'+(T===1?'':'s')+'</strong></div></div>'
      : '<div class="cpf-proc-status is-ok"><span class="cpf-proc-status-ico" aria-hidden="true">'+_CPF_ICO.ok+'</span><div><strong>Nenhum processo encontrado</strong><small>A base respondeu e não encontrou processos para '+esc(quem)+'.</small></div></div>';
    /* 4.5 — o resumo, logo abaixo do total */
    var _rl=_procResumoLinhas(p);
    if(_rl.length){
      var _rh='';
      _rl.forEach(function(kv){
        var longa=kv[0]==='Ramos do direito';
        _rh+='<div class="cpf-proc-resumo-linha'+(longa?' is-longa':'')+'">'
          +'<span class="cpf-proc-resumo-rotulo">'+esc(kv[0])+'</span>'
          +'<span class="cpf-proc-resumo-valor">'+esc(kv[1])+'</span></div>';
      });
      html+=_cpfBloco('Resumo', _rh, true, p.resumo.passivo?'no':'at');
    }
    var _pc='';
    p.processos.forEach(function(x){ _pc+=_procCartaoHtml(x); });
    if(n<T) _pc+='<div class="cpf3-proc-s" style="margin-top:6px">Mostrando '+n+' de '+T+' processos.</div>';
    if(_pc) html+=_cpfBloco('Processos ('+T+')', _pc, false, 'no');
    /* 6(B): só nome e cidade/UF */
    if(p.cadastral){
      var _cc='';
      if(p.cadastral.nome) _cc+='<div class="cpf3-proc-l"><b>'+esc(p.cadastral.nome)+'</b></div>';
      var _loc=[p.cadastral.cidade,p.cadastral.uf].filter(Boolean).join(' / ');
      if(_loc) _cc+='<div class="cpf3-proc-s">'+esc(_loc)+'</div>';
      if(_cc) html+=_cpfBloco('Identificação', '<div class="cpf3-proc">'+_cc+'</div>', false);
    }
    /* mesmo motivo do card do score: botão próprio, sem .pdf-btn */
    html+='<button type="button" id="cpfProcPdf" style="width:100%;margin-top:12px;display:flex;align-items:center;justify-content:center;gap:8px;background:#fff;color:#0a4da6;border:1.5px solid #bfdbfe;border-radius:11px;padding:12px;font-size:13.5px;font-weight:800;cursor:pointer;font-family:inherit">'+ICO_PDF+' Baixar em PDF</button>';
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018). Confirme nos tribunais antes de usar em documento.</div>';
    return html;
  }
  /* ---- Detalhamento Negativo: interpreta o retorno (campos reais da API) ---- */
  var _restState=null;
  function _humaniza(k){ return String(k).replace(/([a-z0-9])([A-Z])/g,'$1 $2').replace(/_/g,' ').replace(/\s+/g,' ').trim().replace(/(^|\s)\S/g,function(c){return c.toUpperCase();}); }
  var _VAZIO=/^\s*(nenhum registro|nao consta|não consta|nao existe[m]?|não existe[m]?|nada consta|inexist|^0$|^-$|^null$|nao foram encontrad|não foram encontrad)\b/i;
  function _restVazio(v){ if(v==null) return true; var s=String(v).trim(); if(!s) return true; return _VAZIO.test(s.toLowerCase()); }
  function restParse(dd){
    dd=dd||{}; var base=dd.resultado||dd; base=base.response||base.dados||base.data||base;
    var cr=_findConsultaCredito(base)||_findConsultaCredito(dd);
    if(cr) return _restAcertaPositivo(cr, base);
    var cc=base.credcadastral||(base.data&&base.data.credcadastral)||null;
    if(cc) return _restAcerta(cc);
    return _restNegativo(dd, base);
  }
  /* localiza o bloco "ConsultaCredito" (Acerta Essencial Positivo) em QUALQUER nível
     — busca em profundidade, tolera qualquer embrulho que a API/gateway use */
  function _findConsultaCredito(o){ return _fccDeep(o,0); }
  function _fccDeep(o,depth){
    if(!o||typeof o!=='object'||depth>8) return null;
    /* percorre também LISTAS (o gateway às vezes embrulha o retorno num array) */
    if(Array.isArray(o)){ for(var ai=0;ai<o.length;ai++){ var fa=_fccDeep(o[ai],depth+1); if(fa) return fa; } return null; }
    if(o.ConsultaCredito&&typeof o.ConsultaCredito==='object') return o.ConsultaCredito;
    /* tolera variações de escrita da chave ("consulta_credito", "consultaCredito"…) */
    for(var kk in o){ if(!Object.prototype.hasOwnProperty.call(o,kk)) continue;
      if(String(kk).toLowerCase().replace(/[^a-z]/g,'')==='consultacredito' && o[kk] && typeof o[kk]==='object' && !Array.isArray(o[kk])) return o[kk];
    }
    /* é o próprio bloco de crédito? (tem dados cadastrais + qualquer sinal de crédito) */
    /* v372: reconhece o bloco em qualquer grafia (PascalCase ou camelCase) */
    if(_ciKey(o,['DadosCadastrais'])!=null && (
         _ciKey(o,['ResumoConsulta'])!=null || _ciKey(o,['Score'])!=null ||
         _ciKey(o,['PendenciasFinanceiras'])!=null || _ciKey(o,['ResumoRetorno'])!=null ||
         _ciKey(o,['ContratosRecentes'])!=null || _ciKey(o,['AcoesCiveis'])!=null ||
         _ciKey(o,['ChequesSemFundo'])!=null || _ciKey(o,['ChequesSustados'])!=null ||
         _ciKey(o,['Protestos'])!=null)) return o;
    for(var k in o){ if(!Object.prototype.hasOwnProperty.call(o,k)) continue; var v=o[k];
      if(v&&typeof v==='object'){ var f=_fccDeep(v,depth+1); if(f) return f; } }
    return null;
  }
  function _rNum(x){ var n=_debNum(x); return isNaN(n)?0:n; }
  function _fmtCpf(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,11); var o=d.slice(0,3); if(d.length>3)o+='.'+d.slice(3,6); if(d.length>6)o+='.'+d.slice(6,9); if(d.length>9)o+='-'+d.slice(9,11); return o; }
  function _asList(v){ if(v==null) return []; if(Array.isArray(v)) return v.filter(function(x){return x&&typeof x==='object';}); if(typeof v==='object') return [v]; return []; }
  /* ---- Acerta Essencial Positivo (estrutura AcertaEssencialPositivo → ConsultaCredito) ---- */
  /* ===== v372 — LER A RESPOSTA SEM SE IMPORTAR COM MAIÚSCULA/MINÚSCULA =====
     BUG QUE ISTO CONSERTA (achado em 10/08/2026 conferindo uma consulta real):
     o provedor Acerta manda as chaves em camelCase (`pendenciasFinanceiras`,
     `dadosCadastrais`, `score`) e este arquivo lia em PascalCase
     (`PendenciasFinanceiras`…). Como o BLOCO em si era encontrado, o app
     entrava no caminho "estrutura conhecida" e afirmava "✓ Nada consta" com
     confiança — mesmo quando a base tinha devolvido dívida. Score, nome,
     renda e endereço também sumiam da tela.
     Reproduzido: com R$ 12.500 de pendência e R$ 3.000 de protesto na
     resposta, a tela dizia "Nada consta" nas cinco linhas.

     REGRA DAQUI PRA FRENTE: nunca ler chave de API por acesso direto neste
     arquivo. Use _ciKey/_ciTxt — eles comparam o nome da chave sem maiúscula,
     "_" nem "-", então PascalCase, camelCase e snake_case funcionam todos. */
  function _ciKey(obj, nomes){
    if(!obj || typeof obj!=='object') return undefined;
    for(var i=0;i<nomes.length;i++){
      var alvo=String(nomes[i]).toLowerCase().replace(/[^a-z0-9]/g,'');
      for(var k in obj){ if(!Object.prototype.hasOwnProperty.call(obj,k)) continue;
        if(String(k).toLowerCase().replace(/[^a-z0-9]/g,'')===alvo) return obj[k];
      }
    }
    return undefined;
  }
  /* mesma busca, já devolvendo texto limpo ('' quando não existe ou é "null") */
  function _ciTxt(obj){
    var v=_ciKey(obj, Array.prototype.slice.call(arguments,1));
    if(v==null || typeof v==='object') return '';
    var s=String(v).trim();
    return (!s || s.toLowerCase()==='null') ? '' : s;
  }
  /* v449 — MESMA BUSCA, MAS EM QUALQUER NÍVEL (e dentro de listas).
     O _ciKey só olha o primeiro andar do objeto. Numa resposta real da API
     Brasil o `resumoRetorno` (protocolo + data da consulta) vem TRÊS andares
     abaixo — response > data > dados[0] > resumoRetorno — então o rodapé do
     PDF saía sem protocolo e sem data, justo o que prova a consulta se o
     cliente questionar. O `scoreRating` (2ª base) vem no mesmo lugar. */
  function _ciDeep(o, nomes, depth){
    depth=depth||0;
    if(!o || typeof o!=='object' || depth>8) return undefined;
    if(!Array.isArray(o)){ var d=_ciKey(o, nomes); if(d!=null) return d; }
    for(var k in o){ if(!Object.prototype.hasOwnProperty.call(o,k)) continue;
      var v=o[k];
      if(v && typeof v==='object'){ var f=_ciDeep(v, nomes, depth+1); if(f!=null) return f; }
    }
    return undefined;
  }
  /* "00400" é como a base escreve 4,00% de chance de NÃO pagar (2 casas
     coladas). Se vier já com ponto/vírgula, respeita o que veio. */
  /* v515 — o teto de baixo passou de 3 para 1 dígito. Conferido em quatro
     respostas reais ("03400"=34% · 2500=25% · 600=6% · 400=4%): a base SEMPRE
     manda em centésimos colados. Com o {3,6} antigo, um valor de 1 ou 2
     dígitos ("50" = 0,50%) escapava pro parseFloat lá embaixo e virava
     50,00% — cem vezes maior, num número que o lojista usa pra decidir
     crédito. Nunca aconteceu nas quatro, mas custava uma linha. */
  function _probPct(v){
    var s=String(v==null?'':v).trim(); if(!s) return '';
    if(/^\d{1,6}$/.test(s)){ var n=parseInt(s,10)/100; return n.toFixed(2).replace('.',',')+'%'; }
    var m=parseFloat(s.replace(',','.')); if(isNaN(m)) return '';
    return m.toFixed(2).replace('.',',')+'%';
  }
  function _restAcertaPositivo(cr, base){
    cr=cr||{};
    var dc=_ciKey(cr,['DadosCadastrais'])||{};
    var rc=_ciKey(cr,['ResumoConsulta'])||{};
    /* conta pelo ResumoConsulta quando existe; senão, conta direto pelas listas
       (a variante "positivo" traz AcoesCiveis/Cheques… soltos, sem resumo) */
    function resumo(k){
      var o=_ciKey(rc,[k]);
      if(o&&typeof o==='object'){
        var q=_ciKey(o,['QuantidadeTotal','Quantidade','Total']);
        var v=_ciKey(o,['ValorTotal','Valor']);
        if(q!=null||v!=null) return { q:parseInt(String(q==null?0:q).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0, v:_rNum(v) };
      }
      var dir=_ciKey(cr,[k]);
      /* sem resumo, soma o valor das próprias linhas */
      if(Array.isArray(dir)) return { q:dir.length, v:dir.reduce(function(s,x){ return s+_rNum(_ciKey(x,['Valor','ValorTotal'])); },0) };
      if(dir&&typeof dir==='object') return { q:1, v:_rNum(_ciKey(dir,['Valor','ValorTotal'])) };
      if(typeof dir==='string'&&dir.trim()&&!_restVazio(dir)) return { q:1, v:0 };
      return { q:0, v:0 };
    }
    var rPend=resumo('PendenciasFinanceiras'), rProt=resumo('Protestos'), rAc=resumo('AcoesCiveis'), rCsf=resumo('ChequesSemFundo'), rCss=resumo('ChequesSustados');
    /* ===== 🔴 v518 (CAMADA A) — O GALHO QUE NINGUÉM VISITAVA ===============
       O `protestoNacional` é IRMÃO do `acertaEssencialPositivo`, não filho:
       ele nunca passava por aqui, e a tela dizia "Protestos — Nada consta"
       pra quem tem protesto em CARTÓRIO. Agora o item mostra a SOMA das duas
       fontes. Ver o 03c pra o porquê de contar pelo resumo quando ele
       existe, e pra a trava que impede contar o mesmo protesto duas vezes. */
    var _pn = (typeof cpfProtestoNacional==='function') ? cpfProtestoNacional(base) : { q:0, v:0, lista:[] };
    var _protLista = (typeof cpfProtestoJuntar==='function')
      ? cpfProtestoJuntar(cpfProtestoBiro(cr), _pn.lista) : [];
    var rProtTot = { q: rProt.q + _pn.q, v: rProt.v + _pn.v };
    function it(rot,r){ return { rot:rot, ruim:r.q>0, det: r.q>0?(r.q+' registro(s)'+(r.v>0?(' · '+_brl(r.v)):'')):'Nada consta' }; }
    var itens=[ it('Pendências financeiras',rPend), it('Protestos',rProtTot), it('Ações cíveis',rAc), it('Cheques sem fundo',rCsf), it('Cheques sustados',rCss) ];
    var tem=itens.some(function(i){return i.ruim;});
    var total=rPend.q+rProtTot.q+rAc.q+rCsf.q+rCss.q;
    var pend=_asList(_ciKey(cr,['PendenciasFinanceiras'])).map(function(o){
      return { informante:_ciTxt(o,'Informante','Credor','Empresa','Associado'),
               valor:_rNum(_ciKey(o,['Valor','ValorTotal','ValorPendencia'])),
               data:_ciTxt(o,'Data','DataOcorrencia','DataVencimento'),
               tipo:_ciTxt(o,'TipoPendencia','Tipo','Natureza'),
               contrato:_ciTxt(o,'Contrato','NumeroContrato'),
               cidade:_ciTxt(o,'Cidade','Municipio') };
    }).filter(function(o){ return o.informante||o.valor; });
    pend.sort(function(a,b){ return b.valor-a.valor; });
    /* o score pode vir como objeto {score, mensagem} ou solto como número */
    var scoRaw=_ciKey(cr,['Score','ScoreCredito']);
    var sco=(scoRaw&&typeof scoRaw==='object')?scoRaw:{};
    var svBruto=(scoRaw!=null&&typeof scoRaw!=='object')?scoRaw:_ciKey(sco,['Score','Pontuacao','Valor']);
    var svalor=String(svBruto==null?'':svBruto).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    /* v449 — a probabilidade vinha só como 'probabilidade' e era descartada */
    var _prob=_probPct(_ciTxt(sco,'ProbabilidadeInadimplencia','Probabilidade'));
    var score=svalor?{ valor:svalor,
                       classe:_ciTxt(sco,'Classe','ClassificacaoAbc','ClassifAbc'),
                       prob:_prob,
                       desc:_ciTxt(sco,'Descricao','DescrScore','TipoScore'),
                       msg:_ciTxt(sco,'Mensagem','Texto') }:null;
    /* v449 — SEGUNDA BASE. A resposta traz dois scores de provedores
       diferentes: o do Acerta (dentro do bloco de crédito) e o `scoreRating`,
       que fica FORA dele, um nível acima. O app usava só o primeiro. */
    var _sr=_ciKey(cr,['ScoreRating'])||_ciDeep(base||{},['ScoreRating']);
    var _srv=(_sr&&typeof _sr==='object')?_ciKey(_sr,['Score','Pontuacao','Valor']):_sr;
    var score2=String(_srv==null?'':_srv).replace(/\D/g,'')||'';
    /* le os campos cadastrais tolerando variacoes de grafia da API */
    function dcv(){ var a=[dc].concat(Array.prototype.slice.call(arguments)); return _ciTxt.apply(null,a); }
    var _cpfBruto=dcv('Cpf','CPF','Documento','NumeroDocumento','CpfCnpj');
    var cadastro=[ ['Nome completo', dcv('Nome','NomeCompleto','NomeConsumidor','NomeRazao')],
      ['CPF', _maskDoc(_cpfBruto)],
      ['Nascimento', dcv('DataNascimento','Nascimento','DataDeNascimento')],
      ['Idade', dcv('Idade')], ['Sexo', dcv('Sexo')],
      ['Nome da mãe', _maskNome(dcv('NomeMae','Mae'))],   /* v612 */
      ['Situação do CPF (Receita)', dcv('Situacao','SituacaoCpf','SituacaoDocumento','StatusDocumento','SituacaoReceita')],
      ['Telefone', dcv('Telefone','TelefoneResidencial','Celular','Fone')] ];
    var extras=[];
    /* v449 — entram aqui (e não num cartão novo) porque o "Comportamento de
       crédito" já é desenhado no PDF: assim tela e PDF nunca desandam. */
    /* v595: a probabilidade NÃO aparece em lugar nenhum (decisão do Angelo)
       e o score2 subiu pro cartão — as duas linhas de extras saíram. A
       LEITURA (_prob/score2) fica: não custa, e o dado viaja no parse. */
    if(dcv('RendaPresumida','RendaEstimada')) extras.push(['Renda presumida', dcv('RendaPresumida','RendaEstimada')]);
    if(dcv('NumeroDependentes','Dependentes')) extras.push(['Dependentes', dcv('NumeroDependentes','Dependentes')]);
    if(dcv('ClasseSocial')) extras.push(['Classe social', dcv('ClasseSocial')]);
    if(dcv('Escolaridade')) extras.push(['Escolaridade', dcv('Escolaridade')]);
    if(dcv('Profissao','Ocupacao')) extras.push(['Profissão', dcv('Profissao','Ocupacao')]);
    if(dcv('EstadoCivil')) extras.push(['Estado civil', dcv('EstadoCivil')]);
    if(!dcv('Escolaridade') && dcv('GrauInstrucao')) extras.push(['Escolaridade', dcv('GrauInstrucao')]);
    var _nota=function(bloco,rot){ var b=_ciKey(cr,[bloco]); var n=b?_ciTxt(b,'Nota','Classificacao'):''; if(n) extras.push([rot, n]); };
    _nota('ContratosRecentes','Contratos recentes (nota)');
    _nota('FaturasEmAtraso','Faturas em atraso (nota)');
    var ca=_ciKey(cr,['ConsultasAnteriores']); var _caq=ca?_ciTxt(ca,'QuantidadeTotal','Quantidade'):'';
    if(_caq) extras.push(['Consultas anteriores ao CPF', _caq]);
    /* v372 — QUEM JÁ CONSULTOU ESTE CPF. Vinha na resposta desde sempre e o
       app jogava fora. Muita consulta recente por financeira é sinal de que a
       pessoa está tentando crédito em vários lugares ao mesmo tempo. */
    var _hist=_asList(_ciKey(cr,['HistoricoConsultas','ConsultasRecentes']));
    var consultas=_hist.slice(0,12).map(function(h){
      var data=_ciTxt(h,'Data','DataConsulta');
      var empresaConsulta=_ciTxt(h,'Empresa','Nome','Associado');
      if(!data&&!empresaConsulta) return null;
      return [empresaConsulta||'Consulta registrada', data||'Data não informada'];
    }).filter(Boolean);
    /* v372 — PARTICIPAÇÃO EM EMPRESAS: também vinha e era descartada. */
    var empresa=[];
    _asList(_ciKey(cr,['ParticipacaoEmEmpresas','ParticipacoesEmEmpresas','Empresas'])).forEach(function(e,i){
      var _nm=_ciTxt(e,'Empresa','RazaoSocial','Nome')||('Empresa '+(i+1));
      var _cj=_ciTxt(e,'Cnpj'), _fu=_ciTxt(e,'Funcao','Cargo','Qualificacao');
      var _pc=_ciTxt(e,'ParticipacaoEmPorcentagem','Participacao','Percentual');
      var _de=_ciTxt(e,'DataEntrada','Entrada','DataInicio');
      var _cjf=(_cj&&typeof cnpjFmt==='function')?cnpjFmt(_cj):_cj;
      var det=[_cjf, _fu, (_pc?(_pc+'%'):''), (_de?('desde '+_de):'')].filter(Boolean).join(' · ');
      if(det) empresa.push([_nm, det]);
    });
    var ident=[];
    var end=[dcv('Endereco','Logradouro'), dcv('Numero')].filter(Boolean).join(', ');
    if(dcv('Bairro')) end+=(end?' · ':'')+dcv('Bairro');
    if(end) ident.push(['Endereço', end]);
    if(dcv('Cidade','Municipio')||dcv('Uf','UF','Estado')) ident.push(['Cidade / UF', dcv('Cidade','Municipio')+(dcv('Uf','UF','Estado')?(' / '+dcv('Uf','UF','Estado')):'')]);
    if(dcv('Cep','CEP')){ var _cp=dcv('Cep','CEP'); ident.push(['CEP', (typeof cepFmt==='function')?cepFmt(_cp):_cp]); }
    /* o protocolo e a data ficam FORA do bloco de crédito, um nível acima */
    /* v449 — busca em QUALQUER nível (ver _ciDeep): na resposta real ele vem
       três andares abaixo e o protocolo/data sumiam do rodapé do PDF. */
    var rr=_ciKey(cr,['ResumoRetorno'])||_ciKey(base||{},['ResumoRetorno'])||_ciDeep(base||{},['ResumoRetorno'])||{};
    /* v449 — o PDF OFICIAL do provedor, quando ele manda (base64 ou link) */
    var _pdfProv=_ciTxt(rr,'PdfBase64','Pdf','PdfUrl');
    var meta={ protocolo:_ciTxt(rr,'Protocolo'), data:_ciTxt(rr,'DataConsulta','Data'), pdf:_pdfProv };
    /* v372 — REDE DE SEGURANÇA: só posso dizer "nada consta" se encontrei ao
       menos UM bloco de RESTRIÇÃO que eu saiba ler. Achar só o cadastro não
       basta — sem isso, uma API que mude os nomes das listas de dívida faria
       a tela absolver todo mundo em silêncio. Quando não reconheço, o painel
       mostra os dados crus e NÃO dá veredito. */
    var reconheci = (_ciKey(cr,['ResumoConsulta'])!=null) ||
                    (_ciKey(cr,['PendenciasFinanceiras'])!=null) ||
                    (_ciKey(cr,['Protestos'])!=null) ||
                    (_ciKey(cr,['AcoesCiveis'])!=null) ||
                    (_ciKey(cr,['ChequesSemFundo'])!=null) ||
                    (_ciKey(cr,['ChequesSustados'])!=null);
    /* ===== 🔴 v518 (CAMADA C) — O VEREDITO CONSERVADOR ====================
       O `reconheci` acima olha DENTRO do `cr`, e por isso não pegava o
       protesto nacional (ver o 03c). Esta é a outra pergunta: chegou algum
       bloco IRMÃO, com cara de restrição, que eu não sei ler? Se chegou, o
       app não absolve e não acusa — ele diz que não sabe.
       ⚠️ Só apaga o VERDE. Se já houver pendência encontrada (vermelho), o
       veredito continua valendo: o desconhecido nunca vira acusação. */
    var _desc = (typeof cpfBlocosDesconhecidos==='function') ? cpfBlocosDesconhecidos(base) : [];
    return { acerta:true, positivo:true, score2:score2, tem:tem, status:(tem?('Constam pendências'+(rPend.v>0?(' · '+_brl(rPend.v)):'')):'Nada consta — sem pendências'), total:total, itens:itens, pend:pend, prot:_protLista, desconhecidos:_desc, incerto:(!tem && _desc.length>0), fiscal:[], ident:ident, score:score, extras:extras, consultas:consultas, consultasTotal:_hist.length, empresa:empresa, cadastro:cadastro, meta:meta, conhecido:!!reconheci, raw:cr };
  }
  /* v166: as pendencias viram uma LISTA (uma linha por credor) em vez de um
     cartao grande para cada uma. Cabe tudo numa tela so, fica mais facil de
     comparar valores e, no PDF, economiza papel e toner. */
  function _pendListHtml(pend){
    if(!pend||!pend.length) return '';
    return '<div style="font-size:10.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:11px 2px 5px">Detalhe das pendências financeiras ('+pend.length+')</div>'+
      '<div style="background:#fff;border:1px solid #fecaca;border-radius:12px;overflow:hidden;box-shadow:0 2px 8px rgba(2,20,60,.05)">'+
      pend.map(function(o,i){
        var sub=[o.data?('Desde '+o.data):'', o.tipo?('Tipo '+o.tipo):'', o.contrato?('Contrato '+o.contrato):''].filter(Boolean).join(' · ');
        return '<div style="padding:7px 12px;'+(i?'border-top:1px dashed #fee2e2;':'')+'">'+
          '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline">'+
            '<span style="flex:1;min-width:0;font-size:12.6px;font-weight:700;color:#0f172a;line-height:1.3">'+esc(o.informante||'Credor não informado')+'</span>'+
            '<span style="flex:none;font-size:13px;font-weight:900;color:#b91c1c">'+esc(_brl(o.valor))+'</span>'+
          '</div>'+
          (sub?('<div style="font-size:10px;color:#94a3b8;margin-top:1px">'+esc(sub)+'</div>'):'')+
        '</div>';
      }).join('')+'</div>';
  }
  /* ---- Acerta Essencial (birô de crédito com score) ---- */
  function _qOc(o){ return parseInt(String((o&&(o.quantidade_ocorrencia||o.quantidade_ocorrencias))||'0').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
  function _acItem(rot,o){ var n=_qOc(o); var vt=String((o&&o.valor_total)||'').trim(); return {rot:rot, ruim:n>0, det: n>0?(n+' registro(s)'+(vt?(' · R$ '+vt):'')):'Nada consta'}; }
  function _restAcerta(cc){
    cc=cc||{};
    /* v372 — mesma blindagem do _restAcertaPositivo: chave lida sem se
       importar com maiúscula/minúscula/underline. Sem isso, uma virada de
       grafia da API faria esta tela dizer "Nada consta" para todo mundo. */
    var _p=function(){ return _ciKey(cc, Array.prototype.slice.call(arguments)); };
    var _cProt=_p('protestos'), _cPend=_p('pend_financeiras','pendenciasFinanceiras'),
        _cAler=_p('informacoes_alertas_restricoes','alertasRestricoes'),
        _cCont=_p('contumacia'), _cPass=_p('passagens_comerciais');
    var itens=[
      _acItem('Protestos', _cProt),
      _acItem('Pendências financeiras', _cPend),
      _acItem('Alertas / restrições', _cAler),
      _acItem('Devedor contumaz', _cCont),
      _acItem('Passagens comerciais', _cPass)
    ];
    var _reconheci = [_cProt,_cPend,_cAler,_cCont,_cPass].some(function(x){ return x!=null; });
    var chq=_qOc(_p('ch_sem_fundos_bacen'))+_qOc(_p('ch_sem_fundos_varejo'));
    itens.push({rot:'Cheques sem fundo', ruim:chq>0, det: chq>0?(chq+' registro(s)'):'Nada consta'});
    var tem=itens.some(function(i){return i.ruim;});
    var _scs=_p('scores'); var sc=(_scs&&_ciKey(_scs,['ocorrencias'])&&_ciKey(_scs,['ocorrencias'])[0])||null;
    var score=sc?{ valor:_ciTxt(sc,'score','pontuacao'), classe:_ciTxt(sc,'classif_abc','classe'), prob:_ciTxt(sc,'probabilidade_inadimplencia'), desc:(_ciTxt(sc,'descr_score')||_ciTxt(sc,'tipo_score')) }:null;
    var extras=[];
    var _pp=_p('pagamento_pontual'); var _ppv=_pp?_ciTxt(_pp,'pontuacao'):'';
    if(_ppv) extras.push(['Pagamento pontual', _ppv+' / 100']);
    var _hc=_p('hist_consultas'); var _hcv=_hc?_ciTxt(_hc,'quantidade_ocorrencias','quantidade'):'';
    if(_hcv) extras.push(['Consultas ao CPF/CNPJ (12 meses)', _hcv]);
    var empresa=[]; var ie=_p('informacoes_da_empresa');
    if(ie&&(_ciTxt(ie,'razao_social')||_ciTxt(ie,'cnpj'))){
      empresa=[['Razão social', _ciTxt(ie,'razao_social')],['Nome fantasia', _ciTxt(ie,'nome_fantasia')],['Situação', _ciTxt(ie,'situacao')],['Fundação', _ciTxt(ie,'data_fundacao')],['CNAE', (_ciTxt(ie,'cnae_primario')?_ciTxt(ie,'cnae_primario')+' - ':'')+_ciTxt(ie,'ramo_atividade_primario')]];
    }
    var en=_p('endereco')||(ie&&_ciKey(ie,['endereco']))||null; var ident=[];
    if(en&&(_ciTxt(en,'endereco')||_ciTxt(en,'cidade'))){ ident.push(['Endereço', [_ciTxt(en,'endereco'),_ciTxt(en,'bairro')].filter(Boolean).join(' - ').replace(/[,\s-]+$/,'')]); ident.push(['Cidade / UF', _ciTxt(en,'cidade')+(_ciTxt(en,'uf')?(' / '+_ciTxt(en,'uf')):'')]); ident.push(['CEP', _ciTxt(en,'cep')]); }
    return { acerta:true, tem:tem, status:(tem?'Constam pendências / restrições':'Nada consta — sem pendências'), total:0, itens:itens, fiscal:[], ident:ident, score:score, extras:extras, consultas:[], consultasTotal:0, empresa:empresa, conhecido:!!(_reconheci||score||empresa.length), raw:cc };
  }
  /* ===== v450 — ESTE CAMINHO NUNCA TINHA RECEBIDO A BLINDAGEM DA v372 =====
     O conserto da v372 (ler a chave sem ligar pra maiúscula) foi aplicado nos
     dois caminhos do Acerta e ESQUECEU este, que atende o produto de
     pendências / Simples Nacional. Provado com uma resposta real: essa API
     escreve `possuiPendencias`, `totalPendencias`, `status` e `pendencias` em
     camelCase, e o código lia `PossuiPendencias`, `TotalPendencias`, `Status`.
     Com TRÊS pendências e possuiPendencias:true a tela dizia
     "Não constam pendências" — e com `conhecido:true`, ou seja, afirmando com
     confiança. É o MESMO falso negativo da v372, na outra porta.
     REGRA (a mesma de sempre): neste arquivo, nada de `base.Chave` na unha —
     só _ciKey / _ciTxt / _ciDeep. ========================================= */
  function _simBool(v){ if(v===true) return true; var s=String(v==null?'':v).trim().toLowerCase(); return s==='true'||s==='sim'||s==='s'||s==='1'; }
  /* lê um item de restrição que pode vir como texto, como LISTA ou como
     objeto {quantidade, valor}. Lista vazia = nada consta (e não "[object]"). */
  function _negVal(o, nomes){
    var v=_ciKey(o, nomes);
    if(v==null) return '';
    if(Array.isArray(v)) return v.length?(v.length+' registro(s)'):'';
    if(typeof v==='object'){
      var q=_ciKey(v,['QuantidadeTotal','Quantidade','Total']), vv=_ciKey(v,['Valor','ValorTotal']);
      var qn=parseInt(String(q==null?0:q).replace(/\D/g,''),10)||0;
      return qn>0?(qn+' registro(s)'+(vv?(' · '+String(vv)):'')):'';
    }
    return String(v);
  }
  function _restNegativo(dd, base){
    base=base||{};
    var pendRaw=_ciKey(base,['Pendencias']);
    if(pendRaw==null) pendRaw=_ciDeep(base,['Pendencias']);
    var pendObj=(pendRaw&&typeof pendRaw==='object'&&!Array.isArray(pendRaw))?pendRaw:{};
    var pf=_ciKey(pendObj,['PessoaFisica'])||null;
    var pj=_ciKey(pendObj,['PessoaJuridica'])||null;
    var alvo=pf||pj||{};
    var itens=[];
    function add(rot,val){ var ruim=!_restVazio(val); itens.push({rot:rot,ruim:ruim,det: ruim?String(val).trim():'Nada consta'}); }
    add('Protestos', _negVal(alvo,['Protestos']));
    add('Ações judiciais', _negVal(alvo,['AcoesJudiciais','AcoesCiveis']));
    add('Cheques sem fundo', _negVal(alvo,['ChequesSemFundo']));
    add('Recuperação judicial / falência', _negVal(alvo,['RecuperacoesJudiciaisFalencia','RecuperacaoJudicial','Falencia']));
    var pfin=_negVal(alvo,['PendenciaFinanceira','PendenciasFinanceiras']);
    if(pfin) add('Pendência financeira', pfin);
    /* v450 — A LISTA DE PENDÊNCIAS. Esta API manda uma lista chapada
       (`pendencias: [ {...} ]`) e o código só sabia procurar dentro de
       pendencias.PessoaFisica — então as linhas saíam todas "Nada consta". */
    var pend=_asList(pendRaw).concat(_asList(_ciKey(alvo,['Pendencias']))).map(function(o){
      var inf=_ciTxt(o,'Informante','Credor','Empresa','Orgao','Origem','Titulo','TipoPendencia','Tipo','Natureza','Detalhamento','Descricao');
      var tp=_ciTxt(o,'TipoPendencia','Tipo','Natureza');
      return { informante:inf,
               valor:_rNum(_ciKey(o,['Valor','ValorTotal','ValorPendencia'])),
               data:_ciTxt(o,'Data','DataOcorrencia','DataInicio','DataVencimento'),
               tipo:(tp===inf?'':tp),
               contrato:_ciTxt(o,'Contrato','NumeroContrato'),
               cidade:_ciTxt(o,'Cidade','Municipio') };
    }).filter(function(o){ return o.informante||o.valor; });
    pend.sort(function(a,b){ return b.valor-a.valor; });
    var totalTop=parseInt(String(_ciTxt(base,'TotalPendencias','TotalPendencia')||'0').replace(/\D/g,''),10)||0;
    var totalPf=parseInt(String(_ciTxt(alvo,'TotalPendencia','TotalPendencias')||'0').replace(/\D/g,''),10)||0;
    var possui=_simBool(_ciKey(base,['PossuiPendencias']))||_simBool(_ciKey(pendObj,['PossuiPendencias']))||_simBool(_ciKey(alvo,['PossuiPendencias']))
               ||totalTop>0||totalPf>0||pend.length>0||itens.some(function(i){return i.ruim;});
    /* o texto da própria base só é aproveitado quando não briga com o que eu
       contei: base dizendo "nao foram encontradas" com 3 pendências na mão
       viraria um veredito verde por cima de dívida. */
    var stApi=_ciTxt(alvo,'Status')||_ciTxt(base,'Status');
    /* ⚠️ NÃO dá pra usar o _restVazio aqui: ele exige fim de palavra e
       "Nao foram encontradas pendencias." (com o "as" colado) escapa dele.
       Foi assim que o teste 3 pegou um veredito verde por cima de dívida. */
    var _ST_LIMPO=/^\s*(n[aã]o\s+(foram|ha|há|existem?|constam?|possui)|nada consta|nenhum|sem pend|inexist)/i;
    var status = possui ? ((stApi && !_ST_LIMPO.test(stApi)) ? stApi : 'Constam pendências')
                        : (stApi || 'Não constam pendências');
    /* situação fiscal (SIMEI / Simples Nacional) — só mostra se o CPF tiver
       vínculo de empresa/MEI. Pra pessoa comum, isso é ruído e fica escondido. */
    var fiscal=[];
    var nomeEmp=_ciTxt(base,'NomeEmpresarial');
    var sitSimei=_ciTxt(base,'SituacaoSimei');
    var sitSN=_ciTxt(base,'SituacaoSimplesNacional');
    var optSimei=_ciKey(base,['OptanteSimei']), optSN=_ciKey(base,['OptanteSimplesNacional']);
    var temEmpresa = _simBool(optSimei) || _simBool(optSN) || (!!nomeEmp)
                     || (sitSimei && !/nao enquadrad|não enquadrad/i.test(sitSimei))
                     || (sitSN && !/nao informad|não informad/i.test(sitSN));
    if(temEmpresa){
      var addF=function(rot,val){ if(val==null||val==='') return; var s=(typeof val==='boolean')?(val?'Sim':'Não'):String(val).trim(); if(s&&s.toLowerCase()!=='null') fiscal.push({rot:rot,val:s}); };
      addF('Nome empresarial', nomeEmp);
      addF('Situação SIMEI', sitSimei);
      addF('Situação Simples Nacional', sitSN);
      addF('Optante SIMEI', optSimei);
      addF('Optante Simples Nacional', optSN);
    }
    /* v450 — IDENTIFICAÇÃO: nome e documento vinham na resposta e o relatório
       saía sem dizer de quem era. */
    var cadastro=[];
    var _nm=_ciTxt(base,'Nome','NomeCompleto','Contribuinte');
    var _cp=_ciTxt(base,'Cpf','CpfCnpj','DocumentoConsultado','Documento');
    if(_nm) cadastro.push(['Nome completo', _nm]);
    if(_cp) cadastro.push(['Documento', _maskDoc(_cp)||_cp]);
    /* v450 — protocolo e data pro rodapé do PDF (aqui o protocolo se chama
       "código da declaração") */
    var meta={ protocolo:_ciTxt(base,'CodigoDeclaracao','Protocolo','CodigoConsulta'),
               data:_ciTxt(base,'DataConsulta','ConsultaRealizadaEm','Data'),
               pdf:_ciTxt(base,'PdfBase64','Pdf') };
    /* estrutura reconhecida? (evita mostrar "nada consta" falso se a API mudar
       de formato) — agora conferido sem ligar pra maiúscula */
    var conhecido = (_ciKey(base,['Pendencias'])!=null) || (_ciKey(base,['PossuiPendencias'])!=null)
                    || (_ciKey(base,['TotalPendencias','TotalPendencia'])!=null)
                    || (_ciKey(base,['Status'])!=null) || !!pf || !!pj;
    return { tem:!!possui, status:String(status), total:(totalTop||totalPf||pend.length||0), itens:itens, pend:pend,
             fiscal:fiscal, ident:[], score:null, extras:[], consultas:[], consultasTotal:0, empresa:[], cadastro:cadastro, meta:meta,
             conhecido:!!conhecido, raw:base };
  }
  /* v449 — PDF OFICIAL DO PROVEDOR. Só aparece quando a resposta traz o
     arquivo (campo pdfBase64/pdf do resumoRetorno); nas que não trazem, nada
     muda na tela. O clique é pego por delegação (logo abaixo do
     restricaoBaixarPDF) pra valer em todas as portas de entrada da análise. */
  function _restPdfProvBtn(p){
    if(!p||!p.meta||!p.meta.pdf) return '';
    /* v610: sem .pdf-btn aqui também — senão o FAB continuaria de pé nesta
       tela e baixaria o PDF DO PROVEDOR no lugar do nosso. */
    return '<button type="button" id="restPdfProv" style="width:100%;margin-top:8px;display:flex;align-items:center;justify-content:center;gap:8px;background:#fff;color:#0a4da6;border:1.5px solid #bfdbfe;border-radius:11px;padding:12px;font-size:13.5px;font-weight:800;cursor:pointer;font-family:inherit">'+ICO_PDF+' PDF do provedor</button>';
  }
  /* ===== v604 — RECEITA FEDERAL E ANTECEDENTES: UM LEITOR SÓ ============
     🔴 O DEFEITO QUE ISTO CONSERTA: desde a v599 a "CPF restrições" paga por
     TRÊS fontes, mas a Receita Federal e os antecedentes só apareciam NA
     TELA — o PDF, que é o que o lojista arquiva e entrega, saía sem eles.
     A causa é a armadilha anotada na v518: tela e PDF são DOIS desenhos, e
     quem escreve um esquece o outro. Conserto de raiz: a LEITURA do dado
     vira uma função só (_cpfReceitaLinhas / _cpfAntecEstado) e os dois
     desenhos passam a beber dela. Fonte nova agora entra nos dois de graça. */
  /* ===== v612 — NADA DE CPF INTEIRO NEM NOME DA MÃE ABERTO ==============
     Pedido do Angelo, olhando o PDF de uma consulta real:
       "mascare as informacoes do cpf, nome da mae"
     🔴 E ELE PEGOU UM VAZAMENTO QUE A v609 ABRIU. Quando a leitura da Receita
     passou a mostrar TODO campo que a base manda (pra a situação nunca mais
     sumir), veio junto o campo `documento` — o CPF com os ONZE dígitos, no
     papel que o lojista imprime e entrega. O conserto de um buraco abriu
     outro; é o preço de mostrar tudo, e a resposta certa não é voltar a
     esconder: é MASCARAR na saída.

     ⚠️ POR QUE O NOME DA MÃE PESA TANTO: ele é a pergunta de segurança do
     Brasil inteiro — banco, cartório, financeira. Num papel que circula, é
     chave de fraude. Mas apagar inteiro tira a serventia (conferir com o
     cliente na mesa). Então o primeiro nome fica, o resto vira inicial: dá
     pra CONFERIR sem dar pra COPIAR.

     Isto vale pra tela E pro PDF porque mascara na FONTE — nas listas de
     [rótulo, valor] que os dois desenhos leem. */
  /* 🔴🔴 A COLISÃO DE NOME MORDEU PELA TERCEIRA VEZ — E DESSA VEZ EU CAÍ.
     Escrevi aqui um `_maskNome` próprio (primeiro nome + inicial + asteriscos)
     sem fazer o grep que a própria v599 mandou fazer. O 19-documentos-e-init
     JÁ TINHA um `_maskNome`, e como todos os módulos vivem no MESMO IIFE e o
     19 é colado DEPOIS do 03, o dele venceu por hoisting: a minha função
     nunca rodou uma vez sequer. O teste pegou porque conferiu o RESULTADO
     ("MARIA D. T.", com ponto) e não a existência da função.
     ⚠️ E o certo era mesmo NÃO criar: a do 19 já faz o trabalho
     ("ELIANA FERNANDES DE SOUZA" → "ELIANA F. D. S."), já é usada em outro
     lugar do app, e reusar mantém o MESMO jeito de mascarar em todo canto.
     Apagada a minha. Fica a regra, agora pela terceira vez:
     🔴 GREP NO NOME ANTES DE CRIAR FUNÇÃO NO IIFE COMPARTILHADO.
     (v434 = classe CSS · v599 = _ciKey · v612 = _maskNome) */
  /* Os despejos crus (renderVal(_cpfRawSeguro(p.raw))) são a outra porta pela qual o CPF e o
     nome da mãe saíam inteiros — "Dados cadastrais e contatos", e os dois
     quadros de "a base respondeu, mas não sei desenhar". Aqui o objeto é
     COPIADO e mascarado antes de virar tela; o original não é tocado, porque
     é dele que o histórico e o PDF vivem. */
  function _cpfRawSeguro(o, prof){
    prof=prof||0;
    if(o==null || prof>6) return o;
    if(Array.isArray(o)) return o.map(function(x){ return _cpfRawSeguro(x,prof+1); });
    if(typeof o==='object'){
      var out={};
      Object.keys(o).forEach(function(k){
        var v=o[k];
        if(v&&typeof v==='object'){ out[k]=_cpfRawSeguro(v,prof+1); return; }
        out[k]=_cpfSeguro(k, v);
      });
      return out;
    }
    return o;
  }
  /* 11 dígitos soltos = CPF, mesmo que o rótulo não diga */
  function _pareceCpf(v){ var d=String(v==null?'':v).replace(/\D/g,''); return d.length===11 && /^[\d.\-\s/]+$/.test(String(v)); }
  function _cpfSeguro(rot, val){
    var r=String(rot||'').toLowerCase(), v=String(val==null?'':val);
    if(/m[ãa]e/.test(r)) return _maskNome(v);
    if(_pareceCpf(v)) return _maskDoc(v)||v;
    return v;
  }
  /* 🔴 v609 — A LISTA CURADA ERA O DEFEITO.
     O Angelo, olhando o PDF de uma consulta REAL: "as informacoes da receita,
     nao veio se tem pendencias". E não veio mesmo: esta função procurava
     CINCO campos por nome exato, e a SITUAÇÃO CADASTRAL — que é justamente o
     que diz se o CPF está regular, pendente de regularização, suspenso ou
     cancelado — voltou da base com um nome que não estava na lista. O dado
     chegou, o app jogou fora, e a lista de ✅ do card prometia "situação na
     Receita Federal".
     ⚠️ A LIÇÃO: lista curada de campos SEMPRE perde o campo que a base
     renomeou — e perde CALADA. Agora é ao contrário: os conhecidos ganham
     rótulo bonito e ORDEM, e TODO O RESTO entra depois, com o nome
     humanizado. O que a base mandar, o lojista vê. */
  function _cpfReceitaLinhas(dd){
    var bl=(dd&&dd.mev_receita)||null;
    if(!bl) return null;                       /* a fonte nem veio na resposta */
    if(!bl.ok) return [];                      /* veio, mas não respondeu */
    var d=(bl.dados&&bl.dados.data)||bl.dados||{};
    var linhas=[], usados={};
    /* 1) os conhecidos, na ordem que se lê */
    [['Nome',/^(nome|nomecompleto|name|nomecontribuinte)$/],
     ['Nascimento',/^(datanascimento|nascimento|birth|datadenascimento)$/],
     ['Nome da mãe',/^(nomemae|mae|mothername|nomedamae)$/],
     ['Situação do CPF',/(situacao|situacional|status)/],
     ['Data da situação',/(datasituacao|datainscricao|dataatualizacao|dataconsulta)/],
     ['Ano do óbito',/(anoobito|obito)/],
     ['Comprovante',/(comprovante|numerocomprovante|protocolo)/]].forEach(function(par){
      var achou=_cpf3AchaRec(d,par[1],usados);
      if(achou) linhas.push([par[0], _cpfSeguro(par[0], achou)]);   /* v612 */
    });
    /* 2) e TUDO o mais que a base mandou, com o nome humanizado — é isto que
       impede o dado de sumir de novo quando mudarem a chave. */
    (function cava(o,prof){
      if(!o||typeof o!=='object'||prof>3) return;
      Object.keys(o).forEach(function(k){
        var v=o[k];
        if(v&&typeof v==='object'){ cava(v,prof+1); return; }
        var ch=String(k).toLowerCase().replace(/[^a-z0-9]/g,'');
        if(usados[ch]) return;
        var txt=String(v==null?'':v).trim();
        if(!txt || txt==='null' || txt==='undefined') return;
        if(linhas.length>=14) return;
        usados[ch]=1;
        /* 🔴 v612 — é AQUI que o CPF inteiro escapava: o campo `documento`
           da Receita entrava cru na lista junto com todo o resto. */
        var _rot=_humaniza(k);
        linhas.push([_rot, _cpfSeguro(_rot, txt)]);
      });
    })(d,0);
    return linhas;
  }
  /* acha o 1º campo (em qualquer nível) cujo nome case, marcando como usado */
  function _cpf3AchaRec(o,re,usados,prof){
    prof=prof||0; if(!o||typeof o!=='object'||prof>3) return '';
    var ks=Object.keys(o);
    for(var i=0;i<ks.length;i++){
      var v=o[ks[i]]; if(v&&typeof v==='object') continue;
      var ch=String(ks[i]).toLowerCase().replace(/[^a-z0-9]/g,'');
      if(usados[ch]) continue;
      if(re.test(ch)){
        var txt=String(v==null?'':v).trim();
        if(txt && txt!=='null'){ usados[ch]=1; return txt; }
      }
    }
    for(var j=0;j<ks.length;j++){
      var x=o[ks[j]];
      if(x&&typeof x==='object'){ var r=_cpf3AchaRec(x,re,usados,prof+1); if(r) return r; }
    }
    return '';
  }
  /* 🔴 A regra v450 vale aqui: SEM RESPOSTA NÃO É "nada consta".
     Devolve {nv:'ok'|'no'|'at', t:'texto curto', det:'motivo'} — 'at' é o
     terceiro estado (não verificado), que nunca pode virar verde. */
  function _cpfAntecEstado(dd){
    var bl=(dd&&dd.mev_antecedentes)||null;
    if(!bl) return null;
    if(!bl.ok){
      var mot=(bl.motivo==='informe RG e UF')?'informe o RG e a UF junto do CPF e consulte de novo':'a base não respondeu agora';
      return { nv:'at', t:'Antecedentes criminais: não verificado', det:mot+' — o valor dessa parte foi devolvido.' };
    }
    var d=(bl.dados&&bl.dados.data)||bl.dados||{};
    var v=_cpf3Deep(d,/^(possuiantecedentescriminais|possuiantecedentes|temantecedentes|antecedentes)$/);
    var tem=(v===true||/^(1|true|sim|s)$/i.test(String(v==null?'':v)));
    return tem
      ? { nv:'no', t:'Constam antecedentes criminais', det:'' }
      : { nv:'ok', t:'Antecedentes criminais: nada consta', det:'' };
  }
  function _cpfReceitaHtml(dd){
    var linhas=_cpfReceitaLinhas(dd);
    if(linhas==null) return '';
    if(!linhas.length) return '<div class="plc-msg" style="margin-top:9px;color:#b45309">Receita Federal: não verificado (a base não respondeu — o valor dessa parte foi devolvido).</div>';
    /* v610: o estado vem da SITUAÇÃO CADASTRAL — regular é ✓, qualquer outra
       coisa (pendente de regularização, suspensa, cancelada, nula, titular
       falecido) é alerta. Sem a linha da situação, ícone neutro: o app não
       inventa veredito. */
    var _sit=''; linhas.forEach(function(r){ if(!_sit && /situa/i.test(r[0])) _sit=String(r[1]||''); });
    /* 🔴 ARMADILHA QUE O TESTE PEGOU: "PENDENTE DE REGULARIZAÇÃO" **contém**
       a palavra "regular". Um /regular/i pintava de VERDE justamente o CPF
       que está irregular na Receita — o pior erro possível nesta tela.
       Agora o ruim é procurado PRIMEIRO, por palavra inteira, e o verde só
       vem quando a situação é REGULAR e nada mais. Situação desconhecida
       fica NEUTRA: o app não adivinha. */
    var _est = null;
    if(_sit){
      if(/pendent|irregular|suspens|cancelad|nula|nulo|falecid|inapt|bloquead|baixad/i.test(_sit)) _est='no';
      else if(/^\s*(regular|ativa|ativo)\s*$/i.test(_sit)) _est='ok';
      else _est='at';                 /* respondeu algo que não sei classificar */
    }
    return _cpfBloco('Receita Federal', '<div class="cpf3-kv">'+
      linhas.map(function(r){ return '<div class="cpf3-lin"><span>'+esc(r[0])+'</span><b>'+esc(r[1])+'</b></div>'; }).join('')+'</div>', false, _est);
  }
  /* v604 — o selo de antecedentes na TELA, desenhado do MESMO estado do PDF */
  function _cpfAntecHtml(dd){
    var e=_cpfAntecEstado(dd); if(!e) return '';
    if(e.nv==='at') return '<div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:12px;padding:10px 13px;margin-top:10px"><b style="color:#b45309;font-size:13px">'+esc(e.t)+'</b><div style="color:#92400e;font-size:11.5px;margin-top:2px">'+esc(e.det)+'</div></div>';
    if(e.nv==='no') return '<div style="background:#fee2e2;border:1px solid #fecaca;border-left:6px solid #dc2626;border-radius:12px;padding:10px 13px;margin-top:10px"><b style="color:#b91c1c;font-size:13px">⚠️ '+esc(e.t)+'</b></div>';
    return '<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-left:6px solid #16a34a;border-radius:12px;padding:10px 13px;margin-top:10px"><b style="color:#15803d;font-size:13px">✓ '+esc(e.t)+'</b></div>';
  }
  function restricaoPanelHtml(dd){
    dd=dd||{}; var p=restParse(dd);
    var tipo=dd.tipo_doc||'Documento';
    var _docCadastro=((p.cadastro||[]).filter(function(r){ return /^(cpf|documento)$/i.test(String(r[0]||''))&&r[1]; })[0]||[])[1]||'';
    var docm=_maskDoc(dd.documento||'')||_docCadastro||esc(String(dd.documento||''));
    var alerta=p.tem;
    /* 🔴 v518 (camada C) — O TERCEIRO ESTADO. Sem pendência encontrada MAS
       com bloco irmão que o app não sabe ler: nem verde nem vermelho. Não
       afirmar é a única resposta honesta numa decisão de crédito. */
    var head = alerta
      ? '<div style="background:#fef2f2;border:1px solid #fecaca;border-left:6px solid #dc2626;border-radius:12px;padding:10px 13px;margin:4px 0 8px"><div style="font-weight:800;color:#b91c1c;font-size:14px">⚠️ Foram encontradas pendências</div><div style="color:#7f1d1d;font-size:11.5px;margin-top:2px">'+esc(p.status)+(p.total?(' · '+p.total+' registro(s)'):'')+'</div></div>'
      : (p.incerto
        ? '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid #0a4da6;border-radius:12px;padding:10px 13px;margin:4px 0 8px"><div style="font-weight:800;color:#0a4da6;font-size:14px">Não posso afirmar "nada consta"</div><div style="color:#1e3a8a;font-size:11.5px;margin-top:2px">'+esc(CPF_AVISO_DESCONHECIDO)+'</div></div>'
        : '<div class="cpf3-status cpf3-status-ok" style="background:#f0fdf4;border:1px solid #bbf7d0;border-left:6px solid #16a34a;border-radius:12px;padding:10px 13px;margin:4px 0 8px"><div style="font-weight:800;color:#15803d;font-size:14px">✓ Nada consta — sem pendências</div><div style="color:#166534;font-size:11.5px;margin-top:2px">'+esc(p.status)+'</div></div>');
    /* estrutura não reconhecida (ex.: API nova/diferente): mostra os dados crus,
       sem afirmar "nada consta" (evita falso negativo numa decisão de crédito). */
    if(!p.conhecido){
      var h0='<div style="font-size:11px;color:#64748b;margin:2px 0 3px">'+esc(tipo)+' consultado: <b>'+docm+'</b></div>';
      h0+='<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid #0a4da6;border-radius:12px;padding:10px 13px;margin:4px 0 8px"><div style="font-weight:800;color:#0a4da6;font-size:14px">Consulta realizada</div><div style="color:#1e3a8a;font-size:11.5px;margin-top:2px">Confira os dados abaixo com atenção antes de decidir.</div></div>';
      h0+='<div style="background:#fff;border:1px solid #e8eef7;border-radius:12px;padding:10px 12px;box-shadow:0 2px 8px rgba(2,20,60,.05)">'+renderVal(_cpfRawSeguro(p.raw))+'</div>';
      h0+='<button type="button" id="restPdf" style="width:100%;margin-top:12px;display:flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(135deg,var(--verde),var(--verde3));color:#fff;border:none;border-radius:11px;padding:13px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit;box-shadow:0 4px 14px rgba(21,101,52,.22)">'+ICO_PDF+' Baixar em PDF</button>'+_restPdfProvBtn(p);
      h0+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018).</div>';
      return h0;
    }
    var html='<div style="font-size:11px;color:#64748b;margin:2px 0 3px">'+esc(tipo)+' consultado: <b>'+docm+'</b></div>';
    /* v166: UM SO montador de cartao (antes eram dois iguais, _kvSecEarly e
       _kvSec) e mais compacto — a informacao continua do mesmo tamanho, quem
       encolheu foi a moldura. O 3o parametro e so a folga de cima. */
    /* v608: o mesmo conteúdo de sempre, agora DENTRO de um card que abre e
       fecha (.fic-item — o acordeão da ficha técnica). O 3º parâmetro, que
       era a folga de cima, deixou de ter uso: quem espaça agora é o card. */
    function _kvSec(titulo,rows,mt){
      rows=(rows||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim()&&String(r[1]).toLowerCase()!=='null'; });
      if(!rows.length) return '';
      return _cpfBloco(titulo,
        '<div class="cpf3-kv">'+
        rows.map(function(r,i){ return '<div style="padding:7px 0;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><div style="font-size:9.5px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:.3px">'+esc(r[0])+'</div><div style="font-size:12.6px;font-weight:700;color:#0f172a;margin-top:1px;line-height:1.3">'+esc(r[1])+'</div></div>'; }).join('')+
        '</div>');
    }
    /* 🔴 v608 — O VEREDITO SUBIU. Com todos os campos fechados (pedido do
       Angelo), abrir o painel numa pilha de caixas mudas não responderia
       nada. Então o que decide fica SEMPRE ABERTO no topo: o veredito e o
       selo de antecedentes. O resto é detalhe, e detalhe abre no dedo. */
    html+=head;
    html+=_cpfAntecHtml(dd);
    if(p.cadastro&&p.cadastro.length) html+=_kvSec('Identificação', p.cadastro, 7);
    /* ===== v595 — SCORE FORA DA TELA (decisão do Angelo, 22/08) ==========
       O projeto original trocava o cartão único por dois (Acerta + Rating);
       na sequência o Angelo decidiu: "remove os dois scores, deixe sem".
       O número não batia com SPC/Serasa e virava discussão com o cliente.
       A LEITURA (p.score / p.score2) segue no parse — pra voltar, é só
       redesenhar o cartão aqui. Nenhuma probabilidade/mensagem em lugar
       nenhum (isso ficou da primeira metade do projeto). */
    /* pendências / restrições (o que importa pra decisão de crédito) */
    var _pr='<div class="cpf3-kv">'+
      p.itens.map(function(it,i){ return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:8px 0;'+(i? 'border-top:1px solid #f1f5f9;':'')+'"><span style="font-size:12.4px;font-weight:600;color:#0f172a">'+esc(it.rot)+'</span><span style="flex:none;font-size:11.3px;font-weight:800;padding:3px 9px;border-radius:20px;'+(it.ruim?'background:#fee2e2;color:#b91c1c':'background:#dcfce7;color:#15803d')+'">'+esc(it.det)+'</span></div>'; }).join('')+
      '</div>';
    _pr+=_pendListHtml(p.pend);
    /* v518 (camada B): cada protesto diz DE ONDE veio — birô ou cartório
       nacional. Sem isso, o lojista que ouvir "não tenho protesto nenhum"
       do cliente não sabe onde ir conferir. */
    if(typeof cpfProtestoListaHtml==='function') _pr+=cpfProtestoListaHtml(p.prot);
    /* v610: o veredito desta seção JÁ existe no p.tem — o ícone só repete
       no card o que a faixa verde/vermelha de cima já disse. */
    html+=_cpfBloco('Pendências / restrições', _pr, false, p.tem?'no':(p.incerto?'at':'ok'));
    html+=_kvSec('Comportamento de crédito', p.extras);
    if(p.consultas&&p.consultas.length){
      var _ct=p.consultas.length, _ctTotal=p.consultasTotal||_ct;
      html+=_kvSec('Quem consultou este CPF'+(_ctTotal>_ct?(' — '+_ct+' mais recentes de '+_ctTotal):(' ('+_ctTotal+')')), p.consultas);
    }
    html+=_kvSec('Empresa', p.empresa);
    if(p.acerta) html+=_kvSec('Endereço', p.ident);
    /* situação fiscal (SIMEI / Simples Nacional) — só no caminho detalhamento-negativo */
    if(p.fiscal.length){
      html+=_cpfBloco('Situação fiscal (MEI / Simples)', '<div class="cpf3-kv">'+
        p.fiscal.map(function(it,i){ return '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:7px 0;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><span style="font-size:11.5px;color:#64748b;font-weight:600">'+esc(it.rot)+'</span><span style="font-size:12.4px;font-weight:700;color:#0f172a;text-align:right">'+esc(it.val)+'</span></div>'; }).join('')+
        '</div>');
    }
    /* ===== v599 — as DUAS FONTES NOVAS da CPF Restrições ================
       Elas vêm em chaves próprias (mev_receita / mev_antecedentes), postas
       pelo servidor — nunca misturadas no objeto do acerta. */
    html+=_cpfReceitaHtml(dd);   /* v608: o selo de antecedentes subiu pro topo */
    html+='<button type="button" id="restPdf" style="width:100%;margin-top:12px;display:flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(135deg,var(--verde),var(--verde3));color:#fff;border:none;border-radius:11px;padding:13px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit;box-shadow:0 4px 14px rgba(21,101,52,.22)">'+ICO_PDF+' Baixar em PDF</button>'+_restPdfProvBtn(p);
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018). Dados informados pela base na data da consulta.</div>';
    return html;
  }
  /* imagem (print) do resultado — usada no PDF.
     v166: mesma receita da consulta de CNPJ. O desenho e feito primeiro "no
     vazio" (sem pintar nada) em varias larguras, so pra MEDIR a altura de
     cada uma; fica valendo a largura cujo resultado mais se parece com uma
     folha A4 em pe (altura = 1,414 x largura). Assim a pagina do PDF fica
     cheia e a letra sai no maior tamanho possivel. */
  /* ======================================================================
     v595 — O PDF DO CPF NO PADRÃO MEV (Fase 2 do PROJETO-pdf-padrao-mev)
     ======================================================================
     O _restDraw (auto-ajuste de folha) foi APOSENTADO: as páginas nascem
     do kit do 06b — faixa azul da casa com o documento mascarado, faixa de
     veredito, quadro de avisos, seções kv e rodapé com protocolo e
     pág. N de M. Sem score e sem probabilidade (decisões de 22/08). */
  /* ===== v599 — os PDFs dos dois cards novos, no KIT (06b) ============== */
  function cpfScorePaginas(dd){
    var p=cpfScoreParse(dd||{});
    var doc=String((dd&&dd.documento)||p.doc||'').replace(/\D/g,'');
    /* v601: quando o dado é o EXEMPLO fictício, o PDF diz isso — no
       protocolo e numa linha de aviso. Consulta real nunca aciona. */
    var _ex=!!(dd&&dd.mev_exemplo);
    var st=pdfkitNovo({ tipo:'Consulta CPF — score bancário', doc:_maskDoc(doc)||'',
      protocolo:_ex?'EXEMPLO-00000000':'',
      lgpdCurto:'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018)' });
    if(_ex) kitTexto(st, 'EXEMPLO — DADOS FICTÍCIOS. Este relatório é uma amostra do modelo; nenhuma consulta foi feita e nenhum valor foi cobrado.');
    if(p.score!=null){
      var f=_scoreFaixa(p.score);
      kitScore(st,'Score bancário', p.score, f[0]);
      kitVeredito(st, (p.score>=700?'ok':(p.score>=500?'at':'no')), 'Pontuação '+f[0], '');
    } else {
      kitVeredito(st,'at','Score não informado pela base','confira os dados abaixo');
    }
    if(p.resumo.length) kitKv2(st,'Resumo consolidado', p.resumo.map(function(r){ return [r[0], _brl(r[1])]; }));
    if(p.modalidades.length) kitKv2(st,'Modalidades', p.modalidades.slice(0,16).map(function(m){ return [m.nome, _brl(m.valor)+(m.pct?(' · '+m.pct+'%'):'')]; }));
    if(p.relacao) kitTexto(st, p.relacao);
    return kitFinaliza(st);
  }
  /* v1024 — o PDF recebe os MESMOS campos e a MESMA ordem da tela (§4.7 do
     projeto de 15/09). Inclusive a regra nº 1: estado 'naolido' não vira
     "nenhum processo encontrado" em lugar nenhum. */
  function cpfProcPaginas(dd, ehCnpj){
    var p=cpfProcParse(dd||{});
    var doc=String((dd&&dd.documento)||'').replace(/\D/g,'');
    var _ex=!!(dd&&dd.mev_exemplo);   /* v601 — ver cpfScorePaginas */
    var st=pdfkitNovo({ tipo:(ehCnpj?'Consulta CNPJ — ações e processos':'Consulta CPF — ações e processos'), doc:_maskDoc(doc)||'',
      protocolo:_ex?'EXEMPLO-00000000':'',
      lgpdCurto:'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018)' });
    if(_ex) kitTexto(st, 'EXEMPLO — DADOS FICTÍCIOS. Este relatório é uma amostra do modelo; nenhuma consulta foi feita e nenhum valor foi cobrado.');
    if(p.estado==='naolido'){
      kitVeredito(st,'at','Não foi possível ler o retorno desta consulta','');
      kitTexto(st, _procMotivoTexto(p)+' Isto não quer dizer que não existam processos: quer dizer que a base não respondeu de forma legível.');
      return kitFinaliza(st);
    }
    var T=p.resumo.total, n=p.processos.length;
    if(T) kitVeredito(st,'no', T+' processo'+(T===1?'':'s')+' encontrado'+(T===1?'':'s'),'');
    else kitVeredito(st,'ok','Nenhum processo encontrado','a base respondeu e não encontrou processos');
    var _rl=_procResumoLinhas(p);
    if(_rl.length) kitKv2(st,'Resumo', _rl);
    if(p.cadastral && (p.cadastral.nome||p.cadastral.cidade)){
      kitKv2(st,'Identificação', [['Nome', p.cadastral.nome||'—'],
        ['Cidade / UF', [p.cadastral.cidade,p.cadastral.uf].filter(Boolean).join(' / ')||'—']]);
    }
    /* um cartão por processo (molde do kitRecall: título + 2 linhas) */
    p.processos.slice(0,20).forEach(function(x){
      var rot=[x.polo,x.poloTipo].filter(Boolean).join(' · ');
      var sit=[x.status, x.arquivadoEm?('Arquivado em '+x.arquivadoEm):'', x.ramo, x.valor?_brl(x.valor):''].filter(Boolean).join(' · ');
      kitRecall(st,{ titulo:(x.numero||'Processo')+(rot?('  ['+rot.toUpperCase()+']'):''), data:x.data||'',
        defeito: x.segredo ? 'Processo em segredo de justiça — assunto e partes não exibidos'
                           : ([x.classe,x.assunto].filter(Boolean).join(' — ')||'—'),
        risco:[x.tribunal,x.orgao,x.uf].filter(Boolean).join(' · ')+(sit?(' · '+sit):'')||'—' });
    });
    if(T>n) kitTexto(st,'Mostrando '+n+' de '+T+' processos.');
    else if(n>20) kitTexto(st,'… e mais '+(n-20)+' processo(s) — a lista completa está na tela da consulta.');
    kitTexto(st,'Confirme nos tribunais antes de usar em documento.');
    return kitFinaliza(st);
  }
  function cpfExtraPdfAcao(qual,modo){
    if(!_mevPdfPronto(function(){ cpfExtraPdfAcao(qual,modo); },false)) return;
    try{
      var dd=Object.assign({}, _cpfExtraState||{});
      if(!dd.documento){ dd.documento=String((($('restDoc')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); }
      var pgs=(qual==='score')?cpfScorePaginas(dd):cpfProcPaginas(dd);
      var blob=kitPdfBlob(pgs);
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      /* nome sem NENHUM dígito do documento (lição da v515) */
      var _base=(qual==='score'?'Score-bancario':'Acoes-e-processos');
      if(dd.mev_exemplo) _base='EXEMPLO-'+_base;   /* v601 */
      var nome=nomeArquivoSeguro(_base,'',Date.now())+'.pdf';
      pdfArquivoAcao(blob,nome,modo,function(){ pdfVisor(blob,nome); },qual==='score'?'Score bancário':'Ações e processos');
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }
  function cpfExtraBaixarPDF(qual){ cpfExtraPdfAcao(qual,'baixar'); }
  function restricaoPaginas(dd){
    var p; try{ p=restParse(dd); }catch(_){ p={}; }
    var doc=String(dd&&dd.documento||'').replace(/\D/g,'');
    var _ex=!!(dd&&dd.mev_exemplo);   /* v601 — ver cpfScorePaginas */
    var st=pdfkitNovo({ tipo:'Consulta CPF — crédito e pendências', doc:_maskDoc(doc)||'',
      protocolo:_ex?'EXEMPLO-00000000':((p.meta&&p.meta.protocolo)||''),
      lgpdCurto:'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018)' });
    if(_ex) kitTexto(st, 'EXEMPLO — DADOS FICTÍCIOS. Este relatório é uma amostra do modelo; nenhuma consulta foi feita e nenhum valor foi cobrado.');
    if(p.tem) kitVeredito(st,'no', p.status||'Constam pendências','');
    else if(p.incerto) kitVeredito(st,'at','Sem pendências nas bases que responderam','parte das bases não respondeu — não verificado');
    else kitVeredito(st,'ok', p.status||'Nada consta — sem pendências','');
    kitKv2(st,'Identificação', p.cadastro||[]);
    if(p.itens&&p.itens.length){
      kitAvisos(st,'Pendências / restrições', p.itens.map(function(it){
        return { t: it.rot+': '+String(it.det||(it.ruim?'consta':'nada consta')), nv: it.ruim?'no':'ok' };
      }));
    }
    if(p.pend&&p.pend.length){
      kitKv2(st,'Detalhe das pendências financeiras ('+p.pend.length+')',
        p.pend.slice(0,16).map(function(o){ return [o.informante||'Credor não informado', _brl(o.valor)+(o.data?(' · desde '+o.data):'')]; }));
      if(p.pend.length>16) kitTexto(st,'… e mais '+(p.pend.length-16)+' pendência(s) — a lista completa está na tela da consulta.');
    }
    if(p.prot&&p.prot.length){
      kitKv2(st,'Protestos ('+p.prot.length+')',
        p.prot.slice(0,12).map(function(o){ return [[o.cidade,o.uf].filter(Boolean).join('/')||'Protesto', _brl(o.valor)+(o.origem?(' · '+o.origem):'')]; }));
    }
    /* 🔴 v604 — AS DUAS FONTES QUE FALTAVAM NO PAPEL. Elas são pagas desde
       a v599 e só saíam na tela; agora entram no PDF, lidas do MESMO leitor
       que a tela usa (ver _cpfReceitaLinhas / _cpfAntecEstado). */
    var _rf=_cpfReceitaLinhas(dd);
    if(_rf && _rf.length) kitKv2(st,'Receita Federal', _rf);
    else if(_rf) kitAtencao(st,'Receita Federal: não verificado — a base não respondeu e o valor dessa parte foi devolvido.');
    var _an=_cpfAntecEstado(dd);
    if(_an) kitAvisos(st,'Antecedentes criminais', [{ t:_an.t, nv:_an.nv }]);
    if(_an && _an.det) kitTexto(st, _an.det);
    kitKv2(st,'Comportamento de crédito', p.extras||[]);
    if(p.consultas&&p.consultas.length){
      var _ct=p.consultas.length, _ctTotal=p.consultasTotal||_ct;
      kitKv2(st,'Quem consultou este CPF'+(_ctTotal>_ct?(' — '+_ct+' mais recentes de '+_ctTotal):(' ('+_ctTotal+')')), p.consultas);
    }
    kitKv2(st,'Participação em empresas', p.empresa||[]);
    if(p.desconhecidos&&p.desconhecidos.length) kitAtencao(st,'Blocos não reconhecidos na resposta: '+p.desconhecidos.join(', ')+'. Confira no PDF do provedor.');
    if(dd&&dd.mev_score&&!dd.mev_score.ok) kitAtencao(st,'Score bancário não verificado — a fonte não respondeu e o valor dessa parte foi devolvido.');
    if(p.meta&&p.meta.data) kitTexto(st,'Consulta realizada em '+p.meta.data+'.');
    return kitFinaliza(st);
  }
  function restricaoCanvas(dd){
    return kitPrevia(restricaoPaginas(dd));
  }
  function _restDraw(dd,W,medindo,cols){
    dd=dd||{};
    var p=restParse(dd), tipo=dd.tipo_doc||'CPF';
    var _cadCpfV=((p.cadastro||[]).filter(function(r){ return r[0]==='CPF'&&r[1]; })[0]||[])[1]||'';
    var docm=_maskDoc(dd.documento||'')||_cadCpfV||String(dd.documento||'');
    cols=(cols===1)?1:2;
    var pad=Math.round(W*0.044), gap=Math.round(W*0.027);
    var colW=(cols===1)?(W-pad*2):Math.round((W-pad*2-gap)/2);
    var cv=document.createElement('canvas'); cv.width=medindo?1:W; cv.height=medindo?1:4600; var g=cv.getContext('2d');
    if(!medindo){ g.fillStyle='#ffffff'; g.fillRect(0,0,W,4600); }
    g.textAlign='left';
    var FF='system-ui,-apple-system,Arial';
    /* 🔴 v518 — O TERCEIRO ESTADO TAMBÉM NO PDF. ⚠️ TELA E PDF SÃO DOIS
       DESENHOS (HTML no restricaoPanelHtml, canvas aqui): a soma dos
       protestos se propaga sozinha porque os dois leem o mesmo `p.itens`,
       mas o veredito é escrito à mão nos dois — é aí que eles desandam. */
    var corRes=p.tem?'#b91c1c':(p.incerto?'#0a4da6':'#15803d');

    /* ---------- cabecalho clean: sem tarja escura (nao gasta toner) ---------- */
    g.fillStyle='#0a4da6'; g.font='800 17px '+FF;
    g.fillText('CONSULTA DE RESTRIÇÕES — '+String(tipo).toUpperCase(), pad, 62);
    g.fillStyle='#b6c2d4'; g.font='500 17px '+FF; g.textAlign='right';
    g.fillText('Gerado em '+histData(Date.now()), W-pad, 62); g.textAlign='left';
    g.fillStyle='#001e50'; g.font='800 40px '+FF; g.fillText(docm||'—', pad, 112);
    g.fillStyle=corRes; g.font='700 20px '+FF;
    g.fillText(String(p.incerto?'Não posso afirmar "nada consta" — confira o PDF do provedor':(p.status||'')).slice(0,64), pad, 148);
    /* selo do resultado SO com contorno */
    (function(){
      var txt=(p.tem?'CONSTAM PENDÊNCIAS':(p.incerto?'SEM VEREDITO':'NADA CONSTA')), bh=34, by=118;
      g.font='800 18px '+FF; var bw=g.measureText(txt).width+30, bx=W-pad-bw;
      g.strokeStyle=corRes; g.lineWidth=2; _rr(g,bx,by,bw,bh,17); g.stroke();
      g.fillStyle=corRes; g.textAlign='left'; g.fillText(txt, bx+15, by+23);
    })();
    g.fillStyle='#e8eef7'; g.fillRect(pad, 172, W-pad*2, 2);
    var top=200;

    /* ---------- faixa do SCORE — REMOVIDA na v595 (decisão do Angelo:
       "remove os dois scores, deixe sem"; o número não bate com SPC/Serasa
       e confundia). O parse segue lendo p.score/p.score2; pra voltar,
       redesenhar o quadro aqui e somar a altura no `top`. ---------- */

    /* ---------- medidas de um cartao (igualzinho ao PDF do CNPJ) ---------- */
    var PD=17, LH=23, TIT=32, DEPOIS=26;
    function _vOk(v){ if(v==null) return false; var t=String(v).trim(); return !!t&&t.toLowerCase()!=='null'; }
    function medir(titulo,rows){
      rows=(rows||[]).filter(function(r){ return _vOk(r[1]); });
      if(!rows.length) return null;
      var hs=rows.map(function(r){
        g.font='700 18px '+FF;
        return { lines:_wrapLines(g,String(r[1]),colW-2*PD) };
      });
      hs.forEach(function(o){ o.h=17+o.lines.length*LH+8; });
      var corpo=hs.reduce(function(a2,b2){ return a2+b2.h; },0)+10;
      return { titulo:titulo, rows:rows, hs:hs, corpo:corpo, h:TIT+corpo+DEPOIS };
    }
    function desenhar(c,x,y){
      g.fillStyle='#0a4da6'; _rr(g,x,y-4,5,22,3); g.fill();
      g.fillStyle='#001e50'; g.font='800 21px '+FF; g.textAlign='left'; g.fillText(c.titulo, x+15, y+14);
      y+=TIT;
      /* fundo BRANCO + contorno fino: na impressora nao gasta toner */
      g.fillStyle='#ffffff'; _rr(g,x,y,colW,c.corpo,14); g.fill();
      g.strokeStyle='#dbe4f0'; g.lineWidth=1.5; _rr(g,x,y,colW,c.corpo,14); g.stroke();
      var ry=y+5;
      c.rows.forEach(function(r,i){
        g.fillStyle='#94a3b8'; g.font='600 14px '+FF; g.fillText(String(r[0]).toUpperCase(), x+PD, ry+16);
        g.fillStyle=r[2]||'#0f172a'; g.font='700 18px '+FF;
        var vy=ry+16+22; c.hs[i].lines.forEach(function(ln){ g.fillText(ln, x+PD, vy); vy+=LH; });
        if(i<c.rows.length-1){ g.strokeStyle='#eef2f7'; g.lineWidth=1.5; g.beginPath(); g.moveTo(x+PD,ry+c.hs[i].h-3); g.lineTo(x+colW-PD,ry+c.hs[i].h-3); g.stroke(); }
        ry+=c.hs[i].h;
      });
      return y+c.corpo+DEPOIS;
    }

    var pendRows=(p.pend||[]).map(function(o){
      var sub=[o.data?('Desde '+o.data):'', o.tipo?('Tipo '+o.tipo):'', o.contrato?('Contrato '+o.contrato):''].filter(Boolean).join(' · ');
      return [ o.informante||'Credor não informado', _brl(o.valor)+(sub?('   ·   '+sub):''), '#b91c1c' ];
    });
    /* v518: o detalhe dos protestos no PDF, com a origem — o mesmo que a
       tela mostra. Dois desenhos, um conteúdo. */
    var protRows=(p.prot||[]).map(function(o){
      var onde=[o.cidade,o.uf].filter(Boolean).join('/');
      var sub=[o.data?('Desde '+o.data):'', onde, 'origem: '+o.origem].filter(Boolean).join(' · ');
      return [ o.cartorio||'Cartório não informado', (o.valor>0?_brl(o.valor):'—')+(sub?('   ·   '+sub):''), '#b91c1c' ];
    });
    var lista=[ medir('Identificação', p.cadastro),
                medir('Pendências / restrições', (p.itens||[]).map(function(it){ return [it.rot, it.det, it.ruim?'#b91c1c':'#15803d']; })),
                medir('Detalhe das pendências', pendRows),
                medir('Detalhe dos protestos', protRows),
                medir('Comportamento de crédito', p.extras),
                medir('Empresa', p.empresa),
                medir('Endereço', p.acerta?p.ident:[]),
                medir('Situação fiscal (MEI / Simples)', (p.fiscal||[]).map(function(f){ return [f.rot, f.val]; })) ].filter(Boolean);

    /* cada cartao cai na coluna mais curta -> as duas terminam parecidas */
    var yA=top, yB=top, xA=pad, xB=pad+colW+gap;
    if(cols===1){ lista.forEach(function(c){ yA=desenhar(c,xA,yA); }); }
    else { lista.forEach(function(c){ if(yA<=yB) yA=desenhar(c,xA,yA); else yB=desenhar(c,xB,yB); }); }

    var y=Math.max(yA,yB)+4;
    g.fillStyle='#e8eef7'; g.fillRect(pad, y, W-pad*2, 1); y+=24;
    g.textAlign='center';
    if(p.meta&&(p.meta.protocolo||p.meta.data)){
      g.fillStyle='#64748b'; g.font='600 16px '+FF;
      _wrapLines(g,[p.meta.protocolo?('Protocolo '+p.meta.protocolo):'', p.meta.data?('Consulta em '+p.meta.data):''].filter(Boolean).join('  ·  '), W-pad*2)
        .forEach(function(ln){ g.fillText(ln, W/2, y); y+=22; });
      y+=2;
    }
    /* v166b: o aviso da LGPD quebra em linhas -> nunca vaza da folha estreita */
    g.fillStyle='#94a3b8'; g.font='400 14px '+FF;
    _wrapLines(g,'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018). Dados informados pela base na data da consulta.', W-pad*2)
      .forEach(function(ln){ g.fillText(ln, W/2, y); y+=19; });
    y+=3;
    g.textAlign='left';

    if(medindo) return Math.max(560,y);
    var out=document.createElement('canvas'); out.width=W; out.height=Math.min(4600,Math.max(560,y));
    var og=out.getContext('2d'); og.fillStyle='#ffffff'; og.fillRect(0,0,out.width,out.height); og.drawImage(cv,0,0);
    return out;
  }
  function restricaoPdfAcao(modo){
    if(!_mevPdfPronto(function(){ restricaoPdfAcao(modo); },false)) return;
    try{
      var dd=Object.assign({}, _restState||{});
      if(!dd.documento){ dd.documento=String((($('restDoc')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); }
      if(!dd.tipo_doc) dd.tipo_doc=(String(dd.documento||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length>11?'CNPJ':'CPF');
      var _pdfP=null; try{ _pdfP=restParse(dd); }catch(_){}
      /* v595: páginas do kit — uma página A4 por canvas, sem fatiamento */
      var _pgs=restricaoPaginas(dd);
      if(dd.mev_score&&dd.mev_score.ok&&dd.mev_score.dados){
        var _scorePdf=Object.assign({},dd.mev_score.dados);
        if(!_scorePdf.documento) _scorePdf.documento=dd.documento;
        _pgs=_pgs.concat(cpfScorePaginas(_scorePdf));
      }
      var _blob=kitPdfBlob(_pgs);
      if(!_blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      /* v515 — antes: 'Restricoes-'+os 8 PRIMEIROS dígitos do CPF. Como os
         dois últimos são verificadores, aquilo reconstruía o documento com
         dez tentativas. Agora vai o NOME e a hora, que é o que distingue,
         e nenhum dígito. Ver nomeArquivoSeguro() no 01-nucleo.js. */
      var _nmPes=''; try{ (_pdfP&&_pdfP.cadastro||[]).forEach(function(r){ if(!_nmPes && /^nome completo/i.test(String(r[0]))) _nmPes=r[1]; }); }catch(_){}
      var nome=nomeArquivoSeguro(dd.mev_exemplo?'EXEMPLO-Consulta-CPF-Score':'Consulta-CPF-Score', _nmPes, Date.now())+'.pdf';
      pdfArquivoAcao(_blob,nome,modo,function(){ pdfVisor(_blob,nome); },'Consulta CPF');
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }
  function restricaoBaixarPDF(){ restricaoPdfAcao('baixar'); }
  /* v449 — baixa o PDF que o PROVEDOR mandou junto da consulta. */
  function restricaoPdfProvedor(){
    try{
      var p=restParse(_restState||{});
      var bruto=String((p&&p.meta&&p.meta.pdf)||'').trim();
      if(!bruto){ toast('Esta consulta não veio com o PDF do provedor.'); return; }
      if(/^https?:\/\//i.test(bruto)){ window.open(bruto,'_blank','noopener'); return; }
      var b64=bruto.replace(/^data:[^,]*,/,'').replace(/\s/g,'');
      var bin=atob(b64), n=bin.length, u8=new Uint8Array(n);
      for(var i=0;i<n;i++) u8[i]=bin.charCodeAt(i);
      /* v515 — este era o pior dos dois: saía com o CPF INTEIRO, os 11
         dígitos, sem máscara nenhuma. Mesma regra do outro download. */
      var _nmPes=''; try{ (p&&p.cadastro||[]).forEach(function(r){ if(!_nmPes && /^nome completo/i.test(String(r[0]))) _nmPes=r[1]; }); }catch(_){}
      var uu=URL.createObjectURL(new Blob([u8],{type:'application/pdf'}));
      var aa=document.createElement('a'); aa.href=uu; aa.download=nomeArquivoSeguro('Consulta', _nmPes, Date.now(), 'provedor')+'.pdf';
      document.body.appendChild(aa); aa.click();
      setTimeout(function(){ URL.revokeObjectURL(uu); aa.remove(); },800);
      toast('PDF do provedor baixado.');
    }catch(e){ toast('Não consegui abrir o PDF do provedor.'); }
  }
  /* delegação: o botão nasce dentro de um innerHTML montado em 4 portas de
     entrada diferentes (tela de CPF, histórico, card do histórico e a análise
     dentro da venda). Ouvir no documento evita religar em cada uma delas. */
  try{
    document.addEventListener('click', function(ev){
      var t=ev&&ev.target; if(!t||!t.closest) return;
      if(t.closest('#restPdfProv')){ ev.preventDefault(); restricaoPdfProvedor(); }
    });
  }catch(_){}

/* ╔═══ src/app/03b-editar-item-ficha.js ══════════════════════════════════ */
  /* ============ CORRIGIR O NOME DE UM ITEM DA FICHA (v353) ==================
     O PEDIDO
     "permita editar um item nos opcionais da ficha técnica, nesse caso não é
     roda 16 e sim 17".

     POR QUE ISSO IMPORTA
     A lista de equipamentos é montada por pesquisa da IA a partir do
     modelo/ano. Ela acerta quase tudo, mas erra detalhe de versão — e "aro
     16" contra "aro 17" é exatamente o tipo de coisa que o cliente confere
     na hora de olhar o carro. Até agora só dava pra DESMARCAR o item errado,
     o que apagava a informação inteira em vez de consertá-la: o carro TEM
     roda de liga leve, só que de outro aro.

     COMO FUNCIONA
     Cada linha (de série e opcional) ganhou um lápis. Toca, corrige o texto,
     pronto. Vale pros dois blocos, porque o erro de nome acontece nos dois.

     ONDE FICA GUARDADO
     Num dicionário de correções por placa, junto do resto do resumo da ficha
     (o mesmo mev_ficha_marc_<PLACA> que já guarda marcados/desmarcados):
        renomes: { "Rodas de liga leve aro 16": "Rodas de liga leve aro 17" }
     A chave é sempre o nome ORIGINAL. Isso é o que faz a correção sobreviver
     quando você manda gerar a ficha de novo: a IA devolve "aro 16" outra vez,
     e o app volta a mostrar "aro 17" — sem você corrigir duas vezes.

     POR QUE UM ARQUIVO NOVO
     Nada do 03-ficha-tecnica.js foi tocado. Este pedaço ENVOLVE duas funções
     que já existem (ligarFichaOpcionais e fichaParaRepasse) — mesmo truque
     que o 14d-facebook-ads.js usa com o _mktPostsHtml. Assim ele entra e sai
     trocando um arquivo, e não briga com nenhuma outra conversa que esteja
     mexendo na ficha.

     ONDE A CORREÇÃO APARECE: na tela e no anúncio do Portal do Repasse (é o
     fichaParaRepasse que monta aquele bloco). O PDF da ficha completa é
     desenhado direto do texto original da IA e continua mostrando o nome de
     lá — se incomodar, dá pra estender depois.
     ========================================================================= */

  var _FTED_SVG='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';

  function _ftedLer(placa){
    var r=(typeof fichaResumoLer==='function'?fichaResumoLer(placa):null)||{};
    return (r && typeof r.renomes==='object' && r.renomes) ? r.renomes : {};
  }
  function _ftedGravar(placa, original, novo){
    if(typeof fichaResumoLer!=='function' || typeof fichaResumoSalvar!=='function') return;
    var r=fichaResumoLer(placa)||{};
    var m=(r.renomes&&typeof r.renomes==='object')?r.renomes:{};
    novo=String(novo||'').trim();
    if(!novo || novo===original) delete m[original];   /* voltou ao original: some da lista */
    else m[original]=novo.slice(0,120);
    r.renomes=m; fichaResumoSalvar(placa, r);
  }
  /* o nome que deve APARECER pra um item */
  function ftedNome(placa, original){
    var m=_ftedLer(placa);
    return (m && m[original]) ? m[original] : original;
  }

  /* ---- pinta os nomes corrigidos e pendura o lápis em cada linha -------- */
  function _ftedDecorar(container, placa){
    if(!container||!placa) return;
    var linhas=container.querySelectorAll('.ft-serie-chk, .ft-opc-chk');
    Array.prototype.forEach.call(linhas, function(chk){
      var lb=chk.closest('label'); if(!lb || lb.getAttribute('data-fted')==='1') return;
      lb.setAttribute('data-fted','1');
      var original=chk.getAttribute('data-serie')||chk.getAttribute('data-opc')||'';
      if(!original) return;
      var sp=lb.querySelector('span'); if(!sp) return;

      /* mostra o nome corrigido (se houver) */
      var atual=ftedNome(placa, original);
      if(atual!==original) sp.textContent=atual;

      /* o lápis */
      var b=document.createElement('button');
      b.type='button'; b.className='fted-lapis';
      b.title='Corrigir o nome deste item'; b.setAttribute('aria-label','Corrigir o nome de '+atual);
      b.innerHTML=_FTED_SVG;
      b.style.cssText='margin-left:auto;flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:9px;background:#f1f5f9;color:#64748b;cursor:pointer';
      /* o label inteiro é clicável (marca/desmarca). Sem estes três freios,
         tocar no lápis também mexeria na caixinha. */
      b.onclick=function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var deMostrar=ftedNome(placa, original);
        var novo=prompt('Corrija o nome do item:', deMostrar);
        if(novo===null) return;
        novo=String(novo).trim();
        if(!novo){ toast('O nome não pode ficar vazio.'); return; }
        _ftedGravar(placa, original, novo);
        var mostrar=ftedNome(placa, original);
        sp.textContent=mostrar;
        b.setAttribute('aria-label','Corrigir o nome de '+mostrar);
        try{ fichaRepasseAtualiza(placa); }catch(_){}
        toast(novo===original?'Nome voltou ao original.':'Nome corrigido ✓');
      };
      b.addEventListener('mousedown',function(e){ e.preventDefault(); e.stopPropagation(); });
      b.addEventListener('touchstart',function(e){ e.stopPropagation(); },{passive:true});
      lb.appendChild(b);
    });
  }

  /* ---- envolve o ligarFichaOpcionais: mantém tudo o que ele já fazia e
     acrescenta a decoração. Sem isto, cada tela que desenha a ficha teria
     que lembrar de chamar o decorador. ----------------------------------- */
  try{
    if(typeof ligarFichaOpcionais==='function' && !ligarFichaOpcionais.__fted){
      var _ligarOrig=ligarFichaOpcionais;
      ligarFichaOpcionais=function(container, placa){
        try{ _ligarOrig(container, placa); }catch(_){}
        try{ _ftedDecorar(container, placa); }catch(_){}
      };
      ligarFichaOpcionais.__fted=true;
    }
  }catch(_){}

  /* ---- envolve o fichaParaRepasse: o anúncio sai com os nomes corrigidos -- */
  try{
    if(typeof fichaParaRepasse==='function' && !fichaParaRepasse.__fted){
      var _repOrig=fichaParaRepasse;
      fichaParaRepasse=function(placa){
        var f=null; try{ f=_repOrig(placa); }catch(_){ f=null; }
        if(!f) return f;
        try{
          f.serie=(f.serie||[]).map(function(n){ return ftedNome(placa,n); });
          f.opcionais=(f.opcionais||[]).map(function(n){ return ftedNome(placa,n); });
        }catch(_){}
        return f;
      };
      fichaParaRepasse.__fted=true;
    }
  }catch(_){}

/* ╔═══ src/app/03c-cpf-protesto.js ═══════════════════════════════════════ */
  /* ==========================================================================
     03c — O PROTESTO QUE O APP NÃO LIA (v518)
     (PROJETO-fase2-o-protesto-que-o-app-nao-le · Fase 2 do
      PROJETO-consulta-cpf-o-que-a-api-manda-e-o-app-ignora)

     🔴 O QUE ESTAVA EM JOGO, EM UMA FRASE:
     **a tela escrevia "PROTESTOS — Nada consta" para quem TEM protesto em
     cartório.** E o erro não se parecia com erro: se parecia com aprovação.
     O lojista financia o carro, entrega a chave, e o problema aparece
     depois. É o único bug do projeto do CPF que custa dinheiro de verdade.

     POR QUE ACONTECIA — O GALHO QUE NINGUÉM VISITA:

         data
          ├── acertaEssencialPositivo
          │    └── consultaCredito          ← o app lia SÓ ISTO
          │         └── protestos: []
          ├── protestoNacional              ← 🔴 NUNCA ERA LIDO
          │    ├── ocorrencias: [...]
          │    └── resumoConsulta.protestos
          └── resumoRetorno

     O `_fccDeep` (03) desce até achar `consultaCredito` e devolve SÓ esse
     pedaço. O `protestoNacional` é **IRMÃO** do `acertaEssencialPositivo`,
     não filho: ele chega ao navegador, é gravado no banco, e some.
     São listas DIFERENTES, de FONTES diferentes — o `protestos` de dentro
     do bloco de crédito é o do birô; o outro é cartório, âmbito nacional.

     🔴 E A REDE DE SEGURANÇA DA v372 NÃO PEGAVA ISSO — é o ponto que engana
     quem for consertar. Ela pergunta se existe a chave `Protestos` DENTRO
     do `cr`; e existe, vazia. Então `reconheci=true` e o app dava o veredito
     com confiança. A v372 foi feita pra "a API mudou o NOME das listas";
     ela não prevê "existe uma SEGUNDA lista, num galho que ninguém visita".
     São dois problemas diferentes, e o conserto de um não serve pro outro.
     (Já foi assim na v450, no caminho das pendências: terceiro capítulo da
     mesma história.)

     ⚠️ ONDE ESTE ARQUIVO VIVE: dentro do IIFE (01 → 19), logo depois do
     `03-ficha-tecnica.js`. Ele usa `_ciKey`, `_ciDeep`, `_asList`, `_ciTxt`,
     `_rNum`, `_brl` e `esc`, todos de lá — declaração de função sobe, então
     o 03 também enxerga o que está aqui.
     ⚠️ O 03 tem 120 KB e é disputado: módulo novo é a técnica anticolisão.
     ⚠️ **NADA MUDA NO SERVIDOR.** O `consultar.js` já entrega a resposta
     inteira e o `protestoNacional` já chega. Esta versão não depende de
     publicar pra ser testada.
     ========================================================================= */

  /* os blocos irmãos que o app SABE ler. A lista é curta e explícita de
     propósito — se ela crescer sem critério, a camada C (lá embaixo) para
     de proteger. */
  var CPF_BLOCOS_CONHECIDOS = ['acertaessencialpositivo','protestonacional','resumoretorno',
    'consultacredito','credcadastral','dadoscadastrais','error','message'];

  function _cpfNorm(s){ return String(s||'').toLowerCase().replace(/[^a-z]/g,''); }

  /* Acha a RAIZ da resposta: o objeto que contém o bloco de crédito (ou o
     resumoRetorno). É dele que a camada C varre os filhos diretos. */
  function _cpfRaiz(base){
    if(!base||typeof base!=='object') return null;
    function tem(o){
      if(!o||typeof o!=='object'||Array.isArray(o)) return false;
      for(var k in o){ if(!Object.prototype.hasOwnProperty.call(o,k)) continue;
        var n=_cpfNorm(k);
        if(n==='acertaessencialpositivo'||n==='resumoretorno'||n==='protestonacional') return true; }
      return false;
    }
    if(tem(base)) return base;
    for(var k in base){ if(!Object.prototype.hasOwnProperty.call(base,k)) continue;
      var v=base[k]; if(v&&typeof v==='object'&&!Array.isArray(v)&&tem(v)) return v; }
    return base;
  }

  /* ---------------------------------------------------------------------
     CAMADA A — SOMAR AS DUAS FONTES DE PROTESTO
     --------------------------------------------------------------------- */
  /* ⚠️ CONTA PELO RESUMO QUANDO ELE EXISTE, E PELA LISTA QUANDO NÃO.
     É a mesma lógica que a função `resumo()` do 03 já usa, e ela existe por
     um motivo: quando o provedor corta o detalhe, vem `quantidadeTotal: 2`
     com `ocorrencias: []`. Contando só pela lista, esses dois sumiriam. */
  function cpfProtestoNacional(base){
    var pn=_ciDeep(base||{}, ['ProtestoNacional']);
    if(!pn||typeof pn!=='object') return { q:0, v:0, lista:[] };
    var lista=_asList(_ciKey(pn,['Ocorrencias','Protestos','Itens']));
    var q=0, v=0;
    var rc=_ciKey(pn,['ResumoConsulta']);
    var rp=rc?_ciKey(rc,['Protestos']):null;
    if(rp&&typeof rp==='object'){
      var qq=_ciKey(rp,['QuantidadeTotal','Quantidade','Total']);
      var vv=_ciKey(rp,['ValorTotal','Valor']);
      if(qq!=null||vv!=null){
        q=parseInt(String(qq==null?0:qq).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
        v=_rNum(vv);
      }
    }
    var det=lista.map(function(o){
      return { cartorio:_ciTxt(o,'Cartorio','Cartório','NomeCartorio','Serventia','Informante'),
               cidade:_ciTxt(o,'Cidade','Municipio','Praca','Praça'),
               uf:_ciTxt(o,'Uf','Estado'),
               data:_ciTxt(o,'Data','DataProtesto','DataOcorrencia'),
               valor:_rNum(_ciKey(o,['Valor','ValorTotal','ValorProtesto'])),
               origem:'cartório nacional' };
    });
    /* sem resumo: a lista manda */
    if(!q && det.length){ q=det.length; v=det.reduce(function(s,x){ return s+x.valor; },0); }
    return { q:q, v:v, lista:det };
  }

  /* o detalhe do protesto do BIRÔ (o que já vinha, e que nunca foi desenhado) */
  function cpfProtestoBiro(cr){
    return _asList(_ciKey(cr||{},['Protestos'])).map(function(o){
      return { cartorio:_ciTxt(o,'Cartorio','Cartório','NomeCartorio','Informante','Credor'),
               cidade:_ciTxt(o,'Cidade','Municipio','Praca','Praça'),
               uf:_ciTxt(o,'Uf','Estado'),
               data:_ciTxt(o,'Data','DataProtesto','DataOcorrencia'),
               valor:_rNum(_ciKey(o,['Valor','ValorTotal'])),
               origem:'birô' };
    });
  }

  /* 🔴 RISCO Nº 1 DO PROJETO: contar o MESMO protesto duas vezes. Se um dia
     o provedor repetir a ocorrência nos dois blocos, o lojista vê o dobro e
     recusa um cliente bom. Compara cartório + data + valor antes de somar. */
  function cpfProtestoJuntar(biro, nacional){
    var vistos={}, out=[];
    function chave(p){
      return _cpfNorm(p.cartorio)+'|'+String(p.data||'').replace(/\D/g,'')+'|'+Math.round(p.valor||0);
    }
    (biro||[]).concat(nacional||[]).forEach(function(p){
      var k=chave(p);
      if(k==='||0'){ out.push(p); return; }         /* sem nada pra comparar: entra */
      if(vistos[k]) return;
      vistos[k]=1; out.push(p);
    });
    return out;
  }

  /* ---------------------------------------------------------------------
     CAMADA B — DIZER DE ONDE VEIO CADA PROTESTO
     --------------------------------------------------------------------- */
  /* ⚠️ NÃO reaproveitar o `_pendListHtml` na força: pendência tem
     informante e contrato; protesto tem cartório, praça e data. Campos
     diferentes, cartão parecido. Sem a origem escrita, o lojista que ouvir
     "eu não tenho protesto nenhum" do cliente não sabe onde ir conferir. */
  function cpfProtestoListaHtml(lista){
    if(!lista||!lista.length) return '';
    return '<div style="font-size:10.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:11px 2px 5px">Detalhe dos protestos ('+lista.length+')</div>'+
      '<div style="background:#fff;border:1px solid #fecaca;border-radius:12px;overflow:hidden;box-shadow:0 2px 8px rgba(2,20,60,.05)">'+
      lista.map(function(o,i){
        var onde=[o.cidade,o.uf].filter(Boolean).join('/');
        var sub=[o.data?('Desde '+o.data):'', onde, 'origem: '+o.origem].filter(Boolean).join(' · ');
        return '<div style="padding:7px 12px;'+(i?'border-top:1px dashed #fee2e2;':'')+'">'+
          '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline">'+
            '<span style="flex:1;min-width:0;font-size:12.6px;font-weight:700;color:#0f172a;line-height:1.3">'+esc(o.cartorio||'Cartório não informado')+'</span>'+
            (o.valor>0?('<span style="flex:none;font-size:13px;font-weight:900;color:#b91c1c">'+esc(_brl(o.valor))+'</span>'):'')+
          '</div>'+
          '<div style="font-size:10px;color:#94a3b8;margin-top:1px">'+esc(sub)+'</div>'+
        '</div>';
      }).join('')+'</div>';
  }

  /* ---------------------------------------------------------------------
     🔴 CAMADA C — O VEREDITO CONSERVADOR. É esta que faz o conserto DURAR.
     --------------------------------------------------------------------- */
  /* Sem ela, o próximo bloco que a API inventar cria o mesmo bug de novo, e
     de novo ninguém percebe. Regra: se algum filho direto da raiz carrega
     `resumoConsulta` ou `ocorrencias` e NÃO está na lista dos que o app sabe
     ler, o app **não dá veredito** — nem verde, nem vermelho.

     ⚠️ NUNCA O CONTRÁRIO. O desconhecido não pode virar "constam
     pendências": acusar quem não deve é tão ruim quanto absolver quem deve.
     O certo é NÃO AFIRMAR e mandar conferir o PDF do provedor.

     ⚠️ RISCO Nº 2 DO PROJETO — deixar o app medroso. Se esta regra for larga
     demais, o cartão azul aparece sempre e o "Nada consta" nunca mais sai —
     a tela perde a serventia. Por isso a lista de conhecidos é explícita e
     só entram aqui blocos que REALMENTE carregam restrição. */
  function cpfBlocosDesconhecidos(base){
    var raiz=_cpfRaiz(base); if(!raiz||typeof raiz!=='object') return [];
    var out=[];
    for(var k in raiz){
      if(!Object.prototype.hasOwnProperty.call(raiz,k)) continue;
      var n=_cpfNorm(k); if(CPF_BLOCOS_CONHECIDOS.indexOf(n)>=0) continue;
      var v=raiz[k]; if(!v||typeof v!=='object') continue;
      var temRestricao = (_ciKey(v,['ResumoConsulta'])!=null) || (_ciKey(v,['Ocorrencias'])!=null);
      if(temRestricao) out.push(String(k));
    }
    return out;
  }
  var CPF_AVISO_DESCONHECIDO = 'Esta consulta trouxe informação que eu ainda não sei ler. Confira o PDF do provedor antes de decidir.';

/* ╔═══ src/app/03d-consultas-veiculo.js ══════════════════════════════════ */
  /* ==========================================================================
     03d — AS CONSULTAS DE VEÍCULO POR PLACA (v628)
     ==========================================================================
     Projetos do Angelo, 24/08 — três de uma vez, e de propósito na mesma
     família:
        PROJETO-2026-08-24-consulta-gravame.txt          -> v628 (esta)
        PROJETO-2026-08-24-consulta-multas-renainf.txt   -> v629
        PROJETO-2026-08-24-consulta-renajud.txt          -> v630

     🔑 UM DESENHO SÓ, TRÊS PÁGINAS — a mesma decisão que a v613 tomou nas
     três páginas de CPF. O que muda entre elas cabe na tabela VEIC_PAGS
     abaixo; o resto (campo da placa, botão, resultado, rodapé) é o mesmo
     código. Página nova no futuro = uma linha na tabela + um desenhista.

     🔴 POR QUE NÃO REAPROVEITEI A PÁGINA DE CPF INTEIRA. O desenho é o
     mesmo (as classes .cpf3-* são as dela), mas o MIOLO não é: lá o
     documento tem 11 números e exige o aceite LGPD; aqui é uma placa de 7.
     Forçar as duas na mesma função criaria um `if(ehCpf)` em cada linha —
     o tipo de economia que cobra juros. É irmã, não gêmea. A mesma decisão
     foi tomada no servidor entre _consultaCpfTipo e _consultaVeiculoTipo.

     ⚠️ CSS: ZERO linha nova. Tudo aqui usa classes que já existem —
     .cpf3-cards/.cpf3-card/.cpf3-h/.cpf3-t/.cpf3-s/.cpf3-lista/.cpf3-bt
     (v601), .lh-inp (o campo de placa do leilão) e .fic-item (os cards que
     abrem, via _cpfBloco).
     ========================================================================= */

  /* [chave da página] -> tudo que muda entre elas */
  var VEIC_PAGS = {
    /* v1149 — combo histórico + FIPE. O preço é gêmeo do servidor:
       4,44 un, já incluindo a consulta FIPE atual de R$ 0,06. */
    proprietarios:{
      produto:'historico_proprietarios', aba:'proprietarios', tok:4.44, salvar:true,
      titulo:'Histórico de Proprietários + FIPE', sub:'Transferências, passagem por empresa e FIPE atual',
      card:'Histórico de proprietários + FIPE',
      bt:'veicBtProprietarios', ex:'veicExProprietarios',
      carregando:'Consultando o histórico de proprietários…',
      itens:['Valor, código e mês de referência da FIPE atual',
             'Qual é o registro de proprietário mais recente disponível na base',
             'Quantas transferências e donos distintos aparecem na base',
             'Cidade e estado informados em cada transferência',
             'Se o veículo já pertenceu a uma empresa'] },
    gravame:{
      produto:'gravame', aba:'gravame', tok:2.43,
      titulo:'Gravame + FIPE', sub:'Alienação, banco e FIPE atual no mesmo relatório',
      card:'Gravame + FIPE',
      bt:'veicBtGravame', ex:'veicExGravame',
      carregando:'Consultando o gravame…',
      itens:['Valor, código e mês de referência da FIPE atual',
             'Se o veículo está COM ou SEM alienação fiduciária hoje',
             'Qual banco/financeira é o agente do gravame',
             'Número do contrato e data do gravame',
             'Histórico de inclusão e baixa, quando a base traz'] },
    /* v1278/v1279 — uma autorização, três fontes: FIPE por placa, Recall por
       placa e Recall V2 pelo chassi que a própria FIPE devolve. O preço
       público é R$ 7,39, com margem bruta de 40,06% sobre R$ 4,43 de custo.
       `tok` preserva somente a unidade legada interna da carteira. */
    recall:{
      produto:'recall', aba:'recall', tok:3.89, salvar:true,
      titulo:'Recall + Recall V2 + FIPE', sub:'Duas bases de recall e identificação FIPE no mesmo relatório',
      card:'Recall',
      bt:'veicBtRecall', ex:'veicExRecall',
      carregando:'Consultando o recall do veículo…',
      etapas:['Consultando a FIPE e identificando o chassi…',
              'Verificando recall pela placa…',
              'Verificando recall pelo chassi…',
              'Consolidando as duas bases consultadas…'],
      itens:['Valor, código e mês de referência da FIPE atual',
             'Recall consultado pela placa do veículo',
             'Recall V2 consultado pelo chassi encontrado na FIPE',
             'Campanhas, riscos, reparos e situação informados pelas bases',
             'Indicação clara quando alguma fonte não responder'] },
    debitos:{
      produto:'debitos_estaduais', aba:'debitos', tok:5.23, salvar:true,
      titulo:'Débitos e restrições', sub:'IPVA, multas detalhadas, licenciamento e alienação',
      card:'Débitos, multas e restrições estaduais',
      bt:'veicBtDebitos', ex:'veicExDebitos',
      carregando:'Consultando débitos, multas e restrições estaduais…',
      itens:['Pendências de IPVA, licenciamento e DPVAT',
             'Multas RENAINF com data, infração, órgão, local e valor',
             'Alienação ou financiamento informado pela base estadual',
             'Restrições gerais, RENAJUD, roubo/furto e baixa',
             'Situação do veículo e data de atualização da fonte'] },
    /* v629 — MULTAS (RENAINF) */
    multas:{
      produto:'renainf', aba:'multas', tok:5,
      titulo:'Consulta Multas (RENAINF)', sub:'Infrações, valores e o que está em aberto',
      card:'Multas · RENAINF',
      bt:'veicBtMultas', ex:'veicExMultas',
      carregando:'Consultando as multas…',
      itens:['Quantas multas o veículo tem e o total EM ABERTO',
             'Data, descrição da infração e órgão autuador de cada uma',
             'Valor de cada multa e se já foi paga',
             'Nº do auto, local, código da infração e exigibilidade'] },
    /* v630 — RENAJUD (bloqueio judicial). v774: o campo RENAVAM saiu da
       tela — a consulta roda só com a placa (o servidor sempre tratou o
       renavam como opcional); quando o app já conhece o renavam DA MESMA
       placa, ele viaja sozinho no corpo (veicCorpoPedido). */
    renajud:{
      produto:'renajud', aba:'renajud', tok:5,
      titulo:'Consulta RENAJUD', sub:'Bloqueio judicial: dá pra transferir hoje?',
      card:'RENAJUD · bloqueio judicial',
      bt:'veicBtRenajud', ex:'veicExRenajud',
      carregando:'Consultando bloqueios judiciais…',
      itens:['Se existe BLOQUEIO ATIVO hoje — o que impede a transferência',
             'Quantas ocorrências o veículo já teve no histórico',
             'Tribunal, número do processo e data de cada ocorrência',
             'Tipo da restrição (transferência · circulação · licenciamento)'] },
    /* ===== v744 — OS DOIS CARDS DA AUTOCORP (pedido do Angelo, 30/08) =====
       "montar os cards das consultas da AutoCorp — Leilão + PT e Premium —
        tudo com os dados de homologação e depois eu substituo pelos de
        produção".
       ⚠️ `autocorp:true` liga: histórico próprio (reabre sem custo), faixa
       de homologação no resultado e a porta (body.autocorp-off esconde os
       cards de quem o servidor não liberou — ver autocorpStatusAtualizar).
       O preço `tok` é o mesmo do PRECOS do servidor (margem bruta de 40%);
       em homologação o servidor não cobra e o botão diz isso. */
    leilaopt:{
      produto:'autocorp_leilao_pt', aba:'leilaopt', tok:11.27, autocorp:true,
      titulo:'Leilão + Perda Total', sub:'Leilão, sinistro, perda total, score e agregados',
      card:'Leilão + PT · AutoCorp',
      bt:'veicBtLeilaoPt', ex:'veicExLeilaoPt',
      carregando:'Consultando leilão e perda total…',
      itens:['Se o veículo já passou por LEILÃO — com lote, pátio, data e leiloeiro',
             'Score de aceitação e condição geral do veículo no leilão',
             'Indício de SINISTRO e registro de PERDA TOTAL (seguradora)',
             'Dados e restrições dos agregados informados pela AutoCorp'] },
    premium:{
      /* v890 — 55 → 39 tokens (decisão do Angelo, 04/09). A conta a R$ 1,90
         por token: receita R$ 74,10 contra custo R$ 36,45 = 2,03× o custo,
         acima da régua de 1,5× da casa.
         ⚠️ ESTE NÚMERO TEM UM GÊMEO NO SERVIDOR: `autocorp_premium` no
         `netlify/functions/consultar.js`. Quem cobra é ele; este aqui só
         mostra. Mudar um sem o outro faz a tela mentir — é a v483 de novo,
         com o preço no lugar do endereço. */
      produto:'autocorp_premium', aba:'premium', tok:31.98, autocorp:true,
      titulo:'Total Premium', sub:'A consulta completa: estadual, leilão, roubo/furto, PT, recall e alertas',
      card:'Total Premium · AutoCorp',
      bt:'veicBtPremium', ex:'veicExPremium',
      carregando:'Consultando a base completa…',
      itens:['Tudo do Leilão + PT: leilões, score, sinistro e perda total',
             'Situação ESTADUAL: IPVA, multas, licenciamento, DPVAT e financiamento',
             'Histórico de ROUBO/FURTO, restrição RENAJUD e veículo baixado',
             'RECALL do modelo, alertas gerais e localizador de agregados'] },
    /* v999 — preço recalculado sobre o custo REAL da fatura (R$ 32,52), e
       não sobre o custo contratado que a v995 usou (R$ 36,27). O preço
       visível passa de R$ 60,46 para R$ 54,21 (28,53 × R$ 1,90), margem
       bruta de 40,04%. ⚠️ GÊMEO do PRECOS do consultar.js: mudar um sem o
       outro faz a tela mostrar um preço e o servidor cobrar outro. */
    especialjud:{
      produto:'autocorp_especial_judicial', aba:'especialjud', tok:28.53, autocorp:true,
      /* v997 — o worker espera até 8 min; a tela acompanha com folga para
         receber também o fechamento e o PDF, sem disparar outra consulta. */
      esperaMs:570000,
      msgEspera:'A consulta judicial ainda está processando. Você pode sair desta tela e consultar a mesma placa mais tarde; o resultado será reaproveitado sem nova cobrança.',
      titulo:'Leilão Especial Plus + Ações Judiciais', sub:'Leilão especial, bloqueios judiciais, roubo/furto, perda total e alertas',
      card:'Leilão Especial + Judicial · AutoCorp',
      bt:'veicBtEspecialJud', ex:'veicExEspecialJud',
      carregando:'Consultando leilão especial e ações judiciais…',
      itens:['BIN estadual e restrições vinculadas ao veículo, incluindo RENAJUD',
             'Histórico de ROUBO/FURTO, recuperação e devolução',
             'Registro de PERDA TOTAL e indício de sinistro',
             'Alertas gerais encontrados nas bases consultadas'] }
  };
  var _veicPagAtual='gravame';
  var _veicState=null;
  var _veicFrases=['Consultando as bases do veículo…','Validando os dados encontrados…','Organizando as informações…','Montando o relatório…'];

  function veicPagEsc(q){ return (VEIC_PAGS[q]?q:'gravame'); }
  function _veicTok(n){ return precoReal(n); }
  function _veicLista(itens){   /* v751: sem emoji — o padrão do 02c desenha a lista */
    return consultaUiBeneficios(itens);
  }

  /* ---------- leitores tolerantes ------------------------------------------
     🔴 As três respostas vêm ACHATADAS e com nomes diferentes do que a
     documentação promete (o gravame chama de `financeiranome`, o RENAJUD de
     `nomeorgaojudicial`). Procurar por REGEX no nome da chave, em qualquer
     nível, é o que a casa já faz no CPF (_cpf3Key/_cpf3Deep). Nome próprio
     (_veic*) porque o IIFE é um só e a última declaração vence — grep antes
     de criar, lição da v599. */
  function _veicKey(o,re){
    if(!o||typeof o!=='object') return null;
    var ks=Object.keys(o);
    for(var i=0;i<ks.length;i++){ if(re.test(ks[i].toLowerCase().replace(/[^a-z0-9]/g,''))) return o[ks[i]]; }
    return null;
  }
  function _veicDeep(o,re,prof){
    prof=prof||0; if(!o||typeof o!=='object'||prof>7) return null;
    var v=_veicKey(o,re); if(v!=null && typeof v!=='object') return v;
    var ks=Object.keys(o);
    for(var i=0;i<ks.length;i++){ var x=o[ks[i]]; if(x&&typeof x==='object'){ var r=_veicDeep(x,re,prof+1); if(r!=null) return r; } }
    return null;
  }
  /* 🔴 O VAZIO DESTES PROVEDORES TEM TRÊS ROUPAS, e as três apareceram nos
     exemplos: "" (gravame), "*****" e "0,00" (RENAINF), "0" e "-" (RENAJUD).
     Tratar as três como ausente — senão a tela enche de zero sem sentido
     ("0 eixos") e de asterisco. */
  function _veicVazio(v){
    if(v==null) return true;
    var s=String(v).trim();
    if(!s) return true;
    if(/^[*]+$/.test(s)) return true;
    if(/^-+$/.test(s)) return true;
    if(/^0([.,]0+)?$/.test(s)) return true;
    return false;
  }
  function _veicTxt(v){ return _veicVazio(v) ? '' : String(v).trim(); }
  function _veicChassi(c){ c=_veicTxt(c); return c ? (typeof chassiMask==='function'?chassiMask(c):c) : ''; }
  /* linha "rótulo · valor" do bloco essencial; campo ausente vira
     "não informado" em vez de sumir — some é o que faz o lojista achar que
     a tela quebrou */
  function _veicLinha(rot, val, classe){
    var v=_veicTxt(val);
    return '<div class="veic-resultado-linha'+(classe?' '+esc(classe):'')+'" style="display:flex;gap:10px;justify-content:space-between;padding:9px 0;border-bottom:1px solid #eef2f7">'
      +'<span style="font-size:12.5px;color:#64748b">'+esc(rot)+'</span>'
      +'<span style="font-size:13px;font-weight:800;color:'+(v?'#0f172a':'#94a3b8')+';text-align:right">'+esc(v||'não informado')+'</span></div>';
  }
  /* a faixa de veredito, no desenho do kitVeredito do PDF (v597) */
  function _veicVeredito(nivel, titulo, linha){
    var c = nivel==='no'  ? ['#fef2f2','#fecaca','#dc2626','#b91c1c']
          : nivel==='mid' ? ['#fffbeb','#fde68a','#d97706','#b45309']
          :                 ['#f0fdf4','#bbf7d0','#16a34a','#15803d'];
    return '<div class="veic-veredito is-'+esc(nivel)+'" style="background:'+c[0]+';border:1px solid '+c[1]+';border-left:6px solid '+c[2]+';border-radius:12px;padding:11px 13px;margin:4px 0 10px">'
      +'<div class="veic-veredito-titulo" style="font-weight:800;color:'+c[3]+';font-size:15px">'+esc(titulo)+'</div>'
      +(linha?('<div class="veic-veredito-texto" style="font-size:12.5px;color:#475569;margin-top:3px">'+esc(linha)+'</div>'):'')
    +'</div>';
  }
  function _veicRodape(id){
    var d=_veicIdent(id||{});
    var pe=[d.placa, d.uf, d.chassi].filter(Boolean).join(' · ');
    return (pe?('<div style="font-size:11px;color:#94a3b8;margin-top:9px">'+esc(pe)+'</div>'):'')
      +'<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:5px">Informação das bases oficiais verificadas na data da consulta. Dados pessoais do proprietário omitidos (LGPD, Lei 13.709/2018).</div>';
  }
  function _veicIdent(base){
    return {
      placa:_veicTxt(_veicDeep(base,/^placa$/)),
      uf:_veicTxt(_veicDeep(base,/^(uf|ufplaca|ufemplacamento|ufjurisdicao)$/)),
      chassi:_veicChassi(_veicDeep(base,/^(chassi|chassis|numerochassi)$/))
    };
  }
  /* o núcleo dos dados, seja qual for o embrulho que o gateway usar */
  function _veicBase(dd){
    var b=dd||{};
    b=b.resultado||b;
    b=b.response||b.dados||b.data||b;
    return b||{};
  }

  /* ==========================================================================
     🔴 v860 (pedido do Angelo, 03/09): "mascare o número do contrato do
     gravame no PDF e resultado".
     --------------------------------------------------------------------------
     O contrato de financiamento é dado do CLIENTE, não do carro — e o PDF do
     gravame circula por WhatsApp e email. Ele aparecia inteiro
     (5002052202400618 00, no print dele).

     A ESCOLHA, perguntada antes: guardar os 4 ÚLTIMOS e esconder o resto, e
     MASCARAR SEMPRE — ninguém vê o número completo, nem na tela. Os 4 finais
     bastam pra conferir com o cliente ("termina em 1800?") sem expor o resto.
     É o mesmo desenho que a casa já usa no chassi (9BWKB05Z***061).

     🔴 POR QUE AQUI, E NÃO NOS DOIS LUGARES QUE DESENHAM: porque são DOIS —
     a tela (_veicLinha) e o PDF (kitKv2) — e amanhã pode ser um terceiro.
     Mascarar no ponto onde o valor NASCE fecha a porta por construção:
     quem escrever a próxima tela recebe o valor já mascarado sem precisar
     saber que esta regra existe. Mascarar na saída é uma promessa que alguém
     esquece de cumprir; mascarar na entrada é uma garantia.
     ⚠️ HONESTIDADE SOBRE O ALCANCE: isto tapa TUDO que a tela e o PDF
     mostram. O número cru ainda VIAJA na resposta do provedor até o
     navegador (é lá que este código roda). Pra ele nem chegar aqui, o corte
     teria de ser no servidor, dentro do consultar.js — é um passo a mais,
     e está anotado como o próximo se o Angelo quiser.
     ⛳ PRA VOLTAR: tire o _veicMascContrato() da linha do `contrato:`. */
  function _veicMascContrato(v){
    var s=String(v==null?'':v).trim();
    if(!s) return s;
    /* mantém os 4 últimos CARACTERES ÚTEIS; se o número for curtinho (≤4),
       não há o que esconder sem virar mentira — devolve como veio. */
    if(s.length<=4) return s;
    return new Array(Math.min(s.length-4, 12)+1).join('•') + s.slice(-4);
  }

  /* ==========================================================================
     🔴 v861 (pedido do Angelo, 03/09): "inclua nas consultas ... uma consulta
     FIPE junto pra aparecer as informações do veículo junto com a consulta,
     adicione as informações da FIPE ao PDF".
     E, no mesmo dia: "multas vem só isso, tem mais informações que dá pra
     incluir na consulta?" — com o print de um PDF de RENAINF que tinha UMA
     linha verde e UMA placa numa folha inteira. É o mesmo problema.
     --------------------------------------------------------------------------
     🔑 A DESCOBERTA QUE MUDOU O DESENHO: fui olhar no banco antes de escrever
     e os dados JÁ SÃO DELE. O histórico de consultas guarda, por placa:
     marca, modelo, versão, ano, ano_modelo, cor, combustível, chassi,
     município, UF, FIPE, código FIPE e mês de referência.

     Ou seja: a decisão dele ("não cobra nada a mais") não é ele absorvendo um
     custo — é custo ZERO de verdade. No caminho normal (consulta a placa,
     depois roda o gravame nela) o dado já está na casa. Nenhuma chamada nova,
     nenhum token.

     A ORDEM DE QUEM RESPONDE PRIMEIRO — do mais barato pro menos:
       1. o veículo que já está na tela  (mesma placa: de graça, em memória)
       2. o histórico de consultas dele  (de graça, uma leitura pequena)
       3. o estoque dele                 (de graça, uma leitura pequena)
       4. não achou → O QUADRO DIZ ISSO, e não consulta nada.

     🔴 O PASSO 4 É O QUE IMPORTA: eu poderia disparar uma consulta paga pra
     preencher o quadro quando falta dado. NÃO FAÇO. Ele pediu sem custo
     extra, e sem custo extra vale INCLUSIVE quando isso significa não ter o
     dado. Gastar token do lojista pra encher um quadro bonito é o tipo de
     coisa que ele só descobre no fim do mês.
     ⛳ PRA DESLIGAR: `MEV_QUADRO_VEICULO = false` no 00-edicoes.js. */
  var _veicDadosCache={};
  function _veicPlacaLimpa(v){ return String(v||'').replace(/[^A-Za-z0-9]/g,'').toUpperCase(); }
  function _veicDoObjeto(o){
    if(!o||typeof o!=='object') return null;
    var d={
      marca:_veicTxt(o.marca), modelo:_veicTxt(o.modelo), versao:_veicTxt(o.versao),
      ano:_veicTxt(o.ano||o.ano_modelo), anoModelo:_veicTxt(o.ano_modelo),
      cor:_veicTxt(o.cor), combustivel:_veicTxt(o.combustivel),
      municipio:_veicTxt(o.municipio), uf:_veicTxt(o.uf),
      fipe:_veicTxt(o.fipe), codigoFipe:_veicTxt(o.codigo_fipe), mesRef:_veicTxt(o.mes_ref)
    };
    /* só vale se tiver o mínimo pra alguém reconhecer o carro */
    return (d.marca||d.modelo) ? d : null;
  }
  async function _veicDadosGratis(placa){
    var pl=_veicPlacaLimpa(placa); if(!pl) return null;
    if(_veicDadosCache[pl]!==undefined) return _veicDadosCache[pl];
    var achou=null;
    /* 1) o que já está na tela — de graça e instantâneo */
    try{
      var va=veiculoAtual||null;
      if(va && _veicPlacaLimpa(va.placa)===pl) achou=_veicDoObjeto(va);
    }catch(_){}
    /* 2) o histórico DELE — o dado já foi pago uma vez, não se paga de novo */
    if(!achou) try{
      var rh=await supa.from('historico_consulta').select('dados')
                       .eq('user_id', meuId).eq('placa', pl)
                       .order('ts',{ascending:false}).limit(1);
      if(rh && rh.data && rh.data.length) achou=_veicDoObjeto(rh.data[0].dados||{});
    }catch(_){}
    /* 3) o estoque DELE — carro da casa, dado da casa */
    if(!achou) try{
      var re=await supa.from('estoque').select('marca,modelo,versao,ano,cor,combustivel,fipe')
                       .eq('user_id', meuId).eq('placa', pl).limit(1);
      if(re && re.data && re.data.length) achou=_veicDoObjeto(re.data[0]);
    }catch(_){}
    _veicDadosCache[pl]=achou;
    return achou;
  }
  /* 🔴 O PDF é montado de forma SÍNCRONA (o kit do 06b desenha direto), e a
     busca dos dados é assíncrona. Em vez de tornar o PDF assíncrono — que
     mexeria em todo o kit e nas outras consultas — o PDF lê o que a TELA já
     guardou: quando o resultado apareceu, o dado já foi buscado e ficou no
     cache. Se por algum motivo não estiver lá, o quadro simplesmente não sai
     e o resto da folha continua igual. Nada trava, nada espera. */
  function _veicDadosJa(placa){
    var pl=_veicPlacaLimpa(placa);
    return (pl && _veicDadosCache[pl]) ? _veicDadosCache[pl] : null;
  }
  /* v1149 — a FIPE do combo vem do servidor já reduzida a campos seguros.
     Ela tem prioridade sobre o cache antigo porque foi consultada agora. */
  function _veicFipeCombo(dd){
    var b=_veicBase(dd), f=b&&b.fipe_combo;
    var d=_veicDoObjeto(f);
    if(d || !f || typeof f!=='object') return d;
    /* A FIPE ainda é útil quando o provedor devolve preço/código, mas deixa
       a identificação vazia. */
    d={ fipe:_veicTxt(f.fipe), codigoFipe:_veicTxt(f.codigo_fipe), mesRef:_veicTxt(f.mes_ref) };
    return (d.fipe||d.codigoFipe)?d:null;
  }
  function _veicAvisoCombo(dd, aviso){
    if(aviso) return aviso;
    var b=_veicBase(dd);
    return b&&b.fipe_combo_indisponivel
      ?'A consulta principal foi concluída, mas a FIPE atual não respondeu. Foi cobrado somente o produto principal.' : '';
  }
  function _veicMesclarDados(base, atual){
    var d=base?Object.assign({},base):{};
    if(atual) Object.keys(atual).forEach(function(k){
      if(atual[k]!==undefined && atual[k]!==null && String(atual[k]).trim()!=='') d[k]=atual[k];
    });
    return Object.keys(d).length?d:null;
  }
  function _veicDadosComCombo(placa, dd){
    var d=_veicMesclarDados(_veicDadosJa(placa),_veicFipeCombo(dd));
    if(d) _veicDadosCache[_veicPlacaLimpa(placa)]=d;
    return d;
  }
  /* as linhas do quadro, na ordem em que o lojista lê o carro */
  function _veicQuadroLinhas(d){
    if(!d) return [];
    var carro=[d.marca, d.modelo].filter(Boolean).join(' ');
    var linhas=[];
    if(carro) linhas.push(['Veículo', carro + (d.versao && d.modelo.indexOf(d.versao)<0 ? (' '+d.versao) : '')]);
    if(d.ano) linhas.push(['Ano', d.ano + (d.anoModelo && d.anoModelo!==d.ano ? ('/'+d.anoModelo) : '')]);
    if(d.cor) linhas.push(['Cor', d.cor]);
    if(d.combustivel) linhas.push(['Combustível', d.combustivel]);
    if(d.municipio||d.uf) linhas.push(['Município', [d.municipio, d.uf].filter(Boolean).join(' / ')]);
    if(d.fipe) linhas.push(['FIPE', d.fipe + (d.mesRef?(' · ref. '+d.mesRef):'')]);
    if(d.codigoFipe) linhas.push(['Código FIPE', d.codigoFipe]);
    return linhas;
  }
  function _veicQuadroHtml(d, classe){
    var ligado=true; try{ if(typeof window.edQuadroVeiculo==='function') ligado=window.edQuadroVeiculo(); }catch(_){}
    if(!ligado) return '';
    var l=_veicQuadroLinhas(d);
    if(!l.length){
      /* 🔴 a verdade, não um quadro vazio: o lojista precisa saber POR QUE
         não tem os dados, e o que fazer — não ficar achando que quebrou. */
      return '<div class="consulta-ui-trust" style="margin:10px 0 2px">Dados do veículo não disponíveis para esta placa — consulte a placa uma vez e eles passam a vir junto, sem custo.</div>';
    }
    return '<div class="veic-quadro'+(classe?(' '+esc(classe)):'')+'" style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:6px 14px 10px;margin-bottom:10px;box-shadow:0 3px 12px rgba(2,20,60,.06)">'
      +'<div style="font:800 11px/1.2 inherit;letter-spacing:.06em;color:#5b7290;padding:10px 0 2px">VEÍCULO</div>'
      +l.map(function(r){ return _veicLinha(r[0], r[1]); }).join('')
      +'</div>';
  }

  /* ---------- a página (a mesma pras consultas de veículo) ---------- */
  /* v751 — Versão C do padrão unificado (02c): as páginas de veículo
     (Gravame, Multas, RENAJUD, Leilão + PT, Total Premium) na mesma casca.
     Placa (o campo RENAVAM do RENAJUD saiu na v774 — só a placa) → o que
     inclui (SVG, sem emoji) → ação da consulta → resultado → histórico
     próprio (AutoCorp) → outras consultas. Nas duas páginas AutoCorp, desde
     a v936, a própria lupa executa a consulta e os antigos CTA e exemplo não
     são desenhados. Nas demais, os IDs e o fluxo anterior são preservados. */
  function veicInnerHtml(qual){
    var P=VEIC_PAGS[qual];
    var jaExplicou=consultaUiTemLanding(qual);
    /* v774: o campo RENAVAM do RENAJUD saiu (a placa basta; o renavam
       conhecido viaja sozinho no veicCorpoPedido) — sem 2ª etapa, a placa
       fica sem numerinho, como nas outras páginas. */
    /* ==========================================================================
       🔴 v897 — O CAMPO DA PLACA FICOU IGUAL AO DA CONSULTA FIPE
       --------------------------------------------------------------------------
       Pedido do Angelo (04/09): "campo de busca no gravame deve ser igual da
       consulta fipe (visual, travas, lupa de busca, funcao)" — e, no minuto
       seguinte: "mesmo em leilao e premium".

       Eram dois campos de placa com jeitos diferentes no mesmo app: o da FIPE
       com a tarja MERCOSUL, a fonte grande e a lupa; o das páginas de veículo
       com um input comum. Mesma coisa, duas caras — e quem usa o app o dia
       inteiro sente isso como "esta tela é de outro app".

       Agora é a MESMA casca: `.placa-wrap` + `.placa-big` + `.plc-lupa`, com a
       mesma máscara e a mesma trava de 7 caracteres.

       🔴 v1030 — EM TODA CONSULTA PAGA POR PLACA, A LUPA CONSULTA.
       Ela só acende com a placa completa, anuncia consulta + preço e passa
       pela mesma confirmação do CTA antes de chamar o servidor. As páginas
       que conservam o CTA oferecem duas entradas para o mesmo fluxo seguro.
       ========================================================================== */
    var lupaRotulo=_veicBtRotulo(P).replace(/^Consultar/,'Consultar esta placa');
    var campos=consultaUiEtapa(null,'Placa',
        '<div class="placa-wrap veic-placa-wrap">'+
        '<input id="veicPlaca" class="placa-big" data-consulta-anim="placa" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="ABC1D23" maxlength="8" aria-label="Placa" data-cu-min="7" value="">'+
        '<button type="button" id="veicPlacaLupa" class="plc-lupa" disabled aria-label="'+esc(lupaRotulo)+'" title="'+esc(lupaRotulo)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.2" y2="16.2"/></svg>'+
        '</button></div>');
    var form=campos
      /* Área única de andamento: nasce logo abaixo da placa. Resultado e
         histórico continuam em seus próprios lugares, sem loader duplicado. */
      +'<div id="veicProgress" class="veic-progress" aria-live="polite" aria-atomic="true"></div>'
      +(jaExplicou?'':consultaUiBeneficios(P.itens))
      /* v775: o card virou <div> (botão não pode conter botão) com os dois
         ícones — visualizar e baixar; o toque no card segue visualizando */
      +((P.autocorp||jaExplicou)?'':'<div id="'+P.ex+'" class="cpf3-ex consulta-ui-exemplo">'
        +'<span class="cpf3-mini" data-exveic="'+veicPagEsc(qual)+'"></span>'
        +'<span class="cpf3-ex-tx"><b>Ver exemplo (PDF)</b><i>dados fictícios · não cobra nada</i></span>'
        +consultaUiExemploAcoes(P.ex)
      +'</div>')
      /* v774 (pedido, com print): a observação "Bases oficiais… (LGPD)"
         saiu das páginas de veículo; a nota da AutoCorp fica (fala de
         disponibilidade, não é rodapé genérico) */
      +(P.autocorp?consultaUiTrust('Fonte: AutoCorp · disponível conforme ambiente e autorização da sua conta'):'')
      +'<div id="veicResult" aria-live="polite"></div>';
    var pref={ proprietarios:['gravame','recall','leilaopt'], gravame:['recall','proprietarios','leilaopt'], recall:['gravame','proprietarios','premium'], multas:['gravame','renajud','plus'], renajud:['gravame','multas','plus'], leilaopt:['premium','especialjud','recall'], premium:['especialjud','leilaopt','recall'], especialjud:['premium','leilaopt','gravame'] }[qual]||[];
    /* 🔴 v861 — a lista de "quem eu prefiro sugerir depois desta" é escrita à
       mão e NÃO passa pela CONS_TABS. Sem esta peneira, o gravame continuaria
       sugerindo "Multas" e "RENAJUD" depois de o Angelo tirá-los do app —
       sugerir o que não se oferece mais é pior do que não sugerir nada. */
    try{ if(typeof window.edConsultaLigada==='function') pref=pref.filter(function(k){ return window.edConsultaLigada(k); }); }catch(_){}
    /* v1400 — histórico é uma segunda tarefa, não parte do formulário.
       Separá-lo do card deixa a leitura: placa → preço → reaproveitar placa →
       outras consultas. Tocar na sugestão continua apenas preenchendo o campo. */
    var hist='<div id="veicFipeRecente" class="consulta-fipe-recente-fora"></div>'
      +consultaUiHistoricoCard('veicHist',{ texto:'Veja e reabra consultas deste produto' });
    return consultaUiCard(form, { id:'veicWrap', classe:'consulta-ui-card-veic consulta-ui-card-'+qual })
      +hist+consultaUiRelacionadas(qual,'veiculo',{ preferir:pref });
  }
  function abrirVeicPag(qual, placa){
    qual=veicPagEsc(qual); _veicPagAtual=qual; _veicState=null;
    var P=VEIC_PAGS[qual];
    /* v751 — Versão C do padrão (02c): a barrinha lateral fica só no computador */
    consultaUiPagina({ chave:P.aba, tab:'completa', ico:(typeof _CT_ICO!=='undefined'&&_CT_ICO[qual])||ICO.valor, cor:'blue', titulo:P.titulo, sub:P.sub }, veicInnerHtml(qual));
    /* v1503 — quando a navegação nasce de um resultado, a placa acompanha o
       card até este formulário. Ela entra pronta, mas a consulta paga só
       começa depois do toque explícito na lupa e da confirmação do valor. */
    veicWire(placa);
    try{ consultaUiSync(); }catch(_){}
  }
  /* v897 — a lupa acende com a MESMA régua do botão pago: placa completa. */
  function veicLupaSync(){
    try{
      var i=$('veicPlaca'), b=$('veicPlacaLupa'); if(!b) return;
      var pl=_veicPlacaLimpa(i?i.value:'');
      b.disabled = pl.length < 7;
    }catch(_){}
  }
  /* v926 — uma única regra para toda entrada/reentrada na consulta. Limpar e
     focar nunca chama API; apenas reseta os estados visuais da lupa e CTA. */
  function veicCampoLimparEFocar(){
    var inp=$('veicPlaca'); if(!inp) return;
    inp.value=''; inp.classList.remove('tem');
    try{ placaCampoVisualSync(inp); }catch(_){}
    veicLupaSync(); try{ consultaUiSync(); }catch(_){}
    try{ inp.focus({preventScroll:true}); }catch(_){ try{ inp.focus(); }catch(_2){} }
    try{ inp.setSelectionRange(0,0); }catch(_){}
  }
  function veicWire(placaInicial){
    var qual=_veicPagAtual, P=VEIC_PAGS[qual];
    var inp=$('veicPlaca');
    if(inp){
      inp.oninput=function(){ inp.value=_lhPlaca(inp.value); inp.classList.toggle('tem', !!inp.value); try{ placaCampoVisualSync(inp); }catch(_){} veicLupaSync(); try{ consultaUiSync(); }catch(_){} };
      inp.addEventListener('paste',function(){ setTimeout(function(){ try{ inp.oninput(); }catch(_){} },0); });
      var recebida=_veicPlacaLimpa(placaInicial||'');
      if(/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(recebida)){
        inp.value=recebida; inp.oninput();
        /* A placa vinda do card deve ser revisável sem abrir o teclado por
           surpresa. O campo continua editável e a lupa já fica habilitada. */
        try{ inp.blur(); }catch(_){}
      } else {
        /* Campo vazio conserva o foco síncrono para a consulta iniciada pela
           página, inclusive no Safari/PWA. */
        veicCampoLimparEFocar();
      }
    }
    /* v1030 — toda lupa desta família executa a consulta selecionada pelo
       fluxo confirmado. Em todos os casos só acende depois da placa válida. */
    veicLupaSync();
    var lupa=$('veicPlacaLupa');
    if(lupa) lupa.onclick=function(){
      if(lupa.disabled) return;
      /* o blur fecha o teclado do celular ANTES do quadro aparecer — sem
         isso, no iPhone, a resposta nasce atrás do teclado (lição da v883) */
      try{ $('veicPlaca').blur(); }catch(_){}
      gerarVeicConsulta(qual, lupa);
    };
    var ex=$(P.ex); if(ex) ex.onclick=function(){ veicVerExemplo(qual); };
    /* v775: os dois ícones do card — o stopPropagation impede o clique de
       vazar pro card (que também visualiza) */
    var exV=$(P.ex+'Ver'); if(exV) exV.onclick=function(ev){ ev.stopPropagation(); veicVerExemplo(qual); };
    var exB=$(P.ex+'Bx'); if(exB) exB.onclick=function(ev){ ev.stopPropagation(); veicBaixarExemplo(qual); };
    /* as miniaturas depois que a tela pinta: são folhas A4 em canvas, e
       travar a abertura da página por causa de enfeite seria burro (v603) */
    setTimeout(function(){ try{ veicMinisPintar(); }catch(_){} },0);
    /* v1153: a última placa da FIPE aparece em toda pesquisa veicular. O
       histórico pago do produto continua sendo carregado só onde já existia. */
    try{ acHistRender(qual); }catch(_){}
    /* v744: histórico próprio + reabrir a placa aberta sem custo */
    if(P.autocorp||P.salvar){
      try{ acHistCarregarNuvem(qual); }catch(_){}
      try{ var _pl=inp?_lhPlaca(inp.value):''; var _sv=_pl?acHistDe(qual,_pl):null; if(_sv&&_sv.resultado) acPintaSalva(qual,_sv,true); }catch(_){}
    }
  }
  /* a porta: sem placa completa, NADA sai — nem chamada, nem token */
  function _veicPronto(){
    var inp=$('veicPlaca'); var p=inp?_lhPlaca(inp.value):'';
    var res=$('veicProgress')||$('veicResult');
    if(!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p)){
      if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite uma placa válida (ABC1234 ou ABC1D23).</div>';
      try{ if(inp) inp.focus(); }catch(_){}
      return '';
    }
    return p;
  }
  /* ==========================================================================
     🔴 v874 — A ESPERA EM SEGUNDO PLANO DAS CONSULTAS DA AUTOCORP
     --------------------------------------------------------------------------
     PROVA DE 03/09, com o painel da AutoCorp na mão: a consulta 10685716
     (45-TOTAL PREMIUM, placa INR0H89, 22:29) foi CONCLUÍDA por ela — e o app
     mostrou "A AutoCorp demorou demais" no mesmo minuto. O servidor abortava
     em 8 s; o fornecedor não abortava junto: concluía e cobrava.

     Agora o servidor cria um JOB e um worker de fundo (sem o teto de 26 s de
     uma função normal) faz a consulta com calma. Aqui a gente só pergunta
     "ficou pronto?" a cada 3 s — o mesmo desenho da Ficha por IA (v240) e do
     gravame (v802).

     ⚠️ SAIR DA TELA PARA A PERGUNTA, NÃO O TRABALHO. O worker termina, grava
     e debita de qualquer jeito; o resultado fica guardado e a próxima consulta
     da mesma placa reaproveita sem cobrar de novo (janela de 10 min no
     servidor). Ficar perguntando numa tela que não existe mais é que não
     serve pra nada.
     ========================================================================== */
  /* 🔴 v897 — A ESPERA GANHOU DOIS ARGUMENTOS E VIROU A ESPERA DA CASA.
     Ela nasceu servindo só a tela do veículo (por isso o `#veicResult` e a
     frase falando em AutoCorp cravados dentro). Nesta versão o risco de CNPJ
     também passou a rodar no worker de fundo, e ele mora em OUTRA tela.
     Copiar a função pra lá seria criar duas esperas que um dia divergem — a
     segunda esqueceria o "saiu da tela: para de perguntar", que é o que
     impede o app de ficar perguntando pra sempre em segundo plano.
       alvoId  — o elemento que prova que a pessoa ainda está na tela
       msgFim  — o que dizer quando o tempo acaba (cada consulta tem o nome
                 do provedor dela; dizer "AutoCorp" num laudo de CNPJ é
                 mentira pequena que custa confiança) */
  async function _veicEsperarJob(protocolo, maxMs, alvoId, msgFim){
    var alvo=alvoId||'veicResult';
    var fim=Date.now()+(maxMs||150000);
    while(Date.now()<fim){
      await new Promise(function(ok){ setTimeout(ok,3000); });
      if(!$(alvo)) return null;                  /* saiu da tela: para de perguntar */
      var p=null;
      try{ p=await apiComTimeout('/api/consultar',{ produto:'veic_job', protocolo:protocolo },12000); }catch(_){ p=null; }
      if(!p) continue;                           /* soluço de rede: pergunta de novo */
      if(p.ok&&p.pendente) continue;             /* ainda trabalhando */
      return p;
    }
    /* 🔴 A FRASE DIZ O QUE FAZER, e ela só é verdade por causa da janela de
       reaproveitamento de 10 minutos do servidor: tocar de novo devolve o
       laudo que JÁ FOI PAGO, sem cobrar outra vez. Sem aquela janela, esta
       frase mandaria o lojista pagar duas vezes. */
    return { ok:false, erro: msgFim || 'A AutoCorp está demorando mais que o normal. Toque em consultar de novo daqui a pouco: se ela já tiver respondido, o resultado vem sem cobrar de novo.' };
  }

  /* ============================================================================
     🔴🔴 v898 — O AVISO DE "RESULTADO REAPROVEITADO" NUNCA CHEGOU NA TELA.
     ----------------------------------------------------------------------------
     Defeito de VERDADE, achado pelo teste-v803 depois que ele voltou a rodar.

     A v803 pôs uma trava de um minuto: repetir a MESMA consulta paga dentro
     da janela devolve o resultado guardado, sem chamar o provedor de novo. Pra
     isso ser honesto, o changelog dela escreveu a regra em letras grandes:
     "dado guardado não pode se passar por novo". O servidor cumpriu a parte
     dele — manda `idade_s` no poll desde então — e o CSS `.veic-reap` foi
     escrito. **A tela nunca leu nem um nem outro.**

     Resultado, por meses: o lojista tocava em consultar, via o mesmo laudo
     aparecer em silêncio e não tinha como saber se aquilo tinha acabado de vir
     da base ou era de 40 segundos atrás. Num laudo de leilão, "de quando é
     este dado" é metade da informação.

     ⚠️ DISCRETO DE PROPÓSITO (é o que o CSS já dizia): é informação, não
     alerta. O dado está certo, só não é novo. Alarmar aqui ensinaria a
     ignorar aviso de verdade.
     ⚠️ E SÓ APARECE COM IDADE DE VERDADE: abaixo de 3 segundos é a própria
     consulta que acabou de rodar, não um reaproveitamento.
     ============================================================================ */
  function veicReapHtml(){ return ''; } /* v1032: reaproveitamento continua seguro no servidor, sem faixa visual */
  /* v936 — o estado do CTA não pode ser aplicado diretamente à lupa: o
     componente troca o conteúdo do botão pelo texto e apagaria o SVG. Esta
     ponte preserva o desenho e comunica carregamento por classe/aria. */
  function veicAcaoEstado(btn, estado, texto){
    if(!btn) return;
    if(btn.classList && btn.classList.contains('plc-lupa')){
      btn.classList.remove('is-loading','is-error'); btn.removeAttribute('aria-busy');
      if(estado==='carregando'){ btn.disabled=true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy','true'); return; }
      if(estado==='erro') btn.classList.add('is-error');
      btn.disabled=false; return;
    }
    /* v1291 — o andamento já aparece no card logo abaixo da placa. Ocultar o
       CTA enquanto a consulta roda evita repetir a mesma frase em dois
       loaders e deixa uma única fonte visual de progresso. */
    btn.hidden=estado==='carregando';
    consultaUiEstadoCta(btn,estado,texto);
  }
  /* v1503 — a página de processamento precisa morar diretamente no body.
     Quando o elemento `position:fixed` ficava dentro do card, ancestrais e
     irmãos podiam criar uma pilha visual própria no Safari/PWA: os cards de
     consultas relacionadas apareciam por cima do escudo. */
  function veicProcessoAbrir(html){
    try{
      var anterior=$('veicProcessoTela'); if(anterior&&anterior.parentNode) anterior.parentNode.removeChild(anterior);
      var caixa=document.createElement('div'); caixa.innerHTML=String(html||'');
      var tela=caixa.firstElementChild; if(!tela) return null;
      tela.id='veicProcessoTela'; document.body.appendChild(tela);
      document.body.classList.add('veic-consultando'); return tela;
    }catch(_){ return null; }
  }
  function veicProcessoFechar(tela){
    try{ if(tela&&tela.parentNode) tela.parentNode.removeChild(tela); }catch(_){}
    try{ document.body.classList.remove('veic-consultando'); }catch(_){}
  }
  async function gerarVeicConsulta(qual, btn){
    qual=veicPagEsc(qual); var P=VEIC_PAGS[qual];
    var placa=_veicPronto(); if(!placa) return;
    var res=$('veicResult'), andamento=$('veicProgress')||res;
    try{ veicAcaoEstado(btn,'carregando',P.carregando); }catch(_){ if(btn) btn.disabled=true; }
    if(res) res.innerHTML='';
    var frases=(P.etapas&&P.etapas.length)?P.etapas:_veicFrases;
    if(andamento) andamento.innerHTML='';
    var telaProcesso=veicProcessoAbrir(ccLoaderHtml(P.carregando,frases));
    var lt=ccLoaderStart(frases);
    var d=null; try{ d=await consultarComRetry(veicCorpoPedido(qual, placa),1); }catch(_){ d=null; }
    /* v874 — resposta "pendente" = o servidor mandou pro worker de fundo.
       O loader continua rodando de propósito: quem está esperando é a pessoa,
       e o relógio dela não parou. */
    if(d&&d.ok&&d.pendente&&d.protocolo){
      var _j=await _veicEsperarJob(d.protocolo,P.esperaMs||150000,'veicProgress',P.msgEspera);
      if(_j===null){ clearInterval(lt); veicProcessoFechar(telaProcesso); return; }   /* saiu da tela */
      d=_j;
    }
    clearInterval(lt);
    veicProcessoFechar(telaProcesso);
    if(andamento) andamento.innerHTML='';
    if(d&&d.sem_saldo){ try{ veicAcaoEstado(btn,'pronto'); }catch(_){} setSaldo(d.saldo); if(res) res.innerHTML=''; abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){
      try{ veicAcaoEstado(btn,'erro'); }catch(_){}
      var _veicErro=(d&&d.erro)||'Não foi possível concluir a consulta agora. Tente de novo em instantes.';
      var _veicIndisponivel=/homologa|não está liberada|nao esta liberada|não está disponível|nao esta disponivel/i.test(_veicErro);
      if(_veicIndisponivel) _veicErro='Esta consulta ainda não está disponível para a sua conta. Escolha uma das alternativas abaixo.';
      if(d&&d.estornado) _veicErro+=' O valor foi devolvido ao seu saldo.';
      if(andamento) andamento.innerHTML='<div class="plc-msg veic-progress-erro" role="alert">'
        +'<span class="veic-progress-erro-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 17h.01"/></svg></span>'
        +'<span><strong>'+(_veicIndisponivel?'Consulta indisponível':'Não foi possível consultar')+'</strong><small>'+esc(_veicErro)+'</small></span></div>';
      return;
    }
    try{ veicAcaoEstado(btn,'novamente',_veicBtRotulo(P).replace(/^Consultar/,'Consultar novamente')); }catch(_){}
    _veicState={ qual:qual, placa:placa, dados:d.resultado };
    /* v1037 — prepara o resumo gratuito, mas não monta mais uma segunda
       cópia do relatório embaixo do formulário. */
    if(!P.autocorp) try{
      var _dv=await _veicDadosGratis(placa);
      _dv=_veicMesclarDados(_dv,_veicFipeCombo(d.resultado));
      if(qual==='proprietarios') _dv=_hpMesclarFipe(_dv,proprietariosParse(d.resultado));
      if(_dv) _veicDadosCache[_veicPlacaLimpa(placa)]=_dv;
    }catch(_){}
    /* v744: as consultas AutoCorp ficam guardadas (reabrem sem custo) */
    /* v998 — o `protocolo` entra no histórico LOCAL (não vai pra nuvem: o
       docHistCloudSave manda só `it.resultado`). É ele que permite reabrir
       uma consulta de ontem e ainda buscar o laudo sem pagar de novo.
       ⚠️ Este é o protocolo do JOB DO MEV, que o app já recebe desde a v802 —
       não é o número de protocolo da AutoCorp, que continua só no servidor
       (a régua do teste-v732). */
    var _veicTs=Date.now();
    if(P.autocorp||P.salvar){ try{ acHistSalvar(qual, { placa:placa, ts:_veicTs, resultado:d.resultado, protocolo:d.protocolo||'', homologacao:!!d.homologacao, aviso:d.aviso||'' }); acHistRender(qual); }catch(_){} }
    /* v874 — o aviso de bloco parcial da AutoCorp viaja pelo job também */
    /* v926 — o resultado conserva a placa consultada; o campo fica pronto
       para a próxima, sem reaproveitar estado e sem consultar sozinho. */
    veicResultadoAbrir(qual,{ placa:placa, ts:_veicTs, resultado:d.resultado, protocolo:d.protocolo||'', homologacao:!!d.homologacao, aviso:d.aviso||'' },false);
  }
  /* o corpo do pedido — o RENAJUD (v630) pede campos que os outros não pedem */
  function veicCorpoPedido(qual, placa){
    var c={ produto:VEIC_PAGS[qual].produto, placa:placa };
    /* 🔴 o CPF/CNPJ do proprietário NÃO viaja daqui: o app não pede esse dado
       de terceiro (ver o comentário do consultarRenajud no servidor). */
    if(qual==='renajud'||qual==='especialjud'){
      /* v774: sem campo na tela — o renavam só viaja quando o app já o
         conhece DA MESMA placa que está sendo consultada (veio da consulta
         de placa). Placa diferente = renavam de outro carro = não manda. */
      try{
        var va=veiculoAtual||{};
        var pv=String(va.placa||'').replace(/[^A-Za-z0-9]/g,'').toUpperCase();
        var pq=String(placa||'').replace(/[^A-Za-z0-9]/g,'').toUpperCase();
        var rv=String(va.renavam||'').replace(/\D/g,'').slice(0,11);
        if(rv && pv && pv===pq) c.renavam=rv;
      }catch(_){}
    }
    return c;
  }
  function veicPanelHtml(qual, dd, placa){
    if(qual==='proprietarios') return proprietariosPanelHtml(dd, placa);
    if(qual==='gravame') return gravamePanelHtml(dd, placa);
    if(qual==='recall') return recallPanelHtml(dd, placa);
    if(qual==='debitos') return debitosPanelHtml(dd, placa);
    if(qual==='multas')  return renainfPanelHtml(dd, placa);
    if(qual==='renajud') return renajudPanelHtml(dd, placa);
    if(VEIC_PAGS[qual] && VEIC_PAGS[qual].autocorp) return autocorpResumoHtml(qual, dd, placa);
    return '<div class="plc-msg">Consulta concluída.</div>';
  }

  /* v1032 — o servidor já entrega uma lista permitida e minimizada. Aqui só
     se interpreta a linha do tempo; nenhuma tentativa de completar nomes ou
     documentos é feita no navegador. */
  function proprietariosParse(dd){
    var b=_veicBase(dd), raw=Array.isArray(b.registros)?b.registros:[];
    var fc=_veicFipeCombo(dd)||{};
    var itens=raw.map(function(r){
      return { data:_veicTxt(r.data_transferencia), nome:_veicTxt(r.nome_razao),
        documento:_veicTxt(r.documento),
        tipo:_veicTxt(r.tipo_pessoa)||'Não informado', municipio:_veicTxt(r.municipio),
        uf:_veicTxt(r.uf), placa:_veicTxt(r.placa_mercosul||r.placa), modelo:_veicTxt(r.modelo) };
    }).sort(function(a,b2){ return (_veicData(b2.data)||0)-(_veicData(a.data)||0); });
    itens.forEach(function(x,i){
      x.fim=i===0?'':itens[i-1].data;
      x.duracao=x.fim?_hpDuracaoEntre(x.data,x.fim):'';
    });
    var ufs={},rota=[]; itens.slice().reverse().forEach(function(x){ if(x.uf){ ufs[x.uf]=1; if(rota[rota.length-1]!==x.uf) rota.push(x.uf); } });
    var totalDonos=Number(b.total_donos); if(!(totalDonos>=0)) totalDonos=itens.length;
    var mediaMeses=null;
    if(itens.length>=3){
      var nova=_hpDataJs(itens[0].data), antiga=_hpDataJs(itens[itens.length-1].data);
      if(nova&&antiga) mediaMeses=Math.max(0,Math.round(((nova-antiga)/(1000*60*60*24*30.4375))/(itens.length-1)));
    }
    return { itens:itens, atual:itens[0]||null, transferencias:Number(b.total_registros)||itens.length,
      donos:totalDonos, mudouUf:Object.keys(ufs).length>1, rotaUf:rota.join(' → '), mediaMeses:mediaMeses,
      passouEmpresa:itens.some(function(x){return x.tipo==='PJ';}),
      fipe:_veicTxt(fc.fipe||b.valor_fipe), codigoFipe:_veicTxt(fc.codigoFipe||b.codigo_fipe),
      mesRef:_veicTxt(fc.mesRef||b.mes_referencia) };
  }
  function _hpDataJs(data){ var m=_veicTxt(data).match(/(\d{2})\/(\d{2})\/(\d{4})/); return m?new Date(Number(m[3]),Number(m[2])-1,Number(m[1])):null; }
  function _hpDuracaoEntre(inicio,fim){
    var d=_hpDataJs(inicio), h=_hpDataJs(fim); if(!d||!h||h<d) return '';
    var meses=(h.getFullYear()-d.getFullYear())*12+(h.getMonth()-d.getMonth());
    if(h.getDate()<d.getDate()) meses--; if(meses<0) return '';
    var anos=Math.floor(meses/12), resto=meses%12, p=[];
    if(anos) p.push(anos+' ano'+(anos===1?'':'s')); if(resto||!anos) p.push(resto+' '+(resto===1?'mês':'meses'));
    return p.join(' e ');
  }
  function _hpMesclarFipe(base,p){
    var d=base?Object.assign({},base):{};
    if(p&&p.fipe&&!d.fipe) d.fipe=p.fipe;
    if(p&&p.codigoFipe&&!d.codigoFipe) d.codigoFipe=p.codigoFipe;
    if(p&&p.mesRef&&!d.mesRef) d.mesRef=p.mesRef;
    return Object.keys(d).length?d:null;
  }
  function _hpPeriodoLinha(x,i){
    if(i===0) return ['Registro em '+(x.data||'data não informada'),'sem data final informada pela base'];
    return ['De '+(x.data||'data não informada')+' até '+(x.fim||'data não informada'),x.duracao];
  }
  function proprietariosPanelHtml(dd, placa){
    var p=proprietariosParse(dd), a=p.atual;
    if(!a) return _veicVeredito('mid','Histórico não informado','A base não retornou histórico para esta placa.');
    return _veicVeredito('ok','Histórico localizado',p.transferencias+' transferência'+(p.transferencias===1?'':'s')+' · '+p.donos+' dono'+(p.donos===1?'':'s')+' distinto'+(p.donos===1?'':'s'))
      +proprietariosDetalhesHtml(p);
  }
  function proprietariosDetalhesHtml(p){
    var a=p&&p.atual; if(!a) return '';
    var local=[a.municipio,a.uf].filter(Boolean).join(' / ');
    var tipo=a.tipo==='PJ'?'Pessoa jurídica':(a.tipo==='PF'?'Pessoa física':'Tipo não informado');
    var icMapa='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>';
    var icEmpresa='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 21h18M6 21V7l6-4v18M12 9h6v12M9 9v.01M9 13v.01M9 17v.01M15 13v.01M18 13v.01M15 17v.01M18 17v.01"/></svg>';
    var icTempo='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
    var html='<div class="hp-registro-atual">'
      +'<div class="hp-registro-nome"><span>PRIMEIRO NOME INFORMADO</span><strong>'+esc(a.nome||'não informado')+'</strong><small>Registro mais recente na base · '+esc(tipo)+'</small></div>'
      +'<div class="hp-registro-grid"><div><span>Documento</span><b>'+esc(a.documento||'não informado')+'</b></div>'
        +'<div><span>Data do registro</span><b>'+esc(a.data||'não informado')+'</b></div>'
        +'<div class="hp-registro-local"><span>Cidade / UF</span><b>'+esc(local||'não informado')+'</b></div></div>'
      +'</div>';
    html+='<div class="hp-sinais" aria-label="Resumo do histórico">'
      +'<div class="hp-sinal '+(p.mudouUf?'is-atencao':'')+'"><span>'+icMapa+'</span><div><small>Mudança de UF</small><b>'+esc(p.mudouUf?p.rotaUf:'Não identificada')+'</b></div></div>'
      +'<div class="hp-sinal"><span>'+icEmpresa+'</span><div><small>Passagem por empresa</small><b>'+(p.passouEmpresa?'Identificada':'Não identificada')+'</b></div></div>'
      +'<div class="hp-sinal"><span>'+icTempo+'</span><div><small>Intervalo médio</small><b>'+(p.mediaMeses!=null?esc(p.mediaMeses+' meses por registro'):'Não calculado')+'</b></div></div>'
      +'</div>';
    var linhas=p.itens.map(function(x,i){
      var per=_hpPeriodoLinha(x,i);
      var sub=[per[0],per[1],[x.municipio,x.uf].filter(Boolean).join(' / '),x.tipo,x.documento].filter(Boolean).join(' · ');
      return '<div class="cpf3-proc"><div class="cpf3-proc-h"><b>'+(i===0?'Mais recente · ':'')+esc(x.nome||'Nome não informado')+'</b></div>'
        +(sub?'<div class="cpf3-proc-s">'+esc(sub)+'</div>':'')+'</div>';
    }).join('');
    html+='<div class="plc-msg" style="font-size:11px;color:#475569;margin:8px 0">A data mais recente é um registro da fonte, não uma confirmação de propriedade atual. O período só é calculado quando existe uma transferência seguinte registrada.</div>';
    html+=_cpfBloco('Linha do tempo · mais recente ao mais antigo ('+p.itens.length+')',linhas,true);
    html+='<div class="plc-msg" style="font-size:10px;color:#64748b;margin-top:8px">Dados pessoais mascarados pelo MEV. Finalidade: conferência de titularidade em negociação de veículo. Fonte consultada na data deste relatório.</div>';
    return html;
  }
  function proprietariosVoltarFormulario(placa, limpar){
    abrirVeicPag('proprietarios');
    if(limpar) return;
    try{
      var inp=$('veicPlaca'); if(!inp) return;
      inp.value=_lhPlaca(placa); if(inp.oninput) inp.oninput();
      inp.blur();
    }catch(_){}
  }
  function proprietariosResultadoAbrir(it, reaberta){
    it=it||{}; var placa=_lhPlaca(it.placa), p=proprietariosParse(it.resultado||{});
    var dv=_hpMesclarFipe(_veicDadosComCombo(placa,it.resultado),p); if(dv) _veicDadosCache[_veicPlacaLimpa(placa)]=dv;
    _veicState={ qual:'proprietarios', placa:placa, dados:it.resultado };
    var modelo=dv?[dv.marca,dv.modelo].filter(Boolean).join(' '):'';
    var ident=[modelo,placa].filter(Boolean).join(' · ');
    var resumo=p.atual
      ?consultaResultadoResumo({ tom:'ok', titulo:'Histórico localizado', texto:p.transferencias+' transferência'+(p.transferencias===1?'':'s')+' · '+p.donos+' proprietário'+(p.donos===1?'':'s')+' distinto'+(p.donos===1?'':'s') })
      :consultaResultadoResumo({ tom:'atencao', titulo:'Histórico não informado', texto:'A base não retornou registros para esta placa.' });
    var avisoCombo=_veicAvisoCombo(it.resultado,it.aviso);
    var corpo=(avisoCombo?'<div class="plc-msg consulta-resultado-aviso">'+esc(avisoCombo)+'</div>':'')
      +(dv?_veicQuadroHtml(dv):'')+(p.atual?consultaResultadoSecao({ titulo:'Registros de propriedade', subtitulo:'Primeiro nome, documento mascarado e sequência das transferências', classe:'consulta-resultado-secao-proprietarios', html:proprietariosDetalhesHtml(p) }):'');
    var cfg={
      chave:'proprietarios', titulo:'Histórico de Proprietários + FIPE', identificacao:ident,
      dataHora:it.ts?histData(it.ts):'', resumoHtml:resumo, secoesHtml:corpo,
      aoVoltar:function(){ proprietariosVoltarFormulario(placa,false); },
      aoNovaConsulta:function(){ proprietariosVoltarFormulario('',true); },
      acoes:[
        { id:'proprietariosPdfVer', rotulo:'Visualizar PDF', icone:'ver', primaria:true, somenteIcone:true, acao:function(){ veicVisualizarPDF(); } },
        { id:'proprietariosPdfBaixar', rotulo:'Baixar PDF', icone:'baixar', somenteIcone:true, acao:function(){ veicBaixarPDF(); } },
        { id:'proprietariosPdfCompartilhar', rotulo:'Compartilhar PDF', icone:'compartilhar', somenteIcone:true, acao:function(){ veicCompartilharPDF(); } }
      ]
    };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
    try{ _cpfBlocosLigar($('secoes')); }catch(_){}
  }

  /* v1036 — mesma casca do piloto para as demais consultas desta família.
     A navegação só reorganiza o que já foi recebido: parser, cobrança,
     histórico e PDF continuam nas portas próprias de cada produto. */
  function veicVoltarFormulario(qual, placa, limpar){
    abrirVeicPag(qual);
    if(limpar) return;
    try{
      var inp=$('veicPlaca'); if(!inp) return;
      inp.value=_lhPlaca(placa); if(inp.oninput) inp.oninput();
      inp.blur();
    }catch(_){}
  }
  function veicResultadoAbrir(qual, it, reaberta){
    qual=veicPagEsc(qual); if(qual==='proprietarios'){ proprietariosResultadoAbrir(it,reaberta); return; }
    it=it||{}; var P=VEIC_PAGS[qual], placa=_lhPlaca(it.placa), dv=_veicDadosComCombo(placa,it.resultado);
    _veicState={ qual:qual, placa:placa, dados:it.resultado };
    var modelo=dv?[dv.marca,dv.modelo].filter(Boolean).join(' '):'';
    var ident=[modelo,placa].filter(Boolean).join(' · ');
    var avisoCombo=_veicAvisoCombo(it.resultado,it.aviso);
    var avisoHtml=avisoCombo?'<div class="plc-msg consulta-resultado-aviso">'+esc(avisoCombo)+'</div>':'';
    var painel=avisoHtml+veicPanelHtml(qual,it.resultado,placa);
    var resumo=consultaResultadoResumo({ tom:'ok', titulo:'Consulta concluída', texto:'Resultado disponível para leitura e PDF.' });
    if(qual==='gravame'){
      var gravameAtual=gravameNivel(gravameParse(it.resultado).status);
      resumo=gravameAtual==='com'
        ?consultaResultadoResumo({ tom:'erro', titulo:'Gravame ativo', texto:'A transferência depende da baixa da alienação fiduciária.' })
        :gravameAtual==='baixado'
          ?consultaResultadoResumo({ tom:'atencao', titulo:'Gravame baixado', texto:'A base indica baixa. Confirme a situação no DETRAN antes da transferência.' })
          :gravameAtual==='sem'
            ?consultaResultadoResumo({ tom:'ok', titulo:'Sem gravame', texto:'Nenhuma alienação fiduciária consta na base verificada.' })
            :consultaResultadoResumo({ tom:'atencao', titulo:'Situação não informada', texto:'A base não devolveu a situação atual do gravame.' });
    }
    var secoes=(!P.autocorp&&dv?_veicQuadroHtml(dv):'')+consultaResultadoSecao({ titulo:'Resultado da consulta', html:painel });
    if(qual==='recall'){
      var recallStatus=recallResumoDados(it.resultado);
      resumo=consultaResultadoResumo({tom:recallStatus.tom,titulo:recallStatus.titulo,texto:recallStatus.texto});
      secoes=consultaResultadoSecao({
        titulo:'Fontes verificadas',
        subtitulo:'Duas bases de recall e a identificação FIPE.',
        classe:'consulta-resultado-secao-recall',
        html:avisoHtml+recallPanelHtml(it.resultado,placa,true)
      })+(dv?consultaResultadoSecao({
        titulo:'Veículo e FIPE',
        subtitulo:'Identificação usada para verificar as campanhas.',
        classe:'consulta-resultado-secao-veiculo-recall',
        html:_veicQuadroHtml(dv,'is-compact')
      }):'');
    }
    if(qual==='debitos'){
      var dbStatus=debitosResumoDados(it.resultado);
      resumo=consultaResultadoResumo({tom:dbStatus.tom,titulo:dbStatus.titulo,texto:dbStatus.texto});
    }
    if(P.autocorp){
      var acStatus=autocorpResumoDados(qual,it.resultado,placa);
      resumo=consultaResultadoResumo({ tom:acStatus.tom, titulo:acStatus.titulo, texto:acStatus.texto });
      var relatorioCombinado=autocorpRelatorioCombinado(qual,it.resultado);
      secoes=avisoHtml+consultaResultadoSecao({
        titulo:'Verificações realizadas',
        subtitulo:'Leitura rápida das bases que responderam nesta consulta.',
        classe:'consulta-resultado-secao-verificacoes',
        html:autocorpResumoHtml(qual,it.resultado,placa)
      })+consultaResultadoSecao({
        titulo:'Informações completas',
        subtitulo:'Dados disponíveis na resposta, organizados por assunto.',
        classe:'consulta-resultado-secao-detalhes',
        html:autocorpPanelHtml(qual,it.resultado,placa,it.ts)
      })+consultaResultadoSecao({
        titulo:relatorioCombinado?'Relatórios da consulta':'Relatório da consulta',
        subtitulo:relatorioCombinado
          ?'O relatório completo MEV reúne AutoCorp, débitos estaduais e multas RENAINF. O laudo original permanece disponível separadamente.'
          :'Abre o laudo oficial quando disponível; caso contrário, usa o relatório MEV.',
        classe:'consulta-resultado-secao-documento',
        html:autocorpBotoesPdfHtml(qual,it.resultado,it.protocolo||'')
      });
    }
    var cfg={
      chave:qual, titulo:P.titulo, identificacao:ident,
      dataHora:it.ts?histData(it.ts):'',
      resumoHtml:resumo,
      secoesHtml:secoes,
      aoVoltar:function(){ veicVoltarFormulario(qual,placa,false); },
      aoNovaConsulta:function(){ veicVoltarFormulario(qual,'',true); },
      acoes:P.autocorp?[]:[
        { id:'veicResultadoPdfVer', rotulo:'Visualizar PDF', icone:'ver', primaria:true, somenteIcone:true, acao:function(){ veicVisualizarPDF(); } },
        { id:'veicResultadoPdfBaixar', rotulo:'Baixar PDF', icone:'baixar', somenteIcone:true, acao:function(){ veicBaixarPDF(); } },
        { id:'veicResultadoPdfCompartilhar', rotulo:'Compartilhar PDF', icone:'compartilhar', somenteIcone:true, acao:function(){ veicCompartilharPDF(); } }
      ]
    };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
    var raiz=$('consultaResultadoPagina')||document;
    try{ _cpfBlocosLigar(raiz); }catch(_){}
    if(P.autocorp) try{ autocorpPdfLigar(raiz,qual,it.resultado,placa,it.protocolo||''); }catch(_){}
  }

  /* ==========================================================================
     GRAVAME — o desenho (v628)
     ==========================================================================
     A pergunta do lojista é UMA: **esse carro está preso ou livre?** Gravame
     é alienação fiduciária: enquanto ele não é baixado, A TRANSFERÊNCIA NÃO
     SAI. Então o veredito vem primeiro, grande, e o resto é detalhe.

     🔴 QUEM MANDA NO VEREDITO É O AGORA (`statusdoveiculo`/`descricaostatus`),
     não o histórico. E quando os dois DISCORDAM — acontece de verdade: a
     baixa é recente e a base ainda não atualizou — a tela DIZ que discordam,
     em vez de escolher em silêncio. É a diferença entre informar e enganar.
     ========================================================================= */
  function gravameParse(dd){
    var b=_veicBase(dd);
    var st=_veicTxt(_veicDeep(b,/^(descricaostatus|statusdoveiculo|situacaoveiculo|status)$/));
    var hist=[];
    var raw=_veicDeep(b,/^(historico|historicogravame|historicos)$/);
    if(!Array.isArray(raw)){ try{ raw=_veicKey(b,/^(historico|historicogravame|historicos)$/); }catch(_){ raw=null; } }
    if(Array.isArray(raw)){
      raw.forEach(function(h){
        if(!h||typeof h!=='object') return;
        hist.push({
          data:_veicTxt(_veicKey(h,/^(data|datagravame|dataocorrencia|dataevento|dataatualizacao)$/)),
          status:_veicTxt(_veicKey(h,/^(status|descricaostatus|situacao|evento)$/)),
          agente:_veicTxt(_veicKey(h,/^(agente|financeiranome|agentefinanceiro|nomeagentefinanceiro|instituicao)$/))
        });
      });
    }
    return {
      status:st,
      banco:_veicTxt(_veicDeep(b,/^(financeiranome|nomeagentefinanceiro|agentefinanceiro|instituicaofinanceira)$/)),
      contrato:_veicMascContrato(_veicTxt(_veicDeep(b,/^(numerocontrato|contrato|numerodocontrato)$/))),
      data:_veicTxt(_veicDeep(b,/^(datagravame|datainclusaogravame|datadogravame)$/)),
      vigencia:_veicTxt(_veicDeep(b,/^(datagravamevigencia|vigencia|datavigencia)$/)),
      hist:hist,
      ident:_veicIdent(b),
      raw:b
    };
  }
  /* 🔴 as três leituras possíveis do texto de situação, nesta ordem — BAIXADO
     antes de COM, porque "GRAVAME BAIXADO" contém a palavra "gravame" */
  function gravameNivel(txt){
    var s=String(txt||'').toLowerCase();
    if(!s) return '';
    if(/baixad|baixa\s+de\s+gravame|liberad/.test(s)) return 'baixado';
    if(/sem\s+(gravame|aliena|restri)|nada\s+consta|n[aã]o\s+consta|livre/.test(s)) return 'sem';
    if(/aliena|gravame|com\s+restri|financiad|arrendament|reserva\s+de\s+dom/.test(s)) return 'com';
    return '';
  }
  function gravamePanelHtml(dd, placa){
    var p=gravameParse(dd);
    var nv=gravameNivel(p.status);
    var nvHist=p.hist.length?gravameNivel(p.hist[0].status):'';
    var html='';
    if(nv==='com') html+=_veicVeredito('no','COM GRAVAME', 'Alienação fiduciária ativa: a transferência só sai depois da baixa.');
    else if(nv==='baixado') html+=_veicVeredito('mid','GRAVAME BAIXADO', 'A base indica baixa do gravame. Confirme no DETRAN antes de transferir.');
    else if(nv==='sem') html+=_veicVeredito('ok','SEM GRAVAME', 'Nenhuma alienação fiduciária consta na base verificada.');
    else html+=_veicVeredito('mid','Situação não informada', 'A base não devolveu a situação do gravame para esta placa.');
    /* 🔴 o conflito entre o AGORA e o HISTÓRICO, dito em voz alta */
    if(nv && nvHist && nv!==nvHist){
      html+='<div class="gravame-conflito" style="background:#fffbeb;border:1px solid #fde68a;border-radius:11px;padding:10px 12px;margin:0 0 10px;font-size:12.5px;color:#92400e">'
        +'<b>Atenção: a base se contradiz.</b> A situação atual diz “'+esc(p.status)+'” e o último registro do histórico diz “'+esc(p.hist[0].status)+'”. Vale confirmar no DETRAN antes de fechar negócio.'
      +'</div>';
    }
    html+='<div class="gravame-resultado-dados" style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:6px 14px 10px;box-shadow:0 3px 12px rgba(2,20,60,.06)">'
      +_veicLinha('Banco / financeira', p.banco)
      +_veicLinha('Contrato', p.contrato)
      +_veicLinha('Data do gravame', p.data)
      +_veicLinha('Situação', p.status, 'is-long-value')
      +(p.vigencia?_veicLinha('Vigência', p.vigencia):'')
    +'</div>';
    if(p.hist.length){
      var linhas=p.hist.map(function(h){
        var sub=[h.data,h.agente].filter(Boolean).join(' · ');
        return '<div class="cpf3-proc"><div class="cpf3-proc-h"><b>'+esc(h.status||'Evento')+'</b></div>'
          +(sub?('<div class="cpf3-proc-s">'+esc(sub)+'</div>'):'')+'</div>';
      }).join('');
      html+=_cpfBloco('Histórico do gravame ('+p.hist.length+')', linhas, false);
    }
    html+=_veicRodape({ placa:p.ident.placa||placa, uf:p.ident.uf, chassi:p.ident.chassi });
    return html;
  }

  /* ========================================================================
     RECALL + RECALL V2 + FIPE (v1278)
     ------------------------------------------------------------------------
     Os fornecedores podem nomear campanha, risco e reparo de formas
     diferentes. O leitor abaixo aceita essas variações, mas nunca transforma
     uma fonte ausente em "nada consta": o veredito verde só aparece quando
     AS DUAS bases de recall responderam e nenhuma trouxe ocorrência. */
  function _recallSim(v){
    if(v===true||v===1) return true;
    return /^(sim|s|true|1|consta|pendente|ativo|aberto)$/i.test(String(v==null?'':v).trim());
  }
  function _recallItem(o, origem){
    if(!o||typeof o!=='object'||Array.isArray(o)) return null;
    var campanha=_veicTxt(_veicDeep(o,/^(campanha|codigocampanha|numerocampanha|codigorecall|recallcodigo|protocolo|numero)$/));
    var descricao=_veicTxt(_veicDeep(o,/^(descricao|descricaorecall|defeito|motivo|componente|assunto|titulo|recall)$/));
    var risco=_veicTxt(_veicDeep(o,/^(risco|consequencia|consequencias|perigo)$/));
    var reparo=_veicTxt(_veicDeep(o,/^(reparo|solucao|providencia|orientacao|procedimento|correcao)$/));
    var status=_veicTxt(_veicDeep(o,/^(status|situacao|situacaorecall|atendimento|atendido)$/));
    var data=_veicTxt(_veicDeep(o,/^(data|datainicio|datacampanha|datacomunicado|datareparo|dataatualizacao)$/));
    if(!campanha&&!descricao&&!risco&&!reparo&&!status&&!data) return null;
    return { origem:origem, campanha:campanha, descricao:descricao, risco:risco, reparo:reparo, status:status, data:data };
  }
  function _recallFonte(raw, origem){
    var b=_veicBase(raw), itens=[], vistos={};
    function incluir(o){
      var x=_recallItem(o,origem); if(!x) return;
      var k=[x.campanha,x.descricao,x.risco,x.reparo,x.status,x.data].join('|').toLowerCase();
      if(!k.replace(/\|/g,'')||vistos[k]) return; vistos[k]=1; itens.push(x);
    }
    function andar(no, dica, prof){
      if(!no||typeof no!=='object'||prof>7) return;
      if(Array.isArray(no)){ no.forEach(function(x){ if(dica) incluir(x); andar(x,dica,prof+1); }); return; }
      var ks=Object.keys(no), assinatura=ks.join(' ').toLowerCase().replace(/[^a-z0-9]/g,'');
      if(dica && /campanh|recall|defeit|risco|reparo|solucao|situacao|status|componente|motivo|data/.test(assinatura)) incluir(no);
      ks.forEach(function(k){
        var v=no[k]; if(!v||typeof v!=='object') return;
        andar(v,dica||/recall|campanh|chamamento|ocorrencia/.test(String(k).toLowerCase()),prof+1);
      });
    }
    andar(b,true,0);
    var indicativo=_veicDeep(b,/^(indicativorecall|temrecall|possuirecall|constarecall|recallativo)$/);
    var qtd=Number(_veicDeep(b,/^(quantidaderecall|quantidaderecalls|quantidadeocorrencias|totalrecall|totalrecalls)$/));
    if(!itens.length && (_recallSim(indicativo)||qtd>0)) itens.push({ origem:origem, campanha:'', descricao:'A base indicou recall para este veículo, sem detalhar a campanha.', risco:'', reparo:'', status:'', data:'' });
    return { itens:itens, ident:_veicIdent(b) };
  }
  function recallParse(dd){
    var b=_veicBase(dd), fontes=b.fontes||{};
    var p=_recallFonte(b.recall_placa,'Recall por placa');
    var v=_recallFonte(b.recall_v2,'Recall V2 por chassi');
    return { itens:p.itens.concat(v.itens), placaOk:fontes.recall===true, v2Ok:fontes.recall_v2===true,
      fipeOk:fontes.fipe===true, ident:p.ident.placa?p.ident:v.ident };
  }
  function _recallFipeMesOrdem(mes){
    var s=_veicTxt(mes).toLowerCase();
    try{ s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    var a=s.match(/^(\d{4})[-\/](\d{1,2})/); if(a) return Number(a[1])*12+Number(a[2]);
    var b=s.match(/^(\d{1,2})[-\/](\d{4})/); if(b) return Number(b[2])*12+Number(b[1]);
    var ano=(s.match(/\b(20\d{2}|19\d{2})\b/)||[])[1], nomes=['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    if(ano){ for(var i=0;i<nomes.length;i++) if(s.indexOf(nomes[i])===0) return Number(ano)*12+i+1; }
    return 0;
  }
  function recallFipeCompleta(dd){
    var b=_veicBase(dd), f=b&&b.fipe_combo;
    if(!f||typeof f!=='object') return null;
    var h=(Array.isArray(f.historico)?f.historico:[]).map(function(x){
      return { mes:_veicTxt(x&&x.mes), valor:Number(x&&x.valor)||0 };
    }).filter(function(x){ return x.mes&&x.valor>0; }).sort(function(a,b2){
      var ka=_recallFipeMesOrdem(a.mes), kb=_recallFipeMesOrdem(b2.mes);
      return ka&&kb ? kb-ka : 0;
    });
    return {
      placa:_veicTxt(f.placa), marca:_veicTxt(f.marca), modelo:_veicTxt(f.modelo), versao:_veicTxt(f.versao),
      ano:_veicTxt(f.ano), anoModelo:_veicTxt(f.ano_modelo), cor:_veicTxt(f.cor), combustivel:_veicTxt(f.combustivel),
      municipio:_veicTxt(f.municipio), uf:_veicTxt(f.uf), chassi:_veicTxt(f.chassi),
      fipe:Number(f.fipe)||0, codigoFipe:_veicTxt(f.codigo_fipe), mesRef:_veicTxt(f.mes_ref),
      historico:h, fonte:'Tabela FIPE'
    };
  }
  function recallResumoDados(dd){
    var p=recallParse(dd), n=p.itens.length, verificadas=(p.placaOk?1:0)+(p.v2Ok?1:0);
    if(n) return {tom:'atencao',titulo:n===1?'1 recall encontrado':n+' recalls encontrados',texto:'Confira a campanha, o reparo e a situação antes de negociar o veículo.'};
    if(verificadas===2) return {tom:'ok',titulo:'Nenhum recall encontrado',texto:'As duas bases responderam sem campanhas para este veículo na data da consulta.'};
    return {tom:'atencao',titulo:'Verificação parcial',texto:'Uma ou mais bases não responderam. Ausência de resultado não significa ausência de recall.'};
  }
  function recallPanelHtml(dd, placa, semVeredito){
    var p=recallParse(dd), n=p.itens.length, verificadas=(p.placaOk?1:0)+(p.v2Ok?1:0), html='';
    if(!semVeredito){
      if(n) html+=_veicVeredito('mid','Recall localizado',n+' campanha'+(n===1?'':'s')+' ou apontamento'+(n===1?'':'s')+' encontrado'+(n===1?'':'s')+' nas bases consultadas.');
      else if(verificadas===2) html+=_veicVeredito('ok','Nenhum recall encontrado','As duas bases responderam sem campanhas para este veículo na data da consulta.');
      else html+=_veicVeredito('mid','Verificação parcial','Nem todas as bases de recall responderam. Ausência de resultado não significa ausência de recall.');
    }
    html+='<div class="recall-fontes" aria-label="Estado das fontes consultadas">'
      +recallFonteHtml('Recall por placa',p.placaOk)
      +recallFonteHtml('Recall V2 por chassi',p.v2Ok)
      +recallFonteHtml('FIPE e identificação',p.fipeOk)
    +'</div>';
    if(n){
      html+=_cpfBloco('Campanhas e apontamentos ('+n+')',p.itens.map(function(x){
        var forte=x.campanha?('Campanha '+x.campanha):(x.descricao||'Recall informado');
        var linhas=[];
        if(x.descricao&&x.descricao!==forte) linhas.push(x.descricao);
        if(x.risco) linhas.push('Risco: '+x.risco);
        if(x.reparo) linhas.push('Reparo: '+x.reparo);
        if(x.status) linhas.push('Situação: '+x.status);
        return '<div class="cpf3-proc"><div class="cpf3-proc-h"><b>'+esc(forte)+'</b></div>'
          +'<div class="cpf3-proc-s">'+esc([x.origem,x.data].filter(Boolean).join(' · '))+'</div>'
          +linhas.map(function(l){return '<div class="cpf3-proc-l">'+esc(l)+'</div>';}).join('')+'</div>';
      }).join(''),false);
    }
    html+='<p class="recall-orientacao">Confirme a campanha e o atendimento com uma concessionária da marca ou pelos canais oficiais do fabricante. Informações verificadas na data da consulta.</p>';
    return html;
  }
  function recallFonteHtml(rotulo, ok){
    return '<div class="recall-fonte '+(ok?'is-ok':'is-parcial')+'"><span class="recall-fonte-ico">'+(ok?_CR_ICO.sucesso:_CR_ICO.atencao)+'</span>'
      +'<span class="recall-fonte-tx"><span>'+esc(rotulo)+'</span><b>'+(ok?'Verificado':'Não verificado')+'</b></span></div>';
  }

  /* ==========================================================================
     MULTAS (RENAINF) — o desenho (v629)
     ==========================================================================
     A pergunta do lojista: **quanto esse carro deve, e está em aberto?**
     Por isso o número vem primeiro e a lista depois.

     🔴 ZERO REGISTROS NÃO É "SEM MULTAS". O RENAINF nasceu só pras infrações
     de UF diferente da de licenciamento; a CONTRAN 637/2016 mandou expandir
     pra todas, mas a cobertura depende de cada órgão ter integrado — e órgão
     municipal é irregular nisso. Então a tela diz "nenhuma multa encontrada
     no RENAINF", nunca "sem multas". A primeira é um fato; a segunda é uma
     garantia que o app não pode dar, e vira reclamação quando aparecer uma
     multa municipal depois. Mesma disciplina do selo "nas bases verificadas
     na data da consulta".

     🔴 A RESPOSTA É FEIA, e o parse é metade do serviço:
       1. `detalhe_cod_infracao` traz CÓDIGO e DESCRIÇÃO grudados por " - ";
       2. dinheiro vem em texto com vírgula ("293,47") — converter antes de
          somar, senão a soma concatena string ou dá NaN;
       3. "*****", "0,00" e "0" são o vazio deste provedor (ver _veicVazio);
       4. 🔴 bloco de pagamento TODO VAZIO = multa EM ABERTO. A informação
          mais importante da linha existe por AUSÊNCIA — cuidado ao ler;
       5. `alerta` só vem quando o provedor tem algo a dizer: quando vier,
          aparece em destaque.
     ========================================================================= */
  /* "293,47" -> 293.47 · "R$ 1.234,56" -> 1234.56 · "" -> null */
  function _veicMoeda(v){
    if(_veicVazio(v)) return null;
    var s=String(v).replace(/r\$/ig,'').replace(/\s/g,'');
    if(/,\d{1,2}$/.test(s)) s=s.replace(/\./g,'').replace(',','.');
    else s=s.replace(/,/g,'');
    var n=parseFloat(s.replace(/[^\d.-]/g,''));
    return isNaN(n)?null:n;
  }
  function _veicBrl(n){ return 'R$ '+Number(n||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  /* dd/mm/aaaa (ou aaaa-mm-dd) -> número comparável; sem data devolve null,
     e quem não tem data vai pro FIM da lista, nunca pro topo (a mesma regra
     da ordenação do Repasse, v627) */
  function _veicData(v){
    var s=_veicTxt(v); if(!s) return null;
    var m=s.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if(m) return Number(m[3]+m[2]+m[1]);
    var i=s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if(i) return Number(i[1]+i[2]+i[3]);
    return null;
  }
  /* o provedor manda um registro achatado quando é uma multa só, e um array
     quando são várias — os dois viram a mesma lista aqui */
  function _renainfRegistros(b){
    var lista=null;
    ['renainf','infracoes','multas','ocorrencias','registros','autuacoes','itens'].some(function(k){
      var v=_veicDeep(b, new RegExp('^'+k+'$'));
      if(Array.isArray(v)&&v.length){ lista=v; return true; }
      var d=b&&b[k];
      if(Array.isArray(d)&&d.length){ lista=d; return true; }
      return false;
    });
    if(!lista){
      /* achatado: se existe qualquer campo de infração, é UM registro */
      if(_veicDeep(b,/^(detalhecodinfracao|codinfracao|codigoinfracao|numeroauto|numautoinfracao)$/)!=null) lista=[b];
      else lista=[];
    }
    return lista;
  }
  function renainfParse(dd){
    var b=_veicBase(dd);
    var itens=_renainfRegistros(b).map(function(r){
      var cod=_veicTxt(_veicDeep(r,/^(detalhecodinfracao|codinfracao|codigoinfracao|codigo)$/));
      var partes=cod.split(/\s+-\s+/);
      var codigo=partes.length>1?partes[0].trim():'';
      var descr=partes.length>1?partes.slice(1).join(' - ').trim():cod;
      if(!descr) descr=_veicTxt(_veicDeep(r,/^(descricaoinfracao|detalhedescricaoinfracao|infracao|descricao)$/));
      var valor=_veicMoeda(_veicDeep(r,/^(detalhevalorinfracao|valorinfracao|valor|valormulta)$/));
      /* 🔴 pago só quando o bloco de pagamento tem ALGUMA coisa */
      var pago=r&&r.pago===true;
      try{
        Object.keys(r||{}).forEach(function(k){
          if(/^dadosdopagamento/i.test(k.replace(/[^a-z]/gi,'')) && !_veicVazio(r[k])) pago=true;
        });
      }catch(_){}
      if(!pago){
        var dp=_veicDeep(r,/^(dadosdopagamento|pagamento|dadospagamento)$/);
        if(dp && typeof dp==='object'){ try{ pago=Object.keys(dp).some(function(k){ return !_veicVazio(dp[k]); }); }catch(_){} }
        else if(!_veicVazio(dp)) pago=true;
      }
      return {
        data:_veicTxt(_veicDeep(r,/^(detalhedatainfracao|datainfracao|dataocorrencia|data)$/)),
        cadastro:_veicTxt(_veicDeep(r,/^(detalhedatacadastramento|detalhecadastramentoinfracao|datacadastramento|datacadastro|cadastro)$/)),
        codigo:codigo, descricao:descr,
        orgao:_veicTxt(_veicDeep(r,/^(detalheorgaoautuador|orgaoautuador|orgao)$/)),
        uf:_veicTxt(_veicDeep(r,/^(detalheufinfracao|ufinfracao|uf)$/)),
        local:_veicTxt(_veicDeep(r,/^(detalhelocalinfracao|locainfracao|localinfracao)$/))
             ||_veicTxt(_veicDeep(r,/^(detalhelocalinfracao|detallocal|local)$/)),
        auto:_veicTxt(_veicDeep(r,/^(numeroauto|numautoinfracao|autoinfracao|numeroautoinfracao|auto)$/)),
        exig:_veicTxt(_veicDeep(r,/^exigibilidade$/)),
        valor:valor, pago:pago
      };
    });
    /* mais recente primeiro; sem data vai pro FIM */
    itens.sort(function(a,c){
      var da=_veicData(a.data), dc=_veicData(c.data);
      if(da==null && dc==null) return 0;
      if(da==null) return 1;
      if(dc==null) return -1;
      return dc-da;
    });
    var aberto=0, temAberto=false;
    itens.forEach(function(x){ if(!x.pago && x.valor!=null){ aberto+=x.valor; temAberto=true; } });
    return { itens:itens, aberto:temAberto?aberto:null,
             alerta:_veicTxt(_veicDeep(b,/^(alerta|aviso)$/)),
             ident:_veicIdent(b), raw:b };
  }
  function renainfPanelHtml(dd, placa, semRodape){
    var p=renainfParse(dd);
    var n=p.itens.length;
    var html='';
    if(!n){
      /* 🔴 a frase é literal e não muda: "no RENAINF" faz parte dela */
      html+=_veicVeredito('ok','Nenhuma multa encontrada no RENAINF',
        'A base do RENAINF não devolveu infrações para esta placa na data da consulta.');
    }else{
      var abertas=p.itens.filter(function(x){ return !x.pago; }).length;
      html+=_veicVeredito(abertas?'no':'mid',
        n+' multa'+(n===1?'':'s')+(p.aberto!=null?(' · '+_veicBrl(p.aberto)+' em aberto'):''),
        abertas ? (abertas+' em aberto de '+n+' encontrada'+(n===1?'':'s')+'.')
                : 'Todas aparecem como pagas na base.');
    }
    if(p.alerta){
      html+='<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:11px;padding:10px 12px;margin:0 0 10px;font-size:12.5px;color:#92400e">⚠️ '+esc(p.alerta)+'</div>';
    }
    p.itens.forEach(function(x){
      var chip=x.pago
        ? '<span class="cpf3-polo" style="background:#dcfce7;color:#15803d">PAGA</span>'
        : '<span class="cpf3-polo" style="background:#fee2e2;color:#b91c1c">EM ABERTO</span>';
      var sub=[x.data, x.orgao, x.uf].filter(Boolean).join(' · ');
      var det=[ x.auto?('Auto: '+x.auto):'', x.codigo?('Código: '+x.codigo):'',
                x.local?('Local: '+x.local):'', x.cadastro?('Cadastramento: '+x.cadastro):'',
                x.exig?('Exigibilidade: '+x.exig):'' ].filter(Boolean);
      html+='<div class="cpf3-proc">'
        +'<div class="cpf3-proc-h"><b>'+esc(x.descricao||'Infração')+'</b>'+chip+'</div>'
        +(sub?('<div class="cpf3-proc-s">'+esc(sub)+'</div>'):'')
        +(x.valor!=null?('<div class="cpf3-proc-l"><b>'+esc(_veicBrl(x.valor))+'</b></div>'):'')
        +(det.length?('<details style="margin-top:5px"><summary style="font-size:12px;color:#0a4da6;cursor:pointer;font-weight:700">detalhes</summary>'
            +det.map(function(d){ return '<div class="cpf3-proc-s">'+esc(d)+'</div>'; }).join('')+'</details>'):'')
      +'</div>';
    });
    if(!semRodape) html+=_veicRodape({ placa:p.ident.placa||placa, uf:p.ident.uf, chassi:p.ident.chassi });
    return html;
  }

  /* ==========================================================================
     RENAJUD — o desenho (v630)
     ==========================================================================
     🔴 O ACHADO QUE DECIDE A TELA INTEIRA: **"tem registro" ≠ "está
     bloqueado".** A resposta do exemplo diz, ao mesmo tempo:

         quantidade_de_bloqueio_ativo_localizado ....... "0"
         quantidade_de_ocorrencias_total_existente ..... "2"
         msg: "CONSTA BLOQUEIO RENAJUD / BLOQUEIO-ATIVO NADA CONSTA."

     A `msg` do provedor se contradiz numa frase só. Os NÚMEROS contam a
     história de verdade: 2 ocorrências no histórico, 0 bloqueios ativos.

     Pra concessionária a pergunta não é "esse carro já teve processo?" — é
     **"eu consigo transferir esse carro hoje?"**:

        bloqueio ativo > 0        -> 🔴 NÃO TRANSFERE. É o veredito.
        ocorrências > 0, ativos 0 -> 🟡 já teve, hoje está livre.
        nada                      -> 🟢 nada consta no RENAJUD.

     🔴 **A `msg` crua NÃO vira veredito.** Jogada na tela, ela reprovaria um
     carro perfeitamente vendável. Ela entra, no máximo, como uma linha do
     detalhe.

     ⚠️ E há TRÊS contadores, não dois. Quando "exibidas pelo DETRAN" e "total
     existente" NÃO baterem, a tela diz "mostrando X de Y" — senão mente por
     omissão.
     ========================================================================= */
  function _veicInt(v){
    if(v==null) return null;
    var s=String(v).replace(/[^\d-]/g,'');
    if(s==='') return null;
    var n=parseInt(s,10);
    return isNaN(n)?null:n;
  }
  function renajudParse(dd){
    var b=_veicBase(dd);
    var ativos=_veicInt(_veicDeep(b,/^(quantidadedebloqueioativolocalizado|bloqueiosativos|qtdbloqueioativo)$/));
    var exib=_veicInt(_veicDeep(b,/^(quantidadedeocorrenciasexibidasedisponivelpelodetran|ocorrenciasexibidas)$/));
    var total=_veicInt(_veicDeep(b,/^(quantidadedeocorrenciastotalexistente|ocorrenciastotal|quantidadeocorrenciastotal)$/));
    var lista=[];
    var raw=_veicDeep(b,/^(renajud|ocorrencias|restricoesjudiciais|bloqueios)$/);
    if(!Array.isArray(raw)) raw=(b&&Array.isArray(b.renajud))?b.renajud:null;
    if(Array.isArray(raw)){
      raw.forEach(function(o){
        if(!o||typeof o!=='object') return;
        lista.push({
          tribunal:_veicTxt(_veicKey(o,/^(nomeorgaojudicial|orgaojudicial|tribunal|nometribunal)$/)),
          processo:_veicTxt(_veicKey(o,/^(numerodoprocesso|numeroprocesso|processo)$/)),
          tipo:_veicTxt(_veicKey(o,/^(tiporestricjudicial|tiporestricaojudicial|tiporestricao|restricao)$/)),
          data:_veicTxt(_veicKey(o,/^(datadainclusao|datainclusao|data)$/)),
          municipio:_veicTxt(_veicKey(o,/^(municipio|nomemunicipio|comarca)$/)),
          consta:_veicTxt(_veicKey(o,/^(constarestricaorenajud|consta)$/))
        });
      });
    }
    return {
      /* 🔴 `exibidas` fica NULL quando o provedor não mandou o contador — não
         cai pra lista.length. Com o padrão errado, uma resposta sem contador
         nenhum virava "0 exibidas" e a tela pintava VERDE ("nada consta") em
         cima de uma base que não respondeu. Foi o teste-v630 que pegou. */
      ativos:ativos, exibidas:exib, total:total,
      lista:lista,
      msg:_veicTxt(_veicDeep(b,/^(msg|mensagem|message)$/)),
      carro:[_veicTxt(_veicDeep(b,/^(marca|marcamodelo|nomemarca)$/)),
             _veicTxt(_veicDeep(b,/^(modelo|nomemodelo)$/)),
             _veicTxt(_veicDeep(b,/^(cor|nomecor|corveiculo)$/)),
             _veicTxt(_veicDeep(b,/^(anomodelo|anofabricacao|ano)$/))].filter(Boolean).join(' · '),
      municipio:_veicTxt(_veicDeep(b,/^(municipio|nomemunicipio)$/)),
      ident:_veicIdent(b), raw:b
    };
  }
  function renajudPanelHtml(dd, placa){
    var p=renajudParse(dd);
    var ocor = (p.total!=null?p.total:(p.exibidas!=null?p.exibidas:p.lista.length));
    var html='';
    if(p.ativos!=null && p.ativos>0){
      html+=_veicVeredito('no','🔴 NÃO TRANSFERE — bloqueio ativo',
        p.ativos+' bloqueio'+(p.ativos===1?'':'s')+' ativo'+(p.ativos===1?'':'s')+' · '+ocor+' ocorrência'+(ocor===1?'':'s')+' no histórico.');
    }else if(ocor>0){
      html+=_veicVeredito('mid','🟡 Já teve — hoje está livre',
        '0 bloqueios ativos · '+ocor+' ocorrência'+(ocor===1?'':'s')+' no histórico.');
    }else if(p.ativos!=null || p.exibidas!=null || p.total!=null || p.lista.length){
      html+=_veicVeredito('ok','🟢 Nada consta no RENAJUD',
        'Nenhum bloqueio judicial ativo e nenhuma ocorrência no histórico.');
    }else{
      html+=_veicVeredito('mid','Situação não informada',
        'A base não devolveu os contadores de bloqueio para esta placa.');
    }
    /* ⚠️ mostrando X de Y — quando o DETRAN não devolveu tudo */
    if(p.total!=null && p.exibidas!=null && p.total>p.exibidas){
      html+='<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:11px;padding:10px 12px;margin:0 0 10px;font-size:12.5px;color:#92400e">'
        +'⚠️ Mostrando '+p.exibidas+' de '+p.total+' ocorrências — o DETRAN não devolveu todas.</div>';
    }
    if(p.carro){
      /* serve de conferência: se não bater com o carro do pátio, a placa
         digitada está errada. É por isso que vale UMA linha com isso. */
      html+='<div style="font-size:12px;color:#475569;margin:0 0 8px">Veículo: <b>'+esc(p.carro)+'</b>'+(p.municipio?(' · '+esc(p.municipio)):'')+'</div>';
    }
    p.lista.forEach(function(x){
      var sub=[x.data, x.municipio].filter(Boolean).join(' · ');
      html+='<div class="cpf3-proc">'
        +'<div class="cpf3-proc-h"><b>'+esc(x.tribunal||'Órgão judicial não informado')+'</b></div>'
        /* 🔴 número de processo é público (CNJ) e pode aparecer — mas NÃO vira
           link: cada tribunal tem seu portal, e link errado é pior que nenhum */
        +(x.processo?('<div class="cpf3-proc-l">Processo '+esc(x.processo)+'</div>'):'')
        +'<div class="cpf3-proc-l">'+esc(x.tipo||'tipo não informado')+'</div>'
        +(sub?('<div class="cpf3-proc-s">'+esc(sub)+'</div>'):'')
      +'</div>';
    });
    if(p.msg){
      html+=_cpfBloco('O que a base respondeu, na íntegra', '<div class="cpf3-proc-s">'+esc(p.msg)+'</div>', false);
    }
    html+=_veicRodape({ placa:p.ident.placa||placa, uf:p.ident.uf, chassi:p.ident.chassi });
    return html;
  }

  /* ==========================================================================
     🔑 O ATALHO NO MOMENTO CERTO (v628)
     --------------------------------------------------------------------------
     Ninguém digita a mesma placa duas vezes (a ideia da v611/v613). Quando a
     consulta de placa JÁ acusou gravame, o botão pra ver o detalhe aparece
     ali mesmo, embaixo do relatório, com o preço na cara.
     ⚠️ Ele só nasce quando o indicador acusou — atalho que aparece sempre
     vira propaganda, e propaganda embaixo de um resultado pago irrita.
     ========================================================================= */
  function veicAtalhosHtml(){
    var ex=null; try{ ex=(typeof leilaoState!=='undefined'&&leilaoState)?relVeicExtrai(leilaoState):null; }catch(_){ ex=null; }
    if(!ex) return '';
    var bts=[];
    if(ex.temGravame) bts.push(['gravame','🏦 Ver detalhes do gravame — '+_veicTok(VEIC_PAGS.gravame.tok)]);
    /* v629 — o indicador de multas do relatório da placa (o item "Multas" ou
       "Multas / infrações (RENAINF)" do quadro de avisos, quando acusou) */
    var _temMulta=false;
    try{ _temMulta=(ex.itens||[]).some(function(i){ return i.ruim && /multa|infra/i.test(String(i.rot||'')); }); }catch(_){}
    if(_temMulta) bts.push(['multas','🚦 Ver as multas — '+_veicTok(VEIC_PAGS.multas.tok)]);
    /* v630 — o indício de restrição judicial no relatório da placa */
    var _temJud=false;
    try{ _temJud=(ex.itens||[]).some(function(i){ return i.ruim && /renajud|judicial/i.test(String(i.rot||'')); }); }catch(_){}
    if(_temJud) bts.push(['renajud','⚖️ Ver o RENAJUD — '+_veicTok(VEIC_PAGS.renajud.tok)]);

    /* ==========================================================================
       🔴 v863 — A PENEIRA QUE FALTAVA NA v861. Buraco meu, achado pelo §1.7 do
       PROJETO20260903tirarrenajudemultas.
       --------------------------------------------------------------------------
       Na v861 eu tirei Multas e RENAJUD do CATÁLOGO — mas ESTES BOTÕES não
       passam pelo catálogo. Eles nascem do quadro de avisos da consulta de
       placa: viu "multa" ou "judicial" lá, oferece a consulta avulsa. Ou seja,
       o app continuava oferecendo duas consultas que ele não oferece mais.

       ⚠️ E o que elas devolvem hoje é 422, conferido no banco em 03/09:
          renainf 11:57:30 "Nao foi possivel concluir a consulta."
          renajud 12:00:26 "Falha na consulta ao provedor."
       Um botão que promete e falha é pior do que botão nenhum.

       🔴 POR QUE UMA PENEIRA NO FIM, E NÃO UM `if` EM CADA `push`: porque a
       lista cresce. Amanhã alguém acrescenta um quarto botão e vai esquecer o
       `if` — que é exatamente o que aconteceu comigo aqui. Peneirando o
       RESULTADO, qualquer botão novo já nasce obedecendo a chavinha, sem quem
       o escreveu precisar saber que esta regra existe.
       📌 O `gravame` NÃO é afetado: ele funciona (provado no banco, 11:50:42) e
       não está na lista de desligados.
       ⛳ PRA VOLTAR: religue a consulta no 00-edicoes.js e o botão dela volta
       sozinho — não há nada a desfazer aqui. */
    try{
      if(typeof window.edConsultaLigada==='function'){
        bts=bts.filter(function(b){ return window.edConsultaLigada(b[0]); });
      }
    }catch(_){}

    if(!bts.length) return '';
    return bts.map(function(b){
      return '<button type="button" class="veic-atalho" data-veicir="'+b[0]+'" style="width:100%;margin-top:8px;background:#eef4ff;color:#0a4da6;border:1px solid #cfe0ff;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">'+esc(b[1])+'</button>';
    }).join('');
  }
  function veicAtalhosLigar(root){
    try{
      Array.prototype.forEach.call((root||document).querySelectorAll('[data-veicir]'),function(b){
        b.onclick=function(e){ e.stopPropagation(); abrirVeicPag(b.getAttribute('data-veicir')); };
      });
    }catch(_){}
  }

  /* ==========================================================================
     v638 — O RELATÓRIO EM PDF DAS TRÊS CONSULTAS DE VEÍCULO
     ==========================================================================
     Angelo, olhando a página do Gravame no computador:
       "nao tem o modelo do relatorio pdf com dados ficticios"

     🔴 E FALTAVA MAIS DO QUE O EXEMPLO: as três consultas (v628/v629/v630)
     nasceram SEM PDF NENHUM. Nem o de baixar o resultado de verdade, nem o
     exemplo. Toda consulta paga desta casa entrega uma folha — o lojista
     imprime, manda no WhatsApp, guarda na pasta do carro. Sem isso, o que ele
     compra por 4 ou 5 tokens morre na tela.

     🔴 E NINGUÉM COMPRA O QUE NÃO VIU. As páginas de CPF resolveram isso na
     v601/v603: um "Ver exemplo (PDF)" com dados fictícios, que não consulta,
     não cobra e não entra no histórico. As de veículo ficaram sem — pediam o
     token no escuro.

     🔑 ZERO PEÇA NOVA NO PAPEL: tudo sai do kit do 06b (a faixa azul da casa,
     o veredito, as seções kv, o rodapé com paginação) — inclusive o `kitLista`
     que a v637 acabou de criar pro CNAE, e que aqui resolve exatamente o
     mesmo problema: multa e ocorrência judicial são texto longo, e texto
     longo numa grade de duas colunas sai cortado pela borda da folha.
     ========================================================================= */

  /* a folha de cada uma — mesma fonte de dados da tela, sempre */
  function veicPaginas(qual, dd, placa){
    qual=veicPagEsc(qual);
    var P=VEIC_PAGS[qual];
    _veicDadosComCombo(placa,dd);
    if(qual==='proprietarios'){
      var _hpPdfDados=_hpMesclarFipe(_veicDadosJa(placa),proprietariosParse(dd));
      if(_hpPdfDados) _veicDadosCache[_veicPlacaLimpa(placa)]=_hpPdfDados;
    }
    var st=pdfkitNovo({ tipo:P.titulo, placa:String(placa||'').toUpperCase(),
      lgpdCurto:qual==='proprietarios'?'Dados pessoais minimizados · uso em negociação de veículo':
        'Informação das bases oficiais na data da consulta · dados pessoais do proprietário omitidos (LGPD)' });
    /* 🔴 v861 (pedido do Angelo: "adicione as informações da FIPE ao PDF") —
       o quadro VEÍCULO entra NO TOPO, logo abaixo do cabeçalho e ANTES do
       resultado, como ele escolheu. Uma folha só.
       📌 Era isto que faltava no PDF do RENAINF do print dele: uma linha
       verde e uma placa numa folha inteira. Agora a folha diz QUAL carro. */
    if(qual==='recall') _pgRecallFipe(st,dd,placa);
    else _pgVeiculo(st, placa);
    if(qual==='proprietarios') _pgProprietarios(st,dd,placa);
    if(qual==='gravame')  _pgGravame(st, dd, placa);
    if(qual==='recall')    _pgRecall(st, dd, placa);
    if(qual==='debitos')   _pgDebitos(st, dd, placa);
    if(qual==='multas')   _pgMultas(st, dd, placa);
    if(qual==='renajud')  _pgRenajud(st, dd, placa);
    if(P.autocorp)        _pgAutocorp(st, qual, dd, placa);   /* v744 */
    return kitFinaliza(st);
  }
  /* o quadro VEÍCULO do papel — mesmas linhas da tela, mesma fonte de dados */
  function _pgVeiculo(st, placa){
    var ligado=true; try{ if(typeof window.edQuadroVeiculo==='function') ligado=window.edQuadroVeiculo(); }catch(_){}
    if(!ligado) return;
    var l=_veicQuadroLinhas(_veicDadosJa(placa));
    if(!l.length) return;   /* sem dado, sem quadro vazio no papel */
    kitKv2(st,'Veículo', l);
  }
  /* o rodapé de identificação, igual nas três */
  function _pgIdent(st, ident, placa){
    var linhas=[];
    if(ident.placa||placa) linhas.push(['Placa', (ident.placa||placa||'').toUpperCase()]);
    if(ident.uf) linhas.push(['UF', ident.uf]);
    /* 03/09: o chassi sai mascarado aqui também — era a última porta do app
       que ainda imprimia os 17 dígitos num PDF que circula por WhatsApp. */
    if(ident.chassi) linhas.push(['Chassi', kitChassiMask(String(ident.chassi))]);
    if(linhas.length) kitKv2(st,'Veículo', linhas);
  }
  function _pgRecallFipe(st,dd,placa){
    var f=recallFipeCompleta(dd), d=_veicDadosJa(placa)||{};
    if(!f){
      _pgVeiculo(st,placa);
      kitAtencao(st,'A identificação FIPE não respondeu nesta consulta. O relatório apresenta somente as bases de recall concluídas.');
      return;
    }
    var carro=[f.marca,f.modelo].filter(Boolean).join(' '), ano=[f.ano,f.anoModelo].filter(Boolean).join('/');
    kitKv2(st,'Veículo e identificação',[
      ['Placa',String(placa||f.placa||'').toUpperCase()],
      ['Veículo',carro||[d.marca,d.modelo].filter(Boolean).join(' ')],
      ['Ano fab. / modelo',ano||d.ano||''],
      ['Cor',f.cor||d.cor||''],
      ['Combustível',f.combustivel||d.combustivel||''],
      ['Município / UF',[f.municipio,f.uf].filter(Boolean).join(' / ')],
      /* pedido explícito: no PDF autenticado do Recall o chassi sai completo */
      ['Chassi',f.chassi||'Não informado pela base']
    ]);
    var hist=f.historico||[], d6=null;
    if(hist.length>=2){
      var i6=Math.min(5,hist.length-1), b6=Number(hist[i6].valor)||0, a6=Number(hist[0].valor)||f.fipe;
      if(b6) d6=((a6-b6)/b6)*100;
    }
    kitFipeValor(st,{ valor:f.fipe, mesRef:f.mesRef||(hist[0]&&hist[0].mes)||'', dif6Pct:d6,
      marca:f.marca, modelo:f.modelo||f.versao,
      linhas:[
        [ano?('Ano fab./mod. '+ano):'',f.combustivel].filter(Boolean).join(' · '),
        f.codigoFipe?('Código FIPE '+f.codigoFipe):''
      ] });
    if(hist.length>=2){
      kitFipe6(st,hist,true);
      kitGrafArea(st,hist);
    }else kitAtencao(st,'A FIPE atual foi identificada, mas a base não retornou histórico suficiente para mostrar a evolução de preços.');
    kitTexto(st,'Fonte da identificação e dos valores: Tabela FIPE. O histórico reflete os meses devolvidos pela base na data da consulta.');
  }
  function _pgProprietarios(st,dd,placa){
    var p=proprietariosParse(dd), a=p.atual;
    if(!a){ kitAtencao(st,'A base não retornou histórico para esta placa.'); return; }
    kitVeredito(st,'ok','Histórico localizado',p.transferencias+' transferências · '+p.donos+' donos distintos.');
    kitKv2(st,'Registro mais recente na base',[
      ['Nome',a.nome||'não informado'],['Documento',a.documento||'não informado'],
      ['Data do registro',a.data||'não informado'],
      ['Cidade / UF',[a.municipio,a.uf].filter(Boolean).join(' / ')||'não informado']
    ]);
    kitAtencao(st,'A data mais recente é um registro da fonte, não uma confirmação de propriedade atual. Períodos são calculados somente entre transferências registradas.');
    kitKv2(st,'Resumo do histórico',[
      ['Transferências',String(p.transferencias)],['Donos distintos',String(p.donos)],
      ['Mudança de UF',p.mudouUf?p.rotaUf:'Não identificada'],['Passou por empresa',p.passouEmpresa?'Sim':'Não']
    ].concat(p.mediaMeses!=null?[['Rotatividade média',p.mediaMeses+' meses por dono']]:[]));
    kitLista(st,'Linha do tempo — mais recente ao mais antigo ('+p.itens.length+')',p.itens.map(function(x,i){
      var per=_hpPeriodoLinha(x,i);
      return {forte:(i===0?'Mais recente · ':'')+(x.nome||'Nome não informado'),fraco:[per[0],per[1],[x.municipio,x.uf].filter(Boolean).join(' / '),x.tipo,x.documento].filter(Boolean).join(' · ')};
    }));
    _pgIdent(st,{placa:(a.placa||placa),uf:a.uf,chassi:''},placa);
  }
  function _pgGravame(st, dd, placa){
    var p=gravameParse(dd);
    var nv=gravameNivel(p.status);
    if(nv==='com') kitVeredito(st,'no','COM GRAVAME','Alienação fiduciária ativa: a transferência só sai depois da baixa.');
    else if(nv==='baixado') kitVeredito(st,'at','GRAVAME BAIXADO','A base indica baixa. Confirme no DETRAN antes de transferir.');
    else if(nv==='sem') kitVeredito(st,'ok','SEM GRAVAME','Nenhuma alienação fiduciária consta na base verificada.');
    else kitVeredito(st,'at','Situação não informada','A base não devolveu a situação do gravame para esta placa.');
    /* 🔴 o conflito entre o AGORA e o histórico vai pro papel também: quem
       imprime a folha e leva pro cliente precisa ver a contradição. */
    var nvH=p.hist.length?gravameNivel(p.hist[0].status):'';
    if(nv && nvH && nv!==nvH){
      kitAtencao(st,'A base se contradiz: a situação atual diz "'+p.status+'" e o último registro do histórico diz "'+p.hist[0].status+'". Confirme no DETRAN.');
    }
    kitKv2(st,'Gravame',[
      ['Banco / financeira', p.banco||'não informado'],
      ['Contrato', p.contrato||'não informado'],
      ['Data do gravame', p.data||'não informado'],
      ['Situação', p.status||'não informado']
    ].concat(p.vigencia?[['Vigência',p.vigencia]]:[]));
    if(p.hist.length){
      kitLista(st,'Histórico do gravame ('+p.hist.length+')',
        p.hist.map(function(h){ return { forte:h.status||'Evento', fraco:[h.data,h.agente].filter(Boolean).join(' · ') }; }));
    }
    _pgIdent(st, p.ident, placa);
  }
  function _pgRecall(st, dd, placa){
    var p=recallParse(dd), n=p.itens.length, verificadas=(p.placaOk?1:0)+(p.v2Ok?1:0);
    if(n) kitVeredito(st,'at','RECALL LOCALIZADO',n+' campanha'+(n===1?'':'s')+' ou apontamento'+(n===1?'':'s')+' encontrado'+(n===1?'':'s')+'.');
    else if(verificadas===2) kitVeredito(st,'ok','NENHUM RECALL ENCONTRADO','As duas bases de recall responderam sem campanhas na data da consulta.');
    else kitVeredito(st,'at','VERIFICAÇÃO PARCIAL','Nem todas as bases responderam. Ausência de resultado não significa ausência de recall.');
    kitKv2(st,'Bases consultadas',[
      ['Tabela FIPE e identificação',p.fipeOk?'Verificada':'Não verificada'],
      ['Recall por placa',p.placaOk?'Verificado':'Não verificado'],
      ['Recall V2 por chassi',p.v2Ok?'Verificado':'Não verificado'],
      ['Consulta emitida em',st.geradoEm]
    ]);
    kitTexto(st,'Tabela FIPE: identificação, valor atual, código, referência e histórico de preços. Recall por placa: campanhas vinculadas ao veículo. Recall V2 por chassi: segunda verificação da campanha pelo identificador veicular.');
    if(n) kitLista(st,'Campanhas e apontamentos ('+n+')',p.itens.map(function(x){
      var forte=x.campanha?('Campanha '+x.campanha):(x.descricao||'Recall informado');
      var fraco=[x.origem,x.data,x.descricao&&x.descricao!==forte?x.descricao:'',x.risco?('Risco: '+x.risco):'',x.reparo?('Reparo: '+x.reparo):'',x.status?('Situação: '+x.status):''].filter(Boolean).join(' · ');
      return { forte:forte, fraco:fraco };
    }));
    kitAtencao(st,'Confirme a campanha e o atendimento com uma concessionária da marca ou pelos canais oficiais do fabricante.');
  }
  function _pgMultas(st, dd, placa, semIdent){
    var p=renainfParse(dd);
    var n=p.itens.length;
    if(!n){
      /* 🔴 a frase é literal e não muda: "no RENAINF" faz parte dela. Zero
         registro não é "sem multas" — é o que ESTA base devolveu. */
      kitSelo(st,'Nenhuma multa encontrada no RENAINF na data da consulta.');
    }else{
      var abertas=p.itens.filter(function(x){ return !x.pago; }).length;
      kitVeredito(st, abertas?'no':'at',
        n+' multa'+(n===1?'':'s')+(p.aberto!=null?(' · '+_veicBrl(p.aberto)+' em aberto'):''),
        abertas ? (abertas+' em aberto de '+n+' encontrada'+(n===1?'':'s')+'.') : 'Todas aparecem como pagas na base.');
    }
    if(p.alerta) kitAtencao(st, p.alerta);
    if(n){
      /* 🔴 largura inteira, não grade: descrição de infração é texto longo, e
         texto longo em meia coluna sai cortado pela borda (lição da v637). */
      kitLista(st,'Multas ('+n+')', p.itens.map(function(x){
        var det=[x.data, x.orgao, x.uf, (x.valor!=null?_veicBrl(x.valor):''), (x.pago?'PAGA':'EM ABERTO')]
                .filter(Boolean).join(' · ');
        return { forte:x.descricao||'Infração', fraco:det };
      }));
    }
    if(!semIdent) _pgIdent(st, p.ident, placa);
  }
  function _pgRenajud(st, dd, placa){
    var p=renajudParse(dd);
    var ocor=(p.total!=null?p.total:(p.exibidas!=null?p.exibidas:p.lista.length));
    if(p.ativos!=null && p.ativos>0){
      kitVeredito(st,'no','NÃO TRANSFERE — bloqueio ativo',
        p.ativos+' bloqueio'+(p.ativos===1?'':'s')+' ativo'+(p.ativos===1?'':'s')+' · '+ocor+' ocorrência'+(ocor===1?'':'s')+' no histórico.');
    }else if(ocor>0){
      kitVeredito(st,'at','Já teve — hoje está livre','0 bloqueios ativos · '+ocor+' ocorrência'+(ocor===1?'':'s')+' no histórico.');
    }else if(p.ativos!=null || p.exibidas!=null || p.total!=null || p.lista.length){
      kitVeredito(st,'ok','Nada consta no RENAJUD','Nenhum bloqueio judicial ativo e nenhuma ocorrência no histórico.');
    }else{
      kitVeredito(st,'at','Situação não informada','A base não devolveu os contadores de bloqueio para esta placa.');
    }
    if(p.total!=null && p.exibidas!=null && p.total>p.exibidas){
      kitAtencao(st,'Mostrando '+p.exibidas+' de '+p.total+' ocorrências — o DETRAN não devolveu todas.');
    }
    if(p.carro) kitKv2(st,'Conferência do veículo',[['Veículo',p.carro]].concat(p.municipio?[['Município',p.municipio]]:[]));
    if(p.lista.length){
      kitLista(st,'Ocorrências ('+p.lista.length+')', p.lista.map(function(x){
        return { forte:x.tribunal||'Órgão judicial não informado',
                 fraco:[(x.processo?('Processo '+x.processo):''), (x.tipo||'tipo não informado'), x.data, x.municipio].filter(Boolean).join(' · ') };
      }));
    }
    _pgIdent(st, p.ident, placa);
  }

  function veicBotaoPdfHtml(rotulo){
    /* ⚠️ SEM a classe .pdf-btn, de propósito (lição da v595, e o mesmo
       conserto que a v637 fez no CNPJ): dentro do resultado ela vira o FAB e
       o botão some. Botão próprio, sempre visível. */
    return '<button type="button" id="veicPdf" class="consulta-relatorio-pdf">'+ICO_PDF+' <span>'+esc(rotulo||'Baixar consulta (PDF)')+'</span></button>';
  }
  function veicPdfExecutar(modo){
    if(!_veicState) return;
    /* v749 — o jsPDF é carregado sob demanda (MEVAssets); sem isto o botão
       dizia "O gerador de PDF não carregou" na primeira vez (print do
       Angelo, 30/08). Mesmo embrulho que o leilão e o CNPJ já usam. */
    if(!_mevPdfPronto(function(){ veicPdfExecutar(modo); },false)) return;
    try{
      var blob=kitPdfBlob(veicPaginas(_veicState.qual, _veicState.dados, _veicState.placa));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      var nome='consulta-'+_veicState.qual+'-'+String(_veicState.placa||'').toLowerCase()+'.pdf';
      pdfArquivoAcao(blob,nome,modo,function(){ pdfVisor(blob,nome); },'Consulta '+String(_veicState.placa||''));
    }catch(_){ toast('Não consegui gerar o PDF agora.'); }
  }
  function veicBaixarPDF(){ veicPdfExecutar('baixar'); }
  function veicVisualizarPDF(){
    veicPdfExecutar('visualizar');
  }
  function veicCompartilharPDF(){ veicPdfExecutar('compartilhar'); }

  /* ---------- o exemplo: dados fictícios, zero token, zero histórico -------
     ⚠️ Os números são inventados e a placa é ABC1D23, que não existe. O aviso
     amarelo em cima da folha diz isso com todas as letras — exemplo que não
     se anuncia como exemplo é propaganda enganosa. */
  var VEIC_EX_PLACA='ABC1D23';
  function veicExDados(qual){
    qual=veicPagEsc(qual);
    if(VEIC_PAGS[qual] && VEIC_PAGS[qual].autocorp) return autocorpExDados(qual);   /* v744 */
    if(qual==='proprietarios') return { mev_exemplo:true, response:{ tipo_doc:'VEIC_PROPRIETARIOS',total_registros:3,total_donos:3,registros:[
      {data_transferencia:'12/08/2024',nome_razao:'Mariana',documento:'***.***.***-42',tipo_pessoa:'PF',municipio:'CAMPINAS',uf:'SP',placa_mercosul:VEIC_EX_PLACA},
      {data_transferencia:'03/05/2021',nome_razao:'LOCADORA CAMINHO EXEMPLO LTDA',documento:'**.***.***/****-19',tipo_pessoa:'PJ',municipio:'CURITIBA',uf:'PR',placa_mercosul:VEIC_EX_PLACA},
      {data_transferencia:'21/11/2018',nome_razao:'Roberto',documento:'***.***.***-07',tipo_pessoa:'PF',municipio:'LONDRINA',uf:'PR',placa_mercosul:VEIC_EX_PLACA}
    ],valor_fipe:'R$ 48.250,00',codigo_fipe:'000000-0',mes_referencia:'setembro de 2026' } };
    if(qual==='debitos') return { mev_exemplo:true, tipo_doc:'VEIC_DEBITOS_ESTADUAIS',consultado_em:'07/10/2026',
      veiculo:{placa:VEIC_EX_PLACA,marca_modelo:'MARCA / MODELO EXEMPLO',ano_fabricacao:'2024',ano_modelo:'2025',situacao:'EM CIRCULAÇÃO',uf:'SP'},
      restricoes:{ipva:{existe:true,valor:'842,31',observacoes:'Exemplo fictício'},multas:{existe:true,valor:'293,47',observacoes:''},licenciamento:{existe:false,valor:'0,00',observacoes:''},dpvat:{existe:null,valor:'',observacoes:''},financiamento:{existe:true,agente:'BANCO EXEMPLO S/A',tipo:'ALIENAÇÃO FIDUCIÁRIA',contrato:'••••1234'},geral:false,renajud:false,roubo_furto:false,baixado:false},mensagens:['Dados fictícios para demonstrar o relatório.'],
      fontes_mev:{estadual:true,renainf:true},renainf_mev:{tipo_doc:'VEIC_RENAINF',placa:VEIC_EX_PLACA,quantidade:1,quantidade_total:1,alerta:'',ocorrencias:[
        {data:'21/10/2023',cadastro:'08/11/2023',codigo:'6050',descricao:'AVANÇAR SINAL VERMELHO DO SEMÁFORO OU DE PARADA OBRIGATÓRIA',orgao:'ÓRGÃO EXEMPLO',uf:'SP',local:'AVENIDA EXEMPLO · CIDADE EXEMPLO',auto:'RAAA1234',exigibilidade:'Sim',valor:293.47,pago:false}
      ]} };
    if(qual==='gravame') return { mev_exemplo:true, response:{
      placa:VEIC_EX_PLACA, uf:'SP', chassi:'9BWZZZ377VT004251',
      descricaostatus:'COM ALIENAÇÃO FIDUCIÁRIA', statusdoveiculo:'COM ALIENAÇÃO FIDUCIÁRIA',
      financeiranome:'BANCO EXEMPLO S/A (FICTÍCIO)', numerocontrato:'000123456789',
      datagravame:'10/02/2024',
      historico:[{ data:'10/02/2024', status:'02-INCLUSAO DE GRAVAME', agente:'BANCO EXEMPLO S/A (FICTÍCIO)' }] } };
    if(qual==='recall') return { mev_exemplo:true, tipo_doc:'VEIC_RECALL_COMBO',
      fontes:{recall:true,recall_v2:true,fipe:true},
      fipe_combo:{placa:VEIC_EX_PLACA,marca:'VOLKSWAGEN',modelo:'MODELO EXEMPLO 1.0',ano_modelo:'2021',valor_fipe:'R$ 63.480,00',codigo_fipe:'000000-0',mes_referencia:'outubro de 2026'},
      recall_placa:{response:{placa:VEIC_EX_PLACA,recalls:[{codigo_campanha:'EXEMPLO-001',descricao:'Componente de segurança — dado fictício para demonstrar o relatório.',risco:'Funcionamento irregular do componente.',reparo:'Inspeção e substituição gratuita quando necessária.',situacao:'PENDENTE',data_inicio:'15/04/2025'}]}},
      recall_v2:{response:{placa:VEIC_EX_PLACA,recalls:[]}} };
    if(qual==='multas') return { mev_exemplo:true, response:{
      placa:VEIC_EX_PLACA, uf:'SP',
      renainf:[
        { detalhe_cod_infracao:'6050 - AVANCAR SINAL VERMELHO DO SEMAFORO OU DE PARADA OBRIGATORIA',
          detalhe_valor_infracao:'293,47', detalhe_data_infracao:'12/03/2025',
          detalhe_orgao_autuador:'DER — ORGAO EXEMPLO', detalhe_uf_infracao:'SP',
          numero_auto:'AA00123456', exigibilidade:'Sim',
          dadosdopagamento_data:'', dadosdopagamento_valor:'' },
        { detalhe_cod_infracao:'7455 - TRANSITAR EM VELOCIDADE SUPERIOR A MAXIMA PERMITIDA EM ATE 20%',
          detalhe_valor_infracao:'130,16', detalhe_data_infracao:'02/11/2024',
          detalhe_orgao_autuador:'PRF — ORGAO EXEMPLO', detalhe_uf_infracao:'MG',
          numero_auto:'BB00998877', exigibilidade:'Sim',
          dadosdopagamento_data:'20/11/2024', dadosdopagamento_valor:'130,16' }
      ] } };
    return { mev_exemplo:true, response:{
      placa:VEIC_EX_PLACA, uf:'SP', chassi:'9BWZZZ32ZGP246344', municipio:'CIDADE EXEMPLO',
      marca:'MARCA EXEMPLO', modelo:'MODELO 1.0', cor:'PRATA', anomodelo:'2019',
      quantidade_de_bloqueio_ativo_localizado:'0',
      quantidade_de_ocorrencias_exibidas_e_disponivel_pelo_detran:'1',
      quantidade_de_ocorrencias_total_existente:'1',
      msg:'CONSTA BLOQUEIO RENAJUD / BLOQUEIO-ATIVO NADA CONSTA.',
      renajud:[{ nomeorgaojudicial:'TRIBUNAL EXEMPLO', numerodoprocesso:'1001234-56.2021.8.26.0100',
                 tiporestricjudicial:'TRANSFERENCIA', datadainclusao:'10/05/2021' }] } };
  }
  function veicExFaixa(){
    /* v774 (pedido, com print): a faixa amarela "Exemplo — dados fictícios /
       nenhuma consulta foi feita, nada foi cobrado" saiu da tela. A função
       fica (2 chamadores) devolvendo vazio — o aviso EXEMPLO continua dentro
       do PDF gerado e o botão "Ver exemplo" segue dizendo "dados fictícios".
       Pra faixa voltar, é só restaurar o HTML daqui. */
    return '';
  }
  /* ===== v760 (pedido do Angelo, 30/08, com print): "quando clicar em ver
     exemplo, já abre o pdf da autocorp" ====================================
     Nas páginas AutoCorp (Leilão + PT · Total Premium) o exemplo passa a ser
     o PDF DE VERDADE da AutoCorp: o servidor consulta a HOMOLOGAÇÃO (placa de
     exemplo, dados fictícios, sem custo), baixa o PDF dela e manda em base64
     — e o visor abre NA HORA. Sem custo, sem histórico, e o link externo da
     AutoCorp continua nunca chegando ao navegador. O PDF fica guardado em
     memória (a 2ª abertura é instantânea). Se o servidor não conseguir agora,
     cai na folha desenhada de sempre — exemplo nunca fica sem resposta. */
  var _acExCache={};
  function _acExNome(qual){
    return 'exemplo-'+(qual==='premium'?'total-premium':qual==='especialjud'?'leilao-especial-acoes-judiciais':'leilao-pt')+'.pdf';
  }
  async function autocorpAbrirExemplo(qual, P){
    var nome=_acExNome(qual);
    var blob=_acExCache[qual];
    var ex=$(P.ex);
    if(!blob){
      var _rot=''; if(ex){ _rot=ex.innerHTML; ex.disabled=true; var _tx=ex.querySelector('.cpf3-ex-tx b'); if(_tx) _tx.textContent='Abrindo o exemplo…'; }
      try{
        var d=await consultarComRetry({ produto:'autocorp_exemplo', qual:qual }, 1);
        if(d && d.ok && d.pdf_base64){
          var bin=atob(d.pdf_base64), arr=new Uint8Array(bin.length);
          for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
          if(bin.slice(0,5)==='%PDF-') blob=new Blob([arr],{ type:'application/pdf' });
        }
      }catch(_){ blob=null; }
      if(ex){ ex.disabled=false; if(_rot) ex.innerHTML=_rot; }
      if(blob) _acExCache[qual]=blob;
    }
    if(!blob) return false;   /* quem chamou cai na folha desenhada */
    var res=$('veicResult');
    if(res){
      res.innerHTML=veicExFaixa()
        +'<button type="button" id="veicExAbrir" style="width:100%;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:8px;background:#fff;color:#0a4da6;border:1.5px solid #bfdbfe;border-radius:11px;padding:12px;font-size:13.5px;font-weight:800;cursor:pointer;font-family:inherit">'+ICO_PDF+' Abrir o exemplo (PDF da AutoCorp)</button>';
      var ab=$('veicExAbrir'); if(ab) ab.onclick=function(){ pdfVisor(_acExCache[qual], nome); };
    }
    try{ pdfVisor(blob, nome); }catch(_){ return false; }
    return true;
  }
  async function veicVerExemplo(qual){
    qual=veicPagEsc(qual);
    var res=$('veicResult'); if(!res) return;
    /* v760: nas páginas AutoCorp o exemplo é o PDF da própria AutoCorp */
    var P=VEIC_PAGS[qual];
    if(P && P.autocorp){ if(await autocorpAbrirExemplo(qual, P)) return; res=$('veicResult'); if(!res) return; }
    var dd=veicExDados(qual);
    /* 🔴 o exemplo TAMBÉM vira o estado, pra o "Baixar em PDF" logo abaixo
       baixar o que está na tela. Ele não entra no histórico e não cobra. */
    _veicState={ qual:qual, placa:VEIC_EX_PLACA, dados:dd };
    var folha='';
    try{
      var cv=kitPrevia(veicPaginas(qual, dd, VEIC_EX_PLACA));
      folha='<div class="cpf3-folha"><img alt="Exemplo do relatório em PDF" src="'+cv.toDataURL('image/jpeg',0.9)+'"></div>';
    }catch(_){ folha=''; }
    res.innerHTML=veicExFaixa()
      +(folha||'<div class="plc-msg" style="color:#b45309">Não consegui desenhar a folha agora. Use o ícone de baixar no card do exemplo.</div>');
    /* v775: o botão "Baixar consulta (PDF)" SAIU daqui — o download do
       exemplo mora no ícone de baixar do próprio card (veicBaixarExemplo).
       Na consulta REAL o botão continua (gerarVeicConsulta). */
    try{ res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){}
  }
  /* v1021 — a landing abre o PDF diretamente, sem mandar o usuário primeiro
     para o formulário. AutoCorp tenta o demonstrativo oficial de homologação;
     se a fonte estiver fora, o mesmo gerador local garante a amostra. */
  async function veicAbrirExemploPdf(qual){
    qual=veicPagEsc(qual);
    var P=VEIC_PAGS[qual]; if(!P) return false;
    if(P.autocorp && await autocorpAbrirExemplo(qual,P)) return true;
    if(!_mevPdfPronto(function(){ veicAbrirExemploPdf(qual); },false)) return true;
    try{
      var dd=veicExDados(qual), blob=kitPdfBlob(veicPaginas(qual,dd,VEIC_EX_PLACA));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return false; }
      pdfVisor(blob,P.autocorp?_acExNome(qual):'exemplo-gravame.pdf');
      return true;
    }catch(_){ toast('Não consegui abrir o exemplo em PDF agora.'); return false; }
  }
  /* v775 — o ícone de BAIXAR do card do exemplo: baixa o PDF do exemplo
     direto, sem desenhar a folha na tela. Nas páginas AutoCorp tenta o PDF
     REAL de homologação (mesmo caminho/cache do autocorpAbrirExemplo); se
     não vier, cai no PDF desenhado com os dados fictícios de sempre. */
  async function veicBaixarExemplo(qual){
    qual=veicPagEsc(qual);
    var P=VEIC_PAGS[qual]; if(!P) return;
    if(P.autocorp){
      var nome=_acExNome(qual);
      var blob=_acExCache[qual];
      if(!blob){
        try{
          var d=await consultarComRetry({ produto:'autocorp_exemplo', qual:qual }, 1);
          if(d && d.ok && d.pdf_base64){
            var bin=atob(d.pdf_base64), arr=new Uint8Array(bin.length);
            for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
            if(bin.slice(0,5)==='%PDF-') blob=new Blob([arr],{ type:'application/pdf' });
          }
        }catch(_){ blob=null; }
        if(blob) _acExCache[qual]=blob;
      }
      if(blob){
        try{
          var u=URL.createObjectURL(blob), a=document.createElement('a');
          a.href=u; a.download=nome; document.body.appendChild(a); a.click();
          setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },800);
          toast('PDF baixado.'); return;
        }catch(_){}
      }
      /* sem o PDF real agora: cai no desenhado, como o visualizar faz */
    }
    _veicState={ qual:qual, placa:VEIC_EX_PLACA, dados:veicExDados(qual) };
    veicBaixarPDF();
  }
  /* a miniatura dentro do card É o gerador rodando (v603) */
  function veicMini(qual){
    try{
      var pags=veicPaginas(qual, veicExDados(qual), VEIC_EX_PLACA);
      var pg=pags&&pags[0]; if(!pg) return '';
      var W=112, H=142;
      var cv=document.createElement('canvas'); cv.width=W*2; cv.height=H*2;
      var g=cv.getContext('2d');
      g.fillStyle='#ffffff'; g.fillRect(0,0,cv.width,cv.height);
      var fator=cv.width/pg.width;
      var alturaFonte=Math.min(pg.height, Math.round(cv.height/fator));
      g.drawImage(pg, 0,0, pg.width, alturaFonte, 0,0, cv.width, cv.height);
      return cv.toDataURL('image/jpeg',0.82);
    }catch(_){ return ''; }
  }
  function veicMinisPintar(){
    try{
      Array.prototype.forEach.call(document.querySelectorAll('.cpf3-mini[data-exveic]'), function(el){
        if(el.getAttribute('data-ok')==='1') return;
        var u=veicMini(el.getAttribute('data-exveic'));
        if(!u) return;
        el.innerHTML='<img alt="Exemplo do relatório" src="'+u+'">';
        el.setAttribute('data-ok','1');
      });
    }catch(_){}
  }

  /* ==========================================================================
     v744 — AUTOCORP: LEILÃO + PT (51) e TOTAL PREMIUM (45)
     ==========================================================================
     O servidor (consultar.js → _autocorp.js) entrega o formato que o
     leilaoHistParse() do 04 já lê (dados_veiculo, leilao, analise_risco,
     sinistro) MAIS perda_total, restricoes, fontes — e, no Premium, estadual,
     roubo_furto, alertas, recall, localizador. Aqui só se desenha.
     Regra de ouro: bloco com fontes.X!=='ok' aparece como "não verificado",
     nunca como "nada consta".
     ========================================================================= */
  function _veicBtRotulo(P){
    return 'Consultar';
  }
  function debitosParse(dd){
    var b=_veicBase(dd)||{}, v=b.veiculo||{}, r=b.restricoes||{}, f=r.financiamento||{};
    function pend(k,nome){ var x=r[k]||{}; return { nome:nome, existe:x.existe===true?true:x.existe===false?false:null, valor:_veicTxt(x.valor), obs:_veicTxt(x.observacoes) }; }
    return { v:v, consultado:_veicTxt(b.consultado_em),
      pendencias:[pend('ipva','IPVA'),pend('multas','Multas'),pend('licenciamento','Licenciamento'),pend('dpvat','DPVAT')],
      financiamento:{ existe:f.existe===true?true:f.existe===false?false:null, agente:_veicTxt(f.agente), tipo:_veicTxt(f.tipo), contrato:_veicTxt(f.contrato), inclusao:_veicTxt(f.inclusao), vigencia:_veicTxt(f.vigencia) },
      geral:r.geral===true?true:r.geral===false?false:null,
      renajud:r.renajud===true?true:r.renajud===false?false:null,
      roubo_furto:r.roubo_furto===true?true:r.roubo_furto===false?false:null,
      baixado:r.baixado===true?true:r.baixado===false?false:null,
      mensagens:Array.isArray(b.mensagens)?b.mensagens:[],
      fontes:(b.fontes_mev&&typeof b.fontes_mev==='object')?b.fontes_mev:{estadual:true,renainf:false},
      renainf:(b.renainf_mev&&typeof b.renainf_mev==='object')?b.renainf_mev:null };
  }
  function _debitosEstado(v){ return v===true?'consta':v===false?'ok':'parcial'; }
  function debitosResumoDados(dd){
    var d=debitosParse(dd), todos=d.pendencias.map(function(x){return x.existe;}).concat([d.financiamento.existe,d.geral,d.renajud,d.roubo_furto,d.baixado]);
    var alerta=todos.some(function(x){return x===true;}), parcial=todos.some(function(x){return x===null;});
    return { d:d, tom:alerta?'erro':parcial?'atencao':'ok',
      titulo:alerta?'Atenção: há pendência ou restrição':parcial?'Consulta concluída parcialmente':'Nenhuma pendência informada',
      texto:alerta?'Confira os itens marcados antes de negociar.':parcial?'Alguns indicadores não foram informados pela fonte.':'Todos os indicadores respondidos vieram sem pendência.' };
  }
  function debitosResumoHtml(dd){
    var d=debitosParse(dd), itens=d.pendencias.map(function(x){
      var det=x.existe&&x.valor&&x.valor!=='0,00'?'R$ '+x.valor:'';
      return _acResumoItem(x.nome,_debitosEstado(x.existe),det);
    });
    itens.push(_acResumoItem('Alienação / financiamento',_debitosEstado(d.financiamento.existe),d.financiamento.existe?d.financiamento.agente:''));
    itens.push(_acResumoItem('RENAJUD',_debitosEstado(d.renajud)));
    itens.push(_acResumoItem('Roubo / furto',_debitosEstado(d.roubo_furto)));
    if(d.fontes.renainf&&d.renainf){
      var rm=renainfParse(d.renainf), abertas=rm.itens.filter(function(x){return !x.pago;}).length;
      itens.push(_acResumoItem('Multas detalhadas · RENAINF',abertas?'consta':'ok',
        rm.itens.length?(rm.itens.length+' ocorrência'+(rm.itens.length===1?'':'s')):'Nenhuma ocorrência encontrada'));
    }else itens.push(_acResumoItem('Multas detalhadas · RENAINF','parcial'));
    return '<section class="ac-resumo" aria-label="Resumo de débitos e restrições"><div class="ac-resumo-grid">'+itens.join('')+'</div></section>';
  }
  function debitosPanelHtml(dd, placa){
    var d=debitosParse(dd), f=d.financiamento, html=debitosResumoHtml(dd);
    var linhas='';
    d.pendencias.forEach(function(x){
      linhas+=_acLinhaSN(x.nome,x.existe===true,x.existe!==null,[x.valor&&x.valor!=='0,00'?('R$ '+x.valor):'',x.obs].filter(Boolean).join(' · '));
    });
    linhas+=_acLinhaSN('Alienação / financiamento',f.existe===true,f.existe!==null,[f.agente,f.tipo,f.contrato].filter(Boolean).join(' · '));
    linhas+=_acLinhaSN('Restrição geral',d.geral===true,d.geral!==null,'');
    linhas+=_acLinhaSN('RENAJUD',d.renajud===true,d.renajud!==null,'');
    linhas+=_acLinhaSN('Roubo / furto',d.roubo_furto===true,d.roubo_furto!==null,'');
    linhas+=_acLinhaSN('Veículo baixado',d.baixado===true,d.baixado!==null,'');
    html+=_acBloco('Situação estadual',linhas);
    if(d.fontes.renainf&&d.renainf){
      html+=_acBloco('Multas detalhadas · RENAINF',renainfPanelHtml(d.renainf,placa,true));
    }else{
      html+=_acBloco('Multas detalhadas · RENAINF',_acLinhaSN('Detalhamento das infrações',false,false,''));
    }
    if(d.mensagens.length) html+=_acBloco('Informações da fonte',d.mensagens.map(function(m){return '<div class="plc-msg">'+esc(m)+'</div>';}).join(''));
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:8px">Fontes: Base Estadual + RENAINF · placa '+esc((d.v.placa||placa||'').toUpperCase())+(d.consultado?' · atualização '+esc(d.consultado):'')+'. Dados pessoais do proprietário e do condutor foram omitidos.</div>';
    return html;
  }
  function _pgDebitos(st,dd,placa){
    var d=debitosParse(dd), avisos=[];
    d.pendencias.forEach(function(x){ avisos.push({nv:x.existe===true?'no':x.existe===false?'ok':'at',t:x.nome+': '+(x.existe===true?'CONSTA'+(x.valor&&x.valor!=='0,00'?' · R$ '+x.valor:''):x.existe===false?'NADA CONSTA':'NÃO VERIFICADO')}); });
    avisos.push({nv:d.financiamento.existe===true?'no':d.financiamento.existe===false?'ok':'at',t:'ALIENAÇÃO / FINANCIAMENTO: '+(d.financiamento.existe===true?'CONSTA':d.financiamento.existe===false?'NADA CONSTA':'NÃO VERIFICADO')});
    kitAvisos(st,'Débitos e restrições',avisos);
    kitKv2(st,'Restrições adicionais',[
      ['Restrição geral',d.geral===true?'CONSTA':d.geral===false?'Nada consta':'Não verificado'],
      ['RENAJUD',d.renajud===true?'CONSTA':d.renajud===false?'Nada consta':'Não verificado'],
      ['Roubo / furto',d.roubo_furto===true?'CONSTA':d.roubo_furto===false?'Nada consta':'Não verificado'],
      ['Veículo baixado',d.baixado===true?'SIM':d.baixado===false?'Não':'Não verificado'],
      ['Agente financeiro',d.financiamento.agente],['Contrato',d.financiamento.contrato],['Atualização da fonte',d.consultado]
    ]);
    if(d.fontes.renainf&&d.renainf) _pgMultas(st,d.renainf,placa,true);
    else kitAtencao(st,'O detalhamento das multas no RENAINF não respondeu nesta consulta.');
    if(d.mensagens.length) kitLista(st,'Informações da fonte',d.mensagens);
  }
  function _debitosComoEstadual(dd){
    var d=debitosParse(dd);
    return { ok:d.fontes.estadual!==false, pendencias:d.pendencias.map(function(x){return {nome:x.nome,existe:x.existe,valor:x.valor,observacoes:x.obs};}),
      financiamento:d.financiamento, restricao_geral:d.geral, renajud:d.renajud, roubo_furto:d.roubo_furto,
      baixado:d.baixado, mensagens:d.mensagens, situacao:d.v.situacao,
      fontes:d.fontes, renainf:d.renainf };
  }
  function _acOk(f, k){ return !!(f && f[k]==='ok'); }
  function autocorpParse(dd){
    var b=_veicBase(dd);
    var p; try{ p=leilaoHistParse(b); }catch(_){ p={ passou:false, qtd:0, regs:[], dados:[], parecer:'', indice:'', sinistro:{existe:false,descricao:''} }; }
    var f=b.fontes||{};
    var pt=b.perda_total||{}, rs=b.restricoes||{}, es=b.estadual||null, rf=b.roubo_furto||null, al=b.alertas||null, rc=b.recall||null, la=b.localizador||null;
    if(b.estadual_mev) es=_debitosComoEstadual(b.estadual_mev);
    var sc=(b.analise_risco||{});
    return {
      p:p, f:f, homolog:String(b.ambiente||'')==='homologacao',
      especial:String(b.produto||'')==='1301', premium:String(b.produto||'')==='45' || String(b.produto||'')==='1301',
      leilaoOk:_acOk(f,'leilao'), sinOk:_acOk(f,'indicio_sinistro'), ptOk:_acOk(f,'perda_total'), agOk:_acOk(f,'agregados'),
      pt:{ existe:!!pt.existe, data:_veicTxt(pt.data), msg:_veicTxt(pt.mensagem) },
      restr:(rs.mensagens||[]).map(function(m){ return String(m||''); }).filter(Boolean),
      score:{ nota:_veicTxt(sc.indicerisco), desc:_veicTxt(sc.descricaoretorno) },
      es:es, rf:rf, al:al, rc:rc, la:la,
      ident:{ placa:_veicTxt((b.dados_veiculo||{}).placa), uf:_veicTxt((b.dados_veiculo||{}).uf), chassi:_veicChassi((b.dados_veiculo||{}).chassi) }
    };
  }
  function _acFaixaHomolog(){
    return '<div style="display:flex;align-items:center;gap:8px;background:#fef3c7;border:1px solid #fde68a;border-left:6px solid #f59e0b;border-radius:12px;padding:10px 13px;margin:4px 0 10px">'
      +'<b style="color:#92400e;font-size:13px">Homologação AutoCorp</b>'
      +'<span style="color:#b45309;font-size:11.5px">resposta gravada de placa de exemplo · sem custo</span></div>';
  }
  function _acLinhaSN(rot, existe, ok, detalhe){
    var v = !ok ? 'não verificado' : (existe ? 'CONSTA' : 'nada consta');
    var cor = !ok ? '#b45309' : (existe ? '#b91c1c' : '#15803d');
    return '<div style="display:flex;gap:10px;justify-content:space-between;padding:9px 0;border-bottom:1px solid #eef2f7">'
      +'<span style="font-size:12.5px;color:#64748b">'+esc(rot)+'</span>'
      +'<span style="font-size:13px;font-weight:800;color:'+cor+';text-align:right">'+esc(v)+(detalhe?(' <span style="font-weight:600;color:#475569">· '+esc(detalhe)+'</span>'):'')+'</span></div>';
  }
  function _acBloco(titulo, corpo){
    return '<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:14px 2px 7px">'+esc(titulo)+'</div>'
      +'<div style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:4px 14px;box-shadow:0 3px 12px rgba(2,20,60,.05)">'+corpo+'</div>';
  }
  function autocorpPanelHtml(qual, dd, placa, ts){
    var a=autocorpParse(dd), p=a.p;
    var html='';
    html+='<div style="font-size:12px;color:#64748b;margin:2px 0 4px">Placa consultada: <b>'+esc(a.ident.placa||placa||'')+'</b></div>';
    /* 1. LEILÃO — o produto 1301 não devolve um bloco LEILAO separado. */
    if(!a.especial){
      if(!a.leilaoOk) html+=_veicVeredito('mid','Leilão não verificado','A base de leilão não respondeu nesta consulta.');
      else if(p.passou) html+=_veicVeredito('no','Veículo com registro de leilão', p.qtd+' ocorrência(s) de leilão. Investigue a origem antes de comprar.');
      else html+=_veicVeredito('ok','Sem registro de leilão','Nenhuma passagem por leilão nas bases consultadas.');
    }
    /* 2. SINISTRO + PERDA TOTAL */
    if(!a.sinOk) html+=_veicVeredito('mid','Indício de sinistro não verificado','');
    else if(p.sinistro&&p.sinistro.existe) html+=_veicVeredito('no','Consta indício de sinistro', p.sinistro.descricao||'Peça a vistoria cautelar antes de fechar negócio.');
    else html+=_veicVeredito('ok','Sinistro: nada consta','');
    if(!a.ptOk) html+=_veicVeredito('mid','Perda total não verificada','A base de perda total não respondeu nesta consulta.');
    else if(a.pt.existe) html+=_veicVeredito('no','Perda total REGISTRADA'+(a.pt.data?(' em '+a.pt.data):''), a.pt.msg||'Indenização integral por seguradora.');
    else html+=_veicVeredito('ok','Perda total: nada consta', a.pt.msg||'');
    /* 3. SCORE */
    if(!a.especial&&(a.score.nota||a.score.desc)){
      html+=_acBloco('Score do veículo', _veicLinha('Pontuação', a.score.nota)+_veicLinha('Descrição', a.score.desc));
    }
    /* v1402 — o bloco estadual permanece legível apenas em relatórios antigos
       já salvos. Novas consultas Leilão + PT usam somente a AutoCorp. */
    if(a.es){
      var es=a.es||{ ok:false, pendencias:[], financiamento:{}, mensagens:[] };
      var corpo='';
      (es.pendencias||[]).forEach(function(pe){ corpo+=_acLinhaSN(pe.nome, pe.existe===true, !!es.ok&&pe.existe!==null, pe.valor?('R$ '+pe.valor):''); });
      corpo+=_acLinhaSN('Roubo / furto (restrição)', es.roubo_furto===true, !!es.ok&&es.roubo_furto!==null, '');
      corpo+=_acLinhaSN('RENAJUD', es.renajud===true, !!es.ok&&es.renajud!==null, '');
      corpo+=_acLinhaSN('Financiamento', !!(es.financiamento&&es.financiamento.existe===true), !!es.ok&&!!es.financiamento&&es.financiamento.existe!==null, (es.financiamento&&es.financiamento.agente)||'');
      corpo+=_acLinhaSN('Veículo baixado', es.baixado===true, !!es.ok&&es.baixado!==null, '');
      if(es.situacao) corpo+=_veicLinha('Situação', es.situacao);
      if((es.mensagens||[]).length) corpo+='<div style="padding:8px 0;font-size:12.5px;color:#7f1d1d">'+es.mensagens.map(function(m){ return '• '+esc(m); }).join('<br>')+'</div>';
      html+=_acBloco('Situação estadual'+(es.ok?'':' — não verificada'), corpo);
      if(es.fontes&&es.fontes.renainf&&es.renainf){
        html+=_acBloco('Multas detalhadas · RENAINF',renainfPanelHtml(es.renainf,placa,true));
      }else html+=_acBloco('Multas detalhadas · RENAINF',_acLinhaSN('Detalhamento das infrações',false,false,''));
    }
    /* Os complementos abaixo continuam exclusivos dos produtos Premium. */
    if(a.premium){
      var rf=a.rf||{ ok:false }, rc=a.rc||{ ok:false }, al=a.al||{ ok:false }, la=a.la||{ ok:false };
      var corpoExtra=_acLinhaSN('Declaração de roubo/furto', !!rf.declaracao, rf.ok, rf.recuperacao?'houve recuperação':'')
        +_acLinhaSN('Alertas gerais', (al.qtd||0)>0, al.ok, al.qtd?(al.qtd+' ocorrência(s)'):'');
      if(!a.especial) corpoExtra+=_acLinhaSN('Recall', !!rc.indicativo, rc.ok, rc.situacao||'')
        +_acLinhaSN('Localizador de agregados', (la.qtd||0)>0, la.ok, la.qtd?(la.qtd+' registro(s)'):'');
      html+=_acBloco(a.especial?'Roubo/furto · alertas':'Roubo/furto · recall · alertas',corpoExtra);
    }
    /* 5. RESTRIÇÕES (agregados) */
    if(!a.especial&&a.restr.length){
      html+=_acBloco('Restrições nos agregados', a.restr.map(function(m){ return '<div style="padding:8px 0;border-bottom:1px solid #eef2f7;font-size:13px;font-weight:700;color:#b91c1c">'+esc(m)+'</div>'; }).join(''));
    }
    /* 6. REGISTROS DE LEILÃO */
    if(!a.especial&&p.regs&&p.regs.length){
      html+='<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:14px 2px 7px">Registros de leilão ('+p.regs.length+')</div>';
      html+=p.regs.map(function(r,i){
        var al=_lhAlerta(r.condicao)||_lhAlerta(r.chassiSit);
        var nc=function(v){ return /^(nc|n\/c)$/i.test(String(v||'').trim())?'':v; };   /* "NC" da AutoCorp = não consta */
        var linhas=[ r.data?['Data',r.data]:null, nc(r.patio)?['Pátio',r.patio]:null, nc(r.leiloeiro)?['Leiloeiro',r.leiloeiro]:null, nc(r.comitente)?['Comitente',r.comitente]:null, r.condicao?['Condição',r.condicao]:null, r.chassiSit?['Chassi',r.chassiSit]:null, (r.lote&&r.lote!=='0')?['Lote',r.lote]:null ].filter(Boolean);
        return '<div style="background:#fff;border:1px solid '+(al?'#fecaca':'#e8eef7')+';border-left:5px solid '+(al?'#dc2626':'#0a4da6')+';border-radius:12px;padding:10px 14px;margin-bottom:8px">'
          +'<div style="font-weight:800;color:#0f172a;font-size:14px;margin-bottom:4px">Registro '+(i+1)+'</div>'
          +linhas.map(function(kv){ return '<div style="display:flex;justify-content:space-between;gap:10px;padding:3px 0"><span style="font-size:12.5px;color:#94a3b8;font-weight:600">'+esc(kv[0])+'</span><span style="font-size:13px;font-weight:700;color:#0f172a;text-align:right;max-width:62%">'+esc(kv[1])+'</span></div>'; }).join('')
          +'</div>';
      }).join('');
    }
    /* 7. DADOS DO VEÍCULO */
    var dvRows=(p.dados||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); });
    if(dvRows.length) html+=_acBloco('Dados do veículo', dvRows.map(function(r){ return _veicLinha(r[0], r[1]); }).join(''));
    if(!a.especial&&p.parecer) html+='<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:14px;padding:12px 14px;margin-top:14px"><div style="font-size:11px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px">Resumo</div><div style="font-size:13.5px;font-weight:700;color:#0f172a;margin-top:3px;line-height:1.4">'+esc(p.parecer)+'</div></div>';
    html+='<div style="font-size:11px;color:#94a3b8;margin-top:9px">Fonte: '+esc(a.es&&!a.premium?'AutoCorp + Base Estadual + RENAINF':'AutoCorp')+' · produto '+esc(a.especial?'1301 Leilão Especial Plus + Ações Judiciais':a.premium?'45 Total Premium':'51 Leilão + PT')+' · gerado em '+esc(histData(ts||Date.now()))+'</div>';
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:5px">Dados informados pelas bases consultadas na data da geração. Uso restrito à avaliação de procedência do veículo (LGPD).</div>';
    return html;
  }

  /* Resultado de decisão rápida. O laudo integral continua no PDF original;
     a página não repete dezenas de campos que empurravam o documento e os
     alertas para baixo da barra fixa. */
  function _acEstadoIcone(estado){
    if(estado==='consta') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.6 2.5 17a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>';
    if(estado==='ok') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.7 2.7L16.5 9"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 17h.01"/></svg>';
  }
  function _acResumoItem(rotulo, estado, detalhe){
    var classe=estado==='consta'?'is-alerta':estado==='ok'?'is-ok':'is-parcial';
    var texto=estado==='consta'?'Consta':estado==='ok'?'Nada consta':'Não verificado';
    return '<div class="ac-resumo-item '+classe+'"><span class="ac-resumo-item-icone">'+_acEstadoIcone(estado)+'</span><div class="ac-resumo-item-tx"><span>'+esc(rotulo)+'</span><b>'+esc(detalhe||texto)+'</b></div></div>';
  }
  function autocorpResumoDados(qual, dd, placa){
    var a=autocorpParse(dd), p=a.p, itens=[], alerta=false, parcial=false;
    function st(ok, existe){ if(!ok){ parcial=true; return 'parcial'; } if(existe){ alerta=true; return 'consta'; } return 'ok'; }
    if(!a.especial) itens.push(_acResumoItem('Leilão',st(a.leilaoOk,!!p.passou),p.passou&&p.qtd?(p.qtd+' ocorrência'+(p.qtd===1?'':'s')):''));
    itens.push(_acResumoItem('Indício de sinistro',st(a.sinOk,!!(p.sinistro&&p.sinistro.existe))));
    itens.push(_acResumoItem('Perda total',st(a.ptOk,!!a.pt.existe)));
    if(!a.especial) itens.push(_acResumoItem('Agregados',st(a.agOk,a.restr.length>0),a.agOk&&!a.restr.length?'Verificados':''));
    if(a.es){
      var es=a.es||{}, pend=(es.pendencias||[]).some(function(x){ return !!x.existe; });
      var esAlerta=pend||!!es.roubo_furto||!!es.renajud||!!es.baixado||!!(es.financiamento&&es.financiamento.existe);
      var esCompleto=(es.pendencias||[]).every(function(x){return x.existe!==null;})&&
        es.roubo_furto!==null&&es.renajud!==null&&es.baixado!==null&&!!es.financiamento&&es.financiamento.existe!==null;
      itens.push(_acResumoItem('Situação estadual',st(!!es.ok&&esCompleto,esAlerta)));
    }
    if(a.premium){
      itens.push(_acResumoItem('Roubo / furto',st(!!(a.rf&&a.rf.ok),!!(a.rf&&a.rf.declaracao))));
      if(!a.especial) itens.push(_acResumoItem('Recall',st(!!(a.rc&&a.rc.ok),!!(a.rc&&a.rc.indicativo))));
      itens.push(_acResumoItem('Alertas gerais',st(!!(a.al&&a.al.ok),!!(a.al&&Number(a.al.qtd)>0)),a.al&&Number(a.al.qtd)>0?(Number(a.al.qtd)+' ocorrência'+(Number(a.al.qtd)===1?'':'s')):''));
    }
    return { a:a, itens:itens, tom:alerta?'erro':parcial?'atencao':'ok',
      titulo:alerta?'Atenção: há ocorrência para analisar':parcial?'Consulta concluída parcialmente':'Nenhuma ocorrência encontrada',
      texto:alerta?'Confira os blocos destacados antes de tomar uma decisão.':parcial?'Algumas bases não responderam; os demais dados continuam disponíveis.':'As verificações respondidas não apontaram ocorrências.' };
  }
  function autocorpResumoHtml(qual, dd, placa){
    var r=autocorpResumoDados(qual,dd,placa), a=r.a;
    return (a.homolog?_acFaixaHomolog():'')
      +'<section class="ac-resumo" aria-label="Resumo da consulta AutoCorp">'
      +'<div class="ac-resumo-grid">'+r.itens.join('')+'</div>'
      +'</section>';
  }
  /* v749 — o PDF da PRÓPRIA AutoCorp (pedido do Angelo: "aproveitar o PDF da
     AutoCorp em vez de montar um novo"). O servidor guardou o arquivo no
     cofre privado e mandou só a referência (pdf_ref); o download pede a URL
     assinada pela /api/arquivo-privado (_arqPrivadoBaixar, do 13). Quando
     a AutoCorp não mandou PDF, fica a folha da casa. */
  function autocorpPdfRef(dd){ try{ var b=_veicBase(dd); return String(b.pdf_ref||'').indexOf('private://')===0?String(b.pdf_ref):''; }catch(_){ return ''; } }
  /* v936 — um único documento: original privado quando existe; folha MEV
     quando a AutoCorp não entregou o arquivo a tempo. A indisponibilidade
     técnica não vira um segundo card nem expõe detalhe interno na tela. */
  /* v1022 — uma única ação para o documento da consulta. "Baixar PDF" tenta
     recuperar e abrir o laudo oficial pelo protocolo já pago. Essa porta não
     repete a consulta e não debita saldo. Se o fornecedor não entregar o
     arquivo, o visualizador abre a folha MEV com os mesmos dados da tela. */
  function autocorpRelatorioCombinado(qual, dd){
    if(qual!=='leilaopt') return false;
    try{ return Object.prototype.hasOwnProperty.call(_veicBase(dd),'estadual_mev'); }catch(_){ return false; }
  }
  function autocorpBotoesPdfHtml(qual, dd, protocolo){
    var acoes=consultaResultadoAcoes([
      { id:'veicPdfVer', rotulo:'Visualizar PDF', icone:'ver', primaria:true, somenteIcone:true },
      { id:'veicPdfBaixar', rotulo:'Baixar PDF', icone:'baixar', somenteIcone:true },
      { id:'veicPdfCompartilhar', rotulo:'Compartilhar PDF', icone:'compartilhar', somenteIcone:true }
    ]);
    if(!autocorpRelatorioCombinado(qual,dd)) return acoes+'<p class="consulta-pdf-status" role="status" aria-live="polite" hidden></p>';
    return '<div class="consulta-documento-opcao is-principal" role="group" aria-label="Relatório completo MEV">'
      +'<div class="consulta-documento-opcao-tx"><strong>Relatório completo MEV</strong><span>Leilão, perda total, débitos, alienação e multas RENAINF.</span></div>'
      +acoes+'</div>'
      +'<div class="consulta-documento-opcao" role="group" aria-label="Laudo original AutoCorp">'
      +'<div class="consulta-documento-opcao-tx"><strong>Laudo original AutoCorp</strong><span>Documento do fornecedor com os dados de leilão e perda total.</span></div>'
      +consultaResultadoAcoes([{ id:'veicPdfAutoCorp', rotulo:'Visualizar laudo original', icone:'ver' }])+'</div>'
      +'<p class="consulta-pdf-status" role="status" aria-live="polite" hidden></p>';
  }
  /* O PDF alternativo é montado no navegador e pode ocupar a thread principal.
     Dois frames dão tempo para o estado de carregamento aparecer antes disso. */
  function autocorpPdfLiberarPintura(){
    return new Promise(function(resolve){
      var raf=window.requestAnimationFrame||function(fn){ return setTimeout(fn,16); };
      raf(function(){ raf(resolve); });
    });
  }
  async function autocorpPdfOriginalAbrir(ref, nome, modo){
    var url=await _arqPrivadoUrl(ref);
    if(!url) throw new Error('url');
    var r=await fetch(url); if(!r.ok) throw new Error('download');
    var blob=await r.blob(), ab=await blob.slice(0,5).arrayBuffer();
    var ini=String.fromCharCode.apply(null,new Uint8Array(ab));
    if(ini!=='%PDF-') throw new Error('pdf');
    if(blob.type!=='application/pdf') blob=new Blob([blob],{type:'application/pdf'});
    pdfArquivoAcao(blob,nome,modo||'visualizar',function(){ pdfVisor(blob,nome); },'Laudo da consulta'); return true;
  }
  function autocorpPdfAppAbrir(modo){
    if(!_veicState) return false;
    if(!_mevPdfPronto(function(){ autocorpPdfAppAbrir(modo); },false)) return true;
    try{
      var blob=kitPdfBlob(veicPaginas(_veicState.qual,_veicState.dados,_veicState.placa));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return false; }
      var nome='consulta-'+_veicState.qual+'-'+String(_veicState.placa||'').toLowerCase()+'.pdf';
      pdfArquivoAcao(blob,nome,modo||'visualizar',function(){ pdfVisor(blob,nome); },'Consulta '+String(_veicState.placa||''));
      return true;
    }catch(_){ toast('Não consegui gerar o PDF agora.'); return false; }
  }
  function autocorpPdfLigar(root, qual, dd, placa, protocolo){
    try{
      var nome='autocorp-'+String(placa||'consulta').toLowerCase()+'.pdf';
      var combinado=autocorpRelatorioCombinado(qual,dd);
      async function abrirOficial(status, modo){
        var ref=autocorpPdfRef(dd);
        if(!ref && protocolo){
          if(status) status.textContent='Buscando o laudo original da AutoCorp…';
          var r=await apiComTimeout('/api/consultar',{ produto:'veic_laudo', protocolo:String(protocolo) },120000);
          if(r&&r.ok&&r.pdf_ref){
            ref=String(r.pdf_ref);
            try{ _veicBase(dd).pdf_ref=ref; }catch(_){}
            try{ acHistMarcarPdf(protocolo,ref); }catch(_){}
          }
        }
        if(!ref) return false;
        if(status) status.textContent='Abrindo o laudo original da AutoCorp…';
        return autocorpPdfOriginalAbrir(ref,nome,modo||'visualizar');
      }
      var botoes=[['#veicPdfVer','visualizar'],['#veicPdfBaixar','baixar'],['#veicPdfCompartilhar','compartilhar']];
      botoes.forEach(function(par){
       var pb=(root||document).querySelector(par[0]); if(!pb) return;
       pb.onclick=async function(){
        var modo=par[1];
        var status=(root||document).querySelector('.consulta-pdf-status');
        var demora=null;
        pb.disabled=true; pb.setAttribute('aria-busy','true');
        if(status){
          status.hidden=false;
          status.textContent=modo==='visualizar'?'Preparando a visualização do relatório…':'Preparando o relatório…';
        }
        demora=setTimeout(function(){
          if(status&&!status.hidden) status.textContent='Ainda preparando o relatório. Só mais um momento…';
        },6000);
        try{
          await autocorpPdfLiberarPintura();
          if(combinado){
            if(status) status.textContent='Montando o relatório completo MEV…';
            await autocorpPdfLiberarPintura();
            autocorpPdfAppAbrir(modo);
            return;
          }
          var oficial=await abrirOficial(status,modo);
          if(!oficial){
            if(status) status.textContent='Montando o relatório MEV…';
            await autocorpPdfLiberarPintura();
            autocorpPdfAppAbrir(modo);
            toast('Laudo oficial indisponível. Abrimos o PDF do app.');
          }
        }catch(_){
          if(status) status.textContent='Não foi possível abrir o relatório agora.';
          toast('Não consegui abrir o PDF agora. Tente novamente.');
        }finally{
          clearTimeout(demora);
          if(document.body.contains(pb)){ pb.disabled=false; pb.removeAttribute('aria-busy'); }
          if(status) status.hidden=true;
        }
      };
      });
      var original=(root||document).querySelector('#veicPdfAutoCorp');
      if(original) original.onclick=async function(){
        var status=(root||document).querySelector('.consulta-pdf-status'), demora=null;
        original.disabled=true; original.setAttribute('aria-busy','true');
        if(status){ status.hidden=false; status.textContent='Preparando o laudo original da AutoCorp…'; }
        demora=setTimeout(function(){ if(status&&!status.hidden) status.textContent='Ainda buscando o laudo original. Só mais um momento…'; },6000);
        try{
          await autocorpPdfLiberarPintura();
          var abriu=await abrirOficial(status,'visualizar');
          if(!abriu){
            if(status) status.textContent='Laudo original indisponível no momento.';
            toast('O laudo original da AutoCorp ainda não está disponível.');
          }
        }catch(_){
          if(status) status.textContent='Não foi possível abrir o laudo original agora.';
          toast('Não consegui abrir o laudo original agora. Tente novamente.');
        }finally{
          clearTimeout(demora);
          if(document.body.contains(original)){ original.disabled=false; original.removeAttribute('aria-busy'); }
          if(status) status.hidden=true;
        }
      };
    }catch(_){}
  }
  /* a folha em PDF — mesmo kit do 06b, mesma fonte de dados da tela */
  /* ==========================================================================
     🔴 03/09/2026 (pedido do Angelo) — O NOSSO PDF NO FORMATO DO LAUDO DELES
     --------------------------------------------------------------------------
     "REPLIQUE O MESMO FORMATO DA AUTOCORP NO NOSSO PDF, MASCARE O CHASSI,
      MOSTRE OS ULTIMOS SEIS DIGITOS, QUANDO FALHAR O DELES APARECE O NOSSO
      NO MESMO FORMATO"

     POR QUE ISSO IMPORTA: quando o PDF da AutoCorp chega, é ele que o lojista
     manda pro cliente. Quando não chega — e em 03/09 não chegou — o cliente
     recebia um documento com OUTRA cara. Duas caras pro mesmo produto é o
     tipo de coisa que faz o comprador desconfiar do laudo inteiro.

     A ORDEM DAS SEÇÕES É A DELES, com os mesmos nomes:
       DADOS DA CONSULTA · QUADRO DE AVISOS · RESUMO DO VEÍCULO · AGREGADOS ·
       DADOS DOS LEILÕES REALIZADOS · PERDA TOTAL · INDÍCIO DE SINISTRO ·
       INFORMAÇÕES IMPORTANTES

     ⚠️ DUAS COISAS QUE NÃO SÃO CÓPIA, E SÃO DE PROPÓSITO:

     1. O CHASSI VAI MASCARADO — só os 6 últimos, pela `kitChassiMask`, que é
        a régua da casa desde a v597 e já valia em todos os outros PDFs. O
        laudo deles mostra o chassi inteiro; o nosso não vai mostrar. Um laudo
        circula por WhatsApp e o chassi inteiro é o que se usa pra clonar
        placa. Os 6 últimos bastam pra conferir contra o documento na mão.

     2. NÃO EXISTE "Nº DA CONSULTA" AQUI. O laudo deles traz o protocolo; o
        nosso não pode — o `protocolo` fica no servidor de propósito e o
        teste-v732 defende isso ("o protocolo fica fora de `dados`"). Pôr na
        tela seria expor o número de contestação da conta do Angelo com o
        fornecedor no documento que vai pro cliente.
     ========================================================================== */
  function _acTipoTitulo(a){
    return a.especial ? '1301 - LEILÃO ESPECIAL PLUS + AÇÕES JUDICIAIS'
      : a.premium ? '45 - TOTAL PREMIUM (COMPLETA PLUS)' : '51 - LEILAO + PT (CONSULTA BASICA)';
  }
  /* os 12 itens que a consulta de leilão cobre — a mesma lista do laudo deles.
     ⚠️ É TEXTO, NÃO CHECKBOX VERDE. No laudo deles cada linha vem com um ✓,
     o que dá a entender que cada item foi verificado E passou. Nem sempre é
     verdade (quando ACHA leilão, os mesmos ✓ continuam lá). Aqui a lista diz
     o que a consulta COBRE; quem diz o resultado é o quadro de avisos. */
  var _AC_ITENS_LEILAO = [
    'Classificação de avaria', 'Leilões presenciais',
    'Classificação para aceite securitário', 'Leilões on-line',
    'Classificação de probabilidade de vistoria', 'Leilões judiciais',
    'Sinistro de pequena monta', 'Leilões de seguradoras',
    'Sinistro de média monta', 'Leilões de bancos e financeiras',
    'Sinistro de grande monta', 'Leilões de empresas'
  ];
  var _AC_LEGAL =
    'ESTAS INFORMAÇÕES SÃO CONFIDENCIAIS E DEVERÃO SER UTILIZADAS, ÚNICA E EXCLUSIVAMENTE, PARA '+
    'ORIENTAÇÃO DAS TRANSAÇÕES COMERCIAIS DO USUÁRIO, RESPONSABILIZANDO-SE CIVIL E CRIMINALMENTE '+
    'POR DANOS QUE OCASIONAR A TERCEIROS, QUANDO UTILIZADAS EM DESACORDO COM A LEGISLAÇÃO EM VIGOR.';
  var _AC_ATENCAO_SINISTRO =
    'As informações de Indício de Sinistro são oriundas de terceiros tais como seguradoras, lojas de '+
    'salvados e órgãos oficiais. Podem, em alguns casos, ser restritas do informante sem divulgação. '+
    'Oriente-se a conciliar esta consulta com a checagem física do veículo.';

  function _pgAutocorp(st, qual, dd, placa){
    var a=autocorpParse(dd), p=a.p;
    var b=_veicBase(dd);
    var dv=(b.dados_veiculo||{}), ag=(b.agregados_ficha||{});
    var pl=(a.ident.placa||placa||'').toUpperCase();

    if(a.homolog) kitAtencao(st,'HOMOLOGAÇÃO AutoCorp — resposta gravada de placa de exemplo. Não é uma consulta real.');

    /* ---------- 1. DADOS DA CONSULTA ---------- */
    kitKv2(st,'Dados da consulta',[
      ['Tipo de consulta', _acTipoTitulo(a)],
      ['Dados utilizados', 'PLACA: '+pl],
      ['Data | hora', st.geradoEm||''],
      ['Fonte', a.es&&!a.premium?'AutoCorp + Base Estadual + RENAINF':'AutoCorp']
    ]);

    /* ---------- 2. QUADRO DE AVISOS ---------- */
    var sinExiste=!!(p.sinistro&&p.sinistro.existe);
    var avisos=[
      { nv:(!a.ptOk?'at':(a.pt.existe?'no':'ok')),
        t:(!a.ptOk?'PERDA TOTAL: NÃO VERIFICADA':(a.pt.existe?'EXISTE OCORRÊNCIA DE PERDA TOTAL':'NÃO EXISTE OCORRÊNCIA DE PERDA TOTAL')) },
      { nv:(!a.sinOk?'at':(sinExiste?'no':'ok')),
        t:(!a.sinOk?'INDÍCIO DE SINISTRO: NÃO VERIFICADO':(sinExiste?'INDÍCIO DE SINISTRO: CONSTA':'INDÍCIO DE SINISTRO: NADA CONSTA')) }
    ];
    if(!a.especial) avisos.splice(1,0,
      { nv:(!a.leilaoOk?'at':(p.passou?'no':'ok')),
        t:(!a.leilaoOk?'LEILÃO: NÃO VERIFICADO':(p.passou?('LEILÃO: '+p.qtd+' OCORRÊNCIA(S)'):'LEILÃO: NADA CONSTA')) });
    if(!a.especial) avisos.push(
      { nv:(!a.agOk?'at':(a.restr.length?'no':'ok')),
        t:(!a.agOk?'AGREGADOS: NÃO VERIFICADOS':(a.restr.length?('CONSTAM '+a.restr.length+' RESTRIÇÃO(ÕES)'):'NÃO CONSTAM OCORRÊNCIAS')) });
    kitAvisos(st,'Quadro de avisos',avisos);

    /* ---------- 3. RESUMO DO VEÍCULO ---------- */
    kitKv2(st,'Resumo do veículo',[
      ['Marca/modelo', _veicTxt(dv.marcamodelo)],
      ['Placa', pl],
      ['Ano fabr./modelo', _veicTxt(dv.anofabricacaomodelo)],
      ['Chassi', dv.chassi?kitChassiMask(String(dv.chassi)):''],
      ['Cor', _veicTxt(dv.cor)],
      ['N. motor', _veicTxt(ag.motor)],
      ['Combustível', _veicTxt(dv.combustivel)],
      ['Município / UF', [_veicTxt(dv.municipio), _veicTxt(dv.uf)].filter(Boolean).join(' / ')]
    ]);

    /* ---------- 4. AGREGADOS (não faz parte do produto 1301) ---------- */
    if(!a.especial){
      kitKv2(st,'Agregados'+(a.agOk?'':' (não verificados)'),[
      ['Tipo de veículo', _veicTxt(ag.tipo_veiculo)],   ['Espécie', _veicTxt(ag.especie)],
      ['Categoria', _veicTxt(ag.categoria)],            ['Carroceria', _veicTxt(ag.carroceria)],
      ['Câmbio', _veicTxt(ag.cambio)],                  ['Cilindrada', _veicTxt(ag.cilindrada)],
      ['Potência', _veicTxt(ag.potencia)],              ['PBT', _veicTxt(ag.pbt)],
      ['CMT', _veicTxt(ag.cmt)],                        ['Capacidade de carga', _veicTxt(ag.capacidade_carga)],
      ['Passageiros', _veicTxt(ag.passageiros)],        ['Eixos', _veicTxt(ag.eixos)],
      ['Procedência', _veicTxt(ag.procedencia)],        ['Situação do chassi', _veicTxt(ag.situacao_chassi)],
      ['Tempo de circulação', _veicTxt(ag.tempo_circulacao)], ['Renavam', _veicTxt(dv.renavam)],
      ['Órgão SRF', _veicTxt(ag.orgao_srf)],            ['Atualizado em', _veicTxt(ag.atualizado_em)]
      ]);
      if(a.restr.length) kitAtencao(st,'Restrições nos agregados: '+a.restr.join(' · '));
    }

    /* ---------- 5. DADOS DOS LEILÕES (não há bloco separado no 1301) --- */
    if(!a.especial){
      kitSecao(st,'Dados dos leilões realizados');
      kitTexto(st,'Itens verificados: '+_AC_ITENS_LEILAO.join(' · ')+'.');
      if(!a.leilaoOk){
        kitVeredito(st,'at','LEILÃO NÃO VERIFICADO','A base de leilão não respondeu nesta consulta.');
      }else if(p.regs&&p.regs.length){
        kitLista(st,'Registros encontrados ('+p.regs.length+')', p.regs.map(function(r){
          return { forte:[r.data, r.patio].filter(Boolean).join(' · ')||'Leilão',
                   fraco:[r.leiloeiro, r.comitente, r.condicao, r.lote?('lote '+r.lote):''].filter(Boolean).join(' · ') };
        }));
      }else if(p.passou){
        kitVeredito(st,'no','CONSTA REGISTRO DE LEILÃO', p.qtd+' ocorrência(s), sem detalhamento na base.');
      }else{
        kitSelo(st,'Nenhum registro de leilão encontrado.');
      }
      if(a.score.nota) kitKv2(st,'Análise de risco',[['Score', a.score.nota],['Descrição', a.score.desc]]);
    }

    /* ---------- 6. PERDA TOTAL ---------- */
    kitSecao(st,'Perda total');
    if(!a.ptOk) kitVeredito(st,'at','NÃO VERIFICADA','A base de perda total não respondeu nesta consulta.');
    else if(a.pt.existe) kitVeredito(st,'no','REGISTRO DE PERDA TOTAL', [a.pt.data?('em '+a.pt.data):'', a.pt.msg].filter(Boolean).join(' · '));
    else kitSelo(st, a.pt.msg||'Nenhum registro encontrado. Nada consta.');

    /* ---------- 7. INDÍCIO DE SINISTRO ---------- */
    kitSecao(st,'Indício de sinistro');
    if(!a.sinOk) kitVeredito(st,'at','NÃO VERIFICADO','A base de indício de sinistro não respondeu nesta consulta.');
    else if(sinExiste) kitVeredito(st,'no','CONSTA INDÍCIO DE SINISTRO', (p.sinistro&&p.sinistro.descricao)||'Peça a vistoria cautelar antes de fechar negócio.');
    else kitSelo(st,'Nenhum registro encontrado até a presente data.');
    kitAtencao(st,_AC_ATENCAO_SINISTRO);

    /* ---------- 8. os blocos que só o PREMIUM traz ---------- */
    if(a.es){
      var es=a.es||{ ok:false, pendencias:[], financiamento:{} };
      function sn(x, ok){ return !ok||x==null ? 'não verificado' : (x ? 'CONSTA' : 'nada consta'); }
      kitKv2(st,'Situação estadual'+(es.ok?'':' (não verificada)'), (es.pendencias||[]).map(function(pe){
        return [pe.nome, sn(pe.existe, es.ok)+(pe.valor?(' · R$ '+pe.valor):'')]; }).concat([
        ['Roubo / furto', sn(es.roubo_furto, es.ok)], ['RENAJUD', sn(es.renajud, es.ok)],
        ['Financiamento', sn(es.financiamento&&es.financiamento.existe, es.ok)+((es.financiamento&&es.financiamento.agente)?(' · '+es.financiamento.agente):'')],
        ['Veículo baixado', sn(es.baixado, es.ok)] ]));
      if(es.fontes&&es.fontes.renainf&&es.renainf) _pgMultas(st,es.renainf,placa,true);
      else kitAtencao(st,'O detalhamento das multas no RENAINF não respondeu nesta consulta.');
    }
    if(a.premium){
      var rf=a.rf||{}, rc=a.rc||{}, al=a.al||{}, la=a.la||{};
      var extras=[
        ['Declaração de roubo/furto', sn(rf.declaracao, rf.ok)],
        ['Alertas gerais', al.ok ? String(al.qtd||0)+' ocorrência(s)' : 'não verificado'] ];
      if(!a.especial) extras.push(
        ['Recall', sn(rc.indicativo, rc.ok)+(rc.situacao?(' · '+rc.situacao):'')],
        ['Localizador de agregados', la.ok ? String(la.qtd||0)+' registro(s)' : 'não verificado'] );
      kitKv2(st,a.especial?'Roubo/furto · alertas':'Roubo/furto · recall · alertas',extras);
    }

    /* ---------- 9. INFORMAÇÕES IMPORTANTES ---------- */
    kitSecao(st,'Informações importantes');
    kitTexto(st,_AC_LEGAL);
    kitTexto(st,'Dados informados pelas bases consultadas na data da geração. Uso restrito à avaliação de procedência do veículo. Dados pessoais do proprietário omitidos (LGPD). Chassi exibido parcialmente.');
  }
  /* o exemplo (dados fictícios, no formato normalizado do servidor) */
  function autocorpExDados(qual){
    var base={ mev_exemplo:true, produto:(qual==='premium'?'45':qual==='especialjud'?'1301':'51'),
      dados_veiculo:{ marcamodelo:'MARCA EXEMPLO/MODELO 1.0', placa:VEIC_EX_PLACA, anofabricacaomodelo:'2018/2019', cor:'PRATA', combustivel:'FLEX', chassi:'9BWZZZ377VT004251', renavam:'', municipio:'CIDADE EXEMPLO', uf:'SP', fipe:'' },
      leilao:{ qtdleilao:1, descricaoretorno:'Consta registro de leilão', registro:[{ comitente:'SEGURADORA EXEMPLO', dataleilao:'17/11/2023', condicaogeraldoveiculo:'MÉDIA MONTA', situacaogeraldochassi:'NORMAL', classificacao:'', lote:'1668', patio:'PÁTIO EXEMPLO', leiloeiro:'LEILOEIRO EXEMPLO' }] },
      analise_risco:{ parecer:'1 passagem(ns) por leilão. Consta indício de sinistro. Score C · aceitação 61%', descricaoretorno:'APARENTEMENTE RECUPERADO', indicerisco:'C' },
      sinistro:{ existe:true, descricao:'EXISTE OCORRENCIA' },
      perda_total:{ existe:false, data:'', mensagem:'NAO EXISTE REGISTRO DE SINISTRO DE INDENIZACAO INTEGRAL' },
      restricoes:{ existe:false, mensagens:[] },
      fontes:{ autocorp:'ok', leilao:'ok', indicio_sinistro:'ok', perda_total:'ok', agregados:'ok' } };
    if(qual==='leilaopt'||qual==='premium'||qual==='especialjud'){
      base.estadual={ ok:true, pendencias:[ {nome:'IPVA',existe:true,valor:'1.234,56'}, {nome:'MULTAS',existe:false,valor:''}, {nome:'LICENCIAMENTO',existe:false,valor:''}, {nome:'DPVAT',existe:false,valor:''} ], roubo_furto:false, renajud:false, baixado:false, financiamento:{ existe:true, agente:'BANCO EXEMPLO S/A (FICTÍCIO)', contrato:'000123', data:'10/02/2024' }, restricao_geral:true, mensagens:['AUTUACAO DEBITO IPVA'], situacao:'EM CIRCULACAO' };
      base.roubo_furto={ ok:true, declaracao:false, recuperacao:false, devolucao:false, ocorrencias:0 };
      base.alertas={ ok:true, qtd:0 };
      base.fontes.bin_estadual='ok'; base.fontes.roubo_furto='ok'; base.fontes.alertas='ok';
      if(qual==='premium'){
        base.recall={ ok:true, indicativo:true, situacao:'PENDENTE', qtd:1 }; base.localizador={ ok:true, qtd:0 };
        base.fontes.recall='ok'; base.fontes.localizador='ok';
      }
    }
    return base;
  }
  /* ---------- histórico próprio (reabre sem custo; nuvem por tipo) ---------- */
  function _acHistKey(){ return 'mev_autocorp_hist'; }
  function _acTipo(qual){
    if(qual==='proprietarios') return 'historico_proprietarios';
    if(qual==='recall') return 'recall';
    if(qual==='debitos') return 'debitos_estaduais';
    return 'autocorp_'+qual;
  }
  function acHistLer(qual){ try{ return JSON.parse(localStorage.getItem(_acHistKey())||'[]').filter(function(x){ return x.qual===qual; }); }catch(_){ return []; } }
  function acHistDe(qual, placa){ var p=_lhPlaca(placa); return acHistLer(qual).filter(function(x){ return _lhPlaca(x.placa)===p; })[0]||null; }
  function acHistSalvar(qual, it){
    try{ var todos=JSON.parse(localStorage.getItem(_acHistKey())||'[]'); todos=todos.filter(function(x){ return !(x.qual===qual && _lhPlaca(x.placa)===_lhPlaca(it.placa)); }); it.qual=qual; todos.unshift(it); todos=todos.slice(0,30); localStorage.setItem(_acHistKey(), JSON.stringify(todos)); }catch(_){}
    try{ docHistCloudSave(_acTipo(qual), _lhPlaca(it.placa), 'placa', it.resultado, it.ts); }catch(_){}
  }
  function acHistCarregarNuvem(qual){
    try{ docHistCloudLoad(_acTipo(qual), function(rows){
      if(!rows||!rows.length) return; var novo=false;
      rows.forEach(function(row){ var pl=_lhPlaca(row.chave); if(!pl||acHistDe(qual,pl)) return; try{ var todos=JSON.parse(localStorage.getItem(_acHistKey())||'[]'); todos.push({ qual:qual, placa:pl, ts:Number(row.ts)||0, resultado:row.resultado }); localStorage.setItem(_acHistKey(), JSON.stringify(todos.slice(0,60))); novo=true; }catch(_){} });
      if(novo) acHistRender(qual);
    }); }catch(_){}
  }
  function acPintaSalva(qual, it, reaberta){
    veicResultadoAbrir(qual,it,reaberta);
  }
  /* v998 — depois de recuperar o laudo, o histórico local precisa saber:
     senão o lojista reabre a consulta amanhã e o botão de busca aparece de
     novo para um arquivo que já está no cofre. */
  function acHistMarcarPdf(protocolo, ref){
    if(!protocolo || !ref) return;
    try{
      var todos=JSON.parse(localStorage.getItem(_acHistKey())||'[]'); var mudou=false;
      todos.forEach(function(x){
        if(String(x.protocolo||'')!==String(protocolo)) return;
        try{ var b=x.resultado||{}; b=b.resultado||b; b=b.response||b.dados||b.data||b; b.pdf_ref=ref; b.pdf_estado='pronto'; delete b.pdf_motivo; mudou=true; }catch(_){}
      });
      if(mudou) localStorage.setItem(_acHistKey(), JSON.stringify(todos));
    }catch(_){}
  }
  /* v1153 — ponte segura entre a FIPE simples e as consultas adicionais.
     Só usa o histórico que já pertence à conta, exige valor FIPE real e não
     chama API. Se a placa já possui resultado neste produto, o card salvo
     continua sendo a melhor ação e a sugestão não é duplicada. */
  function acUltimaPlacaFipe(l){
    var vistos={}; (l||[]).forEach(function(x){ var p=_lhPlaca(x&&x.placa); if(p) vistos[p]=1; });
    try{
      var h=histLer().slice().sort(function(a,b){ return (Number(b&&b.ts)||0)-(Number(a&&a.ts)||0); });
      for(var i=0;i<h.length;i++){
        var it=h[i]||{}, placa=_lhPlaca(it.placa), v=it.v||{};
        if(!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(placa) || !Number(v.fipe) || vistos[placa]) continue;
        return { placa:placa, modelo:String(it.modelo||((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo'), ts:Number(it.ts)||0 };
      }
    }catch(_){}
    return null;
  }
  function acUltimaPlacaFipeHtml(l){
    var it=acUltimaPlacaFipe(l); if(!it) return '';
    return '<button type="button" class="consulta-fipe-recente" data-placa-fipe="'+esc(it.placa)+'" aria-label="Usar a última placa consultada na FIPE, '+esc(it.placa)+'">'
      +'<span class="consulta-fipe-recente-tx"><small>Última placa na FIPE</small><strong>'+esc(it.placa)+'</strong><span>'+esc(it.modelo)+(it.ts?' · '+esc(histData(it.ts)):'')+'</span></span>'
      +'<span class="consulta-fipe-recente-acao">Usar placa</span></button>';
  }
  function acUltimaPlacaFipeLigar(box){
    var bt=box&&box.querySelector('.consulta-fipe-recente'); if(!bt) return;
    bt.onclick=function(){
      var inp=$('veicPlaca'), placa=_lhPlaca(bt.getAttribute('data-placa-fipe')||'');
      if(!inp||!placa) return;
      inp.value=placa;
      try{ inp.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){ try{ inp.oninput(); }catch(_2){} }
      try{ inp.scrollIntoView({behavior:'smooth',block:'center'}); }catch(_){}
      try{ inp.focus({preventScroll:true}); inp.setSelectionRange(placa.length,placa.length); }catch(_){}
      try{ toast('Placa '+placa+' preenchida. Confirme a consulta para continuar.'); }catch(_){}
    };
  }
  function acHistRender(qual){
    var box=$('veicHist'); if(!box) return;
    var l=acHistLer(qual).sort(function(a,b){ return (b.ts||0)-(a.ts||0); });
    var sugestao=acUltimaPlacaFipeHtml(l);
    var sugestaoBox=$('veicFipeRecente');
    if(sugestaoBox){ sugestaoBox.innerHTML=sugestao; acUltimaPlacaFipeLigar(sugestaoBox); }
    if(!l.length){ box.innerHTML='<p class="consulta-historico-vazio">Nenhuma consulta salva neste produto.</p>'; return; }
    box.innerHTML=l.map(function(it,i){
        var a,ruim=false,rot='';
        if(qual==='proprietarios'){
          try{ a=proprietariosParse(it.resultado||{}); }catch(_){ a={donos:0}; }
          rot=(a.donos||0)+' dono'+(a.donos===1?'':'s');
        }else if(qual==='recall'){
          try{ a=recallParse(it.resultado||{}); }catch(_){ a={itens:[],placaOk:false,v2Ok:false}; }
          ruim=!!a.itens.length;
          rot=ruim?'Recall localizado':((a.placaOk&&a.v2Ok)?'Nada consta':'Verificação parcial');
        }else if(qual==='debitos'){
          try{ a=debitosResumoDados(it.resultado||{}); }catch(_){ a={tom:'atencao'}; }
          ruim=a.tom==='erro'; rot=ruim?'Consta':(a.tom==='ok'?'Nada consta':'Verificação parcial');
        }else{
          try{ a=autocorpParse(it.resultado||{}); }catch(_){ a={ p:{} }; }
          ruim=!!(a.p&&(a.p.passou||(a.p.sinistro&&a.p.sinistro.existe)))||!!(a.pt&&a.pt.existe);
          rot=ruim?'Consta':'Nada consta';
        }
        return '<button type="button" class="ac-hc '+(ruim?'is-alerta':'is-ok')+'" data-i="'+i+'">'
          +'<span class="ac-hc-tx"><span class="ac-hc-placa">'+esc(it.placa||'')+'</span><span class="ac-hc-data">'+esc(histData(it.ts))+(it.homologacao||(a.homolog)?' · homologação':'')+'</span></span>'
          +'<span class="ac-hc-status">'+rot+'</span></button>';
      }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.ac-hc'),function(c){ c.onclick=function(){
      var it=l[Number(c.getAttribute('data-i'))||0]; if(!it) return;
      acPintaSalva(qual, it, true);
    }; });
    if(!sugestaoBox) acUltimaPlacaFipeLigar(box);
  }
  /* ---------- a porta: quem vê os cards ------------------------------------
     O servidor decide (env AUTOCORP_AMBIENTE + ADMIN_EMAILS / piloto). O app
     lembra a última resposta no aparelho (mev_autocorp_status) pra pintar a
     home certa NA HORA, e confere de novo em 2º plano a cada entrada.
     body.autocorp-off esconde [data-ha]/[data-cons] leilaopt e premium. */
  var _AC_ST_KEY='mev_autocorp_status';
  function _acStLer(){ try{ return JSON.parse(localStorage.getItem(_AC_ST_KEY)||'null'); }catch(_){ return null; } }
  function autocorpLiberado(){ var s=_acStLer(); return !!(s && s.liberado); }
  function autocorpCobra(){ var s=_acStLer(); return !!(s && s.cobra); }
  function _acAplicaClasse(){
    try{ document.body.classList.toggle('autocorp-off', !autocorpLiberado()); }catch(_){}
  }
  async function autocorpStatusAtualizar(){
    var antes=autocorpLiberado();
    var r=null; try{ r=await apiComTimeout('/api/consultar',{ produto:'autocorp_status' },12000); }catch(_){ r=null; }
    if(!(r && r.ok)) return;
    try{ localStorage.setItem(_AC_ST_KEY, JSON.stringify({ liberado:!!r.liberado, cobra:!!r.cobra, ambiente:String(r.ambiente||''), ts:Date.now() })); }catch(_){}
    _acAplicaClasse();
    if(antes!==autocorpLiberado()){ try{ if(typeof homePainelMontar==='function') homePainelMontar(); }catch(_){} }
  }
  _acAplicaClasse();

/* ╔═══ src/app/04-leilao-cnpj.js ═════════════════════════════════════════ */
  /* ==========================================================================
     🔴🔴 CONSULTA PLUS — 19/08 (Fase 2 do PROJETO-consulta-plus)
     "cria um projeto pra unir tudo em uma pesquisa" · 25 tokens

     UMA chamada traz as TRÊS fontes pagas de uma vez: os dados do carro +
     FIPE, o estadual (multas, IPVA, licenciamento, DPVAT, restrições, gravame),
     e leilão + sinistro. O servidor dispara as três em paralelo e devolve um
     pacote com um bloco por fonte, cada um carimbado com a fonte e a hora.

     ⚠️ A FICHA DE FÁBRICA NÃO VEM NESSE PACOTE, e isso é de propósito. Ela é
     a única das três que **não custa API nenhuma** (é IA), e ela roda como
     JOB DE FUNDO com o app perguntando "ficou pronto?" por até 2,5 minutos —
     porque pesquisa de carro antigo passa do tempo de vida de uma function.
     Enfiá-la na chamada síncrona mataria a consulta inteira pra buscar o
     pedaço de graça. Então ela é disparada AQUI, em paralelo, e cai na tela
     quando chegar. Quem paga espera 8 s; a ficha alcança sozinha.

     🔴 ESTORNO PROPORCIONAL (decisão do Angelo): se uma fonte não responde, o
     servidor devolve o pedaço dela e o `aviso` diz o que faltou. Aqui a tela
     só precisa MOSTRAR isso — nunca esconder um bloco vazio como se fosse
     "nada consta".
     ========================================================================== */
  var plusState=null;          /* o pacote inteiro, do jeito que o servidor mandou */
  function plusFontesFalharam(p){ return (p && Array.isArray(p.faltou)) ? p.faltou : []; }

  /* chamado pelo 03 quando a ficha de fábrica finalmente chega (ela corre por
     fora, ver o `fichaTecPedirEmParalelo`). Se a tela já saiu, não faz nada. */
  function plusFichaChegou(placa){
    try{
      if(!plusState || _lhPlaca(plusState.placa) !== _lhPlaca(placa)) return;
      plusState.ficha_de_fabrica = { fonte:'ficha por IA', ok:true, em:new Date().toISOString(), dados:fichaTecState };
      /* 🟢 e é AQUI que ela vira valor de verdade: com a ficha na mão, o
         indício de alteração no combustível (fábrica × cadastro, da v570)
         passa a ter os dois lados pra comparar. Repinta o relatório. */
      if(typeof _mrPinta === 'function' && document.getElementById('mrWrap')) _mrPinta(false);
    }catch(_){ }
  }

  /* 🔴 O VEREDITO — a primeira coisa que quem decide a compra quer ver.
     Ele NÃO inventa nada: só junta o que os blocos já disseram.
       🔴 vermelho = leilão, sinistro ou restrição pesada;
       🟡 amarelo  = indício de alteração, ou alguma fonte que não respondeu;
       🟢 verde    = as três fontes vieram e nenhuma acusou nada.
     ⚠️ FONTE QUE FALTOU NUNCA VIRA VERDE. "Nada consta" com uma base muda é
     a mentira mais cara que este relatório poderia contar. */
  function plusVeredito(){
    var p = plusState || {};
    var ex = null;
    try{ ex = leilaoState ? relVeicExtrai(leilaoState) : null; }catch(_){ ex = null; }
    var proc = null;
    try{ proc = _leilaoHistState ? leilaoHistParse(_leilaoHistState) : null; }catch(_){ proc = null; }

    var motivos = [];
    if(proc && proc.passou) motivos.push('passagem por leilão');
    if(proc && proc.sinistro && proc.sinistro.existe) motivos.push('indício de sinistro');
    if(ex && ex.temAlerta) motivos.push('restrições ou débitos');
    if(motivos.length) return { cor:'vermelho', titulo:'Confira antes de comprar',
      linha:'Encontramos '+motivos.join(' e ')+'.' };

    var faltou = plusFontesFalharam(p);
    if(faltou.length) return { cor:'amarelo', titulo:'Consulta incompleta',
      linha:'Não veio: '+faltou.join(' e ')+'. O que veio não acusou nada.' };

    return { cor:'verde', titulo:'Nada encontrado',
      linha:'As três fontes responderam e nenhuma acusou restrição, leilão ou sinistro.' };
  }

  /* Reabre ou acaba de receber uma Plus? O estadual é a base do relatório.
     O encaixe nacional abaixo existe só para relatórios históricos feitos
     enquanto a Base Nacional esteve ativa; novas consultas não a chamam. */
  function plusAplicarEstados(p, salvoEstadual){
    var b=(p&&p.blocos)||{}, est=(b.estadual&&b.estadual.ok&&b.estadual.dados)||salvoEstadual||null;
    var nac=b.nacional&&b.nacional.ok&&b.nacional.dados;
    if(est) leilaoState=est;
    else if(nac) leilaoState={ data:{ veicular:{} } };
    if(leilaoState){
      try{ delete leilaoState.__nacional; }catch(_){}
      if(nac) leilaoState.__nacional=nac;
    }
    if(b.procedencia&&b.procedencia.ok&&b.procedencia.dados){
      _leilaoHistState={ resultado:b.procedencia.dados };
    }
    return leilaoState;
  }

  /* Roda a Consulta Plus e ESPALHA o resultado nos estados que as telas de
     hoje já sabem ler. Devolve { ok, aviso, erro, semSaldo }.
     🟢 Espalhar em vez de reescrever as telas é o que faz esta versão caber:
     o relatório do estadual, o painel do leilão e o PDF continuam sendo os
     mesmos, já testados — eles só passam a ser abastecidos por uma chamada
     só em vez de três. */
  async function consultaPlusRodar(placa, opts){
    opts = opts || {};
    placa = _lhPlaca(placa);
    if(placa.length < 7) return { ok:false, erro:'Placa inválida.' };

    /* ⚠️ a ficha de fábrica sai ANTES e sem await: ela é de graça e demora
       mais que o resto. Falhar aqui não pode derrubar nada. */
    if(opts.comFicha !== false){
      try{ if(typeof fichaTecPedirEmParalelo === 'function') fichaTecPedirEmParalelo(placa); }catch(_){}
    }

    var d = null;
    try{ d = await consultarComRetry({ produto:'consulta_plus', placa:placa }, 1); }catch(_){ d = null; }
    if(d && d.sem_saldo){ setSaldo(d.saldo); return { ok:false, semSaldo:true, saldo:d.saldo }; }
    if(d && d.saldo != null) setSaldo(d.saldo);
    if(!d || !d.ok){
      return { ok:false, erro:(d && d.erro) || 'Não foi possível concluir a consulta agora.',
               estornado: !!(d && d.estornado) };
    }

    var p = d.resultado || {};
    plusState = p;
    /* Só resultados gerados pela Plus podem reabrir como uma Consulta Plus
       salva. Consultas avulsas antigas continuam no histórico, sem receber
       indevidamente o selo do novo produto. */
    try{ histSetGerado(placa, 'consultaPlus', p); }catch(_){}
    var b = p.blocos || {};

    /* 1) O CARRO (FIPE) → veiculoAtual, que é de onde meia dúzia de telas lê */
    if(b.carro && b.carro.ok && b.carro.dados && b.carro.dados.resultado){
      veiculoAtual = b.carro.dados.resultado; histFonteTs = null;
      try{ histSalvar(placa, ((veiculoAtual.marca||'')+' '+(veiculoAtual.modelo||'')).trim(), veiculoAtual, null); }catch(_){}
    } else if(!(veiculoAtual && _lhPlaca(veiculoAtual.placa) === placa)){
      /* sem a FIPE o relatório sai mais magro, mas sai — e o bloco vai DIZER
         que ela não veio, em vez de aparecer vazio */
      veiculoAtual = { placa:placa }; histFonteTs = null;
    }

    /* 2) ESTADUAL + BASE NACIONAL → relatório e PDF unificados. */
    plusAplicarEstados(p);
    if(leilaoState) try{ histSetGerado(placa, 'leilao', leilaoState); }catch(_){}

    /* 3) PROCEDÊNCIA (leilão + sinistro) → o painel que o 04 já desenha */
    if(b.procedencia && b.procedencia.ok && b.procedencia.dados){
      _leilaoHistState = { resultado: b.procedencia.dados };
      try{ lhHistSalvar({ placa:placa,
        modelo: ((veiculoAtual&&veiculoAtual.marca)||'')+' '+((veiculoAtual&&veiculoAtual.modelo)||''),
        ts: Date.now(), resultado: b.procedencia.dados, tok: 0 }); lhHistRender(); }catch(_){}
    }

    return { ok:true, aviso: d.aviso || null, faltou: plusFontesFalharam(p),
             estornado_parcial: d.estornado_parcial || 0 };
  }

  /* ================= CONSULTA DE LEILÃO/SINISTRO (API Brasil + AnyCar, 20 tokens) ========= */
  var _leilaoHistState=null;
  var _lhFrases=['🔨 Buscando registros de leilão…','🛡️ Verificando passagem por seguradora…','📋 Lendo comitente, data e lote…','⚠️ Checando condição do veículo…','📊 Montando a análise de risco…','✅ Quase lá…'];
  function _lhLimpo(v){ var s=String(v==null?'':v).trim(); if(!s) return ''; if(/^(nao informado|não informado|nao divulgado|não divulgado|n\/c|null|nao foi possivel|não foi possível|0)$/i.test(s)) return ''; return s; }
  function _lhData(v){ var s=String(v||'').trim(); if(!s||/^01\/01\/0001/.test(s)||/^0+$/.test(s.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''))) return ''; return s; }
  function _lhPlaca(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); }
  function _lhAlerta(txt){ return /sucata|inserviv|perda total|grande monta|m[eé]dia monta|irrecuper|sinistr/i.test(String(txt||'')); }
  function leilaoHistParse(dd){
    var base=(dd&&dd.resultado)||dd||{}; base=base.data||base;
    var lo=base.leilao||{}; var ar=base.analise_risco||{}; var dv=base.dados_veiculo||{}; var sin=base.sinistro||{};
    function _semBase(t){ return String(t||'').replace(/\s*\(base anycar\)/gi,'').replace(/base anycar:?\s*/gi,'').replace(/\banycar\b/gi,'').replace(/api ?brasil ?·? ?(leilão\/remarketing)?/gi,'').replace(/\s{2,}/g,' ').trim(); }
    var sinExiste=!!(sin.existe===true||String(sin.existe)==='1'||/existe\s+ocorr/i.test(String(sin.descricao||'')));
    var sinDet=(Array.isArray(sin.detalhes)?sin.detalhes:[]).map(_semBase).filter(Boolean);
    var qtd=parseInt(String(lo.qtdleilao||0).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
    var loDesc=String(lo.descricaoretorno||'');
    var _neg=/n[ãa]o consta|nenhum|sem registro|not found|inexist/i.test(loDesc);
    var passou=qtd>0 || (/consta\s+registro/i.test(loDesc) && !_neg);
    var regs=(Array.isArray(lo.registro)?lo.registro:[]).map(function(r){
      return { comitente:_lhLimpo(r.comitente), data:_lhData(r.dataleilao), condicao:_lhLimpo(r.condicaogeraldoveiculo), chassiSit:_lhLimpo(r.situacaogeraldochassi), classif:_lhLimpo(r.classificacao), lote:_lhLimpo(r.lote), patio:_lhLimpo(r.patio), leiloeiro:_lhLimpo(r.leiloeiro) };
    });
    /* ordena por data (mais recente primeiro) */
    function _dnum(d){ var m=String(d||'').match(/(\d{2})\/(\d{2})\/(\d{4})/); return m?(m[3]+m[2]+m[1]):'0'; }
    regs.sort(function(a,b){ return _dnum(b.data)<_dnum(a.data)?-1:1; });
    var parecer=_semBase(_lhLimpo(ar.parecer))||'';
    var semRisco=/nao foi encontrado risco|não foi encontrado risco|sem risco|nao consta|não consta/i.test(parecer);
    var _mun=[_lhLimpo(dv.municipio), _lhLimpo(dv.uf)].filter(Boolean).join(' / ');
    var _fipe=_lhLimpo(dv.fipe); if(_fipe&&/^\d/.test(String(_fipe).replace(/\./g,''))) _fipe='R$ '+Number(String(dv.fipe).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'')).toLocaleString('pt-BR');
    var dados=[ ['Veículo', _lhLimpo(dv.marcamodelo)], ['Placa', _lhLimpo(dv.placa)], ['Ano fab./modelo', _lhLimpo(dv.anofabricacaomodelo)], ['Cor', _lhLimpo(dv.cor)], ['Combustível', _lhLimpo(dv.combustivel)], ['Município / UF', _mun], ['Renavam', _lhLimpo(dv.renavam)], ['Chassi', _lhLimpo(dv.chassi)], ['Valor FIPE', _fipe] ];
    var temAlerta=passou||sinExiste||regs.some(function(r){ return _lhAlerta(r.condicao)||_lhAlerta(r.chassiSit); });
    var arDesc=_lhLimpo(ar.descricaoretorno)||_lhLimpo(lo.descricaoretorno)||'';
    /* 🔴 19/08 — o que foi COMPLETADO de consulta anterior sai carimbado.
       Nada entra no relatório em silêncio: quem lê tem que poder saber que
       aquele campo não veio DESTA consulta. Ver o bloco do `__completado`. */
    var _cp=dv.__completado||null, compl=null;
    if(_cp && Array.isArray(_cp.campos) && _cp.campos.length){
      var _rot={ marcamodelo:'veículo', cor:'cor', anofabricacaomodelo:'ano', chassi:'chassi',
                 municipio:'município', uf:'UF', renavam:'renavam' };
      var _q=''; try{ _q=histData(_cp.quando); }catch(_){ }
      compl={ campos:_cp.campos.map(function(c){ return _rot[c]||c; }),
              quando:_q,
              texto:'Completado com a consulta de '+(_q||'antes')+': '+
                    _cp.campos.map(function(c){ return _rot[c]||c; }).join(', ')+'.' };
    }
    return { passou:passou, qtd:qtd, parecer:parecer, semRisco:semRisco, indice:_lhLimpo(ar.indicerisco), status:arDesc, regs:regs, dados:dados, temAlerta:temAlerta, completado:compl, sinistro:{existe:sinExiste, descricao:_semBase(_lhLimpo(sin.descricao)), detalhes:sinDet}, conhecido:!!(base.leilao||base.dados_veiculo||base.sinistro) };
  }
  /* histórico local das consultas de leilão (cards) */
  function lhHistLer(){ try{ return JSON.parse(localStorage.getItem('mev_leilao_hist')||'[]'); }catch(_){ return []; } }
  function lhTemSalvo(placa){ try{ var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); if(!p) return false; return lhHistLer().some(function(x){ return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===p && x.resultado; }); }catch(_){ return false; } }
  function lhSalvoDe(placa){ try{ var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); return lhHistLer().filter(function(x){ return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===p; })[0]||null; }catch(_){ return null; } }
  function lhHistSalvar(it){ try{ var l=lhHistLer().filter(function(x){ return String(x.placa)!==String(it.placa); }); l.unshift(it); l=l.slice(0,15); localStorage.setItem('mev_leilao_hist', JSON.stringify(l)); }catch(_){} try{ docHistCloudSave('leilao', it.placa, 'placa', it.resultado, it.ts); }catch(_){} }
  function lhHistCarregarNuvem(){
    docHistCloudLoad('leilao', function(rows, deuCerto){
      /* v259 — backfill: sobe o que só existe neste aparelho (ver docHistBackfill no 03) */
      if(deuCerto) try{ docHistBackfill('leilao', rows, lhHistLer().map(function(it){ return { chave:String(it.placa||''), tipo_doc:'placa', resultado:it.resultado, ts:it.ts }; })); }catch(_){}
      if(!rows||!rows.length) return;
      var l=lhHistLer(); var novo=false;
      rows.forEach(function(row){ var pl=String(row.chave||''); if(!pl) return; if(!l.some(function(x){ return String(x.placa)===pl; })){ var p; try{ p=leilaoHistParse(row.resultado||{}); }catch(_){ p={}; } l.push({ placa:pl, modelo:(p.dados&&p.dados[0]&&p.dados[0][1])||'', ts:Number(row.ts)||0, resultado:row.resultado }); novo=true; } });
      if(!novo) return;
      l.sort(function(a,b){ return (b.ts||0)-(a.ts||0); }); l=l.slice(0,15);
      try{ localStorage.setItem('mev_leilao_hist', JSON.stringify(l)); }catch(_){}
      lhHistRender();
    });
  }
  function lhHistCards(){
    var l=lhHistLer(); if(!l.length) return '';
    return '<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:20px 2px 8px">Consultas recentes</div>'+
      l.map(function(it,i){
        var p; try{ p=leilaoHistParse(it.resultado||{}); }catch(_){ p={}; }
        var _sin=!!(p.sinistro&&p.sinistro.existe);
        var _al=p.passou||_sin;
        var _rot=_al?((p.passou&&_sin)?'Leilão + sinistro':(_sin?'Consta sinistro':((p.qtd||'')+' leilão(ões)'))):'Nada consta';
        var chip='<span style="flex:none;font-size:12px;font-weight:800;padding:4px 10px;border-radius:20px;background:'+(_al?'#fee2e2':'#dcfce7')+';color:'+(_al?'#b91c1c':'#15803d')+'">'+_rot+'</span>';
        return '<button type="button" class="lh-hc" data-i="'+i+'" style="width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;background:'+(_al?'#fff7f7':'#fff')+';border:1.5px solid '+(_al?'#fecaca':'#e8eef7')+';border-radius:12px;padding:12px 14px;margin-bottom:8px;cursor:pointer;font-family:inherit;text-align:left;box-shadow:0 2px 8px rgba(2,20,60,.04)">'+
          '<span style="min-width:0"><span style="display:block;font-weight:800;color:#0f172a;font-size:14px">'+esc(it.placa||'')+'</span><span style="font-size:11.5px;color:#94a3b8">'+esc(it.modelo||'Veículo')+' · '+esc(histData(it.ts))+'</span></span>'+chip+'</button>';
      }).join('');
  }
  function lhHistRender(){
    var box=$('lhHist'); if(!box) return;
    box.innerHTML=lhHistCards();
    Array.prototype.forEach.call(box.querySelectorAll('.lh-hc'),function(c){ c.onclick=function(){ var l=lhHistLer(); var it=l[Number(c.getAttribute('data-i'))||0]; if(!it) return; var inp=$('lhPlaca'); if(inp){ inp.value=String(it.placa||''); _lhAuto=inp.value; inp.classList.add('tem'); } _lhPintaSalva(it.resultado, true); var res=$('lhResult'); if(res){ try{ res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){} } }; });
  }
  /* v387: miolo e fiação separados — usados na página (celular) E na coluna
     da tela inicial (computador). */
  /* v390 (pedido): SEM o botão grande — completou a placa, a consulta sai
     sozinha (mesmo costume do CPF e do CNPJ). Placa com resultado salvo
     reabre sem custo; pagar de novo só pelo "Consultar de novo" que
     aparece junto do resultado. */
  var _lhAuto='', _lhRodando=false;
  var _LH_REFAZER='<button type="button" class="cad-btn sec" id="lhRefazer" style="margin-top:8px">Consultar de novo</button>';
  function _lhPintaSalva(resultado, reaberta){
    _leilaoHistState=resultado; var res=$('lhResult'); if(!res) return;
    res.innerHTML=(reaberta?'<div style="font-weight:800;color:var(--verde);padding:2px 0 6px">✓ Consulta salva (reaberta sem custo)</div>':'')+leilaoHistPanelHtml(resultado)+_LH_REFAZER;
    var pb=res.querySelector('#lhPdf'); if(pb) pb.onclick=function(){ leilaoHistBaixarPDF(); };
    var rf=$('lhRefazer'); if(rf) rf.onclick=function(){ gerarLeilaoHist(true); };
  }
  function lhInnerHtml(){
    var pre=(veiculoAtual&&veiculoAtual.placa)?esc(veiculoAtual.placa):'';
    /* v595 (projeto "telas de consulta sem explicações"): a DESCRIÇÃO saiu —
       o preço subiu pro subtítulo do panelHead (a consulta dispara sozinha
       com a placa válida; sem botão na frente, é lá que o preço mora). */
    return '<div class="lh-busca">'+_icoBusca+'<input id="lhPlaca" class="lh-inp'+(pre?' tem':'')+'" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Digite ou cole a placa" aria-label="Buscar placa" value="'+pre+'"></div>'
      +'<div id="lhResult"></div>'
      +'<div id="lhHist"></div>';
  }
  function lhWire(){
    var inp=$('lhPlaca'); if(inp){
      inp.oninput=function(){
        inp.value=_lhPlaca(inp.value); inp.classList.toggle('tem', !!inp.value);
        var p=inp.value;
        if(/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p)){ if(p!==_lhAuto){ _lhAuto=p; gerarLeilaoHist(); } }
        else _lhAuto='';
      };
      inp.addEventListener('paste',function(){ setTimeout(function(){ try{ inp.oninput(); }catch(_){} },0); });
      /* v190: já abre com o cursor no campo (pronto pra digitar). Se veio placa da consulta,
         seleciona o texto pra bastar digitar por cima. O timeout deixa a tela terminar de montar. */
      setTimeout(function(){ try{ inp.focus({preventScroll:true}); }catch(_){ try{ inp.focus(); }catch(_2){} } try{ if(inp.value) inp.select(); }catch(_3){} }, 140);
    }
    lhHistRender();
    try{ lhHistCarregarNuvem(); }catch(_){}
    /* se essa placa já foi consultada, mostra o resultado salvo direto (não recobra) */
    try{
      var _sv=veiculoAtual?lhSalvoDe(veiculoAtual.placa):null;
      if(_sv&&_sv.resultado){ _lhPintaSalva(_sv.resultado, true); }
    }catch(_){}
  }
  function abrirLeilaoHist(){
    mevTabSet('completa');
    irTela(panelHead(ICO.leilao,'blue','Consulta leilão e sinistro','Leilão e sinistro · '+precoReal(20))+'<div id="lhWrap">'+lhInnerHtml()+'</div>','menu');
    document.body.classList.remove('md-veiculo');   /* leilão tem placa própria: esconde a coluna da esquerda (home) e usa tela cheia */
    lhWire();
  }
  async function gerarLeilaoHist(forcar){
    if(_lhRodando) return;
    var inp=$('lhPlaca'); var placa=inp?_lhPlaca(inp.value):'';
    var res=$('lhResult');
    if(!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(placa)){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite uma placa válida (ABC1234 ou ABC1D23).</div>'; return; }
    /* v390: já tem essa placa salva? reabre SEM custo (pagar de novo é só
       pelo botão "Consultar de novo" — que passa forcar=true) */
    if(forcar!==true){
      try{ var _jah=lhSalvoDe(placa); if(_jah&&_jah.resultado){ _lhPintaSalva(_jah.resultado, true); return; } }catch(_){}
    }
    _lhRodando=true;
    if(res) res.innerHTML=ccLoaderHtml('Consultando leilão…',_lhFrases); var lt=ccLoaderStart(_lhFrases);
    var _sAntes=saldo;   /* saldo ANTES da consulta (pro extrato) */
    /* 🔴 19/08 — o leilão/sinistro não se compra mais sozinho (decisão do
       Angelo: "avulso só a consulta FIPE"). Este botão passou a rodar a
       CONSULTA PLUS, que traz ele junto com a FIPE e o estadual pelo mesmo
       toque. Quem chega aqui já queria o carro inteiro. */
    var _pl = await consultaPlusRodar(placa);
    clearInterval(lt);
    _lhRodando=false;
    if(_pl.semSaldo){ if(res) res.innerHTML=''; abrirPacotes(); return; }
    if(!_pl.ok){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc(_pl.erro||'Não foi possível concluir a consulta agora. Tente de novo em instantes.')+(_pl.estornado?' O valor foi devolvido ao seu saldo.':'')+'</div>'; return; }
    if(_pl.aviso) toast(_pl.aviso);
    /* o pacote da Plus, no formato que o resto desta tela já lê */
    var d = { ok:true, saldo:saldo,
      resultado: (((plusState||{}).blocos||{}).procedencia||{}).dados || null };
    if(!d.resultado){
      /* a procedência não veio (e já foi estornada). O estadual e a FIPE
         vieram — então manda pro relatório deles em vez de deixar a tela em
         branco com um erro que não conta a história toda. */
      if(res) res.innerHTML='<div class="plc-msg" style="margin-top:8px">A base de leilão e sinistro não respondeu agora — essa parte foi devolvida. O restante da consulta está no relatório.</div>';
      return;
    }
    /* ========================================================================
       🔴 19/08 — O RELATÓRIO NÃO SE COMPLETA MAIS EM SILÊNCIO
       (PROJETO-consulta-plus, defeito 2)

       Isto aqui existe por um bom motivo: sem ele o relatório sai "magro",
       porque o leilão devolve pouca coisa do carro. O problema nunca foi
       completar — foi completar **sem dizer**.

       O que estava errado, e é fácil de ver quando alguém aponta:
         · a única trava era a PLACA BATER. Nenhum limite de idade — e o app
           guarda a data da origem logo ali (`histFonteTs`), sem usar;
         · a FIPE entrava junto. Ela **muda todo mês**. Um relatório de hoje
           saía com o valor de uma consulta de três meses atrás, no mesmo
           documento que o rodapé afirma ser "dados na data da geração";
         · foi assim que "PORTO ALEGRE / RS" apareceu num PDF sem ter vindo
           da consulta que o gerou.

       O que mudou:
         1. 🔴 a FIPE SAIU. Preço velho num documento datado é o pior tipo de
            erro: parece certo;
         2. 🔴 o COMBUSTÍVEL SAIU. Desde hoje ele alimenta o indício de
            alteração (fábrica × cadastro, no 19). Comparar contra um valor
            de cache seria acusar o carro com base em memória;
         3. ⚠️ só completa o que veio de consulta de até **90 dias** — e a
            data vem do `histFonteTs`, que já estava ali;
         4. 🔴🔴 e cada campo completado fica CARIMBADO em `__completado`:
            de onde veio e de quando. O relatório mostra isso.
       ======================================================================== */
    try{
      var _dv=d.resultado&&(d.resultado.dados_veiculo||(d.resultado.data&&d.resultado.data.dados_veiculo));
      if(!_dv&&d.resultado){ _dv=d.resultado.dados_veiculo={}; }
      var _va=veiculoAtual&&String(veiculoAtual.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===placa?veiculoAtual:null;
      /* ⚠️ histFonteTs vazio = a consulta é DESTA sessão (veio agora). Só é
         "velho" o que tem carimbo de origem antigo. */
      var _idade = histFonteTs ? (Date.now() - Number(histFonteTs)) : 0;
      var _VALIDADE = 90*24*3600*1000;
      if(_idade > _VALIDADE) _va = null;
      if(_dv){
        if(!_dv.placa) _dv.placa=placa;
        if(_va){
          var _feitos=[];
          function _compl(campo, valor){
            if(valor==null || valor==='') return;
            if(_dv[campo]!=null && _dv[campo]!=='') return;
            _dv[campo]=valor; _feitos.push(campo);
          }
          _compl('marcamodelo', ((_va.marca||'')+' '+(_va.modelo||'')).trim());
          _compl('cor', _va.cor);
          _compl('anofabricacaomodelo', (_va.ano||_va.ano_modelo)?((_va.ano||'')+(_va.ano_modelo&&_va.ano_modelo!=_va.ano?('/'+_va.ano_modelo):'')):'');
          _compl('chassi', _va.chassi);
          _compl('municipio', _va.municipio);
          _compl('uf', _va.uf);
          _compl('renavam', _va.renavam);
          /* 🔴 fipe e combustivel NÃO entram — ver o bloco acima. */
          if(_feitos.length){
            _dv.__completado={ de:'consulta anterior', quando:(histFonteTs||Date.now()), campos:_feitos };
          }
        }
      }
    }catch(_){}
    _lhPintaSalva(d.resultado, false);
    try{ var p=leilaoHistParse(d.resultado); lhHistSalvar({ placa:placa, modelo:(p.dados&&p.dados[0]&&p.dados[0][1])||'', ts:Date.now(), resultado:d.resultado, tok:_tokCalc(_sAntes,d.saldo) }); lhHistRender(); }catch(_){}
  }
  function leilaoHistPanelHtml(dd){
    var p=leilaoHistParse(dd);
    if(!p.conhecido){
      return '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-left:6px solid #0a4da6;border-radius:14px;padding:14px 16px;margin:6px 0 12px"><div style="font-weight:800;color:#0a4da6;font-size:15.5px">Consulta realizada</div></div><div style="background:#fff;border:1px solid #e8eef7;border-radius:14px;padding:12px 14px">'+renderVal(dd&&dd.resultado||dd)+'</div>';
    }
    var docm=(p.dados[1]&&p.dados[1][1])||'';
    var html='<div style="font-size:12px;color:#64748b;margin:2px 0 4px">Placa consultada: <b>'+esc(docm)+'</b></div>';
    /* banner principal */
    html += p.passou
      ? '<div style="background:#fef2f2;border:1px solid #fecaca;border-left:6px solid #dc2626;border-radius:14px;padding:16px;margin:6px 0 12px"><div style="font-weight:900;color:#b91c1c;font-size:17px">⚠️ Veículo COM registro de leilão</div><div style="color:#7f1d1d;font-size:13.5px;margin-top:3px">Foram encontradas <b>'+p.qtd+'</b> ocorrência(s) de leilão para esta placa. Investigue a origem antes de comprar.</div></div>'
      : '<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-left:6px solid #16a34a;border-radius:14px;padding:16px;margin:6px 0 12px"><div style="font-weight:900;color:#15803d;font-size:17px">✓ Sem registro de leilão</div><div style="color:#166534;font-size:13.5px;margin-top:3px">Não foi encontrada passagem por leilão para esta placa nas bases consultadas.</div></div>';
    /* indício de sinistro (bases de seguradora) */
    if(p.sinistro && p.sinistro.existe){
      var _sdet=(p.sinistro.detalhes||[]).map(function(d){ return '<div style="color:#7f1d1d;font-size:12.5px;margin-top:5px;padding:5px 0 0 10px;border-left:3px solid #fecaca">'+esc(d)+'</div>'; }).join('');
      html+='<div style="background:#fef2f2;border:1px solid #fecaca;border-left:6px solid #b91c1c;border-radius:14px;padding:14px 16px;margin:0 0 12px"><div style="font-weight:900;color:#b91c1c;font-size:16px">🛡️ Consta indício de SINISTRO</div><div style="color:#7f1d1d;font-size:13px;margin-top:3px">'+esc(p.sinistro.descricao||'Existe ocorrência de sinistro registrada para este veículo. Peça a vistoria cautelar antes de fechar negócio.')+'</div>'+_sdet+'</div>';
    } else if(p.conhecido){
      html+='<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:14px;padding:11px 14px;margin:0 0 12px"><div style="font-size:13.5px;color:#166534"><b>🛡️ Sinistro:</b> nada consta nas bases consultadas.</div></div>';
    }
    /* análise de risco */
    if(p.parecer){
      var rc=p.temAlerta?['#dc2626','#fef2f2','#fecaca']:['#16a34a','#f0fdf4','#bbf7d0'];
      html+='<div style="background:'+rc[1]+';border:1px solid '+rc[2]+';border-radius:14px;padding:12px 14px;margin:0 0 12px"><div style="font-size:11px;font-weight:800;color:'+rc[0]+';text-transform:uppercase;letter-spacing:.4px">Análise de risco</div><div style="font-size:14px;font-weight:700;color:#0f172a;margin-top:3px;line-height:1.35">'+esc(p.parecer)+'</div></div>';
    }
    /* registros de leilão */
    if(p.regs.length){
      html+='<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:10px 2px 7px">Registros encontrados ('+p.regs.length+')</div>';
      html+=p.regs.map(function(r,i){
        var al=_lhAlerta(r.condicao)||_lhAlerta(r.chassiSit);
        var linhas=[ r.data?['Data do leilão',r.data]:null, r.comitente?['Comitente',r.comitente]:null, r.condicao?['Condição do veículo',r.condicao]:null, r.chassiSit?['Situação do chassi',r.chassiSit]:null, r.classif?['Classificação',r.classif]:null, r.lote?['Lote',r.lote]:null, r.leiloeiro?['Leiloeiro',r.leiloeiro]:null ].filter(Boolean);
        return '<div style="background:#fff;border:1px solid '+(al?'#fecaca':'#e8eef7')+';border-left:5px solid '+(al?'#dc2626':'#0a4da6')+';border-radius:12px;padding:12px 14px;margin-bottom:8px;box-shadow:0 2px 8px rgba(2,20,60,.04)">'+
          '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline;margin-bottom:6px"><span style="font-weight:800;color:#0f172a;font-size:14px">Registro '+(i+1)+'</span>'+(r.data?'<span style="flex:none;font-size:12px;color:#64748b;font-weight:700">'+esc(r.data)+'</span>':'')+'</div>'+
          linhas.map(function(kv){ var alv=(kv[0]==='Condição do veículo'&&_lhAlerta(kv[1]))||(kv[0]==='Situação do chassi'&&_lhAlerta(kv[1])); return '<div style="display:flex;justify-content:space-between;gap:10px;padding:3px 0"><span style="font-size:12.5px;color:#94a3b8;font-weight:600">'+esc(kv[0])+'</span><span style="font-size:13px;font-weight:'+(alv?'800':'700')+';color:'+(alv?'#b91c1c':'#0f172a')+';text-align:right;max-width:62%">'+esc(kv[1])+'</span></div>'; }).join('')+
        '</div>';
      }).join('');
    }
    /* dados do veículo */
    var dvRows=(p.dados||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); });
    if(dvRows.length){
      html+='<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:16px 2px 7px">Dados do veículo</div>'+
        '<div style="background:#fff;border:1px solid #e8eef7;border-radius:14px;overflow:hidden;box-shadow:0 3px 12px rgba(2,20,60,.05)">'+
        dvRows.map(function(r,i){ return '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 14px;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><span style="font-size:12.5px;color:#64748b;font-weight:600">'+esc(r[0])+'</span><span style="font-size:13.5px;font-weight:700;color:#0f172a;text-align:right">'+esc(r[1])+'</span></div>'; }).join('')+
        /* 🔴 19/08 — a etiqueta do que NÃO veio desta consulta */
        (p.completado?('<div style="border-top:1px solid #f1f5f9;padding:9px 14px;font-size:11.5px;color:#94a3b8;line-height:1.45">'+esc(p.completado.texto)+'</div>'):'')+
        '</div>';
    }
    /* abrangência / fonte da consulta — explica o que foi verificado e onde */
    html+='<div style="font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:16px 2px 7px">Abrangência da consulta</div>'+
      '<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:14px;padding:13px 15px">'+
        '<div style="font-size:12.5px;color:#475569;line-height:1.55">Verifica se o veículo já <b>passou por leilão</b> — de <b>seguradora</b> (perda total), <b>financeira</b> (retomada) ou <b>judicial</b>, além de remarketing — e se há <b>indício de sinistro</b> registrado. Cobre registros <b>nacionais</b> consolidados.</div>'+
        (p.indice?'<div style="display:flex;justify-content:space-between;gap:10px;padding:8px 0 0"><span style="font-size:11.5px;color:#94a3b8;font-weight:700">Índice de risco</span><span style="font-size:12.5px;color:#0f172a;font-weight:700;text-align:right">'+esc(p.indice)+'</span></div>':'')+
        '<div style="display:flex;justify-content:space-between;gap:10px;padding:8px 0 0"><span style="font-size:11.5px;color:#94a3b8;font-weight:700">Gerado em</span><span style="font-size:12.5px;color:#0f172a;font-weight:700;text-align:right">'+esc(histData(Date.now()))+'</span></div>'+
      '</div>';
    html+='<button type="button" id="lhPdf" class="pdf-btn" style="margin-top:14px">'+ICO_PDF+' Baixar em PDF</button>';
    html+='<div class="plc-msg" style="font-size:11px;color:#94a3b8;margin-top:8px">Dados informados pelas bases consultadas na data da geração. Uso restrito à avaliação de procedência do veículo, conforme a LGPD.</div>';
    return html;
  }
  function leilaoHistCanvas(dd){
    var p=leilaoHistParse(dd);
    var docm=(p.dados[1]&&p.dados[1][1])||'';
    var modelo=(p.dados[0]&&p.dados[0][1])||'';
    var W=1000, pad=44, iw=W-2*pad;
    var cv=document.createElement('canvas'); cv.width=W; cv.height=5200; var g=cv.getContext('2d');
    g.fillStyle='#ffffff'; g.fillRect(0,0,W,5200); g.textAlign='left';
    var HH=182;
    g.fillStyle='#001e50'; g.fillRect(0,0,W,HH);
    g.fillStyle='#0a4da6'; g.fillRect(0,HH-6,W,6);
    g.fillStyle='#9fc3ff'; g.font='700 23px system-ui,-apple-system,Arial'; g.fillText('CONSULTA DE LEILÃO', pad, 50);
    g.font='500 21px system-ui,-apple-system,Arial'; g.textAlign='right'; g.fillText('Gerado em '+histData(Date.now()), W-pad, 50); g.textAlign='left';
    g.fillStyle='#ffffff'; g.font='800 56px system-ui,-apple-system,Arial'; g.fillText(docm, pad, 120);
    g.fillStyle='#cfe0ff'; g.font='500 22px system-ui,-apple-system,Arial'; g.fillText(modelo||'Passagem por leilão · sinistro e risco', pad, 156);
    var y=HH+38;
    /* banner */
    var al=p.passou, sbh=110;
    g.fillStyle=al?'#fef2f2':'#f0fdf4'; _rr(g,pad,y,iw,sbh,16); g.fill();
    g.strokeStyle=al?'#fecaca':'#bbf7d0'; g.lineWidth=2; _rr(g,pad,y,iw,sbh,16); g.stroke();
    g.fillStyle=al?'#dc2626':'#16a34a'; _rr(g,pad+1,y+1,9,sbh-2,5); g.fill();
    g.fillStyle=al?'#b91c1c':'#15803d'; g.font='800 32px system-ui,-apple-system,Arial'; g.fillText(al?'Veículo COM registro de leilão':'Sem registro de leilão', pad+34, y+44);
    g.fillStyle=al?'#7f1d1d':'#166534'; g.font='500 21px system-ui,-apple-system,Arial';
    g.fillText(al?('Foram encontradas '+p.qtd+' ocorrência(s). Investigue a origem antes de comprar.'):'Não foi encontrada passagem por leilão nas bases consultadas.', pad+34, y+80);
    y+=sbh+28;
    /* SINISTRO (destaque vermelho quando consta) */
    if(p.sinistro && p.sinistro.existe){
      g.font='500 20px system-ui,-apple-system,Arial';
      var _sl=_wrapLines(g, p.sinistro.descricao||'Existe ocorrência de sinistro registrada para este veículo. Peça a vistoria cautelar antes de fechar negócio.', iw-80);
      var _sd=(p.sinistro.detalhes||[]).slice(0,5);
      var _sh=64+_sl.length*26+_sd.length*27+14;
      g.fillStyle='#fef2f2'; _rr(g,pad,y,iw,_sh,16); g.fill(); g.strokeStyle='#fecaca'; g.lineWidth=2; _rr(g,pad,y,iw,_sh,16); g.stroke();
      g.fillStyle='#b91c1c'; _rr(g,pad+1,y+1,9,_sh-2,5); g.fill();
      g.font='800 30px system-ui,-apple-system,Arial'; g.fillStyle='#b91c1c'; g.fillText('Consta indício de SINISTRO', pad+34, y+42);
      g.fillStyle='#7f1d1d'; g.font='500 20px system-ui,-apple-system,Arial'; var _sy=y+72;
      _sl.forEach(function(ln){ g.fillText(ln,pad+34,_sy); _sy+=26; });
      _sd.forEach(function(d){ var dl=d; var df=19; g.font='600 '+df+'px system-ui,-apple-system,Arial'; while(g.measureText('• '+dl).width>iw-80&&df>13){ df--; g.font='600 '+df+'px system-ui,-apple-system,Arial'; } g.fillText('• '+dl,pad+34,_sy); _sy+=27; g.font='500 20px system-ui,-apple-system,Arial'; });
      y+=_sh+22;
    } else if(p.conhecido){
      var _sh2=58;
      g.fillStyle='#f0fdf4'; _rr(g,pad,y,iw,_sh2,14); g.fill(); g.strokeStyle='#bbf7d0'; g.lineWidth=2; _rr(g,pad,y,iw,_sh2,14); g.stroke();
      g.fillStyle='#166534'; g.font='700 22px system-ui,-apple-system,Arial'; g.fillText('Sinistro: nada consta nas bases consultadas.', pad+24, y+37);
      y+=_sh2+22;
    }
    /* análise de risco */
    if(p.parecer){
      var rc2=p.temAlerta?['#dc2626','#fef2f2','#fecaca']:['#16a34a','#f0fdf4','#bbf7d0'];
      g.font='700 22px system-ui,-apple-system,Arial';
      var pl=_wrapLines(g,p.parecer,iw-44); var rh=54+pl.length*28;
      g.fillStyle=rc2[1]; _rr(g,pad,y,iw,rh,14); g.fill(); g.strokeStyle=rc2[2]; g.lineWidth=2; _rr(g,pad,y,iw,rh,14); g.stroke();
      g.fillStyle=rc2[0]; g.font='700 18px system-ui,-apple-system,Arial'; g.fillText('ANÁLISE DE RISCO', pad+20, y+30);
      g.fillStyle='#0f172a'; g.font='700 22px system-ui,-apple-system,Arial'; var ry=y+58; pl.forEach(function(ln){ g.fillText(ln, pad+20, ry); ry+=28; });
      y+=rh+28;
    }
    /* registros */
    if(p.regs.length){
      _accTit(g,'Registros encontrados ('+p.regs.length+')',pad,y); y+=26;
      p.regs.forEach(function(r,i){
        var al2=_lhAlerta(r.condicao)||_lhAlerta(r.chassiSit);
        var linhas=[ r.data?['Data do leilão',r.data]:null, r.comitente?['Comitente',r.comitente]:null, r.condicao?['Condição do veículo',r.condicao]:null, r.chassiSit?['Situação do chassi',r.chassiSit]:null, r.classif?['Classificação',r.classif]:null, r.lote?['Lote',r.lote]:null, r.leiloeiro?['Leiloeiro',r.leiloeiro]:null ].filter(Boolean);
        var rowH=40, bh=54+linhas.length*rowH;
        g.fillStyle='#ffffff'; _rr(g,pad,y,iw,bh,14); g.fill(); g.strokeStyle=al2?'#fecaca':'#e8eef7'; g.lineWidth=2; _rr(g,pad,y,iw,bh,14); g.stroke();
        g.fillStyle=al2?'#dc2626':'#0a4da6'; _rr(g,pad+1,y+1,8,bh-2,4); g.fill();
        g.fillStyle='#0f172a'; g.font='800 24px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText('Registro '+(i+1), pad+26, y+38);
        var ly=y+54+18;
        linhas.forEach(function(kv){
          var alv=(kv[0].indexOf('Condição')>=0&&_lhAlerta(kv[1]))||(kv[0].indexOf('chassi')>=0&&_lhAlerta(kv[1]));
          g.fillStyle='#94a3b8'; g.font='500 20px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(kv[0], pad+26, ly);
          var vf=21; g.font=(alv?'800 ':'700 ')+vf+'px system-ui,-apple-system,Arial'; while(g.measureText(kv[1]).width>iw*0.52&&vf>13){ vf--; g.font=(alv?'800 ':'700 ')+vf+'px system-ui,-apple-system,Arial'; }
          g.fillStyle=alv?'#b91c1c':'#0f172a'; g.textAlign='right'; g.fillText(kv[1], W-pad-26, ly); g.textAlign='left';
          ly+=rowH;
        });
        y+=bh+12;
      });
      y+=16;
    }
    /* dados do veículo */
    var dd2=(p.dados||[]).filter(function(r){ return r[1]!=null&&String(r[1]).trim(); });
    if(dd2.length){
      _accTit(g,'Dados do veículo',pad,y); y+=24;
      var pd=18, dh=dd2.length*46+12;
      g.fillStyle='#f8fafc'; _rr(g,pad,y,iw,dh,16); g.fill(); g.strokeStyle='#eef2f7'; g.lineWidth=1.5; _rr(g,pad,y,iw,dh,16); g.stroke();
      var dy=y+7;
      dd2.forEach(function(r,i){ var mid=dy+23;
        g.fillStyle='#64748b'; g.font='500 20px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(r[0], pad+pd, mid+6);
        var vf=20; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; while(g.measureText(String(r[1])).width>iw*0.55&&vf>13){ vf--; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; }
        g.fillStyle='#0f172a'; g.textAlign='right'; g.fillText(String(r[1]), W-pad-pd, mid+6); g.textAlign='left';
        if(i<dd2.length-1){ g.strokeStyle='#f1f5f9'; g.lineWidth=1.5; g.beginPath(); g.moveTo(pad+pd,dy+46); g.lineTo(W-pad-pd,dy+46); g.stroke(); }
        dy+=46;
      });
      y+=dh+30;
      /* 🔴 19/08 — no PDF a etiqueta importa MAIS que na tela: o documento
         sai da mão do lojista e vai pro cliente com data de hoje no rodapé. */
      if(p.completado && p.completado.texto){
        g.fillStyle='#94a3b8'; g.font='500 17px system-ui,-apple-system,Arial'; g.textAlign='left';
        y=_wrapText(g, p.completado.texto, pad+4, y-18, iw-8, 22)+18;
      }
    }
    /* abrangência / fonte da consulta */
    _accTit(g,'Abrangência da consulta',pad,y); y+=24;
    var abTxt='Verifica se o veículo já passou por leilão — de seguradora (perda total), financeira (retomada) ou judicial, além de remarketing — e se há indício de sinistro registrado. Cobre registros nacionais consolidados.';
    g.font='500 20px system-ui,-apple-system,Arial'; var abL=_wrapLines(g,abTxt,iw-36);
    var abRows=[];
    if(p.indice) abRows.push(['Índice de risco',p.indice]);
    abRows.push(['Gerado em',histData(Date.now())]);
    var abH=16+abL.length*26+10+abRows.length*38+10;
    g.fillStyle='#f8fafc'; _rr(g,pad,y,iw,abH,16); g.fill(); g.strokeStyle='#eef2f7'; g.lineWidth=1.5; _rr(g,pad,y,iw,abH,16); g.stroke();
    g.fillStyle='#475569'; g.font='500 20px system-ui,-apple-system,Arial'; g.textAlign='left'; var aby=y+30; abL.forEach(function(ln){ g.fillText(ln,pad+18,aby); aby+=26; });
    aby+=6;
    abRows.forEach(function(r){
      g.fillStyle='#94a3b8'; g.font='500 18px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(r[0],pad+18,aby+22);
      var vf=19; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; while(g.measureText(String(r[1])).width>iw*0.5&&vf>13){ vf--; g.font='700 '+vf+'px system-ui,-apple-system,Arial'; }
      g.fillStyle=(r[0].indexOf('Status')>=0?'#15803d':'#0f172a'); g.textAlign='right'; g.fillText(String(r[1]),W-pad-18,aby+22); g.textAlign='left';
      aby+=38;
    });
    y+=abH+30;
    g.fillStyle='#94a3b8'; g.font='400 18px system-ui,-apple-system,Arial'; g.textAlign='center';
    y=_wrapText(g,'Dados informados pelas bases consultadas na data da geração. Uso restrito à avaliação de procedência do veículo, conforme a LGPD.', W/2, y+8, iw-40, 26)+12;
    g.textAlign='left';
    var out=document.createElement('canvas'); out.width=W; out.height=Math.min(5200,Math.max(480,y)); out.getContext('2d').drawImage(cv,0,0); return out;
  }
  function leilaoHistBaixarPDF(){
    if(!_mevPdfPronto(leilaoHistBaixarPDF,false)) return;
    try{
      var cv=leilaoHistCanvas(_leilaoHistState||{});
      var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'pt',format:'a4'});
      var pw=pdf.internal.pageSize.getWidth(), ph=pdf.internal.pageSize.getHeight(), m=20, iw=pw-2*m;
      var pageH=Math.floor(cv.width*(ph-2*m)/iw), sy=0, first=true;
      while(sy<cv.height){
        var sh=Math.min(pageH, cv.height-sy);
        var tmp=document.createElement('canvas'); tmp.width=cv.width; tmp.height=sh;
        tmp.getContext('2d').drawImage(cv,0,sy,cv.width,sh,0,0,cv.width,sh);
        if(!first) pdf.addPage();
        pdf.addImage(tmp.toDataURL('image/jpeg',0.92),'JPEG',m,m,iw,iw*sh/cv.width);
        sy+=sh; first=false;
      }
      var pl=leilaoHistParse(_leilaoHistState||{}); var pplaca=(pl.dados&&pl.dados[1]&&pl.dados[1][1])||'placa';
      var nome='Leilao-'+String(pplaca).replace(/[^A-Z0-9]/gi,'').slice(0,8)+'.pdf';
      var u=URL.createObjectURL(pdf.output('blob')), a=document.createElement('a'); a.href=u; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },800);
      toast('PDF baixado.');
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }

  /* ================= CONSULTA SIMPLES DE CNPJ (grátis · base pública Receita) ========= */
  var _cnpjState=null;
  /* 🔴 v643 — SUBIU DE ESCOPO DE PROPÓSITO. O `_cnpjAuto` nasceu dentro do
     `cnpjWire` (v387) e guarda o último CNPJ que já foi consultado de graça —
     é ele que impede a consulta automática de sair duas vezes pro mesmo
     número. O `_cnpjDoHistorico` (abaixo) precisa MARCAR esse número antes de
     escrever no campo; se não marcasse, escrever ali dispararia a consulta
     grátis de novo e o resultado salvo do histórico seria sobrescrito por um
     recém-chegado — a pessoa veria a tela piscar sem entender por quê. */
  var _cnpjAuto='';
  /* v643: qual CNPJ veio do histórico (pra linha de aviso sumir se a pessoa
     digitar outro). Mesma mecânica do CPF na v611. */
  var _cnpjHistDoc='';
  var _cnpjSaidaFoco=null;
  function cnpjSaidaHtml(){
    var icoCompliance=(typeof _CT_ICO!=='undefined'&&_CT_ICO.cnpjcompliance)?_CT_ICO.cnpjcompliance:_CNPJ_ICO_PREDIO;
    var icoProcessos=(typeof _CT_ICO!=='undefined'&&_CT_ICO.cnpjprocessos)?_CT_ICO.cnpjprocessos:_CNPJ_ICO_PREDIO;
    return '<div class="consulta-saida-overlay" id="cnpjSaidaOverlay" hidden>'+
      '<div class="consulta-saida-sheet cnpj-saida-sheet" role="dialog" aria-modal="true" aria-labelledby="cnpjSaidaTitulo" aria-describedby="cnpjSaidaTexto">'+
      '<span class="consulta-saida-kicker">ANTES DE SAIR</span>'+
      '<h2 id="cnpjSaidaTitulo">Deseja fazer outra pesquisa desta empresa?</h2>'+
      '<p id="cnpjSaidaTexto">Aprofunde a análise usando o mesmo CNPJ. A consulta só será cobrada depois da confirmação.</p>'+
      '<button type="button" class="consulta-saida-principal" id="cnpjSaidaCompliance">'+icoCompliance+'<span><strong>Compliance Complete</strong><small>Crédito, restrições e listas públicas.</small></span></button>'+
      '<div class="consulta-saida-divisor"><span>Outra pesquisa disponível</span></div>'+
      '<button type="button" class="consulta-saida-sugestao" id="cnpjSaidaProcessos">'+icoProcessos+'<span><strong>Ações e processos</strong><small>Processos judiciais vinculados à empresa.</small></span><span class="consulta-saida-seta" aria-hidden="true">›</span></button>'+
      '<button type="button" class="consulta-saida-sair" id="cnpjSaidaSair">Não, voltar ao Início</button>'+
      '</div></div>';
  }
  function cnpjSaidaOcultar(){
    var ov=$('cnpjSaidaOverlay'); if(!ov) return;
    ov.hidden=true; try{ document.body.classList.remove('consulta-saida-on'); }catch(_){}
    try{ if(_cnpjSaidaFoco&&_cnpjSaidaFoco.focus) _cnpjSaidaFoco.focus(); }catch(_){}
    _cnpjSaidaFoco=null;
  }
  function cnpjSaidaExecutar(destino){
    var inp=$('cnpjDoc'), doc=inp?String(inp.value||'').replace(/\D/g,'').slice(0,14):'';
    cnpjSaidaOcultar();
    if(destino){ setTimeout(function(){ try{ consIr(destino,doc); }catch(_){} },0); return; }
    voltarHome();
  }
  function cnpjSaidaMostrar(){
    var ov=$('cnpjSaidaOverlay'); if(!ov){ voltarHome(); return; }
    _cnpjSaidaFoco=document.activeElement; ov.hidden=false;
    try{ document.body.classList.add('consulta-saida-on'); }catch(_){}
    var pri=$('cnpjSaidaCompliance'); try{ if(pri) pri.focus({preventScroll:true}); }catch(_){}
  }
  function cnpjSaidaWire(){
    var ov=$('cnpjSaidaOverlay'), cp=$('cnpjSaidaCompliance'), pr=$('cnpjSaidaProcessos'), sair=$('cnpjSaidaSair');
    if(cp) cp.onclick=function(){ cnpjSaidaExecutar('cnpjcompliance'); };
    if(pr) pr.onclick=function(){ cnpjSaidaExecutar('cnpjprocessos'); };
    if(sair) sair.onclick=function(){ cnpjSaidaExecutar(''); };
    if(!ov) return;
    ov.onclick=function(e){ if(e.target===ov) cnpjSaidaOcultar(); };
    ov.onkeydown=function(e){
      if(e.key==='Escape'){ e.preventDefault(); cnpjSaidaOcultar(); return; }
      if(e.key!=='Tab') return;
      var f=ov.querySelectorAll('button:not([disabled])'); if(!f.length) return;
      var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}
      else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}
    };
  }
  var _cnpjFrases=['🔎 Buscando na base da Receita…','🏢 Lendo os dados cadastrais…','📍 Conferindo endereço e CNAE…','👥 Listando os sócios…','✅ Quase lá…'];
  function _fmtCnpj(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,14); var o=d.slice(0,2); if(d.length>2)o+='.'+d.slice(2,5); if(d.length>5)o+='.'+d.slice(5,8); if(d.length>8)o+='/'+d.slice(8,12); if(d.length>12)o+='-'+d.slice(12,14); return o; }
  /* v387: miolo e fiação separados — usados na página (celular) E na coluna
     da tela inicial (computador). Mesmo desenho da consulta de CPF no 03. */
  /* ===== 🔴 v641 (pedido do Angelo, 25/08) — O RISCO DE CRÉDITO GANHOU PÁGINA
     ==========================================================================
     "CRIE UMA PAGINA E UM CARD PRA ANALISE DE RISCO CNPJ"

     Até aqui o Risco de crédito era um BOTÃO ESCONDIDO dentro da Consulta
     CNPJ: ele só nascia depois que o CNPJ completo estava digitado, embaixo do
     resultado grátis da Receita. Quem não soubesse que ele existe não achava.
     E é a consulta mais cara da casa (9,75 tokens) — a que mais precisa ser
     encontrada, não a que menos.

     🔑 DUAS PÁGINAS, UM MIOLO SÓ. A tentação era escrever uma tela nova. Seria
     um segundo campo de CNPJ, uma segunda máscara, uma segunda fiação, um
     segundo histórico — e daí a pouco os dois divergem, que é exatamente o
     defeito que a v625 gastou uma versão inteira pra matar na home.
     Então o `cnpjInnerHtml` passou a receber QUAL página está montando, e o
     que muda é só a ORDEM das peças. Campo, máscara, fiação, histórico e a
     `gerarCnpjRisco` são os MESMOS objetos.

     O QUE MUDA NA PÁGINA DO RISCO:
       · o botão pago vem LOGO DEPOIS DO CAMPO, não no fim da página — é o
         assunto dela, tem que ser a primeira coisa que o dedo alcança;
       · ele NASCE VISÍVEL (desabilitado até os 14 números), pra a página não
         parecer que não tem o que fazer — a mesma lição da v618, quando o
         Angelo disse que campo invisível faz a tela parecer vazia;
       · a consulta GRÁTIS da Receita continua rodando sozinha e o resultado
         dela fica ABAIXO: ela identifica a empresa antes de alguém gastar
         9,75 tokens. Saber o nome de quem se vai consultar é o que impede
         consultar o CNPJ errado.

     🔴🔴 A REGRA Nº 1 DA CASA (v585) NÃO SE MEXEU: **consulta paga nunca sai
     sozinha.** O auto-disparo desta tela vale só pra grátis; o risco continua
     esperando o dedo, nas duas páginas. */
  var CNPJ_PAGS={
    /* v768 (projeto animacao-campos-e-cnpj, §6.1): "Consulta CNPJ" sem o
       "(Dados)"; a gratuidade virou o SELO ao lado do título + o CTA */
    dados:{ titulo:'Consulta CNPJ', selo:'GRÁTIS', sub:'Dados cadastrais e situação na Receita Federal' },
    risco:{ titulo:'Análise de risco · CNPJ', sub:'Score, alertas e pendências · '+precoReal(5.71) },
    /* v1000 — a página do produto novo. Reaproveita o MIOLO da página de
       risco (campo, máscara, fiação, histórico) pela mesma razão da v641:
       tela nova seria um segundo campo de CNPJ que um dia diverge do
       primeiro. O que muda é o CTA, o produto e o resultado. */
    compliance:{ titulo:'Compliance Complete · CNPJ', sub:'Score, protestos, negativações e listas de compliance · '+precoReal(12.67) },
    /* v1024 — ações e processos da EMPRESA. Mesmo miolo (campo, máscara,
       fiação, histórico) pela mesma razão da v641 e da v1000: tela nova seria
       um segundo campo de CNPJ que um dia diverge do primeiro. */
    processos:{ titulo:'Ações e processos · CNPJ', sub:'Processos judiciais em que a empresa é parte · '+precoReal(5.43) },
    sintegra:{ titulo:'Inscrição Estadual · Sintegra', sub:'IE, situação cadastral e regime estadual · '+precoReal(0.58) }
  };
  var _cnpjPagAtual='dados';
  /* ===== v753 — PADRÃO UNIFICADO, Versão E: CNPJ =========================
     docs/PROJETO-2026-08-29-padrao-unificado-paginas-de-consulta.txt
     As duas páginas (Dados · Risco) na casca do 02c. O MIOLO continua um só:
     campo (cnpjField/cnpjDoc/cnpjProg), linha "veio do histórico"
     (cnpjDocHist), botão grátis (.cnpj-btn), botão do risco (cnpjRiscoBt),
     cnpjResult, cnpjRiscoResult, cnpjHist — MESMOS IDs, mesma fiação.
       DADOS: campo → "O que a consulta inclui" → CTA "Consultar empresa —
         grátis" (nasce desligado; liga aos 14 números) → confiança →
         #cnpjResult → o botão do risco (secundário, aparece aos 14 números,
         como sempre) → #cnpjRiscoResult → #cnpjHist.
       RISCO: campo → "O que a consulta inclui" → CTA "Risco de crédito —
         9,75 tokens" (nasce desligado; liga aos 14 — e NUNCA dispara sozinho)
         → confiança → #cnpjRiscoResult → #cnpjResult (a identificação grátis
         da empresa, que continua saindo sozinha aos 14) → #cnpjHist.
     A consulta grátis continua automática aos 14 números (é grátis); o CTA
     dela serve pra consultar de novo / quando veio do histórico. */
  function cnpjInnerHtml(qual){
    var ehCmpl=(qual==='compliance');
    var ehProc=(qual==='processos');   /* v1024 */
    var ehSintegra=(qual==='sintegra');
    var ehRisco=(qual==='risco');
    var landingChave=ehSintegra?'cnpjsintegra':(ehProc?'cnpjprocessos':(ehCmpl?'cnpjcompliance':(ehRisco?'cnpjrisco':'cnpj')));
    var jaExplicou=consultaUiTemLanding(landingChave);
    /* v768 (§6.2): o rótulo é VISÍVEL (não só placeholder) e o placeholder
       encurtou — o antigo ("00.000.000/0000-00 — ou o nome pra buscar")
       aparecia cortado no celular */
    var campo='<label class="consulta-ui-label" for="cnpjDoc">CNPJ ou nome da empresa</label>'
      +'<div class="cnpj-field com-lupa" id="cnpjField">'
        +_icoBusca
        /* v682: inputmode text — o mesmo campo busca por NOME no histórico */
        +'<input id="cnpjDoc" class="cnpj-inp" data-consulta-anim="cnpj" inputmode="text" autocomplete="off" placeholder="Digite o CNPJ ou nome" aria-label="CNPJ ou nome da empresa" data-cu-min="18">'
        +'<div class="cnpj-prog"><i id="cnpjProg"></i></div>'
      +'</div>'
      +'<div id="cnpjDocHist" class="cpf3-veio" style="display:none" role="status">'
        +'<span class="cpf3-veio-ic" aria-hidden="true">↩</span><span>CNPJ trazido do histórico — confira antes de consultar</span>'
      +'</div>';
    /* v768 (§6.3): exatamente TRÊS linhas — o bloco encolheu sem perder o essencial */
    var itensDados=['Situação cadastral e dados da empresa','Endereço, contatos, CNAE e porte','Sócios, capital e inscrição estadual'];
    var itensRisco=['Score de crédito PJ com a faixa e a fonte','Concessão de crédito: a recomendação do birô','Alertas, restrições e pendências financeiras','Situação na Receita, faturamento e porte'];
    /* v1000 — o que ESTE produto entrega, sem prometer o que ele não garante:
       cada linha é um bloco que pode voltar "fonte não respondeu". */
    var itensCmpl=['Score de crédito PJ com a leitura do birô','Protestos em cartório e negativações','Listas de compliance: CEIS, CNEP, TCU, PEP, IBAMA, MPT','Quem andou consultando este CNPJ'];
    /* v1024 — o que ESTE card promete antes de pagar (§5.8 do projeto) */
    var itensProc=['Processos judiciais em que a empresa aparece como parte','Se ela é AUTORA ou RÉ em cada um','Tribunal, vara, assunto e valor da causa','Situação: em tramitação ou arquivado, com data'];
    var itensSintegra=['Inscrição estadual e UF','Situação cadastral do contribuinte','Regime de apuração e obrigatoriedade de NFe','Atividade principal e endereço estadual'];
    /* o botão grátis: CTA visível na página dos Dados; na do Risco fica escondido (a grátis sai sozinha aos 14) */
    var btGratis=((ehRisco||ehCmpl||ehProc||ehSintegra)
        ? '<button type="button" class="cnpj-btn" style="'+BTN_STYLE+';display:none">Consultar empresa — grátis</button>'
        : consultaUiCta({ id:'cnpjBtGratis', classe:'cnpj-btn', verbo:'Consultar empresa', gratis:true, disabled:true }).replace('id="cnpjBtGratis"','id="cnpjBtGratis" data-cu-reqs="cnpjDoc"'))
      +'<div id="cnpjResult" aria-live="polite"></div>';
    /* 🔴🔴 o botão do risco (9,75 tk) NUNCA dispara sozinho (regra v585). Na página
       do risco é o CTA principal (desligado até os 14); na dos Dados nasce
       escondido e aparece aos 14, embaixo do resultado grátis (v595/v641). */
    var btRisco=(ehRisco
        ? consultaUiCta({ id:'cnpjRiscoBt', rotulo:_cnpjRiscoRotulo(), disabled:true }).replace('id="cnpjRiscoBt"','id="cnpjRiscoBt" data-cu-reqs="cnpjDoc"')
        : consultaUiCta({ id:'cnpjRiscoBt', classe:'consulta-ui-cta-sec', rotulo:_cnpjRiscoRotulo() }).replace('<button ','<button style="display:none" '))
      +'<div id="cnpjRiscoResult" aria-live="polite"></div>';
    /* 🔴🔴 A REGRA Nº 1 DA CASA (v585) VALE AQUI TAMBÉM: consulta paga nunca
       sai sozinha. O CTA do compliance nasce DESLIGADO e só liga aos 14
       números — e mesmo ligado espera o dedo. A grátis da Receita é que roda
       sozinha, e é ela que impede consultar o CNPJ errado por R$ 24,07. */
    var btCmpl=(ehCmpl
        ? (consultaUiCta({ id:'cnpjCmplBt', rotulo:_cnpjCmplRotulo(), disabled:true }).replace('id="cnpjCmplBt"','id="cnpjCmplBt" data-cu-reqs="cnpjDoc"')
           +'<div id="cnpjCmplResult" aria-live="polite"></div>')
        : '');
    /* v1024 — MESMA REGRA Nº 1 (v585): nasce DESLIGADO, liga aos 14 números e
       ainda assim espera o dedo. A grátis da Receita é que roda sozinha, e é
       ela que impede consultar o CNPJ errado. */
    var btProc=(ehProc
        ? (consultaUiCta({ id:'cnpjProcBt', rotulo:_cnpjProcRotulo(), disabled:true }).replace('id="cnpjProcBt"','id="cnpjProcBt" data-cu-reqs="cnpjDoc"')
           +'<div id="cnpjProcResult" aria-live="polite"></div>')
        : '');
    var btSintegra=(ehSintegra
        ? (consultaUiCta({ id:'cnpjSintegraBt', rotulo:_cnpjSintegraRotulo(), disabled:true }).replace('id="cnpjSintegraBt"','id="cnpjSintegraBt" data-cu-reqs="cnpjDoc"')
           +'<div id="cnpjSintegraResult" aria-live="polite"></div>')
        : '');
    var form=campo
      +(jaExplicou?'':consultaUiBeneficios(ehSintegra?itensSintegra:(ehProc?itensProc:(ehCmpl?itensCmpl:(ehRisco?itensRisco:itensDados)))))
      +(ehSintegra
        ? (btSintegra+consultaUiTrust('Base estadual consultada na data da pesquisa · a identificação gratuita da empresa aparece abaixo')+btGratis)
        : ehProc
        ? (btProc+consultaUiTrust('Tribunais e diários oficiais na data da consulta · a identificação da empresa (grátis) aparece abaixo')+btGratis)
        : ehCmpl
        ? (btCmpl+consultaUiTrust('Birô de crédito, cartórios e listas públicas na data da consulta · a identificação da empresa (grátis) aparece abaixo')+btGratis)
        : ehRisco
        ? (btRisco+consultaUiTrust('Birô de crédito e Receita Federal na data da consulta · a identificação da empresa (grátis) aparece abaixo')+btGratis)
        /* v768 (§6.5, REMOÇÃO APROVADA): a linha "Fonte pública: Receita
           Federal · nenhum token é cobrado" SAIU da página de dados — com o
           selo GRÁTIS no título e no CTA ela só ocupava espaço. Nada entra
           no lugar. O trust da página de RISCO fica. */
        : (btGratis+btRisco))
      +consultaUiHistoricoCard('cnpjHist',{ texto:'Veja e reabra consultas de empresa' })
      +(qual==='dados'?cnpjSaidaHtml():'');
    return consultaUiCard(form, { id:'cnpjCard' })
      /* v996 — a Consulta CNPJ não oferece mais o Risco de crédito ao lado:
         o produto saiu do app. O desenho da página de risco continua neste
         arquivo, inerte, mas nada aponta pra ele. */
      +consultaUiRelacionadas(ehSintegra?'cnpjsintegra':(ehProc?'cnpjprocessos':(ehCmpl?'cnpjcompliance':(ehRisco?'cnpjrisco':'cnpj'))),'empresa',{ preferir:['cnpj'] });
  }
  var _CNPJ_ICO_PREDIO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>';
  function abrirCnpjPag(qual){
    var P=CNPJ_PAGS[qual]?qual:'dados';
    _cnpjPagAtual=P;
    var ico=(P==='sintegra' && typeof _CT_ICO!=='undefined' && _CT_ICO.cnpjsintegra) ? _CT_ICO.cnpjsintegra
          : (P==='processos' && typeof _CT_ICO!=='undefined' && _CT_ICO.cnpjprocessos) ? _CT_ICO.cnpjprocessos
          : (((P==='risco'||P==='compliance') && typeof _CT_ICO!=='undefined' && _CT_ICO.cnpjrisco) ? _CT_ICO.cnpjrisco : _CNPJ_ICO_PREDIO);
    /* v753 — Versão E do padrão (02c): celular sem grade antes do formulário; computador com a barrinha lateral */
    consultaUiPagina({ chave:(P==='sintegra'?'cnpjsintegra':(P==='processos'?'cnpjprocessos':(P==='compliance'?'cnpjcompliance':(P==='risco'?'cnpjrisco':'cnpj')))), tab:'completa', voltar:'home', ico:ico, cor:'blue', titulo:CNPJ_PAGS[P].titulo, selo:CNPJ_PAGS[P].selo||'', sub:CNPJ_PAGS[P].sub },
      '<div id="cnpjWrap">'+cnpjInnerHtml(P)+'</div>');
    cnpjWire();
    if(P==='dados'){
      cnpjSaidaWire();
      /* v1349 — sair da consulta cadastral oferece aprofundamentos, mas
         nenhuma pesquisa paga parte daqui: cada opção abre sua página e
         continua sujeita à confirmação canônica de valor. */
      voltarTab(cnpjSaidaMostrar);
    }
    try{ consultaUiSync(); }catch(_){}
  }
  /* ===== 🔴 v643 (pedido do Angelo, 25/08, com o print da página do risco) ==
     "QUANDO ABRO UMA CONSULTA RECENTE ELE JÁ MOSTRA O CNPJ NO CAMPO PRA FAZER
      A ANALISE DE CREDITO DO CNPJ"

     No print: a empresa inteira na tela — razão social, situação, dados
     cadastrais — e o campo em cima ainda dizendo "Digite ou cole o CNPJ".
     Pra pedir o risco de crédito DAQUELA empresa era preciso digitar de novo
     um número que já estava ali embaixo, na tela, escrito.

     🔴 É O MESMO BURACO QUE A v611 TAPOU NO CPF, e o CNPJ nunca recebeu o
     conserto. Reabrir do histórico enchia o RESULTADO mas deixava o CAMPO
     vazio — e é o campo que a consulta paga lê. */
  function _cnpjDoHistorico(doc){
    var i=$('cnpjDoc'); if(!i) return;
    var dg=String(doc||'').replace(/\D/g,''); if(dg.length!==14) return;
    /* ⚠️ MARCA ANTES DE ESCREVER: o `_cnpjAuto` é o que impede a consulta
       grátis de sair de novo quando o campo chega aos 14 números. Sem esta
       linha, reabrir do histórico re-consultaria a Receita e jogaria fora o
       resultado salvo que a pessoa acabou de mandar abrir. */
    _cnpjAuto=dg;
    _cnpjHistDoc=dg;
    i.value=_fmtCnpj(dg);
    /* dispara o MESMO ouvinte de quem digita: pinta a barrinha, acende o
       verde do campo cheio e destrava o botão do risco — sem repetir aqui
       nenhuma linha da lógica que já existe. */
    try{ i.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
    var av=$('cnpjDocHist'); if(av) av.style.display='flex';
  }
  function abrirCnpj(){ abrirCnpjPag('dados'); }
  function abrirCnpjRisco(){ abrirCnpjPag('risco'); }
  function cnpjResultadoVoltar(qual,doc,limpar){
    abrirCnpjPag(qual); if(limpar) return;
    setTimeout(function(){ try{ _cnpjDoHistorico(doc); var i=$('cnpjDoc'); if(i) i.blur(); }catch(_){} },0);
  }
  function cnpjResultadoAbrir(qual,doc,resultado,ts,reaberta){
    qual=CNPJ_PAGS[qual]?qual:'dados'; var painel='', titulo=CNPJ_PAGS[qual].titulo;
    if(qual==='dados'){ _cnpjState=resultado; painel=cnpjPanelHtml(resultado); }
    else if(qual==='compliance'){ _cnpjCmplState=resultado; painel=cnpjCmplPanelHtml(resultado); }
    else if(qual==='sintegra'){ _cnpjSintegraState=resultado; painel=cnpjSintegraPanelHtml(resultado); }
    else if(qual==='processos'){
      _cnpjProcState={ documento:doc, tipo_doc:'CNPJ_PROCESSOS', data:((resultado&&resultado.data)||resultado||{}) };
      painel=cpfProcPanelHtml(_cnpjProcState, true);
    }else{ _cnpjRiscoState=resultado; painel=cnpjRiscoPanelHtml(resultado); }
    var pdfAcao=function(modo){ cnpjResultadoPdfAcao(qual,modo); };
    var cfg={ chave:qual==='dados'?'cnpj':qual==='compliance'?'cnpjcompliance':qual==='processos'?'cnpjprocessos':qual==='sintegra'?'cnpjsintegra':'cnpjrisco',
      titulo:titulo, identificacao:'CNPJ '+_fmtCnpj(doc), dataHora:histData(ts||Date.now()), origem:reaberta?'Resultado salvo':'',
      resumoHtml:consultaResultadoResumo({ tom:'ok', titulo:'Consulta concluída', texto:qual==='dados'?'Dados cadastrais disponíveis.':'Resultado disponível para análise.' }),
      secoesHtml:consultaResultadoSecao({ titulo:'Resultado da consulta', classe:qual==='dados'?'consulta-resultado-secao-cnpj':'', html:painel }),
      aoVoltar:function(){ cnpjResultadoVoltar(qual,doc,false); }, aoNovaConsulta:function(){ cnpjResultadoVoltar(qual,'',true); },
      acoes:[
        {id:'cnpjPdfVisualizar',rotulo:'Visualizar PDF',icone:'ver',somenteIcone:true,primaria:true,acao:function(){ pdfAcao('visualizar'); }},
        {id:'cnpjPdfBaixar',rotulo:'Baixar PDF',icone:'baixar',somenteIcone:true,acao:function(){ pdfAcao('baixar'); }},
        {id:'cnpjPdfCompartilhar',rotulo:'Compartilhar PDF',icone:'compartilhar',somenteIcone:true,acao:function(){ pdfAcao('compartilhar'); }}
      ] };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
    var raiz=$('consultaResultadoPagina')||document;
    try{ _cpfBlocosLigar(raiz); }catch(_){}
    var pb=raiz.querySelector(qual==='dados'?'#cnpjPdf':qual==='processos'?'#cpfProcPdf':qual==='sintegra'?'#cnpjSintegraPdf':'#cnpjRiscoPdf');
    if(pb) pb.onclick=function(){ if(qual==='dados') cnpjBaixarPDF(); else if(qual==='processos') cnpjProcBaixarPDF(); else if(qual==='sintegra') cnpjSintegraPdfAcao('baixar'); else cnpjRiscoBaixarPDF(); };
    if(!reaberta && qual==='dados') consultaOfertaToast({
      titulo:'Deseja fazer uma análise de crédito?',
      texto:'Use o mesmo CNPJ para consultar risco, score e pendências. O valor será mostrado antes da confirmação.',
      rotulo:'Analisar crédito',
      acao:function(){ consultaResultadoFechar(false); setTimeout(function(){ abrirCnpjPag('risco'); setTimeout(function(){ _cnpjDoHistorico(doc); },0); },0); }
    });
  }
  function cnpjResultadoPdfAcao(qual,modo){
    if(qual==='dados'){ cnpjPdfAcaoDe(_cnpjState||{},modo); return; }
    if(qual==='processos'){ cnpjProcPdfAcao(modo); return; }
    if(qual==='sintegra'){ cnpjSintegraPdfAcao(modo); return; }
    if(qual==='compliance'){ cnpjCmplPdfAcao(modo); return; }
    cnpjRiscoPdfAcao(modo);
  }
  function cnpjWire(){
    /* ⚠️ v643 — ZERAR AQUI É OBRIGATÓRIO. O `_cnpjAuto` subiu pro escopo do
       módulo pra o histórico poder marcá-lo; se ele não fosse zerado a cada
       montagem da tela, o valor sobreviveria de uma abertura pra outra e
       digitar de novo o MESMO CNPJ deixaria de disparar a consulta grátis —
       a tela ficaria muda sem motivo. Antes, o `var` dentro desta função
       fazia isso sozinho; agora é explícito. */
    _cnpjAuto=''; _cnpjHistDoc='';
    var inp=$('cnpjDoc'); if(inp){
      /* v643: o `_cnpjAuto` agora mora lá em cima (ver o comentário dele) */
      var _cnpjPinta=function(dg){
        var f=$('cnpjField'), pr=$('cnpjProg'); if(!f) return;
        f.classList.toggle('tem', dg.length>0);
        if(pr) pr.style.width=Math.min(100,Math.round(dg.length/14*100))+'%';
        var cheio=(dg.length===14);
        if(cheio && !f.classList.contains('full')){ f.classList.add('full','flash'); setTimeout(function(){ f.classList.remove('flash'); },620); }
        if(!cheio) f.classList.remove('full');
        /* v643: digitou outro número? a marca do histórico não vale mais */
        if(_cnpjHistDoc && dg!==_cnpjHistDoc){
          _cnpjHistDoc='';
          var av=$('cnpjDocHist'); if(av) av.style.display='none';
        }
        /* v595: o botão do Risco acompanha o campo — aparece, mas NÃO dispara.
           🔴 v641: na PÁGINA DO RISCO ele está sempre visível e o que o campo
           liga/desliga é o `disabled` — a página não pode parecer vazia (v618).
           ⚠️ Na página dos DADOS nada mudou: continua aparecendo aos 14.
           E o `_cnpjRiscoOcupado` existe porque a `gerarCnpjRisco` também usa
           o `disabled` como trava de toque único: sem ele, o pintor do campo
           reabilitaria o botão no meio de uma consulta em andamento. */
        /* v753: os CTAs do padrão acompanham o campo — e o "cheio" daqui manda
           (o sync olha o tamanho do texto; um NOME longo não é CNPJ) */
        try{ consultaUiSync(); }catch(_){}
        var rb=$('cnpjRiscoBt');
        if(rb && !_cnpjRiscoOcupado){
          if(_cnpjPagAtual==='risco'){ rb.style.display=''; rb.disabled=!cheio; }
          else rb.style.display=cheio?'':'none';
        }
        var gb=$('cnpjBtGratis'); if(gb && !gb.classList.contains('is-loading')) gb.disabled=!cheio;
      };
      /* ===== v682 — O MESMO CAMPO BUSCA NO HISTÓRICO ======================
         Pedido 28/08 (decisão: SÓ o campo do CNPJ filtrando, sem campo novo).
         Tem LETRA → é busca por nome: o campo NÃO é reformatado (o _fmtCnpj
         apagaria as letras), a barrinha não anda e NENHUMA consulta sai.
         Só dígito → tudo como sempre foi (formata, pinta, consulta grátis
         aos 14) — e o histórico embaixo vai filtrando junto, o que mostra
         "você já consultou esta empresa" ANTES de repetir a consulta. */
      var _cnpjTry=function(){
        var bruto=String(inp.value||'');
        if(/[A-Za-zÀ-ÿ]/.test(bruto)){
          _cnpjAuto='';
          _cnpjPinta('');
          try{ cnpjHistRender(bruto); }catch(_){}
          return;
        }
        inp.value=_fmtCnpj(inp.value); var dg=inp.value.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); _cnpjPinta(dg);
        try{ cnpjHistRender(dg); }catch(_){}
        if(dg.length===14){ if(dg!==_cnpjAuto){ _cnpjAuto=dg; var bb=$('cnpjWrap')?$('cnpjWrap').querySelector('.cnpj-btn'):null; if(bb&&!bb.disabled) gerarCnpj(bb); } } else { _cnpjAuto=''; } };
      inp.oninput=_cnpjTry;
      inp.addEventListener('paste',function(){ setTimeout(_cnpjTry,0); });
      /* v387: dentro da coluna do computador ninguém "rouba" o foco da placa */
      try{ if(!(inp.closest&&inp.closest('#consCols'))) inp.focus(); }catch(_){}
    }
    var pb=$('cnpjPaste'); if(pb) pb.onclick=function(){ cnpjColar(); };
    var b=$('cnpjWrap')?$('cnpjWrap').querySelector('.cnpj-btn'):null; if(b) b.onclick=function(){ gerarCnpj(b); };
    var rb=$('cnpjRiscoBt'); if(rb) rb.onclick=function(){ gerarCnpjRisco(rb); };
    var cb=$('cnpjCmplBt'); if(cb) cb.onclick=function(){ gerarCnpjCompliance(cb); };
    var pb2=$('cnpjProcBt'); if(pb2) pb2.onclick=function(){ gerarCnpjProcessos(pb2); };   /* v1024 */
    var sb=$('cnpjSintegraBt'); if(sb) sb.onclick=function(){ gerarCnpjSintegra(sb); };
    cnpjHistRender();
    try{ cnpjHistCarregarNuvem(); }catch(_){}
    try{ cnpjRiscoNuvem(); }catch(_){}   /* v595: o diário do risco também sincroniza */
  }
  async function cnpjColar(){
    var inp=$('cnpjDoc'); if(!inp) return;
    try{ var t=(navigator.clipboard&&navigator.clipboard.readText)?await navigator.clipboard.readText():''; if(t&&/\d/.test(t)){ inp.value=_fmtCnpj(t); try{inp.focus();}catch(_){} return; } throw 0; }
    catch(_){ toast('Não consegui colar automático. Segure no campo e toque em "Colar", ou digite.'); try{inp.focus();}catch(e){} }
  }
  /* COMPLETA os dados do CNPJ: a base da Receita costuma vir SEM rua, número,
     complemento, telefone e e-mail. Busca o que faltar na fonte reserva (cnpja).
     Usada na consulta NOVA e também ao REABRIR uma consulta antiga do histórico. */
  async function cnpjCompletar(d){
    try{
      if(!d || !d.cnpj) return d;
      if(d.logradouro && d.numero && d.ddd_telefone_1 && d.email) return d;   /* já está completo */
      var doc=String(d.cnpj).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(doc.length!==14) return d;
      var r9=await fetch('https://open.cnpja.com/office/'+doc); if(!r9.ok) return d;
      var c9=await r9.json(); var e9=c9.address||{}; var p9=(c9.phones&&c9.phones[0])||null; var p9b=(c9.phones&&c9.phones[1])||null; var m9=(c9.emails&&c9.emails[0]&&c9.emails[0].address)||'';
      if(!d.logradouro && e9.street) d.logradouro=e9.street;
      if(!d.numero && e9.number) d.numero=e9.number;
      if(!d.complemento && e9.details) d.complemento=e9.details;
      if(!d.bairro && e9.district) d.bairro=e9.district;
      if(!d.municipio && e9.city) d.municipio=e9.city;
      if(!d.uf && e9.state) d.uf=e9.state;
      if(!d.cep && e9.zip) d.cep=e9.zip;
      if(!d.ddd_telefone_1 && p9) d.ddd_telefone_1=String(p9.area||'')+String(p9.number||'');
      if(!d.ddd_telefone_2 && p9b) d.ddd_telefone_2=String(p9b.area||'')+String(p9b.number||'');
      if(!d.email && m9) d.email=m9;
    }catch(_){}
    return d;
  }
  async function gerarCnpj(btn){
    var inp=$('cnpjDoc'); var doc=inp?String(inp.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''):'';
    var res=$('cnpjResult');
    if(doc.length!==14){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CNPJ com 14 números.</div>'; return; }
    consultaUiBotao(btn,'carregando','Consultando empresa…');   /* v753 */
    if(res) res.innerHTML=ccLoaderHtml('Consultando empresa…',_cnpjFrases,_SVG_PREDIO); var lt=ccLoaderStart(_cnpjFrases);
    var d=null, nf=false;
    try{ var r=await fetch('https://brasilapi.com.br/api/cnpj/v1/'+doc,{headers:{Accept:'application/json'}}); if(r.ok){ d=await r.json(); } else if(r.status===404){ nf=true; } }catch(_){}
    if(d && d.cnpj) d=await cnpjCompletar(d);
    clearInterval(lt);
    consultaUiBotao(btn,'pronto','Consultar empresa — grátis');
    if(nf){ consultaUiBotao(btn,'erro'); if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">CNPJ não encontrado na base da Receita.</div>'; return; }
    if(!d||!d.cnpj){ consultaUiBotao(btn,'erro'); if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Não consegui consultar agora. Tente de novo em instantes.</div>'; return; }
    consultaUiBotao(btn,'novamente','Consultar novamente — grátis');
    _cnpjState=d;
    try{ cnpjHistSalvar(_cnpjHistItem(d)); cnpjHistRender(); }catch(_){}
    try{ await cnpjBuscarIE(doc); }catch(_){}
    try{ cnpjVirarCliente(d); }catch(_){}   /* v355: a consulta já vira ficha de cliente */
    cnpjResultadoAbrir('dados',doc,d,Date.now(),false);
  }

  /* ======================================================================
     v355 — CONSULTOU O CNPJ, JÁ NASCE A FICHA DO CLIENTE
     Antes o lojista consultava a empresa, via os dados na tela e depois
     digitava tudo de novo na página Clientes. Agora a consulta grava
     sozinha: razão social, CNPJ, telefone, e-mail e o endereço inteiro.
     Se a empresa JÁ tem ficha (casa pelo CNPJ ou pelo telefone), nada é
     duplicado — só os campos que estavam VAZIOS são preenchidos. O que
     foi digitado à mão nunca é sobrescrito.
     ====================================================================== */
  async function cnpjVirarCliente(d){
    if(!d || !d.cnpj || typeof meuId==='undefined' || !meuId) return null;
    var docDig=String(d.cnpj).replace(/\D/g,''); if(docDig.length!==14) return null;
    function _t(v){ v=String(v==null?'':v).trim(); return (v && v.toLowerCase()!=='null') ? v : ''; }
    function _fone(v){ v=String(v||'').replace(/\D/g,''); return v.length>=10 ? v : ''; }
    var tipoLog=_t(d.descricao_tipo_de_logradouro), nomeLog=_t(d.logradouro);
    var rua=(tipoLog && nomeLog && nomeLog.toUpperCase().indexOf(tipoLog.toUpperCase())!==0) ? (tipoLog+' '+nomeLog) : nomeLog;
    var novo={
      nome: _t(d.razao_social) || _t(d.nome_fantasia) || 'Empresa',
      cpf: docDig,
      telefone: _fone(d.ddd_telefone_1) || _fone(d.ddd_telefone_2),
      email: _t(d.email).toLowerCase(),
      cep: _t(d.cep).replace(/\D/g,''),
      rua: rua, numero: _t(d.numero), complemento: _t(d.complemento),
      bairro: _t(d.bairro), cidade: _t(d.municipio), uf: _t(d.uf),
      origem: 'Consulta CNPJ'
    };
    try{
      /* já existe? procura pelo CNPJ e, se não achar, pelo telefone */
      var achado=null;
      var r1=await supa.from('clientes').select('*').eq('user_id',meuId).eq('cpf',docDig).limit(1);
      if(r1 && r1.data && r1.data.length) achado=r1.data[0];
      if(!achado && novo.telefone){
        var r2=await supa.from('clientes').select('*').eq('user_id',meuId).limit(500);
        var sig=novo.telefone.slice(-8);
        achado=((r2&&r2.data)||[]).filter(function(c){
          return String(c.telefone||'').replace(/\D/g,'').slice(-8)===sig; })[0]||null;
      }

      if(achado){
        /* SÓ preenche buraco: nada do que o lojista escreveu é apagado */
        var patch={};
        Object.keys(novo).forEach(function(k){
          if(k==='nome'||k==='origem') return;
          if(novo[k] && !_t(achado[k])) patch[k]=novo[k];
        });
        if(!Object.keys(patch).length){ cnpjAvisoCliente(achado,'ja'); _cnpjToastCliente('ja'); return achado; }
        patch.atualizado_em=new Date().toISOString();
        var ru=await supa.from('clientes').update(patch).eq('id',achado.id).select().single();
        var atualizado=(ru&&ru.data)||achado;
        cnpjAvisoCliente(atualizado,'atualizado'); _cnpjToastCliente('atualizado');
        return atualizado;
      }

      novo.user_id=meuId;
      novo.anotacoes=[{ t:'Cadastro criado pela Consulta CNPJ ('+_fmtCnpj(docDig)+')', ts:new Date().toISOString() }];
      var ri=await supa.from('clientes').insert(novo).select().single();
      if(ri && ri.error) throw ri.error;
      var criado=(ri&&ri.data)||null;
      if(criado){ try{ mtEspelhar(criado); }catch(_){} cnpjAvisoCliente(criado,'novo'); _cnpjToastCliente('novo'); }
      return criado;
    }catch(e){ return null; }
  }
  var CNPJ_AVISO_CLIENTE = false;  /* ⛳ v682 — a faixa verde saiu da tela
     (pedido 28/08: "ocultar esse campo que aparece e o botao abrir ficha").
     🔴 O CADASTRO AUTOMÁTICO DA v355 CONTINUA — o cnpjVirarCliente está
     intacto; quem avisa agora é o toast, que subiu pra lá (uma linha por
     chamada). A faixa era explicação na tela (regra da casa) e ainda
     chegava ATRASADA: o resultado aparecia, o async ia ao banco e a faixa
     entrava POR CIMA, empurrando o nome da empresa pra baixo no meio da
     leitura. PRA VOLTAR: true — o desenho inteiro está guardado abaixo. */
  /* a faixinha verde acima do resultado, com atalho pra ficha */
  function cnpjAvisoCliente(c, tipo){
    if(!CNPJ_AVISO_CLIENTE) return;   /* v682: só o desenho morre aqui */
    if(!c) return;
    var txt = tipo==='novo' ? 'Cliente cadastrado a partir desta consulta'
            : (tipo==='atualizado' ? 'Cadastro do cliente completado com estes dados'
            : 'Esta empresa já está nos seus clientes');
    var res=$('cnpjResult'); if(!res) return;
    var velho=res.querySelector('.cnpj-cli-aviso'); if(velho) velho.remove();
    var box=document.createElement('div');
    box.className='cnpj-cli-aviso';
    box.style.cssText='display:flex;align-items:center;gap:10px;background:#ecfdf5;border:1px solid #a7f3d0;border-radius:12px;padding:10px 13px;margin:0 0 10px';
    box.innerHTML='<span style="flex:1;min-width:0;font-size:12.5px;color:#065f46;line-height:1.35;overflow-wrap:anywhere">'+
      '<b style="display:block;font-size:13px;color:#047857">'+esc(txt)+'</b>'+esc(c.nome||'')+'</span>'+
      '<button type="button" style="flex:none;background:#059669;color:#fff;border:0;border-radius:9px;padding:8px 13px;font-size:12.5px;font-weight:700;font-family:inherit;cursor:pointer">Abrir ficha</button>';
    var b=box.querySelector('button');
    if(b) b.onclick=function(){
      try{ Promise.resolve(telaClientes()).then(function(){
        try{ crmFichaAbrir(c.id); }catch(_){ try{ cliAbrirFicha(c.id); }catch(_){} }
      }); }catch(_){}
    };
    res.insertBefore(box, res.firstChild);
    /* v682: o toast SAIU daqui — mora junto de cada chamada, no
       cnpjVirarCliente. A função de desenhar só desenha (armadilha 1.4 do
       projeto: cortar a função no topo matava o aviso junto). */
  }
  /* v682 — o aviso que sobrevive à faixa: o app nunca cadastra calado */
  function _cnpjToastCliente(tipo){
    try{ toast(tipo==='ja' ? 'Empresa já cadastrada nos Clientes.' : 'Salvo em Clientes ✓'); }catch(_){}
  }

  /* ==========================================================================
     v637 — O QUE NASCE AQUI ARRUMA A TELA **E** O PDF
     ==========================================================================
     Pedido do Angelo (25/08, com dois PDFs reais na mão): "melhore a
     visualizacao dos dados".

     🔑 O `cnpjParse` alimenta os DOIS desenhos — o painel da tela e a folha
     do PDF. Então cada conserto feito aqui vale em dobro. É o melhor tipo de
     conserto que existe neste app: um ponto, dois efeitos.

     O que foi consertado, na ordem em que dói:

     🔴 DATA EM FORMATO DE COMPUTADOR. A folha saía com "2005-11-03" no meio
        de um documento em português com "R$ 50.000,00". Quem lê com pressa
        entende 11 de março. Agora: 03/11/2005.

     🔴 SILÊNCIO NÃO É "NÃO". O `bool()` devolvia string vazia quando a base
        não respondia, e o filtro de vazios apagava a linha inteira. Dois PDFs
        do MESMO app, no mesmo dia: um mostra "Simples Nacional: Não", o outro
        não tem a linha. Quem compara os dois não tem como saber se a empresa
        não é Simples ou se ninguém perguntou. Numa decisão de crédito, é a
        diferença entre uma informação e um chute.
        Agora campo PREVISTO que não veio aparece como "Não informado".
        ⚠️ Vale só pro previsto. Empresa sem sócios não inventa card de sócios.

     🔴 ZERO FORMATADO ENGANA MELHOR QUE BRANCO. A base pública preenche
        buraco com zero, e o formatador transformava "0000000000" no telefone
        bem desenhado "(00) 00000-0000" — em negrito, do lado de um telefone
        de verdade. Alguém liga. Ou pior: conclui que o app conferiu.
        Vazio some; isto PARECE informação. Agora zeros não viram telefone,
        nem CEP, nem capital social.

     · A IDADE DA EMPRESA. "Aberta em 06/04/2026" obriga uma subtração. Pra
       quem decide repasse com uma loja desconhecida, **4 meses de casa é a
       informação** — e "30 anos" também é. Data sozinha é dado; data com o
       tempo decorrido é resposta.
       ⚠️ Só a idade, sem julgamento: empresa nova não é empresa ruim. O app
       informa; quem decide é o lojista.
     ========================================================================= */
  /* '2005-11-03' → '03/11/2005'. Já formatado ou vazio passa direto. */
  function _cnpjData(v){
    var t=String(v==null?'':v).trim();
    if(!t) return '';
    var m=t.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? (m[3]+'/'+m[2]+'/'+m[1]) : t;
  }
  /* quanto tempo faz — em anos, ou em meses quando ainda não fez um ano */
  function _cnpjIdade(v){
    var t=String(v==null?'':v).trim(); if(!t) return '';
    var m=t.match(/^(\d{4})-(\d{2})-(\d{2})/) || t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if(!m) return '';
    var dt = m[0].indexOf('-')>0 ? new Date(+m[1], +m[2]-1, +m[3]) : new Date(+m[3], +m[2]-1, +m[1]);
    if(isNaN(dt.getTime())) return '';
    var hoje=new Date();
    var meses=(hoje.getFullYear()-dt.getFullYear())*12 + (hoje.getMonth()-dt.getMonth());
    if(hoje.getDate() < dt.getDate()) meses--;
    if(meses < 0) return '';
    if(meses < 12) return meses<=1 ? (meses===1?'1 mês':'menos de 1 mês') : (meses+' meses');
    var anos=Math.floor(meses/12);
    return anos===1 ? '1 ano' : (anos+' anos');
  }
  /* 🔴 zero não é dado: '0000000000', '00000000', '0' e afins são buraco que a
     base preencheu, não informação. Devolve '' pra quem quiser sumir com o
     campo, ou o chamador troca por "Não informado". */
  function _cnpjSoZero(v){
    var t=String(v==null?'':v).replace(/\D/g,'');
    return !t || /^0+$/.test(t);
  }
  var CNPJ_SEM_RESPOSTA='Não informado';

  function cnpjParse(d){
    d=d||{};
    var sit=String(d.descricao_situacao_cadastral||'').toUpperCase();
    var ativa=/ATIVA/.test(sit);
    var ender=[d.logradouro,d.numero].filter(Boolean).join(', ')+(d.complemento?(' - '+d.complemento):'');
    /* 🔴 previsto e não respondido vira "Não informado" — nunca some */
    function bool(v){
      if(v===true||/^sim$/i.test(String(v))) return 'Sim';
      if(v===false||/^n[aã]o$/i.test(String(v))) return 'Não';
      return CNPJ_SEM_RESPOSTA;
    }
    var ident=[
      ['Nome fantasia', d.nome_fantasia],
      ['CNPJ', _fmtCnpj(d.cnpj||'')],
      ['Situação cadastral', (d.descricao_situacao_cadastral||'')+(d.data_situacao_cadastral?(' desde '+_cnpjData(d.data_situacao_cadastral)):'')],
      ['Data de abertura', _cnpjData(d.data_inicio_atividade)+(_cnpjIdade(d.data_inicio_atividade)?(' ('+_cnpjIdade(d.data_inicio_atividade)+')'):'')],
      ['Natureza jurídica', d.natureza_juridica],
      ['Porte', d.descricao_porte||d.porte],
      /* capital zerado é buraco preenchido pela base, não capital de R$ 0,00 */
      ['Capital social', (d.capital_social!=null&&d.capital_social!==''&&Number(d.capital_social)>0)?('R$ '+Number(d.capital_social).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2})):CNPJ_SEM_RESPOSTA],
      ['Simples Nacional', bool(d.opcao_pelo_simples)],
      ['MEI', bool(d.opcao_pelo_mei)]
    ];
    if(d._ie && d._ie.length){ var _ieTxt=d._ie.map(function(x){ return x.numero+(x.uf?(' ('+x.uf+')'):'')+(x.enabled===false?' · baixada':''); }).join(' · '); ident.splice(2,0,['Inscrição estadual', _ieTxt]); }
    /* v165: CNAE vira LISTA (um item por linha) em vez de um paragrafao */
    var atividade=[];
    if(d.cnae_fiscal||d.cnae_fiscal_descricao) atividade.push(['CNAE principal', { lista:[{ cod:String(d.cnae_fiscal||''), des:String(d.cnae_fiscal_descricao||'') }] }]);
    /* CNAEs secundários (se houver) — agora TODOS, um por linha */
    var sec=(d.cnaes_secundarios||[]).filter(function(c){ return c && (c.descricao||c.codigo); });
    if(sec.length){ atividade.push(['CNAEs secundários ('+sec.length+')', { lista: sec.map(function(c){ return { cod:String(c.codigo||''), des:String(c.descricao||'') }; }) }]); }
    /* endereço COMPLETO: junta o tipo do logradouro (RUA/AV) e formata o CEP */
    var tipoLog=String(d.descricao_tipo_de_logradouro||'').trim(), nomeLog=String(d.logradouro||'').trim();
    var ruaFull=(tipoLog && nomeLog && nomeLog.toUpperCase().indexOf(tipoLog.toUpperCase())!==0)?(tipoLog+' '+nomeLog):nomeLog;
    var ender2=[ruaFull,d.numero].filter(Boolean).join(', ');
    var cepTxt=(d.cep && !_cnpjSoZero(d.cep))?((typeof cepFmt==='function')?cepFmt(String(d.cep)):String(d.cep)):'';
    /* 🔴 telefone só de zeros, ou curto demais pra ser telefone, NÃO é
       telefone. Formatado, ele fica bonito e mente. */
    function _fone(v){
      v=String(v||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
      if(!v) return '';
      if(_cnpjSoZero(v) || v.length<10) return CNPJ_SEM_RESPOSTA;
      return (typeof foneFmt==='function')?foneFmt(v):v;
    }
    var endereco=[
      ['Endereço', ender2||ender], ['Complemento', d.complemento], ['Bairro', d.bairro],
      ['Município / UF', String(d.municipio||'')+(d.uf?(' / '+d.uf):'')],
      ['CEP', cepTxt]
    ];
    var contato=[
      ['Telefone', _fone(d.ddd_telefone_1)],
      ['Telefone 2', _fone(d.ddd_telefone_2)],
      ['E-mail', d.email?String(d.email).toLowerCase():'']
    ];
    /* v682: .trim() nos dois pontos — um nome de sócio feito só de espaço
       passava no filtro (espaço é truthy), o título dizia "Sócios (1)" e o
       kitLista, que apara antes de desenhar, descartava o item: contador
       sem conteúdo, o pior defeito de documento (régua da v637). */
    var socios=(d.qsa||[]).map(function(s){ return { nome:String(s.nome_socio||s.nome||'').trim(), qual:String(s.qualificacao_socio||'').trim() }; }).filter(function(s){ return s.nome; });
    return { ativa:ativa, sit:d.descricao_situacao_cadastral||'', razao:d.razao_social||'',
             fantasia:String(d.nome_fantasia||'').trim(),
             /* v637 — a faixa da folha diz "ATIVA desde 03/11/2005" em vez de
                repetir "ATIVA" que já está do lado esquerdo */
             sitDesde:(d.descricao_situacao_cadastral||'')+(d.data_situacao_cadastral?(' desde '+_cnpjData(d.data_situacao_cadastral)):''),
             abertura:_cnpjData(d.data_inicio_atividade), idade:_cnpjIdade(d.data_inicio_atividade),
             cnpjFmt:_fmtCnpj(d.cnpj||''),
             ident:ident, atividade:atividade, endereco:endereco, contato:contato, socios:socios };
  }
  function cnpjPanelHtml(d){
    var p=cnpjParse(d);
    var icoAtiva='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.7 2.7L16.5 9"/></svg>';
    var icoAlerta='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.6 2.5 17a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>';
    var banner = p.ativa
      ? '<div class="cnpj-resultado-status is-ativa"><div class="cnpj-resultado-status-titulo">'+icoAtiva+'<span>Empresa ATIVA</span></div><div class="cnpj-resultado-status-apoio">'+esc(p.sit)+'</div></div>'
      : '<div class="cnpj-resultado-status is-alerta"><div class="cnpj-resultado-status-titulo">'+icoAlerta+'<span>Situação: '+esc(p.sit||'—')+'</span></div><div class="cnpj-resultado-status-apoio">Confira a situação da empresa antes de negociar.</div></div>';
    /* v165: um valor pode ser texto simples OU {lista:[{cod,des}]} (CNAEs) */
    function _cnpjVazio(v){ if(v==null) return true; if(v&&v.lista) return !v.lista.length; var t=String(v).trim(); return !t||t.toLowerCase()==='null'; }
    function _cnpjValor(v){
      if(v&&v.lista) return '<div style="margin-top:3px">'+v.lista.map(function(it,j){
        return '<div style="display:flex;gap:6px;align-items:baseline;'+(j?'margin-top:4px;padding-top:4px;border-top:1px dashed #eef2f7;':'')+'">'+
          (it.cod?'<span style="flex:none;font-size:10px;font-weight:800;color:#0a4da6;background:#eef4ff;border-radius:5px;padding:2px 5px;font-family:ui-monospace,Menlo,Consolas,monospace">'+esc(it.cod)+'</span>':'')+
          '<span style="flex:1;min-width:0;font-size:11.8px;font-weight:500;color:#0f172a;line-height:1.32;overflow-wrap:anywhere">'+esc(it.des)+'</span></div>';
      }).join('')+'</div>';
      /* v355: e-mail e site são UMA palavra só e não quebravam — passavam por
         cima da borda do cartão. overflow-wrap:anywhere quebra onde precisar e
         o e-mail sai um pouco menor, que é onde o estouro sempre acontecia. */
      var t=String(v), umaPalavra=(t.indexOf(' ')<0 && t.length>26);
      /* v393 (pedido): a ficha cadastral do CNPJ SEM negrito nos valores */
      return '<div style="font-size:'+(umaPalavra?'11.2':'12.6')+'px;font-weight:500;color:#0f172a;margin-top:1px;line-height:1.3;overflow-wrap:anywhere;word-break:break-word">'+esc(v)+'</div>';
    }
    /* ======================================================================
       🔴 v637 — OS BLOCOS VIRARAM CARDS QUE ABREM
       ======================================================================
       Pedido do Angelo: "mostre os dados gerados em campos colapsaveis
       semelhante a ficha tecnica".

       🔑 ZERO PEÇA NOVA. O `_cpfBloco` / `_cpfBlocosLigar` (03-ficha-tecnica)
       já montam o `.fic-item` da ficha técnica desde a v253, a v608 os pôs
       nas três páginas de CPF e a v628 nas três de veículo. O app inteiro é
       UM IIFE só: este arquivo enxerga aquelas funções sem importar nada.
       ⚠️ E NÃO criei a quinta cópia do HTML de card que já existe quatro
       vezes no app (03:549 · 03:1356 · 07:2177 · 14:2163). Unificar as quatro
       é limpeza de outra versão; mexer em quatro telas por estética é trocar
       risco por nada.

       🔴 A FAIXA DE SITUAÇÃO NÃO COLAPSA. "Empresa ATIVA" é o veredito — é a
       razão de a consulta existir. Card que esconde o veredito obriga um
       toque pra responder a única pergunta que já estava respondida. Mesma
       regra do gravame (v628): o veredito vem primeiro, grande; o resto é
       detalhe.
       ✅ "Dados da empresa" nasce ABERTO: é o que 9 em 10 consultas querem.
       ⚠️ O contador no título ("Sócios (2)") não é enfeite — card fechado sem
       número esconde que existe conteúdo lá dentro.
       ====================================================================== */
    function corpo(rows){
      rows=rows.filter(function(r){ return !_cnpjVazio(r[1]); });
      if(!rows.length) return '';
      return '<div style="background:#fff;border:1px solid #e8eef7;border-radius:12px;overflow:hidden">'+
        rows.map(function(r,i){ return '<div style="padding:7px 12px;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><div style="font-size:9.5px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:.3px">'+esc(r[0])+'</div>'+_cnpjValor(r[1])+'</div>'; }).join('')+'</div>';
    }
    function card(titulo,rows,aberto){
      var c=corpo(rows);
      if(!c) return '';   /* empresa sem telefone não desenha card vazio */
      return _cpfBloco(titulo, c, !!aberto);
    }
    /* 🔴 a razão social é o identificador da tela: grande, e o fantasia
       embaixo em cinza. A hierarquia estava invertida (item 4.3). */
    var html='<div style="font-size:17px;font-weight:800;color:#001e50;margin:2px 2px 0;line-height:1.22">'+esc(p.razao||'—')+'</div>'+
      (p.fantasia?'<div style="font-size:12px;color:#64748b;font-weight:600;margin:1px 2px 0">'+esc(p.fantasia)+'</div>':'')+
      banner;
    html+='<div id="cnpjBlocos">';
    html+=card('Dados da empresa', p.ident, true);
    var nCnae=0; try{ p.atividade.forEach(function(r){ if(r[1]&&r[1].lista) nCnae+=r[1].lista.length; }); }catch(_){}
    html+=card('Atividade (CNAE)'+(nCnae>1?(' ('+nCnae+')'):''), p.atividade, false);
    html+=card('Endereço', p.endereco, false);
    html+=card('Contato', p.contato, false);
    if(p.socios.length){
      /* 🔴 a pessoa é o dado; o cargo é o detalhe. Estava invertido: o cargo
         aparecia como etiqueta e o nome como valor (item 4.5). */
      var listaSocios='<div style="background:#fff;border:1px solid #e8eef7;border-radius:12px;overflow:hidden">'+p.socios.map(function(s,i){ return '<div style="padding:7px 12px;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><div style="font-size:12.6px;font-weight:700;color:#0f172a;line-height:1.3">'+esc(s.nome)+'</div>'+(s.qual?'<div style="font-size:10.6px;color:#64748b;margin-top:1px">'+esc(s.qual)+'</div>':'')+'</div>'; }).join('')+'</div>';
      html+=_cpfBloco('Sócios ('+p.socios.length+')', listaSocios, false);
    }
    html+='</div>';
    /* 🔴 SEM a classe .pdf-btn, de propósito — e este é o conserto do
       segundo pedido. O botão SEMPRE existiu aqui; quem o apagava era
       `#cardVeiculo .pdf-btn{display:none!important}` (styles.css:1029), a
       regra que transforma todos os "Baixar em PDF" dos resultados no FAB
       flutuante. Mexer NELA traria o botão de volta em uma dúzia de telas de
       uma vez, cada uma com dois caminhos pro mesmo download.
       A saída é a da v595, já usada em cinco telas: botão próprio, estilo
       próprio, sempre visível. Esta era a última página que faltava.
       ⚠️ O FAB continua — não é duplicação ruim: o FAB é o atalho de quem já
       rolou a página; o botão é o fim natural da leitura. */
    html+='<button type="button" id="cnpjPdf" style="width:100%;margin-top:14px;display:flex;align-items:center;justify-content:center;gap:8px;background:#fff;color:#0a4da6;border:1.5px solid #bfdbfe;border-radius:11px;padding:13px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">'+ICO_PDF+' Baixar consulta (PDF)</button>';
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Dados públicos da Receita Federal (base aberta), na data da consulta.</div>';
    return html;
  }

  /* ==========================================================================
     v595 — RISCO DE CRÉDITO CNPJ (consulta paga · 9,75 tokens · quod/cnpj)
     ==========================================================================
     PROJETO-risco-de-credito-cnpj (22/08). O servidor (consultar.js, produto
     'cnpj_risco') debita/estorna e limpa o envelope da conta; aqui é a tela.
     Decisão do Angelo (22/08, igual ao CPF): NENHUMA probabilidade aparece —
     nem 'PROBABILIDADE INADIMPLENCIA', nem 'CAPACIDADE PAGTO', nem o texto
     'A CHANCE DE UMA EMPRESA...'. O parse LÊ tudo (tolerante a grafia, com
     os _ciKey/_ciDeep do 03 — mesmo IIFE); a EXIBIÇÃO escolhe o que mostra.
     ⚠️ 1ª CONSULTA REAL: conferir o desenho contra a resposta viva — o mock
     do teste segue o formato do painel, mas base troca chave sem avisar
     (lição v449/v450). */
  /* 🔴 v648 — O PREÇO DO RISCO NUM LUGAR SÓ. Ele estava escrito à mão em
     três textos ("Risco de crédito — 9,75 tokens") e agora o SELO do card da
     home também precisa dele. Quatro cópias do mesmo número é convite pra o
     card dizer um preço e o botão dizer outro no dia em que ele mudar. */
  var CNPJ_RISCO_TOK=5.71;
  /* v1000 — Compliance Complete PJ. GÊMEO do `cnpj_compliance:12.67` do
     PRECOS (netlify/functions/consultar.js): mudar um sem o outro faz a tela
     mostrar um preço e o servidor cobrar outro.
         custo R$ 14,44 ÷ 0,60 = R$ 24,07  →  ÷ 1,90 = 12,67 unidades */
  var CNPJ_CMPL_TOK=12.67;
  function _cnpjCmplRotulo(){ return 'Consultar compliance'; }
  /* v1024 — AÇÕES E PROCESSOS · CNPJ. GÊMEO do `cnpj_processos:5.43` do PRECOS
     (netlify/functions/consultar.js): mudar um sem o outro faz a tela mostrar
     um preço e o servidor cobrar outro.
         custo R$ 6,19 ÷ 0,60 = R$ 10,3167  →  ÷ 1,90 = 5,43 unidades */
  var CNPJ_PROC_TOK=5.43;
  function _cnpjProcRotulo(){ return 'Consultar ações e processos'; }
  /* v1384 — SINTEGRA ESTADUAL. Gêmeo de `cnpj_sintegra:0.58` no servidor. */
  var CNPJ_SINTEGRA_TOK=0.58;
  function _cnpjSintegraRotulo(){ return 'Consultar inscrição estadual'; }
  var _CNPJ_PROC_FRASES=['⚖️ Procurando processos no nome da empresa…','🏛️ Lendo tribunais e varas…','📄 Conferindo classe, assunto e polo…','✅ Quase lá…'];
  var _CNPJ_CMPL_FRASES=['🏛️ Consultando as listas de compliance…','📊 Lendo score e indicadores…','🧾 Conferindo protestos e negativações…','✅ Quase lá…'];
  var _CNPJ_SINTEGRA_FRASES=['Consultando a base estadual…','Conferindo inscrição e situação cadastral…','Lendo regime e atividade econômica…','Preparando o resultado…'];

  var _cnpjSintegraState=null;
  function cnpjSintegraParse(cr){
    var d=(cr&&cr.data)||cr||{};
    var ies=[];
    if(d.ie) ies.push({ie:String(d.ie),uf:String(d.uf||''),situacaoCadastral:String(d.situacaoCadastral||''),tipoIE:String(d.tipoIE||'')});
    (Array.isArray(d.inscricoesEstaduais)?d.inscricoesEstaduais:[]).forEach(function(x){
      if(!x||!x.ie) return;
      if(ies.some(function(y){return String(y.ie)===String(x.ie)&&String(y.uf)===String(x.uf||'');})) return;
      ies.push(x);
    });
    var endereco=[d.logradouro,d.numero,d.complemento,d.bairro,d.municipio,d.uf,d.cep].filter(Boolean).join(' · ');
    return { d:d, ies:ies, endereco:endereco };
  }
  function cnpjSintegraPanelHtml(cr){
    var p=cnpjSintegraParse(cr),d=p.d;
    var situacao=String(d.situacaoCadastral||d.situacaoContribuinteNaData||'Não informada');
    var habilitada=/HABILIT|ATIV|REGULAR/i.test(situacao);
    var html='<div class="sintegra-result">';
    html+='<div class="sintegra-status '+(habilitada?'ok':'at')+'"><strong>'+esc(situacao)+'</strong><span>Situação cadastral informada pela base estadual</span></div>';
    html+='<div class="sintegra-ident"><strong>'+esc(d.nomeEmpresarial||d.nomeFantasia||'Empresa consultada')+'</strong><span>'+esc(_fmtCnpj(d.cnpj||''))+(d.nomeFantasia?' · '+esc(d.nomeFantasia):'')+'</span></div>';
    if(p.ies.length){
      html+='<div class="sintegra-lista">'+p.ies.map(function(x){return '<div class="sintegra-ie"><span>Inscrição estadual</span><strong>'+esc(x.ie)+'</strong><small>'+esc([x.uf,x.tipoIE,x.situacaoCadastral].filter(Boolean).join(' · '))+'</small></div>';}).join('')+'</div>';
    }else{
      html+='<div class="sintegra-aviso"><strong>Inscrição estadual não informada</strong><span>A base respondeu, mas não apresentou um número de IE. Isso não comprova isenção.</span></div>';
    }
    html+='<div class="sintegra-blocos">'
      +_cpfBloco('Cadastro estadual',_cnpjRiscoKv('',[
        ['Regime de apuração',d.regimeApuracao],['Início da atividade',d.dataInicioAtividade],
        ['Situação desde',d.dataSituacaoCadastral],['Obrigatoriedade de NFe',d.indicadorObrigatoriedadeNFe],
        ['Credenciamento para NFe',d.dataCredenciamentoEmissorNFe]
      ]),true)
      +_cpfBloco('Atividade econômica',_cnpjRiscoKv('',[
        ['Atividade principal',d.atividadeEconomicaPrincipal],['Natureza jurídica',d.naturezaJuridica]
      ]),false)
      +(p.endereco?_cpfBloco('Endereço cadastrado',_cnpjRiscoKv('',[['Endereço',p.endereco]]),false):'')
      +_cpfBloco('Simples e SIMEI',_cnpjRiscoKv('',[
        ['Simples Nacional',d.situacaoSimplesNacional||(d.optanteSimplesNacional===true?'Optante':d.optanteSimplesNacional===false?'Não optante':'Não informado')],
        ['SIMEI',d.situacaoSIMEI||(d.optanteSimei===true?'Enquadrado':d.optanteSimei===false?'Não enquadrado':'Não informado')]
      ]),false)
      +'</div>';
    html+='<button type="button" id="cnpjSintegraPdf" class="sintegra-pdf">'+ICO_PDF+' Baixar em PDF</button>';
    html+='<p class="sintegra-fonte">Fonte: Sintegra estadual via APIBrasil · situação na data da consulta.</p></div>';
    return html;
  }
  function cnpjSintegraPaginas(cr){
    var p=cnpjSintegraParse(cr),d=p.d;
    var st=pdfkitNovo({tipo:'Inscrição Estadual · Sintegra',doc:_fmtCnpj(d.cnpj||''),lgpdCurto:'Dados cadastrais estaduais disponíveis na data da consulta.'});
    kitVeredito(st,/HABILIT|ATIV|REGULAR/i.test(String(d.situacaoCadastral||''))?'ok':'at','Situação cadastral: '+(d.situacaoCadastral||'não informada'),'Consulte a data e os detalhes do cadastro antes de decidir.');
    kitKv2(st,'Empresa', [['Razão social',d.nomeEmpresarial],['Nome fantasia',d.nomeFantasia],['CNPJ',_fmtCnpj(d.cnpj||'')],['UF',d.uf]]);
    if(p.ies.length) kitKv2(st,'Inscrições estaduais',p.ies.map(function(x){return ['IE '+(x.uf||''),[x.ie,x.tipoIE,x.situacaoCadastral].filter(Boolean).join(' · ')];}));
    else kitAtencao(st,'A base respondeu sem informar número de inscrição estadual. Isso não comprova isenção.');
    kitKv2(st,'Cadastro estadual', [['Regime de apuração',d.regimeApuracao],['Início da atividade',d.dataInicioAtividade],['Situação desde',d.dataSituacaoCadastral],['Obrigatoriedade de NFe',d.indicadorObrigatoriedadeNFe],['Credenciamento para NFe',d.dataCredenciamentoEmissorNFe]]);
    kitKv2(st,'Atividade e endereço', [['Atividade principal',d.atividadeEconomicaPrincipal],['Natureza jurídica',d.naturezaJuridica],['Endereço',p.endereco],['Simples Nacional',d.situacaoSimplesNacional],['SIMEI',d.situacaoSIMEI]]);
    return kitFinaliza(st);
  }
  function cnpjSintegraPdfAcao(modo){
    if(!_cnpjSintegraState) return;
    if(!_mevPdfPronto(function(){cnpjSintegraPdfAcao(modo);},false)) return;
    try{
      var blob=kitPdfBlob(cnpjSintegraPaginas(_cnpjSintegraState));
      if(!blob){toast('O gerador de PDF não carregou. Tente de novo.');return;}
      var nome=nomeArquivoSeguro('Inscricao-Estadual-Sintegra','',Date.now())+'.pdf';
      pdfArquivoAcao(blob,nome,modo,function(){pdfVisor(blob,nome);},'Inscrição Estadual · Sintegra');
    }catch(_){toast('Não consegui gerar o PDF agora.');}
  }
  function cnpjSintegraHistSalvar(doc,resultado){
    try{
      var l=JSON.parse(localStorage.getItem('mev_cnpj_sintegra_hist')||'[]').filter(function(x){return String(x.doc)!==String(doc);});
      l.unshift({doc:String(doc),ts:Date.now(),resultado:resultado});
      localStorage.setItem('mev_cnpj_sintegra_hist',JSON.stringify(l.slice(0,15)));
    }catch(_){}
    try{docHistCloudSave('cnpj_sintegra',doc,'CNPJ_SINTEGRA',resultado,Date.now());}catch(_){}
  }
  function _cnpjRiscoRotulo(){ return 'Consultar risco de crédito'; }
  var _cnpjRiscoState=null;
  /* v641: "tem consulta de risco rodando agora?" — ver o comentário no pintor
     do campo (_cnpjPinta). Só a gerarCnpjRisco liga e desliga. */
  /* ==========================================================================
     🔴🔴 v1000 — COMPLIANCE COMPLETE PJ · A REGRA Nº 1 DESTA TELA
     --------------------------------------------------------------------------
     **VAZIO NÃO É LIMPO.**

     O retorno traz coisas assim:
         "protestos": [ { "total_protestos": null, "cartorios": [], … } ]
         "possui_dados_negativacoes": false
         "credito_emergencial": { "risco": "Indefinido" }

     Nada disso quer dizer "a empresa está limpa". Quer dizer "não consultei"
     ou "não voltou dado". Uma tela que imprime ✅ "Sem protestos" a partir de
     um campo nulo está AFIRMANDO O QUE O DADO NÃO DIZ — e quem paga essa
     conta é o lojista que levar calote depois de ver o selo verde.

     Por isso todo bloco desta tela tem TRÊS estados, nunca dois:
         encontrado  → a fonte respondeu E achou alguma coisa
         nada        → a fonte respondeu e não achou nada  (só com PROVA de
                       que ela respondeu: uma contagem explícita, um total 0,
                       um booleano de "consultado")
         semdado     → a fonte não respondeu — cinza, sem ícone verde, e o
                       texto diz isso com todas as letras
     Array vazio SEM confirmação cai em `semdado`. É a diferença entre
     "procurei e não achei" e "não procurei", e ela vale dinheiro.
     ========================================================================== */
  function _cmplEstado(valor, confirmado){
    /* nulo/ausente: a fonte não respondeu, ponto */
    if(valor === null || valor === undefined) return 'semdado';
    if(Array.isArray(valor)){
      if(valor.length) return 'encontrado';
      return confirmado ? 'nada' : 'semdado';
    }
    if(typeof valor === 'number'){ return valor > 0 ? 'encontrado' : 'nada'; }
    if(typeof valor === 'boolean'){ return valor ? 'encontrado' : (confirmado ? 'nada' : 'semdado'); }
    var t = String(valor).trim();
    if(!t) return 'semdado';
    /* o provedor usa estas palavras quando NÃO sabe — não são resposta */
    if(/^(indefinido|nao informado|não informado|n\/a|na|sem informacao|sem informação|null)$/i.test(t)) return 'semdado';
    return 'encontrado';
  }
  var _CMPL_SELO = {
    encontrado: ['#fee2e2','#b91c1c'],
    nada:       ['#dcfce7','#15803d'],
    semdado:    ['#f1f5f9','#516480']
  };
  function _cmplLinha(rotulo, estado, textoEncontrado){
    var c=_CMPL_SELO[estado]||_CMPL_SELO.semdado;
    var txt = estado==='encontrado' ? (textoEncontrado||'Encontrado')
            : estado==='nada'       ? 'Nada consta'
            :                         'Fonte não respondeu';
    return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 13px;background:#fff;border:1px solid #e8eef7;border-radius:12px;margin-bottom:6px">'
      +'<span style="font-size:12.4px;font-weight:600;color:#0f172a">'+esc(rotulo)+'</span>'
      +'<span style="flex:none;font-size:11.3px;font-weight:800;padding:3px 9px;border-radius:20px;background:'+c[0]+';color:'+c[1]+'">'+esc(txt)+'</span></div>';
  }
  /* pega o primeiro caminho que existir — o payload muda de forma entre
     ambientes e o fixture de homologação não é palavra final */
  function _cmplEm(o, caminhos){
    for(var i=0;i<caminhos.length;i++){
      var no=o, ok=true, parts=caminhos[i].split('.');
      for(var j=0;j<parts.length;j++){
        if(no && typeof no==='object' && parts[j] in no) no=no[parts[j]];
        else { ok=false; break; }
      }
      if(ok && no !== undefined) return no;
    }
    return undefined;
  }
  /* v1006 — a resposta real do Compliance Complete veio como
       { data:{ resultado:{ score, protestos, compliance, ... } } }
     O contrato visual nasceu lendo apenas `data`, então o relatório pago
     existia no job, mas todos os cards pintavam "Fonte não respondeu". Esta
     abertura é deliberadamente estreita: só atravessa envelopes conhecidos. */
  function _cmplRaiz(cr){
    var r=cr||{};
    for(var i=0;i<4;i++){
      if(!r || typeof r!=='object' || Array.isArray(r)) break;
      if(r.response && typeof r.response==='object' && !Array.isArray(r.response)){ r=r.response; continue; }
      if(r.dados && typeof r.dados==='object' && !Array.isArray(r.dados)){ r=r.dados; continue; }
      if(r.data && typeof r.data==='object' && !Array.isArray(r.data)){ r=r.data; continue; }
      if(r.resultado && typeof r.resultado==='object' && !Array.isArray(r.resultado)){ r=r.resultado; continue; }
      break;
    }
    return r||{};
  }
  function _cmplColecoes(valor){
    if(Array.isArray(valor)) return { confirmado:true, itens:valor };
    var itens=[], confirmado=false;
    if(valor && typeof valor==='object') Object.keys(valor).forEach(function(k){
      if(!Array.isArray(valor[k])) return;
      confirmado=true;
      valor[k].forEach(function(x){ itens.push(x); });
    });
    return { confirmado:confirmado, itens:itens };
  }
  function cnpjCmplParse(cr){
    var raiz = _cmplRaiz(cr);
    var out = { raiz:raiz };
    /* identificação — o projeto avisa: os campos de TEXTO do porte se
       contradizem no fixture (EPP num, ME no outro). O código da Receita é
       o único que não mente: 01 MEI · 03 EPP · 05 Demais. */
    out.razao  = _cmplEm(raiz, ['razao_social','nome_empresarial','nm_razao_social','dados_cadastrais.razao_social_nome_empresarial']);
    out.cnpj   = _cmplEm(raiz, ['cnpj','nr_cnpj','dados_cadastrais.cnpj_completo']);
    out.porteCd= _cmplEm(raiz, ['cd_porte_empresa','porte_codigo','firmografico.cd_porte_empresa']);
    out.abertura=_cmplEm(raiz, ['data_abertura','dt_abertura','dados_cadastrais.data_inicio_atividade']);
    /* score: MOSTRAR UM SÓ. O payload traz a faixa ("50% e 70%") e uma frase
       pronta que se contradizem aos olhos de quem lê. A frase do provedor é a
       que um leigo entende — é ela que vai pra tela. E este score NUNCA se
       mistura com o do limite-positivo-pj: escalas diferentes, mesmo CNPJ deu
       642 aqui e 800 lá. Dois números no mesmo quadradinho fazem o mesmo
       lojista parecer duas empresas. */
    out.score   = _cmplEm(raiz, ['score.score','score.pontuacao','score.numero_score','score_serasa','score.valor']);
    out.scoreFrase = _cmplEm(raiz, ['score.mensagem','score.descricao_probabilidade_pagamento','score.descricao','score.texto','score.probabilidade_texto']);
    /* os blocos com três estados */
    var prot = _cmplEm(raiz, ['protestos','protesto']);
    var protTotal = _cmplEm(raiz, ['protestos.0.total_protestos','total_protestos','quantidade_protestos']);
    out.protestos = { estado:_cmplEstado(
        (typeof protTotal==='number') ? protTotal : (Array.isArray(prot) && prot.length && Array.isArray(prot[0] && prot[0].cartorios) ? prot[0].cartorios : prot),
        (typeof protTotal==='number')),
      qtd: (typeof protTotal==='number') ? protTotal : null };
    var possuiNeg = _cmplEm(raiz, ['possui_dados_negativacoes']);
    var negs = _cmplEm(raiz, ['negativacoes','pendencias_financeiras']);
    var negColecoes = _cmplColecoes(negs);
    /* 🔴 `possui_dados_negativacoes:false` NÃO é "sem negativação" — é "não
       tenho o bloco". Só vira "nada consta" se vier junto uma lista vazia
       com confirmação, ou um total 0. */
    var negTotal = _cmplEm(raiz, ['total_negativacoes','quantidade_negativacoes']);
    out.negativacoes = { estado: (typeof negTotal==='number')
        ? _cmplEstado(negTotal, true)
        : (possuiNeg === false ? 'semdado'
          : (possuiNeg === true ? _cmplEstado(negColecoes.itens.length, true)
            : (negColecoes.itens.length ? 'encontrado' : 'semdado'))),
      qtd:(typeof negTotal==='number')?negTotal:null };
    var listas = _cmplEm(raiz, ['compliance','listas_restritivas','listas']);
    var listasColecoes = _cmplColecoes(listas);
    out.compliance = { estado:_cmplEstado(listasColecoes.itens, listasColecoes.confirmado), itens:listasColecoes.itens };
    var cons = _cmplEm(raiz, ['consultas','consultas_recentes']);
    if(Array.isArray(cons)){
      out.consultas = { estado:_cmplEstado(cons, true), qtd:cons.length };
    }else if(cons && typeof cons==='object'){
      var detalhes=Array.isArray(cons.detalhes_consultas)?cons.detalhes_consultas:[];
      var camposContagem=['contagem_consultas_ultimos_30_dias','contagem_consultas_31_a_60_dias','contagem_consultas_61_a_90_dias','contagem_consultas_mais_90_dias'];
      var temContagem=false, totalConsultas=0;
      camposContagem.forEach(function(k){ if(typeof cons[k]==='number'){ temContagem=true; totalConsultas+=cons[k]; } });
      out.consultas = temContagem
        ? { estado:_cmplEstado(totalConsultas,true), qtd:totalConsultas }
        : { estado:(detalhes.length?'encontrado':'semdado'), qtd:(detalhes.length?detalhes.length:null) };
    }else{
      out.consultas = { estado:'semdado', qtd:null };
    }
    return out;
  }
  function cnpjCmplPanelHtml(cr){
    var p=cnpjCmplParse(cr);
    var html='<div style="margin-top:12px">';
    if(p.razao){
      html+='<div style="padding:11px 13px;background:#f8fafc;border:1px solid #e8eef7;border-radius:13px;margin-bottom:9px">'
        +'<div style="font-size:13.5px;font-weight:800;color:#0f172a">'+esc(p.razao)+'</div>'
        +(p.cnpj?('<div style="font-size:11.5px;color:#64748b;margin-top:1px">'+esc(_fmtCnpj(p.cnpj))+'</div>'):'')
        +'</div>';
    }
    /* o score, com a frase do provedor — e UM número só */
    if(p.score!==undefined && p.score!==null && String(p.score).trim()!==''){
      var sv=parseInt(p.score,10)||0;
      var sc=(sv>=700)?['#16a34a','#f0fdf4','#bbf7d0']:((sv>=500)?['#d97706','#fffbeb','#fde68a']:['#dc2626','#fef2f2','#fecaca']);
      html+='<div style="background:'+sc[1]+';border:1px solid '+sc[2]+';border-radius:14px;padding:11px;margin:0 0 9px;text-align:center">'
        +'<div style="font-size:10px;font-weight:800;color:'+sc[0]+';text-transform:uppercase;letter-spacing:.5px">Score de crédito PJ</div>'
        +'<div style="font-size:32px;font-weight:900;color:'+sc[0]+';line-height:1.05;margin-top:2px">'+esc(String(p.score))+'</div>'
        +(p.scoreFrase?('<div style="font-size:11.8px;color:#475569;margin-top:4px;line-height:1.35">'+esc(String(p.scoreFrase))+'</div>'):'')
        +'</div>';
    }else{
      html+=_cmplLinha('Score de crédito PJ','semdado','');
    }
    html+=_cmplLinha('Protestos em cartório', p.protestos.estado,
            (p.protestos.qtd!=null?(p.protestos.qtd+' protesto(s)'):'Encontrado'));
    html+=_cmplLinha('Negativações', p.negativacoes.estado,
            (p.negativacoes.qtd!=null?(p.negativacoes.qtd+' ocorrência(s)'):'Encontrado'));
    html+=_cmplLinha('Listas de compliance (CEIS, CNEP, TCU, PEP…)', p.compliance.estado,
            (p.compliance.itens.length+' aparição(ões)'));
    html+=_cmplLinha('Consultas recentes ao CNPJ', p.consultas.estado,
            (p.consultas.qtd!=null?(p.consultas.qtd+' consulta(s)'):'Encontrado'));
    /* 🔴 a legenda não é enfeite: sem ela, cinza vira "tudo bem" na cabeça de
       quem lê rápido — e este produto existe pra decidir repasse. */
    html+='<div style="margin-top:10px;padding:9px 12px;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:11px;font-size:11.3px;color:#516480;line-height:1.45">'
      +'<b>Nada consta</b> = a fonte respondeu e não encontrou nada. '
      +'<b>Fonte não respondeu</b> = não foi possível verificar — <b>não</b> significa que esteja limpo.'
      +'</div>';
    html+='</div>';
    return html;
  }
  function cnpjCmplPaginas(cr){
    var p=cnpjCmplParse(cr), st=pdfkitNovo({ tipo:'Compliance Complete · CNPJ', doc:_fmtCnpj(p.cnpj||''), lgpdCurto:'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018)' });
    if(p.razao) kitKv2(st,'Identificação',[['Razão social',p.razao],['CNPJ',_fmtCnpj(p.cnpj||'')],['Abertura',p.abertura||'—']]);
    if(p.score!==undefined && p.score!==null && String(p.score).trim()!==''){
      kitScore(st,'Score de crédito PJ',String(p.score),'');
      if(p.scoreFrase) kitTexto(st,String(p.scoreFrase));
    }
    function estado(x){ return x==='nada'?'Nada consta':x==='encontrado'?'Encontrado':'Fonte não respondeu'; }
    kitKv2(st,'Compliance e restrições',[
      ['Protestos em cartório',estado(p.protestos.estado)+(p.protestos.qtd!=null?' · '+p.protestos.qtd:'')],
      ['Negativações',estado(p.negativacoes.estado)+(p.negativacoes.qtd!=null?' · '+p.negativacoes.qtd:'')],
      ['Listas públicas',estado(p.compliance.estado)],
      ['Consultas recentes',estado(p.consultas.estado)+(p.consultas.qtd!=null?' · '+p.consultas.qtd:'')]
    ]);
    return kitFinaliza(st);
  }
  function cnpjCmplPdfAcao(modo){
    if(!_cnpjCmplState) return;
    if(!_mevPdfPronto(function(){ cnpjCmplPdfAcao(modo); },false)) return;
    try{
      var blob=kitPdfBlob(cnpjCmplPaginas(_cnpjCmplState));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      var nome=nomeArquivoSeguro('Compliance-CNPJ','',Date.now())+'.pdf';
      pdfArquivoAcao(blob,nome,modo,function(){ pdfVisor(blob,nome); },'Compliance CNPJ');
    }catch(_){ toast('Não consegui gerar o PDF agora.'); }
  }
  var _cnpjRiscoOcupado=false;
  var _CNPJ_RISCO_FRASES=['🏦 Consultando o birô de crédito…','📊 Lendo score e alertas…','🧾 Conferindo pendências…','✅ Quase lá…'];
  var _CNPJ_RISCO_BLOQ=/PROBABILIDADE|CAPACIDADE\s*(DE\s*)?PAGTO|A CHANCE DE UMA EMPRESA/i;
  function cnpjRiscoParse(cr){
    cr=cr||{}; var d=cr.data||cr;
    /* score: bloco (ou lista) com pontuação + informante ("BASE I") */
    var scoB=_ciDeep(d,['Score','Scores'])||{};
    if(Array.isArray(scoB)) scoB=scoB[0]||{};
    var valor=String((_ciKey(scoB,['Score','Pontuacao','Valor'])!=null?_ciKey(scoB,['Score','Pontuacao','Valor']):scoB)||'').replace(/^(\d+)[.,]\d+$/,'$1').replace(/\D/g,'');
    var informante=_ciTxt(scoB,'Informante','Base','NomeBase','Fonte','Origem');
    /* alertas/restrições: a CONCESSÃO DE CRÉDITO é a linha de destaque;
       probabilidade e capacidade de pagamento FICAM DE FORA (decisão 22/08) */
    var alertas=_ciDeep(d,['InformacoesAlertasRestricoes','AlertasRestricoes','Alertas'])||[];
    if(!Array.isArray(alertas)) alertas=[alertas];
    var concessao='', outros=[];
    alertas.forEach(function(a){
      if(!a||typeof a!=='object') return;
      var t=String(_ciTxt(a,'Titulo','Nome','Alerta')||'').trim();
      var v=String(_ciTxt(a,'Descricao','Valor','Resultado','Situacao','Texto')||'').trim();
      if(!t&&!v) return;
      if(/CONCESS/i.test(t)||/CONCESS/i.test(v)){ concessao=v||t; return; }
      if(_CNPJ_RISCO_BLOQ.test(t)||_CNPJ_RISCO_BLOQ.test(v)) return;
      outros.push([t||'Alerta', v||'—']);
    });
    /* Receita Federal (cadastro) */
    var rf=_ciDeep(d,['ReceitaFederal','DadosCadastrais','Cadastro','Empresa'])||{};
    function rv(){ var a=[rf].concat(Array.prototype.slice.call(arguments)); return _ciTxt.apply(null,a); }
    var receita=[
      ['Razão social', rv('RazaoSocial','Razao','Nome','NomeEmpresarial')],
      ['CNPJ', _fmtCnpj(rv('Cnpj','Documento','NumeroDocumento')||'')],
      ['Situação', rv('Situacao','SituacaoCadastral','StatusCadastral')],
      ['Natureza jurídica', rv('NaturezaJuridica','Natureza')],
      ['Fundação', rv('DataFundacao','Fundacao','DataAbertura','Abertura')],
      ['CNAE', rv('Cnae','CnaePrincipal','AtividadePrincipal','DescricaoCnae')] ];
    /* Faturamento presumido + Porte */
    var fat=_ciDeep(d,['FaturamentoPresumido','FaturamentoEstimado','Faturamento'])||{};
    var porteB=_ciDeep(d,['Porte','PorteEmpresa'])||{};
    var porte=[
      ['Faturamento presumido (faixa anual)', _ciTxt(fat,'Faixa','FaixaAnual','Descricao','Valor')||_ciTxt(rf,'FaturamentoPresumido')],
      ['Quadro de funcionários', _ciTxt(porteB,'QuadroFuncionarios','Funcionarios','FaixaFuncionarios')||_ciTxt(rf,'QuadroFuncionarios')],
      ['Capital social', _ciTxt(porteB,'CapitalSocial','Capital')||_ciTxt(rf,'CapitalSocial')] ];
    /* Pendências financeiras — LIÇÃO v450: só é "nada consta" quando a base
       RESPONDEU (status codigo 1) E disse zero ocorrências. */
    var pendB=_ciDeep(d,['PendenciasFinanceiras','Pendencias','PendenciasRestricoes'])||{};
    var st=_ciDeep(pendB,['StatusRetorno','Status'])||{};
    var cod=String(_ciKey(st,['Codigo','Code','Cod'])!=null?_ciKey(st,['Codigo','Code','Cod']):'');
    var qtd=String(_ciKey(pendB,['QuantidadeOcorrencia','QuantidadeOcorrencias','Quantidade','Qtd'])!=null?_ciKey(pendB,['QuantidadeOcorrencia','QuantidadeOcorrencias','Quantidade','Qtd']):'');
    var valTot=_ciTxt(pendB,'ValorTotal','Total','Valor');
    var pend={ qtd:qtd, valor:valTot, nada:(cod==='1' && (qtd==='0'||qtd===0)), incerto:(cod!=='1') };
    var proto=_ciDeep(d,['Protocolo'])||''; if(typeof proto==='object') proto=_ciTxt(proto,'Numero','Protocolo');
    return { score:valor, informante:informante, concessao:concessao, alertas:outros,
             receita:receita, porte:porte, pend:pend, protocolo:String(proto||''), raw:cr };
  }
  function _cnpjRiscoKv(titulo, rows){
    rows=(rows||[]).filter(function(r){ var v=String(r[1]==null?'':r[1]).trim(); return v && v.toLowerCase()!=='null'; });
    if(!rows.length) return '';
    /* v637 — sem título, ele é o CORPO de um card que abre (o título passou
       a ser o do próprio card). Com título, continua como era. */
    return (titulo?('<div style="font-size:10.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:11px 2px 5px">'+esc(titulo)+'</div>'):'')+
      '<div style="background:#fff;border:1px solid #e8eef7;border-radius:12px;overflow:hidden">'+
      rows.map(function(r,i){ return '<div style="padding:7px 12px;'+(i?'border-top:1px solid #f1f5f9;':'')+'"><div style="font-size:9.5px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:.3px">'+esc(r[0])+'</div><div style="font-size:12.6px;font-weight:700;color:#0f172a;margin-top:1px;line-height:1.3">'+esc(r[1])+'</div></div>'; }).join('')+'</div>';
  }
  function cnpjRiscoPanelHtml(cr){
    var p=cnpjRiscoParse(cr);
    var html='<div style="margin-top:12px">';
    /* cartão do score PJ — mesma régua de cor do CPF (>=700 verde · >=500 âmbar · vermelho) */
    if(p.score){
      var sv=parseInt(p.score,10)||0;
      var sc=(sv>=700)?['#16a34a','#f0fdf4','#bbf7d0']:((sv>=500)?['#d97706','#fffbeb','#fde68a']:['#dc2626','#fef2f2','#fecaca']);
      html+='<div style="background:'+sc[1]+';border:1px solid '+sc[2]+';border-radius:14px;padding:11px;margin:0 0 9px;text-align:center">'
        +'<div style="font-size:10px;font-weight:800;color:'+sc[0]+';text-transform:uppercase;letter-spacing:.5px">Score de crédito PJ'+(p.informante?(' · '+esc(p.informante)):'')+'</div>'
        +'<div style="font-size:32px;font-weight:900;color:'+sc[0]+';line-height:1.05;margin-top:2px">'+esc(p.score)+'<span style="font-size:14px;font-weight:700;color:#94a3b8"> / 1000</span></div>'
        +'</div>';
    }
    /* linha de destaque: CONCESSÃO DE CRÉDITO */
    if(p.concessao){
      var ap=/APROVAD/i.test(p.concessao);
      html+='<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 13px;border-radius:12px;margin-bottom:9px;'+(ap?'background:#f0fdf4;border:1px solid #bbf7d0':'background:#fef2f2;border:1px solid #fecaca')+'">'
        +'<span style="font-size:12px;font-weight:800;color:#0f172a">Concessão de crédito</span>'
        +'<span style="flex:none;font-size:12px;font-weight:900;padding:4px 11px;border-radius:20px;'+(ap?'background:#dcfce7;color:#15803d':'background:#fee2e2;color:#b91c1c')+'">'+esc(p.concessao.toUpperCase())+'</span></div>';
    }
    /* pendências — v450: "nada consta" só quando a base respondeu de verdade */
    var pTxt, pCor;
    if(p.pend.nada){ pTxt='Nada consta'; pCor=['#dcfce7','#15803d']; }
    else if(p.pend.incerto && !p.pend.qtd){ pTxt='Não informado pela base'; pCor=['#f1f5f9','#516480']; }
    else { pTxt=(p.pend.qtd||'?')+' ocorrência(s)'+(p.pend.valor?(' · '+esc(p.pend.valor)):''); pCor=['#fee2e2','#b91c1c']; }
    html+='<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 13px;background:#fff;border:1px solid #e8eef7;border-radius:12px;margin-bottom:2px">'
      +'<span style="font-size:12.4px;font-weight:600;color:#0f172a">Pendências financeiras</span>'
      +'<span style="flex:none;font-size:11.3px;font-weight:800;padding:3px 9px;border-radius:20px;background:'+pCor[0]+';color:'+pCor[1]+'">'+pTxt+'</span></div>';
    /* v637 — o irmão pago da MESMA página também vira cards que abrem.
       Deixar metade da tela em card e metade em parede é pior que não ter
       começado — e as duas se abrem uma da outra. */
    html+='<div id="cnpjRiscoBlocos">';
    if(p.alertas.length) html+=_cpfBloco('Alertas e restrições ('+p.alertas.length+')', _cnpjRiscoKv('', p.alertas), true);
    html+=_cpfBloco('Receita Federal', _cnpjRiscoKv('', p.receita), false);
    html+=_cpfBloco('Faturamento e porte', _cnpjRiscoKv('', p.porte), false);
    html+='</div>';
    /* ⚠️ SEM a classe .pdf-btn de propósito: no celular ela é escondida e
       vira o FAB verde — que clica o PRIMEIRO .pdf-btn da tela (seria o da
       consulta grátis, não este). Botão próprio, sempre visível. */
    html+='<button type="button" id="cnpjRiscoPdf" style="width:100%;margin-top:14px;display:flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(135deg,var(--verde),var(--verde3));color:#fff;border:none;border-radius:11px;padding:13px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit;box-shadow:0 4px 14px rgba(21,101,52,.22)">'+ICO_PDF+' Baixar em PDF</button>';
    html+='<div class="plc-msg" style="font-size:10px;color:#94a3b8;margin-top:7px">Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018). Dados informados pela base na data da consulta.'+(p.protocolo?(' Protocolo '+esc(p.protocolo)+'.'):'')+'</div>';
    html+='</div>';
    return html;
  }
  /* PDF do risco no PADRÃO MEV (kit do 06b, v595 Fase 2): faixa azul da
     casa, veredito da concessão, cartão de score (componente G), seções kv
     e rodapé com paginação — SEM probabilidade e sem o link do provedor. */
  function cnpjRiscoPaginas(cr){
    var p=cnpjRiscoParse(cr);
    var docFmt=''; try{ (p.receita||[]).forEach(function(r){ if(!docFmt && /^cnpj$/i.test(String(r[0]))) docFmt=String(r[1]||''); }); }catch(_){}
    var st=pdfkitNovo({ tipo:'Risco de crédito CNPJ', doc:docFmt, protocolo:p.protocolo||'',
      lgpdCurto:'Uso restrito à análise de crédito, conforme a LGPD (Lei 13.709/2018)' });
    if(p.concessao){
      var ap=/APROVAD/i.test(p.concessao);
      kitVeredito(st, ap?'ok':'no', 'Concessão de crédito: '+p.concessao, '');
    }
    if(p.score) kitScore(st,'Score de crédito PJ'+(p.informante?(' · '+p.informante):''), p.score, '');
    if(p.pend.nada) kitSelo(st,'Pendências financeiras: nada consta.');
    else if(p.pend.incerto && !p.pend.qtd) kitAtencao(st,'Pendências financeiras: não informado pela base — não verificado.');
    else kitKv2(st,'Pendências financeiras',[['Situação',(p.pend.qtd||'?')+' ocorrência(s)'+(p.pend.valor?(' · '+p.pend.valor):'')]]);
    if(p.alertas.length) kitKv2(st,'Alertas e restrições', p.alertas);
    kitKv2(st,'Receita Federal', p.receita);
    kitKv2(st,'Faturamento e porte', p.porte);
    return kitFinaliza(st);
  }
  function cnpjRiscoCanvas(cr){
    return kitPrevia(cnpjRiscoPaginas(cr));
  }
  function cnpjRiscoPdfAcao(modo){
    if(!_cnpjRiscoState) return;
    try{
      var _blob=kitPdfBlob(cnpjRiscoPaginas(_cnpjRiscoState));
      if(!_blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      var nome='risco-credito-cnpj.pdf';
      pdfArquivoAcao(_blob,nome,modo,function(){ pdfVisor(_blob,nome); },'Risco de crédito CNPJ');
    }catch(_){ toast('Não consegui gerar o PDF agora.'); }
  }
  function cnpjRiscoBaixarPDF(){ cnpjRiscoPdfAcao('baixar'); }
  /* ---------- histórico do risco (local + nuvem, tipo 'cnpj_risco') ------- */
  function cnpjRiscoHistLer(){ try{ return JSON.parse(localStorage.getItem('mev_cnpj_risco_hist')||'[]'); }catch(_){ return []; } }
  function cnpjRiscoHistSalvar(doc, resultado){
    try{
      var l=cnpjRiscoHistLer().filter(function(x){ return String(x.doc)!==String(doc); });
      l.unshift({ doc:String(doc), ts:Date.now(), resultado:resultado }); l=l.slice(0,15);
      localStorage.setItem('mev_cnpj_risco_hist', JSON.stringify(l));
    }catch(_){}
    try{ docHistCloudSave('cnpj_risco', doc, 'CNPJ_RISCO', resultado, Date.now()); }catch(_){}
  }
  function cnpjRiscoDoDoc(doc){ return cnpjRiscoHistLer().filter(function(x){ return String(x.doc)===String(doc); })[0]||null; }
  function cnpjRiscoNuvem(){
    try{ docHistCloudLoad('cnpj_risco', function(rows, deuCerto){
      if(!rows||!rows.length) return;
      var l=cnpjRiscoHistLer(); var novo=false;
      rows.forEach(function(row){ var doc=String(row.chave||''); if(!doc) return;
        if(!l.some(function(x){ return String(x.doc)===doc; })){ l.push({ doc:doc, ts:Number(row.ts)||Date.now(), resultado:row.resultado||{} }); novo=true; } });
      if(!novo) return;
      l.sort(function(a,b){ return (b.ts||0)-(a.ts||0); });
      try{ localStorage.setItem('mev_cnpj_risco_hist', JSON.stringify(l.slice(0,15))); }catch(_){}
    }); }catch(_){}
  }
  /* v595: reabrir do histórico MOSTRA O SALVO SEM COBRAR — quem cobra é só o
     botão. Chamada pelo cnpjHistRender (05) ao reabrir uma empresa. */
  function cnpjRiscoMostrarSalvo(doc){
    var res=$('cnpjRiscoResult'); if(!res) return;
    var it=cnpjRiscoDoDoc(String(doc||'').replace(/\D/g,''));
    if(!it){ res.innerHTML=''; return; }
    cnpjResultadoAbrir('risco',doc,it.resultado,it.ts,true);
  }
  /* v1006 — o Compliance e o risco compartilham o diário legado
     `mev_cnpj_risco_hist`. Ao reabrir um CNPJ, o histórico até encontrava a
     resposta paga, mas só tentava pintá-la no painel do risco. Na landing de
     Compliance esse painel não existe, então o relatório parecia perdido e
     convidava a uma nova cobrança. O pintor abaixo usa exatamente a resposta
     salva e o parser do Compliance; nenhum pedido novo sai daqui. */
  function cnpjComplianceMostrarSalvo(doc){
    var res=$('cnpjCmplResult'); if(!res) return;
    var it=cnpjRiscoDoDoc(String(doc||'').replace(/\D/g,''));
    if(!it){ res.innerHTML=''; return; }
    /* O roteador genérico abaixo escolhe explicitamente o parser de
       Compliance; risco e Compliance nunca compartilham a apresentação. */
    cnpjResultadoAbrir('compliance',doc,it.resultado,it.ts,true);
  }
  /* ==========================================================================
     v1000 — A CONSULTA DO COMPLIANCE COMPLETE PJ
     --------------------------------------------------------------------------
     Mesmo desenho do risco (v897) e da AutoCorp (v874): o servidor responde
     `pendente:true` + protocolo e quem espera é o laço aqui, perguntando
     "ficou pronto?" a cada 3 s. NÃO é capricho — o exemplo oficial da API
     Brasil usa --max-time 120, e numa função síncrona de 8 s cada estouro
     devolveria o crédito ao lojista e queimaria R$ 14,44 da conta do Angelo
     em silêncio.
     ⚠️ O botão travado + o `_cnpjRiscoOcupado` impedem o segundo toque durante
     a espera; do lado do servidor a trava de 60 s cobre o resto. Num produto
     de R$ 24,07 isso é o que separa um toque nervoso de uma cobrança dupla.
     ========================================================================== */
  var _cnpjCmplState=null;
  async function gerarCnpjCompliance(btn){
    var inp=$('cnpjDoc'); var doc=inp?String(inp.value).replace(/\D/g,''):'';
    var res=$('cnpjCmplResult');
    if(doc.length!==14){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CNPJ com 14 números.</div>'; return; }
    if(btn.disabled) return;   /* token único por toque */
    _cnpjRiscoOcupado=true;
    consultaUiBotao(btn,'carregando','Consultando compliance…');
    if(res) res.innerHTML=ccLoaderHtml('Consultando o compliance da empresa…',_CNPJ_CMPL_FRASES,_SVG_PREDIO);
    var lt=ccLoaderStart(_CNPJ_CMPL_FRASES);
    var d=null;
    try{ d=await consultarComRetry({ produto:'cnpj_compliance', documento:doc }, 1); }catch(_){ d=null; }
    if(d&&d.ok&&d.pendente&&d.protocolo){
      var _j=await _veicEsperarJob(d.protocolo, 150000, 'cnpjCmplResult',
        'A base de compliance está demorando mais que o normal. Toque em consultar de novo daqui a pouco: se ela já tiver respondido, o resultado vem sem cobrar de novo.');
      if(_j===null){ clearInterval(lt); _cnpjRiscoOcupado=false; return; }   /* saiu da tela */
      d=_j;
    }
    clearInterval(lt);
    _cnpjRiscoOcupado=false;
    consultaUiBotao(btn,'pronto',_cnpjCmplRotulo());
    if(d&&d.sem_saldo){ if(res) res.innerHTML=''; setSaldo(d.saldo); abrirPacotes(); return; }
    if(!d||!d.ok){
      consultaUiBotao(btn,'erro');
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não consegui consultar o compliance agora. Tente de novo em instantes.')+'</div>';
      return;
    }
    setSaldo(d.saldo);
    consultaUiBotao(btn,'novamente','Consultar o compliance novamente');
    _cnpjCmplState=d.resultado;
    try{ cnpjRiscoHistSalvar(doc, d.resultado); }catch(_){}
    cnpjResultadoAbrir('compliance',doc,d.resultado,Date.now(),false);
  }
  /* ==========================================================================
     v1024 — AÇÕES E PROCESSOS · CNPJ (produto novo)
     --------------------------------------------------------------------------
     🔴 O LEITOR É O MESMO DO CPF. `cpfProcParse` / `cpfProcPanelHtml` /
     `cpfProcPaginas` moram no 03-ficha-tecnica.js e todos os módulos vivem no
     MESMO IIFE — então aqui é só chamar. O corpo da resposta é idêntico; o que
     muda é o documento consultado e o rótulo da tela. Copiar o parser para cá
     seria garantir que uma das duas cópias fica para trás no próximo conserto
     (é a lição que o próprio defeito desta versão ensinou: um leitor errado,
     no ar por 425 versões).
     ⚠️ Esta consulta é SÍNCRONA (mesma fonte, mesmo tempo do cpf_processos) —
     não passa pelo VEIC_LENTO.
     ========================================================================== */
  var _cnpjProcState=null;
  async function gerarCnpjProcessos(btn){
    var inp=$('cnpjDoc'); var doc=inp?String(inp.value).replace(/\D/g,''):'';
    var res=$('cnpjProcResult');
    if(doc.length!==14){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CNPJ com 14 números.</div>'; return; }
    if(btn.disabled) return;   /* token único por toque */
    _cnpjRiscoOcupado=true;
    consultaUiBotao(btn,'carregando','Consultando processos…');
    if(res) res.innerHTML=ccLoaderHtml('Procurando processos da empresa…',_CNPJ_PROC_FRASES,_SVG_PREDIO);
    var lt=ccLoaderStart(_CNPJ_PROC_FRASES);
    var d=null;
    try{ d=await consultarComRetry({ produto:'cnpj_processos', documento:doc }, 1); }catch(_){ d=null; }
    clearInterval(lt);
    _cnpjRiscoOcupado=false;
    consultaUiBotao(btn,'pronto',_cnpjProcRotulo());
    if(d&&d.sem_saldo){ if(res) res.innerHTML=''; setSaldo(d.saldo); abrirPacotes(); return; }
    if(!d||!d.ok){
      consultaUiBotao(btn,'erro');
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não consegui consultar os processos agora. Tente de novo em instantes.')+(d&&d.estornado&&!/devolvid/i.test(String(d&&d.erro||''))?' ✓ Valor devolvido ao saldo.':'')+'</div>';
      return;
    }
    setSaldo(d.saldo);
    consultaUiBotao(btn,'novamente','Consultar os processos novamente');
    _cnpjProcState={ documento:doc, tipo_doc:'CNPJ_PROCESSOS', data:((d.resultado&&d.resultado.data)||d.resultado||{}) };
    try{ cnpjProcHistSalvar(doc, d.resultado); }catch(_){}
    cnpjResultadoAbrir('processos',doc,d.resultado,Date.now(),false);
  }
  async function gerarCnpjSintegra(btn){
    var inp=$('cnpjDoc'),doc=inp?String(inp.value).replace(/\D/g,''):'';
    var res=$('cnpjSintegraResult');
    if(doc.length!==14){if(res)res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CNPJ com 14 números.</div>';return;}
    if(btn.disabled)return;
    _cnpjRiscoOcupado=true;
    consultaUiBotao(btn,'carregando','Consultando inscrição estadual…');
    if(res)res.innerHTML=ccLoaderHtml('Consultando a base estadual…',_CNPJ_SINTEGRA_FRASES,_SVG_PREDIO);
    var lt=ccLoaderStart(_CNPJ_SINTEGRA_FRASES),d=null;
    try{d=await consultarComRetry({produto:'cnpj_sintegra',documento:doc},1);}catch(_){d=null;}
    if(d&&d.ok&&d.pendente&&d.protocolo){
      var j=await _veicEsperarJob(d.protocolo,150000,'cnpjSintegraResult','A base estadual está demorando mais que o normal. Tente novamente daqui a pouco; um resultado já concluído não será cobrado de novo.');
      if(j===null){clearInterval(lt);_cnpjRiscoOcupado=false;return;}
      d=j;
    }
    clearInterval(lt);_cnpjRiscoOcupado=false;
    consultaUiBotao(btn,'pronto',_cnpjSintegraRotulo());
    if(d&&d.sem_saldo){if(res)res.innerHTML='';setSaldo(d.saldo);abrirPacotes();return;}
    if(!d||!d.ok){
      consultaUiBotao(btn,'erro');if(d&&d.saldo!=null)setSaldo(d.saldo);
      if(res)res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não consegui consultar a inscrição estadual agora. Tente novamente em instantes.')+'</div>';
      return;
    }
    setSaldo(d.saldo);
    consultaUiBotao(btn,'novamente','Consultar novamente');
    _cnpjSintegraState=d.resultado;
    try{cnpjSintegraHistSalvar(doc,d.resultado);}catch(_){}
    cnpjResultadoAbrir('sintegra',doc,d.resultado,Date.now(),false);
  }
  /* v1024 — o EXEMPLO da landing ("ver exemplo sem cobrança"). Mesma forma da
     resposta real — é o que o leitor novo entende — e DADOS FICTÍCIOS.
     ⚠️ Exemplo que não tem a forma do dado de verdade não prova nada: foi
     exatamente por isso que o PDF de exemplo do CPF ficou bonito por 425
     versões enquanto a consulta paga saía vazia. */
  function _cnpjProcExDados(){
    return { documento:'11222333000181', tipo_doc:'CNPJ_PROCESSOS', mev_exemplo:true, data:{
      cadastralCompleto:{ razaoSocial:'EMPRESA EXEMPLO COMERCIO LTDA (DADOS FICTICIOS)', enderecos:[{ cidade:'Campinas', uf:'SP' }] },
      acoesProcessos:{ documentoNaoEncontrado:false, possuiErro:false, acoes:{ processos:[
        { numeroProcessoUnico:'0002345-67.2025.5.15.0001',
          classeProcessual:{ codigoCnj:1125, nome:'AÇÃO TRABALHISTA - RITO ORDINÁRIO' },
          assuntosCNJ:[{ codigo:2546, titulo:'VERBAS RESCISÓRIAS', principal:true },
                       { codigo:864,  titulo:'DIREITO DO TRABALHO', principal:false }],
          informacoesPartePessoaConsultada:[{ polo:'PASSIVO', tipo:'RECLAMADA' }],
          statusPj:{ statusProcesso:'EM TRAMITAÇÃO', ramoDireito:'DIREITO DO TRABALHO' },
          tribunal:'TRT15', orgaoJulgador:'2ª Vara do Trabalho', uf:'SP', grauProcesso:'1º grau',
          dataDistribuicao:'2025-02-11 10:05:00', valorCausa:{ moeda:'BRL', valor:42000 },
          segredoJustica:false },
        { numeroProcessoUnico:'0009876-54.2023.8.26.0114',
          classeProcessual:{ codigoCnj:12377, nome:'EXECUÇÃO DE TÍTULO EXTRAJUDICIAL' },
          assuntosCNJ:[{ codigo:7691, titulo:'DUPLICATA', principal:true }],
          informacoesPartePessoaConsultada:[{ polo:'ATIVO', tipo:'EXEQUENTE' }],
          statusPj:{ statusProcesso:'ARQUIVAMENTO DEFINITIVO', ramoDireito:'DIREITO CIVIL',
                     dataArquivamento:'2024-09-30 00:00:00' },
          tribunal:'TJSP', orgaoJulgador:'4ª Vara Cível', uf:'SP', grauProcesso:'1º grau',
          dataDistribuicao:'2023-06-20 16:40:00', valorCausa:{ moeda:'BRL', valor:0 },
          segredoJustica:false }
      ] } } } };
  }
  function cnpjProcExemploPdf(){
    if(!_mevPdfPronto(cnpjProcExemploPdf,false)) return;
    try{
      var blob=kitPdfBlob(cpfProcPaginas(_cnpjProcExDados(), true));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      pdfVisor(blob,'exemplo-acoes-e-processos-cnpj.pdf');
    }catch(_){ toast('Não consegui abrir o exemplo em PDF agora.'); }
  }
  function cnpjProcPdfAcao(modo){
    if(!_cnpjProcState) return;
    if(!_mevPdfPronto(cnpjProcBaixarPDF,false)) return;
    try{
      var _blob=kitPdfBlob(cpfProcPaginas(_cnpjProcState, true));
      if(!_blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      /* nome sem NENHUM dígito do documento (lição da v515) */
      var nome=nomeArquivoSeguro('Acoes-e-processos-CNPJ','',Date.now())+'.pdf';
      pdfArquivoAcao(_blob,nome,modo,function(){ pdfVisor(_blob,nome); },'Ações e processos CNPJ');
    }catch(_){ toast('Não consegui gerar o PDF agora.'); }
  }
  function cnpjProcBaixarPDF(){ cnpjProcPdfAcao('baixar'); }
  /* histórico próprio (local + nuvem, tipo 'cnpj_processos') — mesmo molde do risco */
  function cnpjProcHistLer(){ try{ return JSON.parse(localStorage.getItem('mev_cnpj_proc_hist')||'[]'); }catch(_){ return []; } }
  function cnpjProcHistSalvar(doc, resultado){
    try{
      var l=cnpjProcHistLer().filter(function(x){ return String(x.doc)!==String(doc); });
      l.unshift({ doc:String(doc), ts:Date.now(), resultado:resultado }); l=l.slice(0,15);
      localStorage.setItem('mev_cnpj_proc_hist', JSON.stringify(l));
    }catch(_){}
    try{ docHistCloudSave('cnpj_processos', doc, 'CNPJ_PROCESSOS', resultado, Date.now()); }catch(_){}
  }
  async function gerarCnpjRisco(btn){
    var inp=$('cnpjDoc'); var doc=inp?String(inp.value).replace(/\D/g,''):'';
    var res=$('cnpjRiscoResult');
    if(doc.length!==14){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite um CNPJ com 14 números.</div>'; return; }
    if(btn.disabled) return;   /* token único por toque */
    _cnpjRiscoOcupado=true;   /* v641 */
    consultaUiBotao(btn,'carregando','Consultando risco…');   /* v753 */
    if(res) res.innerHTML=ccLoaderHtml('Consultando risco de crédito…',_CNPJ_RISCO_FRASES,_SVG_PREDIO);
    var lt=ccLoaderStart(_CNPJ_RISCO_FRASES);
    var d=null;
    try{ d=await consultarComRetry({ produto:'cnpj_risco', documento:doc }, 1); }catch(_){ d=null; }
    /* ======================================================================
       🔴 v897 — O RISCO DE CNPJ PASSOU A RODAR NO WORKER DE FUNDO.
       O servidor agora responde `pendente:true` + protocolo, e quem espera é
       esta espera aqui, perguntando "ficou pronto?" a cada 3 s. É o mesmo
       desenho da Ficha por IA (v240), do gravame (v802) e da AutoCorp (v874).
       O loader continua girando de propósito: quem está esperando é a pessoa,
       e o relógio dela não parou.
       ⚠️ O `_cnpjRiscoOcupado` e o botão travado seguem valendo o tempo todo —
       são eles que impedem um segundo toque durante a espera. Do lado do
       servidor a trava dos 60 s cobre o resto.
       ====================================================================== */
    if(d&&d.ok&&d.pendente&&d.protocolo){
      var _j=await _veicEsperarJob(d.protocolo, 150000, 'cnpjRiscoResult',
        'A base de risco está demorando mais que o normal. Toque em consultar de novo daqui a pouco: se ela já tiver respondido, o resultado vem sem cobrar de novo.');
      if(_j===null){ clearInterval(lt); _cnpjRiscoOcupado=false; return; }   /* saiu da tela */
      d=_j;
    }
    clearInterval(lt);
    _cnpjRiscoOcupado=false;   /* v641 */
    consultaUiBotao(btn,'pronto',_cnpjRiscoRotulo());
    if(d&&d.sem_saldo){ if(res) res.innerHTML=''; setSaldo(d.saldo); abrirPacotes(); return; }
    if(!d||!d.ok){
      consultaUiBotao(btn,'erro');
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+esc((d&&d.erro)||'Não consegui consultar o risco agora. Tente de novo em instantes.')+(d&&d.estornado&&!/devolvid/i.test(String(d&&d.erro||''))?' ✓ Valor devolvido ao saldo.':'')+'</div>';
      return;
    }
    setSaldo(d.saldo);
    consultaUiBotao(btn,'novamente',_cnpjRiscoRotulo().replace(/^Risco de crédito/,'Consultar o risco novamente'));
    _cnpjRiscoState=d.resultado;
    try{ cnpjRiscoHistSalvar(doc, d.resultado); }catch(_){}
    cnpjResultadoAbrir('risco',doc,d.resultado,Date.now(),false);
  }

/* ╔═══ src/app/05-historico-e-home.js ════════════════════════════════════ */
  /* =====================================================================
     v165 - PDF do CNPJ redesenhado.
     Antes: uma coluna so, muito comprida -> ao caber numa pagina A4 o
     conteudo encolhia e sobrava tarja branca dos dois lados.
     Agora: DUAS COLUNAS na proporcao da folha A4 (largura/altura 0,707),
     entao a pagina e preenchida e a letra sai maior. Os cartoes sao
     medidos primeiro e cada um cai na coluna que estiver mais curta.
     ===================================================================== */
  /* O desenho e feito uma vez "no vazio" em varias larguras so pra MEDIR a
     altura; fica valendo a largura cujo resultado mais se parece com uma folha
     A4 em pe (altura = 1,414 x largura). Assim a pagina do PDF fica preenchida
     e a letra sai no maior tamanho possivel, seja empresa com 1 CNAE ou com 30. */
  /* ======================================================================
     v595 — O PDF DO CNPJ NO PADRÃO MEV (Fase 2): as páginas nascem do kit
     do 06b (faixa azul da casa, veredito da situação, seções kv, rodapé
     com paginação). O _cnpjDraw (auto-ajuste de folha) foi aposentado. */
  function cnpjPaginas(d){
    var p=cnpjParse(d||{});
    var st=pdfkitNovo({ tipo:'Consulta CNPJ — dados da empresa', doc:_fmtCnpj((d&&d.cnpj)||''),
      lgpdCurto:'Dados públicos da Receita Federal (base aberta), na data da consulta' });
    /* 🔴 v637 — A RAZÃO SOCIAL ERA O MENOR TEXTO DA PÁGINA.
       Saía pelo kitTexto: cinza, 10px, com menos peso que o rótulo "NOME
       FANTASIA" logo abaixo. É o identificador mais importante do documento.
       Agora é título de verdade, com o fantasia em cinza embaixo. */
    kitTitulo(st, p.razao, p.fantasia);
    /* 🔴 a faixa dizia "ATIVA" à direita e "✓ EMPRESA ATIVA" à esquerda — a
       mesma coisa duas vezes. A direita passa a carregar o que ela NÃO dizia:
       desde quando. Espaço que já existia, agora com informação nova. */
    if(p.ativa) kitVeredito(st,'ok','Empresa ativa', p.sitDesde||p.sit||'');
    else kitVeredito(st,'at','Situação: '+(p.sit||'não informada'),'confira antes de negociar');

    /* ======================================================================
       🔴 v637 — O CNAE SAÍA CORTADO DA FOLHA, E ISSO É PERDA DE DADO
       ======================================================================
       Num PDF real de 25/08 (LEO REPASSES), o bloco prometia "CNAES
       SECUNDÁRIOS (2)" e entregava um e meio:
           4511101 — Comércio a varejo de automóveis… · 7319002 — P
       Cortado no meio da palavra. O segundo CNAE não existe naquele documento.

       ✅ A CAUSA é quase engraçada: o comentário aqui dizia
            "viram texto de UMA LINHA POR ITEM"
          e a linha logo abaixo fazia o CONTRÁRIO — juntava tudo com ' · '.
          Aí o `kitKv2`, que é uma GRADE DE DUAS COLUNAS, recebia 200
          caracteres numa célula de meia largura e o resto ia pela borda.
          A v165 arrumou isso NA TELA e escreveu "CNAE vira lista, um item por
          linha". A tela obedeceu; o gerador de PDF ficou com o parágrafão.
          Um ano de comentário dizendo uma coisa e código fazendo outra.

       ✅ Agora lista sai da grade e vira BLOCO DE LARGURA INTEIRA (kitLista,
          v637), um item por linha, com quebra de linha de verdade.
       ⚠️ Grade de duas colunas continua ótima pra dado curto — CEP, porte,
          capital. Lista e texto longo pedem a largura toda.
       🔴 REGRA QUE FICA: texto cortado é pior que texto ausente. Ausente, a
          pessoa procura em outro lugar. Cortado, ela acha que leu.
       ====================================================================== */
    function _semLista(rows){ return (rows||[]).filter(function(r){ return !(r[1] && r[1].lista); }); }
    function _soListas(rows){ return (rows||[]).filter(function(r){ return r[1] && r[1].lista; }); }

    /* 🔴 o CNPJ aparecia TRÊS vezes na folha: no cabeçalho, aqui e no nome do
       arquivo. No cabeçalho basta — o espaço vai pro que disputava lugar. */
    kitKv2(st,'Identificação', _semLista(p.ident).filter(function(r){ return !/^cnpj$/i.test(String(r[0])); }));

    _semLista(p.atividade).length && kitKv2(st,'Atividade (CNAE)', _semLista(p.atividade));
    _soListas(p.atividade).forEach(function(r){
      kitLista(st, r[0], r[1].lista);
    });

    kitKv2(st,'Endereço', _semLista(p.endereco));
    kitKv2(st,'Contato', _semLista(p.contato));

    /* 🔴 OS SÓCIOS ERAM CORTADOS EM 12, EM SILÊNCIO. `p.socios.slice(0,12)`
       com o título dizendo "Sócios (15)" — o documento se contradizia
       sozinho. É PDF: pode ter duas páginas. O kitLista pagina.
       ⚠️ E o rótulo estava invertido: o CARGO aparecia como etiqueta e o NOME
       como valor. A pessoa é o dado; o cargo é o detalhe. */
    if(p.socios&&p.socios.length){
      kitLista(st,'Sócios ('+p.socios.length+')',
        p.socios.map(function(so){ return { forte:so.nome, fraco:so.qual||'' }; }));
    }
    return kitFinaliza(st);
  }
  function cnpjCanvas(d){
    return kitPrevia(cnpjPaginas(d));
  }
  function _cnpjDraw(d,W,medindo){
    var p=cnpjParse(d);
    var pad=Math.round(W*0.044), gap=Math.round(W*0.027), colW=Math.round((W-pad*2-gap)/2);
    var cv=document.createElement('canvas'); cv.width=medindo?1:W; cv.height=medindo?1:3800; var g=cv.getContext('2d');
    if(!medindo){ g.fillStyle='#ffffff'; g.fillRect(0,0,W,3800); }
    g.textAlign='left';
    var FF='system-ui,-apple-system,Arial';

    /* ---------- cabecalho clean: sem tarja escura, so tipografia ---------- */
    g.fillStyle='#0a4da6'; g.font='800 17px '+FF; g.fillText('CONSULTA DE CNPJ', pad, 62);
    g.fillStyle='#b6c2d4'; g.font='500 17px '+FF; g.textAlign='right';
    g.fillText('Gerado em '+histData(Date.now()), W-pad, 62); g.textAlign='left';
    var rz=String(p.razao||'—').toUpperCase(), rf=40;
    g.fillStyle='#001e50'; g.font='800 '+rf+'px '+FF;
    while(g.measureText(rz).width>W-pad*2 && rf>22){ rf--; g.font='800 '+rf+'px '+FF; }
    if(g.measureText(rz).width>W-pad*2){ while(rz.length>4 && g.measureText(rz+'…').width>W-pad*2){ rz=rz.slice(0,-1); } rz+='…'; }
    g.fillText(rz, pad, 112);
    g.fillStyle='#64748b'; g.font='600 22px '+FF; g.fillText(_fmtCnpj(d.cnpj||''), pad, 148);
    /* selo de situacao SO com contorno (nao usa fundo colorido: economiza toner) */
    (function(){
      var txt=(p.ativa?'EMPRESA ATIVA':String(p.sit||'—').toUpperCase()), cor=p.ativa?'#15803d':'#c2410c';
      g.font='800 18px '+FF; var tw=g.measureText(txt).width, bw=tw+30, bh=34, bx=W-pad-bw, by=124;
      g.strokeStyle=cor; g.lineWidth=2; _rr(g,bx,by,bw,bh,17); g.stroke();
      g.fillStyle=cor; g.textAlign='left'; g.fillText(txt, bx+15, by+23);
    })();
    g.fillStyle='#e8eef7'; g.fillRect(pad, 172, W-pad*2, 2);
    var top=214;

    /* ---------- medidas de um cartao ---------- */
    var PD=17, LH=23, TIT=32, DEPOIS=26;
    function _vOk(v){ if(v==null) return false; if(v&&v.lista) return !!v.lista.length; var t=String(v).trim(); return !!t&&t.toLowerCase()!=='null'; }
    function _partes(v){ return (v&&v.lista)?v.lista.map(function(it){ return (it.cod?(it.cod+' – '):'')+it.des; }):[String(v)]; }
    function medir(titulo,rows){
      rows=(rows||[]).filter(function(r){ return _vOk(r[1]); });
      if(!rows.length) return null;
      var hs=rows.map(function(r){
        var maxW=colW-2*PD, partes=_partes(r[1]);
        /* v355 — E-MAIL/SITE NÃO ESTOURAM MAIS A BORDA.
           São uma palavra só. Antes saíam por cima do cartão. Agora a letra
           DESSA linha encolhe (18px → até 12px) até caber inteira; se nem
           assim couber, o _wrapLines parte por letra. As outras linhas
           continuam no tamanho normal. */
        var fs=18;
        partes.forEach(function(t){
          String(t).split(' ').forEach(function(w){
            if(!w) return;
            var f=fs;
            g.font='500 '+f+'px '+FF;
            while(g.measureText(w).width>maxW && f>12){ f--; g.font='500 '+f+'px '+FF; }
            if(f<fs) fs=f;
          });
        });
        var lh=(fs>=17)?LH:Math.round(fs*1.32);
        g.font='500 '+fs+'px '+FF;   /* v393: ficha do CNPJ sem negrito */
        var lines=[]; partes.forEach(function(t){ lines=lines.concat(_wrapLines(g,t,maxW)); });
        return { lines:lines, fs:fs, lh:lh, h:17+lines.length*lh+8 };
      });
      var corpo=hs.reduce(function(a,b){ return a+b.h; },0)+10;
      return { titulo:titulo, rows:rows, hs:hs, corpo:corpo, h:TIT+corpo+DEPOIS };
    }
    function desenhar(c,x,y){
      g.fillStyle='#0a4da6'; _rr(g,x,y-4,5,22,3); g.fill();
      g.fillStyle='#001e50'; g.font='800 21px '+FF; g.textAlign='left'; g.fillText(c.titulo, x+15, y+14);
      y+=TIT;
      /* fundo BRANCO + contorno fino: na impressora nao gasta toner */
      g.fillStyle='#ffffff'; _rr(g,x,y,colW,c.corpo,14); g.fill();
      g.strokeStyle='#dbe4f0'; g.lineWidth=1.5; _rr(g,x,y,colW,c.corpo,14); g.stroke();
      var ry=y+5;
      c.rows.forEach(function(r,i){
        g.fillStyle='#94a3b8'; g.font='600 14px '+FF; g.fillText(String(r[0]).toUpperCase(), x+PD, ry+16);
        g.fillStyle='#0f172a'; g.font='500 '+(c.hs[i].fs||18)+'px '+FF;
        var vy=ry+16+22; c.hs[i].lines.forEach(function(ln){ g.fillText(ln, x+PD, vy); vy+=(c.hs[i].lh||LH); });
        if(i<c.rows.length-1){ g.strokeStyle='#eef2f7'; g.lineWidth=1.5; g.beginPath(); g.moveTo(x+PD,ry+c.hs[i].h-3); g.lineTo(x+colW-PD,ry+c.hs[i].h-3); g.stroke(); }
        ry+=c.hs[i].h;
      });
      return y+c.corpo+DEPOIS;
    }

    var lista=[ medir('Dados da empresa', p.ident),
                medir('Atividade (CNAE)', p.atividade),
                medir('Endereço', p.endereco),
                medir('Contato', p.contato),
                medir('Sócios', p.socios.map(function(s){ return [s.qual||'Sócio', s.nome]; })) ].filter(Boolean);

    /* cada cartao cai na coluna mais curta -> as duas terminam parecidas */
    var yA=top, yB=top, xA=pad, xB=pad+colW+gap;
    lista.forEach(function(c){ if(yA<=yB) yA=desenhar(c,xA,yA); else yB=desenhar(c,xB,yB); });

    var y=Math.max(yA,yB)+4;
    g.fillStyle='#e8eef7'; g.fillRect(pad, y, W-pad*2, 1); y+=26;
    g.fillStyle='#94a3b8'; g.font='400 15px '+FF; g.textAlign='center';
    g.fillText('Dados públicos da Receita Federal (base aberta), na data da consulta.', W/2, y); y+=22;
    g.textAlign='left';

    if(medindo) return Math.max(560,y);
    var out=document.createElement('canvas'); out.width=W; out.height=Math.min(3800,Math.max(560,y));
    var og=out.getContext('2d'); og.fillStyle='#ffffff'; og.fillRect(0,0,out.width,out.height); og.drawImage(cv,0,0);
    return out;
  }
  /* v768: o MESMO gerador de sempre, com os DADOS explícitos — é o que
     permite baixar o PDF direto do card do histórico usando o resultado
     SALVO daquele card (nunca o _cnpjState de outra empresa, §6.9), sem
     duplicar cnpjPaginas/kitPdfBlob. `done` devolve o botão do card. */
  function cnpjPdfAcaoDe(dados, modo, done){
    if(!_mevPdfPronto(function(){ cnpjPdfAcaoDe(dados, modo, done); },false)) return;   /* o jspdf chega e tenta de novo com OS MESMOS dados */
    var deuCerto=false;
    try{
      /* v595: páginas do kit — uma página A4 por canvas */
      var _blob=kitPdfBlob(cnpjPaginas(dados||{}));
      if(!_blob){ toast('O gerador de PDF não carregou. Tente de novo.'); }
      else{
        var nome='CNPJ-'+String((dados&&dados.cnpj)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,14)+'.pdf';
        pdfArquivoAcao(_blob,nome,modo,function(){ pdfVisor(_blob,nome); },'Consulta CNPJ'); deuCerto=true;
      }
    }catch(e){ toast('Não consegui gerar o PDF.'); }
    if(done) try{ done(deuCerto); }catch(_){}
  }
  function cnpjBaixarPDFDe(dados, done){ cnpjPdfAcaoDe(dados,'baixar',done); }
  function cnpjBaixarPDF(){ cnpjBaixarPDFDe(_cnpjState||{}); }

  /* ---- histórico local de consultas de CNPJ (dados) ---- */
  function cnpjHistLer(){ try{ return JSON.parse(localStorage.getItem('mev_cnpj_hist')||'[]'); }catch(_){ return []; } }
  function _cnpjHistItem(d){ var p=cnpjParse(d); return { doc:String(d.cnpj||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''), razao:p.razao||d.razao_social||'', uf:d.uf||'', ativa:!!p.ativa, ts:Date.now(), dados:d }; }
  /* ===== v682 — GUARDAR TUDO (decisão 28/08), COM A COTA NA MÃO ==========
     O teto de 20 caiu: a nuvem sempre guardou tudo (doc_consulta, upsert por
     CNPJ, sem teto) — quem jogava fora era o slice(0,20) daqui. Só que o
     localStorage TEM cota (~5 MB no iPhone) e o setItem LANÇA quando estoura
     — e o catch mudo antigo engolia: o histórico parava de atualizar sem
     erro, sem aviso (o mesmo desenho do defeito que a v592 caçou na fila).
     REGRA: a nuvem guarda tudo completo; o aparelho guarda o que couber.
     Apertou a cota → PODA sozinho: as 60 mais novas ficam inteiras, as
     antigas viram item LEVE (doc, razao, uf, ativa, ts — sem o `dados`).
     Tocar numa leve consulta de novo — e a consulta de CNPJ é a grátis.
     Só avisa se nem assim couber. */
  var _CNPJ_HIST_INTEIRAS = 60;
  function _cnpjHistGrava(l){
    function tenta(lista){ localStorage.setItem('mev_cnpj_hist', JSON.stringify(lista)); }
    try{ tenta(l); return true; }catch(_){}
    var podada=l.map(function(x,i){
      if(i<_CNPJ_HIST_INTEIRAS || !x || !x.dados) return x;
      return { doc:x.doc, razao:x.razao, uf:x.uf, ativa:x.ativa, ts:x.ts };
    });
    try{ tenta(podada); return true; }catch(_){}
    var enc=podada.slice();
    while(enc.length>10){
      enc=enc.slice(0, Math.floor(enc.length*0.7));
      try{ tenta(enc); return true; }catch(_){}
    }
    try{ toast('O histórico de CNPJ encheu a memória do aparelho — as consultas continuam completas na nuvem.'); }catch(_){}
    return false;
  }
  function cnpjHistSalvar(it){ if(!it||!it.doc) return; try{ var l=cnpjHistLer().filter(function(x){ return String(x.doc)!==String(it.doc); }); l.unshift(it); _cnpjHistGrava(l); }catch(_){} try{ docHistCloudSave('cnpj', it.doc, 'CNPJ', it.dados, it.ts); }catch(_){} }
  function cnpjHistCarregarNuvem(){
    try{ docHistCloudLoad('cnpj', function(rows, deuCerto){   /* v682: limite lá embaixo */
      /* v259 — backfill: sobe o que só existe neste aparelho (ver docHistBackfill no 03).
         Repare que no CNPJ o resultado fica em `dados`, não em `resultado`. */
      if(deuCerto) try{ docHistBackfill('cnpj', rows, cnpjHistLer().map(function(it){ return { chave:String(it.doc||''), tipo_doc:'CNPJ', resultado:it.dados, ts:it.ts }; })); }catch(_){}
      if(!rows||!rows.length) return;
      var l=cnpjHistLer(); var novo=false;
      rows.forEach(function(row){ var doc=String(row.chave||''); if(!doc) return; if(!l.some(function(x){ return String(x.doc)===doc; })){ var it2=_cnpjHistItem(row.resultado||{}); it2.doc=doc; it2.ts=Number(row.ts)||it2.ts; l.push(it2); novo=true; } });
      if(!novo) return;
      l.sort(function(a,b){ return (b.ts||0)-(a.ts||0); });   /* v682: sem teto — a poda cuida da cota */
      try{ _cnpjHistGrava(l); }catch(_){}
      cnpjHistRender();
    }, 1000); }catch(_){}   /* v682: a nuvem guarda tudo — o app agora vai buscar (era .limit(30)) */
  }
  /* ===== v682 — O FILTRO DO HISTÓRICO (decisão 28/08: o próprio #cnpjDoc
     filtra enquanto digita; sem campo separado). Só dígito → compara com o
     doc; tem letra → compara com a razão, sem acento e sem caixa.
     ⚠️ O filtro NUNCA dispara consulta — ele só escolhe o que DESENHAR. */
  function _cnpjSemAcento(x){
    try{ return String(x==null?'':x).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase(); }
    catch(_){ return String(x==null?'':x).toLowerCase(); }
  }
  function _cnpjHistFiltra(termo, l){
    termo=String(termo||'').trim();
    var pares=(l||[]).map(function(it,i){ return { it:it, i:i }; });
    if(!termo) return pares;
    var dig=termo.replace(/\D/g,'');
    if(dig && !/[A-Za-zÀ-ÿ]/.test(termo)){
      return pares.filter(function(p){ return String(p.it.doc||'').indexOf(dig)>=0; });
    }
    var t=_cnpjSemAcento(termo);
    return pares.filter(function(p){ return _cnpjSemAcento(p.it.razao).indexOf(t)>=0; });
  }
  /* v768: quantos cards o RESUMO mostra (o "Ver todas" abre o resto, §6.6) */
  var _CNPJ_HIST_RESUMO=3, _cnpjHistTudo=false;
  function cnpjHistCards(termo){
    var l=cnpjHistLer(); if(!l.length) return '';
    /* 🔴 A ARMADILHA DO data-i (nota da v601, no restHistCards, repetida
       aqui de propósito): o clique relê a LISTA COMPLETA pelo índice. O
       filtro escolhe O QUE desenhar, mas cada cartão carrega o índice REAL
       — filtrar e reindexar abriria a empresa errada, sem erro nenhum. */
    var pares=_cnpjHistFiltra(termo, l);
    if(!pares.length) return '';
    var corte=(!_cnpjHistTudo && !String(termo||'').trim()) ? _CNPJ_HIST_RESUMO : pares.length;
    var visiveis=pares.slice(0, corte);
    var verTodas=(pares.length>corte)?'<button type="button" class="cnpj-hc-vertodas" id="cnpjHistVer">Ver todas</button>':'';
    /* v768 (§6.7): o card deixou de ser UM botão — virou <article> com DUAS
       ações irmãs (abrir + PDF), nunca button dentro de button. O PDF só
       nasce vivo quando o registro tem os DADOS salvos (a poda da v682 pode
       ter tirado); degradado fica desabilitado com a explicação no title. */
    return '<div class="cnpj-hc-head"><span>Consultas recentes</span>'+verTodas+'</div>'+
      visiveis.map(function(par){ var it=par.it, i=par.i;
        var chip= it.ativa
          ? '<span class="cnpj-hc-chip ok">Ativa</span>'
          : '<span class="cnpj-hc-chip ver">Ver</span>';
        /* v595: a empresa que já tem RISCO salvo ganha o chip (reabrir mostra sem cobrar) */
        try{ if(typeof cnpjRiscoDoDoc==='function' && cnpjRiscoDoDoc(String(it.doc))) chip='<span class="cnpj-hc-chip risco">Risco</span>'+chip; }catch(_){}
        var temDados=!!(it.dados && it.dados.cnpj);
        var pdfBt='<button type="button" class="cnpj-hc-pdf" data-i="'+i+'"'+(temDados?'':' disabled')
          +' aria-label="Baixar PDF da consulta de '+esc(it.razao||'Empresa')+'" title="'+(temDados?'Baixar PDF':'Abra a consulta para gerar o PDF')+'">'+ICO_PDF+'</button>';
        return '<article class="cnpj-hc" data-i="'+i+'">'
          +'<button type="button" class="cnpj-hc-open" data-i="'+i+'">'
          +'<span class="cnpj-hc-tx"><span class="cnpj-hc-nm">'+esc(it.razao||'Empresa')+'</span><span class="cnpj-hc-sub">'+esc(_fmtCnpj(it.doc))+' · '+esc(histData(it.ts))+'</span></span>'
          +chip+'<span class="cnpj-hc-chev" aria-hidden="true">'+CHEV+'</span></button>'
          +pdfBt+'</article>';
      }).join('');
  }
  function cnpjHistRender(termo){
    var box=$('cnpjHist'); if(!box) return;
    /* v682: sem termo explícito, o filtro é o que está no campo agora —
       assim toda repintura (nuvem chegou, consulta salvou) respeita a busca */
    if(termo==null){ try{ termo=String(($('cnpjDoc')||{}).value||''); }catch(_){ termo=''; } }
    box.innerHTML=cnpjHistCards(termo)||'<p class="consulta-historico-vazio">Nenhuma consulta salva nesta pesquisa.</p>';
    /* v768: "Ver todas" abre o resto (o resumo mostra 3, §6.6) */
    var vt=$('cnpjHistVer'); if(vt) vt.onclick=function(){ _cnpjHistTudo=true; cnpjHistRender(); };
    /* v768: o PDF do card usa o resultado SALVO daquele card — nunca o
       _cnpjState da última consulta aberta (§6.9); stopPropagation segura o
       toque pra não abrir os detalhes junto; o botão trava durante a geração */
    Array.prototype.forEach.call(box.querySelectorAll('.cnpj-hc-pdf'),function(b){ b.onclick=function(e){
      try{ e.stopPropagation(); }catch(_){}
      var l=cnpjHistLer(); var it=l[Number(b.getAttribute('data-i'))||0];
      if(!it || !it.dados || !it.dados.cnpj){ toast('Abra a consulta para gerar o PDF.'); return; }
      if(b.disabled) return;
      b.disabled=true;
      cnpjBaixarPDFDe(it.dados, function(){ b.disabled=false; });
    }; });
    Array.prototype.forEach.call(box.querySelectorAll('.cnpj-hc-open'),function(c){ c.onclick=function(){ var l=cnpjHistLer(); var it=l[Number(c.getAttribute('data-i'))||0]; if(!it) return;
      /* v682 — EMPRESA DEGRADADA (a poda tirou o `dados`): consulta de novo
         pela porta de sempre — é a grátis. O campo recebe o número e o
         ouvinte do campo faz o resto, sem repetir lógica aqui. */
      if(!it.dados){
        var inp=$('cnpjDoc');
        if(inp){ inp.value=(typeof _fmtCnpj==='function')?_fmtCnpj(it.doc):it.doc;
          try{ inp.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){} }
        return;
      }
      _cnpjState=it.dados;
      /* v1037: o card cadastral reabre somente o relatório cadastral. Antes,
         a mesma ação tentava pintar também risco e Compliance; se um deles
         estivesse salvo, substituía a página que a pessoa havia escolhido. */
      cnpjResultadoAbrir('dados',it.doc,it.dados,it.ts,true);
      /* consulta ANTIGA pode estar sem endereço/contato: completa e atualiza o cache */
      cnpjCompletar(it.dados).then(function(d2){ _cnpjState=d2; it.dados=d2; try{ cnpjHistSalvar(_cnpjHistItem(d2)); }catch(_){} });
    }; });
  }
  /* Inscrição Estadual (melhor esforço): a base da Receita NÃO traz IE; tento a base aberta do CNPJá */
  async function cnpjBuscarIE(doc){
    doc=String(doc||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(doc.length!==14) return;
    try{
      var r=await fetch('https://open.cnpja.com/office/'+doc,{headers:{Accept:'application/json'}});
      if(!r.ok) return;
      var j=await r.json();
      var regs=(j&&j.registrations)||[];
      var ie=regs.filter(function(x){ return x&&x.number; }).map(function(x){ return { uf:(x.state||''), numero:String(x.number), enabled:(x.enabled!==false) }; });
      if(!ie.length) return;
      if(_cnpjState && String(_cnpjState.cnpj||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'')===doc){
        _cnpjState._ie=ie;
        var res=$('cnpjResult'); if(res){ res.innerHTML=cnpjPanelHtml(_cnpjState); var pb=res.querySelector('#cnpjPdf'); if(pb) pb.onclick=function(){ cnpjBaixarPDF(); }; try{ _cpfBlocosLigar(res); }catch(_){}   /* v637 */ }
        try{ cnpjHistSalvar(_cnpjHistItem(_cnpjState)); }catch(_){}
      }
    }catch(_){}
  }

  /* selo da montadora — cor + sigla da marca (identificação; sem reproduzir a logo registrada) */
  var MARCAS_BADGE={
    'VW':{t:'VW',c:'#0a3d91'},'VOLKSWAGEN':{t:'VW',c:'#0a3d91'},
    'FIAT':{t:'FIAT',c:'#8e1b2e'},
    'CHEVROLET':{t:'CHEV',c:'#b8962e'},'GM':{t:'GM',c:'#b8962e'},
    'FORD':{t:'FORD',c:'#003478'},
    'TOYOTA':{t:'TOY',c:'#c00010'},'HONDA':{t:'HON',c:'#c00010'},
    'HYUNDAI':{t:'HYU',c:'#002c5f'},'RENAULT':{t:'REN',c:'#efdf00',fg:'#111'},
    'NISSAN':{t:'NIS',c:'#c3002f'},'JEEP':{t:'JEEP',c:'#0b3d2e'},
    'PEUGEOT':{t:'PEU',c:'#00205b'},'CITROEN':{t:'CIT',c:'#8b1a2b'},'CITROËN':{t:'CIT',c:'#8b1a2b'},
    'KIA':{t:'KIA',c:'#111111'},'MITSUBISHI':{t:'MIT',c:'#e60012'},
    'MERCEDES':{t:'MB',c:'#111111'},'MERCEDES-BENZ':{t:'MB',c:'#111111'},
    'BMW':{t:'BMW',c:'#0166b1'},'AUDI':{t:'AUDI',c:'#bb0a30'},
    'YAMAHA':{t:'YAM',c:'#003399'},'SUZUKI':{t:'SUZ',c:'#e30613'},'KAWASAKI':{t:'KAW',c:'#0b7a2e'},
    'CHERY':{t:'CHERY',c:'#c00010'},'CAOA':{t:'CAOA',c:'#c00010'},'GWM':{t:'GWM',c:'#c00010'},'BYD':{t:'BYD',c:'#c00010'},
    'VOLVO':{t:'VOLVO',c:'#00285a'},'JAGUAR':{t:'JAG',c:'#0b2e1e'}
  };
  function _marcaInfo(marca){
    var m=String(marca||'').toUpperCase().replace(/\s*-\s*.*$/,'').trim();
    if(MARCAS_BADGE[m]) return MARCAS_BADGE[m];
    var full=String(marca||'').toUpperCase(); for(var k in MARCAS_BADGE){ if(full.indexOf(k)>=0) return MARCAS_BADGE[k]; }
    var sig=(m||'?').replace(/[^A-Z0-9]/g,'').slice(0,4)||'?';
    return { t:sig, c:'#64748b' };
  }
  function marcaBadge(marca, size){ var i=_marcaInfo(marca); return '<span class="mbadge '+(size||'sm')+'" style="background:'+i.c+(i.fg?(';color:'+i.fg):'')+'">'+esc(i.t)+'</span>'; }

  /* ---- Tela: Histórico de consultas ---- */
  var _histPinta=null;   /* v386: repinta a página Histórico quando os mapas chegam */
  var ICO_TRASH='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
  /* placa desenhada no formato Mercosul */
  function placaMercosul(p){
    var s=String(p||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(/^[A-Z]{3}[0-9]{4}$/.test(s)){ /* placa antiga (cinza): LLL-NNNN */
      return '<span class="mrc mrc-old"><span class="top"><span>BRASIL</span></span><span class="num">'+esc(s.slice(0,3)+'-'+s.slice(3))+'</span></span>';
    }
    return '<span class="mrc"><span class="top"><span>MERCOSUL</span><span class="fl"></span></span><span class="num">'+esc(s||p||'')+'</span></span>';
  }
  /* etiqueta do que já está salvo naquela placa (evita pagar de novo) */
  /* ===== v350 (pedido) — A ETIQUETA DE SITUAÇÃO NO CARD DA CONSULTA ========
     O vendedor consulta uma placa e, dias depois, consulta de novo sem
     lembrar que aquele carro JÁ ESTÁ no pátio — ou pior, que já foi vendido.
     Agora o próprio card da consulta diz em que pé o veículo está:

        NO ESTOQUE   verde  — cadastrado e disponível
        RESERVADO    âmbar  — marcado como reservado no estoque
        VENDIDO      cinza  — já saiu
        NEGOCIANDO   roxo   — venda aberta pra uma placa que NÃO está no
                              seu estoque (carro que ainda vai entrar)

     Se a mesma placa se encaixa em mais de um, vale o estado mais adiantado:
     vendido > reservado > no estoque.
     SEM etiqueta = a placa não está no seu estoque.

     ===== v378 (pedido) — "O VIRTUS JÁ TÁ NO ESTOQUE" =====================
     O Virtus estava cadastrado e disponível no pátio, e mesmo assim o card
     dizia NEGOCIANDO. Duas coisas erradas de uma vez:

       1. a proposta aberta ROUBAVA o lugar da situação do estoque, então o
          carro que é seu, no seu pátio, parecia carro de fora;
       2. "negociando", sozinho, não diz se é negociação pra COMPRAR ou pra
          VENDER — e quem lê entende o que estiver mais na cabeça no dia.

     Regra nova: quem manda na etiqueta é o ESTOQUE. A proposta em aberto
     vira um SEGUNDO selinho ao lado ("Em proposta"), que é a informação que
     realmente evita dois vendedores oferecendo o mesmo carro. */
  var _SIT_TAG = {
    vendido:    { t:'Vendido',    c:'cinza' },
    reservado:  { t:'Reservado',  c:'ambar' },
    negociando: { t:'Negociando', c:'roxo'  },
    disponivel: { t:'No estoque', c:'verde' }
  };
  /* v378: o selinho extra. Só faz sentido em carro que ainda está no pátio —
     em VENDIDO a venda aberta é a própria história do card, e em NEGOCIANDO
     seria dizer a mesma coisa duas vezes. */
  function histProp(x){
    if(!_estProp || !_estSit) return false;
    var pl=_avPlacaKey(x && x.placa);
    if(!pl || !_estProp[pl]) return false;
    var st=_estSit[pl];
    return st==='disponivel' || st==='reservado';
  }
  function histTag(x){
    /* enquanto o mapa não chegou do banco, card nenhum ganha etiqueta — é
       melhor não mostrar nada do que mostrar a situação errada por um
       segundo. Quando chega, o pintaHomeHist redesenha sozinho. */
    if(!_estSit) return null;
    var st = _estSit[_avPlacaKey(x && x.placa)];
    return st ? (_SIT_TAG[st] || null) : null;
  }
  /* v358: miniatura da capa no card do histórico. Só existe pra veículo que
     está no estoque (é de lá que a foto vem). Sem foto, o card fica igual ao
     de antes — nenhum espaço vazio reservado. */
  function histCapaHtml(x){
    if(!_estCapa) return '';
    var u=_estCapa[_avPlacaKey(x && x.placa)];
    if(!u) return '';
    return '<span class="hi-capa"><img loading="lazy" decoding="async" src="'+esc(u)+'" alt=""></span>';
  }
  /* junta TODAS as fontes de histórico (placa, ficha, restrições, leilão, CPF, CNPJ) num extrato só */
  function _histTudo(){
    var itens=[];
    try{ histLer().forEach(function(x){ itens.push({ kind:'placa', tipo:'placa', placa:x.placa, chave:x.placa, modelo:x.modelo||'Veículo', ts:x.ts||0, fav:!!x.fav, tok:x.tok||null, v:x.v||null, temFicha:!!x.ficha, temRestr:!!x.leilao, fipe:(x.v&&x.v.fipe)?brl(x.v.fipe):'' }); }); }catch(_){}
    try{ fipeModeloHistLer().forEach(function(x){ itens.push({ kind:'fipe_modelo', tipo:'fipe_modelo', placa:'', chave:x.chave, modelo:x.modelo||'Veículo', ts:x.ts||0, fav:false, v:x.v||null, _fm:x }); }); }catch(_){}
    /* v990 — o CPF SAIU do extrato. Não é filtro nem esconde-esconde: o
       histórico de consulta de CPF deixou de existir (ver restHistLimpar,
       no 03-ficha-tecnica). Sem fonte, não há o que listar. O CNPJ, na
       linha de baixo, FICA — é dado de empresa, público na Receita. */
    try{ cnpjHistLer().forEach(function(x){ itens.push({ kind:'cnpj', tipo:'cnpj', chave:String(x.doc||''), modelo:x.razao||'Consulta CNPJ', ts:x.ts||0, tok:null }); }); }catch(_){}
    try{ lhHistLer().forEach(function(x){ itens.push({ kind:'leilao', tipo:'leilao', placa:x.placa, chave:x.placa, modelo:x.modelo||'Veículo', ts:x.ts||0, tok:x.tok||null }); }); }catch(_){}
    itens.sort(function(a,b){ var f=(b.fav?1:0)-(a.fav?1:0); return f||((b.ts||0)-(a.ts||0)); });
    return itens;
  }
  function _histMatch(x,f){
    if(f==='todos') return true;
    if(f==='placa') return x.tipo==='placa' || x.tipo==='fipe_modelo';
    if(f==='ficha') return x.tipo==='placa' && x.temFicha;
    if(f==='restr') return x.tipo==='placa' && x.temRestr;
    if(f==='leilao') return x.tipo==='leilao';
    if(f==='cpf') return x.tipo==='cpf';
    if(f==='cnpj') return x.tipo==='cnpj';
    return false;
  }
  function _histBadge(x,filtro){
    /* Se a lista está filtrada por um complemento da placa, o selo e o custo
       precisam representar exatamente esse complemento. */
    if(filtro==='ficha') return ['ficha','Ficha'];
    if(filtro==='restr') return ['restr','Restrições'];
    if(x.tipo==='cpf') return ['cpf','CPF'];
    if(x.tipo==='cnpj') return ['cnpj','CNPJ'];
    if(x.tipo==='leilao') return ['leilao','Leilão'];
    if(x.tipo==='fipe_modelo') return ['placa','FIPE por veículo'];
    if(x.temRestr) return ['restr','Restrições'];
    if(x.temFicha) return ['ficha','Ficha'];
    return ['placa','Placa'];
  }
  /* Custos canônicos de cada pesquisa representada no histórico.
     Não depende de x.tok: registros antigos e sincronizados podem não guardar
     o extrato do débito, mas continuam sabendo qual pesquisa foi realizada. */
  function _histCusto(tipo, tok){
    if(tipo==='placa' && tok && tok.gratuito) return ['Grátis',true];
    var custos={
      placa:[precoReal(0.06),false],
      ficha:[precoReal(1),false],
      restr:[precoReal(2.50),false],
      leilao:[precoReal(20),false],
      cpf:[precoReal(2.50),false],
      cnpj:['Grátis',true],
      fipe_modelo:['Grátis',true]
    };
    return custos[tipo]||['—',false];
  }

  function _histConsumoNumero(custo){
    if(!custo || custo[1]) return 0;
    var valor=parseFloat(String(custo[0]||'').replace(/[^\d,.-]/g,'').replace(',','.'));
    return isFinite(valor)?valor:0;
  }

  function _histConsumoTexto(valor){
    if(!valor) return 'Sem consumo';
    var normal=Math.round(valor*100)/100;
    return 'R$ '+normal.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});
  }

  function _histDia(ts){ return ts ? histData(ts) : 'Sem data'; }
  /* v763 — FASE 3 do PROJETO-2026-08-30-cards-consulta: o RÓTULO DO DIA que
     separa os registros do histórico na coluna larga do computador. A decisão
     Hoje/Ontem é a MESMA do chat (_chDiaTxt, 12d — regra §9.5: reutilizar, não
     criar um segundo algoritmo); pra dias anteriores a data sai POR EXTENSO
     (ex.: "sexta-feira, 28 de agosto"), sem mexer no separador do chat. */
  function _hhDiaTxt(ts){
    if(!ts) return 'Sem data';
    var dt=new Date(ts), t='';
    try{ t=_chDiaTxt(dt); }catch(_){ t=''; }
    if(t==='Hoje'||t==='Ontem') return t;
    try{ return dt.toLocaleDateString('pt-BR',{ weekday:'long', day:'numeric', month:'long' }); }catch(_){ return t||_histDia(ts); }
  }
  /* reabre a consulta certa (sem custo) conforme o tipo */
  function _histReabrir(x){
    if(!x) return;
    if(x.kind==='placa'){ abrirSalva(x.placa); return; }
    if(x.kind==='leilao'){ _histAbrirLeilao(x.chave); return; }
    if(x.kind==='cpf'){ _histAbrirCpf(x.chave); return; }
    if(x.kind==='cnpj'){ _histAbrirCnpj(x.chave); return; }
    if(x.kind==='fipe_modelo'){ try{ fipeModeloHistAbrir(x.chave); }catch(_){} return; }
  }
  function _histAbrirCpf(doc){ try{ abrirRestricao(); }catch(_){ return; } try{ var it=restHistLer().filter(function(x){return String(x.doc)===String(doc);})[0]; if(it){ _restState=it.resultado; var inp=$('restDoc'); if(inp) inp.value=(typeof _fmtCpf==='function')?_fmtCpf(doc):doc; var res=$('restResult'); if(res){ res.innerHTML=restricaoPanelHtml(it.resultado); var pb=res.querySelector('#restPdf'); if(pb) pb.onclick=function(){ restricaoBaixarPDF(); }; try{ res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){} } } }catch(_){} }
  function _histAbrirCnpj(doc){ try{ var it=cnpjHistLer().filter(function(x){return String(x.doc)===String(doc);})[0]; if(it&&it.dados){
    cnpjResultadoAbrir('dados',doc,it.dados,it.ts,true);
    cnpjCompletar(it.dados).then(function(d2){ _cnpjState=d2; it.dados=d2; try{ cnpjHistSalvar(_cnpjHistItem(d2)); }catch(_){} });
  } }catch(_){} }
  function _histAbrirLeilao(placa){ try{ abrirLeilaoHist(); }catch(_){ return; } try{ var it=lhHistLer().filter(function(x){return String(x.placa)===String(placa);})[0]; if(it&&it.resultado){ _leilaoHistState=it.resultado; var inp=$('lhPlaca'); if(inp) inp.value=placa; var res=$('lhResult'); if(res){ res.innerHTML='<div style="font-weight:800;color:var(--verde);padding:2px 0 6px">✓ Consulta salva (reaberta sem custo)</div>'+leilaoHistPanelHtml(it.resultado); var pb=res.querySelector('#lhPdf'); if(pb) pb.onclick=function(){ leilaoHistBaixarPDF(); }; try{ res.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){} } } }catch(_){} }
  /* remove uma consulta da nuvem (doc_consulta) e do cache local */
  function _docCloudDel(tipo,chave){ try{ if(window.supa&&meuId){ supa.from('doc_consulta').delete().eq('user_id',meuId).eq('tipo',tipo).eq('chave',String(chave)).then(function(){},function(){}); } }catch(_){} }
  function _histApagarItem(x){
    if(!x) return;
    if(x.kind==='placa'){ if(confirm('Apagar a consulta da placa '+x.placa+'?\nIsso remove do histórico em todos os seus aparelhos.')){ histExcluirPlaca(x.placa, abrirHistorico); } return; }
    if(!confirm('Apagar esta consulta do histórico?')) return;
    try{
      /* v990 — o ramo do 'cpf' saiu daqui junto com a fonte: sem item de CPF
         no extrato, este ramo nunca rodaria, e o que ele fazia era GRAVAR de
         volta o 'mev_rest_hist' que a v990 passou a apagar. */
      if(x.kind==='cnpj'){ localStorage.setItem('mev_cnpj_hist', JSON.stringify(cnpjHistLer().filter(function(y){return String(y.doc)!==String(x.chave);}))); _docCloudDel('cnpj',x.chave); }
      else if(x.kind==='leilao'){ localStorage.setItem('mev_leilao_hist', JSON.stringify(lhHistLer().filter(function(y){return String(y.placa)!==String(x.chave);}))); _docCloudDel('leilao',x.chave); }
      else if(x.kind==='fipe_modelo'){ fipeModeloHistGrava(fipeModeloHistLer().filter(function(y){return String(y.chave)!==String(x.chave);})); _docCloudDel('fipe_modelo',x.chave); }
    }catch(_){}
    abrirHistorico();
  }
  /* v387 — os cards "Da equipe" dentro do Histórico (mesmo card da lista
     normal, com o nome de quem consultou; sem lixeira — a placa é do colega).
     Clique abre a consulta em modo leitura (abrirEquipe, o mesmo da home). */
  function _histEquipePinta(el, termo){
    var lista=_equipeHist.slice().sort(function(a,b){ return (b.ts||0)-(a.ts||0); })
      .filter(function(x){ if(!termo) return true; return (String(x.placa||'').toUpperCase().indexOf(termo)>=0)||(String(x.modelo||'').toUpperCase().indexOf(termo)>=0); });
    if(!lista.length){ el.innerHTML='<div class="plc-msg" style="padding:8px 2px">'+(_equipeHist.length?'Nada encontrado.':'A equipe ainda não salvou placas.')+'</div>'; return; }
    el.innerHTML=lista.map(function(x){
      var i=_equipeHist.indexOf(x);
      var _af=(x.v&&(x.v.ano||''))||'', _am=(x.v&&(x.v.ano_modelo||''))||'';
      var anoTxt=(_af||_am)?((_af||_am)+'/'+(_am||_af)):'';
      var anoHtml=anoTxt?('<span class="hi-ano">'+esc(anoTxt)+'</span> · '):'';
      var por=x.por?('<span class="hi-por">'+esc(x.por)+'</span> · '):'';
      var fipeHtml=(x.v&&x.v.fipe)?('<div class="hi-fipe">'+esc(brl(x.v.fipe))+'</div>'):'';
      return '<div class="hist-item" data-eq="'+i+'" role="button" tabindex="0" aria-label="Abrir '+esc(x.modelo||'consulta')+'">'+
        '<div class="hi-top"><div class="hi-mod">'+esc(x.modelo||'Veículo')+'</div></div>'+
        '<div class="hi-main"><span class="hi-plcol">'+placaMercosul(x.placa)+'</span>'+
        '<div class="hi-info">'+fipeHtml+
        '<div class="hi-meta">'+anoHtml+por+esc(histData(x.ts))+'</div></div>'+
        '<span class="hi-go">'+CHEV+'</span></div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.hist-item'),function(it){
      var idx=+it.getAttribute('data-eq');
      it.onclick=function(){ abrirEquipe(idx); };
      it.onkeydown=function(e){ if(e.target!==it || (e.key!=='Enter' && e.key!==' ')) return; e.preventDefault(); abrirEquipe(idx); };
    });
  }
  /* ==========================================================================
     v766 — HISTÓRICO DE CONSULTAS NO CELULAR
     (docs/PROJETO-2026-08-30-historico-consultas-mobile.txt)
     ==========================================================================
     A página ganhou: título + contador em pílula, busca + FILTROS (origem ·
     período · situação, num bottom sheet), agrupamento por dia (Hoje/Ontem/
     data — a decisão Hoje/Ontem é a MESMA do chat), card compacto SEM a
     lixeira exposta (a exclusão foi pro menu "Mais ações", protegida), e o
     dock compacto da v754 (body.hist-on).
     🔴 MUDANÇA DE COMPORTAMENTO (aprovada no projeto, substitui a v395):
     tocar no CORPO do card agora REABRE a consulta salva (sem custo);
     o menu de ações abre só pelos três pontinhos (hi-more).
     Filtros vivem só enquanto a página está aberta (§10.4) — sair e voltar
     começa em Minhas placas / últimos 30 dias.
     Rollback: remover body.hist-on + bloco CSS v766 e restaurar esta função
     (a versão anterior está no git/changelog v395–v765).
     ========================================================================= */
  function abrirHistorico(){
    mevTabSet('hist');
    /* 🔴🔴 v1089 — FASE 4 DO PROJETO DE 19/09, §8 "ESTADOS OBRIGATÓRIOS".
       "Carregando: manter estrutura estável; NÃO EXIBIR 'nenhuma consulta'
        antes do fim do carregamento."
       "Erro ou offline: mensagem clara; botão Tentar novamente; NENHUM
        REGISTRO LOCAL DEVE SER APAGADO."

       Até aqui esta tela tinha DOIS estados pra TRÊS situações: quem chegava
       com o histórico ainda vindo da nuvem via "Nenhuma consulta recente" —
       a mesma frase de quem nunca consultou nada, e a mesma de quem está sem
       internet. Três verdades diferentes, uma frase só, e a mais desanimadora
       das três.

       ⚠️ O ESTADO É DA TELA, NÃO DO APP: mora numa variável do módulo e
       começa em "carregando" a cada abertura. Guardar isso no app faria a
       segunda visita herdar o erro da primeira. */
    _histNuvem='carregando';
    try{ fipeModeloHistSync(function(mudou, ok){
      if(!document.body.classList.contains('hist-on')) return;
      _histNuvem = (ok===false) ? 'erro' : 'pronto';
      /* mudou: a lista de itens é outra, então a tela se remonta inteira
         (era assim desde a v766 e continua). Não mudou: basta repintar, pra
         sair do esqueleto sem refazer a tela por nada. */
      if(mudou){ abrirHistorico(); return; }
      try{ if(_histPinta) _histPinta((($('histBusca')||{}).value)||''); }catch(_){}
    }); }catch(_){ _histNuvem='erro'; }
    if(_avValores===null) avValoresCarregar();
    if(_estSit===null) estSituacaoCarregar();
    var itens=_histTudo();
    var total=itens.filter(function(x){ return _histMatch(x,'placa'); }).length;
    /* v764: o gestor enxerga a origem "Da equipe" também enquanto carrega/da erro */
    /* ==========================================================================
       🔴 v918 — OS FILTROS SAÍRAM DO HISTÓRICO (pedido do Angelo, 06/09:
       "novo projeto pra remover filtros do histórico")
       --------------------------------------------------------------------------
       A v896 já tinha encolhido o botão: ele só aparecia quando algum filtro
       separaria a lista de verdade. Esta versão termina o serviço — a tela
       responde UMA pergunta, "onde está aquela placa", e a busca responde
       melhor que qualquer painel.

       O QUE SAIU: o botão Filtros, a folha de opções (origem · período ·
       situação), os chips dos filtros ativos e a linha "Limpar filtros" —
       da MONTAGEM, não do CSS (esconder deixaria o handler vivo e a folha a
       um `display` de distância).

       ✅ O GESTOR NÃO PERDE A EQUIPE, e eu conferi antes de tirar: a
       alternância "Minhas · Da equipe" existe TAMBÉM no cartão de histórico
       da tela inicial (`pintaHomeHist`, com o `_histView`), e essa continua
       intacta. O que saiu daqui foi a SEGUNDA porta pra mesma coisa, a que
       estava escondida atrás de um funil.
       ⚠️ E nada foi apagado no motor: `_equipeHist`, `carregarPapelEquipe`,
       `abrirEquipe` e o `_histEquipePinta` (v387) seguem inteiros. */
    var ICO_MAIS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="5" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="12" cy="19" r="1.4"/></svg>';
    /* ==========================================================================
       🔴 v885 — AS CONTAGENS SAEM DO HISTÓRICO
       (PROJETO-2026-09-04-historico-premium-sem-contagens, §2)
       --------------------------------------------------------------------------
       Eram três: a pílula do total ao lado do título, o "N consultas" no
       cabeçalho de cada dia e o "N resultados" embaixo dos filtros.

       🔴 POR QUE ELAS SAEM, e não é só estética: número na tela é promessa de
       precisão. "3 consultas" convida a conferir, e no dia em que um filtro
       mudar a conta e outro não, a tela mente sem avisar. O que o Angelo
       procura aqui é UMA placa — a lista responde isso, o número não ajuda.

       ⚠️ E SAEM DA MONTAGEM, não do CSS (§2, "preferência de implementação"):
       esconder com `display:none` deixa o cálculo rodando, o `aria-label`
       falando o número pro leitor de tela e o elemento pronto pra reaparecer
       no próximo ajuste de folha de estilo.

       ⚠️ O QUE FICA: as contas internas que os FILTROS precisam. O
       `totalOrigem` continua vivo logo abaixo porque é ele que decide se o
       botão "Filtros" aparece — some o número, não a lógica.
       ⚠️ E NÃO ENCOSTEI nos contadores de "Uso e faturamento" nem nos badges
       de conversas/notificações: não são do histórico (§2 e §15). */
    var head='<div class="hist-page-head">'
      +'<span class="hist-page-eyebrow">CONSULTAS SALVAS</span>'
      +'<h2 class="hist-page-title" id="histTit">Histórico de consultas</h2>'
      +'<p class="hist-page-sub">Encontre uma placa ou veículo e reabra o resultado sem nova cobrança.</p>'
      +'</div>';
    var busca='<label class="hist-search" for="histBusca">'+_icoBusca+'<input id="histBusca" class="hist-busca" type="search" aria-label="Buscar no histórico" placeholder="Buscar placa ou modelo" autocomplete="off" autocapitalize="characters"></label>';
    /* v918 — a busca agora é a linha inteira (`hist-tools-row-solo` troca as
       duas colunas do grid por uma só). Sem botão ao lado, sem chips embaixo,
       sem linha de "Limpar filtros". */
    irTela(head+'<div class="hist-toolbar hist-tools-row hist-tools-row-solo" id="histTools">'+busca+'</div>'
      +'<div id="histLista" class="hist-lista"></div>','home');
    document.body.classList.remove('md-veiculo');   /* histórico é lista, não resultado de placa */
    document.body.classList.add('hist-on');   /* v766: dock compacto + estilos; irTela/voltarHome tiram */
    try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar('Histórico'); }catch(_){}
    /* ==========================================================================
       🔴 v885 — O 5º BOTÃO DA CÁPSULA: "Adicionar" (§7 do projeto)
       --------------------------------------------------------------------------
       A ordem aprovada é Voltar · Adicionar · Início · Conversas · Menu, e o
       projeto diz onde ele mora: "ações contextuais devem usar o destino
       existente de `btnAcaoFab`/`mevCtx`, sem duplicar listeners". É o que
       isto faz — nenhum botão novo no DOM.

       ⚠️ ADICIONAR NÃO CONSULTA (§7): ele leva pra tela de consulta com o campo
       da placa em foco. Quem dispara a consulta paga continua sendo a lupa
       (v883). Aqui não passa nem perto de cobrança.

       ⚠️ E QUANDO ELE NÃO EXISTE, A CÁPSULA FECHA O ESPAÇO SOZINHA: quem some
       o botão é o `mevCtx(null)` das outras telas, e a distribuição da cápsula
       é flex — quatro círculos se redistribuem sem buraco. É o §7 outra vez:
       "se Adicionar não estiver disponível, o botão deve sair do fluxo e a
       distribuição deve recalcular sem deixar um espaço vazio". */
    try{
      mevCtx('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
        'Nova consulta', function(){
          try{ voltarHome(); }catch(_){}
          try{ var p=$('placa'); if(p) setTimeout(function(){ try{ p.focus(); }catch(_2){} }, 120); }catch(_){}
        });
      var _af=$('btnAcaoFab'); if(_af) _af.setAttribute('aria-label','Nova consulta');
    }catch(_){}
    try{ consultaUiDockMedir(); }catch(_){}
    /* v401: sem o rótulo "Nova consulta" no alto (o voltar continua no dock e no deslize) */
    try{ var _th=document.querySelector('#secoes .tela-head'); if(_th) _th.parentNode.removeChild(_th); }catch(_){}

    /* ---- normalização da busca (§9.3): caixa, espaços e, pra placa, só o alfanumérico ---- */
    function _norm(s){ return String(s||'').toUpperCase().replace(/\s+/g,' ').trim(); }
    function _alfa(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
    function _buscaOk(x,termo){
      if(!termo) return true;
      var tAlfa=_alfa(termo);
      if(tAlfa && _alfa(x.placa).indexOf(tAlfa)>=0) return true;
      if(_norm(x.modelo).indexOf(termo)>=0) return true;
      if(x.por && _norm(x.por).indexOf(termo)>=0) return true;   /* autor, no modo Da equipe */
      return false;
    }
    /* v918 — uma fonte só: as consultas de PLACA desta conta. O filtro de
       origem (minhas × da equipe) saiu com o painel. */
    function _fonte(){ return itens.filter(function(x){ return _histMatch(x,'placa'); }); }
    /* rótulo do dia (§11.2): Hoje/Ontem pela MESMA régua do chat; depois a
       data ("29 de agosto", com o ano só quando não é o ano corrente) */
    function _diaLabel(ts){
      if(!ts) return 'Sem data';
      var dt=new Date(ts), t='';
      try{ t=_chDiaTxt(dt); }catch(_){ t=''; }
      if(t==='Hoje'||t==='Ontem') return t;
      try{ var op={ day:'numeric', month:'long' }; if(dt.getFullYear()!==(new Date()).getFullYear()) op.year='numeric'; return dt.toLocaleDateString('pt-BR',op); }catch(_){ return _histDia(ts); }
    }
    function _cardHtml(x,i){
      var _af=(x.v&&(x.v.ano||''))||'', _am=(x.v&&(x.v.ano_modelo||''))||'';
      var anoTxt=(_af||_am)?((_af||_am)+'/'+(_am||_af)):'';
      var anoHtml=anoTxt?('<span class="hi-ano">'+esc(anoTxt)+'</span>'):'';
      var por=(x.kind==='equipe'&&x.por)?('<span class="hi-por">'+esc(x.por)+'</span> · '):'';
      /* 🔴 v1087 — FASE 1 DO PROJETO DE 19/09 (§6.5 e §9): o rótulo "Valor
         FIPE" passa a ser TEXTO DE VERDADE no HTML, não um pseudo-elemento.
         O §9 diz por quê: "não depender só de cor para identificar FIPE".
         Até aqui o único sinal de que aquele número é a FIPE era ele ser
         verde — e verde não chega em leitor de tela.

         ⚠️ O VALOR CONTINUA NO MESMO NÓ `.hi-fipe`: o `nowrap` da v1083 e a
         cor verde não se mexem, e quem procurar `.hi-fipe` no CSS continua
         achando o que sempre achou. O rótulo é um irmão, não um embrulho
         que muda o valor de lugar.

         ⚠️ E É SÓ AQUI, NÃO NOS OUTROS DOIS CARTÕES: o mesmo `.hi-fipe` é
         montado também pelo `pintaHomeHist` (o cartão lateral da tela
         inicial) e pelo `_histEquipePinta`. O projeto (§4) é da PÁGINA
         COMPLETA do histórico; mexer nos outros dois seria escopo que
         ninguém pediu — e o CSS do rótulo está preso em `#histLista`
         justamente pra não vazar pra eles por acidente. */
      var fipeHtml=(x.v&&x.v.fipe)?('<div class="hi-fipe-box"><span class="hi-fipe-lbl">Valor FIPE</span><div class="hi-fipe">'+esc(brl(x.v.fipe))+'</div></div>'):'';
      var avHtml='', tagHtml='';
      if(x.kind!=='equipe'){
        var _av=(_avValores&&_avValores[_avPlacaKey(x.placa)])||0;
        if(_av) avHtml='<div class="hi-aval">Avaliado <b>'+esc(brl(_av))+'</b></div>';
        var tag=histTag(x); if(tag) tagHtml=' <span class="hi-tag '+tag.c+'">'+tag.t+'</span>';
        if(histProp(x)) tagHtml+=' <span class="hi-tag roxo">Em proposta</span>';
      }
      /* §13.1: a lixeira SAIU do card — quem tem ações ganha os três pontinhos */
      var more=(x.kind!=='equipe'&&x.kind!=='fipe_modelo')?('<button type="button" class="hi-more" data-i="'+i+'" aria-label="Mais ações para '+esc(x.placa||'')+'" title="Mais ações">'+ICO_MAIS+'</button>'):'';
      var identificador=x.kind==='fipe_modelo'?'<span class="hist-sem-placa">Sem placa</span>':placaMercosul(x.placa);
      return '<div class="hist-item" data-i="'+i+'" role="button" tabindex="0" aria-label="Abrir consulta salva — '+esc((x.modelo||'Veículo')+' '+(x.placa||''))+'">'+
        '<div class="hi-top"><div class="hi-mod">'+esc(x.modelo||'Veículo')+'</div>'+more+'</div>'+
        '<div class="hi-main"><span class="hi-plcol">'+identificador+'</span>'+
        '<div class="hi-info">'+fipeHtml+avHtml+
        '<div class="hi-meta">'+por+anoHtml+tagHtml+'</div></div>'+
        /* 🔴 v1088 — §9: "SVG decorativo com aria-hidden". O chevron repete
           com desenho o que o `aria-label` do card já diz com palavra; sem
           isto o leitor de tela lê o card e depois anuncia um gráfico sem
           nome. É o mesmo tratamento que o `.cnpj-hc-chev` já tem nesta
           arquivo desde antes — o card do histórico é que tinha ficado de
           fora. */
        '<span class="hi-go" aria-hidden="true">'+CHEV+'</span></div></div>';
    }
    function pinta(termo){
      var el=$('histLista'); if(!el) return;
      termo=_norm(termo);
      /* 🔴 v1089 (§8) — SEM NADA PRA MOSTRAR, SÃO TRÊS TELAS, NÃO UMA:
         carregando · erro/offline · vazio de verdade. A caixa de busca some
         nas três — buscar em lista vazia é degrau em qualquer uma delas. */
      if(!total && !termo && _histNuvem==='carregando'){
        var tl0=$('histTools'); if(tl0) tl0.hidden=true;
        /* ESQUELETO, não "carregando..." escrito: o §8 pede "manter estrutura
           estável". Três blocos do tamanho de um card seguram o layout no
           lugar, e aí nada salta quando a lista chega.
           ⚠️ `aria-busy` + `aria-label`: pro leitor de tela, três retângulos
           cinzas são silêncio. A frase existe pra ele mesmo que não seja
           desenhada. */
        el.innerHTML='<div class="hist-esqueleto" role="status" aria-busy="true" aria-label="Carregando suas consultas">'
          +'<div class="hist-esq-card"></div><div class="hist-esq-card"></div><div class="hist-esq-card"></div></div>';
        return;
      }
      if(!total && !termo && _histNuvem==='erro'){
        var tl1=$('histTools'); if(tl1) tl1.hidden=true;
        el.innerHTML='<div class="hh-vazio hist-vazio-pg">'
          +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3a9 9 0 1 1-9 9"/><line x1="12" y1="8" x2="12" y2="13"/><circle cx="12" cy="16.5" r="1"/></svg>'
          +'<b>N\u00e3o consegui carregar seu hist\u00f3rico</b>'
          +'<p>Pode ser a sua conex\u00e3o. <b>Nada foi apagado</b> \u2014 suas consultas continuam salvas.</p>'
          +'<button type="button" class="hh-tentar" id="histTentarDeNovo">Tentar novamente</button></div>';
        var tn=$('histTentarDeNovo');
        if(tn) tn.onclick=function(){
          /* volta pro esqueleto ANTES de pedir de novo: se a segunda tentativa
             também falhar, a pessoa vê que ALGO aconteceu. Botão que não
             pisca parece botão quebrado. */
          _histNuvem='carregando'; pinta(termo);
          try{ fipeModeloHistSync(function(mudou, ok){
            if(!document.body.classList.contains('hist-on')) return;
            _histNuvem = (ok===false) ? 'erro' : 'pronto';
            if(mudou){ abrirHistorico(); return; }
            pinta((($('histBusca')||{}).value)||'');
          }); }catch(_){ _histNuvem='erro'; pinta(termo); }
        };
        return;
      }
      /* VAZIO de verdade: a nuvem respondeu, e não há registro nenhum. */
      if(!total && !termo){
        var tools=$('histTools'); if(tools) tools.hidden=true;
        el.innerHTML='<div class="hh-vazio hist-vazio-pg">'
          +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>'
          +'<b>Nenhuma consulta recente</b>'
          +'<p>As consultas por placa ou por veículo realizadas nos últimos 30 dias aparecerão aqui.</p>'
          +'<button type="button" class="hh-vazio-bt" id="histIrPlaca">Consultar uma placa</button></div>';
        var ir=$('histIrPlaca'); if(ir) ir.onclick=function(){ voltarHome(); try{ var p=$('placa'); if(p){ p.scrollIntoView({ block:'center' }); p.focus(); } }catch(_){} };
        return;
      }
      /* v918 — DUAS peneiras onde havia quatro: a fonte e o que a pessoa
         digitou. Saíram o corte de 7 dias, a situação e a origem. */
      var lista=_fonte()
        .filter(function(x){ return _buscaOk(x,termo); })
        .sort(function(a,b){ return (b.ts||0)-(a.ts||0); });
      if(!lista.length){
        el.innerHTML='<div class="hh-vazio hist-vazio-pg"><b>Nenhuma consulta encontrada</b>'
          +'<p>Confira a placa ou o modelo pesquisado.</p>'
          +(termo?'<button type="button" class="hh-tentar" id="histLimparBusca">Limpar busca</button>':'')+'</div>';
        var lb=$('histLimparBusca'); if(lb) lb.onclick=function(){ var b=$('histBusca'); if(b) b.value=''; pinta(''); };
        return;
      }
      el._lista=lista;
      /* agrupamento por dia (§11): grupos do mais novo pro mais velho; dentro
         do dia, favoritos primeiro SEM sair do próprio dia (§11.3) */
      var grupos=[], porDia={};
      lista.forEach(function(x,i){ var k=x.ts?histData(x.ts):'-'; if(!porDia[k]){ porDia[k]={ label:_diaLabel(x.ts), itens:[] }; grupos.push(porDia[k]); } porDia[k].itens.push({ x:x, i:i }); });
      grupos.forEach(function(g){ g.itens.sort(function(a,b){ return ((b.x.fav?1:0)-(a.x.fav?1:0))||((b.x.ts||0)-(a.x.ts||0)); }); });
      el.innerHTML='<div class="hist-days">'+grupos.map(function(g){
        /* v885 — sai o "N consultas" do lado (§5) e o rótulo do dia vira um
           TÍTULO DE SEÇÃO de verdade (§10: "Hoje", "Ontem" e as datas devem ser
           títulos reais). Era um <b> dentro de um <div>: bonito e mudo — quem
           navega por cabeçalhos no leitor de tela não achava os dias.
           ⚠️ O `_diaLabel` continua sendo quem escreve o rótulo (§5): nenhum
           algoritmo de data novo. */
        return '<section class="hist-day" aria-label="'+esc(g.label)+'"><div class="hist-day-head"><h3>'+esc(g.label)+'</h3></div>'
          +g.itens.map(function(par){ return _cardHtml(par.x, par.i); }).join('')+'</section>';
      }).join('')+'</div>';
      /* 🔴 v766 (substitui a v395): o CORPO do card REABRE a consulta salva
         (sem custo); o menu de ações mora nos três pontinhos */
      function _abre(it){
        var x=el._lista[+it.getAttribute('data-i')]; if(!x) return;
        if(x.kind==='equipe'){ abrirEquipe(x._eq); return; }
        _histReabrir(x);
      }
      Array.prototype.forEach.call(el.querySelectorAll('.hist-item'),function(it){
        it.onclick=function(){ _abre(it); };
        it.onkeydown=function(e){ if(e.target!==it || (e.key!=='Enter' && e.key!==' ')) return; e.preventDefault(); _abre(it); };
      });
      Array.prototype.forEach.call(el.querySelectorAll('.hi-more'),function(b){
        b.onclick=function(e){ e.stopPropagation(); var x=el._lista[+b.getAttribute('data-i')]; if(x) histAcoesAbrir(x.placa, b, true); };
      });
    }
    _histPinta=pinta;   /* v386: os mapas (avaliação/situação) repintam a página quando chegam */
    pinta('');
    var bq=$('histBusca'); if(bq){ bq.oninput=function(){ pinta(this.value); }; }
  }
  /* abre uma placa consultada por um colega da equipe (só leitura da consulta) */
  function abrirEquipe(idx){
    var it=_equipeHist[idx]; if(!it){ return; }
    if(!it.v){ voltarHome(); $('placa').value=it.placa; $('placa').scrollIntoView({behavior:'smooth',block:'center'}); return; }
    veiculoAtual=it.v; histFonteTs=it.ts; fichaState=it.ficha||null; fichaTecState=it.fichaTec||null; leilaoState=it.leilao||null;
    var _pi2=$('placa'); if(_pi2) _pi2.value='';   /* campo de pesquisa fica LIMPO */
    abrirMenu();
  }
  /* histórico direto na tela inicial */
  /* mapa placa -> valor avaliado (pra mostrar no card quando o veículo já foi avaliado) */
  /* v1089 — o estado da nuvem NA TELA do histórico: 'carregando' | 'pronto'
     | 'erro'. Reiniciado pelo `abrirHistorico` a cada abertura. */
  var _histNuvem='pronto';
  var _avValores=null, _avValLoading=false;
  function _avPlacaKey(p){ return String(p||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  async function avValoresCarregar(force){
    if(_avValLoading) return; if(_avValores && !force) return;
    if(!meuId || !window.supa){ return; }
    _avValLoading=true;
    try{
      var mapa={};
      var r=await supa.from('avaliacoes').select('placa,payload,criado_em').eq('user_id',meuId).order('criado_em',{ascending:false});
      var rows=(r&&r.data)||[];
      rows.forEach(function(row){
        var pl=_avPlacaKey(row.placa); if(!pl || mapa[pl]!==undefined) return; /* mantém a avaliação mais recente */
        var v=row.payload && row.payload.avaliado;
        v=parseInt(String(v==null?'':v).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
        if(v>0) mapa[pl]=v;
      });
      _avValores=mapa;
      try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
      try{ if(_histPinta) _histPinta((($('histBusca')||{}).value)||''); }catch(_){}
    }catch(e){ if(!_avValores) _avValores={}; }
    _avValLoading=false;
  }
  /* ===== v350 — DE ONDE SAI A SITUAÇÃO DE CADA PLACA ======================
     Uma consulta só ao estoque e uma às vendas abertas, guardadas num mapa
     placa -> situação. Roda uma vez por sessão (igual ao mapa de avaliações
     aqui de cima) e, quando termina, manda repintar a lista.
     A RLS do banco já limita ao que é seu / da sua loja — por isso não
     preciso filtrar por user_id aqui. */
  var _estSit=null, _estSitLoading=false;
  /* v358: capa do veículo (1ª foto do estoque) por placa. Vem de carona na
     MESMA consulta que já buscava a situação — nenhuma requisição a mais. */
  var _estCapa=null;
  /* v378: placas com PROPOSTA ABERTA (venda não fechada). Fica num mapa
     separado do de situação justamente pra NÃO disputar lugar com ele —
     ver a explicação no bloco de comentário do _SIT_TAG. */
  var _estProp=null;
  async function estSituacaoCarregar(force){
    if(_estSitLoading) return; if(_estSit && !force) return;
    if(!meuId || !window.supa) return;
    _estSitLoading=true;
    try{
      var mapa={};
      var capas={};
      var r=await supa.from('estoque').select('placa,status,fotos');
      ((r&&r.data)||[]).forEach(function(row){
        var pl=_avPlacaKey(row.placa); if(!pl) return;
        var st=String(row.status||'disponivel');
        /* mesma placa cadastrada duas vezes: fica o estado mais adiantado */
        /* a capa não depende de qual cadastro "vence": vale a primeira foto
           que aparecer pra essa placa */
        try{ if(!capas[pl] && row.fotos && row.fotos.length) capas[pl]=String(row.fotos[0]||''); }catch(_){}
        if(mapa[pl]==='vendido') return;
        if(mapa[pl]==='reservado' && st!=='vendido') return;
        mapa[pl]=st;
      });
      /* v378 — VENDA ABERTA (mp_vendas com fechada=false) pra essa placa.
         ANTES ela virava a etiqueta "Negociando" e ESCONDIA o "No estoque".
         Era o pior dos dois mundos: o carro do pátio parecia carro de fora, e
         a palavra "negociando" nem dizia se era pra comprar ou pra vender.
         AGORA a proposta não mexe mais na situação de quem já está no
         estoque — vira só um segundo selinho ("Em proposta"). "Negociando"
         sobrou pro caso em que a placa NÃO está no seu estoque. */
      var props={};
      try{
        var rv=await supa.from('vendas').select('placa,fechada').eq('fechada',false);
        ((rv&&rv.data)||[]).forEach(function(row){
          var pl=_avPlacaKey(row.placa); if(!pl) return;
          props[pl]=1;
          if(!mapa[pl]) mapa[pl]='negociando';
        });
      }catch(_){ /* sem vendas, o resto continua valendo */ }
      /* v376 — FOTOS DA AVALIAÇÃO também viram miniatura.
         Elas ficam na doc_consulta com tipo 'aval_fotos', uma linha por placa,
         e a CAPA é sempre a PRIMEIRA da lista (é a que a aba Fotos marca e a
         que vai pra prévia do link no WhatsApp).
         O ESTOQUE tem prioridade: aqui só preenchemos a placa que ficou sem
         foto — por isso o `if(capas[pl]) return`. */
      try{
        var rf=await supa.from('doc_consulta').select('chave,resultado').eq('user_id',meuId).eq('tipo','aval_fotos');
        ((rf&&rf.data)||[]).forEach(function(row){
          var pl=_avPlacaKey(row.chave); if(!pl || capas[pl]) return;
          var d=row.resultado;
          if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(_){ d=null; } }
          var fs=(d&&d.fotos)||[];
          if(!fs.length) return;
          var u=(typeof fs[0]==='string')?fs[0]:(fs[0]&&fs[0].url);
          if(u) capas[pl]=String(u);
        });
      }catch(_){ /* sem as fotos da avaliação, as do estoque continuam valendo */ }
      _estSit=mapa; _estCapa=capas; _estProp=props;   /* v378 */
      try{ pintaHomeHist((($('homeHistBusca')||{}).value)||''); }catch(_){}
      try{ if(_histPinta) _histPinta((($('histBusca')||{}).value)||''); }catch(_){}
    }catch(e){ if(!_estSit) _estSit={}; if(!_estCapa) _estCapa={}; if(!_estProp) _estProp={}; }
    _estSitLoading=false;
  }

  /* ===== v595 (pedido 22/08): as placas recentes SAÍRAM da home ==========
     "remove as 3 placas que ficam na parte debaixo da tela, já tem um card
     de histórico". Escondido, NÃO apagado (padrão v437 do Funil): o motor
     inteiro fica de pé — a página Histórico usa as mesmas peças — e voltar
     é virar este interruptor. O scroll do 05d ("ver histórico") já se
     guarda sozinho: ele confere o display antes de rolar.

     ===== v619 (pedido 24/08): O INTERRUPTOR GANHOU ENDEREÇO ===============
     "No desktop, permita aparecer o histórico das últimas consultas de
     placa, apenas no desktop. No mobile, não. Aparece o histórico abaixo
     da consulta de placa."

     O pedido da v595 era DO CELULAR — as três placas empurravam o conteúdo
     numa tela estreita. O interruptor, porém, tinha desligado nos dois
     mundos. Agora ele liga, e quem decide ONDE aparece é o CSS:

         @media(max-width:899px) #homeHistCard{display:none !important}
         (styles.css, duas regras — a do 5781 e a do 6005)

     🔴 POR QUE `true` PURO E NÃO UM matchMedia AQUI: um matchMedia lido uma
     vez não acompanha o usuário redimensionando a janela, e viraria um
     SEGUNDO dono da mesma decisão. Um dono só: o CSS diz ONDE aparece
     (e o `!important` dele ganha do display:block que esta função escreve),
     o JS diz SE TEM O QUE MOSTRAR. */
  var HOME_HIST_VISIVEL=true;
  /* v619: teto de placas no cartão da HOME. Eram 30 — na home isso vira uma
     parede de cards. A lista completa continua na página Histórico, e a
     busca do próprio cartão aparece sozinha quando passa de 4. */
  var HOME_HIST_MAX=8;
  /* v730 — HOME EM DUAS COLUNAS (docs/PROJETO-2026-08-29-home-duas-colunas-
     cards-historico-v2.txt). No computador largo (≥1280px) o cartão vira a
     COLUNA DA DIREITA, ao lado dos cards, e a prévia cai pra 6. Quem decide
     a largura continua sendo o CSS: o JS marca os itens além do 6º com a
     classe `hh-extra` e o CSS os esconde só na faixa larga. Assim a regra
     "um dono só" (v619, logo acima) segue valendo — nada de matchMedia +
     resize aqui repintando a lista. */
  /* v734 (pedido do Angelo, com print: "mostre já o histórico completo"):
     na coluna da direita do computador largo a prévia de 6 SAIU — a lista
     inteira aparece ali, rolando com a página. O JS pinta TODAS as consultas
     e marca as que passam de HOME_HIST_MAX com `hh-alem`; o CSS esconde
     `hh-alem` em toda largura e mostra só na larga (mesmo desenho da v730:
     o CSS decide a largura, o JS não mede tela). HOME_HIST_LATERAL_MAX (6)
     deixou de existir.
     v737 (pedido, com print): "mostra as últimas dez e depois Ver histórico
     completo" — a coluna larga mostra HOME_HIST_LARGO_MAX (10); o que passa
     ganha `hh-alem-largo` e o CSS esconde só na faixa larga. */
  var HOME_HIST_LARGO_MAX=10;
  /* v730: a prévia lateral ganhou cabeçalho, contagem, estado vazio e a porta
     "Ver histórico completo". Os quatro moram no app.html; esta função só
     liga/desliga. */
  function _homeHistPecas(n, vazio){
    try{
      var ct=$('homeHistCount'); if(ct){ ct.textContent=String(n||''); ct.hidden=!(n>0); }
      var vz=$('homeHistVazio'); if(vz) vz.hidden=!vazio;
      var vr=$('homeHistVer');
      if(vr){
        vr.hidden=!!vazio;
        if(!vr._wired){ vr._wired=1; vr.onclick=function(){
          /* a PÁGINA completa, nunca "rolar até um painel que já está na tela".
             O renderer é o mesmo de sempre (abrirHistorico original, guardado
             pelo 05d em _ctHistPagina); se o embrulho não existir, o próprio
             abrirHistorico serve. */
          try{ if(typeof _ctHistPagina==='function'){ _ctHistPagina(); return; } }catch(_){}
          abrirHistorico();
        }; }
      }
      var sw=$('homeHistSearch'); if(sw && vazio) sw.style.display='none';
      /* v764 (§14.6): a porta do vazio — foca o campo da placa, que é a
         primeira consulta que a pessoa vai fazer. Nada de tela nova. */
      var ir=$('homeHistIrPlaca');
      if(ir && !ir._wired){ ir._wired=1; ir.onclick=function(){
        try{ var p=$('placa'); if(p){ p.scrollIntoView({ block:'center' }); p.focus(); } }catch(_){}
      }; }
    }catch(_){}
  }
  function pintaHomeHist(termo){
    var card=$('homeHistCard'), el=$('homeHistLista'); if(!el||!card) return;
    /* v776 — OS BLOCOS DA COLUNA DA DIREITA (05j-blocos-da-home.js).
       Uma linha só, e ela vem ANTES dos returns de estado vazio de propósito:
       o histórico pode não ter nada e as pendências terem. O bhMontar só cria
       os contêineres vazios (barato) e agenda a carga pra 250 ms — a home
       nunca espera por ele (lição da v738). Abaixo de 1280px ele volta na
       primeira linha, sem fazer consulta nenhuma. */
    try{ bhMontar(); }catch(_){ }
    if(!HOME_HIST_VISIVEL){ card.style.display='none'; return; }
    if(_avValores===null) avValoresCarregar();
    if(_estSit===null) estSituacaoCarregar();   /* v350 */
    /* v764: o gestor vê a alternância também ENQUANTO a equipe carrega (esqueleto)
       e quando a carga falhou (Tentar novamente) — antes, sem linhas, a aba sumia
       e os dois estados eram invisíveis. */
    var ehGestor=(meuPapel==='dono'||meuPapel==='gerente') && (_equipeHist.length>0 || _equipeCarga==='carregando' || _equipeCarga==='erro');
    if(!ehGestor && _histView==='equipe'){ _histView='minhas'; }
    var minhas=histLer().slice().sort(function(a,b){ return (b.ts||0)-(a.ts||0); });
    /* nada meu e nada da equipe => ESTADO VAZIO (v730). O cartão fica no DOM
       com a classe `hh-vazia`; o CSS o esconde em toda largura MENOS no
       computador largo, onde a coluna da direita sem nada deixaria um buraco.
       Sem chamada de API, sem botão falso: só o título e uma frase. Na
       primeira consulta o pintor roda de novo e a lista toma o lugar. */
    if(!minhas.length && !ehGestor){
      card.classList.add('hh-vazia'); card.style.display='block';
      el.innerHTML=''; _homeHistPecas(0, true); return;
    }
    card.classList.remove('hh-vazia');
    /* gestor sem placas próprias começa já mostrando as da equipe */
    if(!minhas.length && ehGestor){ _histView='equipe'; }
    var equipe=(_histView==='equipe');
    var todos=equipe ? _equipeHist.slice().sort(function(a,b){ return (b.ts||0)-(a.ts||0); }) : minhas;
    card.style.display='block';
    _homeHistPecas(todos.length, false);
    /* alterna Minhas / Da equipe (só aparece pra dono e gerente) */
    var toggle='';
    if(ehGestor){
      toggle='<div class="hh-toggle">'
        +'<button type="button" class="hh-tg'+(equipe?'':' on')+'" data-hv="minhas">Minhas</button>'
        +'<button type="button" class="hh-tg'+(equipe?' on':'')+'" data-hv="equipe">Da equipe</button></div>';
    }
    var sw=$('homeHistSearch'); if(sw) sw.style.display=todos.length>4?'block':'none';
    var hb=$('homeHistBusca'); if(hb && !hb._wired){ hb._wired=1; hb.oninput=function(){ pintaHomeHist(this.value); }; }
    termo=(termo||'').toUpperCase().replace(/\s+/g,' ').trim();
    var lista=todos.filter(function(x){ if(!termo) return true; return (String(x.placa||'').toUpperCase().indexOf(termo)>=0)||(String(x.modelo||'').toUpperCase().indexOf(termo)>=0); });
    var corpo;
    if(equipe && !todos.length && _equipeCarga==='carregando'){
      /* v764 (§14.7): esqueleto com a ESTRUTURA do card final — sem pulo de
         layout quando os cards chegam; a busca e a alternância ficam usáveis */
      corpo='<div class="hh-carregando" role="status" aria-label="Carregando as consultas da equipe">'
        +'<div class="hh-skel" aria-hidden="true"></div><div class="hh-skel" aria-hidden="true"></div>'
        +'<div class="hh-skel" aria-hidden="true"></div><div class="hh-skel" aria-hidden="true"></div></div>';
    } else if(equipe && !todos.length && _equipeCarga==='erro'){
      /* v764 (§14.8): mensagem objetiva + Tentar novamente (recarrega SÓ a
         equipe; se uma recarga falhar com dados antigos na tela, eles ficam
         — este ramo só existe com a lista vazia) */
      corpo='<div class="hh-erro" role="status"><p>Não deu para carregar as consultas da equipe.</p>'
        +'<button type="button" class="hh-tentar" id="hhTentar">Tentar novamente</button></div>';
    } else if(!lista.length){
      corpo='<div class="plc-msg" style="padding:8px 2px">'+(equipe?'A equipe ainda não salvou placas.':'Nada encontrado.')+'</div>';
    } else {
      var _diaAnt='';   /* v763: agrupamento por dia (só a faixa larga MOSTRA o rótulo — CSS) */
      corpo=lista.map(function(x,i){ var tag=histTag(x);   /* v619: era 30 · v734: sem corte — o CSS esconde o que passa de HOME_HIST_MAX fora da faixa larga */
        /* v763 (§9.5 do projeto): quando o DIA muda, entra um rótulo Hoje /
           Ontem / data por extenso antes do card. O rótulo herda as classes
           de corte do card que o segue (hh-alem-largo), pra nunca sobrar um
           título de dia sem registros embaixo. Fora da faixa larga o CSS
           esconde todos os .hh-dia — celular e tablet ficam como estavam. */
        var _sep='', _diaK=x.ts?histData(x.ts):'-';
        if(_diaK!==_diaAnt){ _diaAnt=_diaK; _sep='<div class="hh-dia'+(i>=HOME_HIST_LARGO_MAX?' hh-alem-largo':'')+'">'+esc(_hhDiaTxt(x.ts))+'</div>'; }
        var por=(equipe&&x.por)?('<span class="hi-por">'+esc(x.por)+'</span> · '):'';
        var tagHtml=tag?(' · <span class="hi-tag '+tag.c+'">'+tag.t+'</span>'):'';
        if(histProp(x)) tagHtml+=' <span class="hi-tag roxo">Em proposta</span>';   /* v378 */
        var _av=(_avValores&&_avValores[_avPlacaKey(x.placa)])||0;
        var avHtml=_av?('<div class="hi-aval">Avaliado <b>'+esc(brl(_av))+'</b></div>'):'';
        /* ano fabricação/modelo no card (ex.: 2023/2023) */
        var _af=(x.v&&(x.v.ano||''))||'', _am=(x.v&&(x.v.ano_modelo||''))||'';
        var anoTxt=(_af||_am)?((_af||_am)+'/'+(_am||_af)):'';
        var anoHtml=anoTxt?('<span class="hi-ano">'+esc(anoTxt)+'</span> · '):'';
        /* v407 (pedido): SEM a miniatura da foto no card — só a placa.
           Pra voltar: acrescentar histCapaHtml(x) depois do placaMercosul. */
        /* v730: role/tabindex/aria-label — a linha responde ao teclado (Enter e
           espaço, abaixo) e tem nome pro leitor de tela; `hh-alem` marca o
           que passa da prévia lateral (o CSS esconde só no computador largo). */
        return _sep+'<div class="hist-item'+(i>=HOME_HIST_MAX?' hh-alem':'')+(i>=HOME_HIST_LARGO_MAX?' hh-alem-largo':'')+'" data-placa="'+esc(x.placa)+'" data-idx="'+i+'" role="button" tabindex="0" aria-label="'+esc((x.modelo||'Veículo')+' '+x.placa)+'">'+
          '<div class="hi-mod">'+esc(x.modelo||'Veículo')+'</div>'+
          '<div class="hi-main"><span class="hi-plcol">'+placaMercosul(x.placa)+'</span>'+
          '<div class="hi-info">'+((x.v&&x.v.fipe)?('<div class="hi-fipe">'+esc(brl(x.v.fipe))+'</div>'):'')+avHtml+
          '<div class="hi-meta">'+anoHtml+por+esc(histData(x.ts))+tagHtml+'</div></div>'+
          '<span class="hi-go">'+CHEV+'</span></div></div>';
      }).join('');
    }
    el.innerHTML=toggle+corpo;
    /* v764: o Tentar novamente do erro da equipe — repinta já em "carregando"
       (o esqueleto entra na hora) e dispara a recarga de verdade */
    var _tn=$('hhTentar'); if(_tn) _tn.onclick=function(){ try{ carregarPapelEquipe(); }catch(_){} pintaHomeHist(''); };
    Array.prototype.forEach.call(el.querySelectorAll('.hh-tg'),function(b){ b.onclick=function(){ _histView=b.getAttribute('data-hv'); var s=$('homeHistBusca'); if(s) s.value=''; pintaHomeHist(''); }; });
    Array.prototype.forEach.call(el.querySelectorAll('.hist-item'),function(it){
      var placa=it.getAttribute('data-placa'), idx=+it.getAttribute('data-idx'), timer=null, longed=false;
      /* v730: Enter e espaço fazem o que o clique curto faz. O toque longo
         continua existindo, mas nunca foi (nem é) o único caminho. */
      it.onkeydown=function(e){ if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){ e.preventDefault(); it.click(); } };
      if(equipe){
        /* placas da equipe: só abrir a consulta (sem menu de ações, não é do gestor apagar) */
        it.onclick=function(){ abrirEquipe(idx); };
        return;
      }
      function start(e){ longed=false; timer=setTimeout(function(){ longed=true; try{ if(navigator.vibrate) navigator.vibrate(15); }catch(_){} histAcoesAbrir(placa, it); },480); }
      function cancel(){ if(timer){ clearTimeout(timer); timer=null; } }
      it.addEventListener('touchstart',start,{passive:true});
      it.addEventListener('touchend',cancel); it.addEventListener('touchmove',cancel); it.addEventListener('touchcancel',cancel);
      it.addEventListener('mousedown',start); it.addEventListener('mouseup',cancel); it.addEventListener('mouseleave',cancel);
      /* v406: com o histórico de volta na home (abaixo da placa), o clique
         abre o MESMO menu de ações da antiga página Histórico (v395) —
         "Abrir consulta" primeiro, depois avaliação, multas e leilão. */
      it.onclick=function(e){ if(longed){ longed=false; e.preventDefault(); e.stopPropagation(); return; } histAcoesAbrir(placa, it, true); };
    });
  }
  /* ---- Menu de ações do histórico (toque longo) ---- */
  function actSheetFechar(){ var bg=$('actSheet'); if(bg){ bg.classList.remove('on'); setTimeout(function(){ if(bg&&bg.parentNode) bg.parentNode.removeChild(bg); },200); } }
  /* popover de ações reutilizável (histórico, estoque, etc.) */
  /* v893 — `extraHtml` (5º, opcional): conteúdo livre DENTRO da mesma folha,
     depois dos itens. Nasceu pro "Nova avaliação", que precisa de um campo e
     de uma lista — coisas que não são item de menu. Quem chama com quatro
     argumentos, como sempre se chamou, não muda em nada. */
  function _popAbrir(headHtml, itens, anchorEl, onPick, extraHtml){
    actSheetFechar();
    var bg=document.createElement('div'); bg.className='act-bg'; bg.id='actSheet';
    bg.innerHTML='<div class="act-pop" id="actPop">'+headHtml+itens.map(function(a){
      return (a[4]?'<div class="act-section" role="heading" aria-level="3">'+a[4]+'</div>':'')+
        '<button type="button" class="act-item '+(a[3]||'')+'" data-k="'+a[0]+'">'+a[1]+
          (a[5]?'<span class="act-item-copy"><b>'+a[2]+'</b><small>'+a[5]+'</small></span>':'<span>'+a[2]+'</span>')+
        '</button>';
    }).join('')+(extraHtml||'')+'</div>';
    document.body.appendChild(bg);
    var pop=$('actPop'), vw=window.innerWidth, vh=window.innerHeight, pw=pop.offsetWidth, ph=pop.offsetHeight, m=12;
    var r=(anchorEl&&anchorEl.getBoundingClientRect)?anchorEl.getBoundingClientRect():null;
    var left, top, oy='top', ox=30;
    if(r){
      left=Math.min(Math.max(m, r.left), vw-pw-m);
      if(r.bottom+ph+10 <= vh-m){ top=r.bottom+8; oy='top'; }
      else if(r.top-ph-10 >= m){ top=r.top-ph-8; oy='bottom'; }
      else { top=Math.max(m, (vh-ph)/2); oy='top'; }
      ox=Math.max(24, Math.min(pw-24, (r.left+42)-left));
    } else { left=(vw-pw)/2; top=(vh-ph)/2; ox=pw/2; }
    pop.style.left=left+'px'; pop.style.top=top+'px';
    pop.style.transformOrigin=ox+'px '+(oy==='bottom'?'bottom':'top');
    bg.addEventListener('click',function(e){ if(e.target===bg){ actSheetFechar(); } });
    Array.prototype.forEach.call(bg.querySelectorAll('.act-item'),function(b){ b.onclick=function(){ onPick(b.getAttribute('data-k')); }; });
    requestAnimationFrame(function(){ bg.classList.add('on'); });
  }
  function _histItem(placa){ var it=histLer().filter(function(x){ return x.placa===placa; })[0]; if(!it && veiculoAtual && veiculoAtual.placa===placa){ it={ placa:placa, modelo:(((veiculoAtual.marca||'')+' '+(veiculoAtual.modelo||'')).trim())||'Veículo', ts:Date.now(), v:veiculoAtual, ficha:fichaState||null, leilao:leilaoState||null }; } return it||null; }
  /* `completo` liga a Consulta Plus no menu de ações do Histórico. No toque
     longo da inicial nada muda. */
  function _histAvaliaEstoqueDe(placa){
    placa=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    return (_estoque||[]).filter(function(v){ return String((v&&v.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===placa; })[0]||null;
  }
  function _histAvaliaRepasseDe(placa){
    placa=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    return (_repMeu||[]).filter(function(r){
      return String((r&&r.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===placa && r.ativo!==false && r.vendido!==true;
    })[0]||null;
  }
  async function _histAvaliaPodeEstoque(){
    try{
      if(typeof acGarantir==='function') await acGarantir();
      var loja=(typeof _lojaRec!=='undefined'&&_lojaRec)||null;
      if(!loja && typeof lojaGet==='function') loja=await lojaGet();
      if(!loja || !loja.id) return false;
      if(typeof _ehAdmin==='function' && _ehAdmin()) return true;
      return !!(typeof acPlanoAtual==='function' && acPlanoAtual()) &&
        (typeof acEstado!=='function' || acEstado('estoque')==='livre');
    }catch(_){ return false; }
  }
  function _histAvaliaCompartilharLink(url,titulo){
    if(!url){ toast('Não consegui montar o link deste veículo.'); return; }
    var dados={title:titulo||'Veículo',text:'Confira este veículo:',url:url};
    try{
      if(navigator.share){
        navigator.share(dados).catch(function(e){ if(!e || e.name!=='AbortError') toast('Não consegui compartilhar o link.'); });
        return;
      }
    }catch(_){ }
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).then(function(){ toast('Link copiado.'); },function(){ toast(url); });
        return;
      }
    }catch(_){ }
    toast(url);
  }
  async function histAcoesAbrir(placa, anchorEl, completo){
    var it=_histItem(placa); if(!it) return;
    actSheetFechar();
    var IC={
      abrir:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
      aval:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><polyline points="9 14 11 16 15 12"/></svg>',
      mr:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="11" x2="12" y2="15"/><line x1="12" y1="17.5" x2="12.01" y2="17.5"/></svg>',
      lh:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
      nova:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      vinc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>',
      est:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><line x1="12" y1="12" x2="12" y2="17"/><line x1="9.5" y1="14.5" x2="14.5" y2="14.5"/></svg>',
      print:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>',
      atu:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>',
      del:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
      comp:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>',
      pdf:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/></svg>',
      foto:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
      catalogo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
      share:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
      repasse:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M8 13h8"/></svg>'
    };
    /* v241: saiu "Consulta multa/restrições" (a tela já tem o cartão pago) e
       saiu "Gerar print" (virou o fab verde de download na tela do veículo). */
    /* v364 (pedido): "Fotos" abre a avaliação daquela placa já na aba Fotos —
       onde você vê, anexa, exclui, escolhe a capa e pega o link pra mandar. */
    /* 🔴 v890 — "AVALIAÇÃO" NO MENU (pedido do Angelo, 04/09). O item já
       existia: `aval`, com ícone e despacho prontos — mas só entrava quando
       `completo` era verdadeiro, e no menu do card da placa não é. Em vez de
       inventar uma ação nova, ele desceu pra lista de sempre.
       ⚠️ HOJE ELE CAI NO MESMO LUGAR QUE "Nova cotação": as duas chamam
       `abrirAvaliacaoLojista()`. Está anotado de propósito — se a intenção
       for "abrir a que existe" contra "começar outra", quem separa é o
       despacho lá embaixo, não o rótulo. */
    /* v1145 — o PDF simples saiu desta folha. O resultado da FIPE continua
       oferecendo o PDF próprio, completo e contextualizado; repetir aqui um
       segundo PDF com menos informações deixava a escolha ambígua. */
    var itens=[['aval',IC.aval,'Avaliação',''],['nova',IC.nova,'Nova cotação',''],['fotos',IC.foto,'Fotos',''],['vincular',IC.vinc,'Vincular cliente',''],['estoque',IC.est,'Adicionar ao estoque',''],['atualizar',IC.atu,'Atualizar pesquisa',''],['excluir',IC.del,'Excluir','danger']];
    /* v941 — no MEV Avaliações esta folha deixou de repetir caminhos que já
       estão na própria avaliação. Ela vira uma lista curta de ações sobre o
       veículo. Estoque só aparece para conta com loja e plano elegível; se o
       carro já estiver cadastrado, entram a página pública e o compartilhar
       nativo. O portal só aparece quando há publicação ativa da mesma placa. */
    var _soAvalia=false; try{ _soAvalia=window.edicaoAtual&&window.edicaoAtual()==='avalia'; }catch(_){ }
    if(_soAvalia){
      var _podeEst=await _histAvaliaPodeEstoque();
      if(_podeEst && typeof estCarregar==='function' && !(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} }
      if(typeof repPortalCarregar==='function' && !(_repMeu||[]).length){ try{ await repPortalCarregar(); }catch(_){} }
      var _ev=_histAvaliaEstoqueDe(placa), _rp=_histAvaliaRepasseDe(placa);
      itens=[];
      /* v981 — a consulta já tem o retrato do veículo; começar a avaliação
         daqui reaproveita esse retrato e não pede a placa nem faz uma nova
         consulta. O rascunho continua sendo restaurado pela própria tela de
         avaliação quando esta placa já tiver trabalho salvo. */
      itens.push(['iniciar_avaliacao',IC.aval,'Iniciar avaliação','']);
      if(_podeEst && !_ev) itens.push(['estoque_avalia',IC.est,'Adicionar ao estoque','']);
      if(_podeEst && _ev){
        itens.push(['catalogo_ver',IC.catalogo,'Ver no catálogo','']);
        itens.push(['catalogo_compartilhar',IC.share,'Compartilhar link do catálogo','']);
      }
      if(_rp) itens.push(['repasse_ver',IC.repasse,'Ver no portal do repasse','']);
      itens.push(['atualizar',IC.atu,'Atualizar consulta','']);
      itens.push(['excluir',IC.del,'Excluir','danger']);
    }
    /* 🔴 v918 — O MENU DE TRÊS PONTOS OBEDECE À EDIÇÃO
       (PROJETO "MEV Consultas sem links para outros aplicativos", §4)
       Cinco dos oito itens levam pra FORA do MEV Consultas: Avaliação, Nova
       cotação e Fotos abrem a avaliação; Vincular cliente é CRM; Adicionar ao
       estoque é o Estoque. Num app de consulta eles não são atalho, são
       porta pra uma sala que o cliente não comprou.
       ✅ Ficam sempre: Abrir consulta, Atualizar pesquisa e Excluir — as três
       ações diretas sobre uma CONSULTA. O PDF simples saiu na v1145.
       ⚠️ Filtrado pelo mesmo mapa de páginas das outras telas, então no MEV
       Completo o menu continua com os oito, e no MEV Estoque continua com o
       "Adicionar ao estoque". */
    var _ACAO_DO_ITEM={ aval:'avaliacoes', iniciar_avaliacao:'avaliacoes', nova:'avaliacoes', fotos:'avaliacoes', vincular:'vincular', estoque:'estoque' };
    itens=itens.filter(function(it){
      var ac=_ACAO_DO_ITEM[it[0]]; if(!ac) return true;
      try{ return (typeof window.edPode!=='function') || window.edPode(ac); }catch(_){ return true; }
    });
    /* v761: a ação "Consulta Plus" saiu do menu (a Plus foi eliminada do app; o handler 'plus' fica pra link antigo) */
    /* v890 — o `aval` saiu daqui porque agora mora na lista de sempre; na
       versão completa continua só o "Abrir consulta" na frente. */
    if(completo) itens=[['abrir',IC.abrir,'Abrir consulta','']].concat(itens);
    _popAbrir('<div class="act-head"><div class="ah-nm">'+esc(it.modelo||'Veículo')+'</div><div class="ah-pl">'+esc(it.placa||'')+'</div></div>', itens, anchorEl, function(k){ histAcaoExec(placa, k); });
  }
  async function histAcaoExec(placa, key){
    var it=_histItem(placa); if(!it) return;
    actSheetFechar();
    /* v918 — a mesma trava do menu, agora na EXECUÇÃO. O menu é montado
       filtrado; isto aqui é o que garante que nenhum outro caminho (um link
       antigo, um atalho de teclado, uma chamada direta) atravesse. */
    try{
      var _ac2={ aval:'avaliacoes', iniciar_avaliacao:'avaliacoes', nova:'avaliacoes', fotos:'avaliacoes', vincular:'vincular', estoque:'estoque', plus:'plus' }[key];
      if(_ac2 && typeof window.edPode==='function' && !window.edPode(_ac2)) return;
    }catch(_){}
    if(key==='abrir'){ abrirSalva(placa); return; }   /* v395: o mesmo do clique antigo no card */
    if(key==='excluir'){ if(confirm('Apagar a consulta da placa '+placa+'?')){ histExcluirPlaca(placa, function(){ if($('histLista')){ abrirHistorico(); } else { pintaHomeHist((($('homeHistBusca')||{}).value)||''); } }); } return; }
    if(key==='atualizar'){ voltarHome(); var pi=$('placa'); if(pi) pi.value=placa; buscarPlaca(true); return; }   /* v1372: o cartão de andamento já confirma a atualização; sem toast duplicado. v712: "Atualizar" força — sem o true, o atalho do histórico devolveria a salva */
    if(key==='catalogo_ver'){
      var _cv=_histAvaliaEstoqueDe(placa); if(!_cv){ toast('Este veículo ainda não está no estoque.'); return; }
      estAbrirNoCatalogo(_cv); return;
    }
    if(key==='catalogo_compartilhar'){
      var _cc=_histAvaliaEstoqueDe(placa), _cu='';
      if(!_cc){ toast('Este veículo ainda não está no estoque.'); return; }
      try{ _cu=_publicoVeiculoUrl(_cc); }catch(_){}
      _histAvaliaCompartilharLink(_cu,(((_cc.marca||'')+' '+(_cc.modelo||'')).trim()||'Veículo')); return;
    }
    if(key==='repasse_ver'){
      var _pr=_histAvaliaRepasseDe(placa); if(!_pr||!_pr.id){ toast('Este veículo não está publicado no portal do repasse.'); return; }
      var _pu=location.origin+'/r/'+encodeURIComponent(String(_pr.id));
      try{ _publicoAbrir(_pu,{titulo:'Veículo no portal do repasse',voltar:'Voltar às avaliações'}); }catch(_){ try{ window.open(_pu,'_blank','noopener'); }catch(__){} }
      return;
    }
    if(key==='print'){ if(!it.v){ toast('Consulte a placa primeiro.'); return; } histPrint(it); return; }
    if(key==='pdf'){ if(!it.v){ toast('Consulte a placa primeiro.'); return; } pdfConsultaSimples(it); return; }
    if(!it.v){ toast('Consulte a placa primeiro.'); return; }
    veiculoAtual=it.v; histFonteTs=it.ts; fichaState=it.ficha||null; fichaTecState=it.fichaTec||null; leilaoState=it.leilao||null; var p2=$('placa'); if(p2) p2.value='';
    if(key==='plus'){ abrirConsultaPlus(); return; }
    if(key==='iniciar_avaliacao'){ abrirAvaliacaoLojista(); return; }
    if(key==='aval'){ abrirAvaliacaoLojista(); return; }
    if(key==='nova'){ abrirAvaliacaoLojista(); return; }
    if(key==='fotos'){ abrirAvaliacaoLojista('fotos'); return; }
    if(key==='vincular'){ vincularClienteAbrir(); return; }
    if(key==='estoque'){ estFromConsulta(); return; }
    if(key==='estoque_avalia'){
      if(!(await _histAvaliaPodeEstoque())){ toast('Adicionar ao estoque está disponível para assinantes com loja cadastrada.'); return; }
      estFromConsulta(); return;
    }
  }
  function _rr(g,x,y,w,h,r){ g.beginPath(); g.moveTo(x+r,y); g.arcTo(x+w,y,x+w,y+h,r); g.arcTo(x+w,y+h,x,y+h,r); g.arcTo(x,y+h,x,y,r); g.arcTo(x,y,x+w,y,r); g.closePath(); }
  /* 🔴 v896 — histPrint ganhou um MODO (pedido do Angelo, 04/09):
     "abaixo do baixar pdf, adicione um baixar print (salva na galeria) e um
      compartilhar print (abre a funcao nativa)".
     Sem modo, tudo continua como sempre: abre o visor com a prévia e os dois
     botões. Com 'baixar' ou 'compartilhar', o print é gerado e a ação dispara
     DIRETO, sem prévia — que é o que dois botões separados prometem.
     ⚠️ A imagem é a MESMA nos três caminhos: um canvas só, desenhado uma vez.
     Duas rotas desenhando o mesmo print é como elas passam a divergir. */
  /* ==========================================================================
     v918 — O ITEM DE PRINT DA CONSULTA QUE ESTÁ NA TELA
     --------------------------------------------------------------------------
     Nasceu dentro do 02 (v896) como `_itemPrint`, fechado na tela da placa.
     Com o "Compartilhar print" mudando de casa pro visor do PDF da FIPE, dois
     lugares precisavam da MESMA montagem — e duas cópias da mesma regra é
     como o print da tela e o print do visor um dia sairiam diferentes.

     🔑 A FONTE PREFERIDA É O HISTÓRICO (a mesma do FAB da impressora, no
     19-documentos-e-init.js): é lá que mora a consulta completa. Se a placa
     ainda não chegou no histórico, monta do `veiculoAtual` em vez de falhar
     calado — que era a regra da v896 e continua sendo. */
  function histItemDaConsulta(v){
    if(!v) return null;
    var it=null; try{ it=_histItem(v.placa); }catch(_){}
    if(!it) it={ placa:v.placa, modelo:((v.marca||'')+' '+(v.modelo||'')).trim(), v:v,
                 ts:(typeof histFonteTs!=='undefined'?histFonteTs:0)||0 };
    if(!it.v) it.v=v;
    return it;
  }
  function histShareMensagemBase(placa,modelo,ano,cor,combustivel,fipe,ref){
    return [
      '*Consulta veicular*',
      '*'+String(placa||'').toUpperCase()+'*',
      modelo,
      '',
      ano?('Ano/modelo: '+ano):'',
      cor?('Cor: '+cor):'',
      combustivel?('Combustível: '+combustivel):'',
      '',
      '*Valor FIPE: '+fipe+'*',
      ref&&ref!=='—'?('Referência: '+ref):''
    ].join('\n').replace(/\n{3,}/g,'\n\n').trim();
  }
  /* v1478 — print e PDF passam pela mesma porta antes de chegar ao WhatsApp.
     Assim placa, veículo, FIPE, referência e campos vazios nunca divergem
     conforme o tipo de arquivo que a pessoa escolheu compartilhar. */
  function histShareMensagemVeiculo(v,it){
    v=v||{}; it=it||{};
    function util(x){ x=String(x==null?'':x).trim(); if(!x||x==='—'||x==='-'||/^desconhecid/i.test(x)||/^n[aã]o informad/i.test(x)) return ''; return x; }
    var placa=v.placa||it.placa||'';
    var modelo=((v.marca||'')+' '+(v.modelo||'')).trim()||it.modelo||'';
    var af=v.ano||'', am=v.ano_modelo||'', ano=af?(af+'/'+(am||af)):(am||'');
    var fipe=(v.fipe!=null&&Number(v.fipe)>0)?brl(v.fipe):'Não informado';
    return histShareMensagemBase(placa,modelo,ano,util(v.cor),util(v.combustivel),fipe,util(v.mes_ref)||'—');
  }
  function mevConsultasAssinatura(){
    return 'MEV Consultas\nhttps://mevveiculos.com.br/consultas';
  }
  /* v1487 — o destinatário do print/PDF consegue continuar a análise da
     mesma placa na consulta correta. `?consulta=&p=` é deliberado: diferente
     do parâmetro histórico `?placa=`, ele apenas abre o produto e preenche o
     campo; nunca executa nem cobra uma consulta sem novo toque. */
  function mevConsultaEspecialJudicialChamada(placa){
    var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);
    if(!/^[A-Z]{3}[A-Z0-9][A-Z0-9][0-9]{2}$/.test(p)) return '';
    var u=new URL('https://mevveiculos.com.br/consultas');
    u.searchParams.set('consulta','especialjud');
    u.searchParams.set('p',p);
    u.searchParams.set('de','fipe');
    return '*Quer saber se há sinistro, leilão ou bloqueio judicial?*\n'
      +'Consulte em *Leilão Especial + Judicial*:\n'+u.toString();
  }
  function histShareObservacoesLista(texto){
    return String(texto||'').split(/(?:\r?\n|[,;])+/).map(function(item){
      return item.trim();
    }).filter(Boolean).map(function(item){
      return '• '+item;
    }).join('\n');
  }
  function histShareMensagemCompleta(base,detalhes){
    detalhes=detalhes||{};
    var placa=String(detalhes.placa||'');
    if(!placa){
      var pm=String(base||'').match(/\n\*([A-Z0-9]{7})\*\n/i);
      placa=pm?pm[1]:'';
    }
    var observacoes=histShareObservacoesLista(detalhes.observacoes);
    var extras=[
      detalhes.quilometragem?('*Quilometragem: '+detalhes.quilometragem+'*'):'',
      observacoes?('*Observações*\n'+observacoes):'',
      detalhes.gastosPrevistos?('*Gastos previstos: '+detalhes.gastosPrevistos+'*'):'',
      detalhes.gastosDescricao?('Descrição: '+detalhes.gastosDescricao):''
    ].filter(Boolean);
    /* O domínio fica sempre no fim da mensagem: além de preservar a leitura
       dos dados complementares, o WhatsApp mantém o link longe do meio do
       conteúdo e o destinatário encontra a ação no encerramento. */
    return [
      String(base||'').trim(),
      extras.length?('*Informações do veículo*\n'+extras.join('\n')):'',
      mevConsultasAssinatura(),
      mevConsultaEspecialJudicialChamada(placa)
    ].filter(Boolean).join('\n\n');
  }
  function histPrint(it, modo){
    /* v1407 — cartão 4:5 pensado para compartilhamento no celular. A placa
       Mercosul, o veículo e a FIPE formam a hierarquia; os dados técnicos
       ficam em blocos curtos, sem aparência de formulário ou relatório. */
    var v=it.v||{}; var W=1080, H=1350, pad=64;
    function util(x){ x=String(x==null?'':x).trim(); if(!x||x==='—'||x==='-'||/^desconhecid/i.test(x)||/^n[aã]o informad/i.test(x)) return ''; return x; }
    var placaTxt=v.placa||it.placa||'';
    var modeloTxt=((v.marca||'')+' '+(v.modelo||'')).trim()||it.modelo||'';
    var _af=v.ano||'', _am=v.ano_modelo||'';
    var anoTxt=_af?(_af+'/'+(_am||_af)):(_am||'');
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H; var g=cv.getContext('2d');
    function fonte(peso,tam,mono){ g.font=peso+' '+tam+'px '+(mono?'ui-monospace,Menlo,Consolas,monospace':'system-ui,-apple-system,Arial'); }
    function cabe(txt,x,y,cor){ g.fillStyle=cor; g.textAlign='left'; g.fillText(String(txt||''),x,y); }
    function ajusta(txt,peso,tam,min,maxW,mono){ txt=String(txt||''); do{ fonte(peso,tam,mono); if(g.measureText(txt).width<=maxW||tam<=min) break; tam-=2; }while(tam>min); return tam; }
    function linhas(txt,maxW,max){
      var out=[], atual=''; String(txt||'').split(/\s+/).forEach(function(p){ if(!p) return; var t=atual?(atual+' '+p):p; if(g.measureText(t).width>maxW&&atual){ out.push(atual); atual=p; } else atual=t; });
      if(atual) out.push(atual); if(!out.length) out=['Veículo consultado'];
      if(out.length>max){ out=out.slice(0,max); var u=out.length-1; while(g.measureText(out[u]+'…').width>maxW&&out[u].length>3) out[u]=out[u].slice(0,-1); out[u]+='…'; }
      return out;
    }
    function dado(x,y,w,rotulo,valor){
      g.fillStyle='#f8fafc'; _rr(g,x,y,w,116,20); g.fill();
      g.strokeStyle='#e3eaf4'; g.lineWidth=2; _rr(g,x,y,w,116,20); g.stroke();
      fonte('700',20,false); cabe(rotulo.toUpperCase(),x+24,y+36,'#64748b');
      var vt=util(valor)||'—', tam=ajusta(vt,'800',30,22,w-48,false); fonte('800',tam,false); cabe(vt,x+24,y+82,'#0f2b57');
    }
    /* fundo e hero da marca */
    g.fillStyle='#edf4ff'; g.fillRect(0,0,W,H);
    var gr=g.createLinearGradient(0,0,W,300); gr.addColorStop(0,'#001e50'); gr.addColorStop(1,'#0a4da6');
    g.fillStyle=gr; g.fillRect(0,0,W,330);
    g.save(); g.globalAlpha=.16; g.fillStyle='#58a6ff'; g.beginPath(); g.arc(1010,30,300,0,Math.PI*2); g.fill(); g.globalAlpha=.10; g.beginPath(); g.arc(950,70,190,0,Math.PI*2); g.fill(); g.restore();
    /* símbolo de busca documental, desenhado em linha como o ícone oficial */
    g.save(); g.shadowColor='rgba(0,12,40,.28)'; g.shadowBlur=20; g.shadowOffsetY=9;
    g.fillStyle='rgba(255,255,255,.12)'; _rr(g,pad,40,82,82,22); g.fill(); g.restore();
    g.strokeStyle='#b8d8ff'; g.lineWidth=4; _rr(g,pad,40,82,82,22); g.stroke();
    g.strokeStyle='#ffffff'; g.lineWidth=4; g.beginPath(); g.arc(pad+39,78,16,0,Math.PI*2); g.moveTo(pad+51,90); g.lineTo(pad+65,104); g.stroke();
    g.lineWidth=3; g.beginPath(); g.moveTo(pad+29,78); g.lineTo(pad+49,78); g.stroke();
    fonte('850',40,false); cabe('MEV Consultas',pad+108,91,'#ffffff');
    fonte('800',21,false); cabe('CONSULTA VEICULAR',pad,171,'#91bfff');
    fonte('650',29,false); cabe('Dados do veículo e valor FIPE',pad,215,'#d7e4f4');
    /* cartão principal elevado */
    var cardX=44, cardY=248, cardW=W-88, cardH=1034;
    g.save(); g.shadowColor='rgba(0,30,80,.16)'; g.shadowBlur=28; g.shadowOffsetY=12; g.fillStyle='#ffffff'; _rr(g,cardX,cardY,cardW,cardH,34); g.fill(); g.restore();
    /* v1413 — o formato é decidido primeiro pelos caracteres:
       ABC1D23 = Mercosul; ABC1234 = placa antiga. Antes, toda placa sem uma
       marca especial caía no desenho Mercosul, então MGY7975 recebia uma
       tarja impossível. A fonte continua distinguindo experiência/fabricante
       para o rótulo, mas não pode transformar placa antiga em Mercosul. */
    var pt=String(placaTxt||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    var placaMercosul=/^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(pt);
    var placaAntiga=/^[A-Z]{3}[0-9]{4}$/.test(pt);
    var tipoPlaca=[v.tipo_placa,v.tipoPlaca,v.placa_tipo,v.cor_placa,v.corPlaca,v.placa_cor,v.categoria_placa,it.placa_tipo,it.placa_cor].filter(Boolean).join(' ').toLowerCase();
    var placaEspecial=v.placa_verde===true||it.placa_verde===true||/(verde|experi[eê]ncia|fabricante|montadora)/i.test(tipoPlaca);
    var placaRotulo=placaMercosul?'M E R C O S U L':(placaEspecial?'E X P E R I Ê N C I A':'B R A S I L');
    /* placa Mercosul, antiga cinza/prata ou especial verde */
    var px=80, py=292, pw=920, ph=184;
    g.save(); _rr(g,px,py,pw,ph,24); g.clip();
    if(placaEspecial){
      var vg=g.createLinearGradient(px,py,px+pw,py+ph); vg.addColorStop(0,'#08713e'); vg.addColorStop(1,'#159447'); g.fillStyle=vg; g.fillRect(px,py,pw,ph);
      g.fillStyle='rgba(255,255,255,.13)'; g.fillRect(px,py,pw,48);
    }else if(placaAntiga){
      g.fillStyle='#e8eaed'; g.fillRect(px,py,pw,ph);
      var ag=g.createLinearGradient(px,py,px+pw,py); ag.addColorStop(0,'#4b5563'); ag.addColorStop(1,'#6b7280'); g.fillStyle=ag; g.fillRect(px,py,pw,50);
    }else{
      g.fillStyle='#ffffff'; g.fillRect(px,py,pw,ph);
      var pg=g.createLinearGradient(px,py,px+pw,py); pg.addColorStop(0,'#075fc2'); pg.addColorStop(1,'#0b7ce8'); g.fillStyle=pg; g.fillRect(px,py,pw,50);
    }
    g.restore();
    g.strokeStyle=placaEspecial?'#d5f5df':(placaAntiga?'#3a3f47':'#8eb9ec'); g.lineWidth=4; _rr(g,px,py,pw,ph,24); g.stroke();
    fonte('800',24,false); g.textAlign='center'; g.fillStyle='#ffffff'; g.fillText(placaRotulo,W/2,py+34);
    if(placaMercosul){ var fx=px+pw-64, fy=py+12; g.fillStyle='#159447'; _rr(g,fx,fy,38,25,4); g.fill(); g.fillStyle='#f4c542'; g.beginPath(); g.moveTo(fx+19,fy+4); g.lineTo(fx+34,fy+12.5); g.lineTo(fx+19,fy+21); g.lineTo(fx+4,fy+12.5); g.closePath(); g.fill(); }
    if(placaAntiga) pt=pt.slice(0,3)+'-'+pt.slice(3);
    var psz=ajusta(pt,'850',76,60,pw-100,true); fonte('850',psz,true); g.fillStyle=placaEspecial?'#ffffff':(placaAntiga?'#111827':'#001e50'); g.textAlign='center'; g.fillText(pt,W/2,py+139); g.textAlign='left';
    /* identificação do veículo */
    fonte('800',20,false); cabe('VEÍCULO',80,526,'#0a4da6');
    fonte('800',36,false); var ml=linhas(modeloTxt,920,2); ml.forEach(function(t,i){ cabe(t,80,574+i*43,'#0f172a'); });
    /* dados essenciais, agrupados em quatro blocos */
    dado(80,666,440,'Ano/modelo',anoTxt);
    dado(560,666,440,'Cor',v.cor);
    dado(80,802,440,'Combustível',v.combustivel);
    dado(560,802,440,'Código FIPE',v.codigo_fipe);
    g.fillStyle='#f8fafc'; _rr(g,80,938,920,88,20); g.fill(); g.strokeStyle='#e3eaf4'; g.lineWidth=2; _rr(g,80,938,920,88,20); g.stroke();
    fonte('700',20,false); cabe('REFERÊNCIA FIPE',104,975,'#64748b'); var ref=util(v.mes_ref)||'—'; var rsz=ajusta(ref,'800',28,22,480,false); fonte('800',rsz,false); g.textAlign='right'; g.fillStyle='#0f2b57'; g.fillText(ref,976,988); g.textAlign='left';
    /* conclusão: o valor que orienta a negociação */
    var fyb=1054; g.fillStyle='#effaf3'; _rr(g,80,fyb,920,150,24); g.fill(); g.strokeStyle='#bfe8cc'; g.lineWidth=2; _rr(g,80,fyb,920,150,24); g.stroke();
    fonte('800',22,false); cabe('VALOR FIPE',108,1102,'#15803d');
    var fipeTxt=(v.fipe!=null&&Number(v.fipe)>0)?brl(v.fipe):'Não informado'; var fsz=ajusta(fipeTxt,'900',64,42,560,false); fonte('900',fsz,false); g.textAlign='right'; g.fillStyle='#15803d'; g.fillText(fipeTxt,972,1146); g.textAlign='left';
    fonte('600',20,false); cabe('Fonte: Tabela FIPE',80,1245,'#64748b'); g.textAlign='right'; g.fillStyle='#64748b'; g.fillText('Gerado em '+histData(Date.now()),1000,1245); g.textAlign='left';
    fonte('800',23,false); g.fillStyle='#0a4da6'; g.textAlign='center'; g.fillText('mevveiculos.com.br',W/2,1324); g.textAlign='left';
    /* v1408 — a imagem continua sendo a peça principal, mas o WhatsApp
       também recebe um resumo legível para quem prefere conferir na mensagem. */
    /* v1446 — o WhatsApp precisa de hierarquia, não de uma coluna contínua
       de rótulos. Título, identificação, FIPE e fonte formam blocos curtos. */
    cv.__mevShareText=histShareMensagemVeiculo(v,it);
    cv.__mevShareVehicle=clonar(v); cv.__mevShareModel=modeloTxt;
    var placa=placaTxt||'placa', url;
    try{ url=cv.toDataURL('image/png'); }catch(e){ toast('Não consegui gerar o print.'); return; }
    histPrintVisor(url, cv, placa, modo);
  }
  /* v1427/v1442 — antes do compartilhamento do print, Consultas e Avaliações
     oferecem dados úteis para a conversa comercial. Quilometragem, observações
     e gastos previstos ficam
     vinculadas ao veículo no histórico privado da conta; fotos continuam fora
     do MEV e são anexadas diretamente no aplicativo escolhido. */
  function histShareDetalhesLerDados(placa){
    try{
      var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      var r=histLerUm(p), v=(r&&r.v)||{};
      return {km:Number(v.quilometragem_compartilhamento)||0,obs:String(v.observacoes_compartilhamento||'').slice(0,4000),
        gastosTotal:Math.max(0,Number(v.gastos_previstos_compartilhamento)||0),
        gastosDescricao:String(v.descricao_gastos_compartilhamento||'').slice(0,1000)};
    }catch(_){ return {}; }
  }
  function histShareValorNumero(valor){
    var s=String(valor==null?'':valor).trim().replace(/R\$/gi,'').replace(/\s/g,'');
    if(!s) return 0;
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if(/^\d{1,3}(?:\.\d{3})+$/.test(s)) s=s.replace(/\./g,'');
    s=s.replace(/[^\d.-]/g,'');
    var n=Number(s); return isFinite(n)?Math.max(0,Math.round(n*100)/100):0;
  }
  function histShareValorTexto(valor){
    var n=histShareValorNumero(valor); return n?n.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}):'';
  }
  function histShareDetalhesGravarDados(placa,km,obs,gastosTotal,gastosDescricao,origem,subir){
    try{
      var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''), dig=String(km||'').replace(/\D/g,'').slice(0,9);
      var tx=String(obs||'').trim().replace(/[ \t]+/g,' ').replace(/\n{3,}/g,'\n\n').slice(0,4000);
      var gt=histShareValorNumero(gastosTotal), gd=gt?String(gastosDescricao||'').trim().replace(/[ \t]+/g,' ').replace(/\n{3,}/g,'\n\n').slice(0,1000):'';
      var lista=histLer(), achou=false, mudou=false;
      if(!lista.some(function(item){ return String(item&&item.placa||'').toUpperCase()===p; })&&origem&&(dig||tx||gt||subir)){
        var vv=origem.__mevShareVehicle||origem, mm=origem.__mevShareModel||[vv.marca,vv.modelo].filter(Boolean).join(' ');
        lista.unshift({placa:p,modelo:mm||'',ts:Date.now(),v:clonar(vv)}); mudou=true;
      }
      lista.forEach(function(item){
        if(String(item&&item.placa||'').toUpperCase()!==p) return;
        achou=true; item.v=clonar(item.v||{});
        var antesKm=Number(item.v.quilometragem_compartilhamento)||0, novoKm=dig?Number(dig):0;
        var antesObs=String(item.v.observacoes_compartilhamento||'');
        var antesGt=Number(item.v.gastos_previstos_compartilhamento)||0, antesGd=String(item.v.descricao_gastos_compartilhamento||'');
        if(novoKm) item.v.quilometragem_compartilhamento=novoKm; else delete item.v.quilometragem_compartilhamento;
        if(tx) item.v.observacoes_compartilhamento=tx; else delete item.v.observacoes_compartilhamento;
        if(gt) item.v.gastos_previstos_compartilhamento=gt; else delete item.v.gastos_previstos_compartilhamento;
        if(gd) item.v.descricao_gastos_compartilhamento=gd; else delete item.v.descricao_gastos_compartilhamento;
        if(antesKm!==novoKm||antesObs!==tx||antesGt!==gt||antesGd!==gd) mudou=true;
      });
      if(achou&&mudou){ histGrava(lista); if(subir) histPushOne(p); }
      return {quilometragem:dig?(Number(dig).toLocaleString('pt-BR')+' km'):'',observacoes:tx,
        gastosPrevistos:histShareValorTexto(gt),gastosDescricao:gd};
    }catch(_){ return {quilometragem:'',observacoes:'',gastosPrevistos:'',gastosDescricao:''}; }
  }
  function histShareDetalhesPedir(placa, continuar, origem, opcoes){
    if(typeof continuar!=='function') return;
    try{ var edShare=edicaoAtual(); if(edShare!=='consultas'&&edShare!=='avalia'){ continuar({}); return; } }catch(_){ continuar({}); return; }
    opcoes=opcoes||{};
    var paraPdf=opcoes.modo==='pdf';
    var kicker=paraPdf?'ANTES DE GERAR O PDF':'ANTES DE COMPARTILHAR';
    var ajuda=paraPdf?'Adicione informações que devem aparecer no PDF da consulta ':'Adicione informações úteis à mensagem da consulta ';
    var acao=paraPdf?'Gerar PDF':'Continuar para compartilhar';
    var cancelarAria=paraPdf?'Cancelar geração do PDF':'Cancelar compartilhamento';
    var anterior=$('histShareDetalhes'); if(anterior) anterior.remove();
    var foco=document.activeElement, placaLimpa=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    var identificacao=String(opcoes.identificacao||placaLimpa||'este veículo').trim();
    var salvo=opcoes.dadosIniciais||histShareDetalhesLerDados(placaLimpa), avSalvo={};
    try{ if(placaLimpa&&typeof avCompartDetalhesLer==='function') avSalvo=avCompartDetalhesLer(placaLimpa)||{}; }catch(_){}
    var kmSalva=Number(avSalvo.km||salvo.km)||0;
    var obsSalva=String(avSalvo.obs||salvo.obs||'').slice(0,4000);
    var gastosSalvos=histShareValorNumero(avSalvo.gastosTotal||salvo.gastosTotal)||0;
    var gastosDescricaoSalva=String(avSalvo.gastosDescricao||salvo.gastosDescricao||'').slice(0,1000);
    var ov=document.createElement('div'); ov.id='histShareDetalhes'; ov.className='hsp-overlay';
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 18a8 8 0 1 1 16 0"/><path d="m12 18 4-5"/><path d="M7 18h10"/></svg>';
    var fechar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    ov.innerHTML='<button type="button" class="hsp-fundo" aria-label="'+esc(cancelarAria)+'"></button>'+
      '<section class="hsp-sheet" role="dialog" aria-modal="true" aria-labelledby="hspTitulo" aria-describedby="hspAjuda" tabindex="-1">'+
      '<div class="hsp-head"><span class="hsp-ico">'+ico+'</span><div><span>'+esc(kicker)+'</span><h2 id="hspTitulo">Detalhes do veículo</h2></div><button type="button" class="hsp-x" id="hspX" aria-label="Fechar">'+fechar+'</button></div>'+
      '<p id="hspAjuda">'+esc(ajuda)+'<b>'+esc(identificacao)+'</b>.</p>'+
      '<form id="hspForm"><label class="hsp-campo" for="hspKm"><span>Quilometragem <small>(opcional)</small></span><input id="hspKm" type="text" inputmode="numeric" autocomplete="off" maxlength="12" value="'+esc(kmSalva?kmSalva.toLocaleString('pt-BR'):'')+'" placeholder="Ex.: 85.000 km"></label>'+
      '<label class="hsp-campo" for="hspObs"><span>Observações <small>(opcional)</small></span><textarea id="hspObs" rows="3" maxlength="4000">'+esc(obsSalva)+'</textarea></label>'+
      '<label class="hsp-campo" for="hspGastos"><span>Gastos previstos <small>(opcional)</small></span><input id="hspGastos" type="text" inputmode="decimal" autocomplete="off" maxlength="18" value="'+esc(histShareValorTexto(gastosSalvos))+'" placeholder="R$ 0,00"></label>'+
      '<label class="hsp-campo hsp-campo-condicional" id="hspGastosDescricaoBox" for="hspGastosDescricao"'+(gastosSalvos?'':' hidden')+'><span>Descrição dos gastos <small>(opcional)</small></span><textarea id="hspGastosDescricao" rows="2" maxlength="1000" placeholder="Ex.: pneus, revisão e retoque de pintura">'+esc(gastosDescricaoSalva)+'</textarea></label>'+
      '<div class="hsp-privacidade"><strong>Esses dados ficarão salvos '+(placaLimpa?'nesta placa.':'neste veículo.')+'</strong><span>'+(paraPdf?'As informações serão incluídas no relatório.':'Envie as fotos depois, diretamente pelo WhatsApp.')+'</span></div>'+
      '<button type="submit" class="hsp-continuar">'+esc(acao)+'</button><button type="button" class="hsp-cancelar" id="hspCancelar">Cancelar</button></form></section>';
    document.body.appendChild(ov); document.body.classList.add('hsp-on');
    var sheet=ov.querySelector('.hsp-sheet'), form=$('hspForm'), km=$('hspKm'), obs=$('hspObs');
    var gastos=$('hspGastos'), gastosDescricao=$('hspGastosDescricao'), gastosDescricaoBox=$('hspGastosDescricaoBox');
    function gastosAlternar(){ if(gastosDescricaoBox) gastosDescricaoBox.hidden=!(histShareValorNumero(gastos&&gastos.value)>0); }
    if(gastos){ gastos.oninput=gastosAlternar; gastos.onblur=function(){ var f=histShareValorTexto(gastos.value); gastos.value=f; gastosAlternar(); }; }
    function encerrar(devolver){
      document.removeEventListener('keydown',teclado,true); document.body.classList.remove('hsp-on');
      ov.remove(); if(devolver!==false){ try{ if(foco&&foco.isConnected) foco.focus({preventScroll:true}); }catch(_){} }
    }
    function teclado(e){
      if(e.key==='Escape'){ e.preventDefault(); encerrar(); return; }
      if(e.key!=='Tab') return;
      var fs=ov.querySelectorAll('button,input,textarea,[tabindex]:not([tabindex="-1"])'); if(!fs.length) return;
      var primeiro=fs[0], ultimo=fs[fs.length-1];
      if(e.shiftKey&&document.activeElement===primeiro){ e.preventDefault(); ultimo.focus(); }
      else if(!e.shiftKey&&document.activeElement===ultimo){ e.preventDefault(); primeiro.focus(); }
    }
    document.addEventListener('keydown',teclado,true);
    ov.querySelector('.hsp-fundo').onclick=function(){ encerrar(); };
    $('hspX').onclick=function(){ encerrar(); }; $('hspCancelar').onclick=function(){ encerrar(); };
    form.onsubmit=function(e){
      e.preventDefault();
      var digitos=String((km&&km.value)||'').replace(/\D/g,'').slice(0,9);
      var observacoes=String((obs&&obs.value)||'').trim().replace(/[ \t]+/g,' ').replace(/\n{3,}/g,'\n\n').slice(0,4000);
      var gastosTotal=histShareValorNumero((gastos&&gastos.value)||'');
      var gastosTexto=gastosTotal?String((gastosDescricao&&gastosDescricao.value)||'').trim().replace(/[ \t]+/g,' ').replace(/\n{3,}/g,'\n\n').slice(0,1000):'';
      var bruto={km:digitos?Number(digitos):0,obs:observacoes,gastosTotal:gastosTotal,gastosDescricao:gastosTexto};
      var detalhes;
      if(typeof opcoes.salvar==='function'){
        detalhes={quilometragem:digitos?(Number(digitos).toLocaleString('pt-BR')+' km'):'',observacoes:observacoes,
          gastosPrevistos:histShareValorTexto(gastosTotal),gastosDescricao:gastosTexto};
        try{ opcoes.salvar(bruto,detalhes); }catch(_){}
      }else{
        detalhes=histShareDetalhesGravarDados(placaLimpa,digitos,observacoes,gastosTotal,gastosTexto,origem,true);
        try{ if(placaLimpa&&typeof avCompartDetalhesAplicar==='function') avCompartDetalhesAplicar(placaLimpa,digitos,observacoes,gastosTotal,gastosTexto); }catch(_){}
      }
      encerrar(false); continuar(detalhes);
    };
    requestAnimationFrame(function(){ ov.classList.add('is-on'); try{ (km||sheet).focus({preventScroll:true}); }catch(_){} });
  }
  function histPrintVisor(url, cv, placa, modo){
    var nome='consulta-'+placa+'.png';
    var textoCompartilhar=String((cv&&cv.__mevShareText)||('Consulta veicular · '+placa));
    var X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var DL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    var SH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
    var bg=document.createElement('div'); bg.className='pv-bg'; bg.id='pvBg';
    bg.innerHTML='<button class="pv-x" id="pvX">'+X+'</button>'+
      '<div class="pv-box"><div class="pv-imgwrap"><img src="'+url+'" alt="Consulta '+esc(placa)+'"></div>'+
      '<div class="pv-acts pv-icon-actions"><button class="pv-act pv-icon-only" id="pvBaixar" aria-label="Baixar imagem" title="Baixar imagem">'+DL+'</button>'+
      '<button class="pv-act pv-share pv-icon-only" id="pvShare" aria-label="Compartilhar imagem" title="Compartilhar imagem">'+SH+'</button></div>'+
      '<div class="pv-hint">No iPhone, toque em <b>Baixar</b> e escolha <b>“Salvar Imagem”</b> pra ir pra Fototeca.</div></div>';
    document.body.appendChild(bg);
    function fechar(){ bg.classList.remove('on'); setTimeout(function(){ if(bg.parentNode) bg.parentNode.removeChild(bg); },200); }
    bg.addEventListener('click',function(e){ if(e.target===bg) fechar(); });
    $('pvX').onclick=fechar;
    function acaoBaixar(){
      var down=function(){ try{ var a=document.createElement('a'); a.href=url; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ a.remove(); },700); toast('Imagem baixada.'); }catch(_){ toast('Não consegui baixar.'); } };
      /* iPhone/PWA: link não salva na Fototeca — usa o menu nativo pra "Salvar Imagem".
         🔴 v1086: a condição era `navigator.canShare`, e o Mac TEM essa API —
         então o botão "Baixar" abria a folha de compartilhamento no computador
         também. O motivo escrito acima continua verdadeiro e continua valendo:
         ele fala do iPhone. Só a pergunta mudou pra "este aparelho sabe
         baixar?", que é o que o comentário sempre quis dizer. */
      if(!podeBaixarArquivo()){
        try{
          cv.toBlob(function(blob){
            if(!blob){ down(); return; }
            try{ var file=new File([blob], nome, {type:'image/png'}); if(navigator.canShare({files:[file]})){ navigator.share({files:[file]}).then(function(){ toast('Toque em “Salvar Imagem” pra ir pra Fototeca.'); }).catch(function(err){ if(!(err&&err.name==='AbortError')) down(); }); } else { down(); } }
            catch(_){ down(); }
          },'image/png');
        }catch(_){ down(); }
        return;
      }
      down();
    }
    function acaoShare(){
      histShareDetalhesPedir(placa,function(detalhes){
        detalhes=detalhes||{};
        var textoFinal=histShareMensagemCompleta(textoCompartilhar,detalhes);
        var fb=function(){ try{ var a=document.createElement('a'); a.href=url; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ a.remove(); },700); toast('Compartilhamento indisponível — imagem salva.'); }catch(_){}; };
        try{
          cv.toBlob(function(blob){
            if(!blob){ fb(); return; }
            try{
              var file=new File([blob], nome, {type:'image/png'});
              if(navigator.canShare && navigator.canShare({files:[file]})){
                navigator.share({files:[file], title:'Consulta veicular · '+placa, text:textoFinal}).catch(function(err){ if(!(err&&err.name==='AbortError')) fb(); });
              } else { fb(); }
            }catch(_){ fb(); }
          }, 'image/png');
        }catch(_){ fb(); }
      },cv);
    }
    /* v896: com modo, dispara a ação e não mostra a prévia */
    if(modo==='baixar'){ try{ bg.parentNode&&bg.parentNode.removeChild(bg); }catch(_){} acaoBaixar(); return; }
    if(modo==='compartilhar'){ try{ bg.parentNode&&bg.parentNode.removeChild(bg); }catch(_){} acaoShare(); return; }
    $('pvBaixar').onclick=acaoBaixar;
    $('pvShare').onclick=acaoShare;
    requestAnimationFrame(function(){ bg.classList.add('on'); });
  }

  /* v1292 — zoom compartilhado pelos dois visualizadores de PDF. Mantém o
     ponto observado no centro do gesto/visor, aceita pinça no celular,
     Ctrl/Cmd + roda no computador e oferece controles explícitos acessíveis. */
  function _pdfZoomInstala(bg, wrap, conteudo, prefixo){
    var menos=$(prefixo+'ZoomMenos'), nivel=$(prefixo+'ZoomNivel'), mais=$(prefixo+'ZoomMais');
    var zoom=1, inicioDist=0, inicioZoom=1, destruido=false;
    function limita(n){ return Math.max(1,Math.min(3,n)); }
    function atualizarBotoes(){
      var pct=Math.round(zoom*100);
      nivel.textContent=pct+'%'; nivel.setAttribute('aria-label','Zoom em '+pct+'%. Toque para voltar a 100%');
      menos.disabled=zoom<=1.001; mais.disabled=zoom>=2.999;
    }
    function aplicar(n,x,y){
      var anterior=zoom, proximo=limita(n);
      if(Math.abs(proximo-anterior)<.005) return;
      x=Number.isFinite(x)?x:wrap.clientWidth/2; y=Number.isFinite(y)?y:wrap.clientHeight/2;
      zoom=proximo; conteudo.style.width=(zoom*100)+'%'; conteudo.classList.toggle('pv-zoomado',zoom>1.001);
      requestAnimationFrame(function(){
        if(destruido) return;
        var fator=zoom/anterior;
        wrap.scrollLeft=(wrap.scrollLeft+x)*fator-x;
        wrap.scrollTop=(wrap.scrollTop+y)*fator-y;
      });
      atualizarBotoes();
    }
    function distancia(ts){ var dx=ts[0].clientX-ts[1].clientX,dy=ts[0].clientY-ts[1].clientY; return Math.sqrt(dx*dx+dy*dy); }
    function ponto(ts){ var r=wrap.getBoundingClientRect(); return {x:(ts[0].clientX+ts[1].clientX)/2-r.left,y:(ts[0].clientY+ts[1].clientY)/2-r.top}; }
    function toqueInicio(e){ if(e.touches.length===2){ inicioDist=distancia(e.touches); inicioZoom=zoom; } }
    function toqueMove(e){ if(e.touches.length!==2||!inicioDist) return; e.preventDefault(); var p=ponto(e.touches); aplicar(inicioZoom*distancia(e.touches)/inicioDist,p.x,p.y); }
    function toqueFim(e){ if(e.touches.length<2) inicioDist=0; }
    function roda(e){ if(!(e.ctrlKey||e.metaKey)) return; e.preventDefault(); var r=wrap.getBoundingClientRect(); aplicar(zoom+(e.deltaY<0?.25:-.25),e.clientX-r.left,e.clientY-r.top); }
    menos.onclick=function(){ aplicar(zoom-.25); }; mais.onclick=function(){ aplicar(zoom+.25); }; nivel.onclick=function(){ aplicar(1); };
    wrap.addEventListener('touchstart',toqueInicio,{passive:true});
    wrap.addEventListener('touchmove',toqueMove,{passive:false});
    wrap.addEventListener('touchend',toqueFim,{passive:true});
    wrap.addEventListener('touchcancel',toqueFim,{passive:true});
    wrap.addEventListener('wheel',roda,{passive:false});
    atualizarBotoes();
    return {
      tecla:function(e){
        if(e.key==='+'||e.key==='='){ e.preventDefault(); aplicar(zoom+.25); return true; }
        if(e.key==='-'){ e.preventDefault(); aplicar(zoom-.25); return true; }
        if(e.key==='0'){ e.preventDefault(); aplicar(1); return true; }
        return false;
      },
      desativar:function(){ conteudo.style.width='100%'; conteudo.classList.remove('pv-zoomado'); menos.disabled=true; mais.disabled=true; nivel.disabled=true; nivel.textContent='Leitor'; },
      destruir:function(){ destruido=true; wrap.removeEventListener('touchstart',toqueInicio); wrap.removeEventListener('touchmove',toqueMove); wrap.removeEventListener('touchend',toqueFim); wrap.removeEventListener('touchcancel',toqueFim); wrap.removeEventListener('wheel',roda); }
    };
  }
  function _pdfZoomHtml(prefixo){
    var MENOS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
    var MAIS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>';
    return '<div class="pv-zoom" aria-label="Controles de zoom"><button class="pv-zoom-btn" id="'+prefixo+'ZoomMenos" aria-label="Diminuir zoom" title="Diminuir zoom">'+MENOS+'</button><button class="pv-zoom-nivel" id="'+prefixo+'ZoomNivel" title="Voltar a 100%">100%</button><button class="pv-zoom-btn" id="'+prefixo+'ZoomMais" aria-label="Aumentar zoom" title="Aumentar zoom">'+MAIS+'</button></div>';
  }

  /* Visualizador de PDF na tela (relatório completo): abre o PDF + Baixar/Compartilhar.
     v1026: o leitor nativo do Safari ignora `FitH` e corta a lateral do A4.
     O PDF.js, que o app já carrega sob demanda para miniaturas, passa a
     desenhar cada página na largura real do visor. */
  function pdfVisor(blob, nome){
    var url=URL.createObjectURL(blob);
    var X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var DL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    var SH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
    var bg=document.createElement('div'); bg.className='pv-bg'; bg.id='pvBgDoc';
    bg.setAttribute('role','dialog'); bg.setAttribute('aria-modal','true'); bg.setAttribute('aria-label','Visualização do PDF');
    bg.innerHTML='<div class="pv-toolbar">'+_pdfZoomHtml('pvDoc')+'<button class="pv-x" id="pvxDoc" aria-label="Fechar PDF">'+X+'</button></div>'+
      '<div class="pv-box pv-box-doc"><div class="pv-docwrap"><div class="pv-docstatus" role="status"><span class="mini-spin"></span> Ajustando o PDF à tela…</div><div class="pv-pages" aria-label="Páginas do PDF"></div></div>'+
      '<div class="pv-acts pv-icon-actions"><button class="pv-act pv-icon-only" id="pvBaixarDoc" aria-label="Baixar PDF" title="Baixar PDF">'+DL+'</button>'+
      '<button class="pv-act pv-share pv-icon-only" id="pvShareDoc" aria-label="Compartilhar PDF" title="Compartilhar PDF">'+SH+'</button></div>'+
      '<div class="pv-hint">No iPhone, toque em <b>Baixar</b> e escolha <b>“Salvar em Arquivos”</b>.</div></div>';
    document.body.appendChild(bg);
    var focoAntes=document.activeElement, scrollAntes=window.scrollY, estiloAntes=document.body.getAttribute('style'), fechado=false;
    document.body.classList.add('comercial-modal-on');
    document.body.style.position='fixed'; document.body.style.top=-scrollAntes+'px'; document.body.style.width='100%';
    var wrap=bg.querySelector('.pv-docwrap'), paginas=bg.querySelector('.pv-pages');
    var zoomPdf=_pdfZoomInstala(bg,wrap,paginas,'pvDoc');
    function teclaPdf(e){
      if(e.key==='Escape'){e.preventDefault();fechar();}
      if(zoomPdf.tecla(e)) return;
      if(e.key==='Tab'){
        var bs=Array.prototype.slice.call(bg.querySelectorAll('button:not([disabled])'));
        if(e.shiftKey&&document.activeElement===bs[0]){e.preventDefault();bs[bs.length-1].focus();}
        else if(!e.shiftKey&&document.activeElement===bs[bs.length-1]){e.preventDefault();bs[0].focus();}
      }
    }
    document.addEventListener('keydown',teclaPdf);
    function fechar(){
      if(fechado) return; fechado=true; bg.classList.remove('on');
      document.removeEventListener('keydown',teclaPdf); zoomPdf.destruir(); document.body.classList.remove('comercial-modal-on');
      if(estiloAntes===null) document.body.removeAttribute('style'); else document.body.setAttribute('style',estiloAntes);
      window.scrollTo(0,scrollAntes);
      setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(_){} if(bg.parentNode) bg.parentNode.removeChild(bg); if(focoAntes&&focoAntes.isConnected) focoAntes.focus({preventScroll:true}); },200);
    }
    bg.addEventListener('click',function(e){ if(e.target===bg) fechar(); });
    $('pvxDoc').onclick=fechar;
    function baixar(){ try{ var a=document.createElement('a'); a.href=url; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ a.remove(); },700); toast('PDF baixado.'); }catch(_){ toast('Não consegui baixar.'); } }
    function compart(){ try{ var file=new File([blob], nome, {type:'application/pdf'}); if(navigator.canShare && navigator.canShare({files:[file]})){ navigator.share({files:[file], title:nome}).catch(function(err){ if(!(err&&err.name==='AbortError')) baixar(); }); return; } }catch(_){} baixar(); }
    /* v1086 — era `if(navigator.canShare)`, que mandava o Mac pro compartilhar. */
    $('pvBaixarDoc').onclick=function(){ if(podeBaixarArquivo()) baixar(); else compart(); };
    $('pvShareDoc').onclick=compart;
    $('pvxDoc').focus();
    requestAnimationFrame(function(){ bg.classList.add('on'); });
    /* Render progressivo: cada canvas tem exatamente a largura disponível.
       O teto de 920 px físicos mantém o texto nítido sem estourar memória em
       laudos longos. Se a biblioteca não carregar, o PDF continua acessível
       pelo leitor nativo como plano B. */
    (async function(){
      var status=bg.querySelector('.pv-docstatus');
      try{
        if(typeof _pdfjsLoad!=='function') throw new Error('pdfjs');
        var lib=await _pdfjsLoad(), bytes=await blob.arrayBuffer();
        if(fechado) return;
        var doc=await lib.getDocument({data:new Uint8Array(bytes)}).promise;
        for(var i=1;i<=doc.numPages;i++){
          if(fechado) return;
          status.textContent='Preparando página '+i+' de '+doc.numPages+'…';
          var pg=await doc.getPage(i), base=pg.getViewport({scale:1});
          var largura=Math.max(260,wrap.clientWidth-16), escala=Math.min(3,1800/base.width,largura/base.width*Math.min(window.devicePixelRatio||1,2)*2);
          var vp=pg.getViewport({scale:escala}), cv=document.createElement('canvas');
          cv.className='pv-pdf-page'; cv.width=Math.ceil(vp.width); cv.height=Math.ceil(vp.height);
          cv.setAttribute('aria-label','Página '+i+' de '+doc.numPages);
          paginas.appendChild(cv);
          await pg.render({canvasContext:cv.getContext('2d'),viewport:vp}).promise;
        }
        if(!fechado){ status.remove(); paginas.classList.add('pronto'); }
      }catch(_){
        if(fechado) return;
        status.textContent='Abrindo no leitor do aparelho…';
        paginas.innerHTML='<iframe class="pv-frame" src="'+url+'#view=FitH&toolbar=0&navpanes=0" title="'+esc(nome)+'"></iframe>';
        paginas.classList.add('fallback');
        zoomPdf.desativar();
      }
    })();
  }

  /* Desenha o RELATÓRIO COMPLETO numa imagem (canvas) — encaixa 100% em qualquer tela,
     sem depender do visualizador de PDF do iPhone (que cortava a lateral). */
  function _wrapText(g, text, x, y, maxW, lh){
    var words=String(text).split(' '), line='';
    for(var i=0;i<words.length;i++){ var t=line+words[i]+' ';
      if(g.measureText(t).width>maxW && i>0){ g.fillText(line, x, y); line=words[i]+' '; y+=lh; } else line=t; }
    g.fillText(line, x, y); return y;
  }
  /* título de seção com barra de destaque à esquerda */
  function _accTit(g,txt,x,y){ g.fillStyle='#0a4da6'; _rr(g,x,y-21,6,26,3); g.fill(); g.fillStyle='#001e50'; g.font='800 27px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(txt,x+18,y); }
  /* pílula de status (verde = ok, vermelho = alerta) alinhada à direita */
  function _pill(g,txt,xr,ymid,ruim){ g.font='800 20px system-ui,-apple-system,Arial'; var tw=g.measureText(txt).width, px=15, bw=tw+px*2, bh=36, bx=xr-bw, by=ymid-bh/2; g.fillStyle=ruim?'#fee2e2':'#dcfce7'; _rr(g,bx,by,bw,bh,18); g.fill(); g.fillStyle=ruim?'#b91c1c':'#15803d'; g.textAlign='left'; g.fillText(txt,bx+px,ymid+7); return bw; }
  /* v355 — QUEBRA DE LINHA QUE NÃO ESTOURA MAIS A CAIXA.
     Esta função só quebrava nos ESPAÇOS. Um e-mail
     (chiquinhoveiculos@chiquinhoveiculos.com.br) é uma palavra só: não tinha
     onde quebrar e o texto saía por cima da borda do cartão no PDF. Agora,
     quando uma palavra sozinha não cabe, ela é partida por letra. Vale pra
     todo canvas do app (CNPJ, relatório veicular). */
  function _wrapLines(g,text,maxW){
    var words=String(text).split(' '), line='', out=[];
    function empurra(w){                     /* palavra maior que a caixa: parte por letra */
      var pedaco='';
      for(var k=0;k<w.length;k++){
        if(g.measureText(pedaco+w[k]).width>maxW && pedaco){ out.push(pedaco); pedaco=''; }
        pedaco+=w[k];
      }
      return pedaco;
    }
    for(var i=0;i<words.length;i++){
      var w=words[i];
      if(g.measureText(w).width>maxW){
        if(line.trim()){ out.push(line.trim()); line=''; }
        line=empurra(w)+' ';
        continue;
      }
      var t=line+w+' ';
      if(g.measureText(t).width>maxW && line){ out.push(line.trim()); line=w+' '; }
      else line=t;
    }
    if(line.trim()) out.push(line.trim());
    return out.length?out:[''];
  }
  /* ======================================================================
     v595 — O RELATÓRIO COMPLETO NO PDF PADRÃO MEV (Fase 1 do projeto)
     ======================================================================
     O desenho antigo (um canvas altíssimo fatiado pelo jsPDF) saiu; agora
     as páginas nascem do KIT (06b): cabeçalho com a placa Mercosul,
     FAIXA DE VEREDITO, QUADRO DE AVISOS com semáforo, dados unificados,
     FIPE 6 meses com tendência e rodapé com protocolo + pág. N de M em
     toda página. Nenhum bloco cortado ao meio.
     🔴 Regra v450 no veredito: resposta SEM a estrutura de restrições NÃO
     vira "nada consta" — vira âmbar "não foi possível verificar" (o
     desenho antigo pintava verde nesse caso; era um falso nada-consta). */
  function relatorioPaginas(rel, v){
    v=v||{};
    var temCompleta=!!(rel&&((rel.data&&(rel.data.veicular||rel.data.bin_estadual))||rel.veicular||rel.bin_estadual||rel.bin_nacional||rel.renajud||rel.renainf));
    var ex = temCompleta ? relVeicExtrai(rel) : null;
    var proto=''; try{ var _p=_ciDeep(rel||{},['Protocolo','NumeroProtocolo']); if(_p&&typeof _p==='object') _p=_ciTxt(_p,'Numero','Protocolo'); proto=String(_p||''); }catch(_){}
    var st=pdfkitNovo({ tipo:'Relatório completo do veículo', placa:v.placa||'', protocolo:proto,
      lgpdCurto:'Uso restrito à avaliação de procedência, conforme a LGPD (Lei 13.709/2018)' });
    /* B — veredito geral */
    var ruins = ex ? ex.itens.filter(function(i){ return i.ruim; }) : [];
    if(!ex){
      kitVeredito(st,'at','Não foi possível verificar','a base não devolveu a estrutura de restrições');
    } else if(ruins.length || ex.temGravame){
      var nAvisos=ruins.length+(ex.temGravame?1:0);
      kitVeredito(st,'no','Constam restrições ('+nAvisos+')', ruins.map(function(i){ return i.rot; }).slice(0,2).join(' · ')||'gravame ativo');
    } else {
      kitVeredito(st,'ok','Sem restrições','todas as verificações vieram limpas');
    }
    /* C — quadro de avisos (um item por bloco verificado + gravame) */
    if(ex){
      var avisos=ex.itens.map(function(it){
        return { t: it.rot+': '+(it.ruim?String(it.extra||'consta'):'nada consta'), nv: it.ruim?'no':'ok' };
      });
      if(ex.temGravame) avisos.push({ t:'Financiamento (gravame): ativo', nv:'no' });
      kitAvisos(st,'Quadro de avisos',avisos);
      if(ex.msgs && ex.msgs.length) kitTexto(st, ex.msgs.map(function(m){ return '• '+m; }).join('  '), '#b91c1c');
    }
    /* gravame em detalhe (quando existe) */
    if(ex && ex.temGravame && ex.gravame && ex.gravame.length){
      kitKv2(st,'Financiamento ativo (gravame)', ex.gravame);
      kitAtencao(st,'Veículo com alienação fiduciária: só transfere após a baixa do gravame. Considere a quitação no valor da troca.');
    }
    /* E — dados do veículo unificados (relatório antigo sem os campos → cai
       nos dados da própria consulta de placa, nunca seção vazia) */
    var _dv=((ex&&ex.dados)||[]).filter(function(d){ var val=String(d[1]==null?'':d[1]).trim(); return val && val!=='/' && val!=='-'; });
    var dadosAll = _dv.length ? _dv : [['Marca',v.marca],['Modelo',v.modelo],['Ano fab. / modelo',String(v.ano||'')+(v.ano_modelo&&v.ano_modelo!=v.ano?(' / '+v.ano_modelo):'')],['Cor',v.cor],['Combustível',v.combustivel],['Chassi',v.chassi?kitChassiMask(v.chassi):''],['Valor FIPE',brl(v.fipe)],['Ref. FIPE',v.mes_ref],['Cód. FIPE',v.codigo_fipe]];
    /* v597: chassi no PDF SÓ com os 6 últimos dígitos, venha de onde vier */
    dadosAll=dadosAll.map(function(d){ return /chassi/i.test(String(d[0]))?[d[0],kitChassiMask(d[1])]:d; });
    kitKv2(st,'Dados do veículo', dadosAll);
    /* H — FIPE 6 meses (histórico que o aparelho já guarda) */
    try{
      var histF=(typeof verHistDe==='function')?verHistDe(v).filter(function(x){ return x&&x.valor!=null; }):[];
      if(histF.length>=2){
        histF=histF.slice().sort(function(a,b){ return String(b.mes||'')<String(a.mes||'')?-1:1; });
        kitFipe6(st, histF);
      }
    }catch(_){}
    /* selo do que está limpo, quando o veredito é verde */
    if(ex && !ruins.length && !ex.temGravame) kitSelo(st,'Nada consta em nenhuma das bases verificadas na data da consulta.');
    /* termo LGPD + assinatura (o de sempre — avisos legais UMA vez) */
    kitEspaco(st,6);
    _kitBanda(st,'Termo de Uso e Consentimento (LGPD)');
    var termo='Relatório com informações de bases públicas/privadas, obtidas via provedor terceirizado, para avaliação da procedência do veículo em compra/troca. São informativas e podem divergir das bases oficiais; a concessionária não se responsabiliza por dados de terceiros. Tratamento conforme a LGPD (Lei 13.709/2018); dados pessoais do proprietário omitidos.';
    kitEspaco(st,8);
    kitTexto(st, termo);
    kitEspaco(st,10);
    kitTexto(st, 'Data: '+histData(Date.now())+'      Solicitante: ____________________      Assinatura: ____________________', '#0f172a');
    return kitFinaliza(st);
  }
  /* a prévia da tela (relInlineHtml/visor) é a pilha das páginas do kit */
  function relatorioCanvas(rel, v){
    return kitPrevia(relatorioPaginas(rel, v));
  }
  /* mostra o relatório como IMAGEM (largura 100%, sem cortar) + Baixar/Compartilhar o PDF */
  /* ==========================================================================
     v918 — O VISOR ACEITA UMA TERCEIRA AÇÃO (opcional)
     --------------------------------------------------------------------------
     `op.compartilharPrint` é uma função. Passou? o visor ganha o botão
     "Compartilhar print". Não passou? o visor é EXATAMENTE o de antes.

     🔑 POR QUE OPCIONAL, e não um botão fixo: este mesmo visor mostra o PDF do
     contrato, o do CNPJ, o do leilão — PDFs que não têm print correspondente.
     Um terceiro botão fixo prometeria imagem onde não existe imagem. Quem
     sabe se há print é quem chama, então é quem passa. */
  function relatorioVisor(canvas, pdfBlob, nome, op){
    var url; try{ url=canvas.toDataURL('image/png'); }catch(_){ pdfVisor(pdfBlob, nome); return; }
    var X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var DL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    var SH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
    /* moldura de foto + a seta do compartilhar: o botão fala de IMAGEM, não
       de arquivo — é o que separa ele do "Compartilhar" do lado */
    var IM='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="14" height="14" rx="2"/><circle cx="7.5" cy="9.5" r="1.3"/><polyline points="17 15 12.5 10.5 4 19"/><polyline points="18 2 22 6 18 10"/><path d="M22 6h-6"/></svg>';
    var temPrint=!!(op && typeof op.compartilharPrint==='function');
    var bg=document.createElement('div'); bg.className='pv-bg'; bg.id='pvBgRel';
    bg.setAttribute('role','dialog'); bg.setAttribute('aria-modal','true'); bg.setAttribute('aria-label','Visualização do PDF');
    bg.innerHTML='<div class="pv-toolbar">'+_pdfZoomHtml('pvRel')+'<button class="pv-x" id="pvxRel" aria-label="Fechar PDF">'+X+'</button></div>'+
      '<div class="pv-box"><div class="pv-imgwrap"><img src="'+url+'" alt="Relatório"></div>'+
      '<div class="pv-acts pv-icon-actions"><button class="pv-act pv-icon-only" id="pvBaixarRel" aria-label="Baixar PDF" title="Baixar PDF">'+DL+'</button>'+
      '<button class="pv-act pv-share pv-icon-only" id="pvShareRel" aria-label="Compartilhar PDF" title="Compartilhar PDF">'+SH+'</button>'+
      (temPrint?('<button class="pv-act pv-print-share pv-icon-only" id="pvSharePrint" aria-label="Compartilhar print da consulta" title="Compartilhar print da consulta">'+IM+'</button>'):'')+'</div>'+
      '<div class="pv-hint">No iPhone, toque em <b>Baixar PDF</b> pra salvar em <b>Arquivos</b>.'+
        (temPrint?' Pra mandar como <b>imagem</b>, use o <b>Compartilhar print</b>.':'')+'</div></div>';
    document.body.appendChild(bg);
    var focoAntes=document.activeElement, scrollAntes=window.scrollY, estiloAntes=document.body.getAttribute('style');
    document.body.classList.add('comercial-modal-on');
    document.body.style.position='fixed'; document.body.style.top=-scrollAntes+'px'; document.body.style.width='100%';
    var fechado=false, wrap=bg.querySelector('.pv-imgwrap'), imagem=wrap.querySelector('img');
    var zoomPdf=_pdfZoomInstala(bg,wrap,imagem,'pvRel');
    function teclaPdf(e){
      if(e.key==='Escape'){e.preventDefault();fechar();}
      if(zoomPdf.tecla(e)) return;
      if(e.key==='Tab'){
        var bs=Array.prototype.slice.call(bg.querySelectorAll('button:not([disabled])'));
        if(e.shiftKey&&document.activeElement===bs[0]){e.preventDefault();bs[bs.length-1].focus();}
        else if(!e.shiftKey&&document.activeElement===bs[bs.length-1]){e.preventDefault();bs[0].focus();}
      }
    }
    document.addEventListener('keydown',teclaPdf);
    function fechar(){
      if(fechado) return; fechado=true;
      document.removeEventListener('keydown',teclaPdf); zoomPdf.destruir(); document.body.classList.remove('comercial-modal-on');
      if(estiloAntes===null) document.body.removeAttribute('style'); else document.body.setAttribute('style',estiloAntes);
      window.scrollTo(0,scrollAntes); bg.remove(); if(focoAntes&&focoAntes.isConnected) focoAntes.focus({preventScroll:true});
    }
    bg.addEventListener('click',function(e){ if(e.target===bg) fechar(); });
    $('pvxRel').onclick=fechar;
    $('pvxRel').focus();
    function baixar(){ try{ var u=URL.createObjectURL(pdfBlob), a=document.createElement('a'); a.href=u; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },800); toast('PDF baixado.'); }catch(_){ toast('Não consegui baixar.'); } }
    function compart(){ try{ var file=new File([pdfBlob], nome, {type:'application/pdf'}); if(navigator.canShare && navigator.canShare({files:[file]})){ var dados={files:[file],title:nome}; if(op&&op.textoCompartilhar) dados.text=String(op.textoCompartilhar); navigator.share(dados).catch(function(err){ if(!(err&&err.name==='AbortError')) baixar(); }); return; } }catch(_){} baixar(); }
    /* v1086 — era `if(navigator.canShare)`, que mandava o Mac pro compartilhar. */
    $('pvBaixarRel').onclick=function(){ if(podeBaixarArquivo()) baixar(); else compart(); };
    $('pvShareRel').onclick=compart;
    /* v918 — o print é do CHAMADOR: o visor não sabe desenhar consulta
       nenhuma, ele só aperta o botão que recebeu. O visor NÃO fecha junto —
       a folha nativa abre por cima e a pessoa pode querer o PDF depois. */
    if(temPrint){
      var bp=$('pvSharePrint');
      if(bp) bp.onclick=function(){ try{ op.compartilharPrint(); }catch(_){ toast('Não consegui gerar o print.'); } };
    }
    requestAnimationFrame(function(){ bg.classList.add('on'); });
  }

/* ╔═══ src/app/05b-terceira-coluna.js ════════════════════════════════════ */
  /* ==========================================================================
     05b — (VAZIO desde a v398, pedido do Angelo)

     A terceira coluna "Últimas consultas" do desktop (>=1400px) foi
     REMOVIDA. Este arquivo ficou de propósito como casca vazia: assim o
     montar.js não quebra e ninguém recria a coluna sem querer.
     A versão antiga está no git e em
     _QUARENTENA_PARA_EXCLUIR (se existir) — pra voltar, restaurar o
     conteúdo v390 e recolocar a chamada colTresPinta() no 05d.
     ========================================================================= */

/* ╔═══ src/app/05c-avaliacoes.js ═════════════════════════════════════════ */
  /* ==========================================================================
     05c — PÁGINA "AVALIAÇÕES" (v383)

     PEDIDO do Angelo: "constrói a página de avaliações — ela puxa o histórico e
     abre a partir da placa".

     O QUE É: a lista das avaliações que você já salvou, uma por placa (a mais
     recente de cada). Tocar numa linha abre a avaliação daquele veículo, do
     mesmo jeito que abrir pela placa — porque é isso que ela faz: recupera o
     veículo do histórico e chama a mesma tela de sempre.

     DE ONDE VEM: da tabela `avaliacoes` (é lá que a avaliação do lojista é
     gravada quando você gera o link). O nome do modelo, o ano e a FOTO vêm do
     que já está no aparelho — o mesmo histórico e o mesmo mapa de capas que a
     lista da página inicial usa. Nenhuma tabela nova, nenhum SQL.

     SE A PLACA NÃO ESTIVER NO HISTÓRICO DESTE APARELHO: em vez de gastar uma
     consulta sem avisar, a placa é colocada no campo da página inicial e você
     decide se busca.
     ========================================================================== */
  var _avlCache=null, _avlBusca='', _avlCli=null;
  /* v686 (pedido: "ADICIONE UM BOTAO PRA ORDENAR, KM, PRECO DE FIPE,
     ADICIONADOS RECENTEMENTE") — o mesmo desenho do ordenar do Mercado
     (v663): memória só, sem preferência gravada, e SEM DADO VAI PRO FIM —
     carro sem km não pode furar a fila de quem tem. */
  var _avlOrd='recentes';
  var AVL_ORDENS=[
    ['recentes','Mais recentes', function(a){ return -(Number(a.ts)||0) || null; }],
    ['antigos','Mais antigos',   function(a){ return Number(a.ts)||null; }],
    ['km','Menor km',            function(a){ var f=_avlFonteVeic(a.placa); var n=Number(a.km||f.km)||0; return n>0?n:null; }],
    ['fipe','Menor FIPE',        function(a){ var h=_avlDoHistorico(a.placa); var n=Number(a.fipe||((h&&h.v)||{}).fipe)||0; return n>0?n:null; }],
    ['fipe-maior','Maior FIPE',  function(a){ var h=_avlDoHistorico(a.placa); var n=Number(a.fipe||((h&&h.v)||{}).fipe)||0; return n>0?-n:null; }]
  ];
  function avlOrdenar(lista, ordem){
    var def=AVL_ORDENS.filter(function(o){ return o[0]===ordem; })[0]||AVL_ORDENS[0];
    var f=def[2];
    return lista.slice().sort(function(a,b){
      var va=f(a), vb=f(b);
      if(va==null && vb==null) return 0;
      if(va==null) return 1;    /* sem dado vai pro fim (régua v663) */
      if(vb==null) return -1;
      return va-vb;
    });
  }
  /* v937 — sem o filtro "Todas", a página sempre abre numa situação real.
     Os três cards são exclusivos e não se desligam ao tocar novamente. */
  var _avlChip='cotando';

  /* v400 (pedido): nome do cliente VINCULADO à placa (tabela cliente_consulta,
     a mesma do "Vincular cliente"). placa -> nome; o mais recente vence. */
  async function _avlClientesCarregar(){
    _avlCli={};
    try{
      if(!meuId || !window.supa) return;
      var r=await supa.from('cliente_consulta').select('placa,cliente_id').eq('user_id',meuId).limit(500);
      var rows=(r&&r.data)||[];
      if(!rows.length) return;
      try{ await cliCarregar(); }catch(_){}
      var nomes={}; (_clientes||[]).forEach(function(c){ nomes[String(c.id)]=String(c.nome||''); });
      rows.forEach(function(x){ var p=_avlKey(x.placa); var nm=nomes[String(x.cliente_id)]; if(p && nm && !_avlCli[p]) _avlCli[p]=nm; });
    }catch(_){ }
  }

  function _avlKey(p){ return String(p||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  /* ===== v481 — DE ONDE VEM O "PREÇO DA AVALIAÇÃO" =====
     O `avaliado` do payload de mp_avaliacoes é null em TODAS as
     avaliações — e isso é de propósito: a v265 tirou o valor avaliado do
     pacote público pra que o lojista parceiro não abrisse o "inspecionar"
     e lesse o piso da negociação.
     Mas o número existe: fica no RASCUNHO da avaliação (mp_doc_consulta,
     tipo `aval_rascunho`, campo avValor) — que é privado, só seu.
     Então a lista lê de lá. O pacote público continua limpo.
     Uma consulta a mais no banco, zero token. */
  var _avlAval=null, _avlRascunhos={};
  function avlPrecosDaAvaliacao(a){
    var pl=_avlKey(a.placa),d=_avlRascunhos[pl]||null;
    try{var local=JSON.parse(localStorage.getItem('mev_aval:'+pl)||'null');if(local)d=local;}catch(_){}
    var entrada=d&&d.avMotorEntrada;
    if(entrada){
      var _fxSalva={};
      try{ _fxSalva=(typeof fichaVendeDe==='function')?(fichaVendeDe(a.placa||'')||{}):{}; }catch(_){ _fxSalva={}; }
      var _anoFabSalvo=Number(a.ano_fab||a.ano||a.ano_modelo)||0;
      if(_anoFabSalvo) entrada=Object.assign({},entrada,{anoFabricacao:_anoFabSalvo});
      if((_fxSalva.opcionais_todos||[]).length) entrada=Object.assign({},entrada,{semTetoSolar:MEV_AVALIACAO_MOTOR.tetoSolarAusente(
        _fxSalva.opcionais_todos,_fxSalva.opcionais_marcados||_fxSalva.opcionais)});
    }
    if(!entrada&&d&&d.avGastosJ!=null){
      var gastos=[],ed={};try{gastos=JSON.parse(d.avGastosJ||'[]');ed=JSON.parse(d.avCustoEdJ||'{}');}catch(_){}
      var moto=MEV_AVALIACAO_MOTOR.ehMoto(a),prefs=_avPcts();
      function escolha(id,padrao){return d[id]==='outro'?{valor:_avlSoNum(d[id+'Out'])}:{percentual:d[id]!=null&&d[id]!==''?Number(d[id]):padrao};}
      var _fx={};try{_fx=(typeof fichaVendeDe==='function')?(fichaVendeDe(a.placa||'')||{}):{};}catch(_){}
      entrada={fipe:Number(a.fipe)||0,ano:Number(a.ano_modelo||a.ano)||0,
        anoFabricacao:Number(a.ano_fab||a.ano||a.ano_modelo)||0,
        anoAtual:new Date().getFullYear(),km:_avlSoNum(d.avKm),moto:moto,
        /* v1230 — mesma troca da ficha aberta: a resposta vem dos Opcionais
           (d.avOpcJ), não dos selects escondidos na v1079. */
        semAr:MEV_AVALIACAO_MOTOR.semArNosOpcionais(d.avOpcJ),semDir:MEV_AVALIACAO_MOTOR.semDirecaoNosOpcionais(d.avOpcJ),
        semTetoSolar:!moto&&MEV_AVALIACAO_MOTOR.tetoSolarAusente(_fx.opcionais_todos,_fx.opcionais_marcados||_fx.opcionais),
        liquidezManual:d.avLiqT?_avlSoNum(d.avLiq):null,
        preferencias:prefs,lucro:escolha('avLucro',moto?prefs.lucroMoto:prefs.lucroCarro),garantia:escolha('avMg',prefs.garantia),
        garantiaFabrica:d.avGarantia==='Tem',garantiaEditada:d.avMg!=='0',chave:_avlSoNum(d.avChave),edicoes:ed,
        itens:Array.isArray(gastos)?gastos.map(function(g,i){return {id:'gasto'+i,rotulo:g.descricao||'',valor:Number(g.valor)||0};}):[]};
    }
    if(entrada){var r=MEV_AVALIACAO_MOTOR.calcular(entrada);return {compra:r.loja,
      lojista:d&&d.avVendaLojistaT?_avlSoNum(d.avVendaLojista):r.comercial.lojista,
      varejo:d&&d.avVendaVarejoT?_avlSoNum(d.avVendaVarejo):r.comercial.varejo,sugerida:true};}
    var compra=_avlValorDe(a.placa,a),com=MEV_AVALIACAO_MOTOR.comerciais(compra,Number(a.fipe)||0);
    return {compra:compra,lojista:com.lojista,varejo:com.varejo,sugerida:false};
  }
  /* ===== v685 — O EDITOR RÁPIDO DO CARD (dois pedidos de 28/08) ===========
     "PERMITA EDITAR O VALOR AVALIADO NO CARD - MARCA SE FOI REPASSE, VALOR
      QUE O LOJISTA PASSOU E VALOR TIRANDO A MARGEM DE 2000"
     "QUANDO CLICAR NUM CARD, PERMITA MARCAR SE FOI VENDIDO, O VALOR DE
      VENDA E A COMISSAO QUE ENTROU"

     O card ganha um ✎ na área dos valores: abre uma folha com o valor
     avaliado, a marca de repasse (com o valor do lojista e a conta da
     margem), e a marca de vendido (com valor de venda e comissão).
     O toque no RESTO do card continua abrindo a avaliação, como sempre.

     🔴 UM NOME SÓ PRA CADA COISA (v390): o "valor avaliado" editado aqui
     NÃO vira um segundo número — ele é gravado NO MESMO rascunho da
     avaliação (aval_rascunho, campo avValor), local e nuvem. O card e o
     formulário leem da mesma fonte.
     Os campos NOVOS (repasse/vendido/venda/comissão) moram num registro
     próprio (`aval_card` no doc_consulta + espelho local) — eles são dados
     do NEGÓCIO, não do formulário de vistoria. */
  var AVL_MARGEM_REPASSE=2000;   /* ⛳ v685 — a margem do repasse, em R$.
     Pedido do Angelo: "valor tirando a margem de 2000". Mudar aqui muda a
     conta em todo card. */
  var _avlCard=null;
  function _avlCardLer(){ try{ return JSON.parse(localStorage.getItem('mev_avl_card')||'{}')||{}; }catch(_){ return {}; } }
  function _avlCardGravaLocal(){ try{ localStorage.setItem('mev_avl_card', JSON.stringify(_avlCard||{})); }catch(_){} }
  async function _avlCardCarregar(){
    _avlCard=_avlCardLer();
    try{
      if(!meuId || !window.supa) return;
      var r=await supa.from('doc_consulta')
        .select('chave,resultado,ts')
        .eq('user_id',meuId).eq('tipo','aval_card').limit(500);
      ((r&&r.data)||[]).forEach(function(row){
        var pl=_avlKey(row.chave); if(!pl) return;
        var d=row.resultado; if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(_){ d=null; } }
        if(!d) return;
        /* a nuvem ganha do aparelho quando é mais nova (mesma régua do resto) */
        var loc=_avlCard[pl];
        if(!loc || (Number(row.ts)||0) >= (Number(loc._ts)||0)) _avlCard[pl]=d;
      });
      _avlCardGravaLocal();
    }catch(_){ }
  }
  function avlCardDe(placa){ return (_avlCard&&_avlCard[_avlKey(placa)])||null; }
  function _avlSoNum(s){ return parseInt(String(s==null?'':s).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
  function _avlRs(n){ n=Number(n)||0; return n?('R$ '+n.toLocaleString('pt-BR')):''; }
  /* v692 — o valor avaliado de uma placa, onde quer que ele more: o rascunho
     da NUVEM primeiro (_avlAval), depois o registro da avaliação (a.valor) e
     por fim o rascunho LOCAL deste aparelho — que a nuvem pode ainda não ter
     visto. Era o buraco do card "Sem valor avaliado" com o valor já digitado.
     Um nome só pra essa conta (v390): os três lugares do card usam ela. */
  function _avlValorDe(placa, a){
    var n=(_avlAval&&_avlAval[_avlKey(placa)])||Number((a||{}).valor)||0;
    if(n>0) return n;
    try{
      var o=JSON.parse(localStorage.getItem('mev_aval:'+_avlKey(placa))||'null');
      n=_avlSoNum(o&&o.avValor);
    }catch(_){ n=0; }
    return n>0?n:0;
  }
  /* v713 ("o que dá pra melhorar", item km): a MESMA escada do _avlValorDe,
     só que pro km — o rascunho digitado (nuvem e aparelho) completa o card
     quando o registro e o estoque não têm a quilometragem. */
  var _avlKmR=null;
  function _avlKmDe(placa){
    placa=_avlKey(placa);
    var n=(_avlKmR&&_avlKmR[placa])||0;
    if(n>0) return n;
    try{
      var o=JSON.parse(localStorage.getItem('mev_aval:'+placa)||'null');
      n=_avlSoNum(o&&o.avKm);
    }catch(_){ n=0; }
    return n>0?n:0;
  }
  async function _avlAvaliadosCarregar(){
    _avlAval={}; _avlKmR={}; _avlRascunhos={};
    try{
      if(!meuId || !window.supa) return;
      var r=await supa.from('doc_consulta')
        .select('chave,resultado')
        .eq('user_id',meuId).eq('tipo','aval_rascunho').limit(500);
      ((r&&r.data)||[]).forEach(function(row){
        var pl=_avlKey(row.chave); if(!pl) return;
        var d=row.resultado; if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(_){ d=null; } }
        if(d) _avlRascunhos[pl]=d;
        var n=parseInt(String((d&&d.avValor)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
        if(n>0 && !_avlAval[pl]) _avlAval[pl]=n;
        var k=parseInt(String((d&&d.avKm)||'').replace(/\D/g,''),10)||0;   /* v713 */
        if(k>0 && !_avlKmR[pl]) _avlKmR[pl]=k;
      });
    }catch(_){ }
  }

  /* ===== v685 — A FOLHA DO EDITOR ========================================= */
  function _avlMaskRs(inp){
    inp.addEventListener('input',function(){
      var n=_avlSoNum(this.value);
      this.value=n?_avlRs(n):'';
    });
  }
  /* ===== v695 — O MENU DO CARD, A PÁGINA E O EXCLUIR ======================
     Pedido do Angelo (28/08, com print do card do Fox): "quando clicar no
     card, abra um menu (editar avaliacao, ver pagina lojista, excluir),
     coloque um svg canto superior direito do card, de compartilhar".
     · o link da página do lojista é RECONSTRUÍDO da própria linha do banco
       (id → 8 dígitos + placa + slug da loja), o MESMO desenho do avLojGerar
       — nenhum formato novo de link;
     · excluir apaga as linhas de `avaliacoes` daquela placa (a página do
       lojista sai do ar junto) — o RASCUNHO do formulário fica no aparelho,
       de propósito: apagar o card não come o que foi digitado;
     · confirmação NA PRÓPRIA FOLHA (nunca window.confirm — trava o app). */
  /* v696 — os ícones do menu, no traço da casa (viewBox 24, stroke 2) */
  var _AVM_ICO={
    lapis:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/></svg>',
    valores:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    olho:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    lixo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    /* v799 — o "Comprado": um aperto de mão. O carro passou a ser seu. */
    comprado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 12.5l-4 4a2.1 2.1 0 0 1-3 0l-1-1"/><path d="M3 10l3.5-3.5a2 2 0 0 1 2.8 0L13 10l-2 2a1.5 1.5 0 0 1-2.1 0L7 10"/><path d="M13 10l3-3 5 5"/><path d="M2 8l3-3M22 13l-2 2"/></svg>',
    /* v797 — o avião de papel do "enviar" (o mesmo traço da v696, que já
       marca o "Mandar pro vendedor do carro" dentro da avaliação) */
    proposta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>',
    /* v713 — o desfecho da negociação, no mesmo traço */
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    xis:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    arquivo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16v13H4z"/><path d="M3 3h18v4H3z"/><path d="M9 11h6"/></svg>',
    restaurar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>'
  };
  /* ⚠️ v919 — ESTE ÍCONE MORA AQUI, no nível do módulo, e não lá dentro junto
     dos ícones da folha: quem o usa é o `avlPinta` (o rodapé do card), e a
     folha inteira é declarada DENTRO do `telaAvaliacoes`. Declarado lá, ele
     existiria só enquanto a tela estivesse sendo montada — e o card, que é
     repintado a qualquer momento, estouraria com "não definido". */
  var _AVL_ICO_SETA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M12 6l6 6-6 6"/></svg>';
  var _AVL_ICO_SHARE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
  async function _avlRowDe(placa){
    try{
      var r=await supa.from('avaliacoes').select('id')
        .eq('user_id',meuId).eq('placa',_avlKey(placa))
        .order('criado_em',{ascending:false}).limit(1);
      return (r&&r.data&&r.data[0])||null;
    }catch(_){ return null; }
  }
  async function _avlUrlDe(placa){
    var row=await _avlRowDe(placa); if(!row||!row.id) return '';
    var cod=String(row.id||'').replace(/-/g,'').slice(0,8);
    var slug=''; try{ slug=ljApelido(); }catch(_){ slug=''; }
    return location.origin+(slug?('/'+slug+'/avaliacao/'):'/av/')+_avlKey(placa)+'-'+cod;
  }
  async function avlVerPagina(placa){
    var u=await _avlUrlDe(placa);
    if(!u){ toast('Esta avaliação ainda não tem página — abra a avaliação e gere o link.'); return; }
    try{ if(typeof _publicoAbrir==='function'){ _publicoAbrir(u,{ voltar:'Voltar às avaliações', titulo:'Página do lojista' }); return; } }catch(_){}
    try{ window.open(u,'_blank','noopener'); }catch(_){ location.href=u; }
  }
  async function _avlCompartilharLojista(placa){
    var u=await _avlUrlDe(placa);
    if(!u){ toast('Esta avaliação ainda não tem página — abra a avaliação e gere o link.'); return; }
    /* ========================================================================
       🔴 v722 (pedido): "QUANDO CLICAR NO SVG DE COMPARTILHAR, DEVE ENVIAR A
       MENSAGEM NO WHATSAPP WEB SEMELHANTE AO BOTAO DE ENVIO NO WHATSAPP QUE
       TEM DENTRO DO APP, COM FOTO, MENSAGEM E LINK"
       — a MESMA mensagem do botão de dentro da avaliação (avRepMsg): o `msg`
       que já viaja pronto no pacote (v490) + a moldura "📸 Fotos e oferta" +
       o link. A FOTO entra pela pré-visualização do link no WhatsApp — o
       aval-share serve a capa (fotos[0]) como imagem da página, a mesma
       miniatura da v710. O navigator.share saiu: o destino pedido é o
       WhatsApp, sempre. */
    var msg='';
    try{
      var r=await supa.from('avaliacoes').select('payload')
        .eq('user_id',meuId).eq('placa',_avlKey(placa))
        .order('criado_em',{ascending:false}).limit(1);
      var p=(r&&r.data&&r.data[0]&&r.data[0].payload)||null;
      if(typeof p==='string'){ try{ p=JSON.parse(p); }catch(_){ p=null; } }
      msg=String((p&&p.msg)||'').trim();
    }catch(_){}
    if(!msg){
      var a=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===_avlKey(placa); })[0]||{};
      msg=String(_avlModelo(a.modelo||'Avaliação')).trim();   /* pacote antigo sem msg: ao menos o carro */
    }
    var txt=msg+'\n\n📸 Fotos e oferta:\n'+u;   /* a MESMA moldura do avRepMsg */
    try{ if(typeof mevIrProWhats==='function'){ mevIrProWhats('https://wa.me/?text='+encodeURIComponent(txt)); return; } }catch(_){}
    try{ window.open('https://wa.me/?text='+encodeURIComponent(txt),'_blank','noopener'); }catch(_){}
  }
  function avlCompartilhar(placa){ return _avlCompartilharLojista(placa); }
  async function avlExcluir(placa){
    placa=_avlKey(placa);
    try{
      var r=await supa.from('avaliacoes')['delete']()
        .eq('user_id',meuId).eq('placa',placa).select('id');
      if(r&&r.error) throw r.error;
    }catch(_){ toast('Não consegui excluir agora — tente de novo.'); return false; }
    _avlCache=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)!==placa; });
    avlPinta();
    toast('Avaliação excluída — o rascunho do formulário continua no aparelho.');
    return true;   /* v725: a folha do card espera esta resposta pra fechar (ou ficar aberta no erro) */
  }
  /* ===== v723 — A FOLHA DO CARD: QUATRO ÁREAS, ROLAGEM PRÓPRIA ==============
     (docs/PROJETO-2026-08-29-menu-do-card-de-avaliacao.txt · VERSÃO A)
     A folha era sete caixas iguais empilhadas, sem max-height: em aparelho
     menor (ou com o teclado aberto) "Salvar venda", "Excluir" e "Cancelar"
     saíam da tela. Agora ela tem quatro áreas reconhecíveis — CABEÇALHO
     (modelo, placa, situação e o X), AÇÕES (navegar/editar), SITUAÇÃO
     (Vendido / Não fechou) e a ÁREA DE RISCO (Excluir) — rola por dentro,
     e no celular encosta no rodapé como uma folha curta.
     (v723 = só a organização e a caixa; v724 = a situação virou grupo
     exclusivo e os dados da venda ganharam os campos canônicos; v725 =
     diálogo com ARIA, foco preso, Escape, devolução do foco ao card e
     o aviso "Descartar alterações da venda?".) */
  var _AVM_ICO_X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var _AVM_ICO_SETA='<svg class="avm-seta" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
  /* ==========================================================================
     🔴 v922 (PROJETO-filtros-avaliacoes-cotando-comprados-vendidos, 06/09)
     UMA FONTE SÓ PRA SITUAÇÃO — o filtro e o selo do card leem a MESMA função
     --------------------------------------------------------------------------
     O defeito que o projeto aponta, e ele é real: o filtro antigo "Em
     negociação" olhava só o `vendido` e o `desfecho` do card; o SELO do card,
     além disso, olhava o vínculo de ESTOQUE. Resultado: um carro já comprado
     (que entrou no estoque sem ninguém marcar "comprei") aparecia com o selo
     "Comprado" E dentro do filtro de quem ainda está negociando. A mesma tela
     dizia duas coisas sobre o mesmo carro.

     🔑 Agora existe UMA função — `avlSituacao(placa)` — e os dois a
     chamam. Ela devolve exatamente um de quatro estados, na PRECEDÊNCIA que o
     projeto fixou:

       1. vendido confirmado          → 'vendido'
       2. desfecho 'comprei'          → 'comprado'
       3. desfecho 'nao'              → 'nao'      (fora de Cotando; vive em Todas)
       4. vínculo válido de estoque   → 'comprado'
       5. nada disso                  → 'cotando'

     ⚠️ A ORDEM É O CONTRATO. "Vendido" na frente de "comprado" é o que garante
     que um carro comprado e depois vendido apareça SÓ em Vendidos — os três
     filtros são mutuamente exclusivos porque a função devolve UM valor, não
     porque cada filtro se lembra de excluir os outros. Filtro que exclui à mão
     é filtro que um dia esquece.

     ⚠️ E OFERTA NÃO É SITUAÇÃO. Ter proposta, não ter valor avaliado, ser
     recente — nada disso entra aqui. O projeto é explícito: "Pode ter ou nao
     oferta e valor avaliado. Esses valores nao definem status." Eles seguem
     aparecendo no card como informação complementar.

     📌 FALHA DE CARREGAMENTO NÃO RECLASSIFICA. Se o estoque ainda não
     chegou, `_avlEstTem` devolve false e o carro fica em 'cotando' — que é
     onde ele já estava. Nunca o contrário: nada aqui move um carro PRA FORA de
     Comprados por causa de uma lista que não carregou.
     ========================================================================= */
  var _avlEstIdx=null, _avlEstIdxFonte=null;
  /* índice placa→1 do estoque, refeito só quando a LISTA muda de identidade
     (o 14-estoque troca o array inteiro ao recarregar). Sem isto seria uma
     varredura do estoque inteiro por card, a cada repintura da lista. */
  function _avlEstTem(placa){
    try{
      var fonte=(typeof _estoque!=='undefined' && _estoque)?_estoque:[];
      if(_avlEstIdxFonte!==fonte){
        _avlEstIdxFonte=fonte; _avlEstIdx=Object.create(null);
        for(var i=0;i<fonte.length;i++){ var p=_avlKey(fonte[i]&&fonte[i].placa); if(p) _avlEstIdx[p]=1; }
      }
      var k=_avlKey(placa);
      return !!(k && _avlEstIdx[k]);
    }catch(_){ return false; }
  }
  /* ==========================================================================
     🔴🔴🔴 v1079 — A ETIQUETA "AVALIADO" (pedido do Angelo, com print)
     --------------------------------------------------------------------------
     "se estiver preenchido o valor do avaliex ou do lojista interessado,
      marque uma etiqueta no card de avaliacao como avaliado ao invés de
      cotando".

     🔑 A ETIQUETA MUDA, A SITUAÇÃO NÃO. O card passa a dizer "Avaliado", mas
        `avlSituacao()` continua devolvendo 'cotando' — então o placar
        "Cotando" continua contando esse carro e o filtro continua achando
        ele. São duas perguntas diferentes: *onde a negociação está* (o
        placar) e *esta avaliação já tem número* (a etiqueta). Mexer na
        situação mudaria os três contadores da linha de cima sem ninguém
        pedir.

     ⚠️ DE ONDE VEM O DADO, E POR QUE DE DOIS LUGARES:
        · o rascunho DESTE aparelho (`mev_aval:PLACA` no localStorage) — é
          instantâneo e não custa consulta nenhuma;
        · e o mesmo rascunho na NUVEM (`aval_rascunho` do doc_consulta), que
          o `avFormSalvarNuvem()` grava desde sempre. Sem ele, um carro
          avaliado no celular não apareceria avaliado no computador.
        A nuvem vem em UMA consulta só pra lista inteira, não uma por card.

     ⚠️ E NÃO ENTROU NO `payload` DA TABELA `avaliacoes`. Seria mais fácil de
        ler dali — e seria vazamento: aquele payload é o que a PÁGINA PÚBLICA
        do lojista lê, e o valor do Avaliex (avaliação do gerente) e a oferta
        do lojista interessado são números internos. A v288 já cravou a regra
        pro preço de repasse; ela vale igual pra estes dois.
     ========================================================================== */
  var _avlRasc={};          /* placa -> {avaliex:n, oferta:n} */
  var _avlRascNuvem=false;  /* a nuvem já respondeu uma vez nesta sessão? */

  function _avlNum(v){
    /* "R$ 52.000,00" e "52000" têm que dar o mesmo número. Os centavos saem
       antes dos pontos: sem isto, "R$ 1.500,00" viraria 150000. */
    var t=String(v==null?'':v).trim();
    if(!t) return 0;
    t=t.replace(/,\d{1,2}\s*$/,'');
    return parseInt(t.replace(/\D/g,''),10)||0;
  }
  function _avlRascDe(o){
    if(!o||typeof o!=='object') return null;
    var a=_avlNum(o.avAvaliex), b=_avlNum(o.avLojOferta);
    return { avaliex:a, oferta:b };
  }
  /* o rascunho deste aparelho, lido na hora de pintar (custo zero) */
  function _avlRascLocal(placa){
    try{
      var o=JSON.parse(localStorage.getItem('mev_aval:'+placa)||'null');
      return _avlRascDe(o);
    }catch(_){ return null; }
  }
  function _avlAvaliado(placa){
    var r=_avlRascLocal(placa) || _avlRasc[placa];
    if(!r){
      /* local vazio: vale o da nuvem, se chegou */
      r=_avlRasc[placa];
    } else if(_avlRasc[placa]){
      /* os dois existem: o maior de cada um vence. Rascunho local recém-aberto
         nasce com os campos em branco e apagaria a marca que a nuvem trouxe. */
      r={ avaliex:Math.max(r.avaliex,_avlRasc[placa].avaliex),
          oferta: Math.max(r.oferta, _avlRasc[placa].oferta) };
    }
    return !!r && (r.avaliex>0 || r.oferta>0);
  }
  /* UMA consulta pra lista inteira, e ela repinta quando responder */
  function avlRascNuvemCarregar(){
    try{
      if(_avlRascNuvem) return;
      if(typeof docHistCloudLoad!=='function') return;
      _avlRascNuvem=true;
      docHistCloudLoad('aval_rascunho', function(rows){
        try{
          var mudou=false;
          (rows||[]).forEach(function(row){
            var pl=_avlKey((row&&row.chave)||''); if(!pl) return;
            var r=_avlRascDe(row&&row.resultado); if(!r) return;
            _avlRasc[pl]=r; mudou=true;
          });
          if(mudou) avlPinta();
        }catch(_){}
      }, 300);
    }catch(_){}
  }

  function avlSituacao(placa){
    var cd=avlCardDe(placa)||{};
    if(cd.arquivado) return 'arquivado';
    if(cd.vendido) return 'vendido';
    if(cd.desfecho==='comprei') return 'comprado';
    if(cd.desfecho==='nao') return 'nao';
    if(_avlEstTem(placa)) return 'comprado';
    return 'cotando';
  }
  /* o rótulo de cada filtro, num lugar só (chip, vazio e leitor de tela) */
  var AVL_SIT_ROTULO={ cotando:'Cotando', comprado:'Comprados', vendido:'Vendidos', arquivado:'Arquivados' };

  /* a etiqueta textual da situação do card (nunca só cor) */
  function _avmSituacao(cd){
    cd=cd||{};
    if(cd.arquivado) return { k:'arquivado', tx:'Arquivado' };
    if(cd.vendido) return { k:'vendido', tx:'Vendido' };
    if(cd.desfecho==='comprei') return { k:'comprei', tx:'Comprado' };
    return { k:'neg', tx:'Cotando' };
  }
  function avlCardMenu(placa){
    placa=_avlKey(placa);
    var a=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===placa; })[0]||{};
    var velho=$('avmBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avmBg'; bg.className='cropmask avm-mask';
    /* v713 (desfecho) → 🔴 v718 (pedido, com print do menu): "troque o
       comprei por vendido, coloca valor da venda e da comissão e quem
       comprou". O item liga na máquina de VENDA que o card já tinha desde a
       v685 (vendido/valor_venda/comissao no registro aval_card — v390: um
       nome só) e ganha o campo novo `comprador`.
       ===== v724 — SITUAÇÃO COMO GRUPO EXCLUSIVO (VERSÃO B do projeto) =====
       Três opções que se excluem: "Em negociação", "Vendido", "Não fechou".
       · tocar em Vendido ABRE os dados da venda (não grava ainda) e o botão
         Vendido CONTINUA visível enquanto se edita (antes ele sumia);
       · Não fechou grava desfecho='nao' + vendido=false, como hoje;
       · Em negociação grava desfecho='' + vendido=false SEM apagar
         valor_venda/comissao/comprador (a regra do "Desmarcar venda" v718);
       · ⚠️ REGRA QUE MUDOU: tocar de novo em "Não fechou" NÃO desmarca mais
         (o toggle da v713 saiu). Pra desmarcar, toca-se em "Em negociação".
       · os campos são os canônicos .cad-float/.cad-lbl/.cad-in, e o rodapé
         "Cancelar alterações / Salvar venda" fica preso no fundo da folha. */
    var _cd0=avlCardDe(placa)||{};
    var _sit=_avmSituacao(_cd0);
    function _rd(id,k,ico,tx){
      return '<button type="button" class="avm-rd'+(_sit.k===k?' on':'')+' '+k+'" role="radio" aria-checked="'+(_sit.k===k?'true':'false')+'" id="'+id+'" data-sit="'+k+'">'+
        '<span class="avm-rd-ic">'+ico+'</span><span class="avm-rd-tx">'+tx+'</span></button>';
    }
    /* v725 — quem abriu a folha recebe o foco de volta quando ela fechar */
    var _veioDe=null; try{ _veioDe=document.activeElement; }catch(_){}
    var _cardDe=null; try{ _cardDe=document.querySelector('.est-card[data-placa="'+placa+'"]'); }catch(_){}
    bg.innerHTML='<div class="cropbox avm-box" role="dialog" aria-modal="true" aria-labelledby="avmTit" tabindex="-1">'+
      /* 1. CABEÇALHO — preso no topo enquanto o miolo rola */
      '<div class="avm-head">'+
        '<div class="avm-head-tx">'+
          '<div class="avm-tit" id="avmTit">'+esc(_avlModelo(a.modelo||'Veículo'))+'</div>'+
          '<div class="avm-sub"><span class="avm-placa">'+esc(placa)+'</span>'+
            '<span class="avm-sit '+_sit.k+'" id="avmSit">'+_sit.tx+'</span></div>'+
        '</div>'+
        '<button type="button" class="avm-x" id="avmFechar" aria-label="Fechar menu da avaliação">'+_AVM_ICO_X+'</button>'+
      '</div>'+
      '<div class="avm-body">'+
        /* 2. AÇÕES — uma superfície só, com divisores; não três cards */
        '<div class="avm-grp-t">Ações</div>'+
        '<div class="avm-grp">'+
          '<button type="button" class="avm-it" id="avmEditar"><span class="avm-ic">'+_AVM_ICO.lapis+'</span><span class="avm-tx">Editar avaliação</span>'+_AVM_ICO_SETA+'</button>'+
          '<button type="button" class="avm-it" id="avmArquivar"><span class="avm-ic">'+(_cd0.arquivado?_AVM_ICO.restaurar:_AVM_ICO.arquivo)+'</span><span class="avm-tx">'+(_cd0.arquivado?'Restaurar cotação':'Arquivar cotação')+'</span>'+_AVM_ICO_SETA+'</button>'+
          /* ⛳ v1066 (pedido do Angelo: "oculta do menu o comprado registrar
             a compra"). O botão saiu — a SITUAÇÃO "Comprado" logo abaixo
             continua, e é outra coisa: ela marca o desfecho da negociação,
             não abre a tela de registrar a compra.

             🔴 O QUE ISSO CUSTA, ESCRITO AQUI PRA NINGUÉM DESCOBRIR DEPOIS:
             este era o ÚNICO caminho pro `abrirCompra`. Sem ele a tela de
             registrar a compra fica inalcançável — inclusive o "Compra
             registrada — abrir", pros veículos que já têm compra gravada.
             O Angelo pediu duas vezes, com print; é decisão dele.
             ⛳ NADA FOI APAGADO: o `abrirCompra` e o `compraExiste` continuam
             inteiros no 05l-compra-do-veiculo.js, e o dado gravado também.
             Devolver o botão é descomentar o bloco que era:
               '<button type="button" class="avm-it" id="avmComprado">…'+
                 (compraExiste(placa)?'Compra registrada — abrir':'Comprado — registrar a compra')+
               '</span>'+_AVM_ICO_SETA+'</button>'+
             (era v799, e ficava depois do "Editar avaliação"). */
        '</div>'+
        /* 3. SITUAÇÃO — grupo exclusivo (v724) */
        '<div class="avm-grp-t" id="avmSitT">Situação</div>'+
        '<div class="avm-radios" role="radiogroup" aria-labelledby="avmSitT">'+
          _rd('avmEmNeg','neg',_AVM_ICO.check,'Cotando')+
          _rd('avmCompraSit','comprei',_AVM_ICO.check,'Comprado')+
          _rd('avmVendido','vendido',_AVM_ICO.check,'Vendido')+
        '</div>'+
        /* 3b. DADOS DA VENDA — só quando "Vendido" estiver selecionado */
        '<div id="avmVendBox" class="avm-venda cad-float" hidden>'+
          '<div class="avm-grp-t">Dados da venda</div>'+
          '<label class="cad-lbl" for="avmVenda">Valor da venda (R$)</label>'+
          '<input id="avmVenda" class="cad-in" inputmode="decimal" autocomplete="off" value="'+esc(_avlRs(_cd0.valor_venda))+'">'+
          '<label class="cad-lbl" for="avmComissao">Comissão que entrou (R$)</label>'+
          '<input id="avmComissao" class="cad-in" inputmode="decimal" autocomplete="off" value="'+esc(_avlRs(_cd0.comissao))+'">'+
          '<label class="cad-lbl" for="avmComprador">Quem comprou</label>'+
          '<input id="avmComprador" class="cad-in" autocomplete="off" value="'+esc(String(_cd0.comprador||''))+'">'+
        '</div>'+
        /* 4. ÁREA DE RISCO — depois de um divisor, fora das ações frequentes */
        '<div class="avm-risco">'+
          '<button type="button" class="avm-it perigo" id="avmExcluir"><span class="avm-ic">'+_AVM_ICO.lixo+'</span><span class="avm-tx">Excluir avaliação</span></button>'+
          '<div id="avmConfirma" hidden>'+
            '<div class="avm-aviso">Excluir a avaliação de <b>'+esc(placa)+'</b>? A página do lojista sai do ar. O rascunho do formulário fica no aparelho.</div>'+
            '<div class="avc-acts"><button type="button" class="crop-c" id="avmNao">Voltar</button>'+
            '<button type="button" class="crop-ok avm-vermelho" id="avmSim">Excluir de vez</button></div>'+
          '</div>'+
        '</div>'+
      '</div>'+
      /* rodapé da venda — preso no fundo da folha, acima do teclado/safe area */
      '<div class="avm-foot" id="avmFoot" hidden>'+
        '<div class="avm-descarte" id="avmDescarte" role="alertdialog" aria-labelledby="avmDescarteTx" hidden>'+
          '<div class="avm-descarte-tx" id="avmDescarteTx">Descartar alterações da venda?</div>'+
          '<div class="avm-descarte-acts">'+
            '<button type="button" class="crop-c" id="avmContinuar">Continuar editando</button>'+
            '<button type="button" class="crop-ok avm-vermelho" id="avmDescartar">Descartar alterações</button>'+
          '</div>'+
        '</div>'+
        '<div class="avm-foot-acts" id="avmFootActs">'+
          '<button type="button" class="crop-c" id="avmVendCancel">Cancelar alterações</button>'+
          '<button type="button" class="crop-ok" id="avmVendSalvar">Salvar venda</button>'+
        '</div>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    var _box=bg.querySelector('.avm-box');
    /* v725 — fechar de verdade: tira a folha e DEVOLVE o foco a quem abriu
       (o card da lista, ou o que estava focado antes) */
    function fechar(){
      try{ bg.parentNode.removeChild(bg); }catch(_){}
      try{ document.removeEventListener('keydown', _teclas, true); }catch(_){}
      try{
        var alvo=(_veioDe && _veioDe!==document.body && document.contains(_veioDe)) ? _veioDe : _cardDe;
        if(alvo && document.contains(alvo)){
          if(!alvo.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(alvo.tagName)) alvo.setAttribute('tabindex','-1');
          alvo.focus({ preventScroll:true });
        }
      }catch(_){}
    }
    /* v725 — "sujo" = qualquer um dos três campos diferente do que estava ao
       abrir. Fechar com alteração pendente pergunta; nunca descarta calado. */
    function _sujo(){
      if($('avmVendBox').hidden) return false;
      return ($('avmVenda').value!==_abertura.venda) || ($('avmComissao').value!==_abertura.comissao) || ($('avmComprador').value!==_abertura.comprador);
    }
    var _campoFocado=null, _depoisDoDescarte=null;
    function _pedeDescarte(depois){
      _depoisDoDescarte=depois||fechar;
      try{ _campoFocado=(document.activeElement && _box.contains(document.activeElement)) ? document.activeElement : null; }catch(_){ _campoFocado=null; }
      $('avmFootActs').hidden=true; $('avmDescarte').hidden=false;
      try{ $('avmContinuar').focus(); }catch(_){}
    }
    function _fecharOuPergunta(depois){
      if(_sujo()){ _pedeDescarte(depois); return; }
      (depois||fechar)();
    }
    $('avmContinuar').onclick=function(){
      $('avmDescarte').hidden=true; $('avmFootActs').hidden=false;
      try{ (_campoFocado && document.contains(_campoFocado) ? _campoFocado : $('avmVenda')).focus(); }catch(_){}
    };
    $('avmDescartar').onclick=function(){ var d=_depoisDoDescarte||fechar; _depoisDoDescarte=null; d(); };
    /* v725 — foco preso na folha (Tab/Shift+Tab) e Escape */
    function _focaveis(){
      return Array.prototype.filter.call(_box.querySelectorAll('button,input,select,textarea,[tabindex]:not([tabindex="-1"])'), function(el){
        if(el.disabled) return false;
        for(var p=el; p && p!==_box; p=p.parentNode){ if(p.hidden) return false; }
        var r=el.getBoundingClientRect(); return r.width>0 && r.height>0;
      });
    }
    function _teclas(e){
      if(!document.contains(bg)) return;
      if(e.key==='Escape'){ e.preventDefault(); e.stopPropagation(); if(!$('avmDescarte').hidden){ $('avmContinuar').click(); return; } _fecharOuPergunta(); return; }
      if(e.key!=='Tab') return;
      var f=_focaveis(); if(!f.length){ e.preventDefault(); _box.focus(); return; }
      var i=f.indexOf(document.activeElement);
      if(e.shiftKey){ if(i<=0){ e.preventDefault(); f[f.length-1].focus(); } }
      else { if(i<0 || i===f.length-1){ e.preventDefault(); f[0].focus(); } }
    }
    document.addEventListener('keydown', _teclas, true);
    bg.onclick=function(e){ if(e.target===bg) _fecharOuPergunta(); };
    $('avmFechar').onclick=function(){ _fecharOuPergunta(); };
    /* foco inicial: a primeira ação (o leitor de tela anuncia título → placa → situação pelo aria-labelledby) */
    try{ $('avmEditar').focus({ preventScroll:true }); }catch(_){}
    $('avmEditar').onclick=function(){ fechar(); avlAbrir(placa); };
    /* v713 — grava o desfecho no MESMO registro do card (aval_card, v685):
       local + nuvem, preservando repasse/vendido/valores já marcados. */
    function _cardGrava(o, aviso){
      o._ts=Date.now();
      _avlCard=_avlCard||{}; _avlCard[placa]=o; _avlCardGravaLocal();
      try{ docHistCloudSave('aval_card', placa, 'card', o, o._ts); }catch(_){}
      fechar(); avlPinta(); toast(aviso);
    }
    $('avmArquivar').onclick=function(){
      var o=Object.assign({}, avlCardDe(placa)||{}), restaurar=!!o.arquivado;
      o.arquivado=!restaurar;
      if(o.arquivado){
        try{ if(typeof estRepasseTirarDoAr==='function') Promise.resolve(estRepasseTirarDoAr(placa)).catch(function(){}); }catch(_){}
        try{ (_repMeu||[]).forEach(function(r){ if(_avlKey(r&&r.placa)===placa) r.ativo=false; }); }catch(_){}
      }
      _cardGrava(o, restaurar?'Cotação restaurada.':'Cotação arquivada.');
    };
    /* o que estava nos campos ao abrir — é a régua do "Cancelar alterações"
       (e, na versão C, do "formulário sujo") */
    var _abertura={ venda:_avlRs(_cd0.valor_venda), comissao:_avlRs(_cd0.comissao), comprador:String(_cd0.comprador||'') };
    function _marca(k){
      ['avmEmNeg','avmCompraSit','avmVendido'].forEach(function(id){
        var b=$(id); if(!b) return; var on=b.getAttribute('data-sit')===k;
        b.classList.toggle('on',on); b.setAttribute('aria-checked',on?'true':'false');
      });
    }
    function _vendaAbre(sim){
      $('avmVendBox').hidden=!sim; $('avmFoot').hidden=!sim;
      bg.querySelector('.avm-box').classList.toggle('com-rodape',!!sim);
    }
    /* Compra e cotacao preservam os dados anteriores de venda. */
    function _situacaoGrava(k){
      var o=Object.assign({}, avlCardDe(placa)||{});
      var eraVendido=!!o.vendido, anterior=o.desfecho||'';
      o.vendido=false;                       /* os valores da venda FICAM (v718) */
      o.desfecho=(k==='comprei')?'comprei':'';
      var aviso=k==='comprei'?'Marcado: Comprado':'Cotando';
      if(!eraVendido && anterior===o.desfecho){ fechar(); return; }
      _cardGrava(o, aviso);
    }
    $('avmEmNeg').onclick=function(){ _fecharOuPergunta(function(){ _situacaoGrava('neg'); }); };
    $('avmCompraSit').onclick=function(){ _fecharOuPergunta(function(){ _situacaoGrava('comprei'); }); };
    $('avmVendido').onclick=function(){
      _marca('vendido'); _vendaAbre(true);
      try{ var f=$('avmVenda'); if(f && !f.value) f.focus(); }catch(_){}
    };
    ['avmVenda','avmComissao'].forEach(function(id){ var e=$(id); if(e) _avlMaskRs(e); });
    $('avmVendCancel').onclick=function(){
      $('avmVenda').value=_abertura.venda; $('avmComissao').value=_abertura.comissao; $('avmComprador').value=_abertura.comprador;
      if(_sit.k!=='vendido'){ _marca(_sit.k); _vendaAbre(false); }
      else { try{ $('avmVendido').focus(); }catch(_){} }
    };
    $('avmVendSalvar').onclick=function(){
      var b=this; if(b.disabled) return;        /* duplo toque não grava duas vezes */
      b.style.minWidth=b.getBoundingClientRect().width+'px'; b.disabled=true; b.textContent='Salvando…';
      try{
        var o=Object.assign({}, avlCardDe(placa)||{});
        o.vendido=true;
        o.valor_venda=_avlSoNum(($('avmVenda')||{}).value);
        o.comissao=_avlSoNum(($('avmComissao')||{}).value);
        o.comprador=String((($('avmComprador')||{}).value)||'').trim();
        if(o.desfecho==='nao') o.desfecho='';   /* vendido e "não fechou" não moram juntos */
        _cardGrava(o, 'Vendido ✓ — guardado no card');
      }catch(e){
        b.disabled=false; b.textContent='Salvar venda';
        toast('Não consegui guardar a venda agora — confira os valores e toque em Salvar de novo.');
      }
    };
    if(_sit.k==='vendido') _vendaAbre(true);   /* já vendido: abre com os dados preservados */
    /* 🔴🔴 v1066 — A GUARDA. `$()` devolve null, e `null.onclick=` derruba a
       abertura do menu INTEIRA. Foi exatamente a armadilha da v1063, quando
       dois outros botões saíram da avaliação: quem some da tela deixa pra
       trás uma linha que ainda procura por ele. */
    (function(){ var b=$('avmComprado'); if(b) b.onclick=function(){ fechar(); abrirCompra(placa); }; })();  /* v799, oculto na v1066 */
    $('avmNao').onclick=function(){ $('avmConfirma').hidden=true; $('avmExcluir').hidden=false; try{ $('avmExcluir').focus(); }catch(_){} };
    $('avmExcluir').onclick=function(){ $('avmConfirma').hidden=false; this.hidden=true; try{ $('avmNao').focus(); }catch(_){} };
    $('avmSim').onclick=function(){
      var b=this; if(b.disabled) return;         /* v725: duplo toque não dispara duas exclusões */
      b.style.minWidth=b.getBoundingClientRect().width+'px'; b.disabled=true; b.textContent='Excluindo…';
      Promise.resolve().then(function(){ return avlExcluir(placa); }).then(function(deu){
        if(deu===false){ b.disabled=false; b.textContent='Excluir de vez'; return; }   /* o toast do avlExcluir já explicou; a folha fica */
        fechar();
      }).catch(function(){ b.disabled=false; b.textContent='Excluir de vez'; toast('Não consegui excluir agora — tente de novo.'); });
    };
  }

  function avlCardEditar(placa){
    placa=_avlKey(placa);
    var a=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===placa; })[0]||{};
    var cd=avlCardDe(placa)||{};
    var avalN=_avlValorDe(placa,a);   /* v692: nuvem → registro → rascunho local */
    var velho=$('avcBg'); if(velho) velho.parentNode.removeChild(velho);
    /* v688: a classe antiga nasce display:none — o mesmo bug invisível do
       Avaliex (a nota longa mora no 05i, acima do avxConferir). A família
       visível de modal é .cropmask/.cropbox. */
    var bg=document.createElement('div'); bg.id='avcBg'; bg.className='cropmask';
    bg.innerHTML='<div class="cropbox avc-box">'+
      '<div class="avc-tit">'+esc(_avlModelo(a.modelo||'Veículo'))+'</div>'+
      '<div class="avc-sub">'+esc(placa)+(a.fipe?(' · FIPE '+esc(brl(a.fipe))):'')+'</div>'+
      /* v695 (pedido): os TRÊS valores com o nome que o Angelo usa —
         Avaliex (o do laudo), lojista (o que ofereceram) e loja (o seu).
         O da loja continua sendo o avValor do formulário (v390: um nome
         só) — os outros dois moram no registro do card. */
      '<div class="avc-campo"><label>Valor avaliação Avaliex (R$)</label>'+
        '<input id="avcAvaliex" class="avt-in" inputmode="numeric" value="'+esc(_avlRs(cd.valor_avaliex))+'"></div>'+
      /* v721: o rótulo fala a língua do card — "repasse", não "lojista" */
      '<div class="avc-campo"><label>Valor avaliação repasse (R$)</label>'+
        '<input id="avcLojista" class="avt-in" inputmode="numeric" value="'+esc(_avlRs(cd.valor_lojista))+'"></div>'+
      '<div class="avc-campo"><label>Valor avaliação loja (R$)</label>'+
        '<input id="avcAvaliado" class="avt-in" inputmode="numeric" value="'+esc(_avlRs(avalN))+'"></div>'+
      '<label class="avc-chk"><input type="checkbox" id="avcRepasse"'+(cd.repasse?' checked':'')+'><span>Foi repasse</span></label>'+
      '<div id="avcRepBox" style="display:'+(cd.repasse?'block':'none')+'">'+
        '<div class="avc-conta" id="avcConta"></div>'+
      '</div>'+
      '<label class="avc-chk"><input type="checkbox" id="avcVendido"'+(cd.vendido?' checked':'')+'><span>Vendido</span></label>'+
      '<div id="avcVendBox" style="display:'+(cd.vendido?'block':'none')+'">'+
        '<div class="avc-campo"><label>Valor de venda (R$)</label>'+
          '<input id="avcVenda" class="avt-in" inputmode="numeric" value="'+esc(_avlRs(cd.valor_venda))+'"></div>'+
        '<div class="avc-campo"><label>Comissão que entrou (R$)</label>'+
          '<input id="avcComissao" class="avt-in" inputmode="numeric" value="'+esc(_avlRs(cd.comissao))+'"></div>'+
        /* v718: quem comprou — o mesmo registro que o menu Vendido grava */
        '<div class="avc-campo"><label>Quem comprou</label>'+
          '<input id="avcComprador" class="avt-in" autocomplete="off" value="'+esc(String(cd.comprador||''))+'"></div>'+
      '</div>'+
      '<div class="avc-acts">'+
        '<button type="button" class="crop-c" id="avcAbrir">Abrir avaliação</button>'+
        '<button type="button" class="crop-ok" id="avcSalvar">Salvar</button>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    function fechar(){ try{ bg.parentNode.removeChild(bg); }catch(_){} }
    bg.onclick=function(e){ if(e.target===bg) fechar(); };
    ['avcAvaliex','avcAvaliado','avcLojista','avcVenda','avcComissao'].forEach(function(id){ var e=$(id); if(e) _avlMaskRs(e); });
    /* a conta da margem, viva enquanto digita */
    function conta(){
      var el=$('avcConta'); if(!el) return;
      var n=_avlSoNum(($('avcLojista')||{}).value);
      el.innerHTML=(n>AVL_MARGEM_REPASSE)
        ? ('− R$ '+AVL_MARGEM_REPASSE.toLocaleString('pt-BR')+' de margem → <b>'+esc(_avlRs(n-AVL_MARGEM_REPASSE))+'</b>'+
           ' <button type="button" class="avc-usar" id="avcUsar">usar como avaliado</button>')
        : '';
      var u=$('avcUsar');
      if(u) u.onclick=function(){ var av=$('avcAvaliado'); if(av){ av.value=_avlRs(n-AVL_MARGEM_REPASSE); } };
    }
    var lj=$('avcLojista'); if(lj) lj.addEventListener('input',conta); conta();
    var ck=$('avcRepasse'); if(ck) ck.onchange=function(){ $('avcRepBox').style.display=this.checked?'block':'none'; };
    var cv=$('avcVendido'); if(cv) cv.onchange=function(){ $('avcVendBox').style.display=this.checked?'block':'none'; };
    $('avcAbrir').onclick=function(){ fechar(); avlAbrir(placa); };
    $('avcSalvar').onclick=function(){
      var novoAval=_avlSoNum(($('avcAvaliado')||{}).value);
      var o={ repasse:!!(($('avcRepasse')||{}).checked),
              valor_avaliex:_avlSoNum(($('avcAvaliex')||{}).value),   /* v695 */
              valor_lojista:_avlSoNum(($('avcLojista')||{}).value),
              vendido:!!(($('avcVendido')||{}).checked),
              valor_venda:_avlSoNum(($('avcVenda')||{}).value),
              comissao:_avlSoNum(($('avcComissao')||{}).value),
              comprador:String((($('avcComprador')||{}).value)||'').trim(),   /* v718 */
              desfecho:(avlCardDe(placa)||{}).desfecho||'',   /* v718: o editor não come o desfecho do menu (v713) */
              _ts:Date.now() };
      _avlCard=_avlCard||{}; _avlCard[placa]=o; _avlCardGravaLocal();
      try{ docHistCloudSave('aval_card', placa, 'card', o, o._ts); }catch(_){}
      /* 🔴 o valor avaliado vai pra MESMA porta do formulário (v390: um nome
         só) — patch no rascunho local e na nuvem, sem apagar o resto dele. */
      if(novoAval !== (Number(avalN)||0)){
        avlCardPatchRascunho(placa, novoAval);
        _avlAval=_avlAval||{};
        if(novoAval>0) _avlAval[placa]=novoAval; else delete _avlAval[placa];
      }
      fechar(); avlPinta();
      toast('Salvo ✓');
    };
  }
  function avlCardPatchRascunho(placa, n){
    var val=n>0?_avlRs(n):'';
    var chaveL='mev_aval:'+placa;
    var o=null;
    try{ o=JSON.parse(localStorage.getItem(chaveL)||'null'); }catch(_){ o=null; }
    if(o){ o.avValor=val; try{ localStorage.setItem(chaveL, JSON.stringify(o)); }catch(_){} }
    /* na nuvem: lê o rascunho que existe, troca SÓ o avValor e regrava — um
       setItem cego apagaria a vistoria inteira de quem preencheu no celular */
    try{
      docHistCloudLoadOne('aval_rascunho', placa, function(o2){
        o2=(o2&&typeof o2==='object')?o2:(o||{});
        o2.avValor=val;
        try{ docHistCloudSave('aval_rascunho', placa, 'rascunho', o2, Date.now()); }catch(_){}
      });
    }catch(_){}
  }

  /* "VW - VolksWagen Saveiro..." escreve a marca duas vezes e come uma
     linha inteira do título. Tira a sigla da frente quando ela é só o
     apelido do que vem logo depois. Conservador: só corta prefixo curto
     (até 4 letras) seguido de " - ". */
  function _avlModelo(txt){
    var s=String(txt||'').trim();
    var m=s.match(/^([A-Za-zÀ-ÿ\.]{1,4})\s*-\s*(.+)$/);
    return (m && m[2]) ? m[2].trim() : s;
  }

  async function avlCarregar(force){
    if(_avlCache && !force) return _avlCache;
    if(!meuId || !window.supa) return [];
    var out=[], vistos={};
    try{
      var r=await supa.from('avaliacoes')
        .select('placa,payload,criado_em')
        .eq('user_id',meuId)
        .order('criado_em',{ascending:false})
        .limit(300);
      ((r&&r.data)||[]).forEach(function(row){
        var pl=_avlKey(row.placa); if(!pl || vistos[pl]) return;
        vistos[pl]=true;                                   /* fica a mais recente de cada placa */
        var p=row.payload||{};
        if(typeof p==='string'){ try{ p=JSON.parse(p); }catch(_){ p={}; } }
        /* v452: a própria avaliação salva já guarda FIPE, cor e as FOTOS —
           estavam ali desde sempre e a lista nunca leu. Com isto o card se
           basta: não depende do histórico deste aparelho nem de o carro
           estar no estoque. (As fotos vêm como [{url:'...'}].) */
        var _fotos=[];
        try{ _fotos=(p.fotos||[]).map(function(x){ return (x&&x.url)||x; }).filter(function(u){ return typeof u==='string' && u; }); }catch(_){}
        out.push({
          placa: pl,
          ts:    Date.parse(row.criado_em||'')||0,
          modelo:String(p.veiculo||'').trim(),
          ano:   String(p.ano||'').trim(),
          km:    parseInt(String(p.km==null?'':p.km).replace(/\D/g,''),10)||0,
          valor: parseInt(String(p.avaliado==null?'':p.avaliado).replace(/\D/g,''),10)||0,
          fipe:  parseInt(String(p.fipe==null?'':p.fipe).replace(/\D/g,''),10)||0,
          cor:   String(p.cor||'').trim(),
          fotos: _fotos
        });
      });
    }catch(_){ }
    _avlCache=out;
    return out;
  }

  /* completa modelo/ano com o que já está guardado no aparelho */
  function _avlDoHistorico(placa){
    try{ return histLer().filter(function(x){ return _avlKey(x.placa)===placa; })[0]||null; }catch(_){ return null; }
  }

  /* ===== v452 (pedido) — A LISTA VIROU CARD DE ESTOQUE =====
     "tela de avaliações vamos mostrar no mesmo formato do estoque (fotos
     (quando tiver), tamanho do card, quem mandou proposta (repasse), fipe,
     placa, cor, km)".

     Como isto foi feito SEM duplicar desenho: o card é o MESMO
     `.est-card.est-vv-card` do estoque, e o `#avlLista` foi acrescentado à
     lista de contêineres que ligam esse desenho no styles.css. Um card só,
     um CSS só — se o estoque mudar de cara, esta tela muda junto.
     ⚠️ ARMADILHA DA v436, que custou uma versão: `.est-card-dados` (as
     pílulas de ano/km/cor) nasce `display:none` no global e só acende dentro
     de `#estLista,#vendaEstoque,#repMeuLista`. Sem pôr `#avlLista` nessa
     lista, os dados existiriam no HTML e ninguém veria — e o teste passaria.

     DE ONDE VEM CADA COISA (a avaliação salva guarda pouco):
       · foto, cor  → do carro no ESTOQUE com a mesma placa; se não estiver
                      no estoque, do anúncio no REPASSE; senão, sem foto.
       · FIPE, ano  → do histórico da placa já guardado neste aparelho.
       · km, valor  → da própria avaliação.
       · proposta   → das ofertas RECEBIDAS no repasse daquela placa.
     Nada disso consulta API nem gasta token: é tudo coisa que o app já tem. */
  function _avlFonteVeic(placa){
    var out={ fotos:[], cor:'', km:0 };
    try{
      (_estoque||[]).forEach(function(v){
        if(out.fotos.length || _avlKey(v.placa)!==placa) return;
        if(v.fotos && v.fotos.length) out.fotos=v.fotos.slice();
        if(v.cor) out.cor=v.cor;
        if(v.km) out.km=Number(v.km)||0;
      });
    }catch(_){}
    try{
      (_repMeu||[]).forEach(function(r){
        if(out.fotos.length || _avlKey(r.placa)!==placa) return;
        if(r.fotos && r.fotos.length) out.fotos=r.fotos.slice();
        var rv=r.veiculo||{};
        if(!out.cor && rv.cor) out.cor=rv.cor;
        if(!out.km && rv.km) out.km=Number(rv.km)||0;
      });
    }catch(_){}
    return out;
  }
  /* Quem ofertou naquela placa, e por quanto.
     v453 mostrava a ÚLTIMA oferta ("em quanto a conversa está agora").
     v481 (pedido: "melhor valor pago, quem pagou") mostra a MAIOR. Ordeno
     por valor decrescente; empate fica com a mais recente, porque a lista
     já chega do banco em criado_em decrescente e o sort é estável. */
  function _avlPropostas(placa){
    try{
      return (_repOfertasRecebidas||[])
        .filter(function(o){ return _avlKey(o.placa)===placa && String(o.status||'')!=='recusada'; })
        .slice()
        .sort(function(a,b){ return (Number(b.valor)||0)-(Number(a.valor)||0); });
    }catch(_){ return []; }
  }
  /* ===== v507 — A LINHA DE RESUMO (pedido: "o que dá pra melhorar na
     visualização")
     O Estoque já tinha uma faixa de totais; Avaliações não tinha nenhuma, e
     era a primeira pergunta de quem abre a tela ("quantas eu tenho? alguma
     recebeu oferta?"). Reaproveita as classes .est-resumo/.er-cell/.er-n/
     .er-l do estoque de propósito: mesmo desenho, zero CSS novo, e no dia
     em que aquele bloco mudar de cara este muda junto.
     Os números saem SEMPRE do cache inteiro (_avlCache), não da lista
     filtrada — total que encolhe quando se digita na busca não é total. O
     que a busca muda é só a primeira célula, que passa a dizer "3 de 12". */
  /* ⛳ v531 (pedido: "REMOVE O DASHBOARD") — os três números do alto
     (avaliações salvas · com oferta recebida · última avaliação) somem.
     É o MESMO movimento que a v530 fez nos cinco cartões da página Clientes,
     e pela mesma razão: o número que interessa já está no card de cada
     carro, e a faixa empurrava a lista pra baixo da dobra.
     ⚠️ A trava fica na ENTRADA da função, não em quem chama: `avlPinta` a
     invoca a cada letra digitada na busca. Uma trava lá fora precisaria ser
     repetida em todo lugar — e um dia alguém esqueceria um.
     PRA VOLTAR: `AVL_RESUMO_VISIVEL = true`. O motor está intacto. */
  var AVL_RESUMO_VISIVEL = false;
  var AVL_NOVA_VISIVEL   = false;   /* ⛳ v531 — o card "Nova avaliação" (ver telaAvaliacoes) */
  function _avlResumoPinta(mostrando){
    var el=$('avlResumo'); if(!el) return;
    if(!AVL_RESUMO_VISIVEL){ el.style.display='none'; el.innerHTML=''; return; }
    var todas=_avlCache||[];
    if(!todas.length){ el.style.display='none'; el.innerHTML=''; return; }
    var comOferta=0, ult=0;
    todas.forEach(function(a){
      try{ if((_avlPropostas(a.placa)||[]).length) comOferta++; }catch(_){}
      var t=Number(a.ts)||0; if(t>ult) ult=t;
    });
    var filtrando=(mostrando!=null && mostrando!==todas.length);
    function cel(n,l,cls){
      return '<div class="er-cell"><span class="er-n'+(cls?(' '+cls):'')+'">'+esc(String(n))+'</span>'+
             '<span class="er-l">'+esc(l)+'</span></div>';
    }
    el.style.display='';
    el.innerHTML=
      cel(filtrando?(mostrando+' de '+todas.length):todas.length,
          filtrando?'nesta busca':(todas.length===1?'avaliação salva':'avaliações salvas'))+
      cel(comOferta,'com oferta recebida')+
      cel(ult?histData(ult):'—','última avaliação');
  }
  /* v595 (item 3): a data ganha significado — e avisa quando a FIPE do
     card pode ter envelhecido. v713: o aviso desceu de 30 pra 15 dias,
     ficou âmbar e virou ATALHO — tocar nele abre a avaliação direto pra
     reavaliar (o wire está no avlPinta, com stopPropagation). */
  function _avlQuando(ts){
    if(!ts) return '';
    var dias=Math.floor((Date.now()-ts)/864e5);
    var txt;
    if(dias<=0) txt='Avaliada hoje';
    else if(dias===1) txt='Avaliada ontem';
    else if(dias<=30) txt='Avaliada há '+dias+' dias';
    else txt='Avaliada em '+histData(ts);
    if(dias>15) txt+=' <i class="avl-velha">· FIPE pode ter mudado — reavaliar</i>';
    return txt;
  }
  /* um lugar só pra acender o card de situação selecionado */
  function avlChipsPinta(){
    var contagens={cotando:0,comprado:0,vendido:0};
    (_avlCache||[]).forEach(function(a){
      var situacao=avlSituacao(a.placa);
      if(Object.prototype.hasOwnProperty.call(contagens,situacao))contagens[situacao]++;
    });
    Array.prototype.forEach.call(document.querySelectorAll('#avlChips .avl-chip'),function(x){
      var lig=(x.getAttribute('data-chip')||'')===(_avlChip||'');
      x.classList.toggle('on', lig);
      var contador=x.querySelector('.avl-chip-count');
      if(!contador){contador=document.createElement('b');contador.className='avl-chip-count';x.appendChild(contador);}
      contador.textContent=_avlCache===null?'':String(contagens[x.getAttribute('data-chip')]||0);
      x.setAttribute('aria-pressed', lig?'true':'false');   /* v800 §7.1: nunca só a cor */
    });
  }
  /* ==========================================================================
     🔴 v922 §9 — A ARTE DEIXA DE APARECER COM FAIXAS DO LADO
     --------------------------------------------------------------------------
     A área de mídia do card era `aspect-ratio:4/3` FIXA, com `object-fit:
     contain`. Contain é o certo — ele nunca corta nem estica — mas dentro de
     uma caixa 4/3 uma arte quadrada ou 9:16 sobra espaço nos lados: são as
     faixas que o Angelo mostrou no print. O carro fica pequeno no meio de dois
     tarjões da cor do fundo.

     🔑 A CAIXA É QUE PASSA A OBEDECER À CAPA. Quando a primeira foto
     carrega, a gente lê o tamanho REAL dela (naturalWidth/naturalHeight) e
     escreve a proporção numa variável CSS do próprio quadro. A caixa vira do
     tamanho da arte: a imagem ocupa a largura inteira e o `contain` passa a
     não ter sobra nenhuma pra mostrar.

     ⚠️ CONTAIN CONTINUA, E NÃO VIRA COVER. O projeto proíbe as duas saídas
     fáceis: esticar (distorce o carro) e `cover` (corta — e nessa arte o que
     seria cortado são justamente os preços e os textos). Com a caixa na
     proporção certa, contain não deixa sobra; nas OUTRAS fotos do carrossel,
     que quase nunca têm a mesma proporção da capa, ele mostra a foto inteira
     com uma margem — que é o comportamento pedido.

     ⚠️ A ALTURA NÃO PODE PULAR. A proporção é definida UMA VEZ, pela CAPA, e
     não muda ao deslizar entre as fotos: a lista não salta no meio do dedo. E
     enquanto a capa não carregou, vale o 4/3 do CSS — o espaço já está
     reservado, então a lista também não salta no carregamento.

     📌 No computador a altura tem teto (ver styles.css). Uma arte 9:16
     num monitor largo viraria um card de meio metro; ali o contain volta a
     deixar margem, e o projeto aceita isso com todas as letras: "margens
     residuais sao aceitaveis para evitar recortes".
     ========================================================================= */
  function avlCapaProporcao(el){
    var raiz=el||$('avlLista'); if(!raiz) return;
    Array.prototype.forEach.call(raiz.querySelectorAll('.est-thumb'),function(box){
      if(box.classList.contains('no')) return;          /* sem foto: fica no 4/3 */
      if(box.getAttribute('data-ar')) return;           /* já medido */
      var im=box.querySelector('img'); if(!im) return;  /* a CAPA é a primeira */
      /* ====================================================================
         🔴🔴 v1064 — "ENQUADRE MELHOR AS IMAGENS, CENTRALIZAR O VEÍCULO"
         --------------------------------------------------------------------
         ⚠️ ACHEI DUAS COISAS MEDINDO, E A PRIMEIRA É CONSTRANGEDORA:
         esta função lia `naturalWidth/naturalHeight` — e escrevia o literal
         `'1'` na variável. Os dois números só serviam pro `if` e pro
         `data-ar`. Pior: **o CSS nunca leu `--avl-ar`**. O recurso que o
         comentário grande aí em cima descreve ("a caixa passa a obedecer à
         capa") NÃO EXISTIA — código e comentário discordavam desde a v922.

         ⚠️ E o card de hoje nem usa aquela caixa: ele é o `.avl-card-novo`,
         que é **16/9 com `object-fit:cover`** (styles.css ~13875). Ou seja,
         a foto É cortada — e com `object-position:center` o corte tira
         metade em cima e metade embaixo.

         🔑 E É ISSO que o Angelo está vendo. Numa foto de celular 4:3, o
         carro ocupa a METADE DE BAIXO do quadro. Cortar igual em cima e
         embaixo deixa o prédio dominando e o carro rasteiro.
         ✅ Então o corte passa a favorecer a parte de baixo: `center 65%`.

         🔴 MAS SÓ EM FOTO DEITADA, e essa ressalva é o coração da mudança.
         As ARTES que o app gera são quadradas ou em pé, com PREÇO em cima e
         embaixo — puxar o corte pra baixo comeria o texto de cima. Foto de
         carro de celular é deitada (w > h); arte não é. A forma da imagem
         separa os dois casos sem precisar adivinhar de onde ela veio.
         ⚠️ E o 65% É UM PALPITE INFORMADO, não uma medição do carro: ninguém
            aqui detecta veículo na foto. É o ponto que centraliza um carro
            fotografado de pé, de frente ou de lado — o caso normal do pátio.
         ==================================================================== */
      var poe=function(){
        var w=im.naturalWidth||0, h=im.naturalHeight||0;
        if(!w||!h) return;
        box.setAttribute('data-ar', w+'x'+h);
        /* deitada = foto de carro → corta mais do céu/prédio, menos do chão.
           quadrada ou em pé = arte → fica no centro, pra não comer o preço. */
        if(w>h) box.style.setProperty('--avl-pos','center 65%');
        else    box.style.removeProperty('--avl-pos');
      };
      if(im.complete && im.naturalWidth) poe();
      else im.addEventListener('load', poe, { once:true });
      /* deu erro na foto reduzida? o estStripsWire troca pra original e o
         `load` dela cai aqui do mesmo jeito — nada a fazer no erro. */
    });
  }
  function avlPinta(){
    /* v1079: a nuvem dos rascunhos entra UMA vez por sessão e repinta sozinha
       quando responde — por isso a chamada mora aqui, e não num caminho só. */
    try{ avlRascNuvemCarregar(); }catch(_){}
    var el=$('avlLista'); if(!el) return;
    avlChipsPinta();
    /* v1067 — o card da vitrine se repinta junto com os chips. O `avlPinta`
       roda DUAS vezes na abertura (uma na hora, outra quando o portal chega),
       e é justamente por isso que ele é o lugar certo: o card aparece sozinho
       quando o dado chegar, sem cronômetro e sem segundo caminho. */
    try{ vitRepPinta(); vitRepWire(); avlArquivadosPinta(); avlArquivadosWire(); }catch(_){}
    var termo=String(_avlBusca||'').toUpperCase().trim();
    var base=(_avlCache||[]).filter(function(a){ return _avlChip==='arquivado' ? true : avlSituacao(a.placa)!=='arquivado'; });
    var lista=base.filter(function(a){
      /* O card filtra JUNTO com a busca. O `data-chip` é o próprio estado
         devolvido pelo avlSituacao, sem tabela paralela. */
      if(_avlChip && avlSituacao(a.placa)!==_avlChip) return false;
      if(!termo) return true;
      return a.placa.indexOf(termo)>=0 || String(a.modelo||'').toUpperCase().indexOf(termo)>=0;
    });
    lista=avlOrdenar(lista, _avlOrd);   /* v686: ordena o que sobrou do filtro */
    _avlResumoPinta(lista.length);
    /* v800 §7.2 — quantas sobraram, dito em voz alta pra quem não vê a tela */
    (function(){
      var tt=$('avlTotal'); if(!tt) return;
      var n=lista.length, tudo=base.length;
      var filtrando=!!(_avlChip || String(_avlBusca||'').trim());
      tt.textContent = !tudo ? ''
        : filtrando ? (n+' de '+tudo+(tudo===1?' avaliação':' avaliações'))
                    : (n+(n===1?' avaliação':' avaliações'));
    })();
    if(!lista.length){
      /* v800 §11.2 — com filtro ligado, o vazio oferece a SAÍDA. Sem isso o
         lojista vê "Nada encontrado" e não liga o vazio ao chip que ele mesmo
         apertou dois toques atrás. Nenhuma consulta nova é inventada aqui. */
      var temBusca=!!String(_avlBusca||'').trim();
      /* v937 — o vazio nomeia o card ligado e aponta para os outros dois;
         "Todas" não existe mais nem no controle nem no texto de apoio. */
      var _rot=AVL_SIT_ROTULO[_avlChip]||'';
      var _tit = _rot ? ('Nenhuma avaliação em “'+esc(_rot)+'”')
                      : 'Nada encontrado';
      var _sub = _rot ? 'Escolha outro status nos cards acima.'
                      : 'Tente outra placa ou outro modelo.';
      el.innerHTML='<div class="cli-empty">'+
        ((_avlCache&&_avlCache.length)
          ? ('<b>'+_tit+'</b>'+_sub+
             (temBusca?'<button type="button" class="avl-limpar" id="avlLimpar">Limpar busca</button>':''))
          : '<b>Você ainda não salvou nenhuma avaliação</b>Consulte uma placa e avalie o veículo — ela aparece aqui.')+'</div>';
      var lb=$('avlLimpar');
      if(lb) lb.onclick=function(){
        _avlBusca='';
        var bb=$('avlBusca'); if(bb) bb.value='';
        avlPinta();
      };
      return;
    }
    el.innerHTML=lista.map(function(a){
      var h=_avlDoHistorico(a.placa);
      var hv=(h&&h.v)||{};
      var modelo=a.modelo || (h&&h.modelo) || 'Veículo';
      var ano=a.ano || hv.ano_modelo || hv.ano || '';
      var f=_avlFonteVeic(a.placa);
      var cor=a.cor || f.cor || hv.cor || '';
      /* v713: o km digitado no rascunho também conta — antes o chip sumia
         mesmo com a quilometragem escrita na avaliação */
      var km=a.km || f.km || _avlKmDe(a.placa) || Number(hv.km)||0;
      /* a foto da própria avaliação vem primeiro: é a que o vendedor tirou
         daquele carro naquele dia. Estoque e repasse ficam de reserva. */
      var foto=estThumbFotos((a.fotos && a.fotos.length) ? a.fotos : f.fotos, modelo);

      var dados=[];
      if(ano) dados.push('<span>'+_ICO_CAL+esc(String(ano))+'</span>');
      if(km)  dados.push('<span>'+_EST_ICO_KM+km.toLocaleString('pt-BR')+' km</span>');
      if(cor) dados.push('<span>'+_EST_ICO_COR+esc(cor)+'</span>');

      /* ===== v481 — TODO NÚMERO COM RÓTULO =====
         Até a v480 o card mostrava UM número verde grande e sem nome. Na
         prática esse número era SEMPRE a FIPE (conferido no banco: o
         `avaliado` do payload é null em todas as avaliações e o
         `ocultar_preco` é true em todas). Numa tela chamada "Avaliações",
         número sem rótulo é lido como "o que eu avaliei" — e num carro o
         card dizia 67.800 quando o avaliado foi 56.000.
         Agora são até três linhas, cada uma com o nome na frente:
           FIPE           · sempre que existir
           Avaliado       · do rascunho privado (ver _avlAvaliadosCarregar)
           Melhor oferta  · a MAIOR recebida no repasse + quem ofertou */
      var fipeN = a.fipe || Number(hv.fipe) || 0;
      var avalN = _avlValorDe(a.placa,a);   /* v692: o rascunho local também conta */
      var props = _avlPropostas(a.placa);
      var p0    = props[0] || null;

      var linhas='';
      /* v944 — a lista usa os mesmos nomes e o mesmo motor da etapa Avaliado:
         Valor de compra, Venda lojista e Venda varejo. O Avaliex continua
         como referência independente, conforme o padrão da avaliação. */
      var cd=avlCardDe(a.placa);   /* o registro do card (v685) — usado nas 4 linhas */
      var comerciais={lojista:null,varejo:null};
      var compraSugerida=false;
      try{comerciais=avlPrecosDaAvaliacao(Object.assign({},a,{fipe:fipeN}));avalN=comerciais.compra;compraSugerida=comerciais.sugerida;}catch(_){}
linhas+='<div class="avl-precos-principais"><div><span>FIPE</span><b>'+(fipeN?esc(_avlRs(fipeN)):'—')+'</b></div><div><span>Avaliação compra'+(compraSugerida?' (sugerida)':'')+'</span><b class="avl-compra">'+(avalN?esc(_avlRs(avalN)):'—')+'</b></div></div>';
      linhas+='<div class="avl-precos-venda"><div><span>Venda lojista</span><b>'+(comerciais.lojista?esc(_avlRs(comerciais.lojista)):'—')+'</b></div><div><span>Venda varejo</span><b>'+(comerciais.varejo?esc(_avlRs(comerciais.varejo)):'—')+'</b></div></div>';
      if(cd&&cd.valor_avaliex)linhas+='<div class="avl-v"><span>Avaliex</span><b>'+esc(_avlRs(cd.valor_avaliex))+'</b></div>';
      if(p0){
        var quem=String(p0.de_loja_nome||'').trim();
        var mais=props.length>1?(' <i>+'+(props.length-1)+'</i>'):'';
        linhas+='<div class="avl-v of"><span>Melhor oferta</span><b>'+esc(_repDinheiro(p0.valor))+'</b></div>'+
                (quem?('<div class="avl-quem">'+esc(quem)+mais+'</div>'):'');
      }
      if(cd && cd.vendido){
        var vdN=Number(cd.valor_venda)||0, cmN=Number(cd.comissao)||0;
        linhas+='<div class="avl-v sold"><span>Vendido</span><b>'+(vdN?esc(_avlRs(vdN)):'✓')+'</b></div>'+
          (cmN?('<div class="avl-menos ok">comissão <b>'+esc(_avlRs(cmN))+'</b></div>'):'')+
          /* v718: quem comprou, no mesmo desenho do "quem ofertou" */
          (cd.comprador?('<div class="avl-quem">'+esc(String(cd.comprador))+'</div>'):'');
      }
      /* v721: o ✎ saiu do card — a edição dos valores mora no MENU do card
         (toque no card → Valores do card). Um caminho só. */

      var cli=(_avlCli&&_avlCli[a.placa])
        ? ('<div class="est-meta"><span class="est-rep">'+_AVL_ICO_PESSOA+esc(_avlCli[a.placa])+'</span></div>') : '';

      /* v595 (item 4): etiqueta de situação — funil de compra com dados que
         a tela JÁ tem em memória (estilo etiqueta do CRM v529: NÃO navega).
         Prioridade: Comprado > No repasse > Oferta R$ X. */
      var sit='';
      try{
        /* v713 (desfecho): o que ELE marcou no menu vence o deduzido — a
           etiqueta verde reusa a classe do Comprado (v390). v718: a venda
           marcada no menu vem primeiro de tudo. */
        /* 🔴 v922 — O SELO E O FILTRO LEEM A MESMA FUNÇÃO.
           As palavras na tela não mudaram (o "Comprei ✓" de quem marcou à mão
           continua diferente do "Comprado" de quem só apareceu no estoque —
           são informações diferentes e o projeto pede pra não reescrever
           dado de negociação só pra trocar rótulo). O que mudou é QUEM decide:
           antes esta cascata era a segunda opinião da tela sobre a situação;
           agora ela só VESTE a resposta do avlSituacao.
           ⚠️ "No repasse" e "Oferta" continuam por último, e só sobram pra
           quem está em 'cotando' — são complemento, nunca situação. */
        var _sit=avlSituacao(a.placa);
        if(_sit==='vendido') sit='<span class="avl-sit comprado">Vendido ✓</span>';
        else if(_sit==='comprado') sit='<span class="avl-sit comprado">'+((cd&&cd.desfecho==='comprei')?'Comprei ✓':'Comprado')+'</span>';
        else if(_sit==='nao') sit='<span class="avl-sit nao">Não fechou</span>';
        else if(_sit==='arquivado') sit='<span class="avl-sit arquivado">Arquivado</span>';
        else if(p0) sit='<span class="avl-sit oferta">Oferta '+esc(_repDinheiro(p0.valor))+'</span>';
      }catch(_){}
      /* ======================================================================
         🔴 v1066 — A ETIQUETA "REDE DE REPASSE" (pedido do Angelo:
         "adicione uma etiqueta 'rede de repasse' todos veiculos que estao
          anunciados pra repassar")
         ----------------------------------------------------------------------
         ⚠️ ELA SAIU DA CASCATA DE PROPÓSITO, e essa é a mudança inteira.
         Antes, "No repasse" era o QUARTO `else if`: só aparecia em quem ainda
         estava em 'cotando'. Um carro Comprado e anunciado na rede mostrava
         só "Comprado" — a etiqueta que o Angelo quer era justamente a que
         a cascata comia. "TODOS os veículos anunciados pra repassar" não cabe
         num else-if; cabe numa etiqueta PRÓPRIA, que soma em vez de disputar.

         🔑 E são duas informações diferentes, por isso duas etiquetas:
            · a SITUAÇÃO diz onde a negociação está (Cotando/Comprado/Vendido);
            · a REDE diz por onde o carro está sendo oferecido.
         Um carro pode estar Comprado E anunciado. Antes a tela não sabia
         dizer isso.
         ⚠️ Visual diferente também (classe `rede`, contornada): duas pílulas
            azuis idênticas lado a lado leriam como uma coisa só.
         ====================================================================== */
      var redeEt='';
      try{
        if((_repMeu||[]).some(function(r){ return _avlKey(r.placa)===a.placa; }))
          redeEt='<span class="avl-sit rede">Rede de repasse</span>';
      }catch(_){}
      /* v800 §8.6 — o card já era clicável e não era alcançável por teclado:
         role/tabindex e Enter/espaço fazem o mesmo que o toque. */
      /* 🔴 v1079 — "Avaliado" no lugar de "Cotando" quando já existe número.
         A situação continua 'cotando' (ver a nota lá em cima) — o que muda
         aqui é só a PALAVRA que o card mostra. */
      if(!sit){
        sit = _avlAvaliado(a.placa)
          ? '<span class="avl-sit avaliado">Avaliado</span>'
          : '<span class="avl-sit repasse">Cotando</span>';
      }
      return '<div class="est-card est-vv-card avl-card-novo" data-placa="'+esc(a.placa)+'" role="button" tabindex="0" '+
        'aria-label="'+esc(_avlModelo(modelo))+' — placa '+esc(a.placa)+', abrir ações">'+
        /* v695 — o compartilhar no canto do card (pedido; stopPropagation v305) */
        /* v800 §8.3/§13 — o nome acessível diz QUAL veículo. Numa lista de
           vinte cards, vinte botões chamados "Compartilhar página do lojista"
           são vinte botões idênticos pra quem navega por leitor de tela. */
        foto+
        '<div class="est-tx"><div class="avl-etiquetas">'+sit+redeEt+'</div><div class="est-nm">'+esc(_avlModelo(modelo))+'</div>'+
        '<div class="est-card-placa">'+esc(a.placa)+'</div>'+
        (dados.length?('<div class="est-card-dados">'+dados.join('')+'</div>'):'')+
        cli+
        '<div class="avl-valores">'+linhas+'</div>'+
        /* ==================================================================
           🔴 v919 (§6.4) — O RODAPÉ DO CARD: SITUAÇÃO + "ABRIR AVALIAÇÃO"
           ------------------------------------------------------------------
           O projeto pede a ação "Abrir avaliação" no card. Ela virou um BOTÃO
           de verdade, e isso é decisão, não enfeite: desde a v695 tocar no
           corpo do card abre o MENU (editar, ver página do lojista, excluir).
           Escrever "Abrir avaliação" e entregar um menu seria um rótulo que
           mente. Então o corpo continua abrindo o menu — e este botão, com o
           mesmo `stopPropagation` do compartilhar (v305), vai DIRETO pro
           formulário, que é o caminho que a frase promete.
           ⚠️ A data continua sendo o `_avlQuando` de sempre (com o aviso âmbar
           da FIPE velha da v713 embutido); o que mudou foi o lugar. */
        '<div class="avl-data est-meta">'+_avlQuando(Number(a.ts)||0)+'</div><div class="avl-rodape">'+
          '<button type="button" class="avl-abrir" data-abrir="'+esc(a.placa)+'" '+
            'aria-label="Abrir a avaliação de '+esc(_avlModelo(modelo))+' — placa '+esc(a.placa)+'">'+
            'Abrir avaliação'+_AVL_ICO_SETA+'</button>'+
          (_avlChip==='arquivado'?'':'<button type="button" class="avl-share" data-share="'+esc(a.placa)+'" title="Compartilhar" aria-label="Compartilhar '+esc(a.placa)+'">'+_AVL_ICO_SHARE+'</button>')+
          '<button type="button" class="avl-menu-card" data-menu="'+esc(a.placa)+'" title="Mais opções" aria-label="Mais opções de '+esc(a.placa)+'">'+_HA_ICO.menu+'</button>'+
        /* ⚠️ TRÊS `</div>`: o rodapé, a `.est-tx` e o `.est-card`. O primeiro
           rascunho fechou só dois, e o card seguinte nasceu DENTRO deste —
           oito cards encaixados um no outro, cada um 20px mais estreito, com
           o último a 3.500 px de distância. Na tela isso não gritava: os
           cards apareciam quase certos. Quem pegou foi o teste-v800 pela
           rolagem lateral a 768 px. */
        '</div></div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card[data-placa]'),function(it){
      /* v695 (pedido): o toque no card abre um MENU — editar avaliação,
         ver página do lojista, excluir — em vez de ir direto pro formulário */
      it.onclick=function(){ avlCardMenu(it.getAttribute('data-placa')); };
      it.onkeydown=function(e){
        if(e.key!=='Enter' && e.key!==' ' && e.key!=='Spacebar') return;
        if(e.target!==it) return;                 /* o share tem o teclado dele */
        e.preventDefault(); avlCardMenu(it.getAttribute('data-placa'));
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('.avl-share'),function(b){
      b.onclick=function(e){ try{ e.preventDefault(); e.stopPropagation(); }catch(_){} avlCompartilhar(b.getAttribute('data-share')); };
    });
    Array.prototype.forEach.call(el.querySelectorAll('.avl-menu-card'),function(b){b.onclick=function(e){e.preventDefault();e.stopPropagation();avlCardMenu(b.getAttribute('data-menu'));};});
    /* v919 — o "Abrir avaliação" do rodapé: mesmo cuidado do compartilhar */
    Array.prototype.forEach.call(el.querySelectorAll('.avl-abrir'),function(b){
      b.onclick=function(e){ try{ e.preventDefault(); e.stopPropagation(); }catch(_){} avlAbrir(b.getAttribute('data-abrir')); };
    });
    /* v685 → v721: o ✎ saiu do card (a edição mora no menu) — o wire dele
       saiu junto. O avlCardEditar continua vivo, chamado pelo menu. */
    /* v713 — o aviso âmbar da idade é atalho: toca e a avaliação abre pra
       reavaliar (mesmo cuidado do stopPropagation dos outros botões, v305) */
    Array.prototype.forEach.call(el.querySelectorAll('.avl-velha'),function(s){
      s.onclick=function(e){
        try{ e.preventDefault(); e.stopPropagation(); }catch(_){}
        var c=s.closest?s.closest('.est-card'):null;
        if(c) avlAbrir(c.getAttribute('data-placa'));
      };
    });
    /* v452: a tira de fotos do card do estoque só desliza depois de ligada —
       é a mesma função que o estoque chama, não uma cópia. */
    try{ if(typeof estStripsWire==='function') estStripsWire(el); }catch(_){}
    try{ avlCapaProporcao(el); }catch(_){}   /* v922 §9 */
  }
  /* ===== v453 — O CAMPO DE PLACA DA PÁGINA AVALIAÇÕES =====
     Copia o COMPORTAMENTO da home, não o código: espera meio segundo depois
     de uma placa válida (pra dar tempo de corrigir), Enter também vale, e
     então entrega pro `buscarPlaca()` de sempre.

     ⚠️ Passa pelo `voltarHome()` de propósito. O `buscarPlaca()` lê o
     `#placa`, escreve no `#fipeMsg` e liga a `.busca-card` — três elementos
     que moram na tela inicial. Chamado de dentro de uma tela interna, ele
     consultaria de verdade mas o anel de "consultando…" ficaria rodando
     atrás de uma tela escondida, e a pessoa acharia que o app travou.
     É o mesmo caminho que o "Atualizar pesquisa" do histórico já usa. */
  var _avlPlacaT=null;
  function avlPlacaIr(){
    var el=$('avlPlaca'); if(!el) return;
    /* v882 — era a regex copiada aqui dentro. Agora usa a `valida()` do
       01-nucleo, a mesma do campo da home e da trava. Uma regra, um lugar. */
    var p=String(el.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!valida(p)) return;
    if(_avlPlacaT){ clearTimeout(_avlPlacaT); _avlPlacaT=null; }
    el.value='';
    try{ voltarHome(); }catch(_){}
    var alvo=$('placa'); if(alvo) alvo.value=p;
    try{ buscarPlaca(); }catch(_){}
  }
  function avlPlacaWire(){
    var el=$('avlPlaca'); if(!el) return;
    /* 🔴 v882 — a MESMA trava do campo da home (`placaLigar`, no 01-nucleo).
       Antes este campo tinha a regra copiada aqui dentro — a mesma regex, à
       mão, num arquivo diferente. Regra copiada é regra que envelhece sozinha:
       quando a de lá mudasse, esta ficaria pra trás sem ninguém perceber. */
    try{ placaLigar(el); }catch(_){}
    el.addEventListener('input',function(){
      if(_avlPlacaT){ clearTimeout(_avlPlacaT); _avlPlacaT=null; }
      _avlPlacaT=setTimeout(avlPlacaIr, 550);
    });
    el.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); avlPlacaIr(); } });
  }
  var _AVL_ICO_LUPA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
  var _AVL_ICO_PESSOA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';

  /* abre a avaliação A PARTIR DA PLACA — o mesmo caminho de sempre */
  function avlAbrir(placa){
    var h=_avlDoHistorico(_avlKey(placa));
    if(h && h.v){
      veiculoAtual=h.v; histFonteTs=h.ts;
      fichaState=h.ficha||null; fichaTecState=h.fichaTec||null; leilaoState=h.leilao||null;
      try{ verAplicar(veiculoAtual); }catch(_){}
      abrirAvaliacaoLojista();
      /* v401 (pedido): quem veio da LISTA de avaliações volta pra ela (a
         setinha e o deslize usam o mesmo voltarTab) */
      try{ voltarTab(window.edicaoAtual&&window.edicaoAtual()==='avalia'?voltarHome:telaAvaliacoes); }catch(_){}
      _avVoltarPara='avaliacoes';   /* v719: o Salvar e fechar também volta pra lista */
      return;
    }
    /* v697 — A AVALIAÇÃO ABRE MESMO SEM O HISTÓRICO DESTE APARELHO.
       O Angelo importou o laudo no computador e tocou "Editar avaliação" no
       celular: caía na tela de consulta, como se a avaliação não existisse.
       Mas o CARD já tem o carro (modelo, ano, FIPE, cor — do payload salvo):
       monta um veiculoAtual LEVE e abre — o MESMO caminho do import do
       Avaliex (item 6-f), e a mesma regra: NENHUMA consulta paga dispara.
       O rascunho da nuvem preenche os campos ao abrir, como sempre. */
    var aLeve=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===_avlKey(placa); })[0]||null;
    if(aLeve){
      var mNm=String(aLeve.modelo||'').match(/^([^-]+)-\s*(.+)$/);
      veiculoAtual={ placa:_avlKey(placa),
        marca:(mNm?mNm[1]:'').trim(), modelo:(mNm?mNm[2]:String(aLeve.modelo||'')).trim(),
        ano:aLeve.ano||'', ano_fab:aLeve.ano||'', ano_modelo:aLeve.ano_modelo||aLeve.ano||'',
        cor:aLeve.cor||'', combustivel:'', fipe:Number(aLeve.fipe)||0 };
      histFonteTs=null; fichaState=null; fichaTecState=null; leilaoState=null;
      try{ abrirAvaliacaoLojista(); }catch(_){ toast('Não consegui abrir a avaliação.'); return; }
      try{ voltarTab(window.edicaoAtual&&window.edicaoAtual()==='avalia'?voltarHome:telaAvaliacoes); }catch(_){}
      _avVoltarPara='avaliacoes';   /* v719: o Salvar e fechar também volta pra lista */
      toast('Aberta sem consulta — a ficha completa vem quando você consultar a placa.');
      return;
    }
    /* placa que não está em lugar NENHUM deste aparelho: não consulto por
       conta própria (gastaria do seu saldo) — deixo no campo pra você decidir. */
    voltarHome();
    /* v585: escrever + focus() apagava a placa na mesma linha (o ouvinte de
       focus do 01 limpa o campo). plDevolver() levanta a marca que o focus
       respeita — agora a placa FICA, como o comentário acima sempre prometeu. */
    var pi=$('placa'); if(pi){ plDevolver(placa); try{ pi.focus(); }catch(_){} }
    toast('Consulte a placa '+placa+' para abrir a avaliação.');
  }

  async function telaAvaliacoes(modo){
    var soArquivados=modo==='arquivados';
    avAreaMarcar('avaliacoes');
    mevTabSet('');
    /* ==========================================================================
       🔴 v919 — O TOPO DA PÁGINA (PROJETO-2026-09-06, §6)
       --------------------------------------------------------------------------
       O diagnóstico do projeto (§5), item por item, e o que mudou:

         · "Importar" e "Nova avaliação" empilhados, com larguras diferentes,
           sem dizer qual é a ação principal → viraram UMA linha de duas
           colunas (≈55/45): "Nova avaliação" cheia, azul, primária; "Importar"
           ao lado, contornada, secundária. Hierarquia é o desenho dizendo por
           onde se começa.
         · busca, botões e filtros comendo a altura antes do primeiro carro →
           a busca ganhou a linha inteira e os filtros foram consolidados.

       🔴 v937 atualiza esse topo: remove "Todas", transforma Cotando,
       Comprados e Vendidos em cards abaixo das ações, move a busca para
       depois deles e remove o cabeçalho/contagem "Avaliações recentes".

       ⚠️ O "Importar" mostra só "Importar" (§6.2) mas o NOME ACESSÍVEL continua
       dizendo de onde vem: quem usa leitor de tela ouviria "Importar" e não
       saberia importar o quê.
       ⚠️ O `#avlResumo` continua no DOM, escondido: o `_avlResumoPinta` procura
       por ele e o `AVL_RESUMO_VISIVEL` (false desde a v531) é o interruptor de
       trazê-lo de volta. Tirar o elemento transformaria um interruptor numa
       reescrita.
       ⚠️ E NÃO ENTROU UM BOTÃO DE "FILTROS" ao lado da busca, apesar de o
       mockup ter um. Ele abriria um painel com as MESMAS quatro opções que os
       chips já mostram uma linha abaixo, sempre visíveis: um degrau a mais
       pra chegar no mesmo lugar, e mais altura antes do primeiro carro — que
       é exatamente o defeito que o §5 manda consertar. É a mesma lição da
       v918 no histórico. Se um dia os filtros crescerem a ponto de não caber
       na faixa, aí o botão passa a servir pra alguma coisa.
       ========================================================================== */
    var cab=edicaoAtual()==='avalia'?'':panelHead(ICO_AV,'blue',soArquivados?'Arquivados':'Avaliações',soArquivados?'Cotações guardadas para consultar novamente':'Consulte, avalie e acompanhe seus veículos');
    irTela(cab+
      /* ⛳ v531/v919 — o card da placa desta página continua desligado
         (AVL_NOVA_VISIVEL=false). Quando ligado, ele entra ACIMA das ações,
         em linha cheia: a grade de duas colunas da v507 existia pra ele
         dividir a faixa com a busca, e essa faixa não existe mais.
         O `avlPlacaWire`/`avlPlacaIr` continuam inteiros. */
      (AVL_NOVA_VISIVEL?(
      '<div class="card busca-card avl-placa-card">'+
        '<div class="plc-panel-head"><span class="ico blue">'+_AVL_ICO_LUPA+'</span>'+
          '<div><h2>Nova avaliação</h2><p>Digite a placa do veículo para começar</p></div></div>'+
        '<div class="placa-wrap"><input id="avlPlaca" class="placa-big" placeholder="ABC1D23" maxlength="8" autocomplete="off" autocapitalize="characters" spellcheck="false"></div>'+
        '<div class="busca-bar"><i></i></div>'+
      '</div>'):'')+
      /* §6.2 — as duas ações, com dono: o 05c põe a primária e o 05i põe a
         secundária, os dois pelo mesmo endereço (#avlAcoes). */
      (soArquivados?'<div class="avl-arq-topo"><button type="button" id="avlArqVoltar" class="avl-arq-voltar">'+_AVL_ICO_SETA+'<span>Voltar às avaliações</span></button><div><h2>Cotações arquivadas</h2><p>Pesquise, abra ou restaure uma cotação sem refazer a consulta.</p></div></div>':'<div class="avl-acoes" id="avlAcoes"></div>')+
      '<div class="est-resumo" id="avlResumo" style="display:none"></div>'+
      /* v937 — três cards de situação imediatamente abaixo das ações. O
         estado é exclusivo, textual e também comunicado por aria-pressed. */
      (soArquivados?'':'<div class="avl-chips" id="avlChips" role="group" aria-label="Filtrar por situação">'+
        '<button type="button" class="avl-chip avl-status-card on" data-chip="cotando" aria-pressed="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span>Cotando</span></button>'+
        '<button type="button" class="avl-chip avl-status-card" data-chip="comprado" aria-pressed="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 12.5l-4 4a2.1 2.1 0 0 1-3 0l-1-1"/><path d="M3 10l3.5-3.5a2 2 0 0 1 2.8 0L13 10l-2 2a1.5 1.5 0 0 1-2.1 0L7 10"/><path d="M13 10l3-3 5 5"/></svg><span>Comprados</span></button>'+
        '<button type="button" class="avl-chip avl-status-card" data-chip="vendido" aria-pressed="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/></svg><span>Vendidos</span></button>'+
        /* 🔴 v1077 — O CARD DA VITRINE ENTROU AQUI DENTRO, como QUARTO card
           da mesma linha (pedido do Angelo, com print). Na v1067 ele ficava
           logo ABAIXO deste bloco, num painel largo com tira de fotos.
           A linha é um grid de quatro colunas desde a v937 e a quarta estava
           vazia — ele ocupou um lugar que já existia.
           ⚠️ Ele NÃO é um filtro: não tem `.avl-chip` nem `aria-pressed`, e
              por isso o `avlChipsPinta()` passa por ele sem tocar. O bloco
              inteiro mora no 05m-vitrine-repasse.js; aqui fica só a porta. */
        vitRepCardHtml()+avlArquivadosCardHtml()+
      '</div>')+
      /* A busca vem depois dos cards, como uma segunda etapa visual. */
      '<div class="hh-search avl-busca-linha" id="avlSearch"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>'+
        '<input id="avlBusca" class="hh-busca" placeholder="Buscar placa ou modelo" aria-label="Buscar placa ou modelo" autocomplete="off" autocapitalize="characters"></div>'+
      /* v937 — título e contagem visual saíram; ordenar permanece sozinho. */
      '<div class="avl-sec avl-sec-so-ordem">'+
        '<span id="avlTotal" role="status" aria-live="polite"></span>'+
        '<select id="avlOrd" class="avl-ord" aria-label="Ordenar as avaliações">'+
          AVL_ORDENS.map(function(o){ return '<option value="'+o[0]+'">'+o[1]+'</option>'; }).join('')+
        '</select>'+
      '</div>'+
      '<div id="avlLista"></div>','home');
    /* 🔴 v795 — A MARCA VEM AQUI, DEPOIS DO irTela(), e não no começo da
       função: o irTela() e o mevTabSet() limpam as classes de página no meio
       do caminho (é o trabalho deles). Marcar antes era marcar e perder.
       Ver o changelog da v795. */
    document.body.classList.add('oper-on');
    try{ consultaUiDockMedir(); }catch(_){ }
    document.body.classList.remove('md-veiculo');   /* é lista, não resultado de placa */
    /* v401 (pedido): sem o rótulo "Nova consulta" no alto */
    try{ var _th=document.querySelector('#secoes .tela-head'); if(_th) _th.parentNode.removeChild(_th); }catch(_){}
    var el=$('avlLista'); if(el) el.innerHTML=pgLoad('Abrindo suas avaliações…');   /* v424: anel da abertura no lugar do texto seco */
    var b=$('avlBusca'); if(b) b.oninput=function(){ _avlBusca=this.value; avlPinta(); };
    /* v937: os três cards são exclusivos e a tela abre em Cotando. */
    _avlChip=soArquivados?'arquivado':'cotando';
    /* v686: o seletor de ordem — memória só, como os chips */
    _avlOrd='recentes';
    (function(){ var o=$('avlOrd'); if(o){ o.value=_avlOrd; o.onchange=function(){ _avlOrd=this.value; avlPinta(); }; } })();
    /* Card ativo não desliga ao ser tocado novamente: sem "Todas", a página
       deve ter sempre uma situação selecionada. */
    avlChipsPinta();
    Array.prototype.forEach.call(document.querySelectorAll('#avlChips .avl-chip'),function(c){
      c.onclick=function(){
        var k=c.getAttribute('data-chip')||'';
        _avlChip=k;
        avlChipsPinta();
        avlPinta();
      };
    });
    avlPlacaWire();
    var _arqVoltar=$('avlArqVoltar'); if(_arqVoltar) _arqVoltar.onclick=function(){ telaAvaliacoes(); };
    /* ============================================================================
     🔴 v893 — "NOVA AVALIAÇÃO", AO LADO DO IMPORTAR (pedido do Angelo, 04/09)
     ----------------------------------------------------------------------------
     "Adicione um botão pra iniciar uma nova avaliação a partir de uma placa que
     já tem no histórico (ou uma nova placa), ao lado do importar do Avaliex."

     Ele se insere ao lado do `#avxBtn`, pela mesma técnica do 05i — a tela de
     Avaliações não precisa saber que ele existe.

     ⚠️ E ELE NÃO INVENTA AVALIAÇÃO DO NADA. Uma avaliação precisa do veículo:
     modelo, ano, FIPE. Placa que JÁ ESTÁ no histórico tem tudo isso guardado —
     abre direto, sem consultar de novo e sem gastar. Placa NOVA não tem: ela
     vai pro campo da home e a consulta acontece pelo caminho de sempre, que é
     onde o custo está escrito na tela. Atalho que consulta escondido é atalho
     que gasta escondido.
     ============================================================================ */
  function avlNovaWire(){
    /* v919 — a casa virou a linha de ações (#avlAcoes) e ele é o PRIMÁRIO.
       ⚠️ Ele entra SEMPRE em primeiro lugar, mesmo que o Importar (05i) já
       tenha chegado: quem define a hierarquia é a ordem na linha, e ela não
       pode depender de qual dos dois módulos rodou antes. */
    var casa=$('avlAcoes') || document.querySelector('.avl-topo-lado');
    if(!casa) return;
    if($('avlNovaBtn')) return;
    var bt=document.createElement('button');
    bt.type='button'; bt.id='avlNovaBtn'; bt.className='avl-acao avl-acao-1';
    bt.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg><span>Nova avaliação</span>';
    /* v1418 — não passar avlNovaAbrir direto: o onclick entrega o MouseEvent
       como primeiro argumento, e a folha o confundia com um veículo manual
       vindo da busca FIPE. Resultado: mostrava "Iniciar avaliação" e pulava
       a consulta da placa. Clique comum abre sempre o modo Nova placa. */
    bt.onclick=function(){ avlNovaAbrir(); };
    casa.insertBefore(bt, casa.firstChild);
  }
  /* ==========================================================================
     🔴 v919 — A FOLHA "NOVA AVALIAÇÃO" (PROJETO-2026-09-06, §4)
     --------------------------------------------------------------------------
     O QUE ELA ERA (v893): um popover com o campo da placa espremido ao lado de
     um botão "Consultar" que comia a linha, e logo abaixo o histórico inteiro
     como uma lista de texto, sem busca. Os dois caminhos disputavam a mesma
     tela, e a pergunta que a pessoa faz ao abrir — "por onde eu começo?" —
     ficava sem resposta.

     🔑 A DECISÃO CENTRAL É A SEPARAÇÃO, e ela é o que o teste protege: DOIS
     caminhos, um de cada vez, num controle segmentado. Placa nova é uma
     consulta que custa; veículo do histórico abre de graça. São coisas
     diferentes e agora ficam em abas diferentes — quem escolhe é o dedo, não
     a rolagem.

     ⚠️ NENHUM MOTOR NOVO. A placa nova continua indo pro `buscarPlaca()` de
     sempre (pela home, que é onde o custo está escrito na tela); o veículo do
     histórico continua entrando pelo `histAcaoExec(placa,'aval')`, o MESMO
     caminho do menu do card. A câmera é o `#btnFotoFab` que já existe. Aqui
     só mudou a montagem.

     ⚠️ E ELA NÃO É UM `_popAbrir`. O popover é ancorado e pequeno — serve pra
     menu de três pontos, não pra uma folha com abas e lista rolável. Em vez de
     alargar o `_popAbrir` (e mexer em TODOS os menus do app que dependem
     dele), esta folha monta o próprio miolo dentro do MESMO `.act-bg#actSheet`
     que o resto do app usa. Assim o `actSheetFechar()` — e todo mundo que o
     chama — continua fechando ela sem saber que ela existe.
     ========================================================================== */
  var _AVL_SH_ICO={
    prancheta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M12 11v6M9 14h6"/></svg>',
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    mais:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 12h18M12 3v18"/></svg>',
    relogio:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/></svg>',
    cam:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    info:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></svg>',
    escudo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    lupa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>',
    seta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    chev:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>'
  };
  var _AVL_SH_MOSTRA=5;   /* §4.4: "até quatro ou cinco resultados" antes do "ver todo" */
  function avlNovaAbrir(manualInicial){
    try{ actSheetFechar(); }catch(_){}
    /* o histórico inteiro fica na memória da folha; a busca peneira ele */
    function histTodos(){
      var l=[];
      try{ l=(histLer()||[]).slice(0,40); }catch(_){ l=[]; }
      try{ fipeModeloHistLer().forEach(function(x){ l.push({manual:true,chave:x.chave,placa:'',modelo:x.modelo||'Veículo',ts:x.ts||0,v:x.v||{},_fm:x}); }); }catch(_){}
      return l.sort(function(a,b){return (b.ts||0)-(a.ts||0);}).slice(0,40);
    }
    var hist=histTodos(), manualEscolhida=null;

    var bg=document.createElement('div');
    bg.className='act-bg avl-sh-bg'; bg.id='actSheet';
    bg.innerHTML=
      '<section class="avl-sh" role="dialog" aria-modal="true" aria-labelledby="avlShTit">'+
        '<span class="avl-sh-alca" aria-hidden="true"></span>'+
        /* 🔴🔴 UM `<div>`, NÃO UM `<header>` — e isto custou uma reprovação
           do teste pra aparecer. O app tem, desde sempre, uma regra global
           `body.app-on header{display:none}` (styles.css) que existe pra
           esconder o cabeçalho azul antigo. Ela não pergunta ONDE o `<header>`
           está: qualquer um, em qualquer profundidade, some. O cabeçalho desta
           folha — ícone, título, apoio e o botão Fechar — nascia invisível.
           ⚠️ E ele nascia invisível SEM ERRO NENHUM: o `textContent` do título
           continuava lá, o `querySelector` achava tudo. Quem pegou foi a
           medição de 44 × 44 do botão Fechar, que voltou 0 × 0. É a lição do
           `_teste-comum.js` inteira: conferir a regra não é conferir o dedo. */
        '<div class="avl-sh-head">'+
          '<span class="avl-sh-ico" aria-hidden="true">'+_AVL_SH_ICO.prancheta+'</span>'+
          '<span class="avl-sh-copy"><h2 id="avlShTit">Nova avaliação</h2><p>Como você deseja começar?</p></span>'+
          '<button type="button" class="avl-sh-x" id="avlShX" aria-label="Fechar">'+_AVL_SH_ICO.x+'</button>'+
        '</div>'+
        /* ⚠️ tablist de verdade: o estado selecionado é dito pelo
           `aria-selected`, não só pela cor do fundo (§8). */
        '<div class="avl-sh-tabs" role="tablist" aria-label="Origem do veículo">'+
          '<button type="button" role="tab" id="avlTabNova" class="avl-sh-tab on" data-tab="nova" aria-selected="true" aria-controls="avlPanNova">'+_AVL_SH_ICO.mais+'<span>Nova placa</span></button>'+
          '<button type="button" role="tab" id="avlTabHist" class="avl-sh-tab" data-tab="hist" aria-selected="false" aria-controls="avlPanHist" tabindex="-1">'+_AVL_SH_ICO.relogio+'<span>Do histórico</span></button>'+
        '</div>'+
        '<div class="avl-sh-corpo">'+
          '<div class="avl-sh-pan" id="avlPanNova" role="tabpanel" aria-labelledby="avlTabNova">'+
            '<label class="avl-sh-lbl" for="avlNovaPlaca">Placa</label>'+
            '<div class="avl-sh-linha">'+
              '<div class="placa-wrap avl-sh-placa">'+
                '<input id="avlNovaPlaca" class="placa-big" maxlength="7" inputmode="text" enterkeyhint="search" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="ABC1D23" aria-describedby="avlNovaAjuda">'+
                '<button type="button" class="plc-lupa" id="avlNovaBuscar" disabled aria-label="Buscar esta placa" title="Buscar esta placa">'+_AVL_SH_ICO.lupa+'</button>'+
              '</div>'+
              '<button type="button" class="avl-sh-cam" id="avlNovaCam" aria-label="Ler placa por foto">'+_AVL_SH_ICO.cam+'</button>'+
            '</div>'+
            /* §8: o erro é ligado ao campo por aria-describedby (o JS acrescenta
               o id quando ele aparece) e some assim que a pessoa corrige */
            '<p class="avl-sh-erro" id="avlNovaErro" role="alert" hidden></p>'+
            '<p class="avl-sh-ajuda" id="avlNovaAjuda">'+_AVL_SH_ICO.info+'<span>Digite a placa ou use a câmera. Você verá os dados e o custo antes de confirmar a consulta.</span></p>'+
            '<button type="button" class="avl-sh-cta" id="avlNovaIr" disabled><span id="avlNovaIrTx">Consultar e continuar</span>'+_AVL_SH_ICO.seta+'</button>'+
            '<p class="avl-sh-seguro">'+_AVL_SH_ICO.escudo+'<span>A avaliação só será criada depois que você confirmar o veículo encontrado.</span></p>'+
          '</div>'+
          '<div class="avl-sh-pan" id="avlPanHist" role="tabpanel" aria-labelledby="avlTabHist" hidden>'+
            '<label class="avl-sh-busca">'+_AVL_SH_ICO.lupa+
              '<input id="avlNovaBusca" placeholder="Buscar placa ou modelo" aria-label="Buscar placa ou modelo" autocomplete="off" autocapitalize="characters">'+
            '</label>'+
            '<p class="avl-sh-nota">'+_AVL_SH_ICO.escudo+'<span>Veículos já consultados abrem sem nova cobrança</span></p>'+
            '<div class="avl-sh-lista" id="avlNovaLista"></div>'+
          '</div>'+
        '</div>'+
      '</section>';
    document.body.appendChild(bg);
    bg.addEventListener('click',function(e){ if(e.target===bg) actSheetFechar(); });
    var xb=$('avlShX'); if(xb) xb.onclick=function(){ actSheetFechar(); };
    function esc1(e){ if(e.key==='Escape'){ try{ document.removeEventListener('keydown',esc1); }catch(_){} actSheetFechar(); } }
    document.addEventListener('keydown',esc1);

    /* ---------------- as duas abas ---------------- */
    function aba(qual){
      Array.prototype.forEach.call(bg.querySelectorAll('.avl-sh-tab'),function(t){
        var on=t.getAttribute('data-tab')===qual;
        t.classList.toggle('on',on);
        t.setAttribute('aria-selected', on?'true':'false');
        t.tabIndex = on?0:-1;
      });
      var pn=$('avlPanNova'), ph=$('avlPanHist');
      if(pn) pn.hidden=(qual!=='nova');
      if(ph) ph.hidden=(qual!=='hist');
      if(qual==='hist'){ histPinta(($('avlNovaBusca')||{}).value||''); var bq=$('avlNovaBusca'); if(bq) setTimeout(function(){ try{ bq.focus(); }catch(_){} },30); }
      else { var pc=$('avlNovaPlaca'); if(pc) setTimeout(function(){ try{ pc.focus(); }catch(_){} },30); }
    }
    Array.prototype.forEach.call(bg.querySelectorAll('.avl-sh-tab'),function(t){
      t.onclick=function(){ aba(t.getAttribute('data-tab')); };
      /* setas navegam entre as abas, como manda um tablist */
      t.onkeydown=function(e){
        if(e.key!=='ArrowRight' && e.key!=='ArrowLeft') return;
        e.preventDefault();
        aba(t.getAttribute('data-tab')==='nova'?'hist':'nova');
        var alvo=bg.querySelector('.avl-sh-tab.on'); if(alvo) alvo.focus();
      };
    });

    /* ---------------- aba 1: placa nova ---------------- */
    var campo=$('avlNovaPlaca'), busca=$('avlNovaBuscar'), cta=$('avlNovaIr'), ctaTx=$('avlNovaIrTx'), err=$('avlNovaErro');
    function placaAgora(){
      try{ return placaNormalizar((campo&&campo.value)||''); }
      catch(_){ return String((campo&&campo.value)||'').toUpperCase().replace(/[\s\-‐-―.·]/g,''); }
    }
    function descSync(){
      if(!campo) return;
      var temErro=!!(err&&String(err.textContent||'').trim());
      if(err) err.hidden=!temErro;
      campo.setAttribute('aria-describedby',temErro?'avlNovaErro avlNovaAjuda':'avlNovaAjuda');
    }
    function placaPronta(bom){
      if(cta) cta.disabled=!bom;
      if(busca) busca.disabled=!bom;
      descSync();
    }
    function manualModo(it){
      manualEscolhida=it||null;
      var ajuda=$('avlNovaAjuda'), seguro=bg.querySelector('.avl-sh-seguro span');
      if(manualEscolhida){
        aba('nova');
        if(ajuda) ajuda.innerHTML=_AVL_SH_ICO.info+'<span>Informe a placa para iniciar a avaliação de <b>'+esc(_avlModelo(manualEscolhida.modelo||'veículo'))+'</b>. A consulta por modelo não será refeita.</span>';
        if(ctaTx) ctaTx.textContent='Iniciar avaliação';
        if(seguro) seguro.textContent='Os dados já consultados serão aproveitados sem nova cobrança.';
      }
      placaPronta(placaOk(placaAgora()));
    }
    function erroPoe(msg){
      if(!err) return;
      err.textContent=msg||''; err.hidden=!msg;
      /* §8: o erro entra e sai do aria-describedby junto com a mensagem */
      if(campo) campo.setAttribute('aria-describedby', msg?'avlNovaErro avlNovaAjuda':'avlNovaAjuda');
    }
    /* 🔴 §9 + REGRA DA v882: a validade é a `valida()` do 01-nucleo, a MESMA do
       campo da home e da trava da consulta. UMA regra, UM lugar.
       ⚠️ E aqui NÃO ENTRA uma regex de reserva — foi a primeira versão deste
       trecho e o teste-v882 reprovou na hora ("nenhum módulo tem a regex da
       placa copiada"). Cópia de reserva é cópia: no dia em que a regra mudar
       (moto, placa nova de outro país), a reserva fica pra trás e passa a
       recusar placa boa em silêncio. Sem a `valida()` — que só aconteceria com
       o app pela metade — o portão exige sete caracteres e deixa a trava do
       `buscarPlaca()` dizer o resto. */
    function placaOk(p){
      try{ if(typeof valida==='function') return !!valida(p); }catch(_){}
      return String(p||'').length===7;
    }
    /* v1418 — o campo da folha usa a MESMA trava do MEV Consultas. Além de
       validar pela posição, ela cuida de digitação, colagem, caixa alta,
       placa antiga/Mercosul e do estado da lupa sem criar outra regra. */
    try{ placaLigar(campo,{erro:err,pronto:placaPronta}); }catch(_){ placaPronta(placaOk(placaAgora())); }
    if(campo){
      campo.addEventListener('input',descSync);
      campo.addEventListener('blur',function(){ setTimeout(descSync,0); });
      campo.onkeydown=function(e){ if(e.key==='Enter'){ e.preventDefault(); irNova(); } };
    }
    function irNova(){
      var pl=placaAgora();
      if(!placaOk(pl)){ erroPoe(pl.length<7?'Digite a placa inteira (7 caracteres).':'Essa placa não parece válida. Confira as letras e os números.'); try{ campo.focus(); }catch(_){} return; }
      if(manualEscolhida){
        try{
          veiculoAtual=JSON.parse(JSON.stringify(manualEscolhida.v||{})); veiculoAtual.placa=pl; histFonteTs=manualEscolhida.ts||Date.now();
          try{ verAplicar(veiculoAtual); }catch(_){}
          if(cta) cta.disabled=true; if(ctaTx) ctaTx.textContent='Abrindo…';
          actSheetFechar(); _avVoltarPara='avaliacoes'; abrirAvaliacaoLojista();
        }catch(_){ if(cta) cta.disabled=false; if(ctaTx) ctaTx.textContent='Iniciar avaliação'; erroPoe('Não consegui iniciar a avaliação. Tente novamente.'); }
        return;
      }
      /* §4.5: o CTA não encolhe ao trocar o texto — a largura é 100% e só a
         palavra muda. Se o app não conseguir sair daqui, a placa fica no campo. */
      if(cta) cta.disabled=true;
      if(ctaTx) ctaTx.textContent='Consultando…';
      try{ actSheetFechar(); }catch(_){}
      try{ voltarHome(); }catch(_){}
      var pi=$('placa');
      try{ if(typeof plDevolver==='function') plDevolver(pl); else if(pi){ pi.value=pl; placaCampoVisualSync(pi); } }
      catch(_){ if(pi) pi.value=pl; }
      try{ buscarPlaca(); }catch(_){ try{ toast('Não consegui iniciar a consulta.'); }catch(__){} }
    }
    if(cta) cta.onclick=irNova;
    if(busca) busca.onclick=function(){ if(busca.disabled) return; try{ campo.blur(); }catch(_){} irNova(); };
    /* a câmera é o botão que JÁ existe na tela inicial — nenhum leitor novo */
    var cam=$('avlNovaCam');
    if(cam) cam.onclick=function(){
      try{ actSheetFechar(); }catch(_){}
      try{ voltarHome(); }catch(_){}
      setTimeout(function(){ try{ var f=$('btnFotoFab'); if(f) f.click(); else toast('A leitura por foto está na tela inicial.'); }catch(_){} },160);
    };

    /* ---------------- aba 2: do histórico ---------------- */
    function itemHtml(it){
      var v=it.v||{};
      var ano=(function(){ var af=String(v.ano||'').trim(), am=String(v.ano_modelo||'').trim();
        return (af&&am&&af!==am)?(af+'/'+am):(am||af||''); })();
      var fipe=Number(v.fipe)||0;
      var meta='';
      if(ano)  meta+='<span class="avl-sh-ano">'+esc(ano)+'</span>';
      if(fipe) meta+='<span class="avl-sh-fipe">FIPE '+esc(_avlRs(fipe))+'</span>';
      return '<button type="button" class="avl-sh-veic" data-p="'+esc(it.placa||'')+'" data-k="'+esc(it.chave||'')+'">'+
        '<span class="avl-sh-plc">'+(it.manual?'<span class="avl-sh-semplaca">Sem placa</span>':placaMercosul(it.placa))+'</span>'+
        '<span class="avl-sh-info"><span class="avl-sh-nm">'+esc(_avlModelo(it.modelo||'Veículo'))+'</span>'+
          (meta?('<span class="avl-sh-meta">'+meta+'</span>'):'')+'</span>'+
        '<span class="avl-sh-go" aria-hidden="true">'+_AVL_SH_ICO.chev+'</span></button>';
    }
    function histPinta(termo){
      var el=$('avlNovaLista'); if(!el) return;
      var t=String(termo||'').toUpperCase().trim();
      var achados=hist.filter(function(it){
        if(!t) return true;
        return String(it.placa||'').toUpperCase().indexOf(t)>=0
            || String(it.modelo||'').toUpperCase().indexOf(t)>=0;
      });
      if(!hist.length){
        /* §4.5 — histórico vazio: orientação e caminho de volta pra aba certa */
        el.innerHTML='<div class="avl-sh-vazio"><b>Nenhum veículo consultado ainda</b>'+
          '<p>Assim que você consultar por placa ou modelo, o veículo aparece aqui sem nova cobrança.</p>'+
          '<button type="button" class="avl-sh-vazio-bt" id="avlShVoltaNova">Começar por uma placa nova</button></div>';
        var vb=$('avlShVoltaNova'); if(vb) vb.onclick=function(){ aba('nova'); };
        return;
      }
      if(!achados.length){
        el.innerHTML='<div class="avl-sh-vazio"><b>Nenhum veículo encontrado</b>'+
          '<p>Confira a placa ou o modelo pesquisado.</p>'+
          '<button type="button" class="avl-sh-vazio-bt" id="avlShLimpa">Limpar busca</button></div>';
        var lb=$('avlShLimpa'); if(lb) lb.onclick=function(){ var b=$('avlNovaBusca'); if(b){ b.value=''; b.focus(); } histPinta(''); };
        return;
      }
      /* sem busca, mostra os cinco primeiros e oferece o histórico inteiro;
         com busca, mostra tudo o que casou (a peneira já é a resposta) */
      var mostra=t?achados:achados.slice(0,_AVL_SH_MOSTRA);
      var sobra=t?0:(achados.length-mostra.length);
      el.innerHTML=mostra.map(itemHtml).join('')+
        '<button type="button" class="avl-sh-mais" id="avlShTodo">Ver todo o histórico'+
          (sobra?(' <i>+'+sobra+'</i>'):'')+'</button>';
      Array.prototype.forEach.call(el.querySelectorAll('.avl-sh-veic'),function(b){
        b.onclick=function(){
          var pl=b.getAttribute('data-p')||'';
          var k=b.getAttribute('data-k')||'', manual=hist.filter(function(x){return x.manual&&String(x.chave)===String(k);})[0];
          if(manual){ manualModo(manual); return; }
          try{ actSheetFechar(); }catch(_){}
          /* o MESMO caminho do menu do card: estado do histórico + avaliação,
             sem consultar de novo e sem cobrar (§9) */
          try{ histAcaoExec(pl,'aval'); }catch(_){}
        };
      });
      var td=$('avlShTodo');
      if(td) td.onclick=function(){
        try{ actSheetFechar(); }catch(_){}
        try{ abrirHistorico(); }catch(_){}
      };
    }
    var bq=$('avlNovaBusca'); if(bq) bq.oninput=function(){ histPinta(this.value); };
    try{ fipeModeloHistSync(function(mudou){ if(!mudou || !document.body.contains(bg)) return; hist=histTodos(); histPinta(($('avlNovaBusca')||{}).value||''); }); }catch(_){}

    /* v1007 — a busca FIPE acabou de produzir este item sem placa. Abrimos
       a mesma folha canônica já usada pelo histórico, diretamente no modo
       que pede a placa e reaproveita os dados, sem refazer a consulta. */
    if(manualInicial) manualModo(manualInicial);

    requestAnimationFrame(function(){ bg.classList.add('on'); });
    /* §8 — a ordem do foco começa no campo da aba aberta; o Fechar é o
       primeiro elemento do DOM, então o Shift+Tab chega nele naturalmente. */
    setTimeout(function(){ try{ if(campo) campo.focus(); }catch(_){} },120);
    placaPronta(placaOk(placaAgora()));
  }

  /* v678 — o botão "Importar do Avaliex" mora AQUI e só aqui (decisão
       28/08). Não vai na fila de chips: aqueles três são FILTROS, e misturar
       uma ação ali ensina errado. O motor mora no 05i-importar-avaliex.js. */
    if(!soArquivados){
      try{ if(typeof avxBotaoWire==='function') avxBotaoWire(); }catch(_){}
      try{ avlNovaWire(); }catch(_){}   /* v893 — "Nova avaliação", ao lado do Importar */
    }
    try{ mdrAtivoSet('avaliacoes'); }catch(_){}
    await avlCarregar(true);
    try{ await _avlClientesCarregar(); }catch(_){}   /* v400: nomes dos vinculados */
    try{ await _avlAvaliadosCarregar(); }catch(_){}  /* v481: o valor avaliado (rascunho privado) */
    try{ await _avlCardCarregar(); }catch(_){}       /* v685: repasse/vendido/comissão do card */
    avlPinta();                                     /* pinta já, sem esperar o resto */
    /* v452: foto, cor e as propostas do repasse vêm de listas que outras telas
       já carregam. Peço só o que ainda NÃO estiver na memória — quem passou
       pelo Estoque ou pelo Repasse antes não paga nada por isso — e repinto
       quando chegar. A lista aparece na hora; os enfeites entram depois. */
    try{
      var pend=[];
      if(typeof estCarregar==='function' && !(_estoque||[]).length) pend.push(estCarregar());
      if(typeof repPortalCarregar==='function' && !(_repMeu||[]).length) pend.push(repPortalCarregar());
      if(typeof ofertasCarregar==='function' && !(_repOfertasRecebidas||[]).length) pend.push(ofertasCarregar());
      if(pend.length){ await Promise.all(pend.map(function(p){ return p.catch(function(){}); })); avlPinta(); }
    }catch(_){}
  }

/* ╔═══ src/app/05d-abas-consultas.js ═════════════════════════════════════ */
  /* ==========================================================================
     05d — CONSULTAS EM ABAS (v387, pedido — folha manuscrita "CONSULTAS")

     Tudo em UMA página, organizada por abas:

        Placa/FIPE · Busca por veículo · Consulta Plus · CPF · CNPJ

     NO CELULAR: a barrinha de abas usa o MESMO mecanismo da página de
     avaliação (.vpx-steps: pílulas roláveis + deslizar o dedo troca de
     consulta — o deslize já existia no 18b; aqui ele só ganhou a barrinha
     visível e a ordem nova).

     NO COMPUTADOR (v388, corrigido com o Angelo): a MESMA barrinha vira um
     MENU NA ESQUERDA (colunas de verdade não — cada aba mostra UMA consulta
     por vez, igual à página de avaliação no desktop). O CSS resolve sozinho
     via #secoes:has(> .cons-tabs) e #telaHome — nenhum JS a mais.

     A Consulta Plus tem placa própria e reúne as fontes pagas em uma única
     ação, preservando a Consulta FIPE avulsa.
     ========================================================================= */

  /* ---------- ícones (os mesmos desenhos do menu lateral) ---------- */
  var _CT_ICO={
    placa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M8 11h6"/></svg>',
    hist:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/><path d="M12 8v4l3 2"/></svg>',
    plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    cpf:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="10" cy="7" r="4"/><path d="M15.5 8.5l2 2 3.5-3.5"/></svg>',
    cnpj:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>',
    /* v613: as duas abas novas. Ícones próprios pra não confundir com o CPF. */
    cpfproc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18"/><path d="M5 7h14"/><path d="m5 7-3 6a3 3 0 0 0 6 0z"/><path d="m19 7 3 6a3 3 0 0 1-6 0z"/><path d="M8 21h8"/></svg>',
    cpfscore:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17a9 9 0 1 1 18 0"/><path d="m12 17 4-5"/></svg>',
    fipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="20" x2="4" y2="13"/><line x1="10" y1="20" x2="10" y2="8"/><line x1="16" y1="20" x2="16" y2="11"/><line x1="20" y1="20" x2="20" y2="5"/></svg>',
    /* v628 — as consultas de VEÍCULO novas. Mesmo traço e mesma cor dos
       vizinhos (lição do Canva que sobreviveu ao projeto da home em grade):
       um cadeado pro gravame (o carro que está preso ao banco). */
    gravame:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/><path d="M12 14v2"/></svg>',
    debitos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 3h16v18H4z"/><path d="M8 7h8M8 11h5M8 15h3"/><circle cx="16" cy="16" r="3"/><path d="m18.2 18.2 2 2"/></svg>',
    recall:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/><path d="m9 12 2 2 4-4"/></svg>',
    proprietarios:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2.5 20v-2a5.5 5.5 0 0 1 11 0v2"/><path d="M14.5 15.5a4 4 0 0 1 7 2.5v2"/><path d="m13 5 2-2 2 2"/></svg>',
    /* v629 — multas: um semáforo (a infração que o carro carrega) */
    multas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="14" rx="4"/><path d="M12 6h.01M12 9h.01M12 12h.01"/><path d="M12 16v6"/><path d="M8 22h8"/></svg>',
    /* 🔴 v641 — risco de crédito CNPJ: o PRÉDIO com um triângulo de alerta.
       Não pode ser o medidor (é o "Score bancário" do CPF, v613) nem o
       cadeado (é o Gravame, v628) nem o escudo (é a Consulta Plus). Dois
       desenhos iguais em pílulas vizinhas é pior que nenhum desenho. */
    cnpjrisco:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h9"/><path d="M5 21V7l6-4 6 4v3"/><path d="M8 9h.01M8 13h.01M8 17h.01"/><path d="M17.4 13.6 21.8 21H13z"/><path d="M17.4 16.6v2"/><path d="M17.4 19.9h.01"/></svg>',
    /* v1000 — o Compliance Complete usa o mesmo prédio-com-alerta do risco:
       é a mesma família (empresa sob análise) e ícone novo aqui seria ruído. */
    /* v1024 — ações e processos da EMPRESA: o prédio com a balança */
    cnpjprocessos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h8"/><path d="M5 21V7l5-3 5 3v2"/><path d="M8 9h.01M8 13h.01M8 17h.01"/><path d="M18 11v10"/><path d="M13 13h10"/><path d="m13 13-2.4 4.6a2.6 2.6 0 0 0 4.8 0z"/><path d="m23 13 2.4 4.6"/></svg>',
    cnpjcompliance:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h9"/><path d="M5 21V7l6-4 6 4v3"/><path d="M8 9h.01M8 13h.01M8 17h.01"/><path d="M17.4 13.6 21.8 21H13z"/><path d="M17.4 16.6v2"/><path d="M17.4 19.9h.01"/></svg>',
    cnpjsintegra:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M8 10h3M8 14h3M14 10h2M14 14h2"/><path d="m15 18 1.5 1.5L20 16"/></svg>',
    /* v630 — renajud: o MARTELO do juiz, não a balança. A balança já é o
       ícone de "Ações e processos" (v613) — dois desenhos iguais em pílulas
       vizinhas é pior que nenhum desenho. */
    renajud:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14 13-7.5 7.5a2.12 2.12 0 0 1-3-3L11 10"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>',
    /* v744 — AutoCorp: um carro com a etiqueta de leilão (Leilão + PT) e um
       escudo com estrela (Total Premium). Não repetem nenhum vizinho. */
    leilaopt:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14l-1.5-5.5a2 2 0 0 0-1.9-1.5H8.4a2 2 0 0 0-1.9 1.5z"/><circle cx="7.5" cy="17" r="1.5"/><circle cx="16.5" cy="17" r="1.5"/><path d="M12 3v4"/><path d="M9 5h6"/></svg>',
    premium:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m12 8 1.2 2.5 2.8.4-2 2 .5 2.7-2.5-1.3-2.5 1.3.5-2.7-2-2 2.8-.4z"/></svg>',
    /* v994 — reutiliza o martelo canônico do RENAJUD dentro do escudo:
       leilão especial e bloqueio judicial na mesma consulta. */
    especialjud:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 13 4-4"/><path d="m11 7 4 4"/><path d="m8 14 2 2"/><path d="m14 12 3 3"/></svg>'
  };
  /* v390 (plano item 7): UM nome só pra cada coisa — abas e menu lateral
     falam igual (o app.html foi alinhado junto). */
  /* v406 (pedido): "Buscar por veículo" VIROU ABA, no lugar do Histórico —
     e o histórico voltou pra baixo da consulta de placa (na 1ª aba). O card
     embutido da FIPE saiu da home; a busca agora tem página própria. */
  /* v613 (pedido): as três consultas de CPF viraram TRÊS PÁGINAS irmãs, cada
     uma com uma consulta só. Elas entram na barrinha logo depois do CPF,
     porque é ali que o lojista já está olhando quando pensa "e os processos?" */
  var CONS_TABS=[
    ['placa','Consulta placa'],
    ['fipe','Buscar por veículo'],
    /* 🔴 v761 (pedido do Angelo, 30/08): "oculte o card de consulta plus
       (elimine do app)". A linha sai daqui e a Plus SOME de tudo que nasce
       do CONS_TABS — grade da home, barrinha das páginas internas, "Outras
       consultas" do padrão e selos. A PÁGINA continua no código
       (abrirConsultaPlus/mrInnerHtml) e a rota consIr('plus') segue valendo
       pra link antigo — desligar mostrando o caminho (regra v568). Pra
       reativar: descomentar a linha abaixo e devolver o item do menu no
       app.html (procure v761). */
    /* ['plus','Consulta Plus'], */
    ['cpf','Consulta CPF'],
    ['cpfproc','Ações e processos'],
    ['cnpj','Consulta CNPJ'],
    /* 🔴 v1000 — COMPLIANCE COMPLETE PJ entra onde o risco de crédito saiu.
       NÃO é o mesmo produto: o cnpj_risco batia em /quod/cnpj por R$ 6,50 e
       foi removido na v996 porque o endereço devolvia 404. Este bate em
       /consulta/cnpj/credits por R$ 14,44 e entrega o que aquele não
       entregava — listas de compliance, firmográfico e o bloco de consultas.
       ⚠️ Esta linha é a que faz o produto existir na tela: dela saem o card
       da home, a pílula da barrinha e a lista de "outras consultas". */
    ['cnpjcompliance','Compliance Complete · CNPJ'],
    ['cnpjsintegra','Inscrição Estadual · Sintegra'],
    /* v1024 — ações e processos de CNPJ. Esta linha é a que faz o produto
       existir na tela: dela saem o card da home, a pílula da barrinha e a
       lista de "outras consultas". */
    ['cnpjprocessos','Ações e processos · CNPJ'],
    /* 🔴 v996 — O RISCO DE CRÉDITO PJ SAIU DAQUI (pedido do Angelo, 12/09).
       Era a pílula e o card da v641, do lado da Consulta CNPJ grátis.
       Tirar a linha DESTA lista é o que faz o produto sumir de todo lugar:
       é dela que saem o card da home, a pílula da barrinha e a lista de
       "outras consultas". O desenho da tela continua no 04-leilao-cnpj,
       inerte — mas ninguém chega mais nele, e o servidor não vende mais
       (o `cnpj_risco` saiu do PRECOS do consultar.js).
       Pra voltar: repor esta linha, a do CONS_GRUPO, a da descrição, a do
       preço, a do CONS_DOC, a do roteador e a do PRECOS. */
    /* v628 — as consultas de VEÍCULO entram DEPOIS das de pessoa, juntas,
       porque formam família: as três perguntam sobre a placa, não sobre
       quem é o dono. (v629 e v630 põem 'multas' e 'renajud' aqui do lado.) */
    ['proprietarios','Histórico de proprietários'],
    ['gravame','Gravame'],
    ['recall','Recall'],
    ['debitos','Débitos e restrições'],
    ['multas','Multas (RENAINF)'],
    ['renajud','RENAJUD'],
    /* v744 — AutoCorp (03d). Aparecem só pra quem o servidor liberou: body.autocorp-off */
    ['leilaopt','Leilão + PT'],
    ['premium','Total Premium'],
    ['especialjud','Leilão Especial + Judicial']
  ];

  /* ==========================================================================
     🔴 v861 (decisão do Angelo, 03/09): "multas e renajud vou tirar do app".
     --------------------------------------------------------------------------
     UM filtro, aqui, resolve os CINCO lugares que leem esta lista: a grade da
     home, a barrinha das páginas internas, o "outras consultas" do padrão, os
     selos e as famílias. Foi o mesmo raciocínio da v761 (Consulta Plus), só
     que com interruptor em vez de linha comentada — porque agora são duas
     consultas e podem virar outras.

     ⚠️ O QUE ESTE FILTRO **NÃO** FAZ, DE PROPÓSITO: ele não mexe no
     VEIC_PAGS (03d). As páginas continuam existindo e as rotas continuam
     abrindo — um link antigo ou um favorito do cliente não vira 404. Some a
     OFERTA, não o destino. É a regra da casa: desligar mostrando o caminho.
     ⛳ PRA VOLTAR: MEV_CONSULTA_MULTAS / MEV_CONSULTA_RENAJUD no 00-edicoes.js. */
  try{
    if(typeof window.edConsultaLigada==='function'){
      CONS_TABS=CONS_TABS.filter(function(t){ return window.edConsultaLigada(t[0]); });
    }
  }catch(_){}

  /* ==========================================================================
     v625 — UMA LISTA SÓ PROS ATALHOS DA HOME
     ==========================================================================
     Pedido do Angelo: a home em grade, com grupos, IGUAL no celular e no
     computador (projeto "home em grade", alternativa B).

     🔑 O ACHADO QUE MUDOU O SERVIÇO: os atalhos nasciam em DOIS lugares
     diferentes — o _ctFabsHtml() (só computador: Tokens · Loja · Avaliação ·
     Vitrine · Ler placa por foto) e a grade do celular (v408: Tokens ·
     Histórico · Ler placa por foto · Loja · Vitrine · Site · Leads · Apps).
     Duas listas escritas à mão, e por isso as duas telas JÁ divergiam:

       · "Site", "Histórico", "Leads" e "Apps MEV" existiam só no CELULAR;
       · "Avaliação" existia só no COMPUTADOR.

     Cada divergência tinha um comentário explicando por quê — ninguém errou,
     mas manter duas listas em sincronia à mão não dura. Enquanto fossem
     duas, "os grupos valem nas duas telas" significaria fazer tudo duas
     vezes, pra sempre.

     Agora a fonte é UMA. Cada linha diz o rótulo, o GRUPO (já preparando o
     painel da próxima versão) e COMO abre — porque hoje já são cinco
     caminhos diferentes e todos precisam continuar valendo:

        cons   → consIr()            (as páginas de consulta)
        drawer → drawerIr()          (páginas do menu)
        fab    → clica o FAB escondido (câmera, site)
        loja   → haLojaAlterna()     (a listinha da Loja)
        hist   → abrirHistorico()
        saldo  → não tem clique próprio: a classe .saldo-chip já cuida

     ⚠️ ESTA VERSÃO NÃO MEXE NO LAYOUT. As duas telas continuam com os
     mesmos contêineres de sempre (.ct-fabs no computador, .ha-grid no
     celular) — o que muda é que as duas passam a ler a MESMA lista, então
     o conteúdo delas fica igual. O painel com os grupos é a v626.
     Fazer as duas coisas juntas esconderia o risco: se a home quebrasse,
     ninguém saberia se foi a lista ou o layout. */
  /* ==========================================================================
     🔴 v639 (pedido do Angelo, 25/08) — O PAINEL DA HOME EM CINCO GRUPOS
     ==========================================================================
     Cinco recados, todos sobre a mesma tela:
       "separe consulta veicular e analise de risco (CPF e CNPJ)"
       "secao loja deixe esses cards visiveis" (com o print do menu lateral)
       "adiciona o card uso e faturamento em conta"
       "avaliacoes e avaliacao ta duplicado, deixe um só em lojista"
       "card loja com menu ao clicar sai, ja vai ter todas paginas em card"

     O QUE MUDOU, E POR QUÊ:

     1. AS CONSULTAS VIRARAM DUAS SEÇÕES. Placa, veículo, Plus, gravame,
        multas e RENAJUD perguntam sobre o CARRO. CPF, processos, score e CNPJ
        perguntam sobre QUEM está do outro lado do negócio. Eram dez cards
        numa fileira só, e o olho não separava as duas perguntas.
        ⚠️ Quem decide o grupo é a tabela CONS_GRUPO abaixo, não a posição na
        CONS_TABS — posição é acidente, chave é intenção (mesma lição do selo
        dos pacotes, v534).

     2. 🔴 O CARD "LOJA" QUE ABRIA UM MENUZINHO SAIU. Ele existia pra caber
        seis páginas num card só. Agora as seis são cards — o menuzinho virou
        um toque a mais pra chegar no mesmo lugar. A `haLojaAlterna` e a
        `haLojaMontar` FICAM no código, desligadas: desligar mostrando o
        caminho, nunca sumir (v568).

     3. 🔴 "AVALIAÇÃO" E "AVALIAÇÕES" ERAM O MESMO DESTINO, DUAS VEZES —
        um card em CONSULTAS (via consIr('avl')) e outro em LOJA. Ficou UM,
        em LOJISTA, com o nome do menu lateral: "Avaliações".
        📌 A pendência que o projeto da home em grade (24/08) tinha deixado
        em aberto — "vale renomear a lista pra Minhas avaliações?" — se
        resolveu sozinha: sem o par, não há mais o que confundir.

     4. O CRM GANHOU SEÇÃO PRÓPRIA (Leads e Clientes), como no menu lateral.

     5. "Uso e pagamentos" entrou em CONTA.
        📌 ATUALIZADO NA v650: aqui eu tinha mantido "Uso e pagamentos" porque
        era como o menu lateral chamava — regra da v390, um nome só pra cada
        coisa. O Angelo voltou ao assunto em 25/08 e decidiu: o nome é **Uso e
        faturamento**, nos QUATRO lugares. A regra não mudou; mudou qual dos
        dois nomes vence.
     ========================================================================= */
  /* de qual seção é cada consulta da CONS_TABS */
  var CONS_GRUPO={
    placa:'veicular', fipe:'veicular', plus:'veicular',
    proprietarios:'veicular', gravame:'veicular', recall:'veicular', debitos:'veicular', multas:'veicular', renajud:'veicular',
    leilaopt:'veicular', premium:'veicular', especialjud:'veicular',   /* v995 */
    cpf:'risco', cpfproc:'risco', cpfscore:'risco', cnpj:'risco',   /* v996: cnpjrisco saiu */
    cnpjcompliance:'risco',   /* v1000 */
    cnpjsintegra:'risco',
    cnpjprocessos:'risco'   /* v1024 */
  };
  var HOME_ATALHOS=[
    /* [chave, rótulo, grupo, como abre, extra] */
    /* ===== 🔴 v645 (pedido do Angelo, 25/08) — CADA CARD DO LADO DO SEU PAR
       "o ler placa por foto remove o destaque deixe ao lado do consulta
        placa, e o historico de consultas ao lado direito do buscar por
        veiculo"

       As duas coisas são a mesma ideia: **cada atalho junto da consulta a que
       ele serve.** Ler a placa por foto não é uma consulta à parte — é outro
       jeito de preencher o campo da Consulta placa. E o Histórico é onde
       terminam as buscas por veículo. Ficavam os dois no fim do grupo,
       largados depois do RENAJUD, longe do que fazem.

       🔴 O DESTAQUE AZUL SAIU. Ele existia pra a câmera não sumir no fim da
       fileira; do lado da Consulta placa ela não precisa gritar — a posição
       já diz o que ela é. E card em azul forte no meio da grade agora
       roubaria o olho de tudo em volta.

       ⚠️ O `apos` (6ª posição) é o que faz isso sem criar uma TERCEIRA lista.
       A ordem continua saindo das duas de sempre — CONS_TABS e HOME_ATALHOS;
       o `apos` só diz "este entra logo depois daquele". Uma lista de ordem
       separada teria que ser mantida à mão toda vez que entrasse card novo,
       e é exatamente o defeito que a v625 gastou uma versão pra matar. */
    /* v675: o card 'placa' saiu da home, então o vizinho da câmera sumiu.
       Em vez de deixar a regra do órfão jogá-la pro FIM (era o fallback da
       v645), ela assume o lugar que era da placa: '_inicio' = primeira do
       grupo. A câmera É a outra porta de entrada da placa — faz sentido
       ela abrir a fila. */
    ['foto','Ler placa por foto','veicular','fab','','_inicio'],
    /* 🔴 v642 (pedido do Angelo, 25/08, com o print do grupo veicular):
       "ADICIONE UM CARD DE HISTÓRICO DE CONSULTA".
       ⚠️ ELE FOI MOVIDO, NÃO COPIADO. O card já existia — estava no grupo
       CONTA, chamado só "Histórico". Criar um segundo aqui daria DOIS cards
       pro MESMO destino na mesma tela, que é exatamente o defeito que o
       próprio Angelo apontou na v639 ("avaliacoes e avaliacao ta duplicado").
       E o lugar certo é este: a v390 já tinha decidido que este histórico
       mostra SÓ consultas de PLACA — CPF, CNPJ e leilão têm o próprio
       histórico dentro da página de cada um. Ele é do carro, mora com o carro.
       📌 O nome também mudou, e mudou pro que o app JÁ usa em todo lugar
       ("Histórico de consultas" — o título da tela, desde a v386). Regra da
       v390: um nome só pra cada coisa. */
    /* ⛳ v839 (§7 do projeto "home divisão responsiva e histórico único") —
       O HISTÓRICO SAIU DO GRUPO CONSULTA VEICULAR.
       Não é consulta: é o registro do que já foi consultado. E ele já
       aparecia em OUTROS DOIS lugares na mesma tela — na fileira "Mais
       usados" e na seção completa lá embaixo. Três caminhos visualmente
       concorrentes pro mesmo destino é o defeito que a v642 evitou ao MOVER
       (e não copiar) este card, e que voltou quando a home ganhou as outras
       duas superfícies.
       🔑 O CARD NÃO FOI APAGADO — mudou de grupo, pro grupo 'reserva', que o
       homePainelMontar NÃO desenha. Continua na lista, com o mesmo rótulo, o
       mesmo ícone e o mesmo clique (homeAtalhoClique lê a chave, nunca o
       grupo), e é dele que o "Mais usados" monta o botão quando o Histórico
       entra na fileira (§6). Devolver ao grupo veicular é trocar 'reserva'
       por 'veicular' e pôr de volta o `apos` — era: ['hist','Histórico de
       consultas','veicular','hist','','fipe'].
       ⚠️ Se um dia o Histórico sair do "Mais usados", §7 manda deixar UM
       atalho no cabeçalho — nunca os dois ao mesmo tempo. */
    /* ==========================================================================
       ⛳ v855 (pedido do Angelo, 02/09, com print): "adicione o histórico de
       consultas no quadro das consultas ao lado do consulta por veículo".
       --------------------------------------------------------------------------
       O card VOLTA pro grupo Consulta veicular, logo depois do "Buscar por
       veículo" — exatamente o `apos:'fipe'` que a v839 tinha tirado. O caminho
       de volta estava escrito no comentário acima desde então; foi só segui-lo.

       🔴 E O QUE A v839 TEMIA CONTINUA VERDADE — não estou fingindo que
       sumiu: o Histórico agora aparece em TRÊS lugares na mesma tela — este
       card, a fileira "Mais usados" (quando ele estiver entre os mais usados) e
       a seção completa lá embaixo. Três caminhos pro mesmo destino é o que a
       v642 tinha evitado ao MOVER (e não copiar) este card.
       📌 O Angelo viu a tela e pediu assim. É decisão dele, e é reversível numa
       linha: trocar 'veicular' por 'reserva' e tirar o `apos` devolve a v839.
       ⚠️ Se um dia incomodar, o ajuste barato não é tirar este card — é o §7 da
       v839: deixar UM atalho no cabeçalho, nunca dois ao mesmo tempo. */
    ['hist','Histórico de consultas','veicular','hist','','fipe'],

    /* LOJISTA — as mesmas páginas do menu lateral, agora em card */
    ['loja','Minha loja','lojista','drawer'],
    ['estoque','Estoque','lojista','drawer'],
    /* \U0001f534 v663 (pedido do Angelo, 26/08): "adicione mercado ao campo do
       lojista · card na pagina inicial".
       \U0001f511 O LUGAR É AQUI, LOGO DEPOIS DO ESTOQUE, e não no fim da fila: a
       cabeça lê "o meu estoque" e, na sequência, "o estoque dos outros". Card
       no fim da lista vira card que ninguém acha.
       \u26a0\ufe0f E ele foi ACRESCENTADO à lista de sempre, não a uma lista nova: o
       ícone continua vindo do menu lateral e o clique continua sendo a MESMA
       ação `mercado` que o menu já dispara. Um destino, um nome, um caminho
       (regra da v390). */
    ['mercado','Mercado','lojista','drawer'],
    ['repasse_meu','Repasse','lojista','drawer'],
    ['catalogo','Catálogo','lojista','drawer'],
    ['vendas','Vendas','lojista','drawer'],
    ['avaliacoes','Avaliações','lojista','drawer'],
    ['vitrine','Vitrine','lojista','drawer'],
    ['site','Site','lojista','fab'],

    /* CRM */
    ['clientes','Leads','crm','drawer'],
    ['posvendas','Clientes','crm','drawer'],

    /* CONTA */
    /* 🔴 v920 (PROJETO-remover-minha-loja-e-card-meu-cadastro, 06/09):
       "adicionar um card Meu cadastro no grupo Conta da home".
       🔑 VEM ANTES DO TOKENS de propósito: identidade primeiro, dinheiro
       depois. Tokens e Uso e faturamento continuam juntos, na ordem, logo
       atrás — são o mesmo assunto (consumo).
       ⚠️ Card NOVO, lista de SEMPRE: 'drawer' quer dizer que ele abre pela
       mesma porta do menu lateral (drawerIr('cadastro')), e o ícone vem
       CLONADO do próprio botão [data-acao="cadastro"] do #mevDrawer (regra da
       v639). Nada de rota nova, nada de SVG copiado.
       📌 E ele aparece em TODA edição porque 'cadastro' é COMUM no
       00-edicoes.js — todo mundo tem conta, então todo mundo tem cadastro. */
    ['cadastro','Meu cadastro','conta','drawer'],
    ['tokens','Saldo','conta','saldo'],
    /* ⛳ v642: o 'hist' saiu daqui e foi pro grupo Consulta veicular, junto do
       carro — ver o comentário lá em cima. Era: ['hist','Histórico','conta','hist'] */
    ['pagamentos','Uso e faturamento','conta','drawer'],
    ['apps','Apps MEV','conta','drawer']
  ];
  /* os ícones ficam num getter porque alguns moram em variáveis declaradas
     mais abaixo neste mesmo arquivo — lidas na HORA de desenhar, não agora */
  /* 🔴 v639 — O ÍCONE DO CARD É O ÍCONE DO MENU, LIDO DO MENU.
     Onze cards novos precisavam de ícone, e copiar onze SVGs pra cá criaria
     onze pares pra manter em sincronia à mão — exatamente o defeito que a
     v625 gastou uma versão inteira pra matar nas listas de atalho.
     O menu lateral já tem o desenho de cada página no app.html. Então o card
     PERGUNTA ao menu. Mudou o ícone lá, mudou aqui, sem ninguém lembrar. */
  function _icoDoMenu(acao){
    try{
      var b=document.querySelector('.mev-drawer [data-acao="'+acao+'"] svg');
      return b?b.outerHTML:'';
    }catch(_){ return ''; }
  }
  function homeAtalhoIco(k){
    try{
      /* 🔴 v644 — O ÍCONE 3D VEM PRIMEIRO, e só aqui.
         Quem desenha a GRADE DA HOME pergunta ao ICO3D (02b); a barrinha
         estreita das páginas internas continua com os desenhos de traço.
         ⚠️ E o `||` no fim não é enfeite: chave sem 3D CAI no ícone de traço
         em vez de virar quadrado vazio. É o que faz uma página nova nascer
         funcionando antes de alguém desenhar o ícone dela. */
      /* 🔴 v762 (PROJETO-2026-08-30-cards-consulta-svg-e-grupos): o 3D SAIU
         da frente — card funcional usa SVG de LINHA (mesma linguagem do menu
         e das páginas internas).
         v764 (FASE 5): a auditoria confirmou o ICO3D órfão (nenhum consumidor
         em lugar nenhum) e o 02b saiu do build — a arte está guardada em
         amostras/icones-3d-guardados.js, com a receita de reativação. */
      if(k==='tokens') return _HA_ICO.tokens;
      if(k==='hist') return _CT_ICO.hist;
      if(k==='foto') return _HA_ICO.foto;
      if(k==='lojahub') return _TB_SVG.loja;   /* ⛳ desligado da lista, vivo no código */
      if(k==='site') return _HA_ICO.site;
      var doMenu=_icoDoMenu(k);
      if(doMenu) return doMenu;
      /* reservas, pra o card nunca nascer sem desenho se o menu não estiver
         montado ainda (a home pinta antes do drawer em alguns caminhos) */
      if(k==='avaliacoes') return _CTF_ICO_AVAL;
      if(k==='vitrine') return _CTF_ICO_VIT;
      if(k==='clientes') return _HA_ICO.clientes;
      if(k==='apps') return _HA_ICO_APPS;
    }catch(_){}
    return '';
  }
  /* quem pode aparecer AGORA: a Vitrine tem interruptor (v568) e o Apps MEV
     obedece ao lançamento (v497). Um lugar só decide, pras duas telas. */
  /* ==========================================================================
     v703 (pedido, 29/08) — "crie uma linha de cards para os mais acessados,
     ou acessados recentemente"
     --------------------------------------------------------------------------
     O app APRENDE do dedo: cada card aberto conta 1 no cofre local
     (mev_home_uso, por chave: quantas vezes + quando). A fileira "Mais
     usados" nasce em cima dos grupos quando pelo menos DOIS cards já foram
     usados 2+ vezes — desempate pelo mais recente ("ou acessados
     recentemente", como ele pediu). Nada sobe pra nuvem: é conveniência
     deste aparelho, do jeito que a mão dele usa ESTE aparelho.
     ⚠️ Os cards da fileira são os MESMOS dos grupos (mesmo html, mesmos
     cliques) — atalho repetido de propósito, como toda fileira de recentes;
     nenhuma rota nova (v390). */
  var HA_USO_KEY='mev_home_uso', HA_USO_MAX=6;   /* v739: era 4 — a fileira agora rola de lado */
  /* v791: os dois que abrem a fileira, sempre, nesta ordem (pedido do Angelo).
     Ficam aqui em cima, e não escondidos no meio do pintor, porque a próxima
     conversa que quiser trocar a dupla precisa achar isto em cinco segundos. */
  var HA_FIXOS=['avaliacoes','mercado'];
  /* 🔴 v839 (§6) — A RESERVA DE SEIS.
     "Fallback recomendado de seis itens quando não houver uso suficiente" —
     e a regra que vem logo depois manda mais que a lista: **ela não
     sobrescreve o histórico de uso.** Por isso a reserva entra SÓ NO FIM,
     preenchendo as vagas que sobraram depois dos fixos e do uso de verdade,
     e só com card que EXISTE pra aquele usuário.
     Assim a fileira nunca nasce com dois cards e um buraco de quatro — que é
     o que acontecia com conta de uso recém-começada. */
  var HA_RESERVA=['avaliacoes','mercado','estoque','hist','site','gravame'];
  function haUsoLer(){ try{ return JSON.parse(localStorage.getItem(HA_USO_KEY)||'{}')||{}; }catch(_){ return {}; } }
  /* ==========================================================================
     🔴 v739 (pedido do Angelo): "ver os cards mais acessados de TODOS os
     dispositivos e deixar num grupo de uma linha, acima dos grupos"
     --------------------------------------------------------------------------
     Até aqui a contagem era só deste aparelho (o cofre local acima). Agora
     cada aparelho continua contando o SEU uso localmente e manda a sua conta
     pra nuvem, na tabela doc_consulta que já sincroniza os cards de
     avaliação (tipo 'home_uso', chave 'todos', RLS por usuário — nada novo
     no banco). O documento guarda UMA entrada POR APARELHO:
         { aparelhos:{ <device_id>:{ <card>:{n,em} } } }
     e a fileira soma todos os aparelhos (n somado, `em` = o mais recente).
     Por que por aparelho, e não um total só: cada aparelho só reescreve a
     PRÓPRIA entrada, então dois celulares gravando ao mesmo tempo não
     apagam a conta um do outro (o pior caso é perder o último toque de um
     deles, nunca a história inteira). O envio é adiado 3 s depois do toque
     (junta vários toques numa gravação) e a leitura acontece uma vez por
     abertura do app. Sem nuvem (offline/sem login): a fileira mostra o que
     este aparelho sabe, como sempre. */
  var HA_NUVEM_KEY='mev_home_uso_nuvem', _haNuvem=null, _haEnvioT=null, _haNuvemLida=false;
  function _haDevId(){ try{ return (typeof devId==='function')?devId():'dev-local'; }catch(_){ return 'dev-local'; } }
  function _haNuvemLer(){
    if(_haNuvem) return _haNuvem;
    try{ _haNuvem=JSON.parse(localStorage.getItem(HA_NUVEM_KEY)||'null'); }catch(_){}
    if(!_haNuvem || typeof _haNuvem!=='object' || !_haNuvem.aparelhos) _haNuvem={ aparelhos:{} };
    return _haNuvem;
  }
  /* a soma de todos os aparelhos, com ESTE aparelho sempre pela conta local
     (que é a mais fresca — a nuvem pode estar 3 s atrasada) */
  function haUsoTotal(){
    var nuvem=_haNuvemLer(), meu=_haDevId(), soma={};
    var aparelhos=Object.assign({}, nuvem.aparelhos||{}); aparelhos[meu]=haUsoLer();
    Object.keys(aparelhos).forEach(function(d){ var u=aparelhos[d]||{};
      Object.keys(u).forEach(function(k){ var o=u[k]||{}; if(!soma[k]) soma[k]={ n:0, em:0 };
        soma[k].n+=Number(o.n)||0; soma[k].em=Math.max(soma[k].em, Number(o.em)||0); }); });
    return soma;
  }
  function haUsoNuvemCarregar(){
    if(_haNuvemLida) return; _haNuvemLida=true;
    try{
      if(typeof docHistCloudLoadOne!=='function') return;
      docHistCloudLoadOne('home_uso','todos',function(r){
        try{
          if(r && r.aparelhos && typeof r.aparelhos==='object'){ _haNuvem={ aparelhos:r.aparelhos }; localStorage.setItem(HA_NUVEM_KEY, JSON.stringify(_haNuvem)); haMaisUsadosPinta(); }
          /* v740: este aparelho ainda não está na nuvem (ou a nuvem está vazia)
             mas já tem conta local de antes da v739 → manda agora, sem esperar
             o próximo toque. Assim o que o computador já contava entra na soma. */
          var jaLa=!!(r && r.aparelhos && r.aparelhos[_haDevId()]);
          if(!jaLa && Object.keys(haUsoLer()).length){ haUsoNuvemEnviar(); }
        }catch(_){}
      });
    }catch(_){ }
  }
  function haUsoNuvemEnviar(){
    try{
      var nuvem=_haNuvemLer(); nuvem.aparelhos=nuvem.aparelhos||{}; nuvem.aparelhos[_haDevId()]=haUsoLer();
      localStorage.setItem(HA_NUVEM_KEY, JSON.stringify(nuvem));
      if(typeof docHistCloudSave==='function') docHistCloudSave('home_uso','todos','',{ aparelhos:nuvem.aparelhos }, Date.now());
    }catch(_){}
  }
  function haUsoMarca(k){
    try{
      if(!k) return; var u=haUsoLer(); var o=u[k]||{ n:0, em:0 };
      o.n++; o.em=Date.now(); u[k]=o;
      localStorage.setItem(HA_USO_KEY, JSON.stringify(u));
      haMaisUsadosPinta();   /* v711: a fileira acompanha o dedo, não o reload */
      clearTimeout(_haEnvioT); _haEnvioT=setTimeout(haUsoNuvemEnviar, 3000);   /* v739 */
    }catch(_){}
  }
  /* ==========================================================================
     🔴 v711 (pedido, 29/08, com print: "nao apareceu os mais acessados encima
     do campo de consulta veicular")
     --------------------------------------------------------------------------
     A v703 calculava a fileira UMA vez, na montagem do painel — que acontece
     na abertura do app e nunca mais (o homePainelMontar vê o painel pronto e
     volta). Num PWA que fica dias sem recarregar, o uso contado depois nunca
     redesenhava nada: a fileira só nasceria num reload. Agora ela tem um
     pintor próprio, chamado a cada uso e a cada volta pra home.
     ⚠️ Os cards continuam sendo CLONES dos que já estão nos grupos (mesmo
     html, mesmos destinos — v390): o pintor copia do próprio painel, então
     card escondido/renomeado pela edição sai igual nos dois lugares. */
  function haMaisUsadosPinta(){
    try{
      var pn=document.getElementById('homePainel'); if(!pn) return;
      /* v911 — o MEV Consultas é um produto público e direto: a mesma ação
         não aparece numa fileira de ranking e novamente no grupo completo.
         🔴🔴🔴 v1076 — E A REGRA DEIXOU DE SER "QUAIS EDIÇÕES" PRA SER
         "QUAL TELA". O Angelo pediu, com print: "remove os mais usados da
         tela, pra ficar no mesmo padrão do mev consultas". Na TELA PREMIUM
         não existe "Mais usados", em edição nenhuma.
         ⚠️ PERGUNTAR PELA TELA, E NÃO PELA LISTA DE EDIÇÕES, É O PONTO. Se
            eu só tivesse acrescentado 'completo' à lista, a próxima edição
            que adotasse a tela premium nasceria com a fileira de volta — e
            ninguém ia lembrar de vir aqui. A tela premium se identifica
            sozinha pela classe `.consultas-premium-home`.
         ⚠️ E ESTE PORTÃO PRECISA EXISTIR MESMO COM A CHAMADA DA v1069 FORA:
            o `haUsoMarca()` chama esta função A CADA USO de um card. Sem o
            portão, a fileira voltaria a nascer no primeiro toque — depois da
            home já montada, e só pra quem usa o app. O defeito mais difícil
            de achar é o que só aparece no segundo dia. */
      try{
        var _telaPremium=false;
        try{ _telaPremium=pn.classList.contains('consultas-premium-home'); }catch(_){}
        var _ed=''; try{ if(typeof window.edicaoAtual==='function') _ed=window.edicaoAtual(); }catch(_){}
        if(_telaPremium || ['consultas','avalia'].indexOf(_ed)!==-1){
          var velho=pn.querySelector('.hp-grupo[data-g="maisusados"]');
          if(velho&&velho.parentNode) velho.parentNode.removeChild(velho);
          return;
        }
      }catch(_){}
      var u=haUsoTotal();   /* v739: todos os aparelhos */
      /* v740 (Angelo, com print: "não tá aparecendo o grupo dos mais usados"):
         era n>=2 em dois cards; com a conta recém-começada isso nunca fechava.
         Agora basta ter sido usado uma vez — a ordem continua pelo mais usado
         e, no empate, pelo mais recente. */
      /* 🔴 v791 (pedido do Angelo, com print): "ajuste pra avaliacoes e mercado
         serem os primeiros dos mais usados".
         Estes dois são o trabalho do dia do lojista — avaliar o carro que entra
         e olhar o mercado — e o Angelo quer eles SEMPRE à mão, na frente, sem
         depender de a contagem de uso alcançá-los. Os outros continuam saindo
         do uso de verdade, na ordem de sempre, logo atrás.
         ⚠️ Entram mesmo com uso ZERO (é esse o pedido: posição fixa, não
         ranking) — mas só se o card EXISTIR na grade: quem não é lojista não
         tem Mercado, e a fileira não pode ganhar buraco. O filtro de existência
         é o mesmo da v761, aplicado aos dois listões. */
      /* ==================================================================
         🔴 v839 (§6/§7) — DE ONDE VEM O CARD DA FILEIRA
         ------------------------------------------------------------------
         Até a v838 o card era SEMPRE um clone do que já estava desenhado
         num grupo — e isso era ótimo (mesmo html, mesmo destino, mesma
         edição). Só que o §7 tirou o Histórico do grupo veicular, e um card
         que não está mais na grade não tem o que clonar: o Histórico
         simplesmente sumiria da fileira também.
         Então agora existe uma SEGUNDA fonte, na ordem:
           1º o clone do grupo (continua sendo o caminho normal);
           2º o botão montado da própria HOME_ATALHOS, pelo mesmo
              homeAtalhoBt que desenha os grupos.
         ⚠️ A 2ª fonte NÃO é uma lista nova nem uma rota nova: ela lê a
         `homeAtalhosLista()`, que é a mesma de sempre e já aplica edição e
         permissão. Card que aquele usuário não pode ver continua não
         existindo em nenhuma das duas fontes. */
      /* 🔴 v839 — E "TER CARD" PASSOU A SIGNIFICAR "TER CARD NA TELA".
         O teste pegou: com uso semeado, a fileira montava seis chaves e
         mostrava CINCO. A sexta era o Leilão + PT, que EXISTE no DOM e nasce
         `display:none` quando o servidor não liberou o AutoCorp
         (body.autocorp-off). O filtro da v761 só perguntava se o elemento
         existia — e existir não é aparecer.
         §6: "completar vagas restantes apenas com ações permitidas". Card
         escondido não é ação permitida: ele devolve 'oculto' e a vaga passa
         pro próximo da fila, em vez de virar buraco. */
      var _naGrade=function(k){
        var b=pn.querySelector('.hp-grupo:not([data-g="maisusados"]) [data-cons="'+k+'"], .hp-grupo:not([data-g="maisusados"]) [data-ha="'+k+'"]');
        if(!b) return null;
        try{ if(getComputedStyle(b).display==='none') return 'oculto'; }catch(_){}
        return b;
      };
      var _daLista=function(k){
        var it=null;
        try{ homeAtalhosLista().forEach(function(x){ if(x[0]===k) it=x; }); }catch(_){}
        return it?homeAtalhoBt(it,'ha-bt'):'';
      };
      var cardHtml=function(k){
        var b=_naGrade(k);
        if(b==='oculto') return '';        /* existe e está escondido: não entra */
        if(b) return b.outerHTML;          /* o caminho normal: clone do grupo */
        return _daLista(k);                /* §7: o Histórico, que saiu da grade */
      };
      var temCard=function(k){ return !!cardHtml(k); };
      var fixos=HA_FIXOS.filter(temCard);
      var chaves=fixos.concat(
        Object.keys(u).filter(function(k){ return u[k] && u[k].n>=1; })
          /* v761: só entra quem TEM card — uso antigo de consulta que saiu do
             app (a Plus) não pode abrir buraco na fileira */
          .filter(temCard)
          /* v791: e quem já entrou como fixo não entra duas vezes */
          .filter(function(k){ return fixos.indexOf(k)<0; })
          .sort(function(a,b){ return (u[b].n-u[a].n)||(u[b].em-u[a].em); })
      );
      /* §6 — completa as vagas que sobraram com a RESERVA, nesta ordem, sem
         empurrar ninguém: quem veio do uso real já está na frente. É aqui
         que o Histórico ganha a sexta posição quando não está entre os mais
         acessados. */
      HA_RESERVA.forEach(function(k){
        if(chaves.length>=HA_USO_MAX) return;
        if(chaves.indexOf(k)>=0) return;      /* §6: nenhuma rota duas vezes */
        if(!temCard(k)) return;
        chaves.push(k);
      });
      chaves=chaves.slice(0,HA_USO_MAX);
      var g=pn.querySelector('.hp-grupo[data-g="maisusados"]');
      if(chaves.length<2){ if(g&&g.parentNode) g.parentNode.removeChild(g); return; }   /* fileira de um card só é enfeite */
      var html=chaves.map(cardHtml).join('');
      if(!html){ if(g&&g.parentNode) g.parentNode.removeChild(g); return; }
      if(!g){
        g=document.createElement('div'); g.className='hp-grupo'; g.setAttribute('data-g','maisusados');
        g.innerHTML='<div class="hp-tit">Mais usados</div>'
          +'<div class="vpx-steps vpx-mdr hp-grade cons-tabs" role="group" aria-label="Mais usados"></div>';
        /* 🔴 v1069 — A ÂNCORA GANHOU UM SEGUNDO NOME. Na tela premium (que o
           MEV completo passou a usar) não existe `.hp-grupo[data-g="veicular"]`
           — existe o catálogo `.hcp-catalog`. Sem esta linha o `appendChild`
           do fallback jogava a fileira dos MAIS USADOS pro FIM da página,
           embaixo de tudo. A fileira continua exatamente onde sempre esteve:
           logo acima da lista de consultas. */
        var vei=pn.querySelector('.hp-grupo[data-g="veicular"], .hcp-catalog');
        if(vei) pn.insertBefore(g, vei); else pn.appendChild(g);   /* acima da Consulta veicular */
      }
      var lin=g.querySelector('.vpx-steps'); if(lin) lin.innerHTML=html;
      /* 🔴 v816/v817 (pedido do Angelo, com print): "deixe os mais usados
         fazendo movimento da direita pra esquerda, slide contínuo em loop".
         Roda ANTES da fiação: os cards duplicados também precisam do clique. */
      try{ haMarquee(lin); }catch(_){}
      /* os clones precisam do clique de novo (onclick não viaja no outerHTML) */
      try{ consTabsWire(g); }catch(_){}
      try{ homeAtalhosLigar(g); }catch(_){}
      /* 🔴 v840 (§3.3 do projeto) — "cada atalho deve herdar exatamente o
         mesmo estado de acesso do card completo". O clone vem do outerHTML,
         que TRAZ o selo junto; mas a fileira também nasce da RESERVA (v839),
         e aquele botão é montado do zero. Repintar aqui iguala os dois
         caminhos — sem isto, o Estoque apareceria trancado no grupo e solto
         no Mais usados, que é a contradição que o §14 proíbe. */
      try{ acAplicar(g); }catch(_){}
    }catch(_){}
  }
  /* ==========================================================================
     🔴 v817 — A FILEIRA "MAIS USADOS" ANDA SOZINHA (a segunda tentativa)
     -------------------------------------------------------------------------
     Pedido: "deixe os mais usados fazendo movimento da direita pra esquerda,
     slide contínuo em loop."

     ⚠️ A v816 TENTOU e QUEBROU — a lição vale mais que o código:
        eu embrulhei os cards numa trilha nova (`.hp-mq`) e animei o
        `transform` dela. No computador a fileira virou uma COLUNA de dez
        cards empilhados. Motivo: essa mesma grade carrega a classe
        `.vpx-steps`, que no desktop é `display:flex; flex-direction:column`
        (linha ~1704 do styles.css) — e havia mais quatro regras com
        `!important` disputando `display`, `overflow` e `flex-basis` nesse
        elemento. Cada wrapper novo é uma aposta contra TODAS elas.
        A regra que fica: **não embrulhe elementos numa árvore de CSS densa
        só pra animar.** Anime o que já existe.

     Como ficou: os cards são duplicados COMO IRMÃOS, no mesmo lugar onde já
     estavam — nenhum elemento novo, nenhuma regra de CSS contrariada. O que
     anda é a ROLAGEM da própria fileira (`scrollLeft`), um tantinho por
     quadro (HA_MQ_PXS px por segundo). Ao passar da metade, o valor volta pra metade anterior: como as
     duas metades são idênticas, o olho não vê a emenda.

     Cinco cuidados:
     1. SÓ RODA SE ROLAR. Se depois de duplicar a fileira não tiver
        transbordo horizontal (é o caso do computador, onde ela é coluna),
        os clones são REMOVIDOS e nada anda. Foi exatamente esse caso que a
        v816 estragou.
     2. O CLONE NÃO É LIDO NEM RECEBE TAB (aria-hidden + tabindex=-1), mas o
        dedo abre igual — pro dedo é o mesmo botão.
     3. PARA QUANDO ALGUÉM ENCOSTA (dedo, mouse, foco) e enquanto a aba
        estiver escondida — celular no bolso não gasta bateria.
     4. NÃO ATRAPALHA O ARRASTO: quem arrasta com o dedo manda; o laço só
        continua de onde ficou.
     5. `prefers-reduced-motion: reduce` não cria clone nenhum.
     ⛳ ROLLBACK: apagar a chamada `haMarquee(lin)` no haMaisUsadosPinta.
     ======================================================================== */
  /* velocidade do laço, em pixels por segundo. v817 nasceu com 36;
     v819 caiu pra 18 a pedido do Angelo ("diminua 50%"). */
  var HA_MQ_PXS=18;
  /* 🔴 v824 — A GERAÇÃO DO LAÇO. Ver a nota grande dentro do haMarquee:
     sem este número, cada repintura da fileira deixava um laço vivo pra
     trás e as velocidades se SOMAVAM. */
  var _haMqRaf=0, _haMqParado=false, _haMqGer=0;
  function haMarquee(lin){
    /* ======================================================================
       🔴 v824 — O DEFEITO QUE O ANGELO VIU: "começa devagar e depois de
       clicar em algumas páginas e voltar fica rápido".
       ----------------------------------------------------------------------
       Não era impressão, e não era o navegador: eram VÁRIOS LAÇOS RODANDO AO
       MESMO TEMPO, somando 18 px/s cada um.

       Como vazava: o `haMaisUsadosPinta()` roda a cada uso e a cada volta pra
       home, e chama esta função de novo. O `cancelAnimationFrame(_haMqRaf)`
       aqui em cima só matava o laço que JÁ ESTAVA ANDANDO. Mas o arranque é
       agendado por dois `requestAnimationFrame` aninhados (pra medir depois
       do layout), e nesse vão o `_haMqRaf` vale ZERO — o arranque pendente
       não estava guardado em lugar nenhum e portanto não era cancelado.
       Duas pinturas seguidas = dois arranques = dois laços. O `_haMqRaf` só
       guardava o último, e o anterior ficava girando pra sempre, invisível.
       E o `if(!lin.isConnected)`, que devia recolher laço órfão, nunca
       ajudava: a fileira é REAPROVEITADA (só o innerHTML troca), então o
       elemento continua na página e o laço velho continua se achando vivo.

       O conserto é um número de geração: cada chamada tira uma senha, e só a
       senha mais nova pode andar. O laço velho não é "cancelado" — ele
       simplesmente para de se reagendar na primeira batida, e some sozinho.
       ⚠️ POR QUE NÃO SÓ GUARDAR O ID DO ARRANQUE: guardar ajuda (e eu guardo
       também), mas o cancelamento por id depende de a ordem sair perfeita.
       A senha vale mesmo se dois arranques escaparem juntos.
       ====================================================================== */
    var ger=++_haMqGer;
    try{ if(_haMqRaf) cancelAnimationFrame(_haMqRaf); }catch(_){}
    _haMqRaf=0;
    if(!lin) return;
    /* 🔴 v858 (pedido do Angelo): "tire o slide dos mais usados". A saída é
       AQUI, no mesmo ponto por onde já saía quem pede movimento reduzido —
       e é de propósito: esse caminho já era o estado desejado (fileira
       inteira na tela, nenhum clone criado, nada andando) e está provado
       desde a v816. Desligar é passar a andar sempre por ele.
       ⚠️ Note que a saída é ANTES de clonar: sem clone, a fileira fica
       exatamente com os cards de verdade. Não sobra nada na tela.
       ⛳ PRA VOLTAR: `MEV_MAIS_USADOS_DESLIZA = true` no 00-edicoes.js. */
    var querDeslizar=true;
    try{ if(typeof window.edMaisUsadosDesliza==='function') querDeslizar=window.edMaisUsadosDesliza(); }catch(_){}
    if(!querDeslizar) return;

    var paradinho=false;
    try{ paradinho=!!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){}
    if(paradinho) return;
    var itens=Array.prototype.slice.call(lin.children);
    if(itens.length<2) return;   /* um card só não faz laço */

    /* os clones entram como IRMÃOS — mesma altura na árvore, mesmas regras */
    itens.forEach(function(b){
      var c=b.cloneNode(true);
      c.classList.add('hp-mq-c');
      c.setAttribute('aria-hidden','true');
      c.setAttribute('tabindex','-1');
      try{ if(c.id) c.removeAttribute('id'); }catch(_){}
      try{ Array.prototype.forEach.call(c.querySelectorAll('[id]'), function(x){ x.removeAttribute('id'); }); }catch(_){}
      lin.appendChild(c);
    });

    /* 🔴 A GUARDA QUE FALTAVA NA v816.
       Sem transbordo horizontal não existe rolagem pra animar — e a fileira
       ficaria com o dobro de cards parados na tela. Foi o que aconteceu no
       computador. Aqui os clones voltam atrás e a fileira fica como era. */
    var desfaz=function(){
      try{ Array.prototype.forEach.call(lin.querySelectorAll('.hp-mq-c'), function(c){
        if(c.parentNode) c.parentNode.removeChild(c); }); }catch(_){}
      lin.classList.remove('hp-mq-on');
    };
    var meia=0;
    var mede=function(){
      var cs=lin.querySelectorAll('.hp-mq-c');
      if(!cs.length || !lin.children.length) return 0;
      return cs[0].offsetLeft - lin.children[0].offsetLeft;
    };
    var comeca=function(){
      if(ger!==_haMqGer) return;   /* outra pintura passou na frente */
      meia=mede();
      if(!(meia>0) || lin.scrollWidth <= lin.clientWidth+8){ desfaz(); return; }
      lin.classList.add('hp-mq-on');
      var ultimo=0, pos=lin.scrollLeft, escrito=pos;
      var passo=function(agora){
        /* 🔴 a senha é conferida ANTES de reagendar: um laço de geração
           antiga morre aqui, na primeira batida, sem precisar de ninguém. */
        if(ger!==_haMqGer) return;
        _haMqRaf=requestAnimationFrame(passo);
        if(!ultimo){ ultimo=agora; return; }
        var dt=agora-ultimo; ultimo=agora;
        /* 🔴 v824 — ERA AQUI O "COMEÇA DEVAGAR".
           Antes: `if(dt>200) return;` — o quadro demorado era JOGADO FORA.
           A intenção era boa (voltar de segundo plano não pode dar salto),
           mas o efeito colateral apareceu na abertura do app: enquanto a
           home carrega, com imagem e consulta chegando, os quadros passam
           dos 200 ms com facilidade — e cada um deles era descartado. A
           fileira ficava parada ou aos trancos. Depois de navegar e voltar,
           com tudo já em cache, os quadros ficam lisos e ela anda no ritmo
           certo. Não era ela ficando rápida: era ela destravando.
           Agora o quadro demorado não é descartado, é LIMITADO: conta como
           um quadro normal. Sem salto e sem travada. */
        if(dt>120) dt=16;
        if(_haMqParado || document.hidden) return;
        if(!lin.isConnected){ try{ cancelAnimationFrame(_haMqRaf); }catch(_){} _haMqRaf=0; return; }
        /* 🔴 v819 — A CONTA MORA NUMA VARIÁVEL, NÃO NO scrollLeft.
           O Angelo pediu METADE da velocidade, e a fileira PAROU. Motivo: a
           18 px/s cada quadro anda 0,3 px, e `scrollLeft += 0,3` some — o
           navegador arredonda a leitura de volta pro inteiro anterior, e o
           passo seguinte soma 0,3 no mesmo lugar, pra sempre. A 36 px/s
           (0,6 px por quadro) isso não aparecia, e era sorte, não acerto.
           Agora a posição é acumulada aqui em ponto flutuante e só depois
           ESCRITA na fileira — funciona em qualquer velocidade. */
        if(Math.abs(lin.scrollLeft-escrito)>2) pos=lin.scrollLeft;   /* alguém arrastou: manda quem arrastou */
        pos += (HA_MQ_PXS*dt)/1000;
        if(pos>=meia) pos-=meia;
        lin.scrollLeft=pos; escrito=lin.scrollLeft;
      };
      try{ _haMqRaf=requestAnimationFrame(passo); }catch(_){}
    };
    /* pausa: dedo, mouse, foco de teclado — e o arrasto de verdade */
    if(!lin._mqLigado){
      lin._mqLigado=true;
      var para=function(){ _haMqParado=true; };
      var anda=function(){ _haMqParado=false; };
      ['pointerenter','pointerdown','touchstart','focusin'].forEach(function(ev){
        lin.addEventListener(ev, para, { passive:true }); });
      ['pointerleave','pointerup','pointercancel','touchend','touchcancel','focusout'].forEach(function(ev){
        lin.addEventListener(ev, anda, { passive:true }); });
    }
    _haMqParado=false;
    /* o arranque agora fica GUARDADO no _haMqRaf — era o que faltava pra
       uma chamada seguinte conseguir cancelá-lo */
    try{ _haMqRaf=requestAnimationFrame(function(){ _haMqRaf=requestAnimationFrame(comeca); }); }
    catch(_){ setTimeout(comeca,60); }
  }
  function homeAtalhosLista(){
    return HOME_ATALHOS.filter(function(it){
      if(it[0]==='vitrine') return !!MENU_VITRINE;
      if(it[0]==='apps'){ try{ return (typeof window.edAppsVisivel==='function')?!!window.edAppsVisivel(_ehAdmin()):true; }catch(_){ return true; } }
      /* 🔴 v639 — card de PÁGINA obedece à edição. Sem isto, o MEV Consultas
         mostraria Estoque, Vendas e Catálogo na home e cada toque abriria a
         porta de upsell — a grade viraria uma vitrine de coisas que aquele
         app não tem. O portão é o mesmo das páginas do menu. */
      if(it[3]==='drawer'){
        try{ if(typeof window.edicaoPermite==='function') return !!window.edicaoPermite(it[0]); }catch(_){}
      }
      /* 🔴 v918 — E O "SITE" TAMBÉM, que escapava por não ser 'drawer'.
         O portão da v639 só olhava os cards de PÁGINA (it[3]==='drawer'); o
         Site abre por 'fab' e passava batido pela regra. Ele estava sumindo
         no MEV Consultas por uma linha de CSS do 00-edicoes
         (`['[data-ha="site"]','loja']`) — o que quer dizer que o botão
         NASCIA, com handler ligado, e só ficava invisível. O projeto de 06/09
         é explícito: "não resolver isso escondendo tudo por CSS ... leitor de
         tela ainda poderia encontrar ação escondida". Agora ele não nasce.
         ⚠️ Genérico de propósito: é o mesmo mapa BLOCOS, então o Site
         continua aparecendo em toda edição que tem a Loja. */
      if(it[0]==='site'){
        try{ if(typeof window.edPode==='function') return window.edPode('loja'); }catch(_){}
      }
      return true;
    });
  }
  /* ==========================================================================
     🔴 v839 (§9) — CADA CARD DIZ O QUE ELE ENTREGA
     ==========================================================================
     "Cada card de consulta deve apresentar ícone, nome canônico e descrição
     curta, preferencialmente em uma linha."

     🔑 POR QUE ISSO IMPORTA MAIS AQUI DO QUE PARECE: "RENAJUD", "Gravame" e
     "Leilão + PT" são nomes de ÓRGÃO e de JARGÃO, não de resultado. Quem está
     começando na loja lê a grade inteira e não sabe qual custa token à toa. A
     descrição é a diferença entre escolher e adivinhar.

     REGRAS DO §9, e elas foram medidas, não estimadas:
       · até ~48 caracteres (a maior daqui tem 38 — cabe em UMA linha no card
         de 126px do celular e sobra folga no computador);
       · nunca repetir o título ("Multas" não vira "Consulta de multas");
       · no máximo 2 linhas — quem passar disso é cortado pelo CSS, não some;
       · celular muito estreito (≤420px) esconde a descrição e preserva nome e
         custo, que são o que decide o toque.

     ⚠️ ESTA TABELA NÃO É UMA SEGUNDA LISTA DE CARDS. Ela só põe TEXTO em
     chaves que já existem na CONS_TABS e na HOME_ATALHOS. Chave sem descrição
     aqui simplesmente não ganha a linha — o card nasce igual ao de antes.
     É de propósito: card novo funciona no dia em que nasce, sem depender de
     alguém lembrar de escrever a frase.
     ========================================================================= */
  var CARD_DESC={
    /* consultas de veículo */
    fipe:'Valor FIPE por marca, modelo e ano',
    proprietarios:'Donos e transferências registradas',
    gravame:'Banco, contrato e alienação',
    recall:'Recall por placa e chassi, com FIPE',
    debitos:'IPVA, multas, licenciamento e alienação',
    multas:'Ocorrências e valores informados',
    renajud:'Restrições judiciais do veículo',
    leilaopt:'Indícios de leilão e perda total',
    premium:'Todos os dados num laudo só',
    especialjud:'Leilão especial e bloqueios judiciais',
    /* pessoa e empresa */
    cpf:'Cadastro, pendências e score bancário',
    cpfproc:'Processos judiciais no nome',
    cpfscore:'Pontuação de crédito da pessoa',
    cnpj:'Cadastro e situação da empresa',
    cnpjcompliance:'Score, protestos, negativações e listas públicas',
    cnpjsintegra:'IE, situação cadastral e regime estadual',
    cnpjprocessos:'Processos judiciais no nome da empresa',
    /* atalhos */
    foto:'A câmera preenche a placa por você',
    hist:'Tudo que você já consultou',
    loja:'Dados, logo e horários da loja',
    estoque:'Veículos, fotos, preços e situação',
    mercado:'O que os outros lojistas anunciam',
    repasse_meu:'Ofertas entre lojas',
    catalogo:'A lista de veículos pra enviar',
    vendas:'Negócios fechados e em andamento',
    avaliacoes:'Valores, ofertas e negociações',
    vitrine:'Seus veículos na página pública',
    site:'A página da loja na internet',
    clientes:'Contatos que ainda não compraram',
    posvendas:'Quem já comprou e o pós-venda',
    cadastro:'Seus dados e seu acesso',   /* v920 */
    tokens:'Saldo disponível e histórico de uso',
    pagamentos:'Consumo, faturas e recibos',
    apps:'Os outros aplicativos da família'
  };
  /* a linha só nasce quando há frase; sem frase o card fica como sempre foi */
  function cardDescHtml(k){
    /* ⛳ v843 (pedido, com print): as frases saíram dos cards. O interruptor
       mora no 00-edicoes.js (MEV_CARD_DESC) e a tabela acima continua
       inteira — some a frase, não o texto. */
    try{ if(typeof window.edCardDesc==='function' && !window.edCardDesc()) return ''; }catch(_){}
    try{ var d=CARD_DESC[k]; return d?('<span class="vpx-ds">'+esc(d)+'</span>'):''; }
    catch(_){ return ''; }
  }
  function homeAtalhoBt(it, classe){
    var nome=(it[0]==='tokens')?('Saldo <span class="ha-sal sc-n">—</span>'):esc(it[1]);
    var extra=(it[4]==='forte'?' vpx-forte':'')+((it[0]==='tokens')?' saldo-chip':'');
    return '<button type="button" class="vpx-st '+(classe||'')+extra+'" data-ha="'+it[0]+'" data-grupo="'+it[2]+'">'
      +'<span class="vpx-ico">'+homeAtalhoIco(it[0])+'</span><span class="vpx-nm">'+nome+'</span>'
      +cardDescHtml(it[0])+'</button>';
  }
  /* o clique, num lugar só — os MESMOS destinos de sempre, nenhuma rota nova */
  function homeAtalhoClique(k){
    /* 🔴 v840 — O PORTÃO DO PLANO VEM ANTES DE TUDO, inclusive antes de
       contar o uso: card bloqueado que soma "mais usado" encheria a fileira
       de coisas que a pessoa não consegue abrir. Quando o portão trata o
       clique (abre o modal, ou espera o servidor responder), ele devolve
       true e a navegação não acontece.
       ⚠️ Só módulo de gestão passa por aqui. Consulta nenhuma. */
    try{ if(typeof acPortao==='function' && acPortao(k)) return; }catch(_){}
    var it=HOME_ATALHOS.filter(function(x){ return x[0]===k; })[0];
    var como=it?it[3]:'drawer';
    if(como!=='cons'){ try{ haUsoMarca(k); }catch(_){} }   /* v703 (o 'cons' conta no consIr) */
    try{
      if(como==='hist'){ abrirHistorico(); return; }
      if(como==='loja'){ haLojaAlterna(); return; }
      if(como==='cons'){ consIr(k); return; }
      if(como==='fab'){ var alvo={ site:'btnSiteFab', foto:'btnFotoFab' }[k]; var el=alvo?$(alvo):null; if(el) el.click(); return; }
      drawerIr(k);
    }catch(_){}
  }
  function homeAtalhosLigar(root){
    try{
      Array.prototype.forEach.call((root||document).querySelectorAll('[data-ha]'),function(b){
        var k=b.getAttribute('data-ha');
        if(k==='tokens') return;   /* a classe saldo-chip já cuida do clique */
        b.onclick=function(){ homeAtalhoClique(k); };
      });
      var ref=document.querySelector('#btnSaldoFab .sc-n');
      var meus=(root||document).querySelectorAll('.ha-sal');
      if(ref&&ref.textContent) Array.prototype.forEach.call(meus,function(m){ m.textContent=ref.textContent; });
    }catch(_){}
  }

  /* ==========================================================================
     🔴 v648 — OS SELOS DOS CARDS (NOVO · GRÁTIS · N TOKENS)
     ==========================================================================
     Fecha o projeto dos ícones 3D (25/08). No print do Mercado Livre que o
     Angelo mandou, o que puxa o dedo não é o 3D: é o "NOVO", o "GANHE". São
     pílulas de texto. Aqui elas têm FUNÇÃO, não enfeite:

       NOVO      → consulta recém-lançada, e só enquanto for novidade
       GRÁTIS    → o que não cobra token
       N TOKENS  → o preço, ANTES do toque

     ⚠️ NEM TODO CARD LEVA SELO — se todos têm, nenhum tem. Consulta placa,
     Ler placa por foto, Buscar por veículo, Histórico e os 15 cards de página
     ficam limpos. Selo aqui quer dizer "isto tem preço" — e é justamente
     isso que separa uma consulta de uma página.

     🔴🔴 O PREÇO NÃO É COPIADO. Ele sai da MESMA tabela que o botão da página
     usa (VEIC_PAGS/CPF_PAGS). Se o selo tivesse o número escrito à mão, no
     dia em que um preço mudasse o card diria 5 e o botão diria 7 — e alguém
     confiaria no errado. Chave sem preço conhecido fica SEM selo: melhor
     card mudo que card mentindo (regra da v450).

     ===== A REGRA DO "NOVO", decidida pelo Angelo em 25/08 =================
     **Dura 48 horas OU até a pessoa clicar — o que vier primeiro.**

     🔑 As duas condições cobrem os dois jeitos de o selo virar paisagem:
       · quem clica já sabe que existe  → o selo cumpriu o papel, some
       · quem não clica não vai clicar  → o relógio mata o selo
     Sem o clique, o selo grita pra quem já usou. Sem as 48h, fica pra sempre
     pra quem ignorou. Junto, ele SEMPRE morre.

     🔴 48h A PARTIR DE QUANDO? Da PRIMEIRA VEZ QUE AQUELA PESSOA VÊ O CARD —
     não do lançamento. Contar do lançamento faria o selo sumir justamente
     pra quem passou o fim de semana fora: some pra quem mais precisava saber
     da novidade. Cada um ganha as suas 48 horas, começando quando o card
     aparece na frente dele.

     ⚠️ E a marca é gravada quando o card É PINTADO, não quando o app abre —
     senão card que nunca chegou na tela já nasce com o relógio correndo.

     🔴 A CHAVE LEVA O ID DA PESSOA. Numa loja com três vendedores no mesmo
     balcão, chave só com o nome do card faria o primeiro a clicar apagar o
     selo dos outros dois — e os outros dois nunca saberiam da novidade.
     📌 CONSEQUÊNCIA ACEITÁVEL: quem usa celular E computador vê o "NOVO" nos
     dois. É o preço de não criar tabela no banco por causa de um selo.
     ========================================================================= */
  /* 🔴 v648 — o preço da Consulta Plus também vira constante, pelo mesmo
     motivo do Risco no 04: ele aparecia escrito à mão nos textos da página e
     agora o selo do card precisa dele. */
  var PLUS_TOKENS=25;
  var CONS_GRATIS = { cnpj:1 };
  /* 🔴 v648 — O PREÇO VEM DA FONTE, NUNCA DE UMA CÓPIA.
     Lido na HORA de desenhar porque as tabelas moram em outros módulos do
     mesmo IIFE (03 e 03d) e podem não estar prontas quando este arquivo é
     lido. Devolve null quando não sabe — e card sem preço conhecido fica sem
     selo, em vez de inventar um número. */
  function consPreco(k){
    try{
      if(typeof VEIC_PAGS!=='undefined' && VEIC_PAGS[k] && VEIC_PAGS[k].tok) return VEIC_PAGS[k].tok;
      var deCpf={ cpf:'restricao', cpfproc:'proc', cpfscore:'score' }[k];
      if(deCpf && typeof CPF_PAGS!=='undefined' && CPF_PAGS[deCpf] && CPF_PAGS[deCpf].tok) return CPF_PAGS[deCpf].tok;
      if(k==='plus') return PLUS_TOKENS;
      /* v1000 — mesma regra: lido da FONTE (o 04), nunca de uma cópia aqui */
      if(k==='cnpjcompliance' && typeof CNPJ_CMPL_TOK!=='undefined') return CNPJ_CMPL_TOK;
      if(k==='cnpjsintegra' && typeof CNPJ_SINTEGRA_TOK!=='undefined') return CNPJ_SINTEGRA_TOK;
      if(k==='cnpjprocessos' && typeof CNPJ_PROC_TOK!=='undefined') return CNPJ_PROC_TOK;   /* v1024 */
    }catch(_){}
    return null;
  }
  /* ==========================================================================
     🔴 v918 — O SELO "NOVO" SAIU (pedido do Angelo, 06/09: "remover o rótulo
     de novo — fica só tokens").
     --------------------------------------------------------------------------
     O canto do card tinha DOIS candidatos disputando o mesmo lugar, e o
     "NOVO" ganhava sempre — então justamente as consultas recém-lançadas
     (Gravame, Leilão + PT, Total Premium) escondiam o PREÇO delas. Quem abre
     a home decide pelo custo: "4 tokens" responde a pergunta que a pessoa
     está fazendo; "NOVO" responde uma que ninguém fez.

     ⚠️ SAIU DA MONTAGEM, não do CSS: o HTML nunca mais escreve o selo, e a
     máquina que o sustentava (o relógio de 48h, a memória por pessoa no
     localStorage) foi embora junto — cálculo morto e gravação inútil.
     Ver o changelog da v918 se um dia a ideia voltar: ela mora inteira lá.
     ========================================================================== */
  /* o selo de um card, ou vazio. UM só por card — o mais importante ganha. */
  function seloHtml(k){
    try{
      if(CONS_GRATIS[k]) return '<span class="hp-selo hp-selo-gratis">GRÁTIS</span>';
      var p=consPreco(k);
      if(p==null) return '';
      return '<span class="hp-selo hp-selo-preco">'+esc(precoReal(p))+'</span>';
    }catch(_){ return ''; }
  }

  /* ==========================================================================
     🔴 v649 (pedido do Angelo, 25/08, com o print da tela do CPF) — A BARRINHA
     DAS PÁGINAS INTERNAS MOSTRA SÓ A FAMÍLIA
     ==========================================================================
     "quando cliquei na consulta cpf apareceu esses cards, deixe o consulta
      placa e só os ligados a consulta de cpf - deixe no mesmo padrão da tela
      inicial"

     No print: ele abre a Consulta CPF e leva ONZE cards na cara — Gravame,
     Multas, RENAJUD, CNPJ, Risco de crédito. Nada daquilo tem a ver com o CPF
     que ele foi consultar. A barrinha nasceu na v387 com cinco consultas e
     foi engordando versão a versão até virar um índice do app inteiro no topo
     de toda página.

     🔴 AGORA ELA MOSTRA SÓ A FAMÍLIA DA CONSULTA ABERTA, mais a Consulta
     placa, que fica sempre — é a ação nº 1 do app e a porta de volta pra
     todo o resto.

     ⚠️ FAMÍLIA É MAIS ESTREITO QUE GRUPO, e é isso que o pedido pede. O grupo
     "Análise de risco" junta CPF e CNPJ porque na home eles ocupam a mesma
     seção; aqui não serve: **CNPJ é empresa, CPF é pessoa.** Quem está
     consultando um CPF não quer os cards de empresa do lado.

     🔑 E O PADRÃO É O MESMO DA TELA INICIAL — não por gosto, por economia de
     cabeça: a mesma grade, o mesmo fundo de grupo, os mesmos ícones grandes,
     os mesmos selos de preço. Duas telas com duas caras pra mesma coisa é o
     que a v386 já tinha desfeito no histórico.
     ⛳ EFEITO DE TABELA: a coluna lateral de 250px do computador some sozinha,
     porque a regra dela pedia `.cons-tabs` como FILHO DIRETO de #secoes — e
     agora ele mora dentro do bloco do grupo. A página interna passa a ter a
     grade em cima e o conteúdo embaixo, igual à home.
     ========================================================================= */
  var CONS_FAMILIA={
    placa:'veiculo', fipe:'veiculo', plus:'veiculo',
    proprietarios:'veiculo', gravame:'veiculo', recall:'veiculo', debitos:'veiculo', multas:'veiculo', renajud:'veiculo',
    leilaopt:'veiculo', premium:'veiculo', especialjud:'veiculo',   /* v995 */
    cpf:'cpf', cpfproc:'cpf', cpfscore:'cpf',
    cnpj:'empresa',   /* v996: cnpjrisco saiu */
    cnpjcompliance:'empresa',   /* v1000 */
    cnpjsintegra:'empresa',
    cnpjprocessos:'empresa'   /* v1024 */
  };
  var CONS_FAM_TIT={
    veiculo:'Consulta veicular',
    cpf:'Análise de risco · CPF',
    empresa:'Análise de risco · CNPJ'
  };
  /* ---------- a barrinha de abas (v649: a grade da família) ---------- */
  function consTabsHtml(atual){
    var fam=CONS_FAMILIA[atual]||'veiculo';
    var lista=CONS_TABS.filter(function(t){ return (CONS_FAMILIA[t[0]]||'veiculo')===fam; });
    /* 🔴 a Consulta placa fica SEMPRE, e sempre primeiro. Sem ela, quem entra
       numa página de CPF não tem como voltar pra placa sem abrir o menu. */
    if(fam!=='veiculo'){
      var pl=CONS_TABS.filter(function(t){ return t[0]==='placa'; });
      lista=pl.concat(lista);
    }
    /* ==========================================================================
       \U0001f534 v668 (pedido do Angelo) — "na pagina de consulta placa da pra
       ocultar o card de consulta placa"
       --------------------------------------------------------------------------
       \U0001f511 CARD PRA ONDE VOCÊ JÁ ESTÁ NÃO É ATALHO, É RUÍDO. A página já diz
       onde você está, em letra grande, com o desenho e a explicação, logo
       acima da grade. O card repetia a mesma informação ocupando o lugar de um
       destino de verdade.
       ⚠️ E ELE NÃO SUMIU DA LISTA — sumiu da TELA em que ele é redundante. Em
       qualquer outra página o card continua lá, inteiro. Quem some é a cópia,
       não o caminho (regra v568: desligar mostrando o caminho). */
    lista=lista.filter(function(t){ return t[0]!==atual; });
    var cards=lista.map(function(t){
      var on=(t[0]===atual);
      var ico=_CT_ICO[t[0]]||'';   /* v762: SVG de linha (o 3D saiu dos cards funcionais) */
      return '<button type="button" class="vpx-st'+(on?' on':'')+'" role="tab" aria-selected="'+(on?'true':'false')+'" data-cons="'+t[0]+'">'
        +seloHtml(t[0])
        +'<span class="vpx-ico">'+ico+'</span><span class="vpx-nm">'+esc(t[1])+'</span></button>';
    }).join('');
    /* ⚠️ a classe `cons-tabs` FICA no contêiner da grade: é por ela que a
       edição esconde consulta fora do pacote (00-edicoes, regra 3.3) e é por
       ela que o consTabsWire acha os botões. Tirar o nome quebraria as duas
       coisas em silêncio. */
    return '<div class="mev-grade hp-grupo cons-fam" data-g="'+fam+'">'
      +'<div class="hp-tit">'+esc(CONS_FAM_TIT[fam]||'Consultas')+'</div>'
      +'<div class="vpx-steps vpx-mdr hp-grade cons-tabs" role="tablist" aria-label="Tipo de consulta">'+cards+'</div>'
      +'</div>';
  }
  function consTabsWire(root){
    root=root||document;
    Array.prototype.forEach.call(root.querySelectorAll('.cons-tabs .vpx-st'),function(b){
      b.onclick=function(){ consIr(b.getAttribute('data-cons')); };
    });
    /* deixa a aba ativa visível na barrinha rolável (sem mexer na rolagem da página) */
    try{
      var on=root.querySelector('.cons-tabs .vpx-st.on');
      if(on){ var bar=on.parentNode; bar.scrollLeft=Math.max(0, on.offsetLeft-(bar.clientWidth-on.offsetWidth)/2); }
    }catch(_){}
  }
  /* v884 — o segundo parâmetro é a placa que a tela de origem já tinha na
     mão (o resultado da consulta, por exemplo). Ela viaja pro campo da próxima
     consulta e PARA ALI: quem dispara a consulta paga continua sendo o botão.
     ⚠️ Opcional de propósito — todas as chamadas antigas continuam valendo. */
  function consIr(key, placa){
    /* v1402 — a integração estadual está suspensa. Links antigos e atalhos
       guardados não podem reabrir silenciosamente um produto fora de venda. */
    try{
      if(key==='debitos' && typeof window.edConsultaLigada==='function' && !window.edConsultaLigada(key)){
        toast('Débitos e restrições está temporariamente indisponível.'); return;
      }
    }catch(_){}
    if(edicaoAtual()==='avalia' && key!=='avl'){
      if(!avAreaSalvar()) return;
      avAreaMarcar('consultas');
    }
    try{ haUsoMarca(key); }catch(_){}   /* v703: o cofre dos mais usados */
    /* 🔴 v648 — clicou, o "NOVO" cumpriu o papel e morre. Fica ANTES de
       qualquer porta de upsell de propósito: quem tocou já sabe que a
       consulta existe, mesmo que a edição dele não deixe entrar. */
    /* v486 — EDIÇÕES: aba de consulta fora da edição abre a porta (o CSS já
       esconde a pílula; isto segura o deslize e qualquer atalho antigo). */
    /* v499: quem já TEM o pacote não leva porta de venda — a consulta abre
       (a edição esconde a pílula, mas não tranca a porta). */
    try{
      if(typeof window.edConsPermite==='function' && !window.edConsPermite(key)
         && !(typeof window.edTemPacote==='function' && window.edTemPacote(key))){
        window.edPortaAbrir(key); return;
      }
    }catch(_){}
    /* v1002 — no MEV Consultas, cada produto pago abre primeiro sua landing
       explicativa. O salto direto é usado uma única vez pelo CTA da própria
       landing; resultados e histórico continuam abrindo pelos fluxos antigos. */
    try{ if(typeof consultaLandingIntercepta==='function' && consultaLandingIntercepta(key, placa)) return; }catch(_){}
    /* ===== v595 (pedido 22/08): o card "Avaliações" da grade da home ====
       "ao lado da consulta CNPJ deixe um card pra abrir a página de
       avaliações". É PÁGINA, não consulta — o portão é o das PÁGINAS
       (edicaoPermite/'avaliacoes'), com a mesma regra do v499: quem tem o
       pacote entra; quem não tem leva a porta de upsell, nunca erro seco.
       O card só nasce na grade da HOME (consTabsHome) — a barrinha das
       páginas internas continua só com as consultas. */
    if(key==='avl'){
      try{
        if(typeof window.edicaoPermite==='function' && !window.edicaoPermite('avaliacoes')
           && !(typeof window.edTemPacote==='function' && window.edTemPacote('avaliacoes'))){
          window.edPortaAbrir('avaliacoes'); return;
        }
      }catch(_){}
      try{ telaAvaliacoes(); }catch(_){}
      return;
    }
    if(key==='placa'){
      voltarHome();
      return;
    }
    if(key==='fipe'){ abrirBuscaVeiculo(); return; }
    if(key==='hist'){ abrirHistorico(); return; }   /* v406: fora das abas, mas o caminho continua valendo */
    if(key==='plus'){ abrirConsultaPlus(); return; }
    if(key==='cpf'){ abrirRestricao('restricao'); return; }
    if(key==='cpfproc'){ abrirRestricao('proc'); return; }        /* v613 */
    if(key==='cpfscore'){ abrirRestricao('restricao'); return; } /* rota antiga: score agora integra a Consulta CPF */
    if(key==='cnpj'){ abrirCnpj(); return; }
    if(key==='cnpjcompliance'){ abrirCnpjPag('compliance'); if(placa) setTimeout(function(){ try{ _cnpjDoHistorico(placa); }catch(_){} },0); return; }   /* v1000/v1349 */
    if(key==='cnpjsintegra'){ abrirCnpjPag('sintegra'); if(placa) setTimeout(function(){ try{ _cnpjDoHistorico(placa); }catch(_){} },0); return; }
    if(key==='cnpjprocessos'){ abrirCnpjPag('processos'); if(placa) setTimeout(function(){ try{ _cnpjDoHistorico(placa); }catch(_){} },0); return; }     /* v1024/v1349 */
    /* v628 — as consultas de veículo (03d). Uma função só pras três. */
    if(VEIC_PAGS && VEIC_PAGS[key]){ abrirVeicPag(key, placa); return; }   /* v884 */
  }
  /* põe a barrinha no topo de uma página interna (#secoes) */
  function consTabsInjetar(key){
    try{
      var sc=$('secoes'); if(!sc) return;
      var velha=sc.querySelector('.cons-tabs'); if(velha&&velha.parentNode) velha.parentNode.removeChild(velha);
      sc.insertAdjacentHTML('afterbegin', consTabsHtml(key));
      /* v918: aqui morava a marca do selo "NOVO" (a janela de 48h por
         pessoa). O selo saiu; ficou só a montagem da barrinha. */
      consTabsWire(sc);
    }catch(_){}
  }
  /* põe a barrinha no topo da tela inicial (uma vez só; o DOM da home é fixo) */
  /* ==========================================================================
     v626 — A HOME EM GRADE: UM PAINEL COM TRÊS GRUPOS
     ==========================================================================
     Pedido do Angelo: "quero alterar a pagina inicial pra ficar parecida com
     mobile com cards em formato de grade ao inves de menu" — alternativa B
     (painel com grupos), e a decisão nº 4: **os grupos valem NO CELULAR
     TAMBÉM; as duas telas não divergem.**

     A v625 já tinha juntado as duas listas de atalho numa só. Aqui entra o
     desenho — e ele é UM só, montado uma vez, servindo as duas larguras.

     O QUE VEIO DA MAQUETE DO CANVA (e o que ficou de fora):
       ✅ ÍCONE EM CIMA, RÓTULO EMBAIXO — o atalho vira alvo, não linha de
          lista. A grade do celular já fazia assim; o computador aprendeu.
       ✅ UM TRAÇO SÓ, UMA COR SÓ. A única exceção continua sendo a que já
          existia: "Ler placa por foto" em azul cheio (v531), porque é a
          única que abre a CÂMERA e não uma página.
       ✅ A GRADE DENTRO DE UM PAINEL — cartão branco, largura máxima 860px,
          centrado. É o que separa o menu do fundo.
       ❌ O VIDRO TRANSLÚCIDO não veio: ele depende de foto atrás. Aqui o
          fundo é liso, então só custaria desempenho em máquina fraca.
       ❌ A FRASE "escolha uma categoria" não entra. Regra da casa: sem
          explicação de botão na tela. Os três rótulos já dizem isso.

     🔴 A PLACA CONTINUA MANDANDO: ela fica DENTRO do painel, no topo, ANTES
     dos grupos — é a ação nº 1 do app e não pode virar mais um quadradinho.
     O cartão dela (.home-left) é MOVIDO pra dentro do painel; nada é
     recriado, então tudo que já estava ligado nele continua ligado.

     ⚠️ O CARTÃO DE HISTÓRICO DA v619 fica ABAIXO do painel, não dentro —
     ele é conteúdo, não atalho. E continua só no computador. */
  function homePainelMontar(){
    try{
      var th=$('telaHome'); if(!th) return;
      var box=$('consTabsHome');
      if(!box){ box=document.createElement('div'); box.id='consTabsHome'; th.insertBefore(box, th.firstChild); }
      /* v1002 — composição exclusiva da edição MEV Consultas. As demais
         edições seguem pelo painel histórico logo abaixo, sem qualquer delta. */
      try{ if(typeof homeConsultasPremiumMontar==='function' && homeConsultasPremiumMontar(box,th)) return; }catch(_){}
      if(box.querySelector('.home-painel')){ try{ haMaisUsadosPinta(); }catch(_){} try{ haUsoNuvemCarregar(); }catch(_){} try{ acAplicar(box); }catch(_){} haAppsSync(); return; }   /* já montado — só a fileira do uso repinta (v711) + o estado do plano (v840) */

      /* v639 — as consultas viram DOIS grupos: o que pergunta sobre o CARRO
         e o que pergunta sobre QUEM está do outro lado do negócio.
         ⚠️ O card "Avaliações" saiu daqui: ele era o MESMO destino do card de
         Lojista, e destino repetido na mesma tela é escolha falsa. */
      function gCons(qual){
        return _pecasCons(qual).map(function(x){ return x.html; }).join('');
      }
      function _pecasCons(qual){
        /* v675 (pedido, com print: "remove o card de consulta placa dentro da
           página de consulta, já tem o campo pra buscar") — NA HOME o card
           'placa' não existe mais. O campo da placa está LOGO ACIMA dele, e o
           clique no card só chamava voltarHome() — na home, um botão que não
           faz nada. Card que não faz nada ensina a não tocar nos cards.
           ⚠️ SÓ AQUI. Nas páginas internas (consTabsInjetar) ele CONTINUA:
           lá ele é o caminho de volta pro campo da placa — e a v668 já tira
           o card da página em que você está, então não há repetição lá. */
        return CONS_TABS.filter(function(t){ return t[0]!=='placa' && (CONS_GRUPO[t[0]]||'veicular')===qual; })
          .map(function(t){
            /* v762: SVG de linha (o 3D saiu dos cards funcionais — projeto de 30/08) */
            var _ico=_CT_ICO[t[0]]||'';
            return { chave:t[0], html:'<button type="button" class="vpx-st" role="tab" aria-selected="'+(t[0]==='placa'?'true':'false')+'" data-cons="'+t[0]+'">'
              +seloHtml(t[0])   /* v648 */
              +'<span class="vpx-ico">'+_ico+'</span><span class="vpx-nm">'+esc(t[1])+'</span>'
              +cardDescHtml(t[0])+'</button>' };
          });
      }

      function grupo(chave, titulo, dentro, classes){
        if(!dentro) return '';
        return '<div class="hp-grupo" data-g="'+chave+'"><div class="hp-tit">'+esc(titulo)+'</div>'
          +'<div class="vpx-steps vpx-mdr hp-grade '+(classes||'')+'" role="group" aria-label="'+esc(titulo)+'">'+dentro+'</div></div>';
      }
      function daLista(g){
        return _pecasLista(g).map(function(x){ return x.html; }).join('');
      }
      function _pecasLista(g){
        return homeAtalhosLista().filter(function(it){ return it[2]===g; })
          .map(function(it){ return { chave:it[0], apos:it[5]||'', html:homeAtalhoBt(it,'ha-bt') }; });
      }
      /* 🔴 v645 — O `apos` EM AÇÃO. Junta as consultas e os atalhos do grupo
         numa fileira só e, pra cada atalho que pediu lugar ("entro depois do
         `placa`"), tira ele do fim e encaixa ali.
         ⚠️ Quem pede um vizinho que NÃO está na tela (escondido pela edição,
         ou renomeado) simplesmente fica onde estava, no fim — nunca some.
         Card que desaparece por causa de um nome errado é o defeito calado
         que este projeto todo vem evitando. */
      function _pecasGrupo(g){
        var base=_pecasCons(g).concat(_pecasLista(g));
        /* primeiro os que não pediram lugar, na ordem das listas; depois cada
           um que pediu é ENCAIXADO ao lado do vizinho. Montar assim (em vez de
           mover dentro da fileira) evita a conta de índice que muda embaixo do
           pé enquanto se remove e insere. */
        var fila=base.filter(function(x){ return !x.apos; });
        base.filter(function(x){ return x.apos; }).forEach(function(x){
          if(x.apos==='_inicio'){ fila.unshift(x); return; }   /* v675: primeiro do grupo */
          var alvo=-1;
          for(var i=0;i<fila.length;i++){ if(fila[i].chave===x.apos){ alvo=i; break; } }
          if(alvo<0) fila.push(x);               /* vizinho fora da tela: entra no fim, nunca some */
          else fila.splice(alvo+1, 0, x);
        });
        return fila.map(function(x){ return x.html; }).join('');
      }
      /* o destaque da edição (v486/v496) entra na frente do grupo da Loja —
         é a página principal daquela edição, não um atalho fixo da lista */
      var _edDest=null; try{ _edDest=(typeof window.edicaoDestaque==='function')?window.edicaoDestaque():null; }catch(_){}
      var destHtml='';
      if(_edDest){
        destHtml='<button type="button" class="vpx-st ha-bt" data-ha="'+_edDest[0]+'" data-grupo="lojista">'
          +'<span class="vpx-ico">'+(homeAtalhoIco(_edDest[0])||homeAtalhoIco('avaliacoes'))+'</span>'
          +'<span class="vpx-nm">'+esc(_edDest[1])+'</span></button>';
      }

      /* v703 → v711: a fileira dos MAIS USADOS saiu daqui — quem a desenha é
         o haMaisUsadosPinta (lá em cima), chamado no fim desta montagem e a
         cada uso. Montada aqui, ela nascia congelada na abertura do app. */
      var _somenteConsultas=false;
      try{ _somenteConsultas=(typeof window.edicaoAtual==='function' && ['consultas','avalia'].indexOf(window.edicaoAtual())!==-1); }catch(_){}
      box.innerHTML='<div class="home-painel mev-grade" id="homePainel">'
        + grupo('veicular',_somenteConsultas?'Consultas do veículo':'Consulta veicular', _pecasGrupo('veicular'), 'cons-tabs')
        + grupo('risco',_somenteConsultas?'Pessoa e empresa':'Análise de risco · CPF e CNPJ', _pecasGrupo('risco'), 'cons-tabs')
        + (_somenteConsultas?'':grupo('lojista','Lojista', destHtml+daLista('lojista')))
        + (_somenteConsultas?'':grupo('crm','CRM', daLista('crm')))
        + grupo('conta','Conta', daLista('conta'))
        +'</div>';

      /* 🔴 a placa vai pra DENTRO do painel, no topo — movida, não recriada:
         o campo, os handlers e a sugestão de placas continuam os mesmos. */
      try{
        var pn=box.querySelector('.home-painel'), hl=th.querySelector('.home-left');
        if(pn&&hl) pn.insertBefore(hl, pn.firstChild);
      }catch(_){}
      /* v745 — a ENTRADA da home acontece UMA vez por sessão: a classe entra
         no painel recém-montado e sai 700 ms depois. Como o painel não é
         remontado (linha "já montado" lá em cima), repintar o Mais usados ou
         voltar de uma tela interna não reanima nada. A placa pulsa duas
         vezes e ganha .placa-pulsou no fim — também só uma vez. */
      try{
        var _pnE=box.querySelector('.home-painel');
        if(_pnE && !window.__hpEntrou){ window.__hpEntrou=1; _pnE.classList.add('hp-entrada'); setTimeout(function(){ try{ _pnE.classList.remove('hp-entrada'); }catch(_){} }, 700); }
        var _pb=document.querySelector('.placa-big');
        if(_pb && !_pb.__pulso){ _pb.__pulso=1; _pb.addEventListener('animationend', function(){ try{ _pb.classList.add('placa-pulsou'); }catch(_){} }); }
      }catch(_){}

      /* v918: aqui morava a marca do "viu" do selo NOVO, gravada depois que
         o painel já existia no DOM. O selo saiu; nada a marcar. */
      consTabsWire(box);
      homeAtalhosLigar(box);
      if(_edDest){
        try{ var _bd=box.querySelector('[data-ha="'+_edDest[0]+'"]');
          if(_bd) _bd.onclick=function(){ try{ drawerIr(_edDest[0]); }catch(_){} }; }catch(_){}
      }
      try{ haMaisUsadosPinta(); }catch(_){}   /* v711: a fileira nasce clonando os cards já montados */
      try{ haUsoNuvemCarregar(); }catch(_){}   /* v739: e a nuvem chega em seguida, repintando */
      /* v840 — o estado de plano é pintado AGORA (neutro, sem presumir acesso)
         e repintado sozinho quando o /api/cobranca responder */
      try{ acAplicar(box); }catch(_){}
      try{ acGarantir(); }catch(_){}
      try{ acModalLigar(); }catch(_){}
      haAppsSync();
    }catch(_){}
  }
  /* os dois nomes antigos continuam valendo: meia dúzia de lugares chamam um
     ou outro, e trocar todos só criaria chance de esquecer um. */
  function consTabsHome(){ homePainelMontar(); }


  /* ===== v417 (pedido) — OS FABS DO COMPUTADOR VIRARAM CARDS NO MENU =====
     "esses fab do desktop deixe no menu em formato de card — só fica o fab
     do menu". Tokens · Catálogo · Site · Ler placa por foto entram como
     cards abaixo das consultas, atrás de uma divisória (só no computador —
     no celular a grade v408 já tem tudo, e o CSS esconde este bloco).
     Os cliques repassam pros FABs de sempre (escondidos, handlers vivos);
     o Tokens usa a classe saldo-chip: pintor e clique dos pacotes já
     funcionam por ela (v393). Os botões ficam num .cons-tabs próprio pra
     HERDAR o visual de coluna do menu — mas SEM data-cons, então o
     consTabsWire não os leva pra lugar nenhum, e sem .on o deslize do
     18d ignora a barra. */
  /* ⚠️ v625: este bloco guarda as DECISÕES e os interruptores que moravam
     junto do antigo _ctFabsHtml — o comentário da v417 (os FABs viraram
     cards), o interruptor da Vitrine (v568) e os dois ícones. A montagem em
     si virou a lista única lá em cima; isto aqui NÃO é sobra, é o porquê. */
  /* ===== v417 (pedido) — OS FABS DO COMPUTADOR VIRARAM CARDS NO MENU =====
     "esses fab do desktop deixe no menu em formato de card — só fica o fab
     do menu". Tokens · Catálogo · Site · Ler placa por foto entram como
     cards abaixo das consultas, atrás de uma divisória (só no computador —
     no celular a grade v408 já tem tudo, e o CSS esconde este bloco).
     Os cliques repassam pros FABs de sempre (escondidos, handlers vivos);
     o Tokens usa a classe saldo-chip: pintor e clique dos pacotes já
     funcionam por ela (v393). Os botões ficam num .cons-tabs próprio pra
     HERDAR o visual de coluna do menu — mas SEM data-cons, então o
     consTabsWire não os leva pra lugar nenhum, e sem .on o deslize do
     18d ignora a barra. */

  /* o mesmo tique da Avaliações do menu (app.html) e do _ICO_DEST — um só
     desenho pra uma só ideia */
  /* ==========================================================================
     ⛳ v568 — A VITRINE SAI DO MENU E DO CARD INICIAL
     PEDIDO: *"remove vitrine do menu e do card inicial, no card inicial deixe
     catálogo"* — e, no meio do caminho, a correção: *"o card vitrine sai, não
     precisa pôr o catálogo no lugar, já tem na loja"*. E é verdade: o Catálogo
     mora dentro da listinha da Loja desde a v470. Pôr de novo na fileira seria
     a MESMA porta duas vezes na mesma tela, que é o problema que esta versão
     veio resolver.

     🔴 ESCONDER NÃO É APAGAR. A página continua existindo, o `drawerIr
     ('vitrine')` continua atendendo e a ação continua registrada no mapa das
     edições (00-edicoes). Desregistrar faria o teste-v496 acusar "página
     órfã" — e uma linha basta pra tudo voltar.

     🔴🔴 E O ITEM DO MENU SOME POR `style="display:none"` INLINE, NÃO POR
     CLASSE. O 18b monta a rota do DESLIZE lendo `style.display`: escondido
     por classe, o item sumiria da vista mas o deslize continuaria parando
     numa página que ninguém mais vê. Foi a armadilha da v437; a v526 e a
     v556 já resolveram assim.
     ========================================================================== */
  var MENU_VITRINE = false;

  /* Chamado na ABERTURA do menu (08), junto com o da Cotação — e NÃO no init:
     o drawer é remontado/repintado, e decidir na abertura é o que garante que
     o item obedeça sempre, inclusive depois de trocar de edição. */
  function vitMenuSync(){
    try{
      var el=document.getElementById('mdrVitrineBt');
      if(!el) return;
      el.style.display = MENU_VITRINE ? '' : 'none';
    }catch(_){}
  }

  /* v537 — a lojinha com a vitrine aberta. O MESMO desenho do item de menu
     (app.html) e do cabeçalho da página (14h): um assunto, um ícone. */
  var _HA_ICO_APPS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';   /* v625: era inline na grade do celular */
  var _CTF_ICO_VIT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M9 20v-6h6v6"/></svg>';
  var _CTF_ICO_AVAL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>';

  /* v625: o computador passou a ler a MESMA lista do celular (HOME_ATALHOS).
     O bloco de comentários que morava aqui — cada linha explicando por que
     UM item entrou ou saiu SÓ desta tela — virou história: v417 (os FABs
     viraram cards), v470 (Catálogo → Loja, e o Catálogo continua dentro da
     listinha), v531 (o card do Site deu lugar ao de Avaliação AQUI, porque
     avaliar é rotina diária e o Site é institucional) e v537/v568 (a
     Vitrine, atrás do interruptor). Nenhuma dessas decisões foi desfeita:
     o Site VOLTA a aparecer aqui porque agora as duas telas mostram a mesma
     coisa — que é justamente o que o Angelo pediu. */
  function _ctFabsHtml(){
    return '<div class="vpx-steps vpx-mdr cons-tabs ct-fabs" role="group" aria-label="Atalhos">'
      +homeAtalhosLista().map(function(it){ return homeAtalhoBt(it,'ha-bt'); }).join('')
      +'</div>';
  }
  /* v625: a fiação virou a mesma dos dois lados — homeAtalhosLigar. */
  function _ctFabsWire(root){ homeAtalhosLigar(root); }


  /* ---------- ATALHOS DA HOME NO CELULAR (v408, pedido) ----------
     Grade 2×3 abaixo da consulta de placa, no MESMO formato da grade de
     consultas: Tokens · Histórico · Ler placa por foto · Catálogo · Site ·
     Menu. Substitui os balões flutuantes (FABs) e a lista do histórico na
     home do celular — o CSS esconde os dois lá e esconde ESTA grade no
     computador. Os cliques repassam pros botões de sempre (escondidos, mas
     com os handlers vivos), então nenhuma regra é duplicada; o Tokens tem a
     classe saldo-chip de propósito: o pintor de saldo e o clique dos
     pacotes já funcionam por essa classe (v393). */
  var _HA_ICO={
    tokens:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>',
    foto:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    catalogo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
    site:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18z"/></svg>',
    menu:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg>',
    clientes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'
  };
  /* v497 — a caixinha "Apps MEV" da grade obedece ao interruptor do
     lançamento (MEV_PREVIA no 00-edicoes.js): enquanto ligado, só o dono
     (ou quem já está dentro de uma edição) enxerga. Fica numa função à
     parte porque a grade é montada UMA vez, e quando ela é montada o
     meuId às vezes ainda não chegou — então isto roda de novo a cada
     pintura da home e na abertura do menu. */
  function haAppsSync(){
    try{
      var b=document.querySelector('#homeAtalhos [data-ha="apps"]'); if(!b) return;
      var vis=true;
      try{ vis=(typeof window.edAppsVisivel==='function')?window.edAppsVisivel(_ehAdmin()):true; }catch(_){ vis=true; }
      b.style.display=vis?'':'none';
    }catch(_){}
  }
  /* v626: a grade do celular deixou de ser um bloco à parte — ela virou os
     GRUPOS do painel, os mesmos do computador. A função continua existindo
     porque é chamada de vários lugares (e o #homeAtalhos continua no DOM,
     vazio, porque o 00-edicoes o esconde por id nas edições sem consulta). */
  function homeAtalhosMontar(){ homePainelMontar(); }


  /* ---------- BARRA FIXA DO TOPO (v408 → v410 → v412) ----------
     v412 (pedido, arquivo "v411fotomenudacontaeespacamento"): "o svg de
     sair DENTRO da foto; clica na foto abre uma lista de páginas: meu
     cadastro, minha loja, uso e faturamento, sair".

     Então o botão vermelho solto saiu da barra. O ícone de sair virou um
     SELO dentro da foto (canto de baixo, direita) — é o que conta pra
     pessoa que a foto faz alguma coisa, sem escrever nada na tela. Tocar
     na foto abre a lista da conta (o Sair em vermelho, atrás de um fio).

     NENHUMA TELA NOVA: cada item chama o mesmo drawerIr() do menu lateral
     (as ações cadastro/loja/pagamentos já existem no #mevDrawer) e o Sair
     clica o #btnSair de sempre. O nome da LOJA continua fora da barra
     (pedido de 12/08 — o arquivo colado ainda o trazia; ficou só o nome). */
  var _TB_SVG={
    sair:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>',
    cadastro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.4 8-6.4s8 2.4 8 6.4"/></svg>',
    loja:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.6-5h14.8L21 9"/><path d="M4 9v11h16V9"/><path d="M9.5 20v-6h5v6"/></svg>',
    pagamentos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="3"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>'
  };
  /* [ação do menu lateral, rótulo]. A ação NÃO pode mudar — é o
     identificador que o drawerIr() entende. O rótulo, sim. */
  var _TB_ITENS=[['cadastro','Meu cadastro'],['loja','Minha loja'],['pagamentos','Uso e faturamento'],['sair','Sair']];

  /* ⚠️ Falha pro lado de MOSTRAR, igual ao `edPode` do 00-edicoes: sem o
     portão carregado (módulo fora de ordem, boot pela metade) o botão aparece.
     Esconder por acidente é pior: sumiria o chat do MEV Completo, onde ele é
     o produto. */
  function _tbTemChat(){
    try{ return (typeof window.edPode!=='function') || !!window.edPode('chat'); }
    catch(_){ return true; }
  }
  /* v1308 — no MEV Consultas a navegacao da pagina mora na barra inferior.
     O titulo vem do conteudo que acabou de abrir; Voltar reutiliza o MESMO
     callback do #btnBackFab, portanto nao nasce uma segunda pilha de rotas. */
  function tbTemaBarraSincronizar(){
    try{
      var b=$('tbBackTop'), acao=b&&b.getAttribute('data-acao');
      if(!b || (acao!=='tema' && acao!=='tema-logo')) return;
      var modo=document.body.classList.contains('tema-escuro')?'escuro':'claro';
      var proximo=modo==='claro'?'Escuro':'Claro';
      b.setAttribute('aria-label','Aparência: '+modo+'. Ativar '+proximo.toLowerCase());
      b.setAttribute('title','Ativar '+proximo);
      if(acao==='tema-logo'){
        b.setAttribute('aria-pressed',modo==='escuro'?'true':'false');
        return;
      }
      b.removeAttribute('aria-pressed');
      b.innerHTML=modo==='escuro'
        ?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41"/></svg>'
        :'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z"/></svg>';
    }catch(_){ }
  }
  function tbPaginaAtualizar(titulo){
    try{
      if(typeof window.edicaoAtual!=='function' || ['consultas','avalia'].indexOf(window.edicaoAtual())<0) return;
      var interna=document.body.classList.contains('tela-interna');
      var t=$('tbPageTitle');
      if(t){
        var achado='';
        if(interna){
          var h=document.querySelector('#secoes .consulta-ui-head h2,#secoes .hist-page-title,#secoes .plc-panel-head h2,#secoes h1,#secoes h2');
          achado=h?String(h.textContent||'').replace(/\s+/g,' ').trim():'';
        }
        t.textContent=String(titulo||achado||(interna?'MEV Consultas':'Início')).trim();
      }
      var b=$('tbBackTop');
      if(b){
        b.hidden=false;b.disabled=false;b.setAttribute('aria-hidden','false');
        if(interna){
          b.setAttribute('data-acao','voltar');b.setAttribute('aria-label','Voltar');b.setAttribute('title','Voltar');b.removeAttribute('aria-pressed');
          b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
        }else if(window.__mevConsultasNoSite){
          b.setAttribute('data-acao','tema-logo');b.innerHTML='<img src="/identidade/logo-mev-veiculos-icone-app.svg" alt="">';
          tbTemaBarraSincronizar();
        }else{
          b.setAttribute('data-acao','tema');tbTemaBarraSincronizar();
        }
      }
    }catch(_){}
  }
  function tbMontar(){
    try{
      if($('mevTopbar')||$('mevConsultasNav')) return;
      var el=document.createElement('header'); el.id='mevTopbar';
      var _tbConsultas=false;
      /* v1419 — o MEV Avaliações usa literalmente a navegação atual do MEV
         Consultas: barra inferior com Voltar, título e Menu. Não monta a
         top bar antiga nem o FAB flutuante. */
      try{ _tbConsultas=(typeof window.edicaoAtual==='function' && ['consultas','avalia'].indexOf(window.edicaoAtual())>=0); }catch(_){}
      if(_tbConsultas){
        el=document.createElement('nav'); el.id='mevConsultasNav';
        el.className='consultas-bottom-nav';
        el.setAttribute('aria-label','Navegação da página');
        el.innerHTML='<div class="tb-in">'
          +'<button type="button" class="tb-ib tb-nav-back" id="tbBackTop" data-acao="tema" aria-label="Alternar tema"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41"/></svg></button>'
          +'<strong class="tb-page-title" id="tbPageTitle">Início</strong>'
          +'<button type="button" class="tb-ib tb-nav-menu" id="tbMenuBt" aria-label="Menu" title="Menu" aria-controls="mevDrawer" aria-expanded="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg></button>'
          +'</div>';
      }else el.innerHTML='<div class="tb-in">'
        /* v416 (pedido): "se clicar no logo abre o menu inicial também" —
           o logo virou botão de INÍCIO: clicou, volta pra tela inicial
           (mesma ação do FAB de início da v349, que já sabe salvar/fechar
           o que estiver aberto; se ele não existir, voltarHome direto). */
        /* v486 — EDIÇÕES: a marca da topbar acompanha o nome da edição
           (MEV Consultas / MEV Avalia); no completo fica como sempre. */
        +'<button type="button" class="tb-marca" id="tbMarca" aria-label="Ir para a página inicial"><img src="mev-icon.svg" alt=""><div>'+(function(){ try{ var i=(typeof window.edicaoInfo==='function')?window.edicaoInfo():null; if(i) return '<b>'+i.nome+'</b><small>'+(i.id==='consultas'?'Consultas veiculares':'família MEV Veículos')+'</small>'; }catch(_){} return '<b>MEV Veículos</b><small>Consulta de placa</small>'; })()+'</div></button>'
        /* v413 (pedido 12/08): "remove o nome da top bar, deixe só a foto".
           O nome saiu do lado da foto — ficou logo · foto+selo. O nome
           continua aparecendo dentro do menu lateral e nas telas da conta. */
        /* v456 (pedido 14/08): o aviso mora na pagina Notificacoes, mas quem
           esta na inicial nao ve o menu — o sino traz o contador pra vista.
           Mesma porta do menu lateral (drawerIr('notificacoes')); quem pinta
           o numero e o notifBadgeAtualiza, o MESMO do menu. */
        +'<button type="button" class="tb-sino" id="tbSino" aria-label="Notifica\u00e7\u00f5es"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg><span class="tb-sino-n" id="tbSinoN" style="display:none"></span></button>'
        /* v763 (FASE 3 do projeto cards-consulta, §9.8): no computador largo
           da home, Conversas e Menu saem dos balões flutuantes e moram AQUI.
           Os dois nascem sempre; o CSS só os mostra na faixa larga da home
           (fora dela ficam display:none e os balões seguem mandando). O
           clique reusa os caminhos de sempre; o contador de não lidas do
           #tbChatN é espelhado pelo chatBadgeAtualiza (10c). */
        /* 🔴🔴 v1062 — O BOTÃO DE CONVERSAS NÃO NASCE ONDE NÃO HÁ CONVERSA.
           A v1033 tirou o chat do MEV Consultas removendo o nó do DOM no
           `aplicar()` do 00-edicoes. Só que o `aplicar()` roda na detecção da
           edição e o `tbMontar()` roda quando a tela do app abre — DEPOIS. O
           botão era removido e a barra de cima o criava de novo, logo em
           seguida. Ficou de pé só porque uma regra de CSS o escondia.
           🔑 A doutrina da casa (v920) é outra: item que não pertence à edição
              NÃO NASCE. Escondido por CSS ele continua no DOM, continua no
              caminho do Tab e continua achável por leitor de tela.
           ⚠️ E pergunta ao MESMO portão das outras telas (`edPode` →
              `edicaoPermite('chat')`), não a um `if consultas || avalia`:
              edição nova já nasce obedecendo, sem ninguém lembrar disto. */
        +(_tbTemChat() ?
         '<button type="button" class="tb-ib" id="tbChat" aria-label="Conversas" title="Conversas"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/></svg><span class="tb-bad" id="tbChatN" style="display:none"></span></button>' : '')
        +'<button type="button" class="tb-ib" id="tbMenuBt" aria-label="Menu" title="Menu" aria-controls="mevDrawer" aria-expanded="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg></button>'
        +'<button type="button" class="tb-user" id="tbUser" aria-haspopup="menu" aria-expanded="false" aria-label="Sua conta">'
          +'<span class="tb-ava" id="tbAva"><b class="tb-ini" id="tbIni"></b><i class="tb-ava-out" aria-hidden="true">'+_TB_SVG.sair+'</i></span>'
        +'</button>'
        +'</div>';
      document.body.appendChild(el);
      /* v1364 — em resultados longos, a barra inferior deixa a leitura livre
         enquanto a página está em movimento e volta logo que a rolagem para.
         A rota web usa top bar e fica, de propósito, fora deste comportamento. */
      if(_tbConsultas && !window._consultaDockRolagemLigada){
        window._consultaDockRolagemLigada=true;
        (function(){
          var ultimo=window.scrollY||window.pageYOffset||0, timer=0;
          function restaurar(){
            try{ document.body.classList.remove('consulta-dock-rolando'); }catch(_){}
          }
          function aoRolar(){
            var y=window.scrollY||window.pageYOffset||0, corpo=document.body;
            var pode=corpo.classList.contains('resultado-veiculo-on')
              && !corpo.classList.contains('consultas-web')
              && !corpo.classList.contains('consulta-saida-on')
              && !corpo.classList.contains('drawer-aberto');
            if(!pode){ ultimo=y; clearTimeout(timer); restaurar(); return; }
            if(Math.abs(y-ultimo)<4) return;
            ultimo=y; corpo.classList.add('consulta-dock-rolando');
            clearTimeout(timer); timer=setTimeout(restaurar,420);
          }
          window.addEventListener('scroll',aoRolar,{passive:true});
        })();
      }
      avAreasMontar();
      var u=$('tbUser');
      if(u) u.onclick=function(e){ try{ e.stopPropagation(); }catch(_){} tbMenuAlterna(); };
      var sn=$('tbSino');
      if(sn) sn.onclick=function(){ try{ drawerIr('notificacoes'); }catch(_){ try{ telaNotificacoes(); }catch(__){} } };
      /* v763: os dois usam os MESMOS caminhos dos balões — nada de fluxo novo */
      var tc=$('tbChat');
      if(tc) tc.onclick=function(){ try{ chatPainelAlterna(); }catch(_){ try{ var f=$('btnChatFab'); if(f) f.click(); }catch(__){} } };
      var tm=$('tbMenuBt');
      if(tm) tm.onclick=function(){
        /* v1309 — no Consultas, o Menu saiu da folha de navegação e passou
           definitivamente para a extremidade direita da barra inferior. */
        try{ if(typeof window.edicaoAtual==='function' && ['consultas','avalia'].indexOf(window.edicaoAtual())>=0){ drawerAbrir(); return; } }catch(_){}
        try{ var m=$('btnMenuFab'); if(m){ m.click(); return; } }catch(_){}
        try{ drawerAbrir(); }catch(_){}
      };
      var bt=$('tbBackTop');
      if(bt) bt.onclick=function(){
        if(bt.getAttribute('data-acao')==='tema' || bt.getAttribute('data-acao')==='tema-logo'){
          var modo='escuro';try{ modo=temaConsultasAlternar(); }catch(_){}
          tbTemaBarraSincronizar();
          try{ toast(modo==='escuro'?'Tema escuro ativado.':'Tema claro ativado.'); }catch(_){}
          return;
        }
        if(bt.getAttribute('data-acao')==='inicio'){
          try{ var hf=$('btnHomeFab'); if(hf){ hf.click(); return; } }catch(_){}
          try{ voltarHome(); }catch(_){}
          return;
        }
        try{ var bf=$('btnBackFab'); if(bf){ bf.click(); return; } }catch(_){}
        try{ voltarHome(); }catch(_){}
      };
      var mk=$('tbMarca');
      /* v416: clicar no logo volta pro início. v419 (pedido: "se clicar no
         logo abre o menu inicial"): quando JÁ SE ESTÁ no início, o clique
         abre o MENU lateral — o logo nunca fica "morto". */
      if(mk) mk.onclick=function(){
        var interna=document.body.classList.contains('tela-interna');
        if(!interna){
          try{ var mfab=$('btnMenuFab'); if(mfab){ mfab.click(); return; } }catch(_){}
          try{ drawerAbrir(); }catch(_){}
          return;
        }
        try{ var hf=$('btnHomeFab'); if(hf){ hf.click(); return; } }catch(_){}
        try{ voltarHome(); }catch(_){}
      };
      try{ tbPaginaAtualizar(); }catch(_){}
      /* a foto chega do banco um instante depois do boot — repinta duas
         vezes sem depender de ninguém lembrar de chamar */
      setTimeout(function(){ try{ tbPinta(); }catch(_){} },2500);
      setTimeout(function(){ try{ tbPinta(); }catch(_){} },7000);
    }catch(_){}
  }

  /* foto — mesma fonte do menu lateral (meuFoto). v412: a INICIAL foi pro
     #tbIni (escrever no .tb-ava apagaria o selo de sair). v413: o nome saiu
     da barra — o $('tbNome') devolve null e o if(n) segura os links antigos. */
  function tbPinta(){
    try{
      tbMontar();
      var n=$('tbNome'), a=$('tbAva'), i=$('tbIni');
      var nome=String(meuNome||'').trim()||String(meuEmail||'').split('@')[0];
      if(n) n.textContent=nome||' ';
      if(a){
        if(meuFoto){ a.style.backgroundImage=imgFundo(meuFoto,96); if(i) i.textContent=''; }
        else { a.style.backgroundImage='none'; if(i) i.textContent=(nome||'?').charAt(0).toUpperCase(); }
      }
    }catch(_){}
  }

  /* ---- a lista da conta (abre pela foto) ---- */
  /* ==========================================================================
     🔴 v920 (PROJETO-remover-minha-loja-e-card-meu-cadastro, 06/09)
     A LISTA DA CONTA PASSA A OBEDECER À EDIÇÃO — NA MONTAGEM, NÃO NO CSS
     --------------------------------------------------------------------------
     O pedido do Angelo era "tirar Minha loja da listinha que abre na foto"
     no MEV Consultas. A regra pra isso JÁ EXISTIA no 00-edicoes.js:

         ['#mevTopbar .tb-mi[data-tbm="loja"]','loja']

     e nunca escondeu nada. Motivo: este menu é pendurado no BODY logo ali
     embaixo (`document.body.appendChild(m)`), não dentro do #mevTopbar. O
     seletor procurava num lugar onde o botão nunca esteve — e seletor que
     não acha nada não dá erro, não avisa ninguém, só deixa de esconder.
     É a MESMA armadilha que a v639 documentou nos atalhos da home.

     🔑 Então o conserto não é arrumar o seletor: é o item NÃO NASCER.
     O projeto é explícito — "não esconder por CSS; o item não deve ser
     montado quando não pertence ao MEV Consultas". Item escondido por CSS
     continua no DOM, continua com handler ligado e continua achável por
     leitor de tela.

     ⚠️ E é GENÉRICO de propósito, não um "if consultas": pergunta ao mesmo
     portão das páginas do menu (edPode → edicaoPermite). No MEV Completo a
     Loja continua na lista, porque lá ela é permitida. Item novo que entrar
     no _TB_ITENS já nasce obedecendo, sem ninguém lembrar desta regra.
     🔒 O 'sair' NUNCA passa pelo portão: não é página, é a saída. Uma
     edição que apagasse o Sair prenderia a pessoa dentro do app.
     ========================================================================= */
  function _tbItens(){
    return _TB_ITENS.filter(function(it){
      if(it[0]==='sair') return true;
      try{ if(typeof window.edPode==='function') return !!window.edPode(it[0]); }catch(_){}
      return true;
    });
  }
  function tbMenuMontar(){
    if($('tbMenu')) return;
    var m=document.createElement('div'); m.id='tbMenu'; m.className='tb-menu';
    var itens=_tbItens().map(function(it){
      var ehSair=(it[0]==='sair');
      return (ehSair?'<div class="tb-mi-sep"></div>':'')
        +'<button type="button" class="tb-mi'+(ehSair?' sair':'')+'" data-tbm="'+it[0]+'" role="menuitem">'
        +(_TB_SVG[it[0]]||'')+'<span>'+it[1]+'</span></button>';
    }).join('');
    m.innerHTML='<div class="tb-menu-bg" id="tbMenuBg"></div>'
      +'<div class="tb-menu-cx" role="menu" aria-label="Sua conta">'+itens+'</div>';
    document.body.appendChild(m);
    var bg=$('tbMenuBg'); if(bg) bg.onclick=function(){ tbMenuFechar(); };
    Array.prototype.forEach.call(m.querySelectorAll('.tb-mi'),function(b){
      b.onclick=function(){
        var k=b.getAttribute('data-tbm');
        tbMenuFechar();
        if(k==='sair'){ try{ var s=$('btnSair'); if(s) s.click(); }catch(_){} return; }
        try{ drawerIr(k); }catch(_){}      /* mesma porta do menu lateral */
      };
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape') tbMenuFechar();
    });
  }
  function tbMenuFechar(){
    try{
      var m=$('tbMenu'); if(m) m.classList.remove('on');
      var u=$('tbUser'); if(u) u.setAttribute('aria-expanded','false');
    }catch(_){}
  }
  function tbMenuAlterna(){
    try{
      tbMenuMontar();
      var m=$('tbMenu'); if(!m) return;
      var abrir=!m.classList.contains('on');
      m.classList.toggle('on', abrir);
      var u=$('tbUser'); if(u) u.setAttribute('aria-expanded', abrir?'true':'false');
    }catch(_){}
  }

  /* ---- v416: a listinha da LOJA (abre pelo atalho "Loja" da grade) ----
     Mesmas páginas do submenu Loja do menu lateral. Os ícones e rótulos
     vêm CLONADOS dos próprios botões do drawer (uma fonte só — mudou lá,
     muda aqui); o clique entra pela mesma porta (drawerIr). Visual: a
     mesma caixinha da lista da conta (.tb-menu), só que como FOLHA DE
     BAIXO no celular (classe .ha). */
  var _HA_LOJA_ACOES=['loja','estoque','repasse_meu','catalogo','vendas','avaliacoes'];
  function haLojaMontar(){
    if($('haLojaMenu')) return;
    var m=document.createElement('div'); m.id='haLojaMenu'; m.className='tb-menu ha';
    var itens=_HA_LOJA_ACOES.map(function(k){
      var src=document.querySelector('#mevDrawer [data-acao="'+k+'"]');
      var html=src?src.innerHTML:k;
      /* o innerHTML do drawer é "<svg…/> Rótulo" — embrulha o rótulo num span */
      var fim=html.lastIndexOf('</svg>');
      if(fim>-1){ var corte=fim+6; html=html.slice(0,corte)+'<span>'+html.slice(corte).trim()+'</span>'; }
      else html='<span>'+html+'</span>';
      return '<button type="button" class="tb-mi" data-tbm="'+k+'" role="menuitem">'+html+'</button>';
    }).join('');
    m.innerHTML='<div class="tb-menu-bg" id="haLojaBg"></div>'
      +'<div class="tb-menu-cx" role="menu" aria-label="Páginas da loja">'+itens+'</div>';
    document.body.appendChild(m);
    var bg=$('haLojaBg'); if(bg) bg.onclick=function(){ haLojaFechar(); };
    Array.prototype.forEach.call(m.querySelectorAll('.tb-mi'),function(b){
      b.onclick=function(){
        var k=b.getAttribute('data-tbm');
        haLojaFechar();
        try{ drawerIr(k); }catch(_){}
      };
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') haLojaFechar(); });
  }
  function haLojaFechar(){ try{ var m=$('haLojaMenu'); if(m) m.classList.remove('on'); }catch(_){} }
  function haLojaAlterna(){
    try{
      haLojaMontar();
      var m=$('haLojaMenu'); if(!m) return;
      m.classList.toggle('on', !m.classList.contains('on'));
    }catch(_){}
  }

  /* ---------- SUGESTÕES DE PLACA (v411, pedido) ----------
     Digitou no campo da placa → aparecem as placas JÁ pesquisadas que
     começam igual, com o modelo do lado, pra tocar e reabrir (a consulta
     salva reabre sem custo — quem cuida é o fluxo normal do campo). */
  function placaSugMontar(){
    try{
      var inp=$('placa'); if(!inp||inp._sugWired) return; inp._sugWired=1;
      var wrap=inp.closest('.placa-wrap')||inp.parentNode;
      var box=document.createElement('div'); box.id='placaSug'; box.style.display='none';
      wrap.appendChild(box);
      function fecha(){ box.style.display='none'; }
      function pinta(){
        var t=String(inp.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
        if(!t||t.length>=7){ fecha(); return; }
        var itens=[];
        try{ itens=histLer().filter(function(x){ return String(x.placa||'').toUpperCase().indexOf(t)===0; }).slice(0,5); }catch(_){ itens=[]; }
        if(!itens.length){ fecha(); return; }
        box.innerHTML=itens.map(function(x){
          return '<button type="button" class="pl-sug" data-p="'+esc(x.placa)+'"><b>'+esc(x.placa)+'</b><span>'+esc(x.modelo||'')+'</span></button>';
        }).join('');
        box.style.display='block';
        Array.prototype.forEach.call(box.querySelectorAll('.pl-sug'),function(b){
          /* mousedown com preventDefault: o campo não perde o foco antes do clique */
          b.onmousedown=function(e){ e.preventDefault(); };
          b.onclick=function(){
            fecha();
            inp.value=b.getAttribute('data-p')||'';
            try{ inp.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
          };
        });
      }
      inp.addEventListener('input',pinta);
      inp.addEventListener('focus',pinta);
      inp.addEventListener('blur',function(){ setTimeout(fecha,220); });
    }catch(_){}
  }

  /* ---------- CONSULTA PLUS com placa própria ----------
     🔴🔴 v707 (pedido do Angelo, 29/08): "nao faca consulta plus de forma
     automatica" + "deixe um botao pra pesquisar ao lado da placa digitada".
     Ele estava CERTO pela régua da própria casa (v585/v599: consulta paga
     nunca sai sozinha) — esta era a ÚNICA página que disparava 25 tokens ao
     completar a placa. Agora o gatilho é o BOTÃO, com o preço escrito nele
     (apertar com o preço à vista é o consentimento — o desenho da v654).
     ⛳ O que CONTINUA automático é só o que NÃO CUSTA NADA: placa que já tem
     Plus salva reabre sozinha, sem cobrança, como sempre. */
  var _mrAuto='', _mrRodando=false;
  /* v750 — Versão B do padrão unificado (02c): a Plus na mesma casca do
     "Buscar por veículo". Placa → o que inclui → botão com o preço (fonte:
     PLUS_TOKENS) → resultado → outras consultas. mrWire/gerarConsultaPlus/
     consultaPlusRodar intactos; IDs mrPlaca/mrBt/mrResult preservados. */
  function mrInnerHtml(){
    var pre=(veiculoAtual&&veiculoAtual.placa)?esc(veiculoAtual.placa):'';
    var form=consultaUiEtapa(null,'Placa',
        '<input id="mrPlaca" class="lh-inp'+(pre?' tem':'')+'" data-consulta-anim="placa" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="ABC1D23" inputmode="text" aria-label="Placa" data-cu-min="7" value="'+pre+'">')
      +consultaUiBeneficios(['Valor FIPE e dados do veículo pela placa','Débitos estaduais e multas RENAINF detalhadas','Passagem por leilão e indício de sinistro nas bases consultadas','Relatório em PDF para mandar ao cliente'])
      +consultaUiCta({ id:'mrBt', classe:'mr-bt', verbo:'Pesquisar', preco:PLUS_TOKENS, disabled:!pre })
      +consultaUiTrust('Placa já consultada reabre sem custo · fonte que não responder é devolvida')
      +'<div id="mrResult" aria-live="polite"></div>';
    form=form.replace('id="mrBt"','id="mrBt" data-cu-reqs="mrPlaca"');
    return consultaUiCard(form, { id:'mrWrap' })+consultaUiRelacionadas('plus','veiculo',{ preferir:['placa','fipe','gravame'] });
  }
  function mrFormularioVoltar(placa,limpar){
    abrirConsultaPlus(); if(limpar) return;
    setTimeout(function(){
      try{ var inp=$('mrPlaca'); if(!inp) return; inp.value=_lhPlaca(placa); if(inp.oninput) inp.oninput(); inp.blur(); }
      catch(_){}
    },0);
  }
  function mrResultadoAbrir(placa,reaberta,ts){
    placa=_lhPlaca(placa); var v=veiculoAtual||{}, modelo=[v.marca,v.modelo].filter(Boolean).join(' ');
    var cfg={ chave:'plus', titulo:'Consulta Plus', identificacao:[modelo,placa].filter(Boolean).join(' · '),
      dataHora:histData(ts||Date.now()),
      resumoHtml:consultaResultadoResumo({ tom:'ok', titulo:'Consulta concluída', texto:'FIPE, débitos, restrições, leilão e sinistro reunidos no relatório.' }),
      secoesHtml:consultaResultadoSecao({ titulo:'Relatório da consulta', html:relInlineHtml() }),
      aoVoltar:function(){ mrFormularioVoltar(placa,false); }, aoNovaConsulta:function(){ mrFormularioVoltar('',true); },
      acoes:[
        { id:'mrResultadoPdf', rotulo:'Visualizar PDF', icone:'ver', primaria:true, somenteIcone:true, acao:function(){ acaoGerarPDF('visualizar'); } },
        { id:'mrResultadoPdfBaixar', rotulo:'Baixar PDF', icone:'baixar', somenteIcone:true, acao:function(){ acaoGerarPDF('baixar'); } },
        { id:'mrResultadoPdfCompartilhar', rotulo:'Compartilhar PDF', icone:'compartilhar', somenteIcone:true, acao:function(){ acaoGerarPDF('compartilhar'); } }
      ] };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
  }
  function mrWire(){
    var inp=$('mrPlaca'); if(inp){
      inp.oninput=function(){
        inp.value=_lhPlaca(inp.value); inp.classList.toggle('tem', !!inp.value);
        var p=inp.value;
        /* v707: placa completa NÃO consulta mais — só REABRE o que já está
           salvo (grátis). O pago espera o botão. */
        if(/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p)){
          if(p!==_mrAuto){
            _mrAuto=p;
            try{ var eS=histLerUm(p); if(eS&&eS.consultaPlus) gerarConsultaPlus(); }catch(_){}
          }
        }
        else _mrAuto='';
      };
      inp.addEventListener('keydown',function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); gerarConsultaPlus(); } });
      inp.addEventListener('input',function(){ try{ consultaUiSync(); }catch(_){} });   /* v750: o botão acompanha a placa */
      inp.addEventListener('paste',function(){ setTimeout(function(){ try{ inp.oninput(); }catch(_){} },0); });
      setTimeout(function(){ try{ inp.focus({preventScroll:true}); }catch(_){ try{ inp.focus(); }catch(_2){} } try{ if(inp.value) inp.select(); }catch(_3){} },140);
    }
    var bt=$('mrBt'); if(bt) bt.onclick=function(){ gerarConsultaPlus(/novamente/i.test(bt.textContent||'')); };   /* v707: o dedo · v750: "novamente" força a consulta paga */
    /* A placa aberta já tem uma Consulta Plus salva? Mostra sem custo. */
    try{
      var e=veiculoAtual?histLerUm(veiculoAtual.placa):null;
      if(e&&e.consultaPlus){ plusState=e.consultaPlus; plusAplicarEstados(plusState,e.leilao||null); mrResultadoAbrir(e.placa||(e.v&&e.v.placa)||'',true,e.ts); }
    }catch(_){}
  }
  async function gerarConsultaPlus(forcar){
    if(_mrRodando) return;
    var inp=$('mrPlaca'); var placa=inp?_lhPlaca(inp.value):'';
    var res=$('mrResult');
    if(!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(placa)){ if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">Digite uma placa válida (ABC1234 ou ABC1D23).</div>'; return; }
    var e=null; try{ e=histLerUm(placa); }catch(_){}
    /* 1) já tem salva pra essa placa? reabre sem custo */
    if(e&&e.consultaPlus && forcar!==true){
      if(e.v) veiculoAtual=e.v;
      plusState=e.consultaPlus; plusAplicarEstados(plusState,e.leilao||null);
      mrResultadoAbrir(placa,true,e.ts);
      return;
    }
    _mrRodando=true;
    var _bt=$('mrBt'); try{ consultaUiEstadoCta(_bt,'carregando','Consultando…'); }catch(_){}   /* v750: bloqueia o toque duplo */
    var lt=null;
    if(res){ res.innerHTML=ccLoaderHtml(); lt=ccLoaderStart(); }
    /* `consultaPlusRodar` é a única porta completa: reúne as três fontes
       pagas, dispara a ficha por IA em paralelo e espalha o resultado nas
       telas já existentes. A FIPE avulsa continua na aba Consulta placa. */
    if(e&&e.v && _lhPlaca(e.v.placa||placa)===placa){ veiculoAtual=e.v; }
    var d = await consultaPlusRodar(placa);
    if(lt) clearInterval(lt);
    _mrRodando=false;
    if(d.semSaldo){ try{ consultaUiEstadoCta(_bt,'pronto'); }catch(_){} if(res) res.innerHTML=''; abrirPacotes(); return; }
    if(!d.ok){
      try{ consultaUiEstadoCta(_bt,'erro'); }catch(_){}
      if(res) res.innerHTML='<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+
        esc(d.erro||'Não foi possível concluir a consulta agora. Tente de novo em instantes.')+
        (d.estornado?' O valor foi devolvido ao seu saldo.':'')+'</div>';
      return;
    }
    try{ consultaUiEstadoCta(_bt,'novamente','Pesquisar novamente'); }catch(_){}
    /* 🔴 fonte que não respondeu é DITA, com o estorno junto — nunca um bloco
       vazio parecendo "nada consta" */
    if(d.aviso) toast(d.aviso);
    mrResultadoAbrir(placa,false,Date.now());
  }
  function abrirConsultaPlus(){
    /* v750 — Versão B do padrão (02c) */
    consultaUiPagina({ chave:'plus', tab:'plus', ico:_CT_ICO.plus, cor:'blue', titulo:'Consulta Plus', sub:'FIPE, débitos, restrições, leilão e sinistro · '+precoReal(PLUS_TOKENS) }, mrInnerHtml());
    mrWire();
    try{ consultaUiSync(); }catch(_){}
    /* v707: abrir a página com placa preenchida NÃO consulta mais — o
       mrWire acima já reabriu a salva (grátis) se ela existir. O resto
       espera o botão. */
  }

  /* ---------- BUSCAR POR VEÍCULO como aba (v406, pedido) ----------
     O formulário é o MESMO da FIPE embutida de antes (fmFormHtml/fmFormWire,
     do módulo 11 — funciona daqui porque o app inteiro é um IIFE só). Só a
     casa mudou: era um card minimizado na home, virou a 2ª aba das consultas,
     no lugar do Histórico. */
  /* v747 — TELA PILOTO do padrão unificado (02c): etapas 1–4, botão
     "Buscar veículo" que só liga com a seleção completa, outras consultas
     DEPOIS do formulário (no computador a barrinha continua como menu
     lateral, via consultaUiPagina). fmFormWire/fmComboWire do 11 intactos. */
  function abrirBuscaVeiculo(){
    consultaUiPagina({ chave:'fipe', ico:_CT_ICO.fipe, cor:'blue', titulo:'Buscar por veículo', sub:'Tipo, marca, ano e modelo · valor da FIPE · grátis', tab:'' }, consultaUiBuscaVeiculoHtml());
    fmFormWire($('secoes'));
    consultaUiBuscaVeiculoLigar($('secoes'));
  }

  /* ---------- liga tudo nas páginas que já existiam ----------
     As funções são declaradas nos módulos 03/04/05; aqui elas são embrulhadas
     (o app inteiro é um IIFE só, então reatribuir o nome vale pra todo mundo):
     a página abre normal e ganha a barrinha de abas — que no computador o
     CSS transforma em menu na esquerda. */
  /* v406 (pedido): o Histórico DEIXOU de ser aba — a lista voltou pra baixo
     da consulta de placa, na home (no computador).
     v408 (pedido): no CELULAR a lista saiu da home (virou o atalho
     "Histórico" da grade) — então lá o abrirHistorico abre a PÁGINA cheia
     de antes (v386), guardada em _ctHistPagina. */
  var _ctHistPagina=abrirHistorico;
  abrirHistorico=function(){
    var celular=false; try{ celular=window.matchMedia&&window.matchMedia('(max-width:899px)').matches; }catch(_){}
    /* v730: no computador LARGO (≥1280px) o histórico já está na coluna da
       direita — "voltar pra home e rolar até ele" viraria rolar três pixels
       até um painel que já está na tela. Lá, "Histórico" abre a PÁGINA
       completa, igual ao celular. Na faixa 900–1279 o cartão continua
       embaixo do painel, e rolar até ele segue fazendo sentido. */
    var largo=false; try{ largo=window.matchMedia&&window.matchMedia('(min-width:1280px)').matches; }catch(_){}
    /* ======================================================================
       🔴🔴🔴 v1083 — E SE O CARTÃO NÃO EXISTIR MAIS, NÃO HÁ PRA ONDE ROLAR
       ----------------------------------------------------------------------
       Este desvio (v730) manda "voltar pra home e rolar até o cartão do
       histórico" na faixa de 900 a 1279 px. Ele foi escrito quando a home do
       MEV completo era a antiga, e lá o `#homeHistCard` existia.

       A v1076 pôs o completo na tela premium — que NÃO TEM esse cartão. Desde
       então, nessa faixa de largura, tocar em "Histórico" fazia isto: voltava
       pra home e tentava rolar até um elemento que não existe. Ou seja, NADA
       ACONTECIA. Sem erro, sem aviso, sem tela.
       Medido: a 1100px o `abrirHistorico()` rodava `voltarHome()` e parava —
       o `#histLista` nunca chegava a nascer.

       🔑 A PERGUNTA CERTA NÃO É A LARGURA, É A TELA — a mesma lição da v1076.
          Largura é um palpite sobre qual home está montada; a presença do
          cartão é o fato. Se ele está aí, rolar até ele continua fazendo
          sentido. Se não está, a página cheia é a única resposta possível.
       ⚠️ Não mexi nos dois desvios antigos (celular e ≥1280): quem já
          funcionava continua igual, e a régua mede as duas pontas.
       ====================================================================== */
    /* ⚠️ E "EXISTIR" NÃO BASTA — FOI ASSIM QUE EU ERREI NA PRIMEIRA TENTATIVA.
       O `#homeHistCard` CONTINUA no DOM depois da v1076: quem some é a COLUNA
       que o guarda (`#homeHistCol`, escondida pela tela premium). Perguntar
       `!!getElementById` dava `true` e o desvio seguia mandando rolar até um
       cartão invisível. A pergunta tem que subir pelos PAIS, como a régua da
       v1076 aprendeu a fazer. */
    var cartaoVisivel=false;
    try{
      var _c=document.getElementById('homeHistCard');
      if(_c){
        cartaoVisivel=true;
        for(var _n=_c; _n && _n!==document.body; _n=_n.parentElement){
          if(getComputedStyle(_n).display==='none'){ cartaoVisivel=false; break; }
        }
      }
    }catch(_){}
    if(celular||largo||!cartaoVisivel){ _ctHistPagina(); return; }
    voltarHome();
    setTimeout(function(){
      try{ var c=$('homeHistCard'); if(c && c.style.display!=='none') c.scrollIntoView({behavior:'smooth',block:'start'}); }catch(_){}
    },80);
  };
  /* 🔴🔴 v613 — O EMBRULHO COMIA O ARGUMENTO.
     Este embrulho (padrão v387: a função original + a barrinha de abas) foi
     escrito quando abrirRestricao NÃO tinha parâmetro. Quando a v613 deu um
     a ela (qual página de CPF abrir), o embrulho continuou chamando
     `_ctRest()` SEM repassar nada — então toda aba nova abria a página do
     CPF restrições, calada. Levei um bom tempo procurando no lugar errado.
     ⚠️ REGRA: ao dar um parâmetro a uma função, PROCURAR QUEM A EMBRULHA.
     Neste app o padrão "guarda a original e reatribui" é comum (05d, 05b,
     18d) — um embrulho antigo engole o argumento novo sem reclamar. */
  /* v752 — o embrulho SAIU: as três páginas de CPF abrem pelo consultaUiPagina
     (02c), que injeta a barrinha só no computador (≥900px). No celular a grade
     não vem mais antes do formulário — regra do padrão unificado. */
  /* v753 — o embrulho do CNPJ também saiu: abrirCnpjPag abre pelo consultaUiPagina (02c). */

  /* v406 (pedido): a lista de consultas recentes VOLTOU pra 1ª aba, abaixo
     da consulta de placa (na v387 ela tinha virado a aba Histórico). O
     pintor original (05) volta a rodar — ele mesmo mostra/esconde o card
     conforme tem ou não consultas — e a barrinha de abas continua daqui. */
  var _ctPintaHome=pintaHomeHist;
  pintaHomeHist=function(termo){
    try{ _ctPintaHome(termo); }catch(_){}
    consTabsHome();
    homeAtalhosMontar();   /* v408: grade de atalhos (só aparece no celular) */
    haHomePainelMontar();  /* v499: nos apps sem consulta, o painel do app É a home */
    fxFaixaMontar();       /* v502: a faixa "como você quer trabalhar hoje" */
    tbPinta();             /* v408/v410: barra fixa do topo */
    placaSugMontar();      /* v411: sugestões de placas já pesquisadas */
    /* v398 (pedido): a terceira coluna "Últimas consultas" foi REMOVIDA —
       o módulo 05b saiu do src. Pra voltar, é restaurar o 05b e esta chamada. */
    /* v390 (plano item 8): no computador o cursor já nasce na placa — colar
       e Enter funcionam direto. Só quando nada mais está com o foco. */
    try{
      if(window.matchMedia && window.matchMedia('(min-width:900px)').matches &&
         !document.body.classList.contains('tela-interna') &&
         document.activeElement===document.body){
        var _p=$('placa'); if(_p) _p.focus({preventScroll:true});
      }
    }catch(_){}
  };

  /* v393 — os FABs que substituíram os chips do cabeçalho azul. O de tokens
     já funciona sozinho (classe saldo-chip: o pintor de saldo e o clique que
     abre os pacotes valem pra qualquer elemento com essa classe); Catálogo e
     Site repassam o clique pros botões originais do cabeçalho — escondidos,
     mas com os handlers de sempre, ligados pelo 14-estoque. */
  try{
    var _fCat=$('btnCatalogoFab'); if(_fCat) _fCat.onclick=function(){ var o=$('btnCatalogoTopo'); if(o) o.click(); };
    var _fSite=$('btnSiteFab'); if(_fSite) _fSite.onclick=function(){ var o=$('btnSiteTopo'); if(o) o.click(); };
  }catch(_){}

  /* ==========================================================================
     v746 — O MENU LATERAL COMPACTO E INTELIGENTE (docs/PROJETO-2026-08-29-
     menu-lateral-compacto-e-inteligente.txt). UM controlador pros cinco
     grupos do app.html: seções sempre abertas, item ativo central
     (mdrAtivoSet), contagens dinâmicas e sincronização ao abrir a gaveta.
     Substitui os três toggles (v393/v415/v439) e o "tudo aberto" da v531.
     ⛳ v992: todos os grupos disponíveis ficam abertos e seus cabeçalhos
     continuam visíveis para separar e identificar cada área do menu.
     ⚠️ O estado fechado é só CLASSE no .mdr-sub — o deslize (18b/18d) e as
     edições (00) continuam lendo os mesmos botões; nada sai da rota.
     ========================================================================= */
  var MDR_SECOES_ABERTAS = true;
  var MDR_GRUPOS=[
    { id:'consultas', hi:'mdrConsultas', sub:'mdrConsSub', caret:'mdrConsCaret', cnt:'mdrCntConsultas' },
    { id:'loja',      hi:'mdrLoja',      sub:'mdrLojaSub', caret:'mdrLojaCaret', cnt:'mdrCntLoja' },
    { id:'crm',       hi:'mdrCrm',       sub:'mdrCrmSub',  caret:'mdrCrmCaret',  cnt:'mdrCntCrm' },
    { id:'rede',      hi:'mdrRede',      sub:'mdrRedeSub', caret:'mdrRedeCaret', cnt:'mdrCntRede' },
    { id:'conta',     hi:'mdrConta',     sub:'mdrContaSub',caret:'mdrContaCaret',cnt:'mdrCntConta' }
  ];
  var _mdrAtivo='buscaplaca';
  /* v1025 — no MEV Consultas, "Meu cadastro" pertence ao grupo Conta e
     suporte. O botão já existia como rota oculta no primeiro nível e já era
     usado pelo cabeçalho da conta; mover o MESMO nó preserva ícone, evento,
     permissões e estado ativo sem criar uma segunda tela. Nas outras edições
     a organização histórica permanece intacta.
     v1322 — a Home passa a ser o primeiro destino de Consultas. Reutilizamos
     o nó canônico `inicio`, com o SVG de casa já usado pela barra, e ocultamos
     somente a entrada redundante do drawer; a consulta de placa permanece na
     Home e sua rota continua válida para atalhos e links antigos. */
  function mdrConsultasMontar(){
    if(edicaoAtual()!=='consultas')return;
    var nav=document.querySelector('#mevDrawer .mdr-nav');
    if(!nav||nav.classList.contains('mdr-consultas-cadastro'))return;
    var cadastro=nav.querySelector('[data-acao="cadastro"]');
    var corpo=$('mdrContaSub'); corpo=corpo&&corpo.querySelector('.mdr-sub-in');
    var inicio=$('mdrInicio'), consultas=$('mdrConsSub');
    consultas=consultas&&consultas.querySelector('.mdr-sub-in');
    var placa=nav.querySelector('[data-acao="buscaplaca"]');
    if(!cadastro||!corpo||!inicio||!consultas||!placa)return;
    inicio.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10.6 12 3l9 7.6"/><path d="M5.5 9.4V20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.4"/><path d="M9.6 21v-6.2h4.8V21"/></svg><span>Início</span>';
    consultas.prepend(inicio);
    placa.style.display='none';
    corpo.prepend(cadastro);
    if(_mdrAtivo==='buscaplaca') _mdrAtivo='inicio';
    nav.classList.add('mdr-consultas-cadastro');
  }
  function mdrAvaliaMontar(){
    if(edicaoAtual()!=='avalia')return;
    var nav=document.querySelector('#mevDrawer .mdr-nav');
    if(!nav||nav.classList.contains('mdr-avalia'))return;
    nav.classList.add('mdr-avalia');
    var loja=$('mdrLojaSub'),hi=$('mdrLoja'),cons=$('mdrConsultas');
    nav.insertBefore(hi,cons);nav.insertBefore(loja,cons);
    hi.querySelector('.mdr-hi-t').textContent='Avaliações';
    $('mdrConta').querySelector('.mdr-hi-t').textContent='Conta';
    var lista=nav.querySelector('[data-acao="avaliacoes"]');
    hi.querySelector('svg').replaceWith(lista.querySelector('svg').cloneNode(true));
    var nome=document.createElement('span');nome.textContent='Minhas avaliações';
    Array.prototype.slice.call(lista.childNodes).forEach(function(n){if(n.nodeType===3)n.remove();});lista.appendChild(nome);
    var corpo=loja.querySelector('.mdr-sub-in');corpo.prepend(lista);
    var novo=document.createElement('button');novo.type='button';novo.id='mdrNovaAvaliacao';
    novo.innerHTML=_HA_ICO.tokens+'<span>Nova avaliação</span>';
    lista.after(novo);
    novo.onclick=async function(){
      if(_buscando||$('avConsultaLoad')||acPortao('avaliacoes')||!avAreaSalvar())return;
      drawerFechar(false);avAreaMarcar('avaliacoes');
      await telaAvaliacoes();var bt=$('avlNovaBtn');if(bt)bt.click();
    };
    corpo.appendChild(nav.querySelector('[data-acao="repasse_meu"]'));
    corpo.appendChild(nav.querySelector('[data-acao="catalogo"]'));
    $('mdrContaSub').querySelector('.mdr-sub-in').prepend(nav.querySelector('[data-acao="cadastro"]'));
    MDR_GRUPOS.forEach(function(g){_mdrPoe(g,true);});
  }
  /* o item está disponível? — a MESMA régua do deslize (18b): style inline
     até a .mdr-nav (nunca a classe do .mdr-sub) + permissão da edição */
  function mdrItemVisivel(b){
    try{
      if(!b || b.hidden) return false;
      var n=b;
      while(n && !(n.classList && n.classList.contains('mdr-nav'))){
        if(!(n.classList && (n.classList.contains('mdr-sub')||n.classList.contains('mdr-sub-in'))) && n.style && n.style.display==='none') return false;
        n=n.parentElement;
      }
      var a=b.getAttribute('data-acao');
      if(typeof window.edicaoPermite==='function' && !window.edicaoPermite(a)) return false;
      return true;
    }catch(_){ return true; }
  }
  /* de que grupo é uma ação (lido do HTML, pra nunca desandar dele) */
  function mdrGrupoDe(acao){
    try{
      var b=document.querySelector('#mevDrawer .mdr-nav button[data-acao="'+acao+'"]'); if(!b) return null;
      var sub=b.closest('.mdr-sub'); if(!sub) return null;
      for(var i=0;i<MDR_GRUPOS.length;i++){ if(MDR_GRUPOS[i].sub===sub.id) return MDR_GRUPOS[i].id; }
    }catch(_){}
    return null;
  }
  function _mdrG(id){ for(var i=0;i<MDR_GRUPOS.length;i++){ if(MDR_GRUPOS[i].id===id) return MDR_GRUPOS[i]; } return null; }
  function _mdrPoe(g, aberto){
    var sub=$(g.sub), hi=$(g.hi), ct=$(g.caret);
    if(sub) sub.classList.toggle('on', !!aberto);
    if(hi) hi.setAttribute('aria-expanded', aberto?'true':'false');
    if(ct) ct.classList.toggle('on', !!aberto);
  }
  /* v1008 — no MEV Consultas os títulos são separadores, não controles.
     Tirar o foco e anunciar o estado desabilitado evita que leitor de tela
     e teclado encontrem um botão que, por regra, não executa ação alguma. */
  function mdrCabecalhosFixos(){
    var fixos=['consultas','avalia'].indexOf(edicaoAtual())>=0;
    MDR_GRUPOS.forEach(function(g){
      var hi=$(g.hi); if(!hi) return;
      if(fixos){
        hi.setAttribute('aria-disabled','true');
        hi.setAttribute('tabindex','-1');
      }else{
        hi.removeAttribute('aria-disabled');
        hi.removeAttribute('tabindex');
      }
    });
  }
  /* abre UM grupo e fecha os outros (o acordeão) */
  function mdrGrupoAbrir(id){
    MDR_GRUPOS.forEach(function(g){ _mdrPoe(g, g.id===id); });
  }
  function mdrGrupoAlternar(id){
    var g=_mdrG(id); if(!g) return;
    /* v992: o menu inteiro permanece aberto; o cabeçalho identifica a área,
       mas não volta a esconder seus destinos ao tocar. */
    if(MDR_SECOES_ABERTAS){ MDR_GRUPOS.forEach(function(x){ _mdrPoe(x,true); }); return; }
    var sub=$(g.sub); var aberto=!!(sub && sub.classList.contains('on'));
    if(edicaoAtual()==='avalia'){_mdrPoe(g,!aberto);return;}
    /* o grupo da página atual não fecha: tocar de novo só confirma o toque */
    if(aberto && mdrGrupoDe(_mdrAtivo)===id) return;
    if(aberto) _mdrPoe(g, false); else mdrGrupoAbrir(id);
  }
  /* 🔴 v814 §11.2 — A CONTAGEM SAIU DA TELA, O CÁLCULO FICOU.
     O <span class="mdr-cnt"> não existe mais no app.html: o mockup aprovado
     não tem números nos grupos. Mas a CONTA continua sendo feita aqui,
     porque é ela que decide `mdr-vazio` — o grupo em que nenhum item está
     permitido some inteiro, e isso não é enfeite, é a edição do produto
     mandando. O `$(g.cnt)` continua tolerante (`if(cnt)`) de propósito:
     quem quiser o número de volta só recoloca o span no HTML. */
  function mdrContagens(){
    MDR_GRUPOS.forEach(function(g){
      try{
        var sub=$(g.sub), hi=$(g.hi), cnt=$(g.cnt); if(!sub||!hi) return;
        var n=0; Array.prototype.forEach.call(sub.querySelectorAll('button[data-acao]'), function(b){ if(mdrItemVisivel(b)) n++; });
        if(cnt) cnt.textContent=n?String(n):'';
        hi.classList.toggle('mdr-vazio', n===0); sub.classList.toggle('mdr-vazio', n===0);
      }catch(_){}
    });
  }
  /* a FONTE DA VERDADE do item ativo: quem troca de tela chama isto
     (drawerIr no 09, voltarHome no 02) */
  function mdrAtivoSet(acao){
    try{
      acao=String(acao||''); if(!acao) return;
      var nav=document.querySelector('#mevDrawer .mdr-nav'); if(!nav) return;
      var alvo=nav.querySelector('button[data-acao="'+acao+'"]'); if(!alvo) return;   /* ação sem item no menu: mantém o anterior */
      Array.prototype.forEach.call(nav.querySelectorAll('button[data-acao].active,[aria-current="page"]'), function(b){ b.classList.remove('active'); b.removeAttribute('aria-current'); });
      alvo.classList.add('active'); alvo.setAttribute('aria-current','page');
      _mdrAtivo=acao;
      /* v1309 — rotas abertas pelo drawer também sincronizam o título da
         barra inferior. Sem isso, Uso e faturamento podia conservar o nome
         da consulta visitada anteriormente. */
      try{
        if(edicaoAtual()==='consultas'){
          var rot=String(alvo.textContent||'').replace(/\s+/g,' ').trim();
          tbPaginaAtualizar(document.body.classList.contains('tela-interna')?(rot||'MEV Consultas'):'Início');
        }
      }catch(_){}
      /* gaveta aberta na hora da troca (computador, coluna fixa): reflete já */
      var g=mdrGrupoDe(acao); if(g && !MDR_SECOES_ABERTAS && edicaoAtual()!=='avalia'){ var d=$('mevDrawer'); if(d && (d.classList.contains('on') || window.innerWidth>=900)) mdrGrupoAbrir(g); }
    }catch(_){}
  }
  /* ao abrir a gaveta: permissões já aplicadas pelo drawerAbrir → aqui
     contagens, ativo, grupo da página atual aberto, resto fechado */
  function mdrSync(){
    try{
      mdrConsultasMontar();
      mdrAvaliaMontar();
      mdrContagens();
      mdrCabecalhosFixos();
      if(MDR_SECOES_ABERTAS){ MDR_GRUPOS.forEach(function(g){ _mdrPoe(g, true); }); try{ document.body.classList.add('mdr-aberto'); }catch(_){} return; }
      try{ document.body.classList.remove('mdr-aberto'); }catch(_){}
      mdrAtivoSet(_mdrAtivo);
      var g=mdrGrupoDe(_mdrAtivo) || 'consultas';
      mdrGrupoAbrir(g);
      var at=document.querySelector('#mevDrawer .mdr-nav button.active');
      if(at && at.scrollIntoView) setTimeout(function(){ try{ at.scrollIntoView({ block:'nearest' }); }catch(_){} }, 200);
    }catch(_){}
  }
  /* a fiação dos cabeçalhos — uma vez */
  try{
    MDR_GRUPOS.forEach(function(g){
      var hi=$(g.hi); if(!hi) return;
      var tg=function(e){ e.preventDefault(); e.stopPropagation(); if(['consultas','avalia'].indexOf(edicaoAtual())>=0) return; mdrGrupoAlternar(g.id); };
      hi.addEventListener('click', tg);
      hi.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' ') tg(e); });
    });
    mdrSync();
  }catch(_){}

  /* v406 (pedido): o card "Buscar por veículo" embutido na home SAIU — a
     busca virou aba própria (abrirBuscaVeiculo, acima). Reatribuir o nome
     aqui vale pra todo mundo (voltarHome e o init chamam fmInlineMontar):
     a função original, declarada no módulo 11, fica sobrescrita por esta.
     Pra voltar o card embutido: apagar estas 4 linhas. */
  fmInlineMontar=function(){
    try{ var box=$('fipeInlineCard'); if(box){ box.style.display='none'; box.innerHTML=''; } }catch(_){}
  };

/* ╔═══ src/app/05e-apps-mev.js ═══════════════════════════════════════════ */
  /* ==========================================================================
     05e — PÁGINA "APPS MEV" (v491 — adendo do EXECUTAR-edicoes, itens 5 e 6)

     "como o usuário visualiza a possibilidade de baixar os aplicativos
      separados dentro do app atual, e como eu compartilho só a consulta
      de placas pra um lojista — e ele descobre os outros depois"

     Grade com a família: Consultas · Avalia · (Loja/Vendas/Leads/Rede
     como "em breve") · Completo. Os LINKS vêm do edApps() do 00-edicoes
     (um lugar só — a fase 2 dos subdomínios troca lá e esta página segue).

     BOTÕES:
     · COMPARTILHAR — em todo app disponível: navigator.share (celular),
       senão WhatsApp com mensagem pronta, senão copia o link.
     · INSTALAR — SÓ no card do app QUE VOCÊ USA. De propósito: abrir o
       link de OUTRA edição aqui dentro trocaria a SUA edição (o ?app=
       grava o localStorage mev_edicao) — o dono do Completo clicava em
       "Instalar" no card Consultas e o app dele virava o enxuto. Quem
       quer conhecer outro app COMPARTILHA o link (ou abre em outro
       aparelho/navegador). Android: beforeinstallprompt; iPhone: a
       instruçãozinha do PWA (Compartilhar → Adicionar à Tela de Início).

     ⚠️ LIMITAÇÃO DO PILOTO (combinada no adendo): com ?app= o link abre
     o app ENXUTO pra compartilhar e testar, mas o ícone instalado no
     celular ainda é UM só (o manifest é o mesmo). Ícone separado de
     verdade = fase 2 (subdomínio + manifest próprio por edição).
     ========================================================================= */
  var _amDeferred=null;
  try{
    window.addEventListener('beforeinstallprompt',function(e){
      try{ e.preventDefault(); }catch(_){}
      _amDeferred=e;   /* guarda o convite do Android pro botão Instalar */
    });
  }catch(_){}
  function _amEhIos(){ return /iphone|ipad|ipod/i.test(navigator.userAgent||''); }
  var _AM_ICO={
    consultas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M8 11h6"/></svg>',
    avalia:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
    loja:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><rect x="9" y="13" width="6" height="7"/></svg>',
    vendas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14"/><path d="M6 17V9.5L7.8 5h8.4L18 9.5V17"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>',
    leads:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    rede:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    completo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>'
  };
  function _amCss(){
    if($('mevAppsMevCss')) return;
    var st=document.createElement('style'); st.id='mevAppsMevCss';
    st.textContent=
      '.am-grid{display:grid;grid-template-columns:1fr;gap:12px}'+
      '@media(min-width:720px){.am-grid{grid-template-columns:1fr 1fr}}'+
      '.am-card{background:#fff;border:1px solid #e4ebf5;border-radius:16px;padding:14px 16px;display:flex;flex-direction:column;gap:8px}'+
      '.am-card.breve{opacity:.62}'+
      '.am-hd{display:flex;align-items:center;gap:10px}'+
      '.am-ic{flex:none;width:40px;height:40px;border-radius:12px;display:grid;place-items:center;background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
      '.am-ic svg{width:21px;height:21px}'+
      '.am-hd b{font-size:15px;color:#0a2540}'+
      '.am-tag{margin-left:auto;flex:none;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.4px;border-radius:999px;padding:3px 9px}'+
      '.am-tag.usa{background:#dcfce7;color:#15803d}'+
      '.am-tag.breve{background:#f1f5f9;color:#64748b}'+
      '.am-fr{font-size:12.5px;color:#475569;font-weight:600;line-height:1.4;margin:0}'+
      '.am-acoes{display:flex;gap:8px;margin-top:2px;flex-wrap:wrap}'+
      '.am-bt{flex:1;min-width:120px;border:0;cursor:pointer;border-radius:11px;padding:10px 8px;font-size:12.5px;font-weight:900;font-family:inherit}'+
      '.am-bt.usar{background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff;flex-basis:100%}'+
      '.am-bt.inst{background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
      '.am-bt.comp{background:#eef4ff;color:#0a4da6;border:1.5px solid #dbe6fb}'+
      '.am-saiba{align-self:flex-start;background:none;border:0;padding:2px 0;cursor:pointer;font-family:inherit;font-size:12.5px;font-weight:800;color:#0a4da6;text-decoration:underline}'+
      '.am-nota{font-size:11.5px;color:#94a3b8;font-weight:600;line-height:1.4;margin-top:12px}';
    (document.head||document.documentElement).appendChild(st);
  }
  function _amShareTexto(a){ return a.nome+' — '+a.frase+'\nInstala aqui: '+a.link; }
  async function _amCompartilhar(a){
    try{
      if(navigator.share){ await navigator.share({ title:a.nome, text:a.nome+' — '+a.frase, url:a.link }); return; }
    }catch(e){ if(e && e.name==='AbortError') return; }
    try{ window.open('https://wa.me/?text='+encodeURIComponent(_amShareTexto(a)),'_blank','noopener'); return; }catch(_){}
    try{ await navigator.clipboard.writeText(a.link); toast('Link copiado ✓'); }catch(_){ toast(a.link); }
  }
  function _amInstalar(){
    if(_amDeferred){ try{ _amDeferred.prompt(); }catch(_){} _amDeferred=null; return; }
    if(_amEhIos()){ toast('No iPhone: toque em Compartilhar e depois em "Adicionar à Tela de Início".'); return; }
    toast('No menu do navegador, toque em "Instalar aplicativo" (ou "Adicionar à tela inicial").');
  }
  function telaAppsMev(){
    if(typeof window.edIsolada==='function' && window.edIsolada()){
      return;
    }
    _amCss();
    var minha=(typeof window.edicaoAtual==='function')?window.edicaoAtual():'completo';
    /* v831: a página "Apps MEV" é vitrine — usa a lista filtrada. */
    var apps=(typeof window.edAppsVitrine==='function')?window.edAppsVitrine()
             :((typeof window.edApps==='function')?window.edApps():[]);
    var cards=apps.map(function(a){
      var meu=(a.id===minha);
      var tag = meu ? ('<span class="am-tag usa">'+(a.id==='completo'?'Você tem tudo ✓':'Você usa este')+'</span>')
                    : (a.ok?'':'<span class="am-tag breve">Em breve</span>');
      var acoes='';
      if(a.ok){
        acoes='<div class="am-acoes">'+
          /* v496 (forma 1 do PROJETO-os-4-apps-mev: "trocar de bloco sem
             sair do app"). Recarrega em ?app=<id> — é o caminho que o boot
             inteiro já conhece. No app que você JÁ usa, este botão não
             aparece (seria um recarregar à toa). */
          (meu?'':'<button type="button" class="am-bt usar" data-am-usar="'+a.id+'">'+
                 (a.id==='completo'?'Voltar pro MEV Completo':('Usar o '+esc(a.nome)))+'</button>')+
          (meu?'<button type="button" class="am-bt inst" data-am-inst="'+a.id+'">Instalar no celular</button>':'')+
          '<button type="button" class="am-bt comp" data-am-comp="'+a.id+'">Compartilhar</button></div>';
      }
      return '<div class="am-card'+(a.ok?'':' breve')+'">'+
        '<div class="am-hd"><span class="am-ic">'+(_AM_ICO[a.id]||_AM_ICO.completo)+'</span><b>'+esc(a.nome)+'</b>'+tag+'</div>'+
        '<p class="am-fr">'+esc(a.frase)+'</p>'+
        /* v498 — a landing do app (apps.html), pra quem quer entender antes
           de trocar de app ou compartilhar com um parceiro */
        '<button type="button" class="am-saiba" data-am-saiba="'+a.id+'">Saiba mais</button>'+
        acoes+'</div>';
    }).join('');
    irTela(panelHead(_AM_ICO.completo,'blue','Apps MEV','Um app pra cada jeito de trabalhar — mesma conta, mesmo saldo')+
      '<div class="am-grid">'+cards+'</div>'+
      '<div class="am-nota">Compartilhe o link do app certo pro seu parceiro: ele abre direto no celular, sem loja de aplicativos. '+
      'No piloto o ícone instalado ainda é o do MEV Veículos — o ícone próprio de cada app chega com os endereços definitivos.</div>','home');
    Array.prototype.forEach.call(document.querySelectorAll('[data-am-comp]'),function(b){
      b.onclick=function(){
        var a=(window.edApps()||[]).filter(function(x){ return x.id===b.getAttribute('data-am-comp'); })[0];
        if(a) _amCompartilhar(a);
      };
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-am-inst]'),function(b){
      b.onclick=function(){ _amInstalar(); };
    });
    /* v498 — Saiba mais: abre a landing do app em outra aba (o app fica) */
    Array.prototype.forEach.call(document.querySelectorAll('[data-am-saiba]'),function(b){
      b.onclick=function(){
        var u=location.origin+'/apps.html?app='+b.getAttribute('data-am-saiba');
        try{ window.open(u,'_blank','noopener'); }catch(_){ location.href=u; }
      };
    });
    /* v496 — trocar de app aqui dentro */
    Array.prototype.forEach.call(document.querySelectorAll('[data-am-usar]'),function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-am-usar');
        try{ toast('Abrindo o '+((window.edApps()||[]).filter(function(x){ return x.id===id; })[0]||{}).nome+'…'); }catch(_){}
        try{ window.edicaoTrocar(id); }catch(_){ location.href='/app.html?app='+id; }
      };
    });
  }

/* ╔═══ src/app/05e-consulta-landings.js ══════════════════════════════════ */
  /* ==========================================================================
     v1002 — MEV CONSULTAS PREMIUM + LANDINGS DOS PRODUTOS PAGOS
     --------------------------------------------------------------------------
     A home passa a responder três perguntas na ordem certa: quanto tenho,
     qual placa vou consultar e qual relatório resolve minha dúvida. Cada
     produto pago ganha uma página de decisão antes do formulário. Nenhuma
     API ou regra de cobrança mora aqui: preço vem das tabelas canônicas e a
     confirmação apenas libera o botão já ligado ao fluxo seguro existente.
     ========================================================================== */
  var CONSULTA_LANDINGS={
    proprietarios:{ titulo:'Histórico de Proprietários', chamada:'Entenda por quantas mãos este veículo já passou.', resumo:'Organiza os registros de transferência do mais recente ao mais antigo, com períodos quando as datas permitem.', pergunta:'Quantos donos e transferências aparecem na base?', itens:['Registro de proprietário mais recente','Períodos entre transferências registradas','Cidade e UF de cada registro','Passagem anterior por empresa'], nota:'A data mais recente não comprova propriedade atual. PF aparece somente pelo primeiro nome; CPF/CNPJ permanece mascarado.' },
    gravame:{ titulo:'Consulta Gravame', chamada:'Descubra se o veículo ainda está ligado a um financiamento.', resumo:'Consulte banco, contrato, inclusão, baixa e situação atual da alienação antes de fechar negócio.', pergunta:'O veículo está livre para transferência?', itens:['Situação atual do gravame','Banco ou financeira vinculada','Contrato e datas disponíveis','Histórico de inclusão e baixa'], nota:'A resposta depende da atualização das bases consultadas.' },
    recall:{ titulo:'Recall + Recall V2 + FIPE', chamada:'Verifique campanhas pelo veículo e pelo chassi em uma só consulta.', resumo:'A FIPE identifica o veículo e fornece o chassi no servidor; depois o MEV consulta a base de recall por placa e a Recall V2 por chassi.', pergunta:'Existe campanha de recall para este veículo?', itens:['Valor e referência FIPE atual','Recall consultado pela placa','Recall V2 consultado pelo chassi','Campanha, risco, reparo e situação disponíveis'], nota:'Confirme campanhas e atendimento com uma concessionária da marca ou pelos canais oficiais do fabricante.' },
    debitos:{ titulo:'Débitos e restrições', chamada:'Confira pendências estaduais e o detalhamento das multas antes de fechar o negócio.', resumo:'Reúne IPVA, licenciamento, DPVAT, alienação, restrições e cada infração encontrada no RENAINF.', pergunta:'O veículo tem dívida, multa ou impedimento informado pelas bases?', itens:['IPVA, licenciamento e DPVAT','Multas RENAINF com data, infração, órgão, local e valor','Alienação ou financiamento','RENAJUD, roubo/furto e baixa'], nota:'“Nada consta” aparece somente quando a fonte responde explicitamente. Ausência no RENAINF significa apenas que nenhuma ocorrência foi encontrada nessa base.' },
    leilaopt:{ titulo:'Leilão + Perda Total', chamada:'Veja os sinais que mais mudam o risco e o valor de um veículo.', resumo:'Relatório AutoCorp com leilão, score, indício de sinistro, perda total e informações dos agregados.', pergunta:'O histórico pode afetar compra, revenda ou seguro?', itens:['Leilão, data e condição do veículo','Score e condição informados pela base','Indício de sinistro e perda total','Dados e restrições dos agregados disponíveis'], nota:'Fonte AutoCorp. O relatório reflete as bases disponíveis no momento da consulta.' },
    premium:{ titulo:'Total Premium', chamada:'A visão mais completa do veículo em um único relatório.', resumo:'Cruza situação estadual, leilão, roubo e furto, perda total, recall, restrições e alertas para uma decisão mais segura.', pergunta:'Quero reduzir ao máximo as lacunas antes da compra.', itens:['Tudo do Leilão + Perda Total','Situação estadual e financeira','Roubo, furto, RENAJUD e baixa','Recall, alertas e agregados'], nota:'Alguns blocos podem retornar sem apontamentos ou indisponíveis na fonte.' },
    especialjud:{ titulo:'Leilão Especial + Judicial', chamada:'Investigue leilão especial, bloqueios judiciais e alertas relevantes.', resumo:'Consulta focada em ocorrências que podem impedir transferência ou exigir uma análise mais cuidadosa do negócio.', pergunta:'Há bloqueio ou ocorrência especial nesta placa?', itens:['BIN estadual e restrições vinculadas','Roubo, furto e recuperação','Perda total e indício de sinistro','Leilão especial e alertas judiciais'], nota:'Fonte AutoCorp. O relatório reflete as bases disponíveis no momento.' },
    cpf:{ titulo:'Consulta CPF', chamada:'Confira cadastro, pendências e score antes de negociar.', resumo:'Reúne dados cadastrais, ocorrências financeiras e score bancário em uma única consulta, com aceite de proteção de dados.', pergunta:'Qual é a situação cadastral e o risco financeiro deste CPF?', itens:['Dados e situação na Receita Federal','Pendências, protestos e cheques sem fundo','Score bancário e faixa de risco','Exposição de crédito por modalidade'], nota:'O score é indicativo e não substitui sua política de crédito. Uso sujeito a finalidade legítima e aceite da LGPD.' },
    cpfproc:{ titulo:'Ações e processos', chamada:'Entenda a participação da pessoa em processos judiciais.', resumo:'Mostra quantidade, polo, classe, assunto, tribunal, UF e situação dos processos encontrados.', pergunta:'A pessoa aparece como autor ou réu em ações?', itens:['Quantidade de processos','Polo da pessoa em cada ação','Classe e assunto','Tribunal, UF, situação e data'], nota:'Uso sujeito a finalidade legítima e aceite da LGPD.' },
    cpfscore:{ titulo:'Score bancário', chamada:'Avalie o perfil financeiro com uma leitura objetiva do score.', resumo:'Apresenta pontuação, faixa, valores a vencer, vencidos, prejuízo e distribuição das operações.', pergunta:'Qual é o risco financeiro indicado pelas bases?', itens:['Pontuação e faixa do score','Valores a vencer e vencidos','Operações por modalidade','Instituições e período consultado'], nota:'O score é indicativo e não substitui política própria de crédito.' },
    cnpjcompliance:{ titulo:'Compliance Complete · CNPJ', chamada:'Conheça a empresa, suas restrições e sinais de compliance.', resumo:'Combina score PJ, protestos, negativações, dados firmográficos e consultas em listas públicas.', pergunta:'A empresa apresenta alerta financeiro ou reputacional?', itens:['Score de crédito PJ','Protestos e negativações','Listas públicas de compliance','Histórico de consultas ao CNPJ'], nota:'A identificação cadastral gratuita aparece antes da análise paga.' },
    cnpjsintegra:{ titulo:'Inscrição Estadual · Sintegra', chamada:'Confirme o cadastro estadual da empresa antes de negociar.', resumo:'Consulta inscrição estadual, situação cadastral, regime de apuração e atividade econômica vinculados ao CNPJ.', pergunta:'A empresa está habilitada como contribuinte estadual?', itens:['Inscrição estadual e UF','Situação cadastral do contribuinte','Regime de apuração e NFe','Atividade principal e endereço'], nota:'A ausência de número de IE no retorno não comprova isenção. Confira a situação informada pela base.' },
    /* v1024 — as quatro linhas são as do §5.8 do projeto: o que o card promete
       ANTES de o lojista pagar. Promessa, não decoração. */
    cnpjprocessos:{ titulo:'Ações e processos · CNPJ', chamada:'Veja em quais processos judiciais a empresa aparece como parte.', resumo:'Mostra quantidade, polo, classe, assunto, tribunal, vara, situação, data e valor da causa dos processos encontrados.', pergunta:'A empresa é autora ou ré em ações judiciais?', itens:['Processos judiciais em que a empresa aparece como parte','Se ela é AUTORA ou RÉ em cada um','Tribunal, vara, assunto e valor da causa','Situação: em tramitação ou arquivado, com data'], nota:'A identificação cadastral gratuita aparece antes da análise paga.' }
  };
  var _consultaLandingDireto='';
  var _consultaLandingPlaca='';

  function consultaLandingEh(k){ return !!CONSULTA_LANDINGS[k]; }
  function consultaPrecoUnidades(k){
    if(k==='placa'){ try{return Number(PRECOS.fipe)||0.06;}catch(_){return 0.06;} }
    try{ return Number(consPreco(k))||0; }catch(_){ return 0; }
  }
  function consultaPrecoTexto(k){ var n=consultaPrecoUnidades(k); return n?precoReal(n):'Grátis'; }
  function consultaLandingFaq(k){
    var doc=k.indexOf('cpf')===0?'o CPF':(k.indexOf('cnpj')===0?'o CNPJ':'a placa');
    var propria={
      proprietarios:['A consulta mostra os dados pessoais completos?','Não. Para pessoa física aparece somente o primeiro nome, e CPF ou CNPJ permanece mascarado. O telefone não faz parte do relatório. Razões sociais antigas podem aparecer completas.'],
      gravame:['A consulta garante que o veículo pode ser transferido?','Não. Ela informa os registros de gravame encontrados nas bases consultadas. Antes de concluir o negócio, confira também a situação atual no órgão de trânsito.'],
      recall:['Se não aparecer campanha, o veículo está definitivamente sem recall?','O relatório só mostra “nenhum recall encontrado” quando as duas bases respondem sem apontamentos. Ainda assim, confirme a situação com o fabricante, pois campanhas e atendimentos podem ser atualizados.'],
      debitos:['“Nada consta” garante que o veículo está livre para transferir?','Não. O relatório reflete os indicadores devolvidos pela Base Estadual na data da consulta. Confira também o órgão de trânsito e trate qualquer item não verificado antes de concluir o negócio.'],
      leilaopt:['O score de leilão significa que o seguro será aceito?','Não. O score e o rating são indicadores de risco. A decisão de aceitar, recusar ou definir condições pertence a cada seguradora.'],
      premium:['O Total Premium substitui uma vistoria cautelar?','Não. O relatório reúne bases cadastrais e históricas, mas não verifica presencialmente estrutura, identificação, conservação ou reparos do veículo.'],
      especialjud:['Um alerta judicial sempre impede a transferência?','Não necessariamente. O relatório mostra o alerta encontrado; o efeito prático depende do tipo, da situação e do órgão responsável pelo registro.'],
      cpf:['Posso consultar qualquer CPF?','Use a consulta somente com finalidade legítima e conforme o aceite de proteção de dados apresentado no app. Não utilize as informações para finalidade incompatível.'],
      cpfproc:['A presença em um processo significa condenação?','Não. Uma pessoa pode aparecer como autora, ré ou participante, e o processo pode estar em diferentes fases. Analise o polo, a classe e a situação informados.'],
      cpfscore:['O score decide sozinho se devo conceder crédito?','Não. A pontuação é um indicador e deve ser combinada com sua política de crédito, documentos, renda e demais informações da negociação.'],
      cnpjcompliance:['Aparecer em uma lista significa irregularidade definitiva?','Não necessariamente. Confira a fonte, a natureza do apontamento e a data da consulta antes de tomar uma decisão ou pedir esclarecimentos à empresa.'],
      cnpjsintegra:['A consulta substitui uma certidão estadual?','Não. Ela apresenta os dados encontrados na base estadual na data da pesquisa. Para atos formais, confirme também no portal oficial da Secretaria da Fazenda da UF.'],
      cnpjprocessos:['A empresa aparecer em um processo significa que ela perdeu a causa?','Não. Ela pode ser autora ou ré, e o processo pode estar em qualquer fase. Olhe o polo, a classe, o assunto e a situação antes de decidir.']
    };
    return [
      ['O que preciso informar?','Informe '+doc+' no formato solicitado e revise o dado antes de confirmar. O app mostra o valor da consulta antes de iniciar.'],
      ['Quando o saldo é descontado?','O débito ocorre somente depois que você confirma o valor e inicia a consulta. Abrir esta página não consome saldo.'],
      ['Qual é a diferença entre “Nada consta” e “Fonte indisponível”?','“Nada consta” significa que a fonte respondeu e não encontrou apontamento. “Fonte indisponível” significa que não foi possível verificar naquele momento e não deve ser interpretado como situação regular.'],
      ['Posso abrir o resultado novamente sem pagar?','Sim. Quando o resultado estiver salvo no histórico, você pode reabri-lo sem nova cobrança. Iniciar uma nova consulta pode gerar um novo débito.'],
      ['Como vejo ou baixo o PDF?','Depois do resultado, toque em “Baixar PDF”. O documento abre no visualizador do app, onde você pode baixar ou compartilhar.'],
      propria[k]
    ].filter(Boolean);
  }
  function consultaLandingFaqHtml(k){
    var itens=consultaLandingFaq(k);
    return '<section class="cl-faq" aria-labelledby="clFaqTit"><span class="cl-kicker">TIRE SUAS DÚVIDAS</span><h2 id="clFaqTit">Perguntas frequentes</h2><div class="cl-faq-list">'
      +itens.map(function(x){ return '<details class="cl-faq-item"><summary>'+esc(x[0])+'</summary><p>'+esc(x[1])+'</p></details>'; }).join('')
      +'</div></section>';
  }
  function consultaLandingIntercepta(k,placa){
    if(k==='cpfscore') k='cpf';
    if(!consultaLandingEh(k)) return false;
    if(_consultaLandingDireto===k){ _consultaLandingDireto=''; return false; }
    consultaLandingAbrir(k,placa||''); return true;
  }
  function consultaLandingEntrar(k,placa){
    if(k==='cpfscore') k='cpf';
    _consultaLandingDireto=k; _consultaLandingPlaca=placa||'';
    consIr(k,placa||'');
    try{ voltarTab(function(){ consultaLandingAbrir(k,placa||''); }); }catch(_){}
  }
  function consultaLandingComplianceExemploPdf(){
    if(!_mevPdfPronto(consultaLandingComplianceExemploPdf,false)) return;
    try{
      toast('Gerando exemplo em PDF...');
      var st=pdfkitNovo({
        tipo:'EXEMPLO - COMPLIANCE COMPLETE CNPJ',
        doc:'00.000.000/0000-00',
        protocolo:'EXEMPLO-FICTICIO',
        lgpdCurto:'Documento demonstrativo. Todos os dados desta página são fictícios.'
      });
      kitAtencao(st,'EXEMPLO SEM VALIDADE - nenhum dado real foi consultado e nenhum valor foi cobrado.');
      kitVeredito(st,'ok','Situação cadastral ativa','Resultado inteiramente fictício para demonstrar o formato do relatório.');
      kitScore(st,'Score de crédito PJ','742','Faixa demonstrativa');
      kitKv2(st,'Identificação da empresa',[
        ['Razão social','EMPRESA EXEMPLO COMERCIAL LTDA'],
        ['CNPJ','00.000.000/0000-00'],
        ['Porte','EMPRESA DE PEQUENO PORTE'],
        ['Atividade principal','COMÉRCIO VAREJISTA - EXEMPLO']
      ]);
      kitSelo(st,'Protestos em cartório: nada consta neste exemplo fictício.');
      kitKv2(st,'Negativações',[
        ['Situação','Nenhuma ocorrência neste exemplo'],
        ['Valor total','Nenhum valor neste exemplo'],
        ['Última atualização','Data fictícia']
      ]);
      kitKv2(st,'Listas de compliance',[
        ['CEIS / CNEP / TCU','Sem apontamentos neste exemplo'],
        ['PEP / IBAMA / MPT','Sem apontamentos neste exemplo'],
        ['Leitura','Resultado demonstrativo; não use para decisão real']
      ]);
      kitKv2(st,'Consultas recentes',[
        ['Quantidade','3 consultas fictícias'],
        ['Período','Últimos 90 dias - exemplo']
      ]);
      var blob=kitPdfBlob(kitFinaliza(st));
      if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      pdfVisor(blob,'exemplo-compliance-complete-cnpj.pdf');
    }catch(_){ toast('Não consegui abrir o exemplo em PDF agora.'); }
  }
  function consultaLandingAbrir(k,placa){
    if(k==='cpfscore') k='cpf';
    var P=CONSULTA_LANDINGS[k]; if(!P) return;
    _consultaLandingPlaca=placa||'';
    var ico=(_CT_ICO&&_CT_ICO[k])||'';
    var check='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
    var html='<article class="consulta-landing">'
      +'<section class="cl-hero cl-hero-v2"><div class="cl-hero-ico" aria-hidden="true">'+ico+'</div>'
        +'<div class="cl-hero-copy"><span class="cl-kicker">RELATÓRIO PARA DECIDIR COM SEGURANÇA</span><h1>'+esc(P.chamada)+'</h1><p>'+esc(P.resumo)+'</p></div>'
        +'<div class="cl-hero-buy"><div class="cl-price"><small>Valor da consulta</small><strong>'+esc(consultaPrecoTexto(k))+'</strong><span>Débito somente após confirmar</span></div>'
          +'<button type="button" class="cl-hero-cta" id="clComecar"><span>Começar consulta</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button></div></section>'
      +'<section class="cl-includes" aria-labelledby="clIncludesTit"><div class="cl-includes-head"><span class="cl-kicker">O QUE VOCÊ RECEBE</span><h2 id="clIncludesTit">'+esc(P.pergunta)+'</h2></div>'
        +'<div class="cl-grid cl-grid-v2">'+P.itens.map(function(x){return '<div class="cl-item cl-benefit"><span>'+check+'</span><b>'+esc(x)+'</b></div>';}).join('')+'</div></section>'
      +'<section class="cl-flow cl-flow-v2" aria-label="Como funciona"><div class="cl-flow-head"><span class="cl-kicker">COMO FUNCIONA</span><b>Da busca ao relatório em três passos</b></div>'
        +'<div class="cl-flow-steps"><div><small>01</small><b>Informe</b><span>Revise os dados.</span></div><div><small>02</small><b>Confirme</b><span>Veja o valor antes.</span></div><div><small>03</small><b>Receba</b><span>Leia no app e baixe.</span></div></div></section>'
      +'<p class="cl-note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>'+esc(P.nota)+'</p>'
      +consultaLandingFaqHtml(k)
      +'</article>';
    consultaUiPagina({chave:k,tab:'completa',voltar:'home',ico:ico,cor:'blue',titulo:P.titulo,sub:'Entenda o relatório antes de consultar'},html);
    var c=$('clComecar'); if(c)c.onclick=function(){consultaLandingEntrar(k,_consultaLandingPlaca);};
  }

  /* ---------- home exclusiva do MEV Consultas ---------- */
  function _hcpCard(k,nome,desc,gratis){
    var ico=(_CT_ICO&&_CT_ICO[k])||'';
    var unidades=gratis?0:consultaPrecoUnidades(k);
    return '<button type="button" class="hcp-card" data-hcp="'+esc(k)+'" data-preco="'+unidades+'"><span class="hcp-ico" aria-hidden="true">'+ico+'</span><span class="hcp-copy"><b>'+esc(nome)+'</b><small>'+esc(desc)+'</small><em>'+(gratis?'Grátis':esc(consultaPrecoTexto(k)))+'</em></span><svg class="hcp-go" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m9 18 6-6-6-6"/></svg></button>';
  }
  /* v1004/v1388 — a ordem não é escrita à mão: cada grupo compara o mesmo
     valor numérico que pinta o preço. Se a tabela comercial mudar, o card
     muda de lugar junto; grátis vale zero e naturalmente fica no início. */
  function _hcpOrdenarPorPreco(box){
    Array.prototype.forEach.call(box.querySelectorAll('[data-hpanel]'),function(painel){
      var cards=Array.prototype.slice.call(painel.querySelectorAll('.hcp-card'));
      cards.sort(function(a,b){ return Number(a.getAttribute('data-preco')||0)-Number(b.getAttribute('data-preco')||0); });
      cards.forEach(function(card){ painel.appendChild(card); });
    });
  }
  function _hcpAvaliacoesLigar(box){
    if(!box) return;
    var nova=box.querySelector('[data-havl="nova"]');
    var lista=box.querySelector('[data-havl="lista"]');
    function pode(){
      try{ if(typeof acPortao==='function' && acPortao('avaliacoes')) return false; }catch(_){}
      try{ if(typeof avAreaSalvar==='function' && !avAreaSalvar()) return false; }catch(_){}
      try{ if(typeof avAreaMarcar==='function') avAreaMarcar('avaliacoes'); }catch(_){}
      return true;
    }
    if(nova) nova.onclick=function(){ if(!pode()) return; try{ avlNovaAbrir(); }catch(_){ try{ telaAvaliacoes().then(function(){ var b=$('avlNovaBtn'); if(b)b.click(); }); }catch(__){} } };
    if(lista) lista.onclick=function(){ if(!pode()) return; try{ telaAvaliacoes(); }catch(_){} };
  }
  /* ==========================================================================
     🔴 v1058 (pedido do Angelo, com os dois prints) — "a página de consultas
     do MEV Avaliações, consegue trazer a mesma do MEV Consultas?"
     --------------------------------------------------------------------------
     Esta tela já existia inteira. Ela estava trancada numa linha: a montagem
     só acontecia na edição `consultas`, e o MEV Avaliações caía no painel
     antigo (a grade compacta com as pílulas de preço).

     ⚠️ O QUE MUDA DE VERDADE, E NÃO É SÓ APARÊNCIA: o painel antigo
     mostrava na home da aba Consultas um grupo **Conta** (Apps, Tokens,
     Pagamentos, Notificações, Termos, Suporte). A tela premium não tem esse
     grupo — no MEV Consultas esses destinos moram no menu, e é de lá que se
     chega neles. No MEV Avaliações eles também estão no menu (o
     `mdrAvaliaMontar` os organiza), então nenhum caminho SOME — mas o atalho
     da home sai. Foi conferido no teste: o menu continua levando aos seis.

     ⛳ E O QUE **NÃO** MUDA: o pacote de consultas. ⚠️ E aqui eu escrevi
     errado antes de pôr a régua: eu disse que no MEV Avaliações só `placa` e
     `hist` estavam liberados. NÃO É ISSO. Duas linhas do `00-edicoes` mandam
     no assunto:
         EDICOES.avalia.cons = EDICOES.consultas.cons.slice();   (linha ~193)
         edConsPermite(): if(e==='avalia') return EDICOES.consultas.cons...  (v996)
     O literal de cima (`cons:['placa','hist']`) é SOBRESCRITO trinta linhas
     abaixo. As duas edições têm O MESMO pacote, e é por isso que os cards já
     mostravam PREÇO nos dois apps, nunca cadeado.
     ✅ Então a trava não afrouxou porque não havia trava aqui pra afrouxar. A
     régua da v1058 cobra a IGUALDADE do pacote nos dois lados — se alguém um
     dia apagar aquela linha de herança, o teste reprova.
     ========================================================================== */
  function homeConsultasPremiumMontar(box,th){
    try{
      if(typeof edicaoAtual!=='function') return false;
      /* 🔴 v1069 (pedido do Angelo: "no mev completo — traga o visual premium
         do mev consultas"). Terceira edição a entrar na MESMA tela.
         ⛳ É barato de propósito, e pelo mesmo motivo da v1058: quando o
            pedido é "traz a mesma tela", a resposta certa não é desenhar de
            novo — é achar a linha que tranca. Duas telas que "deviam ser
            iguais" mantidas em dois lugares divergem sozinhas na versão
            seguinte. */
      if(['consultas','avalia','completo'].indexOf(edicaoAtual())<0) return false;
    }catch(_){ return false; }
    if(box.querySelector('.consultas-premium-home')){
      try{ _hcpAvaliacoesLigar(box); }catch(_){}
      try{ if(['consultas','avalia'].indexOf(edicaoAtual())>=0 && !box.querySelector('.mev-consultas-rodape') && typeof mevConsultasRodapeHtml==='function') box.querySelector('.consultas-premium-home').insertAdjacentHTML('beforeend',mevConsultasRodapeHtml('pagina')); }catch(_){}
      try{ if(typeof homeVantagensConsultasMontar==='function') homeVantagensConsultasMontar(box.querySelector('.consultas-premium-home')); }catch(_){} try{acAplicar(box);}catch(_){} return true;
    }
    var _hcpRodape='';
    try{ if(['consultas','avalia'].indexOf(edicaoAtual())>=0 && typeof mevConsultasRodapeHtml==='function') _hcpRodape=mevConsultasRodapeHtml('pagina'); }catch(_){}
    var _hcpAvalia='';
    try{ if(edicaoAtual()==='avalia') _hcpAvalia='<section class="hcp-avalia" aria-labelledby="hcpAvaliaTit">'
      +'<div class="hcp-avalia-copy"><span class="hcp-avalia-ico" aria-hidden="true">'+_CTF_ICO_AVAL+'</span><div><small>MEV AVALIAÇÕES</small><h2 id="hcpAvaliaTit">Avalie e acompanhe veículos</h2><p>Comece uma avaliação ou retome as negociações salvas.</p></div></div>'
      +'<div class="hcp-avalia-acoes"><button type="button" class="hcp-avalia-nova" data-havl="nova"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>Nova avaliação</span></button>'
      +'<button type="button" class="hcp-avalia-lista" data-havl="lista"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg><span>Minhas avaliações</span></button></div>'
      +'</section>'; }catch(_){}
    box.innerHTML='<div class="consultas-premium-home" id="homePainel">'
      +_hcpAvalia
      +'<div class="hcp-credit saldo-chip"><span>Saldo disponível</span><strong class="sc-n">—</strong><small>para usar nas consultas</small><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></div>'
      +'<section class="hcp-search-slot" id="hcpSearchSlot"></section>'
      +'<nav class="hcp-quick" aria-label="Ações rápidas">'
        +'<button type="button" data-hq="fipe">'+(_CT_ICO.fipe||'')+'<span><b>Buscar por veículo</b><small>Marca, modelo e ano</small></span></button>'
        +'<button type="button" data-hq="hist">'+(_CT_ICO.hist||'')+'<span><b>Histórico</b><small>Consultas anteriores</small></span></button>'
      +'</nav>'
      +'<section class="hcp-catalog"><header><div><span>ESCOLHA O RELATÓRIO</span><h2>Consultas disponíveis</h2></div><p>Veja o que cada consulta entrega antes de usar seu saldo.</p></header>'
        +'<div class="hcp-segments" role="tablist" aria-label="Categoria da consulta"><button class="on" data-hseg="veiculo" role="tab" aria-selected="true">Veículo</button><button data-hseg="pessoa" role="tab" aria-selected="false">Pessoa</button><button data-hseg="empresa" role="tab" aria-selected="false">Empresa</button></div>'
        +'<div class="hcp-panel on" data-hpanel="veiculo">'
          +_hcpCard('proprietarios','Histórico de proprietários','Donos e transferências registradas')+_hcpCard('gravame','Gravame','Alienação, banco e contrato')+_hcpCard('recall','Recall','Consulta por placa e chassi')+_hcpCard('leilaopt','Leilão + PT','Leilão, sinistro e perda total')+_hcpCard('premium','Total Premium','O relatório veicular mais completo')+_hcpCard('especialjud','Leilão Especial + Judicial','Bloqueios e alertas judiciais')+'</div>'
        +'<div class="hcp-panel" data-hpanel="pessoa">'+_hcpCard('cpf','Consulta CPF','Cadastro, pendências e score bancário')+_hcpCard('cpfproc','Ações e processos','Participação em processos judiciais')+'</div>'
        +'<div class="hcp-panel" data-hpanel="empresa">'+_hcpCard('cnpj','Consulta CNPJ','Cadastro e situação da empresa',true)+_hcpCard('cnpjsintegra','Inscrição Estadual · Sintegra','IE e situação cadastral estadual')+_hcpCard('cnpjcompliance','Compliance Complete','Crédito, restrições e listas públicas')+_hcpCard('cnpjprocessos','Ações e processos','Processos judiciais da empresa')+'</div>'
      +'</section>'+_hcpRodape+'</div>';
    /* v1325/v1327 — integra somente o carrossel editorial à Home oficial. A
       montagem insere o bloco depois da busca e antes dos atalhos, sem manter
       página/rota de prévia nem duplicar as ações já existentes. */
    try{ if(typeof homeVantagensConsultasMontar==='function') homeVantagensConsultasMontar(box.querySelector('.consultas-premium-home')); }catch(_){}
    try{ _hcpAvaliacoesLigar(box); }catch(_){}
    /* ======================================================================
       🔴🔴🔴 v1076 — A HOME DO MEV COMPLETO É A HOME DO MEV CONSULTAS. PONTO.
       ----------------------------------------------------------------------
       Aqui moravam duas linhas da v1069: uma chamava `_hcpExtrasCompleto`,
       que descia os grupos Lojista · CRM · Conta pro fim da tela premium, e
       outra chamava a fileira "Mais usados". As duas saíram.

       ⚠️ POR QUE EU TINHA POSTO: o pedido da v1069 foi "traga o visual
          premium do MEV Consultas". Eu li "visual" e entendi "só a aparência,
          guarda os atalhos" — e guardei. O Angelo olhou a tela pronta e disse
          as duas coisas, com print: "remove os mais usados da tela, pra ficar
          no mesmo padrão do mev consultas" e, sobre os três grupos, "remove
          esses também". Mesmo padrão é mesmo padrão.

       🔑 NENHUM CAMINHO SOME — e isto foi MEDIDO, não suposto. Os catorze
          destinos dos três grupos (Minha loja, Estoque, Mercado, Repasse,
          Catálogo, Vendas, Avaliações, Vitrine, Leads, Clientes, Meu
          cadastro, Saldo, Uso e faturamento, Apps) continuam no menu ☰, com
          `data-acao` próprio. O único que não tem linha no menu é o Site, que
          abre pelo botão flutuante `#btnSiteFab` — e a régua desta versão
          confere os quinze, um por um, na tela.
       ====================================================================== */
    var slot=$('hcpSearchSlot'),hl=th.querySelector('.home-left'); if(slot&&hl)slot.appendChild(hl);
    /* v1306 — sempre que a home premium reaparece, confirma o saldo no
       servidor. A tela pode continuar instantânea com o último valor em
       memória, mas não permanece com número antigo depois de uma consulta,
       recarga ou retorno do segundo plano. */
    try{ carregarSaldo(); }catch(_){}
    var hc=$('homeHistCol'); if(hc)hc.style.display='none';
    _hcpOrdenarPorPreco(box);
    Array.prototype.forEach.call(box.querySelectorAll('[data-hseg]'),function(b){b.onclick=function(){var k=b.getAttribute('data-hseg');Array.prototype.forEach.call(box.querySelectorAll('[data-hseg]'),function(x){var on=x===b;x.classList.toggle('on',on);x.setAttribute('aria-selected',on?'true':'false');});Array.prototype.forEach.call(box.querySelectorAll('[data-hpanel]'),function(x){x.classList.toggle('on',x.getAttribute('data-hpanel')===k);});};});
    Array.prototype.forEach.call(box.querySelectorAll('[data-hcp]'),function(b){b.onclick=function(){consIr(b.getAttribute('data-hcp'));};});
    Array.prototype.forEach.call(box.querySelectorAll('[data-hq]'),function(b){b.onclick=function(){var k=b.getAttribute('data-hq');if(k==='hist'){abrirHistorico();return;}if(k==='fipe'){abrirBuscaVeiculo();}};});
    /* 🔴 a MESMA fiação do painel antigo, pelo mesmo endereço. Ligar à mão
       aqui criaria um segundo caminho pro mesmo clique — e dois caminhos pro
       mesmo botão é como um deles fica pra trás numa mudança futura. */
    try{ if(typeof homeAtalhosLigar==='function') homeAtalhosLigar(box); }catch(_){}
    try{acAplicar(box);acGarantir();acModalLigar();}catch(_){}
    return true;
  }

  /* v1340 — "Veiculares" no menu é a porta do catálogo completo, não um
     atalho disfarçado para a seleção manual da FIPE. A busca por marca/modelo
     continua na ação rápida da Home. Aqui selecionamos a categoria Veículo e
     levamos o foco ao catálogo já existente, sem duplicar cards ou rotas. */
  function homeConsultasVeicularesAbrir(){
    try{
      if(typeof edicaoAtual==='function'&&edicaoAtual()==='avalia'){
        if(typeof avAreaSalvar==='function'&&!avAreaSalvar()) return;
        if(typeof avAreaMarcar==='function') avAreaMarcar('consultas');
      }
    }catch(_){ }
    try{ drawerFechar(false); }catch(_){ }
    try{ mevAcoes(false); }catch(_){ }
    try{ voltarHome(); }catch(_){ }
    var tentativas=0;
    function abrir(){
      tentativas++;
      var raiz=$('homePainel')||$('telaHome');
      var aba=raiz&&raiz.querySelector('[data-hseg="veiculo"]');
      var catalogo=raiz&&raiz.querySelector('.hcp-catalog');
      if((!aba||!catalogo)&&tentativas<7){ setTimeout(abrir,60); return; }
      if(!aba||!catalogo) return;
      try{ aba.click(); }catch(_){ }
      try{ aba.focus({preventScroll:true}); }catch(_){ try{ aba.focus(); }catch(__){ } }
      var suave=true;
      try{ suave=!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){ }
      try{ catalogo.scrollIntoView({behavior:suave?'smooth':'auto',block:'start'}); }catch(_){ catalogo.scrollIntoView(); }
    }
    setTimeout(abrir,80);
  }

  /* ---------- confirmação imediatamente antes da ação paga ---------- */
  var _ccLiberado=null, _ccFoco=null;
  function _ccChave(btn){
    if(!btn) return '';
    var m={placaBuscar:'placa',restBt3:'cpf',cpfProcBt:'cpfproc',cpfScoreBt:'cpfscore',cnpjCmplBt:'cnpjcompliance',cnpjProcBt:'cnpjprocessos',cnpjSintegraBt:'cnpjsintegra',veicBtGravame:'gravame',veicBtRecall:'recall',veicBtDebitos:'debitos',veicBtProprietarios:'proprietarios'};
    if(m[btn.id]) return m[btn.id];
    if(btn.id==='veicPlacaLupa'){
      try{return VEIC_PAGS[_veicPagAtual]?_veicPagAtual:'';}catch(_){return '';}
    }
    return '';
  }
  function _ccDado(k){
    var id=k==='placa'?'placa':(k.indexOf('cpf')===0?'restDoc':(k.indexOf('cnpj')===0?'cnpjDoc':'veicPlaca'));
    var el=$(id),v=el?String(el.value||'').trim():'';
    return {rotulo:k.indexOf('cpf')===0?'CPF':(k.indexOf('cnpj')===0?'CNPJ':'Placa'),valor:v||'—'};
  }
  function consultaConfirmarFechar(){var bg=$('consultaConfirmBg');if(bg&&bg.parentNode)bg.parentNode.removeChild(bg);try{if(_ccFoco)_ccFoco.focus();}catch(_){}_ccFoco=null;}
  function _ccSaldoRepinta(bg,un){
    if(!bg||!bg.parentNode)return;
    var conhecido=!!_saldoOk,disp=Number(saldo)||0,sem=conhecido&&!ilimitado&&disp<un;
    var valor=bg.querySelector('.cc-credit-value'),estado=bg.querySelector('.cc-credit-state'),ok=bg.querySelector('.cc-ok');
    if(valor)valor.textContent=conhecido?(ilimitado?'Ilimitado':precoReal(disp)):'Verificando…';
    if(estado){
      if(sem){estado.className='cc-credit-state cc-alert';estado.textContent='Seu saldo não é suficiente para esta consulta.';}
      else if(!conhecido){estado.className='cc-credit-state cc-safe';estado.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>O servidor confirmará seu saldo antes de iniciar.';}
      else{estado.className='cc-credit-state cc-safe';estado.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>O débito é processado pelo fluxo seguro do MEV.';}
    }
    if(ok)ok.textContent=sem?'Adicionar saldo':'Confirmar e consultar';
  }
  function consultaConfirmarAbrir(k,btn){
    var un=consultaPrecoUnidades(k),preco=consultaPrecoTexto(k),d=_ccDado(k);
    _ccFoco=btn;
    var bg=document.createElement('div');bg.id='consultaConfirmBg';bg.className='consulta-confirm-bg';bg.innerHTML='<section class="consulta-confirm" role="dialog" aria-modal="true" aria-labelledby="ccTit"><button type="button" class="cc-x" aria-label="Fechar">×</button><span class="cc-kicker">CONFIRME ANTES DE CONSULTAR</span><h2 id="ccTit">Tudo certo para continuar?</h2><p>Confira o dado e o valor. A consulta só começa depois desta confirmação.</p><div class="cc-data"><span>'+esc(d.rotulo)+'</span><b>'+esc(d.valor)+'</b></div><div class="cc-money"><div><span>Valor da consulta</span><strong>'+esc(preco)+'</strong></div><div><span>Saldo disponível</span><strong class="cc-credit-value">—</strong></div></div><div class="cc-credit-state" role="status" aria-live="polite"></div><button type="button" class="cc-ok">Confirmar e consultar</button><button type="button" class="cc-cancel">Cancelar</button></section>';
    document.body.appendChild(bg);
    _ccSaldoRepinta(bg,un);
    if(!_saldoOk){try{carregarSaldo().then(function(){_ccSaldoRepinta(bg,un);});}catch(_){}}
    var fechar=function(){consultaConfirmarFechar();};bg.querySelector('.cc-x').onclick=fechar;bg.querySelector('.cc-cancel').onclick=fechar;bg.onclick=function(e){if(e.target===bg)fechar();};
    bg.querySelector('.cc-ok').onclick=function(){var semAgora=!!_saldoOk&&!ilimitado&&(Number(saldo)||0)<un;if(semAgora){fechar();try{abrirPacotes();}catch(_){toast('Abra sua conta para adicionar saldo.');}return;}_ccLiberado=btn;fechar();btn.click();};
    setTimeout(function(){try{bg.querySelector('.cc-ok').focus();}catch(_){}},0);
  }
  document.addEventListener('click',function(ev){
    var btn=ev.target&&ev.target.closest?ev.target.closest('button'):null,k=_ccChave(btn);if(!k||btn.disabled)return;
    if(_ccLiberado===btn){_ccLiberado=null;return;}
    try{if(ilimitado)return;}catch(_){}
    try{if(k==='placa'&&Number(gratisFipe)>0)return;}catch(_){}
    try{if((k==='leilaopt'||k==='premium'||k==='especialjud')&&typeof autocorpCobra==='function'&&!autocorpCobra())return;}catch(_){}
    ev.preventDefault();ev.stopImmediatePropagation();consultaConfirmarAbrir(k,btn);
  },true);
  document.addEventListener('keydown',function(ev){if(ev.key==='Escape'&&$('consultaConfirmBg'))consultaConfirmarFechar();});

/* ╔═══ src/app/05f-home-do-app.js ════════════════════════════════════════ */
  /* ==========================================================================
     05f — A PÁGINA INICIAL DE CADA APP (v497)

     "quando abre cada um, abre direto na função — tá abrindo na consulta de
      placas" · "crie uma pagina inicial pra cada app, com os cards das
      paginas"

     Abrir o MEV Estoque e cair na consulta de placa é a home do MEV Placas, não
     a dele. Agora cada edição tem a SUA página inicial: um painel com os
     cards das páginas daquele app — e é ela que abre quando o app entra.

     DE ONDE VÊM OS CARDS (nada é escrito duas vezes):
     · a LISTA é o bloco da edição (00-edicoes.js) — mexeu no mapa, mexeu
       aqui junto;
     · o ÍCONE e o NOME saem do PRÓPRIO BOTÃO do menu lateral (app.html). É
       o mesmo desenho e a mesma palavra que a pessoa já conhece, e não
       nasce uma segunda tabela de ícones pra desandar depois;
     · página escondida por style inline (Pré-RENAVE, Chat, Funil,
       Dashboard) NÃO vira card — a mesma régua do menu;
     · a consulta de placa NÃO vira card: é o motor (mora no menu e na
       inicial de sempre), não um destino do app.

     QUEM TEM PAINEL E QUEM NÃO TEM (pedidos do Angelo, 15/08) — quem manda
     é o campo `inicial` do 00-edicoes.js:
       MEV Estoque → painel: Minha loja · Estoque · Repasse · Catálogo
       MEV CRM    → painel: Clientes · Pós-vendas   ("chat acho que não precisa")
       MEV Rede  → painel: Rede Repasses · Rede Seminovos · Repasse
       MEV Avalia  → SEM painel: abre direto em Avaliações ("só vai ter a
                     página principal")
       MEV Vendas  → SEM painel: abre direto em Vendas ("só a página de vendas")
       MEV Consultas → SEM painel: a inicial é a consulta de placa, que é o
                     produto dele.
     No MEV Completo esta página não existe — lá a inicial é a de sempre.
     ========================================================================= */
  var _haCardsOrdem=null;   /* (reservado: ordem manual por bloco, se um dia) */

  function _haIcone(acao){
    try{
      var b=document.querySelector('#mevDrawer .mdr-nav [data-acao="'+acao+'"] svg');
      if(b) return b.outerHTML;
    }catch(_){}
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/></svg>';
  }
  function _haNome(acao){
    try{
      var b=document.querySelector('#mevDrawer .mdr-nav [data-acao="'+acao+'"]');
      if(b){
        var t=String(b.textContent||'').replace(/\s+/g,' ').trim();
        if(t) return t;
      }
    }catch(_){}
    return acao;
  }
  /* a página está escondida no menu por style inline? (regra da v437) */
  function _haOculta(acao){
    try{
      var b=document.querySelector('#mevDrawer .mdr-nav [data-acao="'+acao+'"]');
      if(!b) return true;
      var n=b;
      while(n && !(n.classList && n.classList.contains('mdr-nav'))){
        if(!(n.classList && n.classList.contains('mdr-sub')) && n.style && n.style.display==='none') return true;
        n=n.parentElement;
      }
      return false;
    }catch(_){ return true; }
  }
  function haAppCards(){
    var lista=[];
    try{ lista=(typeof window.edicaoPainel==='function')?window.edicaoPainel():[]; }catch(_){ lista=[]; }
    return lista.filter(function(a){ return a!=='buscaplaca' && !_haOculta(a); });
  }
  function _haCss(){
    if($('mevHomeAppCss')) return;
    var st=document.createElement('style'); st.id='mevHomeAppCss';
    st.textContent=
      '#homeAppPainel{padding:2px 0 8px}'+
      /* nos apps COM consulta (Consultas·Avalia) o bloco entra no fim da
         home, só com os outros apps — e ganha um fio pra separar */
      '#homeAppPainel.so-outros{grid-column:1/-1;margin-top:6px;padding-top:14px;border-top:1px solid #e4ebf5}'+
      '#homeAppPainel.so-outros .ha-sec{margin-top:0}'+
      '#homeAppPainel .ha-tit{display:flex;align-items:center;gap:11px;margin:2px 0 12px}'+
      '#homeAppPainel .ha-tit .hi{flex:none;width:42px;height:42px;border-radius:13px;display:grid;place-items:center;background:#eaf2ff;color:#0a4da6}'+
      '#homeAppPainel .ha-tit .hi svg{width:21px;height:21px}'+
      '#homeAppPainel .ha-tit b{display:block;font-size:17px;font-weight:900;color:#0a2540;line-height:1.2}'+
      '#homeAppPainel .ha-tit small{display:block;font-size:12.5px;color:#64748b;font-weight:650}'+
      '#homeAppPainel .ha-sec{font-size:11px;font-weight:900;letter-spacing:.6px;text-transform:uppercase;color:#94a3b8;margin:20px 0 9px}'+
      /* os outros apps: cartão em linha, mais discreto que os do app atual */
      '.ha-out{display:grid;grid-template-columns:1fr 1fr;gap:10px}'+
      '@media(min-width:720px){.ha-out{grid-template-columns:repeat(3,1fr)}}'+
      '.ha-out button{display:flex;align-items:center;gap:9px;width:100%;text-align:left;cursor:pointer;font-family:inherit;'+
        'background:#fff;border:1px solid #e4ebf5;border-radius:13px;padding:11px 12px}'+
      '.ha-out button:active{transform:scale(.98)}'+
      '.ha-out .oi{flex:none;width:32px;height:32px;border-radius:10px;display:grid;place-items:center;background:#eef4ff;color:#0a4da6}'+
      '.ha-out .oi svg{width:17px;height:17px}'+
      '.ha-out b{font-size:13px;font-weight:800;color:#0a2540;line-height:1.25}'+
      '.ha-app-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}'+
      '@media(min-width:720px){.ha-app-grid{grid-template-columns:repeat(3,1fr)}}'+
      '.ha-app-card{display:flex;flex-direction:column;align-items:flex-start;gap:10px;'+
        'background:#fff;border:1px solid #e4ebf5;border-radius:16px;padding:16px 14px;'+
        'cursor:pointer;font-family:inherit;text-align:left;width:100%;'+
        'box-shadow:0 4px 14px rgba(0,30,80,.05);transition:.15s}'+
      '.ha-app-card:active{transform:scale(.98)}'+
      '.ha-app-card .hac-ic{width:44px;height:44px;border-radius:13px;display:grid;place-items:center;'+
        'background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff;flex:none}'+
      '.ha-app-card .hac-ic svg{width:22px;height:22px}'+
      '.ha-app-card b{font-size:14.5px;font-weight:800;color:#0a2540;line-height:1.25}';
    (document.head||document.documentElement).appendChild(st);
  }
  var _HA_ICO_APP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  /* ==========================================================================
     v499 (pedido) — A HOME DO APP SEPARADO
     "nos apps separados nao mostre os cards e campos de consulta — mostre
      os cards pra acessar os outros apps"

     Nos apps sem consulta (Loja · Vendas · Leads · Rede) o CSS do
     00-edicoes esconde a busca de placa, a barrinha de abas, o histórico e
     a grade de atalhos — e ESTE painel entra no lugar, DENTRO da própria
     #telaHome. Abrir o app já cai aqui, e o botão de início sempre volta
     pra cá. Embaixo, os outros apps: um toque troca de app (edicaoTrocar).
     ========================================================================= */
  function _haOutrosHtml(atual){
    /* ⚠️ v502 — QUEM TROCA DE APP AGORA É A FAIXA (05g), que fica acima da
       home E dentro do menu. Repetir aqui os mesmos seis cards deixava a
       home de cada app com DOIS trocadores, um em cima do outro. O bloco
       continua inteiro: desligue a faixa (MEV_FAIXA=false no 00-edicoes) e
       ele volta a aparecer sozinho — o caminho de volta nunca some. */
    try{ if(typeof window.edFaixaVisivel==='function' && window.edFaixaVisivel()) return ''; }catch(_){}
    /* 🔴 v918 — EDIÇÃO VENDIDA SOZINHA NÃO FALA DAS OUTRAS.
       (PROJETO "MEV Consultas sem links para outros aplicativos", 06/09)
       Na prática o MEV Consultas já saía limpo daqui: `edAppsVitrine()`
       devolve lista VAZIA na edição isolada desde a v879, e sem cards o
       `return` lá embaixo já era ''. Esta linha existe pra dizer a REGRA em
       vez de depender do efeito colateral de uma lista vazia — se um dia a
       vitrine voltar a ter itens, a edição isolada continua sem bloco. */
    try{ if(typeof window.edIsolada==='function' && window.edIsolada()) return ''; }catch(_){}
    /* v831: a VITRINE usa a lista filtrada. Com a oferta de módulos
       desligada sobra só o MEV Completo — o caminho de volta de quem entrou
       por um link ?app=. Ver o interruptor no 00-edicoes. */
    var apps=[]; try{ apps=(typeof window.edAppsVitrine==='function')?window.edAppsVitrine()
                          :((typeof window.edApps==='function')?window.edApps():[]); }catch(_){ apps=[]; }
    var out=apps.filter(function(a){ return a.ok && a.id!==atual; }).map(function(a){
      return '<button type="button" data-haout="'+a.id+'">'+
        '<span class="oi">'+(_HA_ICO_FAM[a.id]||_HA_ICO_APP)+'</span><b>'+esc(a.nome)+'</b></button>';
    }).join('');
    /* v831: com um card só, "Outros apps MEV" viraria um plural mentiroso */
    var titulo=(apps.length>1)?'Outros apps MEV':'Ir para o app completo';
    return out?('<div class="ha-sec">'+titulo+'</div><div class="ha-out">'+out+'</div>'):'';
  }
  var _HA_ICO_FAM={
    consultas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M8 11h6"/></svg>',
    avalia:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
    loja:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><rect x="9" y="13" width="6" height="7"/></svg>',
    vendas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14"/><path d="M6 17V9.5L7.8 5h8.4L18 9.5V17"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>',
    leads:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    rede:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    completo:_HA_ICO_APP
  };
  /* monta (ou repinta) o painel dentro da home. Chamado pelo pintor da home
     — o mesmo lugar que monta a grade de atalhos. */
  function haHomePainelMontar(){
    try{
      var info=(typeof window.edicaoInfo==='function')?window.edicaoInfo():null;
      var th=$('telaHome'); if(!th) return;
      var box=$('homeAppPainel');
      /* MEV Completo: nada disso existe */
      if(!info){ if(box) box.style.display='none'; return; }
      _haCss();
      /* App SEM consulta (Loja·Vendas·Leads·Rede): o painel É a home e vai
         no TOPO, no lugar da busca de placa.
         App COM consulta (Consultas·Avalia): a busca continua sendo a home
         — os cards dos outros apps entram no FIM dela (pedido: "adicione
         os cards para os outros apps"). */
      var semConsulta=true;
      try{ semConsulta=(typeof window.edicaoPermite==='function') && !window.edicaoPermite('buscaplaca'); }catch(_){ semConsulta=false; }
      if(!box){
        box=document.createElement('div'); box.id='homeAppPainel';
        if(semConsulta) th.insertBefore(box, th.firstChild); else th.appendChild(box);
      }
      box.style.display='';
      box.className=semConsulta?'':'so-outros';
      var cards=semConsulta?haAppCards().map(function(a){
        return '<button type="button" class="ha-app-card" data-haapp="'+a+'">'+
          '<span class="hac-ic">'+_haIcone(a)+'</span><b>'+esc(_haNome(a))+'</b></button>';
      }).join(''):'';
      box.innerHTML=
        (semConsulta?
          ('<div class="ha-tit"><span class="hi">'+_HA_ICO_APP+'</span>'+
            '<span><b>'+esc(info.nome)+'</b><small>'+esc(info.sub)+'</small></span></div>'+
           '<div class="ha-app-grid">'+cards+'</div>'):'')+
        _haOutrosHtml(info.id);
      Array.prototype.forEach.call(box.querySelectorAll('[data-haapp]'),function(b){
        b.onclick=function(){ try{ drawerIr(b.getAttribute('data-haapp')); }catch(_){} };
      });
      Array.prototype.forEach.call(box.querySelectorAll('[data-haout]'),function(b){
        b.onclick=function(){ try{ window.edicaoTrocar(b.getAttribute('data-haout')); }
                              catch(_){ location.href='/app.html?app='+b.getAttribute('data-haout'); } };
      });
    }catch(_){}
  }
  function telaHomeApp(){
    var info=null; try{ info=(typeof window.edicaoInfo==='function')?window.edicaoInfo():null; }catch(_){}
    if(!info){ voltarHome(); return; }        /* completo: a inicial é a de sempre */
    _haCss();
    var cards=haAppCards().map(function(a){
      return '<button type="button" class="ha-app-card" data-haapp="'+a+'">'+
        '<span class="hac-ic">'+_haIcone(a)+'</span><b>'+esc(_haNome(a))+'</b></button>';
    }).join('');
    irTela(panelHead(_HA_ICO_APP,'blue',info.nome,info.sub)+
      '<div class="ha-app-grid">'+cards+'</div>','home');
    Array.prototype.forEach.call(document.querySelectorAll('[data-haapp]'),function(b){
      b.onclick=function(){ try{ drawerIr(b.getAttribute('data-haapp')); }catch(_){} };
    });
  }
  /* v497 — O QUE ABRE QUANDO O APP ENTRA (o entrar() do 01-nucleo chama).
     Quem decide é o campo `inicial` da edição: 'cards' → o painel · uma
     ação → abre direto naquela página · null → a inicial de sempre.
     Uma vez por carregamento: quem voltar pra home da placa depois fica
     lá, sem o app teimar em trocar de tela. */
  var _haAbriuJa=false;
  function edAbrirInicialDoApp(){
    try{
      if(_haAbriuJa) return;
      var alvo=(typeof window.edicaoInicial==='function')?window.edicaoInicial():null;
      if(!alvo) return;
      /* deep link manda mais: clonar (v492) e link de avaliação (?a=) */
      if(/[?&](clonar|a)=/.test(location.search||'')) return;
      _haAbriuJa=true;
      setTimeout(function(){
        try{ if(alvo==='cards') telaHomeApp(); else drawerIr(alvo); }catch(_){}
      }, 80);
    }catch(_){}
  }

/* ╔═══ src/app/05g-faixa-como-trabalhar.js ═══════════════════════════════ */
  /* ==========================================================================
     05g — A FAIXA "COMO VOCÊ QUER TRABALHAR HOJE" (v502)

     PEDIDO (Angelo, 15/08): "onde eu poderia colocar cards pro lojista
     selecionar o que quer trabalhar (MEV Consultas, MEV Avalia, MEV
     Estoque, MEV Vendas, MEV CRM, MEV Rede) — barra superior? fab? card na
     página? no menu? o que acha" → combinado: FAIXA NA HOME + ITEM NO MENU.
     Nada na barra superior e NADA no FAB (lá já moram voltar, +, início,
     menu e chat — FAB é AÇÃO, isto aqui é CONTEXTO).

     DUAS CASAS, UM SÓ DESENHO (a mesma função monta as duas):
       · #mevFaixaApps — na home, dentro do #scApp, LOGO ACIMA do #telaHome.
         Fica FORA do #telaHome de propósito: no computador o #telaHome é
         grid/flex (menu de consultas na coluna 1), e um filho a mais ali
         viraria coluna. Fora dele, a faixa é uma linha cheia e ponto.
       · #mevFaixaMenu — no menu lateral, ENTRE o .mdr-top e a .mdr-nav.
         Também fora da .mdr-nav de propósito: lá o `.mdr-nav button` manda
         width:100% e min-height:54px em TODO botão, e as pílulas viravam
         barras. Fora, herdam zero.

     O QUE ELA NÃO É: não é vitrine de "Instalar". É o que a v500 combinou —
     uma linha dizendo o que a pessoa quer VER na tela. Mesma conta, mesmo
     preço, mesmo login. Por isso a pílula "Tudo" (o MEV Completo) vem
     PRIMEIRO e nasce pintada: é o estado de hoje e é o caminho de volta.

     DE ONDE VÊM OS NOMES: do edApps() (00-edicoes.js), campo `curto`.
     Renomeou um app lá? Renomeou aqui. Os ÍCONES são os mesmos do painel
     "Outros apps" (_HA_ICO_FAM, 05f) — um desenho por app, num lugar só.

     ⛳ PRA DESLIGAR: `var MEV_FAIXA=false` no alto do 00-edicoes.js.
     ⚠️ As pílulas usam data-edfx, NUNCA data-acao: a rota do deslize
     (18b/18d) e o CSS das edições varrem `button[data-acao]`, e uma pílula
     com data-acao entraria na rota do deslize sem ser página nenhuma.
     ========================================================================= */
  function _fxCss(){
    if($('mevFaixaCss')) return;
    var st=document.createElement('style'); st.id='mevFaixaCss';
    st.textContent=
      /* ---- a faixa da HOME ---- */
      '#mevFaixaApps{margin:0 auto 12px;max-width:1080px}'+
      /* some junto com a home: página aberta e modo lado-a-lado (no
         md-veiculo o #scApp vira flex e a faixa viraria coluna) */
      'body.tela-interna #mevFaixaApps{display:none !important}'+
      'body.md-veiculo #mevFaixaApps{display:none !important}'+
      '@media(min-width:1100px){body.app-on:not(.tela-interna) #mevFaixaApps{max-width:1032px}}'+
      /* ---- a faixa do MENU ---- */
      '#mevFaixaMenu{flex:none;padding:2px 13px 10px}'+
      '#mevFaixaMenu .fx-chips{flex-wrap:wrap;overflow:visible;padding-bottom:0}'+
      '#mevFaixaMenu .fx-chip{font-size:12.5px;padding:7px 12px 7px 9px}'+
      '#mevFaixaMenu .fx-tit{margin-bottom:7px}'+
      /* ---- o desenho, um só ---- */
      '.fx-tit{font-size:11px;font-weight:900;letter-spacing:.6px;text-transform:uppercase;'+
        'color:#94a3b8;margin:0 3px 8px}'+
      '.fx-chips{display:flex;gap:8px;overflow-x:auto;padding:2px 2px 6px;'+
        '-webkit-overflow-scrolling:touch;scrollbar-width:none;scroll-snap-type:x proximity}'+
      '.fx-chips::-webkit-scrollbar{display:none}'+
      '.fx-chip{flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;cursor:pointer;'+
        'font-family:inherit;background:#fff;border:1.5px solid #e4ebf5;border-radius:999px;'+
        'padding:8px 14px 8px 10px;font-size:13px;font-weight:800;color:#0a2540;'+
        'white-space:nowrap;scroll-snap-align:center;min-height:0;width:auto;'+
        'text-align:left;line-height:1.1;transition:.15s}'+
      '.fx-chip .fx-ic{flex:none;width:18px;height:18px;display:grid;place-items:center;color:#0a4da6}'+
      '.fx-chip .fx-ic svg{width:18px;height:18px;color:inherit}'+
      '.fx-chip.on{background:linear-gradient(135deg,#0a4da6,#1769d3);border-color:transparent;'+
        'color:#fff;box-shadow:0 6px 16px rgba(10,77,166,.24)}'+
      '.fx-chip.on .fx-ic{color:#fff}'+
      '.fx-chip:active{transform:scale(.97)}';
    (document.head||document.documentElement).appendChild(st);
  }

  /* a lista, na ordem que o Angelo ditou, já com nome curto e ícone */
  function fxLista(){
    var apps=[]; try{ apps=(typeof window.edApps==='function')?window.edApps():[]; }catch(_){ apps=[]; }
    var porId={}; apps.forEach(function(a){ porId[a.id]=a; });
    var ordem=[]; try{ ordem=(typeof window.edFaixaOrdem==='function')?window.edFaixaOrdem():[]; }catch(_){ ordem=[]; }
    return ordem.map(function(id){ return porId[id]; }).filter(function(a){ return a && a.ok; });
  }
  function _fxChipsHtml(atual){
    return fxLista().map(function(a){
      var nm=a.curto||String(a.nome||'').replace(/^MEV\s+/,'');
      return '<button type="button" class="fx-chip'+(a.id===atual?' on':'')+'" data-edfx="'+a.id+'"'+
        ' aria-pressed="'+(a.id===atual?'true':'false')+'">'+
        '<span class="fx-ic">'+((typeof _HA_ICO_FAM!=='undefined'&&_HA_ICO_FAM[a.id])||'')+'</span>'+
        '<span class="fx-nm">'+esc(nm)+'</span></button>';
    }).join('');
  }
  function _fxLigar(box){
    Array.prototype.forEach.call(box.querySelectorAll('[data-edfx]'),function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-edfx');
        var atual='completo';
        try{ atual=(typeof window.edicaoAtual==='function')?window.edicaoAtual():'completo'; }catch(_){}
        /* já estou nele: nada de recarregar a página à toa */
        if(id===atual){ try{ drawerFechar(); }catch(_){} return; }
        try{ window.edicaoTrocar(id); }
        catch(_){ location.href='/app.html?app='+id; }
      };
    });
  }
  /* monta (ou repinta) as DUAS faixas. Idempotente: pode chamar à vontade —
     o pintor da home chama a cada repintura e a abertura do menu também. */
  function fxFaixaMontar(){
    try{
      var lig=true;
      try{ lig=(typeof window.edFaixaVisivel==='function')?window.edFaixaVisivel():true; }catch(_){}
      var atual='completo';
      try{ atual=(typeof window.edicaoAtual==='function')?window.edicaoAtual():'completo'; }catch(_){}
      var html=lig?('<div class="fx-tit">Como você quer trabalhar hoje</div>'+
                    '<div class="fx-chips">'+_fxChipsHtml(atual)+'</div>'):'';
      if(lig) _fxCss();

      /* 1. a faixa da HOME — dentro do #scApp, logo acima do #telaHome */
      var sc=$('scApp');
      if(sc){
        var box=$('mevFaixaApps');
        if(!box && lig){
          box=document.createElement('div'); box.id='mevFaixaApps';
          var th=$('telaHome');
          if(th && th.parentNode===sc) sc.insertBefore(box,th); else sc.insertBefore(box,sc.firstChild);
        }
        if(box){
          /* regra da casa: escondo, não removo do DOM */
          box.style.display=lig?'':'none';
          if(lig){ box.innerHTML=html; _fxLigar(box); }
        }
      }

      /* 2. a faixa do MENU — entre o .mdr-top e a .mdr-nav */
      var dr=$('mevDrawer');
      if(dr){
        var bm=$('mevFaixaMenu');
        if(!bm && lig){
          bm=document.createElement('div'); bm.id='mevFaixaMenu';
          var nav=dr.querySelector('.mdr-nav');
          if(nav) dr.insertBefore(bm,nav); else dr.appendChild(bm);
        }
        if(bm){
          bm.style.display=lig?'':'none';
          if(lig){ bm.innerHTML=html; _fxLigar(bm); }
        }
      }
    }catch(_){}
  }

/* ╔═══ src/app/05h-avaliex-parser.js ═════════════════════════════════════ */
/* Parser compartilhado, extraído sem mudar o mapeamento do importador.
   Entrada: texto posicionado. Não baixa PDF, não executa IA, não importa clientes. */
var MEV_AVALIEX_PARSER=(function(){
  'use strict';
  var AVX_GAP_CELULA=24;   /* vão horizontal que separa células na mesma linha */
  var AVX_TOL_X=14;        /* o valor fica na linha de baixo, com x parecido */

  /* rótulos que o parser LÊ. CLIENTE e TELEFONE não estão aqui DE PROPÓSITO
     (item 6-b): não é ler-e-descartar, é NÃO EXTRAIR — o que nunca foi lido
     não vaza em log, rascunho nem tela. A v691 chegou a incluí-los a pedido;
     a v708 tirou de novo, também a pedido ("nao puxe os dados do cliente do
     avaliex"). O vendedor do carro entra DIGITADO, no card "Mandar pro
     vendedor" (v694/v702) — dado que o Angelo digita é dele. */
  var AVX_ROTULOS={
    'QUILOMETRAGEM':'km', 'RESPONSÁVEL':'quem', 'RESPONSAVEL':'quem',
    'DATA':'data', 'FIPE REFERÊNCIA':'fipe_ref', 'FIPE REFERENCIA':'fipe_ref',
    'CÓDIGO FIPE':'codigo_fipe', 'CODIGO FIPE':'codigo_fipe', 'FIPE':'fipe',
    'AVALIAÇÃO LOJA':'valor_loja', 'AVALIACAO LOJA':'valor_loja',
    'GASTOS PREVISTOS':'gastos', 'ORIGEM':'origem'
  };

  function avxLinhas(pecas){
    /* agrupa por y arredondado (o PDF entrega x,y de cada pedaço) e, dentro
       da linha, corta em CÉLULAS quando o vão passa de AVX_GAP_CELULA. */
    var porY={};
    (pecas||[]).forEach(function(p){
      if(!p || !String(p.s||'').trim()) return;
      var y=Math.round(Number(p.y)||0);
      (porY[y]=porY[y]||[]).push(p);
    });
    var ys=Object.keys(porY).map(Number).sort(function(a,b){ return b-a; }); /* PDF: y cresce pra cima */
    return ys.map(function(y){
      var ps=porY[y].slice().sort(function(a,b){ return a.x-b.x; });
      var cels=[], atual=null;
      ps.forEach(function(p){
        if(atual && (p.x-atual.fimX)<=AVX_GAP_CELULA){
          atual.s+=(p.x-atual.fimX>1?' ':'')+String(p.s);
          atual.fimX=p.x+(Number(p.w)||String(p.s).length*5);
        }else{
          if(atual) cels.push(atual);
          atual={ x:p.x, y:y, s:String(p.s), fimX:p.x+(Number(p.w)||String(p.s).length*5) };
        }
      });
      if(atual) cels.push(atual);
      cels.forEach(function(c){ c.s=c.s.replace(/\s+/g,' ').trim(); });
      return { y:y, cels:cels };
    });
  }

  function avxSoNum(s){ return String(s==null?'':s).replace(/\D/g,''); }
  function avxDinheiro(s){
    var m=String(s||'').replace(/[^\d,\.]/g,'');
    if(!m) return 0;
    m=m.replace(/\.(?=\d{3}(\D|$))/g,'').replace(',','.');
    var n=Math.round(parseFloat(m));
    return isFinite(n)?n:0;
  }
  function avxSimNao(s){
    var t=String(s||'').trim().toLowerCase();
    if(t==='sim') return 'Sim';
    if(t==='não'||t==='nao') return 'Não';
    return '';
  }

  function avxCampos(pecas, nomeArquivo){
    var linhas=avxLinhas(pecas);
    var o={ placa:'', marca:'', modelo:'', ano:'', ano_modelo:'', combustivel:'',
            cor:'', km:'', quem:'', data:'', fipe_ref:'', codigo_fipe:'',
            fipe:0, valor_loja:0, gastos:0, ipva:'', multas:'', alienado:'',
            checklist:'', opcionais:'', obs:'', origem:'', reconhecido:false };
    var textoTodo=linhas.map(function(l){ return l.cels.map(function(c){ return c.s; }).join(' '); }).join('\n');

    /* ---- reconhecer que é um laudo do Avaliex (item 9-8: PDF errado avisa,
       não importa lixo). O laudo tem os rótulos da tabela; uma nota fiscal
       não tem QUILOMETRAGEM + FIPE + AVALIAÇÃO LOJA juntos. */
    var acertos=0, achou=[];
    Object.keys(AVX_ROTULOS).forEach(function(r){
      if(textoTodo.toUpperCase().indexOf(r)>=0){ acertos++; achou.push(r); }
    });
    o.reconhecido = acertos>=4;
    /* v683: o diagnóstico viaja junto — é ele que a tela de falha mostra,
       pra falha em campo virar conserto em vez de mistério. */
    o._diag={ acertos:acertos, achou:achou };
    if(!o.reconhecido) return o;

    /* ---- ARMADILHA 1: a placa, por regex do texto inteiro + conferência ---- */
    var mPl=textoTodo.toUpperCase().match(/\b[A-Z]{3}\d[A-Z0-9]\d{2}\b/);
    var plTexto=mPl?mPl[0]:'';
    var plArq=(String(nomeArquivo||'').toUpperCase().match(/[A-Z]{3}\d[A-Z0-9]\d{2}/)||[])[0]||'';
    var mTit=textoTodo.toUpperCase().match(/AVALIA[ÇC][AÃ]O\s+([A-Z]{3}\d[A-Z0-9]\d{2})/);
    var plTit=mTit?mTit[1]:'';
    /* três fontes: as que EXISTEM têm que concordar (régua da v653). O nome
       do arquivo pode não ter placa (WhatsApp renomeia) — aí valem duas. */
    var fontes=[plTexto,plArq,plTit].filter(Boolean);
    if(fontes.length && fontes.every(function(p){ return p===fontes[0]; })) o.placa=fontes[0];

    /* ---- rótulo → valor, por POSIÇÃO (a regra que funciona) ---- */
    for(var i=0;i<linhas.length;i++){
      var L=linhas[i], Lbaixo=linhas[i+1];
      L.cels.forEach(function(c){
        var rot=c.s.toUpperCase().replace(/\s*:\s*$/,'').trim();
        var chave=AVX_ROTULOS[rot];
        if(!chave || !Lbaixo) return;
        var val=null;
        Lbaixo.cels.forEach(function(v){ if(Math.abs(v.x-c.x)<=AVX_TOL_X && val===null) val=v.s; });
        if(val===null) return;
        if(chave==='km'){ o.km=avxSoNum(val); }
        else if(chave==='fipe'){ o.fipe=avxDinheiro(val); }
        else if(chave==='valor_loja'){ o.valor_loja=avxDinheiro(val); }
        else if(chave==='gastos'){ o.gastos=avxDinheiro(val); }
        else if(!o[chave]) o[chave]=val;
      });
    }
    /* ⚠️ "FIPE" é prefixo de "FIPE REFERÊNCIA": o pareamento por célula acima
       não confunde (são células distintas), mas se o valor da FIPE vier vazio
       e a referência preenchida com dinheiro, é sinal de laudo diferente —
       deixa como está: vazio destacado é melhor que chutado (regra v450). */

    /* ---- ARMADILHA 3: o título do veículo, juntando linhas até a do ano ---- */
    /* o vocabulário de combustível que os laudos usam. ⚠️ Na dúvida a
       resposta é "não é combustível" — errar pro lado da COR deixa o campo
       combustível vazio (visível, corrigível), e errar pro outro lado escreve
       uma cor no lugar do combustível, que foi o defeito. */
    function _avxEhCombustivel(x){
      var t=String(x||'').toLowerCase().replace(/\s+/g,' ').trim();
      if(!t) return false;
      return /^(flex|total ?flex|gasolina|[aá]lcool|etanol|diesel|h[ií]brido|el[eé]trico|gnv|g[aá]s|gasolina ?\/ ?etanol|[aá]lcool ?\/ ?gasolina|bi-?combust[ií]vel)$/.test(t);
    }
    var reAno=/(\d{4})\s*\/\s*(\d{4})/;
    for(var j=0;j<linhas.length;j++){
      var txt=linhas[j].cels.map(function(c){ return c.s; }).join(' ');
      var mA=txt.match(reAno);
      if(!mA) continue;
      /* achou a linha do ano: o título é o que veio acima, juntado, parando
         nos títulos decorativos (letra solta) e nos rótulos. */
      o.ano=mA[1]; o.ano_modelo=mA[2];
      /* a linha do ano ainda traz "· combustível · cor": corta por "·" cru
         (o separador cola nos vizinhos) e limpa as pontas. */
      var resto=txt.slice(txt.indexOf(mA[0])+mA[0].length);
      var pedacos=resto.split('·').map(function(x){ return x.trim(); }).filter(Boolean);
      /* ===== 🔴 v1057 — ERA PELA POSIÇÃO, E A POSIÇÃO MENTIU ==============
         Aqui se assumia que o primeiro pedaço depois do ano é o COMBUSTÍVEL e
         o segundo é a COR. Num laudo real (o HB20 do Angelo) veio só UM
         pedaço — a cor — e ele foi gravado como combustível. A página do
         lojista passou a mostrar "COMBUSTÍVEL: PRATA".
         🔴 Agora cada pedaço é CLASSIFICADO, não contado: combustível é um
         vocabulário pequeno e conhecido; o que não está nele é cor. Assim
         funciona com um pedaço só, com os dois, e até na ordem trocada. */
      pedacos.forEach(function(x){
        if(_avxEhCombustivel(x)){ if(!o.combustivel) o.combustivel=x; }
        else if(!o.cor) o.cor=x;
      });
      /* v684 (medido no laudo real IXH4F10): entre a linha do ano e o nome
         do carro moram a PLACA e a tarja "PLACA" da coluna da direita — o
         laço antigo PARAVA nelas e o nome saía vazio ("5p" sozinho não vira
         marca+modelo). Agora essas linhas são PULADAS (continue), e só os
         limites de verdade param: rótulo da tabela, "LAUDO", o cabeçalho. */
      var nome=[];
      for(var k=j-1;k>=0 && k>=j-4;k--){
        var t2=linhas[k].cels.map(function(c){ return c.s; }).join(' ');
        if(Object.keys(AVX_ROTULOS).some(function(r){ return t2.toUpperCase().indexOf(r)>=0; })) break;
        if(/\bLAUDO\b/i.test(t2)) break;
        if(/GERADO EM|AVALIEX/i.test(t2.replace(/\s+/g,' '))) break;
        var t2c=t2.replace(/\s+/g,'').toUpperCase();
        if(/^[A-Z]{3}\d[A-Z0-9]\d{2}$/.test(t2c)) continue;     /* a própria placa */
        if(/^PLACA$/.test(t2c)) continue;                       /* a tarja dela */
        if(/^AVALIADO$/.test(t2c)) continue;                    /* tarja do topo */
        if(/^[A-Z]( [A-Z]){3,}/.test(t2)) break;                /* outro título decorativo */
        nome.unshift(t2);
      }
      var nomeTodo=nome.join(' ').replace(/\s+/g,' ').trim();
      if(nomeTodo){
        /* "VW - VolksWagen Saveiro ..." → marca = 1º pedaço, modelo = resto */
        var mNm=nomeTodo.match(/^([^-]+)-\s*(.+)$/);
        if(mNm){
          var m2=mNm[2].trim().match(/^(\S+)\s+(.+)$/);
          if(m2){ o.marca=m2[1]; o.modelo=m2[2]; }
          else { o.marca=mNm[1].trim(); o.modelo=mNm[2].trim(); }
        }else{
          var m3=nomeTodo.match(/^(\S+)\s+(.+)$/);
          if(m3){ o.marca=m3[1]; o.modelo=m3[2]; }
        }
      }
      break;
    }

    /* ---- IPVA pago / Multas / Alienado (valor na MESMA linha ou na de baixo) */
    linhas.forEach(function(L,ix){
      L.cels.forEach(function(c,ci){
        var t=c.s.toUpperCase();
        function valDe(alvoX){
          /* ⚠️ o valor fica à DIREITA do rótulo, ANTES do próximo rótulo.
             v684 (medido no laudo real): o teto de 160px caiu — na tabela
             de "Pendências financeiras" o Sim/Não encosta na borda direita
             da coluna, bem longe do rótulo. O que segura o vazamento numa
             linha de vários pares não é distância: é PARAR no próximo
             rótulo (IPVA/MULTAS/ALIENADO/EXERCÍCIO) antes de aceitar. */
          var v='', teto=Infinity;
          L.cels.forEach(function(x,xi){
            if(xi===ci || x.x<=alvoX) return;
            if(/^(IPVA|MULTAS|ALIENADO|EXERC)/i.test(x.s) && x.x<teto) teto=x.x;
          });
          L.cels.forEach(function(x,xi){
            if(xi===ci || x.x<=alvoX || x.x>=teto) return;
            if(avxSimNao(x.s) && !v) v=avxSimNao(x.s);
          });
          if(!v && linhas[ix+1]) linhas[ix+1].cels.forEach(function(x){ if(Math.abs(x.x-alvoX)<=AVX_TOL_X && avxSimNao(x.s) && !v) v=avxSimNao(x.s); });
          return v;
        }
        if(/^IPVA PAGO/.test(t)) o.ipva=o.ipva||valDe(c.x);
        else if(/^MULTAS$/.test(t)) o.multas=o.multas||valDe(c.x);
        else if(/^ALIENADO$/.test(t)) o.alienado=o.alienado||valDe(c.x);
      });
    });

    /* ---- checklist (quatro notas 0-5) → TEXTO, nunca custo (item 6-c) ---- */
    var notas=[];
    ['Mecânica','Pintura','Interior','Pneus'].forEach(function(n){
      var re=new RegExp(n.replace('â','[âa]').replace('é','[ée]')+'\\s*:?\\s*(\\d)\\s*\\/\\s*5','i');
      var mN=textoTodo.match(re);
      if(mN) notas.push(n+' '+mN[1]+'/5');
    });
    if(notas.length) o.checklist='Avaliex: '+notas.join(' · ');

    /* ---- observações e opcionais: o bloco de texto abaixo do rótulo ---- */
    function blocoDe(rotulo){
      for(var b=0;b<linhas.length;b++){
        var tB=linhas[b].cels.map(function(c){ return c.s; }).join(' ').toUpperCase();
        if(tB.indexOf(rotulo)!==0) continue;
        var saida=[];
        for(var c2=b+1;c2<linhas.length && c2<=b+6;c2++){
          var t3=linhas[c2].cels.map(function(x){ return x.s; }).join(' ');
          if(Object.keys(AVX_ROTULOS).some(function(r){ return t3.toUpperCase().indexOf(r)===0; })) break;
          if(/OBSERVA|OPCIONA|CHECKLIST|FOTOS/i.test(t3)) break;
          saida.push(t3);
        }
        return saida.join('\n').trim();
      }
      return '';
    }
    /* v684 (laudo real IXH4F10): a observação que IMPORTA mora na página 1,
       sob "Observação sobre o valor pago" — a da página 2 costuma ser só o
       carimbo "Sem observações registradas", que não é observação de gente. */
    var obsValor=blocoDe('OBSERVAÇÃO SOBRE O VALOR')||blocoDe('OBSERVACAO SOBRE O VALOR');
    var obsGeral=blocoDe('OBSERVAÇÕES')||blocoDe('OBSERVACOES');
    if(/^sem observa/i.test(obsGeral)) obsGeral='';
    o.obs=[obsValor,obsGeral].filter(Boolean).join('\n');
    o.opcionais=blocoDe('OPCIONAIS');
    if(/^nenhum opcional/i.test(o.opcionais)) o.opcionais='';
    return o;
  }
  return Object.freeze({campos:avxCampos,linhas:avxLinhas,soNum:avxSoNum,dinheiro:avxDinheiro,simNao:avxSimNao,rotulos:Object.freeze(AVX_ROTULOS)});
})();
if(typeof module==='object'&&module.exports) module.exports=MEV_AVALIEX_PARSER;

/* ╔═══ src/app/05h-espelho-cotacao.js ════════════════════════════════════ */
  /* ============================================================================
   * 05h — A COTAÇÃO VW DENTRO DO MENU (v556 · ampliado na v562)
   *
   * PEDIDO da v556 (Angelo, 18/08): *"consigo colocar um espelho da página
   * cotação dentro do menu do MEV Veículos?"* — a tela "Selecione o Carro"
   * (Polo, Virtus, T-Cross, Nivus, Tera, Taos, Jetta, Golf GTI, Saveiro…).
   *
   * PEDIDO da v562 (mesmo dia, vendo o resultado): *"a cotação tá como espelho,
   * eu queria que o usuário não visse assim como espelho"*. Ele mandou o print:
   * a barra do MEV Veículos em cima, e LOGO ABAIXO a barra da Cotação
   * ("‹ Voltar · Cotação · Menu ···"). Duas barras de cima, duas de baixo, e o
   * quadro da Cotação num cartão com borda no meio da página — a tela contava
   * pro vendedor que ali era outro aplicativo.
   *
   * ============================================================================
   * 🔴 É ESPELHO DE VERDADE, NÃO CÓPIA — E CONTINUA SENDO NA v562
   * A Cotação vive em OUTRO deploy (mevtools.netlify.app, o MEV Tools) e
   * continua sendo mantida lá. Aqui ela entra num <iframe>: toda mudança
   * feita na Cotação aparece neste espelho no mesmo instante, sem ninguém
   * copiar nada. Copiar as 22 páginas de cotação pra cá (~9 MB de HTML)
   * criaria dois lugares pra corrigir cada preço — foi a alternativa
   * DESCARTADA nas duas conversas.
   * O que a v562 mudou é só a APARÊNCIA: a Cotação passou a saber que está
   * dentro do MEV Veículos (`?embutido=1`) e esconde a própria moldura. Quem faz
   * isso do lado de lá é o `js/mev-embutido.js`, no repositório da Cotação.
   *
   * ============================================================================
   * 🔴🔴 SÓ A LOJA DO DONO DO MEV VÊ — E ISSO NÃO É FRESCURA
   * A Cotação tem CUSTO, MARGEM e ação de vendas da concessionária. O MEV
   * Placas é vendido para OUTROS lojistas: um item de menu visível pra todos
   * mostraria a régua de preço da concessionária pra concorrência.
   * A trava é DUPLA, de propósito:
   *   1. o item do menu nasce escondido e só aparece pra quem pode (o mesmo
   *      lugar e o mesmo motivo do #mdrAdminBox — decidido na ABERTURA do
   *      menu, porque no init o `meuId` ainda é nulo);
   *   2. a TELA recusa abrir de novo, por conta própria. Item escondido não
   *      é cadeado: quem souber o caminho (deep link, deslize, console)
   *      chegaria aqui. As duas travas juntas é o padrão do telaPainelAdmin.
   *
   * ⚠️ QUEM É "A LOJA DO DONO" SEM CRAVAR UUID NOVO: o app já conhece o
   * `ANGELO_ID` (o dono do MEV, usado pelo `_ehAdmin`). A loja é aquela cujo
   * `mp_loja.user_id` é ele — então a pergunta vira "a minha loja é a loja
   * dele?". Assim o vendedor DELE vê, e nenhum outro lojista vê,
   * sem inventar uma segunda constante que um dia sairia do lugar.
   *
   * ⚠️ CONSULTA QUE FALHA NÃO É "PODE VER". Na dúvida, ESCONDE — a mesma
   * regra do `_chatTem` (v529) e do `rowsOk` (v525). Errar pro lado de
   * mostrar preço de custo pro lojista errado não tem desfazer.
   *
   * ============================================================================
   * v562 — AS TRÊS COISAS QUE TIRAM A CARA DE ESPELHO
   *
   * 1. A MOLDURA DE LÁ SOME. A tela abre a Cotação com `?embutido=1`; o
   *    `mev-embutido.js` (do outro repositório) esconde a barra de cima e a de
   *    baixo DELA. Sobra uma barra só: a do MEV Veículos.
   *    ⚠️ Publicar SÓ este app não adianta — a metade de lá é que esconde as
   *    barras. Enquanto a Cotação não subir, o espelho volta a ter duas barras
   *    (feio, mas funcionando: nada quebra).
   *
   * 2. O QUADRO VIRA A PÁGINA. Saíram a borda, o canto arredondado e a altura
   *    fixa: o iframe passa a ocupar TUDO o que sobra da tela, medido no
   *    desenho de verdade (`cotAjustar`) e remedido quando o telefone gira.
   *    Altura fixa em `calc(100dvh - 210px)` errava sempre — o cabeçalho tem
   *    tamanhos diferentes no celular e no computador.
   *
   * 3. A SETINHA PASSA A MANDAR LÁ DENTRO. Escondida a barra da Cotação,
   *    escondeu-se junto o "Voltar" dela — e o vendedor ficaria preso na tela
   *    do Polo sem caminho de volta pra grade de carros. Agora a setinha do
   *    MEV Veículos PERGUNTA pra Cotação ("dá pra voltar aí dentro?") e só sai
   *    da tela quando a resposta é "não tenho mais pra onde".
   *    ⚠️ Vale pro DESLIZE também, de graça: o 18b não inventa caminho de
   *    volta, ele CLICA na própria setinha (`#btnBackFab`).
   *    ⚠️ Trava de segurança do gesto: se a Cotação não responder em 900ms
   *    (versão velha ainda publicada, rede caída), a setinha volta a fazer o
   *    que sempre fez — sair pra home. Gesto nenhum fica sem resposta.
   *
   * ============================================================================
   * ⚠️ O QUE SÓ FUNCIONA DEPOIS DE PUBLICAR
   * O iframe depende de DOIS cabeçalhos, e os dois são de servidor:
   *   · aqui, o `frame-src` da CSP (netlify.toml + _seguranca.js) precisa
   *     conhecer o mevtools.netlify.app — senão o PRÓPRIO MEV Veículos bloqueia;
   *   · lá, o `frame-ancestors` da Cotação precisa liberar o mevveiculos.com.br
   *     (entrou na v556, junto com a trava: antes ela não tinha nenhuma).
   * Enquanto os dois deploys não subirem, a tela abre e o quadro fica vazio.
   * v562: o aviso de socorro deixou de ficar sempre na tela e passou a ser a
   * EXCEÇÃO — ele só aparece se a Cotação não der sinal de vida em 6 segundos
   * (`cot-pronta`). Quando tudo funciona, a tela fica limpa, que é a regra do
   * app: o mínimo de informação na tela.
   *
   * ⚠️ O LOGIN DA COTAÇÃO É DELA. Ela é outro domínio: o navegador guarda o
   * login dela separado (e o iPhone separa ainda mais). Pode ser preciso
   * entrar uma vez dentro do espelho. Se incomodar no dia a dia, o plano B
   * está a uma linha: trocar a tela pelo `window.open(COTACAO_URL)`.
   * ========================================================================== */

  /* ⛳ v556 — uma linha some com o item do menu e com a tela.

     🔴 v872 (03/09/2026) — DESLIGADA, A PEDIDO DO ANGELO: "OCULTE A PAGINA
     COTACAO VW".
     O motivo é de vida real, não de código: em 31/08/2026 ele saiu da Santa
     Luzia Veículos. A Cotação é a régua de preço DA CONCESSIONÁRIA — mantê-la
     num menu que ele hoje usa como profissional independente não faz sentido,
     e a trava da v556 ("só a loja do dono do MEV vê") deixou de ser a pergunta
     certa: agora a resposta é "ninguém vê".

     ⚠️ NADA FOI APAGADO — é a regra da casa: esconder, não apagar. A tela, o
     espelho, o postMessage e a trava por conta continuam inteiros logo abaixo.
     ⛳ PRA VOLTAR: troque `false` por `true`. Uma linha, e o item volta pro
     menu exatamente pra quem a trava da v556 já deixava ver.

     ⚠️ E O BOTÃO CONTINUA NO app.html DE PROPÓSITO. Ele nasce
     `style="display:none"` e o `cotMenuSync` (abaixo) o mantém escondido
     porque o `cotPodeVer` agora sempre responde não. Tirar o botão do HTML
     quebraria a soma do mapa de edições (a régua da v496): lá o `cotacaovw`
     é INVENTÁRIO — "que itens existem no menu" —, não permissão. */
  var MENU_COTACAO_VW = false;

  /* A página "Selecione o Carro" do outro deploy (conferido em 18/08:
     cotacao/index.html existe lá). ⚠️ Endereço do PRODUTO, não da loja —
     não há nome de loja nenhum cravado aqui. */
  var COTACAO_URL = 'https://mevtools.netlify.app/cotacao/';

  /* v562 — o mesmo endereço, avisando que é pra entrar sem a moldura dele.
     ⚠️ A origem entra separada porque toda mensagem que chega de lá é
     conferida por ela: recado de outro site não manda nesta tela. */
  var COTACAO_ORIGEM = 'https://mevtools.netlify.app';
  var COTACAO_EMB    = COTACAO_URL + '?embutido=1';

  /* null = ainda não perguntei · true/false = resposta do banco.
     Fica guardado porque o menu abre muitas vezes por sessão e a resposta
     não muda enquanto o app está aberto. */
  var _cotPode = null;

  /* Responde "esta conta pode ver a Cotação?".
     🔴 Nunca devolve true por desencargo: erro de rede cai em false. */
  async function cotPodeVer(){
    if(!MENU_COTACAO_VW) return false;
    if(_cotPode !== null) return _cotPode;
    try{
      if(typeof meuId==='undefined' || !meuId) return false;   /* sem sessão, nem pergunta */
      if(typeof _ehAdmin==='function' && _ehAdmin()){ _cotPode=true; return true; }
      /* vendedor: a MINHA loja é a loja do dono do MEV? */
      var r=await supa.from('loja_membros').select('loja_id').eq('user_id',meuId).limit(1);
      if(r&&r.error) return false;
      var lj=((r&&r.data)||[])[0];
      if(!lj || !lj.loja_id){ _cotPode=false; return false; }
      var r2=await supa.from('loja').select('id').eq('id',lj.loja_id)
        .eq('user_id',(typeof ANGELO_ID!=='undefined')?ANGELO_ID:'').limit(1);
      if(r2&&r2.error) return false;
      _cotPode=(((r2&&r2.data)||[]).length>0);
      return _cotPode;
    }catch(_){ return false; }
  }

  /* O item do menu. Chamado na ABERTURA do drawer (08), como o Painel. */
  async function cotMenuSync(){
    try{
      var el=document.querySelector('#mevDrawer .mdr-nav [data-acao="cotacaovw"]');
      if(!el) return;
      var box=el.parentNode && el.parentNode.id==='mdrCotacaoBox' ? el.parentNode : el;
      var pode=await cotPodeVer();
      /* ⚠️ display INLINE, não classe: é assim que o item sai também da rota
         do DESLIZE (o `_menuOculto` do 18b lê style="display:none"). A mesma
         solução do Funil (v437) e do Chat (v526). */
      box.style.display = pode ? '' : 'none';
      try{ mdrSyncLeve(); }catch(_){}   /* v746: a contagem do grupo acompanha */
    }catch(_){}
  }

  /* ------------------------------------------------------------------------
     v562 — A CONVERSA COM O QUADRO
     São dois endereços diferentes: o app NÃO consegue mexer no que está dentro
     do iframe (o navegador proíbe, e ainda bem). O único canal é o recado —
     `postMessage`. Daqui saem pedidos ('voltar'); de lá voltam respostas
     ('cot-pronta', 'voltei').
     ------------------------------------------------------------------------ */

  var _cotAberta   = false;   /* a tela está no ar? (o ouvinte só vale nela) */
  var _cotViva     = false;   /* a Cotação já deu sinal de vida? */
  var _cotEsperaFn = null;    /* o que fazer quando a resposta do 'voltar' chegar */

  function _cotFrame(){ try{ return $('cotFrame'); }catch(_){ return null; } }

  function _cotFala(msg){
    var f=_cotFrame();
    try{ if(f && f.contentWindow) f.contentWindow.postMessage(msg, COTACAO_ORIGEM); }catch(_){}
  }

  /* Um ouvinte só, registrado uma vez na vida do app. Ele não faz nada
     enquanto a tela estiver fechada — e confere a origem SEMPRE. */
  (function _cotOuvir(){
    try{
      window.addEventListener('message', function(ev){
        /* ⚠️ a pergunta de verdade é "o quadro ainda está na tela?" — sair
           por outro caminho (menu, FAB de início) não passa pelo cotSair. */
        if(!_cotAberta || !_cotFrame()) return;
        if(!ev || ev.origin !== COTACAO_ORIGEM) return;
        var d=ev.data;
        if(!d || typeof d!=='object' || !d.mev) return;
        if(d.mev==='cot-pronta'){
          _cotViva=true;
          try{ var a=$('cotAviso'); if(a) a.style.display='none'; }catch(_){}
          try{ cotAjustar(); }catch(_){}
          return;
        }
        if(d.mev==='voltei'){
          var fn=_cotEsperaFn; _cotEsperaFn=null;
          if(typeof fn==='function') fn(!!d.fim);
        }
      });
    }catch(_){}
  })();

  /* A setinha (e o deslize, que clica nela). Pergunta primeiro; só sai da tela
     se a Cotação disser que não tem mais pra onde voltar.
     ⚠️ O relógio de 900ms é o que impede o vendedor de ficar preso: se a
     Cotação não responder (versão velha publicada, quadro vazio, rede fora),
     a setinha faz o de sempre. */
  function cotVoltar(){
    var respondeu=false;
    _cotEsperaFn=function(fim){
      respondeu=true;
      if(fim) cotSair();
    };
    _cotFala({ mev:'voltar' });
    setTimeout(function(){
      if(respondeu) return;
      _cotEsperaFn=null;
      cotSair();
    }, 900);
  }

  /* Sair da tela: o ouvinte volta a ser surdo ANTES de a home entrar.
     ⚠️ Sem isso, um recado atrasado da Cotação mexeria numa tela que já mudou. */
  function cotSair(){
    _cotAberta=false; _cotEsperaFn=null;
    try{ voltarHome(); }catch(_){}
  }

  /* A altura do quadro medida no desenho de verdade: o que sobra da janela
     abaixo de onde o iframe começa. Serve pro celular, pro computador, pro
     telefone deitado e pra quando o teclado abre e fecha. */
  function cotAjustar(){
    try{
      var f=_cotFrame(); if(!f) return;
      var topo=f.getBoundingClientRect().top;
      var h=Math.round(window.innerHeight - topo - 10);
      f.style.height=Math.max(360, h)+'px';
    }catch(_){}
  }
  try{
    window.addEventListener('resize', function(){ if(_cotAberta) cotAjustar(); });
    window.addEventListener('orientationchange', function(){ if(_cotAberta) setTimeout(cotAjustar, 250); });
  }catch(_){}

  /* O aviso de socorro. v562: nasce ESCONDIDO e só aparece se a Cotação não
     der sinal de vida — a tela limpa é o normal, o aviso é a exceção. */
  function _cotAviso(){
    return '<div class="doc-hint" id="cotAviso" style="margin-top:10px;display:none">'+
      'Quadro vazio? A Cotação só aparece aqui depois que os dois aplicativos '+
      'forem publicados. <button type="button" class="link" id="cotAbrirFora" '+
      'style="color:#0a4da6">Abrir em outra aba</button></div>';
  }

  var _COT_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';

  /* A tela. ⚠️ A trava de entrada é a SEGUNDA metade da dupla — o item
     escondido não impede deep link nem console. */
  async function telaCotacaoVW(){
    if(!MENU_COTACAO_VW) return;
    var pode=await cotPodeVer();
    if(!pode){ try{ toast('Esta página é da sua concessionária.'); }catch(_){} return; }
    try{ mevTabSet(''); }catch(_){}
    _cotAberta=true; _cotViva=false; _cotEsperaFn=null;
    irTela(panelHead(_COT_ICO,'blue','Cotação VW','Só a sua concessionária vê esta tela')+
      '<div class="cot-wrap" id="cotWrap">'+
        '<iframe id="cotFrame" class="cot-frame" src="'+esc(COTACAO_EMB)+'" '+
        'title="Cotação VW" allow="clipboard-write"></iframe>'+
      '</div>'+_cotAviso(),
      'home');
    try{ document.body.classList.remove('md-veiculo'); }catch(_){}
    /* 🔴 DEPOIS do irTela, nunca antes: o irTela reprograma a setinha
       (`voltarTab(voltarHome)`) e apagaria esta linha se ela viesse primeiro. */
    try{ voltarTab(cotVoltar); }catch(_){}
    cotAjustar();
    var b=$('cotAbrirFora');
    if(b) b.onclick=function(){
      try{ window.open(COTACAO_URL,'_blank','noopener'); }catch(_){ location.href=COTACAO_URL; }
    };
    /* o socorro entra em cena só se ninguém atender */
    setTimeout(function(){
      if(_cotViva || !_cotAberta) return;
      try{ var a=$('cotAviso'); if(a) a.style.display=''; }catch(_){}
    }, 6000);
  }

/* ╔═══ src/app/05i-importar-avaliex.js ═══════════════════════════════════ */
  /* ==========================================================================
     v678 — IMPORTAR AVALIAÇÃO DO AVALIEX (pelo PDF do laudo)
     PROJETO-2026-08-28-importar-avaliacao-do-avaliex — executado conforme
     escrito, com as quatro decisões do Angelo (28/08):
       · o CLIENTE do laudo NÃO entra (nem é lido) — item 6-b do projeto
         (a v691 chegou a revogar isso a pedido; a v708 RESTAUROU, também a
          pedido: "nao puxe os dados do cliente do avaliex". O vendedor do
          carro entra pelo card "Mandar pro vendedor" — DIGITADO, v694/v702);
       · placa que já tem avaliação: QUEM MEXEU NO CAMPO GANHA (regra v665);
       · o botão fica SÓ na página Avaliações;
       · sem API do Avaliex — o PDF resolve e não depende de ninguém.

     POR QUE PELO PDF E NÃO PELO LINK: o link do Avaliex é o próprio app
     deles, atrás de login (testado no projeto — toda rota exige Bearer).
     O PDF é texto de verdade (não imagem): pdf.js lê local, instantâneo,
     custo ZERO, nenhum token, nenhuma ida ao servidor.

     🔴 O QUE NUNCA ACONTECE AQUI:
       · consulta paga NÃO dispara sozinha (regra v585/v599): placa que nunca
         foi consultada abre com um veiculoAtual LEVE montado do laudo, e o
         botão "Consultar a placa agora" fica no dedo;
       · o valor "AVALIAÇÃO LOJA" entra em #avValor e em NENHUM outro campo
         de preço (a lição da v665 — nunca em preco_anuncio);
       · o checklist de notas (Mecânica 3/5...) NÃO vira custo — vira texto
         no rodapé das observações. Campo vazio é melhor que campo errado;
       · o PDF é lido em memória e descartado: não sobe, não vira arquivo.
     ========================================================================== */

  /* ---- as três armadilhas do laudo (medidas no laudo real, ver projeto) ----
     1. a PLACA fica ACIMA do rótulo (tarja do cabeçalho) → sai por regex do
        texto inteiro, conferida contra o nome do arquivo e o título;
     2. títulos com letter-spacing viram letra solta → NÃO se normaliza;
        pareia-se por POSIÇÃO e os títulos decorativos são ignorados;
     3. o nome do veículo quebra em duas linhas → junta até a linha do ano. */

  function avxCampos(pecas,nomeArquivo){ return MEV_AVALIEX_PARSER.campos(pecas,nomeArquivo); }
  var AVX_ROTULOS=MEV_AVALIEX_PARSER.rotulos;
  function avxDinheiro(s){ return MEV_AVALIEX_PARSER.dinheiro(s); }
  function avxSimNao(s){ return MEV_AVALIEX_PARSER.simNao(s); }
  function avxSoNum(s){ return MEV_AVALIEX_PARSER.soNum(s); }

  /* ⛳ v714 (pedido, 29/08: "AJUSTE PRA IMPORTACAO DO AVALIEX NAO TRAZER AS
     FOTOS, ACHO QUE CONSOME MUITA API DA IA")
     A verdade, dita antes de desligar: a extração NÃO gasta IA nem token —
     é o pdf.js rodando NO PRÓPRIO APARELHO lendo o arquivo. O custo real é
     outro: tempo de celular renderizando página por página e o upload das
     fotos pro armazenamento. Desligado a pedido, mostrando o caminho (v568):
     o MOTOR INTEIRO fica vivo (avxFotos, avxObjetoPraJpeg, as caixas de
     seleção da conferência, o avAddFotos no aplicar).
     PRA VOLTAR: AVX_TRAZ_FOTOS = true — e nada mais. */
  var AVX_TRAZ_FOTOS = false;
  /* ---- as fotos, pela lista de operadores (armadilhas do item 3) ---- */
  function avxFotos(pdf){
    var lib=window.pdfjsLib;
    if(!pdf || !lib) return Promise.resolve([]);
    var OPS=lib.OPS||{};
    var paginas=[]; for(var p=1;p<=pdf.numPages;p++) paginas.push(p);
    var fotos=[];
    function umaPagina(n){
      return pdf.getPage(n).then(function(pg){
        /* 🔴 v688 — AS FOTOS SÓ EXISTEM DEPOIS DE RENDERIZAR. O pdf.js só
           decodifica os objetos de imagem quando a página é DESENHADA; sem
           isso o objs.get espera os 4s do teto e devolve nulo — o laudo
           real do Angelo (6 fotos) veio "sem fotos legíveis". Renderiza num
           canvas descartável, pequeno (o tamanho do desenho não muda a
           resolução do OBJETO extraído), e só então colhe. */
        var render=Promise.resolve();
        try{
          var vp=pg.getViewport({scale:0.5});
          var cvR=document.createElement('canvas');
          cvR.width=Math.max(2,Math.ceil(vp.width)); cvR.height=Math.max(2,Math.ceil(vp.height));
          render=pg.render({canvasContext:cvR.getContext('2d'),viewport:vp}).promise['catch'](function(){});
        }catch(_){}
        return render.then(function(){ return pg.getOperatorList(); }).then(function(ops){
          var nomes=[];
          (ops.fnArray||[]).forEach(function(fn,i){
            if(fn===OPS.paintImageXObject){
              var nm=(ops.argsArray[i]||[])[0];
              if(nm && nomes.indexOf(nm)<0) nomes.push(nm);
            }
          });
          /* ⚠️ o objeto pode não estar pronto: forma com callback quando o
             get direto voltar vazio. E o NOME diz "img_p1_N" até na página 2
             — não se confia no nome pra nada. */
          return Promise.all(nomes.map(function(nm){
            return new Promise(function(res){
              var direto=null;
              try{ direto=pg.objs.get(nm); }catch(_){ direto=null; }
              if(direto) return res(direto);
              try{ pg.objs.get(nm, function(o){ res(o||null); }); }catch(_){ res(null); }
              setTimeout(function(){ res(null); }, 4000);
            });
          }));
        });
      });
    }
    var cadeia=Promise.resolve();
    paginas.forEach(function(n){
      cadeia=cadeia.then(function(){ return umaPagina(n).then(function(objs){
        objs.forEach(function(o){ if(o) fotos.push(o); });
      }); });
    });
    return cadeia.then(function(){
      /* cada objeto vira um Blob JPEG — ImageBitmap (3.11) ou data cru RGB */
      return Promise.all(fotos.map(function(o){ return avxObjetoPraJpeg(o); }))
        .then(function(bl){ return bl.filter(Boolean); });
    });
  }
  function avxObjetoPraJpeg(o){
    return new Promise(function(res){
      try{
        var cv=document.createElement('canvas'), cx;
        /* 🔴 v690 — A FORMA QUE O NAVEGADOR ENTREGA. O pdf.js 3.11 NO
           NAVEGADOR (onde existe OffscreenCanvas) devolve o objeto de
           imagem EMBRULHADO: { bitmap: ImageBitmap, width, height }.
           A sonda em Node usou o build legacy (sem OffscreenCanvas), que
           devolve { data, width, height } — por isso o conserto da v689
           passou no teste e as fotos SEGUIRAM não vindo no Chrome do
           Angelo: o embrulho caía fora dos dois ramos e virava nulo
           antes mesmo do piso. O ramo do embrulho vem PRIMEIRO. */
        if(o && o.bitmap && typeof o.width==='number'){                     /* navegador: {bitmap,width,height} */
          cv.width=o.width; cv.height=o.height;
          cx=cv.getContext('2d'); cx.drawImage(o.bitmap,0,0);
        }else if(o && typeof o.width==='number' && typeof o.close==='function'){ /* ImageBitmap direto */
          cv.width=o.width; cv.height=o.height;
          cx=cv.getContext('2d'); cx.drawImage(o,0,0);
        }else if(o && o.data && o.width && o.height){                       /* RGB cru */
          cv.width=o.width; cv.height=o.height;
          cx=cv.getContext('2d');
          var im=cx.createImageData(o.width,o.height), d=o.data, px=im.data;
          if(d.length===o.width*o.height*3){
            for(var i=0,j=0;i<d.length;i+=3,j+=4){ px[j]=d[i]; px[j+1]=d[i+1]; px[j+2]=d[i+2]; px[j+3]=255; }
          }else{ for(var k2=0;k2<Math.min(d.length,px.length);k2++) px[k2]=d[k2]; }
          cx.putImageData(im,0,0);
        }else return res(null);
        /* 🔴 v689 — O PISO QUE COMIA AS FOTOS POR 2 PIXELS. As miniaturas do
           laudo real têm 198px de largura — e o piso de 200×150 descartava
           TODAS as seis como "logo". Medido no PDF do Angelo: w=198.
           O piso cai pra 120×90: logo e ícone de verdade (≤100px) continuam
           fora, e nenhuma foto de carro passa fome por arredondamento. */
        if(cv.width<120 || cv.height<90) return res(null);   /* logo/ícone não é foto de carro */
        cv.toBlob(function(b){
          if(!b) return res(null);
          res(new File([b],'avaliex-'+Date.now()+'-'+Math.floor(Math.random()*1e4)+'.jpg',{type:'image/jpeg'}));
        },'image/jpeg',0.88);
      }catch(_){ res(null); }
    });
  }

  /* ---- ler o PDF (texto com posição + fotos) ---- */
  async function avxLerPdf(file){
    if(typeof _pdfjsLoad!=='function') throw new Error('leitor de PDF indisponível');
    var lib=await _pdfjsLoad();
    var buf=await file.arrayBuffer();
    var pdf=await lib.getDocument({data:buf}).promise;
    var pecas=[];
    for(var p=1;p<=pdf.numPages;p++){
      var pg=await pdf.getPage(p);
      var tc=await pg.getTextContent();
      (tc.items||[]).forEach(function(it){
        pecas.push({ s:it.str, x:(it.transform||[])[4]||0, y:((it.transform||[])[5]||0)-p*10000, w:it.width||0 });
        /* o -p*10000 mantém as páginas em ordem sem misturar linhas */
      });
    }
    var campos=avxCampos(pecas, file.name);
    var fotos=[];
    /* v714: o ⛳ AVX_TRAZ_FOTOS decide — desligado, nem renderiza página */
    if(AVX_TRAZ_FOTOS && campos.reconhecido){ try{ fotos=await avxFotos(pdf); }catch(_){ fotos=[]; } }
    var nPags=pdf.numPages;
    try{ pdf.destroy(); }catch(_){}
    return { campos:campos, fotos:fotos, paginas:nPags, pedacos:pecas.length };
  }

  /* ================= A TELA DE CONFERÊNCIA ================= */
  var _avxLido=null, _avxFotosSel=[];
  /* ==========================================================================
     🔴🔴 v1001 — O MESMO BOTÃO, DUAS ORIGENS (projeto de 14/09)
     --------------------------------------------------------------------------
     Pedido do Angelo: "verifica pra mim se consigo criar uma avaliação a
     partir desse link, com o mesmo botão do importar Avaliex, quero já
     importar as fotos também."

     ⚠️ POR QUE O SELETOR DE ARQUIVO NÃO ABRE MAIS DIRETO NO TOQUE.
     Até aqui `avxAbrir` chamava `.click()` no input de arquivo dentro do
     próprio gesto — obrigatório no iPhone, que bloqueia seletor aberto fora
     de gesto do usuário. Agora o botão tem DUAS origens válidas, então ele
     abre uma folha de escolha. O gesto síncrono continua existindo: ele só
     mudou de lugar — quem chama `.click()` é o toque em "Escolher PDF do
     Avaliex", que também é um gesto do usuário. Nada se perdeu no iPhone.
     ========================================================================== */
  function avxAbrir(){
    var velho=$('avxBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avxBg'; bg.className='cropmask';
    bg.innerHTML='<div class="cropbox avx-box">'+
      '<div class="avx-tit">Importar do Avaliex</div>'+
      '<div class="avx-sub">De onde vem esta avaliação?</div>'+
      '<div class="avx-origens">'+
        '<button type="button" class="avx-origem" id="avxOrigPdf">'+
          '<span class="avx-origem-ico" aria-hidden="true">'+_AVX_ICO_PDF+'</span>'+
          '<span class="avx-origem-txt"><b>Escolher PDF do Avaliex</b>'+
          '<i>O laudo que o próprio Avaliex gera</i></span></button>'+
        '<button type="button" class="avx-origem" id="avxOrigLink">'+
          '<span class="avx-origem-ico" aria-hidden="true">'+_AVX_ICO_LINK+'</span>'+
          '<span class="avx-origem-txt"><b>Colar link público de cotação</b>'+
          '<i>Traz também as fotos do veículo</i></span></button>'+
      '</div>'+
      '<div class="avx-acts"><button type="button" class="crop-c" id="avxEscFecha">Cancelar</button></div>'+
    '</div>';
    document.body.appendChild(bg);
    function fecha(){ try{ bg.parentNode.removeChild(bg); }catch(_){} }
    $('avxEscFecha').onclick=fecha;
    $('avxOrigPdf').onclick=function(){ fecha(); avxAbrirPdf(); };
    $('avxOrigLink').onclick=function(){ fecha(); avxAbrirLink(); };
    try{ $('avxOrigPdf').focus(); }catch(_){}
  }
  var _AVX_ICO_PDF='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>';
  var _AVX_ICO_LINK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
  function avxAbrirPdf(){
    /* seletor nativo DIRETO no toque (gesto síncrono — senão o iPhone
       bloqueia), com a proteção da v253: o input é recriado se sumir. */
    var inp=$('avxArquivo');
    if(!inp){
      inp=document.createElement('input');
      inp.type='file'; inp.accept='application/pdf'; inp.id='avxArquivo';
      inp.style.display='none';
      document.body.appendChild(inp);
    }
    inp.onchange=function(){
      var f=this.files && this.files[0]; this.value='';
      if(f) avxProcessar(f);
    };
    inp.click();
  }
  /* ===== v683 — A FALHA QUE FICAVA MUDA ====================================
     Relato do Angelo (28/08, no computador): "cliquei em importar, escolhi o
     pdf, apareceu lendo o laudo, mas nao abriu a avaliacao". O que havia:
     as duas falhas possíveis (PDF ilegível / laudo não reconhecido) eram um
     TOAST de 2,4 segundos — piscava por cima do "Lendo o laudo…" e sumia.
     Pra quem olha o arquivo, é como se nada tivesse acontecido.
     Agora falha abre uma CAIXA que fica, dizendo O QUE deu errado e o
     diagnóstico (quantos rótulos do laudo foram achados, quantas páginas,
     quanto texto) — com "Tentar outro PDF" no dedo. Falha visível vira
     conserto; falha que pisca vira mistério. */
  function avxFalha(titulo, corpo, diag){
    var velho=$('avxBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avxBg'; bg.className='cropmask';   /* v688: ver a nota da caixa invisível, acima do avxConferir */
    bg.innerHTML='<div class="cropbox avx-box">'+
      '<div class="avx-tit">'+esc(titulo)+'</div>'+
      '<div class="avx-sub">'+corpo+'</div>'+
      (diag?('<div class="avx-nota">'+esc(diag)+'</div>'):'')+
      '<div class="avx-acts">'+
        '<button type="button" class="crop-c" id="avxFecha">Fechar</button>'+
        '<button type="button" class="crop-ok" id="avxDeNovo">Tentar outro PDF</button>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    function fecha(){ try{ bg.parentNode.removeChild(bg); }catch(_){} }
    $('avxFecha').onclick=fecha;
    /* v1001: volta direto pro seletor de PDF — quem chegou aqui já escolheu
       a origem, e devolvê-lo à folha de escolha seria um passo a mais à toa. */
    $('avxDeNovo').onclick=function(){ fecha(); avxAbrirPdf(); };
  }
  async function avxProcessar(file){
    if(!/pdf$/i.test(String(file.type||''))&&!/\.pdf$/i.test(String(file.name||''))){
      toast('Escolha o PDF do laudo do Avaliex.'); return;
    }
    toast('Lendo o laudo…');
    var r;
    try{ r=await avxLerPdf(file); }
    catch(e){
      avxFalha('Não consegui ler este PDF',
        'O leitor de PDF não conseguiu abrir o arquivo. Se a internet caiu agora, tente de novo — o leitor é carregado na primeira vez.',
        'detalhe: '+String((e&&e.message)||e).slice(0,120));
      return;
    }
    if(!r.campos.reconhecido){
      var d=(r.campos._diag||{});
      var motivo = (r.pedacos===0)
        ? 'Este PDF não tem <b>texto</b> por dentro — é uma foto/escaneado. O importador lê o laudo que o próprio Avaliex gera (Exportar/Baixar PDF), não uma foto dele.'
        : 'Este PDF não parece o laudo do Avaliex — os rótulos da tabela do laudo não estão nele. Nada foi importado.';
      avxFalha('Não reconheci este PDF como laudo do Avaliex', motivo,
        'diagnóstico: '+(d.acertos||0)+' de '+Object.keys(AVX_ROTULOS).length+' rótulos achados'+
        ((d.achou&&d.achou.length)?(' ('+d.achou.join(', ')+')'):'')+
        ' · '+r.paginas+' página(s) · '+r.pedacos+' pedaço(s) de texto');
      return;
    }
    _avxLido=r; _avxFotosSel=r.fotos.map(function(){ return true; });
    avxConferir();
  }
  function avxCampoHtml(id,rot,valor){
    var vazio=!String(valor||'').trim();
    return '<div class="avx-campo'+(vazio?' vazio':'')+'"><label>'+esc(rot)+(vazio?' <i>não achei — confira</i>':'')+'</label>'+
      '<input id="'+id+'" class="avt-in" value="'+esc(valor||'')+'"></div>';
  }
  /* 🔴 v688 — A CAIXA QUE SEMPRE ABRIU INVISÍVEL ============================
     Desde a v678 estas caixas usavam a classe do RECORTADOR de fotos — que
     nasce display:none no CSS (o recorte a liga com .on por outro caminho)
     e cuja caixa interna nem existe no styles. A conferência abria,
     preenchida, POR TRÁS DO NADA: o Angelo via "Lendo o laudo…" e mais
     nada — três relatos até os sensores no navegador dele flagrarem a
     caixa viva com display:none e a placa dentro.
     A família visível de modal é .cropmask/.cropbox (a mesma do reauth).
     ⚠️ E A LIÇÃO PROS TESTES, na veia do _teste-comum: caixa no DOM não é
     caixa NA TELA — o .click() funciona até em elemento invisível. Agora o
     teste mede getComputedStyle e o retângulo de verdade. */
  function avxConferir(){
    var c=_avxLido.campos;
    var velho=$('avxBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avxBg'; bg.className='cropmask';   /* v688: ver a nota da caixa invisível, acima do avxConferir */
    var fotosHtml=_avxLido.fotos.length
      ? ('<div class="avx-fotos">'+_avxLido.fotos.map(function(f,i){
          return '<label class="avx-foto"><input type="checkbox" data-foto="'+i+'" checked>'+
            '<img data-fimg="'+i+'" alt="foto '+(i+1)+'"></label>';
        }).join('')+'</div>')
      /* v714: com o ⛳ desligado a nota fala a verdade nova — as fotos não
         vêm por escolha, não por defeito do laudo */
      : (AVX_TRAZ_FOTOS
          ? '<div class="avx-nota">O laudo veio sem fotos legíveis.</div>'
          : '<div class="avx-nota">As fotos do laudo não são trazidas — anexe as suas na aba Fotos da avaliação.</div>');
    bg.innerHTML='<div class="cropbox avx-box">'+
      '<div class="avx-tit">Conferir o laudo do Avaliex</div>'+
      '<div class="avx-sub">Ajuste o que quiser — nada entra sem você confirmar. '+
        'O nome e o telefone do cliente do laudo <b>não são importados</b>.</div>'+
      /* v692 — "adicione um campo pra aparecer o valor avaliado": o número
         do laudo em destaque, formatado, que acompanha AO VIVO o campo
         editável logo abaixo (uma fonte só: o input manda no destaque). */
      '<div class="avx-valor"><span>Valor avaliado no laudo</span><b id="avxValorBig">'+
        esc(c.valor_loja?('R$ '+Number(c.valor_loja).toLocaleString('pt-BR')):'—')+'</b></div>'+
      '<div class="avx-grid">'+
        avxCampoHtml('avxPlaca','Placa',c.placa)+
        avxCampoHtml('avxMarca','Marca',c.marca)+
        avxCampoHtml('avxModelo','Modelo',c.modelo)+
        avxCampoHtml('avxAno','Ano',c.ano)+
        avxCampoHtml('avxAnoM','Ano modelo',c.ano_modelo)+
        avxCampoHtml('avxCor','Cor',c.cor)+
        avxCampoHtml('avxComb','Combustível',c.combustivel)+
        avxCampoHtml('avxKm','Quilometragem',c.km)+
        avxCampoHtml('avxQuem','Responsável (sua equipe)',c.quem)+
        avxCampoHtml('avxValor','Valor avaliado (R$)',c.valor_loja?String(c.valor_loja):'')+
        avxCampoHtml('avxFipe','FIPE (R$)',c.fipe?String(c.fipe):'')+
        avxCampoHtml('avxIpva','IPVA pago (Sim/Não)',c.ipva)+
        avxCampoHtml('avxMultas','Multas (Sim/Não)',c.multas)+
        avxCampoHtml('avxAlien','Alienado (Sim/Não)',c.alienado)+
      '</div>'+
      (c.checklist?('<div class="avx-nota">'+esc(c.checklist)+' — vai pro fim das observações; os custos ficam com você.</div>'):'')+
      (c.obs?('<div class="avx-campo"><label>Observações do avaliador</label><textarea id="avxObs" class="avt-in" rows="3">'+esc(c.obs)+'</textarea></div>'):'')+
      fotosHtml+
      '<div class="avx-acts">'+
        '<button type="button" class="crop-c" id="avxCancela">Cancelar</button>'+
        '<button type="button" class="crop-ok" id="avxOk">Importar pra avaliação</button>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    /* miniaturas: object URL curto, revogado ao fechar */
    var urls=[];
    Array.prototype.forEach.call(bg.querySelectorAll('img[data-fimg]'),function(img){
      try{
        var i=Number(img.getAttribute('data-fimg'));
        var u=URL.createObjectURL(_avxLido.fotos[i]); urls.push(u); img.src=u;
      }catch(_){}
    });
    function fechar(){ urls.forEach(function(u){ try{ URL.revokeObjectURL(u); }catch(_){} });
      try{ bg.parentNode.removeChild(bg); }catch(_){} }
    Array.prototype.forEach.call(bg.querySelectorAll('input[data-foto]'),function(ck){
      ck.onchange=function(){ _avxFotosSel[Number(ck.getAttribute('data-foto'))]=!!ck.checked; };
    });
    /* v692: o destaque do valor acompanha o campo editável AO VIVO */
    (function(){ var vi=$('avxValor'), big=$('avxValorBig'); if(!vi||!big) return;
      vi.addEventListener('input',function(){ var n=avxDinheiro(vi.value);
        big.textContent=n?('R$ '+n.toLocaleString('pt-BR')):'—'; });
    })();
    $('avxCancela').onclick=function(){ _avxLido=null; fechar(); };
    $('avxOk').onclick=function(){
      var c2={
        placa:String((($('avxPlaca')||{}).value)||'').toUpperCase().replace(/[^A-Z0-9]/g,''),
        marca:String((($('avxMarca')||{}).value)||'').trim(),
        modelo:String((($('avxModelo')||{}).value)||'').trim(),
        ano:avxSoNum((($('avxAno')||{}).value)),
        ano_modelo:avxSoNum((($('avxAnoM')||{}).value)),
        cor:String((($('avxCor')||{}).value)||'').trim(),
        combustivel:String((($('avxComb')||{}).value)||'').trim(),
        km:avxSoNum((($('avxKm')||{}).value)),
        quem:String((($('avxQuem')||{}).value)||'').trim(),
        valor_loja:avxDinheiro((($('avxValor')||{}).value)),
        fipe:avxDinheiro((($('avxFipe')||{}).value)),
        ipva:avxSimNao((($('avxIpva')||{}).value)),
        multas:avxSimNao((($('avxMultas')||{}).value)),
        alienado:avxSimNao((($('avxAlien')||{}).value)),
        checklist:_avxLido.campos.checklist,
        obs:String((($('avxObs')||{}).value)||_avxLido.campos.obs||'').trim()
      };
      var fotos=_avxLido.fotos.filter(function(_,i){ return _avxFotosSel[i]; });
      fechar();
      avxAplicar(c2, fotos);
    };
  }

  /* ================= APLICAR NA AVALIAÇÃO ================= */
  function avxPoeSeVazio(id, valor){
    var el=$(id); if(!el || !String(valor||'').trim()) return false;
    if(String(el.value||'').trim()) return false;    /* quem mexeu no campo ganha */
    el.value=valor;
    try{ el.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
    return true;
  }
  function avxPoeSelect(id, valor, padrao){
    var el=$(id); if(!el || !valor) return false;
    if(String(el.value)!==String(padrao)) return false;   /* mexido = fica */
    el.value=valor;
    try{ el.dispatchEvent(new Event('change',{bubbles:true})); }catch(_){}
    return true;
  }
  function avxAplicar(c, fotos){
    if(!c.placa || !/^[A-Z]{3}\d[A-Z0-9]\d{2}$/.test(c.placa)){
      toast('Confira a placa antes de importar.'); _avxLido=null; return;
    }
    /* dois caminhos (item 6-f): placa já consultada neste aparelho abre por
       cima do que existe; nunca consultada abre com o veiculoAtual LEVE —
       e NENHUM dos dois dispara consulta paga. */
    var h=null;
    try{ h=_avlDoHistorico(_avlKey(c.placa)); }catch(_){ h=null; }
    if(h && h.v){
      veiculoAtual=h.v; histFonteTs=h.ts;
      fichaState=h.ficha||null; fichaTecState=h.fichaTec||null; leilaoState=h.leilao||null;
      try{ verAplicar(veiculoAtual); }catch(_){}
    }else{
      veiculoAtual={ placa:c.placa, marca:c.marca||'', modelo:c.modelo||'',
        ano:c.ano||'', ano_fab:c.ano||'', ano_modelo:c.ano_modelo||c.ano||'',
        cor:c.cor||'', combustivel:c.combustivel||'', fipe:c.fipe||0 };
      histFonteTs=null; fichaState=null; fichaTecState=null; leilaoState=null;
    }
    try{ abrirAvaliacaoLojista(); }catch(e){ toast('Não consegui abrir a avaliação.'); return; }
    try{ voltarTab(telaAvaliacoes); }catch(_){}

    /* campo a campo — o laudo NUNCA apaga, só preenche buraco (item 6-e) */
    avxPoeSeVazio('avKm', c.km?Number(c.km).toLocaleString('pt-BR'):'');
    avxPoeSeVazio('avQuem', c.quem);
    avxPoeSeVazio('avValor', c.valor_loja?('R$ '+Number(c.valor_loja).toLocaleString('pt-BR')):'');
    /* v708 — o cliente do laudo NÃO entra mais (item 6-b restaurado, a
       pedido). O bilhete mev_avcli/aval_cli agora só nasce do que o Angelo
       DIGITA no card "Mandar pro vendedor" (v694/v702). */
    if(c.ipva) avxPoeSelect('avIpva', c.ipva==='Sim'?'Pago':'Em atraso', 'Pago');
    if(c.multas) avxPoeSelect('avMultas', c.multas, 'Não');
    if(c.alienado) avxPoeSelect('avAlien', c.alienado, 'Não');
    /* observações: o texto do avaliador entra se o campo está vazio; as
       quatro notas viram rodapé (uma vez só — o marcador "Avaliex:" evita
       duplicar num segundo import). */
    var obsEl=$('avObs');
    if(obsEl){
      var atual=String(obsEl.value||'');
      if(!atual.trim() && c.obs) atual=c.obs;
      if(c.checklist && atual.indexOf('Avaliex:')<0) atual=(atual?atual+'\n':'')+c.checklist;
      if(atual!==String(obsEl.value||'')){
        obsEl.value=atual;
        try{ obsEl.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
      }
    }
    try{ calcAvaliacao(); }catch(_){}
    /* v695 — o valor do laudo também vira o "Avaliex" do card (só se o card
       ainda não tem um): é ele que o Angelo quer VER e comparar na lista. */
    if(c.valor_loja){
      try{
        _avlCard=_avlCard||{};
        var oc=_avlCard[c.placa]||{};
        if(!oc.valor_avaliex){
          oc.valor_avaliex=c.valor_loja; oc._ts=Date.now();
          _avlCard[c.placa]=oc; _avlCardGravaLocal();
          try{ docHistCloudSave('aval_card', c.placa, 'card', oc, oc._ts); }catch(_){}
        }
      }catch(_){}
    }
    /* as fotos são ACRÉSCIMO (avAddFotos já soma) — nunca substituição */
    if(fotos && fotos.length){ try{ avAddFotos(fotos); }catch(_){} }
    if(!h || !h.v){
      /* placa nunca consultada: diz em UMA linha e deixa o caminho pago no
         dedo — o importador nunca consulta sozinho (v585/v599). */
      toast('Importado sem consulta — sem ficha técnica e sem leilão. Consulte a placa quando quiser.');
    }else{
      toast('Laudo importado por cima da avaliação existente — o que você já tinha digitado ficou.');
    }
    /* v709 — "importar" tem que APARECER EM AVALIAÇÕES: garante a linha no
       banco (quieto; as fotos entram no pacote no primeiro Salvar/atualizar,
       porque o upload delas ainda está rodando aqui). */
    try{ avLojGarantirLinha(); }catch(_){}
    _avxLido=null;
  }

  /* ==========================================================================
     v1001 — A SEGUNDA ORIGEM: O LINK PÚBLICO DE COTAÇÃO
     --------------------------------------------------------------------------
     Três passos, e nenhum deles cria nada sozinho:
        1. avxAbrirLink   — pede o endereço
        2. avxLinkLer     — o SERVIDOR lê a página (modo prévia) e devolve os
                            campos e os endereços das fotos. Nada é baixado,
                            nada é criado, nada é cobrado.
        3. avxLinkImportar— só depois do dedo: o servidor RELÊ a página, baixa
                            as fotos escolhidas POR ÍNDICE, confere a assinatura
                            real de cada arquivo e devolve os bytes. O app monta
                            um File e entrega pra MESMA porta de fotos de sempre
                            (avAddFotos → proteção de placa → avUpload).
     ⚠️ O navegador nunca fala com o Avaliex nem com o servidor de fotos: quem
        vai à rede é a Function. Isso resolve o CORS e mantém a lista branca de
        endereços num lugar só, no servidor.
     ========================================================================== */
  var _avxLink=null;

  function avxAbrirLink(){
    var velho=$('avxBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avxBg'; bg.className='cropmask';
    bg.innerHTML='<div class="cropbox avx-box">'+
      '<div class="avx-tit">Colar link público de cotação</div>'+
      '<div class="avx-sub">Cole o endereço da cotação que o Avaliex publica. '+
        'Nada é criado enquanto você não confirmar.</div>'+
      '<div class="avx-campo"><label for="avxLinkIn">Link público da cotação</label>'+
        '<input id="avxLinkIn" class="avt-in" inputmode="url" autocomplete="off" spellcheck="false" '+
        'placeholder="https://avaliex.com.br/loja/cotacao/código"></div>'+
      '<div class="avx-nota" id="avxLinkMsg" role="status"></div>'+
      '<div class="avx-acts">'+
        '<button type="button" class="crop-c" id="avxLinkFecha">Cancelar</button>'+
        '<button type="button" class="crop-ok" id="avxLinkOk">Ler cotação</button>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    function fecha(){ try{ bg.parentNode.removeChild(bg); }catch(_){} }
    $('avxLinkFecha').onclick=fecha;
    $('avxLinkOk').onclick=function(){ avxLinkLer(this); };
    var inp=$('avxLinkIn');
    if(inp){
      try{ inp.focus(); }catch(_){}
      inp.onkeydown=function(e){ if(e.key==='Enter'){ e.preventDefault(); avxLinkLer($('avxLinkOk')); } };
    }
  }

  function _avxLinkMsg(txt, ruim){
    var e=$('avxLinkMsg'); if(!e) return;
    e.textContent=String(txt||'');
    e.style.color = ruim ? '#b91c1c' : '#516480';
  }

  async function avxLinkLer(btn){
    var inp=$('avxLinkIn'); var url=inp?String(inp.value||'').trim():'';
    if(!url){ _avxLinkMsg('Cole o endereço da cotação.', true); try{ inp.focus(); }catch(_){} return; }
    if(btn&&btn.disabled) return;
    if(btn){ btn.disabled=true; btn.textContent='Lendo cotação do Avaliex…'; }
    _avxLinkMsg('Lendo cotação do Avaliex…', false);
    var r=null;
    try{ r=await apiComTimeout('/api/importar-avaliex-link',{ url:url, modo:'previa' },45000); }catch(_){ r=null; }
    if(btn){ btn.disabled=false; btn.textContent='Ler cotação'; }
    if(!r||!r.ok){
      _avxLinkMsg((r&&r.erro)||'Não consegui abrir essa cotação agora.', true);
      return;
    }
    _avxLink={ url:url, dados:r.dados||{}, fotos:(r.fotos||[]),
               sel:(r.fotos||[]).map(function(){ return true; }) };
    try{ var bg=$('avxBg'); if(bg) bg.parentNode.removeChild(bg); }catch(_){}
    avxConferirLink();
  }

  function avxConferirLink(){
    if(!_avxLink) return;
    var d=_avxLink.dados, fs=_avxLink.fotos;
    var velho=$('avxBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avxBg'; bg.className='cropmask';
    /* as miniaturas usam o endereço do próprio Avaliex: MOSTRAR imagem não
       esbarra em CORS (só ler os pixels esbarraria), então a conferência é
       instantânea e nenhum byte viaja pro MEV antes do "Importar". */
    var fotosHtml = fs.length
      ? ('<div class="avx-fotos">'+fs.map(function(f,i){
          return '<label class="avx-foto"><input type="checkbox" data-lfoto="'+i+'" checked>'+
            '<img src="'+esc(f.url)+'" alt="foto '+(i+1)+'" loading="lazy"></label>';
        }).join('')+'</div>'+
        '<div class="avx-nota" id="avxLinkConta"></div>')
      : '<div class="avx-nota">Essa cotação não publicou fotos.</div>';
    var gastosHtml = (d.gastos&&d.gastos.length)
      ? ('<div class="avx-nota">Previsão de gastos que vem junto: '+
          d.gastos.map(function(g){ return esc(g.nome)+' R$ '+Number(g.valor).toLocaleString('pt-BR'); }).join(' · ')+
          ' — total R$ '+Number(d.gastos_total||0).toLocaleString('pt-BR')+'.</div>')
      : '';
    bg.innerHTML='<div class="cropbox avx-box">'+
      '<div class="avx-tit">Conferir a cotação do Avaliex</div>'+
      '<div class="avx-sub">Ajuste o que quiser — nada entra sem você confirmar. '+
        'O telefone e o WhatsApp da cotação <b>não são importados</b>.</div>'+
      '<div class="avx-grid">'+
        avxCampoHtml('avxLPlaca','Placa',d.placa)+
        avxCampoHtml('avxLMarca','Marca',d.marca)+
        avxCampoHtml('avxLModelo','Modelo',d.modelo)+
        avxCampoHtml('avxLAno','Ano',d.ano)+
        avxCampoHtml('avxLAnoM','Ano modelo',d.ano_modelo)+
        avxCampoHtml('avxLCor','Cor',d.cor)+
        avxCampoHtml('avxLKm','Quilometragem',d.km?String(d.km):'')+
        avxCampoHtml('avxLFipe','FIPE (R$)',d.fipe?String(d.fipe):'')+
        avxCampoHtml('avxLAlien','Alienado (Sim/Não)',d.alienado)+
      '</div>'+
      gastosHtml+
      fotosHtml+
      '<div class="avx-acts">'+
        '<button type="button" class="crop-c" id="avxLCancel">Cancelar</button>'+
        '<button type="button" class="crop-ok" id="avxLOk">Importar pra avaliação</button>'+
      '</div>'+
    '</div>';
    document.body.appendChild(bg);
    function conta(){
      var n=_avxLink.sel.filter(Boolean).length;
      var e=$('avxLinkConta');
      if(e) e.textContent = n ? (n+' de '+fs.length+' foto(s) serão importadas.') : 'Nenhuma foto será importada.';
    }
    bg.querySelectorAll('[data-lfoto]').forEach(function(cb){
      cb.onchange=function(){ _avxLink.sel[Number(cb.dataset.lfoto)]=cb.checked; conta(); };
    });
    conta();
    /* 🔴 cancelar não deixa rastro: nada foi baixado, nada foi criado, nada
       foi enviado pro bucket. Não existe foto órfã por este caminho. */
    $('avxLCancel').onclick=function(){ _avxLink=null; try{ bg.parentNode.removeChild(bg); }catch(_){} };
    $('avxLOk').onclick=function(){ avxLinkImportar(this); };
  }

  /* base64 → File, pra foto do link entrar pela MESMA porta do arquivo
     escolhido à mão (avAddFotos → proteção de placa → avUpload). */
  function avxBase64File(b64, tipo, nome){
    var bin=atob(String(b64||''));
    var n=bin.length, u8=new Uint8Array(n);
    for(var i=0;i<n;i++) u8[i]=bin.charCodeAt(i);
    return new File([u8], nome, { type:tipo||'image/jpeg' });
  }

  /* os três gastos da cotação entram em Gastos previstos SEM duplicar:
     importar o mesmo link duas vezes não cria seis linhas. */
  function avxGastosDoLink(gastos){
    if(!gastos||!gastos.length) return;
    try{
      var atuais=avGastosLer();
      var nomes={}; atuais.forEach(function(g){ nomes[String(g.descricao||'').trim().toLowerCase()]=1; });
      var mudou=false;
      gastos.forEach(function(g){
        var nome=String(g.nome||'').trim();
        var valor=Number(g.valor)||0;
        if(!nome || !(valor>0)) return;
        if(nomes[nome.toLowerCase()]) return;
        atuais.push({ valor:Math.round(valor*100)/100, descricao:nome });
        nomes[nome.toLowerCase()]=1; mudou=true;
      });
      if(mudou){ avGastosGravar(atuais); avGastosPinta(); }
    }catch(_){}
  }

  async function avxLinkImportar(btn){
    if(!_avxLink) return;
    if(btn&&btn.disabled) return;
    var indices=[];
    _avxLink.sel.forEach(function(v,i){ if(v) indices.push(i); });
    if(btn){ btn.disabled=true; btn.textContent = indices.length ? ('Importando '+indices.length+' foto(s)…') : 'Importando…'; }
    var r=null;
    try{ r=await apiComTimeout('/api/importar-avaliex-link',
          { url:_avxLink.url, modo:'importar', fotos:indices }, 120000); }catch(_){ r=null; }
    if(!r||!r.ok){
      if(btn){ btn.disabled=false; btn.textContent='Importar pra avaliação'; }
      toast((r&&r.erro)||'Não consegui importar essa cotação agora.');
      return;
    }
    /* os campos editados na conferência mandam no que veio do servidor — é a
       pessoa que confere, não o parser. */
    var d=r.dados||{};
    function campo(id, padrao){ var e=$(id); return e ? String(e.value||'').trim() : (padrao||''); }
    var c={
      placa: String(campo('avxLPlaca', d.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,''),
      marca: campo('avxLMarca', d.marca),
      modelo: campo('avxLModelo', d.modelo),
      ano: campo('avxLAno', d.ano),
      ano_modelo: campo('avxLAnoM', d.ano_modelo),
      cor: campo('avxLCor', d.cor),
      combustivel: '',
      km: Number(String(campo('avxLKm', d.km)).replace(/\D/g,''))||0,
      fipe: Number(String(campo('avxLFipe', d.fipe)).replace(/[^\d.,]/g,'').replace(/\./g,'').replace(',','.'))||0,
      quem: '', valor_loja: 0, ipva: '', multas: '',
      alienado: /^s/i.test(campo('avxLAlien', d.alienado))?'Sim':(/^n/i.test(campo('avxLAlien', d.alienado))?'Não':''),
      obs: String(d.obs||''), checklist: ''
    };
    var arquivos=[];
    try{
      (r.fotos||[]).forEach(function(f,k){
        var ext=(String(f.tipo||'').indexOf('png')>=0)?'png':((String(f.tipo||'').indexOf('webp')>=0)?'webp':'jpg');
        arquivos.push(avxBase64File(f.base64, f.tipo, 'avaliex-'+(c.placa||'cotacao').toLowerCase()+'-'+(k+1)+'.'+ext));
      });
    }catch(_){ arquivos=[]; }
    try{ var bg=$('avxBg'); if(bg) bg.parentNode.removeChild(bg); }catch(_){}
    var gastos=(d.gastos||[]);
    _avxLink=null;
    avxAplicar(c, arquivos);
    /* depois do avxAplicar: a avaliação já está aberta, então os campos de
       gasto existem na tela pra receber as linhas. */
    avxGastosDoLink(gastos);
    if(r.fotos_falharam){
      toast('Avaliação criada. '+(r.fotos_importadas||0)+' de '+(r.fotos_pedidas||0)+' fotos foram importadas.');
    }else if((r.fotos_importadas||0)>0){
      toast('Avaliação criada com '+r.fotos_importadas+' foto(s).');
    }
  }

  /* o botão na página Avaliações (o ÚNICO lugar — decisão 28/08).
     v683 (pedido): NA MESMA LINHA do campo de busca — o botão entra numa
     linha flex junto com o #avlSearch, em vez de cair embaixo dele. */
  function avxBotaoWire(){
    /* ==========================================================================
       🔴 v919 — O BOTÃO MUDOU DE CASA E DE PESO (PROJETO-2026-09-06, §6.2)
       --------------------------------------------------------------------------
       Ele morava numa linha própria colada na busca (`.avx-linha`) e tinha a
       MESMA aparência do "Nova avaliação" ao lado — duas ações do mesmo peso,
       nenhuma dizendo por onde se começa. Agora ele é o SECUNDÁRIO (contornado)
       da linha `#avlAcoes`, e o primário é o "Nova avaliação".

       ⚠️ O RÓTULO VISÍVEL ENCOLHEU PRA "Importar" (§6.2: cabe na coluna menor
       sem quebrar em duas linhas), mas o NOME ACESSÍVEL continua inteiro: quem
       usa leitor de tela ouviria "Importar" e não saberia importar de onde.
       ⚠️ O caminho antigo (`.avl-topo-lado` + `.avx-linha`) fica de reserva:
       sem o `#avlAcoes` na tela — outra página, uma versão futura — ele volta
       a se montar como antes em vez de sumir calado.
       ========================================================================== */
    if($('avxBtn')) return;
    var bt=document.createElement('button');
    bt.type='button'; bt.id='avxBtn';
    bt.onclick=avxAbrir;
    var casa=$('avlAcoes');
    if(casa){
      bt.className='avl-acao avl-acao-2';
      bt.setAttribute('aria-label','Importar do Avaliex');
      bt.title='Importar avaliações do Avaliex';
      bt.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg><span>Importar</span>';
      casa.appendChild(bt);
      return;
    }
    var lado=document.querySelector('.avl-topo-lado'); if(!lado) return;
    bt.className='avx-btn';
    bt.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>Importar do Avaliex';
    var busca=$('avlSearch');
    if(busca && busca.parentNode===lado){
      var linha=document.createElement('div');
      linha.className='avx-linha';
      lado.insertBefore(linha, busca);
      linha.appendChild(busca);
      linha.appendChild(bt);
    }else{
      lado.appendChild(bt);
    }
  }
  try{ window.avxBotaoWire=avxBotaoWire; }catch(_){}

/* ╔═══ src/app/05j-blocos-da-home.js ═════════════════════════════════════ */
  /* ==========================================================================
     05j — OS BLOCOS DA COLUNA DA HOME (SÓ COMPUTADOR ≥1280px)
     PROJETO-2026-08-30-pendencias-de-hoje-e-novidades-na-home
     --------------------------------------------------------------------------
     No computador a coluna da direita da home terminava depois do histórico e
     sobrava um branco grande até o pé da tela. Aqui moram os TRÊS blocos que
     ocupam esse espaço, nesta ordem, que NUNCA muda (§4 R7 do projeto):

         histórico (já existia)
           ↓
         PENDÊNCIAS DE HOJE   → só EU resolvo, e piora se ficar parado
           ↓
         NOVO NA REDE         → oportunidade, não tarefa
           ↓
         O QUE HÁ DE NOVO     → mudou algo no app; leio uma vez

     Por que os três num arquivo só: são vizinhos, do mesmo dono, na mesma
     coluna. E por que NÃO no 05-historico-e-home.js: ele já tem 101 KB e 89
     funções — a regra da leitura barata (v729) manda separar ANTES de crescer.

     AS REGRAS DE DESENHO (valem para os três — §4 do projeto):
       R1 cartão branco igual aos outros; sem fundo colorido, banner, ilustração
          ou ponto piscando. Cor SÓ dentro do quadradinho do ícone.
       R2 os fundos coloridos da coluna esquerda (laranja=risco, verde=lojista)
          são um CÓDIGO de família — bloco novo colorido quebra o código.
       R3 título 12px, maiúsculas, espaçado, cinza. Não é manchete.
       R4 teto de linhas, sem rolagem e sem "ver mais" DENTRO do bloco.
       R5 bloco sem conteúdo NÃO APARECE (nunca "Nenhuma pendência" ocupando
          espaço). Única exceção: o rodapé de tokens.
       R6 nada disso no celular — a home móvel foi resolvida na v745.
       R7 a ordem nunca muda.

     🔴 A REGRA DE CUSTO (§5.4 — o ponto mais importante do projeto)
     A cota do Supabase já estourou uma vez (28/08). A home é a tela que TODO
     lojista abre TODA vez: uma consulta pesada aqui multiplica pela base
     inteira, todo dia. Por isso, aqui dentro:
       · toda contagem é COUNT no servidor (head:true) — ZERO linha volta;
       · NENHUMA foto é carregada por causa destes blocos;
       · o resultado fica guardado em memória por 5 minutos;
       · nada roda abaixo de 1280px (o celular não faz uma consulta sequer);
       · a home NÃO espera por nada disto (mesma lição da v738);
       · enquanto carrega o bloco não existe — sem "carregando", sem esqueleto.
     ========================================================================== */
  var BH_MIN_LARGURA = 1280;      /* a mesma quebra da home em duas colunas */
  var BH_CACHE_MS    = 5*60*1000; /* §5.4: voltar pra home não refaz as contagens */

  function bhLargo(){
    try{ return window.matchMedia('(min-width:'+BH_MIN_LARGURA+'px)').matches; }
    catch(_){ return (window.innerWidth||0) >= BH_MIN_LARGURA; }
  }

  /* ---- ícones de LINHA, no mesmo traço do resto do app (v762) ---- */
  function _bhIco(d,w){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="'+(w||2)+'" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>'; }
  var BH_ICO = {
    oferta:  _bhIco('<path d="M12 1v22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>'),
    foto:    _bhIco('<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>'),
    aval:    _bhIco('<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 14h6"/>'),
    repasse: _bhIco('<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>'),
    mercado: _bhIco('<path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><circle cx="11" cy="14" r="3"/><path d="M16 19l-2.2-2.2"/>')
  };
  var BH_CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

  /* ==========================================================================
     O CSS — mora junto do módulo (§5.6: evitar mexer no styles.css, que é
     compartilhado por todas as conversas). Injetado uma vez só.
     ⚠️ O cinza dos textos pequenos é #526687 (5,8:1 sobre branco) e não o
     --cinza — é a mesma régua que o histórico usa desde a v764 §12.7.
     ========================================================================== */
  var _bhCssPronto=false;
  function bhCss(){
    if(_bhCssPronto) return; _bhCssPronto=true;
    var css =
    /* fora do computador largo os blocos simplesmente NÃO existem (R6) */
    '#bhBlocos{display:none}'+
    '@media(min-width:'+BH_MIN_LARGURA+'px){'+
      'body.app-on:not(.tela-interna):not(.md-veiculo) #bhBlocos{display:block}'+
    '}'+
    '#bhBlocos .bh-card{background:#fff;border:1px solid #e4eaf5;border-radius:16px;'+
      'box-shadow:0 1px 2px rgba(15,23,42,.04);padding:12px 12px 10px;margin-top:12px}'+
    '#bhBlocos .bh-card[hidden]{display:none}'+
    '#bhBlocos .bh-tit{margin:0 0 6px;font-size:12px;font-weight:800;letter-spacing:.06em;'+
      'text-transform:uppercase;color:#526687;line-height:1.3}'+
    /* a LINHA INTEIRA é o botão (§5.1), com 44px de altura mínima */
    '#bhBlocos .bh-linha{display:flex;align-items:center;gap:10px;width:100%;min-height:44px;'+
      'padding:8px 4px;border:0;background:none;font-family:inherit;text-align:left;cursor:pointer;'+
      'border-radius:10px;color:inherit}'+
    '#bhBlocos .bh-linha + .bh-linha{border-top:1px solid #eef2f7}'+
    '#bhBlocos .bh-linha:hover{background:#f7faff}'+
    '#bhBlocos .bh-linha:focus-visible{outline:3px solid rgba(10,77,166,.3);outline-offset:2px}'+
    '#bhBlocos .bh-ico{flex:0 0 auto;width:28px;height:28px;border-radius:9px;display:flex;'+
      'align-items:center;justify-content:center;background:#eef4ff;color:#0a4da6}'+
    '#bhBlocos .bh-ico svg{width:16px;height:16px}'+
    '#bhBlocos .bh-ico.ver{background:#fee2e2;color:#b91c1c}'+
    '#bhBlocos .bh-ico.lar{background:#ffedd5;color:#b45309}'+
    '#bhBlocos .bh-tx{flex:1 1 auto;min-width:0}'+
    '#bhBlocos .bh-tx b{display:block;font-size:13px;font-weight:700;color:#0f2b57;line-height:1.35}'+
    '#bhBlocos .bh-tx small{display:block;font-size:11.5px;color:#526687;line-height:1.35;margin-top:1px}'+
    '#bhBlocos .bh-cta{flex:0 0 auto;font-size:12px;font-weight:800;color:#0a4da6;background:#eaf1fd;'+
      'border:1px solid #dbe6f7;border-radius:9px;padding:6px 10px}'+
    '#bhBlocos .bh-go{flex:0 0 auto;width:18px;height:18px;color:#94a3b8}'+
    '#bhBlocos .bh-go svg{width:18px;height:18px}'+
    /* o rodapé de tokens NÃO é uma linha da lista: é rodapé (§5.1) */
    '#bhBlocos .bh-rod{display:block;width:100%;min-height:36px;margin-top:6px;padding:8px 4px 2px;'+
      'border:0;border-top:1px solid #eef2f7;background:none;font-family:inherit;font-size:11.5px;'+
      'font-weight:600;color:#526687;text-align:left;cursor:pointer;border-radius:0 0 10px 10px}'+
    '#bhBlocos .bh-rod[hidden]{display:none}'+
    '#bhBlocos .bh-rod:hover{color:#0a4da6}'+
    '#bhBlocos .bh-rod:focus-visible{outline:3px solid rgba(10,77,166,.3);outline-offset:2px}'+
    '#bhBlocos .bh-rod b.baixo{color:#b45309}'+
    /* "O que há de novo": data à esquerda, texto de uma linha só */
    '#bhBlocos .bh-nov{display:flex;align-items:flex-start;gap:9px}'+
    '#bhBlocos .bh-data{flex:0 0 auto;font-size:11.5px;font-weight:700;color:#526687;padding-top:1px}'+
    '#bhBlocos .bh-nov .bh-tx b{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600}'+
    '#bhBlocos .bh-nov.nlida .bh-tx b{font-weight:800}'+
    '#bhBlocos .bh-vertudo{display:block;width:100%;min-height:36px;margin-top:4px;padding:8px 4px 2px;'+
      'border:0;border-top:1px solid #eef2f7;background:none;font-family:inherit;font-size:12px;'+
      'font-weight:700;color:#0a4da6;text-align:left;cursor:pointer}'+
    '#bhBlocos .bh-vertudo:focus-visible{outline:3px solid rgba(10,77,166,.3);outline-offset:2px}'+
    /* nada animado, nada piscando (§8): a pessoa pode estar digitando placa ao lado */
    '@media(prefers-reduced-motion:reduce){#bhBlocos *{transition:none!important;animation:none!important}}';
    try{
      var s=document.createElement('style'); s.id='bhCss'; s.textContent=css;
      document.head.appendChild(s);
    }catch(_){ _bhCssPronto=false; }
  }

  /* ==========================================================================
     O ENCAIXE — chamado no fim de pintaHomeHist (05-historico-e-home.js).
     Cria os contêineres VAZIOS dentro do #homeHistCol (o embrulho da coluna da
     direita, no app.html) e dispara as cargas sem segurar a home.
     ========================================================================== */
  var _bhMontado=false;
  function bhMontar(){
    /* v911 — estes blocos são operacionais: avaliações pendentes, repasses,
       mercado e avisos da rede. No MEV Consultas eles não devem nem nascer
       nem consultar o servidor. Nas demais edições nada muda. */
    try{
      if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='consultas'){
        var antigo=document.getElementById('bhBlocos');
        if(antigo&&antigo.parentNode) antigo.parentNode.removeChild(antigo);
        _bhPasso='desligado:mev-consultas';
        return;
      }
    }catch(_){}
    /* v790: a migalha de pão. Cada linha destas diz ATÉ ONDE o código chegou —
       é o que separa "o bloco nem nasceu" de "nasceu e ficou vazio". Sem ela
       a v789 não gravou nada e não soubemos por quê: o rastro morava só no
       fim do pdhCarregar, e os returns de cima escapavam dele em silêncio. */
    _bhPasso='montar';
    if(!bhLargo()){ _bhPasso='estreito:'+(window.innerWidth||0); return; }
    /* 🔴 o relógio é armado AQUI, antes de qualquer desistência — foi o
       teste-v790 que pegou isto: eu o tinha posto lá embaixo, depois do
       `if(!col) return`, e o caso "a coluna não existe" continuava mudo.
       Um relatório que só é agendado quando o caminho dá certo é o mesmo
       erro da v789, só que uma linha mais abaixo.
       Depois da largura, e não antes, porque no celular o silêncio é a
       regra (R6) — lá não há defeito nenhum a relatar. */
    if(!_bhRelogio) _bhRelogio=setTimeout(bhDiagnostico, 3000);
    var col=$('homeHistCol');
    if(!col){ _bhPasso='sem #homeHistCol'; return; }
    bhCss();
    if(!_bhMontado || !$('bhBlocos')){
      var box=$('bhBlocos');
      if(!box){
        box=document.createElement('div'); box.id='bhBlocos';
        box.innerHTML=
          '<section class="bh-card" id="bhPend" aria-labelledby="bhPendTit" hidden>'+
            '<h2 class="bh-tit" id="bhPendTit">Pendências de hoje</h2>'+
            '<div id="bhPendLista"></div>'+
            '<button type="button" class="bh-rod" id="bhPendRod" hidden></button>'+
          '</section>'+
          '<section class="bh-card" id="bhRede" aria-labelledby="bhRedeTit" hidden>'+
            '<h2 class="bh-tit" id="bhRedeTit">Novo na rede</h2>'+
            '<div id="bhRedeLista"></div>'+
          '</section>'+
          '<section class="bh-card" id="bhNov" aria-labelledby="bhNovTit" hidden>'+
            '<h2 class="bh-tit" id="bhNovTit">O que há de novo</h2>'+
            '<div id="bhNovLista"></div>'+
            '<button type="button" class="bh-vertudo" id="bhNovVer">Ver tudo no sino ↗</button>'+
          '</section>';
        col.appendChild(box);
      }
      _bhMontado=true;
    }
    /* §5.4: a home NÃO espera — o bloco aparece pronto, depois, de uma vez.
       ⚠️ pintaHomeHist roda a CADA TECLA da busca do histórico. Se o cache
       ainda vale, aqui só repinta o que já está em memória — nada de novo
       agendamento e nenhuma consulta. */
    if(_pdhDados && (Date.now()-_pdhQuando)<BH_CACHE_MS){ pdhPintar(); redPintar(); novPintar(); return; }
    if(_bhAgendado) return;
    _bhAgendado=setTimeout(function(){ _bhAgendado=0;
      _bhPasso='carregando';
      try{ pdhCarregar(); }catch(e){ _bhPasso='pdhCarregar estourou'; _bhPorque=String((e&&e.message)||e).slice(0,120); } },250);
  }
  var _bhRelogio=0;
  var _bhAgendado=0;

  /* ==========================================================================
     FASE 1 — PENDÊNCIAS DE HOJE
     --------------------------------------------------------------------------
     AS LINHAS, EM ORDEM DE PRIORIDADE (§5.2). Mostra as que tiverem número > 0,
     no máximo 4:

       P1 "N ofertas esperando resposta"  → Portal do Repasse, aba Ofertas
          É A MAIS URGENTE: tem gente esperando do outro lado e dinheiro na
          mesa. É a única com ícone vermelho — e o texto "esperando resposta"
          carrega o sentido sozinho, pra quem não enxerga a cor (§8).
       P2 "N veículos sem foto"           → Estoque já filtrado em "Sem foto"
       P3 "N avaliações abertas"          → tela de Avaliações

     🔴 O QUE FICOU DE FORA, E POR QUÊ — "N clientes sem retorno há X dias".
     O projeto autorizava tirar ("só entra se a contagem sair barata... não
     forçar"). A contagem sai barata, mas ela MENTIRIA: a tela de Leads filtra
     em memória pelo `leadNaLista` (v528, quem já comprou sai da lista) e pela
     etapa. O número da home não bateria com a lista que o clique abre — e
     pendência que mente é pior que pendência nenhuma. Fica pra quando o
     filtro do CRM virar regra de servidor.

     🔴 E POR QUE A "AVALIAÇÃO ABERTA" NÃO OLHA A mp_avaliacoes.
     Medido no banco de produção em 30/08: das 82 avaliações salvas, 58 estão
     com `payload->>avaliado` vazio — e TODAS as 19 da última semana. O valor
     avaliado não mora ali: mora no rascunho privado (doc_consulta, tipo
     `aval_rascunho`, campo avValor), que é de onde a própria tela de
     Avaliações lê desde a v692. Contar pela mp_avaliacoes daria "19
     avaliações abertas" pra sempre. Aqui a conta é a certa: rascunho SEM
     avValor, mexido nos últimos 7 dias (12 hoje) — número que se resolve
     sozinho quando o valor é preenchido.
     ========================================================================== */
  var PDH_AVAL_DIAS = 7;         /* janela do rascunho sem valor */
  var _pdhDados=null, _pdhQuando=0, _pdhEmVoo=false;

  function _pdhIso(dias){ return new Date(Date.now()-dias*864e5).toISOString(); }

  /* uma contagem: COUNT no servidor, head:true — nenhuma linha volta */
  function _pdhCount(q){
    return Promise.resolve(q).then(function(r){
      if(r && r.error) return null;
      return (r && typeof r.count==='number') ? r.count : null;
    }).catch(function(){ return null; });
  }

  async function pdhCarregar(force){
    if(!bhLargo()){ _bhPasso='estreito no carregar'; return; }
    if(_pdhEmVoo){ _bhPasso='ainda em voo'; return; }
    if(!force && _pdhDados && (Date.now()-_pdhQuando)<BH_CACHE_MS){
      _bhPasso='cache'; pdhPintar(); redCarregar(); novCarregar(); bhDiagnostico(); return; }
    /* 🔴 v790: ESTE return era o mais suspeito de todos e saía calado — se o
       relógio de 250ms dispara ANTES de a sessão terminar de entrar, meuId
       ainda é null, o bloco fica vazio pra sempre e ninguém fica sabendo.
       Agora ele diz o nome, e o relógio de 3s relata de qualquer jeito. */
    if(!meuId || !window.supa){
      _bhPasso='sem sessão (meuId='+(!!meuId)+' supa='+(!!window.supa)+')'; return; }
    _pdhEmVoo=true;
    _bhPasso='consultando';
    try{
      var mes=new Date(); mes.setDate(1); mes.setHours(0,0,0,0);
      var r=await Promise.all([
        /* P1 — ofertas recebidas ainda sem aceitar/recusar */
        _pdhCount(supa.from('oferta').select('id',{count:'exact',head:true})
          .eq('para_user_id',meuId).eq('status','nova')),
        /* P2 — veículos do estoque sem NENHUMA foto. Sem user_id de propósito:
           a RLS já devolve os colegas, que é exatamente o que a tela mostra —
           assim o número da home e a lista do clique nunca divergem.
           ⚠️ fotos é jsonb: vazio é null OU '[]' (conferido no banco). */
        _pdhCount(supa.from('estoque').select('id',{count:'exact',head:true})
          .or('fotos.is.null,fotos.eq.[]')),
        /* P3 — rascunho de avaliação sem valor, mexido nos últimos 7 dias */
        _pdhCount(supa.from('doc_consulta').select('id',{count:'exact',head:true})
          .eq('user_id',meuId).eq('tipo','aval_rascunho')
          /* sem valor = chave ausente OU string vazia (no banco existem os dois:
             25 ausentes e 8 vazias em 30/08). O PostgREST aceita as duas num
             or() só — conferido contra o servidor antes de escrever isto. */
          .or('resultado->>avValor.is.null,resultado->>avValor.eq.')
          .gte('atualizado_em',_pdhIso(PDH_AVAL_DIAS))),
        /* rodapé — consultas deste mês (a mesma conta da tela Uso) */
        _pdhCount(supa.from('historico_consulta').select('placa',{count:'exact',head:true})
          .eq('user_id',meuId).gte('ts',mes.getTime()))
      ]);
      _pdhDados={ ofertas:r[0]||0, semFoto:r[1]||0, avalAbertas:r[2]||0, consultasMes:r[3]||0 };
      _pdhQuando=Date.now();
    }catch(e){
      /* §5.3: falhou a consulta → o bloco não aparece e o app NÃO mostra erro.
         Pendência não é crítica; falhar calado é o certo aqui.
         v789: mas guarda O MOTIVO — calado pro lojista, não pra quem conserta. */
      _pdhDados=null;
      _bhPorque='consulta: '+String((e&&e.message)||e).slice(0,120);
    }
    _pdhEmVoo=false;
    pdhPintar();
    try{ redCarregar(); }catch(_){}
    try{ novCarregar(); }catch(_){}
    bhDiagnostico();
  }

  function _pdhLinhaHtml(qual, ico, cor, titulo, sub, cta, aria){
    return '<button type="button" class="bh-linha" data-pdh="'+qual+'" aria-label="'+esc(aria)+'">'+
      '<span class="bh-ico'+(cor?(' '+cor):'')+'">'+ico+'</span>'+
      '<span class="bh-tx"><b>'+esc(titulo)+'</b>'+(sub?('<small>'+esc(sub)+'</small>'):'')+'</span>'+
      (cta ? ('<span class="bh-cta">'+esc(cta)+'</span>') : ('<span class="bh-go">'+BH_CHEV+'</span>'))+
    '</button>';
  }

  function _pdhRodapeHtml(){
    var d=_pdhDados; if(!d) return '';
    var temPlano = ilimitado || saldo>0;
    if(!temPlano && !d.consultasMes) return '';
    var tok = ilimitado ? '<b>Consultas ilimitadas</b>'
      : ('<b'+(saldo<SALDO_BAIXO?' class="baixo"':'')+'>'+esc(precoReal(saldo))+'</b>');
    var cs = d.consultasMes ? (' · '+d.consultasMes+' consulta'+(d.consultasMes===1?'':'s')+' este mês') : '';
    return tok+cs;
  }

  function pdhPintar(){
    var card=$('bhPend'), lista=$('bhPendLista'), rod=$('bhPendRod');
    if(!card||!lista||!rod) return;
    var d=_pdhDados;
    if(!d){ card.hidden=true; return; }          /* §5.3: falhou → some, calado */
    var linhas=[];
    if(d.ofertas>0){
      linhas.push(_pdhLinhaHtml('ofertas', BH_ICO.oferta, 'ver',
        d.ofertas+' oferta'+(d.ofertas===1?'':'s')+' esperando resposta',
        'O lojista está aguardando você', 'Responder',
        d.ofertas+' oferta'+(d.ofertas===1?'':'s')+' esperando resposta. Abrir as ofertas do Portal do Repasse.'));
    }
    if(d.semFoto>0){
      linhas.push(_pdhLinhaHtml('semfoto', BH_ICO.foto, 'lar',
        d.semFoto+' veículo'+(d.semFoto===1?'':'s')+' sem foto',
        'Anúncio sem foto quase não recebe contato', 'Resolver',
        d.semFoto+' veículo'+(d.semFoto===1?'':'s')+' sem foto. Abrir o estoque filtrado em sem foto.'));
    }
    if(d.avalAbertas>0){
      linhas.push(_pdhLinhaHtml('avaliacoes', BH_ICO.aval, '',
        d.avalAbertas+' avaliaç'+(d.avalAbertas===1?'ão aberta':'ões abertas'),
        'Começadas nos últimos '+PDH_AVAL_DIAS+' dias, ainda sem valor', '',
        d.avalAbertas+' avaliaç'+(d.avalAbertas===1?'ão aberta':'ões abertas')+'. Abrir a tela de avaliações.'));
    }
    linhas=linhas.slice(0,4);                    /* R4: teto de 4 linhas */
    var rodTxt=_pdhRodapeHtml();
    /* §5.3: sem pendência E sem plano/tokens → o bloco inteiro some (R5) */
    if(!linhas.length && !rodTxt){ card.hidden=true; return; }
    lista.innerHTML=linhas.join('');
    if(rodTxt){ rod.hidden=false; rod.innerHTML=rodTxt; rod.setAttribute('aria-label','Ver uso e pagamentos'); }
    else { rod.hidden=true; rod.innerHTML=''; }
    card.hidden=false;
    Array.prototype.forEach.call(lista.querySelectorAll('.bh-linha'),function(b){
      b.onclick=function(){ pdhIr(b.getAttribute('data-pdh')); };
    });
    rod.onclick=function(){ try{ telaInfo('pagamentos'); }catch(_){} };
  }

  function pdhIr(qual){
    try{
      if(qual==='ofertas'){
        /* a tela do Portal abre sempre na aba Rede; a aba Ofertas é o clique
           no botão que ela mesma monta — sem tocar no 09. */
        var p=telaRepassePortal();
        if(p && p.then){ p.then(function(){ _bhCliqueAba('ofertas'); }); }
        else { setTimeout(function(){ _bhCliqueAba('ofertas'); },250); }
        return;
      }
      if(qual==='semfoto'){ estAbrirFiltro('semfoto'); return; }
      if(qual==='avaliacoes'){ telaAvaliacoes(); return; }
    }catch(e){ try{ window.mevErro && window.mevErro(e,'pdhIr'); }catch(_){} }
  }
  function _bhCliqueAba(rv){
    try{ var b=document.querySelector('#repTgl .hh-tg[data-rv="'+rv+'"]'); if(b) b.click(); }catch(_){}
  }

  /* ==========================================================================
     FASE 2 — NOVO NA REDE  (v777)
     --------------------------------------------------------------------------
     Duas linhas, sem subtexto (o número já diz tudo):

       "N repasses novos desde ontem"   → Portal do Repasse
       "N seminovos novos na região"    → Mercado da região

     O QUE É "NOVO": apareceu DESDE A ÚLTIMA VEZ que você abriu aquela tela.
     O carimbo da última visita mora no APARELHO (localStorage) e a contagem
     é um COUNT no servidor por cima dele. Sem carimbo (aparelho novo), a
     régua são os últimos 7 dias.

     🔴 ABRIR A TELA ATUALIZA O CARIMBO — é isso que impede o bloco de virar
     mentira. Entrou no portal, a linha some da home. E some NA HORA: o
     redCarimboGravar zera a linha em memória e repinta, sem esperar os 5
     minutos do cache.

     ⚠️ Este é o bloco que mais poderia custar cota, porque conta coisa da
     REDE INTEIRA. Conferido no banco em 30/08, antes de escrever:
       · mp_repasse tem `mp_repasse_ativo_idx (ativo, criado_em DESC)` — a
         contagem cai em cima do índice, é de graça;
       · mp_mercado_veiculos tem `mp_mercado_veic_busca (user_id, saiu_em,
         preco)`; o `entrou_em` fica de filtro por cima, mas a tabela é POR
         USUÁRIO e hoje tem 85 linhas no total. Sem risco.
     E o de sempre: COUNT com head:true, nenhuma linha volta, nenhuma foto
     é carregada. Aqui é contagem, não vitrine — a vitrine é a tela do portal.

     ⚠️ Nada a ver com o "vigia de estoque" (v671): aqui não tem aviso, não
     tem push, não tem e-mail. É só uma linha na home.
     ========================================================================== */
  var RED_SEM_CARIMBO_DIAS = 7;   /* aparelho novo: a régua são 7 dias */
  var RED_TETO = 9;               /* acima disso mostra "9+" — número grande vira ruído */
  var _redDados=null, _redQuando=0, _redEmVoo=false;

  function _redChave(qual){ return 'mev_bh_visto:'+qual; }
  function redCarimboLer(qual){
    try{
      var v=localStorage.getItem(_redChave(qual));
      if(v && /^\d{4}-/.test(v)) return v;
    }catch(_){ }
    return _pdhIso(RED_SEM_CARIMBO_DIAS);
  }
  function redCarimboGravar(qual){
    try{ localStorage.setItem(_redChave(qual), new Date().toISOString()); }catch(_){ }
    /* a linha some NA HORA: você acabou de olhar, não há nada de novo */
    if(_redDados && _redDados[qual]!=null){ _redDados[qual]=0; try{ redPintar(); }catch(_){} }
  }

  async function redCarregar(force){
    if(!bhLargo() || _redEmVoo) return;
    if(!force && _redDados && (Date.now()-_redQuando)<BH_CACHE_MS){ redPintar(); return; }
    if(!meuId || !window.supa) return;
    _redEmVoo=true;
    try{
      var r=await Promise.all([
        /* repasses da REDE que entraram depois da minha última visita.
           Os MEUS não contam: carro que eu mesmo publiquei não é novidade. */
        _pdhCount(supa.from('repasse').select('id',{count:'exact',head:true})
          .eq('ativo',true).neq('user_id',meuId)
          .gt('criado_em',redCarimboLer('repasse'))),
        /* seminovos que entraram no índice do Mercado e ainda estão no ar */
        _pdhCount(supa.from('mp_mercado_veiculos').select('id',{count:'exact',head:true})
          .eq('user_id',meuId).is('saiu_em',null)
          .gt('entrou_em',redCarimboLer('mercado')))
      ]);
      _redDados={ repasse:r[0]||0, mercado:r[1]||0 };
      _redQuando=Date.now();
    }catch(e){ _redDados=null; }   /* falhou: o bloco some, calado */
    _redEmVoo=false;
    redPintar();
  }

  function _redNum(n){ return n>RED_TETO ? (RED_TETO+'+') : String(n); }

  function redPintar(){
    var card=$('bhRede'), lista=$('bhRedeLista');
    if(!card||!lista) return;
    var d=_redDados;
    if(!d){ card.hidden=true; return; }
    var linhas=[];
    if(d.repasse>0){
      linhas.push(_pdhLinhaHtml('repasse', BH_ICO.repasse, '',
        _redNum(d.repasse)+' repasse'+(d.repasse===1?'':'s')+' novo'+(d.repasse===1?'':'s')+' desde a sua última visita', '', '',
        _redNum(d.repasse)+' repasses novos na rede. Abrir o Portal do Repasse.'));
    }
    if(d.mercado>0){
      linhas.push(_pdhLinhaHtml('mercado', BH_ICO.mercado, '',
        _redNum(d.mercado)+' seminovo'+(d.mercado===1?'':'s')+' novo'+(d.mercado===1?'':'s')+' na região', '', '',
        _redNum(d.mercado)+' seminovos novos na região. Abrir o Mercado da região.'));
    }
    linhas=linhas.slice(0,2);                    /* R4: teto de 2 linhas */
    if(!linhas.length){ card.hidden=true; return; }   /* R5: as duas zeradas → some */
    lista.innerHTML=linhas.join('');
    card.hidden=false;
    Array.prototype.forEach.call(lista.querySelectorAll('.bh-linha'),function(b){
      b.onclick=function(){ redIr(b.getAttribute('data-pdh')); };
    });
  }

  function redIr(qual){
    try{
      if(qual==='repasse'){ telaRepassePortal(); return; }
      if(qual==='mercado'){ telaMercado(); return; }
    }catch(e){ try{ window.mevErro && window.mevErro(e,'redIr'); }catch(_){} }
  }

  /* ==========================================================================
     FASE 3 — O QUE HÁ DE NOVO  (v778)
     --------------------------------------------------------------------------
     No MÁXIMO 2 itens, uma linha de texto cada (corta com "…"), e um
     "Ver tudo no sino ↗" que abre a tela de notificações que JÁ existe.

     🔴 A REGRA DE OURO: FONTE ÚNICA.
     Este bloco NÃO tem lista própria, NÃO tem tabela nova, NÃO tem cadastro
     separado. Ele lê a MESMA mp_notificacoes do sino e filtra os avisos que
     são novidade do app. Mandou pelo painel, aparece; não mandou, não aparece.

     QUAIS TIPOS SÃO "NOVIDADE DO APP" (conferido no banco em 30/08):
       · `novidades` — as novidades do dia (admin-painel, `mudancas_enviar`)
       · `sistema`   — o aviso solto do painel ("Agora dá pra instalar o MEV
                       Placas no computador", 14/08)
     Os outros tipos do sino (`chat`, `chat:lj:…`, `zap:…`, `plano`) são
     recado de gente ou de cobrança — não entram aqui.

     ⚠️ ONDE ESTA FASE SE AFASTA DO PROJETO, E POR QUÊ.
     O projeto mandava chamar `notifCarregar()`. Ela faz `select('*')` com
     limit 80 — oitenta linhas INTEIRAS (com o corpo do texto) baixadas na
     HOME, que é a tela que todo lojista abre toda vez. Isso é exatamente o
     que o §5.4 do mesmo projeto proíbe. A fonte única continua sendo a
     mesma tabela do sino; o que muda é o tamanho da mordida: quatro colunas,
     duas linhas, filtradas no servidor. E se o sino JÁ tiver carregado nesta
     sessão (`_notifs` cheio), o bloco usa o que está na memória e não pede
     nada.

     🔴 O ERRO MAIS FÁCIL DE COMETER NO PROJETO INTEIRO: clicar aqui tem que
     contar como LIDO — o MESMO "lido" do sino — e chamar notifBadgeAtualiza
     logo em seguida. Sem isso o balãozinho vermelho nunca zera e vira ruído
     permanente. Está no novAbrir, e o teste clica pra provar.
     ========================================================================== */
  var NOV_DIAS = 14;     /* item mais velho que isto NÃO aparece — trava contra
                            aviso velho parado na home fazendo o app parecer
                            abandonado. Melhor branco que velho. */
  var NOV_TIPOS = ['novidades','sistema'];
  var _novItens=null, _novQuando=0, _novEmVoo=false;

  function _novEhNovidade(n){ return NOV_TIPOS.indexOf(String((n&&n.tipo)||''))>=0; }
  function _novRecente(n){
    var t=Date.parse((n&&n.criado_em)||'')||0;
    return t>0 && (Date.now()-t) <= NOV_DIAS*864e5;
  }
  function _novData(iso){
    try{ var d=new Date(iso); if(isNaN(d.getTime())) return '';
      return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
    catch(_){ return ''; }
  }

  async function novCarregar(force){
    if(!bhLargo() || _novEmVoo) return;
    if(!force && _novItens && (Date.now()-_novQuando)<BH_CACHE_MS){ novPintar(); return; }
    if(!meuId || !window.supa) return;
    /* o sino já carregou nesta sessão? então não se pede nada ao servidor */
    try{
      if(typeof _notifs!=='undefined' && _notifs && _notifs.length){
        _novItens=_notifs.filter(_novEhNovidade).filter(_novRecente).slice(0,2);
        _novQuando=Date.now(); novPintar(); return;
      }
    }catch(_){ }
    _novEmVoo=true;
    try{
      var r=await supa.from('notificacoes')
        .select('id,tipo,titulo,criado_em,lida')
        .in('tipo',NOV_TIPOS)
        .gte('criado_em',_pdhIso(NOV_DIAS))
        .order('criado_em',{ascending:false}).limit(2);
      if(r && r.error) throw r.error;
      _novItens=((r&&r.data)||[]).filter(_novRecente);
      _novQuando=Date.now();
    }catch(e){ _novItens=null; }   /* falhou: o bloco some, calado */
    _novEmVoo=false;
    novPintar();
  }

  function novPintar(){
    var card=$('bhNov'), lista=$('bhNovLista'), ver=$('bhNovVer');
    if(!card||!lista) return;
    var itens=_novItens;
    /* R5 + a regra dos 14 dias: nenhum item recente → o bloco INTEIRO some */
    if(!itens || !itens.length){ card.hidden=true; return; }
    lista.innerHTML=itens.slice(0,2).map(function(n){
      var tit=String(n.titulo||'').trim() || 'Novidade no app';
      return '<button type="button" class="bh-linha bh-nov'+(n.lida?'':' nlida')+'" data-nov="'+esc(String(n.id||''))+'" '+
        'aria-label="'+esc(tit+'. Abrir as notificações.')+'">'+
        '<span class="bh-data">'+esc(_novData(n.criado_em))+'</span>'+
        '<span class="bh-tx"><b>'+esc(tit)+'</b></span>'+
      '</button>';
    }).join('');
    card.hidden=false;
    Array.prototype.forEach.call(lista.querySelectorAll('.bh-linha'),function(b){
      b.onclick=function(){ novAbrir(b.getAttribute('data-nov')); };
    });
    if(ver) ver.onclick=novVerTudo;
  }

  /* 🔴 marcar lido é o MESMO lido do sino, e o badge é atualizado logo em
     seguida. `.select('id')` porque UPDATE barrado por RLS volta "sucesso"
     com zero linhas (regra do CLAUDE.md desde a v483): sem conferir, a home
     tiraria o destaque de um item que o banco não mudou. */
  async function novAbrir(id){
    if(id){
      try{
        var u=await supa.from('notificacoes').update({lida:true}).eq('id',id).select('id');
        if(u && !u.error && u.data && u.data.length){
          (_novItens||[]).forEach(function(n){ if(String(n.id)===String(id)) n.lida=true; });
          try{ if(typeof _notifs!=='undefined' && _notifs) _notifs.forEach(function(n){ if(String(n.id)===String(id)) n.lida=true; }); }catch(_){}
          try{ novPintar(); }catch(_){}
          try{ notifBadgeAtualiza(); }catch(_){}
        }
      }catch(e){ try{ window.mevErro && window.mevErro(e,'novAbrir'); }catch(_){} }
    }
    novVerTudo();
  }
  function novVerTudo(){ try{ telaNotificacoes(); }catch(e){ try{ window.mevErro && window.mevErro(e,'novVerTudo'); }catch(_){} } }

  /* ==========================================================================
     v789 — O RASTRO DE QUANDO A COLUNA SAI VAZIA
     --------------------------------------------------------------------------
     🔴 POR QUE ISTO EXISTE, E POR QUE NÃO É GAMBIARRA DE DEBUG

     O §5.3 manda estes blocos FALHAREM CALADOS: pendência não é crítica, e
     um recado de erro na home seria pior que a ausência do bloco. A regra
     está certa e continua valendo — pro lojista.

     Só que ela também nos deixou CEGOS. Em 31/08 os três blocos não
     apareceram na tela do Angelo com a v787 confirmada, e nenhuma das
     medidas possíveis de fora explicou: a versão estava no ar, havia
     conteúdo no banco (12 avaliações abertas, 3 repasses novos), a janela
     tinha 1440px, não havia colisão de nomes, as variáveis existiam, a
     sintaxe do or() do PostgREST voltava 200, e o teste-v776 passava com
     21 ✓ num navegador real contra os MESMOS arquivos. Sobrou só o que não
     dá pra ver de fora: o estado real da tela dele.

     Então o "calado" vira "calado pro lojista, não pro conserto": UMA linha
     em mp_erros, no canal que o app já usa desde a v248, quando — e só
     quando — a coluna termina VAZIA num computador largo. Custo por sessão:
     no máximo um insert, nunca dois.

     Isto NÃO é temporário. Um bloco que some sem dizer por quê some de novo
     algum dia; o rastro é o que transforma "não apareceu" numa resposta em
     vez de numa investigação. Quando o defeito de 31/08 for entendido, o
     que sai daqui é o `porque` dele — não o mecanismo.
     ========================================================================== */
  var _bhPorque='';        /* o motivo, quando pdhCarregar tropeça */
  var _bhPasso='';         /* v790: até onde o código chegou (a migalha de pão) */
  var _bhContou=false;     /* uma vez por sessão, e olhe lá */

  function _bhVis(id){
    var e=$(id); if(!e) return 'ausente';
    if(e.hidden) return 'hidden';
    try{ var cs=getComputedStyle(e);
         return cs.display+'/'+cs.visibility+'/'+Math.round(e.getBoundingClientRect().height)+'px'; }
    catch(_){ return '?'; }
  }

  function bhDiagnostico(){
    if(_bhContou) return;
    if(!bhLargo()) return;                       /* celular não conta nada */
    /* só interessa o caso RUIM: nada visível na coluna */
    var algum=['bhPend','bhRede','bhNov'].some(function(id){
      var e=$(id); return e && !e.hidden;
    });
    if(algum) return;                            /* apareceu: nada a relatar */
    _bhContou=true;
    try{
      if(typeof window.mevErro!=='function') return;
      var b=document.body.className||'';
      window.mevErro('blocos-home: coluna vazia', {
        passo:       _bhPasso || '(nem chegou no bhMontar)',
        porque:      _bhPorque || 'sem erro — as contagens vieram zeradas',
        bhBlocos:    _bhVis('bhBlocos'),
        bhPend:      _bhVis('bhPend'),
        bhRede:      _bhVis('bhRede'),
        bhNov:       _bhVis('bhNov'),
        col:         _bhVis('homeHistCol'),
        dados:       _pdhDados ? (_pdhDados.ofertas+'/'+_pdhDados.semFoto+'/'+
                       _pdhDados.avalAbertas+'/'+_pdhDados.consultasMes) : 'null',
        rede:        (typeof _redDados!=='undefined' && _redDados)
                       ? JSON.stringify(_redDados).slice(0,120) : 'null',
        nov:         (typeof _novItens!=='undefined' && _novItens)
                       ? ('n='+_novItens.length) : 'null',
        largura:     window.innerWidth,
        m1280:       bhLargo(),
        appOn:       b.indexOf('app-on')>=0,
        telaInterna: b.indexOf('tela-interna')>=0,
        mdVeiculo:   b.indexOf('md-veiculo')>=0,
        temMeuId:    !!(typeof meuId!=='undefined' && meuId),
        temSupa:     !!window.supa,
        saldo:       (typeof saldo!=='undefined'? saldo : '?'),
        ilim:        !!(typeof ilimitado!=='undefined' && ilimitado)
      });
    }catch(_){ }
  }

/* ╔═══ src/app/05k-proposta-ao-vendedor.js ═══════════════════════════════ */
  /* ==========================================================================
     05k — ENVIAR PROPOSTA AO VENDEDOR (v797)

     🔴 PEDIDO DO ANGELO (31/08, com dois prints da folha de Avaliações):
     "adicione um enviar proposta ao vendedor - abre o campo que tem dentro da
      avaliacao, nome do vendedor e telefone e valor da proposta, quando
      cadastra uma vez, vai pro cadastro de vendedores e lojistas, na proxima
      aparece uma lista em dropdown enquanto digita, com os vendedores e
      lojistas cadastrados"

     ---------------------------------------------------------------------------
     O QUE JÁ EXISTIA (e por isso este módulo NÃO inventa nada novo)
     ---------------------------------------------------------------------------
     Os três campos que ele descreve JÁ existem: são os do "Mandar pro vendedor
     do carro" (v694), lá no fim das Cotações de lojistas, DENTRO da avaliação
     aberta. Pra chegar neles era preciso abrir a avaliação e rolar até o fim.
     O cadastro também já existe: desde a v702 o primeiro envio grava o vendedor
     em `clientes` com origem "Vendedor do carro" (achar-ou-criar pela regra da
     casa — crmFoneChave, os 8 últimos dígitos).

     Então o que falta é uma PORTA e um DROPDOWN:
       · a porta → um item novo na folha do card ("Enviar proposta ao
         vendedor"), que abre os MESMOS campos sem precisar abrir a avaliação;
       · o dropdown → a lista de quem já está cadastrado, enquanto se digita.

     🔴 UM NOME SÓ PRA CADA COISA (v390). As duas portas — a folha do card e o
     card de dentro da avaliação — chamam as MESMAS funções daqui: a mesma
     mensagem (propVendMsg), a mesma gravação (propVendEnviar), o mesmo
     dropdown (propVendAuto). Duas cópias do mesmo texto viram dois textos
     diferentes em três versões; foi assim que a v566 e a v568 fizeram o mesmo
     serviço duas vezes.

     ---------------------------------------------------------------------------
     ⚠️ DECISÃO: NENHUMA TABELA NOVA, NENHUM SQL, NENHUMA RLS MEXIDA
     ---------------------------------------------------------------------------
     "vai pro cadastro de vendedores e lojistas" foi lido como: entra no acervo
     que depois alimenta o dropdown — e esse acervo já são DUAS tabelas que
     existem:
       · `clientes` (a ficha nasce com origem "Vendedor do carro" — v702);
       · `lojistas_repasse` (o cadastro de Rede > Lojistas Repasses).
     Um vendedor NÃO é gravado em `lojistas_repasse`: aquela tabela é de quem
     COMPRA repasse. Escrever vendedor lá sujaria a lista de repasse do Angelo
     — e essa lista é usada pra disparar oferta em massa (13-abrir-avaliacao).

     ⛳ SE UM DIA FOR PRECISO MARCAR "É VENDEDOR" NUMA FICHA QUE JÁ EXISTIA:
     hoje o avtVendCliGrava sai calado quando acha a ficha ("primeira vez SÓ").
     Marcar exigiria UPDATE numa linha do cliente — e aí vale a regra da v483:
     todo update pede a linha de volta (.select('id')) e confere data.length,
     porque UPDATE barrado por RLS volta "sucesso" com ZERO linhas. Enquanto
     isso não existir, o dropdown cobre o caso mostrando o grupo "Clientes"
     como terceira faixa (veja propVendLista) — quem já era cliente aparece
     assim mesmo, com a etiqueta certa.
     ========================================================================== */

  /* ---------- 1. O ACERVO: vendedores, lojistas e (por último) clientes ----- */

  /* a chave que decide se dois contatos são a MESMA pessoa. A régua da casa é
     crmFoneChave (v517: os 8 últimos dígitos, que resolve o nono dígito
     sozinho). Sem telefone, cai no nome em minúsculas. */
  function _pvChave(nome, tel){
    var d=String(tel||'').replace(/\D/g,'');
    try{ if(d && typeof crmFoneChave==='function'){ var k=crmFoneChave(d); if(k) return 'f:'+k; } }catch(_){}
    if(d.length>=8) return 'f:'+d.slice(-8);
    return 'n:'+String(nome||'').trim().toLowerCase();
  }
  function _pvEhVendedor(c){
    /* as duas marcas que o insert da v702 deixa na ficha */
    return String((c||{}).origem||'')==='Vendedor do carro' || !!(c||{}).placa_troca;
  }
  /* carrega o que ainda não está na memória. As duas listas já têm quem as
     carregue (cliCarregar do 12, repCarregar do 19) — aqui só se chama. */
  async function propVendCarregar(){
    try{ if(typeof cliCarregar==='function' && (!window.__pvCli) && !(typeof _clientes!=='undefined' && _clientes && _clientes.length)){ window.__pvCli=1; await cliCarregar(); } }catch(_){}
    try{ if(typeof repCarregar==='function' && (!window.__pvRep) && !(typeof _repasses!=='undefined' && _repasses && _repasses.length)){ window.__pvRep=1; await repCarregar(); } }catch(_){}
  }
  /* O acervo, em TRÊS faixas com ordem de importância. A etiqueta viaja junto
     porque a lista mistura gente de origens diferentes — e o Angelo precisa
     saber, olhando, se aquele "João" é o vendedor do carro ou o lojista. */
  function propVendLista(){
    var out=[], visto={};
    function poe(nome, tel, tipo){
      nome=String(nome||'').trim();
      var dig=String(tel||'').replace(/\D/g,'');
      if(!nome && !dig) return;
      var k=_pvChave(nome, dig);
      if(visto[k]) return;                 /* a faixa de cima ganha: vendedor > lojista > cliente */
      visto[k]=1;
      out.push({ nome:nome, tel:dig, tipo:tipo,
        busca:(nome+' '+dig).toLowerCase() });
    }
    var cli=[]; try{ cli=(typeof _clientes!=='undefined' && _clientes)?_clientes:[]; }catch(_){ cli=[]; }
    var rep=[]; try{ rep=(typeof _repasses!=='undefined' && _repasses)?_repasses:[]; }catch(_){ rep=[]; }
    cli.filter(_pvEhVendedor).forEach(function(c){ poe(c.nome, c.telefone, 'vendedor'); });
    rep.forEach(function(c){ poe(c.nome, c.telefone, 'lojista'); });
    cli.filter(function(c){ return !_pvEhVendedor(c); }).forEach(function(c){ poe(c.nome, c.telefone, 'cliente'); });
    return out;
  }
  var PV_MAX=6;                            /* ⛳ quantas linhas o dropdown mostra */
  function propVendFiltra(termo){
    termo=String(termo||'').trim().toLowerCase();
    var digs=termo.replace(/\D/g,'');
    var todos=propVendLista();
    if(!termo) return todos.slice(0,PV_MAX);
    var achou=todos.filter(function(x){
      if(digs.length>=3 && x.tel.indexOf(digs)>=0) return true;
      return x.busca.indexOf(termo)>=0;
    });
    /* quem COMEÇA com o que foi digitado vem antes de quem só contém */
    achou.sort(function(a,b){
      var pa=a.nome.toLowerCase().indexOf(termo)===0?0:1;
      var pb=b.nome.toLowerCase().indexOf(termo)===0?0:1;
      return pa-pb;
    });
    return achou.slice(0,PV_MAX);
  }

  /* ---------- 2. O DROPDOWN (combobox de verdade, com teclado) -------------- */

  var _PV_TAG={ vendedor:'Vendedor', lojista:'Lojista', cliente:'Cliente' };
  /* Liga o dropdown num par de campos (nome, telefone). Digitar em QUALQUER um
     dos dois filtra — o Angelo tanto lembra o nome quanto o número. Escolher
     preenche OS DOIS.
     ⚠️ o painel mora dentro de um .pv-ac (position:relative) que embrulha o
     campo: assim ele rola junto com a folha em vez de ficar boiando no lugar
     errado quando o miolo rola. */
  function propVendAuto(inpNome, inpTel){
    if(!inpNome) return;
    var pai=inpNome.parentNode; if(!pai) return;
    if(pai.querySelector('.pv-pop')) return;                 /* já ligado */
    try{ pai.classList.add('pv-ac'); }catch(_){}
    var pop=document.createElement('div');
    pop.className='pv-pop'; pop.setAttribute('role','listbox'); pop.hidden=true;
    pop.id='pvPop_'+(inpNome.id||('x'+Math.random().toString(36).slice(2,7)));
    pai.appendChild(pop);
    inpNome.setAttribute('role','combobox');
    inpNome.setAttribute('aria-autocomplete','list');
    inpNome.setAttribute('aria-expanded','false');
    inpNome.setAttribute('aria-controls',pop.id);
    inpNome.setAttribute('autocomplete','off');
    var itens=[], i=-1;

    function fecha(){
      pop.hidden=true; pop.innerHTML=''; itens=[]; i=-1;
      inpNome.setAttribute('aria-expanded','false');
      inpNome.removeAttribute('aria-activedescendant');
    }
    function marca(){
      Array.prototype.forEach.call(pop.children, function(el,n){
        var on=(n===i); el.classList.toggle('on',on); el.setAttribute('aria-selected',on?'true':'false');
        if(on){ inpNome.setAttribute('aria-activedescendant',el.id); try{ el.scrollIntoView({block:'nearest'}); }catch(_){} }
      });
      if(i<0) inpNome.removeAttribute('aria-activedescendant');
    }
    function escolhe(x){
      if(!x) return;
      inpNome.value=x.nome||inpNome.value;
      if(inpTel && x.tel) inpTel.value=(typeof foneFmt==='function')?foneFmt(x.tel):x.tel;
      fecha();
      try{ inpNome.dispatchEvent(new Event('change')); }catch(_){}
      try{ (inpTel||inpNome).focus(); }catch(_){}
    }
    function abre(termo){
      itens=propVendFiltra(termo);
      if(!itens.length){ fecha(); return; }
      pop.innerHTML=itens.map(function(x,n){
        var tel=(typeof foneFmt==='function' && x.tel)?foneFmt(x.tel):x.tel;
        return '<div class="pv-op" role="option" aria-selected="false" id="'+pop.id+'_'+n+'" data-n="'+n+'">'+
          '<span class="pv-op-nm">'+esc(x.nome||tel||'—')+'</span>'+
          (tel?('<span class="pv-op-tel">'+esc(tel)+'</span>'):'')+
          '<span class="pv-op-tag '+x.tipo+'">'+_PV_TAG[x.tipo]+'</span></div>';
      }).join('');
      pop.hidden=false; i=-1;
      inpNome.setAttribute('aria-expanded','true');
      /* mousedown, não click: o blur do campo fecharia o painel antes do click */
      Array.prototype.forEach.call(pop.children, function(el){
        el.onmousedown=function(e){ e.preventDefault(); escolhe(itens[Number(el.getAttribute('data-n'))]); };
      });
    }
    function digitou(){ propVendCarregar().then(function(){ abre(inpNome===document.activeElement?inpNome.value:(inpTel&&inpTel.value)||''); }); }
    /* 🔴 O BLUR NÃO PODE FECHAR QUANDO O FOCO SÓ PULOU PRO CAMPO IRMÃO.
       Os DOIS campos são a mesma caixa de busca (nome e telefone). Fechando
       no blur seco, digitar o nome e ir pro WhatsApp matava a lista no meio —
       e pior: o temporizador de 120ms disparava DEPOIS de o campo do telefone
       já ter reaberto o painel, então a lista aparecia e sumia sozinha. */
    function saiu(){
      setTimeout(function(){
        var f=null; try{ f=document.activeElement; }catch(_){}
        if(f===inpNome || (inpTel && f===inpTel)) return;
        if(f && pop.contains(f)) return;
        fecha();
      },120);
    }
    /* reabrir: tocar de novo no campo já focado NÃO dispara `focus`. Sem o
       clique aqui, quem fechasse a lista com Escape teria de apagar e
       redigitar pra vê-la de novo. */
    function reabre(){ propVendCarregar().then(function(){ abre(inpNome.value); }); }
    inpNome.addEventListener('input', digitou);
    /* ⚠️ ABRE NO CLIQUE, NÃO NO FOCO. A folha da proposta já chega com o nome
       preenchido (o bilhete da placa) e põe o foco no campo: no `focus` a
       lista abriria sozinha toda vez que a folha abrisse, tapando o campo do
       WhatsApp logo abaixo. Quem quer a lista toca no campo, digita, ou usa a
       seta pra baixo. */
    inpNome.addEventListener('click', reabre);
    inpNome.addEventListener('blur', saiu);
    if(inpTel){
      inpTel.addEventListener('input', function(){
        var d=String(inpTel.value||'').replace(/\D/g,'');
        if(d.length<3){ fecha(); return; }
        propVendCarregar().then(function(){ abre(d); });
      });
      inpTel.addEventListener('blur', saiu);
    }
    function teclas(e){
      /* com a lista fechada, a seta pra baixo ABRE — é o gesto que todo
         combobox tem, e é como se volta atrás de um Escape sem apagar nada */
      if(pop.hidden){
        if(e.key==='ArrowDown'){ e.preventDefault(); reabre(); }
        return;
      }
      if(e.key==='ArrowDown'){ e.preventDefault(); i=(i+1)%itens.length; marca(); return; }
      if(e.key==='ArrowUp'){ e.preventDefault(); i=(i<=0?itens.length:i)-1; marca(); return; }
      if(e.key==='Enter' && i>=0){ e.preventDefault(); e.stopPropagation(); escolhe(itens[i]); return; }
      /* Escape fecha o DROPDOWN e para aí. Dentro da folha do 05k quem chega
         primeiro é o ouvinte de captura dela (veja `aberto` abaixo); este aqui
         é o que atende o card de DENTRO da avaliação, que não tem folha. */
      if(e.key==='Escape'){ e.preventDefault(); e.stopPropagation(); fecha(); return; }
    }
    inpNome.addEventListener('keydown', teclas);
    if(inpTel) inpTel.addEventListener('keydown', teclas);
    /* `aberto` existe por causa da ORDEM DOS OUVINTES: a folha escuta Escape
       em CAPTURA no document, então ela é avisada ANTES do campo — o
       stopPropagation daqui chegaria tarde e a folha inteira fecharia junto
       com o dropdown. Quem manda no Escape é a folha; ela pergunta aqui se o
       painel está aberto e, se estiver, fecha só ele. */
    return { fecha:fecha, aberto:function(){ return !pop.hidden; } };
  }

  /* ---------- 3. A MENSAGEM E O ENVIO (uma vez só, pras duas portas) -------- */

  /* ⛳ O TEXTO DA PROPOSTA MORA AQUI — e só aqui. Mudar esta linha muda o que
     sai pelas duas portas. É o texto da v694, que o Angelo usa desde 28/08. */
  function propVendMsg(nome, carro, placa, valor){
    return (nome?('Olá, '+nome+'!'):'Olá!')+' Sobre o '+(carro||'o veículo')+
      (placa?(' ('+placa+')'):'')+': consegui R$ '+Number(valor||0).toLocaleString('pt-BR')+
      ' de avaliação. Podemos conversar?';
  }
  /* Valida, guarda o bilhete (aparelho + nuvem), manda pro cadastro e ABRE o
     WhatsApp com o texto pronto. 🔴 NUNCA envia sozinho — quem aperta enviar é
     o Angelo, lá no WhatsApp (a mesma regra do v292 e do v694).
     Devolve true/false pra quem chamou saber se pode fechar a folha. */
  function propVendEnviar(o){
    o=o||{};
    var nome=String(o.nome||'').trim();
    var dig=String(o.tel||'').replace(/\D/g,'');
    var n=Number(o.valor||0);
    var pl=String(o.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(dig.length<10 || dig.length>11){ toast('Confira o WhatsApp — são 10 ou 11 dígitos com o DDD.'); return false; }
    if(!n){ toast('Coloque o valor da proposta.'); return false; }
    /* o bilhete da placa aprende o que foi corrigido aqui (v691: um lugar só) */
    try{ localStorage.setItem('mev_avcli:'+pl, JSON.stringify({ nome:nome, tel:dig })); }catch(_){}
    try{ docHistCloudSave('aval_cli', pl, 'cli', { nome:nome, tel:dig }, Date.now()); }catch(_){}
    try{ avtVendCliGrava(nome, dig, pl, o.carro||''); }catch(_){}    /* v702 — o cadastro */
    var txt=propVendMsg(nome, o.carro, pl, n);
    var u='https://wa.me/'+(dig.length<=11?('55'+dig):dig)+'?text='+encodeURIComponent(txt);
    try{ if(typeof mevIrProWhats==='function'){ mevIrProWhats(u); return true; } }catch(_){}
    try{ window.open(u,'_blank','noopener'); }catch(_){ location.href=u; }
    return true;
  }
  /* o bilhete da placa: aparelho primeiro, nuvem depois (o import pode ter
     acontecido no OUTRO aparelho — foi o buraco que a v702 fechou) */
  function _pvBilhete(pl, cb){
    var bil=null; try{ bil=JSON.parse(localStorage.getItem('mev_avcli:'+pl)||'null'); }catch(_){ bil=null; }
    cb(bil||{});
    if(bil && bil.nome && bil.tel) return;
    try{ docHistCloudLoadOne('aval_cli', pl, function(x){ if(x) cb(x); }); }catch(_){}
  }

  /* ---------- 4. A PORTA NOVA: a folha "Enviar proposta ao vendedor" -------- */

  /* Abre os MESMOS três campos da avaliação, sem precisar abrir a avaliação.
     A caixa reusa as classes .avm-* da folha do card (v723) — mesmo desenho,
     mesmo comportamento de teclado, zero CSS novo além do dropdown. */
  function propVendAbrir(placa){
    placa=_avlKey(placa);
    var a=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===placa; })[0]||{};
    var carro=_avlModelo(a.modelo||'Veículo');
    var valor=_avlValorDe(placa, a);
    var velho=$('pvBg'); if(velho) velho.parentNode.removeChild(velho);
    var _veioDe=null; try{ _veioDe=document.activeElement; }catch(_){}
    var bg=document.createElement('div'); bg.id='pvBg'; bg.className='cropmask avm-mask';
    bg.innerHTML='<div class="cropbox avm-box pv-box com-rodape" role="dialog" aria-modal="true" aria-labelledby="pvTit" tabindex="-1">'+
      '<div class="avm-head">'+
        '<div class="avm-head-tx">'+
          '<div class="avm-tit" id="pvTit">Enviar proposta ao vendedor</div>'+
          '<div class="avm-sub"><span class="avm-placa">'+esc(placa)+'</span>'+
            '<span class="avm-sit">'+esc(carro)+'</span></div>'+
        '</div>'+
        '<button type="button" class="avm-x" id="pvFechar" aria-label="Fechar">'+_AVM_ICO_X+'</button>'+
      '</div>'+
      '<div class="avm-body">'+
        '<div class="pv-sub">O valor que você conseguiu, direto no WhatsApp de quem está vendendo o carro. '+
          'Nada sai sem você apertar enviar lá.</div>'+
        '<div class="avx-campo"><label for="pvNome">Nome do vendedor</label>'+
          '<input id="pvNome" class="avt-in" placeholder="Quem está vendendo"></div>'+
        '<div class="avx-campo"><label for="pvTel">WhatsApp</label>'+
          '<input id="pvTel" class="avt-in" inputmode="tel" placeholder="(00) 00000-0000"></div>'+
        '<div class="avx-campo"><label for="pvValor">Valor da proposta (R$)</label>'+
          '<input id="pvValor" class="avt-in" inputmode="numeric" placeholder="R$ 0"></div>'+
      '</div>'+
      '<div class="avm-foot"><div class="avm-foot-acts">'+
        '<button type="button" class="crop-c" id="pvCancelar">Cancelar</button>'+
        '<button type="button" class="crop-ok" id="pvEnviar">Mandar no WhatsApp</button>'+
      '</div></div>'+
    '</div>';
    document.body.appendChild(bg);
    var _box=bg.querySelector('.avm-box');

    /* o que já se sabe desta placa entra pronto (e a nuvem completa depois) */
    _pvBilhete(placa, function(b){
      var n=$('pvNome'), t=$('pvTel');
      if(n && !String(n.value||'').trim() && b.nome) n.value=b.nome;
      if(t && !String(t.value||'').trim() && b.tel) t.value=(typeof foneFmt==='function')?foneFmt(b.tel):b.tel;
    });
    if(valor>0) $('pvValor').value=_avlRs(valor);
    (function(){ var tl=$('pvTel'); if(tl && typeof foneFmt==='function') tl.oninput=function(){ this.value=foneFmt(this.value); }; })();
    _avlMaskRs($('pvValor'));
    var _ac=propVendAuto($('pvNome'), $('pvTel'));
    propVendCarregar();                     /* aquece o acervo antes do primeiro toque */

    function fechar(){
      try{ bg.parentNode.removeChild(bg); }catch(_){}
      try{ document.removeEventListener('keydown', _teclas, true); }catch(_){}
      try{ if(_veioDe && document.contains(_veioDe)) _veioDe.focus({ preventScroll:true }); }catch(_){}
    }
    /* foco preso na folha e Escape — a mesma régua da v725 */
    function _focaveis(){
      return Array.prototype.filter.call(_box.querySelectorAll('button,input,[tabindex]:not([tabindex="-1"])'), function(el){
        if(el.disabled) return false;
        var r=el.getBoundingClientRect(); return r.width>0 && r.height>0;
      });
    }
    function _teclas(e){
      if(!document.contains(bg)) return;
      if(e.key==='Escape'){
        e.preventDefault(); e.stopPropagation();
        /* 🔴 uma folha, dois Escapes: o primeiro fecha o dropdown, o segundo
           fecha a folha. Sem isso, escolher errado na lista e apertar Escape
           jogaria fora o que já estava digitado. */
        if(_ac && _ac.aberto()){ _ac.fecha(); return; }
        fechar(); return;
      }
      if(e.key!=='Tab') return;
      var f=_focaveis(); if(!f.length){ e.preventDefault(); _box.focus(); return; }
      var n=f.indexOf(document.activeElement);
      if(e.shiftKey){ if(n<=0){ e.preventDefault(); f[f.length-1].focus(); } }
      else { if(n<0 || n===f.length-1){ e.preventDefault(); f[0].focus(); } }
    }
    document.addEventListener('keydown', _teclas, true);
    bg.addEventListener('mousedown', function(e){ if(e.target===bg) fechar(); });
    $('pvFechar').onclick=fechar;
    $('pvCancelar').onclick=fechar;
    $('pvEnviar').onclick=function(){
      var ok=propVendEnviar({ nome:$('pvNome').value, tel:$('pvTel').value,
        valor:_avlSoNum($('pvValor').value), placa:placa, carro:carro });
      if(ok) fechar();
    };
    try{ $('pvNome').focus({ preventScroll:true }); }catch(_){}
  }

/* ╔═══ src/app/05l-compra-do-veiculo.js ══════════════════════════════════ */
  /* ==========================================================================
     05l — COMPRA DO VEÍCULO: A PÁGINA E O CONTRATO (v799)

     🔴 PEDIDO DO ANGELO (31/08, com dois prints da lista de Avaliações):
     "adicione um comprado - que leva pra uma pagina de compra - pra anexar os
      dados do cliente que vendeu e do lojista que comprou e gerar um contrato
      de compra e venda - aproveite a estrutura da pagina de vendas, quando foi
      vendido é gerado um contrato - tem uma aba pra anexar os documentos,
      outra pros termos da negociacao valores, quilometragem, e um gerador de
      contrato"

     ---------------------------------------------------------------------------
     🔴 O QUE ESTA PÁGINA É — E POR QUE ELA NÃO É A PÁGINA DE VENDA ESPELHADA
     ---------------------------------------------------------------------------
     A página de venda (17-vendas) é a loja VENDENDO ao consumidor. Aqui a loja
     COMPRA de uma pessoa física. Não é a mesma coisa com os nomes trocados:
       · lá o comprador é consumidor e o contrato carrega garantia, benefícios
         inclusos e obrigações do comprador (CDC). Aqui não existe nada disso:
         quem vende é o dono do carro, e a loja é a parte profissional;
       · lá o que interessa é a entrada, o financiamento e as parcelas. Aqui o
         que interessa é o valor pago, a forma, os débitos, o gravame e a
         QUILOMETRAGEM — que é o número que o vendedor DECLARA e que protege a
         loja depois;
       · lá o carro sai do estoque. Aqui ele ENTRA.
     Por isso a estrutura (abas .vpx, painéis, o jeito de gravar) é a mesma —
     esse era o pedido — e o conteúdo é próprio.

     ---------------------------------------------------------------------------
     ⚠️ DECISÃO: NENHUMA TABELA NOVA, NENHUM SQL, NENHUMA RLS MEXIDA
     ---------------------------------------------------------------------------
     A compra mora em `doc_consulta`, tipo `aval_compra`, chave = a placa —
     exatamente o padrão que a v685 escolheu pro `aval_card` (dado do NEGÓCIO,
     não do formulário de vistoria), com espelho local e a nuvem ganhando
     quando é mais nova. Isso mantém esta versão inteira no frontend: sem
     migration, sem política nova, sem janela de risco no banco.
     ⛳ Se um dia a compra virar tabela própria (relatório, busca por vendedor,
     conferência fiscal), a migração é direta: cada registro daqui é um objeto
     fechado com placa, vendedor, veículo, termos e documentos.

     ⚠️ AS FOTOS DOS DOCUMENTOS NÃO MORAM NO REGISTRO. Vão pro cofre privado
     (arqUpload → referência), e só a referência fica guardada. É a lição da
     v592: foto dentro do jsonb faz TODA abertura do app baixar as fotos de
     todo mundo (medido lá: 1,1 MB por abertura, por causa de três vendas).
     ========================================================================== */

  var _cprCache=null;          /* espelho local, placa -> registro */
  var _cprAtual=null;          /* o registro aberto na tela */
  var _cprPlaca='';
  /* v804 §5 — a página abre nos DOCUMENTOS. Os arquivos são a conferência
     inicial da compra; ninguém deve atravessar formulário pra achar onde
     anexa o CRLV. */
  var _cprTab='docs';
  var _cprLoja=null;

  function _cprLer(){ try{ return JSON.parse(localStorage.getItem('mev_avl_compra')||'{}')||{}; }catch(_){ return {}; } }
  function _cprGravaLocal(){ try{ localStorage.setItem('mev_avl_compra', JSON.stringify(_cprCache||{})); }catch(_){} }
  function compraDe(placa){ if(!_cprCache) _cprCache=_cprLer(); return _cprCache[_avlKey(placa)]||null; }
  function compraExiste(placa){ var c=compraDe(placa); return !!(c && (c.termos||c.vendedor)); }

  /* o registro em branco, já com o que o app JÁ SABE deste carro — ninguém
     redigita o que a avaliação e o bilhete do vendedor (v691/v702/v797) têm */
  function _cprNovo(placa){
    var a=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===placa; })[0]||{};
    var h=null; try{ h=_avlDoHistorico(placa); }catch(_){ h=null; }
    var v=(h&&h.v)||{};
    var bil={}; try{ bil=JSON.parse(localStorage.getItem('mev_avcli:'+placa)||'{}')||{}; }catch(_){ bil={}; }
    var km=0; try{ km=_avlKmDe(placa); }catch(_){ km=0; }
    return {
      _ts:Date.now(),
      /* 🔴 v821 — os campos novos do contrato (CNH, filiação, conta do
         vendedor, o resto do CRLV e a testemunha). Tudo que a CONSULTA da
         placa já trouxe entra sozinho: espécie, cilindrada, potência e
         município saem do mesmo objeto que a ficha técnica usa (06), e
         redigitar o que já foi pago pra saber é o desperdício que este app
         existe pra acabar. */
      vendedor:{ nome:String(bil.nome||''), fone:String(bil.tel||''), cpf:'', rg:'', nasc:'',
                 rua:'', numero:'', bairro:'', cidade:'', uf:'', cep:'',
                 cnh:'', filiacao:'' },
      veiculo:{ placa:placa,
                marca:String(v.marca||''),
                modelo:String(a.modelo||v.modelo||''),
                ano:String(a.ano||v.ano||''),
                cor:String(a.cor||v.cor||''),
                km:km||0, renavam:String(v.renavam||''), chassi:String(v.chassi||''),
                combustivel:String(v.combustivel||''),
                ano_modelo:String(v.ano_modelo||''),
                especie:String(v.especie||''),
                categoria:'',
                motor:String(v.motor||''),
                potencia:[String(v.potencia||''),String(v.cilindrada||'')].filter(Boolean).join(' cv / ')+(v.cilindrada?' cc':''),
                municipio:[String(v.municipio||''),String(v.uf||'')].filter(Boolean).join(' / '),
                licenciado:'', ipva_sit:'', detran:'' },
      termos:{ valor:(function(){ try{ return _avlValorDe(placa,a)||0; }catch(_){ return 0; } })(),
               forma:'', sinal:0, data:'', quitacao:'', debitos:'', gravame:'nao', obs:'',
               banco:'', agencia:'', conta:'', pix:'', titular:'',
               retirada_data:'', retirada_hora:'',
               estoque:true },
      testemunha:{ nome:'', cargo:'', cpf:'' },
      docs:{},
      extras_docs:[],
      estoque_id:''
    };
  }

  /* ---------- gravar: aparelho + nuvem, com a régua de sempre ------------- */
  /* 🔴 v821 — REGISTRO ANTIGO NÃO PODE QUEBRAR.
     Toda compra salva antes desta versão está no localStorage e na nuvem sem
     os campos novos. Ler `t.banco` de um registro de ontem devolve undefined,
     e `undefined` impresso num contrato é a palavra "undefined" no papel.
     Esta função completa o que falta, sem tocar no que já existe. */
  function _cprCompleta(r){
    if(!r) return r;
    r.vendedor=r.vendedor||{}; r.veiculo=r.veiculo||{}; r.termos=r.termos||{};
    ['cnh','filiacao'].forEach(function(k){ if(r.vendedor[k]==null) r.vendedor[k]=''; });
    ['ano_modelo','especie','categoria','motor','potencia','municipio','licenciado','ipva_sit','detran']
      .forEach(function(k){ if(r.veiculo[k]==null) r.veiculo[k]=''; });
    ['banco','agencia','conta','pix','titular','retirada_data','retirada_hora']
      .forEach(function(k){ if(r.termos[k]==null) r.termos[k]=''; });
    if(!r.testemunha) r.testemunha={ nome:'', cargo:'', cpf:'' };
    if(!Array.isArray(r.extras_docs)) r.extras_docs=[];   /* v825 */
    return r;
  }

  function cprGravar(){
    if(!_cprAtual || !_cprPlaca) return;
    _cprAtual._ts=Date.now();
    if(!_cprCache) _cprCache=_cprLer();
    _cprCache[_cprPlaca]=_cprAtual;
    _cprGravaLocal();
    try{ docHistCloudSave('aval_compra', _cprPlaca, 'compra', _cprAtual, _cprAtual._ts); }catch(_){}
    var ind=$('cprSave');
    if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo';
      clearTimeout(cprGravar._t);
      cprGravar._t=setTimeout(function(){ var i=$('cprSave'); if(i&&i.classList.contains('ok')){ i.className='cad-autosave vazio'; i.textContent=''; } },2200); }
  }
  var _cprTimer=null;
  function cprAgenda(){
    var ind=$('cprSave'); if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; }
    clearTimeout(_cprTimer); _cprTimer=setTimeout(function(){ cprLe(); cprGravar(); },650);
  }
  async function cprCarregarNuvem(placa){
    return new Promise(function(res){
      var pronto=false;
      var t=setTimeout(function(){ if(!pronto){ pronto=true; res(null); } },6000);
      try{
        docHistCloudLoadOne('aval_compra', placa, function(o){
          if(pronto) return; pronto=true; clearTimeout(t); res(o||null);
        });
      }catch(_){ if(!pronto){ pronto=true; clearTimeout(t); res(null); } }
    });
  }

  /* ---------- a tela ------------------------------------------------------ */
  /* ==========================================================================
     v804 (PROJETO-2026-08-31-compra-veiculo-documentos-primeiro-grade-fixa)
     §3.1 A ORDEM MUDOU e §4 os títulos viraram substantivos curtos com uma
     linha de apoio. Documentos vem primeiro porque é o que se procura ao
     abrir a compra; os formulários vêm depois.
     Cada linha: [chave, título, ícone, apoio]
     ========================================================================== */
  /* 🔴 v825 (pedido do Angelo) — A ABA VEÍCULO NASCEU.
     Os dados do carro moravam DENTRO de Termos, junto com forma de pagamento
     e declarações. Eram dois assuntos numa aba só: conferir o carro contra o
     CRLV é uma coisa; combinar como se paga é outra, e quem faz cada uma
     costuma ser um momento diferente do dia.
     A quilometragem, o valor e as observações vieram junto — é o que se
     confere COM O CARRO NA FRENTE. */
  var _CPR_TABS=[
    ['docs','Documentos','clipe','Anexar arquivos'],
    ['partes','Partes','pessoas','Vendedor e comprador'],
    ['veiculo','Veículo','carro','Conferir e medir'],
    ['termos','Termos','dinheiro','Valores e condições'],
    ['contrato','Contrato','papel','Revisar e gerar']
  ];
  var _CPR_ICO={
    carro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11"/><path d="M3 11h18v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><circle cx="7.5" cy="14" r="1"/><circle cx="16.5" cy="14" r="1"/></svg>',
    pessoas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    dinheiro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    clipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>',
    papel:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>'
  };
  /* os documentos que uma compra de pessoa física pede. ⛳ mexer aqui muda a
     aba inteira — a lista é a fonte, não o HTML. */
  /* [chave, título, apoio, leitor de IA]
     🔴 v825 — O 4º CAMPO É O LEITOR. Até a v824 esta aba só ANEXAVA arquivo;
     o comentário logo abaixo dizia isso com todas as letras, e estava certo
     enquanto não havia leitura. Agora há: o MEV_IA (mev-ia-importar.js) já
     lê CNH, cartão CNPJ, comprovante de residência e CRLV — é o mesmo motor
     que a aba de anexos da Venda usa desde a v305. Não escrevi leitor novo:
     liguei o que existia.
     · 'cnh' tem DOIS leitores porque o vendedor pode ser pessoa OU empresa
       (pedido do Angelo). Quem escolhe é ele, no toque. */
  var _CPR_DOCS=[
    ['crlv','CRLV do veículo','O documento do carro, com placa, renavam e chassi','crlv'],
    ['cnh','Documento do vendedor','CNH, RG + CPF ou cartão CNPJ de quem está vendendo','pessoa_ou_empresa'],
    ['res','Comprovante de residência','No nome do vendedor, dos últimos 3 meses','residencia'],
    ['recibo','Recibo / ATPV-e assinado','A prova da transferência',''],
    ['outros','Outros papéis','Laudo, procuração, o que mais vier','']
  ];
  /* os documentos que VOCÊ criou (v825) — ficam no registro da compra */
  function _cprDocsLista(){
    var extra=((_cprAtual&&_cprAtual.extras_docs)||[]).map(function(x){
      return [String(x.k), String(x.titulo||'Documento'), 'Documento que você adicionou', ''];
    });
    return _CPR_DOCS.concat(extra);
  }

  function _cprCampo(id, rot, val, ph, tipo){
    return '<label class="cad-lbl" for="'+id+'">'+esc(rot)+'</label>'+
      '<input class="cad-in" id="'+id+'"'+(tipo?(' inputmode="'+tipo+'"'):'')+
      ' autocomplete="off" value="'+esc(val==null?'':String(val))+'" placeholder="'+esc(ph||'')+'">';
  }
  function _cprDupla(a,b){ return '<div class="cli-2col"><div>'+a+'</div><div>'+b+'</div></div>'; }
  function _cprDin(id, rot, val){
    return '<label class="cad-lbl" for="'+id+'">'+esc(rot)+'</label>'+
      '<input class="cad-in" id="'+id+'" inputmode="numeric" autocomplete="off" value="'+
      esc(Number(val)?('R$ '+Number(val).toLocaleString('pt-BR')):'')+'" placeholder="R$ 0">';
  }

  function _cprPartesHtml(){
    var s=_cprAtual.vendedor, lj=_cprLoja||{};
    var t0=_cprAtual.termos||{}, tw=_cprAtual.testemunha||{};
    var nomeLoja=lj.nome_fantasia||lj.razao_social||meuNome||'Minha loja';
    return '<div class="cad-sec"><h3>Quem vendeu (o dono do carro)</h3>'+
      '<div class="cpr-hint">É o CLIENTE. Estes dados vão para o contrato — confira o CPF e o endereço com o documento na mão.</div>'+
      _cprCampo('cprVNome','Nome completo',s.nome,'Como está no documento')+
      _cprDupla(_cprCampo('cprVCpf','CPF',s.cpf,'000.000.000-00','numeric'),
                _cprCampo('cprVRg','RG',s.rg,''))+
      _cprDupla(_cprCampo('cprVFone','WhatsApp',(typeof foneFmt==='function'&&s.fone)?foneFmt(s.fone):s.fone,'(00) 00000-0000','tel'),
                _cprCampo('cprVNasc','Nascimento',s.nasc,'dd/mm/aaaa'))+
      /* v821: CNH e filiação entram no contrato quando preenchidas, e ficam
         de fora quando não — campo vazio não vira linha em branco no papel */
      _cprDupla(_cprCampo('cprVCnh','CNH (opcional)',s.cnh,'Nº, categoria e validade'),
                _cprCampo('cprVFil','Filiação (opcional)',s.filiacao,'Pai e mãe'))+
      _cprDupla(_cprCampo('cprVRua','Rua',s.rua,''),
                _cprCampo('cprVNum','Número',s.numero,''))+
      _cprDupla(_cprCampo('cprVBairro','Bairro',s.bairro,''),
                _cprCampo('cprVCep','CEP',s.cep,'','numeric'))+
      _cprDupla(_cprCampo('cprVCidade','Cidade',s.cidade,''),
                _cprCampo('cprVUf','UF',s.uf,''))+
      '<button type="button" class="btn-sec-lb" id="cprDoCadastro">Puxar de um cliente já cadastrado</button>'+
      '<div id="cprCliLista"></div>'+
      '</div>'+
      '<div class="cad-sec"><h3>Quem comprou (a loja)</h3>'+
      '<div class="cpr-hint">Vem de <b>Minha loja</b>. Está errado ou faltando? Corrija lá — assim vale para todos os contratos, não só para este.</div>'+
      '<div class="cpr-loja">'+
        '<div class="cpr-loja-l"><b>'+esc(nomeLoja)+'</b>'+
          (lj.cnpj?('<span>CNPJ '+esc(lj.cnpj)+'</span>'):'<span class="falta">sem CNPJ cadastrado</span>')+
          (lj.cidade?('<span>'+esc([lj.cidade,lj.uf].filter(Boolean).join('/'))+'</span>'):'')+
          ((lj.rua||lj.endereco)?('<span>'+esc(String(lj.rua||lj.endereco||''))+'</span>'):'')+
        '</div>'+
      '</div></div>'+
      /* ==================================================================
         🔴 v821 — A CONTA DO VENDEDOR
         O dinheiro sai daqui, e é o único lugar do negócio onde um erro de
         digitação vira prejuízo direto. Por isso o TITULAR é campo próprio,
         e o contrato compara o titular com o nome do vendedor: quando são
         pessoas diferentes, o papel diz isso em voz alta em vez de deixar
         passar. Conta de terceiro não é proibida — é uma decisão que
         precisa estar escrita.
         ================================================================== */
      '<div class="cad-sec"><h3>Conta do vendedor para o pagamento</h3>'+
      '<div class="cpr-hint">Confira com o comprovante na mão. Se o titular não for o vendedor, o contrato registra a autorização.</div>'+
      _cprDupla(_cprCampo('cprBanco','Banco',t0.banco,'Ex.: Bradesco (237)'),
                _cprCampo('cprAgencia','Agência',t0.agencia,''))+
      _cprDupla(_cprCampo('cprConta','Conta',t0.conta,''),
                _cprCampo('cprPix','Chave PIX',t0.pix,'CPF, telefone, e-mail…'))+
      _cprCampo('cprTitular','Titular da conta',t0.titular,'Vazio = o próprio vendedor')+
      '</div>'+
      '<div class="cad-sec"><h3>Testemunha</h3>'+
      '<div class="cpr-hint">Sai impressa na linha de assinatura. A segunda testemunha fica em branco, pra assinar na hora.</div>'+
      _cprDupla(_cprCampo('cprTNome','Nome',tw.nome,'Quem assina por você'),
                _cprCampo('cprTCargo','Cargo',tw.cargo,'Ex.: Consultor de vendas'))+
      _cprCampo('cprTCpf','CPF da testemunha',tw.cpf,'000.000.000-00','numeric')+
      '</div>';
  }

  function _cprVeicHtml(){
    var v=_cprAtual.veiculo;
    return '<div class="cad-sec"><h3>O veículo</h3>'+
      '<div class="cpr-hint">Um caractere errado no chassi e o contrato não bate com o documento. Confira pelo CRLV.</div>'+
      _cprDupla(_cprCampo('cprPlaca','Placa',v.placa,''),
                _cprCampo('cprRenavam','Renavam',v.renavam,'','numeric'))+
      _cprCampo('cprChassi','Chassi',v.chassi,'')+
      _cprDupla(_cprCampo('cprMarca','Marca',v.marca,''),
                _cprCampo('cprModelo','Modelo',v.modelo,''))+
      _cprDupla(_cprCampo('cprAno','Ano',v.ano,''),
                _cprCampo('cprCor','Cor',v.cor,''))+
      _cprDupla(_cprCampo('cprKm','Quilometragem',v.km?Number(v.km).toLocaleString('pt-BR'):'','','numeric'),
                _cprCampo('cprComb','Combustível',v.combustivel,''))+
      '</div>'+
      /* v821: o resto do CRLV. Espécie, potência/cilindrada e município JÁ
         vêm da consulta da placa — quem preenche à mão é só o que a consulta
         não devolve. */
      '<details class="cad-sec cpr-mais"><summary><h3>Mais dados do CRLV</h3></summary>'+
      '<div class="cpr-hint">O que a consulta da placa já trouxe entra sozinho. O resto é do documento em papel — e cada campo vazio simplesmente não aparece no contrato.</div>'+
      _cprDupla(_cprCampo('cprAnoMod','Ano modelo',v.ano_modelo,''),
                _cprCampo('cprEspecie','Espécie / tipo',v.especie,'Ex.: Misto / Camioneta'))+
      _cprDupla(_cprCampo('cprCateg','Categoria',v.categoria,'Ex.: Particular'),
                _cprCampo('cprMotor','Motor',v.motor,''))+
      _cprDupla(_cprCampo('cprPot','Potência / cilindrada',v.potencia,''),
                _cprCampo('cprMunic','Registrado em',v.municipio,'Cidade / UF'))+
      _cprDupla(_cprCampo('cprLic','Licenciamento válido até',v.licenciado,'dd/mm/aaaa'),
                _cprCampo('cprIpvaS','Situação do IPVA',v.ipva_sit,'Ex.: 2026 liquidado'))+
      _cprCampo('cprDetran','Consulta DETRAN na data da compra',v.detran,'Ex.: em circulação, sem multas')+
      '</details>';
  }

  /* v825 — a aba Veículo: conferir o carro, medir e anotar */
  function _cprVeiculoHtml(){
    var t=_cprAtual.termos;
    return _cprVeicHtml()+
      '<div class="cad-sec"><h3>O que você combinou</h3>'+
      '<div class="cpr-hint">O valor sai no contrato por extenso. A quilometragem é DECLARADA por quem vende — é a cláusula 7 do termo.</div>'+
      _cprDin('cprValor','Valor da compra',t.valor)+
      '<label class="cad-lbl" for="cprObs">Observações que entram no contrato</label>'+
      '<textarea class="cad-in" id="cprObs" rows="3" placeholder="Ex.: veículo vendido no estado, com avarias já vistoriadas">'+esc(t.obs||'')+'</textarea>'+
      '</div>'+
      '<button type="button" class="cad-btn" id="cprSalvar2">Salvar a compra</button>'+
      '<div class="cad-msg" id="cprMsg2"></div>';
  }

  function _cprTermosHtml(){
    var t=_cprAtual.termos;
    var jaNoEstoque=!!_cprAtual.estoque_id;
    return ''+
      '<div class="cad-sec"><h3>Valores e pagamento</h3>'+
      '<div class="cpr-hint">O valor da compra está na aba <b>Veículo</b>, junto da quilometragem.</div>'+
      _cprDupla(_cprDin('cprSinal','Sinal pago na assinatura',t.sinal),
                _cprCampo('cprData','Data da compra',t.data,'dd/mm/aaaa'))+
      _cprCampo('cprForma','Forma de pagamento',t.forma,'Ex.: PIX à vista na assinatura')+
      _cprCampo('cprQuit','Quando o saldo é pago',t.quitacao,'Ex.: na transferência')+
      /* 🔴 v822 (pedido do Angelo) — QUANDO O CARRO SAIU DA MÃO DO VENDEDOR.
         A data da COMPRA e a da RETIRADA quase nunca são a mesma: assina-se
         num dia e o carro sai em outro. E é a RETIRADA que marca o começo da
         responsabilidade da loja — cláusulas 5 e 8 falam "a partir da
         entrega". Sem esta hora escrita, "a partir da entrega" é a palavra
         de um contra a do outro. */
      _cprDupla(_cprCampo('cprRetData','Data da retirada do veículo',t.retirada_data,'dd/mm/aaaa'),
                _cprCampo('cprRetHora','Hora da retirada',t.retirada_hora,'hh:mm'))+
      '</div>'+
      '<div class="cad-sec"><h3>O que o vendedor declara</h3>'+
      '<div class="cpr-hint">É esta parte que protege a loja depois. A quilometragem e a situação de débitos e gravame são DECLARADAS por quem vende, e entram no contrato assinado.</div>'+
      '<label class="cad-lbl" for="cprGravame">O veículo tem gravame (financiamento)?</label>'+
      '<select class="cad-in" id="cprGravame">'+
        '<option value="nao"'+(t.gravame==='nao'?' selected':'')+'>Não — livre e desembaraçado</option>'+
        '<option value="sim"'+(t.gravame==='sim'?' selected':'')+'>Sim — será quitado nesta operação</option>'+
      '</select>'+
      _cprCampo('cprDebitos','Débitos pendentes (IPVA, multas, licenciamento)',t.debitos,'Deixe vazio se não há nenhum')+
      '</div>'+
      '<div class="cad-sec"><h3>Estoque</h3>'+
      (jaNoEstoque
        ? '<div class="cpr-ok">✓ Este carro já foi lançado no estoque por esta compra.</div>'
        : '<label class="cpr-check"><input type="checkbox" id="cprEstoque"'+(t.estoque?' checked':'')+'>'+
          '<span><b>Lançar no estoque ao salvar</b>'+
          '<i>Cria o veículo no seu estoque com placa, modelo, km e o valor pago como preço de compra. Acontece uma vez só.</i></span></label>')+
      '</div>'+
      '<button type="button" class="cad-btn" id="cprSalvar">Salvar a compra</button>'+
      '<div class="cad-msg" id="cprMsg"></div>';
  }

  var _CPR_ICO_DOC='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';
  /* ==========================================================================
     🔴 v825 — A PRÉVIA DO QUE A IA LEU (pedido do Angelo)
     -------------------------------------------------------------------------
     Duas linhas em fonte pequena embaixo do documento anexado, com os dados
     principais que saíram dele. Não é enfeite: é a única chance de você ver
     que a IA leu a placa errada ANTES de ela virar contrato assinado.
     ⚠️ O texto é sempre CURTO e cortado: prévia que vira parágrafo deixa de
     ser prévia, e a lista de documentos é pra ser varrida com o olho.
     ========================================================================= */
  function _cprResumoDoc(d){
    if(!d || !d.dados) return '';
    var t=d.tipoIa||'', x=d.dados||{}, e=x.endereco||{}, p=x.proprietario||{}, l=[];
    function po(r,v){ v=String(v==null?'':v).trim(); if(v) l.push(r+' '+v); }
    if(t==='crlv'){
      po('Placa',x.placa); po('Chassi',x.chassi); po('Renavam',x.renavam);
      po('',[x.marca,x.modelo].filter(Boolean).join(' '));
      po('',[x.ano_fabricacao,x.ano_modelo].filter(Boolean).join('/'));
      po('Cor',x.cor); po('Dono',p.nome); po('CPF/CNPJ',p.cpf_cnpj);
    }else if(t==='cnh'){
      po('',x.nome); po('CPF',x.cpf); po('RG',x.rg);
      po('Nasc.',x.data_nascimento); po('CNH',x.numero_registro); po('Cat.',x.categoria);
    }else if(t==='cnpj'){
      po('',x.razao_social||x.nome_fantasia); po('CNPJ',x.cnpj); po('Porte',x.porte);
      po('',[e.cidade,e.uf].filter(Boolean).join('/'));
    }else if(t==='residencia'){
      po('Titular',x.titular_nome); po('',x.empresa_emissora);
      po('',[e.logradouro,e.numero].filter(Boolean).join(', '));
      po('',e.bairro); po('CEP',e.cep); po('',[e.cidade,e.uf].filter(Boolean).join('/'));
    }
    if(!l.length) return '';
    return '<div class="cpr-doc-ia"><b>Lido pela IA</b>'+esc(l.join('  ·  '))+'</div>';
  }

  function _cprDocsHtml(){
    var d=_cprAtual.docs||{};
    /* ⚠️ §9.1 — O TEXTO NÃO PODE PROMETER O QUE O FLUXO NÃO FAZ.
       Aqui só se ANEXA e se ABRE arquivo; não há leitura por IA nem
       preenchimento automático de campo. Escrever "a IA lê e preenche" (como
       faz a aba de anexos da Venda, onde existe OCR) ensinaria o lojista a
       esperar algo que não vem — e ele anexaria o CRLV e ficaria esperando. */
    return '<div class="cad-sec"><h3>Documentos da compra</h3>'+
      '<div class="cpr-hint">Anexe e confira os arquivos relacionados a esta compra. '+
        'CRLV, documento do vendedor e comprovante de residência são <b>lidos pela IA</b> — '+
        'o que ela achar preenche as abas Partes e Veículo, e fica escrito aqui embaixo pra você conferir.</div>'+
      '<div class="cpr-docs">'+
      _cprDocsLista().map(function(x){
        var g=d[x[0]] && d[x[0]].arquivo ? d[x[0]] : null;
        var quando=g?_cprData(g.em):'';
        return '<div class="cpr-doc'+(g?' ok':'')+'" data-cprlinha="'+x[0]+'">'+
          '<span class="cpr-doc-ic">'+_CPR_ICO_DOC+'</span>'+
          '<div class="cpr-doc-tx"><b>'+esc(x[1])+'</b>'+
            '<i>'+esc(g?(quando?('Anexado em '+quando):'Anexado'):x[2])+'</i>'+
            (g?_cprResumoDoc(g):'')+'</div>'+
          /* §9.2 — o estado é TEXTO, não só a cor da borda */
          '<span class="cpr-doc-st'+(g?' ok':'')+'" data-cprst="'+x[0]+'">'+(g?'Anexado':'Pendente')+'</span>'+
          '<div class="cpr-doc-bt">'+
            (g?'<button type="button" class="cpr-doc-a" data-cprver="'+x[0]+'">Visualizar</button>':'')+
            '<button type="button" class="btn-sec-lb" data-cprdoc="'+x[0]+'">'+(g?'Trocar':'Anexar')+'</button>'+
          '</div></div>';
      }).join('')+
      '</div>'+
      /* v825: um documento que a lista fixa não previu — laudo, procuração,
         contrato social, o que a compra pedir. */
      '<button type="button" class="btn-sec-lb cpr-doc-novo" id="cprDocNovo">+ Adicionar documento</button>'+
      '<div class="cpr-doc-priv">Arquivos privados · somente sua conta pode abrir.</div>'+
      '<input type="file" id="cprFile" accept="image/*,application/pdf" style="display:none">'+
      '</div>';
  }
  function _cprData(iso){
    try{ var d=new Date(iso); if(isNaN(d)) return ''; return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear(); }catch(_){ return ''; }
  }

  function _cprContratoHtml(){
    var f=_cprFaltando();
    return '<div class="cad-sec"><h3>Contrato de compra e venda</h3>'+
      '<div class="cpr-hint">A loja é a COMPRADORA e o cliente é o VENDEDOR. O contrato sai com o que está nas outras abas — confira antes de imprimir.</div>'+
      (f.length
        ? '<div class="cpr-falta"><b>Falta preencher para o contrato ficar completo:</b><ul>'+
          f.map(function(x){ return '<li>'+esc(x)+'</li>'; }).join('')+'</ul>'+
          '<i>Você pode gerar assim mesmo — os campos vazios saem em branco, para preencher à caneta.</i></div>'
        : '<div class="cpr-ok">✓ Todos os dados do contrato estão preenchidos.</div>')+
      '<button type="button" class="cad-btn" id="cprGerar">Gerar PDF do contrato</button>'+
      '<div class="cad-msg" id="cprGerarMsg">Uma página: partes, veículo, valor, declarações e assinaturas.</div>'+
      '</div>';
  }
  /* o que falta — dito pelo nome que o lojista usa, não pelo id do campo */
  function _cprFaltando(){
    var s=_cprAtual.vendedor, v=_cprAtual.veiculo, t=_cprAtual.termos, f=[];
    if(!String(s.nome||'').trim()) f.push('Nome do vendedor');
    if(!String(s.cpf||'').trim())  f.push('CPF do vendedor');
    if(!String(s.rua||'').trim() && !String(s.cidade||'').trim()) f.push('Endereço do vendedor');
    if(!String(v.placa||'').trim()) f.push('Placa');
    if(!String(v.chassi||'').trim()) f.push('Chassi');
    if(!String(v.renavam||'').trim()) f.push('Renavam');
    if(!Number(v.km)) f.push('Quilometragem');
    if(!Number(t.valor)) f.push('Valor da compra');
    if(!String(t.data||'').trim()) f.push('Data da compra');
    var lj=_cprLoja||{};
    if(!lj.cnpj) f.push('CNPJ da loja (cadastre em Minha loja)');
    return f;
  }

  /* §8 — quantos dos CINCO documentos já estão anexados. Conta só as chaves
     que o _CPR_DOCS conhece: propriedade estranha no registro não vira
     progresso mentiroso. */
  function _cprDocsFeitos(){
    var d=(_cprAtual&&_cprAtual.docs)||{};
    return _cprDocsLista().filter(function(x){ var g=d[x[0]]; return !!(g && g.arquivo); }).length;
  }
  var _CPR_ICO_CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var _CPR_ICO_CARRO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';

  /* ==========================================================================
     v804 §7 — A GRADE FIXA DAS QUATRO ETAPAS
     --------------------------------------------------------------------------
     A fita rolável do .vpx-steps mostrava duas etapas e meia no celular: pra
     saber que existiam quatro era preciso arrastar. Agora as quatro ficam à
     vista numa grade 2×2 (4×1 no computador).
     ⚠️ A grade é uma VARIANTE (.cpr-tabs-grid), não uma mudança no .vpx-steps
     — Vendas, Minha loja e Minha conta dependem da fita como ela é (§7.1).
     ⚠️ SEMÂNTICA DE ABA DE VERDADE (§12): tablist/tab/tabpanel, aria-selected,
     aria-controls e um tabindex só na aba ativa. Antes eram quatro <button>
     soltos — o leitor de tela não dizia "aba 1 de 4" nem que havia painel.
     ========================================================================== */
  function _cprCardTab(t){
    var on=(t[0]===_cprTab);
    var ext='';
    if(t[0]==='docs'){
      var f=_cprDocsFeitos(), tot=_cprDocsLista().length;
      ext='<span class="cpr-st-num'+(f>=tot?' ok':'')+'" id="cprDocsN" role="status" aria-live="polite">'+
          (f>=tot?(_CPR_ICO_CHECK+' '):'')+f+'/'+tot+'</span>';
    }
    return '<button type="button" class="vpx-st cpr-st" role="tab" id="cprTab_'+t[0]+'"'+
      ' data-step="'+t[0]+'" aria-controls="cprPanel_'+t[0]+'"'+
      ' aria-selected="'+(on?'true':'false')+'" tabindex="'+(on?'0':'-1')+'">'+
      '<span class="vpx-ico cpr-st-ic">'+_CPR_ICO[t[2]]+'</span>'+
      '<span class="cpr-st-tx"><span class="cpr-st-nm">'+esc(t[1])+'</span>'+
      '<span class="cpr-st-sub">'+esc(t[3]||'')+'</span></span>'+ext+'</button>';
  }
  function _cprPainel(chave, idInterno){
    return '<div class="vpx-panel" data-panel="'+chave+'" id="cprPanel_'+chave+'"'+
      ' role="tabpanel" aria-labelledby="cprTab_'+chave+'"'+(chave===_cprTab?'':' hidden')+'>'+
      '<div id="'+idInterno+'"></div></div>';
  }
  function _cprConteudoHtml(){
    var nav=_CPR_TABS.map(_cprCardTab).join('');
    /* §6.2 — o resumo virou card compacto: ícone, nome em duas linhas, placa
       embaixo e o autosave discreto. Sem altura mínima e sem área reservada
       pra imagem que não existe. */
    return '<div class="cpr-topo">'+
        '<span class="cpr-topo-ic">'+_CPR_ICO_CARRO+'</span>'+
        '<div class="cpr-topo-l">'+
          '<b>'+esc(_avlModelo(_cprAtual.veiculo.modelo||'Veículo'))+'</b>'+
          '<span class="cpr-topo-pl">'+esc(_cprPlaca)+'</span>'+
        '</div>'+
        '<div class="cad-autosave" id="cprSave"></div></div>'+
      '<div class="vpx cpr-vpx">'+
      '<div class="vpx-steps cpr-tabs-grid" id="cprTabs" role="tablist" aria-label="Etapas da compra">'+nav+'</div>'+
      '<div class="vpx-body cad-float" id="cprCorpo">'+
        _cprPainel('docs','cprDocs')+
        _cprPainel('partes','cprPartes')+
        _cprPainel('veiculo','cprVeiculo')+
        _cprPainel('termos','cprTermos')+
        _cprPainel('contrato','cprContrato')+
      '</div></div>';
  }
  function _cprTabAplica(){
    /* §5 — marcação inválida cai em DOCUMENTOS, não em outra etapa por acaso */
    if(!_CPR_TABS.some(function(t){ return t[0]===_cprTab; })) _cprTab='docs';
    Array.prototype.forEach.call(document.querySelectorAll('#cprCorpo .vpx-panel'),function(pn){
      var on=pn.getAttribute('data-panel')===_cprTab;
      pn.classList.toggle('on', on);
      /* o `hidden` é o que tira o painel da árvore do leitor de tela — a
         classe sozinha só o esconde pro olho */
      if(on) pn.removeAttribute('hidden'); else pn.setAttribute('hidden','');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#cprTabs .vpx-st'),function(b){
      var on=b.getAttribute('data-step')===_cprTab;
      b.classList.toggle('on',on);
      b.setAttribute('aria-selected', on?'true':'false');
      b.setAttribute('tabindex', on?'0':'-1');
    });
    /* ⚠️ o _tabCentra saiu: ele rolava a fita pra centralizar a aba ativa.
       Numa grade fixa não há o que rolar, e chamá-lo mexeria a página à toa. */
  }
  /* §8 — o contador vive: repinta sozinho quando um anexo entra ou sai */
  function _cprDocsNumPinta(){
    var el=$('cprDocsN'); if(!el) return;
    var f=_cprDocsFeitos(), tot=_cprDocsLista().length;
    el.className='cpr-st-num'+(f>=tot?' ok':'');
    el.innerHTML=(f>=tot?(_CPR_ICO_CHECK+' '):'')+f+'/'+tot;
  }
  /* §12 — o teclado que uma tablist precisa ter */
  function _cprTeclaAba(e, b){
    var chaves=_CPR_TABS.map(function(t){ return t[0]; });
    var i=chaves.indexOf(b.getAttribute('data-step'));
    var alvo=-1;
    if(e.key==='ArrowRight') alvo=(i+1)%chaves.length;
    else if(e.key==='ArrowLeft') alvo=(i-1+chaves.length)%chaves.length;
    /* no 2×2 do celular, para baixo/cima é o card da outra linha */
    else if(e.key==='ArrowDown') alvo=(i+2)%chaves.length;
    else if(e.key==='ArrowUp') alvo=(i+2)%chaves.length;
    else if(e.key==='Home') alvo=0;
    else if(e.key==='End') alvo=chaves.length-1;
    else return;
    e.preventDefault();
    cprTrocaAba(chaves[alvo], true);
  }
  /* ==========================================================================
     v804 §11 — UMA PORTA SÓ PRA TROCAR DE ETAPA
     O clique e o teclado passam por aqui. Antes o clique tinha a lógica
     inteira dentro do onclick; com o teclado entrando (§12), duas cópias da
     mesma sequência iam divergir na primeira manutenção.
     `foco` diz se o card deve receber o foco — o teclado precisa, o dedo não
     (roubar o foco depois de um toque atrapalha quem só quis trocar de aba).
     ========================================================================== */
  function cprTrocaAba(chave, foco){
    if(!chave) chave='docs';
    cprLe();                       /* §11.1: o que está digitado não se perde */
    _cprTab=chave;
    /* 🔴 A ABA CONTRATO É CALCULADA, NÃO GUARDADA: ela mostra o que ainda
       falta. Sem repintar na entrada, exibiria a lista de pendências de
       quando a página abriu — o lojista preencheria o CPF e a tela
       continuaria dizendo que falta CPF. */
    if(_cprTab==='contrato'){
      var ct=$('cprContrato');
      if(ct){ ct.innerHTML=_cprContratoHtml();
        var gr=$('cprGerar'); if(gr) gr.onclick=function(){ cprLe(); cprContratoPdf(); }; }
    }
    _cprTabAplica();
    if(foco){ try{ var bt=$('cprTab_'+_cprTab); if(bt) bt.focus(); }catch(_){} }
    try{ $('cprPagina').scrollIntoView({block:'start'}); }catch(_){}
  }
  function _cprPinta(){
    var p=$('cprPartes'); if(!p) return;
    p.innerHTML=_cprPartesHtml();
    $('cprVeiculo').innerHTML=_cprVeiculoHtml();   /* v825 */
    $('cprTermos').innerHTML=_cprTermosHtml();
    $('cprDocs').innerHTML=_cprDocsHtml();
    $('cprContrato').innerHTML=_cprContratoHtml();
    _cprWire();
    _cprTabAplica();
  }

  /* ---------- ler a tela de volta pro registro ---------------------------- */
  function cprLe(){
    if(!_cprAtual || !$('cprVNome')) return;
    function g(id){ var e=$(id); return e?String(e.value||'').trim():''; }
    function n(id){ var e=$(id); return e?_avlSoNum(e.value):0; }
    var s=_cprAtual.vendedor, v=_cprAtual.veiculo, t=_cprAtual.termos;
    s.nome=g('cprVNome'); s.cpf=g('cprVCpf'); s.rg=g('cprVRg');
    s.fone=String(g('cprVFone')).replace(/\D/g,''); s.nasc=g('cprVNasc');
    s.rua=g('cprVRua'); s.numero=g('cprVNum'); s.bairro=g('cprVBairro');
    s.cep=g('cprVCep'); s.cidade=g('cprVCidade'); s.uf=g('cprVUf').toUpperCase().slice(0,2);
    /* v821 — os campos novos. Cada bloco confere o PRÓPRIO campo antes de
       ler: a aba Partes e a aba Termos não estão na tela ao mesmo tempo, e
       ler de uma aba fechada apagaria o que já estava salvo. */
    if($('cprVCnh')){ s.cnh=g('cprVCnh'); s.filiacao=g('cprVFil'); }
    if($('cprBanco')){
      var t2=_cprAtual.termos;
      t2.banco=g('cprBanco'); t2.agencia=g('cprAgencia');
      t2.conta=g('cprConta'); t2.pix=g('cprPix'); t2.titular=g('cprTitular');
    }
    if($('cprTNome')){
      _cprAtual.testemunha=_cprAtual.testemunha||{};
      _cprAtual.testemunha.nome=g('cprTNome');
      _cprAtual.testemunha.cargo=g('cprTCargo');
      _cprAtual.testemunha.cpf=g('cprTCpf');
    }
    if($('cprAnoMod')){
      var v2=_cprAtual.veiculo;
      v2.ano_modelo=g('cprAnoMod'); v2.especie=g('cprEspecie'); v2.categoria=g('cprCateg');
      v2.motor=g('cprMotor'); v2.potencia=g('cprPot'); v2.municipio=g('cprMunic');
      v2.licenciado=g('cprLic'); v2.ipva_sit=g('cprIpvaS'); v2.detran=g('cprDetran');
    }
    if($('cprPlaca')){
      v.placa=g('cprPlaca').toUpperCase().replace(/[^A-Z0-9]/g,'');
      v.renavam=g('cprRenavam').replace(/\D/g,''); v.chassi=g('cprChassi').toUpperCase();
      v.marca=g('cprMarca'); v.modelo=g('cprModelo'); v.ano=g('cprAno'); v.cor=g('cprCor');
      v.km=n('cprKm'); v.combustivel=g('cprComb');
      /* 🔴 v825 — o VALOR e a OBSERVAÇÃO mudaram pra aba Veículo, e o resto
         ficou em Termos. As duas abas não estão na tela ao mesmo tempo, então
         cada bloco confere o PRÓPRIO campo antes de ler: sem isso, abrir uma
         aba apagaria o que foi digitado na outra. */
      if($('cprValor')) t.valor=n('cprValor');
      if($('cprObs'))   t.obs=String((($('cprObs')||{}).value)||'').trim();
      if($('cprSinal')){
        t.sinal=n('cprSinal'); t.forma=g('cprForma');
        t.data=g('cprData'); t.quitacao=g('cprQuit');
        t.retirada_data=g('cprRetData'); t.retirada_hora=g('cprRetHora');
        t.gravame=(($('cprGravame')||{}).value)||'nao';
        t.debitos=g('cprDebitos');
        var ck=$('cprEstoque'); if(ck) t.estoque=!!ck.checked;
      }
    }
  }

  function _cprWire(){
    /* autosave em tudo que é campo — o mesmo gesto da ficha do estoque */
    Array.prototype.forEach.call(document.querySelectorAll('#cprCorpo input, #cprCorpo textarea, #cprCorpo select'),function(e){
      if(e.type==='file') return;
      e.addEventListener('input', cprAgenda);
      e.addEventListener('change', cprAgenda);
    });
    var tf=$('cprVFone'); if(tf && typeof foneFmt==='function') tf.addEventListener('input',function(){ this.value=foneFmt(this.value); });
    ['cprValor','cprSinal'].forEach(function(id){ var e=$(id); if(e && typeof _avlMaskRs==='function') _avlMaskRs(e); });
    var km=$('cprKm'); if(km) km.addEventListener('input',function(){ var n=_avlSoNum(this.value); this.value=n?Number(n).toLocaleString('pt-BR'):''; });

    var pc=$('cprDoCadastro'); if(pc) pc.onclick=function(){ _cprEscolherCliente(); };
    var nv=$('cprDocNovo'); if(nv) nv.onclick=function(){ _cprDocNovo(); };   /* v825 */
    var sv=$('cprSalvar'); if(sv) sv.onclick=function(){ cprSalvarTudo(sv); };
    var sv2=$('cprSalvar2'); if(sv2) sv2.onclick=function(){ cprSalvarTudo(sv2); };   /* v825: a aba Veículo salva também */
    var gr=$('cprGerar'); if(gr) gr.onclick=function(){ cprLe(); cprContratoPdf(); };
    Array.prototype.forEach.call(document.querySelectorAll('[data-cprdoc]'),function(b){
      b.onclick=function(){ _cprAnexar(b.getAttribute('data-cprdoc')); }; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cprver]'),function(b){
      b.onclick=function(){ _cprVerDoc(b.getAttribute('data-cprver')); }; });
  }

  /* ---------- puxar de um cliente já cadastrado --------------------------- */
  function _cprEscolherCliente(){
    var box=$('cprCliLista'); if(!box) return;
    if(box.innerHTML){ box.innerHTML=''; return; }
    var lista=[]; try{ lista=(typeof _clientes!=='undefined' && _clientes)?_clientes:[]; }catch(_){ lista=[]; }
    if(!lista.length){ box.innerHTML='<div class="cpr-vazio">Nenhum cliente cadastrado ainda.</div>'; return; }
    box.innerHTML='<div class="cli-search busca-lupa">'+_icoBusca+'<input class="cad-in" id="cprCliBusca" type="search" aria-label="Buscar por nome ou telefone" placeholder="Buscar por nome ou telefone" autocomplete="off"></div>'+
      '<div class="cpr-cli" id="cprCliRows"></div>';
    function pinta(termo){
      termo=String(termo||'').toLowerCase().trim();
      var d=termo.replace(/\D/g,'');
      var f=lista.filter(function(c){
        if(!termo) return true;
        if(d.length>=3 && String(c.telefone||'').replace(/\D/g,'').indexOf(d)>=0) return true;
        return String(c.nome||'').toLowerCase().indexOf(termo)>=0;
      }).slice(0,8);
      $('cprCliRows').innerHTML=f.map(function(c,i){
        return '<button type="button" class="cpr-cli-r" data-i="'+lista.indexOf(c)+'">'+
          '<b>'+esc(c.nome||'—')+'</b><i>'+esc((typeof foneFmt==='function'&&c.telefone)?foneFmt(c.telefone):(c.telefone||''))+'</i></button>';
      }).join('')||'<div class="cpr-vazio">Ninguém com esse nome.</div>';
      Array.prototype.forEach.call($('cprCliRows').querySelectorAll('[data-i]'),function(b){
        b.onclick=function(){
          var c=lista[Number(b.getAttribute('data-i'))]; if(!c) return;
          cprLe();
          var s=_cprAtual.vendedor;
          /* só preenche o que está VAZIO: o que você digitou aqui vence o
             cadastro, que pode estar velho (a régua do v284) */
          if(!s.nome) s.nome=String(c.nome||'');
          if(!s.cpf)  s.cpf=String(c.cpf||'');
          if(!s.rg)   s.rg=String(c.rg||'');
          if(!s.fone) s.fone=String(c.telefone||'').replace(/\D/g,'');
          if(!s.nasc) s.nasc=String(c.nascimento||'');
          if(!s.rua)  s.rua=String(c.rua||'');
          if(!s.numero) s.numero=String(c.numero||'');
          if(!s.bairro) s.bairro=String(c.bairro||'');
          if(!s.cep)  s.cep=String(c.cep||'');
          if(!s.cidade) s.cidade=String(c.cidade||'');
          if(!s.uf)   s.uf=String(c.uf||'');
          cprGravar(); _cprPinta();
          toast('Dados de '+(c.nome||'cliente')+' preenchidos — confira o que faltava.');
        };
      });
    }
    pinta('');
    var bs=$('cprCliBusca'); if(bs) bs.oninput=function(){ pinta(this.value); };
  }

  /* ---------- anexar documento ------------------------------------------- */
  var _cprEnviando={};   /* §9.2: impede segundo envio do MESMO item */
  /* ==========================================================================
     🔴 v825 — ANEXAR PASSOU A LER (e a PREENCHER as outras abas)
     -------------------------------------------------------------------------
     Até a v824 esta aba só guardava arquivo. O comentário do v804 dizia isso
     de propósito, pra não prometer o que não havia. Agora há: o MEV_IA já lê
     CNH, cartão CNPJ, comprovante de residência e CRLV — é o MESMO motor da
     aba de anexos da Venda, desde a v305. Não escrevi leitor novo.

     🔴 A REGRA QUE PROTEGE O QUE VOCÊ DIGITOU: o que a IA lê só entra em
     campo VAZIO. Ela nunca sobrescreve o que você corrigiu na mão — se você
     ajustou o nome porque a leitura saiu torta, anexar outro documento não
     desfaz o seu ajuste. Um preenchimento automático que apaga correção é
     pior que nenhum.
     ⚠️ E O QUE ELA LEU FICA ESCRITO na linha do documento (o _cprResumoDoc),
     porque leitura de IA que ninguém confere é leitura que vira contrato
     errado.
     ========================================================================= */
  function _cprIaPreenche(tipo, x){
    if(!x) return 0;
    var s2=_cprAtual.vendedor, v2=_cprAtual.veiculo, n=0;
    function po(o,c,val){
      val=String(val==null?'':val).trim();
      if(val && !String(o[c]||'').trim()){ o[c]=val; n++; }
    }
    var e=x.endereco||{};
    if(tipo==='cnh'){
      po(s2,'nome',x.nome); po(s2,'cpf',x.cpf); po(s2,'rg',x.rg);
      po(s2,'nasc',x.data_nascimento);
      po(s2,'cnh',[x.numero_registro,x.categoria,x.validade].filter(Boolean).join(' - '));
      po(s2,'filiacao',[x.filiacao_pai,x.filiacao_mae].filter(Boolean).join(' e '));
    }else if(tipo==='cnpj'){
      /* vendedor EMPRESA: a razão social ocupa o nome e o CNPJ ocupa o CPF —
         é o mesmo par de campos que o contrato imprime como "Nome / CPF". */
      po(s2,'nome',x.razao_social||x.nome_fantasia);
      po(s2,'cpf',x.cnpj);
      po(s2,'rua',e.logradouro); po(s2,'numero',e.numero); po(s2,'bairro',e.bairro);
      po(s2,'cep',e.cep); po(s2,'cidade',e.cidade); po(s2,'uf',e.uf);
      po(s2,'fone',String(x.telefone||'').replace(/\D/g,''));
    }else if(tipo==='residencia'){
      po(s2,'rua',e.logradouro); po(s2,'numero',e.numero); po(s2,'bairro',e.bairro);
      po(s2,'cep',e.cep); po(s2,'cidade',e.cidade); po(s2,'uf',e.uf);
      po(s2,'nome',x.titular_nome);
    }else if(tipo==='crlv'){
      po(v2,'placa',String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''));
      po(v2,'renavam',String(x.renavam||'').replace(/\D/g,''));
      po(v2,'chassi',String(x.chassi||'').toUpperCase());
      po(v2,'marca',x.marca); po(v2,'modelo',x.modelo);
      po(v2,'ano',x.ano_fabricacao); po(v2,'ano_modelo',x.ano_modelo);
      po(v2,'cor',x.cor); po(v2,'combustivel',x.combustivel);
      var pr=x.proprietario||{};
      po(s2,'nome',pr.nome); po(s2,'cpf',pr.cpf_cnpj);
    }
    return n;
  }

  /* sobe a foto que o leitor devolveu, do mesmo jeito que a Venda faz (v592):
     os DADOS ficam no registro, a FOTO vai pro cofre e só a referência fica */
  function _cprB64File(b64, mime, nome){
    var bin=atob(String(b64||'')), u=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) u[i]=bin.charCodeAt(i);
    return new File([u], nome, { type:mime||'image/jpeg' });
  }

  function _cprLerComIa(k, tipo){
    if(!window.MEV_IA){ _iaAcao(function(){ _cprLerComIa(k,tipo); }); return; }
    var fn = tipo==='cnh' ? window.MEV_IA.importarCNH
           : tipo==='cnpj' ? window.MEV_IA.importarCNPJ
           : tipo==='residencia' ? window.MEV_IA.importarResidencia
           : window.MEV_IA.importarCRLV;
    if(typeof fn!=='function'){ toast('Esta leitura não está disponível nesta versão.'); return; }
    fn(async function(dados){
      if(!dados) return;
      if(dados.erro){ toast(String(dados.erro)); return; }
      var anx=dados._anexo||null; try{ delete dados._anexo; }catch(_){ dados._anexo=null; }
      cprLe();
      _cprAtual.docs=_cprAtual.docs||{};
      _cprAtual.docs[k]={ arquivo:'', nome:'', em:new Date().toISOString(),
                          tipoIa:tipo, dados:dados };
      var n=_cprIaPreenche(tipo, dados);
      cprGravar(); _cprPinta(); _cprDocsNumPinta();
      toast(n?('Documento lido — '+n+' campo'+(n===1?'':'s')+' preenchido'+(n===1?'':'s')+'. Confira.')
             :'Documento lido — confira os dados.');
      if(anx && anx.base64){
        try{
          var file=_cprB64File(anx.base64, anx.mimeType||'image/jpeg', k+'-documento.jpg');
          var ref=await arqUpload(file,'documento');
          if(ref && _cprAtual.docs[k]){ _cprAtual.docs[k].arquivo=ref; cprGravar(); _cprPinta(); _cprDocsNumPinta(); }
        }catch(_){ /* a foto não subiu: os dados lidos ficam do mesmo jeito */ }
      }
    });
  }

  /* o vendedor pode ser PESSOA ou EMPRESA (pedido do Angelo) — quem decide é
     ele, no toque, porque o app não tem como saber antes de ler */
  function _cprEscolherDocVendedor(k){
    _popAbrir('<div class="act-head"><div class="ah-nm">Documento do vendedor</div>'+
              '<div class="ah-pl">quem está vendendo o carro</div></div>',
      [['pessoa','','Pessoa física — CNH',''],
       ['empresa','','Empresa — cartão CNPJ',''],
       ['semia','','Só anexar, sem ler','']],
      null, function(esc2){
        if(esc2==='pessoa')  _cprLerComIa(k,'cnh');
        else if(esc2==='empresa') _cprLerComIa(k,'cnpj');
        else if(esc2==='semia')   _cprAnexarArquivo(k);
      });
  }

  /* v825 — o documento que a lista fixa não previu */
  function _cprDocNovo(){
    var ov=document.createElement('div');
    ov.className='cpr-novo-ov';
    ov.innerHTML='<div class="cpr-novo-cx" role="dialog" aria-modal="true" aria-label="Novo documento">'+
      '<b>Que documento é este?</b>'+
      '<small>O nome aparece na lista e no contrato, no lugar de "Outros papéis".</small>'+
      '<input class="cad-in" id="cprNovoNm" placeholder="Ex.: Laudo cautelar, Procuração, Contrato social" maxlength="42">'+
      '<div class="cpr-novo-bt">'+
        '<button type="button" class="art-bt" id="cprNovoX">Cancelar</button>'+
        '<button type="button" class="cad-btn" id="cprNovoOk">Adicionar</button>'+
      '</div></div>';
    document.body.appendChild(ov);
    var inp=ov.querySelector('#cprNovoNm');
    setTimeout(function(){ try{ inp.focus(); }catch(_){} },60);
    function fecha(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) fecha(); };
    ov.querySelector('#cprNovoX').onclick=fecha;
    ov.addEventListener('keydown',function(e){ if(e.key==='Escape'){ e.preventDefault(); fecha(); } });
    function cria(){
      var nm=String(inp.value||'').trim();
      if(!nm){ try{ inp.focus(); }catch(_){} toast('Dê um nome ao documento.'); return; }
      cprLe();
      _cprAtual.extras_docs=_cprAtual.extras_docs||[];
      var k='x'+Date.now().toString(36);
      _cprAtual.extras_docs.push({ k:k, titulo:nm });
      cprGravar(); fecha(); _cprPinta(); _cprDocsNumPinta();
      toast('"'+nm+'" entrou na lista — agora é só anexar.');
    }
    ov.querySelector('#cprNovoOk').onclick=cria;
    inp.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); cria(); } });
  }

  function _cprAnexar(k){
    if(_cprEnviando[k]) return;
    /* v825: a linha diz qual leitor usar. Sem leitor, anexa como sempre. */
    var linha=_cprDocsLista().filter(function(x){ return x[0]===k; })[0];
    var leitor=(linha&&linha[3])||'';
    if(leitor==='pessoa_ou_empresa'){ _cprEscolherDocVendedor(k); return; }
    if(leitor){ _cprLerComIa(k, leitor); return; }
    _cprAnexarArquivo(k);
  }
  function _cprAnexarArquivo(k){
    if(_cprEnviando[k]) return;
    var inp=$('cprFile'); if(!inp) return;
    inp.value='';
    inp.onchange=async function(){
      var f=inp.files&&inp.files[0]; if(!f) return;
      _cprEnviando[k]=1;
      var linha=document.querySelector('[data-cprlinha="'+k+'"]');
      var st=document.querySelector('[data-cprst="'+k+'"]');
      var bt=document.querySelector('[data-cprdoc="'+k+'"]');
      if(st){ st.textContent='Enviando…'; st.className='cpr-doc-st indo'; }
      if(bt){ bt.disabled=true; }          /* a largura fica: o botão não encolhe */
      if(linha) linha.classList.add('indo');
      try{
        var ref=await arqUpload(f,'documento');
        if(!ref) throw new Error('sem referência');
        cprLe();
        _cprAtual.docs=_cprAtual.docs||{};
        _cprAtual.docs[k]={ arquivo:ref, nome:String(f.name||''), em:new Date().toISOString() };
        cprGravar();
        _cprEnviando[k]=0;
        _cprPinta();
        _cprDocsNumPinta();               /* §8: o X/5 acompanha */
        toast('Documento anexado ✓');
      }catch(e){
        /* 🔴 §9.2 — A FALHA NÃO PODE APAGAR O QUE JÁ ESTAVA. Se havia um
           arquivo anexado e a troca falhou, o registro NÃO é tocado: repintar
           devolve a linha exatamente como estava, com o arquivo antigo. */
        _cprEnviando[k]=0;
        _cprPinta();
        _cprDocsNumPinta();
        /* 🔴 O SELO SÓ VIRA "Não enviou" QUANDO NÃO HÁ ARQUIVO ANTERIOR.
           Se já havia um anexado e a TROCA falhou, o documento continua
           anexado — e escrever "Não enviou" numa linha que tem arquivo diria
           ao lojista que ele está sem o CRLV quando o CRLV está lá. Quem
           conta a falha é o aviso; o selo conta o ESTADO. */
        var tinha=!!(_cprAtual.docs && _cprAtual.docs[k] && _cprAtual.docs[k].arquivo);
        if(!tinha){
          var st2=document.querySelector('[data-cprst="'+k+'"]');
          if(st2){ st2.textContent='Não enviou'; st2.className='cpr-doc-st erro'; }
        }
        toast('Não foi possível enviar. Tentar novamente.');
        try{ var bt2=document.querySelector('[data-cprdoc="'+k+'"]'); if(bt2) bt2.focus(); }catch(_){}
      }
    };
    inp.click();
  }
  async function _cprVerDoc(k){
    var g=(_cprAtual.docs||{})[k]; if(!g||!g.arquivo) return;
    try{
      var u=await _arqPrivadoUrl(g.arquivo);
      if(!u){ toast('Não consegui abrir o documento agora.'); return; }
      window.open(u,'_blank','noopener');
    }catch(_){ toast('Não consegui abrir o documento agora.'); }
  }

  /* ---------- salvar + (opcional) lançar no estoque ----------------------- */
  async function cprSalvarTudo(btn){
    cprLe();
    /* v825: agora DUAS abas salvam (Veículo e Termos). O recado tem que
       aparecer na que está aberta, senão ele nasce escondido. */
    var msg=$(_cprTab==='veiculo'?'cprMsg2':'cprMsg');
    var v=_cprAtual.veiculo, t=_cprAtual.termos;
    if(!v.placa && !v.modelo){ if(msg){ msg.className='cad-msg err'; msg.textContent='Informe ao menos a placa ou o modelo.'; } return; }
    if(btn){ btn.disabled=true; btn.textContent='Salvando…'; }
    cprGravar();
    var entrou=false, erroEstoque='';
    if(t.estoque && !_cprAtual.estoque_id){
      try{
        var r=await _cprLancarNoEstoque();
        if(r && r.id){ _cprAtual.estoque_id=r.id; cprGravar(); entrou=true; }
        else erroEstoque=(r&&r.erro)||'o estoque não confirmou a gravação';
      }catch(e){ erroEstoque=(e&&e.message)||'falha ao falar com o estoque'; }
    }
    if(btn){ btn.disabled=false; btn.textContent='Salvar a compra'; }
    if(entrou){ try{ await estCarregar(); }catch(_){} }
    /* 🔴 REPINTA ANTES DE FALAR. O _cprPinta refaz o HTML do painel inteiro —
       e o #cprMsg mora dentro dele. Escrevendo o recado primeiro, a repintura
       o apagava no mesmo instante: o lojista clicava em Salvar e não via
       resposta nenhuma. O botão some, nada acontece, e ele clica de novo. */
    _cprPinta();
    var m2=$(_cprTab==='veiculo'?'cprMsg2':'cprMsg');
    if(m2){
      if(erroEstoque){
        m2.className='cad-msg err';
        m2.textContent='A compra foi salva, mas NÃO entrou no estoque: '+erroEstoque+'. Tente salvar de novo.';
      } else {
        m2.className='cad-msg ok';
        m2.textContent=entrou?'Compra salva e veículo lançado no estoque ✓':'Compra salva ✓';
      }
    }
  }
  /* 🔴 A RÉGUA DA v483: INSERT/UPDATE barrado por RLS volta "sucesso" com ZERO
     linhas. Um "lançado no estoque ✓" que mente é pior que um erro — o lojista
     confia e o carro não está lá. Por isso o insert PEDE A LINHA DE VOLTA e
     confere que ela veio. */
  async function _cprLancarNoEstoque(){
    if(!meuId || !window.supa) return { erro:'sem conexão com a conta' };
    var v=_cprAtual.veiculo, t=_cprAtual.termos;
    /* já existe um carro com esta placa? não duplico estoque calado */
    try{
      var pl=String(v.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      if(pl){
        var ja=(typeof _estoque!=='undefined' && _estoque ? _estoque : []).filter(function(x){
          return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===pl; })[0];
        if(ja && ja.id) return { id:ja.id, jaTinha:true };
      }
    }catch(_){}
    var reg={
      user_id:meuId,
      placa:String(v.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''),
      marca:v.marca||null, modelo:v.modelo||null, ano:v.ano||null, cor:v.cor||null,
      km:Number(v.km)||null, combustivel:v.combustivel||null,
      preco_compra:Number(t.valor)||null,
      data_entrada:_cprDataISO(t.data),
      origem:'Compra de particular',
      status:'disponivel',
      criado_em:new Date().toISOString()
    };
    /* 🔴 03/09 (relato do Angelo: "nem puxou as informações da consulta FIPE
       pro estoque"). Conferido no banco: o carro entrou SEM `extras`, então
       sem FIPE — enquanto os veículos cadastrados direto no estoque têm
       `extras.fipe` completo. O lançamento nunca escreveu esse campo.

       De onde vem, sem gastar consulta nova: do MESMO histórico da placa que
       este arquivo já lê no `_cprNovo` (`_avlDoHistorico`), e da avaliação
       como reserva. É informação que o app já pagou pra ter.

       ⚠️ `mes_ref` e `codigo_fipe` só entram se o histórico tiver — quando
       não têm, ficam de fora em vez de virar campo vazio. Todas as telas que
       leem `mes_ref` já omitem quando falta (conferido em 02, 05 e 06), então
       um registro parcial informa sem mentir. */
    try{
      var _hf=null; try{ _hf=_avlDoHistorico(reg.placa); }catch(_){ _hf=null; }
      var _hv=(_hf&&_hf.v)||{};
      var _av=(_avlCache||[]).filter(function(x){ return _avlKey(x.placa)===_avlKey(reg.placa); })[0]||{};
      var _valor=Number(String(_hv.fipe!=null?_hv.fipe:(_av.fipe||'')).replace(/[^\d]/g,''))||0;
      if(_valor>0){
        var _fipe={ valor:_valor, modelo:String(reg.modelo||_hv.modelo||'') };
        if(_hv.mes_ref)     _fipe.mes_ref=String(_hv.mes_ref);
        if(_hv.codigo_fipe) _fipe.codigo_fipe=String(_hv.codigo_fipe);
        reg.extras={ fipe:_fipe };
      }
      if(!reg.ano_modelo && (v.ano_modelo||_hv.ano_modelo)) reg.ano_modelo=String(v.ano_modelo||_hv.ano_modelo);
    }catch(_){ }
    var r=await supa.from('estoque').insert(reg).select('id');
    if(r && r.error) return { erro:String(r.error.message||r.error) };
    var linha=r && r.data && r.data[0];
    if(!linha || !linha.id) return { erro:'o banco não devolveu a linha (permissão?)' };
    return { id:linha.id };
  }
  function _cprDataISO(br){
    var m=String(br||'').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if(!m) return new Date().toISOString().slice(0,10);
    return m[3]+'-'+m[2]+'-'+m[1];
  }

  /* ==========================================================================
     O CONTRATO — uma página, enxuto, com a LOJA como compradora
     --------------------------------------------------------------------------
     ⚠️ O QUE ESTE CONTRATO NÃO TEM, E POR QUÊ: garantia, benefícios inclusos e
     obrigações do comprador. Essas cláusulas são do contrato de VENDA ao
     consumidor (18-credito-e-troca) e existem porque lá quem compra é pessoa
     física protegida pelo CDC. Aqui quem compra é a loja. Copiar aquelas
     seções pra cá produziria um documento que promete coisas ao contrário de
     quem elas protegem.
     ⚠️ E O QUE ELE TEM DE PRÓPRIO: a declaração do vendedor sobre
     QUILOMETRAGEM, débitos e gravame. É o parágrafo que serve à loja depois —
     e é exatamente o que o Angelo pediu que entrasse nos termos.
     🔴 Isto é um modelo de documento, não aconselhamento jurídico: quem
     assina confere com quem entende. O rodapé do PDF diz isso.
     ========================================================================== */
  async function cprContratoPdf(){
    if(!_mevPdfPronto(function(){ cprContratoPdf(); },false)) return;
    toast('Gerando contrato…');
    _cprCompleta(_cprAtual);
    var s=_cprAtual.vendedor, v=_cprAtual.veiculo, t=_cprAtual.termos,
        tw=_cprAtual.testemunha||{}, lj=_cprLoja||{};
    var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'mm',format:'a4'});
    var W=210, H=297, M=12, LARG=W-M*2, y=M;

    function F(sz,b){ pdf.setFont('helvetica',b?'bold':'normal'); pdf.setFontSize(sz); }
    function col(r,g,b){ pdf.setTextColor(r,g,b); }
    function din(n){ return 'R$ '+Number(n||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function txt(x){ return String(x==null?'':x).trim(); }

    /* a faixa de seção — é ela que dá o "formato de proposta" */
    function barra(rot){
      pdf.setFillColor(224,228,234); pdf.rect(M,y,LARG,5.2,'F');
      pdf.setDrawColor(120,130,145); pdf.setLineWidth(0.25); pdf.rect(M,y,LARG,5.2);
      F(8,true); col(20,20,20); pdf.text(rot,W/2,y+3.5,{align:'center'});
      y+=5.2;
    }
    /* 🔴 UMA LINHA DE CAMPOS, E O CAMPO VAZIO SIMPLESMENTE NÃO ENTRA.
       Contrato com "Motor: ____" impresso é pior que contrato sem a linha:
       parece que faltou preencher. Aqui a linha se fecha com o que existe. */
    function linhaCampos(cols){
      cols=cols.filter(function(c){ return txt(c.v)!==''; });
      if(!cols.length) return;
      var total=cols.reduce(function(a,c){ return a+(c.w||1); },0);
      var x=M+2, alt=7.6;
      cols.forEach(function(c){
        var larg=(LARG-4)*((c.w||1)/total);
        F(5.6); col(120,128,138); pdf.text(String(c.l),x,y+3);
        F(c.b?8.4:8, c.b); col(15,15,15);
        var val=pdf.splitTextToSize(txt(c.v), larg-2);
        pdf.text(val.slice(0,1), x, y+6.4);
        x+=larg;
      });
      y+=alt;
    }
    function cxIni(){ return y; }
    function cxFim(y0){ pdf.setDrawColor(120,130,145); pdf.setLineWidth(0.35); pdf.rect(M,y0,LARG,y-y0+1.5); y+=1.5; }
    function para(texto,sz,gap,x0,larg,b){
      F(sz||7.4,b); col(35,38,44);
      var ls=pdf.splitTextToSize(texto,(larg||LARG-4));
      pdf.text(ls,(x0||M+2),y+3);
      y+=ls.length*((sz||7.4)*0.40)+(gap==null?1.6:gap);
    }
    /* item numerado do termo: título em negrito, texto correndo ao lado.
       🔴 A primeira linha é montada À MÃO de propósito: o splitTextToSize
       não sabe recuar a primeira linha, e sobrepor o título em negrito por
       cima do mesmo texto em peso normal borra a letra — o negrito é mais
       largo e invade a palavra seguinte. Então eu meço o título, vejo quanto
       do texto cabe ao lado dele, e quebro o resto na largura cheia. */
    function clausula(tit,texto){
      var lh=3.4;
      F(7.2,true); var lt=pdf.getTextWidth(tit);
      F(7,false);
      var palavras=String(texto).split(' '), prim='', i2=0;
      while(i2<palavras.length &&
            pdf.getTextWidth((prim+' '+palavras[i2]).trim()) <= (LARG-4-lt-1.5)){
        prim=(prim+' '+palavras[i2]).trim(); i2++;
      }
      var resto=palavras.slice(i2).join(' ');
      F(7.2,true); col(15,15,15); pdf.text(tit, M+2, y+3);
      F(7,false); col(35,38,44); if(prim) pdf.text(prim, M+2+lt+1.5, y+3);
      var ls = resto ? pdf.splitTextToSize(resto, LARG-4) : [];
      for(var k=0;k<ls.length;k++) pdf.text(ls[k], M+2, y+3+(k+1)*lh);
      y += (1+ls.length)*lh + 1.6;
    }

    var nomeLoja=txt(lj.nome_fantasia||lj.razao_social||meuNome||'A LOJA');
    var cidLoja=[txt(lj.cidade),txt(lj.uf)].filter(Boolean).join('/');
    var repLoja=txt(lj.responsavel||lj.socio||'');
    var titular=txt(t.titular)||txt(s.nome);
    var terceiro=(txt(t.titular)!=='' && txt(t.titular).toUpperCase()!==txt(s.nome).toUpperCase());

    /* ===================== CABEÇALHO ===================== */
    F(12,true); col(15,15,15); pdf.text(nomeLoja,M,y+4);
    F(7.4); col(70,75,82);
    pdf.text([txt(lj.rua||lj.endereco),cidLoja,(txt(lj.cep)?('CEP '+txt(lj.cep)):'')].filter(Boolean).join('  -  '),M,y+8.2);
    pdf.text([(txt(lj.cnpj)?('CNPJ: '+txt(lj.cnpj)):''),(txt(lj.whatsapp)?('Fone: '+txt(lj.whatsapp)):''),txt(lj.email)].filter(Boolean).join('     '),M,y+11.6);
    F(7); col(90,95,102);
    pdf.text('Página: 1',W-M,y+4,{align:'right'});
    pdf.text('Emissão: '+(txt(t.data)||_cprData(new Date().toISOString())),W-M,y+7.4,{align:'right'});
    pdf.text('Placa '+txt(v.placa),W-M,y+10.8,{align:'right'});
    y+=14.5;
    pdf.setDrawColor(30,30,30); pdf.setLineWidth(0.5); pdf.line(M,y,W-M,y); y+=1;

    barra('CONTRATO DE COMPRA E VENDA DE VEÍCULO USADO');
    var y0=cxIni();
    F(7.6); col(20,20,20);
    pdf.text('COMPRADOR: '+nomeLoja+(txt(lj.cnpj)?('  -  CNPJ '+txt(lj.cnpj)):'')+
             (repLoja?('      Representante: '+repLoja):''), M+2, y+5);
    y+=7.4; cxFim(y0);

    /* ===================== VENDEDOR ===================== */
    barra('IDENTIFICAÇÃO DO VENDEDOR / PROPRIETÁRIO');
    y0=cxIni();
    linhaCampos([{l:'Nome completo',v:s.nome,w:2.6,b:true},{l:'CPF',v:s.cpf,w:1,b:true},
                 {l:'Telefone',v:(typeof foneFmt==='function'&&s.fone)?foneFmt(s.fone):s.fone,w:1,b:true}]);
    linhaCampos([{l:'RG',v:s.rg,w:1},{l:'CNH',v:s.cnh,w:2},{l:'Nascimento',v:s.nasc,w:1}]);
    linhaCampos([{l:'Filiação',v:s.filiacao,w:2.4},{l:'Endereço',v:[txt(s.rua),txt(s.numero)].filter(Boolean).join(', '),w:1.8}]);
    linhaCampos([{l:'Bairro',v:s.bairro,w:1.3},{l:'Cidade / UF',v:[txt(s.cidade),txt(s.uf)].filter(Boolean).join('/'),w:1.2},
                 {l:'CEP',v:s.cep,w:1}]);
    cxFim(y0);

    /* ===================== VEÍCULO ===================== */
    barra('IDENTIFICAÇÃO DO VEÍCULO');
    y0=cxIni();
    linhaCampos([{l:'Marca / Modelo',v:[txt(v.marca),txt(v.modelo)].filter(Boolean).join(' / '),w:2.6,b:true},
                 {l:'Placa',v:v.placa,w:.9,b:true},
                 {l:'Ano Fab / Mod',v:[txt(v.ano),txt(v.ano_modelo)].filter(Boolean).join(' / '),w:1,b:true},
                 {l:'Cor',v:v.cor,w:.9,b:true}]);
    linhaCampos([{l:'Chassi',v:v.chassi,w:1.8},{l:'RENAVAM',v:v.renavam,w:1.2},
                 {l:'Combustível',v:v.combustivel,w:1.2},{l:'Espécie / Tipo',v:v.especie,w:1.2}]);
    linhaCampos([{l:'Categoria',v:v.categoria,w:1},{l:'Potência / Cilindrada',v:v.potencia,w:1.2},
                 {l:'Motor',v:v.motor,w:1.3},
                 {l:'Quilometragem declarada',v:(Number(v.km)?(Number(v.km).toLocaleString('pt-BR')+' km'):''),w:1.3,b:true}]);
    linhaCampos([{l:'Registrado em',v:v.municipio,w:1.4},{l:'Licenciamento válido até',v:v.licenciado,w:1.3},
                 {l:'IPVA',v:v.ipva_sit,w:1.3}]);
    linhaCampos([{l:'Consulta DETRAN na data desta compra',v:v.detran,w:1}]);
    cxFim(y0);

    /* ===================== VALORES ===================== */
    barra('VALORES / CONDIÇÕES DE PAGAMENTO');
    y0=cxIni();
    var ext=''; try{ ext=_numExtenso(Number(t.valor)||0); }catch(_){ ext=''; }
    var saldo=Math.max(0,(Number(t.valor)||0)-(Number(t.sinal)||0));
    linhaCampos([{l:'Valor da compra',v:din(t.valor),w:1,b:true},
                 {l:'Sinal na assinatura',v:(Number(t.sinal)?din(t.sinal):''),w:1},
                 {l:'Saldo',v:(Number(t.sinal)?din(saldo):''),w:1},
                 {l:'Valor por extenso',v:ext,w:2.4}]);
    linhaCampos([{l:'Forma de pagamento',v:t.forma,w:1.6},{l:'Pagamento do saldo',v:t.quitacao,w:1.6},
                 {l:'Data da compra',v:t.data,w:1}]);
    linhaCampos([{l:'Banco',v:t.banco,w:1.2},{l:'Agência',v:t.agencia,w:.8},
                 {l:'Conta',v:t.conta,w:1.2},{l:'Chave PIX',v:t.pix,w:1.4}]);
    linhaCampos([{l:'Titular da conta',v:(txt(t.banco)||txt(t.pix))?titular:'',w:1}]);
    if(txt(t.banco)||txt(t.pix)){
      /* 🔴 a frase muda quando a conta é de terceiro. É o único jeito de o
         papel refletir a realidade em vez de repetir uma promessa padrão. */
      para(terceiro
        ? ('A conta indicada NÃO é de titularidade do VENDEDOR. O VENDEDOR autoriza expressamente o pagamento a '+
           titular+', dando plena quitação como se a si próprio houvesse sido pago.')
        : 'O pagamento será efetuado exclusivamente na conta acima, de titularidade do próprio VENDEDOR. '+
          'Conta de terceiro só será aceita mediante autorização escrita e assinada pelo VENDEDOR, anexa a este contrato.',
        7, 2.2);
    }
    cxFim(y0);

    /* ===================== TERMO DE RESPONSABILIDADE ===================== */
    barra('TERMO DE RESPONSABILIDADE SOBRE O VEÍCULO');
    y0=cxIni(); y+=1.2;
    clausula('1. Propriedade e origem.','O VENDEDOR declara ser o legítimo proprietário e possuidor do veículo acima, respondendo pela evicção de direito, e que ele se encontra '+
      (t.gravame==='sim'
        ? 'com gravame/alienação fiduciária a ser quitado nesta operação, cabendo às partes a baixa junto ao órgão competente.'
        : 'livre e desembaraçado de ônus, gravame, alienação fiduciária, arrendamento, penhora, arresto, busca e apreensão ou qualquer restrição judicial ou administrativa, bem como de registro de furto, roubo, perda total, remarcação de chassi ou adulteração de sinais identificadores.'));
    clausula('2. Débitos até a entrega.','Correm por conta exclusiva do VENDEDOR todos os débitos e responsabilidades do veículo até a data da entrega, ainda que lançados depois: IPVA, licenciamento, seguro obrigatório, taxas, multas de trânsito e respectiva pontuação, pedágios e qualquer despesa administrativa. Débitos declarados nesta data: '+
      (txt(t.debitos)||'nenhum')+'. Constatado débito anterior à entrega, o VENDEDOR se obriga a quitá-lo em até 10 (dez) dias da comunicação, ou autoriza o COMPRADOR a fazê-lo e a descontar o valor de saldo eventualmente pendente.');
    clausula('3. Multas e pontuação.','As infrações cometidas até a data da entrega são de responsabilidade do VENDEDOR, que se obriga a apresentar-se como condutor perante o órgão de trânsito quando for o caso, dentro do prazo legal.');
    clausula('4. Documentação.','O VENDEDOR entrega nesta data a documentação necessária à transferência e se obriga a assinar, no prazo de até 5 (cinco) dias úteis, todo documento que dela dependa, incluindo a Autorização para Transferência de Veículo com firma reconhecida, sob pena de responder pelas perdas e danos decorrentes do atraso.');
    /* 🔴 v821 (pedido do Angelo) — A CLÁUSULA QUE FALTAVA NA VIDA REAL.
       A loja compra pra revender e NÃO transfere o carro pra si: a
       transferência vai direto pro comprador final. Ou seja, o carro fica no
       nome do vendedor por semanas ou meses depois de ele já ter entregado a
       chave — e é justamente esse vão que gera briga. Esta cláusula escreve
       as duas obrigações que fecham o vão: a loja AVISA quando vender (pra a
       ATPV-e / DUT ser preenchida em nome do comprador final) e RESPONDE
       pelo veículo enquanto isso não acontece. */
    clausula('5. Revenda e transferência ao novo proprietário.','O COMPRADOR é revendedor de veículos e recebe o veículo para revenda, hipótese em que a transferência da propriedade será feita diretamente ao adquirente final. O COMPRADOR se obriga a comunicar o VENDEDOR e a enviar-lhe, assim que o veículo for vendido, todas as informações necessárias ao preenchimento da ATPV-e ou do CRV/DUT em nome do novo proprietário. Até a formalização dessa venda, o COMPRADOR responde pelo veículo e por multas, tributos, encargos e danos decorrentes do uso e da posse a partir da entrega, mantendo o VENDEDOR indene.');
    clausula('6. Estado do veículo.','O veículo é vendido no estado em que se encontra, usado, tendo sido previamente examinado pelo COMPRADOR. O VENDEDOR declara não ter conhecimento de vício oculto, defeito estrutural, avaria grave não reparada ou alteração mecânica não informada, respondendo na forma da lei caso venha a ser apurado o contrário.');
    clausula('7. Hodômetro.','O VENDEDOR declara que a quilometragem indicada neste instrumento é a real do veículo nesta data e que não houve qualquer adulteração no hodômetro.');
    clausula('8. Posse e riscos.','A posse do veículo transfere-se ao COMPRADOR na data da entrega, passando a correr por conta deste, a partir de então, os riscos, os tributos, as multas e as responsabilidades civis e administrativas decorrentes do uso.');
    clausula('9. Dados pessoais (LGPD).','Os dados pessoais aqui coletados são tratados exclusivamente para a execução deste contrato e para o cumprimento de obrigações legais e regulatórias, nos termos da Lei 13.709/2018.');
    if(txt(t.obs)) clausula('10. Observações.',txt(t.obs));
    cxFim(y0);

    F(6.4); col(140,145,152);
    pdf.text(nomeLoja+(txt(lj.cnpj)?('  -  CNPJ '+txt(lj.cnpj)):'')+(cidLoja?('  -  '+cidLoja):''),M,H-M+2);
    pdf.text('Página 1  -  placa '+txt(v.placa),W-M,H-M+2,{align:'right'});

    /* ===================== PÁGINA 2 ===================== */
    pdf.addPage(); y=M;
    F(11,true); col(15,15,15); pdf.text(nomeLoja,M,y+4);
    F(7); col(70,75,82);
    pdf.text('Contrato de compra e venda de veículo usado  -  placa '+txt(v.placa),M,y+7.8);
    pdf.text('Página: 2',W-M,y+4,{align:'right'});
    y+=10; pdf.setDrawColor(30,30,30); pdf.setLineWidth(0.5); pdf.line(M,y,W-M,y); y+=1;

    barra('ANEXOS E DOCUMENTOS RECEBIDOS DO VENDEDOR');
    y0=cxIni(); y+=2.5;
    /* 🔴 a lista sai da MESMA fonte da aba Documentos (_CPR_DOCS), e já vem
       MARCADA no que está anexado. Duas listas separadas divergiriam. */
    var d=_cprAtual.docs||{};
    var extras=[['pgto','Comprovante do pagamento (PIX/TED)'],['chave','Chave reserva'],['manual','Manual do proprietário']];
    var todos=_CPR_DOCS.map(function(x){ return [x[0],x[1],!!(d[x[0]]&&d[x[0]].arquivo)]; })
                .concat(extras.map(function(x){ return [x[0],x[1],false]; }));
    for(var k=0;k<todos.length;k+=2){
      y+=6.2;
      for(var c2=0;c2<2 && (k+c2)<todos.length;c2++){
        var it=todos[k+c2], x=M+3+c2*(LARG/2);
        pdf.setDrawColor(90,100,115); pdf.setLineWidth(0.3); pdf.rect(x,y-2.6,3.2,3.2);
        if(it[2]){ pdf.setLineWidth(0.6); pdf.line(x+0.6,y-1.1,x+1.3,y-0.4); pdf.line(x+1.3,y-0.4,x+2.6,y-2.1); }
        F(7.6); col(25,25,25); pdf.text(String(it[1]),x+5,y);
      }
    }
    y+=3; cxFim(y0); y+=2.5;

    barra('DECLARAÇÃO FINAL DAS PARTES');
    y0=cxIni(); y+=1.2;
    para('As partes declaram haver lido e compreendido integralmente este contrato e o Termo de Responsabilidade sobre o Veículo '+
         'constante da página 1, com o qual concordam em todos os seus termos. O VENDEDOR confirma a exatidão dos dados pessoais, '+
         'bancários e do veículo aqui informados, e responde por eles.'+
         (cidLoja?(' Fica eleito o foro da comarca de '+cidLoja+' para dirimir eventuais controvérsias.'):''), 7.4, 2.4);
    cxFim(y0); y+=6;

    F(8); col(30,30,30);
    pdf.text((cidLoja||'____________________')+', '+(txt(t.data)||'____/____/________')+'.',W-M,y,{align:'right'});
    y+=18;
    var meia=(LARG-16)/2;
    pdf.setDrawColor(60,60,60); pdf.setLineWidth(0.3);
    pdf.line(M,y,M+meia,y); pdf.line(M+meia+16,y,W-M,y);
    F(8,true); col(20,20,20);
    pdf.text('VENDEDOR',M,y+4); pdf.text('COMPRADOR',M+meia+16,y+4);
    F(7.2); col(60,64,70);
    pdf.text(txt(s.nome),M,y+7.6); pdf.text('CPF '+txt(s.cpf),M,y+11);
    pdf.text(nomeLoja,M+meia+16,y+7.6);
    pdf.text(('CNPJ '+txt(lj.cnpj)+(repLoja?('   -   '+repLoja):'')).trim(),M+meia+16,y+11);

    y+=26;
    pdf.line(M,y,M+meia,y); pdf.line(M+meia+16,y,W-M,y);
    F(8,true); col(20,20,20);
    pdf.text('TESTEMUNHA 1',M,y+4); pdf.text('TESTEMUNHA 2',M+meia+16,y+4);
    F(7.2); col(60,64,70);
    pdf.text((txt(tw.nome)+(txt(tw.cargo)?('  -  '+txt(tw.cargo)):'')) || 'Nome:',M,y+7.6);
    pdf.text(txt(tw.cpf)?('CPF '+txt(tw.cpf)):'CPF:',M,y+11);
    pdf.text('Nome:',M+meia+16,y+7.6); pdf.text('CPF:',M+meia+16,y+11);

    /* ==================================================================
       🔴 v822 — A RETIRADA, NO PÉ DO CONTRATO
       O último bloco do documento, e de propósito: é a linha que se assina
       DEPOIS, na hora em que a chave troca de mão. Ela fecha o contrato no
       tempo — data, hora, quilometragem e a assinatura de quem entregou.
       Quando os campos estão vazios ela sai com linhas em branco, pra
       preencher à caneta no pátio; preenchidos, sai impressa.
       ================================================================== */
    y+=22;   /* v822: folga real abaixo do CPF da testemunha (y+11) */
    barra('RETIRADA DO VEÍCULO');
    var yR=cxIni(); yR=y;
    y+=2;
    var rd=txt(t.retirada_data), rh=txt(t.retirada_hora);
    F(6); col(120,128,138);
    pdf.text('Data da retirada',M+3,y+3);
    pdf.text('Hora',M+3+LARG*0.30,y+3);
    pdf.text('Quilometragem na retirada',M+3+LARG*0.52,y+3);
    F(9,true); col(15,15,15);
    pdf.text(rd||'____/____/________',M+3,y+8);
    pdf.text(rh||'______:______',M+3+LARG*0.30,y+8);
    pdf.text((Number(v.km)?(Number(v.km).toLocaleString('pt-BR')+' km'):'________________'),M+3+LARG*0.52,y+8);
    y+=13;
    F(7); col(60,64,70);
    pdf.text('O VENDEDOR declara haver entregado o veículo, com as chaves e a documentação, na data e hora acima.',M+3,y);
    y+=12;
    pdf.setDrawColor(60,60,60); pdf.setLineWidth(0.3);
    pdf.line(M+3,y,M+3+meia,y); pdf.line(M+meia+16,y,W-M-3,y);
    F(7); col(60,64,70);
    pdf.text('Assinatura de quem ENTREGOU o veículo',M+3,y+4);
    pdf.text('Assinatura de quem RETIROU o veículo',M+meia+16,y+4);
    y+=7;
    pdf.setDrawColor(120,130,145); pdf.setLineWidth(0.35); pdf.rect(M,yR,LARG,y-yR+1.5);
    y+=1.5;

    y+=10;
    F(6.4); col(140,145,152);
    pdf.text('Documento gerado pelo MEV Veículos a partir dos dados informados pelo lojista. '+
             'Modelo de uso geral — confira com seu contador ou advogado antes de assinar.',M,y);
    pdf.text(nomeLoja+(txt(lj.cnpj)?('  -  CNPJ '+txt(lj.cnpj)):''),M,H-M+2);
    pdf.text('Página 2  -  placa '+txt(v.placa),W-M,H-M+2,{align:'right'});

    /* ==================================================================
       🔴 v821 — O DOWNLOAD QUE FUNCIONA NO IPHONE
       Aqui morava `pdf.save(nome)`. A skill mev-pdf-vetorial já registrava:
       o `save()` do jsPDF FALHA no iPhone e no PWA — e falha CALADO, sem
       estourar exceção, então o `catch` que existia aqui nunca rodava e o
       botão simplesmente não fazia nada. Este era o ÚNICO PDF do app ainda
       nesse caminho: ficha técnica, consultas e leilão já usavam blob +
       <a download>, que é o que funciona. Agora este também.
       ================================================================== */
    var nome='contrato-compra-'+(txt(v.placa)||'veiculo').toLowerCase()+'.pdf';
    try{
      var u=URL.createObjectURL(pdf.output('blob'));
      var a=document.createElement('a'); a.href=u; a.download=nome;
      document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){} },800);
    }catch(_){
      try{ window.open(pdf.output('bloburl'),'_blank'); }catch(_2){ toast('Não consegui gerar o PDF.'); return; }
    }
    toast('Contrato gerado ✓');
  }

  /* ---------- a porta: abrir a página da compra --------------------------- */
  async function abrirCompra(placa){
    placa=_avlKey(placa); if(!placa) return;
    _cprPlaca=placa; _cprTab='docs';
    if(!_cprCache) _cprCache=_cprLer();
    _cprAtual=_cprCache[placa]||null;
    _cprLoja=null;
    try{ _cprLoja=_lojaRec||await lojaGet()||{}; }catch(_){ _cprLoja={}; }
    /* a nuvem pode ter uma compra que este aparelho ainda não viu (o mesmo
       buraco que a v702 fechou pro bilhete do vendedor) */
    if(!_cprAtual){
      var daNuvem=await cprCarregarNuvem(placa);
      if(daNuvem){ _cprAtual=daNuvem; _cprCache[placa]=daNuvem; _cprGravaLocal(); }
    }
    if(!_cprAtual) _cprAtual=_cprNovo(placa);
    _cprCompleta(_cprAtual);   /* v821: registro antigo ganha os campos novos */
    /* o cadastro de clientes alimenta o "puxar de um cliente" */
    try{ if(typeof cliCarregar==='function' && !(typeof _clientes!=='undefined' && _clientes && _clientes.length)) cliCarregar(); }catch(_){}
    try{ if(typeof estCarregar==='function' && !(typeof _estoque!=='undefined' && _estoque && _estoque.length)) estCarregar(); }catch(_){}

    consultaUiPagina({ chave:'compra', tab:'completa', ico:_CPR_ICO.papel, cor:'blue',
      titulo:'Compra do veículo', sub:'Dados das partes, termos e contrato' },
      '<div id="cprPagina">'+_cprConteudoHtml()+'</div>');
    _cprPinta();
    Array.prototype.forEach.call(document.querySelectorAll('#cprTabs .vpx-st'),function(b){
      b.onclick=function(){ cprTrocaAba(b.getAttribute('data-step'), false); };
      b.onkeydown=function(e){ _cprTeclaAba(e, b); };
    });
    try{ consultaUiSync(); }catch(_){}
  }

/* ╔═══ src/app/05m-acesso-por-plano.js ═══════════════════════════════════ */
  /* ==========================================================================
     🔴 v840 — OS MÓDULOS DA LOJA PASSAM A DEPENDER DO PLANO
     (executa as FASES 2 e 3 do PROJETO20260901homeconsultasemodulosporplano)
     ==========================================================================
     Pedido do Angelo, 01/09: "bloqueie o acesso dos cards para não assinantes,
     mas ele consegue clicar, aparece um 'disponível pra assinantes' e as
     vantagens da consulta ou da página, chamando pra assinar".

     🔴🔴 A LINHA QUE ESTE ARQUIVO NÃO ATRAVESSA — e ela é do projeto dele,
     §1, escrita como "REGRA DE NEGÓCIO INEGOCIÁVEL":
         **assinatura da loja e tokens de consulta são produtos diferentes.**
     Então CONSULTA NENHUMA é bloqueada aqui. Nem placa, nem FIPE, nem CPF,
     nem Gravame. Quem não tem plano continua consultando de graça o que é
     de graça, e continua consultando com token o que custa token. Bloquear
     consulta por falta de assinatura mataria o funil que traz o lojista pra
     dentro — e ainda contradiria a tabela de preços, que vende TOKEN, não
     acesso. Este arquivo trata só dos MÓDULOS DE GESTÃO.

     🔴 E A SEGUNDA LINHA, que é de segurança e está no §7 do projeto:
     **O CARD NÃO É O COFRE.** O que está aqui é a CAMADA DE TELA — ela
     comunica o estado e abre a conversa de venda. O cadeado de verdade
     (servidor, RLS, revalidação de rota) é a FASE 4 e NÃO FOI FEITA. Está
     escrito assim no changelog e no documento de segurança de propósito:
     versão que diz "protegido" sem o servidor protegendo é pior que versão
     que diz "ainda não".

     ⚠️ DECISÃO CONSCIENTE, E ELA CONTRARIA UMA LINHA DO §4 (TIPO E):
     o projeto manda "em erro de rede, módulos protegidos permanecem
     fechados". AQUI NÃO. Enquanto o cofre da Fase 4 não existir, travar por
     tropeço de rede tranca um lojista PAGANTE fora do próprio estoque e não
     protege nada — quem quisesse burlar chamaria a API direto, que continua
     aberta. É a mesma escolha que o 09c-plano-repasse já tinha feito
     ("não consegui saber → não travo"), e ela deve ser INVERTIDA no dia em
     que a Fase 4 entrar. Está anotado no changelog como pendência.
     ========================================================================= */

  /* --------------------------------------------------------------------------
     1. A ESCADA DOS PLANOS — a ordem vem do _PAG_PLANOS (11-uso-pagamentos),
     que é a fonte comercial canônica. Aqui só se diz QUEM VEM DEPOIS DE QUEM.
     ⚠️ Plano novo na tabela entra aqui também, senão ele cai como "não
     reconhecido" e vira o degrau mais baixo — que trava quem paga.
     -------------------------------------------------------------------------- */
  var AC_ESCADA = { consultas149:1, parceiro:1, essencial:2, profissional:3, unico300:3, max:4, admin:9 };

  /* --------------------------------------------------------------------------
     2. QUAL MÓDULO PEDE QUAL DEGRAU
     Os degraus saem dos BENEFÍCIOS que a tabela de planos já promete — não
     foram inventados aqui:
       · "CRM de clientes e catálogo" só aparece no Lojista Pro e no Max
         → Leads, Clientes e Catálogo pedem 'profissional';
       · o Vendedor Parceiro tem vitrine, rede de repasse e mercado, mas
         `veiculos:0` → Estoque e Vendas pedem 'essencial';
       · o resto é o que qualquer plano de loja já entrega.
     🔑 CHAVE QUE NÃO ESTÁ AQUI = CARD LIVRE. É de propósito: página nova
     nasce funcionando, e ninguém precisa lembrar de liberar. O contrário —
     bloquear por padrão — faria uma página nova nascer trancada em silêncio.
     ⚠️ NUNCA PONHA UMA CONSULTA NESTA TABELA (ver a regra inegociável lá em
     cima). Ela é só de módulo de gestão.
     -------------------------------------------------------------------------- */
  var AC_MODULOS = {
    loja:        { min:'parceiro',     nome:'Minha loja' },
    estoque:     { min:'essencial',    nome:'Estoque' },
    mercado:     { min:'parceiro',     nome:'Mercado' },
    repasse_meu: { min:'parceiro',     nome:'Repasse' },
    catalogo:    { min:'profissional', nome:'Catálogo' },
    vendas:      { min:'essencial',    nome:'Vendas' },
    avaliacoes:  { min:'parceiro',     nome:'Avaliações' },
    vitrine:     { min:'parceiro',     nome:'Vitrine' },
    site:        { min:'parceiro',     nome:'Site' },
    clientes:    { min:'profissional', nome:'Leads' },
    posvendas:   { min:'profissional', nome:'Clientes' }
  };

  /* --------------------------------------------------------------------------
     3. AS VANTAGENS DE CADA MÓDULO — três por módulo, ESPECÍFICAS.
     §14 do projeto: "cada módulo bloqueado tiver benefícios específicos, não
     texto genérico". Três frases iguais em onze modais não vendem nada: a
     pessoa lê a primeira, reconhece o molde e fecha.
     ⚠️ Nenhuma delas promete consulta grátis nem fala de token. Misturar os
     dois produtos na mesma tela é exatamente o que o §6.1 proíbe.
     -------------------------------------------------------------------------- */
  var AC_VANTAGENS = {
    loja: ['Seus dados, sua logo e seus horários num cadastro só',
           'É daqui que saem o site, o catálogo e a vitrine',
           'Cada vendedor com o próprio acesso'],
    estoque: ['Organize veículos, fotos, preços e situação num lugar só',
              'O mesmo cadastro alimenta o site, o catálogo e a vitrine',
              'A equipe inteira trabalhando na mesma base'],
    mercado: ['Veja o que as lojas da sua região estão pedindo',
              'Compare o seu preço com o do mercado antes de anunciar',
              'Descubra o carro que está faltando no seu pátio'],
    repasse_meu: ['Veja os carros que outras lojas estão repassando',
                  'Faça ofertas sem sair do app',
                  'Negocie direto com o lojista, no chat'],
    catalogo: ['A lista de veículos pronta pra mandar no WhatsApp',
               'Escolha os carros e envie um link só',
               'Preço e foto saem direto do seu estoque'],
    vendas: ['Comece e acompanhe a negociação até fechar',
             'Cliente, veículo e andamento no mesmo lugar',
             'Resultados e comissões conforme o seu plano'],
    avaliacoes: ['Salve a avaliação por placa, com fotos e valor',
                 'Compare a FIPE, o mercado e o preço da sua loja',
                 'Retome a negociação sem perder o histórico'],
    vitrine: ['Seus carros numa página pronta pra mandar no WhatsApp',
              'Ela se atualiza sozinha quando o estoque muda',
              'Com a sua marca, o seu contato e o seu link'],
    site: ['A página da sua loja na internet, com endereço próprio',
           'Estoque, contato e horários sempre atualizados',
           'O cliente acha a sua loja no Google'],
    clientes: ['Cada contato com o carro que ele está procurando',
               'Nada se perde entre a mensagem e a venda',
               'A equipe vê em que pé está cada cliente'],
    posvendas: ['Quem já comprou, e quando costuma voltar',
                'Lembretes de revisão, documento e aniversário',
                'Cliente que volta custa menos que cliente novo']
  };

  /* --------------------------------------------------------------------------
     4. O ESTADO — 'livre' · 'carregando' · 'plano'
     -------------------------------------------------------------------------- */
  var _acCarregou=false, _acCarregando=null;

  function acLigado(){
    try{ return (typeof window.edAcessoPorPlano==='function') ? !!window.edAcessoPorPlano() : false; }
    catch(_){ return false; }
  }
  function acPlanoAtual(){
    try{ return (typeof pagPlanoDaAssinatura==='function') ? pagPlanoDaAssinatura() : null; }
    catch(_){ return null; }
  }
  function acDegrau(){
    var p=acPlanoAtual(); if(!p) return 0;
    return AC_ESCADA[String(p.id||'').toLowerCase()] || 0;
  }
  /* 🔴 "ainda não sei" é diferente de "não tem plano", e confundir os dois é o
     defeito que o §4 (TIPO E) manda evitar: piscar card liberado e depois
     bloquear — ou o contrário, mostrar cadeado pra quem paga. */
  function acSabe(){ return _acCarregou; }

  function acEstado(k){
    if(!acLigado()) return 'livre';
    var m=AC_MODULOS[k]; if(!m) return 'livre';            /* chave fora da tabela: livre */
    try{ if(typeof _ehAdmin==='function' && _ehAdmin()) return 'livre'; }catch(_){}
    if(!acSabe()) return 'carregando';
    var preciso=AC_ESCADA[m.min]||1;
    return (acDegrau()>=preciso) ? 'livre' : 'plano';
  }
  function acBloqueado(k){ return acEstado(k)==='plano'; }

  /* v948 — resposta conservadora usada pelas vitrines do MEV Avaliações.
     Só existe gestão quando a assinatura já foi carregada, está ativa e o
     plano alcança o módulo pedido. Estado desconhecido nunca vira edição. */
  function acPodeGerirVitrine(k){
    if(!acSabe() || acDegrau()<1) return false;
    return acEstado(k)==='livre';
  }

  /* carrega UMA vez por sessão; quem chamar de novo pega a mesma promessa */
  function acGarantir(){
    if(_acCarregou) return Promise.resolve();
    if(_acCarregando) return _acCarregando;
    _acCarregando=(async function(){
      try{ if(typeof assinaturaCarregar==='function') await assinaturaCarregar(); }catch(_){}
      _acCarregou=true;
      /* ⚠️ o `_assinatura` pode ter voltado null (rede ruim). Marcamos como
         "sabido" mesmo assim, e o degrau fica 0 — o que, com o cofre da
         Fase 4 ainda ausente, mantém a tela travada mas a rota aberta. Ver o
         cabeçalho: esta escolha se inverte quando o servidor validar. */
      try{ acAplicar(document); }catch(_){}
      return null;
    })();
    return _acCarregando;
  }

  /* --------------------------------------------------------------------------
     5. O SELO E O ESTADO NO CARD
     O selo mora no MESMO canto e na MESMA família visual do selo de preço
     (.hp-selo, v648) — a pessoa já aprendeu a olhar ali.
     -------------------------------------------------------------------------- */
  var AC_CADEADO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10.5" width="16" height="10" rx="2.2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>';

  function acNomePlano(k){
    var m=AC_MODULOS[k]; if(!m) return '';
    if(m.min==='parceiro') return '';                       /* qualquer plano serve */
    var lista=[]; try{ lista=(typeof _PAG_PLANOS!=='undefined')?_PAG_PLANOS:[]; }catch(_){}
    var p=lista.filter(function(x){ return x.aVenda!==false && (AC_ESCADA[x.id]||0)>=(AC_ESCADA[m.min]||0); })[0];
    return (p&&p.nome)||'';
  }
  function acSeloHtml(k){
    var e=acEstado(k);
    if(e==='carregando') return '<span class="hp-selo hp-selo-ac-carrega" aria-hidden="true"></span>';
    if(e!=='plano') return '';
    return '<span class="hp-selo hp-selo-plano">'+AC_CADEADO+'<i>Plano</i></span>';
  }
  /* o texto que o leitor de tela ouve — §13.18 do projeto pede o MOTIVO, não
     só o cadeado desenhado */
  function acAvisoLeitor(k){
    var n=acNomePlano(k);
    return n ? ('Incluído no plano '+n+'. Toque para ver as vantagens.')
             : 'Incluído nos planos MEV. Toque para ver as vantagens.';
  }

  /* pinta (ou repinta) TODOS os cards de módulo que estiverem na tela.
     ⚠️ Repinta em vez de remontar o painel: remontar apagaria a fileira dos
     Mais usados, o foco do teclado e a animação de entrada. */
  function acAplicar(root){
    try{
      var alvo=root||document;
      Array.prototype.forEach.call(alvo.querySelectorAll('[data-ha]'), function(b){
        var k=b.getAttribute('data-ha'); if(!k) return;
        var e=acEstado(k);
        b.classList.toggle('ac-bloq', e==='plano');
        b.classList.toggle('ac-carrega', e==='carregando');
        if(e==='plano') b.setAttribute('aria-haspopup','dialog');
        else b.removeAttribute('aria-haspopup');
        /* o selo antigo sai antes do novo entrar — senão dois selos empilham
           no mesmo canto quando o estado muda de 'carregando' pra 'plano' */
        var velho=b.querySelector('.hp-selo-plano, .hp-selo-ac-carrega');
        if(velho&&velho.parentNode) velho.parentNode.removeChild(velho);
        var novo=acSeloHtml(k);
        if(novo) b.insertAdjacentHTML('afterbegin', novo);
        var aviso=b.querySelector('.ac-sr');
        if(e==='plano'){
          if(!aviso){ aviso=document.createElement('span'); aviso.className='ac-sr sr-only'; b.appendChild(aviso); }
          aviso.textContent=acAvisoLeitor(k);
        } else if(aviso&&aviso.parentNode){ aviso.parentNode.removeChild(aviso); }
      });
    }catch(_){}
  }

  /* --------------------------------------------------------------------------
     6. O MODAL — §6.1 e §6.4 (acessibilidade)
     -------------------------------------------------------------------------- */
  var _acFoco=null, _acEsc=null, _acPrende=null;

  function acModalAbrir(k, motivo){
    var bg=$('acModal'); if(!bg){ toast('Este recurso é dos planos MEV.'); return; }
    var m=AC_MODULOS[k]||{}, nome=m.nome||k;
    var plano=acNomePlano(k);
    var permissao=(motivo==='permissao');

    _acFoco=document.activeElement||null;   /* §6.4: devolver o foco depois */

    var tit=$('acTitulo'), sub=$('acSub'), van=$('acVant'), pl=$('acPlano'),
        cta=$('acCta'), fec=$('acFechar'), ico=$('acIco');
    if(ico) ico.innerHTML=AC_CADEADO;

    if(permissao){
      /* 🔴 §4 TIPO D — FALTA DE PERMISSÃO NUNCA É APRESENTADA COMO FALTA DE
         ASSINATURA. Quem já paga e leva oferta de plano porque o gerente não
         liberou a tela sente que foi enganado — e liga pra reclamar, não pra
         comprar. Aqui não há CTA de venda. Nenhuma. */
      if(tit) tit.textContent='Você não tem permissão para acessar '+nome;
      if(sub) sub.textContent='Peça acesso ao responsável pela loja.';
      if(van) van.innerHTML='';
      if(pl)  { pl.textContent=''; pl.style.display='none'; }
      if(cta) cta.style.display='none';
      if(fec) fec.textContent='Entendi';
    } else {
      if(tit) tit.textContent = plano ? ('Disponível no plano '+plano) : 'Disponível para assinantes MEV';
      if(sub) sub.textContent = 'Use '+nome+' dentro da sua operação MEV.';
      var vs=AC_VANTAGENS[k]||[];
      if(van) van.innerHTML=vs.map(function(x){ return '<li>'+esc(x)+'</li>'; }).join('');
      if(pl){
        pl.textContent = plano ? ('Plano necessário: '+plano+'.')
                               : 'Está em qualquer plano de loja MEV.';
        pl.style.display='';
      }
      if(cta){ cta.style.display=''; cta.textContent='Conhecer os planos'; }
      if(fec) fec.textContent='Continuar nas consultas';
    }

    bg.classList.add('on');
    /* §6.4: o foco vai pro TÍTULO ao abrir (não pro botão de venda — quem
       chega no modal precisa saber onde caiu antes de decidir) */
    try{ if(tit) tit.focus(); }catch(_){}

    _acEsc=function(ev){ if(ev.key==='Escape'){ ev.preventDefault(); acModalFechar(); } };
    document.addEventListener('keydown', _acEsc);
    /* §6.4: prender o foco DENTRO do modal — sem isto o Tab sai pro fundo e
       a pessoa "some" da caixa sem saber por quê */
    _acPrende=function(ev){
      if(ev.key!=='Tab') return;
      var f=bg.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis=Array.prototype.filter.call(f, function(x){ return x.offsetParent!==null; });
      if(!vis.length) return;
      var pri=vis[0], ult=vis[vis.length-1];
      if(ev.shiftKey && document.activeElement===pri){ ev.preventDefault(); ult.focus(); }
      else if(!ev.shiftKey && document.activeElement===ult){ ev.preventDefault(); pri.focus(); }
    };
    document.addEventListener('keydown', _acPrende);
  }
  function acModalFechar(){
    var bg=$('acModal'); if(bg) bg.classList.remove('on');
    if(_acEsc){ document.removeEventListener('keydown', _acEsc); _acEsc=null; }
    if(_acPrende){ document.removeEventListener('keydown', _acPrende); _acPrende=null; }
    try{ if(_acFoco && _acFoco.focus) _acFoco.focus(); }catch(_){}   /* §6.4 */
    _acFoco=null;
  }
  function acModalLigar(){
    var bg=$('acModal'); if(!bg || bg.__ac) return; bg.__ac=1;
    var f=$('acFechar'); if(f) f.onclick=acModalFechar;
    var c=$('acCta'); if(c) c.onclick=function(){
      acModalFechar();
      try{ if(typeof telaInfo==='function'){ telaInfo('pagamentos'); return; } }catch(_){}
      try{ drawerIr('pagamentos'); }catch(_){}
    };
    /* clicar no fundo fecha — é só descoberta, não confirmação crítica (§6.4) */
    bg.onclick=function(ev){ if(ev.target===bg) acModalFechar(); };
  }

  /* --------------------------------------------------------------------------
     7. O PORTÃO — um lugar só decide, pras três portas
     (card da home · item do menu · link direto)
     Devolve true quando ELE tratou o clique; quem chama para na hora.
     -------------------------------------------------------------------------- */
  function acPortao(k){
    var e=acEstado(k);
    if(e==='livre') return false;
    if(e==='plano'){ acModalLigar(); acModalAbrir(k); return true; }
    /* 'carregando': não presumo acesso (§4 TIPO E) nem deixo a pessoa
       esperando calada. Pergunto ao servidor e refaço o clique com resposta. */
    toast('Conferindo seu plano…');
    acGarantir().then(function(){
      try{
        if(acBloqueado(k)){ acModalLigar(); acModalAbrir(k); return; }
        if(typeof homeAtalhoClique==='function'){ homeAtalhoClique(k); return; }
        drawerIr(k);
      }catch(_){}
    });
    return true;
  }

/* ╔═══ src/app/05m-vitrine-repasse.js ════════════════════════════════════ */
  /* ==========================================================================
     05m — O CARD DA VITRINE DE REPASSE  (v1067)
     --------------------------------------------------------------------------
     Pedido do Angelo: "adicone um card pra mostrar a vitrine do Lojista de
     repasses, tudo que ele coloca na rede de repasse".

     🔴 O QUE JÁ EXISTIA, E POR QUE NÃO BASTAVA:
        o Portal do Repasse já tem a aba "Meu portal" — a vitrine dele existe.
        O que não existia era VER que ela existe sem ir lá. Quem anuncia um
        carro na rede e passa a semana na tela de Avaliações não tinha
        nenhum sinal de quantos carros estão no ar, nem de quais.
        🔑 Então este card não é uma segunda vitrine: é a JANELA pra aquela.
           Tocar nele abre a mesma aba "Meu portal", com os mesmos dados.
           Duas telas pintando a mesma lista viram duas verdades no dia em
           que uma for alterada e a outra não.

     🔴 ONDE ELE MORA: logo abaixo dos três chips de situação, na área de
        Avaliações. Ali porque é a tela onde o Angelo passa o dia, e porque
        é a mesma altura da página em que ele já procura "o que está
        acontecendo com meus carros".

     🔴 POR QUE É UM ARQUIVO NOVO: o 05c-avaliacoes.js está com 109 KB, acima
        do teto de ~80 KB da casa (CLAUDE.md, v729 FASE 4). O 05c recebe só o
        gancho.
     ========================================================================== */

  /* 🔴🔴 "AINDA NÃO CARREGUEI" É DIFERENTE DE "NÃO TEM NENHUM", e a tela
     PRECISA saber a diferença. O `_repMeu` nasce `[]` — o mesmo valor dos dois
     casos. Sem esta bandeira, quem abre a tela com a internet lenta leria
     "Você ainda não anunciou nenhum carro" com oito carros no ar.
     ⚠️ Ela é ligada dentro do `repPortalCarregar` (09-portal-repasse.js), e
        não aqui: assim vale por QUALQUER caminho que carregue o portal — a
        home, a tela do Portal ou esta. Um só lugar diz "já sei". */
  var _vitRepPronto=false;

  function _vitRepMeus(){
    /* v1147 — vitrine é catálogo para enviar, não arquivo operacional.
       Mostra somente anúncio no ar e ainda disponível. Vendido continua
       guardado na gestão, mas não entra na contagem nem no catálogo público. */
    return (_repMeu||[]).filter(function(x){ return x && x.ativo!==false && !x.vendido; });
  }

  /* v1155 — a visão interna do catálogo também ajuda a acompanhar o funil.
     Enviamos somente dados comerciais de apresentação para o iframe local;
     valores privados da avaliação, cliente e observações não saem do app.
     O link público não recebe esta mensagem e continua contendo apenas o que
     foi efetivamente publicado na rede de repasses. */
  function vitRepCotandoDados(){
    var publicados=Object.create(null);
    _vitRepMeus().forEach(function(r){ var p=_avlKey(r&&r.placa); if(p) publicados[p]=1; });
    return (_avlCache||[]).filter(function(a){
      var p=_avlKey(a&&a.placa);
      return p && !publicados[p] && avlSituacao(p)==='cotando';
    }).map(function(a){
      var placa=_avlKey(a.placa), h=_avlDoHistorico(placa), hv=(h&&h.v)||{}, f=_avlFonteVeic(placa);
      var fotos=(a.fotos&&a.fotos.length?a.fotos:f.fotos)||[];
      fotos=fotos.map(function(x){ return (x&&x.url)||x; }).filter(function(x){ return typeof x==='string'&&x; });
      return {
        placa:placa,
        modelo:_avlModelo(a.modelo||(h&&h.modelo)||'Veículo'),
        ano:String(a.ano||hv.ano_modelo||hv.ano||''),
        km:Number(a.km||f.km||_avlKmDe(placa)||hv.km)||0,
        cor:String(a.cor||f.cor||hv.cor||''),
        foto:fotos[0]||'',
        estado:_avlAvaliado(placa)?'Avaliado':'Cotando'
      };
    });
  }

  /* ==========================================================================
     🔴🔴🔴 v1077 — A VITRINE VIROU O QUARTO CARD DA LINHA DE SITUAÇÃO
     --------------------------------------------------------------------------
     Pedido do Angelo, com print: "vitrine repasse deixe um card igual cotando
     comprados ou vendidos, na mesma linha, quando clica nele vai pra uma
     página apenas dos repasses que a loja tem cadastrada no portal do
     repasse".

     🔑 A LINHA JÁ TINHA O LUGAR. A `.avl-chips` é um grid de QUATRO colunas
        desde a v937 e só três estavam ocupadas — a quarta ficava vazia. Não
        apertei nada pra ele caber.

     ⚠️ ELE NÃO É UM FILTRO, E ISSO PRECISA ESTAR DITO NO HTML, não só no meu
        comentário. Os três vizinhos filtram a lista e por isso carregam
        `aria-pressed` e a classe `.avl-chip` — que é por onde o
        `avlChipsPinta()` (05c) acha os filtros pra acender e contar. Este
        card NAVEGA. Então ele tem a mesma roupa (`.avl-status-card`) e NÃO
        tem nem a classe `.avl-chip` nem o `aria-pressed`: quem varre os
        filtros passa por ele sem tocar, e o leitor de tela não anuncia um
        liga-desliga que não existe.

     ⚠️ A TIRA DE MINIATURAS SAIU. Num card de 82px de altura não cabe — e o
        que decide o toque ali é o NÚMERO de carros no ar, não a foto deles.
        O `_vitRepFoto`, o `VIT_REP_TETO` e o CSS da tira foram apagados
        junto: código que ninguém chama é código que alguém religa sem saber.
     ========================================================================== */

  /* o ícone é o MESMO do atalho "Repasse" do menu — duas setas em laço.
     Card novo com desenho inventado obriga a aprender um símbolo a mais. */
  var _VIT_REP_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';
  var _VIT_ARQ_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16v13H4z"/><path d="M3 3h18v4H3z"/><path d="M9 11h6"/></svg>';

  function vitRepCardHtml(){
    /* nasce escondido: card vazio piscando na abertura é ruído, e a régua da
       casa diz que vazio não é limpo. Ele aparece quando tem o que dizer. */
    return '<button type="button" class="avl-status-card vitrep-chip" id="vitRepCard" hidden '+
             'aria-label="Repasses — abrir o catálogo da minha loja">'+
      _VIT_REP_ICO+
      '<span>Repasses</span>'+
      /* a MESMA peça de número dos três vizinhos — ver a nota no styles.css */
      '<b class="avl-chip-count vitrep-n" id="vitRepN"></b>'+
    '</button>';
  }

  function avlArquivadosCardHtml(){
    return '<button type="button" class="avl-status-card vitrep-chip" id="avlArquivadosCard" aria-label="Abrir cotações arquivadas">'+
      _VIT_ARQ_ICO+'<span>Arquivados</span><b class="avl-chip-count vitrep-n" id="avlArquivadosN"></b></button>';
  }

  function avlArquivadosPinta(){
    var c=$('avlArquivadosCard'); if(!c) return;
    var n=(_avlCache||[]).filter(function(a){ return avlSituacao(a.placa)==='arquivado'; }).length;
    var ct=$('avlArquivadosN'); if(ct) ct.textContent=n?String(n):'';
    c.title=n?(n+(n===1?' cotação arquivada':' cotações arquivadas')):'Nenhuma cotação arquivada';
  }

  function avlArquivadosWire(){
    var c=$('avlArquivadosCard'); if(!c||c._lig) return; c._lig=1;
    c.onclick=function(){ try{ telaAvaliacoes('arquivados'); }catch(_){ toast('Não consegui abrir os arquivados.'); } };
  }

  function vitRepPinta(){
    var c=$('vitRepCard'); if(!c) return;
    /* enquanto não carregou, o card NÃO fala — nem pra dizer que está vazio */
    if(!_vitRepPronto){ c.hidden=true; return; }

    var meus=_vitRepMeus(), cotando=[];
    try{ cotando=vitRepCotandoDados(); }catch(_){ cotando=[]; }
    var n=meus.length+cotando.length;
    c.hidden=false;

    var cnt=$('vitRepN');
    if(cnt) cnt.textContent=n?String(n):'';
    /* 🔑 O DETALHE NÃO CABE NO CARD, MAS NÃO PODE SUMIR. A frase que antes
       ficava embaixo do título vive agora no `title` e no `aria-label`: quem
       para o dedo em cima lê, e o leitor de tela lê sempre. Guardar o número
       só no balãozinho azul deixaria "3" sem dizer três do quê. */
    var frase = !n
      ? 'Nenhum veículo em repasse ou cotação'
      : (n===1?'1 veículo entre repasses e cotações':(n+' veículos entre repasses e cotações'));
    try{
      c.setAttribute('title','Vitrine de repasse — '+frase);
      c.setAttribute('aria-label','Vitrine de repasse: '+frase+'. Abrir o catálogo da minha loja.');
    }catch(_){}
  }

  function vitRepWire(){
    var c=$('vitRepCard'); if(!c || c._lig) return;
    c._lig=1;
    c.onclick=function(){
      /* v1147 — este card é uma VITRINE, portanto abre a página pública que
         a loja envia aos outros lojistas. A antiga aba "Meu portal" misturava
         assinantes, rede, particulares, ofertas e filtros administrativos —
         tudo ruído para quem só quer conferir e compartilhar o catálogo. */
      try{
        if(typeof avaliaVitrinePublicaAbrir!=='function'){ toast('A vitrine de repasses não está disponível agora.'); return; }
        avaliaVitrinePublicaAbrir('repasse');
      }catch(e){ try{ toast('Não consegui abrir a vitrine de repasses.'); }catch(_){} }
    };
  }

/* ╔═══ src/app/05n-home-futura-consultas.js ══════════════════════════════ */
  /* ==========================================================================
     v1328 — VANTAGENS DENTRO DA HOME ATUAL DO MEV CONSULTAS
     --------------------------------------------------------------------------
     A página de prévia saiu. O carrossel entra na Home já existente, depois
     de todo o catálogo de consultas. As tarefas e os produtos ficam primeiro;
     as vantagens encerram a página sem criar rota ou item de menu separado.

     O avanço automático acontece enquanto o carrossel está visível. Toque e
     foco pausam a rotação; aba oculta e movimento reduzido a suspendem. Ao
     trocar de card, a leitura entra em uma sequência curta (ícone, frases,
     benefícios e CTA), sem reiniciar durante a rolagem e sem animação em
     movimento reduzido.
     Os CTAs somente abrem as rotas reais e nunca executam nem cobram uma
     consulta automaticamente. */
  var _fhcTimer=0, _fhcIndice=0, _fhcVisivel=false, _fhcPausaAte=0, _fhcObserver=null;
  var _FHC_ICO={
    seta:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
    voltar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    pdf:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h6"/></svg>'
  };
  function fhcBeneficios(lista){
    return '<ul class="fhc-beneficios">'+lista.map(function(x){return '<li><span>'+_FHC_ICO.check+'</span>'+esc(x)+'</li>';}).join('')+'</ul>';
  }
  function fhcSlide(classe,rotulo,titulo,texto,beneficios,acao,cta,ico){
    return '<article class="fhc-slide '+classe+'" role="group" aria-roledescription="slide" aria-label="'+esc(rotulo)+'">'+
      '<div class="fhc-slide-copy"><span class="fhc-slide-ico">'+ico+'</span><p class="fhc-kicker">'+esc(rotulo)+'</p><h3>'+esc(titulo)+'</h3><p>'+esc(texto)+'</p>'+
      fhcBeneficios(beneficios)+'<button type="button" class="fhc-slide-cta" data-fhc-acao="'+acao+'">'+esc(cta)+_FHC_ICO.seta+'</button></div><div class="fhc-orbe" aria-hidden="true"><i></i><b></b><em></em></div></article>';
  }
  function fhcHtml(){
    return '<section class="fhc-home-slides" id="homeVantagensConsultas" aria-labelledby="fhcVantagensTit">'+
      '<div class="fhc-sec-head"><div><p class="fhc-kicker">Um app, várias decisões</p><h2 id="fhcVantagensTit">Escolha a consulta certa</h2></div><div class="fhc-setas"><button type="button" id="fhcAnterior" aria-label="Vantagem anterior">'+_FHC_ICO.voltar+'</button><button type="button" id="fhcProximo" aria-label="Próxima vantagem">'+_FHC_ICO.seta+'</button></div></div><div class="fhc-viewport" id="fhcViewport" tabindex="0" aria-label="Vantagens das consultas">'+
        fhcSlide('fhc-azul','Veículos','Conheça o veículo antes de negociar.','Da referência FIPE aos sinais que merecem atenção, cada informação chega em uma leitura direta.',['Valor de referência e dados do veículo','Leilão, perda total e restrições','Recall, gravame e histórico'],'premium','Conhecer consultas veiculares',_CT_ICO.premium)+
        fhcSlide('fhc-dourado','Pessoas','Analise riscos com mais contexto.','Consulte informações que apoiam decisões comerciais sem transformar um único dado em resposta definitiva.',['Score bancário e operações financeiras','Ações e processos encontrados','Resultado salvo para consultar depois'],'cpf','Ver consultas de pessoa',_CT_ICO.cpf)+
        fhcSlide('fhc-verde','Empresas','Entenda melhor com quem você negocia.','Dados cadastrais, compliance e processos em uma jornada clara, com preço informado antes da confirmação.',['Situação cadastral e dados da empresa','Compliance e listas públicas','Ações e processos da empresa'],'cnpj','Ver consultas de empresa',_CT_ICO.cnpj)+
        fhcSlide('fhc-gelo','Relatórios','Do resultado à ação, sem complicação.','Resultados organizados para leitura no app e, quando disponível, em PDF para guardar ou compartilhar.',['Histórico centralizado no app','PDF com ações padronizadas','Nova consulta sempre sob sua confirmação'],'historico','Abrir histórico',_FHC_ICO.pdf)+
      '</div><div class="fhc-pontos" id="fhcPontos" role="tablist" aria-label="Escolher vantagem"><button type="button" role="tab" aria-selected="true" aria-label="Veículos"></button><button type="button" role="tab" aria-selected="false" aria-label="Pessoas"></button><button type="button" role="tab" aria-selected="false" aria-label="Empresas"></button><button type="button" role="tab" aria-selected="false" aria-label="Relatórios"></button></div></section>';
  }
  function fhcAtualizar(indice,mover,instantaneo){
    var vp=$('fhcViewport');if(!vp)return;
    var slides=vp.querySelectorAll('.fhc-slide');if(!slides.length)return;
    _fhcIndice=Math.max(0,Math.min(slides.length-1,indice));
    var alvo=slides[_fhcIndice];
    if(mover!==false)vp.scrollTo({left:alvo.offsetLeft,behavior:(instantaneo||fhcMovimentoReduzido())?'auto':'smooth'});
    fhcAnimar(slides,_fhcIndice);
    var pts=$('fhcPontos');if(pts)Array.prototype.forEach.call(pts.children,function(p,i){p.setAttribute('aria-selected',i===_fhcIndice?'true':'false');});
    var ant=$('fhcAnterior'),pro=$('fhcProximo');if(ant)ant.disabled=_fhcIndice===0;if(pro)pro.disabled=_fhcIndice===slides.length-1;
  }
  function fhcMovimentoReduzido(){try{return !!window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(_){return false;}}
  function fhcAnimar(slides,indice){
    var vp=$('fhcViewport'),bloco=$('homeVantagensConsultas');if(!vp||!bloco||!slides[indice])return;
    var chave=String(indice);if(vp.getAttribute('data-fhc-ativo')===chave)return;
    vp.setAttribute('data-fhc-ativo',chave);
    Array.prototype.forEach.call(slides,function(slide,i){slide.classList.toggle('is-active',i===indice);});
    if(fhcMovimentoReduzido())return;
    bloco.classList.remove('fhc-motion-ready');
    void slides[indice].offsetWidth;
    bloco.classList.add('fhc-motion-ready');
  }
  function fhcTimerLimpar(){if(_fhcTimer)clearTimeout(_fhcTimer);_fhcTimer=0;}
  function fhcPausar(){_fhcPausaAte=Date.now()+8000;fhcTimerLimpar();fhcAuto(8050);}
  function fhcAuto(atraso){
    fhcTimerLimpar();
    if(fhcMovimentoReduzido()||window.matchMedia('(max-width:760px)').matches||!_fhcVisivel||document.hidden)return;
    var espera=Math.max(Number(atraso)||4800,_fhcPausaAte-Date.now());
    _fhcTimer=setTimeout(function(){
      if(fhcMovimentoReduzido()||window.matchMedia('(max-width:760px)').matches||!_fhcVisivel||document.hidden)return;
      if(Date.now()<_fhcPausaAte){fhcAuto(_fhcPausaAte-Date.now()+80);return;}
      var vp=$('fhcViewport'),slides=vp&&vp.querySelectorAll('.fhc-slide');if(!slides||!slides.length)return;
      var proximo=(_fhcIndice+1)%slides.length;
      fhcAtualizar(proximo,true,proximo===0);
      fhcAuto();
    },espera);
  }
  function fhcIr(acao){
    fhcPausar();
    if(acao==='cpf'){abrirRestricao();return;}
    if(acao==='cnpj'){abrirCnpj();return;}
    if(acao==='historico'){abrirHistorico();return;}
    if(acao==='premium'){try{consIr('premium');}catch(_){try{drawerIr('plus');}catch(__){}}}
  }
  function homeVantagensConsultasMontar(host){
    if(typeof edicaoAtual==='function'&&['consultas','avalia'].indexOf(edicaoAtual())<0)return false;
    host=host||$('homePainel');if(!host)return false;
    var bloco=$('homeVantagensConsultas'),catalogo=host.querySelector('.hcp-catalog');
    if(!bloco){if(!catalogo)return false;catalogo.insertAdjacentHTML('afterend',fhcHtml());bloco=$('homeVantagensConsultas');}
    if(!bloco||bloco.getAttribute('data-fhc-ligado')==='1')return !!bloco;
    bloco.setAttribute('data-fhc-ligado','1');
    Array.prototype.forEach.call(bloco.querySelectorAll('[data-fhc-acao]'),function(b){b.onclick=function(){fhcIr(b.getAttribute('data-fhc-acao'));};});
    var ant=$('fhcAnterior'),pro=$('fhcProximo');if(ant)ant.onclick=function(){fhcPausar();fhcAtualizar(_fhcIndice-1,true);};if(pro)pro.onclick=function(){fhcPausar();fhcAtualizar(_fhcIndice+1,true);};
    var pts=$('fhcPontos');if(pts)Array.prototype.forEach.call(pts.children,function(p,i){p.onclick=function(){fhcPausar();fhcAtualizar(i,true);};});
    var vp=$('fhcViewport');if(vp){vp.addEventListener('pointerdown',fhcPausar,{passive:true});vp.addEventListener('focusin',fhcPausar);var raf=0;vp.addEventListener('scroll',function(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;var ss=vp.querySelectorAll('.fhc-slide'),melhor=0,dist=Infinity;Array.prototype.forEach.call(ss,function(s,i){var d=Math.abs(s.offsetLeft-vp.scrollLeft);if(d<dist){dist=d;melhor=i;}});fhcAtualizar(melhor,false);});},{passive:true});}
    fhcAtualizar(0,false);_fhcPausaAte=0;
    if(typeof IntersectionObserver==='function'){
      if(_fhcObserver)_fhcObserver.disconnect();
      _fhcObserver=new IntersectionObserver(function(entradas){
        var e=entradas&&entradas[0];_fhcVisivel=!!(e&&e.isIntersecting&&e.intersectionRatio>=.35);
        if(_fhcVisivel)fhcAuto(1400);else fhcTimerLimpar();
      },{threshold:[0,.35,.65]});
      _fhcObserver.observe(bloco);
    }else{_fhcVisivel=true;fhcAuto(1400);}
    document.addEventListener('visibilitychange',function(){if(document.hidden)fhcTimerLimpar();else if(_fhcVisivel)fhcAuto(1000);});
    return true;
  }
  window.homeVantagensConsultasMontar=homeVantagensConsultasMontar;

/* ╔═══ src/app/06-pdf-consulta.js ════════════════════════════════════════ */
  /* ===== PDF da CONSULTA SIMPLES (placa + evolução da FIPE + ficha técnica) =====
     Vetorial (texto de verdade no PDF, nítido em qualquer zoom) e com quebra de
     página automática. Entrega via compartilhar (iPhone: "Salvar em Arquivos") ou
     baixa direto no computador. */
  /* 🔴🔴 v615 — A PRÉVIA QUE CORTAVA NO IPHONE.
     O print do Angelo mostrava o PDF da FIPE cortado na direita ("UNO
     VIVACE/RUA 1.0 EVO Fire F…", "R$ 34.841,00 (código 00140…") e a tabela
     de tendência só com MAR/ABR/MAI. O DOCUMENTO estava certo — quem estava
     errado era a janelinha.

     A causa: a prévia era um <iframe> com o PDF dentro e um `#view=FitH` no
     endereço, que o Safari do iPhone IGNORA. Ele desenha o papel A4 no
     tamanho real dentro de um telefone de 390px e corta o que sobra. Não tem
     CSS que conserte: quem desenha ali dentro é o leitor de PDF do sistema,
     não a nossa página.

     🔑 O visor CERTO já existia no app desde sempre: o relatorioVisor() do
     05-historico-e-home.js, que mostra uma IMAGEM das páginas — e imagem em
     <img> obedece largura 100% e não corta em lugar nenhum. O relatório de
     leilão (19-documentos-e-init.js:779) já usava esse caminho. O PDF da
     FIPE é que caía no pdfVisor, que era pra ser o atalho de emergência e
     virou o padrão sem ninguém notar.

     O conserto mora AQUI, no lugar por onde todo mundo passa (mesma lição do
     gancho único do show() na v601): quem tem as PÁGINAS do kit em mãos
     ganha a prévia boa de graça, é só passar o 4º argumento.

     ⚠️ O `paginas` é OPCIONAL de propósito — a chamada de 3 argumentos (o
     pdfConsultaSimples, que é jsPDF vetorial e não tem canvas nenhum)
     continua funcionando igual, no plano B. */
  /* ⚠️ v918 — o 5º argumento (`op`) é OPCIONAL e só chega ao visor de prévia:
     hoje ele carrega o `compartilharPrint`, a terceira ação do visor. As
     chamadas de 3 e 4 argumentos seguem idênticas, e o plano B (pdfVisor de
     iframe) ignora a opção de propósito — lá não há prévia pra acompanhar. */
  function pdfEntregar(blob, nome, placa, paginas, op){
    try{
      if(paginas && paginas.length && typeof kitPrevia==='function' && typeof relatorioVisor==='function'){
        relatorioVisor(kitPrevia(paginas), blob, nome, op); return;
      }
    }catch(_){}
    /* v244 · PLANO B: o visor de iframe. Só chega aqui quem não tem as
       páginas desenhadas (ou se o desenho falhar). */
    try{ if(typeof pdfVisor==='function'){ pdfVisor(blob, nome); return; } }catch(_){}
    var baixar=function(){ try{ var url=URL.createObjectURL(blob), a=document.createElement('a'); a.href=url; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(url); a.remove(); },900); toast('PDF gerado.'); }catch(_){ toast('Não consegui baixar o PDF.'); } };
    /* 🔴 v1086 — MESMA CONTA INVERTIDA DOS OUTROS TRÊS LUGARES: era
       `if(navigator.canShare)`, e o Mac tem essa API, então o plano B também
       abria a folha de compartilhamento em vez de baixar. Aqui NÃO há visor
       nem botão "Compartilhar" do lado: quem chegou neste caminho pediu o
       PDF e só. No computador, baixar. No iPhone, a folha — que é o que leva
       pro app Arquivos. */
    if(podeBaixarArquivo()){ baixar(); return; }
    try{
      var file=new File([blob], nome, {type:'application/pdf'});
      if(navigator.canShare && navigator.canShare({files:[file]})){
        var dados={files:[file],title:'Consulta '+placa};
        if(op&&op.textoCompartilhar) dados.text=String(op.textoCompartilhar);
        navigator.share(dados)
          .then(function(){ toast('No iPhone, escolha “Salvar em Arquivos”.'); })
          .catch(function(err){ if(!(err&&err.name==='AbortError')) baixar(); });
        return; }
    }catch(_){}
    baixar();
  }
  /* v1293 — uma única porta para as três ações compactas do resultado.
     Visualizar conserva o visor interno; baixar respeita o caminho do iPhone;
     compartilhar entrega o arquivo ao sistema e volta ao visor se não houver
     compartilhamento nativo. */
  function pdfArquivoAcao(blob, nome, modo, abrir, titulo){
    modo=String(modo||'visualizar');
    function baixar(){
      try{ var u=URL.createObjectURL(blob),a=document.createElement('a');a.href=u;a.download=nome;document.body.appendChild(a);a.click();setTimeout(function(){URL.revokeObjectURL(u);a.remove();},900);toast('PDF baixado.'); }
      catch(_){ toast('Não consegui baixar o PDF.'); }
    }
    function compartilhar(aoFalhar){
      try{
        var file=new File([blob],nome,{type:'application/pdf'});
        if(navigator.canShare&&navigator.canShare({files:[file]})){
          navigator.share({files:[file],title:titulo||nome}).catch(function(err){ if(!(err&&err.name==='AbortError')&&aoFalhar) aoFalhar(); });
          return true;
        }
      }catch(_){}
      if(aoFalhar) aoFalhar(); return false;
    }
    if(modo==='visualizar'){ abrir(); return; }
    if(modo==='compartilhar'){
      compartilhar(function(){ abrir(); toast('Compartilhamento direto indisponível. Use o ícone verde no visor.'); });
      return;
    }
    if(!podeBaixarArquivo()){ compartilhar(function(){ baixar(); }); return; }
    baixar();
  }
  /* ===== v623 — A PLACA DESENHADA DENTRO DE UMA PLACA =======================
     Pedido do Angelo (24/08, com print): "deixe os dados da placa dentro de
     uma placa (mercosul ou antiga, dependendo da placa)". Até aqui o
     cabeçalho escrevia o número como texto branco solto.

     🔑 A REGRA NÃO FOI INVENTADA: é a MESMA do placaMercosul() do
     05-historico-e-home, que os cards do Histórico já usam —
     /^[A-Z]{3}[0-9]{4}$/ é placa antiga (tarja cinza "BRASIL", número com
     hífen), qualquer outra é Mercosul (tarja azul "MERCOSUL" + bandeirinha).
     Aquela função devolve HTML e não serve dentro do jsPDF; o que se
     reaproveita aqui é a REGRA, redesenhada em vetor.

     ⚠️ NOTA DE IDENTIDADE (v595): a moldura de placa foi TIRADA do outro
     gerador (o kit padrão MEV) de propósito, porque é a assinatura visual de
     um concorrente. Aqui ela ENTRA porque o Angelo pediu de novo e com todas
     as letras, neste PDF específico — mas fica desenhada com a cara da casa
     (azul MEV na tarja, cantos suaves), não como réplica. Se um dia o
     incômodo com a semelhança voltar, é este bloco que sai. */
  function _pdfPlaca(doc, placa, xDir, yTopo){
    var s=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!s) return;
    var antiga=/^[A-Z]{3}[0-9]{4}$/.test(s);
    var txt=antiga?(s.slice(0,3)+'-'+s.slice(3)):s;
    var w=44, h=15, x=xDir-w, y=yTopo, tarja=4.6;
    doc.setFillColor(255,255,255); doc.setDrawColor(15,23,42); doc.setLineWidth(0.5);
    doc.roundedRect(x,y,w,h,1.8,1.8,'FD');
    if(antiga){
      doc.setFillColor(203,213,225); doc.roundedRect(x+0.6,y+0.6,w-1.2,tarja,1.2,1.2,'F');
      doc.setFillColor(203,213,225); doc.rect(x+0.6,y+tarja-0.6,w-1.2,1.2,'F');
      doc.setTextColor(51,65,85); doc.setFont('helvetica','bold'); doc.setFontSize(4.6);
      doc.text('BRASIL', x+w/2, y+3.9, {align:'center'});
    } else {
      doc.setFillColor(10,77,166); doc.roundedRect(x+0.6,y+0.6,w-1.2,tarja,1.2,1.2,'F');
      doc.setFillColor(10,77,166); doc.rect(x+0.6,y+tarja-0.6,w-1.2,1.2,'F');
      doc.setTextColor(255,255,255); doc.setFont('helvetica','bold'); doc.setFontSize(4.6);
      doc.text('MERCOSUL', x+w/2, y+3.9, {align:'center'});
      /* a bandeirinha do Mercosul, no canto — dois filetes, sem virar desenho */
      doc.setFillColor(56,189,248); doc.rect(x+w-6.4,y+1.6,3.4,1.1,'F');
      doc.setFillColor(250,204,21); doc.rect(x+w-6.4,y+2.7,3.4,1.1,'F');
    }
    doc.setFont('courier','bold'); doc.setFontSize(15); doc.setTextColor(15,23,42);
    doc.text(txt, x+w/2, y+h-3.4, {align:'center'});
    doc.setLineWidth(0.2);
  }
  /* a MESMA fórmula do _mil() do gráfico da avaliação (02-icones-e-telas):
     não inventar conta nova pra escrever o mesmo número de outro jeito */
  function _pdfMil(x){
    x=Number(x)||0;
    if(x>=1000){ var k=x/1000; return 'R$ '+(k>=100?String(Math.round(k)):k.toFixed(1).replace('.',','))+' mil'; }
    return brl(x);
  }
  function pdfConsultaSimples(it){
    if(!_mevPdfPronto(function(){ pdfConsultaSimples(it); },false)) return;
    var v=(it&&it.v)||veiculoAtual||{}, ficha=(it&&it.ficha)||fichaState||null;
    var placa=String(v.placa||(it&&it.placa)||'consulta');
    toast('Gerando PDF…');
    try{
      var doc=new window.jspdf.jsPDF('p','mm','a4');
      var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
      var M=12, cw=W-2*M, gap=8, colW=(cw-gap)/2, xL=M, xR=M+colW+gap, y=0;
      function humano(k){ return String(k).replace(/_/g,' ').replace(/(^|\s)\S/g,function(c){return c.toUpperCase();}); }
      function corta(s,n){ s=String(s||''); return s.length>n?(s.slice(0,n-1).replace(/\s+\S*$/,'')+'…'):s; }
      function secao(t){ y+=3; doc.setTextColor(0,30,80); doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.text(String(t).toUpperCase(), M, y); y+=1.4; doc.setDrawColor(0,30,80); doc.setLineWidth(0.4); doc.line(M,y,M+cw,y); doc.setLineWidth(0.2); y+=4.4; }
      /* pares [rótulo,valor] em DUAS colunas — devolve a altura usada */
      function duasColunas(pares){
        pares=pares.filter(function(p){ var val=String(p[1]==null?'':p[1]).trim(); return val && val!=='/' && val!=='—'; });
        if(!pares.length) return;
        /* v623 (pedido): "deixe uma margem maior de um campo para o outro".
           A altura de linha era 4,7mm — as linhas ficavam coladas. Foi pra
           6,6mm (+40%), e a linha divisória desceu junto, na mesma proporção
           (ela fica a 1/3 do respiro acima da próxima linha, não colada). */
        var meio=Math.ceil(pares.length/2), esq=pares.slice(0,meio), dir=pares.slice(meio), rh=6.6;
        function desenha(arr,x){ var yy=y; arr.forEach(function(p){
          doc.setTextColor(120,132,148); doc.setFont('helvetica','normal'); doc.setFontSize(7.4); doc.text(corta(p[0],26), x, yy+3);
          doc.setTextColor(15,23,42); doc.setFont('helvetica','bold'); doc.text((doc.splitTextToSize(String(p[1]), colW-30)[0])||String(p[1]), x+colW, yy+3, {align:'right'});
          yy+=rh; doc.setDrawColor(238,241,246); doc.line(x,yy-2.2,x+colW,yy-2.2);
        }); return yy; }
        var yE=desenha(esq,xL), yD=desenha(dir,xR); y=Math.max(yE,yD)+1.5;
      }
      function linhaTexto(txt,fs,cor){ var ls=doc.splitTextToSize(String(txt), cw); doc.setFont('helvetica','normal'); doc.setFontSize(fs||7.8); doc.setTextColor(cor?cor[0]:55,cor?cor[1]:65,cor?cor[2]:80); ls.forEach(function(l){ doc.text(l, M, y+3); y+=fs?fs*0.52:4.2; }); }
      function rotulo(t){ doc.setTextColor(0,30,80); doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.text(String(t), M, y+3); y+=4.6; }

      /* cabeçalho azul compacto */
      doc.setFillColor(0,30,80); doc.rect(0,0,W,26,'F');   /* v623: 22 -> 26mm (a placa desenhada pede o respiro) */
      doc.setTextColor(255,255,255); doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.text('MEV Veículos', M, 9.5);
      doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(159,195,255); doc.text('Consulta de veículo', M, 15);
      /* v623: a placa DESENHADA (antiga ou Mercosul, conforme o número) no
         lugar do texto branco solto. A faixa azul cresceu de 22 pra 26mm pra
         a moldura caber com respiro. */
      _pdfPlaca(doc, placa, W-M, 4.5);
      var modelo=(((v.marca||'')+' '+(v.modelo||'')).trim())||((it&&it.modelo)||''); if(v.ano) modelo+=' · '+v.ano;
      doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(159,195,255); doc.text((doc.splitTextToSize(modelo,cw*0.52)[0])||'', M, 21, {align:'left'});
      y=32;

      /* dados do veículo (2 colunas) */
      secao('Dados do veículo');
      duasColunas([
        ['Marca / modelo', ((v.marca||'')+' '+(v.modelo||'')).trim()],
        ['Ano fab. / mod.', (function(){ var a=String(v.ano==null?'':v.ano).trim(), m=String(v.ano_modelo==null?'':v.ano_modelo).trim(); return (a&&m)?(a+' / '+m):(a||m); })()],   /* v615: o rótulo diz fab./mod., então mostra OS DOIS — inclusive quando são iguais */
        ['Cor', v.cor], ['Combustível', v.combustivel],
        ['Código FIPE', v.codigo_fipe], ['Ref. FIPE', v.mes_ref],
        ['Chassi', v.chassi?(typeof chassiMask==='function'?chassiMask(v.chassi):v.chassi):'']
      ]);

      /* valor + evolução da FIPE (janela de 6 meses) */
      secao('Valor e evolução da FIPE · 6 meses');
      doc.setFillColor(240,253,244); doc.roundedRect(M,y,cw,11,2,2,'F');
      doc.setTextColor(21,128,61); doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.text('Valor FIPE atual', M+4, y+4.6);
      doc.setFontSize(14); doc.text(brl(v.fipe||0), M+cw-4, y+7.6, {align:'right'});
      y+=14;
      var h=verHistDe(v).filter(function(x){ return x&&x.valor!=null; });
      if(h.length>=2){
        h=h.slice().sort(function(a,b){ return String(b.mes||'')<String(a.mes||'')?-1:1; });
        var jan=h.slice(0,6);                                   /* últimos 6 meses */
        var atual=Number(jan[0].valor)||0, iBase=jan.length-1, base=Number(jan[iBase].valor)||0;
        var dd=atual-base, pp=base?(dd/base*100):0, sinal=dd>=0?'+':'-';
        var vals=jan.map(function(x){ return Number(x.valor)||0; });
        var max=Math.max.apply(null,vals), min=Math.min.apply(null,vals), maxI=vals.indexOf(max), minI=vals.indexOf(min);
        doc.setFont('helvetica','normal'); doc.setFontSize(8.2); doc.setTextColor(15,23,42);
        doc.text('Variação em 6 meses: '+sinal+brl(Math.abs(dd))+'  ('+sinal+Math.abs(pp).toFixed(1)+'%)', M, y+3); y+=4.8;
        doc.setTextColor(90,102,120); doc.text('Menor '+brl(min)+' ('+(jan[minI].mes||'')+')      Maior '+brl(max)+' ('+(jan[maxI].mes||'')+')', M, y+3); y+=5.4;
        /* ===== v623 — O GRÁFICO IGUAL AO DA AVALIAÇÃO =======================
           Pedido: "deixe o gráfico da fipe, semelhante ao que já tem na
           avaliação". O de antes era uma linha reta dentro de um retângulo:
           sem eixo, sem valor, sem destaque. O da avaliação (histFipeHtml,
           no 02-icones-e-telas) tem grade, rótulo em R$ mil, linha
           tracejada, área preenchida e três bolinhas — atual, maior e menor.

           ⚠️ NÃO DÁ PRA COPIAR O SVG: este PDF é vetorial de propósito
           ("texto de verdade, nítido em qualquer zoom" — o cabeçalho do
           arquivo). Rasterizar o SVG quebraria essa promessa. Então o mesmo
           visual foi REDESENHADO com os comandos do jsPDF, reaproveitando as
           mesmas regras: a fórmula do _mil, as mesmas 3 cores (azul da casa,
           verde no maior, vermelho no menor) e os mesmos 3 rótulos de mês
           (início, meio, fim — não todos, que embolam). */
        var chrono=vals.slice().reverse(), span=(max-min)||1;
        var mesesC=jan.map(function(x){ return String(x.mes||''); }).reverse();
        var gxL=M+16, gy=y, gw=cw-16, gh=24, nC=chrono.length;
        function _gX(i){ return gxL+(nC>1?(i/(nC-1)):0)*gw; }
        function _gY(val){ return gy+gh-((val-min)/span)*gh; }
        /* grade + escala em R$ mil (4 linhas, como no SVG) */
        doc.setLineWidth(0.15); doc.setFontSize(5.6); doc.setFont('helvetica','normal');
        for(var gi=0; gi<=3; gi++){
          var fr=gi/3, yy=gy+gh-gh*fr, vv=min+span*fr;
          doc.setDrawColor(232,237,245); doc.line(gxL, yy, gxL+gw, yy);
          doc.setTextColor(148,163,184); doc.text(_pdfMil(vv), gxL-2, yy+1.6, {align:'right'});
        }
        /* área preenchida embaixo da linha (o mesmo azul clarinho do SVG) */
        try{
          doc.setFillColor(226,236,250);
          var pts=[]; chrono.forEach(function(val,i){ pts.push([_gX(i), _gY(val)]); });
          for(var pi=pts.length-1; pi>=0; pi--){
            var a=pts[pi], b=pts[pi-1];
            if(!b) break;
            doc.triangle(a[0],a[1], b[0],b[1], b[0],gy+gh, 'F');
            doc.triangle(a[0],a[1], a[0],gy+gh, b[0],gy+gh, 'F');
          }
        }catch(_){}
        /* a linha — TRACEJADA, como na avaliação desde a v303 */
        doc.setDrawColor(10,77,166); doc.setLineWidth(0.5);
        try{ if(doc.setLineDashPattern) doc.setLineDashPattern([1.2,0.9],0); }catch(_){}
        var px=null,py=null;
        chrono.forEach(function(val,i){ var x=_gX(i), yy=_gY(val); if(px!=null) doc.line(px,py,x,yy); px=x; py=yy; });
        try{ if(doc.setLineDashPattern) doc.setLineDashPattern([],0); }catch(_){}
        /* as três bolinhas: atual (azul, maior), maior (verde), menor (vermelho) */
        var maxCI=chrono.indexOf(max), minCI=chrono.indexOf(min);
        chrono.forEach(function(val,i){
          var x=_gX(i), yy=_gY(val), r=0.9, cor=[148,163,184];
          if(i===nC-1){ r=1.5; cor=[10,77,166]; }
          else if(i===maxCI){ r=1.3; cor=[21,128,61]; }
          else if(i===minCI){ r=1.3; cor=[185,28,28]; }
          doc.setFillColor(cor[0],cor[1],cor[2]); doc.circle(x,yy,r,'F');
        });
        /* rótulos de mês: início, meio e fim */
        doc.setFontSize(5.6); doc.setTextColor(148,163,184);
        var idxs=(nC<=3)?chrono.map(function(_x,i){ return i; }):[0,Math.floor((nC-1)/2),nC-1];
        idxs.forEach(function(ix){
          doc.text(mesesC[ix]||'', _gX(ix), gy+gh+3.4,
            { align:(ix===0?'left':(ix===nC-1?'right':'center')) });
        });
        doc.setLineWidth(0.2);
        y+=gh+7.5;
        /* tabela dos 6 meses em 2 colunas (mês → valor · variação) */
        var pares=jan.map(function(x,i){ var val=Number(x.valor)||0, prev=(i+1<h.length)?(Number(h[i+1].valor)||0):null;
          var dtxt=''; if(prev!=null){ var d=val-prev; dtxt='  ('+(d>0?'+':(d<0?'-':''))+brl(Math.abs(d))+')'; }
          return [String(x.mes||''), brl(val)+dtxt]; });
        duasColunas(pares);
      } else {
        doc.setTextColor(120,132,148); doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.text('Sem histórico de FIPE suficiente para esta placa.', M, y+3); y+=6;
      }

      /* ficha técnica (se já gerada) — compacta pra caber na página */
      secao('Ficha técnica');
      if(ficha){
        if(ficha.texto || ficha.avaliacao){ linhaTexto(corta(String(ficha.texto||ficha.avaliacao),900), 7.8); }
        else{
          function especBloco(rot,vv){ if(vv==null||vv==='') return;
            if(typeof vv==='object'){ var specs=[]; (function junta(o){ Object.keys(o).forEach(function(k){ var x=o[k]; if(x==null||x==='') return; if(typeof x==='object') junta(x); else specs.push([humano(k), String(x)]); }); })(vv); if(specs.length){ rotulo(rot); duasColunas(specs); } return; }
            var partes=String(vv).split(/,\s+|;\s+|\.\s+(?=[A-ZÀ-Ÿ])/).map(function(s){ return s.trim().replace(/[.;,]+$/,''); }).filter(Boolean);
            rotulo(rot); partes.forEach(function(p){ linhaTexto('• '+p, 7.6, [55,65,80]); }); y+=1;
          }
          especBloco('Motor', ficha.motor);
          especBloco('Dimensões', ficha.dimensoes);
          especBloco('Desempenho e consumo', ficha.desempenho);
          var its=(ficha.itens_serie||[]).filter(Boolean); if(its.length){ rotulo('Itens de série'); linhaTexto(its.join(' · '), 7.6, [60,72,90]); y+=1; }
          var opc=(ficha.opcionais||[]).filter(Boolean); if(opc.length){ rotulo('Opcionais para conferir'); linhaTexto(opc.join(' · '), 7.6, [60,72,90]); y+=1; }
          if(ficha.veredicto){ rotulo('Veredicto de mercado'); linhaTexto(corta(String(ficha.veredicto),320), 7.8); }
          var pa=(ficha.problemas_recorrentes||ficha.pontos_atencao||[]).filter(Boolean); if(pa.length){ rotulo('Itens recorrentes para vistoria'); pa.slice(0,4).forEach(function(p){ linhaTexto('• '+corta(p,120), 7.6, [60,72,90]); }); }
        }
      } else {
        doc.setTextColor(120,132,148); doc.setFont('helvetica','normal'); doc.setFontSize(8);
        doc.text('Gere a ficha técnica na consulta para incluí-la no PDF.', M, y+3); y+=6;
      }

      /* rodapé */
      doc.setTextColor(150,160,175); doc.setFont('helvetica','normal'); doc.setFontSize(6.6);
      doc.text('MEV Veículos · Consulta simples · '+histData(Date.now())+' · fonte: tabela FIPE', W/2, H-7, {align:'center'});
      pdfEntregar(doc.output('blob'), 'consulta-'+placa.toLowerCase()+'.pdf', placa);
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }

  /* ===== v596 — PDF DA CONSULTA FIPE, PRONTO NA HORA (Fase 1B do padrão MEV)
     Pedido: "crie um relatório pdf da fipe pra disponibilizar na hora que
     gera a consulta". O botão aparece JUNTO do resultado da placa e o desenho
     roda NO CLIQUE, com os dados que a consulta acabou de devolver — nenhuma
     chamada nova, custo zero. Gabarito aprovado (resposta real da IXY8J56):
     mudancas/PROJETO-exemplo-pdf-fipe-IXY8J56.pdf. 1 página.
     A resposta do tipo 'fipe' já traz ~22 meses de histórico e o IPVA — o
     gráfico de área (kitGrafArea) usa a série inteira; a tabela (kitFipe6
     soTabela) mostra os últimos 6 meses; o IPVA entra como par rótulo/valor. */
  function fipePaginas(v,detalhes){
    v=v||{}; detalhes=detalhes||{};
    var st=pdfkitNovo({ tipo:'CONSULTA FIPE — PLACA', placa:v.placa||'',
      lgpdCurto:'Valores informados pela tabela FIPE na data da consulta.' });
    /* histórico da versão que está valendo na tela, do mais novo pro mais velho */
    var hist=[];
    try{ hist=(typeof verHistDe==='function'?verHistDe(v):(v.historico||[])); }catch(_){ hist=v.historico||[]; }
    hist=(hist||[]).filter(function(x){ return x && x.valor!=null; })
      .slice().sort(function(a,b){ return String(b.mes||'')<String(a.mes||'')?-1:1; });
    /* capa: o valor + a identificação do modelo */
    var d6=null;
    if(hist.length>=2){ var i6=Math.min(5,hist.length-1), b6=Number(hist[i6].valor)||0, a6=Number(hist[0].valor)||0;
      if(b6) d6=((a6-b6)/b6)*100; }
    /* 🔴 v615 — ANO DE FABRICAÇÃO E ANO MODELO, SEMPRE OS DOIS.
       Pedido do Angelo: "mostre ano fabricacao e ano modelo no pdf".
       ✅ Conferido na tabela placa_consultas antes de mexer: das 133 consultas
       guardadas, 129 têm ano_modelo e 82 têm ano DIFERENTE de ano_modelo
       (Clio 2010/2011, ix35 2014/2015, Duster 2013/2014, Polo TSI 2025/2026).
       O provedor manda os dois separados e o nosso caminho da placa preserva
       os dois — não havia achatamento nenhum pra consertar.
       O Fiat Uno do print é 2014/2014 DE VERDADE: o PDF não escondeu nada,
       só escreveu "Ano 2014" e deixou a dúvida no ar.
       Por isso o conserto é de RÓTULO: quando existem os dois números, sai
       "Ano fab./mod. 2014/2014" mesmo quando são iguais — é assim que o
       mercado escreve e é o que responde a pergunta antes de ela ser feita.
       Quando falta um de verdade (4 das 133), sai um ano só, sem barra
       solta e sem repetir número inventado. */
    var _anoF=String(v.ano==null?'':v.ano).trim(), _anoM=String(v.ano_modelo==null?'':v.ano_modelo).trim();
    var anoTxt=(_anoF&&_anoM)?('Ano fab./mod. '+_anoF+'/'+_anoM):((_anoF||_anoM)?('Ano '+(_anoF||_anoM)):'');
    var l1=[anoTxt, v.combustivel?String(v.combustivel):'', v.codigo_fipe?('código FIPE '+v.codigo_fipe):''].filter(Boolean).join(' · ');
    var l3='fonte oficial: veiculos.fipe.org.br';
    kitFipeValor(st,{ valor:v.fipe, mesRef:v.mes_ref||(hist[0]&&hist[0].mes)||'', dif6Pct:d6,
      marca:v.marca||'', modelo:v.modelo||v.versao||'', linhas:[l1,l3] });
    /* v1478 — o gráfico anual já traz mês e valor exatos; a tabela de seis
       meses repetia a mesma leitura e encolhia justamente o gráfico. */
    kitGrafArea(st,hist);
    /* IPVA estimado + dados do veículo (linha vazia não entra) */
    var rows=[];
    if(v.ipva&&v.ipva.valor!=null) rows.push(['IPVA estimado'+(v.ipva.uf?(' ('+v.ipva.uf+(v.ipva.aliquota?(' · '+v.ipva.aliquota+'%'):'')+')'):''), brl(v.ipva.valor)+' ao ano']);
    if(v.chassi) rows.push(['Chassi', kitChassiMask(v.chassi)]);   /* v597: só os 6 últimos */
    var _cc=[_dadoUtil(v.cor),_dadoUtil(v.combustivel)].filter(Boolean).join(' · '); if(_cc) rows.push(['Cor · combustível',_cc]);
    var _mu=[_dadoUtil(v.municipio),_dadoUtil(v.uf)].filter(Boolean).join(' / '); if(_mu) rows.push(['Município / UF',_mu]);
    var _cp=[_dadoUtil(v.cilindrada)&&(v.cilindrada+' cc'),_dadoUtil(v.potencia)&&(v.potencia+' cv')].filter(Boolean).join(' · '); if(_cp) rows.push(['Cilindrada · potência',_cp]);
    var _el=[_dadoUtil(v.especie),_dadoUtil(v.lugares)&&(v.lugares+' lugares')].filter(Boolean).join(' · '); if(_el) rows.push(['Espécie · lugares',_el]);
    if(rows.length) kitKv2(st,'IPVA estimado e dados do veículo',rows);
    /* v1472 — os dados confirmados na folha anterior ao PDF pertencem ao
       relatório, não só ao histórico privado usado pelo compartilhamento. */
    var informados=[];
    if(detalhes.quilometragem) informados.push(['Quilometragem',detalhes.quilometragem]);
    if(detalhes.gastosPrevistos) informados.push(['Gastos previstos',detalhes.gastosPrevistos+(detalhes.gastosDescricao?(' · '+detalhes.gastosDescricao):'')]);
    if(informados.length) kitKv2(st,'Informações do veículo',informados);
    if(detalhes.observacoes){
      var obsItens=String(detalhes.observacoes).split(/\s*(?:,|;|\n)\s*/).map(function(x){return x.trim();}).filter(Boolean);
      kitLista(st,'Observações',obsItens.map(function(x){return '• '+x;}));
    }
    /* versões FIPE da placa: 1 = selo; mais de 1 = selo + uma linha por versão */
    var ops=(v.fipe_opcoes||[]).filter(function(o){ return o && o.valor!=null; });
    if(ops.length>1){
      kitSelo(st, ops.length+' versões FIPE · versão em uso confirmada.');
      ops.filter(function(o){ return String(o.codigo_fipe||'')!==String(v.codigo_fipe||''); }).slice(0,4).forEach(function(o){
        kitTexto(st,'• '+[o.descricao,o.ano].filter(Boolean).join(' · ')+' — '+brl(o.valor)+(o.codigo_fipe?(' (código '+o.codigo_fipe+')'):''));
      });
    } else {
      kitSelo(st,'Versão FIPE confirmada.');
    }
    return kitFinaliza(st);
  }
  function _fipePdfGerar(v,detalhes){
    if(!_mevPdfPronto(function(){ _fipePdfGerar(v,detalhes); },false)) return;
    toast('Gerando PDF…');
    try{
      var pags=fipePaginas(v,detalhes);
      var blob=kitPdfBlob(pags);
      if(!blob){ toast('Não consegui gerar o PDF.'); return; }
      /* v918 — a prévia do PDF da FIPE ganha o "Compartilhar print" (o print
         da consulta desta placa). É a única chamada que passa a opção: só
         aqui existe uma imagem da consulta correspondente ao PDF. */
      var _op=null;
      try{
        var _itemPdf=typeof histItemDaConsulta==='function'?histItemDaConsulta(v):null;
        var _basePdf=typeof histShareMensagemVeiculo==='function'?histShareMensagemVeiculo(v,_itemPdf):'';
        var _textoPdf=typeof histShareMensagemCompleta==='function'
          ?histShareMensagemCompleta(_basePdf,detalhes||{})
          :(_basePdf||mevConsultasAssinatura());
        _op={ textoCompartilhar:_textoPdf };
        if(typeof histPrint==='function' && _itemPdf){
          _op.compartilharPrint=function(){
            try{ histPrint(_itemPdf,'compartilhar'); }
            catch(_){ toast('Não consegui gerar o print.'); }
          };
        }
      }catch(_){ _op=null; }
      pdfEntregar(blob,'fipe-'+String(v.placa||'consulta').toLowerCase()+'.pdf', String(v.placa||''), pags, _op);   /* v615: com as páginas, a prévia sai como IMAGEM */
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }
  function fipePdfBaixar(){
    var v=veiculoAtual;
    if(!v||v.fipe==null){ toast('Consulte a placa primeiro.'); return; }
    if(typeof histShareDetalhesPedir!=='function'){ _fipePdfGerar(v,{}); return; }
    var origem={__mevShareVehicle:v,__mevShareModel:[v.marca,v.modelo].filter(Boolean).join(' ')};
    histShareDetalhesPedir(v.placa,function(detalhes){ _fipePdfGerar(v,detalhes||{}); },origem,{modo:'pdf'});
  }

  /* wiring comum das telas (toggles, versões, gerar, ficha) */
  function ligarComuns(){
    var sc=$('secoes');
    Array.prototype.forEach.call(sc.querySelectorAll('.plc-row'),function(row){ row.onclick=function(){ var c=document.getElementById('c-'+row.getAttribute('data-sec')),ab=!row.classList.contains('open'); row.classList.toggle('open',ab); if(c)c.classList.toggle('open',ab); }; });
    Array.prototype.forEach.call(sc.querySelectorAll('.gerar-btn'),function(btn){ btn.onclick=function(e){ e.stopPropagation(); gerarPago(btn.getAttribute('data-gerar'),btn); }; });
    Array.prototype.forEach.call(sc.querySelectorAll('.deb-btn'),function(btn){ btn.onclick=function(e){ e.stopPropagation(); if(btn.getAttribute('data-debitos')==='ir'){ abrirDebitos(); } else { gerarDebitos(btn); } }; });
    /* v628 — o atalho pras consultas de veículo (gravame/multas/renajud),
       que só nasce quando o relatório da placa acusou o indicador. */
    try{ veicAtalhosLigar(sc); }catch(_){}
    Array.prototype.forEach.call(sc.querySelectorAll('[data-acao="pdf"]'),function(b){ b.onclick=function(e){ e.stopPropagation(); acaoGerarPDF(); }; });
    /* v164: 'trocar versao' abre o MODAL de cartoes (mesmo modal que aparece sozinho) */
    Array.prototype.forEach.call(sc.querySelectorAll('.ver-troca'),function(bt){ bt.onclick=function(e){ e.stopPropagation(); verModalAbrir(false); }; });
    /* v158: escolher a versao SALVA de verdade (aparelho + historico + nuvem) */
    /* v164: a escolha em si mora em verEscolherOp() - um lugar so */
    Array.prototype.forEach.call(sc.querySelectorAll('.ver-opt'),function(opt){ opt.onclick=function(e){ e.stopPropagation(); if(!veiculoAtual)return;
      verEscolherOp(opt.getAttribute('data-fipe'), opt.getAttribute('data-cod')||'', opt.getAttribute('data-des')||'');
      try{ toast('Versão salva ✓ — vou usar essa sempre nesta placa.'); }catch(_){}
      abrirMenu(); }; });
    Array.prototype.forEach.call(sc.querySelectorAll('.ver-limpa'),function(bt){ bt.onclick=function(e){ e.stopPropagation(); if(!veiculoAtual)return;
      verUsarSugerida();
      try{ toast('Voltei pra versão sugerida pela consulta.'); }catch(_){}
      abrirMenu(); }; });
    Array.prototype.forEach.call(sc.querySelectorAll('.fic-t'),function(b){ b.onclick=function(e){ e.stopPropagation(); b.parentNode.classList.toggle('open'); }; });
    /* "Dados e FIPE" minimizado: toca no cabeçalho pra abrir/fechar os detalhes */
    Array.prototype.forEach.call(sc.querySelectorAll('.df-toggle'),function(bt){ bt.onclick=function(e){ e.stopPropagation(); var body=bt.parentNode.querySelector('.df-body'); if(!body) return; var ab=body.style.display==='none'; body.style.display=ab?'block':'none'; bt.classList.toggle('on',ab); }; });
  }

/* ╔═══ src/app/06b-pdf-kit.js ════════════════════════════════════════════ */
  /* ==========================================================================
     06b — O KIT DO PDF PADRÃO MEV (v595 · Fase 1 do PROJETO-pdf-padrao-mev)
     ==========================================================================
     Nasceu da análise do relatório da AutoCorp (22/08): copiamos o que ele
     tem de bom (quadro de avisos com semáforo, bandas de seção, placa
     desenhada, selos "nada consta", FIPE com tendência) e corrigimos o que
     ele erra (texto-rio, duplicação de bases, avisos repetidos, sem
     paginação). A prévia visual aprovada é a
     mudancas/PROJETO-previa-pdf-padrao-mev.html.

     🔴 A MELHORIA TÉCNICA: os PDFs antigos desenhavam UM canvas altíssimo e
     o jsPDF fatiava a imagem onde a faca caísse — linha cortada ao meio
     entre páginas. AQUI cada componente MEDE antes de desenhar e, se não
     couber na página, a página fecha (com rodapé) e outra abre (com
     cabeçalho reduzido). Nenhum bloco cortado. Escala 2x (nitidez de
     impressão), JPEG 0.92 no jsPDF como sempre.

     COMPONENTES (letras do projeto):
       A kitCabecalho (embutido no pdfkitNovo/_kitNovaPagina)
       B kitVeredito · C kitAvisos · D banda (interna) · E kitKv2
       F kitSelo · G kitScore · H kitFipe6 · I kitAtencao · J rodapé
       (no kitFinaliza) · K kitRecall
       v596 (Fase 1B): H2 kitFipeValor (capa do PDF da FIPE) e H3 kitGrafArea
       (série completa do histórico) — consumidos pelo fipePaginas (06).
     Fase 1 consome B/C/E/F/H + rodapé no relatório completo (05/19);
     G/I/K ficam prontos pras Fases 2–3 (CPF/CNPJ/leilão).

     Paleta e hierarquia: as MESMAS dos PDFs atuais — nada de cor nova. */

  var _KIT={ azul:'#0a4da6', escuro:'#001e50', tinta:'#0f172a', rotulo:'#94a3b8', cinza:'#64748b',
    verde:'#15803d', vermelho:'#b91c1c', ambar:'#b45309', ambarVivo:'#d97706',
    fAz:'#eff6ff', fCz:'#f1f5f9', fVd:'#dcfce7', fVm:'#fee2e2', fAm:'#fef3c7',
    borda:'#dbe4f0', FF:'system-ui, -apple-system, Segoe UI, Roboto, Arial' };

  function _kitRR(g,x,y,w,h,r){ g.beginPath(); g.moveTo(x+r,y); g.arcTo(x+w,y,x+w,y+h,r); g.arcTo(x+w,y+h,x,y+h,r); g.arcTo(x,y+h,x,y,r); g.arcTo(x,y,x+w,y,r); g.closePath(); }
  function _kitWrap(g,texto,maxW){
    var palavras=String(texto||'').split(/\s+/), linhas=[], atual='';
    palavras.forEach(function(p){ var t=atual?(atual+' '+p):p; if(g.measureText(t).width>maxW && atual){ linhas.push(atual); atual=p; } else atual=t; });
    if(atual) linhas.push(atual);
    return linhas;
  }
  function _kitAgora(){
    var d=new Date();
    return d.toLocaleDateString('pt-BR')+' · '+d.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
  }

  /* v1476 — placa veicular no cabeçalho, não texto solto.
     A regra é a mesma já usada no app e no PDF simples: ABC1234 é o modelo
     antigo (BRASIL + hífen); ABC1D23 é Mercosul. CPF, CNPJ e outros
     documentos continuam usando o cabeçalho textual. */
  function _kitPlacaCabecalho(g,placa,xDir,yTopo){
    var s=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!/^[A-Z]{3}[0-9]{4}$/.test(s) && !/^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(s)) return false;
    var antiga=/^[A-Z]{3}[0-9]{4}$/.test(s);
    var txt=antiga?(s.slice(0,3)+'-'+s.slice(3)):s;
    var w=160,h=62,x=xDir-w,y=yTopo-3,tarja=18;
    g.save();
    g.fillStyle='#ffffff'; g.strokeStyle='#0f172a'; g.lineWidth=2;
    _kitRR(g,x,y,w,h,8); g.fill(); g.stroke();
    g.fillStyle=antiga?'#cbd5e1':_KIT.azul;
    _kitRR(g,x+2,y+2,w-4,tarja,5); g.fill();
    g.fillRect(x+2,y+tarja-4,w-4,6);
    g.textAlign='center'; g.textBaseline='alphabetic';
    g.fillStyle=antiga?'#334155':'#ffffff';
    g.font='900 8.5px '+_KIT.FF;
    g.fillText(antiga?'BRASIL':'MERCOSUL',x+w/2,y+14);
    if(!antiga){
      g.fillStyle='#38bdf8'; g.fillRect(x+w-20,y+6,10,3);
      g.fillStyle='#facc15'; g.fillRect(x+w-20,y+9,10,3);
    }
    g.fillStyle=_KIT.tinta; g.font='900 28px "Courier New", monospace';
    g.fillText(txt,x+w/2,y+h-10);
    g.restore();
    return true;
  }

  /* ---------- o estado: página A4 lógica de 794×1123, desenhada em 2x ----- */
  function pdfkitNovo(op){
    op=op||{};
    var st={ W:794, H:1123, pad:38, RODAPE:44, paginas:[], g:null, y:0,
      tipo:String(op.tipo||'').toUpperCase(), placa:String(op.placa||'').toUpperCase(),
      docTexto:String(op.doc||''), protocolo:String(op.protocolo||''),
      lgpdCurto:op.lgpdCurto||'Uso restrito à finalidade legítima, conforme a LGPD (Lei 13.709/2018)',
      geradoEm:_kitAgora() };
    _kitNovaPagina(st,false);
    return st;
  }
  function _kitNovaPagina(st,reduzido){
    var cv=document.createElement('canvas'); cv.width=st.W*2; cv.height=st.H*2;
    var g=cv.getContext('2d'); g.scale(2,2);
    g.fillStyle='#ffffff'; g.fillRect(0,0,st.W,st.H);
    g.textAlign='left'; g.textBaseline='alphabetic';
    st.paginas.push(cv); st.g=g;
    /* A — cabeçalho (cheio na 1ª página, reduzido nas seguintes).
       v595 (pedido do Angelo: "não pareça cópia do AutoCorp"): saiu a
       moldura de placa Mercosul (assinatura visual deles) e entrou a FAIXA
       AZUL da casa — o mesmo degradê do splash/topbar do app — com a placa
       grande DENTRO da faixa, como o cabeçalho que os PDFs do MEV sempre
       tiveram. A identidade é a do app, não a do relatório alheio. */
    var pad=st.pad;
    if(!reduzido){
      var HH=88;
      var gr=g.createLinearGradient(0,0,st.W,0); gr.addColorStop(0,'#001e50'); gr.addColorStop(.62,'#0a4da6'); gr.addColorStop(1,'#1976F2');
      g.fillStyle=gr; g.fillRect(0,0,st.W,HH);
      g.fillStyle='#0a4da6'; g.fillRect(0,HH-4,st.W,4);
      g.fillStyle='#9fc3ff'; g.font='900 13px '+_KIT.FF; g.fillText('MEV VEÍCULOS', pad, 28);
      g.fillStyle='#ffffff'; g.font='800 15px '+_KIT.FF; g.fillText(st.tipo, pad, 52);
      g.fillStyle='#cfe0ff'; g.font='500 10px '+_KIT.FF; g.fillText('Gerado em '+st.geradoEm, pad, 72);
      var dir=st.placa||st.docTexto;
      if(st.placa && _kitPlacaCabecalho(g,st.placa,st.W-pad,16)){
        /* placa desenhada pelo componente canônico acima */
      } else if(dir){
        g.textAlign='right';
        g.fillStyle='#ffffff'; g.font='900 '+(st.placa?'32':'22')+'px '+_KIT.FF; g.fillText(dir, st.W-pad, st.placa?56:52);
        g.textAlign='left';
      }
      st.y=HH+18;
    } else {
      var gr2=g.createLinearGradient(0,0,st.W,0); gr2.addColorStop(0,'#001e50'); gr2.addColorStop(1,'#0a4da6');
      g.fillStyle=gr2; g.fillRect(0,0,st.W,38);
      g.fillStyle='#ffffff'; g.font='900 11px '+_KIT.FF; g.fillText('MEV VEÍCULOS', pad, 24);
      g.fillStyle='#cfe0ff'; g.font='700 10px '+_KIT.FF;
      g.fillText('· '+st.tipo+(st.placa?(' · '+st.placa):''), pad+84, 24);
      st.y=56;
    }
  }
  /* o coração do kit: NENHUM bloco começa se não couber inteiro na página */
  function kitGarante(st,h){
    if(st.y+h > st.H-st.RODAPE-10) _kitNovaPagina(st,true);
  }
  function kitEspaco(st,h){ st.y+=(h==null?14:h); }

  /* D — título de seção NO ESTILO 2 (decisão 22/08 noite, anti-semelhança):
     a banda azul cheia saiu; entrou a abinha azul + título AZUL #0a4da6 em
     CAIXA ALTA + linha fina #dbe4f0 embaixo. É a versão v597 do adendo
     "ESTILO 2 É O PADRÃO" — nada de faixa navy com texto branco. */
  function _kitBanda(st,titulo){
    var g=st.g, pad=st.pad;
    g.fillStyle=_KIT.azul; _kitRR(g,pad,st.y+3,5,15,2.5); g.fill();
    g.fillStyle=_KIT.azul; g.font='800 12px '+_KIT.FF; g.fillText(String(titulo).toUpperCase(), pad+13, st.y+15);
    g.strokeStyle=_KIT.borda; g.lineWidth=1;
    g.beginPath(); g.moveTo(pad,st.y+23); g.lineTo(st.W-pad,st.y+23); g.stroke();
    st.y+=30;
  }
  /* caixa de conteúdo SEM borda (Estilo 2): cartão suave arredondado */
  function _kitCartao(st,h){
    var g=st.g, pad=st.pad;
    g.fillStyle='#f8fafc'; _kitRR(g,pad,st.y,st.W-pad*2,h,12); g.fill();
  }

  /* chassi mascarado em TODO relatório (decisão 22/08): SÓ os 6 últimos
     dígitos aparecem — mesma régua do CPF. A tela segue com a chassiMask
     antiga (8+***+3); esta é a régua dos PDFs do kit. */
  function kitChassiMask(c){
    c=String(c||''); if(c.length<=6) return c;
    var pontos=''; for(var i=0;i<c.length-6;i++) pontos+='•';
    return pontos+c.slice(-6);
  }

  /* A2 (03/09) — SÓ O TÍTULO DE SEÇÃO, sem conteúdo atrás.
     O `kitTitulo` existe, mas desenha um cabeçalho GRANDE e escuro — outra
     linguagem visual. Num documento onde as outras seções vêm com a abinha
     azul (kitKv2, kitAvisos, kitLista), misturar os dois faz o PDF parecer
     montado por duas pessoas. Seções que só carregam um selo ou um veredito
     (Perda total, Indício de sinistro) precisavam de um título no MESMO
     desenho — é o que esta função dá. */
  function kitSecao(st,titulo){
    if(!titulo) return;
    kitGarante(st,46);
    _kitBanda(st,titulo);
  }

  /* B — faixa de veredito: verde/âmbar/vermelho, o resultado geral */
  function kitVeredito(st,nivel,texto,sub){
    var h=44; kitGarante(st,h+14);
    var g=st.g, pad=st.pad;
    var cor=(nivel==='ok')?[_KIT.fVd,'#bbf7d0',_KIT.verde]:((nivel==='no')?[_KIT.fVm,'#fecaca',_KIT.vermelho]:[_KIT.fAm,'#fcd34d',_KIT.ambar]);
    g.fillStyle=cor[0]; _kitRR(g,pad,st.y,st.W-pad*2,h,10); g.fill();
    g.strokeStyle=cor[1]; g.lineWidth=1.5; _kitRR(g,pad,st.y,st.W-pad*2,h,10); g.stroke();
    g.fillStyle=cor[2]; _kitRR(g,pad+1,st.y+1,7,h-2,4); g.fill();   /* a orelha de status da casa */
    var ico=(nivel==='ok')?'✓':((nivel==='no')?'✗':'⚠');
    g.fillStyle=cor[2]; g.font='900 16px '+_KIT.FF; g.fillText(ico+'  '+String(texto).toUpperCase(), pad+20, st.y+28);
    if(sub){ g.font='700 10px '+_KIT.FF; g.textAlign='right'; g.fillText(String(sub), st.W-pad-14, st.y+27); g.textAlign='left'; }
    st.y+=h+14;
  }

  /* C — quadro de avisos: duas colunas com semáforo.
     🔴 Regra v450 (do projeto): ✓ verde SÓ quando a base respondeu E veio
     limpa; base falhada/sem resposta é '!' âmbar "não verificado" — quem
     monta a lista manda o nível certo, este componente só desenha. */
  function kitAvisos(st,titulo,itens){
    itens=(itens||[]).filter(function(i){ return i && i.t; });
    if(!itens.length) return;
    var linhas=Math.ceil(itens.length/2), rh=24, h=linhas*rh+18;
    kitGarante(st,30+h+14);
    _kitBanda(st,titulo||'Quadro de avisos');
    _kitCartao(st,h);
    var g=st.g, pad=st.pad, colW=(st.W-pad*2-28)/2;
    itens.forEach(function(it,i){
      var col=i%2, row=Math.floor(i/2);
      var x=pad+14+col*(colW+14), ym=st.y+12+row*rh+8;
      var cor=(it.nv==='ok')?_KIT.verde:((it.nv==='no')?_KIT.vermelho:_KIT.ambarVivo);
      g.fillStyle=cor; g.beginPath(); g.arc(x+7,ym-3,7,0,Math.PI*2); g.fill();
      g.fillStyle='#ffffff'; g.font='900 8.5px '+_KIT.FF; g.textAlign='center';
      g.fillText((it.nv==='ok')?'✓':((it.nv==='no')?'✗':'!'), x+7, ym);
      g.textAlign='left';
      var tf=11; g.font='700 '+tf+'px '+_KIT.FF;
      var txt=String(it.t);
      while(g.measureText(txt).width>colW-22 && tf>8){ tf--; g.font='700 '+tf+'px '+_KIT.FF; }
      var corTxt=(it.nv==='ok')?'#166534':((it.nv==='no')?_KIT.vermelho:_KIT.ambar);
      g.fillStyle=corTxt; g.fillText(txt, x+20, ym+1);
    });
    st.y+=h+14;
  }

  /* E — pares rótulo/valor em 2 colunas; linha divergente sai em âmbar */
  function kitKv2(st,titulo,rows){
    rows=(rows||[]).filter(function(r){ var v=String(r[1]==null?'':r[1]).trim(); return v && v!=='/' && v!=='-' && v.toLowerCase()!=='null'; });
    if(!rows.length) return;
    var linhas=Math.ceil(rows.length/2), rh=38, h=linhas*rh+16;
    kitGarante(st,30+h+14);
    _kitBanda(st,titulo);
    _kitCartao(st,h);
    var g=st.g, pad=st.pad, colW=(st.W-pad*2-42)/2;
    rows.forEach(function(r,i){
      var col=i%2, row=Math.floor(i/2);
      var x=pad+14+col*(colW+14), yt=st.y+10+row*rh;
      g.fillStyle=_KIT.rotulo; g.font='800 8.5px '+_KIT.FF; g.fillText(String(r[0]).toUpperCase(), x, yt+9);
      var vf=12; g.font='800 '+vf+'px '+_KIT.FF;
      var val=String(r[1]);
      while(g.measureText(val).width>colW && vf>8){ vf--; g.font='800 '+vf+'px '+_KIT.FF; }
      g.fillStyle=r[2]?_KIT.ambar:_KIT.tinta; g.fillText(val, x, yt+25);
      if(row<linhas-1){ g.strokeStyle=_KIT.fCz; g.lineWidth=1; g.beginPath(); g.moveTo(x,yt+rh-4); g.lineTo(x+colW,yt+rh-4); g.stroke(); }
    });
    st.y+=h+14;
  }

  /* F — selo "nada consta" (o tudo-certo também é informação) */
  function kitSelo(st,texto){
    var h=30; kitGarante(st,h+10);
    var g=st.g, pad=st.pad;
    g.fillStyle=_KIT.fVd; _kitRR(g,pad,st.y,st.W-pad*2,h,8); g.fill();
    g.fillStyle='#166534'; g.font='800 11px '+_KIT.FF; g.fillText('✓  '+String(texto), pad+13, st.y+19);
    st.y+=h+10;
  }

  /* G — cartão de score (Fases 2–3; sem frase de probabilidade, decisão 22/08) */
  function kitScore(st,rotulo,valor,classe){
    var h=76; kitGarante(st,h+14);
    var g=st.g, pad=st.pad;
    var sv=parseInt(String(valor).replace(/\D/g,''),10)||0;
    var cor=(sv>=700)?[_KIT.fVd,'#bbf7d0',_KIT.verde]:((sv>=500)?[_KIT.fAm,'#fde68a',_KIT.ambarVivo]:[_KIT.fVm,'#fecaca',_KIT.vermelho]);
    g.fillStyle=cor[0]; _kitRR(g,pad,st.y,st.W-pad*2,h,10); g.fill();
    g.strokeStyle=cor[1]; g.lineWidth=1.5; _kitRR(g,pad,st.y,st.W-pad*2,h,10); g.stroke();
    g.textAlign='center'; g.fillStyle=cor[2];
    g.font='800 11px '+_KIT.FF; g.fillText(String(rotulo).toUpperCase(), st.W/2, st.y+22);
    g.font='900 30px '+_KIT.FF; g.fillText(String(valor)+'  /  1000', st.W/2, st.y+54);
    if(classe){ g.fillStyle=_KIT.cinza; g.font='700 10px '+_KIT.FF; g.fillText('Classe '+classe, st.W/2, st.y+69); }
    g.textAlign='left';
    st.y+=h+14;
  }

  /* mês curto ("2026-03" → "mar/26"; "março de 2026" → "mar") — era interna
     da kitFipe6; virou do módulo na v596 (o gráfico de área também usa) */
  var _KIT_MESES=['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
  function _kitMesCurto(m){
    m=String(m||'');
    var q=m.match(/^(\d{4})-(\d{2})/); if(q) return (_KIT_MESES[parseInt(q[2],10)-1]||q[2])+'/'+q[1].slice(2);
    var q2=m.match(/^([a-zç]+)/i); if(q2) return q2[1].slice(0,3);
    return m.slice(0,6);
  }

  /* H — FIPE 6 meses: número grande + tabela com setas ↑/↓ e Dif %.
     v596: soTabela=true tira o número grande (quando a página já mostra o
     valor num cartão próprio, como no PDF da consulta FIPE) — a tabela
     ocupa a largura toda e a banda vira "Tendência". */
  function kitFipe6(st,hist,soTabela){
    /* hist: [{mes, valor}] do MAIS NOVO pro mais velho (verHistDe já ordena) */
    hist=(hist||[]).filter(function(x){ return x && x.valor!=null; }).slice(0,6);
    if(hist.length<2) return;
    var h=104; kitGarante(st,30+h+14);
    _kitBanda(st, soTabela?('Tendência — últimos '+hist.length+' meses'):('FIPE — valor e tendência ('+hist.length+' meses)'));
    _kitCartao(st,h);
    var g=st.g, pad=st.pad;
    var _mesCurto=_kitMesCurto;
    var atual=Number(hist[0].valor)||0, antigo=Number(hist[hist.length-1].valor)||0;
    var difPct=antigo?(((atual-antigo)/antigo)*100):0;
    /* número grande à esquerda (no modo soTabela ele sai — o valor já tem cartão próprio) */
    var bx=pad+14, bw=soTabela?0:150;
    if(!soTabela){
      g.fillStyle=_KIT.fAz; _kitRR(g,bx,st.y+12,bw,80,10); g.fill();
      g.textAlign='center';
      g.fillStyle=_KIT.azul; g.font='800 9px '+_KIT.FF; g.fillText('FIPE '+_mesCurto(hist[0].mes).toUpperCase(), bx+bw/2, st.y+30);
      var nf=22; g.font='900 '+nf+'px '+_KIT.FF;
      var nTxt=brl(atual); while(g.measureText(nTxt).width>bw-16 && nf>13){ nf--; g.font='900 '+nf+'px '+_KIT.FF; }
      g.fillText(nTxt, bx+bw/2, st.y+58);
      g.fillStyle=difPct>=0?_KIT.verde:_KIT.vermelho; g.font='800 10px '+_KIT.FF;
      g.fillText((difPct>=0?'↑ +':'↓ −')+Math.abs(difPct).toFixed(2).replace('.',',')+'% no período', bx+bw/2, st.y+80);
    } else { g.textAlign='center'; }
    /* tabela cronológica à direita (coluna própria pros rótulos de linha) */
    var crono=hist.slice().reverse();
    var rotW=44, tx=bx+bw+(soTabela?0:18)+rotW, tw=st.W-pad-14-tx, cw=tw/crono.length;
    g.textAlign='center';
    g.font='800 8px '+_KIT.FF; g.fillStyle=_KIT.rotulo;
    crono.forEach(function(m,i){ g.fillText(_mesCurto(m.mes).toUpperCase(), tx+i*cw+cw/2, st.y+26); });
    g.strokeStyle=_KIT.borda; g.lineWidth=1; g.beginPath(); g.moveTo(tx-rotW,st.y+32); g.lineTo(tx+tw,st.y+32); g.stroke();
    crono.forEach(function(m,i){
      var vAt=Number(m.valor)||0, vAnt=i>0?(Number(crono[i-1].valor)||0):null;
      var sobe=vAnt==null?null:(vAt>=vAnt);
      g.fillStyle=sobe==null?_KIT.tinta:(sobe?_KIT.verde:_KIT.vermelho);
      g.font='800 10.5px '+_KIT.FF;
      g.fillText((sobe==null?'':(sobe?'↑ ':'↓ '))+(vAt>=1000?(vAt/1000).toFixed(1).replace('.',','):String(vAt)), tx+i*cw+cw/2, st.y+50);
      if(vAnt!=null && vAnt>0){
        var dp=((vAt-vAnt)/vAnt)*100;
        g.fillStyle=dp>=0?_KIT.verde:_KIT.vermelho; g.font='700 8.5px '+_KIT.FF;
        g.fillText((dp>=0?'+':'−')+Math.abs(dp).toFixed(2).replace('.',',')+'%', tx+i*cw+cw/2, st.y+68);
      }
    });
    g.textAlign='left'; g.fillStyle=_KIT.rotulo; g.font='700 8px '+_KIT.FF;
    g.fillText('R$ MIL', tx-rotW, st.y+50);
    g.fillText('DIF %', tx-rotW, st.y+68);
    st.y+=h+14;
  }

  /* H2 (v596) — CARTÃO DO VALOR FIPE: número grande à esquerda (caixinha
     azul, com a variação de 6 meses embaixo) e a identificação do modelo à
     direita. É a capa do PDF da consulta FIPE — o gabarito aprovado é a
     mudancas/PROJETO-exemplo-pdf-fipe-IXY8J56.pdf. */
  function kitFipeValor(st,d){
    d=d||{};
    var h=124; kitGarante(st,30+h+14);
    _kitBanda(st,'Valor FIPE do veículo');
    _kitCartao(st,h);
    var g=st.g, pad=st.pad;
    /* caixinha azul do número */
    var bx=pad+14, bw=190;
    g.fillStyle=_KIT.fAz; _kitRR(g,bx,st.y+14,bw,96,10); g.fill();
    g.textAlign='center';
    /* o mês de referência por EXTENSO ("FIPE · AGOSTO DE 2026"), como no
       gabarito — encolhe a fonte se não couber na caixinha */
    var rot='FIPE'+(d.mesRef?(' · '+String(d.mesRef).toUpperCase()):'');
    var rf=9; g.fillStyle=_KIT.azul; g.font='800 '+rf+'px '+_KIT.FF;
    while(g.measureText(rot).width>bw-14 && rf>6.5){ rf-=0.5; g.font='800 '+rf+'px '+_KIT.FF; }
    g.fillText(rot, bx+bw/2, st.y+36);
    var nf=29; g.font='900 '+nf+'px '+_KIT.FF;
    var nTxt=brl(Number(d.valor)||0);
    while(g.measureText(nTxt).width>bw-18 && nf>14){ nf--; g.font='900 '+nf+'px '+_KIT.FF; }
    g.fillStyle=_KIT.tinta; g.fillText(nTxt, bx+bw/2, st.y+69);
    if(d.dif6Pct!=null){
      var s=Number(d.dif6Pct)>=0;
      g.fillStyle=s?_KIT.verde:_KIT.vermelho; g.font='800 9.5px '+_KIT.FF;
      g.fillText((s?'↑ +':'↓ −')+Math.abs(Number(d.dif6Pct)).toFixed(1).replace('.',',')+'% em 6 meses', bx+bw/2, st.y+98);
    }
    /* identificação do modelo à direita */
    g.textAlign='left';
    var ix=bx+bw+20, iw=st.W-pad-14-ix, iy=st.y+34;
    if(d.marca){ g.fillStyle=_KIT.tinta; g.font='800 13px '+_KIT.FF; g.fillText(String(d.marca), ix, iy); iy+=19; }
    if(d.modelo){
      g.fillStyle=_KIT.tinta; var mf=13; g.font='900 '+mf+'px '+_KIT.FF;
      var mLin=_kitWrap(g,String(d.modelo),iw).slice(0,2);
      mLin.forEach(function(ln){ g.fillText(ln, ix, iy); iy+=17; });
    }
    iy+=2;
    g.fillStyle=_KIT.cinza; g.font='600 10px '+_KIT.FF;
    (d.linhas||[]).slice(0,3).forEach(function(ln){ if(!ln) return; g.fillText(String(ln), ix, iy); iy+=15; });
    st.y+=h+14;
  }

  /* H3 (v1476/v1478) — GRÁFICO FIPE dos últimos 12 meses.
     Reproduz a leitura do resultado da consulta: grade, escala monetária,
     pontos e identificação de mês/valor. Desde a v1478, concentra sozinho a
     leitura anual; a tabela repetida de seis meses saiu deste relatório. */
  function kitGrafArea(st,hist){
    hist=(hist||[]).filter(function(x){ return x && x.valor!=null; });
    if(hist.length<2) return;
    var pad=st.pad, h=250;
    kitGarante(st,30+h+12);
    _kitBanda(st,'Gráfico FIPE — últimos '+Math.min(12,hist.length)+' meses');
    var g=st.g;
    _kitCartao(st,h);
    var crono=hist.slice().sort(function(a,b){ return String(b.mes||'').localeCompare(String(a.mes||'')); }).slice(0,12).reverse();
    var vals=crono.map(function(x){ return Number(x.valor)||0; });
    var min=Math.min.apply(null,vals), max=Math.max.apply(null,vals), span=(max-min)||1;
    var minI=vals.indexOf(min), maxI=vals.indexOf(max);
    var gx=pad+72, gw=st.W-pad-gx-14, gy=st.y+18, gh=154;
    function X(i){ return gx+(crono.length>1?(i/(crono.length-1)):0)*gw; }
    function Y(v){ return gy+gh-((v-min)/span)*(gh-8)-4; }
    function ReaisInteiros(v){
      return 'R$ '+Math.round(Number(v)||0).toLocaleString('pt-BR');
    }
    /* grade e escala: quatro referências, como no gráfico da consulta */
    g.font='700 8.2px '+_KIT.FF;
    for(var gi=0;gi<=3;gi++){
      var fr=gi/3, yy=gy+gh-(gh*fr), vv=min+(span*fr);
      g.strokeStyle=_KIT.borda; g.lineWidth=1; g.beginPath(); g.moveTo(gx,yy); g.lineTo(gx+gw,yy); g.stroke();
      g.fillStyle=_KIT.cinza; g.textAlign='right'; g.fillText(ReaisInteiros(vv),gx-8,yy+3);
    }
    /* área + linha */
    g.beginPath(); g.moveTo(gx,gy+gh);
    vals.forEach(function(v,i){ g.lineTo(X(i),Y(v)); });
    g.lineTo(gx+gw,gy+gh); g.closePath();
    g.fillStyle='rgba(10,77,166,.14)'; g.fill();
    g.beginPath();
    vals.forEach(function(v,i){ var x=X(i),y=Y(v); if(i===0) g.moveTo(x,y); else g.lineTo(x,y); });
    g.strokeStyle=_KIT.azul; g.lineWidth=1.1; g.setLineDash([4,3]); g.stroke();
    g.setLineDash([]); g.lineWidth=1;
    /* ponto, mês e valor em cada coluna; 12 meses cabem na largura A4 */
    crono.forEach(function(x,i){
      var px=X(i),py=Y(vals[i]);
      var ehAtual=i===crono.length-1, ehMax=i===maxI, ehMin=i===minI;
      var pc=ehMax?_KIT.verde:(ehMin?_KIT.vermelho:_KIT.azul);
      g.fillStyle=ehAtual?'#ffffff':pc; g.strokeStyle=ehAtual?_KIT.azul:pc;
      g.lineWidth=ehAtual?2:1;
      g.beginPath(); g.arc(px,py,ehAtual?3.8:((ehMax||ehMin)?3.1:2.2),0,Math.PI*2); g.fill(); g.stroke();
      g.textAlign='center'; g.fillStyle=_KIT.cinza; g.font='700 7.8px '+_KIT.FF;
      g.fillText(_kitMesCurto(x.mes),px,gy+gh+16);
      g.fillStyle=_KIT.tinta; g.font='800 7.8px '+_KIT.FF;
      g.fillText(ReaisInteiros(vals[i]),px,gy+gh+29);
    });
    /* legenda: mesma semântica de cor da consulta, sem depender só da cor */
    var ly=gy+gh+50,lx=gx;
    [['Menor',_KIT.vermelho],['Maior',_KIT.verde],['Atual',_KIT.azul]].forEach(function(it,i){
      var xx=lx+i*76; g.fillStyle=i===2?'#ffffff':it[1]; g.strokeStyle=it[1]; g.lineWidth=i===2?2:1;
      g.beginPath(); g.arc(xx,ly-2,3,0,Math.PI*2); g.fill(); g.stroke();
      g.fillStyle=_KIT.cinza; g.font='700 7.8px '+_KIT.FF; g.textAlign='left'; g.fillText(it[0],xx+7,ly+1);
    });
    g.fillStyle=_KIT.rotulo; g.font='700 7.8px '+_KIT.FF; g.textAlign='right';
    g.fillText('VALORES MENSAIS EM REAIS · FONTE: TABELA FIPE', gx+gw, ly+1);
    g.textAlign='left';
    st.y+=h+12;
  }

  /* I — box de atenção âmbar (no máximo 1 por relatório) */
  /* 🔴 03/09 — DEFEITO ANTIGO, ACHADO GERANDO O LAUDO DA AUTOCORP.
     Estas duas funções pegavam `var g=st.g` ANTES de chamar o kitGarante. Só
     que o kitGarante pode VIRAR A PÁGINA — e virar a página troca o st.g por
     um canvas novo. O `g` local continuava apontando pro canvas ANTERIOR, e o
     desenho saía na página velha, na altura da página nova: em cima do
     cabeçalho, por cima do que já estava escrito.
     Sintoma real: o aviso de "Indício de sinistro" apareceu carimbado sobre a
     faixa azul do topo da página 1, e a seção sumiu da página 2.
     ✅ A regra agora: mede com o g atual, chama o kitGarante, e SÓ ENTÃO pega
     o g de novo. Quem desenha depois de um kitGarante tem de reler o st.g. */
  function kitAtencao(st,texto){
    var pad=st.pad;
    st.g.font='600 10.5px '+_KIT.FF;
    var linhas=_kitWrap(st.g,texto,st.W-pad*2-30), h=linhas.length*15+18;
    kitGarante(st,h+12);
    var g=st.g;                     /* releitura obrigatória: pode ter virado a página */
    g.fillStyle=_KIT.fAm; _kitRR(g,pad,st.y,st.W-pad*2,h,8); g.fill();
    g.fillStyle=_KIT.ambar; g.font='600 10.5px '+_KIT.FF;
    var ty=st.y+15; linhas.forEach(function(ln){ g.fillText(ln, pad+15, ty); ty+=15; });
    st.y+=h+12;
  }

  /* K — cartão de recall compacto (Fase 3): Data · Defeito · Risco, 1 linha cada */
  function kitRecall(st,rec){
    var g=st.g, pad=st.pad, h=64;
    kitGarante(st,h+10);
    _kitCartao(st,h);
    g.fillStyle=_KIT.tinta; g.font='800 11.5px '+_KIT.FF; g.fillText(String(rec.titulo||'Recall')+(rec.data?(' · '+rec.data):''), pad+14, st.y+18);
    g.fillStyle=_KIT.cinza; g.font='600 10px '+_KIT.FF;
    var d1='Defeito: '+String(rec.defeito||'—'); if(g.measureText(d1).width>st.W-pad*2-28) d1=d1.slice(0,110)+'…';
    var d2='Risco: '+String(rec.risco||'—'); if(g.measureText(d2).width>st.W-pad*2-28) d2=d2.slice(0,110)+'…';
    g.fillText(d1, pad+14, st.y+36);
    g.fillText(d2, pad+14, st.y+52);
    st.y+=h+10;
  }

  /* parágrafo cinza (termo, notas) */
  function kitTexto(st,texto,cor){
    var pad=st.pad;
    st.g.font='500 10px '+_KIT.FF;
    var linhas=_kitWrap(st.g,texto,st.W-pad*2-8), h=linhas.length*14+6;
    kitGarante(st,h+8);
    var g=st.g;                     /* mesma armadilha do kitAtencao — ver acima */
    g.font='500 10px '+_KIT.FF;
    g.fillStyle=cor||_KIT.cinza;
    var ty=st.y+10; linhas.forEach(function(ln){ g.fillText(ln, pad+4, ty); ty+=14; });
    st.y+=h+8;
  }

  /* ==========================================================================
     M (v637) — A LISTA DE LARGURA INTEIRA
     ==========================================================================
     🔴 POR QUE ELA PRECISOU EXISTIR. O `kitKv2` é uma GRADE DE DUAS COLUNAS,
     e cada célula tem meia folha. Quando o CNAE secundário chegava lá como um
     texto de 200 caracteres, o kv2 encolhia a fonte até 8px e desenhava —
     e o que não cabia saía PELA BORDA DA FOLHA. Num PDF real de 25/08, o
     segundo CNAE apareceu como "7319002 — P" e acabou. Cortado no meio da
     palavra, sem aviso.

     🔴 A REGRA QUE FICA: **texto cortado é pior que texto ausente.** Ausente,
     a pessoa procura em outro lugar. Cortado, ela acha que leu.

     Esta peça é o contrário do kv2: uma coluna, a largura toda, e quebra de
     linha DE VERDADE (o _kitWrap, que já existia). Dado curto — CEP, porte,
     capital — continua no kv2, que é onde grade rende. Lista e texto longo
     vêm pra cá.

     Cada item pode ser:
        'texto simples'
        { forte:'o que importa', fraco:'o detalhe' }   → nome / cargo
        { cod:'4511101', des:'Comércio a varejo…' }    → CNAE
     ⚠️ Ela pagina sozinha: 30 itens viram duas folhas em vez de uma folha
     cortada. É PDF — pode ter duas páginas; o que não pode é mentir. */
  function kitLista(st, titulo, itens){
    itens=(itens||[]).filter(function(it){
      if(it==null) return false;
      if(typeof it==='object') return String(it.forte||it.des||it.cod||'').trim()!=='';
      return String(it).trim()!=='';
    });
    if(!itens.length) return;
    var g=st.g, pad=st.pad;
    var largura=st.W-pad*2-28;

    /* mede antes de desenhar: cada item pode virar 1, 2 ou 3 linhas */
    function pedacos(it){
      if(typeof it!=='object') return { cod:'', linhas:_medeLinhas(String(it)), fraco:'' };
      var texto=String(it.forte||it.des||'').trim();
      /* v682 — o recuo do código é MEDIDO, não chutado. O 46 fixo deixava
         ~4px de folga pro código de 7 dígitos — em fonte de sistema mais
         larga (Segoe, no PDF real do Angelo de 28/08) o código ENCOSTAVA na
         descrição: "4520003Serviços…". Agora o recuo é a largura real do
         código + 10, nunca menor que 46 — a coluna continua alinhada nos
         códigos normais e só cresce quando precisa. */
      var rec=0;
      if(it.cod){
        g.font='800 9.5px '+_KIT.FF;
        rec=Math.max(46, Math.ceil(g.measureText(String(it.cod).trim()).width)+10);
      }
      return { cod:String(it.cod||'').trim(), rec:rec,
               linhas:_medeLinhas(texto, rec),
               fraco:String(it.fraco||'').trim() };
    }
    function _medeLinhas(txt, recuo){
      g.font='700 11px '+_KIT.FF;
      return _kitWrap(g, txt, largura-(recuo||0));
    }

    var medidos=itens.map(pedacos);
    var alturas=medidos.map(function(m){ return m.linhas.length*15 + (m.fraco?13:0) + 9; });

    var i=0;
    while(i<itens.length){
      /* quantos itens cabem no que sobra da página? no mínimo um */
      var sobra=st.H-st.RODAPE-10-st.y-30-14;
      var cabem=0, acumulado=16;
      while(i+cabem<itens.length && (acumulado+alturas[i+cabem])<=sobra){ acumulado+=alturas[i+cabem]; cabem++; }
      if(cabem===0){ kitGarante(st, 30+16+alturas[i]+14); continue; }

      g=st.g; // A paginacao troca o canvas; desenhar sempre na folha atual.
      _kitBanda(st, i===0 ? titulo : (titulo+' (continuação)'));
      _kitCartao(st, acumulado);
      var y=st.y+12;
      for(var k=0;k<cabem;k++){
        var m=medidos[i+k], x=pad+14;
        if(k){ g.strokeStyle=_KIT.fCz; g.lineWidth=1; g.beginPath();
               g.moveTo(pad+14,y-6); g.lineTo(st.W-pad-14,y-6); g.stroke(); }
        var xTexto=x;
        if(m.cod){
          g.fillStyle=_KIT.azul; g.font='800 9.5px '+_KIT.FF;
          g.fillText(m.cod, x, y+11);
          xTexto=x+(m.rec||46);   /* v682: o recuo medido lá em cima */
        }
        g.fillStyle=_KIT.tinta; g.font='700 11px '+_KIT.FF;
        m.linhas.forEach(function(ln,j){ g.fillText(ln, xTexto, y+11+j*15); });
        var yy=y+11+m.linhas.length*15;
        if(m.fraco){
          g.fillStyle=_KIT.cinza; g.font='600 9.5px '+_KIT.FF;
          g.fillText(m.fraco, xTexto, yy-2);
        }
        y+=alturas[i+k];
      }
      st.y+=acumulado+14;
      i+=cabem;
      if(i<itens.length) kitGarante(st, 200);   /* força folha nova pro resto */
    }
  }

  /* N (v637) — O TÍTULO DO DOCUMENTO
     🔴 No PDF do CNPJ a razão social era o MENOR texto da página: cinza claro,
     miúdo, com menos peso que o rótulo "NOME FANTASIA" logo abaixo. É o
     identificador mais importante da folha. Hierarquia invertida. */
  function kitTitulo(st, texto, sub){
    texto=String(texto||'').trim(); if(!texto) return;
    var g=st.g, pad=st.pad, largura=st.W-pad*2-4;
    var tam=17;
    g.font='800 '+tam+'px '+_KIT.FF;
    while(g.measureText(texto).width>largura && tam>12){ tam--; g.font='800 '+tam+'px '+_KIT.FF; }
    var linhas=_kitWrap(g, texto, largura);
    var h=linhas.length*(tam+5)+(sub?15:0)+8;
    kitGarante(st, h+8);
    g.fillStyle=_KIT.escuro;
    var ty=st.y+tam;
    linhas.forEach(function(ln){ g.fillText(ln, pad+2, ty); ty+=tam+5; });
    if(sub){ g.fillStyle=_KIT.cinza; g.font='600 10.5px '+_KIT.FF; g.fillText(String(sub), pad+2, ty+2); }
    st.y+=h+8;
  }

  /* J — o rodapé entra em TODA página, com pág. N de M (só dá pra carimbar
     no fim, quando o M existe) */
  /* ===== L (v621) — A GRADE DE FOTOS =========================================
     A única peça que faltava no kit pro PDF da avaliação. Grade de 3 colunas,
     6 fotos por página, cada célula 4:3 com o recorte "cover" (a foto
     preenche a célula sem deformar — o mesmo que o CSS object-fit faz).

     🔴 AS IMAGENS CHEGAM AQUI JÁ CARREGADAS. Desenhar em canvas é síncrono e
     carregar foto não é; quem chama resolve as promessas ANTES (ver
     avalPdfFotosCarrega no 07). Assim o kit continua todo síncrono — se essa
     regra cair, o PDF sai com buracos brancos e ninguém entende por quê.

     ⚠️ E CADA FOTO PRECISA SER DA MESMA ORIGEM (ou vir com CORS liberado):
     foto de outro domínio SUJA a canvas e o toDataURL() do jsPDF passa a
     falhar — o PDF inteiro morre por causa de uma imagem. O 07 resolve isso
     passando as fotos pelo /.netlify/images (o imgCdn), que é o nosso próprio
     domínio. */
  function _kitCover(g,img,x,y,w,h){
    var iw=img.naturalWidth||img.width, ih=img.naturalHeight||img.height;
    if(!iw||!ih) return false;
    var e=Math.max(w/iw, h/ih), dw=iw*e, dh=ih*e;
    g.drawImage(img, x+(w-dw)/2, y+(h-dh)/2, dw, dh);
    return true;
  }
  function kitFotos(st, imgs, titulo, rodape){
    imgs=(imgs||[]).filter(Boolean);
    if(!imgs.length) return 0;
    var pad=st.pad, gap=10, colW=(st.W-pad*2-gap*2)/3, celH=Math.round(colW*0.75);
    var i=0, primeira=true, desenhadas=0;
    while(i<imgs.length){
      var nesta=Math.min(6, imgs.length-i);
      var linhas=Math.ceil(nesta/3), h=linhas*(celH+gap)-gap;
      kitGarante(st, 30+h+14);
      _kitBanda(st, primeira?titulo:(titulo+' (continuação)'));
      primeira=false;
      var g=st.g;
      for(var k=0;k<nesta;k++){
        var col=k%3, lin=Math.floor(k/3);
        var x=pad+col*(colW+gap), y=st.y+lin*(celH+gap);
        g.save();
        _kitRR(g,x,y,colW,celH,8); g.clip();
        g.fillStyle='#f1f5f9'; g.fillRect(x,y,colW,celH);
        try{ if(_kitCover(g, imgs[i+k], x, y, colW, celH)) desenhadas++; }catch(_){}
        g.restore();
        g.strokeStyle=_KIT.borda; g.lineWidth=1; _kitRR(g,x+0.5,y+0.5,colW-1,celH-1,8); g.stroke();
      }
      st.y+=h+14;
      i+=nesta;
    }
    if(rodape){
      kitGarante(st,20);
      st.g.fillStyle=_KIT.cinza; st.g.font='600 9.5px '+_KIT.FF; st.g.textAlign='left';
      st.g.fillText(String(rodape), pad, st.y+8);
      st.y+=20;
    }
    return desenhadas;
  }

  function kitFinaliza(st){
    st.paginas.forEach(function(cv,i){
      var g=cv.getContext('2d');   /* já está em escala 2 via transform salvo? não — reaplica */
      g.save(); g.setTransform(2,0,0,2,0,0);
      var pad=st.pad, yr=st.H-st.RODAPE+8;
      g.strokeStyle=_KIT.borda; g.lineWidth=1.5; g.beginPath(); g.moveTo(pad,yr); g.lineTo(st.W-pad,yr); g.stroke();
      g.font='600 8.5px '+_KIT.FF; g.textAlign='left'; g.fillStyle=_KIT.rotulo;
      g.fillText((st.protocolo?('Protocolo '+st.protocolo+' · '):'')+st.geradoEm, pad, yr+16);
      g.textAlign='center'; g.fillText(st.lgpdCurto, st.W/2, yr+16);
      g.textAlign='right'; g.fillStyle=_KIT.cinza; g.font='700 8.5px '+_KIT.FF;
      g.fillText('MEV Veículos · pág. '+(i+1)+' de '+st.paginas.length, st.W-pad, yr+16);
      g.restore();
    });
    return st.paginas;
  }

  /* as páginas viram PDF (uma página A4 por canvas — nada mais é fatiado) */
  function kitPdfBlob(paginas){
    var jsPDF=window.jspdf&&window.jspdf.jsPDF; if(!jsPDF) return null;
    var pdf=new jsPDF({unit:'pt',format:'a4'});
    var pw=pdf.internal.pageSize.getWidth(), ph=pdf.internal.pageSize.getHeight();
    paginas.forEach(function(cv,i){
      if(i>0) pdf.addPage();
      pdf.addImage(cv.toDataURL('image/jpeg',0.92),'JPEG',0,0,pw,ph);
    });
    return pdf.output('blob');
  }

  /* prévia: as páginas empilhadas numa imagem só (pro visor da tela) */
  function kitPrevia(paginas){
    var GAP=10, W=paginas[0].width;
    var H=paginas.reduce(function(a,c){ return a+c.height; },0)+GAP*2*(paginas.length-1);
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
    var g=cv.getContext('2d'); g.fillStyle='#cbd5e1'; g.fillRect(0,0,W,H);
    var y=0;
    paginas.forEach(function(p){ g.drawImage(p,0,y); y+=p.height+GAP*2; });
    return cv;
  }

/* ╔═══ src/app/06z-avaliacao-motor.js ════════════════════════════════════ */
/* Fonte numérica única: navegador e backend. Não consulta APIs nem decide compra. */
var MEV_AVALIACAO_MOTOR = (function(){
  'use strict';
  /* ⚠️ A VERSÃO VAI JUNTO COM OS NÚMEROS. Ela sai carimbada em toda conta
     (`calcular` devolve `versao`), e serve pra saber DE QUAL RÉGUA veio um
     valor guardado. A v1051 mudou o imposto — então mudou a régua, então
     muda a data. Deixar a antiga faria uma avaliação nova se passar por
     velha. */
  var versao='2026-10-10.1';   /* faixa ideal usa 1.000–1.300 km por mês de uso */
  /* 🔴 v1068 (pedido do Angelo: "margem de 3000 editavel") — A MARGEM PADRÃO
     DE REPASSE SOBE DE 2.000 PRA 3.000.
     ⚠️ ELA MUDA AQUI, E NÃO NA TELA, e essa é a decisão: este arquivo é a
        fonte numérica única — o navegador o carrega e a função
        `netlify/functions/_avaliacao-previa.js` faz `require` DO MESMO
        ARQUIVO. Mudar só na tela faria a prévia do servidor devolver 28 onde
        o aplicativo mostra 27, pro mesmo carro. Duas verdades sobre o mesmo
        número é o defeito que esta casa mais persegue.
     ⚠️ E a VERSÃO subiu junto, como manda o aviso aqui em cima: ela sai
        carimbada em toda conta, e é o que permite saber de qual régua veio um
        valor guardado. Avaliação fechada com margem de 2.000 continua
        dizendo '2026-09-16.1'; a partir de hoje é '2026-09-18.1'. */
  var revisaoPct=.02, margemRepassePadrao=3000;
  var pisosCarro=Object.freeze({rev:1000,gar:1000,lucro:5000,com:1000});
  var pisosMoto=Object.freeze({rev:500,gar:500,lucro:3000,com:500});
  var padroes=Object.freeze({imp:2.5,comCarro:2,comMoto:2,lucroCarro:10,lucroMoto:15,garantia:5});
  function numero(v){ var n=Number(v); return Number.isFinite(n)?n:0; }
  function arredondar(v){ return Math.round(numero(v)/500)*500; }
  function arr500(v){ v=Math.round(numero(v)); return v<=0?0:Math.max(500,arredondar(v)); }
  /* ==========================================================================
     🔴 v1051 (pedido do Angelo, 16/09) — O IMPOSTO SOBE DE 500 EM 500
     --------------------------------------------------------------------------
     "impostos do veiculo sempre arredonde pra cima de 500,00 em 500,00".
     No print dele: FIPE de R$ 38.021,00 a 2,5% dava R$ 951,00. Passa a dar
     R$ 1.000,00.

     ⚠️ ISTO NÃO É O `arredondar` NEM O `arr500`, e a diferença importa:
       arredondar(951) = 1000   (mas arredondar(749) = 500 — desce)
       arr500(951)     = 1000   (mas arr500(749)     = 500 — desce)
       teto500(951)    = 1000
       teto500(749)    = 1000   ← SEMPRE sobe. É o que "pra cima" quer dizer.
     Por isso ele nasce como função própria em vez de reaproveitar as duas que
     já existem: elas arredondam pro mais PERTO, e imposto que desce vira
     imposto que a loja paga do bolso.

     ⚠️ OS CENTAVOS ANTES DO TETO, de propósito. `Math.ceil` de um número de
     ponto flutuante é traiçoeiro: um valor que DEVERIA ser 1000 exato pode
     chegar aqui como 1000,0000000001 e virar 1500 — R$ 500 de erro visível,
     por causa de um ruído na décima terceira casa. Arredondar pro centavo
     primeiro mata o ruído sem mexer em nenhum valor de verdade.

     ⛳ E ZERO CONTINUA ZERO: sem FIPE, ou com o percentual em 0, não há
     imposto — e "pra cima" não pode inventar R$ 500 de imposto do nada.
     Qualquer valor POSITIVO, por menor que seja, custa 500.
     ========================================================================== */
  function teto500(v){
    v=numero(v); if(v<=0) return 0;
    var cent=Math.round(v*100)/100;
    return Math.ceil(cent/500)*500;
  }
  function piso(v,min,ligado){ v=numero(v); return ligado&&v>0?Math.max(min,v):v; }
  function faixas(med){ med=numero(med); return med<=15000?0:Math.ceil((med-15000)/10000); }
  function textoBusca(v){
    return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  }
  function mencionaTetoSolar(v){
    var s=textoBusca(v);
    return /\bteto\b/.test(s) && /\b(solar|panoram)/.test(s);
  }
  /* O desconto só existe quando a ficha da versão OFERECE teto solar e ele
     não foi confirmado entre os opcionais presentes neste veículo. */
  function tetoSolarAusente(oferecidos,presentes){
    oferecidos=Array.isArray(oferecidos)?oferecidos:[];
    presentes=Array.isArray(presentes)?presentes:[];
    return oferecidos.some(mencionaTetoSolar) && !presentes.some(mencionaTetoSolar);
  }
  /* ============================================================================
     🔴🔴🔴 v1230 — O ABATIMENTO DE AUSÊNCIA VOLTOU A ACONTECER
     ----------------------------------------------------------------------------
     A regra existia desde sempre, mas lia `avAc`/`avDir` — os dois <select> que
     a v1079 ESCONDEU quando o Angelo pediu "fica só nos opcionais". Escondidos,
     eles respondem "Verificar" pra sempre, e "Verificar" não casa com "não tem".
     Resultado: de 1079 até aqui, NENHUMA avaliação levou abate de ar ou direção
     — sem erro na tela, só o número saindo cheio. Agora a resposta vem de onde
     ela realmente é dada: a lista de Opcionais do veículo.

     ⚠️ NÃO CONFERIDO ≠ NÃO TEM. Se a lista está VAZIA, ninguém conferiu nada —
     e silêncio não pode virar desconto. Sem essa trava, toda avaliação antiga
     (que não tem a chave `arcond`, criada agora) seria rebaixada de uma vez.
     ========================================================================== */
  var DESC_AUSENCIA={ ar:.95, dir:.95, teto:.90 };   /* ar 5% · direção 5% · teto solar 10% */
  function marcadosDe(v){
    if(Array.isArray(v)) return v;
    try{ var j=JSON.parse(String(v||'')||'null'); return (j&&Array.isArray(j.m))?j.m:[]; }catch(_){ return []; }
  }
  function semArNosOpcionais(v){
    var m=marcadosDe(v); if(!m.length) return false;
    return m.indexOf('arcond')<0 && m.indexOf('ardigital')<0;
  }
  function semDirecaoNosOpcionais(v){
    var m=marcadosDe(v); if(!m.length) return false;
    return m.indexOf('direeletr')<0 && m.indexOf('dirhidr')<0;
  }
  /* v1433 — idade estimada pela FABRICAÇÃO, não pelo ano-modelo.
     Sem o mês da compra, o meio do ano é a aproximação mais honesta: um
     2024/2025 calculado em 2026 tem 18 meses estimados (1,5 ano), em vez de
     só 12 meses pelo modelo 2025. `anoFabricacao` é explícito para não mudar
     silenciosamente integrações antigas nas quais `ano` ainda significa
     ano-modelo. Sem o novo campo, o cálculo legado permanece inteiro. */
  function idadeUso(d){
    var atual=numero(d.anoAtual), fab=numero(d.anoFabricacao);
    if(fab>0) return Math.max(.5,atual-fab-.5);
    return Math.max(1,atual-numero(d.ano));
  }
  function kmIdeal(idadeMeses){
    var meses=Math.max(0,Math.round(numero(idadeMeses)));
    return {min:meses*1000,max:meses*1300};
  }
  function liquidez(d){
    var idade=idadeUso(d), anoRef=numero(d.anoFabricacao)||numero(d.ano);
    var idadeMeses=anoRef>0?Math.round(idade*12):0, ideal=kmIdeal(idadeMeses);
    var media=d.km>0&&anoRef>0?Math.round(d.km/idade):0;
    var n=faixas(media);
    /* v1230: era um 0,9 só pra qualquer ausência; agora cada uma tem o seu.
       Os fatores se MULTIPLICAM, como as faixas de km já faziam — sem ar e sem
       direção dá 0,95 × 0,95 = 0,9025, ou seja −9,75%, não −10% redondo. */
    var descAus=d.moto?1:((d.semAr?DESC_AUSENCIA.ar:1)*(d.semDir?DESC_AUSENCIA.dir:1)*(d.semTetoSolar?DESC_AUSENCIA.teto:1));
    var fator=Math.pow(.90,n)*descAus;
    var auto=arr500(numero(d.fipe)*fator);
    return {idade:idade,idadeMeses:idadeMeses,idealMin:ideal.min,idealMax:ideal.max,media:media,faixas:n,automatica:auto,
      valor:d.liquidezManual!=null?(numero(d.liquidezManual)||auto):auto};
  }
  function percentual(base,escolha){
    escolha=escolha||{};
    return escolha.valor!=null?numero(escolha.valor):arr500(base*numero(escolha.percentual)/100);
  }
  function preferencias(d){
    var p=Object.assign({},padroes);
    Object.keys(p).forEach(function(k){
      var n=parseFloat((d||{})[k]); if(Number.isFinite(n)&&n>=0&&n<=90) p[k]=n;
    });
    return p;
  }
  function comerciais(compra,fipe){
    compra=Number(compra); fipe=Number(fipe);
    if(!Number.isFinite(compra)||compra<=0||!Number.isFinite(fipe)||fipe<=0) return {lojista:null,varejo:null};
    var base=Math.min(compra+2500,fipe*.85-2000);
    if(base<=0) return {lojista:null,varejo:null};
    var lojista=arredondar(base)+500;
    return {lojista:lojista,varejo:lojista+5000-100};
  }
  function compraRepasse(oferta,margem){ return Math.max(0,numero(oferta)-numero(margem)); }
  function calcular(d){
    var l=liquidez(d), liq=l.valor, p=preferencias(d.preferencias);
    var mins=d.moto?pisosMoto:pisosCarro, comPct=d.moto?p.comMoto:p.comCarro;
    var lucro=d.lucro||{percentual:d.moto?p.lucroMoto:p.lucroCarro};
    var garantia=d.garantia||{percentual:p.garantia};
    if(d.garantiaFabrica&&!d.garantiaEditada) garantia={percentual:0};
    var mg=piso(percentual(liq,garantia),mins.gar,!d.garantiaFabrica);
    var linhas=[['imp','Impostos (FIPE)',teto500(numero(d.fipe)*p.imp/100)],   /* v1051 */
      ['prep','Preparação',d.moto?200:1000],
      ['rev','Revisão',piso(Math.round(liq*revisaoPct),mins.rev,liq>0)],
      ['com','Comissão vendedor',piso(Math.round(liq*(comPct/100)),mins.com,comPct>0)]];
    (d.itens||[]).forEach(function(i){ if(i.valor>0) linhas.push([i.id,i.rotulo,numero(i.valor)]); });
    linhas=linhas.concat([['chave','Chave reserva',numero(d.chave)],
      ['lucro','Margem de lucro',piso(percentual(liq,lucro),mins.lucro,true)],
      ['garantia',d.garantiaFabrica&&!mg?'Margem de garantia (na garantia de fábrica)':'Margem de garantia',mg]]);
    var total=0, edits=d.edicoes||{};
    linhas.forEach(function(x){ x[3]=Object.prototype.hasOwnProperty.call(edits,x[0])&&edits[x[0]]!=null?numero(edits[x[0]]):x[2]; if(x[0]==='rev'||x[0]==='com'){x[2]=Math.min(1000,Math.max(0,x[2]));x[3]=Math.min(1000,Math.max(0,x[3]));} total+=x[3]; });
    var loja=Math.max(0,arredondar(liq-total));
    var repasse=Math.max(0,arredondar(liq*.85));
    if(repasse&&loja&&repasse<loja) repasse=arredondar(loja*1.02);
    var comercial=comerciais(loja,d.fipe);
    return {versao:versao,liquidez:l,linhas:linhas,custos:total,loja:loja,repasse:repasse,
      comercial:comercial,faixa:{min:arredondar(liq*.95),max:arredondar(liq*1.05)},
      compraRepasse:comercial.lojista==null?null:compraRepasse(
        d.ofertaLojista!=null?d.ofertaLojista:comercial.lojista,
        d.margemRepasse!=null?d.margemRepasse:margemRepassePadrao)};
  }
  function ehMoto(v){
    if(!v) return false;
    if(v.tipo){ var t=String(v.tipo).toLowerCase(); if(t.indexOf('moto')>=0) return true; if(t.indexOf('carro')>=0||t.indexOf('auto')>=0||t.indexOf('cami')>=0) return false; }
    var s=String(v.especie||'').toUpperCase();
    if(/MOTO|CICLOMOTOR|MOTONETA|TRICICLO|QUADRICICLO/.test(s)) return true;
    var txt=((v.marca||'')+' '+(v.modelo||'')+' '+(v.versao||'')).toUpperCase();
    if(/\b\d{2,4}\s?CC\b/.test(txt)) return true;
    if(/\b(YAMAHA|KAWASAKI|HARLEY|DUCATI|TRIUMPH|DAFRA|SHINERAY|HAOJUE|TRAXX|KASINSKI|ROYAL ENFIELD|VESPA|KYMCO|SUNDOWN|MOTOMEL|BAJAJ|MOTTU)\b/.test(txt)) return true;
    if(/\b(BIZ|POP|CG|FAN|TITAN|BROS|XRE|CB|CBR|PCX|ELITE|LEAD|FAZER|FACTOR|CRYPTON|NEO|XTZ|LANDER|TENERE|YBR|MT03|MT07|INTRUDER|BURGMAN|GSX|BANDIT|HORNET|TWISTER|COMET|NMAX|ADV|XJ6|SRAD)\b/.test(txt)) return true;
    return false;
  }
  function motoPorte(v){
    var m=(((v&&v.modelo)||'')+' '+((v&&v.versao)||'')).toUpperCase(), cc=0;
    var mt=m.match(/(\d{2,4})\s?CC/); if(mt) cc=parseInt(mt[1],10)||0;
    if(!cc){ var mt2=m.match(/\b(110|125|150|160|190|200|250|300|350|400|500|600|650|750|800|900|1000|1200)\b/); if(mt2) cc=parseInt(mt2[1],10)||0; }
    if(!cc){ var f=Number(v&&v.fipe)||0; if(f&&f<12000) return 'peq'; if(f&&f<25000) return 'med'; return 'gra'; }
    if(cc<=160) return 'peq'; if(cc<=350) return 'med'; return 'gra';
  }
  function motoTiers(porte){
    var T={ peq:{pneuD:200,pneuT:250,rel:250,fre:120,car:300,rev:250},
            med:{pneuD:350,pneuT:450,rel:450,fre:180,car:600,rev:350},
            gra:{pneuD:700,pneuT:800,rel:900,fre:300,car:1000,rev:500} };
    return T[porte]||T.med;
  }
  return Object.freeze({revisaoPct:revisaoPct,margemRepassePadrao:margemRepassePadrao,ehMoto:ehMoto,motoPorte:motoPorte,motoTiers:motoTiers,versao:versao,pisosCarro:pisosCarro,pisosMoto:pisosMoto,
    padroes:padroes,preferencias:preferencias,arr500:arr500,teto500:teto500,piso:piso,faixas:faixas,
    tetoSolarAusente:tetoSolarAusente,idadeUso:idadeUso,kmIdeal:kmIdeal,
    liquidez:liquidez,calcular:calcular,comerciais:comerciais,compraRepasse:compraRepasse,
    DESC_AUSENCIA:DESC_AUSENCIA,semArNosOpcionais:semArNosOpcionais,semDirecaoNosOpcionais:semDirecaoNosOpcionais});
})();
if(typeof module==='object'&&module.exports) module.exports=MEV_AVALIACAO_MOTOR;

/* ╔═══ src/app/07-avaliacao.js ═══════════════════════════════════════════ */
  /* ===== CLIENTE: faixa de valor (sem custos nem margem) ===== */
  function faixaHtml(v){
    var f=Number(v.fipe)||0;
    if(!f) return '<div class="plc-msg">Sem FIPE pra estimar. Confira a placa.</div>';
    var partMin=Math.round(f*0.92), partMax=Math.round(f*1.00);   /* venda particular */
    var rapMin=Math.round(f*0.82), rapMax=Math.round(f*0.90);      /* venda rápida / troca */
    return '<div class="faixa-box"><div class="faixa-lbl">Venda para particular</div><div class="faixa-val">'+brl(partMin)+' a '+brl(partMax)+'</div></div>'+
      '<div class="faixa-box" style="margin-top:8px"><div class="faixa-lbl">Venda rápida / troca na loja</div><div class="faixa-val">'+brl(rapMin)+' a '+brl(rapMax)+'</div></div>'+
      '<div class="plc-msg" style="margin-top:8px">Estimativa a partir da tabela FIPE. O valor real depende de quilometragem, estado de conservação e documentação. Para um número fechado, fale com um vendedor.</div>';
  }

  /* ===== Avaliação de troca — CÁLCULO MANTIDO (mesma lógica), porém NÃO EXIBIDO =====
     As funções abaixo continuam no app pra uso futuro/interno, mas nada delas é
     renderizado: a tela só mostra a estimativa em faixa (faixaHtml). Ninguém vê
     custo/margem. Para reativar a exibição, basta chamar avaliacaoFormHtml/atrelarAvaliacao
     dentro de renderResultado. */
  function ai(id,lbl,val,ph){ return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><input id="'+id+'" class="avt-in" value="'+(val==null?'':val)+'" placeholder="'+(ph||'')+'" inputmode="numeric"></div>'; }
  function asel(id,lbl,opts,sel){ return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><select id="'+id+'" class="avt-in avt-sel">'+opts.map(function(o){return '<option'+(o===sel?' selected':'')+'>'+o+'</option>';}).join('')+'</select></div>'; }
  /* lista de custo: cada opção guarda o valor em R$ (usado no cálculo) */
  function aselC(id,lbl,pairs,selVal){ return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><select id="'+id+'" class="avt-in avt-sel">'+pairs.map(function(p){return '<option value="'+p[1]+'"'+(p[1]===selVal?' selected':'')+'>'+p[0]+'</option>';}).join('')+'</select></div>'; }
  /* ===== v620 — OS TRÊS PISOS MORAM AQUI, NUM LUGAR SÓ =====================
     Eles nasceram na v617 DENTRO da função de cálculo. O rótulo do seletor é
     outra função — e não enxergava os pisos. Resultado: a tela dizia
     "10% · R$ 2.500" e a avaliação usava R$ 5.000. Num papel que vira
     negociação com o cliente, número na tela diferente do número da conta é
     pior do que não ter piso nenhum.
     Subindo pro topo do módulo, os dois lugares leem a MESMA fonte — mesmo
     princípio do MEV_BUILD: um número só, nunca copiado. */
  /* v624 (pedido): "em custos, na comissao do vendedor deixe 2% com valor
     minimo de 1000". O piso da comissão dobrou (era 500, da v617) e o
     percentual padrão do CARRO virou 2% — o da moto já era 2%.
     ⚠️ Quem já mexeu no % da comissão pela linha do custo tem o número
     SALVO no aparelho (mev_av_pcts) e continua com o dele: o padrão só vale
     pra quem nunca mexeu. Pra passar pro novo, é editar o % na linha uma
     vez — aí ele grava por cima. */
  var AV_MIN_COM=MEV_AVALIACAO_MOTOR.pisosCarro.com, AV_MIN_GAR=MEV_AVALIACAO_MOTOR.pisosCarro.gar, AV_MIN_LUCRO=MEV_AVALIACAO_MOTOR.pisosCarro.lucro;
  /* v677 (pedido, com print da aba Custos: "adicione por padrão nos custos,
     1000 (mínimo, ou 2%) de revisão") — a REVISÃO virou linha padrão: 2% da
     liquidez ajustada, nunca menos de R$ 1.000. Mesma família dos pisos da
     v617: percentual justo no carro caro, chão no carro barato. */
  var AV_MIN_REV=MEV_AVALIACAO_MOTOR.pisosCarro.rev, AV_REV_PCT=MEV_AVALIACAO_MOTOR.revisaoPct;
  /* ============================================================================
     🔴 v893 — A MOTO TEM PISOS PRÓPRIOS (pedido do Angelo, 04/09)
     ----------------------------------------------------------------------------
     "Quando for uma avaliação de moto, esses são os valores mínimos:
      quinhentos na revisão, quinhentos na garantia e três mil na margem."

     Os pisos da v617/v620/v677 nasceram olhando CARRO. Numa moto de R$ 12 mil
     um piso de R$ 5.000 de margem não é chão: é a avaliação inteira. O piso
     existe pra proteger o negócio no veículo barato — aplicado no tamanho
     errado, ele inviabiliza o negócio que deveria proteger.

     ⚠️ A COMISSÃO NÃO ENTROU. O Angelo nomeou três, e piso é dinheiro: mexer
     no que ele não pediu seria inventar regra comercial. Ela segue em R$ 1.000
     nos dois — se estiver errado pra moto, é uma linha.
     ⚠️ E os pisos são LIDOS POR FUNÇÃO, não copiados. A lição da v620 é
     exatamente esta: quando o rótulo da tela e a conta leem fontes diferentes,
     a tela diz um número e a avaliação usa outro. Um número só, nunca copiado.
     ============================================================================ */
  /* v894 (04/09, mesma conversa) — a comissão da moto entrou: R$ 500.
     A v893 tinha deixado a comissão fora de propósito, porque o Angelo
     nomeou três pisos e piso é dinheiro. Ele voltou e nomeou o quarto:
     "comissão de moto coloca o mínimo em 500,00". Agora a moto tem os
     QUATRO pisos próprios, e a tabela fica assim:

         piso                CARRO       MOTO
         revisão            R$ 1.000    R$ 500
         margem de garantia R$ 1.000    R$ 500
         margem de lucro    R$ 5.000    R$ 3.000
         comissão           R$ 1.000    R$ 500

     ⚠️ O percentual NÃO mudou — 2% nos dois. O que mudou é o chão de quando
     os 2% dão pouco. E quem já editou o % na linha de custo segue com o
     número salvo no aparelho (mev_av_pcts), como sempre. */
  var AV_MIN_MOTO=MEV_AVALIACAO_MOTOR.pisosMoto;
  function avMinRev(){   return _ehMoto?AV_MIN_MOTO.rev  :AV_MIN_REV; }
  function avMinGar(){   return _ehMoto?AV_MIN_MOTO.gar  :AV_MIN_GAR; }
  function avMinLucro(){ return _ehMoto?AV_MIN_MOTO.lucro:AV_MIN_LUCRO; }
  function avMinCom(){   return _ehMoto?AV_MIN_MOTO.com  :AV_MIN_COM; }
  /* devolve o valor com o piso aplicado — só quando a linha está LIGADA
     (percentual > 0). Zerar de propósito continua valendo zero: piso é chão,
     não cobrança nova. */
  function avPiso(valor, piso, ligado){ return MEV_AVALIACAO_MOTOR.piso(valor,piso,ligado); }

  /* Cada item com custo usa a mesma lógica: sem custo, serviços ou verificar.
     O serviço abre uma ficha curta com um exemplo de orçamento do próprio item. */
  var AV_SERV_EXEMPLOS={
    avPneus:{servico:'troca de dois pneus',valor:1500}, avLat:{servico:'pintura da porta',valor:500},
    avMec:{servico:'troca de correia dentada',valor:1200}, avEle:{servico:'reparo do alternador',valor:600},
    avCambio:{servico:'troca do óleo do câmbio',valor:1500}, avSusp:{servico:'troca de amortecedores',valor:1200},
    avEmbr:{servico:'troca do kit de embreagem',valor:1800}, avParab:{servico:'reparo de trinca',valor:200},
    avEstof:{servico:'reparo do banco do motorista',valor:400}, avPainel:{servico:'reparo do painel de instrumentos',valor:600},
    avRev:{servico:'troca de óleo e filtros',valor:500}, avPneuD:{servico:'troca do pneu dianteiro',valor:350},
    avPneuT:{servico:'troca do pneu traseiro',valor:450}, avRelacao:{servico:'troca de corrente, coroa e pinhão',valor:450},
    avFreios:{servico:'troca de pastilhas de freio',valor:180}, avCaren:{servico:'reparo na carenagem',valor:600},
    avFerr:{servico:'tratamento no escapamento',valor:200}
  };
  function avServExemplo(id){ return AV_SERV_EXEMPLOS[id]||{servico:'serviço a avaliar',valor:0}; }
  function aselServ(id,lbl,okLbl){
    var ex=avServExemplo(id);
    return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><select id="'+id+'" class="avt-in avt-sel"><option value="" selected>Verificar</option><option value="0">'+okLbl+'</option><option value="outro">Serviços</option></select><input id="'+id+'Desc" class="avt-in" placeholder="Ex.: '+ex.servico+'" style="display:none;margin-top:6px"><input id="'+id+'Out" class="avt-in" inputmode="numeric" placeholder="custo aproximado (R$)" style="display:none;margin-top:6px"></div>';
  }
  /* ⚠️ v620: o 4º argumento (selVal) é DECORATIVO aqui — esta função sempre
     começa em "Verificar". Ficou como está de propósito: mexer nisso mudaria
     o padrão de TODOS os itens de custo de uma vez. Quem lê a chamada e vê
     um número no fim não deve concluir que aquilo é o valor pré-escolhido. */
  function aselCusto(id,lbl,pairs,selVal){
    var temOutro=false;
    var opts='<option value="" selected>Verificar</option>'+pairs.map(function(p){
      if(String(p[1])==='outro'){ temOutro=true; return '<option value="outro">Serviços</option>'; }
      return '<option value="'+p[1]+'">'+p[0]+'</option>';
    }).join('');
    if(!temOutro) opts+='<option value="outro">Serviços</option>';
    return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><select id="'+id+'" class="avt-in avt-sel">'+opts+'</select><input id="'+id+'Out" class="avt-in" inputmode="numeric" placeholder="R$ 0" style="display:none;margin-top:6px"></div>';
  }
  function aselPct(id,lbl,pcts,selVal){ var opts=pcts.map(function(p){return '<option value="'+p+'"'+(p===selVal?' selected':'')+'>'+p+'%</option>';}).join('')+'<option value="outro"'+(selVal==='outro'?' selected':'')+'>Outro (digite em R$)</option>'; return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><select id="'+id+'" class="avt-in avt-sel">'+opts+'</select><input id="'+id+'Out" class="avt-in" inputmode="numeric" placeholder="R$ 0" style="display:none;margin-top:6px"></div>'; }
  function _custo(id){ var e=$(id); if(!e) return 0; if(e.value==='outro'){ var o=$(id+'Out'); return o?(parseInt(String(o.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0):0; } return Number(e.value)||0; }
  function _slug(s){ try{ s=String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,''); }catch(_){ s=String(s||''); } return s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function buscaLinksHtml(v, km){
    v=v||{};
    var marcaRaw=String(v.marca||''); var marca=marcaRaw.split(/[\s\-]+/).filter(Boolean).pop()||marcaRaw;
    var modelo=String(v.modelo||'').split(/\s+/).slice(0,2).join(' ');
    var ano=parseInt(v.ano_modelo||v.ano||0,10)||0;   /* v190: anuncio e' pelo ano-modelo */
    km=parseInt(km||0,10)||0;
    var kmLo=Math.max(0,km-15000), kmHi=km+15000;
    var q=encodeURIComponent((marca+' '+modelo+(ano?(' '+ano):'')).trim());
    var mS=_slug(marca), moS=_slug(modelo);
    var ml='https://lista.mercadolivre.com.br/'+[mS,moS,(ano||'')].filter(Boolean).join('-');
    var olx='https://www.olx.com.br/autos-e-pecas/carros-vans-e-utilitarios?q='+q;
    var wm='https://www.webmotors.com.br/carros/estoque/'+mS+(moS?('/'+moS):'')+'?'+(ano?('anoDe='+ano+'&anoAte='+ano+'&'):'')+(km?('kmDe='+kmLo+'&kmAte='+kmHi):'');
    var termo=(marca+' '+modelo+(ano?(' '+ano):'')).trim()||'veículos semelhantes';
    var faixa=km?(kmLo.toLocaleString('pt-BR')+'–'+kmHi.toLocaleString('pt-BR')+' km'):'quilometragem a informar';
    /* Os filtros aparecem antes dos atalhos para deixar claro qual recorte cada
       portal vai receber, sem embutir páginas externas no app. */
    return '<div class="avt-busca-t">'+_AVI_SEARCH+'<span>Pesquisar anúncios semelhantes</span></div>'+
      '<div class="avt-busca-meta"><span>'+esc(termo)+'</span><span>'+esc(faixa)+'</span></div>'+
      '<div class="avt-busca-btns avt-busca-3">'+
        '<a class="avt-busca-b" href="'+esc(olx)+'" target="_blank" rel="noopener">OLX</a>'+
        '<a class="avt-busca-b ml" href="'+esc(ml)+'" target="_blank" rel="noopener">Mercado Livre</a>'+
        '<a class="avt-busca-b wm" href="'+esc(wm)+'" target="_blank" rel="noopener">Webmotors</a>'+
      '</div>';
  }
  function atualizaBusca(){ var box=$('avBusca'); if(!box) return; box.innerHTML=buscaLinksHtml(veiculoAtual||{}, _km()); }
  /* A faixa pertence ao resultado pesquisado, não ao motor de liquidez. Uma
     faixa sem fontes web não é aceita: avaliações antigas permanecem sem
     números até uma nova pesquisa, em vez de receber uma estimativa local. */
  function avMercadoFaixa(){
    var r=fichaState&&fichaState.faixa_mercado, fontes=fichaState&&fichaState.fontes_pesquisa;
    var min=Number(r&&r.min)||0, max=Number(r&&r.max)||0;
    if(!(min>0&&max>=min&&Array.isArray(fontes)&&fontes.length)) return null;
    return {min:Math.round(min),max:Math.round(max),amostra:Math.max(0,Number(r.amostra)||0),quilometragem:Math.max(0,Number(r.quilometragem)||0)};
  }
  function avMercadoFaixaPinta(){
    var el=$('avMktRng'), ajuda=$('avMktRngAjuda'), f=avMercadoFaixa(), km=_km();
    if(el) el.textContent=f?(r$(f.min)+' a '+r$(f.max)):'Aguardando pesquisa';
    if(!ajuda) return;
    if(!f) ajuda.textContent='Gere ou atualize a análise para pesquisar anúncios deste modelo e quilometragem.';
    else if(km&&f.quilometragem&&km!==f.quilometragem) ajuda.textContent='Pesquisa feita para '+f.quilometragem.toLocaleString('pt-BR')+' km. Atualize para pesquisar a quilometragem atual.';
    else ajuda.textContent='Faixa baseada em anúncios semelhantes'+(f.amostra?(' · '+f.amostra+' referências'):'')+(f.quilometragem?(' · '+f.quilometragem.toLocaleString('pt-BR')+' km'):'')+'.';
  }
  /* v946 — preparação automática da avaliação.
     Ficha técnica e análise de mercado começam depois que dados e km já foram
     restaurados. O mapa evita repetir automaticamente uma falha na mesma
     sessão; o endpoint também reaproveita job pendente por usuário/placa/tipo. */
  var _avIaAutoSessao={};
  function _avIaAutoPlaca(placa){ return String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); }
  function _avIaAutoChave(tipo,placa){ return String(tipo||'')+':'+_avIaAutoPlaca(placa); }
  function avIaAutoRodando(tipo,placa){ return _avIaAutoSessao[_avIaAutoChave(tipo,placa)]==='rodando'; }
  function _avIaAutoAindaAberta(placa){ return _avIaAutoPlaca(veiculoAtual&&veiculoAtual.placa)===_avIaAutoPlaca(placa); }
  /* Preenche a "Avaliação de mercado" dentro do card azul (vem da Ficha Técnica). */
  function pintaAvalMercado(){
    var box=$('avMktAval'); if(!box) return;
    var html=fichaState?avalMercadoHtml(fichaState):'';
    if(html){
      var faixa=avMercadoFaixa(), km=_km(), desatualizada=!faixa||(km&&faixa.quilometragem&&km!==faixa.quilometragem);
      box.innerHTML = html+(desatualizada?'<button type="button" class="avm-gerar" id="avmAtualizarFaixa">Atualizar pesquisa de preços — '+precoReal(1)+'</button>':'');
      var atualizar=$('avmAtualizarFaixa'); if(atualizar) atualizar.onclick=function(){ avalMercadoGerar(true); };
      /* v242: acordeão — abrir um bloco minimiza o que estava aberto */
      Array.prototype.forEach.call(box.querySelectorAll('.avm-it > .fic-t'),function(b){
        b.onclick=function(e){ e.stopPropagation(); var it=b.parentNode, abre=!it.classList.contains('open');
          Array.prototype.forEach.call(box.querySelectorAll('.avm-it.open'),function(x){ x.classList.remove('open'); });
          if(abre) it.classList.add('open'); };
      });
    } else if(avIaAutoRodando('mercado',veiculoAtual&&veiculoAtual.placa)) {
      box.innerHTML='<div class="plc-msg av-ia-preparo">Preparando análise de mercado em segundo plano…</div>';
    } else {
      box.innerHTML=(fichaState?'<p class="plc-msg" role="status">A análise recebida está incompleta. Tente gerar novamente.</p>':'')+'<button type="button" class="avm-gerar" id="avmGerar">Gerar análise de mercado com IA — '+precoReal(1)+'</button>';
      var b=$('avmGerar'); if(b) b.onclick=function(){ avalMercadoGerar(); };
    }
  }
  async function avalMercadoGerar(forcar){
    if(!veiculoAtual) return;
    if(!forcar && fichaState && avalMercadoHtml(fichaState)){ pintaAvalMercado(); return; }
    if(avIaAutoRodando('mercado',veiculoAtual.placa)) return;
    var box=$('avMktAval'); if(box) box.innerHTML=ccLoaderHtml('Analisando o mercado deste veículo…',_mktFrasesIA);
    var _lt=ccLoaderStart(_mktFrasesIA);
    /* Geracao manual paga; resultados salvos nao geram outro job. */
    var _pl=_avIaAutoPlaca(veiculoAtual.placa), _key=_avIaAutoChave('mercado',_pl);
    _avIaAutoSessao[_key]='rodando';
    var _veic=vinfo(); _veic.quilometragem=_km();
    var d=null;
    try{ d=await _iaJobRodar({ job:true, cobrar:true, tipo:'mercado', placa:_pl, veiculo:_veic },150000); }
    catch(_){ d=null; }
    finally{ clearInterval(_lt); }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(d&&d.ok&&d.resultado){
      _avIaAutoSessao[_key]='feito';
      histSetGerado(_pl,'ficha',d.resultado);
      if(_avIaAutoAindaAberta(_pl)) fichaState=d.resultado||{};
      else return;
    }
    else { _avIaAutoSessao[_key]='falhou'; if(_avIaAutoAindaAberta(_pl) && $('avMktAval')){ $('avMktAval').innerHTML='<button type="button" class="avm-gerar" id="avmGerar">Tentar de novo</button>'; var rb=$('avmGerar'); if(rb) rb.onclick=function(){ avalMercadoGerar(); }; } return; }
    pintaAvalMercado(); avMercadoFaixaPinta(); avJevPinta();
  }
  /* salva/restaura o formulário de avaliação por placa (localStorage) */
  var AV_FIELDS=['avKm','avIpva','avLiq','avLiqT','avAc','avDir','avPorte','avPneus','avPneusDesc','avPneusOut','avLat','avLatDesc','avLatOut','avPneuD','avPneuDDesc','avPneuDOut','avPneuT','avPneuTDesc','avPneuTOut','avRelacao','avRelacaoDesc','avRelacaoOut','avFreios','avFreiosDesc','avFreiosOut','avCaren','avCarenDesc','avCarenOut','avMec','avMecDesc','avMecOut','avEle','avEleDesc','avEleOut','avRev','avRevDesc','avRevOut','avMg','avMgOut','avLucro','avLucroOut','avChave','avManual','avRevC','avRevCKm','avDonos','avObs','avQuem','avValor','avValorT','avVendaLojista','avVendaLojistaT','avVendaVarejo','avVendaVarejoT','avAlien','avAlienQuem','avAlienValor','avMultas','avRepPreco','avRepT','avCustoEdJ','avMktPreco','avMktOutro','avMktOpc','avMktDest','avPostIa','avPostIaEm','avJevJ','avCambio','avCambioDesc','avCambioOut','avSusp','avSuspDesc','avSuspOut','avEmbr','avEmbrDesc','avEmbrOut','avParab','avParabDesc','avParabOut','avRevJa','avProxRev','avPrecoOculto','avLojFlag','avLojOferta','avLojMargem','avLojQuem','avFerr','avFerrDesc','avFerrOut','avGarantia','avGarantiaAte','avEstof','avEstofDesc','avEstofOut','avPainel','avPainelDesc','avPainelOut','avLatSvJ','avMecSvJ','avEleSvJ','avCambioSvJ','avSuspSvJ','avEmbrSvJ','avEstofSvJ','avPainelSvJ','avLatSvJ','avMecSvJ','avEleSvJ','avCambioSvJ','avSuspSvJ','avEmbrSvJ','avEstofSvJ','avPainelSvJ','avPneusSvJ','avParabSvJ','avRevSvJ','avPneuDSvJ','avPneuTSvJ','avRelacaoSvJ','avFreiosSvJ','avCarenSvJ','avFerrSvJ'];
  AV_FIELDS=AV_FIELDS.filter(function(id,i,a){return a.indexOf(id)===i;});
  /* 🔴 v924 — OS CAMPOS DA VISTORIA ENTRAM NA MESMA LISTA.
     A AV_FIELDS é o único lugar que decide o que é salvo no rascunho, o que
     sobe pra nuvem, o que volta ao reabrir e o que sai na exportação. Somar
     aqui é somar nos quatro de uma vez — e é por isso que não existe uma
     segunda máquina de persistência pra vistoria.
     ⚠️ A lista vem do 07c (avVistoriaIds), não copiada pra cá: campo novo lá
     já nasce salvo, sem ninguém lembrar desta linha. */
  try{ AV_FIELDS=AV_FIELDS.concat(avVistoriaIds()); }catch(_){}
  function avFormKey(){ return 'mev_aval:'+((veiculoAtual&&veiculoAtual.placa)||'x'); }
  /* ============ v184 — ESPELHO: AVALIACAO <-> ESTOQUE ============
     O que resolve: voce digitava a quilometragem, as observacoes e o valor na
     AVALIACAO e depois tinha que digitar tudo de novo no ESTOQUE (e vice-versa).
     Como funciona: existe um "bilhete" guardado no proprio aparelho, um por
     PLACA (mev_espelho_ABC1D23). Sempre que voce muda um campo compartilhado
     numa tela, o bilhete e' atualizado; quando a outra tela abre, ela le' o
     bilhete e se preenche sozinha. Como as duas telas nunca ficam abertas ao
     mesmo tempo no celular, vale sempre "quem digitou por ultimo".

     CUIDADO PROPOSITAL: apagar um campo NAO apaga o outro lado. So' valor
     preenchido viaja — assim um campo em branco nunca come um dado bom.

     Os pares (e a unidade de cada um, que e' diferente nas duas telas!):
       km      -> #avKm      (80.000)     <-> #efKm      (80.000)
       obs     -> #avObs                  <-> #efObs
       repasse -> #avRepPreco (R$ 59.415) <-> #efRepasse (R$ 59.415,00)
       compra  -> #avValor    (R$ 55.471) <-> #efCompra  (R$ 55.471,00)
     A avaliacao trabalha em reais inteiros; o estoque, em centavos. O bilhete
     guarda sempre REAIS INTEIROS e cada lado formata do seu jeito. */
  var ESP_CAMPOS=['km','obs','repasse','compra'];
  function _espKey(placa){ return 'mev_espelho_'+String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function espelhoLer(placa){
    try{ var k=_espKey(placa); if(k.length<17) return {}; return JSON.parse(localStorage.getItem(k)||'{}')||{}; }catch(_){ return {}; }
  }
  function espelhoGravar(placa, campos){
    try{
      var k=_espKey(placa); if(k.length<17) return;
      var o=espelhoLer(placa), mud=false;
      ESP_CAMPOS.forEach(function(c){
        var nv=campos[c]; if(nv==null||nv==='') return;          /* vazio nao viaja */
        if(String(nv)===String(o[c]==null?'':o[c])) return;
        o[c]=nv; mud=true;
      });
      if(!mud) return;
      o._em=Date.now();
      localStorage.setItem(k, JSON.stringify(o));
    }catch(_){}
  }
  /* v693 — APAGAR DE PROPÓSITO TAMBÉM VALE. O Angelo apagava as observações
     (as do laudo do Avaliex) e elas VOLTAVAM: o rascunho salvava o vazio,
     mas o bilhete do espelho guardava o texto velho ("vazio não viaja") — e
     o pon(soVazio) da reabertura preenchia o campo vazio de novo. Regra
     nova: quando o texto passa de PREENCHIDO pra VAZIO na tela, a chave sai
     do BILHETE. A outra tela não perde nada (aplicar já ignora chave
     ausente) — só PARA DE REPOR o que foi apagado. */
  function espelhoApagaCampo(placa, campo){
    try{
      var k=_espKey(placa); if(k.length<17) return;
      var o=JSON.parse(localStorage.getItem(k)||'{}')||{};
      if(o[campo]==null) return;
      delete o[campo]; o._em=Date.now();
      localStorage.setItem(k, JSON.stringify(o));
    }catch(_){}
  }
  function _espMilhar(n){ n=Math.round(Number(n)||0); return n?Number(n).toLocaleString('pt-BR'):''; }
  function _espRsInt(n){ n=Math.round(Number(n)||0); return n?('R$ '+Number(n).toLocaleString('pt-BR')+',00'):''; }
  function _espSoNum(id){ var e=$(id); if(!e) return ''; var d=String(e.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); return d?String(parseInt(d,10)):''; }

  /* ---- lado AVALIACAO ---- */
  function avEspelhoColeta(){
    var gc=_avGastoCompartLer(avGastosLer());
    return { km:_espSoNum('avKm'), obs:String((($('avObs')||{}).value||'')).trim(),
             repasse:_espSoNum('avRepPreco'), compra:_espSoNum('avValor'),
             gastosTotal:gc?gc.valor:0, gastosDescricao:gc?gc.descricao:'' };
  }
  var _avObsPlaca='', _avObsTinha=false;   /* v693: transição preenchido→vazio */
  function avEspelhoGravar(){
    try{
      var placa=(veiculoAtual&&veiculoAtual.placa)||''; if(!placa) return;
      var c=avEspelhoColeta();
      if(_avObsPlaca===placa && _avObsTinha && !c.obs){
        espelhoApagaCampo(placa,'obs');                 /* v693: apagou, não volta */
        try{ avFormSalvarNuvem(); }catch(_){}           /* e a nuvem fica sabendo JÁ (sem os 1,5s) */
      }
      _avObsPlaca=placa; _avObsTinha=!!c.obs;
      espelhoGravar(placa, c);
      /* v1435 — Dados do veículo e a folha de compartilhar escrevem na
         mesma ficha por placa. Aqui a cópia do histórico é apenas local;
         o envio à conta continua no autosave/compartilhamento já existente. */
      try{ histShareDetalhesGravarDados(placa,c.km,c.obs,c.gastosTotal,c.gastosDescricao,veiculoAtual,false); }catch(_){}
    }catch(_){}
  }
  function avCompartDetalhesLer(placa){
    try{
      var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''), km='', obs='', gc=null;
      var o=espelhoLer(p); km=String(o.km||''); obs=String(o.obs||'');
      try{
        var d=JSON.parse(localStorage.getItem('mev_aval:'+p)||'{}')||{};
        if(d.avKm) km=String(d.avKm).replace(/\D/g,'');
        if(d.avObs) obs=String(d.avObs);
        gc=_avGastoCompartLer(avGastosNormalizar(d.avGastosJ));
      }catch(_){}
      var atual=String((veiculoAtual&&veiculoAtual.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      if(atual===p&&($('avKm')||$('avObs')||$('avGastosJ'))){
        var ek=$('avKm'), eo=$('avObs');
        if(ek&&String(ek.value||'').replace(/\D/g,'')) km=String(ek.value).replace(/\D/g,'');
        if(eo&&String(eo.value||'').trim()) obs=String(eo.value).trim();
        gc=_avGastoCompartLer(avGastosLer())||gc;
      }
      return {km:km,obs:obs,gastosTotal:gc?gc.valor:0,gastosDescricao:gc?gc.descricao:''};
    }catch(_){ return {}; }
  }
  function avCompartDetalhesAplicar(placa,km,obs,gastosTotal,gastosDescricao){
    try{
      var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); if(!p) return;
      var n=String(km||'').replace(/\D/g,'').slice(0,9);
      var tx=String(obs||'').trim().slice(0,4000);
      var gt=Math.max(0,Number(gastosTotal)||0), gd=gt?String(gastosDescricao||'').trim().slice(0,1000):'';
      var k=_espKey(p), o=espelhoLer(p);
      if(n) o.km=String(parseInt(n,10)); else delete o.km;
      if(tx) o.obs=tx; else delete o.obs;
      o._em=Date.now(); localStorage.setItem(k,JSON.stringify(o));
      var dk='mev_aval:'+p, d={}; try{ d=JSON.parse(localStorage.getItem(dk)||'{}')||{}; }catch(_){ d={}; }
      d.avKm=n?Number(n).toLocaleString('pt-BR'):''; d.avObs=tx;
      d.avGastosJ=JSON.stringify(_avGastoCompartAtualizar(avGastosNormalizar(d.avGastosJ),gt,gd));
      localStorage.setItem(dk,JSON.stringify(d));
      var atual=String((veiculoAtual&&veiculoAtual.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      /* No MEV Consultas, veiculoAtual também aponta para esta placa, mas os
         campos da avaliação não estão montados. Só autosalva a tela quando o
         formulário realmente existe; o rascunho gravado acima permanece
         intacto para a avaliação aberta depois. */
      if(atual===p&&($('avKm')||$('avObs')||$('avGastosJ'))){
        var ek=$('avKm'), eo=$('avObs'); if(ek) ek.value=d.avKm; if(eo) eo.value=tx;
        var eg=$('avGastosJ'); if(eg) eg.value=JSON.stringify(_avGastoCompartAtualizar(avGastosLer(),gt,gd));
        avGastosPinta();
        _avObsPlaca=p; _avObsTinha=!!tx;
        try{ avFormSalvar(); }catch(_){} try{ calcAvaliacao(); }catch(_){}
      }
    }catch(_){}
  }
  function avEspelhoAplicar(){
    try{
      var placa=(veiculoAtual&&veiculoAtual.placa)||''; if(!placa) return;
      var o=espelhoLer(placa), mud=false;
      /* O histórico é a ponte entre Consultas e Avaliações. Um detalhe
         informado primeiro na folha de envio preenche a avaliação ao abrir. */
      try{
        var hs=histShareDetalhesLerDados(placa);
        if(!o.km&&hs.km) o.km=String(hs.km); if(!o.obs&&hs.obs) o.obs=String(hs.obs);
        if(hs.gastosTotal>0){
          var eg=$('avGastosJ'), ga=_avGastoCompartAtualizar(avGastosLer(),hs.gastosTotal,hs.gastosDescricao);
          if(eg&&JSON.stringify(avGastosLer())!==JSON.stringify(ga)){ eg.value=JSON.stringify(ga); avGastosPinta(); mud=true; }
        }
      }catch(_){}
      /* soVazio = so' preenche se o campo estiver em branco. Uso isso nas
         OBSERVACOES: o texto da avaliacao ("unico dono, revisoes...") e o do
         estoque ("recebido na troca de Fulano") contam historias diferentes —
         seria ruim um apagar o outro. Ja os NUMEROS sincronizam de verdade. */
      function pon(id,val,soVazio){ var e=$(id); if(!e||val==null||val==='') return; if(soVazio&&String(e.value||'').trim()) return; if(String(e.value||'')===String(val)) return; e.value=val; mud=true; }
      pon('avKm', o.km?_espMilhar(o.km):'');
      pon('avObs', o.obs||'', true);
      pon('avValor', o.compra?_espRsInt(o.compra):'');
      /* O preço de repasse é calculado internamente; o espelho não o substitui. */
      /* v241: o valor avaliado passou a acompanhar a sugestão da loja —
         o espelho não trava mais o campo (só a digitação na própria tela). */
      if(mud){ try{ avFormSalvar(); }catch(_){} try{ calcAvaliacao(); }catch(_){} }
      avEspelhoGravar();   /* semeia o bilhete com o que so' existe nesta tela */
    }catch(_){}
  }

  /* ---- lado ESTOQUE ---- */
  function estEspelhoColeta(){
    return { km:String(estNum('efKm')||''), obs:String((($('efObs')||{}).value||'')).trim(),
             repasse:String(Math.round(estRS('efRepasse'))||''), compra:String(Math.round(estRS('efCompra'))||'') };
  }
  var _efObsPlaca='', _efObsTinha=false;   /* v693: o estoque tinha o MESMO buraco */
  function estEspelhoGravar(){
    try{
      var placa=String((($('efPlaca')||{}).value||'')).trim(); if(!placa) return;
      var c=estEspelhoColeta();
      if(_efObsPlaca===placa && _efObsTinha && !c.obs) espelhoApagaCampo(placa,'obs');
      _efObsPlaca=placa; _efObsTinha=!!c.obs;
      espelhoGravar(placa, c);
    }catch(_){}
  }
  function estEspelhoAplicar(){
    try{
      var placa=String((($('efPlaca')||{}).value||'')).trim(); if(!placa) return;
      var o=espelhoLer(placa), mud=false;
      function pon(id,val,soVazio){ var e=$(id); if(!e||val==null||val==='') return; if(soVazio&&String(e.value||'').trim()) return; if(String(e.value||'')===String(val)) return; e.value=val; mud=true; }
      pon('efKm', o.km?_espMilhar(o.km):'');
      pon('efObs', o.obs||'', true);
      pon('efRepasse', o.repasse?_rsF(Number(o.repasse)):'');
      pon('efCompra', o.compra?_rsF(Number(o.compra)):'');
      if(mud){ try{ estMargemCalc(); }catch(_){} try{ estAgendaSalvar(); }catch(_){} }
      estEspelhoGravar();
    }catch(_){}
  }
  var _avCloudTimer=null;
  AV_FIELDS=AV_FIELDS.concat(['avGastosJ']);
  function avGastosNormalizar(valor){
    var a=valor;
    if(typeof a==='string'){ try{ a=JSON.parse(a||'[]'); }catch(_){ a=[]; } }
    return Array.isArray(a)?a.filter(function(g){return g&&typeof g==='object';}).map(function(g){
      var n=Number(g.valor), item={valor:isFinite(n)?Math.max(0,Math.round(n*100)/100):0,descricao:String(g.descricao||'').slice(0,1000)};
      if(g.origem==='compartilhamento') item.origem='compartilhamento';
      return item;
    }):[];
  }
  function avGastosLer(){ return avGastosNormalizar((($('avGastosJ')||{}).value)||'[]'); }
  function _avGastoCompartLer(a){
    a=avGastosNormalizar(a); for(var i=0;i<a.length;i++) if(a[i].origem==='compartilhamento') return a[i]; return null;
  }
  function _avGastoCompartAtualizar(a,valor,descricao){
    valor=Math.max(0,Math.round((Number(valor)||0)*100)/100); descricao=String(descricao||'').slice(0,1000);
    if(!(valor>0)) return [];
    return [{valor:valor,descricao:descricao,origem:'compartilhamento'}];
  }
  function avGastosTotal(){return avGastosLer().reduce(function(t,g){return t+Math.round(g.valor*100);},0)/100;}
  function avGastosDescricao(a){
    var vistos={};return avGastosNormalizar(a).map(function(g){return g.descricao.trim();}).filter(function(d){if(!d||vistos[d])return false;vistos[d]=true;return true;}).join('\n').slice(0,1000);
  }
  function avGastosResumo(){avGastosPinta();}
  function avGastosGravar(a){var e=$('avGastosJ');if(e)e.value=JSON.stringify(a);avGastosResumo();avFormSalvar();calcAvaliacao();}
  function avGastosPinta(){
    var valor=$('avGastosValor'),descricao=$('avGastosDescricao'),box=$('avGastosDescricaoBox');if(!valor||!descricao||!box)return;
    var a=avGastosLer(),total=avGastosTotal(),texto=avGastosDescricao(a);
    if(document.activeElement!==valor) valor.value=total>0?String(total):'';
    if(document.activeElement!==descricao) descricao.value=texto;
    box.hidden=!(total>0);
  }
  function avGastosCampoGravar(){
    var valor=$('avGastosValor'),descricao=$('avGastosDescricao'),box=$('avGastosDescricaoBox');if(!valor||!descricao||!box)return;
    if(valor.validity.badInput||valor.valueAsNumber<0)return;
    var total=isFinite(valor.valueAsNumber)?Math.round(valor.valueAsNumber*100)/100:0;
    box.hidden=!(total>0);
    var a=total>0?[{valor:total,descricao:String(descricao.value||'').slice(0,1000)}]:[];
    var h=$('avGastosJ');if(h)h.value=JSON.stringify(a);
    avFormSalvar();calcAvaliacao();
  }
  function avGastosWire(){
    var valor=$('avGastosValor'),descricao=$('avGastosDescricao');
    if(valor){valor.addEventListener('input',avGastosCampoGravar);valor.addEventListener('change',avGastosCampoGravar);}
    if(descricao){descricao.addEventListener('input',avGastosCampoGravar);descricao.addEventListener('change',avGastosCampoGravar);}
  }
  function avGastosImportar(o){
    var h=$('avGastosJ');if(!h||h.value||!o)return;
    var a=[];
    (_avCusto||[]).forEach(function(id){
      if(o[id]==null)return;
      var valor=_custo(id);if(!(valor>0))return;
      var ed={};try{ed=JSON.parse(o.avCustoEdJ||'{}')||{};}catch(_){}
      if(ed[id]!=null)valor=Math.max(0,Number(ed[id])||0);
      a.push({valor:valor,descricao:(AV_LABELS[id]||id)+(o[id+'Desc']?' - '+o[id+'Desc']:'')});
    });
    h.value=JSON.stringify(a);
  }
  function avFormObj(){ var o={}; AV_FIELDS.forEach(function(id){ var e=$(id); if(e) o[id]=e.value; });
    if($('avGastosJ')&&veiculoAtual){try{o.avMotorEntrada=avMotorEntrada();}catch(_){}}
    return o; }
  function avFormSalvar(){
    try{ localStorage.setItem(avFormKey(), JSON.stringify(avFormObj())); }catch(_){}
    try{ avEspelhoGravar(); }catch(_){}   /* v184 — leva pro estoque */
    /* salva o rascunho na NUVEM (com atraso, pra não pesar) — sobrevive a reinstalar */
    try{ clearTimeout(_avCloudTimer); _avCloudTimer=setTimeout(avFormSalvarNuvem, 1500); }catch(_){}
  }
  function avFormSalvarNuvem(){ try{ var placa=(veiculoAtual&&veiculoAtual.placa)||''; if(!placa) return; docHistCloudSave('aval_rascunho', placa, 'rascunho', avFormObj(), Date.now()); }catch(_){} }
  /* ===== v266 — RASCUNHO ANTIGO NÃO PODE DEIXAR O CAMPO EM BRANCO =====
     Os campos que diziam "— a conferir —" passaram a dizer "Verificar". Só que
     os rascunhos já salvos no aparelho guardaram o texto ANTIGO — e, num
     <select>, atribuir um valor que não existe entre as opções não dá erro:
     ele fica com selectedIndex -1 e aparece VAZIO na tela. A pessoa abriria uma
     avaliação antiga e veria campos em branco, achando que perdeu o que
     preencheu.
     Aqui, se o valor guardado não casar com nenhuma opção, o campo volta pra
     primeira (que é justamente o "Verificar"). Vale pra esta troca e pra
     qualquer outra que a gente faça no futuro. */
  /* v945: avaliações antigas tinham uma observação por grupo. A interface
     passa a ter uma só, mas o texto já salvo não pode desaparecer. Quando a
     observação geral estiver vazia, reunimos as antigas nela uma única vez. */
  function _avObsGruposMigra(o){
    if(!o || String(o.avObs||'').trim()) return o;
    var nomes={ident:'Identificação e documentos',ext:'Avaliação externa',fre:'Estrutura dianteira',
      tras:'Porta-malas e traseira',mec:'Mecânica',cam:'Câmbio e embreagem',
      sus:'Suspensão, direção e freios',ele:'Elétrica e interior',rod:'Teste de rodagem',moto:'Itens da moto'};
    var linhas=[];
    Object.keys(nomes).forEach(function(k){
      var v=String(o['avgObs'+k]||'').trim(); if(v) linhas.push(nomes[k]+': '+v);
    });
    if(linhas.length) o.avObs=linhas.join('\n');
    return o;
  }
  function _avAplica(o){
    o=_avObsGruposMigra(o);
    var mudou=false; if(!o) return false;
    AV_FIELDS.forEach(function(id){
      if(o[id]==null||o[id]==='') return;
      var e=$(id); if(!(e&&(e.value==null||e.value===''))) return;
      e.value=o[id]; mudou=true;
      if(e.tagName==='SELECT' && e.selectedIndex<0 && e.options.length) e.selectedIndex=0;
    });
    if(mudou){
      avGastosImportar(o);avGastosPinta();
      try{ avOpcPinta(); }catch(_){}           /* v1065 */
      try{ avVistoriaRestaurou(); }catch(_){}   /* v924 */
      try{ avMktPrecoPinta(false); }catch(_){}  /* v937: restauração assíncrona */
      try{ avJevPinta(); }catch(_){}            /* v1450 */
    }
    return mudou;
  }
  function avFormRestaurar(){
    var did=false;
    try{ var o=_avObsGruposMigra(JSON.parse(localStorage.getItem(avFormKey())||'null')); if(o){ AV_FIELDS.forEach(function(id){ if(o[id]!=null&&o[id]!==''){ var e=$(id); if(e) e.value=o[id]; } }); avGastosImportar(o);did=true; } }catch(_){}
    /* também busca na nuvem (só preenche o que ainda está vazio) — restaura após reinstalar */
    try{
      var placa=(veiculoAtual&&veiculoAtual.placa)||'';
      if(placa){ docHistCloudLoadOne('aval_rascunho', placa, function(o2){ if(_avAplica(o2)){ try{ calcAvaliacao(); }catch(_){} try{ localStorage.setItem(avFormKey(), JSON.stringify(avFormObj())); }catch(_){} } }); }
    }catch(_){}
    /* v924: repor VALOR não é repor TELA. Os checkboxes das peças de
       repintura, a caixa que só aparece no "Sim" e os resumos dos grupos são
       desenhados a partir dos valores — quem acabou de repô-los precisa
       avisar. Sem isto, reabrir uma avaliação com 3 peças marcadas mostrava
       a lista fechada e o resumo dizendo "Não iniciado". */
    try{ avVistoriaRestaurou(); }catch(_){}
    avGastosPinta();
    try{ avOpcPinta(); }catch(_){}   /* v1065 */
    try{ avJevPinta(); }catch(_){}   /* v1450 — segunda opinião salva por placa */
    return did;
  }
  function docHistCloudLoadOne(tipo, chave, cb){
    try{ if(!(window.supa && meuId)){ cb&&cb(null); return; }
      supa.from('doc_consulta').select('resultado').eq('user_id',meuId).eq('tipo',tipo).eq('chave',String(chave)).limit(1).then(function(r){ var row=r&&r.data&&r.data[0]; cb&&cb(row?row.resultado:null); },function(){ cb&&cb(null); });
    }catch(_){ cb&&cb(null); }
  }
  /* campo travado (só leitura) */
  function aro(lbl,val){ return '<div class="avt-col"><div class="avt-lbl">'+lbl+'</div><input class="avt-in" value="'+(val==null?'':val)+'" readonly title="Valor oficial da FIPE — não editável"></div>'; }
  /* ===== Detecção de MOTO e faixas de custo por porte ===== */
  function ehMoto(v){ return MEV_AVALIACAO_MOTOR.ehMoto(v); }
  function motoPorte(v){ return MEV_AVALIACAO_MOTOR.motoPorte(v); }
  function motoTiers(porte){ return MEV_AVALIACAO_MOTOR.motoTiers(porte); }
  /* v265: chamava-se _rs e colidia com a _rs do 14-estoque.js. Como tudo
     vira um bloco só, valia a do 14 (que devolve TEXTO VAZIO quando o valor
     é zero) — então um custo zerado na tabela de motos viraria "Trocar ()".
     Com nome próprio, cada uma faz o que promete. */
  function _rsAv(n){ return 'R$ '+Number(n||0).toLocaleString('pt-BR'); }
  function motoItensHtml(porte){
    var T=motoTiers(porte);
    return '<div class="avt-g2">'+aselCusto('avPneuD','Pneu dianteiro',[['Novo','novos'],['Bom',0],['Trocar ('+_rsAv(T.pneuD)+')',T.pneuD],['Outro (digite o valor)','outro']],0)+aselCusto('avPneuT','Pneu traseiro',[['Novo','novos'],['Bom',0],['Trocar ('+_rsAv(T.pneuT)+')',T.pneuT],['Outro (digite o valor)','outro']],0)+'</div>'+
      '<div class="avt-g2">'+aselCusto('avRelacao','Kit relação (corrente/coroa/pinhão)',[['Ok',0],['Trocar ('+_rsAv(T.rel)+')',T.rel],['Outro (digite o valor)','outro']],0)+aselCusto('avFreios','Freios (pastilhas)',[['Ok',0],['Trocar ('+_rsAv(T.fre)+')',T.fre],['Outro (digite o valor)','outro']],0)+'</div>'+
      '<div class="avt-g2">'+aselCusto('avCaren','Carenagem',[['Sem danos',0],['Reparo ('+_rsAv(T.car)+')',T.car],['Outro (digite o valor)','outro']],0)+aselServ('avMec','Mecânica / motor','Sem custo')+'</div>'+
      '<div class="avt-g2">'+aselServ('avEle','Elétrica','Sem custo')+aselCusto('avRev','Revisão',[['Sem custo',0],['Básica ('+_rsAv(T.rev)+')',T.rev],['Completa ('+_rsAv(T.rev+300)+')',T.rev+300],['Outro (digite o valor)','outro']],T.rev)+'</div>'+
      '<div class="avt-g2">'+aselCusto('avFerr','Ferrugens (guidão, raios, escapamento…)',[['Sem ferrugem',0],['Pontos leves (R$ 200)',200],['Média (R$ 500)',500],['Forte (R$ 1.000)',1000],['Outro (digite o valor)','outro']],0)+'</div>';
  }
  /* v621/v623: o ícone do botão de PDF da avaliação. Mora aqui em cima
     porque o botão agora é montado lá no bloco da Cotação repasse. */
  var _icoPdf='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>';
  var AV_LABELS={ avPneus:'Pneus', avLat:'Lataria', avMec:'Mecânica', avEle:'Elétrica', avRev:'Revisão', avCambio:'Câmbio', avSusp:'Suspensão', avEmbr:'Embreagem', avParab:'Para-brisa', avPneuD:'Pneu dianteiro', avPneuT:'Pneu traseiro', avRelacao:'Kit relação', avFreios:'Freios', avCaren:'Carenagem', avFerr:'Ferrugens', avEstof:'Estofados', avPainel:'Painel' };
  /* v247: Estofados e Painel entraram na vistoria do carro (pedido) — mesma
     lógica de "Serviços" com modal (aselServ). */
  var AV_CUSTO_CARRO=['avPneus','avLat','avMec','avEle','avCambio','avSusp','avEmbr','avParab','avEstof','avPainel','avRev'];
  var AV_CUSTO_MOTO=['avPneuD','avPneuT','avRelacao','avFreios','avCaren','avMec','avEle','avFerr','avRev'];
  /* Todo item de custo pode registrar serviço e valor na mesma ficha curta. */
  var AV_SERV_MODAL={};
  AV_CUSTO_CARRO.concat(AV_CUSTO_MOTO).forEach(function(id){ AV_SERV_MODAL[id]=1; });

  /* ===== v182 — a avaliacao virou uma tela de ETAPAS, no mesmo formato de
     "Minha loja": um menu de etapas (.vpx-steps) do lado (no celular ele vira
     uma barrinha que rola) e um painel por etapa (.vpx-panel). Nada de conta
     mudou: sao os MESMOS campos, com os MESMOS ids — so que agora divididos em
     7 assuntos, pra caber na tela e pra voce saber sempre onde esta. */
  var _AV_ICO={
    /* v896: o mesmo megafone da aba Marketing do estoque (_EF_ICO.marketing) —
       ícone repetido de propósito: é a MESMA coisa, nas duas telas. */
    marketing:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>',
    histfipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>',
    dados:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h5"/></svg>',
    itens:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 13l2 2 4-4"/></svg>',
    valores:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1v22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    custos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6h8"/><path d="M8 11h.01"/><path d="M12 11h.01"/><path d="M16 11h.01"/><path d="M8 15h.01"/><path d="M12 15h.01"/><path d="M16 15v4"/></svg>',
    fotos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    cotloja:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0"/></svg>',
    cotrep:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    fichatec:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z"/></svg>',
    mercado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 15l4-6 4 3 5-8"/></svg>'
  };
  /* ⛳ v557 (pedido do Angelo): *"na página de avaliação, cotação loja, não
     traga o valor avaliado enquanto não for digitado"*.
     `true` volta o comportamento antigo (o campo nascia preenchido com a
     sugestão da loja e se reescrevia a cada recálculo — v241). */
  var AV_VALOR_SUGERE = false;

  /* v891 — 'histfipe' SAIU daqui: o Histórico da FIPE foi pra tela da consulta
     da placa, logo abaixo do "Baixar o PDF da FIPE" (pedido do Angelo, 04/09).
     A aba era a primeira desde a v240. O componente é o mesmo (`histFipeHtml`
     do 02-icones-e-telas.js) — mudou de casa, não de código. */
  /* v896: 'marketing' entrou depois de 'fotos' — tirou a foto, escreve a
     legenda. O painel dela mora no 07b-avaliacao-marketing.js. */
  /* 🔴 v924 — A ABA "AVALIAÇÃO ITENS" SAIU DA BARRA.
     Ela virou os grupos recolhidos DENTRO de "Dados veículo" (ver o
     07c-vistoria.js). Era:
       ['dados','Dados veículo'],['itens','Avaliação itens'],['fichatec',…]
     ⚠️ Aba e painel andam juntos — é a regra que a v891 deixou escrita aqui
     mesmo: painel sem passo correspondente fica órfão, ninguém o abre e ele
     some do teclado e do leitor de tela sem dizer por quê. Por isso o
     `_avP('itens',…)` saiu na mesma linha em que a aba saiu daqui.
     🔑 Link antigo apontando pra 'itens' NÃO quebra: o avTabIr traduz
     pra 'dados' e ainda abre o grupo certo. */
  /* 🔴 v1063 (pedido do Angelo, 17/09): "remove a aba ficha tecnica" — e,
     perguntado qual, ele respondeu "das avaliacoes". Então sai daqui, e NÃO
     da tela de Ficha Técnica do app (03-ficha-tecnica.js), que continua
     inteira, nem do estoque, que a v1060 acabou de preencher com o
     catálogo oficial da montadora.
     ⚠️ ABA E PAINEL ANDAM JUNTOS — a regra que a v891 deixou escrita logo
        acima. O `_avP('fichatec',…)` saiu na mesma leva; painel sem passo
        fica órfão, ninguém o abre, e ele some do teclado e do leitor de tela
        sem dizer por quê.
     ⛳ E O DADO NÃO VAI JUNTO: o `fichaWrapPinta` é só desenho, e o
        `#fichaWrap` continua existindo na tela própria da Ficha Técnica.
        Sai a porta, fica o quarto. */
  /* v1448 — Cotação repasse deixou de ser uma etapa paralela. Preço, página,
     PDF, publicação no portal e ofertas agora encerram a própria Avaliação. */
  var _AV_STEPS=[['dados','Dados veículo'],['valores','Mercado'],['fotos','Fotos'],['cotloja','Avaliação']];
  var _avTab='dados';
  var _AV_SETA_ANT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5"/><path d="m11 18-6-6 6-6"/></svg>';
  var _AV_SETA_PRO='<svg class="av-step-next-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  var _AV_CHECK='<svg class="av-step-next-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
  function _avP(k,html){ return '<div class="vpx-panel" data-panel="'+k+'">'+html+'</div>'; }
  /* v242: as abas ja tem nome no chip — o cabecalho repetido saiu de TODAS */
  function _avTit(t,sub){ return ''; }
  /* ===== v246: CHECKLIST VISUAL DOS CAMPOS (pedido) =====
     Campo ainda NÃO respondido → CINZA claro (fundo cinza, texto apagado):
     é tudo que está "— a conferir —", "— avaliar —", "Verificar" ou vazio.
     Campo INFORMADO → branco com BORDA AZUL clara. O azul forte continua
     só no campo em foco. Assim dá pra bater o olho e ver o que falta. */
  function avPendMarca(){
    var root=$('avBody'); if(!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('.avt-in'),function(el){
      if(el.readOnly||el.disabled||el.type==='hidden') return;
      var pend;
      if(el.tagName==='SELECT'){
        var t=(((el.options||[])[el.selectedIndex])||{}).text||'';
        /* v924: os campos da vistoria dizem "Não verificado" / "Não informado"
           / "Não realizado" no lugar de "Verificar". Sem esta linha eles
           nasceriam pintados de RESPONDIDO — e a tela toda diria que a
           vistoria está feita antes de alguém olhar o carro. */
        pend=!String(el.value||'').trim() || /^\s*—/.test(t)
          || /^verificar$/i.test(String(t||'').trim())
          || /^n(ã|a)o (verificado|informado|realizado)$/i.test(String(t||'').trim());
      } else {
        pend=!String(el.value||'').trim();
      }
      el.classList.toggle('avt-pend', !!pend);
      el.classList.toggle('avt-ok', !pend);
    });
  }
  document.addEventListener('change',function(e){ var t=e.target; if(t&&t.classList&&t.classList.contains('avt-in')&&$('avBody')) avPendMarca(); },true);
  document.addEventListener('input',function(e){ var t=e.target; if(t&&t.classList&&t.classList.contains('avt-in')&&$('avBody')) avPendMarca(); },true);
  /* ===== v253: clicar num campo de % ou VALOR dos custos já SELECIONA o
     conteúdo (pedido) — é só digitar por cima, sem apagar antes. */
  document.addEventListener('focusin',function(e){
    var t=e.target;
    if(t&&t.tagName==='INPUT'&&t.closest&&t.closest('#avCustos')){
      setTimeout(function(){ try{ t.select(); }catch(_){} },0);
    }
  },true);
  /* ===== v253: OBSERVAÇÕES (e qualquer textarea da avaliação) crescem
     conforme o texto — nada de conteúdo cortado (pedido). */
  function avTaGrow(t){ if(!t||t.tagName!=='TEXTAREA') return; try{ t.style.height='auto'; t.style.height=Math.min(600, Math.max(84, t.scrollHeight+2))+'px'; }catch(_){} }
  document.addEventListener('input',function(e){ var t=e.target; if(t&&t.tagName==='TEXTAREA'&&t.classList&&t.classList.contains('avt-in')) avTaGrow(t); },true);
  var _avFooterTimer=null;
  function avFooterSync(){var bar=$('avEtapaNav'),body=$('avBody'),active=!!(bar&&body&&body.getClientRects().length&&getComputedStyle(body).visibility!=='hidden');document.body.classList.toggle('av-step-footer-active',active);}
  function avFooterSchedule(){if(_avFooterTimer)return;_avFooterTimer=setTimeout(function(){_avFooterTimer=null;avFooterSync();},60);}
  document.addEventListener('DOMContentLoaded',function(){avFooterSync();new MutationObserver(avFooterSchedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','class']});});
  function avEtapaIndice(){
    for(var i=0;i<_AV_STEPS.length;i++) if(_AV_STEPS[i][0]===_avTab) return i;
    return 0;
  }
  function avEtapaNavPinta(){
    var i=avEtapaIndice(), total=_AV_STEPS.length, atual=_AV_STEPS[i], anterior=_AV_STEPS[i-1], proxima=_AV_STEPS[i+1];
    var titulo=$('avEtapaTitulo'),contador=$('avEtapaContador'),trilha=$('avEtapaProgresso'),fill=$('avEtapaProgressoFill');
    if(titulo)titulo.textContent=atual[1];
    if(contador)contador.textContent=(i+1)+' de '+total;
    var footerCount=$('avEtapaRodapeContador');if(footerCount)footerCount.textContent='Etapa '+(i+1)+' de '+total;
    if(trilha){trilha.setAttribute('aria-valuenow',String(i+1));trilha.setAttribute('aria-valuetext','Etapa '+(i+1)+' de '+total+': '+atual[1]);}
    if(fill)fill.style.width=((i+1)/total*100)+'%';
    Array.prototype.forEach.call(document.querySelectorAll('#avTabs .vpx-st'),function(b){
      var on=b.getAttribute('data-step')===_avTab;
      b.classList.toggle('on',on);b.setAttribute('aria-pressed',String(on));
      if(on)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');
    });
    var ant=$('avEtapaAnterior'),pro=$('avEtapaProximo'),proTxt=$('avEtapaProximoTexto');
    if(ant){ant.disabled=!anterior;ant.setAttribute('aria-label',anterior?'Voltar para '+anterior[1]:'Não há etapa anterior');}
    if(pro){
      var final=!proxima;pro.setAttribute('data-final',String(final));
      pro.setAttribute('aria-label',final?'Salvar e concluir avaliação':'Avançar para '+proxima[1]);
      if(proTxt)proTxt.textContent=final?'Salvar e concluir':'Próximo: '+proxima[1];
    }
  }
  function avTabAplica(){
    Array.prototype.forEach.call(document.querySelectorAll('#avBody .vpx-panel'),function(pn){ pn.classList.toggle('on', pn.getAttribute('data-panel')===_avTab); });
    avEtapaNavPinta();
    try{ avPendMarca(); }catch(_){}
    try{ if(window._salvarFabSync) window._salvarFabSync(); }catch(_){}
    /* v253: ajusta a altura das observações da aba que abriu */
    try{ Array.prototype.forEach.call(document.querySelectorAll('#avBody .vpx-panel.on textarea.avt-in'), avTaGrow); }catch(_){}
    /* v253: rótulos "Serviços · R$ X" refletem o rascunho restaurado */
    try{ Object.keys(AV_SERV_MODAL).forEach(function(k){ avServicoRotulo(k); }); }catch(_){}
    /* v937: Fotos e Marketing do Varejo seguem a aba ativa e recebem na hora
       qualquer imagem salva pela IA. */
    try{ if(typeof avmPinta==='function') avmPinta(); }catch(_){}
  }
  function avTabsWire(){
    Array.prototype.forEach.call(document.querySelectorAll('#avTabs .vpx-st'),function(b){
      b.onclick=function(){ avTabIr(b.getAttribute('data-step')); };
    });
    var ant=$('avEtapaAnterior'),pro=$('avEtapaProximo');
    if(ant)ant.onclick=function(){var i=avEtapaIndice();if(i>0)avTabIr(_AV_STEPS[i-1][0]);};
    if(pro)pro.onclick=function(){var i=avEtapaIndice();if(i<_AV_STEPS.length-1)avTabIr(_AV_STEPS[i+1][0]);else{var salvar=$('avBtnFechar');if(salvar)salvar.click();}};
    avTabAplica();
  }
  /* ==========================================================================
     🔴 v924 — A PORTA ÚNICA PRA IR A UMA ABA (e o link antigo que não quebra)
     --------------------------------------------------------------------------
     "Links antigos para itens devem abrir Dados do veiculo e expandir o grupo
     correspondente."
     Quem pedir 'itens' cai em 'dados'. Quem pedir 'itens:mec' cai em 'dados'
     COM o grupo Mecânica aberto — que é o que um atalho antigo quer dizer.
     ⚠️ Traduzir aqui, e não em cada chamador, é o que faz o conserto valer pro
     deslize, pro deep link e pro botão interno de uma vez só. */
  function avMercadoCustosAbrir(aberto){
    var painel=$('avMercadoCustos'),botao=$('avMercadoCustosBtn');
    if(!painel||!botao)return;
    painel.hidden=!aberto;
    botao.setAttribute('aria-expanded',String(!!aberto));
  }
  var _avCustosFolha=null;
  function avCustosFolhaFechar(devolverFoco){
    var f=_avCustosFolha;if(!f)return;_avCustosFolha=null;
    try{document.removeEventListener('keydown',f.teclado,true);}catch(_){}
    try{if(f.marca&&f.marca.parentNode)f.marca.parentNode.insertBefore(f.editor,f.marca.nextSibling);}catch(_){}
    try{if(f.marca&&f.marca.parentNode)f.marca.parentNode.removeChild(f.marca);}catch(_){}
    try{f.raiz.classList.remove('on');setTimeout(function(){try{f.raiz.remove();}catch(_){}},180);}catch(_){}
    document.body.classList.remove('av-custos-folha-on');
    if(devolverFoco!==false){try{if(f.ancora&&f.ancora.isConnected)f.ancora.focus();}catch(_){}}
  }
  function avCustosFolhaAbrir(ancora){
    avCustosFolhaFechar(false);
    var editor=$('avCustos');if(!editor)return;
    var marca=document.createComment('avCustos-volta');editor.parentNode.insertBefore(marca,editor);
    var raiz=document.createElement('div');raiz.className='av-custos-folha';
    raiz.innerHTML='<button type="button" class="av-custos-folha-bg" aria-label="Fechar custos"></button>'+
      '<section class="av-custos-dialog" role="dialog" aria-modal="true" aria-labelledby="avCustosFolhaTit" tabindex="-1">'+
        '<div class="av-custos-folha-head"><div><h2 id="avCustosFolhaTit">Custos da avaliação</h2><p>Edite os percentuais e valores usados no cálculo.</p></div>'+
        '<button type="button" class="av-custos-folha-x" aria-label="Fechar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'+
        '<div class="av-custos-folha-body"></div></section>';
    raiz.querySelector('.av-custos-folha-body').appendChild(editor);editor.classList.add('open');
    document.body.appendChild(raiz);document.body.classList.add('av-custos-folha-on');
    var dialog=raiz.querySelector('.av-custos-dialog'),x=raiz.querySelector('.av-custos-folha-x');
    var teclado=function(e){
      if(e.key==='Escape'){e.preventDefault();avCustosFolhaFechar(true);return;}
      if(e.key!=='Tab')return;var focos=dialog.querySelectorAll('button:not([disabled]),input:not([disabled])');if(!focos.length)return;
      var a=focos[0],z=focos[focos.length-1];if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}
    };
    document.addEventListener('keydown',teclado,true);
    raiz.querySelector('.av-custos-folha-bg').onclick=function(){avCustosFolhaFechar(true);};
    x.onclick=function(){avCustosFolhaFechar(true);};
    _avCustosFolha={raiz:raiz,editor:editor,marca:marca,ancora:ancora,teclado:teclado};
    requestAnimationFrame(function(){raiz.classList.add('on');try{x.focus();}catch(_){}});
  }
  /* 🔑 v1063: `fichatec` entra aqui pelo mesmo motivo do `itens` (v891):
     link, atalho ou teste antigo apontando pra aba que saiu NÃO pode dar em
     nada. Ele cai em 'dados', que é onde a avaliação começa. */
  var _AV_TAB_ALIAS={ itens:'dados', custos:'valores', fichatec:'dados', cotrep:'cotloja' };
  function avTabIr(passo){
    var p=String(passo||''), grupo='', abrirCustos=p==='custos';
    var i=p.indexOf(':'); if(i>0){ grupo=p.slice(i+1); p=p.slice(0,i); }
    if(p==='itens' && !grupo) grupo='ext';   /* a vistoria começa pela pintura */
    p=_AV_TAB_ALIAS[p]||p;
    var existe=_AV_STEPS.some(function(t){ return t[0]===p; });
    if(!existe) return false;
    _avTab=p; avTabAplica();
    if(abrirCustos)avMercadoCustosAbrir(true);
    /* v1063: o `if(p==='fichatec')` saiu — o alias acima já traduz antes,
       então a linha nunca mais rodaria. Linha morta é armadilha pro próximo. */
    if(grupo){ try{ avVistoriaAbrir(grupo); }catch(_){} }
    try{ window.scrollTo(0,0); }catch(_){}
    return true;
  }
  /* ============ v240: MUDAR DE ABA DESLIZANDO (esquerda/direita) ============
     Vale pra TODAS as telas de etapas (avaliação, venda, estoque, loja...):
     o deslize acha a aba acesa na barra e "clica" na vizinha — reaproveitando
     o onclick que cada tela já tem, sem mudar nenhuma delas.
     Cuidados pra não brigar com o resto:
     - só conta se o toque COMEÇOU dentro do corpo de um stepper (.vpx-body);
     - precisa ser bem mais horizontal que vertical (rolagem da página segue livre);
     - ignora toque que nasce em campo de digitação ou em algo que rola de lado. */
  (function(){
    /* v1219 — páginas e abas mudam somente por ação explícita nos botões.
       Este portão desliga o gesto global sem interferir nos arrastes próprios
       de fotos, recortes, sliders e enquadramento de capas. */
    var trocarPaginaPorArraste=false;
    if(!trocarPaginaPorArraste) return;
    var x0=0, y0=0, corpo=null, valendo=false;
    function rolaDeLado(el){
      for(; el && el!==document.body; el=el.parentElement){
        try{
          if(el.scrollWidth>el.clientWidth+4){
            var ov=getComputedStyle(el).overflowX;
            if(ov==='auto'||ov==='scroll') return true;
          }
        }catch(_){}
      }
      return false;
    }
    /* ===== v245: PÁGINAS LADO A LADO — o conteúdo SEGUE O DEDO (pedido) =====
       Em vez de trocar a aba "seca" no fim do gesto, a página atual desliza
       junto com o dedo e a vizinha entra do lado, como um carrossel. A barra
       de abas rola PROPORCIONAL ao arrasto — aba e página 100% sincronizadas.
       Soltou passando de ~1/4 da tela: completa a troca; senão volta. */
    var AR=null;   /* estado do arrasto visual */
    function _arLimpaViz(a){
      if(!a||!a.viz) return;
      a.viz.style.display=''; a.viz.style.position=''; a.viz.style.top='';
      a.viz.style.left=''; a.viz.style.width=''; a.viz.style.transform=''; a.viz.style.transition='';
    }
    function _arFim(cancelou){
      var a=AR; AR=null; if(!a) return;
      var commit=!cancelou && a.viz && a.aba && Math.abs(a.dx||0)>Math.max(64, a.w*0.24);
      var alvoX=commit?(a.dir>0?-a.w:a.w):0;
      a.atual.style.transition='transform .18s ease-out';
      if(a.viz) a.viz.style.transition='transform .18s ease-out';
      a.atual.style.transform='translateX('+alvoX+'px)';
      if(a.viz) a.viz.style.transform='translateX('+(alvoX+(a.dir>0?a.w:-a.w))+'px)';
      window._tabCentraTs=Date.now();
      setTimeout(function(){
        if(commit){ try{ a.aba.click(); }catch(_){} }   /* troca a aba ANTES de limpar (sem piscar) */
        a.atual.style.transition=''; a.atual.style.transform='';
        _arLimpaViz(a);
        a.body.style.height=''; a.body.style.overflow=''; if(a.posMeu) a.body.style.position='';
      },200);
    }
    document.addEventListener('touchstart',function(e){
      valendo=false;
      if(AR){ _arFim(true); }                    /* toque novo no meio da animação: encerra */
      if(!e.touches||e.touches.length!==1) return;
      var t=e.target; if(!t||!t.closest) return;
      /* v241: vale em QUALQUER ponto da tela que tenha um stepper aberto */
      if(t.closest('#mevDrawer,#mevPublicoViewer,.mev-publico,[role="dialog"]')) return;
      corpo=t.closest('.vpx')||document.querySelector('#secoes .vpx'); if(!corpo) return;
      /* v244: o deslize agora vale MESMO começando num campo (pedido) —
         só fica de fora o que realmente usa o arrasto: slider e texto editável. */
      if(t.closest('input[type="range"],[contenteditable]')) return;
      if(rolaDeLado(t)) return;
      x0=e.touches[0].clientX; y0=e.touches[0].clientY; valendo=true;
    },{passive:true});
    document.addEventListener('touchmove',function(e){
      if(!valendo||!corpo) return;
      if(!e.touches||e.touches.length!==1){ if(AR) _arFim(true); valendo=false; return; }
      var dx=e.touches[0].clientX-x0, dy=e.touches[0].clientY-y0;
      if(!AR){
        if(Math.abs(dy)>26 && Math.abs(dy)>Math.abs(dx)){ valendo=false; return; }   /* virou rolagem vertical */
        if(Math.abs(dx)<14 || Math.abs(dx)<Math.abs(dy)*1.6) return;                 /* ainda não é arrasto de lado */
        var vpx=corpo.classList&&corpo.classList.contains('vpx')?corpo:corpo.closest('.vpx'); if(!vpx){ valendo=false; return; }
        var body=vpx.querySelector('.vpx-body'), barra=vpx.querySelector('.vpx-steps');
        var atual=body&&body.querySelector('.vpx-panel.on');
        if(!body||!barra||!atual){ valendo=false; return; }
        AR={ body:body, barra:barra, atual:atual, w:body.clientWidth||1,
             viz:null, aba:null, dir:0, dx:0, s0:barra.scrollLeft, c0:0, c1:0,
             posMeu:false };
        AR.body.style.height=AR.body.offsetHeight+'px';   /* trava a altura (sem pulo) */
        AR.body.style.overflow='hidden';
        if(getComputedStyle(AR.body).position==='static'){ AR.body.style.position='relative'; AR.posMeu=true; }
      }
      e.preventDefault();   /* arrastando de lado: segura a rolagem vertical da página */
      var dir=dx<0?1:-1;    /* 1 = próxima aba (deslizou pra esquerda) */
      if(dir!==AR.dir){
        _arLimpaViz(AR);
        AR.dir=dir; AR.viz=null; AR.aba=null; AR.c1=0;
        var abas=Array.prototype.slice.call(AR.barra.querySelectorAll('.vpx-st'));
        var i=-1; abas.forEach(function(b,k){ if(b.classList.contains('on')) i=k; });
        var alvo=(i>=0)?abas[i+dir]:null;
        if(alvo){
          var k2=alvo.getAttribute('data-step');
          var pn=AR.body.querySelector('.vpx-panel[data-panel="'+k2+'"]');
          if(pn){
            AR.viz=pn; AR.aba=alvo;
            pn.style.display='block'; pn.style.position='absolute';
            pn.style.top=AR.atual.offsetTop+'px'; pn.style.left=AR.atual.offsetLeft+'px';
            pn.style.width=AR.atual.offsetWidth+'px';
            var atu=abas[i];
            AR.c0=atu?(atu.offsetLeft+atu.offsetWidth/2):0;
            AR.c1=alvo.offsetLeft+alvo.offsetWidth/2;
          }
        }
      }
      var d=Math.max(-AR.w, Math.min(AR.w, dx));
      if(!AR.viz) d=d/3;                                   /* primeira/última aba: resistência */
      AR.dx=d;
      AR.atual.style.transform='translateX('+d+'px)';
      if(AR.viz) AR.viz.style.transform='translateX('+(d+(AR.dir>0?AR.w:-AR.w))+'px)';
      /* a BARRA anda junto, proporcional ao quanto a página já andou */
      if(AR.viz && AR.c1){
        var prog=Math.min(1, Math.abs(d)/AR.w);
        window._tabCentraTs=Date.now();                    /* rolagem programática (não dispara o sync) */
        AR.barra.scrollLeft=AR.s0+(AR.c1-AR.c0)*prog;
      }
    },{passive:false});
    document.addEventListener('touchend',function(e){
      if(AR){ valendo=false; _arFim(false); return; }      /* solta: completa ou volta */
      /* reserva: flick rápido sem arrasto visual (eventos de move perdidos) */
      if(!valendo||!corpo) return; valendo=false;
      var t=e.changedTouches&&e.changedTouches[0]; if(!t) return;
      var dx=t.clientX-x0, dy=t.clientY-y0;
      if(Math.abs(dx)<64 || Math.abs(dx)<Math.abs(dy)*2) return;   /* curto ou diagonal: ignora */
      var vpx=corpo.classList&&corpo.classList.contains('vpx')?corpo:corpo.closest('.vpx'); if(!vpx) return;
      var barra=vpx.querySelector('.vpx-steps'); if(!barra) return;
      var abas=Array.prototype.slice.call(barra.querySelectorAll('.vpx-st'));
      var i=-1; abas.forEach(function(b,k){ if(b.classList.contains('on')) i=k; });
      if(i<0) return;
      var prox=abas[i+(dx<0?1:-1)];   /* deslizou pra ESQUERDA = próxima aba */
      if(prox) prox.click();
    },{passive:true});
    document.addEventListener('touchcancel',function(){ valendo=false; if(AR) _arFim(true); },{passive:true});
    /* ============ v247: ROLOU A BARRA → A PÁGINA ACOMPANHA AO VIVO ============
       (pedido: sincronização EXATA) Enquanto a pessoa arrasta a BARRA de abas,
       a página já vai deslizando junto, proporcional — a próxima página entra
       do lado em tempo real, igual ao arrasto na própria página. Quando a
       rolagem para, a aba mais perto do centro vira a aba aberta (ou volta).
       Vale pra TODAS as barras .vpx-steps (avaliação, venda, estoque, loja,
       documentos). O _tabCentra marca window._tabCentraTs pra rolagem
       PROGRAMÁTICA (troca de aba pelo app) não disparar este preview. */
    var _tabRolT=null, BR=null;   /* BR = preview vivo do arrasto da barra */
    function _brInstant(b){
      if(!b) return;
      b.atual.style.transition=''; b.atual.style.transform='';
      if(b.viz){ b.viz.style.transition=''; b.viz.style.display=''; b.viz.style.position=''; b.viz.style.top=''; b.viz.style.left=''; b.viz.style.width=''; b.viz.style.transform=''; }
      b.body.style.height=''; b.body.style.overflow=''; if(b.posMeu) b.body.style.position='';
    }
    function _brFim(abaCommit){
      var b=BR; BR=null; if(!b) return;
      if(abaCommit){ try{ abaCommit.click(); }catch(_){} _brInstant(b); return; }
      b.atual.style.transition='transform .16s ease-out';
      if(b.viz) b.viz.style.transition='transform .16s ease-out';
      b.atual.style.transform='translateX(0px)';
      if(b.viz) b.viz.style.transform='translateX('+(b.dir>0?b.w:-b.w)+'px)';
      setTimeout(function(){ _brInstant(b); },170);
    }
    /* clicou direto numa aba com o preview vivo: limpa NA HORA, antes do onclick */
    document.addEventListener('click',function(e){
      if(BR && e.target && e.target.closest && e.target.closest('.vpx-st')){ var b=BR; BR=null; _brInstant(b); }
    },true);
    document.addEventListener('scroll',function(e){
      var barra=e.target;
      if(!barra||!barra.classList||!barra.classList.contains('vpx-steps')) return;
      if(AR) return;                                        /* página já sendo arrastada pelo dedo */
      if(Date.now()-(window._tabCentraTs||0)<800){ return; } /* rolagem programática */
      var vpx=barra.closest('.vpx'); if(!vpx) return;
      var body=vpx.querySelector('.vpx-body');
      var atual=body&&body.querySelector('.vpx-panel.on');
      if(!body||!atual) return;
      var abas=Array.prototype.slice.call(barra.querySelectorAll('.vpx-st'));
      var ia=-1; abas.forEach(function(b,k){ if(b.classList.contains('on')) ia=k; });
      if(ia<0) return;
      /* v258 — TRAVA DAS PONTAS.
         A regra "vence a aba mais perto do centro da barra" não funciona para a
         PRIMEIRA e a ÚLTIMA aba: elas nunca conseguem ficar no meio, porque a
         barra encosta no fim da rolagem. Estando ali, a vizinha sempre parecia
         mais central e a aba trocava sozinha. Encostado na ponta com a aba da
         ponta aberta, não troca nada. */
      var _maxRol=barra.scrollWidth-barra.clientWidth;
      if((barra.scrollLeft<=2 && ia===0) || (barra.scrollLeft>=_maxRol-2 && ia===abas.length-1)){
        if(BR) _brFim(null);
        return;
      }
      if(BR && BR.atual!==atual){ _brFim(null); }
      if(!BR){
        BR={ body:body, atual:atual, w:body.clientWidth||1, dir:0, viz:null, aba:null, posMeu:false };
        BR.body.style.height=BR.body.offsetHeight+'px'; BR.body.style.overflow='hidden';
        if(getComputedStyle(BR.body).position==='static'){ BR.body.style.position='relative'; BR.posMeu=true; }
      }
      var cAtu=abas[ia].offsetLeft+abas[ia].offsetWidth/2;
      var centro=barra.scrollLeft+barra.clientWidth/2;
      var dir=centro>=cAtu?1:-1;
      var alvo=abas[ia+dir]||null;
      if(dir!==BR.dir || (alvo&&BR.aba!==alvo)){
        if(BR.viz){ BR.viz.style.display=''; BR.viz.style.position=''; BR.viz.style.top=''; BR.viz.style.left=''; BR.viz.style.width=''; BR.viz.style.transform=''; }
        BR.dir=dir; BR.viz=null; BR.aba=null;
        if(alvo){
          var k2=alvo.getAttribute('data-step');
          var pn=BR.body.querySelector('.vpx-panel[data-panel="'+k2+'"]');
          if(pn){
            BR.viz=pn; BR.aba=alvo;
            pn.style.display='block'; pn.style.position='absolute';
            pn.style.top=BR.atual.offsetTop+'px'; pn.style.left=BR.atual.offsetLeft+'px';
            pn.style.width=BR.atual.offsetWidth+'px';
          }
        }
      }
      var prog=0;
      if(BR.aba){
        var cAlvo=BR.aba.offsetLeft+BR.aba.offsetWidth/2;
        var den=cAlvo-cAtu; if(den) prog=Math.min(1, Math.max(0, (centro-cAtu)/den));
      }
      BR.atual.style.transition=''; if(BR.viz) BR.viz.style.transition='';
      BR.atual.style.transform='translateX('+(-dir*prog*BR.w)+'px)';
      if(BR.viz) BR.viz.style.transform='translateX('+((dir>0?BR.w:-BR.w)-dir*prog*BR.w)+'px)';
      clearTimeout(_tabRolT);
      _tabRolT=setTimeout(function(){
        try{
          if(!BR) return;
          /* parou de rolar: a aba mais perto do CENTRO vence (cobre arremesso longo) */
          var br2=barra.getBoundingClientRect(), cx=br2.left+br2.width/2, melhor=null, md=1e9;
          abas.forEach(function(b){
            var r=b.getBoundingClientRect(), d=Math.abs((r.left+r.width/2)-cx);
            if(d<md){ md=d; melhor=b; }
          });
          window._tabCentraTs=Date.now();
          if(melhor && !melhor.classList.contains('on')) _brFim(melhor);
          else _brFim(null);
        }catch(_){ _brFim(null); }
      },150);
    },true);
  })();
  var _AVI_CAM='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';
  var _AVI_SEARCH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>';
  var _AVI_EYE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>';
  var _AVI_WA='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2m0 2a8 8 0 1 1-4.1 14.9l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 0 1 12 4"/></svg>';
  /* v563 — balão de pergunta. SVG, não emoji (padroes/ICONES-SVG.md). */
  var _AVI_PEDIR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.2A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.1-2.4 3.2"/><path d="M12 16.5h.01"/></svg>';

  /* ===========================================================================
   * v563 — PEDIR INFORMAÇÕES AO CLIENTE (o botão ao lado da quilometragem)
   *
   * Pedido do Angelo (18/08, com print): *"ao lado da KM adicione um svg pra
   * solicitar informações ao cliente, vai daí a placa, informação da FIPE, os
   * opcionais pra confirmar se tem (vem da ficha técnica se foi gerado), os
   * itens de verificação"*.
   *
   * O QUE ELE RESOLVE: metade da avaliação depende de coisa que só o dono do
   * carro sabe — km de hoje, chave reserva, manual, revisões, garantia,
   * quantos donos, e quais opcionais o carro realmente tem. Hoje o vendedor
   * digita essa pergunta na mão, toda vez, e sempre esquece um item.
   *
   * 🔴 A MENSAGEM SÓ PERGUNTA O QUE AINDA NÃO SE SABE. Item já respondido na
   * tela não vira pergunta — mandar uma lista com coisa já resolvida é o jeito
   * mais rápido de o cliente parar de ler. Se não sobrar nada pra perguntar, o
   * botão diz isso em vez de abrir uma mensagem vazia.
   *
   * ⚠️ OS OPCIONAIS SÃO OS **NÃO MARCADOS**. O `opcionais` da ficha é "o que
   * este carro TEM"; o `opcionais_todos` é "o que a fábrica oferecia neste
   * ano". A pergunta pro cliente nasce da diferença entre os dois — perguntar
   * do que já está marcado seria perguntar o que já se sabe.
   * ⚠️ SEM FICHA GERADA a seção de opcionais simplesmente não existe. A ficha
   * não é gerada aqui: `fichaVendeDe` lê o que já existe, não gasta token.
   * ⚠️ NADA DE PREÇO, CUSTO OU MARGEM nesta mensagem — ela vai pro CLIENTE
   * (a régua da v265).
   * ⛳ PEDIR_INFO_ON = false some com o botão numa linha.
   * ========================================================================= */
  var PEDIR_INFO_ON = true;
  var PEDIR_OPC_TETO = 10;   /* opcionais por mensagem; o resto vira "+N" */

  /* "ainda não sei" = vazio ou uma das palavras de espera do app */
  function _pdiFalta(id){
    var e=$(id); if(!e) return false;
    var t=String(e.value||'').trim();
    if(!t) return true;
    return /^(verificar|conferir|a definir|— a definir —|não sabe|nao sabe)$/i.test(t);
  }
  var _PDI_PERGUNTAS=[
    ['avKm',       'Qual a quilometragem de hoje?'],
    ['avDonos',    'Quantos donos o carro já teve?'],
    ['avChave',    'Tem a chave reserva?'],
    ['avManual',   'Tem o manual do veículo?'],
    ['avRevC',     'As revisões foram feitas na concessionária? Até qual km?'],
    ['avGarantia', 'Ainda está na garantia de fábrica? Até quando?']
  ];

  function avPedirTexto(){
    var v=(typeof veiculoAtual!=='undefined' && veiculoAtual) ? veiculoAtual : {};
    var placa=String(v.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim();
    var anos=(v.ano&&v.ano_modelo&&String(v.ano)!==String(v.ano_modelo))
      ? (v.ano+'/'+v.ano_modelo) : String(v.ano_modelo||v.ano||'');
    var L=[], perguntou=false;

    L.push('Oi! Estou fechando a avaliação do seu *'+(nome||'veículo')+'*'+(anos?(' '+anos):'')+'.');
    if(placa) L.push('Placa '+placa+'.');
    L.push('');
    L.push('Me confirma estes pontos, por favor:');

    /* 1) o que a tela ainda não sabe */
    var faltas=[];
    _PDI_PERGUNTAS.forEach(function(q){
      if(q[0]==='avKm'){
        var km=_km();
        if(km>0) faltas.push('A quilometragem ainda é '+km.toLocaleString('pt-BR')+' km?');
        else faltas.push(q[1]);
        return;
      }
      if(_pdiFalta(q[0])) faltas.push(q[1]);
    });
    if(faltas.length){
      perguntou=true;
      L.push('');
      faltas.forEach(function(f){ L.push('\u2022 '+f); });
    }

    /* 2) os opcionais que a ficha conhece e ninguém confirmou */
    try{
      var fx=(typeof fichaVendeDe==='function') ? (fichaVendeDe(placa)||{}) : {};
      var todos=(fx.opcionais_todos||[]).map(function(x){ return String(x||'').trim(); }).filter(Boolean);
      var jaTem={}; (fx.opcionais_marcados||fx.opcionais||[]).forEach(function(x){ jaTem[String(x||'').trim().toLowerCase()]=1; });
      var pend=todos.filter(function(x){ return !jaTem[x.toLowerCase()]; });
      if(pend.length){
        perguntou=true;
        L.push('');
        L.push('O carro tem algum destes itens?');
        pend.slice(0,PEDIR_OPC_TETO).forEach(function(x){ L.push('\u2022 '+x); });
        if(pend.length>PEDIR_OPC_TETO) L.push('\u2022 (+'+(pend.length-PEDIR_OPC_TETO)+' item(ns) — me diga se tiver mais algum)');
      }
    }catch(_){}

    if(!perguntou) return '';

    /* 3) a FIPE, como informação — não é pergunta */
    var fipe=Number(v.fipe)||0;
    if(fipe>0){
      L.push('');
      L.push('Referência FIPE hoje: *'+r$(fipe)+'*'+(v.mes_ref?(' ('+v.mes_ref+')'):'')+'.');
    }
    L.push('');
    L.push('Pode responder por aqui mesmo. Obrigado!');
    return L.join('\n');
  }

  function avPedirFechar(){ try{ var b=$('avPedirBg'); if(b) b.remove(); }catch(_){} }

  /* ===========================================================================
   * v564 — A MENSAGEM VIROU UM LINK
   *
   * Pedido do Angelo: *"vamos fazer esse formulário de preenchimento do
   * cliente… o que o cliente lançar vai alimentando a avaliação"*.
   *
   * Na v563 a mensagem era a lista de perguntas em texto. O cliente lia,
   * respondia por escrito, e o vendedor digitava tudo de novo na tela — o
   * trabalho só mudava de mão. Agora vai um LINK: ele responde tocando no
   * celular dele e o que ele marcar cai na avaliação.
   *
   * ⚠️ O TEXTO DE ANTES NÃO MORREU: se por algum motivo o link não puder ser
   * gerado (rede caída, avaliação ainda não salva), a folha cai na mensagem
   * escrita da v563. Uma pergunta em texto é pior que um link, e é infinitas
   * vezes melhor que um botão que não faz nada.
   * ⚠️ A CAIXINHA DAS FOTOS mexe no PACOTE da avaliação, não só no texto — é
   * o `pedir_fotos` do payload que faz a página do cliente mostrar a área de
   * mandar foto. Por isso marcar/desmarcar re-salva o pacote.
   * ========================================================================= */
  function avPedirLinkDe(id){
    var i=String(id||'').trim(); if(!i) return '';
    return location.origin+'/cli/'+i;
  }
  function avPedirTextoLink(url){
    var v=(typeof veiculoAtual!=='undefined' && veiculoAtual) ? veiculoAtual : {};
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim();
    var L=[];
    L.push('Oi! Estou fechando a avaliação do seu *'+(nome||'veículo')+'*.');
    L.push('');
    L.push('Confirma os dados aqui, é rapidinho'+(_avPedirFotos?' (e dá pra mandar as fotos por lá também)':'')+':');
    L.push(url);
    L.push('');
    L.push('É só tocar nas respostas. Obrigado!');
    return L.join('\n');
  }

  async function avPedirAbrir(){
    if(!PEDIR_INFO_ON) return;
    var bt=$('avPedirBt');
    if(bt){ bt.disabled=true; }
    /* a caixinha nasce marcada só quando ainda não há foto nenhuma */
    try{ _avPedirFotos = !((_avFotos||[]).length); }catch(_){ _avPedirFotos=true; }

    /* 1) o link precisa existir — e precisa estar ATUALIZADO, senão o cliente
       responde em cima de um pacote velho (mesma regra do "Avisar lojistas") */
    var url='';
    try{
      if(typeof avLojGerar==='function'){
        if(!_avLojUrl) await avLojGerar(); else if(typeof avLojAtualizar==='function') await avLojAtualizar();
        url=avPedirLinkDe(_avLojId);
      }
    }catch(_){ url=''; }
    if(bt){ bt.disabled=false; }

    var txt = url ? avPedirTextoLink(url) : avPedirTexto();
    if(!txt){ toast('Já está tudo respondido — não sobrou nada pra perguntar.'); return; }

    avPedirFechar();
    var d=document.createElement('div');
    d.id='avPedirBg'; d.className='pdi-bg';
    d.innerHTML='<div class="pdi-box" role="dialog" aria-label="Pedir informações ao cliente">'+
      '<div class="pdi-hd"><b>Pedir ao cliente</b>'+
        '<button type="button" class="pdi-x" id="avPedirX" aria-label="Fechar">&times;</button></div>'+
      '<div class="pdi-sub">'+(url
        ? 'Ele responde tocando, no celular dele — e o que responder entra aqui.'
        : 'Sem link agora: vai como perguntas escritas. Dá pra editar antes de mandar.')+'</div>'+
      /* ==================================================================
         🔴 19/08 — PRA QUEM É ESSA AVALIAÇÃO?
         (PROJETO-o-cliente-com-nome, Parte 1)

         Até aqui a avaliação e a PESSOA viviam em mundos separados: o único
         vínculo era indireto, por placa. Com o telefone na mão a avaliação
         **entra no funil** — vira lead com ficha, aparece em Leads, e o
         "e aí, pensou no carro?" deixa de depender da sua memória.

         ⚠️⚠️ E NADA DISSO É OBRIGATÓRIO. Muita avaliação é feita com o carro
         na frente e o dono do lado; parar pra digitar ali atrasa. Em branco,
         tudo funciona exatamente como funcionava — inclusive o WhatsApp,
         que volta a abrir o seletor de contatos.
         ================================================================== */
      '<div class="pdi-cli">'+
        '<label class="cad-lbl">Nome do cliente <i style="font-weight:600;color:#94a3b8">(opcional)</i></label>'+
        '<input class="cad-in" id="avCliNome" placeholder="Nome do cliente" autocomplete="off" autocapitalize="words">'+
        '<label class="cad-lbl" style="margin-top:8px">WhatsApp <i style="font-weight:600;color:#94a3b8">(opcional)</i></label>'+
        '<input class="cad-in" id="avCliTel" inputmode="tel" placeholder="(00) 00000-0000">'+
        '<div class="pdi-cli-msg" id="avCliMsg"></div>'+
      '</div>'+
      (url ? ('<label class="pdi-chk'+(_avPedirFotos?' on':'')+'" id="avPedirFotoBox">'+
        '<input type="checkbox" id="avPedirFotoChk"'+(_avPedirFotos?' checked':'')+'>'+
        '<span><b>Pedir também as fotos do carro</b>'+
        '<i>'+((_avFotos||[]).length ? ('esta avaliação já tem '+(_avFotos||[]).length+' foto(s)') : 'ainda não há foto nenhuma aqui')+'</i></span></label>') : '')+
      '<textarea class="pdi-txt" id="avPedirTxt"></textarea>'+
      '<div class="pdi-ft">'+
        '<button type="button" class="pdi-cp" id="avPedirCopiar">Copiar</button>'+
        '<button type="button" class="pdi-wa" id="avPedirWa">WhatsApp</button>'+
      '</div></div>';
    document.body.appendChild(d);
    $('avPedirTxt').value=txt;
    d.onclick=function(e){ if(e.target===d) avPedirFechar(); };
    $('avPedirX').onclick=avPedirFechar;

    var chk=$('avPedirFotoChk');
    if(chk) chk.onchange=async function(){
      _avPedirFotos=!!chk.checked;
      try{ $('avPedirFotoBox').classList.toggle('on', _avPedirFotos); }catch(_){}
      /* 🔴 re-salva o PACOTE: é o payload que a página do cliente lê. Só
         mudar o texto daqui não faria a área de fotos aparecer pra ele. */
      try{ if(typeof avLojAtualizar==='function') await avLojAtualizar(); }catch(_){}
      if(url) $('avPedirTxt').value=avPedirTextoLink(url);
    };

    $('avPedirCopiar').onclick=function(){
      var t=$('avPedirTxt').value;
      try{ navigator.clipboard.writeText(t); toast('Mensagem copiada.'); }
      catch(_){ try{ $('avPedirTxt').select(); document.execCommand('copy'); toast('Mensagem copiada.'); }catch(__){ toast('Não consegui copiar.'); } }
    };
    /* máscara na digitação — telefone errado é pior que telefone nenhum */
    (function(){ var tl=$('avCliTel'); if(!tl||typeof foneFmt!=='function') return;
      tl.oninput=function(){ this.value=foneFmt(this.value); _avCliPinta(); };
      tl.addEventListener('paste',function(){ var el=this; setTimeout(function(){ el.value=foneFmt(el.value); _avCliPinta(); },0); });
      var nm=$('avCliNome'); if(nm) nm.oninput=_avCliPinta;
      _avCliPinta();
    })();
    /* v691 — o cliente que veio do laudo do Avaliex PUXA JUNTO: o import
       deixou um bilhete por placa (mev_avcli:PLACA, ver 05i) e a folha
       preenche a partir dele — SÓ campo vazio, o digitado sempre ganha. */
    try{
      var _plCli=String((veiculoAtual&&veiculoAtual.placa)||'');
      var _cliImp=JSON.parse(localStorage.getItem('mev_avcli:'+_plCli)||'null');
      /* v702: sem bilhete local, a nuvem responde (importou no outro aparelho) */
      if(!_cliImp && _plCli){
        try{ docHistCloudLoadOne('aval_cli', _plCli, function(o){
          if(!o) return;
          var nEl=$('avCliNome'), tEl=$('avCliTel');
          if(nEl && !String(nEl.value||'').trim() && o.nome) nEl.value=o.nome;
          if(tEl && !String(tEl.value||'').trim() && o.tel)
            tEl.value=(typeof foneFmt==='function')?foneFmt(o.tel):o.tel;
          try{ _avCliPinta(); }catch(_){}
          try{ localStorage.setItem('mev_avcli:'+_plCli, JSON.stringify(o)); }catch(_){}
        }); }catch(_){}
      }
      if(_cliImp){
        var _nEl=$('avCliNome'), _tEl=$('avCliTel');
        if(_nEl && !String(_nEl.value||'').trim() && _cliImp.nome) _nEl.value=_cliImp.nome;
        if(_tEl && !String(_tEl.value||'').trim() && _cliImp.tel)
          _tEl.value=(typeof foneFmt==='function')?foneFmt(_cliImp.tel):_cliImp.tel;
        _avCliPinta();
      }
    }catch(_){}

    $('avPedirWa').onclick=async function(){
      var t=$('avPedirTxt').value;
      var bt=this; bt.disabled=true;
      /* 🔴 19/08 — grava o cliente ANTES de abrir a conversa. Se falhar, o
         WhatsApp abre assim mesmo: perder o vínculo é aborrecimento, perder
         a mensagem é o pedido do Angelo indo pro lixo. */
      var tel='';
      try{ var r=await avCliGravar(); tel=(r&&r.telefone)||''; }catch(_){ tel=''; }
      bt.disabled=false;
      /* ⚠️ ATÉ A v572 O TELEFONE NÃO IA NA URL DE PROPÓSITO — o comentário
         antigo dizia, com razão, que a avaliação nem sempre tem cliente
         vinculado e que mandar pro número errado é pior que escolher a
         conversa na mão. Isso continua valendo **quando não há número**:
         sem telefone, o wa.me sem número abre o seletor, igual a antes.
         O que mudou é que agora existe um número CONFIRMADO por quem
         digitou, com máscara e conferência de tamanho — e aí abrir direto
         na conversa é melhor que fazer a pessoa procurar. */
      var u='';
      try{ if(tel && typeof cliWhatsUrl==='function') u=cliWhatsUrl(tel); }catch(_){ u=''; }
      u = u ? (u+'?text='+encodeURIComponent(t)) : ('https://wa.me/?text='+encodeURIComponent(t));
      try{ if(typeof mevIrProWhats==='function'){ mevIrProWhats(u); } else { window.open(u,'_blank','noopener'); } }
      catch(_){ location.href=u; }
      avPedirFechar();
    };
  }

  /* mostra o número formatado ANTES de abrir — um dígito trocado manda a
     avaliação do carro pro estranho, e ler "(51) 99999-0001" na tela é a
     única chance de a pessoa perceber. */
  function _avCliPinta(){
    var el=$('avCliMsg'); if(!el) return;
    var d=String((($('avCliTel')||{}).value)||'').replace(/\D/g,'');
    if(!d){ el.textContent=''; el.className='pdi-cli-msg'; return; }
    if(d.length<10 || d.length>11){
      el.textContent='Faltam números — o WhatsApp tem 10 ou 11 dígitos com o DDD.';
      el.className='pdi-cli-msg err'; return;
    }
    el.textContent='Vai abrir a conversa com '+((typeof _crmFoneFmt==='function')?_crmFoneFmt(d):d)+'.';
    el.className='pdi-cli-msg ok';
  }
  /* ==========================================================================
     🔴 ACHAR-OU-CRIAR o cliente, e amarrar a avaliação nele.
     ⚠️ A dedup é a REGRA DA CASA: `crmFoneChave` = os 8 últimos dígitos
     (v517), a mesma do atendente IA — ela resolve o nono dígito sozinha.
     Reaproveitar a ficha que já existe é o que impede o CRM de encher de
     "Alemão" repetido, que quebra o histórico do carro e a carteira.
     ⚠️ Nome e telefone vão SÓ pra `clientes`. Na avaliação entra apenas o
     `cliente_id` — um uuid, que sozinho não diz nada. Ver o SQL da v573.
     ========================================================================== */
  async function avCliGravar(){
    var nome=String((($('avCliNome')||{}).value)||'').trim();
    var telv=String((($('avCliTel')||{}).value)||'').trim();
    var dig=telv.replace(/\D/g,'');
    if(!nome && !dig) return null;                    /* pulou os dois: nada a fazer */
    if(dig && (dig.length<10 || dig.length>11)) return { telefone:'' };  /* número torto não vira ficha */

    var achado=null;
    try{
      var chave=(typeof crmFoneChave==='function') ? crmFoneChave(dig) : '';
      if(chave && Array.isArray(_clientes)){
        achado=_clientes.filter(function(c){
          return (typeof crmFoneChave==='function') && crmFoneChave(c.telefone)===chave; })[0]||null;
      }
      if(!achado && nome && typeof cliNomeIgual==='function') achado=cliNomeIgual(nome)||null;
    }catch(_){ achado=null; }

    var id=achado&&achado.id;
    if(!id && (nome||dig)){
      try{
        var ins={ user_id:meuId, nome: nome || ((typeof _crmFoneFmt==='function')?_crmFoneFmt(dig):dig) };
        if(telv) ins.telefone=telv;
        var r=await supa.from('clientes').insert(ins).select().single();
        if(r&&r.error) throw r.error;
        if(r&&r.data){ id=r.data.id; try{ if(Array.isArray(_clientes)) _clientes.push(r.data); }catch(_){} }
      }catch(_){ id=null; }
    }
    /* ⚠️ só amarra quando a avaliação já existe no banco. Falhar aqui não
       pode atrapalhar o envio — o vínculo é conveniência, o link é o pedido. */
    if(id && _avLojId){
      try{ await supa.from('avaliacoes').update({ cliente_id:id }).eq('id',_avLojId).select('id'); }catch(_){}
    }
    return { id:id||null, telefone: dig || (achado&&String(achado.telefone||'').replace(/\D/g,'')) || '' };
  }

  var _AVI_REP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';

  function avaliacaoFormHtml(v){
    var fipe=Math.round(Number(v.fipe)||0);
    var fipeFmt=fipe?('R$ '+fipe.toLocaleString('pt-BR')):'';
    var moto=ehMoto(v); _ehMoto=moto; _motoPorte=motoPorte(v); _avCusto=(moto?AV_CUSTO_MOTO:AV_CUSTO_CARRO).slice();
    /* moto não tem ar/direção; carro sim
       ⛳ v924: o `arDir` saiu. Os DOIS campos continuam existindo, só que
       montados um a um no `_pecasVist` (o Ar-condicionado foi pro grupo
       Elétrica e interior, a Direção foi pro grupo Suspensão, direção e
       freios). A regra "moto não tem" continua igual — os dois nascem string
       vazia quando é moto. Era:
         var arDir = moto ? '' : ('<div class="avt-g2">'+asel('avAc',…)+asel('avDir',…)+'</div>'); */
    /* porte ocupa a linha inteira (pra caber "Pequena (até 160cc)") */
    var porteSel = moto ? ('<div class="avt-full">'+aselC('avPorte','Porte da moto (ajusta os custos)',[['Pequena (até 160cc)','peq'],['Média (até 350cc)','med'],['Grande (acima de 350cc)','gra']],_motoPorte)+'</div>') : '';
    var itens = moto
      ? ('<div id="avMotoItens">'+motoItensHtml(_motoPorte)+'</div>')
      : ('<div class="avt-g2">'+aselCusto('avPneus','Pneus',[['Novos','novos'],['Bons',0],['Troca dois (R$ 1.500)',1500],['Troca os 4 (R$ 3.000)',3000],['Outro (digite o valor)','outro']],0)+aselServ('avLat','Lataria','Sem danos')+'</div>'+
          '<div class="avt-g2">'+aselServ('avMec','Mecânica / motor','Sem custo')+aselServ('avEle','Elétrica','Sem custo')+'</div>'+
          /* v182 — itens novos do bloco de vistoria (pedido do Angelo) */
          '<div class="avt-g2">'+aselServ('avCambio','Câmbio','Sem custo')+aselServ('avSusp','Suspensão','Sem custo')+'</div>'+
          '<div class="avt-g2">'+aselServ('avEmbr','Embreagem','Sem custo')+/* v266 (pedido): "Original" entrou como primeira opção — para-brisa de
             fábrica é ponto POSITIVO do carro, não custo.
             ⚠️ O valor interno dela é 'original', e NÃO 0. Se fosse 0 ela
             empataria com "Sem trincas" e cairíamos no mesmo bug da v248: ao
             restaurar o rascunho o navegador escolhe a PRIMEIRA opção com
             aquele valor, e "Sem trincas" viraria "Original" sozinho. O cálculo
             não muda — _custo() lê Number('original') como 0. */
          aselCusto('avParab','Para-brisa',[['Original','original'],['Sem trincas',0],['Reparo (R$ 200)',200],['Trocar (R$ 900)',900],['Outro (digite o valor)','outro']],0)+'</div>'+
          /* v247: Estofados e Painel — mesma lógica dos Serviços (modal) */
          '<div class="avt-g2">'+aselServ('avEstof','Estofados','Sem custo')+aselServ('avPainel','Painel','Sem custo')+'</div>'+
          '<div class="avt-g2">'+aselCusto('avRev','Revisão',[['Sem custo',0],['Intermediária (R$ 1.000)',1000],['Reforçada (R$ 1.500)',1500],['Ampla (R$ 2.000)',2000],['Completa (R$ 2.500)',2500],['Outro (digite o valor)','outro']],1000)+asel('avRevJa','Revisado?',['Verificar','Sim','Não'],'Verificar')+'</div>'+
          '<div class="avt-full">'+ai('avProxRev','Próxima revisão (km)','','ex: 90.000')+'</div>');
    /* v241: as margens nascem com o percentual salvo nos "Percentuais padrão" */
    var _pcSel=_avPcts();
    var _lucroDef=Math.round(moto?_pcSel.lucroMoto:_pcSel.lucroCarro);
    var _lucroLista=(moto?[12,13,14,15,16,18,20]:[5,6,7,8,9,10,11,12]).slice();
    if(_lucroLista.indexOf(_lucroDef)<0){ _lucroLista.push(_lucroDef); _lucroLista.sort(function(a,b){return a-b;}); }
    var lucroSel = aselPct('avLucro','Margem de lucro',_lucroLista,_lucroDef);
    var _garDef=Math.round(_pcSel.garantia);
    var _garLista=[3,4,5,6,7,8,9,10]; if(_garLista.indexOf(_garDef)<0){ _garLista.push(_garDef); _garLista.sort(function(a,b){return a-b;}); }

    /* ==========================================================================
       🔴 v924 — "DADOS DO VEÍCULO" PASSOU A SER A TELA INTEIRA DA VISTORIA
       --------------------------------------------------------------------------
       (PROJETO: AVALIACAO INTEGRADA A DADOS DO VEICULO, 06/09)

       A aba "Avaliação itens" acabou. O que morava nela — e o que morava aqui —
       virou NOVE GRUPOS que começam fechados, montados pelo 07c-vistoria.js.

       🔑 A QUILOMETRAGEM FICA FORA DOS GRUPOS, logo abaixo do título, na
       largura inteira. É o dado que mais mexe no preço e o único que quase
       sempre se digita; com tudo recolhido, ele continua na tela. Ordem, letra
       por letra do projeto: Dados do veículo > Quilometragem > grupos.

       🔴 O "PEDIR AO CLIENTE" SAIU DESTA TELA. Só da tela: o
       avPedirAbrir, o formulário, os pedidos já enviados e os contatos
       continuam todos de pé no código (o projeto: "Nao excluir contatos ou
       pedidos antigos ao retirar esse acesso da interface"). O que sumiu é a
       OFERTA daqui — e some junto a coluna vazia que ele ocupava, pra a
       quilometragem ocupar a linha inteira em vez de meia.
       ⚠️ Era a `.avt-g2.avt-km-destaque` com duas colunas: campo + botão.
       Agora é `.avt-full`.

       ⚠️ O avObs saiu do legado oculto na v1435 e agora fica visível logo
       depois da quilometragem; continua no anúncio e no estoque. */
    var _pecasVist={
      alien:      asel('avAlien','Veículo alienado?',['Não','Sim'],'Não'),
      multas:     asel('avMultas','Tem multas?',['Não','Sim'],'Não'),
      alienBox:   '<div class="avt-g2" id="avAlienBox" style="display:none">'+asel('avAlienQuem','Quem quita o financiamento?',['— a definir —','Cliente quita','Loja quita'],'— a definir —')+
                    '<div class="avt-col"><div class="avt-lbl">Valor da quitação</div><input id="avAlienValor" class="avt-in" inputmode="numeric" placeholder="R$ 0"></div>'+
                  '</div>',
      ipva:       asel('avIpva','IPVA '+(new Date().getFullYear()),['Pago','Em atraso'],'Pago'),
      donos:      asel('avDonos','Histórico de donos',['Verificar','Único dono','Segundo dono','3+ donos','Não sabe'],'Verificar'),
      /* v248 (BUG): "— a conferir —" e "Tem" tinham o MESMO valor interno (0).
         Cada opção tem valor próprio ('' / 'tem' / 1000) desde então. */
      chave:      aselC('avChave','Chave reserva',[['Verificar',''],['Tem','tem'],['Não tem (+R$ 1.000)',1000]],''),
      manual:     asel('avManual','Manual do veículo',['Verificar','Tem','Digital (app)','Não tem'],'Verificar'),
      revC:       '<div class="avt-col"><div class="avt-lbl">Revisões concessionária</div><select id="avRevC" class="avt-in avt-sel"><option selected>Verificar</option><option>Sim</option><option>Não</option><option>Não tem todas</option></select><input id="avRevCKm" class="avt-in" inputmode="numeric" placeholder="revisões até qual km? ex: 60.000" style="display:none;margin-top:6px"></div>',
      garantia:   asel('avGarantia','Garantia de fábrica',['Verificar','Tem','Não tem'],'Verificar'),
      garantiaAte:'<div class="avt-g2"><div class="avt-col" id="avGarantiaAteBox"><div class="avt-lbl">Garantia até (mês/ano)</div><input id="avGarantiaAte" class="avt-in" inputmode="numeric" placeholder="ex: 08/2027" maxlength="7"></div></div>',
      /* os de custo, exatamente como eram — só mudaram de endereço */
      lat:        aselServ('avLat','Lataria','Sem danos'),
      pneus:      aselCusto('avPneus','Pneus (custo de troca)',[['Novos','novos'],['Bons',0],['Troca dois (R$ 1.500)',1500],['Troca os 4 (R$ 3.000)',3000],['Outro (digite o valor)','outro']],0),
      /* v266: "Original" com valor interno 'original', NUNCA 0 — senão ela
         empata com "Sem trincas" e o rascunho volta trocado (bug da v248). */
      parab:      aselCusto('avParab','Para-brisa',[['Original','original'],['Sem trincas',0],['Reparo (R$ 200)',200],['Trocar (R$ 900)',900],['Outro (digite o valor)','outro']],0),
      mec:        aselServ('avMec','Mecânica / motor (custo)','Sem custo'),
      ele:        aselServ('avEle','Elétrica (custo)','Sem custo'),
      cambio:     aselServ('avCambio','Câmbio (custo)','Sem custo'),
      susp:       aselServ('avSusp','Suspensão (custo)','Sem custo'),
      embr:       aselServ('avEmbr','Embreagem (custo)','Sem custo'),
      estof:      aselServ('avEstof','Estofados','Sem custo'),
      painel:     aselServ('avPainel','Painel','Sem custo'),
      rev:        aselCusto('avRev','Revisão',[['Sem custo',0],['Intermediária (R$ 1.000)',1000],['Reforçada (R$ 1.500)',1500],['Ampla (R$ 2.000)',2000],['Completa (R$ 2.500)',2500],['Outro (digite o valor)','outro']],1000),
      revJa:      asel('avRevJa','Revisado?',['Verificar','Sim','Não'],'Verificar'),
      proxRev:    '<div class="avt-full">'+ai('avProxRev','Próxima revisão (km)','','ex: 90.000')+'</div>',
      ac:         moto?'':asel('avAc','Ar-condicionado',['Verificar','Tem e gela','Tem, não gela','Não tem'],'Verificar'),
      dir:        moto?'':asel('avDir','Direção',['Verificar','Tem (hidr./elétr.)','Não tem'],'Verificar'),
      porte:      porteSel,
      itens:      itens
    };
    var _arSimples=_pecasVist.ac, _dirSimples=_pecasVist.dir;
    _pecasVist.ac='';_pecasVist.dir='';
    var pDados='<div class="avt av-dados-simples">'+
      '<div class="avt-full avt-km-destaque">'+ai('avKm','Quilometragem','','Ex.: 52.316 km')+'</div>'+
      '<div id="avMediaAtual" class="avt-media avt-media-atual" style="display:none"></div>'+
      '<div id="avMedia" class="avt-media" style="display:none" aria-live="polite"></div>'+
      avObservacoesHtml()+
      /* ==================================================================
         🔴🔴🔴 v1079 — AR-CONDICIONADO E DIREÇÃO SAÍRAM DE BAIXO DA KM
         ------------------------------------------------------------------
         Pedido do Angelo: "remove ar e direcao debaixo da quilometragem,
         fica só nos opcionais". Os dois já existem na lista de Opcionais do
         veículo (v1065) — perguntar a mesma coisa duas vezes na mesma tela é
         convidar as duas respostas a discordarem.

         ⚠️ SAI A PORTA, FICA O QUARTO — a regra da casa. Os dois `<select>`
            CONTINUAM no DOM, dentro de um `<div hidden>`:
              · `avAc` e `avDir` estão no AV_FIELDS. Se sumissem do DOM, o
                `avFormObj()` pararia de gravá-los e a resposta que já estava
                salva em avaliação antiga seria APAGADA no primeiro autosave.
              · o resumo da vistoria (linha ~2480) lê os dois pra dizer o que
                falta verificar; com eles fora, ele passaria a mentir.
         ⚠️ `<div hidden>` SEM CLASSE de propósito: a `.avt-g2` tem
            `display:grid` na folha, e grid de folha GANHA do `hidden` do
            navegador — o bloco continuaria aparecendo. Div pelada, sem
            regra nenhuma apontando pra ela, obedece ao `hidden`.
         ================================================================== */
      '<div id="avArDirOculto" hidden>'+_arSimples+_dirSimples+'</div>'+
      '<input type="hidden" id="avGastosJ">'+
      '<div class="av-gastos-head"><h3>Gastos previstos</h3></div>'+
      '<div class="av-gastos-unico">'+
        '<label class="avt-col" for="avGastosValor">Valor total (R$)<input class="avt-in" id="avGastosValor" type="number" min="0" step="0.01" inputmode="decimal" placeholder="0,00"></label>'+
        '<label class="avt-col av-gastos-descricao" id="avGastosDescricaoBox" for="avGastosDescricao" hidden>Descrição<textarea class="avt-in" id="avGastosDescricao" maxlength="1000" rows="3"></textarea></label>'+
      '</div>'+
      /* v1065 — OPCIONAIS DO VEÍCULO, logo abaixo da estimativa de gastos
         (pedido do Angelo). O bloco inteiro mora no 07e-opcionais.js; aqui
         fica só a porta. A função está declarada em outro arquivo do MESMO
         IIFE, então ela sobe no hoisting e já existe quando isto roda. */
      avOpcBlocoHtml()+
      '<div class="av-dados-legado" hidden>'+
      '<div class="avt-lbl avt-lbl-sec">Rodagem</div>'+
      avVistoriaHtml(v, moto, _pecasVist)+
    '</div></div>';

    /* ---- 0) HISTÓRICO DA FIPE — v891: SAIU DAQUI ----
       Foi pra tela da consulta da placa, abaixo do "Baixar o PDF da FIPE".
       O painel `_avP('histfipe',…)` também saiu da montagem: um painel sem
       passo correspondente em `_AV_STEPS` fica órfão — ninguém o abre, e ele
       some do teclado e do leitor de tela sem dizer por quê. Aba e painel
       andam juntos, os dois foram embora juntos. */

    /* ---- 2) AVALIAÇÃO DOS ITENS ---- ⛳ v924: ESTE PAINEL SAIU.
       O `arDir`, o `porteSel` e o bloco `itens` não sumiram — eles foram
       ENTREGUES ao 07c-vistoria pelo `_pecasVist` ali em cima, e agora moram
       dentro dos grupos de "Dados do veículo". O painel sumiu junto com a aba
       (regra da v891: aba e painel andam juntos).
       Era:
         var pItens='<div class="avt…">'+_avTit('Avaliação dos itens',…)+arDir+porteSel+itens+'</div>';
       ------------------------------------------------------------------- */

    /* ---- 3) PESQUISA DE MERCADO (dentro de Valores) ---- */
    /* ==========================================================================
       🔴 v921 (PROJETO-mercado-ordem-botao-ocultar-margens, 06/09)
       O "ANALISAR MERCADO" DESCEU PRA DEPOIS DOS ANÚNCIOS
       --------------------------------------------------------------------------
       Era: faixa de preço → [Analisar mercado] → Pesquisar anúncios semelhantes.
       O botão ficava ENTRE o título do bloco e os links dos portais, e a leitura
       da tela virava "olhe a faixa, peça a análise, ah, e tem uns links".

       🔑 A ordem agora acompanha o que a pessoa faz: primeiro as
       referências (FIPE e liquidez), depois a faixa, depois OLHAR o mercado de
       verdade nos portais, e só então pedir a leitura da IA. A análise é o
       fecho, não o meio.

       ⚠️ É a MESMA caixa, MOVIDA — não uma segunda. O #avMktAval continua sendo
       o único lugar onde o pintaAvalMercado desenha o botão, o carregando, o
       resultado e o "Tentar de novo". Duplicar o container daria dois botões
       pro mesmo job (e a segunda cobrança em cima). */
    var pMercado='<section class="avt-market" aria-label="Pesquisa de mercado">'+
      '<div class="avt-market-head">'+
        '<div><div class="avt-market-kicker">Pesquisa de mercado</div><p>Faixa pesquisada em anúncios semelhantes deste modelo e quilometragem.</p></div>'+
      '</div>'+
      '<div id="avMkt">'+
        '<div class="avt-market-range"><span>Faixa de preço de mercado</span><b id="avMktRng">Aguardando pesquisa</b><small id="avMktRngAjuda">Gere ou atualize a análise para pesquisar anúncios deste modelo e quilometragem.</small></div>'+
        '<div class="avt-busca" id="avBusca">'+buscaLinksHtml(v,0)+'</div>'+
        '<div class="avt-mkt-aval" id="avMktAval"></div>'+
      '</div>'+
    '</section>';

    /* ---- 3) VALORES ---- */
    /* ==========================================================================
       🔴 v921 — AS MARGENS SAÍRAM DE VISTA NESTA ABA (não do sistema)
       --------------------------------------------------------------------------
       "Ocultar Margem de lucro e Margem de garantia na aba Mercado. Retirar
       também o espaço da linha que esses campos ocupavam."

       🔑 OS DOIS SELECTS CONTINUAM EXISTINDO, e isso não é preguiça — é o
       contrário. Meia dúzia de rotinas fala com eles pelo id: o avFormSalvar
       (avLucro/avMg estão na AV_FIELDS), o wirePctOutro, o _mgPct, o
       _pctValor, o _poeNoSelect (é ele que grava quando a pessoa edita o %
       NA LINHA DO CUSTO), o avGarantia do 13-abrir-avaliacao... Apagar os
       campos apagaria o valor salvo de toda avaliação já feita. Ocultar
       preserva tudo: valor, padrão, cálculo, rascunho e reabertura.

       ⚠️ E O JEITO DE OCULTAR IMPORTA. `display:none` (não `visibility`, não
       `opacity`) — assim os selects não recebem foco pelo Tab, não aparecem
       pro leitor de tela e NÃO DEIXAM A LINHA VAZIA no lugar deles, que era
       metade do pedido.
       🚫 E NÃO tem `aria-hidden` aqui de propósito: `display:none` já
       tira do leitor de tela E do Tab. Pôr `aria-hidden` num bloco com campos
       é a receita do defeito clássico — se um dia alguém devolver o bloco pra
       tela, ele voltaria visível e MUDO pro leitor de tela, e ninguém veria.
       📌 ONDE SE EDITA AGORA: na aba CUSTOS, no % da própria linha
       (o `.avc-pin` com data-p="lucro"/"garantia"), que já existia e já grava
       no padrão salvo. Nada ficou sem porta.

       E a frase "Preencha a liquidez e as margens antes de analisar o mercado"
       saiu junto: mandar preencher um campo que não está mais na tela é pior
       que não dizer nada. Nenhum parágrafo novo entrou no lugar (pedido). */
    var pValores='<div class="avt">'+
      _avTit('Mercado','Referências de preço e liquidez para orientar sua revenda.')+
      '<section class="avt-market-base" aria-label="Referências de preço">'+
      '<div class="avt-market-kicker">Referências de preço</div>'+
      '<div class="avt-market-precos">'+aro('FIPE de referência',fipeFmt)+'<div class="avt-market-liquidez"><div class="avt-liq" id="avLiqCampo">'+ai('avLiq','Valor de liquidez',fipeFmt,'')+'</div><button type="button" class="btn-sec-lb avt-market-custos" id="avMercadoCustosBtn" aria-expanded="false" aria-controls="avMercadoCustos">'+_AV_ICO.custos+'<span>Custos</span></button></div></div>'+
      '<input type="hidden" id="avLiqT">'+
      '<div class="avt-g2 avt-margens-off" id="avMargensBox">'+lucroSel+aselPct('avMg','Margem de garantia',_garLista,_garDef)+'</div>'+
      '</section><!--av-mercado-custos-->'+
      pMercado+
    '</div>';

    /* ---- 4) CUSTOS ---- */
    var pCustos='<div class="avt">'+
      _avTit('Custos','Tudo que sai do valor. Cada linha é editável: digitou por cima, vale o seu número.')+
      '<div class="avt-custos open" id="avCustos"><button type="button" class="avt-custos-btn"><span class="l">Custos identificados</span><span class="r"><b id="avCustosTot">−R$ 0</b><span class="chev">▸</span></span></button><div class="avt-custos-body" id="avCustosBody"></div></div><input type="hidden" id="avCustoEdJ">'+
    '</div>';
    /* v244: a observação do rodapé ("Os percentuais se editam...") saiu (pedido) */
    pValores=pValores.replace('<!--av-mercado-custos-->','<section id="avMercadoCustos" aria-label="Custos" hidden>'+pCustos+'</section>');

    /* ---- 5) FOTOS ---- */
    var pFotos='<div class="avt">'+
      _avTit('Fotos','As fotos vão junto no link que você manda pro lojista. Elas já entram no enquadramento certo.')+
      '<div class="avt-photo-card">'+
        '<div class="av-fotos" id="avFotos"></div>'+
        '<div class="avt-photo-count" id="avFotoCount"></div>'+
      '</div>'+
    '</div>';

    /* ---- 6) COTAÇÃO LOJA ---- */
    var pLoja='<div class="avt">'+
      _avTit('Avaliação','')+
      /* v242: os cartoes viram fixos e a LIQUIDEZ se edita ali mesmo —
         os campos soltos de liquidez e margem de lucro sairam (pedido). */
      '<div class="avt-cotres" id="avCotRes"><span>FIPE<b id="avCotFipe">—</b></span><span class="edit">Liquidez ✎<input id="avLiq3" class="avc-cotin" inputmode="numeric" placeholder="R$ 0"></span><button type="button" class="avt-cotres-custos" id="avCotCustosBt" aria-haspopup="dialog">Custos<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg><b id="avCotCustos">—</b></button></div>'+
      '<div class="avt-escolher"><span class="l">Valor sugerido</span><span class="fipe">FIPE '+r$(fipe)+'</span></div>'+
      /* v262: saiu a linha de comparação com a FIPE ("−R$ 8.105,00 · −27.4% vs
         FIPE") — pedido. O cartão fica com o essencial: quanto pagar. O id
         avSugLojaP continua existindo (escondido) porque o cálculo escreve
         nele; assim nada quebra e é fácil trazer de volta se quiser. */
      '<div class="avt-sug avt-sug-static" role="status"><span class="n">Avaliação compra repasse<small id="avSugLojaP" style="display:none"></small></span><span class="v" id="avSugLoja">—</span></div>'+
      /* ===== v271 (pedido) — QUANDO QUEM AVALIOU FOI UM LOJISTA PARCEIRO =====
         Acontece direto: o parceiro olha o carro e diz quanto paga. A loja não
         repassa esse número cru pro cliente — ela guarda uma margem no meio
         (na prática, R$ 2.000) e oferece o resto.
         Essa conta era feita de cabeça e o número do parceiro não ficava
         registrado em lugar nenhum. Agora ela fica na tela, e o resultado cai
         direto no "Valor avaliado". */
      /* ===== 🔴 v705 (pedido do Angelo, 29/08, com o print da Cotação loja):
         "deixe tres campos, valor avaliado Avaliex (avaliado gerente), valor
          avaliado repasse (se digitar abre pra digitar qual lojista avaliou)
          e valor avaliado loja (repasse menos 2000 de margem) e nome de quem
          avaliou loja"
         O INTERRUPTOR "Quem avaliou foi um lojista" (v271) SAIU DE CENA: o
         gesto agora é DIGITAR — repasse digitado abre o "qual lojista" e a
         margem, e a conta (repasse − 2.000) cai no Valor avaliado loja, como
         a v271 já fazia. ⛳ Pra voltar ao interruptor: reponha o label
         avLojRow/avLojSw e o display:none do avLojBox (o avLojWire ainda
         sabe ligá-lo se ele existir no DOM).
         · Avaliex (avaliado gerente) → mora no REGISTRO DO CARD
           (valor_avaliex, v695) — o import do laudo já o preenche sozinho;
         · repasse → o avLojOferta de sempre (rascunho), + avLojQuem novo;
         · loja → o avValor de sempre (v390: um nome só pra cada coisa). */
      /* ======================================================================
         🔴 v1068 — A ORDEM DOS QUATRO CAMPOS, AO PÉ DA LETRA DO PEDIDO:
           1º sugestão compra  →  o `avSugLoja` logo acima
           2º avaliação Avaliex
           3º sugestão venda lojista
           4º sugestão venda varejo
         E ABAIXO deles o bloco "Interesse Repasse" (07f-interesse-repasse.js).

         ⚠️ O "Valor que entra pra loja", a distância pra FIPE e o "Quem
            avaliou (loja)" DESCERAM JUNTO com o bloco — não por arrumação,
            mas porque o valor que entra pra loja É o resultado da conta do
            Interesse Repasse (ofertado − margem). Separá-lo da conta que o
            produz era o que fazia a tela parecer ter dois assuntos.
         ⚠️ NENHUM id sumiu: todos estão no AV_FIELDS, e campo que o autosave
            lê tem que continuar existindo no DOM (lições v177 e v442).
         ====================================================================== */
      '<div class="avt-lbl">Valor avaliado Avaliex <span class="avt-lbl-sub">(avaliado gerente)</span></div>'+
      '<input id="avAvaliex" class="avt-in" inputmode="numeric" placeholder="R$ 0">'+
      '</div><div class="av-vendas"><section><label for="avVendaLojista">Venda lojista</label><input id="avVendaLojista" class="av-venda-in" inputmode="decimal" placeholder="R$ 0,00"><input type="hidden" id="avVendaLojistaT"></section>'+
      '<section><label for="avVendaVarejo">Venda varejo</label><input id="avVendaVarejo" class="av-venda-in" inputmode="decimal" placeholder="R$ 0,00"><input type="hidden" id="avVendaVarejoT"></section></div>'+
      intRepBlocoHtml()+
      '<section class="av-jev" aria-labelledby="avJevTitulo">'+
        '<div class="av-jev-head"><span class="av-jev-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"/><circle cx="12" cy="12" r="4"/></svg></span><div><div class="avt-market-kicker">Decisão assistida</div><h3 id="avJevTitulo">Análise JEV</h3></div></div>'+
        '<p class="av-jev-ajuda">Segunda opinião sobre preços de liquidez e compra, risco e destino comercial. Não altera os valores da avaliação.</p>'+
        '<input type="hidden" id="avJevJ">'+
        '<div class="av-jev-resultado" id="avJevResultado" aria-live="polite"></div>'+
        '<button type="button" class="cad-btn ico" id="avJevBtn"><svg class="mk-ico" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2v4M12 18v4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M2 12h4M18 12h4M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8"/><circle cx="12" cy="12" r="4"/></svg><span id="avJevBtnTexto">Analisar com JEV</span></button>'+
        '<p class="av-jev-nota">A recomendação é um apoio à decisão. Confirme o preço e a compra antes de concluir.</p>'+
      '</section>'+
      /* ======================================================================
         🔴🔴🔴 v1078 — AQUI MORAVA UM `</div>` A MAIS, E ELE APAGAVA A ABA
                        "COTAÇÃO REPASSE" INTEIRA NO COMPUTADOR.
         ----------------------------------------------------------------------
         O `pLoja` fechava NOVE divs e abria OITO. A conta não fechava desde
         que alguém removeu um bloco daqui e deixou a tampa dele pra trás (o
         `'</div>'` que ainda abre a linha do `av-vendas`, lá em cima, é a
         tampa do `.avt` — essa é legítima e é ela que separa os dois cartões
         na tela).

         O QUE A SOBRA CAUSAVA, em cadeia:
           1. o `</div>` extra fechava o `#avBody` antes da hora;
           2. o painel `cotrep`, que vem logo depois, nascia FORA do `#avBody`;
           3. o trocador de abas procura em `#avBody .vpx-panel` — nunca o
              achava, então nunca punha a classe `.on` nele;
           4. e como `.vpx-panel{display:none}` (acima de 980px), o painel
              existia no DOM e NUNCA aparecia.

         ⚠️ EU IA ESCREVER AQUI QUE ERA "SÓ NO COMPUTADOR". Não é — e a
            diferença importa. Eu tinha suposto que o `.vpx-panel{display:none}`
            morasse dentro de um `@media(min-width:980px)`; fui medir e ele
            está no NÍVEL DE CIMA do styles.css, valendo em qualquer largura.
            A régua desta versão abre a aba nas DUAS larguras e compara: o
            defeito era igual nos dois lados. Explicação bonita que ninguém
            mediu é palpite com cara de fato.

         ⚠️ O CONSERTO É TIRAR A TAMPA QUE SOBRAVA, NÃO A DE CIMA. Tirar a de
            cima também equilibraria a conta — e juntaria os dois cartões num
            só, mudando a tela que o Angelo já usa. Esta versão conserta a
            estrutura sem mexer em uma linha de desenho.
         ====================================================================== */
      '<div class="cad-msg" id="avMsg"></div><div id="avResult"></div>';

    /* ---- 7) REPASSE DENTRO DA AVALIAÇÃO (v1448) ---- */
    var pRep='<section class="avt av-repasse av-repasse-na-avaliacao" aria-labelledby="avRepasseTit">'+
      '<div class="avt-market-kicker">Repasse</div><h3 class="av-repasse-titulo" id="avRepasseTit">Página e portal do repasse</h3>'+
      '<p class="av-repasse-ajuda">Prepare o material para lojistas e acompanhe as ofertas sem sair da avaliação.</p>'+
      '<div class="avt-escolher"><span class="fipe">FIPE '+r$(fipe)+'</span></div>'+
      '<input type="hidden" id="avRepPreco"><input type="hidden" id="avRepT"><input type="hidden" id="avPrecoOculto" value="1">'+
      /* ===== v310 (pedido) — O INTERRUPTOR "MOSTRAR O PREÇO" SAIU DAQUI =====
         "Remova o mostre o preço na página do lojista".

         Ele deixava a decisão em aberto a cada carro, e a decisão já está
         tomada: preço de repasse não sai. É a mesma regra do Portal, da
         página pública /repasses, do Marketplace de Parceiros e do link do
         carro. Cinco lugares com a mesma regra e um interruptor deixando
         escapar é o suficiente pra vazar num dia de pressa.

         E ele ainda vinha LIGADO por padrão: quem não reparasse mandava o
         próprio preço de repasse junto, sem perceber. O rótulo em cima
         ("referência sua — o portal não mostra") dizia uma coisa e o
         interruptor logo abaixo fazia outra.

         O campo escondido continua aqui, fixo em "1" (não mostrar), porque
         rascunhos antigos guardados no aparelho ainda procuram por ele. */
      '<div class="av-actbar av-actbar-repasse" style="margin-top:12px">'+
        '<button type="button" class="av-actbtn" id="avBtnVer">'+_AVI_EYE+'<span>Gerar página</span></button>'+
        '<button type="button" class="av-actbtn" id="avalPdfBt">'+_icoPdf+'<span>Gerar PDF</span></button>'+
        '<label class="av-actbtn av-rep-portal" id="avRepPubRow">'+_AV_ICO.cotrep+'<input class="sr-only" type="checkbox" id="avRepPub"><span id="avRepPubTexto">Adicionar ao portal</span></label>'+
      '</div>'+
      /* v452: quem não tem plano Lojista vê ESTE aviso no lugar do interruptor
         de cima. Os dois nascem no DOM; quem decide qual aparece é o
         avRepPubWire (13-abrir-avaliacao.js). Motivo em 09c-plano-repasse.js. */
      repassePlanoTravaHtml('avRepPubTrava','avRepPubPlanos')+
      /* v452 (pedido): "Em negociação" ou "No meu estoque". Só aparece com o
         interruptor LIGADO — pergunta sobre um anúncio que não existe é
         ruído. Quem mostra/esconde e quem republica ao trocar é o
         avRepPubWire (13-abrir-avaliacao.js). */
      '<div class="rep-pub" id="avRepPosseRow" style="display:none;cursor:default">'+
        '<span class="rep-pub-tx"><b>Como o lojista vê este carro</b></span>'+
        '<select class="cad-in" id="avRepPosse" style="flex:none;width:auto;max-width:170px;margin:0">'+
          '<option value="negociacao">Em negociação</option>'+
          '<option value="estoque">No meu estoque</option>'+
        '</select>'+
      '</div>'+
      /* v242: resumo do que foi lançado + observações que vão pro lojista */
      /* v494 (Parte B do 3em1): o laudo pro DONO do carro — a mesma página
         numa moldura pra pessoa física, sem oferta e sem valores da loja. */
      /* v519 (pedido: "oculta do app o laudo para o cliente"):
         ⛳ o interruptor é o `MEV_LAUDO`, no alto do 13-abrir-avaliacao.js.
         🔴 Isto fecha a PORTA dentro do app — NÃO derruba o recurso: a
         página pública ?laudo=1 (v494) continua de pé e os links já
         enviados a clientes continuam abrindo.
         ⚠️ O 07 e o 13 vivem no MESMO IIFE, e o `var MEV_LAUDO` é atribuído
         no carregamento — muito antes de alguém abrir uma avaliação, que é
         quando esta tela é montada. Ler a variável daqui é seguro; o typeof
         é só cinto de segurança. */
      ((typeof MEV_LAUDO!=='undefined' && MEV_LAUDO)
        ? '<button type="button" class="av-actbtn" id="avBtnLaudo" style="width:100%;margin-top:8px">📄<span>Enviar laudo pro cliente</span></button>'
        : '')+
      /* v656 — GERAR ARTE do carro que a loja acabou de comprar na troca,
         antes mesmo de cadastrar no estoque. 🔴 A arte nasce SEM valor: o que
         existe aqui é o valor AVALIADO — o que a loja PAGA —, e isso não pode
         virar preço de anúncio nem por descuido. Aparece um campo vazio. */
      /* v835: a arte saiu do app (interruptor no 00-edicoes) */
      ((typeof arteDisponivel!=='function'||arteDisponivel()) ?
       '<button type="button" class="av-actbtn" id="avBtnArte" style="width:100%;margin-top:8px">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15l-1.9-4.1L5.5 9l4.6-1.4z"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z"/></svg>'+
        '<span>Gerar arte do veículo</span></button>' : '')+
      '<button type="button" class="cad-btn" id="avBtnFechar">Salvar e fechar</button>'+
      '<div id="avtOfertas" style="margin-top:14px"></div>'+
    '</section>';

    var _nav=_AV_STEPS.map(function(t,i){ return '<button type="button" class="vpx-st" data-step="'+t[0]+'" aria-pressed="false"><span class="av-step-num">'+(i+1)+'</span><span class="vpx-nm">'+t[1]+'</span></button>'; }).join('');
    /* v565: o aviso do que o CLIENTE respondeu fica FORA do corpo das abas —
       ele vale pra avaliação inteira, e escondido dentro de uma aba só seria
       visto por acaso. Nasce vazio; só existe quando há resposta nova. */
    /* v621 (pedido): o botão do PDF da avaliação. Ele fica FORA das abas de
       propósito — o documento é da avaliação inteira, não de um passo; preso
       dentro de uma aba só seria achado por acaso.
       🔴 Botão PRÓPRIO, SEM a classe .pdf-btn: aquela classe é do FAB verde,
       que clica sozinho o primeiro .pdf-btn da tela (lição que já custou três
       versões — v595, v599, v610). */
    return '<div class="vpx av-stepper"><section class="av-step-head" aria-labelledby="avEtapaTitulo">'+
      '<div class="av-step-meta"><div><span>Etapa da avaliação</span><strong id="avEtapaTitulo">Dados veículo</strong></div><b id="avEtapaContador">1 de 4</b></div>'+
      '<div class="av-step-track" id="avEtapaProgresso" role="progressbar" aria-label="Etapa da avaliação" aria-valuemin="1" aria-valuemax="4" aria-valuenow="1" aria-valuetext="Etapa 1 de 4: Dados veículo"><i id="avEtapaProgressoFill"></i></div>'+
      '<div class="vpx-steps vpx-mdr" id="avTabs" role="navigation" aria-label="Etapas da avaliação">'+_nav+'</div></section>'+
      '<div id="avCliBox"></div>'+
      '<div class="vpx-body cad-float" id="avBody">'+
      _avP('dados',pDados)+_avP('valores',pValores)+
      _avP('fotos',pFotos)+'<div hidden>'+avMktPainelHtml()+'</div>'+_avP('cotloja',pLoja+pRep)+'<input type="hidden" id="avClienteJ">'+
      '<nav class="av-step-actions" id="avEtapaNav" aria-label="Navegação entre etapas"><button type="button" class="av-step-prev" id="avEtapaAnterior" disabled>'+_AV_SETA_ANT+'<span>Anterior</span></button><span class="av-step-footer-counter" id="avEtapaRodapeContador" aria-live="polite"></span><button type="button" class="av-step-next" id="avEtapaProximo" data-final="false"><span id="avEtapaProximoTexto">Próximo: Mercado</span>'+_AV_SETA_PRO+_AV_CHECK+'</button></nav>'+
      /* v1063: o painel 'fichatec' saiu junto com a aba (ver o _AV_STEPS). */
    '</div></div>';
  }
  /* v169: quantas FAIXAS DE RODAGEM o veículo estourou.
     Acima de 15.000 km/ano = 1 faixa; acima de 24.000 = 2; acima de 34.000 = 3;
     e daí pra frente de 10.000 em 10.000 (acima de 44.000 = 4, de 54.000 = 5…).
     v176: cada faixa tira 5% da liquidez (antes eram 10%), um desconto SOBRE
     O OUTRO — por isso o valor cai forte no começo e nunca chega a zero. */
  /* 🔴 v706 (pedido do Angelo, 29/08): "ajuste a liquidez pra 10% a menos se
     passar dos 15000 km/ano de media, e a cada 10.000 km acima disso,
     diminui 10% da liquidez". A régua ficou REDONDA: passou de 15 mil/ano é
     1 faixa; cada 10 mil a mais é outra (15–25 mil → 1 · 25–35 mil → 2 ·
     35–45 mil → 3…). Antes (v176) os cortes eram em 24/34 mil e cada faixa
     valia 5%; agora cada faixa vale 10% — o desconto é composto (0,9^n),
     como sempre foi, um sobre o outro. */
  function _faixasKmAno(med){
    return MEV_AVALIACAO_MOTOR.faixas(med);
  }
  function _n(id){ var e=document.getElementById(id); return e?(parseFloat(String(e.value).replace(/[^0-9,.-]/g,'').replace(',','.'))||0):0; }
  /* v253: números "redondos de conversa" (pedido) — liquidez automática e
     margens em % arredondam pro múltiplo de R$ 500 mais próximo (33.195 →
     33.000; 3.320 → 3.500). Valor DIGITADO pelo lojista nunca é mexido, e
     um valor positivo nunca vira zero (mínimo R$ 500). */
  function _arr500(v){ return MEV_AVALIACAO_MOTOR.arr500(v); }
  function _km(){ return parseInt(String((($('avKm')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
  function _digits(id){ return parseInt(String((($(id)||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
  /* ===== v271 — A CONTA DO LOJISTA PARCEIRO =====
     oferta do parceiro − sua margem = o que entra na negociação com o cliente.
     A margem nasce em R$ 2.000 (o de sempre) e é editável — carro caro ou
     negócio apertado muda esse número.

     O resultado vai DIRETO pro "Valor avaliado", porque é ele que manda no
     resto da tela (diferença pra FIPE, repasse, mensagem do WhatsApp). E
     marca o campo como "digitado" pra conta automática da loja não passar por
     cima do número que veio do parceiro.

     Nada disso é público: são campos internos, não entram no pacote que vai
     pra página do lojista nem pro Portal do Repasse. */
  var AV_MARGEM_LOJISTA_PADRAO = MEV_AVALIACAO_MOTOR.margemRepassePadrao;
  function _mil0(n){ return 'R$ '+Math.round(Number(n)||0).toLocaleString('pt-BR'); }
  /* v705: "ligado" é REPASSE DIGITADO — o interruptor saiu; a flag escondida
     continua sendo escrita (o rascunho antigo e qualquer leitor seguem valendo) */
  /* v1068 — a decisão saiu daqui pro 07f: com o "flega" de volta na tela, é
     a CAIXA que manda (e o valor digitado continua mandando onde ela não
     existe). Ver o comentário grande no `_intRepLigado`. */
  function _avLojLigado(){ return _intRepLigado(); }
  function _avLojNum(id){ return parseInt(String((($(id)||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
  function avLojCalc(escrever){
    var box=$('avLojBox'), cx=$('avLojNeg');
    var on=_avLojLigado();
    try{ var _hid=$('avLojFlag'); if(_hid) _hid.value=on?'1':''; }catch(_){}   /* v705 */
    if(box) box.style.display=on?'':'none';
    if(!on){ if(cx){ cx.innerHTML=''; cx.className='avt-negoc'; } return; }
    var oferta=_avLojNum('avLojOferta');
    var marg=_avLojNum('avLojMargem');
    if(!marg && !String((($('avLojMargem')||{}).value)||'').trim()) marg=AV_MARGEM_LOJISTA_PADRAO;
    var neg=MEV_AVALIACAO_MOTOR.compraRepasse(oferta,marg);
    if(cx){
      if(!oferta){ cx.className='avt-negoc'; cx.innerHTML=''; }
      else{
        cx.className='avt-negoc on';
        cx.innerHTML='<span class="nl">Entra na negociação</span>'+
          /* v271: sem centavos na linha de baixo — com "R$ 80.000,00 − R$ 2.000,00"
             a frase quebrava em duas linhas e empurrava o título junto. */
          '<span class="nv">'+esc(r$(neg))+'<small>oferta '+esc(_mil0(oferta))+' − margem '+esc(_mil0(marg))+'</small></span>';
      }
    }
    /* escreve no Valor avaliado só quando a pessoa mexeu nestes campos */
    if(escrever && oferta){
      var vi=$('avValor');
      if(vi && document.activeElement!==vi){
        vi.value=r$(neg);
        valorTocado=true; var t=$('avValorT'); if(t) t.value='1';
        try{ _avDifFipePinta(); }catch(_){}
      }
    }
  }
  function avLojWire(){
    /* v1068 — rascunho de antes desta versão tem oferta e pode não ter a
       bandeira. Liga a bandeira ANTES de ler, senão a caixa nasce desmarcada
       e o bloco nasce fechado com o lojista interessado dentro, invisível. */
    try{ intRepMigra(); }catch(_){}
    var sw=$('avLojSw'), hid=$('avLojFlag');
    if(sw&&hid){
      sw.checked = (String(hid.value||'')==='1');
      sw.addEventListener('change', function(){
        hid.value=this.checked?'1':'';
        if(this.checked && !String((($('avLojMargem')||{}).value)||'').trim()){
          var m=$('avLojMargem'); if(m) m.value=r$(AV_MARGEM_LOJISTA_PADRAO);
        }
        try{ avFormSalvar(); }catch(_){}
        avLojCalc(true); try{ calcAvaliacao(); }catch(_){}
      });
    }
    ['avLojOferta','avLojMargem'].forEach(function(id){
      var e=$(id); if(!e) return;
      e.addEventListener('input', function(){
        avMaskRS.call(this);
        /* v705: a margem padrão entra quando o repasse começa a ser digitado */
        if(id==='avLojOferta' && _avLojNum('avLojOferta')>0 && !String((($('avLojMargem')||{}).value)||'').trim()){
          var m=$('avLojMargem'); if(m) m.value=r$(AV_MARGEM_LOJISTA_PADRAO);
        }
        avLojCalc(true); try{ avFormSalvar(); }catch(_){}
      });
    });
    /* v705 — o Avaliex (avaliado gerente): mora no registro do CARD
       (valor_avaliex — v695; o import do laudo já o preenche). Aqui ele é
       mostrado e editável; mudou → patch no card, local e nuvem, sem tocar
       no resto do registro. */
    (function(){
      var e=$('avAvaliex'); if(!e) return;
      var pl=String((veiculoAtual&&veiculoAtual.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      try{
        var cd=(typeof avlCardDe==='function')?(avlCardDe(pl)||{}):{};
        if(cd.valor_avaliex && !String(e.value||'').trim()) e.value=r$(cd.valor_avaliex);
      }catch(_){}
      e.addEventListener('input', function(){ avMaskRS.call(this); });
      e.addEventListener('change', function(){
        try{
          var n=parseInt(String(e.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
          _avlCard=_avlCard||{};
          var o=_avlCard[pl]||{};
          if(n>0) o.valor_avaliex=n; else delete o.valor_avaliex;
          o._ts=Date.now(); _avlCard[pl]=o;
          if(typeof _avlCardGravaLocal==='function') _avlCardGravaLocal();
          try{ docHistCloudSave('aval_card', pl, 'card', o, o._ts); }catch(_){}
        }catch(_){}
      });
    })();
    var eq=$('avLojQuem');
    if(eq) eq.addEventListener('input', function(){ try{ avFormSalvar(); }catch(_){} });
    avLojCalc(false);   /* ao abrir: só desenha o que já estava salvo */
  }

  /* ===== v268 (pedido) — A DIFERENÇA ENTRE A FIPE E O VALOR AVALIADO =====
     Mostra quanto o valor que a loja vai pagar está abaixo (ou acima) da tabela,
     em reais e em porcentagem. É a conta que o lojista faz de cabeça toda hora
     pra saber se está bem comprado.

     A porcentagem é sobre a FIPE, que é a referência: R$ 13.629 abaixo de uma
     FIPE de R$ 93.129 dá 14,6% — e é assim que se fala na loja ("comprei 15
     abaixo da tabela").

     Acompanha o campo AO VIVO: o valor avaliado é editável, então a linha
     recalcula tanto quando a conta roda sozinha quanto quando ele digita por
     cima. Verde = abaixo da tabela (bem comprado). Âmbar = acima — não é erro,
     acontece em carro raro ou muito novo, mas é bom aparecer. */
  function _avDifFipePinta(){
    var el=$('avDifFipe'); if(!el) return;
    var fipe=Math.round(Number((veiculoAtual&&veiculoAtual.fipe))||0);
    var val=parseInt(String((($('avValor')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
    if(!fipe || !val){ el.innerHTML=''; el.className='avt-difipe'; return; }
    var d=fipe-val, pct=fipe?(Math.abs(d)/fipe*100):0;
    var abaixo=d>0;
    var pctTxt=pct.toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1})+'%';
    if(Math.abs(d)<1){
      el.className='avt-difipe igual';
      el.innerHTML='<span class="dl">Diferença para a FIPE</span><span class="dv">na tabela</span>';
      return;
    }
    el.className='avt-difipe '+(abaixo?'abaixo':'acima');
    el.innerHTML='<span class="dl">Diferença para a FIPE</span>'+
      '<span class="dv">'+esc(r$(Math.abs(d)))+'<small>'+pctTxt+(abaixo?' abaixo':' acima')+' da tabela</small></span>';
  }

  /* ===== v267 (pedido) — GARANTIA DE FÁBRICA ZERA A MARGEM DE GARANTIA =====
     A margem de garantia existe pra cobrir o que a loja vai gastar cobrindo o
     carro depois de vendido. Se o carro AINDA ESTÁ NA GARANTIA DE FÁBRICA,
     quem cobre é a montadora — a loja não tem esse custo, e cobrar essa margem
     é tirar dinheiro do cliente por um risco que não existe.

     Isso já era feito, mas SÓ no momento em que se marcava "Tem" no campo da
     garantia. Quem abrisse de novo uma avaliação salva com "Tem" via a margem
     de volta em "3% · R$ 2.500", porque nada reconferia depois — o conserto
     dependia de um clique que já tinha acontecido ontem.

     Agora a regra olha o ESTADO, não o clique: toda vez que a conta roda, se a
     garantia é de fábrica a margem vai pra "Sem custo".

     RESPEITANDO A ESCOLHA DO LOJISTA: se, DEPOIS de marcar a garantia, ele
     escolher um percentual de propósito, a escolha dele manda e não é desfeita
     (é o mesmo combinado da v242 — o campo continua livre). Trocar o campo da
     garantia zera essa marca e a regra volta a valer. */
  var _mgTocado=false;

  /* ===== v562 — DIESEL JÁ NASCE COM R$ 15.000 DE MARGEM DE GARANTIA ========
   * Pedido do Angelo (18/08, com print da Hilux 3.0 TDI): *"veículos diesel
   * deixe por padrão uma margem de garantia de 15.000"*.
   *
   * POR QUE UM VALOR EM R$ E NÃO UM %: motor diesel quebra caro. Um turbo,
   * uma bomba injetora ou um bico não custam "5% do carro" — custam o que
   * custam, e num Hilux de R$ 120 mil os 5% do padrão dariam R$ 6.000, menos
   * da metade do risco real. Por isso o padrão do diesel entra pela opção
   * "Outro (digite em R$)", que é o campo que fala em dinheiro.
   *
   * 🔴 É PADRÃO, NÃO REGRA. Ele só entra quando NINGUÉM escolheu nada:
   *   · avaliação salva/rascunho manda mais (o `tinhaRascunho` abaixo);
   *   · se o lojista já mexeu no seletor (`_mgTocado`), não encosta;
   *   · se já existe valor digitado no campo, não encosta.
   * É a mesma lição da v557: campo que outros caminhos legítimos escrevem
   * não se preenche por cima.
   *
   * ⚠️ A GARANTIA DE FÁBRICA CONTINUA MANDANDO MAIS. Num diesel novo ainda
   * na garantia, o `_mgSincronizaGarantia` logo abaixo zera a margem — quem
   * paga o turbo ali é a fábrica, não a loja. É a precedência certa.
   * ⛳ AV_GAR_DIESEL = 0 desliga o padrão numa linha. */
  var AV_GAR_DIESEL = 15000;

  /* "é diesel?" — usa o MESMO classificador do 14b (o que preenche o
     combustível no cadastro), pra não existirem duas opiniões no app sobre
     o que é diesel. Ele já sabe ler TDI, CRDi, MWM e turbodiesel do nome da
     versão, e põe híbrido/elétrico na frente do diesel de propósito.
     ⚠️ Se o 14b sair do build, o `typeof` cai num plano B com a mesma régua. */
  function _avEhDiesel(v){
    v = v || (typeof veiculoAtual!=='undefined' ? veiculoAtual : null) || {};
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim();
    try{
      if(typeof _cpCombustivel==='function') return _cpCombustivel(nome, v.combustivel)==='Diesel';
    }catch(_){}
    var t=' '+String((v.combustivel||'')+' '+nome).toLowerCase()
      .replace(/[^a-z0-9]+/g,' ').trim()+' ';
    if(/ (hibrid|hybrid|mhev|phev|hev|eletric|electric|bev) /.test(t)) return false;
    return / (diesel|tdi|crdi|mwm|turbodiesel) /.test(t);
  }

  /* Roda UMA vez, logo depois de restaurar o rascunho. Devolve true se
     realmente pôs o padrão (o teste usa isso). */
  function _avGarDieselAplica(tinhaRascunho){
    if(!(AV_GAR_DIESEL>0)) return false;
    if(tinhaRascunho) return false;                    /* o que foi salvo manda */
    if(!_avEhDiesel()) return false;
    var s=$('avMg'), o=$('avMgOut'); if(!s||!o) return false;
    if(_mgTocado) return false;                        /* ele já escolheu */
    if(s.value==='outro' || String(o.value||'').trim()) return false;
    s.value='outro';
    o.value='R$ '+Number(AV_GAR_DIESEL).toLocaleString('pt-BR');
    return true;
  }

  function _mgSincronizaGarantia(){
    var g=$('avGarantia'), s=$('avMg');
    if(!g||!s) return;
    if(g.value!=='Tem') return;                 /* sem garantia de fábrica: nada a fazer */
    if(_mgTocado) return;                       /* ele escolheu um % de propósito */
    if(s.value==='0') return;                   /* já está em "Sem custo" */
    s.value='0';
    /* v562: vindo do padrão do diesel o seletor estava em "Outro" e o campo
       em R$ estava À MOSTRA. Trocar só o valor deixaria "Sem custo" no
       seletor com R$ 15.000 escritos embaixo — some com ele junto. */
    try{ var _mo=$('avMgOut'); if(_mo) _mo.style.display='none'; }catch(_){}
    try{ avFormSalvar(); }catch(_){}
  }
  /* rótulos das margens: "10% · R$ 9.239" (valor = % sobre a liquidez ajustada) */
  function atualizaMargemLabels(base){
    /* v242: na garantia de fábrica a margem COMEÇA em "Sem custo", mas o
       select fica LIVRE — dá pra escolher um % mesmo assim (pedido). */
    var _gfab=((($('avGarantia')||{}).value)==='Tem');
    ['avLucro','avMg'].forEach(function(id){ var s=$(id); if(!s||!s.options) return;
      if(id==='avMg'){ try{ s.disabled=false; s.classList.toggle('avmg-semcusto', s.value==='0'); }catch(_){} }
      Array.prototype.forEach.call(s.options,function(o){
        if(o.value==='0'){ o.textContent=_gfab?'Sem custo — garantia de fábrica':'Sem custo'; return; }
        if(!/^\d+$/.test(o.value)){ if(o.value==='outro') o.textContent='Outro (digite em R$)'; return; }
        /* 🔴 v620 — O RÓTULO PASSOU A CONTAR A VERDADE.
           Até aqui ele mostrava o percentual PURO: "10% · R$ 2.500" enquanto a
           avaliação já usava R$ 5.000 (o piso da v617 entrava na conta e não
           no texto). Agora o texto passa pelo MESMO piso do cálculo, e ganha
           o sufixo "(mínimo)" quando é o piso que está mandando — assim o
           número se explica sozinho, sem legenda em lugar nenhum. */
        var pct=parseInt(o.value,10)||0;
        var _v=_arr500((base||0)*pct/100);
        var _piso=(id==='avLucro')?avMinLucro():avMinGar();   /* v893 — moto tem piso próprio */
        var _vale=avPiso(_v, _piso, (id==='avLucro') ? true : !_gfab);
        o.textContent=pct+'% · R$ '+_vale.toLocaleString('pt-BR')+((_vale>_v)?' (mínimo)':'');   /* v253: sem ",00" pra não cortar no seletor */ });
    });
  }
  /* percentual da margem de garantia (aceita "outro" digitado)
     ⚠️ v562 — NÃO CHAME ESTA FUNÇÃO SEM CONSERTAR ANTES. Hoje ela não é
     usada por ninguém (conferido), e ainda bem: no caminho "outro" ela lê o
     campo em REAIS como se fosse porcentagem — "R$ 15.000" vira 15. Quem
     precisa do valor da margem usa o `_mgValor` / `_pctValor`, que devolve
     R$ de verdade. */
  function _mgPct(){ var s=$('avMg'); if(!s) return 0; if(s.value==='outro'){ return parseFloat(String((($('avMgOut')||{}).value)||'').replace(/[^0-9.,]/g,'').replace(',','.'))||0; } return parseInt(s.value,10)||0; }
  /* valor da margem de garantia em R$: opção % => % da liquidez ajustada; "outro" => valor digitado em R$ */
  function _mgValor(base){ return _pctValor('avMg', base); }
  /* valor em R$ de um select de % (aselPct): opção % => % da base; "outro" => R$ digitado */
  function _pctValor(id, base){ var s=$(id); if(!s) return 0; if(s.value==='outro'){ return parseInt(String((($(id+'Out')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; } var pct=parseInt(s.value,10)||0; return _arr500((base||0)*pct/100); }
  function avMaskKM(){ var n=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); this.value=n?Number(n).toLocaleString('pt-BR'):''; }
  /* liga os selects de custo (mostra "Outro", recalcula, salva) — reaproveitado ao trocar o porte */
  /* liga um select de % (aselPct) com opção "Outro (R$)": mostra/esconde e recalcula */
  function wirePctOutro(id){ var s=$(id), o=$(id+'Out'); if(!(s&&o)) return; var upd=function(){ o.style.display=(s.value==='outro')?'block':'none'; }; s.addEventListener('change',function(){ upd(); calcAvaliacao(); avFormSalvar(); }); o.addEventListener('input',function(){ avMaskRS.call(this); calcAvaliacao(); avFormSalvar(); }); upd(); }
  /* O valor de um serviço é parte do próprio campo de avaliação. Os inputs
     ocultos continuam sendo a fonte do cálculo e do rascunho, mas nunca são
     exibidos isoladamente abaixo do seletor. */
  function avServicoRotulo(id){
    if(!AV_SERV_MODAL[id]) return;
    var s=$(id), o=$(id+'Out'); if(!(s&&o)) return;
    var op=s.querySelector('option[value="outro"]'); if(!op) return;
    var vv=parseInt(String(o.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
    /* v262: rede de segurança — se o campo escondido do total ficou vazio por
       algum motivo, soma direto da lista de serviços guardada. Antes, nesse
       caso, o campo voltava a mostrar só "Serviços" e o valor sumia da vista. */
    if(!vv){
      try{
        var sj=$(id+'SvJ');
        var rows=(sj&&sj.value)?JSON.parse(sj.value):[];
        (rows||[]).forEach(function(r){ vv+=(parseInt(r&&r.v,10)||0); });
      }catch(_){}
    }
    /* v262: no campo aparece SÓ o valor total dos serviços (pedido). O que foi
       feito continua nas observações e no resumo — aqui vale o número. */
    op.textContent=vv>0 ? ('R$ '+vv.toLocaleString('pt-BR')) : 'Serviços';
  }
  function wireCustoItens(list){
    (list||[]).forEach(function(id){ var s=$(id), o=$(id+'Out'); if(!s) return;
      s.addEventListener('change',calcAvaliacao); s.addEventListener('change',avFormSalvar);
      var d=$(id+'Desc');
      /* v247: Elétrica/Câmbio/Suspensão/Embreagem não têm campo de descrição
         no HTML — ganham um hidden aqui pro modal (e o autosave) usarem. */
      if(o && !d && AV_SERV_MODAL[id]){
        d=document.createElement('input'); d.type='hidden'; d.id=id+'Desc';
        try{ o.parentNode.insertBefore(d, o); }catch(_){ d=null; }
      }
      if(o && d){
        /* ===== v247: SERVIÇOS AGORA ABREM UM MODAL (pedido) =====
           Escolheu "Serviços"/"Outro" → abre um modal com "qual serviço?" e o
           valor. Os inputs soltos continuam existindo ESCONDIDOS (são eles que
           o cálculo, o salvar e o resumo leem — só a forma de preencher mudou).
           O próprio campo passa a mostrar o valor ("Serviços · R$ 1.500") e a
           informação vai pras OBSERVAÇÕES (que aparecem na página do lojista). */
        d.style.display='none'; o.style.display='none';
        /* ===== v252: ATUALIZAR o serviço tocando no próprio campo (pedido) =====
           Problema: com "Serviços · R$ 500" já escolhido, re-escolher "Serviços"
           no seletor não dispara o evento change (o valor não mudou) — então o
           modal nunca reabria pra editar. Truque: ao FOCAR o campo já em
           "Serviços", a seleção é solta por um instante (selectedIndex=-1);
           assim QUALQUER escolha dispara change — inclusive "Serviços" de novo,
           que reabre o modal já preenchido pra atualizar descrição e valor.
           Se a pessoa fechar o seletor sem escolher nada, o blur restaura. */
        /* v262: o truque acontecia SÓ no 'focus'. No iPhone, com o app aberto
           em tela cheia, o seletor às vezes abre antes do focus disparar — aí
           "Serviços" continuava marcado, escolher de novo não gerava evento e
           o modal nunca reabria pra editar. Agora o mesmo reset vale também
           no toque (pointerdown/touchstart), que sempre vem antes do seletor. */
        function _svcSolta(){
          if(s.value==='outro'){ s.setAttribute('data-reidx', String(s.selectedIndex)); s.selectedIndex=-1; }
        }
        s.addEventListener('focus', _svcSolta);
        s.addEventListener('pointerdown', _svcSolta);
        s.addEventListener('touchstart', _svcSolta, {passive:true});
        s.addEventListener('mousedown', _svcSolta);
        s.addEventListener('blur',function(){
          var ri=s.getAttribute('data-reidx');
          if(s.selectedIndex===-1 && ri!==null){ s.selectedIndex=parseInt(ri,10)||0; }
          s.removeAttribute('data-reidx');
        });
        /* v253: VÁRIOS serviços por item (pedido) — a lista detalhada vive num
           hidden JSON (id+'SvJ'); o Desc guarda o resumo ("a + b") e o Out o
           TOTAL — cálculo, resumo e autosave continuam lendo os mesmos campos. */
        var sj=$(id+'SvJ');
        if(!sj){ sj=document.createElement('input'); sj.type='hidden'; sj.id=id+'SvJ'; try{ o.parentNode.insertBefore(sj, o); }catch(_){ sj=null; } }
        (function(){
          var prev=s.value;
          s.addEventListener('change',function(){
            s.removeAttribute('data-reidx');
            if(s.value!=='outro'){ prev=s.value; try{ avObsSincroniza(); }catch(_){} return; }
            var lista=null;
            try{ var j=JSON.parse((sj&&sj.value)||'null'); if(j&&j.length) lista=j; }catch(_){}
            if(!lista){ var vd=String(d.value||'').trim(), vv=parseInt(String(o.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; if(vd||vv) lista=[{d:vd,v:vv}]; }
            avServModal({
              id:id,
              titulo:(AV_LABELS[id]||'Serviço'),
              lista:lista,
              onOk:function(rows){
                rows=rows||[];
                var tot=0; rows.forEach(function(r2){ tot+=(parseInt(r2.v,10)||0); });
                d.value=rows.map(function(r2){ return String(r2.d||'').trim(); }).filter(Boolean).join(' + ');
                o.value=tot>0?('R$ '+tot.toLocaleString('pt-BR')):'';
                if(sj) sj.value=rows.length?JSON.stringify(rows):'';
                prev='outro'; avServicoRotulo(id);
                /* v253: reescreve as linhas geridas das observações a partir
                   do estado atual de TODOS os itens (só descrições, sem custo) */
                try{ avObsSincroniza(); }catch(_){}
                try{ calcAvaliacao(); }catch(_){} try{ avFormSalvar(); }catch(_){}
              },
              onCancel:function(){ s.value=prev; avServicoRotulo(id); try{ avObsSincroniza(); }catch(_){} try{ calcAvaliacao(); }catch(_){} try{ avPendMarca(); }catch(_){} }
            });
          });
        })();
        avServicoRotulo(id);
      } else if(o){ var upd=function(){ var mostra=(s.value==='outro'); o.style.display=mostra?'block':'none'; }; s.addEventListener('change',upd); upd();
        o.addEventListener('input',function(){ avMaskRS.call(this); calcAvaliacao(); avFormSalvar(); }); }
    });
  }
  /* v253: modal do serviço agora é uma LISTA (pedido: mais de um serviço por
     item). Cada linha tem descrição + valor + remover; "+ Adicionar outro
     serviço" cria mais uma. Salvar devolve as linhas preenchidas (onOk(rows)). */
  function avServModal(cfg){
    var ex=avServExemplo(cfg.id);
    var exServico=String(ex.servico||'serviço a avaliar');
    var exValor=Number(ex.valor)||0;
    var lista=(cfg.lista&&cfg.lista.length)?cfg.lista.map(function(r){ return { d:String(r.d||''), v:parseInt(r.v,10)||0 }; }):[{d:'',v:0}];
    var bg=document.createElement('div');
    bg.style.cssText='position:fixed;inset:0;z-index:100200;background:rgba(2,10,30,.55);display:flex;align-items:center;justify-content:center;padding:20px';
    bg.innerHTML='<div style="background:#fff;border-radius:18px;max-width:440px;width:100%;padding:20px 18px;box-shadow:0 18px 50px rgba(2,10,40,.35);max-height:86vh;overflow:auto">'+
      '<div style="font-weight:800;color:var(--titulo);font-size:16px;margin-bottom:12px">'+esc(cfg.titulo||'Serviço')+' — serviços</div>'+
      '<div id="avSvLista"></div>'+
      '<button type="button" id="avSvMais" class="cad-btn sec" style="margin-top:10px">+ Adicionar outro serviço</button>'+
      '<div style="display:flex;gap:10px;margin-top:16px">'+
        '<button type="button" id="avSvCanc" class="cad-btn sec" style="flex:1">Cancelar</button>'+
        '<button type="button" id="avSvOk" class="cad-btn" style="flex:1">Salvar</button>'+
      '</div></div>';
    document.body.appendChild(bg);
    var wrap=bg.querySelector('#avSvLista');
    function guarda(){
      var ds=wrap.querySelectorAll('.avsv-d'), vs=wrap.querySelectorAll('.avsv-v');
      for(var i=0;i<lista.length;i++){
        if(ds[i]) lista[i].d=String(ds[i].value||'').trim();
        if(vs[i]) lista[i].v=parseInt(String(vs[i].value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
      }
    }
    function pinta(){
      wrap.innerHTML=lista.map(function(r,i){
        /* v266: cada rótulo+campo dentro de .avt-col — é o mesmo molde do resto
           do formulário, o que faz o rotulinho pousar certo em cima da borda. */
        return '<div class="avsv-item">'+
          (lista.length>1?('<button type="button" class="avsv-x" data-i="'+i+'" aria-label="Remover serviço">&times;</button>'):'')+
          '<div class="avt-col"><div class="avt-lbl">Qual serviço?</div><input class="avt-in avsv-d" placeholder="Ex.: '+esc(exServico)+'" value="'+esc(r.d||'')+'"></div>'+
          '<div class="avt-col"><div class="avt-lbl">Valor (R$)</div><input class="avt-in avsv-v" inputmode="numeric" placeholder="'+esc(exValor?('Ex.: R$ '+exValor.toLocaleString('pt-BR')):'R$ 0')+'" value="'+(r.v>0?('R$ '+Number(r.v).toLocaleString('pt-BR')):'')+'"></div>'+
        '</div>';
      }).join('');
      Array.prototype.forEach.call(wrap.querySelectorAll('.avsv-v'),function(vi2){ vi2.addEventListener('input',avMaskRS); });
      Array.prototype.forEach.call(wrap.querySelectorAll('.avsv-x'),function(b){ b.onclick=function(){ guarda(); lista.splice(parseInt(b.getAttribute('data-i'),10)||0,1); if(!lista.length) lista.push({d:'',v:0}); pinta(); }; });
    }
    bg.querySelector('#avSvMais').onclick=function(){
      guarda(); lista.push({d:'',v:0}); pinta();
      setTimeout(function(){ var ds=wrap.querySelectorAll('.avsv-d'); var u=ds[ds.length-1]; if(u){ try{ u.focus(); }catch(_){} } },40);
    };
    function fecha(){ if(bg.parentNode) bg.parentNode.removeChild(bg); }
    function cancela(){ fecha(); if(cfg.onCancel) cfg.onCancel(); }
    bg.querySelector('#avSvCanc').onclick=cancela;
    bg.addEventListener('click',function(e){ if(e.target===bg) cancela(); });
    bg.querySelector('#avSvOk').onclick=function(){
      guarda();
      var rows=lista.filter(function(r){ return (r.d&&r.d.trim())||r.v>0; });
      fecha(); if(cfg.onOk) cfg.onOk(rows);
    };
    pinta();
    setTimeout(function(){ var d0=wrap.querySelector('.avsv-d'); if(d0){ try{ d0.focus(); }catch(_){} } },60);
  }
  /* Serviço pode aparecer ao lojista como contexto de estado, mas o custo
     é interno à loja avaliadora e não deve entrar em observações públicas. */
  function avObsServico(rotulo, desc, valor){
    var t=$('avObs'); if(!t) return;
    var linha=rotulo+': '+(String(desc||'').trim()||'serviço');
    var linhas=String(t.value||'').split('\n').filter(function(l){ return l.trim() && l.indexOf(rotulo+':')!==0; });
    linhas.push(linha);
    t.value=linhas.join('\n');
    try{ t.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
  }
  /* ===== v253: as OBSERVAÇÕES acompanham os ITENS (pedido) =====
     Reescreve TODAS as linhas geridas ("Mecânica: ...", "Lataria: ..." etc.)
     a partir do estado ATUAL dos selects: virou "Sem custo"/"Verificar", a
     linha daquele item SAI; mudou o serviço, a linha atualiza. O que você
     digitou à mão (linhas que não começam com um rótulo gerido) fica intacto.
     Linhas antigas com valor — "Mecânica: X (R$ 500)" — são regravadas sem
     o valor (custo é interno da loja). */
  /* v263: texto da opção escolhida SEM o valor entre parênteses.
     "Troca os 4 (R$ 3.000)" -> "Troca os 4" (v620). Devolve vazio quando a opção não
     tem custo ("Verificar", "Bons", "Novos", "Sem custo"...), porque aí não há
     nada pra contar pro lojista. */
  function _avOpcaoSemValor(s){
    if(!s) return '';
    var custo=parseInt(String(s.value||'').replace(/\D/g,''),10)||0;
    if(custo<=0) return '';
    var o=(s.options&&s.options[s.selectedIndex]);
    var t=String((o?(o.text||o.textContent):'')||'').trim();
    return t.replace(/\s*\([^()]*\)\s*$/,'').trim();
  }
  function avObsSincroniza(){
    var t=$('avObs'); if(!t) return;
    var chaves=Object.keys(AV_SERV_MODAL);
    var rotulos=chaves.map(function(k){ return (AV_LABELS[k]||k)+':'; });
    var livres=String(t.value||'').split('\n').filter(function(l){
      var lt=l.trim(); if(!lt) return false;
      return !rotulos.some(function(r){ return lt.indexOf(r)===0; });
    });
    chaves.forEach(function(k){
      var s=$(k); if(!s) return;
      var tx='';
      if(s.value==='outro'){
        try{ var j=JSON.parse((($(k+'SvJ')||{}).value)||'null'); if(j&&j.length) tx=j.map(function(r){ return String(r.d||'').trim(); }).filter(Boolean).join(' + '); }catch(_){}
        if(!tx) tx=String((($(k+'Desc')||{}).value)||'').trim();
      } else {
        /* v263 (pedido): o item marcado com um custo DA LISTA — por exemplo
           Pneus "Troca os 4 (R$ 3.000)" — também vira linha nas observações.
           Antes só os "Serviços" (o modal) apareciam, então quem escolhia da
           lista lançava o custo, via o desconto na conta e o lojista não ficava
           sabendo de nada. O VALOR não vai junto: custo é interno da loja. */
        tx=_avOpcaoSemValor(s);
      }
      if(tx) livres.push((AV_LABELS[k]||k)+': '+tx);
    });
    var novo=livres.join('\n');
    if(novo!==String(t.value||'')){
      t.value=novo;
      try{ t.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
    }
  }
  function atrelarAvaliacao(v){
    sugSel='loja'; valorTocado=false; liqTocado=false; repTocado=false; _mgTocado=false;
    _avCustoEd={}; _avCustoEdJson=''; _avCustoFoco=null;
    /* v176: este ouvinte é registrado ANTES de todos os outros, de propósito.
       O navegador executa os ouvintes na ordem em que foram criados — então,
       quando o cálculo rodar logo em seguida, ele já sabe se o campo foi
       digitado à mão (congela) ou se ficou vazio (volta a calcular sozinho). */
    var _lqEl0=$('avLiq');
    if(_lqEl0){
      _lqEl0.addEventListener('input',function(){
        liqTocado = !!String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
        var t=$('avLiqT'); if(t) t.value = liqTocado?'1':'';
        var box=$('avLiqCampo'); if(box) box.classList.toggle('avt-liq-ajustar',!liqTocado);
      });
      /* saiu do campo vazio? recalcula na hora (enquanto está digitando eu não
         escrevo por cima, senão o cursor pularia) */
      _lqEl0.addEventListener('blur',function(){ try{ calcAvaliacao(); }catch(_){} });
    }
    /* 🔴🔴 v617 — A ORDEM DOS OUVINTES DECIDIA QUEM GANHAVA.
       O "eu escolhi este % de propósito" (_mgTocado) era marcado por um
       ouvinte registrado LÁ EMBAIXO, depois destes. Ouvinte roda na ordem em
       que foi registrado: o `change` do avMg chamava o calcAvaliacao com o
       _mgTocado ainda FALSO, a sincronia da garantia de fábrica devolvia o
       seletor pra "Sem custo", e só DEPOIS a bandeira era levantada — tarde
       demais, o valor já tinha voltado pra zero.
       Efeito na loja: num carro NA GARANTIA DE FÁBRICA o lojista não
       conseguia escolher um percentual de margem — o seletor voltava sozinho
       toda vez, sem explicação.
       A bandeira agora sobe ANTES de qualquer ouvinte que recalcule.
       (Achado escrevendo o teste da v617, exatamente na exceção que o Angelo
       pediu: "exceto quando for garantia de fábrica".) */
    (function(){ var s=$('avMg'); if(s) s.addEventListener('change', function(){ _mgTocado=true; }); })();
    var ids=['avKm','avIpva','avLiq','avAc','avDir','avMg','avLucro','avChave'];
    ids.forEach(function(id){ var e=$(id); if(e){ e.addEventListener('input',calcAvaliacao); e.addEventListener('change',calcAvaliacao); } });
    wireCustoItens(_avCusto);
    /* seletor de porte da moto: re-renderiza os itens com os custos daquela faixa */
    var pSel=$('avPorte'); if(pSel){ pSel.addEventListener('change',function(){ _motoPorte=this.value||'med'; var box=$('avMotoItens'); if(box){ box.innerHTML=motoItensHtml(_motoPorte); wireCustoItens(_avCusto); } calcAvaliacao(); avFormSalvar(); }); }
    /* v241: mesmo ouvinte-espelho da liquidez/repasse, agora pro valor
       avaliado — digitou trava o seu número, apagou tudo volta a acompanhar
       a sugestão da loja. A máscara deixa no formato R$ 000.000. */
    var vi=$('avValor');
    if(vi){
      vi.addEventListener('input',function(){
        valorTocado = !!String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
        var t=$('avValorT'); if(t) t.value = valorTocado?'1':'';
      });
      vi.addEventListener('input',avMaskRS);
      /* v268: a diferença pra FIPE acompanha a digitação. Fica DEPOIS da
         máscara de propósito — assim ela lê o número já formatado, e não um
         estado intermediário. */
      vi.addEventListener('input',function(){ try{ _avDifFipePinta(); }catch(_){} });
      vi.addEventListener('blur',function(){ try{ calcAvaliacao(); }catch(_){} });
    }
    Array.prototype.forEach.call(document.querySelectorAll('#secoes [data-sug]'),function(b){
      b.addEventListener('click',function(){ Array.prototype.forEach.call(document.querySelectorAll('#secoes .avt-sug'),function(x){x.classList.remove('sel');}); b.classList.add('sel'); sugSel=b.getAttribute('data-sug'); valorTocado=false; calcAvaliacao(); });
    });
    var cbtn=document.querySelector('#secoes .avt-custos-btn'); if(cbtn) cbtn.addEventListener('click',function(){ $('avCustos').classList.toggle('open'); });
    var custosAbrir=$('avMercadoCustosBtn');if(custosAbrir)custosAbrir.addEventListener('click',function(){avMercadoCustosAbrir($('avMercadoCustos').hidden);$('avCustos').classList.add('open');});
    var custosResumo=$('avCotCustosBt');if(custosResumo)custosResumo.addEventListener('click',function(){avCustosFolhaAbrir(custosResumo);});
    [['avVendaLojista','avVendaLojistaT'],['avVendaVarejo','avVendaVarejoT']].forEach(function(par){
      var campo=$(par[0]),tocou=$(par[1]);if(!campo||!tocou)return;
      campo.addEventListener('input',function(){avMaskRS.call(campo);tocou.value=String(campo.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'')?'1':'';});
      campo.addEventListener('blur',function(){try{calcAvaliacao();}catch(_){}});
    });
    pintaAvalMercado();
    avGastosWire();
    avGastosPinta();
    try{ avOpcPinta(); }catch(_){}   /* v1065 */
    AV_FIELDS.forEach(function(id){ var e=$(id); if(e){ e.addEventListener('input',avFormSalvar); e.addEventListener('change',avFormSalvar); } });
    /* v379: além do 'input', o campo se arruma também no 'change' e ao SAIR
       dele. Assim, se algum caminho escrever a quilometragem já formatada de
       outro jeito, o campo volta pro padrão 80.000 antes de virar resumo. */
    (function(){ var pb=$('avPedirBt');
      if(pb){ if(PEDIR_INFO_ON) pb.onclick=avPedirAbrir; else pb.style.display='none'; } })();
    var kmEl=$('avKm'); if(kmEl){ kmEl.addEventListener('input',avMaskKM); kmEl.addEventListener('input',atualizaBusca); kmEl.addEventListener('change',avMaskKM); kmEl.addEventListener('blur',avMaskKM); kmEl.addEventListener('change',pintaAvalMercado); }
    var liqEl=$('avLiq'); if(liqEl) liqEl.addEventListener('input',avMaskRS);
    wirePctOutro('avMg'); wirePctOutro('avLucro');
    try{ avLojWire(); }catch(_){}   /* v271 */
    (function(){ var pb=$('avalPdfBt'); if(pb) pb.onclick=function(){ avComercialPdf('lojista'); }; })();
    /* v267: escolha manual da margem de garantia manda mais que a regra
       (o ouvinte do avMg subiu pra antes do wirePctOutro na v617 — ver a nota lá) */
    (function(){ var g=$('avGarantia'); if(g) g.addEventListener('change', function(){ _mgTocado=false; }); })();
    /* v242: o select da margem de garantia ganha uma opção fixa "Sem custo"
       (valor 0). É ela que entra sozinha quando o carro está na garantia de
       fábrica — mas o lojista pode abrir e escolher um % mesmo assim. */
    (function(){ var s=$('avMg'); if(s && !Array.prototype.some.call(s.options,function(o){ return o.value==='0'; })){ var o=document.createElement('option'); o.value='0'; o.textContent='Sem custo'; s.insertBefore(o, s.firstChild); } })();
    /* v562: o padrão do diesel entra AQUI — depois de restaurar, pra nunca
       escrever por cima de uma avaliação que já existia. */
    var _tinhaRasc = avFormRestaurar();
    try{ _avGarDieselAplica(_tinhaRasc); }catch(_){}
    _avCusto.forEach(avServicoRotulo);
    /* v176: o rascunho guarda se a liquidez tinha sido digitada à mão */
    try{ var _lqt=$('avLiqT'); liqTocado = !!(_lqt && _lqt.value); }catch(_){}
    try{ var _liqBox=$('avLiqCampo'); if(_liqBox) _liqBox.classList.toggle('avt-liq-ajustar',!liqTocado); }catch(_){}
    /* v178: e o rascunho guarda também se o preço do repasse foi digitado */
    try{ var _rpt=$('avRepT'); repTocado = !!(_rpt && _rpt.value); }catch(_){}
    try{ var _vlt=$('avValorT'); valorTocado = !!(_vlt && _vlt.value); }catch(_){}
    /* moto: se o porte foi lembrado diferente do detectado, re-renderiza os custos daquela faixa */
    if(_ehMoto){ var ps=$('avPorte'); if(ps&&ps.value&&ps.value!==_motoPorte){ _motoPorte=ps.value; var mbox=$('avMotoItens'); if(mbox){ mbox.innerHTML=motoItensHtml(_motoPorte); wireCustoItens(_avCusto); avFormRestaurar(); } } }
    if(kmEl) avMaskKM.call(kmEl);
    var prEl=$('avProxRev'); if(prEl){ prEl.addEventListener('input',avMaskKM); avMaskKM.call(prEl); }
    if(liqEl) avMaskRS.call(liqEl);
    _avCusto.concat(['avMg','avLucro']).forEach(function(id){ var s=$(id), o=$(id+'Out'); if(s&&o) o.style.display=(s.value==='outro' && !AV_SERV_MODAL[id])?'block':'none'; });
    atualizaBusca();
    calcAvaliacao();
    try{ avEspelhoAplicar(); }catch(_){}   /* v184 — traz o que veio do estoque */
    try{ avVistoriaWire(); }catch(_){}     /* v924 — os grupos da vistoria (07c) */
    try{ avJevWire(); }catch(_){}          /* v1450 — análise consultiva com JEV */
    /* v946: só agora, com rascunho/espelho/quilometragem restaurados, começa
       a preparação silenciosa da ficha técnica e do mercado. */
    /* Ficha tecnica e mercado so sao gerados pelo botao de cada etapa. */
  }
  /* ===== v181: CUSTOS IDENTIFICADOS EDITAVEIS =====
     Cada linha de custo virou um campo. O numero que a conta sugere ja vem
     escrito dentro dele; se voce digitar por cima, AQUELA linha trava no seu
     valor (ganha a marquinha "seu valor" e um botao ↺ pra voltar ao calculado).
     O total e a sugestao "Loja" saem sempre da SOMA DO QUE ESTA NA TELA — por
     isso o que voce le e o que a conta usa nunca podem discordar. */
  var _avCustoEd={};       /* chave -> valor digitado por voce (sobrepoe o calculado) */
  var _avCustoEdJson='';   /* ultimo JSON que NOS mesmos escrevemos no campo escondido */
  var _avCustoFoco=null;   /* chave da linha com o cursor dentro: nao redesenho por cima de quem digita */
  function _avCustoEdSync(){
    var h=$('avCustoEdJ'); if(!h) return;
    if(h.value===_avCustoEdJson) return;   /* nada mudou */
    _avCustoEdJson=h.value;                /* mudou sem ser por nos = acabou de ser restaurado */
    var o=null; try{ o=JSON.parse(h.value||'{}'); }catch(_){ o=null; }
    _avCustoEd={};
    if(o) Object.keys(o).forEach(function(k){ var n=parseInt(o[k],10); if(!isNaN(n)&&n>=0) _avCustoEd[k]=n; });
  }
  function _avCustoEdGrava(){
    _avCustoEdJson=JSON.stringify(_avCustoEd);
    var h=$('avCustoEdJ'); if(h) h.value=_avCustoEdJson;
    try{ avFormSalvar(); }catch(_){}
  }
  /* v240: percentuais ajustáveis — impostos (% da FIPE) e comissão do vendedor.
     Guardados no aparelho (mev_av_pcts) e aplicados em toda avaliação nova.
     Carro e moto têm comissões separadas (1% e 2% de fábrica). */
  function _avPcts(){
    var p=MEV_AVALIACAO_MOTOR.preferencias();
    try{ var o=JSON.parse(localStorage.getItem('mev_av_pcts')||'null');
      if(o){ ['imp','comCarro','comMoto','lucroCarro','lucroMoto','garantia'].forEach(function(k){ var n=parseFloat(o[k]); if(isFinite(n)&&n>=0&&n<=90) p[k]=n; }); }
    }catch(_){}
    return p;
  }
  function _avPctsSalvar(p){ try{ localStorage.setItem('mev_av_pcts', JSON.stringify(p)); }catch(_){} }
  /* v242: o percentual agora se edita NA PROPRIA LINHA do custo (pedido).
     Estes ajudantes dizem qual % vale hoje e gravam a mudanca no select
     correspondente (lucro/garantia) e no padrao salvo. */
  var _AVC_PCT={ imp:1, com:1, lucro:1, garantia:1 };
  function _poeNoSelect(id, n){ var sel=$(id); if(!sel) return; n=Math.round(n);
    var tem=false; Array.prototype.forEach.call(sel.options,function(o){ if(String(o.value)===String(n)) tem=true; });
    if(!tem){ var op=document.createElement('option'); op.value=String(n); op.textContent=n+'%';
      var ou=null; Array.prototype.forEach.call(sel.options,function(o){ if(o.value==='outro') ou=o; });
      sel.insertBefore(op, ou); }
    sel.value=String(n); }
  function _avcPctAtual(k){ try{ var p=_avPcts();
      if(k==='imp') return p.imp;
      if(k==='com') return _ehMoto?p.comMoto:p.comCarro;
      if(k==='lucro'){ var s2=$('avLucro'); if(s2&&/^\d+$/.test(s2.value)) return parseInt(s2.value,10); return _ehMoto?p.lucroMoto:p.lucroCarro; }
      if(k==='garantia'){ var g2=$('avMg'); if(g2&&/^\d+$/.test(g2.value)) return parseInt(g2.value,10); return p.garantia; }
    }catch(_){ } return 0; }
  function _pctBr(n){ n=Number(n)||0; return String(Math.abs(n-Math.round(n))<1e-9?Math.round(n):n).replace('.',','); }
  function _avCustoLinhaHtml(L){
    var k=L[0], ed=(_avCustoEd[k]!=null);
    return '<div class="avt-custos-row'+(ed?' ed':'')+'">'+
      '<span class="avc-l">'+esc(L[1])+(ed?'<i class="avc-tag">seu valor</i>':'')+'</span>'+
      (_AVC_PCT[k]?('<span class="avc-pct"><input type="text" class="avc-pin" inputmode="decimal" data-p="'+esc(k)+'" value="'+esc(_pctBr(_avcPctAtual(k)))+'">%</span>'):'')+
      '<span class="avc-r"><b>−</b>'+
        '<input type="text" class="avc-in" inputmode="numeric" data-k="'+esc(k)+'" value="'+esc(r$(L[3]))+'">'+
        (ed?('<button type="button" class="avc-x" data-k="'+esc(k)+'" title="voltar ao valor calculado">↺</button>'):'')+
      '</span>'+
    '</div>';
  }
  function _avCustoWire(){
    var body=$('avCustosBody'); if(!body) return;
    Array.prototype.forEach.call(body.querySelectorAll('.avc-in'),function(inp){
      inp.onfocus=function(){ _avCustoFoco=this.getAttribute('data-k'); };
      inp.oninput=function(){
        avMaskRS.call(this);
        var k=this.getAttribute('data-k'),n=parseInt(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10);
        if(/^gasto\d+$/.test(k)){
          var gastos=avGastosLer(),indice=Number(k.slice(5));
          if(gastos[indice]){gastos[indice].valor=isNaN(n)?0:n;var h=$('avGastosJ');if(h)h.value=JSON.stringify(gastos);avGastosResumo();}
          delete _avCustoEd[k];
        }else _avCustoEd[k]=(k==='rev'||k==='com')?Math.min(1000,Math.max(0,isNaN(n)?0:n)):(isNaN(n)?0:n);
        try{ calcAvaliacao(); }catch(_){}
      };
      inp.onblur=function(){ _avCustoFoco=null; _avCustoEdGrava(); try{ calcAvaliacao(); }catch(_){} };
    });
    /* v242: % editavel na linha — grava no padrao salvo e recalcula na hora */
    Array.prototype.forEach.call(body.querySelectorAll('.avc-pin'),function(inp){
      inp.onfocus=function(){ _avCustoFoco='pct:'+this.getAttribute('data-p'); };
      inp.oninput=function(){
        var k=this.getAttribute('data-p');
        var n=parseFloat(String(this.value||'').replace(',','.'));
        if(!isFinite(n)||n<0||n>90) return;
        var p=_avPcts();
        if(k==='imp') p.imp=n;
        else if(k==='com'){ if(_ehMoto) p.comMoto=n; else p.comCarro=n; }
        else if(k==='lucro'){ var l2=Math.round(n); if(_ehMoto) p.lucroMoto=l2; else p.lucroCarro=l2; _poeNoSelect('avLucro',l2); }
        else if(k==='garantia'){ var g3=Math.round(n); p.garantia=g3; _poeNoSelect('avMg',g3); }
        _avPctsSalvar(p);
        try{ avFormSalvar(); }catch(_){}
        try{ calcAvaliacao(); }catch(_){}
      };
      inp.onblur=function(){ _avCustoFoco=null; try{ calcAvaliacao(); }catch(_){} };
    });
    Array.prototype.forEach.call(body.querySelectorAll('.avc-x'),function(b){
      b.onclick=function(){ delete _avCustoEd[this.getAttribute('data-k')]; _avCustoFoco=null; _avCustoEdGrava(); try{ calcAvaliacao(); }catch(_){} };
    });
  }
  /* Adaptador da tela: lê escolhas, mantém migração de rascunhos e renderiza.
     Todas as fórmulas pertencem ao mesmo módulo exigido pelo backend. */
  function avMotorEntrada(){
    function escolha(id){ var s=$(id); return s&&s.value==='outro'
      ? {valor:_digits(id+'Out')} : {percentual:parseInt(s&&s.value,10)||0}; }
    var ficha={};
    try{ ficha=(typeof fichaVendeDe==='function')?(fichaVendeDe((veiculoAtual&&veiculoAtual.placa)||'')||{}):{}; }catch(_){ ficha={}; }
    var itens=avGastosLer().map(function(g,i){return {id:'gasto'+i,rotulo:g.descricao.trim()||'Gasto '+(i+1),valor:g.valor};});
    if(!$('avGastosJ')) _avCusto.forEach(function(id){
      var valor=_custo(id), rotulo=AV_LABELS[id]||id;
      var desc=String((($(id+'Desc')||{}).value)||'').trim();
      if(desc) rotulo+=' — '+desc;
      if(valor>0) itens.push({id:id,rotulo:rotulo,valor:valor});
    });
    return {fipe:Number(veiculoAtual&&veiculoAtual.fipe)||0,
      ano:Number(veiculoAtual&&(veiculoAtual.ano_modelo||veiculoAtual.ano))||0,
      anoFabricacao:Number(veiculoAtual&&(veiculoAtual.ano_fab||veiculoAtual.ano||veiculoAtual.ano_modelo))||0,
      anoAtual:new Date().getFullYear(),km:_km(),moto:_ehMoto,
      /* v1230 — era (($('avAc')||{}).value), o select que a v1079 escondeu e
         que responde "Verificar" pra sempre. A resposta mora nos Opcionais. */
      semAr:MEV_AVALIACAO_MOTOR.semArNosOpcionais(avOpcLer().m),
      semDir:MEV_AVALIACAO_MOTOR.semDirecaoNosOpcionais(avOpcLer().m),
      semTetoSolar:!_ehMoto&&MEV_AVALIACAO_MOTOR.tetoSolarAusente(
        ficha.opcionais_todos, ficha.opcionais_marcados||ficha.opcionais),
      liquidezManual:liqTocado?_digits('avLiq'):null,
      preferencias:_avPcts(),lucro:escolha('avLucro'),garantia:escolha('avMg'),
      garantiaFabrica:(($('avGarantia')||{}).value)==='Tem',
      garantiaEditada:_mgTocado,itens:itens,chave:_n('avChave'),edicoes:_avCustoEd};
  }
  function avJevDados(){
    var entrada=avMotorEntrada(), resultado=MEV_AVALIACAO_MOTOR.calcular(entrada);
    var faixa=avMercadoFaixa();
    return {fipe:entrada.fipe,liquidez:resultado.liquidez.valor,mercado_min:faixa?faixa.min:0,
      mercado_max:faixa?faixa.max:0,mercado_pesquisado:faixa?1:0,mercado_amostra:faixa?faixa.amostra:0,
      custos:resultado.custos,avaliacao_sugerida:resultado.loja,
      km:entrada.km,km_ano:resultado.liquidez.media,idade_meses:resultado.liquidez.idadeMeses||0,
      ano_fabricacao:entrada.anoFabricacao,ano_modelo:entrada.ano};
  }
  function avJevAssinatura(d){
    return ['fipe','liquidez','mercado_min','mercado_max','mercado_pesquisado','mercado_amostra','custos','avaliacao_sugerida','km','km_ano','idade_meses','ano_fabricacao','ano_modelo'].map(function(k){return Number(d[k])||0;}).join('|');
  }
  function avJevLer(){
    try{var h=$('avJevJ'),j=JSON.parse((h&&h.value)||'null');return j&&typeof j==='object'?j:null;}catch(_){return null;}
  }
  function avJevPinta(){
    var box=$('avJevResultado'); if(!box) return;
    var j=avJevLer();
    if(!j){box.innerHTML='<p class="av-jev-vazio">Faça a análise depois de preencher os dados do veículo e os gastos previstos.</p>';return;}
    var atual='';try{atual=avJevAssinatura(avJevDados());}catch(_){}
    var antiga=!!(j.assinatura&&atual&&j.assinatura!==atual);
    box.innerHTML=(antiga?'<div class="av-jev-alerta">Os dados mudaram. Analise novamente antes de usar esta recomendação.</div>':'')+
      '<div class="av-jev-grid">'+
        '<div class="av-jev-preco"><span>Preço de liquidez sugerido</span><strong>'+r$(Number(j.preco_liquidez)||0)+'</strong></div>'+
        (Number(j.preco_compra)>0?'<div class="av-jev-compra"><span>Preço de compra sugerido</span><strong>'+r$(Number(j.preco_compra))+'</strong></div>':'')+
        '<div><span>Destino recomendado</span><strong>'+esc(j.destino||'—')+'</strong></div>'+
        '<div><span>Risco comercial</span><strong>'+esc(j.risco||'—')+'</strong></div>'+
        '<div><span>Confiança</span><strong>'+Math.max(0,Math.min(100,Number(j.confianca)||0))+'%</strong></div>'+
      '</div>'+(j.revisao_manual?'<div class="av-jev-alerta">Revisão manual recomendada antes de decidir.</div>':'');
  }
  async function avJevAnalisar(){
    var bt=$('avJevBtn'),tx=$('avJevBtnTexto'),box=$('avJevResultado'); if(!bt||!box)return;
    var dados=avJevDados();
    if(!(dados.fipe>0&&dados.liquidez>0&&dados.mercado_min>0)){box.innerHTML='<div class="av-jev-erro">Preencha FIPE, liquidez e faixa de mercado antes de analisar.</div>';return;}
    bt.disabled=true;bt.classList.add('mk-gerando');if(tx)tx.textContent='Analisando…';
    box.innerHTML='<div class="av-jev-carregando" role="status">Comparando mercado, rodagem, custos e risco…</div>';
    try{
      var r=await fetch('/api/jev-avaliacao',{method:'POST',headers:{'Content-Type':'application/json',Authorization:'Bearer '+String(token||'')},body:JSON.stringify({token:token,dados:dados})});
      var j={};try{j=await r.json();}catch(_){}
      if(!r.ok||!j.ok||!j.resultado) throw new Error(j.erro||'Não foi possível concluir a análise.');
      j.resultado.assinatura=avJevAssinatura(dados);
      var h=$('avJevJ');if(h)h.value=JSON.stringify(j.resultado);
      avFormSalvar();avJevPinta();
    }catch(e){box.innerHTML='<div class="av-jev-erro">'+esc(e&&e.message||'Não foi possível concluir a análise.')+' <button type="button" id="avJevTentar">Tentar de novo</button></div>';var rb=$('avJevTentar');if(rb)rb.onclick=avJevAnalisar;}
    finally{bt.disabled=false;bt.classList.remove('mk-gerando');if(tx)tx.textContent=avJevLer()?'Analisar novamente':'Analisar com JEV';}
  }
  function avJevWire(){
    var bt=$('avJevBtn');if(bt)bt.onclick=avJevAnalisar;
    avJevPinta();
    ['avKm','avLiq','avGastosJ','avCustoEdJ','avMg','avLucro','avChave'].forEach(function(id){var e=$(id);if(e){e.addEventListener('input',avJevPinta);e.addEventListener('change',avJevPinta);}});
    var tx=$('avJevBtnTexto');if(tx&&avJevLer())tx.textContent='Analisar novamente';
  }
  function avKmNaFaixa(km,min,max){
    km=Number(km)||0; min=Number(min)||0; max=Number(max)||0;
    return km>0&&min>0&&max>=min&&km>=min&&km<=max;
  }
  function calcAvaliacao(){
    try{ _mgSincronizaGarantia(); }catch(_){}
    _avCustoEdSync();
    /* Migração existente: higienização + polimento -> preparação. */
    if(_avCustoEd && (_avCustoEd.hig!=null || _avCustoEd.pol!=null)){
      if(_avCustoEd.prep==null) _avCustoEd.prep=(Number(_avCustoEd.hig)||0)+(Number(_avCustoEd.pol)||0);
      delete _avCustoEd.hig; delete _avCustoEd.pol;
      try{ _avCustoEdGrava(); }catch(_){}
    }
    var entrada=avMotorEntrada(), resultado=MEV_AVALIACAO_MOTOR.calcular(entrada);
    var fipe=entrada.fipe, liqAj=resultado.liquidez.valor, med=resultado.liquidez.media;
    var idadeMeses=resultado.liquidez.idadeMeses||0;
    var idealMin=resultado.liquidez.idealMin||0, idealMax=resultado.liquidez.idealMax||0;
    var nFaixas=resultado.liquidez.faixas, loja=resultado.loja, repasse=resultado.repasse;
    var custosIdent=resultado.custos, _linhas=resultado.linhas, el;
    var ma=$('avMediaAtual'), mb=$('avMedia');
    if(mb){
      if(idadeMeses&&idealMax){
        var kmAtual=entrada.km||0, dentro=avKmNaFaixa(kmAtual,idealMin,idealMax), alto=kmAtual>idealMax;
        var baixo=kmAtual>0&&kmAtual<idealMin, estadoKm=baixo?'Quilometragem abaixo da média ideal.':(alto?'Quilometragem acima da média ideal.':(dentro?'Quilometragem dentro da média ideal.':''));
        var mediaAtual=kmAtual&&med?'Média do veículo: ~'+med.toLocaleString('pt-BR')+' km/ano · '+idadeMeses+' meses estimados':'';
        var faixaKm='Média KM esperada: '+idealMin.toLocaleString('pt-BR')+' a '+idealMax.toLocaleString('pt-BR')+' km';
        /* v1484: a média anual real volta em um cartão próprio. A faixa
           esperada permanece separada e classifica a rodagem informada. */
        if(ma){
          ma.style.display=mediaAtual?'block':'none';
          ma.textContent=mediaAtual;
        }
        mb.style.display='block'; mb.className='avt-media'+(baixo?' baixo':(alto?' alto':(dentro?' dentro':'')));
        mb.innerHTML='<span>'+faixaKm+'</span>'+(estadoKm?'<strong>'+estadoKm+'</strong>':'');
        mb.setAttribute('aria-label',(mediaAtual?mediaAtual+' ':'')+faixaKm+(estadoKm?' '+estadoKm:''));
      } else {
        if(ma){ ma.style.display='none'; ma.textContent=''; }
        mb.style.display='none'; mb.textContent=''; mb.removeAttribute('aria-label');
      }
    }
    var _liqEl=$('avLiq'), _e2=$('avLiq3');
    if(!liqTocado && _liqEl && document.activeElement!==_liqEl) _liqEl.value=liqAj?r$(liqAj):'';
    if(_e2 && document.activeElement!==_e2) _e2.value=(_liqEl&&_liqEl.value)?_liqEl.value:(liqAj?r$(liqAj):'');
    atualizaMargemLabels(liqAj);
    if(el=$('avCustosTot')) el.textContent='−'+r$(custosIdent);
    if((el=$('avCustosBody')) && !_avCustoFoco){
      var _vis=_linhas.filter(function(L){ return L[3]>0 || _avCustoEd[L[0]]!=null; });
      el.innerHTML = _vis.length ? _vis.map(_avCustoLinhaHtml).join('') : '<div class="avt-custos-row" style="border:none;color:#94a3b8"><span>Nenhum custo marcado</span></div>';
      _avCustoWire();
    }
    /* Sugestões */
    function pct(val){ if(!fipe) return ''; var d=val-fipe, p=d/fipe*100; return (d>=0?'+':'−')+r$(Math.abs(d))+' · '+(p>=0?'+':'−')+Math.abs(p).toFixed(1)+'% vs FIPE'; }
    if(el=$('avSugLoja')) el.textContent=r$(loja);
    if(el=$('avSugLojaP')) el.textContent=pct(loja);
    if(el=$('avSugRep')) el.textContent=r$(repasse);
    if(el=$('avSugRepP')) el.textContent=pct(repasse);
    /* v182: a etapa "Cotacao loja" repete os tres numeros que mandam na conta */
    if(el=$('avCotFipe')) el.textContent=r$(fipe);
    if(el=$('avCotCustos')) el.textContent='-'+r$(custosIdent);
    /* v242: resumo do que foi lançado — km, dados conferidos e serviços
       marcados (com a descrição), pra bater o olho antes de enviar. */
    if(el=$('avRepResumo')){
      var _rs2=[];
      var _selTx2=function(id){ var e2=$(id); if(!e2) return ''; var o2=(e2.selectedOptions&&e2.selectedOptions[0]); var t2=String((o2?o2.textContent:e2.value)||'').trim(); return (!t2||/^verificar$/i.test(t2)||/a conferir|a definir/i.test(t2))?'':t2; };   /* v266: "Verificar" também é campo sem resposta */
      /* v379: o resumo FORMATA o número em vez de repetir o texto cru do campo.
         Antes ele copiava letra por letra o que estivesse escrito em #avKm — se
         o campo ficasse com o ponto fora do lugar ("8.0000"), o resumo repetia
         o erro. Agora só os dígitos viajam e a formatação é feita aqui. */
      var _kmD=String((($('avKm')||{}).value)||'').replace(/\D/g,'').replace(/^0+(?=\d)/,'');
      if(_kmD) _rs2.push(['Quilometragem',Number(_kmD).toLocaleString('pt-BR')+' km']);
      var _ip2=_selTx2('avIpva'); if(_ip2) _rs2.push(['IPVA',_ip2]);
      if(_selTx2('avMultas')==='Sim') _rs2.push(['Multas','Sim']);
      if(_selTx2('avAlien')==='Sim'){ var _aq=_selTx2('avAlienQuem'), _avv=String((($('avAlienValor')||{}).value)||'').trim(); _rs2.push(['Alienado','Sim'+(_aq?(' · '+_aq):'')+(_avv?(' · quitação '+_avv):'')]); }
      [['avChave','Chave reserva'],['avManual','Manual'],['avRevC','Revisões concessionária'],['avDonos','Donos']].forEach(function(pp){ var t3=_selTx2(pp[0]); if(t3){ if(pp[0]==='avRevC'){ var k3=String((($('avRevCKm')||{}).value)||'').replace(/\D/g,''); if(k3) t3+=' · até '+Number(k3).toLocaleString('pt-BR')+' km'; } _rs2.push([pp[1],t3]); } });
      var _gf2=_selTx2('avGarantia'); if(_gf2){ var _ga2=String((($('avGarantiaAte')||{}).value)||'').trim(); _rs2.push(['Garantia de fábrica',_gf2+((_gf2==='Tem'&&_ga2)?(' até '+_ga2):'')]); }
      _linhas.forEach(function(L){ if(L[3]>0 && ['imp','com','lucro','garantia','prep','chave'].indexOf(L[0])<0) _rs2.push([L[1],'−'+r$(L[3])]); });
      /* v243: o que ficou "Verificar" (sem inspeção) aparece no resumo */
      _avCusto.forEach(function(id2){ var e3=$(id2); if(e3&&e3.value==='verificar') _rs2.push([AV_LABELS[id2]||id2,'verificar']); });
      [['avAc','Ar-condicionado'],['avDir','Direção']].forEach(function(pp2){ var e4=$(pp2[0]); if(e4&&e4.value==='Verificar') _rs2.push([pp2[1],'verificar']); });
      el.innerHTML = _rs2.length ? _rs2.map(function(p2){ return '<div class="avr-row"><span>'+esc(p2[0])+'</span><b>'+esc(p2[1])+'</b></div>'; }).join('') : '<div class="avr-row" style="color:#94a3b8;border:none"><span>Nada lançado ainda.</span></div>';
    }
    /* Liquidez e faixa de mercado têm fontes independentes. Recalcular custos
       ou editar a liquidez nunca reescreve o resultado salvo da pesquisa. */
    avMercadoFaixaPinta();
    /* =====================================================================
       v557 — O VALOR AVALIADO NASCE VAZIO (pedido do Angelo)

       ATÉ AQUI o campo vinha PREENCHIDO com a sugestão da loja ("quanto
       pagar no veículo") e se reescrevia a cada recálculo, enquanto
       ninguém tivesse digitado nele (v241).

       🔴 POR QUE ISSO ERA RUIM: este campo é a DECISÃO. É ele que vira o
       `avaliado` gravado — o número que aparece na lista de avaliações, no
       card, e que entra como entrada na troca da venda. Nascendo
       preenchido, uma avaliação salva sem ninguém olhar registra um valor
       que a pessoa nunca escolheu: na prática o app decidia quanto a loja
       paga no carro.

       ⚠️ E A SUGESTÃO NÃO SE PERDE: ela continua no cartão "Loja · quanto
       pagar no veículo" (#avSugLoja), logo acima, atualizando a cada
       recálculo. Ela vira o que sempre deveria ter sido — referência ao
       lado, não resposta pronta dentro do campo.

       ⚠️ OS OUTROS CAMINHOS QUE ESCREVEM AQUI CONTINUAM, porque neles o
       número veio de ALGUÉM, não de um cálculo: o espelho
       avaliação↔estoque (v184 — valor digitado noutra tela) e a conta do
       lojista parceiro (v271 — ele digitou a oferta e a margem). Vazio
       aqui quer dizer "ainda não decidi", nunca "não tem".

       ⚠️ Nada exige o campo pra salvar, e o `_avDifFipePinta` já esconde a
       linha da diferença quando ele está vazio — conferido.
       ===================================================================== */
    var vi=$('avValor');
    if(AV_VALOR_SUGERE && vi && !valorTocado && document.activeElement!==vi) vi.value=loja?r$(loja):'';
    /* v178: preço do repasse acompanha a sugestão enquanto ninguém digitou.
       Não escrevo por cima enquanto o campo está em foco — o cursor pularia. */
    try{ avLojCalc(false); }catch(_){}   /* v271: mantém o cartão desenhado */
    try{ _avDifFipePinta(); }catch(_){}   /* v268 */
    var rpI=$('avRepPreco');
    var comercial=avComercialPrecos(loja,fipe),vendas={};
    [['avVendaLojista','avVendaLojistaT','lojista',comercial.lojista],['avVendaVarejo','avVendaVarejoT','varejo',comercial.varejo]].forEach(function(par){
      var el=$(par[0]),tocado=$(par[1]);if(!el)return;
      el.dataset.sugestao=par[3]||'';
      if(!(tocado&&tocado.value) && document.activeElement!==el)el.value=par[3]?r$(par[3]):'';
      vendas[par[2]]=_digits(par[0])||par[3]||0;
    });
    if(rpI){
      rpI.dataset.sugestao=comercial.lojista||'';
      rpI.value=comercial.lojista?r$(comercial.lojista):'';
      repTocado=false;
      var rpT=$('avRepT');if(rpT)rpT.value='';
    }
    var varejo=$('avClientePreco');
    if(varejo){ varejo.dataset.valor=vendas.varejo||''; varejo.textContent=vendas.varejo?r$(vendas.varejo):'Indisponível'; }
    /* =====================================================================
       🔴 v895 — O CAMPO PAROU DE DESFAZER O QUE O ANGELO DIGITA
       ---------------------------------------------------------------------
       "to editando valor de repasse, mas nao ta indo, ele volta nos 32."
       E voltava mesmo. A v241 tinha posto uma trava aqui:

           digitou MENOS que a sugestão?  ao sair do campo, sobe pra sugestão.

       Com a sugestão em R$ 32.000, QUALQUER número abaixo disso era apagado
       na saída do campo — 31.999 virava 32.000 igual a 28.000. Da tela, isso
       não parece uma regra: parece um campo quebrado, porque o app desfaz a
       digitação sem dizer nada.

       A razão da v241 era o PORTAL: o preço não podia ir pro Portal do
       Repasse abaixo da sugestão. Só que o preço não vai mais pro Portal —
       o próprio rótulo deste campo diz "referência sua — o portal não
       mostra", e a Rede de Repasse publica com "Faça sua oferta" (v240–v309,
       ver 13-abrir-avaliacao.js). A trava ficou guardando uma porta que já
       tinha sido murada, e o preço que ela protegia não sai mais pra
       lugar nenhum.

       ⚠️ O QUE FOI TIRADO FOI A REESCRITA, NÃO A INFORMAÇÃO. A sugestão
       continua sendo calculada e continua entrando sozinha no campo enquanto
       ninguém digitou (a linha acima). O que acabou é o app decidir por cima
       de um número que a pessoa escreveu de propósito. Um campo que diz
       "referência sua" e devolve outro valor está mentindo no rótulo.
       ⚠️ Se um dia fizer falta AVISAR que o preço está abaixo da sugestão,
       o lugar é ao lado do campo, como a linha "−R$ 5.504 · −14,7% vs FIPE"
       que já existe logo acima — aviso, não correção.
       ===================================================================== */
  }

  /* ===== Ficha Técnica: monta o acordeão a partir do JSON da IA ===== */
  /* formata a Avaliação de Mercado: deixa "RÓTULO:" em negrito e separa parágrafos */
  function fmtAvaliacao(t){
    return String(t||'').split(/\n+/).map(function(p){ p=p.trim(); if(!p) return '';
      var m=p.match(/^([A-ZÀ-Ú][A-ZÀ-Ú0-9 \/()]{2,40}):\s*([\s\S]*)$/);
      return m ? '<p class="fic-av-p"><b>'+esc(m[1])+':</b> '+esc(m[2])+'</p>' : '<p class="fic-av-p">'+esc(p)+'</p>';
    }).join('');
  }
  function fichaHtml(r){
    r=r||{};
    if(r.texto) return '<div class="fic-aval">'+fmtAvaliacao(r.texto)+'</div>';
    var out='';
    function item(ic,titulo,cnt,corpo,aberto){ if(!corpo) return '';
      return '<div class="fic-item'+(aberto?' open':'')+'"><button class="fic-t"><span class="fic-ic">'+ic+'</span><span class="fic-tt">'+esc(titulo)+'</span>'+(cnt?'<span class="fic-cnt">'+esc(cnt)+'</span>':'')+'<span class="fic-ar">&#9656;</span></button><div class="fic-b">'+corpo+'</div></div>'; }
    function humaniza(k){ return String(k).replace(/_/g,' ').replace(/(^|\s)\S/g,function(c){return c.toUpperCase();}); }
    function chips(a,cls){ a=(a||[]).filter(Boolean); return a.length?('<div class="fic-chips">'+a.map(function(x){return '<span class="fic-chip'+(cls?' '+cls:'')+'">'+esc(String(x))+'</span>';}).join('')+'</div>'):''; }
    function val(v){
      if(v==null||v==='') return '';
      if(typeof v!=='object') return '<div class="fic-txt">'+esc(String(v))+'</div>';
      if(Array.isArray(v)) return chips(v);
      var rows=[], nested=[];
      Object.keys(v).forEach(function(k){ var x=v[k]; if(x==null||x==='') return;
        if(typeof x==='object'){ var inner=val(x); if(inner) nested.push('<div class="fic-sub"><div class="fic-sub-t">'+esc(humaniza(k))+'</div>'+inner+'</div>'); }
        else rows.push('<div class="fic-kv"><span>'+esc(humaniza(k))+'</span><b>'+esc(String(x))+'</b></div>');
      });
      return (rows.length?'<div class="fic-kvg">'+rows.join('')+'</div>':'')+nested.join('');
    }
    /* motor/dimensões/desempenho: cada informação em uma linha (melhor leitura) */
    function especTexto(vv){
      if(vv==null||vv==='') return '';
      if(typeof vv==='object') return val(vv);
      var partes=String(vv).split(/,\s+|;\s+|\.\s+(?=[A-ZÀ-Ÿ])/).map(function(s){ return s.trim().replace(/[.;,]+$/,''); }).filter(Boolean);
      if(partes.length<=1) return '<div class="fic-txt">'+esc(String(vv))+'</div>';
      return '<div class="fic-lines">'+partes.map(function(p){ return '<div class="fic-line">'+esc(p)+'</div>'; }).join('')+'</div>';
    }
    out+=item(ICO.motor,'MOTOR','',especTexto(r.motor),true);
    out+=item(ICO.dimensoes,'DIMENSÕES','',especTexto(r.dimensoes),true);
    out+=item(ICO.desempenho,'DESEMPENHO E CONSUMO','',especTexto(r.desempenho),true);
    var it=(r.itens_serie||[]).filter(Boolean);
    out+=item(ICO.itens,'ITENS DE SÉRIE', it.length?it.length+' itens':'', chips(it), false);
    var op=(r.opcionais||[]).filter(Boolean);
    out+=item(ICO.opcionais,'OPCIONAIS PARA CONFERIR', op.length?op.length+' p/ conferir':'', chips(op,'opc'), false);
    var cmp=(r.comparativo||[]).filter(function(c){return c&&(c.versao||c.obs);});
    if(cmp.length){ var b=cmp.map(function(c){return '<div class="fic-cmp"><b>'+esc(c.versao||'')+'</b>'+(c.obs?' — '+esc(c.obs):'')+'</div>';}).join('');
      out+=item(ICO.comparativo,'COMPARATIVO DE VERSÕES', cmp.length+' versões', b, false); }
    /* A "Avaliação de mercado" foi movida para o card azul da Avaliação de troca. */
    return out||'<div class="plc-msg">Gerado.</div>';
  }
  /* Monta a pesquisa de mercado. A faixa financeira é calculada uma única vez
     no cabeçalho; aqui entram apenas pontos de vistoria e comparativos. */
  function avalMercadoNormalizar(r, nivel){
    nivel=nivel||0; if(nivel>3) return {};
    if(typeof r==='string'){
      var t=r.trim(), json=t.replace(/^```(?:json)?\s*/i,'').replace(/\s*```$/,'').trim();
      try{ return avalMercadoNormalizar(JSON.parse(json),nivel+1); }catch(_){}
      // JSON truncado ou misturado com prosa nao deve virar texto visivel.
      if(/```|^[\[{]|"[\w_]+"\s*:/.test(t)) return {};
      return {avaliacao:t};
    }
    if(!r || typeof r!=='object' || Array.isArray(r)) return {};
    var out={};
    ['veredicto'].forEach(function(k){ if(typeof r[k]==='string') out[k]=r[k]; });
    ['problemas_recorrentes','pontos_atencao','vantagens','fontes_pesquisa'].forEach(function(k){
      var v=r[k]; out[k]=Array.isArray(v)?v.filter(function(x){return typeof x==='string'&&x.trim();}):(typeof v==='string'?[v]:[]);
    });
    if(r.faixa_mercado&&typeof r.faixa_mercado==='object'&&!Array.isArray(r.faixa_mercado)){
      var fm=r.faixa_mercado, min=Number(fm.min)||0, max=Number(fm.max)||0;
      if(min>0&&max>=min) out.faixa_mercado={min:min,max:max,amostra:Math.max(0,Number(fm.amostra)||0),quilometragem:Math.max(0,Number(fm.quilometragem)||0)};
    }
    out.concorrentes=Array.isArray(r.concorrentes)?r.concorrentes.filter(function(c){return c&&typeof c==='object'&&!Array.isArray(c);}).map(function(c){
      var x={}; ['modelo','preco','vantagem','desvantagem','obs'].forEach(function(k){ if(typeof c[k]==='string'||typeof c[k]==='number') x[k]=String(c[k]); }); return x;
    }):[];
    var livre=r.avaliacao||r.texto;
    if(livre){
      var extra=avalMercadoNormalizar(livre,nivel+1);
      Object.keys(extra).forEach(function(k){ if(!out[k] || (Array.isArray(out[k])&&!out[k].length)) out[k]=extra[k]; });
    }
    return out;
  }
  function avalMercadoHtml(r){
    r=avalMercadoNormalizar(r);
    /* v242: cada grupo virou um bloco colapsável (acordeão) — o primeiro
       vem aberto, os demais minimizados; abrir um fecha o outro. */
    var blocos=[];
    if(r.veredicto) blocos.push(['Veredicto de mercado','','<div class="fic-vered"><p class="fic-av-p">'+esc(r.veredicto)+'</p></div>']);
    var pa=(r.problemas_recorrentes&&r.problemas_recorrentes.length?r.problemas_recorrentes:(r.pontos_atencao||[])).filter(Boolean);
    if(pa.length) blocos.push(['Itens para vistoria',pa.length+' itens','<div class="fic-pa"><p class="fic-pesq-aviso">Relatos públicos orientam a conferência; não substituem diagnóstico.</p>'+pa.map(function(x){return '<div class="fic-pa-i"><span class="ck">✓</span><span>'+esc(String(x))+'</span></div>';}).join('')+'</div>']);
    var vantagens=(r.vantagens||[]).filter(Boolean);
    if(vantagens.length) blocos.push(['Vantagens desta versão',vantagens.length+' pontos','<div class="fic-vant">'+vantagens.map(function(x){return '<div class="fic-pa-i"><span class="ck">✓</span><span>'+esc(String(x))+'</span></div>';}).join('')+'</div>']);
    var conc=(r.concorrentes||[]).filter(function(c){return c&&(c.modelo||c.preco||c.vantagem||c.desvantagem);});
    if(conc.length) blocos.push(['Concorrentes diretos',conc.length+' modelos','<div class="fic-conc">'+conc.map(function(c){ var detalhe=[]; if(c.vantagem) detalhe.push('<small><b>Vantagem:</b> '+esc(c.vantagem)+'</small>'); if(c.desvantagem) detalhe.push('<small><b>Desvantagem:</b> '+esc(c.desvantagem)+'</small>'); if(c.obs) detalhe.push('<small>'+esc(c.obs)+'</small>'); return '<div class="fic-conc-i"><span><b>'+esc(c.modelo||'')+'</b>'+detalhe.join('')+'</span>'+(c.preco?'<em>'+esc(c.preco)+'</em>':'')+'</div>'; }).join('')+'</div>']);
    var fontes=(r.fontes_pesquisa||[]).filter(function(u){ try{ return /^https:$/.test(new URL(String(u)).protocol); }catch(_){ return false; } }).slice(0,4);
    if(fontes.length) blocos.push(['Fontes da pesquisa','','<div class="fic-fontes">'+fontes.map(function(u){ var nome='Fonte'; try{ nome=new URL(String(u)).hostname.replace(/^www\./,''); }catch(_){} return '<a href="'+esc(String(u))+'" target="_blank" rel="noopener">'+esc(nome)+'</a>'; }).join('')+'</div>']);
    /* v946: se a IA respondeu texto válido mas fora do JSON pedido, o servidor
       devolve em `texto`. Antes a interface olhava apenas `avaliacao` e o
       resultado parecia vazio (caso observado no Jetta EZG4B77). */
    var textoLivre=r.avaliacao||r.texto;
    if(!blocos.length && textoLivre){ var linhas=String(textoLivre).split(/\n+/).filter(function(x){ return !/(faixa|revenda estimada|mercado estimado)/i.test(x); }).join('\n'); if(linhas) return '<div class="fic-aval">'+fmtAvaliacao(linhas)+'</div>'; }
    /* v253: sem os badges de contagem ("4 itens", "3 modelos"...) e com um
       ícone SVG em cada bloco (pedido). */
    return blocos.map(function(b,i){
      return '<div class="fic-item avm-it'+(i===0?' open':'')+'"><button type="button" class="fic-t"><span class="fic-ic">'+_ficIcoTit(b[0])+'</span><span class="fic-tt">'+esc(b[0])+'</span><span class="fic-ar">&#9656;</span></button><div class="fic-b">'+b[2]+'</div></div>';
    }).join('');
  }
  /* v253: ícone SVG por título de bloco (mercado e ficha) */
  function _ficIcoTit(t){
    t=String(t||'').toLowerCase();
    var S='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
    if(t.indexOf('veredicto')>=0) return S+'<circle cx="12" cy="9" r="6"/><path d="M8.5 14.5L7 22l5-3 5 3-1.5-7.5"/></svg>';
    if(t.indexOf('vistoria')>=0) return S+'<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>';
    if(t.indexOf('vantagen')>=0) return S+'<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
    if(t.indexOf('concorrente')>=0) return S+'<path d="M16 3h5v5"/><path d="M8 21H3v-5"/><path d="M21 3l-7.5 7.5"/><path d="M3 21l7.5-7.5"/></svg>';
    if(t.indexOf('fontes')>=0) return S+'<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>';
    if(t.indexOf('identifica')>=0) return S+'<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 9h5"/><path d="M7 13h8"/></svg>';
    if(t.indexOf('quem consultou')>=0||t.indexOf('consultas')>=0) return S+'<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M11 7v4l2.5 1.5"/></svg>';
    if(t.indexOf('comportamento')>=0||t.indexOf('crédito')>=0) return S+'<path d="M4 19V9"/><path d="M10 19V5"/><path d="M16 19v-7"/><path d="M22 19H2"/></svg>';
    if(t.indexOf('atividade')>=0||t.indexOf('cnae')>=0) return S+'<path d="M4 20V10"/><path d="M10 20V4"/><path d="M16 20v-7"/><path d="M22 20H2"/></svg>';
    if(t.indexOf('empresa')>=0||t.indexOf('participa')>=0) return S+'<path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>';
    if(t.indexOf('sócio')>=0||t.indexOf('socio')>=0) return S+'<circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M3 20v-2a6 6 0 0 1 12 0v2"/><path d="M15 14.5a5 5 0 0 1 6 4.9V20"/></svg>';
    if(t.indexOf('endereço')>=0||t.indexOf('endereco')>=0) return S+'<path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0z"/><circle cx="12" cy="10" r="2.5"/></svg>';
    if(t.indexOf('contato')>=0||t.indexOf('telefone')>=0) return S+'<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2z"/></svg>';
    if(t.indexOf('receita')>=0||t.indexOf('fiscal')>=0) return S+'<path d="M3 10h18"/><path d="M5 10v8M9 10v8M15 10v8M19 10v8"/><path d="M2 21h20M12 3l9 4H3l9-4z"/></svg>';
    if(t.indexOf('histórico')>=0||t.indexOf('historico')>=0) return S+'<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/><path d="M12 7v5l3 2"/></svg>';
    if(t.indexOf('pendência')>=0||t.indexOf('restriç')>=0) return S+'<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
    if(t.indexOf('motor')>=0) return S+'<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z"/></svg>';
    if(t.indexOf('desempenho')>=0) return S+'<path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/></svg>';
    if(t.indexOf('dimens')>=0) return S+'<rect x="2" y="9" width="20" height="6" rx="1"/><path d="M6 9v3"/><path d="M10 9v3"/><path d="M14 9v3"/><path d="M18 9v3"/></svg>';
    if(t.indexOf('freios')>=0) return S+'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></svg>';
    if(t.indexOf('equipamento')>=0) return S+'<circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>';
    return S+'<circle cx="12" cy="12" r="9"/></svg>';
  }
  function ligarFicha(scope){
    Array.prototype.forEach.call(scope.querySelectorAll('.fic-t'),function(b){
      b.addEventListener('click',function(e){ e.stopPropagation(); b.parentNode.classList.toggle('open'); });
    });
  }

  /* animação de "gerando a consulta completa" com frases dos benefícios girando */
  var _ccFrases=['🔎 Verificando histórico de leilão e sinistro…','🛡️ Checando restrições, roubo e furto…','⚖️ Consultando bloqueios judiciais (Renajud)…','🚨 Buscando multas e recalls pendentes…','📋 Conferindo procedência e situação no Detran…','💡 Evita comprar veículo com problema escondido…','✅ Quase lá — montando o seu relatório…'];
  var _debFrases=['💰 Consultando IPVA em aberto…','📄 Verificando licenciamento do ano…','🚦 Buscando multas com valor…','🏛️ Conferindo taxas no Detran / SEFAZ…','💡 Saber os débitos evita surpresa na transferência…','✅ Quase lá — somando os valores…'];
  var _restFrases=['🔎 Consultando restrições financeiras…','🏦 Verificando pendências e protestos…','⚖️ Checando ocorrências negativas…','📊 Analisando a situação de crédito…','💡 Ajuda a decidir antes de fechar negócio…','✅ Quase lá — montando o resultado…'];
  var _SVG_CARRO='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 11l1.4-4.2A2.5 2.5 0 0 1 8.8 5h6.4a2.5 2.5 0 0 1 2.4 1.8L19 11h.5A1.5 1.5 0 0 1 21 12.5v3a1 1 0 0 1-1 1h-.6a2.4 2.4 0 0 1-4.8 0H9.4a2.4 2.4 0 0 1-4.8 0H4a1 1 0 0 1-1-1v-3A1.5 1.5 0 0 1 4.5 11H5zm2.1-.4h9.8l-1-3a1 1 0 0 0-1-.7H9.1a1 1 0 0 0-1 .7l-1 3zM7 15.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zm10 0a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z"/></svg>';
  /* v252: animação nova (padrão MEV Tools, pedido) — o carrinho agora fica
     dentro de um ANEL (tracejado girando devagar + arco azul girando), no
     lugar do carrinho + barra. Como TODOS os carregamentos usam esta função,
     a troca vale pra ficha, mercado, consulta completa, leilão etc. */
  /* v350 (pedido): a bolinha que gira mostra o ÍCONE DO ASSUNTO — prédio na
     consulta de CNPJ, pessoa na de CPF. Sem passar nada, continua o carro (é
     consulta de veículo). Os desenhos são os MESMOS do menu lateral, pra tela
     e menu falarem a mesma língua. */
  var _SVG_PREDIO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>';
  var _SVG_PESSOA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="10" cy="7" r="4"/><path d="M15.5 8.5l2 2 3.5-3.5"/></svg>';
  /* ===== v488 — O LOADER QUE ANDA (projeto "animação da ficha técnica") ==
     Três coisas mudaram, e todas por um motivo MEDIDO:

     1) A FRASE OCUPA DUAS LINHAS SEMPRE. Em cada lista existia uma frase
        que quebrava em duas (37,8px contra 20px das outras). Como o
        .cc-load é uma coluna centralizada, o bloco crescia e o ANEL
        PULAVA a cada volta. Agora a altura é fixa — ver o CSS (v488).

     2) O ANEL GANHOU PROGRESSO. Antes ele girava igual no segundo 1 e no
        150. O `segundos` é quanto aquela operação COSTUMA levar; o aro
        anda em cima disso. Ele para em 92% e nunca fecha: barra que
        chega a 100% e continua esperando é pior do que não ter barra.

     3) A LISTA NÃO REPETE ATÉ CANSAR. 6 frases × 1,8s = 10,8s de ciclo —
        numa espera de 150s era a MESMA sequência 14 vezes. Agora a troca
        é a cada 2,6s (dá pra ler 40 caracteres) e, passado o tempo
        esperado, a lista PARA e fixa uma frase honesta.

     ⚠️ O segundo parâmetro é OPCIONAL. As outras chamadas do app (placa,
        CPF, CNPJ, leilão, débitos, mercado, comparativo, aprovação…)
        continuam funcionando sem tocar em nada (caem no padrão de 45s). */
  /* v1376 — após o limite honesto de 92%, tempo e atividade continuam visíveis. */
  var _CC_ESPERA='A fonte ainda está processando — o resultado aparecerá automaticamente.';
  function _ccTempoDecorrido(ms){
    var s=Math.max(0,Math.floor(ms/1000)), m=Math.floor(s/60); s%=60;
    return m?(m+' min '+String(s).padStart(2,'0')+' s'):(s+' s');
  }
  function ccLoaderHtml(titulo,frases,ico,classe){
    frases=frases||_ccFrases;
    titulo=titulo||'Gerando consulta completa…';
    var pctInicial=classe==='cc-load-placa'?'6%':'6% estimado';
    return '<div class="cc-load mev-process-page'+(classe?' '+classe:'')+'" role="status" aria-live="polite">'+
      mevProcessoMarcaHtml()+
      '<div class="cc-load-head"><div class="cc-load-t">'+titulo+'</div><span class="cc-load-pct" id="ccLoadPct" aria-hidden="true">'+pctInicial+'</span></div>'+
      '<div class="cc-load-track" id="ccLoadTrack" role="progressbar" aria-label="'+titulo+'" aria-valuemin="0" aria-valuemax="100" aria-valuenow="6"><i id="ccLoadFill" style="width:6%"></i></div>'+
      '<div class="cc-load-s" id="ccLoadS">'+frases[0]+'</div></div>';
  }
  function ccLoaderStart(frases, segundos){
    frases=frases||_ccFrases;
    var i=0, t0=Date.now(), total=Math.max(5,(segundos||45))*1000;
    var tick=0, parou=false, ultimaFatia=-1;
    /* base de 200ms: o aro precisa andar liso; a frase troca a cada 13
       ticks (2600ms), que é o tempo de ler 40 caracteres com calma. */
    return setInterval(function(){
      var e=$('ccLoadS'); if(!e) return;
      var passou=Date.now()-t0;
      /* a barra acompanha o tempo esperado e fica em 92% enquanto a fonte
         ainda responde; 100% pertence somente ao resultado concluído. */
      var pg=Math.max(6,Math.min(92,passou/total*100)), fill=$('ccLoadFill'), pct=$('ccLoadPct'), track=$('ccLoadTrack');
      if(fill) fill.style.width=pg.toFixed(1)+'%';
      if(parou){
        var fatia=Math.floor(passou/5000);
        if(fatia!==ultimaFatia){
          ultimaFatia=fatia;
          if(pct) pct.textContent='Processando · '+_ccTempoDecorrido(passou);
          if(track) track.setAttribute('aria-valuetext','Fonte ainda processando há '+_ccTempoDecorrido(passou));
        }
        return;
      }
      if(pct){ var cargaPlaca=pct.closest&&pct.closest('.cc-load-placa'); pct.textContent=Math.round(pg)+'%'+(cargaPlaca?'':' estimado'); }
      if(track) track.setAttribute('aria-valuenow',Math.round(pg));
      /* passou do esperado: fixa a frase honesta e para de trocar */
      if(passou>total){
        parou=true;
        var carga=e.closest?e.closest('.cc-load'):null; if(carga) carga.classList.add('is-waiting');
        if(pct) pct.textContent='Processando · '+_ccTempoDecorrido(passou);
        if(track) track.setAttribute('aria-valuetext','Fonte ainda processando há '+_ccTempoDecorrido(passou));
        e.style.opacity='0'; e.style.transform='translateY(6px)';
        setTimeout(function(){ var e2=$('ccLoadS'); if(e2){ e2.textContent=_CC_ESPERA; e2.style.opacity='1'; e2.style.transform='none'; } },220);
        return;
      }
      tick++; if(tick%13) return;
      i=(i+1)%frases.length;
      e.style.opacity='0'; e.style.transform='translateY(6px)';
      setTimeout(function(){
        var e2=$('ccLoadS'); if(!e2) return;
        e2.textContent=frases[i]; e2.style.opacity='1'; e2.style.transform='none';
      },220);
    }, 200);
  }
  /* chama /api/consultar repetindo a solicitação (até 'tentativas' vezes) —
     dá tempo do provedor responder (~30s). O backend estorna a cada falha,
     então repetir NÃO cobra tokens a mais; a tentativa que der certo é a que fica. */
  async function consultarComRetry(body, tentativas){
    tentativas=tentativas||3; var ultimo=null;
    for(var k=0;k<tentativas;k++){
      var d=await api('/api/consultar', body); ultimo=d;
      if(d && d.ok) return d;
      if(d && d.sem_saldo) return d;
      if(k<tentativas-1){ await new Promise(function(r){ setTimeout(r,1200); }); }
    }
    return ultimo;
  }
  async function gerarPago(produto, btn){
    if(!veiculoAtual) return;
    var content=(produto==='ficha_avaliacao') ? $('fichaWrap') : $('leilaoWrap');
    if(!content) content=btn.parentNode;
    var loaderTimer=null;
    if(produto==='leilao'){ content.innerHTML=ccLoaderHtml(); loaderTimer=ccLoaderStart(); }
    else { btn.disabled=true; btn.textContent='Gerando… pode levar alguns segundos'; }
    var body={produto:produto,placa:veiculoAtual.placa};
    if(produto==='ficha_avaliacao') body.veiculo=vinfo();
    /* v240: a análise de mercado roda em segundo plano (sem o limite de ~26s);
       os outros produtos seguem pelo /api/consultar normal */
    /* 🔴 19/08 — 'leilao' (o estadual) deixou de ser vendido sozinho: virou
       parte da Consulta Plus. Este botão passou a rodar a Plus, que traz o
       estadual + FIPE + leilão/sinistro pelo mesmo toque, e o
       `consultaPlusRodar` já deixa o `leilaoState` pronto pro que vem
       abaixo — por isso a linha do resultado não mudou. */
    var d;
    if(produto==='leilao'){
      var _pl = await consultaPlusRodar(veiculoAtual.placa);
      if(_pl.aviso) toast(_pl.aviso);
      d = _pl.semSaldo ? { sem_saldo:true, saldo:_pl.saldo }
        : _pl.ok ? { ok:true, saldo:saldo, resultado: leilaoState }
        : { ok:false, erro:_pl.erro, estornado:_pl.estornado };
    }
    else d = (produto==='ficha_avaliacao') ? await _iaJobRodar({ job:true, cobrar:true, tipo:'mercado', placa:veiculoAtual.placa, veiculo:vinfo() })
          : await api('/api/consultar',body);
    if(loaderTimer){ clearInterval(loaderTimer); loaderTimer=null; }
    if(d&&d.sem_saldo){ setSaldo(d.saldo); if(produto==='leilao'){ abrirLeilao(); } else { btn.disabled=false; btn.textContent='Gerar'; } abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){
      var msgFalha='Não foi possível concluir a consulta agora. Tente de novo em instantes.';
      if(produto==='leilao'){ abrirLeilao(); var w=$('leilaoWrap'); if(w) w.insertAdjacentHTML('beforeend','<div class="plc-msg" style="color:#b91c1c;margin-top:8px">'+msgFalha+(d&&d.estornado?' O valor foi devolvido ao seu saldo.':'')+'</div>'); }
      else { btn.disabled=false; btn.textContent='Tentar de novo'; content.insertAdjacentHTML('beforeend','<div class="plc-msg" style="color:#b91c1c">'+esc((d&&d.erro)||'Falha na consulta.')+'</div>'); }
      return;
    }
    if(produto==='ficha_avaliacao'){ fichaState=d.resultado||{}; histSetGerado(veiculoAtual.placa,'ficha',fichaState); content.innerHTML=fichaHtml(fichaState); ligarFicha(content); }
    else { leilaoState=d.resultado; histSetGerado(veiculoAtual.placa,'leilao',leilaoState); content.innerHTML='<div style="font-weight:800;color:var(--verde);padding:4px 0 8px">✓ Consulta salva</div>'+relInlineHtml()+botaoPDF(); var _pb=content.querySelector('[data-acao="pdf"]'); if(_pb) _pb.onclick=function(){ acaoGerarPDF(); }; }
  }

  /* A ficha técnica é sempre do ANO DO MODELO (ex.: 2021/2022 → usa 2022). */
  function vinfo(){ return {marca:veiculoAtual.marca,modelo:veiculoAtual.modelo,versao:veiculoAtual.versao||'',ano:(veiculoAtual.ano_modelo||veiculoAtual.ano),ano_modelo:veiculoAtual.ano_modelo||veiculoAtual.ano,combustivel:veiculoAtual.combustivel,fipe:veiculoAtual.fipe,quilometragem:_km()}; }
  function subInfoModelo(v){ var a=v.ano_modelo||v.ano; return esc((((v.marca||'')+' '+(v.modelo||'')).trim())+(a?' · '+a:'')); }

  /* ==========================================================================
     v621 — O PDF DA AVALIAÇÃO
     ==========================================================================
     Pedido do Angelo (24/08): "adicione um botao com icone svg gerar pdf da
     avaliacao, vem com todos os dados no mesmo formato padrao da consulta,
     vem consulta, ficha tecnica, avaliacao de mercado (se foi gerado),
     informacoes, fotos".

     🔑 A ORDEM DAS SEÇÕES NÃO FOI INVENTADA: é a mesma do _AV_STEPS, que é a
     ordem em que a tela pede as coisas. Documento que segue a ordem da tela
     se confere olhando; documento com ordem própria obriga a procurar.

     🔴 DUAS VERSÕES NO MESMO BOTÃO, e essa é a decisão que mais importa aqui:
     custos, margens e cotações são CONTA INTERNA DA LOJA. Se o papel vai pra
     mão do cliente, essas seções não podem ir junto — por isso o botão
     pergunta antes: "Completo (interno)" ou "Do cliente". O cliente recebe o
     carro (dados, ficha técnica, itens avaliados, fotos, faixa de mercado) e
     o valor avaliado; não recebe a margem da loja.

     ⚠️ EGRESS (prazo 28/08): as fotos passam pelo imgCdn(url,600) — a mesma
     imagem que a tela já usa nas prévias, uma fração dos bytes do original.
     Um PDF que baixasse 12 fotos originais por geração é exatamente o tipo de
     coisa que estourou a quota. E o imgCdn tem um efeito colateral ótimo: a
     foto passa a vir do NOSSO domínio, então não suja a canvas. */
  var AVAL_PDF_MAX_FOTOS=12;

  /* junta num objeto só tudo que o PDF precisa. Uma fonte só: o teste lê
     ESTE objeto e o desenho lê ESTE objeto — não tem como divergirem. */
  function avalPdfDados(){
    var v=veiculoAtual||{};
    var d={ v:v, placa:String(v.placa||''), km:_km(), modo:'', quando:new Date() };
    d.modelo=((v.marca||'')+' '+(v.modelo||'')).trim();
    var _af=String(v.ano==null?'':v.ano).trim(), _am=String(v.ano_modelo==null?'':v.ano_modelo).trim();
    d.ano=(_af&&_am)?(_af+'/'+_am):(_af||_am);
    /* histórico FIPE — a mesma leitura do PDF da FIPE (v596) */
    try{ d.hist=(typeof verHistDe==='function'?verHistDe(v):(v.historico||[])); }catch(_){ d.hist=v.historico||[]; }
    d.hist=(d.hist||[]).filter(function(x){ return x && x.valor!=null; })
      .slice().sort(function(a,b){ return String(b.mes||'')<String(a.mes||'')?-1:1; });
    /* itens avaliados: só o que TEM resposta (o "Verificar" não vira linha) */
    d.itens=[];
    try{
      (_ehMoto?AV_CUSTO_MOTO:AV_CUSTO_CARRO).forEach(function(id){
        var s=$(id); if(!s) return;
        var txt=_avOpcaoSemValor(s);
        if(!txt){
          var o=(s.options&&s.options[s.selectedIndex]);
          var t=o?String(o.textContent||'').trim():'';
          if(!t || /^verificar$/i.test(t) || /^—/.test(t)) return;
          txt=t;
        }
        d.itens.push([AV_LABELS[id]||id, txt]);
      });
    }catch(_){}
    d.obs=String((($('avObs')||{}).value)||'').trim();
    /* ficha técnica, se a tela já tem */
    d.ficha=null;
    try{ if(fichaTecState) d.ficha=fichaTecParse(fichaTecState); }catch(_){}
    /* mercado — "se foi gerado": só entra quando a faixa está calculada */
    d.mercado=''; try{ var mr=$('avMktRng'); var _t=mr?String(mr.textContent||'').trim():''; if(_t && _t!=='—') d.mercado=_t; }catch(_){}
    d.liq=_digits('avLiq');
    /* custos: a MESMA lista que a tela mostra (o _avCustoEd já aplicado) */
    d.custos=[]; d.custoTotal=0;
    try{
      Array.prototype.forEach.call(document.querySelectorAll('#avCustosBody .avt-custos-row'),function(r){
        var l=r.querySelector('.avc-l'), i=r.querySelector('.avc-in');
        if(!l||!i) return;
        var val=parseInt(String(i.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
        d.custos.push([String(l.textContent||'').replace(/seu valor/i,'').trim(), brl(val)]);
        d.custoTotal+=val;
      });
    }catch(_){}
    d.avaliado=_digits('avValor');
    d.repasse=_digits('avRepPreco');
    d.quem=String((($('avQuem')||{}).value)||'').trim();
    d.fotos=[]; try{ d.fotos=(_avFotos||[]).slice(); }catch(_){}
    return d;
  }

  /* carrega as fotos ANTES de desenhar (o kit é síncrono — ver a nota no 06b).
     Foto que não carrega é PULADA, não derruba o PDF. */
  function avalPdfFotosCarrega(urls, max){
    urls=(urls||[]).slice(0, max||AVAL_PDF_MAX_FOTOS);
    return Promise.all(urls.map(function(u){
      return new Promise(function(ok){
        try{
          var src=(typeof imgCdn==='function')?imgCdn(u,600):u;
          var im=new Image();
          var timer=setTimeout(function(){ im.onload=im.onerror=null; ok(null); },15000);
          im.onload=function(){ clearTimeout(timer); ok(im); };
          im.onerror=function(){ clearTimeout(timer); ok(null); };
          try{ im.crossOrigin='anonymous'; }catch(_){}
          im.src=src;
        }catch(_){ ok(null); }
      });
    })).then(function(l){ return l.filter(Boolean); });
  }

  function avalPdfPaginas(d, modo, imgs){
    var interno=(modo!=='cliente');
    var st=pdfkitNovo({ tipo:'AVALIAÇÃO DE VEÍCULO', placa:d.placa,
      lgpdCurto: interno ? 'Documento interno da loja — contém custos e margens.'
                         : 'Valores de referência na data da avaliação.' });
    /* capa */
    kitKv2(st,'Veículo avaliado',[
      ['Placa', d.placa], ['Marca / modelo', d.modelo], ['Ano fab./mod.', d.ano],
      ['Quilometragem', d.km?(d.km.toLocaleString('pt-BR')+' km'):''],
      ['Cor', d.v.cor], ['Combustível', d.v.combustivel],
      ['Chassi', d.v.chassi?kitChassiMask(d.v.chassi):''],
      ['Município / UF', [d.v.municipio,d.v.uf].filter(Boolean).join(' / ')],
      ['Avaliado por', d.quem]
    ]);
    /* 1. histórico FIPE (a mesma dupla do PDF da FIPE) */
    if(d.hist && d.hist.length){
      try{ kitFipe6(st,d.hist,true); }catch(_){}
      try{ kitGrafArea(st,d.hist); }catch(_){}
    }
    /* 2. itens avaliados */
    if(d.itens.length) kitKv2(st,'Avaliação — itens verificados', d.itens);
    if(d.obs) kitTexto(st, d.obs);
    /* 3. ficha técnica (quando a tela já carregou) */
    if(d.ficha){
      if((d.ficha.ident||[]).length)  kitKv2(st,'Ficha técnica', d.ficha.ident);
      if((d.ficha.motor||[]).length)  kitKv2(st,'Motor', d.ficha.motor);
      if((d.ficha.desemp||[]).length) kitKv2(st,'Desempenho e consumo', d.ficha.desemp);
      if((d.ficha.dim||[]).length)    kitKv2(st,'Dimensões', d.ficha.dim);
    }
    /* 4. mercado — só quando foi gerado */
    if(d.mercado) kitKv2(st,'Mercado',[['Faixa de preço de mercado', d.mercado],
      ['Liquidez ajustada', d.liq?brl(d.liq):'']]);
    /* 5. custos e cotações — SÓ NA VERSÃO INTERNA */
    if(interno){
      if(d.custos.length) kitKv2(st,'Custos identificados', d.custos.concat([['Total dos custos', brl(d.custoTotal)]]));
      var cot=[];
      if(d.avaliado) cot.push(['Valor avaliado (compra)', brl(d.avaliado)]);
      if(d.repasse)  cot.push(['Preço de repasse', brl(d.repasse)]);
      if(cot.length) kitKv2(st,'Cotação', cot);
    } else if(d.avaliado){
      kitKv2(st,'Proposta',[['Valor avaliado', brl(d.avaliado)]]);
    }
    /* 6. fotos */
    if(imgs && imgs.length){
      var sobra=Math.max(0, (d.fotos||[]).length - imgs.length);
      kitFotos(st, imgs, 'Fotos do veículo', sobra?('+ '+sobra+' foto(s) no aplicativo'):'');
    }
    return kitFinaliza(st);
  }

  function avalPdfBaixar(modo){
    if(!veiculoAtual){ toast('Abra uma avaliação primeiro.'); return; }
    if(!_mevPdfPronto(function(){ avalPdfBaixar(modo); },false)) return;
    toast('Gerando PDF…');
    var d=avalPdfDados(); d.modo=modo;
    avalPdfFotosCarrega(d.fotos, AVAL_PDF_MAX_FOTOS).then(function(imgs){
      try{
        var pags=avalPdfPaginas(d, modo, imgs);
        var blob=kitPdfBlob(pags);
        if(!blob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
        var nome='avaliacao-'+(String(d.placa||'veiculo').toLowerCase())+(modo==='cliente'?'-cliente':'')+'.pdf';
        /* v615: o visor que mostra a folha como IMAGEM — o de iframe cortava
           a lateral no iPhone. */
        try{ relatorioVisor(kitPrevia(pags), blob, nome); }
        catch(_){ pdfVisor(blob, nome); }
      }catch(e){ toast('Não consegui gerar o PDF.'); }
    });
  }

  function avalPdfEscolher(anchorEl){
    var _i1='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v4H3z"/><path d="M5 7v14h14V7"/><path d="M9 12h6"/></svg>';
    var _i2='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
    try{
      _popAbrir('<div class="act-head"><div class="ah-nm">PDF da avaliação</div><div class="ah-pl">'+esc(String((veiculoAtual&&veiculoAtual.placa)||''))+'</div></div>',
        [['interno',_i1,'Completo (interno)',''],['cliente',_i2,'Do cliente (sem custos)','']],
        anchorEl, function(k){ try{ actSheetFechar(); }catch(_){} avalPdfBaixar(k); });
    }catch(_){ avalPdfBaixar('interno'); }
  }

  function renderVal(v){
    if(v==null) return '<span style="color:#94a3b8">—</span>';
    if(typeof v!=='object') return esc(String(v));
    if(Array.isArray(v)){ if(!v.length) return '<span style="color:#94a3b8">nenhum registro</span>'; return v.map(function(it){return '<div style="margin:4px 0 4px 8px;padding-left:8px;border-left:2px solid #e2e8f0">'+renderVal(it)+'</div>';}).join(''); }
    return Object.keys(v).slice(0,60).map(function(k){ var val=v[k], label=k.replace(/_/g,' ');
      if(typeof val==='object'&&val!==null) return '<div style="margin-top:6px"><b style="text-transform:capitalize;color:var(--azul)">'+esc(label)+'</b>'+renderVal(val)+'</div>';
      return '<div class="kv"><span class="k" style="text-transform:capitalize">'+esc(label)+'</span><span class="v">'+esc(String(val))+'</span></div>';
    }).join('');
  }

/* ╔═══ src/app/07b-avaliacao-marketing.js ════════════════════════════════ */
  /* ==========================================================================
     07b — MARKETING DENTRO DA AVALIAÇÃO (pedido do Angelo, 04/09)
     --------------------------------------------------------------------------
     "crie uma aba/card com a mesma aba de marketing do estoque, pra gerar
      legenda de post"

     Até aqui, pra escrever a legenda de um carro era preciso PRIMEIRO passá-lo
     pro estoque. Na rotina de repasse isso quase nunca acontece: o carro é
     avaliado, fotografado e anunciado sem nunca virar registro de estoque.
     A aba morava no lugar errado pra quem trabalha assim.

     🔑 A DECISÃO QUE FAZ ESTE ARQUIVO SER PEQUENO: não há gerador novo aqui.
     Quem escreve o post continua sendo o `mktGerarTextos` do 14j — o MESMO
     que a ficha do estoque usa, com o mesmo custo de token, o mesmo loader, o
     mesmo editor e o mesmo botão de regerar. Este arquivo só monta o painel
     com os MESMOS ids que aquele código procura e entrega a ele um veículo
     montado a partir da avaliação. Duas telas, um gerador. Se um dia o post
     mudar, muda nos dois sem ninguém precisar lembrar do segundo.

     ⚠️ POR QUE OS ids REPETIDOS NÃO COLIDEM: a ficha do estoque e a avaliação
     escrevem as duas no MESMO `#secoes` (14-estoque.js:2247 e a avaliação),
     uma substituindo a outra. Nunca existem juntas no DOM — conferido antes
     de escrever uma linha. Se algum dia isso mudar, o `$('mkOut')` passa a
     achar o painel errado e a legenda sai na tela errada: é o primeiro lugar
     pra olhar.

     ⚠️ E O QUE NÃO É REAPROVEITADO, DE PROPÓSITO: o preço. No estoque ele vem
     do `preco_anuncio`. Na avaliação há preço de repasse, venda lojista, venda
     varejo, outro valor escolhido na hora e post sem preço. Chutar qual deles
     vai pro anúncio é decidir dinheiro pelo Angelo. Então a tela pergunta, e
     o padrão continua sendo o repasse.

     🔴 O QUE NUNCA PODE VAZAR PRO POST (lição da v265): as observações
     INTERNAS e os custos. O `_mktDadosParaGerar` já resolve isso — ele lê
     `extras.destaques` (campo feito pra publicar) e passa pelo `obsPublica`.
     Este arquivo NÃO manda `avObs` nem nenhum número de custo pra lá.
     ========================================================================== */

  /* o veículo que a aba entrega ao gerador do 14j, montado da avaliação */
  function avMktVeiculo(){
    var v = (typeof veiculoAtual!=='undefined' && veiculoAtual) ? veiculoAtual : {};
    var _num=function(id){ return parseInt(String((($(id)||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; };
    var fonte=String((($('avMktPreco')||{}).value)||'repasse');
    var comercial={lojista:null,varejo:null};
    try{ comercial=avComercialPrecos(_num('avValor'),Number(v.fipe)||0); }catch(_){}
    var preco = fonte==='repasse' ? _num('avRepPreco')
              : fonte==='lojista' ? (Number(comercial.lojista)||0)
              : fonte==='varejo'  ? (Number(comercial.varejo)||0)
              : fonte==='outro'   ? _num('avMktOutro')
              : 0;
    return {
      id:'',                                  /* sem id de estoque: o post não sobe pra tabela estoque */
      placa:String(v.placa||''),
      marca:String(v.marca||''), modelo:String(v.modelo||''),
      ano:String(v.ano||''), ano_modelo:String(v.ano_modelo||v.ano||''),
      cor:String(v.cor||''),
      km:_num('avKm'),
      preco_anuncio:preco,
      /* destaques: o campo de marketing, nunca o avObs (v265) */
      extras:Object.assign({},_exDifLidos(),{ destaques:String((($('avMktDest')||{}).value)||''),
               opcionais:String((($('avMktOpc')||{}).value)||''),
               post_mostrar_km:!!(($('mkPostKm')||{}).checked),
               post_ia:String((($('avPostIa')||{}).value)||''),
               post_ia_em:String((($('avPostIaEm')||{}).value)||'') })
    };
  }

  /* o painel da aba — os MESMOS ids que o 14j procura (mkPostKm, mkBtnGerarTextos, mkOut) */
  function avMktPainelHtml(){
    return '<div class="avt">'+
      '<label class="avt-lbl" for="avMktPreco">Preço que vai no post</label>'+
      '<select class="cad-in" id="avMktPreco" aria-controls="avMktOutroWrap" aria-expanded="false">'+
        '<option value="repasse">Repasse</option>'+
        '<option value="lojista">Venda Lojista</option>'+
        '<option value="varejo">Venda Varejo</option>'+
        '<option value="outro">Outro valor</option>'+
        '<option value="sem">Sem preço no texto</option>'+
      '</select>'+
      '<div class="cad-float avmkt-outro" id="avMktOutroWrap" hidden>'+
        '<label class="cad-lbl" for="avMktOutro">Outro valor</label>'+
        '<input class="cad-in" id="avMktOutro" inputmode="decimal" placeholder="R$ 0,00" autocomplete="off">'+
      '</div>'+
      '<div class="avmkt-ajuda">O post é escrito com o preço que você escolher aqui. '+
        'Os custos e as observações internas da avaliação NUNCA entram no texto.</div>'+

      '<div class="avt-lbl" style="margin-top:14px">Diferenciais do veículo</div>'+
      _exDifHtml({})+

      '<label class="cad-lbl">Opcionais</label>'+
      '<input class="cad-in" id="avMktOpc" placeholder="Ex: teto solar, multimídia, rodas de liga...">'+
      '<label class="cad-lbl">Destaques</label>'+
      '<textarea class="cad-in" id="avMktDest" rows="2" placeholder="Ex: revisões em dia, segundo dono, sem detalhes na pintura..."></textarea>'+

      '<label class="vd-ck on"><input type="checkbox" id="mkPostKm" checked><span>Incluir quilometragem no post</span></label>'+
      '<button class="cad-btn ico" type="button" id="mkBtnGerarTextos" style="margin-top:12px">'+mkIco('post')+'Montar post</button>'+
      '<div class="mk-gerar-ajuda">O post é montado sem IA, somente com os dados preenchidos e os itens marcados.</div>'+
      '<div id="mkOut"></div>'+
      /* guardados no rascunho da avaliação (estão em AV_FIELDS) — o token
         que você gastou não pode se perder ao trocar de aba (lição da v782) */
      '<input type="hidden" id="avMktOpcH"><input type="hidden" id="avPostIa"><input type="hidden" id="avPostIaEm">'+
    '</div>';
  }

  /* ⚠️ O gerador do 14j lê exOpc/exDest (os ids do estoque). A avaliação usa
     ids próprios pra não confundir quem lê o código — então antes de gerar a
     gente ESPELHA os dois valores em campos escondidos com os nomes que ele
     espera. É feio? É. Mas é uma linha, e a alternativa era reescrever o
     _mktExtrasDaFicha com prefixo — mexer no gerador que o estoque usa todo
     dia, de madrugada, por uma tela nova. Não vale o risco. */
  function avMktEspelhaCampos(){
    var box=$('avMktEspelho');
    if(!box){
      box=document.createElement('div');
      box.id='avMktEspelho'; box.style.display='none';
      box.innerHTML='<input id="exOpc"><textarea id="exDest"></textarea>';
      var alvo=$('avBody'); if(alvo) alvo.appendChild(box); else return;
    }
    var o=$('exOpc'), d=$('exDest');
    if(o) o.value=String((($('avMktOpc')||{}).value)||'');
    if(d) d.value=String((($('avMktDest')||{}).value)||'');
  }

  /* pinta o post já guardado no rascunho desta avaliação */
  function avMktPostSalvoPinta(){
    var out=$('mkOut'); if(!out) return;
    var txt=String((($('avPostIa')||{}).value)||''); if(!txt) return;
    var v=avMktVeiculo();
    var quando=String((($('avPostIaEm')||{}).value)||'');
    try{
      out.innerHTML=_mktPostsHtml(txt, quando?_mktPostQuando(quando):'', '', '', v);
      _mktPostWire(txt,'');
    }catch(_){}
  }

  /* v937: "Outro valor" só ocupa espaço quando foi escolhido. A função é
     chamada também depois de restaurar o rascunho, não apenas no change. */
  function avMktPrecoPinta(focar){
    var sel=$('avMktPreco'), box=$('avMktOutroWrap'), inp=$('avMktOutro');
    if(!(sel&&box)) return;
    var outro=sel.value==='outro';
    box.hidden=!outro;
    sel.setAttribute('aria-expanded',outro?'true':'false');
    if(outro&&focar&&inp) try{ inp.focus({preventScroll:true}); }catch(_){ inp.focus(); }
  }

  /* liga a aba. Chamada pelo atrelarAvaliacao (07) */
  function avMktWire(){
    var bt=$('mkBtnGerarTextos'); if(!bt) return;
    ['avMktPreco','avMktOutro','avMktOpc','avMktDest'].forEach(function(id){
      var e=$(id); if(e){ e.addEventListener('input',function(){ try{ avFormSalvar(); }catch(_){} });
                          e.addEventListener('change',function(){ try{ avFormSalvar(); }catch(_){} }); }
    });
    var sel=$('avMktPreco');
    if(sel&&sel.selectedIndex<0) sel.value='repasse'; /* rascunho anterior com a opção "loja" */
    if(sel) sel.addEventListener('change',function(){ avMktPrecoPinta(true); });
    var outro=$('avMktOutro');
    if(outro&&typeof avMaskRS==='function') outro.addEventListener('input',avMaskRS);
    avMktPrecoPinta(false);
    if(outro&&typeof avMaskRS==='function') avMaskRS.call(outro);
    bt.onclick=async function(){
      if((($('avMktPreco')||{}).value)==='outro' && !avMktVeiculo().preco_anuncio){
        toast('Digite o outro valor que vai no post.');
        if(outro) outro.focus();
        return;
      }
      avMktEspelhaCampos();
      _mktV=avMktVeiculo();
      _mktDireto=true;
      var extras=''; try{ extras=_mktExtrasDaFicha(); }catch(_){ extras=''; }
      try{ await mktGerarTextos(extras); }catch(_){}
      /* O rascunho da avaliação continua preservado ao trocar de aba. */
      try{
        var ex=(_mktV&&_mktV.extras)||{};
        if(ex.post_ia){
          var h=$('avPostIa'); if(h) h.value=ex.post_ia;
          var he=$('avPostIaEm'); if(he) he.value=ex.post_ia_em||new Date().toISOString();
          avFormSalvar();
        }
      }catch(_){}
    };
    avMktPostSalvoPinta();
  }

/* ╔═══ src/app/07c-vistoria.js ═══════════════════════════════════════════ */
/* ============================================================================
   07c — A VISTORIA DENTRO DE "DADOS DO VEÍCULO"   (v924)
   ----------------------------------------------------------------------------
   PROJETO: AVALIACAO INTEGRADA A DADOS DO VEICULO (06/09/2026)

   O QUE MUDOU, EM UMA FRASE: a aba "Avaliação itens" deixou de existir e o
   que morava nela passou a viver DENTRO de "Dados do veículo", em grupos
   que começam fechados.

   🔑 POR QUE UM MÓDULO NOVO, E NÃO MAIS 600 LINHAS NO 07-avaliacao.js:
   o 07 já tem 186 KB. A regra de leitura barata da casa (v729, FASE 4) manda
   separar ANTES de mexer num módulo que passou de ~80 KB — o padrão `14b-`,
   `14c-` que o estoque já usa. Então a vistoria nasce na casa dela.
   ⚠️ Ele é colado no MESMO IIFE (o montar.js cola tudo em ordem: 07-, 07b-,
   07c-), então enxerga o asel/aselServ/aselCusto/ai do 07 e é enxergado por
   ele. Nada de import, nada de global novo.

   ============================================================================
   AS TRÊS DECISÕES QUE EXPLICAM O RESTO
   ============================================================================

   1. CONDIÇÃO NÃO É CUSTO — E OS DOIS CONVIVEM.
      O projeto diz, com todas as letras: "A condicao observada e diferente do
      custo: custo zero nao prova item bom." Os campos de CUSTO que já existiam
      (avLat, avMec, avPneus, avRev…) continuam EXATAMENTE como estavam — mesmo
      id, mesmas opções, mesmo cálculo na aba Custos. Os campos novos, que
      dizem o que foi OBSERVADO, são outros, com prefixo `avg`.
      ⚠️ Por isso "Pneus" (custo de troca) e "Pneus dianteiros / traseiros"
      (estado observado) aparecem no mesmo grupo sem se contradizerem: um diz
      quanto sai, o outro diz o que se viu.

   2. NADA COMEÇA RESPONDIDO.
      Todo campo novo nasce em "Não verificado" (ou "Não informado" / "Não
      realizado", conforme o tipo). O projeto proíbe o contrário em letras
      maiúsculas: "Registros antigos nao devem ser convertidos para Bom, Nao ou
      Sem indicios por ausencia de dados." Uma avaliação de agosto reaberta
      hoje mostra os campos novos vazios — que é a verdade — e não um laudo
      inventado.

   3. UM SIM/NÃO SÓ NÃO SERVE PRA TUDO.
      "Nao usar um mesmo Sim/Nao para perguntas com sentidos diferentes."
      Cada tipo de pergunta tem a sua lista, e a diferença não é preciosismo:
      · a geometria é percebida somente no teste de rodagem; na inspeção
        externa ficam os sinais visuais de soldas e reparos;
      · "não observei fumaça" não é "não tem fumaça" — por isso existe
        "Inconclusivo" em quase todas;
      · "teste não realizado" nunca pode ser lido como "passou no teste".
   ========================================================================= */
(function(){ /* marcador de leitura — o corpo real está colado no IIFE do app */ })();

  /* ---- 1) OS TIPOS DE RESPOSTA -------------------------------------------
     `opcs` = as opções, na ordem. A PRIMEIRA é sempre a de "ainda não
     respondi" — é ela que o resumo conta como pendente e o avPendMarca pinta
     de cinza.
     `atencao` = as respostas que acendem "ponto de atenção" no resumo do
     grupo fechado. Inconclusivo entra em quase todas de propósito: quem não
     conseguiu ver precisa VOLTAR, e um resumo que engole isso vira um laudo
     otimista. */
  var AV_VIST_TIPOS={
    cons:   { opcs:['Não verificado','Bom','Requer atenção','Não se aplica'],
              atencao:['Requer atenção'] },
    capo:   { opcs:['Não verificado','Sem sinais de intervenção','Com sinais de intervenção','Inconclusivo'],
              atencao:['Com sinais de intervenção','Inconclusivo'] },
    geom:   { opcs:['Não verificado','Sem deformação aparente','Deformação aparente','Inconclusivo'],
              atencao:['Deformação aparente','Inconclusivo'] },
    solda:  { opcs:['Não verificado','Sem indícios aparentes','Com indícios','Inconclusivo'],
              atencao:['Com indícios','Inconclusivo'] },
    estepe: { opcs:['Não verificado','Presente e bom','Requer atenção','Ausente','Não se aplica'],
              atencao:['Requer atenção','Ausente'] },
    obsv:   { opcs:['Não verificado','Não observado','Observado','Inconclusivo'],
              atencao:['Observado','Inconclusivo'] },
    fumaca: { opcs:['Não verificado','Não observada','Branca persistente','Azulada','Preta','Inconclusivo'],
              atencao:['Branca persistente','Azulada','Preta','Inconclusivo'] },
    cambio: { opcs:['Não informado','Manual','Automático','Automatizado','CVT','Outro'],
              atencao:[] },
    luzes:  { opcs:['Não verificado','Apagam após partida','Permanecem acesas','Intermitentes','Inconclusivo'],
              atencao:['Permanecem acesas','Intermitentes','Inconclusivo'] },
    teste:  { opcs:['Não realizado','Realizado','Parcial'], atencao:[] },
    rodgeo: { opcs:['Não verificado','Sem desvio percebido','Puxa para esquerda','Puxa para direita','Inconclusivo'],
              atencao:['Puxa para esquerda','Puxa para direita','Inconclusivo'] },
    repint: { opcs:['Não verificado','Não','Sim','Inconclusivo'],
              atencao:['Sim','Inconclusivo'] }
  };
  function avgPendente(tipo, val){
    var t=AV_VIST_TIPOS[tipo]; if(!t) return false;
    return !String(val||'').trim() || String(val)===t.opcs[0];
  }
  function avgAtencao(tipo, val){
    var t=AV_VIST_TIPOS[tipo]; if(!t) return false;
    return t.atencao.indexOf(String(val||''))>=0;
  }
  /* o select de vistoria. Mesma classe `.avt-in` dos outros campos da tela —
     é ela que o avPendMarca pinta e que o CSS já veste. */
  function avgSel(id, lbl, tipo){
    var t=AV_VIST_TIPOS[tipo]||AV_VIST_TIPOS.cons;
    return '<div class="avt-col"><div class="avt-lbl"><label for="'+id+'">'+lbl+'</label></div>'+
      '<select id="'+id+'" class="avt-in avt-sel" data-avg="'+tipo+'">'+
      t.opcs.map(function(o,i){ return '<option'+(i===0?' selected':'')+'>'+o+'</option>'; }).join('')+
      '</select></div>';
  }
  function avgTexto(id, lbl, ph){
    return '<div class="avt-col avt-full"><div class="avt-lbl"><label for="'+id+'">'+lbl+'</label></div>'+
      '<input id="'+id+'" class="avt-in" placeholder="'+(ph||'')+'"></div>';
  }

  /* ---- 2) AS PEÇAS DA REPINTURA -----------------------------------------
     ⚠️ AS CHAVES SÃO ESTÁVEIS E NÃO SÃO OS RÓTULOS ("usar IDs estaveis para
     grupos e pecas, sem depender de rotulos"). Renomear "Para-lama dianteiro
     esquerdo" amanhã não pode perder a marcação de uma avaliação de hoje.
     ⚠️ Esquerda/direita seguem o SENTIDO DE MARCHA do veículo — está escrito
     na tela, porque metade das divergências de laudo nasce aí. */
  var AV_REP_PECAS=[
    ['capo','Capô'], ['teto','Teto'],
    ['plde','Para-lama dianteiro esquerdo'], ['pldd','Para-lama dianteiro direito'],
    ['pde','Porta dianteira esquerda'],      ['pdd','Porta dianteira direita'],
    ['pte','Porta traseira esquerda'],       ['ptd','Porta traseira direita'],
    ['lte','Lateral traseira esquerda'],     ['ltd','Lateral traseira direita'],
    ['tampa','Tampa do porta-malas'],
    ['pcd','Para-choque dianteiro'],         ['pct','Para-choque traseiro']
  ];
  function avgRepPecasHtml(){
    return '<div class="avg-rep" id="avgRepBox" hidden>'+
      '<div class="avg-rep-tt">Peças com repintura</div>'+
      '<div class="avg-rep-ajuda">Esquerda e direita pelo sentido de marcha do veículo. '+
        'Peça que o carro não tem: marque “Não se aplica” na observação.</div>'+
      '<div class="avg-rep-lista" role="group" aria-label="Peças com repintura">'+
        AV_REP_PECAS.map(function(p){
          return '<label class="avg-pc"><input type="checkbox" class="avg-pc-ck" value="'+p[0]+'">'+
            '<span>'+p[1]+'</span></label>';
        }).join('')+
      '</div>'+
      avgTexto('avgRepOutra','Outra peça','ex: soleira, coluna B…')+
      avgTexto('avgRepObs','Observação da repintura','ex: capô com tonalidade diferente — repintura observada')+
      /* guarda a marcação em campo escondido: é ele que entra na AV_FIELDS e
         viaja pro rascunho, pra nuvem e pra reabertura, sem schema novo. */
      '<input type="hidden" id="avgRepPecas">'+
      /* a confirmação de apagar — inline, no lugar onde a coisa acontece.
         Nada de `confirm()` do navegador: ele trava a tela inteira e, no
         app instalado, aparece com a cara do sistema, não com a do MEV. */
      '<div class="avg-rep-conf" id="avgRepConf" hidden role="alertdialog" aria-live="assertive">'+
        '<div class="avg-rep-conf-tx" id="avgRepConfTx"></div>'+
        '<div class="avg-rep-conf-bts">'+
          '<button type="button" class="avg-bt-sec" id="avgRepCancelar">Cancelar</button>'+
          '<button type="button" class="avg-bt-perigo" id="avgRepLimpar">Apagar as peças</button>'+
        '</div>'+
      '</div>'+
    '</div>';
  }

  /* ---- 3) OS GRUPOS -----------------------------------------------------
     Cada grupo: [chave, título, html, campos].
     `campos` é [id, tipo] — 'legado' são os campos que JÁ existiam (custo,
     documento), e eles contam no resumo com a mesma régua de pendência do
     avPendMarca (vazio, "—…" ou "Verificar"), mas NUNCA acendem ponto de
     atenção: custo não é condição (decisão nº 1 lá em cima). */
  function avgGrupos(v, moto, _pecas){
    var G=[];
    /* 1 — IDENTIFICAÇÃO E DOCUMENTOS (vale pra carro e pra moto) */
    G.push(['ident','Identificação e documentos',
      '<div class="avt-lbl avt-lbl-sec">Documento e débitos</div>'+
      '<div class="avt-g2">'+_pecas.alien+_pecas.multas+'</div>'+
      _pecas.alienBox+
      '<div class="avt-g2">'+_pecas.ipva+_pecas.donos+'</div>'+
      '<div class="avt-lbl avt-lbl-sec">Chave reserva e manual</div>'+
      '<div class="avt-g2">'+_pecas.chave+_pecas.manual+'</div>'+
      '<div class="avt-g2">'+_pecas.revC+_pecas.garantia+'</div>'+
      _pecas.garantiaAte,
      [['avAlien','legado'],['avMultas','legado'],['avIpva','legado'],['avDonos','legado'],
       ['avChave','legado'],['avManual','legado'],['avRevC','legado'],['avGarantia','legado']]]);

    if(moto){
      /* ⚠️ MOTO NÃO RECEBE OS GRUPOS DE CARRO. O projeto é explícito:
         "campos de carros nao devem aparecer para motos". Longarina, estepe,
         câmbio automático e porta traseira não existem numa moto — e um
         formulário que pergunta isso ensina a pessoa a ignorar o formulário.
         A moto fica com a vistoria dela, que já existia, num grupo só. */
      G.push(['moto','Itens da moto', _pecas.porte+_pecas.itens,
        [['avPneuD','legado'],['avPneuT','legado'],['avRelacao','legado'],['avFreios','legado'],
         ['avCaren','legado'],['avMec','legado'],['avEle','legado'],['avFerr','legado'],['avRev','legado']]]);
    } else {
      /* 2 — AVALIAÇÃO EXTERNA
         Externa, estrutura dianteira e traseira formam uma única leitura.
         Geometria não é inferida visualmente: fica somente na rodagem. */
      G.push(['ext','Avaliação externa',
        '<div class="avt-g2">'+_pecas.lat+_pecas.parab+'</div>'+
        '<div class="avt-g2">'+avgSel('avgPneuD','Pneus dianteiros','cons')+avgSel('avgPneuT','Pneus traseiros','cons')+'</div>'+
        '<div class="avt-g2">'+_pecas.pneus+avgSel('avgRepint','Repinturas','repint')+'</div>'+
        avgRepPecasHtml()+
        '<div class="avt-lbl avt-lbl-sec">Estrutura dianteira</div>'+
        '<div class="avt-g2">'+avgSel('avgCapo','Parafusos do capô','capo')+avgSel('avgPainelFr','Painel frontal — soldas','solda')+'</div>'+
        '<div class="avt-lbl avt-lbl-sec">Longarina dianteira esquerda</div>'+
        '<div class="avt-g2">'+avgSel('avgLdeS','Soldas e reparos','solda')+'</div>'+
        '<div class="avt-lbl avt-lbl-sec">Longarina dianteira direita</div>'+
        '<div class="avt-g2">'+avgSel('avgLddS','Soldas e reparos','solda')+'</div>'+
        '<div class="avt-lbl avt-lbl-sec">Porta-malas e traseira</div>'+
        '<div class="avt-g2">'+avgSel('avgEstepe','Estepe','estepe')+avgSel('avgAloj','Alojamento do estepe','cons')+'</div>'+
        '<div class="avg-nota">No alojamento, olhe deformação, corrosão e umidade.</div>'+
        '<div class="avt-g2">'+avgSel('avgSoldaTr','Soldas na traseira','solda')+avgSel('avgBatidaTr','Vestígios de batida traseira','solda')+'</div>'+
        '<div class="avt-lbl avt-lbl-sec">Longarinas traseiras</div>'+
        '<div class="avt-g2">'+avgSel('avgLtrS','Soldas e reparos','solda')+'</div>',
        [['avLat','legado'],['avParab','legado'],['avPneus','legado'],
         ['avgPneuD','cons'],['avgPneuT','cons'],['avgRepint','repint'],
         ['avgCapo','capo'],['avgPainelFr','solda'],['avgLdeS','solda'],['avgLddS','solda'],
         ['avgEstepe','estepe'],['avgAloj','cons'],['avgSoldaTr','solda'],['avgBatidaTr','solda'],['avgLtrS','solda']]]);

      /* 3 — MECÂNICA
         Motor, escapamento, câmbio, embreagem, suspensão, direção e
         freios ficam juntos para evitar grupos fragmentados. */
      G.push(['mec','Mecânica',
        '<div class="avt-g2">'+avgSel('avgMotor','Funcionamento do motor','cons')+avgSel('avgBarulho','Barulho de motor','obsv')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgVazOleo','Vazamento de óleo ou fluido','obsv')+avgSel('avgArref','Arrefecimento','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgSurdina','Surdina / silencioso','cons')+avgSel('avgFumaca','Fumaça no escapamento','fumaca')+'</div>'+
        '<div class="avg-nota">A cor da fumaça entra como observação. O app não conclui defeito por ela.</div>'+
        '<div class="avt-g2">'+_pecas.mec+_pecas.rev+'</div>'+
        '<div class="avt-g2">'+_pecas.revJa+'</div>'+
        _pecas.proxRev+
        '<div class="avt-lbl avt-lbl-sec">Câmbio e embreagem</div>'+
        '<div class="avt-g2">'+avgSel('avgTipoCambio','Tipo de câmbio','cambio')+avgSel('avgEngates','Engates e trocas','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgVazCambio','Vazamentos no câmbio','obsv')+avgSel('avgEmbr','Embreagem','cons')+'</div>'+
        '<div class="avg-nota">Câmbio automático não tem embreagem de pedal: marque “Não se aplica”.</div>'+
        '<div class="avt-g2">'+_pecas.cambio+_pecas.embr+'</div>'+
        '<div class="avt-lbl avt-lbl-sec">Suspensão, direção e freios</div>'+
        '<div class="avt-g2">'+avgSel('avgSuspD','Suspensão dianteira','cons')+avgSel('avgSuspT','Suspensão traseira','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgDirFolga','Folgas na direção','cons')+avgSel('avgFreios','Freios','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgFreioEst','Freio de estacionamento','cons')+_pecas.dir+'</div>'+
        '<div class="avt-g2">'+_pecas.susp+'</div>',
        [['avgMotor','cons'],['avgBarulho','obsv'],['avgVazOleo','obsv'],['avgArref','cons'],
         ['avgSurdina','cons'],['avgFumaca','fumaca'],['avMec','legado'],['avRev','legado'],['avRevJa','legado'],
         ['avgTipoCambio','cambio'],['avgEngates','cons'],['avgVazCambio','obsv'],['avgEmbr','cons'],
         ['avCambio','legado'],['avEmbr','legado'],['avgSuspD','cons'],['avgSuspT','cons'],
         ['avgDirFolga','cons'],['avgFreios','cons'],['avgFreioEst','cons'],['avDir','legado'],['avSusp','legado']]]);

      /* 8 — ELÉTRICA E INTERIOR */
      G.push(['ele','Elétrica e interior',
        '<div class="avt-g2">'+avgSel('avgPiscas','Piscas','cons')+avgSel('avgAlerta','Pisca-alerta','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgFarois','Faróis e lanternas','cons')+avgSel('avgLuzFreio','Luzes de freio e ré','cons')+'</div>'+
        '<div class="avt-g2">'+avgSel('avgLuzPainel','Luzes de advertência no painel','luzes')+_pecas.ac+'</div>'+
        avgTexto('avgLuzQual','Qual luz e quando acende','ex: injeção, acende depois de 5 min'),
        [['avgPiscas','cons'],['avgAlerta','cons'],['avgFarois','cons'],['avgLuzFreio','cons'],
         ['avgLuzPainel','luzes'],['avAc','legado'],['avEstof','legado'],['avPainel','legado'],['avEle','legado']],
        /* os três de custo do interior entram no fim do grupo */
        '<div class="avt-g2">'+_pecas.estof+_pecas.painel+'</div><div class="avt-g2">'+_pecas.ele+'</div>']);
    }

    /* 9 — TESTE DE RODAGEM (carro e moto)
       ⚠️ "Se nao realizado, registrar motivo e nao marcar verificacoes como
       boas." Por isso o motivo é um campo, e por isso NADA aqui vira "bom"
       sozinho: os itens da rodagem nascem "Não verificado" e continuam assim
       enquanto o teste não for marcado. */
    G.push(['rod','Teste de rodagem',
      '<div class="avt-g2">'+avgSel('avgTeste','Teste realizado','teste')+avgSel('avgRodGeo','Geometria / tendência de puxar','rodgeo')+'</div>'+
      avgTexto('avgTesteMot','Motivo (se não realizado ou parcial)','ex: carro sem bateria no pátio')+
      '<div class="avt-g2">'+avgSel('avgVolante','Volante centralizado','cons')+avgSel('avgVibra','Vibrações e ruídos','obsv')+'</div>'+
      '<div class="avt-g2">'+avgSel('avgCambioMov','Câmbio em movimento','cons')+avgSel('avgEmbrMov','Embreagem em movimento','cons')+'</div>'+
      '<div class="avt-g2">'+avgSel('avgFrenagem','Frenagem em movimento','cons')+'</div>'+
      '<div class="avg-nota">Observação visual e rodagem não são laudo estrutural nem medição de geometria.</div>',
      [['avgTeste','teste'],['avgRodGeo','rodgeo'],['avgVolante','cons'],['avgVibra','obsv'],
       ['avgCambioMov','cons'],['avgEmbrMov','cons'],['avgFrenagem','cons']]]);
    return G;
  }

  /* ---- 4) O DESENHO DE UM GRUPO -----------------------------------------
     `<details>`/`<summary>` de propósito: o navegador já entrega abrir/fechar
     por toque E por teclado, `aria-expanded` correto e o conteúdo achável
     pela busca da página — de graça, e sem uma máquina de estado nossa pra
     manter. O projeto aceita as duas formas ("details/summary OU botoes com
     aria-expanded"); esta é a que erra menos.
     ⚠️ Fechar um <details> NÃO desmonta o conteúdo: os campos continuam no
     DOM, com os valores, e o rascunho salva igual. "Fechar grupo nao apaga
     campos" sai de graça também. */
  var _AVG_ICO={
    ident:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="12" r="2.2"/><path d="M14 10h4M14 14h4"/></svg>',
    ext:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 16l1.6-5.2A2 2 0 0 1 8.5 9.4h7a2 2 0 0 1 1.9 1.4L19 16"/><path d="M3 16h18v3H3z"/><circle cx="7.5" cy="19" r="1.4"/><circle cx="16.5" cy="19" r="1.4"/></svg>',
    fre:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M6 7v10"/><path d="M18 7v10"/><path d="M6 12h12"/></svg>',
    tras:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="11" rx="2"/><path d="M3 12h18"/><circle cx="12" cy="15" r="1.4"/></svg>',
    mec:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"/></svg>',
    cam:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 5v14"/><path d="M12 5v14"/><path d="M18 5v14"/><path d="M6 5h12"/><circle cx="12" cy="19" r="1.6"/></svg>',
    sus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v4"/><path d="M9 8h6l-1 8h-4z"/><path d="M12 16v4"/><path d="M8 20h8"/></svg>',
    ele:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>',
    rod:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="2.4"/><path d="M12 4v3.6M12 16.4V20M4 12h3.6M16.4 12H20"/></svg>',
    moto:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17" r="3"/><circle cx="18.5" cy="17" r="3"/><path d="M5.5 17h5l4-7h3"/><path d="M12 10h4"/></svg>'
  };
  function avgGrupoHtml(g){
    var chave=g[0], tit=g[1], corpo=g[2], extra=g[4]||'';
    return '<details class="avg-grupo" id="avg-'+chave+'" data-avg-g="'+chave+'">'+
      '<summary class="avg-head">'+
        '<span class="avg-ico" aria-hidden="true">'+(_AVG_ICO[chave]||_AVG_ICO.ident)+'</span>'+
        '<span class="avg-nome">'+tit+'</span>'+
        /* o resumo é TEXTO. "Mostrar estado com texto, nao somente cor" — e
           por isso ele também é `aria-live`: quem responde um campo com o
           grupo aberto ouve o resumo mudar. */
        '<span class="avg-resumo" id="avgR-'+chave+'" role="status" aria-live="polite">Não iniciado</span>'+
        '<span class="avg-seta" aria-hidden="true"></span>'+
      '</summary>'+
      '<div class="avg-body">'+corpo+extra+'</div>'+
    '</details>';
  }

  /* ---- 5) O RESUMO ------------------------------------------------------
     Três estados, como o projeto pede: "Nao iniciado, X/Y verificados, ou N
     pontos de atencao" — e o de atenção mostra os dois números, porque saber
     que há 2 pontos sem saber de quantos itens não ajuda ninguém. */
  var _AVG_MAPA=null;   /* chave do grupo -> lista de [id, tipo] da montagem atual */
  function avgResumoDe(chave){
    var campos=(_AVG_MAPA&&_AVG_MAPA[chave])||[];
    var total=0, feitos=0, aten=0;
    campos.forEach(function(c){
      var el=$(c[0]); if(!el) return;
      total++;
      var val=String(el.value||'');
      if(c[1]==='legado'){
        /* mesma régua do avPendMarca: vazio, "— …" ou "Verificar" = pendente */
        var txt=(((el.options||[])[el.selectedIndex])||{}).text||val;
        var pend=!val.trim() || /^\s*—/.test(txt) || /^verificar$/i.test(String(txt).trim());
        if(!pend) feitos++;
        return;   /* legado NUNCA acende atenção: custo não é condição */
      }
      if(!avgPendente(c[1], val)) feitos++;
      if(avgAtencao(c[1], val)) aten++;
    });
    return { total:total, feitos:feitos, aten:aten,
      tx: (!feitos && !aten) ? 'Não iniciado'
        : (aten ? (feitos+'/'+total+' · '+aten+(aten===1?' ponto de atenção':' pontos de atenção'))
                : (feitos+'/'+total+' verificados')) };
  }
  function avgResumosPinta(){
    if(!_AVG_MAPA) return;
    Object.keys(_AVG_MAPA).forEach(function(chave){
      var el=$('avgR-'+chave); if(!el) return;
      var r=avgResumoDe(chave);
      var tx=r.tx;
      /* "O resumo recolhido pode mostrar 'Repintura: 3 pecas'." — e ele mora
         AQUI, e não numa função à parte que escreve depois: o pintor roda a
         cada resposta e sobrescreveria qualquer texto colado por fora. Foi
         exatamente o que aconteceu no primeiro rascunho desta versão: a
         contagem aparecia e sumia no clique seguinte. */
      if(chave==='ext'){ var np=avgRepLer().length;
        if(np) tx+=' · Repintura: '+np+(np===1?' peça':' peças'); }
      el.textContent=tx;
      el.classList.toggle('aten', r.aten>0);
      el.classList.toggle('zero', !r.feitos && !r.aten);
      var det=$('avg-'+chave); if(det) det.classList.toggle('tem-aten', r.aten>0);
    });
  }

  /* ---- 6) A MONTAGEM ----------------------------------------------------
     `_pecas` são os pedaços de HTML que o 07 já sabia montar (os campos de
     custo e de documento). Eles chegam prontos e só são COLOCADOS no grupo
     certo — nenhum deles foi reescrito, e é isso que garante que os ids, as
     opções e o cálculo continuem os mesmos. */
  /* v1435 — o mesmo campo de observações agora aparece logo abaixo da
     quilometragem em Dados do veículo. Ele continua sendo o #avObs canônico:
     rascunho, PDF, repasse e compartilhamento não ganham cópias divergentes. */
  function avObservacoesHtml(){
    return '<div class="avt-col avt-full avg-obs-geral av-obs-compartilhada">'+
      '<div class="avt-lbl"><label for="avObs">Observações</label></div>'+
      '<textarea id="avObs" class="avt-in" rows="3" maxlength="4000"></textarea>'+
      '<p class="avt-nota">Estas observações e a quilometragem também acompanham a consulta quando você compartilhar a placa.</p>'+
    '</div>';
  }
  function avVistoriaHtml(v, moto, _pecas){
    var G=avgGrupos(v, moto, _pecas);
    _AVG_MAPA={};
    G.forEach(function(g){ _AVG_MAPA[g[0]]=g[3]; });
    return '<div class="avg-lista" id="avgLista">'+G.map(avgGrupoHtml).join('')+'</div>';
  }
  /* todos os ids que a vistoria cria — entram na AV_FIELDS pra viajar no
     rascunho, na nuvem, na reabertura e na exportação, como qualquer outro. */
  function avVistoriaIds(){
    var ids=[];
    ids=ids.concat(['avgPneuD','avgPneuT','avgRepint','avgRepPecas','avgRepOutra','avgRepObs',
      'avgCapo','avgPainelFr','avgLdeG','avgLdeS','avgLddG','avgLddS',
      'avgEstepe','avgAloj','avgSoldaTr','avgBatidaTr','avgLtrG','avgLtrS',
      'avgMotor','avgBarulho','avgVazOleo','avgArref','avgSurdina','avgFumaca',
      'avgTipoCambio','avgEngates','avgVazCambio','avgEmbr',
      'avgSuspD','avgSuspT','avgDirFolga','avgFreios','avgFreioEst',
      'avgPiscas','avgAlerta','avgFarois','avgLuzFreio','avgLuzPainel','avgLuzQual',
      'avgTeste','avgRodGeo','avgTesteMot','avgVolante','avgVibra','avgCambioMov',
      'avgEmbrMov','avgFrenagem']);
    return ids;
  }

  /* ---- 7) A FIAÇÃO ------------------------------------------------------ */
  var _avgAberto={};    /* chave -> true, sobrevive à troca de aba na MESMA avaliação */
  function avgLembraAberto(){ _avgAberto={}; }
  function avVistoriaWire(){
    var lista=$('avgLista'); if(!lista) return;

    /* abrir/fechar: o <details> faz sozinho; a gente só ANOTA, pra que trocar
       de aba e voltar devolva a tela como estava ("Preservar expansao durante
       a edicao da mesma avaliacao"). */
    Array.prototype.forEach.call(lista.querySelectorAll('details.avg-grupo'),function(d){
      var k=d.getAttribute('data-avg-g');
      if(_avgAberto[k]) d.open=true;
      d.addEventListener('toggle',function(){ _avgAberto[k]=!!d.open; });
    });

    /* o resumo acompanha cada resposta */
    lista.addEventListener('change', function(){ try{ avgResumosPinta(); }catch(_){} });
    lista.addEventListener('input',  function(){ try{ avgResumosPinta(); }catch(_){} });

    avgRepWire();
    avgResumosPinta();
  }

  /* ---- 8) A REPINTURA ---------------------------------------------------
     ⚠️ "Nenhuma peca vem marcada. Lista vazia nao significa ausencia de
     repintura." Por isso a lista só APARECE no "Sim", e por isso trocar o
     "Sim" por outra coisa com peças marcadas PERGUNTA antes de apagar. */
  function avgRepLer(){
    try{ return String((($('avgRepPecas')||{}).value)||'').split(',').filter(Boolean); }
    catch(_){ return []; }
  }
  function avgRepGrava(){
    var m=[];
    Array.prototype.forEach.call(document.querySelectorAll('#avgRepBox .avg-pc-ck'),function(c){ if(c.checked) m.push(c.value); });
    var h=$('avgRepPecas'); if(h) h.value=m.join(',');
    try{ avFormSalvar(); }catch(_){}
    try{ avgResumosPinta(); }catch(_){}   /* a contagem de peças sai daqui */
  }
  /* ⛳ a contagem de peças foi PRA DENTRO do avgResumosPinta (veja lá o
     porquê). Uma função só escreve o resumo; duas brigavam. */
  function avgRepAplica(){
    var s=$('avgRepint'); if(!s) return;
    var box=$('avgRepBox'); if(!box) return;
    box.hidden=(s.value!=='Sim');
  }
  function avgRepWire(){
    var s=$('avgRepint'); if(!s) return;
    var box=$('avgRepBox'), conf=$('avgRepConf');
    var anterior=s.value;
    avgRepAplica();
    /* marca de volta o que estava salvo */
    (function(){
      var m=avgRepLer();
      Array.prototype.forEach.call(box.querySelectorAll('.avg-pc-ck'),function(c){ c.checked=m.indexOf(c.value)>=0; });
    })();
    Array.prototype.forEach.call(box.querySelectorAll('.avg-pc-ck'),function(c){
      c.onchange=function(){ avgRepGrava(); };
    });
    ['avgRepOutra','avgRepObs'].forEach(function(id){
      var e=$(id); if(e) e.addEventListener('input',function(){ try{ avFormSalvar(); }catch(_){} });
    });
    s.onchange=function(){
      var novo=s.value;
      if(anterior==='Sim' && novo!=='Sim' && avgRepLer().length){
        /* 🔴 NÃO APAGA NADA AINDA. Mostra a pergunta e DEIXA o select onde a
           pessoa colocou; cancelar devolve o valor anterior, como o projeto
           manda ("cancelar deve manter a selecao anterior"). */
        var n=avgRepLer().length;
        var tx=$('avgRepConfTx');
        if(tx) tx.textContent='Você marcou '+n+(n===1?' peça':' peças')+'. Mudar para “'+novo+'” apaga esses detalhes.';
        if(conf) conf.hidden=false;
        if(box) box.hidden=false;
        return;
      }
      anterior=novo;
      if(conf) conf.hidden=true;
      avgRepAplica();
      try{ avFormSalvar(); }catch(_){}
      try{ avgResumosPinta(); }catch(_){}
    };
    var bc=$('avgRepCancelar'), bl=$('avgRepLimpar');
    if(bc) bc.onclick=function(){
      s.value=anterior;                 /* volta pro "Sim" */
      if(conf) conf.hidden=true;
      avgRepAplica();
      try{ avgResumosPinta(); }catch(_){}
    };
    if(bl) bl.onclick=function(){
      Array.prototype.forEach.call(box.querySelectorAll('.avg-pc-ck'),function(c){ c.checked=false; });
      var h=$('avgRepPecas'); if(h) h.value='';
      var o=$('avgRepOutra'); if(o) o.value='';
      anterior=s.value;
      if(conf) conf.hidden=true;
      avgRepAplica();
      try{ avFormSalvar(); }catch(_){}
      try{ avgResumosPinta(); }catch(_){}
    };
  }
  /* chamado pelo avFormRestaurar do 07 depois de repor os valores */
  function avVistoriaRestaurou(){
    try{ avgRepAplica(); }catch(_){}
    try{
      var m=avgRepLer();
      Array.prototype.forEach.call(document.querySelectorAll('#avgRepBox .avg-pc-ck'),function(c){ c.checked=m.indexOf(c.value)>=0; });
    }catch(_){}
    try{ avgResumosPinta(); }catch(_){}
  }
  /* abre um grupo por fora (é por aqui que um link antigo pra "Avaliação
     itens" cai: a aba vira Dados do veículo e o grupo se abre) */
  function avVistoriaAbrir(chave){
    try{
      var d=$('avg-'+(chave||'')); if(!d) return false;
      d.open=true; _avgAberto[chave]=true;
      try{ d.scrollIntoView({ block:'start' }); }catch(_){}
      return true;
    }catch(_){ return false; }
  }

/* ╔═══ src/app/07d-repasse-divulgacao.js ═════════════════════════════════ */
  /* Commercial outputs never reuse the internal evaluation PDF/payload. */
  /* Retain legacy draft data; retail publication is no longer an app step. */
  AV_FIELDS.push('avClienteJ');

  function avComercialPrecos(compra,fipe){
    return MEV_AVALIACAO_MOTOR.comerciais(compra,fipe);
  }
  function avComercialPercentual(fipe,preco){
    if(!(fipe>0&&preco>0)) return '';
    var p=(fipe-preco)/fipe*100;
    return Math.abs(p)<.05?'Na FIPE':Math.abs(p).toFixed(1).replace('.',',')+'% '+(p>0?'abaixo':'acima')+' da FIPE';
  }
  /* v1444 — o PDF de repasse aproveita a pesquisa que já foi gerada dentro
     da avaliação. Não dispara nova consulta e não publica dado adicional. */
  function avComercialMercadoPdf(st,r){
    r=r||{};
    if(r.veredicto) kitLista(st,'Veredicto de mercado',[String(r.veredicto)]);
    var vistoria=(r.problemas_recorrentes&&r.problemas_recorrentes.length?r.problemas_recorrentes:(r.pontos_atencao||[])).filter(Boolean);
    if(vistoria.length) kitLista(st,'Itens para vistoria',vistoria);
    var vantagens=(r.vantagens||[]).filter(Boolean);
    if(vantagens.length) kitLista(st,'Vantagens desta versão',vantagens);
    var concorrentes=(r.concorrentes||[]).filter(Boolean).map(function(c){
      var cab=[c.modelo,c.preco].filter(Boolean).join(' · '),det=[];
      if(c.vantagem) det.push('Vantagem: '+c.vantagem);
      if(c.desvantagem) det.push('Desvantagem: '+c.desvantagem);
      if(c.obs) det.push(c.obs);
      return [cab,det.join(' — ')].filter(Boolean).join(' — ');
    }).filter(Boolean);
    if(concorrentes.length) kitLista(st,'Concorrentes diretos',concorrentes);
    var fontes=(r.fontes_pesquisa||[]).map(function(u){
      try{ var url=new URL(String(u)); return url.protocol==='https:'?url.hostname.replace(/^www\./,''):''; }catch(_){ return ''; }
    }).filter(function(host,i,a){return host&&a.indexOf(host)===i;}).slice(0,4);
    if(fontes.length) kitLista(st,'Fontes da pesquisa',fontes);
  }
  function avComercialPdfPaginas(d,modo,imgs){
    if(modo!=='lojista') return [];
    var st=pdfkitNovo({tipo:modo==='lojista'?'REPASSE LOJISTA':'VENDA VAREJO',placa:d.placa||'',lgpdCurto:'Valores de referência na data da emissão.'});
    kitKv2(st,'Veículo',[['Modelo',d.modelo],['Ano',d.ano],['Quilometragem',d.km?Number(d.km).toLocaleString('pt-BR')+' km':''],['Cor',d.cor],['Combustível',d.combustivel]]);
    var preco=[['FIPE',d.fipe>0?brl(d.fipe):'Indisponível'],['Referência FIPE',d.referencia||''],[modo==='lojista'?'Preço de repasse':'Venda varejo',brl(d.preco)]];
    if(modo==='lojista') preco.push(['Comparativo FIPE',avComercialPercentual(d.fipe,d.preco)]);
    kitKv2(st,'Valores',preco);
    if(modo==='lojista'&&d.historico&&d.historico.length>1){
      kitFipe6(st,d.historico,true);
      kitGrafArea(st,d.historico);
    }
    if(modo==='lojista'&&d.mercado) avComercialMercadoPdf(st,d.mercado);
    if(modo==='lojista'&&d.gastos&&d.gastos.length){
      var gastos=d.gastos.map(function(g){return [g.descricao||'Gasto estimado',brl(Number(g.valor)||0)];});
      gastos.push(['Total estimado',brl(Number(d.gastosTotal)||0)]);
      kitKv2(st,'Gastos previstos',gastos);
    }
    /* v1065 — OS OPCIONAIS MARCADOS NA AVALIAÇÃO SAEM NO MATERIAL DO LOJISTA.
       É pra isso que a lista existe: marcar e ninguém ver não serve de nada.
       Os que a pessoa DIGITOU já vieram limpos pelo obsPublica (avOpcTexto),
       que é a porta obrigatória de todo texto livre que sai daqui. */
    if(modo==='lojista'&&d.opcionais&&d.opcionais.length) kitLista(st,'Opcionais deste veículo',d.opcionais);
    if(modo==='lojista'&&d.ficha){
      [['ident','Ficha técnica'],['motor','Motor e transmissão'],['desemp','Desempenho e consumo'],['dim','Dimensões'],['chassi','Freios e suspensão']].forEach(function(g){
        var rows=(d.ficha[g[0]]||[]).filter(function(r){return r[1]&&String(r[1]).trim()&&!/^(Placa|Chassi)$/i.test(r[0]);});
        if(rows.length)kitLista(st,g[1],rows.map(function(r){return r[0]+': '+r[1];}));
      });
      if(d.ficha.itens.length)kitLista(st,'Equipamentos',d.ficha.itens);
    }
    if(d.observacoes) kitTexto(st,d.observacoes);
    if(imgs.length) kitFotos(st,imgs,'Fotos do veículo','');
    return kitFinaliza(st);
  }
  async function avComercialPdf(modo){
    if(modo!=='lojista') return;
    try{
      if(!_mevPdfPronto(function(){avComercialPdf(modo);},false)) return;
      var d;
      {
        var v=veiculoAtual||{};
        d={placa:v.placa,modelo:[v.marca,v.modelo].filter(Boolean).join(' '),ano:String(v.ano_modelo||v.ano||''),km:_km(),cor:v.cor,combustivel:v.combustivel,fipe:Number(v.fipe)||0,referencia:v.mes_ref||v.fipe_mes||v.mes_referencia||v.referencia||'',preco:_digits('avRepPreco'),observacoes:obsPublica(String(($('avObs')||{}).value||'')),fotos:avFotosNormaliza(_avFotos)};
        d.gastos=avGastosLer().filter(function(g){return Number(g.valor)>0||String(g.descricao||'').trim();});
        d.gastosTotal=d.gastos.reduce(function(total,g){return total+(Number(g.valor)||0);},0);
        try{ d.historico=(typeof verHistDe==='function'?verHistDe(v):(v.historico||[])).filter(function(h){return h&&h.valor!=null;}); }catch(_){ d.historico=[]; }
        try{ d.mercado=(typeof avalMercadoNormalizar==='function'?avalMercadoNormalizar(fichaState):{}); }catch(_){ d.mercado={}; }
        try{ d.opcionais=avOpcTexto(); }catch(_){ d.opcionais=[]; }   /* v1065 */
        if(!(d.preco>0)) throw new Error('Informe um preço de repasse válido.');
        d.ficha=avComercialFicha(v);
      }
      toast('Gerando PDF...');
      var imgs=await avalPdfFotosCarrega(d.fotos,d.fotos.length);
      if(imgs.length!==d.fotos.length) throw new Error('Uma foto não carregou. Tente novamente antes de compartilhar.');
      var paginas=avComercialPdfPaginas(d,modo,imgs), blob=kitPdfBlob(paginas);
      if(!blob) throw new Error('Não consegui gerar o PDF.');
      relatorioVisor(kitPrevia(paginas),blob,'veiculo-'+modo+'.pdf');
    }catch(e){toast(e.message||'Não consegui gerar o PDF.');}
  }
  function avComercialFicha(v){
    try{
      var dd=fichaTecObter(v.placa);if(!dd||!fichaTecTemConteudoUtil(dd))return null;
      var p=fichaTecParse(dd),raw=p.raw||{},norm=function(x){return String(x||'').toUpperCase().replace(/[^A-Z0-9]/g,'');};
      if(raw.placa&&norm(raw.placa)!==norm(v.placa))return null;
      if(raw.ano_modelo&&v.ano_modelo&&String(raw.ano_modelo)!==String(v.ano_modelo))return null;
      var ref=dd._mevReferencia;
      if(ref&&(ref.modelo!==norm(v.modelo)||ref.codigo!==norm(v.codigo_fipe||v.cod_fipe||v.fipe_codigo)))return null;
      if(raw.codigo_fipe&&(v.codigo_fipe||v.cod_fipe||v.fipe_codigo)&&norm(raw.codigo_fipe)!==norm(v.codigo_fipe||v.cod_fipe||v.fipe_codigo))return null;
      var vende=fichaVendeDe(v.placa);p.itens=(vende.itens||[]).concat(vende.opcionais||[]);
      return p;
    }catch(_){return null;}
  }

/* ╔═══ src/app/07e-opcionais.js ══════════════════════════════════════════ */
  /* ==========================================================================
     07e — OPCIONAIS DO VEÍCULO  (v1065)
     --------------------------------------------------------------------------
     Pedido do Angelo, 17/09:
       "embaixo do estimativa de gastos, adicione um opcionais do veiculo,
        deixe alguns opcionais como padrao pra flegar: bancos em couro,
        camera de ré, sensor dianteiro, sensor traseiro, pacote adas, central
        multimidia, som original, vidros eletricos, trava eletrica, sensor
        crepuscular, sensor de chuva, piloto automatico, acc, rodas de liga,
        teto solar, ar digital, airbags, direcao eletrica, direcao hidraulica"
       e, depois: "no 2 permita adicionar um opcional que nao ta na lista".

     🔴 POR QUE ISTO É UM ARQUIVO NOVO E NÃO UMA EMENDA NO 07-avaliacao.js:
        o 07 está com 202 KB. A regra da casa (CLAUDE.md, v729 FASE 4) manda
        separar ANTES o pedaço novo, no padrão `07b-`, `07c-` que já existe.
        O 07 recebe só o gancho: quatro linhas.

     🔴 COMO ISTO SOBREVIVE (e por que não inventei persistência nova):
        o autosave da avaliação é uma LISTA DE IDs — o `AV_FIELDS`. O
        `avFormObj()` percorre a lista e lê o `.value` de cada um. Então um
        <input type="hidden"> com JSON dentro entra no rascunho, no
        localStorage E na nuvem sem uma linha de código a mais. É exatamente
        o que o `avGastosJ` já faz desde a v846. Caminho provado, zero risco
        de "esconder a tela apagou o dado".

     🔑 A DECISÃO QUE MANDA NOS PADRÕES: um opcional marcado por engano é uma
        PROMESSA AO LOJISTA. Se o carro não tem e o anúncio diz que tem, quem
        paga o vexame é o Angelo, na entrega. Então só vem marcado o que
        QUALQUER carro rodando hoje tem — vidro elétrico, trava elétrica e
        airbag (obrigatório no Brasil desde 2014). Câmera de ré, multimídia,
        rodas de liga e afins ficam DESMARCADOS, mesmo sendo comuns: errar
        pra menos custa um toque; errar pra mais custa credibilidade.
     ========================================================================== */

  /* [chave, rótulo, vem marcado?] — EM ORDEM ALFABÉTICA, TODOS DESMARCADOS.
     🔴 Foi o Angelo quem decidiu, e a decisão dele é mais forte que a minha:
        eu tinha deixado três marcados de fábrica (vidros, trava, airbags) e
        a lista na ordem em que ele ditou. Ele pediu "deixa todos desmarcados
        e em ordem alfabética" — e está certo pelo MESMO motivo que eu usei
        pra marcar só três: opcional marcado por engano é PROMESSA ao lojista.
        Zero marcados é zero promessa. Quem confere o carro marca o que viu.
     ⚠️ A ordem alfabética também é a que se procura com o olho: numa grade de
        19 itens, saber onde "Teto solar" está sem ler tudo vale mais que
        qualquer agrupamento esperto.
     ⚠️ A terceira coluna CONTINUA EXISTINDO (hoje todos 0). É o interruptor
        que liga um padrão de novo, se um dia ele quiser — sem mexer em
        código nenhum além da lista. */
  var AV_OPCIONAIS=[
    ['acc',         'ACC (piloto adaptativo)', 0],
    ['airbags',     'Airbags',                 0],
    ['ardigital',   'Ar digital',              0],
    /* 🔴 v1230 — O AR-CONDICIONADO NÃO EXISTIA NA LISTA, E ISSO TINHA PREÇO.
       Só havia "Ar digital" (climatizador). Carro com ar MANUAL — a maioria
       do seminovo — não tinha onde ser marcado, então o motor ia ler "sem ar"
       em todos eles e abater indevidamente. Os dois convivem: quem tem
       digital marca digital; quem tem manual marca este. */
    ['arcond',      'Ar-condicionado',         0],
    ['couro',       'Bancos em couro',         0],
    ['camre',       'Câmera de ré',            0],
    ['multimidia',  'Central multimídia',      0],
    ['direeletr',   'Direção elétrica',        0],
    ['dirhidr',     'Direção hidráulica',      0],
    ['milha',       'Faróis de milha',         0],
    ['adas',        'Pacote ADAS',             0],
    ['piloto',      'Piloto automático',       0],
    ['liga',        'Rodas de liga',           0],
    ['crepuscular', 'Sensor crepuscular',      0],
    ['chuva',       'Sensor de chuva',         0],
    ['sensdia',     'Sensor dianteiro',        0],
    ['senstras',    'Sensor traseiro',         0],
    ['som',         'Som original',            0],
    ['teto',        'Teto solar',              0],
    ['trava',       'Trava elétrica',          0],
    ['vidros',      'Vidros elétricos',        0]
  ];
  /* 🔴 As duas direções se excluem: nenhum carro tem as DUAS. Marcar uma
     desmarca a outra. Não é frescura — é o par que mais gera contradição
     numa conferência rápida, e contradição no anúncio o lojista percebe. */
  var _AV_OPC_EXCLUI={ direeletr:'dirhidr', dirhidr:'direeletr' };

  var AV_OPC_MAX_EXTRA=12;          /* teto do "adicionar o que não está na lista" */
  var AV_OPC_EXTRA_TAM=40;          /* um opcional é um NOME, não um parágrafo */

  AV_FIELDS=AV_FIELDS.concat(['avOpcJ']);

  /* ---- leitura / gravação ------------------------------------------------ */
  /* Formato: {"m":["vidros","trava",…],"x":["Engate reboque",…]}
     `m` = marcados da lista fixa · `x` = os que a pessoa digitou. */
  function avOpcLer(){
    var o={m:[],x:[]};
    try{
      var j=JSON.parse((($('avOpcJ')||{}).value)||'null');
      if(j && typeof j==='object'){
        /* ⚠️ só entra chave que EXISTE na lista de hoje. Rascunho antigo com
           uma chave que já saiu não pode ressuscitar um opcional fantasma. */
        var val={}; AV_OPCIONAIS.forEach(function(p){ val[p[0]]=1; });
        o.m=(Array.isArray(j.m)?j.m:[]).filter(function(k){ return val[k]; });
        o.x=(Array.isArray(j.x)?j.x:[]).map(_avOpcLimpa)
              .filter(function(s){ return !!s; }).slice(0,AV_OPC_MAX_EXTRA);
      }
    }catch(_){}
    return o;
  }
  function _avOpcLimpa(s){
    return String(s==null?'':s).replace(/[\r\n\t]+/g,' ').replace(/\s{2,}/g,' ')
             .trim().slice(0,AV_OPC_EXTRA_TAM);
  }
  function avOpcGravar(o){
    var e=$('avOpcJ'); if(!e) return;
    e.value=JSON.stringify({ m:(o&&o.m)||[], x:(o&&o.x)||[] });
    try{ avFormSalvar(); }catch(_){}
  }
  /* 🔴 O PRIMEIRO DESENHO É O QUE SEMEIA OS PADRÕES — e só ele.
     Se o campo já tem qualquer coisa dentro (rascunho salvo, nuvem,
     importação), os padrões NÃO entram: o que a pessoa decidiu vence o que a
     gente achou. Um "marcar de novo a cada pintura" desfaria, calado, todo
     desmarcar que ela fizesse. */
  function avOpcSemeia(){
    var e=$('avOpcJ'); if(!e || String(e.value||'').trim()) return;
    e.value=JSON.stringify({
      m:AV_OPCIONAIS.filter(function(p){ return p[2]; }).map(function(p){ return p[0]; }),
      x:[]
    });
  }

  /* ---- a tela ------------------------------------------------------------ */
  function avOpcBlocoHtml(){
    return '<input type="hidden" id="avOpcJ">'+
      '<div class="av-opc-head"><h3>Opcionais do veículo</h3>'+
        '<output id="avOpcConta" class="av-opc-conta" aria-live="polite">0</output></div>'+
      '<p class="av-opc-sub">Marque o que ESTE carro tem. Vai junto no material do lojista.</p>'+
      '<div class="av-opc-grade" id="avOpcGrade"></div>'+
      '<div class="av-opc-extra">'+
        '<label class="avt-col" for="avOpcNovo">Não está na lista?'+
          '<input class="avt-in" id="avOpcNovo" type="text" maxlength="'+AV_OPC_EXTRA_TAM+'" '+
            'autocomplete="off" placeholder="ex.: Engate para reboque"></label>'+
        '<button type="button" class="av-opc-add" id="avOpcAdd">Adicionar</button>'+
      '</div>'+
      '<div class="av-opc-meus" id="avOpcMeus"></div>';
  }
  function avOpcPinta(){
    var g=$('avOpcGrade'); if(!g) return;
    avOpcSemeia();
    var o=avOpcLer(), tem={}; o.m.forEach(function(k){ tem[k]=1; });
    g.innerHTML=AV_OPCIONAIS.map(function(p){
      return '<label class="av-opc-it'+(tem[p[0]]?' on':'')+'">'+
        '<input type="checkbox" data-opc="'+p[0]+'"'+(tem[p[0]]?' checked':'')+'>'+
        '<span>'+esc(p[1])+'</span></label>';
    }).join('');
    var meus=$('avOpcMeus');
    if(meus) meus.innerHTML=o.x.length
      ? o.x.map(function(s,i){
          return '<span class="av-opc-chip">'+esc(s)+
            '<button type="button" data-opc-rm="'+i+'" aria-label="Remover '+esc(s)+'" title="Remover">&times;</button></span>';
        }).join('')
      : '';
    avOpcConta();
    avOpcWire();
  }
  function avOpcConta(){
    var e=$('avOpcConta'); if(!e) return;
    var o=avOpcLer(), n=o.m.length+o.x.length;
    e.textContent=n===0?'nenhum':(n+(n===1?' item':' itens'));
  }
  function avOpcWire(){
    var g=$('avOpcGrade'); if(!g) return;
    Array.prototype.forEach.call(g.querySelectorAll('[data-opc]'),function(c){
      c.onchange=function(){
        var o=avOpcLer(), k=c.getAttribute('data-opc');
        var fora=o.m.filter(function(x){ return x!==k; });
        if(c.checked){
          var par=_AV_OPC_EXCLUI[k];
          if(par) fora=fora.filter(function(x){ return x!==par; });
          fora.push(k);
        }
        o.m=fora; avOpcGravar(o); avOpcPinta();
      };
    });
    var meus=$('avOpcMeus');
    if(meus) Array.prototype.forEach.call(meus.querySelectorAll('[data-opc-rm]'),function(b){
      b.onclick=function(){
        var o=avOpcLer(); o.x.splice(Number(b.getAttribute('data-opc-rm')),1);
        avOpcGravar(o); avOpcPinta();
      };
    });
    var add=$('avOpcAdd'), campo=$('avOpcNovo');
    if(add&&campo&&!add._lig){
      add._lig=1;
      var por=function(){
        var s=_avOpcLimpa(campo.value);
        if(!s){ campo.focus(); return; }
        var o=avOpcLer();
        /* ⚠️ repetido não entra — nem igual a um da lista fixa, nem a um já
           digitado. Comparação sem acento e sem caixa, porque quem digita
           "camera de re" está falando da mesma coisa que "Câmera de ré". */
        var chave=_avOpcCmp(s);
        var jaFixo=AV_OPCIONAIS.some(function(p){ return _avOpcCmp(p[1])===chave; });
        var jaMeu=o.x.some(function(t){ return _avOpcCmp(t)===chave; });
        if(jaFixo||jaMeu){ toast('Esse opcional já está na lista.'); campo.value=''; return; }
        if(o.x.length>=AV_OPC_MAX_EXTRA){ toast('Você já adicionou '+AV_OPC_MAX_EXTRA+' opcionais fora da lista.'); return; }
        o.x.push(s); avOpcGravar(o); campo.value=''; avOpcPinta();
        try{ $('avOpcNovo').focus(); }catch(_){}
      };
      add.onclick=por;
      /* Enter adiciona — e NÃO envia o formulário junto (o form da avaliação
         não tem submit, mas o Enter num input solto ainda sobe o evento). */
      campo.onkeydown=function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); por(); } };
    }
  }
  /* compara "camera de re" com "Câmera de ré" e vê que é a mesma coisa:
     sem acento, sem caixa, sem pontuação. */
  function _avOpcCmp(s){
    var t=String(s||'').toLowerCase();
    try{ t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    return t.replace(/[^a-z0-9]+/g,' ').trim();
  }

  /* ---- o que SAI daqui --------------------------------------------------- */
  /* Lista pronta pro material do lojista. Os da lista fixa saem com o rótulo
     oficial; os digitados passam pelo `obsPublica` — é a única porta por onde
     texto livre vai pro lojista, e ela tira valor em dinheiro que a pessoa
     tenha escrito sem querer ("Engate R$ 800" vira "Engate"). */
  function avOpcTexto(){
    var o=avOpcLer(), tem={}; o.m.forEach(function(k){ tem[k]=1; });
    var fixos=AV_OPCIONAIS.filter(function(p){ return tem[p[0]]; }).map(function(p){ return p[1]; });
    var meus=o.x.map(function(s){
      try{ return String(obsPublica(s)||'').trim(); }catch(_){ return ''; }
    }).filter(function(s){ return !!s; });
    return fixos.concat(meus);
  }

/* ╔═══ src/app/07f-interesse-repasse.js ══════════════════════════════════ */
  /* ==========================================================================
     07f — INTERESSE REPASSE  (v1068)
     --------------------------------------------------------------------------
     Pedido do Angelo: "em venda lojista permita colocar quem cobriu o valor da
     oferta, flega se tem lojista interessado e o valor que o lojista mandou —
     o primeiro campo fica sugestao compra, segundo campo: avaliacao Avaliex,
     terceiro sugestao venda lojista, quarto sugestao venda varejo — e abaixo
     Interesse Repasse, campo pra por o nome do Lojista, valor ofertado, e o
     valor que entra pra loja 3.000 de margem (lojista mandou 30, entra por 27)"
     e, depois: "margem de 3000 editavel".

     🔴🔴 ANTES DE ESCREVER UMA LINHA EU FUI VER O QUE JÁ EXISTIA — E EXISTIA
        QUASE TUDO. A v705 (29/08) construiu exatamente esta conta: o valor que
        o lojista ofertou, o nome dele, a margem e o resultado. Só que o bloco
        inteiro estava dentro de um `<div hidden class="av-legado-compra">`.
        A mecânica rodava; ninguém via.

        🔑 Então este módulo NÃO reimplementa nada. Ele traz o bloco pra cima,
        veste com as palavras do Angelo e devolve o interruptor que a v705
        tinha aposentado. As funções `avLojCalc` e `avLojWire` continuam sendo
        as mesmas do 07-avaliacao.js — reescrevê-las criaria duas contas pro
        mesmo número, que é como um app passa a discordar de si mesmo.

     🔴 O QUE MUDOU DE VERDADE, e é pouco:
        1. a ORDEM dos quatro campos de cima (pedido, ao pé da letra);
        2. o bloco saiu do `hidden` e virou "Interesse Repasse";
        3. voltou o "flega" — o interruptor `avLojSw`, que a v705 tirou e cujo
           código de ligação ela deixou de pé de propósito ("o avLojWire ainda
           sabe ligá-lo se ele existir no DOM"). Estava escrito lá; só faltava
           o elemento;
        4. a margem padrão foi de 2.000 pra 3.000 — no MOTOR, não aqui
           (06z-avaliacao-motor.js). Ver o porquê no changelog.

     ⚠️ TODOS OS IDs DESTE BLOCO ESTÃO NO `AV_FIELDS`. Mover é permitido;
        sumir do DOM não é. A regra da casa: campo que o autosave lê tem que
        continuar existindo, senão "esconder a tela" vira "apagar o dado"
        (lições v177 e v442).
     ========================================================================== */

  function intRepBlocoHtml(){
    return '<section class="intrep" aria-labelledby="intRepTit">'+
      '<h3 class="intrep-tit" id="intRepTit">Interesse Repasse</h3>'+
      /* o "flega" do pedido. É um checkbox de verdade, com o label inteiro
         como alvo — 44px de altura, regra da v567. */
      '<label class="intrep-sw" for="avLojSw">'+
        '<input type="checkbox" id="avLojSw">'+
        '<span>Tem lojista interessado</span>'+
      '</label>'+
      '<input type="hidden" id="avLojFlag">'+
      '<div id="avLojBox" style="display:none">'+
        '<div class="avt-g2">'+
          '<div class="avt-col"><div class="avt-lbl">Lojista interessado</div>'+
            '<input id="avLojQuem" class="avt-in" placeholder="Nome do lojista" autocomplete="off"></div>'+
          '<div class="avt-col"><div class="avt-lbl">Valor ofertado</div>'+
            '<input id="avLojOferta" class="avt-in" inputmode="numeric" placeholder="R$ 0"></div>'+
        '</div>'+
        '<div class="avt-col"><div class="avt-lbl">Sua margem</div>'+
          '<input id="avLojMargem" class="avt-in" inputmode="numeric" placeholder="R$ 3.000"></div>'+
        '<div class="avt-negoc" id="avLojNeg"></div>'+
      '</div>'+
      /* 🔑 O RESULTADO É O `avValor` DE SEMPRE — o mesmo campo que a tela
         inteira já chama de "valor avaliado da loja" e que a conta da v271
         sempre escreveu. Só o RÓTULO mudou, pras palavras do Angelo. Criar um
         campo novo aqui seria criar um segundo nome pro mesmo número, que é
         o que a v390 proibiu com todas as letras. */
      '<div class="avt-lbl">Valor que entra pra loja <span class="avt-lbl-sub">(ofertado − margem)</span></div>'+
      '<input id="avValor" class="avt-in" style="font-weight:800;color:#166534" placeholder="R$ 0">'+
      '<input type="hidden" id="avValorT">'+
      /* v268: a distância pra FIPE anda colada no valor — ela é sobre ELE. */
      '<div class="avt-difipe" id="avDifFipe" role="status" aria-live="polite"></div>'+
      /* 🔴 v1079 — "remove o quem avaliou" (pedido do Angelo, com print).
         Mesma regra do Ar/Direção: o campo SAI DA VISTA e FICA NO DOM.
         O `avQuem` está no AV_FIELDS, o `avLojPayload()` o lê pro pacote da
         página do lojista e o importador do Avaliex (05i) escreve nele.
         Removê-lo do DOM apagaria, no primeiro autosave, o nome que já
         estava gravado nas avaliações antigas. */
      '<div hidden>'+
        '<div class="avt-lbl">Quem avaliou (loja)</div>'+
        '<input id="avQuem" class="avt-in" placeholder="Nome de quem avaliou">'+
      '</div>'+
    '</section>';
  }

  /* 🔴🔴 QUEM MANDA NO "LIGADO": A CAIXA, QUANDO ELA EXISTE.
     A v705 definia ligado = "tem valor digitado", porque tinha tirado a caixa
     de cena. Com a caixa de volta (pedido do Angelo: "flega se tem lojista
     interessado"), quem manda é ela — senão marcar sem digitar nada fecharia
     o bloco na cara da pessoa, e desmarcar com valor digitado não faria nada.
     ⚠️ E o caminho ANTIGO continua valendo: numa tela sem a caixa, ou num
        rascunho salvo antes desta versão, o valor digitado ainda liga. Sem
        isso, uma avaliação de ontem abriria com o bloco fechado e o lojista
        interessado sumido da vista — o dado ainda lá, invisível. */
  function _intRepLigado(){
    var f=false;
    try{ var h=$('avLojFlag'); f=!!(h && String(h.value||'')==='1'); }catch(_){}
    if($('avLojSw')) return f;
    return f || _avLojNum('avLojOferta')>0;
  }

  /* Rascunho de antes da v1068 que tem oferta mas não tem a bandeira: liga a
     bandeira UMA vez, pra caixa nascer marcada e o bloco nascer aberto. */
  function intRepMigra(){
    try{
      var h=$('avLojFlag'); if(!h) return;
      if(String(h.value||'')!=='1' && _avLojNum('avLojOferta')>0) h.value='1';
    }catch(_){}
  }

/* ╔═══ src/app/08-drawer-notificacoes.js ═════════════════════════════════ */
  /* ============ MENU LATERAL (drawer) + PDF vetorial do relatorio ============ */
  /* ⛳ v526 — O ITEM "CHAT" DO MENU (PROJETO-uma-caixa-de-entrada-so, Parte 3)
     false = o chat mora só no balão (a caixa de entrada única).
     true  = o item volta pro menu, como era até a v525, e o deslize entre
             telas volta a passar por ele sozinho. Uma linha, os dois mundos.
     ⚠️ Mexer AQUI, não no app.html: a `<div id="mdrChatBox">` continua no
     HTML de propósito, e a página (12d) continua inteira. */
  var MEV_CHAT_NO_MENU = false;
  function toast(msg){ var t=$('mevToast'); if(!t){ t=document.createElement('div'); t.id='mevToast'; t.className='mev-toast'; document.body.appendChild(t); } t.textContent=msg; t.classList.add('on'); clearTimeout(toast._t); toast._t=setTimeout(function(){ t.classList.remove('on'); },2400); }

  /* Navegação em FABs: Menu (canto), Voltar (à esquerda) e + Ações (acima).
     mevTabSet reseta pro estado base: só o Menu aparece; Voltar/Ações somem. */
  function mevTabSet(which){ try{ document.body.classList.remove('venda-cot'); document.body.classList.remove('est-2col'); document.body.classList.remove('est-panel-on'); document.body.classList.remove('crm-on');
    /* v433: a página cheia do Chat no celular marca o body. Se a classe
       sobrevivesse à troca de tela, a barra de baixo e os FABs ficariam
       escondidos em TODAS as páginas (o CSS de .ch-fx-on os oculta). */
    document.body.classList.remove('ch-fx-on'); document.body.classList.remove('ch-cad-on'); document.body.classList.remove('consulta-ui-on'); /* v754 */ document.body.classList.remove('conta-on'); /* v755 */ document.body.classList.remove('loja-on'); /* v756 */ document.body.classList.remove('veh-on'); /* v757 */ document.body.classList.remove('oper-on'); /* v795: as cinco telas operacionais */ document.body.classList.remove('mkd-on'); /* v870: a coluna da placa volta ao sair do Mercado */ document.body.classList.remove('resultado-veiculo-on'); /* v884 */ /* 🔴 v795: e RECALCULA. Tirar a classe `oper-on` não basta — quem acende e
    apaga o `dock-largo` (e quem zera o --consulta-ui-dock) é o
    consultaUiDockMedir. Sem esta chamada a Home voltava COM a barra do dock e
    com espaço reservado embaixo, violando o §4.1 do projeto ("Home: sem dock
    inferior"). Foi o teste-v795 que pegou: cinco telas, cinco falhas iguais. */
    try{ if(typeof consultaUiDockMedir==='function') consultaUiDockMedir(); }catch(_){ } }catch(_){} var mf=$('btnMenuFab'); if(mf) mf.style.display='flex'; var bf=$('btnBackFab'); if(bf) bf.style.display='none'; var af=$('btnAcaoFab'); if(af) af.style.display='none'; var prf=$('btnPrintFab'); if(prf) prf.style.display='none'; mevGreetPinta(); mevGreetStart(); }
  /* ---- Saudação da barra inferior (foto + frase que troca) ---- */
  var _GREET_MAN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>';
  var _GREET_FRASES=[
    'Consulta placa, FIPE e ficha num toque só.',
    'Seu estoque e suas cotações na palma da mão.',
    'Gere documentos e cards de venda em segundos.',
    'Menos digitação, mais tempo pra vender.',
    'Cada cliente é uma venda esperando pra acontecer.',
    'Quem atende rápido, fecha mais. Bora! 🚀',
    'A próxima venda pode estar a um contato de distância.',
    'Foco no cliente — o resto é consequência.',
    'Preço certo + bom atendimento = negócio fechado.',
    'Um "não" te aproxima do próximo "sim".',
    'Todo grande vendedor já ouviu muitos nãos.',
    'Constância vence talento. Siga firme. 💪',
    'Dia difícil também constrói resultado.',
    'Recomeçar faz parte. Levanta e vai.',
    'Disciplina hoje, comissão amanhã.',
    'Você é do tamanho dos desafios que encara.'
  ];
  var _greetIdx=0, _greetTimer=null;
  function _primeiroNome(){ var n=String(meuNome||'').trim(); if(!n) return ''; return n.split(/\s+/)[0]; }
  /* v439 (pedido): "tire a saudacao e deixe apenas nome e sobrenome".
     Sai o "Olá," e sai o 👋 — fica NOME + SOBRENOME. Nome do meio e os
     "de/da/dos" ficam de fora: quem tem nome comprido estourava a linha.
     Sem nome nenhum, some o texto em vez de aparecer um "Olá" solto. */
  function _nomeSobrenome(){
    var p=String(meuNome||'').trim().split(/\s+/).filter(Boolean);
    if(!p.length) return '';
    if(p.length===1) return p[0];
    var lig={de:1,da:1,do:1,das:1,dos:1,e:1};
    var sob=''; for(var i=1;i<p.length;i++){ if(!lig[p[i].toLowerCase()]){ sob=p[i]; break; } }
    return sob?(p[0]+' '+sob):p[0];
  }
  function mevGreetPinta(){
    var avatares=[$('hgAva'),$('mdrConsAva')];
    avatares.forEach(function(av){ if(av){ if(meuFoto){ av.style.backgroundImage=imgFundo(meuFoto,96); av.innerHTML=''; } else { av.style.backgroundImage='none'; av.innerHTML=_GREET_MAN; } } });
    var nome=_nomeSobrenome();
    var ola=$('hgOla'); if(ola){ ola.textContent=nome; }
    var nomeMenu=$('mdrConsNome'); if(nomeMenu){ nomeMenu.textContent=nome||'Minha conta'; }
    var fr=$('hgFr'); if(fr) fr.textContent=_GREET_FRASES[_greetIdx]||_GREET_FRASES[0];
    /* v770 (§5.5 do projeto home-menu-e-documentos): tocar na foto/nome
       abre MINHA CONTA direto (o subtítulo do cabeçalho diz isso). O
       mini-menu antigo (greetOpcoes, com Sair) ficou guardado sem uso —
       o Sair continua no avatar do cabeçalho fixo (tbMenu) e no site. */
    var g=$('heroGreet'); if(g) g.onclick=function(){ drawerFechar(false); telaCadastro(); };
  }
  function mevGreetStart(){
    mevGreetStop();
    _greetTimer=setInterval(function(){
      var fr=$('hgFr'); if(!fr){ mevGreetStop(); return; }
      _greetIdx=(_greetIdx+1)%_GREET_FRASES.length;
      fr.style.opacity='0';
      setTimeout(function(){ var f2=$('hgFr'); if(f2){ f2.textContent=_GREET_FRASES[_greetIdx]; f2.style.opacity='1'; } }, 400);
    }, 5000);
  }
  function mevGreetStop(){ if(_greetTimer){ clearInterval(_greetTimer); _greetTimer=null; } }
  var ICO_CTX_DOTS='<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="12" cy="5.5" r="1.9"/><circle cx="12" cy="12" r="1.9"/><circle cx="12" cy="18.5" r="1.9"/></svg>';
  var ICO_CTX_SAVE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>';
  var ICO_CTX_PLUS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  /* v885 — a `mevCtx` continua a mesma; ela só passou a AVISAR a cápsula do
     dock se o 5º botão existe agora. Sem essa marca, o CSS teria que adivinhar
     pelo `style="display:..."` inline — e adivinhar por atributo de estilo é o
     tipo de regra que quebra no dia em que alguém troca `flex` por `block`.
     ⚠️ Uma classe no body, como manda a casa. E ela é a MESMA para as ~10
     telas que já usam a `mevCtx`: nenhuma delas precisou saber disto. */
  function mevCtx(iconSvg, label, fn){ var af=$('btnAcaoFab'); if(!af) return;
    function _marca(tem){ try{ document.body.classList.toggle('dock-tem-acao', !!tem); }catch(_){} }
    if(!iconSvg){ af.style.display='none'; af._fn=null; _marca(false); return; }
    var ic=af.querySelector('.af-ic'); if(ic) ic.innerHTML=iconSvg; af._fn=fn||null; af.style.display='flex'; _marca(true);
    /* a cápsula muda de 4 pra 5 lugares: a altura pode mudar, e o espaço
       reservado embaixo do conteúdo tem que acompanhar */
    try{ if(typeof consultaUiDockMedir==='function') consultaUiDockMedir(); }catch(_){}
  }
  /* v360 (pedido): o FAB de ações virou um + — o ⋮ parecia "menu escondido",
     e o + diz melhor que ali se ACRESCENTA algo (estoque, venda, cliente...). */
  function mevAcoes(on){ if(on && veiculoAtual){ mevCtx(ICO_CTX_PLUS,'Ações',function(){ if(veiculoAtual) histAcoesAbrir(veiculoAtual.placa, $('btnAcaoFab')); }); } else { mevCtx(null); mevPrintFab(false); } }
  /* v241: fab verde que baixa o PRINT da consulta simples — só aparece na
     tela principal do veículo (abrirMenu); nas outras telas ele some. */
  function mevPrintFab(on){ var pf=$('btnPrintFab'); if(pf) pf.style.display=on?'flex':'none'; }
  function mevSalvarLoja(on){ if(on){ mevCtx(ICO_CTX_SAVE,'Salvar',function(){ lojaSalvar(); }); } else { mevCtx(null); } }
  function mevEstNovo(on){ if(on){ mevCtx(ICO_CTX_PLUS,'Opções',function(){ if(typeof estFabMenu==='function'){ estFabMenu($('btnAcaoFab')); } else { estAbrirFicha(null); } }); } else { mevCtx(null); } }
  var _voltarAlvo=null;
  function voltarTab(fn){
    _voltarAlvo=(typeof fn==='function')?fn:null;
    var bf=$('btnBackFab'); if(bf) bf.style.display=_voltarAlvo?'flex':'none';
    var mf=$('btnMenuFab'); if(mf) mf.style.display='flex';
    /* v1347 — a barra do MEV Consultas deriva o controle esquerdo do
       estado real da página. Toda tela interna que registra um retorno troca
       Aparência pelo SVG Voltar; só a Home, sem retorno, mantém o tema. */
    try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar(); }catch(_){}
  }
  var _mevDrawerA11y=null;
  /* 🔴 v793 — QUEM ABRE O DRAWER AVISA OS BOTÕES QUE ELE ABRIU
     O #btnMenuFab e o #tbMenuBt nascem no HTML com aria-expanded="false" e
     nunca ninguém mudava isso: pra um leitor de tela o menu ficava "fechado"
     mesmo aberto, e o destaque visual do item Menu no dock (que é pintado
     por [aria-expanded="true"]) nunca acendia.
     A sincronia mora AQUI, no abrir/fechar, e não no clique de cada botão,
     porque o drawer também é aberto por outros caminhos — o item do menu
     lateral, o botão da top bar e o Escape. Amarrar ao clique deixaria o
     atributo mentindo em todos os outros. §5.3, §8 e §11 do projeto. */
  function _drawerAria(aberto){
    try{
      ['btnMenuFab','tbMenuBt'].forEach(function(id){
        var b=document.getElementById(id);
        if(b) b.setAttribute('aria-expanded', aberto?'true':'false');
      });
    }catch(_){ }
  }

  /* ==========================================================================
     🔴 v814 §9 — A GAVETA ABERTA TRAVA A PÁGINA E APAGA A BARRA DE BAIXO
     Três coisas que faltavam, e as três só se veem no celular:
       1. `body.drawer-aberto` — a classe de estado que o CSS usa pra sumir
          com a tabbar, a fileira de FABs e o botão de menu. Antes eles
          continuavam acesos POR CIMA da faixa escurecida, o que faz o
          scrim parecer um erro de desenho em vez de uma cortina.
       2. a rolagem da página trava. O `.drawer-lock` já existia no CSS
          desde sempre e NINGUÉM colocava a classe — ele é `position:fixed`,
          que zera a rolagem, então guardo o `scrollY` e devolvo no fechar.
          Sem isso, quem abre o menu no meio de uma lista longa volta pro
          topo, e parece que o app perdeu o lugar.
       3. o `overflow` do documento também, porque no iOS o `body` fixo
          sozinho não segura o quique da página.
     O foco preso, o Escape e o `inert` da gaveta continuam no
     mev-accessibility.js — isto aqui não mexe neles. */
  var _drwScroll=0;
  /* v1492 — no MEV Consultas e no MEV Avaliações móvel, a navegação começa
     diretamente pelos grupos. O fechar é o único FAB da gaveta, fica no canto
     inferior e vem depois da navegação na ordem de foco. Aparência permanece
     no início do grupo Conta e suporte. */
  function drawerConsultasBarraPosicionar(){
    try{
      if(!(typeof edicaoAtual==='function' && ['consultas','avalia'].indexOf(edicaoAtual())>=0)) return;
      var d=$('mevDrawer'), top=d&&d.querySelector('.mdr-top'), nav=d&&d.querySelector('.mdr-nav');
      if(!d||!top||!nav) return;
      var tema=d.querySelector('#mdrTema'),conta=d.querySelector('#mdrContaSub .mdr-sub-in');
      var instalar=conta&&conta.querySelector('button[data-acao="instalar"]');
      if(tema&&conta&&conta.firstElementChild!==tema) conta.insertBefore(tema,conta.firstElementChild);
      if(tema&&instalar&&tema.nextElementSibling!==instalar) conta.insertBefore(instalar,tema.nextElementSibling);
      var mobile=!!(window.matchMedia&&window.matchMedia('(max-width: 899px)').matches);
      top.classList.remove('mdr-fechar-integrado');
      top.classList.remove('mdr-fechar-cabecalho');
      top.classList.toggle('mdr-fechar-fab',mobile);
      d.classList.remove('mdr-consultas-pwa');
      if(mobile){
        if(d.lastElementChild!==top) d.appendChild(top);
      }else if(top.nextElementSibling!==nav) d.insertBefore(top,nav);
    }catch(_){ }
  }
  function _drawerTrava(liga){
    try{
      var b=document.body, e=document.documentElement;
      if(liga){
        _drwScroll = window.pageYOffset || e.scrollTop || 0;
        b.classList.add('drawer-aberto');
        b.classList.add('drawer-lock');
        b.style.top = (-_drwScroll)+'px';
      }else{
        b.classList.remove('drawer-aberto');
        b.classList.remove('drawer-lock');
        b.style.top='';
        try{ window.scrollTo(0, _drwScroll); }catch(_){}
      }
    }catch(_){}
  }

  function drawerAbrir(){
    var d=$('mevDrawer'),b=$('mevDrawerBg');
    drawerConsultasBarraPosicionar();
    if(d)d.classList.add('on');
    if(b)b.classList.add('on');
    _drawerAria(true);
    try{ if(typeof temaConsultasPintar==='function') temaConsultasPintar(typeof temaConsultasModo==='function'?temaConsultasModo():temaConsultasEscuro()); }catch(_){}
    /* no computador a gaveta é coluna fixa, não cortina: nada a travar */
    if(!(window.matchMedia && window.matchMedia('(min-width: 900px)').matches)) _drawerTrava(true);
    if(_mevDrawerA11y) _mevDrawerA11y.abrir(document.activeElement);
    /* v351: o item "Painel" só existe pro dono do MEV. Decido aqui, na ABERTURA
       do menu, e não no init: quando o app carrega, o meuId ainda é nulo (a
       sessão chega depois), então um teste feito lá esconderia o item pra
       sempre. Aqui acerta sempre, inclusive logo depois do login. */
    try{
      var _ab=$('mdrAdminBox'), _ed=(typeof window.edicaoAtual==='function')?window.edicaoAtual():'completo';
      if(_ab) _ab.style.display=(_ehAdmin() && _ed==='completo')?'block':'none';
    }catch(_){}
    /* v497 — MESMA lógica pro "Apps MEV": enquanto o MEV_PREVIA estiver
       ligado (00-edicoes.js), a vitrine da família é só do dono — os outros
       lojistas seguem com o app completo e nem ficam sabendo que existem
       edições. Decidido AQUI, na abertura do menu, pelo mesmo motivo do
       Painel: no init o meuId ainda é nulo. Esconder por style INLINE
       também tira o item da rota do deslize, que é o que se quer. */
    try{
      var _ap=document.querySelector('#mevDrawer .mdr-nav [data-acao="apps"]');
      if(_ap){
        var _vis=true;
        try{ _vis=(typeof window.edAppsVisivel==='function')?window.edAppsVisivel(_ehAdmin()):true; }catch(_){ _vis=true; }
        _ap.style.display=_vis?'':'none';
      }
    }catch(_){}
    try{ haAppsSync(); }catch(_){}   /* v497 — a caixinha "Apps MEV" da grade da home */
    /* v1361 — instalar pertence ao site aberto no navegador. No PWA já
       instalado, ou nas outras edições, repetir essa ação só criaria ruído. */
    try{
      var _in=document.querySelector('#mevDrawer [data-acao="instalar"]');
      if(_in){
        var _standalone=!!((window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone);
        _in.style.display=(window.__mevConsultasNoSite&&!_standalone)?'':'none';
      }
    }catch(_){}
    /* v556 — o espelho da Cotação VW: mesmo lugar, mesmo motivo (no init o
       meuId ainda é nulo). Ele é async porque pergunta ao banco de quem é a
       loja; o item nasce escondido no app.html, então o pior caso é ele
       aparecer meio segundo depois — nunca o contrário. */
    try{ cotMenuSync(); }catch(_){}
    try{ vitMenuSync(); }catch(_){}   /* v568 — a Vitrine, mesmo lugar e mesmo motivo */
    /* v948 — no MEV Avaliações, Catálogo e Repasse são vitrines públicas
       para quem ainda não assina e viram entrada de gestão apenas depois de
       o plano elegível ser confirmado. O texto nasce como Visualizar: em
       dúvida de rede, nunca prometemos edição. */
    try{ mdrAvaliaVitrinesSync(); }catch(_){}
    /* v502 — a faixa "Como você quer trabalhar hoje" no alto do menu.
       Montada AQUI, na abertura, pelo mesmo motivo do Painel e do Apps MEV:
       assim ela sempre nasce com a pílula certa pintada. */
    try{ fxFaixaMontar(); }catch(_){}
    /* v433: o Chat só existe pra quem tem Atendente IA. O chatDisponivel()
       responde depois (é uma ida ao banco), então ele repinta sozinho.

       ===== v526 — O CHAT SAIU DO MENU (Parte 3 da caixa de entrada) =====
       ⛳ MEV_CHAT_NO_MENU (logo abaixo) — uma linha traz o item de volta.
       O balão herdou tudo o que a página tinha (fila, filtros, busca, selo
       de espera e a ficha dobrável — v523/v524) e a ficha nasce sozinha
       (v525). Duas portas pra mesma caixa de entrada viraram ruído.

       🔴 O `chatDisponivel()` CONTINUA SENDO CHAMADO. Ele não decide mais o
       item do menu — decide se a **aba Clientes** do painel aparece. Sem
       ele, o balão perderia o chat de cliente na loja que tem atendente.

       🔴 E O ITEM É ESCONDIDO, NÃO APAGADO (regra da casa, e a mesma
       solução do Funil na v437). Isso resolve de graça o risco maior desta
       parte: o DESLIZE entre telas lê `nav.querySelectorAll('button
       [data-acao]')` e PULA o que está com `style="display:none"` (o
       `_menuOculto` do 18b). Item escondido = item fora da rota, sem tocar
       no 18b. Apagar a `<div>` do app.html daria no mesmo, sem volta. */
    try{
      chatDisponivel();
      var _cb=$('mdrChatBox');
      if(_cb) _cb.style.display=(MEV_CHAT_NO_MENU && _chatTem===true)?'block':'none';
    }catch(_){}
    mevGreetPinta();
    try{ notifBadgeAtualiza(); }catch(_){}
    /* v746 — depois de todas as visibilidades: contagens, item ativo e o grupo
       da página atual aberto (os itens assíncronos repetem via mdrSyncLeve) */
    try{ mdrSync(); }catch(_){}
  }
  function mdrAvaliaVitrinesSync(){
    var ed=(typeof window.edicaoAtual==='function')?window.edicaoAtual():'completo';
    if(ed!=='avalia') return;
    var cr=$('mdrCatalogoRot'), rr=$('mdrRepasseRot');
    if(cr) cr.textContent='Catálogo do estoque';
    if(rr) rr.textContent='Portal do repasse';
    function pinta(id, pode, nome){
      var s=$(id), b=s&&s.closest('button'); if(!s||!b) return;
      s.dataset.modo=pode?'gerenciar':'visualizar';
      b.setAttribute('aria-label',nome+' — '+(pode?'gerenciar':'somente visualização'));
    }
    pinta('mdrCatalogoModo',false,'Catálogo do estoque');
    pinta('mdrRepasseModo',false,'Portal do repasse');
    if(typeof acGarantir!=='function') return;
    acGarantir().then(function(){
      pinta('mdrCatalogoModo',typeof acPodeGerirVitrine==='function'&&acPodeGerirVitrine('estoque'),'Catálogo do estoque');
      pinta('mdrRepasseModo',typeof acPodeGerirVitrine==='function'&&acPodeGerirVitrine('repasse_meu'),'Portal do repasse');
      try{ mdrSyncLeve(); }catch(_){}
    });
  }
  /* v746 — os itens que chegam depois (Chat, Cotação VW, Vitrine) só refazem as contagens */
  function mdrSyncLeve(){ try{ mdrContagens(); }catch(_){} }
  function drawerFechar(restaurarFoco){
    var d=$('mevDrawer'),b=$('mevDrawerBg');
    if(d)d.classList.remove('on');
    if(b)b.classList.remove('on');
    _drawerAria(false);
    _drawerTrava(false);   /* v814 §9: destrava a rolagem e devolve dock/tabbar/FABs */
    if(_mevDrawerA11y) _mevDrawerA11y.fechar(restaurarFoco!==false);
  }
  /* ===== NOTIFICAÇÕES (histórico estilo push) ===== */
  var _notifs=[], _notifNaoLidas=0;
  async function notifCarregar(){
    try{ var r=await withTimeout(supa.from('notificacoes').select('*').order('criado_em',{ascending:false}).limit(80),9000); _notifs=(r&&r.data)||[]; }
    catch(_){ _notifs=[]; }
  }
  async function notifBadgeAtualiza(){
    if(!meuId) return;
    try{
      var r=await withTimeout(supa.from('notificacoes').select('id').eq('lida',false).limit(30),8000);
      _notifNaoLidas=((r&&r.data)||[]).length;
    }catch(_){ return; }
    /* 🔴 v640 — A ATUALIZAÇÃO SAIU DO SINO. Da v594 até aqui ela somava 1 no
       badge, porque era um AVISO esperando o dedo. Agora ela se resolve
       sozinha e calada (ver o bloco grande no 19), então não há o que avisar:
       um sino aceso pra uma coisa que já vai acontecer sem ninguém fazer nada
       é um alarme falso — e alarme falso ensina a ignorar o sino de verdade. */
    var _tot=_notifNaoLidas;
    var b=$('mdrNotifBadge'); if(b){ b.textContent=_tot>9?'9+':String(_tot); b.style.display=_tot?'inline-flex':'none'; }
    /* v456 — o sino da topbar mostra o mesmo numero */
    var sb=$('tbSinoN'); if(sb){ sb.textContent=_tot>9?'9+':String(_tot); sb.style.display=_tot?'inline-block':'none'; }
  }
  /* ==========================================================================
     v551 — O MAPA: DE UMA NOTIFICAÇÃO PRO LUGAR DELA
     (PROJETO-link-nas-notificacoes, Fase 1 — pedido: "adicione o link nas
      notificações")

     O que motivou: três avisos na tela terminando em "— abra o balão de
     conversas pra ver". Isso é instrução manual no lugar onde devia ter um
     toque. Aviso que explica como procurar a coisa já falhou.

     🔴🔴 O ACHADO QUE DESENHOU ESTA TABELA: `tipo:'chat'` faz TRÊS trabalhos
     diferentes, medidos no banco em 18/08:
       · "<Loja> te mandou mensagem"        → chat entre lojistas
       · "<Loja> te mandou: <carro> (…)"    → um veículo enviado
       · "Você avisou N lojistas: … (avaliação)" → RECIBO do próprio autor
     Três destinos debaixo de um rótulo só. Por isso a regra olha o tipo E o
     título — e por isso ela mora AQUI.

     🔴 E MORA AQUI POR UM MOTIVO DURO: **quem escreve não é quem leva.** O
     texto "Você avisou N lojistas" NÃO existe neste repositório — vem de
     outro app que grava na mesma tabela. Se a regra morasse em quem escreve,
     esses avisos ficariam sem link pra sempre. Decidindo na hora de
     desenhar, vale pro que já está gravado, pro que este app escrever, e pro
     que o outro escrever amanhã.

     🔴 "NADA" É RESPOSTA LEGÍTIMA. Aviso de sistema ("você ganhou 10
     tokens") não tem pra onde ir — e um botão que erra é pior que nenhum.
     Tipo desconhecido não desenha botão, e o aviso fica exatamente como
     está hoje.

     ⚠️ A DEDUÇÃO PELO TÍTULO É FRÁGIL DE PROPÓSITO: se a frase mudar, o
     botão some (não quebra). A Fase 2 grava a chave no próprio `tipo`, e
     esta dedução vira só a rede pro que já existe.
     ========================================================================== */
  var NTF_DESTINOS = [
    { id:'consulta', rotulo:'Histórico',
      quando:function(t){ return t.indexOf('consulta:')===0; },
      ir:function(){
        if(typeof abrirHistorico!=='function') return false;
        abrirHistorico(); return true; } },
    { id:'zap', ico:'💬', rotulo:'Conversas',
      quando:function(t){ return t.indexOf('zap:')===0; },
      ir:function(n,t){
        if(typeof chatPainelAbrirZap!=='function') return false;
        chatPainelAbrirZap(t.slice(4), n.titulo||''); return true; } },
    /* o chat ENTRE LOJISTAS — a aba Lojas do balão, nunca a página Chat
       (ela saiu do menu na v526; o caminho de lá foi trocado, não apagado)

       🔴 v567 (Fase 2) — A CHAVE PRIMEIRO, O TÍTULO DEPOIS.
       Com `chat:lj:<uuid>` dá pra abrir A CONVERSA daquele lojista; sem ela,
       abre a lista. As duas coisas na mesma regra de propósito: é o MESMO
       aviso, só que um foi gravado antes de a chave existir.
       ⚠️ A DEDUÇÃO PELO TÍTULO NÃO SAI. Ela é o que segura as linhas que já
       estão gravadas e o que o outro app escrever até a Fase 3. Tirar a
       dedução "porque agora tem chave" seria apagar o link do passado. */
    { id:'lojista', ico:'💬', rotulo:'Conversas',
      quando:function(t,tit){
        return t.indexOf('chat:lj:')===0 || (t==='chat' && /te mandou/i.test(tit)); },
      ir:function(n,t){
        var uid = (t.indexOf('chat:lj:')===0) ? t.slice(8) : '';
        if(uid && typeof chatPainelAbrirLojista==='function'){
          chatPainelAbrirLojista(uid, _ntfQuemMandou(n.titulo)); return true; }
        if(typeof chatPainelAbrirLojas!=='function') return false;
        chatPainelAbrirLojas(); return true; } },
    { id:'estoque', ico:'📦', rotulo:'Estoque',
      quando:function(t){ return t.indexOf('estoque_novo:')===0; },
      ir:function(){
        if(typeof telaEstoque!=='function') return false;
        telaEstoque(); return true; } },
    { id:'repasse', ico:'🔄', rotulo:'Repasse',
      quando:function(t){ return t==='repasse' || t.indexOf('repasse:')===0; },
      ir:function(){
        if(typeof telaRepassePortal!=='function') return false;
        telaRepassePortal(); return true; } },
    /* o RECIBO do "avisei os lojistas" — leva pra lista de avaliações.
       ⚠️ o rótulo é "as avaliações", no plural: sem o id da avaliação no
       aviso, o que abre é a LISTA. Prometer "a avaliação" e cair numa lista
       é o tipo de mentirinha que faz a pessoa achar que clicou errado. A
       Fase 2 grava o id e aí o rótulo pode virar singular. */
    { id:'aval', ico:'✅', rotulo:'Avaliações',
      /* v567 — o prefixo `chat:aval:` já é aceito pra quando a Fase 3 fizer o
         MEV Tools gravá-lo. Aceitar antes custa uma linha e evita que o dia
         da Fase 3 precise mexer aqui de novo. */
      quando:function(t,tit){
        return t.indexOf('chat:aval:')===0 || (t==='chat' && /^você avisou/i.test(tit)); },
      ir:function(){
        if(typeof telaAvaliacoes!=='function') return false;
        telaAvaliacoes(); return true; } }
  ];
  /* v567 — o nome de quem mandou, tirado do título ("<Loja> te mandou…").
     ⚠️ Devolve VAZIO quando não reconhece o padrão: quem chama tem um plano B
     ("Loja"), e um nome chutado no cabeçalho da conversa é pior que nenhum. */
  function _ntfQuemMandou(tit){
    var m=String(tit||'').match(/^(.+?)\s+te mandou/i);
    return m ? m[1].trim() : '';
  }
  /* a regra que casa com esta notificação — ou nada */
  function _ntfDestino(n){
    var t=String((n&&n.tipo)||''), tit=String((n&&n.titulo)||'');
    for(var i=0;i<NTF_DESTINOS.length;i++){
      try{ if(NTF_DESTINOS[i].quando(t,tit)) return NTF_DESTINOS[i]; }catch(_){}
    }
    return null;
  }
  /* ⚠️ aceita a notificação INTEIRA (v551) ou só o tipo (como era antes):
     o ícone passou a depender do título nos casos de `chat`, e um segundo
     jeito de descobrir o ícone divergiria do destino no primeiro dia. */
  function _ntfIco(t){
    var n = (t && typeof t==='object') ? t : { tipo:t, titulo:'' };
    var d = _ntfDestino(n);
    if(d && d.ico) return d.ico;
    t = String(n.tipo||'');
    return _ntfIcoBase(t);
  }
  function _ntfIcoBase(t){
    if(String(t||'').indexOf('consulta:')===0) return mkIco('ficha',19);
    if(t==='pagamento'||String(t||'').indexOf('pagamento:')===0) return mkIco('carteira',19);
    if(t==='renovacao') return '🔔';
    if(t==='troca') return '🔄';
    if(t==='repasse'||String(t||'').indexOf('repasse:')===0) return mkIco('carro',19);
    /* v448: lojista novo entrou. Mesmo sem isto a notificação apareceria (o
       fallback é a estrela), mas ela merece ser reconhecida de longe — é a
       única desta lista que significa cliente novo chegando. */
    if(t==='cadastro') return '🎉';
    /* v457 — convite de indicador (o tipo carrega o codigo: 'indicador:XXX') */
    if(String(t||'').indexOf('indicador:')===0) return '🤝';
    /* v548 — cliente escreveu no WhatsApp (o tipo carrega a conversa:
       'zap:<8 dígitos>'). Mesmo truque do indicador: o tipo é a chave. */
    if(String(t||'').indexOf('zap:')===0) return '💬';
    return '⭐';
  }
  function _ntfQuando(ts){
    try{
      var d=new Date(ts), diff=(Date.now()-d.getTime())/60000;
      if(diff<1) return 'agora';
      if(diff<60) return Math.floor(diff)+' min';
      if(diff<1440) return Math.floor(diff/60)+' h';
      if(diff<10080) return Math.floor(diff/1440)+' d';
      return d.toLocaleDateString('pt-BR');
    }catch(_){ return ''; }
  }
  /* Preferências de ofertas são opt-in e pertencem à conta. A assinatura não
     é decidida por metadata: ela é conferida pelo servidor antes de qualquer
     envio de notificação. */
  function repassePrefLer(){
    /* 🔴🔴 v549 — ESPELHO DO SERVIDOR, e é aqui que ele podia mentir.
       No `notificar-repasse.js` o padrão virou "nunca escolheu = RECEBE".
       Se esta função continuasse com `===true`, as duas caixas nasceriam
       DESMARCADAS enquanto o aviso chegava — a tela dizendo uma coisa e o
       servidor fazendo outra. É o defeito que mais custou versão nesta casa
       (lição da v541). Mudou lá, muda aqui. */
    var p=(meuMeta&&meuMeta.repasse_ofertas);
    if(!p || typeof p!=='object') return { carros:true, motos:true };
    return { carros:p.carros!==false, motos:p.motos!==false };
  }
  function repasseAssinaturaAtiva(){
    var a=(_assinatura&&_assinatura.assinatura)||null;
    return !!(a&&a.ativo&&(a.dias==null||Number(a.dias)>=0));
  }
  function repassePrefHtml(prefix){
    /* v549: a pergunta virou AFIRMAÇÃO porque o padrão virou "recebe".
       O interruptor agora DESLIGA — antes ele era a única forma de ligar, e
       quase ninguém chegava a vê-lo (ver o bloco grande no
       netlify/functions/notificar-repasse.js). */
    var p=repassePrefLer();
    return '<section class="rep-pref" aria-labelledby="'+prefix+'Tit">'+
      '<div class="rep-pref-head"><h3 id="'+prefix+'Tit">Ofertas de repasse</h3><p>Você recebe um aviso aqui quando uma loja publica uma oferta nova. Desmarque o que não quiser.</p></div>'+
      '<div class="rep-pref-opcoes" role="group" aria-label="Tipos de oferta de repasse">'+
        '<label class="vd-ck'+(p.carros?' on':'')+'"><input type="checkbox" id="'+prefix+'Carros"'+(p.carros?' checked':'')+'><span>Carros</span></label>'+
        '<label class="vd-ck'+(p.motos?' on':'')+'"><input type="checkbox" id="'+prefix+'Motos"'+(p.motos?' checked':'')+'><span>Motos</span></label>'+
      '</div><div class="cad-msg rep-pref-msg" id="'+prefix+'Msg" aria-live="polite"></div></section>';
  }
  async function repassePrefMontar(targetId,prefix){
    var alvo=$(targetId); if(!alvo) return;
    alvo.innerHTML='';
    await assinaturaCarregar();
    if(!repasseAssinaturaAtiva()) return;
    alvo.innerHTML=repassePrefHtml(prefix);
    var carros=$(prefix+'Carros'), motos=$(prefix+'Motos'), msg=$(prefix+'Msg');
    var campos=[carros,motos].filter(Boolean);
    function pintar(){ campos.forEach(function(c){ var lb=c&&c.parentElement; if(lb) lb.classList.toggle('on',!!c.checked); }); }
    async function salvar(){
      var pref={ carros:!!(carros&&carros.checked), motos:!!(motos&&motos.checked), atualizado_em:new Date().toISOString() };
      campos.forEach(function(c){ c.disabled=true; });
      if(msg){ msg.className='cad-msg rep-pref-msg'; msg.textContent='Salvando preferências…'; }
      try{
        /* v758: só o patch — a fila única (cadMetaAtualizar) funde com o metadata mais recente */
        await cadMetaAtualizar({ repasse_ofertas:pref }, 'repasse');
        if(msg){ msg.className='cad-msg ok rep-pref-msg'; msg.textContent='Preferências salvas.'; }
      }catch(_){
        if(msg){ msg.className='cad-msg err rep-pref-msg'; msg.textContent='Não consegui salvar agora. Tente novamente.'; }
      }finally{ campos.forEach(function(c){ c.disabled=false; }); pintar(); }
    }
    campos.forEach(function(c){ c.onchange=function(){ pintar(); salvar(); }; });
  }
  async function telaNotificacoes(){
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>Notificações</h2><div id="ntfPush"></div><div id="ntfRepassePref"></div><div id="ntfLista">'+skelHtml(4)+'</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    /* v550 — o cartão de ligar a notificação no celular fica AQUI, que é
       onde o sino da topbar leva. Era o pedido: poder ativar pelo sino, e não
       só por um sininho escondido na barra da página Leads.
       ⚠️ Ele só aparece quando o servidor tem a chave VAPID (ver o bloco
       grande no 12b) — convite que só sabe falhar é pior que nenhum. */
    await Promise.all([notifCarregar(),repassePrefMontar('ntfRepassePref','ntfRepasse'),
                       (typeof pushCartaoMontar==='function'?pushCartaoMontar('ntfPush'):Promise.resolve())]);
    var el=$('ntfLista'); if(!el) return;
    /* ⛳ v640 — O CARTÃO "Atualização disponível" SAIU DAQUI. Ele era da v594
       e existia pra oferecer o botão "Atualizar agora"; a v640 fez a
       atualização acontecer sozinha, então o cartão passou a anunciar uma
       coisa que já está resolvida. Desligar mostrando o caminho (v568): o que
       ele era está escrito aqui, e a `updAtualizarAgora` continua viva no 19
       — só que agora quem a chama é a régua de segurança, não um dedo. */
    var _updCard='';
    if(!_notifs.length){ el.innerHTML=_updCard+'<div class="cli-empty"><b>Nenhuma notificação ainda</b>Avisos de pagamento, renovação da assinatura e novidades aparecem aqui.</div>'; }
    else {
      el.innerHTML=_updCard+_notifs.map(function(n){
        return '<div class="ntf'+(n.lida?'':' nova')+'"><span class="ntf-ic">'+_ntfIco(n)+'</span>'+
          '<div class="ntf-tx"><div class="ntf-t">'+esc(n.titulo||'')+(n.lida?'':'<i class="ntf-dot"></i>')+'</div>'+
          (n.corpo?('<div class="ntf-c">'+esc(n.corpo)+'</div>'):'')+
          (String(n.tipo||'').indexOf('indicador:')===0?('<button type="button" class="ntf-aceitar" data-cod="'+esc(String(n.tipo).slice(10))+'">Aceitar convite</button>'):'')+
          /* v548 — a notificação do WhatsApp LEVA pra conversa. Aviso que
             diz "fulano te chamou" e não abre nada obriga a pessoa a
             procurar a conversa na mão, que é o trabalho que o aviso
             deveria ter poupado. */
          /* v551 — o botão sai do MAPA (o `data-zap` da v548 virou uma
             regra dele, pra não existirem dois caminhos pro mesmo lugar) */
          (function(){ var d=_ntfDestino(n);
  return d ? ('<button type="button" class="ntf-link" data-ntf="'+esc(d.id)+'" data-i="'+esc(String(n.id||''))+'">'+esc(d.rotulo)+'</button>') : ''; })()+
          '<div class="ntf-q">'+_ntfQuando(n.criado_em)+'</div></div></div>';
      }).join('');
      /* v551 — um clique só, pro mapa inteiro */
      Array.prototype.forEach.call(el.querySelectorAll('[data-ntf]'),function(bt){
        bt.onclick=function(){
          var id=bt.getAttribute('data-ntf'), qual=bt.getAttribute('data-i');
          var n=(_notifs||[]).filter(function(x){ return String(x.id||'')===String(qual); })[0];
          var regra=NTF_DESTINOS.filter(function(r){ return r.id===id; })[0];
          if(!n || !regra) return;
          var foi=false;
          try{ foi=regra.ir(n, String(n.tipo||'')); }catch(_){ foi=false; }
          /* ⚠️ se o destino não existe neste build, DIZ — em vez de um
             clique que não faz nada e parece app travado */
          if(!foi) toast('Não consegui abrir isso agora.');
        };
      });
      /* v457 — Aceitar convite: MESMA porta do codigo (indicador_entrar).
         O dono recebe o aviso de aceite pela propria RPC.

         🔴🔴 v569 — O SELETOR É `[data-cod]`, E ELE É O CONSERTO DA VERSÃO.
         Este laço pegava `.ntf-aceitar` INTEIRO. Só que o botão do mapa
         (v551) nasce com a MESMA classe — ela é quem dá o visual. Resultado:
         este `bt.onclick=` passava por cima do onclick do mapa, e o botão
         do mapa caía no `if(!cod) return` da primeira linha daqui.
         O toque não abria nada, não dava erro e não mostrava aviso: o app
         parecia travado. Foi o defeito de "os botões não estão funcionando".
         ⚠️ NÃO troque a classe do botão do mapa pra resolver — é ela que
         pinta. Quem tem que ser específico é o SELETOR: convite é quem
         carrega `data-cod`. */
      Array.prototype.forEach.call(el.querySelectorAll('.ntf-aceitar[data-cod]'),function(bt){
        bt.onclick=async function(){
          var cod=bt.getAttribute('data-cod')||''; if(!cod) return;
          bt.disabled=true; bt.textContent='Aceitando...';
          try{
            var r=await supa.rpc('indicador_entrar',{p_codigo:cod,p_nome:meuNome||''});
            var d=(r&&r.data)||{}; if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(_){ d={}; } }
            if(d.ok){ bt.textContent='Convite aceito ✓'; toast('Pronto! A '+(d.loja||'loja')+' entrou em "Lojas que eu divulgo".'); }
            else if(d.erro==='nao_encontrada'){ bt.textContent='Convite vencido'; toast('Esse convite não vale mais — a loja trocou o código.'); }
            else if(d.erro==='ja_e_dono'){ bt.textContent='—'; toast('Essa loja é a sua.'); }
            else { bt.disabled=false; bt.textContent='Aceitar convite'; toast('Não consegui aceitar agora. Tente de novo.'); }
          }catch(_){ bt.disabled=false; bt.textContent='Aceitar convite'; toast('Não consegui aceitar agora. Tente de novo.'); }
        };
      });
    }
    /* marca tudo como lido (o destaque some na próxima visita) */
    try{ if(_notifs.some(function(n){ return !n.lida; })){ supa.from('notificacoes').update({lida:true}).eq('lida',false).then(function(){},function(){}); _notifNaoLidas=0;
      /* 🔴 v640: sem a pendência de atualização no sino, "marcar tudo como
         lido" volta a APAGAR o badge inteiro — que é o que a palavra "tudo"
         sempre prometeu. Da v594 até aqui ele teimava em 1. */
      var bb=$('mdrNotifBadge'); if(bb) bb.style.display='none';
      var sc=$('tbSinoN'); if(sc) sc.style.display='none'; } }catch(_){}
  }
  /* clicar na foto/saudação → escolher Meu cadastro ou Sair */
  function greetOpcoes(){
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:300px;padding:10px">'+
      '<button type="button" class="go-item" id="goCad"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg><span>Meu cadastro</span></button>'+
      '<button type="button" class="go-item out" id="goOut"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg><span>Logout</span></button>'+
      '<button type="button" class="link" id="goFechar" style="margin-top:8px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    $('goCad').onclick=function(){ close(); drawerFechar(false); telaCadastro(); };
    $('goOut').onclick=function(){ close(); _hardLogout(); location.reload(); };
    $('goFechar').onclick=close;
  }

  /* ===== v259 — DESLIZAR O DEDO ABRE / FECHA O MENU DA ESQUERDA (pedido) =====
     Arrastar pra DIREITA em qualquer ponto da tela inicial PUXA o menu;
     arrastar pra ESQUERDA joga ele de volta (isso vale em qualquer tela, desde
     que o menu esteja aberto). O menu ACOMPANHA O DEDO e completa sozinho
     quando a pessoa solta — se soltar no meio do caminho, ele volta.
     Fica de fora, pra não roubar gesto de ninguém: telas largas (o menu já é
     uma coluna fixa lá), campo de texto, carrossel que rola de lado, e
     qualquer modal aberto. */
  (function(){
    var LARG=300, x0=0, y0=0, dx=0, valendo=false, arrastando=false, jaAberto=false;
    function _dw(){ return document.getElementById('mevDrawer'); }
    function _bg(){ return document.getElementById('mevDrawerBg'); }
    /* sobe a árvore procurando algo que já rola na horizontal (carrossel, abas) */
    function _rolaDeLado(el){
      for(; el && el!==document.body; el=el.parentElement){
        try{
          if(el.scrollWidth>el.clientWidth+4){
            var ov=getComputedStyle(el).overflowX;
            if(ov==='auto'||ov==='scroll') return true;
          }
        }catch(_){}
      }
      return false;
    }
    /* v288 — as telas que se sobrepõem ao app inteiro. Só conta a que está
       de fato visível: .crop-bg e .fsrc-bg vivem no HTML com display:none e
       só aparecem com a classe "on". */
    function _temOverlay(){
      try{
        return !!document.querySelector('.crop-bg.on,.fsrc-bg.on,.plcconf-zoom,#cropBg.on,#plcConfBg.on');
      }catch(_){ return false; }
    }
    function _podeComecar(t){
      if(window.innerWidth>=900) return false;                        /* desktop: menu já é fixo */
      if(!document.body.classList.contains('app-on')) return false;   /* ainda no login */
      var d=_dw(); if(!d) return false;
      if(!t || !t.closest) return false;
      if(t.closest('input,textarea,select,[contenteditable="true"],input[type="range"]')) return false;
      if(t.closest('.cropmask,.cli-mbg,[role="dialog"],#mevPublicoViewer,.mev-publico')) return false;
      /* v288 — ENQUANTO TEM TELA POR CIMA, O GESTO DE LADO NÃO É DO MENU.
         O recorte da foto da placa (.crop-bg, z-index 300) e a confirmação
         da placa (.fsrc-bg, z-index 320) ficam ACIMA do menu (z-index 130).
         Arrastar o retângulo de recorte para a direita fazia o menu abrir
         ESCONDIDO atrás do recorte — e ele só aparecia depois, já em cima
         da consulta. Testar o alvo do toque não bastava: o fundo do modal
         não está dentro do [role="dialog"], e a imagem do recorte também
         não. Então a regra passa a ser a tela: se existe overlay aberto,
         o menu não escuta o dedo. */
      if(_temOverlay()) return false;
      if(_rolaDeLado(t)) return false;
      if(d.classList.contains('on')) return true;                     /* FECHAR: vale em qualquer tela */
      var home=document.getElementById('telaHome');                   /* ABRIR: só na tela inicial */
      return !!home && home.style.display!=='none' && !document.body.classList.contains('tela-interna');
    }
    function _solta(){
      var d=_dw(), b=_bg();
      if(d){ d.style.transition=''; d.style.transform=''; }
      if(b){ b.style.transition=''; b.style.opacity=''; }
    }
    document.addEventListener('touchstart',function(e){
      valendo=false; arrastando=false;
      if(!e.touches || e.touches.length!==1) return;
      if(!_podeComecar(e.target)) return;
      var d=_dw();
      try{ LARG=d.getBoundingClientRect().width||300; }catch(_){ LARG=300; }
      jaAberto=d.classList.contains('on');
      x0=e.touches[0].clientX; y0=e.touches[0].clientY; dx=0; valendo=true;
    },{passive:true});
    document.addEventListener('touchmove',function(e){
      if(!valendo) return;
      if(!e.touches || e.touches.length!==1){ valendo=false; return; }
      var d=_dw(), b=_bg(); if(!d){ valendo=false; return; }
      dx=e.touches[0].clientX-x0;
      var dy=e.touches[0].clientY-y0;
      if(!arrastando){
        if(Math.abs(dy)>24 && Math.abs(dy)>Math.abs(dx)){ valendo=false; return; }   /* virou rolagem vertical */
        if(Math.abs(dx)<18 || Math.abs(dx)<Math.abs(dy)*1.4) return;                 /* ainda não é gesto de lado */
        if(!jaAberto && dx<0){ valendo=false; return; }                              /* fechado + pra esquerda: não é comigo */
        if(jaAberto && dx>0){ valendo=false; return; }                               /* aberto + pra direita: idem */
        arrastando=true;
        d.style.transition='none';
        if(b){ b.style.transition='none'; b.classList.add('on'); }
      }
      /* posição do menu: 0 = todo aberto, -LARG = todo escondido */
      var pos = jaAberto ? Math.max(-LARG, Math.min(0, dx)) : Math.min(0, dx-LARG);
      d.style.transform='translateX('+pos+'px)';
      if(b) b.style.opacity=String(Math.max(0, Math.min(1, (LARG+pos)/LARG)));
      if(e.cancelable) e.preventDefault();   /* segura a rolagem enquanto o menu acompanha o dedo */
    },{passive:false});
    document.addEventListener('touchend',function(){
      if(!valendo) return;
      valendo=false;
      if(!arrastando) return;
      arrastando=false;
      _solta();
      /* passou de ~28% da largura (ou 60px)? completa. Senão, volta pro lugar. */
      var passou = Math.abs(dx) > Math.max(60, LARG*0.28);
      if(jaAberto){ if(passou) drawerFechar(false); else drawerAbrir(); }
      else       { if(passou) drawerAbrir();       else drawerFechar(false); }
    });
    document.addEventListener('touchcancel',function(){
      if(arrastando){ _solta(); if(jaAberto) drawerAbrir(); else drawerFechar(false); }
      valendo=false; arrastando=false;
    });
  })();

/* ╔═══ src/app/09-portal-repasse.js ══════════════════════════════════════ */
  /* =================== REDE / PORTAL DE REPASSE ===================
     Cada loja publica carros; TODAS as lojas veem e (fase 2) ofertam.
     Publicação parte da Avaliação (marcar "Publicar no repasse"). */
  var _repRede=[], _repMeu=[], _repView='rede', _repErroP=false;
  var _portalMembro=null, _portalMembroCarregado=false, _repMembros=[], _membrosAtivosIds={}, _membrosAtivos=[], _repOfertasRecebidas=[], _repOfertasEnviadas=[];
  function _repDinheiro(n){ n=Number(n)||0; return n>0?('R$ '+Math.round(n).toLocaleString('pt-BR')+',00'):'—'; }  /* v254: padrao com centavos */
  /* ===== v288 (pedido) — O PREÇO NÃO VAI MAIS PRO PORTAL. =====
     "Não publique o preço no portal do repasse, deixe um faça sua oferta."

     No SEU carro você continua vendo o preço (é seu). No carro das OUTRAS
     lojas, onde antes aparecia o valor, agora aparece "Faça sua oferta".

     E não é só a tela: o preço dos outros NÃO CHEGA MAIS NO APARELHO. O
     portal parou de ler a tabela direto e passou a chamar a função
     mp_repasse_rede, que monta a resposta campo a campo e só devolve o
     preço pra quem é dono da linha. Se fosse só esconder na tela, qualquer
     pessoa abriria o "inspecionar" do navegador e leria o número. */
  function _repMeuCarro(x){ return !!(x && (x.meu===true || String(x.user_id)===String(meuId))); }
  function _repPrecoHtml(x, classe){
    /* v400 (pedido): a FIPE aparece junto do preço nos repasses — vem do
       retrato do veículo gravado no anúncio (anúncios antigos podem não ter). */
    var _f=Number(((x&&x.veiculo)||{}).fipe)||0;
    var fipeHtml=_f>0?('<span class="rep-fipe" title="Tabela FIPE">FIPE '+_repDinheiro(_f)+'</span>'):'';
    /* ===== v453 (pedido) — O PREÇO VOLTOU, E COM A MAIOR OFERTA =====
       "mostre o valor que a loja quer, o valor da oferta mais alta, mas não
       mostre a informação de quem ofertou."

       ⚠️ Isto reverte de propósito o que a v288 fez (o texto acima, de 2026,
       continua aí pra história): naquela versão o preço dos outros parou até
       de SAIR DO BANCO. A migração v453_repasse_preco_e_oferta_maxima
       devolveu o `preco` pra todo mundo e acrescentou o `oferta_max`.
       O raciocínio novo é de mercado: preço à vista faz a rede negociar mais
       rápido, e a maior oferta cria a disputa que fecha o carro.

       ⚠️ E o que NÃO voltou: quem ofertou. O `oferta_max` é só o número —
       de_loja_nome, de_whatsapp e a mensagem continuam fora da resposta do
       servidor. A rede vê em quanto está a disputa, nunca com quem. Oferta
       recusada não entra: proposta rejeitada não é patamar de negociação. */
    var _pr=Number(x&&x.preco)||0;
    var _of=Number(x&&x.oferta_max)||0;
    var _ofHtml=_of>0?('<span class="rep-ofmax">Maior oferta '+_repDinheiro(_of)+'</span>'):'';
    if(_pr>0) return '<span class="'+(classe||'est-preco')+'">'+_repDinheiro(_pr)+'</span>'+fipeHtml+_ofHtml;
    return '<span class="'+(classe||'est-preco')+' rep-oferta">Faça sua oferta</span>'+fipeHtml+_ofHtml;
  }
  function _repWa(num, txt){ num=String(num||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(!num) return; if(num.length<=11) num='55'+num; var u='https://wa.me/'+num+(txt?('?text='+encodeURIComponent(txt)):''); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } }
  async function _repLojaInfo(){ var lj=_lojaRec; if(!lj){ try{ lj=await lojaGet(); }catch(_){ lj=null; } } lj=lj||{}; return { nome:(lj.nome_fantasia||lj.razao_social||meuNome||'Minha loja'), whats:(lj.whatsapp||lj.telefone||''), cidade:lj.cidade||'', uf:lj.uf||'' }; }
  /* v288: era um select direto na tabela pedindo a coluna preco. Agora é a
     função mp_repasse_meu, que só responde sobre o carro de quem perguntou. */
  async function repassePublicadaDaPlaca(placa){
    try{ var r=await withTimeout(supa.rpc('repasse_meu',{p_placa:String(placa||'')}),8000);
      return (r&&r.data)||null;
    }catch(_){ return null; }
  }
  /* O servidor busca o veículo e os destinatários por conta própria; o app só
     informa o identificador da publicação recém-criada. */
  async function repasseNotificarNovaOferta(id){
    if(!id) return {ok:false};
    try{ return await apiComTimeout('/api/notificar-repasse',{repasse_id:id},9000); }catch(_){ return {ok:false}; }
  }
  /* v178 — O RESUMO DO ESTADO DO CARRO.
     A avaliação já pergunta IPVA, ar, direção, alienação, multas, chave,
     manual, revisões e donos. Antes essas respostas ficavam só na página
     /av/<código> (a que você manda pro lojista avaliar). Agora elas vão
     junto pro Portal do Repasse — é a mesma informação, num lugar só.
     O que ficou "a conferir" não vai: informação vazia só ocupa espaço. */
  function _avEstadoObj(){
    /* v266: os campos deixaram de usar "— a conferir —" e passaram a dizer
       "Verificar". Esta peneira olhava só o travessão — sem isto, o Portal do
       Repasse passaria a anunciar "Chave reserva: Verificar", que não informa
       nada e ainda passa desleixo pro outro lojista. */
    function _limpa(t){ t=String(t||'').trim(); return (/^—/.test(t)||/^verificar$/i.test(t))?'':t; }
    function val(id){ var e=$(id); return e?_limpa(e.value):''; }
    function selTxt(id){ var e=$(id); return (e&&e.options&&e.options[e.selectedIndex])?_limpa(String(e.options[e.selectedIndex].text||'').replace(/\s*\(.*?\)\s*$/,'')):''; }
    var o={ ipva:val('avIpva'), ar:val('avAc'), direcao:val('avDir'), alienado:val('avAlien'),
      multas:val('avMultas'), chave:selTxt('avChave'), manual:val('avManual'),
      revisoes:val('avRevC'), donos:val('avDonos') };
    var lim={};
    Object.keys(o).forEach(function(k){ var t=o[k]; if(t && !/a conferir/i.test(t) && !/^verificar$/i.test(String(t).trim())) lim[k]=t; });   /* v266 */
    return lim;
  }
  /* v295: reduz a primeira foto a 32px de largura e devolve como texto
     embutido (data URI). 32px é o ponto onde o carro ainda se reconhece e a
     placa deixa de existir — testei com as fotos de verdade antes de escolher.
     Roda no navegador, com canvas: não custa nada e não depende de servidor. */
  function _repCapaBorrada(url){
    return new Promise(function(resolve){
      url=String(url||''); if(!url) return resolve('');
      var im=new Image();
      im.crossOrigin='anonymous';
      var acabou=false;
      function fim(v){ if(acabou) return; acabou=true; resolve(v||''); }
      setTimeout(function(){ fim(''); }, 8000);   /* nunca segura a publicação */
      im.onerror=function(){ fim(''); };
      im.onload=function(){
        try{
          var L=32, A=Math.max(1, Math.round(L*(im.naturalHeight/im.naturalWidth)||24));
          var cv=document.createElement('canvas'); cv.width=L; cv.height=A;
          cv.getContext('2d').drawImage(im,0,0,L,A);
          var d=cv.toDataURL('image/jpeg',0.45);
          fim(d.indexOf('data:image/jpeg')===0 && d.length<8000 ? d : '');
        }catch(_){ fim(''); }
      };
      im.src=url;
    });
  }
  async function repassePublicarAval(on, msgOk){
    var v=veiculoAtual||{}; if(!meuId||!v.placa){ toast('Faça a avaliação primeiro.'); return false; }
    if(on){
      /* ===== v452 — O FREIO ÚNICO =====
         Os caminhos que PÕEM um carro na rede passam todos por aqui: o
         interruptor da Avaliação e a republicação automática de quando o
         preço muda com o carro já no ar. Um lugar só decide, então não existe
         porta dos fundos entre eles. (O botão "Publicar" da ficha do repasse
         não passa por esta função — tem o mesmo freio no próprio clique.)
         Tirar do ar continua livre: quem publicou pode sempre desfazer. */
      if(!(await podeAnunciarRepasseAsync())){ toast(REPASSE_TRAVA_TX); return false; }
      try{var gate=await supa.rpc('mp_repasse_acesso');if(gate.error)throw new Error();
        if(gate.data!==true){toast('Acesso exclusivo para lojas autorizadas.');return false;}}
      catch(_){toast('Não consegui confirmar o acesso de lojista. A publicação não foi alterada.');return false;}
      var info=await _repLojaInfo();
      var km=parseInt(String((($('avKm')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||'';
      /* v178: o preço vem do campo novo (avRepPreco). Antes ele vinha de um
         campo "avPrecoLoj" que nunca chegou a existir na tela — por isso o
         portal caía sempre no valor avaliado ou na FIPE. */
      var precoRep=parseInt(String((($('avRepPreco')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
      if(!(precoRep>0)){toast('Informe um preço de repasse válido.');return false;}
      var aval=parseInt(String((($('avValor')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
      var _veic={ marca:v.marca||'', modelo:v.modelo||'', ano:v.ano_modelo||v.ano||'', ano_fab:v.ano||'', ano_modelo:v.ano_modelo||v.ano||'', cor:v.cor||'', km:km, combustivel:v.combustivel||'', fipe:v.fipe||'' };
      try{ var _fic=fichaParaRepasse(v.placa); if(_fic) _veic.ficha=_fic; }catch(_){}
      try{ _veic.estado=_avEstadoObj(); }catch(_){}
      /* v452 (pedido): a escolha "Em negociação / No meu estoque" viaja DENTRO
         do veículo. Sem o campo na tela (rascunho antigo), assume negociação —
         que é o mais comum e o que NÃO afirma posse que talvez não exista. */
      _veic.posse=(String((($('avRepPosse')||{}).value)||'negociacao')==='estoque')?'estoque':'negociacao';
      /* ===== v265 (VAZAMENTO) — AQUI O TEXTO IA CRU =====
         A avaliação limpava os valores antes de publicar; o Portal do Repasse
         não. Quem escrevesse "Mecânica: correia R$ 1.200" no campo de
         observações mandava o próprio custo de reparo pra rede inteira de
         lojistas — e pra quem tivesse o link /r/<id>. Agora passa pela MESMA
         limpeza (obsPublica, no 01-nucleo.js). */
      var _obs=obsPublica(String((($('avObs')||{}).value)||''));
      var row={ user_id:meuId, loja_nome:info.nome, loja_whatsapp:info.whats, cidade:info.cidade, uf:info.uf, placa:v.placa,
        veiculo:_veic, obs:_obs,
        fotos:(_avFotos||[]).slice(0,10), preco:precoRep, ativo:true, atualizado_em:new Date().toISOString() };
      /* v295 — A CAPA BORRADA DO SITE PÚBLICO.
         O site mostra o carro de repasse com uma foto de 32 pixels de largura:
         dá pra ver que é um carro branco de pátio, e a placa não cabe nesses
         32 pixels. Ela é gerada AQUI, no aparelho de quem publica, e vai junto
         com o carro — assim a foto boa nunca precisa sair do banco pro site.
         Se falhar (foto de outro domínio, aparelho antigo), o site cai no
         desenho neutro; nada quebra. */
      try{ var _capa=await _repCapaBorrada((_avFotos||[])[0]); if(_capa) row.capa_borrada=_capa; }catch(_){}
      try{ var ex=await repassePublicadaDaPlaca(v.placa), repasseId='', avisar=!ex||!ex.ativo;
        if(ex){ var u=await supa.from('repasse').update(row).eq('id',ex.id); if(u&&u.error) throw u.error; repasseId=ex.id; }
        else { var i=await supa.from('repasse').insert(row).select('id').single(); if(i&&i.error) throw i.error; repasseId=i&&i.data&&i.data.id; }
        var aviso=avisar?await repasseNotificarNovaOferta(repasseId):null;
        var retorno=msgOk||'Publicado na Rede de Repasse ✓';
        if(aviso&&aviso.ok){ retorno+=aviso.ja_enviado?' Aviso já estava registrado.':(' Aviso criado para '+Number(aviso.enviados||0)+' assinante(s) na aba Notificações.'); }
        else if(avisar){ retorno+=' Publicação salva; não consegui confirmar o aviso agora.'; }
        toast(retorno);
        /* ===== v514 — PORTA A do PROJETO-avisar-lojistas ==================
           O carro JÁ está publicado; avisar é um CONVITE, não um passo
           obrigatório. Por isso não abre folha na cara de ninguém: aparece
           a tirinha do 18f, que some sozinha em alguns segundos.
           ⚠️ Só no PRIMEIRO ar (a mesma condição do `avisar` acima). Quem
           só mexeu no preço de um carro que já estava na rede não deve
           levar convite pra avisar os mesmos lojistas de novo. */
        try{
          if(avisar && repasseId && typeof avisarLojistasConvite==='function'){
            var _cv=avisarLojistasDoRepasse({ id:repasseId, veiculo:_veic });
            if(_cv) avisarLojistasConvite(_cv.texto, _cv.titulo, { link:_cv.link, foto:_cv.foto||'', chave:_cv.chave||'' });
          }
        }catch(_){}
        return true;
      }catch(e){ toast('Não consegui publicar. '+((e&&e.message)||'')); return false; }
    } else {
      try{ await supa.from('repasse').update({ativo:false,atualizado_em:new Date().toISOString()}).eq('user_id',meuId).eq('placa',v.placa); toast('Tirado do repasse.'); return true; }catch(_){ return false; }
    }
  }
  var _repRetorno=null;
  function _repComparativo(x){
    var f=Number((x.veiculo||{}).fipe), p=Number(x.preco);
    if(!(f>0 && p>0 && p<f)) return '';
    return '<span class="rep-desconto">'+((f-p)/f*100).toLocaleString('pt-BR',{maximumFractionDigits:1})+'% abaixo da FIPE</span>';
  }
  async function telaRepassePortal(restaurar){
    mevTabSet('');
    /* v777 — o carimbo da última visita ao Portal (bloco "Novo na rede" da
       home, 05j). Abrir a tela zera a linha: é isso que impede o bloco de
       virar mentira. Vale por QUALQUER caminho, não só pelo clique na home. */
    try{ redCarimboGravar('repasse'); }catch(_){ }
    if(!_portalMembroCarregado) await membroCarregar();
    /* v285: a assinatura precisa estar carregada ANTES de decidir quem entra.
       Sem esta linha, quem tem plano em dia levava a tela de bloqueio na cara
       só porque a resposta do servidor ainda não tinha chegado. */
    if(!_assinatura){ try{ await assinaturaCarregar(); }catch(_){} }
    if(!_souParceiro()){ portalBloqueio(); return; }
    var retorno=restaurar===true?_repRetorno:null;
    _repView=retorno?retorno.view:'rede';
    var adminBox = _ehAdmin() ? '<div id="repAdminBox" class="rep-admin"></div>' : '<div id="repAssinBox"></div>';
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><div class="est-head"><h2 style="margin:0">Portal do Repasse</h2></div>'+
      adminBox+
      /* v308: a 4ª aba — os carros que PARTICULARES anunciaram pelo site. */
      '<div class="hh-toggle" id="repTgl" style="margin-bottom:10px"><button type="button" class="hh-tg on" data-rv="rede">Rede</button><button type="button" class="hh-tg" data-rv="particular">Particulares</button><button type="button" class="hh-tg" data-rv="meu">Meu portal</button><button type="button" class="hh-tg" data-rv="ofertas">Ofertas</button></div>'+
      '<div class="cli-top"><div class="cli-search" style="flex:1">'+_icoBusca+'<input id="repPortalBusca" aria-label="Buscar placa, modelo, loja ou cidade" placeholder="Buscar placa, modelo, loja ou cidade" autocomplete="off"></div></div>'+
      '<div class="rep-lista-filtros"><label>Situação<select class="crm-ord" id="repRedeSituacao"><option value="">Todas</option><option value="disponivel">Disponíveis</option><option value="vendido">Vendidos</option></select></label><label>Ordenar<select class="crm-ord" id="repRedeOrdem"><option value="">Ordem da rede</option><option value="menor">Menor preço</option><option value="maior">Maior preço</option></select></label></div>'+
      '<div id="repPortalLista">'+skelHtml(4)+'</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);

    /* 🔴 v795 — A MARCA VEM AQUI, DEPOIS DE A TELA ESTAR MONTADA, e não no
       começo da função. O mevTabSet() e o irTela() rodam no meio do caminho e
       LIMPAM as classes de página (é o trabalho deles: sair de uma tela apaga
       a marca da anterior). Marcar antes deles era marcar e perder — medido:
       as cinco telas ficavam sem `oper-on` e sem dock, com o código todo
       "certo". Ver o changelog da v795. */
    document.body.classList.add('oper-on');
    try{ consultaUiDockMedir(); }catch(_){ }
    Array.prototype.forEach.call(document.querySelectorAll('#repTgl .hh-tg'),function(b){ b.onclick=function(){ _repView=b.getAttribute('data-rv'); Array.prototype.forEach.call(document.querySelectorAll('#repTgl .hh-tg'),function(x){ x.classList.toggle('on',x===b); }); repPortalPinta(); }; });
    var bq=$('repPortalBusca'); if(bq) bq.oninput=function(){ repPortalPinta(); };
    if(retorno){ bq.value=retorno.busca; $('repRedeSituacao').value=retorno.sit; $('repRedeOrdem').value=retorno.ord; }
    document.querySelectorAll('#repTgl .hh-tg').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-rv')===_repView);});
    ['repRedeSituacao','repRedeOrdem'].forEach(function(id){$(id).onchange=repPortalPinta;});
    if(_ehAdmin()){ membrosAdminCarregar().then(membrosAdminPinta); }
    else { assinaturaCarregar().then(assinaturaPintaBox); }
    await repPortalCarregar(); repPortalPinta();
    if(retorno) requestAnimationFrame(function(){window.scrollTo(0,retorno.y);});
  }
  /* ===== v285 — A TELA DE BLOQUEIO NÃO VENDE MAIS UM PACOTE SEPARADO =====
     Ela pedia R$ 99,90/mês do "pacote Parceiro" e gerava o PIX ali mesmo.
     Agora o Portal do Repasse faz parte de QUALQUER plano, então esta tela só
     explica isso e leva pra tela de planos — um lugar só decide preço. */
  function portalBloqueio(){
    var bens=[
      ['\ud83d\udd04','Rede de repasse','Veja os carros de repasse de todas as lojas num lugar só.'],
      ['\ud83d\udcb8','Faça ofertas','Oferte direto nos carros da rede e receba ofertas nos seus.'],
      /* v452: publicar passou a ser do plano Lojista \u2014 a tela de bloqueio n\u00e3o
         pode prometer o que o plano de baixo n\u00e3o entrega. */
      ['\ud83c\udfea','Seu portal','Publique seu estoque de repasse \u2014 nos planos Lojista e Max.'],
      ['\u2b50','Loja em destaque','Sua loja aparece como Parceira, vista por toda a rede MEV.']
    ];
    var bHtml=bens.map(function(b){ return '<div class="pt-ben"><span class="pt-ben-ic">'+b[0]+'</span><div><b>'+b[1]+'</b><span>'+b[2]+'</span></div></div>'; }).join('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><div class="est-head"><h2 style="margin:0">Portal do Repasse</h2></div>'+
      '<div class="pt-hero"><div class="pt-hero-t">Faz parte do seu plano</div>'+
        '<div class="pt-hero-s">O Portal do Repasse está incluído em qualquer plano do MEV — Essencial, Profissional ou Max. Escolha o seu e ele libera na hora.</div></div>'+
      '<div class="pt-bens">'+bHtml+'</div>'+
      '<button type="button" class="pt-wa" id="portalPlanos" style="background:#0a4da6">Ver os planos</button>'+
      '<button type="button" class="link" id="portalWa" style="display:block;width:100%;margin-top:8px">Precisa de ajuda? Falar no WhatsApp</button>'+
      '<div class="pt-foot">Sem fidelidade &middot; cancele quando quiser.</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    var pl=$('portalPlanos'); if(pl) pl.onclick=function(){ telaInfo('pagamentos'); };
    var w=$('portalWa'); if(w) w.onclick=function(){
      var wa=String(MEV_SUPORTE.whats||'').replace(/\D/g,'');
      if(wa) _repWa(wa,'Olá! É sobre meu acesso ao Portal do Repasse.'); else toast('WhatsApp do MEV ainda não configurado no app.');
    };
  }
  async function membroCarregar(){
    _portalMembroCarregado=false;
    if(!meuId){ _portalMembro=null; return; }
    try{ var r=await withTimeout(supa.from('portal_membro').select('*').eq('user_id',meuId).limit(1),8000); _portalMembro=(r&&r.data&&r.data[0])||null; }
    catch(_){ _portalMembro=null; }
    _portalMembroCarregado=true;
  }
  /* v285 — QUEM ENTRA NO PORTAL DO REPASSE.
     Antes era só quem pagava o pacote Parceiro de R$ 99,90 (ou o admin).
     Agora quem tem QUALQUER plano ativo entra, porque o card do plano promete
     "toda a estrutura do MEV". Mantive a liberação antiga (portal_membro
     ativo) de propósito: ninguém que já tinha acesso perde por causa desta
     mudança. */
  function _temPlanoAtivo(){
    try{ return !!pagPlanoDaAssinatura(); }catch(_){ return false; }
  }
  function _souParceiro(){ return _ehAdmin() || _temPlanoAtivo() || !!(_portalMembro && _portalMembro.ativo); }
  /* lojista pede acesso: cria o pedido (ativo=false) e chama o WhatsApp do MEV */
  async function membroSolicitar(){
    if(!meuId){ toast('Faça login primeiro.'); return; }
    var info=await _repLojaInfo();
    if(!_portalMembro){
      var row={ user_id:meuId, plano:'parceiro', ativo:false, loja_nome:info.nome, cidade:info.cidade, uf:info.uf, whatsapp:info.whats, atualizado_em:new Date().toISOString() };
      try{ var i=await supa.from('portal_membro').insert(row); if(i&&i.error) throw i.error; _portalMembro=row; toast('Pedido de acesso enviado ✓'); }
      catch(_){ /* provavelmente já existe */ }
    }
    var wa=String(MEV_SUPORTE.whats||'').replace(/\D/g,'');
    var msg='Olá! Quero acessar o Portal do Repasse. Minha loja: '+(info.nome||'')+([info.cidade,info.uf].filter(Boolean).join('/')?(' - '+[info.cidade,info.uf].filter(Boolean).join('/')):'')+'.';
    if(wa){ _repWa(wa, msg); }
    portalBloqueio();
  }
  /* ADMIN: aprovar / desativar assinantes */
  async function membrosAdminCarregar(){
    try{ var r=await withTimeout(supa.from('portal_membro').select('*').order('ativo',{ascending:true}).order('criado_em',{ascending:false}),9000); _repMembros=(r&&r.data)||[]; }catch(_){ _repMembros=[]; }
  }
  function membrosAdminPinta(){
    var el=$('repAdminBox'); if(!el) return;
    var pend=_repMembros.filter(function(m){ return !m.ativo; });
    var atv=_repMembros.filter(function(m){ return m.ativo; });
    var btnFat='<button type="button" class="cob-abrir" id="cobAbrir">💰 Cobranças e faturamento</button>';
    function row(m){ return '<div class="rep-adm-row"><div class="rep-adm-tx"><b>'+esc(m.loja_nome||'Loja')+'</b><small>'+esc([m.cidade,m.uf].filter(Boolean).join('/'))+(m.whatsapp?(' · '+esc(m.whatsapp)):'')+'</small></div>'+(m.ativo?'<button type="button" class="rep-b rm" data-mem-off="'+esc(m.user_id)+'">Desativar</button>':'<button type="button" class="rep-b" data-mem-on="'+esc(m.user_id)+'">Aprovar</button>')+'</div>'; }
    var corpo = _repMembros.length
      ? ('<div class="rep-admin-h">Admin · Assinantes ('+atv.length+' ativos · '+pend.length+' pendentes)</div>'+(pend.concat(atv)).map(row).join(''))
      : '<div class="rep-admin-h">Admin · Assinantes</div><div class="rep-admin-e">Ninguém pediu acesso ainda.</div>';
    el.innerHTML=corpo+btnFat;
    var cf=$('cobAbrir'); if(cf) cf.onclick=telaCobrancas;
    Array.prototype.forEach.call(el.querySelectorAll('[data-mem-on]'),function(b){ b.onclick=function(){ membroSetAtivo(b.getAttribute('data-mem-on'),true); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-mem-off]'),function(b){ b.onclick=function(){ membroSetAtivo(b.getAttribute('data-mem-off'),false); }; });
  }
  async function membroSetAtivo(uid, on){
    try{ var u=await supa.from('portal_membro').update({ativo:on, atualizado_em:new Date().toISOString()}).eq('user_id',uid); if(u&&u.error) throw u.error; toast(on?'Acesso liberado ✓':'Acesso desativado.'); await membrosAdminCarregar(); membrosAdminPinta(); }
    catch(_){ toast('Não consegui atualizar.'); }
  }
  /* OFERTAS */
  async function ofertasCarregar(){
    try{ var r=await withTimeout(supa.from('oferta').select('*').eq('para_user_id',meuId).order('criado_em',{ascending:false}).limit(200),9000); _repOfertasRecebidas=(r&&r.data)||[]; }catch(_){ _repOfertasRecebidas=[]; }
    try{ var e=await withTimeout(supa.from('oferta').select('*').eq('de_user_id',meuId).order('criado_em',{ascending:false}).limit(200),9000); _repOfertasEnviadas=(e&&e.data)||[]; }catch(_){ _repOfertasEnviadas=[]; }
  }
  function ofertaAbrir(x){
    var v=x.veiculo||{};
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='💸'; $('cliMt').textContent='Fazer oferta';
    $('cliMbody').innerHTML=
      /* v288: esta janela dizia "sugerido R$ 37.000,00" — era o preço da OUTRA
         loja entregue de bandeja pra quem ia ofertar. Agora não sai nada. */
      '<div class="of-veic"><b>'+esc(((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo')+'</b> · '+esc(x.placa||'')+'<br><small>'+esc(x.loja_nome||'Loja')+'</small></div>'+
      '<label class="cad-lbl">Sua oferta (R$)</label><input class="cad-in" id="ofValor" inputmode="numeric" placeholder="R$ 0">'+
      '<label class="cad-lbl">Mensagem (opcional)</label><textarea class="cad-in" id="ofMsg" rows="3" placeholder="Ex.: Tenho interesse, pago à vista, retiro hoje..."></textarea>'+
      '<button type="button" class="cad-btn" id="ofEnviar" style="margin-top:10px">Enviar oferta</button>';
    var vv=$('ofValor'); if(vv) vv.oninput=avMaskRS;
    var bt=$('ofEnviar'); if(bt) bt.onclick=function(){ ofertaEnviar(x); };
  }
  async function ofertaEnviar(x){
    var valor=parseInt(String((($('ofValor')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
    var msg=String((($('ofMsg')||{}).value)||'').trim();
    if(!valor){ toast('Digite o valor da sua oferta.'); return; }
    var info=await _repLojaInfo();
    var row={ repasse_id:x.id, de_user_id:meuId, para_user_id:x.user_id, placa:x.placa, valor:valor, mensagem:msg, de_loja_nome:info.nome, de_whatsapp:info.whats, status:'nova', atualizado_em:new Date().toISOString() };
    try{ var i=await supa.from('oferta').insert(row); if(i&&i.error) throw i.error; toast('Oferta enviada ✓'); cliModalFechar(); await ofertasCarregar(); if(_repView==='ofertas') repPortalPinta(); }
    catch(e){ toast('Não consegui enviar. '+((e&&e.message)||'')); }
  }
  function _ofStatus(s){ return s==='aceita'?'<span class="of-st ok">aceita</span>':(s==='recusada'?'<span class="of-st no">recusada</span>':'<span class="of-st">nova</span>'); }
  function _ofCard(o, tipo){
    var val=_repDinheiro(o.valor);
    var top = (tipo==='recebida') ? (esc(o.de_loja_nome||'Uma loja')+' ofertou') : 'Você ofertou';
    /* v519: "avisado ✓" discreto, do lado da etiqueta. É a única informação
       nova na tela, e é a que responde "ele soube?" */
    var av=(tipo==='recebida' && o.status==='aceita' && _ofAvisados[String(o.id)]==='ok')
      ? '<span class="of-av">avisado ✓</span>' : '';
    var sub = '<b>'+esc(o.placa||'-')+'</b> · '+val+' · '+_ofStatus(o.status)+av;
    var msg = o.mensagem?('<div class="of-msg">"'+esc(o.mensagem)+'"</div>'):'';
    var acts='';
    if(tipo==='recebida'){
      var wa = o.de_whatsapp?('<button type="button" class="rep-b wa" data-of-wa="'+esc(o.id)+'">💬 Responder</button>'):'';
      if(o.status==='nova'){ acts='<div class="rep-acts">'+wa+'<button type="button" class="rep-b" data-of-ok="'+esc(o.id)+'">✓ Aceitar</button><button type="button" class="rep-b rm" data-of-no="'+esc(o.id)+'">Recusar</button></div>'; }
      else if(o.status==='aceita' && _ofAvisados[String(o.id)]==='falhou'){
        /* v519: o negócio JÁ está gravado; só o aviso não saiu. O botão
           tenta de novo — e é seguro, porque o lote (v514) faz o lojista
           receber uma vez só por mais que se insista. */
        acts='<div class="rep-acts">'+wa+'<button type="button" class="rep-b" data-of-av="'+esc(o.id)+'">Avisar</button></div>';
      }
      else if(wa){ acts='<div class="rep-acts">'+wa+'</div>'; }
    } else {
      acts='<div class="rep-acts"><button type="button" class="rep-b rm" data-of-del="'+esc(o.id)+'">Cancelar oferta</button></div>';
    }
    return '<div class="of-card"><div class="of-top">'+top+'</div><div class="of-sub">'+sub+'</div>'+msg+acts+'</div>';
  }
  function ofertasPinta(el){
    var rec=_repOfertasRecebidas, env=_repOfertasEnviadas;
    var h='<div class="of-sec-h">Recebidas ('+rec.length+')</div>';
    h += rec.length ? rec.map(function(o){ return _ofCard(o,'recebida'); }).join('') : '<div class="cli-empty"><b>Nenhuma oferta recebida</b>Quando alguém ofertar nos seus carros, aparece aqui.</div>';
    h += '<div class="of-sec-h" style="margin-top:16px">Enviadas ('+env.length+')</div>';
    h += env.length ? env.map(function(o){ return _ofCard(o,'enviada'); }).join('') : '<div class="cli-empty"><b>Você ainda não fez ofertas</b>Na aba Rede, toque em "Fazer oferta".</div>';
    el.innerHTML=h;
    Array.prototype.forEach.call(el.querySelectorAll('[data-of-wa]'),function(b){ b.onclick=function(){ var o=rec.filter(function(y){return String(y.id)===String(b.getAttribute('data-of-wa'));})[0]; if(o) _repWa(o.de_whatsapp,'Olá! Sobre sua oferta de '+_repDinheiro(o.valor)+' no veículo '+(o.placa||'')+'.'); }; });
    /* v519: aceitar passa a receber o OBJETO da oferta (precisa de valor,
       placa, de_user_id, de_loja_nome e repasse_id — o card já tem tudo) */
    Array.prototype.forEach.call(el.querySelectorAll('[data-of-ok]'),function(b){
      b.onclick=function(){
        var o=rec.filter(function(y){return String(y.id)===String(b.getAttribute('data-of-ok'));})[0];
        if(o) ofertaAceitar(o); else ofertaStatus(b.getAttribute('data-of-ok'),'aceita');
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-of-av]'),function(b){
      b.onclick=async function(){
        var o=rec.filter(function(y){return String(y.id)===String(b.getAttribute('data-of-av'));})[0]; if(!o) return;
        b.disabled=true; b.textContent='Avisando…';
        var nome=_ofNomeCarro(o);
        var link=o.repasse_id?(MEV_SITE+'/r/'+encodeURIComponent(String(o.repasse_id))):'';
        var r=(typeof avisarUmLojista==='function')
          ? await avisarUmLojista(o.de_user_id, _ofTextoGanhador(o,nome), 'Sua oferta foi aceita', { lote:o.id, link:link })
          : { ok:false, erro:'sem o módulo de avisos' };
        _ofAvisados[String(o.id)]=r.ok?'ok':'falhou';
        toast(r.ok?'Avisado ✓':('Não consegui avisar. '+(r.erro||'')));
        repPortalPinta();
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-of-no]'),function(b){ b.onclick=function(){ ofertaStatus(b.getAttribute('data-of-no'),'recusada'); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-of-del]'),function(b){ b.onclick=async function(){ var id=b.getAttribute('data-of-del'); if(!confirm('Cancelar esta oferta?')) return; try{ var d=await supa.from('oferta').delete().eq('id',id); if(d&&d.error) throw d.error; toast('Oferta cancelada.'); await ofertasCarregar(); repPortalPinta(); }catch(_){ toast('Não consegui.'); } }; });
  }
  /* ===== v519 — OFERTA ACEITA = NEGÓCIO FECHADO ==========================
     (PROJETO-oferta-aceita-negocio-fechado)

     PEDIDO (Angelo, 16/08): "repasses — quero enviar uma mensagem via chat
     para o Lojista que sua oferta foi aceita, oferta que foi fechado o
     negócio."

     O QUE ACONTECIA ATÉ AQUI: `update status='aceita'` → toast → repinta.
     E acabou. **O lojista que ofertou não ficava sabendo de nada.** Ele só
     descobriria abrindo o app, entrando no Portal, na aba Ofertas, achando
     a oferta dele e vendo a etiquetinha mudar. Na prática: ninguém
     descobre. O negócio ficava fechado só na cabeça de quem aceitou.

     ⛳ OS TRÊS INTERRUPTORES — "aceitar = fechar" é uma DECISÃO, e ela está
     aqui pra ser desfeita numa linha. Mesmo padrão do MEV_PREVIA (v497),
     MEV_FAIXA (v502) e MEV_AVISO_TESTE (v514).
     POR QUE ligados: carro com oferta aceita que continua "disponível" gera
     oferta fantasma — gente ofertando num carro vendido e você respondendo
     um por um no WhatsApp. E lojista que oferta e nunca recebe resposta é
     lojista que não oferta na segunda vez.
     A rede de segurança é a confirmação ANTES e o "Voltar pra disponível"
     (v259) DEPOIS. ⚠️ Honestidade: o "voltar pra disponível" desfaz o
     vendido, **não desfaz as mensagens** — aviso é irreversível. Por isso a
     confirmação diz o nome e o valor, e por isso ela não é um toque só. */
  var OFA_VENDIDO       = true;   /* aceitar marca o carro como vendido      */
  var OFA_RECUSA_OUTRAS = true;   /* e recusa as outras ofertas 'nova'       */
  var OFA_AVISA_OUTROS  = true;   /* avisando cada um (sem valor, sem nomes) */

  /* recusar UMA oferta continua mudo, como sempre foi — e de propósito:
     "sua oferta foi recusada" chegando do nada é o tipo de mensagem que faz
     o lojista desinstalar. Recusa EM MASSA (o carro fechou) é outra coisa:
     ali a notícia é útil. Só ganhou o `.select('id')`. */
  async function ofertaStatus(id, st){
    try{
      var u=await supa.from('oferta').update({status:st, atualizado_em:new Date().toISOString()}).eq('id',id).select('id');
      if(u&&u.error) throw u.error;
      if(!(u&&u.data&&u.data.length)){ toast('Não consegui atualizar — esta oferta não é sua.'); return false; }
      toast(st==='aceita'?'Oferta aceita ✓':'Oferta recusada.');
      await ofertasCarregar(); repPortalPinta(); return true;
    }
    catch(_){ toast('Não consegui atualizar.'); return false; }
  }

  /* 🔴 A ORDEM IMPORTA, E É ESTA. Gravar e CONFERIR vem ANTES de avisar:
     aviso é irreversível, e o update é o que prova que o negócio existe.
     Sem o `.select('id')`, a RLS barrando devolveria "sucesso" com zero
     linhas (regra 6 do CLAUDE.md) e o app mandaria "negócio fechado" para
     o lojista de um negócio que o banco não registrou. */
  async function ofertaAceitar(o){
    if(!o || !o.id) return;
    var quem=String(o.de_loja_nome||'este lojista');
    var quanto=_repDinheiro(o.valor);
    var extra=(OFA_VENDIDO||OFA_RECUSA_OUTRAS)
      ? ('\n\n'+[OFA_VENDIDO?'O carro fica como vendido':'', OFA_RECUSA_OUTRAS?'as outras ofertas são recusadas':'']
          .filter(Boolean).join(' e ')+'.')
      : '';
    if(!confirm('Fechar negócio com '+quem+' por '+quanto+'?'+extra)) return;

    /* a. grava e CONFERE */
    var okGrava=false;
    try{
      var u=await supa.from('oferta').update({status:'aceita', atualizado_em:new Date().toISOString()})
        .eq('id',o.id).select('id');
      if(u&&u.error) throw u.error;
      okGrava=!!(u&&u.data&&u.data.length===1);
    }catch(_){ okGrava=false; }
    if(!okGrava){ toast('Não consegui registrar o aceite. Ninguém foi avisado.'); return; }

    /* b. o carro vira vendido. Falhou? o aceite continua valendo. */
    if(OFA_VENDIDO && o.repasse_id){
      try{ await repMarcarVendido(o.repasse_id, true); }
      catch(_){ toast('Aceite gravado, mas não consegui marcar o carro como vendido.'); }
    }

    /* c. as outras ofertas do MESMO carro viram recusadas. Pedir a linha de
       volta aqui não é só a regra 6: é DE ONDE SAI A LISTA de quem recebe o
       aviso de "o carro foi fechado". */
    var perdedores=[];
    if(OFA_RECUSA_OUTRAS && o.repasse_id){
      try{
        var rr=await supa.from('oferta').update({status:'recusada', atualizado_em:new Date().toISOString()})
          .eq('repasse_id',o.repasse_id).eq('status','nova').neq('id',o.id).select('id,de_user_id');
        if(rr&&rr.data) perdedores=rr.data.map(function(x){ return x.de_user_id; })
          .filter(function(v,i,a){ return v && a.indexOf(v)===i && String(v)!==String(o.de_user_id); });
      }catch(_){}
    }

    /* d. avisa. O ganhador primeiro. */
    var nomeCarro=_ofNomeCarro(o);
    var link=o.repasse_id?(MEV_SITE+'/r/'+encodeURIComponent(String(o.repasse_id))):'';
    var avisou=false;
    if(typeof avisarUmLojista==='function'){
      var rA=await avisarUmLojista(o.de_user_id, _ofTextoGanhador(o, nomeCarro),
        'Sua oferta foi aceita', { lote:o.id, link:link });
      avisou=!!(rA&&rA.ok);
      /* e os que não ganharam — um a um, com o repasse_id como lote (cada um
         recebe uma vez por carro, mesmo se você aceitar duas vezes) */
      if(OFA_AVISA_OUTROS && perdedores.length){
        for(var i=0;i<perdedores.length;i++){
          try{ await avisarUmLojista(perdedores[i], _ofTextoPerdedor(nomeCarro, o.placa),
            'Este carro foi fechado', { lote:o.repasse_id, link:link }); }catch(_){}
        }
      }
    }
    _ofAvisados[String(o.id)]=avisou?'ok':'falhou';

    toast(avisou ? ('Negócio fechado ✓ '+quem+' foi avisado.')
                 : 'Negócio fechado ✓ mas não consegui avisar — dá pra tentar de novo no cartão.');
    await ofertasCarregar(); repPortalPinta();
  }

  /* quem já foi avisado nesta sessão — o cartão mostra "avisado ✓" ou o
     botão de tentar de novo. Não precisa de coluna nova: o aviso em si é
     idempotente pelo lote (v514), então tentar de novo é sempre seguro. */
  var _ofAvisados={};
  function _ofNomeCarro(o){
    var v=(o&&o.veiculo)||{};
    var n=((v.marca||'')+' '+(v.modelo||'')).trim();
    if(n) return n;
    /* o cartão da oferta não traz o veículo; procura na rede/meu portal */
    var r=(_repMeu||[]).concat(_repRede||[]).filter(function(x){ return String(x.id)===String(o.repasse_id); })[0];
    var vv=(r&&r.veiculo)||{};
    return ((vv.marca||'')+' '+(vv.modelo||'')).trim() || 'o veículo';
  }
  /* ===== OS TEXTOS — é isto que chega, palavra por palavra ================
     🔴 NÃO começar com 🚗: o 🚗 no primeiro caractere é o que faz a mensagem
     virar CARD DE VEÍCULO na conversa (v474/v508). Este aviso não é um card
     de carro. Começa com ✅.
     Assina com a LOJA, não com a pessoa: o chat mostra de quem veio, mas o
     e-mail e o sino chegam FORA do app, sem esse contexto — e quem negocia
     com o lojista é a loja. Se amanhã um vendedor da equipe aceitar (v484),
     a mensagem continua fazendo sentido. */
  function _ofAssina(){
    try{ return '\n— '+((_lojaRec&&(_lojaRec.nome_fantasia||_lojaRec.razao_social))||meuNome||'Minha loja'); }catch(_){ return ''; }
  }
  function _ofTextoGanhador(o, nomeCarro){
    return '✅ *Negócio fechado!*\n'+
      'Sua oferta de *'+_repDinheiro(o.valor)+'* no '+nomeCarro+
      (o.placa?(' ('+String(o.placa).toUpperCase()+')'):'')+' foi aceita.\n'+
      'Vamos combinar a retirada?'+_ofAssina();
  }
  /* 🔴 SEM VALOR E SEM DIZER COM QUEM. Quem perdeu não pode descobrir por
     quanto fechou: é a v288 pela porta dos fundos, e é o que faria o próximo
     lance ser calculado em cima do seu último negócio. */
  function _ofTextoPerdedor(nomeCarro, placa){
    return 'Este carro foi fechado — '+nomeCarro+(placa?(' ('+String(placa).toUpperCase()+')'):'')+'.\n'+
      'Obrigado pela oferta! Assim que entrar carro novo eu te aviso.'+_ofAssina();
  }
  /* ================= ASSINATURA DO PARCEIRO (cobrança recorrente) ================= */
  var _assinatura=null;
  async function assinaturaCarregar(){ try{ var d=await apiTimeout('/api/cobranca',{acao:'status'},12000); _assinatura=(d&&d.ok)?d:null; }catch(_){ _assinatura=null; } }
  function assinaturaPintaBox(){
    var el=$('repAssinBox'); if(!el) return;
    if(_ehAdmin()){ el.innerHTML=''; return; }
    var a=(_assinatura&&_assinatura.assinatura)||null; var ab=(_assinatura&&_assinatura.aberta)||null;
    if(!a){ el.innerHTML=''; return; }
    var dias=a.dias; var venc=a.validade?new Date(a.validade+'T12:00:00').toLocaleDateString('pt-BR'):'—';
    var vencida=(dias!=null&&dias<0);
    var cls=(vencida||(dias!=null&&dias<=5))?'venc':'ok';
    var linha = a.validade
      ? (vencida ? ('Venceu em <b>'+venc+'</b> · renove pra voltar') : ('Vence em <b>'+venc+'</b>'+(dias!=null?(' · faltam '+dias+' dia'+(dias===1?'':'s')):'')))
      : 'Ative sua mensalidade pra garantir o acesso';
    var precisa = (dias==null) || (dias<=5) || !!ab;
    /* v285: era "Assinatura do Parceiro" — nome do pacote que deixou de
       existir. Agora mostra o nome do PLANO que a pessoa realmente assinou. */
    var _pl=null; try{ _pl=pagPlanoDaAssinatura(); }catch(_){ _pl=null; }
    var _rot=(_pl&&_pl.nome)?((_pl.publico==='consultas'?'':'Plano ')+_pl.nome):'Sua assinatura';
    el.innerHTML='<div class="assin-box '+cls+'"><div class="assin-tx"><b>'+esc(_rot)+' · '+brl(a.valor)+'/mês</b><small>'+linha+'</small></div>'+
      (precisa?('<button type="button" class="assin-pay" id="assinPay">'+(ab?'Pagar PIX':'Renovar')+'</button>'):'<span class="assin-ok">✓ em dia</span>')+'</div>';
    var b=$('assinPay'); if(b) b.onclick=function(){ assinaturaPagar(); };
  }
  async function assinaturaPagar(planoId,contratoConfirmado){
    /* 🔴 v881 — a SEGUNDA porta de compra do app (a primeira é o
       `abrirPacotes()` do 01-nucleo). Ela gera o PIX do PLANO, e é chamada
       de três lugares: os cards de plano do 11-uso-pagamentos, o botão
       "Pagar PIX / Renovar" da assinatura aqui em cima, e o bloco de planos
       que nasce embaixo dos pacotes. Mesma regra: a trava mora na função,
       não nas chamadas. Dentro do app de loja, mostra o recado e para. */
    if(typeof ehAppDeLoja==='function' && ehAppDeLoja()){
      try{ abrirPacotes(); }catch(_){ try{ toast('Contrate em mevveiculos.com.br pelo navegador.'); }catch(__){} }
      return;
    }
    var _planoCompra=planoId||'';
    var _ehConsultas=_planoCompra==='consultas149';
    try{ _ehConsultas=_ehConsultas||(typeof edicaoAtual==='function'&&edicaoAtual()==='consultas'); }catch(_){}
    if(_ehConsultas && contratoConfirmado!==true){
      var _assinou=false;
      try{ _assinou=await contratoConsultasGarantir('consultas149'); }catch(_){}
      if(!_assinou) return;
      return assinaturaPagar('consultas149',true);
    }
    var d; try{ d=await api('/api/cobranca',{acao:'assinatura_pix',plano:planoId||''}); }catch(_){ d=null; }
    if(!d||!d.ok){ toast((d&&d.erro)||'Não consegui gerar o PIX.'); return; }
    var _pb=$('pixBody'), _ps=$('pixSucesso'); if(_pb) _pb.style.display='block'; if(_ps){ _ps.style.display='none'; _ps.innerHTML=''; }
    $('pixValor').textContent=brl(d.valor); var pc=$('pixCred'); if(pc) pc.textContent=(planoId==='consultas149'||(typeof edicaoAtual==='function'&&edicaoAtual()==='consultas'))?'Assinatura mensal MEV Consultas':'Plano de lojista MEV Veículos';
    $('qrImg').src=d.qr_code_base64?('data:image/png;base64,'+d.qr_code_base64):'';
    $('copiaCola').textContent=d.qr_code||'—';
    /* v634 — mesma linha de espera do PIX de tokens (pontinhos no lugar do
       aro). Duas telas com o mesmo trabalho não podem ter desenhos diferentes. */
    $('statusPg').innerHTML='<div class="pg-row"><span class="pg-dots" aria-hidden="true"><i></i><i></i><i></i></span><span>Aguardando pagamento…</span></div><div class="pg-frase" id="pgFrase"></div>';
    $('btnCopiar').textContent='📋 Copiar código PIX';
    $('btnCopiar').onclick=function(){ if(navigator.clipboard&&d.qr_code){navigator.clipboard.writeText(d.qr_code).then(function(){$('btnCopiar').textContent='✓ Copiado!';setTimeout(function(){$('btnCopiar').textContent='📋 Copiar código PIX';},1500);});} };
    $('modalPix').classList.add('on');
    var soConsultas=planoId==='consultas149';
    try{ soConsultas=soConsultas||(typeof edicaoAtual==='function'&&edicaoAtual()==='consultas'); }catch(_){}
    pollAssinatura(d.cobranca_id,soConsultas);
  }
  function pollAssinatura(cid,soConsultas){
    if(pollTimer) clearInterval(pollTimer);
    if(_pgFraseStop){ try{_pgFraseStop();}catch(_){} _pgFraseStop=null; }
    /* v634 — curtas, pelo mesmo motivo do 01-nucleo: frase de duas linhas
       transbordava a caixa e invadia os vizinhos. */
    var frases=['⏳ O novo ciclo libera após o pagamento','📲 Escaneie o QR no app do seu banco','🔒 Pagamento seguro pelo Mercado Pago','💙 Obrigado por ser parceiro do MEV'];
    _pgFraseStop=fraseRotator($('pgFrase'),frases,3000);
    var inicio=Date.now();
    pollTimer=setInterval(async function(){
      if(Date.now()-inicio>12*60*1000){ clearInterval(pollTimer); if(_pgFraseStop){try{_pgFraseStop();}catch(_){}_pgFraseStop=null;} var sp=$('statusPg'); if(sp) sp.innerHTML='<span style="color:#b91c1c">Tempo esgotado. Se você pagou, feche e abra de novo.</span>'; return; }
      var d; try{ d=await api('/api/cobranca',{acao:'confirmar',cobranca_id:cid}); }catch(_){ d=null; }
      if(d&&d.pago&&d.ok){ clearInterval(pollTimer); pollTimer=null; assinaturaSucesso(d.validade,soConsultas); }
    },4000);
  }
  function assinaturaSucesso(validade,soConsultas){
    if(_pgFraseStop){ try{_pgFraseStop();}catch(_){} _pgFraseStop=null; }
    var pb=$('pixBody'), ps=$('pixSucesso'); if(pb) pb.style.display='none'; if(!ps) return;
    var venc=validade?new Date(validade+'T12:00:00').toLocaleDateString('pt-BR'):'';
    ps.style.display='block';
    ps.innerHTML='<div class="pix-ok"><div class="pix-ok-check"><svg viewBox="0 0 52 52"><circle class="pk-c" cx="26" cy="26" r="24"/><path class="pk-p" d="M15 27l7 7 15-15"/></svg></div>'+
      '<div class="pix-ok-t">Assinatura renovada!</div>'+
      '<div class="pix-ok-s">Seu acesso '+(soConsultas?'ao MEV Consultas':'ao Portal do Repasse')+' está garantido'+(venc?(' até <b>'+venc+'</b>'):'')+'. O recibo foi enviado por e-mail. 💙</div>'+
      '<button class="btn btn-azul" id="pixOkBtn" style="margin-top:16px;padding:12px">Voltar '+(soConsultas?'ao app':'ao Portal')+' ›</button></div>';
    var b=ps.querySelector('#pixOkBtn'); if(b) b.onclick=function(){ pixFecharTudo(); if(soConsultas) voltarHome(); else{ _portalMembroCarregado=false; telaRepassePortal(); } };
  }
  /* v1183 — saldo zero de conta nova não é "saldo acabando". O banner só
     passa a fazer sentido depois da primeira recarga efetivamente creditada
     na carteira; bônus, cortesia, abertura e assinatura não contam. */
  function avisoSaldoBaixo(){
    var ex=$('bxSaldoBanner');
    if(ilimitado || saldo>=10 || !_saldoOk || !jaRecarregouTokens){ if(ex) ex.remove(); return; }
    if(ex) return;
    var host=$('telaHome'); if(!host) return;
    var b=document.createElement('div'); b.id='bxSaldoBanner'; b.className='bx-saldo';
    b.innerHTML='<span>⚠️ Seu saldo está acabando (<b>'+precoReal(saldo)+'</b>).</span><button type="button" id="bxSaldoBtn">Recarregar</button><button type="button" id="bxSaldoX" aria-label="fechar">×</button>';
    host.insertBefore(b, host.firstChild);
    var g=$('bxSaldoBtn'); if(g) g.onclick=function(){ try{ abrirPacotes(); }catch(_){} };
    var x=$('bxSaldoX'); if(x) x.onclick=function(){ b.remove(); };
  }
  /* ================= ADMIN: COBRANÇAS E FATURAMENTO ================= */
  var _cobrancas=[], _cobView='todas', _cobLojas={};
  async function telaCobrancas(){
    if(!_ehAdmin()){ toast('Área do administrador.'); return; }
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><div class="est-head"><h2 style="margin:0">Cobranças e faturamento</h2></div>'+
      '<div id="cobResumo" class="cob-sum">'+skelHtml(1)+'</div>'+
      '<div class="hh-toggle" id="cobTgl" style="margin:12px 0 10px"><button type="button" class="hh-tg on" data-cv="todas">Todas</button><button type="button" class="hh-tg" data-cv="paga">Pagas</button><button type="button" class="hh-tg" data-cv="aberta">Abertas</button></div>'+
      '<div id="cobLista">'+skelHtml(4)+'</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(function(){ telaRepassePortal(); });
    Array.prototype.forEach.call(document.querySelectorAll('#cobTgl .hh-tg'),function(b){ b.onclick=function(){ _cobView=b.getAttribute('data-cv'); Array.prototype.forEach.call(document.querySelectorAll('#cobTgl .hh-tg'),function(x){ x.classList.toggle('on',x===b); }); cobrancasPinta(); }; });
    await cobrancasCarregar(); cobrancasResumo(); cobrancasPinta();
  }
  async function cobrancasCarregar(){
    try{ var r=await withTimeout(supa.from('cobranca').select('*').order('criado_em',{ascending:false}).limit(500),9000); _cobrancas=(r&&r.data)||[]; }catch(_){ _cobrancas=[]; }
    _cobLojas={};
    try{ var m=await withTimeout(supa.from('portal_membro').select('user_id,loja_nome').limit(500),8000); (m&&m.data||[]).forEach(function(x){ _cobLojas[String(x.user_id)]=x.loja_nome||''; }); }catch(_){}
  }
  function cobrancasResumo(){
    var el=$('cobResumo'); if(!el) return;
    var now=new Date(), mes=now.getMonth(), ano=now.getFullYear();
    var fatMes=0, nMes=0, abertoV=0, abertoN=0, pagoTot=0;
    _cobrancas.forEach(function(c){
      if(c.status==='paga'){ pagoTot+=Number(c.valor)||0; if(c.pago_em){ var d=new Date(c.pago_em); if(d.getMonth()===mes && d.getFullYear()===ano){ fatMes+=Number(c.valor)||0; nMes++; } } }
      else if(c.status==='aberta'){ abertoV+=Number(c.valor)||0; abertoN++; }
    });
    var mesNome=now.toLocaleDateString('pt-BR',{month:'long'});
    el.innerHTML='<div class="cob-card big"><span class="cob-k">Faturamento de '+esc(mesNome)+'</span><span class="cob-v">'+brl(fatMes)+'</span><span class="cob-s">'+nMes+' pagamento(s) no mês</span></div>'+
      '<div class="cob-row2"><div class="cob-card"><span class="cob-k">Em aberto</span><span class="cob-v">'+brl(abertoV)+'</span><span class="cob-s">'+abertoN+' cobrança(s)</span></div>'+
      '<div class="cob-card"><span class="cob-k">Total recebido</span><span class="cob-v">'+brl(pagoTot)+'</span><span class="cob-s">desde o início</span></div></div>';
  }
  function _cobStatus(s){ return s==='paga'?'<span class="cob-st ok">paga</span>':(s==='aberta'?'<span class="cob-st ab">aberta</span>':'<span class="cob-st">'+esc(s||'')+'</span>'); }
  function cobrancasPinta(){
    var el=$('cobLista'); if(!el) return;
    var lista=_cobrancas.filter(function(c){ return _cobView==='todas'?true:c.status===_cobView; });
    if(!lista.length){ el.innerHTML='<div class="cli-empty"><b>Nada por aqui</b>Nenhuma cobrança '+(_cobView==='todas'?'':(_cobView==='paga'?'paga ':'aberta '))+'encontrada.</div>'; return; }
    el.innerHTML=lista.map(function(c){
      var quem=_cobLojas[String(c.user_id)]||c.email||'Cliente';
      var data=c.pago_em?('pago '+new Date(c.pago_em).toLocaleDateString('pt-BR')):(c.criado_em?('criado '+new Date(c.criado_em).toLocaleDateString('pt-BR')):'');
      var tp=(c.tipo==='assinatura')?'Assinatura':'Saldo';
      return '<div class="cob-item"><div class="cob-it-tx"><b>'+esc(quem)+'</b><small>'+tp+' · '+esc(data)+'</small></div><div class="cob-it-r"><span class="cob-it-v">'+brl(c.valor)+'</span>'+_cobStatus(c.status)+'</div></div>';
    }).join('');
  }
  async function repPortalCarregar(){
    _repErroP=false;
    /* v288 — UMA CHAMADA SÓ, E SEM O PREÇO DOS OUTROS.
       Antes eram dois "select *": um na rede e outro nos meus. O primeiro
       trazia o preço de repasse de TODAS as lojas pro aparelho de quem
       abrisse o portal. Agora a função mp_repasse_rede devolve os carros da
       rede + os meus (inclusive os fora do ar) e o preço só vem no que é meu. */
    var _tudo=[];
    try{ var r=await withTimeout(supa.rpc('repasse_rede'),9000); _tudo=(r&&r.data)||[]; if(!Array.isArray(_tudo)) _tudo=[]; }
    catch(e){ _tudo=[]; _repErroP=true; }
    _repRede=_tudo.filter(function(x){ return x && x.ativo===true; });
    _repMeu =_tudo.filter(function(x){ return _repMeuCarro(x); });
    _membrosAtivosIds={};
    try{ var ma=await withTimeout(supa.from('portal_membro').select('user_id').eq('ativo',true).limit(500),8000); (ma&&ma.data||[]).forEach(function(m){ _membrosAtivosIds[String(m.user_id)]=true; }); }catch(_){}
    _membrosAtivosIds[String(ANGELO_ID)]=true;
    /* v1067 — "já sei o que tem na vitrine". O card da vitrine (05m) precisa
       distinguir "ainda não carreguei" de "não tem nenhum": o `_repMeu` nasce
       `[]` nos dois casos. A bandeira é ligada AQUI, e não lá, pra valer por
       qualquer caminho que carregue o portal — a home, a tela do Portal ou a
       de Avaliações. Um só lugar diz "já sei". */
    _vitRepPronto=true;
    await ofertasCarregar();
  }
  /* v176 — CARD SIMPLES no Portal do Repasse.
     ANTES: cada card do portal era uma ficha inteira — foto, preço, loja,
     motor, câmbio, todos os itens de série, os opcionais e 3 botões. Com 20
     carros na rede a tela virava um rolo sem fim e o lojista se perdia.
     AGORA: o card mostra só o que decide o "vale a pena olhar?" — foto,
     nome, placa, ano, km, preço e a loja. Tocando nele abre a PÁGINA DE
     VENDA do carro (repVeiculoAbrir), que é a mesma coisa que o link
     mevveiculos.com.br/r/<id> mostra pros outros lojistas. Lista enxuta,
     detalhe completo quando você pede. */
  /* v259 — VENDIDO. Etiqueta de preço com o "check": marcar que o carro saiu.
     Não apaga nada — o carro continua na página pública, só que com a tarja e
     no fim da lista, e sai da conta de "N carros no repasse". Quem quiser tirar
     de vez continua usando o Remover (lixeira). */
  var ICO_VEND='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  async function repMarcarVendido(id, vendido){
    var r=await supa.from('repasse').update({ vendido:!!vendido, vendido_em:(vendido?new Date().toISOString():null), atualizado_em:new Date().toISOString() }).eq('id',id);
    if(r&&r.error) throw r.error;
    return true;
  }
  /* ===== v452 (pedido) — "EM NEGOCIAÇÃO" ou "NO MEU ESTOQUE" =====
     Boa parte do que vai pro repasse ainda NÃO foi comprada: é um carro que o
     vendedor está negociando com o cliente. Pro lojista do outro lado isso
     muda tudo — prazo, quem entrega o documento, se dá pra ver o carro hoje —
     e até a v451 não tinha como saber. (Foi por isso, aliás, que o selo verde
     "No estoque" saiu do card na v441: ele afirmava posse que não existia.
     Agora quem publica é quem diz, então o selo pode voltar sem mentir.)
     ⚠️ Mora dentro do `veiculo` (jsonb) DE PROPÓSITO: coluna nova pediria
     migração no banco, e a RPC mp_repasse_rede já devolve esse objeto
     inteiro — então a informação chega no outro lojista sem tocar em SQL.
     Anúncio antigo não tem o campo e não ganha selo nenhum: card sem selo é
     melhor que card afirmando o que ninguém marcou. */
  var REP_POSSE={
    estoque:    ['No meu estoque', '#166534', '#dcfce7', '#bbf7d0'],
    negociacao: ['Em negociação',  '#9a3412', '#ffedd5', '#fed7aa']
  };
  function _repPosseTag(v){
    var t=REP_POSSE[String((v&&v.posse)||'').toLowerCase()];
    if(!t) return '';
    return '<span class="rep-selo" style="color:'+t[1]+';background:'+t[2]+';border-color:'+t[3]+'">'+t[0]+'</span>';
  }
  function _repCard(x, meu){
    var v=x.veiculo||{};
    var nf=(x.fotos&&x.fotos.length)||0;
    /* v259: carro vendido ganha a TARJA DIAGONAL na miniatura (mesma da página
       pública) — dá pra ver o que já saiu sem abrir carro por carro. */
    var vend=!!x.vendido;
    var _tj=vend?'<span class="rep-vd">Vendido</span>':'';
    var foto=nf?('<div class="est-thumb">'+_tj+'<img loading="lazy" src="'+esc(x.fotos[0])+'">'+(nf>1?('<span class="rep-nf">'+nf+'</span>'):'')+'</div>'):('<div class="est-thumb no">'+_tj+ICO_EST+'</div>');
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
    var selo=(_membrosAtivosIds && _membrosAtivosIds[String(x.user_id)])?'<span class="rep-selo">Parceiro</span>':'';
    var sub='<b>'+esc(x.placa||'-')+'</b>'+(v.ano?' · '+esc(v.ano):'')+(v.km?(' · '+Number(v.km).toLocaleString('pt-BR')+' km'):'');
    var loja='<div class="rep-loja">'+esc(x.loja_nome||'Loja')+([x.cidade,x.uf].filter(Boolean).join('/')?(' · '+esc([x.cidade,x.uf].filter(Boolean).join('/'))):'')+(meu&&!x.ativo?' · <span style="color:#b91c1c;font-weight:800">fora do ar</span>':'')+'</div>';
    return '<div class="est-card rep-card rep-simples'+(vend?' vend':'')+'" data-abrir="'+esc(x.id)+'">'+foto+
      '<div class="est-tx"><div class="est-nm">'+esc(nome)+selo+_repPosseTag(v)+'</div><div class="est-sb">'+sub+'</div>'+   /* v452 */
      '<div class="rep-preco-titulo">Preço de repasse</div><div class="est-row">'+_repPrecoHtml(x)+'</div>'+_repComparativo(x)+loja+'<button type="button" class="cad-btn sec rep-abrir">Ver veículo</button></div>'+
      /* v178: no SEU carro a setinha vira lixeira — dá pra tirar do portal
         sem precisar abrir a página do veículo antes. */
      /* v259: dois atalhos no próprio card (pedido) — marcar vendido e remover,
         sem precisar abrir a página do veículo. */
      (meu?('<div class="rep-acts-mini">'+
              '<button type="button" class="rep-vdbt'+(vend?' on':'')+'" data-vend="'+esc(x.id)+'" title="'+(vend?'Desmarcar vendido':'Marcar como vendido')+'" aria-label="'+(vend?'Desmarcar vendido':'Marcar como vendido')+'">'+ICO_VEND+'</button>'+
              '<button type="button" class="rep-del" data-del="'+esc(x.id)+'" title="Remover do portal" aria-label="Remover do portal">'+ICO_TRASH+'</button>'+
            '</div>')
         :'<span class="rep-go" aria-hidden="true">›</span>')+'</div>';
  }
  /* v176 — A PÁGINA DE VENDA DO CARRO, dentro do app.
     É a irmã da página pública /r/<id>: mesma ordem, mesmas informações.
     A diferença é que aqui embaixo ficam os BOTÕES que só fazem sentido
     dentro do app (fazer oferta, publicar/tirar do ar, remover) — e o
     botão de compartilhar, que copia justamente o link /r/<id>. */
  /* v178 — o resumo do estado, do jeito que a avaliação preencheu.
     Verde = boa notícia, vermelho = ponto de atenção, cinza = neutro.
     Cada campo tem a sua tabelinha porque "Sim" é bom em revisões e é
     ruim em alienação — a mesma palavra muda de lado. */
  var _EST_LBL={ipva:'IPVA', ar:'Ar-condicionado', direcao:'Direção', alienado:'Alienado', multas:'Multas', chave:'Chave reserva', manual:'Manual', revisoes:'Revisões concessionária', donos:'Histórico de donos'};
  var _EST_ORD=['ipva','ar','direcao','alienado','multas','chave','manual','revisoes','donos'];
  var _EST_BOM={ipva:['pago'], ar:['tem e gela'], direcao:['tem (hidr./elétr.)'], alienado:['não'], multas:['não'], chave:['tem'], manual:['tem','digital (app)'], revisoes:['sim'], donos:['único dono','segundo dono']};
  var _EST_RUIM={ipva:['em atraso'], ar:['não tem','tem, não gela'], direcao:['não tem'], alienado:['sim'], multas:['sim'], chave:['não tem'], manual:['não tem'], revisoes:['não'], donos:['3+ donos']};
  function _estTom(k,t){ var z=String(t||'').toLowerCase().trim();
    if((_EST_BOM[k]||[]).indexOf(z)>=0) return ' ok';
    if((_EST_RUIM[k]||[]).indexOf(z)>=0) return ' no';
    return ''; }
  function _repEstadoHtml(e){
    if(!e || typeof e!=='object') return '';
    var out=_EST_ORD.filter(function(k){ return e[k]; }).map(function(k){
      return '<div class="repest-i'+_estTom(k,e[k])+'"><span>'+esc(_EST_LBL[k])+'</span><b>'+esc(e[k])+'</b></div>';
    }).join('');
    return out?('<div class="repest">'+out+'</div>'):'';
  }
  /* v178 — EDITAR PELO PORTAL. Abre a janela de avaliação do próprio carro,
     com tudo que você já tinha preenchido, pra mudar o preço (ou qualquer
     outra coisa). Se a placa ainda está no seu histórico de consultas, uso
     os dados de lá; senão, remonto o veículo a partir do próprio anúncio. */
  function repEditarAval(x){
    var pl=String((x&&x.placa)||'').toUpperCase();
    if(!pl){ toast('Este anúncio está sem placa.'); return; }
    var it=null; try{ it=histLerUm(pl); }catch(_){}
    if(it && it.v){
      veiculoAtual=it.v; histFonteTs=it.ts; fichaState=it.ficha||null; fichaTecState=it.fichaTec||null; leilaoState=it.leilao||null;
    } else {
      var vv=(x&&x.veiculo)||{};
      veiculoAtual={ placa:pl, marca:vv.marca||'', modelo:vv.modelo||'', ano:vv.ano_fab||vv.ano||'', ano_modelo:vv.ano_modelo||vv.ano||'', cor:vv.cor||'', combustivel:vv.combustivel||'', fipe:vv.fipe||'' };
      histFonteTs=null; fichaState=null; fichaTecState=null; leilaoState=null;
    }
    var pIn=$('placa'); if(pIn) pIn.value='';
    abrirAvaliacaoLojista();
    setTimeout(function(){ try{ var c=$('avRepPreco'); if(c){ c.scrollIntoView({block:'center'}); } }catch(_){} }, 400);
    toast('Mude o "Preço no Portal do Repasse".');
  }
  var _rvFotos=[];
  function repVeiculoAbrir(x, meu){
    if(!x) return;
    if(!meu&&x.id){_publicoAbrir(location.origin+'/r/'+encodeURIComponent(x.id),{titulo:'Página do lojista',voltar:'Voltar à rede de repasses'});return;}
    var v=x.veiculo||{};
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
    var fotos=(x.fotos&&x.fotos.length)?x.fotos.slice():[];
    _rvFotos=fotos;
    /* v259: a tarja de vendido também na galeria da página do veículo */
    var _tjv=x.vendido?'<span class="rv-vd">Vendido</span>':'';
    var gal = fotos.length
      ? ('<div class="rv-gal'+(x.vendido?' vend':'')+'">'+_tjv+'<div class="rv-tr" id="rvTr">'+fotos.map(function(f,i){ return fotosGaleriaImg(f,i,'foto '+(i+1)); }).join('')+'</div>'+
         '<span class="rv-zoom">'+mkIco('ampliar',13)+'toque pra ampliar</span>'+
         (fotos.length>1?('<div class="rv-cnt" id="rvCnt">1/'+fotos.length+'</div>'):'')+'</div>')
      : ('<div class="rv-gal vazia'+(x.vendido?' vend':'')+'">'+_tjv+ICO_EST+'<span>sem foto</span></div>');
    var sub=[]; if(v.km) sub.push(Number(v.km).toLocaleString('pt-BR')+' km'); if(v.cor) sub.push(String(v.cor)); if(v.ficha&&v.ficha.cambio) sub.push(String(v.ficha.cambio));
    /* comparativo com a FIPE: aqui a conversa é entre lojistas, então o número
       aparece sempre que existir — pra cima ou pra baixo, sem maquiagem. */
    /* v288: o comparativo com a FIPE é uma conta EM CIMA DO PREÇO — "15%
       abaixo da FIPE" entrega o valor tão bem quanto escrevê-lo. Então ele
       só aparece no seu próprio carro. */
    var fipe=Number(v.fipe)||0, preco=(_repMeuCarro(x)?(Number(x.preco)||0):0), fipeBox='';
    if(fipe>0 && preco>0){
      var dif=fipe-preco, pct=Math.round(Math.abs(dif)/fipe*100), abaixo=(dif>=0);
      fipeBox='<div class="rv-sec"><h4>Comparativo com a tabela FIPE</h4><div class="rv-fipe">'+
        '<div class="rv-fc"><b>'+_repDinheiro(fipe)+'</b><span>Tabela FIPE</span></div>'+
        '<div class="rv-fc '+(abaixo?'ok':'up')+'"><b>'+pct+'%</b><span>'+(abaixo?'abaixo da FIPE':'acima da FIPE')+'</span></div></div>'+
        '<div class="rv-fnota">Diferença de <b>'+_repDinheiro(Math.abs(dif))+'</b> pra tabela.'+(abaixo?' É a margem que sobra pra preparação, custos e lucro na revenda.':'')+'</div></div>';
    }
    var obs=String(x.obs||'').trim();
    var obsBox=obs?('<div class="rv-sec"><h4>Observações do vendedor</h4><div class="rv-obs">'+esc(obs)+'</div></div>'):'';
    var estadoH=_repEstadoHtml(v.estado);
    var estadoBox=estadoH?('<div class="rv-sec"><h4>Estado do veículo</h4>'+estadoH+'</div>'):'';
    var ficha=_repFichaHtml(v.ficha);
    var fichaBox=ficha?('<div class="rv-sec"><h4>Ficha do veículo</h4>'+ficha+'</div>'):'';
    var selo=(_membrosAtivosIds && _membrosAtivosIds[String(x.user_id)])?'<span class="rep-selo">⭐ Parceiro</span>':'';
    var cid=[x.cidade,x.uf].filter(Boolean).join(' / ');
    var lojaBox='<div class="rv-sec"><h4>Quem está vendendo</h4><div class="rv-loja"><div class="rv-lnm">'+esc(x.loja_nome||'Loja')+selo+'</div>'+(cid?('<div class="rv-lcid">'+esc(cid)+'</div>'):'')+'</div></div>';
    var acoes;
    if(meu){
      var nof=_repOfertasRecebidas.filter(function(o){ return String(o.repasse_id)===String(x.id); }).length;
      acoes=
        /* v514 (porta A) — a mesma folha do 18f, agora com o carro na mão.
           Fica PRIMEIRO: é a ação que faz o carro andar; as outras arrumam
           o anúncio. Só com o 18f no build (typeof-guard). */
        (typeof avisarLojistasAbrir==='function'
          ? '<button type="button" class="rep-b av" id="rvAvisar">📣 Avisar lojistas</button>' : '')+
        '<button type="button" class="rep-b ed" id="rvEditar">Editar preço / avaliação</button>'+
        '<button type="button" class="rep-b vd'+(x.vendido?' on':'')+'" id="rvVendido">'+(x.vendido?'Voltar pra disponível':'Marcar como vendido')+'</button>'+
        '<button type="button" class="rep-b" id="rvToggle">'+(x.ativo?'Tirar do ar':'Publicar')+'</button>'+
        '<button type="button" class="rep-b" id="rvOfertas">Ofertas'+(nof?(' ('+nof+')'):'')+'</button>'+
        '<button type="button" class="rep-b rm" id="rvDel">Remover</button>';
    } else {
      acoes='<button type="button" class="rep-b of" id="rvOferta">💸 Fazer oferta</button>'+
        (x.loja_whatsapp?'<button type="button" class="rep-b wa" id="rvWa">💬 Falar com a loja</button>':'');
    }
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg rv-pg">'+
      '<div class="est-head"><h2 style="margin:0">Repasse</h2></div>'+
      gal+
      '<div class="rv-head"><div class="rv-tt">'+esc(nome)+(v.ano?(' '+esc(v.ano)):'')+_repPosseTag(v)+'</div>'+   /* v452 */
      (x.placa?('<span class="rv-pl">'+esc(x.placa)+'</span>'):'')+
      (sub.length?('<div class="rv-sub">'+esc(sub.join(' · '))+'</div>'):'')+
      /* v288: no meu carro, "Preço de repasse R$ X". No dos outros, o convite. */
      '<div class="rv-prl">Preço de repasse</div><div class="rv-pr">'+_repDinheiro(x.preco)+'</div></div>'+
      fipeBox+obsBox+estadoBox+fichaBox+lojaBox+
      '<div class="rep-acts rv-acts">'+acoes+'</div>'+
      '<button type="button" class="cad-btn sec" id="rvShare" style="margin-top:10px">Compartilhar com outro lojista</button>'+
      /* v656 — a arte pro grupo de repasse. 🔴 O PREÇO OBEDECE A MESMA REGRA
         DESTA TELA (v288/v453): vai pra arte o `preco` que o `_repPrecoHtml`
         mostraria aqui, e só ele. Se a tela diz "Faça sua oferta", a arte
         nasce sem valor e com o campo vazio pro lojista digitar. */
      /* v835: e com a arte ligada (00-edicoes) */
      ((x.fotos&&x.fotos.length && (typeof arteDisponivel!=='function'||arteDisponivel())) ? '<button type="button" class="cad-btn sec" id="rvArte" style="margin-top:8px">Gerar arte</button>' : '')+
      '<div class="rv-foot">O link abre a mesma página que você está vendo, no navegador de qualquer pessoa.</div>'+
    '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack();
    voltarTab(function(){ telaRepassePortal(true); });
    /* contador das fotos + toque pra ampliar (usa o mesmo visualizador do estoque) */
    var tr=$('rvTr');
    if(tr){
      fotosGaleriaPreparar(tr,0);
      tr.addEventListener('scroll',function(){ requestAnimationFrame(function(){
        var i=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth)); fotosGaleriaPreparar(tr,i); var c=$('rvCnt'); if(c) c.textContent=(i+1)+'/'+_rvFotos.length;
      }); });
      Array.prototype.forEach.call(tr.querySelectorAll('img'),function(im){
        im.onclick=function(){ fotosVerAbrir(_rvFotos, parseInt(im.getAttribute('data-i'),10)||0, {editar:false}); };
      });
    }
    var bo=$('rvOferta'); if(bo) bo.onclick=function(){ ofertaAbrir(x); };
    var bw=$('rvWa'); if(bw) bw.onclick=function(){ _repWa(x.loja_whatsapp, 'Olá! Tenho interesse no repasse do '+nome+' ('+(x.placa||'')+') que você publicou.'); };
    var bg=$('rvOfertas'); if(bg) bg.onclick=function(){ telaRepassePortal().then(function(){ var t=document.querySelector('#repTgl .hh-tg[data-rv="ofertas"]'); if(t) t.click(); }); };
    var bt=$('rvToggle'); if(bt) bt.onclick=async function(){
      /* v452: o botão continua na tela — ele também serve pra TIRAR DO AR, e
         isso ninguém perde. O freio só entra no movimento de PÔR no ar. */
      if(!x.ativo && !(await podeAnunciarRepasseAsync())){ toast(REPASSE_TRAVA_TX); return; }
      try{ await supa.from('repasse').update({ativo:!x.ativo, atualizado_em:new Date().toISOString()}).eq('id',x.id); x.ativo=!x.ativo; toast(x.ativo?'No ar ✓':'Tirado do ar.'); bt.textContent=x.ativo?'Tirar do ar':'Publicar'; await repPortalCarregar(); }catch(_){ toast('Não consegui.'); }
    };
    var bvd=$('rvVendido'); if(bvd) bvd.onclick=async function(){
      var novoV=!x.vendido;
      if(novoV && !confirm('Marcar este carro como VENDIDO?\n\nEle continua na página pública, com a tarja de vendido e no fim da lista, mas sai da conta de carros disponíveis.')) return;
      bvd.disabled=true;
      try{ await repMarcarVendido(x.id, novoV); x.vendido=novoV;
        toast(novoV?'Marcado como vendido ✓':'Voltou pra disponível.');
        await repPortalCarregar(); repVeiculoAbrir(x, meu);
      }catch(_){ bvd.disabled=false; toast('Não consegui salvar.'); }
    };
    var bd=$('rvDel'); if(bd) bd.onclick=async function(){
      if(!confirm('Remover este carro do seu portal de repasse?')) return;
      try{ var d=await supa.from('repasse').delete().eq('id',x.id); if(d&&d.error) throw d.error; toast('Removido.'); await repPortalCarregar(); telaRepassePortal(); }catch(_){ toast('Não consegui remover.'); }
    };
    var be=$('rvEditar'); if(be) be.onclick=function(){ repEditarAval(x); };
    var bav=$('rvAvisar'); if(bav) bav.onclick=function(){
      var _av=null; try{ _av=avisarLojistasDoRepasse(x); }catch(_){}
      if(!_av){ toast('Não consegui montar a mensagem deste carro.'); return; }
      avisarLojistasAbrir(_av.texto, _av.titulo, { link:_av.link, foto:_av.foto||'', chave:_av.chave||'' });
    };
    var bs=$('rvShare'); if(bs) bs.onclick=function(){ repVeiculoCompartilhar(x, nome); };
    var ba=$('rvArte'); if(ba) ba.onclick=function(){
      arteAbrir({
        marca:v.marca||'', modelo:v.modelo||'', ano:v.ano||'', ano_modelo:v.ano_modelo||v.ano||'',
        fotos:(x.fotos||[]).slice(), extras:{ fipe:{ valor:Number(v.fipe)||0 } },
        preco_repasse:Number(x.preco)||0, vendido:!!x.vendido
      }, 'repasse');
    };   /* v656 */
  }
  /* Compartilhar: o mesmo link que qualquer lojista abre no navegador. */
  function repVeiculoCompartilhar(x, nome){
    if(!x || !x.id){ toast('Salve o veículo antes de compartilhar.'); return; }
    var url=MEV_SITE+'/r/'+encodeURIComponent(String(x.id));
    /* v288: o link vai sem valor — quem abrir faz a oferta dele. */
    var txt=nome+(x.placa?(' ('+x.placa+')'):'')+' — repasse, faça sua oferta:\n'+url;
    try{
      /* v672 (pedido: "arrume o link que vai pro cliente") — SEM o campo url.
         O `txt` logo acima JÁ TERMINA no endereço. Mandando os dois, o
         WhatsApp escrevia o texto e, colado embaixo, o mesmo endereço outra
         vez. É o mesmo conserto da página do veículo e do catálogo — e o
         mesmo caminho que o compartilhar do estoque usa desde a v309.
         ⚠️ O `url` continua existindo: é ele que vai pra área de
         transferência quando o aparelho não tem navigator.share. */
      if(navigator.share){ navigator.share({title:nome, text:txt}).catch(function(){}); return; }
    }catch(_){}
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url); toast('Link copiado ✓'); return; }
    }catch(_){}
    try{ window.open(url,'_blank'); }catch(_){ toast(url); }
  }
  /* bloco da FICHA no anúncio do repasse: motor, câmbio, itens de série e
     opcionais marcados pelo lojista. Só aparece se tiver algo. */
  function _repFichaHtml(f){
    if(!f) return '';
    var motor=String(f.motor||'').trim(), cambio=String(f.cambio||'').trim();
    var serie=(Array.isArray(f.serie)?f.serie:[]).filter(Boolean);
    var opc=(Array.isArray(f.opcionais)?f.opcionais:[]).filter(Boolean);
    if(!motor&&!cambio&&!serie.length&&!opc.length) return '';
    function kv(lb,val){ return val?('<div class="repf-kv"><span>'+esc(lb)+'</span><b>'+esc(val)+'</b></div>'):''; }
    function chips(titulo,arr,cls){ if(!arr.length) return ''; return '<div class="repf-t">'+esc(titulo)+'</div><div class="repf-chips">'+arr.map(function(n){ return '<span class="repf-chip '+cls+'">'+esc(n)+'</span>'; }).join('')+'</div>'; }
    return '<div class="repf">'+kv('Motor',motor)+kv('Câmbio',cambio)+
      chips('Itens de série', serie, 'serie')+
      chips('Opcionais deste carro', opc, 'opc')+'</div>';
  }
  function repPortalPinta(){
    var el=$('repPortalLista'); if(!el) return;
    el.classList.toggle('rep-lista-cards',_repView==='rede'||_repView==='meu');
    var filtros=document.querySelector('.rep-lista-filtros'); if(filtros) filtros.hidden=(_repView==='ofertas'||_repView==='particular');
    var st=document.querySelector('.info-pg .cli-top'); if(st) st.style.display=(_repView==='ofertas')?'none':'';
    if(_repView==='ofertas'){ ofertasPinta(el); return; }
    /* v308 — a aba dos carros de particular. A lista vem de uma porta
       separada (mp_anuncios_rede), então ela carrega sob demanda: quem nunca
       abre esta aba não paga nem uma consulta por ela. */
    if(_repView==='particular'){
      if(!_apLista.length && !_apErro){
        el.innerHTML=skelHtml(3);
        apCarregar().then(function(){ if(_repView==='particular') apPinta(el); });
      } else apPinta(el);
      return;
    }
    if(_repErroP && !_repRede.length && _repView==='rede'){ erroLista(el, async function(){ el.innerHTML=skelHtml(4); await repPortalCarregar(); repPortalPinta(); }); return; }
    var termo=String((($('repPortalBusca')||{}).value)||'').toLowerCase().trim();
    /* v178 — CONSERTO IMPORTANTE. Antes "sou o dono" era a ABA em que você
       estava. Resultado: o seu próprio carro, aberto pela aba Rede, mostrava
       "Fazer oferta" em vez de Publicar/Ofertas/Remover. Agora a pergunta é
       a certa: o carro é meu se o user_id dele for o meu. */
    var aba=(_repView==='meu'); var base=aba?_repMeu:_repRede;
    function _souDono(x){ return !!meuId && String(x.user_id||'')===String(meuId); }
    var sit=($('repRedeSituacao')||{}).value||'', ord=($('repRedeOrdem')||{}).value||'';
    var lista=base.filter(function(x){ if(sit==='vendido'&&!x.vendido || sit==='disponivel'&&x.vendido) return false; if(!termo) return true; var v=x.veiculo||{}; return ((x.placa||'')+' '+(v.marca||'')+' '+(v.modelo||'')+' '+(x.loja_nome||'')+' '+(x.cidade||'')).toLowerCase().indexOf(termo)>=0; });
    if(ord) lista.sort(function(a,b){var pa=Number(a.preco),pb=Number(b.preco);if(!(pa>0))return pb>0?1:0;if(!(pb>0))return -1;return ord==='menor'?pa-pb:pb-pa;});
    if(!lista.length && (termo||sit)){el.innerHTML='<div class="cli-empty"><b>Nenhum veículo encontrado</b>Altere a busca ou a situação.</div>';return;}
    if(!lista.length){
      /* v452: sem plano Lojista, mandar o vendedor "marcar o interruptor na
         Avaliação" seria mandá-lo procurar um botão que a v452 esconde dele.
         A aba passa a dizer a verdade. */
      var _vazioMeu = podeAnunciarRepasse()
        ? '<b>Você ainda não publicou nenhum carro</b>Na Avaliação do veículo, marque "🔁 Publicar no repasse".'
        : '<b>Publicar é do plano Lojista</b>No seu plano você vê os carros da rede e faz ofertas.';
      el.innerHTML='<div class="cli-empty">'+(aba?_vazioMeu:'<b>Nenhum carro na rede ainda</b>Assim que as lojas publicarem repasses, aparecem aqui.')+'</div>'; return; }
    el.innerHTML=lista.map(function(x){ return _repCard(x, _souDono(x)); }).join('');
    /* v176: o card inteiro é o botão. Tocou, abre a página de venda do carro. */
    Array.prototype.forEach.call(el.querySelectorAll('[data-abrir]'),function(c){ c.onclick=function(){ var x=lista.filter(function(y){return String(y.id)===String(c.getAttribute('data-abrir'));})[0]; if(x){_repRetorno={view:_repView,busca:($('repPortalBusca')||{}).value||'',sit:sit,ord:ord,y:window.scrollY};repVeiculoAbrir(x, _souDono(x));} }; });
    /* v178: a lixeira. stopPropagation() é obrigatório — sem ele o toque
       escorreria pro card inteiro e abriria a página em vez de remover. */
    /* v259: o mesmo cuidado do stopPropagation vale aqui — sem ele o toque
       escorre pro card e abre a página em vez de marcar. */
    Array.prototype.forEach.call(el.querySelectorAll('[data-vend]'),function(b){
      b.onclick=async function(e){
        try{ e.stopPropagation(); e.preventDefault(); }catch(_){}
        var id=b.getAttribute('data-vend');
        var it=lista.filter(function(y){return String(y.id)===String(id);})[0]||{};
        var novoV=!it.vendido;
        var nm=(((it.veiculo||{}).marca||'')+' '+((it.veiculo||{}).modelo||'')).trim()||'este carro';
        if(novoV && !confirm('Marcar '+nm+(it.placa?(' ('+it.placa+')'):'')+' como VENDIDO?\n\nEle continua na página, com a tarja de vendido, mas sai da conta de carros disponíveis.')) return;
        b.disabled=true;
        try{ await repMarcarVendido(id, novoV); it.vendido=novoV;
          toast(novoV?'Marcado como vendido ✓':'Voltou pra disponível.');
          await repPortalCarregar(); repPortalPinta();
        }catch(_){ b.disabled=false; toast('Não consegui salvar.'); }
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-del]'),function(b){
      b.onclick=async function(e){
        try{ e.stopPropagation(); e.preventDefault(); }catch(_){}
        var id=b.getAttribute('data-del');
        var it=lista.filter(function(y){return String(y.id)===String(id);})[0]||{};
        var nm=(((it.veiculo||{}).marca||'')+' '+((it.veiculo||{}).modelo||'')).trim()||'este carro';
        if(!confirm('Remover '+nm+(it.placa?(' ('+it.placa+')'):'')+' do portal de repasse?')) return;
        b.disabled=true;
        try{ var d=await supa.from('repasse').delete().eq('id',id); if(d&&d.error) throw d.error;
          toast('Removido do portal.'); await repPortalCarregar(); repPortalPinta();
        }catch(_){ b.disabled=false; toast('Não consegui remover.'); }
      };
    });
  }
  /* v1406 — o menu abre primeiro a apresentação, dentro do visor público do
     app. Compartilhar passa a ser uma escolha visível depois que a pessoa viu
     a página; o parâmetro novo força o WhatsApp a buscar a capa horizontal em
     vez de reutilizar a miniatura quadrada que já estava em cache. */
  function abrirApresentacaoConsultasLojista(){
    var url='';
    try{ url=location.origin+'/consultas-para-lojistas?v=1406'; }
    catch(_){ url='https://mevveiculos.com.br/consultas-para-lojistas?v=1406'; }
    var dados={
      title:'MEV Consultas para lojistas',
      text:'Conheça o MEV Consultas para sua loja:',
      url:url
    };
    try{
      _publicoAbrir(url,{
        titulo:'MEV Consultas para lojistas',
        voltar:'Fechar apresentação e voltar ao app',
        compartilhar:dados
      });
    }catch(_){ try{ window.open(url,'_blank','noopener'); }catch(__){ location.href=url; } }
  }
  function drawerIr(acao){
    /* v1301 — preferência visual local: não é rota nem produto pago, então
       precisa acontecer antes dos portões de edição e assinatura. */
    if(acao==='tema'){
      var modo='escuro'; try{ modo=temaConsultasAlternar(); }catch(_){}
      drawerFechar(false); toast(modo==='escuro'?'Tema escuro ativado.':'Tema claro ativado.'); return;
    }
    /* v1361 — saída explícita no menu. Reutiliza o botão canônico para
       conservar o mesmo encerramento resistente a sessão travada. */
    if(acao==='sair'){
      if(!confirm('Deseja sair da sua conta?')) return;
      drawerFechar(false);
      var sairBt=$('btnSair'); if(sairBt) sairBt.click();
      return;
    }
    if(acao==='instalar'){
      drawerFechar(false);
      try{ instalarAppAbrir(); }catch(_){ toast('Abra o menu do navegador e escolha “Adicionar à Tela de Início”.'); }
      return;
    }
    if(acao==='compartilhar_consultas'){
      drawerFechar(false);
      abrirApresentacaoConsultasLojista();
      return;
    }
    if(edicaoAtual()==='avalia'){
      if(acao==='consultas' || acao==='buscaplaca'){ avAreaIr('consultas'); return; }
      if(acao==='avaliacoes'){ avAreaIr('avaliacoes'); return; }
      if(['buscaveiculo','historico','plus','restricao','cnpj'].indexOf(acao)!==-1){
        if(!avAreaSalvar()) return;
        avAreaMarcar('consultas');
      }
    }
    /* O acesso à conta não autoriza sair da edição pelo menu ou gesto. */
    if(typeof window.edIsolada==='function' && window.edIsolada()
       && acao!=='inicio' && acao!=='apphome'
       && typeof window.edicaoPermite==='function' && !window.edicaoPermite(acao)){
      drawerFechar(false);
      return;
    }
    try{ mdrAtivoSet(acao); }catch(_){}   /* v746: o item ativo do menu acompanha a tela */
    /* v948 — estas duas entradas têm um contrato próprio no MEV Avaliações:
       assinatura elegível abre gestão; sem ela abre a vitrine pública em
       modo leitura. Vêm antes do acPortao para que o não assinante não seja
       empurrado a um modal de compra quando pediu apenas para visualizar. */
    try{
      if((acao==='catalogo'||acao==='repasse_meu') && typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia'){
        drawerFechar(false); mevAcoes(false); avaliaVitrineIr(acao); return;
      }
    }catch(_){}
    /* v486 — EDIÇÕES (00-edicoes.js, que vive FORA deste IIFE): página fora
       da edição NUNCA quebra nem abre — vira a PORTA de upsell. Deep link,
       deslize, topbar, botão interno: todo mundo entra por aqui. Sem o
       00 (typeof) ou na edição 'completo', nada muda. */
    /* v499 (pedido): "se o usuário já tiver o pacote, já abre o app; se tem
       o pacote não mostra landing page". Quem TEM o produto não leva porta
       de venda: a página abre normalmente, mesmo estando fora do menu
       daquele app (a edição é FOCO, não cadeado). A porta — e as landings
       da v498 — ficam pra quem NÃO tem, quando a Fase 3 chegar. */
    try{
      if(acao!=='inicio' && acao!=='apphome' && typeof window.edicaoPermite==='function' && !window.edicaoPermite(acao)
         && !(typeof window.edTemPacote==='function' && window.edTemPacote(acao))){
        drawerFechar(false); window.edPortaAbrir(acao); return;
      }
    }catch(_){}
    /* 🔴 v840 — O MESMO PORTÃO DO CARD, AQUI. Este é o funil por onde passam
       o item do menu, o deslize, a topbar e o LINK DIRETO (§8 do projeto:
       "link direto para rota protegida: revalida"). Bloquear só no card
       deixaria a porta dos fundos aberta pra quem soubesse o nome da rota.
       ⚠️ E continua sendo trava de TELA, não cofre: a API por trás segue
       aberta até a Fase 4. Está escrito assim no changelog de propósito. */
    try{ if(typeof acPortao==='function' && acPortao(acao)){ drawerFechar(false); return; } }catch(_){}
    drawerFechar(false);
    if(acao!=='plus') mevAcoes(false);
    if(acao==='buscaplaca'){
      voltarHome();
      setTimeout(function(){ var p=$('placa'); if(p){ try{ p.focus(); p.select(); }catch(_){} } },80);
      return;
    }
    if(acao==='plus'){ abrirConsultaPlus(); return; }
    if(acao==='buscaveiculo'){ abrirBuscaVeiculo(); return; }   /* v406: busca FIPE virou aba, no lugar do Histórico */
    if(acao==='historico'){ abrirHistorico(); return; }         /* v406: sem botão no menu, mas o caminho continua (a lista mora na home) */
    if(acao==='avaliacoes'){ return telaAvaliacoes(); }   /* v383: lista das avaliações salvas */   /* v382: o histórico virou página do menu */
    if(acao==='restricao'){ abrirRestricao(); return; }
    if(acao==='cnpj'){ abrirCnpj(); return; }
    if(acao==='loja'){ telaLoja(); return; }
    if(acao==='estoque'){ return telaEstoque(); }
    if(acao==='mercado'){ return telaMercado(); }   /* v659 — o mercado da região */
    if(acao==='repasse_meu'){ abrirRepasseEstoque(); return; }   /* v396: página Repasse (negociando) */
    if(acao==='catalogo'){ return homeCatalogoAbrir(); }        /* v396: Catálogo pelo menu */
    /* v537 — VITRINE: os carros disponíveis, como o cliente vê, DENTRO do app.
       ⚠️ Não confundir com 'catalogo' logo acima: aquele abre a página
       PÚBLICA num visor; esta é tela do app, e lê a mesma fonte do site
       (mp_get_catalogo). Duas portas pro mesmo assunto, de propósito — uma
       pra olhar rápido, outra pra mostrar/compartilhar. */
    if(acao==='vitrine'){ if(typeof telaVitrine==='function') telaVitrine(); return; }
    if(acao==='vincular'){ vincularClienteAbrir(); return; }
    if(acao==='add-estoque'){ estFromConsulta(); return; }
    if(acao==='vendas'){ telaVendas(); return; }
    if(acao==='repasse'){ telaRepasse(); return; }
    if(acao==='repasse_portal'){ telaRepassePortal(); return; }
    if(acao==='clientes'){ return telaClientes(); }
    if(acao==='funil'){ telaFunil(); return; }   /* v431 */
    /* v433 · 🔴 v526 — A LINHA FOI TROCADA, NÃO APAGADA.
       Notificação antiga, atalho salvo e link de push ainda apontam pra ação
       'chat'. Apagar daria TELA BRANCA em quem tocasse num aviso de ontem;
       trocar abre o painel, que agora é a caixa de entrada. E com
       MEV_CHAT_NO_MENU=true (o caminho de volta) a página abre como antes —
       a rota nunca fica sem dono. */
    if(acao==='chat'){
      if(typeof MEV_CHAT_NO_MENU!=='undefined' && MEV_CHAT_NO_MENU){ telaChat(); return; }
      if(typeof chatPainelAbrirClientes==='function'){ chatPainelAbrirClientes(); return; }
      telaChat(); return;
    }
    if(acao==='posvendas'){ return telaPosVendas(); }   /* v434 */
    if(acao==='prerenave'){ telaPreRenave(); return; }   /* v442 */
    if(acao==='cadastro'){ telaCadastro(); return; }
    if(acao==='tokens'){ abrirPacotes(); return; }
    if(acao==='notificacoes'){ telaNotificacoes(); return; }
    /* v432 — "Parceiros" virou duas páginas. A terceira linha é o seguro:
       atalho velho apontando pra 'parceiros' (notificação antiga, link
       salvo) continua caindo num lugar que existe em vez de tela branca. */
    /* v497 — a página inicial do app (o painel de cards da edição).
       v499: nos apps sem consulta o painel É a home, então basta voltar. */
    /* ===== v814 §8.3 — PAINEL INICIAL =====
       Ação PRÓPRIA, roteada pra home comum que já existe. Não é o `painel`
       (área do dono, logo abaixo) e não é atalho pra ele: o projeto pede a
       separação com todas as letras, e ela vive aqui, na roteadora.
       Cai no mesmo lugar do 'apphome' de propósito — nos apps sem consulta
       o painel de cards JÁ É a home, então `voltarHome()` é a home certa. */
    if(acao==='inicio'){
      if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='consultas'){ voltarHome(); return; }
      try{ if(typeof window.edicaoPermite==='function' && !window.edicaoPermite('buscaplaca')){ voltarHome(); return; } }catch(_){}
      telaHomeApp(); return;
    }
    if(acao==='apphome'){
      try{ if(typeof window.edicaoPermite==='function' && !window.edicaoPermite('buscaplaca')){ voltarHome(); return; } }catch(_){}
      telaHomeApp(); return;
    }
    if(acao==='apps'){   /* v491 — a família de apps */
      /* v497 — enquanto o MEV_PREVIA estiver ligado, a vitrine da família é
         só do dono (ou de quem já está DENTRO de uma edição, que precisa
         dela pra voltar). Deep link de outra pessoa não abre nem quebra:
         cai na inicial de sempre. */
      try{ if(typeof window.edAppsVisivel==='function' && !window.edAppsVisivel(_ehAdmin())){ voltarHome(); return; } }catch(_){}
      telaAppsMev(); return;
    }
    if(acao==='rede_repasses'){ telaRedeRepasses(); return; }
    if(acao==='rede_seminovos'){ telaRedeSeminovos(); return; }
    if(acao==='parceiros'){ telaRedeRepasses(); return; }
    if(acao==='indicador'){ telaIndicador(); return; }
    /* v351: PAINEL do dono (/admin). Abre em outra aba porque é uma página
       separada, fora do app. A conferência aqui é só cortesia — quem barra de
       verdade é o servidor do /admin (env ADMIN_EMAILS). */
    /* v556 — o espelho da Cotação VW. A trava mora na própria tela
       (cotPodeVer), como no Painel: item escondido não é cadeado. */
    if(acao==='cotacaovw'){ telaCotacaoVW(); return; }
    if(acao==='painel'){
      if(!_ehAdmin()){ toast('Área do administrador.'); return; }
      /* ⚠️ v513 — O PAINEL PASSOU A ABRIR DENTRO DO APP (Fase 1 do
         PROJETO-painel-dentro-do-app). Era window.open('/admin'), que abria
         uma ABA com outro app: CSS próprio, menu próprio, e sem funcionar
         direito no celular.
         O /admin continua no ar de propósito (Fase 4 do projeto) — o rodapé
         da tela nova tem o link pra ele, e este catch também. */
      try{ telaPainelAdmin(); }
      catch(_){ try{ window.open('/admin','_blank','noopener'); }catch(__){ location.href='/admin'; } }
      return;
    }
    telaInfo(acao);
  }
  async function avaliaVitrineIr(acao){
    try{ if(typeof acGarantir==='function') await acGarantir(); }catch(_){}
    var modulo=acao==='catalogo'?'estoque':'repasse_meu';
    var pode=false;
    try{ pode=typeof acPodeGerirVitrine==='function'&&acPodeGerirVitrine(modulo); }catch(_){ pode=false; }
    if(pode){
      if(acao==='catalogo'){ telaEstoque(); return; }
      abrirRepasseEstoque(); return;
    }
    if(typeof avaliaVitrinePublicaAbrir==='function') avaliaVitrinePublicaAbrir(acao==='catalogo'?'catalogo':'repasse');
  }

  /* v240: o bloco "Acesso rápido" da home foi removido (pedido do Angelo).
     O HTML saiu do app.html; aqui saiu o listener que reagia aos cliques. */

/* ╔═══ src/app/09b-anuncios-particular.js ════════════════════════════════ */
  /* ==========================================================================
   * v308 — "DE PARTICULARES": os carros que donos comuns puseram na rede.
   *
   * É o outro lado do /vender do site. O lojista vê o carro e faz a oferta, do
   * mesmo jeito que já faz no repasse entre lojas — mesma tela, mesma janela
   * de oferta, mesmo gesto. Aprender coisa nova aqui seria custo à toa.
   *
   * O QUE ELE NÃO VÊ — E NÃO É ESTA TELA QUE DECIDE:
   *   · nome e WhatsApp do dono, antes de o dono ACEITAR a oferta dele;
   *   · a placa inteira (fica MJG••••, como na página pública de repasse);
   *   · o que as outras lojas ofereceram.
   * Quem escolhe isso é o BANCO, nas funções mp_anuncios_rede e mp_anuncio_ver,
   * que montam a resposta campo a campo. Se um dia alguém reescrever esta tela
   * inteira, o dado continua protegido. Esconder na tela não é esconder.
   *
   * POR QUE NINGUÉM VÊ A OFERTA DE NINGUÉM: num leilão às claras a segunda
   * loja cobre a primeira por R$ 100 e para. Às cegas, cada uma dá o melhor
   * preço que consegue dar de verdade — e quem ganha com isso é o dono do
   * carro, que é quem a gente precisa convencer a voltar.
   * ========================================================================== */
  var _apLista = [];
  var _apErro  = false;

  async function apCarregar(){
    _apErro = false;
    try{
      var r = await withTimeout(supa.rpc('anuncios_rede'), 9000);
      if(r && r.error) throw r.error;
      _apLista = (r && r.data) || [];
      if(!Array.isArray(_apLista)) _apLista = [];
    }catch(_){ _apLista = []; _apErro = true; }
  }

  function _apNome(a){ return (String((a&&a.marca)||'')+' '+String((a&&a.modelo)||'')).trim() || 'Veículo'; }
  /* Dinheiro SEM centavos. Carro de particular não custa R$ 58.000,00 — custa
     58 mil. Os dois zeros no fim só ocupam espaço e fazem o olho parar. É o
     mesmo formato da mensagem de WhatsApp que já sai do estoque. */
  function _apDin(v){
    var n = Number(v) || 0;
    return n > 0 ? ('R$ ' + n.toLocaleString('pt-BR', { maximumFractionDigits:0 })) : '';
  }
  function _apFotos(a){ return ((a&&a.fotos)||[]).map(function(f){ return (f&&f.url)||f; }).filter(Boolean); }

  /* O carimbo do laudo. Verde quando a placa foi conferida na base ao publicar.
     NÃO escrevo "sem restrição": a consulta da publicação confirma o VEÍCULO,
     não a vida dele. Leilão, sinistro e débito continuam sendo a consulta
     completa — que é paga, e é justamente aí que este recurso vira dinheiro. */
  function _apLaudoHtml(a){
    return a.laudo_ok
      ? '<span class="ap-laudo ok">Placa conferida na base</span>'
      : '<span class="ap-laudo">Placa não conferida</span>';
  }

  function _apCard(a){
    var fotos = _apFotos(a), nf = fotos.length;
    var capa = nf
      ? ('<div class="est-thumb"><img loading="lazy" src="'+esc(fotos[0])+'">'+(nf>1?('<span class="rep-nf">'+nf+'</span>'):'')+'</div>')
      : ('<div class="est-thumb no">'+ICO_EST+'</div>');
    var sub = '<b>'+esc(a.placa||'-')+'</b>'+
              ((a.ano_modelo||a.ano) ? (' · '+esc(a.ano_modelo||a.ano)) : '')+
              (a.km ? (' · '+Number(a.km).toLocaleString('pt-BR')+' km') : '');
    var quer = a.preco_desejado
      ? ('<span class="ap-quer">Quer '+esc(_apDin(a.preco_desejado))+'</span>')
      : '<span class="ap-quer neutro">Faça sua oferta</span>';
    var minha = a.minha_oferta
      ? ('<span class="ap-minha'+(a.minha_oferta.status==='aceita'?' venceu':'')+'">'+
         (a.minha_oferta.status==='aceita' ? 'Você ganhou · ' : 'Sua oferta: ')+
         esc(_apDin(a.minha_oferta.valor))+'</span>')
      : '';
    var onde = [a.cidade, a.uf].filter(Boolean).join('/');
    return '<div class="est-card rep-card rep-simples" data-apabrir="'+esc(a.id)+'">'+capa+
      '<div class="est-tx"><div class="est-nm">'+esc(_apNome(a))+'<span class="ap-tag">particular</span></div>'+
      '<div class="est-sb">'+sub+'</div>'+
      '<div class="est-row">'+quer+minha+'</div>'+
      '<div class="rep-loja">'+(onde?(esc(onde)+' · '):'')+_apLaudoHtml(a)+'</div></div>'+
      '<span class="rep-go" aria-hidden="true">›</span></div>';
  }

  function apPinta(el){
    if(!el) return;
    if(_apErro && !_apLista.length){
      erroLista(el, async function(){ el.innerHTML=skelHtml(3); await apCarregar(); apPinta(el); });
      return;
    }
    var termo = String((($('repPortalBusca')||{}).value)||'').toLowerCase().trim();
    var lista = _apLista.filter(function(a){
      if(!termo) return true;
      return ((a.placa||'')+' '+_apNome(a)+' '+(a.cidade||'')).toLowerCase().indexOf(termo)>=0;
    });
    if(!lista.length){
      el.innerHTML='<div class="cli-empty"><b>Nenhum carro de particular agora</b>'+
        'Quando alguém anunciar o carro pelo site (mevveiculos.com.br/vender), ele aparece aqui e você faz a sua oferta.</div>';
      return;
    }
    el.innerHTML = lista.map(_apCard).join('');
    Array.prototype.forEach.call(el.querySelectorAll('[data-apabrir]'), function(c){
      c.onclick = function(){ apAbrir(c.getAttribute('data-apabrir')); };
    });
  }

  /* ------------------------------------------------------- a página do carro */
  var _apFotosAtuais = [];
  async function apAbrir(id){
    $('secoes').innerHTML = _cadBack()+'<div class="info-pg">'+skelHtml(2)+'</div>';
    $('telaHome').style.display='none';
    document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo');
    $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack();
    voltarTab(_apVoltar);

    var a=null;
    try{
      var r = await withTimeout(supa.rpc('anuncio_ver',{ p_id:String(id) }), 9000);
      if(r && r.error) throw r.error;
      a = r && r.data;
    }catch(_){ a=null; }
    if(!a){
      $('secoes').innerHTML = _cadBack()+'<div class="info-pg"><div class="cli-empty">'+
        '<b>Não consegui abrir este carro</b>Pode ser que o dono já tenha encerrado o anúncio.</div></div>';
      _cadWireBack(); voltarTab(_apVoltar); return;
    }

    var fotos = _apFotos(a);
    _apFotosAtuais = fotos;
    var gal = fotos.length
      ? ('<div class="rv-gal"><div class="rv-tr" id="apTr">'+
         fotos.map(function(f,i){ return fotosGaleriaImg(f,i,'foto '+(i+1)); }).join('')+'</div>'+
         '<span class="rv-zoom">'+mkIco('ampliar',13)+'toque pra ampliar</span>'+
         (fotos.length>1?('<div class="rv-cnt" id="apCnt">1/'+fotos.length+'</div>'):'')+'</div>')
      : ('<div class="rv-gal vazia">'+ICO_EST+'<span>sem foto</span></div>');

    var sub=[];
    if(a.km) sub.push(Number(a.km).toLocaleString('pt-BR')+' km');
    if(a.cor) sub.push(String(a.cor));
    if(a.combustivel) sub.push(String(a.combustivel));

    var ganhou = !!a.ganhei;
    var minha  = a.minha_oferta;

    /* O bloco de preço. No repasse entre lojas o dono do carro vê o próprio
       preço; aqui não existe "preço", existe o que o DONO espera receber — e
       isso é informação boa pro lojista, não é o valor de ninguém. */
    var precoBox = a.preco_desejado
      ? ('<div class="rv-prl">O dono espera receber</div><div class="rv-pr">'+_apDin(a.preco_desejado)+'</div>'+
         '<div class="rv-prnota">É o que ele pediu, não o que você precisa pagar. A oferta é sua.</div>')
      : ('<div class="rv-prl">Valor</div><div class="rv-pr rep-oferta">O dono não disse quanto quer</div>'+
         '<div class="rv-prnota">Faça a sua oferta — ele escolhe entre as lojas.</div>');

    var fipeBox = a.fipe
      ? ('<div class="rv-sec"><h4>Tabela FIPE</h4><div class="rv-fipe">'+
         '<div class="rv-fc"><b>'+_apDin(a.fipe)+'</b><span>Tabela FIPE</span></div>'+
         (a.preco_desejado?('<div class="rv-fc '+((Number(a.fipe)-Number(a.preco_desejado))>=0?'ok':'up')+'"><b>'+
            Math.round(Math.abs(Number(a.fipe)-Number(a.preco_desejado))/Number(a.fipe)*100)+'%</b><span>'+
            ((Number(a.fipe)-Number(a.preco_desejado))>=0?'abaixo do pedido':'acima do pedido')+'</span></div>'):'')+
         '</div></div>')
      : '';

    var obs = String(a.obs||'').trim();
    var obsBox = obs ? ('<div class="rv-sec"><h4>O dono contou</h4><div class="rv-obs">'+esc(obs)+'</div></div>') : '';

    var minhaBox = (minha && !ganhou)
      ? ('<div class="rv-sec"><h4>Sua oferta</h4><div class="ap-minha-box"><b>'+esc(_apDin(minha.valor))+'</b>'+
         '<span>'+(minha.status==='recusada' ? 'O dono escolheu outra loja.' : 'Aguardando o dono escolher.')+'</span></div></div>')
      : '';

    var contatoBox = ganhou
      ? ('<div class="rv-sec"><h4>Negócio fechado</h4><div class="ap-ganhou">'+
         '<b>O dono aceitou a sua oferta.</b>'+
         '<div class="ap-cont">'+esc(a.dono_nome||'')+(a.dono_whatsapp?(' · '+esc(a.dono_whatsapp)):'')+'</div>'+
         '<div class="ap-cont">Placa completa: <b>'+esc(a.placa||'')+'</b></div>'+
         '</div></div>')
      : '';

    var acoes = ganhou
      ? (a.dono_whatsapp ? '<button type="button" class="rep-b wa" id="apZap">💬 Falar com o dono</button>' : '')
      : ('<button type="button" class="rep-b of" id="apOfertar">💸 '+(minha?'Mudar minha oferta':'Fazer oferta')+'</button>'+
         (minha ? '<button type="button" class="rep-b rm" id="apTirar">Tirar minha oferta</button>' : ''));

    $('secoes').innerHTML = _cadBack()+'<div class="info-pg rv-pg">'+
      '<div class="est-head"><h2 style="margin:0">Carro de particular</h2></div>'+
      gal+
      '<div class="rv-head"><div class="rv-tt">'+esc(_apNome(a))+((a.ano_modelo||a.ano)?(' '+esc(a.ano_modelo||a.ano)):'')+'</div>'+
      (a.placa?('<span class="rv-pl">'+esc(a.placa)+'</span>'):'')+
      (sub.length?('<div class="rv-sub">'+esc(sub.join(' · '))+'</div>'):'')+
      precoBox+'</div>'+
      '<div class="ap-onde">'+esc([a.cidade,a.uf].filter(Boolean).join(' / '))+' · '+_apLaudoHtml(a)+'</div>'+
      fipeBox+obsBox+minhaBox+contatoBox+
      (acoes?('<div class="rep-acts rv-acts">'+acoes+'</div>'):'')+
      '<div class="rv-foot">Carro de <b>pessoa física</b>, anunciado pelo site. O contato do dono só é '+
      'liberado se ele aceitar a sua oferta — e nenhuma outra loja vê o que você ofereceu.</div>'+
      '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false);
    _cadWireBack(); voltarTab(_apVoltar);

    var tr=$('apTr');
    if(tr){
      fotosGaleriaPreparar(tr,0);
      tr.addEventListener('scroll',function(){ requestAnimationFrame(function(){
        var i=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));
        fotosGaleriaPreparar(tr,i);
        var c=$('apCnt'); if(c) c.textContent=(i+1)+'/'+_apFotosAtuais.length;
      }); });
      Array.prototype.forEach.call(tr.querySelectorAll('img'),function(im){
        im.onclick=function(){ fotosVerAbrir(_apFotosAtuais, parseInt(im.getAttribute('data-i'),10)||0, {editar:false}); };
      });
    }

    var bz=$('apZap');
    if(bz) bz.onclick=function(){
      var z=String(a.dono_whatsapp||'').replace(/\D/g,''); if(z.length<=11) z='55'+z;
      var pri=String(a.dono_nome||'').split(' ')[0];
      var msg='Olá'+(pri?(', '+pri):'')+'! Sou da loja aqui do MEV Veículos — você aceitou a minha oferta do '+
              _apNome(a)+'. Podemos combinar a vistoria?';
      mevIrProWhats('https://wa.me/'+z+'?text='+encodeURIComponent(msg));   /* v370 */
    };
    var bo=$('apOfertar'); if(bo) bo.onclick=function(){ apOfertaAbrir(a); };
    var bt=$('apTirar');
    if(bt) bt.onclick=async function(){
      if(!confirm('Tirar a sua oferta deste carro?')) return;
      bt.disabled=true;
      try{
        var d=await supa.rpc('anuncio_cancelar_oferta',{ p_id:String(a.id) });
        if(d&&d.error) throw d.error;
        toast('Oferta retirada.'); await apCarregar(); apAbrir(a.id);
      }catch(_){ bt.disabled=false; toast('Não consegui agora.'); }
    };
  }

  function _apVoltar(){
    telaRepassePortal().then(function(){
      try{ var b=document.querySelector('#repTgl .hh-tg[data-rv="particular"]'); if(b) b.click(); }catch(_){}
    });
  }

  /* ------------------------------------------------------------ fazer a oferta */
  function apOfertaAbrir(a){
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='💸'; $('cliMt').textContent='Sua oferta';
    var atual=(a.minha_oferta && a.minha_oferta.valor) ? String(Math.round(Number(a.minha_oferta.valor)||0)) : '';
    $('cliMbody').innerHTML=
      '<div class="of-veic"><b>'+esc(_apNome(a))+'</b> · '+esc(a.placa||'')+
      '<br><small>carro de particular'+([a.cidade,a.uf].filter(Boolean).length?(' · '+esc([a.cidade,a.uf].filter(Boolean).join('/'))):'')+'</small></div>'+
      '<label class="cad-lbl">Quanto você paga (R$)</label>'+
      '<input class="cad-in" id="apValor" inputmode="numeric" placeholder="R$ 0" value="'+esc(atual)+'">'+
      '<label class="cad-lbl">Recado pro dono (opcional)</label>'+
      '<textarea class="cad-in" id="apMsg" rows="3" maxlength="240" placeholder="Ex.: pago à vista, retiro em Torres, faço a transferência">'+
        esc((a.minha_oferta&&a.minha_oferta.mensagem)||'')+'</textarea>'+
      '<div class="ap-nota">O dono vê o nome da sua loja e o valor. As outras lojas não veem nada da sua oferta.</div>'+
      '<button type="button" class="cad-btn" id="apEnviar" style="margin-top:10px">Enviar oferta</button>';
    var vv=$('apValor'); if(vv && typeof avMaskRS==='function') vv.oninput=avMaskRS;
    var bt=$('apEnviar'); if(bt) bt.onclick=function(){ apOfertaEnviar(a); };
  }

  async function apOfertaEnviar(a){
    var valor=parseInt(String((($('apValor')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
    var msg=String((($('apMsg')||{}).value)||'').trim();
    if(!valor){ toast('Digite o valor da sua oferta.'); return; }
    var bt=$('apEnviar'); if(bt){ bt.disabled=true; bt.textContent='Enviando…'; }
    try{
      /* ===== v313 — A OFERTA PASSA PELO SERVIDOR ==========================
         Antes ela ia daqui DIRETO pro banco. Funcionava, mas o servidor nunca
         ficava sabendo — e sem passar por ele não dá pra avisar o dono no
         WhatsApp, que é justamente quem não tem app nem conta pra ver.

         A permissão não mudou: o servidor grava usando o MEU token, chamando
         a mesma função do banco. Quem não podia ofertar continua não podendo.

         Se a rede falhar no meio, o velho caminho ainda responde — por isso o
         segundo try. Perde-se o aviso, não a oferta. */
      var d=null;
      try{
        var api1=await api('/api/anuncio',{ acao:'ofertar', anuncio_id:String(a.id), valor:valor, mensagem:msg });
        if(api1 && api1.ok) d={ ok:true, id:api1.id };
        else if(api1 && api1.erro) d={ ok:false, erro:api1.erro };
      }catch(_){ d=null; }
      if(!d){
        var r=await supa.rpc('anuncio_ofertar',{ p_id:String(a.id), p_valor:valor, p_msg:msg });
        if(r&&r.error) throw r.error;
        d=(r&&r.data)||{};
      }
      if(d.ok===false){ if(bt){ bt.disabled=false; bt.textContent='Enviar oferta'; } toast(d.erro||'Não consegui enviar.'); return; }
      toast('Oferta enviada ✓');
      cliModalFechar();
      await apCarregar();
      apAbrir(a.id);
    }catch(e){
      if(bt){ bt.disabled=false; bt.textContent='Enviar oferta'; }
      toast('Não consegui enviar. '+((e&&e.message)||''));
    }
  }

/* ╔═══ src/app/09c-plano-repasse.js ══════════════════════════════════════ */
  /* ========= v452 — PUBLICAR NA REDE DE REPASSE É DO PLANO LOJISTA =========
     Até aqui o Vendedor (R$ 199) e o Lojista (R$ 299) davam exatamente o
     mesmo acesso à Rede de Repasse, e a única diferença entre os dois planos
     era a quantidade de token. Token é consumo: ninguém sobe de plano por
     token, só recarrega. Na prática o plano de R$ 299 não tinha o que vender,
     e o lojista de verdade ficava no de baixo usufruindo de tudo.

     A divisão agora é entre VER e PUBLICAR:
       · Vendedor      → entra na rede, vê os carros e faz ofertas.
       · Lojista / Max → publica os carros dele na rede.

     Por que não fechar a rede inteira pro Vendedor: rede vazia não vale nada.
     Cada vendedor que entra é mais um comprador olhando o carro de quem paga
     R$ 299 — ele AUMENTA o valor da rede em vez de diluir. E o lojista que
     tentar economizar ficando no plano de baixo descobre sozinho que não
     consegue anunciar, que é justamente o que ele quer fazer: sobe por
     vontade própria, sem ninguém precisar fiscalizar.

     ⚠️ ISTO É UMA TRAVA DE TELA, NÃO DE COFRE. Vale pro uso normal do app.
     A porta do banco (RLS do mp_repasse) continua aberta pra quem souber
     mexer no "inspecionar" do navegador. Se um dia isso incomodar, é uma
     regra no Supabase — e ela vai precisar liberar o admin à mão, porque a
     ficha do Angelo tem plano "essencial".

     ⚠️ E NÃO DÁ PRA USAR `_portalMembro.ativo` COMO LIBERAÇÃO. Parece a
     escolha óbvia ("quem o Angelo aprovou continua publicando"), mas o
     cobranca.js grava `ativo:true` nessa mesma linha a cada pagamento
     confirmado — QUALQUER plano. Usar esse campo aqui deixaria todo Vendedor
     pagante passar, e a trava nunca fecharia. */
  var REPASSE_PUBLICA = { unico300:1, profissional:1, max:1, admin:1 };
  var REPASSE_TRAVA_TX = 'Publicar carro na rede é do plano Lojista. No seu plano você vê a rede e faz ofertas.';

  function planoAtualId(){
    try{
      var p = (typeof pagPlanoDaAssinatura==='function') ? pagPlanoDaAssinatura() : null;
      return p ? String(p.id||'') : '';
    }catch(_){ return ''; }
  }
  function podeAnunciarRepasse(){
    if(typeof _ehAdmin==='function' && _ehAdmin()) return true;
    return !!REPASSE_PUBLICA[planoAtualId()];
  }
  /* A tela da Avaliação abre antes de o /api/cobranca ter respondido, e nesse
     instante `pagPlanoDaAssinatura()` devolve null — ou seja, um Lojista que
     paga veria a trava. Por isso quem pergunta espera a resposta.
     Se a resposta NÃO vier (internet ruim, servidor fora), libera: travar
     cliente pagante por causa de um tropeço de rede é pior que deixar passar
     um anúncio a mais. */
  async function podeAnunciarRepasseAsync(){
    if(typeof _ehAdmin==='function' && _ehAdmin()) return true;
    if(typeof _assinatura==='undefined' || !_assinatura){
      if(typeof assinaturaCarregar==='function'){ try{ await assinaturaCarregar(); }catch(_){} }
    }
    if(typeof _assinatura==='undefined' || !_assinatura) return true;   /* não consegui saber → não trava */
    return podeAnunciarRepasse();
  }
  /* O aviso que substitui o interruptor. Sem CSS novo: é a mesma caixa
     `.rep-pub` do interruptor, então ele nasce alinhado com o resto da aba. */
  function repassePlanoTravaHtml(idCaixa, idBotao){
    return '<div class="rep-pub" id="'+idCaixa+'" style="display:none;cursor:default">'+
        '<span class="rep-pub-tx"><b>Publicar na Rede de Repasse</b><small>'+REPASSE_TRAVA_TX+'</small></span>'+
        '<button type="button" class="link" id="'+idBotao+'" style="margin-top:0;flex:none;color:#0a4da6">Ver planos</button>'+
      '</div>';
  }
  function repassePlanoTravaLigar(idBotao){
    var b=$(idBotao); if(!b) return;
    b.onclick=function(){ if(typeof telaInfo==='function') telaInfo('pagamentos'); };
  }

  /* ============ v452 — TETO DE VEÍCULOS DO PLANO (pedido) ============
     O Vendedor passou a caber ATÉ 20 veículos no estoque. É TETO, não
     contador mensal: vendeu um, abre uma vaga. Contador que zera todo dia 1º
     precisaria guardar quantos entraram em cada mês, e "cabem 20 no pátio" é
     mais fácil de explicar pro lojista do que "você já usou 20 este mês".

     🔴 O NÚMERO PRECISA SER VERDADE. Até a v451 o campo `veiculos` era só
     texto no card — nada no app impedia ninguém de cadastrar 200. Card que
     promete uma regra que o app não cumpre não gera upgrade, gera
     reclamação do primeiro lojista que contar. Por isso este freio existe.

     Vendido não conta (é o mesmo critério que a régua de "veículos ativos"
     da tela de Uso e faturamento já usava). */
  function planoLimiteVeiculos(){
    if(typeof _ehAdmin==='function' && _ehAdmin()) return null;
    var p=null; try{ p=(typeof pagPlanoDaAssinatura==='function')?pagPlanoDaAssinatura():null; }catch(_){}
    if(!p) return null;                       /* não sei o plano → não travo */
    /* 🔴 v504 — ZERO NÃO É "SEM LIMITE". Isto aqui era
           return (p.veiculos==null) ? null : (Number(p.veiculos)||null);
       e o `||null` transformava o 0 em null, ou seja, em ilimitado — a
       armadilha clássica do zero falso em JavaScript. Com o plano Parceiro
       (veiculos:0) isso daria estoque LIVRE justamente pra quem paga o
       plano mais barato, que é o oposto do que o card promete.
       Agora só `null` é sem limite; qualquer número, inclusive 0, é teto. */
    if(p.veiculos==null) return null;
    var n=Number(p.veiculos);
    return isFinite(n) ? n : null;
  }
  function estoqueAtivosConta(){
    try{
      return (_estoque||[]).filter(function(v){
        return String((v&&v.status)||'disponivel').toLowerCase()!=='vendido';
      }).length;
    }catch(_){ return 0; }
  }
  function cabeMaisVeiculo(){
    var lim=planoLimiteVeiculos();
    return (lim==null) || (estoqueAtivosConta() < lim);
  }
  /* Aviso do teto. Uso `confirm` de propósito, e não `toast`: o toast some em
     2 segundos e aqui a pessoa acabou de tocar em "Novo veículo" e não vai
     entender por que nada abriu. O mesmo padrão do "Marcar como vendido". */
  function avisarTetoVeiculos(){
    var lim=Number(planoLimiteVeiculos())||0;
    /* ⚠️ v504 — DUAS CONVERSAS DIFERENTES, não uma.
       Teto CHEIO (Vendedor com 20 carros) é "faz espaço ou sobe".
       Teto ZERO (Parceiro) não é limite atingido — é uma função que o plano
       dele não tem. Dizer "cabe até 0 veículos e você já tem 0" pareceria
       defeito do app. Aqui ele precisa ouvir o que o plano dele É: a
       vitrine com os carros das lojas — e o que ele ganha subindo. */
    var msg = (lim===0)
      ? ('No Vendedor Parceiro você anuncia na SUA vitrine os carros das lojas que te convidaram — sem cadastrar estoque próprio.\n\n'+
         'Pra cadastrar o seu próprio carro, o plano é o Vendedor (R$ 199): até 20 veículos seus, além de tudo que você já tem hoje.\n\n'+
         'Quer ver os planos?')
      : ('Seu plano cabe até '+lim+' veículos no estoque, e você já tem '+estoqueAtivosConta()+'.\n\n'+
         'Marque um como vendido (vendido não conta) ou suba pro plano Lojista, que é sem limite.\n\n'+
         'Quer ver os planos?');
    try{ if(confirm(msg) && typeof telaInfo==='function') telaInfo('pagamentos'); }catch(_){}
  }

/* ╔═══ src/app/10-parceiros.js ═══════════════════════════════════════════ */
  /* ================= PARCEIROS / PATROCINADORES ================= */
  var ANGELO_ID='1b0ce2c8-9597-4340-8fa0-daf1dcfe0bc8';
  function _ehAdmin(){ return String(meuId||'')===ANGELO_ID; }
  var _parceiros=[], _parLogoUrl='';
  function _parIni(n){ return String(n||'?').trim().charAt(0).toUpperCase(); }
  function _url(u){ u=String(u||'').trim(); if(!u) return ''; if(!/^https?:\/\//i.test(u)) u='https://'+u; return u; }
  /* ===== v285 — O PACOTE PARCEIRO DE R$ 99,90 ACABOU =====
     Existiam TRÊS preços vivos no app ao mesmo tempo: os planos (Essencial,
     Profissional, Max), este pacote de R$ 99,90 e os pacotes de token. Um
     lojista via R$ 99,90 numa tela e R$ 149,90 em outra pela mesma coisa.

     Agora o Portal do Repasse faz parte de QUALQUER plano — é isso que a
     frase "toda a estrutura do MEV" dos cards sempre prometeu. Sobrou aqui só
     o WhatsApp do suporte, que não tem nada a ver com preço. */
  var MEV_SUPORTE = {
    whats: '5551996417433'     /* WhatsApp do suporte MEV (55 + DDD + número, só dígitos) */
  };
  var ICO_PORTAL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';
  /* ===== (v173) A PROPRIA PESSOA vira Parceiro =====
     A ficha e' dela (user_id). Quem manda no "aparece ou nao" e' o banco:
     um gatilho no Supabase liga o destaque enquanto a assinatura esta' paga
     e desliga sozinho quando ela vence. Ninguem se promove pelo aplicativo. */
  var _meuPar=null, _meuParCarregado=false;
  async function meuParceiroCarregar(){
    if(!meuId) return null;
    try{ var r=await withTimeout(supa.from('parceiros').select('*').eq('user_id',meuId).limit(1),8000); _meuPar=((r&&r.data)||[])[0]||null; }catch(_){ _meuPar=null; }
    _meuParCarregado=true; return _meuPar;
  }
  function meuParceiroPinta(){
    var el=$('parEu'); if(!el) return;
    if(!meuId){ el.innerHTML=''; return; }
    if(!_meuParCarregado){ el.innerHTML=skelHtml(1); return; }
    var p=_meuPar;
    var ico=p&&p.logo_url ? '<img loading="lazy" decoding="async" src="'+esc(imgCdn(p.logo_url,200))+'" style="width:100%;height:100%;object-fit:cover;border-radius:12px">'
                          : _cIco('<path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 21v-6h6v6"/>');
    var st = !p ? ''
      : (p.ativo ? '<span class="par-eu-st on">'+_cIco('<polyline points="20 6 9 17 4 12"/>')+' No ar — sua loja aparece na lista</span>'
                 : '<span class="par-eu-st off">'+_cIco('<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>')+' Salvo, mas fora do ar — a assinatura precisa estar em dia</span>');
    el.innerHTML='<div class="par-eu">'+
      '<div class="par-eu-h"><span class="par-eu-ic">'+ico+'</span><span><b>'+esc(p?(p.nome||'Minha página de Patrocinador'):'Minha página de Patrocinador')+'</b>'+
        '<small>'+(p?'Logo, descricao, WhatsApp e os seus veiculos':'Monte sua ficha: logo, descricao, WhatsApp e os seus veiculos')+'</small></span></div>'+
      st+
      '<div class="par-eu-bt"><button type="button" class="cad-btn'+(p?' sec':'')+'" id="parEuEd">'+(p?'Editar minha pagina':'Criar minha pagina')+'</button>'+
        (p&&p.catalogo_url?('<button type="button" class="cad-btn sec" id="parEuVer">Ver meus veiculos</button>'):'')+'</div>'+
      '</div>';
    var b=$('parEuEd'); if(b) b.onclick=function(){ meuParceiroFicha(); };
    var v=$('parEuVer'); if(v) v.onclick=function(){ var u=_url(_meuPar.catalogo_url); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } };
  }
  function meuParceiroFicha(){
    var p=_meuPar||{}; _parLogoUrl='';
    var catPadrao = p.catalogo_url || (meuId?(location.origin+'/catalogo/'+meuId):'');
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='🤝'; $('cliMt').textContent='Minha página de Patrocinador';
    function I(id,lb,val,ph){ return '<label class="cad-lbl">'+lb+'</label><input class="cad-in" id="'+id+'" value="'+esc(val==null?'':val)+'" placeholder="'+esc(ph||'')+'">'; }
    var tipoSel='<label class="cad-lbl">Tipo</label><select class="cad-in" id="mpTipo">'+['Loja','Repasse','Consultor'].map(function(t){ return '<option'+((p.tipo||'Loja')===t?' selected':'')+'>'+t+'</option>'; }).join('')+'</select>';
    $('cliMbody').innerHTML=
      '<div class="doc-hint">Sua ficha aparece na lista de Patrocinadores <b>enquanto a assinatura estiver em dia</b>. O link dos seus veiculos ja\' vem preenchido: e\' o seu catalogo, que se atualiza sozinho conforme voce mexe no estoque.</div>'+
      '<div class="lj-logo-wrap"><div class="lj-logo" id="mpLogoBox">'+(p.logo_url?'<img loading="lazy" decoding="async" src="'+esc(imgCdn(p.logo_url,200))+'">':'<span>logo</span>')+'</div><button type="button" class="cad-btn sec" id="mpLogoBtn" style="flex:1;margin:0">'+(p.logo_url?'Trocar logo/foto':'Adicionar logo/foto')+'</button><input type="file" id="mpLogoInput" accept="image/*" style="display:none"></div>'+
      I('mpNome','Nome da loja / do consultor',p.nome,'Como voce quer aparecer')+tipoSel+
      I('mpWa','WhatsApp',p.whatsapp,'(00) 00000-0000')+
      I('mpCat','Meus veiculos (link do catalogo)',catPadrao,'link do catalogo')+
      I('mpSite','Site',p.site,'www.site.com.br')+
      I('mpCnpj','CNPJ',p.cnpj,'00.000.000/0000-00')+
      '<label class="cad-lbl">Descricao</label><textarea class="cad-in" id="mpDesc" rows="2" placeholder="Uma linha sobre voce ou sobre a loja">'+esc(p.descricao||'')+'</textarea>'+
      '<button class="cad-btn" id="mpSalvar" style="margin-top:12px">Salvar minha pagina</button><div class="cad-msg" id="mpMsg"></div>'+
      (p.id?'<button class="cad-btn sair" id="mpDel" style="margin-top:8px">Tirar minha pagina do ar</button>':'');
    $('mpLogoBtn').onclick=function(){ $('mpLogoInput').click(); };
    $('mpLogoInput').onchange=function(){ var f=this.files&&this.files[0]; this.value=''; if(!f) return;
      fotoCropAbrir(f, function(bl){ if(bl) meuParLogoUp(bl); }, {ar:1, out:512, redondo:false, blob:true, titulo:'Ajustar a logo', sub:'Arraste pra posicionar · use a barra pra dar zoom'});
    };
    var wa=$('mpWa'); if(wa){ if(wa.value) wa.value=foneFmt(wa.value); wa.addEventListener('input',function(){ this.value=foneFmt(this.value); }); }
    $('mpSalvar').onclick=meuParceiroSalvar;
    var d=$('mpDel'); if(d) d.onclick=meuParceiroApagar;
  }
  async function meuParLogoUp(file){ if(!file) return; toast('Enviando imagem...'); try{ var url=await avUpload(file); if(url){ _parLogoUrl=url; var box=$('mpLogoBox'); if(box) box.innerHTML='<img loading="lazy" decoding="async" src="'+esc(imgCdn(url,800))+'">'; toast('Imagem pronta.'); } }catch(e){ toast('Falha ao enviar.'); } }
  async function meuParceiroSalvar(){
    var m=$('mpMsg'); if(m) m.className='cad-msg';
    function g(x){ var e=$(x); return e?(e.value||'').trim():''; }
    var nome=g('mpNome'); if(!nome){ if(m){ m.className='cad-msg err'; m.textContent='Diga o nome que vai aparecer.'; } return; }
    var reg={ user_id:meuId, nome:nome, tipo:g('mpTipo'), whatsapp:g('mpWa'), catalogo_url:g('mpCat'), site:g('mpSite'), cnpj:g('mpCnpj'), descricao:g('mpDesc') };
    if(_parLogoUrl) reg.logo_url=_parLogoUrl;
    var btn=$('mpSalvar'); if(btn){ btn.disabled=true; btn.textContent='Salvando...'; }
    try{
      if(_meuPar&&_meuPar.id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('parceiros').update(reg).eq('id',_meuPar.id); if(r&&r.error) throw r.error; }
      else { var r2=await supa.from('parceiros').insert(reg); if(r2&&r2.error) throw r2.error; }
      cliModalFechar(); await meuParceiroCarregar(); meuParceiroPinta(); await parCarregar(); parPinta();
      toast(_meuPar&&_meuPar.ativo?'Pagina salva e no ar.':'Pagina salva.');
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Nao consegui salvar. '+((e&&e.message)||''); } if(btn){ btn.disabled=false; btn.textContent='Salvar minha pagina'; } }
  }
  async function meuParceiroApagar(){
    if(!_meuPar||!_meuPar.id) return;
    if(!confirm('Tirar sua página de Patrocinador do ar? Dá pra criar de novo depois.')) return;
    try{ var r=await supa.from('parceiros').delete().eq('id',_meuPar.id); if(r&&r.error) throw r.error;
      cliModalFechar(); _meuPar=null; meuParceiroPinta(); await parCarregar(); parPinta(); toast('Pagina retirada.');
    }catch(e){ toast('Nao consegui tirar.'); }
  }
  /* ===== v432 — "PARCEIROS" VIROU DUAS PÁGINAS ==========================
     Rede Lojistas Repasses (lojista comprando de lojista, preço de atacado)
     e Rede Lojistas Seminovos (a vitrine de varejo das lojas). São dois
     produtos com dois compradores diferentes, e viviam escondidos atrás de
     uma aba que muita gente não clicava.

     ⚠️ REGRA DE OURO: o código NÃO foi duplicado. As duas páginas usam o
     MESMO motor (parHubPinta, _parHubVeicCardHtml, _parLojaCardHtml, os
     filtros). O que muda é o valor de _parHubView — que já existia. Copiar
     o arquivo criaria dois lugares pra corrigir todo bug.

     ⚠️ telaParceiros CONTINUA SENDO A PÁGINA DE REPASSES DE VERDADE (não é
     um apelido que chama outra). Motivo: o 10b-chat-lojistas.js REESCREVE
     `telaParceiros` no carregamento pra pendurar o card "Conversas entre
     lojas". Quem entra pelo menu passa por telaRedeRepasses(), que chama
     telaParceiros() — o nome é resolvido na HORA da chamada, então cai na
     versão embrulhada e o card aparece. Se fosse o contrário (telaParceiros
     chamando telaRedeRepasses), o embrulho nunca rodaria e o card sumiria.
     ==================================================================== */
  var REDE={
    repasse:    { titulo:'Rede Lojistas Repasses',
                  intro:'Veículos que outros lojistas estão repassando — preço de lojista, faça sua oferta.',
                  outra:'marketplace', outraLabel:'Ver a Rede de Seminovos' },
    marketplace:{ titulo:'Rede Lojistas Seminovos',
                  intro:'Os catálogos de venda das lojas parceiras — carros prontos pra repassar pro seu cliente.',
                  outra:'repasse',     outraLabel:'Ver a Rede de Repasses' }
  };
  function telaRedeRepasses(){ return telaParceiros(); }        /* v432 — passa pelo embrulho do chat */
  function telaRedeSeminovos(){ return _redeTela('marketplace'); }
  async function telaParceiros(){ return _redeTela('repasse'); }
  async function _redeTela(view){
    var R=REDE[view]||REDE.repasse;
    mevTabSet('');
    _parHubView=(view==='marketplace')?'marketplace':'repasse';
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg par-hub-pg"><h2>'+esc(R.titulo)+'</h2>'+
      '<p class="par-hub-intro">'+esc(R.intro)+'</p>'+
      '<div class="par-hub-tools">'+
        '<label class="par-hub-field par-hub-search" for="parHubBusca"><span>Buscar</span><span class="cli-search">'+_icoBusca+'<input id="parHubBusca" type="search" placeholder="Loja, cidade ou veículo" autocomplete="off"></span></label>'+
        '<label class="par-hub-field" for="parHubCidade"><span>Filtrar por cidade</span><select id="parHubCidade"><option value="">Todas as cidades</option></select></label>'+
        '<label class="par-hub-field" for="parHubOrdem"><span>Ordenar</span><select id="parHubOrdem"><option value="destaque">Mais recentes</option><option value="veiculos">Mais veículos</option><option value="nome">Nome da loja</option></select></label>'+
      '</div>'+
      /* v312 (pedido): "remova esse texto da pagina do portal do repasse".
         Saíram a linha "Lojas com repasses · N veículos" e, mais abaixo, a
         "Lojistas parceiros · Deslize pra ver todas" (esta no _faixaLojas).
         Com os cards de loja em grade de largura cheia, não há mais o que
         deslizar, e os dois rótulos só ocupavam altura antes dos cards. */
      '<div id="parHubLista">'+skelHtml(4)+'</div>'+
      /* v432: as duas abas saíram. No lugar, um link discreto no rodapé —
         quem está olhando repasse às vezes quer espiar o seminovo, e sem
         isto teria que voltar no menu. */
      '<button type="button" class="rede-troca" id="redeTroca" data-rede="'+esc(R.outra)+'">'+ICO_REPMINI+esc(R.outraLabel)+'</button>'+
    '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    if(_ehAdmin()) mevCtx('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>','Novo', function(){ parceiroFicha(null); });
    await parCarregar();
    parHubLigar();
    await parHubCarregar();
  }
  var ICO_LOJINHA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M5 13v7h14v-7"/></svg>';
  var ICO_CARTAO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8" cy="11" r="2"/><path d="M4.8 16.2a3.4 3.4 0 0 1 6.4 0"/><line x1="14" y1="10" x2="19" y2="10"/><line x1="14" y1="14" x2="18" y2="14"/></svg>';
  var ICO_WAMINI='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-12.3 7.5L3 21l2.1-5.5A8.4 8.4 0 1 1 21 11.5z"/></svg>';
  var ICO_COPIAR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';
  var ICO_COMPARTILHAR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="10.6" x2="15.4" y2="6.4"/><line x1="8.6" y1="13.4" x2="15.4" y2="17.6"/></svg>';
  /* Lojas assinantes e a vitrine institucional da administração. A Santa Luzia
     tem um catálogo já público e não pode sumir do marketplace só por não ter
     uma linha de assinatura do portal. */
  async function membrosAtivosCarregar(){
    try{ var r=await withTimeout(supa.from('portal_membro').select('loja_nome,cidade,uf,whatsapp,user_id,atualizado_em').eq('ativo',true).order('atualizado_em',{ascending:false}).limit(100),8000); _membrosAtivos=(r&&r.data)||[]; }catch(_){ _membrosAtivos=[]; }
    if(!_membrosAtivos.some(function(m){ return String(m&&m.user_id||'')===String(ANGELO_ID); })){
      _membrosAtivos.unshift({user_id:ANGELO_ID,loja_nome:'',cidade:'',uf:'',whatsapp:'',atualizado_em:'',catalogo_admin:true});
    }
  }
  /* v190: cache do cartao digital de cada assinante (logo, capa e nº de carros) */
  var _membrosCat={};
  async function membrosCatCarregar(){
    await _precosMinCarregar();   /* v330: preco de lojista junto com os catalogos */
    var alvo=_membrosAtivos.filter(function(m){ return m && m.user_id; }).slice(0,24);
    await Promise.all(alvo.map(async function(m){
      var k=String(m.user_id); if(_membrosCat[k]) return;
      try{
        var r=await withTimeout(supa.rpc('get_catalogo',{p_uid:m.user_id}),9000);
        var d=(r&&r.data)||null; if(!d) return;
        var lj=d.loja||{}, vs=(d.veiculos||[]).filter(function(v){ return v && String(v.status||'disponivel').toLowerCase()!=='vendido'; });
        var capa=''; for(var i=0;i<vs.length && !capa;i++){ var f=(vs[i]&&vs[i].fotos)||[]; if(f&&f[0]) capa=f[0]; }
        _membrosCat[k]={ pronto:true, logo:lj.logo||'', nome:lj.nome||'', cidade:lj.cidade||'', uf:lj.uf||'', whatsapp:lj.whatsapp||'', cor:lj.cor||'', insta:String(lj.instagram||lj.insta_user||'').replace(/^@/,''), n:vs.length, capa:capa, veiculos:vs.slice(0,30) };
      }catch(_){}
    }));
  }
  function _mbrCatUrl(uid){ return location.origin+'/catalogo/'+encodeURIComponent(String(uid||'')); }
  /* ================= v205 — PARCEIROS COMO HUB DE VITRINES =================
     Repasses e seminovos usam os mesmos dados e links públicos que já existiam.
     A página apenas organiza por loja, sem criar um segundo cadastro. */
  var _parHubView='repasse', _parHubRepasses=[], _parHubErro=false;
  function _parHubRepUrl(uid){ return location.origin+'/repasses/'+encodeURIComponent(String(uid||'')); }
  function _parHubData(s){ var n=Date.parse(String(s||'')); return isFinite(n)?n:0; }
  function _parHubNomeVeiculo(v){
    v=v||{}; return (((v.marca||'')+' '+(v.modelo||'')).trim()||v.nome||'Veículo');
  }
  function _parHubRepLojas(){
    var mapa={};
    _parHubRepasses.forEach(function(x,ordem){
      var uid=String(x.user_id||'').trim();
      var chave=uid||('loja:'+String(x.loja_nome||'').toLowerCase());
      if(!chave) return;
      var cat=_membrosCat[uid]||{};
      if(!mapa[chave]) mapa[chave]={
        uid:uid, nome:x.loja_nome||cat.nome||'Loja parceira', cidade:x.cidade||'', uf:x.uf||'',
        whatsapp:x.loja_whatsapp||'', logo:cat.logo||'', tipo:'repasse',
        url:uid?_parHubRepUrl(uid):'', veiculos:[], ordem:ordem, recente:0
      };
      var v=x.veiculo||{};
      /* v308 (pedido) — O PREÇO DE REPASSE SAIU DAQUI.
         Este marketplace mostrava o preço de repasse dos carros das OUTRAS
         lojas — o mesmo número que o Portal do Repasse esconde de propósito
         atrás de "Faça sua oferta". Eram duas telas do mesmo app dizendo
         coisas opostas sobre o mesmo dado.
         Agora o preço nem chega até aqui: a lista vem da porta estreita do
         banco (repasse_rede), que só entrega valor pro dono do carro. O que
         não sai do banco não vaza por descuido de tela nenhuma. */
      /* v411 (pedido): o card do repasse mostra ano fab/modelo, FIPE e a
         situação (Em negociação / No estoque) — esses campos passam adiante.
         O PREÇO continua NÃO passando (v308): FIPE é tabela pública, preço
         de repasse é segredo do dono. */
      mapa[chave].veiculos.push({
        nome:_parHubNomeVeiculo(v), fotos:Array.isArray(x.fotos)?x.fotos:[],
        repasse:true, ano:v.ano||v.ano_modelo||'', ano_modelo:v.ano_modelo||v.ano||'',
        km:Number(v.km)||0, cor:v.cor||'',
        fipe:Number(v.fipe)||0, situacao:String(x.situacao||'')
      });
      mapa[chave].recente=Math.max(mapa[chave].recente,_parHubData(x.atualizado_em||x.criado_em));
    });
    return Object.keys(mapa).map(function(k){ return mapa[k]; });
  }
  function _parHubMarketLojas(){
    var lista=[], vistos={}, nomes={};
    _membrosAtivos.forEach(function(m,ordem){
      var uid=String(m.user_id||'').trim(); if(!uid||vistos[uid]) return;
      var c=_membrosCat[uid]||{};
      /* O cadastro sintético só é exibido depois que o RPC público confirmou
         o catálogo. Assim não aparece um card vazio se a loja for retirada. */
      if(m.catalogo_admin&&!c.pronto) return;
      var nome=c.nome||m.loja_nome||'Loja parceira';
      vistos[uid]=true;
      nomes[String(nome).toLowerCase()]=true;
      lista.push({
        uid:uid, nome:nome, cidade:c.cidade||m.cidade||'', uf:c.uf||m.uf||'', whatsapp:c.whatsapp||m.whatsapp||'',
        logo:c.logo||'', tipo:'marketplace', url:_mbrCatUrl(uid),
        veiculos:Array.isArray(c.veiculos)?c.veiculos:[], ordem:ordem,
        recente:_parHubData(m.atualizado_em)
      });
    });
    /* Parceiros cadastrados manualmente continuam aparecendo, mesmo quando o
       catálogo é externo e não permite carregar as fotos dentro do app. */
    (_parceiros||[]).forEach(function(p,ordem){
      if(!p||!p.ativo||!p.catalogo_url) return;
      var nome=String(p.nome||'Loja parceira'), nk=nome.toLowerCase();
      if(nomes[nk]) return;
      nomes[nk]=true;
      lista.push({
        uid:String(p.user_id||''), nome:nome, cidade:'', uf:'', whatsapp:p.whatsapp||'',
        logo:p.logo_url||'', tipo:'marketplace', url:_url(p.catalogo_url),
        veiculos:[], ordem:1000+ordem, recente:_parHubData(p.atualizado_em||p.criado_em)
      });
    });
    return lista;
  }
  function _parHubBase(){ return _parHubView==='marketplace'?_parHubMarketLojas():_parHubRepLojas(); }
  function _parHubCidadesPinta(){
    var s=$('parHubCidade'); if(!s) return;
    var atual=s.value||'', mapa={};
    _parHubBase().forEach(function(l){ var c=String(l.cidade||'').trim(); if(c) mapa[c.toLowerCase()]=c; });
    var cidades=Object.keys(mapa).map(function(k){return mapa[k];}).sort(function(a,b){return a.localeCompare(b,'pt-BR');});
    s.innerHTML='<option value="">Todas as cidades</option>'+cidades.map(function(c){ return '<option value="'+esc(c.toLowerCase())+'">'+esc(c)+'</option>'; }).join('');
    if(cidades.some(function(c){return c.toLowerCase()===atual;})) s.value=atual;
  }
  function _parHubSlideHtml(v,i){
    var fotos=Array.isArray(v.fotos)?v.fotos:[], foto=fotos[0]||'';
    if(!foto) return '';
    var meta=[]; if(v.ano) meta.push(String(v.ano)); if(v.km) meta.push(Number(v.km).toLocaleString('pt-BR')+' km');
    return '<div class="par-store-slide">'+
      '<img '+(i?'loading="lazy" ':'')+'src="'+esc(_url(foto))+'" alt="'+esc(v.nome||'Veículo da loja')+'">'+
      '<span class="par-store-overlay"><b>'+esc(v.nome||'Veículo')+'</b>'+
        (meta.length?('<small>'+esc(meta.join(' · '))+'</small>'):'')+
        /* v308: carro de repasse não tem preço na tela — tem convite. */
        (v.repasse ? '<strong class="par-oferta">Faça sua oferta</strong>'
                   : (v.preco?('<strong>'+_repDinheiro(v.preco)+'</strong>'):''))+
      '</span></div>';
  }
  /* ===== v264 — O CARD DO LOJISTA PARCEIRO (pedido) ==========================
     Antes cada loja aparecia com uma foto grande de um veículo dela. Isso
     confundia duas coisas: a LOJA e o CARRO. Dava a impressão de que aquele
     card era um anúncio daquele carro, e a mesma loja se repetia embaixo, na
     faixa dos veículos.

     Agora o card do parceiro é só a loja — logo, nome, cidade e os caminhos
     pra chegar nela: WhatsApp, Ver catálogo e Ver repasses. Os veículos ficam
     todos juntos na faixa de baixo, que é onde se procura carro.

     A faixa dos parceiros virou um SLIDE horizontal: cabem várias lojas sem
     empurrar os veículos pra fora da tela.
     ========================================================================= */
  var ICO_WA_PAR='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2m0 2a8 8 0 1 1-4.1 14.9l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 0 1 12 4"/></svg>';
  var ICO_REP_PAR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3h5v5"/><path d="M21 3l-7 7"/><path d="M8 21H3v-5"/><path d="M3 21l7-7"/></svg>';
  function _parLojaCardHtml(l){
    var logo=l.logo?('<img class="par-loja-logo" loading="lazy" src="'+esc(_url(l.logo))+'" alt="">')
                   :('<span class="par-loja-logo ini">'+esc(_parIni(l.nome))+'</span>');
    var local=[l.cidade,l.uf].filter(Boolean).join(' / ');
    var qtd=(l.veiculos||[]).length;
    var uid=String(l.uid||'');
    var urlCat=uid?_mbrCatUrl(uid):(l.tipo==='marketplace'?(l.url||''):'');
    var urlRep=uid?_parHubRepUrl(uid):(l.tipo==='repasse'?(l.url||''):'');
    var wa=String(l.whatsapp||'').replace(/\D/g,'');
    var botoes='';
    if(wa) botoes+='<button type="button" class="pl-bt wa" data-pl-wa="'+esc(wa)+'" data-pl-nome="'+esc(l.nome)+'">'+ICO_WA_PAR+'<span>WhatsApp</span></button>';
    if(urlCat) botoes+='<button type="button" class="pl-bt" data-pl-uid="'+esc(uid)+'" data-pl-abrir="'+esc(urlCat)+'" data-pl-tit="Catálogo — '+esc(l.nome)+'">'+ICO_LOJINHA+'<span>Ver catálogo</span></button>';
    if(urlRep) botoes+='<button type="button" class="pl-bt" data-pl-uid="'+esc(uid)+'" data-pl-abrir="'+esc(urlRep)+'" data-pl-tit="Repasses — '+esc(l.nome)+'">'+ICO_REP_PAR+'<span>Ver repasses</span></button>';
    if(!botoes) botoes='<span class="pl-vazio">Sem vitrine publicada ainda</span>';
    return '<article class="par-loja-card" data-ph-busca="'+esc([l.nome,l.cidade,l.uf].join(' ').toLowerCase())+'">'+
      '<div class="par-loja-topo">'+logo+
        '<span class="par-loja-tx"><b>'+esc(l.nome)+'</b><small>'+esc(local||'Loja parceira')+'</small></span>'+
      '</div>'+
      /* v432: a contagem dizia "no repasse" nas DUAS redes. Agora que
         Seminovos é uma página com nome próprio, "3 veículos no repasse"
         dentro dela é informação errada na cara do lojista. */
      (qtd?('<div class="par-loja-qtd">'+qtd+' veículo'+(qtd===1?'':'s')+(_parHubView==='marketplace'?' no catálogo':' no repasse')+'</div>'):'')+
      '<div class="par-loja-bts">'+botoes+'</div>'+
    '</article>';
  }
  /* liga os botões dos cards de loja. Abrir é SEMPRE dentro do app (visor), pra
     que fechar volte exatamente pra esta página de parceiros — antes o catálogo
     abria numa aba nova do navegador e voltar era um caminho de ida e volta
     pelo sistema, não pelo app. */
  function _parLojaWire(el){
    Array.prototype.forEach.call(el.querySelectorAll('[data-pl-abrir]'),function(b){
      b.onclick=function(e){
        e.stopPropagation();
        var url=b.getAttribute('data-pl-abrir'); if(!url) return;
        try{ _preAquece(url); }catch(_){}
        /* v264: se a loja aberta for a SUA, o catálogo já vem com as ações de
           dono liberadas (marcar vendido / excluir), sem precisar ir ao estoque */
        var _dono=!!(meuId && String(b.getAttribute('data-pl-uid')||'')===String(meuId));
        try{ _publicoAbrir(url,{ titulo:b.getAttribute('data-pl-tit')||'Vitrine da loja', voltar:'Voltar à rede', dono:_dono }); }
        catch(_){ try{ window.open(url,'_blank','noopener'); }catch(__){ location.href=url; } }
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-pl-wa]'),function(b){
      b.onclick=function(e){
        e.stopPropagation();
        var n=b.getAttribute('data-pl-wa')||''; if(!n) return;
        if(n.length<=11) n='55'+n;                      /* número sem o país */
        var txt='Olá! Vi a '+(b.getAttribute('data-pl-nome')||'loja')+' no MEV Veículos.';
        var u='https://wa.me/'+n+'?text='+encodeURIComponent(txt);
        try{ window.open(u,'_blank','noopener'); }catch(_){ location.href=u; }
      };
    });
    /* v436: se o /.netlify/images falhar, a foto volta a ser a original.
       Sem onerror inline por causa do CSP — igual ao estStripsWire. */
    Array.prototype.forEach.call(el.querySelectorAll('img[data-orig]'),function(im){
      im.addEventListener('error',function(){
        var o=im.getAttribute('data-orig');
        if(o && im.src.indexOf('/.netlify/images')>=0){ im.removeAttribute('data-orig'); im.src=o; }
      });
    });
    /* v312: a tira de fotos que desliza dentro do card de veículo (data-ph-strip).
       O contador "2/6" acompanha o scroll; e a foto que rola marca o toque como
       "mexeu", pra que um arraste não abra a vitrine por engano. */
    Array.prototype.forEach.call(el.querySelectorAll('[data-ph-strip]'),function(tr){
      var foto=tr.closest('.par-vc-foto');
      var cnt=foto?foto.querySelector('[data-ph-count]'):null;
      var n=tr.children.length;
      tr.addEventListener('scroll',function(){ requestAnimationFrame(function(){
        var ix=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));
        if(cnt) cnt.textContent=(Math.min(n,ix+1))+'/'+n;
      }); },{passive:true});
      var x0=0,y0=0,mexeu=false;
      tr.addEventListener('touchstart',function(e){ if(!e.touches||e.touches.length!==1) return; x0=e.touches[0].clientX; y0=e.touches[0].clientY; mexeu=false; },{passive:true});
      tr.addEventListener('touchmove',function(e){ if(!e.touches||!e.touches.length) return;
        if(Math.abs(e.touches[0].clientX-x0)>8||Math.abs(e.touches[0].clientY-y0)>8) mexeu=true; },{passive:true});
      /* captura (true): intercepta o clique ANTES do handler de abrir a vitrine.
         Se foi arraste, mata o clique ali mesmo. */
      tr.addEventListener('click',function(e){ if(mexeu){ e.preventDefault(); e.stopPropagation(); mexeu=false; } },true);
    });
  }
  /* ===== v303 (pedido) — O CARD DO VEÍCULO NO FORMATO DA PÁGINA DA WEB ====
     "deixe a pagina parceiros no mesmo layout da pagina inicial da web".

     O card que estava aqui foi feito pra LOJA: a foto ocupava tudo e o nome
     e o preço iam ESCRITOS POR CIMA dela, num cantinho. Com nome de carro de
     verdade não cabia — no print do Angelo dava "VW -... R$ 37.000,00".

     Este aqui é o card do site: foto 4:3 em cima, nome embaixo, uma linha
     de dados, o preço grande, a loja, e os dois ícones no canto da foto.

     O QUE ELE MOSTRA É EXATAMENTE O QUE O ANTIGO JÁ MOSTRAVA: nome, ano,
     km, preço e a loja. Nenhum campo novo entrou. Isso importa porque preço
     de repasse é dado de lojista — mudar o formato não pode virar porta pra
     mostrar algo que antes não aparecia.

     Os botões reaproveitam a fiação que já existe: data-pl-wa (WhatsApp da
     loja), data-ph-share (link da vitrine) e data-ph-open (abrir a vitrine
     dentro do app). Nada de caminho novo. */
  /* v330 — preco de LOJISTA no marketplace (area fechada do portal).
     Mapa {estoque_id: preco_minimo} carregado 1x por visita. */
  try{ MP_RPC.precos_lojista = 1; }catch(_){ }
  var _precosMin = null;
  async function _precosMinCarregar(){
    if(_precosMin) return;
    try{ var r = await withTimeout(supa.rpc('precos_lojista'), 9000); _precosMin = (r && r.data) || {}; }
    catch(_){ _precosMin = {}; }
  }
  function _parHubVeicCardHtml(l, v){
    var fotos=Array.isArray(v.fotos)?v.fotos:[], foto=fotos[0]||'';
    /* v436: no REPASSE o nome já vinha montado; no MARKETPLACE os veículos
       chegam crus do get_catalogo (marca/modelo separados) e o card escrevia
       "Veículo" em todos. A mesma função resolve os dois. */
    var nome=_parHubNomeVeiculo(v);
    var local=[l.cidade,l.uf].filter(Boolean).join('/');
    var dados=[]; if(v.ano) dados.push(String(v.ano)); if(v.km) dados.push(Number(v.km).toLocaleString('pt-BR')+' km');
    var wa=String(l.whatsapp||'').replace(/\D/g,'');
    var url=String(l.url||'');
    var ics='';
    if(wa) ics+='<button type="button" class="par-vc-ic wa" data-pl-wa="'+esc(wa)+'" data-pl-nome="'+esc(l.nome)+'" title="Falar no WhatsApp" aria-label="Falar com a '+esc(l.nome)+' no WhatsApp">'+ICO_WA_PAR+'</button>';
    if(url) ics+='<button type="button" class="par-vc-ic sh" data-ph-share="'+esc(url)+'" data-ph-nome="'+esc(l.nome)+'" title="Compartilhar" aria-label="Compartilhar a vitrine da '+esc(l.nome)+'">'+_ICO_SHARE_PAR+'</button>';
    /* ===== v312 (pedido) — AS FOTOS DESLIZAM DENTRO DO CARD ==============
       "no portal do repasse permita o slide das fotos antes de abrir o card".

       Antes o card mostrava SÓ a primeira foto e a etiqueta "3 fotos" — pra
       ver as outras era preciso abrir a vitrine. Agora as fotos formam uma
       tira que desliza com o dedo, e o contador vira "1/3", "2/3"…

       O toque parado continua abrindo a vitrine; ARRASTAR só desliza as fotos.
       Essa diferença (tocou × arrastou) é medida no _parLojaWire, com uma
       trava de "mexeu" — o mesmo cuidado que a galeria do estoque já usa. */
    /* ===== v436 — A FOTO NÃO CARREGAVA (só a tira de cima) ================
       É EXATAMENTE o bug da v396 no Estoque, que nunca chegou aqui: o card
       pedia a foto ORIGINAL do Supabase (3–4 mil px, vários MB). Com 20
       cards na tela e 4G, o celular corta a decodificação no meio e sobra a
       tirinha de cima — foi o que o print mostrou.
       Conserto igual ao do estoque: pedir a foto já REDUZIDA (w=800) pelo
       /.netlify/images, com data-orig de reserva se o redimensionador falhar.
       E teto de 8 fotos por card, como o estThumbFotos já fazia. */
    function _pvFotoAttr(u,i){
      var raw=_url(u);
      var attr=(typeof _imgCdnAttr==='function') ? _imgCdnAttr(raw,800) : (' src="'+esc(raw)+'"');
      return '<img class="par-vc-slide"'+(i?' loading="lazy"':'')+' decoding="async"'+attr+
             ' alt="'+esc(nome)+(i!=null?(' — foto '+(i+1)):'')+'">';
    }
    var img, vis=fotos.slice(0,8);
    if(vis.length>1){
      img='<div class="par-vc-strip" data-ph-strip>'+
        vis.map(function(f,i){ return _pvFotoAttr(f,i); }).join('')+'</div>';
    } else if(foto){
      img=_pvFotoAttr(foto,null).replace(' class="par-vc-slide"','');
    } else {
      img='<span class="par-vc-semfoto">'+ICO_EST+'</span>';
    }
    return '<article class="par-vc" data-ph-busca="'+esc([l.nome,l.cidade,l.uf,nome].join(' ').toLowerCase())+'">'+
      '<div class="par-vc-foto"'+(url?(' data-ph-open="'+esc(url)+'" role="button" tabindex="0" aria-label="Abrir a vitrine de '+esc(l.nome)+'"'):'')+'>'+img+
        '<span class="par-vc-tag'+(l.tipo==='repasse'?' rep':'')+'">'+(l.tipo==='repasse'?'Repasse':'Seminovo')+'</span>'+
        (ics?('<span class="par-vc-ics">'+ics+'</span>'):'')+
        (vis.length>1?('<span class="par-vc-nf" data-ph-count>1/'+vis.length+'</span>'):'')+
      '</div>'+
      '<div class="par-vc-in"'+(url?(' data-ph-open="'+esc(url)+'" role="button" tabindex="0"'):'')+'>'+
        /* v330 (pedido): card padronizado com o ESTOQUE — mesmos svgs de
           chips (ano/km/cor) e preco verde (classes est-* do styles.css). */
        '<b class="est-nm">'+esc(nome)+'</b>'+
        (function(){
          var ch=[];
          var icoCal=(typeof _ICO_CAL!=='undefined')?_ICO_CAL:'';
          var icoKm=(typeof _EST_ICO_KM!=='undefined')?_EST_ICO_KM:'';
          var icoCor=(typeof _EST_ICO_COR!=='undefined')?_EST_ICO_COR:'';
          /* v411 (pedido): ano de fabricação/modelo por extenso (2020/2021) */
          var _af=String(v.ano||''), _am=String(v.ano_modelo||'');
          var anoTxt=(_af||_am)?((_af||_am)+'/'+(_am||_af)):'';
          if(anoTxt) ch.push('<span>'+icoCal+esc(anoTxt)+'</span>');
          if(v.km) ch.push('<span>'+icoKm+Number(v.km).toLocaleString('pt-BR')+' km</span>');
          if(v.cor) ch.push('<span>'+icoCor+esc(String(v.cor))+'</span>');
          return ch.length?('<div class="est-card-dados">'+ch.join('')+'</div>'):'';
        })()+
        '<div class="est-row"><span class="est-preco">'+
          (v.repasse ? 'Faça sua oferta' : (v.preco?_repDinheiro(v.preco):'Sob consulta'))+
        '</span>'+
        /* v411 (pedido): FIPE junto (tabela pública) e a situação do carro */
        (Number(v.fipe)>0?('<span class="rep-fipe" title="Tabela FIPE">FIPE '+_repDinheiro(v.fipe)+'</span>'):'')+
        '</div>'+
        /* v441 (pedido): o selo verde "No estoque" SAIU do card da Rede.
           Motivo do Angelo: carro anunciado no repasse muitas vezes ainda não
           foi comprado — está só em negociação — e dizer "No estoque" pras
           outras lojas era informação errada. Agora o selo só aparece quando
           tem algo a dizer: "Em negociação". Sem selo = sem promessa. */
        (v.repasse&&String(v.situacao||'')==='negociando'
          ?'<span class="par-vc-st neg">Em negociação</span>':'')+
        /* v330 (pedido): preco de LOJISTA (minimo cadastrado) — so seminovo;
           sem minimo cadastrado vira "consulte". Area fechada do portal. */
        (v.repasse ? '' : (function(){
          var mn = (_precosMin && v.id && _precosMin[String(v.id)]) || 0;
          return '<span class="par-vc-loja" style="font-weight:800;color:#0a4da6">Lojista: '+
            (mn?_repDinheiro(mn):'consulte')+'</span>';
        })())+
        '<span class="par-vc-loja">'+esc([l.nome,local].filter(Boolean).join(' · '))+'</span>'+
      '</div>'+
    '</article>';
  }
  var _ICO_SHARE_PAR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5v11"/><path d="m8 7.2 4-3.7 4 3.7"/><path d="M5.5 13v6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-6"/></svg>';

  function _parHubCardHtml(l,i,veiculo){
    var vs=veiculo?[veiculo]:(l.veiculos||[]).slice(0,8);
    var slides=vs.map(_parHubSlideHtml).filter(Boolean);
    var logo=l.logo?('<img class="par-store-logo" loading="lazy" src="'+esc(_url(l.logo))+'" alt="">')
                   :('<span class="par-store-logo ini">'+esc(_parIni(l.nome))+'</span>');
    var local=[l.cidade,l.uf].filter(Boolean).join(' / ');
    var qtd=(l.veiculos||[]).length;
    var gal=slides.length
      ? ('<div class="par-store-gal" data-ph-gal><div class="par-store-track">'+slides.join('')+'</div>'+
         (slides.length>1?('<span class="par-store-page" data-ph-page>1/'+slides.length+'</span>'):'')+'</div>')
      : ('<div class="par-store-empty">'+ICO_EST+'<span>A vitrine abre no catálogo da loja</span></div>');
    var tipo=l.tipo==='repasse'?'Repasse':'Seminovos';
    var busca=[l.nome,l.cidade,l.uf].concat((veiculo?[veiculo]:(l.veiculos||[])).map(function(v){return v.nome||'';})).join(' ').toLowerCase();
    return '<article class="par-store-card" data-ph-busca="'+esc(busca)+'">'+
      '<div class="par-store-main" data-ph-open="'+esc(l.url||'')+'" role="button" tabindex="0" aria-label="Abrir vitrine de '+esc(l.nome)+'">'+gal+
        '<div class="par-store-body"><div class="par-store-head">'+logo+
          '<span class="par-store-tx"><b>'+esc(l.nome)+'</b><small>'+esc(local||'Loja parceira')+'</small></span>'+
          '<span class="par-store-kind '+(l.tipo==='repasse'?'rep':'')+'">'+tipo+'</span></div>'+
          '<div class="par-store-foot"><span>'+qtd+' veículo'+(qtd===1?'':'s')+'</span><span>Ver vitrine '+_icoChev+'</span></div>'+
        '</div></div>'+
      '<div class="par-store-actions">'+
        '<button type="button" data-ph-visualizar="'+esc(l.url||'')+'">'+ICO_CARTAO+'Visualizar</button>'+
        '<button type="button" data-ph-share="'+esc(l.url||'')+'" data-ph-nome="'+esc(l.nome)+'">'+ICO_COMPARTILHAR+'Compartilhar</button>'+
      '</div>'+
    '</article>';
  }
  /* A primeira linha dá visibilidade aos parceiros antes de repetir a mesma
     loja. Quando há menos de quatro parceiros com catálogo, ela é completada
     pelos próximos veículos desses parceiros; as linhas seguintes mantêm
     todos os veículos restantes disponíveis no marketplace. */
  /* ===== v303 — ESTA FUNÇÃO ESTAVA ESCONDENDO 4 CARROS. SEMPRE. ==========
     Ela separava os veículos em dois grupos: os 4 primeiros ("parceiros") e
     o resto ("estoque"). Isso fazia sentido quando a faixa de cima do
     Marketplace era feita de CARDS DE VEÍCULO — os 4 primeiros iam lá em
     cima e os outros embaixo.

     Só que na v264 a faixa de cima virou card de LOJA (foi um acerto: antes
     a loja aparecia com foto de carro e as pessoas confundiam as duas
     coisas). A partir dali `linhas.parceiros` deixou de ser desenhado — e
     ninguém tirou o splice que o alimentava. Os 4 primeiros veículos
     passaram a ser separados e simplesmente JOGADOS FORA.

     Medi antes de mexer, com a conta rodando:
        1 loja e  4 carros → apareciam 0  (sumiam 4)
        1 loja e 11 carros → apareciam 7  (sumiam 4)
        5 lojas e 20 carros → apareciam 16 (sumiam 4)
     Com a Santa Luzia sozinha no portal, o Marketplace mostrava a loja e
     NENHUM carro. Ninguém tinha reclamado porque a aba parecia só "vazia".

     Agora ela lista todos, igual à de Repasses. Mantive a função (em vez de
     apagar) porque o nome `linhas.estoque` é usado lá fora. */
  function _parHubMarketLinhas(lojas){
    var todos=[];
    (lojas||[]).forEach(function(loja){
      (loja.veiculos||[]).forEach(function(veiculo){ todos.push({loja:loja,veiculo:veiculo}); });
    });
    return { parceiros:[], estoque:todos };
  }
  /* v260 — REPASSES na mesma organização do Marketplace, porém sem cortar:
     a primeira faixa traz TODOS os lojistas parceiros (um card por loja) e
     a faixa de baixo traz TODOS os veículos que estão no Portal, um por card. */
  function _parHubRepLinhas(lojas){
    var cards=[], veiculos=[];
    (lojas||[]).forEach(function(loja){
      cards.push({ loja:loja, veiculo:null });
      (loja.veiculos||[]).forEach(function(v){ veiculos.push({ loja:loja, veiculo:v }); });
    });
    return { lojas:cards, veiculos:veiculos };
  }
  function parHubPinta(){
    var el=$('parHubLista'); if(!el) return;
    var base=_parHubBase(), termo=String((($('parHubBusca')||{}).value)||'').toLowerCase().trim();
    var cidade=String((($('parHubCidade')||{}).value)||'').toLowerCase();
    var ordem=String((($('parHubOrdem')||{}).value)||'destaque');
    var lista=base.filter(function(l){
      if(cidade && String(l.cidade||'').toLowerCase()!==cidade) return false;
      if(!termo) return true;
      return [l.nome,l.cidade,l.uf].concat((l.veiculos||[]).map(function(v){return v.nome||'';})).join(' ').toLowerCase().indexOf(termo)>=0;
    });
    lista.sort(function(a,b){
      if(ordem==='nome') return String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR');
      if(ordem==='veiculos') return ((b.veiculos||[]).length-(a.veiculos||[]).length)||String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR');
      return (b.recente-a.recente)||(a.ordem-b.ordem);
    });
    var tit=$('parHubTitulo'), ct=$('parHubContagem');
    if(tit) tit.textContent=_parHubView==='repasse'?'Lojas com repasses':'Lojas com seminovos';   /* v432 */
    if(ct) ct.textContent=lista.length+' loja'+(lista.length===1?'':'s');
    if(_parHubErro && !base.length){ erroLista(el, async function(){ el.innerHTML=skelHtml(4); await parHubCarregar(); }); return; }
    if(!lista.length){
      el.innerHTML='<div class="cli-empty"><b>Nenhuma loja encontrada</b>Tente retirar um filtro ou buscar por outro nome.</div>';
      return;
    }
    /* v264: a faixa dos parceiros é a MESMA nas duas visões — um slide de
       cards de LOJA, sem foto de veículo. Muda só o que vem embaixo. */
    /* v312 (pedido): sem o cabeçalho "Lojistas parceiros · Deslize pra ver
       todas" — a seção é só a grade de lojas. O título e o sub continuam
       recebidos por compatibilidade, mas não são mais desenhados. */
    function _faixaLojas(titulo, sub, ls){
      /* v329 (pedido): a SUA loja sai da faixa de lojas da pagina Parceiros
         (nas duas visoes) — parceiros e' pra olhar as lojas DOS OUTROS; a sua
         voce ja tem no Estoque e em Minha Loja. */
      ls = ls.filter(function(l){ return String(l.uid||'')!==String(meuId||''); });
      if(!ls.length) return '';
      return '<section class="par-market-section">'+
        '<div class="par-loja-slide">'+ls.map(_parLojaCardHtml).join('')+'</div></section>';
    }
    if(_parHubView==='marketplace'){
      var linhas=_parHubMarketLinhas(lista);
      var topo=_faixaLojas('', '', lista);
      var todos=linhas.estoque.length?('<section class="par-market-section"><div class="par-market-head"><b>Veículos disponíveis</b><span>Estoque de todos os lojistas</span></div><div class="par-vc-grid">'+
        linhas.estoque.map(function(item){ return _parHubVeicCardHtml(item.loja,item.veiculo); }).join('')+'</div></section>'):'';
      el.innerHTML=topo+todos;
    }else{
      /* v260 — Repasses: lojistas na primeira faixa, veículos do Portal abaixo */
      var lr=_parHubRepLinhas(lista);
      var topoRep=_faixaLojas('', '', lista);
      var vsRep=lr.veiculos.length
        ? ('<section class="par-market-section"><div class="par-market-head"><b>Veículos no repasse</b><span>Todos os veículos do Portal</span></div><div class="par-vc-grid">'+
           lr.veiculos.map(function(item){ return _parHubVeicCardHtml(item.loja,item.veiculo); }).join('')+'</div></section>')
        : '';
      el.innerHTML=topoRep+vsRep;
      if(ct) ct.textContent=lista.length+' loja'+(lista.length===1?'':'s')+' · '+lr.veiculos.length+' veículo'+(lr.veiculos.length===1?'':'s');
    }
    _parLojaWire(el);   /* v264: botões dos cards de loja */
    /* v264: abrir a vitrine DENTRO do app (visor) — fechando, você cai de volta
       nesta mesma página de parceiros, com os filtros como estavam. Antes abria
       numa aba do navegador e o "voltar" era do sistema, não do app. */
    function abrir(url, tit){
      if(!url) return;
      try{ _preAquece(url); }catch(_){}
      try{ _publicoAbrir(url,{ titulo:tit||'Vitrine da loja', voltar:'Voltar à rede' }); return; }catch(_){}
      try{ window.open(url,'_blank','noopener'); }catch(__){ location.href=url; }
    }
    Array.prototype.forEach.call(el.querySelectorAll('[data-ph-open]'),function(c){
      c.onclick=function(){ abrir(c.getAttribute('data-ph-open')); };
      c.onkeydown=function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); abrir(c.getAttribute('data-ph-open')); } };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-ph-visualizar]'),function(b){ b.onclick=function(){ abrir(b.getAttribute('data-ph-visualizar')); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-ph-share]'),function(b){ b.onclick=function(e){
      /* v303: o compartilhar agora mora DENTRO da foto do card, e o card
         inteiro abre a vitrine. Sem parar o clique aqui, um toque no ícone
         faria as duas coisas: abriria a bandeja E a vitrine por cima dela.
         Antes ele ficava numa barra separada e isso nunca acontecia. */
      if(e && e.stopPropagation) e.stopPropagation();
      var url=b.getAttribute('data-ph-share')||'', nome=b.getAttribute('data-ph-nome')||'Loja parceira';
      if(!url) return;
      try{ if(navigator.share){ navigator.share({title:nome,text:'Confira os veículos da '+nome+':',url:url})['catch'](function(){}); return; } }catch(_){}
      try{ navigator.clipboard.writeText(url).then(function(){toast('Link copiado ✓');},function(){toast(url);}); }catch(_){ toast(url); }
    }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-ph-gal]'),function(g){
      var tr=g.querySelector('.par-store-track'), pg=g.querySelector('[data-ph-page]'); if(!tr||!pg) return;
      tr.onscroll=function(){ requestAnimationFrame(function(){ var n=tr.children.length, ix=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth)); pg.textContent=(Math.min(n,ix+1))+'/'+n; }); };
    });
  }
  function parHubLigar(){
    /* v432: no lugar das abas, o link do rodapé leva pra OUTRA rede */
    var tr=$('redeTroca');
    if(tr) tr.onclick=function(){
      var alvo=tr.getAttribute('data-rede');
      if(alvo==='marketplace') telaRedeSeminovos(); else telaRedeRepasses();
    };
    var q=$('parHubBusca'); if(q) q.oninput=parHubPinta;
    var c=$('parHubCidade'); if(c) c.onchange=parHubPinta;
    var o=$('parHubOrdem'); if(o) o.onchange=parHubPinta;
  }
  async function parHubCarregar(){
    _parHubErro=false;
    try{
      /* ===== v308 (pedido) — A LEITURA MUDOU DE PORTA ======================
         Antes esta tela lia a TABELA de repasse direto, pedindo o campo preco
         junto. Duas coisas erradas nisso:

         1. mostrava na tela o preço de repasse dos carros das outras lojas —
            o mesmo número que o Portal esconde atrás de "Faça sua oferta";
         2. e trazia o número pro navegador mesmo que a tela não o pintasse.
            Dado que chega no navegador está no código-fonte da página: basta
            abrir o inspetor pra ler. Esconder na tela não é esconder.

         Agora vem pela mesma porta estreita que o Portal já usa: ela devolve
         a rede inteira e só entrega o PREÇO pro dono de cada carro. Filtro
         aqui o que a consulta antiga filtrava lá (só ativo e não vendido).
         ==================================================================== */
      var r=await withTimeout(supa.rpc('repasse_rede'),9000);
      var todos=(r&&r.data)||[];
      if(!Array.isArray(todos)) todos=[];
      _parHubRepasses=todos
        .filter(function(x){ return x && x.ativo===true && !x.vendido; })  /* v259: só o que dá pra comprar */
        .sort(function(a,b){ return _parHubData(b.atualizado_em||b.criado_em)-_parHubData(a.atualizado_em||a.criado_em); })
        .slice(0,300);
    }catch(_){ _parHubRepasses=[]; _parHubErro=true; }
    await membrosAtivosCarregar();
    await membrosCatCarregar();
    _parHubCidadesPinta();
    parHubPinta();
  }
  function membrosAtivosPinta(){
    var el=$('parAssinantes'); if(!el) return;
    var lista=_membrosAtivos.filter(function(m){ return m.loja_nome; });
    if(!lista.length){ el.innerHTML=''; return; }
    el.innerHTML='<div class="par-sec-h">'+ICO_LOJINHA+' Lojas Parceiras · cartão digital</div>'+
      '<div class="mbr-hint">Toque em <b>Ver catálogo</b> pra abrir o cartão digital da loja — o mesmo endereço que ela manda pros clientes dela.</div>'+
      lista.map(function(m){
        var c=_membrosCat[String(m.user_id)]||{};
        var wa=String(m.whatsapp||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); var loc=[m.cidade,m.uf].filter(Boolean).join('/');
        var logo=c.logo?('<img loading="lazy" class="mbr-logo" src="'+esc(_url(c.logo))+'" alt="">'):('<div class="mbr-logo ini">'+esc(_parIni(m.loja_nome))+'</div>');
        var capa=c.capa?('<div class="mbr-capa" style="background-image:url('+esc(_url(c.capa))+')"></div>'):'';
        var qtd=(c.n!=null)?('<span class="mbr-qtd">'+c.n+(c.n===1?' veículo':' veículos')+'</span>'):'<span class="mbr-qtd off">carregando…</span>';
        var insta=c.insta?('<span class="mbr-insta">@'+esc(c.insta)+'</span>'):'';
        return '<div class="mbr-card">'+capa+
          '<div class="mbr-top">'+logo+
            '<div class="mbr-tx"><div class="mbr-nm">'+esc(m.loja_nome)+' <span class="rep-selo">⭐ Parceiro</span></div>'+
            '<div class="mbr-sb">'+esc(loc||'Loja parceira')+(insta?(' · '+insta):'')+'</div>'+qtd+'</div>'+
          '</div>'+
          '<div class="mbr-bts">'+
            '<a class="mbr-b cat" href="'+esc(_mbrCatUrl(m.user_id))+'" target="_blank" rel="noopener">'+ICO_CARTAO+'Ver catálogo</a>'+
            (wa?('<button type="button" class="mbr-b wa" data-mwa="'+esc(m.whatsapp)+'" data-mnome="'+esc(m.loja_nome)+'">'+ICO_WAMINI+'Falar</button>'):'')+
            '<button type="button" class="mbr-b cp" data-mcp="'+esc(_mbrCatUrl(m.user_id))+'">'+ICO_COPIAR+'Copiar link</button>'+
          '</div>'+
        '</div>';
      }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('[data-mwa]'),function(b){ b.onclick=function(e){ e.stopPropagation(); _repWa(b.getAttribute('data-mwa'),'Olá! Vi sua loja ('+(b.getAttribute('data-mnome')||'')+') na rede de Parceiros do MEV Veículos.'); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-mcp]'),function(b){ b.onclick=function(e){ e.stopPropagation(); var u=b.getAttribute('data-mcp')||'';
      try{ navigator.clipboard.writeText(u).then(function(){ toast('Link do catálogo copiado ✓'); },function(){ toast(u); }); }catch(_){ toast(u); } }; });
  }
  /* ===== v285 — SAIU DAQUI TODO O CAMINHO DE PAGAMENTO DO R$ 99,90 =====
     Foram removidas cinco funções que só existiam para vender o pacote
     Parceiro por R$ 99,90: parceiroPagarPix, pollParceiro, _parceiroWaUrl,
     parceiroSucesso e patrocinioPitch (esta última já era código morto —
     ninguém a chamava). Quem cobra a mensalidade agora é a tela de planos
     (Menu → Uso e faturamento), que gera o PIX do plano escolhido e tem o
     próprio acompanhamento de pagamento (assinaturaPagar / pollAssinatura). */

  var _parErro=false;
  async function parCarregar(){ _parErro=false; try{ var r=await withTimeout(supa.from('parceiros').select('*').order('ordem',{ascending:true}).order('criado_em',{ascending:false}),9000); _parceiros=(r&&r.data)||[]; }catch(e){ _parceiros=[]; _parErro=true; } }
  function parPinta(){
    var el=$('parLista'); if(!el) return;
    if(_parErro && !_parceiros.length){ erroLista(el, async function(){ el.innerHTML=skelHtml(3); await parCarregar(); parPinta(); }); return; }
    var lista=_parceiros; if(!_ehAdmin()) lista=lista.filter(function(p){ return p.ativo; });
    if(!_ehAdmin()) lista=lista.filter(function(p){ return !p.catalogo_url; });
    if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:16px;color:#94a3b8">'+(_ehAdmin()?'Nenhum patrocinador. Toque no "+" pra cadastrar.':'Em breve, lojistas por aqui.')+'</div>'; return; }
    el.innerHTML=lista.map(function(p,i){
      var logo=p.logo_url?('<img loading="lazy" class="pc-logo" src="'+esc(p.logo_url)+'">'):('<div class="pc-logo">'+esc(_parIni(p.nome))+'</div>');
      var tp=esc(p.tipo||'Patrocinador')+((_ehAdmin()&&!p.ativo)?' · <span class="off">inativo</span>':'');
      return '<div class="pc-card" data-i="'+i+'">'+logo+'<div class="pc-tx"><div class="pc-nm">'+esc(p.nome)+'</div><div class="pc-tp">'+tp+'</div></div><span style="color:#0a4da6">'+_icoChev+'</span></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.pc-card'),function(node){ node.onclick=function(){ parceiroAbrir(lista[+node.getAttribute('data-i')]); }; });
  }
  function parceiroAbrir(p){
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='🤝'; $('cliMt').textContent=p.nome||'Patrocinador';
    var wa=String(p.whatsapp||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(wa && wa.length<=11) wa='55'+wa;
    var logo=p.logo_url?('<img loading="lazy" class="pc-logo" src="'+esc(p.logo_url)+'">'):('<div class="pc-logo">'+esc(_parIni(p.nome))+'</div>');
    var acts='';
    if(p.site) acts+='<a href="'+esc(_url(p.site))+'" target="_blank" rel="noopener">🌐 Site</a>';
    if(wa) acts+='<a class="wa" href="https://wa.me/'+wa+'" target="_blank" rel="noopener">💬 WhatsApp</a>';
    if(p.catalogo_url) acts+='<a href="'+esc(_url(p.catalogo_url))+'" target="_blank" rel="noopener">🖼️ Catálogo</a>';
    if(p.landing_url) acts+='<a href="'+esc(_url(p.landing_url))+'" target="_blank" rel="noopener">🔗 Página</a>';
    $('cliMbody').innerHTML='<div class="pc-head">'+logo+'<div><div class="pc-nm" style="font-size:18px">'+esc(p.nome)+'</div><div class="pc-tp">'+esc(p.tipo||'Patrocinador')+'</div>'+(p.cnpj?'<div class="pc-cnpj">CNPJ '+esc(p.cnpj)+'</div>':'')+'</div></div>'+
      (p.descricao?'<div style="font-size:13px;color:#334155;line-height:1.5;margin-bottom:10px">'+esc(p.descricao)+'</div>':'')+
      (acts?'<div class="pc-acts">'+acts+'</div>':'<div class="cli-empty" style="padding:10px;color:#94a3b8">Sem contatos cadastrados.</div>')+
      (_ehAdmin()?'<button type="button" class="cad-btn sec" id="parEditar" style="margin-top:14px">Editar patrocinador</button>':'');
    var eb=$('parEditar'); if(eb) eb.onclick=function(){ parceiroFicha(p); };
  }
  function parceiroFicha(p){
    p=p||{}; _parLogoUrl='';
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='🤝'; $('cliMt').textContent=p.id?'Editar parceiro':'Novo parceiro';
    function I(id,lb,val,ph){ return '<label class="cad-lbl">'+lb+'</label><input class="cad-in" id="'+id+'" value="'+esc(val==null?'':val)+'" placeholder="'+esc(ph||'')+'">'; }
    var tipoSel='<label class="cad-lbl">Tipo</label><select class="cad-in" id="pfTipo">'+['Loja','Repasse','Consultor','Patrocinador'].map(function(t){ return '<option'+((p.tipo||'Loja')===t?' selected':'')+'>'+t+'</option>'; }).join('')+'</select>';
    $('cliMbody').innerHTML=
      '<div class="lj-logo-wrap"><div class="lj-logo" id="pfLogoBox">'+(p.logo_url?'<img loading="lazy" decoding="async" src="'+esc(imgCdn(p.logo_url,200))+'">':'<span>logo</span>')+'</div><button type="button" class="cad-btn sec" id="pfLogoBtn" style="flex:1;margin:0">'+(p.logo_url?'Trocar logo/foto':'Adicionar logo/foto')+'</button><input type="file" id="pfLogoInput" accept="image/*" style="display:none"></div>'+
      I('pfNome','Nome',p.nome,'Nome do parceiro')+tipoSel+
      I('pfSite','Site',p.site,'www.site.com.br')+
      I('pfWa','WhatsApp',p.whatsapp,'(00) 00000-0000')+
      I('pfCat','Catálogo (link)',p.catalogo_url,'link do catálogo/vitrine')+
      I('pfLanding','Landing page (link)',p.landing_url,'link da página')+
      I('pfCnpj','CNPJ',p.cnpj,'00.000.000/0000-00')+
      '<label class="cad-lbl">Descrição</label><textarea class="cad-in" id="pfDesc" rows="2" placeholder="Sobre o parceiro">'+esc(p.descricao||'')+'</textarea>'+
      '<label class="cad-lbl">Ordem (menor aparece primeiro)</label><input class="cad-in" id="pfOrdem" inputmode="numeric" value="'+esc(p.ordem||0)+'">'+
      '<label class="vd-ck'+(p.ativo!==false?' on':'')+'" style="margin-top:8px"><input type="checkbox" id="pfAtivo"'+(p.ativo!==false?' checked':'')+'><span>Ativo (pagamento em dia · aparece pros usuários)</span></label>'+
      '<button class="cad-btn" id="pfSalvar" style="margin-top:12px">Salvar</button><div class="cad-msg" id="pfMsg"></div>'+
      (p.id?'<button class="cad-btn sair" id="pfDel" style="margin-top:8px">Apagar parceiro</button>':'');
    $('pfLogoBtn').onclick=function(){ $('pfLogoInput').click(); };
    $('pfLogoInput').onchange=function(){ var f=this.files&&this.files[0]; this.value=''; if(!f) return;
      fotoCropAbrir(f, function(bl){ if(bl) parLogoUp(bl); }, {ar:1, out:512, redondo:false, blob:true, titulo:'Ajustar a logo', sub:'Arraste pra posicionar · use a barra pra dar zoom'});
    };
    var ck=$('pfAtivo'); if(ck) ck.onchange=function(){ var lb=ck.closest('.vd-ck'); if(lb) lb.classList.toggle('on',ck.checked); };
    $('pfSalvar').onclick=function(){ parceiroSalvar(p.id); };
    var d=$('pfDel'); if(d) d.onclick=function(){ parceiroApagar(p.id); };
  }
  async function parLogoUp(file){ if(!file) return; toast('Enviando imagem...'); try{ var url=await avUpload(file); if(url){ _parLogoUrl=url; var box=$('pfLogoBox'); if(box) box.innerHTML='<img loading="lazy" decoding="async" src="'+esc(imgCdn(url,800))+'">'; toast('Imagem pronta.'); } }catch(e){ toast('Falha ao enviar.'); } }
  async function parceiroSalvar(id){
    var m=$('pfMsg'); if(m) m.className='cad-msg';
    function g(x){ var e=$(x); return e?(e.value||'').trim():''; }
    var nome=g('pfNome'); if(!nome){ if(m){ m.className='cad-msg err'; m.textContent='Informe o nome.'; } return; }
    var reg={ nome:nome, tipo:g('pfTipo'), site:g('pfSite'), whatsapp:g('pfWa'), catalogo_url:g('pfCat'), landing_url:g('pfLanding'), cnpj:g('pfCnpj'), descricao:g('pfDesc'), ordem:(parseInt(g('pfOrdem'),10)||0), ativo:!!(($('pfAtivo')||{}).checked) };
    if(_parLogoUrl) reg.logo_url=_parLogoUrl;
    var btn=$('pfSalvar'); if(btn){ btn.disabled=true; btn.textContent='Salvando...'; }
    try{
      if(id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('parceiros').update(reg).eq('id',id); if(r&&r.error) throw r.error; }
      else { reg.admin_id=meuId; var r2=await supa.from('parceiros').insert(reg); if(r2&&r2.error) throw r2.error; }
      cliModalFechar(); await parCarregar(); parPinta(); toast('Patrocinador salvo.');
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } if(btn){ btn.disabled=false; btn.textContent='Salvar'; } }
  }
  async function parceiroApagar(id){ if(!id) return; if(!confirm('Apagar este patrocinador?')) return; try{ var r=await supa.from('parceiros').delete().eq('id',id); if(r&&r.error) throw r.error; cliModalFechar(); await parCarregar(); parPinta(); toast('Patrocinador apagado.'); }catch(e){ toast('Não consegui apagar.'); } }

/* ╔═══ src/app/10b-chat-lojistas.js ══════════════════════════════════════ */
  /* ============================================================================
   * CHAT ENTRE LOJISTAS — 06/08/2026 (v325)
   *
   * Mensagem direta loja↔loja DENTRO do app: negociar repasse, parceria,
   * indicar cliente — sem caçar o WhatsApp do outro lojista.
   *
   * Onde vive: um cartão "Conversas entre lojas" no topo da tela Parceiros
   * (a tela original roda intacta — este arquivo só EMBRULHA telaParceiros,
   * mesma técnica do 16b). Os destinatários são os MEMBROS ATIVOS do portal
   * (mp_portal_membro) — o mesmo diretório que a tela de Parceiros já usa.
   *
   * Banco: mp_chat_lojista (RLS: só remetente e destinatário; enviar só como
   * você mesmo e só pra membro ativo; marcar lida = só o destinatário, e por
   * grant de coluna ele não consegue alterar o texto recebido).
   * ========================================================================== */

  try{ MP_TAB.chat_lojista = 1; }catch(_){ }

  var _clTimer = null, _clOutro = null, _clMeuId = '';

  /* ---- cartão na tela Parceiros (embrulho; original intacto) ---- */
  try{
    if(typeof telaParceiros === 'function'){
      var _clTelaParOrig = telaParceiros;
      telaParceiros = function(){
        var r = _clTelaParOrig.apply(this, arguments);
        setTimeout(clCartaoNaTela, 80);
        setTimeout(clCartaoNaTela, 700);
        return r;
      };
    }
  }catch(_){ }
  async function clCartaoNaTela(){
    try{
      if(true) return;   /* v402 (pedido): banner OCULTO por enquanto — pra voltar, apague esta linha */
      if(document.getElementById('clAtalho')) return;
      var pg = document.querySelector('#secoes .info-pg'); if(!pg) return;
      var h2 = pg.querySelector('h2'); if(!h2) return;
      var d = document.createElement('div');
      d.id = 'clAtalho';
      d.style.cssText = 'background:linear-gradient(135deg,#0a4da6,#1d6fd0);color:#fff;border-radius:14px;padding:14px 16px;margin:10px 0 14px;display:flex;align-items:center;gap:12px;cursor:pointer';
      d.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/></svg>'+
        '<div style="flex:1"><b style="font-size:15px">Conversas entre lojas</b><br><span style="font-size:12.5px;opacity:.85">Negocie repasses e parcerias direto por aqui.</span></div>'+
        '<span id="clBadge" style="display:none;flex:none;background:#0f9d58;border-radius:999px;min-width:22px;height:22px;padding:0 6px;font-size:12px;font-weight:900;line-height:22px;text-align:center"></span>'+
        '<span style="font-size:20px;opacity:.8">›</span>';
      d.onclick = function(){ telaChatLojas(); };
      h2.parentNode.insertBefore(d, h2.nextSibling);
      /* bolinha de não lidas */
      var rq = await supa.from('chat_lojista').select('id').eq('lida', false).limit(100);
      var n = 0, uid = await clMeuId();
      ((rq && rq.data) || []).forEach(function(_m){ n++; });
      /* (a RLS já limita às minhas; o filtro fino de "para mim" vem na tela) */
      if(n > 0){ var b = document.getElementById('clBadge'); if(b){ b.style.display='block'; b.textContent = n > 99 ? '99+' : n; } }
    }catch(_){ }
  }
  async function clMeuId(){
    if(_clMeuId) return _clMeuId;
    try{ var s = await supa.auth.getSession(); _clMeuId = (s && s.data && s.data.session && s.data.session.user && s.data.session.user.id) || ''; }catch(_){ }
    return _clMeuId;
  }

  /* ============================ TELA: LISTA ============================ */
  async function telaChatLojas(){
    clPararTimer();
    mevTabSet('');
    $('secoes').innerHTML = _cadBack()+
      '<div class="info-pg"><h2>Conversas entre lojas</h2>'+
      '<div id="clWrap"><div class="cli-empty">Carregando...</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    window.scrollTo(0,0); try{ fabFoto(false); }catch(_){ }
    _cadWireBack(); try{ voltarTab(telaParceiros); }catch(_){ }
    await clListaPinta();
  }

  async function clListaPinta(){
    var wrap = $('clWrap'); if(!wrap) return;
    var uid = await clMeuId();
    var msgs = [], membros = [];
    try{
      var r = await supa.from('chat_lojista').select('de_user,para_user,texto,lida,criado_em')
        .order('criado_em', {ascending:false}).limit(400);
      msgs = (r && r.data) || [];
    }catch(_){ }
    try{
      var rm = await supa.from('portal_membro').select('user_id,loja_nome,cidade,uf')
        .eq('ativo', true).order('loja_nome', {ascending:true}).limit(100);
      membros = (rm && rm.data) || [];
    }catch(_){ }
    var nomeDe = {}; membros.forEach(function(m){ nomeDe[m.user_id] = m.loja_nome || 'Loja'; });

    /* agrupa por "o outro" */
    var conv = {}, ordem = [];
    msgs.forEach(function(m){
      var outro = (m.de_user === uid) ? m.para_user : m.de_user;
      if(!conv[outro]){ conv[outro] = { ultimo:m, naoLidas:0 }; ordem.push(outro); }
      if(m.para_user === uid && m.lida === false) conv[outro].naoLidas++;
    });

    var h = '';
    if(ordem.length){
      h += ordem.map(function(o){
        var c = conv[o], eu = c.ultimo.de_user === uid;
        return '<div class="card" data-cl="'+esc(o)+'" style="padding:12px 14px;margin-bottom:8px;display:flex;align-items:center;gap:10px;cursor:pointer">'+
          '<div style="flex:1;min-width:0"><div style="font-weight:800;font-size:14px">'+esc(nomeDe[o]||'Loja parceira')+'</div>'+
          '<div style="font-size:12.5px;color:#64748b;overflow:hidden;white-space:nowrap;text-overflow:ellipsis">'+(eu?'Você: ':'')+esc(String(c.ultimo.texto||'').slice(0,60))+'</div></div>'+
          (c.naoLidas?('<span style="flex:none;background:#0f9d58;color:#fff;border-radius:999px;min-width:20px;height:20px;padding:0 6px;font-size:11px;font-weight:900;line-height:20px;text-align:center">'+c.naoLidas+'</span>'):'')+
          '<span style="color:#94a3b8">›</span></div>';
      }).join('');
    } else {
      h += '<div class="cli-empty" style="margin-bottom:12px"><b>Nenhuma conversa ainda</b>Escolha uma loja abaixo e mande a primeira mensagem.</div>';
    }

    /* diretório pra puxar conversa nova */
    var outros = membros.filter(function(m){ return m.user_id !== uid && !conv[m.user_id]; });
    if(outros.length){
      h += '<div style="font-weight:800;font-size:12px;color:#64748b;margin:14px 2px 8px">PUXAR CONVERSA COM</div>';
      h += outros.map(function(m){
        var onde = [m.cidade, m.uf].filter(Boolean).join('/');
        return '<div class="card" data-cl="'+esc(m.user_id)+'" style="padding:10px 14px;margin-bottom:7px;display:flex;align-items:center;gap:10px;cursor:pointer">'+
          '<div style="flex:1"><b style="font-size:13.5px">'+esc(m.loja_nome||'Loja')+'</b>'+(onde?('<span style="font-size:12px;color:#94a3b8"> · '+esc(onde)+'</span>'):'')+'</div>'+
          '<span style="color:#0a4da6;font-weight:800;font-size:12.5px">Conversar</span></div>';
      }).join('');
    }
    wrap.innerHTML = h;
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-cl]'), function(cd){
      cd.onclick = function(){ clAbrirConversa(cd.getAttribute('data-cl'), nomeDe[cd.getAttribute('data-cl')] || (cd.querySelector('b,div>div') ? cd.querySelector('b, div>div').textContent : 'Loja')); };
    });
  }

  /* ============================ TELA: CONVERSA ============================ */
  async function clAbrirConversa(outro, nome){
    clPararTimer();
    _clOutro = outro;
    mevTabSet('');
    $('secoes').innerHTML = _cadBack()+
      '<div class="info-pg"><h2>'+esc(nome||'Conversa')+'</h2>'+
      '<div id="clTh" style="background:#eef2f7;border:1px solid #e4ebf5;border-radius:14px;padding:10px;max-height:56vh;min-height:220px;overflow-y:auto;display:flex;flex-direction:column;gap:6px"><div class="cli-empty" style="padding:12px">Carregando...</div></div>'+
      '<div style="display:flex;gap:8px;margin-top:10px;align-items:flex-end">'+
        '<textarea class="cad-in" id="clIn" rows="1" placeholder="Escreva sua mensagem..." style="flex:1;resize:none"></textarea>'+
        '<button type="button" class="crm-send" id="clSend" title="Enviar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>'+
      '</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    window.scrollTo(0,0); try{ fabFoto(false); }catch(_){ }
    _cadWireBack(); try{ voltarTab(telaChatLojas); }catch(_){ }
    var bs=$('clSend'); if(bs) bs.onclick=clEnviar;
    var inp=$('clIn'); if(inp) inp.addEventListener('keydown', function(e){ if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); clEnviar(); } });
    await clThreadPinta(false);
    _clTimer = setInterval(function(){
      if(document.getElementById('clTh')) clThreadPinta(true); else clPararTimer();
    }, 8000);
  }
  function clPararTimer(){ if(_clTimer){ clearInterval(_clTimer); _clTimer = null; } }

  async function clThreadPinta(silencioso){
    var box = $('clTh'); if(!box || !_clOutro) return;
    var uid = await clMeuId();
    var msgs = [];
    try{
      var r = await supa.from('chat_lojista').select('id,de_user,para_user,texto,lida,criado_em')
        .or('de_user.eq.'+_clOutro+',para_user.eq.'+_clOutro)
        .order('criado_em', {ascending:true}).limit(300);
      msgs = ((r && r.data) || []).filter(function(m){
        return (m.de_user===uid && m.para_user===_clOutro) || (m.de_user===_clOutro && m.para_user===uid);
      });
    }catch(_){ if(!silencioso) box.innerHTML='<div class="cli-empty" style="padding:12px">Não consegui carregar. Tente de novo.</div>'; return; }
    if(!msgs.length){ box.innerHTML='<div class="cli-empty" style="padding:12px">Nenhuma mensagem ainda. Quebre o gelo. 🙂</div>'; return; }
    var noFim = box.scrollTop + box.clientHeight >= box.scrollHeight - 60;
    box.innerHTML = msgs.map(function(m){
      var eu = m.de_user === uid;
      var dt = new Date(m.criado_em), hh = ('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
      return '<div style="max-width:82%;padding:8px 12px;border-radius:14px;font-size:14px;line-height:1.45;word-break:break-word;'+
        (eu ? 'background:#dcf3e5;align-self:flex-end;border-bottom-right-radius:4px'
            : 'background:#fff;border:1px solid #e4ebf5;align-self:flex-start;border-bottom-left-radius:4px')+'">'+
        esc(m.texto||'')+'<i style="display:block;font-style:normal;font-size:10px;color:#94a3b8;text-align:right;margin-top:2px">'+hh+'</i></div>';
    }).join('');
    if(noFim || !silencioso) box.scrollTop = box.scrollHeight;
    /* marca as recebidas como lidas (grant só na coluna lida) */
    try{
      await supa.from('chat_lojista').update({lida:true})
        .eq('para_user', uid).eq('de_user', _clOutro).eq('lida', false);
    }catch(_){ }
  }

  async function clEnviar(){
    var inp = $('clIn'); if(!inp || !_clOutro) return;
    var t = String(inp.value||'').trim(); if(!t) return;
    var uid = await clMeuId(); if(!uid) return;
    inp.disabled = true;
    try{
      var r = await supa.from('chat_lojista').insert({ de_user: uid, para_user: _clOutro, texto: t.slice(0,2000) });
      if(r && r.error) throw r.error;
      inp.value = '';
      await clThreadPinta(false);
    }catch(_){ toast('Não consegui enviar. Tente de novo.'); }
    inp.disabled = false;
    try{ inp.focus(); }catch(_){ }
  }

/* ╔═══ src/app/10c-chat-painel.js ════════════════════════════════════════ */
  /* ==========================================================================
     10c — O BALÃO E O PAINEL DO CHAT (v471, Fase 1 do PROJETO-chat-interno)

     "quero que fique como um fab canto inferior direito ao lado esquerdo
      do menu, clica encima abre o chat interno sem sair da pagina"

     - #btnChatFab (app.html) à ESQUERDA do #btnMenuFab. A visibilidade
       ESPELHA a do balão do Menu por JS (chatFabSync): as regras de CSS do
       Menu são muitas (v390/v408/v417/v423) e espelhar por classe .on é a
       única forma de valer em TODA página/breakpoint sem duplicar o
       emaranhado. Onde o Menu aparece, o chat aparece.
     - Clique → PAINEL FLUTUANTE (#chatPainel): folha de baixo no celular,
       janelinha no canto no computador. Fecha no X, no Esc e no clique
       fora — a página continua onde estava (nada de #secoes).
     - Aba LOJAS = o motor v325 (mp_chat_lojista, RLS pronta) renderizado
       DENTRO do painel. As telas antigas do 10b seguem intactas (e o
       banner segue oculto desde a v402) — a porta de entrada agora é o
       balão. v472 acrescenta a aba CLIENTES ao lado.
     Pra desligar: apagar este arquivo e rodar o montar.js.
     ========================================================================= */

  var _cpAba='lojas', _cpOutro=null, _cpOutroNome='', _cpTimer=null, _cpBadgeTimer=null;
  var _cpFone=null, _cpFoneNome='';   /* v472: a conversa aberta na aba Clientes */
  var _cpFotoAnexo='';                /* v547: a capa do carro que acabou de ser anexado */

  /* ---------- o balão espelha o do Menu ---------- */
  function chatFabSync(){
    try{
      var m=$('btnMenuFab'), c=$('btnChatFab'); if(!m||!c) return;
      var vis = !!token && m.offsetParent!==null && getComputedStyle(m).display!=='none';
      c.classList.toggle('on', vis);
      /* v763: o Conversas do cabeçalho (#tbChat, 05d) segue só o login — na
         faixa larga da home o balão do Menu está escondido de propósito
         (§9.8) e a régua dele deixaria o cabeçalho sem o chat. */
      var tb=$('tbChat'); if(tb) tb.hidden=!token;
    }catch(_){}
  }
  try{
    var _cfB=$('btnChatFab');
    if(_cfB) _cfB.onclick=function(){ chatPainelAlterna(); };
    setInterval(chatFabSync, 1200);
    window.addEventListener('resize', chatFabSync);
  }catch(_){}

  /* ---------- o painel ---------- */
  function chatPainelMontar(){
    if($('chatPainel')) return;
    var d=document.createElement('div'); d.id='chatPainel';
    d.innerHTML='<div class="cp-bg" id="cpBg"></div>'+
      '<div class="cp-box" role="dialog" aria-label="Conversas">'+
        '<div class="cp-hd">'+
          '<div class="cp-tabs" id="cpTabs"><button type="button" class="cp-tb on" data-cpt="lojas">Lojas</button><button type="button" class="cp-tb" data-cpt="clientes">Clientes</button></div>'+
          '<button type="button" class="cp-x" id="cpX" aria-label="Fechar">&times;</button>'+
        '</div>'+
        '<div class="cp-body" id="cpBody"></div>'+
      '</div>';
    document.body.appendChild(d);
    $('cpX').onclick=chatPainelFechar;
    $('cpBg').onclick=chatPainelFechar;
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') chatPainelFechar(); });
    Array.prototype.forEach.call(d.querySelectorAll('[data-cpt]'),function(b){
      b.onclick=function(){ _cpAba=b.getAttribute('data-cpt'); _cpOutro=null; _cpFone=null; cpTabsPinta(); cpPinta(); };
    });
  }
  function cpTabsPinta(){
    /* ===== v526 — QUEM DECIDE A ABA CLIENTES É O chatDisponivel ==========
       Até a v525 esse sinal decidia o ITEM DO MENU. O item saiu (Parte 3),
       e o sinal passou a decidir a ABA — é a mesma pergunta ("esta loja tem
       atendente de WhatsApp?") no lugar novo, e não um sinal a mais.
       ⚠️ SÓ ESCONDE COM `false` EXPLÍCITO. O `_chatTem` nasce `null` e a
       resposta vem do banco depois; esconder no `null` faria a aba piscar
       ao abrir o painel — e sumir de vez se a consulta demorasse. */
    var some=false;
    try{ some=(typeof _chatTem!=='undefined' && _chatTem===false); }catch(_){}
    var tb=document.querySelector('#cpTabs .cp-tb[data-cpt="clientes"]');
    if(tb) tb.style.display=some?'none':'';
    if(some && _cpAba==='clientes'){ _cpAba='lojas'; _cpFone=null; }
    Array.prototype.forEach.call(document.querySelectorAll('#cpTabs .cp-tb'),function(b){
      b.classList.toggle('on', b.getAttribute('data-cpt')===_cpAba);
    });
  }
  function chatPainelAlterna(){
    chatPainelMontar();
    var p=$('chatPainel');
    if(p.classList.contains('on')){ chatPainelFechar(); return; }
    p.classList.add('on');
    _cpOutro=null; _cpFone=null;
    cpTabsPinta(); cpPinta();
  }
  /* ===== v522 — ABRIR JÁ NA CONVERSA DE UM CLIENTE ======================
     O botão de balãozinho da linha do CRM (12j) chama esta função.
     🔴 NÃO dá pra reaproveitar o `chatPainelAlterna` acima, por DOIS motivos:
       1. ele faz `_cpOutro=null; _cpFone=null;` — zeraria justamente a
          conversa que a gente quer abrir;
       2. ele ALTERNA — se o painel já estivesse aberto, o clique FECHARIA
          o chat em vez de trocar de conversa.
     Por isso esta é uma porta separada: só ABRE (nunca fecha), e já entra
     na aba Clientes com o telefone escolhido. */
  function chatPainelAbrirCliente(telefone, nome, rascunho){
    var d=String(telefone||'').replace(/\D/g,'');
    if(!d){ toast('Este cliente não tem telefone cadastrado.'); return; }
    /* v530: quem chama pode mandar a mensagem JÁ ESCRITA (o pós-venda manda
       o texto pronto do contato do dia). Não envia nada — só deixa no campo
       pra você ler, mudar e decidir. */
    _cpRascunho=String(rascunho||'');
    chatPainelMontar();
    _cpAba='clientes';
    _cpOutro=null;
    _cpFone=d;
    /* v532: quem chama nem sempre TEM o nome. O link do e-mail do lead
       (`app.html?chat=<telefone>`) traz só o telefone de propósito — nome na
       URL é dado pessoal num endereço que se encaminha por e-mail.
       Então a busca do nome mora AQUI, num lugar só, e serve todo mundo:
       CRM → telefone formatado → "Cliente". Cabeçalho escrito "Cliente"
       quando a ficha existe é o tipo de coisa que faz o vendedor achar que
       abriu a conversa errada. */
    _cpFoneNome=nome||_cpNomePeloFone(d)||'Cliente';
    var p=$('chatPainel'); if(p) p.classList.add('on');
    cpTabsPinta(); cpPinta();
  }
  /* v526 — a porta de quem chega por FORA (notificação antiga, atalho salvo,
     link de push): abre a caixa de entrada na LISTA, sem escolher conversa.
     Igual à `chatPainelAbrirCliente`, só ABRE — nunca alterna. */
  function chatPainelAbrirClientes(){
    chatPainelMontar();
    _cpAba='clientes'; _cpOutro=null; _cpFone=null;
    var p=$('chatPainel'); if(p) p.classList.add('on');
    cpTabsPinta(); cpPinta();
  }
  /* ==========================================================================
     v567 — AS DUAS PORTAS DO CHAT ENTRE LOJISTAS
     (Fase 2 do PROJETO-link-nas-notificacoes)

     O aviso do sino "<Loja> te mandou mensagem" já levava pra cá — mas só
     conseguia abrir a ABA Lojas, e o vendedor tinha que achar a conversa na
     lista. Agora o `tipo` da notificação carrega quem mandou
     (`chat:lj:<uuid>`), então dá pra abrir A CONVERSA.

     ⚠️ São DUAS portas de propósito, não uma com parâmetro opcional:
     · `chatPainelAbrirLojas()` — a lista, pra quem chega SEM saber de quem é
       (notificação antiga, gravada antes da chave);
     · `chatPainelAbrirLojista(uid)` — a conversa, pra quem chega COM a chave.
     Uma função só, com o uid vazio caindo na lista, esconderia no mesmo nome
     dois comportamentos bem diferentes — e é justamente essa diferença que o
     mapa das notificações precisa enxergar.

     ⚠️ `_cpOutroNome` nasce do TÍTULO do aviso ("<Loja> te mandou…"), porque
     a lista de lojas pode ainda não ter carregado quando a conversa abre.
     Cabeçalho genérico com o nome disponível é o tipo de coisa que faz o
     vendedor achar que abriu a conversa errada (a lição da v532).
     ========================================================================== */
  function chatPainelAbrirLojas(){
    chatPainelMontar();
    _cpAba='lojas'; _cpOutro=null; _cpFone=null;
    var p=$('chatPainel'); if(p) p.classList.add('on');
    cpTabsPinta(); cpPinta();
  }
  function chatPainelAbrirLojista(uid, nome){
    var u=String(uid||'').trim();
    if(!u){ chatPainelAbrirLojas(); return; }          /* sem chave, a lista */
    chatPainelMontar();
    _cpAba='lojas'; _cpFone=null;
    _cpOutro=u;
    _cpOutroNome=String(nome||'').trim() || 'Loja';
    var p=$('chatPainel'); if(p) p.classList.add('on');
    try{ cpRepintaZera(); }catch(_){}   /* conversa nova, tela nova (v561) */
    cpTabsPinta(); cpPinta();
  }
  /* ==========================================================================
     v548 — A PORTA DA NOTIFICAÇÃO DO WHATSAPP
     A notificação do sino guarda a conversa em `tipo='zap:<8 dígitos>'` (o
     mesmo truque do 'indicador:' da v457 — o tipo carrega o dado, sem coluna
     nova no banco).

     🔴🔴 MAS 8 DÍGITOS NÃO SERVEM PRA MANDAR MENSAGEM. O servidor põe '55'
     na frente de qualquer número com até 11 dígitos: abrir a conversa com o
     sufixo faria o compositor mirar num telefone que não existe — pior que
     não abrir, porque a mensagem SAIRIA, pra outra pessoa. Então o número
     inteiro vem da lista (a fila do chat, ou o CRM), casando pelos 8 dígitos
     finais, que é o critério que o app inteiro usa.

     ⚠️ E quando não dá pra descobrir o número inteiro, a porta NÃO chuta:
     abre a caixa de entrada com os 8 dígitos já na busca. Um toque a mais,
     nenhuma mensagem no lugar errado. */
  function chatPainelAbrirZap(sig, nome){
    var k=String(sig||'').replace(/\D/g,'').slice(-8);
    if(!k){ chatPainelAbrirClientes(); return; }
    var cheio='';
    function acha(lista){
      try{
        (lista||[]).forEach(function(x){
          if(cheio) return;
          var d=String((x&&x.telefone)||'').replace(/\D/g,'');
          if(d.length>=8 && d.slice(-8)===k) cheio=String(x.telefone||'');
        });
      }catch(_){}
    }
    acha(typeof _chLista!=='undefined' ? _chLista : null);
    if(!cheio) acha(typeof _clientes!=='undefined' ? _clientes : null);
    if(cheio){ chatPainelAbrirCliente(cheio, nome); return; }
    try{ _chBusca=k; }catch(_){}
    chatPainelAbrirClientes();
  }
  function chatPainelFechar(){
    var p=$('chatPainel'); if(p) p.classList.remove('on');
    _cpPararTimer();
    try{ chatBadgeAtualiza(); }catch(_){}
  }
  function _cpPararTimer(){ if(_cpTimer){ clearInterval(_cpTimer); _cpTimer=null; } }

  function cpPinta(){
    _cpPararTimer();
    if(_cpAba==='lojas'){
      if(_cpOutro) cpLojasThread(false); else cpLojasLista();
      return;
    }
    /* ===== v472 (Fase 2) — ABA CLIENTES =================================
       REGRA DE OURO do projeto: NÃO é um canal novo. É a MESMA conversa
       do WhatsApp/atendente que a ficha do CRM mostra (mensagens_whatsapp
       via /api/chat-whatsapp, o _chatApi do 12) — só que acessível de
       qualquer página. Responder daqui = o mesmo efeito da ficha: grava
       'enviada' e a IA silencia 30 min (humano no comando). */
    if(_cpAba==='clientes'){
      if(_cpFone) cpCliThread(false); else cpCliLista();
      return;
    }
    var b=$('cpBody'); if(b) b.innerHTML='<div class="cli-empty" style="padding:16px">Em breve.</div>';
  }

  /* ===== v474 (Fase 3) — ANEXAR VEÍCULOS ================================
     "permita no chat o usuario anexar os proprios veiculos (todos
      incluindo repasse)". O clipe 🚗 no compositor abre a listinha dos
     SEUS veículos (o _estoque inteiro menos os vendidos — os anunciados
     no repasse estão lá dentro), com busca por placa/modelo. Escolheu →
     o texto do carro (nome · ano · km · preço + link público) entra no
     campo de mensagem — você pode escrever junto e mandar. Na conversa,
     mensagens que começam com 🚗 pintam como CARD (negrito + botão "Ver
     o carro"); no WhatsApp do cliente vai como texto+link, como o
     atendente já faz. */
  /* ===== v508 (pedido) — "MELHORE A QUALIDADE DA MENSAGEM QUE VAI DO
     VEÍCULO, MESMO PADRÃO DE QUANDO ENVIA DO CATÁLOGO"

     Existiam DUAS mensagens de carro no app, e a do chat era a pobre:
       · estVeicMsg() (14-estoque.js) — a do compartilhar do estoque e do
         catálogo: 🚗 *nome*, ano · km · cor · combustível, 💰 *preço*,
         ✅ os itens, 📸 "Fotos e ficha completa:" e o link;
       · esta aqui — só nome, ano · km · preço e o link. Sem negrito, sem
         itens, sem cor, sem combustível.
     Agora o chat CHAMA a do catálogo. Não é escrever mensagem nova: é
     parar de ter duas. Mexeu numa, mexeu nas duas.

     ⚠️ O 🚗 CONTINUA SENDO O PRIMEIRO CARACTERE — o estVeicMsg já começa
     com ele. É esse sinal que faz a mensagem virar CARD na conversa
     (v474), e ele está gravado nas mensagens ANTIGAS do banco. Trocar o
     começo apagaria o card de tudo que já foi enviado.
     O typeof-guard mantém a versão curta se um dia o 14 sair do build. */
  function _cpCarroTexto(v){
    try{ if(typeof estVeicMsg==='function'){ var m=estVeicMsg(v); if(m) return m; } }catch(_){}
    var nome=[v.marca,v.modelo].filter(Boolean).join(' ').trim()||'Veículo';
    var l2=[];
    if(v.ano) l2.push(String(v.ano)+(v.ano_modelo?('/'+String(v.ano_modelo)):''));
    if(Number(v.km)) l2.push(Number(v.km).toLocaleString('pt-BR')+' km');
    if(Number(v.preco_anuncio)) l2.push(estMoney(v.preco_anuncio));
    var u=''; try{ u=_publicoVeiculoUrl(v)||''; }catch(_){}
    return '🚗 '+nome+(l2.length?('\n'+l2.join(' · ')):'')+(u?('\n'+u):'');
  }
  /* o *negrito* do WhatsApp vira <b>. Sem isto a mensagem nova apareceria
     COM asteriscos na tela do app — no WhatsApp do cliente eles somem,
     porque lá o asterisco É a marcação de negrito. */
  function _cpNegrito(s){
    return esc(String(s||'')).replace(/\*([^*\n]+)\*/g,'<b>$1</b>');
  }

  /* ===== v560 — O VISOR DE FOTO, DENTRO DO APP ==============================
   * Pedido do Angelo (18/08, com print): *"quando clicar na imagem dentro do
   * chat, não abre em link em outra página, abre dentro do app ampliando na
   * tela"*.
   *
   * A v553 fez a foto aparecer na bolha, mas o toque abria `target="_blank"`.
   * Num app instalado na tela de início isso JOGA O USUÁRIO PRA FORA: abre o
   * Safari, a conversa fica para trás e voltar é uma viagem. Agora a foto
   * abre AQUI, em cima da conversa.
   *
   * ⚠️ SEM history.pushState. O app inteiro não usa histórico do navegador em
   * lugar nenhum (conferido: zero pushState/popstate no código). Ligar o
   * botão "voltar" do Android só neste ponto criaria uma regra que só vale
   * aqui — e regra que só vale num canto é a que quebra depois. Fechar é:
   * tocar fora, tocar no X, ou apertar Esc no computador.
   *
   * ⚠️ O "Abrir original" continua existindo, embaixo. O link da Z-API pode
   * expirar e a foto pode não carregar — o usuário precisa de uma saída que
   * não dependa desta tela.
   * ⛳ VISOR_FOTO = false volta ao comportamento da v553 (abre em outra aba). */
  var VISOR_FOTO = true;
  var _vfUrl='';
  function cpFotoFechar(){
    try{
      var b=document.getElementById('cpVisorFoto');
      if(b) b.parentNode.removeChild(b);
      document.body.classList.remove('cp-visor-on');
    }catch(_){}
    _vfUrl='';
  }
  function cpFotoAbrir(url){
    url=String(url||''); if(!url) return;
    if(!VISOR_FOTO){ try{ window.open(url,'_blank','noopener'); }catch(_){ location.href=url; } return; }
    cpFotoFechar();
    _vfUrl=url;
    var b=document.createElement('div');
    b.id='cpVisorFoto'; b.className='cp-visor';
    b.setAttribute('role','dialog');
    b.setAttribute('aria-label','Foto da conversa');
    b.innerHTML=
      '<button type="button" class="cp-visor-x" id="cpVisorX" aria-label="Fechar a foto">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>'+
      '</button>'+
      '<img id="cpVisorImg" class="cp-visor-img" src="'+esc(url)+'" alt="Foto da conversa">'+
      '<div class="cp-visor-pe">'+
        '<span id="cpVisorDica">Toque na foto para ampliar · toque fora para fechar</span>'+
        '<a id="cpVisorFora" href="'+esc(url)+'" target="_blank" rel="noopener">Abrir original ↗</a>'+
      '</div>';
    document.body.appendChild(b);
    document.body.classList.add('cp-visor-on');
    /* foto que não carrega (link da Z-API vencido) não pode virar tela preta muda */
    var img=document.getElementById('cpVisorImg');
    if(img) img.onerror=function(){
      var d=document.getElementById('cpVisorDica');
      if(d) d.textContent='Esta foto não está mais disponível no servidor do WhatsApp.';
      try{ img.style.display='none'; }catch(_){}
    };
    /* tocar NA foto amplia; tocar FORA fecha */
    if(img) img.onclick=function(e){ e.stopPropagation(); b.classList.toggle('zoom'); };
    b.onclick=function(e){ if(e.target===b) cpFotoFechar(); };
    var x=document.getElementById('cpVisorX');
    if(x) x.onclick=function(e){ e.stopPropagation(); cpFotoFechar(); };
    var pe=b.querySelector('.cp-visor-pe');
    if(pe) pe.onclick=function(e){ e.stopPropagation(); };
  }
  /* ===== v561 — O CHAT PARA DE ROLAR SOZINHO ===============================
   * Pedido do Angelo (18/08, com print): *"o chat fica fazendo scroll
   * sozinho, deixa na última mensagem, até ao digitar, não faz scroll
   * sozinho"*.
   *
   * 🔴 A CAUSA (e é antiga, das duas abas): de 8 em 8 segundos a conversa
   * refazia a lista INTEIRA com `innerHTML = …`, mesmo quando NADA tinha
   * mudado. Trocar o innerHTML zera o `scrollTop`. Aí:
   *   · se você estava no fim, ele voltava pro fim — mas as fotos
   *     `loading="lazy"` nasciam de novo e empurravam a tela na sua cara;
   *   · se você tinha SUBIDO pra reler alguma coisa, o `noFim` dava falso,
   *     ninguém devolvia a posição e a conversa **pulava pro TOPO**.
   *     É esse o pulo do print — e ele acontecia a cada 8 segundos.
   *
   * A correção tem três partes, e a primeira sozinha já resolve quase tudo:
   *   1. 🔴 SÓ REPINTA SE MUDOU. Comparo o HTML que ia pintar com o que já
   *      está na tela. Conversa parada = DOM intocado = nada se mexe. De
   *      quebra, as fotos param de recarregar a cada 8s.
   *   2. quando repinta e você NÃO estava no fim, devolvo a mesma
   *      DISTÂNCIA DO FIM — você continua olhando a mesma mensagem, mesmo
   *      que uma mensagem nova tenha entrado embaixo.
   *   3. enquanto você DIGITA, ninguém mexe na rolagem.
   *
   * ⚠️ Abrir a conversa continua caindo na ÚLTIMA mensagem — isso é o
   * `silencioso=false`, e é o único momento em que a rolagem é forçada.
   * ⚠️ Mandar uma mensagem também desce (quem chama é o `cpCliEnviar` /
   * `cpLojasEnviar`): ver a própria mensagem sair é o esperado.
   * ⛳ CHAT_ROLAGEM_CALMA=false volta ao comportamento antigo, numa linha.
   * ========================================================================= */
  var CHAT_ROLAGEM_CALMA = true;
  var _cpPintado = '';          /* o HTML que está na tela agora */

  /* "digitando" é o dedo no compositor OU texto começado nele. Os dois
     contam: no celular a pessoa escreve, olha a conversa e volta — e uma
     rolagem no meio disso perde o lugar dela. */
  function _cpDigitando(){
    try{
      var i=document.getElementById('cpIn');
      if(!i) return false;
      return (document.activeElement===i) || !!String(i.value||'').trim();
    }catch(_){ return false; }
  }

  /* ⚠️ Foto que chega DEPOIS empurra a conversa pra baixo. Se a gente
     acabou de ancorar no fim, volta pro fim quando ela terminar de
     carregar — mas só se ainda estivermos por perto do fim, senão eu
     roubaria a tela de quem subiu pra reler nesse meio tempo. */
  function _cpFotosAncora(box){
    try{
      Array.prototype.forEach.call(box.querySelectorAll('img'), function(im){
        if(im.complete || im._cpAnc) return;
        im._cpAnc = 1;
        im.addEventListener('load', function(){
          try{
            if(_cpDigitando()) return;
            if(box.scrollTop + box.clientHeight < box.scrollHeight - 400) return;
            box.scrollTop = box.scrollHeight;
          }catch(_){}
        }, { once:true });
      });
    }catch(_){}
  }

  /* O ÚNICO lugar que escreve na conversa. As duas abas passam por aqui. */
  function cpRepinta(box, html, silencioso){
    if(!box) return;
    if(!CHAT_ROLAGEM_CALMA){                       /* ⛳ o jeito de antes */
      var nf=box.scrollTop+box.clientHeight>=box.scrollHeight-60;
      box.innerHTML=html; _cpPintado=html;
      if(nf||!silencioso) box.scrollTop=box.scrollHeight;
      return;
    }
    if(silencioso && html===_cpPintado) return;    /* 🔴 nada mudou: não toca */
    var noFim   = box.scrollTop + box.clientHeight >= box.scrollHeight - 60;
    var doFim   = box.scrollHeight - box.scrollTop;  /* pra devolver o lugar */
    var topAntes= box.scrollTop;
    box.innerHTML = html;
    _cpPintado   = html;
    if(!silencioso){                               /* abriu: última mensagem */
      box.scrollTop = box.scrollHeight;
      _cpFotosAncora(box);
    } else if(_cpDigitando()){
      /* 🔴 DIGITANDO: congela no lugar EXATO (scrollTop absoluto), não na
         distância do fim. Quem está no fim e escrevendo tem distância zero —
         "manter a distância" ali significaria descer atrás de cada mensagem
         nova, que é justamente o que o Angelo pediu pra não fazer. */
      box.scrollTop = topAntes;
    } else if(noFim){                              /* estava no fim: segue */
      box.scrollTop = box.scrollHeight;
      _cpFotosAncora(box);
    } else {                                       /* estava lendo: fica */
      box.scrollTop = Math.max(0, box.scrollHeight - doFim);
    }
  }
  /* trocou de conversa (ou de aba) ⇒ o que está pintado não vale mais */
  function cpRepintaZera(){ _cpPintado=''; }

  /* Liga o toque das fotos da conversa. Um ouvinte SÓ, no #cpTh — as bolhas
     são reescritas a cada atualização (innerHTML), então pendurar ouvinte em
     cada foto vazaria um por atualização. As duas abas (Lojas e Clientes)
     usam o mesmo #cpTh, então este ouvinte serve às duas. */
  function cpFotoLigar(box){
    if(!box) return;
    box.onclick=function(e){
      var alvo=e.target;
      var el=(alvo && alvo.closest) ? alvo.closest('[data-foto]') : null;
      if(!el) return;
      var u=el.getAttribute('data-foto'); if(!u) return;
      e.preventDefault(); e.stopPropagation();
      cpFotoAbrir(u);
    };
  }
  /* Esc fecha (computador). Um ouvinte só, ligado uma vez. */
  try{
    document.addEventListener('keydown', function(e){
      if((e.key==='Escape'||e.keyCode===27) && document.getElementById('cpVisorFoto')) cpFotoFechar();
    });
  }catch(_){}
  try{ window.cpFotoAbrir=cpFotoAbrir; window.cpFotoFechar=cpFotoFechar; }catch(_){}
  /* v547 — a foto de capa entra DENTRO do card do carro (pedido: "adiciona
     a foto de capa do veiculo na mensagem que vai pro cliente de dentro do
     chat"). Ela chega pelo `midia_url` da linha, gravado no envio.
     ⚠️ Só no card: numa mensagem comum a foto continua sendo o link
     "[foto]" de sempre — inventar duas caras pro mesmo anexo é ruído. */
  function _cpBolhaHtml(texto, foto){
    var t=String(texto||'');
    if(t.indexOf('🚗')!==0) return esc(t);
    var ls=t.split('\n');
    /* ⚠️ v508 — o desenho do card acompanhou a mensagem nova. Cada linha
       tem um papel; as VAZIAS (que no WhatsApp são respiro) virariam
       <span> vazio e abririam buracos no card se eu não pulasse aqui. */
    var titulo=String(ls[0]||'').replace(/^🚗\s*/,'');
    var itens=[], corpo='', link='';
    ls.slice(1).forEach(function(l){
      l=String(l).trim();
      if(!l) return;                                    /* respiro do WhatsApp */
      if(/^https?:\/\//.test(l)){ link=l; return; }
      if(l.indexOf('✅')===0){ itens.push(l.replace(/^✅\s*/,'')); return; }
      if(l.indexOf('📸')===0) return;                   /* o rótulo vira o botão */
      corpo+='<span class="cp-car-l2">'+_cpNegrito(l)+'</span>';
    });
    return '<span class="cp-car">'+
      /* v560: a capa do card também amplia no visor (data-foto) — é uma
         foto dentro do chat como qualquer outra. O "Ver o carro" continua
         sendo o botão que leva pra página do veículo. */
      (foto?('<img class="cp-car-foto" src="'+esc(foto)+'" alt="" loading="lazy" data-foto="'+esc(foto)+'">'):'')+
      '<b>'+_cpNegrito(titulo)+'</b>'+corpo+
      (itens.length?('<span class="cp-car-itens">'+itens.map(function(x){
        return '<i>'+esc(x)+'</i>'; }).join('')+'</span>'):'')+
      (link?('<a class="cp-car-link" href="'+esc(link)+'" target="_blank" rel="noopener">Ver o carro ↗</a>'):'')+
      '</span>';
  }
  /* ===== v487 — O "+" DO COMPOSITOR (PROJETO-botao-mais-chat) ============
     Sai o emoji 🚗 do botão (emoji não é ícone: muda por aparelho, não
     aceita cor nem estado — padroes/ICONES-SVG.md), entra o "+" SVG
     redondo do MEV Tools: clicou, gira 45° (vira "x") e abre um MENU com
     as ações que FUNCIONAM hoje — Anexar veículo (o mesmo cpAnexoAbrir da
     v474) e Enviar link do catálogo (ljLinks, o mesmo do Meu site).
     "Anexar arquivo" fica pra fase 2 (precisa de upload) — nada de item
     cinza "em breve". O menu nasce DENTRO do .cp-box (dois flutuantes
     empilhados dão briga de z-index). O SINAL 🚗 no TEXTO da mensagem não
     muda — é ele que pinta o card da v474 (banco intacto). */
  /* v509 — os tracinhos. SVG, não caractere: o "✓✓" muda de desenho em cada
     aparelho e não aceita cor (padroes/ICONES-SVG.md). Um tracinho = enviada,
     dois = lida (e aí ficam azuis pela classe .lida). */
  var CP_TIC1='<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 8.5l3 3 8-8"/></svg>';
  var CP_TIC2='<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 8.5l3 3 6.5-6.5"/><path d="M6 11.5l1.5 1.5L15 5.5"/></svg>';
  var CP_MAIS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var CP_I_CARRO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';
  /* v538 — o balãozinho com linhas: "texto pronto" */
  var CP_I_RESP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.3 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8A8.4 8.4 0 0 1 12.5 3 8.4 8.4 0 0 1 21 11.5z"/><path d="M8.5 10h8"/><path d="M8.5 13.5h5"/></svg>';
  var CP_I_LINK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
  /* v555 — a faísca: "a IA escreve por mim" (SVG, nunca emoji — padrão) */
  var CP_I_IA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.7 4.6L18.3 9l-4.6 1.7L12 15.3l-1.7-4.6L5.7 9l4.6-1.4L12 3z"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14z"/></svg>';
  /* ⛳ v555 — o item "Sugerir resposta com IA" no menu "+". */
  var SUGERIR_IA_ON = true;
  var _cpMaisFora=null;
  function cpMaisFechar(){
    var m=$('cpMaisMenu'); if(m){ try{ m.remove(); }catch(_){} }
    var b=$('cpClip'); if(b){ b.classList.remove('on'); b.setAttribute('aria-expanded','false'); }
    if(_cpMaisFora){ document.removeEventListener('click',_cpMaisFora,true); _cpMaisFora=null; }
    document.removeEventListener('keydown',_cpMaisEsc,true);
  }
  function _cpMaisEsc(e){
    /* Esc fecha SÓ o menu (captura + stopPropagation: o Esc do painel,
       linha ~55, não pode fechar o chat inteiro junto) */
    if(e.key==='Escape'){ e.stopPropagation(); cpMaisFechar(); }
  }
  function cpMaisAbrir(){
    if($('cpMaisMenu')){ cpMaisFechar(); return; }
    var box=document.querySelector('#chatPainel .cp-box'); if(!box) return;
    var pk=$('cpPick'); if(pk){ try{ pk.remove(); }catch(_){} }
    var m=document.createElement('div'); m.id='cpMaisMenu'; m.className='cp-mais-menu';
    m.innerHTML=
      '<button type="button" class="cp-mm-it" id="cpMmVeic">'+CP_I_CARRO+'<span>Anexar veículo</span></button>'+
      '<button type="button" class="cp-mm-it" id="cpMmCat">'+CP_I_LINK+'<span>Enviar link do catálogo</span></button>'+
      /* ⛳ v538 (pedido): "vai morar dentro do + no chat". Este menu já é "o
         que eu ponho nesta mensagem" — resposta pronta é exatamente isso. */
      (RESP_PADRAO_ON ? ('<button type="button" class="cp-mm-it" id="cpMmResp">'+CP_I_RESP+'<span>Respostas padrão</span></button>') : '')+
      /* ⛳ v555 (pedido): "adicione nessa lista, sugerir resposta com ia" —
         a IA lê a conversa e o texto cai no COMPOSITOR, pra editar. Quem
         envia continua sendo o Angelo (e as travas do servidor). */
      (SUGERIR_IA_ON ? ('<button type="button" class="cp-mm-it" id="cpMmIa">'+CP_I_IA+'<span>Sugerir resposta com IA</span></button>') : '');
    box.appendChild(m);
    var b=$('cpClip'); if(b){ b.classList.add('on'); b.setAttribute('aria-expanded','true'); }
    $('cpMmVeic').onclick=function(){ cpMaisFechar(); cpAnexoAbrir(); };
    $('cpMmCat').onclick=function(){
      cpMaisFechar();
      var u=''; try{ var L=ljLinks(_lojaRec||null); u=(L&&L.cat)||''; }catch(_){}
      if(!u){ try{ toast('Não achei o link do catálogo — abra a Minha loja uma vez.'); }catch(_){} return; }
      var inp=$('cpIn');
      if(inp){ inp.value=(inp.value?inp.value.replace(/\s+$/,'')+'\n':'')+'Dá uma olhada no nosso catálogo: '+u; try{ inp.focus(); }catch(_){} }
    };
    var _br=$('cpMmResp'); if(_br) _br.onclick=function(){ cpMaisFechar(); cpRespAbrir(); };
    var _bi=$('cpMmIa'); if(_bi) _bi.onclick=function(){ cpMaisFechar(); cpSugerirIa(); };
    _cpMaisFora=function(e){
      var t=e.target;
      if(t&&t.closest&&(t.closest('#cpMaisMenu')||t.closest('#cpClip'))) return;
      cpMaisFechar();
    };
    document.addEventListener('click',_cpMaisFora,true);
    document.addEventListener('keydown',_cpMaisEsc,true);
  }
  function cpMaisWire(){
    /* trocar de conversa/aba reconstrói o cpBody, mas o menu mora no
       .cp-box (irmão) — sem esta linha ele ficava ÓRFÃO, aberto por cima
       do compositor novo (o teste pegou). */
    cpMaisFechar();
    var b=$('cpClip'); if(b) b.onclick=cpMaisAbrir;
  }

  /* ===== v555 — SUGERIR RESPOSTA COM IA ==================================
     A IA (no SERVIDOR — a chave nunca vem pro navegador) lê a conversa e
     devolve UMA mensagem pronta, que cai aqui no compositor pra EDITAR.
     🔴 Ela NUNCA envia: apertar o aviãozinho continua sendo do Angelo, e o
     envio passa pelas mesmas travas de sempre (v510/v529/v542/v546).
     ⚠️ Se já tem texto escrito no campo, a sugestão NÃO passa por cima —
     texto digitado é trabalho do usuário, e sumir com ele é o tipo de
     surpresa que faz desligar a função. */
  var _cpSugindo=false;
  async function cpSugerirIa(){
    if(!_cpFone || _cpSugindo) return;
    var inp=$('cpIn'); if(!inp) return;
    if(String(inp.value||'').trim()){
      toast('Já tem texto no campo — envie ou apague antes de pedir a sugestão.');
      return;
    }
    _cpSugindo=true;
    var phAntes=inp.placeholder;
    inp.disabled=true; inp.placeholder='A IA está lendo a conversa…';
    var r=null;
    try{ r=await _chatApi({acao:'sugerir',telefone:_cpFone}); }catch(_){ r=null; }
    inp.disabled=false; inp.placeholder=phAntes; _cpSugindo=false;
    if(r && r.ok && r.sugestao){
      inp.value=String(r.sugestao);
      try{ inp.focus(); }catch(_){}
      toast('Sugestão pronta — revise antes de enviar.');
    } else {
      toast((r&&r.erro)||'Não consegui sugerir agora. Tente de novo.');
    }
  }

  async function cpAnexoAbrir(){
    var box=document.querySelector('#chatPainel .cp-box'); if(!box) return;
    if($('cpPick')) { try{ $('cpPick').remove(); }catch(_){} return; }
    var d=document.createElement('div'); d.id='cpPick';
    d.innerHTML='<div class="cp-pk-hd"><b>Anexar veículo</b><button type="button" class="cp-x" id="cpPkX">&times;</button></div>'+
      '<div class="cli-search busca-lupa">'+_icoBusca+'<input class="cad-in" id="cpPkBusca" type="search" aria-label="Buscar placa ou modelo" placeholder="Placa ou modelo" autocomplete="off"></div>'+
      '<div class="cp-pk-lista" id="cpPkLista"><div class="cli-empty" style="padding:12px">Carregando seus veículos…</div></div>';
    box.appendChild(d);
    $('cpPkX').onclick=function(){ try{ d.remove(); }catch(_){} };
    if(!(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} }
    var veics=(_estoque||[]).filter(function(v){ return String(v.status||'disponivel')!=='vendido'; });
    function pinta(){
      var el=$('cpPkLista'); if(!el) return;
      var q=String(($('cpPkBusca')||{}).value||'').trim().toLowerCase();
      var lista=veics.filter(function(v){
        if(!q) return true;
        return ((String(v.placa||'')+' '+String(v.marca||'')+' '+String(v.modelo||'')).toLowerCase().indexOf(q)>=0);
      });
      if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:12px"><b>Nenhum veículo</b>'+(q?'Nada com esse termo.':'Cadastre um carro no Estoque primeiro.')+'</div>'; return; }
      el.innerHTML=lista.slice(0,60).map(function(v){
        var foto=(Array.isArray(v.fotos)&&v.fotos[0])?('<img src="'+esc(v.fotos[0])+'" alt="" loading="lazy">'):'<span class="cp-pk-sem">🚗</span>';
        var nome=[v.marca,v.modelo].filter(Boolean).join(' ').trim()||'Veículo';
        return '<button type="button" class="cp-pk-it" data-cp-vx="'+esc(String(v.id))+'">'+
          '<span class="cp-pk-th">'+foto+'</span>'+
          '<span class="cp-cv-tx"><b>'+esc(nome)+'</b><i>'+esc(String(v.placa||'').toUpperCase())+(Number(v.preco_anuncio)?(' · '+estMoney(v.preco_anuncio)):'')+'</i></span>'+
        '</button>';
      }).join('');
      Array.prototype.forEach.call(el.querySelectorAll('[data-cp-vx]'),function(b){
        b.onclick=function(){
          var v=veics.filter(function(x){ return String(x.id)===String(b.getAttribute('data-cp-vx')); })[0];
          if(!v) return;
          var inp=$('cpIn');
          if(inp){
            var txt=_cpCarroTexto(v);
            /* 🔴 v547 — a capa vai JUNTO com o texto, numa mensagem só.
               ⚠️ A URL ORIGINAL, não a do redimensionador (`imgCdn`): quem
               vai buscar a foto é a Z-API, do lado de fora do navegador.
               ⚠️ E é o servidor quem confere se este endereço pode ser
               enviado — aqui é só a sugestão. */
            try{ _cpFotoAnexo=(Array.isArray(v.fotos)&&v.fotos[0])?String(v.fotos[0]):''; }catch(_){ _cpFotoAnexo=''; }
            inp.value=(inp.value?inp.value.replace(/\s+$/,'')+'\n':'')+txt;
            try{ inp.focus(); }catch(_){}
          }
          try{ d.remove(); }catch(_){}
        };
      });
    }
    $('cpPkBusca').oninput=pinta;
    pinta();
  }

  /* ================= ABA LOJAS (o motor v325, dentro do painel) ============ */
  async function cpLojasLista(){
    var body=$('cpBody'); if(!body) return;
    /* v531: a mesma animação da aba Clientes — uma função só, pra que as
       duas abas nunca divirjam no jeito de esperar */
    body.innerHTML=cpLoadHtml(); cpLoadGira();
    var uid=await clMeuId();
    var msgs=[], membros=[];
    try{
      var r=await supa.from('chat_lojista').select('de_user,para_user,texto,lida,criado_em')
        .order('criado_em',{ascending:false}).limit(400);
      msgs=(r&&r.data)||[];
    }catch(_){}
    try{
      /* v478 (pedido do Angelo: "permita escolher um usuário") — o diretório
         deixou de ser só quem é membro ATIVO do portal de repasse (quase
         ninguém) e virou TODAS as contas do app, pela mp_chat_diretorio
         (SECURITY DEFINER, saída fechada: user_id + melhor nome + cidade/uf
         — nunca e-mail inteiro nem telefone). O RLS do envio acompanhou. */
      var rm=await supa.rpc('mp_chat_diretorio');
      var dm=(rm&&!rm.error)?rm.data:[];
      if(typeof dm==='string'){ try{ dm=JSON.parse(dm||'[]'); }catch(_){ dm=[]; } }
      membros=Array.isArray(dm)?dm:[];
    }catch(_){}
    body=$('cpBody'); if(!body || _cpAba!=='lojas' || _cpOutro) return;
    var nomeDe={}; membros.forEach(function(m){ nomeDe[m.user_id]=m.loja_nome||'Loja'; });
    /* v514 — a conversa COMIGO MESMO tem nome. Ela nasce do modo de teste do
       "Avisar lojistas" (18f), que manda tudo pra quem está testando; o
       diretório nunca devolve a própria conta, então sem esta linha o
       ensaio aparecia como "Loja parceira" e parecia mensagem de estranho. */
    if(uid) nomeDe[uid]='Você (teste)';
    var conv={}, ordem=[];
    msgs.forEach(function(m){
      var outro=(m.de_user===uid)?m.para_user:m.de_user;
      if(!conv[outro]){ conv[outro]={ultimo:m,naoLidas:0}; ordem.push(outro); }
      if(m.para_user===uid && m.lida===false) conv[outro].naoLidas++;
    });
    var h='';
    if(ordem.length){
      h+=ordem.map(function(o){
        var c=conv[o], eu=c.ultimo.de_user===uid;
        return '<button type="button" class="cp-conv" data-cp-abre="'+esc(o)+'" data-cp-nome="'+esc(nomeDe[o]||'Loja parceira')+'">'+
          '<span class="cp-cv-tx"><b>'+esc(nomeDe[o]||'Loja parceira')+'</b>'+
          '<i>'+(eu?'Você: ':'')+esc(String(c.ultimo.texto||'').slice(0,58))+'</i></span>'+
          (c.naoLidas?('<span class="cp-nn">'+c.naoLidas+'</span>'):'')+
        '</button>';
      }).join('');
    } else {
      h+='<div class="cli-empty" style="padding:14px;margin-bottom:8px"><b>Nenhuma conversa ainda</b>Escolha uma loja abaixo e mande a primeira mensagem.</div>';
    }
    var outros=membros.filter(function(m){ return m.user_id!==uid && !conv[m.user_id]; });
    if(outros.length){
      h+='<div class="cp-sec">PUXAR CONVERSA COM</div>';
      /* v478: com o diretório completo, uma busca ajuda a achar a conta */
      if(outros.length>5) h+='<div class="cli-search busca-lupa cp-dir-busca-wrap">'+_icoBusca+'<input type="search" class="cad-in cp-dir-busca" id="cpDirBusca" aria-label="Buscar usuário" placeholder="Buscar usuário…" autocomplete="off"></div>';
      h+=outros.map(function(m){
        var onde=[m.cidade,m.uf].filter(Boolean).join('/');
        return '<button type="button" class="cp-conv nova" data-cp-abre="'+esc(m.user_id)+'" data-cp-nome="'+esc(m.loja_nome||'Loja')+'">'+
          '<span class="cp-cv-tx"><b>'+esc(m.loja_nome||'Loja')+'</b>'+(onde?('<i>'+esc(onde)+'</i>'):'')+'</span>'+
          '<span class="cp-vai">Conversar</span>'+
        '</button>';
      }).join('');
    }
    if(!h) h='<div class="cli-empty" style="padding:16px"><b>Nenhum outro usuário ainda</b>Quando mais contas entrarem no MEV, elas aparecem aqui.</div>';
    body.innerHTML=h;
    var bd=$('cpDirBusca');
    if(bd) bd.oninput=function(){
      var q=String(bd.value||'').toLowerCase();
      Array.prototype.forEach.call(body.querySelectorAll('.cp-conv.nova'),function(b){
        b.style.display=(!q || (b.getAttribute('data-cp-nome')||'').toLowerCase().indexOf(q)>=0)?'':'none';
      });
    };
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-abre]'),function(b){
      b.onclick=function(){
        _cpOutro=b.getAttribute('data-cp-abre');
        _cpOutroNome=b.getAttribute('data-cp-nome')||'Loja';
        cpPinta();
      };
    });
  }

  async function cpLojasThread(silencioso){
    var body=$('cpBody'); if(!body || !_cpOutro) return;
    if(!silencioso){
      body.innerHTML='<div class="cp-th-hd"><button type="button" class="cp-volta" id="cpVolta">&#8249;</button><b>'+esc(_cpOutroNome)+'</b></div>'+
        '<div class="cp-th" id="cpTh"><div class="cli-empty" style="padding:12px">Carregando…</div></div>'+
        '<div class="cp-comp"><button type="button" class="cp-clip" id="cpClip" aria-label="Mais ações" aria-expanded="false" title="Mais ações">'+CP_MAIS+'</button><textarea class="cad-in" id="cpIn" rows="1" placeholder="Escreva sua mensagem…"></textarea>'+
        '<button type="button" class="crm-send" id="cpSend" title="Enviar">'+_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>';
      $('cpVolta').onclick=function(){ _cpOutro=null; cpRepintaZera(); cpPinta(); };
      cpMaisWire();
      $('cpSend').onclick=cpLojasEnviar;
      cpRepintaZera();   /* v561: conversa nova, tela nova — pode pintar */
      var inp=$('cpIn');
      inp.addEventListener('keydown',function(e){ if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); cpLojasEnviar(); } });
      _cpPararTimer();
      _cpTimer=setInterval(function(){
        if(document.getElementById('cpTh')) cpLojasThread(true); else _cpPararTimer();
      },8000);
    }
    var box=$('cpTh'); if(!box) return;
    var uid=await clMeuId();
    var msgs=[];
    try{
      /* v560: midia_url/midia_tipo entram aqui — sem elas a capa existiria no
         banco e a tela nunca saberia. */
      var r=await supa.from('chat_lojista').select('id,de_user,para_user,texto,lida,criado_em,midia_url,midia_tipo')
        .or('de_user.eq.'+_cpOutro+',para_user.eq.'+_cpOutro)
        .order('criado_em',{ascending:true}).limit(300);
      msgs=((r&&r.data)||[]).filter(function(m){
        return (m.de_user===uid&&m.para_user===_cpOutro)||(m.de_user===_cpOutro&&m.para_user===uid);
      });
    }catch(_){ if(!silencioso) box.innerHTML='<div class="cli-empty" style="padding:12px">Não consegui carregar. Tente de novo.</div>'; return; }
    box=$('cpTh'); if(!box) return;
    if(!msgs.length){
      cpRepinta(box, '<div class="cli-empty" style="padding:12px">Nenhuma mensagem ainda. Quebre o gelo. 🙂</div>', silencioso);
    }
    else{
      cpRepinta(box, msgs.map(function(m){
        var eu=m.de_user===uid;
        var dt=new Date(m.criado_em), hh=('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
        /* ===== v509 (pedido) — OS TRACINHOS DE LEITURA, IGUAL AO WHATSAPP
           Só nas MINHAS mensagens: um tracinho = saiu daqui, dois azuis =
           o outro lado abriu. O dado já existia e já vinha nesta mesma
           consulta — é a coluna `lida`, a mesma que conta as não-lidas do
           balão desde a v325. Não precisou de banco nem de consulta nova:
           só faltava mostrar.
           ⚠️ Nas mensagens DELE não entra tracinho: ali quem leu fui eu, e
           o WhatsApp também não mostra. */
        var tic=eu?('<em class="cp-tic'+(m.lida?' lida':'')+'" aria-label="'+(m.lida?'lida':'enviada')+'">'+
                    (m.lida?CP_TIC2:CP_TIC1)+'</em>'):'';
        /* v560: a capa entra DENTRO do card do carro, igual à aba Clientes
           (v547). Fora do card não há foto nesta aba — aqui não existe
           anexo solto como no WhatsApp. */
        var ehCard=(String(m.texto||'').indexOf('🚗')===0);
        var capa=(ehCard && m.midia_tipo==='image') ? (m.midia_url||'') : '';
        return '<div class="cp-b '+(eu?'eu':'ele')+'">'+_cpBolhaHtml(m.texto, capa)+'<i>'+hh+tic+'</i></div>';
      }).join(''), silencioso);   /* v561: só repinta se mudou */
    }
    cpFotoLigar(box);   /* v560: o toque na foto abre o visor, não outra aba */
    try{
      await supa.from('chat_lojista').update({lida:true})
        .eq('para_user',uid).eq('de_user',_cpOutro).eq('lida',false);
    }catch(_){}
  }

  /* ===== v560 — A CAPA DO CARRO NO CARD DO LOJISTA ==========================
     Pedido do Angelo (18/08, com print da conversa com o douglas_tpw_):
     *"mensagem que vai pro lojista, já coloque a foto de capa…"*.

     🔴 POR QUE FALTAVA: a `mp_chat_lojista` não tinha coluna de mídia
     NENHUMA (conferido no banco em 18/08). A aba Clientes tinha, e é por
     isso que lá a capa aparecia desde a v547 e aqui não. A v560 acrescentou
     `midia_url` e `midia_tipo` — duas colunas novas e opcionais; as policies
     são por LINHA (de_user/para_user), não por coluna, então nada mudou de
     permissão.

     ⚠️ REDE DE SEGURANÇA: se o app subir ANTES da migração ter rodado (ou
     alguém rodar este código contra um banco antigo), o PostgREST recusa a
     coluna que não existe e o envio inteiro falharia — a pessoa não
     conseguiria mais mandar mensagem nenhuma. Por isso, se o envio COM foto
     falhar, ele repete SEM foto na hora. Perde-se a capa, nunca a mensagem.
     ⛳ CAPA_CHAT_LOJA = false volta ao comportamento da v559. */
  var CAPA_CHAT_LOJA = true;
  async function cpLojasEnviar(){
    var inp=$('cpIn'); if(!inp || !_cpOutro) return;
    var t=String(inp.value||'').trim(); if(!t) return;
    var uid=await clMeuId(); if(!uid) return;
    inp.disabled=true;
    try{
      var _base={ de_user:uid, para_user:_cpOutro, texto:t.slice(0,2000) };
      /* 🔴 a mesma conferência da v547: a capa só acompanha se o texto AINDA
         for o do carro (o 🚗 é o sinal que vira card, v474). Anexar um
         veículo, apagar tudo e escrever outra coisa não pode mandar a foto
         de um carro colada numa mensagem que não fala dele. */
      var _foto=(CAPA_CHAT_LOJA && _cpFotoAnexo && t.indexOf('🚗')>=0) ? String(_cpFotoAnexo) : '';
      var _linha=_foto ? { de_user:_base.de_user, para_user:_base.para_user, texto:_base.texto,
                           midia_url:_foto, midia_tipo:'image' } : _base;
      var r=await supa.from('chat_lojista').insert(_linha);
      if(r&&r.error && _foto){
        try{ console.warn('[chat interno] sem coluna de mídia? mando sem a capa:', r.error); }catch(_){}
        r=await supa.from('chat_lojista').insert(_base);
      }
      if(r&&r.error) throw r.error;
      _cpFotoAnexo='';                  /* v560: a capa vale por UM envio (v547) */
      inp.value='';
      /* v473 — avisa o outro lado (push + sino). Fire-and-forget: se a
         function ainda não subiu (pré-deploy) ou a rede falhar, a mensagem
         JÁ está no banco — o aviso é cortesia, nunca trava o envio. */
      try{
        fetch('/api/chat-aviso',{ method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({ token:token, para_user:_cpOutro, texto:t.slice(0,80) }) })['catch'](function(){});
      }catch(_){}
      await cpLojasThread(true);
      var bx=$('cpTh'); if(bx) bx.scrollTop=bx.scrollHeight;
    }catch(e){
      /* 15/08 — o toast mudo escondia a causa (404 de tabela, 401 de sessão,
         403 de RLS). Agora mostra o motivo e deixa o detalhe no console.
         Foi o aviso mudo que segurou o diagnóstico do chat_lojista sem mp_. */
      var _m = (e && (e.message || e.details || e.hint || e.code)) || '';
      try{ console.error('[chat interno] envio falhou:', e); }catch(_){}
      toast('Não consegui enviar.' + (_m ? (' ' + String(_m).slice(0,120)) : ' Tente de novo.'));
    }
    inp.disabled=false;
    try{ inp.focus(); }catch(_){}
  }

  /* ================= ABA CLIENTES (v472 — o mesmo canal do CRM) ============ */
  /* v532 — o nome de quem tem só o telefone.
     ⚠️ Casa pelos 8 ÚLTIMOS DÍGITOS, que é a regra do app inteiro: o mesmo
     número aparece como 5551999990001, +55 51 99999-0001 e 999990001
     dependendo de quem cadastrou. Comparar a string toda erraria a maioria.
     ⚠️ E não vai ao banco: se a `_clientes` ainda não chegou, devolve o
     número formatado e pronto. Buscar aqui atrasaria a abertura da conversa,
     que é justamente o que esta função existe pra acelerar. */
  function _cpNomePeloFone(d){
    try{
      var suf=String(d||'').replace(/\D/g,''); if(suf.length<8) return '';
      suf=suf.slice(-8);
      var achou=(_clientes||[]).filter(function(c){
        var t=String((c&&c.telefone)||'').replace(/\D/g,'');
        return t.length>=8 && t.slice(-8)===suf;
      })[0];
      if(achou && achou.nome) return achou.nome;
    }catch(_){}
    return _cpFoneFmt(d);
  }
  function _cpFoneFmt(f){
    var d=String(f||'').replace(/\D/g,'');
    if(d.length>=12) return '('+d.slice(2,4)+') '+d.slice(4,9)+'-'+d.slice(9,13);
    if(d.length>=10) return '('+d.slice(0,2)+') '+d.slice(2,d.length-4)+'-'+d.slice(-4);
    return f||'';
  }
  /* ======================================================================
     v523 — A ABA CLIENTES VIRA CAIXA DE ENTRADA
     (PROJETO-uma-caixa-de-entrada-so, Parte 1)

     COMO ERA: lista corrida. Sem fila, sem tempo de espera, sem filtro,
     sem busca. Nome, prévia e bolinha — e só. A página Chat tinha tudo
     isso; o balão, que é a porta que existe em TODA página, era a porta
     pobre. Duas listas da mesma coisa, com qualidades diferentes.

     🔑 A REGRA DESTE PROJETO: **NÃO REESCREVER — CHAMAR.**
     `_chFiltra`, `_chConta`, `_chEsperaSelo`, `_chHora`, `_chCliente`,
     `_chSuf` e `CH_FILTROS` já existem, prontos e testados, no 12d. Aqui
     não nasceu nenhuma regra nova de fila: nasceu um DESENHO estreito pros
     mesmos números. Mexeu na regra, mexeu nas duas telas.

     ⚠️ ORDEM DE MONTAGEM: o 10c é concatenado ANTES do 12d. Por isso toda
     chamada ao motor acontece DENTRO das funções (em tempo de execução,
     quando tudo já rodou) e com typeof-guard — nunca no corpo do módulo.
     É o mesmo cuidado que o `_cpCarroTexto` toma com o `estVeicMsg` do 14.
     ====================================================================== */
  function _cpMotorOk(){ return (typeof _chFiltra==='function' && typeof CH_FILTROS!=='undefined'); }

  /* ======================================================================
     v531 (pedido) — "TA DEMORANDO PRA CARREGAR, VERIFIQUE E SE PRECISAR
     COLOQUE UMA ANIMAÇÃO PADRÃO COM ÍCONE DE CLIENTES E FRASES PERTINENTES"

     🔴 VERIFIQUEI ANTES DE MAQUIAR — e o "Carregando…" seco não era o
     problema, era o sintoma. A v523 deixou DUAS consultas EM FILA:

         await cliCarregar()   → as 107 fichas do CRM
         await chCarregar()    → as conversas + as 208 mensagens

     Uma esperava a outra terminar pra só então começar. Somadas, é o dobro
     do tempo de espera da mais lenta — e o painel abre de QUALQUER página,
     inclusive das que nunca carregaram o CRM, então quase sempre as duas
     rodavam de verdade.

     TRÊS CONSERTOS, nesta ordem de importância:

     1. 🔴 **AS DUAS AGORA VÃO JUNTAS** (`Promise.all`). Elas não dependem
        uma da outra: o `chCarregar` busca no servidor do chat, o
        `cliCarregar` busca no Supabase. A espera passa a ser a da mais
        lenta, não a soma.
     2. 🔴 **SE JÁ TEM LISTA NA MEMÓRIA, PINTA NA HORA.** Quem já abriu o
        painel uma vez na sessão vê a lista instantaneamente, e a atualização
        entra por cima quando chegar. Antes, a segunda abertura apagava tudo
        e mostrava "Carregando…" de novo — pela lista que já estava ali.
     3. e SÓ ENTÃO a animação, pro caso em que realmente há o que esperar.

     ⚠️ Por que o `cliCarregar` não pode simplesmente sair daqui: sem as
     fichas, TODA conversa apareceria como "sem ficha" (o `_chCliente` casa
     pelo telefone contra a `_clientes`) e o filtro "Sem ficha" mentiria.
     Ele é necessário — só não precisava ser sequencial. */

  var _CP_ICO_CLI='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
  /* as frases falam do que ESTÁ ACONTECENDO de verdade, na ordem em que
     acontece — não são enfeite genérico. Quem espera 3 segundos lendo
     "juntando com as fichas do seu CRM" entende por que demorou. */
  var _CP_FRASES=['Buscando suas conversas…','Juntando com as fichas do seu CRM…','Organizando quem está esperando…'];
  var _cpFraseTimer=null;
  function _cpPararFrases(){ if(_cpFraseTimer){ clearInterval(_cpFraseTimer); _cpFraseTimer=null; } }
  function cpLoadHtml(){
    return '<div class="cp-load mev-process-page" role="status" aria-live="polite">'+
      mevProcessoMarcaHtml()+
      '<div class="pg-load-head"><b class="cp-load-tx" id="cpLoadTx">'+esc(_CP_FRASES[0])+'</b><span>Carregando</span></div>'+
      '<div class="pg-load-track cp-load-track" role="progressbar" aria-label="Carregando conversas" aria-valuetext="Em andamento"><i></i></div>'+
    '</div>';
  }
  function cpLoadGira(){
    _cpPararFrases();
    var i=0;
    _cpFraseTimer=setInterval(function(){
      var el=$('cpLoadTx');
      if(!el){ _cpPararFrases(); return; }        /* a lista chegou: para sozinho */
      i=(i+1)%_CP_FRASES.length;
      el.classList.add('sai');
      setTimeout(function(){
        var e2=$('cpLoadTx'); if(!e2) return;
        e2.textContent=_CP_FRASES[i]; e2.classList.remove('sai');
      },300);
    },1400);
  }

  async function cpCliLista(){
    var body=$('cpBody'); if(!body) return;
    if(!_cpMotorOk()){ cpCliListaCrua(); return; }   /* rede: motor ausente */
    /* 2. já tem lista? mostra ELA, e atualiza por baixo */
    var jaTem=false;
    try{ jaTem=!!(typeof _chLista!=='undefined' && _chLista && _chLista.length); }catch(_){ jaTem=false; }
    if(jaTem){ cpFilaPinta(); }
    else { body.innerHTML=cpLoadHtml(); cpLoadGira(); }
    /* 1. as duas ao MESMO TEMPO */
    var tarefas=[];
    try{ if(typeof cliCarregar==='function' && !((_clientes||[]).length)) tarefas.push(cliCarregar()); }catch(_){}
    try{ if(typeof chCarregar==='function') tarefas.push(chCarregar()); }catch(_){}
    /* v538: as removidas entram na MESMA leva paralela — sem elas o filtro
       do 12d deixa passar tudo na primeira pintura e a lista "pisca" com as
       conversas removidas aparecendo por um instante. */
    try{ if(typeof remCarregar==='function') tarefas.push(remCarregar()); }catch(_){}
    if(tarefas.length){
      try{ await Promise.all(tarefas.map(function(p){ return Promise.resolve(p).catch(function(){}); })); }catch(_){}
    }
    _cpPararFrases();
    cpFilaPinta();
    cpFilaRelogio();
  }
  /* pinta a fila com o que já está em `_chLista`. É chamada TAMBÉM pelo
     `chRepintaTudo` do 12d, então tem que aguentar ser chamada com o painel
     fechado ou numa conversa aberta. */
  function cpFilaPinta(){
    var body=$('cpBody');
    if(!body || _cpAba!=='clientes' || _cpFone) return;
    if(!_cpMotorOk()) return;
    /* ======================================================================
       ⛳ v544 — A FILEIRA DE FILTROS SAIU
       (pedido, com print: "remove esses filtros — fica no chat só os
        contatos que não foram excluídos do chat e os novos")

       🔴🔴 E TIRAR OS BOTÕES **NÃO** É TIRAR O FILTRO. O `_chFiltro` nasce
       em 'esperando' (12d) e é COMPARTILHADO com a página Chat. Apagar só a
       fileira deixaria a fila mostrando apenas quem está esperando — e sem
       nenhum botão pra mudar isso. Seria o pior resultado possível: some
       conversa e não existe mais nem como perceber, quanto mais desfazer.
       Por isso a linha abaixo, e por isso ela mora AQUI, coladinha no
       `_chFiltra()`: assim não há como as duas discordarem.

       O que continua filtrando é só o que o Angelo pediu que continuasse:
       quem foi REMOVIDO do chat (v538) sai, e volta sozinho se escrever de
       novo. O resto — inclusive quem chegou agora — aparece. */
    if(!CX_FILTROS) _chFiltro='todas';
    var lista=_chFiltra();
    body.innerHTML=
      '<div class="cp-fila-top">'+
        '<div class="cli-search cp-busca">'+_icoBusca+'<input id="cpBusca" placeholder="Nome, telefone ou veículo" autocomplete="off" value="'+esc(_chBusca||'')+'"></div>'+
        (CX_FILTROS
          ? ('<div class="cp-filtros" id="cpFiltros">'+CH_FILTROS.map(function(f){
               return '<button type="button" class="cp-fb'+(_chFiltro===f[0]?' on':'')+'" data-f="'+f[0]+'">'+esc(f[1])+'<i>'+_chConta(f[0])+'</i></button>';
             }).join('')+'</div>')
          : '')+
      '</div>'+
      '<div class="cp-fila" id="cpFila">'+(lista.length?lista.map(_cpFilaItem).join(''):_cpFilaVazio())+'</div>';
    var bu=$('cpBusca');
    if(bu){
      bu.oninput=function(){ _chBusca=this.value; cpFilaPinta();
        try{ var b2=$('cpBusca'); if(b2){ b2.focus(); var n=b2.value.length; b2.setSelectionRange(n,n); } }catch(_){} };
    }
    Array.prototype.forEach.call(body.querySelectorAll('.cp-fb'),function(b){
      b.onclick=function(){ _chFiltro=b.getAttribute('data-f'); cpFilaPinta(); };
    });
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-cli]'),function(b){
      b.onclick=function(){
        /* ⛳ v538: tocar no card abria a LISTA de opções ("Enviar mensagem" /
           "Remover do chat"). A folha existia por um motivo declarado: dar
           lugar ao "Remover" **sem inventar um ícone escondido no canto do
           card, que ninguém acha no celular**.
           🔁 v544 (pedido): "ao clicar no card vai direto pra mensagem, se
           clicar na lixeira remove o card do chat". O ícone deixou de ser
           escondido — virou uma lixeira do lado, do tamanho do card inteiro
           em altura — então a razão de ser da folha caiu junto, e o toque
           volta a fazer o que 9 de cada 10 toques querem: abrir a conversa.
           ⛳ `CHAT_CARD_MENU = true` devolve a folha (a `cpCardAcoes` segue
           inteira logo abaixo — escondida, não apagada). */
        if(CHAT_CARD_MENU){ cpCardAcoes(b.getAttribute('data-cp-cli'), b.getAttribute('data-cp-nome')); return; }
        cpAbreConversa(b.getAttribute('data-cp-cli'), b.getAttribute('data-cp-nome'));
      };
    });
    /* 🗑️ v544 — a lixeira. Remove NA HORA e oferece Desfazer por 7 s.
       ⚠️ Nada de `confirm()` do navegador: o app tirou os últimos do CRM na
       v522 e não vamos trazer um de volta pra cá. O desfazer é melhor que a
       pergunta — não custa um toque a quem tem certeza, e salva quem errou.
       ⚠️ É o MESMO caminho da folha da v538 (`chatRemover` → repinta →
       `cpAvisoDesfazer`); nada de segunda forma de remover. */
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-rem]'),function(b){
      b.onclick=async function(){
        if(b.disabled) return;
        var fone=b.getAttribute('data-cp-rem'), quem=b.getAttribute('data-cp-nm')||'Contato';
        b.disabled=true;
        var ok=false;
        try{ ok=await chatRemover(fone); }catch(_){ ok=false; }
        if(!ok){ b.disabled=false; return; }   /* o chatRemover já disse o porquê */
        cpFilaPinta();
        try{ chatBadgeAtualiza(); }catch(_){}
        cpAvisoDesfazer(quem, fone);
      };
    });
    /* v529: as duas saídas da busca sem resultado */
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-abrir]'),function(b){
      b.onclick=function(){ chatPainelAbrirCliente(b.getAttribute('data-cp-abrir'), b.getAttribute('data-cp-nm')||'Cliente'); };
    });
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-novo]'),function(b){
      b.onclick=function(){ cpNovoContato(b.getAttribute('data-cp-novo')); };
    });
  }
  /* ======================================================================
     v538 — A FOLHA DAS RESPOSTAS PADRÃO
     Duas telas na mesma folha: a LISTA (tocar usa) e o FORMULÁRIO (criar ou
     editar). Uma folha só porque o caminho é sempre lista → formulário →
     lista; duas folhas empilhadas no celular viram briga de z-index, que é o
     que o comentário do menu do "+" já registra ter dado errado antes.
     ⚠️ Fica DENTRO do .cp-box, como o seletor de veículos (#cpPick).
     ====================================================================== */
  function cpRespFechar(){ var e=$('cpResp'); if(e&&e.parentNode) e.parentNode.removeChild(e); }

  async function cpRespAbrir(){
    var box=document.querySelector('#chatPainel .cp-box'); if(!box) return;
    if($('cpResp')){ cpRespFechar(); return; }
    var d=document.createElement('div'); d.id='cpResp';
    d.innerHTML='<div class="cp-pk-hd"><b>Respostas padrão</b><button type="button" class="cp-x" id="cpRpX">&times;</button></div>'+
      '<div class="cp-rp-corpo" id="cpRpCorpo"><div class="cli-empty" style="padding:12px">Carregando…</div></div>';
    box.appendChild(d);
    var x=$('cpRpX'); if(x) x.onclick=cpRespFechar;
    await rpCarregar();
    cpRespLista();
  }

  function cpRespLista(){
    var c=$('cpRpCorpo'); if(!c) return;
    var l=_rpLista||[];
    c.innerHTML=
      (l.length
        ? l.map(function(r){
            return '<div class="cp-rp-it">'+
              '<button type="button" class="cp-rp-usar" data-rp="'+esc(r.id)+'">'+
                '<b>'+esc(r.titulo||'Sem nome')+'</b>'+
                '<i>'+esc(String(r.texto||'').slice(0,70))+(String(r.texto||'').length>70?'…':'')+'</i>'+
              '</button>'+
              '<button type="button" class="cp-rp-ed" data-rped="'+esc(r.id)+'" aria-label="Editar">'+_RP_ICO_LAPIS+'</button>'+
            '</div>';
          }).join('')
        /* ⚠️ o vazio EXPLICA com exemplo, que é o que faz alguém criar a
           primeira. "Nenhuma resposta" sozinho não ensina nada. */
        : '<div class="cli-empty" style="padding:14px 12px"><b>Nenhuma resposta salva</b>'+
          'Guarde aqui o que você digita todo dia — o PIX da loja, os dados pro financiamento, o horário.</div>')+
      '<button type="button" class="cp-rp-nova" id="cpRpNova">+ Nova resposta</button>';

    Array.prototype.forEach.call(c.querySelectorAll('[data-rp]'),function(b){
      b.onclick=function(){ cpRespUsar(b.getAttribute('data-rp')); };
    });
    Array.prototype.forEach.call(c.querySelectorAll('[data-rped]'),function(b){
      b.onclick=function(){ cpRespForm(b.getAttribute('data-rped')); };
    });
    var nv=$('cpRpNova'); if(nv) nv.onclick=function(){ cpRespForm(null); };
  }

  /* 🔴 USAR = PÔR NO CAMPO, NUNCA ENVIAR. O texto entra no compositor pra
     você ler, ajustar e decidir — mandar sozinho um PIX ou dados de
     financiamento no toque errado é o tipo de erro que não tem desfazer. */
  function cpRespUsar(id){
    var r=(_rpLista||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!r) return;
    var inp=$('cpIn');
    if(inp){
      inp.value=(inp.value ? inp.value.replace(/\s+$/,'')+'\n' : '')+String(r.texto||'');
      try{ inp.focus(); }catch(_){}
      try{ inp.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){}
    }
    cpRespFechar();
  }

  function cpRespForm(id){
    var c=$('cpRpCorpo'); if(!c) return;
    var r=id ? ((_rpLista||[]).filter(function(x){ return String(x.id)===String(id); })[0]||null) : null;
    c.innerHTML=
      '<label class="cad-lbl" for="cpRpTit">Nome (só pra você achar)</label>'+
      '<input class="cad-in" id="cpRpTit" maxlength="40" placeholder="Ex: PIX da loja" value="'+esc((r&&r.titulo)||'')+'">'+
      '<label class="cad-lbl" for="cpRpTxt" style="margin-top:10px">Texto que vai pro cliente</label>'+
      /* 🔴 NENHUM NOME DE LOJA NO CÓDIGO — nem em exemplo de placeholder. O
         app vai pra outras concessionárias; é a mesma regra do template da
         primeira mensagem (v529), e foi o teste dela que pegou isto aqui. */
      '<textarea class="cad-in" id="cpRpTxt" rows="5" placeholder="Ex: Nosso PIX é o CNPJ 00.000.000/0001-00. Pode mandar o comprovante por aqui.">'+esc((r&&r.texto)||'')+'</textarea>'+
      '<button type="button" class="cad-btn" id="cpRpSalvar" style="margin-top:12px">Salvar</button>'+
      (r ? '<button type="button" class="cpac-sec" id="cpRpDel">Apagar esta resposta</button>' : '')+
      '<button type="button" class="cpac-x" id="cpRpVolta">Voltar</button>';
    var v=$('cpRpVolta'); if(v) v.onclick=function(){ cpRespLista(); };
    var sv=$('cpRpSalvar');
    if(sv) sv.onclick=async function(){
      sv.disabled=true; sv.textContent='Salvando…';
      var ok=await rpSalvar(id, ($('cpRpTit')||{}).value, ($('cpRpTxt')||{}).value);
      sv.disabled=false; sv.textContent='Salvar';
      if(ok){ cpRespLista(); toast('Resposta salva ✓'); }
    };
    var dl=$('cpRpDel');
    if(dl) dl.onclick=async function(){
      dl.disabled=true;
      var ok=await rpApagar(id);
      dl.disabled=false;
      if(ok){ cpRespLista(); toast('Resposta apagada.'); }
    };
    try{ var t=$('cpRpTit'); if(t) t.focus(); }catch(_){}
  }

  var _RP_ICO_LAPIS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';

  /* ⛳ v544 (pedido): a fileira Esperando · Não lidas · Sem ficha · Todas
     saiu do painel. `true` traz os quatro botões de volta, e mais nada
     precisa mudar — o motor do 12d segue inteiro. */
  var CX_FILTROS = false;

  /* ======================================================================
     v538 — A LISTA DE OPÇÕES DO CARD
     ⚠️ É uma FOLHA (`.cropmask`), o padrão da casa — não um `confirm`, que o
     app tirou na v522, nem um menu flutuante que no celular abre fora da
     tela. O mesmo desenho da folha de cadastrar número novo aqui do lado.

     🔁 v544 — DESLIGADA (pedido: "ao clicar no card vai direto pra
     mensagem, se clicar na lixeira remove o card do chat"). A folha nasceu
     pra dar lugar ao "Remover" sem um ícone escondido; com a lixeira ao
     lado do card, o motivo dela acabou. `true` devolve a folha — a função
     abaixo continua inteira, escondida e não apagada.
     ====================================================================== */
  var CHAT_CARD_MENU = false;

  function cpAbreConversa(fone, nome){
    _cpFone=String(fone||'').replace(/\D/g,'');
    _cpFoneNome=nome||'Cliente';
    cpPinta();
  }
  function cpCardFechaAcoes(){ var m=$('cpAcMask'); if(m&&m.parentNode) m.parentNode.removeChild(m); }

  function cpCardAcoes(fone, nome){
    if($('cpAcMask')) return;
    var quem=nome||_cpFoneFmt(fone)||'Cliente';
    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='cpAcMask';
    ov.innerHTML='<div class="cropbox cpac-box">'+
      '<div class="cpac-tit">'+esc(quem)+'</div>'+
      '<button type="button" class="cad-btn" id="cpAcMsg">Enviar mensagem</button>'+
      (CHAT_REMOVER_ON
        ? '<button type="button" class="cpac-sec" id="cpAcRem">Remover do chat</button>'
        : '')+
      '<button type="button" class="cpac-x" id="cpAcCancel">Cancelar</button>'+
    '</div>';
    document.body.appendChild(ov);
    ov.onclick=function(e){ if(e.target===ov) cpCardFechaAcoes(); };
    var bc=$('cpAcCancel'); if(bc) bc.onclick=cpCardFechaAcoes;
    var bm=$('cpAcMsg');
    if(bm) bm.onclick=function(){ cpCardFechaAcoes(); cpAbreConversa(fone, nome); };
    var br=$('cpAcRem');
    if(br) br.onclick=async function(){
      br.disabled=true; br.textContent='Removendo…';
      var ok=false;
      try{ ok=await chatRemover(fone); }catch(_){ ok=false; }
      cpCardFechaAcoes();
      if(!ok) return;
      cpFilaPinta();
      try{ chatBadgeAtualiza(); }catch(_){}
      /* 🔴 DESFAZER na hora. Remover é o único caminho que tira algo da vista
         do usuário, e um toque errado no celular é fácil demais. O aviso é a
         rede — e é barata: uma linha no banco pra apagar. */
      cpAvisoDesfazer(quem, fone);
    };
  }

  /* o aviso com o Desfazer, 7 segundos */
  var _cpDesfTimer=null;
  function cpAvisoDesfazer(quem, fone){
    var p=$('chatPainel'); if(!p) return;
    var velho=$('cpDesf'); if(velho&&velho.parentNode) velho.parentNode.removeChild(velho);
    if(_cpDesfTimer){ clearTimeout(_cpDesfTimer); _cpDesfTimer=null; }
    var d=document.createElement('div'); d.id='cpDesf'; d.className='cp-desf';
    d.innerHTML='<span>'+esc(quem)+' saiu da lista</span><button type="button" id="cpDesfBt">Desfazer</button>';
    p.appendChild(d);
    var fecha=function(){ var e=$('cpDesf'); if(e&&e.parentNode) e.parentNode.removeChild(e);
                          if(_cpDesfTimer){ clearTimeout(_cpDesfTimer); _cpDesfTimer=null; } };
    var b=$('cpDesfBt');
    if(b) b.onclick=async function(){
      b.disabled=true;
      var ok=false; try{ ok=await chatDevolver(fone); }catch(_){ ok=false; }
      fecha();
      if(ok){ cpFilaPinta(); try{ chatBadgeAtualiza(); }catch(_){} toast('De volta na lista ✓'); }
    };
    _cpDesfTimer=setTimeout(fecha, 7000);
  }

  /* ---- cadastrar um número novo e já abrir a conversa (v529) ----
     ⚠️ Uma folha, não um `prompt` — o app tirou os dois últimos prompts do
     CRM na v522; não vamos trazer um de volta.
     ⚠️ E reaproveita o `_orfaCriar` da v335, que é o MESMO caminho que
     cadastra uma conversa órfã: origem 'WhatsApp', etapa 'chat', e a
     anotação dizendo de onde veio. Nada de segunda porta de cadastro. */
  function cpNovoContato(d){
    if($('cpNvMask')) return;
    var fmt=(typeof _crmFoneFmt==='function')?_crmFoneFmt(d):d;
    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='cpNvMask';
    ov.innerHTML='<div class="cropbox cpnv-box">'+
      '<div class="crop-tit">Quem é '+esc(fmt)+'?</div>'+
      '<label class="crm-lb">NOME</label><input class="cad-in" id="cpNvNome" placeholder="Nome do contato" autocomplete="off">'+
      '<button type="button" class="cad-btn" id="cpNvOk" style="margin-top:12px;width:100%">Cadastrar e conversar</button>'+
      '<button type="button" class="link" id="cpNvNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#cpNvNao').onclick=close;
    try{ $('cpNvNome').focus(); }catch(_){}
    $('cpNvNome').addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); $('cpNvOk').click(); } });
    $('cpNvOk').onclick=async function(){
      var nome=String($('cpNvNome').value||'').trim();
      if(!nome){ toast('Escreva o nome — é ele que vai aparecer na lista.'); try{ $('cpNvNome').focus(); }catch(_){} return; }
      var b=$('cpNvOk'); b.disabled=true; b.textContent='Cadastrando…';
      var novo=null;
      try{ novo=await _orfaCriar({ telefone:d, nome:nome }); }catch(_){ novo=null; }
      close();
      if(!novo) return;                       /* o _orfaCriar já avisou o porquê */
      _chBusca='';                            /* a busca cumpriu o papel */
      chatPainelAbrirCliente(d, nome);
    };
  }
  /* v544 — a lixeira do card. Traço fino, do mesmo tamanho dos outros
     ícones do painel (padroes/ICONES-SVG.md): SVG, nunca caractere. */
  var CP_LIXO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';

  function _cpFilaItem(cv){
    var c=(typeof _chCliente==='function')?_chCliente(cv):null;
    var nome=(c&&c.nome)||cv.nome||_cpFoneFmt(cv.telefone)||'Sem nome';
    /* ======================================================================
       🔴🔴 v544 — A LIXEIRA É IRMÃ DO CARD, NUNCA FILHA.
       (pedido: "adicione um svg de lixeira — ao clicar no card vai direto
        pra mensagem, se clicar na lixeira remove o card do chat")

       O card É um <button>. **Botão dentro de botão é HTML inválido**: o
       navegador tira o de dentro do lugar na hora de montar a página, e o
       resultado é um card torto com uma lixeira solta embaixo. Por isso os
       dois viram IRMÃOS dentro de uma linha (.cp-cv-row).
       De brinde, some o problema clássico do ícone dentro do card: não
       existe clique pra "parar de subir" (stopPropagation), porque o
       clique na lixeira nunca passa pelo card.
       ====================================================================== */
    var card='<button type="button" class="cp-conv" data-cp-cli="'+esc(cv.telefone||'')+'" data-cp-nome="'+esc(nome)+'">'+
      '<span class="cp-cv-tx">'+
        '<span class="cp-l1"><b>'+esc(nome)+'</b><i>'+esc((typeof _chHora==='function')?_chHora(cv.quando):'')+'</i></span>'+
        '<i class="cp-l2">'+((cv.direcao==='enviada')?'Você: ':'')+esc(String(cv.ultima||'').slice(0,58))+'</i>'+
        /* ⚠️ .ch-sf e .ch-esp são as MESMAS etiquetas da página Chat — nada
           de segunda paleta pro mesmo significado */
        '<span class="cp-l3">'+(c?'':'<span class="ch-sf">sem ficha</span>')+
          ((typeof _chEsperaSelo==='function')?_chEsperaSelo(cv):'')+'</span>'+
      '</span>'+
      (cv.nao_lidas?('<span class="cp-nn">'+cv.nao_lidas+'</span>'):'')+
    '</button>';
    /* a lixeira só existe onde o "remover do chat" existe (v538) */
    var lixo = CHAT_REMOVER_ON
      ? ('<button type="button" class="cp-lixo" data-cp-rem="'+esc(cv.telefone||'')+'" data-cp-nm="'+esc(nome)+'"'+
         ' title="Remover do chat" aria-label="Remover '+esc(nome)+' do chat">'+CP_LIXO+'</button>')
      : '';
    return '<div class="cp-cv-row">'+card+lixo+'</div>';
  }
  /* 🔴 CADA FILTRO VAZIO DIZ UMA COISA DIFERENTE. "Nenhuma conversa aqui"
     em cima de "Esperando" faz a pessoa achar que o app quebrou; na
     verdade é a melhor notícia do dia. E "Sem ficha: 0" é o resultado que
     a Parte 2 deste projeto persegue — tem que soar como conquista. */
  /* ======================================================================
     v529 — "NADA NESSA BUSCA" DEIXOU DE SER UM BECO
     (print do Angelo: digitou 48991483129 e a tela não ofereceu saída)

     📏 São DOIS becos, e o segundo é o mais comum:
       A) número que nunca conversou — o do print;
       B) 🔴 cliente que ESTÁ no CRM e nunca trocou WhatsApp. A busca daqui
          filtra a lista de CONVERSAS, não a de clientes — e são **107
          fichas contra 10 conversas**. Esse beco é 10× mais provável.
     O mesmo conserto cobre os dois: quando o que foi digitado PARECE um
     telefone e não achou nada, a tela oferece o caminho. */
  function _cpBuscaFone(){
    var d=String(_chBusca||'').replace(/\D/g,'');
    return d.length>=8 ? d : '';
  }
  function _cpClienteDoFone(d){
    var k=d.slice(-8);
    return ((typeof _clientes!=='undefined'&&_clientes)||[]).filter(function(c){
      return String(c.telefone||'').replace(/\D/g,'').slice(-8)===k; })[0]||null;
  }
  function _cpSaidaDaBusca(){
    var d=_cpBuscaFone(); if(!d) return '';
    var fmt=(typeof _crmFoneFmt==='function')?_crmFoneFmt(d):d;
    var c=_cpClienteDoFone(d);
    if(c){
      /* beco B: ele existe, só nunca conversou */
      return '<div class="cp-saida"><b>'+esc(c.nome||'Este cliente')+' está no seu CRM</b>'+
        '<span>'+esc(fmt)+' — mas vocês nunca trocaram mensagem por aqui.</span>'+
        '<button type="button" class="cad-btn" data-cp-abrir="'+esc(String(c.telefone||d))+'" data-cp-nm="'+esc(c.nome||'Cliente')+'">Abrir a conversa</button></div>';
    }
    /* beco A: número novo */
    return '<div class="cp-saida"><b>'+esc(fmt)+' não está no seu CRM</b>'+
      '<span>Dá pra cadastrar e começar a conversa agora.</span>'+
      '<button type="button" class="cad-btn" data-cp-novo="'+esc(d)+'">Cadastrar e conversar</button></div>';
  }
  /* quantas conversas a lista está escondendo por terem sido REMOVIDAS.
     v544: com os filtros fora, é o único motivo que sobrou pra uma conversa
     não aparecer — e a casa não deixa nada sumir calado (lição da v528). */
  function _cpRemovidasN(){
    try{
      if(typeof chatRemovida!=='function') return 0;
      return (_chLista||[]).filter(function(cv){ return chatRemovida(cv); }).length;
    }catch(_){ return 0; }
  }
  function _cpFilaVazio(){
    if(_chBusca) return '<div class="cli-empty" style="padding:18px">Nada nessa busca.</div>'+_cpSaidaDaBusca();
    if(_chFiltro==='esperando') return '<div class="cli-empty" style="padding:18px"><b>Ninguém esperando</b>Todo mundo já foi respondido.</div>';
    if(_chFiltro==='naolidas') return '<div class="cli-empty" style="padding:18px"><b>Nada por ler</b>Você está em dia.</div>';
    if(_chFiltro==='semficha') return '<div class="cli-empty" style="padding:18px"><b>Todo mundo tem ficha</b>Toda conversa já virou cliente no CRM.</div>';
    /* 🔴 v544 — "vazio" e "tudo removido" NÃO são a mesma frase. Dizer
       "nenhuma conversa ainda" pra quem removeu as 10 que tinha é dizer que
       o app perdeu as conversas. A lixeira nova torna isto fácil de
       acontecer sem querer — então a saída fica escrita. */
    var rem=_cpRemovidasN();
    if(rem) return '<div class="cli-empty" style="padding:18px"><b>Nada na lista</b>'+
      (rem===1?'1 conversa foi removida do chat':(rem+' conversas foram removidas do chat'))+
      ' — e volta sozinha assim que a pessoa escrever de novo.</div>';
    return '<div class="cli-empty" style="padding:18px"><b>Nenhuma conversa ainda</b>As conversas do WhatsApp do atendente aparecem aqui — e você responde sem sair da página.</div>';
  }
  /* a fila se atualiza sozinha a cada 20 s, igual à da página */
  function cpFilaRelogio(){
    _cpPararTimer();
    _cpTimer=setInterval(function(){
      if($('cpFila') && _cpAba==='clientes' && !_cpFone){ try{ chCarregar(true); }catch(_){} }
      else _cpPararTimer();
    },20000);
  }
  /* a lista de antes da v523, guardada como rede: se o 12d sumir do build,
     a aba Clientes continua funcionando (pobre, mas funcionando). */
  async function cpCliListaCrua(){
    var body=$('cpBody'); if(!body) return;
    /* v531: a mesma animação da aba Clientes — uma função só, pra que as
       duas abas nunca divirjam no jeito de esperar */
    body.innerHTML=cpLoadHtml(); cpLoadGira();
    var d=await _chatApi({acao:'resumo'});
    body=$('cpBody'); if(!body || _cpAba!=='clientes' || _cpFone) return;
    if(!d || !d.ok){
      body.innerHTML='<div class="cli-empty" style="padding:16px"><b>Não consegui carregar</b>'+esc((d&&d.erro)||'Tente de novo em instantes.')+'</div>';
      return;
    }
    var cvs=(d.conversas||[]);
    if(!cvs.length){
      body.innerHTML='<div class="cli-empty" style="padding:16px"><b>Nenhuma conversa ainda</b>As conversas do WhatsApp do atendente aparecem aqui — e você responde sem sair da página.</div>';
      return;
    }
    body.innerHTML=cvs.map(function(cv){
      var nome=cv.nome||_cpFoneFmt(cv.telefone);
      return '<button type="button" class="cp-conv" data-cp-cli="'+esc(cv.telefone||'')+'" data-cp-nome="'+esc(nome)+'">'+
        '<span class="cp-cv-tx"><b>'+esc(nome)+'</b>'+
        '<i>'+((cv.direcao==='enviada')?'Você: ':'')+esc(String(cv.ultima||'').slice(0,58))+'</i></span>'+
        (cv.nao_lidas?('<span class="cp-nn">'+cv.nao_lidas+'</span>'):'')+
      '</button>';
    }).join('');
    Array.prototype.forEach.call(body.querySelectorAll('[data-cp-cli]'),function(b){
      b.onclick=function(){
        _cpFone=String(b.getAttribute('data-cp-cli')||'').replace(/\D/g,'');
        _cpFoneNome=b.getAttribute('data-cp-nome')||'Cliente';
        cpPinta();
      };
    });
  }
  /* ======================================================================
     v524 → 🔁 v529 — A FICHA SAIU DA FAIXA E VIROU O LÁPIS DO CABEÇALHO
     (PROJETO-cabecalho-da-conversa-editar-e-onde-ele-esta)

     "deixe um ícone pra editar o cliente ao lado do nome — substitui o
      botão Ficha do cliente"

     📏 POR QUE ELE TEM RAZÃO, MEDIDO NO NAVEGADOR (celular de 360px):
         o painel tem 435px úteis
         a faixa "Ficha do cliente" FECHADA ...... 45px
         o aviso "A MESMA conversa…" ............. 48px
         🔴 sobrava pra CONVERSA .................. 180px
     Os dois pedaços somavam **93px — 21% do painel** — e a conversa, que é
     a única coisa que aquela tela existe pra mostrar, ficava com menos da
     metade. Sem eles ela vai a ~273px: **+52%**.

     🔴 MAS A FAIXA NÃO ERA UM BOTÃO: ela CONTINHA o editor inteiro, e fazia
     duas coisas que um lápis mudo não faz — avisava "sem ficha", e nascia
     aberta no computador. **Nada disso se perdeu:**
       · o editor virou FOLHA por cima (`.cropmask`, o padrão da casa) — o
         chat continua atrás, e fechar não recarrega a conversa;
       · o "sem ficha" virou a ETIQUETA do lado do nome, que é mais visível
         do que era dentro de um acordeão fechado;
       · e a etiqueta também diz Lead · Repasse · Perdido · Cliente, que era
         o segundo pedido ("o ícone poderia levar pra página onde ele está").

     ⚠️ A ETIQUETA NÃO NAVEGA (decisão do Angelo, 16/08). O painel existe
     pra você **não sair da página** — mandar pra outra tela no meio de um
     atendimento perde o contexto e o rascunho do compositor. Ela informa;
     o lápis edita. Uma coisa cada.

     🔴 O PREFIXO 'cpc' CONTINUA OBRIGATÓRIO — e é a armadilha mais fácil de
     perder numa reforma dessas. O painel pode estar POR CIMA da página
     Chat, que usa 'ch': dois `#chNome` na mesma tela e o `$()` devolve
     sempre o primeiro — você digita num campo e salva o outro. Trocar
     acordeão por folha **não muda isso**. O teste da v524 monta as duas de
     propósito e conta os ids; ele é o guarda-costas desta mudança.
     ====================================================================== */
  function _cpFxCv(){ return { telefone:_cpFone, nome:_cpFoneNome }; }
  function _cpFxCliente(){
    var cv=_cpFxCv();
    try{ if(typeof _chCliente==='function') return _chCliente(cv); }catch(_){}
    return null;
  }
  /* a etiqueta: quem manda é o 12k, pra nunca discordar das listas */
  function cpTagHtml(){
    var c=_cpFxCliente();
    var t = (typeof ondeEstaAficha==='function') ? ondeEstaAficha(c)
          : (c?['lead','Lead']:['semficha','sem ficha']);
    return '<span class="cp-tag '+esc(t[0])+'" id="cpTag">'+esc(t[1])+'</span>';
  }
  function cpCabPinta(){
    /* a ficha pode ter acabado de nascer: a etiqueta se corrige sozinha */
    var t=$('cpTag'); if(!t) return;
    var d=document.createElement('div'); d.innerHTML=cpTagHtml();
    try{ t.replaceWith(d.firstChild); }catch(_){}
  }
  var _ICO_LAPIS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>';
  function cpCabHtml(nome){
    /* 🔁 v552 (pedido, com print): "deixe tudo na mesma linha do nome".
       A linha da IA (v529/v544) morava num segundo andar, logo abaixo do
       cabeçalho — 20px que eram só dela. Agora o `cp-ia` NASCE DENTRO do
       cabeçalho: ‹ · nome · [etiqueta] · ✏️ · IA ⭘, uma linha só, e os
       20px voltam pra conversa (a mesma briga medida na v529).
       ⚠️ O nome continua sendo o único que encolhe (flex:1 + ellipsis no
       CSS) — etiqueta, lápis e interruptor são flex:none e nunca saem da
       tela, nem no 360px com "Maria Aparecida de Souza Nascimento".
       ⚠️ `cpIaHtml()` pode voltar vazio (loja sem atendente) — aí o
       cabeçalho fica exatamente como era. */
    return '<div class="cp-th-hd cp-th-cli">'+
      '<button type="button" class="cp-volta" id="cpVolta" aria-label="Voltar">&#8249;</button>'+
      '<b>'+esc(nome)+'</b>'+cpTagHtml()+
      ((typeof chCadCamposHtml==='function')
        ? ('<button type="button" class="cp-ed" id="cpEdit" title="Editar o cadastro" aria-label="Editar o cadastro de '+esc(nome)+'">'+_ICO_LAPIS+'</button>')
        : '')+
      cpIaHtml()+
    '</div>';
  }
  /* ---- a linha da IA (o que sobrou da `cp-avisa`) ----------------------
     🔴 O QUE ELA RESOLVE: responder por aqui **cala o atendente automático
     por 30 minutos** — é uma coisa que o sistema faz e o usuário não vê. O
     aviso antigo dizia isso ANTES, toda vez, pra quem já sabia. Agora a
     tela mostra o FATO, em duas palavras.

     📏 E não é caso raro: das 96 mensagens enviadas, 54 são da IA — ou
     seja, umas 42 saíram de humano. A pausa dispara direto.

     ⚠️ Três estados, e o terceiro é o silêncio: loja SEM atendente não vê
     linha nenhuma (não há IA pra pausar). Só esconde com `false`
     explícito — o `_chatTem` nasce `null` e a resposta vem do banco
     depois; esconder no `null` faria a linha piscar. */
  var _cpIa=null;      /* null = ainda não sei · 'pausada' · 'ativa' */
  var _cpRascunho='';  /* v530: texto que quem abriu a conversa já deixou pronto */
  function cpIaHtml(){
    var semIa=false;
    try{ semIa=(typeof _chatTem!=='undefined' && _chatTem===false); }catch(_){}
    if(semIa) return '';
    var p=(_cpIa==='pausada');
    /* ======================================================================
       🔁 v544 (pedido, com print): *"deixe (IA + (botão on/off) ao lado)"*.

       A v541 escrevia a linha inteira: ● "IA pausada" ......... [Ligar a IA]
       — bolinha, frase e um botão de texto, ocupando a largura toda do
       painel logo acima da conversa. Virou: **IA  [ ●]**.

       🔴 O QUE NÃO SE PERDEU, e por que:
        · o botão continua sendo a AÇÃO, não o estado (`data-ia` diz no que
          ele VAI virar) — é assim que o `cpIaLiga` e o servidor conversam
          desde a v541, e mexer nisso quebraria os dois de uma vez;
        · a bolinha separada saiu porque o interruptor JÁ é a bolinha: verde
          à direita = respondendo, âmbar à esquerda = pausada. Duas coisas
          dizendo o mesmo estado é como elas passam a discordar;
        · quem não enxerga cor continua atendido: `role="switch"` +
          `aria-checked` + um `aria-label`/`title` que dizem a frase inteira
          ("IA respondendo nesta conversa · tocar para desligar").
       ⚠️ Só aparece com conversa aberta: é uma decisão POR CLIENTE.
       ====================================================================== */
    var frase=p?'IA pausada nesta conversa · tocar para ligar'
               :'IA respondendo nesta conversa · tocar para desligar';
    var bt=(IA_SELETOR_ON && _cpFone)
      ? ('<button type="button" class="cp-ia-sw" id="cpIaBt" role="switch"'+
         ' aria-checked="'+(p?'false':'true')+'" data-ia="'+(p?'ativa':'pausada')+'"'+
         ' title="'+esc(frase)+'" aria-label="'+esc(frase)+'"><i class="cp-ia-kn"></i></button>')
      : '';
    /* sem seletor (fila, ou interruptor desligado) a linha volta a DIZER o
       estado — sem o botão, "IA" sozinho não significaria nada */
    return '<div class="cp-ia'+(p?' pausada':'')+'" id="cpIa">'+(bt?'':'<i></i>')+
      '<span>'+(bt?'IA':(p?'IA pausada':'IA respondendo'))+'</span>'+bt+'</div>';
  }
  function cpIaPinta(){
    var el=$('cpIa');
    var d=document.createElement('div'); d.innerHTML=cpIaHtml();
    var novo=d.firstChild;
    /* ⚠️ v541: os três caminhos caem no `cpIaLiga()` do fim. Eles eram três
       `return` — e o seletor novo, ligado depois, nunca recebia o clique no
       caso mais comum (a linha já existia e foi trocada). */
    if(el && novo){ try{ el.replaceWith(novo); }catch(_){} }
    else if(el && !novo){ try{ el.remove(); }catch(_){} }
    /* v552: nasceu escondida e agora precisa existir — entra DENTRO do
       cabeçalho (é lá que ela mora agora), no fim da linha */
    else if(!el && novo){ var hd=document.querySelector('#cpBody .cp-th-cli');
      if(hd) hd.appendChild(novo); }
    cpIaLiga();
  }
  /* v541 — o clique do seletor. Fica FORA do cpIaHtml porque a linha é
     redesenhada a cada 8s pelo timer da thread; ligar o evento no HTML
     perderia o handler na primeira repintura. */
  function cpIaLiga(){
    var b=$('cpIaBt'); if(!b) return;
    b.onclick=async function(e){
      e.stopPropagation();
      var quer=b.getAttribute('data-ia');
      /* ⚠️ v544: era `b.textContent='…'`. O botão virou um interruptor com
         a bolinha DENTRO (`<i class="cp-ia-kn">`) — escrever texto nele
         apagaria a bolinha, e se a gravação falhasse o interruptor voltaria
         vazio. O sinal de "estou indo" agora é o próprio `disabled` (o CSS
         apaga um pouco), e a bolinha continua lá. */
      b.disabled=true;
      var novo=await iaEscolher(_cpFone, quer);
      if(!novo){ cpIaPinta(); return; }
      _cpIa=novo;
      cpIaPinta();
      toast(novo==='pausada'
        ? 'IA desligada nesta conversa. Ela não volta sozinha.'
        : 'IA ligada nesta conversa.');
    };
  }

  /* ======================================================================
     v529 — O PRIMEIRO CONTATO (pedido do Angelo, 16/08)
     "iniciar uma conversa com um número que não está cadastrado… com um
      template … e bloqueia até a resposta"

     🔴 ISTO AFROUXA A REGRA Nº 1 DA v510 — "nunca iniciar" — que é a que
     mais salva chip. Quem impede continua sendo o SERVIDOR; aqui é só a
     conversa com a pessoa. As travas de lá (uma mensagem por número, uma
     vez na vida; teto de 220 caracteres; `primeiro:true` obrigatório)
     valem pra qualquer caminho, inclusive um disparo em lote futuro.

     ⚠️ O TEXTO NÃO É FIXO. Ele se monta do SEU nome e da SUA loja — o app
     vai ser vendido pra outras concessionárias, e uma mensagem com
     "Volkswagen Santa Luzia" escrita no código sairia na cara do lojista
     errado. Sem nome nem loja, cai em algo genérico e honesto.

     ⚠️ E ele PEDE LICENÇA ("podemos conversar por aqui?"). Não é
     propaganda: é a mensagem que menos vira denúncia — e denúncia é o que
     derruba número na Z-API. */
  function cpTemplatePrimeiro(){
    var quem='';
    try{
      var n=String((typeof meuNome!=='undefined'&&meuNome)||'').trim().split(/\s+/).slice(0,2).join(' ');
      var l=''; try{ l=String((_lojaRec&&(_lojaRec.nome_fantasia||_lojaRec.razao_social))||'').trim(); }catch(_){}
      quem=[n,l].filter(Boolean).join(' da ');
    }catch(_){}
    return 'Olá! Aqui é '+(quem||'a equipe da loja')+'. Podemos conversar por aqui?';
  }
  /* ==========================================================================
     v546 (pedido): *"no campo de mensagem, ao passar 24 horas, bloqueie o
     campo e mostre um enviar template, já sugere Olá 'Fulano', me chamo
     'fulano' da loja 'fulano', podemos conversar por aqui? — se o cliente
     responde, libera pra trocar mensagem"*.

     🔴 O TEMPLATE MONTA SOZINHO, DE TRÊS PEDAÇOS QUE JÁ EXISTEM:
       · o primeiro nome DELE  → da ficha do CRM, ou do nome da conversa;
       · o meu primeiro nome   → `meuNome`;
       · o nome da LOJA        → `_lojaRec`.
     ⚠️ NOME DE LOJA NO CÓDIGO, NUNCA — nem em placeholder (regra da casa; o
     teste-v529 já pegou "Santa Luzia" escrito na v538). O app vai ser
     vendido pra outras concessionárias: um nome cravado aqui sairia na cara
     do lojista errado.
     ⚠️ E cada pedaço que falta some junto com a vírgula dele — "Olá , me
     chamo  da loja ." é pior que uma frase curta. */
  function _cpPrimeiroNome(s){
    return String(s||'').trim().split(/\s+/)[0] || '';
  }
  function cpTemplateRetomar(){
    var dele='';
    try{
      var c=(typeof _cpFxCliente==='function')?_cpFxCliente():null;
      dele=_cpPrimeiroNome((c&&c.nome)||_cpFoneNome||'');
      if(/^\d+$/.test(dele)) dele='';          /* "5551..." não é nome */
    }catch(_){}
    var eu='', loja='';
    try{ eu=_cpPrimeiroNome((typeof meuNome!=='undefined'&&meuNome)||''); }catch(_){}
    try{ loja=String((_lojaRec&&(_lojaRec.nome_fantasia||_lojaRec.razao_social))||'').trim(); }catch(_){}
    var quem = eu ? ('me chamo '+eu+(loja?(' da '+loja):'')) : (loja?('aqui é da '+loja):'aqui é da loja');
    return 'Olá'+(dele?(' '+dele):'')+', '+quem+'. Podemos conversar por aqui?';
  }
  /* ---- os espelhos das regras do servidor ----------------------------------
     🔴🔴 REGRA QUE VIVE EM DOIS LUGARES MUDA NOS DOIS — e aqui o SERVIDOR é
     quem manda. Quem de fato recusa o envio é o `chat-whatsapp.js`, ação
     `enviar`: a trava do "esfriou" (v510) e a do "não insistir" (v542).
     Estas três funções são ESPELHO, e existem por um motivo só: avisar antes
     em vez de deixar a pessoa escrever um parágrafo e tomar um erro. Se a
     regra mudar lá, muda aqui. */
  function _cpUltRecebida(ms){
    var t=0;
    (ms||[]).forEach(function(m){
      if(m && m.direcao==='recebida'){ var x=Date.parse(m.criado_em||'')||0; if(x>t) t=x; }
    });
    return t;
  }
  /* horas desde a última fala DELE. -1 = ele nunca falou (outro caso) */
  function _cpHorasSemFalar(ms){
    var t=_cpUltRecebida(ms); if(!t) return -1;
    return Math.floor((Date.now()-t)/3600000);
  }
  /* já mandamos alguma coisa DEPOIS da última fala dele? (a trava da v542) */
  function _cpEnviadaDepois(ms){
    var t=_cpUltRecebida(ms); if(!t) return false;
    return (ms||[]).some(function(m){
      return m && m.direcao==='enviada' && (Date.parse(m.criado_em||'')||0) > t;
    });
  }
  /* ⛳ v546 — `false` volta ao compositor sempre aberto depois das 24h (o
     servidor continua barrando; a tela é que deixaria de avisar antes). */
  var CX_TRAVA_24H = true;

  /* nunca trocamos uma palavra com este número */
  function _cpVirgem(ms){ return !ms || !ms.length; }
  /* já cutuquei e ele NÃO respondeu — a partir daqui o servidor barra.
     ⚠️ O NOME evita colidir com o `_chEsperando` do 12d, que é OUTRA coisa:
     lá "esperando" é o cliente esperando RESPOSTA NOSSA (a fila da caixa de
     entrada); aqui somos NÓS esperando o retorno dele. Duas coisas com o
     mesmo nome no mesmo arquivo é como se troca uma pela outra. */
  function _cpAguardandoRetorno(ms){
    return !!(ms && ms.length && !ms.some(function(m){ return m.direcao==='recebida'; }));
  }
  /* trava/destrava o compositor conforme o estado da conversa */
  function cpCompEstado(ms){
    var inp=$('cpIn'), snd=$('cpSend'), comp=document.querySelector('#cpBody .cp-comp');
    if(!inp || !comp) return;
    var aviso=$('cpTrava'); if(aviso){ try{ aviso.remove(); }catch(_){} }
    if(_cpAguardandoRetorno(ms)){
      /* 🔴 UMA mensagem, e para. Cutucar de novo quem não respondeu é
         exatamente o que faz a pessoa denunciar — e o servidor recusaria
         de qualquer jeito. Melhor a tela dizer antes do que dar erro. */
      inp.value=''; inp.disabled=true; if(snd) snd.disabled=true;
      inp.placeholder='Esperando ele responder…';
      var wa=(typeof cliWhatsUrl==='function')?cliWhatsUrl(_cpFone):'';
      var d=document.createElement('div'); d.className='cp-trava'; d.id='cpTrava';
      /* ⚠️ curto de propósito: este bloco divide a folha com a conversa e o
         compositor. Texto longo aqui empurra a conversa pra fora da tela —
         medido no celular de 360px. */
      d.innerHTML='<b>Enviada — esperando ele responder</b>'+
        '<span>Insistir antes da resposta é o que derruba número. Quando ele escrever, destrava sozinha.'+
        (wa?(' <a href="'+esc(wa)+'" target="_blank" rel="noopener">Abrir no WhatsApp ›</a>'):'')+'</span>';
      comp.parentNode.insertBefore(d, comp);
      return;
    }
    /* ========================================================================
       🔴 v546 — PASSOU DE 24 H SEM ELE FALAR
       São DOIS estados, e confundi-los seria o defeito: um ainda deixa mandar
       (uma vez), o outro não deixa de jeito nenhum. Quem decide isso é o
       servidor; a tela só chega na frente pra não fazer a pessoa escrever um
       parágrafo e tomar um erro depois.

         a) já mandamos alguma coisa DEPOIS da última fala dele
            → BARRADO de verdade (v542, "não insistir"). Nem o `confirmo`
              destrava. A tela diz e não oferece botão nenhum: botão que dá
              erro é pior que botão nenhum.
         b) nada nosso desde então
            → passa UMA vez, com `confirmo:true` (v510, "esfriou"). É aqui
              que mora o template: curto, com nome, e pedindo licença.

       ⚠️ Assim que ele responder, `horas` volta a ser < 24 e o campo
       destrava sozinho — ninguém precisa desfazer nada.
       ======================================================================== */
    var _h=CX_TRAVA_24H ? _cpHorasSemFalar(ms) : -1;
    if(_h >= 24){
      inp.value=''; inp.disabled=true; if(snd) snd.disabled=true;
      var _quanto = _h>=48 ? (Math.floor(_h/24)+' dias') : (_h+' horas');
      var d2=document.createElement('div'); d2.className='cp-trava'; d2.id='cpTrava';
      if(_cpEnviadaDepois(ms)){
        inp.placeholder='Esperando ele responder…';
        var wa2=(typeof cliWhatsUrl==='function')?cliWhatsUrl(_cpFone):'';
        d2.innerHTML='<b>Você já chamou — esperando ele responder</b>'+
          '<span>A última mensagem dele foi há '+esc(_quanto)+'. Insistir antes da resposta é o que faz o cliente bloquear o número.'+
          (wa2?(' <a href="'+esc(wa2)+'" target="_blank" rel="noopener">Abrir no WhatsApp ›</a>'):'')+'</span>';
      } else {
        inp.placeholder='Retomada por template…';
        d2.className='cp-trava cp-tpl';
        d2.innerHTML='<b>Faz '+esc(_quanto)+' que ele não escreve</b>'+
          '<span>Depois de 24 h sai só uma mensagem curta de retomada — é o que não derruba o número.</span>'+
          '<i class="cp-tpl-txt" id="cpTplTxt">'+esc(cpTemplateRetomar())+'</i>'+
          '<button type="button" class="cad-btn cp-tpl-bt" id="cpTplBt">Enviar template</button>';
      }
      comp.parentNode.insertBefore(d2, comp);
      var _bt=$('cpTplBt');
      if(_bt) _bt.onclick=async function(){
        var txt=String(($('cpTplTxt')||{}).textContent||'').trim();
        if(!txt) return;
        _bt.disabled=true; _bt.textContent='Enviando…';
        /* 🔴 `confirmo:true` é o que o servidor pede pro caso "esfriou" — e
           é honesto mandá-lo aqui: a tela ACABOU de mostrar há quanto tempo
           ele não fala, que é exatamente o que a confirmação existe pra
           garantir que alguém olhou. */
        var r=null;
        try{ r=await _chatApi({acao:'enviar',telefone:_cpFone,texto:txt,confirmo:true}); }catch(_){ r=null; }
        if(r && r.ok){ toast('Template enviado ✓'); cpCliThread(true); }
        else{
          _bt.disabled=false; _bt.textContent='Enviar template';
          toast((r&&r.erro)||'Não consegui enviar.');
        }
      };
      return;
    }
    inp.disabled=false; if(snd) snd.disabled=false;
    /* v530: o rascunho vence o template, e só entra UMA vez (senão ele
       voltaria a cada repintura de 8s, por cima do que você digitou) */
    if(_cpRascunho && !String(inp.value||'').trim()){
      inp.value=_cpRascunho; _cpRascunho='';
      inp.rows=3; inp.placeholder='Responder pelo WhatsApp…';
      return;
    }
    if(_cpVirgem(ms)){
      inp.placeholder='Primeira mensagem…';
      /* ⚠️ o template tem ~70 caracteres e não cabe em 1 linha num celular
         de 360px — sem isto ele nasce cortado, e cortado parece defeito. */
      inp.rows=2;
      if(!String(inp.value||'').trim()) inp.value=cpTemplatePrimeiro();
    } else {
      inp.rows=1;
      inp.placeholder='Responder pelo WhatsApp…';
    }
  }

  /* ---- a folha do editor (o que era a faixa) ---- */
  function cpFichaAbrir(){
    if(typeof chCadCamposHtml!=='function'){ toast('O cadastro não está disponível agora.'); return; }
    if($('cpFxMask')) return;
    var c=_cpFxCliente();
    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='cpFxMask';
    ov.innerHTML='<div class="cropbox cpfx-box">'+
      '<div class="crop-tit">'+(c?'Ficha do cliente':'Cadastrar este contato')+'</div>'+
      '<div class="cpfx-bd" id="cpFxBd">'+chCadCamposHtml(c,_cpFxCv(),'cpc')+'</div>'+
      '<button type="button" class="link" id="cpFxNao" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#cpFxNao').onclick=close;
    try{
      chCadLiga(c, _cpFxCv(), 'cpc', function(){
        /* gravou — e a ficha pode ter acabado de NASCER: recarrega, corrige
           a etiqueta do cabeçalho e fecha. */
        try{
          if(typeof cliCarregar==='function') cliCarregar().then(function(){ cpCabPinta(); close(); });
          else { cpCabPinta(); close(); }
        }catch(_){ close(); }
      });
    }catch(_){}
  }

  /* ==========================================================================
     v543 — OS TRACINHOS DO WHATSAPP  (pedido: "coloque os tracinhos nas
     mensagens de entregue, recebido, e azul quando lido")

     ⚠️ A NOTA ANTIGA DA FILA ESTAVA ERRADA. Ela dizia "o CSS .cp-tic já
     existe desde a v509, é só ligar". O que a v509 fez foi o tique da aba
     LOJAS — o chat INTERNO entre lojistas, outra tabela, outro
     renderizador, e lá o dado era a coluna `lida`, que já vinha de graça.
     No WhatsApp não vinha nada: faltava coluna no banco, faltava guardar o
     protocolo no envio e faltava alguém escutando a Z-API. É por isso que
     a v543 é uma versão inteira e não uma linha.

     O QUE APROVEITA DE VERDADE da v509: o desenho (CP_TIC1/CP_TIC2) e as
     três linhas de CSS (.cp-tic e .cp-tic.lida). Nada de estilo novo — os
     dois chats ficam idênticos ao olho, que é o certo.

     🔴 SEM STATUS, SEM TRACINHO — e isso é regra, não descuido.
     As mensagens que o Angelo manda pelo CELULAR da loja entram por outro
     caminho (o webhook do MEV Tools) e nunca terão protocolo. Pintar um ✓
     cinza nelas seria afirmar "só saiu" numa mensagem que pode ter sido
     lida ontem. O app não sabe — então o app não fala.

     ⚠️ Nas mensagens DELE não entra tracinho: quem leu fui eu, e o
     WhatsApp de verdade também não mostra.
     ========================================================================= */
  function cpTicHtml(m){
    if(!m || m.direcao!=='enviada') return '';
    var s=String(m.status||'');
    if(s!=='enviada' && s!=='entregue' && s!=='lida') return '';
    var lida=(s==='lida');
    var rot=lida?'lida':(s==='entregue'?'entregue':'enviada');
    return '<em class="cp-tic'+(lida?' lida':'')+'" aria-label="'+rot+'" title="'+rot+'">'+
           (s==='enviada'?CP_TIC1:CP_TIC2)+'</em>';
  }

  async function cpCliThread(silencioso){
    var body=$('cpBody'); if(!body || !_cpFone) return;
    if(!silencioso){
      /* 🔁 v529 — SAIU a faixa e SAIU a `cp-avisa`.
         A explicação "A MESMA conversa do WhatsApp" morreu por regra da
         casa (não se explica botão na tela) — e o compositor já diz
         sozinho, no placeholder "Responder pelo WhatsApp…".
         🔴 Mas metade daquela frase não era explicação, era CONSEQUÊNCIA:
         "responder aqui pausa a IA por 30 min". Isso o sistema FAZ e o
         usuário não vê. Virou a linha `cp-ia`, pequena e informativa, que
         diz o estado em duas palavras — ver `cpIaHtml`. */
      /* v552: a linha da IA mora DENTRO do cpCabHtml — nada entre o
         cabeçalho e a conversa. */
      body.innerHTML=cpCabHtml(_cpFoneNome)+
        '<div class="cp-th" id="cpTh"><div class="cli-empty" style="padding:12px">Carregando…</div></div>'+
        '<div class="cp-comp"><button type="button" class="cp-clip" id="cpClip" aria-label="Mais ações" aria-expanded="false" title="Mais ações">'+CP_MAIS+'</button><textarea class="cad-in" id="cpIn" rows="1" placeholder="Responder pelo WhatsApp…"></textarea>'+
        '<button type="button" class="crm-send" id="cpSend" title="Enviar">'+_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>';
      $('cpVolta').onclick=function(){ _cpFone=null; cpRepintaZera(); cpPinta(); };
      var _be=$('cpEdit'); if(_be) _be.onclick=cpFichaAbrir;
      cpMaisWire();
      $('cpSend').onclick=cpCliEnviar;
      cpRepintaZera();   /* v561: conversa nova, tela nova — pode pintar */
      var inp=$('cpIn');
      inp.addEventListener('keydown',function(e){ if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); cpCliEnviar(); } });
      _cpPararTimer();
      _cpTimer=setInterval(function(){
        if(document.getElementById('cpTh') && _cpFone) cpCliThread(true); else _cpPararTimer();
      },8000);
    }
    var box=$('cpTh'); if(!box) return;
    var d=await _chatApi({acao:'listar',telefone:_cpFone});
    /* v529: quem sabe da pausa com precisão é o SERVIDOR (a regra mora no
       atendente-whatsapp: 'enviada' recente que não é da IA = humano no
       comando). O `listar` passou a devolver isso. */
    if(d && d.ok && typeof d.ia!=='undefined'){ _cpIa=(d.ia==='pausada')?'pausada':'ativa'; cpIaPinta(); }
    /* v554: abrir a conversa acabou de marcar as recebidas como lidas no
       servidor (efeito do `listar`, v433) — a bolinha não pode esperar os
       3 min do cache pra contar isso. Só na abertura de verdade, não a
       cada repintura de 8s. */
    if(d && d.ok && !silencioso){ _cpBadgeCli.em=0; try{ chatBadgeAtualiza(); }catch(_){} }
    box=$('cpTh'); if(!box) return;
    if(!d || !d.ok){ if(!silencioso) box.innerHTML='<div class="cli-empty" style="padding:12px">'+esc((d&&d.erro)||'Não consegui carregar a conversa.')+'</div>'; return; }
    var ms=(d.mensagens||[]);
    /* 🔴 v522 — O VAZIO É O CASO COMUM, NÃO A EXCEÇÃO.
       Medido em 16/08: 107 fichas no CRM contra 10 conversas de WhatsApp.
       Quer dizer que o botão novo da linha do CRM vai cair AQUI na maioria
       dos cliques. "Nenhuma mensagem ainda" sozinho tem cara de defeito —
       a pessoa clicou, veio nada, e ela não sabe se o app falhou.
       Então o vazio DIZ o que é e oferece a saída: o WhatsApp, que é onde
       toda conversa nasce (o atendente só passa a responder aqui depois
       que o cliente escreve pela primeira vez). */
    if(!ms.length){
      /* 🔁 v529: o vazio deixou de ser um beco. O compositor abaixo já vem
         com a primeira mensagem escrita — dá pra editar antes de mandar. */
      var _wa=(typeof cliWhatsUrl==='function')?cliWhatsUrl(_cpFone):'';
      cpRepinta(box, '<div class="cli-empty cp-vazio" style="padding:16px">'+
        '<b>Ainda não há conversa com '+esc(_cpFoneNome||'este cliente')+'</b>'+
        /* ⚠️ nada de <b> aqui dentro: o `.cli-empty b` é display:block, e
           um negrito no meio da frase a quebraria em três pedaços. */
        'Mande a primeira mensagem aqui embaixo — <i class="cp-forte">uma só</i>, e o app espera ele responder pra destravar o resto.'+
        (_wa?('<a class="cad-btn sec cp-vz-wa" href="'+esc(_wa)+'" target="_blank" rel="noopener">Ou chamar no WhatsApp</a>'):'')+
        '</div>', silencioso);
      cpCompEstado(ms);
      return;
    }
    cpRepinta(box, ms.map(function(m){
      var dt=new Date(m.criado_em), hh=('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
      /* v547: no card do carro a foto vira a CAPA do card; fora dele
         continua o link de sempre. Sem este `ehCard`, a mesma foto
         apareceria duas vezes na mesma bolha. */
      var ehCard=(String(m.texto||'').indexOf('🚗')===0);
      var capa=(ehCard && m.midia_tipo==='image') ? m.midia_url : '';
      /* ================================================================
         v553 (pedido, com print): "cliente mandou foto, mas não aparece
         no chat, permita visualizar".
         O banco SEMPRE teve a foto (midia_url vem no listar desde a
         v543) — a bolha é que escrevia só o link "[foto]". Agora:
           · imagem → a PRÓPRIA foto na bolha, e o toque abre a original
             (mesmo target=_blank que o [anexo] já usava);
           · áudio  → um player na bolha (o CSP já libera media-src
             https:) — era o "🎤 Áudio" morto;
           · o resto continua o link [anexo] de sempre.
         ⚠️ O link da mídia é da Z-API e PODE expirar: o `onerror` da
         imagem devolve o "[foto]" antigo em vez de deixar um quadrado
         quebrado — a bolha nunca fica pior do que era antes da v553.
         ⚠️ `esc()` na URL continua obrigatório (ela vem de fora). */
      var media='';
      if(m.midia_url && !capa){
        if(m.midia_tipo==='image'){
          /* v560: era <a target="_blank"> (v553) — jogava o usuário pro
             Safari e deixava a conversa pra trás. Agora é um BOTÃO que abre
             o visor aqui dentro (cpFotoAbrir). O endereço vai num data-,
             não num onclick: quem escuta é o clique do painel, um ouvinte
             só pra conversa inteira. */
          media='<button type="button" class="cp-fimg" data-foto="'+esc(m.midia_url)+'" aria-label="Ampliar a foto">'+
            '<img src="'+esc(m.midia_url)+'" alt="Foto" loading="lazy" '+
            'onerror="this.parentNode.textContent=\'[foto]\'"></button>';
        } else if(m.midia_tipo==='audio'){
          media='<span class="cp-faud"><audio controls preload="none" src="'+esc(m.midia_url)+'"></audio></span>';
        } else {
          media='<a href="'+esc(m.midia_url)+'" target="_blank" rel="noopener">[anexo] </a>';
        }
      }
      return '<div class="cp-b '+(m.direcao==='enviada'?'eu':'ele')+'">'+media+_cpBolhaHtml(m.texto, capa)+'<i>'+hh+cpTicHtml(m)+'</i></div>';
    }).join(''), silencioso);   /* v561: só repinta se mudou; a rolagem é dele */
    cpFotoLigar(box);   /* v560: o toque na foto abre o visor, não outra aba */
    cpCompEstado(ms);   /* v529: trava/destrava conforme o estado */
  }
  async function cpCliEnviar(){
    var inp=$('cpIn'); if(!inp || !_cpFone) return;
    var t=String(inp.value||'').trim(); if(!t) return;
    inp.disabled=true;
    /* v529: `primeiro:true` é o que abre a exceção da v510 no servidor —
       e ela só é pedida quando a conversa está REALMENTE vazia na tela. */
    var _virgem=!document.querySelector('#cpTh .cp-b');
    /* 🔴 v547 — a capa só acompanha se o texto AINDA for o do carro.
       Sem esta conferência, anexar um veículo, apagar tudo e escrever outra
       coisa mandaria a foto do carro colada numa mensagem que não fala dele.
       O 🚗 é o mesmo sinal que faz a mensagem virar card (v474). */
    var _foto=(_cpFotoAnexo && t.indexOf('🚗')>=0) ? _cpFotoAnexo : '';
    var _env={acao:'enviar',telefone:_cpFone,texto:t};
    if(_virgem) _env.primeiro=true;
    if(_foto) _env.foto=_foto;
    var r=await _chatApi(_env);
    inp.disabled=false;
    if(r&&r.ok){
      /* 🔴 v529: respondi por aqui ⇒ a IA ACABOU de ser pausada. O app sabe
         a hora exata; não precisa esperar a próxima ida ao servidor pra
         contar isso pra quem está olhando a tela. */
      _cpIa='pausada'; cpIaPinta();
      _cpFotoAnexo='';                  /* v547: a capa vale por UM envio */
      inp.value=''; cpCliThread(true); var bx=$('cpTh'); if(bx) bx.scrollTop=bx.scrollHeight; }
    else toast((r&&r.erro)||'Não consegui enviar.');
    try{ inp.focus(); }catch(_){}
  }

  /* ---------- a bolinha do balão (v473: lojas + clientes somados) --------- */
  /* ⛳ v554 (pedido): "o número de notificações deve aparecer apenas quando
     tem mensagem não lida". Isto REVERTE, de propósito, o critério da v523
     (contar ESPERANDO): o Angelo quer a bolinha no sentido do WhatsApp —
     número = conversas com mensagem que ele ainda NÃO ABRIU. A fila
     "esperando" NÃO morreu: continua como filtro e selo DENTRO do painel;
     só saiu da bolinha. Abrir a conversa zera na hora (o `listar` já marca
     `lida` no servidor desde sempre — v433). `false` volta ao critério da
     v523. */
  var BADGE_SO_NAO_LIDA = true;
  /* ⛳ v563 — conversa removida do chat não conta na bolinha (ver o bloco
     grande dentro do chatBadgeAtualiza). */
  var BADGE_IGNORA_REMOVIDA = true;
  var _cpBadgeCli={ n:0, em:0 };   /* o resumo dos clientes é caro: cache 3 min */
  async function chatBadgeAtualiza(){
    try{
      if(!token || !meuId) return;
      var n=0;
      try{
        var r=await supa.from('chat_lojista').select('id').eq('para_user',meuId).eq('lida',false).limit(99);
        n+=((r&&r.data)||[]).length;
      }catch(_){}
      /* v473 — o lado dos CLIENTES entra na soma (resumo do mesmo
         /api/chat-whatsapp; só a cada 3 min pra não pesar no servidor)

         🔴🔴 v523 — A BOLINHA MENTIA, E IA MENTIR PIOR
         Ela somava NÃO-LIDAS. Medido em 16/08: 208 mensagens, 10 conversas,
         **7 esperando resposta** e **1 não lida**. Ou seja: a bolinha
         mostrava 1 com 7 pessoas na fila.
         Enquanto existia a página Chat, o "7 esperando" aparecia lá e a
         conta fechava na cabeça de quem olhava. Quando o balão virar a
         ÚNICA porta (Parte 3), uma bolinha "1" com 7 esperando é mentira na
         cara do usuário — e é o número que faz alguém abrir o app.
         Agora ela conta CONVERSAS ESPERANDO: a última mensagem é do
         cliente. Mesma regra do `_chEsperando` (12d) — nada de segunda
         definição de "esperando" no app.
         ⚠️ As não-lidas continuam contando pro chat de LOJISTAS (acima):
         lá não existe "esperando", existe lido e não lido. */
      try{
        if(Date.now()-_cpBadgeCli.em>180000){
          var dc=await _chatApi({acao:'resumo'});
          if(dc && dc.ok){
            var cvs2=(dc.conversas||[]);
            /* v554: o critério virou NÃO LIDA. O ESPERANDO da v523 fica
               atrás do ⛳.
               🔴 SOMA MENSAGENS, NÃO CONTA CONVERSAS — e isso não é detalhe:
               o lado dos LOJISTAS (logo acima) sempre contou MENSAGENS não
               lidas. Se este lado contasse CONVERSAS, a bolinha somaria
               laranja com maçã e o número não significaria nada — é a mesma
               família de erro que a v523 apontou. Foi o teste-v473 (que
               semeia 2+1 não lidas e cobra "5") que pegou isto. */
            /* ===== v563 — A BOLINHA CONTAVA CONVERSA QUE A LISTA ESCONDE ===
               Pedido do Angelo (18/08, com print): *"só mostre o número no
               chat se tiver mensagem não lida VISÍVEL no chat"*.

               🔴 PROVADO NO BANCO, não deduzido: havia exatamente UMA
               mensagem não lida (a da OHANA, final 97083434, de 17/08 00:01)
               — e essa MESMA conversa está na `mp_chat_removido`, removida
               do chat em 17/08 19:19. A lista escondia; a bolinha contava.
               Resultado: um "1" que ele não conseguia zerar de jeito nenhum,
               porque não existia conversa pra abrir.

               A régua do que aparece já existe e é o `chatRemovida` (12l).
               Agora a bolinha usa A MESMA — nada de segunda definição de
               "removida" no app (a lição da v508/v560).
               ⚠️ O `remCarregar` é chamado aqui porque a bolinha roda de 60
               em 60 segundos DESDE O INÍCIO do app, muito antes de alguém
               abrir o painel. Sem ele o `_remSet` estaria vazio e a bolinha
               voltaria a contar as removidas até o primeiro toque no balão.
               ⛳ BADGE_IGNORA_REMOVIDA = false volta a contar tudo. */
            if(BADGE_SO_NAO_LIDA){
              if(BADGE_IGNORA_REMOVIDA){
                try{ if(typeof remCarregar==='function') await remCarregar(); }catch(_){}
                try{
                  if(typeof chatRemovida==='function')
                    cvs2 = cvs2.filter(function(c2){ return !chatRemovida(c2); });
                }catch(_){}
              }
              _cpBadgeCli.n = cvs2.reduce(function(s2,c2){ return s2+(Number(c2.nao_lidas)||0); },0);
            } else {
              _cpBadgeCli.n = (typeof _chEsperando==='function')
                ? cvs2.filter(function(c2){ return _chEsperando(c2); }).length
                : cvs2.reduce(function(s2,c2){ return s2+(Number(c2.nao_lidas)||0); },0);
            }
            _cpBadgeCli.em=Date.now();
          }
        }
        n+=_cpBadgeCli.n;
      }catch(_){}
      /* v763: o contador vale pros DOIS lugares — o balão (#chatFabN) e o
         botão do cabeçalho (#tbChatN, 05d). Mesmo número, mesma hora. */
      var _tx=(n>99?'99+':String(n));
      var b=$('chatFabN');
      if(b){ if(n>0){ b.style.display='flex'; b.textContent=_tx; } else b.style.display='none'; }
      var b2=$('tbChatN');
      if(b2){ if(n>0){ b2.style.display='block'; b2.textContent=_tx; } else b2.style.display='none'; }
    }catch(_){}
  }
  try{
    _cpBadgeTimer=setInterval(chatBadgeAtualiza, 60000);
    setTimeout(chatBadgeAtualiza, 4000);
    document.addEventListener('visibilitychange',function(){ if(document.visibilityState==='visible') chatBadgeAtualiza(); });
  }catch(_){}

/* ╔═══ src/app/11-uso-pagamentos.js ══════════════════════════════════════ */
  /* ================= USO E PAGAMENTOS =================
     Créditos avulsos e assinatura da loja são produtos diferentes. Esta tela
     mostra os dois sem transformar uma referência comercial em limite ativo. */
  /* Os mesmos ids, preços e créditos são validados no servidor em cobranca.js.
     O saldo pertence à loja: os usuários consomem a mesma carteira. */
  /* v285 — DUAS LINHAS SAÍRAM DE TODOS OS PLANOS:
     · "Paga somente pelo que usar" — contradizia o próprio card. Num plano de
       valor fixo essa frase lê como erro, e erro no card mais caro derruba a
       confiança justamente na hora de decidir.
     · "Sem anúncios" — o app não tem anúncio nenhum. Anunciar isso como
       vantagem faz o lojista perguntar "então a versão de graça tem?".
     E o Essencial passou de 2 para 3 usuários: dono mais dois vendedores é o
     tamanho de uma revenda pequena de verdade.

     v285-b — VEÍCULOS ILIMITADOS EM TODOS OS PLANOS.
     O limite de veículos era o pior dos dois: a Santa Luzia tem 14 carros e
     não cabia no plano de entrada, que permitia 10. Limitar o estoque também
     castiga justamente quem usa mais o sistema — e o custo de um carro a mais
     no banco é praticamente zero.
     A escada agora sobe por USUÁRIOS e CRÉDITOS, que são as duas coisas que
     realmente custam: gente mexendo no sistema e consulta paga por uso. */
  /* v344 — TABELA NOVA (07/08/2026). Espelha cobranca.js, que é a fonte de
     verdade; se mudar aqui, mude LÁ também (o servidor nunca aceita preço
     vindo do navegador).
     · O plano de entrada agora é PARA UM VENDEDOR — 1 usuário, R$ 199. Ele
       compra sem depender do dono da loja.
     · Os tokens subiram (25→50, 50→120, 100→250) porque a escada antiga não
       subia: com token extra fixo em R$ 1,90, o salto de R$ 150 entregava só
       R$ 47,50 em token, e ficar no plano de baixo era SEMPRE mais barato.
       Ver a explicação completa no comentário de cobranca.js. */
  /* ⚠️ v452 — ESTA LISTA VIROU A ÚNICA COISA QUE SEPARA OS DOIS PLANOS NA
     TELA. Antes a diferença entre Vendedor e Lojista era só a quantidade de
     token, e token não faz ninguém subir de plano — faz recarregar. Agora a
     linha da Rede de Repasse é o degrau: o Vendedor VÊ e OFERTA, o Lojista
     PUBLICA. Se mexer nestes textos, mexer junto na trava de verdade, que
     mora no 09c-plano-repasse.js — texto e código dizendo coisas diferentes
     é como se vende uma reclamação. */
  /* ⚠️ v504 — O PARCEIRO (R$ 99,90) É O NOVO DEGRAU DE ENTRADA.
     Pedido do Angelo (15/08): "cria o pacote parceiro, consultas próprias,
     escolhe os veículos que quer anunciar de lojistas, usa a plataforma e
     paga um valor menor 99,90 — se for cadastrar veículos pra anunciar,
     vira lojista 199" + "adiciona umas consultas de brinde pro parceiro".

     É o vendedor EXTERNO / agenciador: marca própria, WhatsApp próprio,
     vende alguns carros e motos e faz parceria com lojas. A ferramenta dele
     já existia desde 06/08 — a vitrine do 16b-vitrine-vendedor.js — e nunca
     tinha aparecido num card de preço. Por isso a VITRINE é o primeiro
     benefício da lista: é o que ele compra.
     ⚠️ Espelhado no cobranca.js, que é a fonte de verdade.
     ⚠️ veiculos:0 é ZERO, não "ilimitado" — quem desenha trata no
     pagPlanoCardHtml e quem trava de verdade é o planoLimiteVeiculos (09c). */
  /* ⚠️ v506 (pedido do Angelo, olhando o print dos cards): a LINHA DOS
     VEÍCULOS não se repete mais. Cada card já tem, no alto, a linha fixa que
     o pagPlanoCardHtml monta ("Até 20 veículos" / "Veículos ilimitados" /
     "Sem estoque próprio") — e a lista de benefícios repetia a mesma frase
     logo abaixo ("Até 20 veículos no estoque"). Com três cards passava
     batido; com quatro, e o Vendedor Parceiro precisando de espaço pra
     explicar a vitrine, virava ruído. Nenhuma informação se perdeu: a linha
     do topo é a mesma verdade, e é ela que o teste confere.
     ⚠️ Quem for acrescentar benefício aqui: NÃO escreva de novo o número de
     veículos nem "ilimitado no estoque". O teste-v504 reprova. */
  /* ======================================================================
     v534 (pedido) — PREÇOS NOVOS E A VITRINE EM DOIS ANDARES

     "deixe os planos em 149, 249, 349, 449 — parceiro, vendedor, lojista,
      max" + "coloque os dois planos de vendedor no fim da página pra não
      queimar o plano lojista — não tem loja? veja essas ofertas"

     📏 A ESCADA NOVA (a de ontem entre parênteses):
         Vendedor Parceiro .. R$ 149  (99,90)
         Vendedor ........... R$ 249  (199)
         Lojista ............ R$ 349  (299)   ← "Mais escolhido"
         Max ................ R$ 449  (499)   🔴 este DESCEU

     🔴 A VITRINE VIROU DOIS ANDARES, e é isto que resolve o problema que o
     Angelo enxergou: com os quatro lado a lado, o olho de quem tem loja bate
     primeiro no card de R$ 149 e o Lojista de R$ 349 vira "o caro". Só que o
     de R$ 149 **não serve pra quem tem loja** — ele não publica no repasse e
     não tem estoque próprio. O card barato não estava competindo: estava
     confundindo.
     Agora quem tem loja vê só os planos de loja. Os de vendedor ficam
     embaixo, atrás de uma pergunta que só o público deles responde "sim":
     **"Não tem loja?"**.

     ⚠️ Quem decide o andar é o campo `publico`, não a posição na lista. A
     v504 já aprendeu essa lição do jeito difícil (era por índice e um plano
     novo no começo rebaixava todo mundo um degrau).
     ⚠️ E a ordem DENTRO de cada andar continua do mais caro pro mais barato,
     que é o pedido da v505.

     ⛳ Pra voltar tudo num andar só: `PAG_DOIS_ANDARES = false`. */
  /* ======================================================================
     🔴 v635 (pedido do Angelo, 25/08) — OS TRÊS PLANOS LOJISTA
     ======================================================================
     "pacote vendedor parceiro exclui, pacote vendedor vira lojista starter,
      o outro, lojista pro e o outro Lojista Max"

         id             era                  virou
         -------------------------------------------------------
         parceiro       Vendedor Parceiro    — sai da vitrine —
         essencial      Vendedor             Lojista Starter   R$ 249
         profissional   Lojista              Lojista Pro       R$ 349  ← destaque
         max            Max                  Lojista Max       R$ 449

     🔴 OS ids NÃO MUDARAM, e isso não é preguiça. Eles estão no BANCO
     (`mp_cobranca.plano_id`, `mp_portal_membro.plano_id`), no cobranca.js e
     em todos os testes. Trocar id quebraria assinatura de cliente pagante —
     o tipo de estrago que só aparece na renovação, semanas depois. É a mesma
     decisão da v502 ("MEV Loja virou MEV ESTOQUE; o id continua `loja`").

     🔴 "EXCLUIR" NÃO É APAGAR. O `parceiro` sai da vitrine com
     `aVenda:false` — o mecanismo que a casa JÁ TEM (v533) — e a definição
     dele fica inteira. Se alguém abrir o app com uma assinatura antiga
     gravada como `parceiro`, o app precisa saber dizer o que é isso; senão a
     tela do plano nasce vazia e calada. Mesma disciplina da Vitrine (v568) e
     do `mp-criar-pix` de hoje: desligar mostrando o caminho, nunca sumir.
     ✅ Conferido no banco antes: ninguém paga o `parceiro` hoje.

     🔴 A VITRINE VOLTOU A UM ANDAR SÓ. Com os três virando "Lojista",
     `publico:'vendedor'` ficaria sem ninguém — e o andar de baixo viraria uma
     seção vazia com a pergunta "Não tem loja?" sem resposta. O interruptor
     que a v534 deixou pronto (`PAG_DOIS_ANDARES=false`) faz exatamente isso.

     ⚠️ A v635 NÃO mexeu em prazo de token, de propósito: os cards diziam
     "60 dias / nunca expiram" porque era o que o código fazia. A v636 mudou
     a REGRA no banco (lotes com validade) e trocou estes textos NA MESMA
     versão — texto e regra andam juntos, nunca um antes do outro.

     📏 E a escada continua uniforme com três degraus: 249 → 349 → 449,
        +R$100 por +30 tokens. Isso não quebrou. ✓
     ⚠️ A porta de entrada subiu de R$ 149 para R$ 249. É escolha do Angelo,
        registrada: o app deixa de mirar o vendedor solto e passa a mirar só
        quem tem loja. Não foi efeito colateral da troca de nome.
     ====================================================================== */
  var _PAG_PLANOS=[
    /* ⛳ v635 — FORA DA VITRINE, e inteiro no código (ver o cabeçalho). */
    { id:'parceiro', nome:'Vendedor Parceiro', valor:149.00, usuarios:1, veiculos:0, tokens_mensais:30,
      aVenda:false,
      publico:'vendedor',   /* v534 — andar de baixo: quem NÃO tem loja */
      /* ⛳ v539 (pedido): saiu "Toda a estrutura do MEV". Aparecia IGUAL nos
         quatro cards — linha repetida não compara nada, só empurra pra baixo
         as que decidem (usuários, veículos, tokens). O que ela dizia já está
         dito pelo resto da lista. */
      beneficios:['Vitrine própria: seu link, sua marca, seu WhatsApp',
                  'Escolha carros das lojas parceiras e anuncie na sua vitrine',
                  'R$ 57,00 de saldo mensal na carteira',
                  'Rede de Repasse: ver os carros e fazer ofertas',
                  'Todo saldo vale 30 dias'] },
    /* v452 (pedido): o Vendedor ganhou TETO DE 20 VEÍCULOS no estoque.
       É teto, não contador mensal: vendeu um, abre uma vaga. Contador que
       zera todo dia 1º precisaria guardar quantos entraram em cada mês, e é
       mais difícil de explicar pro lojista do que "cabem 20 no pátio".
       ⚠️ Este número TAMBÉM está no cobranca.js (fonte de verdade) e é
       cobrado de verdade no estSalvarAuto do 14-estoque.js. Os três andam
       juntos — número no card que o app não cumpre vira reclamação. */
    { id:'essencial', nome:'Lojista Starter', valor:249.00, usuarios:1, veiculos:20, tokens_mensais:60, aVenda:false,
      publico:'loja',   /* v635 — os três são de loja agora */
      beneficios:['R$ 114,00 de saldo mensal na carteira','Rede de Repasse: ver os carros e fazer ofertas','Todo saldo vale 30 dias'] },
    /* v451 (pedido): o Lojista passou de 5 para ATÉ 3 USUÁRIOS — dono e dois
       vendedores. Quem precisa de mais gente sobe pro Max, que é ilimitado.
       ⚠️ Espelhar em cobranca.js, que é a fonte de verdade. */
    /* ======================================================================
       🔴 A COLUNA DE TOKENS DA v534 (definida pelo Angelo, e ela fecha)

       📏 A régua: o token mais barato que o lojista consegue comprar hoje é
       o pacote Pro — R$149,90 por 100 = **R$1,50 cada**. É contra ESSE preço
       que o plano tem que ser comparado, não contra o avulso de R$1,90.

       A REGRA DE OURO DA ESCADA: cada degrau custa +R$100, e os tokens que
       ele entrega têm que valer MENOS que R$100. Se valerem mais, subir vira
       lucro pro cliente e o plano de cima come o de baixo — foi por isso que
       o Max caiu de 250 pra 150 nesta mesma versão.

           plano      preço   tokens   valem    sobra p/ estrutura
           Parceiro   149      30      R$ 45         R$ 104
           Vendedor   249      60      R$ 90         R$ 159
           Lojista    349      90      R$135         R$ 214
           Max        449     120      R$180         R$ 269

           degrau P→V: +R$100 leva R$45   ✓
           degrau V→L: +R$100 leva R$45   ✓
           degrau L→M: +R$100 leva R$45   ✓

       🔴 v536 — O MAX FOI DE 150 PRA 120 E A ESCADA FICOU UNIFORME: agora
       TODO degrau é +R$100 por +30 tokens, e a estrutura sobe exatamente
       R$55 por degrau (104 · 159 · 214 · 269). Antes o último degrau era o
       dobro dos outros (+60 tokens) e por isso o único apertado.
       ⚠️ Regra que continua valendo: escada uniforme é fácil de defender na
       conversa de venda — "cada R$100 a mais te dá 30 tokens e o próximo
       nível de estrutura". Escada irregular obriga a explicar exceção.

       🔴 E a coluna da direita SOBE SEMPRE. Isso não é enfeite: quando a
       estrutura de um plano vale menos que a do plano abaixo, o de baixo
       vira a escolha óbvia e o de cima vira vitrine morta. Numa versão
       intermediária desta v534 o Lojista tinha R$169 contra R$174 do
       Vendedor — invertido, e ninguém teria visto na planilha.

       ⚠️ MEXEU EM UM NÚMERO, REFAÇA A COLUNA INTEIRA. E mexa nos TRÊS
       lugares: aqui, no texto do benefício logo abaixo, e no cobranca.js.
       Número no card que o servidor não credita vira reclamação. */
    /* 🔴 o destaque ("Mais escolhido") está preso AO id, não à posição na
       lista — posição é acidente, id é intenção. */
    { id:'profissional', nome:'Lojista Pro', valor:349.00, usuarios:3, veiculos:null, tokens_mensais:90, aVenda:false,
      publico:'loja',   /* v534 — andar de cima */
      beneficios:['R$ 171,00 de saldo mensal na carteira da loja','Publicar seus carros na Rede de Repasse','CRM de clientes e catálogo','Todo saldo vale 30 dias'] },
    /* 🔴 v534 → v536 — O MAX CAIU DE 250 PRA 150 (v534) E DEPOIS PRA 120
       (v536, pedido do Angelo). O motivo é aritmética,
       não economia de brinde.
       📏 O token mais barato que o lojista consegue comprar hoje é o pacote
       Pro: R$149,90 por 100 = **R$1,50 cada**. É contra esse preço que o
       plano tem que ser comparado, não contra o avulso de R$1,90.
       Com 250 tokens e o Max a R$449, o degrau Lojista→Max ficava assim:
             paga +R$100  ·  recebe +130 tokens = R$195
       ou seja, **subir dava LUCRO pro cliente** — e o Max é o plano que
       menos sobra pra estrutura. Todo Lojista que usa token deveria subir,
       e o Lojista (o "Mais escolhido") virava plano de passagem. Era o
       contrário do pedido de não queimar o Lojista: a vitrine protegia ele e
       a tabela de preço o afundava.
       Com 120:  paga +R$100 · recebe +30 tokens (R$45) → R$55 de estrutura,
       exatamente o mesmo de todos os outros degraus.
       Quem sobe pro Max sobe por usuários ilimitados, não por token barato.
       📏 E a estrutura do Max vai de R$74 (com 250) pra R$269 — a maior da
       tabela, que é como tem que ser no plano mais caro.
       ⚠️ Reparo lateral: 120 é também o tamanho do pacote Pro (R$179,90).
       Não é conflito, é uma boa régua de conversa — os mesmos 120 tokens
       custam R$179,90 avulsos; no Max eles vêm todo mês, e os R$269 de
       diferença são a estrutura inteira. */
    { id:'max', nome:'Lojista Max', valor:449.00, usuarios:null, veiculos:null, tokens_mensais:120, aVenda:false,
      publico:'loja',   /* v534 */
      beneficios:['R$ 228,00 de saldo mensal na carteira da loja','Publicar seus carros na Rede de Repasse','CRM de clientes e catálogo','Todo saldo vale 30 dias'] },
    { id:'unico300', nome:'MEV Único', valor:300.00, usuarios:3, veiculos:null, tokens_mensais:157.89, publico:'loja',
      beneficios:['R$ 300,00 de saldo mensal na carteira da loja','Consultas e recursos com preços em reais','Publicar seus carros na Rede de Repasse','CRM de clientes e catálogo','Todo saldo vale 30 dias'] },
    /* v993 — oferta exclusiva da edição MEV Consultas. O valor interno
       preserva a conversão legada de R$ 1,90 por unidade: 78,42 = R$ 149,00
       quando apresentado em reais. Não libera estoque, CRM nem repasse. */
    { id:'consultas149', nome:'Assinatura mensal', valor:149.00, usuarios:1, veiculos:0, tokens_mensais:78.42, publico:'consultas', aVenda:false,
      beneficios:['Valor da assinatura convertido em saldo para consultas durante 30 dias'] }
  ];
  /* Add-on vendido à parte, em cima de qualquer plano. Fica só como vitrine:
     o botão abre a conversa, quem liga a assinatura é o Angelo. Colocar aqui
     porque add-on que o cliente não vê não é vendido — e este é o produto de
     maior margem da casa (custo ~R$ 75 em 500 conversas). */
  /* v400 (pedido): 299,90 → 349,90 */
  var _PAG_ADDON={
    nome:'Atendente IA no WhatsApp', valor:349.90, whats:'5551996417433',
    linhas:['Responde 24h com o seu estoque real','Manda o cartão do carro com foto, preço e link','Cala a boca na hora em que o vendedor assume','Até 500 conversas por mês']
  };
  var _pagCarga=0;
  function pagPlanoDaAssinatura(){
    if(_ehAdmin()) return { id:'admin', nome:'Acesso administrativo', valor:0, usuarios:null, veiculos:null, tokens_mensais:0, ativo:true, especial:true };
    var a=(_assinatura&&_assinatura.assinatura)||null;
    if(!a || !a.ativo || (a.dias!=null && a.dias<0)) return null;
    var id=String(a.id||a.plano_id||'').toLowerCase(); if(id==='ilimitado') id='max';
    var base=_PAG_PLANOS.filter(function(p){ return p.id===id; })[0];
    /* v344 — as faixas mudaram junto com os preços. Antes eram 150/250, que
       com a tabela nova (199/299/499) jogaria um Lojista de R$ 299 pro card
       do Max. Estes cortes funcionam para as duas tabelas: a antiga
       (149,90/299,90/449,90) e a nova. */
    /* ⚠️ v504 — POR ID, NÃO POR ÍNDICE. Era _PAG_PLANOS[2]/[1]/[0], e o
       Parceiro entrando na frente da lista teria empurrado todo mundo um
       degrau: um assinante de R$ 299 sem id gravado viraria "Parceiro" em
       silêncio e perderia o estoque. O piso continua sendo o VENDEDOR de
       propósito — quem tem valor legado de 99,90 assinou quando esse era o
       plano de entrada, e rebaixar quem paga é pior que errar pra cima. */
    if(!base){ var valAntigo=Number(a.valor)||0;
      var _pid=valAntigo>=400?'max':(valAntigo>=250?'profissional':'essencial');
      base=_PAG_PLANOS.filter(function(p){ return p.id===_pid; })[0]; }
    return Object.assign({},base,{ valor:Number(a.valor)||base.valor, tokens_mensais:Number(a.tokens_mensais)||base.tokens_mensais, ativo:true, validade:a.validade||null, dias:a.dias });
  }
  function pagPct(atual,limite){
    atual=Math.max(0,Number(atual)||0);
    if(limite==null) return 0;
    limite=Math.max(1,Number(limite)||1);
    return Math.max(0,Math.min(100,(atual/limite)*100));
  }
  function pagMedidorHtml(cfg){
    var limite=cfg.limite, ilimitado=limite==null && cfg.planoAtivo;
    var atual=Math.max(0,Number(cfg.atual)||0);
    var valor=cfg.valor||(ilimitado?(fmtTok(atual)+' · sem limite'):(limite==null?fmtTok(atual):(fmtTok(atual)+' de '+fmtTok(limite))));
    var meta=cfg.meta||'';
    var pct=ilimitado?100:pagPct(atual,limite);
    var aria=ilimitado?(cfg.titulo+': '+atual+', sem limite'):(limite==null?(cfg.titulo+': '+atual):(cfg.titulo+': '+atual+' de '+limite));
    return '<div class="pag-meter'+(ilimitado?' ilimitado':'')+(limite==null&&!cfg.planoAtivo?' sem-plano':'')+'">'+
      '<div class="pag-meter-top"><span class="pag-meter-ico">'+mkIco(cfg.icone,17)+'</span><span class="pag-meter-tx"><b>'+esc(cfg.titulo)+'</b><small>'+esc(meta)+'</small></span><strong>'+esc(valor)+'</strong></div>'+
      '<div class="pag-track" role="progressbar" aria-label="'+esc(aria)+'" aria-valuemin="0"'+(limite!=null?(' aria-valuemax="'+esc(limite)+'" aria-valuenow="'+esc(Math.min(atual,limite))+'"'):'')+'><span style="width:'+pct.toFixed(1)+'%"></span></div>'+
      '</div>';
  }
  function pagPlanoCardHtml(p,atual){
    var corrente=!!(atual&&atual.id===p.id);
    var soConsultas=p.publico==='consultas';
    var lim=p.usuarios==null?'Usuários ilimitados':(p.usuarios+' usuário'+(p.usuarios===1?'':'s'));
    /* ⚠️ v504 — ZERO VEÍCULOS TEM TEXTO PRÓPRIO. "Até 0 veículos" leria como
       defeito, e é o contrário: o Parceiro não tem estoque porque o estoque
       dele são os carros das lojas que o convidaram. */
    var vei=p.veiculos==null?'Veículos ilimitados'
           :(Number(p.veiculos)===0?'Sem estoque próprio — anuncia o das lojas'
           :('Até '+p.veiculos+' veículos'));   /* v452 */
    var beneficios=(p.beneficios||[]).map(function(x){ return '<li>'+mkIco('ok',15)+' '+esc(x)+'</li>'; }).join('');
    return '<article class="pag-plano'+(p.destaque?' destaque':'')+(corrente?' atual':'')+'">'+
      '<div class="pag-plano-head"><div><span>'+esc(p.nome)+'</span><b>'+brl(p.valor)+'<small>/mês</small></b></div>'+(corrente?'<i>Plano atual</i>':(p.destaque?'<i>Mais escolhido</i>':''))+'</div>'+
      '<ul><li>'+mkIco('usuarios',15)+' '+esc(lim)+'</li>'+(soConsultas?'':('<li>'+mkIco('carro',15)+' '+esc(vei)+'</li>'))+beneficios+'</ul>'+
      '<button type="button" class="pag-plano-btn" data-pag-plano="'+esc(p.id)+'"'+(corrente?' disabled':'')+'>'+(corrente?'Plano atual':(soConsultas?'Assinar':'Escolher plano'))+'</button>'+
      '</article>';
  }

  /* v1017 — o plano do MEV Consultas tem contrato próprio. O texto vem do
     servidor, junto com a versão e o hash; o navegador apenas apresenta e
     recolhe a identificação do responsável. PIX nenhum nasce antes do
     servidor confirmar a evidência assinada. */
  async function contratoConsultasGarantir(planoId){
    if(String(planoId||'')!=='consultas149') return true;
    var st; try{ st=await apiComTimeout('/api/contrato-assinatura',{acao:'status',plano:'consultas149'},15000); }catch(_){ st=null; }
    if(!st||!st.ok||!st.contrato){ toast((st&&st.erro)||'Não consegui abrir o contrato agora.'); return false; }
    if(st.assinado) return true;
    return await contratoConsultasAbrir(st.contrato);
  }
  function contratoConsultasAbrir(contrato){
    return new Promise(function(resolve){
      var antigo=$('contratoConsultasMask'); if(antigo) antigo.remove();
      var nome=String(meuNome||'').trim();
      var md=meuMeta||{}, doc=String(md.cpf_cnpj||md.cpf||md.cnpj||'').replace(/\D/g,'');
      var bg=document.createElement('div'); bg.id='contratoConsultasMask'; bg.className='contrato-mask';
      bg.setAttribute('role','dialog'); bg.setAttribute('aria-modal','true'); bg.setAttribute('aria-labelledby','contratoConsultasTitulo');
      bg.innerHTML='<section class="contrato-card">'+
        '<header class="contrato-head"><div><span>ASSINATURA ELETRÔNICA</span><h2 id="contratoConsultasTitulo">'+esc(contrato.titulo||'Contrato de assinatura')+'</h2><p>Leia o documento e confirme os dados do responsável.</p></div><button type="button" class="legal-icon-btn" id="contratoConsultasFechar" aria-label="Fechar contrato"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></header>'+
        '<div class="contrato-body"><div class="contrato-resumo"><span><small>Plano</small><b>MEV Consultas</b></span><span><small>Mensalidade</small><b>'+brl(contrato.valor||149)+'</b></span><span><small>Acesso</small><b>1 usuário</b></span></div>'+
        '<div class="contrato-doc" tabindex="0" aria-label="Texto completo do contrato">'+String(contrato.html||'')+'</div>'+
        '<div class="contrato-form"><div class="contrato-campo"><label for="contratoNome">Nome completo do responsável</label><input class="cad-in" id="contratoNome" autocomplete="name" maxlength="120" value="'+esc(nome)+'" placeholder="Digite o nome completo"></div>'+
        '<div class="contrato-campo"><label for="contratoDocumento">CPF ou CNPJ</label><input class="cad-in" id="contratoDocumento" inputmode="numeric" autocomplete="off" maxlength="18" value="'+esc(doc)+'" placeholder="Somente números"></div>'+
        '<label class="legal-check contrato-check"><input type="checkbox" id="contratoAceite"><span><b>Li e aceito integralmente este contrato.</b><small>Minha conta, data, IP, dispositivo, versão e hash serão registrados como evidência.</small></span></label>'+
        '<div class="legal-error" id="contratoErro" role="alert"></div></div></div>'+
        '<footer class="contrato-actions"><button type="button" class="legal-exit" id="contratoCancelar">Cancelar</button><button type="button" class="cad-btn" id="contratoAssinar" disabled>Assinar e continuar</button></footer></section>';
      document.body.appendChild(bg);
      var n=$('contratoNome'),d=$('contratoDocumento'),ck=$('contratoAceite'),bt=$('contratoAssinar'),er=$('contratoErro');
      function mascara(){var s=String(d.value||'').replace(/\D/g,'').slice(0,14);if(s.length<=11)s=s.replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2');else s=s.replace(/^(\d{2})(\d)/,'$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/,'$1.$2.$3').replace(/\.(\d{3})(\d)/,'.$1/$2').replace(/(\d{4})(\d{1,2})$/,'$1-$2');d.value=s;atualiza();}
      function atualiza(){bt.disabled=!(String(n.value||'').trim().length>=5&&String(d.value||'').replace(/\D/g,'').length>=11&&ck.checked);}
      function fechar(valor){try{bg.remove();}catch(_){}resolve(!!valor);}
      n.addEventListener('input',atualiza); d.addEventListener('input',mascara); ck.onchange=atualiza;
      $('contratoConsultasFechar').onclick=function(){fechar(false);}; $('contratoCancelar').onclick=function(){fechar(false);};
      bg.addEventListener('keydown',function(e){if(e.key==='Escape')fechar(false);else if(typeof legalPrenderFoco==='function')legalPrenderFoco(bg,e);});
      bt.onclick=async function(){
        if(bt.disabled)return;er.textContent='';bt.disabled=true;bt.textContent='Registrando assinatura…';
        var r;try{r=await apiComTimeout('/api/contrato-assinatura',{acao:'assinar',plano:'consultas149',contrato_hash:contrato.hash,nome:String(n.value||'').trim(),documento:String(d.value||'').replace(/\D/g,''),li_e_aceito:ck.checked===true},18000);}catch(_){r=null;}
        if(!(r&&r.ok&&r.assinado)){er.textContent=(r&&r.erro)||'Não foi possível registrar a assinatura agora. Tente novamente.';bt.disabled=false;bt.textContent='Tentar novamente';return;}
        toast('Contrato assinado. Agora você pode concluir o PIX.');fechar(true);
      };
      mascara();setTimeout(function(){try{document.querySelector('#contratoConsultasMask .contrato-doc').focus();}catch(_){}},60);
    });
  }
  /* v344 — o card do add-on. Estilo inline de propósito: styles.css é gerado
     e enorme, e uma faixa só não justifica mexer nele. */
  /* ⚠️ v452 (pedido) — O CARD DO ATENDENTE IA ESTÁ OCULTO.
     "oculte por enquanto". Escondido, não apagado: o _PAG_ADDON, o texto, o
     preço e o botão que abre o WhatsApp continuam inteiros logo abaixo. Pra
     ele voltar, é trocar esta linha para `true` — nada mais. */
  var PAG_ADDON_ON = false;
  function pagAddonHtml(){
    if(!PAG_ADDON_ON) return '';
    var a=_PAG_ADDON;
    var itens=a.linhas.map(function(x){ return '<li style="margin:3px 0">'+esc(x)+'</li>'; }).join('');
    return '<article style="grid-column:1/-1;margin-top:12px;padding:16px;border:1px solid #2f4257;'+
      'border-radius:14px;background:linear-gradient(180deg,rgba(90,169,247,.10),rgba(90,169,247,.03))">'+
      '<div style="font-size:11px;font-weight:700;letter-spacing:.05em;opacity:.75">ADICIONAL — VALE PARA QUALQUER PLANO</div>'+
      '<div style="display:flex;flex-wrap:wrap;align-items:baseline;gap:10px;margin:4px 0 2px">'+
        '<b style="font-size:18px">'+esc(a.nome)+'</b>'+
        '<b style="font-size:22px">'+brl(a.valor)+'<small style="opacity:.7">/mês</small></b>'+
      '</div>'+
      '<ul style="margin:8px 0 0;padding-left:18px;font-size:13.5px;opacity:.85">'+itens+'</ul>'+
      '<button type="button" class="pag-plano-btn" data-pag-addon="1" style="margin-top:12px">Quero o Atendente</button>'+
      '</article>';
  }
  /* ⚠️ v505 (pedido do Angelo): "sempre quando mostrar os planos mostre do
     mais caro para o mais barato, de cima pra baixo ou da esquerda pra
     direita" — e o mesmo nas recargas, logo abaixo.

     ⚠️ A LISTA-FONTE (_PAG_PLANOS) CONTINUA DO MAIS BARATO PRO MAIS CARO, de
     propósito: ela espelha o cobranca.js linha a linha e os comentários de
     economia do v344 leem como escada. Quem inverte é só a PINTURA. Se um
     dia alguém inverter a fonte, vai ter que inverter as DUAS tabelas e
     ainda mexer nos selos dos pacotes, que são por posição. */
  /* v533 — "este plano ainda pode ser assinado?". Sem a marca, é sim: assim
     um plano novo entra na vitrine só por existir, sem ter que lembrar de
     marcar nada. Quem sai é que precisa dizer.
     (v534: o Vendedor Parceiro voltou a vender — nenhum plano usa isto hoje,
     mas o mecanismo fica: aposentar um plano é uma palavra.) */
  function pagEhConsultas(){ try{ return typeof edicaoAtual==='function' && edicaoAtual()==='consultas'; }catch(_){ return false; } }
  function pagPlanoAVenda(p){
    if(!p || p.aVenda===false) return false;
    return pagEhConsultas() ? p.publico==='consultas' : p.publico!=='consultas';
  }
  /* v534 — de quem é este plano. Sem dizer, é de LOJA: a loja é o cliente
     principal, e plano novo sem marca deve nascer no andar de cima. */
  function pagPlanoPublico(p){ return (p && p.publico==='vendedor') ? 'vendedor' : ((p&&p.publico==='consultas')?'consultas':'loja'); }
  /* ⛳ v635 — DE VOLTA A UM ANDAR SÓ. Os três planos são de loja; o andar de
     baixo ficaria vazio com a pergunta "Não tem loja?" sem ninguém pra
     responder. O interruptor já estava pronto desde a v534 — voltar é uma
     palavra, e voltar a dois andares também. */
  var PAG_DOIS_ANDARES = false;
  function pagPlanosPinta(atual){
    var el=$('pagPlanos'); if(!el) return;
    /* v1185 — o MEV Consultas trabalha somente com recargas. Uma assinatura
       antiga pode continuar identificada no resumo, mas não é mais vendida. */
    if(pagEhConsultas()){ el.innerHTML=''; return; }
    /* 🔴 v533: só entra na vitrine quem está À VENDA. O filtro fica AQUI, na
       pintura, e NÃO na lista-fonte — as três buscas por id deste arquivo
       precisam continuar achando um plano aposentado pra saber dizer o nome
       dele. */
    var aVenda=_PAG_PLANOS.filter(pagPlanoAVenda);
    el.classList.toggle('pag-planos-unico',aVenda.length===1);
    /* ⚠️ do mais caro pro mais barato DENTRO de cada andar (pedido da v505).
       A lista-fonte continua do mais barato pro mais caro; quem inverte é a
       pintura, e só ela. */
    function banda(quem){
      return aVenda.filter(function(p){ return pagPlanoPublico(p)===quem; }).reverse();
    }
    var html;
    if(PAG_DOIS_ANDARES){
      var loja=banda('loja'), vend=banda('vendedor');
      html = loja.map(function(p){ return pagPlanoCardHtml(p,atual); }).join('');
      /* 🔴 a pergunta é o filtro. Quem tem loja lê "não tem loja?" e não desce
         — que é exatamente o ponto: o card de R$ 149 não estava competindo
         com o Lojista, estava confundindo quem já tinha loja. */
      if(vend.length){
        html += '<div class="pag-band-sep"><b>Não tem loja?</b> Veja essas ofertas</div>'+
                vend.map(function(p){ return pagPlanoCardHtml(p,atual); }).join('');
      }
    } else {
      html = aVenda.slice().reverse().map(function(p){ return pagPlanoCardHtml(p,atual); }).join('');
    }
    el.innerHTML=html+pagAddonHtml();
    var bAdd=el.querySelector('[data-pag-addon]');
    if(bAdd) bAdd.onclick=function(){
      var msg='Olá! Quero ativar o Atendente IA no WhatsApp para a minha loja.';
      mevIrProWhats('https://wa.me/'+_PAG_ADDON.whats+'?text='+encodeURIComponent(msg));   /* v370 */
    };
    Array.prototype.forEach.call(el.querySelectorAll('[data-pag-plano]'),function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-pag-plano'), p=_PAG_PLANOS.filter(function(x){ return x.id===id; })[0];
        if(!p) return;
        assinaturaPagar(p.id);
      };
    });
  }
  function pagPacotesPinta(){
    var el=$('pagPacotes'); if(!el) return;
    if(!pacotes.length){ el.innerHTML='<div class="ui-state error"><b>Pacotes indisponíveis agora</b><small>Tente atualizar a página em alguns instantes.</small></div>'; return; }
    /* 🔴 v505 — A CONTA DA ECONOMIA NÃO PODE DEPENDER DA ORDEM DA TELA.
       Era `pacotes[0]`, o pacote de entrada, e funcionava só porque a lista
       vinha do mais barato pro mais caro. Invertendo a pintura, o [0]
       passaria a ser o MAIOR pacote e todo mundo apareceria com "economize
       0%" — o desconto sumiria justamente do card que mais vende.
       Agora a base é o MAIOR preço por token da lista, que é o pacote de
       entrada por definição, venha ele em que posição vier. */
    var base=Math.max.apply(null, pacotes.map(function(x){ return Number(x.valor)/(Number(x.creditos)||1); }));
    /* v505 (pedido): do mais caro pro mais barato, igual aos planos.
       ⚠️ O `i` que vai pro desenho é a POSIÇÃO ORIGINAL, não a da tela: os
       selos "Mais usado" (3º pacote) e "Maior saldo" (o último) são por
       posição na lista de verdade, e reverter sem isso trocaria os dois de
       card. Por isso a ordem original viaja junto. */
    var doMaisCaro=pacotes.map(function(p,i){ return { p:p, i:i }; }).reverse();
    el.innerHTML=doMaisCaro.map(function(x){
      var p=x.p, i=x.i;
      var unit=Number(p.valor)/(Number(p.creditos)||1);
      var econ=Math.max(0,Math.round((1-unit/base)*100));
      /* 🔴🔴 v534 — ERA `i===2`, e com TRÊS pacotes isso quebrava feio.
         Com 4 pacotes, o índice 2 era o penúltimo e dava certo por acaso.
         Com 3, o índice 2 é o ÚLTIMO — então os dois selos caíam no MESMO
         card, o ternário escolhia "Mais usado", e o "Maior saldo" sumia da
         tela. O card mais caro ficaria marcado como o mais vendido e o
         desconto de 25% não teria selo nenhum.
         Agora é PENÚLTIMO por posição relativa, que é a mesma correção que a
         v430 já tinha feito no outro desenho de pacotes (o do 01-nucleo) —
         com o mesmo comentário. Dois desenhos, uma regra. */
      var iDest=Math.max(0, pacotes.length-2);
      var selo=(pacotes.length>1 && i===iDest)?'<i>Mais usado</i>'
              :((pacotes.length>2 && i===pacotes.length-1)?'<i>Maior saldo</i>':'');
      /* 🔴 v535: o REALCE também era `i===2` — eu tinha consertado só o selo,
         e aí o card realçado e o card com a etiqueta "Mais usado" seriam
         cards DIFERENTES. Os dois agora leem o mesmo `iDest`. */
      return '<button type="button" class="pag-pac'+(i===iDest?' destaque':'')+'" data-pag-pac="'+esc(p.id)+'">'+
        '<span class="pag-pac-main"><span class="pag-pac-nome">'+esc(p.nome)+selo+'</span><small>'+((pagEhConsultas()?'Válido por 30 dias':(econ?('Economize '+econ+'%'):'Saldo para consultas')))+'</small></span>'+
        '<span class="pag-pac-val">'+brl(p.valor)+'<small>Comprar</small></span>'+
        '</button>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('[data-pag-pac]'),function(b){ b.onclick=function(){ comprar(b.getAttribute('data-pag-pac')); }; });
  }
  function pagPoliticaPinta(){
    var sec=$('pagCarteiraSec'), box=$('pagCarteiraBody'); if(!sec||!box) return;
    if(pagEhConsultas()){ sec.style.display='none'; return; }
    var compartilhada=carteiraTokens==='loja'; sec.style.display=compartilhada?'':'none';
    if(!compartilhada) return;
    var gestor=(meuPapel==='dono'||meuPapel==='gerente');
    var politica=politicaRecargaTokens==='equipe'?'equipe':'dono_gerente';
    var regra=politica==='equipe'?'Toda a equipe pode comprar pacotes para a carteira.':'Somente o dono ou gerente pode comprar pacotes para a carteira.';
    /* v636 — uma verdade só: todo token vence em 30 dias, e o que vence
       primeiro é gasto primeiro. */
    box.innerHTML='<p class="pag-intro">O saldo desta loja é compartilhado: todos os usuários consomem a mesma carteira. Cada recarga vale 30 dias, e o saldo que vence primeiro é gasto primeiro.</p>'+
      (gestor
        ? '<label class="pag-politica-lbl" for="pagPoliticaRecarga">Quem pode recarregar o saldo da loja?</label><select class="cad-in pag-politica-select" id="pagPoliticaRecarga" aria-describedby="pagPoliticaMsg"><option value="dono_gerente"'+(politica==='dono_gerente'?' selected':'')+'>Somente dono e gerente</option><option value="equipe"'+(politica==='equipe'?' selected':'')+'>Toda a equipe</option></select><small id="pagPoliticaMsg" class="pag-politica-msg" aria-live="polite">'+esc(regra)+'</small>'
        : '<div class="pag-politica-read"><b>Recarga da carteira</b><small>'+esc(regra)+'</small></div>');
    var seletor=$('pagPoliticaRecarga'); if(seletor) seletor.onchange=function(){ pagPoliticaSalvar(seletor.value); };
  }
  function pagEdicaoPinta(){
    var consultas=pagEhConsultas();
    var tit=$('pagPlanosTitulo'), sub=$('pagPlanosSub'), intro=$('pagPlanosIntro'), pac=$('pagPacotesIntro');
    var planosSec=$('pagPlanosSec'); if(planosSec) planosSec.style.display=consultas?'none':'';
    if(tit) tit.textContent=consultas?'Recargas':'Planos para a loja';
    if(sub) sub.textContent=consultas?'sem mensalidade':'estrutura e equipe';
    if(intro) intro.textContent=consultas
      ? 'Escolha uma recarga avulsa. Não há mensalidade.'
      : 'Usuários e estoque na mesma estrutura. Cada plano adiciona saldo mensal à carteira da loja. Consultas adicionais seguem no modelo pague pelo uso.';
    if(pac) pac.textContent=consultas
      ? 'As recargas entram no seu saldo e valem por 30 dias.'
      : 'As recargas entram na carteira da loja e são descontadas somente quando você usa um recurso pago.';
    var car=$('pagCarteiraSec'), con=$('pagConsumoSec');
    if(consultas){ if(car) car.style.display='none'; if(con) con.style.display='none'; }
    else if(con) con.style.display='';
  }
  async function pagPoliticaSalvar(politica){
    var seletor=$('pagPoliticaRecarga'), msg=$('pagPoliticaMsg'); if(!seletor) return;
    seletor.disabled=true; if(msg) msg.textContent='Salvando regra de recarga…';
    var d; try{ d=await api('/api/creditos',{acao:'politica_recarga',politica:politica}); }catch(_){ d=null; }
    seletor.disabled=false;
    if(!d||!d.ok){ if(msg) msg.textContent=(d&&d.erro)||'Não consegui salvar a regra. Tente de novo.'; return; }
    politicaRecargaTokens=d.politica_recarga||politica; podeRecarregarTokens=d.pode_recarregar!==false;
    pagPoliticaPinta(); toast('Regra de recarga atualizada.');
  }
  function pagResumoPinta(dados){
    var atual=pagPlanoDaAssinatura(), ativo=!!atual;
    var soConsultas=pagEhConsultas();
    var status=$('pagPlanoStatus'), nome=$('pagPlanoNome'), meta=$('pagPlanoMeta');
    if(nome) nome.textContent=ativo?atual.nome:'Uso por consulta';
    if(status){ status.textContent=ativo?'Ativo':'Sem mensalidade'; status.className='pag-status '+(ativo?'ok':''); }
    if(meta){
      if(ativo&&atual.validade) meta.textContent='Renovação até '+new Date(atual.validade+'T12:00:00').toLocaleDateString('pt-BR')+'.';
      else if(ativo) meta.textContent=(atual.tokens_mensais?precoReal(atual.tokens_mensais)+(soConsultas?' de saldo para consultas por 30 dias.':' de saldo mensal na carteira da loja.'):'Estrutura liberada.');
      else meta.textContent='Adicione saldo quando precisar. Cada recarga vale 30 dias.';   /* v636 */
    }
    var ps=$('pagSaldo'); if(ps) ps.textContent=ilimitado?'∞':precoReal(saldo);
    var mes=new Date().toLocaleDateString('pt-BR',{month:'long'});
    var k=$('pagKpis');
    if(k) k.classList.toggle('so-consultas',soConsultas);
    if(k) k.innerHTML='<div><b>'+fmtTok(dados.consultas)+'</b><span>placas em '+esc(mes)+'</span></div>'+
      (soConsultas?'<div><b>1</b><span>usuário no plano</span></div>':('<div><b>'+fmtTok(dados.veiculos)+'</b><span>veículos ativos</span></div><div><b>'+fmtTok(dados.usuarios)+'</b><span>usuários da loja</span></div>'));
    var med=$('pagMedidores');
    if(med){
      var saldoRef=Number((usoTokens&&usoTokens.consulta_plus)||25);
      /* 🔴 v636 — O QUE VENCE APARECE AQUI, e vem do servidor.
         Sem esta linha a expiração é uma surpresa, e surpresa com dinheiro do
         cliente é a fábrica de reclamação. Quando nada vence (só saldo antigo
         honrado, ou carteira vazia), a frase simplesmente não nasce. */
      var _vence=''; try{ _vence=tokensVenceTexto(); }catch(_){ _vence=''; }
      var saldoMeta=ilimitado?'Consultas liberadas sem débito'
        :((carteiraTokens==='loja'?'Carteira compartilhada da loja. ':'')
          +(_vence?(_vence+'. ')
            :(ativo&&atual.tokens_mensais?(precoReal(atual.tokens_mensais)+' entram a cada mês. '):''))
          +(saldo>=saldoRef?'Saldo suficiente para qualquer consulta':'Referência: '+precoReal(saldoRef)+' para a Consulta Plus'));
      if(soConsultas) saldoMeta=_vence?(_vence+'.'):(ativo&&atual.tokens_mensais?'O valor da assinatura vira saldo por 30 dias.':'Adicione saldo quando precisar.');
      med.innerHTML=pagMedidorHtml({ titulo:soConsultas?'Saldo para consultas':(carteiraTokens==='loja'?'Saldo da loja':'Saldo para consultas'), atual:ilimitado?saldoRef:saldo, limite:saldoRef, valor:ilimitado?'∞':precoReal(saldo), meta:saldoMeta, icone:'carteira', planoAtivo:true })+
        (soConsultas?'':(pagMedidorHtml({ titulo:'Usuários da loja', atual:dados.usuarios, limite:ativo?atual.usuarios:null, meta:ativo?'Limite do plano '+atual.nome:'Sem limite contratado no uso por consulta', icone:'usuarios', planoAtivo:ativo })+
        /* v285-b: nenhum plano limitava veículo, então o medidor deixou de
           falar em limite. v452: o Vendedor voltou a ter teto (20), então a
           régua volta a mostrar barra cheia — mas SÓ pra quem tem teto.
           Lojista e Max continuam sem limite e sem susto na tela. */
        pagMedidorHtml({ titulo:'Veículos ativos', atual:dados.veiculos,
          limite:(ativo && atual.veiculos!=null) ? atual.veiculos : null,
          meta:(ativo && atual.veiculos!=null)
            ? ('Até '+atual.veiculos+' veículos no plano '+atual.nome+' · vendidos não contam')
            : 'Veículos ilimitados neste plano · vendidos não contam',
          icone:'carro', planoAtivo:ativo })));
    }
    pagPlanosPinta(atual);
    pagPoliticaPinta();
    pagPacotesPinta();
    pagConsumoPinta();
  }
  function pagConsumoPinta(){
    var lista=$('pagConsumoLista'); if(!lista) return;
    if(pagEhConsultas()){ var sec=$('pagConsumoSec'); if(sec) sec.style.display='none'; return; }
    var fipe=precoReal(usoTokens&&usoTokens.fipe!=null?usoTokens.fipe:0.06);
    var plus=precoReal(usoTokens&&usoTokens.consulta_plus!=null?usoTokens.consulta_plus:25);
    var cpf=precoReal(usoTokens&&usoTokens.cpf_completo!=null?usoTokens.cpf_completo:8.20);
    var ia=precoReal(usoTokens&&usoTokens.ficha_avaliacao!=null?usoTokens.ficha_avaliacao:1);
    var risco=precoReal(usoTokens&&usoTokens.cnpj_risco!=null?usoTokens.cnpj_risco:5.71);   /* v971 */
    lista.innerHTML='<div><span>Consulta FIPE</span><b>'+esc(fipe)+'</b></div>'+
      '<div><span>Consulta Plus</span><b>'+esc(plus)+'</b></div>'+
      '<div><span>Consulta CPF</span><b>'+esc(cpf)+'</b></div>'+
      '<div><span>Risco de crédito CNPJ</span><b>'+esc(risco)+'</b></div>'+
      '<div><span>Recurso IA</span><b>'+esc(ia)+'</b></div>';
  }
  /* v1323 — a abertura de Uso e faturamento mostra as etapas reais das
     requisições em uma barra horizontal. Não usa o carro do pgLoad global e
     não inventa progresso por tempo: cada avanço corresponde a um grupo de
     dados que terminou de carregar, mesmo quando a resposta veio vazia. */
  function pagUsoLoadHtml(){
    return '<div class="pag-uso-load" role="status" aria-live="polite">'+
      '<div class="pag-uso-load-head"><b>Calculando seu uso…</b><span id="pagUsoPct">8%</span></div>'+
      '<div class="pag-uso-load-track" id="pagUsoTrack" role="progressbar" aria-label="Carregando dados de uso" aria-valuemin="0" aria-valuemax="100" aria-valuenow="8"><i id="pagUsoFill" style="width:8%"></i></div>'+
      '<p id="pagUsoEtapa">Consultando saldo e plano.</p></div>';
  }
  function pagUsoProgresso(carga,pct,etapa){
    if(carga!==_pagCarga)return;
    pct=Math.max(0,Math.min(100,Number(pct)||0));
    var tr=$('pagUsoTrack'),fill=$('pagUsoFill'),num=$('pagUsoPct'),txt=$('pagUsoEtapa');
    if(tr)tr.setAttribute('aria-valuenow',String(pct));
    if(fill)fill.style.width=pct+'%';
    if(num)num.textContent=pct+'%';
    if(txt)txt.textContent=etapa||'Calculando seu uso…';
  }
  function pagUsoEsperaFinal(){
    var reduz=false;try{reduz=window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(_){}
    return new Promise(function(resolve){setTimeout(resolve,reduz?0:180);});
  }
  async function pagamentosCarregar(){
    var carga=++_pagCarga;
    var med=$('pagMedidores'); if(med) med.innerHTML=pagUsoLoadHtml();
    try{ await Promise.all([carregarSaldo(),assinaturaCarregar()]); }catch(_){}
    pagUsoProgresso(carga,38,'Saldo e plano conferidos.');
    var lojaId=null, usuarios=1, veiculos=0, consultas=0;
    try{
      var rm=await withTimeout(supa.from('loja_membros').select('loja_id').eq('user_id',meuId).limit(1),8000);
      lojaId=(rm&&rm.data&&rm.data[0]&&rm.data[0].loja_id)||null;
    }catch(_){}
    pagUsoProgresso(carga,58,'Conferindo sua conta.');
    var inicio=new Date(); inicio.setDate(1); inicio.setHours(0,0,0,0);
    var tarefas=[
      withTimeout(supa.from('estoque').select('id,status'),9000),
      withTimeout(supa.from('historico_consulta').select('placa,ts').eq('user_id',meuId).gte('ts',inicio.getTime()),9000)
    ];
    if(lojaId) tarefas.push(withTimeout(supa.from('loja_membros').select('id').eq('loja_id',lojaId),9000));
    try{
      var rr=await Promise.all(tarefas);
      veiculos=((rr[0]&&rr[0].data)||[]).filter(function(v){ return String(v.status||'disponivel')!=='vendido'; }).length;
      consultas=((rr[1]&&rr[1].data)||[]).length;
      if(lojaId) usuarios=Math.max(1,((rr[2]&&rr[2].data)||[]).length);
    }catch(_){}
    if(carga!==_pagCarga || !$('pagMedidores')) return;
    pagUsoProgresso(carga,100,'Uso atualizado.');
    await pagUsoEsperaFinal();
    if(carga!==_pagCarga || !$('pagMedidores')) return;
    pagResumoPinta({usuarios:usuarios,veiculos:veiculos,consultas:consultas});
  }

  /* Extrato de uso da carteira. Diferente do histórico visual, esta tela
     mostra movimentação financeira de TODAS as consultas e das recargas. */
  function abrirExtratoConsultas(){
    irTela('<section class="extf-page" aria-labelledby="extfTitulo">'+
      '<header class="extf-head"><span class="extf-head-ico">'+mkIco('ficha',21)+'</span><span><small>USO E FATURAMENTO</small><h2 id="extfTitulo">Extrato de consultas</h2><p>Consultas, recargas e saldos em ordem cronológica.</p></span></header>'+
      '<section class="extf-balance" aria-label="Saldo atual"><span><small>Saldo atual</small><b id="extfSaldo">—</b></span><i>Atualizado agora</i></section>'+
      '<div class="extf-filtros" role="group" aria-label="Filtrar movimentações">'+
        '<button type="button" class="on" data-extf="todos" aria-pressed="true">Todos</button>'+
        '<button type="button" data-extf="debito" aria-pressed="false">Consultas</button>'+
        '<button type="button" data-extf="credito" aria-pressed="false">Recargas</button></div>'+
      '<div id="extfEstado" class="extf-estado" aria-live="polite">'+pgLoad('Carregando seu extrato…')+'</div>'+
      '<div id="extfLista" class="extf-lista" hidden></div></section>','home');
    document.body.classList.add('hist-on');
    try{ mevCtx(null); mevPrintFab(false); }catch(_){}
    voltarTab(function(){ telaInfo('pagamentos'); });
    try{ consultaUiDockMedir(); }catch(_){}

    var movimentos=[];
    function tipoGrupo(m){ return (m.movimento==='debito'||m.movimento==='consulta_gratis')?'debito':'credito'; }
    function dataInfo(v){
      var d=new Date(v), dia='', hora='';
      if(isNaN(d.getTime())) return {dia:'Data não informada',hora:'—'};
      dia=d.toLocaleDateString('pt-BR',{weekday:'long',day:'2-digit',month:'long',year:'numeric'});
      hora=d.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
      return {dia:dia.charAt(0).toUpperCase()+dia.slice(1),hora:hora};
    }
    function render(filtro){
      var lista=$('extfLista'), estado=$('extfEstado'); if(!lista||!estado) return;
      var itens=movimentos.filter(function(m){ return filtro==='todos'||tipoGrupo(m)===filtro; });
      if(!itens.length){ lista.hidden=true; estado.innerHTML='<div class="extf-vazio">'+mkIco('ficha',28)+'<b>Nenhuma movimentação neste filtro</b><span>As próximas consultas e recargas aparecerão aqui.</span></div>'; return; }
      estado.innerHTML=''; lista.hidden=false;
      var grupos={}, ordem=[];
      itens.forEach(function(m){ var dt=dataInfo(m.criado_em); if(!grupos[dt.dia]){grupos[dt.dia]=[];ordem.push(dt.dia);} grupos[dt.dia].push({m:m,dt:dt}); });
      lista.innerHTML=ordem.map(function(dia){
        return '<section class="extf-dia"><h3>'+esc(dia)+'</h3>'+grupos[dia].map(function(x){
          var m=x.m, gratis=m.movimento==='consulta_gratis', deb=m.movimento==='debito'||gratis, abertura=m.movimento==='abertura';
          var sinal=deb?'−':'+';
          return '<article class="extf-item '+(deb?'debito':'credito')+(gratis?' gratis':'')+'">'+
            '<div class="extf-item-top"><span class="extf-mov-ico">'+mkIco(deb?'ficha':'carteira',18)+'</span><span class="extf-item-nome"><b>'+esc(m.descricao||'Movimentação de saldo')+'</b><small>'+esc(x.dt.hora)+'</small></span>'+
            '<strong>'+(gratis?'Grátis':sinal+esc(precoReal(m.quantidade)))+'</strong></div>'+
            '<dl><div><dt>Saldo anterior</dt><dd>'+(abertura||m.saldo_anterior==null?'—':esc(precoReal(m.saldo_anterior)))+'</dd></div><div><dt>'+(gratis?'Uso':(deb?'Débito':'Entrada'))+'</dt><dd>'+(gratis?'Grátis':sinal+esc(precoReal(m.quantidade)))+'</dd></div><div><dt>Novo saldo</dt><dd>'+(m.saldo_posterior==null?'—':esc(precoReal(m.saldo_posterior)))+'</dd></div></dl>'+
          '</article>';
        }).join('')+'</section>';
      }).join('');
      try{ consultaUiDockMedir(); }catch(_){}
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-extf]'),function(b){
      b.onclick=function(){ document.querySelectorAll('[data-extf]').forEach(function(x){var on=x===b;x.classList.toggle('on',on);x.setAttribute('aria-pressed',on?'true':'false');}); render(b.getAttribute('data-extf')); };
    });
    (async function(){
      var d; try{ d=await api('/api/creditos',{acao:'extrato'}); }catch(_){ d=null; }
      if(!$('extfEstado')) return;
      if(!d||!d.ok){ $('extfEstado').innerHTML='<div class="extf-vazio erro">'+mkIco('alerta',28)+'<b>Não foi possível abrir o extrato</b><span>'+esc((d&&d.erro)||'Tente novamente em alguns instantes.')+'</span><button type="button" id="extfRetry">Tentar novamente</button></div>'; var rb=$('extfRetry'); if(rb) rb.onclick=abrirExtratoConsultas; return; }
      $('extfSaldo').textContent=d.ilimitado?'∞':precoReal(d.saldo);
      movimentos=Array.isArray(d.movimentos)?d.movimentos:[]; render('todos');
    })();
  }
  function telaInfo(chave){
    var C=MEV_TEXTOS[chave]; if(!C) return;
    /* Sem cabeçalho "‹ Início": a volta é pelo botão flutuante de baixo. */
    var back='';
    $('secoes').innerHTML=back+'<div class="info-pg"><h2>'+esc(C.t)+'</h2>'+C.h+'</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false);
    /* v1322 — Suporte e as demais páginas informativas também são internas.
       Sincroniza a barra depois de aplicar `tela-interna`: a esquerda vira
       Voltar (SVG) e o alternador de tema permanece exclusivo da Home. */
    try{ if(typeof tbPaginaAtualizar==='function') tbPaginaAtualizar(C.t); }catch(_){}
    var ib=$('infoBack'), il=$('infoBackLb'); if(ib) ib.onclick=voltarHome; if(il) il.onclick=voltarHome; voltarTab(voltarHome);
    if(chave==='pagamentos'){
      try{ pagEdicaoPinta(); }catch(_){}
      var pc=$('pagComprar'); if(pc) pc.onclick=abrirPacotes;
      var ph=$('pagHist'); if(ph) ph.onclick=abrirExtratoConsultas;
      var pp=$('pagPlanoAjuda'); if(pp) pp.onclick=function(){ _repWa('5551996417433','Olá! Preciso de ajuda com meu plano, uso ou pagamento no MEV Veículos.'); };
      pagamentosCarregar();
    }
  }
  /* Confirmação por código no e-mail (reautenticação). Envia um código de 6 dígitos
     pro e-mail do usuário e devolve o código digitado (ou null se cancelar).
     Usado antes de trocar senha / e-mail / telefone — mais segurança. */
  function reautPedirCodigo(titulo){
    return new Promise(function(resolve){
      (async function(){
        try{ var rr=await supa.auth.reauthenticate(); if(rr&&rr.error) throw rr.error; }
        catch(e){ toast('Não consegui enviar o código: '+((e&&e.message)||'tente de novo')); resolve(null); return; }
        var ov=document.createElement('div'); ov.className='cropmask';
        ov.innerHTML='<div class="cropbox" style="max-width:322px">'+
          '<div class="crop-tit">'+esc(titulo||'Confirme que é você')+'</div>'+
          '<div class="crop-sub">Enviamos um código de 6 dígitos pro seu e-mail. Digite abaixo pra confirmar.</div>'+
          '<input id="reautCode" class="cad-in" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="______" style="text-align:center;letter-spacing:9px;font-size:23px;font-weight:800;margin-top:2px">'+
          '<div class="cad-msg" id="reautMsg" style="min-height:14px"></div>'+
          '<div class="crop-acts"><button type="button" class="crop-c" id="reautCancel">Cancelar</button><button type="button" class="crop-ok" id="reautOk">Confirmar</button></div>'+
          '</div>';
        document.body.appendChild(ov);
        var inp=ov.querySelector('#reautCode'); setTimeout(function(){ try{inp.focus();}catch(_){} },120);
        inp.oninput=function(){ this.value=this.value.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,6); };
        function done(v){ try{ov.remove();}catch(_){} resolve(v); }
        ov.querySelector('#reautCancel').onclick=function(){ done(null); };
        ov.querySelector('#reautOk').onclick=function(){ var c=String(inp.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(c.length!==6){ var mm=ov.querySelector('#reautMsg'); mm.className='cad-msg err'; mm.textContent='Digite os 6 dígitos do código.'; return; } done(c); };
        inp.onkeydown=function(e){ if(e.key==='Enter'){ ov.querySelector('#reautOk').click(); } };
      })();
    });
  }
  /* ---- Tela: Minha conta (Cadastro editavel) ---- */
  /* Sem cabeçalho "‹ Início": a volta é pelo botão flutuante de baixo. */
  function _cadBack(){ return ''; }
  function _cadWireBack(){ var ib=$('infoBack'),il=$('infoBackLb'); if(ib) ib.onclick=voltarHome; if(il) il.onclick=voltarHome; }
  /* v352 — Minha conta em duas abas (mesmo menu .vpx da Minha loja) */
  var _cadTab='docs';   /* v389: a conta abre nos Documentos (1ª seção da folha) */
  /* ===== v755 — MINHA CONTA, FASE 1 (base e navegação) =====================
     docs/PROJETO-2026-08-29-redesign-minha-conta.txt
     A MESMA tela (IDs e fluxos preservados), agora com: classe de página
     body.conta-on (dock compacto da v754 + padding inferior), abas reais
     (tablist/tab/tabpanel, setas/Home/End, anúncio da troca), cabeçalho
     padrão de cada área (cad-area-head) com status de salvamento
     (cad-save-status, aria-live) e abertura por rota: telaCadastro(null,'acesso'). */
  /* v771 (projeto home-menu-e-documentos §6.3): a ABA continua "Documentos";
     o TÍTULO DA SEÇÃO (4º campo) virou "Arquivos pessoais" — acabou o
     título repetido na aba e na seção. */
  var CAD_ABAS=[['docs','Documentos','Seus documentos ficam protegidos e disponíveis somente para você.','Arquivos pessoais'],
                ['dados','Dados pessoais','Informações usadas na sua conta e no catálogo.'],
                ['endereco','Endereço','Usado no cadastro e nos documentos que você gerar.'],
                ['fotos','Fotos','Imagens que podem aparecer no seu catálogo público.'],
                ['lojas','Lojas','Gerencie seu vínculo, convite e preferências.'],
                ['acesso','Acesso','Senha, recuperação, aparelhos e dados da conta.']];
  function cadAbaOk(k){ return CAD_ABAS.some(function(a){ return a[0]===k; })?k:'docs'; }
  /* ==========================================================================
     🔴 v1299/v1482 — MINHA CONTA ESSENCIAL EM CONSULTAS E AVALIAÇÕES
     --------------------------------------------------------------------------
     No MEV Consultas e no MEV Avaliações a "Minha conta" mostra somente:
         Dados para nota | Acesso
     Nome/razão social, CPF/CNPJ, e-mail e endereço fiscal ficam reunidos na
     primeira seção. Foto, telefone, Documentos, Fotos e Lojas não aparecem.

     ⚠️ A CONDIÇÃO enumera `consultas` e `avalia`, NÃO usa `edIsolada()`.
     Outras edições isoladas podem existir e não devem herdar esta redução.

     ⚠️ O `CAD_ABAS` CONTINUA SENDO O CATÁLOGO COMPLETO, e o `cadAbaOk` continua
     com a semântica global de sempre (fallback 'docs'). Ele é usado pelo
     `cadStatusSet` e pelo `_cadAbaDoCampo` — mexer nele faria um status de
     Documentos aparecer no cabeçalho de Dados pessoais. Quem filtra é a lista
     VISÍVEL aqui embaixo, e ela serve só pra navegação: botões, aba inicial,
     teclado e destino de rota.

     ⚠️ OS PAINÉIS CONTINUAM MONTADOS NO DOM, escondidos (o `hidden` que o
     cadTabAplica põe em tudo que não é a aba ativa, e a aba ativa nunca pode
     ser uma delas). Isso é DE PROPÓSITO, e o projeto autoriza:
       · o `cadColeta()` preserva do metadata qualquer campo que não esteja
         montado nesta edição. Esconder tela não pode apagar dado antigo.
       · os inicializadores compartilhados continuam achando seus elementos.
     O que NÃO roda são as buscas de rede exclusivas dos painéis escondidos
     (documentos, quadro da loja e preferência de repasse) — ver a telaCadastro.

     ⚠️ Isto é simplificação de INTERFACE. Não apaga arquivo, não desvincula
     loja, não mexe em autenticação, RLS, cobrança nem direito de acesso.
     ========================================================================== */
  var CAD_ABAS_CONSULTAS=['dados','acesso'];
  function cadContaEssencial(){
    try{ var e=typeof edicaoAtual==='function'?edicaoAtual():''; return e==='consultas'||e==='avalia'; }
    catch(_){ return false; }
  }
  function cadAbasVisiveis(){
    if(cadContaEssencial()){
      return CAD_ABAS.filter(function(a){ return CAD_ABAS_CONSULTAS.indexOf(a[0])>=0; }).map(function(a){
        return a[0]==='dados' ? ['dados','Dados para nota','Dados usados para emitir sua nota fiscal.','Dados para nota fiscal'] : a;
      });
    }
    return CAD_ABAS;
  }
  /* v1188 — Instagram, site e a apresentação pública pertencem ao produto
     que entrega catálogo/site. O MEV Completo inclui esse produto; Consultas,
     Avaliações e os demais módulos não exibem nem reenviam esses campos. */
  function cadPerfilPublicoVisivel(){
    try{ var e=(typeof edicaoAtual==='function')?edicaoAtual():'completo'; return e==='loja'||e==='completo'; }
    catch(_){ return false; }
  }
  function cadAbaDisponivel(k){ var v=String(k||''); return cadAbasVisiveis().some(function(a){ return a[0]===v; }); }
  function cadAbaPadrao(){ var v=cadAbasVisiveis(); return (v[0]&&v[0][0])||'docs'; }
  /* destino de NAVEGAÇÃO (não é o cadAbaOk): pedido fora da edição cai na padrão */
  function cadAbaDestino(k){ return cadAbaDisponivel(k)?String(k):cadAbaPadrao(); }
  function cadTabAplica(anunciar){
    Array.prototype.forEach.call(document.querySelectorAll('#cadBody .vpx-panel'),function(pn){
      var on=pn.getAttribute('data-panel')===_cadTab; pn.classList.toggle('on', on);
      if(on){ pn.removeAttribute('hidden'); pn.classList.remove('cad-panel-entra'); void pn.offsetWidth; pn.classList.add('cad-panel-entra'); } else pn.setAttribute('hidden','');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#cadTabs .vpx-st'),function(b){
      var on=b.getAttribute('data-step')===_cadTab; b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on?'true':'false'); b.setAttribute('tabindex', on?'0':'-1');
      if(on){ try{ _tabCentra(b.parentNode, b); }catch(_){ } }
    });
    if(anunciar){ try{ var lv=$('cadTabLive'); var a=cadAbasVisiveis().filter(function(x){ return x[0]===_cadTab; })[0]; if(lv&&a){ lv.textContent=''; setTimeout(function(){ lv.textContent=a[1]; },30); } }catch(_){} }
    /* v771 (§6.10): a troca de aba muda a altura da página — o dock se
       remede pra o padding inferior continuar certo */
    try{ consultaUiDockMedir(); }catch(_){}
  }
  /* a troca por rota interna: telaCadastro(null,'acesso') ou, já na tela, cadAbaIr('lojas') */
  function cadAbaIr(k, foco){
    /* 🔴 v1033 — pedido de aba que não existe nesta edição: FICA ONDE ESTÁ.
       Não remonta a tela, não troca o foco e não limpa campo. Recusar uma
       troca de aba não pode custar o que a pessoa já digitou. Vale pra link
       antigo, pra chamada interna e pra navegação por teclado. */
    if(!cadAbaDisponivel(k)) return;
    _cadTab=cadAbaOk(k); cadTabAplica(true);
    if(foco){ try{ var b=document.querySelector('#cadTabs .vpx-st[data-step="'+_cadTab+'"]'); if(b) b.focus(); }catch(_){} }
  }
  /* setas movem entre as abas (grade 3×2: ←/→ vizinho, ↑/↓ mesma coluna); Home/End; ativar move junto */
  function cadTabsTeclado(e){
    var keys=['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End']; if(keys.indexOf(e.key)<0) return;
    var bts=Array.prototype.slice.call(document.querySelectorAll('#cadTabs .vpx-st')); if(!bts.length) return;
    var i=bts.indexOf(document.activeElement); if(i<0) i=bts.findIndex(function(b){ return b.classList.contains('on'); }); if(i<0) i=0;
    var n=bts.length, cols=(window.innerWidth<900)?3:1, j=i;
    if(e.key==='ArrowRight') j=(i+1)%n; else if(e.key==='ArrowLeft') j=(i-1+n)%n;
    else if(e.key==='ArrowDown') j=(i+cols<n)?i+cols:i%cols; else if(e.key==='ArrowUp') j=(i-cols>=0)?i-cols:Math.min(n-1, i+cols*Math.floor((n-1-i)/cols));
    else if(e.key==='Home') j=0; else if(e.key==='End') j=n-1;
    e.preventDefault();
    cadAbaIr(bts[j].getAttribute('data-step'), true);
  }
  /* status de salvamento por área (cad-save-status): neutro · pendente · salvando · sucesso · erro-recuperavel · erro */
  function cadStatusSet(aba, estado, texto, tentar){ cadStatusPinta($('cadStatus-'+cadAbaOk(aba)), estado, texto, tentar); }
  /* v756: o pintor é genérico — a Minha loja (16) usa o mesmo cad-save-status */
  function cadStatusPinta(el, estado, texto, tentar){
    if(!el) return;
    var _ck='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var _sp='<span class="cad-save-spin" aria-hidden="true"></span>';
    el.className='cad-save-status'+(estado&&estado!=='neutro'?(' is-'+estado):'');
    if(!estado||estado==='neutro'){ el.innerHTML=''; return; }
    if(estado==='pendente'){ el.textContent=texto||'Alterações pendentes'; return; }
    if(estado==='salvando'){ el.innerHTML=_sp+esc(texto||'Salvando…'); return; }
    if(estado==='sucesso'){ el.innerHTML=_ck+esc(texto||'Alterações salvas'); return; }
    if(estado==='erro-recuperavel'){ el.textContent=texto||'Sem conexão. Tentando novamente…'; return; }
    el.innerHTML=esc(texto||'Não foi possível salvar.')+(tentar?' <button type="button" class="cad-save-retry">Tentar novamente</button>':'');
    if(tentar){ var b=el.querySelector('.cad-save-retry'); if(b) b.onclick=tentar; }
  }
  /* em qual área mora o campo que acabou de mudar (pro status aparecer na aba certa) */
  function _cadAbaDoCampo(el){ try{ var p=el&&el.closest?el.closest('.vpx-panel'):null; return p?cadAbaOk(p.getAttribute('data-panel')):''; }catch(_){ return ''; } }
  function cadAreaHead(k){
    var a=CAD_ABAS.filter(function(x){ return x[0]===k; })[0]||[k,k,''];
    if(cadContaEssencial() && k==='dados') a=['dados','Dados para nota','Dados usados para emitir sua nota fiscal.','Dados para nota fiscal'];
    var descricao=(k==='dados'&&!cadPerfilPublicoVisivel()&&!cadContaEssencial())?'Informações usadas na sua conta.':a[2];
    var ico=''; try{ ico=_CAD_ICO[k]||''; }catch(_){}
    return '<div class="cad-area-head"><span class="cad-area-ico" aria-hidden="true">'+ico+'</span>'
      +'<div class="cad-area-tx"><h3 class="cad-area-t" id="cadPanelT-'+k+'">'+esc(a[3]||a[1])+'</h3><p class="cad-area-d">'+esc(descricao)+'</p></div>'
      +'<div class="cad-save-status" id="cadStatus-'+k+'" role="status" aria-live="polite"></div></div>';
  }
  var _CAD_ICO=null;
  /* ===== v758 — A FILA ÚNICA DO METADATA (RISCO A do projeto da conta) =====
     Dados pessoais/endereço (autosave), referências de documentos (11c) e a
     preferência de repasse (08) gravam no MESMO metadata da autenticação. Cada
     um montava "Object.assign({}, meuMeta, ...)" na hora e gravava — duas
     gravações cruzadas terminavam com a cópia velha por cima da nova (o campo
     que acabou de salvar sumia). Agora TODO mundo entrega só um PATCH aqui;
     a fila serializa, funde o patch com o meuMeta MAIS RECENTE no momento de
     gravar, e só atualiza o meuMeta depois da confirmação do servidor. */
  var _metaFila=Promise.resolve(), _metaEmVoo=0;
  function cadMetaAtualizar(patch, origem){
    patch=patch||{};
    var job=function(){
      _metaEmVoo++;
      var meta=Object.assign({}, meuMeta||{}, patch);
      return supa.auth.updateUser({ data:meta }).then(function(up){
        if(up&&up.error) throw up.error;
        var srv=up&&up.data&&up.data.user&&up.data.user.user_metadata;
        meuMeta=(srv&&typeof srv==='object')?Object.assign({}, meta, srv):meta;
        return meuMeta;
      }).finally(function(){ _metaEmVoo--; });
    };
    var p=_metaFila.then(job, job);
    _metaFila=p.catch(function(){});
    return p;
  }
  function cadMetaEmVoo(){ return _metaEmVoo>0; }
  async function telaCadastro(voltarPara, abaInicial){
    var _volta=(typeof voltarPara==='function')?voltarPara:voltarHome;
    mevTabSet('');
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); voltarTab(_volta);
    document.body.classList.add('conta-on');   /* v755: dock compacto + padding inferior (mevTabSet/voltarHome tiram) */
    /* abre NA HORA com os dados da sessão (sem esperar a rede) e atualiza o cache em segundo plano */
    /* v758: a cópia do servidor não passa por cima de uma gravação em voo */
    try{ withTimeout(supa.auth.getUser(),8000).then(function(r){ var u=r&&r.data&&r.data.user; if(u&&u.user_metadata && !cadMetaEmVoo()) meuMeta=Object.assign({}, u.user_metadata); }).catch(function(){}); }catch(_){}
    var md=meuMeta||{}; var email=meuEmail||''; var _soConsultas=cadContaEssencial();
    /* A foto NÃO fica no token (md.foto) — ela vem da tabela 'perfil' (meuFoto).
       Por isso usamos meuFoto como fonte da verdade aqui, senão o avatar
       aparecia vazio (só a inicial) mesmo tendo foto salva no banco. */
    var foto=md.foto||meuFoto||'', nome=md.nome||'', tel=md.telefone||'';
    var ini=esc((nome||email||'?').trim().charAt(0).toUpperCase());
    var avaStyle=foto?(' style="background-image:url('+esc(foto)+')"'):'';
    var saldoTxt=ilimitado?'&#8734;':String(saldo);
    /* ===== v389 (pedido — folha "MINHA CONTA") ============================
       A conta virou SEIS seções, na ordem do papel:
         Documentos · Dados pessoais · Endereço · Fotos · Lojas · Acesso
       - Documentos: CNH + comprovante de residência (anexar, miniatura, ver,
         baixar) — painel do 11c-conta-documentos.js, bucket privado.
       - Dados pessoais: foto, e-mail, CPF, nome, telefone, Instagram, site
         e o "Sobre mim" (metade texto da prova social).
       - Fotos: entregas e depoimentos (metade murais da prova social).
       - Lojas: CNPJ da empresa + lojas vinculadas/código + preferência de
         repasse. Acesso: senha, recuperação e sair.
       Os IDs dos campos NÃO mudaram — autosave, CEP e afins continuam. */
    var _CI={
      docs:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h6"/></svg>',
      dados:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
      endereco:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
      fotos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
      lojas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><rect x="9" y="13" width="6" height="7"/></svg>',
      acesso:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
    };
    _CAD_ICO=_CI;
    /* v1033 — a navegação usa a lista VISÍVEL da edição; os painéis abaixo
       continuam sendo montados todos (ver o comentário do cadAbasVisiveis). */
    var _abas=cadAbasVisiveis();
    var _perfilPublico=cadPerfilPublicoVisivel();
    var _d0=psNorm(null); _psDados.cad=_d0;
    /* v755: abas reais — role=tab/aria-controls; painéis role=tabpanel/aria-labelledby/hidden */
    var _painel=function(k, extra){ return '<div class="vpx-panel" data-panel="'+k+'" id="cadPanel-'+k+'" role="tabpanel" aria-labelledby="cadTab-'+k+'"'+(extra||'')+' hidden>'+cadAreaHead(k); };
    var _enderecoHtml='<div class="cad-sec"'+(_soConsultas?'':' style="border-top:none;padding-top:8px;margin-top:8px"')+'>'+
          (_soConsultas?'<h3>Endereço para nota fiscal</h3>':'')+
          '<label class="cad-lbl">CEP</label><input class="cad-in" id="cadCep" inputmode="numeric" value="'+esc(md.cep||'')+'" placeholder="00000-000 (busca o endereço)"><div class="cad-msg" id="cadCepMsg"></div>'+
          '<label class="cad-lbl">Rua</label><input class="cad-in" id="cadRua" value="'+esc(md.rua||'')+'" placeholder="Rua / logradouro">'+
          '<div class="cli-2col"><div><label class="cad-lbl">Número</label><input class="cad-in" id="cadNum" inputmode="numeric" value="'+esc(md.numero||'')+'" placeholder="Nº"></div><div><label class="cad-lbl">Bairro</label><input class="cad-in" id="cadBairro" value="'+esc(md.bairro||'')+'" placeholder="Bairro"></div></div>'+
          '<div class="cli-2col"><div><label class="cad-lbl">Cidade</label><input class="cad-in" id="cadCidade" value="'+esc(md.cidade||'')+'" placeholder="Cidade"></div><div><label class="cad-lbl">UF</label><input class="cad-in" id="cadUf" maxlength="2" value="'+esc(md.uf||'')+'" placeholder="UF" autocapitalize="characters"></div></div>'+
      '</div>';
    var html='<div class="info-pg cad-float cad-conta"><h2>Minha conta</h2><p class="cad-conta-sub">'+(_soConsultas?'Dados fiscais, acesso e recuperação':'Gerencie seus dados e acessos')+'</p>'+
      '<div class="vpx"><div class="vpx-steps vpx-mdr" id="cadTabs" role="tablist" aria-label="Seções da minha conta">'+
        _abas.map(function(a){ return '<button type="button" class="vpx-st" role="tab" id="cadTab-'+a[0]+'" aria-controls="cadPanel-'+a[0]+'" aria-selected="false" tabindex="-1" data-step="'+a[0]+'"><span class="vpx-ico" aria-hidden="true">'+_CI[a[0]]+'</span><span class="vpx-nm">'+a[1]+'</span></button>'; }).join('')+
      '</div><div class="vpx-body" id="cadBody"><div id="cadTabLive" class="sr-only" aria-live="polite"></div>'+

      /* ---- 1. DOCUMENTOS ---- */
      _painel('docs')+cdocPainelHtml()+'</div>'+

      /* ---- 2. DADOS PESSOAIS ---- */
      _painel('dados')+
      (_soConsultas?'':('<div class="cad-ava-row"><div class="cad-ava" id="cadAva"'+avaStyle+'>'+(foto?'':ini)+'</div>'+
        '<div><button class="cad-fbtn" id="cadFotoBtn">Trocar foto</button>'+
        '<div style="font-size:11.5px;color:#94a3b8;margin-top:5px">Fica salva na sua conta</div></div>'+
        '<input type="file" id="cadFoto" accept="image/*" style="display:none"></div>'))+
      '<div class="cad-sec" style="border-top:none;padding-top:8px;margin-top:8px">'+
      '<div class="cad-grid2">'+
        '<div>'+
          '<div class="cad-lbl">E-mail <span style="font-weight:600;color:#94a3b8">(seu login)</span></div><input class="cad-in" id="cadEmail" type="email" value="'+esc(email)+'" readonly style="background:#f1f5f9;color:#64748b;cursor:not-allowed">'+
          (_soConsultas?('<label class="cad-lbl">Nome ou razão social</label><input class="cad-in" id="cadNome" value="'+esc(nome)+'" placeholder="Nome do tomador da nota">'+
            '<div class="cli-2col"><div><label class="cad-lbl">CPF</label><input class="cad-in" id="cadCpf" inputmode="numeric" value="'+esc(md.cpf||'')+'" placeholder="000.000.000-00"></div><div><label class="cad-lbl">CNPJ</label><input class="cad-in" id="cadCnpj" inputmode="numeric" value="'+esc(md.cnpj||'')+'" placeholder="00.000.000/0000-00"></div></div>'+
            '<div class="cad-msg">Preencha CPF ou CNPJ, conforme o tomador da nota fiscal.</div>'):(
            '<div class="cad-lbl">CPF</div><input class="cad-in" id="cadCpf" inputmode="numeric" value="'+esc(md.cpf||'')+'" placeholder="000.000.000-00">'+
            '<div class="cli-2col"><div><label class="cad-lbl">Nome</label><input class="cad-in" id="cadNome" value="'+esc(nome)+'" placeholder="Seu nome"></div><div><label class="cad-lbl">Telefone / WhatsApp</label><input class="cad-in" id="cadTel" value="'+esc(tel)+'" placeholder="(00) 00000-0000"></div></div>'))+
          (_perfilPublico?('<div class="cli-2col"><div><label class="cad-lbl">Instagram</label><input class="cad-in" id="cadInsta" value="'+esc(md.instagram||'')+'" placeholder="@sualoja" autocapitalize="none"></div><div><label class="cad-lbl">Site (se tiver)</label><input class="cad-in" id="cadSite" value="'+esc(md.site||'')+'" placeholder="www.seusite.com.br" inputmode="url" autocapitalize="none"></div></div>'):'')+
        '</div>'+
        (_perfilPublico?('<div id="cadPsTexto"><div class="ps-wrap">'+psTextoHtml('cad','vendedor',_d0)+'<div class="cad-autosave vazio" id="cadPsSave"></div></div></div>'):'')+
      '</div>'+
        '<div class="cad-autosave vazio" id="cadAutosave"></div>'+
        '<div class="cad-msg" id="cadMsg"></div></div>'+(_soConsultas?_enderecoHtml:'')+
      '</div>'+

      /* ---- 3. ENDEREÇO ---- */
      _painel('endereco')+
      (_soConsultas?'':_enderecoHtml)+'</div>'+

      /* ---- 4. FOTOS (entregas e depoimentos) ---- */
      _painel('fotos')+'<div id="cadPsBox"><div class="ps-wrap">'+psFotosHtml('cad','vendedor',_d0)+'</div></div></div>'+

      /* ---- 5. LOJAS ---- */
      _painel('lojas')+
      '<div class="cad-sec" style="border-top:none;padding-top:8px;margin-top:8px">'+
        (_soConsultas?'':('<label class="cad-lbl">CNPJ da empresa</label><input class="cad-in" id="cadCnpj" value="'+esc(md.cnpj||'')+'" placeholder="00.000.000/0000-00" inputmode="numeric">'))+
      '</div>'+
      /* v282: "o código da loja que trabalha ou o CNPJ dentro do meu cadastro".
         O quadro se pinta sozinho logo abaixo (cadLojaPinta), porque depende de
         uma ida ao banco — e o cadastro tem que abrir NA HORA, sem esperar rede. */
      '<div id="cadLojaBox"></div>'+
      '<div id="cadRepassePref"></div>'+
      /* v400 (pedido): "Lojas que eu divulgo" saiu do menu e mora aqui */
      '<div class="cad-sec"><div class="cad-sec-tit">Lojas que eu divulgo</div>'+
      '<button type="button" class="cad-btn sec ico" id="cadIndicador" style="margin-top:8px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:17px;height:17px"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M9 13h6"/><path d="m9 17 2 2 4-4"/></svg> Abrir minhas lojas divulgadas</button></div>'+
      '</div>'+

      /* ---- 6. ACESSO ---- */
      _painel('acesso')+
      '<div class="cad-grid2">'+
      '<div class="cad-sec" style="border-top:none;margin-top:8px"><h3>Trocar senha</h3>'+
        '<div class="cad-help">Por segurança, enviaremos um código de 6 dígitos ao seu e-mail antes de alterar.</div>'+
        '<div class="cad-lbl">Nova senha (min. 6)</div><input class="cad-in" id="cadS1" type="password" autocomplete="new-password">'+
        '<div class="cad-lbl">Repetir nova senha</div><input class="cad-in" id="cadS2" type="password" autocomplete="new-password">'+
        '<button class="cad-btn" id="cadSenha">Alterar senha</button>'+
        '<div class="cad-msg" id="cadMsgS"></div></div>'+
      '<div class="cad-sec" style="border-top:none;margin-top:8px"><h3>Recuperação de senha</h3>'+
        '<div class="cad-help">Envia um código de 6 dígitos para o seu e-mail de login.</div>'+
        '<button class="cad-btn sec" id="cadRec" style="margin-top:10px">Recuperar com código por e-mail</button>'+
        '<div class="cad-msg" id="cadMsgR"></div></div>'+
      '</div>'+
      /* v407 (pedido): lista dos aparelhos da conta, com Desconectar —
         quem pinta é o devListaPinta() do 01b-dispositivos */
      '<div class="cad-sec"><h3>Aparelhos conectados</h3>'+
        '<div class="cad-help cad-help-space">Aparelhos que já entraram nesta conta. Desconectar um aparelho faz ele pedir a senha de novo.</div>'+
        '<div id="devLista"></div></div>'+
      /* ===== v512 — BAIXAR MEUS DADOS (Fase 1 do projeto de excluir conta)
         "Permita o usuário baixar um backup do estoque, conversas, fotos."
         Fica na aba Acesso, que é onde moram as coisas da CONTA (senha,
         aparelhos, sair) — e não em Documentos, que é papel de veículo.
         ⚠️ O pacote NÃO é montado aqui: o botão só faz o pedido e o link
         chega por e-mail. Zipar 100 MB no navegador do celular trava o
         aparelho, e o link precisa ser privado e com prazo porque o pacote
         pode ter foto de documento. Quem monta é a função de fundo. */
      '<div class="cad-sec"><h3>Meus dados</h3>'+
        '<div class="cad-help cad-help-space">'+
          (_soConsultas
            ? 'Baixe uma cópia dos dados da sua conta e das consultas. Se esta mesma conta também for usada em outros produtos MEV, o pacote inclui os dados desses serviços.<br>'
            : 'Baixe uma cópia de tudo que é seu: estoque, clientes, vendas, avaliações, repasses, consultas, as conversas e as fotos no tamanho original. Os arquivos abrem no Excel.<br>')+
          'O pacote é montado no servidor e o link chega no seu e-mail — vale por 24 horas. '+
          '<b>Pedir não muda nada na sua conta.</b></div>'+
        '<button class="cad-btn sec" id="cadBaixarDados">Baixar meus dados</button>'+
        '<div id="cadBaixarMsg" class="msg"></div></div>'+
      '<div class="cad-sec"><button class="cad-btn sair" id="cadSair">Sair da conta</button></div>'+
      /* ===== 🔴 v1038 — EXCLUIR MINHA CONTA ============================
         Pedido do Angelo (15/09) e exigência da Google Play: quem cria a
         conta dentro do app tem que conseguir PEDIR a exclusão dentro do app.
         Fica no fim da aba Acesso, depois do "Sair da conta" e depois do
         "Baixar meus dados" — nessa ordem de propósito: antes de apagar, a
         pessoa vê que dá pra levar os dados embora.
         ⚠️ O botão é discreto e FRIO (contorno, não vermelho cheio): ação
         destrutiva não se oferece como se fosse a próxima coisa a fazer.
         A fila automática respeita 24h de cancelamento e o período já pago.
         Contratos e comprovantes financeiros seguem a retenção legal; o
         restante é apagado e o Auth é sempre a última etapa. */
      '<div class="cad-sec cad-sec-perigo" id="cadExcBox">'+
        '<h3>Excluir minha conta</h3>'+
        '<div id="cadExcTexto" style="font-size:12.5px;color:#64748b;line-height:1.5;margin-bottom:8px">'+
          'Apaga a sua conta do MEV e os dados ligados a ela. <b>Não dá pra desfazer depois do prazo.</b><br>'+
          'Contratos e comprovantes financeiros podem ser guardados pelo prazo legal, com acesso restrito.<br>'+
          'Se quiser guardar uma cópia antes, use o "Baixar meus dados" aqui em cima.</div>'+
        '<button class="cad-btn sec cad-btn-perigo" id="cadExcluir">Excluir minha conta</button>'+
        '<div id="cadExcMsg" class="msg"></div></div>'+
      '</div>'+

      '</div></div>'+                                        /* fecha vpx-body e vpx */
      '</div>';
    $('secoes').innerHTML=html; _cadWireBack(); voltarTab(_volta);
    /* as seções de Minha conta (v389: abre nos Documentos, 1ª da folha) */
    /* v1033 — a aba inicial é decidida ANTES da primeira pintura: no Consultas
       abre em Dados pessoais, sem piscar Documentos no meio do caminho. */
    _cadTab=cadAbaDestino(abaInicial||cadAbaPadrao()); cadTabAplica(false);
    Array.prototype.forEach.call(document.querySelectorAll('#cadTabs .vpx-st'),function(b){
      b.onclick=function(){ cadAbaIr(b.getAttribute('data-step')||cadAbaPadrao(), false); };
    });
    var _tl=$('cadTabs'); if(_tl) _tl.addEventListener('keydown', cadTabsTeclado);
    try{ consultaUiDockMedir(); }catch(_){}   /* v755: o padding inferior vem da altura real do dock */
    /* v1033 — só busca documentos quando a seção existe nesta edição.
       O painel segue no DOM; o que não sai é a ida ao bucket. */
    if(cadAbaDisponivel('docs')) cdocWire();
    if(!_soConsultas){ psWire('cad','vendedor'); psCarregarPerfil({texto:_perfilPublico}); }
    /* recuperação de senha: abre o mesmo fluxo guiado por código do login */
    var _ind=$('cadIndicador'); if(_ind) _ind.onclick=function(){ telaIndicador(); };   /* v400 */
    try{ devListaPinta(); }catch(_){}   /* v407: aparelhos conectados (01b) */
    var _rec=$('cadRec'); if(_rec) _rec.onclick=function(){ try{ abrirPedidoRecuperacao(); }catch(_){ var m=$('cadMsgR'); if(m){ m.className='cad-msg err'; m.textContent='Não consegui abrir a recuperação agora.'; } } };
    /* Segurança: se a foto ainda não tiver sido carregada da tabela 'perfil'
       (rede lenta / abriu Minha conta muito rápido), busca agora e pinta o avatar. */
    if(!_soConsultas && !foto && meuId){ try{ withTimeout(supa.from('perfil').select('foto').eq('user_id',meuId).limit(1),8000).then(function(r){ var f=(r&&r.data&&r.data[0]&&r.data[0].foto)||''; if(f){ meuFoto=f; var av=$('cadAva'); if(av){ av.style.backgroundImage=imgFundo(f,96); av.textContent=''; } try{ mevGreetPinta(); }catch(_){} } }).catch(function(){}); }catch(_){} }
    var _fotoBtn=$('cadFotoBtn'), _fotoInp=$('cadFoto');
    if(_fotoBtn&&_fotoInp){
      _fotoBtn.onclick=function(){ _fotoInp.value=''; _fotoInp.click(); };
      _fotoInp.onchange=function(){ var f=this.files&&this.files[0]; if(!f) return;
        fotoCropAbrir(f, async function(b64){
          if(!b64) return; toast('Enviando foto...');
          try{ var durl='data:image/jpeg;base64,'+b64;
            var av=$('cadAva'); if(av){ av.style.backgroundImage='url('+durl+')'; av.textContent=''; }
            /* IMPORTANTE: a foto vai pra tabela 'perfil', NUNCA pro token (metadata).
               Foto grande no token deixa o cabeçalho gigante e TRAVA as consultas. */
            var up=await supa.from('perfil').upsert({user_id:meuId, foto:durl, atualizado_em:new Date().toISOString()}, {onConflict:'user_id'});
            if(!(up&&up.error)){ meuFoto=durl; try{ mevGreetPinta(); }catch(_){} }
            toast((up&&up.error)?'Nao consegui salvar a foto':'Foto atualizada'); }
          catch(e){ toast('Nao consegui usar essa imagem'); }
        }); };
    }
    var _cc=$('cadCnpj'); if(_cc) _cc.oninput=function(){ var d=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,14); var o=d;
      if(d.length>2) o=d.slice(0,2)+'.'+d.slice(2); if(d.length>5) o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5);
      if(d.length>8) o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5,8)+'/'+d.slice(8); if(d.length>12) o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5,8)+'/'+d.slice(8,12)+'-'+d.slice(12); this.value=o; cadAgendaSalvar(); };
    /* ================= SALVAR AUTOMÁTICO (sem botão) ================= */
    var _cv=function(id){ return String((($(id)||{}).value)||'').trim(); };
    var _cvOuMeta=function(id,chave){ var el=$(id); return el?_cv(id):String((meuMeta&&meuMeta[chave])||(md&&md[chave])||'').trim(); };
    function cadColeta(){
      var dados={ nome:_cvOuMeta('cadNome','nome'), telefone:_cvOuMeta('cadTel','telefone'), cnpj:_cvOuMeta('cadCnpj','cnpj'), cpf:_cvOuMeta('cadCpf','cpf'), cep:_cvOuMeta('cadCep','cep'), rua:_cvOuMeta('cadRua','rua'), numero:_cvOuMeta('cadNum','numero'), bairro:_cvOuMeta('cadBairro','bairro'), cidade:_cvOuMeta('cadCidade','cidade'), uf:_cvOuMeta('cadUf','uf') };
      /* Campo ausente não vira string vazia: preserva o dado já salvo quando
         a pessoa abre a conta por Consultas ou Avaliações. */
      if(_perfilPublico){ dados.instagram=_cv('cadInsta'); dados.site=_cv('cadSite'); }
      return dados;
    }
    var _cadSaveTimer=null, _cadSaveLast=JSON.stringify(cadColeta());
    /* v755: o status vive no cabeçalho da ÁREA do campo que mudou (cad-save-status);
       "salvas" só depois da confirmação do servidor; erro não some ao trocar de aba */
    var _cadStatusAba='dados', _cadTentado='';
    function cadAgendaSalvar(){ var ind=$('cadAutosave'); if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; }
      var ab=_cadAbaDoCampo(document.activeElement); if(ab) _cadStatusAba=ab;
      /* um erro à vista só sai da tela quando os dados mudam de verdade (o blur do campo ao trocar de aba não o apaga) */
      var st=$('cadStatus-'+_cadStatusAba); var erroVivo=!!(st && /is-erro/.test(st.className));
      if(!(erroVivo && JSON.stringify(cadColeta())===_cadTentado)) cadStatusSet(_cadStatusAba,'pendente');
      clearTimeout(_cadSaveTimer); _cadSaveTimer=setTimeout(cadSalvarAuto, 1100); }
    async function cadSalvarAuto(){ var obj=cadColeta(); var js=JSON.stringify(obj); var ind=$('cadAutosave'); var ab=_cadStatusAba;
      if(js===_cadSaveLast){ if(ind){ ind.className='cad-autosave vazio'; ind.textContent=''; } cadStatusSet(ab,'neutro'); return; }
      _cadTentado=js;
      cadStatusSet(ab,'salvando');
      try{ await cadMetaAtualizar(obj, 'autosave');   /* v758: pela fila única */
        _cadSaveLast=js; meuNome=obj.nome||meuNome;
        if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; setTimeout(function(){ var i2=$('cadAutosave'); if(i2&&i2.classList.contains('ok')){ i2.className='cad-autosave vazio'; i2.textContent=''; } }, 2200); }
        cadStatusSet(ab,'sucesso'); setTimeout(function(){ var st=$('cadStatus-'+ab); if(st&&st.classList.contains('is-sucesso')) cadStatusSet(ab,'neutro'); }, 2200);
        try{ mevGreetPinta(); }catch(_){}
      }catch(e){ if(ind){ ind.className='cad-autosave err'; ind.textContent='Sem conexão — tentando de novo…'; } cadStatusSet(ab,'erro-recuperavel'); clearTimeout(_cadSaveTimer); _cadSaveTimer=setTimeout(cadSalvarAuto, 3000); }
    }
    ['cadNome','cadTel','cadCnpj','cadInsta','cadSite','cadRua','cadNum','cadBairro','cadCidade','cadUf'].forEach(function(id){ var e=$(id); if(e){ e.addEventListener('input',cadAgendaSalvar); e.addEventListener('change',cadAgendaSalvar); } });
    var _uf=$('cadUf'); if(_uf) _uf.addEventListener('input',function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); });
    /* CPF: campo simples (a consulta de CPF saiu do cadastro a pedido) */
    var _cpfEl=$('cadCpf'); if(_cpfEl){
      var _cpfTry=function(){ _cpfEl.value=(typeof _fmtCpf==='function')?_fmtCpf(_cpfEl.value):_cpfEl.value; cadAgendaSalvar(); };
      _cpfEl.oninput=_cpfTry; _cpfEl.addEventListener('paste',function(){ setTimeout(_cpfTry,0); });
    }
    /* CEP: preenche rua/bairro/cidade/uf */
    var CAD_CEP_IDS={cep:'cadCep',rua:'cadRua',bairro:'cadBairro',cidade:'cadCidade',uf:'cadUf',num:'cadNum'};
    var _cep=$('cadCep'); if(_cep){ var _cepGo=function(){ var m=$('cadCepMsg'); if(String((($('cadCep')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length!==8) return; if(m){ m.className='cad-msg'; m.textContent='Buscando endereço…'; } cepBusca(($('cadCep')||{}).value,CAD_CEP_IDS).then(function(ok){ if(m){ if(ok&&ok.rua){ m.className='cad-msg ok'; m.textContent='Endereço encontrado ✓'; } else if(ok){ m.className='cad-msg ok'; m.textContent='CEP geral de '+(ok.cidade||'da cidade')+' ✓ — esse CEP não tem rua definida, digite a rua e o bairro.'; } else { m.className='cad-msg'; m.textContent='CEP não encontrado — pode preencher à mão.'; } } cadAgendaSalvar(); }); };
      _cep.oninput=function(){ this.value=(typeof cepFmt==='function')?cepFmt(this.value):this.value; cadAgendaSalvar(); if(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length===8) _cepGo(); };
      _cep.addEventListener('blur',_cepGo);
    }
    var _cadCpr=$('cadComprar'); if(_cadCpr) _cadCpr.onclick=function(){ abrirPacotes(); };
    var _ch=$('cadHist'); if(_ch) _ch.onclick=function(){ abrirHistorico(); };
    /* v1033 — mesma regra pro painel Lojas: sem seção, sem ida ao banco.
       ⚠️ O campo cadCnpj continua montado e com o valor salvo — é dele que o
       cadColeta() lê na hora de salvar. */
    if(cadAbaDisponivel('lojas')){
      try{ var _pl=cadLojaPinta(); if(_pl&&_pl.catch) _pl.catch(function(){}); }catch(_){}
      try{ repassePrefMontar('cadRepassePref','cadRepasse').catch(function(){}); }catch(_){}
    }
    $('cadSenha').onclick=async function(){ var m=$('cadMsgS'); m.className='cad-msg'; var s1=$('cadS1').value, s2=$('cadS2').value, self=this;
      if(s1.length<6){ m.className='cad-msg err'; m.textContent='A senha precisa ter no minimo 6 caracteres.'; return; }
      if(s1!==s2){ m.className='cad-msg err'; m.textContent='As senhas nao sao iguais.'; return; }
      var code=await reautPedirCodigo('Confirmar troca de senha');
      if(code===null){ m.className='cad-msg'; m.textContent='Troca de senha cancelada.'; return; }
      self.disabled=true; self.textContent='Alterando...';
      try{ var up=await supa.auth.updateUser({password:s1, nonce:code}); if(up&&up.error) throw up.error; m.className='cad-msg ok'; m.textContent='Senha alterada com sucesso.'; $('cadS1').value=''; $('cadS2').value=''; }
      catch(err){ var msg=(err&&err.message)||''; m.className='cad-msg err'; m.textContent=/nonce|invalid|expired|token|reauth/i.test(msg)?'Código inválido ou expirado. Tente de novo.':(msg||'Nao consegui alterar a senha.'); }
      self.disabled=false; self.textContent='Alterar senha'; };
    $('cadSair').onclick=function(){ _hardLogout(); location.reload(); };
    /* ======================================================================
       🔴🔴 v1038 — EXCLUIR MINHA CONTA (Meu cadastro › Acesso)
       ----------------------------------------------------------------------
       TRÊS PORTAS ANTES DE REGISTRAR O PEDIDO, e nenhuma delas é enfeite:
         1) a tela diz o que vai acontecer, o prazo e o que dá pra salvar antes;
         2) a pessoa DIGITA a palavra EXCLUIR — clique errado não apaga conta;
         3) o servidor guarda o pedido, manda e-mail pra ela e pro suporte, e
            deixa CANCELAR por 24 horas (decisão do Angelo, 15/09).
       ⚠️ O estado é lido do SERVIDOR quando a aba Acesso aparece pela primeira
       vez — não de um palpite local. Se a pessoa pediu no celular e abriu no
       computador, os dois têm que mostrar a mesma coisa.
       ⚠️ Eu não apago nada daqui. A função diária faz a limpeza no servidor,
       guarda a trilha mínima e apaga o Auth somente no fim. */
    var _excPedido=null, _excLido=false;
    function cadExcPinta(){
      var box=$('cadExcBox'), bt=$('cadExcluir'), tx=$('cadExcTexto'), m=$('cadExcMsg');
      if(!box||!bt||!tx) return;
      if(_excPedido && _excPedido.pedida_em){
        var _q=_excDataBr(_excPedido.cancelavel_ate), _d=Number(_excPedido.prazo_dias||30);
        box.classList.add('is-pedido');
        tx.innerHTML='<b>Pedido de exclusão registrado.</b><br>'+
          'A sua conta e os seus dados serão apagados em até '+_d+' dias.<br>'+
          'Dá pra cancelar até <b>'+esc(_q)+'</b>. Depois desse prazo, só pelo suporte.';
        bt.textContent='Cancelar o pedido de exclusão';
        bt.classList.remove('cad-btn-perigo');
        bt.disabled=false;
      } else {
        box.classList.remove('is-pedido');
        tx.innerHTML='Apaga a sua conta do MEV e os dados ligados a ela. <b>Não dá pra desfazer depois do prazo.</b><br>'+
          'Contratos e comprovantes financeiros podem ser guardados pelo prazo legal, com acesso restrito.<br>'+
          'Se quiser guardar uma cópia antes, use o "Baixar meus dados" aqui em cima.';
        bt.textContent='Excluir minha conta';
        bt.classList.add('cad-btn-perigo');
        bt.disabled=false;
      }
      if(m){ m.className='msg'; m.textContent=''; }
    }
    function _excDataBr(iso){ try{ return new Date(iso).toLocaleString('pt-BR'); }catch(_){ return String(iso||''); } }
    async function cadExcStatus(){
      if(_excLido) return; _excLido=true;
      var d=null; try{ d=await apiTimeout('/api/excluir-minha-conta',{acao:'status'},12000); }catch(_){ d=null; }
      if(d&&d.ok){ _excPedido=d.pedido||null; cadExcPinta(); }
    }
    /* o diálogo da palavra EXCLUIR — mesmo molde do reautPedirCodigo */
    function cadExcConfirmar(){
      return new Promise(function(resolve){
        var ov=document.createElement('div'); ov.className='cropmask';
        ov.innerHTML='<div class="cropbox" style="max-width:340px">'+
          '<div class="crop-tit">Excluir a sua conta</div>'+
          '<div class="crop-sub" style="text-align:left">Vão embora: a sua conta, o seu cadastro, as suas consultas, avaliações, clientes e fotos.<br><br>'+
          'O saldo que você já pagou vale até o fim do período da sua assinatura.<br><br>'+
          'Contratos assinados e comprovantes financeiros podem ficar guardados por 5 anos para obrigação legal e defesa de direitos, sem acesso público.<br><br>'+
          '<b>Isso não tem como desfazer depois do prazo.</b> Pra confirmar, digite <b>EXCLUIR</b> abaixo.</div>'+
          '<input id="excPalavra" class="cad-in" autocapitalize="characters" autocomplete="off" placeholder="EXCLUIR" style="text-align:center;letter-spacing:4px;font-size:18px;font-weight:800;margin-top:2px">'+
          '<div class="cad-msg" id="excMsg" style="min-height:14px"></div>'+
          '<div class="crop-acts"><button type="button" class="crop-c" id="excNao">Cancelar</button><button type="button" class="crop-ok" id="excSim">Confirmar exclusão</button></div>'+
          '</div>';
        document.body.appendChild(ov);
        var inp=ov.querySelector('#excPalavra'); setTimeout(function(){ try{inp.focus();}catch(_){} },120);
        function done(v){ try{ov.remove();}catch(_){} resolve(v); }
        ov.querySelector('#excNao').onclick=function(){ done(false); };
        ov.querySelector('#excSim').onclick=function(){
          if(String(inp.value||'').trim().toUpperCase()!=='EXCLUIR'){
            var mm=ov.querySelector('#excMsg'); mm.className='cad-msg err'; mm.textContent='Digite EXCLUIR pra confirmar.'; return;
          }
          done(true);
        };
        inp.onkeydown=function(e){ if(e.key==='Enter'){ ov.querySelector('#excSim').click(); } };
      });
    }
    var _bx=$('cadExcluir');
    if(_bx) _bx.onclick=async function(){
      var m=$('cadExcMsg'), self=this;
      var cancelando=!!(_excPedido&&_excPedido.pedida_em);
      if(!cancelando){ var ok=await cadExcConfirmar(); if(!ok) return; }
      self.disabled=true; self.textContent=cancelando?'Cancelando…':'Registrando…';
      if(m){ m.className='msg'; m.textContent=''; }
      var d=null;
      try{ d=await apiTimeout('/api/excluir-minha-conta',{acao:cancelando?'cancelar':'pedir'},15000); }catch(_){ d=null; }
      if(d&&d.ok){
        _excPedido=d.pedido||null; cadExcPinta();
        if(m){ m.className='msg ok';
          m.textContent=cancelando ? 'Pedido cancelado. Está tudo como antes.'
            : (d.repetido ? 'Você já tinha pedido — o prazo continua valendo.'
               : 'Pedido registrado. Mandamos um e-mail pra '+(meuEmail||'você')+' com o prazo e o link pra cancelar.'); }
      } else {
        cadExcPinta();
        if(m){ m.className='msg err'; m.textContent=(d&&d.erro)||'Não consegui agora. Tente de novo em instantes.'; }
      }
    };
    /* lê o estado quando a aba Acesso aparece (e já agora, se ela é a inicial) */
    if(_cadTab==='acesso') cadExcStatus();
    try{
      var _tlAc=$('cadTabs');
      if(_tlAc) _tlAc.addEventListener('click', function(e){
        var b=e.target&&e.target.closest?e.target.closest('.vpx-st'):null;
        if(b && b.getAttribute('data-step')==='acesso') cadExcStatus();
      });
    }catch(_){}

    /* v512 — o pedido de "baixar meus dados". O botão desliga no clique e
       NÃO volta: o pacote leva minutos e o link chega por e-mail. Deixar o
       botão vivo convidaria a tocar de novo, e o servidor tem um freio de
       1 pedido por hora que responderia "você já pediu" — parecendo erro. */
    var _bd=$('cadBaixarDados');
    if(_bd) _bd.onclick=async function(){
      var m=$('cadBaixarMsg'); var self=this;
      self.disabled=true; self.textContent='Pedindo…';
      if(m){ m.className='msg'; m.textContent=''; }
      var d=null;
      try{ d=await apiTimeout('/api/exportar-meus-dados',{},20000); }catch(_){ d=null; }
      if(d&&d.ok){
        self.textContent='Pedido enviado ✓';
        if(m){ m.className='msg ok';
          m.textContent=d.repetido ? d.aviso
            : ('Estamos montando o seu pacote. O link chega em '+(meuEmail||'seu e-mail')+' em alguns minutos — ele vale por 24 horas.'); }
      } else {
        self.disabled=false; self.textContent='Baixar meus dados';
        if(m){ m.className='msg err'; m.textContent=(d&&d.erro)||'Não consegui pedir agora. Tente de novo em instantes.'; }
      }
    };
  }

  /* ---- Tela: Consultar FIPE por modelo (tabela FIPE publica, gratis) ---- */
  var FIPE_BASE='https://parallelum.com.br/fipe/api/v1';
  async function fipeGet(path){
    try{ var r=await fetch('/api/fipe',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({path:path})}); if(r&&r.ok) return await r.json(); }catch(_){}
    /* fallback: chama a FIPE direto (parallelum libera CORS) — funciona mesmo se a rota /api/fipe faltar */
    var r2=await fetch(FIPE_BASE+path,{headers:{Accept:'application/json'}}); if(!r2||!r2.ok) throw new Error('FIPE '+((r2&&r2.status)||'')); return await r2.json();
  }
  function fmSelHtml(id,label){ return '<div class="fm-field"><label class="fm-lbl" for="'+id+'">'+label+'</label><select id="'+id+'" class="fm-sel" disabled><option value="">-</option></select></div>'; }
  function fmFill(id,items,ph){ var s=$(id); if(!s) return; s.innerHTML='<option value="">'+esc(ph)+'</option>'+(items||[]).map(function(it){ return '<option value="'+esc(it.codigo)+'">'+esc(it.nome)+'</option>'; }).join(''); s.disabled=false; }
  function fmReset(id,txt){ var s=$(id); if(!s) return; s.innerHTML='<option value="">'+esc(txt||'-')+'</option>'; s.disabled=true; }
  function fmBusy(id,txt){ var s=$(id); if(!s) return; s.innerHTML='<option value="">'+esc(txt||'Carregando...')+'</option>'; s.disabled=true; }
  function fmMsg(t,cls){ ['fmMsg','fmGuideMsg'].forEach(function(id){ var m=$(id); if(m){ m.className='cad-msg'+(id==='fmGuideMsg'?' fm-guide-msg':'')+(cls?(' '+cls):''); m.textContent=t||''; } }); }
  function fmResult(html){ var r=$('fmResult'); if(r) r.innerHTML=html||''; }
  var _fmUltimo=null, _fmUltimoItem=null;
  /* v982 — a busca manual por tipo/marca/modelo também é uma consulta útil,
     mesmo sem placa. Ela ganha histórico próprio, sincronizado pela mesma
     doc_consulta usada pelos demais documentos. A chave FIPE+ano evita
     duplicatas sem inventar uma placa fictícia. */
  function fipeModeloHistKey(){ return 'mev_fipe_modelo_hist:'+(meuId||'local'); }
  function fipeModeloHistLer(){ try{ var l=JSON.parse(localStorage.getItem(fipeModeloHistKey())||'[]'); return Array.isArray(l)?l:[]; }catch(_){ return []; } }
  function fipeModeloNumero(v){
    var s=String(v==null?'':v).replace(/[^\d,.-]/g,'').replace(/\./g,'').replace(',','.');
    var n=Number(s); return isFinite(n)?n:0;
  }
  function fipeModeloHistChave(d,tipo,ano){ return [tipo||'',d&&d.CodigoFipe||'',ano||d&&d.AnoModelo||''].join(':'); }
  function fipeModeloHistItem(d,tipo,ano){
    var af=String((d&&d.AnoModelo)||'').replace(/\D/g,'').slice(0,4);
    return { chave:fipeModeloHistChave(d,tipo,ano), tipo_veiculo:tipo||'carros', ts:Date.now(), modelo:(d&&d.Modelo)||'Veículo', bruto:d||{}, v:{
      placa:'', marca:(d&&d.Marca)||'', modelo:(d&&d.Modelo)||'Veículo', ano:af, ano_modelo:af,
      combustivel:(d&&d.Combustivel)||'', fipe:fipeModeloNumero(d&&d.Valor), codigo_fipe:(d&&d.CodigoFipe)||'', mes_ref:(d&&d.MesReferencia)||'', tipo:tipo||'carros', tipo_veiculo:tipo||'carros'
    } };
  }
  function fipeModeloHistGrava(l){ try{ localStorage.setItem(fipeModeloHistKey(),JSON.stringify((l||[]).slice(0,40))); }catch(_){} }
  function fipeModeloHistSalvar(d,tipo,ano){
    try{
      var it=fipeModeloHistItem(d,tipo,ano), l=fipeModeloHistLer().filter(function(x){ return String(x.chave)!==String(it.chave); });
      l.unshift(it); fipeModeloHistGrava(l);
      try{ docHistCloudSave('fipe_modelo',it.chave,it.tipo_veiculo,it,it.ts); }catch(_){}
      return it;
    }catch(_){ return null; }
  }
  function fipeModeloHistSync(cb){
    try{ docHistCloudLoad('fipe_modelo',function(rows,ok){
      var l=fipeModeloHistLer(), antes=JSON.stringify(l), mapa={};
      l.forEach(function(x){ if(x&&x.chave) mapa[String(x.chave)]=x; });
      (rows||[]).forEach(function(r){ var x=r&&r.resultado; if(typeof x==='string'){ try{ x=JSON.parse(x); }catch(_){ x=null; } } if(!x||!x.chave) return; var k=String(x.chave), atual=mapa[k]; if(!atual||(Number(x.ts)||0)>(Number(atual.ts)||0)) mapa[k]=x; });
      l=Object.keys(mapa).map(function(k){return mapa[k];}).sort(function(a,b){return (b.ts||0)-(a.ts||0);}).slice(0,40);
      fipeModeloHistGrava(l);
      if(ok) try{ docHistBackfill('fipe_modelo',rows,l.map(function(x){ return {chave:x.chave,tipo_doc:x.tipo_veiculo,resultado:x,ts:x.ts}; })); }catch(_){}
      /* 🔴 v1089 — O `ok` PASSA A CHEGAR NO CHAMADOR (§8 do projeto de
         19/09: "Erro ou offline: mensagem clara; botão Tentar novamente").
         O `docHistCloudLoad` sempre soube dizer se a leitura deu certo —
         ele devolve `(rows, ok)`. Este sync ENGOLIA o `ok` e avisava só se
         a lista MUDOU. Com isso a tela do histórico não tinha como separar
         "a nuvem respondeu e não havia nada novo" de "a nuvem não
         respondeu" — e as duas viravam a mesma tela de vazio.
         ⚠️ ARGUMENTO NOVO NO FIM, de propósito: quem já chama com
         `function(mudou)` (o 05c-avaliacoes) continua idêntico; em
         JavaScript um argumento a mais é simplesmente ignorado. */
      if(cb) cb(JSON.stringify(l)!==antes, ok!==false);
    },40); }catch(_){ if(cb) cb(false, false); }
  }
  function fipeModeloHistAbrir(chave){
    var it=fipeModeloHistLer().filter(function(x){return String(x.chave)===String(chave);})[0]; if(!it) return;
    try{ fmResultadoAbrir(it,true,null); }catch(_){ return; }
  }
  /* v1014 — a busca FIPE é compartilhada por várias edições, mas a ação de
     avaliação só nasce onde a área Avaliações é permitida. No MEV Consultas
     ela ficava parecendo parte do produto e levava para outro app. */
  function fmPodeAvaliar(){
    try{ return typeof window.edPode!=='function'||window.edPode('avaliacoes'); }
    catch(_){ return true; }
  }
  function fmIniciarAvaliacao(){
    if(!fmPodeAvaliar()) return;
    if(!_fmUltimo) return;
    var it=_fmUltimoItem;
    if(!it){
      var tipo=String((($('fmTipo')||{}).value)||'carros'), ano=String((($('fmAno')||{}).value)||'');
      it=fipeModeloHistItem(_fmUltimo,tipo,ano);
    }
    try{
      if(typeof avlNovaAbrir!=='function') throw new Error('avaliacao_indisponivel');
      avlNovaAbrir(it);
    }catch(_){ toast('Não consegui abrir a avaliação agora.'); }
  }
  function fmResultadoWire(){
    var sb=$('fmShareBtn'); if(sb) sb.onclick=fmShareImg;
    var ab=$('fmAvaliarBtn'); if(ab) ab.onclick=fmIniciarAvaliacao;
  }
  /* v1037 — a busca manual deixa o formulário limpo depois do sucesso. O
     estado dos quatro seletores é apenas restaurado ao voltar; restaurar não
     chama a FIPE e não grava outro histórico. */
  function fmEstadoAtual(){
    function v(id){ return String((($(id)||{}).value)||''); }
    return { tipo:v('fmTipo'), marca:v('fmMarca'), marcaTxt:v('fmMarcaInput'), anoFiltro:v('fmAnoFiltro'), anoFiltroTxt:v('fmAnoFiltroInput'), modelo:v('fmModelo'), modeloTxt:v('fmModeloInput'), ano:v('fmAno'), anoTxt:v('fmAnoInput') };
  }
  function fmFormularioVoltar(estado,limpar){
    abrirBuscaVeiculo(); if(limpar||!estado) return;
    setTimeout(function(){
      try{
        [['fmTipo','tipo'],['fmMarca','marca'],['fmMarcaInput','marcaTxt'],['fmAnoFiltro','anoFiltro'],['fmAnoFiltroInput','anoFiltroTxt'],['fmModelo','modelo'],['fmModeloInput','modeloTxt'],['fmAno','ano'],['fmAnoInput','anoTxt']].forEach(function(x){ var e=$(x[0]); if(e) e.value=estado[x[1]]||''; });
        var cw=$('fmCombustivelWrap'); if(cw) cw.style.display=estado.ano?'':'none';
        try{ consultaUiSync(); }catch(_){}
      }catch(_){}
    },0);
  }
  function fmResultadoAbrir(it,reaberta,estado){
    it=it||{}; var d=it.bruto||{}, v=it.v||{}; _fmUltimo=d; _fmUltimoItem=it;
    var cfg={ chave:'fipe', titulo:'Buscar por veículo', identificacao:[d.Modelo,d.AnoModelo].filter(Boolean).join(' · '),
      dataHora:it.ts?histData(it.ts):histData(Date.now()), origem:reaberta?'Resultado salvo':'',
      resumoHtml:consultaResultadoResumo({ tom:'ok', titulo:'Valor FIPE '+(d.Valor||'localizado'), texto:[d.Marca,fipeAnoRotulo(d.AnoModelo),d.Combustivel].filter(Boolean).join(' · ') }),
      secoesHtml:consultaResultadoSecao({ titulo:'Dados do veículo', html:fmCard(d,it) }),
      aoVoltar:function(){ fmFormularioVoltar(estado,false); }, aoNovaConsulta:function(){ fmFormularioVoltar(null,true); }, acoes:[] };
    if(reaberta) consultaResultadoDoHistorico(cfg); else consultaResultadoAbrir(cfg);
    fmResultadoWire();
  }
  function fmCard(d,it){ if(!d) return ''; _fmUltimo=d; _fmUltimoItem=it||null; function kv(k,v){ return (v||v===0)?('<div class="fm-kv"><span>'+esc(k)+'</span><b>'+esc(v)+'</b></div>'):''; }
    var avaliar=fmPodeAvaliar()?('<button type="button" class="fm-share fm-avaliar" id="fmAvaliarBtn"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M12 11v6M9 14h6"/></svg> Iniciar avaliação</button>'):'';
    return '<div class="fm-card" id="fmCardBox"><div class="fm-vlabel">Valor FIPE</div><div class="fm-val">'+esc(d.Valor||'-')+'</div>'+
      kv('Modelo',d.Modelo)+kv('Marca',d.Marca)+kv('Ano do modelo',fipeAnoRotulo(d.AnoModelo))+kv('Combustível',d.Combustivel)+kv('Código FIPE',d.CodigoFipe)+kv('Referência',d.MesReferencia)+'<div class="fm-fonte" style="margin-top:8px">Fonte: Tabela FIPE &middot; <a href="https://veiculos.fipe.org.br" target="_blank" rel="noopener">fipe.org.br</a></div>'+'</div>'+
      avaliar+
      '<button type="button" class="fm-share" id="fmShareBtn"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Compartilhar imagem</button>'; }
  /* desenha o resultado da FIPE numa imagem (canvas) pra baixar/compartilhar */
  function fmShareCanvas(d){
    d=d||{};
    var W=1000, pad=54, iw=W-2*pad;
    var cv=document.createElement('canvas'); cv.width=W; cv.height=1400; var g=cv.getContext('2d');
    g.fillStyle='#f4f7fb'; g.fillRect(0,0,W,1400);
    /* cabeçalho */
    var HH=150; g.fillStyle='#001e50'; g.fillRect(0,0,W,HH); g.fillStyle='#0a4da6'; g.fillRect(0,HH-6,W,6);
    g.fillStyle='#9fc3ff'; g.font='700 24px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText('CONSULTA FIPE', pad, 56);
    g.fillStyle='#fff'; g.font='800 40px system-ui,-apple-system,Arial'; g.fillText(String(d.Marca||'Veículo'), pad, 104);
    g.fillStyle='#cfe0ff'; g.font='500 22px system-ui,-apple-system,Arial'; g.textAlign='right'; g.fillText('MEV Veículos', W-pad, 56); g.textAlign='left';
    /* card do valor */
    var y=HH+40, ch=180;
    function rr(x,yy,w,h,r){ g.beginPath(); g.moveTo(x+r,yy); g.arcTo(x+w,yy,x+w,yy+h,r); g.arcTo(x+w,yy+h,x,yy+h,r); g.arcTo(x,yy+h,x,yy,r); g.arcTo(x,yy,x+w,yy,r); g.closePath(); }
    g.fillStyle='#eef4ff'; rr(pad,y,iw,ch,20); g.fill(); g.strokeStyle='#d6e3fb'; g.lineWidth=2; rr(pad,y,iw,ch,20); g.stroke();
    g.fillStyle='#64748b'; g.font='600 24px system-ui,-apple-system,Arial'; g.fillText('Valor FIPE', pad+30, y+52);
    g.fillStyle='#0a4da6'; g.font='900 74px system-ui,-apple-system,Arial'; g.fillText(String(d.Valor||'-'), pad+28, y+130);
    y+=ch+30;
    /* linhas de dados */
    var rows=[['Modelo',d.Modelo],['Marca',d.Marca],['Ano',fipeAnoRotulo(d.AnoModelo)],['Combustível',d.Combustivel],['Código FIPE',d.CodigoFipe],['Referência',d.MesReferencia]].filter(function(r){ return r[1]!=null && String(r[1]).trim(); });
    g.fillStyle='#fff'; var bh=rows.length*74+16; rr(pad,y,iw,bh,18); g.fill(); g.strokeStyle='#e8eef7'; g.lineWidth=2; rr(pad,y,iw,bh,18); g.stroke();
    var ry=y+8;
    rows.forEach(function(r,i){ var mid=ry+37;
      g.fillStyle='#64748b'; g.font='600 25px system-ui,-apple-system,Arial'; g.textAlign='left'; g.fillText(String(r[0]), pad+30, mid+9);
      g.fillStyle='#0f172a'; g.font='800 26px system-ui,-apple-system,Arial'; g.textAlign='right';
      var val=String(r[1]); var maxw=iw-260; while(g.measureText(val).width>maxw && val.length>4){ val=val.slice(0,-2); } if(val!==String(r[1])) val=val+'…';
      g.fillText(val, W-pad-30, mid+9); g.textAlign='left';
      if(i<rows.length-1){ g.strokeStyle='#f1f5f9'; g.lineWidth=1.5; g.beginPath(); g.moveTo(pad+22,ry+74); g.lineTo(W-pad-22,ry+74); g.stroke(); }
      ry+=74;
    });
    y+=bh+28;
    g.fillStyle='#94a3b8'; g.font='500 21px system-ui,-apple-system,Arial'; g.textAlign='center'; g.fillText('Fonte: Tabela FIPE · fipe.org.br', W/2, y+10); g.textAlign='left';
    y+=44;
    var out=document.createElement('canvas'); out.width=W; out.height=Math.min(1400,Math.max(500,y)); out.getContext('2d').drawImage(cv,0,0); return out;
  }
  function fmShareTexto(d,semAssinatura){
    d=d||{};
    var linhas=['Consulta FIPE do veículo',''];
    var veiculo=[d.Marca,d.Modelo].filter(Boolean).join(' · ');
    if(veiculo) linhas.push(veiculo);
    if(d.AnoModelo) linhas.push('Ano/modelo: '+fipeAnoRotulo(d.AnoModelo));
    if(d.Combustivel) linhas.push('Combustível: '+String(d.Combustivel));
    if(d.Valor) linhas.push('Valor FIPE: '+String(d.Valor));
    if(d.MesReferencia) linhas.push('Referência: '+String(d.MesReferencia));
    if(d.CodigoFipe) linhas.push('Código FIPE: '+String(d.CodigoFipe));
    if(!semAssinatura) linhas.push('',mevConsultasAssinatura());
    return linhas.join('\n');
  }
  function fmShareDetalhesLer(){
    var v=(_fmUltimoItem&&_fmUltimoItem.v)||{};
    return {km:Number(v.quilometragem_compartilhamento)||0,obs:String(v.observacoes_compartilhamento||'').slice(0,4000),
      gastosTotal:Math.max(0,Number(v.gastos_previstos_compartilhamento)||0),
      gastosDescricao:String(v.descricao_gastos_compartilhamento||'').slice(0,1000)};
  }
  function fmShareDetalhesSalvar(bruto){
    if(!_fmUltimoItem||!_fmUltimoItem.chave) return;
    bruto=bruto||{};
    function aplicar(v){
      v=v||{};
      if(bruto.km) v.quilometragem_compartilhamento=Number(bruto.km); else delete v.quilometragem_compartilhamento;
      if(bruto.obs) v.observacoes_compartilhamento=String(bruto.obs); else delete v.observacoes_compartilhamento;
      if(bruto.gastosTotal) v.gastos_previstos_compartilhamento=Number(bruto.gastosTotal); else delete v.gastos_previstos_compartilhamento;
      if(bruto.gastosDescricao) v.descricao_gastos_compartilhamento=String(bruto.gastosDescricao); else delete v.descricao_gastos_compartilhamento;
      return v;
    }
    _fmUltimoItem.v=aplicar(_fmUltimoItem.v||{}); _fmUltimoItem.ts=Date.now();
    var chave=String(_fmUltimoItem.chave), lista=fipeModeloHistLer(), salvo=null;
    lista.forEach(function(x){ if(String(x&&x.chave)!==chave) return; x.v=aplicar(x.v||{}); x.ts=_fmUltimoItem.ts; salvo=x; });
    if(!salvo){ salvo=_fmUltimoItem; lista.unshift(salvo); }
    fipeModeloHistGrava(lista);
    try{ docHistCloudSave('fipe_modelo',salvo.chave,salvo.tipo_veiculo,salvo,salvo.ts); }catch(_){}
  }
  function fmShareImg(){
    var d=_fmUltimo; if(!d){ toast('Escolha o veículo primeiro.'); return; }
    if(typeof histShareDetalhesPedir!=='function'){ fmShareImgExecutar(d,{}); return; }
    var identificacao=[d.Marca,d.Modelo,fipeAnoRotulo(d.AnoModelo)].filter(Boolean).join(' · ');
    histShareDetalhesPedir('',function(detalhes){ fmShareImgExecutar(d,detalhes||{}); },d,{
      identificacao:identificacao||'este veículo',dadosIniciais:fmShareDetalhesLer(),salvar:fmShareDetalhesSalvar
    });
  }
  async function fmShareImgExecutar(d,detalhes){
    var cv; try{ cv=fmShareCanvas(d); }catch(e){ toast('Não consegui gerar a imagem.'); return; }
    var nome='FIPE-'+String((d.Marca||'veiculo')).replace(/[^A-Za-z0-9]+/g,'-').slice(0,20)+'.png';
    var texto=fmShareTexto(d);
    try{ if(typeof histShareMensagemCompleta==='function') texto=histShareMensagemCompleta(fmShareTexto(d,true),detalhes||{}); }catch(_){}
    var blob=await new Promise(function(res){ try{ cv.toBlob(function(b){ res(b); },'image/png',0.95); }catch(_){ res(null); } });
    if(!blob){ try{ var a0=document.createElement('a'); a0.href=cv.toDataURL('image/png'); a0.download=nome; a0.click(); }catch(_){} return; }
    try{
      if(navigator.canShare){ var file=new File([blob],nome,{type:'image/png'}); if(navigator.canShare({files:[file]})){ await navigator.share({files:[file], title:'Consulta FIPE do veículo', text:texto}); return; } }
    }catch(err){ if(err&&err.name==='AbortError') return; }
    var u=URL.createObjectURL(blob), a=document.createElement('a'); a.href=u; a.download=nome; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },800); toast('Imagem baixada.');
  }
  /* Combobox com BUSCA (digita e filtra). A ordem desta jornada é sempre
     Marca → Ano do modelo → Modelo / versão. A FIPE pública só revela os
     anos depois do modelo; por isso, ao digitar o modelo, verificamos apenas
     as versões daquela marca que realmente existem no ano escolhido. */
  var _fmCombo={}, _fmModeloAnoCache={}, _fmModeloAnoReq=0, _fmMarcasReq=0;
  /* v243: memoria dos ANOS de cada modelo — cada modelo so e consultado
     uma vez na FIPE, mesmo trocando o texto da busca. */
  var _fmAnosCache={};
  async function _fmAnosDoModelo(tipo,marca,cod){
    var k=[tipo,marca,cod].join('|');
    if(_fmAnosCache[k]) return _fmAnosCache[k];
    try{ var anos=await fipeGet('/'+tipo+'/marcas/'+encodeURIComponent(marca)+'/modelos/'+encodeURIComponent(cod)+'/anos'); _fmAnosCache[k]=anos||[]; return _fmAnosCache[k]; }
    catch(_){ return null; }
  }
  function fmComboHtml(id,label,ph){
    return '<div class="fm-field"><label class="fm-lbl" for="'+id+'Input">'+esc(label)+'</label>'+
      '<div class="fm-combo"><input id="'+id+'Input" class="fm-sel" placeholder="'+esc(ph||'-')+'" autocomplete="off" autocapitalize="off" disabled>'+
      '<input type="hidden" id="'+id+'"><div class="fm-drop" id="'+id+'Drop" style="display:none"></div></div></div>';
  }
  /* v390 escondia ANO e MODELO até fazerem sentido (plano item 5).
     v391 (pedido): DESFEITO — os campos de busca sumiam da tela e confundia.
     Os três campos ficam sempre visíveis, como sempre foram. */
  function fmComboSet(id,items,ph){ _fmCombo[id]=items||[]; var inp=$(id+'Input'),hid=$(id),box=$(id+'Drop');
    if(hid) hid.value=''; if(inp){ inp.value=''; inp.placeholder=ph||'Digite pra buscar'; inp.disabled=!(items&&items.length); } if(box){ box.style.display='none'; box.innerHTML=''; } }
  function fmComboReset(id,ph){ _fmCombo[id]=[]; var inp=$(id+'Input'),hid=$(id),box=$(id+'Drop');
    if(hid) hid.value=''; if(inp){ inp.value=''; inp.placeholder=ph||'-'; inp.disabled=true; } if(box){ box.style.display='none'; box.innerHTML=''; } }
  function fmComboBusy(id,txt){ var inp=$(id+'Input'),hid=$(id),box=$(id+'Drop');
    if(hid) hid.value=''; if(inp){ inp.value=''; inp.placeholder=txt||'Carregando...'; inp.disabled=true; } if(box){ box.style.display='none'; box.innerHTML=''; } }
  /* ===== v302 (pedido) — A FIPE DO ZERO KM ================================
     A tabela FIPE trata carro 0 km como um "ano" próprio, de código 32000.
     Ele vem sempre em PRIMEIRO na lista de anos de um modelo:
        [{"codigo":"32000-5","nome":"32000 Flex"}, {"codigo":"2027-5", ...
     Só que a nossa lista de anos era montada aqui na mão, de 2027 até 1985,
     e o 32000 não estava nela: não tinha como escolher o preço de 0 km.

     E TINHA UM SEGUNDO PROBLEMA, PIOR, QUE SÓ APARECEU QUANDO FUI OLHAR.
     A função que descobre o ano de um item procurava "19xx ou 20xx" DENTRO
     do texto. Em "32000" ela achava "2000" — o 3 da frente ela ignorava.
     Resultado: o preço de ZERO KM era classificado como ano 2000. Um carro
     0 km entrava na lista do ano 2000 com o preço de novo, e nada na tela
     dizia que estava errado. Rodei com os dados de verdade da FIPE pra
     confirmar antes de mexer numa linha.

     Por isso o teste do 32000 vem ANTES da conta do ano, aqui embaixo. */
  var FIPE_ZERO_KM='32000';
  function fipeEhZeroKm(x){
    var s=String((x&&x.codigo)||(x&&x.nome)||(x==null?'':x));
    return /(^|\D)32000(\D|$)/.test(s);
  }
  /* Troca o 32000 por "Zero km" em qualquer texto que vá pra tela.
     "32000 Flex" vira "Zero km Flex"; o número 32000 vira "Zero km". */
  function fipeAnoRotulo(x){
    var s=String(x==null?'':x).trim();
    if(!s) return s;
    return fipeEhZeroKm(s) ? s.replace(/(^|\D)32000(\D|$)/,'$1Zero km$2').trim() : s;
  }
  function _fipeAnosParaEscolha(){
    var atual=(new Date()).getFullYear()+1;
    var out=[{codigo:FIPE_ZERO_KM,nome:'Zero km'}];   /* primeiro, como na própria FIPE */
    for(var ano=atual;ano>=1985;ano--) out.push({codigo:String(ano),nome:String(ano)});
    return out;
  }
  function _fipeAnoDoItem(item){
    if(fipeEhZeroKm(item)) return FIPE_ZERO_KM;   /* ANTES do regex — veja o texto acima */
    var m=String((item&&item.codigo)||((item&&item.nome)||'')).match(/(?:19|20)\d{2}/); return m?m[0]:'';
  }
  function _fipeItemNoAno(item,ano){ return !!ano && _fipeAnoDoItem(item)===String(ano); }
  function _fipeUltimoAnoReal(anos){
    return (anos||[]).reduce(function(maior,item){
      var ano=_fipeAnoDoItem(item), n=(ano&&ano!==FIPE_ZERO_KM)?parseInt(ano,10):0;
      return n>maior?n:maior;
    },0);
  }
  /* ===== v405 (bug do celular: "não consigo ler a lista de veículos") =====
     Com o teclado aberto, a lista abria pra baixo e ficava ATRÁS do teclado.
     Agora, ao abrir a lista: (1) a tela rola pra deixar o campo no alto;
     (2) a altura da lista é recalculada pro espaço realmente VISÍVEL
     (visualViewport desconta o teclado do iPhone). */
  function fmDropEncaixa(box){
    if(!box) return;
    try{
      var campo=box.parentNode;                       /* .fm-combo */
      var vv=window.visualViewport;
      if(window.innerWidth<900 && campo && campo.scrollIntoView){
        campo.scrollIntoView({block:'start', behavior:'smooth'});
      }
      setTimeout(function(){
        try{
          var r=box.getBoundingClientRect();
          var alturaVisivel=(vv? (vv.height+vv.offsetTop) : window.innerHeight) - r.top - 10;
          if(alturaVisivel>120) box.style.maxHeight=Math.floor(alturaVisivel)+'px';
        }catch(_){}
      },220);
    }catch(_){}
  }
  function fmComboPintaDrop(id,lista,vazio){
    var box=$(id+'Drop'); if(!box) return;
    fmDropEncaixa(box);
    if(!lista||!lista.length){ box.innerHTML='<div class="fm-drop-empty">'+esc(vazio||'Nada encontrado')+'</div>'; box.style.display='block'; return; }
    box.innerHTML=lista.slice(0,80).map(function(m){ return '<button type="button" class="fm-drop-it" data-cod="'+esc(m.codigo)+'" data-nome="'+esc(m.nome)+'">'+esc(m.nome)+'</button>'; }).join('');
    box.style.display='block';
    Array.prototype.forEach.call(box.querySelectorAll('.fm-drop-it'),function(b){ b.onmousedown=function(e){ e.preventDefault(); }; b.onclick=function(){ fmComboPick(id,b.getAttribute('data-cod'),b.getAttribute('data-nome')); }; });
  }
  async function fmModeloPorAnoDrop(termo){
    var box=$('fmModeloDrop'), ano=String((($('fmAnoFiltro')||{}).value)||''), marca=String((($('fmMarca')||{}).value)||''), tipo=String((($('fmTipo')||{}).value)||'carros');
    termo=String(termo||'').toLowerCase().trim();
    if(!box||!ano||!marca) return;
    if(termo.length<2){ fmComboPintaDrop('fmModelo',[],'Digite pelo menos 2 letras do modelo para filtrar as versões de '+fipeAnoRotulo(ano)+'.'); return; }
    /* v243: era .slice(0,18) e cortava versoes (o Polo Highline ficava de
       fora). Agora confere ate 60 candidatos, em lotes de 8. */
    var candidatos=(_fmCombo.fmModelo||[]).filter(function(m){ return String(m.nome||'').toLowerCase().indexOf(termo)>=0; }).slice(0,60);
    if(!candidatos.length){ fmComboPintaDrop('fmModelo',[],'Nenhum modelo dessa marca contém esse texto.'); return; }
    var chave=[tipo,marca,ano,termo].join('|'), memoria=_fmModeloAnoCache[chave];
    if(memoria){ fmComboPintaDrop('fmModelo',memoria,'Nenhuma versão disponível para '+fipeAnoRotulo(ano)+'.'); return; }
    var pedido=++_fmModeloAnoReq;
    box.innerHTML='<div class="fm-drop-empty"><span class="spin"></span> Conferindo versões de '+esc(fipeAnoRotulo(ano))+'…</div>'; box.style.display='block'; fmDropEncaixa(box);
    var avaliados=[];
    for(var _i=0;_i<candidatos.length;_i+=8){
      var _lote=await Promise.all(candidatos.slice(_i,_i+8).map(async function(m){
        var anos=await _fmAnosDoModelo(tipo,marca,m.codigo);
        return anos?{ modelo:m, anos:anos }:null;
      }));
      avaliados=avaliados.concat(_lote);
      if(pedido!==_fmModeloAnoReq) return;   /* usuario mudou a busca: para */
    }
    if(pedido!==_fmModeloAnoReq || !$('fmModeloDrop') || String((($('fmModeloInput')||{}).value)||'').toLowerCase().trim()!==termo) return;
    /* A FIPE mantém o item "32000 / Zero km" em algumas versões que já
       deixaram a linha atual. Para Zero km, além do código 32000, a versão
       precisa alcançar o ano-modelo corrente da própria lista consultada.
       Se a tabela ainda não virou o ano civil, usamos o maior ano publicado
       como referência; assim a busca não fica vazia na virada do calendário. */
    var validos=avaliados.filter(Boolean), referenciaZero=0;
    if(fipeEhZeroKm(ano)){
      var maiorPublicado=validos.reduce(function(maior,x){ return Math.max(maior,_fipeUltimoAnoReal(x.anos)); },0);
      referenciaZero=Math.min((new Date()).getFullYear(),maiorPublicado||((new Date()).getFullYear()));
    }
    memoria=validos.filter(function(x){
      if(!fipeEhZeroKm(ano)) return x.anos.some(function(a){ return _fipeItemNoAno(a,ano); });
      return x.anos.some(fipeEhZeroKm) && _fipeUltimoAnoReal(x.anos)>=referenciaZero;
    }).map(function(x){ return x.modelo; });
    _fmModeloAnoCache[chave]=memoria;
    fmComboPintaDrop('fmModelo',memoria,'Nenhuma versão encontrada para '+fipeAnoRotulo(ano)+'. Tente outro nome ou ano.');
  }
  function fmComboDrop(id,termo){ var box=$(id+'Drop'); if(!box) return;
    if(id==='fmModelo' && (($('fmAnoFiltro')||{}).value)){ fmModeloPorAnoDrop(termo); return; }
    termo=String(termo||'').toLowerCase().trim();
    var lista=(_fmCombo[id]||[]).filter(function(m){ return !termo || String(m.nome||'').toLowerCase().indexOf(termo)>=0; });
    fmComboPintaDrop(id,lista,'Nada encontrado');
  }
  function fmComboPick(id,cod,nome,opcoes){ var inp=$(id+'Input'),hid=$(id),box=$(id+'Drop');
    if(inp) inp.value=nome||''; if(hid) hid.value=cod||''; if(box){ box.style.display='none'; box.innerHTML=''; }
    var tp=($('fmTipo')||{}).value;
    if(id==='fmMarca'){ fmResult(''); fmComboReset('fmAnoFiltro','Escolha o ano do modelo'); fmComboReset('fmModelo','Escolha marca e ano primeiro'); fmComboReset('fmAno','-'); var cw=$('fmCombustivelWrap'); if(cw) cw.style.display='none'; if(cod) fmComboSet('fmAnoFiltro',_fipeAnosParaEscolha(),'Escolha o ano do modelo'); }
    else if(id==='fmAnoFiltro'){ fmResult(''); fmComboReset('fmModelo','Carregando modelos…'); fmComboReset('fmAno','-'); var cw2=$('fmCombustivelWrap'); if(cw2) cw2.style.display='none'; if(cod) carregarModelos(tp,($('fmMarca')||{}).value,cod); }
    else if(id==='fmModelo'){ fmResult(''); fmComboReset('fmAno','Carregando opções…'); var cw3=$('fmCombustivelWrap'); if(cw3) cw3.style.display='none'; if(cod) carregarAnos(tp,($('fmMarca')||{}).value,cod,($('fmAnoFiltro')||{}).value); }
    else if(id==='fmAno'){ if(cod && !$('fmGuideBg')) carregarValor(tp,($('fmMarca')||{}).value,($('fmModelo')||{}).value,cod); else if(!cod) fmResult(''); }
    try{ if($('fmGuideBg') && id==='fmMarca' && typeof fmGuiaMarcaPadraoSelecionada==='function') fmGuiaMarcaPadraoSelecionada(); }catch(_){}
    try{ if(!(opcoes&&opcoes.manterEtapa) && $('fmGuideBg') && typeof fmGuiaDepoisEscolha==='function') fmGuiaDepoisEscolha(id); }catch(_){}
    try{ consultaUiSync(); }catch(_){}   /* v747: o botão "Buscar veículo" acompanha a seleção */
  }
  function fmComboWire(id){ var inp=$(id+'Input'); if(!inp) return;
    inp.oninput=function(){ var h=$(id); if(h) h.value='';
      if(id==='fmMarca'){ fmResult(''); fmComboReset('fmAnoFiltro','Escolha o ano do modelo'); fmComboReset('fmModelo','Escolha marca e ano primeiro'); fmComboReset('fmAno','-'); }
      else if(id==='fmAnoFiltro'){ fmResult(''); fmComboReset('fmModelo','Escolha marca e ano primeiro'); fmComboReset('fmAno','-'); }
      else if(id==='fmModelo'){ fmResult(''); fmComboReset('fmAno','-'); var cw=$('fmCombustivelWrap'); if(cw) cw.style.display='none'; }
      fmComboDrop(id,this.value);
      try{ if(id==='fmMarca'&&typeof fmGuiaMarcaPadraoSelecionada==='function') fmGuiaMarcaPadraoSelecionada(); }catch(_){}
    };
    inp.onfocus=function(){ fmComboDrop(id,this.value); };
    inp.addEventListener('blur',function(){ setTimeout(function(){ var box=$(id+'Drop'); if(box) box.style.display='none'; },180); });
  }
  /* v1480 — o ponto de partida acompanha o tipo mais usado sem fabricar
     código FIPE: encontramos a marca pelo nome devolvido pela própria lista.
     Carros começam em Volkswagen; motos, em Honda; caminhões seguem livres. */
  function fmMarcaPadrao(tipo,marcas){
    var alvo=tipo==='carros'?'volkswagen':(tipo==='motos'?'honda':'');
    if(!alvo) return null;
    return (marcas||[]).find(function(m){
      var nome=String((m&&m.nome)||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');
      return alvo==='volkswagen'?nome.indexOf('volkswagen')>=0:nome==='honda';
    })||null;
  }
  async function carregarMarcas(tipo){ var pedido=++_fmMarcasReq; fmMsg(''); fmComboBusy('fmMarca','Carregando marcas...'); fmComboReset('fmAnoFiltro','Escolha a marca primeiro'); fmComboReset('fmModelo','Escolha marca e ano primeiro'); fmComboReset('fmAno','-'); var cw=$('fmCombustivelWrap'); if(cw) cw.style.display='none';
    try{ var d=await fipeGet('/'+tipo+'/marcas');
      if(pedido!==_fmMarcasReq || String((($('fmTipo')||{}).value)||'')!==String(tipo)) return;
      fmComboSet('fmMarca',d||[],'Digite ou toque pra escolher a marca');
      var padrao=fmMarcaPadrao(tipo,d||[]), atual=String((($('fmMarca')||{}).value)||'');
      if(padrao&&!atual) fmComboPick('fmMarca',padrao.codigo,padrao.nome,{manterEtapa:true});
    }
    catch(e){ fmComboReset('fmMarca','Erro ao carregar'); fmMsg('Nao consegui carregar as marcas. Verifique a internet e tente de novo.','err'); } }
  async function carregarModelos(tipo,marca,ano){ fmMsg(''); fmComboBusy('fmModelo','Carregando modelos...'); fmComboReset('fmAno','-');
    try{ var d=await fipeGet('/'+tipo+'/marcas/'+encodeURIComponent(marca)+'/modelos'); fmComboSet('fmModelo',(d&&d.modelos)||[],'Digite ao menos 2 letras para filtrar versões de '+fipeAnoRotulo(ano)); }catch(e){ fmComboReset('fmModelo','-'); fmMsg('Nao consegui carregar os modelos. Verifique a internet e tente de novo.','err'); } }
  async function carregarAnos(tipo,marca,modelo,anoFiltro){ fmMsg(''); fmComboBusy('fmAno','Carregando opções...');
    try{
      var d=await fipeGet('/'+tipo+'/marcas/'+encodeURIComponent(marca)+'/modelos/'+encodeURIComponent(modelo)+'/anos');
      /* v302: o nome que a FIPE manda pro 0 km é "32000 Flex". O código
         ("32000-5") continua igual, porque é ele que volta pra API — só o
         texto que o Angelo lê é que muda. */
      var opcoes=(d||[]).filter(function(a){ return !anoFiltro||_fipeItemNoAno(a,anoFiltro); })
                        .map(function(a){ return { codigo:a.codigo, nome:fipeAnoRotulo(a.nome) }; });
      var cw=$('fmCombustivelWrap'); if(cw) cw.style.display=opcoes.length>1?'':'none';
      if(!opcoes.length){ fmComboReset('fmAno','Sem opção para '+fipeAnoRotulo(anoFiltro)); fmMsg('Essa versão não existe para o ano escolhido. Selecione outra versão ou outro ano.','err'); return; }
      fmComboSet('fmAno',opcoes,opcoes.length===1?'Combustível identificado':'Escolha o combustível');
      if(opcoes.length===1){
        /* Na página padronizada existe um botão explícito. Selecionamos o
           combustível único sem disparar a consulta; no formulário antigo,
           sem CTA, preservamos a busca automática que já existia. */
        if($('fmBuscarBt')){
          var inp=$('fmAnoInput'), hid=$('fmAno'), box=$('fmAnoDrop');
          if(inp) inp.value=opcoes[0].nome; if(hid) hid.value=opcoes[0].codigo;
          if(box){ box.style.display='none'; box.innerHTML=''; }
          try{ consultaUiSync(); }catch(_){}
        }else fmComboPick('fmAno',opcoes[0].codigo,opcoes[0].nome);
      }
      try{ if($('fmGuideBg') && typeof fmGuiaCombustiveis==='function') fmGuiaCombustiveis(opcoes); }catch(_){}
    }catch(e){ fmComboReset('fmAno','-'); fmMsg('Nao consegui carregar as opções desse veículo.','err'); } }
  async function carregarValor(tipo,marca,modelo,ano){ fmMsg('Consultando a Tabela FIPE…','loading'); fmResult(''); var estado=fmEstadoAtual();
    try{ var d=await fipeGet('/'+tipo+'/marcas/'+encodeURIComponent(marca)+'/modelos/'+encodeURIComponent(modelo)+'/anos/'+encodeURIComponent(ano)); var it=fipeModeloHistSalvar(d,tipo,ano); fmMsg(''); fmResultadoAbrir(it,false,estado); return true; }catch(e){ fmMsg('Nao consegui buscar o valor. Tente de novo.','err'); return false; } }
  function fmFormHtml(comHead){
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="20" x2="4" y2="13"/><line x1="10" y1="20" x2="10" y2="8"/><line x1="16" y1="20" x2="16" y2="11"/><line x1="20" y1="20" x2="20" y2="5"/></svg>';
    var _svgCar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17h2l1.5-5h11L19 17h2v-2h-1l-1.5-6.5A2 2 0 0 0 16.5 7h-9A2 2 0 0 0 5.5 8.5L4 15H3v2z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';
    var _svgMoto='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17" r="3"/><circle cx="18.5" cy="17" r="3"/><path d="M5.5 17l3-6h5l2 3h3M13 8h3"/></svg>';
    var _svgTruck='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="10" rx="1"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>';
    var tiles='<div class="fm-tiles">'+[['carros','Carros',_svgCar],['motos','Motos',_svgMoto],['caminhoes','Caminhões',_svgTruck]].map(function(t){ return '<button type="button" class="fm-tile'+(t[0]==='carros'?' on':'')+'" data-tipo="'+t[0]+'">'+t[2]+'<span>'+t[1]+'</span></button>'; }).join('')+'</div>';
    var head=comHead?('<div class="fm-head">'+ico+'<div><h2>Buscar por veículo</h2><p>Escolha tipo, marca, ano e modelo para reduzir as versões disponíveis</p></div></div>'):'';
    return head+tiles+fmComboHtml('fmMarca','Marca','Carregando marcas...')+fmComboHtml('fmAnoFiltro','Ano do modelo','Escolha a marca primeiro')+fmComboHtml('fmModelo','Modelo / versão','Escolha marca e ano primeiro')+'<div id="fmCombustivelWrap" style="display:none">'+fmComboHtml('fmAno','Combustível','-')+'</div>'+
      '<input type="hidden" id="fmTipo" value="carros">'+
      '<div id="fmMsg" class="cad-msg"></div><div id="fmResult"></div>';
  }
  function fmFormWire(root){
    root=root||document; var guiada=!!root.querySelector('#fmGuideBg');
    Array.prototype.forEach.call(root.querySelectorAll('.fm-tile'),function(b){ b.onclick=function(){ var tp=b.getAttribute('data-tipo'); var h=$('fmTipo'); if(h) h.value=tp; Array.prototype.forEach.call(root.querySelectorAll('.fm-tile'),function(x){ x.classList.toggle('on',x===b); x.setAttribute('aria-pressed',x===b?'true':'false'); }); fmResult(''); fmComboReset('fmAnoFiltro','Escolha a marca primeiro'); fmComboReset('fmModelo','Escolha marca e ano primeiro'); fmComboReset('fmAno','-'); carregarMarcas(tp); try{ if(guiada&&typeof fmGuiaDepoisTipo==='function') fmGuiaDepoisTipo(tp); }catch(_){} try{ consultaUiSync(); }catch(_){} }; });
    fmComboWire('fmMarca'); fmComboWire('fmAnoFiltro'); fmComboWire('fmModelo'); fmComboWire('fmAno');
    if(!guiada) carregarMarcas('carros');
  }
  function telaFipeModelo(){
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg">'+fmFormHtml(true)+'</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    fmFormWire(document);
  }
  /* Busca por veículo (FIPE) EMBUTIDA na home — começa MINIMIZADA (só o
     cabeçalho); toca pra abrir. As marcas só carregam quando abre a 1ª vez
     (economiza chamada). */
  var _fmInlineFeito=false, _fmInlineAberto=false, _fmInlineWired=false;
  function fmInlineMontar(){
    var box=$('fipeInlineCard'); if(!box) return;
    if(_fmInlineFeito && box.querySelector('#fmInlineBody')){ box.style.display='block'; return; }
    var ico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="20" x2="4" y2="13"/><line x1="10" y1="20" x2="10" y2="8"/><line x1="16" y1="20" x2="16" y2="11"/><line x1="20" y1="20" x2="20" y2="5"/></svg>';
    box.innerHTML='<button type="button" class="fm-inline-tg" id="fmInlineTg">'+
        '<span class="fm-it-ic">'+ico+'</span>'+
        '<span class="fm-it-tx"><b>Buscar por veículo</b><small>Tipo, marca, ano e modelo · valor da FIPE</small></span>'+
        '<span class="fm-it-chev">'+CHEV+'</span>'+
      '</button>'+
      '<div id="fmInlineBody" style="display:none"></div>';
    box.style.display='block';
    /* v179 — enquanto estiver fechado, a borda do card "respira" (pulsa) pra
       o lojista perceber que da' pra tocar ali. Ao abrir, para na hora. */
    box.classList.add('fipe-pisca');
    var tg=$('fmInlineTg');
    function _fmAbreCorpo(){ var b=$('fmInlineBody'); if(!b) return; _fmInlineAberto=true; b.style.display='block'; box.classList.remove('fipe-pisca'); if(tg) tg.classList.add('on'); if(!_fmInlineWired){ _fmInlineWired=true; b.innerHTML=fmFormHtml(false); fmFormWire(b); } }
    if(tg) tg.onclick=function(){
      var b=$('fmInlineBody'); if(!b) return;
      if(_fmInlineAberto){ _fmInlineAberto=false; b.style.display='none'; tg.classList.remove('on'); box.classList.add('fipe-pisca'); }
      else { _fmAbreCorpo(); }
    };
    /* v387 (pedido): abre EXPANDIDA em todo lugar — celular e computador.
       (a v390 tinha deixado recolhida no desktop; v391 desfez: os campos de
       busca não podem ficar escondidos). O toque no cabeçalho segue
       fechando/abrindo pra quem quiser. */
    try{ _fmAbreCorpo(); }catch(_){}
    _fmInlineFeito=true;
  }

/* ╔═══ src/app/11b-pagamento-asaas.js ════════════════════════════════════ */
/* ============================================================================
   11b — PAGAMENTO PELO ASAAS (peça independente, v257)

   POR QUE ESTE ARQUIVO EXISTE SEPARADO:
   ele NÃO altera nada do 11-uso-pagamentos.js. Ele só "escuta" as respostas
   do servidor e completa o que falta. Se um dia der problema, é só apagar
   este arquivo e rodar o montar.js — tudo volta ao que era.

   O QUE ELE FAZ:
   1) CPF/CNPJ — o Asaas exige o documento de quem paga. Quando o servidor
      responde "precisa_cpf", abre uma janelinha, guarda o documento e REFAZ
      o pedido sozinho. Pra quem está usando, parece que nada aconteceu.
   2) CARTÃO — quando a resposta traz "link_pagamento", coloca o botão
      "Pagar com cartão" logo abaixo do QR Code do PIX.

   Enquanto o Asaas estiver desligado no servidor, nada aqui aparece.
   ========================================================================= */
(function(){
  var ROTAS = /\/api\/(creditos|cobranca)\b/;
  var GUARDA = 'mev_doc_pagador';
  var ultimoLink = '';

  function docSalvo(){
    try{ return String(localStorage.getItem(GUARDA)||''); }catch(_){ return ''; }
  }
  function guardarDoc(d){
    try{ localStorage.setItem(GUARDA, d); }catch(_){}
  }
  function soDigitos(v){ return String(v||'').replace(/\D+/g,''); }
  function docValido(v){ var d=soDigitos(v); return d.length===11 || d.length===14; }
  function formatarDoc(v){
    var d = soDigitos(v).slice(0,14);
    if(d.length<=11) return d.replace(/^(\d{3})(\d)/,'$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/,'$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/,'.$1-$2');
    return d.replace(/^(\d{2})(\d)/,'$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/,'$1.$2.$3').replace(/\.(\d{3})(\d)/,'.$1/$2').replace(/(\d{4})(\d{1,2})$/,'$1-$2');
  }

  /* ---------- janelinha que pede o CPF/CNPJ ---------- */
  function pedirDocumento(){
    return new Promise(function(resolve){
      var antigo = document.getElementById('asaasDocMask'); if(antigo) antigo.remove();
      var bg = document.createElement('div');
      bg.id = 'asaasDocMask';
      bg.style.cssText = 'position:fixed;inset:0;background:rgba(15,23,42,.55);backdrop-filter:blur(2px);z-index:99999;display:flex;align-items:center;justify-content:center;padding:18px';
      bg.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:400px;width:100%;padding:22px;box-shadow:0 24px 60px rgba(2,6,23,.35);font-family:inherit">'+
          '<div style="font-size:12px;font-weight:800;letter-spacing:.6px;color:#0a4da6">PAGAMENTO</div>'+
          '<h3 style="margin:6px 0 8px;font-size:19px;color:#0f172a">CPF ou CNPJ de quem vai pagar</h3>'+
          '<p style="margin:0 0 14px;font-size:14px;line-height:1.45;color:#475569">O banco exige esse dado para emitir a cobrança. Fica guardado para as próximas vezes.</p>'+
          '<input id="asaasDocIn" inputmode="numeric" autocomplete="off" placeholder="000.000.000-00" '+
            'style="width:100%;box-sizing:border-box;font-size:16px;padding:13px 14px;border:1.5px solid #cbd5e1;border-radius:12px;font-family:inherit;letter-spacing:.4px">'+
          '<div id="asaasDocErro" style="color:#b91c1c;font-size:13px;font-weight:600;margin-top:8px;min-height:18px"></div>'+
          '<div style="display:flex;gap:9px;margin-top:6px">'+
            '<button type="button" id="asaasDocSair" style="flex:1;padding:13px;border-radius:12px;border:1.5px solid #cbd5e1;background:#fff;color:#334155;font-size:15px;font-weight:700;font-family:inherit;cursor:pointer">Cancelar</button>'+
            '<button type="button" id="asaasDocOk" style="flex:1.4;padding:13px;border-radius:12px;border:none;background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff;font-size:15px;font-weight:800;font-family:inherit;cursor:pointer">Continuar</button>'+
          '</div>'+
        '</div>';
      document.body.appendChild(bg);

      var campo = document.getElementById('asaasDocIn');
      var erro  = document.getElementById('asaasDocErro');
      var pronto = false;

      campo.value = formatarDoc(docSalvo());
      campo.addEventListener('input', function(){
        var pos = campo.value.length;
        campo.value = formatarDoc(campo.value);
        if(pos >= campo.value.length) erro.textContent = '';
      });

      function fechar(valor){ if(pronto) return; pronto = true; try{ bg.remove(); }catch(_){} resolve(valor); }
      function confirmar(){
        var d = soDigitos(campo.value);
        if(!docValido(d)){ erro.textContent = 'Digite os 11 números do CPF ou os 14 do CNPJ.'; campo.focus(); return; }
        guardarDoc(d); fechar(d);
      }
      document.getElementById('asaasDocOk').onclick = confirmar;
      document.getElementById('asaasDocSair').onclick = function(){ fechar(''); };
      bg.addEventListener('click', function(e){ if(e.target === bg) fechar(''); });
      campo.addEventListener('keydown', function(e){ if(e.key === 'Enter') confirmar(); });
      setTimeout(function(){ try{ campo.focus(); }catch(_){} }, 60);
    });
  }

  /* ---------- botão "Pagar com cartão" embaixo do QR ---------- */
  function botaoCartao(link){
    var b = document.createElement('a');
    b.className = 'asaas-cartao';
    b.href = link; b.target = '_blank'; b.rel = 'noopener noreferrer';
    b.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:9px;margin:12px auto 0;max-width:330px;'+
      'padding:13px 16px;border-radius:13px;background:#fff;border:1.5px solid #0a4da6;color:#0a4da6;'+
      'font-size:15px;font-weight:800;text-decoration:none;font-family:inherit';
    b.innerHTML =
      '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+
        '<rect x="2" y="5" width="20" height="14" rx="2.5"/><path d="M2 10h20"/></svg>'+
      '<span>Prefere cartão? Pague aqui</span>';
    return b;
  }

  /* Acha o QR na tela e encaixa o botão logo abaixo, uma vez só. */
  function encaixarBotao(link){
    if(!link) return;
    var achou = false;
    var fim = Date.now() + 8000;   /* desiste depois de 8s */

    function tentar(){
      if(achou) return true;
      if(document.querySelector('.asaas-cartao')){ achou = true; return true; }
      var imgs = document.querySelectorAll('img[src^="data:image/png"]');
      for(var i=imgs.length-1; i>=0; i--){
        var img = imgs[i];
        if(!img.offsetParent) continue;                  /* invisível: pula */
        var alvo = img.parentNode; if(!alvo) continue;
        alvo.appendChild(botaoCartao(link));
        achou = true; return true;
      }
      return false;
    }

    if(tentar()) return;
    var obs = new MutationObserver(function(){
      if(tentar() || Date.now() > fim){ try{ obs.disconnect(); }catch(_){} }
    });
    try{ obs.observe(document.body, { childList:true, subtree:true }); }catch(_){}
    setTimeout(function(){ try{ obs.disconnect(); }catch(_){} }, 8000);
  }

  /* ---------- escuta as respostas do servidor ---------- */
  var fetchOriginal = window.fetch;
  if(typeof fetchOriginal !== 'function') return;

  window.fetch = async function(entrada, config){
    var url = '';
    try{ url = (typeof entrada === 'string') ? entrada : (entrada && entrada.url) || ''; }catch(_){}

    if(!ROTAS.test(url)) return fetchOriginal.apply(this, arguments);

    var resposta = await fetchOriginal.apply(this, arguments);

    /* lê uma cópia: o app continua lendo a resposta original normalmente */
    var dados = null;
    try{ dados = await resposta.clone().json(); }catch(_){ return resposta; }
    if(!dados || typeof dados !== 'object') return resposta;

    /* 1) faltou o documento → pede e refaz o mesmo pedido */
    if(dados.precisa_cpf){
      var corpo = null;
      try{ corpo = JSON.parse((config && config.body) || '{}'); }catch(_){ corpo = null; }
      if(corpo){
        var doc = docSalvo();
        if(!docValido(doc)) doc = await pedirDocumento();
        if(docValido(doc)){
          corpo.cpf_cnpj = doc;
          var config2 = Object.assign({}, config, { body: JSON.stringify(corpo) });
          var resposta2 = await fetchOriginal.call(this, entrada, config2);
          try{
            var d2 = await resposta2.clone().json();
            if(d2 && d2.link_pagamento){ ultimoLink = d2.link_pagamento; encaixarBotao(ultimoLink); }
          }catch(_){}
          return resposta2;
        }
      }
      return resposta;
    }

    /* 2) veio link de fatura → oferece o cartão */
    if(dados.link_pagamento){ ultimoLink = dados.link_pagamento; encaixarBotao(ultimoLink); }
    else if(dados.aberta && dados.aberta.link_pagamento){ ultimoLink = dados.aberta.link_pagamento; encaixarBotao(ultimoLink); }

    return resposta;
  };
})();

/* ╔═══ src/app/11c-conta-documentos.js ═══════════════════════════════════ */
  /* ==========================================================================
     11c — DOCUMENTOS DA MINHA CONTA (v389, pedido — folha "MINHA CONTA")

     Seção "Documentos" da página Minha conta: CNH e COMPROVANTE DE RESIDÊNCIA
     do usuário, cada um com Anexar → miniatura, Ver, Baixar, Remover, Trocar.

     ONDE FICA GUARDADO: os arquivos vão pro bucket PRIVADO 'documentos-
     privados' pelo caminho que já existe desde a Minha loja (arqUpload →
     /api/arquivo-privado, URL assinada curta — ver 13-abrir-avaliacao.js).
     No app só fica a REFERÊNCIA private://, gravada no metadata da conta
     (doc_cnh / doc_residencia) — string pequena, não incha o token.

     O visual é o MESMO cartão da CNH da Minha loja (classes lj-cnh-*), e o
     visor/download reusam _ljVerDoc/_arqPrivadoBaixar. Módulo NOVO de
     propósito: o 11 (telaCadastro) só ganha o painel e as chamadas.
     ========================================================================= */

  var _CDOC_TIPOS={
    cnh:        { rotulo:'CNH',                      categoria:'cnh',        meta:'doc_cnh' },
    residencia: { rotulo:'Comprovante de residência', categoria:'residencia', meta:'doc_residencia' }
  };
  var _cdocRefs={ cnh:'', residencia:'' };

  function cdocInit(){
    var md=meuMeta||{};
    _cdocRefs.cnh=String(md.doc_cnh||'');
    _cdocRefs.residencia=String(md.doc_residencia||'');
  }
  /* ===== v758 — MINHA CONTA, FASE 2: os cards de estado dos documentos =====
     (PROJETO-2026-08-29-redesign-minha-conta.txt §7). Cada documento é um
     cad-state-card: miniatura/ícone, nome canônico, estado ("Documento
     anexado · PDF" / "Nenhum arquivo anexado"), "Visualizar" (primária),
     "Baixar" (secundária) e "Mais ações" (Substituir · Remover, com
     confirmação). Vazio: "Adicionar documento". Estados de envio: "Enviando
     arquivo…" (indeterminado) → "Salvando referência…" → pronto; remoção:
     "Removendo…"; falha restaura o card anterior. Aviso de privacidade com
     cadeado SVG. A referência vai pro metadata pela fila única
     (cadMetaAtualizar) — nunca mais "Object.assign na hora". */
  var _CDOC_SVG={
    doc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h6"/></svg>',
    cadeado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    mais:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>',
    ver:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>',
    bx:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>',
    tr:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/></svg>',
    rm:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    mais_doc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
  };
  var _cdocEstado={ cnh:'', residencia:'' };   /* '' | 'enviando' | 'salvando' | 'removendo' */
  function cdocPainelHtml(){
    return '<div class="cad-state-list">'+Object.keys(_CDOC_TIPOS).map(function(t){
      return '<div id="cdocW_'+t+'"></div>'+
        '<input type="file" id="cdocIn_'+t+'" accept="image/jpeg,image/png,image/webp,.pdf,application/pdf" style="display:none">';
    }).join('')+'</div>'+
    /* v771 (§6.9): o aviso encurtou */
    '<div class="cad-privado"><span class="cad-privado-ic" aria-hidden="true">'+_CDOC_SVG.cadeado+'</span><div><b>Arquivos privados</b><p>Somente você pode abrir. Cada acesso usa um link temporário.</p></div></div>';
  }
  function _cdocTipoArquivo(ref){ return /\.pdf($|\?|#)/i.test(String(ref||''))?'PDF':'Imagem'; }
  var _CDOC_CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  function cdocRender(t){
    var def=_CDOC_TIPOS[t]; var w=$('cdocW_'+t); if(!def||!w) return;
    var ref=_cdocRefs[t]; var est=_cdocEstado[t]||'';
    var ocupado=!!est;
    /* v771 (§6.4): o status ANEXADO virou PILL pequena ("PDF anexado" /
       "Imagem anexada"); os estados de trabalho continuam texto vivo */
    var estadoHtml;
    if(est==='enviando') estadoHtml='<span class="cad-state-m" role="status">Enviando arquivo…</span>';
    else if(est==='salvando') estadoHtml='<span class="cad-state-m" role="status">Salvando referência…</span>';
    else if(est==='removendo') estadoHtml='<span class="cad-state-m" role="status">Removendo…</span>';
    else if(ref) estadoHtml='<span class="cad-state-pill" role="status">'+_CDOC_CHECK+(_cdocTipoArquivo(ref)==='PDF'?'PDF anexado':'Imagem anexada')+'</span>';
    else estadoHtml='<span class="cad-state-m" role="status">Nenhum arquivo anexado</span>';
    var acoes = ocupado ? '<span class="cad-state-spin" aria-hidden="true"></span>'
      : (ref
        ? ('<button type="button" class="cad-state-bt" id="cdocVer_'+t+'">'+_CDOC_SVG.ver+'<span>Visualizar</span></button>'
          +'<button type="button" class="cad-state-bt is-sec" id="cdocBx_'+t+'">'+_CDOC_SVG.bx+'<span>Baixar</span></button>')
        : ('<button type="button" class="cad-state-bt" id="cdocBtn_'+t+'">'+_CDOC_SVG.mais_doc+'<span>Adicionar</span></button>'));
    /* v771 (§6.4): "Mais ações" mora no CANTO SUPERIOR DIREITO do card (fora
       da fileira de botões — nunca cai pra uma terceira linha) */
    var maisBt=(!ocupado && ref)?('<button type="button" class="cad-state-more cdoc-more" id="cdocMais_'+t+'" aria-label="Mais ações para '+esc(def.rotulo)+'" aria-haspopup="dialog">'+_CDOC_SVG.mais+'</button>'):'';
    w.innerHTML='<div class="cad-state-card'+(ref?' is-success':' is-empty')+(ocupado?' is-loading':'')+'" aria-busy="'+(ocupado?'true':'false')+'">'
      +'<span class="cad-state-ic" id="cdocTh_'+t+'" aria-hidden="true">'+_CDOC_SVG.doc+'</span>'
      +'<div class="cad-state-tx"><b class="cad-state-t">'+esc(def.rotulo)+'</b>'+estadoHtml
      +'<div class="cad-state-acts">'+acoes+'</div></div>'+maisBt+'</div>';
    if(ocupado) return;
    if(!ref){
      var b=$('cdocBtn_'+t); if(b) b.onclick=function(){ var i=$('cdocIn_'+t); if(i){ i.value=''; i.click(); } };
      return;
    }
    var ehPdf=/\.pdf($|\?|#)/i.test(ref);
    var nome=def.rotulo.replace(/\s+/g,'-')+(ehPdf?'.pdf':'.jpg');
    var vv=$('cdocVer_'+t); if(vv) vv.onclick=function(){ _ljVerDoc(ref,nome); };
    var bx=$('cdocBx_'+t); if(bx) bx.onclick=function(){ _arqPrivadoBaixar(ref,nome); };
    var mais=$('cdocMais_'+t); if(mais) mais.onclick=function(){
      openVehicleActionSheet({ titulo:def.rotulo, ancora:mais, grupos:[
        { nome:'Arquivo', itens:[{ rotulo:'Substituir documento', acao:'trocar', ico:_CDOC_SVG.tr }] },
        { nome:'Perigo', perigo:true, itens:[{ rotulo:'Remover documento', acao:'remover', ico:_CDOC_SVG.rm, confirmar:'Confirmar: remover '+def.rotulo }] }
      ], ao:function(acao){ if(acao==='trocar'){ var i=$('cdocIn_'+t); if(i){ i.value=''; i.click(); } } else if(acao==='remover'){ cdocRemover(t); } } });
    };
    /* miniatura: URL assinada temporária, pedida só agora (pdf vira imagem da 1ª página) */
    (function(refAtual,pdf){
      _arqPrivadoUrl(refAtual).then(function(url){
        return pdf?_pdfMiniatura(url):url;
      }).then(function(u){
        var ph=$('cdocTh_'+t); if(!ph || _cdocRefs[t]!==refAtual || !u) return;
        /* v771 (§6.5): a miniatura NÃO fica legível na visão geral — entra
           DESFOCADA com véu e cadeado; a imagem limpa só aparece no
           Visualizar (URL assinada de sempre). alt/title sem dado pessoal. */
        var img=document.createElement('img'); img.className='cad-state-thumb'; img.src=u; img.alt='Miniatura protegida: '+def.rotulo; img.title='Visualizar';
        ph.innerHTML=''; ph.classList.add('cdoc-priv'); ph.appendChild(img);
        var veu=document.createElement('span'); veu.className='cdoc-priv-lock'; veu.setAttribute('aria-hidden','true'); veu.innerHTML=_CDOC_SVG.cadeado; ph.appendChild(veu);
        ph.onclick=function(){ _ljVerDoc(refAtual,nome); };
        ph.removeAttribute('aria-hidden');
      })['catch'](function(){});
    })(ref,ehPdf);
  }
  async function cdocRemover(t){
    var def=_CDOC_TIPOS[t]; if(!def) return;
    var antiga=_cdocRefs[t]; if(!antiga) return;
    _cdocEstado[t]='removendo'; cdocRender(t);
    var ok=await cdocSalvarRef(t,'');
    _cdocEstado[t]='';
    if(!ok){ cdocRender(t); toast('Não consegui salvar a remoção. O documento foi mantido.'); return; }
    _cdocRefs[t]=''; cdocRender(t);
    try{ await _arqPrivadoApagar(antiga); }catch(_){}
    toast(def.rotulo+' removido(a).');
  }
  /* grava a referência no metadata da conta pela FILA ÚNICA (v758) — string
     pequena; o arquivo em si está no bucket privado */
  async function cdocSalvarRef(t,ref){
    try{
      var def=_CDOC_TIPOS[t]; if(!def) return false;
      var patch={}; patch[def.meta]=String(ref||'');
      await cadMetaAtualizar(patch, 'documento');
      return true;
    }catch(_){ return false; }
  }
  async function cdocUp(t,file){
    var def=_CDOC_TIPOS[t]; if(!def||!file) return;
    if(_cdocEstado[t]){ toast('Aguarde o envio anterior terminar.'); return; }   /* v758: a trava é por card — o outro continua utilizável (a fila do metadata garante a ordem) */
    toast('Enviando '+def.rotulo+'…');
    var antiga=_cdocRefs[t];
    /* v758: só este card fica ocupado (o outro continua utilizável); tipo e tamanho conferidos antes de subir */
    var tipoOk=/^(image\/(jpeg|png|webp)|application\/pdf)$/i.test(String(file.type||'')) || /\.(jpe?g|png|webp|pdf)$/i.test(String(file.name||''));
    if(!tipoOk){ toast('Tipo não aceito. Envie JPG, PNG, WEBP ou PDF.'); return; }
    if(file.size>4*1024*1024){ toast('Arquivo maior que 4 MB. Reduza e tente de novo.'); return; }
    _cdocEstado[t]='enviando'; cdocRender(t);
    try{
      var ref=await arqUpload(file,def.categoria);
      if(!ref){ _cdocEstado[t]=''; cdocRender(t); toast('Não recebi o arquivo de volta. Tente de novo.'); return; }
      _cdocEstado[t]='salvando'; cdocRender(t);
      var ok=await cdocSalvarRef(t,ref);
      _cdocEstado[t]='';
      if(!ok){
        cdocRender(t);   /* o card anterior volta (a referência nunca mudou) */
        try{ await _arqPrivadoApagar(ref); }catch(_){}
        toast('Não consegui salvar. O documento anterior foi mantido.');
        return;
      }
      _cdocRefs[t]=ref; cdocRender(t);
      if(antiga&&antiga!==ref){ try{ await _arqPrivadoApagar(antiga); }catch(_){} }
      toast(def.rotulo+' anexado(a) e salvo(a).');
    }catch(e){ _cdocEstado[t]=''; cdocRender(t); var em=String((e&&e.message)||'').trim(); toast(/sess|401|autentic/i.test(em)?'Sua sessão expirou. Entre de novo e tente outra vez.':(em || 'Falha ao enviar. Tente foto ou PDF de até 4 MB.')); }
    finally{ _cdocEstado[t]=''; }
  }
  function cdocWire(){
    cdocInit();
    Object.keys(_CDOC_TIPOS).forEach(function(t){
      cdocRender(t);
      var i=$('cdocIn_'+t); if(i) i.onchange=function(){ var f=this.files&&this.files[0]; this.value=''; if(f) cdocUp(t,f); };
    });
  }

/* ╔═══ src/app/12-crm-clientes.js ════════════════════════════════════════ */
  /* ============ CLIENTES (CRM) + vincular consulta ============ */
  var _clientes=[];
  var ICO_CLI='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
  function cliIni(n){ return String(n||'?').trim().charAt(0).toUpperCase()||'?'; }
  function cliWhatsUrl(tel){ var d=String(tel||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d && d.length>=10 && d.indexOf('55')!==0) d='55'+d; return d?('https://wa.me/'+d):''; }
  var _icoBusca='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  /* v418 (pedido): ícone do WhatsApp OFICIAL (o glifo padrão da marca,
     via Simple Icons) — antes era um desenho à mão que saía preto.
     ⚠️ ESTE é o padrão do app: quem precisar do símbolo do WhatsApp em
     SVG usa este _icoWa (fill=currentColor — a cor vem do botão). */
  var _icoWa='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>';
  var _icoChev='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

  async function telaClientes(){
    /* v173: uma tela so'. No computador ela abre em 3 colunas; no celular
       vira fita de etapas + lista + ficha em tela cheia (padrao MEVTOOLS). */
    return telaClientesCrm();
  }
  var _cliErro=false;
  async function cliCarregar(){
    _cliErro=false;
    try{ var r=await withTimeout(supa.from('clientes').select('*').order('nome',{ascending:true}),9000); _clientes=(r&&r.data)||[]; }
    catch(e){ _clientes=[]; _cliErro=true; }
    /* v520: com a faixa oculta, o resultado desta consulta não ia a lugar
       nenhum. Conferido antes de pular: o `_mtClientes` alimenta SÓ o
       `_mtHtml` e o `_mtBind` — o `mtEspelhar` relê o app_state por conta
       própria e continua funcionando. */
    if(MT_LISTA_VISIVEL) await mtCarregar();   /* clientes do MEVTOOLS (mesmo banco) que ainda não estão aqui */
    try{ crmDupsBadge(); }catch(_){}   /* v458: recontar os telefones repetidos */
  }
  /* ===== PONTE COM O CRM DO MEVTOOLS (mesmo banco, tabela app_state) =====
     Mostra os clientes cadastrados no MEVTOOLS que ainda não existem aqui,
     permite IMPORTAR com um clique e ESPELHA de volta o que for salvo aqui. */
  var _mtClientes=[];
  function _mtDig(x){ return String(x||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); }
  function _mtTel(x){ var d=_mtDig(x); if(d.length>11 && d.slice(0,2)==='55') d=d.slice(2); return d; }
  function _mtIgual(m,c){
    var cpf=_mtDig(m.cpf), tel=_mtTel(m.telefone);
    if(cpf.length>=11 && _mtDig(c.cpf)===cpf) return true;
    if(tel.length>=8 && _mtTel(c.telefone)===tel) return true;
    if(!cpf && !tel){ var nm=String(m.nome||'').trim().toLowerCase(); return !!nm && String(c.nome||'').trim().toLowerCase()===nm; }
    return false;
  }
  async function mtCarregar(){
    _mtClientes=[];
    try{
      if(!meuId) return;
      var r=await withTimeout(supa.from('app_state').select('dados').eq('vendedor_id',meuId).eq('feature','clientes').limit(1),9000);
      var lista=(r&&r.data&&r.data[0]&&r.data[0].dados&&r.data[0].dados.clientes)||[];
      _mtClientes=lista.filter(function(m){ return (m&&(m.nome||m.telefone||m.cpf)) && !(_clientes||[]).some(function(c){ return _mtIgual(m,c); }); });
    }catch(_){ _mtClientes=[]; }
  }
  async function mtImportar(m){
    try{
      var ins={ user_id:meuId, nome:String(m.nome||'Cliente').trim()||'Cliente', telefone:m.telefone||null, email:m.email||null,
        cpf:m.cpf||null, rg:m.rg||null, nascimento:m.nasc||null, cep:m.cep||null, rua:m.rua||null, numero:m.numero||null,
        bairro:m.bairro||null, cidade:m.cidade||null, uf:m.uf||null, interesse:m.veiculo_interesse||null,
        origem:m.origem||'MEVTOOLS', faixa_preco:(parseInt(_mtDig(m.faixa_valor),10)||null),
        faixa_parcela:(parseInt(_mtDig(m.faixa_parcela),10)||null), obs:m.obs_negociacao||null,
        anotacoes:[{t:'Importado do CRM do MEVTOOLS', ts:new Date().toISOString()}] };
      var r=await supa.from('clientes').insert(ins).select().single(); if(r&&r.error) throw r.error;
      if(r&&r.data) _clientes.push(r.data);
      _mtClientes=_mtClientes.filter(function(x){ return x!==m; });
      toast('Cliente importado do MEVTOOLS \u2713');
      return (r&&r.data)||null;
    }catch(e){ toast('N\u00e3o consegui importar. '+((e&&e.message)||'')); return null; }
  }
  /* espelha um cliente salvo aqui de volta pro cadastro do MEVTOOLS (mescla por CPF/telefone) */
  async function mtEspelhar(c){
    try{
      if(!meuId || !c || !String(c.nome||'').trim()) return;
      var r=await supa.from('app_state').select('dados').eq('vendedor_id',meuId).eq('feature','clientes').limit(1);
      var dados=(r&&r.data&&r.data[0]&&r.data[0].dados)||{};
      if(!Array.isArray(dados.clientes)) dados.clientes=[];
      var idx=dados.clientes.findIndex(function(x){ return _mtIgual({cpf:c.cpf,telefone:c.telefone,nome:c.nome}, {cpf:x.cpf,telefone:x.telefone,nome:x.nome}); });
      var alvo = idx>=0 ? dados.clientes[idx] : { criado_em:new Date().toISOString() };
      function poe(k,v){ v=String(v==null?'':v).trim(); if(v) alvo[k]=v; }
      poe('nome',c.nome); poe('telefone',c.telefone); poe('cpf',c.cpf); poe('email',c.email); poe('rg',c.rg);
      poe('nasc',c.nascimento); poe('cep',c.cep); poe('rua',c.rua); poe('numero',c.numero); poe('bairro',c.bairro);
      poe('cidade',c.cidade); poe('uf',c.uf); poe('veiculo_interesse',c.interesse); poe('origem',c.origem);
      if(c.faixa_preco) alvo.faixa_valor=String(c.faixa_preco);
      if(c.faixa_parcela) alvo.faixa_parcela=String(c.faixa_parcela);
      alvo.atualizado_em=new Date().toISOString();
      if(idx>=0) dados.clientes[idx]=alvo; else dados.clientes.unshift(alvo);
      await supa.from('app_state').upsert({ vendedor_id:meuId, feature:'clientes', dados:dados, updated_at:new Date().toISOString() });
    }catch(_){}
  }
  /* cards dos clientes do MEVTOOLS ainda n\u00e3o importados (respeita a busca) */
  function _mtFiltra(termo){
    termo=(termo||'').toLowerCase().trim(); var td=termo.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    return (_mtClientes||[]).filter(function(m){ if(!termo) return true;
      var okN=String(m.nome||'').toLowerCase().indexOf(termo)>=0;
      var okT=td&&_mtDig(m.telefone).indexOf(td)>=0; return okN||okT; });
  }
  function _mtBind(el, crm){
    Array.prototype.forEach.call(el.querySelectorAll('[data-mt]'),function(card){
      card.onclick=async function(){
        var m=_mtClientes[+card.getAttribute('data-mt')]||null;
        if(!m) return;
        card.style.opacity='.5';
        var novo=await mtImportar(m);
        if(novo){ if(crm){ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); crmFichaAbrir(novo.id); } else { cliPinta((($('cliBusca')||{}).value)||''); cliAbrirFicha(novo.id); } }
        else card.style.opacity='';
      };
    });
  }
  /* ===== v520 (pedido do Angelo: "oculte") — A FAIXA DO MEV TOOLS =========
     (PROJETO-ocultar-a-lista-do-mevtools)
     ⛳ false = a faixa "CLIENTES DO MEVTOOLS — TOQUE PRA TRAZER PRA CÁ" não
     aparece. Religar = trocar por true. Nada mais precisa mudar.

     POR QUE: medido em 16/08, o CRM do MEV Tools tem 106 clientes e 101
     já vieram pra cá. O trabalho da faixa acabou — o que restou são ~15
     cards com telefone cru, sem etapa e sem temperatura, pendurados no fim
     de uma lista de trabalho diário. (Conferido de propósito: NÃO é erro de
     comparação; o _mtIgual confere CPF, telefone sem DDI e nome, e nenhum
     dos 15 é "a mesma pessoa com o nono dígito diferente".)

     🔴 A TRAVA VAI NA ENTRADA DA FUNÇÃO, e não nas chamadas. O _mtHtml é
     chamado de SETE lugares (lista cheia, lista vazia, busca sem resultado,
     no celular e no computador). Sair caçando as sete deixaria a faixa
     aparecendo só no caso raro, e ninguém descobriria por semanas.

     🔴🔴 ISTO ESCONDE SÓ A **IDA**. O `mtEspelhar` (a VOLTA da ponte —
     toda vez que um cliente é salvo aqui, ele é gravado de volta no
     cadastro do MEV Tools) CONTINUA LIGADO, e não pode ser desligado
     junto. São coisas diferentes:
         ocultar a lista  = parar de OFERECER os que faltam vir
         desligar a ponte = o MEV Tools parar de RECEBER o que muda aqui
     E a segunda falha é CALADA: o mtEspelhar inteiro vive dentro de um
     try/catch vazio, de propósito ("espelhar nunca pode travar o
     salvamento"). Se ele parar, ninguém recebe aviso nenhum — o MEV Tools
     só vai ficando velho. */
  var MT_LISTA_VISIVEL = false;

  function _mtHtml(termo, crm){
    if(!MT_LISTA_VISIVEL) return '';
    var lista=_mtFiltra(termo); if(!lista.length) return '';
    var h='<div class="mt-sep">Clientes do MEVTOOLS \u2014 toque pra trazer pra c\u00e1</div>';
    lista.forEach(function(m){
      var i=_mtClientes.indexOf(m);
      if(crm){ h+='<div class="crm-card mtc" data-mt="'+i+'"><div class="crm-ctx"><div class="crm-cnm">'+esc(m.nome||'(sem nome)')+'<span class="mt-badge">MEVTOOLS</span></div>'+
        '<div class="crm-csb">'+esc(m.telefone||'\u2014')+'</div></div><div class="cli-chev">'+_icoChev+'</div></div>'; }
      else { h+='<div class="cli-card mtc" data-mt="'+i+'"><div class="cli-av" style="background:#f3e8ff;color:#7c3aed">'+esc(cliIni(m.nome))+'</div>'+
        '<div class="cli-tx"><div class="cli-nm">'+esc(m.nome||'(sem nome)')+' <span class="mt-badge">MEVTOOLS</span></div><div class="cli-sb">'+esc(m.telefone||'\u2014')+'</div></div><div class="cli-chev">'+_icoChev+'</div></div>'; }
    });
    return h;
  }

  function cliPinta(termo){
    if($('crmLista')){ crmPintaEtapas(); crmPintaLista(termo); return; }   /* tela CRM (desktop) */
    var el=$('cliLista'); if(!el) return;
    _chatResumoCarrega(function(){ cliPinta((($('cliBusca')||{}).value)||''); }); termo=(termo||'').toLowerCase().trim(); var td=termo.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(!_clientes.length && _cliErro){ erroLista(el, async function(){ el.innerHTML=skelHtml(5); await cliCarregar(); cliPinta((($('cliBusca')||{}).value)||''); }); return; }
    var _orfasM=_orfaHtml(termo,false);   /* v335: conversas do WhatsApp sem ficha */
    if(!_clientes.length){ el.innerHTML=(_orfasM?'':'<div class="cli-empty"><b>Nenhum cliente ainda</b>Toque no <b>+</b> no canto direito da barra de baixo para cadastrar o primeiro.</div>')+_orfasM+_mtHtml(termo,false); _orfaBind(el,false); _mtBind(el,false); return; }
    var lista=_clientes.filter(function(c){ if(!termo) return true; var okN=String(c.nome||'').toLowerCase().indexOf(termo)>=0; var okT=td&&String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').indexOf(td)>=0; return okN||okT; });
    if(!lista.length){ el.innerHTML=(_orfasM?'':'<div class="cli-empty">Nada encontrado.</div>')+_orfasM+_mtHtml(termo,false); _orfaBind(el,false); _mtBind(el,false); return; }
    el.innerHTML=lista.map(function(c){ var wa=cliWhatsUrl(c.telefone);
      return '<div class="cli-card" data-id="'+esc(c.id)+'"><div class="cli-av">'+esc(cliIni(c.nome))+'</div>'+
        '<div class="cli-tx"><div class="cli-nm">'+esc(c.nome||'Cliente')+'</div><div class="cli-sb">'+esc(c.telefone||c.email||'-')+'</div>'+_chatLinhaHtml(c)+'</div>'+
        (wa?'<button class="cli-wa" data-wa="'+esc(wa)+'" title="WhatsApp">'+_icoWa+'</button>':'')+
        '<div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    el.innerHTML += _orfasM + _mtHtml(termo,false);
    _orfaBind(el,false);
    Array.prototype.forEach.call(el.querySelectorAll('.cli-card:not(.mtc)'),function(card){ card.onclick=function(e){ if(e.target.closest&&e.target.closest('[data-wa]')) return; cliAbrirFicha(card.getAttribute('data-id')); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-wa]'),function(b){ b.onclick=function(e){ e.stopPropagation(); var u=b.getAttribute('data-wa'); if(u){ try{ window.open(u,'_blank'); }catch(_){ location.href=u; } } }; });
    _mtBind(el,false);
  }

  /* ================= CRM DE CLIENTES (desktop) — estrutura do MEVTOOLS =================
     3 colunas: ETAPAS (funil) | LISTA (com ações rápidas) | CADASTRO + HISTÓRICO */
  function _cIco(p){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>'; }
  var CRM_ETAPAS=[
    ['chat','Chat',_cIco('<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/>')],
    ['agendados','Agendados',_cIco('<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M9 15l2 2 4-4"/>')],
    ['nao_atendido','Não Atendido',_cIco('<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>')],
    ['em_atendimento','Em atendimento',_cIco('<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.36 1.85.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.96.34 1.91.58 2.81.7A2 2 0 0 1 22 16.92z"/>')],
    ['parou_responder','Parou de responder',_cIco('<path d="M21 11.5a8.5 8.5 0 0 1-12.3 7.6L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z"/><line x1="4" y1="4" x2="20" y2="20"/>')],
    ['aguardando_veiculo','Aguardando Veículo',_cIco('<path d="M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11"/><path d="M3 11h18v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><circle cx="7.5" cy="14" r="1"/><circle cx="16.5" cy="14" r="1"/>')],
    ['perdido','Perdido',_cIco('<circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>')],
    ['comprou','Comprou',_cIco('<circle cx="12" cy="12" r="10"/><path d="M8 12l2.5 2.5L16 9"/>')],
    ['pos_vendas','Pós-vendas',_cIco('<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>')],
    ['repasse','Repasse',_cIco('<path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>')],
    /* v458 (pedido): quem entrou por engano ou nao e comprador */
    ['nao_e_cliente','Não é cliente',_cIco('<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="18" y1="8" x2="23" y2="13"/><line x1="23" y1="8" x2="18" y2="13"/>')]
  ];
  var _ICO_TAG=_cIco('<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>');
  var _ICO_FIRE=_cIco('<path d="M12 22c4 0 7-2.7 7-7 0-3-2-5.5-3.5-7C14 6.5 13 4.5 13 2c-3 2-5 5-5 8-1-.7-1.8-1.8-2-3-1.2 1.6-2 3.6-2 5.5C4 19 8 22 12 22z"/>');
  var _ICO_CAL=_cIco('<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>');
  var _ICO_DOTS=_cIco('<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>');
  /* v520: o lápis do #cxMais (cadastro completo). Mesmo traço dos vizinhos
     porque sai do mesmo _cIco — ver o comentário no botão. */
  var _ICO_EDIT=_cIco('<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>');
  var _ICO_LIXO=_cIco('<polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>');
  var _ICO_FONE2=_cIco('<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.36 1.85.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.96.34 1.91.58 2.81.7A2 2 0 0 1 22 16.92z"/>');
  /* v429 */
  var _ICO_MAIS2=_cIco('<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>');
  var _ICO_IMPORTA=_cIco('<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>');
  var _ICO_EXPORTA=_cIco('<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>');
  var _ICO_OLHO=_cIco('<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>');
  var _ICO_COPIA=_cIco('<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>');
  var CRM_ORIGENS=['Loja (balcão)','WhatsApp','Instagram','Facebook','OLX','Webmotors','iCarros','Indicação','Telefone','Passou na frente','Outro'];
  var _crmEtapa='', _crmSel=null, _crmTimer=null, _crmOrd='recente', _crmFichaAba='dados';
  /* ===== v401 (pedido) — CHAT SÓ PRA QUEM TEM O ATENDENTE IA ==============
     A loja com atendente tem uma linha em mp_atendente_loja (RLS: cada um lê
     só a própria — política criada em 12/08). Sem o atendente, a etapa
     "Chat" some do filtro e a aba "Chat" some da ficha. O Angelo (admin)
     sempre vê. Enquanto a resposta não chega, fica escondido. */
  var _chatTem=null, _chatTemIndo=false;
  function chatDisponivel(){
    if(_chatTem!==null) return;
    try{ if(typeof _ehAdmin==='function' && _ehAdmin()){ _chatTem=true; return; } }catch(_){}
    if(_chatTemIndo || !window.supa || !meuId) return;
    _chatTemIndo=true;
    try{
      supa.from('atendente_loja').select('user_id').eq('user_id',meuId).limit(1).then(function(r){
        _chatTem=!!(r&&r.data&&r.data.length);
        _chatTemIndo=false;
        try{ if($('crmEtSel')) crmPintaEtapas(); }catch(_){}
      },function(){ _chatTem=false; _chatTemIndo=false; });
    }catch(_){ _chatTem=false; _chatTemIndo=false; }
  }
  var CRM_ORDENS=[['recente','Mais recente'],['nome','Nome (A-Z)'],['etapa','Por etapa']];
  /* v401 (pedido): filtro de INATIVIDADE — quanto tempo sem nenhuma ação
     (a régua é o atualizado_em: qualquer mexida no cliente renova) */
  var _crmSemAcao='';
  var CRM_SEM_ACAO=[['','Sem ação: todos'],['24h','Sem ação há 24h+'],['7d','Sem ação de 1 a 7 dias'],['8a14','Sem ação de 8 a 14 dias'],['14mais','Sem ação há mais de 14 dias']];
  function crmEtapaInfo(k){ for(var i=0;i<CRM_ETAPAS.length;i++){ if(CRM_ETAPAS[i][0]===k) return CRM_ETAPAS[i]; } return null; }
  async function telaClientesCrm(){
    mevTabSet('');
    _crmEtapa='nao_atendido';   /* v397 (pedido): a página abre já filtrada em "Não Atendido" */
    document.body.classList.add('crm-on');   /* solta a largura da página (CSS) */
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg crm-pg"><h2>Leads</h2>'+
      /* v484 (A3 do plano): sem esta linha, a primeira reação do vendedor
         à carteira nova seria "o app apagou meus clientes". */
      (_cliEhDono()?'':'<div class="crm-carteira-nota">Aqui ficam os clientes que <b>você</b> cadastrou.</div>')+
      /* v375 — UMA COLUNA SÓ, IGUAL NO COMPUTADOR E NO CELULAR.
         Antes eram 3 colunas no computador: as etapas ocupavam 225px na
         esquerda e a lista de clientes ficava espremida em 380px, com os
         nomes compridos quebrando em duas linhas.
         Agora, de cima pra baixo: BUSCA · ETIQUETAS DE ETAPA + ORDENAR ·
         LISTA na largura toda. E o cliente escolhido abre em PÁGINA CHEIA
         com abas (Cadastro / Histórico / Chat) — o mesmo desenho que o
         celular já usava. Quem faz o resto é o bloco "v375" do styles.css. */
      '<div class="crm">'+
        '<div class="crm-mid">'+
          /* ===== v806 (§3 e §6) — A ORDEM DA PRIMEIRA DOBRA =================
             Pedido, na letra: título · Novo lead + Mais ações · busca ·
             etapa + Filtros · total e filtros ativos · resumo dos grupos
             fora da lista · lista.
             🔴 POR QUE AS AÇÕES SUBIRAM: antes elas vinham DEPOIS dos
             filtros, então quem abria a página no celular via primeiro três
             controles e só então o botão de criar. A ação primária da
             página não pode ser a quarta coisa da tela.
             ⚠️ Os ids não mudaram — os punhos lá de baixo (#crmNovo,
             #crmMais, #cliBusca, #crmEtapas, #crmFiltrosBt, #crmOrd,
             #crmSemAcao) continuam achando os mesmos elementos. */
          '<div class="crm-acoes">'+
            '<button type="button" class="crm-ab primaria" id="crmNovo">'+_ICO_MAIS2+'Novo lead</button>'+
            '<button type="button" class="crm-ab crm-ab-mais" id="crmMais" aria-label="Mais ações" aria-haspopup="dialog" title="Importar, exportar, unificar e avisos">⋯</button>'+
            '<input type="file" id="crmArquivo" accept=".csv,.txt,text/csv" hidden>'+
          '</div>'+
          /* v806: o sino saiu daqui (foi pra dentro de "Mais ações", com
             texto). A busca passa a ocupar a linha inteira no celular. */
          '<div class="crm-top"><div class="cli-search">'+_icoBusca+
            '<input id="cliBusca" placeholder="Buscar nome, telefone ou veículo" autocomplete="off" enterkeyhint="search">'+
            '<button type="button" class="cli-limpa" id="cliBuscaX" aria-label="Limpar busca" title="Limpar busca" hidden>×</button>'+
          '</div></div>'+
          /* ===== v598 (PROJETO-leads-tela-enxuta): 8 andares viraram 4 ====
             Regra do projeto: mínimo de informação na tela. Os DOIS selects
             (Sem ação · Ordenar) moram agora na FOLHA de filtros; Importar/
             Exportar/Unificar moram no "⋯". ⚠️ Os ids NÃO mudaram — os
             punhos lá de baixo (_od/_sa/_bi/_be/_bu e o crmDupsBadge)
             continuam achando os mesmos elementos, só que dentro da folha. */
          '<div class="crm-filtros">'+
            '<aside class="crm-et" id="crmEtapas"></aside>'+
            '<button type="button" class="crm-ord crm-fbt" id="crmFiltrosBt" aria-haspopup="dialog">Filtros<span class="crm-fbt-n" id="crmFiltrosN"></span> <span class="crm-fbt-ch">⏷</span></button>'+
          '</div>'+
          /* v806 (§6): a linha do RESULTADO — total vivo, chips do que está
             filtrado e a ordem. Quem preenche é `crmPintaResumo()`, chamado
             pelo mesmo `crmPintaLista` que desenha as linhas: o número e a
             lista nascem da MESMA contagem, então não têm como discordar. */
          '<div class="crm-res" id="crmRes" aria-live="polite"></div>'+
          /* a folha de filtros (padrão folha-por-cima da v529) */
          '<div class="cropmask" id="crmFiltrosFolha" style="display:none"><div class="cropbox" style="max-width:340px">'+
            '<div class="crop-tit">Filtros</div>'+
            '<div class="crm-fitem"><label>Tempo sem ação</label>'+
              '<select class="crm-ord" id="crmSemAcao" aria-label="Filtrar por tempo sem ação">'+CRM_SEM_ACAO.map(function(o){ return '<option value="'+o[0]+'">'+esc(o[1])+'</option>'; }).join('')+'</select></div>'+
            '<div class="crm-fitem"><label>Ordenar</label>'+
              '<select class="crm-ord" id="crmOrd">'+CRM_ORDENS.map(function(o){ return '<option value="'+o[0]+'">'+esc(o[1])+'</option>'; }).join('')+'</select></div>'+
            '<button type="button" class="link" id="crmFiltrosOk" style="margin-top:12px;width:100%">Fechar</button>'+
          '</div></div>'+
          /* o menu do "⋯" — ações raras não moram na tela (regra do projeto) */
          '<div class="cropmask" id="crmMaisMenu" style="display:none"><div class="cropbox" style="max-width:320px">'+
            '<div class="crop-tit">Mais ações</div>'+
            '<div class="crm-mmenu">'+
              '<button type="button" class="crm-ab" id="crmImportar">'+_ICO_IMPORTA+'Importar</button>'+
              '<button type="button" class="crm-ab" id="crmExportar">'+_ICO_EXPORTA+'Exportar</button>'+
              '<button type="button" class="crm-ab" id="crmUnificar" style="display:none"></button>'+
            '</div>'+
            /* ===== v806 (§6) — O SINO SAIU DA LINHA DA BUSCA ===============
               Ele era um quadrado de 44px que ficava VERDE quando ligado, ao
               lado do campo de busca, disputando a primeira dobra com a ação
               mais usada da página. E a cor era a única forma de saber o
               estado — quem não distingue verde de branco não sabia se o
               aviso estava ligado.
               Agora: linha escrita, com o estado em PALAVRA
               ("Ativados"/"Desativados") e, quando não dá pra ligar, o
               MOTIVO em texto (pushImpedimento).
               🔴 O botão continua sendo o `pushSinoHtml()`/`pushSinoBind()`
               de sempre — nada de um segundo sino com regra própria. */
            '<div class="crm-mav" id="crmAvisos">'+
              '<div class="crm-mav-tx"><b>Avisos de novos leads</b>'+
                '<span id="crmAvisosEst">Verificando…</span></div>'+
              pushSinoHtml()+
            '</div>'+
            '<button type="button" class="link" id="crmMaisOk" style="margin-top:12px;width:100%">Fechar</button>'+
          '</div></div>'+
          '<div id="crmLista">'+skelHtml(5)+'</div>'+
        '</div>'+
        '<section class="crm-fx" id="crmFicha"><div class="cli-empty" style="margin-top:40px"><b>Escolha um cliente</b>Toque num cliente da lista pra abrir a ficha completa.</div></section>'+
      '</div></div>';
    /* 🔴🔴 v1071 — A ABA "REVISÕES" É MONTADA AQUI, e a POSIÇÃO é a regra.
       Armadilha da v810: aba nova despachada DEPOIS de um `if(!dados) return`
       abre EM BRANCO e nada acusa. Esta linha vem imediatamente depois do
       innerHTML e ANTES de qualquer saída antecipada da função — o teste mede
       a posição de uma em relação à outra justamente por isso.
       O painel inteiro mora no 12p-revisoes.js; aqui fica só a porta. */
    try{ revAbaMontar(); }catch(_){}
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    mevCtx('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>','Novo', function(){ cliAbrirFicha(null); });
    /* v806 (§6): a busca com botão de limpar — some quando o campo está
       vazio, pra não virar mais um alvo parado na tela. */
    $('cliBusca').oninput=function(){ crmBuscaX(); crmPintaLista(this.value); };
    { var _bx=$('cliBuscaX'); if(_bx) _bx.onclick=function(){
        var i=$('cliBusca'); if(!i) return;
        i.value=''; crmBuscaX(); crmPintaLista(''); try{ i.focus(); }catch(_){}
      }; }
    /* v429: os três botões da barra de ações */
    var _bn=$('crmNovo'); if(_bn) _bn.onclick=function(){ cliAbrirFicha(null); };
    var _bi=$('crmImportar'), _ba=$('crmArquivo');
    if(_bi&&_ba){
      _bi.onclick=function(){ _ba.value=''; _ba.click(); };
      _ba.onchange=function(){ var f=this.files&&this.files[0]; if(f) crmImportarCsv(f); };
    }
    /* v458: o botao so aparece quando existe telefone repetido.
       v517 (pedido: "mostrar contato duplicado"): ele deixou de disparar o
       confirm cinza do navegador — que mostrava um NÚMERO e apagava fichas —
       e passa a ABRIR A TELA com um cartão por grupo, mostrando os nomes.
       O `crmUnificarDuplicados` (o laço que unificava tudo de uma vez) fica
       no arquivo, escondido, como caminho de volta. */
    {
      var _bu=$('crmUnificar');
      if(_bu) _bu.onclick=function(){
        if(typeof crmRepetidosAbrir==='function') crmRepetidosAbrir();
        else crmUnificarDuplicados();
      };
      try{ if(typeof crmNaoDupCarregar==='function') crmNaoDupCarregar().then(function(){ try{ crmDupsBadge(); }catch(_){} }); }catch(_){}
      try{ crmDupsBadge(); }catch(_){}
    }
    var _be=$('crmExportar'); if(_be) _be.onclick=crmExportarCsv;
    var _od=$('crmOrd'); if(_od){ _od.value=_crmOrd; _od.onchange=function(){ _crmOrd=this.value; _crmFiltroDot(); crmPintaLista((($('cliBusca')||{}).value)||''); }; }
    var _sa=$('crmSemAcao'); if(_sa){ _sa.value=_crmSemAcao; _sa.onchange=function(){ _crmSemAcao=this.value||''; _crmFiltroDot(); crmPintaLista((($('cliBusca')||{}).value)||''); }; }
    /* ===== v598: a folha de Filtros e o menu "⋯" ==========================
       A bolinha azul no botão Filtros = sinal de filtro fora do padrão
       (Sem ação escolhido, ou ordem diferente de "Mais recente"). */
    /* v806 (§6): "Filtros" ou "Filtros (N)". A bolinha azul da v598 dizia
       "tem algo ligado" sem dizer QUANTO; o número diz. ⚠️ A bolinha
       continua existindo pro botão igual da página Repasses (#repFiltrosBt,
       mesma classe .crm-fbt) — quem a esconde aqui é o `.tem-n` do CSS. */
    function _crmFiltroDot(){ _crmFiltroDotSeguro(); }
    var _ffo=$('crmFiltrosFolha'), _fbt=$('crmFiltrosBt');
    if(_fbt&&_ffo){
      _fbt.onclick=function(){ _ffo.style.display='flex'; };
      _ffo.onclick=function(e){ if(e.target===_ffo) _ffo.style.display='none'; };
      var _fok=$('crmFiltrosOk'); if(_fok) _fok.onclick=function(){ _ffo.style.display='none'; };
    }
    var _mm=$('crmMaisMenu'), _mbt=$('crmMais');
    if(_mbt&&_mm){
      _mbt.onclick=function(){ _mm.style.display='flex'; };
      _mm.onclick=function(e){ if(e.target===_mm) _mm.style.display='none'; };
      var _mok=$('crmMaisOk'); if(_mok) _mok.onclick=function(){ _mm.style.display='none'; };
      /* escolher uma ação fecha o menu (depois do onclick do próprio botão) */
      _mm.addEventListener('click',function(e){ if(e.target.closest && e.target.closest('.crm-ab')) _mm.style.display='none'; });
    }
    _crmFiltroDot();
    pushSinoBind();   /* v335 — o botão de verdade; o texto é o espelho dele */
    crmAvisosEspelho();   /* v806 */
    _crmSel=null; crmFichaFechar();
    await cliCarregar();
    /* v400 (susto do Angelo: "meu histórico de clientes sumiu"): se NÃO tem
       ninguém em Não Atendido, abre em "Todos" — o pré-filtro da v397 só vale
       quando há alguém esperando. */
    if(_crmEtapa==='nao_atendido' && !_clientes.filter(function(c){ return c.etapa==='nao_atendido'; }).length) _crmEtapa='';
    crmPintaEtapas(); crmPintaLista('');
  }
  /* ================= v322 — CHAT DO WHATSAPP DENTRO DO APP =================
     As mensagens moram em mensagens_whatsapp (webhook do atendente alimenta).
     O servidor (/api/chat-whatsapp) le, marca como lida e envia pelo Z-API. */
  var _cxChatTimer=null, _chatResumo=null, _chatResumoEm=0, _chatResumoIndo=false;
  async function _chatApi(corpo){
    try{
      var s=await supa.auth.getSession();
      var tk=(s&&s.data&&s.data.session&&s.data.session.access_token)||'';
      if(!tk) return null;
      var r=await fetch('/api/chat-whatsapp',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(Object.assign({token:tk},corpo||{}))});
      return await r.json();
    }catch(_){ return null; }
  }
  function cxChatDesligar(){ if(_cxChatTimer){ clearInterval(_cxChatTimer); _cxChatTimer=null; } }
  function cxChatLigar(c){
    cxChatDesligar();
    var d=String(c&&c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    cxChatPinta(d,false);
    _cxChatTimer=setInterval(function(){
      if(document.getElementById('cxChatMsgs')) cxChatPinta(d,true); else cxChatDesligar();
    }, 8000);
  }
  async function cxChatPinta(fone,silencioso){
    var box=document.getElementById('cxChatMsgs'); if(!box) return;
    if(!fone){ box.innerHTML='<div class="cli-empty" style="padding:12px">Cadastre o telefone do cliente pra ver a conversa.</div>'; return; }
    var d=await _chatApi({acao:'listar',telefone:fone});
    box=document.getElementById('cxChatMsgs'); if(!box) return;
    if(!d||!d.ok){ if(!silencioso) box.innerHTML='<div class="cli-empty" style="padding:12px">'+esc((d&&d.erro)||'Nao consegui carregar a conversa.')+'</div>'; return; }
    if(!(d.mensagens||[]).length){ box.innerHTML='<div class="cli-empty" style="padding:12px">Nenhuma mensagem ainda. Escreva abaixo pra puxar assunto.</div>'; return; }
    var noFim = box.scrollTop+box.clientHeight >= box.scrollHeight-60;
    box.innerHTML=d.mensagens.map(function(m){
      var dt=new Date(m.criado_em), hh=('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
      var media=m.midia_url?('<a href="'+esc(m.midia_url)+'" target="_blank" rel="noopener">'+(m.midia_tipo==='image'?'[foto] ':'[anexo] ')+'</a>'):'';
      return '<div class="cx-b '+(m.direcao==='enviada'?'eu':'ele')+'">'+media+esc(m.texto||'')+'<i>'+hh+'</i></div>';
    }).join('');
    if(noFim||!silencioso) box.scrollTop=box.scrollHeight;
    _chatResumo=null; /* lidas mudaram — resumo sera' recarregado */
  }
  async function cxChatEnviar(c){
    var inEl=document.getElementById('cxChatIn'); if(!inEl) return;
    var t=String(inEl.value||'').trim(); if(!t) return;
    var d=String(((document.getElementById('cxTel')||{}).value)||c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(!d){ toast('Cadastre o telefone primeiro.'); return; }
    inEl.disabled=true;
    var r=await _chatApi({acao:'enviar',telefone:d,texto:t});
    inEl.disabled=false;
    if(r&&r.ok){ inEl.value=''; cxChatPinta(d,false); } else toast((r&&r.erro)||'Nao consegui enviar.');
    try{ inEl.focus(); }catch(_){}
  }
  /* resumo pra lista: ultima mensagem + bolinha de nao lidas por telefone */
  function _chatDe(c){
    var d=String(c&&c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(-8);
    return (d&&_chatResumo&&_chatResumo[d])||null;
  }
  function _chatResumoCarrega(depois){
    if(_chatResumo && (Date.now()-_chatResumoEm)<60000) return;
    if(_chatResumoIndo) return;
    _chatResumoIndo=true;
    _chatApi({acao:'resumo'}).then(function(d){
      _chatResumoIndo=false;
      if(d&&d.ok){
        var mapa={};
        (d.conversas||[]).forEach(function(cv){ mapa[String(cv.telefone||'').replace(/\D/g,'').slice(-8)]=cv; });
        _chatResumo=mapa; _chatResumoEm=Date.now();
        if(typeof depois==='function') depois();
      }
    });
  }
  function _chatLinhaHtml(c){
    var cv=_chatDe(c); if(!cv) return '';
    return '<div class="cli-last'+(cv.nao_lidas?' tem':'')+'">'+(cv.nao_lidas?('<b class="cli-nn">'+cv.nao_lidas+'</b>'):'')+
      ((cv.direcao==='enviada')?'Voce: ':'')+esc(String(cv.ultima||'').slice(0,52))+'</div>';
  }

  /* ===== v335: CONVERSA SEM FICHA ("orfa") — o bug do "nao aparece em Todos"
     Ate' a v334 as duas listas de Clientes so' liam _clientes (a tabela
     mp_clientes). Quem escreveu no WhatsApp e ainda NAO tinha ficha existia
     so' em mensagens_whatsapp: nao entrava em "Todos", nao entrava no chip
     Chat, nao aparecia na busca. A conversa ficava invisivel.
     (O atendente IA ate' cria a ficha sozinho, mas so' na PRIMEIRA mensagem
     de uma conversa nova — conversa antiga, audio/foto, numero que o
     atendente ignorou ou lead que chegou por outro caminho ficava de fora.)
     Agora toda conversa sem ficha vira um card no fim da lista; um toque
     cadastra o cliente de verdade (etapa Chat) e abre a ficha. */
  function _chatOrfas(){
    if(!_chatResumo) return [];
    var tem={};
    (_clientes||[]).forEach(function(c){
      var d=String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(-8);
      if(d) tem[d]=1;
    });
    var out=[];
    Object.keys(_chatResumo).forEach(function(k){ if(!tem[k]) out.push(_chatResumo[k]); });
    out.sort(function(a,b){ return String(b.quando||'').localeCompare(String(a.quando||'')); });
    return out;
  }
  function _orfaFiltra(termo){
    termo=(termo||'').toLowerCase().trim(); var td=termo.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    /* a etapa "Chat" mostra so' as pendentes; "Todos" mostra todas */
    var base=_chatOrfas().filter(function(cv){ return _crmEtapa!=='chat' || (cv.nao_lidas>0); });
    return base.filter(function(cv){ if(!termo) return true;
      var okN=String(cv.nome||'').toLowerCase().indexOf(termo)>=0;
      var okT=td&&String(cv.telefone||'').replace(/\D/g,'').indexOf(td)>=0;
      return okN||okT; });
  }
  function _orfaVisivel(){ return _crmEtapa==='' || _crmEtapa==='chat'; }
  function _orfaHtml(termo, crm){
    if(crm && !_orfaVisivel()) return '';
    var lista=_orfaFiltra(termo); if(!lista.length) return '';
    _orfaCache=lista;
    var h='<div class="mt-sep">Conversas do WhatsApp sem ficha — toque pra cadastrar</div>';
    lista.forEach(function(cv,i){
      var nome=esc(cv.nome||'Cliente do WhatsApp');
      var fone=esc(cv.telefone||'—');
      var ult='<div class="cli-last'+(cv.nao_lidas?' tem':'')+'">'+(cv.nao_lidas?('<b class="cli-nn">'+cv.nao_lidas+'</b>'):'')+
        ((cv.direcao==='enviada')?'Voce: ':'')+esc(String(cv.ultima||'').slice(0,52))+'</div>';
      if(crm){
        h+='<div class="crm-card mtc" data-orfa="'+i+'"><div class="crm-ctx">'+
          '<div class="crm-cnm">'+nome+'<span class="mt-badge">WHATSAPP</span></div>'+
          '<div class="crm-csb">'+fone+'</div>'+ult+'</div><div class="cli-chev">'+_icoChev+'</div></div>';
      }else{
        h+='<div class="cli-card mtc" data-orfa="'+i+'"><div class="cli-av" style="background:#dcfce7;color:#15803d">'+esc(cliIni(cv.nome||'W'))+'</div>'+
          '<div class="cli-tx"><div class="cli-nm">'+nome+' <span class="mt-badge">WHATSAPP</span></div>'+
          '<div class="cli-sb">'+fone+'</div>'+ult+'</div><div class="cli-chev">'+_icoChev+'</div></div>';
      }
    });
    return h;
  }
  var _orfaCache=[];
  async function _orfaCriar(cv){
    try{
      var tel=String(cv.telefone||'').replace(/\D/g,'');
      if(tel.length>11 && tel.slice(0,2)==='55') tel=tel.slice(2);
      var ins={ user_id:meuId, nome:(String(cv.nome||'').trim()||'Cliente do WhatsApp'),
        telefone:tel||null, origem:'WhatsApp', etapa:'chat',
        anotacoes:[{t:'Cadastrado a partir da conversa do WhatsApp', ts:new Date().toISOString()}] };
      var r=await supa.from('clientes').insert(ins).select().single();
      if(r&&r.error) throw r.error;
      if(r&&r.data) _clientes.push(r.data);
      toast('Cliente criado a partir da conversa ✓');
      return (r&&r.data)||null;
    }catch(e){ toast('Não consegui cadastrar. '+((e&&e.message)||'')); return null; }
  }
  function _orfaBind(el, crm){
    Array.prototype.forEach.call(el.querySelectorAll('[data-orfa]'),function(card){
      card.onclick=async function(){
        var cv=_orfaCache[+card.getAttribute('data-orfa')]||null; if(!cv) return;
        card.style.opacity='.5';
        var novo=await _orfaCriar(cv);
        if(novo){
          _crmFichaAba='chat';
          if(crm){ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); crmFichaAbrir(novo.id); }
          else { cliPinta((($('cliBusca')||{}).value)||''); cliAbrirFicha(novo.id); }
        } else card.style.opacity='';
      };
    });
  }

  /* v397 (pedido): a fita de etiquetas virou UM DROPDOWN (mesma roupa do
     "Ordenar") com a contagem em cada opção. Etapas e números são os mesmos
     de antes — só a apresentação mudou. */
  function crmPintaEtapas(){
    var el=$('crmEtapas'); if(!el) return;
    /* 🔴 v528: "Todos" tem que bater com o número de LINHAS. Depois que a
       lista passou a esconder quem já comprou (e os perdidos/repasses), um
       "Todos (107)" em cima de 31 linhas seria a tela mentindo — e é
       exatamente o tipo de mentira que faz alguém achar que perdeu dado.
       As contagens POR ETAPA continuam inteiras: elas dizem o que você vai
       ver AO ESCOLHER aquela etapa, e escolher manda em tudo. */
    var _vis=_clientes;
    try{ if(typeof leadNaLista==='function') _vis=_clientes.filter(function(c){ return leadNaLista(c,''); }); }catch(_){ _vis=_clientes; }
    var tot=_vis.length + _chatOrfas().length;   /* v335: conta as conversas sem ficha */
    chatDisponivel();
    var ops=[['','Todos',tot]];
    CRM_ETAPAS.forEach(function(e){
      if(e[0]==='chat' && _chatTem!==true) return;   /* v401: sem atendente, sem etapa Chat */
      var n=_clientes.filter(function(c){ return c.etapa===e[0]; }).length;
      if(e[0]==='chat' && _chatResumo){
        var pend=0; _clientes.forEach(function(c){ var cv=_chatDe(c); if((cv&&cv.nao_lidas>0)||c.etapa==='chat') pend++; });
        _chatOrfas().forEach(function(cv){ if(cv.nao_lidas>0) pend++; });   /* v335 */
        n=pend;
      }
      ops.push([e[0],e[1],n]);
    });
    el.innerHTML='<select class="crm-ord crm-fsel" id="crmEtSel" aria-label="Filtrar clientes por etapa">'+
      ops.map(function(o){ return '<option value="'+o[0]+'"'+(_crmEtapa===o[0]?' selected':'')+'>'+esc(o[1])+' ('+o[2]+')</option>'; }).join('')+'</select>';
    var s=$('crmEtSel'); if(s) s.onchange=function(){ _crmEtapa=this.value||''; crmPintaLista((($('cliBusca')||{}).value)||''); };
  }
  /* ===== v404 (pedido) — LISTA EM TABELA NO COMPUTADOR ===================
     Uma coluna só, formato de tabela: nome · telefone · veículo · faixa de
     valor · faixa de parcela · tempo sem ação · etiqueta · agendamento ·
     WhatsApp (abre o WhatsApp Web). Clicar na linha abre a ficha em página
     cheia (Chat · Histórico · Cadastro). No celular seguem os cards. */
  function _crmSemAcaoTxt(c){
    var d=(Date.now()-(Date.parse(c.atualizado_em||c.criado_em||'')||0))/864e5;
    if(!isFinite(d)||d<0) return ['—',false];
    if(d<1) return ['hoje',false];
    var n=Math.floor(d);
    return [n+(n===1?' dia':' dias'), n>7];
  }
  /* ===== v417 (pedido) — ORDENAR E FILTRAR A TABELA POR COLUNA ==========
     Clicar no TÍTULO ordena (clicou de novo, inverte — a setinha mostra);
     a linha de baixo do cabeçalho tem um campo de FILTRO por coluna
     (digita, a tabela encolhe na hora). Tudo em memória, sobre a lista já
     carregada — nada muda no banco nem no celular (que segue nos cards). */
  /* v428: exc[coluna] = lista de valores DESMARCADOS no painel estilo Excel */
  var _crmTbl={ord:'',dir:1,f:{},exc:{}};
  var _crmTblFoco='';
  var _crmTblBase=[];   /* v428: a lista ANTES dos filtros de coluna (base do painel) */
  var _CRMT_COLS=[['nome','Cliente'],['telefone','Telefone'],['interesse','Veículo de interesse'],['temp','Temperatura'],['sem','Sem ação'],['etapa','Etiqueta'],['agenda','Agendamento']];
  /* ===== v522 — A COLUNA "ATENDENTE" (PROJETO-coluna-do-atendente-e-chat)
     Ela NÃO entra na lista fixa acima: só existe pro DONO da loja. Pro
     vendedor a RLS da carteira (v484) já devolve só os clientes dele — a
     coluna mostraria o nome dele em toda linha, ocupando espaço à toa.
     ⚠️ Esconder a coluna não é segurança: a segurança está na RLS. Aqui é
     arrumação de tela, que é a regra da casa (mínimo na tela).
     Fica NO FIM, antes dos botões: é informação de gestão, não o que se lê
     primeiro numa linha. */
  function _crmtCols(){
    var cols=_CRMT_COLS.slice();
    if(typeof atNomeDe==='function' && typeof _cliEhDono==='function' && _cliEhDono()) cols.push(['dono','Atendente']);
    return cols;
  }
  /* v417 (pedido): telefone SEMPRE no mesmo formato — (xx) xxxxx-xxxx.
     Tira o 55 do DDI, põe DDD entre parênteses e o traço. Número torto
     (curto/estrangeiro) aparece como veio — melhor que esconder. */
  function _crmFoneFmt(t){
    var d=String(t||'').replace(/\D/g,'');
    if(!d) return String(t||'');
    if((d.length===12||d.length===13)&&d.slice(0,2)==='55') d=d.slice(2);
    if(d.length===11) return '('+d.slice(0,2)+') '+d.slice(2,7)+'-'+d.slice(7);
    if(d.length===10) return '('+d.slice(0,2)+') '+d.slice(2,6)+'-'+d.slice(6);
    return String(t||'');
  }
  /* o texto que a coluna MOSTRA (o filtro compara com o que se vê) */
  /* ===== v458 — TEMPERATURA DO CLIENTE (quente/morno/frio) ===============
     Vive no jsonb `extra.temperatura` (sem SQL); o boolean `quente` antigo
     continua em dia (true so quando temperatura = quente) pro fogo da ficha
     nao desandar. Clicar na celula gira: — → quente → morno → frio → —. */
  function _crmTempDe(c){ return (c&&c.extra&&c.extra.temperatura)||((c&&c.quente)?'quente':''); }
  function _crmTempTxt(t){ return t==='quente'?'🔥🔥🔥🔥🔥':(t==='morno'?'🔥🔥🔥':(t==='frio'?'🧊':'—')); }
  async function crmTempCiclo(c){
    var ordem=['','quente','morno','frio'];
    var t=ordem[(ordem.indexOf(_crmTempDe(c))+1)%ordem.length];
    var ex=Object.assign({},c.extra||{}); if(t) ex.temperatura=t; else delete ex.temperatura;
    await crmSalvaCampo(c.id,{extra:ex,quente:t==='quente'});
  }
  function _crmTblTxt(c,col){
    if(col==='nome') return String(c.nome||'');
    if(col==='telefone') return _crmFoneFmt(c.telefone);
    if(col==='interesse') return String(c.interesse||'');
    if(col==='temp') return _crmTempDe(c)||'';
    if(col==='sem') return _crmSemAcaoTxt(c)[0];
    if(col==='etapa'){ var e=crmEtapaInfo(c.etapa); return e?e[1]:''; }
    /* v458 (pedido): a coluna mostra a DATA e O QUE foi agendado */
    if(col==='agenda'){ try{ var a9=crmAgendaAtual(c); return a9?(histData(Date.parse(a9.em))+' · '+crmAgendaInfo(a9.tipo).t):''; }catch(_){ return ''; } }
    /* v522: o texto do atendente — nome → email → "Fora da equipe".
       🔴 NUNCA o UUID. O filtro da coluna compara com o que se VÊ, então é
       por aqui que dá pra filtrar "Fora da equipe" e achar as 12 fichas
       órfãs de uma vez. */
    if(col==='dono'){ return (typeof atNomeDe==='function')?atNomeDe(c.user_id):''; }
    return '';
  }
  /* o valor que a coluna ORDENA (número ordena como número) */
  function _crmTblVal(c,col){
    if(col==='temp'){ return {quente:3,morno:2,frio:1}[_crmTempDe(c)]||0; }
    if(col==='agenda'){ try{ var av=crmAgendaAtual(c); return av?(Date.parse(av.em)||0):0; }catch(_){ return 0; } }
    if(col==='sem') return Date.now()-(Date.parse(c.atualizado_em||c.criado_em||'')||0);
    if(col==='telefone') return String(c.telefone||'').replace(/\D/g,'');
    return String(_crmTblTxt(c,col)||'').toLowerCase();
  }
  function _crmTblTemFiltro(){
    return Object.keys(_crmTbl.f).some(function(k){ return String(_crmTbl.f[k]||'').trim(); })
      || Object.keys(_crmTbl.exc||{}).some(function(k){ return (_crmTbl.exc[k]||[]).length; });
  }
  /* ===== v428 (pedido) - FILTRO ESTILO EXCEL NA TABELA =====================
     Clicar no campo "Filtrar..." de uma coluna abre uma listinha flutuante com
     TODOS os valores daquela coluna (com a contagem), cada um numa caixinha
     marcada. Desmarcou, a linha some. O texto digitado continua filtrando
     junto - os dois se somam.
     /!\ O painel mora no BODY (position:fixed): a crmPintaLista REDESENHA a
     tabela inteira a cada tecla, entao um painel pendurado dentro do <th>
     morreria no meio do uso. */
  function _crmFltValor(c,col){ return String(_crmTblTxt(c,col)||'\u2014').trim()||'\u2014'; }
  function _crmFltFechar(){ var pn=$('crmFltPanel'); if(pn) pn.remove(); }
  function _crmFltPanel(inp){
    var col=inp.getAttribute('data-col'); if(!col) return;
    var aberto=$('crmFltPanel');
    if(aberto && aberto.getAttribute('data-col')===col) return;   /* ja esta aberto nesta coluna */
    _crmFltFechar();
    /* os valores saem da lista SEM os filtros de coluna (senao a propria
       coluna esconderia as opcoes que voce acabou de desmarcar) */
    var base=(_crmTblBase&&_crmTblBase.length)?_crmTblBase:_clientes;
    var vals={};
    base.forEach(function(c){ var v=_crmFltValor(c,col); vals[v]=(vals[v]||0)+1; });
    var nomes=Object.keys(vals).sort(function(a,b){
      if(a==='\u2014') return 1; if(b==='\u2014') return -1;
      return a.localeCompare(b,'pt-BR',{sensitivity:'base',numeric:true});
    });
    var ex=_crmTbl.exc[col]||[];
    var pn=document.createElement('div'); pn.id='crmFltPanel'; pn.className='ct-fpanel'; pn.setAttribute('data-col',col);
    pn.innerHTML='<label class="ct-fitem ct-fall"><input type="checkbox" id="ctFpAll"'+(ex.length?'':' checked')+'><b>(Marcar tudo)</b></label>'+
      '<div class="ct-fscroll">'+nomes.map(function(v){
        return '<label class="ct-fitem"><input type="checkbox" data-v="'+esc(v)+'"'+(ex.indexOf(v)>=0?'':' checked')+'><span>'+esc(v)+'</span><i>'+vals[v]+'</i></label>';
      }).join('')+'</div>'+
      '<div class="ct-facts"><button type="button" id="ctFpLimpa">Limpar filtro da coluna</button></div>';
    document.body.appendChild(pn);
    var r=inp.getBoundingClientRect();
    pn.style.left=Math.max(8,Math.min(r.left,window.innerWidth-pn.offsetWidth-8))+'px';
    pn.style.top=Math.min(r.bottom+6,window.innerHeight-pn.offsetHeight-8)+'px';
    function aplica(){
      var novos=[];
      Array.prototype.forEach.call(pn.querySelectorAll('.ct-fscroll input[data-v]'),function(cb){ if(!cb.checked) novos.push(cb.getAttribute('data-v')); });
      _crmTbl.exc[col]=novos;
      var all2=$('ctFpAll'); if(all2) all2.checked=!novos.length;
      crmPintaLista((($('cliBusca')||{}).value)||'');
    }
    Array.prototype.forEach.call(pn.querySelectorAll('.ct-fscroll input[data-v]'),function(cb){ cb.onchange=aplica; });
    var all=$('ctFpAll');
    if(all) all.onchange=function(){
      var liga=all.checked;
      Array.prototype.forEach.call(pn.querySelectorAll('.ct-fscroll input[data-v]'),function(cb){ cb.checked=liga; });
      aplica();
    };
    var lp=$('ctFpLimpa');
    if(lp) lp.onclick=function(){
      _crmTbl.exc[col]=[]; _crmTbl.f[col]='';
      _crmFltFechar();
      crmPintaLista((($('cliBusca')||{}).value)||'');
    };
  }
  document.addEventListener('mousedown',function(e){
    var pn=$('crmFltPanel'); if(!pn) return;
    if(pn.contains(e.target)) return;
    if(e.target.closest && e.target.closest('.ct-flt')) return;
    _crmFltFechar();
  },true);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') _crmFltFechar(); });
  /* rolou a pagina? o painel e' FIXO — ficaria solto no meio da tela.
     (a rolagem DE DENTRO do proprio painel nao conta) */
  window.addEventListener('scroll',function(e){
    var pn=$('crmFltPanel'); if(!pn) return;
    if(e.target && e.target.nodeType===1 && pn.contains(e.target)) return;
    _crmFltFechar();
  },true);
  /* ===== v429 (pedido) — IMPORTAR E EXPORTAR CLIENTES =====================
     Arquivo CSV separado por ponto-e-vírgula e com BOM: é o que o Excel
     brasileiro abre com dois cliques, com os acentos certos.
     - Exportar leva os clientes QUE ESTÃO NA TELA (respeita busca, etiqueta
       e os filtros de coluna). Sem filtro nenhum, leva todos.
     - Importar casa pelo TELEFONE (DDD + os 8 últimos dígitos, pra não
       tropeçar no nono dígito): quem já existe só tem os campos EM BRANCO
       preenchidos — nome, histórico e etiqueta de quem está no app nunca
       são atropelados. */
  var _crmListaVista=[];
  var _CSV_COLS=[
    ['Nome',                 function(c){ return c.nome||''; }],
    ['Telefone',             function(c){ return c.telefone?_crmFoneFmt(c.telefone):''; }],
    ['Cidade',               function(c){ return c.cidade||''; }],
    ['UF',                   function(c){ return c.uf||''; }],
    ['Veiculo de interesse', function(c){ return c.interesse||''; }],
    ['Faixa de preco',       function(c){ return c.faixa_preco||''; }],
    ['Faixa de parcela',     function(c){ return c.faixa_parcela||''; }],
    ['Origem',               function(c){ return c.origem||''; }],
    ['Etiqueta',             function(c){ var e=crmEtapaInfo(c.etapa); return e?e[1]:''; }],
    ['E-mail',               function(c){ return c.email||''; }],
    ['CPF',                  function(c){ return c.cpf||''; }],
    ['Cadastrado em',        function(c){ try{ return c.criado_em?new Date(c.criado_em).toLocaleDateString('pt-BR'):''; }catch(_){ return ''; } }]
  ];
  function _csvCampo(v){
    var t=(v==null?'':String(v));
    return /[";\n\r]/.test(t) ? ('"'+t.replace(/"/g,'""')+'"') : t;
  }
  function crmExportarCsv(){
    var lista=(_crmListaVista&&_crmListaVista.length)?_crmListaVista:_clientes;
    if(!lista.length){ toast('Nenhum cliente pra exportar.'); return; }
    var linhas=[_CSV_COLS.map(function(k){ return _csvCampo(k[0]); }).join(';')];
    lista.forEach(function(c){ linhas.push(_CSV_COLS.map(function(k){ return _csvCampo(k[1](c)); }).join(';')); });
    var d=new Date(), dia=('0'+d.getDate()).slice(-2), mes=('0'+(d.getMonth()+1)).slice(-2);
    try{
      var blob=new Blob(['\ufeff'+linhas.join('\r\n')],{type:'text/csv;charset=utf-8;'});
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);
      a.download='clientes-'+d.getFullYear()+'-'+mes+'-'+dia+'.csv';
      document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(a.href); a.remove(); }catch(_){} },1500);
      toast(lista.length+' cliente'+(lista.length===1?'':'s')+' no arquivo \u2713');
    }catch(e){ toast('N\u00e3o consegui gerar o arquivo.'); }
  }
  /* --- leitura do CSV (aguenta aspas, ponto-e-vírgula, vírgula e tabulação) --- */
  function _csvSep(txt){
    var l1=String(txt||'').split(/\r?\n/)[0]||'';
    var pv=(l1.match(/;/g)||[]).length, vg=(l1.match(/,/g)||[]).length, tb=(l1.match(/\t/g)||[]).length;
    if(tb>pv && tb>vg) return '\t';
    return (vg>pv)?',':';';
  }
  function _csvLinhas(txt,sep){
    var out=[], linha=[], campo='', aspas=false;
    txt=String(txt||'').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
    for(var i=0;i<txt.length;i++){
      var ch=txt.charAt(i);
      if(aspas){
        if(ch==='"'){ if(txt.charAt(i+1)==='"'){ campo+='"'; i++; } else aspas=false; }
        else campo+=ch;
      }
      else if(ch==='"') aspas=true;
      else if(ch===sep){ linha.push(campo); campo=''; }
      else if(ch==='\n'){ linha.push(campo); out.push(linha); linha=[]; campo=''; }
      else campo+=ch;
    }
    if(campo!=='' || linha.length){ linha.push(campo); out.push(linha); }
    return out.filter(function(l){ return l.some(function(x){ return String(x).trim(); }); });
  }
  function _csvChave(s){
    var t=String(s||'').toLowerCase();
    try{ t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    return t.replace(/[^a-z0-9]/g,'');
  }
  var _CSV_DE={
    nome:['nome','cliente','nomedocliente','nomecompleto','razaosocial','nomerazaosocial'],
    telefone:['telefone','celular','whatsapp','fone','tel','telefone1','telefonecelular','contato','numero'],
    cidade:['cidade','municipio'],
    uf:['uf','estado'],
    interesse:['veiculodeinteresse','interesse','veiculo','modelo','carro','veiculointeresse'],
    faixa_preco:['faixadepreco','faixadevalor','valor','preco','faixapreco','valordoveiculo'],
    faixa_parcela:['faixadeparcela','parcela','faixaparcela','valordaparcela'],
    origem:['origem','origemdolead','fonte','midia','canal'],
    email:['email','emails','enderecodeemail'],
    cpf:['cpf','cpfcnpj','documento','cnpj'],
    etapa:['etiqueta','etapa','situacao','status'],
    obs:['observacao','observacoes','obs','anotacoes','anotacao','comentario']
  };
  /* DDD + os 8 últimos dígitos: (51) 9999-0001 e (51) 99999-0001 casam */
  function _crmFoneChave(t){
    var d=String(t||'').replace(/\D/g,'');
    if(d.length>11 && d.slice(0,2)==='55') d=d.slice(2);
    if(d.length<8) return '';
    return (d.length>=10 ? d.slice(0,2) : '')+'|'+d.slice(-8);
  }
  function _crmEtapaDe(txt){
    var k=_csvChave(txt); if(!k) return null;
    var achou=null;
    CRM_ETAPAS.forEach(function(e){ if(!achou && (_csvChave(e[0])===k || _csvChave(e[1])===k)) achou=e[0]; });
    return achou;
  }
  /* 🔴 v779 — O _crmInt SAIU DAQUI. Ele era declarado neste arquivo E no
     12g-crm-salvamento.js, com o MESMO corpo. Como os dois vivem no mesmo
     IIFE e o 12g vem depois na ordem do montador, quem rodava era sempre a
     do 12g — a daqui era código morto, e o MAPA-GERADO.md apontava as duas.
     É a mesma armadilha das quatro do Facebook Ads (ver a v779 no
     14-estoque.js): editar a função errada, montar, publicar e não ver
     mudança nenhuma. 👉 Ela mora no 12g-crm-salvamento.js.
     ⚠️ As chamadas logo abaixo (faixa_preco / faixa_parcela do importador de
     CSV) continuam funcionando iguais: passam a usar a do 12g, que é
     idêntica linha por linha. */
  async function crmImportarCsv(arq){
    if(!arq) return;
    var txt='';
    try{ txt=await arq.text(); }catch(_){ toast('N\u00e3o consegui ler o arquivo.'); return; }
    /* Excel do Windows às vezes salva em ANSI — se vier com caractere quebrado, relê */
    if(txt.indexOf('\ufffd')>=0){
      try{ txt=new TextDecoder('windows-1252').decode(await arq.arrayBuffer()); }catch(_){}
    }
    txt=txt.replace(/^\ufeff/,'');
    var sep=_csvSep(txt), linhas=_csvLinhas(txt,sep);
    if(linhas.length<2){ toast('O arquivo n\u00e3o tem clientes.'); return; }
    var cab=linhas[0].map(_csvChave), col={};
    Object.keys(_CSV_DE).forEach(function(campo){
      for(var i=0;i<cab.length;i++){ if(_CSV_DE[campo].indexOf(cab[i])>=0){ col[campo]=i; break; } }
    });
    if(col.nome==null && col.telefone==null){
      toast('N\u00e3o achei as colunas Nome ou Telefone nesse arquivo.'); return;
    }
    var porFone={}, porCpf={};
    _clientes.forEach(function(c){
      var f=_crmFoneChave(c.telefone); if(f) porFone[f]=c;
      var p=String(c.cpf||'').replace(/\D/g,''); if(p.length>=11) porCpf[p]=c;
    });
    function celula(l,campo){ return (col[campo]==null)?'':String(l[col[campo]]||'').trim(); }
    var novos=[], mudar=[], iguais=0;
    linhas.slice(1).forEach(function(l){
      var nome=celula(l,'nome'), fone=celula(l,'telefone').replace(/\D/g,'');
      if(fone.length>11 && fone.slice(0,2)==='55') fone=fone.slice(2);
      var cpf=celula(l,'cpf').replace(/\D/g,'');
      if(!nome && !fone) return;
      var d={ nome:nome||'Cliente', telefone:fone||null, email:celula(l,'email')||null,
        cpf:(cpf.length>=11?cpf:null), cidade:celula(l,'cidade')||null,
        uf:(celula(l,'uf').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2))||null,
        interesse:celula(l,'interesse')||null, faixa_preco:_crmInt(celula(l,'faixa_preco')),
        faixa_parcela:_crmInt(celula(l,'faixa_parcela')), origem:celula(l,'origem')||null,
        etapa:_crmEtapaDe(celula(l,'etapa')), obs:celula(l,'obs')||null };
      var ja=(fone&&porFone[_crmFoneChave(fone)])||(d.cpf&&porCpf[d.cpf])||null;
      if(!ja){ novos.push(d); return; }
      var patch={};
      Object.keys(d).forEach(function(k){
        if(d[k]==null || d[k]==='') return;
        var atual=ja[k];
        if(atual==null || String(atual).trim()==='') patch[k]=d[k];
      });
      if(Object.keys(patch).length) mudar.push({id:ja.id, patch:patch}); else iguais++;
    });
    if(!novos.length && !mudar.length){
      toast(iguais?('Esses '+iguais+' clientes j\u00e1 est\u00e3o cadastrados.'):'N\u00e3o achei nenhum cliente no arquivo.');
      return;
    }
    var aviso='Achei '+(novos.length+mudar.length+iguais)+' clientes no arquivo.\n\n'+
      '\u2022 '+novos.length+' pra cadastrar\n'+
      '\u2022 '+mudar.length+' j\u00e1 cadastrados (vou preencher s\u00f3 o que est\u00e1 em branco)'+
      (iguais?('\n\u2022 '+iguais+' sem nada novo'):'')+'\n\nPosso continuar?';
    if(!confirm(aviso)) return;
    var btn=$('crmImportar'); if(btn){ btn.disabled=true; }
    var criados=0, atualizados=0, falhas=0;
    try{
      for(var i=0;i<novos.length;i+=200){
        var lote=novos.slice(i,i+200).map(function(d){
          return Object.assign({}, d, { user_id:meuId,
            anotacoes:[{t:'Importado de arquivo CSV', ts:new Date().toISOString()}] });
        });
        var r=await supa.from('clientes').insert(lote).select();
        if(r&&r.error) throw r.error;
        criados+=((r&&r.data)||[]).length;
      }
      for(var j=0;j<mudar.length;j++){
        var m=mudar[j];
        var r2=await supa.from('clientes').update(Object.assign({},m.patch,{atualizado_em:new Date().toISOString()})).eq('id',m.id);
        if(r2&&r2.error) falhas++; else atualizados++;
      }
      await cliCarregar();
      crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||'');
      toast(criados+' cadastrados \u00b7 '+atualizados+' atualizados'+(falhas?(' \u00b7 '+falhas+' com erro'):'')+' \u2713');
    }catch(e){
      toast('Deu erro na importa\u00e7\u00e3o. '+((e&&e.message)||''));
    }
    if(btn){ btn.disabled=false; }
  }
  /* apaga pela lixeira da tabela e repinta o CRM (o cliApagar repinta a lista antiga) */
  async function crmApagarCliente(c){
    if(!c) return;
    await cliApagar(c.id);
    if(String(_crmSel)===String(c.id)){
      _crmSel=null; crmFichaFechar();
      var fx=$('crmFicha'); if(fx) fx.innerHTML='<div class="cli-empty" style="margin-top:40px"><b>Escolha um cliente</b></div>';
    }
    crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||'');
  }
  function crmTabelaHtml(lista){
    /* v522: uma pergunta só pra tabela inteira, não uma por linha */
    var _cols=_crmtCols();
    var _temDono=_cols.some(function(x){ return x[0]==='dono'; });
    var linhas=lista.map(function(c){
      var et=crmEtapaInfo(c.etapa), wa=cliWhatsUrl(c.telefone);
      var sem=_crmSemAcaoTxt(c);
      var ag='';
      /* v458 (pedido): a celula mostra a DATA e O QUE foi agendado */
      try{ var _a9=crmAgendaAtual(c);
        ag=_a9?('<span class="ct-pill ag" title="'+esc(crmAgendaInfo(_a9.tipo).t+' · '+crmAgendaDataTexto(_a9.em)+(_a9.obs?(' — '+_a9.obs):''))+'">'+esc(histData(Date.parse(_a9.em))+' · '+crmAgendaInfo(_a9.tipo).t)+'</span>'):''; }catch(_){ ag=''; }
      return '<tr data-id="'+esc(c.id)+'">'+
        /* v417: nome, veículo e faixas são EDITÁVEIS na própria célula */
        /* v517 (pedido: "mostrar contato duplicado NOS CLIENTES"): a etiqueta
           tem que dar pra ver na própria lista, não só num botão escondido.
           ⚠️ Discreta MESMO — cinza, pequena, sem ícone. A linha já tem
           etiqueta de etapa e de temperatura; mais uma gritando deixa a
           tabela ilegível, e a regra da casa é mínimo de informação na tela. */
        '<td class="ct-nm ct-ed" data-campo="nome" title="Editar o nome">'+esc(c.nome||'(sem nome)')+
          ((typeof crmRepetidoDe==='function' && crmRepetidoDe(c))
            ? ('<button type="button" class="ct-rep" data-rep="'+esc(crmRepetidoDe(c))+'" title="Este telefone está em mais de um cadastro">repetido</button>') : '')+
        '</td>'+
        /* v419 (pedido): o telefone também edita na célula, e o botão do
           WhatsApp mora AQUI, do lado do número (a FICHA abre pelo
           "Sem ação" ou pelo ícone de histórico) */
        '<td class="ct-ed ct-tel" data-campo="telefone" title="Editar o telefone">'+esc(c.telefone?_crmFoneFmt(c.telefone):'—')+
          (wa?('<button type="button" class="ct-wa" data-wa="'+esc(wa)+'" title="WhatsApp Web" aria-label="Chamar '+esc(c.nome||'cliente')+' no WhatsApp">'+_icoWa+'</button>'):'')+
          (c.telefone?('<button type="button" class="ct-cp" data-cp="'+esc(_crmFoneFmt(c.telefone))+'" title="Copiar o telefone" aria-label="Copiar o telefone de '+esc(c.nome||'cliente')+'">'+_ICO_COPIA+'</button>'):'')+'</td>'+
        '<td class="ct-ed" data-campo="interesse" title="Editar o veículo de interesse">'+esc(c.interesse||'—')+'</td>'+
        '<td class="ct-temp" title="Mudar a temperatura (quente · morno · frio)">'+_crmTempTxt(_crmTempDe(c))+'</td>'+
        '<td><span class="ct-sem'+(sem[1]?' velho':'')+'">'+esc(sem[0])+'</span></td>'+
        /* v417: etiqueta e agendamento são CLICÁVEIS na própria célula */
        '<td class="ct-cet" title="Mudar etiqueta">'+(et?('<span class="ct-pill">'+esc(et[1])+'</span>'):'—')+'</td>'+
        '<td class="ct-cag" title="Agendar">'+(ag||'—')+'</td>'+
        /* v522: quem está atendendo. A célula INTEIRA abre o seletor de
           transferência — é a ação óbvia de quem olha essa coluna. */
        (_temDono?('<td class="ct-dono'+(atForaDaEquipe(c.user_id)?' fora':'')+'" title="Passar para outro vendedor">'+
          '<span class="ct-dn">'+esc(atNomeDe(c.user_id))+'</span></td>'):'')+
        /* v429 (pedido): abrir o cadastro · agendar · apagar
           v522 (pedido): o balão do chat VOLTA — mas só quando há telefone,
           e agora ele abre a conversa de verdade (o de antes não abria) */
        '<td class="ct-acts">'+
          '<button type="button" class="ct-ib" data-act="ver" title="Abrir o cadastro" aria-label="Abrir o cadastro de '+esc(c.nome||'cliente')+'">'+_ICO_OLHO+'</button>'+
          ((typeof atChatBotaoHtml==='function')?atChatBotaoHtml(c):'')+
          '<button type="button" class="ct-ib" data-act="agenda" title="Agendar" aria-label="Agendar com '+esc(c.nome||'cliente')+'">'+_ICO_CAL+'</button>'+
          '<button type="button" class="ct-ib del" data-act="del" title="Apagar cliente" aria-label="Apagar '+esc(c.nome||'cliente')+'">'+_ICO_LIXO+'</button>'+
        '</td>'+
      '</tr>';
    }).join('');
    var head=_cols.map(function(cl){
      var on=(_crmTbl.ord===cl[0]);
      return '<th class="ct-th'+(on?' on':'')+'" data-col="'+cl[0]+'" title="Ordenar por '+esc(cl[1])+'">'+esc(cl[1])+'<span class="ct-seta">'+(on?(_crmTbl.dir>0?'▲':'▼'):'⇅')+'</span></th>';
    }).join('')+'<th></th>';
    var filtros=_cols.map(function(cl){
      var v=_crmTbl.f[cl[0]]||'';
      /* v428: coluna com valores desmarcados fica com a borda azul */
      var fon=(((_crmTbl.exc||{})[cl[0]]||[]).length?' ct-flt-on':'');
      return '<th class="ct-fth"><input class="ct-flt'+fon+'" data-col="'+cl[0]+'" value="'+esc(v)+'" placeholder="Filtrar…" aria-label="Filtrar por '+esc(cl[1])+'"></th>';
    }).join('')+'<th class="ct-fth"></th>';
    return '<table class="crm-tbl"><thead><tr>'+head+'</tr><tr class="ct-frow">'+filtros+'</tr></thead><tbody>'+linhas+'</tbody></table>';
  }
  /* v528: o aviso do topo da lista mora no 12k (a regra e o texto juntos).
     ⚠️ typeof-guard: o 12k é concatenado DEPOIS do 12. Em tempo de execução
     ele já existe, mas o guard mantém o 12 de pé se o arquivo sumir. */
  function _lcAviso(){ try{ return (typeof leadAvisoHtml==='function')?leadAvisoHtml():''; }catch(_){ return ''; } }
  function _lcAvisoBind(el){ try{ if(typeof leadAvisoLiga==='function') leadAvisoLiga(el); }catch(_){} }

  /* ==========================================================================
     v806 (§6) — A LINHA DO RESULTADO: total vivo, chips removíveis, ordem
     ==========================================================================
     📏 O PROBLEMA MEDIDO: a página tinha um seletor de etapa, um botão de
     Filtros com uma bolinha azul e uma busca — e NENHUM dos três dizia
     quantas linhas sobraram nem O QUE estava ligado. Dava pra ficar com
     "Sem ação há mais de 14 dias" ligado desde ontem e achar que a carteira
     tinha esvaziado.
     🔴 A REGRA: tudo o que está filtrando aparece escrito, e cada coisa sai
     com um toque no × dela. Nada de "limpar tudo" como única saída — quem
     quer tirar SÓ a busca não deveria perder a etapa junto.
     ⚠️ O total é o `lista.length` que acabou de virar HTML, não uma segunda
     contagem: duas contagens paralelas é como uma tela começa a mentir. */

  /* v806 (§6, "Card móvel de lead"): a segunda linha do card passou a ser
     TELEFONE · VEÍCULO DE INTERESSE. O veículo é o que o lojista usa pra
     lembrar quem é a pessoa — estava gravado (`interesse`, a mesma coluna
     que a tabela do computador mostra) e não aparecia em lugar nenhum no
     celular. Sem os dois, a linha não vira um "—" solitário: mostra o que
     existe, e o "—" fica só pra ficha realmente sem nada. */
  function _crmSubHtml(c){
    var ps=[];
    if(c&&c.telefone) ps.push(esc(_crmFoneFmt(c.telefone)));
    var v=String((c&&c.interesse)||'').trim();
    if(v) ps.push('<span class="crm-cve">'+esc(v)+'</span>');
    return ps.length?ps.join(' <i>·</i> '):'—';
  }
  /* ===== v806 (§6, "Estados") — os três textos de lista vazia ============
     Um texto por MOTIVO, porque cada um pede uma saída diferente:
       nada cadastrado ....... "Novo lead" (e nunca mais "toque no +": o +
                               saiu da navegação no §5 deste projeto)
       filtro/busca sem nada . "Limpar filtros" — o botão vem da linha de
                               chips logo acima, não de um link solto aqui
       etapa vazia ........... diz que os outros continuam lá */
  function _crmVazioHtml(termo){
    if(!_clientes.length) return 'Nenhum lead ainda — toque em <b>Novo lead</b> pra cadastrar.';
    var temFiltro = !!(termo || _crmEtapa || _crmSemAcao);
    if(temFiltro && (termo || _crmSemAcao)) return 'Nenhum lead encontrado com estes filtros.';
    if(_crmEtapa) return 'Nenhum lead nesta etapa.';
    return 'Nenhum lead nesta lista.';
  }
  /* o botão de limpar dentro do campo de busca */
  function crmBuscaX(){
    var i=$('cliBusca'), b=$('cliBuscaX'); if(!i||!b) return;
    b.hidden = !String(i.value||'').length;
  }
  /* o que está ligado DENTRO da folha "Filtros" — é o que o "(N)" conta */
  function crmFiltrosAtivos(){
    var fs=[];
    if(_crmSemAcao){
      var r=''; CRM_SEM_ACAO.forEach(function(o){ if(o[0]===_crmSemAcao) r=o[1]; });
      fs.push({ k:'semacao', rot:r||'Sem ação', limpa:function(){
        _crmSemAcao=''; var e=$('crmSemAcao'); if(e) e.value='';
      }});
    }
    if(_crmOrd && _crmOrd!=='recente'){
      var ro=''; CRM_ORDENS.forEach(function(o){ if(o[0]===_crmOrd) ro=o[1]; });
      fs.push({ k:'ordem', rot:'Ordem: '+(ro||_crmOrd), limpa:function(){
        _crmOrd='recente'; var e=$('crmOrd'); if(e) e.value='recente';
      }});
    }
    return fs;
  }
  /* TODOS os chips da linha: busca e etapa entram junto com os de cima */
  function crmChipsAtivos(termo){
    var cs=[];
    var t=String(termo||'');
    if(t) cs.push({ k:'busca', rot:'Busca: “'+t+'”', limpa:function(){
      var i=$('cliBusca'); if(i) i.value=''; crmBuscaX();
    }});
    if(_crmEtapa){
      var inf=(typeof crmEtapaInfo==='function')?crmEtapaInfo(_crmEtapa):null;
      cs.push({ k:'etapa', rot:'Etapa: '+((inf&&inf[1])||_crmEtapa), limpa:function(){
        _crmEtapa=''; try{ crmPintaEtapas(); }catch(_){}
      }});
    }
    return cs.concat(crmFiltrosAtivos());
  }
  var _crmChips=[];   /* guarda os `limpa` do último desenho (o × chama daqui) */
  function crmPintaResumo(n, termo){
    var el=$('crmRes'); if(!el) return;
    _crmChips=crmChipsAtivos(termo);
    var ro=''; CRM_ORDENS.forEach(function(o){ if(o[0]===(_crmOrd||'recente')) ro=o[1]; });
    var chips=_crmChips.map(function(c,ix){
      return '<button type="button" class="crm-chip" data-chip="'+ix+'" '+
        'aria-label="Remover filtro: '+esc(c.rot)+'">'+esc(c.rot)+'<i aria-hidden="true">×</i></button>';
    }).join('');
    if(_crmChips.length>1) chips+='<button type="button" class="crm-chip lim" data-chip="tudo">Limpar filtros</button>';
    el.innerHTML='<div class="crm-res-l">'+
        '<span class="crm-res-n"><b>'+n+'</b> '+(n===1?'lead':'leads')+'</span>'+
        '<span class="crm-res-o">'+esc(ro||'Mais recente')+'</span>'+
      '</div>'+(chips?('<div class="crm-res-c">'+chips+'</div>'):'');
    Array.prototype.forEach.call(el.querySelectorAll('[data-chip]'),function(b){
      b.onclick=function(){
        var q=b.getAttribute('data-chip');
        if(q==='tudo') _crmChips.forEach(function(c){ try{ c.limpa(); }catch(_){} });
        else { var c=_crmChips[Number(q)]; if(c){ try{ c.limpa(); }catch(_){} } }
        _crmFiltroDotSeguro();
        crmPintaLista((($('cliBusca')||{}).value)||'');
      };
    });
    _crmFiltroDotSeguro();
  }
  /* o `_crmFiltroDot` mora DENTRO de `telaClientesCrm` (fechamento sobre a
     tela). Daqui de fora chamamos pelo id, sem depender daquele escopo. */
  function _crmFiltroDotSeguro(){
    var b=$('crmFiltrosBt'); if(!b) return;
    var n=crmFiltrosAtivos().length;
    b.classList.toggle('on', n>0);
    b.classList.toggle('tem-n', n>0);
    var sp=$('crmFiltrosN'); if(sp) sp.textContent = n? (' ('+n+')') : '';
  }
  /* ===== v806 (§6) — o ESPELHO do sino, em palavra ==========================
     O botão continua sendo o `pushSinoHtml()`/`pushSinoBind()` do 12b: ele
     é quem liga, desliga e sabe o estado. Aqui só LEMOS o `data-on` que ele
     escreve e traduzimos pra "Ativados"/"Desativados" — porque a cor verde
     não é informação pra quem não a distingue (nem pra quem lê a tela).
     🔴 NADA AQUI PEDE PERMISSÃO: `pushLido()` só consulta
     `Notification.permission`. Pedir sozinho ao abrir a página é o jeito
     mais rápido de ganhar um "bloquear" permanente do navegador. */
  function crmAvisosEspelho(){
    var box=$('crmAvisos'), tx=$('crmAvisosEst'); if(!box||!tx) return;
    var b=document.getElementById('pushSino');
    var impede='';
    try{ if(typeof pushImpedimento==='function') impede=pushImpedimento()||''; }catch(_){}
    if(!b || impede){
      box.classList.add('bloq');
      tx.textContent = impede || 'Não disponível neste aparelho.';
      return;
    }
    box.classList.remove('bloq');
    function le(){
      var v=b.getAttribute('data-on');
      tx.textContent = (v==null) ? 'Verificando…' : ((v==='1')?'Ativados':'Desativados');
    }
    le();
    try{ new MutationObserver(le).observe(b,{attributes:true,attributeFilter:['data-on']}); }catch(_){}
  }
  function crmPintaLista(termo){
    var el=$('crmLista'); if(!el) return;
    _chatResumoCarrega(function(){ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); });
    /* v522: o mapa user_id→nome da coluna "Atendente". Uma consulta só na
       vida da aba; quando chega, repinta uma vez. */
    if(typeof atMembrosGarante==='function') atMembrosGarante(function(){ crmPintaLista((($('cliBusca')||{}).value)||''); });
    termo=(termo||'').toLowerCase().trim(); var td=termo.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(!_clientes.length && _cliErro){ erroLista(el, async function(){ el.innerHTML=skelHtml(5); await cliCarregar(); crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); }); return; }
    var lista=_clientes.filter(function(c){
      /* v322: a etapa "Chat" mostra quem tem conversa PENDENTE no WhatsApp
         (nao lida), alem de quem foi marcado manualmente na etapa. */
      if(_crmEtapa==='chat'){
        var cv=_chatDe(c);
        if(!((cv&&cv.nao_lidas>0)||c.etapa==='chat')) return false;
      } else if(_crmEtapa && c.etapa!==_crmEtapa) return false;
      /* ===== v528 (Fase 3+4 do PROJETO-a-pagina-vira-leads) ==============
         A regra mora no 12k, e é a MESMA `jaComprou` que a página Clientes
         usa do outro lado — é isso que garante que ninguém suma das duas.
         ⚠️ Filtrou por etapa? Manda o filtro. Esconder o que a pessoa
         acabou de pedir seria o pior tipo de esperteza. */
      if(typeof leadNaLista==='function' && !leadNaLista(c, _crmEtapa)) return false;
      /* v401: tempo sem ação (dias desde a última mexida) */
      if(_crmSemAcao){
        var _idle=(Date.now()-(Date.parse(c.atualizado_em||c.criado_em||'')||0))/864e5;
        if(_crmSemAcao==='24h' && _idle<1) return false;
        if(_crmSemAcao==='7d' && (_idle<1||_idle>7)) return false;
        if(_crmSemAcao==='8a14' && (_idle<8||_idle>14)) return false;
        if(_crmSemAcao==='14mais' && _idle<=14) return false;
      }
      if(!termo) return true;
      var okN=String(c.nome||'').toLowerCase().indexOf(termo)>=0;
      var okT=td&&String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').indexOf(td)>=0;
      var okV=String(c.interesse||'').toLowerCase().indexOf(termo)>=0;
      return okN||okT||okV;
    });
    /* ordem escolhida no seletor ao lado da busca (v173) */
    if(_crmOrd==='nome'){
      lista.sort(function(a,b){ return String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR',{sensitivity:'base'}); });
    } else if(_crmOrd==='etapa'){
      var pos={}; CRM_ETAPAS.forEach(function(e,ix){ pos[e[0]]=ix; });
      lista.sort(function(a,b){
        var pa=(a.etapa&&pos[a.etapa]!=null)?pos[a.etapa]:99, pb=(b.etapa&&pos[b.etapa]!=null)?pos[b.etapa]:99;
        if(pa!==pb) return pa-pb;
        return String(b.atualizado_em||b.criado_em||'').localeCompare(String(a.atualizado_em||a.criado_em||''));
      });
    } else {
      lista.sort(function(a,b){ return String(b.atualizado_em||b.criado_em||'').localeCompare(String(a.atualizado_em||a.criado_em||'')); });
    }
    var _orfas=_orfaHtml(termo,true);   /* v335: conversas do WhatsApp sem ficha */
    /* v404: no computador a lista vira TABELA */
    var _desk=window.matchMedia && window.matchMedia('(min-width:980px)').matches;
    if(_desk){
      /* v428: guarda a lista ANTES dos filtros de coluna - e' dela que o
         painel estilo Excel tira os valores e as contagens */
      _crmTblBase=lista.slice();
      /* v417: filtros por coluna (compara com o que a célula MOSTRA) */
      Object.keys(_crmTbl.f).forEach(function(col){
        var t=String(_crmTbl.f[col]||'').toLowerCase().trim(); if(!t) return;
        var tdg=t.replace(/\D/g,'');
        lista=lista.filter(function(c){
          var s=String(_crmTblTxt(c,col)||'').toLowerCase();
          if(col==='telefone'&&tdg) return s.replace(/\D/g,'').indexOf(tdg)>=0;
          return s.indexOf(t)>=0;
        });
      });
      /* v428: e agora o que foi DESMARCADO no painel estilo Excel */
      Object.keys(_crmTbl.exc||{}).forEach(function(col){
        var ex=_crmTbl.exc[col]||[]; if(!ex.length) return;
        lista=lista.filter(function(c){ return ex.indexOf(_crmFltValor(c,col))<0; });
      });
      /* v417: ordenação clicada no título vence a do seletor */
      if(_crmTbl.ord){
        var _col=_crmTbl.ord,_dir=_crmTbl.dir;
        lista.sort(function(a,b){
          var va=_crmTblVal(a,_col), vb=_crmTblVal(b,_col);
          if(typeof va==='number'&&typeof vb==='number') return (va-vb)*_dir;
          /* vazio sempre no fim, em qualquer direção */
          if(!String(va)&&String(vb)) return 1;
          if(String(va)&&!String(vb)) return -1;
          return String(va).localeCompare(String(vb),'pt-BR',{sensitivity:'base',numeric:true})*_dir;
        });
      }
      crmPintaResumo(lista.length, termo);   /* v806 */
      /* sem nada NA BUSCA (sem filtro de coluna ligado): mensagem de sempre.
         Com filtro de coluna ligado, a tabela fica (senão não dá pra limpar). */
      if(!lista.length && !_crmTblTemFiltro()){ el.innerHTML=_lcAviso()+(_orfas?'':'<div class="cli-empty">'+_crmVazioHtml(termo)+'</div>')+_orfas+_mtHtml(termo,true); _lcAvisoBind(el); _orfaBind(el,true); _mtBind(el,true); return; }
      _crmListaVista=lista.slice();   /* v429: é esta que o Exportar leva */
      el.innerHTML=_lcAviso()+crmTabelaHtml(lista)+_orfas+_mtHtml(termo,true);
      _lcAvisoBind(el);
      _orfaBind(el,true);
      Array.prototype.forEach.call(el.querySelectorAll('.crm-tbl tbody tr'),function(tr){
        tr.onclick=function(e){
          if(e.target.closest && e.target.closest('.ct-wa')) return;
          if(e.target.closest && e.target.closest('.ct-cp')) return;   /* v458: copiar nao abre a ficha */
          /* v517: a etiqueta "repetido" abre a tela JÁ NAQUELE GRUPO */
          var _rp=e.target.closest && e.target.closest('.ct-rep');
          if(_rp){ if(typeof crmRepetidosAbrir==='function') crmRepetidosAbrir(_rp.getAttribute('data-rep')); return; }
          var _tp=e.target.closest && e.target.closest('.ct-temp');
          /* v516 (pedido do Angelo): um toque ABRE AS 3 OPÇÕES, em vez de
             girar de degrau em degrau gravando a cada toque. O
             `crmTempCiclo` continua no arquivo, escondido — se o picker der
             problema no celular, o ciclo volta trocando esta linha. */
          if(_tp){ var _ct=_clientes.filter(function(x){return String(x.id)===String(tr.getAttribute('data-id'));})[0];
                   if(_ct){ if(typeof crmTempPicker==='function') crmTempPicker(_ct); else crmTempCiclo(_ct); } return; }
          if(e.target.closest && e.target.closest('.ct-edin')) return;   /* já editando */
          var id=tr.getAttribute('data-id');
          var c=_clientes.filter(function(x){return String(x.id)===String(id);})[0];
          var ed=e.target.closest && e.target.closest('.ct-ed');
          if(ed && c){ _crmTblEdita(ed,c,ed.getAttribute('data-campo')); return; }   /* v417: edição na célula */
          if(e.target.closest && e.target.closest('.ct-cet')){ if(c) crmEtapaPicker(c); return; }   /* v417 */
          if(e.target.closest && e.target.closest('.ct-cag')){ if(c) crmAgendar(c); return; }       /* v417 */
          /* v522: a célula do atendente abre o seletor de transferência */
          if(e.target.closest && e.target.closest('.ct-dono')){ if(c && typeof atTransferirAbrir==='function') atTransferirAbrir(c); return; }
          /* v429: os ícones de ação da última coluna */
          var ib=e.target.closest && e.target.closest('.ct-ib');
          if(ib && c){
            var act=ib.getAttribute('data-act');
            if(act==='ver'){ crmFichaAbrir(c.id); return; }
            if(act==='chat'){ if(typeof atChatAbrir==='function') atChatAbrir(c); return; }   /* v522 */
            if(act==='agenda'){ crmAgendar(c); return; }
            if(act==='del'){ crmApagarCliente(c); return; }
          }
          crmFichaAbrir(id);
        };
      });
      /* v417: título ordena (clicou de novo, inverte) */
      Array.prototype.forEach.call(el.querySelectorAll('.crm-tbl th[data-col]'),function(th){
        th.onclick=function(){
          var cl=th.getAttribute('data-col');
          if(_crmTbl.ord===cl) _crmTbl.dir=-_crmTbl.dir; else { _crmTbl.ord=cl; _crmTbl.dir=1; }
          crmPintaLista((($('cliBusca')||{}).value)||'');
        };
      });
      /* v417: campos de filtro — repinta a cada tecla e devolve o cursor */
      Array.prototype.forEach.call(el.querySelectorAll('.ct-flt'),function(inp){
        inp.oninput=function(){
          _crmTbl.f[inp.getAttribute('data-col')]=inp.value;
          _crmTblFoco=inp.getAttribute('data-col');
          crmPintaLista((($('cliBusca')||{}).value)||'');
        };
        /* v428: clicar no campo abre a listinha de valores da coluna */
        inp.onclick=function(e){ e.stopPropagation(); _crmFltPanel(inp); };
      });
      if(_crmTblFoco){
        try{ var _ff=el.querySelector('.ct-flt[data-col="'+_crmTblFoco+'"]'); if(_ff){ _ff.focus(); var _fn=_ff.value.length; _ff.setSelectionRange(_fn,_fn); } }catch(_){}
        _crmTblFoco='';
      }
      Array.prototype.forEach.call(el.querySelectorAll('.ct-wa'),function(bw){
        bw.onclick=function(e){ e.stopPropagation(); var u=bw.getAttribute('data-wa'); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } };
      });
      /* v458 (pedido): copiar o numero direto da tabela */
      Array.prototype.forEach.call(el.querySelectorAll('.ct-cp'),function(bc){
        bc.onclick=function(e){ e.stopPropagation(); var t=bc.getAttribute('data-cp')||''; try{ navigator.clipboard.writeText(t); toast('Telefone copiado.'); }catch(_){ prompt('Telefone:',t); } };
      });
      _mtBind(el,true);
      return;
    }
    crmPintaResumo(lista.length, termo);   /* v806 */
    if(!lista.length){ el.innerHTML=_lcAviso()+(_orfas?'':'<div class="cli-empty">'+_crmVazioHtml(termo)+'</div>')+_orfas+_mtHtml(termo,true); _lcAvisoBind(el); _orfaBind(el,true); _mtBind(el,true); return; }
    _crmListaVista=lista.slice();   /* v429 */
    el.innerHTML=_lcAviso()+lista.map(function(c){
      var et=crmEtapaInfo(c.etapa), wa=cliWhatsUrl(c.telefone);
      return '<div class="crm-card'+(String(c.id)===String(_crmSel)?' sel':'')+'" data-id="'+esc(c.id)+'">'+
        /* v397 (pedido): saiu a etiqueta de temperatura do card (a chama ao
           lado do nome e o botão de "lead quente"). O campo `quente` continua
           existindo e a chama segue na FICHA do cliente (cxFire). */
        '<div class="crm-ctx"><div class="crm-cnm">'+esc(c.nome||'(sem nome)')+'</div>'+
        '<div class="crm-csb">'+_crmSubHtml(c)+'</div>'+_chatLinhaHtml(c)+
        (et?('<span class="crm-cet">'+esc(et[1])+'</span>'):'')+crmAgendaPillHtml(c)+'</div>'+
        /* v598 (tela enxuta): 5 alvos apertados viraram DOIS — WhatsApp (a
           ação nº 1 do lojista) + "⋯" com chat interno · etiqueta · agendar
           dentro. O corpo do card segue abrindo a ficha, como sempre. */
        '<div class="crm-acts">'+
          (wa?('<button type="button" class="crm-a wa" data-wa="'+esc(wa)+'" title="WhatsApp">'+_icoWa+'</button>'):'')+
          '<button type="button" class="crm-a crm-a-mais" data-mais="1" title="Mais ações">⋯</button>'+
        '</div><div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    el.innerHTML += _orfas + _mtHtml(termo,true);
    _lcAvisoBind(el);
    _orfaBind(el,true);
    Array.prototype.forEach.call(el.querySelectorAll('.crm-card:not(.mtc)'),function(card){
      var id=card.getAttribute('data-id');
      var c=_clientes.filter(function(x){return String(x.id)===String(id);})[0];
      card.onclick=function(e){ if(e.target.closest&&e.target.closest('.crm-a')) return; crmFichaAbrir(id); };
      var w=card.querySelector('[data-wa]'); if(w) w.onclick=function(e){ e.stopPropagation(); var u=w.getAttribute('data-wa'); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } };
      /* v598: os antigos data-tag/data-cal/data-chat moram agora no "⋯" —
         os punhos ficam (null-safe) como caminho de volta */
      var t=card.querySelector('[data-tag]'); if(t) t.onclick=function(e){ e.stopPropagation(); crmEtapaPicker(c); };
      var g=card.querySelector('[data-cal]'); if(g) g.onclick=function(e){ e.stopPropagation(); crmAgendar(c); };
      var ch=card.querySelector('[data-chat]'); if(ch) ch.onclick=function(e){ e.stopPropagation(); if(typeof atChatAbrir==='function') atChatAbrir(c); };   /* v522 */
      var mz=card.querySelector('[data-mais]'); if(mz) mz.onclick=function(e){ e.stopPropagation(); _crmCardMais(c); };   /* v598 */
    });
    _mtBind(el,true);
  }
  /* v417 (pedido): editar nome, veículo de interesse e faixas NA CÉLULA.
     Clique vira um campo; Enter/sair salva (crmSalvaCampo repinta tudo);
     Esc desiste. O que você digita é gravado como está — a formatação de
     R$ volta sozinha na repintura (_crmMoney). */
  function _crmTblEdita(td,c,campo){
    try{
      if(!td||td.querySelector('input')) return;
      var atual=String(c[campo]||'');
      td.innerHTML='<input class="ct-edin" aria-label="Editar">';
      var inp=td.querySelector('input'); inp.value=atual;
      inp.focus(); try{ inp.setSelectionRange(atual.length,atual.length); }catch(_){}
      var fim=false;
      async function salva(){
        if(fim) return; fim=true;
        var v=String(inp.value||'').trim();
        if(v===atual.trim()){ crmPintaLista((($('cliBusca')||{}).value)||''); return; }
        var p={}; p[campo]=v||null;
        await crmSalvaCampo(c.id,p);   /* repinta sozinho */
      }
      inp.onblur=salva;
      inp.onkeydown=function(e){
        if(e.key==='Enter'){ e.preventDefault(); inp.blur(); }
        if(e.key==='Escape'){ fim=true; crmPintaLista((($('cliBusca')||{}).value)||''); }
      };
      inp.onclick=function(e){ e.stopPropagation(); };
    }catch(_){}
  }

  /* v429: o MODAL de edição do cadastro (v418/v428) foi removido a pedido —
     o olho da tabela abre a ficha, que já tem os mesmos campos. */

  /* grava um ou mais campos do cliente e repinta o que precisa */
  async function crmSalvaCampo(id, patch){
    /* ===== v516 (B3 do PROJETO-crm-salva-sozinho) — O "SALVO ✓" MENTIROSO
       Isto aqui fazia `update(...)` e confiava no `r.error`. Mas **erro não
       é a mesma coisa que zero linhas**: quando a RLS barra a escrita, o
       PostgREST devolve SUCESSO com nenhuma linha alterada (regra 6 do
       CLAUDE.md, v483). O app entrava no `return true`, escrevia "Salvo ✓"
       em verde e atualizava a lista em memória com um valor que NÃO existe
       no banco — recarregou a página, voltou tudo como estava.
       Deixou de ser teoria na v484: com a carteira do vendedor, quem edita
       cliente de outra carteira recebia o ✓ verde e não salvava nada.
       Agora quem grava é o `_crmGravaConfere` (12g), que pede a linha de
       volta com `.select('id')` e só diz que salvou se ela veio. */
    patch=Object.assign({},patch,{atualizado_em:new Date().toISOString()});
    var res=await _crmGravaConfere('clientes', patch, id);
    if(!res.ok){ toast(_crmMsgErro(res)); return false; }
    var c=_clientes.filter(function(x){return String(x.id)===String(id);})[0]; if(c) Object.assign(c,patch);
    try{ if(c) mtEspelhar(c); }catch(_){}
    crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||'');
    return true;
  }
  /* v598 — o "⋯" do card: as 3 ações que saíram da fileira (chat interno ·
     etiqueta · agendar), na mesma folhinha padrão dos pickers. */
  function _crmCardMais(c){
    if(!c) return;
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:320px"><div class="crop-tit">'+esc((c.nome||'Cliente').split(' ')[0])+'</div>'+
      '<div class="crm-mmenu">'+
      ((c.telefone&&typeof AT_ICO_CHAT!=='undefined')?('<button type="button" class="crm-ab" data-m="chat">'+AT_ICO_CHAT+'Conversa no chat</button>'):'')+
      '<button type="button" class="crm-ab" data-m="tag">'+_ICO_TAG+'Mudar etapa</button>'+
      '<button type="button" class="crm-ab" data-m="cal">'+_ICO_CAL+'Agendar</button>'+
      '</div><button type="button" class="link" data-m="x" style="margin-top:12px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    Array.prototype.forEach.call(ov.querySelectorAll('[data-m]'),function(b){ b.onclick=function(){
      var m=b.getAttribute('data-m'); close();
      if(m==='chat'){ if(typeof atChatAbrir==='function') atChatAbrir(c); }
      else if(m==='tag') crmEtapaPicker(c);
      else if(m==='cal') crmAgendar(c);
    }; });
  }
  function crmEtapaPicker(c){
    if(!c) return;
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:320px;max-height:82vh;overflow:auto"><div class="crop-tit">Etapa de '+esc((c.nome||'cliente').split(' ')[0])+'</div>'+
      '<div class="crm-pick">'+CRM_ETAPAS.map(function(e){ return '<button type="button" class="crm-pi'+(c.etapa===e[0]?' on':'')+'" data-et="'+e[0]+'">'+e[2]+'<span>'+esc(e[1])+'</span></button>'; }).join('')+
      '<button type="button" class="crm-pi" data-et="">'+_cIco('<circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/>')+'<span>Sem etapa</span></button></div>'+
      '<button type="button" class="link" id="cepFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#cepFechar').onclick=close;
    Array.prototype.forEach.call(ov.querySelectorAll('.crm-pi'),function(b){ b.onclick=async function(){
      close(); var et=b.getAttribute('data-et')||null;
      /* v458 (pedido): toda mudanca de etiqueta vai pro HISTORICO; Perdido
         pede o MOTIVO e oferece agendar a proxima acao de recuperacao. */
      var antes=c.etapa||null, mot='';
      if(et==='perdido' && et!==antes) mot=String(prompt('Qual o motivo da perda? (vai pro histórico)')||'').trim();
      await crmSalvaCampo(c.id,{etapa:et});
      if(et!==antes){ var inf=crmEtapaInfo(et); crmObsRegistrar(c.id,'Etiqueta: '+(et?(inf?inf[1]:et):'Sem etapa')+(mot?(' — motivo: '+mot):''),true); }
      if(et==='perdido' && et!==antes && confirm('Agendar uma próxima ação pra tentar recuperar '+esc((c.nome||'o cliente').split(' ')[0])+'?')) crmAgendar(c);
      if(String(_crmSel)===String(c.id)) crmFichaAbrir(c.id);
    }; });
  }
  /* Agenda do CRM — espelha o fluxo do MEVTOOLS, mas guarda os detalhes no
     histórico JSON que esta tabela já possui. Assim não exige coluna ou
     migration nova: data de referência continua em `agendado_em` e tipo,
     observação, situação e etiqueta ficam no evento auditável. */
  var CRM_AGENDAMENTOS=[
    ['retorno','Retorno','Retomar o contato com o cliente',_cIco('<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>')],
    ['followup','Follow up','Acompanhar a negociação',_cIco('<path d="M12 3v5"/><path d="M6.6 5.2l3 4"/><path d="M17.4 5.2l-3 4"/><path d="M4.5 11.5h15"/><path d="M7 20h10"/><path d="M8 11.5a4 4 0 0 0 8 0"/>')],
    ['ligar','Ligar','Fazer uma ligação para o cliente',_ICO_FONE2],
    ['enviar_opcoes','Enviar opções','Enviar veículos ou proposta',_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')],
    ['visita','Agendar visita','Receber o cliente na loja',_ICO_CAL],
    ['best_drive','Agendar Best Drive','Organizar a experiência de direção',_cIco('<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2.5"/><path d="M12 3v6.5M12 14.5V21M3.5 9.5l6 2M20.5 9.5l-6 2"/>')],
    ['evento','Convidar para evento','Registrar convite para feirão ou evento',_cIco('<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>')]
  ];
  function crmAgendaInfo(k){
    for(var i=0;i<CRM_AGENDAMENTOS.length;i++) if(CRM_AGENDAMENTOS[i][0]===k) return {k:CRM_AGENDAMENTOS[i][0],t:CRM_AGENDAMENTOS[i][1],d:CRM_AGENDAMENTOS[i][2],ico:CRM_AGENDAMENTOS[i][3]};
    return {k:'retorno',t:'Retorno',d:'Retomar o contato com o cliente',ico:_ICO_CAL};
  }
  function _crmAgendaPad(n){ return ('0'+n).slice(-2); }
  function crmAgendaDataInput(iso){
    try{ var d=iso?new Date(iso):null; if(!d||isNaN(d.getTime())) return ''; return d.getFullYear()+'-'+_crmAgendaPad(d.getMonth()+1)+'-'+_crmAgendaPad(d.getDate())+'T'+_crmAgendaPad(d.getHours())+':'+_crmAgendaPad(d.getMinutes()); }catch(_){ return ''; }
  }
  function crmAgendaPadrao(){ var d=new Date(); d.setDate(d.getDate()+1); d.setHours(9,0,0,0); return crmAgendaDataInput(d.toISOString()); }
  function crmAgendaDataTexto(iso){
    try{ var d=new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleDateString('pt-BR')+' às '+d.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'}); }catch(_){ return ''; }
  }
  function crmAgendaAtual(c){
    var arr=Array.isArray(c&&c.anotacoes)?c.anotacoes:[];
    for(var i=0;i<arr.length;i++){
      var a=arr[i]||{}, ag=a.crm_agenda;
      if(ag&&ag.estado==='agendado'&&ag.em) return {id:ag.id||'',tipo:ag.tipo||'retorno',em:ag.em,obs:ag.obs||'',etapa_origem:ag.etapa_origem||'',indice:i,legado:false};
    }
    if(c&&c.agendado_em) return {id:'legado',tipo:'retorno',em:c.agendado_em,obs:'',etapa_origem:'',indice:-1,legado:true};
    return null;
  }
  function crmEtiquetasAgenda(c){
    var tags=[], arr=Array.isArray(c&&c.anotacoes)?c.anotacoes:[];
    arr.forEach(function(a){ (a&&a.crm_etiquetas||[]).forEach(function(t){ t=String(t||'').trim(); if(t&&tags.indexOf(t)<0) tags.push(t); }); });
    return tags;
  }
  function crmEtiquetasAgendaHtml(c){
    var tags=crmEtiquetasAgenda(c); if(!tags.length) return '';
    return '<div class="crm-ag-tags" aria-label="Etiquetas do cliente">'+tags.map(function(t){ return '<span>'+esc(t)+'</span>'; }).join('')+'</div>';
  }
  function crmAgendaPillHtml(c){
    var ag=crmAgendaAtual(c); if(!ag) return '';
    var inf=crmAgendaInfo(ag.tipo), vencido=false;
    try{ vencido=new Date(ag.em).getTime()<=Date.now(); }catch(_){}
    return '<span class="crm-cag'+(vencido?' vencido':'')+'" title="'+esc(inf.t+' · '+crmAgendaDataTexto(ag.em))+'">'+inf.ico+'<span>'+esc(inf.t)+' · '+esc(crmAgendaDataTexto(ag.em))+'</span></span>';
  }
  function crmAgendaResumoHtml(c){
    var ag=crmAgendaAtual(c); if(!ag) return '';
    var inf=crmAgendaInfo(ag.tipo), vencido=false;
    try{ vencido=new Date(ag.em).getTime()<=Date.now(); }catch(_){}
    return '<section class="crm-ag-resumo'+(vencido?' vencido':'')+'"><div class="crm-ag-ico">'+inf.ico+'</div><div class="crm-ag-tx"><b>'+esc(inf.t)+'</b><span>'+esc(crmAgendaDataTexto(ag.em))+(ag.obs?(' · '+esc(ag.obs)):'')+'</span></div><div class="crm-ag-acoes"><button type="button" id="cxAgConcluir" title="Marcar como realizado" aria-label="Marcar '+esc(inf.t)+' como realizado">'+_cIco('<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>')+'</button><button type="button" id="cxAgReagendar" title="Reagendar" aria-label="Reagendar '+esc(inf.t)+'">'+_cIco('<polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>')+'</button><button type="button" class="danger" id="cxAgCancelar" title="Cancelar" aria-label="Cancelar '+esc(inf.t)+'">'+_cIco('<circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="15" x2="15" y2="9"/>')+'</button></div></section>';
  }
  function _crmAgendaFechar(ov){ try{ ov.remove(); }catch(_){} }
  function crmAgendaEscolher(c, anterior){
    if(!c) return;
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox crm-agenda-box" role="dialog" aria-modal="true" aria-labelledby="cagTitulo"><div class="crop-tit" id="cagTitulo">'+(anterior?'Reagendar contato':'Agendar contato')+'</div><div class="crop-sub">'+esc(c.nome||'Cliente')+'</div><p class="crm-ag-ajuda">O que você quer agendar?</p><div class="crm-ag-opcoes">'+CRM_AGENDAMENTOS.map(function(a){ return '<button type="button" data-tipo="'+a[0]+'">'+a[3]+'<span><b>'+esc(a[1])+'</b><small>'+esc(a[2])+'</small></span><i aria-hidden="true">›</i></button>'; }).join('')+'</div><button type="button" class="link crm-ag-cancelar" id="cagX">Cancelar</button></div>';
    document.body.appendChild(ov);
    ov.onclick=function(e){ if(e.target===ov) _crmAgendaFechar(ov); };
    var cancelar=ov.querySelector('#cagX'); if(cancelar) cancelar.onclick=function(){ _crmAgendaFechar(ov); };
    Array.prototype.forEach.call(ov.querySelectorAll('[data-tipo]'),function(b){ b.onclick=function(){ var tipo=b.getAttribute('data-tipo'); _crmAgendaFechar(ov); crmAgendar(c,tipo,anterior); }; });
    setTimeout(function(){ var primeiro=ov.querySelector('[data-tipo]'); if(primeiro) primeiro.focus(); },0);
  }
  function crmAgendar(c, tipo, anterior){
    if(!c) return;
    if(!tipo){ crmAgendaEscolher(c,anterior); return; }
    var inf=crmAgendaInfo(tipo), ov=document.createElement('div'); ov.className='cropmask';
    var valor=crmAgendaDataInput((anterior&&anterior.em)||'')||crmAgendaPadrao();
    ov.innerHTML='<div class="cropbox crm-agenda-box" role="dialog" aria-modal="true" aria-labelledby="cagTitulo"><button type="button" class="crm-ag-voltar" id="cagVoltar">‹ Escolher outro tipo</button><div class="crop-tit" id="cagTitulo">'+inf.ico+esc(inf.t)+'</div><div class="crop-sub">'+esc(c.nome||'Cliente')+'</div><div class="crm-ag-form"><label for="cagData">Data e hora</label><input type="datetime-local" class="cad-in" id="cagData" value="'+esc(valor)+'"><label for="cagObs">Observações (opcional)</label><textarea class="cad-in" id="cagObs" rows="2" maxlength="180" placeholder="Ex.: confirmar disponibilidade do veículo">'+esc((anterior&&anterior.obs)||'')+'</textarea></div><button type="button" class="crop-ok crm-ag-salvar" id="cagOk">Agendar '+esc(inf.t)+'</button><button type="button" class="link crm-ag-cancelar" id="cagX">Cancelar</button></div>';
    document.body.appendChild(ov);
    ov.onclick=function(e){ if(e.target===ov) _crmAgendaFechar(ov); };
    ov.querySelector('#cagX').onclick=function(){ _crmAgendaFechar(ov); };
    ov.querySelector('#cagVoltar').onclick=function(){ _crmAgendaFechar(ov); crmAgendaEscolher(c,anterior); };
    ov.querySelector('#cagOk').onclick=async function(){
      var campo=ov.querySelector('#cagData'), v=(campo&&campo.value)||'';
      if(!v){ toast('Escolha data e hora.'); if(campo) campo.focus(); return; }
      var dt=new Date(v); if(isNaN(dt.getTime())){ toast('Informe uma data e hora válidas.'); return; }
      var anteriorAtivo=crmAgendaAtual(c), arr=(Array.isArray(c.anotacoes)?c.anotacoes:[]).map(function(a){ return Object.assign({},a); });
      if(anteriorAtivo&&!anteriorAtivo.legado&&anteriorAtivo.indice>=0&&arr[anteriorAtivo.indice]&&arr[anteriorAtivo.indice].crm_agenda){ arr[anteriorAtivo.indice].crm_agenda=Object.assign({},arr[anteriorAtivo.indice].crm_agenda,{estado:'substituido',encerrado_em:new Date().toISOString()}); }
      var obs=String((ov.querySelector('#cagObs')||{}).value||'').trim().slice(0,180), etapaOrigem=(anteriorAtivo&&anteriorAtivo.etapa_origem)||((c.etapa&&c.etapa!=='agendados')?c.etapa:'');
      var etiquetas=(tipo==='best_drive')?['Best Drive']:[];
      var ag={id:'ag_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,7),tipo:inf.k,em:dt.toISOString(),obs:obs,estado:'agendado',etapa_origem:etapaOrigem};
      arr.unshift({t:inf.t+' agendado para '+crmAgendaDataTexto(ag.em)+(obs?(' · '+obs):''),ts:new Date().toISOString(),crm_agenda:ag,crm_etiquetas:etiquetas});
      var ok=await crmSalvaCampo(c.id,{anotacoes:arr,agendado_em:ag.em,etapa:'agendados'});
      if(!ok) return;
      _crmAgendaFechar(ov); toast(inf.t+' agendado.');
      if(String(_crmSel)===String(c.id)) crmFichaAbrir(c.id);
    };
    setTimeout(function(){ var campo=ov.querySelector('#cagData'); if(campo) campo.focus(); },0);
  }
  async function crmAgendaEncerrar(c, estado){
    var ag=crmAgendaAtual(c); if(!c||!ag){ toast('Não há agendamento ativo.'); return; }
    var inf=crmAgendaInfo(ag.tipo), arr=(Array.isArray(c.anotacoes)?c.anotacoes:[]).map(function(a){ return Object.assign({},a); });
    if(!ag.legado&&ag.indice>=0&&arr[ag.indice]&&arr[ag.indice].crm_agenda){ arr[ag.indice].crm_agenda=Object.assign({},arr[ag.indice].crm_agenda,{estado:estado,encerrado_em:new Date().toISOString()}); }
    var concluido=estado==='realizado', texto=inf.t+(concluido?' realizado':' cancelado');
    arr.unshift({t:texto+(ag.em?(' · previsto para '+crmAgendaDataTexto(ag.em)):''),ts:new Date().toISOString(),crm_agenda_evento:{id:ag.id||'legado',acao:estado}});
    var patch={anotacoes:arr,agendado_em:null}; if(c.etapa==='agendados') patch.etapa=ag.etapa_origem||null;
    var ok=await crmSalvaCampo(c.id,patch); if(!ok) return;
    toast(concluido?'Agendamento marcado como realizado.':'Agendamento cancelado.');
    if(String(_crmSel)===String(c.id)) crmFichaAbrir(c.id);
  }
  /* registra uma anotação no histórico do cliente (jsonb 'anotacoes') */
  async function crmObsRegistrar(id, texto, silencioso){
    texto=String(texto||'').trim(); if(!texto) return;
    var c=_clientes.filter(function(x){return String(x.id)===String(id);})[0]; if(!c) return;
    var arr=Array.isArray(c.anotacoes)?c.anotacoes.slice():[];
    arr.unshift({ t:texto, ts:new Date().toISOString() });
    try{
      var r=await supa.from('clientes').update({anotacoes:arr, atualizado_em:new Date().toISOString()}).eq('id',id); if(r&&r.error) throw r.error;
      c.anotacoes=arr;
      if(!silencioso) toast('Registrado no histórico ✓');
      if(String(_crmSel)===String(id)) crmHistPinta(c);
    }catch(e){ toast('Não consegui registrar. '+((e&&e.message)||'')); }
  }
  /* ===== v458 — CADASTROS DUPLICADOS (mesmo telefone) ====================
     O botao "Unificar repetidos (N)" so nasce quando ha telefone repetido.
     Regra da unificacao: o cadastro MAIS ANTIGO fica; os outros preenchem o
     que nele estiver vazio, entregam anotacoes/historico/consultas/
     documentos e sao apagados. Tudo pelas mesmas portas do app (RLS). */
  function _crmFoneDig(t){ return String(t||'').replace(/\D/g,''); }
  /* ⚠️ v517: esta comparação pelo número INTEIRO enxergava menos da metade
     dos repetidos (medido: 2 grupos em vez de 4). Quem manda agora é a
     `crmFoneChave` do 12h — os 8 ÚLTIMOS dígitos, a mesma regra que o
     atendente IA já usava. Fica aqui, escondida, como caminho de volta. */
  function crmDupsGrupos(){
    var g={};
    _clientes.forEach(function(c){ var d=_crmFoneDig(c.telefone); if(d.length>=8){ (g[d]=g[d]||[]).push(c); } });
    return Object.keys(g).map(function(k){ return g[k]; }).filter(function(x){ return x.length>1; });
  }
  function crmDupsBadge(){
    var b=$('crmUnificar'); if(!b) return;
    var extras = (typeof crmRepetidosExtras==='function')
      ? crmRepetidosExtras()
      : crmDupsGrupos().reduce(function(s2,x){ return s2+x.length-1; },0);
    if(extras>0){ b.style.display=''; b.innerHTML=_cIco('<circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M6 21V9a9 9 0 0 0 9 9"/>')+'Unificar repetidos ('+extras+')'; }
    else b.style.display='none';
  }
  async function crmUnificarDuplicados(){
    var grupos=crmDupsGrupos();
    if(!grupos.length){ toast('Nenhum telefone repetido.'); return; }
    var extras=grupos.reduce(function(s2,x){ return s2+x.length-1; },0);
    if(!confirm('Achei '+grupos.length+' telefone'+(grupos.length===1?'':'s')+' repetido'+(grupos.length===1?'':'s')+' ('+extras+' cadastro'+(extras===1?'':'s')+' a mais). Unificar? O cadastro mais antigo fica e recebe as anotações, consultas e documentos dos outros.')) return;
    toast('Unificando...');
    var CAMPOS=['nome','email','cpf','cep','rua','numero','bairro','complemento','cidade','uf','rg','nascimento','nome_mae','etapa','origem','interesse','faixa_preco','faixa_parcela','placa_troca','veiculo_troca','ano_troca','fipe_troca','avaliacao_troca','avaliado_por','obs'];
    var feitos=0;
    for(var gi=0; gi<grupos.length; gi++){
      var g=grupos[gi].slice().sort(function(x,y){ return new Date(x.criado_em||0)-new Date(y.criado_em||0); });
      var fica=g[0], sai=g.slice(1), upd={};
      CAMPOS.forEach(function(k){
        if(fica[k]==null||fica[k]===''){ for(var si=0;si<sai.length;si++){ if(sai[si][k]!=null&&sai[si][k]!==''){ upd[k]=sai[si][k]; break; } } }
      });
      if(!fica.quente && sai.some(function(x){ return x.quente; })) upd.quente=true;
      if(!fica.agendado_em){ var ag=sai.map(function(x){ return x.agendado_em; }).filter(Boolean)[0]; if(ag) upd.agendado_em=ag; }
      var an=Array.isArray(fica.anotacoes)?fica.anotacoes.slice():[];
      sai.forEach(function(x){ if(Array.isArray(x.anotacoes)) an=an.concat(x.anotacoes); });
      var hi=Array.isArray(fica.historico)?fica.historico.slice():[];
      sai.forEach(function(x){ if(Array.isArray(x.historico)) hi=hi.concat(x.historico); });
      an.unshift({ t:'Cadastros unificados: '+(sai.length+1)+' com o telefone '+_crmFoneFmt(fica.telefone||sai[0].telefone||''), ts:new Date().toISOString() });
      upd.anotacoes=an; if(hi.length) upd.historico=hi;
      try{
        var r=await supa.from('clientes').update(Object.assign({},upd,{atualizado_em:new Date().toISOString()})).eq('id',fica.id); if(r&&r.error) throw r.error;
        for(var di=0; di<sai.length; di++){
          var dsc=sai[di];
          try{ await supa.from('cliente_consulta').update({cliente_id:fica.id}).eq('cliente_id',dsc.id); }catch(_){}
          try{ await supa.from('cliente_documento').update({cliente_id:fica.id}).eq('cliente_id',dsc.id); }catch(_){}
          var rd=await supa.from('clientes').delete().eq('id',dsc.id); if(rd&&rd.error) throw rd.error;
          feitos++;
        }
      }catch(e){ toast('Parei no meio: '+((e&&e.message)||'erro')+'. O que já foi unificado está salvo.'); break; }
    }
    await cliCarregar();
    crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||'');
    try{ crmDupsBadge(); }catch(_){}
    if(feitos) toast(feitos+' cadastro'+(feitos===1?'':'s')+' unificado'+(feitos===1?'':'s')+' ✓');
  }
  function _crmMoney(v){ v=Number(v)||0; return v?('R$ '+v.toLocaleString('pt-BR')):''; }
  async function crmFichaAbrir(id){
    /* ===== 🔴 v516 (B2, o mais sério do PROJETO-crm-salva-sozinho) =========
       O CINTO (a): descarrega o pendente ANTES de repintar. Sem esta linha,
       corrigir o telefone do cliente A e clicar no B em menos de 1,2 s fazia
       o relógio de A disparar lendo a tela do B — e **o A virava uma cópia
       do B**. Aqui o DOM ainda é do A, então o que estava pendente é gravado
       no dono certo. O cinto (b) mora no `agenda()`, lá embaixo. */
    try{ if(typeof crmFlush==='function') await crmFlush(); }catch(_){}
    var c=_clientes.filter(function(x){return String(x.id)===String(id);})[0]; if(!c) return;
    if(String(_crmSel)!==String(id)) _crmFichaAba='dados';   /* v401: a 2ª coluna abre no CADASTRO (correção do Angelo) */
    if(_crmFichaAba==='chat') _crmFichaAba='dados';           /* v429: o chat saiu da página Clientes */
    _crmSel=id; crmPintaLista((($('cliBusca')||{}).value)||'');
    var el=$('crmFicha'); if(!el) return;
    var et=crmEtapaInfo(c.etapa);
    function fin(id2,lb,val,ph,extra){ return '<label class="crm-lb">'+lb+'</label><input class="cad-in" id="'+id2+'" value="'+esc(val||'')+'" placeholder="'+esc(ph||'')+'"'+(extra||'')+'>'; }
    el.innerHTML=
      '<div class="crm-head"><div class="t">Cadastro'+(c.quente?('<span class="crm-hbadge hot">'+_ICO_FIRE+' quente</span>'):'')+'</div>'+
        '<div class="crm-hacts">'+
          '<button type="button" id="cxTag" title="Mudar etapa">'+_ICO_TAG+'</button>'+
          '<button type="button" id="cxFire" title="Lead quente" class="'+(c.quente?'on':'')+'">'+_ICO_FIRE+'</button>'+
          '<button type="button" id="cxCal" title="Agendar">'+_ICO_CAL+'</button>'+
          /* v520 (pedido: "um ícone SVG ao lado do fechar pra editar o
             cadastro completo"). O botão SEMPRE existiu e sempre teve o
             handler certo — quem o escondia era o CSS (v428). O que muda
             aqui é só o desenho: sai o ⋯ (_ICO_DOTS), entra o LÁPIS.
             ⚠️ Os três pontinhos são o ícone universal de "mais opções",
             que abre um MENU. Este abre uma TELA — posto ao lado do X, ia
             prometer um submenu que não existe.
             ⚠️ O lápis sai do `_cIco`, como todos os ícones deste arquivo:
             mesmo peso de traço do X ao lado. SVG colado de fora fica mais
             gordo ou mais fino que o vizinho, e num cabeçalho com dois
             botões lado a lado isso salta aos olhos. */
          '<button type="button" id="cxMais" title="Cadastro completo (CPF, endereço...)">'+_ICO_EDIT+'</button>'+
          '<button type="button" id="cxDel" title="Apagar cliente">'+_ICO_LIXO+'</button>'+
          '<button type="button" id="cxFechar" class="crm-x" title="Fechar">'+_cIco('<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>')+'</button>'+
        '</div></div>'+
      crmEtiquetasAgendaHtml(c)+crmAgendaResumoHtml(c)+
      /* v402 (pedido): as abas viraram as PÍLULAS da avaliação (vpx-st, com
         ícone), na ordem Chat · Histórico · Cadastro. O Chat continua só pra
         quem tem o Atendente IA (v401). A ficha segue ABRINDO no Cadastro
         (correção do Angelo na v401). */
      '<div class="vpx-steps vpx-mdr crm-tabs2 crm-tabs" role="tablist" aria-label="Seções do cliente">'+
        /* v429 (pedido): a aba Chat saiu da página Clientes. A seção
           #crmChat continua no HTML (escondida) pra nenhum handler quebrar. */
        '<button type="button" id="cxTabHist" data-tb="hist" role="tab" aria-controls="crmHistPainel" aria-selected="'+(_crmFichaAba==='hist'?'true':'false')+'" class="vpx-st '+(_crmFichaAba==='hist'?'on':'')+'"><span class="vpx-ico">'+_cIco('<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/><path d="M12 8v4l3 2"/>')+'</span><span class="vpx-nm">Histórico</span></button>'+
        '<button type="button" id="cxTabDados" data-tb="dados" role="tab" aria-controls="crmDados" aria-selected="'+(_crmFichaAba==='dados'?'true':'false')+'" class="vpx-st '+(_crmFichaAba==='dados'?'on':'')+'"><span class="vpx-ico">'+_cIco('<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>')+'</span><span class="vpx-nm">Cadastro</span></button>'+
      '</div>'+
      '<div class="crm-body tab-'+_crmFichaAba+'">'+
        '<div class="crm-dados" id="crmDados" role="tabpanel" aria-labelledby="cxTabDados">'+
          '<div class="crm-sec">DADOS DO CLIENTE</div>'+
          fin('cxNome','NOME',c.nome,'Nome do cliente')+
          '<label class="crm-lb">TELEFONE</label><div class="crm-tel"><input class="cad-in" id="cxTel" inputmode="tel" value="'+esc(c.telefone||'')+'" placeholder="(00) 00000-0000">'+
            '<button type="button" class="crm-tb wa" id="cxWa" title="WhatsApp">'+_icoWa+'</button>'+
            '<button type="button" class="crm-tb" id="cxLigar" title="Ligar">'+_ICO_FONE2+'</button>'+
            '<button type="button" class="crm-tb" id="cxCopia" title="Copiar">'+_ICO_COPIA+'</button></div>'+
          '<label class="crm-lb">CIDADE / UF DE EMPLACAMENTO</label><div class="crm-2c"><input class="cad-in" id="cxCidade" value="'+esc(c.cidade||'')+'" placeholder="Cidade"><input class="cad-in" id="cxUf" maxlength="2" value="'+esc(c.uf||'')+'" placeholder="UF" style="max-width:74px">'+'</div>'+
          fin('cxInteresse','VEÍCULO DE INTERESSE',c.interesse,'Digite ou escolha o modelo...')+
          fin('cxFaixaP','FAIXA DE PREÇO',_crmMoney(c.faixa_preco),'R$ 0,00',' inputmode="numeric"')+
          fin('cxFaixaParc','FAIXA DE PARCELA',_crmMoney(c.faixa_parcela),'R$ 0,00',' inputmode="numeric"')+
          '<label class="crm-lb">ORIGEM DO LEAD</label><select class="cad-in" id="cxOrigem"><option value="">Origem do lead...</option>'+CRM_ORIGENS.map(function(o){ return '<option'+(c.origem===o?' selected':'')+'>'+esc(o)+'</option>'; }).join('')+'</select>'+
          '<label class="crm-lb">ADICIONAR OBSERVAÇÕES</label><div class="crm-obs"><textarea class="cad-in" id="cxObs" rows="2" placeholder="Escreva e aperte enter pra registrar no histórico..."></textarea><button type="button" class="crm-send" id="cxSend" title="Registrar">'+_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>'+
          '<div class="cad-msg cad-autosave" id="cxAuto" style="text-align:right;color:#94a3b8;min-height:14px"></div>'+
          /* v429: o ⋯ do cabeçalho está escondido desde a v428 — é por aqui
             que se chega no cadastro completo (CPF, endereço, documentos) */
          '<button type="button" class="crm-mais-link" id="cxCompleto">Cadastro completo</button>'+
          /* v431: o caminho mais curto pro Funil — a negociação nasce aqui.
             ⚠️ v437: ESCONDIDO junto com o Funil. O botão e o handler ficam
             no lugar; some só o style="display:none" pra trazer de volta. */
          '<button type="button" class="crm-mais-link" id="cxNegocio" style="display:none">Abrir negociação</button>'+
        '</div>'+
        '<div class="crm-hist" id="crmHistPainel" role="tabpanel" aria-labelledby="cxTabHist"><div class="crm-sec">HISTÓRICO</div><div id="crmHist"><div class="cli-empty" style="padding:12px">Carregando...</div></div></div>'+
        /* v322 — a aba Chat mostra a CONVERSA DE VERDADE (mensagens_whatsapp,
           alimentada pelo webhook do atendente IA). Responder por aqui grava
           'enviada' — que e' exatamente o sinal do "humano no comando": a IA
           se cala por 30 min pra este cliente. */
        '<section class="crm-chat" id="crmChat" role="tabpanel" aria-labelledby="cxTabChat"><div class="crm-sec">CHAT</div>'+
          '<p class="crm-chat-sem" id="cxChatSem"'+(cliWhatsUrl(c.telefone)?' hidden':'')+'>Cadastre um Telefone / WhatsApp no Cadastro para ver a conversa.</p>'+
          '<div class="cx-th" id="cxChatMsgs"><div class="cli-empty" style="padding:12px">Carregando a conversa...</div></div>'+
          '<div class="cx-th-bar"><textarea class="cad-in" id="cxChatIn" rows="1" placeholder="Responder no WhatsApp..."></textarea>'+
            '<button type="button" class="crm-send" id="cxChatSend" title="Enviar">'+_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>'+
          '<div class="cx-th-foot"><small>Responder por aqui pausa a IA por 30 min (voce assume a conversa).</small>'+
            '<button type="button" class="crm-chat-open cx-th-wa" id="cxChatWa"'+(cliWhatsUrl(c.telefone)?'':' disabled')+'><span aria-hidden="true">'+_icoWa+'</span><span>Abrir WhatsApp</span></button></div>'+
        '</section>'+
      '</div>';
    /* ---- no celular a ficha e' uma tela cheia; abre e trava o fundo ---- */
    document.body.classList.add('crm-fx-on'); el.scrollTop=0;
    var _fx=$('cxFechar'); if(_fx) _fx.onclick=crmFichaFechar;
    var _tabs=el.querySelectorAll('.crm-tabs button'), _bd=el.querySelector('.crm-body');
    function crmAbaSelecionar(aba){
      if(['dados','hist'].indexOf(aba)<0) aba='dados';   /* v429: sem chat */
      _crmFichaAba=aba;
      Array.prototype.forEach.call(_tabs,function(x){ var on=x.getAttribute('data-tb')===aba; x.classList.toggle('on',on); x.setAttribute('aria-selected',on?'true':'false'); });
      if(_bd){ _bd.className='crm-body tab-'+aba; }
      el.scrollTop=0;
      if(aba==='chat'){ cxChatLigar(c); } else { cxChatDesligar(); }
    }
    Array.prototype.forEach.call(_tabs,function(b){
      b.onclick=function(){
        crmAbaSelecionar(b.getAttribute('data-tb'));
      };
    });
    /* ---- ações do cabeçalho ---- */
    $('cxTag').onclick=function(){ crmEtapaPicker(c); };
    /* v516: o 🔥 deixou de ser liga/desliga e abre o MESMO picker da tabela.
       Antes ele mexia SÓ no boolean `quente` e não tocava no
       `extra.temperatura` — então um cliente "morno" ficava com o fogo aceso
       na ficha e continuava morno na tabela. Duas telas discordando sobre o
       mesmo cliente. Agora uma função só escreve temperatura, e escreve os
       dois campos juntos (ver o 12g). */
    $('cxFire').onclick=function(){
      if(typeof crmTempPicker==='function'){ crmTempPicker(c); return; }
      crmSalvaCampo(id,{quente:!c.quente}).then(function(){ crmFichaAbrir(id); });
    };
    $('cxCal').onclick=function(){ crmAgendar(c); };
    var agConcluir=$('cxAgConcluir'); if(agConcluir) agConcluir.onclick=function(){ crmAgendaEncerrar(c,'realizado'); };
    var agReagendar=$('cxAgReagendar'); if(agReagendar) agReagendar.onclick=function(){ crmAgendaEscolher(c,crmAgendaAtual(c)); };
    var agCancelar=$('cxAgCancelar'); if(agCancelar) agCancelar.onclick=function(){ crmAgendaEncerrar(c,'cancelado'); };
    /* v516: o cadastro completo abre POR CIMA e edita o MESMO cliente — se
       houver pendência aqui, ela vai antes, senão os dois autosaves brigam
       e o mais lento sobrescreve o mais novo. */
    function _cxAbreCompleto(){ try{ if(typeof crmFlush==='function') crmFlush(); }catch(_){} cliAbrirFicha(id); }
    $('cxMais').onclick=_cxAbreCompleto;
    var _cc=$('cxCompleto'); if(_cc) _cc.onclick=_cxAbreCompleto;   /* v429 */
    var _cn=$('cxNegocio'); if(_cn) _cn.onclick=async function(){   /* v431 */
      if(!(_vendas||[]).length){ try{ await vendaCarregar(); }catch(_){} }
      if(!(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} }
      funilNovaAbrir(id);
    };
    $('cxDel').onclick=async function(){ await cliApagar(id); _crmSel=null; crmFichaFechar(); var fx=$('crmFicha'); if(fx) fx.innerHTML='<div class="cli-empty" style="margin-top:40px"><b>Escolha um cliente</b></div>'; crmPintaEtapas(); crmPintaLista(''); };
    /* ---- telefone: whatsapp / ligar / copiar ---- */
    function abrirChat(){ var u=cliWhatsUrl((($('cxTel')||{}).value)||c.telefone); if(u){ try{ window.open(u,'_blank'); }catch(_){ location.href=u; } } else toast('Sem telefone.'); }
    $('cxWa').onclick=abrirChat;
    var chatWa=$('cxChatWa'); if(chatWa) chatWa.onclick=abrirChat;
    var _cse=$('cxChatSend'); if(_cse) _cse.onclick=function(){ cxChatEnviar(c); };
    var _cin=$('cxChatIn'); if(_cin) _cin.addEventListener('keydown',function(e){ if(e.key==='Enter'&&!e.shiftKey){ e.preventDefault(); cxChatEnviar(c); } });
    if(_crmFichaAba==='chat') cxChatLigar(c);
    $('cxLigar').onclick=function(){ var d=String((($('cxTel')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d) location.href='tel:+55'+d; else toast('Sem telefone.'); };
    $('cxCopia').onclick=function(){ var v=(($('cxTel')||{}).value)||''; try{ navigator.clipboard.writeText(v); toast('Telefone copiado.'); }catch(_){ prompt('Copie:',v); } };
    /* ---- máscaras ---- */
    function pintaChatStatus(){ var tem=!!cliWhatsUrl((($('cxTel')||{}).value)||c.telefone), b=$('cxChatWa'), aviso=$('cxChatSem'); if(b) b.disabled=!tem; if(aviso) aviso.hidden=tem; }
    var tel=$('cxTel'); if(tel){ if(tel.value) tel.value=foneFmt(tel.value); tel.addEventListener('input',function(){ this.value=foneFmt(this.value); pintaChatStatus(); }); }
    var uf=$('cxUf'); if(uf) uf.addEventListener('input',function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); });
    ['cxFaixaP','cxFaixaParc'].forEach(function(i){ var e=$(i); if(e) e.addEventListener('input',estMaskRSint); });
    /* ---- autosave dos campos (debounce 1,2s) ---- */
    /* v516 (B4): o que a ficha SALVA e o que ela LIGA saem da MESMA lista
       (CX_CAMPOS, no 12g). Antes eram duas listas escritas à mão em lugares
       diferentes — botar um campo novo no HTML e esquecer de somar no
       coleta() criava um campo que aceita digitação e nunca salva, sem erro
       nenhum. Agora é impossível ligar um campo e esquecer de gravá-lo. */
    var coleta = (typeof crmColetaFicha==='function') ? crmColetaFicha : function(){ return {}; };
    function agenda(){
      var st=$('cxAuto'); if(st){ st.textContent='Salvando…'; st.classList.add('saving'); }
      /* 🔴 v516 (B2): o pendente passa a carregar o DONO. */
      try{ if(typeof crmPendMarcar==='function') crmPendMarcar(id, coleta); }catch(_){}
      if(_crmTimer) clearTimeout(_crmTimer);
      _crmTimer=setTimeout(async function(){
        _crmTimer=null;
        /* 🔴 O CINTO (b): se a ficha aberta já não for esta, NÃO grava. O
           que estava pendente já foi salvo pelo flush do crmFichaAbrir, no
           dono certo. Sem esta linha, o relógio do cliente A dispararia
           lendo a tela do cliente B. */
        if(typeof crmPendEhDaFichaAberta==='function' && !crmPendEhDaFichaAberta(id)) return;
        var dados=coleta();
        try{ if(typeof crmPendLimpar==='function') crmPendLimpar(); }catch(_){}
        var ok=await crmSalvaCampo(id, dados);
        /* v516: tentar de novo é certo pra internet caindo e é um LOOP
           ETERNO quando o motivo é permissão (RLS). Aí a tela para e diz. */
        var _rls = (typeof crmErroFoiRls==='function') && crmErroFoiRls();
        var st2=$('cxAuto');
        if(st2){ st2.classList.remove('saving');
          st2.textContent = ok ? 'Salvo ✓' : (_rls ? 'Não salvou — não é da sua carteira' : 'Não salvou — tento de novo');
          st2.style.color = ok ? '#16a34a' : '#dc2626'; }
        if(!ok && !_rls){ try{ if(typeof crmPendMarcar==='function') crmPendMarcar(id, coleta); }catch(_){} _crmTimer=setTimeout(agenda,4000); }
      },1200);
    }
    if(typeof crmLigaCampos==='function') crmLigaCampos(agenda);
    else { ['cxNome','cxTel','cxCidade','cxUf','cxInteresse','cxFaixaP','cxFaixaParc'].forEach(function(i){ var e=$(i); if(e){ e.addEventListener('input',agenda); } });
           var og=$('cxOrigem'); if(og) og.onchange=agenda; }
    /* ---- observações: Enter (ou aviãozinho) registra no histórico ---- */
    function registra(){ var e=$('cxObs'); var t=(e&&e.value||'').trim(); if(!t) return; if(e) e.value=''; crmObsRegistrar(id,t); }
    $('cxSend').onclick=registra;
    var ob=$('cxObs'); if(ob) ob.addEventListener('keydown',function(ev){ if(ev.key==='Enter' && !ev.shiftKey){ ev.preventDefault(); registra(); } });
    pintaChatStatus();
    crmHistPinta(c);
  }
  /* fecha a ficha em tela cheia do celular (no computador ela fica sempre a' vista) */
  function crmFichaFechar(){
    /* ===== v516 (B1) — FECHAR NÃO JOGA MAIS FORA O QUE IA SER SALVO ======
       O `cliModalFechar` (cadastro completo) sempre teve o `_cfFlush()`.
       Esta função, não: ela cancelava o relógio e ia embora. Na prática,
       corrigir o nome e tocar no X antes de 1,2 s fazia a alteração sumir —
       DEPOIS de a tela ter escrito "Salvando…" na cara do usuário.
       ⚠️ Sem `await` de propósito: o `crmFlush` lê o DOM de forma síncrona
       antes do primeiro await (ver o comentário dele no 12g), e um fechar
       de tela não pode esperar rede. */
    try{ if(typeof crmFlush==='function') crmFlush(); }catch(_){}
    document.body.classList.remove('crm-fx-on');
    if(_crmTimer){ clearTimeout(_crmTimer); _crmTimer=null; }
  }
  /* HISTÓRICO: anotações + cotações + documentos + consultas vinculadas, do mais novo pro mais antigo */
  async function crmHistPinta(c){
    var el=$('crmHist'); if(!el || !c) return;
    var itens=[];
    (Array.isArray(c.anotacoes)?c.anotacoes:[]).forEach(function(a){ if(a&&a.t) itens.push({ts:a.ts||'', tipo:(a.crm_agenda||a.crm_agenda_evento)?'agenda':'obs', titulo:a.t}); });
    var cots=[], docs=[], cons=[];
    try{ var r1=await withTimeout(supa.from('vendas').select('id,veiculo,placa,valor_venda,proposta,criado_em').eq('cliente_id',c.id).order('criado_em',{ascending:false}),9000); cots=((r1&&r1.data)||[]).filter(function(x){ return x.proposta&&x.proposta.espelho; }); }catch(_){}
    try{ var r2=await withTimeout(supa.from('cliente_documento').select('id,tipo,nome,dados,criado_em').eq('cliente_id',c.id).order('criado_em',{ascending:false}),9000); docs=(r2&&r2.data)||[]; }catch(_){}
    try{ var r3=await withTimeout(supa.from('cliente_consulta').select('*').eq('cliente_id',c.id).order('criado_em',{ascending:false}),9000); cons=(r3&&r3.data)||[]; }catch(_){}
    cots.forEach(function(v,i){ itens.push({ts:v.criado_em||'', tipo:'cot', titulo:'Cotação salva — '+(v.veiculo||'veículo'), sub:estMoney(v.valor_venda||0), i:i}); });
    docs.forEach(function(k,i){ itens.push({ts:k.criado_em||'', tipo:'doc', titulo:(_DOC_LABEL[k.tipo]||k.tipo||'Documento')+((k.dados&&k.dados.placa)?(' — '+k.dados.placa):''), i:i}); });
    cons.forEach(function(k,i){ itens.push({ts:k.criado_em||'', tipo:'con', titulo:'Consulta '+(k.placa||''), sub:(((k.veiculo||{}).marca||'')+' '+((k.veiculo||{}).modelo||'')).trim(), i:i}); });
    itens.sort(function(a,b){ return String(b.ts).localeCompare(String(a.ts)); });
    if(String(_crmSel)!==String(c.id)) return;   /* trocou de cliente no meio do carregamento */
    if(!itens.length){ el.innerHTML='<div class="cli-empty" style="padding:12px;color:#94a3b8">Nada por aqui ainda. Anote algo nas observações, salve uma cotação ou gere um documento.</div>'; return; }
    el.innerHTML=itens.map(function(it,idx){
      var dt=''; try{ if(it.ts) dt=new Date(it.ts).toLocaleDateString('pt-BR')+' '+new Date(it.ts).toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'}); }catch(_){}
      var link=(it.tipo!=='obs');
      return '<div class="crm-hi'+(link?' lk':'')+'" data-x="'+idx+'"><span class="crm-dot '+it.tipo+'"></span><div class="crm-hit"><b>'+esc(it.titulo)+(link?' ›':'')+'</b>'+(it.sub?('<span>'+esc(it.sub)+'</span>'):'')+'<i>'+esc(dt)+'</i></div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.crm-hi.lk'),function(node){
      node.onclick=function(){
        var it=itens[+node.getAttribute('data-x')]; if(!it) return;
        if(it.tipo==='cot') cliVerEspelho(cots[it.i]);
        else if(it.tipo==='doc') docRebaixar(docs[it.i]);
        else if(it.tipo==='con'){ var k=cons[it.i]||{}; cliAbrirConsultaVinc(k.placa, k.veiculo||{}); }
      };
    });
  }

  function cliModalEl(){
    var bg=$('cliMbg');
    if(!bg){ bg=document.createElement('div'); bg.id='cliMbg'; bg.className='cli-mbg';
      bg.innerHTML='<div class="cli-modal"><div class="cli-mhead"><div class="av" id="cliMav">?</div><div class="t" id="cliMt">Cliente</div><button class="mdel" id="cliMdel" aria-label="Apagar" style="display:none"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg></button><button class="x" id="cliMx" aria-label="Fechar">&#10005;</button></div><div class="cli-mbody" id="cliMbody"></div></div>';
      document.body.appendChild(bg);
      bg.addEventListener('click',function(e){ if(e.target===bg) cliModalFechar(); });
      bg.querySelector('#cliMx').onclick=cliModalFechar;
    }
    var db=bg.querySelector('#cliMdel'); if(db){ db.style.display='none'; db.onclick=null; }
    return bg;
  }
  function cliModalDel(fn){ var b=$('cliMdel'); if(!b) return; if(fn){ b.style.display=''; b.onclick=fn; } else { b.style.display='none'; b.onclick=null; } }
  function cliModalFechar(){ try{ _cfFlush(); }catch(_){} var bg=$('cliMbg'); if(bg) bg.classList.remove('on'); }
  var ICO_CFCNH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><circle cx="8" cy="11.5" r="2.2"/><path d="M4.5 16.5a3.5 3.5 0 0 1 7 0"/><line x1="14" y1="10" x2="19" y2="10"/><line x1="14" y1="14" x2="18" y2="14"/></svg>';
  var ICO_CFCASA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5L12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M9.5 21v-6h5v6"/></svg>';
  function cliFormHtml(c){ c=c||{};
    return '<div class="doc-hint">Anexe a <b>CNH</b> e o <b>comprovante de endereço</b> que eu leio e preencho sozinho — ou digite à mão. Confira tudo antes de salvar.</div>'+
      '<div class="doc-ia"><button type="button" class="doc-iabtn" id="cfIaCnh">'+ICO_CFCNH+'Anexar CNH</button><button type="button" class="doc-iabtn" id="cfIaRes">'+ICO_CFCASA+'Comprovante de endereço</button></div>'+
      '<label class="cad-lbl">Nome</label><input class="cad-in" id="cfNome" value="'+esc(c.nome||'')+'" placeholder="Nome do cliente">'+
      '<label class="cad-lbl">Telefone / WhatsApp</label><input class="cad-in" id="cfTel" inputmode="tel" value="'+esc(c.telefone||'')+'" placeholder="(00) 00000-0000">'+
      '<label class="cad-lbl">E-mail</label><input class="cad-in" id="cfEmail" value="'+esc(c.email||'')+'" placeholder="email@exemplo.com">'+
      '<label class="cad-lbl">CPF</label><input class="cad-in" id="cfCpf" inputmode="numeric" value="'+esc(c.cpf||'')+'" placeholder="000.000.000-00">'+
      '<div class="cli-2col nb"><div><label class="cad-lbl">RG</label><input class="cad-in" id="cfRg" value="'+esc(c.rg||'')+'" placeholder="RG"></div><div><label class="cad-lbl">Nascimento</label><input class="cad-in" id="cfNasc" value="'+esc(c.nascimento||'')+'" placeholder="DD/MM/AAAA"></div></div>'+
      '<label class="cad-lbl">Nome da mãe</label><input class="cad-in" id="cfMae" value="'+esc(c.nome_mae||'')+'" placeholder="Nome da mãe">'+
      '<label class="cad-lbl">CEP</label><input class="cad-in" id="cfCep" inputmode="numeric" value="'+esc(c.cep||'')+'" placeholder="00000-000 (busca o endereço)">'+
      '<label class="cad-lbl">Rua</label><input class="cad-in" id="cfRua" value="'+esc(c.rua||'')+'" placeholder="Rua / logradouro">'+
      '<div class="cli-2col nb"><div><label class="cad-lbl">Número</label><input class="cad-in" id="cfNum" inputmode="numeric" value="'+esc(c.numero||'')+'" placeholder="Nº"></div><div><label class="cad-lbl">Bairro</label><input class="cad-in" id="cfBairro" value="'+esc(c.bairro||'')+'" placeholder="Bairro"></div></div>'+
      '<label class="cad-lbl">Complemento</label><input class="cad-in" id="cfComp" value="'+esc(c.complemento||'')+'" placeholder="Apto, bloco, ponto de referência">'+
      '<div class="cli-2col cid"><div><label class="cad-lbl">Cidade</label><input class="cad-in" id="cfCidade" value="'+esc(c.cidade||'')+'" placeholder="Cidade"></div><div><label class="cad-lbl">UF</label><input class="cad-in" id="cfUf" maxlength="2" value="'+esc(c.uf||'')+'" placeholder="UF"></div></div>'+
      '<label class="cad-lbl">Observacoes</label><textarea class="cad-in" id="cfObs" rows="3" placeholder="Anotacoes sobre o cliente">'+esc(c.obs||'')+'</textarea>'+
      '<div class="cad-msg cad-autosave" id="cfAuto" style="text-align:right;color:#94a3b8;min-height:16px"></div><div class="cad-msg" id="cfMsg"></div>';
  }
  function foneDig(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length>11 && d.slice(0,2)==='55') d=d.slice(2); return d.slice(0,11); }
  function foneFmt(s){ var d=foneDig(s); if(!d) return ''; if(d.length<3) return '('+d; if(d.length<7) return '('+d.slice(0,2)+') '+d.slice(2); if(d.length<11) return '('+d.slice(0,2)+') '+d.slice(2,6)+'-'+d.slice(6); return '('+d.slice(0,2)+') '+d.slice(2,7)+'-'+d.slice(7); }
  function cepFmt(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,8); return d.length>5?(d.slice(0,5)+'-'+d.slice(5)):d; }
  async function cepBusca(v, ids){ ids=ids||{cep:'cfCep',rua:'cfRua',bairro:'cfBairro',cidade:'cfCidade',uf:'cfUf',num:'cfNum'};
    var d=String(v||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length!==8) return false;
    var j=null;
    try{ var r=await fetch('https://viacep.com.br/ws/'+d+'/json/'); if(r.ok){ var b=await r.json(); if(b&&!b.erro) j={rua:b.logradouro,bairro:b.bairro,cidade:b.localidade,uf:b.uf}; } }catch(_){}
    if(!j){ try{ var r2=await fetch('https://brasilapi.com.br/api/cep/v2/'+d); if(r2.ok){ var c=await r2.json(); if(c&&c.city) j={rua:c.street,bairro:c.neighborhood,cidade:c.city,uf:c.state}; } }catch(_){} }
    if(!j) return false;
    /* v759: resposta ANTIGA não sobrescreve um CEP novo — se o campo já mudou, esta resposta é ignorada */
    try{ var _ag=String((($(ids.cep)||{}).value)||'').replace(/\D/g,''); if(_ag && _ag!==d) return false; }catch(_){}
    if($(ids.rua)) $(ids.rua).value=j.rua||$(ids.rua).value; if($(ids.bairro)) $(ids.bairro).value=j.bairro||$(ids.bairro).value; if($(ids.cidade)) $(ids.cidade).value=j.cidade||''; if($(ids.uf)) $(ids.uf).value=j.uf||'';
    var foco=(!j.rua && $(ids.rua)) ? $(ids.rua) : ($(ids.num)&&!$(ids.num).value ? $(ids.num) : null);
    if(foco) try{ foco.focus(); }catch(_){}
    return j;   /* objeto: quem chama sabe se veio rua/bairro (CEP geral não tem) */
  }
  function cliWireForm(){
    var tel=$('cfTel'); if(tel){ if(tel.value) tel.value=foneFmt(tel.value); tel.oninput=function(){ this.value=foneFmt(this.value); }; tel.addEventListener('paste',function(){ var el=this; setTimeout(function(){ el.value=foneFmt(el.value); },0); }); }
    var cep=$('cfCep'); if(cep){ cep.oninput=function(){ this.value=cepFmt(this.value); if(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length===8) cepBusca(this.value); }; cep.addEventListener('blur',function(){ cepBusca(this.value); }); cep.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); cepBusca(this.value); } }); }
    var uf=$('cfUf'); if(uf){ uf.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); }; }
    /* v190: leitura por IA da CNH e do comprovante de endereço (substitui a busca paga por CPF) */
    var bC=$('cfIaCnh'); if(bC) bC.onclick=function(){ if(!window.MEV_IA){ _iaAcao(function(){ bC.click(); }); return; } window.MEV_IA.importarCNH(function(d){ if(!d) return;
      _dset('cfNome',d.nome);
      if(d.cpf) _dset('cfCpf',_fmtCpf(d.cpf));
      _dset('cfRg',[d.rg,d.rg_orgao_emissor].filter(Boolean).join(' '));
      _dset('cfNasc',d.data_nascimento);
      _dset('cfMae',d.filiacao_mae);
      try{ _cfAgenda(); }catch(_){}
      toast('CNH lida — confira os dados.');
    }); };
    var bR=$('cfIaRes'); if(bR) bR.onclick=function(){ if(!window.MEV_IA){ _iaAcao(function(){ bR.click(); }); return; } window.MEV_IA.importarResidencia(function(d){ if(!d) return; var e=d.endereco||{};
      if(!((($('cfNome')||{}).value)||'').trim() && d.titular_nome) _dset('cfNome',d.titular_nome);
      _dset('cfCep',e.cep?cepFmt(e.cep):'');
      _dset('cfRua',e.logradouro); _dset('cfNum',e.numero); _dset('cfBairro',e.bairro);
      _dset('cfCidade',e.cidade); _dset('cfUf',String(e.uf||'').toUpperCase());
      try{ _cfAgenda(); }catch(_){}
      toast('Endereço lido — confira os dados.');
    }); };
  }
  function cliAbrirConsultaVinc(placa, snap){
    cliModalFechar();
    if(placa && histLerUm(placa)){ abrirSalva(placa); return; }
    snap=snap||{};
    veiculoAtual={placa:placa,marca:snap.marca,modelo:snap.modelo,ano:snap.ano,cor:snap.cor,combustivel:snap.combustivel,fipe:snap.fipe,chassi:snap.chassi};
    histFonteTs=null; fichaState=null; leilaoState=null;
    if($('placa')) $('placa').value='';   /* campo de pesquisa fica LIMPO */
    abrirMenu();
  }
  async function cliAbrirFicha(id){
    var bg=cliModalEl(); bg.classList.add('on');
    var c = id ? _clientes.filter(function(x){return String(x.id)===String(id);})[0] : null;
    $('cliMav').textContent=cliIni(c?c.nome:'+');
    $('cliMt').textContent = c ? (c.nome||'Cliente') : 'Novo cliente';
    var body=$('cliMbody'); body.innerHTML=cliFormHtml(c)+(c?'<div id="cfExtra"></div>':'');
    cliAutoWire(c?c.id:null);   /* salva automaticamente — sem botão Salvar */
    cliWireForm();
    if(c){
      var extra=$('cfExtra');
      extra.innerHTML='<div class="cad-sec"><h3>Documentos gerados</h3><div id="cfDocs"><div class="cli-empty" style="padding:12px">Carregando...</div></div></div>'+
        '<div class="cad-sec"><h3>Cotações (espelho)</h3><div id="cfCotacoes"><div class="cli-empty" style="padding:12px">Carregando...</div></div></div>'+
        '<div class="cad-sec"><h3>Consultas vinculadas</h3><div id="cfCons"><div class="cli-empty" style="padding:12px">Carregando...</div></div></div>'+
        (cliWhatsUrl(c.telefone)?'<button class="cad-btn sec" id="cfWa">Abrir WhatsApp</button>':'')+
        (_cliEhDono()?'<button class="cad-btn sec" id="cfPassar">Passar para outro vendedor</button>':'')+   /* v484: só o dono */
        '<button class="cad-btn sair" id="cfDel">Apagar cliente</button>';
      cliDocsPinta(c.id);
      cliCotacoesPinta(c.id);
      var wb=$('cfWa'); if(wb) wb.onclick=function(){ var u=cliWhatsUrl(c.telefone); if(u){ try{window.open(u,'_blank');}catch(_){location.href=u;} } };
      var pb=$('cfPassar'); if(pb) pb.onclick=function(){ cliPassarAbrir(c); };   /* v484 */
      $('cfDel').onclick=function(){ cliApagar(c.id); };
      cliModalDel(function(){ cliApagar(c.id); });
      try{ var r=await withTimeout(supa.from('cliente_consulta').select('*').eq('cliente_id',c.id).order('criado_em',{ascending:false}),9000); var cons=(r&&r.data)||[];
        $('cfCons').innerHTML = cons.length ? cons.map(function(k){ var v=k.veiculo||{}; return '<div class="cli-con"><div class="cli-con-tx"><b>'+esc(k.placa||'-')+'</b><span>'+esc(((v.marca||'')+' '+(v.modelo||'')).trim())+'</span></div><span class="cli-con-go">Abrir ›</span></div>'; }).join('') : '<div class="cli-empty" style="padding:12px;color:#94a3b8">Nenhuma consulta vinculada ainda.</div>';
        if(cons.length){ Array.prototype.forEach.call($('cfCons').querySelectorAll('.cli-con'),function(el,i){ el.onclick=function(){ var k=cons[i]||{}; cliAbrirConsultaVinc(k.placa, k.veiculo||{}); }; }); }
      }catch(e){ if($('cfCons')) $('cfCons').innerHTML='<div class="cli-empty" style="padding:12px">Nao consegui carregar.</div>'; }
    }
  }
  /* lista as cotações salvas do cliente (espelho) dentro do cadastro dele */
  async function cliCotacoesPinta(cliId){
    var el=$('cfCotacoes'); if(!el) return;
    try{
      var r=await withTimeout(supa.from('vendas').select('id,veiculo,placa,valor_venda,proposta,criado_em').eq('cliente_id',cliId).order('criado_em',{ascending:false}),9000);
      var rows=((r&&r.data)||[]).filter(function(x){ return x.proposta && x.proposta.espelho; });
      if(!rows.length){ el.innerHTML='<div class="cli-empty" style="padding:12px;color:#94a3b8">Nenhuma cotação salva ainda.</div>'; return; }
      el.innerHTML=rows.map(function(v,i){ var dt=''; try{ if(v.criado_em) dt=new Date(v.criado_em).toLocaleDateString('pt-BR'); }catch(_){}
        return '<div class="cli-con" data-i="'+i+'"><div class="cli-con-tx"><b>'+esc(v.veiculo||'Veículo')+'</b><span>'+esc(estMoney(v.valor_venda||0))+(dt?' · '+dt:'')+'</span></div><span class="cli-con-go">Ver ›</span></div>';
      }).join('');
      Array.prototype.forEach.call(el.querySelectorAll('.cli-con'),function(node){ node.onclick=function(){ cliVerEspelho(rows[+node.getAttribute('data-i')]); }; });
    }catch(e){ el.innerHTML='<div class="cli-empty" style="padding:12px">Não consegui carregar as cotações.</div>'; }
  }
  /* lista os documentos (TRV/PCP/procuração) já gerados pro cliente, com botão de baixar de novo */
  async function cliDocsPinta(cliId){
    var el=$('cfDocs'); if(!el) return;
    try{
      var r=await withTimeout(supa.from('cliente_documento').select('id,tipo,nome,dados,criado_em').eq('cliente_id',cliId).order('criado_em',{ascending:false}),9000);
      var rows=(r&&r.data)||[];
      if(!rows.length){ el.innerHTML='<div class="cli-empty" style="padding:12px;color:#94a3b8">Nenhum documento gerado ainda. Ao gerar um TRV, PCP ou procuração, a cópia aparece aqui.</div>'; return; }
      el.innerHTML=rows.map(function(k,i){ var dt=''; try{ if(k.criado_em) dt=new Date(k.criado_em).toLocaleDateString('pt-BR'); }catch(_){}
        var lbl=_DOC_LABEL[k.tipo]||(k.tipo||'Documento');
        return '<div class="cli-con" data-i="'+i+'"><div class="cli-con-tx"><b>'+esc(lbl)+'</b><span>'+esc((k.dados&&k.dados.placa)||k.nome||'')+(dt?' · '+dt:'')+'</span></div><span class="cli-con-go" data-baixar="'+i+'">⬇ Baixar</span><button type="button" class="cli-con-del" data-del="'+i+'" title="Apagar" style="border:none;background:none;cursor:pointer;color:#cbd5e1;padding:4px 2px 4px 8px">'+ICO_TRASH+'</button></div>';
      }).join('');
      Array.prototype.forEach.call(el.querySelectorAll('.cli-con'),function(node){ node.onclick=function(e){ if(e.target.closest('.cli-con-del')) return; docRebaixar(rows[+node.getAttribute('data-i')]); }; });
      Array.prototype.forEach.call(el.querySelectorAll('.cli-con-del'),function(btn){ btn.onclick=async function(e){ e.stopPropagation(); var rec=rows[+btn.getAttribute('data-del')]; if(!rec) return; if(!confirm('Apagar este documento salvo? O cliente e as outras cópias continuam.')) return; try{ var d=await supa.from('cliente_documento').delete().eq('id',rec.id); if(d&&d.error) throw d.error; toast('Documento apagado.'); cliDocsPinta(cliId); }catch(err){ toast('Não consegui apagar. '+((err&&err.message)||'')); } }; });
    }catch(e){ el.innerHTML='<div class="cli-empty" style="padding:12px">Não consegui carregar os documentos.</div>'; }
  }
  /* mostra o espelho (resumos salvos) de uma cotação, com opção de abrir/compartilhar */
  function cliVerEspelho(venda){
    var esp=(venda&&venda.proposta&&venda.proposta.espelho)||{};
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:384px;max-height:86vh;overflow:auto">'+
      '<div class="crop-tit">Cotação</div>'+
      '<div class="crop-sub">'+esc(venda.veiculo||'')+'</div>'+
      '<div style="text-align:left;white-space:pre-wrap;font-size:12.5px;line-height:1.5;background:#f8fafc;border:1px solid #eef1f6;border-radius:12px;padding:12px;margin-top:6px;color:#0f172a">'+esc(esp.simples||'(sem espelho salvo)')+'</div>'+
      (esp.detalhado?('<details style="margin-top:8px"><summary style="font-size:12px;font-weight:800;color:#7c3aed;cursor:pointer">Ver detalhe do vendedor</summary><div style="text-align:left;white-space:pre-wrap;font-size:12px;line-height:1.5;background:#fafcff;border:1px dashed #cbd5e1;border-radius:12px;padding:12px;margin-top:6px;color:#334155">'+esc(esp.detalhado)+'</div></details>'):'')+
      '<div class="vp-acts" style="margin-top:12px"><button type="button" id="ceAbrir">Abrir / editar</button><button type="button" id="ceShare">Compartilhar</button></div>'+
      '<button type="button" class="link" id="ceFechar" style="margin-top:10px;width:100%">Fechar</button>'+
      '</div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.querySelector('#ceFechar').onclick=close;
    ov.querySelector('#ceShare').onclick=function(){ vpCompartilhar(esp.simples||''); };
    ov.querySelector('#ceAbrir').onclick=function(){ close(); cliModalFechar(); vendaNovaAbrir(venda.id); };
  }
  /* ===== AUTOSAVE do cliente — salva sozinho enquanto digita (sem botão Salvar) ===== */
  var _cfId=null, _cfTimer=null, _cfSalvando=false, _cfPend=false;
  function _cfPayload(){
    function _cv(id){ var e=$(id); return e?(e.value||'').trim():''; }
    return { nome:_cv('cfNome'), telefone:_cv('cfTel'), email:_cv('cfEmail'), cpf:_cv('cfCpf'), obs:_cv('cfObs'),
      cep:_cv('cfCep'), rua:_cv('cfRua'), numero:_cv('cfNum'), bairro:_cv('cfBairro'), complemento:_cv('cfComp'),
      cidade:_cv('cfCidade'), uf:_cv('cfUf'), rg:_cv('cfRg'), nascimento:_cv('cfNasc'), nome_mae:_cv('cfMae') };
  }
  function _cfStatus(txt, cls){ var st=$('cfAuto'); if(!st) return; st.textContent=txt||''; st.classList.toggle('saving', cls==='saving'); st.style.color = cls==='err' ? '#dc2626' : (cls==='ok' ? '#16a34a' : '#94a3b8'); }
  function cliAutoWire(id){
    _cfId=id||null; _cfPend=false; _cfSalvando=false;
    if(_cfTimer){ clearTimeout(_cfTimer); _cfTimer=null; }
    ['cfNome','cfTel','cfEmail','cfCpf','cfRg','cfNasc','cfMae','cfCep','cfRua','cfNum','cfBairro','cfComp','cfCidade','cfUf','cfObs'].forEach(function(i){
      var e=$(i); if(!e) return;
      e.addEventListener('input', _cfAgenda);
      e.addEventListener('change', _cfAgenda);
    });
    _cfStatus(id?'Alterações salvas automaticamente':'Preencha o nome — salva sozinho', '');
  }
  function _cfAgenda(){
    _cfPend=true; _cfStatus('Salvando…','saving');
    if(_cfTimer) clearTimeout(_cfTimer);
    _cfTimer=setTimeout(function(){ cliSalvar(); }, 1200);
  }
  /* dispara o que estiver pendente na hora de fechar o modal (não perde nada) */
  function _cfFlush(){ if(_cfPend && $('cfAuto')){ if(_cfTimer){ clearTimeout(_cfTimer); _cfTimer=null; } cliSalvar(); } }
  async function cliSalvar(){
    if(_cfSalvando){ _cfTimer=setTimeout(function(){ cliSalvar(); }, 800); return; }
    var d=_cfPayload();
    if(!d.nome){ _cfStatus('Informe o nome pra salvar','err'); return; }
    _cfSalvando=true; _cfPend=false; _cfStatus('Salvando…','saving');
    try{
      /* v516 (B3): o cadastro completo tinha o MESMO "Salvo ✓" mentiroso da
         ficha rápida — update sem conferir a linha. Com a carteira do
         vendedor (v484) isso vira dado perdido em silêncio. */
      if(_cfId){
        var _rs=await _crmGravaConfere('clientes', Object.assign({},d,{atualizado_em:new Date().toISOString()}), _cfId);
        if(!_rs.ok) throw new Error(_rs.erro==='rls' ? 'este cliente não é da sua carteira' : (_rs.erro||'erro'));
      }
      else {
        var r2=await supa.from('clientes').insert(Object.assign({user_id:meuId},d)).select().single(); if(r2&&r2.error) throw r2.error;
        if(r2&&r2.data&&r2.data.id){ _cfId=r2.data.id; var t=$('cliMt'); if(t) t.textContent=d.nome; }
      }
      _cfStatus('Salvo ✓','ok');
      try{ mtEspelhar(Object.assign({},d)); }catch(_){}
      cliCarregar().then(function(){ cliPinta((($('cliBusca')||{}).value)||''); },function(){});  /* atualiza a lista por trás, sem fechar */
    }catch(e){
      /* v516: idem ao da ficha — RLS não se resolve tentando de novo. */
      var _r=(typeof crmErroFoiRls==='function') && crmErroFoiRls();
      _cfPend=!_r;
      _cfStatus(_r ? ('Não salvou — '+((e&&e.message)||'sem permissão')) : ('Não salvou: '+((e&&e.message)||'erro')+' — tento de novo'), 'err');
      if(!_r) _cfTimer=setTimeout(function(){ cliSalvar(); }, 4000);
    }
    _cfSalvando=false;
  }
  /* ===== v484 — A CARTEIRA DO VENDEDOR =====================================
     Cada vendedor vê só os clientes (e vendas) que ELE cadastrou; o DONO vê
     os da loja inteira. A regra mora no BANCO (RLS mp_app_minha_carteira,
     migração v484) — aqui só entram: a nota da página pro vendedor e a ação
     do dono de PASSAR um cliente pra carteira de alguém (decisão do Angelo:
     os 108 antigos ficam com ele e vão sendo distribuídos por esta ação). */
  function _cliEhDono(){
    try{ return !(_lojaRec && _lojaRec.user_id && meuId && String(_lojaRec.user_id)!==String(meuId)); }
    catch(_){ return true; }
  }
  /* ===== v522 — O PROMPT DO NAVEGADOR SAIU DAQUI ==========================
     COMO ERA: um `prompt` do Chrome com a lista NUMERADA dos vendedores e a
     pessoa DIGITANDO UM NÚMERO, seguido de um `confirm`. Duas caixas cinza
     com a cara do navegador, num app que já tem seletor pronto.
     AGORA: o mesmo seletor da tabela (atTransferirAbrir, do 12j) — escolher
     o destino já mostra "sai da lista de X e entra na de Y" e o botão
     confirma. Um passo, não dois.
     ⚠️ O caminho velho continua ABAIXO, intacto, como rede: se o 12j não
     tiver carregado (ordem de módulo, arquivo apagado), o prompt volta a
     atender em vez de o botão não fazer nada. */
  async function cliPassarAbrir(c){
    if(typeof atTransferirAbrir==='function'){
      atTransferirAbrir(c, function(){ try{ cliModalFechar(); }catch(_){} });
      return;
    }
    var membros=[];
    try{ if(_lojaRec&&_lojaRec.id){ var r=await supa.from('loja_membros').select('user_id,nome,email,papel').eq('loja_id',_lojaRec.id); membros=(r&&r.data)||[]; } }catch(_){}
    membros=membros.filter(function(m){ return m.user_id && String(m.user_id)!==String(c.user_id); });
    if(!membros.length){ toast('Sua equipe ainda não tem outro vendedor pra receber.'); return; }
    var nomes=membros.map(function(m,i){ return (i+1)+'. '+(m.nome||m.email||'Vendedor'); }).join('\n');
    var escolha=prompt('Passar "'+(c.nome||'cliente')+'" pra quem?\n\n'+nomes+'\n\nDigite o número:');
    if(escolha==null) return;
    var alvo=membros[parseInt(String(escolha).trim(),10)-1];
    if(!alvo){ toast('Número inválido.'); return; }
    if(!confirm('Passar '+(c.nome||'o cliente')+' para '+(alvo.nome||alvo.email)+'? Ele sai da sua lista e entra na dela.')) return;
    try{
      /* regra 6 do CLAUDE.md: pedir a linha de volta — RLS recusada = erro */
      var r2=await supa.from('clientes').update({user_id:alvo.user_id, atualizado_em:new Date().toISOString()}).eq('id',c.id).select('id');
      if(r2&&r2.error) throw r2.error;
      if(!r2||!r2.data||!r2.data.length) throw new Error('Só o dono da loja pode passar clientes.');
      /* as consultas vinculadas acompanham o cliente (fire-and-forget) */
      try{ supa.from('cliente_consulta').update({user_id:alvo.user_id}).eq('cliente_id',c.id).select('id').then(function(){},function(){}); }catch(_){}
      toast('Cliente passado pra '+(alvo.nome||alvo.email)+' ✓');
      cliModalFechar(); await cliCarregar(); cliPinta((($('cliBusca')||{}).value)||'');
    }catch(e){ toast((e&&e.message)||'Não consegui passar o cliente.'); }
  }
  async function cliApagar(id){
    if(!confirm('Apagar este cliente e as consultas vinculadas a ele?')) return;
    try{ var r=await supa.from('clientes').delete().eq('id',id); if(r&&r.error) throw r.error; await cliCarregar(); cliPinta((($('cliBusca')||{}).value)||''); cliModalFechar(); toast('Cliente apagado.'); }
    catch(e){ toast('Nao consegui apagar.'); }
  }
  /* Vincular a consulta atual a um cliente */
  async function vincularClienteAbrir(){
    if(!veiculoAtual){ toast('Faca uma consulta de placa primeiro.'); return; }
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='+'; $('cliMt').textContent='Vincular a um cliente';
    $('cliMbody').innerHTML='<div class="cad-msg" style="color:#64748b;margin:0 0 10px">Placa <b>'+esc(veiculoAtual.placa||'')+'</b> - escolha o cliente:</div>'+
      '<div class="cli-search" style="margin-bottom:10px">'+_icoBusca+'<input id="vcBusca" placeholder="Buscar cliente" autocomplete="off"></div>'+
      '<button class="cad-btn" id="vcNovo" style="margin-top:0">+ Novo cliente e vincular</button>'+
      '<div id="vcLista" style="margin-top:12px"><div class="cli-empty">Carregando...</div></div>';
    $('vcNovo').onclick=vincularNovo;
    $('vcBusca').oninput=function(){ vcPinta(this.value); };
    await cliCarregar(); vcPinta('');
  }
  function vcPinta(termo){
    var el=$('vcLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    if(!_clientes.length){ el.innerHTML='<div class="cli-empty" style="padding:14px">Nenhum cliente ainda. Crie um novo acima.</div>'; return; }
    var lista=_clientes.filter(function(c){ return !termo || String(c.nome||'').toLowerCase().indexOf(termo)>=0; });
    el.innerHTML = lista.length ? lista.map(function(c){ return '<div class="cli-card" data-id="'+esc(c.id)+'"><div class="cli-av">'+esc(cliIni(c.nome))+'</div><div class="cli-tx"><div class="cli-nm">'+esc(c.nome||'')+'</div><div class="cli-sb">'+esc(c.telefone||'')+'</div></div></div>'; }).join('') : '<div class="cli-empty" style="padding:14px">Nada encontrado.</div>';
    Array.prototype.forEach.call(el.querySelectorAll('.cli-card'),function(card){ card.onclick=function(){ vincularSalvar(card.getAttribute('data-id')); }; });
  }
  async function vincularSalvar(clienteId){
    if(!clienteId||!veiculoAtual) return;
    try{ var v=veiculoAtual; var snap={marca:v.marca,modelo:v.modelo,ano:v.ano,cor:v.cor,combustivel:v.combustivel,fipe:v.fipe,chassi:v.chassi?chassiMask(v.chassi):''};
      var r=await supa.from('cliente_consulta').insert({user_id:meuId,cliente_id:clienteId,placa:v.placa,veiculo:snap}); if(r&&r.error) throw r.error;
      cliModalFechar();
      var nome=(_clientes.filter(function(x){return String(x.id)===String(clienteId);})[0]||{}).nome||'cliente';
      toast('Consulta vinculada a '+nome+'.');
    }catch(e){ toast('Nao consegui vincular. '+((e&&e.message)||'')); }
  }
  function vincularNovo(){
    if(!veiculoAtual){ toast('Faca uma consulta de placa primeiro.'); return; }
    try{ window.__vnForcar=false; }catch(_){}   /* v517: cada abertura pergunta de novo */
    $('cliMt').textContent='Novo cliente';
    $('cliMbody').innerHTML=
      '<div class="cad-msg" style="color:#64748b;margin:0 0 12px">Cadastro rápido — só Nome e telefone. O resto (endereço, CPF...) você completa depois em <b>Leads</b>.</div>'+
      '<label class="cad-lbl">Nome</label><input class="cad-in" id="vnNome" placeholder="Nome do cliente" autocomplete="off" autocapitalize="words">'+
      /* v517 (pedido): ao digitar o nome, os já cadastrados aparecem aqui */
      '<div id="vnSug" class="vn-sug"></div>'+
      '<label class="cad-lbl" style="margin-top:10px">Telefone / WhatsApp</label><input class="cad-in" id="vnTel" inputmode="tel" placeholder="(00) 00000-0000">'+
      '<button class="cad-btn" id="vnSalvar" style="margin-top:14px">Salvar e vincular</button>'+
      '<div class="cad-msg" id="vnMsg"></div>'+
      '<button type="button" id="vnVoltar" style="background:none;border:none;color:#0a4da6;font-weight:700;font-size:13px;margin-top:12px;cursor:pointer;font-family:inherit;padding:6px">← voltar pra lista</button>';
    var tel=$('vnTel'); if(tel){ tel.oninput=function(){ this.value=foneFmt(this.value); }; tel.addEventListener('paste',function(){ var el=this; setTimeout(function(){ el.value=foneFmt(el.value); },0); }); }
    var nm=$('vnNome'); if(nm){ try{ nm.focus(); }catch(_){} }
    /* ===== v517 (pedido do Angelo) — DIGITAR O NOME FILTRA OS JÁ CADASTRADOS
       "quando for adicionar um carro a um novo cliente, ao ir digitando o
        nome vai filtrando os já cadastrados."
       O problema real: hoje dá pra cadastrar "Alemao" três vezes, e cliente
       duplicado quebra o histórico do carro, o funil e a carteira. Tocar
       numa sugestão VINCULA no que já existe e não cria nada — é este
       atalho que mata a duplicata antes de ela nascer.
       ⚠️ Zero achados = NADA aparece. Nenhum "não encontrado": a tela fica
       exatamente como era. E o campo continua um input comum — nada de
       <select> nem autocomplete de biblioteca.
       ⚠️ Sem ida ao banco: o `_clientes` já veio carregado pelo
       vincularClienteAbrir, e já vem filtrado pela carteira (RLS, v484). */
    if(nm) nm.oninput=function(){
      var el=$('vnSug'); if(!el) return;
      var achados = (typeof cliParecidos==='function') ? cliParecidos(nm.value, 4) : [];
      if(!achados.length){ el.innerHTML=''; return; }
      el.innerHTML='<div class="vn-sug-t">Já cadastrado?</div>'+achados.map(function(c){
        return '<div class="cli-card vn-sug-it" data-vns="'+esc(c.id)+'">'+
          '<div class="cli-av">'+esc(cliIni(c.nome))+'</div>'+
          '<div class="cli-tx"><div class="cli-nm">'+esc(c.nome||'')+'</div>'+
          '<div class="cli-sb">'+esc(c.telefone?_crmFoneFmt(c.telefone):'sem telefone')+'</div></div>'+
          '<span class="vn-sug-vai">usar este</span></div>';
      }).join('');
      Array.prototype.forEach.call(el.querySelectorAll('[data-vns]'),function(card){
        card.onclick=function(){ vincularSalvar(card.getAttribute('data-vns')); };
      });
    };
    $('vnVoltar').onclick=vincularClienteAbrir;
    $('vnSalvar').onclick=async function(){
      var nome=(($('vnNome')||{}).value||'').trim(); var msg=$('vnMsg');
      if(!nome){ if(msg){ msg.className='cad-msg err'; msg.textContent='Digite o nome do cliente.'; } return; }
      /* v517 — a REDE DE SEGURANÇA. Quem ignora as sugestões duplica assim
         mesmo; nome idêntico (sem acento, sem maiúscula) pergunta antes. */
      var _ig=(typeof cliNomeIgual==='function') ? cliNomeIgual(nome) : null;
      if(_ig && !window.__vnForcar){
        if(confirm('Já existe um cliente "'+(_ig.nome||'')+'"'+(_ig.telefone?(' — '+_crmFoneFmt(_ig.telefone)):'')+'.\n\nÉ ele?\n\nOK = usar o que já existe · Cancelar = criar outro')){
          await vincularSalvar(_ig.id); return;
        }
        window.__vnForcar=true;   /* ele decidiu criar outro: não pergunta de novo */
      }
      var telv=(($('vnTel')||{}).value||'').trim(); var btn=this; btn.disabled=true; btn.textContent='Salvando...';
      try{
        var ins={user_id:meuId,nome:nome}; if(telv) ins.telefone=telv;
        var r=await supa.from('clientes').insert(ins).select().single(); if(r&&r.error) throw r.error;
        if(r&&r.data){ _clientes.push(r.data); await vincularSalvar(r.data.id); }
      }catch(e){ btn.disabled=false; btn.textContent='Salvar e vincular'; if(msg){ msg.className='cad-msg err'; msg.textContent='Não consegui criar. '+((e&&e.message)||''); } }
    };
  }

/* ╔═══ src/app/12b-notificacoes.js ═══════════════════════════════════════ */
  /* ==========================================================================
   * v335 — NOTIFICAÇÃO NO CELULAR (Web Push)
   *
   * O QUE RESOLVE: mensagem de cliente chegava no WhatsApp e o lojista só
   * descobria quando abria o app. Agora o celular avisa na hora, com o app
   * FECHADO — igual notificação de WhatsApp.
   *
   * COMO FUNCIONA (3 peças):
   *   1. AQUI  — o sininho na página Clientes pede permissão e "inscreve"
   *      este aparelho. A inscrição vai pro /api/push-inscrever.
   *   2. sw.js — recebe o aviso e mostra a notificação (mesmo app fechado).
   *   3. netlify/functions/_push.js — quem dispara, chamado pelo atendente
   *      quando chega mensagem nova.
   *
   * IPHONE: a Apple só entrega push pra site INSTALADO na tela inicial
   * (Compartilhar → Adicionar à Tela de Início). Se o app estiver rodando
   * dentro do Safari, avisamos isso em português em vez de dar erro seco.
   * ========================================================================== */
  var _pushSub = null;

  function pushSuportado(){
    try{ return ('serviceWorker' in navigator) && ('PushManager' in window) && ('Notification' in window); }
    catch(_){ return false; }
  }
  function _pushEhIos(){ try{ return /iPad|iPhone|iPod/.test(navigator.userAgent); }catch(_){ return false; } }
  function _pushInstalado(){
    try{ return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone===true; }
    catch(_){ return false; }
  }
  /* v1410 — cada instalação informa a identidade do produto ao servidor.
     Isso permite que um aviso exclusivo do MEV Consultas não seja repetido
     nos PWAs MEV Veículos ou MEV Tools vinculados à mesma conta. */
  function pushCanalAtual(){
    try{ return (typeof edicaoAtual==='function'&&edicaoAtual()==='consultas')?'mev-consultas':'mev-veiculos'; }
    catch(_){ return 'mev-veiculos'; }
  }
  async function _pushApi(corpo){
    try{
      var s=await supa.auth.getSession();
      var tk=(s&&s.data&&s.data.session&&s.data.session.access_token)||'';
      var r=await fetch('/api/push-inscrever',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(Object.assign({token:tk},corpo||{}))});
      return await r.json();
    }catch(_){ return null; }
  }
  /* a chave VAPID vem em base64url e o navegador quer bytes crus */
  function _pushChaveBytes(b64){
    var s=String(b64||'').replace(/-/g,'+').replace(/_/g,'/');
    while(s.length%4) s+='=';
    var bin=atob(s), arr=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    return arr;
  }
  async function pushLido(){    /* já está ligado neste aparelho? */
    try{
      if(!pushSuportado() || Notification.permission!=='granted') return false;
      var reg=await navigator.serviceWorker.ready;
      _pushSub=await reg.pushManager.getSubscription();
      return !!_pushSub;
    }catch(_){ return false; }
  }
  async function pushLigar(){
    if(!pushSuportado()){
      toast(_pushEhIos()&&!_pushInstalado()
        ? 'No iPhone, instale o app primeiro: Compartilhar → Adicionar à Tela de Início.'
        : 'Este navegador não aceita notificação. Tente pelo Chrome.');
      return false;
    }
    if(_pushEhIos() && !_pushInstalado()){
      toast('No iPhone só funciona com o app instalado: Compartilhar → Adicionar à Tela de Início.');
      return false;
    }
    var ch=await _pushApi({acao:'chave'});
    if(!ch || !ch.ok || !ch.chave){ toast((ch&&ch.erro)||'Notificações ainda não configuradas no servidor.'); return false; }

    var perm;
    try{ perm=await Notification.requestPermission(); }catch(_){ perm='denied'; }
    if(perm!=='granted'){
      toast('Você bloqueou as notificações. Libere nos ajustes do navegador pra este site.');
      return false;
    }
    try{
      var reg=await navigator.serviceWorker.ready;
      _pushSub=await reg.pushManager.getSubscription();
      if(!_pushSub){
        _pushSub=await reg.pushManager.subscribe({ userVisibleOnly:true, applicationServerKey:_pushChaveBytes(ch.chave) });
      }
      var g=await _pushApi({acao:'inscrever', sub:_pushSub.toJSON(), canal:pushCanalAtual()});
      if(!g || !g.ok){ toast((g&&g.erro)||'Não consegui guardar a inscrição.'); return false; }
      toast('Notificação ligada ✓ mandei um teste pro seu celular');
      _pushApi({acao:'testar'});
      return true;
    }catch(e){ toast('Não consegui ligar. '+((e&&e.message)||'')); return false; }
  }
  async function pushDesligar(){
    try{
      var reg=await navigator.serviceWorker.ready;
      var sub=await reg.pushManager.getSubscription();
      if(sub){ await _pushApi({acao:'remover', endpoint:sub.endpoint}); try{ await sub.unsubscribe(); }catch(_){} }
      _pushSub=null;
      toast('Notificação desligada neste aparelho.');
    }catch(_){}
    return false;
  }
  /* Inscrições antigas já têm endpoint e permissão, mas ainda não têm
     o canal. Sincroniza silenciosamente ao abrir o app; não pede permissão,
     não cria inscrição e não mostra notificação de teste. */
  async function pushCanalSincronizar(){
    try{
      if(!token||!pushSuportado()||Notification.permission!=='granted') return false;
      var reg=await navigator.serviceWorker.ready;
      var sub=await reg.pushManager.getSubscription();
      if(!sub) return false;
      var r=await _pushApi({acao:'inscrever',sub:sub.toJSON(),canal:pushCanalAtual()});
      return !!(r&&r.ok);
    }catch(_){ return false; }
  }
  /* o sininho que aparece na barra da página Clientes */
  function pushSinoHtml(){
    if(!pushSuportado()) return '';
    return '<button type="button" id="pushSino" title="Notificação de mensagem nova" aria-label="Notificação de mensagem nova" '+
      'style="border:1px solid #e2e8f0;background:#fff;border-radius:12px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:0 0 auto">'+
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+
      '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></button>';
  }
  async function pushSinoBind(){
    var b=document.getElementById('pushSino'); if(!b) return;
    function pinta(on){
      b.style.background = on ? '#dcfce7' : '#fff';
      b.style.borderColor = on ? '#86efac' : '#e2e8f0';
      b.style.color = on ? '#15803d' : '#475569';
      b.title = on ? 'Notificação ligada — toque pra desligar' : 'Ativar notificação de mensagem nova';
      b.setAttribute('data-on', on?'1':'0');
    }
    pinta(await pushLido());
    b.onclick=async function(){
      b.disabled=true;
      var on = b.getAttribute('data-on')==='1';
      var novo = on ? await pushDesligar() : await pushLigar();
      pinta(novo); b.disabled=false;
    };
  }
  /* ==========================================================================
   * v550 — LIGAR A NOTIFICAÇÃO SAIU DO ESCONDERIJO
   * (pedido: "apertei, mas apareceu notificações não configuradas no
   *  servidor — permita ativar no sino da top bar na barra inicial; primeiro
   *  acesso já mostre um popup pra ativar")
   *
   * 🔴 O QUE ESTAVA ERRADO ERA ANTES DA TELA: o servidor não tinha as chaves
   * VAPID, então o único caminho que existia (o sininho da página Leads)
   * SEMPRE terminava naquele aviso. A tabela `mp_push` está vazia por isso.
   * As chaves foram geradas e configuradas junto com esta versão.
   *
   * 🔴 E POR ISSO A REGRA Nº 1 DAQUI: **só oferece o que pode dar certo.**
   * Nada de card nem de popup enquanto o servidor não tiver a chave — um
   * convite que só sabe falhar é pior que convite nenhum, e foi exatamente
   * o que aconteceu com ele hoje.
   * ========================================================================== */
  var _pushServidorOk = null;   /* null = ainda não perguntei */
  async function pushServidorPronto(){
    if(_pushServidorOk !== null) return _pushServidorOk;
    var ch = await _pushApi({acao:'chave'});
    _pushServidorOk = !!(ch && ch.ok && ch.chave);
    return _pushServidorOk;
  }
  /* o motivo pelo qual NÃO dá pra ligar aqui — ou '' quando dá */
  function pushImpedimento(){
    if(!pushSuportado()){
      return _pushEhIos()
        ? 'No iPhone, instale o app primeiro: Compartilhar → Adicionar à Tela de Início.'
        : 'Este navegador não aceita notificação. Tente pelo Chrome.';
    }
    if(_pushEhIos() && !_pushInstalado())
      return 'No iPhone só funciona com o app instalado: Compartilhar → Adicionar à Tela de Início.';
    try{ if(Notification.permission==='denied')
      return 'As notificações estão bloqueadas para este site. Libere nos ajustes do navegador.'; }catch(_){}
    return '';
  }

  var PUSH_CARD_LIGADO = false;   /* ⛳ v563 — ver o bloco dentro do montador */
  /* v563: com a notificação já ligada, sobra só isto — uma linha discreta no
     PÉ da página. Continua sendo a porta de desligar, sem ocupar o topo. */
  function pushRodapeDesligar(alvoId){
    var alvo=document.getElementById(alvoId); if(!alvo) return;
    alvo.innerHTML='';
    var pg=alvo.closest ? alvo.closest('.info-pg') : null;
    var pe=document.getElementById('ntfPushPe');
    if(!pe){
      pe=document.createElement('div');
      pe.id='ntfPushPe'; pe.className='push-pe';
      (pg||alvo.parentNode||document.body).appendChild(pe);
    }
    pe.innerHTML='<span>Notificações ligadas neste aparelho.</span>'+
      '<button type="button" id="pushPeBt">Desligar</button>';
    var bt=document.getElementById('pushPeBt');
    if(bt) bt.onclick=async function(){
      bt.disabled=true; bt.textContent='Desligando…';
      await pushDesligar();
      try{ pe.remove(); }catch(_){}
      pushCartaoMontar(alvoId);        /* volta o convite: agora está desligado */
    };
  }
  /* ---- o cartão da página Notificações (onde o sino da topbar leva) ---- */
  async function pushCartaoMontar(alvoId){
    var alvo=document.getElementById(alvoId); if(!alvo) return;
    alvo.innerHTML='';
    if(!await pushServidorPronto()) return;   /* servidor sem chave: nem aparece */
    var impede=pushImpedimento();
    var ligado=await pushLido();
    /* ===== v563 — LIGADO NÃO PRECISA DE CARTÃO ==============================
       Pedido do Angelo (18/08, com print): *"remova a primeira observação de
       notificações ligadas"*.

       O cartão verde é um CONVITE — ele existe pra quem ainda não ligou.
       Depois de ligado vira um aviso permanente ocupando o topo da página
       toda vez, dizendo algo que já está resolvido. Some.

       🔴 MAS O "DESLIGAR" NÃO PODE SUMIR JUNTO. Tirar o cartão inteiro
       tiraria a única forma de desligar a notificação neste aparelho — e
       opção que a pessoa não consegue ver não é escolha, é parede (a lição
       da v549). Então, ligado, sobra uma LINHA discreta no rodapé da página
       em vez do cartão no topo.
       ⛳ PUSH_CARD_LIGADO = true traz o cartão de volta. */
    if(ligado && !PUSH_CARD_LIGADO){ pushRodapeDesligar(alvoId); return; }
    alvo.innerHTML='<div class="push-card'+(ligado?' on':'')+'">'+
      '<div class="push-card-tx"><b>'+(ligado?'Notificações ligadas neste aparelho':'Receber no celular')+'</b>'+
      '<span>'+(ligado
        ? 'Quando um cliente escrever no WhatsApp, o celular avisa mesmo com o app fechado.'
        : (impede || 'O celular avisa quando um cliente escrever, mesmo com o app fechado.'))+'</span></div>'+
      (impede && !ligado ? '' :
        '<button type="button" class="cad-btn'+(ligado?' sec':'')+'" id="pushCardBt">'+
        (ligado?'Desligar':'Ativar')+'</button>')+
    '</div>';
    var bt=document.getElementById('pushCardBt');
    if(bt) bt.onclick=async function(){
      bt.disabled=true; bt.textContent=ligado?'Desligando…':'Ativando…';
      if(ligado) await pushDesligar(); else await pushLigar();
      pushCartaoMontar(alvoId);
    };
  }

  /* ---- o convite do primeiro acesso ----
     ⚠️ UM CONVITE, UMA VEZ. Popup que volta toda sessão é o que faz a pessoa
     aprender a fechar sem ler — e aí o dia em que ele importa, ela fecha
     também. Recusou, não pergunta mais: o cartão da página Notificações fica
     lá pra quando ela quiser.
     ⚠️ E o pedido de permissão TEM que sair de um toque. Navegador nenhum
     aceita `Notification.requestPermission()` sozinho no carregamento — por
     isso o convite é uma folha com botão, não um pedido automático. */
  var PUSH_CONVITE_CHAVE = 'mev_push_convite_v1';
  function _pushJaConvidou(){ try{ return localStorage.getItem(PUSH_CONVITE_CHAVE)==='1'; }catch(_){ return false; } }
  function _pushMarcaConvite(){ try{ localStorage.setItem(PUSH_CONVITE_CHAVE,'1'); }catch(_){} }

  async function pushConvite(forcar){
    try{
      if(document.getElementById('pushConvMask')) return false;
      if(!forcar && _pushJaConvidou()) return false;
      if(!token) return false;                       /* ainda não entrou */
      if(!pushSuportado() || pushImpedimento()) return false;
      try{ if(Notification.permission!=='default') return false; }catch(_){ return false; }
      if(await pushLido()) return false;             /* já está ligado */
      if(!await pushServidorPronto()) return false;  /* nada a oferecer */

      var ov=document.createElement('div'); ov.className='cropmask'; ov.id='pushConvMask';
      ov.innerHTML='<div class="cropbox push-conv">'+
        '<div class="push-conv-ico">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+
        '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></div>'+
        '<div class="crop-tit">Quer ser avisado na hora?</div>'+
        '<p class="push-conv-tx">Quando um cliente escrever no WhatsApp, o celular avisa — mesmo com o app fechado.</p>'+
        '<button type="button" class="cad-btn" id="pushConvSim" style="width:100%">Ativar notificações</button>'+
        '<button type="button" class="link" id="pushConvNao" style="margin-top:8px;width:100%">Agora não</button>'+
      '</div>';
      document.body.appendChild(ov);
      function fecha(){ _pushMarcaConvite(); try{ ov.remove(); }catch(_){} }
      ov.onclick=function(e){ if(e.target===ov) fecha(); };
      document.getElementById('pushConvNao').onclick=fecha;
      document.getElementById('pushConvSim').onclick=async function(){
        var b=document.getElementById('pushConvSim');
        b.disabled=true; b.textContent='Ativando…';
        await pushLigar();          /* o pushLigar já avisa o que deu certo ou não */
        fecha();
      };
      return true;
    }catch(_){ return false; }
  }

  /* duas tentativas e para: na primeira o login às vezes ainda não terminou */
  try{
    setTimeout(function(){ try{ pushCanalSincronizar(); }catch(_){} }, 3500);
    setTimeout(function(){ try{ pushCanalSincronizar(); }catch(_){} }, 18000);
    setTimeout(function(){ try{ pushConvite(); }catch(_){} }, 6000);
    setTimeout(function(){ try{ pushConvite(); }catch(_){} }, 25000);
  }catch(_){}

  /* tocar na notificação com o app já aberto: o sw.js manda a gente pra página */
  try{
    if('serviceWorker' in navigator){
      navigator.serviceWorker.addEventListener('message', function(e){
        try{
          if(e && e.data && e.data.mev==='abrir'){
            if(typeof telaClientes==='function') telaClientes();
            else if(e.data.url) location.href=e.data.url;
          }
        }catch(_){}
      });
    }
  }catch(_){}

/* ╔═══ src/app/12c-funil.js ══════════════════════════════════════════════ */
  /* ======================================================================
     v431 — FUNIL DE VENDAS (PROJETO-FUNIL-DE-VENDAS.txt, fase 1 + o que
     o próprio projeto chamou de "a falha mais cara": próximo passo e
     temperatura)

     A DECISÃO QUE MANDA EM TUDO (seção 3 do projeto): NÃO existe tabela
     nova. O funil é uma VISÃO da mp_vendas — que deixa de ser "vendas" e
     passa a ser "negociações": o registro nasce quando a conversa começa,
     não quando fecha.

        ── FUNIL (esta página) ──────────  ── ENTREGA (página Vendas) ──
        oportunidade → proposta → visita → fechamento │ vendido → entrega
                                                      │ → entregue → posvenda
                        (+ perdido, fora do quadro)

     As duas páginas leem a MESMA coluna `etapa`. Nada diverge — foi o
     erro que a v335 teve que consertar quando a conversa ficou num lugar
     e a ficha em outro.

     ⚠️ mp_clientes.etapa continua sendo SÓ do atendimento. A única
     automação aqui é num sentido só: negócio → cliente (ao vender, o
     cliente vira "comprou"). Nunca o contrário.

     ⚠️ Precisa do sql-v431-funil.sql rodado no Supabase. Sem ele a
     página ABRE e mostra tudo (o select é *), mas gravar próximo passo,
     previsão ou motivo da perda dá erro — por isso o aviso na tela.
     ====================================================================== */
  var FUNIL_ETAPAS=[
    {k:'oportunidade',t:'Oportunidade',peso:0.10,c:'#0a4da6'},
    {k:'proposta',    t:'Proposta',    peso:0.30,c:'#7c3aed'},
    {k:'visita',      t:'Visita',      peso:0.60,c:'#b45309'},
    {k:'fechamento',  t:'Fechamento',  peso:0.85,c:'#16a34a'}
  ];
  /* 'negociacao' é a etapa VELHA da página Vendas: todo negócio que já
     estava lá entra no funil pela primeira coluna, sem migração de dados. */
  var FUNIL_LEGADO='negociacao';
  var FUNIL_MOTIVOS=[
    'Preço — achou caro',
    'Avaliação da troca — não aceitou o valor do usado',
    'Crédito reprovado',
    'Comprou em outra loja',
    'Desistiu / adiou a compra',
    'Não tínhamos o carro certo',
    'Sumiu — nunca mais respondeu',
    'Outro'
  ];
  var _fnEt='oportunidade';   /* a etapa aberta no celular */
  var _fnBusca='';
  var _fnDragId=null;

  /* está no FUNIL? (é o que faz a página Vendas parar de mostrar o mesmo) */
  function funilEtapaDe(v){
    var e=String((v&&v.etapa)||'');
    if(e===FUNIL_LEGADO || !e) return 'oportunidade';
    return e;
  }
  function noFunil(v){
    if(!v || v.fechada) return false;
    var e=String(v.etapa||'');
    if(e===FUNIL_LEGADO || !e) return true;
    return FUNIL_ETAPAS.some(function(x){ return x.k===e; });
  }
  function funilEtapaInfo(k){ return FUNIL_ETAPAS.filter(function(e){ return e.k===k; })[0]||FUNIL_ETAPAS[0]; }

  /* ---- a troca: das colunas novas ou, pra quem já tem cotação, da proposta ---- */
  function _fnTroca(v){
    if(!v) return null;
    if(v.troca_placa || v.troca_avaliacao!=null){
      return { placa:v.troca_placa||'', modelo:v.troca_modelo||'', aval:Number(v.troca_avaliacao)||0 };
    }
    var t=v.proposta&&v.proposta.troca;
    if(t&&t.tem) return { placa:t.placa||'', modelo:t.modelo||'', aval:Number(t.avaliacao)||0 };
    return null;
  }
  /* ---- quando este negócio se mexeu pela última vez ----
     Não é o criado_em nem a data da cotação (a crítica (j) do projeto):
     é a MAIOR data entre a última edição, a entrada na etapa e a última
     mensagem de verdade no WhatsApp. */
  function _fnMovido(v){
    var t=0;
    ['atualizado_em','etapa_em','criado_em'].forEach(function(k){
      var d=Date.parse(v&&v[k]||''); if(d>t) t=d;
    });
    try{
      var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(v.cliente_id); })[0];
      var cv=c?_chatDe(c):null;
      var m=Date.parse((cv&&(cv.ultima_em||cv.atualizado_em))||''); if(m>t) t=m;
    }catch(_){}
    return t||Date.now();
  }
  function _fnDias(ms){ return Math.floor((Date.now()-ms)/864e5); }
  /* ---- TEMPERATURA: o card que chama atenção sozinho (seção 6) ----
     Conta o tempo SEM MOVIMENTO, não o tempo total. */
  function _fnTemp(v){
    var venc=_fnVencido(v);
    if(venc) return {k:'venc',c:'#111827',t:'retorno vencido'};
    var d=_fnDias(_fnMovido(v));
    if(d<=2)  return {k:'ok',   c:'#16a34a', t:d<=0?'hoje':(d+' dia'+(d===1?'':'s'))};
    if(d<=6)  return {k:'morno',c:'#eab308', t:d+' dias parado'};
    if(d<=14) return {k:'frio', c:'#f97316', t:d+' dias parado'};
    return      {k:'gelado',c:'#dc2626', t:d+' dias parado'};
  }
  function _fnVencido(v){
    var d=Date.parse(v&&v.proximo_passo_em||''); if(!d) return false;
    var hoje=new Date(); hoje.setHours(0,0,0,0);
    return d<hoje.getTime();
  }
  function _fnData(s){
    var d=Date.parse(s||''); if(!d) return '';
    var hoje=new Date(); hoje.setHours(0,0,0,0);
    var dif=Math.round((d-hoje.getTime())/864e5);
    if(dif===0) return 'hoje';
    if(dif===1) return 'amanhã';
    if(dif===-1) return 'ontem';
    try{ return new Date(d).toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit'}); }catch(_){ return ''; }
  }
  function _fnMoney(n){ n=Number(n)||0; return n?('R$ '+n.toLocaleString('pt-BR',{maximumFractionDigits:0})):'—'; }

  /* a lista que a tela usa: só o que está no funil, já com a busca */
  function _fnLista(){
    var t=String(_fnBusca||'').toLowerCase().trim();
    return (_vendas||[]).filter(function(v){
      if(!noFunil(v)) return false;
      if(!t) return true;
      return ((v.cliente_nome||'')+' '+(v.veiculo||'')+' '+(v.placa||'')).toLowerCase().indexOf(t)>=0;
    });
  }
  /* ordem dentro da coluna (seção 6): vencido primeiro, depois o mais
     esquecido, depois o de maior valor. É o CONTRÁRIO do "mais recente no
     topo" — o card recente você lembra sozinho. */
  function _fnOrdena(l){
    var ordem={venc:0,gelado:1,frio:2,morno:3,ok:4};
    return l.slice().sort(function(a,b){
      var ta=ordem[_fnTemp(a).k], tb=ordem[_fnTemp(b).k];
      if(ta!==tb) return ta-tb;
      var ma=_fnMovido(a), mb=_fnMovido(b);
      if(ma!==mb) return ma-mb;
      return (Number(b.valor_venda)||0)-(Number(a.valor_venda)||0);
    });
  }

  /* ====================== A PÁGINA ====================== */
  async function telaFunil(){
    mevTabSet('');
    document.body.classList.add('crm-on');   /* solta a largura (mesmo CSS do Clientes) */
    $('secoes').innerHTML='<div class="info-pg fn-pg"><h2>Funil de vendas</h2>'+
      '<div id="fnTopo"></div>'+
      '<div class="fn-acoes">'+
        '<button type="button" class="crm-ab primaria" id="fnNovo">'+_ICO_MAIS2+'Nova negociação</button>'+
        '<div class="cli-search fn-busca">'+_icoBusca+'<input id="fnBusca" placeholder="Cliente, veículo ou placa..." autocomplete="off"></div>'+
      '</div>'+
      '<div id="fnQuadro">'+pgLoad('Montando o funil…')+'</div>'+
    '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block';
    window.scrollTo(0,0); fabFoto(false); voltarTab(voltarHome);
    mevCtx(_ICO_MAIS2,'Nova', function(){ funilNovaAbrir(); });
    $('fnNovo').onclick=function(){ funilNovaAbrir(); };
    $('fnBusca').oninput=function(){ _fnBusca=this.value; funilPinta(); };
    if(!(_vendas||[]).length) await vendaCarregar();
    if(!(_clientes||[]).length){ try{ await cliCarregar(); }catch(_){} }
    if(!(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} }
    try{ _chatResumoCarrega(function(){ funilPinta(); }); }catch(_){}
    funilPinta();
  }

  function funilPinta(){
    var el=$('fnQuadro'); if(!el) return;
    var lista=_fnLista();
    funilTopoPinta();
    var desk=window.matchMedia && window.matchMedia('(min-width:980px)').matches;
    if(desk){
      el.innerHTML='<div class="fn-quadro">'+FUNIL_ETAPAS.map(function(e){
        var da=_fnOrdena(lista.filter(function(v){ return funilEtapaDe(v)===e.k; }));
        var soma=da.reduce(function(s,v){ return s+(Number(v.valor_venda)||0); },0);
        /* aviso de coluna cheia (WIP) — não bloqueia nada, só avisa */
        var wip=(e.k==='proposta'&&da.length>15)?'<div class="fn-wip">muita proposta parada — feche ou perca</div>':'';
        /* ⚠️ <div>, NUNCA <header>: a linha 17 do styles.css tem
           body.tela-interna header{display:none} — e toda página interna do
           app põe essa classe no body. Com <header> o título da coluna some
           da tela (mas continua no HTML, então o teste passa e o olho não
           vê). Mesma armadilha do header{height:48px} da v390. */
        return '<section class="fn-col" data-et="'+e.k+'">'+
          '<div class="fn-ch" style="border-top-color:'+e.c+'">'+
            '<b>'+esc(e.t)+'</b><span class="fn-cn">'+da.length+'</span>'+
            '<i>'+_fnMoney(soma)+'</i></div>'+wip+
          '<div class="fn-cards">'+(da.length?da.map(funilCardHtml).join(''):'<div class="fn-vazio">nada aqui</div>')+'</div>'+
        '</section>';
      }).join('')+'</div>';
      funilLigaDrag(el);
    } else {
      /* celular: fita de etapas + lista (mesmo padrão da página Clientes
         desde a v375). ⚠️ NADA de arrastar em tela pequena — briga com a
         rolagem, foi o problema do dedo na foto (v343/v344). */
      var fita=FUNIL_ETAPAS.map(function(e){
        var da=lista.filter(function(v){ return funilEtapaDe(v)===e.k; });
        var soma=da.reduce(function(s,v){ return s+(Number(v.valor_venda)||0); },0);
        return '<button type="button" class="fn-fb'+(_fnEt===e.k?' on':'')+'" data-et="'+e.k+'">'+
          esc(e.t)+'<span>'+da.length+'</span><i>'+_fnMoney(soma)+'</i></button>';
      }).join('');
      var da2=_fnOrdena(lista.filter(function(v){ return funilEtapaDe(v)===_fnEt; }));
      el.innerHTML='<div class="fn-fita">'+fita+'</div>'+
        '<div class="fn-cards fn-lista">'+(da2.length?da2.map(funilCardHtml).join(''):'<div class="fn-vazio">nada nesta etapa</div>')+'</div>';
      Array.prototype.forEach.call(el.querySelectorAll('.fn-fb'),function(b){
        b.onclick=function(){ _fnEt=b.getAttribute('data-et'); funilPinta(); };
      });
    }
    Array.prototype.forEach.call(el.querySelectorAll('.fn-card'),function(card){
      card.onclick=function(ev){
        if(ev.target.closest && ev.target.closest('.fn-wa')) return;
        funilFichaAbrir(card.getAttribute('data-id'));
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('.fn-wa'),function(b){
      b.onclick=function(ev){ ev.stopPropagation(); var u=b.getAttribute('data-wa'); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } };
    });
  }

  function funilCardHtml(v){
    var t=_fnTemp(v), tr=_fnTroca(v);
    var cli=(_clientes||[]).filter(function(x){ return String(x.id)===String(v.cliente_id); })[0];
    var wa=cli?cliWhatsUrl(cli.telefone):'';
    var quente=cli&&cli.quente;
    var prox=String(v.proximo_passo||'').trim();
    var linhaTroca='';
    if(tr){
      linhaTroca='<div class="fn-l fn-troca">'+esc(('Troca: '+(tr.modelo||tr.placa||'usado')).trim())+
        (tr.aval>0?(' · '+_fnMoney(tr.aval)):' · <b class="fn-alerta">sem avaliação</b>')+'</div>';
    }
    var linhaProx = prox
      ? '<div class="fn-l fn-prox"><b>'+esc(prox)+'</b>'+(v.proximo_passo_em?(' · '+esc(_fnData(v.proximo_passo_em))):'')+'</div>'
      : '<div class="fn-l fn-semprox">sem próximo passo</div>';
    return '<article class="fn-card t-'+t.k+'" data-id="'+esc(v.id)+'" draggable="true" tabindex="0">'+
      '<div class="fn-nm">'+(quente?'<span class="fn-fogo">'+_ICO_FIRE+'</span>':'')+esc(v.cliente_nome||'(sem nome)')+'</div>'+
      '<div class="fn-car">'+esc(v.veiculo||'Veículo')+(v.valor_venda?(' · <b>'+_fnMoney(v.valor_venda)+'</b>'):'')+'</div>'+
      linhaTroca+linhaProx+
      '<div class="fn-pe"><span class="fn-temp">'+esc(t.t)+'</span>'+
        (wa?('<button type="button" class="fn-wa" data-wa="'+esc(wa)+'" title="WhatsApp" aria-label="Chamar '+esc(v.cliente_nome||'cliente')+' no WhatsApp">'+_icoWa+'</button>'):'')+
      '</div>'+
    '</article>';
  }

  /* ---- o topo: os números que substituem o "% do funil" (seção 7) ---- */
  function funilTopoPinta(){
    var box=$('fnTopo'); if(!box) return;
    var lista=_fnLista();
    var emJogo=0, ponderado=0, mes=0;
    var m0=new Date(); m0.setDate(1); m0.setHours(0,0,0,0);
    var m1=new Date(m0.getFullYear(), m0.getMonth()+1, 1).getTime();
    lista.forEach(function(v){
      var val=Number(v.valor_venda)||0;
      emJogo+=val;
      ponderado+=val*funilEtapaInfo(funilEtapaDe(v)).peso;
      var p=Date.parse(v.previsao_fechamento||'');
      if(p && p>=m0.getTime() && p<m1) mes+=val;
    });
    var vend=(_vendas||[]).filter(function(v){
      if(String(v.etapa||'')==='perdido') return false;
      if(noFunil(v)) return false;
      var d=Date.parse(v.fechada_em||v.atualizado_em||'');
      return d>=m0.getTime() && d<m1;
    });
    var perd=(_vendas||[]).filter(function(v){
      if(String(v.etapa||'')!=='perdido') return false;
      var d=Date.parse(v.atualizado_em||'');
      return d>=m0.getTime() && d<m1;
    });
    function soma(l){ return l.reduce(function(s,v){ return s+(Number(v.valor_venda)||0); },0); }
    var semProx=lista.filter(function(v){ return !String(v.proximo_passo||'').trim(); }).length;
    var vencidos=lista.filter(_fnVencido).length;
    var semAval=lista.filter(function(v){ var t=_fnTroca(v); return t && !(t.aval>0); }).length;
    var pend=[];
    if(semProx)  pend.push('<button type="button" class="fn-pend" data-p="semprox">'+semProx+' sem próximo passo</button>');
    if(vencidos) pend.push('<button type="button" class="fn-pend" data-p="venc">'+vencidos+' com retorno vencido</button>');
    if(semAval)  pend.push('<button type="button" class="fn-pend" data-p="semaval">'+semAval+' com troca sem avaliação</button>');
    box.innerHTML='<div class="fn-nums">'+
      '<div class="fn-n"><span>EM JOGO</span><b>'+_fnMoney(emJogo)+'</b><i>'+lista.length+' negocia'+(lista.length===1?'ção':'ções')+'</i></div>'+
      '<div class="fn-n"><span>PREVISÃO PONDERADA</span><b>'+_fnMoney(ponderado)+'</b><i>valor × chance da etapa</i></div>'+
      '<div class="fn-n"><span>FECHA ESTE MÊS</span><b>'+_fnMoney(mes)+'</b><i>com previsão no mês</i></div>'+
      '<div class="fn-n ok"><span>VENDIDO NO MÊS</span><b>'+_fnMoney(soma(vend))+'</b><i>'+vend.length+'</i></div>'+
      '<div class="fn-n ruim"><span>PERDIDO NO MÊS</span><b>'+_fnMoney(soma(perd))+'</b><i>'+perd.length+'</i></div>'+
    '</div>'+(pend.length?('<div class="fn-pends">'+pend.join('')+'</div>'):'');
    Array.prototype.forEach.call(box.querySelectorAll('.fn-pend'),function(b){
      b.onclick=function(){
        var p=b.getAttribute('data-p');
        var alvo=_fnLista().filter(function(v){
          if(p==='semprox') return !String(v.proximo_passo||'').trim();
          if(p==='venc') return _fnVencido(v);
          var t=_fnTroca(v); return t && !(t.aval>0);
        })[0];
        if(alvo) funilFichaAbrir(alvo.id);
      };
    });
  }

  /* ---- arrastar entre colunas (SÓ no computador) ---- */
  function funilLigaDrag(el){
    Array.prototype.forEach.call(el.querySelectorAll('.fn-card'),function(card){
      card.ondragstart=function(ev){
        _fnDragId=card.getAttribute('data-id');
        card.classList.add('arrastando');
        try{ ev.dataTransfer.setData('text/plain',_fnDragId); ev.dataTransfer.effectAllowed='move'; }catch(_){}
      };
      card.ondragend=function(){ card.classList.remove('arrastando'); _fnDragId=null;
        Array.prototype.forEach.call(el.querySelectorAll('.fn-col'),function(c){ c.classList.remove('alvo'); }); };
    });
    Array.prototype.forEach.call(el.querySelectorAll('.fn-col'),function(col){
      col.ondragover=function(ev){ ev.preventDefault(); try{ ev.dataTransfer.dropEffect='move'; }catch(_){} col.classList.add('alvo'); };
      col.ondragleave=function(){ col.classList.remove('alvo'); };
      col.ondrop=function(ev){
        ev.preventDefault(); col.classList.remove('alvo');
        var id=_fnDragId; try{ id=ev.dataTransfer.getData('text/plain')||id; }catch(_){}
        if(id) funilMover(id, col.getAttribute('data-et'));
      };
    });
  }

  /* ---- gravar ---- */
  async function funilSalva(id, patch, silencioso){
    try{
      patch=Object.assign({},patch,{atualizado_em:new Date().toISOString()});
      var r=await supa.from('vendas').update(patch).eq('id',id);
      if(r&&r.error) throw r.error;
      var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
      if(v) Object.assign(v,patch);
      funilPinta();
      return true;
    }catch(e){
      toast('Não consegui salvar. '+((e&&e.message)||''));
      return false;
    }
  }
  async function funilMover(id, etapa){
    var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v || funilEtapaDe(v)===etapa) return;
    await funilSalva(id,{ etapa:etapa, etapa_em:new Date().toISOString() });
  }

  /* ---- ficha da negociação ---- */
  function funilFichaAbrir(id){
    var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v) return;
    var tr=_fnTroca(v), et=funilEtapaDe(v);
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox fn-box"><div class="crop-tit">'+esc(v.cliente_nome||'Negociação')+'</div>'+
      '<div class="fn-sub">'+esc(v.veiculo||'Veículo')+(v.placa?(' · '+esc(v.placa)):'')+'</div>'+
      '<label class="crm-lb">ETAPA</label><div class="fn-steps" id="fnSteps">'+FUNIL_ETAPAS.map(function(e){
        return '<button type="button" class="fn-st'+(e.k===et?' on':'')+'" data-et="'+e.k+'">'+esc(e.t)+'</button>';
      }).join('')+'</div>'+
      '<label class="crm-lb">VALOR DO NEGÓCIO</label><input class="cad-in" id="fnValor" inputmode="numeric" placeholder="R$ 0,00">'+
      '<label class="crm-lb">PRÓXIMO PASSO</label><input class="cad-in" id="fnProx" placeholder="Ex.: mandar simulação">'+
      '<div class="crm-2c"><div style="flex:1"><label class="crm-lb">QUANDO</label><input class="cad-in" id="fnProxEm" type="date"></div>'+
      '<div style="flex:1"><label class="crm-lb">PREVISÃO DE FECHAMENTO</label><input class="cad-in" id="fnPrev" type="date"></div></div>'+
      '<label class="crm-lb">TROCA (PLACA E VALOR AVALIADO)</label><div class="crm-2c">'+
        '<input class="cad-in" id="fnTrPlaca" placeholder="Placa do usado" maxlength="8">'+
        '<input class="cad-in" id="fnTrVal" inputmode="numeric" placeholder="R$ 0,00"></div>'+
      '<button type="button" class="cad-btn" id="fnSalvar" style="margin-top:16px;width:100%">Salvar</button>'+
      '<div class="fn-fim"><button type="button" id="fnVendido" class="ok">Marcar vendido</button>'+
        '<button type="button" id="fnPerdido" class="ruim">Marcar perdido</button></div>'+
      '<div class="fn-foot"><button type="button" id="fnCliente">Abrir o cliente</button>'+
        (v.proposta?'<button type="button" id="fnCot">Abrir a cotação</button>':'')+
        '<button type="button" id="fnFechar">Fechar</button></div>'+
    '</div>';
    document.body.appendChild(ov);
    var q=function(i){ return ov.querySelector('#'+i); };
    q('fnValor').value=v.valor_venda?('R$ '+Number(v.valor_venda).toLocaleString('pt-BR')):'';
    q('fnProx').value=String(v.proximo_passo||'');
    q('fnProxEm').value=String(v.proximo_passo_em||'').slice(0,10);
    q('fnPrev').value=String(v.previsao_fechamento||'').slice(0,10);
    q('fnTrPlaca').value=(tr&&tr.placa)||'';
    q('fnTrVal').value=(tr&&tr.aval)?('R$ '+Number(tr.aval).toLocaleString('pt-BR')):'';
    ['fnValor','fnTrVal'].forEach(function(i){ q(i).addEventListener('input',estMaskRSint); });
    /* v882 — a trava da placa, a mesma do campo da home (01-nucleo).
       Era `.toUpperCase().replace(...)` aqui, que arruma o formato mas aceita
       "111ABCD" numa boa. Agora o caractere fora de posição nem entra. */
    try{ placaLigar(q('fnTrPlaca')); }catch(_){ q('fnTrPlaca').addEventListener('input',function(){ this.value=this.value.toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); }); }
    var etSel=et;
    Array.prototype.forEach.call(ov.querySelectorAll('.fn-st'),function(b){
      b.onclick=function(){
        etSel=b.getAttribute('data-et');
        Array.prototype.forEach.call(ov.querySelectorAll('.fn-st'),function(x){ x.classList.toggle('on', x===b); });
      };
    });
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    q('fnFechar').onclick=close;
    /* v431: quem já tem cotação salva chega no espelho financeiro por aqui.
       É o que permite a aba "Cotações salvas" continuar sendo o arquivo das
       cotações sem virar uma segunda lista de negociação. */
    var _bc=q('fnCot'); if(_bc) _bc.onclick=function(){ close(); vendaNovaAbrir(v.id); };
    q('fnCliente').onclick=function(){ close(); if(v.cliente_id){ telaClientes().then(function(){ try{ crmFichaAbrir(v.cliente_id); }catch(_){} }); } else toast('Esta negociação não tem cliente ligado.'); };
    function num(i){ return parseInt(String(q(i).value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||null; }
    q('fnSalvar').onclick=async function(){
      var p={ valor_venda:num('fnValor'),
        proximo_passo:(q('fnProx').value||'').trim()||null,
        proximo_passo_em:q('fnProxEm').value||null,
        previsao_fechamento:q('fnPrev').value||null,
        troca_placa:(q('fnTrPlaca').value||'').trim()||null,
        troca_avaliacao:num('fnTrVal') };
      if(etSel!==et){ p.etapa=etSel; p.etapa_em=new Date().toISOString(); }
      close();
      await funilSalva(v.id,p);
    };
    q('fnVendido').onclick=async function(){
      close();
      await funilSalva(v.id,{ etapa:'vendido', etapa_em:new Date().toISOString() });
      /* automação num sentido só (seção 3): o negócio mexe no cliente,
         nunca o contrário */
      try{ if(v.cliente_id) await crmSalvaCampo(v.cliente_id,{etapa:'comprou'}); }catch(_){}
      toast('Vendido ✓ — o negócio foi pra página Vendas.');
    };
    q('fnPerdido').onclick=function(){ close(); funilPerderAbrir(v); };
  }

  /* ---- motivo da perda: OBRIGATÓRIO (seção 8) ----
     Trinta segundos de incômodo agora valem o relatório que responde,
     daqui a três meses, "perdi R$ 800 mil em avaliação de troca". */
  function funilPerderAbrir(v){
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox fn-box"><div class="crop-tit">Por que perdeu?</div>'+
      '<div class="fn-sub">'+esc(v.cliente_nome||'')+' · '+esc(v.veiculo||'')+'</div>'+
      '<div class="fn-motivos">'+FUNIL_MOTIVOS.map(function(m,i){
        return '<label class="fn-mot"><input type="radio" name="fnmot" value="'+esc(m)+'"'+(i===0?'':'')+'><span>'+esc(m)+'</span></label>';
      }).join('')+'</div>'+
      '<input class="cad-in" id="fnMotObs" placeholder="Quer detalhar? (opcional)">'+
      '<button type="button" class="cad-btn" id="fnMotOk" style="margin-top:14px;width:100%">Marcar como perdido</button>'+
      '<button type="button" class="link" id="fnMotNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#fnMotNao').onclick=close;
    ov.querySelector('#fnMotOk').onclick=async function(){
      var m=ov.querySelector('input[name="fnmot"]:checked');
      if(!m){ toast('Escolha o motivo — é o que faz esse número ensinar alguma coisa.'); return; }
      var obs=(ov.querySelector('#fnMotObs').value||'').trim();
      close();
      await funilSalva(v.id,{ etapa:'perdido', etapa_em:new Date().toISOString(),
        motivo_perda:m.value, motivo_perda_obs:obs||null });
      toast('Negociação encerrada.');
    };
  }

  /* ---- nova negociação: dois cliques (cliente + carro) ----
     ⚠️ Nada obrigatório além disso (seção 14): o resto se preenche andando. */
  function funilNovaAbrir(clienteId){
    var ov=document.createElement('div'); ov.className='cropmask';
    var cls=(_clientes||[]).slice().sort(function(a,b){ return String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR'); });
    var ests=(_estoque||[]).filter(function(e){ return String(e.status||'disponivel')!=='vendido'; });
    ov.innerHTML='<div class="cropbox fn-box"><div class="crop-tit">Nova negociação</div>'+
      '<label class="crm-lb">CLIENTE</label><select class="cad-in" id="fnNvCli"><option value="">Escolha o cliente...</option>'+
        cls.map(function(c){ return '<option value="'+esc(c.id)+'">'+esc(c.nome||'(sem nome)')+'</option>'; }).join('')+'</select>'+
      '<label class="crm-lb">VEÍCULO</label><select class="cad-in" id="fnNvEst"><option value="">Escolha o carro do estoque...</option>'+
        ests.map(function(e){ return '<option value="'+esc(e.id)+'">'+esc(((e.marca||'')+' '+(e.modelo||'')).trim()||e.veiculo||e.placa||'veículo')+(e.placa?(' · '+esc(e.placa)):'')+'</option>'; }).join('')+'</select>'+
      '<label class="crm-lb">VALOR (OPCIONAL)</label><input class="cad-in" id="fnNvVal" inputmode="numeric" placeholder="R$ 0,00">'+
      '<button type="button" class="cad-btn" id="fnNvOk" style="margin-top:16px;width:100%">Criar em Oportunidade</button>'+
      '<button type="button" class="link" id="fnNvNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    var q=function(i){ return ov.querySelector('#'+i); };
    if(clienteId) q('fnNvCli').value=String(clienteId);
    q('fnNvVal').addEventListener('input',estMaskRSint);
    q('fnNvEst').onchange=function(){
      var e=(_estoque||[]).filter(function(x){ return String(x.id)===this.value; }.bind(this))[0];
      if(e && !q('fnNvVal').value){
        var p=Number(e.preco_anuncio)||Number(e.preco_minimo)||0;
        if(p) q('fnNvVal').value='R$ '+p.toLocaleString('pt-BR');
      }
    };
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    q('fnNvNao').onclick=close;
    q('fnNvOk').onclick=async function(){
      var cid=q('fnNvCli').value, eid=q('fnNvEst').value;
      if(!cid){ toast('Escolha o cliente.'); return; }
      var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(cid); })[0]||{};
      var e=(_estoque||[]).filter(function(x){ return String(x.id)===String(eid); })[0]||null;
      var reg={ user_id:meuId, cliente_id:cid, cliente_nome:c.nome||null,
        estoque_id:e?e.id:null, veiculo:e?(((e.marca||'')+' '+(e.modelo||'')).trim()||e.veiculo||null):(c.interesse||null),
        placa:e?(e.placa||null):null,
        valor_venda:(parseInt(String(q('fnNvVal').value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||null),
        etapa:'oportunidade', etapa_em:new Date().toISOString(), origem:c.origem||null };
      close();
      try{
        var r=await supa.from('vendas').insert(reg).select().single();
        if(r&&r.error) throw r.error;
        if(r&&r.data) _vendas.unshift(r.data);
        funilPinta();
        toast('Negociação criada ✓');
        if(r&&r.data) funilFichaAbrir(r.data.id);
      }catch(err){ toast('Não consegui criar. '+((err&&err.message)||'')); }
    };
  }

/* ╔═══ src/app/12d-chat.js ═══════════════════════════════════════════════ */
  /* ======================================================================
     v433 — PÁGINA CHAT (ATENDENTE)
     Fase 1 do PROJETO-CHAT-ATENDENTE.txt: a página em pé (lista com
     filtros · cadastro do lado · conversa · enviar). O "+" e o
     assumir/devolver ficam pras próximas, como o próprio projeto pediu.

     O PROBLEMA QUE ELA RESOLVE: a conversa do WhatsApp mora DENTRO da
     ficha de um cliente — pra ler é preciso saber de quem é e abrir a
     ficha certa (e desde a v429 a aba nem aparece no computador). Não
     existe lista de "quem está esperando resposta": o cliente pergunta às
     9h, a IA diz "um consultor vai te chamar", e ninguém chama.

     80% disto é MUDANÇA DE LUGAR, de propósito — menos código novo, menos
     coisa pra quebrar. Reaproveita _chatApi, o resumo, as órfãs
     (_orfaCriar), o crmSalvaCampo e os balões .cx-b que já existem.

     ⚠️ DOIS FILTROS DO PROJETO FICARAM DE FORA ("Meu atendimento" e "IA"):
     eles dependem da tabela de quem assumiu, que é da fase 2. Filtro que
     nasce sempre vazio é pior do que filtro nenhum — é a mesma crítica
     que o projeto do Funil fez à coluna "Visita agendada" do Cota.
     ====================================================================== */
  var _chLista=[], _chSel=null, _chFiltro='esperando', _chBusca='';
  var _chTimerConv=null, _chTimerLista=null, _chAba='conversa', _chIndo=false;

  var CH_FILTROS=[
    ['esperando','Esperando'],
    ['naolidas','Não lidas'],
    ['semficha','Sem ficha'],
    ['todas','Todas']
  ];

  /* o cliente que tem este telefone (ou null = conversa sem ficha) */
  function _chCliente(cv){
    var k=_chSuf(cv&&cv.telefone);
    if(!k) return null;
    return (_clientes||[]).filter(function(c){ return _chSuf(c.telefone)===k; })[0]||null;
  }
  function _chSuf(t){ var d=String(t||'').replace(/\D/g,''); return d.length>=8?d.slice(-8):''; }

  /* ---- ESPERANDO: a última mensagem é do cliente e ninguém respondeu ----
     É o único número que importa: quem está com a bola no seu campo. */
  function _chEsperando(cv){ return String(cv&&cv.direcao||'')==='recebida'; }
  function _chEsperaMin(cv){
    var t=Date.parse(cv&&cv.quando||''); if(!t) return 0;
    return Math.max(0, Math.floor((Date.now()-t)/60000));
  }
  /* até 15 min neutro · 15 min a 2 h amarelo · mais de 2 h vermelho */
  function _chEsperaSelo(cv){
    if(!_chEsperando(cv)) return '';
    var m=_chEsperaMin(cv), cls=(m>120?'ruim':(m>15?'alerta':''));
    var txt = m<60 ? (m+' min') : (m<1440 ? (Math.floor(m/60)+' h') : (Math.floor(m/1440)+' d'));
    return '<span class="ch-esp '+cls+'">'+esc(txt)+'</span>';
  }
  function _chHora(q){
    var t=Date.parse(q||''); if(!t) return '';
    var d=new Date(t), hoje=new Date(); hoje.setHours(0,0,0,0);
    if(t>=hoje.getTime()) return ('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2);
    try{ return d.toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit'}); }catch(_){ return ''; }
  }

  function _chFiltra(){
    var t=String(_chBusca||'').toLowerCase().trim();
    var td=t.replace(/\D/g,'');
    return (_chLista||[]).filter(function(cv){
      /* 🔴 v538 — REMOVIDA DO CHAT sai daqui, DENTRO do _chFiltra.
         É de propósito: o `_chConta` conta chamando esta mesma função, então
         os quatro contadores (Esperando · Não lidas · Sem ficha · Todas) e o
         balãozinho do FAB acertam sozinhos. Filtrar na pintura deixaria a
         lista certa e os números mentindo — que é pior do que os dois
         errados, porque ninguém desconfia de um número.
         ⚠️ E a regra é "escondida ENQUANTO a última mensagem for mais velha
         que a remoção": quem escrever de novo volta pra fila (ver 12l). */
      try{ if(typeof chatRemovida==='function' && chatRemovida(cv)) return false; }catch(_){}
      if(_chFiltro==='esperando' && !_chEsperando(cv)) return false;
      if(_chFiltro==='naolidas' && !(cv.nao_lidas>0)) return false;
      if(_chFiltro==='semficha' && _chCliente(cv)) return false;
      if(!t) return true;
      var c=_chCliente(cv);
      var alvo=((cv.nome||'')+' '+((c&&c.nome)||'')+' '+((c&&c.interesse)||'')).toLowerCase();
      if(alvo.indexOf(t)>=0) return true;
      return !!(td && String(cv.telefone||'').replace(/\D/g,'').indexOf(td)>=0);
    }).sort(function(a,b){
      /* no filtro Esperando, a espera MAIOR vem primeiro */
      if(_chFiltro==='esperando') return Date.parse(a.quando||0)-Date.parse(b.quando||0);
      return String(b.quando||'').localeCompare(String(a.quando||''));
    });
  }
  function _chConta(k){
    var salvo=_chFiltro; _chFiltro=k;
    var n=_chFiltra().length; _chFiltro=salvo; return n;
  }

  /* ====================== A PÁGINA ====================== */
  async function telaChat(){
    mevTabSet('');
    document.body.classList.add('crm-on');
    $('secoes').innerHTML='<div class="info-pg chat-pg"><h2>Chat</h2>'+
      '<div id="chTopo"></div>'+
      '<div class="ch-grade">'+
        '<section class="ch-col ch-c1">'+
          '<div class="cli-search ch-busca">'+_icoBusca+'<input id="chBusca" placeholder="Nome, telefone ou veículo" autocomplete="off"></div>'+
          '<div class="ch-filtros" id="chFiltros"></div>'+
          '<div class="ch-conversas" id="chConversas">'+pgLoad('Buscando as conversas…')+'</div>'+
        '</section>'+
        '<section class="ch-col ch-c2" id="chCad"></section>'+
        '<section class="ch-col ch-c3" id="chConv"></section>'+
      '</div>'+
    '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block';
    window.scrollTo(0,0); fabFoto(false); voltarTab(voltarHome);
    mevCtx('','',null);
    $('chBusca').oninput=function(){ _chBusca=this.value; chPinta(); };
    if(!(_clientes||[]).length){ try{ await cliCarregar(); }catch(_){} }
    await chCarregar();
    chLigaRelogio();
  }

  /* ===== v523 — O 12d VIROU **MOTOR**, NÃO SÓ PÁGINA =====================
     (PROJETO-uma-caixa-de-entrada-so, Parte 1)
     O `chCarregar` fazia `var el=$('chConversas'); if(!el) return;` LOGO
     DEPOIS da consulta: sem a página na tela, ele buscava as conversas no
     servidor e **jogava fora**. Enquanto a página era a única dona da fila,
     tudo bem. Agora o painel do balão come da mesma tigela.
     🔴 Então a carga foi separada da pintura:
        · `chCarregar` guarda em `_chLista` SEMPRE;
        · a página se pinta se estiver na tela;
        · o painel se pinta se estiver aberto.
     Nenhuma das duas manda na outra — é o PADRÃO 2 da casa (uma fonte de
     verdade, dois desenhos). E `_chErro` guarda o último erro pra quem
     for pintar depois saber o que dizer. */
  var _chErro='';
  async function chCarregar(silencioso){
    if(_chIndo) return;
    _chIndo=true;
    var d=await _chApiChat({acao:'resumo'});
    _chIndo=false;
    if(!d || !d.ok){
      _chErro=(d&&d.erro)||'Não consegui carregar as conversas.';
      var el0=$('chConversas');
      if(el0 && !silencioso) el0.innerHTML='<div class="cli-empty" style="padding:14px">'+esc(_chErro)+'</div>';
      chRepintaTudo(silencioso);
      return;
    }
    _chErro='';
    _chLista=(d.conversas||[]);
    chRepintaTudo(silencioso);
    /* v525: o servidor pode ter acabado de CRIAR fichas pras conversas que
       não tinham (Parte 2 do projeto da caixa de entrada). Sem recarregar a
       lista de clientes, a etiqueta "sem ficha" continuaria na tela
       mentindo, e o nome do WhatsApp continuaria no lugar do nome da ficha. */
    if(Number(d.fichas_criadas||0) > 0){
      try{ await cliCarregar(); }catch(_){}
      chRepintaTudo(true);
      try{ if($('crmLista')){ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); } }catch(_){}
    }
  }
  /* quem estiver na tela, se pinta. Os dois usam a MESMA _chLista. */
  function chRepintaTudo(silencioso){
    try{ if($('chConversas')) chPinta(); }catch(_){}
    try{ if(typeof cpFilaPinta==='function') cpFilaPinta(); }catch(_){}
  }
  /* usa o mesmo caminho do chat da ficha (token de sessão + /api/chat-whatsapp) */
  function _chApiChat(corpo){ return _chatApi(corpo); }

  function chPinta(){
    var el=$('chConversas'); if(!el) return;
    /* topo: quantos estão esperando */
    var top=$('chTopo');
    if(top){
      var esp=_chConta('esperando');
      top.innerHTML='<div class="ch-topo">'+
        '<span class="ch-selo'+(_chTem()?' on':'')+'">'+(_chTem()?'Atendente IA ligado':'Atendente IA desligado')+'</span>'+
        '<b class="ch-esperando'+(esp?' tem':'')+'">'+esp+' esperando resposta</b></div>';
    }
    var fl=$('chFiltros');
    if(fl){
      fl.innerHTML=CH_FILTROS.map(function(f){
        return '<button type="button" class="ch-fb'+(_chFiltro===f[0]?' on':'')+'" data-f="'+f[0]+'">'+esc(f[1])+'<i>'+_chConta(f[0])+'</i></button>';
      }).join('');
      Array.prototype.forEach.call(fl.querySelectorAll('.ch-fb'),function(b){
        b.onclick=function(){ _chFiltro=b.getAttribute('data-f'); chPinta(); };
      });
    }
    var lista=_chFiltra();
    if(!lista.length){
      el.innerHTML='<div class="cli-empty" style="padding:18px">'+
        (_chFiltro==='esperando'?'<b>Ninguém esperando</b>Todo mundo já foi respondido.':'Nenhuma conversa aqui.')+'</div>';
      return;
    }
    el.innerHTML=lista.map(function(cv){
      var c=_chCliente(cv), k=_chSuf(cv.telefone);
      var nome=(c&&c.nome)||cv.nome||_crmFoneFmt(cv.telefone)||'Sem nome';
      var sel=(_chSel&&_chSuf(_chSel.telefone)===k)?' on':'';
      return '<button type="button" class="ch-item'+sel+'" data-k="'+esc(k)+'">'+
        '<span class="ch-av">'+esc(cliIni(nome))+'</span>'+
        '<span class="ch-tx">'+
          '<span class="ch-l1"><b>'+esc(nome)+'</b><i>'+esc(_chHora(cv.quando))+'</i></span>'+
          '<span class="ch-l2">'+((cv.direcao==='enviada')?'Você: ':'')+esc(String(cv.ultima||'').slice(0,60))+'</span>'+
          '<span class="ch-l3">'+(c?'':'<span class="ch-sf">sem ficha</span>')+_chEsperaSelo(cv)+
            (cv.nao_lidas?('<span class="ch-nn">'+cv.nao_lidas+'</span>'):'')+'</span>'+
        '</span></button>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.ch-item'),function(b){
      b.onclick=function(){ chAbrir(b.getAttribute('data-k')); };
    });
  }
  function _chTem(){ try{ return _chatTem===true; }catch(_){ return false; } }

  /* ---- abrir uma conversa: pinta cadastro + conversa ---- */
  function chAbrir(k){
    var cv=(_chLista||[]).filter(function(x){ return _chSuf(x.telefone)===k; })[0];
    if(!cv) return;
    _chSel=cv; _chAba='conversa';
    document.body.classList.remove('ch-cad-on');
    chPinta();
    chCadPinta();
    chConvPinta(false);
    chLigaConversa();
    document.body.classList.add('ch-fx-on');   /* celular: abre em página cheia */
  }
  function chFechar(){
    _chAba='conversa';
    document.body.classList.remove('ch-fx-on');
    document.body.classList.remove('ch-cad-on');
    if(_chTimerConv){ clearInterval(_chTimerConv); _chTimerConv=null; }
  }

  /* as 2 abas do celular. ⚠️ Entram nas DUAS colunas: no celular só uma
     delas está na tela por vez, e sem isso a conversa ficaria sem caminho
     de volta pro cadastro. No computador o CSS esconde. */
  function _chAbasHtml(){
    return '<div class="ch-abas">'+
      '<button type="button" class="ch-ab'+(_chAba==='conversa'?' on':'')+'" data-ab="conversa">Conversa</button>'+
      '<button type="button" class="ch-ab'+(_chAba==='cadastro'?' on':'')+'" data-ab="cadastro">Cadastro</button></div>';
  }
  function _chAbasLiga(el){
    Array.prototype.forEach.call(el.querySelectorAll('.ch-ab'),function(b){
      b.onclick=function(){ _chAbaIr(b.getAttribute('data-ab')); };
    });
  }
  function _chAbaIr(ab){
    _chAba=(ab==='cadastro')?'cadastro':'conversa';
    document.body.classList.toggle('ch-cad-on', _chAba==='cadastro');
    chCadPinta();
    var el=$('chConv'); if(el){ var m=el.querySelector('.ch-abas'); if(m) _chAbasMarca(m); }
  }
  function _chAbasMarca(box){
    Array.prototype.forEach.call(box.querySelectorAll('.ch-ab'),function(b){
      b.classList.toggle('on', b.getAttribute('data-ab')===_chAba);
    });
  }

  /* ---- COLUNA 2: o cadastro (os mesmos campos da ficha de Clientes) ---- */
  /* ===== v524 — O MINI-CADASTRO VIROU PEÇA, NÃO COLUNA ===================
     (PROJETO-uma-caixa-de-entrada-so, Parte 1 — a terceira das "três coisas
      que não podem se perder")

     "Anotar veículo de interesse e faixa de preço no meio da conversa é o
      que faz o relatório do dia ter conteúdo."

     Só que isso morava numa COLUNA — e coluna não cabe no painel do balão.
     Então os campos saíram da coluna e viraram duas funções sem tela:
       · `chCadCamposHtml(c, cv, p)` — o HTML dos campos;
       · `chCadLiga(c, cv, p, apos)` — as máscaras, o pacote e o Salvar.
     A PÁGINA embrulha isso numa coluna; o PAINEL embrulha numa faixa
     dobrável. Mesmo formulário, mesmo `crmSalvaCampo`, dois embrulhos.

     🔴 O `p` (prefixo dos ids) NÃO é enfeite: o painel abre POR CIMA da
     página Chat. Sem prefixo, existiriam dois `#chNome` na mesma tela e o
     `$()` pegaria sempre o primeiro — você digitaria num e salvaria o
     outro. Página usa 'ch'; painel usa 'cpc'. */
  function chCadCamposHtml(c, cv, p){
    return (c?('<div class="ch-cad-acts">'+
        '<button type="button" id="'+p+'Tag" title="Mudar etiqueta">'+_ICO_TAG+'</button>'+
        '<button type="button" id="'+p+'Fire" class="'+(c.quente?'on':'')+'" title="Lead quente">'+_ICO_FIRE+'</button>'+
        '<button type="button" id="'+p+'Cal" title="Agendar">'+_ICO_CAL+'</button>'+
      '</div>'):'')+
    '<label class="crm-lb">NOME</label><input class="cad-in" id="'+p+'Nome" placeholder="Nome do cliente">'+
    '<label class="crm-lb">TELEFONE</label><input class="cad-in" id="'+p+'Tel" inputmode="tel" placeholder="(00) 00000-0000">'+
    '<label class="crm-lb">CIDADE / UF</label><div class="crm-2c"><input class="cad-in" id="'+p+'Cidade" placeholder="Cidade"><input class="cad-in" id="'+p+'Uf" maxlength="2" placeholder="UF" style="max-width:74px"></div>'+
    '<label class="crm-lb">VEÍCULO DE INTERESSE</label><input class="cad-in" id="'+p+'Int" placeholder="Modelo">'+
    '<label class="crm-lb">FAIXA DE PREÇO</label><input class="cad-in" id="'+p+'Val" inputmode="numeric" placeholder="R$ 0,00">'+
    '<label class="crm-lb">FAIXA DE PARCELA</label><input class="cad-in" id="'+p+'Parc" inputmode="numeric" placeholder="R$ 0,00">'+
    '<label class="crm-lb">ORIGEM DO LEAD</label><select class="cad-in" id="'+p+'Origem"><option value="">Origem do lead...</option>'+
      CRM_ORIGENS.map(function(o){ return '<option'+((c&&c.origem===o)?' selected':'')+'>'+esc(o)+'</option>'; }).join('')+'</select>'+
    (c?('<button type="button" class="cad-btn" id="'+p+'Salvar" style="margin-top:14px;width:100%">Salvar</button>'+
        '<button type="button" class="crm-mais-link" id="'+p+'Completo">Cadastro completo</button>')
      :('<button type="button" class="cad-btn" id="'+p+'Criar" style="margin-top:14px;width:100%">Salvar cliente</button>'+
        '<div class="ch-semficha">Esta conversa ainda não tem ficha.</div>'));
  }
  function chCadLiga(c, cv, p, apos){
    var q=function(i){ return $(p+i); };
    if(!q('Nome')) return;
    var fone=String((c&&c.telefone)||(cv&&cv.telefone)||'');
    q('Nome').value=(c&&c.nome)||(cv&&cv.nome)||'';
    q('Tel').value=fone?foneFmt(fone):'';
    q('Cidade').value=(c&&c.cidade)||'';
    q('Uf').value=(c&&c.uf)||'';
    q('Int').value=(c&&c.interesse)||'';
    q('Val').value=(c&&c.faixa_preco)?_crmMoney(c.faixa_preco):'';
    q('Parc').value=(c&&c.faixa_parcela)?_crmMoney(c.faixa_parcela):'';
    q('Tel').addEventListener('input',function(){ this.value=foneFmt(this.value); });
    q('Uf').addEventListener('input',function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); });
    ['Val','Parc'].forEach(function(i){ q(i).addEventListener('input',estMaskRSint); });
    function num(i){ return parseInt(String(q(i).value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||null; }
    function pacote(){
      return { nome:(q('Nome').value||'').trim()||'Cliente', telefone:(q('Tel').value||'').replace(/\D/g,'')||null,
        cidade:(q('Cidade').value||'').trim()||null, uf:(q('Uf').value||'').trim()||null,
        interesse:(q('Int').value||'').trim()||null, faixa_preco:num('Val'), faixa_parcela:num('Parc'),
        origem:(q('Origem').value||'')||null };
    }
    function fim(){ if(typeof apos==='function') apos(); }
    if(c){
      q('Salvar').onclick=async function(){ await crmSalvaCampo(c.id, pacote()); fim(); toast('Cadastro salvo ✓'); };
      q('Completo').onclick=function(){ cliAbrirFicha(c.id); };
      var bt=q('Tag'); if(bt) bt.onclick=function(){ crmEtapaPicker(c); };
      var bf=q('Fire'); if(bf) bf.onclick=async function(){ await crmSalvaCampo(c.id,{quente:!c.quente}); fim(); };
      var bc=q('Cal'); if(bc) bc.onclick=function(){ crmAgendar(c); };
    } else {
      q('Criar').onclick=async function(){
        /* reaproveita o mesmo caminho da conversa órfã da v335 */
        var novo=await _orfaCriar({ telefone:(cv&&cv.telefone), nome:(q('Nome').value||(cv&&cv.nome)||'') });
        if(novo){
          var pk=pacote(); delete pk.nome; delete pk.telefone;
          var tem=Object.keys(pk).some(function(x){ return pk[x]!=null; });
          if(tem) await crmSalvaCampo(novo.id,pk);
          fim();
        }
      };
    }
  }
  function chCadPinta(){
    var el=$('chCad'); if(!el) return;
    var cv=_chSel;
    if(!cv){ el.innerHTML='<div class="cli-empty" style="margin-top:40px"><b>Escolha uma conversa</b></div>'; return; }
    var c=_chCliente(cv);
    el.innerHTML=_chAbasHtml()+'<div class="ch-cad">'+chCadCamposHtml(c,cv,'ch')+'</div>';
    _chAbasLiga(el);
    chCadLiga(c, cv, 'ch', function(){ chCadPinta(); });
  }

  /* ---- COLUNA 3: a conversa ---- */
  function chConvPinta(silencioso){
    var el=$('chConv'); if(!el) return;
    var cv=_chSel;
    if(!cv){ el.innerHTML='<div class="cli-empty" style="margin-top:40px"><b>Nenhuma conversa aberta</b></div>'; return; }
    var c=_chCliente(cv);
    var nome=(c&&c.nome)||cv.nome||_crmFoneFmt(cv.telefone);
    if(!$('chMsgs')){
      el.innerHTML=_chAbasHtml()+
        '<div class="ch-ch"><button type="button" class="ch-volta" id="chVolta" aria-label="Voltar">'+
          _cIco('<polyline points="15 18 9 12 15 6"/>')+'</button>'+
          '<span class="ch-av">'+esc(cliIni(nome))+'</span>'+
          '<span class="ch-cht"><b>'+esc(nome)+'</b><i>'+esc(_crmFoneFmt(cv.telefone))+'</i></span>'+
          (cliWhatsUrl(cv.telefone)?('<button type="button" class="ch-wa" id="chWa" title="Abrir no WhatsApp">'+_icoWa+'</button>'):'')+
        '</div>'+
        '<div class="ch-msgs" id="chMsgs">'+pgLoad('Abrindo a conversa…')+'</div>'+
        '<div class="ch-barra"><textarea class="cad-in" id="chIn" rows="1" placeholder="Escreva a mensagem..."></textarea>'+
          '<button type="button" class="crm-send" id="chEnviar" title="Enviar">'+
          _cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>';
      _chAbasLiga(el);
      var bv=$('chVolta'); if(bv) bv.onclick=chFechar;
      var bw=$('chWa'); if(bw) bw.onclick=function(){ var u=cliWhatsUrl(cv.telefone); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } };
      $('chEnviar').onclick=chEnviar;
      $('chIn').addEventListener('keydown',function(e){ if(e.key==='Enter'&&!e.shiftKey){ e.preventDefault(); chEnviar(); } });
    }
    chMsgsPinta(silencioso);
  }
  async function chMsgsPinta(silencioso){
    var cv=_chSel; if(!cv) return;
    var fone=String(cv.telefone||'').replace(/\D/g,'');
    var d=await _chApiChat({acao:'listar',telefone:fone});
    var box=$('chMsgs'); if(!box || !_chSel || _chSuf(_chSel.telefone)!==_chSuf(cv.telefone)) return;
    if(!d || !d.ok){
      if(!silencioso) box.innerHTML='<div class="cli-empty" style="padding:14px">'+esc((d&&d.erro)||'Não consegui abrir a conversa.')+'</div>';
      return;
    }
    var msgs=d.mensagens||[];
    if(!msgs.length){ box.innerHTML='<div class="cli-empty" style="padding:14px">Nenhuma mensagem ainda.</div>'; return; }
    var noFim = box.scrollTop+box.clientHeight >= box.scrollHeight-60;
    var diaAnt='';
    box.innerHTML=msgs.map(function(m){
      var dt=new Date(m.criado_em);
      var dia=''; try{ dia=dt.toLocaleDateString('pt-BR'); }catch(_){}
      var sep='';
      if(dia && dia!==diaAnt){ diaAnt=dia; sep='<div class="ch-dia">'+esc(_chDiaTxt(dt))+'</div>'; }
      var hh=('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
      var media=m.midia_url?('<a href="'+esc(m.midia_url)+'" target="_blank" rel="noopener">'+(m.midia_tipo==='image'?'[foto] ':'[anexo] ')+'</a>'):'';
      return sep+'<div class="cx-b '+(m.direcao==='enviada'?'eu':'ele')+'">'+media+esc(m.texto||'')+'<i>'+hh+'</i></div>';
    }).join('');
    if(noFim||!silencioso) box.scrollTop=box.scrollHeight;
    /* as não lidas viraram lidas no servidor — a lista precisa saber */
    if(cv.nao_lidas){ cv.nao_lidas=0; chPinta(); }
  }
  function _chDiaTxt(dt){
    var hoje=new Date(); hoje.setHours(0,0,0,0);
    var d0=new Date(dt); d0.setHours(0,0,0,0);
    var dif=Math.round((hoje.getTime()-d0.getTime())/864e5);
    if(dif===0) return 'Hoje';
    if(dif===1) return 'Ontem';
    try{ return dt.toLocaleDateString('pt-BR'); }catch(_){ return ''; }
  }
  async function chEnviar(){
    var inEl=$('chIn'); if(!inEl || !_chSel) return;
    var t=String(inEl.value||'').trim(); if(!t) return;
    var fone=String(_chSel.telefone||'').replace(/\D/g,'');
    inEl.disabled=true;
    var r=await _chApiChat({acao:'enviar',telefone:fone,texto:t});
    /* ===== v510 — AS DUAS TRAVAS QUE SALVAM O CHIP =====
       Quem BARRA é o servidor (chat-whatsapp.js); aqui é só a conversa com
       a pessoa. Duas respostas novas:
        · nunca_escreveu → não tem o que confirmar. Quem nunca te chamou não
          espera você aparecer, e é essa mensagem que vira bloqueio/denúncia
          — que é o que derruba número na Z-API. O texto FICA no campo.
        · esfriou → passou de 24h desde a última dele. Não proíbo: pergunto.
          Confirmou, mando de novo com `confirmo:true` e o servidor deixa
          passar. Uso `confirm` de propósito (e não toast, que some em 2s):
          a pessoa acabou de tocar em enviar e precisa DECIDIR. */
    if(r && r.bloqueio==='esfriou'){
      var _q=(r.erro||'Faz tempo que ele não escreve.')+
             '\n\nQuem recebe mensagem depois de sumir é quem mais bloqueia — e bloqueio derruba o número da loja.\n\nMandar mesmo assim?';
      var _vai=false; try{ _vai=confirm(_q); }catch(_){ _vai=false; }
      if(_vai) r=await _chApiChat({acao:'enviar',telefone:fone,texto:t,confirmo:true});
      else { inEl.disabled=false; try{ inEl.focus(); }catch(_){} return; }
    }
    inEl.disabled=false;
    if(r&&r.ok){
      inEl.value='';
      /* responder pelo app JÁ cala a IA por 30 min — a regra é do servidor */
      _chSel.ultima=t; _chSel.direcao='enviada'; _chSel.quando=new Date().toISOString();
      chPinta(); chMsgsPinta(false);
    } else if(r && r.bloqueio==='nunca_escreveu'){
      try{ alert(r.erro); }catch(_){ toast(r.erro); }   /* o texto continua no campo */
    } else toast((r&&r.erro)||'Não consegui enviar.');
    try{ inEl.focus(); }catch(_){}
  }

  /* ---- relógios: a conversa a cada 8s, a lista a cada 20s ---- */
  function chLigaConversa(){
    if(_chTimerConv) clearInterval(_chTimerConv);
    _chTimerConv=setInterval(function(){
      if($('chMsgs')) chMsgsPinta(true); else { clearInterval(_chTimerConv); _chTimerConv=null; }
    },8000);
  }
  function chLigaRelogio(){
    if(_chTimerLista) clearInterval(_chTimerLista);
    _chTimerLista=setInterval(function(){
      if($('chConversas')) chCarregar(true);
      else { clearInterval(_chTimerLista); _chTimerLista=null; if(_chTimerConv){ clearInterval(_chTimerConv); _chTimerConv=null; } }
    },20000);
  }

/* ╔═══ src/app/12e-pos-vendas.js ═════════════════════════════════════════ */
  /* ======================================================================
     v434 — PÓS-VENDAS (fase 1 do PROJETO-POS-VENDAS.txt)

     O PROBLEMA: quando o carro sai da loja, o cliente some do radar.
     Ninguém lembra de ligar em 7 dias, ninguém sabe quando a garantia
     vence, ninguém sabe que ele faz aniversário amanhã e ninguém avisa
     que o carro completou 1 ano — que é exatamente a hora de oferecer a
     troca.

     A REGRA DE OURO DA TELA: o vendedor NÃO decide quem ligar. O app
     decide e mostra, com o texto já escrito.

     ⚠️ A página não é um cadastro novo: é uma LEITURA cruzada do que já
     existe (mp_vendas fechada=true × mp_clientes × mp_estoque). A data da
     compra mora em mp_vendas e em lugar nenhum mais (PADRÃO 2).

     ⚠️ PRECISA do sql-v434-posvenda.sql (uma coluna jsonb). Sem ele a
     página ABRE e LISTA tudo (o select é *), mas marcar contato feito /
     adiar / pausar dá erro — e o toast diz exatamente isso.
     ====================================================================== */

  /* A RÉGUA. Cada linha vira, no dia certo, um item na lista do dia.
     dias = a partir da entrega. aniv = repete todo ano. */
  var PV_REGUA=[
    {k:'d2',   dias:2,   t:'Chegou tudo certo?'},
    {k:'d7',   dias:7,   t:'Como está o carro?'},
    {k:'d30',  dias:30,  t:'Documentação resolvida?'},
    {k:'d75',  dias:75,  t:'Garantia vence em 15 dias'},
    {k:'d90',  dias:90,  t:'Fim da garantia — revisão'},
    {k:'d180', dias:180, t:'Revisão de 6 meses'}
  ];
  var PV_ANOS=[1,2,3];
  var PV_GARANTIA_DIAS=90;   /* o mínimo do Código do Consumidor */

  /* Os textos prontos. ⚠️ Fase 4 do projeto: editáveis na Minha loja.
     Chaves: {nome} {primeiro_nome} {veiculo} {placa} {ano} {loja}
             {vendedor} {data_compra} {garantia_fim} */
  var PV_MSG={
    d2:   'Oi {primeiro_nome}, aqui é o {vendedor} da {loja}. Passando pra saber se chegou tudo certo com o {veiculo}.',
    d7:   'Oi {primeiro_nome}, aqui é o {vendedor} da {loja}. Faz uma semana que você pegou o {veiculo} — está tudo certo com ele?',
    d30:  'Oi {primeiro_nome}! Um mês do {veiculo}. A documentação já foi resolvida? Se precisar de alguma coisa, é só me chamar.',
    d75:  'Oi {primeiro_nome}, a garantia do seu {veiculo} vence dia {garantia_fim}. Se quiser trazer pra uma revisão antes disso, eu agendo.',
    d90:  'Oi {primeiro_nome}, a garantia do {veiculo} encerrou. Vale fazer uma revisão preventiva — quer que eu agende?',
    d180: 'Oi {primeiro_nome}, seis meses do {veiculo}. Já pensou na revisão? Posso agendar pra você.',
    aniv: 'Oi {primeiro_nome}, feliz aniversário! Um abraço da {loja}.',
    ano:  'Oi {primeiro_nome}! Hoje faz {n} ano(s) do seu {veiculo}. Se quiser, eu faço uma avaliação de troca sem compromisso e te mando o valor hoje mesmo.'
  };

  var _pvVendas=[], _pvSelo='', _pvFiltro='', _pvBusca='', _pvSel=null;

  /* ---------- datas ---------- */
  function _pvHoje(){ var d=new Date(); d.setHours(0,0,0,0); return d; }
  function _pvDia(s){ var t=Date.parse(s||''); if(!t) return null; var d=new Date(t); d.setHours(0,0,0,0); return d; }
  function _pvMais(d,n){ var x=new Date(d.getTime()); x.setDate(x.getDate()+n); return x; }
  function _pvDif(d){ return Math.round((d.getTime()-_pvHoje().getTime())/864e5); }
  function _pvData(d){ if(!d) return '—'; try{ return d.toLocaleDateString('pt-BR'); }catch(_){ return '—'; } }
  function _pvQuando(d){
    var n=_pvDif(d);
    if(n===0) return 'hoje';
    if(n===1) return 'amanhã';
    if(n===-1) return 'ontem';
    if(n<0) return Math.abs(n)+' dias atrás';
    return _pvData(d);
  }
  /* ===== v807 (§10 do PROJETO-leads-clientes-cadastro-historico) =========
     A LINGUAGEM DE PRAZO DO CARD: Hoje · Amanhã · Em N dias · Atrasada há N.

     🔴 POR QUE UMA FUNÇÃO NOVA EM VEZ DE MEXER NO `_pvQuando`: aquele é
     usado também na AGENDA da ficha (linha ~869), onde a lista é de eventos
     futuros e "12/09" é a resposta certa — "Em 11 dias" numa agenda de doze
     linhas vira aritmética mental. São dois trabalhos diferentes; forçar um
     texto só pioraria o outro.

     ⚠️ O §10 pede pra evitar "61 dias atrás" — a palavra ATRASADA é o que
     diz que aquilo era pra ter acontecido. E o card mostra o nome da tarefa
     logo acima, que é a outra metade do pedido ("sem explicar qual tarefa
     está atrasada"). */
  function pvPrazoTxt(d){
    var n=_pvDif(d);
    if(n===0) return 'Hoje';
    if(n===1) return 'Amanhã';
    if(n>1)  return 'Em '+n+' dias';
    var a=Math.abs(n);
    return 'Atrasada há '+a+' dia'+(a===1?'':'s');
  }
  /* §10: "vermelho somente para tarefa vencida ou erro; verde para
     concluído/em dia; âmbar para atenção ainda dentro do prazo." */
  function pvPrazoCls(d){
    var n=_pvDif(d);
    if(n<0) return 'atras';        /* vencida  → vermelho */
    if(n<=2) return 'perto';       /* hoje/2 dias → âmbar */
    return 'ok';                   /* em dia → verde */
  }

  /* ---------- a fonte: quem entra no pós-venda ---------- */
  function _pvEntrega(v){
    return _pvDia(v&&(v.data_entrega||v.data_venda||v.fechada_em||v.criado_em));
  }
  function _pvPv(v){ var p=(v&&v.posvenda)||{}; return (typeof p==='object'&&p)?p:{}; }
  function _pvFeitos(v){ var f=_pvPv(v).feitos; return Array.isArray(f)?f:[]; }
  function _pvAdiado(v,k){ return _pvDia((_pvPv(v).adiado||{})[k]); }
  function _pvPausado(v){ return _pvPv(v).pausado===true; }
  /* v459 (pedido): venda de repasse nao e cliente final — so confere a doc */
  function _pvRepasse(v){ return _pvPv(v).repasse===true; }
  /* ===== v460 — MANUTENCAO (reclamacao · data · solucao · acompanhamento).
     Mora no jsonb posvenda.manutencoes — sem SQL. Registrada e acompanhada
     pela FICHA da venda; o cartao do topo e o filtro contam as abertas. */
  function _pvManuts(v){ var m=_pvPv(v).manutencoes; return Array.isArray(m)?m:[]; }
  function _pvManutAbertas(v){ return _pvManuts(v).filter(function(m){ return m&&m.status!=='resolvida'; }); }

  /* ---------- GARANTIA: UMA função só, usada pela tabela, pela ficha e
       (na fase 3) pelo robô. É o PADRÃO 2 do projeto. ---------- */
  /* ===== v521 — ENTREGA PENDENTE (PROJETO-entrega-pendente) ===============
     PEDIDO: "permita marcar o cliente como entrega pendente (acompanhar)."

     O ESTADO QUE FALTAVA: o app conhecia LEAD (negociando) e PÓS-VENDA
     (comprou E RECEBEU). Faltava o do meio — comprou, assinou, e o carro
     ainda não saiu — que na concessionária é o mais comum: veículo em
     trânsito, faturamento, emplacamento, acessório, pintura.
     (No print do Angelo isso aparecia sozinho: no campo VEÍCULO estava
     escrito "COMPROU". Quando alguém usa um campo pra dizer outra coisa,
     é a tela que está faltando.)

     🔴 A ARMADILHA — DEIXAR A DATA VAZIA NÃO É NEUTRO. O `_pvEntrega` tem
     fallback em cascata: sem `data_entrega` ele cai no `data_venda`, no
     `fechada_em` e por fim no `criado_em`. **O pós-venda não fica sem
     data: ele INVENTA uma** — e a partir dela nascem a garantia, a régua
     de contatos e o aniversário de 1 ano. Carro que só vai ser entregue
     daqui a 40 dias começaria com "Documentação em 18 dias".
     ➜ Por isso a venda pendente fica FORA da régua, explicitamente. Data
       vazia não basta: precisa da bandeira. */
  function _pvPendente(v){ return _pvPv(v).entrega_pendente===true; }
  function _pvPrevisao(v){ return _pvDia(_pvPv(v).previsao); }
  function _pvPendenteDias(v){
    var d=_pvDia(_pvPv(v).pendente_desde)||_pvDia(v&&(v.fechada_em||v.criado_em));
    return d ? Math.max(0, -_pvDif(d)) : 0;
  }
  /* atrasada = passou da previsão, ou passou de 30 dias sem previsão.
     Uma entrega esquecida é um cliente que pagou e ficou sem notícia — é o
     pior lugar do funil pra ter silêncio. */
  function _pvPendenteAtrasada(v){
    var p=_pvPrevisao(v);
    if(p) return _pvDif(p)<0;
    return _pvPendenteDias(v)>30;
  }

  /* ===== v527 — QUEM COMPROU E AINDA NÃO TEM VENDA LANÇADA ==============
     (PROJETO-a-pagina-vira-leads..., FASE 1 — a que vem ANTES de esconder
      qualquer coisa)

     Medido: 16 fichas marcadas como "comprou" NÃO têm venda lançada. Hoje
     elas aparecem só numa FAIXA DE AVISO desta página — não na lista. Isso
     não machuca porque a página de Clientes (a antiga) ainda as mostra. No
     dia em que Leads parar de mostrá-las (v528), elas ficariam **sem tela
     nenhuma**. Por isso entram na LISTA agora.

     🔴 Elas entram como uma venda de MENTIRA (`__semVenda`) montada a
     partir da ficha. E, como a venda pendente da v521, ficam FORA da régua
     e FORA da garantia: sem venda lançada não há data de entrega, e o
     `_pvEntrega` cai silenciosamente no `criado_em` — a garantia contaria
     do dia do cadastro. O card diz o que falta e oferece o caminho. */
  function _pvSemVenda(v){ return !!(v && v.__semVenda); }
  /* v530: 0 km — o que explica a venda sem placa */
  function _pvZeroKm(v){ return _pvPv(v).zero_km===true; }
  function _pvPlacaHtml(v){
    if(v && v.placa) return '<span class="pv-pl">'+esc(v.placa)+'</span>';
    return _pvZeroKm(v) ? '<span class="pv-pl pv-zero">0 km</span>' : '';
  }
  function _pvComoVenda(c){
    return { id:'sv:'+c.id, __semVenda:true, cliente_id:c.id, cliente_nome:c.nome||'',
      telefone:c.telefone||'', veiculo:c.interesse||'', placa:'', fechada:true,
      criado_em:(c.atualizado_em||c.criado_em||null), posvenda:{} };
  }

  function pvGarantia(v){
    /* 🔴 guard do pendente: sem ele o `_pvEntrega` cai no fallback e esta
       função devolveria uma garantia que AINDA NÃO COMEÇOU. E ela é usada
       pela tabela, pela ficha e pelo robô — se vazar, vaza em três lugares. */
    if(_pvPendente(v)) return null;
    if(_pvSemVenda(v)) return null;   /* v527: sem venda, não há o que garantir */
    var g=_pvPv(v).garantia||{};
    var ini=_pvDia(g.inicio)||_pvEntrega(v);
    if(!ini) return null;
    var dias=(Number(g.dias)>0)?Number(g.dias):PV_GARANTIA_DIAS;
    var fim=_pvDia(g.fim)||_pvMais(ini,dias);
    var faltam=_pvDif(fim);
    return { inicio:ini, fim:fim, dias:dias, faltam:faltam,
      estado: faltam<0 ? 'fora' : (faltam<=15 ? 'vencendo' : 'na') };
  }

  /* ---------- A RÉGUA: qual é o PRÓXIMO contato desta venda ---------- */
  function pvEventos(v){
    /* 🔴 v521 — A ÚNICA COISA A FAZER NUMA VENDA PENDENTE É ENTREGAR.
       Nada de garantia, documentação ou aniversário: nenhum deles faz
       sentido antes de o carro sair. Sem este guard, cada venda pendente
       viraria um cliente sendo cobrado de documentação de um carro que
       ainda não recebeu. */
    if(_pvPendente(v)){
      return [{ k:'entrega', quando:(_pvPrevisao(v)||_pvHoje()), titulo:'Confirmar a entrega' }];
    }
    /* 🔴 v527 — pelo mesmo motivo, a ficha SEM VENDA LANÇADA não tem régua:
       não se sabe o que foi vendido nem quando. Cobrar "revisão de 30 dias"
       de uma data inventada é pior do que não cobrar nada. O que falta aqui
       é lançar a venda, e é isso que o card mostra. */
    if(_pvSemVenda(v)) return [];
    var ent=_pvEntrega(v); if(!ent) return [];
    var feitos=_pvFeitos(v), out=[];
    function poe(k,quando,titulo,extra){
      if(!quando) return;
      if(feitos.indexOf(k)>=0) return;
      var ad=_pvAdiado(v,k); if(ad && ad>quando) quando=ad;
      out.push(Object.assign({k:k, quando:quando, titulo:titulo}, extra||{}));
    }
    PV_REGUA.forEach(function(r){ poe(r.k,_pvMais(ent,r.dias),r.t); });
    /* aniversário da COMPRA — o gancho de troca */
    PV_ANOS.forEach(function(n){
      var d=new Date(ent.getTime()); d.setFullYear(d.getFullYear()+n);
      poe('ano'+n, d, n+' ano'+(n===1?'':'s')+' de compra', {n:n});
    });
    /* aniversário do CLIENTE (mp_clientes.nascimento) */
    var c=_pvCliente(v);
    var nasc=_pvDia(c&&c.nascimento);
    if(nasc){
      var hoje=_pvHoje();
      var d2=new Date(nasc.getTime()); d2.setFullYear(hoje.getFullYear());
      if(_pvDif(d2)<-30) d2.setFullYear(hoje.getFullYear()+1);
      poe('aniv'+d2.getFullYear(), d2, 'Aniversário', {aniv:true});
    }
    /* v459: era repasse? A regua inteira vira UM contato — a documentacao */
    if(_pvRepasse(v)) out=out.filter(function(e){ return e.k==='d30'; });
    out.sort(function(a,b){ return a.quando-b.quando; });
    return out;
  }
  function pvProximo(v){
    if(_pvPausado(v)) return null;
    return pvEventos(v)[0]||null;
  }
  function _pvCliente(v){
    if(!v) return null;
    var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(v.cliente_id); })[0];
    if(c) return c;
    var d=String(v.telefone||'').replace(/\D/g,'').slice(-8);
    return d?((_clientes||[]).filter(function(x){ return String(x.telefone||'').replace(/\D/g,'').slice(-8)===d; })[0]||null):null;
  }

  /* ---------- a mensagem pronta ---------- */
  function pvMensagem(v, ev){
    var c=_pvCliente(v), g=pvGarantia(v);
    var nome=String((c&&c.nome)||v.cliente_nome||'').trim();
    var base=(ev&&ev.aniv)?PV_MSG.aniv:((ev&&ev.n)?PV_MSG.ano:(PV_MSG[(ev&&ev.k)||'d7']||PV_MSG.d7));
    var mapa={
      '{nome}':nome||'tudo bem?',
      '{primeiro_nome}':(nome.split(/\s+/)[0]||'tudo bem?'),
      '{veiculo}':String(v.veiculo||'veículo'),
      '{placa}':String(v.placa||''),
      '{ano}':String(v.ano||''),
      '{loja}':String(_pvLoja()),
      '{vendedor}':String(v.vendedor_nome||_pvVendedor()),
      '{data_compra}':_pvData(_pvEntrega(v)),
      '{garantia_fim}':g?_pvData(g.fim):'',
      '{n}':String((ev&&ev.n)||'')
    };
    var t=base;
    Object.keys(mapa).forEach(function(k){ t=t.split(k).join(mapa[k]); });
    return t;
  }
  function _pvLoja(){
    try{ if(typeof _lojaNome==='function'){ var n=_lojaNome(); if(n) return n; } }catch(_){}
    try{ if(window._minhaLoja && window._minhaLoja.nome) return window._minhaLoja.nome; }catch(_){}
    return 'loja';
  }
  function _pvVendedor(){
    try{ if(typeof meuNome!=='undefined' && meuNome) return String(meuNome).split(/\s+/)[0]; }catch(_){}
    return 'time';
  }

  /* ---------- filtros e selos ---------- */
  function _pvBase(){
    var reais=(_pvVendas||[]).filter(function(v){ return !!_pvEntrega(v); });
    /* v527 (Fase 1): + quem tem a ETIQUETA "comprou" e nenhuma venda
       lançada. ⛳ PV_LISTA_SEM_VENDA (12k) desliga numa linha. */
    if(typeof PV_LISTA_SEM_VENDA==='undefined' || !PV_LISTA_SEM_VENDA) return reais;
    return reais.concat(_pvOrfas().map(_pvComoVenda));
  }
  function _pvSeloConta(k){
    return _pvBase().filter(function(v){ return _pvNoSelo(v,k); }).length;
  }
  function _pvNoSelo(v,k){
    var p=pvProximo(v), g=pvGarantia(v);
    if(k==='hoje')      return !!p && _pvDif(p.quando)===0;
    if(k==='atrasado')  return !!p && _pvDif(p.quando)<0;
    if(k==='garantia')  return !!g && g.estado==='vencendo';
    if(k==='manut')     return _pvManutAbertas(v).length>0;   /* v460 */
    if(k==='aniver'){
      var c=_pvCliente(v), n=_pvDia(c&&c.nascimento);
      return !!n && n.getMonth()===_pvHoje().getMonth();
    }
    return true;
  }
  /* ===== v807 (§8) — "PENDÊNCIAS", UMA DEFINIÇÃO SÓ ======================
     O §8 escreve a regra na letra: cliente SEM VENDA LANÇADA, ou em fase
     ANTERIOR À ENTREGA, ou com MANUTENÇÃO ABERTA, ou com PRÓXIMO CONTATO
     ATRASADO.

     🔴 E ele termina com "sem criar outra verdade de negócio": a contagem
     usa as MESMAS `_pvSemVenda`, `_pvPendente`, `_pvManutAbertas` e
     `pvProximo` que a lista usa pra desenhar cada linha. Se um dia o número
     do botão discordar do que a lista mostra ao filtrar, é porque alguém
     escreveu a regra duas vezes — não faça isso. */
  function _pvEhPendencia(v){
    if(!v) return false;
    if(_pvSemVenda(v)) return true;
    if(_pvPendente(v)) return true;                    /* fase anterior à entrega */
    if(_pvManutAbertas(v).length) return true;
    var p=pvProximo(v);
    return !!p && _pvDif(p.quando)<0;                  /* contato atrasado */
  }
  /* 🔴 "um cliente contado em mais de uma regra aparece uma vez" — e também
     um cliente com DUAS vendas conta uma vez. A chave é o cliente, não a
     linha: contar linhas daria um número maior que a quantidade de gente,
     e o botão diz "Pendências", não "pendências". */
  function _pvPendenciasN(){
    var vistos={}, n=0;
    _pvBase().forEach(function(v){
      if(!_pvEhPendencia(v)) return;
      var k=String(v.cliente_id||v.id||'');
      if(vistos[k]) return;
      vistos[k]=1; n++;
    });
    return n;
  }
  function _pvLista(){
    var t=String(_pvBusca||'').toLowerCase().trim(), td=t.replace(/\D/g,'');
    return _pvBase().filter(function(v){
      if(_pvSelo && !_pvNoSelo(v,_pvSelo)) return false;
      var g=pvGarantia(v);
      if(_pvFiltro==='na' && !(g&&g.estado!=='fora')) return false;
      if(_pvFiltro==='fora' && !(g&&g.estado==='fora')) return false;
      if(_pvFiltro==='ano1'){ var e=_pvEntrega(v); if(!e || _pvDif(e)>-365) return false; }
      if(_pvFiltro==='pendente' && !_pvPendente(v)) return false;   /* v521 */
      /* v540: um filtro por fase da entrega — o chip carrega a chave inteira
         ("sit:faturamento") pra não colidir com os filtros antigos. */
      if(_pvFiltro.indexOf('sit:')===0 && pvSituacao(v)!==_pvFiltro.slice(4)) return false;
      if(_pvFiltro==='semvenda' && !_pvSemVenda(v)) return false;   /* v527 */
      if(_pvFiltro==='pausado' && !_pvPausado(v)) return false;
      if(_pvFiltro==='manut' && !_pvManuts(v).length) return false;   /* v466 */
      if(_pvFiltro==='pend' && !_pvEhPendencia(v)) return false;      /* v807 §8 */
      if(!t) return true;
      var c=_pvCliente(v);
      var alvo=((v.cliente_nome||'')+' '+((c&&c.nome)||'')+' '+(v.veiculo||'')+' '+(v.placa||'')).toLowerCase();
      if(alvo.indexOf(t)>=0) return true;
      var fone=String((c&&c.telefone)||v.telefone||'').replace(/\D/g,'');
      return !!(td && fone.indexOf(td)>=0);
    }).sort(_pvOrdena);
  }
  /* ===== v807 (§8) — A ORDENAÇÃO ========================================
     O §8 permite opções além de "Mais urgentes" "somente se implementadas de
     verdade". Estas três são. A de sempre é a primeira, e continua sendo o
     padrão: o contato mais atrasado na frente. */
  var PV_ORDENS=[['urgente','Mais urgentes'],['recente','Mais recentes'],['nome','Nome (A-Z)']];
  var _pvOrd='urgente';
  function _pvNome(v){
    var c=_pvCliente(v);
    return String((c&&c.nome)||v.cliente_nome||'').trim();
  }
  function _pvOrdena(a,b){
    if(_pvOrd==='nome') return _pvNome(a).localeCompare(_pvNome(b),'pt-BR',{sensitivity:'base'});
    if(_pvOrd==='recente'){
      var ea=_pvEntrega(a), eb=_pvEntrega(b);
      return (eb?eb.getTime():0)-(ea?ea.getTime():0);
    }
    /* padrão: o mais atrasado primeiro; quem não tem contato pendente vai pro fim */
    var pa=pvProximo(a), pb=pvProximo(b);
    if(!pa && !pb) return 0;
    if(!pa) return 1;
    if(!pb) return -1;
    return pa.quando-pb.quando;
  }

  /* ====================== A PÁGINA ====================== */
  async function telaPosVendas(){
    mevTabSet('');
    document.body.classList.add('crm-on');
    /* ===== v807 (§7 e §8) — A ORDEM DA PÁGINA ============================
       título · ações · busca · Todos/Pendências/Filtros · resultado+ordem ·
       lista. A busca saiu da fileira dos botões (ela dividia a linha com
       dois botões escritos e sobrava um campo curto no celular) e ganhou a
       largura inteira, com 48px de altura, como o §8 pede.
       ⚠️ Todos os ids continuam: #pvNova, #pvExportar, #pvBusca. */
    $('secoes').innerHTML='<div class="info-pg pv-pg"><h2>Clientes</h2>'+
      '<div id="pvSelos"></div>'+
      '<div class="pv-acoes">'+
        '<button type="button" class="crm-ab primaria" id="pvNova">'+_ICO_MAIS2+'Registrar venda antiga</button>'+
        '<button type="button" class="crm-ab" id="pvExportar">'+_ICO_EXPORTA+'Exportar</button>'+
      '</div>'+
      '<div class="cli-search pv-busca">'+_icoBusca+
        '<input id="pvBusca" placeholder="Cliente, telefone, placa ou modelo" autocomplete="off" enterkeyhint="search">'+
        '<button type="button" class="cli-limpa" id="pvBuscaX" aria-label="Limpar a busca" title="Limpar a busca" hidden>×</button>'+
      '</div>'+
      '<div class="pv-filtros" id="pvFiltros"></div>'+
      '<div class="pv-res" id="pvRes" aria-live="polite"></div>'+
      '<div id="pvOrfas"></div>'+
      '<div id="pvLista">'+pgLoad('Montando o pós-vendas…')+'</div>'+
      /* a folha de Filtros (padrão folha-por-cima da v529) */
      '<div class="cropmask" id="pvFiltrosFolha" style="display:none"><div class="cropbox" style="max-width:360px;max-height:84vh;overflow:auto">'+
        '<div class="crop-tit">Filtros</div>'+
        '<div class="pv-fgrupo" id="pvFiltrosLista"></div>'+
        '<div class="crm-fitem"><label for="pvOrdem">Ordenar</label>'+
          '<select class="crm-ord" id="pvOrdem">'+PV_ORDENS.map(function(o){
            return '<option value="'+o[0]+'">'+esc(o[1])+'</option>'; }).join('')+'</select></div>'+
        '<button type="button" class="link" id="pvFiltrosOk" style="margin-top:12px;width:100%">Fechar</button>'+
      '</div></div>'+
    '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block';
    window.scrollTo(0,0); fabFoto(false); voltarTab(voltarHome);
    /* ⚠️ §7, na letra: "não repetir `Registrar venda antiga` em FAB ou dock".
       A `mevCtx` punha exatamente esse botão no balão flutuante — duas
       portas pra mesma coisa, e a de baixo cobrindo o último card. O botão
       escrito, no topo da página, fica. */
    mevCtx(null);
    $('pvBusca').oninput=function(){ _pvBusca=this.value; pvBuscaX(); pvPinta(); };
    { var _bx=$('pvBuscaX'); if(_bx) _bx.onclick=function(){
        var i=$('pvBusca'); if(!i) return;
        i.value=''; _pvBusca=''; pvBuscaX(); pvPinta(); try{ i.focus(); }catch(_){}
      }; }
    /* a folha de Filtros */
    { var _ff=$('pvFiltrosFolha'), _fok=$('pvFiltrosOk');
      if(_ff){
        _ff.onclick=function(e){ if(e.target===_ff) _ff.style.display='none'; };
        if(_fok) _fok.onclick=function(){ _ff.style.display='none'; };
      }
      var _od=$('pvOrdem');
      if(_od){ _od.value=_pvOrd; _od.onchange=function(){ _pvOrd=this.value||'urgente'; pvPinta(); }; }
    }
    $('pvNova').onclick=function(){ pvNovaAbrir(); };
    $('pvExportar').onclick=pvExportar;
    if(!(_clientes||[]).length){ try{ await cliCarregar(); }catch(_){} }
    if(!(_vendas||[]).length){ try{ await vendaCarregar(); }catch(_){} }
    /* quem entra: toda venda FECHADA */
    _pvVendas=(_vendas||[]).filter(function(v){ return !!v.fechada; });
    pvPinta();
  }

  function pvPinta(){
    var el=$('pvLista'); if(!el) return;
    pvSelosPinta(); pvFiltrosPinta(); pvOrfasPinta();
    var lista=_pvLista();
    pvResPinta(lista.length);   /* v807 §8 — o total sai da MESMA lista */
    pvBuscaX();
    if(!lista.length){
      var temFiltro = !!(_pvFiltro || _pvSelo || String(_pvBusca||'').trim());
      el.innerHTML='<div class="cli-empty" style="padding:20px">'+
        (_pvBase().length
          ? (temFiltro
              ? '<b>Nenhum cliente com estes filtros</b><span>Tire um filtro ou apague a busca.</span>'+
                '<button type="button" class="vazio-bt pv-limpa" id="pvLimpar">Limpar filtros</button>'
              : '<b>Nada nesta lista</b>')
          : '<b>Nenhuma venda fechada ainda</b>Quando uma venda fechar, o cliente entra aqui sozinho.')+'</div>';
      var _lz=$('pvLimpar');
      if(_lz) _lz.onclick=function(){
        _pvFiltro=''; _pvSelo=''; _pvBusca='';
        var i=$('pvBusca'); if(i) i.value='';
        pvPinta();
      };
      return;
    }
    var desk=window.matchMedia && window.matchMedia('(min-width:980px)').matches;
    el.innerHTML = desk ? pvTabelaHtml(lista) : lista.map(pvCardHtml).join('');
    pvLigaLinhas(el);
  }

  /* ⛳ v530 (pedido: "remova o dashboard, página clientes") — os cinco
     cartões do topo (Hoje · Atrasados · Garantia vencendo · Manutenção
     aberta · Aniversários do mês).
     false = a página abre direto na lista, que é o trabalho.
     true  = os cartões voltam, exatamente como estavam.
     ⚠️ Mesmo padrão do MT_LISTA_VISIVEL (v520): a trava mora na ENTRADA da
     função, não nas chamadas — `pvSelosPinta` é chamada de dentro do
     `pvPinta`, que roda a cada filtro, busca e repintura. */
  var PV_SELOS_VISIVEL = false;
  function pvSelosPinta(){
    var box=$('pvSelos'); if(!box) return;
    if(!PV_SELOS_VISIVEL){
      /* 🔴 zera o selo escolhido junto. Sem isto, quem tivesse clicado em
         "Atrasados" antes de desligar ficaria preso num filtro que não
         aparece mais na tela — uma lista curta sem explicação nenhuma. */
      box.innerHTML=''; _pvSelo='';
      return;
    }
    var selos=[['hoje','Hoje'],['atrasado','Atrasados'],['garantia','Garantia vencendo'],['manut','Manutenção aberta'],['aniver','Aniversários do mês']];
    box.innerHTML='<div class="pv-selos">'+selos.map(function(s){
      var n=_pvSeloConta(s[0]);
      return '<button type="button" class="pv-selo'+(s[0]==='atrasado'?' ruim':'')+(_pvSelo===s[0]?' on':'')+'" data-s="'+s[0]+'">'+
        '<b>'+n+'</b><span>'+esc(s[1])+'</span></button>';
    }).join('')+'</div>';
    Array.prototype.forEach.call(box.querySelectorAll('.pv-selo'),function(b){
      b.onclick=function(){ var k=b.getAttribute('data-s'); _pvSelo=(_pvSelo===k)?'':k; pvPinta(); };
    });
  }
  function pvBuscaX(){
    var i=$('pvBusca'), b=$('pvBuscaX'); if(!i||!b) return;
    b.hidden = !String(i.value||'').length;
  }
  /* ===== v807 (§8) — A LINHA DE RESULTADO ================================
     Esquerda: "N clientes", numa região viva. Direita: a ordenação escrita.
     ⚠️ O N vem do MESMO `_pvLista()` que acabou de virar cards — não é uma
     segunda contagem. */
  function pvResPinta(n){
    var el=$('pvRes'); if(!el) return;
    var rot=''; PV_ORDENS.forEach(function(o){ if(o[0]===_pvOrd) rot=o[1]; });
    el.innerHTML='<span class="pv-res-n"><b>'+n+'</b> cliente'+(n===1?'':'s')+'</span>'+
      '<span class="pv-res-o">'+esc(rot||'Mais urgentes')+'</span>';
  }
  /* ===== v807 (§8) — TRÊS CONTROLES À VISTA, O RESTO NA FOLHA ============
     Eram onze chips numa fileira que rolava de lado — e "Pausados", o
     último, ficava fora da vista em qualquer celular. O §8 pede
     `Todos` · `Pendências (N)` · `Filtros` ou `Filtros (N)` sempre visíveis.

     ⚠️ NENHUM FILTRO SUMIU: os onze continuam existindo, agora dentro da
     folha, com a contagem de cada um. O §8 é explícito — "não esconder
     permanentemente uma opção apenas porque está em zero". */
  function _pvFiltrosDef(){
    return [['','Todos']]
      .concat([['semvenda','Sem venda lançada']])
      .concat(SITUACAO_ON
        ? PV_SIT.filter(function(s){ return s.antes; }).map(function(s){ return ['sit:'+s.k, s.rot]; })
        : [['pendente','Entrega pendente']])
      .concat([['na','Na garantia'],['fora','Fora da garantia'],['manut','Manutenção'],['ano1','1 ano+'],['pausado','Pausados']]);
  }
  function _pvFiltroConta(k){
    if(k==='') return _pvBase().length;
    if(k==='pend') return _pvPendenciasN();
    if(k==='pendente') return _pvBase().filter(_pvPendente).length;
    if(k==='semvenda') return _pvBase().filter(_pvSemVenda).length;
    if(k.indexOf('sit:')===0) return _pvBase().filter(function(v){ return pvSituacao(v)===k.slice(4); }).length;
    if(k==='na')   return _pvBase().filter(function(v){ var g=pvGarantia(v); return !!(g&&g.estado!=='fora'); }).length;
    if(k==='fora') return _pvBase().filter(function(v){ var g=pvGarantia(v); return !!(g&&g.estado==='fora'); }).length;
    if(k==='manut') return _pvBase().filter(function(v){ return _pvManuts(v).length>0; }).length;
    if(k==='ano1') return _pvBase().filter(function(v){ var e=_pvEntrega(v); return !!e && _pvDif(e)<=-365; }).length;
    if(k==='pausado') return _pvBase().filter(_pvPausado).length;
    return 0;
  }
  function pvFiltrosPinta(){
    var box=$('pvFiltros'); if(!box) return;
    /* v466: o chip "Manutenção" mostra quem TEM manutenção (aberta OU já
       resolvida — é o histórico de oficina do cliente). O cartão do topo
       "Manutenção aberta" continua contando SÓ as abertas. */
    /* ⛳ v540 (pedido do Angelo): o chip único "Entrega pendente" virou UM
       POR FASE. Assim a barra responde sem clique nenhum a "quantos estão
       esperando nota fiscal?" — que antes exigia entrar no filtro e contar
       na mão. As três substituem o chip antigo, não somam a ele: o antigo
       mostrava exatamente a união destas três. */
    var fs=_pvFiltrosDef();
    var naFolha = fs.filter(function(f){ return f[0]!==''; });
    /* quantos filtros da folha estão ligados (0 ou 1, hoje: é escolha única) */
    var ativosN = (_pvFiltro && _pvFiltro!=='pend') ? 1 : 0;
    var pend=_pvPendenciasN();
    box.innerHTML=
      '<button type="button" class="crm-etb pv-fb'+(_pvFiltro===''?' on':'')+'" data-f="">Todos</button>'+
      '<button type="button" class="crm-etb pv-fb pv-fb-pend'+(_pvFiltro==='pend'?' on':'')+'" data-f="pend">'+
        'Pendências ('+pend+')</button>'+
      '<button type="button" class="crm-etb pv-fb-abre'+(ativosN?' on':'')+'" id="pvFiltrosBt" aria-haspopup="dialog">'+
        'Filtros'+(ativosN?(' ('+ativosN+')'):'')+' <span class="crm-fbt-ch">⏷</span></button>';
    Array.prototype.forEach.call(box.querySelectorAll('.pv-fb'),function(b){
      b.onclick=function(){ _pvFiltro=b.getAttribute('data-f')||''; pvPinta(); };
    });
    /* a lista de dentro da folha — com a contagem de CADA opção */
    var lst=$('pvFiltrosLista');
    if(lst){
      lst.innerHTML=naFolha.map(function(f){
        var n=_pvFiltroConta(f[0]);
        /* §8: "não esconder permanentemente uma opção apenas porque está em
           zero; ela pode aparecer desabilitada ou com 0". Fica com 0 e
           desabilitada — some do caminho do dedo sem sumir da tela. */
        return '<button type="button" class="pv-fi'+(_pvFiltro===f[0]?' on':'')+'" data-f="'+f[0]+'"'+
          (n?'':' disabled')+'><span>'+esc(f[1])+'</span><b>'+n+'</b></button>';
      }).join('');
      Array.prototype.forEach.call(lst.querySelectorAll('[data-f]'),function(b){
        b.onclick=function(){
          _pvFiltro=b.getAttribute('data-f')||'';
          var ff=$('pvFiltrosFolha'); if(ff) ff.style.display='none';
          pvPinta();
        };
      });
    }
    var _fb=$('pvFiltrosBt'), _ff=$('pvFiltrosFolha');
    if(_fb&&_ff) _fb.onclick=function(){ _ff.style.display='flex'; };
  }

  /* ---- a faixa "compras sem ficha": cliente marcado como comprou mas sem
     venda lançada. Sem isso, quem vendeu ANTES da página existir ficaria
     de fora do pós-venda pra sempre. ---- */
  function _pvOrfas(){
    var comVenda={};
    (_pvVendas||[]).forEach(function(v){ if(v.cliente_id) comVenda[String(v.cliente_id)]=1; });
    return (_clientes||[]).filter(function(c){
      return (c.etapa==='comprou'||c.etapa==='pos_vendas') && !comVenda[String(c.id)];
    });
  }
  /* ⛳ v807 (§9 do projeto de 31/08) — A FAIXA AMARELA SAIU DA TELA.
     PEDIDO, na letra: "a faixa amarela `N já compraram e ainda não têm a
     venda lançada` não deve duplicar o filtro e ocupar uma seção inteira
     antes dos cards."

     🔴 ELA DUPLICAVA MESMO: essas pessoas JÁ aparecem na lista desde a
     v527, cada uma com o seu "Registrar venda" no card — a faixa repetia
     todas elas numa segunda lista, acima da primeira. E o filtro "Sem venda
     lançada" faz a mesma seleção, com contagem, dentro da folha.

     ⚠️ O QUE SÓ EXISTIA AQUI — "Juntar em outro" e "Apagar ficha" (v521) —
     NÃO se perdeu: foi pro menu "Mais ações" do próprio cliente, no card,
     que é onde o §9 manda. `clienteEscolherDestino`, `clienteFundir` e
     `clienteApagarDetalhado` continuam sendo quem faz o serviço.

     ⚠️ Mesmo padrão do PV_SELOS_VISIVEL (v530): a trava mora na ENTRADA da
     função. `true` devolve a faixa exatamente como estava. */
  var PV_FAIXA_ORFAS = false;
  function pvOrfasPinta(){
    var box=$('pvOrfas'); if(!box) return;
    if(!PV_FAIXA_ORFAS){ box.innerHTML=''; box.classList.remove('on'); return; }
    var l=_pvOrfas();
    if(!l.length){ box.innerHTML=''; box.classList.remove('on'); return; }
    /* ===== v521 — A FAIXA VIRA LISTA (PROJETO-unificar-ou-excluir) ========
       PEDIDO: "permita adicionar um cadastro a outro (unificar) ou
       excluir — esses já são da página Clientes que foram marcados como
       comprou."

       O QUE TRAVAVA, e eram três coisas:
         1. mostrava 3 nomes de 12 — o resto era "…";
         2. 🔴 o botão abria SEMPRE o `l[0]`, o primeiro da lista. Com 12 na
            fila, era um clique que resolvia 1/12 — e sempre o mesmo;
         3. só existia UM caminho: registrar venda. Se a ficha não é uma
            venda (é lixo, ou é a mesma pessoa duas vezes), não havia saída.

       ⚠️ CADA LINHA COM O SEU BOTÃO — mesma correção da v517: ação em lote
       num assunto que apaga cadastro é como se estraga dado sem perceber.
       ⚠️ TELEFONE E DATA à vista: é o que deixa reconhecer a ficha sem
       abrir, e é justamente o que falta no combo de hoje.
       ⚠️ O vermelho fica SEPARADO e é o único com confirmação — registrar
       e juntar se desfazem com trabalho; apagar não.
       ⚠️ A venda PENDENTE DE ENTREGA não é órfã: ela TEM venda lançada, só
       não tem entrega. O `_pvOrfas` já não a pega (filtra por quem não tem
       venda) — está escrito aqui pra ninguém "consertar" isso depois. */
    /* ===== v527 — A FAIXA MUDOU DE SENTIDO, NÃO DE FUNÇÃO ================
       Antes ela era "quem está FALTANDO nesta página". Agora essas pessoas
       estão na LISTA (Fase 1), e a faixa virou "quem está aqui e ainda
       precisa da venda lançada" — uma pendência, não um remendo.
       ⚠️ Ela NASCE FECHADA: a lista já mostra cada um deles com o botão de
       registrar. O que só existe aqui é JUNTAR e APAGAR (v521), e essas
       duas ninguém procura todo dia. Mínimo na tela, e nada perdido. */
    box.innerHTML='<button type="button" class="pv-orf-hd" id="pvOrfHd" aria-expanded="false">'+
        l.length+' já '+(l.length===1?'comprou e ainda não tem':'compraram e ainda não têm')+' a venda lançada'+
        '<i class="pv-orf-ch" aria-hidden="true">▾</i></button>'+
      '<div class="pv-orf-lista">'+l.map(function(c){
        var quando=''; try{ var d=_pvDia(c.atualizado_em||c.criado_em); quando=d?_pvData(d):''; }catch(_){}
        return '<div class="pv-orf" data-orf="'+esc(c.id)+'">'+
          '<div class="pv-orf-nm">'+esc(c.nome||'(sem nome)')+'</div>'+
          '<div class="pv-orf-sb">'+esc(c.telefone?_crmFoneFmt(c.telefone):'sem telefone')+
            (quando?(' · marcado como comprou em '+esc(quando)):'')+'</div>'+
          '<div class="pv-orf-acts">'+
            '<button type="button" class="crp-b ok" data-orf-venda="'+esc(c.id)+'">Registrar venda</button>'+
            '<button type="button" class="crp-b" data-orf-juntar="'+esc(c.id)+'">Juntar em outro</button>'+
            '<button type="button" class="crp-b rm pv-orf-x" data-orf-del="'+esc(c.id)+'" title="Apagar esta ficha">'+
              _cIco('<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>')+
            '</button>'+
          '</div></div>';
      }).join('')+'</div>';
    var _oh=$('pvOrfHd');
    if(_oh) _oh.onclick=function(){
      var vai=!box.classList.contains('on');
      box.classList.toggle('on', vai);
      _oh.setAttribute('aria-expanded', vai?'true':'false');
    };

    function _orfAcha(id){ return (_clientes||[]).filter(function(x){ return String(x.id)===String(id); })[0]; }
    Array.prototype.forEach.call(box.querySelectorAll('[data-orf-venda]'),function(b){
      b.onclick=function(){ pvNovaAbrir(b.getAttribute('data-orf-venda')); };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-orf-juntar]'),function(b){
      b.onclick=function(){
        var sai=_orfAcha(b.getAttribute('data-orf-juntar')); if(!sai) return;
        if(typeof clienteEscolherDestino!=='function'){ toast('Não consegui abrir o seletor.'); return; }
        clienteEscolherDestino(sai, async function(fica){
          var r=await clienteFundir([sai], fica, 'Juntado manualmente: "'+(sai.nome||'')+'" entrou nesta ficha');
          if(!r.ok){ toast('Não consegui juntar — '+(r.erro||'erro')+'. Nada foi movido.'); return; }
          toast('Juntado em '+(fica.nome||'a outra ficha')+' ✓');
          try{ await cliCarregar(); }catch(_){}
          pvPinta();
        });
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-orf-del]'),function(b){
      b.onclick=async function(){
        var c=_orfAcha(b.getAttribute('data-orf-del')); if(!c) return;
        if(typeof clienteApagarDetalhado!=='function') return;
        b.disabled=true;
        var r=await clienteApagarDetalhado(c);
        if(!r.ok){
          b.disabled=false;
          if(!r.cancelado) toast(r.erro==='rls' ? 'Não consegui apagar — esta ficha não é da sua carteira.' : ('Não consegui apagar. '+(r.erro||'')));
          return;
        }
        toast('Ficha apagada.');
        try{ await cliCarregar(); }catch(_){}
        pvPinta();
      };
    });
  }

  /* ---- a tabela (computador) — mesmas classes da tabela de Clientes ----
     ⚠️ O motor de ordenar/filtrar-Excel do Clientes está amarrado às
     colunas dele (_CRMT_COLS/_crmTbl). Aqui reaproveitamos o CSS e o
     desenho, não aquele código. */
  function pvTabelaHtml(lista){
    /* ⛳ v540 (pedido): a coluna SITUAÇÃO. Entra logo depois do veículo — a
       leitura da linha fica "quem · como falo · qual carro · em que pé
       está · desde quando · garantia · o que fazer". Ver o 12n. */
    var cols=['Cliente','Telefone','Veículo / Placa']
      .concat(SITUACAO_ON?['Situação']:[])
      .concat(['Comprou em','Garantia','Próximo contato','']);
    /* §11: "cabeçalho fixo quando a tabela rolar" — quem prende é o
       `position:sticky` do `.pv-tbl thead th` no styles.css; o wrapper com
       rolagem própria é o que dá a ele um recipiente pra grudar. */
    return '<div class="pv-tbl-rola"><table class="crm-tbl pv-tbl"><thead><tr>'+
      cols.map(function(c){ return '<th class="ct-th">'+esc(c)+'</th>'; }).join('')+
      '</tr></thead><tbody>'+lista.map(function(v){
        var c=_pvCliente(v), g=pvGarantia(v), p=pvProximo(v);
        var fone=String((c&&c.telefone)||v.telefone||'');
        var wa=cliWhatsUrl(fone);
        /* v527: a linha de quem entrou pela etiqueta diz o estado nas
           três colunas que dependem da venda — em vez de mostrar uma data
           e uma garantia inventadas do `criado_em`. */
        var svt=_pvSemVenda(v);
        /* §11: "linhas clicáveis com foco visível" — a linha vira um alvo
           de teclado de verdade, com papel de botão. */
        var _nm=String((c&&c.nome)||v.cliente_nome||'(sem nome)');
        return '<tr data-id="'+esc(v.id)+'" tabindex="0" role="button" '+
            'aria-label="Abrir '+esc(_nm)+'"'+(svt?' class="pv-tr-sv"':'')+'>'+
          /* §11: "não cortar nome, veículo ou tarefa essencial sem title" */
          '<td class="ct-nm" title="'+esc(_nm)+'">'+esc(_nm)+(_pvManutAbertas(v).length?'<span class="pv-man-mk" title="Manutenção aberta">🔧</span>':'')+'</td>'+
          '<td class="ct-tel">'+esc(fone?_crmFoneFmt(fone):'—')+
            (wa?('<button type="button" class="ct-wa" data-wa="'+esc(wa)+'" title="WhatsApp">'+_icoWa+'</button>'):'')+'</td>'+
          '<td'+(svt?'':(' title="'+esc(String(v.veiculo||'')+(v.placa?(' · '+v.placa):''))+'"'))+'>'+
            (svt?'<span class="pv-sit pv-sit-sv">Venda não lançada</span>':(esc(v.veiculo||'—')+_pvPlacaHtml(v)))+'</td>'+
          /* v540: a etiqueta é o próprio botão de trocar de fase — uma coisa
             só pra aprender, na tabela e no card. */
          (SITUACAO_ON?('<td class="ct-sit">'+(svt?'—':pvSitPillHtml(v))+'</td>'):'')+
          '<td>'+(svt?'—':esc(_pvData(_pvEntrega(v))))+'</td>'+
          '<td>'+(svt?'<span class="pv-gar cinza">—</span>':pvGarantiaPill(g))+'</td>'+
          '<td>'+(svt?'<span class="pv-prox perto"><b>Lançar a venda</b><i>para começar a garantia</i></span>':pvProximoHtml(v,p))+'</td>'+
          /* §11: "ação principal compreensível e menu de ações secundárias" —
             as mesmas do card, escritas, e não os quatro ícones de antes. */
          '<td class="ct-acts pv-tacts">'+pvAcoesHtml(v,p)+'</td>'+
        '</tr>';
      }).join('')+'</tbody></table></div>';
  }
  /* ===== v807 (§10) — O CARD COMPACTO DE CLIENTE =========================
     A ordem que o projeto pede:
        1. nome · 2. veículo OU telefone · 3. situação em pill ·
        4. próxima tarefa · 5. prazo · 6. ações.

     🔴 O QUE ENCOLHEU: a caixa "Venda ainda não lançada" era um bloco de
     três linhas (título, um parágrafo explicando o que é, e um botão) dentro
     de um card que já tinha nome, telefone e as ações. Virou uma PILL de uma
     palavra e meia — `Venda não lançada` (§9, "recebem status textual") — e
     o botão dela subiu pras ações, como ação principal.
     O parágrafo não se perdeu: ele explica o que a pill já diz, e quem
     precisar do detalhe toca em "Registrar venda" e vê o formulário. */
  function pvCardHtml(v){
    var c=_pvCliente(v), g=pvGarantia(v), p=pvProximo(v);
    var sv=_pvSemVenda(v);
    var fone=String((c&&c.telefone)||v.telefone||'');
    /* 2. veículo ou telefone, "conforme o estado" (§10): sem venda lançada
       não há veículo pra mostrar — o que identifica a pessoa é o telefone. */
    var sub = sv
      ? (fone?esc(_crmFoneFmt(fone)):'sem telefone')
      : (esc(v.veiculo||'—')+(v.placa?(' · '+esc(v.placa)):(_pvZeroKm(v)?' · 0 km':'')));
    /* 4+5. a tarefa e o prazo. No estado pendente a tarefa é a entrega, e o
       prazo é a previsão — na mesma linguagem do resto (§10). */
    var tarefa='';
    if(sv){
      tarefa='<span class="pv-prox perto"><b>Lançar a venda</b>'+
        '<i>para começar a garantia</i></span>';
    } else if(_pvPendente(v)){
      var dias=_pvPendenteDias(v), prev=_pvPrevisao(v);
      tarefa='<span class="pv-prox '+(prev?pvPrazoCls(prev):(_pvPendenteAtrasada(v)?'atras':'perto'))+'">'+
        '<b>Entregar</b><i>esperando há '+dias+' dia'+(dias===1?'':'s')+
        (prev?(' · previsão '+esc(pvPrazoTxt(prev))):' · sem previsão')+'</i></span>';
    } else {
      tarefa=pvProximoHtml(v,p);
    }
    /* 3. a situação em pill. A de "sem venda" é a única que não é uma FASE
       da entrega — por isso ela tem pill própria (o `pvSituacao` devolve
       vazio pra ela de propósito, ver o 12n). */
    var pill = sv
      ? '<span class="pv-sit pv-sit-sv">Venda não lançada</span>'
      : (SITUACAO_ON?pvSitPillHtml(v):'');
    /* o "Entreguei" é o desfecho de 9 em 10 entregas pendentes: continua
       sendo um botão grande, dentro da linha da tarefa. */
    var entreguei = (!sv && _pvPendente(v))
      ? '<button type="button" class="crp-b ok pv-entreguei" data-entreguei="'+esc(v.id)+'">Entreguei</button>'
      : '';
    return '<div class="pv-card'+(_pvPendente(v)?' pendente':'')+(sv?' semvenda':'')+'" data-id="'+esc(v.id)+'">'+
      '<div class="pv-cnm">'+esc((c&&c.nome)||v.cliente_nome||'(sem nome)')+'</div>'+
      '<div class="pv-csb">'+sub+'</div>'+
      '<div class="pv-crow">'+pill+(sv?'':pvGarantiaPill(g))+tarefa+entreguei+'</div>'+
      '<div class="pv-cacts">'+pvAcoesHtml(v,p)+'</div>'+
    '</div>';
  }
  function pvGarantiaPill(g){
    if(!g) return '<span class="pv-gar cinza">—</span>';
    if(g.estado==='fora') return '<span class="pv-gar cinza">encerrada</span>';
    var cls=(g.estado==='vencendo')?'amarela':'verde';
    return '<span class="pv-gar '+cls+'">'+g.faltam+' dia'+(g.faltam===1?'':'s')+'</span>';
  }
  /* v807 (§10): a próxima tarefa e o prazo, na linguagem do projeto.
     O nome da tarefa vem em cima e o prazo embaixo — é o par que faz
     "Atrasada há 61 dias" querer dizer alguma coisa. */
  function pvProximoHtml(v,p){
    if(_pvPausado(v)) return '<span class="pv-prox pausado">pausado</span>';
    if(!p) return '<span class="pv-prox ok">Em dia</span>';
    return '<span class="pv-prox '+pvPrazoCls(p.quando)+'"><b>'+esc(p.titulo)+'</b>'+
           '<i>'+esc(pvPrazoTxt(p.quando))+'</i></span>';
  }
  /* ===== v807 (§10) — AS AÇÕES DO CARD ==================================
     🔴 O QUE SAIU: uma fileira de QUATRO botões só de ícone (olho, balão,
     ✓, relógio). O §10 proíbe com todas as letras — "não exibir uma fileira
     de quatro botões sem texto". Quatro desenhos de 34px lado a lado, num
     card que já tem nome, veículo, etiqueta e prazo, é onde o dedo erra e
     onde ninguém aprende o que cada um faz.

     O QUE ENTROU, na ordem do §10:
       primária ...... "Abrir cliente" — ou "Registrar venda", quando a
                       venda não foi lançada (§9)
       secundária .... "Conversar", só quando há telefone
       "Mais ações" .. contato feito · adiar 7 dias · situação · agendar ·
                       e, pra quem não tem venda lançada, JUNTAR e APAGAR
                       (que antes só existiam na faixa amarela, §9)

     ⚠️ NADA se perdeu: `pvFichaAbrir`, `pvChat`, `pvFeito`, `pvAdiar`,
     `pvSituacaoAbrir` e `pvEntregar` continuam sendo quem faz o serviço —
     mudou só a porta.
     ⚠️ §10: "ícones dentro de menus e ações secundárias mantêm aria-label
     específico com o nome do cliente". */
  function pvAcoesHtml(v,p){
    var c=_pvCliente(v);
    var nome=String((c&&c.nome)||v.cliente_nome||'este cliente').trim()||'este cliente';
    var fone=String((c&&c.telefone)||v.telefone||'');
    if(_pvSemVenda(v)){
      /* §9: pra quem comprou e não teve a venda lançada, a ação principal é
         lançar a venda — abrir a ficha não resolve o que está pendente. */
      return '<button type="button" class="pv-ab primaria" data-act="lancar" '+
          'aria-label="Registrar a venda de '+esc(nome)+'">Registrar venda</button>'+
        (fone?('<button type="button" class="pv-ab" data-act="chat" '+
          'aria-label="Conversar com '+esc(nome)+'">Conversar</button>'):'')+
        '<button type="button" class="pv-ab pv-ab-mais" data-act="mais" '+
          'aria-label="Mais ações para '+esc(nome)+'" title="Mais ações">⋯</button>';
    }
    return '<button type="button" class="pv-ab primaria" data-act="ver" '+
        'aria-label="Abrir a ficha de '+esc(nome)+'">Abrir cliente</button>'+
      (fone?('<button type="button" class="pv-ab" data-act="chat" '+
        'aria-label="Conversar com '+esc(nome)+'">Conversar</button>'):'')+
      '<button type="button" class="pv-ab pv-ab-mais" data-act="mais" '+
        'aria-label="Mais ações para '+esc(nome)+'" title="Mais ações">⋯</button>';
  }
  /* ===== v807 (§9 e §10) — O MENU "MAIS AÇÕES" DE UM CLIENTE ============
     ⚠️ "Apagar ficha" fica POR ÚLTIMO, vermelho, separado por uma linha, e é
     o único com confirmação detalhada (a mesma `clienteApagarDetalhado` da
     v521). Registrar e juntar se desfazem com trabalho; apagar não.
     ⚠️ §9: "nunca transformar juntar ou excluir em ação em lote" — este
     menu é de UMA ficha, aberto a partir do card DELA. */
  function pvCardMais(v){
    if(!v) return;
    var c=_pvCliente(v), p=pvProximo(v), sv=_pvSemVenda(v);
    var nome=String((c&&c.nome)||v.cliente_nome||'Cliente').trim()||'Cliente';
    var itens='';
    if(!sv){
      if(p){
        itens+='<button type="button" class="crm-ab" data-m="feito">'+
          _cIco('<polyline points="20 6 9 17 4 12"/>')+'Marcar contato feito</button>';
        itens+='<button type="button" class="crm-ab" data-m="adiar">'+_ICO_CAL_MAIS+'Adiar 7 dias</button>';
      }
      if(typeof pvSituacaoAbrir==='function' && typeof SITUACAO_ON!=='undefined' && SITUACAO_ON){
        itens+='<button type="button" class="crm-ab" data-m="sit">'+
          _cIco('<circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>')+'Trocar a situação</button>';
      }
    }
    /* §9: juntar e apagar — o que morava na faixa amarela */
    if(sv && c){
      itens+='<button type="button" class="crm-ab" data-m="juntar">'+
        _cIco('<path d="M8 6h8"/><path d="M8 12h8"/><path d="M12 3v18"/>')+'Juntar em outro cadastro</button>';
      itens+='<div class="pv-mais-sep"></div>'+
        '<button type="button" class="crm-ab pv-ab-rm" data-m="apagar">'+
        _cIco('<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>')+
        'Apagar esta ficha</button>';
    }
    if(!itens) itens='<div class="cli-empty" style="padding:10px">Nada a mais por aqui.</div>';
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:330px;max-height:82vh;overflow:auto">'+
      '<div class="crop-tit">'+esc(nome.split(' ')[0])+'</div>'+
      '<div class="crm-mmenu">'+itens+'</div>'+
      '<button type="button" class="link" data-m="x" style="margin-top:12px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    Array.prototype.forEach.call(ov.querySelectorAll('[data-m]'),function(b){
      b.onclick=async function(){
        var m=b.getAttribute('data-m');
        if(m==='apagar'){
          /* não fecho antes: a confirmação detalhada é dela, e se a pessoa
             desistir o menu continua aberto onde estava */
          if(typeof clienteApagarDetalhado!=='function') return;
          b.disabled=true;
          var r=await clienteApagarDetalhado(c);
          if(!r.ok){
            b.disabled=false;
            if(!r.cancelado) toast(r.erro==='rls' ? 'Não consegui apagar — esta ficha não é da sua carteira.' : ('Não consegui apagar. '+(r.erro||'')));
            return;
          }
          close(); toast('Ficha apagada.');
          try{ await cliCarregar(); }catch(_){}
          pvPinta(); return;
        }
        close();
        if(m==='feito')      pvFeito(v);
        else if(m==='adiar') pvAdiar(v);
        else if(m==='sit')   { if(typeof pvSituacaoAbrir==='function') pvSituacaoAbrir(v.id); }
        else if(m==='juntar'){
          if(!c || typeof clienteEscolherDestino!=='function'){ toast('Não consegui abrir o seletor.'); return; }
          clienteEscolherDestino(c, async function(fica){
            var r=await clienteFundir([c], fica, 'Juntado manualmente: "'+(c.nome||'')+'" entrou nesta ficha');
            if(!r.ok){ toast('Não consegui juntar — '+(r.erro||'erro')+'. Nada foi movido.'); return; }
            toast('Juntado em '+(fica.nome||'a outra ficha')+' ✓');
            try{ await cliCarregar(); }catch(_){}
            pvPinta();
          });
        }
      };
    });
  }
  /* ===== v521 — "ENTREGUEI" =============================================
     🔴 A GARANTIA CONTA DA ENTREGA, NÃO DA ASSINATURA. Se alguém preencher
     a data da venda no lugar, o cliente perde dias de garantia — e é o tipo
     de erro que só aparece na hora do problema.
     O `pvGarantia` já respeita um `garantia.inicio` próprio; a entrega só
     preenche esse início se ele ainda estiver vazio. */
  /* 🔴🔴 v540 — SAIU O `prompt()` DAQUI.
     Esta função pedia a data num `prompt` do navegador, digitada como
     "AAAA-MM-DD". Duas coisas erradas de uma vez: prompt de navegador saiu
     do app na v522 (trava a tela, some no PWA, não dá pra estilizar), e
     digitar data à mão no celular, no meio do atendimento, é onde nasce a
     data errada — que aqui não é um detalhe, é a garantia do cliente
     começando no dia errado.
     Agora "Entreguei" abre a MESMA folha da etiqueta (12n), já em
     "Entregue", com um campo de data de verdade. Um caminho só. */
  function pvEntregar(v){
    if(!v || !v.id) return;
    if(typeof pvSituacaoAbrir==='function'){ pvSituacaoAbrir(v.id); return; }
  }

  function pvLigaLinhas(el){
    /* 🔴 v527: a lista deixou de ser só `_pvVendas` — as fichas que entraram
       pela etiqueta têm id 'sv:<cliente>'. Procurar na lista antiga faria
       essas linhas simplesmente não responderem ao toque. */
    var universo=_pvBase();
    Array.prototype.forEach.call(el.querySelectorAll('[data-id]'),function(no){
      var v=universo.filter(function(x){ return String(x.id)===String(no.getAttribute('data-id')); })[0];
      if(!v) return;
      /* §11: a linha da tabela abre com Enter/Espaço, como qualquer botão */
      if(no.getAttribute('role')==='button'){
        no.onkeydown=function(e){
          if(e.key!=='Enter' && e.key!==' ') return;
          if(e.target!==no) return;         /* o botão de dentro cuida de si */
          e.preventDefault(); no.click();
        };
      }
      no.onclick=function(e){
        var lc=e.target.closest && e.target.closest('[data-lancar]');
        if(lc){ e.stopPropagation(); pvNovaAbrir(lc.getAttribute('data-lancar')); return; }
        if(_pvSemVenda(v)){
          e.stopPropagation();
          var w0=e.target.closest && e.target.closest('.ct-wa');
          if(w0){ var u0=w0.getAttribute('data-wa'); try{ window.open(u0,'_blank'); }catch(_){ location.href=u0; } return; }
          /* v807: os botões escritos do card também valem aqui — sem isto,
             tocar em "Registrar venda" ou no "⋯" de uma ficha sem venda
             caía neste atalho e abria a ficha do cliente. */
          var b0=e.target.closest && e.target.closest('[data-act]');
          if(b0){
            var a0=b0.getAttribute('data-act');
            if(a0==='lancar') return pvNovaAbrir(String(v.cliente_id||''));
            if(a0==='chat')   return pvChat(v);
            if(a0==='mais')   return pvCardMais(v);
          }
          /* a ficha desta pessoa é a do CLIENTE — não existe ficha de venda */
          try{ telaClientes(); }catch(_){}
          try{ setTimeout(function(){ crmFichaAbrir(v.cliente_id); }, 60); }catch(_){}
          return;
        }
        /* v521: "Entreguei" vem ANTES de tudo — ele está dentro do card e
           não pode abrir a ficha junto */
        var en=e.target.closest && e.target.closest('[data-entreguei]');
        if(en){ e.stopPropagation(); pvEntregar(v); return; }
        /* v540: a etiqueta também é botão, e pelo mesmo motivo vem antes */
        var st=e.target.closest && e.target.closest('[data-sit]');
        if(st){ e.stopPropagation(); pvSituacaoAbrir(st.getAttribute('data-sit')); return; }
        var b=e.target.closest && e.target.closest('[data-act]');
        var w=e.target.closest && e.target.closest('.ct-wa');
        if(w){ e.stopPropagation(); var u=w.getAttribute('data-wa'); try{ window.open(u,'_blank'); }catch(_){ location.href=u; } return; }
        if(b){
          e.stopPropagation();
          var a=b.getAttribute('data-act');
          if(a==='ver') return pvFichaAbrir(v.id);
          if(a==='chat') return pvChat(v);          /* v530 */
          if(a==='mais') return pvCardMais(v);      /* v807 §10 */
          if(a==='lancar') return pvNovaAbrir(String(v.cliente_id||''));
          if(a==='zap') return pvZap(v);            /* continua no arquivo: caminho de volta */
          if(a==='feito') return pvFeito(v);
          if(a==='adiar') return pvAdiar(v);
          return;
        }
        pvFichaAbrir(v.id);
      };
    });
  }

  /* ⛳ v530 (pedido: "troque o ícone do agendar por calendário") — o relógio
     do botão de adiar virou CALENDÁRIO. É o mesmo traço do `_ICO_CAL` que o
     resto do app usa pra agendar, com uma setinha à direita: adiar é jogar
     pra outra data, e a seta é o que diferencia os dois sem inventar um
     desenho novo. */
  var _ICO_CAL_MAIS=_cIco('<rect x="3" y="4" width="14" height="17" rx="2"/><line x1="13" y1="2" x2="13" y2="6"/><line x1="7" y1="2" x2="7" y2="6"/><line x1="3" y1="10" x2="17" y2="10"/><polyline points="18 14 21 17 18 20"/>');

  /* ---- v530: o chat de dentro do app, COM o texto pronto ----
     🔴 O texto é o mesmo do `pvZap` (`pvMensagem`). Se um dia a régua mudar
     de palavras, muda nos dois — porque é a MESMA função. */
  function pvChat(v){
    var c=_pvCliente(v);
    var fone=String((c&&c.telefone)||v.telefone||'');
    if(!fone){ toast('Esse cliente não tem telefone.'); return; }
    if(typeof chatPainelAbrirCliente!=='function'){ pvZap(v); return; }   /* rede */
    var p=pvProximo(v), texto='';
    try{ if(p) texto=pvMensagem(v,p); }catch(_){ texto=''; }
    chatPainelAbrirCliente(fone, (c&&c.nome)||v.cliente_nome||'Cliente', texto);
  }
  /* ---- o WhatsApp com o texto pronto: é AQUI que está o ganho de tempo ---- */
  function pvZap(v){
    var p=pvProximo(v); if(!p) return;
    var c=_pvCliente(v);
    var fone=String((c&&c.telefone)||v.telefone||'').replace(/\D/g,'');
    var u=cliWhatsUrl(fone);
    if(!u){ toast('Esse cliente não tem telefone.'); return; }
    var msg=pvMensagem(v,p);
    try{ window.open(u+'?text='+encodeURIComponent(msg),'_blank'); }
    catch(_){ location.href=u+'?text='+encodeURIComponent(msg); }
  }

  /* ---- gravar no jsonb posvenda ---- */
  async function pvSalva(v, muda){
    var p=Object.assign({}, _pvPv(v), muda||{});
    try{
      var r=await supa.from('vendas').update({ posvenda:p, atualizado_em:new Date().toISOString() }).eq('id',v.id);
      if(r&&r.error) throw r.error;
      v.posvenda=p;
      pvPinta();
      return true;
    }catch(e){
      var m=String((e&&e.message)||'');
      if(/posvenda/i.test(m) && /column|coluna/i.test(m))
        toast('Falta rodar o sql-v434-posvenda.sql no Supabase.');
      else toast('Não consegui salvar. '+m);
      return false;
    }
  }
  async function pvFeito(v){
    var p=pvProximo(v); if(!p) return;
    var pv=_pvPv(v);
    var feitos=(_pvFeitos(v)).concat([p.k]);
    var contatos=(Array.isArray(pv.contatos)?pv.contatos:[]).concat([{
      tipo:p.k, em:new Date().toISOString(), canal:'whatsapp', titulo:p.titulo }]);
    var ok=await pvSalva(v,{feitos:feitos, contatos:contatos});
    if(!ok) return;
    /* a memória da loja: entra no histórico do cliente, igual às anotações */
    try{ if(v.cliente_id) crmObsRegistrar(v.cliente_id,'Pós-venda: '+p.titulo,true); }catch(_){}
    toast('Contato registrado ✓');
  }
  async function pvAdiar(v){
    var p=pvProximo(v); if(!p) return;
    var ad=Object.assign({},(_pvPv(v).adiado||{}));
    ad[p.k]=_pvMais(_pvHoje(),7).toISOString().slice(0,10);
    if(await pvSalva(v,{adiado:ad})) toast('Adiado 7 dias.');
  }

  /* ---- exportar (mesmo CSV com ; e BOM da v429) ---- */
  function pvExportar(){
    var lista=_pvLista();
    if(!lista.length){ toast('Nada pra exportar.'); return; }
    var COLS=[
      ['Cliente', function(v){ var c=_pvCliente(v); return (c&&c.nome)||v.cliente_nome||''; }],
      ['Telefone',function(v){ var c=_pvCliente(v); return _crmFoneFmt((c&&c.telefone)||v.telefone||''); }],
      ['Veiculo', function(v){ return v.veiculo||''; }],
      ['Placa',   function(v){ return v.placa||''; }],
      ['Comprou em', function(v){ return _pvData(_pvEntrega(v)); }],
      ['Garantia ate', function(v){ var g=pvGarantia(v); return g?_pvData(g.fim):''; }],
      ['Proximo contato', function(v){ var p=pvProximo(v); return p?p.titulo:''; }],
      ['Quando', function(v){ var p=pvProximo(v); return p?_pvData(p.quando):''; }]
    ];
    function cel(x){ var t=(x==null?'':String(x)); return /[";\n\r]/.test(t)?('"'+t.replace(/"/g,'""')+'"'):t; }
    var linhas=[COLS.map(function(k){ return cel(k[0]); }).join(';')];
    lista.forEach(function(v){ linhas.push(COLS.map(function(k){ return cel(k[1](v)); }).join(';')); });
    try{
      var d=new Date(), mes=('0'+(d.getMonth()+1)).slice(-2), dia=('0'+d.getDate()).slice(-2);
      var b=new Blob(['﻿'+linhas.join('\r\n')],{type:'text/csv;charset=utf-8;'});
      var a=document.createElement('a'); a.href=URL.createObjectURL(b);
      a.download='pos-vendas-'+d.getFullYear()+'-'+mes+'-'+dia+'.csv';
      document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(a.href); a.remove(); }catch(_){} },1500);
      toast(lista.length+' linha'+(lista.length===1?'':'s')+' no arquivo ✓');
    }catch(_){ toast('Não consegui gerar o arquivo.'); }
  }

  /* ---- a ficha (fase 1: o essencial — o resto é a fase 2 do projeto) ---- */
  /* v460 — o painel de UMA manutencao: reclamacao, solucao, acompanhamento */
  function pvManAbrir(v, ix, depois){
    var m=_pvManuts(v)[ix]; if(!m) return;
    var pk=document.createElement('div'); pk.className='cropmask';
    var acs=Array.isArray(m.acompanhamentos)?m.acompanhamentos.slice().reverse():[];
    /* v466: WhatsApp direto do painel, com o texto pronto da manutenção —
       aberta = dar satisfação; resolvida = perguntar se ficou tudo certo. */
    var _mc=_pvCliente(v);
    var _mwa=cliWhatsUrl(String((_mc&&_mc.telefone)||v.telefone||''));
    pk.innerHTML='<div class="cropbox pv-cx"><div class="crop-tit">Manutenção</div>'+
      '<div class="pv-linha"><span>Aberta em</span><b>'+esc(_pvData(_pvDia(m.aberta_em)))+'</b></div>'+
      '<div class="pv-linha"><span>Situação</span><b>'+(m.status==='resolvida'?('Resolvida em '+esc(_pvData(_pvDia(m.resolvida_em)))):'Aberta')+'</b></div>'+
      '<label class="crm-lb">RECLAMAÇÃO</label><div class="pv-man-tx">'+esc(m.reclamacao||'')+'</div>'+
      (m.solucao?('<label class="crm-lb">SOLUÇÃO</label><div class="pv-man-tx ok">'+esc(m.solucao)+'</div>'):'')+
      '<label class="crm-lb">ACOMPANHAMENTO</label>'+
      '<div class="pv-hist">'+(acs.length?acs.map(function(x){
        var q=''; try{ q=new Date(x.em).toLocaleDateString('pt-BR'); }catch(_){}
        return '<div class="pv-hi"><b>'+esc(x.t||'')+'</b><i>'+esc(q)+'</i></div>';
      }).join(''):'<div class="pv-hi nada">nenhuma anotação ainda</div>')+'</div>'+
      '<div class="crm-obs"><textarea class="cad-in" id="pvManObs" rows="2" placeholder="Anotar o acompanhamento..."></textarea><button type="button" class="crm-send" id="pvManAnotar" title="Anotar">'+_cIco('<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>')+'</button></div>'+
      (_mwa?('<div class="pv-age"><button type="button" class="pv-agb zap" id="pvManZap">'+_icoWa+'WhatsApp</button></div>'):'')+
      '<div class="pv-fim">'+
        (m.status==='resolvida'
          ?'<button type="button" id="pvManReabrir">Reabrir</button>'
          :'<button type="button" id="pvManResolver">Marcar resolvida</button>')+
        '<button type="button" id="pvManFechar">Fechar</button>'+
      '</div></div>';
    document.body.appendChild(pk);
    function pclose(){ try{ pk.remove(); }catch(_){} }
    pk.onclick=function(e){ if(e.target===pk) pclose(); };
    pk.querySelector('#pvManFechar').onclick=pclose;
    async function grava(muda, obsCliente){
      var lista=_pvManuts(v).slice(); lista[ix]=Object.assign({}, m, muda);
      if(await pvSalva(v,{manutencoes:lista})){
        try{ if(obsCliente && v.cliente_id) crmObsRegistrar(v.cliente_id, obsCliente, true); }catch(_){}
        pclose(); if(depois) depois();
      }
    }
    var bZ=pk.querySelector('#pvManZap');
    if(bZ) bZ.onclick=function(){
      var nome=String((_mc&&_mc.nome)||v.cliente_nome||'').split(/\s+/)[0]||'tudo bem?';
      var msg=(m.status==='resolvida')
        ? ('Oi '+nome+'! Aqui é '+_pvVendedor()+', da '+_pvLoja()+' 🙂 Passando pra saber: depois do reparo'+(m.solucao?(' ('+m.solucao+')'):'')+', ficou tudo certo com o '+String(v.veiculo||'carro')+'? Qualquer coisa, é só me chamar por aqui.')
        : ('Oi '+nome+'! Aqui é '+_pvVendedor()+', da '+_pvLoja()+' 🙂 Sobre o que você relatou no '+String(v.veiculo||'carro')+(m.reclamacao?(' ("'+m.reclamacao+'")'):'')+': estamos cuidando disso e já te dou um retorno. Qualquer novidade aí, me chama por aqui!');
      try{ window.open(_mwa+'?text='+encodeURIComponent(msg),'_blank'); }
      catch(_){ location.href=_mwa+'?text='+encodeURIComponent(msg); }
    };
    var bA=pk.querySelector('#pvManAnotar');
    if(bA) bA.onclick=function(){
      var t=String((pk.querySelector('#pvManObs')||{}).value||'').trim(); if(!t) return;
      grava({ acompanhamentos:(Array.isArray(m.acompanhamentos)?m.acompanhamentos:[]).concat([{ t:t, em:new Date().toISOString() }]) });
    };
    var bR=pk.querySelector('#pvManResolver');
    if(bR) bR.onclick=function(){
      var sol=String(prompt('Qual foi a solução?')||'').trim(); if(!sol) return;
      grava({ status:'resolvida', solucao:sol, resolvida_em:new Date().toISOString() },
            'Manutenção resolvida: '+sol);
    };
    var bRe=pk.querySelector('#pvManReabrir');
    if(bRe) bRe.onclick=function(){ grava({ status:'aberta', resolvida_em:null }); };
  }
  function pvFichaAbrir(id){
    var v=(_pvVendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v) return;
    _pvSel=v;
    var c=_pvCliente(v), g=pvGarantia(v), evs=pvEventos(v);
    var p=pvProximo(v), wa=cliWhatsUrl(String((c&&c.telefone)||v.telefone||''));
    var pv=_pvPv(v), contatos=Array.isArray(pv.contatos)?pv.contatos.slice().reverse():[];
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox pv-cx"><div class="crop-tit">'+esc((c&&c.nome)||v.cliente_nome||'Cliente')+'</div>'+
      '<div class="pv-sub">'+esc(v.veiculo||'')+(v.placa?(' · '+esc(v.placa)):'')+'</div>'+
      '<div class="pv-linha"><span>Comprou em</span><b>'+esc(_pvData(_pvEntrega(v)))+'</b></div>'+
      '<div class="pv-linha"><span>Era repasse</span><button type="button" class="pv-tgl'+(_pvRepasse(v)?' on':'')+'" id="pvFRep">'+(_pvRepasse(v)?'Sim':'Não')+'</button></div>'+
      (v.valor_venda?('<div class="pv-linha"><span>Valor</span><b>'+estMoney(v.valor_venda)+'</b></div>'):'')+
      (g?('<div class="pv-linha"><span>Garantia até</span><button type="button" class="pv-gbt" id="pvFGar" title="Mudar a garantia (zero km = 3 anos)"><b>'+esc(_pvData(g.fim))+'</b> '+pvGarantiaPill(g)+'</button></div>'):'')+
      (p&&wa?('<div class="pv-age">'+
        '<button type="button" class="pv-agb zap" id="pvFZap">'+_icoWa+'WhatsApp</button>'+
        '<button type="button" class="pv-agb ok" id="pvFFeito">'+_cIco('<polyline points="20 6 9 17 4 12"/>')+'Contato feito</button>'+
      '</div>'):(p?('<div class="pv-age">'+
        '<button type="button" class="pv-agb ok" id="pvFFeito">'+_cIco('<polyline points="20 6 9 17 4 12"/>')+'Contato feito</button>'+
      '</div>'):''))+
      '<label class="crm-lb">A FAZER</label>'+
      '<div class="pv-agenda">'+(evs.length?evs.slice(0,3).map(function(e){
        return '<div class="pv-ag'+(_pvDif(e.quando)<0?' atras':'')+'"><b>'+esc(e.titulo)+'</b><i>'+esc(_pvQuando(e.quando))+'</i></div>';
      }).join('')+(evs.length>3?('<div class="pv-ag mais">e mais '+(evs.length-3)+'</div>'):'')
                     :'<div class="pv-ag nada">nada pendente</div>')+'</div>'+
      '<label class="crm-lb">JÁ FEITOS</label>'+
      '<div class="pv-hist">'+(contatos.length?contatos.map(function(x){
        var q=''; try{ q=new Date(x.em).toLocaleDateString('pt-BR'); }catch(_){}
        /* v459 (pedido): tocar num "ja feito" volta ele pra A FAZER */
        return '<div class="pv-hi" data-undo="'+esc(x.tipo||'')+'" data-em="'+esc(x.em||'')+'" title="Tocar pra voltar pra A FAZER"><b>'+esc(x.titulo||x.tipo||'contato')+'</b><i>'+esc(q)+'</i></div>';
      }).join(''):'<div class="pv-hi nada">nenhum contato registrado ainda</div>')+'</div>'+
      '<label class="crm-lb">MANUTENÇÃO</label>'+
      '<div class="pv-mans">'+(_pvManuts(v).length?_pvManuts(v).map(function(m,ix){
        return '<div class="pv-man'+(m.status==='resolvida'?' ok':'')+'" data-man="'+ix+'"><b>'+esc(m.reclamacao||'(sem descrição)')+'</b><i>'+esc(_pvData(_pvDia(m.aberta_em)))+' · '+(m.status==='resolvida'?'resolvida':'aberta')+'</i></div>';
      }).join(''):'')+
      '<button type="button" class="crm-mais-link" id="pvManNova">Registrar reclamação</button></div>'+
      '<div class="pv-fim">'+
        '<button type="button" id="pvFCli">Abrir o cliente</button>'+
        '<button type="button" id="pvFPausa" class="'+(_pvPausado(v)?'on':'')+'">'+(_pvPausado(v)?'Voltar a contatar':'Pausar contatos')+'</button>'+
        '<button type="button" id="pvFechar">Fechar</button>'+
      '</div></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#pvFechar').onclick=close;
    /* v459 — era repasse (liga/desliga) */
    var _rp=ov.querySelector('#pvFRep');
    if(_rp) _rp.onclick=async function(){
      if(await pvSalva(v,{repasse:!_pvRepasse(v)})){ close(); pvFichaAbrir(v.id); }
    };
    /* v459 — mudar a garantia: 90 dias (usado) · 1 ano · 3 anos (zero km) · data */
    var _gb=ov.querySelector('#pvFGar');
    if(_gb) _gb.onclick=function(){
      var g0=_pvPv(v).garantia||{};
      var pk=document.createElement('div'); pk.className='cropmask';
      pk.innerHTML='<div class="cropbox" style="max-width:300px"><div class="crop-tit">Garantia</div>'+
        '<div class="crm-pick">'+
        '<button type="button" class="crm-pi" data-g="90"><span>90 dias (usado — CDC)</span></button>'+
        '<button type="button" class="crm-pi" data-g="365"><span>1 ano</span></button>'+
        '<button type="button" class="crm-pi" data-g="1095"><span>3 anos (zero km)</span></button>'+
        '<button type="button" class="crm-pi" data-g="data"><span>Escolher a data…</span></button></div>'+
        '<button type="button" class="link" id="pvGFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
      document.body.appendChild(pk);
      function pclose(){ try{ pk.remove(); }catch(_){} }
      pk.onclick=function(e){ if(e.target===pk) pclose(); };
      pk.querySelector('#pvGFechar').onclick=pclose;
      Array.prototype.forEach.call(pk.querySelectorAll('.crm-pi'),function(bt){ bt.onclick=async function(){
        var k=bt.getAttribute('data-g'), gNovo=null;
        if(k==='data'){
          var atu=''; try{ atu=_pvData(pvGarantia(v).fim); }catch(_){}
          var t=String(prompt('Garantia até (dd/mm/aaaa):',atu)||'').trim();
          var m=t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if(!m){ if(t) toast('Data inválida — use dd/mm/aaaa.'); return; }
          gNovo={ inicio:g0.inicio||null, fim:m[3]+'-'+m[2]+'-'+m[1] };
        } else {
          gNovo={ inicio:g0.inicio||null, dias:Number(k) };
        }
        pclose();
        if(await pvSalva(v,{garantia:gNovo})){ close(); pvFichaAbrir(v.id); }
      }; });
    };
    /* v460 — registrar reclamacao e abrir uma manutencao */
    var _mn=ov.querySelector('#pvManNova');
    if(_mn) _mn.onclick=async function(){
      var t=String(prompt('Qual a reclamação do cliente?')||'').trim(); if(!t) return;
      var lista=_pvManuts(v).concat([{ aberta_em:new Date().toISOString(), reclamacao:t, status:'aberta', acompanhamentos:[] }]);
      if(await pvSalva(v,{manutencoes:lista})){
        try{ if(v.cliente_id) crmObsRegistrar(v.cliente_id,'Manutenção — reclamação: '+t,true); }catch(_){}
        close(); pvFichaAbrir(v.id);
      }
    };
    Array.prototype.forEach.call(ov.querySelectorAll('.pv-man'),function(mi){
      mi.onclick=function(){ pvManAbrir(v, Number(mi.getAttribute('data-man')), function(){ close(); pvFichaAbrir(v.id); }); };
    });
    /* v459 — desfazer um "ja feito" (volta pra A FAZER) */
    Array.prototype.forEach.call(ov.querySelectorAll('.pv-hi[data-undo]'),function(hi){
      hi.onclick=async function(){
        var k=hi.getAttribute('data-undo')||'', em=hi.getAttribute('data-em')||'';
        if(!k) return;
        var tit=(hi.querySelector('b')&&hi.querySelector('b').textContent)||k;
        if(!confirm('Voltar "'+tit+'" pra A FAZER?')) return;
        var pv2=_pvPv(v);
        var fs=(_pvFeitos(v)).slice(); var ix=fs.indexOf(k); if(ix>=0) fs.splice(ix,1);
        var tirou=false;
        var cs=(Array.isArray(pv2.contatos)?pv2.contatos:[]).filter(function(x){
          if(!tirou && String(x.tipo||'')===k && String(x.em||'')===em){ tirou=true; return false; }
          return true;
        });
        if(await pvSalva(v,{feitos:fs, contatos:cs})){ close(); pvFichaAbrir(v.id); }
      };
    });
    ov.querySelector('#pvFCli').onclick=function(){
      close();
      if(c) telaClientes().then(function(){ try{ crmFichaAbrir(c.id); }catch(_){} });
      else toast('Esta venda não tem cliente ligado.');
    };
    ov.querySelector('#pvFPausa').onclick=async function(){
      close();
      await pvSalva(v,{pausado:!_pvPausado(v)});
    };
    if(ov.querySelector('#pvFZap')) ov.querySelector('#pvFZap').onclick=function(){ pvZap(v); };
    if(ov.querySelector('#pvFFeito')) ov.querySelector('#pvFFeito').onclick=async function(){ close(); await pvFeito(v); };
  }

  /* ---- registrar venda antiga: dois campos (cliente + veículo) + data ---- */
  function pvNovaAbrir(clienteId){
    var ov=document.createElement('div'); ov.className='cropmask';
    var cls=(_clientes||[]).slice().sort(function(a,b){ return String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR'); });
    ov.innerHTML='<div class="cropbox pv-cx"><div class="crop-tit" id="pvNvTit">Registrar venda antiga</div>'+
      /* v521: o combo mostra TELEFONE junto do nome. Com 107 fichas e nomes
         de empresa compridos, escolher só pelo nome é adivinhação — no
         print do Angelo o nome batia no fim da caixa e sumia ("…ADVOCA"). */
      '<label class="crm-lb">CLIENTE</label><select class="cad-in" id="pvNvCli"><option value="">Escolha o cliente...</option>'+
        cls.map(function(c){ var f=c.telefone?(' — '+_crmFoneFmt(c.telefone)):'';
          return '<option value="'+esc(c.id)+'">'+esc((c.nome||'(sem nome)')+f)+'</option>'; }).join('')+'</select>'+
      /* v530 (pedido): CAIXA ALTA sem depender do Caps Lock. O nome do
         veículo entra pela mão, no meio do atendimento — e metade das
         fichas ficava "saveiro" e a outra "SAVEIRO". A tabela e a busca
         ficam desalinhadas por causa disso. ⚠️ `text-transform` no CSS
         mudaria só o DESENHO e gravaria minúsculo no banco: tem que ser no
         valor, ao digitar. */
      '<label class="crm-lb">VEÍCULO</label><input class="cad-in mev-alta" id="pvNvVeic" placeholder="EX.: POLO TRACK 2023">'+
      /* v521 (PROJETO-entrega-pendente): o estado que faltava — comprou,
         assinou, e o carro ainda não saiu.
         ⛳ v540 (pedido): aquela caixinha "Ainda não entreguei" virou LISTA.
         "Não entreguei" cobria três situações que não se parecem em nada —
         esperando a nota, esperando o carro chegar, e o carro na loja em
         preparação — e quem olhava a lista depois não sabia em qual delas
         cada venda estava. Ver o 12n.
         ⚠️ O padrão continua sendo "Entregue" (era a caixinha desmarcada):
         mudar o padrão faria toda venda nascer pendente sem ninguém pedir. */
      (SITUACAO_ON
        ? ('<label class="crm-lb">SITUAÇÃO</label><select class="cad-in" id="pvNvSit">'+
            pvSitEscolhiveis().map(function(s){
              return '<option value="'+s.k+'"'+(s.k==='entregue'?' selected':'')+'>'+esc(s.rot)+'</option>';
            }).join('')+'</select>')
        : '<label class="pv-nv-pend"><input type="checkbox" id="pvNvPend"><span>Ainda não entreguei</span></label>')+
      /* v530 (pedido: "permita flegar zero quilômetro") — carro 0 km ainda
         NÃO TEM PLACA na hora da venda. Sem esta caixinha, o campo Placa
         fica pedindo uma coisa que não existe, e a pessoa inventa ou deixa
         vazio sem saber se pode. */
      '<label class="pv-nv-pend"><input type="checkbox" id="pvNvZero"><span>Zero quilômetro</span></label>'+
      '<div class="crm-2c"><div style="flex:1"><label class="crm-lb" id="pvNvPlacaLb">PLACA</label><input class="cad-in" id="pvNvPlaca" maxlength="8" placeholder="ABC1D23"></div>'+
      '<div style="flex:1"><label class="crm-lb" id="pvNvDataLb">DATA DA ENTREGA</label><input class="cad-in" id="pvNvData" type="date"></div></div>'+
      '<button type="button" class="cad-btn" id="pvNvOk" style="margin-top:16px;width:100%">Registrar</button>'+
      '<button type="button" class="link" id="pvNvNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    var q=function(i){ return ov.querySelector('#'+i); };
    if(clienteId) q('pvNvCli').value=String(clienteId);
    /* v882 — a trava da placa, a mesma do campo da home (01-nucleo). */
    try{ placaLigar(q('pvNvPlaca')); }catch(_){ q('pvNvPlaca').addEventListener('input',function(){ this.value=this.value.toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); }); }
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    q('pvNvNao').onclick=close;
    /* v521: marcou "ainda não entreguei" → a data vira PREVISÃO (opcional)
       e o título muda. "Registrar venda antiga" com carro não entregue é
       contraditório. */
    /* v530: caixa alta ao digitar, sem Caps Lock, preservando o cursor */
    Array.prototype.forEach.call(ov.querySelectorAll('.mev-alta'),function(inp){
      inp.addEventListener('input',function(){
        var ini=this.selectionStart, fim=this.selectionEnd, alto=this.value.toUpperCase();
        if(alto!==this.value){ this.value=alto; try{ this.setSelectionRange(ini,fim); }catch(_){} }
      });
    });
    /* v530: 0 km → a placa não existe ainda. O campo é desligado e DIZ o
       porquê, em vez de ficar lá pedindo o que ninguém tem. */
    var _zero=q('pvNvZero');
    if(_zero) _zero.onchange=function(){
      var on=_zero.checked, pl=q('pvNvPlaca'), lb=q('pvNvPlacaLb');
      if(pl){ pl.disabled=on; if(on) pl.value=''; pl.placeholder = on ? 'sai depois do emplacamento' : 'ABC1D23'; }
      if(lb) lb.textContent = on ? 'PLACA (0 km — ainda não tem)' : 'PLACA';
    };
    /* a mesma troca de rótulo da v521, agora comandada pela lista */
    function _nvPendente(){
      var s=q('pvNvSit');
      if(s) return s.value!=='entregue';
      return !!(q('pvNvPend')&&q('pvNvPend').checked);
    }
    function _nvRotulos(){
      var on=_nvPendente(), lb=q('pvNvDataLb'), tt=q('pvNvTit');
      if(lb) lb.textContent = on ? 'PREVISÃO DE ENTREGA (opcional)' : 'DATA DA ENTREGA';
      if(tt) tt.textContent = on ? 'Registrar venda' : 'Registrar venda antiga';
    }
    var _pend=q('pvNvPend'); if(_pend) _pend.onchange=_nvRotulos;
    var _sit=q('pvNvSit');   if(_sit)  _sit.onchange=_nvRotulos;
    q('pvNvOk').onclick=async function(){
      var cid=q('pvNvCli').value;
      if(!cid){ toast('Escolha o cliente.'); return; }
      var pend=_nvPendente();
      /* v540: qual das três fases — só existe quando a venda nasce pendente */
      var fase=(q('pvNvSit')&&pend)?q('pvNvSit').value:'';
      var zero=!!(q('pvNvZero')&&q('pvNvZero').checked);
      var dt=q('pvNvData').value;
      /* a trava continua valendo pra venda ENTREGUE: é da data que sai toda
         a régua. Só a pendente é dispensada — e ela paga por isso ficando
         fora da régua inteira (ver os guards do pvEventos/pvGarantia). */
      if(!pend && !dt){ toast('Ponha a data da entrega — é dela que sai toda a régua.'); return; }
      var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(cid); })[0]||{};
      var hojeISO=new Date().toISOString();
      var reg={ user_id:meuId, cliente_id:cid, cliente_nome:c.nome||null,
        veiculo:(q('pvNvVeic').value||'').trim().toUpperCase()||null,
        placa:(zero?null:((q('pvNvPlaca').value||'').trim()||null)),
        data_entrega:(pend?null:dt), etapa:'posvenda',
        /* 🔴 fechada:true MESMO pendente. O `_pvVendas` só enxerga venda
           fechada — uma pendente que nascesse com fechada:false não
           apareceria em tela nenhuma: nem em Leads (porque tem venda),
           nem no pós-venda (porque não está fechada). */
        fechada:true, fechada_em:(pend?hojeISO:new Date(dt).toISOString()) };
      /* 🔴 v540: a `situacao` SOMA ao `entrega_pendente`, não substitui. A
         bandeira é o que o pvGarantia, o pvEventos e o filtro leem desde a
         v521 — trocar uma pela outra quebraria os três de uma vez. */
      if(pend) reg.posvenda={ entrega_pendente:true, previsao:(dt||null),
                              pendente_desde:hojeISO.slice(0,10),
                              situacao:(fase||'faturamento') };
      /* 🔴 o 0 km fica GRAVADO, não só na tela: é ele que explica, seis meses
         depois, por que esta venda não tem placa. Sem isso vira "ficha mal
         preenchida" pra quem abrir. */
      if(zero) reg.posvenda=Object.assign({}, reg.posvenda||{}, { zero_km:true });
      close();
      try{
        var r=await supa.from('vendas').insert(reg).select().single();
        if(r&&r.error) throw r.error;
        if(r&&r.data){ _vendas.unshift(r.data); _pvVendas.unshift(r.data); }
        pvPinta();
        toast('Venda registrada ✓');
      }catch(err){ toast('Não consegui registrar. '+((err&&err.message)||'')); }
    };
  }

/* ╔═══ src/app/12f-pre-renave.js ═════════════════════════════════════════ */
  /* ================= v442 · PRÉ-RENAVE ==================================
     O RENAVE virou obrigatório no Brasil inteiro (Resolução Contran
     1.026/2026) e no RS já valia pela Portaria Detran/RS 401/2025. Só que a
     loja NÃO fala direto com o RENAVE: toda entrada e saída de estoque passa
     por uma empresa integradora autorizada pelo Senatran.

     Então esta página NÃO transmite nada. Ela faz a parte que ninguém faz:
     junta, num bloco só, os dados que o integrador vai pedir na ENTRADA DE
     ESTOQUE — e mostra, antes, qual carro está com dado faltando.

     De onde vem cada dado:
       · do cadastro do estoque      — placa, marca, modelo, ano, cor, km,
                                       valor de compra, data de entrada
       · do CRLV lido na venda       — chassi e renavam, quando o carro já
                                       passou por uma conferência de documentos
                                       (mp_vendas.proposta.conferido)
       · digitado aqui               — o que faltar

     O que é digitado aqui vai pra extras.prerenave do próprio veículo (jsonb
     que já existe — SEM migração de banco).
     ⚠️ O estColeta() do 14-estoque.js reconstrói o extras do zero a cada
     autosave. Por isso ele preserva o prerenave explicitamente, igual já fazia
     com o post_ia (v177) e a importação do anúncio (v199). Sem isso, abrir a
     ficha do carro e digitar qualquer letra apagaria o chassi. */

  var _prVeics=[], _prBusca='', _prAberto='', _prSaveTimer=null;

  /* ids com prefixo "prn" de propósito: prPlaca/prRenavam/prChassi JÁ EXISTEM
     na procuração (18-credito-e-troca.js). Classe CSS usa "pr-", que estava
     livre no styles.css (conferido antes de criar — regra da v434). */

  /* os campos da entrada de estoque. obr=1 é o que trava o registro. */
  var _PR_CAMPOS=[
    ['placa',   'Placa',           1],
    ['chassi',  'Chassi',          1],
    ['renavam', 'Renavam',         1],
    ['marca',   'Marca',           1],
    ['modelo',  'Modelo',          1],
    ['ano',     'Ano fab./mod.',   1],
    ['cor',     'Cor',             1],
    ['km',      'Quilometragem',   0],
    ['compra',  'Valor de compra', 0],
    ['entrada', 'Data de entrada', 1]
  ];

  function _prSalvo(v){ return (((v||{}).extras)||{}).prerenave||{}; }

  /* chassi e renavam que o app JÁ SABE: o CRLV lido na conferência de
     documentos de uma venda desta mesma placa. É o dado que o vendedor já
     digitou (ou fotografou) uma vez — não vamos pedir de novo. */
  function _prDoCrlv(placa){
    var p=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(!p) return null;
    var achou=null;
    (_vendas||[]).forEach(function(vd){
      var pp=String(vd.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
      if(pp!==p) return;
      var cf=((vd.proposta||{}).conferido)||null;
      if(cf && typeof cf==='object' && (cf.chassi||cf.renavam)) achou=cf;
    });
    return achou;
  }

  /* {valor, origem, ok} de um campo. origem só é usada no painel aberto. */
  function _prCampo(v, k){
    var sv=_prSalvo(v), crlv=_prDoCrlv(v.placa);
    function fim(val, org, ok){ return { valor:String(val==null?'':val).trim(), origem:org||'', ok:!!ok }; }
    /* v465: quem preencheu pode ter sido a IA lendo o CRLV anexado na ficha
       do estoque (14f). O carimbo pr.ia diz de quem foi a mão — e some
       quando você mexe no campo (prSalvar). */
    if(k==='chassi'){
      if(sv.chassi) return fim(String(sv.chassi).toUpperCase(),((sv.ia||{}).chassi?'lido do CRLV pela IA':'você digitou'), _vfChassiOk(sv.chassi));
      if(crlv&&crlv.chassi) return fim(String(crlv.chassi).toUpperCase(),'lido do CRLV na venda', _vfChassiOk(crlv.chassi));
      return fim('','',false);
    }
    if(k==='renavam'){
      if(sv.renavam) return fim(sv.renavam,((sv.ia||{}).renavam?'lido do CRLV pela IA':'você digitou'), _vfRenavamOk(sv.renavam));
      if(crlv&&crlv.renavam) return fim(crlv.renavam,'lido do CRLV na venda', _vfRenavamOk(crlv.renavam));
      return fim('','',false);
    }
    if(k==='placa'){ var pl=String(v.placa||'').toUpperCase(); return fim(pl,'do cadastro', _vfPlacaOk(pl)); }
    if(k==='marca')  return fim(v.marca,'do cadastro', !!String(v.marca||'').trim());
    if(k==='modelo') return fim(v.modelo,'do cadastro', !!String(v.modelo||'').trim());
    if(k==='cor')    return fim(v.cor,'do cadastro', !!String(v.cor||'').trim());
    if(k==='ano'){
      var af=String(v.ano||'').trim(), am=String(v.ano_modelo||'').trim();
      var t=(af||am)?((af||am)+'/'+(am||af)):'';
      return fim(t,'do cadastro', !!t);
    }
    if(k==='km'){ var q=Number(v.km)||0; return fim(q?(q.toLocaleString('pt-BR')+' km'):'','do cadastro', q>0); }
    if(k==='compra'){ var c=Number(v.preco_compra)||0; return fim(c?brl(c):'','do cadastro', c>0); }
    if(k==='entrada'){
      var d=String(v.data_entrada||'').slice(0,10);
      var t2=/^\d{4}-\d{2}-\d{2}$/.test(d)?(d.slice(8,10)+'/'+d.slice(5,7)+'/'+d.slice(0,4)):'';
      return fim(t2,'do cadastro', !!t2);
    }
    return fim('','',false);
  }

  /* lista dos campos OBRIGATÓRIOS que ainda não fecham */
  function _prFaltas(v){
    var f=[];
    _PR_CAMPOS.forEach(function(c){ if(!c[2]) return; if(!_prCampo(v,c[0]).ok) f.push(c[1]); });
    return f;
  }

  /* ---------- o texto que vai pro sistema do integrador ---------- */
  function _prFichaTexto(v){
    var l=['ENTRADA DE ESTOQUE — RENAVE'];
    _PR_CAMPOS.forEach(function(c){
      var d=_prCampo(v,c[0]);
      l.push(c[1]+': '+(d.valor||'—'));
    });
    return l.join('\n');
  }

  /* ---------- a tela ----------
     v443: recebe "alvo" = o painel de uma aba, igual fazem as telas de gestão
     das Vendas (vendasPainelEscolher, telaCotacoes…). SEM alvo, desenha a
     página inteira — assim a rota antiga drawerIr('prerenave') continua
     abrindo, mesmo com o botão do menu escondido. */
  async function telaPreRenave(alvo){
    if(!alvo) mevTabSet('');
    (alvo||$('secoes')).innerHTML='<div class="info-pg pr-pg"><h2>Pré-RENAVE</h2>'+
      '<div class="pr-selos" id="prnSelos"></div>'+
      '<div class="pr-acoes">'+
        '<div class="cli-search pr-busca">'+_icoBusca+'<input id="prnBusca" placeholder="Placa ou modelo" autocomplete="off"></div>'+
      '</div>'+
      '<div id="prnLista">'+pgLoad('Conferindo o estoque…')+'</div>'+
    '</div>';
    if(!alvo){
      $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
      document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block';
      window.scrollTo(0,0); fabFoto(false); voltarTab(voltarHome);
    }
    $('prnBusca').oninput=function(){ _prBusca=this.value; prPinta(); };
    if(!(_estoque||[]).length){ try{ await estCarregar(); }catch(_){} }
    if(!(_vendas||[]).length){ try{ await vendaCarregar(); }catch(_){} }
    /* carro vendido já saiu do estoque — a entrada dele não é mais assunto */
    _prVeics=(_estoque||[]).filter(function(v){ return String(v.status||'disponivel')!=='vendido'; });
    prPinta();
  }

  function prPinta(){
    var el=$('prnLista'); if(!el) return;
    var q=String(_prBusca||'').trim().toLowerCase();
    var lista=_prVeics.filter(function(v){
      if(!q) return true;
      return (String(v.placa||'')+' '+String(v.marca||'')+' '+String(v.modelo||'')).toLowerCase().indexOf(q)>=0;
    });
    var prontos=0, pend=0;
    _prVeics.forEach(function(v){ if(_prFaltas(v).length) pend++; else prontos++; });
    var sel=$('prnSelos');
    if(sel){
      sel.innerHTML='<div class="pr-selo"><b>'+prontos+'</b><span>prontos</span></div>'+
        '<div class="pr-selo'+(pend?' ruim':'')+'"><b>'+pend+'</b><span>com dado faltando</span></div>';
    }
    if(!lista.length){
      el.innerHTML='<div class="cli-empty"><b>Nenhum veículo</b>'+
        (q?'Nada com esse termo.':'Cadastre um carro no Estoque para ele aparecer aqui.')+'</div>';
      return;
    }
    el.innerHTML=lista.map(function(v){ return _prItemHtml(v); }).join('');
    prWire();
  }

  function _prItemHtml(v){
    var id=String(v.id||'');
    var falta=_prFaltas(v);
    var nome=[String(v.marca||''),String(v.modelo||'')].join(' ').trim()||'Sem modelo';
    var selo = falta.length
      ? ('<span class="pr-tag ruim">'+(falta.length===1?('Falta '+falta[0].toLowerCase()):('Faltam '+falta.length+' dados'))+'</span>')
      : '<span class="pr-tag ok">Pronto</span>';
    var aberto=(String(_prAberto||'')===id);
    return '<div class="pr-item'+(aberto?' on':'')+'" data-pr-id="'+esc(id)+'">'+
      '<button type="button" class="pr-hd" data-pr-abre="'+esc(id)+'">'+
        '<span class="pr-hd-tx"><b>'+esc(nome)+'</b><i>'+esc(String(v.placa||'sem placa').toUpperCase())+'</i></span>'+
        selo+
        '<span class="pr-caret"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>'+
      '</button>'+
      (aberto?_prPainelHtml(v):'')+
    '</div>';
  }

  function _prPainelHtml(v){
    var id=String(v.id||'');
    var linhas=_PR_CAMPOS.map(function(c){
      var k=c[0], d=_prCampo(v,k);
      /* chassi e renavam são os únicos que se digita aqui — o resto se
         conserta no cadastro do carro, que é onde ele mora */
      if(k==='chassi'||k==='renavam'){
        var mx=(k==='chassi')?17:11;
        return '<label class="pr-cp'+(d.ok?' ok':'')+'">'+
          '<span class="pr-cp-r">'+esc(c[1])+'</span>'+
          '<input class="cad-in pr-in" id="prn_'+k+'_'+esc(id)+'" data-pr-campo="'+k+'" data-pr-veic="'+esc(id)+'" '+
            'value="'+esc(d.valor)+'" maxlength="'+mx+'" autocomplete="off" '+
            (k==='renavam'?'inputmode="numeric" ':'')+'placeholder="'+(k==='chassi'?'17 caracteres':'11 dígitos')+'">'+
          '<span class="pr-cp-og" id="prnOg_'+k+'_'+esc(id)+'">'+esc(d.valor?d.origem:'')+'</span>'+
        '</label>';
      }
      return '<div class="pr-cp'+(d.ok?' ok':'')+(d.valor?'':' vazio')+'">'+
        '<span class="pr-cp-r">'+esc(c[1])+'</span>'+
        '<span class="pr-cp-v">'+esc(d.valor||'—')+'</span>'+
      '</div>';
    }).join('');
    return '<div class="pr-corpo">'+
      '<div class="pr-grade">'+linhas+'</div>'+
      '<button type="button" class="cad-btn ico pr-copiar" data-pr-copia="'+esc(id)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>'+
        'Copiar ficha</button>'+
    '</div>';
  }

  function prWire(){
    var el=$('prnLista'); if(!el) return;
    el.querySelectorAll('[data-pr-abre]').forEach(function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-pr-abre');
        _prAberto=(String(_prAberto||'')===String(id))?'':String(id);
        prPinta();
      };
    });
    el.querySelectorAll('[data-pr-copia]').forEach(function(b){
      b.onclick=function(){
        var v=_prVeic(b.getAttribute('data-pr-copia')); if(!v) return;
        var txt=_prFichaTexto(v);
        try{
          navigator.clipboard.writeText(txt).then(function(){ toast('Ficha copiada ✓'); }, function(){ prompt('Copie:',txt); });
        }catch(_){ prompt('Copie:',txt); }
      };
    });
    el.querySelectorAll('[data-pr-campo]').forEach(function(inp){
      inp.oninput=function(){
        var k=inp.getAttribute('data-pr-campo'), id=inp.getAttribute('data-pr-veic');
        var val=String(inp.value||'');
        if(k==='chassi'){ val=val.toUpperCase().replace(/[^A-Z0-9]/g,''); }
        else { val=val.replace(/\D/g,''); }
        if(inp.value!==val) inp.value=val;
        var ok=(k==='chassi')?_vfChassiOk(val):_vfRenavamOk(val);
        var cx=inp.parentElement; if(cx) cx.className='pr-cp'+(ok?' ok':'');
        var og=$('prnOg_'+k+'_'+id); if(og) og.textContent=val?'você digitou':'';
        clearTimeout(_prSaveTimer);
        _prSaveTimer=setTimeout(function(){ prSalvar(id,k,val); },700);
      };
    });
  }

  function _prVeic(id){
    return (_prVeics||[]).filter(function(x){ return String(x.id)===String(id); })[0]||null;
  }

  /* grava dentro do extras do próprio veículo — sem coluna nova no banco */
  async function prSalvar(id, campo, valor){
    var v=_prVeic(id); if(!v) return;
    var ex=Object.assign({}, v.extras||{});
    var pr=Object.assign({}, ex.prerenave||{});
    if(valor) pr[campo]=valor; else delete pr[campo];
    if(pr.ia && pr.ia[campo]){ pr.ia=Object.assign({},pr.ia); delete pr.ia[campo]; }   /* v465: mexeu na mão → o carimbo da IA sai */
    pr.em=new Date().toISOString();
    ex.prerenave=pr; v.extras=ex;
    try{
      await supa.from('estoque').update({ extras:ex, atualizado_em:new Date().toISOString() }).eq('id',v.id);
    }catch(_){}
    /* o selo do carro muda de cor sem fechar o painel aberto */
    try{ var sel=$('prnSelos'); if(sel){ var p=0,q=0;
      _prVeics.forEach(function(x){ if(_prFaltas(x).length) q++; else p++; });
      sel.innerHTML='<div class="pr-selo"><b>'+p+'</b><span>prontos</span></div>'+
        '<div class="pr-selo'+(q?' ruim':'')+'"><b>'+q+'</b><span>com dado faltando</span></div>'; } }catch(_){}
  }

/* ╔═══ src/app/12g-crm-salvamento.js ═════════════════════════════════════ */
  /* ==========================================================================
     12g — O CRM SALVA DE VERDADE, E A TEMPERATURA EM UM TOQUE (v516)
     (PROJETO-crm-salva-sozinho-e-a-temperatura)

     PEDIDOS (Angelo, 16/08):
       1. "o CRM dos clientes deve salvar automaticamente";
       2. "quando for marcar a temperatura deve abrir as 3 opções pra
           selecionar ao clicar".

     ⚠️ ANTES DE MEXER: O CRM JÁ SALVAVA SOZINHO. O problema era outro.
     Cadastro completo, ficha rápida, célula da tabela, temperatura,
     etiqueta e agendamento — todos já gravavam sem botão Salvar. O que
     havia eram TRÊS jeitos de o salvamento mentir, e são esses que este
     módulo conserta. Quem chegar aqui achando que vai "criar o autosave"
     vai criar o segundo.

     🔴 OS TRÊS BURACOS (em ordem de gravidade):

     B2 — TROCAR DE CLIENTE GRAVAVA NO CLIENTE ERRADO.
       O `_crmTimer` é UM relógio global. O `agenda()` fecha em cima do
       `id` do cliente aberto, mas o `coleta()` lê o DOM — e o DOM é um só.
       Corrigi o telefone do cliente A, cliquei no B antes de 1,2 s, e o
       relógio de A disparava lendo a tela do B: **o A virava uma cópia do
       B**, nome, telefone, cidade e faixas. Calado. Descoberto semanas
       depois, quando "o cliente A sumiu".
       DOIS CINTOS, e valem os dois:
         a) `crmFlush()` roda ANTES de a ficha ser repintada (o que estava
            pendente é gravado no dono certo, com o DOM ainda dele);
         b) `crmPendEhDaFichaAberta(id)` — o relógio só grava se a ficha
            aberta AINDA for a mesma (compara com o `_crmSel`, que é quem
            manda de verdade). É o cinto que segura se aparecer um quarto
            caminho de repintura que ninguém lembrou.

     B1 — FECHAR A FICHA JOGAVA FORA O PENDENTE.
       O `cliModalFechar` (cadastro completo) já chamava `_cfFlush()`. O
       `crmFichaFechar` (ficha rápida) só limpava o relógio e ia embora —
       depois de a tela ter escrito "Salvando…" na cara do usuário. É a
       pior forma de perder dado: com aviso de que estava salvando.

     B3 — "SALVO ✓" QUE NÃO SALVOU NADA.
       Regra 6 do CLAUDE.md (nasceu na v483): **update barrado pela RLS NÃO
       é erro** no supabase-js — volta sucesso com ZERO linhas. Desde a
       v484 (carteira do vendedor, RLS por dono) isso deixou de ser teoria:
       vendedor editando cliente de outra carteira recebia "Salvo ✓" e não
       salvava nada. Mentir sobre ter salvo é PIOR do que não ter
       salvamento automático — com botão a pessoa desconfia; com o ✓ verde
       ela confia e vai embora.
       → `_crmGravaConfere()` usa `.select('id')` e olha se veio linha.

     B4 — a ficha rápida salvava 8 campos e o cadastro completo 15. Hoje
     não perdia nada (os extras só existem na outra tela), mas ligar um
     campo novo no HTML sem somar no `coleta()` criaria um campo que aceita
     digitação e nunca salva, sem erro nenhum. → `CX_CAMPOS`, lista única
     que liga o input E monta o patch. Impossível ligar e esquecer.

     B5 — sair da página (fechar aba, botão voltar do celular) não passava
     por nenhum "fechar". → `visibilitychange` + `pagehide`.
     ⚠️ NADA de `beforeunload` com "tem certeza que quer sair?" — é o tipo
     de aviso que interrompe sem resolver. Salvar calado é melhor.

     ⚠️ ONDE ESTE ARQUIVO VIVE: dentro do IIFE grande (01 → 19), depois do
     `12-crm-clientes.js` na ordem alfabética. Ele enxerga `_crmTimer`,
     `_crmSel`, `_clientes`, `supa`, `toast` — tudo do 12. O 12 chama as
     funções daqui com typeof-guard onde faz diferença.
     ⚠️ O `12-crm-clientes.js` tem 128 KB e é dos arquivos mais disputados
     do projeto: módulo novo é a técnica anticolisão de sempre.
     ========================================================================= */

  /* ---------------------------------------------------------------------
     1) A GRAVAÇÃO HONESTA — a peça que todo mundo devia usar
     --------------------------------------------------------------------- */
  /* Devolve { ok, linhas, erro }. `ok` só é true se o banco confirmou a
     linha. Quem chama decide a mensagem — esta função não dá toast. */
  var _crmUltimoErro='';
  async function _crmGravaConfere(tabela, patch, id){
    var out;
    try{
      var r = await supa.from(tabela).update(patch).eq('id', id).select('id');
      if(r && r.error) out={ ok:false, linhas:0, erro:(r.error.message||'erro') };
      else{
        var n = (r && r.data && r.data.length) || 0;
        /* 🔴 zero linhas = a RLS barrou. Sucesso no protocolo, nada no banco. */
        out = n ? { ok:true, linhas:n, erro:'' } : { ok:false, linhas:0, erro:'rls' };
      }
    }catch(e){ out={ ok:false, linhas:0, erro:String((e&&e.message)||e) }; }
    _crmUltimoErro = out.ok ? '' : out.erro;
    return out;
  }
  /* 🔴 RLS NÃO SE RESOLVE TENTANDO DE NOVO. Os dois autosaves reagendam em
     4 s quando falham — o que é certo pra internet caindo e é um LOOP
     ETERNO de updates quando o motivo é permissão. Quem tenta de novo
     pergunta aqui antes. */
  function crmErroFoiRls(){ return _crmUltimoErro==='rls'; }
  /* a frase que o usuário lê quando a RLS barrou — precisa dizer o MOTIVO
     provável, senão ele tenta de novo a vida toda achando que é internet */
  var CRM_ERRO_RLS = 'Não consegui salvar — este cliente não é da sua carteira.';
  function _crmMsgErro(res){
    if(!res) return 'Não consegui salvar.';
    return res.erro==='rls' ? CRM_ERRO_RLS : ('Não consegui salvar. '+(res.erro||''));
  }

  /* ---------------------------------------------------------------------
     2) O PENDENTE COM DONO — o conserto do B2
     --------------------------------------------------------------------- */
  var _crmPendId=null, _crmPendColeta=null;

  function crmPendMarcar(id, coletaFn){ _crmPendId=id; _crmPendColeta=coletaFn; }
  function crmPendLimpar(){ _crmPendId=null; _crmPendColeta=null; }
  /* 🔴 O CINTO (b). Compara com o `_crmSel`, que é quem realmente diz qual
     ficha está na tela — e é atualizado pelo `crmFichaAbrir`. Se o usuário
     trocou de cliente, o relógio do anterior morre em silêncio: o que ele
     ia gravar já foi salvo pelo flush, no dono certo. */
  function crmPendEhDaFichaAberta(id){ return String(_crmSel)===String(id); }

  /* Descarrega o que está pendente ANTES de a tela ser repintada.
     ⚠️ Chamar SEM await também funciona e é de propósito: o `coleta()` é
     avaliado de forma síncrona aqui dentro (antes do primeiro await), então
     ele lê o DOM certo mesmo quando quem chama não espera — que é o caso do
     `crmFichaFechar` e do `pagehide`.
     ⚠️ Limpa o relógio ANTES de gravar (risco 4 do projeto): flush e
     relógio disparando juntos gravariam duas vezes. */
  async function crmFlush(){
    if(!_crmPendId || typeof _crmPendColeta!=='function') return true;
    if(_crmTimer){ clearTimeout(_crmTimer); _crmTimer=null; }
    var id=_crmPendId, dados=null;
    try{ dados=_crmPendColeta(); }catch(_){ dados=null; }
    crmPendLimpar();
    if(!dados) return true;
    try{ return await crmSalvaCampo(id, dados); }catch(_){ return false; }
  }
  /* os DOIS flushes num lugar só — a ficha rápida e o cadastro completo */
  function crmFlushTudo(){
    try{ crmFlush(); }catch(_){}
    try{ if(typeof _cfFlush==='function') _cfFlush(); }catch(_){}
  }

  /* ---------------------------------------------------------------------
     3) B5 — SAIR DA PÁGINA COM ALTERAÇÃO PENDENTE
     --------------------------------------------------------------------- */
  /* `visibilitychange` (o app foi pro fundo / trocou de aba) e `pagehide`
     (fechou, recarregou, voltou pelo botão do celular) são o que o
     navegador garante no celular. Nenhum dos dois pergunta nada. */
  try{
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState==='hidden') crmFlushTudo();
    });
    window.addEventListener('pagehide', crmFlushTudo);
  }catch(_){}

  /* ---------------------------------------------------------------------
     4) B4 — A LISTA ÚNICA DE CAMPOS DA FICHA RÁPIDA
     --------------------------------------------------------------------- */
  /* [ id do input, coluna do banco, como converter ]. É esta lista que o
     `crmFichaAbrir` usa pra LIGAR os campos E pra montar o patch. Campo
     novo entra aqui e passa a salvar sozinho — não existe mais o caminho
     de ligar um input e esquecer de gravá-lo. */
  function _crmInt(v){
    return parseInt(String(v||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10) || null;
  }
  function _crmTxt(v){ return String(v==null?'':v).trim(); }
  var CX_CAMPOS = [
    ['cxNome',      'nome',          _crmTxt],
    ['cxTel',       'telefone',      _crmTxt],
    ['cxCidade',    'cidade',        _crmTxt],
    ['cxUf',        'uf',            _crmTxt],
    ['cxInteresse', 'interesse',     _crmTxt],
    ['cxFaixaP',    'faixa_preco',   _crmInt],
    ['cxFaixaParc', 'faixa_parcela', _crmInt],
    ['cxOrigem',    'origem',        function(v){ return _crmTxt(v) || null; }]
  ];
  function crmColetaFicha(){
    var o={};
    CX_CAMPOS.forEach(function(cp){
      var e=$(cp[0]);
      o[cp[1]] = cp[2](e ? e.value : '');
    });
    return o;
  }
  /* liga o autosave em TODOS os campos da lista — um caminho só */
  function crmLigaCampos(agendaFn){
    CX_CAMPOS.forEach(function(cp){
      var e=$(cp[0]); if(!e) return;
      e.addEventListener('input', agendaFn);
      e.addEventListener('change', agendaFn);   /* o <select> da origem */
    });
  }

  /* ---------------------------------------------------------------------
     🌡️ 5) A TEMPERATURA EM UM TOQUE (Parte 2 do projeto)
     --------------------------------------------------------------------- */
  /* COMO ERA: cada toque na célula AVANÇAVA um degrau e gravava na hora
     (`crmTempCiclo`). Pra pôr "frio" num cliente sem temperatura eram 3
     toques, 3 gravações e 3 repinturas da lista inteira — e no meio do
     caminho ele ficava marcado como QUENTE, à vista de quem estivesse
     olhando a tela junto. Medido: de 123 clientes, só 4 tinham
     temperatura. O giro é a explicação mais provável.

     ⚠️ A QUARTA OPÇÃO PRECISA EXISTIR. O Angelo pediu 3, e são 3 as
     temperaturas — mas sem "Sem temperatura" não há como DESMARCAR quem
     foi marcado por engano (hoje o giro é o único jeito). Ela entra por
     último, discreta, separada das três.

     ⚠️ MOLDE: o `crmEtapaPicker` (12, ~1018). Mesma `.cropmask`, mesma
     `.crm-pick`/`.crm-pi`, mesmo `.on`, fecha ao tocar fora. A etiqueta e
     a temperatura ficam LADO A LADO na mesma tabela: se abrirem diferente,
     a tela vira duas telas. Nada de segundo jeito de escolher. */

  /* 🔴 E O DESACERTO ANTIGO, RESOLVIDO JUNTO — DUAS FONTES DE VERDADE.
     A mesma informação vivia em dois lugares: o boolean `quente` (antigo,
     do botão 🔥 da ficha) e o `extra.temperatura` (v458, com três níveis).
     O `_crmTempDe` reconciliava NA LEITURA (por isso os 13 clientes com
     `quente=true` e sem jsonb apareciam certos). **A escrita não
     reconciliava**: o 🔥 da ficha mexia só no boolean, então um cliente
     "morno" virava fogo aceso na ficha e continuava morno na tabela —
     duas telas discordando sobre o mesmo cliente.
     Agora existe UMA função que escreve temperatura, e ela SEMPRE escreve
     os dois campos juntos. O 🔥 da ficha deixou de ser liga/desliga e abre
     este mesmo picker.
     ⚠️ NÃO apagar o boolean `quente`: ele é usado na unificação de
     duplicados, no cabeçalho da ficha e possivelmente em relatório. A
     regra é `quente = (temperatura === 'quente')`. */
  var CRM_TEMPS = [
    ['quente', 'Quente', '🔥🔥🔥🔥🔥'],
    ['morno',  'Morno',  '🔥🔥🔥'],
    ['frio',   'Frio',   '🧊']
  ];
  /* a ÚNICA função que escreve temperatura no banco */
  async function crmTempGravar(c, t){
    if(!c) return false;
    var ex=Object.assign({}, c.extra||{});
    if(t) ex.temperatura=t; else delete ex.temperatura;
    return await crmSalvaCampo(c.id, { extra:ex, quente:(t==='quente') });
  }
  function crmTempPicker(c){
    if(!c) return;
    var atual=_crmTempDe(c);
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:320px;max-height:82vh;overflow:auto">'+
      '<div class="crop-tit">Temperatura de '+esc(String(c.nome||'cliente').split(' ')[0])+'</div>'+
      '<div class="crm-pick">'+
        CRM_TEMPS.map(function(t){
          return '<button type="button" class="crm-pi crm-tp'+(atual===t[0]?' on':'')+'" data-tp="'+t[0]+'">'+
            '<span class="crm-tp-ic" aria-hidden="true">'+t[2]+'</span><span>'+esc(t[1])+'</span></button>';
        }).join('')+
        /* a quarta, separada das três — é a que DESMARCA */
        '<button type="button" class="crm-pi crm-tp-nada'+(atual?'':' on')+'" data-tp="">'+
          _cIco('<circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/>')+
          '<span>Sem temperatura</span></button>'+
      '</div>'+
      '<button type="button" class="link" id="ctpFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#ctpFechar').onclick=close;
    Array.prototype.forEach.call(ov.querySelectorAll('[data-tp]'), function(b){
      b.onclick=async function(){
        var t=b.getAttribute('data-tp')||'';
        close();
        /* ⚠️ UMA GRAVAÇÃO SÓ — e nenhuma se escolheu o que já estava.
           Era isso que o giro fazia de errado: 3 toques, 3 updates, 3
           repinturas da lista inteira. */
        if(t===atual) return;
        var ok=await crmTempGravar(c, t);
        if(ok && String(_crmSel)===String(c.id)){ try{ crmFichaAbrir(c.id); }catch(_){} }
      };
    });
  }

/* ╔═══ src/app/12h-clientes-repetidos.js ═════════════════════════════════ */
  /* ==========================================================================
     12h — VER OS CONTATOS REPETIDOS ANTES DE UNIFICAR (v517)
     (PROJETO-ver-os-contatos-duplicados)

     PEDIDO (Angelo, 16/08): "mostrar contato duplicado nos clientes."
     Veio junto do print do aviso cinza do Chrome que existia até aqui:
       "Achei 1 telefone repetido (1 cadastro a mais). Unificar? O cadastro
        mais antigo fica e recebe as anotações…"  [Cancelar] [OK]

     ⚠️ O PEDIDO É SIMPLES. O QUE A MEDIÇÃO MOSTROU, NÃO É. Fui conferir no
     banco antes de escrever e o botão errava OS DOIS LADOS.

     🔴 ACHADO 1 — ELE ENXERGAVA MENOS DA METADE.
       Medido em 16/08 (123 cadastros, 121 com telefone):
         regra antiga (número INTEIRO) → 2 grupos, 3 fichas a mais
         regra nova (8 ÚLTIMOS dígitos) → 4 grupos, 5 fichas a mais
       Telefone brasileiro chega escrito de quatro jeitos, e os grupos reais
       provam: um com 10 e 11 dígitos (**o nono dígito** — mesmo nome nos
       dois cadastros, criados em dias seguidos: é literalmente a mesma
       pessoa, e o botão não via), outro com 12 e 13 (DDI 55), dois com 11.
       🔑 E havia INCOERÊNCIA DENTRO DO PRÓPRIO APP: o atendente IA
       (atendente-whatsapp.js) já usava os 8 últimos antes de criar cliente.
       Duas definições de "é o mesmo telefone" no mesmo sistema — o robô
       considerava duplicado o que o botão considerava gente diferente.
       ⚠️ 8 é o número certo, não 9 nem o inteiro: o celular brasileiro tem
       8 dígitos de assinatura + o 9 na frente + DDD + DDI. Os 8 últimos são
       a única parte que não muda de formato.

     🔴 ACHADO 2 — E O QUE ELE ACHAVA PODIA NÃO SER DUPLICADO.
       O único grupo que a regra antiga via — o do print do Angelo — tem
       **3 fichas com o telefone igual e TRÊS NOMES DIFERENTES**, criadas no
       mesmo dia. Isso não é cadastro repetido: é o telefone de uma loja, de
       uma casa, ou o WhatsApp de marido e mulher.
       **Se ele tivesse clicado em OK, o app teria fundido três pessoas numa
       ficha só e APAGADO duas.** Sem mostrar nada antes, sem desfazer
       depois. É AQUI que mora o pedido: "mostrar" não é conforto, é a
       diferença entre unificar e destruir cadastro.
       → Telefone igual é PISTA, não prova. Nome diferente = o cartão nasce
         SEM o botão de unificar.

     🔴 ACHADO 3 — O `confirm` APROVAVA UMA OPERAÇÃO QUE APAGA.
       A unificação move consultas e documentos (passo 4) e só DEPOIS apaga
       a ficha (passo 5). Se o delete falha no meio, o histórico já foi
       embora e sobra um cadastro vazio que ninguém entende. E o delete
       conferia `error`, que **não é a mesma coisa que zero linhas** (regra 6
       do CLAUDE.md): com a RLS barrando, o app contava "unificado ✓" e a
       ficha continuava lá, agora sem consultas e sem documentos.
       → A ORDEM INVERTEU: apaga primeiro (com `.select('id')`), e só move o
         histórico depois que o banco confirmou. E é UM GRUPO POR VEZ.

     ⚠️ ONDE ESTE ARQUIVO VIVE: dentro do IIFE (01 → 19), depois do 12.
     ⚠️ O NOME É `12h` DE PROPÓSITO: o projeto do salvamento automático
     (v516) já ocupou o `12g`. Dois módulos com o mesmo prefixo seriam dois
     arquivos disputando a mesma vaga na ordem alfabética.
     ========================================================================= */

  /* ---------------------------------------------------------------------
     1) A CHAVE — a mesma do atendente IA
     --------------------------------------------------------------------- */
  function crmFoneChave(t){
    var d=String(t||'').replace(/\D/g,'');
    return d.length>=8 ? d.slice(-8) : '';
  }
  /* nomes iguais? compara sem acento, sem maiúscula e sem espaço sobrando */
  function crmNomeChave(s){
    return String(s||'').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g,'').replace(/\s+/g,' ').trim();
  }

  /* os que o Angelo já disse que NÃO são a mesma pessoa */
  var _crmNaoDup = {}, _crmNaoDupLido = false;
  async function crmNaoDupCarregar(){
    _crmNaoDup={};
    try{
      var r=await supa.from('cliente_nao_duplicado').select('chave_fone').limit(500);
      ((r&&r.data)||[]).forEach(function(x){ _crmNaoDup[x.chave_fone]=1; });
      _crmNaoDupLido=true;
    }catch(_){ _crmNaoDupLido=false; }
  }
  async function crmNaoDupMarcar(chave){
    try{
      var r=await supa.from('cliente_nao_duplicado').insert({ user_id:meuId, chave_fone:chave });
      if(r&&r.error && String(r.error.code||'')!=='23505') throw r.error;   /* já marcado = ok */
      _crmNaoDup[chave]=1; return true;
    }catch(e){ toast('Não consegui marcar. '+((e&&e.message)||'')); return false; }
  }

  /* ---------------------------------------------------------------------
     2) OS GRUPOS
     --------------------------------------------------------------------- */
  /* Devolve [{ chave, fone, fichas:[...], nomesIguais:bool }], do maior pro
     menor. `fichas` já vem em ordem de cadastro: o PRIMEIRO é o que fica. */
  function crmRepetidosGrupos(){
    var g={};
    (_clientes||[]).forEach(function(c){
      var k=crmFoneChave(c.telefone); if(!k) return;
      (g[k]=g[k]||[]).push(c);
    });
    return Object.keys(g).filter(function(k){
      return g[k].length>1 && !_crmNaoDup[k];
    }).map(function(k){
      var fichas=g[k].slice().sort(function(a,b){
        return (Date.parse(a.criado_em||0)||0)-(Date.parse(b.criado_em||0)||0);
      });
      var n0=crmNomeChave(fichas[0].nome);
      return { chave:k, fone:fichas[0].telefone||'', fichas:fichas,
               nomesIguais: fichas.every(function(x){ return crmNomeChave(x.nome)===n0; }) };
    }).sort(function(a,b){ return b.fichas.length-a.fichas.length; });
  }
  /* quantos cadastros "a mais" existem — é o número do botão */
  function crmRepetidosExtras(){
    return crmRepetidosGrupos().reduce(function(s,x){ return s+x.fichas.length-1; },0);
  }
  /* de quais grupos esta ficha participa (pra etiqueta na lista) */
  function crmRepetidoDe(c){
    var k=crmFoneChave(c&&c.telefone); if(!k || _crmNaoDup[k]) return '';
    var n=(_clientes||[]).filter(function(x){ return crmFoneChave(x.telefone)===k; }).length;
    return n>1 ? k : '';
  }

  /* ---------------------------------------------------------------------
     3) A TELA — um cartão por grupo. É o que o Angelo pediu.
     --------------------------------------------------------------------- */
  /* ⚠️ NADA de `confirm` do navegador em caminho nenhum. O print que abriu
     este assunto mostra o diálogo cinza do Chrome, com a cara do navegador
     e não a do app — e ele mostrava um NÚMERO, não os nomes. */
  async function crmRepetidosAbrir(chaveFoco){
    if(!_crmNaoDupLido) await crmNaoDupCarregar();
    var grupos=crmRepetidosGrupos();
    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='crpMask';
    ov.innerHTML='<div class="cropbox crp-box"><div class="crop-tit">Contatos repetidos ('+grupos.length+')</div>'+
      '<div class="crp-lista" id="crpLista"></div>'+
      '<button type="button" class="link" id="crpFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    ov.onclick=function(e){ if(e.target===ov) crmRepetidosFechar(); };
    ov.querySelector('#crpFechar').onclick=crmRepetidosFechar;
    crmRepetidosPinta(chaveFoco);
  }
  function crmRepetidosFechar(){ var o=$('crpMask'); if(o){ try{ o.remove(); }catch(_){} } }

  function crmRepetidosPinta(chaveFoco){
    var el=$('crpLista'); if(!el) return;
    var grupos=crmRepetidosGrupos();
    if(chaveFoco) grupos=grupos.filter(function(g){ return g.chave===chaveFoco; });
    if(!grupos.length){
      el.innerHTML='<div class="cli-empty" style="padding:16px"><b>Nenhum contato repetido</b>Está tudo limpo por aqui.</div>';
      var t=document.querySelector('#crpMask .crop-tit'); if(t) t.textContent='Contatos repetidos (0)';
      return;
    }
    el.innerHTML=grupos.map(function(g){
      var fichas=g.fichas.map(function(c,i){
        var an=(Array.isArray(c.anotacoes)?c.anotacoes.length:0);
        var quando=''; try{ quando=histData(Date.parse(c.criado_em||'')||0)||''; }catch(_){}
        return '<div class="crp-f'+(i===0?' fica':'')+'">'+
          '<span class="crp-dot" aria-hidden="true">'+(i===0?'●':'○')+'</span>'+
          '<span class="crp-ftx"><b>'+esc(c.nome||'(sem nome)')+'</b>'+
            '<i>'+esc(_crmFoneFmt(c.telefone))+(quando?(' · '+esc(quando)):'')+
            ' · '+an+' anotaç'+(an===1?'ão':'ões')+'</i></span>'+
          '<span class="crp-fq">'+(i===0?'fica':'entra no de cima')+'</span>'+
        '</div>';
      }).join('');
      return '<div class="crp-g" data-crp="'+esc(g.chave)+'">'+
        '<div class="crp-hd"><b>'+esc(_crmFoneFmt(g.fone))+'</b><span>'+g.fichas.length+' fichas</span></div>'+
        fichas+
        /* 🔴 nomes diferentes → nada de botão verde. Telefone igual é pista. */
        (g.nomesIguais ? '' :
          '<div class="crp-avisa">Os nomes são diferentes — pode ser o telefone de uma loja ou de uma casa.</div>')+
        '<div class="crp-acts">'+
          '<button type="button" class="crp-b'+(g.nomesIguais?' ok':'')+'" data-crp-uni="'+esc(g.chave)+'">Unificar este</button>'+
          '<button type="button" class="crp-b no" data-crp-nao="'+esc(g.chave)+'">Não é o mesmo</button>'+
        '</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('[data-crp-uni]'),function(b){
      b.onclick=function(){ crmUnificarGrupo(b.getAttribute('data-crp-uni'), b); };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-crp-nao]'),function(b){
      b.onclick=async function(){
        b.disabled=true;
        if(await crmNaoDupMarcar(b.getAttribute('data-crp-nao'))){
          crmRepetidosPinta(chaveFoco);
          try{ crmDupsBadge(); crmPintaLista((($('cliBusca')||{}).value)||''); }catch(_){}
        } else b.disabled=false;
      };
    });
  }

  /* ---------------------------------------------------------------------
     4) UNIFICAR — UM GRUPO, NA ORDEM CERTA
     --------------------------------------------------------------------- */
  /* ⚠️ A ORDEM INVERTEU EM RELAÇÃO À v458, e isso é o conserto do Achado 3:
       1. junta os campos vazios, as anotações e o histórico NO QUE FICA;
       2. APAGA a ficha que sai — com `.select('id')`, conferindo a linha;
       3. só DEPOIS move consultas e documentos pro que ficou.
     Antes era 3 → 2. Se o delete falhasse (RLS), o histórico já tinha ido
     embora e sobrava uma ficha órfã: sem consultas, sem documentos, e viva.
     Agora, se o delete não pegar, NADA foi movido e a tela diz a verdade. */
  var CRP_CAMPOS=['nome','email','cpf','cep','rua','numero','bairro','complemento','cidade','uf',
    'rg','nascimento','nome_mae','etapa','origem','interesse','faixa_preco','faixa_parcela',
    'placa_troca','veiculo_troca','ano_troca','fipe_troca','avaliacao_troca','avaliado_por','obs'];

  /* ⚠️ v521 — A FUSÃO EM SI MUDOU DE CASA. O miolo (juntar campos, apagar
     conferindo, mover consultas/documentos/VENDAS) virou a `clienteFundir`
     do **12i**, porque o "Juntar em outro" das compras sem ficha precisa
     exatamente do mesmo, só que com o destino escolhido a dedo em vez de
     descoberto pela data. Duas implementações parecidas de "juntar
     cadastro" é como o buraco das vendas não movidas nasceu.
     O que fica AQUI é só a regra deste caminho: **o mais antigo fica.** */
  async function crmUnificarGrupo(chave, btn){
    var g=crmRepetidosGrupos().filter(function(x){ return x.chave===chave; })[0];
    if(!g){ toast('Este grupo já não existe.'); return; }
    if(btn){ btn.disabled=true; btn.textContent='Unificando…'; }
    var fica=g.fichas[0], sai=g.fichas.slice(1);

    var r=await clienteFundir(sai, fica,
      'Cadastros unificados: '+g.fichas.length+' com o telefone '+_crmFoneFmt(fica.telefone||''));

    try{ await cliCarregar(); }catch(_){}
    try{ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); crmDupsBadge(); }catch(_){}
    crmRepetidosPinta();
    if(!r.ok){
      toast('Não consegui unificar — '+(r.erro||'erro')+'. Nada foi movido dessa ficha.');
      if(btn){ btn.disabled=false; btn.textContent='Unificar este'; }
      return;
    }
    toast(r.apagados+' cadastro'+(r.apagados===1?'':'s')+' unificado'+(r.apagados===1?'':'s')+' ✓');
  }

  /* ---------------------------------------------------------------------
     5) "Já existe um cliente com esse nome?" — o que MATA a duplicata
     --------------------------------------------------------------------- */
  /* PEDIDO (Angelo, 16/08): "quando for adicionar um carro a um novo
     cliente, ao ir digitando o nome vai filtrando os já cadastrados."
     O PROBLEMA REAL: hoje dá pra cadastrar "Alemao" três vezes, e cliente
     duplicado quebra o histórico do carro, o funil e a carteira do vendedor.
     Consertar depois (seção 4) é caro; não deixar nascer é barato.
     🔑 Os clientes JÁ estão na memória (`_clientes`, carregado pelo
     vincularClienteAbrir) — filtrar é local, sem ida ao banco, sem espera.
     ⚠️ UMA FUNÇÃO SÓ: o formulário grande do CRM e a importação em lote
     podem usar esta mesma peça depois. Não escrever a comparação de novo. */
  function cliParecidos(nome, limite){
    var q=crmNomeChave(nome);
    if(q.length<2) return [];                       /* 1 letra acha meio mundo */
    return (_clientes||[]).filter(function(c){
      return crmNomeChave(c.nome).indexOf(q)>=0;    /* por PEDAÇO: "alem" acha "Alemão" */
    }).slice(0, limite||4);
  }
  function cliNomeIgual(nome){
    var q=crmNomeChave(nome); if(!q) return null;
    return (_clientes||[]).filter(function(c){ return crmNomeChave(c.nome)===q; })[0] || null;
  }

/* ╔═══ src/app/12i-cliente-fusao.js ══════════════════════════════════════ */
  /* ==========================================================================
     12i — JUNTAR CADASTROS COM O DESTINO ESCOLHIDO A DEDO (v521)
     (PROJETO-unificar-ou-excluir-nas-compras-sem-ficha)

     PEDIDO (Angelo, na tela "Registrar venda antiga"): "permita adicionar
     um cadastro a outro (unificar) ou excluir — esses já são da página
     Clientes que foram marcados como comprou."

     🔴 O QUE A MEDIÇÃO MOSTROU, E QUE MUDA O QUE PRECISA SER FEITO:
     os órfãos (marcados como comprou, sem venda lançada) **não têm NENHUM
     grupo de telefone repetido entre si** — medido: zero. E TRÊS deles têm
     nome de EMPRESA (LTDA / SOCIEDADE / ADVOCACIA), vindos da consulta de
     CNPJ que vira cliente (v355): a ficha da EMPRESA e a da PESSOA são
     duas, com nomes diferentes e às vezes telefones diferentes.
     ➜ Ou seja: **o que ele pediu NÃO é o unificar que já existe.** Aquele
     (v517, 12h) acha grupos pelo telefone. Juntar "EDERSON REIS SOCIEDADE
     INDIVIDUAL DE ADVOCACIA" com "PAULO GENRO EDERSON" é decisão HUMANA —
     nenhuma regra automática toma. É unificação MANUAL, com o destino
     apontado a dedo. Outra porta da mesma máquina.

     🔑 **UMA FUNÇÃO DE FUSÃO SÓ, NOS DOIS LUGARES.** O `crmUnificarGrupo`
     (12h, por telefone) e o "Juntar em outro" daqui chamam a MESMA
     `clienteFundir`. Duas implementações parecidas de "juntar cadastro" é
     exatamente como o buraco das vendas não movidas nasceu.

     ⚠️ O NOME É `12i` porque `12g` (salvamento, v516) e `12h` (repetidos,
     v517) já estão ocupados. Terceira spec seguida a pedir o `12g` —
     conferir `ls src/app` antes de batizar módulo.
     ========================================================================= */

  /* os 25 campos que o destino herda quando estiverem vazios nele */
  var CFU_CAMPOS=['nome','email','cpf','cep','rua','numero','bairro','complemento','cidade','uf',
    'rg','nascimento','nome_mae','etapa','origem','interesse','faixa_preco','faixa_parcela',
    'placa_troca','veiculo_troca','ano_troca','fipe_troca','avaliacao_troca','avaliado_por','obs'];

  /* ---------------------------------------------------------------------
     A FUSÃO — sai[] entra em fica. QUEM FICA É QUEM CHAMA QUE DECIDE.
     ---------------------------------------------------------------------
     ⚠️ O unificar da v458 decidia sozinho ("o mais antigo fica"). Aqui é o
     contrário do pedido: "adicionar um cadastro a OUTRO" quer dizer que
     VOCÊ aponta o destino. Por isso a função RECEBE os dois lados.

     🔴 A ORDEM É: juntar os campos → APAGAR (conferindo a linha) → só
     então mover consultas, documentos e VENDAS. Nunca o contrário. Se o
     delete falhar (RLS), nada foi movido e sobra tudo como estava — em vez
     de uma ficha viva e vazia, sem histórico, que ninguém entende.
     🔴 E move `vendas.cliente_id`: sem isso a venda fica órfã, presa a um
     cadastro que acabou de sumir. (Já existem 6 vendas sem cliente
     vinculado no banco — não faltam candidatas.) */
  async function clienteFundir(sai, fica, rotulo){
    sai=(sai||[]).filter(function(x){ return x && String(x.id)!==String(fica&&fica.id); });
    if(!fica || !fica.id || !sai.length) return { ok:false, apagados:0, erro:'nada a juntar' };

    var upd={};
    CFU_CAMPOS.forEach(function(k){
      if(fica[k]==null||fica[k]===''){
        for(var i=0;i<sai.length;i++){ if(sai[i][k]!=null&&sai[i][k]!==''){ upd[k]=sai[i][k]; break; } }
      }
    });
    /* ⚠️ o NOME é campo como os outros: só entra se o destino estiver sem.
       Quem escolheu o destino escolheu o nome que sobrevive — a tela avisa
       isso antes de confirmar. */
    if(!fica.quente && sai.some(function(x){ return x.quente; })) upd.quente=true;
    if(!fica.agendado_em){ var ag=sai.map(function(x){ return x.agendado_em; }).filter(Boolean)[0]; if(ag) upd.agendado_em=ag; }
    var an=Array.isArray(fica.anotacoes)?fica.anotacoes.slice():[];
    sai.forEach(function(x){ if(Array.isArray(x.anotacoes)) an=an.concat(x.anotacoes); });
    var hi=Array.isArray(fica.historico)?fica.historico.slice():[];
    sai.forEach(function(x){ if(Array.isArray(x.historico)) hi=hi.concat(x.historico); });
    an.unshift({ t:(rotulo||('Cadastros unificados: '+(sai.length+1))), ts:new Date().toISOString() });
    upd.anotacoes=an; if(hi.length) upd.historico=hi;

    var r1=await _crmGravaConfere('clientes', Object.assign({},upd,{atualizado_em:new Date().toISOString()}), fica.id);
    if(!r1.ok) return { ok:false, apagados:0,
      erro:(r1.erro==='rls' ? 'este cliente não é da sua carteira' : (r1.erro||'erro')) };

    var apagados=0, parou='';
    for(var i=0;i<sai.length;i++){
      var d=sai[i], linhas=0, err='';
      try{
        var rd=await supa.from('clientes').delete().eq('id',d.id).select('id');
        if(rd&&rd.error) err=rd.error.message||'erro';
        else linhas=(rd&&rd.data&&rd.data.length)||0;
      }catch(e){ err=String((e&&e.message)||e); }
      if(!linhas){ parou = err || 'rls'; break; }
      apagados++;
      try{ await supa.from('cliente_consulta').update({cliente_id:fica.id}).eq('cliente_id',d.id); }catch(_){}
      try{ await supa.from('cliente_documento').update({cliente_id:fica.id}).eq('cliente_id',d.id); }catch(_){}
      try{ await supa.from('vendas').update({cliente_id:fica.id}).eq('cliente_id',d.id); }catch(_){}
    }
    return { ok:!parou, apagados:apagados,
      erro: parou==='rls' ? 'não consegui apagar — a ficha não é da sua carteira' : parou };
  }

  /* ---------------------------------------------------------------------
     O SELETOR DE DESTINO — com busca, não um <select> cru
     ---------------------------------------------------------------------
     ⚠️ O combo simples NÃO serve: são 107 fichas e nomes de empresa
     compridos; o `<select>` do pvNovaAbrir já corta o nome na largura da
     caixa ("…ADVOCA" no print do Angelo). E precisa mostrar TELEFONE junto
     do nome, que é o que deixa reconhecer a ficha sem abrir. */
  function clienteEscolherDestino(sai, onPick){
    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='cfuMask';
    ov.innerHTML='<div class="cropbox cfu-box">'+
      '<div class="crop-tit">Juntar em qual ficha?</div>'+
      '<div class="cfu-sai">Sai: <b>'+esc(sai.nome||'(sem nome)')+'</b></div>'+
      '<div class="cli-search busca-lupa">'+_icoBusca+'<input type="search" class="cad-in" id="cfuBusca" aria-label="Buscar por nome ou telefone" placeholder="Buscar por nome ou telefone" autocomplete="off"></div>'+
      '<div class="cfu-lista" id="cfuLista"></div>'+
      '<div class="cfu-aviso" id="cfuAviso"></div>'+
      '<button type="button" class="link" id="cfuNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    ov.querySelector('#cfuNao').onclick=close;

    function pinta(){
      var el=$('cfuLista'); if(!el) return;
      var q=String((($('cfuBusca')||{}).value)||'').toLowerCase().trim();
      var qd=q.replace(/\D/g,'');
      var lista=(_clientes||[]).filter(function(c){
        if(String(c.id)===String(sai.id)) return false;          /* não em si mesmo */
        if(!q) return true;
        if(String(c.nome||'').toLowerCase().indexOf(q)>=0) return true;
        return !!qd && String(c.telefone||'').replace(/\D/g,'').indexOf(qd)>=0;
      }).slice(0,30);
      if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:12px">Nada com esse termo.</div>'; return; }
      el.innerHTML=lista.map(function(c){
        return '<button type="button" class="cfu-it" data-cfu="'+esc(c.id)+'">'+
          '<span class="cfu-tx"><b>'+esc(c.nome||'(sem nome)')+'</b>'+
          '<i>'+esc(c.telefone?_crmFoneFmt(c.telefone):'sem telefone')+'</i></span></button>';
      }).join('');
      Array.prototype.forEach.call(el.querySelectorAll('[data-cfu]'),function(b){
        b.onclick=function(){
          var fica=(_clientes||[]).filter(function(x){ return String(x.id)===String(b.getAttribute('data-cfu')); })[0];
          if(!fica) return;
          /* ⚠️ A TELA DIZ QUAL NOME SOBREVIVE, ANTES de confirmar. No caso
             do print o destino provavelmente é a PESSOA e o que sai é a
             EMPRESA — mas pode ser o contrário, e juntar na direção errada
             perde o cadastro certo. */
          var av=$('cfuAviso');
          if(av) av.innerHTML='<div class="cfu-conf"><b>'+esc(sai.nome||'')+'</b> entra em <b>'+esc(fica.nome||'')+'</b>.'+
            '<span>O nome que fica é <b>'+esc(fica.nome||'')+'</b>. As anotações, consultas, documentos e vendas dos dois vão junto.</span>'+
            '<button type="button" class="crp-b ok" id="cfuOk">Juntar</button></div>';
          var bo=$('cfuOk'); if(bo) bo.onclick=function(){ bo.disabled=true; bo.textContent='Juntando…'; close(); onPick(fica); };
        };
      });
    }
    var bq=$('cfuBusca'); if(bq) bq.oninput=pinta;
    pinta();
  }

  /* ---------------------------------------------------------------------
     APAGAR — dizendo o que vai junto
     ---------------------------------------------------------------------
     ⚠️ Nada de "tem certeza?" genérico: o aviso LISTA o que existe naquela
     ficha. E a mesma checagem do `.select('id')` — se a RLS barrar, a tela
     precisa dizer que NÃO apagou. Hoje ela diria que apagou. */
  async function clienteApagarDetalhado(c){
    if(!c || !c.id) return { ok:false, erro:'sem ficha' };
    var an=(Array.isArray(c.anotacoes)?c.anotacoes.length:0);
    var cons=0, docs=0;
    try{ var rc=await supa.from('cliente_consulta').select('id').eq('cliente_id',c.id).limit(200); cons=((rc&&rc.data)||[]).length; }catch(_){}
    try{ var rd2=await supa.from('cliente_documento').select('id').eq('cliente_id',c.id).limit(200); docs=((rd2&&rd2.data)||[]).length; }catch(_){}
    var vai=[]; if(an) vai.push(an+' anotaç'+(an===1?'ão':'ões'));
    if(cons) vai.push(cons+' consulta'+(cons===1?'':'s'));
    if(docs) vai.push(docs+' documento'+(docs===1?'':'s'));
    var txt='Apagar "'+(c.nome||'esta ficha')+'"?'+
      (vai.length?('\n\nVai junto: '+vai.join(', ')+'.'):'\n\nEsta ficha não tem anotação, consulta nem documento.')+
      '\n\nNão dá pra desfazer.';
    if(!confirm(txt)) return { ok:false, erro:'cancelado', cancelado:true };
    try{
      var r=await supa.from('clientes').delete().eq('id',c.id).select('id');
      if(r&&r.error) return { ok:false, erro:r.error.message||'erro' };
      if(!(r&&r.data&&r.data.length)) return { ok:false, erro:'rls' };
      return { ok:true };
    }catch(e){ return { ok:false, erro:String((e&&e.message)||e) }; }
  }

/* ╔═══ src/app/12j-atendente-e-chat.js ═══════════════════════════════════ */
  /* ==========================================================================
     12j — A COLUNA DO ATENDENTE E O CHAT NA LINHA (v522)
     (PROJETO-coluna-do-atendente-e-chat-na-linha)

     DOIS PEDIDOS do Angelo, na MESMA linha da MESMA tabela — por isso um
     módulo só. Separar seria garantir colisão.
       1. "adicione uma coluna pro dono da loja ver quem está atendendo e,
           se desejar, transferir o atendimento";
       2. "adicione um ícone ao lado do visualizar pra iniciar o chat — ao
           clicar, o FAB do chat já abre na conversa com o cliente".

     📏 O QUE FOI MEDIDO, E QUE MUDA O DESENHO DA TELA (16/08):
         95 clientes → Angelo Ferrari   · dono      ✅ tem nome
         11 clientes → outro user_id    · 🔴 NÃO é membro de loja nenhuma
          1 cliente  → outro user_id    · 🔴 idem
         e a loja tem 2 membros (1 dono + 1 vendedor).

     🔴 **12 fichas pertencem a gente que não está em `mp_loja_membros`** —
     11% da base, e justamente o grupo que mais precisa ser transferido.
     Do jeito ingênuo, a coluna mostraria vazio (parece defeito da tela) ou
     um UUID cru. **O estado "sem equipe" tem que ser DITO, não escondido:**
     a célula mostra "Fora da equipe" em cinza, e é ela que mais convida ao
     clique de transferir.
     ➜ Ordem de exibição, do melhor pro pior: nome → email → "Fora da
       equipe". **Nunca o UUID.**

     ⚠️ ESCONDER A COLUNA DO VENDEDOR NÃO É SEGURANÇA, É ARRUMAÇÃO. A
     segurança está na RLS: com a carteira do vendedor (v484,
     mp_app_minha_carteira) ele **nem recebe do banco** os clientes dos
     outros — pra ele a coluna mostraria o próprio nome em todas as linhas,
     que é inútil. Por isso ela só entra pro dono.
     ========================================================================= */

  /* ---------------------------------------------------------------------
     1) O MAPA user_id → nome, carregado UMA vez
     --------------------------------------------------------------------- */
  /* ⚠️ O `cliPassarAbrir` já fazia exatamente esta consulta, toda vez que
     abria. Agora ela é feita uma vez e guardada — a coluna pinta em toda
     linha da tabela, e consultar por linha seria absurdo. */
  var _atMembros=[], _atMapa={}, _atLido=false, _atPedido=false;
  async function atMembrosCarregar(forcar){
    if(_atLido && !forcar) return _atMembros;
    var tinhaLoja=false;
    _atMembros=[]; _atMapa={};
    try{
      /* 🐞 v530 — O BUG QUE FEZ A COLUNA DIZER "FORA DA EQUIPE" NA LOJA INTEIRA
         (relatado pelo Angelo em 16/08: "tava aparecendo meu nome como
          atendente… agora não tá igual")

         O `_lojaRec` NÃO é carregado na abertura do app. Quem o preenche é a
         página **Minha Loja** (16, linha 199), o estoque (14) ou o `lojaGet`
         (19). Quem abre o app e vai DIRETO pros Leads chega aqui com
         `_lojaRec` nulo — e a v522 simplesmente desistia, esperando "a
         próxima pintura". Só que nada força uma próxima pintura: o mapa
         ficava vazio e **as 95 fichas do Angelo apareciam como "Fora da
         equipe"**, junto com as 12 que são de verdade.

         Por isso funcionava às vezes: bastava ter passado pela Minha Loja
         antes, na mesma sessão.

         ⚠️ O conserto NÃO é uma consulta nova — é chamar o `lojaGet()`, que
         existe desde sempre pra exatamente isto e já guarda o resultado no
         `_lojaRec` pra todo mundo. */
      if(!(_lojaRec && _lojaRec.id) && typeof lojaGet==='function'){
        try{ await lojaGet(); }catch(_){}
      }
      if(_lojaRec && _lojaRec.id){
        tinhaLoja=true;
        var r=await supa.from('loja_membros').select('user_id,nome,email,papel').eq('loja_id',_lojaRec.id);
        _atMembros=((r&&r.data)||[]).filter(function(m){ return m && m.user_id; });
      }
    }catch(_){ _atMembros=[]; }
    _atMembros.forEach(function(m){ _atMapa[String(m.user_id)]=m; });
    /* 🔴 só considera LIDO se a loja já existia. Sem esta linha, uma pintura
       que acontecesse ANTES do _lojaRec chegar congelaria o mapa vazio, e a
       coluna diria "Fora da equipe" na loja inteira — para sempre. */
    if(tinhaLoja) _atLido=true;
    return _atMembros;
  }
  function atMembrosProntos(){ return _atLido; }
  /* ======================================================================
     🐞🐞 v531 — O LOOP INFINITO QUE A v530 CRIOU SEM QUERER
     (pego pela regressão, no teste-v496; não por print nem por uso)

     A v530 consertou o "Fora da equipe" tirando o `if(!_lojaRec) return`
     daqui. O conserto estava certo — mas abriu um buraco que o `return`
     tapava por acidente. Veja o vai-e-vem da v530:

         atMembrosGarante(repinta)
           if(_atLido || _atPedido) return;   ← os dois estão FALSE
           _atPedido = true;
           atMembrosCarregar()                ← SEM loja: `_atLido` fica FALSE
             .then(() => { _atPedido = false;  ← destrancou ANTES de repintar
                           repinta(); })       ← a repintura chama o garante…
                                               …e volta ao topo com as duas
                                                  travas abertas. PRA SEMPRE.

     🔴 O comentário da v530 dizia "`_atPedido` impede o vai-e-vem infinito".
     Não impedia: ele era zerado ANTES do `repinta()`, então na volta já
     estava aberto de novo.

     🔴 QUANDO ISSO ACONTECE DE VERDADE (não é caso de laboratório):
       · usuário SEM loja cadastrada — o vendedor que ainda não foi
         convidado, ou a conta nova antes de criar a loja;
       · loja que existe mas a consulta FALHA — sem internet no pátio, ou
         a RLS barrando. `_lojaRec` continua nulo do mesmo jeito.
     Em qualquer um dos dois, abrir os Leads passava a girar consulta atrás
     de consulta até o navegador travar. No aparelho do Angelo não aparece
     porque ele TEM loja: `tinhaLoja` vira true e o `_atLido` fecha a porta.

     ⚠️ POR QUE NÃO BASTA ZERAR `_atPedido` DEPOIS DO `repinta()`: resolveria
     esta volta, mas a PRÓXIMA repintura (a busca, um filtro, o relógio de
     8s) cairia aqui de novo com tudo aberto. O que falta é memória de "já
     tentei", e é isso que o `_atTentou` é.

     ⚠️ E POR QUE NÃO `_atLido = true` NA FALHA: `_atLido` quer dizer "o mapa
     de nomes é bom". Marcá-lo na falha faria o `atMembrosProntos()` mentir
     pro resto do app. São duas perguntas diferentes:
         _atLido  → "tenho os nomes?"
         _atTentou → "já fui buscar?"
     ⛳ Quem PRECISA de nova tentativa (trocou de loja, entrou na equipe)
     chama `atMembrosCarregar(true)`, que ignora as duas travas — é o mesmo
     caminho que o teste da v530 usa.
     ====================================================================== */
  var _atTentou=false;
  function atMembrosGarante(repinta){
    if(_atLido || _atPedido || _atTentou) return;
    /* 🐞 v530: SAIU o `if(!_lojaRec) return`. Era ele que travava tudo quando
       se entrava direto nos Leads — o `atMembrosCarregar` agora busca a loja
       sozinho, então não há mais motivo pra desistir aqui. */
    _atPedido=true; _atTentou=true;   /* 🔴 v531: a trava é marcada JÁ, não no fim */
    atMembrosCarregar().then(function(){ _atPedido=false; try{ if(typeof repinta==='function') repinta(); }catch(_){} },
                             function(){ _atPedido=false; });
  }
  /* 🔴 nunca devolve UUID. "Fora da equipe" é informação, não erro. */
  function atNomeDe(userId){
    var m=_atMapa[String(userId||'')];
    if(!m) return 'Fora da equipe';
    return String(m.nome || m.email || 'Sem nome');
  }
  function atForaDaEquipe(userId){ return !_atMapa[String(userId||'')]; }

  /* ---------------------------------------------------------------------
     2) TRANSFERIR — o seletor no lugar do prompt
     ---------------------------------------------------------------------
     COMO ERA: um `prompt` do navegador com lista NUMERADA, seguido de um
     `confirm`. Dois diálogos cinza do Chrome, com a cara do navegador e não
     a do app, e a pessoa tendo que DIGITAR UM NÚMERO pra escolher alguém —
     num app que já tem seletor pronto.

     ⚠️ O passo de confirmação NÃO some: transferir tira o cliente da lista
     de alguém. Mas ele vira o TEXTO DO PRÓPRIO CARTÃO — escolher o destino
     já mostra "sai da lista de X e entra na de Y", e o botão confirma.
     **Um passo, não dois.**

     ⚠️ O `.select('id')` do update NÃO PODE SE PERDER nesta troca: ele é o
     único lugar do 12 que sempre fez certo, e é o modelo do resto. */
  function atTransferirAbrir(c, depois){
    if(!c) return;
    atMembrosCarregar().then(function(membros){
      var alvos=membros.filter(function(m){ return String(m.user_id)!==String(c.user_id); });
      if(!alvos.length){ toast('Sua equipe ainda não tem outro vendedor pra receber.'); return; }
      var de=atNomeDe(c.user_id);
      var ov=document.createElement('div'); ov.className='cropmask'; ov.id='atMask';
      ov.innerHTML='<div class="cropbox at-box">'+
        '<div class="crop-tit">Quem vai atender '+esc(String(c.nome||'este cliente').split(' ')[0])+'?</div>'+
        '<div class="crm-pick">'+alvos.map(function(m){
          return '<button type="button" class="crm-pi at-pi" data-at="'+esc(m.user_id)+'">'+
            '<span class="at-tx"><b>'+esc(m.nome||m.email||'Vendedor')+'</b>'+
            (m.papel?('<i>'+esc(m.papel)+'</i>'):'')+'</span></button>';
        }).join('')+'</div>'+
        '<div class="at-conf" id="atConf"></div>'+
        '<button type="button" class="link" id="atNao" style="margin-top:8px;width:100%">Cancelar</button></div>';
      document.body.appendChild(ov);
      function close(){ try{ ov.remove(); }catch(_){} }
      ov.onclick=function(e){ if(e.target===ov) close(); };
      ov.querySelector('#atNao').onclick=close;
      Array.prototype.forEach.call(ov.querySelectorAll('[data-at]'),function(b){
        b.onclick=function(){
          var alvo=alvos.filter(function(m){ return String(m.user_id)===String(b.getAttribute('data-at')); })[0];
          if(!alvo) return;
          Array.prototype.forEach.call(ov.querySelectorAll('.at-pi'),function(x){ x.classList.toggle('on', x===b); });
          var cf=$('atConf');
          if(cf) cf.innerHTML='<div class="at-cf"><b>'+esc(c.nome||'O cliente')+'</b> sai da lista de <b>'+esc(de)+
            '</b> e entra na de <b>'+esc(alvo.nome||alvo.email||'')+'</b>.'+
            '<button type="button" class="crp-b ok" id="atOk">Passar</button></div>';
          var bo=$('atOk'); if(bo) bo.onclick=async function(){
            bo.disabled=true; bo.textContent='Passando…';
            var r=await atTransferir(c, alvo);
            close();
            toast(r.ok ? ('Cliente passado pra '+(alvo.nome||alvo.email)+' ✓')
                       : (r.erro||'Não consegui passar o cliente.'));
            if(r.ok){
              /* quem chamou da FICHA precisa fechar o modal — a ficha aberta
                 mostra um cliente que não é mais desta carteira */
              if(typeof depois==='function'){ try{ depois(); }catch(_){} }
              try{ await cliCarregar(); }catch(_){}
              try{ crmPintaEtapas(); crmPintaLista((($('cliBusca')||{}).value)||''); }catch(_){}
              try{ if(typeof cliPinta==='function') cliPinta((($('cliBusca')||{}).value)||''); }catch(_){}
            }
          };
        };
      });
    });
  }
  async function atTransferir(c, alvo){
    try{
      /* 🔴 regra 6 do CLAUDE.md: pedir a linha de volta. RLS recusada devolve
         SUCESSO com zero linhas — e aqui isso significaria dizer "passei" e
         o cliente continuar na lista de quem estava. */
      var r=await supa.from('clientes').update({ user_id:alvo.user_id, atualizado_em:new Date().toISOString() })
        .eq('id', c.id).select('id');
      if(r&&r.error) throw r.error;
      if(!(r&&r.data&&r.data.length)) return { ok:false, erro:'Só o dono da loja pode passar clientes.' };
      /* as consultas vinculadas acompanham o cliente (fire-and-forget) */
      try{ supa.from('cliente_consulta').update({user_id:alvo.user_id}).eq('cliente_id',c.id).select('id').then(function(){},function(){}); }catch(_){}
      return { ok:true };
    }catch(e){ return { ok:false, erro:((e&&e.message)||'Não consegui passar o cliente.') }; }
  }

  /* ---------------------------------------------------------------------
     3) O CHAT NA LINHA — o gancho, que é pequeno
     ---------------------------------------------------------------------
     ⚠️ Só aparece quando HÁ TELEFONE: sem telefone não há nem o que tentar.
     (O WhatsApp verde já faz assim.)
     🔴 E o botão vai cair num VAZIO na maioria das vezes: são 107 fichas e
     10 conversas. Por isso o `cpCliThread` ganhou um estado honesto —
     "ainda não há conversa; chame no WhatsApp" — em vez de erro. Não é
     erro, e não pode parecer erro: é o começo normal de toda conversa. */
  var AT_ICO_CHAT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/></svg>';

  function atChatBotaoHtml(c){
    if(!c || !String(c.telefone||'').replace(/\D/g,'')) return '';
    return '<button type="button" class="ct-ib" data-act="chat" title="Abrir a conversa no chat" '+
      'aria-label="Abrir a conversa com '+esc(c.nome||'o cliente')+'">'+AT_ICO_CHAT+'</button>';
  }
  function atChatAbrir(c){
    if(!c) return;
    if(typeof chatPainelAbrirCliente!=='function'){ toast('O chat não está disponível agora.'); return; }
    chatPainelAbrirCliente(c.telefone, c.nome||'Cliente');
  }

/* ╔═══ src/app/12k-leads-e-clientes.js ═══════════════════════════════════ */
  /* ==========================================================================
     12k — LEADS × CLIENTES: A REGRA DE "JÁ COMPROU", UMA SÓ (v527)
     (PROJETO-a-pagina-vira-leads-e-quem-comprou-vira-cliente)

     PEDIDO DO ANGELO: "troque o nome da página pra Leads — os clientes que
     compraram saem dessa página e ficam na página Pós-vendas (Clientes)."

         LEADS     "com quem eu falo hoje?"
         CLIENTES  "quem já é meu e como eu cuido?"

     📏 O QUE FOI MEDIDO (16/08) — E É AQUI QUE MORA O PROBLEMA:
         marcados comprou/pos_vendas ............... 18
         desses, COM venda lançada .................. 2
       🔴 marcados como comprou SEM venda lançada .. 16
       🔴 com venda lançada e a etiqueta em outra coisa .. 1

     **As duas fontes discordam.** "Comprou" é etiqueta que se põe à mão;
     "venda" é registro. Se a página Leads escondesse quem tem a ETIQUETA e
     a página Clientes listasse quem tem VENDA, **16 pessoas sumiriam das
     duas telas**. Por isso este projeto não é um `filter`.

     🔴 A REGRA MORA AQUI, NUM LUGAR SÓ, e as duas páginas chamam a MESMA
     função. Duas regras parecidas em arquivos diferentes é exatamente como
     o buraco de hoje nasceu.
         LEADS     mostra quem NÃO passa em jaComprou()
         CLIENTES  mostra quem passa
     ========================================================================= */

  /* ⛳ v527/v528 — os dois interruptores deste projeto.
     PV_LISTA_SEM_VENDA · a página Clientes lista TAMBÉM quem só tem a
       etiqueta (Fase 1). Desligar devolve a lista só das vendas lançadas.
     LEADS_ESCONDE_COMPROU · a página Leads esconde quem já comprou
       (Fase 3). 🔴 NUNCA ligar este sem o de cima ligado: seria a receita
       exata pras 16 pessoas sumirem das duas telas. */
  var PV_LISTA_SEM_VENDA    = true;
  var LEADS_ESCONDE_COMPROU = true;    /* v528 ligou — a Fase 1 já está no ar */
  /* v528, Fase 4 — os dois grupos que não são "com quem eu falo hoje".
     Medido: perdido 42 · repasse 22, contra 107 fichas. **60% de uma lista
     de trabalho é gente com quem você não vai falar.** Eles não somem: saem
     do padrão e voltam com um toque no "ver perdidos (42)". */
  var LEADS_ESCONDE_FRIOS   = true;
  var LEADS_FRIAS = ['perdido','repasse'];

  /* mapa cliente_id → tem venda FECHADA. Refeito só quando a lista de
     vendas troca de identidade (o `vendaCarregar` reatribui `_vendas`). */
  var _lcMapa=null, _lcFonte=null, _lcTam=-1;
  function lcVendaMapa(){
    var fonte=null;
    try{ fonte=(typeof _vendas!=='undefined')?_vendas:null; }catch(_){ fonte=null; }
    var tam=(fonte&&fonte.length)||0;
    if(_lcMapa && _lcFonte===fonte && _lcTam===tam) return _lcMapa;
    var m={};
    (fonte||[]).forEach(function(v){ if(v && v.fechada && v.cliente_id) m[String(v.cliente_id)]=1; });
    _lcMapa=m; _lcFonte=fonte; _lcTam=tam;
    return m;
  }
  function lcTemVenda(cliId){ return !!lcVendaMapa()[String(cliId||'')]; }

  /* 🔴 A ETIQUETA **OU** A VENDA — as duas contam, e basta uma.
     Medido: 16 têm só a etiqueta, 1 tem só a venda. Exigir as duas some
     com 17 pessoas; usar só uma some com uma das pontas. */
  function jaComprou(c){
    if(!c) return false;
    if(c.etapa==='comprou' || c.etapa==='pos_vendas') return true;
    return lcTemVenda(c.id);
  }
  /* o contrário, com nome próprio — é o que a página Leads pergunta */
  function ehLead(c){ return !jaComprou(c); }

  /* quantos já compraram (o número do aviso da v528) */
  function lcQuantosCompraram(){
    return ((typeof _clientes!=='undefined' && _clientes)||[]).filter(jaComprou).length;
  }
  /* ---------------------------------------------------------------------
     v529 — ONDE ESTA FICHA APARECE (a etiqueta do cabeçalho da conversa)
     ---------------------------------------------------------------------
     Devolve [chave, rótulo] pra pintar do lado do nome, no chat.

     🔴 POR QUE ELA NASCE **AQUI** e não no 10c: se a etiqueta tivesse regra
     própria, um dia ela diria "Lead" pra quem a lista de Leads não mostra.
     Aqui ela come da MESMA `jaComprou()` das duas telas — e, se a página de
     Repasses um dia sair, a etiqueta acompanha sozinha.
     ⚠️ A ORDEM DOS `if` É A REGRA: comprou ganha de repasse, que ganha de
     perdido. É a mesma prioridade do `leadNaLista` logo abaixo — quem
     comprou virou cliente; repasse é o que ele era ANTES. */
  function ondeEstaAficha(c){
    if(!c) return ['semficha','sem ficha'];
    if(jaComprou(c)) return ['cliente','Cliente'];
    var e=String(c.etapa||'');
    if(e==='repasse') return ['repasse','Repasse'];
    if(e==='perdido') return ['perdido','Perdido'];
    return ['lead','Lead'];
  }

  /* ---------------------------------------------------------------------
     v528 — AS ETAPAS FRIAS
     --------------------------------------------------------------------- */
  function lcEtapaFria(c){ return LEADS_FRIAS.indexOf(String((c&&c.etapa)||''))>=0; }
  /* quem está VENDO cada grupo frio agora (o toque no "ver perdidos") */
  var _lcFriasOn={};
  function lcFriaVisivel(k){ return _lcFriasOn[k]===true; }
  function lcFriaAlterna(k){
    _lcFriasOn[k]=!_lcFriasOn[k];
    try{ crmPintaLista((($('cliBusca')||{}).value)||''); }catch(_){}
  }
  function lcContaEtapa(k){
    return ((typeof _clientes!=='undefined' && _clientes)||[]).filter(function(c){
      return c && c.etapa===k && !jaComprou(c); }).length;
  }
  /* 🔴 A REGRA DA LISTA DE LEADS, num lugar só.
     Devolve true = a ficha FICA na lista.
     ⚠️ Escolher a etapa no filtro do topo MANDA em tudo: quem pede
     "Comprou" quer ver quem comprou, e quem pede "Perdido" quer ver os
     perdidos. Esconder o que a pessoa acabou de pedir é o pior tipo de
     esperteza. */
  function leadNaLista(c, etapaEscolhida){
    if(!c) return false;
    var pediu=String(etapaEscolhida||'');
    if(pediu) return true;                       /* filtrou: mostra o que pediu */
    if(LEADS_ESCONDE_COMPROU && jaComprou(c)) return false;
    if(LEADS_ESCONDE_FRIOS && lcEtapaFria(c) && !lcFriaVisivel(c.etapa)) return false;
    return true;
  }
  /* ---------------------------------------------------------------------
     v806 (§6 do PROJETO-leads-clientes-cadastro-historico) — "FORA DA LISTA
     ATUAL", um resumo só, em vez de três chips soltos
     ---------------------------------------------------------------------
     📏 O QUE MUDOU E POR QUÊ: até a v805 os três grupos (Clientes ·
     Perdidos · Repasses) apareciam como chips IGUAIS, lado a lado, como se
     fossem três filtros do mesmo tipo. Não são:
         Clientes  → NAVEGA pra outra página (é gente que virou cliente)
         Perdidos  → LIGA/DESLIGA um grupo dentro desta mesma lista
         Repasses  → idem
     Três botões com a mesma cara e três efeitos diferentes é como se aprende
     errado uma tela. Agora eles vivem debaixo de um título que diz o que
     eles são — "Fora da lista atual" — e o de navegar carrega o "›".

     🔴 A REGRA NÃO MUDOU. `leadNaLista`, `lcFriaAlterna` e `jaComprou`
     continuam exatamente como estavam: isto aqui é a CASCA. Se um dia o
     resumo sumir, ninguém deixa de ser contado — só deixa de ser visto.

     ⚠️ E O TÍTULO CONTA A VERDADE: com um grupo frio aberto, ele deixa de
     dizer "fora da lista" (mentira: eles estão DENTRO) e passa a dizer o que
     você está vendo, com a porta de volta ao lado. */
  function lcFriasAtivas(){
    return LEADS_FRIAS.filter(function(k){ return lcFriaVisivel(k) && lcContaEtapa(k); });
  }
  /* a porta de volta: desliga TODOS os grupos frios de uma vez */
  function lcFriasLimpar(){
    _lcFriasOn={};
    try{ crmPintaLista((($('cliBusca')||{}).value)||''); }catch(_){}
  }
  function _lcNomeFria(k){ return (k==='perdido')?'Perdidos':'Repasses'; }
  /* o aviso do topo da lista: nada some calado.
     🔴 Sumir sem dizer é como se perde a confiança numa tela. */
  function leadAvisoHtml(){
    if(typeof _clientes==='undefined' || !_clientes) return '';
    var partes=[];
    if(LEADS_ESCONDE_COMPROU){
      var n=lcQuantosCompraram();
      if(n) partes.push('<button type="button" class="lc-av-b lc-av-nav" data-lc="clientes" '+
        'title="'+n+' já '+(n===1?'comprou — está':'compraram — estão')+' na página Clientes">'+
        'Clientes <b>'+n+'</b> ›</button>');
    }
    if(LEADS_ESCONDE_FRIOS){
      LEADS_FRIAS.forEach(function(k){
        var q=lcContaEtapa(k); if(!q) return;
        var nome=_lcNomeFria(k), on=lcFriaVisivel(k);
        partes.push('<button type="button" class="lc-av-b'+(on?' on':'')+'" data-lc-fria="'+k+'" '+
          'aria-pressed="'+(on?'true':'false')+'" title="'+(on?'ocultar':'mostrar')+' '+nome.toLowerCase()+' nesta lista">'+
          nome+' <b>'+q+'</b></button>');
      });
    }
    if(!partes.length) return '';
    var ativas=lcFriasAtivas();
    var tit, volta='';
    if(ativas.length){
      tit='Mostrando '+ativas.map(function(k){ return _lcNomeFria(k).toLowerCase(); }).join(' e ');
      volta='<button type="button" class="lc-av-volta" data-lc-voltar="1">Voltar aos leads ativos</button>';
    } else tit='Fora da lista atual';
    return '<div class="lc-aviso'+(ativas.length?' fria-on':'')+'">'+
      '<div class="lc-av-h"><span class="lc-av-t">'+tit+'</span>'+volta+'</div>'+
      '<div class="lc-av-l">'+partes.join('')+'</div></div>';
  }
  function leadAvisoLiga(el){
    if(!el) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-lc="clientes"]'),function(b){
      b.onclick=function(e){ e.stopPropagation(); try{ drawerIr('posvendas'); }catch(_){} };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-lc-fria]'),function(b){
      b.onclick=function(e){ e.stopPropagation(); lcFriaAlterna(b.getAttribute('data-lc-fria')); };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-lc-voltar]'),function(b){
      b.onclick=function(e){ e.stopPropagation(); lcFriasLimpar(); };
    });
  }

/* ╔═══ src/app/12l-remover-do-chat.js ════════════════════════════════════ */
  /* ============================================================================
   * 12l — REMOVER DO CHAT (v538)
   *
   * PEDIDO do Angelo (17/08): *"quando clicar no card, uma lista com enviar
   * mensagem ou remover do chat — o cliente sai da lista de atendimento."*
   *
   * ⚠️ REMOVER DO CHAT **NÃO APAGA NADA**. O cadastro fica, as mensagens
   * ficam, o histórico fica. O que sai é a conversa da FILA DE ATENDIMENTO —
   * daquela lista que existe pra responder quem está esperando.
   *
   * ============================================================================
   * 🔴 A REGRA QUE FAZ ISTO SER SEGURO: QUEM FALA DE NOVO, VOLTA
   *
   * A conversa fica escondida **enquanto a última mensagem for mais velha que
   * a remoção**. Escreveu de novo? Volta pra fila sozinha.
   *
   * Sem essa regra, "remover" seria uma porta de mão única — e num sistema de
   * atendimento o pior defeito possível é o que **faz você ignorar um cliente
   * sem saber**. Um toque errado no card, ou alguém que sumiu e voltou seis
   * meses depois, viraria silêncio permanente.
   *
   * É também por isso que NÃO existe tela de "removidas": ela não faz falta.
   * Quem fala de novo reaparece; quem não fala não é atendimento pendente.
   * Uma tela a menos pra manter, e nenhuma conversa perdida.
   * ============================================================================
   *
   * 🔴 A CHAVE É O TELEFONE, NÃO A FICHA. A lista é de CONVERSAS — o filtro
   * "Sem ficha" existe justamente porque tem conversa de quem não está no
   * CRM. E são os **8 últimos dígitos**, a chave do app inteiro.
   *
   * 🔴 E A CHAVE É A LOJA, NÃO O USUÁRIO. A caixa de entrada é compartilhada
   * (o chat-whatsapp.js diz: "nunca o usuário que abriu o app"). Se a marca
   * fosse por pessoa, o Angelo removeria e a Kerolayne continuaria vendo — com
   * os contadores dos dois discordando na mesma tela.
   *
   * ⚠️ Tabela: `mp_chat_removido` (sql-v538). Sem ela, TUDO AQUI VIRA NÃO-OP:
   * a leitura falha em silêncio, o conjunto fica vazio e a lista aparece
   * inteira, como antes. Publicar o app antes de rodar o SQL não quebra nada
   * — só não remove.
   * ========================================================================== */

  /* ⛳ v538 — desliga a remoção inteira (o item do menu some junto). */
  var CHAT_REMOVER_ON = true;

  var _remSet   = null;    /* chave_fone → timestamp da remoção (ms) */
  var _remLido  = false;
  var _remPedido= false;

  function _remChave(fone){
    var d=String(fone||'').replace(/\D/g,'');
    return d.length>=8 ? d.slice(-8) : '';
  }
  function _remLojaId(){
    try{ if(typeof _lojaRec!=='undefined' && _lojaRec && _lojaRec.id) return _lojaRec.id; }catch(_){}
    return '';
  }

  async function remCarregar(forcar){
    if(_remLido && !forcar) return _remSet;
    /* ⚠️ o mesmo tropeço da v530: quem abre o app e vai direto pro chat chega
       sem a loja carregada. Busca sozinho em vez de desistir. */
    try{
      if(!_remLojaId() && typeof lojaGet==='function') await lojaGet();
    }catch(_){}
    var loja=_remLojaId();
    if(!loja){ _remSet=_remSet||{}; return _remSet; }   /* sem loja: nada removido */
    try{
      var r=await withTimeout(supa.from('chat_removido').select('chave_fone,removido_em').eq('loja_id',loja),8000);
      var m={};
      ((r&&r.data)||[]).forEach(function(x){
        var t=Date.parse(x.removido_em||'')||0;
        if(x.chave_fone) m[String(x.chave_fone)]=t;
      });
      _remSet=m; _remLido=true;
    }catch(_){ _remSet=_remSet||{}; }                   /* falhou: mostra tudo */
    return _remSet;
  }
  /* pede uma vez e manda repintar — o mesmo desenho do atMembrosGarante,
     com a trava de "já tentei" que a v531 teve que acrescentar lá. */
  var _remTentou=false;
  function remGarante(repinta){
    if(_remLido || _remPedido || _remTentou) return;
    _remPedido=true; _remTentou=true;
    remCarregar().then(function(){ _remPedido=false; try{ if(typeof repinta==='function') repinta(); }catch(_){} },
                       function(){ _remPedido=false; });
  }

  /* 🔴 ESTA é a regra: removida só enquanto a última mensagem for mais velha
     que a remoção. `cv.quando` é o criado_em da última mensagem (o resumo do
     servidor manda assim). Sem data, trata como removida. */
  function chatRemovida(cv){
    if(!CHAT_REMOVER_ON || !_remSet) return false;
    var k=_remChave(cv && cv.telefone); if(!k) return false;
    var quando0=_remSet[k]; if(!quando0) return false;
    var ult=Date.parse((cv&&cv.quando)||'')||0;
    return !(ult > quando0);
  }

  async function chatRemover(fone){
    var k=_remChave(fone);
    if(!k){ toast('Conversa sem telefone.'); return false; }
    try{ if(!_remLojaId() && typeof lojaGet==='function') await lojaGet(); }catch(_){}
    var loja=_remLojaId();
    if(!loja){ toast('Não consegui identificar a loja agora.'); return false; }
    var agora=new Date().toISOString();
    try{
      /* 🔴 REGRA 6 DA CASA: update/insert barrado por RLS volta como SUCESSO
         com ZERO linhas. Sem o `.select('id')` (aqui, a chave) a tela diria
         "removido" e a conversa voltaria na próxima pintura. */
      var r=await supa.from('chat_removido')
        .upsert({ loja_id:loja, chave_fone:k, removido_em:agora, por_user_id:meuId||null },
                { onConflict:'loja_id,chave_fone' })
        .select('chave_fone');
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length) throw new Error('sem permissão');
    }catch(e){
      toast('Não consegui remover do chat.');
      return false;
    }
    _remSet=_remSet||{}; _remSet[k]=Date.parse(agora);
    return true;
  }

  async function chatDevolver(fone){
    var k=_remChave(fone); var loja=_remLojaId();
    if(!k || !loja) return false;
    try{
      var r=await supa.from('chat_removido').delete()
        .eq('loja_id',loja).eq('chave_fone',k).select('chave_fone');
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length) throw new Error('sem permissão');
    }catch(_){ toast('Não consegui desfazer.'); return false; }
    if(_remSet) delete _remSet[k];
    return true;
  }

/* ╔═══ src/app/12m-respostas-padrao.js ═══════════════════════════════════ */
  /* ============================================================================
   * 12m — RESPOSTAS PADRÃO (v538)
   *
   * PEDIDO do Angelo: *"cria também a opção de cadastrar respostas padrão"* —
   * o PIX da loja, os dados pra financiamento, o horário, o endereço. As
   * frases que ele digita dez vezes por dia. E depois: *"vai morar dentro do
   * + no chat"*.
   *
   * ⚠️ MORA NO "+" DO COMPOSITOR, ao lado de "Anexar veículo" e "Enviar link
   * do catálogo". É o lugar certo: aquele menu já é "o que eu ponho nesta
   * mensagem", e resposta pronta é exatamente isso. Uma página no menu
   * lateral obrigaria a sair da conversa pra buscar o texto — que é o
   * trabalho que ela existe pra eliminar.
   *
   * 🔴 ELAS SÃO DA LOJA, NÃO DE QUEM CADASTROU.
   * O PIX é o mesmo pro dono e pro vendedor. Se cada um tivesse a sua lista,
   * a Kerolayne mandaria uma chave e o Angelo outra — e o cliente pagaria na
   * conta errada. Isso não é preferência de tela, é dinheiro indo pro lugar
   * errado. A RLS é a mesma `mp_e_da_loja` do "remover do chat".
   *
   * ⚠️ O TÍTULO É SÓ PRA ACHAR na lista (o lojista lê "PIX" e toca). Quem vai
   * pro WhatsApp é o TEXTO — e só ele. Manter os dois separados é o que
   * permite, depois, o atendente ler essa tabela sem levar junto rótulo de
   * tela.
   *
   * 📌 ISTO É A BASE DO PRÓXIMO PASSO que ele já pediu: *"a IA lê esses dados
   * e aprende"*. Não está feito nesta versão — mas a tabela já nasce no
   * formato que o atendente vai precisar (da loja, texto limpo em campo
   * próprio), pra esse passo não exigir migração.
   *
   * ⚠️ Sem a tabela (`sql-v538`), tudo aqui vira NÃO-OP: a leitura falha em
   * silêncio, a lista aparece vazia com o convite pra criar a primeira, e o
   * resto do chat continua igual.
   * ========================================================================== */

  /* ⛳ v538 — desliga o item do "+" e a folha inteira. */
  var RESP_PADRAO_ON = true;

  var _rpLista = null;
  var _rpLido  = false;

  function _rpLojaId(){
    try{ if(typeof _lojaRec!=='undefined' && _lojaRec && _lojaRec.id) return _lojaRec.id; }catch(_){}
    return '';
  }

  async function rpCarregar(forcar){
    if(_rpLido && !forcar) return _rpLista||[];
    /* o tropeço da v530 de novo: quem entra direto no chat chega sem loja */
    try{ if(!_rpLojaId() && typeof lojaGet==='function') await lojaGet(); }catch(_){}
    var loja=_rpLojaId();
    if(!loja){ _rpLista=_rpLista||[]; return _rpLista; }
    try{
      var r=await withTimeout(supa.from('resposta_padrao')
        .select('id,titulo,texto,atualizado_em').eq('loja_id',loja).order('criado_em',{ascending:true}),8000);
      _rpLista=((r&&r.data)||[]); _rpLido=true;
    }catch(_){ _rpLista=_rpLista||[]; }
    return _rpLista;
  }

  async function rpSalvar(id, titulo, texto){
    var loja=_rpLojaId();
    if(!loja){ toast('Não consegui identificar a loja agora.'); return false; }
    titulo=String(titulo||'').trim(); texto=String(texto||'').trim();
    if(!titulo){ toast('Dê um nome pra achar essa resposta depois.'); return false; }
    if(!texto){ toast('Escreva o texto da resposta.'); return false; }
    try{
      var r;
      if(id){
        /* 🔴 REGRA 6 DA CASA: update barrado por RLS volta como SUCESSO com
           ZERO linhas. Sem o `.select('id')` a tela diria "salvo" e o texto
           voltaria ao antigo na próxima abertura. */
        r=await supa.from('resposta_padrao')
          .update({ titulo:titulo, texto:texto, atualizado_em:new Date().toISOString() })
          .eq('id',id).eq('loja_id',loja).select('id');
      } else {
        r=await supa.from('resposta_padrao')
          .insert({ loja_id:loja, titulo:titulo, texto:texto, criado_por:meuId||null })
          .select('id');
      }
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length) throw new Error('sem permissão');
    }catch(e){ toast('Não consegui salvar a resposta.'); return false; }
    await rpCarregar(true);
    return true;
  }

  async function rpApagar(id){
    var loja=_rpLojaId(); if(!id || !loja) return false;
    try{
      var r=await supa.from('resposta_padrao').delete().eq('id',id).eq('loja_id',loja).select('id');
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length) throw new Error('sem permissão');
    }catch(_){ toast('Não consegui apagar.'); return false; }
    await rpCarregar(true);
    return true;
  }

/* ╔═══ src/app/12n-situacao-entrega.js ═══════════════════════════════════ */
  /* ============================================================================
   * 12n — A SITUAÇÃO DO CARRO (v540)
   *
   * PEDIDO do Angelo: *"troque o 'não entreguei' com uma lista dropdown e
   * adicione uma coluna pra etiquetas (Faturamento pendente · Ainda não
   * chegou · Processo de entrega · Entregue · Pós-venda · Manutenção)"*.
   *
   * O QUE ISTO RESOLVE: até a v539 só existiam DOIS estados — entregue ou
   * "ainda não entreguei" (uma caixinha). Mas "não entreguei" cobre três
   * situações que não se parecem em nada: esperando a nota, esperando o
   * carro chegar, e o carro na loja em preparação. Quem olha a lista não
   * sabe em qual delas cada venda está — e é justamente isso que decide
   * pra quem ligar hoje.
   *
   * ============================================================================
   * 🔴🔴 SÃO 6 ETIQUETAS, MAS SÓ 4 SE ESCOLHEM. E ISSO É DE PROPÓSITO.
   *
   * As três primeiras (faturamento · não chegou · processo de entrega) só a
   * pessoa sabe: o app não tem como adivinhar se a nota saiu. Essas viram
   * a LISTA.
   *
   * As outras três o app JÁ SABE, e sabe melhor que a memória de qualquer um:
   *   · "Entregue"   → tem data de entrega e ela é recente;
   *   · "Pós-venda"  → passou da janela de entrega recente (a régua já roda);
   *   · "Manutenção" → tem manutenção ABERTA (isso existe desde a v460).
   *
   * Se elas fossem opção de escolher à mão, o lojista passaria a MANTER na
   * mão uma coisa que o sistema calcula — o oposto do que este app existe
   * pra fazer. Pior: um carro entregue há 40 dias que entrasse na oficina
   * viraria "Manutenção" e **deixaria de ser "Entregue"** — e é da entrega
   * que saem a garantia e a régua inteira. Perderíamos a data que faz o
   * pós-venda funcionar pra ganhar um rótulo.
   *
   * Por isso: `manutencao` ENTRA POR CIMA, sem apagar a entrega. É etiqueta
   * de tela, não estado gravado.
   * ============================================================================
   *
   * 🔴 O `entrega_pendente` DA v521 CONTINUA SENDO O INTERRUPTOR MESTRE.
   * A `situacao` só diz QUAL das três fases de antes da entrega. Guardar a
   * fase e apagar o `entrega_pendente` quebraria de uma vez o `pvGarantia`,
   * o `pvEventos` e o filtro — os três leem a bandeira, não a fase. Somar em
   * vez de substituir mantém as vendas antigas funcionando sem migração.
   *
   * ⚠️ VENDA ANTIGA SEM `situacao` CAI EM "FATURAMENTO PENDENTE" — a
   * primeira fase, de propósito. As fases são um caminho: uma venda cuja
   * fase nunca foi registrada não foi adiantada por ninguém. E, entre errar
   * pra mais e errar pra menos, o certo é a leitura que **mantém o carro na
   * sua frente cobrando** em vez de fazê-lo parecer mais adiantado do que
   * está. Um toque conserta. (Medido no banco em 17/08: 1 venda nessa
   * condição.)
   *
   * ⚠️ SEM SQL. Tudo mora no jsonb `mp_vendas.posvenda`, como a manutenção
   * da v460 e o pendente da v521.
   * ========================================================================== */

  /* ⛳ v540 — volta pro estado da v539 (a caixinha "Ainda não entreguei"). */
  var SITUACAO_ON = true;

  /* 🔴 A JANELA DE "ENTREGUE" É A PRIMEIRA SEMANA, e o número não é chutado:
     é o `d7` da PV_REGUA ("Como está o carro?"). Enquanto o app ainda vai
     perguntar como foi a entrega, a venda está NA entrega. Depois disso o
     assunto é acompanhamento — que é o que "pós-venda" quer dizer. Amarrar
     no d7 faz a etiqueta e a régua contarem a mesma história. */
  var PV_ENTREGUE_DIAS = 7;

  /* As 6, na ordem do caminho. `antes:true` = acontece ANTES da entrega e
     portanto fica fora da régua e da garantia. */
  var PV_SIT = [
    { k:'faturamento', rot:'Faturamento pendente', cls:'fat',  antes:true },
    { k:'nao_chegou',  rot:'Ainda não chegou',     cls:'vem',  antes:true },
    { k:'entrega',     rot:'Processo de entrega',  cls:'prep', antes:true },
    { k:'entregue',    rot:'Entregue',             cls:'ok'   },
    { k:'posvenda',    rot:'Pós-venda',            cls:'pos'  },
    { k:'manutencao',  rot:'Manutenção',           cls:'man'  }
  ];
  /* o que a LISTA oferece: as três de antes + "Entregue" */
  function pvSitEscolhiveis(){
    return PV_SIT.filter(function(s){ return s.antes || s.k==='entregue'; });
  }
  function pvSitDef(k){
    var a=PV_SIT.filter(function(s){ return s.k===String(k||''); });
    return a.length?a[0]:null;
  }
  function pvSitRotulo(k){ var d=pvSitDef(k); return d?d.rot:''; }
  function _pvSitAntes(k){ var d=pvSitDef(k); return !!(d&&d.antes); }

  /* ---------------------------------------------------------------------
     A ETIQUETA DE UMA VENDA. Uma função só, usada pela tabela, pelo card,
     pelos filtros e pelos contadores — pra que os quatro nunca discordem.
     --------------------------------------------------------------------- */
  function pvSituacao(v){
    if(!v) return '';
    /* a ficha sem venda lançada (v527) tem pílula própria e não é uma fase
       da entrega: um carro que ninguém lançou não está em fase nenhuma. */
    try{ if(typeof _pvSemVenda==='function' && _pvSemVenda(v)) return ''; }catch(_){}
    if(!SITUACAO_ON) return '';

    if(_pvPendente(v)){
      var s=String((_pvPv(v).situacao)||'');
      /* ⚠️ o fallback é a PRIMEIRA fase — ver a nota do cabeçalho */
      return _pvSitAntes(s) ? s : 'faturamento';
    }
    /* 🔴 daqui pra baixo o carro FOI entregue. A manutenção entra por cima
       sem mexer nisso: é a informação mais urgente da linha, e some sozinha
       quando a manutenção é resolvida. */
    try{ if(_pvManutAbertas(v).length) return 'manutencao'; }catch(_){}
    var e=_pvEntrega(v);
    if(!e) return 'entregue';
    return (-_pvDif(e) <= PV_ENTREGUE_DIAS) ? 'entregue' : 'posvenda';
  }

  function pvSitPillHtml(v){
    var k=pvSituacao(v); if(!k) return '';
    var d=pvSitDef(k); if(!d) return '';
    return '<button type="button" class="pv-sit pv-sit-'+d.cls+'" data-sit="'+esc(String(v.id))+'">'+
             esc(d.rot)+'</button>';
  }

  /* ---------------------------------------------------------------------
     GRAVAR. Um caminho só pros dois sentidos (avançar e corrigir).
     --------------------------------------------------------------------- */
  async function pvSituacaoSalvar(v, k, dataEntrega, previsao){
    if(!v || !v.id) return false;
    var pv=Object.assign({}, _pvPv(v));
    var antesData=v.data_entrega||null;
    var campos={ atualizado_em:new Date().toISOString() };

    if(k==='entregue'){
      var dt=String(dataEntrega||'').trim();
      if(!/^\d{4}-\d{2}-\d{2}$/.test(dt)){ toast('Ponha a data da entrega.'); return false; }
      pv.entrega_pendente=false;
      delete pv.situacao; delete pv.previsao; delete pv.pendente_desde;
      /* 🔴 A GARANTIA CONTA DA ENTREGA, NÃO DA ASSINATURA (regra da v521).
         Se alguém puser a data da venda no lugar, o cliente perde dias de
         garantia — e isso só aparece na hora do problema.
         ⚠️ Mas um `inicio` posto À MÃO não pode ser atropelado. Então só
         escrevo quando ele está vazio OU quando é cópia da data de entrega
         anterior (ou seja: foi o próprio app que pôs ali). */
      var ini=(pv.garantia||{}).inicio||'';
      if(!ini || (antesData && String(ini)===String(antesData).slice(0,10))){
        pv.garantia=Object.assign({}, pv.garantia||{}, { inicio:dt });
      }
      campos.data_entrega=dt;
    } else if(_pvSitAntes(k)){
      pv.entrega_pendente=true;
      pv.situacao=k;
      pv.previsao=String(previsao||'').trim()||null;
      if(!pv.pendente_desde) pv.pendente_desde=new Date().toISOString().slice(0,10);
      /* ⚠️ VOLTANDO ATRÁS (marcou entregue sem querer): NÃO apago a
         `data_entrega`. O `pvGarantia` e o `pvEventos` já param sozinhos
         quando `entrega_pendente` é true — apagar a data seria destruir um
         dado pra conseguir um efeito que a bandeira já dá, e ela é o
         palpite certo na hora de marcar entregue de novo. */
    } else { return false; }

    campos.posvenda=pv;
    try{
      /* 🔴 REGRA 6 DA CASA: update barrado por RLS volta como SUCESSO com
         ZERO linhas. Sem o `.select('id')` a tela mudaria a etiqueta e ela
         voltaria ao que era na próxima pintura. */
      var r=await supa.from('vendas').update(campos).eq('id',v.id).select('id');
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length){ toast('Não consegui gravar — esta venda não é sua.'); return false; }
    }catch(e){ toast('Não consegui gravar. '+((e&&e.message)||'')); return false; }

    if(campos.data_entrega!==undefined) v.data_entrega=campos.data_entrega;
    v.posvenda=pv;
    return true;
  }

  /* ---------------------------------------------------------------------
     A FOLHA DE TROCAR A SITUAÇÃO.
     ⚠️ Ela SUBSTITUI o `prompt()` do "Entreguei" da v521 — prompt de
     navegador saiu do app na v522, e ainda por cima pedia a data em
     "AAAA-MM-DD" digitada à mão, no celular, no meio do atendimento.
     --------------------------------------------------------------------- */
  function pvSituacaoAbrir(vid){
    if(!SITUACAO_ON) return;
    var lista=(typeof _pvBase==='function')?_pvBase():[];
    var v=lista.filter(function(x){ return String(x.id)===String(vid); })[0];
    if(!v || _pvSemVenda(v)) return;
    if($('pvSitMask')) return;

    var atual=pvSituacao(v);
    /* manutenção/pós-venda não são escolhas — quem está nelas está entregue */
    if(!_pvSitAntes(atual)) atual='entregue';
    var hoje=new Date().toISOString().slice(0,10);
    var dtIni=String(v.data_entrega||'').slice(0,10)||hoje;
    var prIni=String(_pvPv(v).previsao||'').slice(0,10);
    var quem=((_pvCliente(v)||{}).nome)||v.cliente_nome||'esta venda';

    var ov=document.createElement('div'); ov.className='cropmask'; ov.id='pvSitMask';
    ov.innerHTML='<div class="cropbox pv-sitbox">'+
      '<div class="crop-tit">'+esc(quem)+'</div>'+
      '<div class="pv-sit-ops">'+
        pvSitEscolhiveis().map(function(s){
          return '<button type="button" class="pv-sit-op'+(s.k===atual?' on':'')+'" data-k="'+s.k+'">'+
                   '<i class="pv-sit-dot pv-sit-'+s.cls+'"></i><span>'+esc(s.rot)+'</span></button>';
        }).join('')+
      '</div>'+
      '<div id="pvSitData" class="pv-sit-cx"><label class="crm-lb" for="pvSitDt">DATA DA ENTREGA</label>'+
        '<input class="cad-in" id="pvSitDt" type="date" value="'+esc(dtIni)+'" max="'+esc(hoje)+'"></div>'+
      '<div id="pvSitPrev" class="pv-sit-cx"><label class="crm-lb" for="pvSitPr">PREVISÃO DE ENTREGA (opcional)</label>'+
        '<input class="cad-in" id="pvSitPr" type="date" value="'+esc(prIni)+'"></div>'+
      '<button type="button" class="cad-btn" id="pvSitOk" style="margin-top:14px;width:100%">Salvar</button>'+
      '<button type="button" class="link" id="pvSitNao" style="margin-top:8px;width:100%">Cancelar</button>'+
    '</div>';
    document.body.appendChild(ov);

    var esc0=atual;
    function fecha(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) fecha(); };
    $('pvSitNao').onclick=fecha;

    function pinta(){
      Array.prototype.forEach.call(ov.querySelectorAll('.pv-sit-op'),function(b){
        b.classList.toggle('on', b.getAttribute('data-k')===esc0);
      });
      /* 🔴 um campo por vez: data DE ENTREGA só faz sentido em "Entregue",
         PREVISÃO só faz sentido antes dela. Mostrar os dois juntos convida
         a preencher a errada — e a errada aqui mexe na garantia. */
      var ent=(esc0==='entregue');
      $('pvSitData').classList.toggle('off', !ent);
      $('pvSitPrev').classList.toggle('off', ent);
    }
    Array.prototype.forEach.call(ov.querySelectorAll('.pv-sit-op'),function(b){
      b.onclick=function(){ esc0=b.getAttribute('data-k'); pinta(); };
    });
    pinta();

    $('pvSitOk').onclick=async function(){
      var bt=$('pvSitOk'); bt.disabled=true; bt.textContent='Salvando…';
      var ok=await pvSituacaoSalvar(v, esc0, ($('pvSitDt')||{}).value, ($('pvSitPr')||{}).value);
      bt.disabled=false; bt.textContent='Salvar';
      if(!ok) return;
      fecha();
      toast(esc0==='entregue' ? 'Entrega confirmada ✓ a garantia começa nessa data.'
                              : (pvSitRotulo(esc0)+' ✓'));
      try{ pvPinta(); }catch(_){}
    };
  }

/* ╔═══ src/app/12o-ia-liga-desliga.js ════════════════════════════════════ */
  /* ============================================================================
   * 12o — LIGAR E DESLIGAR A IA NA CONVERSA (v541)
   *
   * PEDIDO do Angelo: *"ao lado do 'IA pausada' um seletor pra ativar a IA e
   * vice-versa"*.
   *
   * ============================================================================
   * 🔴🔴 A LINHA "IA PAUSADA" DIZIA UM EFEITO, NÃO UMA DECISÃO
   *
   * Até a v540 aquela linha era 100% DEDUZIDA: "um humano respondeu este
   * telefone nos últimos 30 minutos". Ninguém tinha escolhido nada — o
   * estado era consequência de ter digitado. E ele se desfazia sozinho.
   *
   * Isso torna o seletor impossível de fazer só na tela:
   *
   *   1. DESLIGAR precisa DURAR. Um botão que se desfaz em meia hora é pior
   *      do que não ter botão — ele desliga a IA pra cuidar de uma
   *      negociação delicada, vai almoçar, e a IA volta a falar sozinha com
   *      o cliente. Por isso `pausada` NÃO EXPIRA.
   *
   *   2. LIGAR precisa VENCER os 30 minutos. Se ele acabou de responder à
   *      mão e aperta "ativar", a dedução continua dizendo "humano no
   *      comando" e o botão pareceria quebrado. Por isso grava um `desde`:
   *      mensagem humana anterior a ele deixa de contar.
   *
   * ============================================================================
   * 🔴🔴 E QUEM MANDA DE VERDADE É O SERVIDOR, NÃO ESTA TELA
   *
   * Quem cala a IA é o `atendente-whatsapp.js` (a função que a Z-API chama
   * quando o cliente escreve). Esta tela e o `chat-whatsapp.js` são
   * ESPELHOS. Se o seletor mexesse só no espelho, a tela diria "desligada" e
   * a IA responderia assim mesmo — o pior defeito possível num botão.
   * Por isso a v541 mexeu nos DOIS arquivos do servidor, e os dois leem a
   * mesma `mp_atendente_ia`.
   *
   * 🔴 É DA LOJA, não de quem apertou. A caixa de entrada é compartilhada:
   * se o Angelo desliga a IA de um cliente e ela continuasse ligada pra
   * Kerolayne, a IA responderia do mesmo jeito.
   *
   * ⚠️ Sem a tabela (`sql-v541`) tudo aqui vira NÃO-OP: o seletor avisa que
   * não conseguiu gravar e a IA segue na regra deduzida de sempre.
   * ========================================================================== */

  /* ⛳ v541 — some com o seletor e volta a linha só informativa da v529. */
  var IA_SELETOR_ON = true;

  function _iaChave(fone){
    var d=String(fone||'').replace(/\D/g,'');
    return d.length>=8 ? d.slice(-8) : '';
  }
  function _iaLojaId(){
    try{ if(typeof _lojaRec!=='undefined' && _lojaRec && _lojaRec.id) return _lojaRec.id; }catch(_){}
    return '';
  }

  /* Grava a escolha e devolve o estado novo, ou null se não deu.
     `modo` = 'pausada' | 'ativa'. */
  async function iaEscolher(fone, modo){
    var k=_iaChave(fone);
    if(!k){ toast('Conversa sem telefone.'); return null; }
    if(modo!=='pausada' && modo!=='ativa') return null;
    /* o tropeço da v530 de novo: quem entra direto no chat chega sem loja */
    try{ if(!_iaLojaId() && typeof lojaGet==='function') await lojaGet(); }catch(_){}
    var loja=_iaLojaId();
    if(!loja){ toast('Não consegui identificar a loja agora.'); return null; }
    try{
      /* 🔴 REGRA 6 DA CASA: upsert barrado por RLS volta como SUCESSO com
         ZERO linhas. Sem o `.select` o seletor viraria de lado na tela e a
         IA continuaria fazendo o contrário — exatamente o defeito que este
         módulo existe pra não ter. */
      var r=await supa.from('atendente_ia')
        .upsert({ loja_id:loja, chave_fone:k, modo:modo,
                  desde:new Date().toISOString(), por_user_id:meuId||null },
                { onConflict:'loja_id,chave_fone' })
        .select('chave_fone');
      if(r&&r.error) throw r.error;
      if(!((r&&r.data)||[]).length) throw new Error('sem permissão');
    }catch(e){
      toast(modo==='pausada' ? 'Não consegui desligar a IA.' : 'Não consegui ligar a IA.');
      return null;
    }
    return modo;
  }

/* ╔═══ src/app/12p-revisoes.js ═══════════════════════════════════════════ */
  /* ==========================================================================
     12p — A ABA "REVISÕES" DENTRO DE CLIENTES  (v1071)
     --------------------------------------------------------------------------
     Projeto: PROJETO-2026-09-18-revisoes-nos-clientes.txt

     O Angelo recebe da oficina uma lista em TEXTO CRU — nome, telefone e o
     serviço, um por linha — e hoje lê linha por linha, decide quem ligar
     primeiro e digita telefone por telefone no WhatsApp. É exatamente o
     trabalho manual e repetitivo que o MEV existe pra eliminar.

     🔴 POR QUE O LEITOR VEM PRIMEIRO E É FEITO DE FUNÇÕES PURAS: sem DOM e
        sem rede, o teste mede o que importa (a leitura e a ordem) por poucos
        centavos e sem navegador. Tela e banco vêm em volta depois.

     ⚠️ LETRA `12p` E NÃO `12d`: o projeto sugeria `12d`, mas o `12d-chat.js`
        já existe. Conferi no disco antes de escrever, como o passo 0 manda —
        12b..12o estão todos ocupados.
     ========================================================================== */

  /* ---------------------------------------------------------------- TELEFONE */
  /* 🔴 A EXPRESSÃO É A DO PROJETO, VALIDADA NOS 15 CASOS REAIS. O `(?!\d)` no
     fim é o que impede um número maior de ser cortado no meio. */
  var RE_FONE_REV = /\(?(\d{2})\)?[\s.\-]?(\d{4,5})[\s.\-]?(\d{4})(?!\d)/g;

  function revFones(linha){
    /* 🔴🔴 O `lastIndex` TEM QUE SER ZERADO A CADA LINHA. A flag /g guarda
       estado ENTRE chamadas: sem esta linha, a segunda linha da lista começa
       a procurar de onde a primeira parou e perde telefones — em silêncio.
       É um defeito clássico, e o projeto avisa dele com todas as letras. */
    RE_FONE_REV.lastIndex = 0;
    var s=String(linha||''), m, achados=[];
    while((m=RE_FONE_REV.exec(s))){
      achados.push({ e164:'+55'+m[1]+m[2]+m[3],
                     bonito:'('+m[1]+') '+m[2]+'-'+m[3],
                     ini:m.index, fim:m.index+m[0].length });
    }
    return achados;
  }

  /* ------------------------------------------------------------------- NOME */
  var REV_MINUSCULAS={ da:1, de:1, do:1, das:1, dos:1, e:1 };
  function revNome(pedaco){
    var t=String(pedaco||'').replace(/\s+/g,' ').trim();
    if(!t) return '';
    return t.toLowerCase().split(' ').map(function(p,i){
      if(!p) return p;
      /* "da de do das dos e" ficam em minúscula — MENOS quando abrem o nome */
      if(i>0 && REV_MINUSCULAS[p]) return p;
      return p.charAt(0).toUpperCase()+p.slice(1);
    }).join(' ');
  }

  /* -------------------------------------------------------------- SERVIÇO */
  /* 🔴 A ORDEM DESTA TABELA É A REGRA. O primeiro que casar é o que vale.
     ⚠️ "quinta" precisa ser testada ANTES de qualquer regra genérica de
        "revis", senão tudo cai na primeira que casar por acaso.
     ⚠️ O texto chega SEM ACENTO ("revisao", "diagnostico", "oleo"). As
        expressões toleram as duas grafias de propósito — não "consertar". */
  var REV_REGRAS=[
    [/diagn/i,                         'Serviço de diagnóstico', 0, 1],
    [/recall|campanha/i,               'Recall',                 0, 2],
    [/(quinta|5\s*[ªa°]?)\s*revis/i,   '5ª revisão',             1, 3],
    [/(quarta|4\s*[ªa°]?)\s*revis/i,   '4ª revisão',             1, 4],
    [/(terceira|3\s*[ªa°]?)\s*revis/i, '3ª revisão',             2, 5],
    [/(segunda|2\s*[ªa°]?)\s*revis/i,  '2ª revisão',             2, 6],
    [/(primeira|1\s*[ªa°]?)\s*revis/i, '1ª revisão',             3, 7],
    [/[oó]leo|filtro/i,                'Troca de óleo e filtro', 3, 8]
  ];
  var REV_NIVEIS=[
    ['URGENTE','problema aberto ou campanha de fábrica'],
    ['ALTA','carro mais velho, serviço maior, janela de troca'],
    ['MÉDIA','manutenção de rotina'],
    ['BAIXA','carro novo, um lembrete resolve']
  ];
  function revClassifica(texto){
    var t=String(texto||'');
    for(var i=0;i<REV_REGRAS.length;i++){
      if(REV_REGRAS[i][0].test(t))
        return { servico:REV_REGRAS[i][1], nivel:REV_REGRAS[i][2], posicao:REV_REGRAS[i][3] };
    }
    /* ⚠️ Serviço que ninguém reconheceu NÃO vira "revisão" por otimismo: vira
       "a confirmar", em nível médio. Chutar aqui é prometer ao cliente um
       serviço que talvez não seja o dele. */
    return { servico:'Serviço a confirmar', nivel:2, posicao:9 };
  }

  /* -------------------------------------------------------------- O LEITOR */
  function _revLimpaPontas(s){
    return String(s||'').replace(/^[\s\/·\-–—:,]+/,'').replace(/[\s,;·\-]+$/,'').trim();
  }
  function revLer(textoInteiro){
    var linhas=String(textoInteiro||'').split(/\r?\n/);
    var gente=[], fora=[];
    linhas.forEach(function(linha, ordem){
      var bruta=String(linha||'').trim();
      if(!bruta) return;                       /* linha vazia não é ninguém */
      var fs=revFones(bruta);
      if(!fs.length){
        /* 🔴 LINHA SEM TELEFONE NÃO VIRA CLIENTE — e não some. Engolir em
           silêncio é pior do que não ler: a tela diz quantas e quais
           ficaram de fora, pra ele decidir o que fazer com elas. */
        fora.push(bruta); return;
      }
      var nome=revNome(_revLimpaPontas(bruta.slice(0, fs[0].ini)));
      var servicoBruto=_revLimpaPontas(bruta.slice(fs[fs.length-1].fim));
      var c=revClassifica(servicoBruto);
      gente.push({
        ordem:ordem,
        nome:nome||'(sem nome)',
        fone:fs[0].e164, fone_bonito:fs[0].bonito,
        fone2:fs[1]?fs[1].e164:'', fone2_bonito:fs[1]?fs[1].bonito:'',
        servico_bruto:servicoBruto,
        servico:c.servico, nivel:c.nivel, posicao:c.posicao,
        status:'pendente'
      });
    });
    /* 🔴 ORDENAÇÃO: posição crescente e, no empate, a ORDEM ORIGINAL da linha
       colada. Sem o desempate a fila embaralha entre uma leitura e outra, e
       quem decorou "o terceiro é o Fabiano" perde a referência. */
    gente.sort(function(a,b){ return (a.posicao-b.posicao) || (a.ordem-b.ordem); });
    return { gente:gente, fora:fora };
  }

  /* ------------------------------------------------------------------- CSV */
  var REV_CSV_CAB='Name,Given Name,Family Name,Phone 1 - Type,Phone 1 - Value,Phone 2 - Type,Phone 2 - Value,Notes,Group Membership';
  function _revCsvCampo(v){
    var s=String(v==null?'':v);
    return /[",\n\r]/.test(s) ? ('"'+s.replace(/"/g,'""')+'"') : s;
  }
  function revEtiqueta(d){
    d=d||new Date();
    return 'Revisoes '+String(d.getDate()).padStart(2,'0')+'-'+String(d.getMonth()+1).padStart(2,'0');
  }
  function revCsv(lista, quando){
    var et=revEtiqueta(quando);
    var linhas=[REV_CSV_CAB];
    (lista||[]).forEach(function(p){
      var partes=String(p.nome||'').split(' ');
      var primeiro=partes[0]||'', resto=partes.slice(1).join(' ');
      linhas.push([
        p.nome, primeiro, resto,
        'Mobile', p.fone,
        p.fone2?'Mobile':'', p.fone2||'',
        (REV_NIVEIS[p.nivel]||['',''])[0]+' - '+p.servico+' - fila '+(p.fila||''),
        '* myContacts ::: '+et
      ].map(_revCsvCampo).join(','));
    });
    /* 🔴 BOM + CRLF. É o que o contacts.google.com espera: sem o BOM os
       acentos entram tortos, e sem o CRLF ele engasga na importação. As duas
       coisas são invisíveis na tela e só aparecem no destino — por isso o
       teste mede byte a byte. */
    /* ⚠️ O BOM VAI COMO `\uFEFF` ESCRITO, e não como o caractere colado aqui.
       Ele nasceu colado (invisível) e eu troquei de propósito: um byte que
       ninguém enxerga no editor some num apagar sem querer, e o arquivo passa
       a chegar no Google com os acentos tortos sem nenhum sinal de que mudou.
       Escrito assim, o `\uFEFF` é visível, buscável e tem régua. */
    return '\uFEFF'+linhas.join('\r\n')+'\r\n';
  }

  /* ------------------------------------------------------------- MENSAGENS */
  /* v1176 — A abordagem da oficina é curta e única. O serviço continua na
     linha para orientar o vendedor, mas não entra na primeira mensagem: o
     contato abre como conversa, sem promessa de desconto, prazo ou valor. */
  function revMensagem(p){
    var primeiro=String((p&&p.nome)||'').split(' ')[0]||'';
    return 'Olá '+primeiro+'! Angelo da Volkswagen Santa Luzia! tudo bem?';
  }
  function revWaLink(p){
    return 'https://wa.me/'+String((p&&p.fone)||'').replace(/\D/g,'')+'?text='+encodeURIComponent(revMensagem(p));
  }

  /* ==========================================================================
     GRAVAÇÃO OFFLINE-FIRST (a regra da v810)
     --------------------------------------------------------------------------
     🔑 O Angelo usa isto no balcão e no pátio, com sinal ruim.
        · o localStorage é a FONTE DE TRABALHO: grava a cada toque, sem rede;
        · o Supabase é o DESTINO, não a origem;
        · o que veio do banco NUNCA sobrescreve o que ainda não subiu (`_pend`).
        O inverso — banco primeiro — pendura no timeout e a marcação SOME da
        tela: a pessoa toca em "contatado", vê sumir, e toca de novo.
     ========================================================================== */
  var _revLista=[], _revFora=[], _revFiltro=null, _revNuvemIndo=false, _revNuvemMsg='';
  function _revChave(){ try{ return 'mev-revisoes-'+(meuId||'x'); }catch(_){ return 'mev-revisoes-x'; } }
  function revGuardar(){
    try{ localStorage.setItem(_revChave(), JSON.stringify({ lista:_revLista, fora:_revFora })); }catch(_){}
    try{ revSubir(); }catch(_){}
  }
  function revLerGuardado(){
    try{
      var o=JSON.parse(localStorage.getItem(_revChave())||'null');
      if(o && Array.isArray(o.lista)){ _revLista=o.lista; _revFora=Array.isArray(o.fora)?o.fora:[]; }
    }catch(_){}
  }
  /* 🔴 TODO UPDATE PEDE A LINHA DE VOLTA. UPDATE barrado por RLS NÃO é erro no
     supabase-js: volta "sucesso" com ZERO linhas, o app pinta o valor novo e o
     banco fica com o velho (a v483 descobriu isso do jeito caro). Aqui o
     `.select('id')` + a conferência do `data.length` é o que separa "gravou"
     de "achou que gravou". */
  function revConfereGravou(r){
    if(r && r.error) return false;
    var d=(r&&r.data)||[];
    return !!(d && d.length);
  }
  async function revSubir(){
    try{
      if(!(window.supa && meuId)) return;
      var pend=_revLista.filter(function(p){ return p._pend; });
      if(!pend.length) return;
      var lote=(new Date()).toISOString().slice(0,10);
      for(var i=0;i<pend.length;i++){
        var p=pend[i];
        var row={ user_id:meuId, lote:p.lote||lote, nome:p.nome, fone:p.fone, fone2:p.fone2||null,
                  servico_bruto:p.servico_bruto||null, servico:p.servico, nivel:p.nivel,
                  posicao:p.posicao, status:p.status||'pendente',
                  contatado_em:p.contatado_em||null, atualizado_em:(new Date()).toISOString() };
        try{
          var r=await supa.from('revisoes')
            .upsert(row, { onConflict:'user_id,fone,lote' })
            .select('id');
          if(revConfereGravou(r)) delete p._pend;
        }catch(_){ /* sem rede: continua pendente, e é isso que a regra quer */ }
      }
      try{ localStorage.setItem(_revChave(), JSON.stringify({ lista:_revLista, fora:_revFora })); }catch(_){}
    }catch(_){}
  }

  /* v1175 — RECUPERAÇÃO ENTRE DOMÍNIOS, NAVEGADORES E APARELHOS.
     A fila sempre foi enviada para `mp_revisoes`, mas a abertura da aba lia
     somente o localStorage. Como o armazenamento local pertence à origem,
     entrar pelo novo domínio `mevveiculos.com.br` fazia uma lista criada no
     app antigo parecer apagada, mesmo com as linhas preservadas no banco.

     A ordem continua offline-first:
       1. pinta imediatamente o que existe neste aparelho;
       2. tenta subir qualquer alteração local `_pend`;
       3. lê do banco apenas os campos da fila;
       4. restaura o lote mais recente, sem sobrescrever pendência local.
     Nenhuma consulta usa service_role: a RLS existente continua limitando a
     leitura ao `auth.uid()` da sessão. */
  function revFoneBonito(fone){
    var d=String(fone||'').replace(/\D/g,'');
    if(d.length>11 && d.slice(0,2)==='55') d=d.slice(2);
    if(d.length===11) return '('+d.slice(0,2)+') '+d.slice(2,7)+'-'+d.slice(7);
    if(d.length===10) return '('+d.slice(0,2)+') '+d.slice(2,6)+'-'+d.slice(6);
    return String(fone||'');
  }
  function revPessoaDaNuvem(row){
    row=row||{};
    return { id:row.id||null, lote:String(row.lote||''), nome:row.nome||'(sem nome)',
      fone:row.fone||'', fone_bonito:revFoneBonito(row.fone),
      fone2:row.fone2||'', fone2_bonito:revFoneBonito(row.fone2),
      servico_bruto:row.servico_bruto||'', servico:row.servico||'Serviço a confirmar',
      nivel:Number(row.nivel)||0, posicao:Number(row.posicao)||9,
      fila:Number(row.posicao)||0, status:row.status||'pendente',
      contatado_em:row.contatado_em||null, criado_em:row.criado_em||null,
      atualizado_em:row.atualizado_em||null };
  }
  function revLoteMaisNovo(lista){
    return (lista||[]).reduce(function(mx,p){ var l=String((p&&p.lote)||''); return l>mx?l:mx; },'');
  }
  function revMesclarNuvem(rows){
    rows=Array.isArray(rows)?rows:[]; if(!rows.length) return false;
    var nuvem=rows.map(revPessoaDaNuvem);
    var loteN=revLoteMaisNovo(nuvem), loteL=revLoteMaisNovo(_revLista);
    /* Se há trabalho local que ainda não subiu, ele continua sendo a fonte.
       Uma resposta atrasada da rede nunca pode fazê-lo desaparecer. */
    var pend=(_revLista||[]).some(function(p){ return !!(p&&p._pend); });
    if(pend && loteL && loteL!==loteN) return false;
    var lote=(loteL>loteN)?loteL:loteN;
    if(lote===loteL && loteL>loteN) return false;
    var mapa={};
    nuvem.filter(function(p){ return p.lote===lote; }).forEach(function(p){ mapa[String(p.fone||p.id)]=p; });
    (_revLista||[]).filter(function(p){ return String(p.lote||'')===lote; }).forEach(function(p){
      var k=String(p.fone||p.id||'');
      if(p._pend || !mapa[k]) mapa[k]=p;
    });
    var lista=Object.keys(mapa).map(function(k){ return mapa[k]; });
    lista.sort(function(a,b){ return (Number(a.posicao)||9)-(Number(b.posicao)||9); });
    lista.forEach(function(p,i){ p.fila=i+1; });
    if(!lista.length) return false;
    _revLista=lista;
    try{ localStorage.setItem(_revChave(), JSON.stringify({ lista:_revLista, fora:_revFora })); }catch(_){}
    return true;
  }
  async function revCarregarNuvem(){
    if(_revNuvemIndo || !(window.supa && meuId)) return;
    _revNuvemIndo=true; _revNuvemMsg='Buscando sua última lista salva…'; revPinta();
    try{
      await revSubir();
      var q=supa.from('revisoes')
        .select('id,lote,nome,fone,fone2,servico_bruto,servico,nivel,posicao,status,contatado_em,criado_em,atualizado_em')
        .eq('user_id',meuId).order('lote',{ascending:false}).order('posicao',{ascending:true}).limit(1000);
      var r=await withTimeout(q,9000);
      if(r&&r.error) throw r.error;
      revMesclarNuvem((r&&r.data)||[]);
      _revNuvemMsg='';
    }catch(_){
      _revNuvemMsg=_revLista.length
        ? 'Não consegui atualizar pela nuvem agora. A lista deste aparelho foi preservada.'
        : 'Não consegui carregar sua lista salva agora. Tente abrir novamente.';
    }finally{
      _revNuvemIndo=false; revPinta();
    }
  }

  /* ==========================================================================
     A TELA
     ========================================================================== */
  function _revPend(){ return _revLista.filter(function(p){ return p.status!=='contatado'; }); }
  function _revContaNivel(n){ return _revPend().filter(function(p){ return p.nivel===n; }).length; }

  function revPainelHtml(){
    return '<div class="rev-wrap" id="revWrap">'+
      '<div class="rev-placares" id="revPlacares" role="group" aria-label="Filtrar por prioridade">'+
        REV_NIVEIS.map(function(nv,i){
          return '<button type="button" class="rev-pl rev-pl-'+i+'" data-rev-nivel="'+i+'" aria-pressed="false">'+
            '<b class="rev-pl-n">0</b><span class="rev-pl-t">'+esc(nv[0])+'</span>'+
            '<small>'+esc(nv[1])+'</small></button>';
        }).join('')+
      '</div>'+
      '<div class="rev-acoes">'+
        '<button type="button" class="rev-bt rev-bt-1" id="revCsvBt">Gerar CSV para os contatos</button>'+
        '<button type="button" class="rev-bt" id="revFonesBt">Copiar só os telefones</button>'+
        '<button type="button" class="rev-bt" id="revLimparBt">Limpar marcações</button>'+
        '<span class="rev-conta" id="revConta" aria-live="polite"></span>'+
      '</div>'+
      '<details class="rev-colar" id="revColar">'+
        '<summary>Colar a lista do agendamento</summary>'+
        '<p class="rev-ajuda">Cole o texto como ele vem — um cliente por linha, com nome, telefone e o serviço. O MEV separa sozinho, formata o telefone e classifica a prioridade. Dois telefones na mesma linha (separados por /) também funcionam.</p>'+
        '<textarea id="revTexto" class="rev-ta" rows="7" placeholder="NOME DO CLIENTE 51999999999 segunda revisao"></textarea>'+
        '<button type="button" class="rev-bt rev-bt-1" id="revLerBt">Ler a lista</button>'+
      '</details>'+
      '<div class="rev-aviso" id="revAviso" role="status" aria-live="polite"></div>'+
      '<div class="rev-fila" id="revFila"></div>'+
      '<div class="rev-rodape">'+
        '<b>Como a fila é ordenada</b>'+
        '<span>1. Diagnóstico em aberto e recall vêm primeiro — é problema ou campanha de fábrica.</span>'+
        '<span>2. Depois as revisões, da 5ª para a 1ª: quanto mais velho o carro, maior o serviço.</span>'+
        '<span>3. Troca de óleo e serviços de rotina fecham a fila.</span>'+
        '<span>4. Empate mantém a ordem em que o cliente apareceu na lista colada.</span>'+
      '</div>'+
    '</div>';
  }

  function revPinta(){
    var fila=$('revFila'); if(!fila) return;
    /* placares */
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-nivel]'),function(b){
      var n=Number(b.getAttribute('data-rev-nivel'));
      var c=b.querySelector('.rev-pl-n'); if(c) c.textContent=String(_revContaNivel(n));
      var on=(_revFiltro===n);
      b.classList.toggle('on',on); b.setAttribute('aria-pressed',on?'true':'false');
    });
    var cc=$('revConta');
    if(cc) cc.textContent=_revLista.length ? (_revPend().length+' de '+_revLista.length+' ainda por contatar') : '';
    var av=$('revAviso');
    if(av){
      var avisos=[];
      if(_revFora.length) avisos.push(_revFora.length+' linha'+(_revFora.length>1?'s':'')+' sem telefone ficou de fora: '+_revFora.slice(0,3).join(' · ')+(_revFora.length>3?' …':''));
      if(_revNuvemMsg) avisos.push(_revNuvemMsg);
      av.textContent=avisos.join(' ');
    }

    var lista=_revLista.filter(function(p){ return _revFiltro==null || p.nivel===_revFiltro; });
    if(!lista.length){
      /* ⚠️ VAZIO NUNCA É TELA BRANCA — a regra da casa. */
      fila.innerHTML='<div class="rev-vazio">'+(_revLista.length
        ? 'Nenhum cliente neste nível. Toque de novo no placar para ver todos.'
        : 'Nenhum cliente na fila. Abra "Colar a lista do agendamento" acima e cole o texto.')+'</div>';
      return;
    }
    var nivelAtual=-1, html='';
    lista.forEach(function(p,i){
      if(p.nivel!==nivelAtual){
        nivelAtual=p.nivel;
        html+='<div class="rev-grupo rev-g-'+p.nivel+'">'+esc((REV_NIVEIS[p.nivel]||[''])[0])+'</div>';
      }
      var fones=esc(p.fone_bonito||p.fone)+(p.fone2?(' · '+esc(p.fone2_bonito||p.fone2)):'');
      html+='<div class="rev-linha'+(p.status==='contatado'?' feito':'')+'" data-rev-i="'+_revLista.indexOf(p)+'">'+
        '<span class="rev-pos">'+(i+1)+'</span>'+
        '<div class="rev-quem"><b>'+esc(p.nome)+'</b><span>'+fones+'</span>'+
          '<i class="rev-tag">'+esc(p.servico)+'</i></div>'+
        '<div class="rev-bts">'+
          '<button type="button" class="rev-ic rev-ic-wa" data-rev-wa="'+_revLista.indexOf(p)+'" aria-label="Contatar '+esc(p.nome)+' pelo WhatsApp" title="Contatar pelo WhatsApp">'+_REV_ICO.wa+'</button>'+
        '</div>'+
        /* 🔴 v1075 — O "CONTATADO" VIROU CAMPO, NÃO BOTÃO.
           Pedido: "um campo pra flegar quando já tiver sido contatado". Era
           um botão redondo com aria-pressed — o estado existia, mas só a cor
           contava. Agora é uma CAIXA DE MARCAR de verdade, com a palavra
           "Contatado" do lado: dá pra ver marcado sem saber ler a cor, o Tab
           chega nele, a barra de espaço marca, e o leitor de tela diz
           "caixa de seleção, marcada".
           ⚠️ O `data-rev-ok` continua sendo o nome do punho — o caminho que
              grava (p.status / p.contatado_em / revGuardar) é o MESMO da
              v1071, não nasceu um segundo jeito de marcar contatado. */
        '<label class="rev-flag'+(p.status==='contatado'?' on':'')+'">'+
          '<input type="checkbox" class="rev-flag-cx" data-rev-ok="'+_revLista.indexOf(p)+'"'+(p.status==='contatado'?' checked':'')+' aria-label="Marcar '+esc(p.nome)+' como contatado">'+
          '<span>Contatado</span>'+
        '</label>'+
      '</div>';
    });
    fila.innerHTML=html;
    revWireFila();
  }
  /* v1176 — um único atalho por cliente, com o símbolo canônico do WhatsApp.
     Copiar telefone e copiar mensagem saíram desta linha para que a ação
     principal não precise ser descoberta por tentativa e erro. */
  var _REV_ICO={
    wa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.5 9.5 9.5 0 0 1-4-.9L3 21l1.6-4.6A8.5 8.5 0 1 1 21 11.5z"/><path d="M8.7 8.3c.2 3 2 5 5 6"/></svg>'
  };

  /* ⚠️ O caminho VELHO do copiar vai junto: o `navigator.clipboard` falha em
     contexto não seguro e em alguns WebViews — e falha CALADO. */
  function revCopiar(txt){
    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(txt).then(function(){ toast('Copiado ✓'); },function(){ _revCopiaVelha(txt); });
        return;
      }
    }catch(_){}
    _revCopiaVelha(txt);
  }
  function _revCopiaVelha(txt){
    try{
      var ta=document.createElement('textarea'); ta.value=txt;
      ta.style.position='fixed'; ta.style.left='-9999px';
      document.body.appendChild(ta); ta.select();
      var ok=document.execCommand('copy'); ta.remove();
      toast(ok?'Copiado ✓':'Não consegui copiar.');
    }catch(_){ toast('Não consegui copiar.'); }
  }

  function revWireFila(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-wa]'),function(b){
      b.onclick=function(){ var p=_revLista[Number(b.getAttribute('data-rev-wa'))]; if(!p) return;
        try{ window.open(revWaLink(p),'_blank'); }catch(_){ location.href=revWaLink(p); } };
    });
    /* ⚠️ `onchange` E NÃO `onclick`: numa caixa de marcar o clique pode vir do
       teclado (barra de espaço) ou de um clique no texto do <label>, e nem
       todo navegador dispara `click` no input nesses dois caminhos. O
       `change` dispara nos três. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-ok]'),function(b){
      b.onchange=function(){
        var p=_revLista[Number(b.getAttribute('data-rev-ok'))]; if(!p) return;
        p.status=b.checked?'contatado':'pendente';
        p.contatado_em=(p.status==='contatado')?(new Date()).toISOString():null;
        p._pend=1; revGuardar(); revPinta();
      };
    });
  }

  function revWire(){
    var w=$('revWrap'); if(!w || w._lig) return; w._lig=1;
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-nivel]'),function(b){
      b.onclick=function(){
        var n=Number(b.getAttribute('data-rev-nivel'));
        _revFiltro=(_revFiltro===n)?null:n;   /* tocar de novo desliga */
        revPinta();
      };
    });
    var ler=$('revLerBt');
    if(ler) ler.onclick=function(){
      var t=(($('revTexto')||{}).value)||'';
      var r=revLer(t);
      if(!r.gente.length){ toast('Não achei telefone nenhum nesse texto.'); return; }
      var lote=(new Date()).toISOString().slice(0,10);
      r.gente.forEach(function(p,i){ p.fila=i+1; p.lote=lote; p._pend=1; });
      _revLista=r.gente; _revFora=r.fora; _revFiltro=null;
      revGuardar(); revPinta();
      try{ var d=$('revColar'); if(d) d.open=false; }catch(_){}   /* fecha sozinho */
      toast(r.gente.length+' cliente(s) na fila ✓');
    };
    var csv=$('revCsvBt');
    if(csv) csv.onclick=function(){
      /* entram SÓ os pendentes, e SÓ do filtro que estiver ligado */
      var lista=_revPend().filter(function(p){ return _revFiltro==null || p.nivel===_revFiltro; });
      if(!lista.length){ toast('Não há ninguém pendente pra exportar.'); return; }
      var hoje=new Date();
      var nome='revisoes-contatos-'+String(hoje.getDate()).padStart(2,'0')+'-'+String(hoje.getMonth()+1).padStart(2,'0')+'.csv';
      try{
        var b=new Blob([revCsv(lista,hoje)],{type:'text/csv;charset=utf-8'});
        var u=URL.createObjectURL(b), a=document.createElement('a');
        a.href=u; a.download=nome; document.body.appendChild(a); a.click();
        setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){} },800);
        var av=$('revAviso');
        if(av) av.innerHTML='<b>Arquivo gerado: '+esc(nome)+'</b>'+
          '<span>1. No computador, abra contacts.google.com → Importar → escolha o arquivo.</span>'+
          '<span>2. Os contatos entram com a etiqueta "'+esc(revEtiqueta(hoje))+'".</span>'+
          '<span>3. No celular: WhatsApp → nova conversa → os nomes já aparecem. Para falar com todos de uma vez, crie uma lista de transmissão com essa etiqueta.</span>';
      }catch(_){ toast('Não consegui gerar o arquivo.'); }
    };
    var fn=$('revFonesBt');
    if(fn) fn.onclick=function(){
      var lista=_revPend().filter(function(p){ return _revFiltro==null || p.nivel===_revFiltro; });
      if(!lista.length){ toast('Não há ninguém pendente.'); return; }
      revCopiar(lista.map(function(p){ return p.fone; }).join('\n'));
    };
    var lp=$('revLimparBt');
    if(lp) lp.onclick=function(){
      _revLista.forEach(function(p){ if(p.status==='contatado'){ p.status='pendente'; p.contatado_em=null; p._pend=1; } });
      revGuardar(); revPinta();
    };
  }

  /* CSS pelo módulo, NÃO no styles.css: o styles.css é compartilhado por todas
     as conversas, e mexer nele obriga a bumpar o carimbo à mão (lição v918). */
  var REV_CSS=''+
  '#revWrap{display:block}'+
  '.rev-placares{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px;margin-bottom:12px}'+
  '.rev-pl{display:flex;flex-direction:column;gap:2px;min-height:64px;padding:10px 12px;border:1.5px solid #dbe2ec;border-radius:10px;background:#fff;text-align:left;font:inherit;cursor:pointer}'+
  '.rev-pl .rev-pl-n{font-size:20px;font-weight:800;line-height:1}'+
  '.rev-pl .rev-pl-t{font-size:12px;font-weight:800;letter-spacing:.4px}'+
  '.rev-pl small{font-size:11px;color:#64748b;line-height:1.25}'+
  '.rev-pl-0{border-color:#fecaca}.rev-pl-0 .rev-pl-n,.rev-pl-0 .rev-pl-t{color:#b91c1c}'+
  '.rev-pl-1{border-color:#fed7aa}.rev-pl-1 .rev-pl-n,.rev-pl-1 .rev-pl-t{color:#b45309}'+
  '.rev-pl-2{border-color:#bfdbfe}.rev-pl-2 .rev-pl-n,.rev-pl-2 .rev-pl-t{color:#0a4da6}'+
  '.rev-pl-3{border-color:#e2e8f0}.rev-pl-3 .rev-pl-n,.rev-pl-3 .rev-pl-t{color:#475569}'+
  '.rev-pl.on{box-shadow:inset 0 0 0 2px currentColor}'+
  '.rev-acoes{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin-bottom:12px}'+
  '.rev-bt{min-height:42px;padding:0 14px;border:1.5px solid #dbe2ec;border-radius:10px;background:#fff;color:#001e50;font-size:13px;font-weight:700;cursor:pointer}'+
  '.rev-bt-1{background:#0a4da6;border-color:#0a4da6;color:#fff}'+
  '.rev-conta{margin-left:auto;font-size:12.5px;color:#475569;font-weight:700}'+
  '.rev-colar{border:1.5px solid #dbe2ec;border-radius:10px;padding:10px 12px;margin-bottom:12px;background:#f8fafc}'+
  '.rev-colar>summary{cursor:pointer;font-weight:800;color:#001e50;min-height:32px;display:flex;align-items:center}'+
  '.rev-ajuda{margin:8px 0;font-size:12.5px;color:#475569;line-height:1.45}'+
  '.rev-ta{width:100%;box-sizing:border-box;border:1.5px solid #dbe2ec;border-radius:8px;padding:10px;font:inherit;font-size:13px;margin-bottom:8px}'+
  '.rev-aviso{font-size:12.5px;color:#b45309;margin-bottom:10px;display:flex;flex-direction:column;gap:3px}'+
  '.rev-aviso:empty{display:none}'+
  '.rev-aviso b{color:#166534}'+
  '.rev-grupo{margin:14px 0 6px;font-size:11.5px;font-weight:800;letter-spacing:.5px;color:#475569}'+
  /* v1178 — grade estável no celular. Número, dados, WhatsApp e estado têm
     posições próprias; nomes longos não empurram os controles para lugares
     diferentes e o card não ganha altura vazia por causa do flex-wrap. */
  '.rev-linha{display:grid;grid-template-columns:28px minmax(0,1fr) auto;grid-template-areas:"pos quem acao" "pos quem estado";align-items:center;column-gap:12px;row-gap:8px;min-height:108px;padding:13px 12px;border:1px solid #e6edf6;border-radius:14px;margin-bottom:8px;background:#fff}'+
  '.rev-linha.feito{opacity:1;background:#f7fcf9;border-color:#d7efe0}'+
  '.rev-linha.feito .rev-quem b{color:#526579}'+
  '.rev-linha.feito .rev-quem span{color:#718096}'+
  '.rev-linha.feito .rev-tag{color:#4f8a68}'+
  '.rev-pos{grid-area:pos;align-self:center;width:28px;text-align:center;font-weight:800;color:#94a3b8;font-size:13px}'+
  '.rev-quem{grid-area:quem;min-width:0;display:flex;flex-direction:column;gap:2px}'+
  '.rev-quem b{font-size:14px;color:#001e50;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'+
  '.rev-quem span{font-size:12px;color:#475569}'+
  '.rev-tag{font-style:normal;font-size:11px;font-weight:700;color:#0a4da6}'+
  '.rev-bts{grid-area:acao;justify-self:end;display:flex}'+
  '.rev-ic{width:44px;height:44px;display:flex;align-items:center;justify-content:center;border:1.5px solid #dbe2ec;border-radius:10px;background:#fff;color:#0a4da6;cursor:pointer}'+
  '.rev-ic svg{width:20px;height:20px}'+
  '.rev-ic-wa{color:#15803d;border-color:#bbf7d0;background:#f0fdf4}'+
  '.rev-ic.on{background:#dcfce7;border-color:#86efac;color:#15803d}'+
  /* v1075 — o campo de flegar. Tamanho de alvo de dedo (38px de altura) e a
     PALAVRA junto, pra não depender de verde-contra-branco. */
  '.rev-flag{grid-area:estado;justify-self:end;margin:0;display:inline-flex;align-items:center;gap:7px;min-height:44px;padding:0 11px;border:1.5px solid #dbe2ec;border-radius:10px;background:#fff;color:#475569;font-size:12.5px;font-weight:700;cursor:pointer;-webkit-user-select:none;user-select:none}'+
  '.rev-flag input{width:17px;height:17px;margin:0;accent-color:#15803d;cursor:pointer;flex:none}'+
  '.rev-flag.on{background:#dcfce7;border-color:#86efac;color:#15803d}'+
  '.rev-flag:focus-within{outline:2px solid #0a4da6;outline-offset:2px}'+
  /* v1075 — página exclusiva: o que é de Leads sai de cena enquanto as
     revisões estão abertas. Preso ao `crm-on` de propósito: fora da página
     de Leads esta regra não tem o que esconder. */
  /* 🔴🔴🔴 v1075 — O ACHADO QUE SÓ APARECEU MEDINDO: A LISTA DE LEADS NUNCA
     SUMIU NO COMPUTADOR. A v1071 escondia a `.crm` por estilo em linha
     (`crm.style.display='none'`). Só que o styles.css tem, desde a v375:

         @media(min-width:980px){ .crm{display:block !important} }

     e `!important` de folha GANHA de estilo em linha sem `!important`. Ou
     seja: em qualquer tela de 980px pra cima — o computador do Angelo — a
     aba "Revisões" mostrava a fila das revisões E a lista de leads junto,
     uma embaixo da outra. No celular funcionava, e por isso passou.
     ⚠️ A régua desta versão mede a 1280px de propósito. Se ela medisse só no
        celular, diria verde com o defeito na tela. */
  'body.crm-on.rev-pagina #secoes .crm{display:none!important}'+
  'body.crm-on.rev-pagina .crm-carteira-nota{display:none}'+
  'body.crm-on.rev-pagina #crmFicha{display:none}'+
  /* v1178 — na página de Revisões, Voltar, Início e Conversas já existem no
     drawer. Só o FAB Menu permanece sobre o conteúdo, como nas edições
     Consultas e Avaliações; ações específicas continuam dentro dos cards. */
  'body.crm-on.rev-pagina .fab-row{left:auto!important;right:14px!important;width:56px!important;min-width:56px!important;height:56px!important;margin:0!important;padding:0!important;gap:0!important;border:0!important;border-radius:50%!important;background:transparent!important;box-shadow:none!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;overflow:visible!important}'+
  'body.crm-on.rev-pagina .fab-row .menu-fab:not(#btnMenuFab){display:none!important}'+
  'body.crm-on.rev-pagina .fab-row #btnMenuFab{display:flex!important;width:56px!important;height:56px!important;min-width:56px!important;flex:0 0 56px!important;background:linear-gradient(160deg,#2b7bf3,#1565d8)!important;box-shadow:0 7px 20px rgba(21,101,216,.36)!important}'+
  '.rev-vazio{padding:22px 12px;text-align:center;color:#64748b;font-size:13px}'+
  '.rev-rodape{margin-top:18px;padding-top:14px;border-top:1px solid #e6edf6;display:flex;flex-direction:column;gap:3px;font-size:12px;color:#64748b}'+
  '.rev-rodape b{color:#001e50;font-size:12.5px;margin-bottom:2px}';
  function revCssGarante(){
    try{
      if(document.getElementById('revCss')) return;
      var st=document.createElement('style'); st.id='revCss'; st.textContent=REV_CSS;
      document.head.appendChild(st);
    }catch(_){}
  }

  /* ---------------------------------------------------------------- A ABA */
  /* ⚠️ Esconder/mostrar por `style.display`, NÃO por `[hidden]`: o atributo
     perde para o display do autor, e as réguas medem `getComputedStyle`
     (armadilha da v736). */
  /* 🔴🔴🔴 v1075 — A PÁGINA DAS REVISÕES É DAS REVISÕES, E DE MAIS NADA.
     Pedido do Angelo: "deixe a página dos contatos de revisão exclusivo pra
     revisão". Na v1071 as revisões eram HÓSPEDE da página de Leads: o título
     continuava dizendo "Leads", a nota da carteira de clientes continuava na
     tela e o botão flutuante continuava sendo "Novo lead" — que não tem nada
     a ver com ligar pra quem tem revisão vencida.
     Agora, com as revisões abertas:
       · o título da página passa a ser "Revisões da oficina";
       · a nota da carteira de leads sai;
       · o botão flutuante de "Novo lead" sai (e VOLTA ao ir pra Leads).
     ⚠️ O QUE **NÃO** SAI: o botão de voltar e o alternador Leads | Revisões.
        Página exclusiva não pode virar página sem saída.
     ⚠️ E NADA É REMOVIDO DO DOM: é `display`/classe. O que o autosave e os
        punhos do CRM leem continua existindo, que é a regra da casa. */
  function _revCtxGuarda(){
    try{
      var af=$('btnAcaoFab'); if(!af) return;
      if(!af._revSalvo){
        var ic=af.querySelector('.af-ic');
        af._revSalvo={ ico:(ic?ic.innerHTML:''), fn:af._fn };
      }
      mevCtx(null);
    }catch(_){}
  }
  function _revCtxVolta(){
    try{
      var af=$('btnAcaoFab'); if(!af || !af._revSalvo) return;
      var g=af._revSalvo; af._revSalvo=null;
      if(g.ico) mevCtx(g.ico,'Novo',g.fn);
    }catch(_){}
  }
  function _revTitulo(rev){
    try{
      var h=document.querySelector('#secoes .crm-pg>h2'); if(!h) return;
      if(rev){ if(h._revAntes==null) h._revAntes=h.textContent; h.textContent='Revisões da oficina'; }
      else if(h._revAntes!=null){ h.textContent=h._revAntes; h._revAntes=null; }
    }catch(_){}
  }
  function revAbaIr(qual){
    var crm=document.querySelector('#secoes .crm'), pan=$('revPainel');
    if(!crm || !pan) return;
    var rev=(qual==='revisoes');
    crm.style.display=rev?'none':'';
    pan.style.display=rev?'':'none';
    Array.prototype.forEach.call(document.querySelectorAll('#revTgl .hh-tg'),function(b){
      var on=((b.getAttribute('data-rv')||'')===(rev?'revisoes':'leads'));
      b.classList.toggle('on',on); b.setAttribute('aria-selected',on?'true':'false');
    });
    try{ document.body.classList.toggle('rev-pagina', rev); }catch(_){}
    _revTitulo(rev);
    if(rev){ _revCtxGuarda(); revCssGarante(); revLerGuardado(); revPinta(); revWire(); revCarregarNuvem(); }
    else { _revCtxVolta(); }
  }
  function revAbaMontar(){
    /* ⚠️ A CLASSE MORRE AQUI, NÃO NO "VOLTAR". Esta função roda toda vez que
       a página de Leads é aberta. Se a marca `rev-pagina` tivesse ficado de
       uma visita anterior, o Angelo abriria Leads com a nota da carteira
       escondida e sem o botão de Novo lead — e sem nada na tela explicando
       por quê. Zerar na entrada é mais barato que caçar cada saída. */
    try{ document.body.classList.remove('rev-pagina'); }catch(_){}
    var alvo=document.querySelector('#secoes .crm'); if(!alvo || $('revTgl')) return;
    var tg=document.createElement('div');
    tg.className='hh-toggle'; tg.id='revTgl'; tg.style.marginBottom='10px';
    tg.setAttribute('role','tablist');
    tg.innerHTML='<button type="button" class="hh-tg on" data-rv="leads" role="tab" aria-selected="true">Leads</button>'+
                 '<button type="button" class="hh-tg" data-rv="revisoes" role="tab" aria-selected="false">Revisões</button>';
    alvo.parentNode.insertBefore(tg, alvo);
    var pan=document.createElement('div');
    pan.id='revPainel'; pan.style.display='none'; pan.innerHTML=revPainelHtml();
    alvo.parentNode.insertBefore(pan, alvo.nextSibling);
    Array.prototype.forEach.call(tg.querySelectorAll('.hh-tg'),function(b){
      b.onclick=function(){ revAbaIr(b.getAttribute('data-rv')); };
    });
  }

/* ╔═══ src/app/13-abrir-avaliacao.js ═════════════════════════════════════ */
  /* ============ GERAR AVALIAÇÃO DE SEMINOVO (a partir da consulta) ============ */
  /* ⛳ v519 (pedido do Angelo, 16/08): "oculta do app o laudo para o cliente".
     false = o botão "📄 Enviar laudo pro cliente" NÃO aparece na aba Cotação
     repasse (o 07-avaliacao.js lê esta variável ao montar a tela).
     🔴 A PÁGINA CONTINUA DE PÉ: quem já recebeu o link `?laudo=1` continua
     abrindo normalmente, e o `avLaudoAbrir`/`_avLaudoLink`/`_avLaudoMostrar`
     seguem aqui, intactos. Isto fecha a porta dentro do app; não mata o
     recurso. Pra ligar de volta é uma palavra: true. */
  /* ⛳ v559 — quantos itens da ficha cabem na mensagem do WhatsApp antes de
     virar lista de supermercado. O que passar é contado ("+N"), nunca some
     calado. Opcionais têm teto maior: são eles que mudam o preço. */
  var FICHA_MSG_SERIE = 10;
  var FICHA_MSG_OPC   = 8;

  var MEV_LAUDO = false;

  /* ⛳ v582 — O LINK MORA NA "COTAÇÃO REPASSE", e só lá.
     false = depois de "Gerar / atualizar link", a aba **Cotação da loja** não
     desenha mais a caixa verde ("Link pronto! Mande pros lojistas" + Repasse +
     WhatsApp). Ela era a mesma porta da aba de repasse, repetida.
     🔴 NADA foi apagado: o link continua sendo criado e salvo igual, o
     `_avLojUrl` existe, e o `avEnviarRepAbrir` segue vivo lá na Cotação
     repasse. Isto esconde a porta; o cômodo continua. Pra ligar: true. */
  var LINK_NA_COTLOJA = false;

  var _avFotos=[], _avLojUrl='', _avLojId='', _avFotosCloudTimer=null;
  var _avFotosEst=[];   /* v815: as fotos do MESMO carro no estoque (espelho) */
  /* 🔴 v719 (pedido: "abrir uma avaliação [da tela de Avaliações] e fechar ou
     salvar... tá indo pra tela da consulta") — de ONDE a avaliação foi
     aberta. A setinha de voltar já respeitava a origem (v401, voltarTab);
     o "Salvar e fechar" não: v243 mandava SEMPRE pro menu do veículo.
     Quem abre pela LISTA (avlAbrir, no 05c) escreve 'avaliacoes' aqui;
     o abrirAvaliacaoLojista zera na entrada — origem não vaza de uma
     abertura pra outra. */
  var _avVoltarPara='';
  /* v564: "pedir também as fotos ao cliente" — a caixinha da folha do
     "Pedir ao cliente". Nasce marcada só quando a avaliação AINDA NÃO TEM
     foto nenhuma: pedir foto pra quem já mandou é o tipo de mensagem que
     ensina o cliente a ignorar as próximas. */
  var _avPedirFotos=false;
  var ICO_AV='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>';
  var ICO_CLIP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12l2 2 4-4"/></svg>';
  function avSel(id,label,opts){ return '<div><div class="avt-lbl">'+esc(label)+'</div><select id="'+id+'" class="avt-in avt-sel">'+opts.map(function(o){return '<option>'+esc(o)+'</option>';}).join('')+'</select></div>'; }
  /* ===== v270 (pedido) — QUEM JÁ MANDOU O LINK VOLTA AO BLOCO DE REPASSE ===
     A avaliação sempre abria em "Dados veículo", que é onde ela COMEÇA. Mas
     depois que o link já foi pros lojistas, o assunto muda: agora é preço,
     publicação e as ofertas que chegaram — desde a v1448, tudo na Avaliação.
     A pessoa tinha que deslizar por seis abas toda vez que voltava no carro.

     Guardo uma marca por PLACA no próprio aparelho quando o link é gerado.
     Sem placa não há marca, e aí segue abrindo em "Dados veículo" como antes. */
  function _avLinkKey(placa){ return 'mev_avlink:'+String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function _avLinkJaEnviado(placa){
    try{ return !!localStorage.getItem(_avLinkKey(placa)); }catch(_){ return false; }
  }
  function _avLinkMarcar(placa){
    try{ if(placa) localStorage.setItem(_avLinkKey(placa), String(Date.now())); }catch(_){}
  }
  /* v364: aceita dizer em QUAL ABA abrir. Sem dizer nada, tudo como antes —
     é assim que o menu do + manda ir direto pras Fotos. */
  function abrirAvaliacaoLojista(abaInicial){
    /* ======================================================================
       🔴🔴 v1050 — A PORTA ÚNICA DAS AVALIAÇÕES
       ----------------------------------------------------------------------
       Pedido do Angelo (16/09): "nem acessar o mev avaliacoes de dentro da
       consulta no mev consultas (vai ficar disponível só no mev avaliacoes)".

       🔑 O PORTÃO FICA AQUI, NA PORTA, E NÃO EM CADA CAMPAINHA. Esta função
       é chamada de DEZESSEIS lugares diferentes (o gesto do 18b, o menu do +,
       o card da consulta, o portal de repasse, a importação do Avaliex, o
       link de abertura do 19…). Barrar em cada um seria escrever a mesma
       regra dezesseis vezes e esquecê-la na décima sétima — que é exatamente
       como o gesto do deslize escapou: ele nasceu na v263, antes das edições
       existirem, e nunca ninguém voltou pra ensiná-lo sobre elas.

       ⚠️ QUEM RESPONDE É O `edPode`, o mesmo portão que nunca explode da
       v918: sem a função, ele diz SIM. Uma trava que fecha por acidente
       esconderia as Avaliações do app que as vende.

       ⚠️ E ELA NÃO RECLAMA. Quem chegou aqui por um gesto não pediu nada —
       um aviso seria o app repreendendo a pessoa por um movimento do dedo.
       Ela simplesmente não sai do lugar, que é o que se espera de um gesto
       que não tem destino.
       ====================================================================== */
    try{ if(typeof edPode==='function' && !edPode('avaliacoes')) return; }catch(_){}
    avAreaMarcar('avaliacoes');
    mevTabSet(''); _avFotos=[]; _avFotosEst=[]; _avLojUrl=''; _avLojId=''; _avLojSalvo='';   /* v384 · v815 */
    _avVoltarPara='';   /* v719: quem abriu pela lista escreve depois */
    try{ if(typeof avvAoAbrirAvaliacao==='function') avvAoAbrirAvaliacao(); }catch(_){}   /* v679 */
    try{ if(typeof avmAoAbrirAvaliacao==='function') avmAoAbrirAvaliacao(); }catch(_){}   /* v892 — a galeria de marketing */
    _avPedirFotos=false;   /* v564 */
    _avTab = (typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia') ? 'dados' : (abaInicial || 'dados');
    try{ clearTimeout(_avFotosCloudTimer); }catch(_){}
    document.body.classList.add('venda-cot');
    var v=veiculoAtual; if(!v) return abrirMenu();
    var _anoAv=(v.ano&&v.ano_modelo&&String(v.ano)!==String(v.ano_modelo))?(v.ano+'/'+v.ano_modelo):(v.ano_modelo||v.ano||'');
    var head='<div class="av-hd"><span class="av-hd-ic">'+ICO_CLIP+'</span><div class="av-hd-tx"><h2>Avaliação — '+esc(v.placa||'')+'</h2><p>'+esc(((v.marca||'')+' '+(v.modelo||'')).trim())+(_anoAv?' · '+esc(_anoAv):'')+'</p></div></div>';
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg">'+head+avaliacaoFormHtml(v)+'<input type="file" id="avFotoInput" accept="image/*" multiple style="display:none">'+'</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    atrelarAvaliacao(v);
    avTabsWire();
    avFotosRestaurar(); avFotosPinta();
    document.body.classList.add('oper-on','dock-barra');
    try{ consultaUiDockMedir(); }catch(_){}
    $('avFotoInput').onchange=function(){ var fs=Array.prototype.slice.call(this.files); this.value=''; avAddFotos(fs); };
    $('avBtnVer').onclick=function(){ avLojAbrir('page'); };
    /* ⚠️ v1063 — GUARDA, porque o botão pode não existir mais.
       O `$()` devolve null quando o elemento saiu, e `null.onclick=` estoura
       — derrubando a abertura da avaliação INTEIRA, não só o botão. */
    (function(){ var b=$('avBtnWa'); if(b) b.onclick=function(){ avLojAbrir('wa'); }; })();
    /* 🔁 v558: o botão virou "Avisar lojistas" (a folha da v514, porta C).
       ⚠️ O `avEnviarRepAbrir` (a lista de WhatsApp um a um) NÃO foi apagado
       — fica de reserva, como o /admin da v513. Sem o 18f no build, o
       typeof cai nele e nada quebra. */
    (function(){ var b=$('avBtnRep'); if(!b) return;   /* v1063: mesma guarda */
      b.onclick=(typeof avisarLojistasAbrir==='function')
        ? avAvisarLojistasAbrir : avEnviarRepAbrir; })();
    (function(){ var _bl=$('avBtnLaudo'); if(_bl) _bl.onclick=avLaudoAbrir; })();   /* v494 */
    /* v656 — a arte a partir da avaliação. As fotos são as da PRÓPRIA
       avaliação (_avFotos), não as do estoque: o carro pode nem estar
       cadastrado ainda — é exatamente esse o caso de uso. */
    (function(){ var _ba=$('avBtnArte'); if(!_ba) return; _ba.onclick=function(){
      var _v=veiculoAtual||{};
      arteAbrir({
        marca:_v.marca||'', modelo:_v.modelo||'', ano:_v.ano||'', ano_modelo:_v.ano_modelo||_v.ano||'',
        fotos:(_avFotos||[]).slice(), extras:{ fipe:{ valor:Number(_v.fipe)||0 } }
      }, 'avaliacao');
    }; })();
    /* v243: salva o rascunho + espelho e volta pra tela do veículo */
    var _bf=$('avBtnFechar'); if(_bf) _bf.onclick=function(){ /* v1481: o mesmo salvamento completo usado ao sair sem foto. `fotos:[]` é um estado válido, não uma trava. */ try{ avAvaliacaoSalvarCompleta(); }catch(_){} toast('Avaliação salva.'); /* v719: quem veio da LISTA volta pra lista; da consulta, pro menu do veículo (v243) */ try{ if(_avVoltarPara==='avaliacoes' && typeof telaAvaliacoes==='function'){ telaAvaliacoes(); } else { abrirMenu(); } }catch(_){ voltarHome(); } /* v486 — edição Avalia: porta "Comprou? → MEV Estoque" (1x por sessão) */ try{ if(typeof window.edPortaFimAvalia==='function') window.edPortaFimAvalia(); }catch(_){} };
    /* v1481 — esta substituição é o ponto que fazia o MEV Avaliações perder a
       ficha sem fotos: ela trocava o handler completo por `voltarHome`, então
       só uma alteração na galeria acabava criando a linha. Mantém o destino
       especial da edição, mas salva antes de navegar. */
    if(_bf && typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia') _bf.onclick=function(){
      try{ avAvaliacaoSalvarCompleta(); }catch(_){}
      toast('Avaliação salva.');
      voltarHome();
    };
    /* v242: alienado — pergunta quem quita e o valor só quando "Sim" */
    (function(){
      var a=$('avAlien'), box=$('avAlienBox'), vv=$('avAlienValor'); if(!a||!box) return;
      function mostra(){ box.style.display=(a.value==='Sim')?'':'none'; }
      a.addEventListener('change',function(){ mostra(); try{ avFormSalvar(); }catch(_){} });
      if(vv) vv.addEventListener('input',avMaskRS);
      mostra();
      /* o rascunho restaurado pode ja vir com "Sim" — reconfere depois */
      setTimeout(mostra,0);
    })();
    /* v240: garantia de fábrica — mostra a data só quando "Tem" */
    (function(){
      var g=$('avGarantia'), box=$('avGarantiaAteBox'), dt=$('avGarantiaAte'); if(!g||!box) return;
      function mostra(){ box.style.display=(g.value==='Tem')?'':'none'; }
      g.addEventListener('change',function(){ mostra();
        /* v242: marcou "Tem" -> margem vai pra "Sem custo"; desmarcou -> volta
           pro percentual padrão. Depois disso o lojista muda se quiser. */
        try{ var s=$('avMg'); if(s){ if(this.value==='Tem'){ s.value='0'; } else if(s.value==='0'){ var d=String((_avPcts().garantia)||5); s.value=Array.prototype.some.call(s.options,function(o){ return o.value===d; })?d:'5'; } } }catch(_){}
        try{ avFormSalvar(); }catch(_){} try{ calcAvaliacao(); }catch(_){} });
      if(dt) dt.addEventListener('input',function(){
        var n=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,6);
        this.value=n.length>2?(n.slice(0,2)+'/'+n.slice(2)):n;
        try{ avFormSalvar(); }catch(_){}
      });
      mostra();
    })();
    /* v252: Revisões concessionária — "Sim" ou "Não tem todas" abre o campo
       "revisões até qual km" (pedido). Mesmo padrão da garantia acima. */
    (function(){
      var r=$('avRevC'), k=$('avRevCKm'); if(!r||!k) return;
      function mostra(){ k.style.display=(r.value==='Sim'||r.value==='Não tem todas')?'block':'none'; }
      r.addEventListener('change',function(){ mostra(); try{ avFormSalvar(); }catch(_){} });
      k.addEventListener('input',function(){ avMaskKM.call(this); try{ avFormSalvar(); }catch(_){} });
      mostra();
      setTimeout(mostra,0);   /* o rascunho restaurado pode já vir com "Sim" */
    })();
    /* v242: a liquidez se edita direto no cartao "Liquidez" da Cotação
       loja — escreve no campo oficial da aba Valores e recalcula tudo. */
    (function(){
      var l3=$('avLiq3'), l1=$('avLiq'); if(!l3||!l1) return;
      l3.value=l1.value;
      l3.addEventListener('input',function(){ avMaskRS.call(this); l1.value=this.value; try{ l1.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){} });
    })();
    /* v242: os campos de percentual sairam daqui — agora se editam
       direto na linha de cada custo (ver _avCustoWire / .avc-pin). */
    /* v310: o interruptor "Mostrar o preço na página do lojista" foi removido
       (v240–v309). O preço de repasse não sai mais, ponto — e um rascunho
       antigo com o interruptor ligado também não o traz de volta, porque
       quem grava o payload agora nem lê esse campo. */
    (function(){ var po=$('avPrecoOculto'); if(po) po.value='1'; })();
    avRepPubWire(v);
    mevAcoes(true);
    avtOfertasCarregar(v.placa);
  }
  /* toggle "Publicar na Rede de Repasse" na tela de Avaliação */
  async function avRepPubWire(v){
    var sw=$('avRepPub'); if(!sw) return;
    /* ===== v452 — PUBLICAR NA REDE É DO PLANO LOJISTA =====
       Sem plano Lojista, o interruptor SOME e no lugar dele aparece o aviso
       com o caminho pros planos. Nada é removido do DOM: os dois blocos
       nascem juntos na tela da Avaliação, aqui só se decide qual mostra. */
    var _row=$('avRepPubRow'), _trava=$('avRepPubTrava'), _texto=$('avRepPubTexto');
    function _portalSync(){
      if(_row){ _row.classList.toggle('on',!!sw.checked); _row.classList.toggle('is-loading',!!sw.disabled); }
      if(_texto) _texto.textContent=sw.checked?'Retirar do portal':'Adicionar ao portal';
    }
    var _pode=true; try{ _pode=await podeAnunciarRepasseAsync(); }catch(_){ _pode=true; }
    if(_row)   _row.style.display   = _pode ? '' : 'none';
    if(_trava) _trava.style.display = _pode ? 'none' : '';
    if(!_pode){ _portalSync(); repassePlanoTravaLigar('avRepPubPlanos'); return; }
    sw.disabled=true;
    _portalSync();
    _repPrecoPub=0;
    /* v452 (pedido): "Em negociação / No meu estoque". A linha só existe
       enquanto o carro está no ar, e o valor volta do anúncio — quem já
       marcou "No meu estoque" reabre a tela e vê "No meu estoque". */
    var _posseRow=$('avRepPosseRow'), _posseSel=$('avRepPosse');
    function _posseMostra(on){ if(_posseRow) _posseRow.style.display = on ? '' : 'none'; }
    try{ var ex=await repassePublicadaDaPlaca((v&&v.placa)||''); sw.checked=!!(ex&&ex.ativo);
      _posseMostra(sw.checked);
      if(_posseSel && ex && ex.veiculo && ex.veiculo.posse) _posseSel.value=(String(ex.veiculo.posse)==='estoque')?'estoque':'negociacao';
      /* v178: se este carro JÁ está no portal, o campo nasce com o preço que
         os outros lojistas estão vendo agora — e travado, pra conta
         automática não passar por cima do número que você escolheu. */
      if(ex && Number(ex.preco)>0){
        _repPrecoPub=Number(ex.preco);
        var rp0=$('avRepPreco');
        if(rp0 && !repTocado){ rp0.value=r$(_repPrecoPub); repTocado=true; var t0=$('avRepT'); if(t0) t0.value='1'; try{ avFormSalvar(); }catch(_){} }
      }
    }catch(_){ sw.checked=false; _posseMostra(false); }
    sw.disabled=false;
    _portalSync();
    sw.onchange=async function(){
      sw.disabled=true;
      _portalSync();
      var ok=await repassePublicarAval(sw.checked);
      if(ok && sw.checked){ _repPrecoPub=parseInt(String((($('avRepPreco')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
      if(!ok) sw.checked=!sw.checked;   /* falhou: volta o estado */
      _posseMostra(sw.checked);         /* v452 */
      sw.disabled=false;
      _portalSync();
    };
    /* v452: trocou de "Em negociação" pra "No meu estoque" com o carro no ar?
       Republica na hora — o mesmo cuidado da v178 com o preço. Sem isto a
       escolha ficava só na tela e o outro lojista continuava vendo a antiga. */
    if(_posseSel) _posseSel.onchange=async function(){
      if(!sw.checked) return;
      _posseSel.disabled=true;
      await repassePublicarAval(true, 'Situação atualizada no repasse ✓');
      _posseSel.disabled=false;
    };
    /* v178 — MUDOU O PREÇO COM O CARRO JÁ NO AR? republica sozinho.
       Sem isso você trocava o número, saía da tela e o portal continuava
       mostrando o preço velho — porque só o interruptor salvava. */
    var rpW=$('avRepPreco');
    if(rpW) rpW.addEventListener('blur', async function(){
      if(!sw.checked) return;
      var n=parseInt(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0;
      if(!n || n===_repPrecoPub) return;
      var ok2=await repassePublicarAval(true,'Preço atualizado no repasse ✓');
      if(ok2) _repPrecoPub=n;
    });
  }
  function avMaskRS(){ var n=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); this.value=n?('R$ '+Number(n).toLocaleString('pt-BR')):''; }
  /* v310: SEMPRE oculto. Antes isto lia o interruptor da tela; o interruptor
     saiu e a resposta virou uma só. Deixei a função no lugar (em vez de
     espalhar "true" por dentro do payload) pra que exista UM ponto onde essa
     decisão mora — se um dia ela mudar, muda aqui e em nenhum outro lugar. */
  function _avOculto(){ return false; }
  /* o nome da loja pro cliente reconhecer quem está pedindo.
     ⚠️ NUNCA cai no nome do VENDEDOR: "Angelo está avaliando o seu carro" é
     outra coisa, e pior — passa por pessoa física num pedido que é da loja.
     Sem loja cadastrada, devolve vazio e a página fica como está hoje. */
  function _avLojaNome(){
    try{ if(_lojaRec) return String(_lojaRec.nome_fantasia||_lojaRec.nome||'').trim(); }catch(_){}
    try{ if(window._minhaLoja && window._minhaLoja.nome) return String(window._minhaLoja.nome).trim(); }catch(_){}
    return '';
  }
  function avLojPayload(){
    var v=veiculoAtual||{};
    function val(id){ var e=$(id); return e?String(e.value||'').trim():''; }
    function num(id){ return parseInt(String((($(id)||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
    function selTxt(id){ var e=$(id); return (e&&e.options&&e.options[e.selectedIndex])?(e.options[e.selectedIndex].text||''):''; }
    /* v265: a limpeza de valores subiu pro 01-nucleo.js — é a MESMA função
       que o Portal do Repasse usa agora. Antes cada lugar tinha (ou não tinha)
       a sua, e o repasse mandava o texto cru pra rede inteira. */
    /* ===== v263 (pedido): "RESUMO DO QUE FOI LANÇADO" TAMBÉM NA PÁGINA DO
       LOJISTA. Na tela da avaliação esse resumo já existia; na página pública
       não aparecia nada — o lojista via o carro sem saber o que a vistoria
       apontou. Aqui monto a versão PÚBLICA dele:
         · entram os itens da vistoria (pneus, lataria, mecânica…) e o que foi
           conferido com o cliente (revisões, chave, garantia…);
         · NÃO entra nenhum valor em R$ — custo de reparo é interno da loja;
         · fica de fora o que já aparece no cartão "Dados do veículo" (IPVA,
           ar, direção, cor…), pra página não repetir a mesma coisa duas vezes;
         · o que ficou "Verificar / a conferir" não entra: campo sem resposta
           só enche a página. */
    function resumoPublico(){
      var out=[];
      function limpo(t){ t=String(t||'').trim(); return (!t||/a conferir|a definir|verificar|avaliar/i.test(t))?'':t; }
      /* v379: mesma regra do resumo interno — formata o número, não copia o
         texto do campo. */
      var _km=String((($('avKm')||{}).value)||'').replace(/\D/g,'').replace(/^0+(?=\d)/,'');
      if(_km) out.push(['Quilometragem', Number(_km).toLocaleString('pt-BR')+' km']);
      var _rc=limpo(val('avRevC'));
      if(_rc){ var _rk=String((($('avRevCKm')||{}).value)||'').replace(/\D/g,''); out.push(['Revisões concessionária', _rc+((_rk&&_rc!=='Não')?(' · até '+Number(_rk).toLocaleString('pt-BR')+' km'):'')]); }
      var _ga=limpo(val('avGarantia'));
      if(_ga==='Tem'){ var _gt=String((($('avGarantiaAte')||{}).value)||'').trim(); out.push(['Garantia de fábrica','Tem'+(_gt?(' até '+_gt):'')]); }
      var _ch=limpo(selTxt('avChave')); if(_ch) out.push(['Chave reserva', _ch.replace(/\s*\([^()]*\)\s*$/,'').trim()]);
      var _mn=limpo(val('avManual')); if(_mn) out.push(['Manual do veículo', _mn]);
      var _dn=limpo(val('avDonos')); if(_dn) out.push(['Histórico de donos', _dn]);
      /* itens da vistoria: só o ESTADO, nunca o custo */
      try{
        (_avCusto||[]).forEach(function(id){
          var s=$(id); if(!s) return; var tx='';
          if(s.value==='outro'){
            try{ var j=JSON.parse((($(id+'SvJ')||{}).value)||'null'); if(j&&j.length) tx=j.map(function(r){ return String(r.d||'').trim(); }).filter(Boolean).join(' + '); }catch(_){}
            if(!tx) tx=String((($(id+'Desc')||{}).value)||'').trim();
            tx=obsPublica(tx);
          } else {
            /* v265: rede de segurança — a lista da Revisão tem opções cujo
               rótulo É o valor ("R$ 1.000"), sem parênteses pra remover. */
            tx=obsPublica((typeof _avOpcaoSemValor==='function')?_avOpcaoSemValor(s):'');
          }
          if(tx) out.push([(AV_LABELS&&AV_LABELS[id])||id, tx]);
        });
      }catch(_){}
      return out;
    }
    /* ===== v489 — OS ITENS DA FICHA TÉCNICA QUE VENDEM (pedido 15/08) ====
       A página do lojista JÁ SABIA desenhar "Motor e câmbio", "Itens de
       série" e "Opcionais" (seções que existem no index.html desde a época
       do repasse) — mas o pacote da avaliação NUNCA mandou esses campos.
       Agora, QUANDO A FICHA JÁ FOI GERADA (fichaTecObter lê histórico/
       cache/estoque — não gera nada, não custa token), os destaques vão
       junto: motor, câmbio, potência, torque, consumo, itens de série
       (respeitando o que o lojista DESMARCOU — a mesma régua do repasse,
       fichaResumoLer) e os opcionais MARCADOS. Sem ficha gerada, os campos
       vão vazios e as seções simplesmente não aparecem (links antigos
       idem). É espec de fábrica: nada sensível (regra v265 respeitada). */
    /* ⚠️ v560 — esta leitura era escrita AQUI, em 20 linhas. Ela virou a
       `fichaVendeDe` do 03-ficha-tecnica.js porque a MENSAGEM DO VEÍCULO
       (14-estoque.js) passou a precisar exatamente da mesma coisa, e duas
       leituras iguais viram, com o tempo, duas mensagens diferentes — foi o
       que a v508 teve que desfazer no chat. O resultado aqui é idêntico ao de
       antes: mesmos nomes de campo, mesma régua do desmarcado/marcado, e {}
       de volta quando não existe ficha gerada. */
    var _fx={};
    try{ _fx=(typeof fichaVendeDe==='function')?(fichaVendeDe(v.placa||'')||{}):{}; }catch(_){ _fx={}; }
    var _pay={ placa:v.placa||'', veiculo:((v.marca||'')+' '+(v.modelo||'')).trim(), ano:v.ano_modelo||v.ano||'', ano_fab:v.ano||'', ano_modelo:v.ano_modelo||'', fipe:v.fipe||'', cor:v.cor||'', combustivel:v.combustivel||'',
      /* 🔴 19/08 — O NOME DA LOJA, QUE NUNCA CHEGAVA.
         A página do cliente monta a linha "<Loja> está avaliando o seu
         carro" lendo `loja_nome || loja` — e este pacote **nunca preenchia
         nenhum dos dois**. Resultado: o link chegava por WhatsApp pedindo
         quilometragem e fotos do carro, sem dizer quem estava pedindo.
         Pra quem recebe, essa é a diferença entre "é o vendedor" e "é
         golpe" — e cliente desconfiado não responde.
         ⚠️ Vazio continua sendo aceitável: a página já sabe se virar sem a
         linha. O que não dá é ela nunca ter chance de aparecer. */
      loja_nome:_avLojaNome(),
      resumo:resumoPublico(),
      /* v489: a ficha técnica que vende (só quando já foi gerada) */
      motor:_fx.motor||'', cambio:_fx.cambio||'',
      motor_potencia:_fx.motor_potencia||'', motor_torque:_fx.motor_torque||'',
      motor_cilindrada:_fx.motor_cilindrada||'', motor_combustivel:_fx.motor_combustivel||'',
      motor_consumo:_fx.motor_consumo||'',
      itens:_fx.itens||[], opcionais:_fx.opcionais||[],
      /* ===== v564 — O QUE A PÁGINA DO CLIENTE PRECISA =====================
         `opcionais_todos` = o que a FÁBRICA oferecia neste ano (marcado ou
         não). É a diferença entre ele e o `opcionais` (o que o carro TEM) que
         vira a pergunta "o carro tem algum destes itens?".
         ⚠️ Nada disso é sensível: é espec de fábrica, a mesma régua da v265
         que já deixa a ficha viajar. Preço, custo e margem continuam fora.
         `pedir_fotos` é a caixinha que o vendedor marca — é ela que faz a
         página do cliente mostrar (ou não) a área de mandar foto. */
      opcionais_todos:_fx.opcionais_todos||[],
      pedir_fotos: !!_avPedirFotos,
      km:num('avKm')||'', ipva:val('avIpva'), ar:val('avAc'), direcao:val('avDir'),
      alienado:val('avAlien'), multas:val('avMultas'), manual:val('avManual'),
      /* v252: revisões levam o "até qual km" junto pro lojista */
      revisoes:(function(){ var r2=val('avRevC'); var k2=String((($('avRevCKm')||{}).value)||'').replace(/\D/g,''); return (r2&&k2&&r2!=='Não')?(r2+' · até '+Number(k2).toLocaleString('pt-BR')+' km'):r2; })(),
      donos:val('avDonos'),
      /* v265: o rótulo da opção traz o custo embutido — "Não tem (+R$ 1.000)".
         Ia inteiro pra tela do lojista e pro WhatsApp, entregando que a loja
         já abateu mil reais. Vai só o estado: "Não tem". */
      chave_reserva:semCustoNoRotulo(selTxt('avChave')), observacoes:obsPublica(val('avObs')),
      garantia:val('avGarantia'), garantia_ate:val('avGarantiaAte'),
      /* ===== v265 — O QUE A LOJA PAGA NÃO SAI DAQUI =====
         `avaliado` era o campo #avValor: liquidez − custos − margem de lucro −
         margem de garantia − comissão. Ou seja, o MÁXIMO que a loja topa pagar.
         A página do lojista nunca desenhou esse número na tela, mas ele viajava
         dentro do pacote: bastava o parceiro abrir o inspecionar do navegador
         pra ler o piso da negociação e ofertar em cima dele. Saiu do pacote.

         E o interruptor "ocultar preço" era só visual: a página deixava de
         DESENHAR o preço, mas ele continuava chegando. Agora, ligado o
         interruptor, o número simplesmente não é enviado. */
      preco_sugerido:(_avOculto()?'':(num('avRepPreco')||'')), valor_venda:(_avOculto()?'':(num('avRepPreco')||'')),
      ocultar_preco:_avOculto(),
      fotos:avFotosNormaliza(_avFotos).map(function(x){return {url:x};}),
      /* ===== v681 (decisão 28/08: "o parceiro vê no link do lojista") =====
         O vídeo viaja como REFERÊNCIA, nunca como URL: URL assinada expira
         em minutos, e o lojista abre o link dois dias depois — gravar uma
         no payload é gravar um link morto. A página pública troca a
         referência por uma URL curta NA HORA do toque, pela /api/video-url
         (ação ver-link), que confere o PAR link↔referência no servidor.
         O poster é a foto extraída (pública e leve): a página abre bonita
         sem baixar um byte de vídeo.
         🔴 NUNCA dentro de payload.fotos — campo próprio, regra do projeto. */
      video:(function(){ try{
        var v=(typeof _avVideos!=='undefined')&&_avVideos[0];
        return v?{ ref:String(v.ref||''), dur:Number(v.dur)||0, poster:String(v.poster||'') }:undefined;
      }catch(_){ return undefined; } })() };
    /* ===== v490 — A MENSAGEM DO WHATSAPP VIAJA PRONTA DENTRO DO PACOTE =====
       Existiam DUAS mensagens: a do botão WhatsApp do app (completa: FIPE,
       ✅ o que está em dia, ▫️ o que pede olhar, vistoria, observações) e a
       do botão Compartilhar da página do lojista, que tinha um montador
       PRÓPRIO e muito mais pobre (só km, IPVA e observações). Duas cópias da
       mesma ideia: toda melhoria entrava numa e esquecia a outra.
       Agora existe UM montador só (avRepMsgCorpo) e o texto pronto vai
       gravado no pacote, no campo `msg`. A página não monta nada: pega o
       `msg` e cola o endereço DELA no fim. Melhorou aqui, melhorou nos dois.
       Nada sensível entra: o corpo usa exatamente os campos que a página já
       desenha (a regra da v265 continua valendo — preço não viaja). */
    try{ _pay.msg=avRepMsgCorpo(_pay); }catch(_){ _pay.msg=''; }
    return _pay;
  }
  /* ==========================================================================
     v384 (PEDIDO: "as observações que coloquei pra lojista não foi na mensagem
     do WhatsApp") — O QUE VOCÊ ESCREVE DEPOIS DO LINK TAMBÉM VAI

     O QUE ACONTECEU, na sua avaliação da MHB4J21:
       20:23  você tocou em WhatsApp. Como ainda não havia link, o app criou um
              na hora, gravando o pacote do jeito que a tela estava naquele
              segundo — com as Observações VAZIAS.
       20:25  você voltou e escreveu "Chave reserva, manual, ar gelando".
     Daí em diante o texto só existia no seu aparelho: o link já estava gravado
     sem ele e NADA regravava. O lojista abria a página e não via observação
     nenhuma, e a mensagem só levaria o texto se você tocasse em WhatsApp OUTRA
     VEZ depois de escrever.

     O CONSERTO: antes de compartilhar (WhatsApp, Lista repasse ou Ver página),
     o app confere se a tela mudou desde a última gravação. Mudou? Regrava o
     MESMO link — não cria outro, não muda o endereço, quem já recebeu continua
     com o link certo, agora atualizado.

     Só regrava quando mudou de verdade (comparo o pacote inteiro com o retrato
     do que foi gravado): tocar em WhatsApp três vezes seguidas não vira três
     escritas no banco.
     ========================================================================== */
  var _avLojSalvo='';                                    /* retrato do pacote gravado */
  function _avLojRetrato(p){ try{ return JSON.stringify(p); }catch(_){ return ''; } }
  async function _avLojPacote(){
    var p=avLojPayload();
    // Do not persist newly visible prices while a deployment still has public legacy RPCs.
    try{var gate=await supa.rpc('mp_repasse_acesso');if(gate.error||gate.data!==true)throw new Error();
      p.gastos_estimados=avGastosLer().filter(function(g){return g.valor>0||g.descricao.trim();});
      p.resumo=[];
    }
    catch(_){p.preco_sugerido='';p.valor_venda='';p.ocultar_preco=true;}
    try{ var ru=await supa.auth.getUser(); var u=ru&&ru.data&&ru.data.user; var md=(u&&u.user_metadata)||{};
         p.vendedorFone=md.telefone||''; p.vendedor_nome=md.nome||''; }catch(_){}
    return p;
  }
  /* regrava o link atual se a tela mudou — silencioso: é manutenção, não ação */
  /* ==========================================================================
     🔴 v709 (pedido do Angelo, 29/08): "estou tentando importar um carro do
     avaliex, mas nao ta salvando em avaliacoes"
     --------------------------------------------------------------------------
     A LISTA de Avaliações mostra as LINHAS de `avaliacoes` — e a linha só
     nascia no avLojGerar (o botão de link, na Cotação repasse). Importar
     preenchia formulário e rascunho, e "Salvar e fechar" só ATUALIZAVA
     linha existente (v384) — pra placa nova, nada era criado e o card
     nunca aparecia. Esta função GARANTE a linha, quieta:
       · já tem _avLojId? nada a fazer;
       · já existe linha da placa no banco? ADOTA a mais nova (não duplica);
       · senão, INSERE com o pacote atual — o mesmo insert do avLojGerar,
         sem a parte do link/URL (o link continua nascendo só no botão).
     Nada disso publica nada: a página só abre pra quem tem o link, e o
     repasse continua atrás do próprio toggle. */
  var _avLojGarantiaPendente=null;
  async function avLojGarantirLinha(pacotePronto){
    if(_avLojId || !meuId || !window.supa) return;
    var v=veiculoAtual||{}; if(!v.placa) return;
    /* v1481 — sair, ocultar a aba e pagehide podem acontecer quase juntos.
       Uma promessa compartilhada impede duas consultas sem resultado de
       inserirem duas linhas da mesma placa. Fotos não participam da decisão:
       o pacote sem anexos grava `fotos: []` e continua sendo uma avaliação. */
    if(_avLojGarantiaPendente) return _avLojGarantiaPendente;
    _avLojGarantiaPendente=(async function(){
      try{
        var r0=await supa.from('avaliacoes').select('id')
          .eq('user_id',meuId).eq('placa',v.placa)
          .order('criado_em',{ascending:false}).limit(1);
        var row=r0&&r0.data&&r0.data[0];
        if(row&&row.id){ _avLojId=row.id; return; }
        var payload=await (pacotePronto||_avLojPacote());
        var r=await supa.from('avaliacoes')
          .insert({user_id:meuId, placa:v.placa||'', payload:payload}).select().single();
        if(r&&r.data&&r.data.id){ _avLojId=r.data.id; _avLojSalvo=_avLojRetrato(payload); }
      }catch(_){}
    })();
    try{ return await _avLojGarantiaPendente; }
    finally{ _avLojGarantiaPendente=null; }
  }
  /* v1481 — um único caminho para persistir a avaliação inteira. O rascunho
     continua local/nuvem e a linha privada de `avaliacoes` nasce mesmo quando
     nenhuma foto foi anexada. Isto não gera link e não publica no repasse. */
  function avAvaliacaoSalvarCompleta(){
    try{ avFormSalvar(); }catch(_){}
    try{ avEspelhoGravar(); }catch(_){}
    /* O formulário será desmontado logo depois do toque. `_avLojPacote()` lê
       os campos antes do primeiro await, então iniciar a promessa aqui congela
       a ficha correta antes da navegação. */
    var pacotePronto=null; try{ pacotePronto=_avLojPacote(); }catch(_){}
    try{ return avLojGarantirLinha(pacotePronto).then(function(){ return avLojAtualizar(pacotePronto); }); }
    catch(_){ return Promise.resolve(); }
  }
  async function avLojAtualizar(pacotePronto){
    /* v710: a exigência de `_avLojUrl` saiu — regravar o PACOTE não precisa de
       link nenhum (a URL nasce do id, não do pacote). Com ela, uma avaliação
       importada (v709) que ainda não gerou link ficava congelada: capa nova,
       valor novo, nada chegava no card. Quem precisa de URL (abrir página,
       WhatsApp) confere a URL por conta própria antes de chamar. */
    if(!_avLojId) return;
    try{
      var p=await (pacotePronto||_avLojPacote());
      var novo=_avLojRetrato(p);
      if(!novo || novo===_avLojSalvo) return;            /* nada mudou: não mexe no banco */
      var r=await supa.from('avaliacoes').update({payload:p}).eq('id',_avLojId);
      if(!(r&&r.error)) _avLojSalvo=novo;
    }catch(_){}
  }
  async function avLojGerar(){
    var m=$('avMsg'); if(m) m.className='cad-msg';
    var v=veiculoAtual||{}; var btn=$('avGerar'); if(btn){ btn.disabled=true; btn.textContent='Gerando...'; }
    try{
      var acesso=await supa.rpc('mp_repasse_acesso');
      if(acesso.error) throw new Error('Não consegui confirmar o acesso. Tente novamente.');
      if(acesso.data!==true) throw new Error('Acesso exclusivo para lojas autorizadas.');
      var payload=await _avLojPacote();
      /* v384: "Gerar / ATUALIZAR link" agora atualiza mesmo. Com um link já
         criado nesta tela, ele regrava aquele — antes criava um endereço novo
         a cada toque, e o anterior (que você já tinha mandado) ficava velho. */
      var r = _avLojId
        ? await supa.from('avaliacoes').update({payload:payload}).eq('id',_avLojId).select().single()
        : await supa.from('avaliacoes').insert({user_id:meuId, placa:v.placa||'', payload:payload}).select().single();
      if(r&&r.error) throw r.error;
      _avLojId=(r.data&&r.data.id)||_avLojId;
      _avLojSalvo=_avLojRetrato(payload);
      /* v247: LINK CURTO com o nome da loja, igual ao catálogo (pedido):
         mevveiculos.com.br/<apelido-da-loja>/avaliacao/PLACA-8dígitos
         O código curto (8 primeiros dígitos do id) é resolvido no servidor
         pela mp_get_avaliacao_codigo. Sem apelido cadastrado, cai no /av/. */
      var _cod=String(_avLojId||'').replace(/-/g,'').slice(0,8)||String(_avLojId||'');
      var _pl=String(v.placa||'').replace(/[^A-Za-z0-9]/g,'').toUpperCase();
      var _slug=''; try{ _slug=ljApelido(); }catch(_){}
      if(!_slug){ try{ var _rl=await supa.from('loja').select('slug').eq('user_id',meuId).maybeSingle(); if(_rl&&_rl.data&&_rl.data.slug){ _slug=String(_rl.data.slug).trim(); if(typeof _lojaRec!=='undefined'&&_lojaRec) _lojaRec.slug=_slug; } }catch(_){}}
      _avLojUrl=location.origin+(_slug?('/'+_slug+'/avaliacao/'):'/av/')+(_pl?_pl+'-':'')+_cod;
      _avLinkMarcar(v.placa);   /* v270/v1448: marca que a Avaliação já tem página de repasse */
      try{ var _vv=parseInt(String((($('avValor')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; if(_vv>0){ if(_avValores===null) _avValores={}; _avValores[_avPlacaKey(v.placa)]=_vv; } }catch(_){}
      /* 🔴🔴 v582 — A CAIXA VERDE SAIU DAQUI (PROJETO links-só-na-cotação-repasse)
         O link tem UMA casa: a seção **Repasse** da aba Avaliação. Aqui antes ele
         era a MESMA porta desenhada de novo, dois toques depois — e duas portas
         pro mesmo cômodo é onde a pessoa trava.
         ⚠️ As duas linhas de onclick TÊM que ficar DENTRO deste if: soltas,
         viram `$('avWa2').onclick` num null → erro de JS que derruba o resto do
         avLojGerar, e a tela mente "Não consegui gerar" com o link já salvo.
         ⛳ Virando o interruptor pra true, a caixa volta inteira, viva. */
      if(LINK_NA_COTLOJA){
        $('avResult').innerHTML='<div class="av-done"><div class="av-done-t">Link pronto! Mande pros lojistas:</div><div class="av-link">'+esc(_avLojUrl)+'</div><div class="av-acts"><button type="button" class="b1" id="avEnviarRep">Repasse</button><button type="button" class="b2" id="avWa2">WhatsApp</button></div></div>';
        $('avWa2').onclick=function(){ avLojAbrir('wa'); };
        $('avEnviarRep').onclick=avEnviarRepAbrir;
      } else {
        var _r=$('avResult'); if(_r) _r.innerHTML='';
      }
      if(m){ m.className='cad-msg ok'; m.textContent='Salvo.'; }
      avtOfertasCarregar(v.placa);
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui gerar. '+((e&&e.message)||''); } }
    if(btn){ btn.disabled=false; btn.textContent='Gerar / atualizar link'; }
  }
  async function avLojAbrir(tipo){
    if(!_avLojUrl){ await avLojGerar(); }
    else { await avLojAtualizar(); }   /* v384: leva o que você escreveu depois */
    if(!_avLojUrl){ toast('Gere o link primeiro.'); return; }
    if(tipo==='page'){ _publicoAbrir(_avLojUrl,{ voltar:'Voltar à avaliação', titulo:'Página do lojista' }); return; }
    var txt=avRepMsg();
    mevIrProWhats('https://wa.me/?text='+encodeURIComponent(txt));   /* v370 — vai pro WhatsApp, não fica atrás do app */
  }
  /* ===== v494 — LAUDO PRO DONO DO CARRO (Parte B do 3em1) ==================
     A MESMA avaliação numa moldura pra pessoa física: o ?laudo=1 esconde o
     leilão inteiro (a página cuida disso; nenhum dado novo viaja — payload
     v265 já é limpo). Aqui só se monta o LINK LONGO
     (/avaliacao/?a=...&laudo=1 — o curto /av/ passa pelo aval-share e NÃO
     carrega a flag) e a mensagem PRÓPRIA: o campo msg do pacote (v490)
     fala com LOJISTA e NÃO é reaproveitado. Toggle na hora: "incluir
     FIPE?" (default SIM; desligado vira &fipe=0 — tem lojista que não
     quer ancorar o cliente na FIPE). */
  async function avLaudoAbrir(){
    if(!_avLojUrl){ await avLojGerar(); }
    else { await avLojAtualizar(); }   /* v384: leva o que você escreveu depois */
    if(!_avLojId){ toast('Gere o link primeiro.'); return; }
    _avLaudoMostrar();
  }
  function _avLaudoLink(comFipe){
    return location.origin+'/avaliacao/?a='+encodeURIComponent(_avLojId)+'&laudo=1'+(comFipe?'':'&fipe=0');
  }
  function _avLaudoMostrar(){
    _clnCss();   /* mesma moldura do cartão do clone (v492) */
    var v=veiculoAtual||{};
    var bg=document.createElement('div'); bg.className='cln-bg'; bg.id='laudoBg';
    bg.innerHTML='<div class="cln-card" role="dialog" aria-modal="true">'+
      '<h3>📄 Laudo pro cliente</h3>'+
      '<p>A avaliação do '+esc(((v.marca||'')+' '+(v.modelo||'')).trim()||'carro')+' numa moldura pro DONO: fotos, dados e ficha técnica — sem oferta, sem valores da loja.</p>'+
      '<label style="display:flex;align-items:center;justify-content:center;gap:8px;font-size:13.5px;font-weight:700;color:#0a2540;margin-bottom:6px;cursor:pointer"><input type="checkbox" id="laudoFipe" checked style="width:17px;height:17px;accent-color:#0a4da6"> Incluir a FIPE no laudo</label>'+
      '<button type="button" class="cln-bt wa" id="laudoWa">Enviar no WhatsApp</button>'+
      '<button type="button" class="cln-bt cp" id="laudoCp">Copiar link</button>'+
      '<button type="button" class="cln-x" id="laudoX">Fechar</button></div>';
    document.body.appendChild(bg);
    function fecha(){ try{ bg.remove(); }catch(_){} }
    bg.onclick=function(e){ if(e.target===bg) fecha(); };
    function linkAgora(){ var cb=document.getElementById('laudoFipe'); return _avLaudoLink(!cb||cb.checked); }
    var w=document.getElementById('laudoWa');
    if(w) w.onclick=function(){
      var l=linkAgora();
      mevIrProWhats('https://wa.me/?text='+encodeURIComponent('Segue o laudo da avaliação do seu carro: '+l));
      fecha();
    };
    var c=document.getElementById('laudoCp');
    if(c) c.onclick=function(){ (async function(){ var l=linkAgora(); try{ await navigator.clipboard.writeText(l); toast('Link do laudo copiado ✓'); }catch(_){ toast(l); } })(); };
    var x=document.getElementById('laudoX'); if(x) x.onclick=fecha;
  }
  /* v247: a mensagem do WhatsApp agora LISTA o que foi informado na
     avaliação (mesmo formato da linha da quilometragem) + observações.
     O que ficou "a conferir"/"verificar"/vazio NÃO entra na mensagem. */
  /* ===== v269 (pedido) — A MENSAGEM DO WHATSAPP VIROU UMA LISTA =====
     Antes era um bloco de "Campo: valor" um embaixo do outro, tudo com o mesmo
     peso — o lojista tinha que LER a mensagem inteira pra achar o que importa.

     Agora separa em duas listas, que é como ele decide:
       ✅ o que está OK        (IPVA pago, sem multas, chave reserva, garantia…)
       ⚠️ o que pede atenção   (multa, alienação, pneu pra trocar, lataria…)

     A régua de cada campo está no _wppOk(): "Pago" é bom, "Em atraso" não;
     "Não" em multas é BOA notícia, "Sim" não é. Não dá pra decidir pelo texto
     sozinho — depende do campo.

     Continua valendo tudo o que já era regra: nada de valor de reparo, nada do
     valor avaliado, e o preço só sai se o interruptor deixar. */
  /* ===== v274 — O CARRO É VELHO DEMAIS PRA FALAR DE GARANTIA DE FÁBRICA? =====
     Garantia de fábrica no Brasil é de 3 anos na maioria das marcas (a VW dá 3).
     Passou disso, "sem garantia" é o esperado, não uma observação.

     DUAS DECISÕES DE PROPÓSITO, pra errar sempre pro lado de MOSTRAR:

     1) Uso o ANO MODELO, não o de fabricação. O modelo é o maior dos dois (um
        carro fabricado em 2012 costuma ser modelo 2013), então o carro conta
        como MAIS NOVO e a linha some mais tarde. Se eu usasse o de fabricação,
        um 2023/2024 já perderia o aviso antes da hora.

     2) Sem ano no cadastro (ou ano estranho, tipo 1980 ou o ano que vem),
        devolve false = MOSTRA. Não escondo informação que não sei justificar.

     Devolve true só quando tem CERTEZA de que o carro passou dos 3 anos. */
  var AV_GARANTIA_ANOS = 3;
  function _avGarantiaVelha(p){
    try{
      var hoje = new Date().getFullYear();
      var a = 0;
      [p&&p.ano_modelo, p&&p.ano, p&&p.ano_fab].forEach(function(x){
        var n = parseInt(String(x||'').replace(/\D/g,'').slice(0,4), 10);
        if(n >= 1900 && n <= hoje + 2 && n > a) a = n;   /* fica com o mais novo */
      });
      if(!a) return false;                                /* sem ano → mostra */
      return (hoje - a) > AV_GARANTIA_ANOS;
    }catch(_){ return false; }
  }
  /* v490: quem chama continua chamando avRepMsg() — ela só junta o CORPO
     (o mesmo que vai no pacote) com o endereço deste link. */
  function avRepMsg(){
    var p={}; try{ p=avLojPayload()||{}; }catch(_){ p={}; }
    var corpo=(p&&p.msg&&String(p.msg).trim())||avRepMsgCorpo(p);
    return corpo+'\n\n📸 Fotos e oferta:\n'+_avLojUrl;
  }
  /* CUIDADO: esta função NÃO pode chamar avLojPayload() — é ela quem monta
     o `msg` de dentro do pacote, e a chamada de volta viraria laço infinito.
     Ela recebe o pacote pronto por parâmetro. */
  function avRepMsgCorpo(p){
    p=p||{};
    var v=veiculoAtual||{};
    function okv(x){ x=String((typeof _dadoUtil==='function'?_dadoUtil(x):x)||'').trim(); return x && !/conferir|verificar|avaliar|escolher/i.test(x); }

    /* ---- cabeçalho: o carro ---- */
    var placa=(p.placa||v.placa||'');
    var nome=(p.veiculo||((v.marca||'')+' '+(v.modelo||'')).trim());
    var anos=(p.ano_fab&&p.ano&&String(p.ano_fab)!==String(p.ano))?(p.ano_fab+'/'+p.ano):(p.ano||'');
    var L=['*Avaliação — '+placa+'*'];
    if(nome) L.push(nome);
    var linha1=[anos, p.km?(Number(p.km).toLocaleString('pt-BR')+' km'):'', okv(p.cor)?p.cor:'', okv(p.combustivel)?p.combustivel:''].filter(Boolean);
    if(linha1.length) L.push(linha1.join(' · '));

    /* ---- os números ---- */
    var nums=[];
    /* v413 (pedido 12/08): "manda a fipe junto na mensagem da avaliação".
       A linha *FIPE* já existia (v310), mas só saía quando o veículo em
       memória trazia o valor — abrindo a avaliação por outro caminho, a
       mensagem ia sem. Agora, faltando, busca no HISTÓRICO de consultas
       da mesma placa (a consulta salva guarda a FIPE). */
    var _fipeMsg=Number(p.fipe||v.fipe)||0;
    if(!_fipeMsg){
      try{
        var _plUp=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
        var _hf=histLer().filter(function(x){ return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===_plUp; })[0];
        _fipeMsg=Number(_hf&&_hf.v&&_hf.v.fipe)||0;
      }catch(_){}
    }
    if(_fipeMsg>0) nums.push('*FIPE* '+r$(_fipeMsg));
    /* v310: a linha "*Repasse* R$ x" saiu da mensagem. A FIPE fica — ela é
       pública, qualquer um consulta. O seu preço de repasse, não. */
    if(nums.length){ L.push(''); L.push(nums.join('\n')); }

    /* ===== v559 — A FICHA NA MENSAGEM VIROU UMA LISTA DE ✅ ================
       Pedido do Angelo (18/08, com print): *"das informações da ficha técnica
       que vai na mensagem do whatsapp quero apenas — motor, câmbio, itens de
       série e opcionais, um em cada linha e emoji de verificado"*.

       ANTES (v490) era um parágrafo só, com tudo grudado por "·":
         *Ficha* 1.4 TSI 16V Turbo Flex (EA211) · Automático Tiptronic 6
         marchas · 150 cv · 10,9 km/l (gasolina) · 7,4 km/l (etanol) cidade …
       No WhatsApp aquilo virava um bloco de cinco linhas que ninguém lê, e o
       que vende (motor, câmbio, equipamento) ficava no meio do consumo.

       AGORA cada coisa é uma linha com ✅ — o MESMO formato que a mensagem do
       estoque já usa (estVeicMsg), então as duas mensagens do app passam a
       se parecer, em vez de cada uma ter um jeito.

       🔴 SAÍRAM potência e consumo, a pedido. Eles continuam na PÁGINA do
       lojista (v489) — quem quiser o detalhe abre o link. A mensagem é a
       vitrine, não a ficha inteira.
       🔴 ENTRARAM os itens de SÉRIE, que a v490 tinha deixado de fora por
       serem "20 linhas". Agora vão, com teto — ver abaixo.

       ⚠️ TETO, porque 20 ✅ de série viram lista de supermercado e afogam o
       que importa. O que passar do teto é contado ("+N"), nunca sumido em
       silêncio. Os OPCIONAIS têm teto próprio e maior: são eles que mudam o
       preço do carro.
       ⛳ FICHA_MSG_SERIE / FICHA_MSG_OPC — os dois tetos, numa linha cada. */
    try{
      var _linhas=[];
      [p.motor, p.cambio].forEach(function(x){
        x=String(x||'').trim(); if(x) _linhas.push(x);
      });
      function _lista(arr, teto){
        var todos=(arr||[]).map(function(x){ return String(x||'').trim(); }).filter(Boolean);
        /* sem repetir o que já está na lista (o câmbio às vezes volta como item) */
        var vistos={}; _linhas.forEach(function(x){ vistos[x.toLowerCase()]=1; });
        var novos=todos.filter(function(x){ var k=x.toLowerCase(); if(vistos[k]) return false; vistos[k]=1; return true; });
        novos.slice(0,teto).forEach(function(x){ _linhas.push(x); });
        if(novos.length>teto) _linhas.push('+'+(novos.length-teto)+' item(ns)');
      }
      _lista(p.itens, FICHA_MSG_SERIE);
      _lista(p.opcionais, FICHA_MSG_OPC);
      if(_linhas.length){
        L.push('');
        L.push(_linhas.map(function(x){ return '\u2705 '+x; }).join('\n'));
      }
    }catch(_){}

    /* ---- a régua: o que é boa notícia em cada campo ---- */
    function _wppOk(campo, val){
      var t=String(val||'').trim().toLowerCase();
      switch(campo){
        case 'ipva':      return /pago/.test(t) && !/atras/.test(t);
        case 'multas':    return /^n[ãa]o/.test(t);
        case 'alienado':  return /^n[ãa]o/.test(t);
        case 'ar':        return /gela/.test(t) && !/n[ãa]o gela/.test(t);
        case 'direcao':   return /tem/.test(t) && !/n[ãa]o tem/.test(t);
        case 'chave':     return /tem/.test(t) && !/n[ãa]o tem/.test(t);
        case 'manual':    return /tem|digital/.test(t) && !/n[ãa]o tem/.test(t);
        case 'revisoes':  return /^sim/.test(t);
        case 'donos':     return /[uú]nico|segundo/.test(t);
        case 'garantia':  return /tem/.test(t) && !/n[ãa]o tem/.test(t);
      }
      return true;
    }
    var bons=[], atencao=[];
    function põe(campo, rotulo, val, textoOk, textoRuim){
      if(!okv(val)) return;
      var ok=_wppOk(campo, val);
      var txt=(ok?(textoOk||rotulo+': '+val):(textoRuim||rotulo+': '+val));
      (ok?bons:atencao).push(txt);
    }
    põe('ipva','IPVA',p.ipva,'IPVA pago','IPVA em atraso');
    põe('multas','Multas',p.multas,'Sem multas','Tem multas');
    põe('alienado','Alienado',p.alienado,'Sem alienação','Veículo alienado');
    põe('ar','Ar-condicionado',p.ar);
    põe('direcao','Direção',p.direcao);
    põe('chave','Chave reserva',p.chave_reserva,'Chave reserva','Sem chave reserva');
    põe('manual','Manual',p.manual,(/digital/i.test(String(p.manual))?'Manual digital (app)':'Manual do veículo'),'Sem manual');
    põe('revisoes','Revisões concessionária',p.revisoes,'Revisões na concessionária'+(/·/.test(String(p.revisoes||''))?(' '+String(p.revisoes).split('·').slice(1).join('·').trim()):''),'Revisões: '+p.revisoes);
    põe('donos','Histórico de donos',p.donos,String(p.donos||''),String(p.donos||''));
    /* a régua tem que olhar o ESTADO ("Tem"/"Não tem"), não a frase montada:
       "Garantia de fábrica até 08/2027" não contém a palavra "tem" e caía como
       problema, ainda por cima com o rótulo escrito duas vezes. */
    if(okv(p.garantia)){
      var _temGar=(p.garantia==='Tem');
      /* ===== v274 — CARRO VELHO NÃO PRECISA AVISAR QUE NÃO TEM GARANTIA =====
         Num Grand Siena 2012/2013, "Sem garantia de fábrica" não é informação:
         é o óbvio ocupando uma linha e diluindo o que interessa de verdade (a
         lataria, o painel, a revisão). Ninguém espera garantia de fábrica num
         carro de 13 anos.
         Some só o aviso NEGATIVO. Se o campo disser "Tem" — garantia estendida,
         carro remanufaturado, o que for — a linha aparece em qualquer idade,
         porque aí é boa notícia e é informação de verdade. */
      if(_temGar || !_avGarantiaVelha(p)){
        var _gTxt=_temGar
          ? ('Garantia de fábrica'+(p.garantia_ate?(' até '+p.garantia_ate):''))
          : 'Sem garantia de fábrica';
        (_wppOk('garantia', p.garantia) ? bons : atencao).push(_gTxt);
      }
    }

    /* ---- itens da vistoria: o que a loja apontou (nunca com valor) ---- */
    try{
      var rotVist={}; Object.keys(AV_LABELS||{}).forEach(function(k){ rotVist[AV_LABELS[k]]=1; });
      /* nem todo item da vistoria é problema: "Original", "Novos", "Bons" e
         "Sem trincas" são pontos POSITIVOS do carro e merecem o ✅. */
      var bom=/^(original|novos?|bons?|sem (danos|trincas|custo|ferrugem)|ok)\b/i;
      (p.resumo||[]).forEach(function(r){
        if(!(r && rotVist[r[0]] && r[1])) return;
        (bom.test(String(r[1]).trim()) ? bons : atencao).push(r[0]+': '+r[1]);
      });
    }catch(_){}

    if(bons.length){ L.push(''); L.push(bons.map(function(t){ return '✅ '+t; }).join('\n')); }
    /* v270: o marcador de atenção era ⚠️ e ficava gritante do lado do ✅ —
       parecia alerta de perigo pra coisa que é só "olhe isto". Agora é um
       quadradinho neutro: separa as duas listas sem levantar a voz. */
    if(atencao.length){ L.push(''); L.push(atencao.map(function(t){ return '▫️ '+t; }).join('\n')); }
    /* ===== v270 — A MENSAGEM SE REPETIA =====
       O que você escreve num item de serviço vai pra DOIS lugares: pra linha do
       item ("Elétrica: curto na bobina") e pro campo de observações, porque o
       app copia uma coisa na outra desde a v253. Na mensagem do WhatsApp isso
       aparecia duas vezes seguidas, e o lojista lia a mesma frase de novo três
       linhas abaixo.
       Agora a observação só entra se ela ainda NÃO tiver sido dita na lista. */
    var jaDito={};
    bons.concat(atencao).forEach(function(t){ jaDito[String(t).toLowerCase().replace(/\s+/g,' ').trim()]=1; });
    var obsSobra=String(p.observacoes||'').split('\n')
      .map(function(l){ return l.trim(); })
      .filter(function(l){ return l && !jaDito[l.toLowerCase().replace(/\s+/g,' ')]; });
    if(obsSobra.length){ L.push(''); L.push('*Observações*'); L.push(obsSobra.join('\n')); }
    /* v490: o endereço NÃO entra aqui. Quem monta a última linha é quem tem
       o link na mão: o app usa o _avLojUrl; a página do lojista usa o
       endereço dela. É o que faz o mesmo corpo servir os dois. */
    return L.join('\n');
  }
  /* ===== v558 — AVISAR LOJISTAS a partir da AVALIAÇÃO (porta C) =========
     O link é o MESMO que o "Ver página" abre e que o botão antigo mandava:
     a página da avaliação do lojista. Por isso ele é gerado/atualizado
     aqui antes de abrir a folha — sem link, o lojista recebe um carro que
     não dá pra ver nem ofertar. */
  async function avAvisarLojistasAbrir(){
    if(!_avLojUrl){ await avLojGerar(); }
    else { await avLojAtualizar(); }        /* leva o que ele escreveu depois (v384) */
    if(!_avLojUrl){ toast('Não consegui gerar o link da avaliação.'); return; }
    var pac=null;
    try{ pac=avisarLojistasDaAvaliacao(veiculoAtual, _avLojUrl); }catch(_){}
    if(!pac){ toast('Não consegui montar a mensagem deste carro.'); return; }
    avisarLojistasAbrir(pac.texto, pac.titulo, { link:pac.link, foto:pac.foto||'', chave:pac.chave||'' });
  }

  async function avEnviarRepAbrir(){
    if(!_avLojUrl){ await avLojGerar(); }
    else { await avLojAtualizar(); }   /* v384: leva o que você escreveu depois */
    if(!_avLojUrl){ toast('Gere o link primeiro.'); return; }
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='📤'; $('cliMt').textContent='Enviar pros repasses';
    $('cliMbody').innerHTML='<div class="cad-msg" style="margin:0 0 10px;color:#64748b">Toque em <b>Enviar</b> pra abrir o WhatsApp de cada lojista já com o link da avaliação.</div>'+
      '<div class="cli-search" style="margin-bottom:10px">'+_icoBusca+'<input id="avRepBusca" placeholder="Buscar lojista" autocomplete="off"></div>'+
      '<button class="cad-btn sec" id="avRepCopiar" style="margin:0 0 12px">Copiar link</button>'+
      '<div id="avRepLista"><div class="cli-empty">Carregando...</div></div>';
    $('avRepCopiar').onclick=function(){ try{ navigator.clipboard.writeText(_avLojUrl); toast('Link copiado.'); }catch(_){ prompt('Copie:',_avLojUrl); } };
    $('avRepBusca').oninput=function(){ avRepPinta(this.value); };
    await repCarregar(); avRepPinta('');
  }
  function avRepPinta(termo){
    var el=$('avRepLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    if(!_repasses.length){ el.innerHTML='<div class="cli-empty" style="padding:14px"><b>Nenhum lojista de repasse</b>Cadastre em Rede Lojistas Repasses.</div>'; return; }
    var lista=_repasses.filter(function(c){ return !termo || ((c.nome||'')+' '+(c.cidade||'')).toLowerCase().indexOf(termo)>=0; });
    if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:14px">Nada encontrado.</div>'; return; }
    el.innerHTML=lista.map(function(c){ var sub=[c.cidade,c.uf].filter(Boolean).join('/')||''; var tem=!!String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
      return '<div class="cli-card" style="cursor:default"><div class="cli-av">'+esc(cliIni(c.nome))+'</div><div class="cli-tx"><div class="cli-nm">'+esc(c.nome||'')+'</div><div class="cli-sb">'+esc(sub)+'</div></div>'+(tem?('<button class="av-rep-send" data-id="'+esc(c.id)+'">Enviar</button>'):'<span class="av-rep-no">sem telefone</span>')+'</div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.av-rep-send'),function(b){ b.onclick=function(){ var c=_repasses.filter(function(x){return String(x.id)===String(b.getAttribute('data-id'));})[0]; if(!c) return; var num=String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(!num) return; if(num.length<=11) num='55'+num; var url='https://wa.me/'+num+'?text='+encodeURIComponent(avRepMsg()); try{ window.open(url,'_blank'); }catch(_){ location.href=url; } b.textContent='Enviado ✓'; b.classList.add('done'); }; });
  }

  /* ===========================================================================
   * v565 — A VOLTA: O QUE O CLIENTE RESPONDEU ENTRA NA AVALIAÇÃO
   *
   * A v564 fez a IDA (o link, a página, o porteiro). Esta é a volta.
   *
   * 🔴 A REGRA, ESCOLHIDA PELO ANGELO: *"preenche o que está em branco"*.
   *   · campo VAZIO / "Verificar"  → entra sozinho;
   *   · campo que VOCÊ já respondeu → NÃO é tocado. Vira uma linha no aviso
   *     ("o cliente disse X"), com um botão pra você usar se quiser.
   * É a mesma lição da v557 e da v562: você olhou o carro, o cliente só
   * lembra. Apagar a sua conferência sem avisar mudaria o valor da avaliação
   * sozinho — e ninguém saberia por quê.
   *
   * ⚠️ AS FOTOS NÃO TÊM CONFLITO: elas se somam às suas, nunca substituem.
   * ⚠️ OS OPCIONAIS que ele confirma entram na ficha (o mesmo `marcados` do
   * repasse, v489) — também é adição, não troca.
   * ⚠️ CONSULTA QUE FALHA NÃO INVENTA NADA: sem resposta do banco, o aviso
   * simplesmente não aparece (régua v525/v556).
   * ⚠️ O `aproveitado` guarda o que já entrou, pra abrir a avaliação dez
   * vezes não repetir o aviso nem reescrever o campo que você depois mudou.
   * ⛳ CLIENTE_RESPOSTAS_ON = false desliga a volta inteira.
   * ========================================================================= */
  var CLIENTE_RESPOSTAS_ON = true;
  var _avCliLinha=null, _avCliPend=[];

  /* o que o cliente responde × onde isso mora na tela.
     ⚠️ `traduz` existe porque as opções do <select> do app e as palavras da
     página do cliente não são as mesmas em todos os campos — escrever no
     select um valor que ele não tem faz o navegador ficar CALADO no valor
     antigo, que é o pior dos mundos. */
  var _AVCLI_MAPA = {
    km:            { id:'avKm',       rot:'Quilometragem',
                     traduz:function(v){ var n=Number(v)||0; return n>0 ? n.toLocaleString('pt-BR') : ''; } },
    donos:         { id:'avDonos',    rot:'Histórico de donos',
                     traduz:function(v){ return /n[ãa]o sei/i.test(v) ? 'Não sabe' : String(v||''); } },
    chave_reserva: { id:'avChave',    rot:'Chave reserva',
                     traduz:function(v){ if(/^tem$/i.test(v)) return 'tem';
                                         if(/n[ãa]o tem/i.test(v)) return '1000'; return ''; } },
    manual:        { id:'avManual',   rot:'Manual do veículo' },
    revisoes:      { id:'avRevC',     rot:'Revisões concessionária' },
    garantia:      { id:'avGarantia', rot:'Garantia de fábrica',
                     traduz:function(v){ return /n[ãa]o sei/i.test(v) ? '' : String(v||''); } },
    observacoes:   { id:'avObs',      rot:'Observação do cliente', texto:true }
  };

  /* o campo está esperando resposta? (a mesma régua do "Pedir ao cliente") */
  function _avCliVazio(id){
    var e=$(id); if(!e) return false;
    var t=String(e.value||'').trim();
    if(!t) return true;
    return /^(verificar|conferir|a definir|— a definir —|n[ãa]o sabe)$/i.test(t);
  }
  /* o <select> aceita este valor? Escrever o que ele não tem é escrever nada. */
  function _avCliCabe(id, val){
    var e=$(id); if(!e) return false;
    if(e.tagName!=='SELECT') return true;
    return Array.prototype.some.call(e.options||[], function(o){ return o.value===val || o.textContent===val; });
  }
  function _avCliEscreve(id, val){
    var e=$(id); if(!e) return false;
    e.value=val;
    try{ e.dispatchEvent(new Event('change',{bubbles:true})); }catch(_){}
    return String(e.value||'')===String(val);
  }

  async function avClienteCarregar(ids){
    _avCliLinha=null; _avCliPend=[];
    var box=$('avCliBox'); if(box) box.innerHTML='';
    if(!CLIENTE_RESPOSTAS_ON) return;
    if(!ids || !ids.length) return;
    var r=null;
    try{
      r=await supa.from('avaliacao_cliente')
        .select('id,respostas,fotos,atualizado_em')
        .in('avaliacao_id', ids).order('atualizado_em',{ascending:false}).limit(1);
    }catch(_){ return; }
    if(!r || r.error) return;                 /* falhou: não inventa nada */
    var l=((r&&r.data)||[])[0]; if(!l) return;
    _avCliLinha=l;
    avClienteAplicar(l);
  }

  function avClienteAplicar(l){
    /* 🐞 v565 — ZERAR AQUI, não só no `avClienteCarregar`. O teste pegou:
       aplicando duas vezes na mesma tela (o que acontece de verdade quando a
       avaliação é reaberta sem recarregar o app), as pendências da vez
       anterior continuavam na lista e o aviso ressuscitava conflito que já
       tinha sido resolvido. Quem monta a lista é quem limpa a lista. */
    _avCliPend=[];
    var resp=(l&&l.respostas&&typeof l.respostas==='object') ? l.respostas : {};
    var jaFoi=(resp.aproveitado&&typeof resp.aproveitado==='object') ? resp.aproveitado : {};
    var entraram=[], _novoAproveitado={};

    Object.keys(_AVCLI_MAPA).forEach(function(k){
      if(resp[k]==null || resp[k]==='') return;
      var m=_AVCLI_MAPA[k];
      var val = m.traduz ? m.traduz(resp[k]) : String(resp[k]);
      if(val==='') return;
      var atual=String((($(m.id)||{}).value)||'').trim();

      if(jaFoi[k]){ return; }                 /* já entrou numa abertura anterior */

      if(_avCliVazio(m.id)){
        if(m.texto){
          /* observação SOMA, não troca: o que você escreveu continua lá */
          var jun = atual ? (atual+' · '+val) : val;
          if(_avCliEscreve(m.id, jun)){ entraram.push(m.rot); _novoAproveitado[k]=1; }
          return;
        }
        if(_avCliCabe(m.id, val) && _avCliEscreve(m.id, val)){ entraram.push(m.rot); _novoAproveitado[k]=1; }
        else _avCliPend.push({ k:k, rot:m.rot, val:val, cru:String(resp[k]) });
        return;
      }
      /* você já respondeu: NÃO toca. Vira linha do aviso. */
      if(String(atual).toLowerCase()!==String(val).toLowerCase())
        _avCliPend.push({ k:k, rot:m.rot, val:val, cru:String(resp[k]), seu:atual });
      else _novoAproveitado[k]=1;             /* respondeu igual: nada a decidir */
    });

    /* ---- opcionais confirmados: adição pura, entram na ficha ---- */
    var opcNovos=[];
    try{
      var opc=(Array.isArray(resp.opcionais)?resp.opcionais:[]).map(function(x){ return String(x||'').trim(); }).filter(Boolean);
      if(opc.length && !jaFoi.opcionais && typeof fichaResumoLer==='function'){
        var placa=(veiculoAtual&&veiculoAtual.placa)||'';
        var fr=fichaResumoLer(placa)||{};
        var marc=(fr.marcados||[]).slice(0);
        opc.forEach(function(x){ if(marc.indexOf(x)<0){ marc.push(x); opcNovos.push(x); } });
        if(opcNovos.length && typeof fichaResumoSalvar==='function'){
          fr.marcados=marc; fichaResumoSalvar(placa, fr);
          entraram.push(opcNovos.length+' opcional(is)');
          _novoAproveitado.opcionais=1;
        }
      }
    }catch(_){}

    /* ---- fotos: somam às suas ---- */
    var fotosNovas=0;
    try{
      var fs=(Array.isArray(l.fotos)?l.fotos:[]).filter(Boolean);
      if(fs.length){
        var tem={}; (_avFotos||[]).forEach(function(u){ tem[String(u)]=1; });
        fs.forEach(function(u){ if(!tem[String(u)]){ _avFotos.push(String(u)); fotosNovas++; } });
        if(fotosNovas){ try{ avFotosSalvar(); }catch(_){} try{ avFotosPinta(); }catch(_){} }
      }
    }catch(_){}

    if(Object.keys(_novoAproveitado).length) avClienteMarcar(l, _novoAproveitado);
    avClientePinta(entraram, fotosNovas, (resp.quando||l.atualizado_em||''));
    if(entraram.length){ try{ calcAvaliacao(); }catch(_){} try{ avFormSalvar(); }catch(_){} }
  }

  /* anota no banco o que já foi aproveitado — assim abrir de novo não
     reescreve o campo que você mudou depois nem repete o aviso.
     🔴 REGRA 6: sem o .select('id') isto "daria certo" com zero linhas. */
  async function avClienteMarcar(l, novos){
    try{
      var resp=Object.assign({}, l.respostas||{});
      resp.aproveitado=Object.assign({}, resp.aproveitado||{}, novos);
      var r=await supa.from('avaliacao_cliente').update({ respostas:resp })
        .eq('id', l.id).select('id');
      if(!r || r.error || !((r.data||[]).length)){
        try{ console.warn('[cliente] não consegui marcar o aproveitado'); }catch(_){}
      } else { l.respostas=resp; }
    }catch(_){}
  }

  function avClientePinta(entraram, fotosNovas, quando){
    var box=$('avCliBox'); if(!box) return;
    if(!entraram.length && !fotosNovas && !_avCliPend.length){ box.innerHTML=''; return; }
    var qd=''; try{ if(quando) qd=new Date(quando).toLocaleDateString('pt-BR'); }catch(_){}
    var h='<div class="avcli"><div class="avcli-hd">'+
      '<b>O cliente respondeu</b>'+(qd?('<i>'+esc(qd)+'</i>'):'')+'</div>';
    if(entraram.length || fotosNovas){
      var oks=entraram.slice(0);
      if(fotosNovas) oks.push(fotosNovas+' foto(s)');
      h+='<div class="avcli-ok">Já entrou: '+esc(oks.join(' · '))+'</div>';
    }
    if(_avCliPend.length){
      h+='<div class="avcli-sub">Aqui você já tinha respondido. Use o do cliente se quiser:</div>';
      h+=_avCliPend.map(function(p,i){
        return '<div class="avcli-li"><div class="avcli-tx"><b>'+esc(p.rot)+'</b>'+
          '<span>cliente: '+esc(p.cru)+(p.seu?(' · você: '+esc(p.seu)):'')+'</span></div>'+
          '<button type="button" class="avcli-bt" data-avcli="'+i+'">Usar</button></div>';
      }).join('');
    }
    h+='</div>';
    box.innerHTML=h;
    Array.prototype.forEach.call(box.querySelectorAll('[data-avcli]'), function(bt){
      bt.onclick=function(){
        var p=_avCliPend[Number(bt.getAttribute('data-avcli'))]; if(!p) return;
        var m=_AVCLI_MAPA[p.k]; if(!m) return;
        if(!_avCliCabe(m.id, p.val)){ toast('Esta resposta não cabe no campo.'); return; }
        _avCliEscreve(m.id, p.val);
        bt.textContent='Usado ✓'; bt.disabled=true; bt.classList.add('feito');
        var mk={}; mk[p.k]=1;
        if(_avCliLinha) avClienteMarcar(_avCliLinha, mk);
        try{ calcAvaliacao(); }catch(_){}
        try{ avFormSalvar(); }catch(_){}
      };
    });
  }

  async function avtOfertasCarregar(placa){
    var box=$('avtOfertas'); if(!box) return; box.innerHTML='';
    try{
      var ra=await supa.from('avaliacoes').select('id').eq('user_id',meuId).eq('placa',placa);
      var ids=((ra&&ra.data)||[]).map(function(r){return r.id;}); if(!ids.length) return;
      /* v565: a mesma leva de ids serve pras respostas do cliente — nada de
         uma segunda ida ao banco só pra descobrir o que já está aqui. */
      try{ avClienteCarregar(ids); }catch(_){}
      var ro=await supa.from('ofertas').select('loja_nome,valor,obs,sem_interesse,criado_em,whatsapp').in('avaliacao_id',ids).order('valor',{ascending:false});
      var rows=(ro&&ro.data)||[];
      var ofertas=rows.filter(function(o){return !o.sem_interesse;}), recusas=rows.filter(function(o){return !!o.sem_interesse;});
      var html='<div class="avt-photo-card" style="border-color:'+(ofertas.length?'#bbf7d0':'#e2e8f0')+';background:'+(ofertas.length?'#f0fdf4':'#f8fafc')+'"><div class="avt-photo-title">🤝 Ofertas dos lojistas'+(ofertas.length?(' · '+ofertas.length):'')+(recusas.length?(' <span style="font-size:10px;color:#b91c1c;font-weight:800">· '+recusas.length+' sem interesse</span>'):'')+'</div>';
      if(!rows.length){ html+='<div style="font-size:11.5px;color:#94a3b8;font-weight:650;margin-top:5px">Nenhuma oferta recebida ainda. Envie o link pros lojistas.</div>'; }
      else {
        /* v292 (pedido) — RESPONDER O LOJISTA COM UM TOQUE.
           Cada oferta ganha um botão que abre o WhatsApp DAQUELE lojista com
           a mensagem já escrita. Você escolhe qual resposta e toca uma vez.
           Nas ofertas antigas (antes da v292) não existe telefone guardado —
           lá o botão não aparece, com o motivo à mostra, em vez de aparecer
           e não funcionar. */
        html+=ofertas.map(function(o,i){
          return '<div class="avt-of"><div class="min"><b>'+esc(o.loja_nome||'Lojista')+(i===0?' <span class="tag">MAIOR</span>':'')+'</b>'+
            (o.obs?'<div class="obs">'+esc(o.obs)+'</div>':'')+
            _ofRespostaHtml(o, i===0)+
            '</div><div class="val">'+brl(o.valor)+'</div></div>'; }).join('');
        html+=recusas.map(function(o){ return '<div class="avt-of rec"><div class="min"><b>'+esc(o.loja_nome||'Lojista')+'</b>'+(o.obs?'<div class="obs">'+esc(o.obs)+'</div>':'')+'</div><div class="no">Sem interesse</div></div>'; }).join('');
      }
      html+='</div>'; box.innerHTML=html;
      _ofRespostaWire(box, ofertas, placa);
    }catch(e){ box.innerHTML=''; }
  }

  /* ===== v694 — MANDAR PRO VENDEDOR DO CARRO ==============================
     Pedido do Angelo (28/08): "adicione abaixo de cotacoes lojistas, um
     campo pra mandar a avaliacao pro vendedor do avaliex — coloco o valor
     que consegui de avaliacao e envio".
     O vendedor é o CLIENTE do laudo — nome e WhatsApp vêm do bilhete da
     v691 (mev_avcli:PLACA), editáveis; o valor nasce do "Valor avaliado"
     do formulário e também é editável. O botão ABRE o WhatsApp com o texto
     pronto — NUNCA manda sozinho (a mesma regra do v292, logo acima). */
  /* v702 — "quando eu digitar os dados a primeira vez vai pro cadastro de
     clientes, como vendedor". Achar-ou-criar com a REGRA DA CASA (v517:
     crmFoneChave = 8 últimos dígitos — resolve o nono dígito sozinho).
     Ficha já existente NUNCA é duplicada nem sobrescrita; a nova nasce com
     origem "Vendedor do carro" e a placa/carro da troca preenchidos. */
  async function avtVendCliGrava(nome, dig, placa, carro){
    try{
      if(!meuId || !window.supa || (!nome && !dig)) return;
      var achado=null;
      try{
        var chave=(typeof crmFoneChave==='function')?crmFoneChave(dig):'';
        if(chave && Array.isArray(_clientes)){
          achado=_clientes.filter(function(c){
            return (typeof crmFoneChave==='function') && crmFoneChave(c.telefone)===chave; })[0]||null;
        }
        if(!achado && nome && typeof cliNomeIgual==='function') achado=cliNomeIgual(nome)||null;
      }catch(_){ achado=null; }
      if(achado) return;                       /* primeira vez SÓ — não duplica */
      var ins={ user_id:meuId,
        nome: nome || ((typeof _crmFoneFmt==='function')?_crmFoneFmt(dig):dig),
        origem:'Vendedor do carro',
        placa_troca:placa||null, veiculo_troca:carro||null };
      if(dig) ins.telefone=(typeof foneFmt==='function')?foneFmt(dig):dig;
      var r=await supa.from('clientes').insert(ins).select().single();
      if(r && r.data){
        try{ if(Array.isArray(_clientes)) _clientes.push(r.data); }catch(_){}
        toast('Vendedor guardado no cadastro de clientes ✓');
      }
    }catch(_){}
  }
  function avtVendedorCard(box, placa){
    if(!box || $('avtVend')) return;
    var pl=String(placa||((veiculoAtual||{}).placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    var bil=null; try{ bil=JSON.parse(localStorage.getItem('mev_avcli:'+pl)||'null'); }catch(_){ bil=null; }
    bil=bil||{};
    var v=veiculoAtual||{};
    var valorIni=String((($('avValor')||{}).value)||'').trim();
    var d=document.createElement('div');
    d.className='avt-photo-card'; d.id='avtVend';
    /* v696: emoji vira SVG da casa (o "enviar" de papel de avião) */
    d.innerHTML='<div class="avt-photo-title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;vertical-align:-2px;margin-right:5px"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>Mandar pro vendedor do carro</div>'+
      '<div class="avt-vend-sub">O valor que você conseguiu, direto no WhatsApp de quem está vendendo o carro. Nada sai sem você apertar enviar lá.</div>'+
      '<div class="avt-vend-g">'+
        '<div class="avx-campo"><label>Nome</label><input id="avtVendNome" class="avt-in" value="'+esc(bil.nome||'')+'" placeholder="Quem está vendendo"></div>'+
        '<div class="avx-campo"><label>WhatsApp</label><input id="avtVendTel" class="avt-in" inputmode="tel" value="'+esc((typeof foneFmt==='function'&&bil.tel)?foneFmt(bil.tel):(bil.tel||''))+'" placeholder="(00) 00000-0000"></div>'+
        '<div class="avx-campo"><label>Valor conseguido (R$)</label><input id="avtVendValor" class="avt-in" inputmode="numeric" value="'+esc(valorIni)+'" placeholder="R$ 0"></div>'+
      '</div>'+
      '<button type="button" class="of-resp" id="avtVendBt">Mandar no WhatsApp</button>';
    box.appendChild(d);
    /* v702 — "puxe o nome do vendedor e numero do pdf do avaliex se tiver":
       o bilhete local pode não existir NESTE aparelho (importou no outro).
       A nuvem guarda desde a v702 — busca e preenche SÓ campo vazio. */
    if(!bil.nome || !bil.tel){
      try{
        docHistCloudLoadOne('aval_cli', pl, function(o){
          if(!o) return;
          var nEl=$('avtVendNome'), tEl=$('avtVendTel');
          if(nEl && !String(nEl.value||'').trim() && o.nome) nEl.value=o.nome;
          if(tEl && !String(tEl.value||'').trim() && o.tel)
            tEl.value=(typeof foneFmt==='function')?foneFmt(o.tel):o.tel;
          try{ localStorage.setItem('mev_avcli:'+pl, JSON.stringify(o)); }catch(_){}
        });
      }catch(_){}
    }
    (function(){ var tl=$('avtVendTel'); if(tl && typeof foneFmt==='function') tl.oninput=function(){ this.value=foneFmt(this.value); }; })();
    (function(){ var vl=$('avtVendValor'); if(vl && typeof _avlMaskRs==='function') _avlMaskRs(vl); })();
    /* 🔴 v797 — O DROPDOWN DE QUEM JÁ ESTÁ CADASTRADO
       "na proxima aparece uma lista em dropdown enquanto digita, com os
        vendedores e lojistas cadastrados". A porta nova (folha do card) e
       ESTE card usam o MESMO dropdown — quem faz é o 05k. */
    try{ propVendAuto($('avtVendNome'), $('avtVendTel')); }catch(_){}
    try{ propVendCarregar(); }catch(_){}
    /* 🔴 v797 — O ENVIO PASSOU A MORAR NO 05k (propVendEnviar).
       Antes o texto da mensagem, a validação, o bilhete, a gravação na nuvem
       e o cadastro estavam escritos AQUI. Com a porta nova da folha do card
       virariam DUAS cópias da mesma coisa — e duas cópias viram dois textos
       diferentes em três versões (a lição da v566/v568). Agora é um lugar só
       (v390: um nome só pra cada coisa). O comportamento é o mesmo, inclusive
       o "nunca envia sozinho". ⚠️ ÚNICA diferença de texto: o aviso de valor
       vazio virou "Coloque o valor da proposta." (era "o valor que você
       conseguiu") — as duas portas precisam falar igual, e "proposta" é como
       o Angelo chamou. */
    $('avtVendBt').onclick=function(){
      propVendEnviar({
        nome:  (($('avtVendNome')||{}).value)||'',
        tel:   (($('avtVendTel')||{}).value)||'',
        valor: (typeof _avlSoNum==='function')?_avlSoNum((($('avtVendValor')||{}).value)):0,
        placa: pl,
        carro: String(((v.marca||'')+' '+(v.modelo||'')).trim()||'o veículo')
      });
    };
  }
  /* ===== v292 — A RESPOSTA PRO LOJISTA QUE OFERTOU =====
     Ele mandou uma proposta e ficava sem retorno: não havia contato guardado
     e não havia botão. Agora o número vem junto da oferta (a página passou a
     pedir) e a resposta sai com um toque, com o texto pronto.

     POR QUE NÃO SAI SOZINHA: mandar WhatsApp sem ninguém tocar exige a API
     oficial do WhatsApp Business — cadastro na Meta, modelos aprovados e
     custo por conversa. Com um toque funciona hoje, de graça, e ainda deixa
     você ler antes de enviar. */
  function _ofZap(o){
    var d=String((o&&o.whatsapp)||'').replace(/\D/g,'');
    if(!d) return '';
    if(d.length<10) return '';
    return d.length<=11 ? ('55'+d) : d;
  }
  function _ofRespostaHtml(o, ehMaior){
    if(_ofZap(o)) return '<button type="button" class="of-resp" data-zap="'+esc(_ofZap(o))+'" data-loja="'+esc(o.loja_nome||'')+'" data-valor="'+(Number(o.valor)||0)+'">Responder no WhatsApp</button>';
    return '<div class="of-semzap">Oferta antiga — sem WhatsApp guardado</div>';
  }
  function _ofRespostaWire(box, ofertas, placa){
    var v=veiculoAtual||{};
    var carro=String(((v.marca||'')+' '+(v.modelo||'')).trim()||'o veículo');
    var pl=String(placa||v.placa||'');
    Array.prototype.forEach.call(box.querySelectorAll('.of-resp'), function(b){
      b.onclick=function(){
        var zap=b.getAttribute('data-zap'), loja=b.getAttribute('data-loja')||'', valor=Number(b.getAttribute('data-valor'))||0;
        _ofEscolherResposta(zap, loja, valor, carro, pl);
      };
    });
  }
  function _ofEscolherResposta(zap, loja, valor, carro, placa){
    var quem=String(loja||'').trim(), oi=quem?('Olá, '+quem+'! '):'Olá! ';
    var doCarro=carro+(placa?(' ('+placa+')'):'');
    /* As três respostas que a loja realmente dá. Texto pronto, mas editável
       no WhatsApp antes de enviar — ninguém manda no automático o que não leu. */
    var OPCOES=[
      { rot:'Aceitar a oferta',   sub:'Fechado por '+r$(valor),
        txt: oi+'Fechamos no seu valor de '+r$(valor)+' pelo '+doCarro+'. Pode vir buscar — me confirme o melhor horário.' },
      { rot:'Fazer contraproposta', sub:'Pedir um valor melhor', pedirValor:true },
      { rot:'Avisar que já saiu',  sub:'O carro foi negociado',
        txt: oi+'Obrigado pela oferta de '+r$(valor)+' no '+doCarro+'. Ele acabou sendo negociado, mas já te aviso no próximo.' }
    ];
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').textContent='💬'; $('cliMt').textContent='Responder '+(quem||'o lojista');
    $('cliMbody').innerHTML='<div class="cad-msg" style="margin:0 0 12px;color:#64748b">Escolha a resposta. O WhatsApp abre com o texto pronto — dá pra editar antes de enviar.</div>'+
      OPCOES.map(function(op,i){ return '<button type="button" class="of-op" data-i="'+i+'"><b>'+esc(op.rot)+'</b><small>'+esc(op.sub)+'</small></button>'; }).join('')+
      '<div id="ofContra" style="display:none;margin-top:10px">'+
        '<label class="cad-lbl">Seu valor</label><input class="cad-in" id="ofContraV" inputmode="numeric" placeholder="R$ 0">'+
        '<button type="button" class="cad-btn" id="ofContraOk" style="margin-top:8px">Abrir o WhatsApp</button>'+
      '</div>';
    function manda(txt){
      try{ cliModalEl().classList.remove('on'); }catch(_){}
      var u='https://wa.me/'+zap+'?text='+encodeURIComponent(txt);
      try{ window.open(u,'_blank'); }catch(_){ location.href=u; }
    }
    Array.prototype.forEach.call($('cliMbody').querySelectorAll('.of-op'), function(b){
      b.onclick=function(){
        var op=OPCOES[Number(b.getAttribute('data-i'))||0];
        if(op.pedirValor){
          var cx=$('ofContra'); if(cx) cx.style.display='block';
          var iv=$('ofContraV'); if(iv){ iv.oninput=avMaskRS; try{ iv.focus(); }catch(_){} }
          var ok=$('ofContraOk');
          if(ok) ok.onclick=function(){
            var n=parseInt(String((($('ofContraV')||{}).value)||'').replace(/\D/g,''),10)||0;
            if(!n){ try{ toast('Digite o valor.'); }catch(_){} return; }
            manda(oi+'Obrigado pela oferta de '+r$(valor)+' no '+doCarro+'. Consigo fechar em '+r$(n)+'. Fica bom pra você?');
          };
          return;
        }
        manda(op.txt);
      };
    });
  }
  function avFotosKey(){ return 'mev_avfotos:'+((veiculoAtual&&veiculoAtual.placa)||'x'); }
  function avFotosTsKey(){ return 'mev_avfotos_ts:'+((veiculoAtual&&veiculoAtual.placa)||'x'); }
  /* Fotos do veículo ficam no bucket público reservado a imagens de carros.
     Antes de renderizar ou sincronizar, aceita somente URL HTTPS desse bucket
     e, com sessão ativa, do diretório do usuário atual. Isso evita que uma URL
     guardada localmente por outra conta apareça nesta avaliação. */
  function avFotoUrlSegura(url){
    try{
      var u=new URL(String(url||''));
      if(u.protocol!=='https:') return '';
      var marcador='/storage/v1/object/public/avaliacao-fotos/';
      var caminho=decodeURIComponent(u.pathname||''), pos=caminho.indexOf(marcador);
      if(pos<0) return '';
      var objeto=caminho.slice(pos+marcador.length);
      if(!objeto || objeto.indexOf('/')<1) return '';
      if(meuId && objeto.indexOf(String(meuId)+'/')!==0) return '';
      return u.href;
    }catch(_){ return ''; }
  }
  function avFotosNormaliza(lista){
    var vistos={}, out=[];
    (Array.isArray(lista)?lista:[]).forEach(function(item){
      var url=avFotoUrlSegura(typeof item==='string'?item:(item&&item.url));
      if(url&&!vistos[url]){ vistos[url]=true; out.push(url); }
    });
    return out;
  }
  function avFotosTsLocal(){
    try{ return Math.max(0,Number(localStorage.getItem(avFotosTsKey())||0)||0); }catch(_){ return 0; }
  }
  function avFotosSalvarLocal(ts){
    try{
      ts=Number(ts)>0?Math.floor(Number(ts)):Date.now();
      localStorage.setItem(avFotosKey(), JSON.stringify(_avFotos));
      localStorage.setItem(avFotosTsKey(),String(ts));
      return ts;
    }catch(_){ return 0; }
  }
  function avFotosSalvarNuvem(ts){
    try{
      var placa=(veiculoAtual&&veiculoAtual.placa)||'';
      if(!placa || !(window.supa&&meuId)) return;
      /* Não usa a fila genérica: ela não é segmentada por usuário. Se a rede
         falhar, a lista continua local e a próxima abertura autenticada tenta
         sincronizá-la de novo, sem risco de uma troca de sessão reaproveitar
         referências de foto de outra conta. */
      var agora=Number(ts)>0?Math.floor(Number(ts)):Date.now(), dono=String(meuId), fotos=avFotosNormaliza(_avFotos);
      /* ===== 🔴 v811 — A RÉGUA DA v483, APLICADA AQUI ======================
         PROBLEMA RELATADO (01/09): "ontem já tinha enviado no celular e não
         salvou na avaliação, mas ela tá em estoque com as fotos."

         🔴 É EXATAMENTE A ARMADILHA DA v483, escrita no CLAUDE.md: um
         `upsert` barrado por RLS **NÃO é erro** no supabase-js — ele volta
         "sucesso" com ZERO LINHAS. Este bloco só olhava `r.error`, que fica
         nulo nesse caso. Resultado: a foto ficava no `localStorage` do
         aparelho, aparecia na tela, e nunca chegava no banco. Em outro
         aparelho, sumia. E o Estoque continuava com as fotos porque ele
         grava em OUTRA tabela, por outro caminho.

         Agora o gravar PEDE A LINHA DE VOLTA (`.select('user_id')`) e
         confere. Sem linha, a pessoa é AVISADA — em vez de descobrir semanas
         depois que a avaliação está sem foto.
         ⚠️ E o carimbo local NÃO é apagado: a foto continua no aparelho e a
         próxima abertura autenticada tenta sincronizar de novo. */
      supa.from('doc_consulta').upsert({
        user_id:dono, tipo:'aval_fotos', chave:String(placa), tipo_doc:'fotos',
        resultado:{fotos:fotos}, ts:agora, atualizado_em:new Date().toISOString()
      },{onConflict:'user_id,tipo,chave'}).select('user_id').then(function(r){
        if(r&&r.error){
          try{ console.warn('[MEV] fotos da avaliação não sincronizaram:',r.error.message||r.error); }catch(_){}
          try{ toast('As fotos ficaram só neste aparelho — não consegui salvar na avaliação.'); }catch(_){}
          return;
        }
        var linhas=(r&&r.data&&r.data.length)||0;
        if(!linhas){
          try{ console.warn('[MEV] fotos da avaliação: o banco aceitou e devolveu ZERO linhas (RLS?)'); }catch(_){}
          try{ toast('As fotos ficaram só neste aparelho — o banco não gravou. Avise o suporte.'); }catch(_){}
        }
      },function(e){
        try{ console.warn('[MEV] fotos da avaliação não sincronizaram:',(e&&e.message)||e); }catch(_){}
        try{ toast('As fotos ficaram só neste aparelho — sem conexão com o banco.'); }catch(_){}
      });
    }catch(_){}
  }
  function avFotosSalvar(){
    _avFotos=avFotosNormaliza(_avFotos);
    var ts=avFotosSalvarLocal(Date.now());
    try{ clearTimeout(_avFotosCloudTimer); _avFotosCloudTimer=setTimeout(function(){
      avFotosSalvarNuvem(ts);
      /* 🔴 v710 — toda mudança de foto (capa, anexo, exclusão) chega na LINHA
         de `avaliacoes`, porque é do pacote dela que o card de Avaliações tira
         a capa e o aval-share tira a miniatura do WhatsApp. A mesma dupla do
         Salvar e fechar (v709): garante a linha (adota, nunca duplica) e
         regrava o pacote em silêncio. Nada disso gera link nem publica. */
      try{ avLojGarantirLinha().then(function(){ try{ avLojAtualizar(); }catch(_){} }); }catch(_){}
    },500); }catch(_){}
  }
  /* ==========================================================================
     🔴 v815 — AS FOTOS DO ESTOQUE APARECEM NA AVALIAÇÃO
     -------------------------------------------------------------------------
     PEDIDO (01/09): "não aparece porque foram carregadas no estoque e não na
     avaliação, mas era pra aparecer."

     Ele está certo, e o motivo do vão é histórico: avaliação e estoque
     guardam a lista de fotos em lugares DIFERENTES (doc_consulta/aval_fotos
     × mp_estoque.fotos), porque o carro avaliado pode nunca entrar no
     estoque. Só que quando ele entra, é o MESMO carro e a MESMA placa — e
     quem olha a avaliação espera ver as fotos.

     O que esta função faz: se a avaliação está SEM foto nenhuma e existe um
     veículo SEU no estoque com a mesma placa, as fotos dele aparecem na
     avaliação, marcadas como vindas do estoque, com um botão pra adotá-las.

     🔴 Três cuidados:
     1. ESPELHO, NÃO CÓPIA. `_avFotosEst` é uma lista à parte. Nada entra em
        `_avFotos` sem o toque no botão — então o link dos lojistas, a arte e
        a miniatura do WhatsApp continuam saindo só com o que VOCÊ pôs na
        avaliação. Adotar em silêncio seria publicar foto que ninguém mandou.
     2. Só quando a avaliação está vazia. Tendo foto própria, ela manda.
     3. A régua do dono: `.eq('user_id', meuId)` — a placa sozinha não basta,
        o mesmo carro pode estar no estoque de outra loja.
     O bucket é o MESMO (`avaliacao-fotos`, por usuário): o estoque envia
     pelo mesmo avUpload, então o avFotosNormaliza aceita e a checagem de
     dono de sempre continua valendo. */
  function avFotosDoEstoque(){
    try{
      var placa=limpa((veiculoAtual&&veiculoAtual.placa)||''), dono=String(meuId||'');
      if(!placa || !(window.supa&&dono)) return;
      supa.from('estoque').select('fotos').eq('user_id',dono).eq('placa',placa).limit(1)
        .then(function(r){
          if(limpa((veiculoAtual&&veiculoAtual.placa)||'')!==placa || String(meuId||'')!==dono) return;
          if(r&&r.error) return;
          var linha=(r&&r.data&&r.data[0])||null; if(!linha) return;
          var fs=avFotosNormaliza(linha.fotos);
          if(!fs.length) return;
          _avFotosEst=fs;
          if(!_avFotos.length){ try{ avFotosPinta(); }catch(_){} }
        }, function(){});
    }catch(_){}
  }
  function avFotosRestaurar(){
    try{ _avFotos=avFotosNormaliza(JSON.parse(localStorage.getItem(avFotosKey())||'null')); }catch(_){ _avFotos=[]; }
    _avFotosEst=[]; try{ avFotosDoEstoque(); }catch(_){}   /* v815 */
    /* A versão mais recente prevalece, sem apagar um anexo local que ainda não
       chegou à nuvem. Se for uma foto antiga, só local, a primeira abertura
       autenticada do aparelho original a indexa no rascunho. */
    try{
      var placa=(veiculoAtual&&veiculoAtual.placa)||'', dono=String(meuId||'');
      if(!placa || !(window.supa&&dono)) return;
      supa.from('doc_consulta').select('resultado,ts').eq('user_id',dono).eq('tipo','aval_fotos').eq('chave',String(placa)).maybeSingle().then(function(r){
        if(((veiculoAtual&&veiculoAtual.placa)||'')!==placa || String(meuId||'')!==dono) return;
        var localTs=avFotosTsLocal(), reg=(r&&r.data)||null;
        if(!reg){
          if(localTs>0 || _avFotos.length) avFotosSalvarNuvem(localTs||Date.now());
          return;
        }
        var dados=reg.resultado||{};
        if(typeof dados==='string'){ try{ dados=JSON.parse(dados); }catch(_){ dados={}; } }
        var remotas=avFotosNormaliza(dados.fotos), remotoTs=Math.max(0,Number(reg.ts)||0);
        if(remotoTs>=localTs){
          _avFotos=remotas; avFotosSalvarLocal(remotoTs||Date.now()); avFotosPinta();
        }else if(localTs>0 || _avFotos.length){
          avFotosSalvarNuvem(localTs||Date.now());
        }
      },function(){
        var localTs=avFotosTsLocal();
        if(localTs>0 || _avFotos.length) avFotosSalvarNuvem(localTs||Date.now());
      });
    }catch(_){}
  }
  function avGaleriaPinta(ctx){
    var el=ctx.el; if(!el) return;
    var _avFotos=avFotosNormaliza(ctx.get());
    function avFotosSalvar(){ ctx.set(_avFotos); }
    function avFotosPinta(){ ctx.paint(); }
    var placa=String((veiculoAtual||{}).placa||''), dono=meuId, formulario=$('avClienteJ');
    function vigente(){ return dono===meuId&&placa===String((veiculoAtual||{}).placa||'')&&el.isConnected&&(!ctx.cliente||formulario===$('avClienteJ')); }
    var html=_avFotos.map(function(f,i){ return '<div class="av-thumb"><img alt="Foto do veículo" '+(i?'loading="lazy" ':'')+'decoding="async" src="'+esc(imgCdn(f,400))+'">'+(i===0?'<span class="av-capa">capa</span>':'<button type="button" class="av-mkcapa" data-i="'+i+'" title="Usar esta foto como capa — vira a miniatura do link no WhatsApp" aria-label="Usar como capa"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg></button>')+'<button type="button" class="av-ia" data-i="'+i+'" aria-label="Editar a foto '+(i+1)+' com IA" title="Editar com IA">'+_fotoIaIco('completa')+'</button><button type="button" class="av-del" aria-label="Remover foto" title="Remover foto" data-i="'+i+'">&times;</button></div>'; }).join('');
    html+='<button type="button" class="av-addfoto" data-galeria-add aria-label="Adicionar fotos" title="Adicionar fotos">+</button>';
    var shown=_avFotos.length+1, fillTo=Math.max(4, Math.ceil(shown/4)*4);
    for(var k=shown;k<fillTo;k++){ html+='<div class="av-fotoempty" aria-hidden="true"></div>'; }
    el.innerHTML=html;
    var add=el.querySelector('[data-galeria-add]');
    if(add) add.onclick=function(){ctx.add();};
    Array.prototype.forEach.call(el.querySelectorAll('.av-thumb .av-del'),function(b){ b.onclick=function(){ _avFotos.splice(parseInt(b.getAttribute('data-i'),10)||0,1); avFotosSalvar(); avFotosPinta(); }; });
    /* ==========================================================================
       🔴 v878 — SEGURAR O DEDO ABRE A FOTO GRANDE (pedido do Angelo, 04/09:
       "se apertar e segurar na imagem abre uma pré-visualização na tela")
       --------------------------------------------------------------------------
       Desde a v876 o quadro INTEIRO abre o menu da IA. Isso resolveu o botão que
       tapava o carro, mas tirou o jeito de simplesmente OLHAR a foto de perto —
       e numa grade de 110 px, saber qual é qual às vezes só olhando grande.

       Agora são dois gestos no mesmo quadro:
         · toque rápido  → o menu da IA (como está desde a v876)
         · segurar 480ms → a foto em tela cheia, com ‹ › pra passar as outras

       ⚠️ O `_avLongPress` MARCA que houve segurada, e o `onclick` respeita essa
       marca. Sem isso o dedo levantado depois da pré-visualização abriria o menu
       POR CIMA dela — o visualizador aparece e some no mesmo movimento, e a
       pessoa jura que o app travou.
       ⚠️ 480 ms é o número do iOS pro toque longo. Menos que isso e um toque
       normal meio demorado vira pré-visualização; mais, e ninguém espera.
       ⚠️ E QUALQUER ARRASTO DE MAIS DE 10 px CANCELA: a grade rola com o dedo,
       e rolar a tela não pode abrir foto. */
    Array.prototype.forEach.call(el.querySelectorAll('.av-thumb .av-ia'),function(b){
      var _lpT=null, _lpFez=false, _lpX=0, _lpY=0;
      function _lpLimpa(){ if(_lpT){ clearTimeout(_lpT); _lpT=null; } }
      b.addEventListener('pointerdown',function(ev){
        _lpFez=false; _lpX=ev.clientX; _lpY=ev.clientY;
        _lpLimpa();
        _lpT=setTimeout(function(){
          _lpT=null; _lpFez=true;
          var i=Math.max(0,Math.min(parseInt(b.getAttribute('data-i'),10)||0,_avFotos.length-1));
          /* `editar:false`: aqui é só olhar. As ações da foto moram na grade. */
          try{ fotosVerAbrir(_avFotos, i, {editar:false}); }catch(_){ }
        },480);
      });
      b.addEventListener('pointermove',function(ev){
        if(!_lpT) return;
        if(Math.abs(ev.clientX-_lpX)>10||Math.abs(ev.clientY-_lpY)>10) _lpLimpa();
      });
      ['pointerup','pointercancel','pointerleave'].forEach(function(n){
        b.addEventListener(n,function(){ _lpLimpa(); });
      });
      b.onclick=function(e){
      e.preventDefault(); e.stopPropagation();
      if(_lpFez){ _lpFez=false; return; }   /* v878: já abriu a pré-visualização */
      var i=Math.max(0,Math.min(parseInt(b.getAttribute('data-i'),10)||0,_avFotos.length-1));
      var origem=_avFotos[i]; if(!origem||!vigente()) return;
      var _vIa=veiculoAtual||{},_nIa=function(id){return Number(String((($(id)||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''))||0;};
      var _dadosIa={
        placa:String(_vIa.placa||''),
        modelo:((_vIa.marca||'')+' '+(_vIa.modelo||'')).trim(),
        ano:(_vIa.ano&&_vIa.ano_modelo&&String(_vIa.ano)!==String(_vIa.ano_modelo))?(_vIa.ano+'/'+_vIa.ano_modelo):(_vIa.ano_modelo||_vIa.ano||''),
        precoPor:ctx.cliente?Number(($('avClientePreco')||{}).dataset.valor)||0:_nIa('avRepPreco'),km:_nIa('avKm'),
        fipe:Number(_vIa.fipe)||0,   /* v878 — o riscado da arte é a FIPE */
        cambio:String((($('avCambio')||{}).value)||''),combustivel:String(_vIa.combustivel||''),
        /* 🔴 v876 — a observação do cliente vira DESTAQUE da arte, e passa
           pelo `obsPublica()` (v265) antes: valor em dinheiro escrito à mão
           não vai pra uma arte pública. Vazio some — nada é inventado. */
        fatos:(function(){
          var t=''; try{ t=obsPublica(String((($(ctx.cliente?'avClienteObs':'avObs')||{}).value)||'')); }catch(_){ t=''; }
          return String(t||'').split(/[\n;·]+|,\s*/).map(function(x){
            return String(x||'').replace(/\s+/g,' ').trim();
          }).filter(Boolean);
        })()
      };
      if(ctx.cliente)_dadosIa.precoAnuncio=_dadosIa.precoPor;
      fotoIaEditarUrl(origem,ctx.cliente?'estoque':'avaliacao',async function(blob,meta){
        if(!vigente()) throw new Error('Reabra o veículo de origem para editar.');
        var url=await avUpload(blob,{tipo:'veiculo',protegida:{
          protecao:'ia',acao:meta&&meta.acao||'',mascaras:[],semPlacaConfirmado:true,
          confirmadoPor:meuId||'',confirmadoEm:new Date().toISOString(),versaoProtecao:2
        }});
        if(!url) throw new Error('upload sem URL');
        if(!vigente()) throw new Error('A avaliação mudou durante a edição.');
        _avFotos=avFotosNormaliza(ctx.get());
        var atual=(_avFotos[i]===origem)?i:_avFotos.indexOf(origem);
        if(atual<0) throw new Error('foto removida durante a edição');
        if(ctx.replace) ctx.replace(origem,url); else { _avFotos[atual]=url; avFotosSalvar(); }
        avFotosPinta(); return true;
      /* v877 — a galeria inteira vai junto: é dela que saem as miniaturas
         da montagem. O modal tira a foto principal da lista sozinho. */
      },b,_dadosIa,_avFotos);
    }; });
    Array.prototype.forEach.call(el.querySelectorAll('.av-thumb .av-mkcapa'),function(b){ b.onclick=function(){
      var i=parseInt(b.getAttribute('data-i'),10)||0;
      var f=_avFotos.splice(i,1)[0]; if(!f) return;
      _avFotos.unshift(f); avFotosSalvar();
      /* 🔴 v710 (pedido: "ajustei a capa, mas nao ajustou") — aqui morava um
         `_avLojUrl=''; _avLojId=''` de outra era, "pro próximo envio gerar o
         link já com a miniatura nova". Só que apagar o id fazia o próximo
         Gerar INSERIR outra linha (link novo → o já enviado ficava velho, o
         defeito que a v384 matou) e, sem update, o PACOTE da linha ficava com
         a ordem antiga — e é do pacote que saem a capa do card de Avaliações
         e a miniatura do WhatsApp (aval-share lê fotos[0]). Agora o
         avFotosSalvar regrava o pacote NA MESMA linha: mesmo link, capa nova
         nos dois lugares. */
      avFotosPinta(); toast('Capa atualizada.');
    }; });
  }
  function avFotosPinta(){
    _avFotos=avFotosNormaliza(_avFotos);
    var el=$('avFotos'); if(!el) return;
    avGaleriaPinta({el:el,get:function(){return _avFotos;},
      set:function(fs){_avFotos=fs;avFotosSalvar();},paint:avFotosPinta,
      add:function(){
        var input=$('avFotoInput');
        if(!input){input=document.createElement('input');input.type='file';input.accept='image/*';input.multiple=true;
          input.onchange=function(){avAddFotos(Array.from(input.files||[]));};}
        input.click();
      }});
    /* 🔴 v815 — O ESPELHO DO ESTOQUE.
       Avaliação vazia + carro seu no estoque com a mesma placa = as fotos
       dele aparecem AQUI, escritas de onde vieram, com um botão pra trazer.
       Elas ficam FORA do _avFotos até o toque: sem delete e sem "capa", pra
       ninguém achar que está mexendo na avaliação quando não está. */
    try{
      var esp=$('avFotosEst');
      if(!esp && el.parentNode){
        esp=document.createElement('div'); esp.id='avFotosEst'; esp.className='av-espelho';
        el.parentNode.insertBefore(esp, el.nextSibling);
      }
      if(esp){
        if(!_avFotos.length && _avFotosEst.length){
          var n=_avFotosEst.length;
          esp.innerHTML='<div class="av-esp-hd">'+
            '<span class="av-esp-tx"><b>'+n+' foto'+(n===1?'':'s')+' do estoque</b>'+
            '<small>Este carro já está no seu estoque com foto. Aqui elas são só uma prévia — o link dos lojistas ainda não as usa.</small></span>'+
            '<button type="button" class="av-esp-bt" id="avEspUsar">Usar na avaliação</button></div>'+
            '<div class="av-esp-tira">'+_avFotosEst.map(function(f,i){
              return '<div class="av-esp-th"><img '+(i?'loading="lazy" ':'')+'decoding="async" alt="Foto do veículo no estoque" src="'+esc(imgCdn(f,400))+'"></div>';
            }).join('')+'</div>';
          esp.style.display='';
          var bu=$('avEspUsar');
          if(bu) bu.onclick=function(){
            var trouxe=avFotosNormaliza(_avFotosEst);
            if(!trouxe.length){ toast('Não consegui ler as fotos do estoque.'); return; }
            _avFotos=trouxe; _avFotosEst=[];
            avFotosSalvar(); avFotosPinta();
            toast(trouxe.length+' foto'+(trouxe.length===1?'':'s')+' do estoque '+(trouxe.length===1?'entrou':'entraram')+' na avaliação ✓');
          };
        }else{
          esp.innerHTML=''; esp.style.display='none';
        }
      }
    }catch(_){}
    var c=$('avFotoCount'); if(c) c.textContent=_avFotos.length?(_avFotos.length+' foto(s) anexada(s) · prontas p/ o link'):(_avFotosEst.length?'As fotos abaixo são do estoque — toque em "Usar na avaliação" para trazê-las.':'Anexe fotos do veículo p/ o link dos lojistas.');
    /* v679 — a tira do VÍDEO mora logo abaixo e repinta junto. O motor está
       no 13b-video-da-avaliacao.js; aqui é uma chamada só. 🔴 _avFotos não
       foi tocada: vídeo tem lista própria (_avVideos) de propósito. */
    try{ if(typeof avvPinta==='function') avvPinta(); }catch(_){}
    /* v937: a galeria de Varejo não é mais uma fotografia da primeira
       abertura; ela acompanha cada inclusão feita no acervo da avaliação. */
    try{ if(typeof avDivClientePinta==='function') avDivClientePinta(); }catch(_){}
  }
  async function avAddFotos(files){
    if(!files||!files.length) return;
    /* ===== v808 (§6.2 do PROJETO-placa-mev-veiculos-nas-fotos) ============
       🔴 A TELA DE PROTEÇÃO VEM ANTES DO ENVIO. Até aqui a foto ia direto pro
       bucket PÚBLICO com a placa do cliente legível — e o link público da
       avaliação, as artes e a miniatura do WhatsApp saíam com ela.
       ⚠️ A original NÃO é enviada em lugar nenhum: o que sobe é o `blob`
       mascarado que sai do editor. */
    var prontas=[];
    try{ prontas=await fotoVeiculoPreparar(files, { origem:'avaliacao' }); }
    catch(_){ prontas=[]; }
    /* v811: "você fechou a tela" e "deu erro" escreviam a MESMA frase, e o
       Angelo leu isso como "o app parou de enviar foto". O editor agora
       marca o retorno quando falhou — e ele já avisou o motivo. */
    if(!prontas.length){
      if(!prontas.erro) toast('Nenhuma foto foi enviada — a proteção da placa não foi confirmada.');
      return;
    }
    toast('Enviando foto(s)...');
    for(var i=0;i<prontas.length;i++){
      try{
        var url=await avUpload(prontas[i].blob, { tipo:'veiculo', protegida:prontas[i] });
        if(url){ _avFotos.push(url); avFotosSalvar(); avFotosPinta(); }
      }catch(e){ toast('Falha ao enviar uma foto.'); }
    }
    toast('Foto(s) prontas.');
  }
  /* ===== v808 (§5.2) — O SEGUNDO PARÂMETRO, E POR QUE ELE É OBRIGATÓRIO ==
     O `avUpload` é a porta de upload de imagem do app inteiro. Além das fotos
     de VEÍCULO, passam por aqui:
         10-parceiros.js .............. dois logos de parceiro
         13b-video-da-avaliacao.js .... o poster do vídeo
         16-minha-loja.js ............. a logo da loja
         16b-vitrine-vendedor.js ...... a logo do vendedor
         16c-prova-social.js .......... loja, entregas e depoimentos
     (O §2.5 do projeto citava só o último — são CINCO.)

     🔴 POR ISSO A PROTEÇÃO **NUNCA** LIGA SOZINHA AQUI DENTRO. Se ligasse,
     a logo da loja abriria uma tela pedindo pra "proteger a placa" — e o
     lojista aprenderia a apertar "Sem placa — confirmar" no automático, que
     é como uma trava de segurança morre.
     O tipo `veiculo` é DECLARADO por quem chama, e quem chama já mascarou.
     ⚠️ Sem `opcoes`, o comportamento é exatamente o de antes. */
  async function avUpload(file, opcoes){
    opcoes=opcoes||{};
    if(opcoes.tipo==='veiculo'){
      /* §5.2: "exige publicoBlob protegido ou confirmação explícita de
         ausência de placa". Chegar aqui sem isso é defeito de quem chamou —
         e a foto NÃO sobe. */
      /* ⛳ v845 — A EXIGÊNCIA DORME JUNTO COM A PROTEÇÃO.
         Este `throw` é o guarda-costas da v808: ele impede que uma foto de
         veículo suba sem ter passado pelo editor. Com o interruptor
         `MEV_PROTEGE_PLACA` desligado (pedido do Angelo em 02/09), não existe
         editor pra passar — manter o guarda de pé faria o app simplesmente
         PARAR de enviar foto, que não é o que ele pediu.
         🔴 A regra continua escrita e continua valendo pro dia em que o
         interruptor voltar. Ela não foi apagada; ela está dormindo. */
      if(typeof window.edProtegePlaca==='function' && !window.edProtegePlaca()){
        /* proteção desligada: a foto sobe como está — ver o changelog da v845 */
      }else{
        var pr=opcoes.protegida;
        var ok = pr && (pr.semPlacaConfirmado===true || (pr.mascaras && pr.mascaras.length));
        if(!ok) throw new Error('foto de veículo sem revisão de placa');
      }
    }
    /* v299 — foto que chega com faixa branca colada na lateral perde a faixa
       AQUI, antes de subir. Depois de gravada não tem conserto pelo site: o
       branco vira pixel do arquivo, e nenhum ajuste de tela desfaz isso. */
    try{ var limpa=await tirarFaixas(file); if(limpa) file=limpa; }catch(_){}
    var b64=await reduzirImagem(file,1200,0.80);
    var bin=atob(b64); var arr=new Uint8Array(bin.length); for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    var blob=new Blob([arr],{type:'image/jpeg'});
    var path=(meuId||'anon')+'/'+Date.now()+'_'+Math.random().toString(36).slice(2)+'.jpg';
    /* O nome é único: cache longo não expõe versão antiga e reduz tráfego. */
    var up=await supa.storage.from('avaliacao-fotos').upload(path,blob,{contentType:'image/jpeg',cacheControl:'31536000',upsert:false});
    if(up&&up.error) throw up.error;
    var pub=supa.storage.from('avaliacao-fotos').getPublicUrl(path);
    /* ======================================================================
       🔴🔴🔴 v1081 — AQUI O ENVIO PODIA TERMINAR EM SILÊNCIO
       ----------------------------------------------------------------------
       Angelo, com print: "anexei fotos mas nao apareceram".

       Esta linha era `return avFotoUrlSegura(...)`. O `avFotoUrlSegura`
       devolve STRING VAZIA em cinco situações diferentes — endereço que não
       é https, bucket diferente do esperado, caminho que não começa pelo id
       do dono, objeto sem pasta, ou qualquer exceção. Nenhuma delas levanta
       erro.

       E quem chama faz `if(url){ …push… }` SEM else. Resultado: o arquivo
       subia (ou não), a lista não crescia, ninguém era avisado — e o
       `estAddFotos` ainda terminava dizendo "Foto(s) prontas".
       O app afirmava que tinha dado certo com zero fotos na tela.

       🔑 A CHECAGEM NÃO AFROUXOU — ela continua igual, letra por letra. O que
          muda é que a recusa agora TEM VOZ. E ela merece voz porque este
          endereço não veio do usuário: foi o próprio app que acabou de criar
          o arquivo e de pedir a URL dele. Se ele não confia no que ele mesmo
          produziu, isso é defeito, não entrada inválida — e defeito calado é
          o que esta casa não aceita.
       ⚠️ TODOS OS DEZ CHAMADORES do `avUpload` já estão dentro de try/catch.
          Antes eles engoliam um '' sem saber; agora recebem uma mensagem com
          o motivo. Nenhum deles precisou mudar pra parar de mentir.
       ====================================================================== */
    var _bruta=(pub&&pub.data&&pub.data.publicUrl)||'';
    var _segura=avFotoUrlSegura(_bruta);
    if(!_segura){
      try{ console.error('[MEV] foto enviada mas o endereço foi recusado pela checagem:', _bruta||'(vazio)'); }catch(_){}
      throw new Error(_bruta
        ? 'a foto subiu, mas o endereço dela não passou na checagem de segurança'
        : 'a foto subiu, mas o banco não devolveu endereço nenhum');
    }
    return _segura;
  }
  /* CNH e comprovantes NÃO podem usar o bucket público das fotos dos carros.
     O navegador envia o arquivo autenticado para a Function, e o banco guarda
     apenas a referência private://. Visualização e download usam URL assinada
     de curta duração, sem expor a service_role no app. */
  var _arqPrivadoCache={};
  function _arqPrivadoEh(ref){ return /^private:\/\/documentos-privados\//.test(String(ref||'')); }
  function _arqLerBase64(file){
    return new Promise(function(resolve,reject){
      var fr=new FileReader();
      fr.onload=function(){ var s=String(fr.result||''); resolve(s.split(',')[1]||''); };
      fr.onerror=function(){ reject(new Error('Não consegui ler o arquivo.')); };
      fr.readAsDataURL(file);
    });
  }
  async function _arqPreparar(file){
    if(!file) throw new Error('Escolha um arquivo.');
    var tipo=String(file.type||'').toLowerCase().split(';')[0];
    if(!tipo && /\.pdf$/i.test(String(file.name||''))) tipo='application/pdf';
    var b64='';
    if(/^image\//.test(tipo)){
      /* Normaliza fotos (inclusive CNH/comprovante) para JPEG pequeno. */
      b64=await reduzirImagem(file,1800,0.84);
      tipo='image/jpeg';
    }else if(tipo==='application/pdf'){
      if(Number(file.size||0)>4*1024*1024) throw new Error('O PDF deve ter no máximo 4 MB.');
      b64=await _arqLerBase64(file);
    }else{
      throw new Error('Envie uma foto ou PDF.');
    }
    if(!b64 || Math.ceil(b64.length*3/4)>4*1024*1024) throw new Error('O arquivo deve ter no máximo 4 MB.');
    return { base64:b64, mime:tipo, nome:String(file.name||(/pdf/.test(tipo)?'documento.pdf':'documento.jpg')).slice(0,120) };
  }
  async function _arqPrivadoChamar(body){
    body=body||{}; body.token=token;
    var r=await fetch('/api/arquivo-privado',{
      method:'POST',
      headers:{'Content-Type':'application/json','Authorization':'Bearer '+String(token||'')},
      body:JSON.stringify(body)
    });
    var d=null; try{ d=await r.json(); }catch(_){}
    if(!r.ok || !d || !d.ok) throw new Error((d&&d.erro)||'Não foi possível guardar o documento.');
    return d;
  }
  async function arqUpload(file,categoria){
    var p=await _arqPreparar(file);
    var d=await _arqPrivadoChamar({
      acao:'upload', categoria:categoria||'documento',
      nome:p.nome, mime:p.mime, base64:p.base64
    });
    return String(d.referencia||'');
  }
  async function _arqPrivadoUrl(ref){
    ref=String(ref||'');
    if(!_arqPrivadoEh(ref)) return ref;
    var c=_arqPrivadoCache[ref];
    if(c&&c.url&&c.expira_em>Date.now()+10000) return c.url;
    var d=await _arqPrivadoChamar({acao:'url',referencia:ref});
    _arqPrivadoCache[ref]={url:String(d.url||''),expira_em:Number(d.expira_em)||0};
    return String(d.url||'');
  }
  async function _arqPrivadoApagar(ref){
    ref=String(ref||''); if(!_arqPrivadoEh(ref)) return true;
    await _arqPrivadoChamar({acao:'delete',referencia:ref});
    delete _arqPrivadoCache[ref]; return true;
  }
  async function _arqPrivadoBaixar(ref,nome){
    if(!ref){ toast('Este item não tem arquivo anexado.'); return; }
    var url='';
    try{
      url=await _arqPrivadoUrl(ref);
      var r=await fetch(url); if(!r.ok) throw new Error('download');
      var b=await r.blob(), u=URL.createObjectURL(b), a=document.createElement('a');
      a.href=u; a.download=nome||'documento'; document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){} },800);
    }catch(_){
      if(url){ try{ window.open(url,'_blank'); }catch(__){} }
      else toast('Não consegui preparar o arquivo.');
    }
  }

  /* ===== v492 — LINK EM CADEIA: concluir o clone (?clonar={id}) ==========
     A página do lojista manda o repassador pra cá (app.html?clonar={id}).
     Sem conta, ele cai no login/cadastro de sempre e o parâmetro fica
     esperando na URL; logado, o app chama o /api/clonar-avaliacao (quem
     clona é o SERVIDOR — service_role em nome do usuário; o payload sai
     SEM preço/avaliado e com a identidade do novo dono) e mostra o link
     novo com Copiar/WhatsApp. A URL só é limpa no SUCESSO — se a rede
     falhar, recarregar tenta de novo. ⚠️ function: só vale após deploy. */
  var _clnFeito=false;
  function _clnParam(){ try{ var m=/[?&]clonar=([0-9a-f-]{36})/i.exec(location.search||''); return m?m[1]:''; }catch(_){ return ''; } }
  function _clnLimpaUrl(){ try{ var u=new URL(location.href); u.searchParams.delete('clonar'); history.replaceState(null,'',u.pathname+(u.searchParams.toString()?('?'+u.searchParams.toString()):'')+(u.hash||'')); }catch(_){} }
  async function _clnRodar(){
    var origem=_clnParam(); if(!origem||_clnFeito) return;
    if(!token||!meuId) return;                        /* espera o login/cadastro */
    _clnFeito=true;
    toast('Criando o seu link deste carro…');
    var d=null;
    try{
      var r=await fetch('/api/clonar-avaliacao',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ token:token, origem:origem }) });
      d=await r.json();
    }catch(_){}
    if(!d||!d.ok){
      toast((d&&d.erro)||'Não consegui criar o link agora. Recarregue pra tentar de novo.');
      return;                                         /* URL fica: reload tenta de novo */
    }
    _clnLimpaUrl();
    try{ telaAvaliacoes(); }catch(_){}
    _clnMostrar(d.link, d.ja_existia);
  }
  /* v494: a moldura (CSS) virou função — o cartão do clone e o do laudo usam a mesma */
  function _clnCss(){
    if(document.getElementById('clnCss')) return;
    {
      var st=document.createElement('style'); st.id='clnCss';
      st.textContent='.cln-bg{position:fixed;inset:0;background:rgba(10,25,47,.55);z-index:12000;display:flex;align-items:center;justify-content:center;padding:22px}'+
        '.cln-card{background:#fff;border-radius:18px;max-width:360px;width:100%;padding:24px 20px 18px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.35)}'+
        '.cln-card h3{margin:0 0 6px;font-size:17px;font-weight:900;color:#0a2540}'+
        '.cln-card p{margin:0 0 12px;font-size:13px;line-height:1.45;color:#475569;font-weight:600}'+
        '.cln-link{font-size:12.5px;font-weight:800;color:#0a4da6;background:#f2f7ff;border:1px solid #dbe6fb;border-radius:11px;padding:10px 12px;margin-bottom:12px;word-break:break-all}'+
        '.cln-bt{display:block;width:100%;border:0;cursor:pointer;padding:12px;border-radius:12px;font-size:14px;font-weight:900;font-family:inherit;margin-top:8px}'+
        '.cln-bt.wa{background:#25D366;color:#fff}.cln-bt.cp{background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
        '.cln-x{display:block;width:100%;border:0;background:none;cursor:pointer;margin-top:9px;padding:8px;font-size:13px;font-weight:700;color:#64748b;font-family:inherit}';
      (document.head||document.documentElement).appendChild(st);
    }
  }
  function _clnMostrar(link, jaExistia){
    _clnCss();
    var bg=document.createElement('div'); bg.className='cln-bg'; bg.id='clnBg';
    bg.innerHTML='<div class="cln-card" role="dialog" aria-modal="true">'+
      '<h3>'+(jaExistia?'Este link já era seu ✓':'Seu link está pronto ✓')+'</h3>'+
      '<p>Mesmo carro, mesmas fotos — agora no SEU nome. As ofertas deste link vêm só pra você (ele aparece na página Avaliações).</p>'+
      '<div class="cln-link">'+esc(link)+'</div>'+
      '<button type="button" class="cln-bt wa" id="clnWa">Mandar pra minha rede (WhatsApp)</button>'+
      '<button type="button" class="cln-bt cp" id="clnCp">Copiar link</button>'+
      '<button type="button" class="cln-x" id="clnX">Fechar</button></div>';
    document.body.appendChild(bg);
    bg.onclick=function(e){ if(e.target===bg){ try{ bg.remove(); }catch(_){} } };
    var w=document.getElementById('clnWa'); if(w) w.onclick=function(){ mevIrProWhats('https://wa.me/?text='+encodeURIComponent('Olha esse carro: '+link)); };
    var c=document.getElementById('clnCp'); if(c) c.onclick=function(){ (async function(){ try{ await navigator.clipboard.writeText(link); toast('Link copiado ✓'); }catch(_){ toast(link); } })(); };
    var x=document.getElementById('clnX'); if(x) x.onclick=function(){ try{ bg.remove(); }catch(_){} };
  }
  try{
    var _clnT=setInterval(function(){
      if(!_clnParam()||_clnFeito){ clearInterval(_clnT); return; }
      if(token&&meuId) _clnRodar();
    }, 900);
  }catch(_){}

/* ╔═══ src/app/13b-video-da-avaliacao.js ═════════════════════════════════ */
  /* ==========================================================================
     v679 — O VÍDEO DO CLIENTE DENTRO DA AVALIAÇÃO (Fase 1)
     PROJETO-2026-08-28-video-do-cliente-na-avaliacao — executado com as
     decisões do Angelo (28/08): guarda 30 dias · bucket PRIVADO com URL
     assinada · o parceiro vê no link do lojista (isso é a FASE 2 — aqui é
     tudo DENTRO do app).

     A IDEIA QUE RESOLVE: "às vezes peço foto e ele manda um vídeo". O Angelo
     não queria um vídeo — queria FOTOS. Então o coração daqui é a tira de
     tempo com o botão "Usar este quadro": cada quadro congelado vira uma
     FOTO NORMAL da avaliação (JPEG de ~0,3 MB, pelo avAddFotos de sempre),
     que funciona em TUDO — capa, card, arte, anúncio. O vídeo (40-60 MB,
     150× o peso de uma foto — números da v583) fica guardado como material
     interno.

     🔴 A REGRA MAIS IMPORTANTE (item 4 do projeto): vídeo mora em
     `_avVideos`, lista PRÓPRIA. NUNCA em `_avFotos` — `_avFotos[0]` é a
     CAPA do link do WhatsApp, alimenta o card, a arte e o anúncio; um .mov
     ali vira quadrado preto na melhor hipótese. As fotos EXTRAÍDAS entram
     em _avFotos normalmente: são fotos de verdade.

     🔴 O TRANSPORTE: URL assinada de upload (via /api/video-url) e o
     navegador sobe DIRETO pro storage — o arquivo não passa por Function
     nenhuma (o caminho dos documentos trava em 4 MB; vídeo não passa nem
     perto). Teto de 60 MB, recusado ANTES de subir, dizendo o tamanho.

     ⚠️ preload="none" + poster em tudo: o vídeo só é baixado quando alguém
     toca em assistir. É o equivalente possível do cache da v583 — aqui não
     há CDN de vídeo, então o truque é não baixar até pedirem.
     ========================================================================== */

  var AVV_TETO_MB=60;
  var AVV_MIMES=['video/mp4','video/quicktime','video/webm','video/3gpp'];
  var _avVideos=[];        /* [{ref, dur, poster}] — NUNCA misturar com _avFotos */
  var _avvUrlCache={};     /* ref → {url, expira_em} (URL assinada de leitura) */

  function avvKey(){ return 'mev_avvideos:'+((veiculoAtual&&veiculoAtual.placa)||'x'); }
  function avvLer(){
    try{ _avVideos=JSON.parse(localStorage.getItem(avvKey())||'[]')||[]; }catch(_){ _avVideos=[]; }
    if(!Array.isArray(_avVideos)) _avVideos=[];
    /* só referência privada de vídeo entra na lista — nada de URL solta */
    _avVideos=_avVideos.filter(function(v){ return v && /^private:\/\/avaliacao-videos\//.test(String(v.ref||'')); });
  }
  function avvSalvar(){ try{ localStorage.setItem(avvKey(), JSON.stringify(_avVideos)); }catch(_){} }

  function avvDur(seg){
    seg=Math.round(Number(seg)||0);
    return Math.floor(seg/60)+':'+String(seg%60).padStart(2,'0');
  }
  /* v681 — quantos dias faltam pros 30 (o carimbo está no nome do arquivo).
     A tira AVISA quando faltam ≤5 — "avisar antes de apagar", do projeto. */
  function avvDiasRestantes(ref){
    try{
      var m=String(ref||'').match(/\/(\d{13})-[a-z0-9]+\.\w+$/);
      if(!m) return 99;
      return Math.ceil(30 - (Date.now()-Number(m[1]))/86400000);
    }catch(_){ return 99; }
  }

  /* ---- a URL assinada de leitura, com cache curto ---- */
  async function avvUrlVer(ref){
    var c=_avvUrlCache[ref];
    if(c && c.url && c.expira_em>Date.now()+10000) return c.url;
    var d=await api('/api/video-url',{ acao:'ver', ref:ref });
    if(!d || !d.ok || !d.url) throw new Error((d&&d.erro)||'vídeo indisponível');
    _avvUrlCache[ref]={ url:d.url, expira_em:Number(d.expira_em)||0 };
    return d.url;
  }

  /* ---- extrair UM quadro de uma fonte desenhável (vídeo, canvas) ----
     Separada e "burra" de propósito: é ela que o teste chama com um canvas
     pintado — o que se mede é a fiação quadro→JPEG→foto, não o codec. */
  function avvQuadroDe(fonte, w, h){
    return new Promise(function(res, rej){
      try{
        var cv=document.createElement('canvas');
        cv.width=Math.max(2, Math.round(w||fonte.videoWidth||fonte.width||1280));
        cv.height=Math.max(2, Math.round(h||fonte.videoHeight||fonte.height||720));
        cv.getContext('2d').drawImage(fonte, 0, 0, cv.width, cv.height);
        cv.toBlob(function(b){
          if(!b) return rej(new Error('quadro vazio'));
          res(new File([b], 'quadro-'+Date.now()+'.jpg', { type:'image/jpeg' }));
        }, 'image/jpeg', 0.9);
      }catch(e){ rej(e); }
    });
  }

  /* ---- anexar: seletor nativo no gesto + teto ANTES de subir ---- */
  function avvAnexar(){
    var inp=$('avvInput');
    if(!inp){
      /* a proteção da v253, copiada de propósito: input recriado se sumir */
      inp=document.createElement('input');
      inp.type='file'; inp.id='avvInput'; inp.accept=AVV_MIMES.join(',');
      inp.style.display='none';
      document.body.appendChild(inp);
    }
    inp.onchange=function(){
      var f=this.files && this.files[0]; this.value='';
      if(f) avvSubir(f);
    };
    try{ inp.click(); }catch(err){ toast('Não consegui abrir o seletor de vídeo.'); }
  }
  async function avvSubir(file){
    if(AVV_MIMES.indexOf(String(file.type||'').split(';')[0])<0 && !/\.(mp4|mov|webm|3gp)$/i.test(file.name||'')){
      toast('Formato de vídeo não aceito. Use MP4, MOV, WEBM ou 3GP.'); return;
    }
    if(file.size > AVV_TETO_MB*1024*1024){
      /* recusa AQUI, dizendo o tamanho — não deixa falhar longe, sem mensagem */
      toast('Esse vídeo tem '+Math.round(file.size/1048576)+' MB — o teto é '+AVV_TETO_MB+' MB. Mande um trecho mais curto.');
      return;
    }
    toast('Preparando o vídeo…');
    /* o poster (primeiro quadro) sai LOCALMENTE, do arquivo, antes de subir:
       a tira abre bonita sem baixar um byte do storage. */
    var meta=null;
    try{ meta=await avvMetaLocal(file); }catch(_){ meta=null; }
    if(!meta){ toast('Este vídeo não toca neste aparelho — o formato não é suportado.'); return; }
    var porta;
    try{ porta=await api('/api/video-url',{ acao:'upload', placa:(veiculoAtual&&veiculoAtual.placa)||'', mime:file.type||'video/mp4', tamanho:file.size }); }
    catch(_){ porta=null; }
    if(!porta || !porta.ok || !porta.url){ toast((porta&&porta.erro)||'Não consegui preparar o envio.'); return; }
    toast('Enviando o vídeo ('+Math.round(file.size/1048576)+' MB)…');
    try{
      var up=await fetch(porta.url, { method:'PUT', headers:{ 'Content-Type':file.type||'video/mp4' }, body:file });
      if(!up.ok) throw new Error('upload '+up.status);
    }catch(_){ toast('O envio do vídeo falhou — tente de novo.'); return; }
    /* o poster vira arquivo público leve pelo avUpload de sempre (é um JPEG
       de quadro — NÃO entra em _avFotos: é a capa do player, não uma foto
       da avaliação) */
    var posterUrl='';
    try{ if(meta.poster) posterUrl=await avUpload(meta.poster)||''; }catch(_){ posterUrl=''; }
    _avVideos.push({ ref:porta.ref, dur:meta.dur||0, poster:posterUrl });
    avvSalvar(); avvPinta();
    toast('Vídeo anexado ✓ — toque nele pra extrair fotos.');
  }
  /* lê duração + primeiro quadro do arquivo LOCAL (nada de rede) */
  function avvMetaLocal(file){
    return new Promise(function(res, rej){
      var u=URL.createObjectURL(file);
      var v=document.createElement('video');
      v.preload='metadata'; v.muted=true; v.playsInline=true;
      var acabou=false;
      function fim(ok, meta){ if(acabou) return; acabou=true;
        try{ URL.revokeObjectURL(u); }catch(_){}
        ok?res(meta):rej(new Error('meta')); }
      v.onerror=function(){ fim(false); };
      v.onloadedmetadata=function(){
        var dur=Number(v.duration)||0;
        try{ v.currentTime=Math.min(0.5, dur/10); }catch(_){}
        v.onseeked=function(){
          avvQuadroDe(v).then(function(f){ fim(true,{ dur:dur, poster:f }); },
                              function(){ fim(true,{ dur:dur, poster:null }); });
        };
        setTimeout(function(){ if(!acabou) fim(true,{ dur:dur, poster:null }); }, 4000);
      };
      setTimeout(function(){ fim(false); }, 8000);
      v.src=u;
    });
  }

  /* ---- a TIRA DE TEMPO: arrasta, vê o quadro, "Usar este quadro" ---- */
  async function avvAbrirVisor(i){
    var item=_avVideos[i]; if(!item) return;
    var url='';
    try{ url=await avvUrlVer(item.ref); }
    catch(e){ toast('Não consegui abrir o vídeo — ele pode ter expirado.'); return; }
    var velho=$('avvBg'); if(velho) velho.parentNode.removeChild(velho);
    var bg=document.createElement('div'); bg.id='avvBg'; bg.className='crop-bg';
    bg.innerHTML='<div class="crop-box avv-box">'+
      '<div class="avv-tit">Extrair fotos do vídeo</div>'+
      '<video id="avvVideo" preload="metadata" playsinline muted '+(item.poster?('poster="'+esc(item.poster)+'" '):'')+'></video>'+
      '<input type="range" id="avvTempo" min="0" max="1000" value="0" step="1">'+
      '<div class="avv-acts">'+
        '<button type="button" class="crop-cancel" id="avvFechar">Fechar</button>'+
        '<button type="button" class="crop-ok" id="avvUsar">Usar este quadro</button>'+
      '</div>'+
      '<div class="avx-nota">Cada quadro vira uma foto normal da avaliação. '+
        'Quadro de vídeo serve pra registro (risco, pneu, hodômetro); pra capa de anúncio, prefira foto tirada.</div>'+
    '</div>';
    document.body.appendChild(bg);
    var v=$('avvVideo'); v.src=url;
    var faixa=$('avvTempo');
    faixa.oninput=function(){
      try{ if(v.duration) v.currentTime=(Number(faixa.value)/1000)*v.duration; }catch(_){}
    };
    $('avvFechar').onclick=function(){ try{ v.pause(); }catch(_){} bg.parentNode.removeChild(bg); };
    $('avvUsar').onclick=async function(){
      try{
        var f=await avvQuadroDe(v);
        await avAddFotos([f]);   /* o caminho DE SEMPRE — vira foto de verdade */
      }catch(_){ toast('Não consegui congelar este quadro.'); }
    };
  }

  async function avvApagar(i){
    var item=_avVideos[i]; if(!item) return;
    if(!confirm('Apagar este vídeo? As fotos que você extraiu dele CONTINUAM na avaliação.')) return;
    try{ await api('/api/video-url',{ acao:'delete', ref:item.ref }); }catch(_){}
    _avVideos.splice(i,1); delete _avvUrlCache[item.ref];
    avvSalvar(); avvPinta();
    toast('Vídeo apagado — as fotos extraídas ficaram.');
  }

  /* ---- a tira, desenhada logo abaixo das fotos ---- */
  function avvPinta(){
    var fotos=$('avFotos'); if(!fotos) return;
    var box=$('avVideos');
    if(!box){
      box=document.createElement('div'); box.id='avVideos'; box.className='avv-tira';
      fotos.parentNode.insertBefore(box, fotos.nextSibling);
    }
    var html=_avVideos.map(function(vd,i){
      var dias=avvDiasRestantes(vd.ref);
      return '<div class="av-thumb avv-thumb" data-v="'+i+'">'+
        (vd.poster?('<img loading="lazy" decoding="async" src="'+esc(vd.poster)+'">'):'<span class="avv-semposter"></span>')+
        '<span class="avv-play">▶ '+avvDur(vd.dur)+'</span>'+
        (dias<=0?'<span class="avv-prazo venceu">expirou</span>'
          :(dias<=5?('<span class="avv-prazo">some em '+dias+'d</span>'):''))+
        '<button type="button" class="av-del avv-del" data-v="'+i+'">&times;</button>'+
      '</div>';
    }).join('');
    html+='<button type="button" class="av-addfoto avv-add" id="avvAdd" title="Anexar um vídeo do cliente">🎬</button>';
    box.innerHTML='<div class="avv-rotulo">Vídeo do cliente</div><div class="avv-linha">'+html+'</div>';
    var add=$('avvAdd'); if(add) add.onclick=avvAnexar;
    Array.prototype.forEach.call(box.querySelectorAll('.avv-thumb'),function(th){
      th.onclick=function(e){
        if(e.target && e.target.classList.contains('avv-del')) return;
        avvAbrirVisor(parseInt(th.getAttribute('data-v'),10)||0);
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('.avv-del'),function(b){
      b.onclick=function(e){ e.stopPropagation(); avvApagar(parseInt(b.getAttribute('data-v'),10)||0); };
    });
  }
  function avvAoAbrirAvaliacao(){ avvLer(); avvPinta(); }
  try{ window.avvAoAbrirAvaliacao=avvAoAbrirAvaliacao; }catch(_){}

/* ╔═══ src/app/13c-protecao-placa.js ═════════════════════════════════════ */
  /* ==========================================================================
     13c — PROTEÇÃO DA PLACA NAS FOTOS (v808 · Etapa 1 do
     PROJETO-NOVO-2026-08-31-placa-mev-veiculos-nas-fotos)
     --------------------------------------------------------------------------
     🔴 O PROBLEMA, em uma frase: a placa de um cliente é dado pessoal, e até
     hoje ela subia inteira pro bucket PÚBLICO `avaliacao-fotos` — o que
     significa que ela vira endereço na internet, aberto pra qualquer um, no
     segundo em que a foto entra no Estoque ou na Avaliação.

     🔴 A DECISÃO QUE MOLDA ESTE ARQUIVO: **a original nunca sai do aparelho.**
     O projeto (§5.3) previa um cofre privado guardando a original e um bucket
     público com a derivada. Pra ESTES dois fluxos isso não é preciso — e o
     resultado sem o cofre é mais forte:

         antes .... escolhe a foto → sobe a ORIGINAL → publica
         agora .... escolhe a foto → mascara AQUI, no navegador →
                    sobe SÓ a mascarada → a original morre no `blob` local

     Não existe cofre pra vazar, não existe URL assinada pra expirar mal, não
     existe RLS pra escrever errado. O que não é enviado não vaza.
     ⚠️ O cofre continua NECESSÁRIO na Etapa 2 (foto do cliente e foto
     importada chegam pelo SERVIDOR, não pelo navegador) e pra poder REFAZER
     uma proteção depois. Não apague esta nota achando que o cofre morreu.

     🔴 A MÁSCARA É PIXEL, NÃO CAMADA. Nada aqui é `<div>` por cima da foto:
     o desenho é feito num `<canvas>` e o `toBlob` sai com a placa coberta
     DENTRO do arquivo. Baixar a foto, abrir no computador, printar — a
     proteção vai junto. Uma camada de HTML sairia com um F12.

     ⚠️ O DESFOQUE É IRREVERSÍVEL DE PROPÓSITO: ele reduz a região a poucos
     pixels e reamplia (pixelização), em vez de aplicar só um `filter:blur`.
     Blur gaussiano leve pode ser parcialmente desfeito por software; jogar
     a informação fora não pode.

     ⚠️ E O DETECTOR NÃO EXISTE AINDA (§7, "primeira entrega recomendada:
     editor manual confiável; nenhuma dependência do detector"). Por isso a
     tela ABRE SEMPRE e exige uma das duas coisas: uma região marcada, ou o
     "Sem placa — confirmar" apertado pela pessoa. Um editor que deixa passar
     calado é pior que nenhum: dá a sensação de proteção sem a proteção.
     ========================================================================== */

  /* a arte oficial: docs/identidade-mev-veiculos/placa-mev-veiculos-preta-simbolo.svg
     ⚠️ Os caminhos abaixo são os MESMOS do arquivo (grupo em translate(229 7)
     scale(.62), sistema de 0..100 no eixo x). Copiados pra cá, e não lidos do
     disco, porque `docs/` não vai pro ar — e porque desenhar com `Path2D` é
     síncrono: nada de esperar uma imagem carregar no meio do `toBlob`.
     🔴 SE A ARTE MUDAR NO KIT, MUDE AQUI TAMBÉM. */
  var PLACA_MEV_SIMBOLO = [
    { d:'M9 23 50 5l41 18v31c0 23-16 40-41 52C25 94 9 77 9 54Z', fill:'#0a4da6', stroke:'#ffffff', w:4, join:'round' },
    { d:'M27 51 34 36c2-5 7-7 13-7h6c6 0 11 2 13 7l7 15', fill:null, stroke:'#ffffff', w:5, cap:'round', join:'round' },
    { d:'M24 53c0-4 3-7 7-7h38c4 0 7 3 7 7v18c0 4-3 7-7 7H31c-4 0-7-3-7-7Z', fill:'#ffffff', stroke:null },
    { d:'M33 57h9M58 57h9', fill:null, stroke:'#0a4da6', w:5, cap:'round' },
    { d:'M40 69h20', fill:null, stroke:'#0a4da6', w:4, cap:'round' },
    { d:'m64 86 8 8 18-21', fill:null, stroke:'#60a5fa', w:6, cap:'round', join:'round' }
  ];
  var PLACA_SIMB_W = 100, PLACA_SIMB_H = 110;   /* a caixa do símbolo no SVG */
  /* §4: fundo #030712 · borda #0a4da6 a ~0,6% da largura · cantos a 2% */
  var PLACA_FUNDO='#030712', PLACA_BORDA='#0a4da6';
  var PLACA_BORDA_PCT=0.006, PLACA_RAIO_PCT=0.02;
  /* §4: "a arte cobre no mínimo 112% da região detectada" */
  var PLACA_FOLGA=1.12;
  /* ⚠️ §4 pede o símbolo em "34% a 42% da largura da placa". A arte do kit
     tem 12%, e numa região com formato de placa real (~3:1) 38% da largura
     faria o símbolo estourar a altura. A regra aqui é: o MAIOR símbolo que
     cabe sem distorcer — teto de 42% da largura OU 72% da altura, o que vier
     primeiro. Está escrito no changelog da v808; se a proporção tiver que ser
     outra, são estes dois números. */
  /* 🔴 v820 — a tarja passou a levar a ASSINATURA "MEV Veículos" embaixo do
     símbolo (pedido do Angelo, com a foto da placa preta de referência).
     Por isso o símbolo encolheu e subiu: ele agora divide a placa com o
     texto, em vez de ocupar tudo. */
  var PLACA_SIMB_MAX_W=0.34, PLACA_SIMB_MAX_H=0.50;
  var PLACA_SIMB_DY=-0.13;          /* o símbolo sobe um pouco (fração da altura) */
  var PLACA_TXT_Y=0.34;             /* a linha de base do texto */
  var PLACA_TXT_H=0.18;             /* o corpo da letra, em fração da altura */
  var PLACA_TXT_MIN=26;             /* abaixo disto, em pixels, o texto NÃO é escrito */
  var PLACA_TXT_FONTE='"Helvetica Neue",Helvetica,Arial,sans-serif';

  var _pp = null;   /* o estado do editor aberto; null = fechado */
  /* v811 — a lista vazia que quer dizer "deu erro", e não "cancelei".
     É um array (pra quem só faz `.length`) com uma marca em cima. */
  var _PP_FALHOU = []; _PP_FALHOU.erro = true;


  /* 🔴 v820 — o ângulo, sempre pela mesma porta.
     Limita a ±90° e ENCAIXA no zero perto do zero (±2°): sem esse encaixe,
     quem só quis mexer um tantinho fica com 1° de torto pra sempre, e numa
     tarja preta 1° aparece. */
  function _ppGrau(g){
    g=Number(g)||0;
    if(g>90) g=90; if(g<-90) g=-90;
    if(Math.abs(g)<=2) g=0;
    return Math.round(g);
  }
  function _ppNum(n,a,b){ n=Number(n); if(!isFinite(n)) n=a; return Math.max(a,Math.min(b,n)); }
  /* uma máscara nova, no meio da foto, com cara de placa (3:1) */
  function _ppMascaraNova(){
    return { x:0.5, y:0.62, largura:0.30, altura:0.10, rotacao:0, confirmado:true };
  }

  /* ---------------------------------------------------------------------
     O DESENHO — é aqui que a proteção vira pixel
     --------------------------------------------------------------------- */
  function _ppRetanguloRedondo(ctx, x, y, w, h, r){
    r=Math.min(r, w/2, h/2);
    ctx.beginPath();
    ctx.moveTo(x+r, y);
    ctx.lineTo(x+w-r, y); ctx.quadraticCurveTo(x+w, y, x+w, y+r);
    ctx.lineTo(x+w, y+h-r); ctx.quadraticCurveTo(x+w, y+h, x+w-r, y+h);
    ctx.lineTo(x+r, y+h); ctx.quadraticCurveTo(x, y+h, x, y+h-r);
    ctx.lineTo(x, y+r); ctx.quadraticCurveTo(x, y, x+r, y);
    ctx.closePath();
  }
  /* a placa MEV, desenhada centrada na origem, com largura w e altura h */
  function _ppDesenhaPlacaMev(ctx, w, h){
    var borda=Math.max(1, w*PLACA_BORDA_PCT);
    var raio=w*PLACA_RAIO_PCT;
    ctx.save();
    _ppRetanguloRedondo(ctx, -w/2+borda/2, -h/2+borda/2, w-borda, h-borda, raio);
    ctx.fillStyle=PLACA_FUNDO; ctx.fill();
    ctx.lineWidth=borda; ctx.strokeStyle=PLACA_BORDA; ctx.stroke();
    /* 🔴 v820 — A ASSINATURA "MEV Veículos", embaixo do símbolo.
       Ela é escrita ANTES do símbolo por um motivo bobo e importante: o
       desenho do símbolo mexe no `translate` e no `scale` do contexto, e
       desfazer isso pra escrever depois é convite pra erro. Cada um no seu
       `save`/`restore`.

       ⚠️ O QUE SEGURA ESTA ASSINATURA É UMA FONTE DO SISTEMA, de propósito.
       Fonte baixada pode não ter chegado na hora em que o `toBlob` roda — e
       o arquivo sairia com a letra errada, ou sem letra, sem ninguém ver.
       Aqui a placa é gerada uma vez e vira pixel: não há segunda chance.

       🔴 E ABAIXO DE PLACA_TXT_MIN PIXELS O TEXTO NÃO É ESCRITO. Numa foto
       pequena, ou numa placa marcada bem estreita, a assinatura vira três
       borrões cinzentos que sujam a tarja e não se leem. Nesse caso fica só
       o símbolo, que continua reconhecível. Cobrir a placa é a função; a
       assinatura é o acabamento, e acabamento ilegível é sujeira. */
    var temTexto = (h*PLACA_TXT_H) >= (PLACA_TXT_MIN*0.5) && h >= PLACA_TXT_MIN;
    if(temTexto){
      ctx.save();
      var corpo=h*PLACA_TXT_H;
      ctx.textAlign='left'; ctx.textBaseline='middle';
      var fA='800 '+corpo.toFixed(2)+'px '+PLACA_TXT_FONTE;
      var fB='400 '+corpo.toFixed(2)+'px '+PLACA_TXT_FONTE;
      var a='MEV ', b='Veículos';
      ctx.font=fA; var la=ctx.measureText(a).width;
      ctx.font=fB; var lb=ctx.measureText(b).width;
      var total=la+lb, x0=-total/2, y0=h*PLACA_TXT_Y;
      /* não deixo a assinatura encostar na borda: se não couber, ela encolhe */
      var cabe=(w*0.88)/(total||1);
      if(cabe<1){
        corpo=corpo*cabe;
        fA='800 '+corpo.toFixed(2)+'px '+PLACA_TXT_FONTE;
        fB='400 '+corpo.toFixed(2)+'px '+PLACA_TXT_FONTE;
        ctx.font=fA; la=ctx.measureText(a).width;
        ctx.font=fB; lb=ctx.measureText(b).width;
        total=la+lb; x0=-total/2;
      }
      ctx.fillStyle='#ffffff';
      ctx.font=fA; ctx.fillText(a, x0, y0);
      ctx.font=fB; ctx.fillText(b, x0+la, y0);
      ctx.restore();
    }
    /* o símbolo, sem distorcer: uma escala só pros dois eixos */
    /* ⚠️ `escala`, NUNCA `esc`: veja a nota do `_ppPinta` logo abaixo. */
    ctx.save();
    var escala=Math.min((w*PLACA_SIMB_MAX_W)/PLACA_SIMB_W, (h*PLACA_SIMB_MAX_H)/PLACA_SIMB_H);
    /* com a assinatura embaixo, o símbolo sobe pra os dois respirarem */
    ctx.translate(0, temTexto ? h*PLACA_SIMB_DY : 0);
    ctx.translate(-(PLACA_SIMB_W*escala)/2, -(PLACA_SIMB_H*escala)/2);
    ctx.scale(escala, escala);
    PLACA_MEV_SIMBOLO.forEach(function(p){
      var caminho=new Path2D(p.d);
      if(p.fill){ ctx.fillStyle=p.fill; ctx.fill(caminho); }
      if(p.stroke){
        ctx.strokeStyle=p.stroke; ctx.lineWidth=p.w||1;
        ctx.lineCap=p.cap||'butt'; ctx.lineJoin=p.join||'miter';
        ctx.stroke(caminho);
      }
    });
    ctx.restore();
    ctx.restore();
  }
  /* 🔴 PIXELIZAÇÃO, não `filter:blur`. Reduzir a região a poucos pixels e
     reampliar JOGA A INFORMAÇÃO FORA — não há como reconstruir o que não
     está mais no arquivo. Um blur gaussiano leve pode ser parcialmente
     revertido por software, e numa placa isso é o suficiente. */
  function _ppDesfoca(ctx, cv, x, y, w, h, refBloco){
    w=Math.max(1,Math.round(w)); h=Math.max(1,Math.round(h));
    x=Math.round(x); y=Math.round(y);
    var pequeno=document.createElement('canvas');
    /* v820: o bloco tem ~1/16 do lado menor da REGIÃO (quando ela é passada);
       sem isso, girar a região aumentava o bloco só por causa da diagonal. */
    var bloco=Math.max(2, Math.round((Number(refBloco)||Math.min(w,h))/16));
    var pw=Math.max(3, Math.round(w/bloco)), ph=Math.max(3, Math.round(h/bloco));
    pequeno.width=pw; pequeno.height=ph;
    var pc=pequeno.getContext('2d');
    try{ pc.drawImage(cv, x, y, w, h, 0, 0, pw, ph); }catch(_){ return; }
    ctx.save();
    ctx.imageSmoothingEnabled=false;
    ctx.drawImage(pequeno, 0, 0, pw, ph, x, y, w, h);
    ctx.restore();
  }
  /* aplica UMA máscara sobre o canvas já com a foto desenhada */
  function _ppAplicaMascara(ctx, cv, m, W, H, variante){
    /* §4: a arte cobre no mínimo 112% da região */
    var w=_ppNum(m.largura,0.01,2)*W*PLACA_FOLGA;
    var h=_ppNum(m.altura,0.01,2)*H*PLACA_FOLGA;
    var cx=_ppNum(m.x,0,1)*W, cy=_ppNum(m.y,0,1)*H;
    var rot=(Number(m.rotacao)||0)*Math.PI/180;
    if(variante==='desfoque'){
      if(!rot){ _ppDesfoca(ctx, cv, cx-w/2, cy-h/2, w, h); return; }
      /* 🔴 v820 — O BORRÃO GIRA JUNTO.
         Até aqui, com a região girada, este ramo desfocava a CAIXA QUE
         ENVOLVE o retângulo girado — um quadrado maior, alinhado à tela.
         Duas consequências, e a segunda é a séria:
           · borrava lataria e para-choque à toa;
           · e, numa placa bem inclinada, o retângulo girado encostava nos
             cantos da caixa: o desfoque cobria a placa por sorte, não por
             desenho.
         Agora o recorte é o PRÓPRIO retângulo girado: giro o contexto,
         recorto, desgiro e desfoco a caixa envolvente — o que passa é só o
         que está dentro do recorte. */
      var raio=Math.sqrt(w*w+h*h)/2, bw=raio*2, bh=raio*2;
      ctx.save();
      ctx.translate(cx, cy); ctx.rotate(rot);
      ctx.beginPath(); ctx.rect(-w/2, -h/2, w, h); ctx.clip();
      ctx.rotate(-rot); ctx.translate(-cx, -cy);
      /* o TAMANHO DO BLOCO sai da região marcada, não da caixa: senão uma
         placa girada ganharia blocos maiores só por causa da diagonal */
      _ppDesfoca(ctx, cv, cx-bw/2, cy-bh/2, bw, bh, Math.min(w,h));
      ctx.restore();
      return;
    }
    ctx.save();
    ctx.translate(cx, cy); ctx.rotate(rot);
    if(variante==='tarja'){
      ctx.fillStyle='#000000';
      ctx.fillRect(-w/2, -h/2, w, h);
    } else {
      _ppDesenhaPlacaMev(ctx, w, h);
    }
    ctx.restore();
  }

  /* ---------------------------------------------------------------------
     fotoPlacaRenderizar — a foto protegida, em bytes
     --------------------------------------------------------------------- */
  function fotoPlacaRenderizar(bitmap, mascaras, variante){
    return new Promise(function(resolve, reject){
      try{
        var W=bitmap.width, H=bitmap.height;
        var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
        var ctx=cv.getContext('2d');
        ctx.drawImage(bitmap, 0, 0, W, H);
        (mascaras||[]).forEach(function(m){ _ppAplicaMascara(ctx, cv, m, W, H, variante); });
        cv.toBlob(function(b){
          if(b) resolve(b); else reject(new Error('não consegui gerar a imagem'));
        }, 'image/jpeg', 0.86);
      }catch(e){ reject(e); }
    });
  }
  /* ===== v811 — O DEFEITO QUE DEIXOU O ANGELO SEM ENVIAR FOTO ============
     🔴 A v808 escrevia isto:

         if(window.createImageBitmap){
           try{ return createImageBitmap(blob,{imageOrientation:'from-image'}); }catch(_){}
         }
         return <caminho do <img>>;

     Dois erros num só lugar:

     1. `imageOrientation:'from-image'` **só existe no Safari 16 em diante**
        (iOS 3.2 → 15.8 não suportam). Num iPhone com iOS 15 ou mais antigo,
        essa chamada não funciona.
     2. E quando ela falha, falha DEPOIS: devolve uma Promise REJEITADA, não
        uma exceção. O `try/catch` acima só pega exceção síncrona — a
        rejeição passava reto, era engolida pelo `catch(_){}` do laço lá
        embaixo, e a foto era DESCARTADA EM SILÊNCIO. Com todas as fotos
        caindo assim, a lista ficava vazia, a tela nem chegava a abrir e o
        app dizia só "Nenhuma foto foi enviada".

     Ou seja: num iPhone antigo, a v808 tornou impossível anexar foto — sem
     uma palavra na tela dizendo por quê. Foi o que o Angelo relatou em
     01/09, e é o pior tipo de defeito: o que se parece com "o app não faz".

     Agora são TRÊS tentativas encadeadas, e a última é o `<img>`, que
     funciona em tudo. Quem falhar cai na próxima — inclusive por rejeição. */
  function _ppPorImg(blob){
    return new Promise(function(res, rej){
      var u=URL.createObjectURL(blob), im=new Image();
      im.onload=function(){ try{ URL.revokeObjectURL(u); }catch(_){} res(im); };
      im.onerror=function(){ try{ URL.revokeObjectURL(u); }catch(_){} rej(new Error('não consegui abrir a foto')); };
      im.src=u;
    });
  }
  function _ppBitmap(blob){
    if(!window.createImageBitmap) return _ppPorImg(blob);
    /* ⚠️ `Promise.resolve(...)` embrulhando a chamada: assim uma exceção
       SÍNCRONA e uma Promise REJEITADA caem as duas no mesmo `.catch`. */
    function tenta(opc){
      return new Promise(function(res, rej){
        try{ res(opc ? createImageBitmap(blob, opc) : createImageBitmap(blob)); }
        catch(e){ rej(e); }
      });
    }
    return tenta({ imageOrientation:'from-image' })   /* melhor: corrige o EXIF */
      .catch(function(){ return tenta(null); })        /* Safari 15 e anteriores */
      .catch(function(){ return _ppPorImg(blob); });   /* funciona em tudo */
  }

  /* ---------------------------------------------------------------------
     fotoPlacaValidarRevisao — a trava do §3.1
     "exigir conferência antes de gerar a versão pública"
     --------------------------------------------------------------------- */
  function fotoPlacaValidarRevisao(f){
    if(!f) return false;
    if(f.semPlacaConfirmado===true) return true;
    return !!(f.mascaras && f.mascaras.length);
  }

  /* =====================================================================
     v837 — LOCALIZAR A PLACA COM IA  (PROJETO20260901fotoia)
     ---------------------------------------------------------------------
     🔴 O CLAUDE NÃO EDITA IMAGEM. Ele lê a foto e devolve TEXTO: onde está a
     placa, o que está escrito e que foto é essa. Quem desenha o borrão
     continua sendo o canvas daqui de cima. A função só diz ONDE.

     🔴 §2.4 — CONFIRMAÇÃO OBRIGATÓRIA, E ELA É O CORAÇÃO DISTO.
     A caixa acerta a REGIÃO, não o pixel. Então o app NUNCA borra e baixa
     direto: ele põe a proteção em cima do que a IA achou, DESENHADA NA TELA,
     e o lojista vê antes de salvar. Placa publicada por engano é muito pior
     que marcar na mão.

     🔴 §2.5 — O TOQUE MANUAL CONTINUA SENDO O PADRÃO. Isto exige internet e
     quebra o offline-first do resto do app. Sem sinal, sem chave, timeout,
     JSON estranho: cai calado no manual. NUNCA mostrar erro de API na cara
     do lojista — mostrar "não achei, marque na mão" e seguir a vida.

     §2.3 — A FOTO VAI REDIMENSIONADA. 1024px no maior lado, JPEG 0.8. Foto
     crua de iPhone (3–4 MB) vira ~150 KB. Sem isso o custo multiplica por 6
     e o corpo da requisição começa a estourar o limite da função. */
  var PP_IA_LADO=1024, PP_IA_Q=0.8;
  /* §2.4: 20% de folga em volta do que a IA achou. A caixa vem justa; placa
     é o que NÃO pode escapar pela borda. */
  var PP_IA_FOLGA=0.20;

  function _ppIaImagem(f){
    /* desenha o bitmap já reduzido e devolve o base64 sem o prefixo data: */
    var W=f.largura, H=f.altura, e=Math.min(1, PP_IA_LADO/Math.max(W,H));
    var cv=document.createElement('canvas');
    cv.width=Math.max(1,Math.round(W*e)); cv.height=Math.max(1,Math.round(H*e));
    var ctx=cv.getContext('2d');
    ctx.drawImage(f.bitmap, 0, 0, cv.width, cv.height);
    var url=cv.toDataURL('image/jpeg', PP_IA_Q);
    return { base64:String(url).split(',')[1]||'', tipo:'image/jpeg' };
  }

  /* a caixa vem em 0–1 sobre a imagem ENVIADA; a máscara daqui é centro +
     tamanho, também em 0–1 sobre a foto. Como a redução é proporcional, a
     conversão é direta — e é por isso que reduzir mantendo proporção importa. */
  function _ppIaMascaraDaCaixa(c){
    var x0=c[0], y0=c[1], x1=c[2], y1=c[3];
    var w=(x1-x0), h=(y1-y0);
    var fw=w*PP_IA_FOLGA, fh=h*PP_IA_FOLGA;
    x0=Math.max(0,x0-fw/2); x1=Math.min(1,x1+fw/2);
    y0=Math.max(0,y0-fh/2); y1=Math.min(1,y1+fh/2);
    return { x:(x0+x1)/2, y:(y0+y1)/2, largura:(x1-x0), altura:(y1-y0),
             rotacao:0, confirmado:true, porIa:true };
  }

  function _ppIaRecado(txt){
    var est=document.getElementById('ppEstado');
    if(est) est.textContent=txt||'';
  }

  async function _ppLocalizarComIa(bt){
    var f=_ppFoto(); if(!f) return;
    if(bt){ bt.disabled=true; bt.classList.add('loading'); }
    _ppIaRecado('Procurando a placa na foto…');
    var r=null;
    try{
      var img=_ppIaImagem(f);
      var resp=await fetch('/api/foto-ia', {
        method:'POST', headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ imagem:img.base64, tipo:img.tipo })
      });
      r=await resp.json();
    }catch(_){ r=null; }
    if(bt){ bt.disabled=false; bt.classList.remove('loading'); }

    /* 🔴 tudo que não for um achado bom cai no MESMO lugar: o manual. Sem
       tela de erro, sem nome de fornecedor, sem "tente novamente". */
    if(!r || !r.ok || !r.placa || !r.placa.achou || !r.placa.caixa){
      _ppIaRecado('Não achei a placa — arraste a proteção em cima dela.');
      return;
    }

    f.mascaras.push(_ppIaMascaraDaCaixa(r.placa.caixa));
    f.semPlacaConfirmado=false;
    _pp.sel=f.mascaras.length-1;
    /* guardado pra quem consumir depois (o texto da placa e o ângulo da foto
       são o ganho de verdade do §1 — a tela que usar isso vem depois) */
    f.iaPlacaTexto=r.placa.texto||null;
    f.iaAngulo=r.angulo||null;
    _ppPinta();

    var recado='Achei a placa. Confira a posição e ajuste se precisar.';
    if(r.placa.texto) recado='Achei a placa '+r.placa.texto+'. Confira a posição.';
    /* §6: aviso de qualidade é discreto e NÃO bloqueia. Ele decide. */
    if(r.qualidade && r.qualidade.boa===false){
      recado+=' Foto '+(r.qualidade.motivo||'com problema')+' — pode ficar ruim na arte.';
    }
    _ppIaRecado(recado);
  }

  /* ---------------------------------------------------------------------
     A TELA
     --------------------------------------------------------------------- */
  /* 🔴 v834 (pedido): "remova o borrar placa do jeito que tá, tá horrível de
     fazer". O 'desfoque' saiu da lista de botões — e SÓ da lista.
     ⚠️ O `_ppAplicaMascara` continua sabendo desenhar o desfoque (ramo
     'desfoque', com o recorte girado que a v820 consertou). Duas razões pra
     manter: (1) foto antiga que chegue com variante 'desfoque' continua
     renderizando certo em vez de cair no ramo de trás; (2) o dia em que
     houver um jeito decente de marcar a região, é só devolver a linha aqui.
     Apagar o desenho tornaria a volta uma reescrita. */
  var _PP_VARIANTES=[['mev','Placa MEV'],['tarja','Tarja preta']];
  function _ppIco(d){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" '+
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>';
  }
  function _ppSelo(f){
    if(f.semPlacaConfirmado) return { cls:'ok', tx:'Sem placa — confirmado' };
    if(f.mascaras && f.mascaras.length) return { cls:'ok', tx:'Placa protegida' };
    return { cls:'pend', tx:'Revisar placa' };
  }

  /* fotoPlacaAbrir(blobs, opcoes) → Promise com a lista de fotos protegidas.
     Resolve com [] quando a pessoa cancela. */
  function fotoPlacaAbrir(blobs, opcoes){
    opcoes=opcoes||{};
    return new Promise(async function(resolve){
      var fotos=[], falharam=0;
      var varianteInicial=['mev','desfoque','tarja'].indexOf(opcoes.variante)>=0?opcoes.variante:'mev';
      for(var i=0;i<blobs.length;i++){
        try{
          var bm=await _ppBitmap(blobs[i]);
          fotos.push({ blob:blobs[i], bitmap:bm, largura:bm.width, altura:bm.height,
            mascaras:opcoes.adicionarMascara?[_ppMascaraNova()]:[], semPlacaConfirmado:false,
            variante:varianteInicial });
        }catch(e){
          /* 🔴 v811: antes isto era `catch(_){}` — a foto sumia sem uma
             palavra. Sumir calado é o defeito que fez o Angelo achar que o
             app tinha parado de enviar foto. Agora ele CONTA e AVISA. */
          falharam++;
          try{ console.warn('[MEV] não consegui abrir uma foto:', (e&&e.message)||e); }catch(_){}
        }
      }
      if(falharam){
        try{ toast(falharam+' foto'+(falharam===1?' não abriu':'s não abriram')+
          ' neste aparelho. Tente outra foto, ou atualize o navegador.'); }catch(_){}
      }
      /* ⚠️ o `-1` diz a quem chamou "deu erro", que é diferente de "você
         cancelou" — e os dois casos escreviam a MESMA frase até a v810. */
      if(!fotos.length){ resolve(falharam?_PP_FALHOU:[]); return; }
      _pp={ fotos:fotos, i:0, sel:opcoes.adicionarMascara?0:-1,
        resolve:resolve, origem:opcoes.origem||'estoque' };
      _ppMontar();
    });
  }

  function _ppFechar(saida){
    var ov=document.getElementById('ppOv'); if(ov){ try{ ov.remove(); }catch(_){} }
    document.body.classList.remove('pp-on');
    var r=_pp&&_pp.resolve; _pp=null;
    if(r) r(saida||[]);
  }

  function _ppMontar(){
    var ov=document.createElement('div');
    ov.id='ppOv'; ov.className='pp-ov'; ov.setAttribute('role','dialog');
    ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-labelledby','ppTit');
    ov.innerHTML=
      '<div class="pp-cx">'+
        '<div class="pp-top">'+
          '<div class="pp-tx"><h2 id="ppTit">Proteger placas</h2>'+
            '<span>Revise antes de publicar as fotos</span></div>'+
          '<button type="button" class="pp-x" id="ppX" aria-label="Fechar sem salvar">'+
            _ppIco('<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>')+'</button>'+
        '</div>'+
        '<div class="pp-estado" id="ppEstado" role="status" aria-live="polite"></div>'+
        '<div class="pp-corpo">'+
          '<div class="pp-palco" id="ppPalco">'+
            '<canvas id="ppCv"></canvas>'+
            '<div class="pp-regioes" id="ppRegioes"></div>'+
          '</div>'+
          '<div class="pp-lado">'+
            '<div class="pp-grupo" role="group" aria-label="Tipo de proteção">'+
              _PP_VARIANTES.map(function(v){
                return '<button type="button" class="pp-var" data-var="'+v[0]+'" aria-pressed="false">'+
                  esc(v[1])+'</button>'; }).join('')+
            '</div>'+
            /* 🔴 v837 — "LOCALIZAR PLACA" (executa o PROJETO20260901fotoia)
               Este botão é a resposta ao que o Angelo disse na v834: "tá
               horrível de fazer". O trabalho chato era MARCAR A REGIÃO — e é
               exatamente isso que ele resolve: a IA acha a placa, o app põe a
               proteção em cima dela, e ele só confere.
               ⚠️ Ele vem ANTES do "Adicionar proteção" de propósito: o caminho
               fácil primeiro, o manual logo abaixo, sempre disponível (§2.5). */
            '<button type="button" class="pp-bt pp-ia" id="ppIa">'+
              _ppIco('<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M11 8v6M8 11h6"/>')+
              'Localizar placa</button>'+
            '<button type="button" class="pp-bt" id="ppAdd">'+
              _ppIco('<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>')+
              'Adicionar proteção</button>'+
            '<button type="button" class="pp-bt" id="ppTirar" disabled>'+
              _ppIco('<line x1="5" y1="12" x2="19" y2="12"/>')+'Remover esta proteção</button>'+
            '<button type="button" class="pp-bt" id="ppSem">'+
              _ppIco('<polyline points="20 6 9 17 4 12"/>')+'Sem placa — confirmar</button>'+
            /* v820: a faixa foi de ±45° pra ±90° (placa de caminhão em rampa
               passa dos 45), e o ângulo agora fica ESCRITO ao lado — sem o
               número, ninguém repete o mesmo giro na foto seguinte. */
            '<label class="pp-rot"><span>Girar</span>'+
              '<input type="range" id="ppRot" min="-90" max="90" value="0" step="1" aria-label="Girar a proteção">'+
              '<output id="ppRotN" for="ppRot">0°</output>'+
            '</label>'+
          '</div>'+
        '</div>'+
        '<div class="pp-minis" id="ppMinis"></div>'+
        '<div class="pp-pe">'+
          '<button type="button" class="pp-bt pp-primaria" id="ppSalvar">Salvar fotos</button>'+
          '<button type="button" class="pp-bt" id="ppTodas">Aplicar em todas</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(ov);
    document.body.classList.add('pp-on');
    _ppLigar(ov);
    _ppPinta();
  }

  function _ppFoto(){ return _pp.fotos[_pp.i]; }

  function _ppPinta(){
    if(!_pp) return;
    var f=_ppFoto();
    /* a foto no palco */
    var cv=document.getElementById('ppCv'); if(!cv) return;
    var palco=document.getElementById('ppPalco');
    var maxW=palco.clientWidth||320;
    /* 🔴 `escala`, NUNCA `esc`. O app inteiro roda dentro de UM IIFE e o
       `esc()` (o que escapa HTML, do 01-nucleo) é uma função desse escopo.
       Um `var esc = <número>` aqui dentro HASTEIA e sombreia o `esc()` na
       função inteira — e a linha lá embaixo, que monta as miniaturas com
       `esc(s.tx)`, morre com "esc is not a function". O defeito nasceu
       assim na primeira rodada do teste da v808: a tela abria, o estado
       aparecia certo, e as miniaturas simplesmente não existiam. */
    var escala=Math.min(1, maxW/f.largura);
    cv.width=Math.round(f.largura*escala); cv.height=Math.round(f.altura*escala);
    var ctx=cv.getContext('2d');
    ctx.drawImage(f.bitmap, 0, 0, cv.width, cv.height);
    /* ⚠️ o palco mostra a MESMA composição que vai virar arquivo — usa a
       mesma função de desenho, com as coordenadas normalizadas. Se o preview
       usasse outro desenho, o que a pessoa aprova não seria o que sai. */
    f.mascaras.forEach(function(m){ _ppAplicaMascara(ctx, cv, m, cv.width, cv.height, f.variante); });
    /* as molduras azuis, por cima */
    var box=document.getElementById('ppRegioes');
    box.style.width=cv.width+'px'; box.style.height=cv.height+'px';
    box.innerHTML=f.mascaras.map(function(m,ix){
      var w=m.largura*cv.width, h=m.altura*cv.height;
      return '<div class="pp-reg'+(_pp.sel===ix?' on':'')+'" data-reg="'+ix+'" tabindex="0" role="button" '+
        'aria-label="Proteção '+(ix+1)+' de '+f.mascaras.length+(_pp.sel===ix?', selecionada':'')+
          ((m.rotacao||0)?(', girada '+Math.round(m.rotacao)+' graus'):'')+'" '+
        'style="left:'+(m.x*cv.width-w/2)+'px;top:'+(m.y*cv.height-h/2)+'px;width:'+w+'px;height:'+h+'px;'+
        'transform:rotate('+(m.rotacao||0)+'deg)">'+
        /* 🔴 v820 (pedido do Angelo: "ajuste em cada linha da borda") — além
           dos quatro CANTOS, uma alça no meio de cada LADO. Canto mexe nos
           dois lados de uma vez; a do lado mexe num só. Numa placa, que é
           bem mais larga que alta, é a do lado que resolve: dá pra encostar
           a borda de cima na placa sem estreitar a tarja. */
        ['nw','ne','sw','se','n','s','w','e'].map(function(k){
          return '<i class="pp-alca '+k+'" data-alca="'+k+'"></i>'; }).join('')+
        /* 🔴 v820 — a alça de GIRAR, acima da moldura. A faixa lateral
           continua lá (e é ela que o teclado usa), mas girar com o dedo em
           cima da própria placa é o gesto que a pessoa tenta primeiro. */
        '<i class="pp-girar" data-girar="1" role="button" tabindex="-1" aria-hidden="true"></i>'+
      '</div>';
    }).join('');
    /* o estado escrito (§3.2) */
    var n=f.mascaras.length;
    var est=document.getElementById('ppEstado');
    est.textContent = f.semPlacaConfirmado
      ? 'Sem placa — confirmado'
      : (n===0 ? 'Nenhuma placa marcada' : (n===1 ? '1 placa protegida' : n+' placas protegidas'));
    est.className='pp-estado '+(fotoPlacaValidarRevisao(f)?'ok':'pend');
    /* a escolha visual */
    Array.prototype.forEach.call(document.querySelectorAll('.pp-var'),function(b){
      var on=(b.getAttribute('data-var')===f.variante);
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on?'true':'false');
    });
    var bt=document.getElementById('ppTirar'); if(bt) bt.disabled=(_pp.sel<0);
    var rt=document.getElementById('ppRot');
    if(rt){
      rt.disabled=(_pp.sel<0);
      rt.value=(_pp.sel>=0?(f.mascaras[_pp.sel].rotacao||0):0);
      var rn=document.getElementById('ppRotN');
      if(rn) rn.textContent=Math.round(Number(rt.value)||0)+'\u00b0';
    }
    var sem=document.getElementById('ppSem');
    if(sem){ sem.classList.toggle('on', !!f.semPlacaConfirmado); sem.disabled=(n>0); }
    /* as miniaturas, com o selo ESCRITO (§3.4: cor nunca é a única indicação) */
    var mn=document.getElementById('ppMinis');
    mn.innerHTML=_pp.fotos.map(function(x,ix){
      var s=_ppSelo(x);
      return '<button type="button" class="pp-mini'+(ix===_pp.i?' on':'')+'" data-mini="'+ix+'" '+
        'aria-label="Foto '+(ix+1)+' de '+_pp.fotos.length+', '+s.tx+'" aria-current="'+(ix===_pp.i?'true':'false')+'">'+
        '<b>'+(ix+1)+'</b><span class="pp-selo '+s.cls+'">'+esc(s.tx)+'</span></button>';
    }).join('');
    Array.prototype.forEach.call(mn.querySelectorAll('[data-mini]'),function(b){
      b.onclick=function(){ _pp.i=Number(b.getAttribute('data-mini')); _pp.sel=-1; _ppPinta(); };
    });
    /* o botão de salvar só libera com TODAS revisadas (§3.1) */
    var faltam=_pp.fotos.filter(function(x){ return !fotoPlacaValidarRevisao(x); }).length;
    var sv=document.getElementById('ppSalvar');
    sv.disabled=(faltam>0);
    sv.textContent = faltam>0
      ? ('Falta revisar '+faltam+' foto'+(faltam===1?'':'s'))
      : (_pp.fotos.length===1?'Salvar foto':'Salvar fotos');
    var td=document.getElementById('ppTodas');
    td.textContent='Aplicar em todas ('+_pp.fotos.length+')';
    /* §3.2: "Aplicar em todas (N), somente quando as fotos tiverem regiões
       revisadas" — aqui: só quando ESTA foto tem o que copiar. */
    td.disabled=(_pp.fotos.length<2 || (!f.mascaras.length && !f.semPlacaConfirmado));
    _ppLigarRegioes();
  }

  function _ppLigarRegioes(){
    var box=document.getElementById('ppRegioes'); if(!box) return;
    var cv=document.getElementById('ppCv');
    Array.prototype.forEach.call(box.querySelectorAll('[data-reg]'),function(el){
      var ix=Number(el.getAttribute('data-reg'));
      el.onpointerdown=function(ev){
        ev.preventDefault(); ev.stopPropagation();
        _pp.sel=ix;
        var f=_ppFoto(), m=f.mascaras[ix];
        var alca=ev.target && ev.target.getAttribute && ev.target.getAttribute('data-alca');
        var girando=!!(ev.target && ev.target.getAttribute && ev.target.getAttribute('data-girar'));
        var x0=ev.clientX, y0=ev.clientY;
        var m0={ x:m.x, y:m.y, largura:m.largura, altura:m.altura, rotacao:(m.rotacao||0) };
        /* 🔴 v820 — pra girar eu preciso do CENTRO da região na tela, não do
           ponto onde o dedo encostou: o ângulo é medido do centro até o dedo. */
        var rCv=cv.getBoundingClientRect();
        var cxTela=rCv.left + m0.x*rCv.width, cyTela=rCv.top + m0.y*rCv.height;
        var angDedo=function(e){
          /* +90 porque a alça nasce ACIMA do centro: dedo em cima = 0° */
          return Math.atan2(e.clientY-cyTela, e.clientX-cxTela)*180/Math.PI + 90;
        };
        var ang0=girando?angDedo(ev):0;
        function mover(e){
          if(girando){
            m.rotacao=_ppGrau(m0.rotacao + (angDedo(e)-ang0));
            _ppPinta(); return;
          }
          var pxX=e.clientX-x0, pxY=e.clientY-y0;
          if(alca){
            /* 🔴 v820 — A ALÇA GIRA JUNTO COM A MOLDURA.
               O dedo anda na tela; a moldura, quando está inclinada, tem os
               próprios eixos. Sem desgirar o movimento antes de aplicar,
               puxar a alça de uma placa inclinada mexia na largura quando a
               pessoa queria a altura — parecia defeito da tela, e era conta
               faltando. Aqui o deslocamento é levado pros eixos da moldura. */
            var rd=-(m0.rotacao||0)*Math.PI/180;
            var cos=Math.cos(rd), sen=Math.sin(rd);
            var lx=pxX*cos - pxY*sen, ly=pxX*sen + pxY*cos;
            var dx=lx/cv.width, dy=ly/cv.height;
            /* a alça muda o TAMANHO a partir do centro — é o gesto que a
               pessoa espera numa moldura pequena, e não faz a região fugir
               do dedo.
               🔴 v820: o par [x,y] diz de QUE lados aquela alça cuida. Zero
               significa "não mexe": é isso que faz a alça do meio de cima
               mudar só a altura, e a do meio da esquerda só a largura. */
            var lados={ nw:[-1,-1], ne:[1,-1], sw:[-1,1], se:[1,1],
                        n:[0,-1], s:[0,1], w:[-1,0], e:[1,0] }[alca] || [1,1];
            m.largura = lados[0] ? _ppNum(m0.largura+dx*lados[0]*2, 0.03, 1.6) : m0.largura;
            m.altura  = lados[1] ? _ppNum(m0.altura +dy*lados[1]*2, 0.02, 1.6) : m0.altura;
          } else {
            /* arrastar a moldura inteira continua seguindo a TELA — inclinada
               ou não, ela vai pra onde o dedo vai. */
            m.x=_ppNum(m0.x+pxX/cv.width, 0, 1);
            m.y=_ppNum(m0.y+pxY/cv.height, 0, 1);
          }
          _ppPinta();
        }
        function soltar(){
          window.removeEventListener('pointermove', mover);
          window.removeEventListener('pointerup', soltar);
        }
        window.addEventListener('pointermove', mover);
        window.addEventListener('pointerup', soltar);
        _ppPinta();
      };
      /* §9: o editor funciona por toque, mouse E TECLADO */
      el.onkeydown=function(e){
        var f=_ppFoto(), m=f.mascaras[ix], p=e.shiftKey?0.05:0.01, usou=true;
        _pp.sel=ix;
        if(e.key==='ArrowLeft')      m.x=_ppNum(m.x-p,0,1);
        else if(e.key==='ArrowRight')m.x=_ppNum(m.x+p,0,1);
        else if(e.key==='ArrowUp')   m.y=_ppNum(m.y-p,0,1);
        else if(e.key==='ArrowDown') m.y=_ppNum(m.y+p,0,1);
        else if(e.key==='+'||e.key==='=') { m.largura=_ppNum(m.largura+p,0.03,1.6); m.altura=_ppNum(m.altura+p/2,0.02,1.6); }
        else if(e.key==='-')         { m.largura=_ppNum(m.largura-p,0.03,1.6); m.altura=_ppNum(m.altura-p/2,0.02,1.6); }
        /* v820 — girar pelo teclado (§9: toque, mouse E teclado).
           Shift gira de 5 em 5; sem Shift, de 1 em 1. */
        else if(e.key==='['||e.key===',') m.rotacao=_ppGrau((m.rotacao||0)-(e.shiftKey?5:1));
        else if(e.key===']'||e.key==='.') m.rotacao=_ppGrau((m.rotacao||0)+(e.shiftKey?5:1));
        else if(e.key==='Delete'||e.key==='Backspace'){ f.mascaras.splice(ix,1); _pp.sel=-1; }
        else usou=false;
        if(usou){ e.preventDefault(); _ppPinta(); }
      };
    });
  }

  function _ppLigar(ov){
    document.getElementById('ppX').onclick=function(){ _ppFechar([]); };
    ov.addEventListener('keydown', function(e){
      if(e.key==='Escape'){ e.preventDefault(); _ppFechar([]); }
    });
    (function(){
      var bIa=document.getElementById('ppIa');
      if(bIa) bIa.onclick=function(){ _ppLocalizarComIa(bIa); };
    })();
    document.getElementById('ppAdd').onclick=function(){
      var f=_ppFoto();
      f.mascaras.push(_ppMascaraNova());
      f.semPlacaConfirmado=false;
      _pp.sel=f.mascaras.length-1;
      _ppPinta();
    };
    document.getElementById('ppTirar').onclick=function(){
      var f=_ppFoto();
      if(_pp.sel<0) return;
      f.mascaras.splice(_pp.sel,1); _pp.sel=-1; _ppPinta();
    };
    document.getElementById('ppSem').onclick=function(){
      var f=_ppFoto();
      if(f.mascaras.length) return;   /* com região marcada não faz sentido */
      f.semPlacaConfirmado=!f.semPlacaConfirmado;
      /* §7: "gravar quem confirmou e quando" */
      f.confirmadoPor=(typeof meuId!=='undefined'?meuId:'')||'';
      f.confirmadoEm=new Date().toISOString();
      _ppPinta();
    };
    var rt=document.getElementById('ppRot');
    if(rt) rt.oninput=function(){
      var f=_ppFoto(); if(_pp.sel<0) return;
      f.mascaras[_pp.sel].rotacao=_ppGrau(Number(this.value)||0);
      _ppPinta();
    };
    Array.prototype.forEach.call(ov.querySelectorAll('.pp-var'),function(b){
      b.onclick=function(){ _ppFoto().variante=b.getAttribute('data-var'); _ppPinta(); };
    });
    document.getElementById('ppTodas').onclick=function(){ fotoPlacaAplicarLote(); };
    document.getElementById('ppSalvar').onclick=function(){ fotoPlacaExportar(); };
    /* clicar no palco, fora de uma região, tira a seleção */
    document.getElementById('ppPalco').onpointerdown=function(e){
      if(e.target.closest && e.target.closest('.pp-reg')) return;
      _pp.sel=-1; _ppPinta();
    };
    window.addEventListener('resize', _ppRedim);
  }
  var _ppTimer=null;
  function _ppRedim(){ clearTimeout(_ppTimer); _ppTimer=setTimeout(function(){ if(_pp) _ppPinta(); }, 120); }

  /* §3.2: copiar a composição desta foto pras outras */
  function fotoPlacaAplicarLote(){
    if(!_pp) return;
    var f=_ppFoto();
    _pp.fotos.forEach(function(x){
      if(x===f) return;
      x.mascaras=f.mascaras.map(function(m){ return { x:m.x, y:m.y, largura:m.largura, altura:m.altura, rotacao:m.rotacao, confirmado:true }; });
      x.variante=f.variante;
      x.semPlacaConfirmado=f.semPlacaConfirmado;
      if(f.semPlacaConfirmado){ x.confirmadoPor=f.confirmadoPor; x.confirmadoEm=f.confirmadoEm; }
    });
    try{ toast('Proteção copiada pras outras fotos. Confira uma a uma.'); }catch(_){}
    _ppPinta();
  }

  /* gera os arquivos e devolve pro chamador */
  async function fotoPlacaExportar(){
    if(!_pp) return;
    var faltam=_pp.fotos.filter(function(x){ return !fotoPlacaValidarRevisao(x); });
    if(faltam.length){ try{ toast('Ainda falta revisar '+faltam.length+' foto(s).'); }catch(_){} return; }
    var bt=document.getElementById('ppSalvar');
    if(bt){ bt.disabled=true; bt.textContent='Gerando…'; }
    var saida=[];
    for(var i=0;i<_pp.fotos.length;i++){
      var f=_pp.fotos[i];
      try{
        var b=await fotoPlacaRenderizar(f.bitmap, f.mascaras, f.variante);
        saida.push({
          blob:b, largura:f.largura, altura:f.altura, variante:f.variante,
          mascaras:f.mascaras.map(function(m){
            return { x:m.x, y:m.y, largura:m.largura, altura:m.altura, rotacao:m.rotacao||0, tipo:f.variante, confirmado:true };
          }),
          semPlacaConfirmado:!!f.semPlacaConfirmado,
          confirmadoPor:f.confirmadoPor||'', confirmadoEm:f.confirmadoEm||'',
          versaoProtecao:1
        });
      }catch(e){
        /* §3.3, "Erro ao processar": não sobe nada dessa foto */
        try{ toast('Não consegui proteger uma das fotos. Ela não foi enviada.'); }catch(_){}
      }
    }
    _ppFechar(saida);
  }

  /* ---------------------------------------------------------------------
     fotoVeiculoPreparar — a porta que os chamadores usam (§5.1)
     ---------------------------------------------------------------------
     Recebe os arquivos escolhidos, abre a tela, devolve as fotos protegidas.
     ⚠️ Devolve [] quando a pessoa fecha sem salvar — e quem chama TEM que
     tratar isso como "não envie nada". */
  async function fotoVeiculoPreparar(files, opcoes){
    opcoes=opcoes||{};
    var lista=[].slice.call(files||[]);
    if(!lista.length) return [];

    /* ======================================================================
       v845 — O INTERRUPTOR DESLIGADO PASSA AS FOTOS DIRETO (pedido do Angelo)
       ----------------------------------------------------------------------
       "remove a função de achar a placa e colocar placa preta, não ficou bom
        nem borrar, remove"

       Com `MEV_PROTEGE_PLACA = false` (no 00-edicoes.js), a tela NÃO abre e a
       foto escolhida segue como está pro envio. Todo o resto deste arquivo
       continua vivo e chamável — some a EXIGÊNCIA, não a capacidade.

       🔴 O `semPlacaConfirmado:true` abaixo NÃO é uma mentira sobre a foto, e
       eu não quero que alguém leia como se fosse. Ele é a etiqueta que o
       `avUpload` lê pra saber que ESTE caminho não passou pelo editor. O
       `protecao:'desligada'` ao lado é o que diz a verdade, e é por ele que se
       procura no futuro: uma foto com essa marca subiu com a placa legível,
       por decisão do dono, registrada no changelog da v845.
       ⚠️ Quem for reativar: basta voltar o interruptor. Não escreva conversão
       nenhuma pra "consertar" as fotos antigas — as que já subiram, subiram.
       ====================================================================== */
    if(typeof window.edProtegePlaca==='function' && !window.edProtegePlaca()){
      return lista.map(function(f){
        return { blob:f, largura:0, altura:0, variante:'',
                 mascaras:[], semPlacaConfirmado:true,
                 protecao:'desligada',            /* ⛳ v845 — a marca honesta */
                 confirmadoPor:'', confirmadoEm:'', versaoProtecao:0 };
      });
    }

    if(typeof Path2D==='undefined' || !document.createElement('canvas').getContext){
      /* 🔴 NAVEGADOR SEM CANVAS: não dá pra proteger, então NÃO PUBLICA.
         "Publicar sem proteger porque o navegador é velho" é exatamente o
         defeito que este projeto existe pra impedir. */
      try{ toast('Este navegador não consegue proteger a placa. Abra pelo Chrome ou Safari atualizado.'); }catch(_){}
      return [];
    }
    return await fotoPlacaAbrir(lista, opcoes);
  }

/* ╔═══ src/app/13d-editar-foto-ia.js ═════════════════════════════════════ */
  /* ======================================================================
     13d — EDITAR FOTO COM IA (Estoque + Avaliações)
     ----------------------------------------------------------------------
     A transformação inteira acontece na OpenAI. O navegador só reduz a cópia
     enviada, compara original/resultado e, depois da confirmação, usa a porta
     de upload que já existe. Não há prompt livre: receitas fechadas
     mantêm custo, marca e resultado sob controle.
     ====================================================================== */
  var FOTO_IA_CUSTO=1.5;
  var _fotoIaEmCurso=false;
  var _fotoIaCompartilhando=false;
  var _fotoIaReceitas={
    /* ==========================================================================
       🔴 v862 — PROJETO "converter foto para o estoque com IA" (03/09).
       Pedido do Angelo: "limpeza, aplica placa MEV, deixa o fundo no padrão,
       em uma única chamada (converter imagem pro estoque)".
       --------------------------------------------------------------------------
       O projeto mandou SUBSTITUIR "Limpar e padronizar" por um nome que diga
       pra que serve. Feito.

       ⚠️ E ISSO TROCA A IDENTIDADE PADRÃO, o que merece estar escrito: a ação
       antiga (`completa`) punha a placa ÂNGELO FERRARI; esta põe a placa
       PRETA MEV e reconstrói o fundo neutro. São receitas diferentes, não um
       rótulo novo pra mesma coisa. A `completa` NÃO foi apagada — está logo
       abaixo, comentada, e volta descomentando (regra da casa: esconder,
       não apagar). A receita dela também continua inteira no servidor.
       ⛳ PRA VOLTAR AO ANTIGO: descomente o bloco `completa` abaixo. Os dois
       podem conviver no menu, se você quiser oferecer as duas. */
    estoque_padrao:{
      titulo:'Converter para o estoque',
      sub:'Limpa e otimiza a foto, usa o fundo neutro do Post Clean e troca a placa visível pela placa preta MEV.'
    },
    /* completa:{
      titulo:'Limpar e padronizar',
      sub:'Remove placa e marcas antigas, limpa o fundo e aplica Ângelo Ferrari Consultoria somente na placa.'
    }, */
    privacidade:{
      titulo:'Remover placa e marcas',
      sub:'Remove placas, logos, nomes, telefones e adesivos de outras lojas.'
    },
    fundo:{
      titulo:'Limpar o fundo',
      sub:'Remove outros veículos, pessoas e distrações, preservando o carro principal.'
    },
    mev:{
      titulo:'Aplicar placa MEV',
      sub:'Troca a placa visível pela placa preta oficial, respeitando ângulo e luz.'
    },
    repasse_azul:{
      titulo:'Criar divulgação de repasse',
      sub:'Gera uma arte 9:16 preta e azul no showroom, com o símbolo AF somente na placa.'
    },
    divulgacao_garantia:{
      titulo:'Criar divulgação com garantia',
      sub:'Gera uma arte 9:16 para 0 km ou seminovo no showroom AF, destacando a garantia sem inventar condições.'
    },
    /* v866 — duas opções SEPARADAS: o projeto proíbe gerar os dois formatos
       num toque só, pra ninguém pagar dois tokens quando precisa de um. */
    divulgacao_garantia_post_clean:{
      titulo:'Criar post clean com garantia',
      sub:'Arte quadrada para o feed do Instagram.'
    },
    divulgacao_garantia_story_clean:{
      titulo:'Criar story clean com garantia',
      sub:'Arte vertical para Stories e Status.'
    },
    /* 🔴 v871 — pedido do Angelo (03/09): "CRIE UM POST CLEAN PRA REPASSE
       TAMBÉM". Mesma foto limpa das clean com garantia; o que muda é o que
       o APARELHO escreve por cima: os dois preços (DE riscado / POR) e o
       selo REPASSE no lugar do COM GARANTIA. */
    repasse_post_clean:{
      titulo:'Criar post clean de repasse',
      sub:'Arte quadrada para o feed, com o preço de repasse e o selo REPASSE.'
    },
    /* v875 — o story do repasse. Mesma regra da v866 pro par com garantia:
       DUAS receitas separadas, porque escolher post não pode gerar story
       (nem cobrar o token dos dois). */
    repasse_story_clean:{
      titulo:'Criar story clean de repasse',
      sub:'Arte vertical para Stories e Status, com o preço de repasse.'
    }
  };

  /* ======================================================================
     🔴 v868 — "CONFIRA ANTES DE GERAR" PASSA A VALER PRAS OITO RECEITAS
     ----------------------------------------------------------------------
     A v866 pôs esse quadro só no post e no story clean. Era pouco: TODA
     receita deste menu gasta 1,5 token, e nas outras seis a pessoa tocava
     "Gerar" sabendo só o título do item. Se o preço do cadastro estivesse
     errado, ou se ela tivesse aberto a foto do carro errado, descobria
     DEPOIS de pagar.

     A regra que organiza tudo: o quadro é montado por UMA função, a partir
     de uma configuração FECHADA, ligada às mesmas chaves de
     `_fotoIaReceitas`. Receita nova sem entrada aqui não fica sem quadro
     por esquecimento — o teste da v868 percorre as chaves e reprova.

     ⚠️ LINHA SEM DADO SOME INTEIRA. Nada de "—", "undefined", "não
     informado" ou zero: um traço no lugar do preço parece dado, e dado
     falso numa tela de confirmação é pior que informação nenhuma. A única
     exceção é o valor da arte, que quando não existe DIZ o que a arte vai
     escrever no lugar ("CONSULTE O VALOR") — porque aí a ausência é a
     informação.

     ⚠️ TODOS OS VALORES PASSAM POR `esc()`. Modelo, ano e km vêm do cadastro
     do lojista, que é texto livre.
     ====================================================================== */
  var _FIA_CONF={
    estoque_padrao:{
      botao:'Converter foto',
      formato:'Post 1:1 · 1080 × 1080',
      faz:'Limpeza e otimização, remoção de marcas comerciais, fundo neutro contínuo do Post Clean e placa preta MEV.',
      destino:'Galeria de fotos do estoque',
      campos:['veiculo'],
      notas:['Os emblemas originais do fabricante são preservados.']
    },
    privacidade:{
      botao:'Gerar versão',
      formato:'Proporção original',
      faz:'Oculta as placas legíveis e remove logos, nomes, telefones, adesivos e comunicação de outras lojas.',
      campos:['veiculo'],
      notas:['Não adiciona nova marca.']
    },
    fundo:{
      botao:'Gerar versão',
      formato:'Proporção original',
      faz:'Remove pessoas, outros veículos e distrações do cenário.',
      campos:['veiculo'],
      notas:['O veículo principal será preservado.']
    },
    mev:{
      botao:'Gerar versão',
      formato:'Proporção original',
      faz:'Troca somente a placa visível pela placa preta MEV.',
      campos:['veiculo'],
      notas:['Se a placa não estiver visível, nenhuma é inventada.']
    },
    repasse_azul:{
      botao:'Criar divulgação',
      formato:'Story 9:16',
      faz:'Gera a arte de repasse no showroom AF, com o símbolo AF somente na placa.',
      identidade:'Showroom AF · preto, azul e branco',
      campos:['veiculo','ano','km','precoDe','precoPor'],
      notas:['Dados que não estiverem no cadastro são omitidos, nunca inventados.']
    },
    divulgacao_garantia:{
      botao:'Criar divulgação',
      formato:'Story 9:16',
      faz:'Gera a arte com garantia no showroom AF, sem inventar prazo nem cobertura.',
      identidade:'Showroom AF com garantia',
      campos:['categoria','veiculo','ano','km','valor'],
      notas:['Dados que não estiverem no cadastro são omitidos, nunca inventados.']
    },
    divulgacao_garantia_post_clean:{
      botao:'Criar post',
      formato:'Post 1:1 · 1080 × 1080',
      faz:'A IA entrega só a foto limpa; o modelo, o ano, a km e o preço são escritos aqui no aparelho.',
      /* v888 — a etiqueta de situação entra (não custa altura); os destaques
         NÃO: este layout não recebeu a conta nova, só o post de repasse. */
      campos:['veiculo','ano','km','valor','situacao'],
      notas:['Texto e valores exatos são aplicados no aparelho.']
    },
    divulgacao_garantia_story_clean:{
      botao:'Criar story',
      formato:'Story 9:16 · 1080 × 1920',
      faz:'A IA entrega só a foto limpa; o modelo, o ano, a km, o preço e os destaques são escritos aqui no aparelho.',
      /* v888 — ganhou `fatos` (cabe: 120 px medidos entre o selo e o carro) e
         a etiqueta de situação. */
      campos:['veiculo','ano','km','valor','fatos','situacao'],
      minis:true,   /* v877 */
      notas:['Texto e valores exatos são aplicados no aparelho.']
    },
    /* v871 — o post de repasse mostra DOIS preços na conferência, na mesma
       ordem em que a arte os desenha: o "de" riscado por cima do "por". */
    repasse_post_clean:{
      botao:'Criar post',
      formato:'Post 1:1 · 1080 × 1080',
      faz:'A IA entrega só a foto limpa; o modelo, o ano, a km, a FIPE, o preço e o percentual são escritos aqui no aparelho.',
      identidade:'Showroom AF · selo REPASSE',
      /* v888 — os destaques passaram a caber aqui (o bloco de cima encolheu;
         a conta está no `post_repasse` do `_FIA_LAY`), e a situação entrou. */
      campos:['veiculo','ano','km','precoDeArte','precoPorArte','pctArte','fatos'],
      notas:['Texto e valores exatos são aplicados no aparelho.',
             'A FIPE só é riscada na arte quando for MAIOR que o preço de repasse.',
             'Sem CTA no rodapé: só a assinatura, centralizada.']
    },
    repasse_story_clean:{
      botao:'Criar story',
      formato:'Story 9:16 · 1080 × 1920',
      faz:'A IA entrega só a foto limpa; o modelo, o ano, a km, os preços e os destaques são escritos aqui no aparelho.',
      identidade:'Showroom AF · selo REPASSE',
      /* 🔴 v876 — OS DESTAQUES SÓ ENTRAM AQUI, NO STORY, E ISSO É MEDIDO.
         No post 1:1 o bloco de texto termina a 18 px do teto do carro e as
         rodas param a 34 px do rodapé: não há linha livre. Pôr os destaques
         lá sairia por cima da lataria ou colado no "FALE COMIGO" — e uma
         arte publicada com texto em cima do carro não tem desfazer.
         O story tem 96 px de folga em cima e uma faixa limpa embaixo das
         rodas. É onde a linha cabe de verdade. */
      /* v902 — o `pctArte` entra logo DEPOIS do preço, na mesma ordem em que a
         arte desenha. Sem FIPE maior que o repasse ele devolve vazio e a linha
         inteira some do quadro (o montador ignora campo sem valor). */
      campos:['veiculo','ano','km','precoDeArte','precoPorArte','pctArte','fatos'],
      minis:true,   /* v877 — a montagem (só o story tem pé pra ela) */
      notas:['Texto e valores exatos são aplicados no aparelho.',
             'A FIPE só é riscada na arte quando for MAIOR que o preço de repasse.',
             'Sem CTA no rodapé: só a assinatura, centralizada.']
    }
  };
  var _FIA_ROTULO={
    veiculo:'Veículo', ano:'Ano/modelo', km:'Quilometragem', categoria:'Categoria',
    valor:'Valor que será usado na arte', precoDe:'Preço de', precoPor:'Preço por',
    /* v871 — mesmo rótulo, outra REGRA: `precoDe`/`precoPor` mostram o campo
       cru do cadastro (é o que a `repasse_azul` manda pra IA); estes dois
       mostram o que a ARTE vai escrever — com o "de" sumindo quando não é
       desconto, e o "por" dizendo "CONSULTE O VALOR" quando não há preço. */
    precoDeArte:'FIPE (riscada na arte)', precoPorArte:'Preço por',
    fatos:'Destaques',   /* v876 */
    situacao:'Situação',  /* v888 */
    pctArte:'Percentual na arte'  /* v902 */
  };
  /* ============================================================================
     🔴 v888 — A ETIQUETA DE SITUAÇÃO (pedido do Angelo, 04/09: "permita também
     colocar, Cotação, Entrando em Estoque ou Disponível")
     ----------------------------------------------------------------------------
     ⚠️ É UMA LISTA FECHADA, NÃO UMA CAIXA DE DIGITAR — e isso é de propósito.
     Uma arte que sai no Instagram dizendo "DISPONÍVEL" é uma promessa comercial.
     Com texto livre, um erro de digitação vira promessa errada publicada; com
     três opções, o pior caso é a opção errada, que se corrige gerando de novo.

     ⚠️ NASCE VAZIA, SEMPRE. O cadastro do estoque tem uma situação própria
     (negociando, vendido, …) e seria fácil "adivinhar" a partir dela. Não faz:
     as palavras do Angelo não são as do cadastro, e traduzir uma na outra é
     inventar. Quem sabe se o carro está em cotação é ele, no momento de gerar.
     ========================================================================== */
  var _FIA_SITUACOES=['Cotação','Entrando em estoque','Disponível'];
  function _fotoIaMoedaConf(n){
    n=Number(n)||0; if(!(n>0)) return '';
    var t=''; try{ t=n.toLocaleString('pt-BR',{style:'currency',currency:'BRL',minimumFractionDigits:2,maximumFractionDigits:2}); }catch(_){ }
    if(!t||t.indexOf('R$')<0) t='R$ '+String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+',00';
    /* 🔴 v868 — \u00A0 ESCRITO POR ESCAPE, DE PROPÓSITO. O `toLocaleString`
       do pt-BR separa o "R$" do número com um ESPAÇO NÃO-QUEBRÁVEL, e a
       primeira versão desta linha trazia esse caractere literal — que se
       perdeu na cópia do arquivo e virou um replace de espaço por espaço,
       calado. O teste da v868 pegou. Escapado, ele não se perde mais. */
    return t.replace(/\u00A0/g,' ');
  }
  /* o valor da arte é o ÚNICO campo que não some quando falta: a ausência
     é a informação — a arte vai escrever "CONSULTE O VALOR" no lugar. */
  function _fotoIaValorConf(d){
    var p=Number(d&&d.precoAnuncio)||0;
    return p>0 ? _fotoIaPrecoTxt(d) : 'Sem preço de anúncio. A arte mostrará “CONSULTE O VALOR”.';
  }
  /* ============================================================================
     🔴 v876 — OS DESTAQUES: as observações do repasse, na arte
     ----------------------------------------------------------------------------
     Pedido do Angelo (04/09): "quando for repasse traga as observações do
     repasse pra IA considerar no post".

     ⚠️ E ELAS NÃO VÃO PRA IA — VÃO PRO CANVAS. Não é teimosia, é a mesma razão
     que fez a v866 existir: modelo de imagem ERRA TEXTO. "PNEUS NOVOS" volta
     "PNEUS NOVQS", e ninguém confere o que já foi publicado. Escrito aqui no
     aparelho, o que você digitou é exatamente o que sai. O prompt das receitas
     clean continua FECHADO — nada do cadastro atravessa pro fornecedor.

     ⚠️ NO MÁXIMO TRÊS, E CURTOS. A folha tem uma linha só pra isso; a quarta
     não caberia e sairia cortada, que é pior que não aparecer.
     ⚠️ E O TEXTO JÁ CHEGA LIMPO: quem monta o pacote passa a observação pelo
     `obsPublica()` (v265), que apaga valores em dinheiro. Custo de reparo numa
     arte pública é o piso da sua negociação no Instagram. */
  /* v888 — devolve a etiqueta em maiúsculas, ou '' quando não foi escolhida.
     ⚠️ O que não estiver na lista fechada é DESCARTADO, não desenhado: é a
     mesma trava do servidor (`dados` é dado de exibição, nunca instrução). */
  function _fotoIaSituacaoTxt(d){
    var v=String((d&&d.situacao)||'').trim();
    for(var i=0;i<_FIA_SITUACOES.length;i++)
      if(v.toLowerCase()===_FIA_SITUACOES[i].toLowerCase()) return _FIA_SITUACOES[i].toUpperCase();
    return '';
  }
  function _fotoIaFatosTxt(d){
    var f=(d&&d.fatos);
    if(typeof f==='string') f=f.split(/[,;·\n]+/);
    if(!Array.isArray(f)) return '';
    var out=[];
    for(var i=0;i<f.length && out.length<3;i++){
      var t=String(f[i]||'').replace(/\s+/g,' ').trim();
      if(!t) continue;
      if(t.length>26) t=t.slice(0,26).replace(/[\s·-]+$/,'');
      out.push(t.toUpperCase());
    }
    return out.join('  ·  ');
  }

  function _fotoIaCampoConf(k,d){
    if(k==='veiculo')  return _fotoIaModeloTxt(d);
    if(k==='ano')      return _fotoIaAnoTxt(d);
    if(k==='km')       return _fotoIaKmTxt(d);
    if(k==='categoria')return String((d&&d.categoria)||'')==='0 KM'?'0 km':'Seminovo';
    if(k==='valor')    return _fotoIaValorConf(d);
    if(k==='precoDe')  return _fotoIaMoedaConf(d&&d.precoDe);
    if(k==='precoPor') return _fotoIaMoedaConf(d&&d.precoPor);
    if(k==='precoDeArte')  return _fotoIaRepasseDe(d);
    if(k==='precoPorArte') return _fotoIaRepassePorConf(d);
    if(k==='fatos')        return _fotoIaFatosTxt(d);   /* v876 */
    if(k==='situacao')     return _fotoIaSituacaoTxt(d);   /* v888 */
    if(k==='pctArte')      return _fotoIaPctAbaixoConf(d);   /* v902 */
    return '';
  }
  /* ============================================================================
     🔴 v876 — "PERMITA EDITAR" (pedido do Angelo, 04/09)
     ----------------------------------------------------------------------------
     O que fez o pedido nascer, e vale registrar porque é o teste de verdade
     deste código: a placa do Tiguan trouxe o nome
         "VW - VOLKSWAGEN TIGUAN ALLSPAC R-LINE 350 TSI 2.0 4X4"
     — a marca duplicada (a FIPE escreve "VW - VOLKSWAGEN") e o modelo cortado
     pela base. Numa arte de 1080 px isso encolhe a letra até virar formiga.
     Nenhum conserto automático acerta esse caso sempre; quem sabe o nome certo
     do carro é você. Então a tela deixa você escrever.

     ⚠️ A EDIÇÃO ACONTECE ANTES DA COBRANÇA, e isso é o ponto. O quadro já era
     "Confira antes de gerar" (v868); agora ele também CONSERTA antes de gerar.
     Descobrir o nome errado depois de pagar 1,5 token é o que a v868 quis
     evitar e faltava a metade.

     ⚠️ NADA DISSO VAI PRO FORNECEDOR nas receitas clean: o prompt delas é
     fechado (v866) e o servidor ignora `dados`. O que você edita é o que o
     APARELHO desenha — por isso sai exato.

     O mapa abaixo é FECHADO, como todo o resto deste arquivo: campo sem
     entrada aqui aparece no quadro mas não vira caixa de digitar. */
  var _FIA_EDITA={
    veiculo:      { de:'modelo',       tipo:'texto', dica:'Marca, modelo e versão' },
    ano:          { de:'ano',          tipo:'texto', dica:'2023/2024' },
    km:           { de:'km',           tipo:'num',   dica:'31000' },
    valor:        { de:'precoAnuncio', tipo:'num',   dica:'Preço que sai na arte' },
    precoDe:      { de:'precoDe',      tipo:'num',   dica:'Preço de anúncio' },
    precoPor:     { de:'precoPor',     tipo:'num',   dica:'Preço de repasse' },
    precoDeArte:  { de:'fipe',         tipo:'num',   dica:'Só aparece se for MAIOR que o preço de repasse' },
    precoPorArte: { de:'precoPor',     tipo:'num',   dica:'Preço de repasse' },
    fatos:        { de:'fatos',        tipo:'lista', dica:'Pneus novos, único dono, IPVA pago' },
    situacao:     { de:'situacao',     tipo:'opcao', opcoes:_FIA_SITUACOES, dica:'Sem etiqueta' }   /* v888 */
  };
  function _fiaEditaVal(k,d){
    var e=_FIA_EDITA[k]; if(!e) return '';
    var v=(d||{})[e.de];
    if(e.tipo==='lista') return Array.isArray(v)?v.join(', '):String(v||'');
    if(e.tipo==='num'){ var n=Number(v)||0; return n>0?String(n):''; }
    if(e.tipo==='opcao'){
      var op=String(v||''); return (e.opcoes||[]).indexOf(op)>=0?op:'';
    }
    return String(v==null?'':v);
  }
  /* lê as caixas e devolve um pacote NOVO — o original nunca é alterado, pra
     "Cancelar" ser de verdade e pra um segundo toque partir do cadastro. */
  function _fotoIaConfLer(acao,dados){
    var c=_FIA_CONF[acao]; if(!c) return dados;
    var out={}; for(var kk in (dados||{})) if(Object.prototype.hasOwnProperty.call(dados,kk)) out[kk]=dados[kk];
    (c.campos||[]).forEach(function(k){
      var e=_FIA_EDITA[k]; if(!e) return;
      var el=document.getElementById('fiaEd_'+k); if(!el) return;
      var raw=String(el.value||'').trim();
      if(e.tipo==='num'){ out[e.de]=Number(raw.replace(/[^\d]/g,''))||0; }
      else if(e.tipo==='lista'){ out[e.de]=raw?raw.split(/[,;·]+/).map(function(x){return x.trim();}).filter(Boolean):[]; }
      /* v888 — a lista fechada é cobrada DE NOVO na leitura. A tela já só
         oferece três opções; isto é a segunda trava, pro caso de alguém mexer
         no <select> pelo inspetor do navegador. */
      else if(e.tipo==='opcao'){ out[e.de]=(e.opcoes||[]).indexOf(raw)>=0?raw:''; }
      else{ out[e.de]=raw; }
    });
    return out;
  }
  function _fiaTemEdicao(acao){
    var c=_FIA_CONF[acao]; if(!c) return false;
    return (c.campos||[]).some(function(k){ return !!_FIA_EDITA[k]; });
  }
  function _fotoIaEditaHtml(acao,dados){
    var c=_FIA_CONF[acao]; if(!c) return '';
    return '<div class="fotoia-edita" id="fotoiaEdita" hidden>'+
      (c.campos||[]).filter(function(k){ return !!_FIA_EDITA[k]; }).map(function(k){
        var e=_FIA_EDITA[k], id='fiaEd_'+k;
        var lbl='<label class="cad-lbl" for="'+id+'">'+esc(_FIA_ROTULO[k]||k)+'</label>';
        if(e.tipo==='opcao'){   /* v888 */
          var atual=_fiaEditaVal(k,dados);
          return lbl+'<select class="cad-in" id="'+id+'">'+
            '<option value=""'+(atual?'':' selected')+'>'+esc(e.dica||'Sem etiqueta')+'</option>'+
            (e.opcoes||[]).map(function(o){
              return '<option value="'+esc(o)+'"'+(atual===o?' selected':'')+'>'+esc(o)+'</option>';
            }).join('')+'</select>';
        }
        return lbl+
               '<input class="cad-in" id="'+id+'" '+(e.tipo==='num'?'inputmode="numeric" ':'')+
               'value="'+esc(_fiaEditaVal(k,dados))+'" placeholder="'+esc(e.dica||'')+'">';
      }).join('')+
      '<p class="fotoia-confere-pe">O que você escrever aqui é exatamente o que a arte vai desenhar. Vazio some da arte — nada é inventado.</p>'+
    '</div>';
  }

  /* devolve [[rótulo,valor], …] — já sem as linhas vazias */
  function _fotoIaConfLinhas(acao,dados){
    var c=_FIA_CONF[acao], rec=_fotoIaReceitas[acao];
    if(!c||!rec) return [];
    var L=[['Operação',rec.titulo],['O que será feito',c.faz],['Formato',c.formato]];
    if(c.destino) L.push(['Destino',c.destino]);
    if(c.identidade) L.push(['Identidade',c.identidade]);
    (c.campos||[]).forEach(function(k){
      var v=_fotoIaCampoConf(k,dados);
      if(v) L.push([_FIA_ROTULO[k]||k, v]);
    });
    /* ⛳ v907 TROCOU o texto fixo "1,5 token por resultado válido". Este
       quadro existe pra pessoa CONFERIR ANTES DE PAGAR (v868); mostrar 1,5
       nele enquanto o botão diz 4,5 transformaria a conferência em armadilha. */
    var _nMn=(dados&&Array.isArray(dados.minis))?Math.min(dados.minis.length,2):0;
    L.push(['Custo', _nMn
      ? (_fiaCustoTxt(_nMn)+' — 1,5 pela foto grande e 1,5 por miniatura ('+_nMn+')')
      : 'R$ 2,85 por resultado válido']);
    return L;
  }
  function _fotoIaConfHtml(acao,dados){
    var L=_fotoIaConfLinhas(acao,dados);
    if(!L.length) return '';
    var c=_FIA_CONF[acao]||{};
    var pe=['A foto original continua preservada.'].concat(c.notas||[]).join(' ');
    var podeEditar=_fiaTemEdicao(acao);
    return '<div class="fotoia-confere">'+
      '<div class="fotoia-confere-tp">'+
        '<b id="fotoiaConfereT">Confira antes de gerar</b>'+
        (podeEditar?'<button type="button" class="fotoia-edt" id="fotoiaEditar" aria-expanded="false" aria-controls="fotoiaEdita">Editar</button>':'')+
      '</div>'+
      '<dl id="fotoiaConfDl" aria-labelledby="fotoiaConfereT">'+
        L.map(function(l){ return '<div><dt>'+esc(l[0])+'</dt><dd>'+esc(l[1])+'</dd></div>'; }).join('')+
      '</dl>'+
      (podeEditar?_fotoIaEditaHtml(acao,dados):'')+
      '<p class="fotoia-confere-pe">'+esc(pe)+'</p>'+
    '</div>';
  }

  /* ============================================================================
     🔴 v877 — A TIRA DE ESCOLHER AS MINIATURAS
     ----------------------------------------------------------------------------
     ⚠️ A FOTO PRINCIPAL FICA DE FORA DA TIRA. Ela já é o assunto da arte;
     deixá-la selecionável faria a mesma imagem aparecer grande e pequena na
     mesma peça — parece defeito, não montagem.
     ⚠️ E O TETO É DOIS, travado no clique e no desenho. A folha tem lugar
     para duas caixas de 461 px; uma terceira ou sairia fora da arte ou
     espremeria as três a ponto de não se reconhecer o carro em nenhuma.
     ============================================================================ */
  /* ============================================================================
     🔴 v907 — O PREÇO QUE MUDA ENQUANTO A PESSOA ESCOLHE
     ----------------------------------------------------------------------------
     Até a v906 o custo era uma constante escrita à mão em cinco lugares
     ("1,5 token"). Com a miniatura passando pela IA ele deixou de ser
     constante: é 1,5 pela foto grande MAIS 1,5 por miniatura escolhida.
     ⚠️ Isto é uma conta de dinheiro, então ela mora numa função só. Cinco
     textos calculando o mesmo preço em paralelo é como um deles fica para
     trás — e o que fica para trás é sempre o que a pessoa está lendo. */
  function _fiaCusto(nMinis){ var n=Number(nMinis)||0; if(n<0) n=0; if(n>2) n=2; return FOTO_IA_CUSTO*(1+n); }
  function _fiaCustoTxt(nMinis){
    var v=_fiaCusto(nMinis);
    return precoReal(v);
  }

  function _fotoIaMinisHtml(acao,url,galeria){
    var c=_FIA_CONF[acao]; if(!c||!c.minis) return '';
    var g=(Array.isArray(galeria)?galeria:[]).map(function(x){
      return (x&&typeof x==='object')?String(x.url||x.src||x.href||''):String(x||'');
    }).filter(function(x){ return x && x!==String(url||''); });
    if(!g.length) return '';
    var ehCarrossel=acao==='sl_carrossel';
    return '<div class="fotoia-minis" id="fotoiaMinis" data-max="2">'+
      '<div class="fotoia-minis-tp"><b>'+(ehCarrossel?'Slides do carrossel':'Miniaturas')+' <span class="fotoia-minis-op">(opcional)</span></b>'+
        '<span class="fotoia-minis-n" id="fotoiaMinisN">0 de 2</span></div>'+
      /* ⛳ v907 TROCOU o aviso da v877 ("Elas <b>não</b> passam pela IA —
         entram como estão, e não custam token"). Ele deixou de ser verdade no
         momento em que o Angelo pediu o contrário. Um aviso de preço errado é
         pior do que nenhum: ele ensina a pessoa a não ler os avisos. */
      '<p class="fotoia-minis-aj">'+(ehCarrossel?'A foto atual será a capa. Escolha até mais duas fotos para os slides 2 e 3.':'Escolha até duas fotos pra entrarem pequenas no pé da arte.')+' Cada uma <b>passa pela IA</b> como a foto grande e custa <b>'+precoReal(FOTO_IA_CUSTO)+'</b> — o preço total aparece no botão antes de você gerar.</p>'+
      '<div class="fotoia-minis-tira">'+
        g.slice(0,12).map(function(u){
          return '<button type="button" class="fotoia-mini" data-u="'+esc(u)+'" aria-pressed="false">'+
                 '<img loading="lazy" decoding="async" src="'+esc(u)+'" alt=""><i aria-hidden="true"></i></button>';
        }).join('')+
      '</div>'+
    '</div>';
  }

  function _fotoIaIco(t){
    if(t==='visualizar_foto') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
    if(t==='compartilhar_foto') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4"/></svg>';
    if(t==='fundo') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l5-5 4 4 3-3 6 6"/><path d="M3 5h18v14H3z"/><circle cx="16.5" cy="8.5" r="1.5"/></svg>';
    if(t==='privacidade') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
    if(t==='mev') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="10" rx="2"/><path d="M7 11h10M9 14h6"/></svg>';
    if(String(t||'').indexOf('sl_')===0) return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 7h8M8 11h5M8 17h8"/><path d="m15 14 1 1 2-2"/></svg>';
    if(t==='repasse_azul'||t==='divulgacao_garantia'||t==='divulgacao_garantia_post_clean'||t==='divulgacao_garantia_story_clean'||t==='repasse_post_clean'||t==='repasse_story_clean') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 7h8M8 11h5M8 17h8"/><path d="m15 14 1 1 2-2"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3z"/><path d="m18.5 13 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z"/><path d="M4 14v6M1 17h6"/></svg>';
  }

  function _fotoIaGaleriaUrls(url,galeria){
    var g=(Array.isArray(galeria)?galeria:[]).map(function(x){
      return (x&&typeof x==='object')?String(x.url||x.src||x.href||''):String(x||'');
    }).filter(Boolean);
    if(g.indexOf(String(url||''))<0) g.unshift(String(url||''));
    return g.filter(Boolean);
  }
  function _fotoIaVisualizarAtual(url,galeria,anchorEl){
    try{
      /* Se a folha nasceu dentro do visor, a foto já está aberta: fechar a
         folha é a ação inteira. Criar outro visor duplicaria Escape e foco. */
      if(anchorEl&&anchorEl.closest&&anchorEl.closest('.fotov')) return;
      var g=_fotoIaGaleriaUrls(url,galeria), i=Math.max(0,g.indexOf(String(url||'')));
      if(typeof fotosVerAbrir==='function') fotosVerAbrir(g,i,{editar:false,devolverFoco:anchorEl});
    }catch(_){ try{ toast('Não consegui visualizar esta foto.'); }catch(__){ } }
  }
  function _fotoIaNomeArquivo(dados,mime){
    var base=String((dados&&(dados.placa||dados.modelo))||'foto-mev');
    try{ base=base.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){ }
    base=base.replace(/[^a-z0-9]+/gi,'-').replace(/^-+|-+$/g,'').toLowerCase().slice(0,64)||'foto-mev';
    var ext=/png/i.test(mime||'')?'png':/webp/i.test(mime||'')?'webp':'jpg';
    return base+'-foto.'+ext;
  }
  async function _fotoIaCompartilharAtual(url,dados){
    if(_fotoIaCompartilhando) return;
    _fotoIaCompartilhando=true;
    try{
      try{ toast('Preparando foto…'); }catch(_){ }
      var r=await fetch(url,{credentials:'omit'});
      if(!r.ok) throw new Error('foto_indisponivel');
      var b=await r.blob();
      if(!b||!b.size||!/^image\//i.test(b.type||'')) throw new Error('arquivo_invalido');
      var nome=_fotoIaNomeArquivo(dados,b.type), f=new File([b],nome,{type:b.type||'image/jpeg'});
      if(navigator.share&&navigator.canShare&&navigator.canShare({files:[f]})){
        await navigator.share({files:[f],title:'Foto do veículo'});
        return;
      }
      var u=URL.createObjectURL(b),a=document.createElement('a');
      a.href=u;a.download=nome;document.body.appendChild(a);a.click();
      setTimeout(function(){try{URL.revokeObjectURL(u);a.remove();}catch(_){}},900);
      toast('O compartilhamento não está disponível neste aparelho. A foto foi baixada.');
    }catch(e){
      if(!(e&&e.name==='AbortError')) try{ toast('Não consegui preparar esta foto para compartilhar.'); }catch(_){ }
    }finally{ _fotoIaCompartilhando=false; }
  }

  function _fotoIaProgressoSvg(){
    return '<svg class="fotoia-progresso-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3.1-6.8"/></svg>';
  }
  function _fotoIaIdentidadeLoader(){
    var ed=''; try{ ed=(new URLSearchParams(location.search)).get('app')||''; }catch(_){ }
    if(ed==='avalia') return {src:'/mev-avaliacoes/icone.svg',alt:'MEV Avaliações'};
    if(ed==='consultas') return {src:'/mev-consultas/icone.svg',alt:'MEV Consultas'};
    return {src:'identidade/logo-mev-veiculos-loader-premium.svg',alt:'MEV Veículos'};
  }

  /* ======================================================================
     🔴 v867 — O MENU QUE NASCIA ATRÁS DA FOTO
     ----------------------------------------------------------------------
     O visualizador de foto em tela cheia (`.fotov`) vive em z-index 100000.
     O menu reutilizável da casa (`.act-bg`) vive em 200. Tocar "Editar com
     IA" DENTRO do visualizador criava o menu certo, com os itens certos — e
     ele aparecia ATRÁS da foto. Pra quem usa, o botão simplesmente não fazia
     nada.

     ⚠️ A CORREÇÃO NÃO É SUBIR O `.act-bg` DE TODO MUNDO. Esse menu é o mesmo
     do histórico, do estoque, do repasse e das avaliações; subir a camada
     global resolveria aqui e criaria menu por cima de coisa que deveria
     cobri-lo em outros cinco lugares. Sobe SÓ ESTA ABERTURA, por uma classe
     que só é posta quando o botão está mesmo dentro do visualizador.

     As três camadas, na ordem:
        .fotov ................... 100000   (a foto em tela cheia)
        .act-bg--sobre-foto ...... 100200   (o menu, só neste caso)
        .fotoia .................. 100300   (o modal da edição)
     ====================================================================== */
  function _fotoIaFocoVolta(el){ try{ if(el&&el.focus) el.focus(); }catch(_){ } }
  /* v877 — `galeria` é o 6º parâmetro, e é OPCIONAL de propósito: quem chamava
     com cinco continua funcionando, só não oferece montagem. */
  function fotoIaEditarUrl(url,contexto,aoUsar,anchorEl,dadosRepasse,galeria){
    if(_fotoIaEmCurso){ toast('Aguarde a edição que já está em andamento.'); return; }
    if(!url || typeof aoUsar!=='function') return;
    var head='<div class="act-head"><div class="ah-nm">Ações da foto</div></div>';
    var chaves=['estoque_padrao','mev'];
    /* Linha 0 km é cadastro: o menu mantém apenas as ações gratuitas da
       foto. Enquadramento e ordem continuam nos controles da própria grade. */
    if(contexto==='zero_km') chaves=[];
    if(contexto!=='zero_km'&&dadosRepasse&&typeof dadosRepasse==='object'){
      /* 🔴 03/09 (pedido do Angelo): "nas fotos da avaliação, permita também
         fazer as mesmas coisas que no menu das fotos do estoque".
         A trava era `contexto==='estoque'`, e o motivo escrito na v866 era
         "fora dele não existe preço de anúncio nem km cadastrada, e a arte
         sairia com buraco no lugar do dado".

         ✅ POR QUE DÁ PRA TIRAR AGORA: o buraco não acontece, e quem impede
         é o próprio código destas artes.
           · o VALOR é o único campo que não some quando falta — o
             `_fotoIaValorConf` escreve "CONSULTE O VALOR" na arte (e é o
             comportamento certo pra avaliação com preço oculto);
           · a CATEGORIA sem dado cai em "Seminovo";
           · veículo, ano e km a avaliação JÁ mandava — são os mesmos campos
             que a arte de repasse (`repasse_azul`) usa, e ela já aparecia
             ali desde sempre.

         ⚠️ A CONDIÇÃO PASSOU A SER O DADO, NÃO O NOME DA TELA. Amanhã uma
         terceira tela (o portal de repasse, a proposta) manda `dadosRepasse`
         e ganha as três artes sem ninguém precisar lembrar de acrescentar o
         nome dela numa lista. Trava por nome de contexto envelhece calada. */
      chaves.push('repasse_post_clean');    /* v871 */
      chaves.push('repasse_story_clean');   /* v875 */
      chaves.push('divulgacao_garantia_post_clean');
      chaves.push('divulgacao_garantia_story_clean');
    }
    /* v1108 — peças Santa Luzia aparecem somente no menu das fotos do Estoque.
       A lista mora no módulo 13f para manter identidade, campos e composição
       isolados das receitas gerais do MEV. */
    if(contexto==='estoque' && typeof santaLuziaAcoesChaves==='function'){
      try{ chaves=chaves.concat(santaLuziaAcoesChaves()); }catch(_){ }
    }
    var itens=[
      ['visualizar_foto',_fotoIaIco('visualizar_foto'),'Visualizar',''],
      ['compartilhar_foto',_fotoIaIco('compartilhar_foto'),'Compartilhar','']
    ].concat(chaves.map(function(k){
      var x=_fotoIaReceitas[k];
      return [k,_fotoIaIco(k),x.titulo,x.sub,
        k==='estoque_padrao'?'Editar com IA · R$ 2,85 por resultado':
        k==='sl_entrega_story'?'Conteúdo Santa Luzia':''];
    }));
    /* v867 — só sobe a camada quando o botão está DENTRO do visualizador */
    var _sobreFoto=false;
    try{ _sobreFoto=!!(anchorEl&&anchorEl.closest&&anchorEl.closest('.fotov')); }catch(_){ }
    var _escMenu=null;
    function _fechaMenu(devolveFoco){
      if(_escMenu){ try{ document.removeEventListener('keydown',_escMenu,true); }catch(_){ } _escMenu=null; }
      actSheetFechar();
      if(devolveFoco) _fotoIaFocoVolta(anchorEl);
    }
    _popAbrir(head,itens,anchorEl,function(k){
      /* escolheu uma opção: o modal assume e põe o foco no botão de gerar —
         devolver o foco pro visualizador aqui seria roubar o foco do modal. */
      _fechaMenu(false);
      if(k==='visualizar_foto'){ _fotoIaVisualizarAtual(url,galeria,anchorEl); return; }
      if(k==='compartilhar_foto'){ _fotoIaCompartilharAtual(url,dadosRepasse); return; }
      if(_fotoIaReceitas[k]) _fotoIaAbrir(url,contexto||'',k,aoUsar,dadosRepasse,galeria);
    });
    if(_sobreFoto){
      var _bg=document.getElementById('actSheet');
      if(_bg){
        _bg.classList.add('act-bg--sobre-foto');
        _bg.addEventListener('click',function(e){ if(e.target===_bg) _fechaMenu(true); });
      }
      /* 🔴 O ESCAPE PRECISA SER PEGO NA CAPTURA. O visualizador tem o
         PRÓPRIO ouvinte de Escape no document, e ele FECHA A FOTO INTEIRA.
         Sem isso, apertar Esc pra dispensar o menu levava o visualizador
         junto — o oposto do que a pessoa pediu. Na fase de captura este
         ouvinte roda primeiro e corta a propagação. */
      _escMenu=function(e){
        if(e.key!=='Escape') return;
        if(!document.getElementById('actSheet')){ _fechaMenu(false); return; }
        e.stopPropagation(); e.preventDefault();
        _fechaMenu(true);
      };
      document.addEventListener('keydown',_escMenu,true);
    }
  }

  function _fotoIaAbrir(url,contexto,acao,aoUsar,dadosRepasse,galeria){
    var rec=_fotoIaReceitas[acao]; if(!rec) return;
    /* v866 — 'post' | 'story' | '' */
    var fiaFmt=_fotoIaFormatoClean(acao), ehClean=!!fiaFmt;
    var ehDivulgacao=acao==='repasse_azul'||acao==='divulgacao_garantia'||ehClean;   /* ehClean já cobre o post de repasse da v871 */
    var ehEstoque=acao==='estoque_padrao';   /* v862 */
    /* v868: `ehGarantia` saiu — a garantia deixou de ter tratamento próprio
       na tela; ela é só mais uma linha da configuração `_FIA_CONF`. */
    /* 🔴 v875 — ERA `fiaFmt==='story'`, E ISSO IA QUEBRAR CALADO.
       O layout tem QUATRO chaves ('post', 'story', 'post_repasse' e
       'story_repasse') e a tela só quer saber de duas: é post ou é story?
       A comparação direta acertava por acaso no `post_repasse` (cai no
       "senão", que é 'post') e ERRARIA no `story_repasse`: o botão diria
       "Baixar post" num story, e o aviso diria "Post 1:1" numa arte 9:16.
       Uma pergunta, uma função, um lugar. */
    var fiaRotulo=_fotoIaFamiliaClean(fiaFmt);
    /* v868 — o rótulo do botão vem da MESMA configuração que monta o quadro,
       pra ação e custo baterem com o que está escrito logo acima dele. */
    var fiaBotao=(_FIA_CONF[acao]&&_FIA_CONF[acao].botao)||'Gerar versão';
    var ov=document.createElement('div'); ov.className='fotoia'; ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-labelledby','fotoiaTitulo');
    ov.innerHTML='<div class="fotoia-card">'+
      '<div class="fotoia-head"><div><span class="fotoia-kicker">Edição por IA</span><h2 id="fotoiaTitulo">'+esc(rec.titulo)+'</h2><p>'+esc(rec.sub)+'</p></div><button type="button" class="fotoia-x" aria-label="Fechar">&times;</button></div>'+
      '<div class="fotoia-grid">'+
        '<figure id="fotoiaOrig"><figcaption>Original</figcaption><div class="fotoia-img"><img src="'+esc(url)+'" alt="Foto original do veículo"></div></figure>'+
        '<figure class="fotoia-result"><figcaption>Resultado</figcaption><div class="fotoia-img" id="fotoiaResultado">'+(ehEstoque?'<div class="fotoia-vazio">A versão convertida aparecerá aqui.</div>':'<div class="fotoia-vazio">A versão editada aparecerá aqui.</div>')+'</div></figure>'+
      '</div>'+
      '<div class="fotoia-estado" id="fotoiaEstado" aria-live="polite"></div>'+
      /* 🔴 v866 → v868 — a conferência ANTES da cobrança, agora pra TODAS as
         receitas. A pessoa precisa ver a operação, o formato, os dados e o
         valor que vão pra arte antes de autorizar; sem isso ela descobre o
         erro depois de pagar. Era só do post/story; passou a ser de todas.
         ⚠️ E o preço aparece UMA VEZ SÓ: o quadro `.fotoia-preco` que a v857
         mostrava em paralelo saiu daqui — dois lugares dizendo o mesmo
         número é onde nasce a divergência. */
      _fotoIaMinisHtml(acao,url,galeria)+   /* v877 */
      _fotoIaConfHtml(acao,dadosRepasse)+
      '<div class="fotoia-acoes"><button type="button" class="cad-btn sec" id="fotoiaCancelar">Cancelar</button><button type="button" class="cad-btn" id="fotoiaGerar" data-rotulo="'+esc(fiaBotao)+'">'+esc(fiaBotao)+' · '+precoReal(FOTO_IA_CUSTO)+'</button><button type="button" class="cad-btn" id="fotoiaUsar" hidden>'+(ehClean?(acao==='sl_carrossel'?'Baixar carrossel':('Baixar '+fiaRotulo)):ehDivulgacao?'Baixar divulgação':'Usar esta foto')+'</button>'+
        /* 🔴 v892 — OS DOIS DESTINOS (pedido do Angelo, 04/09).
           "Salvar na galeria" põe a arte no ACERVO do veículo — ela passa a
           descrever o carro no link, no catálogo e na capa do card.
           "Salvar no marketing" guarda numa galeria separada, abaixo do vídeo,
           que NÃO entra no acervo: fica pra baixar e compartilhar.
           ⚠️ Só nas artes (`ehDivulgacao`): nas receitas que consertam uma
           foto o botão de sempre já faz a coisa certa, que é SUBSTITUIR. */
        (ehDivulgacao?('<button type="button" class="cad-btn sec" id="fotoiaGaleria" hidden>Salvar na galeria</button>'+
                       '<button type="button" class="cad-btn sec" id="fotoiaMkt" hidden>Salvar no marketing</button>'):'')+
        /* v866 (§12) — a Galeria de Marketing ainda não existe. Em vez de
           sumir com a ação principal do projeto, ela aparece DESABILITADA e
           dizendo por quê. Baixar e compartilhar continuam de graça. */
        /* 🔴 v878 — "SALVAR EM MARKETING" SAIU (pedido do Angelo: "não sei se
           tá funcionando"). E a resposta é: não funcionava, de propósito. Ele
           nasceu DESLIGADO na v866, porque a Galeria de Marketing não existe
           neste app; a explicação estava só no `title`, que no celular ninguém
           lê. Um botão que não faz nada não é "quase pronto" — é uma pergunta
           que o app faz e não responde, toda vez.
           ⛳ PRA VOLTAR no dia em que a Galeria existir: o rótulo era
           "Salvar em Marketing" e o lugar é este, ao lado do Baixar. */
        ''+
      '</div>'+
    '</div>';
    document.body.appendChild(ov);
    var resultadoBlob=null, resultadoUrl='', loaderTimer=null, cancelado=false;
    function loaderParar(){ if(loaderTimer){ clearInterval(loaderTimer); loaderTimer=null; } }
    /* ======================================================================
       🔴 v867 — A ESPERA VIRA A PRÓPRIA FOTO SE MONTANDO
       ----------------------------------------------------------------------
       Antes a espera mostrava o logo MEV e um texto. Agora ela mostra A FOTO
       QUE A PESSOA ESCOLHEU, partida em seis peças que se encaixam.

       Por que isso é melhor e não só mais bonito: a pessoa VÊ que o app está
       trabalhando NA FOTO DELA — não numa animação genérica que poderia estar
       rodando com o pedido errado. É a mesma URL da coluna "Original", ao
       lado. Nada é copiado, enviado ou pedido de novo: é a imagem que o
       navegador já tem em cache, usada seis vezes com recortes diferentes.

       ⚠️ E CONTINUA SEM PORCENTAGEM, de propósito. A API não devolve
       progresso real; qualquer barra aqui seria número inventado. O ciclo é
       indeterminado e diz "estou trabalhando", não "estou em 62%".

       ⚠️ ESTA É A EXCEÇÃO CONSCIENTE AO PADRÃO "PREMIUM LEVE" DA v745 (nada
       infinito, nada acima de 300 ms). Ela vale para ESTADO DE ESPERA, que é
       onde o movimento contínuo é a própria informação — o relógio que já
       girava aqui desde a v865 é do mesmo tipo. Fora de estado de espera, a
       regra da v745 continua valendo inteira.
       ====================================================================== */
    /* a URL vai parar dentro de um url() do CSS. Aspas, parênteses e barra
       invertida quebrariam a declaração — e um nome de arquivo pode ter
       qualquer coisa. Quem não passar por aqui simplesmente não vira peça. */
    function _fotoIaUrlCss(u){
      u=String(u||'');
      if(!/^(https?:|blob:|data:image\/)/i.test(u)) return '';
      try{ u=encodeURI(u); }catch(_){ return ''; }
      /* o encodeURI não toca em ( ) ' " — e essas quatro são justamente as
         que quebram o url(). Vão codificadas na unha. */
      u=u.replace(/\(/g,'%28').replace(/\)/g,'%29').replace(/'/g,'%27').replace(/"/g,'%22');
      return /["'()\\\s]/.test(u) ? '' : u;
    }
    function loaderIniciar(){
      var alvo=ov.querySelector('#fotoiaResultado'); if(!alvo) return;
      var idLoader=_fotoIaIdentidadeLoader();
      alvo.innerHTML='<div class="fotoia-loader" role="status" aria-label="Preparando sua foto">'+
        '<img src="'+esc(idLoader.src)+'" alt="'+esc(idLoader.alt)+'">'+
        '<div class="fotoia-puzzle" id="fotoiaPuzzle" role="img" aria-label="Foto do veículo sendo preparada">'+
          '<span class="fotoia-brilho" aria-hidden="true"></span>'+
        '</div>'+
        '<b>Preparando sua foto</b><span id="fotoiaLoaderMsg" aria-live="polite">Analisando a imagem…</span><small>Edição protegida</small></div>';
      /* as seis peças nascem pelo DOM, não por innerHTML: a URL entra por
         `style.backgroundImage` já peneirada, e nunca vira texto de HTML. */
      var palco=alvo.querySelector('#fotoiaPuzzle'), fundo=_fotoIaUrlCss(url);
      if(palco){
        for(var p=1;p<=6;p++){
          var pc=document.createElement('i');
          pc.className='fotoia-peca p'+p;
          pc.setAttribute('aria-hidden','true');   /* o rótulo é do conjunto */
          if(fundo) pc.style.backgroundImage='url("'+fundo+'")';
          palco.insertBefore(pc,palco.firstChild);
        }
        if(!fundo) palco.classList.add('sem-foto');
      }
      var frases=['Preservando o veículo…','Limpando o cenário…','Aplicando o padrão MEV…','Analisando a imagem…'],i=0;
      var reduz=false; try{ reduz=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(_){ }
      if(!reduz) loaderTimer=setInterval(function(){ var m=ov.querySelector('#fotoiaLoaderMsg'); if(!m){loaderParar();return;} m.textContent=frases[i++%frases.length]; },1400);
    }
    var fechar=function(forcar){
      if(_fotoIaEmCurso&&!forcar){ toast('A edição ainda está sendo gerada. Aguarde um instante.'); return; }
      if(forcar&&_fotoIaEmCurso) cancelado=true;
      loaderParar();
      try{ if(resultadoUrl) URL.revokeObjectURL(resultadoUrl); }catch(_){ }
      try{ ov.remove(); }catch(_){ }
      try{ document.removeEventListener('keydown',tecla); }catch(_){ }
    };
    var tecla=function(e){ if(e.key==='Escape') fechar(); };
    document.addEventListener('keydown',tecla);
    ov.querySelector('.fotoia-x').onclick=fechar;
    ov.querySelector('#fotoiaCancelar').onclick=function(){ fechar(true); };
    ov.onclick=function(e){ if(e.target===ov) fechar(); };

    /* ======================================================================
       🔴 v876 — O DADO QUE VALE É O QUE ESTÁ NA TELA
       ----------------------------------------------------------------------
       `_fiaDados` é a ÚNICA fonte a partir daqui: ele lê as caixas de edição
       quando elas existem, e devolve o pacote do cadastro quando não.
       ⚠️ E ele é lido NA HORA de usar, não guardado numa variável no começo:
       a pessoa pode abrir o "Editar", digitar e só então tocar em Gerar. Uma
       cópia tirada cedo demais desenharia o nome velho — o defeito exato que
       este pedido veio consertar. */
    function _fiaMinisEscolhidas(){
      var out=[];
      try{
        Array.prototype.forEach.call(ov.querySelectorAll('.fotoia-mini.on'),function(b){
          var u=b.getAttribute('data-u'); if(u) out.push(u);
        });
      }catch(_){ }
      return out.slice(0,2);
    }
    function _fiaDados(){
      var d;
      try{ d=_fiaTemEdicao(acao) ? _fotoIaConfLer(acao,dadosRepasse) : dadosRepasse; }
      catch(_){ d=dadosRepasse; }
      /* v877 — as miniaturas entram por cima, sem tocar no cadastro.
         ⚠️ Uma CÓPIA, sempre: pendurar `minis` no objeto que veio da tela do
         estoque deixaria a escolha grudada nele depois que este modal fechar. */
      try{
        var mn=_fiaMinisEscolhidas();
        if(mn.length){ var c={}; for(var k in (d||{})) if(Object.prototype.hasOwnProperty.call(d,k)) c[k]=d[k]; c.minis=mn; return c; }
      }catch(_){ }
      return d;
    }
    /* a tira: toca pra escolher, toca de novo pra tirar. O teto de dois é
       cobrado AQUI e outra vez no desenho — duas travas, porque esta é de
       tela e a outra é da arte, e elas podem divergir no futuro. */
    (function(){
      var cx=ov.querySelector('#fotoiaMinis'); if(!cx) return;
      var conta=ov.querySelector('#fotoiaMinisN');
      Array.prototype.forEach.call(cx.querySelectorAll('.fotoia-mini'),function(b){
        b.onclick=function(){
          var lig=b.classList.contains('on');
          if(!lig && cx.querySelectorAll('.fotoia-mini.on').length>=2){
            try{ toast('Duas miniaturas é o máximo que cabe na arte.'); }catch(_){ }
            return;
          }
          b.classList.toggle('on',!lig);
          b.setAttribute('aria-pressed', (!lig)?'true':'false');
          var n=cx.querySelectorAll('.fotoia-mini.on').length;
          if(conta) conta.textContent=n+' de 2';
          _fiaPintaCusto();   /* v907 — o preço acompanha a escolha */
        };
      });
    })();
    var _edtBt=ov.querySelector('#fotoiaEditar'), _edtBox=ov.querySelector('#fotoiaEdita');
    if(_edtBt&&_edtBox){
      _edtBt.onclick=function(){
        /* v736: quem manda no escondido é o `hidden`, não uma classe — foi a
           lição da v736, e ela vale pra qualquer caixa que abre e fecha. */
        var abrindo=_edtBox.hidden;
        _edtBox.hidden=!abrindo;
        _edtBt.setAttribute('aria-expanded', abrindo?'true':'false');
        _edtBt.textContent= abrindo ? 'Pronto' : 'Editar';
        var dl=ov.querySelector('#fotoiaConfDl');
        if(dl) dl.hidden=abrindo;
        if(!abrindo){
          /* fechou: o quadro volta a mostrar o que a arte VAI desenhar */
          try{
            var novo=_fotoIaConfLinhas(acao,_fiaDados());
            if(dl&&novo.length) dl.innerHTML=novo.map(function(l){
              return '<div><dt>'+esc(l[0])+'</dt><dd>'+esc(l[1])+'</dd></div>'; }).join('');
          }catch(_){ }
        }else{
          try{ var p1=_edtBox.querySelector('input'); if(p1) p1.focus(); }catch(_){ }
        }
      };
    }
    /* O preço fica no botão/na confirmação ANTES da cobrança; a tela de
       processamento não repete custo nem regra financeira. */
    function _fiaPintaCusto(){
      try{
        var n=_fiaMinisEscolhidas().length, tx=_fiaCustoTxt(n);
        var g=ov.querySelector('#fotoiaGerar');
        if(g && !g.disabled) g.textContent=(g.getAttribute('data-rotulo')||'Gerar')+' · '+tx;
      }catch(_){ }
    }
    /* ==========================================================================
       🔴 v907 — A MINIATURA PASSA PELA IA (pedido do Angelo, 05/09: "Faça com
       que a IA trabalhe também as foto das miniatura, as imagens. não só a
       imagem principal")
       --------------------------------------------------------------------------
       ⚠️ TRÊS REGRAS DE DINHEIRO MORAM AQUI, e nenhuma é enfeite:

       1) O QUE JÁ FOI PAGO NÃO SE PAGA DE NOVO. `_minisPagas` guarda o
          resultado por URL. Se a foto grande falhar e a pessoa tocar em
          "Tentar novamente", as miniaturas que já voltaram NÃO são
          reenviadas — seria cobrar duas vezes pelo mesmo trabalho.

       2) MINIATURA QUE FALHA NÃO DERRUBA A ARTE. Ela volta a ser a foto crua
          do estoque e a arte sai. Jogar fora a foto grande (já paga) porque
          uma auxiliar não voltou é o erro que a v866 já nomeou.

       3) TUDO AO MESMO TEMPO. Três chamadas em fila levariam o triplo do
          tempo pelo mesmo preço. Em paralelo, a espera é a da mais lenta. */
    var _minisPagas={};
    async function _fiaTratarMini(u){
      if(_minisPagas[u]) return {url:u,out:_minisPagas[u],jaPaga:true};
      try{
        var im=await _fotoIaPreparar(u);
        if(cancelado) return {url:u,out:null};
        var d=await apiComTimeout('/api/editar-foto-ia',{
          imagemBase64:im.base64, mimeType:'image/jpeg',
          largura:im.largura, altura:im.altura, acao:'mini_auxiliar'
        },30000);
        /* o `_fotoIaEsperar` escreve em `estado.textContent` sem conferir se
           ele existe. A miniatura não tem letreiro próprio — quem fala com a
           pessoa é o da foto grande — então entra um alvo mudo, não um null. */
        if(d&&d.ok&&d.processando&&d.jobId) d=await _fotoIaEsperar(d.jobId,{},function(){return cancelado;});
        if(d&&d.saldo!=null) try{ setSaldo(Number(d.saldo)); }catch(_){ }
        if(cancelado||!d||!d.ok||!d.imagemBase64) return {url:u,out:null};
        var b=_fotoIaBlob(d.imagemBase64,d.mimeType||'image/jpeg');
        if(!b||!b.size) return {url:u,out:null};
        var bu=URL.createObjectURL(b);
        _minisPagas[u]=bu;
        return {url:u,out:bu};
      }catch(_){ return {url:u,out:null}; }
    }
    var gerar=ov.querySelector('#fotoiaGerar'), usar=ov.querySelector('#fotoiaUsar');

    /* ==========================================================================
       🔴 v878 — A TELA LIMPA (pedido do Angelo, 04/09: "depois de colocar pra
       gerar, oculta tudo da tela e fica a animação, gerando, depois a foto
       gerada com a opção de salvar, tela limpa")
       --------------------------------------------------------------------------
       Até aqui a tela mostrava TUDO o tempo todo: original, resultado, o quadro
       de conferência, a tira de miniaturas, a caixa de custo. Enquanto a IA
       trabalha, nada disso serve pra nada — a decisão já foi tomada e o dinheiro
       já vai sair. E depois de pronta, o quadro "confira ANTES de gerar" fica
       mentindo, porque já foi gerado.

       Três estados, um lugar só que decide:
         · escolher  — tudo à mostra: é a hora de conferir e editar
         · gerando   — só a animação (que já é a foto dele se montando)
         · pronto    — só o resultado e o que fazer com ele

       ⚠️ O "CANCELAR" FICA VISÍVEL DURANTE O "GERANDO", de propósito. Tela
       limpa não pode virar tela sem saída: uma espera de minutos sem porta é
       pior que um botão a mais.
       ⚠️ E TUDO POR `hidden`, NUNCA por classe de display — é a lição da v736,
       e ela vale pra qualquer caixa que abre e fecha neste app. */
    function _fiaTela(modo){
      var esconde=(modo!=='escolher');
      ['#fotoiaOrig','#fotoiaMinis'].forEach(function(sel){
        var el=ov.querySelector(sel); if(el) el.hidden=esconde;
      });
      var cf=ov.querySelector('.fotoia-confere'); if(cf) cf.hidden=esconde;
      try{ ov.querySelector('.fotoia-card').classList.toggle('fotoia-so-result',esconde); }catch(_){ }
    }

    gerar.onclick=async function(){
      if(_fotoIaEmCurso) return;
      /* Receitas adicionais podem exigir uma escolha comercial explícita
         antes da cobrança. A validação recebe só os dados já visíveis e o
         próprio modal; nunca altera cadastro nem envia conteúdo ao servidor. */
      if(typeof _fotoIaValidarReceita==='function' && !_fotoIaValidarReceita(acao,_fiaDados(),ov)) return;
      _fotoIaEmCurso=true;
      gerar.disabled=true; ov.querySelector('.fotoia-x').disabled=true;
      gerar.innerHTML=_fotoIaProgressoSvg()+'<span>'+(ehClean?(acao==='sl_carrossel'?'Criando o carrossel…':('Criando o '+fiaRotulo+'…')):ehEstoque?'Convertendo…':'Editando a foto…')+'</span>';
      var estado=ov.querySelector('#fotoiaEstado');
      estado.className='fotoia-estado';
      estado.textContent='';
      _fiaTela('gerando');   /* v878 */
      loaderIniciar();
      try{
        /* v907 — as miniaturas saem JUNTO com a foto grande. A escolha é
           congelada aqui: a tira já sumiu da tela (`_fiaTela('gerando')`),
           então ninguém muda a conta no meio do caminho. */
        var _mnAlvo=_fiaMinisEscolhidas();
        var _pMinis=_mnAlvo.map(function(u){ return _fiaTratarMini(u); });
        var img=await _fotoIaPreparar(url);
        if(cancelado) return;
        var d=await apiComTimeout('/api/editar-foto-ia',{
          imagemBase64:img.base64, mimeType:'image/jpeg', largura:img.largura, altura:img.altura, acao:acao,
          dados:ehDivulgacao?(_fiaDados()||{}):undefined
        },30000);
        if(d&&d.ok&&d.processando&&d.jobId) d=await _fotoIaEsperar(d.jobId,estado,function(){return cancelado;});
        if(cancelado) return;
        if(d&&d.saldo!=null) try{ setSaldo(Number(d.saldo)); }catch(_){ }
        if(!d || !d.ok || !d.imagemBase64){
          estado.className='fotoia-estado erro';
          estado.textContent=(d&&d.erro)||'Não consegui editar a foto agora.';
          ov.querySelector('#fotoiaResultado').innerHTML='<div class="fotoia-vazio">Nenhuma alteração foi aplicada à foto original.</div>';
          /* v878 — falhou: a tela VOLTA a mostrar tudo. Repetir sem poder
             conferir de novo seria pedir o mesmo token no escuro. */
          _fiaTela('escolher');
          /* ⛳ v907 TROCOU o texto fixo 'Tentar novamente · 1,5 token'. Com
             miniatura o preço não é 1,5 — e o de agora é MENOR que o da
             primeira vez, porque a miniatura que já voltou não se paga de
             novo. Dizer 1,5 aqui seria cobrar confiança à toa. */
          gerar.disabled=false;
          try{
            var _mnFalta=_mnAlvo.filter(function(u){ return !_minisPagas[u]; }).length;
            gerar.textContent='Tentar novamente · '+_fiaCustoTxt(_mnFalta);
          }catch(_){ gerar.textContent='Tentar novamente'; }
          return;
        }
        resultadoBlob=_fotoIaBlob(d.imagemBase64,d.mimeType||'image/jpeg');
        if(!resultadoBlob) throw new Error('resultado inválido');
        /* 🔴 v866 — A COMPOSIÇÃO LOCAL. Daqui pra frente a imagem JÁ FOI PAGA.
           Se escrever o texto falhar, entregamos a foto crua com um aviso —
           jogar fora 1,5 token porque um logo não carregou seria pior. */
        /* 🔴 v907 — ESPERAR AS MINIATURAS AQUI, E NÃO DENTRO DO `if(ehClean)`.
           Hoje as duas receitas com miniatura são clean, então dava no mesmo.
           Mas uma receita nova com miniatura que não fosse clean pularia a
           espera, e as chamadas já pagas seriam jogadas fora em silêncio —
           dinheiro saindo sem nada aparecer na tela. A espera é de quem
           pagou, não do formato. */
        var _mnMapa={}, _mnPerdidas=0;
        if(_pMinis.length){
          estado.textContent='Tratando as miniaturas com a IA…';
          var _mnRes=await Promise.all(_pMinis);
          if(cancelado) return;
          _mnRes.forEach(function(r){ if(r&&r.out) _mnMapa[r.url]=r.out; else _mnPerdidas++; });
        }
        /* a cópia: mexer no objeto de `_fiaDados()` grudaria uma blob: URL
           temporária no pacote que veio da tela do estoque. */
        function _fiaDadosComMinis(mapa){
          var d=_fiaDados();
          if(!d||!Array.isArray(d.minis)||!mapa) return d;
          var c={}; for(var k in d) if(Object.prototype.hasOwnProperty.call(d,k)) c[k]=d[k];
          c.minis=d.minis.map(function(u){ return mapa[u]||u; });
          return c;
        }
        var fiaAviso='';
        if(_mnPerdidas) fiaAviso+=' '+_mnPerdidas+(_mnPerdidas===1?' miniatura não voltou da IA e entrou como está.':' miniaturas não voltaram da IA e entraram como estão.');
        if(ehClean){
          estado.textContent='Escrevendo o preço e os dados na arte…';
          try{
            var fiaPronto=await _fotoIaCompor(resultadoBlob,fiaFmt,_fiaDadosComMinis(_mnMapa));
            if(fiaPronto&&fiaPronto.size) resultadoBlob=fiaPronto;
            else fiaAviso=' A foto saiu, mas não consegui escrever os textos nela.';
          }catch(_){ fiaAviso=' A foto saiu, mas não consegui escrever os textos nela.'; }
        }else if(ehEstoque){
          estado.textContent='Finalizando o post quadrado…';
          try{ resultadoBlob=await _fotoIaPostQuadrado(resultadoBlob); }
          catch(_){ throw new Error('Não consegui finalizar o post quadrado.'); }
        }
        loaderParar();
        if(resultadoUrl) try{ URL.revokeObjectURL(resultadoUrl); }catch(_){ }
        resultadoUrl=URL.createObjectURL(resultadoBlob);
        ov.querySelector('#fotoiaResultado').innerHTML='<img src="'+esc(resultadoUrl)+'" alt="Resultado da edição por IA">';
        estado.className='fotoia-estado ok';
        if(fiaAviso) estado.className='fotoia-estado';
        estado.textContent=ehClean
          ? ((acao==='sl_carrossel'?'Carrossel':(_fotoIaFamiliaClean(fiaFmt)==='story'?'Story 9:16':(/^post45|^post_(entrega|cnpj|condicao)/.test(fiaFmt)?'Post 4:5':'Post 1:1')))+' pronto. Confira os dados e a escrita antes de baixar ou compartilhar.'+fiaAviso)
          : ehDivulgacao
          ? 'Divulgação 9:16 pronta. Confira os dados antes de baixar ou compartilhar.'
          : (ehEstoque ? 'Foto pronta. Compare com a original antes de substituir.'
                        : 'Resultado pronto. Compare com a original antes de substituir.');
        _fiaTela('pronto');   /* v878 */
        gerar.hidden=true; usar.hidden=false;
        /* v892 — os dois destinos aparecem junto com o Baixar, e SÓ quando a
           tela que abriu a IA sabe guardar. Sem isso o botão existiria
           prometendo um lugar que não existe naquele contexto. */
        try{
          var _bg=ov.querySelector('#fotoiaGaleria'), _bm=ov.querySelector('#fotoiaMkt');
          var _pode=acao!=='sl_carrossel'&&(typeof window.avmGuardar==='function' && typeof window.avmParaAcervo==='function');
          if(_bg) _bg.hidden=!_pode;
          if(_bm) _bm.hidden=!_pode;
        }catch(_){ }
        ov.querySelector('#fotoiaCancelar').textContent='Descartar';
      }catch(e){
        if(cancelado) return;
        loaderParar();
        estado.className='fotoia-estado erro';
        estado.textContent='Não consegui preparar a edição. A foto original continua intacta.';
        ov.querySelector('#fotoiaResultado').innerHTML='<div class="fotoia-vazio">Nenhuma alteração foi aplicada.</div>';
        _fiaTela('escolher');   /* v878 */
        /* ⛳ v907 TROCOU 'Tentar novamente · 1,5 token' aqui também: a
           miniatura que já voltou não entra na conta da segunda tentativa. */
        gerar.disabled=false;
        try{
          var _mnF=(_mnAlvo||[]).filter(function(u){ return !_minisPagas[u]; }).length;
          gerar.textContent='Tentar novamente · '+_fiaCustoTxt(_mnF);
        }catch(_){ gerar.textContent='Tentar novamente'; }
      }finally{
        _fotoIaEmCurso=false; var _x=ov.querySelector('.fotoia-x'); if(_x) _x.disabled=false;
      }
    };
    usar.onclick=async function(){
      if(!resultadoBlob || _fotoIaEmCurso) return;
      if(ehDivulgacao){
        _fotoIaEmCurso=true; usar.disabled=true;
        try{ await _fotoIaBaixarOuCompartilhar(resultadoBlob,_fiaDados(),acao); }
        finally{ _fotoIaEmCurso=false; if(usar&&usar.isConnected) usar.disabled=false; }
        return;
      }
      _fotoIaEmCurso=true; usar.disabled=true; usar.innerHTML='<span class="spin"></span> Salvando…';
      try{
        var ok=await aoUsar(resultadoBlob,{acao:acao,custo:FOTO_IA_CUSTO,contexto:contexto});
        if(ok!==false){ _fotoIaEmCurso=false; fechar(); toast('Foto editada com IA e salva ✓'); return; }
        throw new Error('não salvou');
      }catch(e){
        var estado=ov.querySelector('#fotoiaEstado'); estado.className='fotoia-estado erro';
        estado.textContent='A edição ficou pronta, mas não consegui substituir a foto. Tente salvar novamente.';
      }finally{ _fotoIaEmCurso=false; if(usar&&usar.isConnected){ usar.disabled=false; usar.textContent='Usar esta foto'; } }
    };
    /* v892 — os dois destinos. Cada um sabe fazer UMA coisa e diz qual. */
    function _fiaGuardar(bt, quem, msg){
      if(!bt) return;
      bt.onclick=async function(){
        if(!resultadoBlob || _fotoIaEmCurso) return;
        _fotoIaEmCurso=true; bt.disabled=true;
        var _txt=bt.textContent;
        bt.innerHTML='<span class="spin"></span> Salvando…';
        try{
          await quem(resultadoBlob, _fotoIaFamiliaClean(_fotoIaFormatoClean(acao))==='story'?'story':'post');
          try{ toast(msg); }catch(_){ }
        }catch(e){
          try{ toast('Não consegui salvar agora. A arte continua aqui.'); }catch(_){ }
        }finally{
          _fotoIaEmCurso=false;
          if(bt&&bt.isConnected){ bt.disabled=false; bt.textContent=_txt; }
        }
      };
    }
    _fiaGuardar(ov.querySelector('#fotoiaGaleria'),
      function(b){ return window.avmParaAcervo(b); },
      'Arte salva nas fotos do veículo ✓');
    _fiaGuardar(ov.querySelector('#fotoiaMkt'),
      function(b,f){ return window.avmGuardar(b,f); },
      'Arte salva na galeria de marketing ✓');
    setTimeout(function(){ try{ gerar.focus(); }catch(_){ } },40);
  }

  /* ======================================================================
     🔴 v866 — POST E STORY CLEAN COM GARANTIA (projeto de 03/09)
     ----------------------------------------------------------------------
     A DECISÃO QUE MUDA O DESENHO INTEIRO está na seção 9 do projeto:
     A IA NÃO ESCREVE NADA. Ela devolve só a FOTOGRAFIA — carro preservado,
     cenário limpo, placa com o símbolo AF — e o modelo, o ano, a km, o preço,
     o selo "COM GARANTIA" e o CTA são desenhados AQUI, no Canvas do aparelho.

     Três motivos, e nenhum é estético:
       · modelo de imagem ERRA DÍGITO. "R$ 122.900,00" voltando
         "R$ 122.90,00" numa arte publicada é prejuízo, não detalhe;
       · a ortografia passa a ser nossa — a arte de terceiro que serviu de
         referência trazia "LAUCHING" escrito errado, e o modelo copia o que vê;
       · dá pra mexer em posição, corpo e cor sem gastar OUTRO token.

     Continua UMA chamada paga por formato: 1,5 token, como as demais. E são
     DUAS receitas separadas de propósito (§1 do projeto) — escolher post não
     gera story, e escolher story não gera post.

     ⚠️ AS MEDIDAS ABAIXO CONVERSAM COM O SERVIDOR. O `ENQUADRA_CLEAN` do
     _editar-foto-ia-core.js manda o carro ter o teto em 38% (post) / 40%
     (story) e as rodas em 85% / 76% da altura — números medidos NAS PRÉVIAS
     QUE O ANGELO APROVOU, não escolhidos no olho. O bloco de texto de cima
     termina ANTES do teto e o rodapé começa DEPOIS das rodas. Mexer num
     número aqui sem mexer lá põe letra em cima de carro.
     ====================================================================== */
  var _FIA_MARINHO='#16233F', _FIA_AZUL='#1B4E9B', _FIA_CINZA='#6E7787';
  var _FIA_SANS='system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
  var _FIA_LAY={
    /* POST 1:1 — 1080x1080, margem segura de 64 px (§10 do projeto) */
    post:{ L:1080, A:1080, marg:64,
      veu:{ ate:454 },
      modelo:{ y:150, tam:84, max:928 },
      dados:{ y:206, tam:25, esp:7 },
      regua:{ y:224, larg:430, gros:3 },
      preco:{ y:312, tam:66, max:860 },
      selo:{ topo:336, alt:56, tam:23, esp:5 },
      pe:{ y:1002, tam:32, esp:3, logo:76 } },
    /* STORY 9:16 — 1080x1920; nada importante nos 250 px de cima nem nos
       300 px de baixo, que são onde Instagram e WhatsApp põem os controles. */
    story:{ L:1080, A:1920, marg:72,
      veu:{ ate:826, pe:1440 },
      modelo:{ y:376, tam:90, max:912 },
      dados:{ y:432, tam:26, esp:7 },
      regua:{ y:452, larg:440, gros:3 },
      preco:{ y:552, tam:72, max:840 },
      selo:{ topo:588, alt:60, tam:24, esp:5 },
      /* 🔴 v888 — OS DESTAQUES CHEGAM NA ARTE COM GARANTIA (pedido do Angelo,
         04/09: "permita editar também as observações que vem do repasse").
         Aqui não houve troca nenhuma: o selo termina em 648 e o teto do carro
         está em 768 — 120 px de folga medidos, mais até que os 96 do story de
         repasse. A linha ocupa de 696 a 716: 48 px do selo, 52 px do carro. */
      fatos:{ y:712, tam:22, esp:4 },
      /* ============================================================================
         🔴 v877 — A MONTAGEM: DUAS MINIATURAS NO PÉ (pedido do Angelo, 04/09:
         "permita selecionar mais de uma foto pra fazer o post com as duas
         miniaturas")
         ----------------------------------------------------------------------------
         ⛳ v907 TROCOU a nota da v877, que dizia: "AS MINIATURAS NÃO PASSAM
         PELA IA, E ISSO É ESCOLHA DE DINHEIRO. Cada foto que vai pro
         fornecedor custa 1,5 token. Se as três fossem, cada arte custaria
         4,5. A grande — que é a que o cliente olha — ganha o showroom limpo e
         a placa AF; as duas de baixo entram como estão, do seu estoque."
         A conta continua exata: com duas miniaturas a arte custa 4,5 token.
         O que mudou foi a decisão, e ela é dele (05/09: "Faça com que a IA
         trabalhe também as foto das miniatura"). Agora cada miniatura é uma
         chamada paga, o preço aparece no botão ANTES de gerar, e a receita
         `mini_auxiliar` decide sozinha o que fazer com cada foto: troca o
         fundo e põe a placa AF se ela for externa; só acerta luz e cor se for
         do painel. O ENQUADRAMENTO desta folha não mudou nada.

         ⚠️ E COM MINIATURAS O RODAPÉ DESCE. Não dá pra encaixar as caixas sem
         mexer nele: as rodas param em 76% de 1920 = 1459 e a régua azul do
         "FALE COMIGO" começava em 1516 — 57 px, menos de um terço do que uma
         caixa legível precisa. Com o rodapé em 1790 a conta fecha: caixas de
         1512 a 1700, 53 px de folga das rodas em cima e 40 px da régua
         embaixo; a assinatura AF termina em 1838, dentro dos 1920.
         📌 O y começou em 1500 e desceu 12 px depois da prévia: o `ENQUADRA`
         manda as RODAS pararem em 76% (1459), mas o pneu e a sombra passam
         disso — a mesma armadilha que tinha derrubado a linha dos destaques
         na v876. Medir pelo contrato e conferir na imagem, sempre os dois.
         📌 Por isso o `pe` mora AQUI DENTRO: é o rodapé DA VERSÃO COM
         MINIATURAS. Sem elas, o de fora continua valendo, intocado. */
      minis:{ y:1512, alt:188, gap:14, r:14, marg:72,
        pe:{ y:1790, tam:32, esp:3, logo:80, sub:{ y:1832, tam:20, esp:5 } } },
      pe:{ y:1566, tam:32, esp:3, logo:80, sub:{ y:1608, tam:20, esp:5 } } },
    /* v905 — POST DE REPASSE 1:1 no padrão aprovado na prévia: eyebrow,
       rótulo FIPE separado, FIPE e repasse no mesmo corpo, percentual, selos
       e destaques. O servidor reserva até 45% da altura para este bloco só na
       receita de repasse; as receitas com garantia continuam inalteradas. */
    post_repasse:{ L:1080, A:1080, marg:64,
      veu:{ ate:454 },
      eyebrow:{ topo:34, alt:36, tam:17, esp:4, texto:'OFERTA DE REPASSE' },
      modelo:{ y:124, tam:58, max:928 },
      dados:{ y:162, tam:21, esp:6 },
      regua:{ y:176, larg:430, gros:3 },
      precosLadoALado:{ esq:0.27, dir:0.73, colMax:430 },
      precoDe:{ y:258, tam:42, max:430, esp:0, recuo:0, rotulo:'FIPE',
        rotuloAcima:true, rotuloY:210, tamRotulo:17, espRotulo:3 },
      preco:{ y:258, tam:42, max:430, rotulo:'REPASSE',
        rotuloY:210, tamRotulo:17, espRotulo:3 },
      precosMesmoTamanho:true,
      pct:{ y:280, alt:42, tam:23, tamDesc:17, esp:2, r:9, recuo:0 },
      comparativo:'percentual',
      selo:{ ocultar:true },
      cta:false,
      assinatura:'centralizada',
      fatos:{ y:370, tam:18, esp:3 },
      pe:{ y:1002, tam:32, esp:3, logo:76 } },
    /* v905 — STORY DE REPASSE 9:16 no mesmo padrão do post. Os 250 px do topo
       e os 300 px do rodapé seguem livres para os controles de Story/Status;
       o carro começa em 45%, depois do bloco comercial. */
    story_repasse:{ L:1080, A:1920, marg:72,
      veu:{ ate:826, pe:1440 },
      eyebrow:{ topo:270, alt:44, tam:20, esp:5, texto:'OFERTA DE REPASSE' },
      modelo:{ y:386, tam:80, max:912 },
      dados:{ y:438, tam:25, esp:7 },
      regua:{ y:456, larg:440, gros:3 },
      precosLadoALado:{ esq:0.27, dir:0.73, colMax:430 },
      precoDe:{ y:566, tam:56, max:430, esp:0, recuo:0, rotulo:'FIPE',
        rotuloAcima:true, rotuloY:500, tamRotulo:21, espRotulo:4 },
      preco:{ y:566, tam:56, max:430, rotulo:'REPASSE',
        rotuloY:500, tamRotulo:21, espRotulo:4 },
      precosMesmoTamanho:true,
      selo:{ ocultar:true },
      /* 🔴 v876 — A LINHA DOS DESTAQUES, LOGO ABAIXO DO SELO.
         ⚠️ ELA NASCEU EMBAIXO, ENTRE AS RODAS E O RODAPÉ, E ISSO ESTAVA
         ERRADO — a prévia mostrou. No papel a conta fechava (rodas em 76%
         de 1920 = 1459, régua do "FALE COMIGO" em 1516), mas 1459 é onde o
         EIXO da roda encosta, não a borda de baixo dela: o pneu e a sombra
         passam disso, e o texto ficou em cima deles. Foto de carro real
         varia ainda mais que o desenho de teste.
         ✅ Aqui em cima o espaço é medido e sobra: o selo termina em 672 e
         o teto do carro está em 768. A linha ocupa de 696 a 712 — 24 px de
         folga do selo, 56 px do carro. E fica junto do preço, que é onde o
         olho já está. */
      /* v905 — percentual entre os preços e os selos. `recuo:0` é deliberado:
         FIPE e percentual dependem da mesma condição, então somem juntos e o
         único recuo necessário é o do bloco FIPE. */
      pct:{ y:592, alt:56, tam:32, tamDesc:21, esp:3, r:12, recuo:0 },
      comparativo:'percentual',   /* v902 — propriedade fechada da folha, não `if` por nome de ação */
      cta:false,                  /* v902 — §13: esta folha não tem CTA no rodapé */
      assinatura:'centralizada',  /* v902 — §13: só o logo AF, no meio */
      fatos:{ y:706, tam:21, esp:4 },
      /* ============================================================================
         🔴 v877 — A MONTAGEM: DUAS MINIATURAS NO PÉ (pedido do Angelo, 04/09:
         "permita selecionar mais de uma foto pra fazer o post com as duas
         miniaturas")
         ----------------------------------------------------------------------------
         ⛳ v907 TROCOU a nota da v877, que dizia: "AS MINIATURAS NÃO PASSAM
         PELA IA, E ISSO É ESCOLHA DE DINHEIRO. Cada foto que vai pro
         fornecedor custa 1,5 token. Se as três fossem, cada arte custaria
         4,5. A grande — que é a que o cliente olha — ganha o showroom limpo e
         a placa AF; as duas de baixo entram como estão, do seu estoque."
         A conta continua exata: com duas miniaturas a arte custa 4,5 token.
         O que mudou foi a decisão, e ela é dele (05/09: "Faça com que a IA
         trabalhe também as foto das miniatura"). Agora cada miniatura é uma
         chamada paga, o preço aparece no botão ANTES de gerar, e a receita
         `mini_auxiliar` decide sozinha o que fazer com cada foto: troca o
         fundo e põe a placa AF se ela for externa; só acerta luz e cor se for
         do painel. O ENQUADRAMENTO desta folha não mudou nada.

         ⚠️ E COM MINIATURAS O RODAPÉ DESCE. Não dá pra encaixar as caixas sem
         mexer nele: as rodas param em 76% de 1920 = 1459 e a régua azul do
         "FALE COMIGO" começava em 1516 — 57 px, menos de um terço do que uma
         caixa legível precisa. Com o rodapé em 1790 a conta fecha: caixas de
         1512 a 1700, 53 px de folga das rodas em cima e 40 px da régua
         embaixo; a assinatura AF termina em 1838, dentro dos 1920.
         📌 O y começou em 1500 e desceu 12 px depois da prévia: o `ENQUADRA`
         manda as RODAS pararem em 76% (1459), mas o pneu e a sombra passam
         disso — a mesma armadilha que tinha derrubado a linha dos destaques
         na v876. Medir pelo contrato e conferir na imagem, sempre os dois.
         📌 Por isso o `pe` mora AQUI DENTRO: é o rodapé DA VERSÃO COM
         MINIATURAS. Sem elas, o de fora continua valendo, intocado. */
      minis:{ y:1484, alt:212, gap:16, r:14, marg:72,
        pe:{ y:1790, tam:32, esp:3, logo:80, sub:{ y:1832, tam:20, esp:5 } } },
      pe:{ y:1566, tam:32, esp:3, logo:80, sub:{ y:1608, tam:20, esp:5 } } }
  };

  /* ⚠️ O QUE ESTA FUNÇÃO DEVOLVE É A CHAVE DO LAYOUT, não o formato de tela.
     `post` e `post_repasse` são os dois 1080×1080 — folhas diferentes, mesmo
     tamanho. Quem precisa saber o TAMANHO que a IA tem que devolver é o
     servidor, e lá a conta é outra função (`formatoClean` do
     _editar-foto-ia-core.js), que devolve 'post' pras duas. */
  /* v875 — 'post' | 'story', a partir da chave do layout. Ver a nota no
     `fiaRotulo`: é a pergunta que a TELA faz, e ela só tem duas respostas. */
  function _fotoIaFamiliaClean(fmt){ return /^story/.test(String(fmt||'')) ? 'story' : 'post'; }

  function _fotoIaFormatoClean(acao){
    if(acao==='divulgacao_garantia_post_clean') return 'post';
    if(acao==='divulgacao_garantia_story_clean') return 'story';
    if(acao==='repasse_post_clean') return 'post_repasse';    /* v871 */
    if(acao==='repasse_story_clean') return 'story_repasse';  /* v875 */
    return '';
  }

  /* ---- os textos, com as regras da seção 7 do projeto -------------------- */
  function _fotoIaModeloTxt(d){ return String((d&&d.modelo)||'').replace(/\s+/g,' ').trim().toUpperCase(); }
  function _fotoIaAnoTxt(d){ return String((d&&d.ano)||'').trim(); }
  /* §7.3: 0 km confirmado vira "0 KM"; sem dado confiável, OMITE — não inventa */
  function _fotoIaKmTxt(d){
    if(String((d&&d.categoria)||'')==='0 KM') return '0 KM';
    var km=Number(d&&d.km)||0;
    if(!(km>0)) return '';
    return String(Math.round(km)).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' KM';
  }
  /* §7.1: SÓ `precoAnuncio`. Preço mínimo, de compra, custo, margem e FIPE
     nunca entram aqui — o 15-marketing.js já entrega só o de anúncio. */
  function _fotoIaPrecoTxt(d){
    var p=Number(d&&d.precoAnuncio)||0;
    if(!(p>0)) return 'CONSULTE O VALOR';
    var t;
    try{ t=p.toLocaleString('pt-BR',{style:'currency',currency:'BRL',minimumFractionDigits:2,maximumFractionDigits:2}); }
    catch(_){ t=''; }
    if(!t||t.indexOf('R$')<0) t='R$ '+String(Math.round(p)).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+',00';
    return t.replace(/\u00A0/g,' ');   /* v868: era o caractere literal — ver a nota no _fotoIaMoedaConf */
  }

  /* ---- v871: os DOIS preços do post de repasse --------------------------
     A mesma regra do §7.1 vale aqui: preço mínimo, preço de compra, custo,
     margem e FIPE NUNCA viram preço de arte. O "POR" é o preço de repasse;
     na falta dele cai no preço de anúncio; na falta dos dois a arte escreve
     "CONSULTE O VALOR" — que é a única ausência que a casa deixa aparecer,
     porque aí a ausência É a informação. */
  function _fotoIaRepassePorN(d){
    return (Number(d&&d.precoPor)||0) || (Number(d&&d.precoAnuncio)||0);
  }
  function _fotoIaRepassePor(d){ return _fotoIaPrecoTxt({precoAnuncio:_fotoIaRepassePorN(d)}); }
  /* ============================================================================
     🔴 v878 — O RISCADO É A FIPE (pedido do Angelo, 04/09: "no conferir antes
     de gerar no repasse, o preço de vai ser sempre a fipe")
     ----------------------------------------------------------------------------
     Antes o riscado era o PREÇO DE ANÚNCIO. Comparar o repasse com o próprio
     anúncio da loja diz pouco a quem está comprando; comparar com a TABELA diz
     tudo — é o argumento do repasse.

     ⚠️ E POR ISSO O NÚMERO PASSA A SER ROTULADO NA ARTE. Um valor riscado sem
     rótulo é lido como "era este preço, agora é aquele". Se o número é a FIPE
     e a arte não diz, ela deixa o cliente entender errado — e desconto que o
     cliente entende errado volta como reclamação na entrega. A folha desenha
     "FIPE" antes do número, e a risca cobre SÓ o número.

     🔴 E A REGRA DE OURO CONTINUA: só aparece quando é MAIOR que o preço de
     repasse. FIPE igual ou abaixo do seu preço não é desconto — é o mercado
     dizendo outra coisa, e riscar aquilo numa arte publicada é vexame na
     frente do cliente. Some, e ninguém precisa conferir. */
  function _fotoIaRepasseDeN(d){ return Number(d&&d.fipe)||0; }
  function _fotoIaRepasseDe(d){
    var de=_fotoIaRepasseDeN(d), por=_fotoIaRepassePorN(d);
    if(!(de>0)||!(por>0)||de<=por) return '';
    return _fotoIaMoedaConf(de);
  }
  /* ============================================================================
     🔴 v902 — O PERCENTUAL ABAIXO DA FIPE (projeto de 05/09)
     ----------------------------------------------------------------------------
     A faixa comparativa do story deixou de mostrar a diferença em REAIS e passou
     a mostrar o percentual. O motivo é comercial e é bom: "R$ 6.052 abaixo da
     FIPE" só diz alguma coisa pra quem já sabe quanto o carro vale; "13,7%
     abaixo da FIPE" se entende sozinho, em qualquer faixa de preço, e é a mesma
     frase que o lojista usa quando fala com outro lojista.

     ⚠️ A CONTA SAI DOS NÚMEROS CRUS E SÓ FORMATA NO FIM. Arredondar a diferença
     antes de dividir daria outro resultado — e um percentual publicado que não
     bate com a conta do cliente é discussão na entrega.

     ⚠️ E VALE A MESMA REGRA DE OURO DA FIPE RISCADA (v878): só existe quando a
     FIPE é ESTRITAMENTE MAIOR que o repasse. Igual ou abaixo não é desconto —
     e "0%" ou "ACIMA DA FIPE" numa arte publicada é vexame na frente do
     cliente. Some, e a folha sobe os selos sozinha.

     📌 `String(13.7)` já devolve "13.7" e `String(10)` devolve "10": o ",0" que
     o projeto manda remover cai fora sem `if` nenhum. */
  function _fotoIaPctAbaixoN(d){
    var fipe=_fotoIaRepasseDeN(d), por=_fotoIaRepassePorN(d);
    if(!(fipe>0)||!(por>0)||fipe<=por) return 0;
    return Math.round(((fipe-por)/fipe)*1000)/10;
  }
  function _fotoIaPctAbaixoTxt(d){
    var p=_fotoIaPctAbaixoN(d);
    if(!(p>0)) return '';
    return String(p).replace('.',',')+'% ABAIXO DA FIPE';
  }
  /* na conferência a mesma frase em caixa baixa; vazia, a linha inteira some
     (o montador do quadro já ignora campo sem valor — nada de traço, zero ou
     "não informado", como o §15 pede). */
  function _fotoIaPctAbaixoConf(d){
    var p=_fotoIaPctAbaixoN(d);
    if(!(p>0)) return '';
    return String(p).replace('.',',')+'% abaixo da FIPE';
  }

  /* na CONFERÊNCIA o "por" nunca some: sem preço, ele diz o que a arte vai
     escrever no lugar (mesma escolha do `_fotoIaValorConf`). */
  function _fotoIaRepassePorConf(d){
    var por=_fotoIaRepassePorN(d);
    return por>0 ? _fotoIaRepassePor(d) : 'Sem preço de repasse. A arte mostrará “CONSULTE O VALOR”.';
  }

  /* ---- medida e escrita com espaçamento entre letras --------------------- */
  function _fotoIaLargTxt(ctx,txt,esp){
    txt=String(txt==null?'':txt); esp=esp||0;
    var w=0;
    for(var i=0;i<txt.length;i++){ w+=ctx.measureText(txt.charAt(i)).width; if(i<txt.length-1) w+=esp; }
    return w;
  }
  function _fotoIaEscreve(ctx,txt,x,y,esp,alinha){
    txt=String(txt==null?'':txt); esp=esp||0;
    var w=_fotoIaLargTxt(ctx,txt,esp);
    var cur=alinha==='left'?x:alinha==='right'?(x-w):(x-w/2);
    for(var i=0;i<txt.length;i++){ var ch=txt.charAt(i); ctx.fillText(ch,cur,y); cur+=ctx.measureText(ch).width+esp; }
    return w;
  }
  /* diminui o corpo até caber na largura segura — nome comprido encolhe,
     nome curto fica grande. É o que a prévia aprovada faz. */
  function _fotoIaCabe(ctx,txt,fam,peso,tamMax,max,esp){
    var t=tamMax;
    for(;t>14;t-=2){ ctx.font=peso+' '+t+'px '+fam; if(_fotoIaLargTxt(ctx,txt,esp||0)<=max) break; }
    ctx.font=peso+' '+t+'px '+fam;
    return t;
  }
  function _fotoIaCaixa(ctx,x,y,w,h,r){
    ctx.beginPath();
    ctx.moveTo(x+r,y); ctx.lineTo(x+w-r,y); ctx.quadraticCurveTo(x+w,y,x+w,y+r);
    ctx.lineTo(x+w,y+h-r); ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    ctx.lineTo(x+r,y+h); ctx.quadraticCurveTo(x,y+h,x,y+h-r);
    ctx.lineTo(x,y+r); ctx.quadraticCurveTo(x,y,x+r,y); ctx.closePath();
  }
  function _fotoIaSeta(ctx,x,y,t){
    ctx.save(); ctx.strokeStyle=_FIA_AZUL; ctx.lineWidth=3.5; ctx.lineCap='round'; ctx.lineJoin='round';
    ctx.beginPath(); ctx.moveTo(x,y-t/2); ctx.lineTo(x+t*0.6,y); ctx.lineTo(x,y+t/2); ctx.stroke(); ctx.restore();
  }

  /* ---- a fonte do título -------------------------------------------------
     Reaproveita a Anton que o 15c-arte-do-veiculo.js já carrega sob demanda
     (licença SIL Open Font, 130 KB, guardada pelo Service Worker).
     ⚠️ E, DIFERENTE DA ARTE DO 15c, aqui a fonte NÃO é motivo pra desistir:
     a imagem já custou 1,5 token quando chegamos neste ponto. Sem Anton, o
     texto sai na pesada do sistema — o DADO continua exato, que é o que
     importa. Jogar fora uma imagem paga por causa de uma letra seria pior. */
  async function _fotoIaFonteTitulo(){
    try{
      if(typeof arteFonteCarregar==='function'){
        var ok=await arteFonteCarregar();
        if(ok) return { fam:'ArteMev, '+_FIA_SANS, peso:'400' };
      }
    }catch(_){ }
    return { fam:_FIA_SANS, peso:'900' };
  }

  /* o logo horizontal AF — sai de marca/, que é a pasta PÚBLICA (a
     identidade/ tem 7 MB de zips e nunca vai pro ar). Mesma origem, então
     não contamina o canvas e o toBlob continua funcionando.

     🔴 v866 — E É UM ARQUIVO NOVO, `af-horizontal-escuro.png`. O
     `af-horizontal.png` que já existia é CLARO: foi feito pro hero escuro do
     site e, sobre o piso claro da arte, ele some. Este é a mesma marca em
     marinho com fundo transparente. O antigo fica como reserva — se um dia
     o novo sumir do deploy, a assinatura sai fraca em vez de não sair. */
  var _fotoIaLogoCache=null;
  function _fotoIaLogoAf(){
    if(_fotoIaLogoCache!==null) return Promise.resolve(_fotoIaLogoCache);
    var fila=['marca/af-horizontal-escuro.png','marca/af-horizontal.png'];
    return new Promise(function(ok){
      (function tenta(i){
        if(i>=fila.length){ _fotoIaLogoCache=false; return ok(null); }
        var im=new Image();
        im.onload=function(){ _fotoIaLogoCache=im; ok(im); };
        im.onerror=function(){ tenta(i+1); };
        im.src=fila[i];
      })(0);
    });
  }

  /* ---- o véu ---------------------------------------------------------------
     Um degradê na cor MÉDIA da própria borda da foto. Se a parede já é clara
     (o normal), ele é invisível. Se a IA devolveu um fundo escuro, ele clareia
     o suficiente pro texto marinho continuar legível. É a rede de segurança do
     item "contraste e leitura" da validação visual — sem faixa aparente. */
  function _fotoIaCorMedia(ctx,x,y,w,h){
    try{
      var d=ctx.getImageData(x,y,w,h).data,r=0,g=0,b=0,n=d.length/4;
      for(var i=0;i<d.length;i+=4){ r+=d[i]; g+=d[i+1]; b+=d[i+2]; }
      return [Math.round(r/n),Math.round(g/n),Math.round(b/n)];
    }catch(_){ return [247,245,243]; }
  }
  function _fotoIaVeu(ctx,L,de,ate,cima){
    var c=_fotoIaCorMedia(ctx,0,cima?0:Math.max(0,L.A-26),L.L,26);
    if((0.299*c[0]+0.587*c[1]+0.114*c[2])<205) c=[247,245,243];
    var rgb=c[0]+','+c[1]+','+c[2];
    var g=ctx.createLinearGradient(0,de,0,ate);
    g.addColorStop(0,'rgba('+rgb+',0.94)');
    g.addColorStop(0.70,'rgba('+rgb+',0.60)');
    g.addColorStop(1,'rgba('+rgb+',0)');
    ctx.fillStyle=g;
    ctx.fillRect(0,Math.min(de,ate),L.L,Math.abs(ate-de));
  }

  /* ==========================================================================
     🔴 v886 — O ENCAIXE: O CHÃO DO VEÍCULO É MEDIDO, NÃO SUPOSTO
     ----------------------------------------------------------------------------
     A folha inteira é construída em cima de UMA linha: onde as rodas encostam.
     O selo termina acima dela, os destaques ficam acima dela, as miniaturas e
     o rodapé começam abaixo dela. O servidor PEDE essa linha ao fornecedor
     (`ENQUADRA_CLEAN`, no _editar-foto-ia-core.js) — mas pedir não é receber.

     Em 04/09 o Angelo mandou uma arte de repasse com um VÃO BRANCO de 218 px
     entre o carro e as miniaturas. Medido na imagem dele: as rodas pararam em
     67,4% da altura, e a folha conta com 76%. 165 px de diferença viraram o
     vão. O texto do pedido foi corrigido na mesma versão, mas texto de prompt
     é súplica: o fornecedor obedece na maioria das vezes, não em todas. E a
     conta de dinheiro é implacável — cada tentativa custa 1,5 token, então
     "gera de novo até sair certo" não é conserto, é caixa registradora.

     ✅ Então o app confere. Ele lê a foto devolvida, acha a linha onde o
     veículo encosta no chão e ESCORREGA a imagem até a linha da folha. Não
     amplia e não corta: só desloca, e pinta o vazio que sobra com a cor da
     própria borda da foto — que ali é parede/piso liso do estúdio, invisível.

     🔑 O PADRÃO É NÃO MEXER. Toda dúvida devolve -1 e a arte sai como saía:
       · `getImageData` barrado (canvas sujo) → não sei dizer;
       · menos de 40 linhas com corpo → provavelmente não é um carro;
       · faixa do veículo menor que 12% ou maior que 80% da altura → não sei;
       · chão fora de 45%..95% da altura → não sei;
       · erro menor que 26 px → já está bom, não vale mexer.
     E mesmo quando sabe, o deslocamento é limitado a 14% da altura. Um erro
     de medida move a foto um pouco; nunca a destrói.

     📌 O fundo de cada LINHA é medido nas duas bordas dela, não uma vez pra
     imagem toda. É o que faz isto funcionar com fundo claro (o normal) e com
     fundo escuro (quando o fornecedor foge do estúdio): o que conta é o
     veículo destoar da sua própria linha, não ser escuro.
     ⚠️ Se o carro encostar nas bordas laterais, a amostra de fundo vira
     lataria, o contraste some e a medição se recusa — de propósito.
     ========================================================================== */
  var _FIA_ENC={ post:0.84, post_repasse:0.84, story:0.75, story_repasse:0.75 };

  /* `fora` é opcional: quem passa um objeto recebe nele o topo e o chão
     medidos. v888 — o topo passou a importar (ver `_fotoIaEncaixe`). */
  function _fotoIaChao(ctx,L,fora){
    var larg=L.L, alt=L.A, d;
    try{ d=ctx.getImageData(0,0,larg,alt).data; }catch(_){ return -1; }
    var borda=Math.max(12,Math.round(larg*0.025));
    var minCheia=larg*0.14, passo=2;
    var primeira=-1, ultima=-1, n=0, y, x, i;
    for(y=0;y<alt;y+=passo){
      var base=y*larg, r=0, g=0, b=0, c=0;
      for(x=0;x<borda;x++){ i=(base+x)*4; r+=d[i]; g+=d[i+1]; b+=d[i+2]; c++; }
      for(x=larg-borda;x<larg;x++){ i=(base+x)*4; r+=d[i]; g+=d[i+1]; b+=d[i+2]; c++; }
      r/=c; g/=c; b/=c;
      var conta=0;
      for(x=borda;x<larg-borda;x+=2){
        i=(base+x)*4;
        if(Math.abs(d[i]-r)+Math.abs(d[i+1]-g)+Math.abs(d[i+2]-b)>60) conta+=2;
      }
      if(conta>=minCheia){ if(primeira<0) primeira=y; ultima=y; n++; }
    }
    if(n<40||primeira<0) return -1;
    var faixa=(ultima-primeira)/alt;
    if(faixa<0.12||faixa>0.80) return -1;
    if(ultima<alt*0.45||ultima>alt*0.95) return -1;
    if(fora){ fora.topo=primeira; fora.chao=ultima; }
    return ultima;
  }

  /* devolve quantos px a foto precisa descer (positivo) ou subir (negativo).
     Zero quer dizer "não mexe" — por acerto ou por dúvida, e as duas coisas
     valem o mesmo aqui. */
  function _fotoIaEncaixe(ctx,L,fmt){
    var frac=_FIA_ENC[fmt]; if(!frac) return 0;
    var med={}, chao=_fotoIaChao(ctx,L,med); if(chao<0) return 0;
    var d=Math.round(L.A*frac)-chao;
    if(Math.abs(d)<26) return 0;
    var teto=Math.round(L.A*0.14);
    if(d>teto) d=teto; else if(d<-teto) d=-teto;
    /* ==========================================================================
       🔴 v888 — SUBIR A FOTO SOBE O TETO DO CARRO JUNTO
       --------------------------------------------------------------------------
       O encaixe da v886 só olhava o chão. Quando o fornecedor entrega o carro
       BAIXO demais, o conserto é subir a foto — e aí o teto sobe também, na
       direção do preço, do selo e (a partir desta versão) dos destaques.
       Enquanto a folha era só texto em cima e carro embaixo isso passava; com
       a linha de destaques a 16 px do teto do carro no post, não passa mais.
       A subida para onde o véu de cima termina (`veu.ate`), que é exatamente
       onde a zona de texto de cada folha acaba. Descer nunca teve esse risco:
       descer afasta o carro do texto.
       ========================================================================== */
    if(d<0 && med.topo!=null){
      var maxSubida=((L.veu&&L.veu.ate)||0)-med.topo;   /* negativo = há espaço */
      if(d<maxSubida) d=Math.min(0,maxSubida);
    }
    return d;
  }

  /* v938 — miniaturas do Post/Story Clean sempre inteiras.
     `cover` preenchia o retângulo, mas cortava justamente o que essas fotos
     precisam mostrar: traseira completa e visão ampla do interior. O fundo
     neutro ocupa a sobra e `contain` preserva 100% da imagem, centralizada,
     sem deformar. Os cantos continuam sendo recortados pelo card externo. */
  function _fotoIaMiniContain(ctx,img,x,y,w,h){
    ctx.save();
    ctx.fillStyle='#F3F0EC'; ctx.fillRect(x,y,w,h);
    var iw=img.naturalWidth||img.width||1, ih=img.naturalHeight||img.height||1;
    var folga=8, k=Math.min((w-folga*2)/iw,(h-folga*2)/ih);
    var dw=iw*k, dh=ih*k;
    ctx.drawImage(img,x+(w-dw)/2,y+(h-dh)/2,dw,dh);
    ctx.restore();
  }

  /* ---- A COMPOSIÇÃO --------------------------------------------------------
     Entra a foto que a IA devolveu; sai o JPEG final com os textos. Nenhuma
     chamada de rede, nenhum token. */
  async function _fotoIaCompor(blob,formato,dados){
    var L=_FIA_LAY[formato];
    if(!L) return blob;
    var img=await _fotoIaCarregar(blob);
    var cv=document.createElement('canvas'); cv.width=L.L; cv.height=L.A;
    var ctx=cv.getContext('2d');

    /* a foto entra SEM esticar: a proporção que o servidor pediu já é a
       final (1024x1024 e 1008x1792 são exatamente 1:1 e 9:16), então na
       prática não há corte nenhum. O `cover` está aqui pro dia em que o
       provedor devolver um pixel diferente do combinado. */
    var iw=img.naturalWidth||img.width||1, ih=img.naturalHeight||img.height||1;
    var k=Math.max(L.L/iw,L.A/ih);
    var _px=(L.L-iw*k)/2, _py=(L.A-ih*k)/2;
    ctx.drawImage(img,_px,_py,iw*k,ih*k);

    /* v886 — o encaixe. A explicação inteira está no bloco acima de
       `_fotoIaEncaixe`; aqui é só a mão que executa.
       ⚠️ O `revokeObjectURL` desceu pra DEPOIS: enquanto houver chance de um
       segundo `drawImage`, a imagem precisa continuar viva. */
    var _desl=_fotoIaEncaixe(ctx,L,formato);
    if(_desl){
      var _cf=_fotoIaCorMedia(ctx,0,_desl>0?0:Math.max(0,L.A-26),L.L,26);
      ctx.fillStyle='rgb('+_cf[0]+','+_cf[1]+','+_cf[2]+')';
      ctx.fillRect(0,0,L.L,L.A);
      ctx.drawImage(img,_px,_py+_desl,iw*k,ih*k);
    }
    try{ if(img._fotoIaUrl) URL.revokeObjectURL(img._fotoIaUrl); }catch(_){ }

    /* ==========================================================================
       🔴 v877 — AS MINIATURAS SÃO CARREGADAS ANTES DE QUALQUER DECISÃO
       --------------------------------------------------------------------------
       Elas mudam TRÊS coisas na folha: o véu de baixo, a faixa das caixas e a
       altura do rodapé. Se a decisão fosse tomada pela lista de URLs, uma foto
       que não carrega (link vencido, rede caída) faria o rodapé descer e
       deixaria um VÃO VAZIO no meio da arte — foi o que a prévia mostrou.
       Agora vale o que REALMENTE virou imagem.
       ⚠️ Cada uma no seu try: falhou, some, e o resto da arte — que já foi
       paga — sai inteiro.
       ⚠️ E pelo `_cardImg` da casa, que pede crossOrigin='anonymous'. Sem
       isso a foto SUJA o canvas e o `toBlob` do fim estoura: a arte paga
       morreria por causa de uma miniatura. */
    var _minsOk=[];
    if(L.minis && dados && Array.isArray(dados.minis)){
      var _mnUrls=dados.minis.filter(Boolean).slice(0,2);
      for(var _q=0;_q<_mnUrls.length;_q++){
        var _imq=null;
        try{ _imq=await _cardImg(_mnUrls[_q]); }catch(_){ _imq=null; }
        if(_imq&&_imq.width) _minsOk.push(_imq);
      }
    }
    var temMinis=_minsOk.length>0;

    _fotoIaVeu(ctx,L,0,L.veu.ate,true);
    /* com miniaturas o véu de baixo sobe junto: as caixas e o rodapé descem,
       e precisam do mesmo chão claro que o rodapé sozinho tinha. */
    if(L.veu.pe) _fotoIaVeu(ctx,L,L.A,temMinis?Math.min(L.veu.pe,L.minis.y-40):L.veu.pe,false);

    var ft=await _fotoIaFonteTitulo();
    var cx=L.L/2, m=L.marg;
    ctx.textBaseline='alphabetic'; ctx.textAlign='left';

    /* v905 — o cabeçalho curto é dado da folha. Assim post e story de
       repasse usam a mesma abertura sem contaminar as artes com garantia. */
    if(L.eyebrow&&L.eyebrow.texto){
      var E=L.eyebrow;
      ctx.font='800 '+E.tam+'px '+_FIA_SANS;
      var ew=_fotoIaLargTxt(ctx,E.texto,E.esp)+74;
      ctx.save(); ctx.fillStyle=_FIA_AZUL;
      _fotoIaCaixa(ctx,cx-ew/2,E.topo,ew,E.alt,E.alt/2); ctx.fill(); ctx.restore();
      ctx.fillStyle='#FFFFFF';
      _fotoIaEscreve(ctx,E.texto,cx,E.topo+E.alt/2+E.tam*0.35,E.esp,'center');
    }

    /* 1 — modelo/versão */
    var modelo=_fotoIaModeloTxt(dados)||'VEÍCULO';
    _fotoIaCabe(ctx,modelo,ft.fam,ft.peso,L.modelo.tam,L.modelo.max,1);
    ctx.fillStyle=_FIA_MARINHO;
    _fotoIaEscreve(ctx,modelo,cx,L.modelo.y,1,'center');

    /* 2 — ano/modelo e quilometragem */
    var linha=[_fotoIaAnoTxt(dados),_fotoIaKmTxt(dados)].filter(Boolean).join('   •   ');
    if(linha){
      ctx.font='700 '+L.dados.tam+'px '+_FIA_SANS;
      ctx.fillStyle=_FIA_CINZA;
      _fotoIaEscreve(ctx,linha,cx,L.dados.y,L.dados.esp,'center');
    }

    /* 3 — a régua azul fina */
    ctx.save(); ctx.globalAlpha=0.85; ctx.fillStyle=_FIA_AZUL;
    ctx.fillRect(cx-L.regua.larg/2,L.regua.y,L.regua.larg,L.regua.gros); ctx.restore();

    /* 4 — o preço.
       Nas artes com garantia é UM número (o de anúncio). No post de repasse
       (v871) são DOIS: o "DE" riscado por cima e o "POR" grande embaixo.
       ⚠️ QUEM DECIDE É O LAYOUT, NÃO O NOME DA AÇÃO: folha com bloco
       `precoDe` desenha o par. Folha nova entra sozinha. */
    var recuo=0;
    var txtDe=L.precoDe?_fotoIaRepasseDe(dados):'';
    var preco=L.precoDe?_fotoIaRepassePor(dados):_fotoIaPrecoTxt(dados);
    var tamPar=0;
    if(L.precoDe&&L.precosMesmoTamanho&&txtDe){
      var maxDe=L.precosLadoALado?L.precosLadoALado.colMax:(L.precoDe.max||L.preco.max);
      var maxPor=L.precosLadoALado?L.precosLadoALado.colMax:L.preco.max;
      var tamDe=_fotoIaCabe(ctx,txtDe,ft.fam,ft.peso,L.precoDe.tam,maxDe,0);
      var tamPor=_fotoIaCabe(ctx,preco,ft.fam,ft.peso,L.preco.tam,maxPor,0);
      tamPar=Math.min(tamDe,tamPor);
    }
    if(L.precoDe){
      if(txtDe){
        var tamDeUsado=tamPar||L.precoDe.tam;
        ctx.font=(L.precosMesmoTamanho?ft.peso:'700')+' '+tamDeUsado+'px '+(L.precosMesmoTamanho?ft.fam:_FIA_SANS);
        ctx.fillStyle=_FIA_CINZA;
        /* v878 — "FIPE" antes do número, e a risca cobrindo SÓ o número.
           ⚠️ Riscar o rótulo junto faria parecer que a FIPE deixou de valer.
           O que está riscado é o VALOR de tabela, não a tabela. */
        var rotDe=String(L.precoDe.rotulo||'');
        var wRot=0;
        var centroDe=(L.precosLadoALado&&txtDe)?L.L*L.precosLadoALado.esq:cx;
        if(rotDe&&L.precoDe.rotuloAcima){
          ctx.font='800 '+L.precoDe.tamRotulo+'px '+_FIA_SANS;
          _fotoIaEscreve(ctx,rotDe,centroDe,L.precoDe.rotuloY,L.precoDe.espRotulo||0,'center');
          ctx.font=ft.peso+' '+tamDeUsado+'px '+ft.fam;
        }else if(rotDe){
          wRot=_fotoIaLargTxt(ctx,rotDe+'  ',L.precoDe.esp);
        }
        var wDe=_fotoIaLargTxt(ctx,txtDe,L.precoDe.esp);
        var xDe=L.precoDe.rotuloAcima?(centroDe-wDe/2):(centroDe-(wRot+wDe)/2);
        if(rotDe&&!L.precoDe.rotuloAcima) _fotoIaEscreve(ctx,rotDe+'  ',xDe,L.precoDe.y,L.precoDe.esp,'left');
        _fotoIaEscreve(ctx,txtDe,xDe+wRot,L.precoDe.y,L.precoDe.esp,'left');
        ctx.save(); ctx.strokeStyle=_FIA_CINZA; ctx.lineWidth=Math.max(2.5,tamDeUsado*0.055); ctx.lineCap='round';
        ctx.beginPath();
        ctx.moveTo(xDe+wRot-7,L.precoDe.y-tamDeUsado*0.36);
        ctx.lineTo(xDe+wRot+wDe+7,L.precoDe.y-tamDeUsado*0.36);
        ctx.stroke(); ctx.restore();
      }else{
        /* sem desconto pra mostrar, o bloco sobe: buraco no meio da arte
           parece dado que não carregou. */
        recuo=L.precoDe.recuo||0;
      }
    }
    if(tamPar) ctx.font=ft.peso+' '+tamPar+'px '+ft.fam;
    else _fotoIaCabe(ctx,preco,ft.fam,ft.peso,L.preco.tam,L.preco.max,0);
    var centroPor=(L.precosLadoALado&&txtDe)?L.L*L.precosLadoALado.dir:cx;
    if(L.precosLadoALado&&L.preco.rotulo){
      ctx.font='800 '+L.preco.tamRotulo+'px '+_FIA_SANS;
      ctx.fillStyle=_FIA_AZUL;
      _fotoIaEscreve(ctx,L.preco.rotulo,centroPor,L.preco.rotuloY,L.preco.espRotulo||0,'center');
      if(tamPar) ctx.font=ft.peso+' '+tamPar+'px '+ft.fam;
      else _fotoIaCabe(ctx,preco,ft.fam,ft.peso,L.preco.tam,L.preco.max,0);
    }
    ctx.fillStyle=_FIA_MARINHO;
    _fotoIaEscreve(ctx,preco,centroPor,L.preco.y-recuo,0,'center');

    /* ==========================================================================
       🔴 v902 — 4b: A FAIXA COMPARATIVA EM PERCENTUAL
       --------------------------------------------------------------------------
       Quem manda é a FOLHA (`comparativo:'percentual'`), não o nome da ação —
       o §17.10 do projeto foi explícito sobre isso, e com razão: as outras três
       folhas clean passam por este mesmo código e não podem ganhar faixa
       nenhuma por tabela.

       ⚠️ A FAIXA NÃO PODE INVADIR A ÁREA DO CARRO. Cada folha informa suas
       medidas e o servidor reserva até 45% da altura nas receitas de repasse.

       ⚠️ E QUANDO NÃO HÁ PERCENTUAL VÁLIDO, O QUE VEM DEPOIS SOBE. `recuoPct`
       entra somado ao `recuo` da FIPE nos selos e nos fatos. Na v905 ele vale
       zero nas duas folhas porque FIPE e percentual somem sempre juntos; o
       recuo do bloco FIPE já fecha o espaço inteiro. */
    var recuoPct=0;
    if(L.comparativo==='percentual' && L.pct){
      var pctTxt=_fotoIaPctAbaixoTxt(dados);
      if(pctTxt){
        var P=L.pct, pY=P.y-recuo;
        /* o percentual vem em peso maior que a descrição (§9): são duas fontes
           na mesma linha, medidas separadas e desenhadas uma depois da outra. */
        var corte=pctTxt.indexOf(' ');
        var nTxt=pctTxt.slice(0,corte), dTxt=pctTxt.slice(corte+1);
        ctx.font='900 '+P.tam+'px '+_FIA_SANS;
        var wN=_fotoIaLargTxt(ctx,nTxt,P.esp);
        ctx.font='800 '+P.tamDesc+'px '+_FIA_SANS;
        var wD=_fotoIaLargTxt(ctx,'  '+dTxt,P.esp);
        var wF=Math.min(wN+wD+72, L.L-m*2);
        var xF=cx-wF/2;
        ctx.save(); ctx.fillStyle=_FIA_AZUL;
        _fotoIaCaixa(ctx,xF,pY,wF,P.alt,P.r||12); ctx.fill(); ctx.restore();
        var bY=pY+P.alt/2+P.tam*0.34;
        var xT=cx-(wN+wD)/2;
        ctx.fillStyle='#FFFFFF';
        ctx.font='900 '+P.tam+'px '+_FIA_SANS;
        _fotoIaEscreve(ctx,nTxt,xT,bY,P.esp,'left');
        ctx.font='800 '+P.tamDesc+'px '+_FIA_SANS;
        _fotoIaEscreve(ctx,'  '+dTxt,xT+wN,bY,P.esp,'left');
      }else{
        recuoPct=L.pct.recuo||0;
      }
    }

    /* 5 — o selo. §7.4: só "COM GARANTIA" (ou "REPASSE", na folha da v871).
       Prazo, cobertura, garantia de fábrica, revisão, laudo e transferência
       grátis NÃO se inventam — e o texto do selo é DADO DA FOLHA, pra não
       existir um segundo lugar onde alguém escreva promessa nova. */
    if(!L.selo.ocultar){
      var seloTxt=L.selo.texto||'COM GARANTIA', seloY=L.selo.topo-recuo-recuoPct;
      ctx.font='800 '+L.selo.tam+'px '+_FIA_SANS;
      var sw=_fotoIaLargTxt(ctx,seloTxt,L.selo.esp)+76;
      var baseTxt=seloY+L.selo.alt/2+L.selo.tam*0.36;

    /* ==========================================================================
       🔴 v888 — A ETIQUETA DE SITUAÇÃO, AO LADO DO SELO
       --------------------------------------------------------------------------
       Ela entra na MESMA LINHA do selo, e isso é escolha de espaço: no post
       1:1 cada pixel vertical já está comprometido (ver a conta do
       `post_repasse`), e uma etiqueta na horizontal não custa altura nenhuma.

       O selo continua CONTORNADO (é a identidade: REPASSE, COM GARANTIA) e a
       situação é PREENCHIDA — pra quem passa o dedo no feed, o estado do
       carro é o que decide se para ou não.

       ⚠️ SE O PAR NÃO COUBER NA MARGEM, A ETIQUETA NÃO É DESENHADA. "ENTRANDO
       EM ESTOQUE" é a mais longa e cabe com folga nos quatro layouts (medido),
       mas a régua fica: arte com texto encostando na borda é pior que arte sem
       etiqueta, e este é o tipo de coisa que só aparece num nome inesperado.
       ========================================================================== */
      var sitTxt=_fotoIaSituacaoTxt(dados);
      var tw=sitTxt?(_fotoIaLargTxt(ctx,sitTxt,L.selo.esp)+56):0;
      var vao=16, cabe=sitTxt && (sw+vao+tw)<=(L.L-m*2);
      var x0=cabe?(cx-(sw+vao+tw)/2):(cx-sw/2);

      ctx.save(); ctx.strokeStyle=_FIA_AZUL; ctx.lineWidth=2.5;
      _fotoIaCaixa(ctx,x0,seloY,sw,L.selo.alt,7); ctx.stroke(); ctx.restore();
      ctx.fillStyle=_FIA_AZUL;
      _fotoIaEscreve(ctx,seloTxt,x0+sw/2,baseTxt,L.selo.esp,'center');

      if(cabe){
        var xs=x0+sw+vao;
        ctx.save(); ctx.fillStyle=_FIA_AZUL;
        _fotoIaCaixa(ctx,xs,seloY,tw,L.selo.alt,7); ctx.fill(); ctx.restore();
        ctx.fillStyle='#FFFFFF';
        _fotoIaEscreve(ctx,sitTxt,xs+tw/2,baseTxt,L.selo.esp,'center');
      }
    }

    /* 5b — v876: os destaques, quando a folha tem lugar pra eles.
       ⚠️ Fora do véu de baixo o piso pode ser escuro; por isso a linha mora
       DENTRO da faixa que o `veu.pe` já clareou. Folha sem `fatos` (o post
       1:1) simplesmente não desenha — e o quadro de conferência também não
       oferece o campo, pra tela e arte contarem a mesma história. */
    if(L.fatos){
      var fatosTxt=_fotoIaFatosTxt(dados);
      if(fatosTxt){
        /* O texto pode reunir três destaques. Reduzimos corpo e espaçamento
           até ele caber na margem segura; nunca deixamos a linha sair da arte
           ou cruzar o veículo, como ocorreu no story da moto. */
        var fatosEsp=L.fatos.esp;
        var fatosTam=_fotoIaCabe(ctx,fatosTxt,_FIA_SANS,'800',L.fatos.tam,L.L-m*2,fatosEsp);
        while(fatosTam<=14 && _fotoIaLargTxt(ctx,fatosTxt,fatosEsp)>L.L-m*2 && fatosEsp>0){
          fatosEsp--; fatosTam=_fotoIaCabe(ctx,fatosTxt,_FIA_SANS,'800',L.fatos.tam,L.L-m*2,fatosEsp);
        }
        ctx.fillStyle=_FIA_CINZA;
        _fotoIaEscreve(ctx,fatosTxt,cx,L.fatos.y-recuoPct,fatosEsp,'center');
      }
    }

    /* 5c — v877: as duas miniaturas da montagem.
       ⚠️ NADA DISSO ACONTECE SE A PESSOA NÃO ESCOLHEU. Folha sem `minis`, ou
       ninguém selecionado, e a arte sai exatamente como saía antes — inclusive
       com o rodapé no lugar de sempre. */
    if(temMinis){
      var M=L.minis, mm=M.marg||m;
      /* 🔴 A LARGURA É A DE DUAS, SEMPRE — mesmo quando você escolhe UMA.
         Dividir o espaço pelo número escolhido faria a miniatura sozinha
         virar uma faixa de 936 px de largura por 200 de altura: um retângulo
         achatado que não parece uma foto, parece um erro de layout. Com a
         medida fixa ela fica do mesmo tamanho das duas e vai pro meio. */
      var larg=Math.floor((L.L-mm*2-M.gap)/2);
      var total=_minsOk.length*larg+(_minsOk.length-1)*M.gap;
      var x0=Math.round((L.L-total)/2);
      for(var q=0;q<_minsOk.length;q++){
        var imq=_minsOk[q];
        var xq=x0+q*(larg+M.gap);
        ctx.save();
        _fotoIaCaixa(ctx,xq,M.y,larg,M.alt,M.r||14);
        ctx.clip();
        try{ _fotoIaMiniContain(ctx,imq,xq,M.y,larg,M.alt); }catch(_){ }
        ctx.restore();
        ctx.save(); ctx.strokeStyle='rgba(22,35,63,.16)'; ctx.lineWidth=2;
        _fotoIaCaixa(ctx,xq,M.y,larg,M.alt,M.r||14); ctx.stroke(); ctx.restore();
      }
    }

    /* 6 — rodapé: CTA à esquerda, assinatura AF à direita.
       v877 — com miniaturas ele desce; a conta está no comentário da folha.

       🔴 v902 — E NESTA FOLHA NÃO HÁ CTA NENHUM. O §13 do projeto de 05/09
       manda remover "QUERO SABER MAIS"/"FALE COMIGO", a seta, a linha
       decorativa e o "CONSULTE DISPONIBILIDADE" — e, junto com eles, o espaço
       que existia só pra eles. O rodapé tem que parecer intencional, não uma
       coluna direita que perdeu o botão.

       ⚠️ QUEM DECIDE É A FOLHA (`cta:false` / `assinatura:'centralizada'`), não
       o nome da ação. As outras três folhas clean não declaram nada e seguem
       exatamente como estavam — é o §17.9 e o §21 ("não alterar o post 1:1 por
       consequência"), e é a única forma de mexer aqui sem risco de arrastar as
       outras junto.

       ⚠️ E O LOGO NÃO CRESCE PRA PREENCHER O VAZIO (§13). Ele mantém a altura
       de sempre e vai pro meio: aumentar o logo porque sobrou espaço é o tipo
       de coisa que faz uma arte parecer amadora. */
    var PE=(temMinis&&L.minis.pe)?L.minis.pe:L.pe;
    var semCta=(L.cta===false);
    var wCta=0;
    if(!semCta){
      ctx.save(); ctx.globalAlpha=0.8; ctx.fillStyle=_FIA_AZUL;
      ctx.fillRect(m,PE.y-PE.tam-18,124,3); ctx.restore();
      ctx.font='800 '+PE.tam+'px '+_FIA_SANS;
      ctx.fillStyle=_FIA_MARINHO;
      wCta=_fotoIaEscreve(ctx,'FALE COMIGO',m,PE.y,PE.esp,'left');
      _fotoIaSeta(ctx,m+wCta+24,PE.y-10,14);
      if(PE.sub){
        ctx.font='700 '+PE.sub.tam+'px '+_FIA_SANS;
        ctx.fillStyle=_FIA_CINZA;
        _fotoIaEscreve(ctx,'CONSULTE DISPONIBILIDADE',m,PE.sub.y,PE.sub.esp,'left');
      }
    }
    var logo=await _fotoIaLogoAf();
    if(logo&&logo.width&&logo.height){
      var lh=PE.logo, lw=logo.width*(lh/logo.height);
      if(!semCta){
        var teto=L.L-m-(m+wCta+70);
        if(lw>teto&&teto>40){ lw=teto; lh=logo.height*(lw/logo.width); }
      }
      var base=(PE.sub?PE.sub.y:PE.y)+6;
      /* centralizado quando a folha pede; senão, colado na direita como sempre */
      var lx=(L.assinatura==='centralizada') ? Math.round((L.L-lw)/2) : (L.L-m-lw);
      ctx.drawImage(logo,lx,base-lh,lw,lh);
    }

    return await new Promise(function(ok,err){
      cv.toBlob(function(b){ b?ok(b):err(new Error('falha ao compor a arte')); },'image/jpeg',0.92);
    });
  }

  async function _fotoIaBaixarOuCompartilhar(blob,dados,acao){
    var base=String((dados&&dados.modelo)||'veiculo').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,55)||'veiculo';
    var garantia=acao==='divulgacao_garantia';
    var fmt=_fotoIaFormatoClean(acao);   /* v866 */
    /* v871 — o post de repasse é clean, mas NÃO é "divulgacao-garantia":
       o nome do arquivo é o que o Angelo vê na galeria do celular na hora de
       escolher o que postar. Um repasse com nome de garantia é o começo de
       um anúncio errado. */
    var nome=(fmt==='post_repasse'?'repasse-post-clean-'
             :fmt==='story_repasse'?'repasse-story-clean-'
             :fmt?('divulgacao-garantia-'+fmt+'-clean-')
             :garantia?'divulgacao-garantia-'
             :'repasse-')+base+'-af.jpg';
    try{
      var file=new File([blob],nome,{type:'image/jpeg'});
      if(navigator.share&&navigator.canShare&&navigator.canShare({files:[file]})){
        var titulo=(fmt==='post_repasse'||fmt==='story_repasse')?'Divulgação de repasse'
                  :(fmt||garantia)?'Divulgação de veículo com garantia'
                  :'Divulgação de repasse';
        await navigator.share({files:[file],title:titulo}); return;
      }
    }catch(e){ if(e&&e.name==='AbortError') return; }
    var u=URL.createObjectURL(blob),a=document.createElement('a');
    a.href=u;a.download=nome;document.body.appendChild(a);a.click();
    setTimeout(function(){try{URL.revokeObjectURL(u);a.remove();}catch(_){}},900);
    toast('Divulgação baixada ✓');
  }

  async function _fotoIaEsperar(jobId,estado,parou){
    var falhasRede=0;
    for(var i=0;i<180;i++){
      if(parou&&parou()) return {ok:false,cancelado:true};
      await new Promise(function(resolve){setTimeout(resolve,i?4000:1500);});
      if(parou&&parou()) return {ok:false,cancelado:true};
      var d=await apiComTimeout('/api/editar-foto-ia',{operacao:'status',jobId:jobId},20000);
      if(d&&d.saldo!=null) try{setSaldo(Number(d.saldo));}catch(_){ }
      if(d&&d.ok&&!d.processando&&d.imagemBase64) return d;
      if(d&&d.ok&&d.processando){
        falhasRede=0;
        try{
          var modal=estado&&estado.closest&&estado.closest('.fotoia');
          var msg=modal&&modal.querySelector('#fotoiaLoaderMsg');
          if(msg) msg.textContent=d.status==='processando'?'Preparando sua foto…':'Aguardando o processamento…';
          if(estado&&typeof estado.textContent!=='undefined') estado.textContent='';
        }catch(_){ }
        continue;
      }
      if(d&&d.rede&&falhasRede++<2) continue;
      return d||{ok:false,erro:'Não consegui acompanhar a edição agora.'};
    }
    return {ok:false,erro:'A edição demorou mais do que o esperado. O valor será devolvido ao seu saldo se o processamento falhar.'};
  }

  async function _fotoIaPreparar(url){
    var r=await fetch(url,{credentials:'omit'}); if(!r.ok) throw new Error('foto indisponível');
    var bl=await r.blob(); if(!bl||!/^image\//i.test(bl.type||'')) throw new Error('arquivo inválido');
    var img=await _fotoIaCarregar(bl), maior=Math.max(img.naturalWidth||img.width,img.naturalHeight||img.height);
    var e=Math.min(1,1536/Math.max(1,maior));
    var w=Math.max(16,Math.round((img.naturalWidth||img.width)*e));
    var h=Math.max(16,Math.round((img.naturalHeight||img.height)*e));
    var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
    var ctx=cv.getContext('2d'); ctx.drawImage(img,0,0,w,h);
    var out=await new Promise(function(resolve,reject){ cv.toBlob(function(b){ b?resolve(b):reject(new Error('falha ao reduzir')); },'image/jpeg',0.86); });
    try{ if(img._fotoIaUrl) URL.revokeObjectURL(img._fotoIaUrl); }catch(_){ }
    return { base64:await _fotoIaBlobBase64(out), largura:w, altura:h };
  }
  async function _fotoIaPostQuadrado(blob){
    var img=await _fotoIaCarregar(blob),L=1080,A=1080;
    var iw=img.naturalWidth||img.width, ih=img.naturalHeight||img.height;
    var cv=document.createElement('canvas'); cv.width=L; cv.height=A;
    var ctx=cv.getContext('2d');
    /* O provedor já entrega 1:1 com o estúdio Clean reconstruído. Este fundo
       é apenas a proteção de borda caso algum retorno venha fora do tamanho. */
    ctx.fillStyle='#f3f0ec';ctx.fillRect(0,0,L,A);
    var k=Math.min(L/Math.max(1,iw),A/Math.max(1,ih));
    var w=Math.round(iw*k),h=Math.round(ih*k);
    ctx.drawImage(img,Math.round((L-w)/2),Math.round((A-h)/2),w,h);
    try{ if(img._fotoIaUrl) URL.revokeObjectURL(img._fotoIaUrl); }catch(_){ }
    return await new Promise(function(resolve,reject){
      cv.toBlob(function(b){b&&b.size?resolve(b):reject(new Error('post_quadrado_invalido'));},'image/jpeg',0.92);
    });
  }
  function _fotoIaCarregar(blob){
    return new Promise(function(resolve,reject){ var im=new Image(),u=URL.createObjectURL(blob); im._fotoIaUrl=u; im.onload=function(){resolve(im);}; im.onerror=function(){try{URL.revokeObjectURL(u);}catch(_){} reject(new Error('imagem inválida'));}; im.src=u; });
  }
  function _fotoIaBlobBase64(blob){
    return new Promise(function(resolve,reject){ var fr=new FileReader(); fr.onload=function(){ resolve(String(fr.result||'').split(',')[1]||''); }; fr.onerror=function(){reject(new Error('falha ao ler'));}; fr.readAsDataURL(blob); });
  }
  function _fotoIaBlob(base64,mime){
    try{ var bin=atob(String(base64||'')), arr=new Uint8Array(bin.length); for(var i=0;i<bin.length;i++)arr[i]=bin.charCodeAt(i); return new Blob([arr],{type:mime||'image/jpeg'}); }catch(_){ return null; }
  }

/* ╔═══ src/app/13e-galeria-marketing.js ══════════════════════════════════ */
  /* ==========================================================================
     v892 — A GALERIA DE MARKETING (pedido do Angelo, 04/09)
     --------------------------------------------------------------------------
     "adicione um botão pra salvar na galeria (posts) e outro pra salvar na
     galeria do marketing (stories)… ela fica logo abaixo do vídeo, separada do
     bloco de imagens que vai pro acervo do veículo, disponível pra baixar,
     compartilhar ou salvar."

     🔴 A REGRA QUE DEFINE ESTA LISTA: ela NÃO É ACERVO.
     O acervo (`_avFotos`) é o que descreve o carro — vai pro link público, pro
     catálogo, pra capa do card. Uma arte de divulgação com preço, selo REPASSE
     e logo em cima NÃO é foto do carro: publicada como acervo, ela vira a
     "foto" do veículo na vitrine e no WhatsApp. Por isso lista separada, com
     chave separada, como o vídeo da v679 já fazia — e pelo mesmo motivo.

     ⚠️ `_avMkt` NUNCA entra em `_avFotos`, em nenhum caminho. É a mesma
     fronteira que o `13b` escreveu pro vídeo, e ela existe pra não ser
     atravessada "só neste caso".

     ⚠️ A ARTE É REALMENTE SUBIDA. Guardar só o blob: da tela faria a galeria
     morrer no primeiro recarregamento — e o Angelo trabalha no celular e no
     computador. Sobe pelo MESMO `avUpload` do acervo (mesmo balde, mesma RLS);
     o que muda é só em qual lista a URL entra.

     ⚠️ E A LISTA SINCRONIZA, com a régua da v483: o `upsert` barrado por RLS
     volta "sucesso" com ZERO linhas. Aqui ele pede a linha de volta e confere —
     sem isso a galeria ficaria só no aparelho e sumiria no outro, exatamente
     como as fotos da avaliação sumiam antes da v811.
     ========================================================================== */

  var _avMkt=[];   /* [{url, fmt:'post'|'story', quando}] — NUNCA em _avFotos */

  /* ============================================================================
     v893 — A MESMA GALERIA VALE NA AVALIAÇÃO E NO ESTOQUE
     ----------------------------------------------------------------------------
     A chave é a PLACA, não a tela. Uma arte criada a partir da foto do estoque
     e outra criada na avaliação são do MESMO carro — separá-las por tela faria
     o Angelo procurar a peça em dois lugares e não achar em nenhum.
     ⚠️ `_avmPlaca` é escrito por quem pinta e só existe enquanto a tela do
     estoque está aberta; fora dela vale o `veiculoAtual`, como antes. */
  var _avmPlaca='';
  function avmPlacaDe(){ return String(_avmPlaca||((veiculoAtual&&veiculoAtual.placa)||'')).toUpperCase(); }
  function avmKey(){ return 'mev_avmkt:'+(avmPlacaDe()||'x'); }
  function avmFmtOk(f){ f=String(f||''); return f==='post'||f==='story'?f:''; }
  function avmNormaliza(l){
    if(!Array.isArray(l)) return [];
    var vistos={}, out=[];
    l.forEach(function(x){
      var u=String((x&&x.url)||'').trim();
      if(!u || !/^https?:\/\//i.test(u) || vistos[u]) return;
      vistos[u]=1;
      out.push({ url:u, fmt:avmFmtOk(x&&x.fmt)||'post', quando:Number(x&&x.quando)||0 });
    });
    return out;
  }
  function avmLer(){
    try{ _avMkt=avmNormaliza(JSON.parse(localStorage.getItem(avmKey())||'[]')); }catch(_){ _avMkt=[]; }
  }
  function avmSalvarLocal(){ try{ localStorage.setItem(avmKey(), JSON.stringify(_avMkt)); }catch(_){} }
  function avmSalvarNuvem(){
    try{
      var placa=avmPlacaDe();
      if(!placa || !(window.supa&&meuId)) return;
      supa.from('doc_consulta').upsert({
        user_id:String(meuId), tipo:'aval_marketing', chave:String(placa), tipo_doc:'marketing',
        resultado:{artes:avmNormaliza(_avMkt)}, ts:Date.now(), atualizado_em:new Date().toISOString()
      },{onConflict:'user_id,tipo,chave'}).select('user_id').then(function(r){
        /* 🔴 A RÉGUA DA v483: sucesso com zero linhas é RLS, não é sucesso. */
        if(r&&r.error){ try{ toast('A arte ficou só neste aparelho — não consegui salvar.'); }catch(_){ } return; }
        if(!((r&&r.data&&r.data.length)||0)){
          try{ console.warn('[MEV] galeria de marketing: o banco aceitou e devolveu ZERO linhas (RLS?)'); }catch(_){ }
          try{ toast('A arte ficou só neste aparelho — o banco não gravou.'); }catch(_){ }
        }
      },function(){ try{ toast('A arte ficou só neste aparelho — sem conexão com o banco.'); }catch(_){ } });
    }catch(_){}
  }
  async function avmCarregarNuvem(){
    try{
      var placa=avmPlacaDe();
      if(!placa || !(window.supa&&meuId)) return;
      var r=await supa.from('doc_consulta').select('resultado')
        .eq('user_id',String(meuId)).eq('tipo','aval_marketing').eq('chave',String(placa)).limit(1);
      var l=(r&&r.data&&r.data[0]&&r.data[0].resultado&&r.data[0].resultado.artes)||null;
      if(!Array.isArray(l)) return;
      /* junta com o que já está no aparelho — nada é perdido pelos dois lados */
      var tem={}; _avMkt.forEach(function(x){ tem[x.url]=1; });
      avmNormaliza(l).forEach(function(x){ if(!tem[x.url]) _avMkt.push(x); });
      _avMkt=avmNormaliza(_avMkt);
      avmSalvarLocal(); avmPinta();
    }catch(_){}
  }

  /* ---- o que o resultado da IA chama ---------------------------------------
     Recebe o BLOB pronto (a arte já composta) e o formato. Sobe e guarda. */
  async function avmGuardar(blob, fmt){
    fmt=avmFmtOk(fmt)||'post';
    if(!blob) throw new Error('sem arte pra guardar');
    var url=await avUpload(blob,{tipo:'marketing'});
    if(!url) throw new Error('upload sem URL');
    _avMkt.push({ url:String(url), fmt:fmt, quando:Date.now() });
    _avMkt=avmNormaliza(_avMkt);
    avmSalvarLocal(); avmSalvarNuvem(); avmPinta();
    return url;
  }
  try{ window.avmGuardar=avmGuardar; }catch(_){}

  /* ---- o OUTRO botão: a arte vai pro ACERVO ---------------------------------
     ⚠️ AQUI É ADICIONAR, NUNCA SUBSTITUIR. O `aoUsar` que o menu da IA já
     usava troca a foto de origem (`_estFotos[i]=url`) — o certo pras receitas
     que CONSERTAM uma foto. Uma arte de divulgação não conserta nada: ela é
     uma peça nova. Trocar a foto original por ela apagaria a foto do carro. */
  async function avmParaAcervo(blob){
    if(!blob) throw new Error('sem arte pra guardar');
    var url=await avUpload(blob,{tipo:'veiculo'});
    if(!url) throw new Error('upload sem URL');
    /* v893 — o acervo depende da tela aberta: na avaliação é `_avFotos`, no
       estoque é `_estFotos`. Os dois pelo PUSH, os dois pelo salvar de cada um. */
    if(_avmPlaca){
      _estFotos.push(String(url));
      try{ estFotosPinta(); }catch(_){ }
      try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){ }
    }else{
      _avFotos.push(String(url));
      try{ avFotosSalvar(); }catch(_){ }
      try{ avFotosPinta(); }catch(_){ }
    }
    return url;
  }
  try{ window.avmParaAcervo=avmParaAcervo; }catch(_){}

  function avmApagar(i){
    var it=_avMkt[i]; if(!it) return;
    if(!confirm('Tirar esta arte da galeria de marketing?')) return;
    /* Esconder, não apagar: sai da lista, o arquivo continua no balde. Quem
       apaga arquivo é o dono, com calma, não um toque no meio do pátio. */
    _avMkt.splice(i,1);
    avmSalvarLocal(); avmSalvarNuvem(); avmPinta();
  }
  async function avmBaixar(i){
    var it=_avMkt[i]; if(!it) return;
    try{
      var r=await fetch(it.url); var b=await r.blob();
      var nome=(((veiculoAtual&&veiculoAtual.placa)||'arte')+'-'+it.fmt+'.jpg').toLowerCase();
      /* o mesmo caminho do resto da casa: compartilhar quando dá, baixar senão */
      if(navigator.share && navigator.canShare && navigator.canShare({files:[new File([b],nome,{type:b.type||'image/jpeg'})]})){
        await navigator.share({ files:[new File([b],nome,{type:b.type||'image/jpeg'})] });
        return;
      }
      var a=document.createElement('a'), u=URL.createObjectURL(b);
      a.href=u; a.download=nome; document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){ } },400);
    }catch(_){ try{ toast('Não consegui baixar agora.'); }catch(_){ } }
  }

  /* ---- o bloco na tela ------------------------------------------------------
     ⚠️ ELE SE INSERE DEPOIS DO VÍDEO, e cai pra depois das fotos quando não há
     vídeo nenhum. É a mesma técnica do `13b` — o HTML da aba não precisa saber
     que esta galeria existe, então nada quebra se a aba mudar de desenho. */
  /* v893 — o bloco procura a tela que estiver aberta: na avaliação ele vai
     depois do vídeo; no estoque, depois da grade de fotos. Uma função, dois
     lugares — nada de um segundo desenho que diverge no primeiro ajuste. */
  function avmAncora(){
    var cli=$('avClienteMarketingAncora');
    if(cli && cli.closest('.vpx-panel.on')) return cli;
    var av=$('avFotos');
    if(av && av.offsetParent!==null) return $('avVideos')||av;
    var es=$('estFotos');
    if(es && es.offsetParent!==null) return es;
    return av||es||null;
  }
  function avmPinta(){
    var ancora=avmAncora(); if(!ancora) return;
    var noVarejo=ancora.id==='avClienteMarketingAncora';
    var box=$('avMarketing');
    if(box && box.previousElementSibling!==ancora){ try{ box.remove(); }catch(_){ } box=null; }
    if(!box){
      box=document.createElement('div'); box.id='avMarketing'; box.className='avm-bloco';
      ancora.parentNode.insertBefore(box, ancora.nextSibling);
    }
    if(!_avMkt.length){
      box.innerHTML='<div class="avm-rotulo">'+(noVarejo?'Marketing do Varejo':'Galeria de marketing')+'</div>'+
        '<div class="avm-vazio">As artes que você salvar aqui ficam guardadas pra baixar e compartilhar — e <b>não entram</b> nas fotos do veículo.</div>';
      return;
    }
    var html=_avMkt.map(function(a,i){
      return '<div class="avm-item'+(a.fmt==='story'?' story':'')+'" data-a="'+i+'">'+
        '<img loading="lazy" decoding="async" src="'+esc(a.url)+'" alt="Arte de marketing '+(i+1)+'">'+
        '<span class="avm-fmt">'+(a.fmt==='story'?'STORY':'POST')+'</span>'+
        '<button type="button" class="avm-bx" data-a="'+i+'" aria-label="Baixar ou compartilhar a arte '+(i+1)+'">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'+
        '</button>'+
        '<button type="button" class="av-del avm-del" data-a="'+i+'" aria-label="Tirar a arte '+(i+1)+' da galeria">&times;</button>'+
      '</div>';
    }).join('');
    box.innerHTML='<div class="avm-rotulo">'+(noVarejo?'Marketing do Varejo':'Galeria de marketing')+'<small>não entra nas fotos do veículo</small></div>'+
                  '<div class="avm-linha">'+html+'</div>';
    Array.prototype.forEach.call(box.querySelectorAll('.avm-bx'),function(b){
      b.onclick=function(e){ e.stopPropagation(); avmBaixar(parseInt(b.getAttribute('data-a'),10)||0); };
    });
    Array.prototype.forEach.call(box.querySelectorAll('.avm-del'),function(b){
      b.onclick=function(e){ e.stopPropagation(); avmApagar(parseInt(b.getAttribute('data-a'),10)||0); };
    });
  }

  function avmAoAbrirAvaliacao(){ _avmPlaca=''; _avMkt=[]; avmLer(); avmPinta(); try{ avmCarregarNuvem(); }catch(_){} }
  try{ window.avmAoAbrirAvaliacao=avmAoAbrirAvaliacao; }catch(_){}
  /* v893 — a entrada do ESTOQUE. Recebe a placa do veículo em edição. */
  function avmAoAbrirEstoque(placa){
    _avmPlaca=String(placa||'').toUpperCase();
    _avMkt=[]; avmLer(); avmPinta();
    try{ avmCarregarNuvem(); }catch(_){}
  }
  try{ window.avmAoAbrirEstoque=avmAoAbrirEstoque; }catch(_){}

/* ╔═══ src/app/13f-santa-luzia-conteudo.js ═══════════════════════════════ */
  /* ======================================================================
     v1108 — CONTEÚDO SANTA LUZIA NAS FOTOS DO ESTOQUE
     ----------------------------------------------------------------------
     Seis receitas fechadas, baseadas nos padrões aprovados em
     identidade/santa-luzia/. A IA prepara a fotografia; o navegador escreve
     os dados exatos e aplica a assinatura conjunta. Não há prompt livre.
     ====================================================================== */
  var _SL_Acoes=[
    'sl_entrega_story','sl_entrega_post','sl_capa_clean',
    'sl_carrossel','sl_cnpj_produtor','sl_condicao_post','sl_condicao_story'
  ];

  function santaLuziaAcoesChaves(){ return _SL_Acoes.slice(); }

  var _SL_Receitas={
    sl_entrega_story:{titulo:'Criar story de entrega',sub:'Story 9:16 com foto da entrega, mensagem de parabéns e assinatura Santa Luzia + AF.'},
    sl_entrega_post:{titulo:'Criar post de entrega',sub:'Post 4:5 com foto da entrega, mensagem de parabéns e assinatura Santa Luzia + AF.'},
    sl_capa_clean:{titulo:'Criar capa post clean',sub:'Capa 4:5 limpa, sem preço e sem CTA, com veículo, identificação e assinatura.'},
    sl_carrossel:{titulo:'Criar carrossel',sub:'Cria até três slides 4:5 separados: capa, segunda foto e terceira foto.'},
    sl_cnpj_produtor:{titulo:'Criar post CNPJ ou produtor rural',sub:'Post 4:5 com condição comercial exclusiva para CNPJ ou bloco de produtor rural.'},
    sl_condicao_post:{titulo:'Criar post de condição especial',sub:'Post 4:5 com entrada, parcelas e condições confirmadas.'},
    sl_condicao_story:{titulo:'Criar story de condição especial',sub:'Story 9:16 com entrada, parcelas e condições confirmadas.'}
  };
  Object.keys(_SL_Receitas).forEach(function(k){ _fotoIaReceitas[k]=_SL_Receitas[k]; });

  var _SL_Configs={
    sl_entrega_story:{botao:'Criar story',formato:'Story 9:16 · 1080 × 1920',faz:'Prepara a fotografia da entrega e aplica a mensagem e a assinatura aprovadas.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['clientes','veiculo'],notas:['Nomes podem ser corrigidos antes de gerar.','A fotografia deve ter autorização das pessoas retratadas.']},
    sl_entrega_post:{botao:'Criar post',formato:'Post 4:5 · 1080 × 1350',faz:'Prepara a fotografia da entrega e aplica a mensagem e a assinatura aprovadas.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['clientes','veiculo'],notas:['Nomes podem ser corrigidos antes de gerar.','A fotografia deve ter autorização das pessoas retratadas.']},
    sl_capa_clean:{botao:'Criar capa',formato:'Post 4:5 · 1080 × 1350',faz:'Cria uma capa limpa com identificação, ano e veículo inteiro.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['veiculo','ano'],notas:['Sem preço e sem CTA por padrão.','Não usa o selo genérico “Com garantia” para veículo zero km.']},
    sl_carrossel:{botao:'Criar carrossel',formato:'Até 3 slides · 1080 × 1350 cada',faz:'A foto atual vira a capa e até duas fotos escolhidas viram os slides seguintes.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['tipoCarrossel','veiculo','ano','valor','entrada','parcelasQtd','parcelaValor','taxa','fatos'],minis:true,notas:['Escolha o público da campanha antes de gerar.','Cada foto escolhida passa pela IA e tem o custo mostrado no botão.','O resultado contém arquivos separados e numerados, prontos para publicar na ordem.']},
    sl_cnpj_produtor:{botao:'Criar post',formato:'Post 4:5 · 1080 × 1350',faz:'Cria a peça comercial para venda direta, com público e condição confirmados.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['veiculo','ano','publico','entrada','parcelasQtd','parcelaValor','taxa'],notas:['Campos comerciais vazios são omitidos. Nunca inventar condição.']},
    sl_condicao_post:{botao:'Criar post',formato:'Post 4:5 · 1080 × 1350',faz:'Cria a peça de condição especial no padrão Santa Luzia.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['veiculo','ano','entrada','parcelasQtd','parcelaValor','taxa','residual'],notas:['Campos comerciais vazios são omitidos. Nunca inventar condição.']},
    sl_condicao_story:{botao:'Criar story',formato:'Story 9:16 · 1080 × 1920',faz:'Cria a peça vertical de condição especial no padrão Santa Luzia.',identidade:'Santa Luzia + Ângelo Ferrari',campos:['veiculo','ano','entrada','parcelasQtd','parcelaValor','taxa','residual'],notas:['Campos comerciais vazios são omitidos. Nunca inventar condição.']}
  };
  Object.keys(_SL_Configs).forEach(function(k){ _FIA_CONF[k]=_SL_Configs[k]; });

  var _SL_Campos={
    clientes:{de:'clientes',tipo:'texto',dica:'Ex.: Igor e Mirela'},
    tipoCarrossel:{de:'tipoCarrossel',tipo:'opcao',opcoes:['Varejo','CNPJ ou produtor rural','PCD','Taxista','Locadora ou frotista','Venda direta'],dica:'Escolha o público'},
    publico:{de:'publico',tipo:'opcao',opcoes:['CNPJ ou bloco de produtor rural','CNPJ','Bloco de produtor rural'],dica:'CNPJ ou bloco de produtor rural'},
    entrada:{de:'entrada',tipo:'num',dica:'Valor da entrada'},
    parcelasQtd:{de:'parcelasQtd',tipo:'num',dica:'Quantidade de parcelas'},
    parcelaValor:{de:'parcelaValor',tipo:'num',dica:'Valor da parcela'},
    taxa:{de:'taxa',tipo:'texto',dica:'Ex.: 1,19% a.m.'},
    residual:{de:'residual',tipo:'num',dica:'Parcela residual (opcional)'}
  };
  Object.keys(_SL_Campos).forEach(function(k){ _FIA_EDITA[k]=_SL_Campos[k]; });
  var _SL_Rotulos={clientes:'Cliente(s)',tipoCarrossel:'Público do carrossel',publico:'Público da condição',entrada:'Entrada',parcelasQtd:'Quantidade de parcelas',parcelaValor:'Valor da parcela',taxa:'Taxa',residual:'Parcela residual'};
  Object.keys(_SL_Rotulos).forEach(function(k){ _FIA_ROTULO[k]=_SL_Rotulos[k]; });

  /* O público do carrossel nunca é presumido: é uma decisão comercial do
     usuário, feita antes de gerar e antes de qualquer cobrança. */
  function _fotoIaValidarReceita(acao,dados,modal){
    if(acao!=='sl_carrossel') return true;
    var escolhido=String((dados&&dados.tipoCarrossel)||'').trim();
    if((_SL_Campos.tipoCarrossel.opcoes||[]).indexOf(escolhido)>=0) return true;
    try{ toast('Escolha o público do carrossel antes de gerar.'); }catch(_){ }
    try{
      var box=modal.querySelector('#fotoiaEdita'),bt=modal.querySelector('#fotoiaEditar');
      if(box&&box.hidden&&bt) bt.click();
      setTimeout(function(){var el=modal.querySelector('#fiaEd_tipoCarrossel');if(el)el.focus();},40);
    }catch(_){ }
    return false;
  }

  var _slCampoAnterior=_fotoIaCampoConf;
  _fotoIaCampoConf=function(k,d){
    if(k==='clientes'||k==='tipoCarrossel'||k==='publico'||k==='taxa') return String((d&&d[k])||'').trim();
    if(k==='entrada'||k==='parcelaValor'||k==='residual') return _fotoIaMoedaConf(d&&d[k]);
    if(k==='parcelasQtd'){
      var n=Math.round(Number(d&&d[k])||0); return n>0?String(n):'';
    }
    return _slCampoAnterior(k,d);
  };

  var _slFormatoAnterior=_fotoIaFormatoClean;
  _fotoIaFormatoClean=function(acao){
    var mapa={
      sl_entrega_story:'story_entrega',sl_entrega_post:'post_entrega',
      sl_capa_clean:'post45_clean',sl_carrossel:'post_carrossel',sl_cnpj_produtor:'post_cnpj',
      sl_condicao_post:'post_condicao',sl_condicao_story:'story_condicao'
    };
    return mapa[acao]||_slFormatoAnterior(acao);
  };

  function _slCarregaLogo(){
    if(_slCarregaLogo.cache!==undefined) return Promise.resolve(_slCarregaLogo.cache);
    return new Promise(function(ok){
      var im=new Image();
      im.onload=function(){ _slCarregaLogo.cache=im; ok(im); };
      im.onerror=function(){ _slCarregaLogo.cache=null; ok(null); };
      im.src='identidade/santa-luzia/assinaturas/santa-luzia-af-entrega-transparente.png';
    });
  }
  function _slDinheiro(n){ return _fotoIaMoedaConf(n).replace(',00',''); }
  function _slTexto(d,k){ return String((d&&d[k])||'').replace(/\s+/g,' ').trim(); }
  function _slFit(ctx,txt,peso,tam,max,fam){
    txt=String(txt||''); var t=tam;
    for(;t>18;t-=2){ ctx.font=peso+' '+t+'px '+fam; if(ctx.measureText(txt).width<=max) break; }
    ctx.font=peso+' '+t+'px '+fam; return t;
  }
  function _slLinha(ctx,txt,x,y,cor,alinha){ ctx.fillStyle=cor; ctx.textAlign=alinha||'center'; ctx.fillText(String(txt||''),x,y); }
  function _slCover(ctx,img,W,H){
    var iw=img.naturalWidth||img.width||1,ih=img.naturalHeight||img.height||1,k=Math.max(W/iw,H/ih);
    ctx.drawImage(img,(W-iw*k)/2,(H-ih*k)/2,iw*k,ih*k);
  }
  function _slVeu(ctx,W,de,ate,cima){
    var g=ctx.createLinearGradient(0,de,0,ate);
    if(cima){ g.addColorStop(0,'rgba(255,255,255,.99)');g.addColorStop(.72,'rgba(255,255,255,.92)');g.addColorStop(1,'rgba(255,255,255,0)'); }
    else { g.addColorStop(0,'rgba(255,255,255,0)');g.addColorStop(.28,'rgba(255,255,255,.94)');g.addColorStop(1,'rgba(255,255,255,.99)'); }
    ctx.fillStyle=g;ctx.fillRect(0,Math.min(de,ate),W,Math.abs(ate-de));
  }
  async function _slAssinatura(ctx,W,H,y,larg){
    var logo=await _slCarregaLogo(); if(!logo||!logo.width) return;
    var w=Math.min(larg,W-100),h=logo.height*(w/logo.width);
    ctx.drawImage(logo,(W-w)/2,Math.min(H-h-35,y),w,h);
  }
  function _slBlobCanvas(cv){
    return new Promise(function(ok,err){cv.toBlob(function(b){b&&b.size?ok(b):err(new Error('falha ao montar slide'));},'image/jpeg',.93);});
  }
  function _slImagemUrl(url){
    return new Promise(function(ok,err){var im=new Image();im.crossOrigin='anonymous';im.onload=function(){ok(im);};im.onerror=function(){err(new Error('imagem auxiliar inválida'));};im.src=url;});
  }
  function _slTitulo(ctx,txt,W,y,tam){
    txt=String(txt||'').toUpperCase(); _slFit(ctx,txt,'900',tam,W-120,_FIA_SANS);
    _slLinha(ctx,txt,W/2,y,'#001E50');
  }
  function _slComercial(ctx,d,W,y,story){
    var entrada=Number(d&&d.entrada)||0,qtd=Math.round(Number(d&&d.parcelasQtd)||0),parcela=Number(d&&d.parcelaValor)||0;
    var taxa=_slTexto(d,'taxa'),residual=Number(d&&d.residual)||0;
    var col=[];
    if(entrada) col.push('ENTRADA  '+_slDinheiro(entrada));
    if(qtd&&parcela) col.push(qtd+'× DE  '+_slDinheiro(parcela));
    else if(qtd) col.push(qtd+' PARCELAS');
    if(taxa) col.push('TAXA  '+taxa.toUpperCase());
    if(residual) col.push('PARCELA RESIDUAL  '+_slDinheiro(residual));
    if(!col.length) col.push('CONSULTE AS CONDIÇÕES');
    var tam=story?38:30,alt=story?62:50,w=Math.min(W-150,story?790:760),x=(W-w)/2;
    col.slice(0,4).forEach(function(t,i){
      var yy=y+i*(alt+12);ctx.fillStyle=i===0?'#00AEEF':'#001E50';_fotoIaCaixa(ctx,x,yy,w,alt,12);ctx.fill();
      ctx.font='800 '+tam+'px '+_FIA_SANS;_slLinha(ctx,t,W/2,yy+alt*.68,i===0?'#FFFFFF':'#FFFFFF');
    });
  }

  async function _slCompor(blob,formato,d){
    var story=formato.indexOf('story_')===0,W=1080,H=story?1920:1350;
    var img=await _fotoIaCarregar(blob),cv=document.createElement('canvas');cv.width=W;cv.height=H;
    var ctx=cv.getContext('2d');_slCover(ctx,img,W,H);
    var entrega=formato==='story_entrega'||formato==='post_entrega';
    var clean=formato==='post45_clean',cnpj=formato==='post_cnpj';
    _slVeu(ctx,W,0,story?600:390,true);_slVeu(ctx,W,story?1380:980,H,false);
    if(entrega){
      var nomes=_slTexto(d,'clientes');
      ctx.font='800 '+(story?27:22)+'px '+_FIA_SANS;ctx.letterSpacing='5px';
      _slLinha(ctx,'ENTREGA REALIZADA',W/2,story?292:84,'#00AEEF');
      _slTitulo(ctx,nomes?('PARABÉNS, '+nomes+'!'):'PARABÉNS PELA CONQUISTA!',W,story?410:170,story?76:58);
      var mod=_fotoIaModeloTxt(d);if(mod){ctx.font='700 '+(story?30:24)+'px '+_FIA_SANS;_slLinha(ctx,'PELO NOVO '+mod,W/2,story?468:218,'#168FE5');}
      await _slAssinatura(ctx,W,H,story?1640:1120,story?850:780);
    }else if(clean){
      _slTitulo(ctx,'VOLKSWAGEN '+(_fotoIaModeloTxt(d)||'VEÍCULO')+' ZERO KM',W,155,64);
      var ano=_fotoIaAnoTxt(d);if(ano){ctx.font='700 27px '+_FIA_SANS;_slLinha(ctx,ano,W/2,210,'#64748B');}
      await _slAssinatura(ctx,W,H,1110,760);
    }else{
      ctx.font='800 '+(story?26:22)+'px '+_FIA_SANS;_slLinha(ctx,'CONDIÇÃO ESPECIAL',W/2,story?285:78,'#168FE5');
      _slTitulo(ctx,'VOLKSWAGEN '+(_fotoIaModeloTxt(d)||'VEÍCULO')+' ZERO KM',W,story?400:150,story?72:56);
      var ano2=_fotoIaAnoTxt(d);if(ano2){ctx.font='700 '+(story?28:23)+'px '+_FIA_SANS;_slLinha(ctx,ano2,W/2,story?452:194,'#64748B');}
      if(cnpj){
        var pub=_slTexto(d,'publico')||'CNPJ OU BLOCO DE PRODUTOR RURAL';
        ctx.font='800 '+(story?31:25)+'px '+_FIA_SANS;_slLinha(ctx,pub.toUpperCase(),W/2,story?535:252,'#001E50');
      }
      _slComercial(ctx,d,W,story?570:(cnpj?285:260),story);
      await _slAssinatura(ctx,W,H,story?1640:1120,story?850:780);
    }
    try{if(img._fotoIaUrl)URL.revokeObjectURL(img._fotoIaUrl);}catch(_){ }
    return await new Promise(function(ok,err){cv.toBlob(function(b){b?ok(b):err(new Error('falha ao compor padrão Santa Luzia'));},'image/jpeg',.93);});
  }

  var _slCarouselBlobs=[];
  async function _slSlide(img,d,indice,total){
    var W=1080,H=1350,cv=document.createElement('canvas');cv.width=W;cv.height=H;
    var ctx=cv.getContext('2d');_slCover(ctx,img,W,H);_slVeu(ctx,W,0,360,true);_slVeu(ctx,W,990,H,false);
    var tipo=_slTexto(d,'tipoCarrossel')||'Varejo';
    var tipoCurto=tipo==='CNPJ ou produtor rural'?'CNPJ OU PRODUTOR RURAL':tipo.toUpperCase();
    if(indice===0){
      ctx.font='800 21px '+_FIA_SANS;_slLinha(ctx,'CONDIÇÃO '+tipoCurto,W/2,72,'#168FE5');
      _slTitulo(ctx,'VOLKSWAGEN '+(_fotoIaModeloTxt(d)||'VEÍCULO')+' ZERO KM',W,145,61);
      var ano=_fotoIaAnoTxt(d);if(ano){ctx.font='700 25px '+_FIA_SANS;_slLinha(ctx,ano,W/2,196,'#64748B');}
      var valor=Number(d&&d.precoAnuncio)||0;
      if(valor){ctx.font='900 43px '+_FIA_SANS;_slLinha(ctx,'POR  '+_slDinheiro(valor),W/2,257,'#001E50');}
    }else{
      ctx.font='800 22px '+_FIA_SANS;_slLinha(ctx,indice===1?('CONDIÇÃO '+tipoCurto):'DETALHES E ACABAMENTO',W/2,82,'#168FE5');
      _slTitulo(ctx,_fotoIaModeloTxt(d)||'VOLKSWAGEN',W,146,54);
      var fatos=_fotoIaFatosTxt(d);
      if(fatos){ctx.font='800 20px '+_FIA_SANS;_slLinha(ctx,fatos,W/2,194,'#475569');}
      if(indice===1){
        var entrada=Number(d&&d.entrada)||0,qtd=Math.round(Number(d&&d.parcelasQtd)||0),parcela=Number(d&&d.parcelaValor)||0,taxa=_slTexto(d,'taxa'),lin=[];
        if(entrada)lin.push('ENTRADA '+_slDinheiro(entrada));
        if(qtd&&parcela)lin.push(qtd+'× DE '+_slDinheiro(parcela));
        if(taxa)lin.push('TAXA '+taxa.toUpperCase());
        if(lin.length){ctx.font='800 23px '+_FIA_SANS;_slLinha(ctx,lin.join('  •  '),W/2,244,'#001E50');}
      }
    }
    ctx.font='800 18px '+_FIA_SANS;_slLinha(ctx,String(indice+1)+' / '+String(total),W-72,1282,'#168FE5','right');
    await _slAssinatura(ctx,W,H,1120,720);
    return _slBlobCanvas(cv);
  }
  async function _slComporCarrossel(blob,d){
    var imagens=[await _fotoIaCarregar(blob)],extras=(d&&Array.isArray(d.minis)?d.minis:[]).slice(0,2);
    for(var i=0;i<extras.length;i++) try{imagens.push(await _slImagemUrl(extras[i]));}catch(_){ }
    var slides=[];
    for(var j=0;j<imagens.length;j++) slides.push(await _slSlide(imagens[j],d,j,imagens.length));
    try{if(imagens[0]&&imagens[0]._fotoIaUrl)URL.revokeObjectURL(imagens[0]._fotoIaUrl);}catch(_){ }
    _slCarouselBlobs=slides;
    return slides[0];
  }

  var _slComporAnterior=_fotoIaCompor;
  _fotoIaCompor=async function(blob,formato,dados){
    if(formato==='post_carrossel') return _slComporCarrossel(blob,dados||{});
    if(/^(story_entrega|post_entrega|post45_clean|post_cnpj|post_condicao|story_condicao)$/.test(String(formato||'')))
      return _slCompor(blob,formato,dados||{});
    return _slComporAnterior(blob,formato,dados);
  };

  /* Nomes de arquivo e título de compartilhamento claros para a galeria. */
  var _slBaixarAnterior=_fotoIaBaixarOuCompartilhar;
  _fotoIaBaixarOuCompartilhar=async function(blob,dados,acao){
    if(_SL_Acoes.indexOf(acao)<0) return _slBaixarAnterior(blob,dados,acao);
    var base=_fotoIaModeloTxt(dados).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,48)||'veiculo';
    var nome=acao.replace(/^sl_/,'').replace(/_/g,'-')+'-'+base+'-santa-luzia.jpg';
    var blobs=acao==='sl_carrossel'&&_slCarouselBlobs.length?_slCarouselBlobs:[blob];
    var files=blobs.map(function(b,i){return new File([b],acao==='sl_carrossel'?('carrossel-'+String(i+1).padStart(2,'0')+'-'+base+'-santa-luzia.jpg'):nome,{type:'image/jpeg'});});
    try{
      if(navigator.share&&navigator.canShare&&navigator.canShare({files:files})){await navigator.share({files:files,title:_SL_Receitas[acao].titulo});return;}
    }catch(e){if(e&&e.name==='AbortError')return;}
    files.forEach(function(f,i){setTimeout(function(){var u=URL.createObjectURL(f),a=document.createElement('a');a.href=u;a.download=f.name;document.body.appendChild(a);a.click();setTimeout(function(){try{URL.revokeObjectURL(u);a.remove();}catch(_){}},1200);},i*350);});
    toast(files.length>1?'Slides baixados e numerados ✓':'Arte baixada ✓');
  };

/* ╔═══ src/app/14-estoque.js ═════════════════════════════════════════════ */
  /* ================= ESTOQUE / VEÍCULOS DA LOJA ================= */
  var _estoque=[], _estFotos=[], _estFiltro='disponivel', _estEditId=null, _estErro=false, _estPlacaAuto='', _estImportFonte=null, _estFipeEscolha=null, _estFipeRemovida=false;
  /* v1202 — autosaves em fila: escolher a capa enquanto outro campo ainda
     estava salvando podia deixar a requisicao antiga terminar por ultimo e
     devolver ao banco a ordem anterior das fotos. */
  var _estSaveFila=Promise.resolve();
  /* v1209 — cada troca de capa recebe uma sequencia. Se a pessoa escolher
     outra foto antes da confirmacao da primeira, só a escolha mais recente
     pode pintar sucesso ou restaurar a ordem anterior em caso de falha. */
  var _estCapaSeq=0,_estListaAtualizada=0;
  var ICO_EST='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M9 13h6"/></svg>';
  var ICO_CATALOGO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>';
  function _publicoVeiculoUrl(v){
    if(!v) return '';
    /* v514 — QUEM JÁ SABE O PRÓPRIO ENDEREÇO MANDA ELE PRONTO.
       O anúncio do Portal do Repasse mora em /r/<id>, não em /v/<id>. Sem
       esta linha, avisar os lojistas de um carro de repasse (18f) exigiria
       uma SEGUNDA mensagem do veículo — e a v508 existiu justamente pra
       acabar com as duas. Uma mensagem só (estVeicMsg), endereço injetado. */
    if(v.url_publica) return String(v.url_publica);
    if(!v.id) return '';
    var ap=String((_lojaRec&&_lojaRec.slug)||'').trim();
    return ap
      ? (location.origin+'/'+encodeURIComponent(ap)+'/veiculo/'+encodeURIComponent(v.id))
      : (location.origin+'/v/'+encodeURIComponent(v.id));
  }
  var _publicoFoco=null,_publicoScroll=0,_publicoBodyStyle=null;
  function _publicoTecla(e){if(e.key==='Escape'&&$('mevPublicoViewer')){e.preventDefault();_publicoFechar();}}
  function _publicoFechar(){
    var p=$('mevPublicoViewer'); if(p) p.remove();
    document.body.classList.remove('publico-aberto');
    if(p){
      document.removeEventListener('keydown',_publicoTecla);
      if(_publicoBodyStyle===null) document.body.removeAttribute('style');else document.body.setAttribute('style',_publicoBodyStyle);
      window.scrollTo(0,_publicoScroll);
      if(_publicoFoco&&_publicoFoco.isConnected) _publicoFoco.focus({preventScroll:true});
    }
  }
  /* v1396 — ação opcional do visor público. Páginas que recebem dados de
     compartilhamento ganham um botão ao lado de Fechar; as demais continuam
     exatamente com a barra histórica de um único controle. */
  function _publicoCompartilhar(dados){
    dados=dados||{};
    var url=String(dados.url||'');
    function copiar(){
      try{
        if(url&&navigator.clipboard&&navigator.clipboard.writeText){
          navigator.clipboard.writeText(url).then(function(){ toast('Link da apresentação copiado.'); },function(){ try{ prompt('Copie o link:',url); }catch(__){ toast(url); } });
          return;
        }
      }catch(_){}
      try{ prompt('Copie o link:',url); }catch(_){ if(url) toast(url); }
    }
    try{
      if(navigator.share){
        navigator.share(dados).catch(function(err){ if(!(err&&err.name==='AbortError')) copiar(); });
        return;
      }
    }catch(_){}
    copiar();
  }
  function _publicoAbrir(url, opcoes){
    if(!url) return;
    var o=opcoes||{}, voltar=String(o.voltar||'Voltar ao estoque'), titulo=String(o.titulo||'Página pública do veículo');
    _publicoFechar();
    _publicoFoco=document.activeElement;_publicoScroll=window.scrollY;_publicoBodyStyle=document.body.getAttribute('style');
    var p=document.createElement('div'); p.id='mevPublicoViewer'; p.className='mev-publico'; p.setAttribute('role','dialog'); p.setAttribute('aria-modal','true');
    /* v243: so a flecha (o texto saiu) — e esse botao e' do APP; quem abre
       o link de fora (lojista) nunca ve essa barra.
       v362 (pedido): a flecha virou X. A pagina publica se comporta como uma
       tela POR CIMA do app, e o X diz "fecho isto e volto pra onde eu estava"
       — que e' exatamente o que ele faz (no caso da avaliacao, volta pra
       pagina de avaliacao; o destino ja vinha certo no rotulo `voltar`). */
    var compartilhar=(o.compartilhar&&o.compartilhar.url)?'<button type="button" id="mevPublicoCompartilhar" aria-label="Compartilhar esta apresentação" title="Compartilhar esta apresentação"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="m7.5 7.5 4.5-4.5 4.5 4.5"/><path d="M6 11H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1"/></svg></button>':'';
    p.innerHTML='<div class="mev-publico-bar">'+compartilhar+'<button type="button" id="mevPublicoFechar" aria-label="'+esc(voltar)+'" title="'+esc(voltar)+'">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div>'+
      /* v426 (pedido): "quando abrir o catalogo em qualquer lugar do app
         coloque a animacao tambem" — o MESMO anel da abertura cobre o visor
         enquanto a página pública carrega (catálogo, vitrine, anúncio,
         página do lojista...). Some quando o iframe termina; se a rede
         enrolar muito, um limite de 12s tira o pano pra não prender ninguém
         (o X da barra fica por cima o tempo todo, sempre dá pra sair). */
      '<div class="mev-publico-load">'+pgLoad('Abrindo '+(titulo?(titulo.charAt(0).toLowerCase()+titulo.slice(1)):'a página')+'…')+'</div>'+
      '<iframe src="'+esc(url)+'" title="'+esc(titulo)+'"></iframe>';
    document.body.appendChild(p); document.body.classList.add('publico-aberto');
    document.body.style.position='fixed';document.body.style.top=-_publicoScroll+'px';document.body.style.width='100%';
    document.addEventListener('keydown',_publicoTecla);
    var b=$('mevPublicoFechar'); if(b) b.onclick=_publicoFechar;
    var s=$('mevPublicoCompartilhar'); if(s) s.onclick=function(){ _publicoCompartilhar(o.compartilhar); };
    if(b)b.focus();
    function _pubLoadSome(){ try{ var ld=p.querySelector('.mev-publico-load'); if(ld) ld.remove(); }catch(_){} }
    setTimeout(_pubLoadSome, 12000);
    p._mevLoadSome=_pubLoadSome;
    /* v264: quando o catálogo aberto é o DA SUA LOJA, o app avisa a página e
       ela libera "Marcar vendido" e "Excluir" em cada carro. Guardo o aviso
       aqui porque a página pode ainda estar carregando — ela pede de volta
       assim que fica pronta (mensagem "mev-cat-pronto"). */
    p._mevDono = !!o.dono;
    p._mevContexto = String(o.contexto||'');
    try{ var fr=p.querySelector('iframe'); if(fr) fr.onload=function(){ _publicoDonoAvisa(); _pubLoadSome(); }; }catch(_){}
  }
  function _publicoDonoAvisa(){
    var p=$('mevPublicoViewer'); if(!p) return;
    try{ var fr=p.querySelector('iframe'); if(fr&&fr.contentWindow) fr.contentWindow.postMessage({type:'mev-cat-dono', ok:!!p._mevDono}, location.origin); }catch(_){}
    try{
      var fr2=p.querySelector('iframe');
      if(fr2&&fr2.contentWindow&&p._mevContexto){
        var extras=[];
        if(p._mevContexto==='avaliacoes'&&typeof vitRepCotandoDados==='function') extras=vitRepCotandoDados();
        fr2.contentWindow.postMessage({type:'mev-repasse-contexto', contexto:p._mevContexto, cotando:extras}, location.origin);
      }
    }catch(_){}
  }
  window.addEventListener('message',function(e){
    if(e.origin!==location.origin || !e.data) return;
    if(e.data.type==='mev-fechar-publico') _publicoFechar();
    if(e.data.type==='mev-repasse-cotando-abrir'){
      var placa=String(e.data.placa||'');
      _publicoFechar();
      if(placa&&typeof avlAbrir==='function') avlAbrir(placa);
    }
    if(e.data.type==='mev-cat-pronto') _publicoDonoAvisa();          /* v264 */
    if(e.data.type==='mev-cat-acao') _catalogoAcaoDono(e.data);       /* v264 */
    if(e.data.type==='mev-catalogo-voltar'){
      if($('mevPublicoViewer')){ _publicoFechar(); return; }
      if($('ljCatFrame')){
        _ljTab=document.querySelector('#ljTabs [data-step="dados"]')?'dados':'loja';
        ljTabAplica(); window.scrollTo(0,0);
      }
    }
  });
  /* ===== v264 — MARCAR VENDIDO / EXCLUIR DIRETO NO CATÁLOGO (pedido) ========
     Quem grava é o APP, nunca a página: aqui existe a sessão do usuário, e o
     banco ainda confere por conta própria (a linha só muda se o user_id for o
     seu). Por isso o botão do catálogo é só um recado — não um atalho pro
     banco. Depois de gravar, o catálogo recarrega sozinho pra sumir o carro. */
  async function _catalogoAcaoDono(msg){
    var p=$('mevPublicoViewer');
    if(!p || !p._mevDono) return;                 /* não é o dono: ignora */
    if(!meuId){ toast('Faça login pra alterar o veículo.'); return; }
    var id=String((msg&&msg.id)||'').trim(); if(!id) return;
    var nome=String((msg&&msg.nome)||'este veículo');
    var acao=String((msg&&msg.acao)||'');
    if(acao==='excluir'){
      if(!confirm('Excluir '+nome+' do estoque?\n\nEle sai do catálogo, da sua lista e do Portal do Repasse.')) return;
      try{
        /* v333: guardo a placa ANTES de apagar — depois da exclusão ela some
           da lista e eu não teria como achar o anúncio do repasse. */
        var _vAlvo=(_estoque||[]).filter(function(x){ return String(x.id)===id; })[0]||null;
        var d=await supa.from('estoque').delete().eq('id',id).eq('user_id',meuId).select('id');
        estConfereGravou(d,'_catalogoAcaoDono (excluir)',1);   /* v782: DELETE barrado por RLS também volta "sucesso" com zero linhas */
        if(d&&d.error) throw d.error;
        _estoque=(_estoque||[]).filter(function(x){ return String(x.id)!==id; });
        var _nR=await estRepasseTirarDoAr(_vAlvo&&_vAlvo.placa);
        toast(_nR?'Veículo excluído — e o anúncio saiu do Portal do Repasse.':'Veículo excluído.');
      }catch(e2){ toast('Não consegui excluir. '+((e2&&e2.message)||'')); return; }
    } else if(acao==='vendido'){
      if(!confirm('Marcar '+nome+' como VENDIDO?\n\nEle sai do catálogo público e do Portal do Repasse.')) return;
      try{
        var _vVend=(_estoque||[]).filter(function(x){ return String(x.id)===id; })[0]||null;
        var u=await supa.from('estoque').update({status:'vendido'}).eq('id',id).eq('user_id',meuId).select('id');
        estConfereGravou(u,'_catalogoAcaoDono',1);   /* v782 */
        (_estoque||[]).forEach(function(x){ if(String(x.id)===id) x.status='vendido'; });
        var _nV=await estRepasseMarcarVendido(_vVend&&_vVend.placa);   /* v334 */
        toast(_nV?'Vendido — e o anúncio saiu do Portal do Repasse.':'Marcado como vendido.');
      }catch(e3){ toast('Não consegui marcar. '+((e3&&e3.message)||'')); return; }
    } else return;
    /* recarrega o catálogo dentro do visor pra ele já refletir a mudança */
    try{ var fr=p.querySelector('iframe'); if(fr) fr.src=fr.src; }catch(_){}
    try{ estPinta((($('estBusca')||{}).value)||''); }catch(_){}
  }
  /* gera o link do catálogo público (página web com os veículos disponíveis) e compartilha */
  /* v316 (pedido): atalho do catálogo na PÁGINA INICIAL (chip no cabeçalho).
     Nao exige o estoque carregado: monta a URL com o slug/uid e abre. */
  function homeCatalogoAbrir(){
    if(!meuId){ toast('Entre na sua conta pra abrir o catálogo.'); return; }
    var _ap=(typeof _lojaRec!=='undefined'&&_lojaRec&&_lojaRec.slug)?String(_lojaRec.slug):'';
    var _uid=(typeof _lojaRec!=='undefined'&&_lojaRec&&_lojaRec.user_id)||meuId;
    var url=_ap?(location.origin+'/'+_ap):(location.origin+'/catalogo/'+_uid);
    _preAquece(url); toast('Abrindo o catálogo…');
    _publicoAbrir(url,{titulo:'Catálogo da loja',voltar:'Voltar ao app',dono:true});
  }
  /* v948 — visor público do MEV Avaliações. `dono:false` é a diferença
     decisiva: a página não recebe o sinal que libera Marcar vendido/Excluir.
     Os links são os mesmos endereços públicos canônicos da Minha loja. */
  function avaliaVitrinePublicaAbrir(tipo){
    if(!meuId){ toast('Entre na sua conta para abrir a vitrine.'); return; }
    var links;
    try{ links=(typeof ljLinks==='function')?ljLinks(_lojaRec):null; }catch(_){ links=null; }
    if(!links){
      var ap=String((_lojaRec&&_lojaRec.slug)||'').trim();
      links=ap?{cat:location.origin+'/'+ap,rep:location.origin+'/'+ap+'/repasses'}:
               {cat:location.origin+'/catalogo/'+meuId,rep:location.origin+'/repasses/'+meuId};
    }
    var rep=tipo==='repasse', url=rep?links.rep:links.cat;
    _preAquece(url); toast(rep?'Abrindo o portal do repasse…':'Abrindo o catálogo…');
    _publicoAbrir(url,{titulo:rep?'Catálogo de repasses':'Catálogo do estoque',voltar:'Voltar às avaliações',dono:false,contexto:rep?'avaliacoes':''});
  }
  try{ var _bctTopo=document.getElementById('btnCatalogoTopo'); if(_bctTopo) _bctTopo.onclick=homeCatalogoAbrir; }catch(_){}
  /* v320: atalho pra pagina inicial do site (a vitrine publica) */
  try{ var _bstTopo=document.getElementById('btnSiteTopo'); if(_bstTopo) _bstTopo.onclick=function(){ window.open(MEV_SITE+'/','_blank','noopener'); }; }catch(_){}
  function estCatalogoAbrir(){
    var disp=(_estoque||[]).filter(function(v){ return v.status==='disponivel'; });
    if(!disp.length){ toast('Cadastre ve\u00edculos dispon\u00edveis primeiro pra montar o cat\u00e1logo.'); return; }
    if(!meuId){ toast('Fa\u00e7a login pra gerar o cat\u00e1logo.'); return; }
    /* v180: abre DIRETO a p\u00e1gina do cat\u00e1logo (antes abria uma janelinha
       s\u00f3 pra mostrar o link). Compartilhar continua na pr\u00f3pria p\u00e1gina. */
    /* v187: usa o endereço curto (mevveiculos.com.br/santaluziaveiculos) quando
       a loja já tem apelido; senão continua com o link antigo. */
    var _ap=(_lojaRec&&_lojaRec.slug)?String(_lojaRec.slug):'';
    var _uid=(_lojaRec&&_lojaRec.user_id)||meuId;
    var url=_ap?(location.origin+'/'+_ap):(location.origin+'/catalogo/'+_uid);
    _preAquece(url); toast('Abrindo o cat\u00e1logo\u2026');
    /* v264: é o SEU catálogo — libera "Marcar vendido" e "Excluir" nos cards */
    _publicoAbrir(url,{titulo:'Catálogo da loja',voltar:'Voltar ao app',dono:true});
  }
  var EST_STATUS={disponivel:{t:'Disponível',c:'#16a34a',bg:'#f0fdf4',bd:'#bbf7d0'},reservado:{t:'Reservado',c:'#b45309',bg:'#fffbeb',bd:'#fde68a'},vendido:{t:'Vendido',c:'#64748b',bg:'#f1f5f9',bd:'#e2e8f0'}};
  /* ---- v170: DINHEIRO COM CENTAVOS -----------------------------------------
     Antes o app so' trabalhava com reais inteiros ("R$ 15.864"). Agora todo
     campo de dinheiro da ficha do veiculo / pos-venda / nova venda usa o
     formato brasileiro completo: R$ 15.864,00 — e da' pra digitar centavos.
     COMO A DIGITACAO FUNCIONA: o campo le SO os numeros que voce digita e trata
     os 2 ultimos como centavos. Digitou 123456 -> vira R$ 1.234,56.
     COMPATIBILIDADE: o que ja' estava salvo era numero inteiro de REAIS (15864)
     e continua valendo 15864 — muda so' a forma de MOSTRAR e de DIGITAR. ---- */
  function _r2(n){ n=Number(n)||0; return Math.round(n*100)/100; }
  /* sempre com centavos — usado nos campos e nos totais de custos */
  function _rsF(v){ return 'R$ '+_r2(v).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  /* mostra centavos SO' quando existem (cartoes e listas ficam curtinhos) */
  function estMoney(v){ if(v==null||v==='') return ''; var n=Number(v); if(!n) return ''; var d=(Math.round(Math.abs(n)*100)%100)?2:0; return 'R$ '+n.toLocaleString('pt-BR',{minimumFractionDigits:d,maximumFractionDigits:d}); }
  /* le um campo de numero inteiro (quilometragem, por exemplo) */
  function estNum(id){ var e=$(id); return e?(parseInt(String(e.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0):0; }
  /* le um campo de DINHEIRO: os 2 ultimos digitos sao os centavos.
     ---- v283: O BUG DE 100x ----------------------------------------------
     Aqui existia um .replace(/,\d{1,2}\s*$/,'') ANTES do .replace(/\D/g,'').
     Ele apagava os centavos e, logo depois, o /100 cortava de novo:
        "R$ 59.519,00"  ->  tira ",00"  ->  "59519"  ->  /100  ->  595,19
     Ou seja, TODO campo de dinheiro ja' preenchido era lido 100x menor.
     Naquele trecho a intencao era outra: nos campos de REAIS INTEIROS
     (estNum, estMaskRSint, os campos pr* da proposta) jogar fora um ",50"
     digitado sem querer — la' ele continua e esta' certo. Aqui, onde os dois
     ultimos digitos SAO os centavos, ele destruia o valor. */
  function _rsLer(s){ var d=String(s==null?'':s).replace(/\D/g,''); return d?(parseInt(d,10)/100):0; }
  function estRS(id){ var e=$(id); return e?_rsLer(e.value):0; }
  function estMaskRS(){ var n=String(this.value).replace(/\D/g,'').replace(/^0+(?=\d)/,'').slice(0,12); this.value=n?_rsF(parseInt(n,10)/100):''; }
  /* mascara ANTIGA (reais inteiros) — telas que ainda leem o valor sem centavos
     (funil do CRM, ficha de venda e a proposta impressa) */
  function estMaskRSint(){ var n=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); this.value=n?('R$ '+Number(n).toLocaleString('pt-BR')):''; }
  function estMaskKM(){ var n=String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); this.value=n?Number(n).toLocaleString('pt-BR'):''; }
  function estHoje(){ try{ return new Date().toISOString().slice(0,10); }catch(_){ return ''; } }
  function estDias(v){ var d=(v&&(v.data_entrada||v.criado_em))||null; if(!d) return null; try{ var t=new Date(d).getTime(); if(!t) return null; var dias=Math.floor((Date.now()-t)/864e5); return dias<0?0:dias; }catch(_){ return null; } }
  /* ============== v193 — DE ONDE VEIO O CARRO ==============
     Ate' agora o MEV so' sabia se um carro estava PUBLICADO no Portal do
     Repasse. Ele nao sabia de ONDE o carro veio. E isso quebrava todo
     relatorio financeiro, porque um carro CONSIGNADO nao e' da loja: quem
     vende recebe o dinheiro inteiro, mas a maior parte dele e' do dono do
     carro. Se o sistema soma esse valor como faturamento, o lucro sai
     inflado e voce toma decisao em cima de um numero que nao existe.

     Sao tres origens:
       proprio     -> a loja comprou. Entra o valor cheio da venda.
       consignado  -> o carro e' de outra pessoa. Entra SO' a comissao da loja
                      (uma % sobre a venda) e o custo de compra vira ZERO,
                      porque a loja nao pagou nada pelo carro.
       repasse     -> comprei de outro lojista. Na conta funciona igual ao
                      proprio (voce pagou por ele).

     Todas as contas do app passaram a chamar duas funcoezinhas:
       _ogReceita(...)  -> quanto DAQUELE valor de venda entra na loja
       _ogCompra(...)   -> quanto a loja pagou pelo carro
     Assim eu nao repeti a regra em seis lugares diferentes: se um dia mudar,
     muda so' aqui. */
  var _OG_LISTA=[
    ['proprio','Próprio','A loja comprou o carro.'],
    ['consignado','Consignado','O carro é de outra pessoa. A loja fica só com a comissão.'],
    ['repasse','Repasse','Comprei de outro lojista. Na conta, funciona igual ao próprio.']
  ];
  /* quanto desse valor de venda ENTRA na loja */
  function _ogReceita(og, pct, valor){
    valor=Number(valor)||0;
    if(String(og||'')!=='consignado') return valor;
    return _r2(valor*(Number(pct)||0)/100);
  }
  /* quanto a loja pagou pelo carro (no consignado ela nao pagou nada) */
  function _ogCompra(og, compra){ return (String(og||'')==='consignado')?0:(Number(compra)||0); }
  /* as duas de cima lendo o veiculo SALVO no banco */
  function _ogRecV(v, valor){ v=v||{}; return _ogReceita(v.origem, v.consig_pct, valor); }
  function _ogCompraV(v){ v=v||{}; return _ogCompra(v.origem, v.preco_compra); }
  /* e lendo a FICHA que esta aberta na tela */
  function _ogTela(){ var h=$('efOrigem'); return { og:(h&&h.value)||'proprio', pct:parseFloat(String((($('efConsigPct')||{}).value)||'').replace(',','.'))||0 }; }
  function _ogRecT(valor){ var o=_ogTela(); return _ogReceita(o.og,o.pct,valor); }
  function _ogCompraT(){ var o=_ogTela(); return _ogCompra(o.og, estRS('efCompra')); }
  /* liga os botoes de origem e mostra/esconde os campos do consignante */
  function estOrigemAplica(){
    var h=$('efOrigem'); if(!h) return;
    var og=String(h.value||'proprio'), cons=(og==='consignado');
    try{ Array.prototype.forEach.call(document.querySelectorAll('#efOgChips .ef-og-chip'),function(b){ b.classList.toggle('on', b.getAttribute('data-og')===og); }); }catch(_){}
    var w=$('efConsigWrap'); if(w) w.style.display=cons?'block':'none';
    var cr=$('efCompraRow'); if(cr) cr.style.display=cons?'none':'';
    var cv=$('efConsigVal'); if(cv){ var b=estRS('efAnuncio')||estRS('efMin'); cv.textContent=_rsF(_ogRecT(b)); }
    estMargemCalc();
    try{ estPosVendaCalc(); }catch(_){}
  }
  function estOrigemWire(){
    try{ Array.prototype.forEach.call(document.querySelectorAll('#efOgChips .ef-og-chip'),function(b){
      b.onclick=function(){ var h=$('efOrigem'); if(h) h.value=b.getAttribute('data-og')||'proprio'; estOrigemAplica(); try{ estAgendaSalvar(); }catch(_){} };
    }); }catch(_){}
    var p=$('efConsigPct'); if(p) p.oninput=function(){ this.value=String(this.value||'').replace(/[^0-9.,]/g,'').slice(0,5); estOrigemAplica(); try{ estAgendaSalvar(); }catch(_){} };
    ['efConsigNome','efConsigFone'].forEach(function(id){ var e=$(id); if(e) e.oninput=function(){ try{ estAgendaSalvar(); }catch(_){} }; });
    estOrigemAplica();
  }
  /* soma todos os custos de preparação (comissão % sobre o mínimo + itens) */
  function estCustosTotal(){
    var min=estRS('efMin'), compra=_ogCompraT();
    /* v193: no consignado, o que entra na loja e' so' a comissao — entao a
       comissao do vendedor e o imposto sao calculados em cima DELA. */
    var recMin=_ogRecT(min);
    var comPct=parseFloat(String((($('ecComPct')||{}).value)||'').replace(',','.'))||0;
    var com=_r2(recMin*comPct/100);
    var cv=$('ecComVal'); if(cv) cv.textContent=_rsF(com);
    /* soma dos custos SEM o imposto NF (o NF pode depender da margem, então entra depois) */
    var base=_r2(com+estRS('ecHig')+estRS('ecPol')+estRS('ecFun')+estRS('ecPneus')+estRS('ecMec')+estRS('ecDoc')+_ecOutrosSomaDom());
    /* Imposto NF: % sobre a MARGEM (antes do NF) ou sobre o VALOR DE VENDA (anúncio) */
    var nfPct=parseFloat(String((($('ecNfPct')||{}).value)||'').replace(',','.'))||0;
    var nfBase=String((($('ecNfBase')||{}).value)||'margem');
    var baseVal = (nfBase==='venda') ? _ogRecT(estRS('efAnuncio')) : Math.max(0, _r2(recMin - compra - base));
    var nf = _r2(baseVal*nfPct/100);
    var nfv=$('ecNfVal'); if(nfv) nfv.textContent=_rsF(nf);
    var soma=_r2(base+nf);
    var tv=$('ecTotal'); if(tv) tv.textContent=_rsF(soma);
    var tg=$('ecTotalGeral'); if(tg){ tg.textContent=_rsF(compra+soma); }
    return soma;
  }
  /* margem calculada EM RELAÇÃO AO PREÇO MÍNIMO: mínimo − (custo de compra + custos de preparação) */
  function estMargemCalc(){
    var min=estRS('efMin'), compra=_ogCompraT(), custos=estCustosTotal(), el=$('efMargem'); if(!el) return;
    var og=_ogTela().og, rec=_ogRecT(min);
    var invest=_r2(compra+custos);
    if(!rec || (og!=='consignado' && !invest)){ el.value=''; el.style.color='#0f172a'; return; }
    var m=_r2(rec-invest);
    var pct = invest ? (' · '+(m>=0?'+':'−')+Math.round(Math.abs(m)/invest*100)+'%') : '';
    el.value=(m>=0?'':'−')+(estMoney(Math.abs(m))||'R$ 0')+pct;
    el.style.color=m>=0?'#16a34a':'#dc2626';
  }
  /* Ícones compartilhados pelos cards do Estoque e da vitrine de Vendas. */
  var _EST_ICO_KM=_cIco('<path d="M12 2v4"/><path d="m16.2 7.8 2.9-2.9"/><path d="M18 12h4"/><path d="M12 12l3-6"/><path d="M3.3 17a10 10 0 1 1 17.4 0"/>');
  var _EST_ICO_COR=_cIco('<circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>');

  /* v217 — Estoque voltou a ser um destino do menu principal, imediatamente
     abaixo de Minha loja. A tela continua reutilizando a mesma lista, filtros,
     ficha e ações; só não fica mais comprimida dentro do menu interno da loja. */
  async function telaEstoque(){
    /* v452: o teto de veículos só existe se o app souber qual é o plano, e
       quem sabe isso é o /api/cobranca. Peço aqui, sem esperar: a tela abre
       na hora e a resposta chega muito antes de alguém tocar em "Novo
       veículo". Se não chegar, `planoLimiteVeiculos()` devolve null e nada
       trava — cliente pagante não fica preso por tropeço de rede. */
    try{ if(typeof _assinatura!=='undefined' && !_assinatura && typeof assinaturaCarregar==='function') assinaturaCarregar(); }catch(_){}
    mevTabSet('');
    document.body.classList.add('venda-cot');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg cad-float"><div class="lj-est-panel" id="estTelaPainel">'+ljEstoqueHtml()+'</div></div>';
    $('telaHome').style.display='none';
    document.body.classList.add('tela-interna');

    /* 🔴 v795 — A MARCA VEM AQUI, DEPOIS DE A TELA ESTAR MONTADA, e não no
       começo da função. O mevTabSet() e o irTela() rodam no meio do caminho e
       LIMPAM as classes de página (é o trabalho deles: sair de uma tela apaga
       a marca da anterior). Marcar antes deles era marcar e perder — medido:
       as cinco telas ficavam sem `oper-on` e sem dock, com o código todo
       "certo". Ver o changelog da v795. */
    document.body.classList.add('oper-on');
    try{ consultaUiDockMedir(); }catch(_){ }
    /* v795 FASE B: o CTA do cabeçalho vai pro mesmo lugar que o + ia. */
    try{ var _add=$('estAddCta'); if(_add) _add.onclick=function(){
      if(typeof estFabMenu==='function') estFabMenu(_add); else estAbrirFicha(null); }; }catch(_){ }
    document.body.classList.remove('md-veiculo');
    $('cardVeiculo').style.display='block';
    window.scrollTo(0,0);
    fabFoto(false);
    _cadWireBack();
    voltarTab(voltarHome);
    try{ await lojaGet(); }catch(_){}
    await ljEstoqueAtivar();
  }
  function ljEstoqueHtml(){
    return '<div class="est-main lj-est-main vv-pg">'+
      /* v400 (pedido): saiu o botão "Abrir catálogo" — o Catálogo agora tem
         item próprio no menu (v396). estCatalogoAbrir continua existindo. */
      /* 🔴 v795 FASE B (§4.3 do PROJETO-2026-08-31-shell-desktop-padronizado):
         "Estoque: `Adicionar veículo` com ícone +, em botão com texto".
         O + era o FAB de ações (btnAcaoFab), pendurado na NAVEGAÇÃO GLOBAL —
         e é o único caso, entre as cinco telas, em que a barra global
         carregava uma ação de uma página só.
         ⚠️ ISTO NÃO É COSMÉTICO. O dock da fase A esconde tudo o que não é
         um dos quatro destinos globais; sem trazer o + pra cá, adicionar
         veículo ficaria INALCANÇÁVEL no computador. Foi o teste-v795 que
         pegou — as outras quatro telas não ligam ação nenhuma no FAB, o
         Estoque liga.
         Mesmo destino de sempre (estFabMenu), agora com nome escrito. */
      '<div class="est-head vv-top est-stock-head"><div><h2>Estoque</h2></div>'+
        '<button type="button" class="est-add-cta" id="estRefreshCta">Atualizar</button>'+
        '<button type="button" class="est-add-cta" id="estImportCta">Importar anúncio</button>'+
        '<button type="button" class="est-add-cta" id="estAddCta">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'+
          'Adicionar veículo</button>'+
        /* v1102 — "Linha 0 km" (14o-): só pro admin; gancho de uma linha, como o do 14m- */
        (function(){ try{ return (typeof lzBotaoHtml==='function') ? lzBotaoHtml() : ''; }catch(_){ return ''; } })()+
      '</div>'+
      '<div class="vv-tools"><div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="estBusca" aria-label="Buscar placa ou modelo" placeholder="Buscar placa ou modelo" autocomplete="off"></div></div></div>'+
      '<div class="est-filtros" id="estFiltros"></div>'+
      '<p id="estSync" class="cad-hint" role="status">Carregando veículos…</p>'+
      '<div id="estLista">'+pgLoad('Abrindo o seu estoque…')+'</div>'+   /* v424: anel da abertura */
    '</div>';
  }
  async function ljEstoqueAtivar(){
    var painel=document.querySelector('#estTelaPainel, #ljBody .vpx-panel[data-panel="estoque"]');
    if(!painel) return;
    mevEstNovo(true);
    var importer=$('estImportCta');if(importer)importer.onclick=function(){estFabMenu(importer);};var busca=$('estBusca'), cat=$('estCatBtn'),refresh=$('estRefreshCta');if(refresh)refresh.onclick=async function(){if(this.disabled)return;this.disabled=true;this.textContent='Atualizando…';try{await estCarregar();estPinta((($('estBusca')||{}).value)||'');}finally{this.disabled=false;this.textContent='Atualizar';}};
    if(cat && !cat.getAttribute('data-wire')){ cat.setAttribute('data-wire','1'); cat.onclick=estCatalogoAbrir; }
    try{ if(typeof lzWire==='function') lzWire(); }catch(_){}   /* v1102 — Linha 0 km (14o-) */
    if(busca && !busca.getAttribute('data-wire')){ busca.setAttribute('data-wire','1'); busca.oninput=function(){ estPinta(this.value); }; }
    if(!_estErro&&_estListaAtualizada&&Date.now()-_estListaAtualizada<60000){ estPinta((busca&&busca.value)||'');var sync=$('estSync');if(sync)sync.textContent='Última atualização: '+new Date(_estListaAtualizada).toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit',timeZone:'America/Sao_Paulo'});return; }
    painel.setAttribute('data-carregado','1');
    await estCarregar();
    estPinta((busca&&busca.value)||'');
    /* v183: se o cadastro não tem foto, aproveita as fotos já publicadas no
       Portal do Repasse e atualiza a mesma lista desta aba. */
    try{ estFotosBackfill().then(function(m){ if(m && $('estLista')) estPinta((($('estBusca')||{}).value)||''); }); }catch(_){ }
  }
  /* ⛳ v785 — O SINCRONISMO COM O PORTAL DO REPASSE E A LISTA "NEGOCIANDO"
     MUDARAM DE ARQUIVO: agora moram em src/app/14i-negociando.js.
     Nenhuma linha de lógica mudou — foi recortar e colar. O que ficou AQUI é
     o que a lista do estoque usa direto: estRepNegociando, estRepSituacao,
     estRepDe, estEhRepasse, estRepBadge e este _estPl.
     👉 Procurando estRepasseCarregar, estPintaNegociando, estNegAcaoExec ou
        os selos do portal? MAPA-GERADO.md → 14i-negociando.js. */
  function _estPl(p){ return String(p||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  /* ==========================================================================
     🔴 v782 — O GRAVAR QUE CONFERE
     (PROJETO-2026-08-30-a-divida-do-14-estoque · fase 4)
     --------------------------------------------------------------------------
     A regra está no CLAUDE.md desde a v483, e nasceu de um defeito real (o
     vendedor "alterava" o endereço do site do dono só na tela):

       UPDATE (ou DELETE) barrado por RLS **NÃO é erro no supabase-js** —
       volta "sucesso" com ZERO linhas.

     Até a v781 este módulo tinha NOVE updates e TRÊS deletes, e nenhum pedia
     a linha de volta. Todos podiam mentir: o app pintava a tela com o valor
     novo, escrevia "✓ Salvo", e o banco ficava com o antigo.

     QUANTO DISSO ERA PERIGOSO (lido no pg_policies em 30/08, não chutado):
       mp_estoque  SELECT: user_id in (mp_app_colegas())
       mp_estoque  UPDATE: user_id in (mp_app_colegas())   ← IGUAIS
       mp_repasse  SELECT: (ativo = true) OR (user_id = auth.uid())
       mp_repasse  UPDATE: user_id = auth.uid()            ← DIFERENTES
     No estoque, ler e gravar usam a mesma régua — o risco hoje é menor do que
     parece. Mas basta a `mp_app_colegas()` mudar (um vendedor que sai do
     grupo, uma loja que se separa) pra tela passar a mentir, e ninguém vai
     desconfiar do 14-estoque.
     No REPASSE a assimetria JÁ EXISTE: você enxerga o anúncio ativo de
     QUALQUER lojista, mas só pode alterar o seu. É a v483 esperando acontecer
     de novo. As três funções de repasse daqui filtram por user_id antes de
     gravar — mas por sorte de construção, não por conferência.

     ESTE AJUDANTE É A CONFERÊNCIA, em um lugar só. Ele NÃO muda o que a RLS
     decide: só se recusa a acreditar sem prova.
     ⚠️ `esperadas` é quantas linhas o chamador queria mexer. Se voltarem
     MENOS (mexeu em 3, voltaram 2), o app não trava — a parte que passou
     valeu — mas o caso vai pro mp_erros, porque é exatamente o cheiro de
     "uma dessas linhas não é sua".
     ========================================================================== */
  function estConfereGravou(r, onde, esperadas){
    if(r && r.error) throw r.error;
    var n=(r && r.data && r.data.length) || 0;
    if(!n){
      var _e=new Error('Sem permissão para alterar este registro.');
      _e.semPermissao=true;   /* quem trata sabe que NÃO adianta tentar de novo */
      throw _e;
    }
    if(esperadas && n<esperadas){
      try{ window.mevErro && window.mevErro(
        new Error('gravou '+n+' de '+esperadas+' linha(s)'), onde||'estConfereGravou'); }catch(_){}
    }
    return n;
  }
  /* Anunciados no Portal que NÃO existem no estoque — é a lista "Negociando".
     Publicar no repasse sai da Avaliação, então esses carros nunca chegaram a
     virar cadastro de estoque e ficavam invisíveis nesta tela. */
  function estRepNegociando(){
    var noEstoque={};
    (_estoque||[]).forEach(function(v){ var p=_estPl(v.placa); if(p) noEstoque[p]=1; });
    return (_estRepLinhas||[]).filter(function(r){
      var p=_estPl(r.placa);
      return !!p && !noEstoque[p];
    });
  }
  function estRepSituacao(r){
    var s=String((r&&r.situacao)||'').toLowerCase();
    if(s==='reservado'||s==='vendido'||s==='disponivel') return s;
    return (r&&r.vendido)?'vendido':'disponivel';   /* dados antigos, sem a coluna nova */
  }
  function estRepDe(v){ return _estRepPlacas[String((v&&v.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'')]||null; }
  /* Um preço preenchido na ficha já define que o veículo é de repasse para
     fins de identificação e filtro. Isso é independente de `origem`, que
     continua indicando como a loja adquiriu o carro e alimenta os cálculos. */
  function estPrecoRepasse(v){ return Number((v&&v.extras&&v.extras.preco_repasse)||0)||0; }
  function estRepBadge(v){
    var r=estRepDe(v), temPreco=estPrecoRepasse(v)>0;
    if(!r && !temPreco) return '';
    if(r&&r.ativo) return '<span class="est-rep" title="Publicado no Portal do Repasse">'+ICO_REPMINI+'Repasse</span>';
    if(temPreco) return '<span class="est-rep" title="Preço de repasse definido">'+ICO_REPMINI+'Repasse</span>';
    return '<span class="est-rep off" title="Já esteve no Portal do Repasse">'+ICO_REPMINI+'Repasse · fora do ar</span>';
  }
  function estFotosDe(v){
    if(v&&v.fotos&&v.fotos.length) return v.fotos;
    var r=estRepDe(v); return (r&&r.fotos&&r.fotos.length)?r.fotos:null;
  }
  /* v776 — "este carro mostra foto?" numa pergunta só. É a regra do CARD
     (cadastro, e se vazio o anúncio do repasse) — usada pelo filtro novo
     "Sem foto" e pela contagem dele. ⚠️ NÃO carrega foto nenhuma: só olha
     se a lista existe. */
  function estTemFoto(v){ var f=estFotosDe(v); return !!(f && f.length); }
  /* v776 — a porta de fora pra abrir o Estoque JÁ FILTRADO (o clique do bloco
     "Pendências de hoje" da home usa esta). O filtro fica VISÍVEL no seletor,
     como qualquer outro — não é um truque escondido só pra esse clique. */
  function estAbrirFiltro(f){ _estFiltro=String(f||''); return telaEstoque(); }
  /* ===== v396 — FOTO DO CARD PELO REDIMENSIONADOR DO NETLIFY ==============
     O bug: "algumas imagens do estoque estão cortando o carregamento" — a
     foto aparecia só uma tira em cima. São fotos GRANDES (importadas de
     anúncio, 3–4 mil px): o iPhone corta a decodificação quando muitas
     brigam pela memória, e sobra a tira. Conserto: o card pede a foto já
     REDUZIDA (w=800) pelo /.netlify/images — o mesmo redimensionador da
     capa do WhatsApp (netlify.toml [images] já libera o nosso Supabase).
     Se o redimensionador falhar, o data-orig devolve a foto original
     (fiação do erro em estStripsWire — sem onerror inline por causa do CSP). */
  /* v1061: 2 hosts (o do Angelo e o da Cotação). 1 de 6 — ver _fotos-cdn.js. */
  var _IMG_CDN_OK=/^https:\/\/(oeirfkxwwjqkqfpwhvra\.supabase\.co\/storage\/v1\/object\/public\/|mevtools\.netlify\.app\/)/;
  /* ===== v583 — ESTA FUNÇÃO VIROU A REGRA DA CASA, NÃO SÓ DO ESTOQUE ======
     Ela nasceu na v396 pra consertar a foto cortada do card. Só que o que ela
     faz de verdade é maior: a foto passa a ser servida pela NETLIFY, que a
     guarda no cache dela pra sempre. O Supabase entrega a foto UMA vez, na
     primeira pessoa que olhar; da segunda em diante ele nem fica sabendo.
     🔴 É por isso que ela é o conserto da conta de egress: 906 arquivos, 295 MB
     guardados, ~7 GB de tráfego por mês — cada foto baixada umas 24 vezes.
     Não é foto demais; é a MESMA foto, de novo e de novo, direto da fonte.
     ⚠️ Ela é segura por construção: só mexe em URL pública do NOSSO Supabase.
     data:, blob:, bucket privado, outro site — tudo passa intacto. Por isso dá
     pra aplicar em qualquer lugar sem conferir a origem antes.
     ⚠️ E o try/catch não é medo: esta função é chamada de módulos que rodam
     ANTES deste no arquivo montado. Se um dia a ordem mudar, a foto sai
     grande — nunca a tela quebra. */
  /* 🔴 03/09 — A FOTO QUE NÃO APARECIA NO CARD DA AVALIAÇÃO.
     O card mostrava "1/7" e um retângulo VAZIO. As 7 fotos existiam no
     storage (conferido), a lista chegava certa — o que quebrava era o
     `String(u)` da linha de baixo.

     Duas formas de foto convivem no app:
       · ESTOQUE e REPASSE guardam a URL como TEXTO      → "https://…"
       · a AVALIAÇÃO guarda como OBJETO no payload       → {"url":"https://…"}

     O card de Avaliações prefere as fotos da própria avaliação (05c, "a foto
     que o vendedor tirou daquele carro naquele dia") — ou seja, entrega os
     OBJETOS aqui. `String({url:…})` vira a string "[object Object]", que não
     passa no _IMG_CDN_OK, sai inteira no src e o navegador não carrega nada.
     Sem erro no console, sem alerta: só o quadrado cinza.

     ✅ Resolver AQUI, e não no card, cobre todo mundo de uma vez — imgCdn é
     o funil por onde passa toda foto do app. */
  function _imgUrlDe(x){
    if(x && typeof x === 'object') return String(x.url || x.src || x.href || x.u || '');
    return String(x == null ? '' : x);
  }
  function imgCdn(u,w){
    try{
      u=_imgUrlDe(u);
      if(!_IMG_CDN_OK.test(u)) return u;               /* data:, blob:, outro host: fica como está */
      if(location.hostname==='localhost'||location.hostname==='127.0.0.1') return u;
      return '/.netlify/images?url='+encodeURIComponent(u)+'&w='+(w||800)+'&q=75';
    }catch(_){ return String(u||''); }
  }
  /* o mesmo, pra quem pinta a foto como FUNDO (style.backgroundImage) — onde o
     loading="lazy" não alcança, porque não existe <img> nenhum. */
  function imgFundo(u,w){ return 'url('+imgCdn(u,w)+')'; }
  function _imgCdnAttr(u,w,extra){
    u=_imgUrlDe(u);   /* 03/09: aceita {url:…} igual ao imgCdn — ver a nota lá em cima */
    var leve=imgCdn(u,w);
    return (extra||'')+' src="'+esc(leve)+'"'+(leve!==u?(' data-orig="'+esc(u)+'"'):'');
  }
  /* v400: o miolo do estThumb virou função própria (recebe a LISTA de fotos)
     pra página Repasse usar a mesma tira deslizável nos cards do portal. */
  function estThumbFotos(f,nome){
    if(!f||!f.length) return '<div class="est-thumb no">'+ICO_EST+'</div>';
    /* v313 (pedido): as fotos deslizam no proprio card, como na v312 dos
       parceiros. Uma foto so' continua imagem simples — nao ha o que deslizar. */
    if(f.length===1) return '<div class="est-thumb"><img loading="lazy" decoding="async"'+_imgCdnAttr(f[0],800)+' alt="'+esc(nome)+'"></div>';
    var vis=f.slice(0,8);
    return '<div class="est-thumb"><div class="est-th-strip" data-est-strip>'+
      vis.map(function(u,i){
        return '<img'+(i?' loading="lazy"':'')+' decoding="async"'+_imgCdnAttr(u,800)+' alt="'+esc(nome)+' — foto '+(i+1)+'">';
      }).join('')+'</div>'+
      '<span class="est-thumb-count" data-est-count>1/'+vis.length+'</span></div>';
  }
  function estThumb(v){
    var f=estFotosDe(v);
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
    if(!f||!f.length) return '<div class="est-thumb no">'+ICO_EST+'</div>';
    /* v1216 — o card do ESTOQUE é a capa, não uma segunda galeria.

       O banco já devolve a capa em `fotos[0]`. Mesmo assim, a tira horizontal
       podia reaparecer no slide em que o Safari tinha parado (por exemplo,
       uma foto do banco do motorista). O registro estava certo e o card
       parecia errado. Aqui exibimos somente a primeira foto. A galeria
       completa continua na aba Fotos e na página pública do veículo. */
    return '<div class="est-thumb est-capa-auto" data-est-capa>'+
      '<img class="est-capa-bg" loading="lazy" decoding="async"'+_imgCdnAttr(f[0],800)+' alt="" aria-hidden="true">'+
      '<img class="est-capa-main" loading="lazy" decoding="async"'+_imgCdnAttr(f[0],800)+' alt="'+esc(nome)+' — foto de capa">'+
      (f.length>1?('<span class="est-thumb-count">'+f.length+' fotos</span>'):'')+
      '</div>';
  }
  /* v396: a fiação das tiras de foto saiu do miolo do estPinta pra cá, pra
     valer também na página Vendas (que agora usa o MESMO card do estoque) e
     na página Repasse. Faz três coisas: contador 1/N no deslize, arraste não
     abre o menu por engano (trava de 8px, v313) e — novo — se a foto
     reduzida falhar, volta pra original (data-orig). */
  function estStripsWire(el){
    if(!el) return;
    Array.prototype.forEach.call(el.querySelectorAll('img[data-orig]'),function(im){
      im.addEventListener('error',function(){
        var o=im.getAttribute('data-orig');
        if(o && im.src.indexOf('/.netlify/images')>=0){ im.removeAttribute('data-orig'); im.src=o; }
      });
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-est-strip]'),function(tr){
      var box=tr.closest('.est-thumb');
      var cnt=box?box.querySelector('[data-est-count]'):null;
      var n=tr.children.length;
      /* v1202 — o navegador pode restaurar a rolagem horizontal da tira ao
         voltar da ficha. A lista sempre abre na foto 1, que e' a CAPA. */
      function voltaPraCapa(){ tr.scrollLeft=0; if(cnt) cnt.textContent='1/'+n; }
      voltaPraCapa(); requestAnimationFrame(voltaPraCapa);
      tr.addEventListener('scroll',function(){ requestAnimationFrame(function(){
        var ix=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));
        if(cnt) cnt.textContent=(Math.min(n,ix+1))+'/'+n;
      }); },{passive:true});
      var x0=0,y0=0,mexeu=false;
      tr.addEventListener('touchstart',function(ev){ if(!ev.touches||ev.touches.length!==1) return; x0=ev.touches[0].clientX; y0=ev.touches[0].clientY; mexeu=false; },{passive:true});
      tr.addEventListener('touchmove',function(ev){ if(!ev.touches||!ev.touches.length) return;
        if(Math.abs(ev.touches[0].clientX-x0)>8||Math.abs(ev.touches[0].clientY-y0)>8) mexeu=true; },{passive:true});
      tr.addEventListener('click',function(ev){ if(mexeu){ ev.preventDefault(); ev.stopPropagation(); mexeu=false; } },true);
    });
  }
  /* Galerias de fotos públicas: a capa abre imediatamente e só a foto
     seguinte é baixada por antecipação. As demais aguardam o deslize. */
  function fotosGaleriaImg(f,i,alt){
    var src=esc(f), primeiro=i===0;
    return '<img class="clic" data-i="'+i+'" '+(primeiro?('src="'+src+'" fetchpriority="high"'):('data-src="'+src+'" loading="lazy"'))+' decoding="async" alt="'+esc(alt||('foto '+(i+1)))+'">';
  }
  function fotosGaleriaPreparar(tr,atual){
    if(!tr) return;
    atual=Math.max(0,Number(atual)||0);
    Array.prototype.forEach.call(tr.querySelectorAll('img[data-src]'),function(im){
      var i=Number(im.getAttribute('data-i'));
      if(Math.abs(i-atual)>1) return;
      var src=im.getAttribute('data-src'); if(!src) return;
      im.src=src; im.removeAttribute('data-src');
    });
  }
  /* Conserto de verdade (nao so' visual): copia as fotos do anuncio do repasse
     pra dentro do cadastro do estoque. Assim elas aparecem tambem no catalogo,
     na pagina do veiculo e na venda. Roda uma vez, em silencio. */
  var _estBackfillFeito=false;
  async function estFotosBackfill(){
    if(_estBackfillFeito) return false; _estBackfillFeito=true;
    var alvo=[];
    (_estoque||[]).forEach(function(v){
      if(v.fotos&&v.fotos.length) return;
      var r=estRepDe(v); if(r&&r.fotos&&r.fotos.length) alvo.push({v:v,f:r.fotos.slice(0,10)});
    });
    if(!alvo.length) return false;
    var mudou=false;
    for(var i=0;i<alvo.length;i++){
      try{
        var up=await supa.from('estoque').update({fotos:alvo[i].f, atualizado_em:new Date().toISOString()}).eq('id',alvo[i].v.id).select('id');
        /* v782: só marca na tela o que o BANCO devolveu. Antes bastava não dar
           erro — e um update barrado por RLS não dá erro nenhum: o card
           passava a mostrar a foto do anúncio como se ela tivesse entrado no
           cadastro, e ela não tinha. */
        estConfereGravou(up,'estFotosBackfill',1);
        alvo[i].v.fotos=alvo[i].f; mudou=true;
      }catch(e){ try{ window.mevErro && window.mevErro(e,'estFotosBackfill'); }catch(_){} }
    }
    return mudou;
  }
  /* ---- v183: PRE-AQUECER A PAGINA PUBLICA ----------------------------------
     As paginas /v/<id>, /catalogo/<id> e /repasses/<id> sao geradas no
     servidor. Quando ninguem entra nelas ha algum tempo, o servidor precisa
     "acordar" (cold start) e ai o toque em Compartilhar parece travado.
     Solucao: no instante em que o menu abre, eu ja peco a pagina de fininho.
     Quando voce toca em Compartilhar, ela ja esta pronta no cache. ---- */
  var _preAqueceUlt={};
  function _preAquece(url){
    try{
      if(!url) return;
      var ag=Date.now(); if(_preAqueceUlt[url] && (ag-_preAqueceUlt[url])<45000) return;
      _preAqueceUlt[url]=ag;
      try{ var l=document.createElement('link'); l.rel='prefetch'; l.as='document'; l.href=url; document.head.appendChild(l); setTimeout(function(){ try{ l.parentNode.removeChild(l); }catch(_){} },30000); }catch(_){}
      try{ var _p=fetch(url,{mode:'no-cors',credentials:'omit'}); if(_p&&_p.catch) _p.catch(function(){}); }catch(_){}
    }catch(_){ }
  }
  async function estCarregar(){
    _estErro=false;
    var _pRep=estRepasseCarregar();                       /* v183: em paralelo, nao atrasa a lista */
    /* 🔴 v781 — O SELECT DA LISTA DEIXOU DE SER '*' PRA NÃO TRAZER A FICHA.
       Medido no Postgres de produção em 30/08: o JSON completo desta consulta
       são 180.575 bytes, e 74.572 deles são a chave `ficha_tec` dentro do
       `extras` — 41% de tudo que a tela Estoque baixa, pra mostrar uma lista
       que não exibe ficha nenhuma. Sem ela: 107.714 bytes.
       A ficha virou COLUNA PRÓPRIA (mp_estoque.ficha_tec) e esta lista NÃO a
       pede. Quando o lojista abre um carro, a ficha DAQUELE carro é buscada
       sozinha (ver o estAbrirFicha).
       ⚠️ `extras` CONTINUA na lista de propósito: NOVE módulos além deste leem
       `.extras` direto das linhas que esta função trouxe (12f, 14f, 14b, 14d,
       15, 15c, 17, 18). Tirar o extras inteiro seria mais 57 KB e é projeto
       PRÓPRIO, pra outro dia — não este.
       ⚠️⚠️ ESTA LISTA É TODAS AS COLUNAS DA mp_estoque MENOS ficha_tec.
       Coluna nova na tabela = uma palavra AQUI também, senão o app deixa de
       enxergá-la em silêncio. (O que o projeto sugeria estava incompleto:
       faltavam ano_modelo, origem, consig_nome, consig_fone, consig_pct e
       pos_venda — todas lidas por este módulo.) */
    var EST_COLS='id,user_id,placa,marca,modelo,ano,cor,km,combustivel,fipe,'+
      'preco_minimo,preco_anuncio,status,fotos,obs,criado_em,atualizado_em,'+
      'preco_compra,data_entrada,custos,extras,pos_venda,ano_modelo,origem,'+
      'consig_nome,consig_fone,consig_pct';
    try{ var r=await withTimeout(supa.from('estoque').select(EST_COLS).order('criado_em',{ascending:false}),9000); if(r&&r.error)throw r.error;_estoque=(r&&r.data)||[]; }
    catch(e){ _estErro=true; }
    Promise.resolve(_pRep).then(function(){if($('estLista'))estPinta((($('estBusca')||{}).value)||'');}).catch(function(){});
    var sync=$('estSync');if(!_estErro){_estListaAtualizada=Date.now();if(sync)sync.textContent='Última atualização: '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit',timeZone:'America/Sao_Paulo'});}else if(sync)sync.textContent='Não foi possível atualizar. '+(_estoque.length?'Exibindo a última lista carregada.':'Tente novamente.');
  }
  /* "Repasse" não é um status do veículo. Ele vale para os carros publicados
     no Portal e também para aqueles com preço de repasse já preenchido. */
  function estEhRepasse(v){ var r=estRepDe(v); return !!((r&&r.ativo)||estPrecoRepasse(v)>0); }
  function estFiltrosHtml(){
    var box=$('estFiltros'); if(!box) return;
    var counts={todos:_estoque.length,disponivel:0,reservado:0,vendido:0,repasse:0,loja:0,semfoto:0};
    _estoque.forEach(function(v){
      if(counts[v.status]!=null) counts[v.status]++;
      if(estEhRepasse(v)) counts.repasse++; else counts.loja++;
      /* v776: "sem foto" pela MESMA regra do card — estFotosDe olha o cadastro
         e, se ele estiver vazio, as fotos do anúncio do repasse (v183). Um
         carro que já mostra foto no card NUNCA pode contar como sem foto. */
      if(!estTemFoto(v)) counts.semfoto++;
    });
    var negoc=estRepNegociando().length;
    var opts=[
      ['disponivel','Disponíveis ('+counts.disponivel+')'],
      ['reservado','Reservados ('+counts.reservado+')'],
      ['vendido','Vendidos ('+counts.vendido+')'],
      ['loja','Veículos da loja ('+counts.loja+')'],
      ['repasse','No repasse ('+counts.repasse+')'],
      ['negociando','Negociando (repasse) ('+negoc+')'],
      /* v776 — o filtro "Sem foto". Ele nasceu pro clique do bloco
         "Pendências de hoje" da home, mas nasce como filtro DE VERDADE: uma
         opção visível no mesmo seletor, que a pessoa desliga trocando de
         opção. Filtro invisível confunde — quem chega numa lista curta sem
         entender por que o resto sumiu acha que o app apagou os carros. */
      ['semfoto','Sem foto ('+counts.semfoto+')'],
      ['','Todos ('+counts.todos+')']
    ];
    /* v369 (pedido): ORDENAR na mesma linha do filtro, como no catálogo.
       Os dois viram uma linha só de flex — a situação à esquerda (é o que
       você troca mais) e a ordem à direita. O HTML dos selects não mudou:
       só ganharam um pai. A lista de ordens mora no 14b. */
    box.innerHTML='<div class="est-fline">'+
      '<select class="est-fsel" id="estFsel">'+opts.map(function(o){ return '<option value="'+o[0]+'"'+(_estFiltro===o[0]?' selected':'')+'>'+esc(o[1])+'</option>'; }).join('')+'</select>'+
      estOrdenaSelectHtml()+
      '</div>';
    var s=$('estFsel'); if(s) s.onchange=function(){ _estFiltro=this.value; estPinta((($('estBusca')||{}).value)||''); };
    var so=$('estOsel'); if(so) so.onchange=function(){ estOrdenaGravar(this.value); estPinta((($('estBusca')||{}).value)||''); };
  }

  function estResumoHtml(){
    var ativos=_estoque.filter(function(v){ return v.status!=='vendido'; });
    var totalVal=ativos.reduce(function(s,v){ return s+Number(v.preco_anuncio||v.preco_minimo||0); },0);
    var p30=ativos.filter(function(v){ var d=estDias(v); return d!=null&&d>=30; }).length;
    var p60=ativos.filter(function(v){ var d=estDias(v); return d!=null&&d>=60; }).length;
    return '<div class="est-resumo">'+
      '<div class="er-cell"><span class="er-n">'+_estoque.length+'</span><span class="er-l">no estoque</span></div>'+
      '<div class="er-cell"><span class="er-n">'+(estMoney(totalVal)||'R$ 0')+'</span><span class="er-l">valor total</span></div>'+
      '<div class="er-cell"><span class="er-n'+(p30?' warn':'')+'">'+p30+'</span><span class="er-l">parados +30d'+(p60?(' · '+p60+' +60d'):'')+'</span></div>'+
    '</div>';
  }
  /* ===== v301 (pedido) — OS DOIS ÍCONES NO CARD, IGUAL À PÁGINA DA WEB =====
     No site, cada carro tem o WhatsApp e o compartilhar no canto da foto, e
     dá pra mandar o veículo pro cliente sem abrir nada. No estoque isso
     estava três toques longe: tocar no card, esperar o menu, achar
     "Compartilhar". Agora é um toque.

     Os dois NÃO fazem a mesma coisa:
       WhatsApp  → vai DIRETO pro WhatsApp escolher o contato.
       Compartilhar → abre a bandeja do celular (Instagram, e-mail, copiar
                      link) e, quando dá, manda a FOTO junto com o texto.

     Os dois mandam a mesma mensagem de sempre (estVeicMsg) com o link da
     página pública — que não tem preço de compra, preço mínimo, custo nem
     margem. O ícone é atalho pro que já existia, não uma porta nova. */
  var _EST_SVG_WA='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.15.16-.29.18-.53.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.44.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.65.31-.22.25-.85.83-.85 2.03s.87 2.35.99 2.51c.12.16 1.71 2.61 4.15 3.66.58.25 1.03.4 1.39.51.58.19 1.11.16 1.53.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29z"/></svg>';
  var _EST_SVG_SHARE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5v11"/><path d="m8 7.2 4-3.7 4 3.7"/><path d="M5.5 13v6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-6"/></svg>';
  function estIconesHtml(v){
    if(!v || !v.id) return '';                 /* sem ficha salva não há link */
    var nm=esc(((v.marca||'')+' '+(v.modelo||'')).trim()||'este veículo');
    return '<span class="est-ics">'+
      /* v346: o livrinho vem PRIMEIRO (à esquerda do WhatsApp) — é a ação de
         CONFERIR, e conferir vem antes de mandar pro cliente. */
      '<button type="button" class="est-ic est-ic-cat" data-ic="cat" title="Ver a página do veículo" aria-label="Ver a página de '+nm+' no catálogo">'+ICO_CATALOGO+'</button>'+
      '<button type="button" class="est-ic est-ic-wa" data-ic="wa" title="Mandar no WhatsApp" aria-label="Mandar '+nm+' no WhatsApp">'+_EST_SVG_WA+'</button>'+
      '<button type="button" class="est-ic est-ic-share" data-ic="share" title="Compartilhar" aria-label="Compartilhar '+nm+'">'+_EST_SVG_SHARE+'</button>'+
      '</span>';
  }
  function estWhatsAppDireto(v){
    var txt=estVeicMsg(v);
    /* _blank pode ser bloqueado como popup quando o clique demora a virar
       navegação; por isso o location.href de reserva. */
    /* v370: no celular isto TROCA pro WhatsApp em vez de abrir uma aba
       escondida atrás do app. Ver mevIrProWhats, no 14b. */
    mevIrProWhats('https://wa.me/?text='+encodeURIComponent(txt));
  }
  /* Liga os dois ícones de TODOS os cards de uma lista.
     O stopPropagation é o que impede o menu de ações de abrir junto: o card
     inteiro também é clicável, e sem isto cada toque no ícone abriria a
     bandeja E o menu por cima dela. */
  function estIconesWire(el){
    Array.prototype.forEach.call(el.querySelectorAll('.est-ic'),function(b){
      b.onclick=function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var card=b.closest('.est-card'); if(!card) return;
        var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(card.getAttribute('data-id')); })[0];
        if(!v) return;
        var _k=b.getAttribute('data-ic');
        if(_k==='cat') estAbrirNoCatalogo(v);          /* v346 */
        else if(_k==='wa') estWhatsAppDireto(v);
        else estCompartilhar(v);
      };
    });
  }

  function estPinta(termo){
    estFiltrosHtml();
    var el=$('estLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    if(_estFiltro==='negociando'){ estPintaNegociando(el, termo); return; }   /* v260 */
    if(!_estoque.length && _estErro){ el.innerHTML='<div class="cli-empty"><b>Não consegui carregar agora</b>Verifique sua internet e tente de novo.<button type="button" id="estRetry" style="margin-top:12px;background:#0a4da6;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">Tentar de novo</button></div>'; var rb=$('estRetry'); if(rb) rb.onclick=async function(){ el.innerHTML=pgLoad('Tentando de novo…'); await estCarregar(); estPinta((($('estBusca')||{}).value)||''); }; return; }   /* v424: anel também no "Tentar de novo" */
    if(!_estoque.length){ el.innerHTML='<div class="cli-empty"><b>Nenhum veículo no estoque</b>Toque em "+ Novo" para cadastrar, ou adicione a partir de uma consulta.</div>'; return; }
    var lista=_estoque.filter(function(v){
      if(_estFiltro==='repasse'){ if(!estEhRepasse(v)) return false; }
      else if(_estFiltro==='loja'){ if(estEhRepasse(v)) return false; }
      else if(_estFiltro==='semfoto'){ if(estTemFoto(v)) return false; }   /* v776 */
      else if(_estFiltro && (v.status||'disponivel')!==_estFiltro) return false;
      if(!termo) return true;
      return (String(v.placa||'').toLowerCase().indexOf(termo)>=0) || (((v.marca||'')+' '+(v.modelo||'')).toLowerCase().indexOf(termo)>=0);
    });
    /* v316 (pedido): o resumo (N no estoque / valor total / parados +30d) saiu
       da lista. A funcao estResumoHtml fica — pra voltar, e' recolocar a chamada. */
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado.</div>'; return; }
    try{ lista=estOrdenarLista(lista); }catch(_){}      /* v369 — a ordem escolhida */
    el.innerHTML=lista.map(function(v){
      var st=EST_STATUS[v.status]||EST_STATUS.disponivel;
      var foto=estThumb(v);                              /* v183: se o cadastro nao tem foto, usa a do anuncio do repasse */
      var repBadge=estRepBadge(v);                       /* v183: selo "Repasse" */
      var preco=v.preco_anuncio?estMoney(v.preco_anuncio):(v.preco_minimo?('mín. '+estMoney(v.preco_minimo)):'');
      var rotPreco='Preço de venda';
      if(estEhRepasse(v)&&estPrecoRepasse(v)>0){preco=estMoney(estPrecoRepasse(v));rotPreco='Preço de repasse';}
      var dias=estDias(v);
      var diasTxt = (dias!=null && v.status!=='vendido') ? ('<span class="est-dias'+(dias>=60?' d60':(dias>=30?' d30':''))+'">'+dias+' dia'+(dias===1?'':'s')+' parado</span>') : '';
      /* v193 — selo de ORIGEM e margem pela regra certa: no consignado a
         margem nao e' anuncio menos compra, e' a comissao da loja. */
      var ogK=String(v.origem||'proprio');
      var ogTxt = (ogK==='consignado') ? '<span class="est-og">Consignado</span>' : '';
      var mgTxt='', temBase = (ogK==='consignado') ? (Number(v.consig_pct)>0) : !!v.preco_compra;
      if(temBase && v.preco_anuncio){ var mm=_r2(_ogRecV(v,Number(v.preco_anuncio))-_ogCompraV(v)); mgTxt='<span class="est-mg" style="color:'+(mm>=0?'#166534':'#b91c1c')+';background:'+(mm>=0?'#dcfce7':'#fee2e2')+'">margem '+(mm>=0?'':'−')+estMoney(Math.abs(mm))+'</span>'; }
      /* 🔴🔴 v1091 — A ETIQUETA DE 0 KM (pedido do Angelo, 19/09:
         "os novos ganham uma etiqueta de zero km").

         Até aqui o card de um carro novo dizia "Sem placa · 2027 · Branca" e
         mais nada — nada na lista contava que era ZERO QUILÔMETRO. O dado
         existia desde a v1052, gravado em `extras.zero_km`; o que faltava era
         ele APARECER.

         ⚠️ ELA VEM PRIMEIRO NA FILEIRA, antes de Repasse, Consignado, dias
         parado e margem. Num carro novo, "0 km" é a informação que muda o
         que todas as outras querem dizer: "1 dia parado" num 0 km é normal,
         num seminovo de 2019 é outra conversa.

         ⚠️ E ELA LÊ O DADO, NÃO ADIVINHA. Deduzir "0 km" de `km === 0` seria
         pôr a etiqueta em todo seminovo cadastrado sem quilometragem — uma
         afirmação falsa numa lista que o Angelo usa pra negociar. Só o
         interruptor do cadastro decide. */
      var zkTxt=''; try{ if((v.extras||{}).zero_km) zkTxt='<span class="est-zk">0 KM</span>'; }catch(_){}
      var meta = (zkTxt||repBadge||ogTxt||diasTxt||mgTxt) ? ('<div class="est-meta">'+zkTxt+repBadge+ogTxt+diasTxt+mgTxt+'</div>') : '';
      var ano=_efAnoTxt(v), dados=[];
      if(ano) dados.push('<span>'+_ICO_CAL+esc(ano)+'</span>');
      if(v.km) dados.push('<span>'+_EST_ICO_KM+Number(v.km).toLocaleString('pt-BR')+' km</span>');
      if(v.cor) dados.push('<span>'+_EST_ICO_COR+esc(v.cor)+'</span>');
      return '<div class="est-card est-vv-card" data-id="'+esc(v.id)+'">'+foto+
        '<div class="est-tx"><div class="est-nm">'+esc(estNomeComercial(v))+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.ano?' · '+esc(v.ano):'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':'')+'</div>'+
        '<div class="est-card-placa">'+esc(v.placa||'Sem placa')+'</div>'+
        (dados.length?('<div class="est-card-dados">'+dados.join('')+'</div>'):'')+
        '<div class="est-stock-prices"><div><small>FIPE</small><strong>'+esc(Number(v.fipe)>0?estMoney(v.fipe):'—')+'</strong></div><div><small>'+rotPreco+'</small><strong class="est-preco">'+esc(preco||'—')+'</strong></div></div>'+
        '<div class="est-row"><span class="est-badge" style="color:'+st.c+';background:'+st.bg+';border-color:'+st.bd+'">'+st.t+'</span></div>'+meta+
        '<div class="est-stock-actions"><button type="button" class="est-open" data-est-open="'+esc(v.id)+'">Ver detalhes '+_icoChev+'</button>'+estIconesHtml(v)+'</div></div>'+
        '<div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    /* v180: um TOQUE simples no card ja' abre o menu de acoes (antes era
       pressionar e segurar, e tinha uma animacao ensinando isso). Editar a
       ficha virou uma opcao DENTRO do menu. */
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      var id=card.getAttribute('data-id');
      card.onclick=function(){ estAcoesAbrir(id, card); };
    });
    estIconesWire(el);   /* v301: WhatsApp e compartilhar no canto do card */
    Array.prototype.forEach.call(el.querySelectorAll('[data-est-open]'),function(b){b.onclick=function(e){e.stopPropagation();estVerDetalhes(b.getAttribute('data-est-open'));};});
    Array.prototype.slice.call(el.querySelectorAll('.est-capa-main'),0,4).forEach(function(img,i){img.loading='eager';if(!i)img.fetchPriority='high';});
    estStripsWire(el);   /* v313/v396: contador do deslize + trava de arraste + foto reserva */
  }
  function estImportModalAbrir(){
    var bg=cliModalEl(); bg.classList.add('on'); cliModalDel(null);
    var av=$('cliMav'); if(av) av.innerHTML=mkIco('link',20);
    var tt=$('cliMt'); if(tt) tt.textContent='Importar anúncio';
    var body=$('cliMbody'); if(!body) return;
    body.innerHTML=
      '<p class="est-import-modal-note">Cole o link do anúncio. O veículo será aberto para você conferir enquanto os dados, as fotos e a ficha técnica são importados.</p>'+
      '<label class="cad-lbl" for="estFabImportUrl">Link do anúncio</label>'+
      '<input class="cad-in" id="estFabImportUrl" type="url" inputmode="url" autocomplete="off" placeholder="https://...">'+
      '<div class="cad-msg" id="estFabImportMsg"></div>'+
      '<button type="button" class="cad-btn ico" id="estFabImportGo">'+mkIco('link',17)+'Importar do link</button>';
    var go=$('estFabImportGo'), inp=$('estFabImportUrl'), msg=$('estFabImportMsg');
    function seguirComoCarro(url){
      cliModalFechar();
      estAbrirFicha(null);
      var destino=$('efImportUrl'); if(destino) destino.value=url;
      estImportarAnuncio();
    }
    async function iniciar(){
      var url=String((inp&&inp.value)||'').trim();
      if(!url){ if(msg){ msg.className='cad-msg err'; msg.textContent='Cole o link do anúncio para importar.'; } if(inp) inp.focus(); return; }
      if(!/^https?:\/\//i.test(url)){ url='https://'+url; if(inp) inp.value=url; }
      /* 🔴🔴 v654 — ANTES DE COBRAR, O APP PERGUNTA O QUE É O LINK.
         Colar o endereço da BUSCA da loja (aquela tela com 34 carros) importava
         o PRIMEIRO da lista, calado, cobrando 1 token. Esta olhada é DE GRAÇA:
         se for a lista, abre o buscador; se for um carro, segue igual.
         ⚠️ E se a olhada não responder (servidor antigo, internet ruim), o
         caminho de sempre continua — a novidade não pode barrar o que já
         funcionava. */
      if(go) go.disabled=true;
      if(msg){ msg.className='cad-msg load'; msg.textContent='Vendo o que tem nesse link…'; }
      var olhada=null;
      try{ olhada=await apiComTimeout('/api/importar-anuncio',{url:url, so_olhar:true},45000); }catch(_){ }
      if(go) go.disabled=false;
      if(msg){ msg.className='cad-msg'; msg.textContent=''; }
      if(olhada && olhada.ok && olhada.tipo==='lista' && olhada.lista
         && olhada.lista.itens && olhada.lista.itens.length){
        estBuscadorAbrir(olhada.lista, olhada.origem, url);
        return;
      }
      seguirComoCarro(url);
    }
    if(go) go.onclick=iniciar;
    if(inp){ inp.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); iniciar(); } }); setTimeout(function(){ try{ inp.focus(); }catch(_){} },80); }
  }
  /* ⛳ v787 — O BUSCADOR DE PÁGINA (v654) MUDOU DE ARQUIVO: agora mora em
     src/app/14k-buscador-pagina.js. Nenhuma linha de lógica mudou — foi
     recortar e colar. Quem ABRE ele continua aqui: é o estImportarAnuncio,
     quando a olhada de graça descobre que o link é uma LISTA e não um carro.
     👉 Procurando estBuscadorAbrir, estBuscadorPinta ou estBuscadorConfirmar?
        MAPA-GERADO.md → 14k-buscador-pagina.js. */
  /* menu do FAB + no Estoque: novo veículo sempre; compartilhar/excluir quando há ficha aberta */
  function estFabMenu(anchorEl){
    var IC={
      novo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      importar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1"/><path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1"/></svg>',
      share:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>',
      del:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
      venda:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
    };
    var v=_estEditId?(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0]:null;
    /* v827 — DUAS PORTAS PRA IMPORTAR, porque tem duas realidades:
       o anúncio COM link (o de sempre) e o anúncio que só existe em print
       (Instagram, story, WhatsApp). Veja src/app/14l-importar-print.js. */
    var itens=[['novo',IC.novo,'Adicionar um novo veículo',''],
               ['importar',IC.importar,'Importar do link',''],
               ['importar_print',ICO_PRINT_ANUNCIO,'Importar de um print · '+precoReal(1),'']];
    /* v301 — ESTA LINHA É O QUE FALTAVA PRA PODER TIRAR "VENDAS" DO MENU.
       A tela de Vendas tinha um botão que a lista do estoque não tem:
       "+ Veículo fora do estoque" — a venda de um carro que a loja não
       cadastrou (encomenda, carro de terceiro). Se eu só escondesse o menu,
       esse caminho sumiria em silêncio e o Angelo ia descobrir na hora que
       precisasse. Ele vem junto, aqui. */
    itens.push(['venda_fora',IC.venda,'Venda de veículo fora do estoque','']);
    if(v){ itens.push(['share',IC.share,'Compartilhar','']); itens.push(['excluir',IC.del,'Excluir','danger']); }
    var head=v?('<div class="act-head"><div class="ah-nm">'+esc(estNomeComercial(v))+'</div><div class="ah-pl">'+esc(v.placa||'')+'</div></div>'):'';
    if(v&&v.id) _preAquece(_publicoVeiculoUrl(v));   /* v183 */
    _popAbrir(head, itens, anchorEl, function(k){
      actSheetFechar();
      if(k==='novo'){ estAbrirFicha(null); return; }
      if(k==='importar'){ estImportModalAbrir(); return; }
      if(k==='importar_print'){ estImportarPrint(); return; }   /* v827 */
      if(k==='venda_fora'){ vendaNovaAbrir(null); return; }   /* v301 */
      if(!v) return;
      if(k==='share'){ estCompartilhar(v); return; }
      if(k==='excluir'){ estApagar(_estEditId); return; }
    });
  }
  function estAcoesAbrir(id, anchorEl){
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!v) return;
    var st=v.status||'disponivel';
    var IC={
      share:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>',
      res:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4z"/></svg>',
      sold:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
      avail:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
      del:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
      edit:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
      aval:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 13l2 2 4-4"/></svg>',
      venda:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
      cat:ICO_CATALOGO,  /* v337: o mesmo livrinho do botão "Abrir catálogo" */
      cli:ICO_CLI,       /* v342: o bonequinho do CRM */
      post:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
      dl:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>',  /* v467 */
      avisa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>',   /* v514 */
      /* v656 — a arte. Desenho de linha, como o resto do menu (nada de emoji). */
      arte:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15l-1.9-4.1L5.5 9l4.6-1.4z"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z"/></svg>',
      /* v847 — a seta que gira: "buscar de novo o preço". Desenho de linha,
         como o resto do menu. */
      fipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><polyline points="21 3 21 9 15 9"/></svg>'
    };
    var itens=[];
    /* ===== v301 (pedido) — INICIAR VENDA SAI DAQUI =====
       A tela "Vendas" era, palavra por palavra, "Escolha um veículo para
       iniciar a negociação": uma SEGUNDA lista do estoque, só pra escolher o
       carro. Duas listas do mesmo estoque, cada uma com sua busca e seus
       filtros, e o Angelo tinha que lembrar por qual das duas entrar.

       Agora a venda começa de onde o carro já está. Vem PRIMEIRO na lista
       porque é a ação que fecha negócio — as outras arrumam cadastro.

       Carro já vendido não abre venda nova: a própria tela de Vendas também
       tirava os vendidos da lista. */
    if((v.status||'disponivel')!=='vendido') itens.push(['venda',IC.venda,'Iniciar venda','']);
    itens.push(['editar',IC.edit,'Editar no estoque','']);
    /* v264 (pedido): dá pra abrir a AVALIAÇÃO do carro direto daqui — mesmo
       quando ele já está reservado ou vendido. É lá que moram os custos, os
       serviços, as fotos e o preço de repasse; antes, pra mexer nisso, tinha
       que sair do estoque e achar a placa de novo. */
    if(v.placa) itens.push(['aval',IC.aval,'Editar na avaliação','']);
    /* ===== v337 (pedido) — VER NO CATÁLOGO =====
       Até aqui, pra saber como o carro estava aparecendo pro cliente, o
       caminho era: sair do card, tocar em "Abrir catálogo" no topo e procurar
       o carro no meio da lista. Ou tocar em Compartilhar e abrir o próprio
       link mandado. Agora é um toque: abre a MESMA página pública que o
       cliente vê (fotos, ficha, botão de WhatsApp), dentro do app, com a
       flecha de voltar. Preço de compra, preço mínimo, custos e margem não
       existem naquela página — quem monta ela nem recebe esses campos. */
    itens.push(['catalogo',IC.cat,'Ver no catálogo','']);
    /* 🔴 v823 (pedido do Angelo, com print) — TRÊS ITENS SAÍRAM DESTE MENU:
       'Clientes deste carro', 'Compartilhar' e 'Avisar lojistas'.
       O menu do card tinha 13 linhas e passava da altura da tela do celular
       — o 'Excluir', que é o item mais perigoso, ficava na dobra.
       ⛳ As três ROTAS CONTINUAM VIVAS no estAcaoExec logo abaixo, de
       propósito: notificação antiga, atalho salvo e link de push ainda
       apontam pra elas, e apagar a rota daria tela branca em quem tocasse
       num aviso de ontem (a lição da v526, do Chat). Só a LINHA do menu
       saiu. Pra trazer de volta, é uma linha aqui.
       · Clientes deste carro → continua abrindo pelo cdvAbrir(id)
       · Compartilhar         → a bandeja do celular, pelo estCompartilhar
       · Avisar lojistas      → a folha do 18f, pelo avisarLojistasAbrir
    */
    /* v1512: a ação fica sempre disponível. Se ainda não houver texto salvo,
       estCopiarPost monta o post factual com os dados atuais do veículo antes
       de copiar; assim o menu não muda de forma inesperada entre os carros. */
    itens.push(['post',IC.post,'Copiar post','']);
    /* v467: as fotos ORIGINAIS de volta pro aparelho (motor no 14g). Carro
       sem foto não mostra o item — menu com opção morta é pior que menu curto. */
    if((v.fotos||[]).length) itens.push(['fotos',IC.dl,'Baixar fotos ('+(v.fotos||[]).length+')','']);
    /* v656 — GERAR ARTE. Só aparece com foto: um item de menu que abre e diz
       "não dá" é pior que um menu curto (a mesma regra do "Baixar fotos" logo
       acima). E com o carro VENDIDO a arte já abre no selo de vendido — é o
       caso em que o lojista quer a peça. */
    /* 🔴 v823 — 'Gerar arte' passou a abrir o GERADOR NOVO (18h): a arte
       1080×1920 pro Status do WhatsApp, com FIPE e o % abaixo calculados.
       Ele não exige mais que o carro tenha foto no estoque, porque a foto
       boa é a que vem do celular na hora (o recorte do iPhone) — exigir
       foto salva escondia o item justamente de quem mais precisa dele.
       ⛳ ROLLBACK: trocar `arteAnuncioAbrir` por `arteAbrir` — a arte antiga
       (15c) continua inteira no código, nada foi apagado. */
    /* v835: a arte saiu do app — o interruptor mora no 00-edicoes
       (MEV_ARTE_VEICULO). A ROTA continua no estAcaoExec de propósito: ela é
       inalcançável sem este item, e apagá-la tornaria a volta uma reescrita. */
    if(typeof arteDisponivel!=='function' || arteDisponivel()) itens.push(['arte',IC.arte,'Gerar arte','']);
    /* ==========================================================================
       v847 (pedido do Angelo, com print) — ATUALIZAR FIPE
       --------------------------------------------------------------------------
       A tabela FIPE muda todo mês. O preço guardado no carro é do dia em que
       ele foi cadastrado, e ninguém volta na ficha de 29 carros pra conferir.
       Medido no estoque dele em 02/09: dos 29 disponíveis, 13 não tinham NENHUM
       mês de referência guardado, 6 estavam em julho e 9 em agosto. Ou seja: a
       maior parte do estoque negociava com um número velho.

       🔴 SÓ APARECE COM MARCA E MODELO. A busca precisa dos dois pra achar o
       carro na FIPE; sem eles o item abriria pra dizer "não consegui", que é a
       mesma regra do "Baixar fotos" e do "Copiar post" logo acima — menu com
       opção morta é pior que menu curto.
       ⚠️ E o item aparece TAMBÉM em carro vendido ou reservado, de propósito:
       é justamente quando se quer conferir se o preço fechado fazia sentido.
       ========================================================================== */
    if(v.marca && v.modelo) itens.push(['fipe',IC.fipe,'Atualizar FIPE','']);
    if(st!=='reservado') itens.push(['reservado',IC.res,'Marcar reservado','']);
    if(st!=='vendido') itens.push(['vendido',IC.sold,'Marcar vendido','']);
    if(st==='reservado'||st==='vendido') itens.push(['disponivel',IC.avail,'Marcar disponível','']);
    itens.push(['excluir',IC.del,'Excluir','danger']);
    var head='<div class="act-head"><div class="ah-nm">'+esc(estNomeComercial(v))+'</div><div class="ah-pl">'+esc(v.placa||'')+'</div></div>';
    _preAquece(_publicoVeiculoUrl(v));   /* v183: acorda a página antes de você tocar em Compartilhar */
    _popAbrir(head, itens, anchorEl, function(k){ estAcaoExec(id, k); });
  }
  async function estAcaoExec(id, key){
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!v) return;
    actSheetFechar();
    /* v301: leva pra proposta já com ESTE carro dentro — a mesma função que
       a tela de Vendas usava quando você tocava num card lá. */
    if(key==='venda'){ vendaIniciarComVeiculo(id); return; }
    if(key==='editar'){ estVerDetalhes(id,true); return; }
    /* v656 · 🔴 v823: o gerador novo (18h). Se ele não estiver carregado por
       algum motivo, a arte antiga atende — a rota nunca fica sem dono. */
    if(key==='arte'){
      if(typeof arteAnuncioAbrir==='function'){ arteAnuncioAbrir(v,'estoque'); return; }
      arteAbrir(v,'estoque'); return;
    }
    /* v264: abre a AVALIAÇÃO deste carro. Reaproveita o repEditarAval do
       portal, que já sabe achar a placa no histórico de consultas e, quando
       não acha, remonta o veículo com o que tem na mão. */
    if(key==='aval'){
      if(!v.placa){ toast('Este veículo está sem placa.'); return; }
      try{
        repEditarAval({ placa:v.placa, veiculo:{ marca:v.marca||'', modelo:v.modelo||'', ano:v.ano||'', ano_fab:v.ano||'', ano_modelo:v.ano_modelo||v.ano||'', cor:v.cor||'', combustivel:v.combustivel||'', fipe:v.fipe||'' } });
      }catch(_){ toast('Não consegui abrir a avaliação.'); }
      return;
    }
    /* v337: abre a página pública DESTE carro no visor de dentro do app.
       dono:true é o mesmo aviso do catálogo (v264) — se a página tiver os
       botões de dono, quem grava continua sendo o app, nunca a página.
       Reservado/vendido não aparece na LISTA do catálogo, mas a página do
       carro continua abrindo — por isso o aviso em vez de bloquear. */
    if(key==='catalogo'){
      var _uCat=_publicoVeiculoUrl(v);
      if(!_uCat){ toast('Salve o veículo antes de ver no catálogo.'); return; }
      _preAquece(_uCat);
      var _stCat=v.status||'disponivel';
      if(_stCat!=='disponivel') toast('Este veículo está '+(((EST_STATUS[_stCat]||{}).t)||'').toLowerCase()+' — ele não aparece na lista do catálogo.');
      else toast('Abrindo no catálogo\u2026');
      _publicoAbrir(_uCat,{titulo:'Veículo no catálogo',voltar:'Voltar ao estoque',dono:true});
      return;
    }
    /* ==========================================================================
       v847 — ATUALIZAR FIPE: pergunta, MOSTRA a diferença, e só grava se você
       mandar.
       --------------------------------------------------------------------------
       🔴 POR QUE NÃO GRAVA DIRETO. O preço da FIPE é a base de conversa da
       venda. Trocar o número sem mostrar seria mexer no argumento do Angelo
       pelas costas — ele precisa VER que caiu R$ 3.000 antes de aceitar, porque
       às vezes a resposta certa é "a FIPE caiu, meu preço não vai cair".

       🔴 E O GRAVAR CONFERE SE GRAVOU (regra da v483). Um UPDATE barrado pela
       RLS NÃO é erro no supabase-js: volta "sucesso" com ZERO linhas. Sem o
       `.select('id')` e a contagem, a tela mostraria o preço novo e o banco
       ficaria com o velho — e o Angelo negociaria com um número que só existe
       no celular dele. É exatamente o defeito da v483, e ele não vai se repetir
       aqui.
       ⚠️ A consulta à FIPE é PÚBLICA e não gasta token nenhum. Isso está dito
       no toast de propósito: item de menu que parece cobrar não é usado.
       ========================================================================== */
    if(key==='fipe'){
      (async function(){
        toast('Consultando a tabela FIPE… (sem cobrança)');
        var ops=null;
        try{
          ops=await fipeBuscaMelhor({
            marca:v.marca||'', modelo:v.modelo||'', modelo_base:v.modelo||'',
            versao:(v.versao||''), titulo:((v.marca||'')+' '+(v.modelo||'')).trim(),
            ano:v.ano||'', ano_modelo:v.ano_modelo||v.ano||'',
            combustivel:v.combustivel||''
          });
        }catch(e){
          toast('Não achei este carro na tabela FIPE. Abra a ficha e escolha a versão na mão.');
          return;
        }
        var o=(ops&&ops[0])||null;
        if(!o||!o.valor){ toast('A FIPE não devolveu preço pra este carro.'); return; }

        var antes=Number(v.fipe)||0, agora=Number(o.valor)||0;
        var mesAntes=((v.extras&&v.extras.fipe&&v.extras.fipe.mes_ref)||'').trim();
        var dif=agora-antes;
        /* 🔴 O CASO "NÃO MUDOU NADA" TEM QUE SER DITO. Sem esta saída, o
           Angelo tocaria, veria uma confirmação, aceitaria, e não entenderia
           por que o número continuou igual — e pensaria que não funcionou. */
        if(antes && Math.abs(dif) < 1){
          toast('A FIPE deste carro não mudou: '+brl(agora)+
                (o.mes_ref?(' ('+o.mes_ref+')'):''));
          return;
        }
        var linhas = [];
        linhas.push(((v.marca||'')+' '+(v.modelo||'')).trim());
        if(o.descricao) linhas.push('Versão: '+o.descricao);
        linhas.push('');
        linhas.push(antes ? ('FIPE guardada: '+brl(antes)+(mesAntes?(' ('+mesAntes+')'):' (sem mês)'))
                          : 'FIPE guardada: nenhuma');
        linhas.push('FIPE de agora:  '+brl(agora)+(o.mes_ref?(' ('+o.mes_ref+')'):''));
        if(antes) linhas.push((dif>0?'Subiu ':'Caiu ')+brl(Math.abs(dif)));
        linhas.push('');
        linhas.push('Atualizar o preço FIPE deste carro?');
        if(!confirm(linhas.join('\n'))) return;

        toast('Salvando…');
        var extrasNovo = Object.assign({}, (v.extras||{}));
        extrasNovo.fipe = { modelo:o.descricao||'', ano_modelo:o.ano||'',
                            combustivel:o.combustivel||'', valor:agora,
                            codigo_fipe:o.codigo_fipe||'', mes_ref:o.mes_ref||'' };
        try{
          var r=await supa.from('estoque')
                          .update({ fipe:agora, extras:extrasNovo,
                                    atualizado_em:new Date().toISOString() })
                          .eq('id', v.id)
                          .select('id');
          /* ⛳ v847 — o `estConfereGravou` da v782 é o guarda da casa pra isto:
             ele levanta erro quando o UPDATE volta "sucesso" com ZERO linhas,
             que é como a RLS barra sem avisar. Escrever a conferência de novo
             aqui seria a segunda cópia da mesma regra — e a segunda cópia é a
             que um dia esquece de ser atualizada. */
          estConfereGravou(r, 'estAcaoExec:fipe', 1);
        }catch(e){
          toast(e && e.semPermissao
                ? 'Você não tem permissão para alterar este veículo.'
                : ('Não consegui salvar: '+((e&&e.message)||'tente de novo')));
          return;
        }
        v.fipe=agora; v.extras=extrasNovo;
        /* v865 — se a ficha deste mesmo carro estiver aberta, a atualização
           aparece no campo FIPE; preço mínimo e anúncio permanecem intactos. */
        if(String(_estEditId||'')===String(v.id||'')){
          _estFipeEscolha=Object.assign({},extrasNovo.fipe);
          var _efFi=$('efFipe'); if(_efFi) _efFi.value=_rsF(agora);
        }
        try{ estPinta(); }catch(_){}
        toast('FIPE atualizada: '+brl(agora)+(o.mes_ref?(' · '+o.mes_ref):''));
      })();
      return;
    }
    if(key==='clientes'){ cdvAbrir(id); return; }        /* v342 */
    if(key==='post'){ estCopiarPost(v); return; }        /* v347 */
    if(key==='fotos'){ estBaixarFotos(v); return; }      /* v467 (14g) */
    if(key==='share'){ estCompartilhar(v); return; }
    /* v514 (porta B): a MESMA folha da porta A. Um seletor, três canais. */
    if(key==='avisar'){
      var _avB=null; try{ _avB=avisarLojistasDoVeiculo(v); }catch(_){}
      if(!_avB){ toast('Salve o veículo antes de avisar os lojistas.'); return; }
      avisarLojistasAbrir(_avB.texto, _avB.titulo, { link:_avB.link, foto:_avB.foto||'', chave:_avB.chave||'' });
      return;
    }
    if(key==='excluir'){
      if(!confirm('Excluir '+((v.marca||'')+' '+(v.modelo||'')).trim()+' ('+(v.placa||'')+') do estoque?\n\nSe ele estiver anunciado no Portal do Repasse, o anúncio sai do ar junto.')) return;
      try{ var r=await supa.from('estoque').delete().eq('id',id).select('id'); estConfereGravou(r,'estAcaoExec (excluir)',1);   /* v782 */
        _estoque=_estoque.filter(function(x){ return String(x.id)!==String(id); });
        /* v333: o anúncio do repasse mora em outra tabela e ficava órfão no ar */
        var nRep=await estRepasseTirarDoAr(v.placa);
        estPinta((($('estBusca')||{}).value)||''); toast(nRep?'Removido do estoque — e o anúncio saiu do Portal do Repasse.':'Veículo removido do estoque.'); }
      catch(e){ toast('Não consegui excluir. '+((e&&e.message)||'')); }
      return;
    }
    /* mudar status */
    var novo=key; var lbl=(EST_STATUS[novo]||{}).t||novo;
    try{ var r2=await supa.from('estoque').update({status:novo}).eq('id',id).select('id'); estConfereGravou(r2,'estAcaoExec',1);   /* v782 */
      v.status=novo;
      /* v334: vendido no estoque = vendido no portal. Reservado NÃO — o
         combinado da v259 é que reservado continua no ar, com o selo. */
      var nV=(novo==='vendido') ? await estRepasseMarcarVendido(v.placa) : 0;
      estPinta((($('estBusca')||{}).value)||''); toast(nV?'Vendido — e o anúncio saiu do Portal do Repasse.':('Marcado como '+lbl+'.')); }
    catch(e){ toast('Não consegui mudar o status. '+((e&&e.message)||'')); }
  }
  /* ---- v175: COMPARTILHAR O VEICULO COMO PAGINA -----------------------------
     Antes isso mandava um TEXTO solto (e ainda por cima mandava o preco MINIMO
     quando nao tinha preco de anuncio — o cliente via o seu piso de negociacao).
     Agora manda um LINK: mevveiculos.com.br/v/<id da ficha>.
     Essa pagina e' publica e mostra SO' o que o cliente pode ver: fotos (com
     navegacao), ficha, diferenciais e o WhatsApp da loja. Preco de compra,
     preco minimo, custos e margem NAO existem naquela pagina — quem monta a
     pagina pede os dados por uma porta unica no banco (mp_get_veiculo) que
     simplesmente nao devolve esses campos. Nao e' "escondido na tela": a
     pagina nao tem como saber. ---- */
  /* v177 — SEM MODAL. Antes o botao abria uma caixa perguntando se voce queria
     "visualizar como o cliente ve". Era um toque a mais pra ver a mesma coisa.
     Agora o botao abre DIRETO a pagina do veiculo. Compartilhar continua
     existindo la' dentro (o icone no canto da foto) e agora a pagina tem o
     botao de VOLTAR, que te traz de volta pro app na tela onde voce estava. */
  /* ===== v281 — A MENSAGEM DO VEÍCULO =====
     Antes, "Compartilhar" só ABRIA a página — quem mandava pro cliente tinha
     que escrever o texto na mão, toda vez. O do repasse manda uma linha seca
     ("Nome (PLACA) — repasse R$ X" + link) e o post da IA sai bonito mas custa
     uma chamada e só existe na aba Marketing.

     Esta mensagem fica no meio: sai pronta, com a cara do post, sem gastar IA
     — porque usa o que VOCÊ já preencheu na ficha (diferenciais, opcionais,
     destaques). Se a ficha estiver vazia, ela encolhe sozinha e vira só carro,
     preço e link. Nunca inventa.

     ⚠️ REGRA DE DINHEIRO: aqui só entra o preco_anuncio. O preco_minimo (seu
     piso de negociação), o preco_compra e os custos NÃO passam por aqui de
     jeito nenhum — é o mesmo cuidado da v265, quando o valor avaliado estava
     viajando escondido no pacote que ia pro lojista. */
  /* ===== v560 — A MENSAGEM DO VEÍCULO GANHOU A FICHA TÉCNICA ================
     Pedido do Angelo (18/08, com print do card na aba Lojas): *"mensagem que
     vai pro lojista, já coloque a foto de capa, motor, câmbio, itens de série
     e opcionais (estilo a mensagem que vai no whatsapp)"*.

     O card mostrava UM item só ("Teto solar panorâmico") porque esta lista
     lia apenas o que VOCÊ digitou na ficha de venda (`extras`: diferenciais,
     opcionais, destaques). A ficha técnica de FÁBRICA — motor, câmbio, itens
     de série — o app já tinha guardada, e nunca ia junto.

     A ORDEM É A DO PEDIDO: motor, câmbio, depois os SEUS diferenciais, depois
     a série e por fim os opcionais de fábrica marcados.
       · motor e câmbio primeiro porque são o que vende;
       · os seus diferenciais ANTES da série de fábrica de propósito: você
         digitou aquilo porque aquilo importa NESTE carro.

     ⚠️ TETO, senão a mensagem vira parede: um carro com ficha gerada tem até
     20 itens de série e 20 opcionais. São os mesmos números da v559 (a
     mensagem da avaliação) — as duas mensagens do app têm que caber na tela
     do mesmo jeito. O que passa do teto é CONTADO, nunca sumido em silêncio.
     ⛳ MSG_VEIC_FICHA=false devolve a mensagem exatamente como era na v559. */
  var MSG_VEIC_FICHA = true;
  /* ===== v674 (pedido: "tá sem os acessórios e opcionais, motorização,
     câmbio, dimensões" + escolha dele: "curta e forte") ======================
     Motor e câmbio SAÍRAM da lista de ✅ e ganharam linha própria (⚙️/🔧, no
     estVeicMsg) — junto da potência e do porta-malas, que não entravam.
     E o teto encolheu: eram até 26 ✅ (8 seus + 10 série + 8 opcionais); no
     WhatsApp isso vira parede e o preço some pra cima. Agora são ATÉ 7, na
     ordem que vende (os seus diferenciais primeiro), e o resto vira UMA linha
     de contagem: "+ N itens de série". O que passa do teto é CONTADO, nunca
     sumido em silêncio — a régua da v560 continua. */
  /* v680 (escolha do Angelo, vendo os três tamanhos com o Virtus dele):
     "média — o que vende, com teto". O teto subiu de 7 pra 12 e os itens de
     FÁBRICA entram em ordem de argumento: SEGURANÇA primeiro (airbag, ESC,
     frenagem...), depois conforto/tecnologia, depois o resto. Os que VOCÊ
     digitou continuam na frente de tudo — você digitou porque importa. */
  var MSG_VEIC_TETO  = 12;   /* ✅ visíveis na mensagem (v674: 7 → v680: 12) */
  var MSG_VEIC_SEUS  = 8;    /* o que VOCÊ digitou ainda tem prioridade (v281) */
  function _estMsgItens(v){
    var ex=(v&&v.extras)||{}, vistos={}, itens=[], sobraram=0;
    function novo(t){ var k=_mkNorm(t); if(!k||vistos[k]) return false; vistos[k]=1; return true; }
    var fx={};
    if(MSG_VEIC_FICHA){
      try{ fx=(typeof fichaVendeDe==='function')?(fichaVendeDe((v&&v.placa)||'')||{}):{}; }catch(_){ fx={}; }
      /* v674: motor e câmbio marcam presença no `vistos` pra não repetirem
         como ✅ (eles já saem nas linhas ⚙️/🔧 do estVeicMsg) */
      [fx.motor, fx.cambio].forEach(function(x){ x=String(x||'').trim(); if(x) novo(x); });
    }
    function poe(t){ if(itens.length<MSG_VEIC_TETO) itens.push(t); else sobraram++; }
    /* 1º os diferenciais marcados — são o que mais vende */
    var seus=0;
    _EX_DIF.forEach(function(d){ if(ex[d.k] && seus<MSG_VEIC_SEUS && novo(d.t)){ poe(d.t); seus++; } });
    /* depois opcionais e destaques, quebrados do mesmo jeito que o post quebra */
    [ex.opcionais, ex.destaques].forEach(function(tx){
      String(tx||'').split(/[,;\n\r|\u00b7]+|\.\s+/).forEach(function(p){
        p=String(p||'').trim().replace(/[.;,]+$/,'');
        if(p && seus<MSG_VEIC_SEUS && novo(p)){ poe(p); seus++; }
      });
    });
    /* por fim a SÉRIE e os OPCIONAIS de fábrica — v680: em ordem de
       argumento de venda (segurança > conforto/tecnologia > resto), com
       ordenação ESTÁVEL: dentro do mesmo peso, a ordem da ficha fica. */
    if(MSG_VEIC_FICHA){
      var fabrica=[];
      [fx.itens, fx.opcionais].forEach(function(lista){
        (lista||[]).map(function(x){ return String(x||'').trim(); })
          .filter(function(x){ return x && novo(x); })
          .forEach(function(x){ fabrica.push(x); });
      });
      fabrica.map(function(x,i){ return { x:x, i:i, p:_msgPesoItem(x) }; })
        .sort(function(a,b){ return (b.p-a.p) || (a.i-b.i); })
        .forEach(function(par){ poe(par.x); });
    }
    if(sobraram>0) itens.push('+ '+sobraram+' ite'+(sobraram>1?'ns':'m'));
    return itens;
  }
  /* v680 — o peso de venda de um item de fábrica. Não é ciência: é a ordem
     que um vendedor usa. 2 = segurança; 1 = conforto/tecnologia; 0 = resto. */
  /* v680 — devolve o câmbio SÓ quando é de UM jeito. Duvidoso ("/" ou
     manual E automático juntos) devolve vazio — nunca chutado. */
  function msgCambioCerto(c){
    c=String(c||'').trim();
    if(!c) return '';
    if(c.indexOf('/')>=0) return '';
    var t=_mkNorm(c);
    if(/manual/.test(t) && /automa/.test(t)) return '';
    return c;
  }
  function _msgPesoItem(nome){
    var t=_mkNorm(nome);
    if(/airbag|estabilidade|\besc\b|tracao|freio|\babs\b|frenagem|tpms|pressao dos pneus|fadiga|isofix|alarme/.test(t)) return 2;
    if(/multimidia|central|android|carplay|ar.condicionado|digital|farol|farois|\bled\b|carregador|inducao|cruzeiro|sensor|camera|liga leve|volante|vidros|travas|retrovisor|\bsom\b|couro|teto solar/.test(t)) return 1;
    return 0;
  }
  function estVeicMsg(v){
    var L=[], nome=((v.marca||'')+' '+(v.modelo||'')).trim();
    L.push('\ud83d\ude97 *'+(nome||'Ve\u00edculo')+'*');
    var anos=(v.ano&&v.ano_modelo&&String(v.ano)!==String(v.ano_modelo))
      ? (v.ano+'/'+v.ano_modelo) : String(v.ano||v.ano_modelo||'');
    var linha=[anos,
      (Number(v.km)>0 ? Number(v.km).toLocaleString('pt-BR')+' km' : ''),
      String(v.cor||'').trim(),
      String(v.combustivel||'').trim()].filter(Boolean);
    if(linha.length) L.push(linha.join(' \u00b7 '));
    var preco=Number(v.preco_anuncio)||0;              /* SÓ o preço de anúncio */
    /* preço de carro não leva centavos: "R$ 96.900" e não "R$ 96.900,00".
       Se um dia vier um valor quebrado, os centavos voltam — não arredondo
       dinheiro por conta própria. */
    if(preco>0){
      var _p = (preco % 1 === 0)
        ? ('R$ '+preco.toLocaleString('pt-BR',{maximumFractionDigits:0}))
        : _rsF(preco);
      L.push(''); L.push('\ud83d\udcb0 *'+_p+'*');
    }
    /* v674 — motorização e dimensões, em linha própria (não como ✅):
       ⚙️ motor · potência   🔧 câmbio · porta-malas
       Vêm do fichaVendeDe (o dono da ficha, v560) — sem ficha gerada, as
       linhas simplesmente não existem. Nunca inventa dado. */
    var _fx={};
    try{ _fx=(typeof fichaVendeDe==='function')?(fichaVendeDe(v.placa||'')||{}):{}; }catch(_){ _fx={}; }
    /* v680 — o câmbio SÓ entra quando a ficha diz UM ("Automático 6
       marchas"). "Manual 5 marchas / Automático 6 marchas" é resposta do
       MODELO, não deste carro — mandada, o cliente lê que o carro é as duas
       coisas. Campo sem certeza fica fora (regra v450). Na PÁGINA do carro
       ele continua: lá é tabela de ficha técnica, onde as duas versões fazem
       sentido. */
    var _cb=msgCambioCerto(_fx.cambio);
    var _l1=[String(_fx.motor||'').trim(), String(_fx.motor_potencia||'').trim(), _cb].filter(Boolean).join(' \u00b7 ');
    var _pm=String(_fx.porta_malas||'').trim(), _tq=String(_fx.tanque||'').trim();
    var _l2=[_pm?('Porta-malas '+_pm):'', _tq?('Tanque '+_tq):''].filter(Boolean).join(' \u00b7 ');
    if(_l1||_l2){
      L.push('');
      if(_l1) L.push('\u2699\ufe0f '+_l1);
      if(_l2) L.push('\ud83d\udcd0 '+_l2);
    }
    var itens=_estMsgItens(v);
    if(itens.length){ L.push(''); L.push(itens.map(function(t){ return '\u2705 '+t; }).join('\n')); }
    L.push(''); L.push('\ud83d\udcf8 Fotos e ficha completa:');
    L.push(_publicoVeiculoUrl(v));
    return L.join('\n');
  }
  /* v309: _estPrimeiraFoto saiu daqui junto com o compartilhar por arquivo.
     Era o único lugar que a chamava. Função que não é chamada por ninguém dá
     a impressão de que ainda faz algo, e alguém acaba religando. */
  async function estCompartilhar(v){
    if(!v || !v.id){ toast('Salve o ve\u00edculo antes de compartilhar.'); return; }
    var url=_publicoVeiculoUrl(v);
    _preAquece(url);                                   /* v183 */
    var txt=estVeicMsg(v);
    /* ===== v309 (pedido) — AQUI SAI O LINK COM A MENSAGEM, NÃO A FOTO =====
       "quando compartilho da página do estoque o primeiro formato tá puxando
        imagem… deixe o link com mensagem".

       Este compartilhar montava a foto como ARQUIVO e mandava junto com o
       texto. No iPhone o resultado é o que você viu: a folha de compartilhar
       abre anunciando "veiculo — Imagem JPEG · 296 KB", e quando o destino é
       o WhatsApp chega a foto solta. O texto vai junto só às vezes — depende
       do aplicativo — e o link, que é a parte que importa, se perde.

       E uma foto solta não vende: ela não tem preço, não tem os itens e não
       tem pra onde clicar. O link, sim — ele abre a página do carro com as
       fotos todas, a ficha e o botão de falar com a loja. E o próprio
       WhatsApp já desenha a prévia com a foto de capa a partir do link.

       Então agora vai SÓ O TEXTO (que termina no link). A foto como arquivo
       continua existindo onde ela faz sentido: no POST de marketing, que é
       feito pra virar imagem de rede social. Aqui não.
       ==================================================================== */
    try{
      if(navigator.share){ await navigator.share({text:txt}); return; }
    }catch(err){ if(err && err.name==='AbortError') return; }
    mevIrProWhats('https://wa.me/?text='+encodeURIComponent(txt));   /* v370 */
  }
  function _rs(v){ return (v?_rsF(v):''); }
  /* ---- v170: MENU DE ETAPAS ROLAVEL ----------------------------------------
     A tira de etapas (Cadastro / Fotos / Custos / ...) agora rola pro lado.
     Esta funcao rola a PROPRIA tira (nunca a pagina) pra deixar o cartao
     escolhido no MEIO da tela. Se tudo ja' cabe, ela nao faz nada. ---- */
  function _tabCentra(box, btn){
    try{
      if(!box||!btn) return;
      var passo=function(){
        try{
          if(box.scrollWidth<=box.clientWidth+2) return;
          var br=box.getBoundingClientRect(), tr=btn.getBoundingClientRect();
          var alvo=box.scrollLeft+(tr.left-br.left)-((br.width-tr.width)/2);
          var max=box.scrollWidth-box.clientWidth;
          if(alvo<0) alvo=0; if(alvo>max) alvo=max;
          if(Math.abs(alvo-box.scrollLeft)<2) return;
          /* v258 — BUG DA ABA QUE VOLTAVA SOZINHA.
             Esta rolagem é do APP, não do dedo. O vigia de rolagem da barra
             (o "arrastar a barra troca de aba", no 07-avaliacao) só ignora
             rolagem programática se window._tabCentraTs estiver fresco — e
             ninguém carimbava aqui. Resultado: clicar numa aba fazia o app
             rolar a barra, o vigia achava que era o dedo e trocava pra aba
             vizinha. Doía principalmente na PRIMEIRA aba (Histórico FIPE),
             que não tem como ficar centralizada: a barra encosta no início e
             a aba mais perto do centro vira a de Dados veículo. */
          window._tabCentraTs=Date.now();
          if(box.scrollTo) box.scrollTo({left:alvo, behavior:'smooth'}); else box.scrollLeft=alvo;
        }catch(_){}
      };
      passo(); setTimeout(passo,90); setTimeout(passo,240);
      /* mantém o carimbo vivo enquanto a rolagem suave termina */
      setTimeout(function(){ window._tabCentraTs=Date.now(); },420);
    }catch(_){}
  }
  /* ---- v156: OUTROS CUSTOS — primeiro o valor; ao digitar, abre o campo "qual e o custo".
     Aceita vários. Le tambem o formato antigo (outro_nome/outro_val) sem perder nada. ---- */
  function _ccOutros(cc){
    cc=cc||{};
    if(cc.outros&&cc.outros.length) return cc.outros.map(function(o){ return {nome:String((o&&o.nome)||''), val:Number((o&&o.val))||0}; });
    if(cc.outro_val||cc.outro_nome) return [{nome:String(cc.outro_nome||''), val:Number(cc.outro_val)||0}];
    return [];
  }
  function _ccOutrosSoma(cc){ var t=0; _ccOutros(cc).forEach(function(o){ t+=Number(o.val)||0; }); return t; }
  function _ecOutroRow(o){
    o=o||{nome:'',val:0}; var temV=!!(Number(o.val)||0);
    return '<div class="ec-out">'+
      '<div class="ec-row"><label>Outro custo</label><input class="cad-in ec-out-v" inputmode="numeric" value="'+_rs(o.val)+'" placeholder="R$ 0"></div>'+
      '<div class="ec-out-n"'+(temV?'':' style="display:none"')+'><input class="cad-in ec-out-nm" value="'+esc(o.nome||'')+'" placeholder="Qual e esse custo? (ex.: guincho, laudo, chaveiro)"></div>'+
    '</div>';
  }
  function _ecOutrosHtml(cc){ var l=_ccOutros(cc); if(!l.length) l=[{nome:'',val:0}]; return l.map(_ecOutroRow).join(''); }
  function _ecOutrosLer(){
    var box=$('ecOutros'); if(!box) return [];
    var out=[];
    Array.prototype.forEach.call(box.querySelectorAll('.ec-out'),function(r){
      var ve=r.querySelector('.ec-out-v'), ne=r.querySelector('.ec-out-nm');
      var v=_rsLer((ve&&ve.value)||'');
      var n=String((ne&&ne.value)||'').trim();
      if(v||n) out.push({nome:n, val:v});
    });
    return out;
  }
  function _ecOutrosSomaDom(){ var t=0; _ecOutrosLer().forEach(function(o){ t+=o.val; }); return t; }
  function ecOutrosWire(){
    var box=$('ecOutros'); if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('.ec-out'),function(r){
      if(r.getAttribute('data-w')) return; r.setAttribute('data-w','1');
      var ve=r.querySelector('.ec-out-v'), nw=r.querySelector('.ec-out-n'), ne=r.querySelector('.ec-out-nm');
      if(ve) ve.addEventListener('input',function(){
        estMaskRS.call(ve);
        if(nw) nw.style.display=(String(ve.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''))?'block':'none';
        try{ estMargemCalc(); }catch(_){}
        try{ estAgendaSalvar(); }catch(_){}
      });
      if(ne) ne.addEventListener('input',function(){ try{ estAgendaSalvar(); }catch(_){} });
    });
    var add=$('ecOutroAdd');
    if(add) add.onclick=function(){
      var b=$('ecOutros'); if(!b) return;
      b.insertAdjacentHTML('beforeend', _ecOutroRow(null));
      ecOutrosWire();
      var ul=b.querySelectorAll('.ec-out-v'); if(ul.length){ try{ ul[ul.length-1].focus(); }catch(_){} }
    };
  }
  function _custosPadraoLer(){ try{ return JSON.parse(localStorage.getItem('mev_custos_padrao')||'null'); }catch(_){ return null; } }
  /* veículo NOVO já vem com os custos padrão salvos; ao editar, usa os do próprio veículo */
  /* v174 (K) — UMA LISTA SO' DE DIFERENCIAIS.
     Antes o app tinha 2 lugares que perguntavam a mesma coisa: a aba
     "Diferenciais" (com flags) e a aba "Marketing" (que perguntava de novo
     em forma de chips). Agora existe UMA lista, escrita aqui embaixo, e ela
     alimenta: a aba Marketing, o que e' salvo no veiculo (extras), o texto
     que vai pro post da IA e os selos da tela de venda.
     Pra criar/tirar um diferencial no futuro, mexe SO' nesta lista. */
  var _EX_DIF=[
    { id:'exDono',    k:'unico_dono',     t:'\u00danico dono',                     e:'\ud83d\udc64' },
    { id:'exDono2',   k:'dono2',          t:'2\u00ba dono',                        e:'\ud83d\udc65' },
    { id:'exIpva',    k:'ipva_pago',      t:'IPVA pago',                            e:'\u2705' },
    { id:'exTransf',  k:'transferido',    t:'Transferido',                          e:'\ud83d\udcc4' },
    { id:'exRevisado',k:'revisado',       t:'Revisado',                             e:'\ud83d\udd27' },
    { id:'exRev',     k:'rev_conc',       t:'Revis\u00f5es na concession\u00e1ria', e:'\ud83d\udd27' },
    { id:'exPneus',   k:'pneus_novos',    t:'Pneus novos',                          e:'\ud83c\udd95' },
    { id:'exGar',     k:'garantia_fab',   t:'Na garantia de f\u00e1brica',         e:'\ud83d\udee1\ufe0f' },
    { id:'exGar90',   k:'garantia_90_dias', t:'Garantia de 90 dias',                e:'\ud83d\udee1\ufe0f' },
    { id:'exDocDia',  k:'documentacao_em_dia', t:'Documenta\u00e7\u00e3o em dia',   e:'\ud83d\udcc4' },
    { id:'exSinistro',k:'sem_sinistro',    t:'Sem sinistro',                         e:'\ud83d\udee1\ufe0f' },
    { id:'exLeilao',  k:'sem_leilao',      t:'Sem leil\u00e3o',                     e:'\ud83d\udee1\ufe0f' },
    { id:'exManual',  k:'manual_veiculo',  t:'Manual do ve\u00edculo',               e:'\ud83d\udcd8' },
    { id:'exChaveReserva', k:'chave_reserva', t:'Chave reserva',                     e:'\ud83d\udd11' },
    { id:'exEntrega', k:'pronta_entrega', t:'Pronta entrega',                       e:'\ud83d\udd11' }
  ];
  /* desenha as linhas de flegar (mesmo visual .vd-ck da antiga aba Diferenciais) */
  function _exDifHtml(ex){ ex=ex||{};
    /* 🔴 v1052 — num 0 km os seis selos de PASSADO não querem dizer nada
       (único dono, 2º dono, IPVA pago, transferido, revisado, pneus novos).
       ⚠️ Eles somem por CLASSE, nunca do DOM: o autosave lê a tela inteira a
       cada tecla, e campo que sai do DOM some do registro no salvamento
       seguinte. Esconder não pode apagar dado. Quem põe e tira a classe é o
       `zkAplicaNaTela`, no 14m. */
    var _zkOn=false; try{ _zkOn=!!ex.zero_km; }catch(_){}
    var _zkUsado=(typeof ZK_SELOS_DE_USADO!=='undefined')?ZK_SELOS_DE_USADO:[];
    return _EX_DIF.map(function(d){
      var esconde=_zkOn && _zkUsado.indexOf(d.k)>=0;
      return '<label class="vd-ck'+(ex[d.k]&&!esconde?' on':'')+(esconde?' zk-off':'')+'"><input type="checkbox" id="'+d.id+'"'+(ex[d.k]&&!esconde?' checked':'')+'><span>'+d.t+'</span></label>';
    }).join('');
  }
  /* le' o que esta' flegado NA TELA (sem esperar o salvamento automatico) */
  function _exDifLidos(){ var o={}; _EX_DIF.forEach(function(d){ o[d.k]=!!(($(d.id)||{}).checked); }); return o; }
  /* v179 — tira acento e pontuacao pra COMPARAR dois textos.
     "Teto solar" e "TETO SOLAR." viram a mesma coisa, entao o item nao aparece
     duas vezes no post (era o bug do "Teto Solar" repetido). */
  function _mkNorm(s){
    s=String(s||'').toLowerCase();
    var de='áàâãäéèêëíìîïóòôõöúùûüçñ', pa='aaaaaeeeeiiiiooooouuuucn', o='';
    for(var i=0;i<s.length;i++){ var j=de.indexOf(s.charAt(i)); o+=(j>=0?pa.charAt(j):s.charAt(i)); }
    return o.replace(/[^a-z0-9]+/g,' ').trim();
  }
  /* v228 — itens que já foram confirmados na Ficha técnica. A ficha sem placa
     usa a referência IM<hash>; por isso não se deve exigir efPlaca aqui. */
  function _mktItensConfirmadosDaFicha(v){
    var ref='';
    try{ ref=_ftRefAtual(); }catch(_){}
    if(!ref){
      v=v||_mktV||{};
      var placa=limpa(String(v.placa||''));
      if(valida(placa)) ref=placa;
      else {
        var alvo=[v.marca||'',v.modelo||'',v.ano_modelo||v.ano||''].join('|');
        if(alvo.replace(/\|/g,'').trim()) ref='IM'+_ftHash(alvo);
      }
    }
    if(!ref) return [];
    try{
      var ficha=fichaParaRepasse(ref), vistos={}, itens=[];
      /* A ficha pode estar no registro do estoque e ainda não ter sido aberta
         neste aparelho. Nesse caso monta o mesmo resumo em memória, sem
         gravar nem alterar as escolhas já existentes do lojista. */
      if(!ficha){
        /* v781: primeiro a coluna nova, depois o extras antigo */
        var fichaSalva=fichaTecObter(ref)||(v&&(v.ficha_tec||(v.extras&&v.extras.ficha_tec)))||null;
        var fichaParse=fichaSalva?fichaTecParse(fichaSalva):null;
        if(fichaParse&&fichaParse.conhecido){
          var resumo=_fichaResumoDaParse(fichaParse,ref);
          ficha={ serie:(resumo.serie||[]).filter(function(n){ return (resumo.desmarcados||[]).indexOf(n)<0; }), opcionais:(resumo.marcados||[]) };
        }
      }
      if(!ficha) return [];
      (ficha.opcionais||[]).concat(ficha.serie||[]).forEach(function(t){
        t=String(t||'').trim().replace(/[.;,]+$/,'');
        var chave=_mkNorm(t);
        if(!chave || vistos[chave] || itens.length>=10) return;
        vistos[chave]=true; itens.push(t);
      });
      return itens;
    }catch(_){ return []; }
  }
  /* monta a frase que vai pra IA escrever o post.
     v179 — em vez de um texto corrido, manda DUAS LISTAS separadas e ja' sem
     repeticao. A IA recebe item por item, entao ela nao junta dois numa linha
     so' (era o "Único dono · IPVA pago!" que saia grudado). */
  function _mktExtrasDaFicha(){
    var vistos={};
    function novo(t){ var k=_mkNorm(t); if(!k||vistos[k]) return false; vistos[k]=1; return true; }
    var dif=[]; _EX_DIF.forEach(function(d){ if((($(d.id)||{}).checked) && novo(d.t)) dif.push(d.t); });
    var itens=[];
    [String((($('exOpc')||{}).value||'')), String((($('exDest')||{}).value||''))].forEach(function(tx){
      /* separa por virgula, ponto-e-virgula, barra vertical, "·" e quebra de
         linha — e tambem por ponto final SEGUIDO DE ESPACO (assim "Teto solar.
         Bem conservada" vira dois itens, mas "motor 1.6" nao se parte no meio) */
      String(tx||'').split(/[,;\n\r|·]+|\.\s+/).forEach(function(p){
        p=String(p||'').trim().replace(/[.;,]+$/,'');
        if(p && novo(p)) itens.push(p);
      });
    });
    /* v184 — se a FICHA TECNICA ja foi gerada, os itens dela entram no post.
       Ordem de prioridade: primeiro os OPCIONAIS que voce flegou (sao o que
       mais vende), depois os itens de serie. Para em 10 pra nao virar lista
       de supermercado. Cada um sai com ✅ no texto. */
    _mktItensConfirmadosDaFicha(_mktV).forEach(function(t){
      if(itens.length>=10) return;
      if(novo(t)) itens.push(t);
    });
    var partes=[];
    if(dif.length)   partes.push('DIFERENCIAIS CONFIRMADOS (cada um vira UMA linha com ➡️, sozinho, sem juntar com outro): '+dif.join(' | '));
    if(itens.length) partes.push('EQUIPAMENTOS/OPCIONAIS (cada um vira UMA linha com ✅, sozinho, sem juntar com outro): '+itens.join(' | '));
    if(partes.length) partes.push('IMPORTANTE: nao repita nenhum item — se ele ja apareceu numa linha, nao pode aparecer de novo em outra.');
    return partes.join('\n');
  }
  function _mktIncluirKm(v){
    var direto=$('mkPostKm'), pergunta=$('ppMostrarKm');
    if(direto) return !!direto.checked;
    if(pergunta) return !!pergunta.checked;
    var ex=(v&&v.extras)||{};
    return ex.post_mostrar_km!==false;
  }
  function _mktKmPost(v, incluir){
    if(!incluir || !v || v.km===undefined || v.km===null || String(v.km).trim()==='') return '';
    var digitos=String(v.km).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(!digitos) return '';
    var km=Number(digitos);
    return isFinite(km) && km>=0 && km<=9999999 ? Math.round(km).toLocaleString('pt-BR') : '';
  }
  /* v179 — escreve o ano do jeito que o mercado fala: "2023/2024" quando o ano
     de fabricacao e' diferente do ano modelo; se for igual (ou so' tiver um),
     mostra um numero so'. */
  function _efAnoTxt(v){ v=v||{}; var a=String(v.ano||'').trim(), m=String(v.ano_modelo||'').trim(); if(a&&m&&a!==m) return a+'/'+m; return a||m; }
  function estPaineisHtml(v){ v=v||{}; var cc=v.custos||(v.id?{}:(_custosPadraoLer()||{}));
    /* v188 — SITUACAO POR CAIXINHA. O Angelo pediu "um campo pra flegar
       reservado e outro pra flegar vendido". Repare que NAO criei campo novo
       no banco: as duas caixinhas escrevem na MESMA coluna `status` que ja
       existia (Reservado -> 'reservado', Vendido -> 'vendido', nenhuma
       marcada -> 'disponivel'). Guardar a situacao num lugar so' evita o pior
       tipo de bug que existe: dois campos dizendo coisas diferentes sobre o
       mesmo carro. */
    var _st0=(v.status||'disponivel');
    var ex=(v&&v.extras)||{};
    /* v865 — FIPE é referência de mercado, não preço mínimo. A coluna `fipe`
       já existia; registros antigos podem ter o número apenas no metadado. */
    var _fipeValor=Number(v.fipe)||Number(ex.fipe&&ex.fipe.valor)||0;
    var _importUrl=String((_estImportFonte&&_estImportFonte.url)||'');
    var _og0=String(v.origem||'proprio');
    var _origemHtml=
      '<div class="ec-tit" style="margin-top:14px">De onde veio este carro</div>'+
      '<input type="hidden" id="efOrigem" value="'+esc(_og0)+'">'+
      '<div class="ef-og" id="efOgChips">'+_OG_LISTA.map(function(o){
        return '<button type="button" class="ef-og-chip'+(_og0===o[0]?' on':'')+'" data-og="'+o[0]+'"><b>'+esc(o[1])+'</b><i>'+esc(o[2])+'</i></button>';
      }).join('')+'</div>'+
      '<div id="efConsigWrap"'+(_og0==='consignado'?'':' style="display:none"')+'>'+
        '<div class="cli-2col"><div><label class="cad-lbl">Dono do carro</label><input class="cad-in" id="efConsigNome" value="'+esc(v.consig_nome||'')+'" placeholder="Quem deixou o carro na loja"></div><div><label class="cad-lbl">WhatsApp dele</label><input class="cad-in" id="efConsigFone" value="'+esc(v.consig_fone||'')+'" placeholder="(51) 9 9999-9999"></div></div>'+
        '<div class="ec-row"><label>Fica com a loja <span class="ec-hint">(% da venda)</span></label><div class="ec-inw"><input class="cad-in ec-pct" id="efConsigPct" inputmode="decimal" value="'+esc(v.consig_pct||'')+'" placeholder="%"><b class="ec-val" id="efConsigVal">R$ 0</b></div></div>'+
        '<div class="ef-og-hint">Neste carro o dinheiro da venda <b>não é todo seu</b>. Entra na loja só a sua parte — o resto é do dono. Por isso eu tiro o custo de compra da conta e uso só a sua comissão em tudo: margem, lucro real e Resultado.</div>'+
      '</div>';
    function _pan(k,inner){ return '<div class="vpx-panel" data-panel="'+k+'"><div class="vp-sec">'+inner+'</div></div>'; }
    var pCad=
      /* v206 — IMPORTAR ANÚNCIO: o link PREENCHE o cadastro e as fotos, cruza
         a versão com a FIPE e monta a ficha técnica por IA. São duas operações
         independentes de 1 token; se uma falhar, o token daquela etapa volta. */
      '<div class="est-import" id="efImportBox">'+
        '<div class="est-import-h"><span aria-hidden="true">'+mkIco('link',17)+'</span><div><b>Importar anúncio <i class="est-import-total">'+precoReal(2)+'</i></b><small>Cole o link público do veículo ou de um post público do Instagram. '+precoReal(1)+' extrai dados e fotos + '+precoReal(1)+' gera a ficha técnica por IA.</small></div></div>'+
        '<div class="est-import-row"><input class="cad-in" id="efImportUrl" type="url" inputmode="url" value="'+esc(_importUrl)+'" placeholder="https://www.loja.com.br/..." autocomplete="off"><button type="button" id="efImportBtn">'+(_importUrl?'Atualizar importação':'Importar')+'</button></div>'+
        '<div class="est-import-actions" id="efImportAcoes"></div>'+
        '<div class="est-import-msg" id="efImportMsg"></div>'+
      '</div>'+
      /* 🔴 v1052 — o bloco 0 km vem ANTES da placa, porque num carro novo
         é ele que decide o que a placa significa (ver 14m-zero-km.js). */
      (function(){ try{ return (typeof zkBlocoHtml==='function' && zkPodeUsar()) ? zkBlocoHtml(ex) : ''; }catch(_){ return ''; } })()+
      '<label class="cad-lbl">Placa</label><input class="cad-in" id="efPlaca" value="'+esc(v.placa||'')+'" placeholder="ABC1D23" style="text-transform:uppercase" autocomplete="off">'+
      '<div class="est-pldrop" id="efPlacaDrop" style="display:none"></div>'+
      '<div class="cad-msg" id="efPlMsg"></div><div id="efVersoes"></div>'+
      '<label class="cad-lbl">Marca</label><input class="cad-in" id="efMarca" value="'+esc(v.marca||'')+'" placeholder="VW">'+
      /* v179 — ANO DE FABRICACAO e ANO MODELO separados. Antes era um campo so'
         chamado "Ano", e o carro 2023/2024 (fabricado num ano, modelo do ano
         seguinte) nao tinha onde ser escrito direito. */
      '<div class="cli-2col"><div><label class="cad-lbl">Ano fabricação</label><input class="cad-in" id="efAno" inputmode="numeric" value="'+esc(v.ano||'')+'" placeholder="2023"></div><div><label class="cad-lbl">Ano modelo</label><input class="cad-in" id="efAnoMod" inputmode="numeric" value="'+esc(v.ano_modelo||'')+'" placeholder="2024"></div></div>'+
      '<label class="cad-lbl">Modelo</label><input class="cad-in" id="efModelo" value="'+esc(v.modelo||'')+'" placeholder="Nome do modelo">'+
      '<div class="cli-2col"><div><label class="cad-lbl">Cor</label><input class="cad-in" id="efCor" value="'+esc(v.cor||'')+'" placeholder="Cor"></div><div><label class="cad-lbl">Quilometragem</label><input class="cad-in" id="efKm" inputmode="numeric" value="'+(v.km?Number(v.km).toLocaleString('pt-BR'):'')+'" placeholder="80.000"></div></div>'+
      '<div class="cli-2col"><div><label class="cad-lbl" for="efCombustivel">Combustível</label><input class="cad-in" id="efCombustivel" value="'+esc(ex.combustivel||v.combustivel||'')+'" placeholder="Ex.: Flex"></div><div><label class="cad-lbl" for="efCambio">Câmbio</label><input class="cad-in" id="efCambio" value="'+esc(ex.cambio||v.cambio||'')+'" placeholder="Ex.: Automático"></div></div>'+
      '<label class="cad-lbl" for="efFipe">Valor FIPE <span class="ec-hint">(opcional)</span></label><input class="cad-in" id="efFipe" inputmode="decimal" value="'+_rs(_fipeValor)+'" placeholder="R$ 0,00"><p class="cad-help">Referência da tabela FIPE. Não altera seus preços.</p>'+
      '<div class="cli-2col"><div><label class="cad-lbl" for="efMin">Preço mínimo</label><input class="cad-in" id="efMin" inputmode="decimal" value="'+_rs(v.preco_minimo)+'" placeholder="R$ 0,00"></div><div><label class="cad-lbl" for="efMargem">Margem <span class="ec-hint">(s/ mínimo)</span></label><input class="cad-in" id="efMargem" value="" readonly placeholder="—" style="font-weight:800;background:#f8fafc"></div></div>'+
      '<label class="cad-lbl" for="efAnuncio">Preço de anúncio</label><input class="cad-in" id="efAnuncio" inputmode="decimal" value="'+_rs(v.preco_anuncio)+'" placeholder="R$ 0,00">'+
      /* v184 — preco de REPASSE (o que os outros lojistas veem no Portal).
         Fica guardado em extras.preco_repasse, que ja e' uma coluna jsonb —
         nao precisou mexer no banco. */
      '<label class="cad-lbl">Preço no repasse <span class="ec-hint">(referência sua — o portal mostra "Faça sua oferta")</span></label><input class="cad-in" id="efRepasse" inputmode="numeric" value="'+_rs(ex.preco_repasse)+'" placeholder="R$ 0">'+
      '<label class="cad-lbl" for="efLocalizacao">Localização do veículo</label><input class="cad-in" id="efLocalizacao" list="efLocalizacaoLista" value="'+esc(ex.localizacao_veiculo||'')+'" placeholder="Ex.: Santa Luzia"><datalist id="efLocalizacaoLista"><option value="Santa Luzia"><option value="Motomecânica"><option value="Comauto"></datalist>'+
      _origemHtml+
      '<label class="cad-lbl">Situação do veículo</label>'+
      '<div class="ef-flags">'+
        '<label class="vd-ck'+(_st0==='reservado'?' on':'')+'"><input type="checkbox" id="efReservado"'+(_st0==='reservado'?' checked':'')+'><span>Reservado</span></label>'+
        '<label class="vd-ck'+(_st0==='vendido'?' on':'')+'"><input type="checkbox" id="efVendido"'+(_st0==='vendido'?' checked':'')+'><span>Vendido</span></label>'+
      '</div>'+
      '<div class="ef-flags-hint" id="efStatusHint"></div>'+
      '<input type="hidden" id="efStatus" value="'+esc(_st0)+'">'+
      '<label class="cad-lbl">Data de entrada</label><input class="cad-in" id="efEntrada" type="date" value="'+esc(v.data_entrada||estHoje())+'">'+
      /* v1094 — o outro lado do par. A v185 decidiu que a observação é
         INTERNA e nunca vai pra página pública, mas isso só estava escrito no
         código. Dizer na tela é o que impede a pessoa de escrever a descrição
         do anúncio aqui e depois não entender por que o site não mostra. */
      '<label class="cad-lbl" for="efObs">Observações <span class="ec-hint">(só você vê)</span></label>'+
      '<textarea class="cad-in" id="efObs" rows="3" placeholder="Detalhes, opcionais, avarias...">'+esc(v.obs||'')+'</textarea>'+
      '<p class="cad-help">Anotação interna da loja. <b>Nunca</b> aparece no site nem no catálogo.</p>';
    /* v174 (H) — a aba Fotos ficou so' com as fotos. O reenquadramento
       automatico 4:3 continua funcionando por tras (padrao ligado), so'
       sumiu o aviso e o botao que poluiam a tela. */
    var pFotos='<div class="est-foto-head"><div class="ec-tit">Fotos do veículo</div><button type="button" class="cad-btn sec ico est-foto-dl" id="estFotosBaixar">'+mkIco('download',17)+'Baixar fotos</button></div><div class="est-foto-dlmsg" id="estFotosBaixarMsg"></div><div class="est-fotos pg" id="estFotos"></div>';
    var pCustos=
      '<div class="est-custos" style="border:none;padding:0;background:transparent">'+
        '<div class="ec-tit">Custos de preparação</div>'+
        '<div class="ec-row" id="efCompraRow"><label>Custo <span class="ec-hint">(o que paguei)</span></label><input class="cad-in" id="efCompra" inputmode="numeric" value="'+_rs(v.preco_compra)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Comissão <span class="ec-hint">(% do mínimo)</span></label><div class="ec-inw"><input class="cad-in ec-pct" id="ecComPct" inputmode="decimal" value="'+esc(cc.com_pct||'')+'" placeholder="%"><b class="ec-val" id="ecComVal">R$ 0</b></div></div>'+
        '<div class="ec-row"><label>Imposto NF <span class="ec-hint">(%)</span></label><div class="ec-inw"><input class="cad-in ec-pct" id="ecNfPct" inputmode="decimal" value="'+esc(cc.nf_pct||'')+'" placeholder="%"><b class="ec-val" id="ecNfVal">R$ 0</b></div></div>'+
        '<div class="ec-row ec-nfbase"><label>Imposto NF: calcular sobre</label><select class="cad-in" id="ecNfBase"><option value="margem"'+((cc.nf_base||'margem')==='margem'?' selected':'')+'>a margem</option><option value="venda"'+(cc.nf_base==='venda'?' selected':'')+'>o valor de venda</option></select></div>'+
        '<div class="ec-row"><label>Higienização</label><input class="cad-in" id="ecHig" inputmode="numeric" value="'+_rs(cc.hig)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Polimento</label><input class="cad-in" id="ecPol" inputmode="numeric" value="'+_rs(cc.pol)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Funilaria</label><input class="cad-in" id="ecFun" inputmode="numeric" value="'+_rs(cc.fun)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Pneus</label><input class="cad-in" id="ecPneus" inputmode="numeric" value="'+_rs(cc.pneus)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Mecânica</label><input class="cad-in" id="ecMec" inputmode="numeric" value="'+_rs(cc.mec)+'" placeholder="R$ 0"></div>'+
        '<div class="ec-row"><label>Documentação</label><input class="cad-in" id="ecDoc" inputmode="numeric" value="'+_rs(cc.doc)+'" placeholder="R$ 0"></div>'+
        '<div id="ecOutros">'+_ecOutrosHtml(cc)+'</div>'+
        '<button type="button" class="cad-btn sec" id="ecOutroAdd" style="margin:4px 0 2px">+ Adicionar outro custo</button>'+
        '<div class="ec-total"><span>Total de custos adicionais</span><b id="ecTotal">R$ 0</b></div>'+
        '<div class="ec-total geral"><span>Custo total (compra + custos)</span><b id="ecTotalGeral">R$ 0</b></div>'+
      '</div>';
    var pFicha='<div class="ec-tit" style="margin-bottom:8px">Ficha técnica</div><div id="efFichaBox"></div>';
    /* Diferenciais e Marketing formam uma só jornada: os mesmos dados
       alimentam o post social e o anúncio de marketplace. */
    var pMkt=
      '<div class="ec-tit" style="margin-bottom:4px">Diferenciais do veículo</div>'+
      '<div class="ef-diferenciais">'+_exDifHtml(ex)+'</div>'+
      '<label class="cad-lbl">Opcionais</label><input class="cad-in" id="exOpc" value="'+esc(ex.opcionais||'')+'" placeholder="Ex: teto solar, multimídia, rodas de liga...">'+
      /* 🔴🔴 v1094 — O CAMPO NÃO É NOVO. ELE SÓ ESTAVA COM O NOME ERRADO.
         --------------------------------------------------------------------
         Pedido do Angelo (19/09): "no estoque em marketing, adicione um campo
         pra colocar descrição do item (texto que vai no catálogo do produto)".

         Fui olhar antes de criar — a lição que a v1092 me custou — e o campo
         JÁ EXISTIA. Este mesmo `destaques` é quem vira:
            · a "Descrição" na página pública do veículo
              (netlify/functions/veiculo.js: `var desc = [txt(ex.destaques)]`)
            · e o texto de marketing no catálogo
              (netlify/functions/catalogo.js: `var dest = v.destaques`)

         🔑 ELE PEDIU UM CAMPO QUE JÁ TINHA PORQUE O RÓTULO NÃO CONTAVA O QUE
            ELE FAZ. "Destaques" soa como tópicos soltos; ninguém adivinha que
            é DALI que sai a descrição do produto. Criar um segundo campo seria
            dois textos brigando pra ver qual aparece no site — o mesmo erro
            que eu evitei na v1090 com o preço.

         ⚠️ O `id` e a CHAVE NÃO MUDAM. Continua `exDest` e `extras.destaques`.
            Renomear a chave apagaria em silêncio a descrição de todo veículo
            já cadastrado: o jsonb não reclama de chave que ninguém lê, ele
            devolve vazio. Mudou o RÓTULO, não o dado.

         ⚠️ E A DIFERENÇA PRA "Observações" AGORA ESTÁ ESCRITA NA TELA: aquele
            campo é anotação interna e NUNCA vai pro site (v185). Sem dizer
            isso, os dois parecem a mesma coisa e a pessoa escreve no errado. */
      '<label class="cad-lbl" for="exDest">Descrição do veículo</label>'+
      '<textarea class="cad-in" id="exDest" rows="5" placeholder="Ex.: Cabine simples para uso intenso de trabalho · Maior carga útil do segmento · Mecânica simples e barata de manter">'+esc(ex.destaques||'')+'</textarea>'+
      '<p class="cad-help">É <b>este</b> texto que aparece como <b>Descrição</b> na página do veículo e no catálogo da loja. Para anotação interna, use <b>Observações</b> — ela nunca vai pro site.</p>'+
      '<p class="cad-help">A entrada do post é calculada automaticamente em 30% do preço de anúncio.</p>'+
      '<label class="cad-lbl" for="exPostHashtags">Hashtags do post (opcional)</label>'+
      '<textarea class="cad-in" id="exPostHashtags" rows="3" placeholder="#Volkswagen #Seminovo">'+esc(ex.post_hashtags||'')+'</textarea>'+
      '<label class="vd-ck'+(ex.post_mostrar_km!==false?' on':'')+'"><input type="checkbox" id="mkPostKm"'+(ex.post_mostrar_km!==false?' checked':'')+'><span>Incluir quilometragem no post</span></label>'+
      '<div class="mk-gerar-ajuda">O post é atualizado automaticamente. Ele usa somente os dados preenchidos e os itens marcados nesta ficha.</div>'+
      '<div id="mkOut"></div>';
    /* v347 (pedido): aba CLIENTES, à direita de Marketing. O conteúdo é
       montado quando você entra nela (cdvFichaPintar, no 14c) — não na
       abertura da ficha, senão toda vez que você abrisse um carro o app
       sairia procurando cliente sem necessidade. */
    var pCli='<div class="est-foto-head"><div class="ec-tit">Clientes para este carro</div><div class="cdv-cota" id="efCliCota"></div></div>'+
      '<div id="efCliBody"><div class="cdv-vazio">Abrindo…</div></div>';
    return { cadastro:_pan('cadastro',pCad), fotos:_pan('fotos',pFotos), custos:_pan('custos',pCustos), ficha:_pan('ficha',pFicha), marketing:_pan('marketing',pMkt), clientes:_pan('clientes',pCli),
      seo:(function(){ try{ return (typeof seoPainelHtml==='function' && seoPodeUsar()) ? _pan('seo',seoPainelHtml(v,ex)) : ''; }catch(_){ return ''; } })() };   /* v1103 (14p-) */
  }
  function estPlacaDropHide(){ var box=$('efPlacaDrop'); if(box){ box.style.display='none'; box.innerHTML=''; } }
  function estPlacaDrop(termo){
    var box=$('efPlacaDrop'); if(!box) return;
    var t=String(termo||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    /* 1) placas já no estoque (toque abre pra editar) */
    var estMatch=(_estoque||[]).filter(function(v){ if(!v.placa) return false; if(_estEditId && String(v.id)===String(_estEditId)) return false; return !t || String(v.placa).toUpperCase().indexOf(t)>=0; });
    var jaEst={}; estMatch.forEach(function(v){ jaEst[String(v.placa).toUpperCase()]=1; });
    /* 2) placas do HISTÓRICO de consultas (toque preenche os dados, sem gastar) */
    var hist=[]; try{ hist=histLer().filter(function(x){ if(!x.placa||!x.v) return false; var pu=String(x.placa).toUpperCase(); if(jaEst[pu]) return false; return !t || pu.indexOf(t)>=0; }); }catch(_){}
    if(!estMatch.length && !hist.length){ estPlacaDropHide(); return; }
    var html='';
    if(estMatch.length){ html+='<div class="est-pldrop-hd">Já no estoque · toque para abrir</div>'+estMatch.slice(0,5).map(function(v){ var st=EST_STATUS[v.status]||EST_STATUS.disponivel; return '<button type="button" class="est-pldrop-it" data-open="'+esc(v.id)+'"><b>'+esc(v.placa)+'</b><i style="color:'+st.c+'">'+esc(st.t)+'</i><span>'+esc(((v.marca||'')+' '+(v.modelo||'')).trim())+'</span></button>'; }).join(''); }
    if(hist.length){ html+='<div class="est-pldrop-hd">Do seu histórico · toque para preencher</div>'+hist.slice(0,6).map(function(x){ var v=x.v||{}; return '<button type="button" class="est-pldrop-it" data-fill="'+esc(x.placa)+'"><b>'+esc(x.placa)+'</b>'+(v.fipe?('<i>'+esc(brl(v.fipe))+'</i>'):'<i></i>')+'<span>'+esc(x.modelo||((v.marca||'')+' '+(v.modelo||'')).trim())+'</span></button>'; }).join(''); }
    box.innerHTML=html; box.style.display='block';
    Array.prototype.forEach.call(box.querySelectorAll('.est-pldrop-it'),function(b){ b.onmousedown=function(e){ e.preventDefault(); };
      b.onclick=function(){ estPlacaDropHide();
        var openId=b.getAttribute('data-open'); if(openId){ estAbrirFicha(openId); return; }
        var fillPl=b.getAttribute('data-fill'); if(fillPl){ var pl=$('efPlaca'); if(pl) pl.value=fillPl; estPlacaHist(fillPl); } };
    });
  }
  function estWireForm(){
    _estPlacaAuto='';
    var pl=$('efPlaca'); if(pl){ pl.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); estPlacaDrop(this.value); var lp=limpa(this.value); if(valida(lp)){ estPlacaHist(this.value); if(lp!==_estPlacaAuto){ _estPlacaAuto=lp; estPlacaDropHide(); estBuscaPlaca(); /* v903 — placa completa: procura as fotos que já existem na avaliação deste carro */ try{ if(typeof estFotosPinta==='function' && $('estFotos')) estFotosPinta(); }catch(_){ } } } else { _estPlacaAuto=''; } }; pl.addEventListener('focus',function(){ estPlacaDrop(this.value); }); pl.addEventListener('blur',function(){ estPlacaHist(this.value); setTimeout(estPlacaDropHide,180); }); }
    var km=$('efKm'); if(km) km.oninput=estMaskKM;
    var fi=$('efFipe'); if(fi) fi.oninput=estMaskRS;
    var mi=$('efMin'); if(mi) mi.oninput=function(){ estMaskRS.call(this); estMargemCalc(); };
    var an=$('efAnuncio'); if(an) an.oninput=function(){ estMaskRS.call(this); estMargemCalc(); };
    var co=$('efCompra'); if(co) co.oninput=function(){ estMaskRS.call(this); estMargemCalc(); };
    var rpx=$('efRepasse'); if(rpx) rpx.oninput=estMaskRS;
    try{ if(typeof zkWire==='function') zkWire(); }catch(_){}   /* v1052 */
    try{ if(typeof seoWire==='function') seoWire(); }catch(_){}   /* v1103 — aba SEO (14p-) */
    var imp=$('efImportBtn'); if(imp) imp.onclick=estImportarAnuncio;
    var impUrl=$('efImportUrl'); if(impUrl) impUrl.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); estImportarAnuncio(); } });
    estImportAcoesPinta();
    var fdl=$('estFotosBaixar'); if(fdl) fdl.onclick=estFotosBaixar;
    ['ecHig','ecPol','ecFun','ecPneus','ecMec','ecDoc'].forEach(function(id){ var e=$(id); if(e) e.oninput=function(){ estMaskRS.call(this); estMargemCalc(); }; });
    try{ ecOutrosWire(); }catch(_){}
    var cp=$('ecComPct'); if(cp) cp.oninput=function(){ this.value=String(this.value||'').replace(/[^0-9.,]/g,'').slice(0,5); estMargemCalc(); };
    var nfp=$('ecNfPct'); if(nfp) nfp.oninput=function(){ this.value=String(this.value||'').replace(/[^0-9.,]/g,'').slice(0,5); estMargemCalc(); };
    var nfb=$('ecNfBase'); if(nfb) nfb.onchange=estMargemCalc;
    _EX_DIF.forEach(function(d){ var e=$(d.id); if(e) e.addEventListener('change',function(){ var lb=e.closest('.vd-ck'); if(lb) lb.classList.toggle('on',e.checked); }); });
    var efBody=$('efBody');
    if(efBody){
      var postTimer=null, atualizaPost=function(){
        if(_estFichaTab!=='marketing') return;
        clearTimeout(postTimer); postTimer=setTimeout(function(){
          try{ _mktV=_estFichaVeic(); _mktDireto=true; mktPostSalvoPinta(_mktV); }catch(_){}
        },120);
      };
      efBody.addEventListener('input',atualizaPost); efBody.addEventListener('change',atualizaPost);
    }
    estFotosPinta();
    try{ estOrigemWire(); }catch(_){}
    estMargemCalc();
    try{ estPosVendaCalc(); }catch(_){}
  }
  function estImportMsg(texto,tipo){ var el=$('efImportMsg'); if(!el) return; el.className='est-import-msg'+(tipo?(' '+tipo):''); el.textContent=texto||''; }
  function estImportSet(id,valor){ var el=$(id); if(!el) return; el.value=(valor==null?'':String(valor)); }
  function estImportLimparCampos(){
    ['efPlaca','efMarca','efModelo','efAno','efAnoMod','efCor','efCombustivel','efCambio','efKm','efFipe','efAnuncio','efMin','efObs','exOpc'].forEach(function(id){ estImportSet(id,''); });
  }
  function estImportUrlAtual(){
    return String((_estImportFonte&&_estImportFonte.url)||(($('efImportUrl')||{}).value)||'').trim();
  }
  function estImportAcoesPinta(){
    var box=$('efImportAcoes'), btn=$('efImportBtn'); if(btn) btn.textContent=_estImportFonte?'Atualizar importação':'Importar';
    if(!box) return;
    var url=estImportUrlAtual();
    if(!_estImportFonte||!url){ box.innerHTML=''; return; }
    box.innerHTML=
      '<div class="est-import-linkline"><span aria-hidden="true">'+mkIco('link',15)+'</span><a href="'+esc(url)+'" target="_blank" rel="noopener noreferrer" title="'+esc(url)+'">'+esc(url)+'</a></div>'+
      '<div class="est-import-acts">'+
        '<a class="est-import-act" href="'+esc(url)+'" target="_blank" rel="noopener noreferrer">'+mkIco('link',16)+'Abrir anúncio</a>'+
        '<button type="button" class="est-import-act" id="efImportShare">'+mkIco('share',16)+'Compartilhar link</button>'+
      '</div>';
    var sh=$('efImportShare'); if(sh) sh.onclick=estImportCompartilhar;
  }
  async function estImportCompartilhar(){
    var url=estImportUrlAtual(); if(!url) return;
    try{
      if(navigator.share){ await navigator.share({title:'Anúncio do veículo',url:url}); return; }
    }catch(e){ if(e&&e.name==='AbortError') return; }
    try{ await navigator.clipboard.writeText(url); toast('Link copiado.'); }
    catch(_){ try{ prompt('Copie o link:',url); }catch(__){} }
  }
  function _fipeValorNumero(v){
    if(typeof v==='number') return v;
    var s=String(v||'').replace(/[^\d,.-]/g,'');
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    return Number(s)||0;
  }
  function _fipeNomeNormal(s){ return _mkNorm(String(s||'').replace(/\bvolkswagen\b/ig,'vw')); }
  function _fipeTokens(s){
    var fora={de:1,da:1,do:1,e:1,flex:1,gasolina:1,alcool:1,etanol:1,automatico:1,manual:1,aut:1,mec:1,portas:1};
    return _fipeNomeNormal(s).split(' ').filter(function(x){ return x.length>1&&!fora[x]; });
  }
  /* Espelha a consulta FIPE por modelo para transformar "Fox" na versão
     completa do ano-modelo. É uma consulta pública e não consome tokens. */
  /* ==========================================================================
     v847 — A BUSCA NA FIPE SAIU DE DENTRO DO FORMULÁRIO
     --------------------------------------------------------------------------
     Até aqui a única forma de perguntar o preço à FIPE era ABRINDO A FICHA do
     carro: a função pintava direto no `#efVersoes`, então quem não tivesse o
     formulário na tela não tinha como usar.

     O Angelo pediu um "Atualizar FIPE" no menu do card, onde não há
     formulário nenhum. A saída óbvia — copiar a busca pro lugar novo — é
     exatamente o erro que a v841 pagou com o `_marca.js`: DUAS buscas pro
     mesmo assunto, e uma delas aprende sozinha. Então a busca virou uma
     função sem tela, e o formulário passou a ser só mais um cliente dela.

     🔴 ELA NÃO TOCA NO DOM. Se um dia alguém puser um `$('...')` aqui dentro,
     o "Atualizar FIPE" volta a depender da ficha aberta — sem erro nenhum
     aparecer, porque `$()` de um id ausente devolve null e o código segue.
     ⚠️ Devolve a LISTA de versões, a melhor na frente. Quem quiser só a
     melhor pega `[0]`; o formulário precisa das outras pro seletor.
     ========================================================================== */
  async function fipeBuscaMelhor(d){
      var marcas=await fipeGet('/carros/marcas');
      var mn=_fipeNomeNormal(d.marca), aliases=mn==='vw'?['vw','volkswagen']:[mn];
      var marca=(marcas||[]).filter(function(m){ var n=_fipeNomeNormal(m.nome); return aliases.indexOf(n)>=0||aliases.some(function(a){ return n.indexOf(a)>=0||a.indexOf(n)>=0; }); })[0];
      if(!marca) throw new Error('Marca não encontrada na FIPE.');
      var rm=await fipeGet('/carros/marcas/'+marca.codigo+'/modelos');
      var busca=[d.modelo_base,d.modelo,d.versao,d.titulo].filter(Boolean).join(' ');
      var toks=_fipeTokens(busca), base=(_fipeTokens(d.modelo_base||d.modelo)[0]||'');
      var candidatos=((rm&&rm.modelos)||[]).map(function(m){
        var n=_fipeNomeNormal(m.nome), score=0;
        if(base&&n.split(' ').indexOf(base)>=0) score+=30;
        toks.forEach(function(t){ if(n.split(' ').indexOf(t)>=0) score+=5; else if(n.indexOf(t)>=0) score+=2; });
        return {codigo:m.codigo,nome:m.nome,score:score};
      }).filter(function(m){ return m.score>0; }).sort(function(a,b){ return b.score-a.score; }).slice(0,8);
      if(!candidatos.length) throw new Error('Modelo não encontrado na FIPE.');
      var anoAlvo=String(d.ano_modelo||d.ano||'');
      var fuel=_fipeNomeNormal(d.combustivel);
      var resolvidos=await Promise.all(candidatos.map(async function(m){
        try{
          var anos=await fipeGet('/carros/marcas/'+marca.codigo+'/modelos/'+m.codigo+'/anos');
          var comp=(anos||[]).filter(function(a){ return !anoAlvo||String(a.codigo||'').indexOf(anoAlvo)===0; });
          if(!comp.length) return null;
          var ae=comp.filter(function(a){ return fuel&&_fipeNomeNormal(a.nome).indexOf(fuel)>=0; })[0]||comp[0];
          var fv=await fipeGet('/carros/marcas/'+marca.codigo+'/modelos/'+m.codigo+'/anos/'+encodeURIComponent(ae.codigo));
          var valor=_fipeValorNumero(fv&&fv.Valor); if(!fv||!valor) return null;
          /* v302: no 0 km a FIPE devolve AnoModelo = 32000. Isso NÃO é um
             ano — se entrasse aqui, iria parar no cadastro do carro e
             depois no catálogo público como "32000". Fica vazio: o preço da
             FIPE vale, o ano quem escreve é o lojista. */
          var anoFv = fipeEhZeroKm(fv&&fv.AnoModelo) ? '' : String((fv&&fv.AnoModelo)||anoAlvo||'');
          if(fipeEhZeroKm(anoAlvo)) anoFv='';
          return { descricao:fv.Modelo||m.nome, ano:anoFv, zero_km:fipeEhZeroKm(fv&&fv.AnoModelo), combustivel:fv.Combustivel||'', valor:valor, codigo_fipe:fv.CodigoFipe||'', mes_ref:fv.MesReferencia||'', _score:m.score };
        }catch(_){ return null; }
      }));
      var vistos={};
      var ops=resolvidos.filter(Boolean).sort(function(a,b){ return b._score-a._score; }).filter(function(o){ var k=String(o.codigo_fipe||o.descricao); if(vistos[k]) return false; vistos[k]=1; return true; }).slice(0,8);
      if(!ops.length) throw new Error('Não encontrei uma versão desse ano na FIPE.');
      return ops;
  }
  /* O formulário: a MESMA busca de cima, mais a pintura da tela. */
  async function estImportarFipe(d){
    var box=$('efVersoes'); if(!box) return null;
    box.innerHTML='<div class="est-verload"><span class="spin"></span>Buscando a versão correta na tabela FIPE…</div>';
    try{
      var ops=await fipeBuscaMelhor(d);
      estVersoesPinta({importacao:true,fipe:ops[0].valor,fipe_opcoes:ops});
      estVersaoAplicar(ops,0,true);
      return ops[0];
    }catch(e){
      box.innerHTML='<div class="est-vererro">Não consegui confirmar a versão na FIPE. O anúncio continua salvo; escolha a versão manualmente para conferir.</div>'+estVersaoManualAcoes();
      estVersaoManualWire();
      return null;
    }
  }
  /* Importa, preenche e salva imediatamente. O link e os dados precisam
     continuar disponíveis quando a ficha for fechada e aberta de novo. */
  /* v654 — `op.semIa` desliga a ficha técnica por IA (o segundo token). Quem
     usa é o buscador de página, em lote: a confirmação promete "N veículos ·
     N tokens" e essa promessa tem que ser verdade. No carro avulso nada muda.
     ⚠️ E a função agora DIZ se deu certo (true/false) — sem isso o lote conta
     como importado o carro que falhou. */
  async function estImportarAnuncio(op){
    op=op||{};
    var urlEl=$('efImportUrl'), btn=$('efImportBtn'); var url=String((urlEl&&urlEl.value)||'').trim();
    if(!url){ estImportMsg('Cole o link do anúncio para importar.','err'); if(urlEl) urlEl.focus(); return false; }
    if(_estEditId && !op.semIa && !confirm('Importar vai substituir os dados e as fotos deste veículo. Quer continuar?')) return false;
    var rotulo=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='Importando…'; }
    estImportMsg('Extraindo os dados e copiando as fotos · '+precoReal(1)+'…','load');
    try{
      var r=await apiComTimeout('/api/importar-anuncio',{url:url},55000);
      if(r&&r.saldo!=null) setSaldo(r.saldo);
      if(r&&r.sem_saldo){ estImportMsg('Saldo insuficiente para importar o anúncio.','err'); return false; }
      if(!r||!r.ok) throw new Error(((r&&r.erro)||'Não consegui importar esse anúncio.')+(r&&r.estornado?' Valor devolvido ao saldo.':''));
      var d=r.dados||{};
      /* Importar substitui os campos do anúncio. Limpar antes evita que valores
         do veículo anterior contaminem a FIPE quando a fonte não informa algo. */
      estImportLimparCampos();
      estImportSet('efPlaca',d.placa); estImportSet('efMarca',d.marca); estImportSet('efModelo',d.modelo); estImportSet('efAno',d.ano); estImportSet('efAnoMod',d.ano_modelo); estImportSet('efCor',d.cor);
      estImportSet('efCombustivel',d.combustivel); estImportSet('efCambio',d.cambio);
      estImportSet('efKm',d.km?Number(d.km).toLocaleString('pt-BR'):'');
      estImportSet('efAnuncio',d.preco_anuncio?_rs(d.preco_anuncio):'');
      var obs=[]; if(d.descricao) obs.push(String(d.descricao));
      estImportSet('efObs',obs.join('\n\n'));
      estImportSet('exOpc',d.opcionais||'');
      /* Mesmo teto do importador: preserva o carrossel completo do Instagram. */
      _estFotos=Array.isArray(d.fotos)?d.fotos.slice(0,20):[];
      /* 🔴🔴 v652 — TINHA UM NOME DE LOJA CRAVADO AQUI, EM DOIS LUGARES.
         Era `r.origem || 'Motomecânica'`. Quando a origem vinha vazia — que é
         o caso de toda loja que o app ainda não conhece pelo domínio — o
         carro nascia localizado na **Motomecânica**. Um carro do Kolina, de
         Criciúma, entrava no estoque como se estivesse em Lajeado.
         E entrava CALADO: o campo vem preenchido, com um nome plausível.
         ⚠️ Regra da casa: nome de loja no código, NUNCA. Sem origem, o campo
         fica VAZIO — e campo vazio a pessoa preenche; campo errado ninguém
         percebe. */
      if(!(($('efLocalizacao')||{}).value)) estImportSet('efLocalizacao', r.origem||'');
      _estFipeEscolha=null; _estFipeRemovida=true;
      _estImportFonte={
        url:r.anuncio_url||url, origem:r.origem||'', importado_em:new Date().toISOString(),
        custo_extracao:Number(r.custo||1), modelo_original:d.modelo||'', versao_original:d.versao||'',
        /* 🔑 v652 — O FINAL DA PLACA, GUARDADO COMO CONFERÊNCIA.
           Muita loja publica "Final da placa: XXX1F61" — as três primeiras
           letras escondidas. Isso NÃO é placa e não entra no campo placa (o
           servidor barra desde a v652). Mas é ouro na hora em que o lojista
           digitar a placa de verdade: se o final não bater, ou o carro é
           outro, ou alguém errou de anúncio. Guardar custa nada. */
        final_placa:d.final_placa||''
      };
      if(urlEl) urlEl.value=_estImportFonte.url;
      estImportAcoesPinta();
      estFotosPinta(); try{ estMargemCalc(); }catch(_){}
      var avisos=Array.isArray(r.avisos)&&r.avisos.length?(' '+r.avisos.join(' ')):'';
      /* v652: o anúncio só deu o final da placa? diz isso em voz alta, em vez
         de deixar o campo placa vazio sem explicação. */
      if(d.final_placa) avisos+=' O anúncio só mostra o final da placa ('+esc(d.final_placa)+') — a placa fica em branco pra você digitar.';
      /* Post social pode expor apenas fotos e legenda. Nunca use campos
         antigos para completar a FIPE/IA: só seguimos quando ESTA fonte
         trouxe marca, modelo e algum ano para conferência. */
      var dadosCompletos=!!(d.marca&&d.modelo&&(d.ano||d.ano_modelo));
      if(!dadosCompletos){
        estImportMsg('Legenda e '+Number(r.fotos_importadas||0)+' foto(s) importadas · '+precoReal(1)+'. Complete marca, modelo e ano para consultar a FIPE e gerar a ficha técnica por IA.'+avisos,'ok');
        await estSalvarAuto();
        return true;
      }
      estImportMsg('Dados e '+Number(r.fotos_importadas||0)+' foto(s) importados. Conferindo a versão na FIPE…','load');
      var fi=await estImportarFipe(d);
      if(fi) _estImportFonte.fipe={modelo:fi.descricao,ano_modelo:fi.ano,combustivel:fi.combustivel,valor:fi.valor,codigo_fipe:fi.codigo_fipe,mes_ref:fi.mes_ref};
      /* 🔴 v654 — EM LOTE, A IA NÃO SAI SOZINHA. Ver o comentário no topo desta
         função: a conta prometida na tela do buscador é 1 token por carro. */
      if(op.semIa){
        estImportMsg('Dados e '+Number(r.fotos_importadas||0)+' foto(s) importados · '+precoReal(1)+'.'+avisos,'ok');
        await estSalvarAuto();
        return true;
      }
      estImportMsg('Dados prontos. Gerando a ficha técnica por IA · '+precoReal(1)+'…','load');
      var fr=await estFichaGerarIA(_ftRefAtual(),{salvar:false});
      if(fr&&fr.ok) estImportMsg('Importação concluída: dados, fotos e ficha técnica prontos · '+precoReal(2)+'. Revise antes de salvar.'+avisos,'ok');
      else {
        var motivo=(fr&&fr.sem_saldo) ? 'Faltou saldo para gerar a ficha por IA.' :
          ((fr&&fr.estornado) ? 'A ficha por IA não pôde ser gerada agora; o valor dessa etapa foi devolvido ao saldo.' : 'A ficha por IA não trouxe dados técnicos utilizáveis; não vou marcá-la como pronta. Tente novamente pela aba Ficha técnica.');
        estImportMsg('Dados e fotos importados · '+precoReal(1)+'. '+motivo+avisos,(fr&&fr.sem_saldo)?'err':'ok');
      }
      await estSalvarAuto();
      return true;
    }catch(e){ estImportMsg((e&&e.message)||'Falha ao importar o anúncio.','err'); return false; }
    finally{ if(btn){ btn.disabled=false; btn.textContent=_estImportFonte?'Atualizar importação':(rotulo||'Importar'); } }
  }
  function estPreencheVeic(v, soVazio){
    function setv(id,val){ var e=$(id); if(!e||val==null||val==='') return; if(soVazio&&e.value) return; e.value=val; }
    setv('efMarca',(String(v.marca||'').split(/[\s\-]/)[0])||v.marca);
    setv('efModelo',v.modelo||((v.marca||'')+' '+(v.modelo||'')).trim());
    setv('efAno',v.ano); setv('efAnoMod',v.ano_modelo||v.ano); setv('efCor',v.cor); setv('efCombustivel',v.combustivel); setv('efCambio',v.cambio);
    var fi=$('efFipe'); if(fi&&v.fipe&&(!soVazio||!fi.value)) fi.value=_rsF(v.fipe);
    /* v345: completa ano modelo, combustível e câmbio lendo o nome da versão
       (o texto que a própria FIPE devolve). Só mexe em campo vazio. Mora no
       14b-completar-placa.js. */
    try{ estCompletarPelaVersao(v); }catch(_){}
    try{ estMargemCalc(); }catch(_){}
    try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
  }
  function estVersaoAplicar(ops,idx,soVazio){
    var o=ops[Number(idx)||0]; if(!o) return;
    _estFipeRemovida=false;
    var modeloEl=$('efModelo'), modeloAnterior=String((modeloEl&&modeloEl.value)||'').trim();
    if(modeloEl&&o.descricao) modeloEl.value=o.descricao;
    /* v302: só escreve o ano quando ele É um ano. O 0 km da FIPE chega
       aqui sem ano de propósito (veja o comentário em efFmEscolherValor). */
    if(o.ano && !fipeEhZeroKm(o.ano)){ var am=$('efAnoMod'); if(am) am.value=o.ano; var af=$('efAno'); if(af&&!af.value) af.value=o.ano; }
    if($('efCombustivel')&&o.combustivel) $('efCombustivel').value=o.combustivel;
    var fi=$('efFipe'); if(fi&&o.valor&&(!soVazio||!_rsLer(fi.value))) fi.value=_rsF(o.valor);
    _estFipeEscolha={modelo:o.descricao||'',ano_modelo:o.ano||'',combustivel:o.combustivel||'',valor:Number(o.valor)||0,codigo_fipe:o.codigo_fipe||'',mes_ref:o.mes_ref||''};
    if(_estImportFonte) _estImportFonte.fipe=Object.assign({},_estFipeEscolha);
    estModeloFipeSincronizar(modeloAnterior,o.descricao||'');
    try{ estCompletarPelaVersao(o); }catch(_){}   /* v345 */
    try{ estMargemCalc(); }catch(_){}
  }
  function estModeloFipeSincronizar(anterior,novo){
    anterior=String(anterior||'').trim(); novo=String(novo||'').trim(); if(!novo) return;
    var marca=String((($('efMarca')||{}).value)||'').trim();
    var titulo=$('efTitulo'), nomeNovo=(marca+' '+novo).trim(); if(titulo&&nomeNovo) titulo.textContent=nomeNovo;
    try{ _mktV=_estFichaVeic(); }catch(_){}
    if(!anterior||anterior===novo) return;
    var atual=null;
    try{ atual=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0]||null; }catch(_){}
    var ex=Object.assign({},(atual&&atual.extras)||{});
    var mem=(_postIaFicha&&String(_postIaFicha.id||'')===String(_estEditId||''))?_postIaFicha:{id:(_estEditId||'')};
    var nomeAnterior=(marca+' '+anterior).trim(), mudou=false;
    function ajustar(post){
      post=String(post||''); if(!post) return '';
      var atualizado=post;
      if(nomeAnterior&&atualizado.indexOf(nomeAnterior)>=0) atualizado=atualizado.replace(nomeAnterior,nomeNovo);
      else if(atualizado.indexOf(anterior)>=0) atualizado=atualizado.replace(anterior,novo);
      if(atualizado!==post) mudou=true;
      return atualizado;
    }
    var social=ajustar(ex.post_ia||mem.post), marketplace=ajustar(ex.post_marketplace_ia||mem.marketplace);
    if(!mudou) return;
    if(social){ ex.post_ia=social; ex.post_ia_em=ex.post_ia_em||new Date().toISOString(); mem.post=social; mem.em=ex.post_ia_em; }
    if(marketplace){ ex.post_marketplace_ia=marketplace; ex.post_marketplace_ia_em=ex.post_marketplace_ia_em||new Date().toISOString(); mem.marketplace=marketplace; mem.marketplace_em=ex.post_marketplace_ia_em; }
    if(atual) atual.extras=ex;
    _postIaFicha=mem;
    try{ if(_mktV) _mktV.extras=ex; mktPostSalvoPinta(_mktV||atual); }catch(_){}
  }
  /* Seleção manual da FIPE na importação. Mantém os passos canônicos
     marca → ano do modelo → modelo/versão → combustível; o modelo só aparece
     quando existir para o ano escolhido. */
  var _efFmCombo={}, _efFmCache={}, _efFmPedido=0;
  function efFmHtml(id,label,ph){
    return '<div class="fm-field"><label class="fm-lbl" for="'+id+'Input">'+esc(label)+'</label><div class="fm-combo"><input id="'+id+'Input" class="fm-sel" placeholder="'+esc(ph||'-')+'" autocomplete="off" autocapitalize="off" disabled><input type="hidden" id="'+id+'"><div class="fm-drop" id="'+id+'Drop" style="display:none"></div></div></div>';
  }
  function efFmSet(id,items,ph){ var i=$(id+'Input'), h=$(id), b=$(id+'Drop'); _efFmCombo[id]=items||[]; if(h) h.value=''; if(i){ i.value=''; i.placeholder=ph||'Digite para buscar'; i.disabled=!(items&&items.length); } if(b){ b.style.display='none'; b.innerHTML=''; } }
  function efFmReset(id,ph){ efFmSet(id,[],ph||'-'); }
  function efFmDropPinta(id,lista,vazio){
    var b=$(id+'Drop'); if(!b) return;
    if(!lista||!lista.length){ b.innerHTML='<div class="fm-drop-empty">'+esc(vazio||'Nada encontrado')+'</div>'; b.style.display='block'; return; }
    b.innerHTML=lista.slice(0,80).map(function(o){ return '<button type="button" class="fm-drop-it" data-cod="'+esc(o.codigo)+'" data-nome="'+esc(o.nome)+'">'+esc(o.nome)+'</button>'; }).join(''); b.style.display='block';
    Array.prototype.forEach.call(b.querySelectorAll('.fm-drop-it'),function(x){ x.onmousedown=function(e){ e.preventDefault(); }; x.onclick=function(){ efFmPick(id,x.getAttribute('data-cod'),x.getAttribute('data-nome')); }; });
  }
  async function efFmModeloDrop(termo){
    var ano=String((($('efFmAnoRef')||{}).value)||''), marca=String((($('efFmMarca')||{}).value)||''), b=$('efFmModeloDrop'); termo=String(termo||'').toLowerCase().trim();
    if(!b||!ano||!marca) return;
    if(termo.length<2){ efFmDropPinta('efFmModelo',[],'Digite pelo menos 2 letras para filtrar versões de '+ano+'.'); return; }
    var candidatos=(_efFmCombo.efFmModelo||[]).filter(function(o){ return String(o.nome||'').toLowerCase().indexOf(termo)>=0; }).slice(0,60);  /* v243: era 18 e cortava versoes */
    if(!candidatos.length){ efFmDropPinta('efFmModelo',[],'Nenhum modelo dessa marca contém esse texto.'); return; }
    var chave=[marca,ano,termo].join('|'), memo=_efFmCache[chave];
    if(memo){ efFmDropPinta('efFmModelo',memo,'Nenhuma versão encontrada para '+ano+'.'); return; }
    var pedido=++_efFmPedido; b.innerHTML='<div class="fm-drop-empty"><span class="spin"></span> Conferindo versões de '+esc(ano)+'…</div>'; b.style.display='block';
    var achados=[];
    for(var _i=0;_i<candidatos.length;_i+=8){
      var _lote=await Promise.all(candidatos.slice(_i,_i+8).map(async function(o){
        var anos=await _fmAnosDoModelo('carros',marca,o.codigo);
        return (anos&&anos.some(function(a){ return _fipeItemNoAno(a,ano); }))?o:null;
      }));
      achados=achados.concat(_lote);
      if(pedido!==_efFmPedido) return;
    }
    if(pedido!==_efFmPedido || String((($('efFmModeloInput')||{}).value)||'').toLowerCase().trim()!==termo) return;
    memo=achados.filter(Boolean); _efFmCache[chave]=memo; efFmDropPinta('efFmModelo',memo,'Nenhuma versão encontrada para '+ano+'. Tente outro nome ou ano.');
  }
  function efFmDrop(id,termo){
    if(id==='efFmModelo' && (($('efFmAnoRef')||{}).value)){ efFmModeloDrop(termo); return; }
    termo=String(termo||'').toLowerCase().trim(); efFmDropPinta(id,(_efFmCombo[id]||[]).filter(function(o){ return !termo||String(o.nome||'').toLowerCase().indexOf(termo)>=0; }),'Nada encontrado');
  }
  function efFmWire(id){ var i=$(id+'Input'); if(!i) return;
    i.oninput=function(){ var h=$(id); if(h) h.value=''; if(id==='efFmMarca'){ efFmReset('efFmAnoRef','Escolha a marca primeiro'); efFmReset('efFmModelo','Escolha marca e ano primeiro'); efFmReset('efFmCombustivel','-'); } else if(id==='efFmAnoRef'){ efFmReset('efFmModelo','Escolha marca e ano primeiro'); efFmReset('efFmCombustivel','-'); } else if(id==='efFmModelo') efFmReset('efFmCombustivel','-'); efFmDrop(id,this.value); };
    i.onfocus=function(){ efFmDrop(id,this.value); };
    i.addEventListener('blur',function(){ setTimeout(function(){ var b=$(id+'Drop'); if(b) b.style.display='none'; },180); });
  }
  async function efFmCarregarModelos(marca,ano){
    efFmReset('efFmModelo','Carregando modelos…'); efFmReset('efFmCombustivel','-');
    try{ var d=await fipeGet('/carros/marcas/'+encodeURIComponent(marca)+'/modelos'); efFmSet('efFmModelo',(d&&d.modelos)||[],'Digite ao menos 2 letras para filtrar versões de '+ano); }
    catch(_){ efFmReset('efFmModelo','Erro ao carregar'); }
  }
  async function efFmCarregarAnos(marca,modelo,anoFiltro){
    efFmReset('efFmCombustivel','Carregando opções…');
    try{
      var d=await fipeGet('/carros/marcas/'+encodeURIComponent(marca)+'/modelos/'+encodeURIComponent(modelo)+'/anos');
      var opcoes=(d||[]).filter(function(a){ return _fipeItemNoAno(a,anoFiltro); });
      if(!opcoes.length){ efFmReset('efFmCombustivel','Sem opção para '+anoFiltro); var m=$('efFmMsg'); if(m){ m.className='cad-msg err'; m.textContent='Essa versão não existe para o ano escolhido.'; } return; }
      efFmSet('efFmCombustivel',opcoes,opcoes.length===1?'Combustível identificado':'Escolha o combustível');
      if(opcoes.length===1) efFmPick('efFmCombustivel',opcoes[0].codigo,opcoes[0].nome);
    }catch(_){ efFmReset('efFmCombustivel','Erro ao carregar'); }
  }
  async function efFmEscolherValor(marca,modelo,ano){
    var m=$('efFmMsg'); if(m){ m.className='cad-msg'; m.textContent='Consultando a FIPE…'; }
    try{
      var d=await fipeGet('/carros/marcas/'+encodeURIComponent(marca)+'/modelos/'+encodeURIComponent(modelo)+'/anos/'+encodeURIComponent(ano));
      if(!d||!d.CodigoFipe) throw new Error('sem resposta');
      var zk=fipeEhZeroKm(d.AnoModelo);
      var o={descricao:d.Modelo||(($('efFmModeloInput')||{}).value||''),ano:(zk?'':String(d.AnoModelo||'')),zero_km:zk,combustivel:d.Combustivel||'',valor:_fipeValorNumero(d.Valor),codigo_fipe:d.CodigoFipe||'',mes_ref:d.MesReferencia||''};
      estVersaoAplicar([o],0,false);
      if(_estImportFonte) _estImportFonte.fipe={modelo:o.descricao,ano_modelo:o.ano,combustivel:o.combustivel,valor:o.valor,codigo_fipe:o.codigo_fipe,mes_ref:o.mes_ref};
      estVersoesPinta({importacao:true,fipe:o.valor,fipe_opcoes:[o]});
      try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
      /* v1052: a FIPE disse 0 km — OFERECE o interruptor (nunca liga sozinho) */
      try{ if(typeof zkSugerirPelaFipe==='function') zkSugerirPelaFipe(o); }catch(_){}
      /* v302: o 0 km não tem ano na FIPE. Aviso em vez de inventar um. */
      if(m){ m.className='cad-msg'+(zk?'':' ok');
        m.textContent = zk ? 'Preço FIPE do ZERO KM aplicado. A FIPE não informa ano para 0 km — preencha o ano do modelo na ficha.'
                           : 'Versão da FIPE aplicada.'; }
    }catch(_){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui consultar essa versão na FIPE. Tente novamente.'; } }
  }
  function efFmPick(id,cod,nome){ var i=$(id+'Input'),h=$(id),b=$(id+'Drop'); if(i) i.value=nome||''; if(h) h.value=cod||''; if(b){ b.style.display='none'; b.innerHTML=''; }
    if(id==='efFmMarca'){ efFmSet('efFmAnoRef',_fipeAnosParaEscolha(),'Escolha o ano do modelo'); efFmReset('efFmModelo','Escolha marca e ano primeiro'); efFmReset('efFmCombustivel','-'); }
    else if(id==='efFmAnoRef'){ efFmReset('efFmModelo','Carregando modelos…'); efFmReset('efFmCombustivel','-'); if(cod) efFmCarregarModelos(($('efFmMarca')||{}).value,cod); }
    else if(id==='efFmModelo'){ efFmReset('efFmCombustivel','Carregando opções…'); if(cod) efFmCarregarAnos(($('efFmMarca')||{}).value,cod,($('efFmAnoRef')||{}).value); }
    else if(id==='efFmCombustivel'&&cod) efFmEscolherValor(($('efFmMarca')||{}).value,($('efFmModelo')||{}).value,cod);
  }
  function estFipeManualAbrir(){
    var host=$('efVersaoManual'); if(!host) return;
    host.innerHTML='<section class="est-fipe-manual"><div class="est-verlbl">'+mkIco('ficha',14)+'Selecionar versão manualmente na FIPE</div><p>Escolha a marca, o ano do modelo e a versão. Só aparecem versões disponíveis no ano escolhido.</p>'+efFmHtml('efFmMarca','Marca','Carregando marcas...')+efFmHtml('efFmAnoRef','Ano do modelo','Escolha a marca primeiro')+efFmHtml('efFmModelo','Modelo / versão','Escolha marca e ano primeiro')+efFmHtml('efFmCombustivel','Combustível','-')+'<div class="cad-msg" id="efFmMsg"></div><button type="button" class="est-import-act" id="efFmCancelar">Cancelar seleção manual</button></section>';
    ['efFmMarca','efFmAnoRef','efFmModelo','efFmCombustivel'].forEach(efFmWire);
    var cancelar=$('efFmCancelar'); if(cancelar) cancelar.onclick=function(){ var h=$('efVersaoManual'); if(h) h.innerHTML=''; };
    fipeGet('/carros/marcas').then(function(marcas){
      efFmSet('efFmMarca',marcas||[],'Digite ou toque para escolher a marca');
      var original=_fipeNomeNormal((($('efMarca')||{}).value)||''), alvo=(marcas||[]).filter(function(m){ var n=_fipeNomeNormal(m.nome); return n===original || n.indexOf(original)>=0 || original.indexOf(n)>=0; })[0];
      if(alvo){ efFmPick('efFmMarca',alvo.codigo,alvo.nome); var ano=String((($('efAnoMod')||{}).value)||(($('efAno')||{}).value)||'').match(/(?:19|20)\d{2}/); if(ano) efFmPick('efFmAnoRef',ano[0],ano[0]); }
    }).catch(function(){ efFmReset('efFmMarca','Erro ao carregar'); var m=$('efFmMsg'); if(m){ m.className='cad-msg err'; m.textContent='Não consegui carregar as marcas da FIPE.'; } });
  }
  function estVersaoManualAcoes(){
    return '<div class="est-ver-actions"><button type="button" class="est-import-act" id="efVersaoManualBtn">'+mkIco('lapis',15)+'Alterar manualmente</button><button type="button" class="est-import-act est-ver-remove" id="efVersaoLimparBtn">'+mkIco('lixeira',15)+'Remover versão FIPE</button></div><div id="efVersaoManual"></div>';
  }
  function estVersaoManualWire(){ var manual=$('efVersaoManualBtn'), limpar=$('efVersaoLimparBtn'); if(manual) manual.onclick=estFipeManualAbrir; if(limpar) limpar.onclick=estVersaoLimpar; }
  function estVersaoLimpar(){
    if(!confirm('Remover a versão FIPE e o valor FIPE deste veículo?\n\nOs preços mínimo e de anúncio serão preservados.')) return;
    _estFipeRemovida=true;
    _estFipeEscolha=null; if(_estImportFonte) delete _estImportFonte.fipe;
    var fipeEl=$('efFipe'); if(fipeEl) fipeEl.value='';
    var base=String((_estImportFonte&&_estImportFonte.modelo_original)||'').trim(), modelo=$('efModelo'), anterior=String((modelo&&modelo.value)||'').trim();
    if(modelo&&base){ modelo.value=base; estModeloFipeSincronizar(anterior,base); }
    var box=$('efVersoes'); if(box){ box.innerHTML='<div class="est-vererro">Versão FIPE removida. O anúncio continua salvo; escolha outra versão manualmente se precisar.</div>'+estVersaoManualAcoes(); estVersaoManualWire(); }
    try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
  }
  function estVersoesPinta(r){
    var box=$('efVersoes'); if(!box) return; box.innerHTML='';
    var ops=((r&&r.fipe_opcoes)||[]).filter(function(o){return o.valor!=null;});
    if(ops.length<(r&&r.importacao?1:2)) return;
    var titulo=(r&&r.importacao)?'Versão FIPE sugerida — confira se é a correta:':(ops.length+' versões pra esta placa — escolha a correta:');
    box.innerHTML='<div class="est-verlbl">'+mkIco('ficha',14)+esc(titulo)+'</div><select class="cad-in" id="efVerSel">'+ops.map(function(o,i){ var txt=[o.descricao,o.ano,o.combustivel].filter(Boolean).join(' · '); var sel=(Math.round(Number(o.valor))===Math.round(Number(r.fipe)))?' selected':''; return '<option value="'+i+'"'+sel+'>'+esc(txt+' — '+brl(o.valor))+'</option>'; }).join('')+'</select>'+((r&&r.importacao)?estVersaoManualAcoes():'');
    $('efVerSel').onchange=function(){ estVersaoAplicar(ops,this.value,false); try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){} };
    if(r&&r.importacao) estVersaoManualWire();
  }
  function estPlacaHist(placa){
    var p=limpa(placa); if(!valida(p)) return;
    /* v174 (I) — nao escreve mais "Preenchi do seu historico": a placa ja'
       estava ali e os campos aparecem preenchidos sozinhos, o aviso so' ocupava linha. */
    var it=histLerUm(p); if(it&&it.v){ estPreencheVeic(it.v,true); estVersoesPinta(it.v); var m=$('efPlMsg'); if(m){ m.className='cad-msg'; m.textContent=''; } }
  }
  async function estBuscaPlaca(){
    var pEl=$('efPlaca'); var placa=limpa((pEl&&pEl.value)||''); var m=$('efPlMsg');
    if(!valida(placa)){ if(m){ m.className='cad-msg err'; m.textContent='Digite uma placa válida (ABC1234 ou ABC1D23).'; } return; }
    var it=histLerUm(placa); if(it&&it.v){ estPreencheVeic(it.v); if(m){ m.className='cad-msg'; m.textContent=''; } return; }
    var btn=$('efBuscaPlaca'), lbl=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent='Buscando...'; }
    if(m){ m.className='cad-msg'; m.textContent='Consultando a placa...'; }
    try{
      var d=await api('/api/consultar',{produto:'fipe',placa:placa});
      if(d&&d.sem_saldo){ if(m){ m.className='cad-msg err'; m.textContent='Saldo insuficiente para buscar a placa.'; } }
      else if(d&&d.ok&&d.resultado){ estPreencheVeic(d.resultado); estVersoesPinta(d.resultado); if(m){ m.className='cad-msg ok'; m.textContent='Dados da placa preenchidos ✓'; } }
      else { if(m){ m.className='cad-msg err'; m.textContent=(d&&d.erro)||'Não encontrei a placa.'; } }
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Falha ao buscar a placa.'; } }
    if(btn){ btn.disabled=false; btn.textContent=lbl; }
  }
  /* Abre a ficha do veículo no PAINEL (coluna direita no desktop / overlay no celular).
     id = veículo existente · prefill = dados pra um veículo NOVO (ex.: vindo da consulta) */
  var _estFichaTab='cadastro';

  /* ===== v301 (pedido do Angelo) — VOLTAR CAI NO LUGAR DE ONDE SE SAIU =====
     Antes: abrir um carro e tocar em Voltar remontava a tela do estoque do
     zero. A busca digitada sumia e a lista voltava pro topo. Com 40 carros e
     a busca "gol", ele tocava em Voltar e caía numa lista completa lá em
     cima — tinha que digitar de novo e rolar de novo, TODA vez.

     Guardo três coisas ao abrir a ficha e devolvo as três ao fechar:
     a busca, o filtro e ONDE ele estava.

     Volto pelo CARRO, não pelo número de pixels: rolar até a altura antiga
     erra quando a lista mudou de tamanho — e ela muda toda vez, porque
     salvar o cadastro pode tirar o carro do filtro atual (marcar "vendido"
     dentro de "disponíveis", por exemplo). O número de pixels fica só como
     plano B, pra quando o carro não estiver mais na lista. */
  var _estMemo=null;
  function estMemoGuardar(id){
    if(!$('estLista')) return;                 /* não veio da lista: nada a lembrar */
    _estMemo={
      busca : String((($('estBusca')||{}).value)||''),
      filtro: _estFiltro,
      id    : id ? String(id) : '',
      y     : (window.pageYOffset || document.documentElement.scrollTop || 0)
    };
  }
  function estMemoAplicar(){
    var m=_estMemo; _estMemo=null;             /* vale uma vez só */
    if(!m) return;
    var lista=$('estLista'); if(!lista) return;
    if(m.filtro!==_estFiltro){ _estFiltro=m.filtro; estFiltrosHtml(); }
    var busca=$('estBusca');
    if(busca && m.busca){ busca.value=m.busca; estPinta(m.busca); }
    var alvo = m.id ? lista.querySelector('.est-card[data-id="'+String(m.id).replace(/"/g,'')+'"]') : null;
    if(alvo){
      try{ alvo.scrollIntoView({ block:'center' }); }catch(_){ alvo.scrollIntoView(); }
      estMarcaAtivo(m.id);                     /* acende o card: "é este aqui" */
    }else if(m.y > 0){
      try{ window.scrollTo(0, m.y); }catch(_){}
    }
  }

  function estAbrirFicha(id, prefill){
    /* ===== v452 — O TETO DE VEÍCULOS DO PLANO =====
       Ponto ÚNICO: os dois caminhos de carro novo (o FAB "Novo veículo" e o
       item do menu de ações) chamam esta função com id vazio, e o importar
       de link também passa por aqui. Editar carro que já existe NUNCA é
       barrado — só a entrada de mais um. A conta mora no 09c-plano-repasse.js. */
    if(!id && typeof cabeMaisVeiculo==='function' && !cabeMaisVeiculo()){ avisarTetoVeiculos(); return; }
    estMemoGuardar(id);
    var v = id ? _estoque.filter(function(x){return String(x.id)===String(id);})[0] : (prefill||null);
    _estEditId = (id && v) ? v.id : null;
    _estFotos = (v&&v.fotos&&v.fotos.slice)?v.fotos.slice():[];
    /* v903 — o espelho da avaliação é DAQUELE carro: abrir outra ficha zera,
       senão as fotos do carro anterior apareceriam oferecidas no seguinte. */
    try{ if(typeof estFotosAvLimpar==='function') estFotosAvLimpar(); }catch(_){ }
    _estImportFonte=(v&&v.extras&&v.extras.importacao_anuncio)?v.extras.importacao_anuncio:null;
    _estFipeEscolha=(v&&v.extras&&v.extras.fipe)?v.extras.fipe:null;
    _estFipeRemovida=false;
    _estFichaTab='cadastro';
    /* ==========================================================================
       🔴 v781 — A FICHA DAQUELE CARRO, BUSCADA NA HORA DE ABRIR
       A lista não traz mais a ficha técnica (são 74 KB por abertura). Quando o
       lojista ABRE um carro, a ficha DELE vem sozinha, sem esperar, e a tela
       se repinta quando chegar.
       POR QUE É SEGURO NA PRÁTICA: a aba que abre por padrão é `cadastro`,
       nunca `ficha` (a linha acima). O lojista precisa TOCAR na aba Ficha pra
       ver o conteúdo — e nesse meio tempo a busca de UMA linha já voltou. Se
       ele for rápido demais, a aba pinta vazia e se repinta sozinha.
       E na maioria das vezes nem acontece: o localStorage (_ftKey) e o cache
       de memória já têm a ficha. Isto só dispara em aparelho novo ou depois
       de limpar o navegador.
       ⚠️ NÃO escrever direto no window._estFichaCache aqui: a chave dele é a
       placa já normalizada pelo _ftRefAtual(), e errar a normalização cria um
       cache que nunca é encontrado. Basta preencher `v.ficha_tec` — a própria
       fichaTecObter passa a ler dali no terceiro caminho e cuida do cache e do
       localStorage sozinha, como já faz hoje.
       ⚠️ E por que não `await`: a fichaTecObter e a estAbrirFicha são
       SÍNCRONAS, chamadas no meio de pintura de tela. Virar as duas do avesso
       pra esperar uma linha seria trocar 74 KB por uma tela que trava. */
    if(_estEditId && v && !v.ficha_tec){
      try{
        supa.from('estoque').select('ficha_tec').eq('id', v.id).limit(1)
          .then(function(r){
            var ft = r && r.data && r.data[0] && r.data[0].ficha_tec;
            if(!ft) return;
            v.ficha_tec = ft;                      /* a linha em memória, e só isso */
            try{ if(_estFichaTab==='ficha') estFichaBox(); }catch(_){}
          }, function(){ /* sem ficha na nuvem: o localStorage ainda pode ter */ });
      }catch(_){ }
    }
    var titulo = v ? (((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo') : 'Novo veículo';
    var paineis=estPaineisHtml(v);
    var _EF_ICO={
      cadastro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
      fotos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
      custos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
      ficha:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>',
      diferenciais:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
      marketing:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>',
      clientes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9.5" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'
    };
    /* v174 (K): a aba "Diferenciais" saiu daqui — ela virou o topo da aba Marketing.
       v219: Pós-vendas pertence ao negócio concluído e fica em Vendas fechadas. */
    /* Custos fica preservado no DOM e na coleta para que ocultar a aba nao
       apague valores antigos. A interface publica somente as jornadas que o
       usuario precisa usar agora. */
    var _tabs=[['cadastro','Veículo'],['fotos','Fotos'],['ficha','Ficha técnica'],['marketing','Marketing'],['clientes','Clientes']]
      .concat((typeof seoTabDef==='function')?seoTabDef():[]);   /* v1103 — aba SEO, só admin (14p-) */
    var _nav=_tabs.map(function(t){ return '<button type="button" class="vpx-st" data-step="'+t[0]+'"><span class="vpx-ico">'+(_EF_ICO[t[0]]||t[2]||'')+'</span><span class="vpx-nm">'+t[1]+'</span></button>'; }).join('');
    mevTabSet(''); document.body.classList.add('venda-cot','oper-on');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2 id="efTitulo">'+esc(titulo)+'</h2>'+
      '<div class="vpx"><div class="vpx-steps vpx-mdr" id="efTabs">'+_nav+'</div><div class="vpx-body cad-float" id="efBody">'+
      paineis.cadastro+paineis.fotos+paineis.custos+paineis.ficha+paineis.marketing+paineis.clientes+(paineis.seo||'')+
      '<div class="cad-msg" id="efMsg"></div><div class="cad-autosave vazio" id="efAutosave"></div>'+
      '</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(estFecharFicha);
    mevEstNovo(true);
    consultaUiDockMedir();
    estFichaTabAplica();
    Array.prototype.forEach.call(document.querySelectorAll('#efTabs .vpx-st'),function(b){ b.onclick=function(){ _estFichaTab=b.getAttribute('data-step'); estFichaTabAplica(); }; });
    estWireForm();
    try{ estFichaBox(); }catch(_){}
    try{ estFlagsWire(); }catch(_){}   /* v188 — caixinhas Reservado / Vendido */
    /* Marketing: o post é montado localmente com ESTE veículo. */
    try{ _mktV=_estFichaVeic(); _mktDireto=true; mktPostSalvoPinta(_mktV); }catch(_){}
    estAutosaveWire();
    try{ estEspelhoAplicar(); }catch(_){}   /* v184 — traz o que veio da avaliacao */
  }
  function estFichaTabAplica(){
    Array.prototype.forEach.call(document.querySelectorAll('#efBody .vpx-panel'),function(pn){ pn.classList.toggle('on', pn.getAttribute('data-panel')===_estFichaTab); });
    Array.prototype.forEach.call(document.querySelectorAll('#efTabs .vpx-st'),function(b){ var on=b.getAttribute('data-step')===_estFichaTab; b.classList.toggle('on', on); if(on){ _tabCentra(b.parentNode, b); } });
    /* v174 (J) — CORRIGE O "informe a placa" TEIMOSO.
       A aba Ficha tecnica era desenhada uma unica vez, na hora de abrir o
       veiculo. Se voce digitava a placa DEPOIS (aba Cadastro) e vinha pra ca',
       ela continuava mostrando o texto antigo. Agora, toda vez que voce entra
       nesta aba, ela relanca a leitura da placa. */
    if(_estFichaTab==='ficha'){ try{ estFichaBox(); }catch(_){} }
    /* v347: mesma ideia da Ficha técnica — a lista é montada ao ENTRAR na aba,
       com o que estiver no formulário AGORA (preço de anúncio recém-digitado
       já conta no casamento por faixa). */
    if(_estFichaTab==='clientes'){ try{ cdvFichaPintar(); }catch(_){} }
    if(_estFichaTab==='marketing'){ try{ _mktV=_estFichaVeic(); _mktDireto=true; mktPostSalvoPinta(_mktV); }catch(_){} }
    if(_estFichaTab==='seo'){ try{ if(typeof seoPinta==='function') seoPinta(); }catch(_){} }   /* v1103 — a prévia lê o cadastro de agora */
    /* trocar de aba so' mexe em CLASSE — o observador nao percebe. Avisa na mao. */
    try{ if(window._pdfFabSync) window._pdfFabSync(); }catch(_){}
  }
  /* Ficha técnica dentro do cadastro do veículo. A tela usa a lista manual de
     opcionais da avaliação; a ficha antiga continua preservada para os fluxos
     que já a consomem, mas não existe mais geração por IA nesta aba. */
  window._estFichaCache=window._estFichaCache||{};
  /* v156 — a ficha tecnica gerada passa a ser guardada POR PLACA no proprio aparelho
     (localStorage, sem limite de dias) E dentro do registro do veiculo no estoque
     (extras.ficha_tec, que sobe pra nuvem). Antes ela so ficava no historico de
     consultas, que e limitado — por isso "sumia" e pedia os 3 tokens de novo. */
  function _ftKey(placa){ return 'mev_ft_'+String(placa||'').toUpperCase(); }
  function _ftHash(txt){
    var h=2166136261, s=String(txt||'');
    for(var i=0;i<s.length;i++){ h^=s.charCodeAt(i); h+=(h<<1)+(h<<4)+(h<<7)+(h<<8)+(h<<24); }
    return ('00000'+((h>>>0).toString(36).toUpperCase())).slice(-5);
  }
  /* Anúncios nem sempre mostram a placa. Nesses casos a ficha usa uma chave
     estável formada pelo veículo, sem inventar uma placa para a consulta. */
  function _ftRefAtual(){
    var placa=limpa(String((($('efPlaca')||{}).value)||''));
    if(valida(placa)) return placa;
    var alvo=[(($('efMarca')||{}).value||''),(($('efModelo')||{}).value||''),(($('efAnoMod')||{}).value||(($('efAno')||{}).value)||'')].join('|');
    return alvo.replace(/\|/g,'').trim() ? ('IM'+_ftHash(alvo)) : '';
  }
  function fichaTecGuardar(placa, dd){
    placa=limpa(String(placa||'')); if(!placa||!dd) return;
    if(veiculoAtual&&limpa(String(veiculoAtual.placa||''))===placa){
      var norm=function(x){return String(x||'').toUpperCase().replace(/[^A-Z0-9]/g,'');};
      dd._mevReferencia={modelo:norm(veiculoAtual.modelo),codigo:norm(veiculoAtual.codigo_fipe||veiculoAtual.cod_fipe||veiculoAtual.fipe_codigo)};
    }
    window._estFichaCache[placa]=dd;
    try{ localStorage.setItem(_ftKey(placa), JSON.stringify(dd)); }catch(_){}
    try{ histSetGerado(placa,'fichaTec',dd); }catch(_){}
  }
  function fichaTecObter(placa){
    placa=limpa(String(placa||'')); if(!placa) return null;
    var it=null; try{ it=histLerUm(placa); }catch(_){}
    if(it&&it.fichaTec) return it.fichaTec;
    if(window._estFichaCache[placa]) return window._estFichaCache[placa];
    try{ var sv=localStorage.getItem(_ftKey(placa)); if(sv){ var o=JSON.parse(sv); if(o){ window._estFichaCache[placa]=o; return o; } } }catch(_){}
    try{
      /* v781: a ficha virou COLUNA da mp_estoque. O terceiro caminho olha
         primeiro `v.ficha_tec` e só depois o `v.extras.ficha_tec` antigo — o
         fallback fica de propósito enquanto houver carro que ainda não passou
         pela migração/limpeza. Quem preenche o `v.ficha_tec` na linha em
         memória é a busca sob demanda do estAbrirFicha. */
      var aberto=(_estoque||[]).filter(function(x){ return _estEditId&&String(x.id)===String(_estEditId); })[0];
      var fta=aberto&&limpa(String(aberto.placa||''))===placa&&(aberto.ficha_tec||(aberto.extras&&aberto.extras.ficha_tec));
      if(fta){ window._estFichaCache[placa]=fta; return fta; }
      var v=(_estoque||[]).filter(function(x){ return limpa(String(x.placa||''))===placa; })[0];
      var ft=v&&(v.ficha_tec||(v.extras&&v.extras.ficha_tec));
      if(ft){ window._estFichaCache[placa]=ft; try{ localStorage.setItem(_ftKey(placa), JSON.stringify(ft)); }catch(_){} return ft; }
    }catch(_){}
    return null;
  }
  /* A resposta da IA só é uma ficha de verdade quando há ao menos uma seção
     técnica utilizável. Assim uma resposta com apenas nome de versão nunca
     aparece como "ficha pronta" depois da importação. */
  function fichaTecTemConteudoUtil(dd){
    var p=null; try{ p=fichaTecParse(dd); }catch(_){ return false; }
    if(!p||!p.conhecido) return false;
    function tem(linhas){ return Array.isArray(linhas) && linhas.some(function(l){ return l&&String(l[1]||'').trim(); }); }
    return tem(p.motor)||tem(p.desemp)||tem(p.dim)||tem(p.chassi)||(Array.isArray(p.equip)&&p.equip.length>0);
  }
  function estFichaBox(refPreferida){
    var box=$('efFichaBox'); if(!box) return;
    var ref=refPreferida||_ftRefAtual();
    box.innerHTML=estOpcFichaHtml(ref);
    estOpcFichaWire(box, ref);
  }
  /* O auxiliar de ficha usado somente pela importação foi movido para
     14q-opcionais-estoque.js; não existe mais ação de IA nesta aba. */
  /* o veículo ATUAL da ficha (registro vivo do estoque ou o que está digitado) */
  function _estFichaVeic(){
    var c=estColeta(), ex=c.extras||{}; c.fotos=_estFotos;
    c.id=_estEditId||null;
    c.combustivel=ex.combustivel||''; c.cambio=ex.cambio||'';
    var fi=_estFipeEscolha||ex.fipe||{}; c.versao=fi.modelo||''; c.codigo_fipe=fi.codigo_fipe||''; c.fipe=estRS('efFipe')||Number(fi.valor)||null;
    return c;
  }
  /* ---- Pós-vendas: números em tempo real ---- */
  function estPosVendaCalc(){
    var el=$('pvCustoFinal'); if(!el) return;
    var compra=_ogCompraT(), custos=estCustosTotal(), gar=estRS('pvGarantia'), nf=estRS('pvNf'), venda=estRS('pvVenda');
    var og=_ogTela().og, rec=_ogRecT(venda), cons=(og==='consignado'&&venda>0);
    var custoFinal=_r2(compra+custos+gar);
    el.textContent=custoFinal?_rsF(custoFinal):'—';
    /* v193 — no consignado eu abro a conta: quanto ficou com a loja e quanto
       vai pro dono do carro. Sem isso o "lucro" mentiria pra voce. */
    var rr=$('pvRecRow'); if(rr) rr.style.display=cons?'':'none';
    var rv=$('pvRecVal'); if(rv) rv.textContent=_rsF(rec);
    var cr=$('pvConsigRow'); if(cr) cr.style.display=cons?'':'none';
    var cvv=$('pvConsigVal'); if(cvv) cvv.textContent=_rsF(_r2(venda-rec));
    var mg=$('pvMargemReal'); if(mg){
      if(venda){ var m=_r2(rec-custoFinal-nf); mg.textContent=(m<0?'−':'')+_rsF(Math.abs(m)); mg.style.color=m>=0?'#16a34a':'#dc2626'; }
      else { mg.textContent='—'; mg.style.color=''; }
    }
  }
  /* v188 — as duas caixinhas de situacao sao EXCLUSIVAS: marcar uma desmarca
     a outra, porque um carro nao pode estar reservado e vendido ao mesmo
     tempo. Quem guarda o valor de verdade e' o campo escondido #efStatus —
     assim o resto do app (a lista, os filtros, o catalogo) continua lendo a
     coluna `status` exatamente como sempre leu. */
  function estFlagsAplica(){
    var r=$('efReservado'), d=$('efVendido'), h=$('efStatus'), hint=$('efStatusHint');
    if(!h) return;
    var st=(d&&d.checked)?'vendido':((r&&r.checked)?'reservado':'disponivel');
    h.value=st;
    try{ if(r){ var lr=r.closest('.vd-ck'); if(lr) lr.classList.toggle('on', st==='reservado'); } }catch(_){}
    try{ if(d){ var ld=d.closest('.vd-ck'); if(ld) ld.classList.toggle('on', st==='vendido'); } }catch(_){}
    if(hint) hint.textContent = (st==='vendido')
      ? 'Vendido: sai do cat\u00e1logo p\u00fablico, mas continua aqui no seu estoque.'
      : ((st==='reservado')
         ? 'Reservado: continua aparecendo no cat\u00e1logo, com a tarja amarela.'
         : 'Dispon\u00edvel: aparece normalmente no cat\u00e1logo.');
  }
  function estFlagsWire(){
    var r=$('efReservado'), d=$('efVendido');
    if(r) r.addEventListener('change',function(){ if(r.checked){ var o=$('efVendido'); if(o) o.checked=false; } estFlagsAplica(); try{ estAgendaSalvar(); }catch(_){} });
    if(d) d.addEventListener('change',function(){ if(d.checked){ var o=$('efReservado'); if(o) o.checked=false; } estFlagsAplica(); try{ estAgendaSalvar(); }catch(_){} });
    estFlagsAplica();
  }
  async function estFecharFicha(){
    clearTimeout(_estSaveTimer);
    try{ if($('efPlaca')) await estSalvarAuto(); }catch(_){}
    _estEditId=null; document.body.classList.remove('venda-cot'); await telaEstoque();
    estMemoAplicar();   /* v301: devolve busca, filtro e o lugar da rolagem */
    /* v342: acabou de CADASTRAR um carro? abre a lista de quem pode querer.
       Só depois de fechar a ficha — na hora do insert o cadastro ainda tem
       uma placa e mais nada, e lista montada em cima de ficha vazia não
       serve pra ninguém. */
    try{ cdvAoFecharFicha(); }catch(_){}
  }
  function estMarcaAtivo(id){ try{ Array.prototype.forEach.call(document.querySelectorAll('#estLista .est-card'),function(c){ c.classList.toggle('ativo', id!=null && String(c.getAttribute('data-id'))===String(id)); }); }catch(_){} }
  /* ---------- SALVAR AUTOMÁTICO do estoque (sem botão) ---------- */
  var _estSaveTimer=null, _estSaveLast='';
  /* v1209 — capa não espera o autosave genérico da ficha.

     A v1202 já colocava as gravações em fila, mas ainda dizia "virou capa"
     ANTES de o Supabase devolver a linha. Também dependia do DOM da ficha:
     se a pessoa saísse por um atalho global durante os 650 ms do debounce,
     estSalvarAutoAgora encontrava #efPlaca ausente e descartava a mudança.

     Esta porta captura id + ordem agora, entra na MESMA fila (logo nenhuma
     gravação velha pode terminar depois dela), atualiza somente `fotos` e
     exige a linha de volta. Ela continua obedecendo integralmente a RLS; não
     usa service role, RPC privilegiada nem muda permissão alguma. */
  function estCapaSalvar(id, fotos){
    id=String(id||'').trim();
    var ordem=Array.isArray(fotos)?fotos.slice():[];
    if(!ordem.length) return Promise.reject(new Error('A foto de capa não foi encontrada.'));
    if(!id){
      /* Veículo ainda novo: a primeira gravação precisa criar a linha inteira.
         Sem debounce, para a capa também ficar confirmada antes de sair. */
      clearTimeout(_estSaveTimer);
      return estSalvarAuto().then(function(){
        if(!_estEditId) throw new Error('Não foi possível criar o veículo para salvar a capa.');
        return {id:String(_estEditId), fotos:ordem.slice()};
      });
    }
    _estSaveFila=_estSaveFila.catch(function(){}).then(async function(){
      var up=await supa.from('estoque')
        .update({fotos:ordem, atualizado_em:new Date().toISOString()})
        .eq('id',id)
        .select('id,fotos');
      estConfereGravou(up,'estCapaSalvar',1);
      var linha=up&&up.data&&up.data[0];
      var confirmadas=linha&&Array.isArray(linha.fotos)?linha.fotos.slice():[];
      if(JSON.stringify(confirmadas)!==JSON.stringify(ordem)){
        throw new Error('O banco não confirmou a nova ordem das fotos.');
      }
      var v=(_estoque||[]).filter(function(x){ return String(x.id)===id; })[0];
      if(v) v.fotos=confirmadas.slice();
      if(String(_estEditId||'')===id) _estFotos=confirmadas.slice();
      return {id:id, fotos:confirmadas};
    });
    return _estSaveFila;
  }
  function estColeta(){
    var placa=String((($('efPlaca')||{}).value||'')).trim();
    var modelo=String((($('efModelo')||{}).value||'')).trim();
    var fipeTela=estRS('efFipe')||null;
    return { placa:placa, marca:String((($('efMarca')||{}).value||'')).trim(), modelo:modelo, ano:String((($('efAno')||{}).value||'')).trim(), ano_modelo:String((($('efAnoMod')||{}).value||'')).trim(), cor:String((($('efCor')||{}).value||'')).trim(),
      km:estNum('efKm')||null, fipe:fipeTela, preco_minimo:estRS('efMin')||null, preco_anuncio:estRS('efAnuncio')||null, preco_compra:estRS('efCompra')||null, data_entrada:((($('efEntrada')||{}).value)||estHoje()),
      origem:(($('efOrigem')||{}).value||'proprio'), consig_nome:String((($('efConsigNome')||{}).value||'')).trim()||null, consig_fone:String((($('efConsigFone')||{}).value||'')).trim()||null, consig_pct:(parseFloat(String((($('efConsigPct')||{}).value)||'').replace(',','.'))||null),
      custos:{ com_pct:parseFloat(String((($('ecComPct')||{}).value)||'').replace(',','.'))||0, nf_pct:parseFloat(String((($('ecNfPct')||{}).value)||'').replace(',','.'))||0, nf_base:String((($('ecNfBase')||{}).value)||'margem'), hig:estRS('ecHig')||0, pol:estRS('ecPol')||0, fun:estRS('ecFun')||0, pneus:estRS('ecPneus')||0, mec:estRS('ecMec')||0, doc:estRS('ecDoc')||0, outros:_ecOutrosLer(), outro_nome:((_ecOutrosLer()[0]||{}).nome||''), outro_val:((_ecOutrosLer()[0]||{}).val||0) },
      status:(($('efStatus')||{}).value||'disponivel'), obs:String((($('efObs')||{}).value||'')).trim(), fotos:_estFotos,
      extras:(function(){ var o=_exDifLidos(); o.opcionais=String((($('exOpc')||{}).value||'')).trim();
        try{ o.opcionais_edicoes=JSON.parse(String((($('efOpcEdicoes')||{}).value)||'{}'))||{}; }catch(_){ o.opcionais_edicoes={}; }
        o.destaques=String((($('exDest')||{}).value||'')).trim(); o.preco_repasse=estRS('efRepasse')||null;
        o.post_hashtags=String((($('exPostHashtags')||{}).value||'')).trim();
        o.combustivel=String((($('efCombustivel')||{}).value||'')).trim(); o.cambio=String((($('efCambio')||{}).value||'')).trim(); o.localizacao_veiculo=String((($('efLocalizacao')||{}).value||'')).trim();
        o.post_mostrar_km=!!(($('mkPostKm')||{}).checked);
        /* v781: a ficha NÃO mora mais aqui dentro — subiu pro primeiro nível
           do registro (reg.ficha_tec, no fim desta função). Deixar de gravá-la
           no extras é o que faz o extras encolher: cada carro que o lojista
           salvar sai daqui já limpo. */
        /* v177 — o post da IA nao esta em nenhum campo da tela. Se a coleta nao
           trouxesse ele de volta, o proximo salvamento automatico apagaria. */
        try{ var _pa=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0]; var _px=(_pa&&_pa.extras)||{};
          var _pi=_px.post_ia||((_postIaFicha && String(_postIaFicha.id||'')===String(_estEditId||'')) ? _postIaFicha.post : '');
          if(_pi){ o.post_ia=_pi; o.post_ia_em=_px.post_ia_em||((_postIaFicha&&_postIaFicha.em)||''); }
          var _pm=_px.post_marketplace_ia||((_postIaFicha && String(_postIaFicha.id||'')===String(_estEditId||'')) ? _postIaFicha.marketplace : '');
          if(_pm){ o.post_marketplace_ia=_pm; o.post_marketplace_ia_em=_px.post_marketplace_ia_em||((_postIaFicha&&_postIaFicha.marketplace_em)||''); }
          /* v199: preserva a origem do anúncio depois que o cadastro for salvo. */
          var _im=_estImportFonte||_px.importacao_anuncio; if(_im) o.importacao_anuncio=_im;
          var _fi=_estFipeRemovida?null:(_estFipeEscolha||_px.fipe); if(_fi){ o.fipe=Object.assign({},_fi); o.fipe.valor=fipeTela; }
          /* v442: o chassi e o renavam digitados na página Pré-RENAVE moram
             aqui dentro do extras. Este objeto é remontado do ZERO a cada
             autosave da ficha — sem esta linha, digitar qualquer letra no
             cadastro do carro apagaria o que foi preenchido lá. Mesmo cuidado
             que o post_ia já exigiu na v177. */
          if(_px.prerenave) o.prerenave=_px.prerenave;
          if(_px.docs) o.docs=_px.docs;   /* v463: documentos do veículo (14f) */
        }catch(_){}
        /* 🔴 v1052 — o 0 km entra no extras. Só ACRESCENTA: o bloco de
           try/catch acima existe desde a v177, quando um salvamento apagou o
           post da IA, e não se encosta nele. */
        try{ if(typeof zkColeta==='function') Object.assign(o, zkColeta()); }catch(_){}
        try{ if(typeof seoColeta==='function') Object.assign(o, seoColeta()); }catch(_){}   /* v1103 — extras.seo (14p-) */
        return o; })(),
      /* v219: Pós-vendas saiu da ficha do estoque. Ao salvar outro campo deste
         veículo, mantenha intacto o histórico financeiro que agora é editado
         na página Vendas fechadas. */
      pos_venda:(function(){
        var atual=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
        return (atual&&atual.pos_venda)||{};
      })(),
      /* 🔴 v781 — A FICHA TÉCNICA, AGORA NO PRIMEIRO NÍVEL.
         Era `extras.ficha_tec`. Virou coluna própria da mp_estoque, e é por
         isso que a lista do estoque pode deixar de baixá-la: 74 KB por
         abertura, 41% de tudo que a tela pedia.
         ⚠️ Este é o único lugar que GRAVA a ficha. Se ele voltar a escrever
         dentro do extras, o ganho desaparece na primeira vez que o lojista
         salvar o carro. */
      ficha_tec:(function(){
        try{ return fichaTecObter(_ftRefAtual())||null; }catch(_){ return null; }
      })() };
  }
  function estAgendaSalvar(){ try{ estEspelhoGravar(); }catch(_){}   /* v184 — leva pra avaliacao */
    var ind=$('efAutosave'); if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; } clearTimeout(_estSaveTimer); _estSaveTimer=setTimeout(estSalvarAuto, 650); }
  function estSalvarAuto(){
    /* Coleta os campos somente quando chegar a vez desta gravacao. Assim uma
       requisicao anterior nunca pode ultrapassar a troca de capa. */
    _estSaveFila=_estSaveFila.catch(function(){}).then(estSalvarAutoAgora);
    return _estSaveFila;
  }
  async function estSalvarAutoAgora(){
    if(!$('efPlaca')) return;   /* saiu da ficha */
    var reg=estColeta(); var ind=$('efAutosave');
    /* ⛳ v1052 — A REGRA JÁ ACEITAVA SALVAR SEM PLACA desde sempre (basta
       ter o modelo). Quem mentia era o TEXTO: ele mandava informar a placa,
       e o lojista do 0 km ficava sem saber se podia salvar. Com o interruptor
       ligado, a frase passa a dizer a verdade. */
    if(!reg.placa && !reg.modelo){ if(ind){ ind.className='cad-autosave';
      var _zk=false; try{ _zk=(typeof zkLigado==='function') && zkLigado(); }catch(_){}
      ind.textContent=_zk?'Informe ao menos o modelo.':'Informe ao menos a placa ou o modelo.'; } return; }
    var js=JSON.stringify(reg);
    if(js===_estSaveLast){ if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; setTimeout(function(){ var i2=$('efAutosave'); if(i2&&i2.classList.contains('ok')){ i2.className='cad-autosave vazio'; i2.textContent=''; } }, 2200); } return; }
    /* v334: a caixinha "Vendido" da ficha também precisa avisar o portal.
       Guardo a situação ANTERIOR aqui em cima: o autosave dispara a cada
       tecla, e sem isso eu mandaria o mesmo recado dezenas de vezes. Só a
       TRANSIÇÃO (não era vendido → virou vendido) chama o repasse. */
    var _stAntes=''; if(_estEditId){ var _vA=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0]; _stAntes=String((_vA&&_vA.status)||''); }
    try{
      /* 🔴 v782 — ESTE É O MAIS IMPORTANTE DOS DEZ. É autosave: dispara a cada
         tecla com atraso, é o que grava mais vezes por dia, e é o ÚNICO que
         escreve "✓ Salvo" na tela. Sem a conferência, o "✓ Salvo" podia ser
         mentira — o app pintando a ficha com o valor novo e o banco ficando
         com o antigo, exatamente o defeito da v483.
         O que vem DEPOIS (o "✓ Salvo", a lista em memória, o estPinta) só
         roda se passou por aqui. */
      if(_estEditId){ reg.atualizado_em=new Date().toISOString();
        var r=await supa.from('estoque').update(reg).eq('id',_estEditId).select('id');
        estConfereGravou(r,'estSalvarAuto',1); }
      else { reg.user_id=meuId; reg.criado_em=new Date().toISOString(); var r2=await supa.from('estoque').insert(reg).select('id'); if(r2&&r2.error) throw r2.error; var nid=(r2&&r2.data&&r2.data[0]&&r2.data[0].id); if(nid){ _estEditId=nid; try{ cdvMarcarNovo(nid); }catch(_){} } }   /* v342: carro novo -> oferecer os clientes ao fechar a ficha */
      _estSaveLast=js;
      if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; setTimeout(function(){ var i2=$('efAutosave'); if(i2&&i2.classList.contains('ok')){ i2.className='cad-autosave vazio'; i2.textContent=''; } }, 2200); }
      /* atualiza a lista à esquerda em memória (sem reler o banco a cada tecla) */
      var saved=Object.assign({}, reg, {id:_estEditId});
      var idx=-1; for(var i=0;i<_estoque.length;i++){ if(String(_estoque[i].id)===String(_estEditId)){ idx=i; break; } }
      if(idx>=0) _estoque[idx]=Object.assign({}, _estoque[idx], saved); else _estoque.unshift(saved);
      estPinta((($('estBusca')||{}).value)||''); estMarcaAtivo(_estEditId);
      var tt=$('efTitulo'); if(tt){ var nm=((reg.marca||'')+' '+(reg.modelo||'')).trim(); if(nm) tt.textContent=nm; }
      /* v334: virou vendido agora? avisa o Portal do Repasse (uma vez só) */
      if(reg.status==='vendido' && _stAntes!=='vendido'){
        var _nV2=await estRepasseMarcarVendido(reg.placa);
        if(_nV2) toast('O anúncio deste carro saiu do Portal do Repasse.');
      }
    }catch(e){
      /* 🔴 v782 — DOIS MOTIVOS DIFERENTES, DOIS RECADOS DIFERENTES.
         Até aqui QUALQUER falha do autosave virava "Sem conexão — tentando de
         novo…" e o app repetia a cada 3 segundos, pra sempre. Com internet
         ruim isso é o certo. Com a RLS barrando, é o pior dos mundos: o recado
         manda a pessoa olhar o wi-fi (que está ótimo) e o app fica batendo na
         mesma porta fechada de 3 em 3 segundos, gastando cota e escondendo o
         motivo verdadeiro. Agora, sem permissão: diz o que é, PARA de tentar,
         e registra no mp_erros pra ficar rastro. */
      if(e && e.semPermissao){
        if(ind){ ind.className='cad-autosave err'; ind.textContent='Não deu pra salvar: este veículo não é seu.'; }
        clearTimeout(_estSaveTimer);
        try{ window.mevErro && window.mevErro(e,'estSalvarAuto'); }catch(_){}
        return;
      }
      if(ind){ ind.className='cad-autosave err'; ind.textContent='Sem conexão — tentando de novo…'; }
      clearTimeout(_estSaveTimer); _estSaveTimer=setTimeout(estSalvarAuto, 3000);
    }
  }
  function estAutosaveWire(){
    var panel=$('efBody'); if(!panel) return;
    _estSaveLast=JSON.stringify(estColeta());
    Array.prototype.forEach.call(panel.querySelectorAll('input,select,textarea'),function(e){ e.addEventListener('input',estAgendaSalvar); e.addEventListener('change',estAgendaSalvar); });
  }
  /* arredonda para um valor "bonito" terminado em .900 (ex.: 7.470 -> 6.900) */
  function _round900(v){ v=Number(v)||0; if(v<=0) return 0; var t=Math.round(v/1000)*1000-100; return t<0?0:t; }
  /* Antes de gerar, pergunta os diferenciais (o que torna o carro especial). */
  /* v171 — ICONES EM SVG NO LUGAR DOS EMOJIS.
     Emoji e' uma "figurinha" que cada celular desenha do seu jeito (e sempre
     colorida). SVG e' um desenho feito de linhas: como usamos
     stroke="currentColor", o icone assume a MESMA COR da letra do botao.
     Todos os desenhos ficam aqui; quem usa chama mkIco('post'). */
  var _MK_SVG={
    post:'<path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15l-1.9-4.1L5.5 9l4.6-1.4z"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z"/>',
    card:'<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>',
    ok:'<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>',
    recorte:'<path d="M6.13 1 6 16a2 2 0 0 0 2 2h15"/><path d="M1 6.13 16 6a2 2 0 0 1 2 2v15"/>',
    ampliar:'<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>',
    lapis:'<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/>',
    lixeira:'<polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v5"/><path d="M14 11v5"/><path d="M9 6V4h6v2"/>',
    megafone:'<path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>',
    ficha:'<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/>',
    carteira:'<path d="M4 6h15a2 2 0 0 1 2 2v10H4a2 2 0 0 1-2-2V6a3 3 0 0 1 3-3h13"/><path d="M16 11h5v4h-5a2 2 0 0 1 0-4z"/>',
    usuarios:'<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
    carro:'<path d="M5 11l1.4-4.2A2.5 2.5 0 0 1 8.8 5h6.4a2.5 2.5 0 0 1 2.4 1.8L19 11h.5a1.5 1.5 0 0 1 1.5 1.5v3a1 1 0 0 1-1 1h-.6a2.4 2.4 0 0 1-4.8 0H9.4a2.4 2.4 0 0 1-4.8 0H4a1 1 0 0 1-1-1v-3A1.5 1.5 0 0 1 4.5 11H5z"/><path d="M7.1 10.6h9.8"/><circle cx="7" cy="16.2" r="1.1"/><circle cx="17" cy="16.2" r="1.1"/>',
    placa:'<path d="M12 2 4.5 5v5.5c0 5 3 8.7 7.5 11.5 4.5-2.8 7.5-6.5 7.5-11.5V5L12 2Z"/><path d="M7.5 12.5 9 9.2c.4-.9 1.2-1.4 2.2-1.4h1.6c1 0 1.8.5 2.2 1.4l1.5 3.3"/><path d="M7 13.2h10v3.3H7z"/><path d="m15.5 19 1.4 1.4 3.1-3.2"/>',
    borrar:'<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10h.01M10.3 10h.01M13.7 10h.01M17 10h.01M7 14h.01M10.3 14h.01M13.7 14h.01M17 14h.01" stroke-width="3"/>',
    grafico:'<path d="M4 19V9"/><path d="M10 19V5"/><path d="M16 19v-7"/><path d="M22 19H2"/>',
    /* v177 — os 2 icones dos botoes do post */
    copiar:'<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
    atualizar:'<path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/>',
    link:'<path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1"/><path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1"/>',
    share:'<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="10.5" x2="15.4" y2="6.5"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/>',
    download:'<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>',
    instagram:'<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8" fill="currentColor" stroke="none"/>',
    marketplace:'<path d="M3 9h18"/><path d="m4.5 9 1.2-5h12.6l1.2 5"/><path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9"/><path d="M9 20v-5h6v5"/>',
    facebook:'<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>'
  };
  function mkIco(n,px){ var t=px||16;
    return '<svg class="mk-ico" viewBox="0 0 24 24" width="'+t+'" height="'+t+'" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+(_MK_SVG[n]||'')+'</svg>';
  }
  var _POST_MAP={dono1:'Único dono',dono2:'Segundo dono',ipva:'IPVA pago',transf:'Já transferido',revisado:'Revisado',revConc:'Revisões feitas na concessionária',pneus:'Pneus novos',garantia:'Ainda na garantia de fábrica',garantia90:'Garantia de 90 dias',docDia:'Documentação em dia',semSinistro:'Sem sinistro',semLeilao:'Sem leilão',manual:'Manual do veículo',chaveReserva:'Chave reserva',entrega:'Pronta entrega'};
  /* v156 — o que ja esta na aba Diferenciais (e nos campos do veiculo) vem marcado
     e preenchido sozinho: o Marketing nao pergunta de novo o que voce ja informou. */
  /* de que campo salvo (extras) vem cada chip da pagina Marketing */
  var _POST_DE={dono1:'unico_dono',dono2:'dono2',ipva:'ipva_pago',transf:'transferido',revisado:'revisado',revConc:'rev_conc',pneus:'pneus_novos',garantia:'garantia_fab',garantia90:'garantia_90_dias',docDia:'documentacao_em_dia',semSinistro:'sem_sinistro',semLeilao:'sem_leilao',manual:'manual_veiculo',chaveReserva:'chave_reserva',entrega:'pronta_entrega'};
  /* _mktDireto = true quando o post foi pedido de dentro da ficha do veiculo
     (aba Marketing), onde os diferenciais ja' estao na tela. */
  var _mktDireto=false;
  /* ⛳ v779 — A PERGUNTA DOS CHIPS SAIU DAQUI (mktPostPergunta) junto com os
     três ajudantes que só ela usava: _POST_CHIPS, _mktDifPre e mktPostExtras.
     Nenhum deles era chamado por ninguém no app.js montado (conferido com o
     acorn). O _POST_MAP e o _POST_DE FICAM: o 15-marketing.js usa os dois. */
  /* ⛳ v786 — O MARKETING DO VEÍCULO MUDOU DE ARQUIVO: agora mora em
     src/app/14j-marketing-veiculo.js. Nenhuma linha de lógica mudou — foi
     recortar e colar. Foram pra lá: os posts (rede social e marketplace), o
     Instagram, o Marketplace, a fiação do Facebook Ads, o gerar textos por IA
     e o card de venda em canvas.
     O que ficou AQUI é o que MAIS GENTE usa: o _MK_SVG e o mkIco (dez módulos
     chamam), o _POST_MAP e o _POST_DE (o 15-marketing usa os dois) e o
     _mktDireto (a ficha do estoque liga ele).
     👉 Procurando mktGerarTextos, mktPostSalvar, mevCardCanvas ou o
        _mktCopiar? MAPA-GERADO.md → 14j-marketing-veiculo.js. */

  /* Consulta sem autosave; alterações comerciais exigem Salvar alterações. */
  function estVerDetalhes(id,edit){
    var v=(_estoque||[]).find(function(row){return String(row.id)===String(id);});if(!v)return;
    if(!window.MEVStockDetail){estAbrirFicha(id);return;}
    window.MEVStockDetail.open({vehicle:v,edit:!!edit,thumbnail:function(src){return imgCdn(src,200);},
      load:async function(row){var r=await withTimeout(supa.from('estoque').select('*').eq('id',row.id).limit(1),12000);if(r.error)throw r.error;if(!r.data||!r.data[0])throw Error('Veículo não encontrado ou sem acesso.');return r.data[0];},
      save:async function(row,changes){
        var data=Object.assign({},changes,{atualizado_em:new Date().toISOString()});
        var query=supa.from('estoque').update(data).eq('id',row.id);if(row.atualizado_em)query=query.eq('atualizado_em',row.atualizado_em);
        var r=await query.select('id');if(r.error)throw r.error;if(!r.data||r.data.length!==1)throw Error('Veículo alterado em outra tela ou sem permissão. Feche e abra a ficha novamente.');
        var updated=Object.assign({},row,data);
        if(changes.status==='vendido'&&row.status!=='vendido'){try{await estRepasseMarcarVendido(row.placa);}catch(_){toast('Veículo salvo. Confira a situação do anúncio no Repasse.');}}
        return updated;
      },
      onSaved:function(updated){var index=_estoque.findIndex(function(row){return String(row.id)===String(updated.id);});if(index>=0)_estoque[index]=updated;estPinta((($('estBusca')||{}).value)||'');},
      onAdvanced:function(row,tab){estAbrirFicha(id);_estFichaTab=tab==='precos'?'cadastro':(['fotos','marketing','ficha'].indexOf(tab)>=0?tab:'cadastro');estFichaTabAplica();if(tab==='precos'&&$('efAnuncio'))$('efAnuncio').focus();}
    });
  }

  function estNomeComercial(v){var marca=String(v.marca||'').replace(/^GM\s*-\s*/i,'').trim(),modelo=String(v.modelo||'').replace(/^GM\s*-\s*/i,'').trim();return (modelo.toLowerCase().indexOf(marca.toLowerCase())===0?modelo:[marca,modelo].filter(Boolean).join(' '))||'Veículo';}

/* ╔═══ src/app/14b-completar-placa.js ════════════════════════════════════ */
  /* ============ COMPLETAR O CADASTRO PELA PLACA (v345) ======================
     O PROBLEMA
     Você digita a placa, o app consulta e preenche marca, modelo, ano e cor.
     Aí sobram três campos vazios que você preenche na mão TODA vez:
     ANO MODELO, COMBUSTÍVEL e CÂMBIO. E o engraçado é que a resposta já está
     na tela: "Fox Xtreme 1.6 Flex 8V 5p" é flex e é manual; "Nivus Highline
     1.0 200 TSI Flex Aut." é flex e é automático. A informação está escrita
     no nome da versão — só ninguém estava lendo.

     O QUE ESTE PEDAÇO FAZ
     Lê o nome da versão (o mesmo texto que a FIPE devolve) e completa esses
     campos sozinho. Sem consulta nova, sem token, sem internet.

     A REGRA DE OURO: só preenche campo VAZIO.
     Se você digitou "Automatizado" e a versão diz "Aut.", fica o SEU texto.
     Nada do que você escreveu é sobrescrito, nunca — nem quando você troca a
     versão da FIPE no seletor.
     ========================================================================= */

  /* texto comparável: sem acento, sem pontuação, tudo minúsculo e cercado de
     espaços (pra \b funcionar até no começo e no fim). */
  function _cpN(s){
    s=String(s==null?'':s);
    try{ s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    return ' '+s.toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()+' ';
  }

  /* ---- COMBUSTÍVEL -------------------------------------------------------
     A ordem importa: um híbrido flex tem as duas palavras no nome, e o que
     manda é a mais específica. Por isso híbrido e elétrico vêm antes. */
  function _cpCombustivel(nomeVersao, jaVeio){
    var t=_cpN(jaVeio)+_cpN(nomeVersao);
    if(/ (hibrid|hybrid|mhev|phev|hev) /.test(t)) return 'Híbrido';
    if(/ (eletric|electric|ev|bev|e tron) /.test(t)) return 'Elétrico';
    if(/ (diesel|tdi|crdi|mwm|turbodiesel) /.test(t)) return 'Diesel';
    if(/ (flex|flexpower|flexfuel|bicombustivel|tetrafuel|total flex) /.test(t)) return 'Flex';
    if(/ (alcool|etanol) /.test(t)) return 'Álcool';
    if(/ (gasolina|gas) /.test(t)) return 'Gasolina';
    if(/ (gnv) /.test(t)) return 'GNV';
    return '';
  }

  /* ---- CÂMBIO ------------------------------------------------------------
     Todo fabricante escreve de um jeito. Estão aqui os nomes comerciais que
     aparecem na FIPE e nos anúncios: DSG e S-tronic (VW/Audi), Powershift
     (Ford), Dualogic (Fiat), i-Motion (VW), Easytronic (GM), CVT (Honda,
     Nissan, Toyota), Tiptronic, e o "Aut."/"Mec." padrão da própria FIPE. */
  function _cpCambio(nomeVersao){
    var t=_cpN(nomeVersao);
    if(/ (aut|auto|automatico|automatica|automatizado|automatizada|cvt|dsg|dct|tiptronic|s tronic|stronic|i motion|imotion|dualogic|easytronic|powershift|multidrive|at|a t) /.test(t)) return 'Automático';
    if(/ (mec|manual|mt|cambio manual) /.test(t)) return 'Manual';
    return '';
  }

  /* ---- ANOS --------------------------------------------------------------
     Um vazio e o outro preenchido é o caso comum (a consulta às vezes só
     devolve um dos dois). Copio de um pro outro — é o mesmo palpite que o
     app já fazia lá no estPreencheVeic ("ano_modelo || ano"), agora valendo
     também quando os dados chegam pelo seletor de versão da FIPE. */
  function _cpAnos(){
    var af=document.getElementById('efAno'), am=document.getElementById('efAnoMod');
    if(!af||!am) return 0;
    var vf=String(af.value||'').trim(), vm=String(am.value||'').trim();
    if(!vf && vm){ af.value=vm; return 1; }
    if(!vm && vf){ am.value=vf; return 1; }
    return 0;
  }

  /* ---- O COMPLETADOR -----------------------------------------------------
     Chamado depois de todo preenchimento vindo da placa (estPreencheVeic) e
     de toda troca de versão no seletor da FIPE (estVersaoAplicar).
     Devolve quantos campos completou, pra escrever o aviso na tela. */
  function estCompletarPelaVersao(dados){
    var d=dados||{};
    var elModelo=document.getElementById('efModelo');
    /* o nome da versão é o melhor texto que houver: o do seletor da FIPE
       (mais completo) ou o que estiver no campo Modelo. */
    var nome=[ d.descricao, d.modelo, (elModelo&&elModelo.value) ].filter(Boolean).join(' ');
    var feitos=[];

    var elC=document.getElementById('efCombustivel');
    if(elC && !String(elC.value||'').trim()){
      var comb=_cpCombustivel(nome, d.combustivel);
      if(comb){ elC.value=comb; feitos.push('combustível'); }
    }
    var elX=document.getElementById('efCambio');
    if(elX && !String(elX.value||'').trim()){
      var camb=_cpCambio(nome);
      if(camb){ elX.value=camb; feitos.push('câmbio'); }
    }
    if(_cpAnos()) feitos.push('ano');

    if(feitos.length){
      /* aviso curto e honesto: foi DEDUZIDO do nome, não veio de documento. */
      var m=document.getElementById('efPlMsg');
      if(m && !/err/.test(m.className||'')){
        m.className='cad-msg ok';
        m.textContent='Completei '+feitos.join(', ')+' pelo nome da versão — confira.';
      }
      try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
    }
    return feitos.length;
  }

  /* ===== v346 (pedido) — ÍCONE DO CATÁLOGO NO CARD ==========================
     Ao lado do WhatsApp e do compartilhar, no canto da foto de cada carro da
     lista do Estoque, entrou o livrinho do catálogo: um toque e abre a
     LANDING PAGE do veículo — a mesma página que o cliente vê, dentro do app,
     com a flecha de voltar.

     Já existia o mesmo caminho no menu de 3 pontinhos ("Ver no catálogo",
     v337). A diferença é a distância: dali eram dois toques e uma leitura de
     menu; aqui é um toque, com o dedo já em cima do card.

     Reaproveita as mesmas duas peças de sempre: _publicoVeiculoUrl (o link
     público, o mesmo do Compartilhar) e _publicoAbrir (o visor do "Abrir
     catálogo"). Preço de compra, mínimo, custos e margem não existem naquela
     página — quem a monta nem recebe esses campos.
     ======================================================================== */
  function estAbrirNoCatalogo(v){
    if(!v || !v.id){ toast('Salve o veículo antes de ver no catálogo.'); return; }
    var url='';
    try{ url=_publicoVeiculoUrl(v); }catch(_){}
    if(!url){ toast('Não consegui montar o link deste veículo.'); return; }
    try{ _preAquece(url); }catch(_){}
    var st=v.status||'disponivel';
    if(st!=='disponivel') toast('Este veículo está '+((((typeof EST_STATUS!=='undefined'&&EST_STATUS[st])||{}).t)||'').toLowerCase()+' — ele não aparece na lista do catálogo.');
    try{ _publicoAbrir(url,{titulo:'Veículo no catálogo',voltar:'Voltar ao estoque',dono:true}); }
    catch(_){ try{ window.open(url,'_blank','noopener'); }catch(__){ location.href=url; } }
  }

  /* ===== v347 · v1512 — COPIAR O POST DIRETO DO CARD ======================
     A ação fica disponível no menu de todo veículo do estoque.

     O post da IA já existia, mas morava lá dentro: abrir a ficha → aba
     Marketing → rolar → copiar. Quem publica anúncio faz isso o dia inteiro.
     Agora são dois toques a partir da lista.

     ONDE O POST MORA: extras.post_ia (o de redes sociais) e
     extras.post_marketplace_ia (o de marketplace) — os dois gravados pela
     aba Marketing. Copio o de redes sociais; se só existir o de marketplace,
     copio esse. Sem texto salvo, monto o post factual pelo mesmo gerador da
     aba Marketing, usando os dados atuais do veículo. ================= */
  function _estPostTexto(v){
    var ex=(v&&v.extras)||{};
    return String(ex.post_ia||ex.post_marketplace_ia||'').trim();
  }
  async function estCopiarPost(v){
    var txt=_estPostTexto(v);
    if(!txt){ try{ txt=_mktPostAutomatico(v); }catch(_){} }
    if(!txt){ toast('Preencha a marca e o modelo para montar o post.'); return; }
    /* três caminhos, do melhor pro que sempre funciona: a área de
       transferência moderna, o truque do textarea (iPhone antigo e páginas
       sem HTTPS) e, por último, a caixa de texto pra copiar na mão. */
    try{
      if(navigator.clipboard && navigator.clipboard.writeText){
        await navigator.clipboard.writeText(txt);
        toast('Post copiado ✓ É só colar no anúncio.');
        return;
      }
    }catch(_){}
    try{
      var ta=document.createElement('textarea');
      ta.value=txt; ta.setAttribute('readonly','');
      ta.style.position='fixed'; ta.style.top='-1000px'; ta.style.opacity='0';
      document.body.appendChild(ta);
      ta.select(); ta.setSelectionRange(0, txt.length);
      var ok=document.execCommand('copy');
      document.body.removeChild(ta);
      if(ok){ toast('Post copiado ✓ É só colar no anúncio.'); return; }
    }catch(_){}
    try{ prompt('Copie o post:', txt); }catch(_){ toast('Não consegui copiar aqui.'); }
  }

  /* ============ ORDENAR O ESTOQUE (v369) ====================================
     PEDIDO: "adicione na mesma linha dos disponíveis, campo para ordenar
     (semelhante catálogo)".

     Por que isso importa num pátio de verdade: com 14 carros a lista cabe na
     cabeça; com 40, não. As perguntas que o lojista faz todo dia são "o que
     está parado há mais tempo?" e "qual é o mais barato que eu tenho pra
     oferecer?" — e as duas viram uma rolagem inteira sem ordenação.

     A ordem escolhida fica guardada no aparelho: você escolhe uma vez e ela
     continua valendo quando voltar pro estoque amanhã.

     ⚠️ "Parado há mais tempo" usa a data de CADASTRO (criado_em), que é o que
     existe. Não é a data em que o carro entrou no pátio — se você cadastrou
     atrasado, o número mente a seu favor. Está escrito assim na tela ("Mais
     tempo cadastrado") pra não prometer o que o dado não é.
     ========================================================================= */
  var EST_ORDENS=[
    { id:'recentes', nome:'Mais recentes' },
    { id:'antigos',  nome:'Mais tempo cadastrado' },
    { id:'barato',   nome:'Menor preço' },
    { id:'caro',     nome:'Maior preço' },
    { id:'modelo',   nome:'Modelo (A-Z)' },
    { id:'km',       nome:'Menor km' }
  ];
  var _EST_ORD_KEY='mev_estoque_ordem';
  function estOrdenaLer(){
    try{ var v=localStorage.getItem(_EST_ORD_KEY)||'recentes';
      return EST_ORDENS.filter(function(o){ return o.id===v; })[0] ? v : 'recentes';
    }catch(_){ return 'recentes'; }
  }
  function estOrdenaGravar(id){ try{ localStorage.setItem(_EST_ORD_KEY, String(id||'recentes')); }catch(_){} }
  function estOrdenaSelectHtml(){
    var at=estOrdenaLer();
    return '<select class="est-fsel est-osel" id="estOsel" title="Ordenar a lista" aria-label="Ordenar a lista">'+
      EST_ORDENS.map(function(o){
        return '<option value="'+o.id+'"'+(at===o.id?' selected':'')+'>'+esc(o.nome)+'</option>';
      }).join('')+'</select>';
  }
  function _estOrdPreco(v){
    /* o preço que o cliente vê. Sem preço de anúncio, cai no mínimo — e quem
       não tem nenhum dos dois vai pro fim da lista, não pro topo (senão os
       cadastros pela metade ocupariam a primeira tela). */
    return Number((v&&v.preco_anuncio)||(v&&v.preco_minimo)||0)||0;
  }
  function _estOrdData(v){
    var t=Date.parse((v&&(v.criado_em||v.atualizado_em))||'');
    return isNaN(t)?0:t;
  }
  function estOrdenarLista(lista){
    var ordem=estOrdenaLer(), L=(lista||[]).slice();
    if(ordem==='antigos')  return L.sort(function(a,b){ return (_estOrdData(a)||8e15)-(_estOrdData(b)||8e15); });
    if(ordem==='barato')   return L.sort(function(a,b){ var x=_estOrdPreco(a)||Infinity, y=_estOrdPreco(b)||Infinity; return x-y; });
    if(ordem==='caro')     return L.sort(function(a,b){ return _estOrdPreco(b)-_estOrdPreco(a); });
    if(ordem==='km')       return L.sort(function(a,b){ var x=Number(a.km)||Infinity, y=Number(b.km)||Infinity; return x-y; });
    if(ordem==='modelo')   return L.sort(function(a,b){
      var x=(((a.marca||'')+' '+(a.modelo||'')).trim()).toLowerCase();
      var y=(((b.marca||'')+' '+(b.modelo||'')).trim()).toLowerCase();
      return x.localeCompare(y,'pt-BR');
    });
    return L.sort(function(a,b){ return _estOrdData(b)-_estOrdData(a); });   /* recentes */
  }
  /* CSS da linha (filtro + ordem lado a lado), injetado — sem tocar no styles.css */
  try{
    if(typeof document!=='undefined' && !document.getElementById('estOrdCss')){
      var _eoCss=document.createElement('style'); _eoCss.id='estOrdCss';
      _eoCss.textContent='.est-fline{display:flex;gap:8px;align-items:center}'+
        '.est-fline>.est-fsel{flex:1 1 auto;min-width:0}'+
        '.est-fline>.est-osel{flex:0 1 auto;max-width:46%}'+
        '@media(max-width:420px){.est-fline{gap:6px}.est-fline>.est-osel{max-width:44%}}';
      (document.head||document.documentElement).appendChild(_eoCss);
    }
  }catch(_){}

  /* ============ IR PRO WHATSAPP DE VERDADE (v370) ===========================
     O PEDIDO: "depois de enviar um veículo via whatsapp, ajeite pra tela ir
     pro whatsapp e não ficar no app".

     O QUE ACONTECIA: os botões usavam window.open(url,'_blank'). Num app
     instalado no celular (PWA), '_blank' pede uma JANELA NOVA — e o iPhone
     abre isso como uma aba escondida atrás do próprio app. Resultado: você
     tocava em enviar, parecia que nada acontecia, e a mensagem estava
     esperando numa tela que você não via. Aí tinha que sair do app na mão.

     A CORREÇÃO: no celular a gente NAVEGA na mesma janela (location.href).
     Aí o sistema entende "esse endereço é do WhatsApp" e troca de aplicativo
     — que é exatamente o que se espera de um botão de enviar. Voltar é o
     gesto de sempre; o app estava em segundo plano e volta onde parou.

     NO COMPUTADOR continua abrindo em OUTRA ABA: lá o WhatsApp é uma página
     web, e trocar a aba atual faria você perder o estoque de vista. Cada
     lugar com o comportamento que faz sentido nele.
     ========================================================================= */
  function mevIrProWhats(url){
    url=String(url||''); if(!url) return;
    var ua=String((navigator&&navigator.userAgent)||'');
    var celular=/iPhone|iPad|iPod|Android/i.test(ua);
    var instalado=false;
    try{
      instalado=(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || (navigator.standalone===true);
    }catch(_){}
    if(celular || instalado){ try{ window.location.assign(url); }catch(_){ location.href=url; } return; }
    try{ var w=window.open(url,'_blank','noopener'); if(!w) location.href=url; }
    catch(_){ location.href=url; }
  }

/* ╔═══ src/app/14c-clientes-do-veiculo.js ════════════════════════════════ */
  /* ===================== CLIENTES DESTE CARRO (v342) =========================
     PARA QUE SERVE
     Entrou um carro no estoque? A pergunta seguinte é sempre a mesma: "pra
     quem eu ligo agora?". A resposta já estava no app, só que espalhada — o
     campo "veículo de interesse" do cliente, a faixa de preço que ele falou,
     a cotação que ele pediu semana passada. Este pedaço junta as três coisas
     e devolve uma lista pronta, com o MOTIVO de cada nome estar ali e um
     botão pra mandar a novidade.

     O QUE ELE **NÃO** FAZ (de propósito)
     Ele não dispara nada sozinho. Nenhuma mensagem sai daqui sem você tocar
     no botão daquele cliente. Isso não é preguiça de programar: disparo em
     massa é exatamente o que faz o WhatsApp derrubar o número da loja. Os
     freios estão todos em CDV_* logo abaixo e cada um tem o porquê escrito.

     ONDE ELE APARECE
     - menu de 3 pontinhos do card do estoque → "Clientes deste carro (N)"
     - ao cadastrar um veículo NOVO: quando você fecha a ficha, o painel abre
       sozinho uma vez (só se realmente houver gente casando).
     ========================================================================= */

  /* ---- OS FREIOS (mexa aqui se um dia quiser afrouxar/apertar) ------------
     TETO_DIA  : máximo de avisos por dia somando todos os carros. 20 é um
                 número de gente; 200 é número de robô — e robô toma bloqueio.
     GAP_MS    : intervalo mínimo entre dois envios. Duas mensagens no mesmo
                 segundo é a assinatura mais óbvia de disparo automático.
     CLI_DIAS  : não encher o mesmo cliente. Avisou hoje sobre um carro? Só
                 daqui a 7 dias sem confirmar de novo.
     H1/H2     : horário civilizado. Fora dele o app pergunta antes.
     Além disso: o MESMO carro nunca vai duas vezes pro MESMO cliente. */
  var CDV_TETO_DIA=20, CDV_GAP_MS=30000, CDV_CLI_DIAS=7, CDV_H1=8, CDV_H2=20;

  var _cdvEstado=null, _cdvUltimoEnvio=0, _cdvPendente=null, _cdvVeicId=null, _cdvLista=[];

  /* ---- memória dos avisos: mora em app_state (a mesma tabela que o CRM já
     usa pra ponte com o MEVTOOLS). Não precisa de tabela nova nem de SQL. --- */
  function _cdvHoje(){ var d=new Date(); return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  async function _cdvEstadoLer(){
    if(_cdvEstado) return _cdvEstado;
    var dados={};
    try{
      var r=await withTimeout(supa.from('app_state').select('dados').eq('vendedor_id',meuId).eq('feature','avisos_veiculo').limit(1),9000);
      dados=((r&&r.data&&r.data[0]&&r.data[0].dados)||{});
    }catch(_){ dados={}; }
    if(!dados.dia) dados.dia={};
    if(!dados.cli) dados.cli={};
    if(!dados.par) dados.par={};
    /* limpeza: o contador diário guarda 30 dias; o "já avisei este cliente
       sobre este carro" guarda 180. Sem isso o registro cresceria pra sempre
       dentro de uma linha só do banco. */
    try{
      var ks=Object.keys(dados.dia).sort(); while(ks.length>30){ delete dados.dia[ks.shift()]; }
      var corte=Date.now()-180*86400000;
      Object.keys(dados.par).forEach(function(k){ if(Number(dados.par[k]||0)<corte) delete dados.par[k]; });
      Object.keys(dados.cli).forEach(function(k){ if(Number(dados.cli[k]||0)<corte) delete dados.cli[k]; });
    }catch(_){}
    _cdvEstado=dados; return _cdvEstado;
  }
  async function _cdvEstadoGravar(){
    if(!_cdvEstado || !meuId) return;
    try{ await supa.from('app_state').upsert({ vendedor_id:meuId, feature:'avisos_veiculo', dados:_cdvEstado, updated_at:new Date().toISOString() }); }catch(_){}
  }
  function _cdvUsadosHoje(){ var e=_cdvEstado||{dia:{}}; return Number((e.dia||{})[_cdvHoje()]||0); }

  /* ---- normalização: "Nivus Highline 1.0 200 TSI Flex Aut." vira palavras
     comparáveis. Sem acento, sem pontuação, sem os enfeites que todo anúncio
     tem e que não ajudam a reconhecer o carro. ---------------------------- */
  var _CDV_STOP={de:1,da:1,do:1,dos:1,das:1,com:1,sem:1,flex:1,aut:1,automatico:1,automatica:1,manual:1,mec:1,mecanico:1,portas:1,port:1,turbo:1,total:1,gasolina:1,alcool:1,diesel:1,completo:1,novo:1,nova:1,zero:1,km:1,ano:1,cv:1};
  function _cdvN(s){
    s=String(s==null?'':s);
    try{ s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    return s.toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  }
  function _cdvTok(txt, minLen){
    var min=minLen||3;
    return _cdvN(txt).split(' ').filter(function(w){
      return w.length>=min && !_CDV_STOP[w] && !/^\d+$/.test(w);
    });
  }
  /* o "nome forte" do carro: a primeira palavra útil do modelo (nivus, polo,
     onix, cruze...). É o que o lojista escreve no campo de interesse. */
  function _cdvNomeForte(v){ var t=_cdvTok((v&&v.modelo)||''); return t[0]||''; }

  /* ---- HISTÓRICO: quem já cotou ou consultou um carro desse modelo -------
     Vale mesmo pra quem nunca teve o campo "interesse" preenchido — e esse é
     justamente o cliente que costuma ficar esquecido. Uma busca só, guardada
     em memória enquanto o painel está aberto. */
  async function _cdvHistorico(v){
    var forte=_cdvNomeForte(v); var mapa={};
    if(!forte) return mapa;
    function casa(txt){ return _cdvN(txt).indexOf(forte)>=0; }
    try{
      var r1=await withTimeout(supa.from('vendas').select('cliente_id,veiculo,criado_em').not('cliente_id','is',null).order('criado_em',{ascending:false}).limit(400),9000);
      ((r1&&r1.data)||[]).forEach(function(x){
        if(!x.cliente_id || !casa(x.veiculo)) return;
        var k=String(x.cliente_id); if(!mapa[k]) mapa[k]={tipo:'cotou', ts:x.criado_em||''};
      });
    }catch(_){}
    try{
      var r2=await withTimeout(supa.from('cliente_consulta').select('cliente_id,placa,veiculo,criado_em').order('criado_em',{ascending:false}).limit(400),9000);
      ((r2&&r2.data)||[]).forEach(function(x){
        if(!x.cliente_id) return;
        var vv=x.veiculo||{}; var txt=((vv.marca||'')+' '+(vv.modelo||''));
        if(!casa(txt)) return;
        var k=String(x.cliente_id); if(!mapa[k]) mapa[k]={tipo:'consultou', ts:x.criado_em||''};
      });
    }catch(_){}
    return mapa;
  }

  /* ---- A NOTA DE CADA CLIENTE -------------------------------------------
     Somo pontos por motivo e guardo o motivo em texto, porque uma lista sem
     o "por quê" você não confia — e com razão. Corte em 40: abaixo disso é
     chute, e chute vira mensagem inconveniente. */
  function _cdvNota(c, v, hist){
    var pts=0, motivos=[];
    var forte=_cdvNomeForte(v);
    var marca=_cdvN(v.marca||'');
    var alvo=_cdvN(c.interesse||'');
    if(forte && alvo && alvo.indexOf(forte)>=0){ pts+=50; motivos.push('Procura '+(v.modelo||'').split(' ')[0]); }
    else if(marca && alvo && alvo.indexOf(marca)>=0){ pts+=25; motivos.push('Procura '+(v.marca||'')); }
    else if(alvo){
      /* interesse escrito de outro jeito ("SUV pequena") — palavra a palavra */
      var tv=_cdvTok(((v.marca||'')+' '+(v.modelo||'')));
      var bate=_cdvTok(alvo).filter(function(w){ return tv.indexOf(w)>=0; });
      if(bate.length){ pts+=20; motivos.push('Interesse parecido'); }
    }
    /* faixa de preço: uso SÓ o preço de anúncio (o mínimo é seu piso de
       negociação e não sai do app — regra de dinheiro da v175). */
    var preco=Number(v.preco_anuncio)||0, faixa=Number(c.faixa_preco)||0;
    if(preco && faixa){
      if(preco<=faixa*1.1 && preco>=faixa*0.55){ pts+=30; motivos.push('Cabe na faixa dele'); }
      else if(preco>faixa*1.1){ pts-=40; motivos.push('Acima da faixa'); }
    }
    var h=hist[String(c.id)];
    if(h){ pts+=35; motivos.push(h.tipo==='cotou'?'Já cotou esse modelo':'Já consultou esse modelo'); }
    return { pts:pts, motivos:motivos };
  }

  /* ---- monta a lista ordenada (o "quem chamar primeiro") ---------------- */
  async function _cdvMontaLista(v){
    if(!_clientes || !_clientes.length){ try{ await cliCarregar(); }catch(_){} }
    var hist=await _cdvHistorico(v);
    var out=[];
    (_clientes||[]).forEach(function(c){
      if(!c || !c.id) return;
      var tel=String(c.telefone||'').replace(/\D/g,'');
      if(tel.length<10) return;                 /* sem telefone não dá pra avisar */
      var n=_cdvNota(c, v, hist);
      if(n.pts<40) return;
      out.push({ c:c, pts:n.pts, motivos:n.motivos });
    });
    out.sort(function(a,b){ return b.pts-a.pts || String(a.c.nome||'').localeCompare(String(b.c.nome||'')); });
    return out;
  }
  /* usado só pra escrever o número no menu do card, sem abrir nada */
  async function cdvQuantos(v){
    try{ var l=await _cdvMontaLista(v); return l.length; }catch(_){ return 0; }
  }

  /* ---- a mensagem que vai pro cliente -----------------------------------
     Reaproveita a estVeicMsg (a mesma do Compartilhar): carro, preço de
     anúncio, itens marcados e o link da página. Só ganha o nome do cliente
     na frente. Nada de preço de compra, custo ou margem — a estVeicMsg já
     cuida disso e continua sendo a única porta. */
  function _cdvMsg(c, v){
    var nome=String(c.nome||'').trim().split(/\s+/)[0]||'';
    var L=[];
    L.push('Oi'+(nome?(' '+nome):'')+', tudo bem?');
    L.push('');
    L.push('Chegou um carro aqui na loja com a sua cara:');
    L.push('');
    try{ L.push(estVeicMsg(v)); }catch(_){ L.push(((v.marca||'')+' '+(v.modelo||'')).trim()); }
    return L.join('\n');
  }

  /* ---- estilo do painel: injetado uma vez por JS ------------------------
     De propósito NÃO mexo no styles.css: ele é o arquivo mais disputado do
     projeto (várias conversas editam) e uma tela nova não vale o risco de
     colisão. Some junto com a tela quando você fecha. */
  function _cdvCss(){
    if(document.getElementById('cdvCss')) return;
    var s=document.createElement('style'); s.id='cdvCss';
    s.textContent=[
      '.cdv-bg{position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:9600;display:flex;align-items:flex-end;justify-content:center;opacity:0;transition:opacity .18s}',
      '.cdv-bg.on{opacity:1}',
      '.cdv-pn{background:#fff;width:100%;max-width:620px;max-height:88vh;border-radius:18px 18px 0 0;display:flex;flex-direction:column;transform:translateY(14px);transition:transform .18s}',
      '.cdv-bg.on .cdv-pn{transform:none}',
      '@media(min-width:760px){.cdv-bg{align-items:center}.cdv-pn{border-radius:18px}}',
      '.cdv-hd{padding:16px 18px 10px;border-bottom:1px solid #e2e8f0}',
      '.cdv-hd h3{margin:0;font-size:17px;color:#0f172a}',
      '.cdv-hd p{margin:4px 0 0;font-size:13px;color:#64748b}',
      '.cdv-cota{margin-top:8px;font-size:12px;color:#475569;background:#f1f5f9;border-radius:999px;padding:4px 10px;display:inline-block}',
      '.cdv-bd{overflow:auto;padding:8px 12px 16px;-webkit-overflow-scrolling:touch}',
      '.cdv-it{display:flex;gap:10px;align-items:flex-start;padding:12px 8px;border-bottom:1px solid #f1f5f9}',
      '.cdv-av{width:38px;height:38px;border-radius:50%;background:#e0e7ff;color:#3730a3;font-weight:700;display:flex;align-items:center;justify-content:center;flex:0 0 38px}',
      '.cdv-in{flex:1;min-width:0}',
      '.cdv-nm{font-weight:600;color:#0f172a;font-size:15px}',
      '.cdv-tel{font-size:12px;color:#64748b;margin-top:1px}',
      '.cdv-tags{margin-top:6px;display:flex;flex-wrap:wrap;gap:4px}',
      '.cdv-tag{font-size:11px;background:#ecfdf5;color:#047857;border:1px solid #a7f3d0;border-radius:999px;padding:2px 8px}',
      '.cdv-tag.frio{background:#fff7ed;color:#c2410c;border-color:#fed7aa}',
      '.cdv-acts{display:flex;flex-direction:column;gap:6px;align-items:flex-end}',
      '.cdv-bt{border:0;border-radius:10px;padding:8px 12px;font-size:13px;font-weight:600;background:#16a34a;color:#fff;cursor:pointer}',
      '.cdv-bt[disabled]{background:#e2e8f0;color:#94a3b8;cursor:default}',
      '.cdv-bt.sec{background:#f1f5f9;color:#334155}',
      '.cdv-ft{padding:10px 16px 16px;border-top:1px solid #e2e8f0;display:flex;gap:8px;justify-content:space-between;align-items:center}',
      '.cdv-ft small{color:#94a3b8;font-size:11px;line-height:1.35}',
      '.cdv-x{border:0;background:#0f172a;color:#fff;border-radius:10px;padding:9px 16px;font-weight:600;cursor:pointer}',
      '.cdv-vazio{padding:28px 16px;text-align:center;color:#94a3b8;font-size:14px}'
    ].join('\n');
    document.head.appendChild(s);
  }
  function cdvFechar(){
    var b=document.getElementById('cdvBg'); if(!b) return;
    b.classList.remove('on'); setTimeout(function(){ if(b&&b.parentNode) b.parentNode.removeChild(b); },200);
  }

  /* ---- ABRE O PAINEL ---------------------------------------------------- */
  async function cdvAbrir(veicId){
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(veicId); })[0];
    if(!v){ toast('Não achei este veículo na lista.'); return; }
    if(!meuId){ toast('Entre na sua conta.'); return; }
    _cdvVeicId=String(v.id);
    _cdvCss(); cdvFechar();
    var bg=document.createElement('div'); bg.className='cdv-bg'; bg.id='cdvBg';
    bg.innerHTML='<div class="cdv-pn"><div class="cdv-hd"><h3>Clientes para este carro</h3>'+
      '<p>'+esc((((v.marca||'')+' '+(v.modelo||'')).trim())||'Veículo')+(v.placa?(' · '+esc(v.placa)):'')+'</p>'+
      '<div class="cdv-cota" id="cdvCota">conferindo…</div></div>'+
      '<div class="cdv-bd" id="cdvBody"><div class="cdv-vazio">Procurando quem combina…</div></div>'+
      '<div class="cdv-ft"><small>Um de cada vez, no seu tempo:<br>é assim que o WhatsApp não bloqueia o número.</small><button type="button" class="cdv-x" id="cdvX">Fechar</button></div></div>';
    document.body.appendChild(bg);
    bg.addEventListener('click',function(e){ if(e.target===bg) cdvFechar(); });
    var bx=document.getElementById('cdvX'); if(bx) bx.onclick=cdvFechar;
    requestAnimationFrame(function(){ bg.classList.add('on'); });

    /* puxa o resumo do chat: quem JÁ conversou com a loja recebe pelo app;
       quem nunca falou sai pelo seu WhatsApp, na mão — ver _cdvEnviar.
       Não seguro a tela por causa dele: quando a resposta chega, repinto. */
    try{ _chatResumoCarrega(function(){ if(document.getElementById('cdvBody')) _cdvPinta(v,'cdvBody','cdvCota'); }); }catch(_){}
    await _cdvEstadoLer();
    _cdvLista=await _cdvMontaLista(v);
    _cdvPinta(v);
  }

  /* v347: a mesma lista serve dois lugares — o painel que abre sozinho
     (modal) e a ABA "Clientes" dentro da ficha do veículo. Por isso ela
     recebe QUAL caixa pintar em vez de procurar um id fixo. */
  function _cdvPinta(v, boxId, cotaId){
    var body=document.getElementById(boxId||'cdvBody'); if(!body) return;
    var cota=document.getElementById(cotaId||'cdvCota');
    if(cota) cota.textContent=_cdvUsadosHoje()+' de '+CDV_TETO_DIA+' avisos hoje';
    if(!_cdvLista.length){
      body.innerHTML='<div class="cdv-vazio"><b>Ninguém combina com este carro ainda.</b><br><br>'+
        'A lista sai do que está no cadastro do cliente: o campo <b>veículo de interesse</b>, a <b>faixa de preço</b> e as cotações/consultas dele.<br>'+
        'Preencha esses campos na ficha dos clientes que este carro aqui já encontra sozinho.</div>';
      return;
    }
    var est=_cdvEstado||{par:{},cli:{}};
    body.innerHTML=_cdvLista.map(function(it,i){
      var c=it.c;
      var jaEsse=est.par[_cdvVeicId+'|'+c.id];
      var conversa=null; try{ conversa=_chatDe(c); }catch(_){}
      var tags=it.motivos.map(function(m){ return '<span class="cdv-tag'+(/Acima da faixa/.test(m)?' frio':'')+'">'+esc(m)+'</span>'; }).join('');
      if(conversa) tags+='<span class="cdv-tag">Já conversou aqui</span>';
      var bt = jaEsse
        ? '<button type="button" class="cdv-bt" disabled>Avisado ✓</button>'
        : '<button type="button" class="cdv-bt" data-env="'+i+'">Enviar</button>';
      return '<div class="cdv-it">'+
        '<div class="cdv-av">'+esc(cliIni(c.nome))+'</div>'+
        '<div class="cdv-in"><div class="cdv-nm">'+esc(c.nome||'Sem nome')+'</div>'+
        '<div class="cdv-tel">'+esc((typeof foneFmt==='function')?foneFmt(c.telefone||''):(c.telefone||''))+
        (jaEsse?(' · avisado em '+esc(new Date(jaEsse).toLocaleDateString('pt-BR'))):'')+'</div>'+
        '<div class="cdv-tags">'+tags+'</div></div>'+
        '<div class="cdv-acts">'+bt+'<button type="button" class="cdv-bt sec" data-fic="'+i+'">Ficha</button></div>'+
        '</div>';
    }).join('');
    Array.prototype.forEach.call(body.querySelectorAll('[data-env]'),function(b){
      b.onclick=function(){ _cdvEnviar(+b.getAttribute('data-env'), v, b); };
    });
    Array.prototype.forEach.call(body.querySelectorAll('[data-fic]'),function(b){
      b.onclick=function(){
        var it=_cdvLista[+b.getAttribute('data-fic')]; if(!it) return;
        cdvFechar();               /* se veio do modal, ele sai da frente */
        try{ telaClientes().then(function(){ try{ crmFichaAbrir(it.c.id); }catch(_){} }); }
        catch(_){ toast('Abra a tela Clientes pra ver a ficha.'); }
      };
    });
  }

  /* ---- O ENVIO (com todos os freios na frente) -------------------------- */
  async function _cdvEnviar(idx, v, btn){
    var it=_cdvLista[idx]; if(!it) return;
    var c=it.c;
    var tel=String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(tel.length<10){ toast('Este cliente está sem telefone válido.'); return; }
    await _cdvEstadoLer();
    var agora=Date.now(), est=_cdvEstado;

    /* 1) o mesmo carro nunca vai duas vezes pra mesma pessoa */
    if(est.par[_cdvVeicId+'|'+c.id]){ toast('Você já avisou '+(String(c.nome||'').split(' ')[0])+' sobre este carro.'); return; }

    /* 2) teto do dia — é o freio que segura a mão em dia de estoque novo */
    if(_cdvUsadosHoje()>=CDV_TETO_DIA){ toast('Você já mandou '+CDV_TETO_DIA+' avisos hoje. Amanhã o contador zera — isso protege o número da loja.'); return; }

    /* 3) intervalo entre um envio e outro */
    if(agora-_cdvUltimoEnvio < CDV_GAP_MS){
      var falta=Math.ceil((CDV_GAP_MS-(agora-_cdvUltimoEnvio))/1000);
      toast('Espere '+falta+'s pro próximo. Mensagem emendada na outra parece robô.'); return;
    }

    /* 4) não encher o mesmo cliente (qualquer carro) */
    var ult=Number(est.cli[String(c.id)]||0);
    if(ult && (agora-ult) < CDV_CLI_DIAS*86400000){
      var dias=Math.max(1,Math.round((agora-ult)/86400000));
      if(!confirm('Você já avisou '+(String(c.nome||'').split(' ')[0])+' há '+dias+' dia(s) sobre outro carro.\n\nMandar mesmo assim?')) return;
    }

    /* 5) horário civilizado */
    var h=new Date().getHours();
    if(h<CDV_H1 || h>=CDV_H2){
      if(!confirm('São '+h+'h. Mensagem de loja fora do horário costuma render bloqueio e reclamação.\n\nMandar mesmo assim?')) return;
    }

    var msg=_cdvMsg(c, v);
    /* deixo você ler e ajustar antes de sair — em 10 segundos o texto vira
       seu, e texto igualzinho pra todo mundo é o que os filtros pegam. */
    var texto=prompt('Confira a mensagem (dá pra editar):', msg);
    if(texto===null) return;
    texto=String(texto).trim(); if(!texto) return;

    if(btn){ btn.disabled=true; btn.textContent='Enviando…'; }
    var porOnde='';
    var conversa=null; try{ conversa=_chatDe(c); }catch(_){}
    if(conversa){
      /* JÁ CONVERSOU com a loja: pode sair pelo Z-API (o cliente conhece o
         número e já respondeu antes — é o cenário de menor risco). */
      var r=null; try{ r=await _chatApi({acao:'enviar', telefone:tel, texto:texto}); }catch(_){}
      if(!(r&&r.ok)){
        if(btn){ btn.disabled=false; btn.textContent='Enviar'; }
        toast((r&&r.erro)||'Não consegui enviar pelo chat. Tente pela ficha do cliente.');
        return;
      }
      porOnde='chat';
    } else {
      /* NUNCA conversou: não disparo automático nenhum. Abro o WhatsApp com
         o texto pronto e VOCÊ aperta o enviar. Primeiro contato feito por
         robô é o caminho mais curto pro bloqueio. */
      var url=(cliWhatsUrl(tel)||'')+'?text='+encodeURIComponent(texto);
      mevIrProWhats(url);                                   /* v370 */
      porOnde='whatsapp';
    }

    _cdvUltimoEnvio=Date.now();
    est.par[_cdvVeicId+'|'+c.id]=Date.now();
    est.cli[String(c.id)]=Date.now();
    est.dia[_cdvHoje()]=_cdvUsadosHoje()+1;
    await _cdvEstadoGravar();
    /* fica no histórico do cliente — no dia em que ele responder, você lembra
       por que ele está falando desse carro. */
    try{ crmObsRegistrar(c.id, 'Avisado sobre '+((((v.marca||'')+' '+(v.modelo||'')).trim())||'veículo')+(v.placa?(' ('+v.placa+')'):'')+(porOnde==='chat'?' — pelo chat':' — pelo WhatsApp'), true); }catch(_){}

    if(btn){ btn.disabled=true; btn.textContent='Avisado ✓'; }
    var cota=document.getElementById('cdvCota');
    if(cota) cota.textContent=_cdvUsadosHoje()+' de '+CDV_TETO_DIA+' avisos hoje';
    toast(porOnde==='chat'?'Mensagem enviada pelo chat ✓':'WhatsApp aberto — é só apertar o enviar.');
  }

  /* ---- GANCHOS DO ESTOQUE ----------------------------------------------
     Chamados pelo 14-estoque.js. Ficam aqui pra deixar o arquivo de lá com
     o menor remendo possível (menos chance de colidir com outra conversa). */
  function cdvMarcarNovo(id){ if(id) _cdvPendente=String(id); }
  async function cdvAoFecharFicha(){
    var id=_cdvPendente; _cdvPendente=null;
    if(!id) return;
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v || !v.modelo) return;                    /* ficha vazia: não incomoda */
    /* v348: avisa a EQUIPE no WhatsApp — isso vale mesmo que nenhum cliente
       da carteira combine com o carro. É recado interno: o vendedor precisa
       saber o que entrou no pátio pra sair oferecendo. O servidor manda uma
       vez por veículo e nunca pra quem cadastrou. */
    try{ cdvAvisarEquipe(v); }catch(_){}
    var n=0; try{ n=await cdvQuantos(v); }catch(_){}
    if(!n) return;                                  /* ninguém casa: silêncio */
    try{ if(navigator.vibrate) navigator.vibrate(12); }catch(_){}
    cdvAbrir(id);
    /* avisa o lojista por e-mail também (o servidor decide se manda) */
    try{ cdvEmailNovo(v, n); }catch(_){}
  }
  /* e-mail pro lojista — o corpo é montado no servidor pra não expor chave
     nenhuma no app. Se a função não existir ainda, isso simplesmente falha
     em silêncio e a aba Clientes continua funcionando. */
  async function cdvEmailNovo(v, n){
    try{
      var s=await supa.auth.getSession();
      var tk=(s&&s.data&&s.data.session&&s.data.session.access_token)||'';
      if(!tk) return;
      await fetch('/api/aviso-veiculo-novo',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ token:tk, veiculo_id:v.id, quantos:n }) });
    }catch(_){}
  }

  /* ===== v347 (pedido) — A ABA "CLIENTES" DENTRO DA FICHA DO VEÍCULO ========
     "crie uma aba ao lado direito do marketing com os clientes potenciais do
     veículo cadastrado".

     É a MESMA lista do painel da v342 (mesmo casamento, mesmos motivos,
     mesmos freios de envio) — só que morando dentro da ficha, à direita de
     Marketing. Assim, enquanto você termina de cadastrar o carro, a resposta
     de "pra quem eu ligo?" está a uma aba de distância.

     Lê o veículo do FORMULÁRIO (_estFichaVeic), não do banco: assim, se você
     acabou de digitar o preço de anúncio, o casamento por faixa de preço já
     considera o valor novo, sem precisar salvar e reabrir.
     ======================================================================== */
  async function cdvFichaPintar(){
    var body=document.getElementById('efCliBody'); if(!body) return;
    var v=null;
    try{ v=(typeof _estFichaVeic==='function')?_estFichaVeic():null; }catch(_){}
    if(!v || !(v.modelo||'').trim()){
      body.innerHTML='<div class="cdv-vazio"><b>Preencha o veículo primeiro.</b><br><br>'+
        'Informe o modelo e o preço de anúncio para procurar clientes compatíveis na sua carteira.<br><button type="button" class="cdv-preencher" id="efCliPreencher">Preencher veículo</button></div>';
      var preencher=document.getElementById('efCliPreencher');if(preencher)preencher.onclick=function(){_estFichaTab='cadastro';estFichaTabAplica();var modelo=document.getElementById('efModelo');if(modelo)modelo.focus();};
      return;
    }
    if(!v.id){
      body.innerHTML='<div class="cdv-vazio"><b>Só um instante.</b><br><br>'+
        'O veículo está sendo salvo. Volte nesta aba em um segundo que a lista aparece.</div>';
      return;
    }
    _cdvCss();
    _cdvVeicId=String(v.id);
    body.innerHTML='<div class="cdv-vazio">Procurando quem combina…</div>';
    try{ _chatResumoCarrega(function(){ if(document.getElementById('efCliBody')) _cdvPinta(v,'efCliBody','efCliCota'); }); }catch(_){}
    await _cdvEstadoLer();
    _cdvLista=await _cdvMontaLista(v);
    if(!document.getElementById('efCliBody')) return;      /* trocou de aba no meio */
    _cdvPinta(v,'efCliBody','efCliCota');
  }

  /* ===== v348 — O RECADO DA EQUIPE ========================================
     Manda pro servidor o MESMO texto que iria pro cliente (estVeicMsg: carro,
     preço de anúncio, itens marcados e o link da página). Quem escolhe pra
     quem mandar, quantas vezes e com qual intervalo é a function
     /api/avisar-equipe — no app não fica nenhum número de telefone da equipe
     nem credencial de WhatsApp. ========================================== */
  async function cdvAvisarEquipe(v){
    if(!v || !v.id) return;
    var texto='';
    try{ texto=estVeicMsg(v)||''; }catch(_){}
    try{
      var s=await supa.auth.getSession();
      var tk=(s&&s.data&&s.data.session&&s.data.session.access_token)||'';
      if(!tk) return;
      var r=await fetch('/api/avisar-equipe',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ token:tk, veiculo_id:v.id, texto:texto }) });
      var d=null; try{ d=await r.json(); }catch(_){}
      if(d && d.ok && d.enviados) toast('Avisei '+d.enviados+' pessoa'+(d.enviados===1?'':'s')+' da equipe no WhatsApp ✓');
    }catch(_){}
  }

/* ╔═══ src/app/14d-facebook-ads.js ═══════════════════════════════════════ */
  /* ===== v323 — ANÚNCIO PARA FACEBOOK ADS (módulo separado) =================
     Reposto FORA do 14-estoque de propósito: entra/sai trocando UM arquivo, sem
     reescrever a tela do estoque. Envolve o _mktPostsHtml (mantém os posts e
     ANEXA o bloco do Ads), reaproveita o texto de marketplace que a IA já gera,
     monta o título da ficha e o link do veículo. WhatsApp de cada carro = o da
     loja (já é o número da Z-API), então a conversa cai no chat.
     Segurança: usa só campos públicos (título da ficha, texto de marketplace,
     link público). Nunca custo/repasse/preço mínimo. ======================== */
  try{ if(typeof _MK_SVG!=='undefined' && _MK_SVG && !_MK_SVG.facebook){ _MK_SVG.facebook='<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>'; } }catch(_){}

  /* ===================== v348 — O ANÚNCIO REESCRITO ==========================
     O QUE ESTAVA ERRADO
     O bloco reaproveitava o texto de MARKETPLACE, que é ficha técnica
     ("Quilometragem: 88.000 km / Cor: Prata / ✅ Airbag duplo frontal").
     Isso serve pra OLX, onde a pessoa JÁ está procurando carro. No anúncio
     PAGO você interrompe alguém no meio do feed: airbag e ABS não param o
     dedo de ninguém — e são justamente os primeiros 125 caracteres, que é
     tudo que aparece antes do "ver mais".

     E o título saía com 63 caracteres ("VW - VolksWagen Fox Xtreme 1.6 Flex
     8V 5p 2020/2021 — R$ 69.900"), quando a Meta recomenda ~27 a 40: o
     Facebook cortava no meio.

     COMO FICOU (estrutura AIDA)
     ATENÇÃO  1ª linha: carro + ano + km + preço + a prova mais forte.
              Cabe nos 125 caracteres. É o anúncio inteiro pra quem só passa
              o olho.
     INTERESSE os DIFERENCIAIS que você marcou na ficha (IPVA pago, revisado,
              garantia, sem sinistro...). São eles que vendem seminovo — e
              estavam ali do lado, sem serem usados.
     DESEJO   opcionais/destaques que você escreveu + a cidade da loja.
     AÇÃO     chamada direta pro WhatsApp e o link.

     Tudo montado com o que JÁ existe na ficha: nenhuma chamada de IA,
     nenhum token, funciona offline.
     Nunca entra preço de compra, mínimo, custo ou margem.
     ======================================================================== */

  /* nome curto: a marca vira "VW", "Chevrolet"... e do modelo ficam as duas
     primeiras palavras ("Fox Xtreme", "Onix Hatch"). O resto (1.6 Flex 8V 5p)
     é ruído num título de 40 caracteres. */
  function _fbNomeCurto(v){
    var marca=String(v.marca||'').split(/[\s\-\/]+/)[0]||'';
    var mod=String(v.modelo||'').trim().split(/\s+/).filter(function(w){
      return !/^\d/.test(w) && !/^(flex|aut|mec|8v|16v|12v|4p|5p|2p|tsi|msi|mpi)\.?$/i.test(w);
    }).slice(0,2).join(' ');
    return (marca+' '+mod).trim()||'Veículo';
  }
  function _fbAno(v){
    var a=String(v.ano_modelo||v.ano||'').trim();
    return a?a.slice(-4):'';
  }
  function _fbPreco(v){
    var p=Number(v.preco_anuncio)||0;
    return p?('R$ '+p.toLocaleString('pt-BR',{maximumFractionDigits:0})):'';
  }
  function _fbKm(v){
    var k=Number(v.km)||0;
    if(!k) return '';
    return (k>=1000) ? (Math.round(k/1000)+' mil km') : (k+' km');
  }
  /* os diferenciais MARCADOS na ficha, em texto */
  function _fbDiferenciais(v){
    var ex=(v&&v.extras)||{}, out=[];
    try{
      if(typeof _EX_DIF!=='undefined' && _EX_DIF && _EX_DIF.length){
        _EX_DIF.forEach(function(d){ if(ex[d.k]) out.push({t:d.t, e:d.e||'✅'}); });
      }
    }catch(_){}
    return out;
  }
  /* a prova mais forte pra primeira linha: procedência antes de conforto */
  function _fbProvaCurta(v){
    var difs=_fbDiferenciais(v).map(function(d){ return d.t; });
    var ordem=['Sem sinistro','Sem leilão','Único dono','IPVA pago','Garantia de 90 dias','Na garantia de fábrica','Revisado','Pneus novos','Documentação em dia'];
    for(var i=0;i<ordem.length;i++){ if(difs.indexOf(ordem[i])>=0) return ordem[i]; }
    return '';
  }

  /* ---- TÍTULO: alvo 40 caracteres. Monta e vai encurtando até caber. ---- */
  function _mktFbTitulo(v){
    var nome=_fbNomeCurto(v), ano=_fbAno(v), preco=_fbPreco(v);
    var t=[nome, ano].filter(Boolean).join(' ');
    if(preco) t += ' • ' + preco;
    if(t.length<=40) return t;
    t=[nome, ano].filter(Boolean).join(' ');            /* tira o preço */
    if(t.length<=40) return t;
    return (nome+(ano?(' '+ano):'')).slice(0,39).trim(); /* corta o nome */
  }
  /* ---- DESCRIÇÃO: alvo 30 caracteres. Duas provas curtas. -------------- */
  function _mktFbDescricao(v){
    var difs=_fbDiferenciais(v).map(function(d){ return d.t; });
    var curtos=difs.filter(function(t){ return t.length<=20; });
    var d=curtos.slice(0,2).join(' • ');
    if(!d){ var km=_fbKm(v); d=[km,'Fale no WhatsApp'].filter(Boolean).join(' • '); }
    return d.length<=30 ? d : (curtos[0]||'Fale no WhatsApp');
  }
  /* ---- TEXTO PRINCIPAL: AIDA, com a 1ª linha cabendo em 125 caracteres -- */
  function _mktFbTexto(v){
    var nome=_fbNomeCurto(v), ano=_fbAno(v), km=_fbKm(v), preco=_fbPreco(v);
    var prova=_fbProvaCurta(v);
    var L=[];

    /* ATENÇÃO — a única linha que todo mundo lê */
    var chamada='🚗 '+nome+(ano?(' '+ano):'')+(km?(' com '+km):'');
    if(preco) chamada+=' por '+preco;
    if(prova) chamada+=' — '+prova.toLowerCase()+'.'; else chamada+='.';
    L.push(chamada);

    /* INTERESSE — a procedência que você marcou */
    var difs=_fbDiferenciais(v);
    if(difs.length){
      L.push('');
      difs.slice(0,7).forEach(function(d){ L.push(d.e+' '+d.t); });
    }

    /* DESEJO — o que você escreveu de opcionais/destaques */
    var ex=(v&&v.extras)||{};
    var extra=[String(ex.destaques||'').trim(), String(ex.opcionais||'').trim()].filter(Boolean).join(' • ');
    if(extra){ L.push(''); L.push('✨ '+extra); }

    /* AÇÃO — onde falar e o que acontece depois */
    var cidade='';
    try{ cidade=String((typeof _lojaRec!=='undefined'&&_lojaRec&&(_lojaRec.cidade||''))||'').trim(); }catch(_){}
    L.push('');
    if(cidade) L.push('📍 '+cidade);
    L.push('💬 Chame no WhatsApp e agende sua visita — respondemos na hora.');
    L.push('👇 Veja todas as fotos e a ficha completa:');
    return L.join('\n');
  }
  function _mktFbCampo(id,lbl,val,mono){
    return '<div class="fb-field"><div class="fb-field-lbl">'+esc(lbl)+'</div>'+
      '<div class="fb-field-row"><div class="fb-field-val'+(mono?' mono':'')+'" id="'+id+'Val">'+esc(val)+'</div>'+
      '<button type="button" class="fb-copy" id="'+id+'Copy" title="Copiar '+esc(lbl)+'" aria-label="Copiar '+esc(lbl)+'">'+mkIco('copiar',17)+'</button></div></div>';
  }
  function _mktFacebookAdsHtml(v, descricao){
    /* A jornada de anuncio pago foi retirada da aba Marketing. Mantemos o
       montador isolado para nao afetar posts e links ja salvos. */
    var exibirFacebookAds=false;
    if(!exibirFacebookAds) return '';
    if(!v) return '';
    var link=(typeof _publicoVeiculoUrl==='function')?_publicoVeiculoUrl(v):'';
    var titulo=_mktFbTitulo(v);
    /* v348: o texto do anúncio agora é MONTADO aqui (AIDA + diferenciais).
       O texto de marketplace que chegava no parâmetro continua servindo o
       bloco de cima da tela — só não serve mais pro anúncio pago. */
    var texto=_mktFbTexto(v);
    var desc=_mktFbDescricao(v);
    return '<article class="post-box fb-ads"><div class="post-kind">'+mkIco('facebook',14)+'<span>Anúncio para Facebook Ads</span></div>'+
      _mktFbCampo('fbTit','Título (até 40 caracteres)',titulo,false)+
      _mktFbCampo('fbTxt','Texto do anúncio',texto,false)+
      _mktFbCampo('fbDesc','Descrição (até 30 caracteres)',desc,false)+
      (link?_mktFbCampo('fbLink','Link do veículo (destino do anúncio)',link,true)
           :'<div class="fb-field"><div class="fb-field-lbl">Link do veículo</div><div class="fb-nolink">Salve o veículo no estoque para gerar o link.</div></div>')+
      (link?'<div class="post-acts so-ico" style="margin-top:12px"><button type="button" class="b1" id="fbCopiarTudo" title="Copiar texto + link" aria-label="Copiar texto e link">'+mkIco('copiar',19)+'</button><button type="button" class="b2 fb-abrir" id="fbAbrir" title="Copiar e abrir o Facebook Ads" aria-label="Copiar e abrir o Facebook Ads">'+mkIco('facebook',19)+'</button></div>':'')+
      '<div class="post-market-help">Cole o <b>texto</b> no campo do anúncio e o <b>link</b> no destino (site). O cliente clica, cai na página do carro e fala no seu WhatsApp — a conversa cai no chat.</div>'+
      _mktFbGuiaHtml()+'</article>';
  }

  /* ===== v348 — O PASSO A PASSO, FECHADO POR PADRÃO =======================
     Pedido: "monta o passo a passo num campo minimizado, lojista clica e
     abre se desejar". Usa <details>/<summary>, que é do próprio navegador:
     abre e fecha sozinho, sem uma linha de JavaScript e sem ocupar espaço
     de quem já sabe subir anúncio. ========================================= */
  function _mktFbGuiaHtml(){
    var passo=function(n,tit,txt){
      return '<div class="fb-passo"><b>'+n+'. '+tit+'</b><span>'+txt+'</span></div>';
    };
    return '<details class="fb-guia"><summary>Como subir esse anúncio (passo a passo)</summary><div class="fb-guia-in">'+
      passo(1,'Objetivo da campanha','Escolha <b>Tráfego</b> se quer que o cliente abra a página do carro, ou <b>Mensagens</b> se prefere que ele caia direto no seu WhatsApp. Para seminovo, Mensagens costuma trazer conversa mais rápida; Tráfego traz mais gente vendo as fotos.')+
      passo(2,'Onde anunciar','Sua cidade com raio de <b>20 a 40 km</b>. Carro usado é venda de perto: anunciar pro estado inteiro gasta dinheiro com quem não vem até a loja.')+
      passo(3,'Quem vai ver','Idade <b>25 a 55</b>, todos os gêneros. Não aperte demais o público — o Facebook acha o comprador sozinho se você deixar espaço.')+
      passo(4,'Quanto gastar','Comece com <b>R$ 15 a R$ 25 por dia</b> e deixe rodar <b>4 dias inteiros</b> antes de julgar. Mexer todo dia atrapalha o aprendizado da campanha.')+
      passo(5,'Os campos','Cole o <b>Título</b>, o <b>Texto</b> e a <b>Descrição</b> daqui de cima, e o <b>link</b> no destino. Botão de ação: <b>Saiba mais</b> (tráfego) ou <b>Enviar mensagem</b>.')+
      passo(6,'A foto','Use a foto de capa do carro, de frente 3/4, sem escrita por cima. Formato <b>quadrado (1:1)</b> funciona bem no feed e no Instagram.')+
      passo(7,'O que olhar depois','Custo por conversa iniciada. Se em 4 dias não veio conversa nenhuma, troque a <b>foto</b> primeiro — ela pesa mais que o texto.')+
      '</div></details>';
  }

  async function _mktFacebookAdsAbrir(descricao,link){
    try{ await _mktCopiar((descricao?(descricao+'\n\n'):'')+link); }catch(_){}
    try{ window.open('https://www.facebook.com/adsmanager/','_blank','noopener'); }catch(_){ location.href='https://www.facebook.com/adsmanager/'; }
    try{ toast('Texto e link copiados. Cole no seu anúncio do Facebook Ads.'); }catch(_){}
  }

  /* envolve o _mktPostsHtml original: mantém os posts e ANEXA o bloco do Ads.
     Pega o veículo do _mktV (o mesmo que a tela de Marketing já usa) e a
     descrição do texto de marketplace (ou, na falta, do post social). */
  try{
    if(typeof _mktPostsHtml==='function' && !_mktPostsHtml.__fb){
      var _mktPostsHtmlOrig=_mktPostsHtml;
      _mktPostsHtml=function(social, socialQuando, marketplace, marketplaceQuando){
        var base=_mktPostsHtmlOrig(social, socialQuando, marketplace, marketplaceQuando);
        var v=(typeof _mktV!=='undefined')?_mktV:null;
        if(!v) return base;
        var fb=_mktFacebookAdsHtml(v, marketplace||social);
        if(!fb) return base;
        return /<\/div>\s*$/.test(base) ? base.replace(/<\/div>\s*$/, fb+'</div>') : (base+fb);
      };
      _mktPostsHtml.__fb=true;
    }
  }catch(_){}

  /* fiação por DELEGAÇÃO (um listener só, no documento): não depende de o
     chamador religar os botões. Lê os valores direto dos campos exibidos. */
  try{
    if(typeof window!=='undefined' && !window.__fbAdsWired){
      window.__fbAdsWired=true;
      document.addEventListener('click',function(e){
        var b=(e.target&&e.target.closest)?e.target.closest('#fbTitCopy,#fbTxtCopy,#fbDescCopy,#fbLinkCopy,#fbCopiarTudo,#fbAbrir'):null;
        if(!b) return;
        var val=function(id){ var el=document.getElementById(id); return el?el.textContent:''; };
        var titulo=val('fbTitVal'), texto=val('fbTxtVal'), link=val('fbLinkVal');
        if(b.id==='fbTitCopy') _mktCopiar(titulo,'Título copiado.');
        else if(b.id==='fbDescCopy') _mktCopiar(val('fbDescVal'),'Descrição copiada.');
        else if(b.id==='fbTxtCopy') _mktCopiar(texto,'Texto copiado.');
        else if(b.id==='fbLinkCopy') _mktCopiar(link,'Link copiado.');
        else if(b.id==='fbCopiarTudo') _mktCopiar((texto?(texto+'\n\n'):'')+link,'Texto e link copiados.');
        else if(b.id==='fbAbrir') _mktFacebookAdsAbrir(texto, link);
      });
    }
  }catch(_){}

  /* CSS do bloco, injetado (não mexe no styles.css) */
  try{
    if(typeof document!=='undefined' && !document.getElementById('fbAdsCss')){
      var _fbCss=document.createElement('style'); _fbCss.id='fbAdsCss';
      _fbCss.textContent='.fb-ads .fb-field{margin-top:10px}.fb-field-lbl{font-size:11px;font-weight:800;color:var(--azul2);margin-bottom:4px}.fb-field-row{display:flex;gap:8px;align-items:flex-start}.fb-field-val{flex:1;min-width:0;background:#fff;border:1px solid #dbe7fa;border-radius:10px;padding:9px 11px;font-size:13px;line-height:1.5;color:var(--tinta);font-weight:600;white-space:pre-wrap;word-break:break-word;max-height:210px;overflow:auto}.fb-field-val.mono{font-size:12px;word-break:break-all;font-weight:700;color:var(--azul2)}.fb-copy{flex:0 0 auto;width:42px;height:42px;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:11px;background:var(--azulbg);color:var(--azul2);cursor:pointer}.fb-nolink{font-size:12.5px;color:var(--cinza);font-weight:600;background:#fff;border:1px dashed #dbe7fa;border-radius:10px;padding:9px 11px}.post-acts .b2.fb-abrir{background:#1877f2;color:#fff}'+
        /* v348 — o passo a passo fechado */
        '.fb-guia{margin-top:12px;border:1px solid #dbe7fa;border-radius:12px;background:#fff;overflow:hidden}'+
        '.fb-guia>summary{cursor:pointer;list-style:none;padding:11px 13px;font-size:13px;font-weight:800;color:var(--azul2);display:flex;align-items:center;gap:7px}'+
        '.fb-guia>summary::-webkit-details-marker{display:none}'+
        '.fb-guia>summary::before{content:"";width:0;height:0;border-left:6px solid currentColor;border-top:4.5px solid transparent;border-bottom:4.5px solid transparent;transition:transform .18s}'+
        '.fb-guia[open]>summary::before{transform:rotate(90deg)}'+
        '.fb-guia-in{padding:2px 13px 13px}'+
        '.fb-passo{padding:9px 0;border-top:1px solid #eef4fd}'+
        '.fb-passo b{display:block;font-size:12.5px;color:var(--tinta);margin-bottom:2px}'+
        '.fb-passo span{display:block;font-size:12.5px;line-height:1.5;color:var(--cinza)}';
      (document.head||document.documentElement).appendChild(_fbCss);
    }
  }catch(_){}

/* ╔═══ src/app/14e-pagina-repasse.js ═════════════════════════════════════ */
  /* ==========================================================================
     14e — PÁGINA "REPASSE" DO MENU (v396 · v400: cópia exata da página Estoque)

     "repasse com o mesmo layout dos cards e de pagina do estoque (copia
      exata)" — a página agora é montada IGUAL à telaEstoque: mesmo
     cabeçalho (título + frase), mesma busca, mesma lista. Os cards são os
     do estoque (estPintaNegociando já usa est-card/est-vv-card e, desde a
     v400, a MESMA tira deslizável de fotos — estThumbFotos). O CSS das
     três listas é um só: :is(#estLista,#vendaEstoque,#repMeuLista).

     Depois de uma ação nos cards (reservar/vender/excluir), o
     estNegAcaoExec (14) chama repMeuPinta() daqui pra lista se atualizar.
     ========================================================================= */

  /* ===== v627 — ORDENAR E FILTRAR (pedido do Angelo, 24/08) ================
     "adicione um ordenar e um filtrar e deixe por padrao do mais recente pro
     mais antigo".

     🔑 O DESENHO NÃO FOI INVENTADO: é o MESMO da folha de filtros dos Leads
     (v598) — um botão "Filtros ⏷" ao lado da busca e os selects DENTRO de
     uma folha por cima. As classes são as mesmas (.crm-fbt · .cropmask ·
     .cropbox · .crm-fitem), sem CSS novo: se cada tela desenhar a sua folha,
     em três versões existem três desenhos diferentes de folha.
     E é o desenho certo pra cá: esta página tem foto grande, o espaço
     vertical é caro — dois selects soltos empurrariam os cards pra baixo.

     ⚠️ A ESCOLHA FICA GUARDADA no aparelho (quem ordena por preço está
     fazendo uma varredura e volta à tela várias vezes) — MAS a bolinha azul
     no botão avisa sempre que a lista não está no padrão. Preferência
     lembrada sem sinal na tela vira defeito fantasma: o lojista abre semana
     que vem, vê a lista "errada" e não entende por quê. */
  var _REP_ORD_KEY='mev_rep_ord', _REP_SIT_KEY='mev_rep_sit';
  function _repOrd(){ try{ return localStorage.getItem(_REP_ORD_KEY)||'recente'; }catch(_){ return 'recente'; } }
  function _repSit(){ try{ return localStorage.getItem(_REP_SIT_KEY)||''; }catch(_){ return ''; } }
  function _repFiltroDot(){
    var b=$('repFiltrosBt'); if(!b) return;
    b.classList.toggle('on', !!(_repSit() || _repOrd()!=='recente'));
  }
  function repMeuPinta(){
    var el=$('repMeuLista'); if(!el) return;
    var termo=String((($('repMeuBusca')||{}).value)||'').toLowerCase().trim();
    estPintaNegociando(el, termo, { ord:_repOrd(), sit:_repSit(), portal:true });
    _repFiltroDot();
  }
  function repFiltrosLigar(){
    var bt=$('repFiltrosBt'), fo=$('repFiltrosFolha');
    var so=$('repOrd'), ss=$('repSit');
    try{ if(so) so.value=_repOrd(); if(ss) ss.value=_repSit(); }catch(_){}
    if(bt&&fo){
      bt.onclick=function(){ fo.style.display='flex'; };
      fo.onclick=function(e){ if(e.target===fo) fo.style.display='none'; };
      var okb=$('repFiltrosOk'); if(okb) okb.onclick=function(){ fo.style.display='none'; };
    }
    if(so) so.onchange=function(){ try{ localStorage.setItem(_REP_ORD_KEY, so.value); }catch(_){} repMeuPinta(); };
    if(ss) ss.onchange=function(){ try{ localStorage.setItem(_REP_SIT_KEY, ss.value); }catch(_){} repMeuPinta(); };
    _repFiltroDot();
  }

  async function abrirRepasseEstoque(){
    mevTabSet('');
    document.body.classList.add('venda-cot');   /* mesma largura da página Estoque */
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg cad-float"><div class="lj-est-panel">'+
      '<div class="est-main lj-est-main vv-pg">'+
      '<div class="est-head vv-top est-stock-head"><div><h2>Repasse</h2><p>Anunciados no Portal do Repasse — em negociação.</p></div></div>'+
      '<div class="vv-tools"><div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="repMeuBusca" placeholder="Buscar placa ou modelo do repasse" autocomplete="off"></div>'+
        /* v627: o botão da folha, ao lado da busca (padrão da v598) */
        '<button type="button" class="crm-ord crm-fbt" id="repFiltrosBt">Filtros <span class="crm-fbt-ch">⏷</span></button>'+
      '</div></div>'+
      /* v627: a folha por cima — os dois selects moram aqui dentro */
      '<div class="cropmask" id="repFiltrosFolha" style="display:none"><div class="cropbox" style="max-width:340px">'+
        '<div class="crop-tit">Filtros</div>'+
        '<div class="crm-fitem"><label>Ordenar</label>'+
          '<select class="crm-ord" id="repOrd" aria-label="Ordenar a lista">'+
          EST_NEG_ORDENS.map(function(o){ return '<option value="'+o[0]+'">'+esc(o[1])+'</option>'; }).join('')+'</select></div>'+
        '<div class="crm-fitem"><label>Situação</label>'+
          '<select class="crm-ord" id="repSit" aria-label="Filtrar por situação">'+
          EST_NEG_SITS.map(function(o){ return '<option value="'+o[0]+'">'+esc(o[1])+'</option>'; }).join('')+'</select></div>'+
        '<button type="button" class="link" id="repFiltrosOk" style="margin-top:12px;width:100%">Fechar</button>'+
      '</div></div>'+
      '<div id="repMeuLista">'+pgLoad('Abrindo o repasse…')+'</div>'+   /* v424: anel da abertura */
      '</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    var bq=$('repMeuBusca'); if(bq) bq.oninput=function(){ repMeuPinta(); };
    document.body.classList.add('oper-on');
    try{ consultaUiDockMedir(); }catch(_){}
    repFiltrosLigar();   /* v627 */
    /* o filtro "negociando" compara com o estoque (o que já virou cadastro
       não aparece aqui) — então garante os dois carregados */
    try{ if(!_estoque.length) await estCarregar(); }catch(_){}
    try{ await estRepasseCarregar(); }catch(_){}
    repMeuPinta();
  }

/* ╔═══ src/app/14f-docs-renave.js ════════════════════════════════════════ */
  /* ==========================================================================
     14f — DOCUMENTOS DO VEÍCULO + RENAVE NA FICHA DO ESTOQUE (v463, pedido)

     Duas abas novas na ficha do veículo (Cadastro · Fotos · ... · Clientes):
     - DOCUMENTOS: anexar CRLV, CNH e comprovante de residência DO ATUAL
       PROPRIETÁRIO. Sobe pelo MESMO cofre privado dos documentos da conta
       (/api/arquivo-privado via arqUpload do 13 — URL assinada curta, nada
       público). As referências moram em extras.docs do veículo (jsonb).
     - RENAVE: a conferência do Pré-RENAVE (v442) DESTE veículo — os campos
       que a IA/CRLV já preencheram, o que falta, a ficha pronta pra copiar
       no integrador e o atalho pra página completa. NÃO duplica o motor:
       usa _PR_CAMPOS/_prCampo/_prFichaTexto do 12f.

     Este arquivo é AUTOSSUFICIENTE (padrão do 16b): EMBRULHA o
     estAbrirFicha e injeta as abas depois que a ficha nasce. Pra desligar:
     apagar o arquivo e rodar o montar.js.
     ⚠️ O autosave do estoque reconstrói o extras — a preservação de
     extras.docs foi acrescentada ao lado da do prerenave (14, ~2215).
     ========================================================================= */

  var _DR_DOCS=[
    ['crlv','CRLV do veículo'],
    ['cnh','CNH do atual proprietário'],
    ['residencia','Comprovante de residência']
  ];
  function _drVe(){ try{ return _estFichaVeic(); }catch(_){ return null; } }
  function _drDocs(v){ return (((v||{}).extras)||{}).docs||{}; }
  async function _drSalvarDocs(v, docs){
    try{
      var ex=Object.assign({}, v.extras||{}); ex.docs=docs;
      var r=await supa.from('estoque').update({ extras:ex, atualizado_em:new Date().toISOString() }).eq('id',v.id);
      if(r&&r.error) throw r.error;
      v.extras=ex;
      return true;
    }catch(e){ toast('Não consegui salvar o documento. '+((e&&e.message)||'')); return false; }
  }

  /* ---------- aba DOCUMENTOS ---------- */
  function drDocsPinta(){
    var box=$('drDocsBox'), v=_drVe(); if(!box) return;
    if(!v || !v.id){ box.innerHTML='<div class="cli-empty">Salve o cadastro do veículo primeiro.</div>'; return; }
    var docs=_drDocs(v);
    box.innerHTML=_DR_DOCS.map(function(d){
      var reg=docs[d[0]];
      return '<div class="dr-doc'+(reg?' ok':'')+'">'+
        '<div class="dr-doc-tx"><b>'+esc(d[1])+'</b>'+
          (reg?('<i>'+esc(reg.nome||'arquivo')+' · '+esc(reg.em?new Date(reg.em).toLocaleDateString('pt-BR'):'')+'</i>'):'<i>ainda não anexado</i>')+'</div>'+
        '<div class="dr-doc-acts">'+
          (reg?('<button type="button" class="cad-btn sec" data-dr-ver="'+d[0]+'">Ver</button>'):'')+
          '<button type="button" class="cad-btn'+(reg?' sec':'')+'" data-dr-anexa="'+d[0]+'">'+(reg?'Trocar':'Anexar')+'</button>'+
          (reg?('<button type="button" class="cad-btn sec dr-x" data-dr-tira="'+d[0]+'" aria-label="Remover">✕</button>'):'')+
        '</div></div>';
    }).join('')+'<input type="file" id="drDocArq" accept="image/*,.pdf" hidden>';
    Array.prototype.forEach.call(box.querySelectorAll('[data-dr-anexa]'),function(b){
      b.onclick=function(){
        var k=b.getAttribute('data-dr-anexa'), inp=$('drDocArq'); if(!inp) return;
        inp.value=''; inp.onchange=async function(){
          var f=this.files&&this.files[0]; if(!f) return;
          toast('Enviando documento...');
          try{
            var ref=await arqUpload(f, k==='crlv'?'crlv':(k==='cnh'?'cnh':'residencia'));
            if(!ref) throw new Error('sem referência');
            var v2=_drVe(); var ds=Object.assign({}, _drDocs(v2));
            ds[k]={ ref:ref, nome:f.name, em:new Date().toISOString() };
            if(await _drSalvarDocs(v2, ds)){ toast('Documento anexado ✓'); drDocsPinta(); drRenavePinta(); }
          }catch(e){ toast('Não consegui anexar. '+((e&&e.message)||'')); }
        };
        inp.click();
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-dr-ver]'),function(b){
      b.onclick=async function(){
        try{
          var reg=_drDocs(_drVe())[b.getAttribute('data-dr-ver')]; if(!reg) return;
          var u=await _arqPrivadoUrl(reg.ref);
          if(u) window.open(u,'_blank'); else toast('Não consegui abrir agora.');
        }catch(_){ toast('Não consegui abrir agora.'); }
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-dr-tira]'),function(b){
      b.onclick=async function(){
        var k=b.getAttribute('data-dr-tira');
        if(!confirm('Remover este documento do veículo? O arquivo some da ficha (as cópias já geradas continuam).')) return;
        var v2=_drVe(); var ds=Object.assign({}, _drDocs(v2)); delete ds[k];
        if(await _drSalvarDocs(v2, ds)){ toast('Documento removido.'); drDocsPinta(); }
      };
    });
  }

  /* ===== v465 — A IA LÊ O CRLV ANEXADO E PREENCHE O QUE FALTA ============
     O botão na aba RENAVE pega o CRLV que você anexou na aba Documentos
     (cofre privado), manda pro MESMO leitor de CRLV das vendas
     (/api/ia-extrair-proposta, tipo 'crlv' — 1 token, estorno se falhar) e
     preenche SÓ O QUE ESTÁ VAZIO: chassi/renavam no extras.prerenave (com o
     carimbo pr.ia, que o 12f mostra como "lido do CRLV pela IA") e
     marca/modelo/cor/ano/placa vazios no cadastro. O que você já digitou,
     ninguém encosta. Placa do CRLV diferente da placa do carro = NADA é
     preenchido (documento errado na gaveta — lição do crlv_troca, v305). */
  async function _drIaAplicar(v, dados){
    dados=dados||{};
    function limpaPl(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
    var plDoc=limpaPl(dados.placa), plCarro=limpaPl(v.placa);
    if(plDoc && plCarro && plDoc!==plCarro)
      return { ok:false, msg:'⚠️ A placa do CRLV ('+plDoc+') não bate com a deste veículo ('+plCarro+'). Nada foi preenchido — confira se anexou o documento certo.' };
    var ex=Object.assign({}, v.extras||{});
    var pr=Object.assign({}, ex.prerenave||{});
    var postos=[], upd={};
    var ch=String(dados.chassi||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(ch && !pr.chassi){ pr.chassi=ch; pr.ia=Object.assign({},pr.ia||{},{chassi:true}); postos.push('chassi'); }
    var rn=String(dados.renavam||'').replace(/\D/g,'');
    if(rn && !pr.renavam){ pr.renavam=rn; pr.ia=Object.assign({},pr.ia||{},{renavam:true}); postos.push('renavam'); }
    /* campos do CADASTRO: só preenche o que está VAZIO (mesma regra do
       endereço do comprovante — máquina nunca passa por cima do que você
       digitou) */
    var mapa={ placa:plDoc, marca:dados.marca, modelo:dados.modelo, cor:dados.cor,
               ano:dados.ano_fabricacao, ano_modelo:dados.ano_modelo };
    Object.keys(mapa).forEach(function(campo){
      var novo=String(mapa[campo]==null?'':mapa[campo]).trim();
      if(!novo) return;
      if(String(v[campo]||'').trim()) return;   /* já tinha: não encosta */
      upd[campo]=novo; v[campo]=novo; postos.push(campo==='ano'?'ano fab.':campo);
    });
    if(postos.length){ pr.em=new Date().toISOString(); }
    ex.prerenave=pr;
    /* a leitura crua fica guardada junto do documento, pra conferência */
    var ds=Object.assign({}, ex.docs||{});
    if(ds.crlv){ ds.crlv=Object.assign({},ds.crlv,{ia:dados, ia_em:new Date().toISOString()}); ex.docs=ds; }
    upd.extras=ex; upd.atualizado_em=new Date().toISOString();
    try{
      var r=await supa.from('estoque').update(upd).eq('id',v.id);
      if(r&&r.error) throw r.error;
      v.extras=ex;
    }catch(e){ return { ok:false, msg:'Li o CRLV, mas não consegui salvar. '+((e&&e.message)||'') }; }
    return { ok:true, msg: postos.length
      ? ('A IA leu o CRLV ✓ Preencheu: '+postos.join(', ')+'. Confira os dígitos antes de lançar.')
      : 'A IA leu o CRLV ✓ Tudo já estava preenchido — não mexi em nada.' };
  }
  async function drIaLerCrlv(){
    var v=_drVe(); if(!v || !v.id) return;
    var reg=_drDocs(v).crlv;
    if(!reg){ toast('Anexe o CRLV na aba Documentos primeiro.'); return; }
    var bt=$('drRenIa'); if(bt){ bt.disabled=true; bt.textContent='Lendo o CRLV…'; }
    try{
      var u=await _arqPrivadoUrl(reg.ref);
      if(!u) throw new Error('não consegui abrir o documento');
      var rb=await fetch(u); if(!rb.ok) throw new Error('não consegui baixar o documento');
      var blob=await rb.blob();
      var file=new File([blob], reg.nome||'crlv.jpg', { type: blob.type||'image/jpeg' });
      var p=await _arqPreparar(file);   /* o mesmo preparo do cofre: JPEG pequeno / PDF até 4 MB */
      var resp=await fetch('/api/ia-extrair-proposta',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ token:token, imagemBase64:p.base64, mimeType:p.mime, tipo:'crlv' }) });
      var d=null; try{ d=await resp.json(); }catch(_){}
      if(d && d.saldo!=null && typeof window.MEV_SALDO_ATUALIZA==='function') window.MEV_SALDO_ATUALIZA(d.saldo);
      if(!resp.ok || !d || !d.ok) throw new Error((d&&d.erro)||'a leitura falhou');
      var res=await _drIaAplicar(v, d.dados||{});
      toast(res.msg);
    }catch(e){ toast('Não consegui ler agora. '+((e&&e.message)||'')); }
    drRenavePinta();
  }

  /* ---------- aba RENAVE (conferência do Pré-RENAVE deste veículo) -------- */
  function drRenavePinta(){
    var box=$('drRenBox'), v=_drVe(); if(!box) return;
    if(!v || !v.id){ box.innerHTML='<div class="cli-empty">Salve o cadastro do veículo primeiro.</div>'; return; }
    var linhas='', faltam=[];
    try{
      _PR_CAMPOS.forEach(function(c){
        var info=_prCampo(v, c[0]);
        if(c[2] && !info.ok) faltam.push(c[1]);
        linhas+='<div class="dr-ren'+(info.ok?' ok':(c[2]?' falta':''))+'">'+
          '<span>'+esc(c[1])+'</span><b>'+esc(info.valor||'—')+'</b>'+
          (info.origem?('<i>'+esc(info.origem)+'</i>'):'')+'</div>';
      });
    }catch(_){ box.innerHTML='<div class="cli-empty">O motor do Pré-RENAVE não carregou.</div>'; return; }
    var ficha=''; try{ ficha=_prFichaTexto(v); }catch(_){}
    /* v465: o botão da IA — só quando o CRLV está anexado; senão, a dica */
    var temCrlv=!!_drDocs(v).crlv;
    var iaBloco = temCrlv
      ? '<button type="button" class="cad-btn dr-ren-ia" id="drRenIa">🪄 Ler o CRLV anexado com a IA e preencher · '+precoReal(1)+'</button>'
      : '<div class="dr-ren-dica">Anexe o CRLV na aba <b>Documentos</b> e a IA lê e preenche o que falta por aqui.</div>';
    box.innerHTML=
      (faltam.length?('<div class="dr-ren-falta">Faltam: '+esc(faltam.join(' · '))+'</div>')
                    :'<div class="dr-ren-falta ok">Tudo conferido ✓ pronto pra lançar</div>')+
      iaBloco+
      linhas+
      '<label class="crm-lb" style="margin-top:10px">FICHA PRA COLAR NO INTEGRADOR</label>'+
      '<textarea class="cad-in" id="drRenTxt" rows="7" readonly>'+esc(ficha)+'</textarea>'+
      '<div class="dr-ren-acts">'+
        '<button type="button" class="cad-btn" id="drRenCopiar">Copiar a ficha</button>'+
        '<button type="button" class="cad-btn sec" id="drRenAbrir">Abrir o Pré-RENAVE completo</button>'+
      '</div>';
    var bi=$('drRenIa'); if(bi) bi.onclick=drIaLerCrlv;
    var bc=$('drRenCopiar'); if(bc) bc.onclick=function(){
      try{ navigator.clipboard.writeText(($('drRenTxt')||{}).value||''); toast('Ficha copiada ✓'); }
      catch(_){ try{ $('drRenTxt').select(); document.execCommand('copy'); toast('Ficha copiada ✓'); }catch(__){ toast('Não consegui copiar.'); } }
    };
    var ba=$('drRenAbrir'); if(ba) ba.onclick=function(){ try{ drawerIr('prerenave'); }catch(_){ try{ telaPreRenave(); }catch(__){} } };
  }

  /* ---------- injeta as duas abas depois que a ficha nasce ---------- */
  function drInjeta(){
    /* Ocultas por enquanto. O modulo, os dados e as rotas continuam intactos
       para uma reativacao futura sem perder documentos ou campos RENAVE. */
    var abasDocumentaisVisiveis=false;
    if(!abasDocumentaisVisiveis) return;
    var tabs=$('efTabs'), body=$('efBody');
    if(!tabs || !body || tabs.querySelector('[data-step="docs"]')) return;
    var icoDoc='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>';
    var icoRen='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3 8-8"/><path d="M21 12v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11"/></svg>';
    tabs.insertAdjacentHTML('beforeend',
      '<button type="button" class="vpx-st" data-step="docs"><span class="vpx-ico">'+icoDoc+'</span><span class="vpx-nm">Documentos</span></button>'+
      '<button type="button" class="vpx-st" data-step="renave"><span class="vpx-ico">'+icoRen+'</span><span class="vpx-nm">RENAVE</span></button>');
    body.insertAdjacentHTML('beforeend',
      '<div class="vpx-panel" data-panel="docs"><div class="vp-sec"><div class="ec-tit">Documentos do veículo</div><div id="drDocsBox"></div></div></div>'+
      '<div class="vpx-panel" data-panel="renave"><div class="vp-sec"><div class="ec-tit">RENAVE — conferir e lançar</div><div id="drRenBox"></div></div></div>');
    Array.prototype.forEach.call(tabs.querySelectorAll('[data-step="docs"],[data-step="renave"]'),function(b){
      b.onclick=function(){
        _estFichaTab=b.getAttribute('data-step'); estFichaTabAplica();
        if(_estFichaTab==='docs') drDocsPinta();
        if(_estFichaTab==='renave') drRenavePinta();
      };
    });
    drDocsPinta(); drRenavePinta();
  }
  try{
    if(typeof estAbrirFicha==='function'){
      var _drFichaOrig=estAbrirFicha;
      estAbrirFicha=function(){
        var r=_drFichaOrig.apply(this,arguments);
        try{ drInjeta(); }catch(_){}
        return r;
      };
    }
  }catch(_){}

/* ╔═══ src/app/14g-baixar-fotos.js ═══════════════════════════════════════ */
  /* ==========================================================================
     14g — BAIXAR FOTOS DO VEÍCULO (v467, Fase 1 do PROJETO-baixar-fotos)

     Item "Baixar fotos (N)" no menu de ações do card do estoque. Devolve as
     fotos ORIGINAIS do carro pro aparelho do vendedor — o outro vendedor da
     loja para de pedir foto no WhatsApp (onde chega comprimida) ou de
     fotografar tudo de novo.

     AS TRÊS REGRAS DO PROJETO (ler o PROJETO antes de mexer):
     1. NUNCA baixar o que está na tela: o card mostra a foto passada pelo
        /.netlify/images?w=800 (economia de dado). A URL boa é v.fotos[i]
        CRUA — senão o lojista põe foto de 800px no Marketplace e sai borrada.
     2. Download EM SÉRIE (uma por vez): 13 fotos × ~3 MB de uma vez estoura
        a memória de celular. Teto de 20 fotos.
     3. O caminho principal é a FOLHA NATIVA (navigator.share com arquivos):
        é o ÚNICO que oferece "Salvar Imagens" na galeria do iPhone. O
        <a download> é a rede de segurança (Android/computador). Não existe
        API que grave direto na galeria de um PWA.

     Detalhes que parecem bobos e não são:
     · AbortError = a pessoa fechou a folha. NÃO é falha, nenhum toast.
     · NotAllowedError = o navegador perdeu o GESTO do toque (os downloads
       vêm de awaits). Aí a pílula vira o botão "Pronto — salvar N fotos":
       o segundo toque chama a folha DENTRO do gesto. ⚠️ Confirmar no
       iPhone de verdade antes de publicar.
     · revokeObjectURL depois de cada link, senão a memória não volta.
     · 11 de 13 é melhor que nada: entrega o que veio e diz quantas faltaram.

     Módulo separado de propósito: o 14-estoque.js tem 206 KB e é o mais
     disputado do repositório. Aqui só entraram os 2 ganchos (IC.dl + o item
     + o estAcaoExec). Pra desligar: apagar este arquivo e rodar o montar.js.
     ========================================================================= */

  var _DLF_TETO=20;
  function _dlfPill(txt){
    var p=document.getElementById('dlFotosPill');
    if(!p){ p=document.createElement('div'); p.id='dlFotosPill'; p.className='dlf-pill'; document.body.appendChild(p); }
    if(txt!=null) p.textContent=txt;
    return p;
  }
  function _dlfPillSome(){ var p=document.getElementById('dlFotosPill'); if(p){ try{ p.remove(); }catch(_){} } }
  function _dlfLink(f){
    try{
      var u=URL.createObjectURL(f), a=document.createElement('a');
      a.href=u; a.download=f.name; document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){} },1500);
    }catch(_){}
  }
  async function estBaixarFotos(v){
    var urls=((v&&v.fotos)||[]).slice(0,_DLF_TETO);
    if(!urls.length){ toast('Este veículo não tem fotos.'); return; }
    if(document.getElementById('dlFotosPill')) return;   /* já tem um andando */
    var placa=String(v.placa||'').replace(/[^A-Za-z0-9]/g,'')||'fotos';
    var arquivos=[], falhas=0;
    for(var i=0;i<urls.length;i++){
      _dlfPill('Baixando '+(i+1)+' de '+urls.length+'…');
      try{
        var r=await fetch(urls[i]);          /* a ORIGINAL do Storage, nunca a do CDN */
        if(!r.ok) throw 0;
        var b=await r.blob();
        var ext=String((b.type||'').split('/')[1]||'jpg').replace('jpeg','jpg');
        arquivos.push(new File([b], placa+'-'+String(i+1).padStart(2,'0')+'.'+ext, {type:b.type||'image/jpeg'}));
      }catch(_){ falhas++; }
    }
    if(!arquivos.length){ _dlfPillSome(); toast('Não consegui baixar as fotos. Tente de novo com sinal melhor.'); return; }
    var aviso=falhas?(' — '+falhas+' não '+(falhas===1?'veio':'vieram')):'';
    /* 1º caminho: a folha nativa ("Salvar Imagens" na galeria do iPhone) */
    if(navigator.share && navigator.canShare && navigator.canShare({files:arquivos})){
      try{
        _dlfPillSome();
        await navigator.share({files:arquivos});
        toast(arquivos.length+' foto'+(arquivos.length===1?'':'s')+' entregues'+aviso+' ✓');
        return;
      }catch(e){
        if(e && e.name==='AbortError') return;               /* fechou a folha: ok */
        if(e && e.name==='NotAllowedError'){ _dlfSegundoToque(arquivos, aviso); return; }
      }
    }
    /* 2º caminho: um download por foto (Android e computador) */
    _dlfPillSome();
    arquivos.forEach(_dlfLink);
    toast(arquivos.length+' foto'+(arquivos.length===1?'':'s')+' baixadas'+aviso+' ✓');
  }
  /* o navegador perdeu o gesto: o segundo toque chama a folha dentro dele */
  function _dlfSegundoToque(arquivos, aviso){
    var p=_dlfPill(null); p.textContent=''; p.classList.add('acao');
    var b=document.createElement('button'); b.type='button'; b.className='dlf-btn';
    b.textContent='Pronto — salvar '+arquivos.length+' foto'+(arquivos.length===1?'':'s');
    p.appendChild(b);
    b.onclick=function(){
      try{
        navigator.share({files:arquivos}).then(
          function(){ toast('Fotos entregues'+aviso+' ✓'); },
          function(e){ if(!(e&&e.name==='AbortError')){ arquivos.forEach(_dlfLink); toast('A folha não abriu — baixei uma a uma.'); } });
      }catch(_){ arquivos.forEach(_dlfLink); }
      _dlfPillSome();
    };
  }

/* ╔═══ src/app/14h-vitrine.js ════════════════════════════════════════════ */
  /* ============================================================================
   * 14h — A VITRINE DENTRO DO APP (v537)
   *
   * PEDIDO do Angelo (17/08): *"quero que comece com uma página de vitrine no
   * menu inicial e um card na tela inicial"* — o primeiro passo da conversa
   * sobre dar acesso à vitrine para o cliente.
   *
   * É a MESMA vitrine do site: os carros disponíveis da loja, do jeito que o
   * comprador vê. Serve pro vendedor mostrar no balcão, com o cliente do lado,
   * sem precisar abrir o navegador e caçar o link.
   *
   * ============================================================================
   * 🔴🔴 A DECISÃO QUE MAIS IMPORTA NESTE ARQUIVO: DE ONDE VÊM OS CARROS
   *
   * O caminho óbvio seria ler a `_estoque`, que já está carregada na memória.
   * **Seria errado, e de um jeito caro.** O card do Estoque mostra:
   *
   *     · "mín. R$ 62.000"     ← o PREÇO MÍNIMO. É o piso da negociação.
   *     · "margem R$ 8.400"    ← o LUCRO.
   *     · "89 dias parado"     ← quanto tempo o carro está encalhado.
   *     · "Consignado"         ← que o carro nem é da loja.
   *     · a OBSERVAÇÃO interna do cadastro.
   *
   * Qualquer um desses na frente do cliente vira desconto na hora. Mostrar
   * "89 dias parado" é entregar o argumento de negociação de graça; mostrar o
   * mínimo é entregar o fim da conversa antes dela começar.
   *
   * ⚠️ E isso não é hipótese: o cabeçalho do `netlify/functions/catalogo.js`
   * registra que a **observação interna já vazou** pro público uma vez, e que
   * foi preciso consertar. Reconstruir "o que é público" aqui seria repetir a
   * decisão num segundo lugar — e dois lugares decidindo a mesma coisa é como
   * eles passam a discordar.
   *
   * 🔴 ENTÃO ESTA TELA LÊ A MESMA FONTE DO SITE: a função `mp_get_catalogo`
   * do banco, que é exatamente a que a vitrine pública usa. Ela devolve só o
   * que pode ser visto:
   *
   *     marca · modelo · ano · ano_modelo · km · cor · fotos · preco
   *     selos · destaques · combustivel · reservado · repasse
   *
   * Repare no que NÃO vem: preço mínimo, preço de compra, margem, dias
   * parado, origem, observação — **e nem a placa**. Se um dia alguém decidir
   * publicar (ou esconder) um campo, muda numa função só e as duas vitrines
   * mudam juntas. É isso que faz esta ser "a mesma vitrine do site" de
   * verdade, e não uma imitação que envelhece.
   *
   * ⚠️ `get_catalogo` já está na whitelist MP_RPC do 01-nucleo — nada a
   * acrescentar lá.
   * ============================================================================
   *
   * ⚠️ ORDEM DE MONTAGEM: este arquivo é concatenado DEPOIS do 14 (estoque) e
   * ANTES do 19. Reaproveita `estThumbFotos`, `_ICO_CAL`, `_EST_ICO_KM`,
   * `_EST_ICO_COR` e `estStripsWire` do 14 — todos já existem quando isto
   * roda, mas as chamadas ficam dentro de funções e com guarda, que é a regra
   * da casa pra dependência entre módulos.
   * ========================================================================== */

  /* ⛳ v537 — desliga a página inteira (menu, card e rota) numa linha. */
  var VITRINE_ON = true;

  var _vitCache = null;      /* o que a RPC devolveu (loja + veiculos) */
  var _vitBusca = '';
  var _vitErro  = false;

  var _VIT_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><path d="M9 20v-6h6v6"/></svg>';

  /* o uid da loja — o MESMO critério do `homeCatalogoAbrir` (14), pra tela e
     link nunca mostrarem catálogos diferentes */
  function _vitUid(){
    try{ if(typeof _lojaRec!=='undefined' && _lojaRec && _lojaRec.user_id) return _lojaRec.user_id; }catch(_){}
    return meuId || '';
  }
  /* o endereço público, quando existir apelido (slug) */
  function vitUrlPublica(){
    var ap=''; try{ ap=(_lojaRec && _lojaRec.slug) ? String(_lojaRec.slug) : ''; }catch(_){}
    var uid=_vitUid(); if(!uid && !ap) return '';
    return ap ? (location.origin+'/'+ap) : (location.origin+'/catalogo/'+uid);
  }

  async function vitCarregar(forcar){
    if(_vitCache && !forcar) return _vitCache;
    _vitErro=false;
    var uid=_vitUid();
    if(!uid){ _vitErro=true; return null; }
    try{
      var r=await withTimeout(supa.rpc('get_catalogo',{ p_uid:uid }),9000);
      var d=(r&&r.data)||null;
      /* a RPC devolve um json só; dependendo do driver vem objeto ou array */
      if(Array.isArray(d)) d=d[0]||null;
      _vitCache = d || { loja:null, veiculos:[] };
    }catch(_){ _vitErro=true; _vitCache=null; }
    return _vitCache;
  }

  /* 🔴 "veículos disponíveis" (palavra do pedido): o reservado sai da lista.
     A RPC já não manda vendido; o `reservado` ela manda com a marca, porque
     no site ele aparece com tarja. Aqui, numa tela pra mostrar ao cliente,
     carro reservado só gera conversa que termina em "esse já era". */
  /* ══════════════════════════════════════════════════════════════════════
     🔴 v1250 — OS 0 KM DA LINHA VW TAMBÉM NESTA TELA
     ──────────────────────────────────────────────────────────────────────
     Angelo, 28/09: "quando clico que vai pro catalogo facebook, vai pro
     catalogo do app". A v1249 fez o catálogo PÚBLICO; aqui é a tela de
     dentro do app, a que ele abre no balcão com o cliente do lado.

     🔑 E ELA NÃO PRECISOU DE UMA SEGUNDA FONTE: a decisão do arquivo (ler o
     mp_get_catalogo, não a _estoque) já paga o preço agora. A v1249 pôs a
     chave `novos` na MESMA resposta, então esta tela só desenha o que já
     estava chegando. Se ela lesse o banco por conta própria, esta versão
     seria uma segunda regra de "quem aparece" pra discordar da primeira.

     ⚠️ QUEM DECIDE O QUE ENTRA CONTINUA SENDO O BANCO (a view
     vw_novos_catalogo): versão de varejo, cor marcada pro Facebook, foto
     real. Nada disso é reimplementado aqui. */
  function _vitNovos(){
    var ns=((_vitCache&&_vitCache.novos)||[]);
    return ns.map(function(n){
      n=n||{};
      /* "MY27" → "2027". Reaproveita o conversor do editor da linha 0 km
         (14o) em vez de escrever um quarto: ele já existe, e a regra do ano
         comercial não pode ter duas versões. Chamada DENTRO de função e com
         guarda — a regra da casa pra dependência entre módulos. */
      var ano='';
      try{ ano=(typeof lzAnoModelo==='function') ? (lzAnoModelo(n.model_year)||'') : ''; }catch(_){ ano=''; }
      if(!ano){ var _t=String(n.model_year||'').trim(); if(/^(19|20)\d{2}$/.test(_t)) ano=_t; }
      var preco=Number(n.preco)||0, pub=Number(n.preco_publicado)||0, tab=Number(n.preco_tabela)||0;
      return {
        id:'novo-'+String(n.versao_id||'').replace(/-/g,'')+'-'+(n.cor_codigo||''),
        marca:'Volkswagen',
        modelo:[String(n.modelo||'').trim(),String(n.versao||'').trim()].filter(Boolean).join(' '),
        ano:'', ano_modelo:ano, km:0,
        cor:String(n.cor||'').trim(),
        fotos:(n.foto?[n.foto]:[]),
        preco:preco,
        reservado:false,
        zero_km:true,
        /* v1253 — o riscado tem DUAS origens legítimas, nunca as duas juntas:
           o preço publicado (quando ele baixou numa unidade) ou o preço de
           TABELA. Riscar dois números é pedir pro cliente fazer conta pra
           descobrir qual vale; e "por" só se escreve quando houve mesmo um
           preço de venda anterior. */
        de:(preco>0 && pub>preco)?pub:(tab>preco?tab:0),
        dePor:(preco>0 && pub>preco),
        desconto:Number(n.desconto)||0,
        /* ⚠️ VENDA DIRETA NÃO É "O PREÇO MENOR". Medido: no Nivus Highline
           ela sai por R$ 147.700 contra R$ 137.500 do varejo; na Saveiro
           Robust CS é o contrário. Outro produto, outro público, outras
           condições — nunca com cara de desconto. */
        direta:(n.tem_direta && Number(n.preco_direta)>0)?Number(n.preco_direta):0,
        diretaRot:String(n.direta_rotulo||'').trim(),
        oportunidade:!!n.oportunidade,
        pronta:(Number(n.unidades)>0)
      };
    });
  }
  /* 🔴 "veículos disponíveis" (palavra do pedido): o reservado sai da lista.
     Os 0 km entram na FRENTE — é o que ele está publicando agora. */
  function _vitDisponiveis(){
    var vs=((_vitCache&&_vitCache.veiculos)||[]);
    return _vitNovos().concat(vs.filter(function(v){ return v && !v.reservado; }));
  }

  function _vitPreco(v){
    var n=Number(v&&v.preco)||0;
    if(!n) return 'Consulte';                       /* nunca inventa preço */
    try{ return brl(n); }catch(_){ return 'R$ '+n; }
  }

  function vitPinta(){
    var el=$('vitLista'); if(!el) return;
    if(_vitErro && !_vitCache){
      el.innerHTML='<div class="cli-empty"><b>Não consegui abrir a vitrine agora</b>Verifique sua internet e tente de novo.</div>';
      return;
    }
    var termo=String(_vitBusca||'').toLowerCase().trim();
    var lista=_vitDisponiveis().filter(function(v){
      if(!termo) return true;
      /* v1250 — o 0 km tem que ser achável pelas palavras que ele digita */
      var alvo=((v.marca||'')+' '+(v.modelo||'')+' '+(v.cor||'')+
        (v.zero_km?' 0 km zero km novo novos':'')+
        ((v.zero_km&&v.oportunidade)?' oportunidade':'')).toLowerCase();
      return alvo.indexOf(termo)>=0;
    });
    _vitResumoPinta(lista.length);
    if(!lista.length){
      el.innerHTML='<div class="cli-empty">'+
        (_vitDisponiveis().length
          ? '<b>Nada encontrado</b>Tente outro modelo ou outra cor.'
          : '<b>Nenhum veículo disponível na vitrine</b>Os carros do estoque marcados como disponíveis aparecem aqui — os mesmos que o cliente vê no site. Os 0 km da linha VW entram quando a versão está marcada "É de varejo", a cor está marcada pro catálogo do Facebook e tem foto cadastrada.')+'</div>';
      return;
    }
    el.innerHTML=lista.map(function(v){
      var modelo=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
      /* mesma miniatura deslizável do Estoque e das Avaliações */
      /* ⚠️ o `#vitLista` foi ACRESCENTADO à regra `:is(#estLista,…)` do
         styles.css — não bastava usar as mesmas classes do card. Sem isso a
         lista caía no desenho de LINHA (o do celular) mesmo no computador.
         Peguei isso no print, depois de já ter escrito no comentário que
         "herda a grade": herdava as classes, não a grade. */
      var foto=estThumbFotos(v.fotos||[], modelo);
      var dados=[];
      var ano=v.ano_modelo||v.ano||'';
      if(ano)   dados.push('<span>'+_ICO_CAL+esc(String(ano))+'</span>');
      if(v.km)  dados.push('<span>'+_EST_ICO_KM+Number(v.km).toLocaleString('pt-BR')+' km</span>');
      if(v.cor) dados.push('<span>'+_EST_ICO_COR+esc(v.cor)+'</span>');
      /* v1250 — as marcas do 0 km. "Pronta entrega" só quando existe unidade
         DAQUELA COR no pátio: a regra da v1235, que não muda de tela pra tela
         porque é a promessa mais cara que uma loja pode fazer. */
      var selos=[];
      if(v.zero_km) selos.push('<span class="vit-zk">0 KM</span>');
      if(v.zero_km && v.oportunidade) selos.push('<span class="vit-opo">Promoção</span>');
      if(v.zero_km && v.pronta) selos.push('<span class="vit-pe">Pronta entrega</span>');
      var deTxt='';
      if(Number(v.de)>0){ try{ deTxt='<span class="vit-de">de '+esc(brl(v.de))+(v.dePor?' por':'')+'</span>'; }catch(_){ deTxt=''; } }
      var descTxt=''; if(Number(v.desconto)>0){ try{ descTxt='<span class="vit-desc">economize '+esc(brl(v.desconto))+'</span>'; }catch(_){ descTxt=''; } }
      var diretaTxt='';
      if(Number(v.direta)>0){ try{
        diretaTxt='<div class="vit-direta"><b>Venda direta</b> CNPJ · produtor rural: '+esc(brl(v.direta))+
          (v.diretaRot?('<span>'+esc(v.diretaRot)+'</span>'):'')+'</div>';
      }catch(_){ diretaTxt=''; } }
      return '<div class="est-card est-vv-card vit-card'+(v.zero_km?' vit-zkcard':'')+(v.oportunidade?' vit-opocard':'')+'" data-vit="'+esc(v.id||'')+'">'+foto+
        '<div class="est-tx"><div class="est-nm">'+esc(modelo)+'</div>'+
        (selos.length?('<div class="vit-selos">'+selos.join('')+'</div>'):'')+
        (dados.length?('<div class="est-card-dados">'+dados.join('')+'</div>'):'')+
        '<div class="est-row">'+deTxt+'<span class="est-preco">'+esc(_vitPreco(v))+'</span>'+descTxt+'</div>'+
        diretaTxt+
        '</div></div>';
    }).join('');
    /* v452: a tira de fotos só desliza depois de ligada — é a MESMA função do
       Estoque, não uma cópia. */
    try{ if(typeof estStripsWire==='function') estStripsWire(el); }catch(_){}
  }

  /* a linha de cima: quantos carros, e o botão de abrir a página de verdade */
  function _vitResumoPinta(mostrando){
    var el=$('vitTopo'); if(!el) return;
    var total=_vitDisponiveis().length;
    var txt = total
      ? (mostrando!=null && mostrando!==total
          ? (mostrando+' de '+total+' na vitrine')
          : (total+(total===1?' veículo na vitrine':' veículos na vitrine')))
      : '';
    el.innerHTML = txt ? ('<span class="vit-conta">'+esc(txt)+'</span>') : '';
  }

  async function telaVitrine(){
    mevTabSet('');
    var cab=panelHead(_VIT_ICO,'blue','Vitrine','Os veículos disponíveis, como o cliente vê');
    irTela(cab+
      '<div class="vit-topo-linha">'+
        '<div class="hh-search vit-busca"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>'+
        '<input id="vitBusca" class="hh-busca" placeholder="Buscar modelo ou cor" autocomplete="off"></div>'+
        '<button type="button" class="vit-abrir" id="vitAbrir">Abrir a página do cliente</button>'+
      '</div>'+
      '<div id="vitTopo" class="vit-topo"></div>'+
      '<div id="vitLista"></div>','home');
    document.body.classList.remove('md-veiculo');
    try{ var _th=document.querySelector('#secoes .tela-head'); if(_th) _th.parentNode.removeChild(_th); }catch(_){}

    var b=$('vitBusca'); if(b) b.oninput=function(){ _vitBusca=this.value; vitPinta(); };
    /* 🔴 o botão abre a MESMA página que o cliente recebe pelo WhatsApp —
       reaproveita o `homeCatalogoAbrir` do 14 (visor embutido, com o botão de
       voltar pro app). Nada de um segundo jeito de abrir o catálogo. */
    var ab=$('vitAbrir');
    if(ab) ab.onclick=function(){
      if(typeof homeCatalogoAbrir==='function'){ homeCatalogoAbrir(); return; }
      var u=vitUrlPublica(); if(u) window.open(u,'_blank','noopener');
    };

    var el=$('vitLista'); if(el) el.innerHTML=pgLoad('Abrindo a vitrine…');
    /* ⚠️ a loja precisa estar carregada pra saber de QUEM é o catálogo — é o
       mesmo tropeço que derrubou a coluna do atendente na v530: quem abre o
       app e vem direto pra cá chega com o `_lojaRec` vazio. */
    try{ if(!(typeof _lojaRec!=='undefined' && _lojaRec && _lojaRec.id) && typeof lojaGet==='function') await lojaGet(); }catch(_){}
    await vitCarregar(true);
    vitPinta();
  }

/* ╔═══ src/app/14i-negociando.js ═════════════════════════════════════════ */
  /* ==========================================================================
     14i — NEGOCIANDO (REPASSE): O SINCRONISMO COM O PORTAL E A LISTA
     PROJETO-2026-08-30-a-divida-do-14-estoque · FASE 5, primeiro corte
     --------------------------------------------------------------------------
     Este arquivo NASCEU DE UM RECORTE do 14-estoque.js. Nenhuma linha de
     lógica mudou: é o mesmo código, no mesmo IIFE, na mesma ordem relativa —
     só num arquivo onde dá pra achar. O 14-estoque tinha 230 KB e treze
     assuntos; a regra da leitura barata (v729) manda separar antes de crescer.

     O QUE MORA AQUI:
       · o sincronismo com o Portal do Repasse (v183/v260): as MINHAS placas
         publicadas, as fotos emprestadas pro cadastro sem foto, e as três
         funções que mexem no anúncio (tirar do ar, marcar vendido);
       · a lista "Negociando (repasse)" (v260): os carros anunciados no Portal
         que ainda não viraram cadastro de estoque — com card, ordem (v627),
         filtro de situação e o menu de ações (v264).

     O QUE FICOU NO 14-estoque, de propósito, porque a LISTA do estoque usa
     direto: estRepNegociando, estRepSituacao, estRepDe, estEhRepasse,
     estRepBadge, estPrecoRepasse e o _estPl.

     ⚠️ POR QUE O NOME É "14i" E NÃO OUTRO: o montador cola na ordem do NOME.
     14i entra depois do 14h e antes do 14j. Como tudo vive no mesmo IIFE e
     funções são hoisted, a ordem não muda quem enxerga quem — mas as VARIÁVEIS
     daqui (_estRepPlacas, _estRepLinhas) passam a ser inicializadas depois do
     14-estoque. Isso é seguro porque ninguém as lê no topo: só dentro de
     função, e toda função só roda depois que o 19 (o init) fecha a casa.
     ========================================================================== */
  /* ---- v183: O CARRO QUE VEIO/FOI PRO PORTAL DO REPASSE ---------------------
     O Portal do Repasse guarda os anuncios numa tabela propria (repasse), com
     PLACA e FOTOS. O estoque nao sabia disso: um carro que entrou pela
     avaliacao (troca) ficava sem foto no cadastro e sem nenhuma marca dizendo
     que ele estava no repasse. Aqui eu carrego, de uma vez so, as MINHAS
     placas publicadas — e uso isso pra (a) marcar o card e (b) emprestar as
     fotos do anuncio pro cadastro que estiver sem foto. ---- */
  var _estRepPlacas={};
  /* v260: as linhas inteiras do Portal (não só o resumo por placa). Servem
     para o filtro "Negociando (repasse)" — carros que estão anunciados mas
     ainda não viraram veículo de estoque. */
  var _estRepLinhas=[];
  var ICO_REPMINI='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';

  async function estRepasseCarregar(){
    if(!meuId) return;
    try{
      /* 🔴 v780 — O SELECT DEIXOU DE SER '*'.
         Medido no Postgres de produção em 30/08: o JSON completo desta
         consulta são 79.887 bytes; com estas 12 colunas, 44.783. São 34 KB
         a MENOS por abertura da tela Estoque, por usuário — e a tela abre
         várias vezes por dia, em toda a base. A cota já estourou uma vez
         (28/08), então isto é dinheiro, não estética.
         SÃO EXATAMENTE AS QUE O CÓDIGO LÊ: as três que este mapa guarda
         (ativo, fotos, preco), as que a lista "Negociando" pinta (placa,
         veiculo, criado_em, id) e as que os updates daqui gravam de volta
         na linha em memória (vendido, vendido_em, situacao, atualizado_em).
         Conferido também o que sai daqui pra FORA do módulo: repEditarAval
         usa placa+veiculo e repVeiculoCompartilhar usa id+placa (09) —
         tudo na lista.
         FICAM DE FORA, porque a tela do estoque não usa: loja_nome,
         loja_whatsapp, cidade, uf, obs, capa_borrada.
         🔴 `criado_em` É OBRIGATÓRIO. A ordenação da aba "Negociando" lê
         `(r.criado_em || r.created_at)` — e `created_am` nunca existiu nesta
         tabela (conferido no banco): é um plano B morto. Sem criado_em na
         lista, TODOS os carros passariam a ter a mesma data e a ordem da
         v627 viraria ordem nenhuma, em silêncio. */
      var r=await withTimeout(supa.from('repasse').select(
            'id,user_id,placa,ativo,vendido,vendido_em,situacao,'+
            'fotos,preco,veiculo,criado_em,atualizado_em'
          ).eq('user_id',meuId),8000);
      var linhas=((r&&r.data)||[]);
      var m={};
      linhas.forEach(function(x){
        var p=_estPl(x.placa); if(!p) return;
        if(m[p]&&m[p].ativo&&!x.ativo) return;
        m[p]={ ativo:!!x.ativo, fotos:(x.fotos||[]), preco:(+x.preco||0) };
      });
      _estRepPlacas=m;
      _estRepLinhas=linhas;
    }catch(_){ }
  }
  /* ===== v333 — EXCLUIR DO ESTOQUE TIRA O ANÚNCIO DO REPASSE JUNTO ==========
     Bug relatado em 07/08: o Angelo excluía o carro do Estoque e ele CONTINUAVA
     aparecendo na página de Parceiros. Não era cache: são DUAS tabelas
     diferentes — `estoque` (o cadastro da loja, que alimenta o catálogo) e
     `repasse` (o anúncio que a rede inteira enxerga). Apagar uma nunca mexeu na
     outra, então o anúncio ficava órfão, no ar, sem carro por trás.

     Aqui eu só DESLIGO o anúncio (ativo=false) em vez de apagar a linha: é
     exatamente o que Parceiros e Portal usam pra filtrar, some na hora, e se
     tiver sido engano o histórico do anúncio (fotos, preço, ofertas) continua
     lá pra reativar. Casamento pela PLACA normalizada + user_id — o repasse não
     guarda o id do estoque, e a placa é o que os dois lados têm em comum.
     Devolve quantos anúncios saíram do ar (0 = não tinha nenhum). */
  async function estRepasseTirarDoAr(placa){
    var p=_estPl(placa); if(!p || !meuId) return 0;
    try{
      var r=await withTimeout(supa.from('repasse').select('id,placa').eq('user_id',meuId).eq('ativo',true),8000);
      var ids=(((r&&r.data)||[]).filter(function(x){ return _estPl(x.placa)===p; })).map(function(x){ return x.id; });
      if(!ids.length) return 0;
      var u=await supa.from('repasse').update({ ativo:false, atualizado_em:new Date().toISOString() }).in('id',ids).select('id');
      estConfereGravou(u,'estRepasseTirarDoAr',ids.length);   /* v782 */
      (_estRepLinhas||[]).forEach(function(x){ if(ids.indexOf(x.id)>=0) x.ativo=false; });
      if(_estRepPlacas&&_estRepPlacas[p]) _estRepPlacas[p].ativo=false;
      return ids.length;
    }catch(e){ try{ window.mevErro&&window.mevErro(e,'estRepasseTirarDoAr'); }catch(_){} return 0; }
  }
  /* v334 — MARCAR VENDIDO NO ESTOQUE MARCA VENDIDO NO REPASSE TAMBÉM.
     Mesma lógica do irmão acima, só que aqui o anúncio não some por engano
     de digitação: ele fica com a MARCA de vendido (o mesmo desenho que a aba
     "Negociando (repasse)" já usava), sai do ar e o portal para de oferecer.
     Se o Angelo desmarcar o vendido, o anúncio NÃO volta sozinho — voltar pro
     ar é decisão dele, na aba do portal. */
  async function estRepasseMarcarVendido(placa){
    var p=_estPl(placa); if(!p || !meuId) return 0;
    try{
      var r=await withTimeout(supa.from('repasse').select('id,placa,vendido,ativo').eq('user_id',meuId),8000);
      var alvos=(((r&&r.data)||[]).filter(function(x){ return _estPl(x.placa)===p && (x.ativo===true || x.vendido!==true); }));
      var ids=alvos.map(function(x){ return x.id; });
      if(!ids.length) return 0;
      var agora=new Date().toISOString();
      var novo={ vendido:true, vendido_em:agora, ativo:false, situacao:'vendido', atualizado_em:agora };
      var u=await supa.from('repasse').update(novo).in('id',ids).select('id');
      estConfereGravou(u,'estRepasseMarcarVendido',ids.length);   /* v782 */
      (_estRepLinhas||[]).forEach(function(x){ if(ids.indexOf(x.id)>=0){ Object.keys(novo).forEach(function(k){ x[k]=novo[k]; }); } });
      if(_estRepPlacas&&_estRepPlacas[p]) _estRepPlacas[p].ativo=false;
      return ids.length;
    }catch(e){ try{ window.mevErro&&window.mevErro(e,'estRepasseMarcarVendido'); }catch(_){} return 0; }
  }

  /* ================= v260 · NEGOCIANDO (REPASSE) =================
     Carros anunciados no Portal do Repasse que ainda não entraram no estoque.
     Eles não são cadastro de veículo, então têm lista e ações próprias:
     reservar (continua no ar, com selo), marcar vendido e excluir. */
  var _EST_NEG_SIT={
    disponivel:{t:'No portal', c:'#16a34a', bg:'#f0fdf4', bd:'#bbf7d0'},
    reservado :{t:'Reservado', c:'#b45309', bg:'#fffbeb', bd:'#fde68a'},
    vendido   :{t:'Vendido',   c:'#64748b', bg:'#f1f5f9', bd:'#e2e8f0'}
  };
  function _estNegNome(r){
    var v=(r&&r.veiculo)||{};
    var n=((v.marca||'')+' '+(v.modelo||v.versao||'')).trim();
    return n || String(v.titulo||'').trim() || 'Veículo do repasse';
  }
  function _estNegFotos(r){
    var f=(r&&r.fotos)||[];
    if(!Array.isArray(f)) f=[];
    return f.filter(function(x){ return typeof x==='string' && x; });
  }
  /* ==========================================================================
     v627 — ORDENAR E FILTRAR NO REPASSE
     ==========================================================================
     Pedido do Angelo (24/08, com print da página Repasse): "adicione um
     ordenar e um filtrar e deixe por padrao do mais recente pro mais antigo".

     🔴 E O PADRÃO CONSERTA UM DEFEITO QUE NINGUÉM TINHA NOMEADO: até aqui a
     lista NÃO ERA ORDENADA. Ela saía na ordem em que o banco devolvesse —
     que é ordem nenhuma, e muda sem aviso. Agora sai do mais recente pro
     mais antigo, que é o certo pra esta tela: o que entrou por último no
     portal é o que ainda está quente.

     ⚠️ ESTE PINTOR É COMPARTILHADO — ele serve a página Repasse E o bloco
     "negociando" da página Estoque. A decisão: a ORDEM PADRÃO passa a valer
     nos DOIS (o Estoque tinha o mesmo defeito); a FOLHA de filtros aparece
     só no Repasse, que é onde foi pedida. Por isso o terceiro argumento é
     OPCIONAL: sem ele, ordem padrão e sem filtro — o Estoque continua igual,
     só que agora ordenado.
     🔴 E por isso NÃO foi criado um segundo pintor só pro Repasse: a página
     Repasse nasceu como "cópia exata da página Estoque" (v396/v400).
     Duplicar o pintor desfaria isso e criaria duas verdades. */
  var EST_NEG_ORDENS=[
    ['recente','Mais recente'], ['antigo','Mais antigo'],
    ['preco_desc','Maior preço'], ['preco_asc','Menor preço'], ['km_asc','Menor km']
  ];
  var EST_NEG_SITS=[['','Todas'],['disponivel','No portal'],['reservado','Reservado'],['vendido','Vendido']];
  function _estNegTs(r){
    var d=Date.parse(String((r&&(r.criado_em||r.created_at))||''));
    return isNaN(d)?null:d;
  }
  function _estNegPreco(r){ var n=Number((r&&r.preco)||0); return (isFinite(n)&&n>0)?n:null; }
  function _estNegKm(r){ var v=(r&&r.veiculo)||{}; var n=Number(v.km||0); return (isFinite(n)&&n>0)?n:null; }
  /* 🔴 A REGRA DO QUE FALTA: dado ausente vai pro FIM da lista, sempre — em
     qualquer ordenação. Registro velho sem data não pode virar "o mais
     recente", e carro sem preço não pode liderar a lista dos caros. */
  function estNegOrdenar(lista, ord){
    ord=String(ord||'recente');
    var chave = (ord==='preco_desc'||ord==='preco_asc') ? _estNegPreco
              : (ord==='km_asc') ? _estNegKm : _estNegTs;
    var desc = (ord==='recente'||ord==='preco_desc');
    return lista.slice().sort(function(a,b){
      var va=chave(a), vb=chave(b);
      if(va==null && vb==null) return 0;
      if(va==null) return 1;      /* o que falta vai pro fim */
      if(vb==null) return -1;
      return desc ? (vb-va) : (va-vb);
    });
  }
  function estPintaNegociando(el, termo, opts){
    opts=opts||{};
    var lista=estRepNegociando().filter(function(r){
      /* v627: o filtro de situação (só o Repasse manda opts.sit) */
      if(opts.sit && estRepSituacao(r)!==opts.sit) return false;
      if(!termo) return true;
      return String(r.placa||'').toLowerCase().indexOf(termo)>=0 || _estNegNome(r).toLowerCase().indexOf(termo)>=0;
    });
    lista=estNegOrdenar(lista, opts.ord||'recente');   /* v627: ordem, sempre */
    if(!lista.length){
      el.innerHTML='<div class="cli-empty"><b>Nada em negociação</b>'+
        'Aqui aparecem os veículos que você anunciou no Portal do Repasse e que ainda não viraram cadastro do estoque.</div>';
      return;
    }
    el.innerHTML='<div class="est-neg-nota">Anunciados no Portal do Repasse · ainda não entraram no estoque</div>'+
      lista.map(function(r){
        var sit=estRepSituacao(r), st=_EST_NEG_SIT[sit]||_EST_NEG_SIT.disponivel;
        var v=(r.veiculo)||{}, fotos=_estNegFotos(r);
        /* v400 (pedido): o card do portal usa a MESMA tira deslizável de fotos
           do estoque (antes era uma foto só com o contador parado). */
        var foto = estThumbFotos(fotos, _estNegNome(r));
        /* v401 (pedido): os MESMOS 3 ícones do card do estoque — livrinho
           (abre a página pública /r/ do anúncio), WhatsApp e compartilhar. */
        var _nm=esc(_estNegNome(r));
        var ics='<span class="est-ics">'+
          '<button type="button" class="est-ic est-ic-cat" data-negic="ver" title="Ver a página do anúncio" aria-label="Ver a página de '+_nm+'">'+ICO_CATALOGO+'</button>'+
          '<button type="button" class="est-ic est-ic-wa" data-negic="wa" title="Mandar no WhatsApp" aria-label="Mandar '+_nm+' no WhatsApp">'+_EST_SVG_WA+'</button>'+
          '<button type="button" class="est-ic est-ic-share" data-negic="share" title="Compartilhar" aria-label="Compartilhar '+_nm+'">'+_EST_SVG_SHARE+'</button>'+
          '</span>';
        foto = foto.replace('</div>', ics+'</div>');   /* os ícones moram DENTRO do quadro da foto */
        var dados=[];
        var ano=String(v.ano||v.ano_modelo||''); if(ano) dados.push('<span>'+_ICO_CAL+esc(ano)+'</span>');
        var km=Number(v.km||0); if(km) dados.push('<span>'+_EST_ICO_KM+km.toLocaleString('pt-BR')+' km</span>');
        if(v.cor) dados.push('<span>'+_EST_ICO_COR+esc(v.cor)+'</span>');
        var noAr = (r.ativo===false)
          ? '<span class="est-rep off" title="Fora do ar no Portal">'+ICO_REPMINI+'Fora do ar</span>'
          : '<span class="est-rep" title="No ar no Portal do Repasse">'+ICO_REPMINI+'No portal</span>';
        return '<div class="est-card est-vv-card" data-rep-id="'+esc(r.id)+'">'+foto+
          '<div class="est-tx"><div class="est-nm">'+esc(_estNegNome(r))+'</div>'+
          '<div class="est-card-placa">'+esc(r.placa||'Sem placa')+'</div>'+
          (dados.length?('<div class="est-card-dados">'+dados.join('')+'</div>'):'')+
          (opts.portal?'<div class="rep-preco-titulo">Preço de repasse</div>':'')+
          '<div class="est-row"><span class="est-preco">'+esc(estMoney(r.preco)||'—')+'</span>'+
          '<span class="est-badge" style="color:'+st.c+';background:'+st.bg+';border-color:'+st.bd+'">'+st.t+'</span></div>'+
          (opts.portal?((Number(v.fipe)>0?'<div class="rep-fipe">FIPE '+_repDinheiro(v.fipe)+'</div>':'')+_repComparativo(r)):'')+
          '<div class="est-meta">'+noAr+'</div></div>'+
          '<div class="cli-chev">'+_icoChev+'</div></div>';
      }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card[data-rep-id]'),function(card){
      var id=card.getAttribute('data-rep-id');
      card.onclick=function(){ estNegAcoesAbrir(id, card); };
    });
    /* v401: os 3 ícones do card do portal (o stopPropagation impede o menu
       de ações de abrir junto — mesmo cuidado do estIconesWire) */
    Array.prototype.forEach.call(el.querySelectorAll('[data-negic]'),function(b){
      b.onclick=function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var card=b.closest('.est-card'); if(!card) return;
        var r=(_estRepLinhas||[]).filter(function(x){ return String(x.id)===String(card.getAttribute('data-rep-id')); })[0];
        if(!r) return;
        var k=b.getAttribute('data-negic');
        var url=MEV_SITE+'/r/'+encodeURIComponent(String(r.id));
        if(k==='ver'){ _preAquece(url); try{ _publicoAbrir(url,{titulo:'Anúncio no repasse',voltar:'Voltar ao app',dono:true}); }catch(_){ try{ window.open(url,'_blank'); }catch(__){} } return; }
        if(k==='wa'){ var txt=_estNegNome(r)+(r.placa?(' ('+r.placa+')'):'')+' — repasse, faça sua oferta:\n'+url; mevIrProWhats('https://wa.me/?text='+encodeURIComponent(txt)); return; }
        repVeiculoCompartilhar(r, _estNegNome(r));
      };
    });
    estStripsWire(el);   /* v396: foto reserva se a reduzida falhar */
  }
  function estNegAcoesAbrir(id, anchorEl){
    var r=(_estRepLinhas||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!r) return;
    var sit=estRepSituacao(r);
    var IC={
      res :'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4z"/></svg>',
      sold:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
      av  :'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
      del :'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>'
      ,
      /* v264: as duas que faltavam aqui */
      edit:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
      share:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>'
    };
    /* ===== v264 (pedido): MESMA LISTA DE AÇÕES DOS DISPONÍVEIS =====
       Aqui no portal só dava pra mudar o selo e excluir. Faltavam justamente
       as duas mais usadas: EDITAR — que abre a avaliação do próprio carro, com
       tudo o que você já tinha preenchido — e COMPARTILHAR. E elas valem em
       QUALQUER situação: reservado e vendido também se edita e se compartilha. */
    var itens=[['editar',IC.edit,'Editar na avaliação','']];
    itens.push(['share',IC.share,'Compartilhar','']);
    if(sit!=='reservado') itens.push(['reservado',IC.res,'Marcar reservado','']);
    if(sit!=='vendido')   itens.push(['vendido',  IC.sold,'Marcar vendido','']);
    if(sit!=='disponivel')itens.push(['disponivel',IC.av,'Voltar pra disponível','']);
    itens.push(['excluir',IC.del,'Excluir do portal','danger']);
    var head='<div class="act-head"><div class="ah-nm">'+esc(_estNegNome(r))+'</div><div class="ah-pl">'+esc(r.placa||'')+'</div></div>';
    _popAbrir(head, itens, anchorEl, function(k){ estNegAcaoExec(id, k); });
  }
  async function estNegAcaoExec(id, key){
    var r=(_estRepLinhas||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!r) return;
    actSheetFechar();
    var agora=new Date().toISOString();

    /* v264: editar e compartilhar reaproveitam o que o portal já sabia fazer —
       repEditarAval abre a avaliação com tudo preenchido (histórico da placa,
       ou remontando pelo próprio anúncio) e repVeiculoCompartilhar manda o
       mesmo link /r/<id> que qualquer lojista abre no navegador. */
    if(key==='editar'){ try{ repEditarAval(r); }catch(_){ toast('Não consegui abrir a avaliação.'); } return; }
    if(key==='share'){ try{ repVeiculoCompartilhar(r, _estNegNome(r)); }catch(_){ toast('Não consegui compartilhar.'); } return; }

    if(key==='excluir'){
      if(!confirm('Excluir "'+_estNegNome(r)+'" do Portal do Repasse?\n\nO anúncio sai do ar para todos os lojistas.')) return;
      try{
        var d=await supa.from('repasse').delete().eq('id',r.id).select('id');
        estConfereGravou(d,'estNegAcaoExec (excluir do portal)',1);   /* v782 */
        _estRepLinhas=(_estRepLinhas||[]).filter(function(x){ return String(x.id)!==String(id); });
        toast('Excluído do portal.');
      }catch(e){ toast('Não consegui excluir. '+((e&&e.message)||'')); }
      estPinta((($('estBusca')||{}).value)||'');
      try{ repMeuPinta(); }catch(_){}   /* v396: a página Repasse também repinta */
      return;
    }

    if(key!=='reservado' && key!=='vendido' && key!=='disponivel') return;
    /* Reservado continua NO AR, só com o selo — foi o combinado.
       Vendido sai do ar, que é o comportamento que o portal já tinha. */
    var novo={ situacao:key, atualizado_em:agora };
    if(key==='vendido'){ novo.vendido=true;  novo.vendido_em=agora; novo.ativo=false; }
    else               { novo.vendido=false; novo.vendido_em=null;  novo.ativo=true;  }
    try{
      var u=await supa.from('repasse').update(novo).eq('id',r.id).select('id');
      estConfereGravou(u,'estNegAcaoExec',1);   /* v782 */
      Object.keys(novo).forEach(function(k){ r[k]=novo[k]; });
      toast(key==='vendido'?'Marcado como vendido.':(key==='reservado'?'Reservado — segue no portal com o selo.':'De volta como disponível.'));
    }catch(e){ toast('Não consegui atualizar. '+((e&&e.message)||'')); }
    estPinta((($('estBusca')||{}).value)||'');
    try{ repMeuPinta(); }catch(_){}   /* v396: a página Repasse também repinta */
  }

/* ╔═══ src/app/14j-marketing-veiculo.js ══════════════════════════════════ */
  /* ==========================================================================
     14j — MARKETING DO VEÍCULO: OS POSTS, O ANÚNCIO E O CARD
     PROJETO-2026-08-30-a-divida-do-14-estoque · FASE 5, segundo corte
     --------------------------------------------------------------------------
     Este arquivo NASCEU DE UM RECORTE do 14-estoque.js. Nenhuma linha de
     lógica mudou: é o mesmo código, no mesmo IIFE, na mesma ordem relativa.

     O QUE MORA AQUI:
       · o post automático montado com os campos confirmados do estoque;
       · abrir no Instagram e no Marketplace;
       · a fiação do bloco de Facebook Ads (_mktFbWire — o desenho e o texto
         do anúncio moram no 14d-facebook-ads.js desde a v323);
       · o card de venda em canvas (mevCardCanvas) e o compartilhar dele.

     ⚠️ POR QUE ESTE CORTE VEIO DEPOIS DA v779, E NÃO ANTES: até a v779 este
     bloco carregava QUATRO funções de Facebook Ads que eram código morto
     (declaradas de novo, e maiores, no 14d). Cortar antes teria levado o
     código morto junto pra casa nova — e o mapa continuaria mentindo.

     O QUE FICOU NO 14-estoque, de propósito, porque MAIS GENTE usa:
       _MK_SVG e mkIco (dez módulos chamam o mkIco), _POST_MAP e _POST_DE (o
       15-marketing.js usa os dois) e o _mktDireto (a ficha liga ele).

     ⚠️ A ORDEM DO MONTADOR: 14j entra depois do 14i e antes do 15. O `_mktV`
     que este arquivo usa é declarado no 15-marketing.js — e isso já era
     assim antes do corte: como tudo vive no mesmo IIFE e ninguém lê o _mktV
     no topo do arquivo, a ordem não muda nada.
     ========================================================================== */
  /* Os dois textos são parte de uma única geração. Ficam salvos separados,
     mas o lojista não precisa repetir a mesma ação para cada canal. */
  var _postIaFicha=null;   /* {id, post, em, marketplace, marketplace_em} */
  function _mktPostBoxHtml(post, quando, formato, prefixo){
    if(!post) return '';
    var marketplace=formato==='marketplace', pre=prefixo||(marketplace?'mkMarket':'mkSocial');
    var titulo=marketplace?'Anúncio para marketplace · até 1.000 caracteres':'Post para redes sociais';
    return '<article class="post-box'+(marketplace?' marketplace':'')+'">'+
      '<div class="post-kind">'+mkIco(marketplace?'marketplace':'post',14)+'<span>'+titulo+'</span>'+(marketplace?'<b>'+String(post.length)+'/1000</b>':'')+'</div>'+
      '<div class="post-txt" id="'+pre+'Txt">'+esc(post)+'</div>'+
      (quando?('<div class="post-salvo">'+mkIco('ok',13)+'<span>'+esc(quando)+'</span></div>'):'')+
      '<div class="post-acts so-ico">'+
        '<button type="button" class="b1" id="'+pre+'Copy" title="Copiar texto" aria-label="Copiar texto">'+mkIco('copiar',19)+'</button>'+
        (marketplace?
          '<button type="button" class="b2" id="'+pre+'Abrir" title="Copiar e abrir Marketplace" aria-label="Copiar texto e abrir Marketplace">'+mkIco('marketplace',19)+'</button>':
          '<button type="button" class="b4" id="'+pre+'Abrir" title="Copiar e abrir o Instagram" aria-label="Copiar texto e abrir o Instagram">'+mkIco('instagram',19)+'</button>')+
        '<button type="button" class="b3" id="'+pre+'Reg" title="Atualizar com os dados do estoque" aria-label="Atualizar com os dados do estoque">'+mkIco('atualizar',19)+'</button>'+
      '</div>'+(marketplace?'<div class="post-market-help">O texto é copiado e o Marketplace é aberto para você revisar e publicar.</div>':'')+
    '</article>';
  }
  function _mktPostsHtml(social, socialQuando, marketplace, marketplaceQuando, v){
    /* v313 (pedido): "gere um unico post — redes sociais". A geracao e o
       salvamento do texto de marketplace continuam identicos (nada se perde);
       ele so' deixou de ocupar a tela. Pra reexibir, devolva a segunda linha. */
    return '<div class="mkt-post-results">'+
      _mktPostBoxHtml(social,socialQuando,'rede_social','mkSocial')+
    '</div>';
  }
  /* ===== ANÚNCIO PARA FACEBOOK ADS (pedido do Angelo) ==========================
     Facebook Ads (Gerenciador de Anúncios) é o anúncio PAGO. Diferente do
     Marketplace (grátis e sem link), aqui o que fecha o funil é o LINK do carro
     no destino: o cliente clica no anúncio, cai na página do veículo e toca no
     WhatsApp — e a conversa aparece no chat, porque o número da loja é o mesmo
     conectado na Z-API.
     Não gera texto novo nem gasta token: reaproveita o texto de marketplace que
     a IA já escreve e salva (mesmo tendo saído da tela na v313) — ou, na falta
     dele, o post de redes sociais — e monta um título fixo a partir da ficha.
     Sem veículo salvo (sem id) não há link, e o bloco avisa pra salvar. ======== */
  /* 🔴 v779 — AS QUATRO FUNÇÕES DO FACEBOOK ADS SAÍRAM DAQUI.
     _mktFbTitulo · _mktFbCampo · _mktFacebookAdsHtml · _mktFacebookAdsAbrir
     eram declaradas AQUI e DE NOVO no 14d-facebook-ads.js, com conteúdo
     diferente e maior. Como tudo vive no mesmo IIFE e o 14d vem depois na
     ordem do montador, quem rodava era SEMPRE a do 14d — as daqui eram
     código morto desde a v323 (confirmado com o acorn sobre o app.js
     montado, não com busca por texto).
     Isso não quebrava nada HOJE. O perigo era amanhã: o MAPA-GERADO.md
     apontava as quatro para ESTE arquivo. Uma sessão procuraria a função
     pelo mapa (que é o procedimento certo, escrito no CLAUDE.md), abriria
     o arquivo que o mapa indicou, editaria as linhas certas, montaria,
     publicaria — e não veria mudança nenhuma na tela. Uma tarde inteira
     de caça a fantasma.
     👉 Elas moram no 14d-facebook-ads.js. É lá que se edita.
     ⚠️ O _mktFbWire abaixo FICA: é o único dos cinco que só existia aqui,
     e na prática já chamava as do 14d — o comportamento não muda. */
  function _mktFbWire(v, descricao){
    if(!v) return;
    var link=_publicoVeiculoUrl(v);
    var titulo=_mktFbTitulo(v);
    var t=$('fbTitCopy'); if(t) t.onclick=function(){ _mktCopiar(titulo,'Título copiado.'); };
    var x=$('fbTxtCopy'); if(x&&descricao) x.onclick=function(){ _mktCopiar(descricao,'Texto copiado.'); };
    var l=$('fbLinkCopy'); if(l&&link) l.onclick=function(){ _mktCopiar(link,'Link copiado.'); };
    var tudo=$('fbCopiarTudo'); if(tudo) tudo.onclick=function(){ _mktCopiar((descricao?(descricao+'\n\n'):'')+link,'Texto e link copiados.'); };
    var ab=$('fbAbrir'); if(ab) ab.onclick=function(){ _mktFacebookAdsAbrir(descricao,link); };
  }
  function _mktInstagramNormalizar(raw){
    return String(raw||'').replace(/^https?:\/\/(www\.)?instagram\.com\//i,'').replace(/^@/,'').split(/[/?#]/)[0].replace(/[^A-Za-z0-9._]/g,'');
  }
  function _mktInstagramUsuario(){
    return _mktInstagramNormalizar((_lojaRec&&(_lojaRec.instagram||_lojaRec.insta_user))||'');
  }
  function _mktInstagramVendedor(){ return _mktInstagramNormalizar((meuMeta&&meuMeta.instagram)||''); }
  async function _mktCopiar(post, msg){
    try{ if(navigator.clipboard&&navigator.clipboard.writeText){ await navigator.clipboard.writeText(post); if(msg) toast(msg); return true; } }catch(_){}
    try{
      var ta=document.createElement('textarea'); ta.value=post; ta.style.position='fixed'; ta.style.opacity='0';
      document.body.appendChild(ta); ta.select(); var copiou=document.execCommand('copy'); ta.remove();
      if(copiou&&msg) toast(msg); return !!copiou;
    }catch(_){ try{ prompt('Copie:',post); }catch(__){} return false; }
  }
  async function _mktInstagramAbrir(post){
    await _mktCopiar(post);
    var usuario=_mktInstagramUsuario();
    var mobile=/Android|iPhone|iPad|iPod/i.test(navigator.userAgent||'');
    var web='https://www.instagram.com/create/style/';
    if(mobile){
      try{ location.href='instagram://camera'; }catch(_){}
      setTimeout(function(){ if(document.visibilityState==='visible') window.open(web,'_blank','noopener'); },900);
    }else{
      window.open(web,'_blank','noopener');
    }
    toast('Post copiado'+(usuario?' para publicar em @'+usuario:'')+'. Cole a legenda no Instagram.');
  }
  async function _mktMarketplaceAbrir(post){
    await _mktCopiar(post);
    try{ window.open('https://www.facebook.com/marketplace/create/item','_blank','noopener'); }
    catch(_){ location.href='https://www.facebook.com/marketplace/create/item'; }
    toast('Anúncio copiado. Cole no Marketplace que abriu para revisar e publicar.');
  }
  function _mktPostWire(social, marketplace){
    function ligar(pre, post, formato){
      if(!post) return;
      var c=$(pre+'Copy'); if(c) c.onclick=function(){ _mktCopiar(post,'Texto copiado.'); };
      var ab=$(pre+'Abrir'); if(ab) ab.onclick=function(){ if(formato==='marketplace') _mktMarketplaceAbrir(post); else _mktInstagramAbrir(post); };
      var r=$(pre+'Reg'); if(r) r.onclick=function(){ mktGerarTextos(); };
    }
    ligar('mkSocial',social,'rede_social'); ligar('mkMarket',marketplace,'marketplace');
  }
  function _mktPostQuando(iso){
    try{ var d=new Date(iso); if(isNaN(d.getTime())) return 'Post salvo';
      return 'Post salvo em '+d.toLocaleDateString('pt-BR')+' \u00e0s '+('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2);
    }catch(_){ return 'Post salvo'; }
  }
  function _mktPostPartes(txt){
    return String(txt||'').split(/[,;\n\r|\u00b7]+/).map(function(x){ return String(x||'').trim().replace(/[.;,]+$/,''); }).filter(Boolean);
  }
  function _mktPostHashtags(txt){
    var vistos={};
    return String(txt||'').split(/[\s,;]+/).map(function(x){
      x=String(x||'').trim(); if(!x) return '';
      if(x.charAt(0)!=='#') x='#'+x;
      x='#'+x.slice(1).replace(/[^A-Za-z0-9_\u00c0-\u017f]/g,'');
      var k=x.toLowerCase(); if(x==='#'||vistos[k]) return ''; vistos[k]=1; return x;
    }).filter(Boolean).join(' ');
  }
  function _mktPostAutomatico(v){
    v=v||{}; var ex=v.extras||{}, linhas=[], vistos={};
    function unico(t){ var k=_mkNorm(t); if(!k||vistos[k]) return false; vistos[k]=1; return true; }
    var marca=String(v.marca||'').trim(), modelo=String(v.modelo||'').trim();
    var nome=(marca+' '+modelo).replace(/\s+/g,' ').trim();
    if(marca&&modelo.toLowerCase().indexOf(marca.toLowerCase())===0) nome=modelo;
    var ano=(typeof _efAnoTxt==='function')?_efAnoTxt(v):String(v.ano_modelo||v.ano||'').trim();
    if(!nome&&!ano) return '';
    linhas.push([nome,ano].filter(Boolean).join(' '));
    var km=_mktKmPost(v,_mktIncluirKm(v)); if(km) linhas.push('\u27a1\ufe0f '+km+' km');
    try{ _EX_DIF.forEach(function(d){ if(ex[d.k]&&unico(d.t)) linhas.push('\u27a1\ufe0f '+d.t); }); }catch(_){}
    var opcionais=_mktPostPartes(ex.opcionais);
    try{ opcionais=opcionais.concat(_mktItensConfirmadosDaFicha(v)); }catch(_){}
    opcionais.slice(0,20).forEach(function(t){ if(unico(t)) linhas.push('\u2705 '+t); });
    var descricao=String(ex.destaques||'').trim();
    if(typeof obsPublica==='function') descricao=obsPublica(descricao);
    if(descricao) linhas.push('\ud83d\udc8e '+descricao);
    var preco=Number(v.preco_anuncio)||0;
    if(preco){
      var valor='R$ '+preco.toLocaleString('pt-BR',{maximumFractionDigits:0});
      linhas.push('\ud83d\udcb0 '+valor);
      var entrada=Math.round((preco*0.30)*100)/100;
      linhas.push('\ud83d\udcb3 Entrada a partir de R$ '+entrada.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}));
    }
    linhas.push('\ud83e\udd1d Avaliamos seu usado na troca!');
    /* Contato pessoal solicitado para a assinatura deste modelo de post.
       Não altera WhatsApp da loja, catálogo, leads ou demais telas. */
    linhas.push('\ud83d\udcf2 (51) 99641-7433');
    var vendedor=String(meuNome||'').trim(); if(vendedor) linhas.push('\ud83d\udc49 '+vendedor+' - Consultor VW');
    var instagram=_mktInstagramVendedor()||_mktInstagramUsuario(); if(instagram) linhas.push('\ud83d\udcf8 Siga @'+instagram);
    var hashtags=_mktPostHashtags(ex.post_hashtags); if(hashtags) linhas.push(hashtags);
    return linhas.filter(Boolean).join('\n').trim();
  }
  function _mktPostAutomaticoPinta(v){
    var out=$('mkOut'); if(!out||!v) return;
    var social=_mktPostAutomatico(v);
    if(!social){ out.innerHTML='<div class="cad-msg">Preencha a marca e o modelo para montar o post.</div>'; return; }
    out.innerHTML=_mktPostsHtml(social,'Montado automaticamente com os dados do estoque','','',v);
    _mktPostWire(social,''); _mktFbWire(v,social);
  }
  /* monta novamente o post sempre que a aba Marketing abre */
  function mktPostSalvoPinta(v){
    _mktPostAutomaticoPinta(v);
  }
  /* guarda o post no proprio veiculo: memoria + banco (coluna extras) */
  async function mktPostSalvar(v, post, formato){
    if(!v || !post) return;
    var ex=Object.assign({}, v.extras||{});
    var campo=formato==='marketplace'?'post_marketplace_ia':'post_ia';
    ex[campo]=post; ex[campo+'_em']=new Date().toISOString();
    v.extras=ex;
    var mem=(_postIaFicha&&String(_postIaFicha.id||'')===String(v.id||''))?_postIaFicha:{id:(v.id||'')};
    if(formato==='marketplace'){ mem.marketplace=post; mem.marketplace_em=ex[campo+'_em']; }
    else { mem.post=post; mem.em=ex[campo+'_em']; }
    _postIaFicha=mem;
    try{ for(var i=0;i<(_estoque||[]).length;i++){ if(String(_estoque[i].id)===String(v.id)){ _estoque[i].extras=ex; break; } } }catch(_){}
    if(!v.id) return;
    /* 🔴 v782 — ERA UM `catch(_){}` PURO EM CIMA DE UM UPDATE. O texto de
       marketing que a IA acabou de gerar (e que custou token) sumia sem aviso
       nenhum se a gravação falhasse. Em código de TELA o catch vazio é
       defensável — não vale derrubar a interface porque uma miniatura falhou.
       Em código que GRAVA, é onde o defeito se esconde. Agora o erro vai pro
       mp_erros, do mesmo jeito que as funções de repasse deste módulo já
       faziam desde a v333. */
    try{
      var _up=await supa.from('estoque').update({extras:ex}).eq('id', v.id).select('id');
      estConfereGravou(_up,'mktPostSalvar',1);
    }catch(e){ try{ window.mevErro && window.mevErro(e,'mktPostSalvar'); }catch(_){} }
  }
  async function _mktDadosParaGerar(v, extras){
    /* ===== v265 (VAZAMENTO) — O ANÚNCIO SAÍA COM SEGREDO DENTRO =====
       Dois problemas na mesma linha, os dois indo parar num texto feito pra
       publicar no Instagram e nos marketplaces:

       1. `v.obs` é a ANOTAÇÃO INTERNA do estoque ("recebido na troca do
          Fulano", "lataria R$ 900"). O próprio catálogo já a tinha tirado do
          ar por isso — mas ela continuava sendo entregue à IA que escreve o
          anúncio. Pior: o texto da avaliação desce pra cá pelo espelho, então
          um custo digitado lá podia terminar no post. Agora usamos o campo de
          marketing de verdade (extras.destaques), que existe justamente pra
          ser publicado.

       2. Quando o "Preço anúncio" estava vazio, o código caía no PREÇO MÍNIMO
          — o piso da negociação virando manchete do anúncio. Agora, sem preço
          de anúncio, o texto simplesmente sai sem preço. */
    var obs=String((v.extras&&v.extras.destaques)||'').trim();
    if(typeof extras==='string' && extras){ obs=(obs?(obs+'. '):'')+extras; }
    obs=(typeof obsPublica==='function')?obsPublica(obs):obs;
    var anuncioNum=Number(v.preco_anuncio)||0;
    var incluirKm=_mktIncluirKm(v);
    var veic={ marca:String(v.marca||'').trim(), modelo:String(v.modelo||'').trim(), ano:String(v.ano||''), ano_modelo:String(v.ano_modelo||''), cor:String(v.cor||''), km:_mktKmPost(v,incluirKm), preco:anuncioNum?('R$ '+anuncioNum.toLocaleString('pt-BR')):'', itens_confirmados:_mktItensConfirmadosDaFicha(v), obs:obs };
    var valorVenda=veic.preco;
    var entradaNum=_round900(anuncioNum*0.30);
    var entrada=entradaNum?('R$ '+entradaNum.toLocaleString('pt-BR')):'';
    var vend={nome:(meuNome||''),fone:((meuMeta&&meuMeta.telefone)||''),instagram:_mktInstagramVendedor()};
    try{ var u=await supa.auth.getUser(); var md=(u&&u.data&&u.data.user&&u.data.user.user_metadata)||{}; vend.nome=md.nome||vend.nome||''; vend.fone=md.telefone||vend.fone||''; vend.instagram=_mktInstagramNormalizar(md.instagram||vend.instagram||''); }catch(_){}
    if(!vend.fone && _lojaRec) vend.fone=_lojaRec.whatsapp||_lojaRec.telefone||'';
    var lojaNome=(_lojaRec&&(_lojaRec.nome_fantasia||_lojaRec.razao_social))||'';
    return {veic:veic,valorVenda:valorVenda,entrada:entrada,vend:vend,lojaNome:lojaNome};
  }
  /* ==========================================================================
     🔴 v923 (pedido do Angelo, 06/09) — A ANIMAÇÃO COMEÇA NO DEDO
     --------------------------------------------------------------------------
     "na aba marketing dentro das avaliações, adicione uma animação ao gerar
     post com IA."

     A animação JÁ EXISTIA desde a v353 (o anel com o megafone e as frases que
     trocam). O que não existia era ela aparecer NA HORA. Repare na ordem de
     antes:

         var dados = await _mktDadosParaGerar(v, extras);   ← ida ao servidor
         ...
         out.innerHTML = mkLoaderHtml(...);                 ← só agora anima

     O `_mktDadosParaGerar` faz um `supa.auth.getUser()` — uma volta na rede.
     Numa conexão de loja, isso é UM A TRÊS SEGUNDOS em que a pessoa apertou e
     a tela não fez absolutamente nada. Ela aperta de novo. Do lado dela, "não
     tem animação"; do lado do código, "a animação vem depois".

     🔑 Agora o botão trava e o anel aparece ANTES de qualquer `await`.
     Três coisas ao mesmo tempo, de propósito:
       · o BOTÃO mostra que está trabalhando (classe `mk-gerando`) — é onde o
         olho está no instante do toque, e é o único ponto da tela que a pessoa
         tem certeza de estar olhando;
       · a CAIXA de resultado vira o anel com as frases;
       · e a caixa é trazida pra vista (`scrollIntoView`), porque no celular o
         `#mkOut` nasce ABAIXO do botão e podia estar fora da tela — anel que
         gira fora da tela é o mesmo que anel nenhum.

     ⚠️ E o botão precisa DESTRAVAR em toda saída, inclusive na do veículo sem
     marca/modelo — que antes saía com `return` seco, antes mesmo do try. Por
     isso essa checagem entrou PRA DENTRO do try/finally: o `finally` é a única
     saída que não dá pra esquecer.
     ⚠️ Vale pro Estoque também. A função é a mesma nas duas telas, e o vão
     entre o toque e o anel era o mesmo nas duas. */
  function _mktBtnOcupado(btn, on){
    if(!btn) return;
    btn.disabled=!!on;
    try{ btn.classList.toggle('mk-gerando', !!on); }catch(_){}
    if(on) btn.setAttribute('aria-busy','true'); else btn.removeAttribute('aria-busy');
  }
  async function mktGerarTextos(){
    var v=_mktV; if(!v) return;
    if(_mktDireto&&$('efBody')){ try{ v=_mktV=_estFichaVeic(); }catch(_){} }
    _mktPostAutomaticoPinta(v);
    return _mktPostAutomatico(v);
  }
  /* Compatibilidade para cliques antigos ainda presentes em cache: gera sempre
     os dois formatos, evitando que uma tela antiga recrie só um deles. */
  async function mktGerarPost(extras){ return mktGerarTextos(extras); }
  async function postCompartilhar(post, fotoUrl){
    var foto=fotoUrl||null;
    try{
      if(foto && navigator.canShare){
        try{ var resp=await fetch(foto); var blob=await resp.blob(); var file=new File([blob],'veiculo.jpg',{type:(blob&&blob.type)||'image/jpeg'}); if(navigator.canShare({files:[file]})){ await navigator.share({files:[file], text:post}); return; } }catch(_){}
      }
      if(navigator.share){ await navigator.share({text:post}); return; }
    }catch(err){ if(err&&err.name==='AbortError') return; }
    mevIrProWhats('https://wa.me/?text='+encodeURIComponent(post));   /* v370 */
  }
  /* ===== CARD DE VENDA (imagem personalizada por lojista) ===== */
  var _cardUltimo='';
  function _lojaCardCfg(){
    var c=(_lojaRec&&_lojaRec.card_config)||{};
    return { cor:c.cor||'#0a4da6', tema:c.tema||'escuro', mostrar_km:c.mostrar_km!==false, mostrar_placa:!!c.mostrar_placa, mostrar_entrada:c.mostrar_entrada!==false, cta:(c.cta!=null?c.cta:'Chama no WhatsApp') };
  }
  function _lojaCardLerForm(){
    return { cor:(($('ljCardCor')||{}).value||'#0a4da6'), tema:(($('ljCardTema')||{}).value||'escuro'), cta:(($('ljCardCta')||{}).value||''), mostrar_km:!!(($('ljCardKm')||{}).checked), mostrar_entrada:!!(($('ljCardEnt')||{}).checked), mostrar_placa:!!(($('ljCardPlaca')||{}).checked) };
  }
  function _cardImg(url){ return new Promise(function(res){ if(!url){ res(null); return; } var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){ res(im); }; im.onerror=function(){ res(null); }; im.src=url; }); }
  function _cardRR(g,x,y,w,h,r){ g.beginPath(); g.moveTo(x+r,y); g.arcTo(x+w,y,x+w,y+h,r); g.arcTo(x+w,y+h,x,y+h,r); g.arcTo(x,y+h,x,y,r); g.arcTo(x,y,x+w,y,r); g.closePath(); }
  function _cardCover(g,im,x,y,w,h){ var ir=im.width/im.height, br=w/h, sw,sh,sx,sy; if(ir>br){ sh=im.height; sw=sh*br; sx=(im.width-sw)/2; sy=0; } else { sw=im.width; sh=sw/br; sx=0; sy=(im.height-sh)/2; } g.drawImage(im,sx,sy,sw,sh,x,y,w,h); }
  function _cardFit(g,txt,max,start,min,weight){ var s=start; do{ g.font=weight+' '+s+'px system-ui,-apple-system,Arial'; if(g.measureText(txt).width<=max) break; s-=2; }while(s>min); return s; }
  function _shade(hex,f){ hex=String(hex||'#0a4da6').replace('#',''); if(hex.length===3) hex=hex.replace(/(.)/g,'$1$1'); var n=parseInt(hex,16)||0, r=(n>>16)&255,gg=(n>>8)&255,b=n&255; r=Math.min(255,Math.round(r*f));gg=Math.min(255,Math.round(gg*f));b=Math.min(255,Math.round(b*f)); return 'rgb('+r+','+gg+','+b+')'; }
  async function mevCardCanvas(veic, cfg, loja, fotoUrl){
    cfg=cfg||_lojaCardCfg(); loja=loja||_lojaRec||{};
    var W=1080,H=1350, cv=document.createElement('canvas'); cv.width=W; cv.height=H; var g=cv.getContext('2d');
    var cor=cfg.cor||'#0a4da6', escuro=cfg.tema!=='claro', txtCor=escuro?'#ffffff':'#0f172a';
    g.fillStyle='#0f172a'; g.fillRect(0,0,W,H);
    var photoH=860, foto=await _cardImg(fotoUrl);
    if(foto){ _cardCover(g,foto,0,0,W,photoH); }
    else { var gr=g.createLinearGradient(0,0,0,photoH); gr.addColorStop(0,_shade(cor,1.25)); gr.addColorStop(1,cor); g.fillStyle=gr; g.fillRect(0,0,W,photoH); g.fillStyle='rgba(255,255,255,.9)'; g.textAlign='center'; g.font='700 130px system-ui,Arial'; g.fillText('🚗',W/2,photoH/2+45); g.textAlign='left'; }
    var gt=g.createLinearGradient(0,0,0,230); gt.addColorStop(0,'rgba(0,0,0,.5)'); gt.addColorStop(1,'rgba(0,0,0,0)'); g.fillStyle=gt; g.fillRect(0,0,W,230);
    var logo=await _cardImg(loja.logo_url), lx=44, ly=40;
    if(logo){ g.save(); g.beginPath(); g.arc(lx+48,ly+48,48,0,Math.PI*2); g.closePath(); g.fillStyle='#fff'; g.fill(); g.clip(); _cardCover(g,logo,lx,ly,96,96); g.restore(); lx+=116; }
    var nomeLoja=String(loja.nome_fantasia||loja.razao_social||'');
    if(nomeLoja){ g.fillStyle='#fff'; g.textBaseline='middle'; var nfs=_cardFit(g,nomeLoja,W-lx-40,42,26,'800'); g.font='800 '+nfs+'px system-ui,Arial'; g.shadowColor='rgba(0,0,0,.55)'; g.shadowBlur=10; g.fillText(nomeLoja, lx, ly+48); g.shadowBlur=0; g.textBaseline='alphabetic'; }
    /* gradiente suave no PÉ da foto (transição bonita pro painel) */
    var gb=g.createLinearGradient(0,photoH-140,0,photoH); gb.addColorStop(0,'rgba(0,0,0,0)'); gb.addColorStop(1,'rgba(0,0,0,.35)'); g.fillStyle=gb; g.fillRect(0,photoH-140,W,140);
    g.fillStyle=cor; g.fillRect(0,photoH,W,H-photoH);
    g.fillStyle=escuro?'rgba(255,255,255,.9)':_shade(cor,.6); g.fillRect(0,photoH,W,6);
    var pad=60, cx=pad, cy=photoH+92;
    var modelo=((veic.marca||'')+' '+(veic.modelo||'')).trim()||veic.modelo||'Veículo';
    var fs=_cardFit(g,modelo,W-pad*2,74,40,'900'); g.fillStyle=txtCor; g.textBaseline='alphabetic'; g.font='900 '+fs+'px system-ui,Arial'; g.fillText(modelo, cx, cy); cy+=46;
    /* dados em CHIPS arredondados (ano · km · placa · cor) — mais "anúncio" */
    var sub=[]; if(veic.ano) sub.push(String(veic.ano)); if(cfg.mostrar_km&&veic.km){ var kmn=Number(String(veic.km).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''))||0; if(kmn) sub.push(kmn.toLocaleString('pt-BR')+' km'); } if(cfg.mostrar_placa&&veic.placa) sub.push(String(veic.placa).toUpperCase()); if(veic.cor) sub.push(String(veic.cor).toUpperCase());
    if(sub.length){ var chx=cx, chh=52; g.font='800 28px system-ui,Arial';
      sub.forEach(function(t){ var tw=g.measureText(t).width, cw=tw+40; if(chx+cw>W-pad){ return; }
        _cardRR(g,chx,cy,cw,chh,26); g.fillStyle=escuro?'rgba(255,255,255,.16)':'rgba(15,23,42,.08)'; g.fill();
        g.fillStyle=escuro?'rgba(255,255,255,.95)':'rgba(15,23,42,.8)'; g.textBaseline='middle'; g.fillText(t, chx+20, cy+chh/2+1); g.textBaseline='alphabetic';
        chx+=cw+14; });
      cy+=chh+26; } else { cy+=10; }
    cy+=72;
    var preco=Number(veic.precoNum)||0, precoTxt=preco?('R$ '+preco.toLocaleString('pt-BR')):'Consulte';
    g.fillStyle=txtCor; g.font='900 96px system-ui,Arial'; g.fillText(precoTxt, cx, cy);
    if(cfg.mostrar_entrada && preco){ var ent=_round900(preco*0.30); if(ent){ var etxt='Entrada R$ '+ent.toLocaleString('pt-BR'); g.font='800 30px system-ui,Arial'; var ew=g.measureText(etxt).width+44, eh=58, ex=cx, ey=cy+26; _cardRR(g,ex,ey,ew,eh,29); g.fillStyle=escuro?'#ffffff':cor; g.fill(); g.fillStyle=escuro?cor:'#ffffff'; g.textBaseline='middle'; g.fillText(etxt, ex+22, ey+eh/2+1); g.textBaseline='alphabetic'; } }
    /* RODAPÉ em faixa própria: telefone com ÍCONE VETORIAL (nunca vira
       quadradinho, como acontecia com o emoji) + selo verde do WhatsApp */
    var fh=118; g.fillStyle='rgba(0,0,0,.22)'; g.fillRect(0,H-fh,W,fh);
    function _icoFone(x,y,s,color){ try{ var p=new Path2D('M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'); g.save(); g.translate(x,y); g.scale(s/24,s/24); g.fillStyle=color; g.fill(p); g.restore(); }catch(_){} }
    var fone=String(loja.whatsapp||loja.telefone||''), fyC=H-fh/2;
    if(fone){ _icoFone(cx, fyC-21, 42, '#ffffff'); g.font='800 36px system-ui,Arial'; g.fillStyle='#ffffff'; g.textBaseline='middle'; g.fillText(fone, cx+58, fyC+1); g.textBaseline='alphabetic'; }
    var cta=String(cfg.cta||'').replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu,'').trim();
    if(cta){ g.font='800 30px system-ui,Arial'; var ctw=g.measureText(cta).width, ph2=64, pw2=ctw+ph2+34, px=W-pad-pw2, py=fyC-ph2/2;
      _cardRR(g,px,py,pw2,ph2,32); g.fillStyle='#22c55e'; g.fill();
      _icoFone(px+20, py+ph2/2-15, 30, '#ffffff');
      g.fillStyle='#ffffff'; g.textBaseline='middle'; g.fillText(cta, px+60, fyC+1); g.textBaseline='alphabetic'; }
    return cv;
  }
  /* v177 — CODIGO ESTACIONADO. O botao "Gerar card de venda (imagem)" saiu das
     duas telas (ficha do Estoque e pagina Marketing), entao esta funcao nao e'
     mais chamada por ninguem. Nao apaguei de proposito: o desenho do card
     (mevCardCanvas) ainda e' usado pela pre-visualizacao da Loja, e se um dia
     voce quiser o card de volta, basta recolocar o botao. */
  async function mktGerarCard(){
    var out=$('mkOut'), btn=$('mkBtnCard'), v=_mktV; if(!out||!v) return;
    var marca=String(v.marca||'').trim(), modelo=String(v.modelo||'').trim();
    if(!marca && !modelo){ out.innerHTML='<div class="cad-msg err">Esse veículo está sem marca/modelo — complete a ficha no Estoque.</div>'; return; }
    if(!_lojaRec){ try{ var lr=await supa.from('loja').select('*'); var arr=(lr&&lr.data)||[]; _lojaRec=arr.filter(function(l){ return String(l.user_id)===String(meuId); })[0]||arr[0]||null; }catch(_){} }
    var veic={ marca:marca, modelo:modelo, ano:String(v.ano_modelo||v.ano||''), cor:String(v.cor||''), km:String(v.km||''), placa:String(v.placa||''), precoNum:Number(v.preco_anuncio)||Number(v.preco_minimo)||0 };
    var foto=(v.fotos&&v.fotos.length)?v.fotos[0]:null;
    if(btn) btn.disabled=true; out.innerHTML='<div class="post-load"><span class="spin" style="width:22px;height:22px;border-width:3px"></span> Montando o card...</div>';
    try{
      var cv=await mevCardCanvas(veic,_lojaCardCfg(),_lojaRec,foto);
      var url; try{ url=cv.toDataURL('image/jpeg',0.92); }catch(e){ url=cv.toDataURL('image/png'); }
      _cardUltimo=url;
      out.innerHTML='<div class="post-box"><img loading="lazy" decoding="async" class="card-prev" src="'+esc(imgCdn(url,800))+'"><div class="post-acts"><button type="button" class="b1" id="mkCardDl">Baixar</button><button type="button" class="b2" id="mkCardWa">Compartilhar</button><button type="button" class="b3" id="mkCardCfg">Personalizar</button></div></div>';
      $('mkCardDl').onclick=function(){ var a=document.createElement('a'); a.href=url; a.download='card-'+((modelo||'veiculo').replace(/\s+/g,'-').toLowerCase())+'.jpg'; document.body.appendChild(a); a.click(); setTimeout(function(){ a.remove(); },400); };
      $('mkCardWa').onclick=function(){ cardCompartilhar(url); };
      $('mkCardCfg').onclick=function(){ toast('Personalize em Minha loja → Modelo do card.'); telaLoja(); };
    }catch(e){ out.innerHTML='<div class="cad-msg err">Não consegui montar o card. '+esc((e&&e.message)||'')+'</div>'; }
    if(btn) btn.disabled=false;
  }
  async function cardCompartilhar(dataUrl){
    try{ var resp=await fetch(dataUrl); var blob=await resp.blob(); var file=new File([blob],'card.jpg',{type:'image/jpeg'});
      if(navigator.canShare && navigator.canShare({files:[file]})){ await navigator.share({files:[file]}); return; }
    }catch(err){ if(err&&err.name==='AbortError') return; }
    try{ var a=document.createElement('a'); a.href=dataUrl; a.download='card.jpg'; document.body.appendChild(a); a.click(); setTimeout(function(){ a.remove(); },400); toast('Baixei o card — é só enviar.'); }catch(_){}
  }

/* ╔═══ src/app/14k-buscador-pagina.js ════════════════════════════════════ */
  /* ==========================================================================
     14k — O BUSCADOR DE PÁGINA
     PROJETO-2026-08-30-a-divida-do-14-estoque · FASE 5, terceiro e último corte
     --------------------------------------------------------------------------
     Este arquivo NASCEU DE UM RECORTE do 14-estoque.js. Nenhuma linha de
     lógica mudou: é o mesmo código, no mesmo IIFE, na mesma ordem relativa.

     O QUE ELE FAZ (v654): quando o link colado no "Importar anúncio" é a
     BUSCA da loja (aquela tela com 34 carros) e não um carro, esta tela mostra
     os carros da página e deixa o lojista ESCOLHER. A lista é de graça; o
     token sai por carro marcado, com o número na frente ("7 veículos · 7
     tokens") — a regra da casa desde a v585: o que custa não sai sem o dedo.

     QUEM CHAMA: o estImportarAnuncio, que ficou no 14-estoque. É lá que mora
     a olhada de graça que decide "isto é lista ou é carro?".

     ⚠️ A ORDEM DO MONTADOR: 14k entra depois do 14j e antes do 15. Como tudo
     vive no mesmo IIFE e função é hoisted, quem chama e quem é chamado se
     enxergam de qualquer jeito; a variável daqui (_estBuscador) só é lida
     dentro de função, nunca no topo.
     ========================================================================== */
  /* ==========================================================================
     🔴🔴 v654 — O BUSCADOR DE PÁGINA
     --------------------------------------------------------------------------
     O QUE ELE RESOLVE: até a v652, colar o link da BUSCA de uma loja (aquela
     tela com 34 carros) importava, calado, o PRIMEIRO carro da lista — e
     cobrava 1 token por ele. A v653 fez a leitura PARAR. Esta versão faz o que
     sempre devia acontecer: mostra os carros da página e deixa você escolher.

     🔴 A LISTA É DE GRAÇA. O token sai por CARRO MARCADO, e a confirmação vem
        com o número na frente ("7 veículos · 7 tokens"). Regra v585 da casa:
        o que custa não sai sem o dedo.
     🔑 A CHAVE DE CADA CARRO É O `id` QUE O SITE PUBLICA, nunca o endereço —
        na página real existem dois Ford KA cujos endereços só se distinguem
        por um "-2019" enfiado no meio.
     ========================================================================== */
  var _estBuscador=null;   /* {itens, marcados:{}, origem, url, paginas, filtro} */

  function estBuscadorAbrir(lista, origem, url){
    _estBuscador={ itens:(lista&&lista.itens)||[], marcados:{},
                   origem:origem||'', url:url||'',
                   paginas:Number(lista&&lista.paginas)||1,
                   filtro:(lista&&lista.filtro)||[], teto:Number(lista&&lista.teto)||45 };
    var tt=$('cliMt'); if(tt) tt.textContent='Veículos deste link';
    estBuscadorPinta();
  }

  function estBuscadorPinta(){
    var b=_estBuscador; if(!b) return;
    var body=$('cliMbody'); if(!body) return;
    /* 🔴 O AVISO DO FILTRO E DAS PÁGINAS, SEMPRE. O endereço que a pessoa copia
       costuma carregar a busca DELA. Sem esta linha, o lojista acha que viu o
       estoque inteiro da loja — e não viu. */
    var recado=[];
    recado.push('<b>'+b.itens.length+'</b> veículo'+(b.itens.length===1?'':'s')+' nesta página');
    if(b.paginas>1) recado.push('a busca tem <b>'+b.paginas+'</b> páginas — esta é a primeira');
    if(b.filtro.length) recado.push('o seu link já vem filtrado por <b>'+esc(b.filtro.join(', '))+'</b>');
    body.innerHTML=
      '<p class="est-busc-note">'+recado.join(' · ')+'.'+
        (b.paginas>1?' Para ver as outras, abra a próxima página no site da loja e cole o link dela aqui.':'')+
      '</p>'+
      '<div class="est-busc-topo">'+
        '<button type="button" class="est-busc-lnk" id="estBuscTodos">Marcar todos</button>'+
        '<button type="button" class="est-busc-lnk" id="estBuscNenhum">Limpar</button>'+
      '</div>'+
      '<div class="est-busc-lista" id="estBuscLista">'+b.itens.map(estBuscadorCard).join('')+'</div>'+
      '<div class="cad-msg" id="estBuscMsg"></div>'+
      '<button type="button" class="cad-btn ico" id="estBuscGo" disabled>'+mkIco('link',17)+'<span id="estBuscGoTxt">Escolha os veículos</span></button>';
    Array.prototype.forEach.call(body.querySelectorAll('.est-busc-card'), function(c){
      c.onclick=function(){ estBuscadorMarcar(c.getAttribute('data-id')); };
    });
    var td=$('estBuscTodos'); if(td) td.onclick=function(){ b.itens.forEach(function(x){ b.marcados[x.id]=1; }); estBuscadorPinta(); };
    var nn=$('estBuscNenhum'); if(nn) nn.onclick=function(){ b.marcados={}; estBuscadorPinta(); };
    var go=$('estBuscGo'); if(go) go.onclick=estBuscadorConfirmar;
    estBuscadorBotao();
  }

  function estBuscadorCard(x){
    var b=_estBuscador||{marcados:{}};
    var nome=[x.marca, x.modelo, x.versao].filter(Boolean).join(' ');
    var linha=[];
    if(x.ano) linha.push(esc(x.ano+(x.ano_modelo&&x.ano_modelo!==x.ano?('/'+x.ano_modelo):'')));
    if(x.km) linha.push(Number(x.km).toLocaleString('pt-BR')+' km');
    if(x.cambio) linha.push(esc(x.cambio));
    var foto=x.foto?('<img src="'+esc(x.foto)+'" alt="" loading="lazy">'):'<i></i>';
    return '<div class="est-busc-card'+(b.marcados[x.id]?' on':'')+'" data-id="'+esc(x.id)+'">'+
      '<span class="est-busc-ck" aria-hidden="true"></span>'+
      '<div class="est-busc-foto">'+foto+'</div>'+
      '<div class="est-busc-txt"><b>'+esc(nome||x.titulo||'Veículo')+'</b>'+
        '<small>'+linha.join(' · ')+'</small>'+
        '<u>'+(x.preco?_rs(x.preco):'Preço não informado')+'</u></div>'+
    '</div>';
  }

  function estBuscadorMarcar(id){
    var b=_estBuscador; if(!b||!id) return;
    if(b.marcados[id]) delete b.marcados[id]; else b.marcados[id]=1;
    var card=document.querySelector('.est-busc-card[data-id="'+id.replace(/"/g,'')+'"]');
    if(card) card.classList.toggle('on', !!b.marcados[id]);
    estBuscadorBotao();
  }

  function estBuscadorSelecionados(){
    var b=_estBuscador; if(!b) return [];
    return b.itens.filter(function(x){ return !!b.marcados[x.id]; });
  }

  /* 🔴 O NÚMERO NA FRENTE, SEMPRE. O botão nunca diz só "Importar": ele diz
     quantos veículos e quantos tokens, antes do dedo. */
  function estBuscadorBotao(){
    var go=$('estBuscGo'), tx=$('estBuscGoTxt'); if(!go||!tx) return;
    var n=estBuscadorSelecionados().length;
    go.disabled=!n;
    tx.textContent=n?('Importar '+n+' veículo'+(n===1?'':'s')+' · '+precoReal(n)):'Escolha os veículos';
  }

  async function estBuscadorConfirmar(){
    var sel=estBuscadorSelecionados(); if(!sel.length) return;
    var n=sel.length;
    if(!confirm(n+' veículo'+(n===1?'':'s')+' · '+precoReal(n)+'. Confirma?')) return;
    var go=$('estBuscGo'); if(go) go.disabled=true;
    var td=$('estBuscTodos'), nn=$('estBuscNenhum');
    if(td) td.disabled=true; if(nn) nn.disabled=true;
    var feitos=0, falhas=[];
    for(var i=0;i<sel.length;i++){
      estBuscadorMsg('Importando '+(i+1)+' de '+n+' — '+((sel[i].marca||'')+' '+(sel[i].modelo||'')).trim()+'…','load');
      estAbrirFicha(null);
      /* 🔴 A FICHA PODE NÃO ABRIR: o plano tem teto de veículos (v452), e
         quando ele estoura o `estAbrirFicha` avisa e volta. Seguir o laço
         aqui importaria carro nenhum e diria que importou. */
      var campo=$('efImportUrl');
      if(!campo){ falhas.push('o plano não comporta mais veículos'); break; }
      campo.value=sel[i].url;
      /* 🔴 `semIa:true` — e este é o ponto do "7 veículos · 7 tokens".
         A importação de UM carro, no dedo, ainda gera a ficha técnica por IA
         logo depois (mais 1 token). Em lote isso dobraria a conta sem ninguém
         ter combinado. A ficha por IA continua a um botão de distância, na aba
         Ficha técnica de cada carro. */
      /* ⚠️ O `estImportarAnuncio` engole o próprio erro pra mostrar recado na
         tela — por isso quem diz se deu certo é o RETORNO, não um try/catch.
         Contar como importado o carro que falhou é a mesma família do teste
         morto contando como verde. */
      var deu=false;
      try{ deu=await estImportarAnuncio({ semIa:true }); }catch(_){ deu=false; }
      if(deu) feitos++;
      else falhas.push(((sel[i].modelo||'veículo')));
    }
    estBuscadorMsg('','');
    cliModalFechar();
    _estBuscador=null;
    var recado=feitos+' veículo'+(feitos===1?'':'s')+' importado'+(feitos===1?'':'s')+' · '+precoReal(feitos)+'.';
    if(falhas.length) recado+=' '+falhas.length+' não entrou: '+falhas[0];
    toast(recado);
  }

  function estBuscadorMsg(texto,tipo){
    var el=$('estBuscMsg'); if(!el) return;
    el.className='cad-msg'+(tipo?(' '+tipo):''); el.textContent=texto||'';
  }

/* ╔═══ src/app/14l-importar-print.js ═════════════════════════════════════ */
/* ╔══════════════════════════════════════════════════════════════════════════
   ║  14l — IMPORTAR VEÍCULO PELO PRINT DO ANÚNCIO            (v827, pedido)
   ╚══════════════════════════════════════════════════════════════════════════

   O PEDIDO, na palavra dele: "ajuste pra importar um veiculo para estoque
   com print - eu anexo as fotos".

   O QUE ISSO RESOLVE: o "Importar do link" (v654/v665) só funciona quando o
   anúncio TEM link e o servidor consegue abrir a página. Um post do Instagram,
   um story, um anúncio que chegou por WhatsApp — desses não sai link nenhum.
   Mas sai print. E o print tem tudo escrito: modelo, ano, preço, opcionais.

   COMO FUNCIONA: o print vai pro MESMO motor de leitura que a Vendas e a
   Compra já usam (o MEV_IA, /api/ia-extrair-proposta). Nenhum leitor novo foi
   escrito — entrou um tipo novo de documento, o `anuncio_veiculo`.

   🔴 A DIVISÃO DE TRABALHO QUE ELE PEDIU: o print dá os DADOS. As FOTOS ele
   anexa. Por isso, quando a leitura termina, o app abre sozinho o seletor de
   fotos do estoque — que é o mesmo de sempre, com reenquadramento e proteção
   de placa. O print NÃO vira foto do carro: ele é uma tela de celular, com
   barra de status e botões, e ninguém quer isso no catálogo.

   🔴 E A REGRA DA v825 VALE AQUI TAMBÉM: quando a ficha já está aberta, a
   leitura só escreve em CAMPO VAZIO. O que o Angelo digitou fica.
   ══════════════════════════════════════════════════════════════════════════ */

  var _estPrintFonte = null;   /* de onde veio o último carro lido por print */

  /* Ícone do menu: uma imagem com uma faísca — "ler uma tela". */
  var ICO_PRINT_ANUNCIO =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+
    '<rect x="3" y="3" width="18" height="18" rx="2"/>'+
    '<path d="M3 15l4.5-4.5a2 2 0 0 1 2.8 0L15 15"/>'+
    '<path d="M14 13.5l1.6-1.6a2 2 0 0 1 2.8 0L21 14.5"/>'+
    '<circle cx="8.5" cy="8" r="1.5"/></svg>';

  /* ── números que vêm do anúncio ─────────────────────────────────────────
     A IA já foi instruída a mandar número puro, mas anúncio é texto livre e
     um "R$ 52.900,00" escapa. Estas duas funções são a rede. */
  function _prNum(v){
    if(v==null||v==='') return 0;
    if(typeof v==='number') return isFinite(v)?v:0;
    var s=String(v).replace(/[^\d,.-]/g,'');
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if(/\.\d{3}(\D|$)/.test(s)) s=s.replace(/\./g,'');
    var n=Number(s); return isFinite(n)?n:0;
  }
  function _prTxt(v){ return String(v==null?'':v).trim(); }
  function _prAno(v){ var m=/(\d{4})/.exec(String(v||'')); return m?m[1]:''; }

  /* Opcionais: a tela de conferência manda `opcionais_texto` (uma linha só,
     editada à mão); a IA manda `opcionais` (array). Quem foi editado ganha. */
  function _prOpcionais(d){
    var t=_prTxt(d.opcionais_texto);
    if(t) return t;
    if(Array.isArray(d.opcionais)) return d.opcionais.map(_prTxt).filter(Boolean).join(', ');
    return _prTxt(d.opcionais);
  }

  /* ── o preenchimento ────────────────────────────────────────────────────
     `soVazio` = não encoste no que já está escrito. É a regra da v825.
     Devolve quantos campos realmente escreveu, pra poder DIZER isso na tela
     em vez de só piscar um "pronto". */
  function _prPoe(id, valor, soVazio){
    var el=$(id); if(!el) return 0;
    var v=_prTxt(valor); if(!v) return 0;
    if(soVazio && _prTxt(el.value)) return 0;
    el.value=v; return 1;
  }
  function estPrintPreencher(d, soVazio){
    var n=0;
    n+=_prPoe('efMarca', d.marca, soVazio);
    /* Modelo: o anúncio separa "Onix" de "Joy 1.0 flex". No estoque o campo
       modelo é um só — e é ele que a busca da FIPE usa. Junta os dois. */
    var modelo=[_prTxt(d.modelo), _prTxt(d.versao)].filter(Boolean).join(' ');
    n+=_prPoe('efModelo', modelo, soVazio);
    n+=_prPoe('efAno',    _prAno(d.ano_fabricacao)||_prAno(d.ano_modelo), soVazio);
    n+=_prPoe('efAnoMod', _prAno(d.ano_modelo)||_prAno(d.ano_fabricacao), soVazio);
    n+=_prPoe('efCor',    d.cor, soVazio);
    n+=_prPoe('efCombustivel', d.combustivel, soVazio);
    n+=_prPoe('efCambio', d.cambio, soVazio);
    var km=_prNum(d.km); if(km>0) n+=_prPoe('efKm', km.toLocaleString('pt-BR'), soVazio);
    /* 🔴 O PREÇO DO PRINT É O PREÇO DE QUEM ANUNCIOU — NÃO É O CUSTO DELE.
       Por isso ele entra em "preço de anúncio" e NUNCA em preço de compra ou
       preço mínimo. Escrever esse número no lugar do custo faria a margem do
       carro nascer errada, e errada em silêncio. */
    var pr=_prNum(d.preco); if(pr>0) n+=_prPoe('efAnuncio', _rs(pr), soVazio);
    n+=_prPoe('exOpc', _prOpcionais(d), soVazio);
    /* 🔴 v652: final de placa NÃO é placa. Só entra no campo placa o que tem
       cara de placa inteira (ABC1234 ou ABC1D23). */
    var placa=_prTxt(d.placa).toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(/^[A-Z]{3}\d[A-Z0-9]\d{2}$/.test(placa)) n+=_prPoe('efPlaca', placa, soVazio);
    /* Observações: a descrição do anúncio, e o final da placa quando é só
       isso que o anúncio mostrou. Nunca por cima do que ele escreveu. */
    var obs=[]; var desc=_prTxt(d.descricao); if(desc) obs.push(desc);
    var fin=_prTxt(d.final_placa); if(fin && !placa) obs.push('Final da placa no anúncio: '+fin);
    if(obs.length) n+=_prPoe('efObs', obs.join('\n\n'), soVazio);
    return n;
  }

  /* ── o fluxo inteiro ────────────────────────────────────────────────────*/
  /* 🔴🔴 v829 — O DEFEITO QUE O ANGELO ACHOU NO IPHONE EM 15 MINUTOS
     ("O leitor de documentos não carregou. Recarregue o app e tente de novo.")

     O `mev-ia-importar.js` NÃO vem junto com o app: ele é um recurso PESADO,
     carregado sob demanda pelo `_iaAcao()` (01-nucleo) na primeira vez que
     alguém pede uma leitura. Quem abre o Estoque sem ter usado a IA naquela
     sessão simplesmente não tem `window.MEV_IA` — e era exatamente esse o
     caso dele.

     Eu escrevi a checagem certa e a CONCLUSÃO errada: em vez de MANDAR
     CARREGAR, eu desisti com um recado. Todo o resto do app já fazia isso
     certo — 05l (Compra), 17 (Vendas), 12 (CRM) e 19 (Documentos) chamam
     `_iaAcao(function(){ tenta de novo; })`. Fiquei de fora do padrão da casa,
     e o teste da v827 não pegou porque o sandbox injeta um MEV_IA de mentira:
     ali ele SEMPRE existe. O teste da v829 abre sem MEV_IA, de propósito.

     ⚠️ Um detalhe do celular que vale a próxima sessão saber: depois do
     carregamento, o seletor de arquivos abre FORA do gesto original do toque.
     No iPhone isso pode fazer o seletor não abrir sozinho na primeira vez —
     por isso, quando o recurso precisou ser buscado, o app avisa que está
     preparando e o `_iaAcao` cuida do recado. Da segunda vez em diante o
     MEV_IA já está na memória e abre no toque, direto. */
  function estImportarPrint(op){
    op=op||{};
    if(!window.MEV_IA){ _iaAcao(function(){ estImportarPrint(op); }); return; }
    if(typeof window.MEV_IA.importarAnuncioPrint!=='function'){
      /* O leitor está aqui, mas é de uma versão anterior à v827: o app novo
         com o arquivo velho em cache. Dizer isso é mais útil que "não
         carregou", porque o conserto é outro — é atualizar. */
      toast('Atualize o app para ler anúncios por print (puxe a tela para baixo).');
      return;
    }
    window.MEV_IA.importarAnuncioPrint(function(d){
      try{ estPrintAplicar(d, op); }
      catch(e){ toast('Li o anúncio, mas não consegui montar a ficha.'); }
    });
  }

  async function estPrintAplicar(d, op){
    op=op||{};
    d=d||{};
    if(d.erro){ toast(String(d.erro)); return; }
    /* Ficha nova quando o pedido veio do menu (+ do estoque); ficha aberta
       quando ele mandou ler o print DE DENTRO de um carro que já existe. */
    var jaAberta=!!$('efModelo');
    var soVazio=!!jaAberta;
    if(!jaAberta){ estAbrirFicha(null); soVazio=false; }
    if(!$('efModelo')){ toast('Não consegui abrir a ficha do veículo.'); return; }

    var escreveu=estPrintPreencher(d, soVazio);
    _estPrintFonte={
      lido_em:new Date().toISOString(),
      loja:_prTxt(d.loja),
      preco_anunciado:_prNum(d.preco)||0,
      final_placa:_prTxt(d.final_placa),
      modelo_original:_prTxt(d.modelo),
      versao_original:_prTxt(d.versao)
    };
    try{ estMargemCalc(); }catch(_){}
    estImportMsg('Print lido: '+escreveu+' campo(s) preenchido(s)'+
      (soVazio?' (só os que estavam vazios)':'')+'. Conferindo a versão na FIPE…','load');

    /* A FIPE é consulta pública e de graça — só precisa de marca, modelo e um
       ano. Sem os três não dá pra escolher versão, e insistir só demora. */
    var fipeD={ marca:_prTxt(d.marca), modelo:[_prTxt(d.modelo),_prTxt(d.versao)].filter(Boolean).join(' '),
                ano:_prAno(d.ano_fabricacao), ano_modelo:_prAno(d.ano_modelo) };
    var fi=null;
    if(fipeD.marca && fipeD.modelo && (fipeD.ano||fipeD.ano_modelo)){
      try{ fi=await estImportarFipe(fipeD); }catch(_){ fi=null; }
    }
    if(fi) _estPrintFonte.fipe={modelo:fi.descricao,ano_modelo:fi.ano,combustivel:fi.combustivel,valor:fi.valor,codigo_fipe:fi.codigo_fipe,mes_ref:fi.mes_ref};

    try{ await estSalvarAuto(); }catch(_){}

    var recado='Dados do anúncio prontos'+(fi?' e versão da FIPE encontrada':'')+
               '. Agora anexe as fotos do carro.';
    estImportMsg(recado,'ok');
    toast(recado);

    /* 🔴 O PEDIDO DELE, LITERAL: "eu anexo as fotos". Então o app não fica
       esperando ele achar o botão — abre o seletor de fotos do estoque, que é
       o mesmo de sempre (reenquadra e protege a placa).
       ⚠️ O clique precisa de um respiro: o seletor nativo só abre depois que a
       ficha terminou de pintar. E se por algum motivo o campo não existir, o
       fluxo NÃO quebra — os dados já estão salvos, ele anexa na mão. */
    if(op.semFotos) return;
    setTimeout(function(){
      var inp=$('estFotoInput');
      if(inp){ try{ inp.click(); }catch(_){} }
    }, 350);
  }

/* ╔═══ src/app/14m-zero-km.js ════════════════════════════════════════════ */
  /* ==========================================================================
     🔴🔴 v1052 — O VEÍCULO 0 KM NO ESTOQUE
     (PROJETO-2026-09-16-zero-km-e-pagina-novos.txt, FASE 1)
     --------------------------------------------------------------------------
     Pedido do Angelo: "criar uma forma de eu adicionar um veículo zero km ao
     estoque, ele aparecer no catálogo e ele aparecer em uma nova página no
     site como Novos". As quatro decisões dele, tomadas antes de escrever:

       1. Página /novos própria, separada dos seminovos, e com lugar na home.
       2. No estoque, o 0 km é identificado por CHASSI. A placa vira opcional
          e é preenchida quando o carro for faturado.
          🔴 REVOGADA NA v1059, pelo próprio Angelo: "importar as
          informações do mevtools para o cadastro, SEM CHASSI E SEM PLACA".
          Os dois campos saíram da tela do 0 km. O chassi que já está gravado
          nos carros da v1052–v1058 continua no banco (ver `zkColeta`), e o
          custo humano — dois Polo Sense Branco ficam idênticos na lista — ele
          aceitou por escrito. A chave do registro sempre foi o `id` uuid,
          então nada quebra tecnicamente.
       3. Campos: pronta entrega / a faturar · garantia de fábrica e anos ·
          PCD / direto de fábrica / frotista · bônus, taxa zero e cores.
       4. Por enquanto só o Angelo cadastra 0 km — atrás da trava de admin.
          Liberar pra todos depois é apagar UMA linha (ver `zkPodeUsar`).

     🔑 POR QUE ESTE ARQUIVO EXISTE, EM VEZ DE MAIS CÓDIGO NO 14-ESTOQUE.
     O `14-estoque.js` tem ~200 KB, e a regra da casa (CLAUDE.md) é clara:
     módulo acima de ~80 KB, quem for mexer SEPARA ANTES o pedaço novo, no
     padrão `14b-`, `14c-`. Então o 0 km nasce aqui inteiro, e lá dentro
     entram só GANCHOS de uma linha. O montador cola por ordem de nome: o
     `14m-` cai depois do `14l-` e antes do `15-`, sem nada a configurar.

     🔴 NENHUMA COLUNA NOVA NO BANCO. A `mp_estoque` tem 28 colunas e nenhuma
     é "condição do veículo" — mas ela tem `extras` (jsonb), onde já moram
     `unico_dono`, `ipva_pago`, `preco_repasse`, `cambio`, `prerenave`. O 0 km
     entra ali. Zero migração, zero downtime, e um carro que deixa de ser 0 km
     (foi faturado) é só desligar o interruptor — nada pra apagar e recadastrar.

     ⚠️ OS NOMES DAS CHAVES SÃO FECHADOS. Renomear qualquer uma depois quebra
     os carros já gravados em silêncio: o jsonb não reclama de chave que
     ninguém lê, ele só devolve vazio. Elas aparecem em quatro lugares — aqui,
     no `publico_vitrine()`, no `mp_get_catalogo()` e na `vitrine.js`.
     ========================================================================== */
  var ZK_ENTREGAS=[['pronta','Pronta entrega'],['faturar','A faturar']];
  var ZK_VENDAS=[['varejo','Varejo'],['pcd','PCD'],['direto','Direto de fábrica'],
                 ['frotista','Frotista'],['taxi','Táxi']];
  /* ⚠️ OS SEIS SELOS QUE NÃO QUEREM DIZER NADA NUM CARRO NOVO. Único dono,
     2º dono, IPVA pago, Transferido, Revisado e Pneus novos são afirmações
     sobre um PASSADO que um 0 km não tem. Deixá-los na tela não é só enfeite:
     é convidar a marcar "Único dono" num carro que nunca teve dono, e isso
     sai no anúncio público. */
  var ZK_SELOS_DE_USADO=['unico_dono','dono2','ipva_pago','transferido','revisado','pneus_novos'];

  /* 🔴 A TRAVA (decisão 4 do Angelo). Uma linha: apagar o `zkPodeUsar` de
     dentro do gancho do 14-estoque libera pra todos. A checagem é a mesma que
     o 10-parceiros e o 18e já usam — não inventei portão novo.
     ⚠️ E ela falha pro lado de ESCONDER, ao contrário do `edPode`: aqui o
     risco de mostrar por engano é um lojista cadastrar 0 km que a loja dele
     não vende, e isso vira anúncio errado no site público. */
  function zkPodeUsar(){
    try{ return typeof _ehAdmin==='function' && !!_ehAdmin(); }catch(_){ return false; }
  }
  function zkLigado(){ try{ return !!(($('zkOn')||{}).checked); }catch(_){ return false; } }
  function _zkV(id){ try{ return String((($(id)||{}).value||'')).trim(); }catch(_){ return ''; } }
  function _zkN(id){ var n=parseInt(String(_zkV(id)).replace(/\D/g,''),10); return isFinite(n)?n:null; }

  function zkBlocoHtml(ex){
    ex=ex||{};
    var on=!!ex.zero_km;
    function opts(lista,atual){
      return lista.map(function(p){
        return '<option value="'+p[0]+'"'+(String(atual||'')===p[0]?' selected':'')+'>'+esc(p[1])+'</option>';
      }).join('');
    }
    return '<label class="vd-ck zk-switch'+(on?' on':'')+'" id="zkSwitch">'+
        '<input type="checkbox" id="zkOn"'+(on?' checked':'')+'>'+
        '<span>Veículo 0 km (novo)</span></label>'+
      '<div class="zk-bloco'+(on?'':' zk-off')+'" id="zkBloco">'+
        /* 🔴 v1059 — a ponte pra Cotação (14n-). Vem PRIMEIRO porque é ela
           que preenche o resto: escolher modelo → versão → cor é o começo do
           cadastro, não um extra no fim. Gancho de uma linha, como o próprio
           14m- é gancho de uma linha dentro do 14-estoque. */
        (function(){ try{ return (typeof zcBlocoHtml==='function' && zcPodeUsar()) ? zcBlocoHtml() : ''; }catch(_){ return ''; } })()+
        '<div class="cli-2col">'+
          '<div><label class="cad-lbl" for="zkEntrega">Disponibilidade</label>'+
            '<select class="cad-in" id="zkEntrega">'+opts(ZK_ENTREGAS,ex.zk_entrega||'pronta')+'</select></div>'+
          '<div><label class="cad-lbl" for="zkPrazo">Prazo <span class="ec-hint">(dias)</span></label>'+
            '<input class="cad-in" id="zkPrazo" inputmode="numeric" value="'+esc(ex.zk_prazo||'')+'" placeholder="30"></div>'+
        '</div>'+
        '<div class="cli-2col">'+
          '<div><label class="cad-lbl" for="zkGarantia">Garantia de fábrica <span class="ec-hint">(anos)</span></label>'+
            '<input class="cad-in" id="zkGarantia" inputmode="numeric" value="'+esc(ex.zk_garantia_anos||'')+'" placeholder="3"></div>'+
          '<div><label class="cad-lbl" for="zkVenda">Tipo de venda</label>'+
            '<select class="cad-in" id="zkVenda">'+opts(ZK_VENDAS,ex.zk_venda||'varejo')+'</select></div>'+
        '</div>'+
        /* 🔴🔴 v1090 — O PREÇO DE TABELA DO NOVO (pedido do Angelo, 19/09,
           com print do cadastro de uma Saveiro Robust CS 0 km).

           Ele pediu "o preço de tabela do Novo e o preço promocional". SÓ
           UM CAMPO NASCE AQUI, e isso foi decidido com ele antes de escrever:
           o PROMOCIONAL JÁ EXISTE — é o "Preço de anúncio" lá embaixo, que
           sempre foi o número que sai no site. Criar um segundo campo de
           preço público seria dois números brigando pra ver qual manda, e no
           dia em que discordassem o site mostraria um e a loja cobraria outro.

           ⚠️ POR ISSO O AVISO LOGO ABAIXO NÃO É ENFEITE: os dois números do
           "de/por" moram em lugares diferentes da ficha, então a tela precisa
           mostrar o PAR montado, com o desconto já calculado. Sem ele, quem
           preenche a tabela aqui em cima não tem como conferir o que o
           cliente vai ver. */
        '<div class="cli-2col">'+
          '<div><label class="cad-lbl" for="zkTabela">Preço de tabela <span class="ec-hint">(do novo)</span></label>'+
            '<input class="cad-in" id="zkTabela" inputmode="numeric" value="'+_rs(ex.zk_tabela)+'" placeholder="R$ 0"></div>'+
          '<div><label class="cad-lbl" for="zkBonus">Bônus de fábrica</label>'+
            '<input class="cad-in" id="zkBonus" inputmode="numeric" value="'+_rs(ex.zk_bonus)+'" placeholder="R$ 0"></div>'+
        '</div>'+
        '<p class="cad-help zk-depor" id="zkDePor"></p>'+
        '<label class="cad-lbl" for="zkCores">Cores disponíveis</label>'+
        '<input class="cad-in" id="zkCores" value="'+esc(ex.zk_cores||'')+'" placeholder="Branco Cristal, Prata Sirius">'+
        '<label class="vd-ck'+(ex.zk_taxa_zero?' on':'')+'"><input type="checkbox" id="zkTaxaZero"'+
          (ex.zk_taxa_zero?' checked':'')+'><span>Taxa zero</span></label>'+
      '</div>';
  }

  /* ==========================================================================
     O QUE O INTERRUPTOR FAZ NA TELA
     --------------------------------------------------------------------------
     ⚠️ ESCONDER NÃO PODE APAGAR DADO. É a lição que este projeto herda: o
     autosave lê a tela inteira a cada tecla, e um campo que sai do DOM some do
     registro no salvamento seguinte. Por isso aqui NADA é removido — o bloco
     0 km é escondido por CLASSE e os selos de usado também. Desligar o
     interruptor por engano não custa nenhum dado.
     ⛳ v1059: a placa deixou de trocar de rótulo (ela saiu do desenho do
     0 km, mas o CAMPO continua no DOM, intocado, porque o autosave o lê).
     ========================================================================== */
  function zkAplicaNaTela(){
    var on=zkLigado();
    try{
      var sw=$('zkSwitch'); if(sw) sw.classList.toggle('on',on);
      var bl=$('zkBloco');  if(bl) bl.classList.toggle('zk-off',!on);
      /* ⛳ v1059 — A PLACA VOLTOU A SER A PLACA. Até a v1058 o rótulo virava
         "Placa (quando faturar)" e o placeholder virava "preenche quando
         faturar". O Angelo pediu a tela do 0 km sem placa e sem chassi: num
         0 km o campo simplesmente fica vazio, e vazio já se explica sozinho.
         ⚠️ O CAMPO CONTINUA NO DOM, só sem o enfeite — o autosave lê ele. */
      /* 🔴 KM TRAVADO EM 0, não escondido: o campo continua no DOM porque o
         autosave o lê, e um 0 km TEM quilometragem — ela é zero. */
      var km=$('efKm');
      if(km){
        if(on){ km.value='0'; km.readOnly=true; km.classList.add('zk-travado'); }
        else { km.readOnly=false; km.classList.remove('zk-travado'); }
      }
      /* os seis selos de passado somem por classe, e DESMARCADOS: um 0 km que
         já tivesse "Único dono" ligado de antes não pode sair anunciado assim */
      ZK_SELOS_DE_USADO.forEach(function(k){
        var d=_zkSeloPorChave(k); if(!d) return;
        var inp=$(d.id); if(!inp) return;
        var lab=inp.parentElement;
        if(lab && lab.classList) lab.classList.toggle('zk-off',on);
        if(on && inp.checked){ inp.checked=false; if(lab&&lab.classList) lab.classList.remove('on'); }
      });
    }catch(_){}
  }
  /* ==========================================================================
     🔴 v1090 — O AVISO DO "DE / POR", CALCULADO NA TELA
     --------------------------------------------------------------------------
     Ele lê os DOIS campos que formam o par e escreve o que o cliente vai ver:
       tabela E anúncio menor  → "de R$ X por R$ Y — R$ Z de desconto (N%)"
       tabela e anúncio igual/maior → "sem promoção: o site mostra R$ Y"
       tabela sem anúncio      → o aviso que importa: sem anúncio o carro NÃO
                                 aparece no site (regra do `publico_vitrine()`)
       sem tabela              → silêncio. Campo opcional não vira cobrança.

     ⚠️ ELE NÃO DECIDE NADA, SÓ CONTA. Nenhum destes textos grava valor; o que
     vai pro banco é o que está nos campos. Um aviso que também calculasse
     seria um terceiro número na disputa.
     ========================================================================== */
  function zkDePorPinta(){
    try{
      var el=$('zkDePor'); if(!el) return;
      if(!zkLigado()){ el.textContent=''; el.className='cad-help zk-depor'; return; }
      var tab=0, anu=0;
      try{ tab=estRS('zkTabela'); }catch(_){}
      try{ anu=estRS('efAnuncio'); }catch(_){}
      if(!tab){ el.textContent=''; el.className='cad-help zk-depor'; return; }
      if(!anu){
        el.className='cad-help zk-depor zk-depor-aviso';
        el.textContent='Falta o Pre\u00e7o de an\u00fancio (mais abaixo) \u2014 \u00e9 ele o promocional. Sem ele o carro n\u00e3o aparece no site.';
        return;
      }
      if(anu>=tab){
        el.className='cad-help zk-depor';
        el.textContent='Sem promo\u00e7\u00e3o: o site vai mostrar '+_rsF(anu)+'.';
        return;
      }
      var d=tab-anu, pc=(d/tab*100);
      el.className='cad-help zk-depor zk-depor-ok';
      el.textContent='No site: de '+_rsF(tab)+' por '+_rsF(anu)+' \u2014 '+_rsF(d)+' de desconto ('+pc.toFixed(1).replace('.',',')+'%).';
    }catch(_){}
  }
  function _zkSeloPorChave(k){
    try{ return (_EX_DIF||[]).filter(function(d){ return d.k===k; })[0]||null; }catch(_){ return null; }
  }

  function zkWire(){
    try{
      var on=$('zkOn');
      /* 🔴 v1059 — ERA `estAutosave()`, QUE NÃO EXISTE NO PROJETO INTEIRO.
         A v1052 escreveu esse nome dentro de um try/catch; o try engolia o
         ReferenceError e ninguém via. Não virou defeito por sorte: o
         `estAutosaveWire` já ouve o `change` de todo input do painel, e o
         `#zkOn` é um input do painel. Mas era uma linha que MENTIA sobre o que
         fazia — e linha que mente é a próxima armadilha de quem vier ler. */
      if(on) on.onchange=function(){ zkAplicaNaTela(); zkDePorPinta(); try{ estAgendaSalvar(); }catch(_){} };
      try{ if(typeof zcWire==='function') zcWire(); }catch(_){}   /* v1059 */
      var bo=$('zkBonus'); if(bo && typeof estMaskRS==='function') bo.oninput=estMaskRS;
      /* v1090 — a tabela usa a MESMA máscara de dinheiro dos outros campos,
         e repinta o aviso a cada tecla. */
      var tb=$('zkTabela');
      if(tb) tb.oninput=function(){ try{ if(typeof estMaskRS==='function') estMaskRS.call(this); }catch(_){} zkDePorPinta(); };
      /* 🔴🔴 `addEventListener`, NÃO `oninput`. O `#efAnuncio` JÁ TEM um
         `oninput` posto pelo 14-estoque (máscara + cálculo da margem, linha
         1767). Escrever `.oninput=` aqui APAGARIA aquele — a margem pararia
         de calcular e ninguém ligaria uma coisa à outra. Ouvinte somado
         convive; atribuição substitui. */
      var an=$('efAnuncio');
      if(an && !an._zkLigado){ an._zkLigado=true; an.addEventListener('input', zkDePorPinta, false); }
      zkAplicaNaTela();
      zkDePorPinta();
    }catch(_){}
  }

  /* ==========================================================================
     O QUE VAI PRO BANCO
     --------------------------------------------------------------------------
     ⚠️ DESLIGADO, ESTE OBJETO É `{zero_km:false}` E MAIS NADA. Ele NÃO apaga
     o chassi nem os campos zk_* de um carro que já foi 0 km: quem fatura o
     carro desliga o interruptor, e o histórico de como ele chegou fica
     gravado. Apagar seria o app decidir jogar fora um dado que ninguém pediu
     pra jogar fora.
     ========================================================================== */
  function zkColeta(){
    var on=zkLigado();
    var o={ zero_km:on };
    /* 🔴🔴 v1059 — O CHASSI SAIU DA TELA, MAS NÃO PODE SAIR DO BANCO.
       Até a v1058 esta linha era:
           var ch=_zkV('zkChassi'); if(ch) o.chassi=ch;
       O Angelo pediu a tela do 0 km SEM chassi e SEM placa. Se a linha
       simplesmente sumisse, o próximo autosave de um carro que JÁ TEM chassi
       gravado (cadastrado entre a v1052 e a v1058) apagaria o chassi — este
       objeto é remontado do ZERO a cada tecla. É a armadilha "esconder não
       pode apagar dado" que a própria v1052 documentou, agora pelo lado da
       REMOÇÃO. Mesmo cuidado do `post_ia` (v177) e do `prerenave` (v442).
       ⚠️ Não se escreve chassi novo por aqui: só se preserva o que já existe. */
    try{
      var _za=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
      var _zx=(_za&&_za.extras)||{};
      if(_zx.chassi) o.chassi=_zx.chassi;
    }catch(_){}
    /* 🔴 v1059 — o rastro da importação da Cotação. Quem devolve é o
       `zcRef` (14n-), que também PRESERVA o que já está gravado quando esta
       ficha não importou nada agora. Fora do `if(!on)` de propósito: um carro
       que foi faturado e deixou de ser 0 km não perde a história de como
       entrou. */
    try{ if(typeof zcRef==='function'){ var _zr=zcRef(); if(_zr) o.cotacao_ref=_zr; } }catch(_){}
    if(!on) return o;
    o.zk_entrega=_zkV('zkEntrega')||'pronta';
    var pz=_zkN('zkPrazo'); if(o.zk_entrega==='faturar' && pz) o.zk_prazo=pz;
    var ga=_zkN('zkGarantia'); if(ga) o.zk_garantia_anos=ga;
    o.zk_venda=_zkV('zkVenda')||'varejo';
    /* v1090 — a tabela do novo. Mesma regra dos vizinhos: só grava se tiver
       valor, e só quando o interruptor está ligado (este trecho inteiro roda
       depois do `if(!on) return o`). Chave nova no `extras` jsonb — nenhuma
       coluna no banco, como toda a família `zk_` desde a v1052.
       ⚠️ O NOME `zk_tabela` É FECHADO A PARTIR DE AGORA: renomear depois
       deixa os carros já gravados em silêncio, porque o jsonb não reclama de
       chave que ninguém lê — ele devolve vazio. */
    try{ var tb=estRS('zkTabela'); if(tb) o.zk_tabela=tb; }catch(_){}
    try{ var b=estRS('zkBonus'); if(b) o.zk_bonus=b; }catch(_){}
    o.zk_taxa_zero=!!(($('zkTaxaZero')||{}).checked);
    var co=_zkV('zkCores'); if(co) o.zk_cores=co;
    return o;
  }

  /* ==========================================================================
     ⛳ A FIPE JÁ SABE, DESDE A v302 — aqui ela só OFERECE
     --------------------------------------------------------------------------
     A tabela FIPE devolve `AnoModelo = 32000` pra zero quilômetro, e o
     `fipeEhZeroKm()` já existe no 14-estoque desde a v302 pra impedir o app
     de escrever "ano 32000" na ficha. Então, quando a consulta responde 0 km,
     dá pra oferecer o interruptor em vez de deixar a pessoa procurar.

     🔴 OFERECE, NÃO LIGA. Ligar sozinho mudaria o cadastro sem ninguém pedir
     — e o carro poderia ser um usado cuja FIPE foi escolhida errada. Sugerir
     custa um toque; desfazer um cadastro que se ligou sozinho custa confiança.
     ========================================================================== */
  function zkSugerirPelaFipe(o){
    try{
      if(!o || !o.zero_km) return false;
      if(!zkPodeUsar()) return false;
      var el=$('zkOn'); if(!el || el.checked) return false;
      if(typeof toast==='function') toast('A FIPE respondeu 0 km — ligue "Veículo 0 km" no cadastro.');
      var sw=$('zkSwitch');
      if(sw){ sw.classList.add('zk-pisca'); setTimeout(function(){ try{ sw.classList.remove('zk-pisca'); }catch(_){} }, 2400); }
      return true;
    }catch(_){ return false; }
  }

/* ╔═══ src/app/14n-zero-km-cotacao.js ════════════════════════════════════ */
  /* ==========================================================================
     🔴🔴 v1059 — A PONTE ENTRE A COTAÇÃO (MEV TOOLS) E O CADASTRO DO 0 KM
     (PROJETO-2026-09-17-importar-cotacao-no-zero-km.txt, FASES 1 e 2)
     --------------------------------------------------------------------------
     Pedido do Angelo: "monta o projeto pra importar as informações do mevtools
     para o cadastro, sem chassi e sem placa".

     🔑 NÃO É IMPORTAR. É UM SELECT.
     A Cotação VW e o MEV Veículos moram NO MESMO banco Supabase — as tabelas
     `vw_*` da cotação e a `mp_estoque` do estoque são vizinhas de projeto.
     Então não há arquivo pra exportar, nada pra sincronizar, nada que fique
     velho: o app lê a tabela de preços ao vivo, com o mesmo cliente que ele
     já usa pra tudo. (O tradutor `MP_TAB` do 01-nucleo só põe o prefixo `mp_`
     nos nomes que estão na lista dele; `vw_modelos` não está, e passa direto.)

     🔑 POR QUE UM ARQUIVO NOVO, E NÃO MAIS LINHAS NO 14m-.
     O `14m-` é o FORMULÁRIO do 0 km, que é do MEV Veículos. Este aqui é a PONTE
     pra outro produto, e vai mudar quando a Cotação mudar. Motivos diferentes
     pra mudar = arquivos diferentes (a regra dos ~80 KB do CLAUDE.md, aplicada
     antes de doer). O montador cola `14n-` depois de `14m-` e antes do `15-`.

     🔴 A REGRA DO EGRESS, QUE NÃO PODE SER QUEBRADA.
     O Supabase estourou o egress no plano Free em 28/08 e o Angelo quer
     voltar pro Free. Então, aqui dentro:
       · NUNCA `select('*')`. Sempre a lista de colunas, nome por nome.
       · As colunas GORDAS são `ficha` e `vantagens` (a ficha do Polo Track
         sozinha passa de 2 KB de texto). Elas NÃO entram em nenhuma das três
         consultas desta versão — vêm numa quarta consulta, de UMA linha, na
         Versão B, e só quando a pessoa escolher a versão.
       · A lista de modelos/versões/cores é a MESMA pra todo mundo e muda uma
         vez por mês: fica guardada em memória pela sessão. Cadastrar o
         segundo carro não repete consulta nenhuma.

     🔑 COPIAR, NÃO AMARRAR. O `zcAplicar` grava os VALORES no cadastro, não
     uma referência viva. Se ficasse amarrado, o dia que a tabela de preços
     fosse atualizada mudaria o preço de carros já anunciados sem ninguém
     pedir. Junto com os valores vai o RASTRO (`extras.cotacao_ref`), que é o
     que permite, depois, dizer "a tabela agora está R$ 2.000 acima do que
     você cadastrou" sem mexer no anúncio por conta própria.
     ========================================================================== */

  /* ⚠️ GUARDADO POR SESSÃO, não por carro. Some quando o app fecha. */
  var _zcCache={ modelos:null, versoes:{}, cores:{}, taxa0:{}, ficha:{}, fotos:{}, precos:{} };
  /* o que está escolhido AGORA na tela (não vai pro banco; o que vai é o ref) */
  var _zcSel={ modelo:null, versao:null, cores:null, cor:null };
  /* o rastro da última importação feita nesta ficha (lido pelo zkColeta) */
  var _zcRef=null;

  /* 🔴 A GARANTIA DE FÁBRICA NÃO EXISTE COMO COLUNA NA COTAÇÃO.
     Ela só aparece escrita DENTRO das frases de venda ("Garantia Volkswagen
     3 anos"), e ler por texto erra calado. Perguntei ao Angelo e ele
     respondeu: "padrão 3 anos exceto amarok que é 5 anos". Então o número
     vem daqui, e não de um parser.
     ⚠️ ISTO É DADO DA MONTADORA, NÃO DA TABELA — ele envelhece em silêncio se
     a VW mudar a política. O campo continua editável na tela de propósito:
     o que este mapa faz é preencher, não travar. */
  var ZC_GARANTIA_PADRAO=3;
  var ZC_GARANTIA_POR_MODELO={ amarok:5 };

  function zcPodeUsar(){
    try{ return typeof zkPodeUsar==='function' && !!zkPodeUsar(); }catch(_){ return false; }
  }

  /* ==========================================================================
     MY26 → 2026, E A RECUSA HONESTA
     --------------------------------------------------------------------------
     ⚠️ O `model_year` é TEXTO e tem TRÊS formatos no banco hoje, contados na
     hora de escrever isto: "MY26", "MY27" e "2026" (já cheio). O projeto só
     previa o primeiro. Os três são aceitos.
     🔴 E QUALQUER OUTRA COISA DEVOLVE VAZIO. Escrever um ano inventado num
     cadastro que vira anúncio público é pior do que deixar a pessoa digitar:
     campo vazio se vê, ano errado ninguém percebe.
     ========================================================================== */
  function zcAnoModelo(my){
    var t=String(my==null?'':my).trim();
    var m=t.match(/^MY\s*(\d{2})$/i);
    if(m) return String(2000+parseInt(m[1],10));
    if(/^(19|20)\d{2}$/.test(t)) return t;
    return '';
  }

  function _zcNum(v){ var n=Number(v); return isFinite(n)?n:0; }
  function _zcTxt(v){ var s=String(v==null?'':v).trim(); return (s&&s!=='null')?s:''; }

  /* ---------- as consultas (colunas nomeadas, nunca `*`) ---------- */
  async function _zcPede(tabela,cols,montar){
    var q=supa.from(tabela).select(cols);
    q=montar(q);
    var r=await (typeof withTimeout==='function'?withTimeout(q,9000):q);
    if(r&&r.error) throw new Error(r.error.message||'erro');
    return (r&&r.data)||[];
  }
  async function zcModelosBuscar(){
    if(_zcCache.modelos) return _zcCache.modelos;
    var d=await _zcPede('vw_modelos','id,slug,nome,categoria,ordem',function(q){
      return q.eq('ativo',true).order('ordem',{ascending:true});
    });
    _zcCache.modelos=d; return d;
  }
  async function zcVersoesBuscar(mid){
    if(_zcCache.versoes[mid]) return _zcCache.versoes[mid];
    var d=await _zcPede('vw_versoes','id,slug,nome,nome_curto,model_code,model_year,base_price,transmissao,combustivel,subtitulo,bonus_varejo,bonus_go40,ordem,capa_url,ficha',function(q){
      return q.eq('modelo_id',mid).eq('ativa',true).order('ordem',{ascending:true});
    });
    _zcCache.versoes[mid]=d; return d;
  }
  async function zcCoresBuscar(vid){
    if(_zcCache.cores[vid]) return _zcCache.cores[vid];
    var d=await _zcPede('vw_cores','codigo,nome,tipo,hex,preco_adicional,ordem',function(q){
      return q.eq('versao_id',vid).eq('ativa',true).order('ordem',{ascending:true});
    });
    _zcCache.cores[vid]=d; return d;
  }
  /* ==========================================================================
     🔴 v-NOVOS-PRECO — O PREÇO VAREJO E CORPORATIVO (view vw_novos_precos)
     --------------------------------------------------------------------------
     A view mora no MESMO banco e devolve, por versão×cor, o preço de varejo
     (ação vigente + margem 5%) e o corporativo (ação corp + 2% comissão), já
     arredondados em 900 — as MESMAS contas do feed do Meta. Só leitura, uma
     linha, e cacheada por versão+cor na sessão. Copiar, não amarrar: o botão
     só ESCREVE o número no anúncio; nada fica preso à tabela.
     ========================================================================== */
  async function zcPrecosBuscar(vid,cod){
    var k=String(vid)+'|'+String(cod||'');
    if(_zcCache.precos[k]!=null) return _zcCache.precos[k];
    var r=null;
    try{
      var d=await _zcPede('vw_novos_precos','preco_publico,preco_varejo,preco_corp',function(q){
        return q.eq('versao_id',vid).eq('cor_codigo',cod).limit(1);
      });
      r=(d&&d[0])||null;
    }catch(_){ r=null; }
    _zcCache.precos[k]=r; return r;
  }
  /* mostra os dois preços como botões; clicar preenche o campo de anúncio */
  async function zcPrecosOferecer(v,c){
    var box=$('zcPrecos'); if(!box) return;
    box.innerHTML='<div class="zc-vazio">calculando varejo e corporativo…</div>';
    var p=await zcPrecosBuscar(v.id,_zcTxt(c.codigo));
    if(!p){ box.innerHTML=''; return; }
    var vj=_zcNum(p.preco_varejo), cp=_zcNum(p.preco_corp), pb=_zcNum(p.preco_publico);
    box.innerHTML='<div class="zc-passo"><span class="zc-p-n">$</span><b>Preço para o anúncio</b></div>'+
      '<div class="cad-help" style="margin:2px 0 6px">Tabela '+esc(_rs(pb))+' — toque para preencher o anúncio (você ainda pode ajustar).</div>'+
      '<div class="zc-chips">'+
        (vj>0?'<button type="button" class="zc-chip zc-preco-op" data-zp="varejo"><span>Varejo · '+esc(_rs(vj))+'</span></button>':'')+
        (cp>0?'<button type="button" class="zc-chip zc-preco-op" data-zp="corp"><span>Corporativo · '+esc(_rs(cp))+'</span></button>':'')+
      '</div>';
    Array.prototype.forEach.call(box.querySelectorAll('[data-zp]'),function(b){
      b.onclick=function(){
        var val=(b.getAttribute('data-zp')==='corp')?cp:vj;
        if(val>0){
          _zcSet('efAnuncio',_rs(val));
          Array.prototype.forEach.call(box.querySelectorAll('[data-zp]'),function(x){ x.classList.remove('on'); });
          b.classList.add('on');
          try{ estAgendaSalvar(); }catch(_){}
        }
      };
    });
  }
  /* ⛳ a taxa zero é uma PERGUNTA de existência, não uma lista: pede só o
     `cond_id` de UMA linha com taxa 0. É a consulta mais barata possível. */
  async function zcTaxaZeroBuscar(vid){
    if(_zcCache.taxa0[vid]!=null) return _zcCache.taxa0[vid];
    var ok=false;
    try{
      var d=await _zcPede('vw_condicoes','cond_id',function(q){
        return q.eq('versao_id',vid).eq('ativa',true).eq('taxa_mensal',0).limit(1);
      });
      ok=!!(d&&d.length);
    }catch(_){ ok=false; }
    _zcCache.taxa0[vid]=ok; return ok;
  }

  /* ---------- a tela ---------- */
  function zcBlocoHtml(){
    return '<div class="zc-box" id="zcBox">'+
      '<button type="button" class="zc-h" id="zcAbrir" aria-expanded="false" aria-controls="zcCorpo">'+
        '<span class="zc-h-t"><b>Trazer da Cotação</b>'+
        '<small>Modelo, versão e cor — o cadastro nasce preenchido</small></span>'+
        '<span class="zc-h-x" aria-hidden="true">+</span>'+
      '</button>'+
      '<div class="zc-corpo" id="zcCorpo" hidden>'+
        '<div class="zc-passo"><span class="zc-p-n">1</span><b>Modelo</b></div>'+
        '<div class="zc-chips" id="zcModelos"><span class="zc-vazio">carregando…</span></div>'+
        '<div class="zc-passo"><span class="zc-p-n">2</span><b>Versão</b></div>'+
        '<div class="zc-chips" id="zcVersoes"><span class="zc-vazio">escolha o modelo</span></div>'+
        '<div class="zc-passo"><span class="zc-p-n">3</span><b>Cor</b></div>'+
        '<div class="zc-chips" id="zcCores"><span class="zc-vazio">escolha a versão</span></div>'+
        '<div class="zc-msg" id="zcMsg"></div>'+
        '<div class="zc-precos" id="zcPrecos"></div>'+
        '<div class="zc-fotos" id="zcFotos"></div>'+
        '<button type="button" class="zc-ok" id="zcAplicarBt" disabled>Preencher o cadastro</button>'+
        '<p class="cad-help">Preenche marca, modelo, ano, cor, combustível, câmbio, garantia, bônus e cores disponíveis — e sugere o preço de tabela. Você confere e ajusta o que quiser: nada fica amarrado à tabela.</p>'+
      '</div>'+
    '</div>';
  }

  function _zcMsg(txt,tipo){
    var el=$('zcMsg'); if(!el) return;
    el.className='zc-msg'+(tipo?(' '+tipo):'');
    el.innerHTML=txt?esc(txt):'';
  }
  function _zcChips(id,itens,rotulo,extra){
    var box=$(id); if(!box) return;
    if(!itens||!itens.length){ box.innerHTML='<span class="zc-vazio">nada aqui</span>'; return; }
    box.innerHTML=itens.map(function(x,i){
      return '<button type="button" class="zc-chip" data-i="'+i+'">'+
        (extra?extra(x):'')+'<span>'+esc(rotulo(x))+'</span></button>';
    }).join('');
  }
  function _zcMarcar(id,i){
    try{
      Array.prototype.forEach.call(($(id)||document.createElement('div')).querySelectorAll('.zc-chip'),function(b){
        b.classList.toggle('on', String(b.getAttribute('data-i'))===String(i));
      });
    }catch(_){}
  }
  function _zcPronto(){
    var bt=$('zcAplicarBt'); if(!bt) return;
    bt.disabled=!(_zcSel.versao&&_zcSel.cor);
  }

  async function zcModelos(){
    try{
      var ms=await zcModelosBuscar();
      _zcChips('zcModelos',ms,function(m){ return m.nome; });
      var box=$('zcModelos'); if(!box) return;
      Array.prototype.forEach.call(box.querySelectorAll('.zc-chip'),function(b){
        b.onclick=function(){
          var m=ms[parseInt(b.getAttribute('data-i'),10)]; if(!m) return;
          _zcSel.modelo=m; _zcSel.versao=null; _zcSel.cor=null; _zcSel.cores=null;
          _zcMarcar('zcModelos',b.getAttribute('data-i'));
          _zcMsg(''); _zcPronto();
          var cv=$('zcCores'); if(cv) cv.innerHTML='<span class="zc-vazio">escolha a versão</span>';
          zcVersoes(m.id);
        };
      });
    }catch(e){
      var bx=$('zcModelos'); if(bx) bx.innerHTML='<span class="zc-vazio">não consegui ler a tabela</span>';
      _zcMsg('Não consegui falar com a Cotação agora. Você pode preencher à mão normalmente.','err');
    }
  }
  async function zcVersoes(mid){
    var box=$('zcVersoes'); if(box) box.innerHTML='<span class="zc-vazio">carregando…</span>';
    try{
      var vs=await zcVersoesBuscar(mid);
      _zcChips('zcVersoes',vs,function(v){
        return _zcTxt(v.nome_curto)||_zcTxt(v.nome);
      },function(v){
        var p=_zcNum(v.base_price);
        return p?('<i class="zc-preco">'+esc(_rs(p))+'</i>'):'';
      });
      box=$('zcVersoes'); if(!box) return;
      Array.prototype.forEach.call(box.querySelectorAll('.zc-chip'),function(b){
        b.onclick=function(){
          var v=vs[parseInt(b.getAttribute('data-i'),10)]; if(!v) return;
          _zcSel.versao=v; _zcSel.cor=null; _zcSel.cores=null;
          _zcMarcar('zcVersoes',b.getAttribute('data-i'));
          _zcMsg(''); _zcPronto();
          zcCores(v.id);
        };
      });
    }catch(e){
      if(box) box.innerHTML='<span class="zc-vazio">não consegui ler as versões</span>';
      _zcMsg('Não consegui ler as versões agora.','err');
    }
  }
  async function zcCores(vid){
    var box=$('zcCores'); if(box) box.innerHTML='<span class="zc-vazio">carregando…</span>';
    try{
      var cs=await zcCoresBuscar(vid);
      _zcSel.cores=cs;
      _zcChips('zcCores',cs,function(c){
        var a=_zcNum(c.preco_adicional);
        return _zcTxt(c.nome)+(a?(' +'+_rs(a)):'');
      },function(c){
        var hx=_zcTxt(c.hex);
        return '<i class="zc-bolinha" style="background:'+(/^#[0-9a-f]{3,8}$/i.test(hx)?hx:'#ccc')+'"></i>';
      });
      box=$('zcCores'); if(!box) return;
      Array.prototype.forEach.call(box.querySelectorAll('.zc-chip'),function(b){
        b.onclick=function(){
          var c=cs[parseInt(b.getAttribute('data-i'),10)]; if(!c) return;
          _zcSel.cor=c;
          _zcMarcar('zcCores',b.getAttribute('data-i'));
          _zcMsg(''); _zcPronto();
        };
      });
    }catch(e){
      if(box) box.innerHTML='<span class="zc-vazio">não consegui ler as cores</span>';
      _zcMsg('Não consegui ler as cores agora.','err');
    }
  }

  /* ==========================================================================
     🔑 O QUE O BOTÃO ESCREVE NO CADASTRO
     --------------------------------------------------------------------------
     ⚠️ DINHEIRO ENTRA JÁ MASCARADO. O `estRS`/`_rsLer` lê o texto "R$ 1.234,56"
     de volta; cravar o número cru faria o campo valer R$ 12,34. É por isso
     que aqui se usa `_rs(valor)`, exatamente como o importador de anúncio faz
     desde a v199 — não se inventou caminho novo pro dinheiro.
     ⚠️ E O AUTOSAVE É CHAMADO UMA VEZ SÓ, no fim. Um por campo seriam doze
     gravações em sequência.
     🔴 O NOME CERTO DA FUNÇÃO É `estAgendaSalvar`. A v1052 escreveu
     `estAutosave()` dentro de um try/catch no `zkWire` — função que NÃO
     EXISTE em lugar nenhum do projeto. O try engolia o erro e ninguém via.
     Não chegou a virar defeito só porque o `estAutosaveWire` já ouve o
     evento `change` de todo input do painel; mas era uma linha que mentia,
     e foi corrigida junto nesta versão.
     ========================================================================== */
  function _zcSet(id,valor){
    try{ var el=$(id); if(!el) return; el.value=(valor==null?'':String(valor)); }catch(_){}
  }
  function zcGarantiaDe(modelo){
    try{
      var s=String((modelo&&modelo.slug)||'').toLowerCase();
      if(Object.prototype.hasOwnProperty.call(ZC_GARANTIA_POR_MODELO,s)) return ZC_GARANTIA_POR_MODELO[s];
    }catch(_){}
    return ZC_GARANTIA_PADRAO;
  }
  function zcAplicar(){
    var m=_zcSel.modelo, v=_zcSel.versao, c=_zcSel.cor;
    if(!v||!c){ _zcMsg('Escolha modelo, versão e cor primeiro.','err'); return false; }

    var preco=_zcNum(v.base_price)+_zcNum(c.preco_adicional);
    var ano=zcAnoModelo(v.model_year);

    _zcSet('efMarca','VW');
    _zcSet('efModelo',((m&&_zcTxt(m.nome))?(_zcTxt(m.nome)+' '):'')+(_zcTxt(v.nome_curto)||_zcTxt(v.nome)));
    if(ano) _zcSet('efAnoMod',ano);
    _zcSet('efCor',_zcTxt(c.nome));
    if(_zcTxt(v.combustivel)) _zcSet('efCombustivel',_zcTxt(v.combustivel));
    /* ⚠️ a `transmissao` vem NULA em pelo menos uma versão do banco. Campo
       vazio o Angelo preenche; a palavra "null" no câmbio sairia no anúncio. */
    if(_zcTxt(v.transmissao)) _zcSet('efCambio',_zcTxt(v.transmissao));
    _zcSet('efKm','0');
    if(preco>0) _zcSet('efAnuncio',_rs(preco));

    /* o bloco do 0 km */
    _zcSet('zkGarantia',String(zcGarantiaDe(m)));
    /* 🔴 NÃO SOMAR bonus_varejo COM bonus_go40. São políticas diferentes
       (varejo × Go40/frotista) e somar inventa um desconto que não existe.
       O Go40 sai como AVISO ao lado, e só. */
    var bv=_zcNum(v.bonus_varejo), bg=_zcNum(v.bonus_go40);
    if(bv>0) _zcSet('zkBonus',_rs(bv));
    if(_zcSel.cores&&_zcSel.cores.length){
      _zcSet('zkCores',_zcSel.cores.map(function(x){ return _zcTxt(x.nome); }).filter(Boolean).join(', '));
    }

    /* 🔑 O RASTRO. Copiar, não amarrar — ver o cabeçalho deste arquivo. */
    _zcRef={
      versao_id:v.id, cor_codigo:_zcTxt(c.codigo), model_code:_zcTxt(v.model_code),
      model_year:_zcTxt(v.model_year), base_price_na_hora:_zcNum(v.base_price),
      cor_adicional_na_hora:_zcNum(c.preco_adicional), quando:new Date().toISOString()
    };

    /* ==========================================================================
       O QUE CHEGA DEPOIS (taxa zero, ficha técnica e frases de venda)
       --------------------------------------------------------------------------
       ⚠️ As três coisas dependem de consulta, e por isso vieram DEPOIS dos
       campos: o Angelo vê o cadastro preenchido na hora e o resto entra sozinho
       um instante depois, em vez de a tela ficar parada esperando.
       ⚠️ E é UM bloco só, com UM autosave no fim — três blocos separados
       seriam três gravações em sequência.
       ========================================================================== */
    (async function(){
      var mudou=false, extra=[];
      try{
        var tz=await zcTaxaZeroBuscar(v.id);
        var el=$('zkTaxaZero');
        if(el && tz && !el.checked){
          el.checked=true;
          var lab=el.parentElement; if(lab&&lab.classList) lab.classList.add('on');
          mudou=true;
        }
      }catch(_){}
      try{
        var lin=await zcFichaBuscar(v.id);
        if(lin && lin.ficha && typeof lin.ficha==='object'){
          var conv=zcFichaConverter(lin.ficha,{
            marca_modelo:'VW '+((m&&_zcTxt(m.nome))?(_zcTxt(m.nome)+' '):'')+(_zcTxt(v.nome_curto)||_zcTxt(v.nome)),
            versao:_zcTxt(v.nome_curto)||_zcTxt(v.nome),
            ano_modelo:ano, cor:_zcTxt(c.nome), segmento:_zcTxt(m&&m.categoria),
            combustivel:_zcTxt(v.combustivel), versao_id:v.id
          });
          /* 🔑 gravar a ficha É o que faz o botão "Gerar ficha por IA"
             (1 token por carro) parar de ser oferecido — o `estFichaBox` só o
             mostra quando o `fichaTecObter` devolve nada. */
          try{
            var ref=(typeof _ftRefAtual==='function')?_ftRefAtual():'';
            if(ref){ fichaTecGuardar(ref,conv); mudou=true;
              if($('efFichaBox') && typeof estFichaBox==='function') estFichaBox(); }
          }catch(_){}
          if(conv._zcSobrou && conv._zcSobrou.length){
            extra.push('a Cotação trouxe '+conv._zcSobrou.join(', ')+', que esta ficha não tem onde mostrar');
          }
        }
        /* ⚠️ AS FRASES DE VENDA SÓ ENTRAM SE O CAMPO ESTIVER VAZIO. Elas são
           SUGESTÃO da montadora; o que o Angelo escreveu é dele e não se
           sobrescreve por conta própria. */
        var dst=$('exDest');
        if(dst && !String(dst.value||'').trim() && Array.isArray(lin&&lin.vantagens)){
          var frases=lin.vantagens.map(_zcTxt).filter(Boolean);
          if(frases.length){ dst.value=frases.join(' · '); mudou=true; }
        }
      }catch(_){}
      /* -------- as fotos oficiais (v1061) -------- */
      try{
        var cx=$('zcFotos'); if(cx) cx.innerHTML='<div class="zc-vazio">procurando as fotos oficiais…</div>';
        var todas=await zcFotosBuscar(v.id);
        var daCor=zcFotosDaCor(todas,c.codigo);
        var extras=zcFotosExtras(todas);
        var n=zcFotosAcrescentar(daCor.map(function(f){ return f.url; }));
        if(n) mudou=true;
        if(cx){
          if(!todas.length){
            cx.innerHTML='<div class="zc-aviso">Esta versão ainda não tem foto na Cotação — use as suas.</div>';
          } else if(!daCor.length){
            /* ⚠️ A VERSÃO TEM FOTO, MAS NÃO NESTA COR. Dizer as duas coisas é
               diferente de dizer "não tem foto": o Angelo pode escolher outra
               cor, ou saber que precisa fotografar esta. Silêncio aqui seria
               ele achando que o app falhou. */
            cx.innerHTML='<div class="zc-aviso">A Cotação tem fotos desta versão, mas nenhuma da cor <b>'+esc(_zcTxt(c.nome))+'</b> — use as suas.</div>'
              + _zcExtrasHtml(extras);
          } else {
            /* 🔴🔴 IMPORTAR FOTO É O QUE PÕE O CARRO NO AR. A regra do
               `publico_vitrine()` é "tem ao menos 1 foto E preco_anuncio > 0",
               e este botão preenche os dois. É o que o Angelo pediu — mas tem
               que estar ESCRITO, e não ser efeito colateral que ele descobre
               vendo o carro no site. */
            cx.innerHTML='<div class="zc-ok">'+n+' foto'+(n===1?'':'s')+' oficia'+(n===1?'l':'is')+' d'+(n===1?'a':'as')+' cor <b>'+esc(_zcTxt(c.nome))+'</b> entr'+(n===1?'ou':'aram')+' no cadastro. '+
              '<b>Com o preço preenchido, este carro já aparece no seu site</b> — tire as fotos que não quiser antes de sair da tela.</div>'
              + _zcExtrasHtml(extras);
          }
          _zcExtrasLigar(extras);
        }
      }catch(_){
        var cy=$('zcFotos');
        if(cy) cy.innerHTML='<div class="zc-aviso">Não consegui buscar as fotos agora — o resto do cadastro está preenchido.</div>';
      }
      /* -------- os preços varejo e corporativo (view vw_novos_precos) -------- */
      try{ await zcPrecosOferecer(v,c); }catch(_){}
      if(extra.length){
        var el2=$('zcMsg');
        if(el2) el2.innerHTML=esc(String(el2.textContent||'').trim()+' '+extra.join(' · ')+'.');
      }
      if(mudou){ try{ estAgendaSalvar(); }catch(_){} }
    })();

    var avisos=[];
    if(!ano) avisos.push('o ano modelo veio como "'+_zcTxt(v.model_year)+'" e eu não sei traduzir isso — digite à mão');
    if(bg>0) avisos.push('esta versão tem bônus Go40 de '+_rs(bg)+' (frotista) — NÃO somei com o varejo');
    if(!_zcTxt(v.transmissao)) avisos.push('esta versão está sem câmbio na tabela da Cotação');
    _zcMsg(avisos.length
      ? ('Preenchido. Confira: '+avisos.join(' · ')+'.')
      : 'Preenchido. O preço é o de tabela — ajuste para o que você vai anunciar.',
      avisos.length?'av':'ok');

    try{ zkAplicaNaTela(); }catch(_){}
    try{ estAgendaSalvar(); }catch(_){}
    return true;
  }

  /* ==========================================================================
     O RASTRO NO BANCO
     --------------------------------------------------------------------------
     ⚠️ MESMO CUIDADO DO `post_ia` (v177) E DO `prerenave` (v442): o `extras` é
     remontado do ZERO a cada autosave. Sem preservar, digitar qualquer letra
     no cadastro apagaria o rastro da importação.
     ========================================================================== */
  function zcRef(){
    if(_zcRef) return _zcRef;
    try{
      var a=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
      var x=(a&&a.extras)||{};
      if(x.cotacao_ref) return x.cotacao_ref;
    }catch(_){}
    return null;
  }

  function zcWire(){
    try{
      _zcSel={ modelo:null, versao:null, cores:null, cor:null };
      _zcRef=null;   /* ficha nova: o rastro volta a sair do registro salvo */
      try{ var cf=$('zcFotos'); if(cf) cf.innerHTML=''; }catch(_){}
      try{ var cpp=$('zcPrecos'); if(cpp) cpp.innerHTML=''; }catch(_){}
      var ab=$('zcAbrir'), co=$('zcCorpo');
      if(ab&&co){
        ab.onclick=function(){
          var fechado=co.hasAttribute('hidden');
          if(fechado){ co.removeAttribute('hidden'); ab.setAttribute('aria-expanded','true'); zcModelos(); }
          else { co.setAttribute('hidden',''); ab.setAttribute('aria-expanded','false'); }
          var x=ab.querySelector('.zc-h-x'); if(x) x.textContent=fechado?'−':'+';
        };
      }
      var bt=$('zcAplicarBt'); if(bt) bt.onclick=function(){ zcAplicar(); };
    }catch(_){}
  }

  /* ==========================================================================
     🔴🔴 v1060 (Versão B) — A FICHA TÉCNICA DA MONTADORA
     --------------------------------------------------------------------------
     A Cotação guarda uma `ficha` por versão, escrita a partir do catálogo
     oficial da VW. O estoque guarda uma `ficha_tec` no formato do provedor de
     consulta. São formatos DIFERENTES — daí o conversor.

     🔑 A COISA QUE ECONOMIZA DINHEIRO, e é o motivo desta fase existir:
     hoje, sem ficha, a aba Ficha oferece "Gerar ficha por IA" por 1 token POR
     CARRO. Pagar pra uma IA pesquisar na web um dado que já está em casa — e
     pior do que o que está em casa, porque o catálogo da montadora é a fonte
     — é dinheiro no lixo. Gravando a ficha convertida, o botão simplesmente
     não é oferecido (o `estFichaBox` só o mostra quando `fichaTecObter`
     devolve nada). Não precisou de flag nenhuma.

     🔴🔴 E TEM UM SEGUNDO GASTO, QUE EU SÓ VI LENDO O `_ftPrecisaIA`:
     quando a ficha tem buracos (4+ campos vazios em desempenho, por exemplo),
     o app dispara SOZINHO uma pesquisa de IA pra completar — de graça em
     token, mas é chamada de servidor toda vez que a ficha abre. A ficha da
     Cotação TEM buracos de propósito (não há consumo, peso, freios nem
     suspensão no catálogo comercial). O `_ftPrecisaIA` tem uma saída na
     primeira linha: `if(p.raw && p.raw._ia) return false;`. Por isso o `_ia`
     é gravado — ele diz "esta ficha já tem origem declarada, não vá procurar".

     ⚠️ MAS O `_ia` TAMBÉM ACENDE UM AVISO NA TELA que diz "Ficha pesquisada
     por IA". Isso seria MENTIRA aqui. Por isso o `14-estoque.js` ganhou um
     terceiro caso no aviso, pra ficha cuja origem é `cotacao-mevtools`.

     ⚠️ E A REGRA DO PASSO 0.4 DO PROJETO: só se escreve chave que a TELA LÊ.
     A lista abaixo saiu de ler o `fichaTecParse` (03-ficha-tecnica.js), não
     de imaginação. Chave que ninguém lê o jsonb aceita calado, e aí a ficha
     fica "quase" certa pra sempre.
     ========================================================================== */

  /* as chaves da `ficha` da Cotação que este conversor SABE ler. O que não
     estiver aqui é reportado na tela em vez de sumir em silêncio. */
  var ZC_FT_CONHECIDAS={motor:1,torque:1,aceleracao:1,cambio:1,direcao:1,dimensoes:1,
    entreEixos:1,tanque:1,portaMalas:1,destaques:1,seguranca:1,multimidia:1,
    rodas:1,bancos:1,cargaUtil:1,arCondicionado:1,iluminacao:1,edicao:1,anoModelo:1};
  /* estas quebram no MEIO-PONTO e viram uma linha de equipamento cada.
     ⚠️ O separador é " · " (U+00B7), NUNCA vírgula: as frases têm vírgula
     dentro ("pneus 185/65 R15, liga leve") e quebrar na vírgula picaria os
     itens errado. */
  var ZC_FT_EQ_LISTA=['destaques','seguranca','multimidia'];
  /* estas viram UMA linha, com rótulo — a tela não tem campo próprio pra elas,
     e o quadro de equipamentos é uma lista de descrições, que é o que são. */
  var ZC_FT_EQ_LINHA=[['rodas','Rodas'],['bancos','Bancos'],['cargaUtil','Carga útil'],
    ['arCondicionado','Ar-condicionado'],['iluminacao','Iluminação'],['edicao','Edição']];

  /* ---------- tirar número de texto, sem inventar ---------- */
  /* "2.566 mm" → "2566" · o ponto é separador de milhar em pt-BR */
  function _zcMm(txt){
    var m=String(txt==null?'':txt).match(/([0-9][0-9.]*)\s*mm/i);
    return m?m[1].replace(/\./g,''):'';
  }
  /* "50 L" → "50" · "300 L (VDA) / 365 L (máx.)" → "300" (o primeiro é o VDA,
     que é a medida padrão; o segundo é com o banco rebatido) */
  function _zcLitros(txt){
    var m=String(txt==null?'':txt).match(/([0-9][0-9.]*)\s*L\b/);
    return m?m[1].replace(/\./g,''):'';
  }
  /* "4.079 × 1.751 × 1.471 mm" → ['4079','1751','1471'] */
  function _zcDims(txt){
    var s=String(txt==null?'':txt).replace(/\s*mm\s*$/i,'');
    var p=s.split(/\s*[×x]\s*/).map(function(x){
      var m=String(x).match(/([0-9][0-9.]*)/); return m?m[1].replace(/\./g,''):'';
    }).filter(Boolean);
    return p.length===3?p:[];
  }
  /* devolve [{v:'10,3',c:'Etanol'|'Gasolina'|''}] pra "10,3 kgfm (E) / 9,4 kgfm (G)" */
  function _zcMed(txt,uni){
    var s=String(txt==null?'':txt), out=[], m;
    var re=new RegExp('([0-9]+(?:[.,][0-9]+)?)\\s*'+uni+'\\b\\s*(?:\\(\\s*([EG])\\s*\\))?','gi');
    while((m=re.exec(s))){
      out.push({ v:m[1], c: m[2] ? (m[2].toUpperCase()==='E'?'Etanol':'Gasolina') : '' });
      if(out.length>=6) break;
    }
    return out;
  }

  /* ==========================================================================
     O CONVERSOR
     --------------------------------------------------------------------------
     ⚠️ A TELA COLA A UNIDADE SOZINHA. O `fichaTecParse` monta "10,3" + " kgfm".
     Se eu gravasse o texto da Cotação inteiro ("10,3 kgfm (E) / 9,4 kgfm (G)")
     sairia "…(G) kgfm" na tela do Angelo. Por isso cada medida entra só com o
     NÚMERO.
     ⚠️ E CARRO FLEX TEM DUAS MEDIÇÕES. O `_duo` do 03- já sabe desenhar
     "10,3 kgfm (etanol) · 9,4 kgfm (gasolina)" quando há duas entradas em
     `medicao_combustivel` — é pra isso que ele existe. Quando o valor é ÚNICO
     num ficha flex (o torque do Polo Sense, por exemplo), ele vale pros dois,
     e é isso que se grava: o mesmo número nas duas entradas.
     ========================================================================== */
  function zcFichaConverter(ficha,ctx){
    ficha=ficha||{}; ctx=ctx||{};
    var tudo=[ficha.motor,ficha.torque,ficha.aceleracao].join(' ');
    var flex=/\(\s*E\s*\)/.test(tudo) && /\(\s*G\s*\)/.test(tudo);
    var med = flex
      ? [{combustivel:'Etanol'},{combustivel:'Gasolina'}]
      : [{combustivel:_zcTxt(ctx.combustivel)}];

    function _por(txt,uni,campo){
      var l=_zcMed(txt,uni); if(!l.length) return;
      if(!flex){ med[0][campo]=l[0].v; return; }
      var e=null,g=null;
      l.forEach(function(x){ if(x.c==='Etanol'&&!e)e=x; if(x.c==='Gasolina'&&!g)g=x; });
      if(e||g){ if(e) med[0][campo]=e.v; if(g) med[1][campo]=g.v; }
      else { med[0][campo]=l[0].v; med[1][campo]=l[0].v; }   /* vale pros dois */
    }
    _por(ficha.motor,'cv','potencia');
    _por(ficha.torque,'kgfm','torque');
    _por(ficha.aceleracao,'s','tempo_zero_a_cem');
    _por(ficha.aceleracao,'km\\/h','velocidade_maxima');

    var medidas={}, dm=_zcDims(ficha.dimensoes);
    if(dm.length===3){ medidas.comprimento=dm[0]; medidas.largura=dm[1]; medidas.altura=dm[2]; }
    var ee=_zcMm(ficha.entreEixos);      if(ee) medidas.entre_eixos=ee;
    var tq=_zcLitros(ficha.tanque);      if(tq) medidas.tanque_combustivel=tq;
    var pm=_zcLitros(ficha.portaMalas);  if(pm) medidas.porta_malas=pm;

    var equip=[];
    ZC_FT_EQ_LISTA.forEach(function(k){
      String(ficha[k]||'').split('·').forEach(function(x){
        var t=_zcTxt(x); if(t) equip.push({descricao:t, disponibilidade:'SERIE'});
      });
    });
    ZC_FT_EQ_LINHA.forEach(function(p){
      var t=_zcTxt(ficha[p[0]]); if(t) equip.push({descricao:p[1]+': '+t, disponibilidade:'SERIE'});
    });

    var ft={
      marca_modelo:_zcTxt(ctx.marca_modelo),
      versao:_zcTxt(ctx.versao),
      ano_modelo:_zcTxt(ctx.ano_modelo),
      cor_veiculo:_zcTxt(ctx.cor),
      segmento:_zcTxt(ctx.segmento),
      motor:_zcTxt(ficha.motor),
      cambio:_zcTxt(ficha.cambio),
      direcao:_zcTxt(ficha.direcao),
      medidas:medidas,
      medicao_combustivel:med,
      equipamentos:equip,
      /* 🔑 a origem declarada: ela é o que impede o app de sair pesquisando
         sozinho (`_ftPrecisaIA`) uma ficha que já veio da fonte certa. */
      _ia:{ fonte:'cotacao-mevtools', versao_id:_zcTxt(ctx.versao_id),
            quando:new Date().toISOString(), campos:[] }
    };
    /* ⚠️ o que a Cotação trouxe e esta tela não tem onde mostrar. Não some em
       silêncio: vira aviso. Chave nova na Cotação aparece aqui no dia seguinte. */
    var sobrou=Object.keys(ficha).filter(function(k){ return !ZC_FT_CONHECIDAS[k]; });
    return { ficha_tecnica_veicular:ft, _zcSobrou:sobrou };
  }

  /* a quarta consulta: UMA linha, e só quando o botão é apertado.
     ⛳ O projeto dizia "quando a pessoa escolhe a versão". Apertar o botão é
     ainda mais tarde e mais barato: quem fica navegando entre versões pra
     comparar preço não puxa 2 KB de texto a cada toque. */
  async function zcFichaBuscar(vid){
    if(_zcCache.ficha[vid]) return _zcCache.ficha[vid];
    var d=await _zcPede('vw_versoes','ficha,vantagens',function(q){
      return q.eq('id',vid).limit(1);
    });
    var r=(d&&d[0])||null; _zcCache.ficha[vid]=r; return r;
  }

  /* ==========================================================================
     🔴🔴 v1061 (Versão C) — AS FOTOS OFICIAIS DA MONTADORA
     --------------------------------------------------------------------------
     🔑 DE ONDE ELAS VÊM, E POR QUE NÃO É DE UM ARQUIVO.
     As 668 fotos moravam num `.js` do site da Cotação. Trazer aquele arquivo
     pro app custaria 75 KB por sessão E jogaria pro navegador um problema que
     não é dele: casar o nome da versão do catálogo com o slug do banco. São
     dois vocabulários que se PARECEM e não são iguais — medido, não suposto:
         jetta:  banco `gli-350-tsi`      · catálogo `gli`
         tiguan: banco `r-line-350-tsi`   · catálogo `r-line`
         virtus: banco `tsi`              · catálogo `tsi_at`
         virtus: banco "Prata Sírius"     · catálogo "Prata Sirius"
         taos:   banco "…com teto preto"  · catálogo "…c/ teto preto"
     Com igualdade crua, 41 dos 78 pares (versão × cor) achavam foto. Com o
     casamento certo, 64. Jetta, Tiguan e Virtus TSI ficariam com ZERO — e em
     silêncio, que é o pior jeito de ficar errado.

     ✅ Então o casamento foi feito UMA vez, fora do app, e o resultado mora
     numa tabela `vw_fotos` do MESMO banco (ver sql/sql-v1061-*.sql). Aqui o
     app só PERGUNTA as fotos daquela versão — uns poucos KB.

     ⚠️ E NADA DE MONTAR NOME DE ARQUIVO POR PADRÃO (o projeto avisava, e com
     razão: existem três convenções de nome no disco). O que se fez foi o
     contrário — LER o código da cor de dentro do nome que já existe:
     "BZ3SK3_B4B4_f1.jpeg" → B4B4, que é o `vw_cores.codigo`. Foi assim que
     415 das 668 casaram.
     ========================================================================== */

  /* 🔴 A DIFERENÇA QUE IMPORTA, e ela é sutil:
       · foto SEM COR DE VERDADE (interior, detalhe) → cor_codigo E cor_texto nulos
       · foto cuja cor NÃO CASOU com o banco         → cor_codigo nulo, cor_texto CHEIO
     A segunda NÃO pode ser tratada como "serve pra qualquer cor" — senão a
     "Cinza Ascot" do Tiguan (8 fotos) apareceria num carro Branco. */
  function _zcFotoSemCor(f){ return !f.cor_codigo && !_zcTxt(f.cor_texto); }

  async function zcFotosBuscar(vid){
    if(_zcCache.fotos[vid]) return _zcCache.fotos[vid];
    var d=await _zcPede('vw_fotos','url,tipo,cor_codigo,cor_texto,ordem',function(q){
      return q.eq('versao_id',vid).order('ordem',{ascending:true});
    });
    _zcCache.fotos[vid]=d; return d;
  }

  /* as que entram SOZINHAS: externas, da cor escolhida (decisão do Angelo) */
  function zcFotosDaCor(lista,cod){
    return (lista||[]).filter(function(f){
      return String(f.tipo||'')==='externa' && f.cor_codigo && String(f.cor_codigo)===String(cod);
    });
  }
  /* as que ficam na segunda fileira, DESLIGADAS: interior e detalhe, que não
     têm cor. ⚠️ Desligadas de propósito: as mesmas sete fotos de painel em
     todo carro do pátio deixam o catálogo repetitivo, e o cliente percebe. */
  function zcFotosExtras(lista){
    return (lista||[]).filter(function(f){
      var t=String(f.tipo||'');
      return (t==='interna'||t==='detalhe') && _zcFotoSemCor(f);
    });
  }
  function _zcJaTem(u){
    try{ return (_estFotos||[]).some(function(x){
      return String((x&&x.url)||x||'')===String(u); }); }catch(_){ return false; }
  }
  /* ⚠️ O MESMO TETO DO IMPORTADOR DE ANÚNCIO (20). Não é número mágico novo. */
  var ZC_TETO_FOTOS=20;
  function zcFotosAcrescentar(urls){
    var n=0;
    (urls||[]).forEach(function(u){
      if(!u || _zcJaTem(u)) return;
      if((_estFotos||[]).length>=ZC_TETO_FOTOS) return;
      _estFotos.push(String(u)); n++;
    });
    if(n){
      try{ if(typeof estFotosPinta==='function' && $('estFotos')) estFotosPinta(); }catch(_){}
    }
    return n;
  }

  function _zcExtrasHtml(extras){
    if(!extras.length) return '';
    return '<div class="zc-extras" id="zcExtras">'+
      '<div class="zc-extras-cab"><b>Adicionar também</b>'+
        '<small>'+extras.length+' foto'+(extras.length===1?'':'s')+' de interior e detalhe — iguais em todo carro desta versão</small></div>'+
      '<div class="zc-extras-tira">'+
        extras.map(function(f,i){
          return '<button type="button" class="zc-extra" data-zx="'+i+'" aria-pressed="false" title="Adicionar esta foto">'+
            '<img loading="lazy" decoding="async" src="'+esc(f.url)+'" alt="Foto de '+esc(String(f.tipo||''))+'">'+
            '<span class="zc-extra-ok" aria-hidden="true">+</span></button>';
        }).join('')+
      '</div></div>';
  }
  function _zcExtrasLigar(extras){
    var box=$('zcExtras'); if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('[data-zx]'),function(b){
      b.onclick=function(){
        var f=extras[parseInt(b.getAttribute('data-zx'),10)]; if(!f) return;
        if(b.getAttribute('aria-pressed')==='true') return;   /* tirar é pelo × da foto */
        var n=zcFotosAcrescentar([f.url]);
        if(n){ b.setAttribute('aria-pressed','true'); b.classList.add('on');
               try{ estAgendaSalvar(); }catch(_){} }
        else { _zcMsg('Essa foto já está no cadastro, ou você chegou no limite de '+ZC_TETO_FOTOS+'.','av'); }
      };
    });
  }

/* ╔═══ src/app/14o-linha-0km-editar.js ═══════════════════════════════════ */
  /* ==========================================================================
     🔴🔴 v1102 — "LINHA 0 KM": EDITAR AS PÁGINAS /novos DE DENTRO DO APP
     --------------------------------------------------------------------------
     Pedido do Angelo (20/09): "quero alterar as fotos das Saveiros, inserir e
     alimentar o banco… acho que era poder alterar no estoque" → respondeu
     "nos dois": na própria página pública (botão "Editar página", só pra ele)
     E aqui, numa tela do MEV Veículos. E o que se edita: "frase de destaque,
     vantagens, texto 'Sobre', ficha técnica, o que é o pacote (ex.: VW Play
     não inclui luzes de leitura), tamanho de roda… alterar ali e alterar
     automaticamente em todos os locais que aparece".

     🔑 UMA PORTA SÓ. A página pública e esta tela gravam pela MESMA função,
     /api/novo-admin (netlify/functions/novo-admin.js), que escreve nas
     tabelas de ORIGEM da Cotação (vw_versoes, vw_opcionais, vw_cores,
     vw_fotos). Por isso "vale em todo lugar": página da versão, card do
     modelo, vitrine /novos, feed do Meta e o próprio cotador leem dali.
     Nada de segunda cópia dos dados no app.

     🔑 O QUE ESTA TELA TEM QUE A PÁGINA NÃO TEM: os opcionais e as cores
     INATIVOS. A página só busca os ativos (é o que ela mostra); aqui a ação
     `carregar` traz tudo, então desligou por engano → religa aqui.

     🔑 POR QUE UM ARQUIVO NOVO. O 14-estoque tem 200 KB (regra dos ~80 KB do
     CLAUDE.md): lá dentro entram só DOIS ganchos de uma linha — o botão no
     cabeçalho do Estoque (`lzBotaoHtml`) e o `lzWire`. A lista de modelos e
     versões vem das funções do 14n- (`zcModelosBuscar`, `zcVersoesBuscar`),
     que já existem e já guardam em memória — nada de consulta nova.

     🔴 QUEM VÊ: a mesma trava do 0 km (`zkPodeUsar` → `_ehAdmin`). E o
     servidor confere de novo (ADMIN_EMAILS) — a trava da tela é conforto,
     a do servidor é a segurança.

     ⚠️ REGRA DO EGRESS: as consultas daqui passam pelo servidor com colunas
     nomeadas (ver novo-admin.js). A foto é reduzida a 1600 px ANTES de subir.

     🔴 v1107 — pedidos do Angelo (20/09, com print da tela):
     · "melhora a visualização, quero definir uma capa pra cada cor" → as fotos
       ficam AGRUPADAS POR COR (bolinha da cor, nome, quantas fotos), e cada
       grupo tem a sua estrela: "capa da cor" (vw_cores.capa_url — a 1ª foto
       quando o cliente escolhe aquela cor na página). A estrela dourada
       continua sendo a capa da VERSÃO (card do modelo, WhatsApp, cor sem
       capa própria). Título "Polo Polo Track" → não repete o modelo.
     · "as informações de SEO já traga preenchida — descrição do veículo
       também" → os campos abrem com o texto AUTOMÁTICO da página (r.auto,
       calculado no servidor com as MESMAS fórmulas do novo.js). Se ele deixar
       igual, a tela manda vazio e a página segue automática — não congela o
       preço de hoje no banco. Mudou uma letra → vira texto dele.
     · "campo para o preço de tabela total, com os opcionais — e um campo para
       o preço com desconto (já calculado)" → seção "Preços", só leitura: o
       mesmo cálculo da página (novos_precos_combos), por cor. Quem manda no
       número é a Cotação (preço base, desconto, ações) — aqui é o espelho.
     · "permita enquadrar arrastando a imagem pra centralizar o veículo" →
       ao definir uma capa abre o ENQUADRAR: moldura 4:3, arrasta com o dedo,
       zoom; o recorte é feito no aparelho (canvas) e sobe pela ação `capa`
       como um arquivo próprio (capa-…), sem entrar na galeria. Por isso a
       capa centralizada vale em TODO lugar que mostra a capa (card, vitrine,
       WhatsApp) — nenhum deles precisou aprender a "posição do foco".
       ⚠️ v1248 — ONDE A CAPA DA VERSÃO VALE, EXATAMENTE: card do modelo,
       vitrine, WhatsApp, a prévia (og:image) e o herói da tela "Escolha a
       cor". Ela NÃO lidera a galeria de uma cor que tenha foto própria — capa
       de carro branco abrindo a página do preto foi o defeito que a v1162
       consertou. Numa cor sem foto nenhuma ela entra, sim (antes entrava o
       logotipo do MEV, um desenho onde tem que ter carro). O texto de ajuda
       da tela dizia "cores sem capa própria" e prometia mais do que o site
       faz; foi corrigido junto.
     ========================================================================== */
  var LZ_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14"/><path d="M6 17l1.5-5h9L18 17"/><path d="M8.5 12l1-3h5l1 3"/><circle cx="8" cy="19" r="1"/><circle cx="16" cy="19" r="1"/><path d="M12 3l1.2 2.4L16 6l-2 2 .5 2.7L12 9.4 9.5 10.7 10 8 8 6l2.8-.6z"/></svg>';
  var LZ_TAB_ICO={
    veiculo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14"/><path d="M6 17l1.5-5h9L18 17"/><circle cx="8" cy="19" r="1"/><circle cx="16" cy="19" r="1"/></svg>',
    fotos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    ficha:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>',
    marketing:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>',
    precos:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    seo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/><path d="M8 11h6"/><path d="M11 8v6"/></svg>'
  };
  var LZ_FICHA=[ ['motor','Motor'], ['cambio','Câmbio'], ['direcao','Direção'], ['tracao','Tração'], ['torque','Torque'], ['aceleracao','0–100 km/h'],
    ['tanque','Tanque'], ['rodas','Rodas'], ['bancos','Bancos'], ['dimensoes','Dimensões'], ['entreEixos','Entre-eixos'], ['portaMalas','Porta-malas'], ['cargaUtil','Carga útil'] ];
  var LZ_FICHA_LISTAS=[ ['destaques','Itens de série'], ['seguranca','Segurança'], ['multimidia','Multimídia'] ];
  var LZ_TIPOS=['externa','interna','detalhe'];
  var LZ_PUBLICOS_PRECO=[
    ['cnpj_produtor','CNPJ ou produtor rural'],
    ['taxista','Taxista'],
    ['pcd','PCD'],
    ['frotista','Frotista']
  ];
  /* o que está aberto agora (não vai pro banco — o banco é o servidor) */
  var _lz={ modelo:null, versao:null, cor:null, dados:null, fotos:[], capa:'', capas:{}, auto:{}, tab:'veiculo' };   /* v1107/v1221: capas + página separada por cor */

  /* ⚠️ o esc() da casa não escapa aspas — e aqui TUDO vai dentro de value="…".
     Uma ficha com `Rodas: Aço 15"` quebrava o atributo e o campo abria "Aço 15"
     (pego pelo teste-v1102). Atributo passa por aqui, sempre. */
  function _lzA(s){ return esc(s).replace(/"/g,'&quot;'); }
  function lzNumeroMoeda(v){
    var s=String(v==null?'':v).trim().replace(/[R$\s]/g,''); if(!s) return 0;
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if(/^\d{1,3}(\.\d{3})+$/.test(s)) s=s.replace(/\./g,'');
    var n=Number(s); return isFinite(n)&&n>0?n:0;
  }
  function lzPromocoes(V){
    var bruto=((V||{}).ficha||{}).precos_promocionais, obj={};
    try{ obj=typeof bruto==='string'?JSON.parse(bruto):(bruto&&typeof bruto==='object'?bruto:{}); }catch(_){ obj={}; }
    return obj&&typeof obj==='object'&&!Array.isArray(obj)?obj:{};
  }
  function lzPromoChave(){ return String(_lz.cor||'').toUpperCase()||'_geral'; }
  function lzPromoAtual(){
    var d=_lz.dados||{}, mapa=lzPromocoes(d.versao||{}), p=mapa[lzPromoChave()]||{};
    return { valor:lzNumeroMoeda(p.valor), publicos:Array.isArray(p.publicos)?p.publicos:[] };
  }
  function lzPodeUsar(){ try{ return typeof zkPodeUsar==='function' && !!zkPodeUsar(); }catch(_){ return false; } }

  /* ---------- os dois ganchos do 14-estoque ---------- */
  function lzBotaoHtml(){
    if(!lzPodeUsar()) return '';
    return '<button type="button" class="est-add-cta lz-cta" id="lzAbrirCta">'+LZ_ICO+'Linha 0 km</button>';
  }
  function lzWire(){
    try{ var b=$('lzAbrirCta'); if(b && !b.getAttribute('data-wire')){ b.setAttribute('data-wire','1'); b.onclick=function(){ telaLinha0km(); }; } }catch(_){}
  }
  function lzAnoModelo(my){
    var t=String(my==null?'':my).trim(), m=t.match(/^MY\s*'?(\d{2})$/i);
    if(m) return String(2000+parseInt(m[1],10));
    return /^(19|20)\d{2}$/.test(t)?t:'';
  }
  function lzNomeComAno(nome,my){
    var n=String(nome==null?'':nome).trim(), ano=lzAnoModelo(my);
    if(!ano) return n;
    n=n.replace(/\s+(?:MY\s*'?\d{2}|(?:19|20)\d{2})\s*$/i,'').trim();
    return (n+' '+ano).trim();
  }
  function lzVendaDiretaMarcada(V){
    var f=(V&&V.ficha&&typeof V.ficha==='object')?V.ficha:{};
    return /^(1|sim|true)$/i.test(String(f.venda_direta||'').trim());
  }
  async function lzPreviewVersoes(vs){
    var mapa={}, ids=(vs||[]).map(function(v){ return v.id; }).filter(Boolean);
    if(!ids.length) return mapa;
    try{
      var d=await _zcPede('vw_novos_showroom','versao_id,preco_varejo,preco_corp,foto_capa,nome_curto',function(q){ return q.in('versao_id',ids); });
      (d||[]).forEach(function(x){ if(x&&x.versao_id) mapa[String(x.versao_id)]=x; });
    }catch(_){ }
    return mapa;
  }

  /* ---------- a tela ---------- */
  async function telaLinha0km(){
    if(!lzPodeUsar()){ try{ toast('Só o administrador edita a linha 0 km.'); }catch(_){} return; }
    mevTabSet('');
    var cab=panelHead(LZ_ICO,'blue','Linha 0 km','Fotos, textos, ficha, opcionais e cores das páginas /novos — vale no site na hora');
    irTela(cab+
      '<div class="lz-wrap">'+
        '<div class="est-chips lz-chips" id="lzModelos">'+pgLoad('Buscando a linha…')+'</div>'+
        '<div id="lzVersoes"></div>'+
      '</div>','home');
    document.body.classList.remove('md-veiculo');
    try{ var _th=document.querySelector('#secoes .tela-head'); if(_th) _th.parentNode.removeChild(_th); }catch(_){}
    var ms=[];
    try{ ms=await zcModelosBuscar(); }catch(_){ ms=[]; }
    var el=$('lzModelos'); if(!el) return;
    if(!ms.length){ el.innerHTML='<div class="cli-empty"><b>Não consegui abrir a linha 0 km</b>Verifique sua internet e tente de novo.</div>'; return; }
    el.innerHTML=ms.map(function(m){ return '<button type="button" class="est-chip lz-chip" data-mid="'+esc(m.id)+'">'+esc(m.nome)+'</button>'; }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.lz-chip'),function(b){
      b.onclick=function(){ var m=ms.filter(function(x){ return String(x.id)===b.getAttribute('data-mid'); })[0]; if(m) lzAbrirModelo(m); };
    });
    var primeiro=(_lz.modelo && ms.filter(function(x){ return x.id===_lz.modelo.id; })[0]) || ms[0];
    lzAbrirModelo(primeiro);
  }
  async function lzAbrirModelo(m){
    _lz.modelo=m; _lz.versao=null; _lz.dados=null;
    try{ Array.prototype.forEach.call(document.querySelectorAll('.lz-chip'),function(b){ b.classList.toggle('on', b.getAttribute('data-mid')===String(m.id)); }); }catch(_){}
    var ed=$('lzEditor'); if(ed) ed.innerHTML='';
    var el=$('lzVersoes'); if(!el) return;
    el.innerHTML=pgLoad('Versões do '+esc(m.nome)+'…');
    var vs=[];
    try{ vs=await zcVersoesBuscar(m.id); }catch(_){ vs=[]; }
    if(!_lz.modelo || _lz.modelo.id!==m.id) return;   /* trocou de modelo no meio */
    if(!vs.length){ el.innerHTML='<div class="cli-empty"><b>Nenhuma versão ativa</b>Este modelo não tem versão ativa na Cotação.</div>'; return; }
    var prev=await lzPreviewVersoes(vs);
    if(!_lz.modelo || _lz.modelo.id!==m.id) return;
    el.innerHTML='<div class="lz-versoes">'+vs.map(function(v){
      var p=prev[String(v.id)]||{}, foto=v.capa_url||p.foto_capa||'', preco=Number(p.preco_varejo)||Number(v.base_price)||0;
      return '<button type="button" class="lz-vcard lz-vpreview" data-vid="'+esc(v.id)+'">'+
        '<span class="lz-vfoto">'+(foto?('<img src="'+_lzA(foto)+'" alt="" loading="lazy">'):'<span class="lz-vsemfoto">Sem foto de capa</span>')+'</span>'+
        '<span class="lz-vconteudo"><span class="lz-vnome">'+esc(lzNomeComAno(v.nome||v.nome_curto||'',v.model_year))+'</span>'+
        '<span class="lz-vspecs"><i>0 km</i><i>Garantia de fábrica</i>'+(m.categoria?('<i>'+esc(m.categoria)+'</i>'):'')+(lzVendaDiretaMarcada(v)?'<i>Venda direta</i>':'')+'</span>'+
        '<span class="lz-vpreco"><small>A partir de</small><b>'+(preco?_rsF(preco):'Consulte')+'</b></span>'+
        '<span class="lz-vsub">'+esc([lzAnoModelo(v.model_year), v.model_code].filter(Boolean).join(' · '))+'</span>'+
        '<span class="lz-vgo">Editar página <span aria-hidden="true">›</span></span></span></button>';
    }).join('')+'</div>';
    Array.prototype.forEach.call(el.querySelectorAll('.lz-vcard'),function(b){
      b.onclick=function(){ var v=vs.filter(function(x){ return String(x.id)===b.getAttribute('data-vid'); })[0]; if(v) lzAbrirVersao(v); };
    });
  }

  /* ---------- o editor de UMA versão ---------- */
  async function lzAbrirVersao(v, reabrirCor){
    _lz.versao=v; _lz.cor=null;
    /* v1221 — o editor é uma PÁGINA, não uma continuação da lista. Antes ele
       nascia abaixo de todos os modelos e versões: no celular o usuário via
       dois contextos ao mesmo tempo e perdia quase uma tela inteira antes do
       primeiro campo. A lista fica como seletor; tocar numa versão troca para
       uma tela interna limpa. O Voltar do app recompõe a lista e mantém o
       modelo escolhido em `_lz.modelo`. */
    mevTabSet('');
    var modelo=String((_lz.modelo&&_lz.modelo.nome)||'').trim();
    var meta=[modelo, lzAnoModelo(v.model_year), v.model_code].filter(Boolean).join(' · ');
    irTela(panelHead(LZ_ICO,'blue','Editar página 0 km',esc(meta||v.nome||''))+
      '<div class="lz-editor-page"><div id="lzEditor" aria-live="polite">'+pgLoad('Abrindo '+esc(v.nome||'')+'…')+'</div></div>','home');
    document.body.classList.remove('md-veiculo');
    try{ voltarTab(telaLinha0km); }catch(_){}
    var ed=$('lzEditor'); if(!ed) return;
    var r=null;
    try{ r=await apiTimeout('/api/novo-admin',{ acao:'carregar', versao_id:v.id },20000); }catch(_){ r=null; }
    if(!_lz.versao || _lz.versao.id!==v.id) return;
    if(!r || !r.ok){
      ed.innerHTML='<div class="cli-empty"><b>Não consegui abrir esta versão</b>'+esc((r&&r.erro)||'Verifique sua internet e tente de novo.')+'</div>';
      return;
    }
    _lz.dados=r; _lz.capa=r.versao.capa_url||''; _lz.auto=r.auto||{};
    _lz.capas={}; (r.cores||[]).forEach(function(c){ if(c.capa_url) _lz.capas[c.codigo]=c.capa_url; });
    _lz.fotos=(r.fotos||[]).map(function(f){ return { id:f.id, u:f.url, c:f.cor_codigo||'', t:f.tipo||'externa', o:f.ordem||0, apagar:false }; })
      .sort(function(a,b){ return a.o-b.o; });
    lzOrdena();
    if(reabrirCor!==undefined && reabrirCor!==null){ lzAbrirCor(String(reabrirCor)); return; }
    lzMostrarCoresDaVersao();
  }
  function lzCorAtual(){
    var d=_lz.dados||{}, cod=_lz.cor;
    if(cod===null) return null;
    if(cod==='') return { codigo:'', nome:'Fotos internas e detalhes', hex:'', semCor:true, ativa:true };
    return (d.cores||[]).filter(function(c){ return String(c.codigo)===String(cod); })[0]||null;
  }
  function lzMostrarCoresDaVersao(){
    var d=_lz.dados; if(!d) return;
    _lz.cor=null;
    var titulo=lzTitulo(d), cores=(d.cores||[]).slice();
    var temSemCor=_lz.fotos.some(function(f){ return !f.c; });
    if(temSemCor) cores.push({ codigo:'', nome:'Fotos internas e detalhes', hex:'', semCor:true, ativa:true });
    var cards=cores.map(function(c){
      var cod=String(c.codigo||''), capa=(cod&&_lz.capas[cod])||((_lz.fotos.filter(function(f){ return f.c===cod && !f.apagar; })[0]||{}).u)||'';
      var qtd=_lz.fotos.filter(function(f){ return f.c===cod && !f.apagar; }).length;
      var amostra=c.semCor?'<span class="lz-cor-sem">Foto</span>':'<span class="lz-cor-bola" style="background:'+_lzA(/^#[0-9a-f]{3,8}$/i.test(c.hex)?c.hex:'#cbd5e1')+'"></span>';
      return '<button type="button" class="lz-cor-card'+(c.ativa===false?' off':'')+'" data-lz-cor="'+_lzA(cod)+'">'+
        (capa?('<img src="'+_lzA(capa)+'" alt="" loading="lazy">'):('<span class="lz-cor-fallback">'+amostra+'</span>'))+
        '<span class="lz-cor-info"><b>'+esc(c.nome||cod||'Sem cor')+'</b>'+(cod?('<small>'+esc(cod)+'</small>'):'')+
        '<span>'+qtd+' foto'+(qtd===1?'':'s')+' · Editar página</span></span><span class="lz-cor-seta" aria-hidden="true">›</span></button>';
    }).join('');
    irTela(panelHead(LZ_ICO,'blue',titulo,'Escolha a cor — cada cor abre em uma página separada')+
      '<div class="lz-cores-page"><div class="lz-cores-grid" id="lzCoresPaginas">'+(cards||'<div class="cli-empty"><b>Nenhuma cor cadastrada</b>Cadastre as cores desta versão na Cotação.</div>')+'</div></div>','home');
    document.body.classList.remove('md-veiculo');
    try{ voltarTab(telaLinha0km); }catch(_){}
    Array.prototype.forEach.call(document.querySelectorAll('[data-lz-cor]'),function(b){
      b.onclick=function(){ lzAbrirCor(b.getAttribute('data-lz-cor')); };
    });
  }
  function lzAbrirCor(codigo){
    var d=_lz.dados; if(!d) return;
    _lz.cor=String(codigo==null?'':codigo);
    var cor=lzCorAtual(); if(!cor){ lzMostrarCoresDaVersao(); return; }
    irTela(panelHead(LZ_ICO,'blue',lzTitulo(d)+' — '+String(cor.nome||cor.codigo),'Edição separada desta cor · dados gerais da versão são compartilhados')+
      '<div class="lz-editor-page"><div id="lzEditor"></div></div>','home');
    document.body.classList.remove('md-veiculo');
    try{ voltarTab(lzMostrarCoresDaVersao); }catch(_){}
    lzPintaEditor();
  }
  function _lzCoresOpt(sel, comVazio){
    var d=_lz.dados||{};
    return (comVazio?('<option value=""'+(!sel?' selected':'')+'>sem cor (interna/detalhe)</option>'):'')+
      (d.cores||[]).map(function(c){ return '<option value="'+_lzA(c.codigo)+'"'+(c.codigo===sel?' selected':'')+'>'+esc(c.nome)+(c.codigo?(' ('+esc(c.codigo)+')'):'')+'</option>'; }).join('');
  }
  function lzUrlPagina(){
    var d=_lz.dados; if(!d || !d.modelo || !d.modelo.slug || !d.versao.slug) return '';
    return location.origin+'/novos/'+d.modelo.slug+'/'+d.versao.slug;
  }
  /* O MY é a fonte do ano: "Saveiro Robust 2026" + MY27 → "Saveiro Robust 2027". */
  function lzTitulo(d){
    var m=String((d.modelo||{}).nome||'').trim(), V=d.versao||{};
    var v=lzNomeComAno(V.nome||'',V.model_year);
    if(!v) return m; if(!m) return v;
    return (v.toLowerCase().indexOf(m.toLowerCase())===0)?v:(m+' '+v);
  }
  function lzTabsHtml(){
    var tabs=[['veiculo','Veículo'],['precos','Preço e condições'],['fotos','Fotos'],['ficha','Ficha técnica'],['marketing','Marketing'],['seo','SEO da página']];
    return '<div class="vpx-steps vpx-mdr lz-tabs" id="lzTabs" role="tablist" aria-label="Cadastro da linha 0 km">'+tabs.map(function(t){
      return '<button type="button" class="vpx-st" data-lz-tab="'+t[0]+'" role="tab" aria-selected="false"><span class="vpx-ico">'+LZ_TAB_ICO[t[0]]+'</span><span class="vpx-nm">'+t[1]+'</span></button>';
    }).join('')+'</div>';
  }
  function lzTabAbrir(tab){
    var raiz=$('lzEditor'); if(!raiz) return;
    var existe=raiz.querySelector('[data-lz-panel="'+tab+'"]');
    _lz.tab=existe?tab:'veiculo';
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-lz-panel]'),function(p){ p.classList.toggle('on',p.getAttribute('data-lz-panel')===_lz.tab); });
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-lz-tab]'),function(b){
      var on=b.getAttribute('data-lz-tab')===_lz.tab; b.classList.toggle('on',on); b.setAttribute('aria-selected',on?'true':'false'); b.tabIndex=on?0:-1;
      if(on){ try{ _tabCentra(b.parentNode,b); }catch(_){} }
    });
  }
  function lzPrecosHtml(d){
    var P=d.precos||{}, pc=P.por_cor||[];
    if(_lz.cor!==null && _lz.cor!=='') pc=pc.filter(function(c){ return String(c.codigo)===String(_lz.cor); });
    if(!pc.length && !P.tabela) return '<h4>Preços</h4><p class="cad-help">Sem preço calculado pra esta versão (confira o preço base e o desconto na Cotação).</p>';
    var atual=pc[0]||{}, tabela=atual.tabela||P.tabela, varejo=atual.varejo||P.varejo, nome=atual.nome||P.cor||'';
    return '<h4>Preços</h4><p class="cad-help">O mesmo cálculo da página, com todos os opcionais de escolha marcados (é como ela abre). Quem manda no número é a Cotação — preço base, desconto e ações de venda.</p>'+
      '<div class="lz-ficha"><div><label class="cad-lbl">Preço de tabela total (com opcionais)'+(nome?(' · '+esc(nome)):'')+'</label><input class="cad-in lz-ro" readonly value="'+_lzA(tabela?_rsF(tabela):'—')+'"></div>'+
      '<div><label class="cad-lbl">Preço com desconto (já calculado)</label><input class="cad-in lz-ro lz-verde" readonly value="'+_lzA(varejo?_rsF(varejo):'—')+'"></div></div>';
  }
  function lzPromocaoHtml(V){
    var p=lzPromoAtual(), marcados={}; p.publicos.forEach(function(k){ marcados[k]=1; });
    return '<section class="lz-promo"><div class="lz-promo-head"><div><h4>Preço promocional desta cor</h4><p class="cad-help">Se preenchido, este valor substitui o preço calculado no card e na página pública desta cor.</p></div></div>'+
      '<label class="cad-lbl" for="lzPrecoPromo">Preço promocional</label><input class="cad-in lz-num" id="lzPrecoPromo" inputmode="numeric" autocomplete="off" placeholder="R$ 0,00" value="'+_lzA(p.valor?_rsF(p.valor):'')+'">'+
      '<fieldset class="lz-publicos"><legend>Público da condição</legend><p class="cad-help">Marque todos os públicos para os quais este preço é válido.</p><div class="lz-publicos-lista">'+LZ_PUBLICOS_PRECO.map(function(x){
        var on=!!marcados[x[0]]; return '<label class="vd-ck'+(on?' on':'')+'"><input type="checkbox" data-lz-publico="'+x[0]+'"'+(on?' checked':'')+'><span>'+esc(x[1])+'</span></label>';
      }).join('')+'</div></fieldset></section>';
  }
  function lzFichaSepara(valor){
    return String(valor||'').split(/\s*·\s*|\n+/).map(function(x){ return x.trim(); }).filter(Boolean);
  }
  function lzFichaItemHtml(chave,texto,ativo){
    var lixo='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v5M14 11v5"/></svg>';
    return '<div class="lz-fi-item'+(ativo?' on':'')+'" data-ficha-item="'+_lzA(chave)+'">'+
      '<label class="lz-fi-check"><input type="checkbox" class="lz-fi-on"'+(ativo?' checked':'')+'><span aria-hidden="true"></span><span class="sr-only">Mostrar este item</span></label>'+
      '<input class="cad-in lz-fi-texto" value="'+_lzA(texto)+'" placeholder="Digite o item">'+
      '<button type="button" class="lz-fi-remover" aria-label="Remover item" title="Remover item">'+lixo+'</button></div>';
  }
  function lzFichaListaHtml(V,chave,titulo){
    var ativos=lzFichaSepara((V.ficha||{})[chave]), inativos=lzFichaSepara((V.ficha||{})[chave+'_inativos']);
    var vistos={};
    var linhas=ativos.map(function(x){ vistos[x.toLowerCase()]=1; return lzFichaItemHtml(chave,x,true); });
    inativos.forEach(function(x){ if(!vistos[x.toLowerCase()]) linhas.push(lzFichaItemHtml(chave,x,false)); });
    return '<section class="lz-fi-grupo" data-ficha-grupo="'+_lzA(chave)+'"><div class="lz-fi-head"><div><h4>'+esc(titulo)+'</h4><p class="cad-help">Marque o que aparece na página. Edite o texto ou desmarque para ocultar sem perder o item.</p></div>'+
      '<span class="lz-fi-cont">'+ativos.length+' marcado'+(ativos.length===1?'':'s')+'</span></div><div class="lz-fi-lista">'+linhas.join('')+'</div>'+
      '<button type="button" class="lz-fi-adicionar" data-ficha-add="'+_lzA(chave)+'">Adicionar item</button></section>';
  }
  function lzFichaListaWire(ed){
    var ligar=function(linha){
      var ck=linha.querySelector('.lz-fi-on'), rm=linha.querySelector('.lz-fi-remover');
      if(ck) ck.onchange=function(){ linha.classList.toggle('on',ck.checked); lzFichaConta(linha.closest('[data-ficha-grupo]')); };
      if(rm) rm.onclick=function(){ var grupo=linha.closest('[data-ficha-grupo]'); linha.remove(); lzFichaConta(grupo); };
    };
    var lzFichaConta=function(grupo){
      if(!grupo) return; var n=grupo.querySelectorAll('.lz-fi-on:checked').length, c=grupo.querySelector('.lz-fi-cont');
      if(c) c.textContent=n+' marcado'+(n===1?'':'s');
    };
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-fi-item'),ligar);
    Array.prototype.forEach.call(ed.querySelectorAll('[data-ficha-add]'),function(b){
      b.onclick=function(){ var grupo=b.closest('[data-ficha-grupo]'), lista=grupo&&grupo.querySelector('.lz-fi-lista'); if(!lista) return;
        lista.insertAdjacentHTML('beforeend',lzFichaItemHtml(b.getAttribute('data-ficha-add'),'',true));
        var linha=lista.lastElementChild; ligar(linha); lzFichaConta(grupo); var inp=linha&&linha.querySelector('.lz-fi-texto'); if(inp) inp.focus(); };
    });
  }
  function lzMarketingVantagens(V){
    var ativos=Array.isArray(V.vantagens)?V.vantagens.map(function(x){ return String(x||'').trim(); }).filter(Boolean):[];
    var inativos=lzFichaSepara((V.ficha||{}).marketing_vantagens_inativas), vistos={};
    var linhas=ativos.map(function(x){ vistos[x.toLowerCase()]=1; return lzFichaItemHtml('marketing',x,true); });
    inativos.forEach(function(x){ if(!vistos[x.toLowerCase()]) linhas.push(lzFichaItemHtml('marketing',x,false)); });
    return '<section class="lz-fi-grupo lz-mkt-vant" data-marketing-grupo="vantagens"><div class="lz-fi-head"><div><h4>Vantagens do veículo</h4><p class="cad-help">Marque o que entra no post e na página. Você pode editar, remover ou adicionar outros itens.</p></div>'+
      '<span class="lz-fi-cont">'+ativos.length+' marcado'+(ativos.length===1?'':'s')+'</span></div><div class="lz-fi-lista">'+linhas.join('')+'</div>'+
      '<button type="button" class="lz-fi-adicionar" data-marketing-add="vantagens">Adicionar vantagem</button></section>';
  }
  function lzMarketingColeta(ed){
    var ativos=[], inativos=[], grupo=ed&&ed.querySelector('[data-marketing-grupo="vantagens"]');
    if(!grupo) return { ativos:ativos, inativos:inativos };
    Array.prototype.forEach.call(grupo.querySelectorAll('[data-ficha-item]'),function(linha){
      var texto=((linha.querySelector('.lz-fi-texto')||{}).value||'').trim(); if(!texto) return;
      ((linha.querySelector('.lz-fi-on')||{}).checked?ativos:inativos).push(texto);
    });
    return { ativos:ativos, inativos:inativos };
  }
  function lzMarketingListaWire(ed){
    var grupo=ed.querySelector('[data-marketing-grupo="vantagens"]'); if(!grupo) return;
    var conta=function(){ var n=grupo.querySelectorAll('.lz-fi-on:checked').length, c=grupo.querySelector('.lz-fi-cont'); if(c) c.textContent=n+' marcado'+(n===1?'':'s'); };
    var ligar=function(linha){
      var ck=linha.querySelector('.lz-fi-on'), rm=linha.querySelector('.lz-fi-remover');
      if(ck) ck.onchange=function(){ linha.classList.toggle('on',ck.checked); conta(); lzPostPinta(); };
      if(rm) rm.onclick=function(){ linha.remove(); conta(); lzPostPinta(); };
    };
    Array.prototype.forEach.call(grupo.querySelectorAll('.lz-fi-item'),ligar);
    var add=grupo.querySelector('[data-marketing-add]'); if(add) add.onclick=function(){
      var lista=grupo.querySelector('.lz-fi-lista'); if(!lista) return;
      lista.insertAdjacentHTML('beforeend',lzFichaItemHtml('marketing','',true));
      var linha=lista.lastElementChild; ligar(linha); conta(); var inp=linha&&linha.querySelector('.lz-fi-texto'); if(inp) inp.focus();
    };
  }
  /* ==========================================================================
     🔴 v1237 — A ENTRADA SAI DO PREÇO DA UNIDADE, NÃO DO PREÇO DA COR
     --------------------------------------------------------------------------
     Angelo, 27/09, com print: "calcula a entrada sobre o preco dessa unidade".
     A tela dizia "A entrada é calculada sobre R$ 144.100,00" (o preço da cor)
     enquanto a unidade em pátio estava cadastrada por R$ 139.900,00.

     Ele tem razão e a razão é simples: o post é sobre UM CARRO. O carro que
     está no pátio custa o que está escrito nele. Calcular a entrada sobre o
     preço da cor faz o cliente chegar na loja com uma conta que não fecha.

     A ordem de quem manda, do mais específico para o mais geral:
       1. o preço DESTA UNIDADE (é um carro, com opcionais e preço próprios)
       2. o preço promocional DESTA COR
       3. o preço de varejo calculado
     ⚠️ COM MAIS DE UMA UNIDADE da mesma cor, vale a MAIS BARATA — e a tela
     escreve em cima de qual preço está calculando. Sem dizer o número, duas
     unidades com preços diferentes viram mistério; dizendo, é escolha. */
  function lzPrecoDaUnidade(){
    var ed=document.getElementById('lzEditor'); if(!ed) return 0;
    var menor=0;
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-un'), function(cx){
      if(cx.getAttribute('data-un-tirada')==='1') return;
      var sel=cx.querySelector('[data-k="cor_codigo"]');
      if(!sel || String(sel.value||'')!==String(_lz.cor||'')) return;
      var p=lzNumeroMoeda((cx.querySelector('[data-k="preco"]')||{}).value);
      if(p && (!menor || p<menor)) menor=p;
    });
    return menor;
  }
  function lzPostPreco(){
    var unid=lzPrecoDaUnidade(); if(unid) return unid;
    var manual=lzNumeroMoeda((document.getElementById('lzPrecoPromo')||{}).value); if(manual) return manual;
    var d=_lz.dados||{}, P=d.precos||{}, pc=(P.por_cor||[]).filter(function(c){ return _lz.cor!==null && String(c.codigo)===String(_lz.cor); });
    return Number(((pc[0]||{}).varejo)||P.varejo)||0;
  }
  /* ======================================================================
     🔴 v1240 — DESCRIÇÃO PADRÃO E HASHTAG PADRÃO DO POST
     ----------------------------------------------------------------------
     Pedido do Angelo, 27/09, com as palavras dele:

       hashtag padrão .... #volkswagen #(modelo) #oportunidade #torresrs #vw
       descrição padrão .. Volkswagen (modelo|versao|ano modelo) com
                           condição imperdível! Aproveite!

     Duas decisões que tomei e que ele precisa saber, estão no changelog:

     1) ESCREVI EM MAIÚSCULA DE PALAVRA (#Volkswagen, #TorresRS, #VW). No
        Instagram e no Facebook hashtag NÃO diferencia maiúscula de
        minúscula — #torresrs e #TorresRS são a mesma hashtag, caem na
        mesma busca. A maiúscula é só pra quem lê o post. Se ele preferir
        tudo minúsculo é trocar uma linha.

     2) O MODELO SAI SOZINHO, não o título inteiro. Antes a hashtag era o
        título todo grudado: #NivusHighlineTSI2027 — uma hashtag que
        ninguém no mundo pesquisa. Agora é #Nivus, que é o que o cliente
        digita. "T-Cross" vira #TCross, "Polo Track" vira #PoloTrack:
        hashtag não aceita hífen nem espaço. */
  function lzPostDescricao(ed,d){
    var el=ed?$('lzSobre'):null, meu=el?String(el.value||'').trim():'';
    var auto=String((_lz.auto||{}).sobre||'').trim();
    /* o texto automático da página não conta como descrição escrita por ele */
    function achata(t){ return String(t||'').replace(/\s+/g,' ').trim().toLowerCase(); }
    if(meu && achata(meu)!==achata(auto)) return meu;
    var nome=lzTitulo(d||_lz.dados||{});
    if(!nome) return '';
    /* o título já vem "modelo + versão + ano" sem repetir o modelo */
    return 'Volkswagen '+nome+' com condição imperdível! Aproveite!';
  }
  function lzTagLimpa(t){
    /* hashtag não aceita espaço, hífen nem ponto: "T-Cross" → TCross */
    return String(t||'').replace(/[^A-Za-z0-9\u00c0-\u017f]/g,'');
  }
  function lzPostTags(d){
    d=d||_lz.dados||{};
    var modelo=lzTagLimpa((d.modelo||{}).nome);
    var t=['#Volkswagen'];
    if(modelo && modelo.toLowerCase()!=='volkswagen') t.push('#'+modelo);
    t.push('#Oportunidade','#TorresRS','#VW');
    return t.join(' ');
  }
  function lzPostAutomatico(){
    var ed=$('lzEditor'), d=_lz.dados||{}, cor=lzCorAtual(), linhas=[], vistos={};
    function unico(t){ t=String(t||'').trim(); var k=t.toLowerCase(); if(!t||vistos[k]) return; vistos[k]=1; return t; }
    var titulo=lzTitulo(d); if(titulo) linhas.push(titulo);
    if(cor&&!cor.semCor&&cor.nome) linhas.push('\u27a1\ufe0f '+cor.nome);
    var mk=lzMarketingColeta(ed); mk.ativos.forEach(function(x){ x=unico(x); if(x) linhas.push('\u27a1\ufe0f '+x); });
    if(ed) Array.prototype.forEach.call(ed.querySelectorAll('[data-ficha-grupo] .lz-fi-on:checked'),function(ck){
      if(linhas.length>=18) return; var linha=ck.closest('[data-ficha-item]'), x=unico(((linha&&linha.querySelector('.lz-fi-texto'))||{}).value); if(x) linhas.push('\u2705 '+x);
    });
    /* ======================================================================
       🔴 v1240 — A DESCRIÇÃO DO POST TEM UM PADRÃO, E ELE É CURTO
       ----------------------------------------------------------------------
       Angelo, 27/09: "descricao que aparece no post deixe por padrao:
       Volkswagen (modelo|versao|ano modelo) com condicao imperdivel!
       Aproveite!"

       Antes o post despejava aqui o texto de "Sobre o veículo", que é o
       texto de SEO da PÁGINA — um parágrafo longo, escrito pra o Google
       ler. Num post de Instagram isso rouba a leitura antes do preço.

       Agora: se ele escreveu a descrição dele, é a dele que sai, sempre.
       Se o campo está vazio ou ainda está com o texto automático da
       página, sai a frase padrão que ele pediu.

       ⚠️ ISTO NÃO MEXE NO BANCO. É leitura de tela: quem grava o campo
       `sobre` é o `semAuto('lzSobre','sobre')` no salvar, e ele continua
       gravando vazio quando o texto é o automático. */
    var sobre=lzPostDescricao(ed,d); if(sobre) linhas.push('\ud83d\udc8e '+sobre);
    /* ======================================================================
       🔴 v1234 — A ENTRADA DO POST DEIXA DE SER UM 30% CHUTADO
       ----------------------------------------------------------------------
       Antes: `preco*.30`, fixo, com o texto "Entrada a partir de". Trinta por
       cento não vinha de lugar nenhum — não era a condição do carro, era um
       número escrito no código. Quem lia o post recebia uma entrada que podia
       não existir em condição nenhuma.
       Agora sai a condição ESCOLHIDA na aba Preço e condições, com a entrada
       calculada sobre o preço que está valendo, a taxa e o número de parcelas
       — exatamente os três dados que ele pediu. Sem condição escolhida, o
       post não fala de entrada: melhor calar do que chutar.
       ⚠️ NADA DE VALOR DE PARCELA, por decisão dele. Parcela publicada é
       promessa; o cálculo de PMT depende de IOF e tarifa que variam. */
    var preco=lzPostPreco(); if(preco){
      linhas.push('\ud83d\udcb0 '+_rsF(preco));
      var cond=lzCondDa(lzCondSel()||((_lz.dados||{}).versao||{}).cond_destaque);
      if(cond){
        var ent=Math.round(preco*(Number(cond.entrada_pct)||0)/100*100)/100;
        linhas.push('\ud83d\udcb3 Entrada de '+_rsF(ent)+' ('+(Number(cond.entrada_pct)||0)+'%)');
        linhas.push('\ud83d\uddd3\ufe0f '+(Number(cond.prazo)||0)+'x \u00b7 '+lzTaxaTxt(cond.taxa_mensal));
      }
    }
    /* ======================================================================
       🔴 v1246 — A VENDA DIRETA NO POST
       ----------------------------------------------------------------------
       Angelo, 28/09: "coloca nos post venda direta com o que foi selecionado
       CNPJ e produtor rural".

       🔴🔴🔴 TRÊS TRAVAS, E CADA UMA EVITA UM ESTRAGO DIFERENTE:

       1. SEM PÚBLICO MARCADO, NÃO SAI. Uma entrada de 30% num post sem dizer
          "CNPJ" é uma condição de PJ oferecida a pessoa física. O público não
          é enfeite do texto — é o que torna a frase verdadeira.

       2. SEM NF CADASTRADA, NÃO SAI EM REAIS. A entrada da venda direta é
          sobre a NF da fábrica. Sem ela eu teria que usar o preço público, e
          isso dá oito mil reais de erro (a conta está no changelog da v1245).
          Sem NF, sai a porcentagem e nada mais.

       3. O PÚBLICO VEM ANTES DO NÚMERO na linha. Quem lê um post lê de cima
          pra baixo e para no primeiro número que interessa; se o "CNPJ"
          viesse depois, metade das pessoas já teria parado de ler. */
    try{
      var vdMarcada=!!($('lzVendaDireta')&&$('lzVendaDireta').checked);
      var cdir=vdMarcada?lzDiretaDa(lzDiretaSel()):null, pub=vdMarcada?lzDiretaPublicoTxt():'';
      if(cdir && pub){
        var nfd=lzPrecoCorp(), pctd=Number(cdir.entrada_pct)||0;
        linhas.push('\ud83c\udfe2 Venda direta \u00b7 '+pub);
        var entd=nfd?Math.round(nfd*pctd/100):0;
        linhas.push('\ud83d\udcb3 Entrada de '+(entd?(_rsF(entd)+' ('+pctd+'%)'):(pctd+'%')));
        linhas.push('\ud83d\uddd3\ufe0f '+(Number(cdir.prazo)||0)+'x \u00b7 '+lzTaxaTxt(cdir.taxa_mensal));
      }
    }catch(_){}
    /* v1234 — os selos que ele pediu no post, e só quando marcados */
    try{
      var _vv=$('lzVarejo'), _ehVarejo=_vv?_vv.checked:!!(((_lz.dados||{}).versao||{}).varejo);
      if(_ehVarejo) linhas.push('\ud83c\udff7\ufe0f Condição de varejo');
      /* v1235 — "pronta entrega" só é dito quando existe um carro DESTA COR
         no pátio. Dizer isso sem ter o carro é a promessa mais cara que uma
         loja pode fazer. */
      if(lzTemProntaEntrega(ed)) linhas.push('\ud83d\ude97 Pronta entrega');
    }catch(_){}
    linhas.push('\ud83e\udd1d Avaliamos seu usado na troca!');
    linhas.push('\ud83d\udcf2 (51) 99641-7433');
    var vendedor=String(meuNome||'Angelo Ferrari').trim(); if(vendedor) linhas.push('\ud83d\udc49 '+vendedor+' - Consultor VW');
    var instagram=''; try{ instagram=_mktInstagramVendedor()||_mktInstagramUsuario(); }catch(_){} if(instagram) linhas.push('\ud83d\udcf8 Siga @'+instagram);
    var link=lzUrlPagina(); if(link) linhas.push('\ud83d\udd17 '+link);
    linhas.push(lzPostTags(d));
    return linhas.filter(Boolean).join('\n').trim();
  }
  function lzPostPinta(){
    var out=$('lzPostOut'); if(!out) return; var post=lzPostAutomatico();
    out.innerHTML='<article class="post-box lz-post-auto"><div class="post-kind">'+mkIco('post',14)+'<span>Post automático</span></div>'+
      '<div class="post-txt" id="lzPostTxt">'+esc(post)+'</div><div class="post-salvo">'+mkIco('ok',13)+'<span>Montado automaticamente com os campos marcados</span></div>'+
      '<div class="post-acts so-ico"><button type="button" class="b1" id="lzPostCopy" title="Copiar texto" aria-label="Copiar texto">'+mkIco('copiar',19)+'</button>'+
      '<button type="button" class="b4" id="lzPostAbrir" title="Copiar e abrir o Instagram" aria-label="Copiar texto e abrir o Instagram">'+mkIco('instagram',19)+'</button>'+
      '<button type="button" class="b3" id="lzPostReg" title="Atualizar prévia" aria-label="Atualizar prévia">'+mkIco('atualizar',19)+'</button></div></article>';
    var cp=$('lzPostCopy'); if(cp) cp.onclick=function(){ _mktCopiar(post,'Texto copiado.'); };
    var ab=$('lzPostAbrir'); if(ab) ab.onclick=function(){ _mktInstagramAbrir(post); };
    var rg=$('lzPostReg'); if(rg) rg.onclick=lzPostPinta;
  }
  function lzPintaEditor(){
    var ed=$('lzEditor'), d=_lz.dados; if(!ed || !d) return;
    var V=d.versao, url=lzUrlPagina(), AU=_lz.auto||{}, corAtual=lzCorAtual();
    ed.innerHTML='<div class="lz-ed">'+
      '<div class="lz-ed-topo"><div><h3>'+esc(lzTitulo(d))+'</h3>'+
        (url?('<a class="lz-ver" href="'+esc(url)+'" target="_blank" rel="noopener">Ver a página no site ↗</a>'):'')+'</div>'+
        '<button type="button" class="cad-btn lz-salvar" id="lzSalvar">Salvar e publicar</button></div>'+
      '<div class="lz-err" id="lzErr" hidden></div>'+
      '<div class="vpx lz-vpx">'+lzTabsHtml()+'<div class="vpx-body lz-tab-body">'+
      '<section class="vpx-panel lz-tab-panel" data-lz-panel="veiculo" role="tabpanel"><div class="vp-sec">'+
      /* ====================================================================
         🔴🔴 v1233 — O ANO DO MODELO, AGORA NA TELA ONDE ELE TRABALHA
         --------------------------------------------------------------------
         26/09, o Angelo: "permita editar o ano tambem, nesse caso quero
         colocar 2027". Eu pus o campo na v1232 — e pus NO ARQUIVO ERRADO
         (o `novo.js`, que é o editor sobreposto da página pública). A tela
         dele é ESTA. Erro meu, de andar rápido demais entre assuntos.

         O ano mora em dois lugares: a coluna `model_year` ("MY27") e o fim
         do `nome` ("Nivus Highline 2027"). Quem manda no título é o
         `model_year` — e era justamente ele que não tinha porta. Tanto que
         o banco já estava se contradizendo: o Nivus Highline (e o GTS)
         tinham 2027 no nome e MY26 na coluna.

         ⚠️ O SERVIDOR ACERTA OS DOIS (novo-admin.js, v1232): grava o
         `model_year` no formato da casa e reescreve o fim do `nome` pela
         MESMA regra do `versaoComAno`. Aqui a tela só manda o que a pessoa
         digitou; normalizar em dois lugares seria pedir pra divergir.
         ⚠️ Vazio LIMPA o ano, de propósito — é como se desfaz um engano. */
      '<h4>Ano do modelo</h4><p class="cad-help">É ele que manda no título em toda parte: página, card, WhatsApp e catálogo. O nome da versão é acertado junto ao salvar. Deixe vazio pra tirar o ano.</p>'+
      '<label class="cad-lbl" for="lzAno">Ano do modelo</label><input class="cad-in" id="lzAno" inputmode="numeric" maxlength="7" autocomplete="off" placeholder="2027" value="'+_lzA(lzAnoModelo((V||{}).model_year))+'">'+
      '<h4>Cor desta página</h4><div class="lz-lista">'+(d.cores||[]).filter(function(c){ return _lz.cor!==null && String(c.codigo)===String(_lz.cor); }).map(function(c){
        return '<div class="lz-item lz-linha'+(c.ativa?'':' off')+'" data-cor="'+esc(c.id)+'"><span class="lz-cod">'+esc(c.codigo||'—')+'</span>'+
          '<input class="cad-in" data-k="nome" value="'+_lzA(c.nome)+'" placeholder="nome">'+
          '<input class="cad-in lz-num" data-k="preco_adicional" inputmode="numeric" value="'+_lzA(c.preco_adicional?_rsF(c.preco_adicional):'')+'" placeholder="+ R$">'+
          '<input class="lz-hex" type="color" data-k="hex" value="'+_lzA(/^#[0-9a-f]{6}$/i.test(c.hex)?c.hex:'#cccccc')+'">'+
          '<label class="vd-ck'+(c.ativa?' on':'')+'"><input type="checkbox" data-k="ativa"'+(c.ativa?' checked':'')+'><span>ativa</span></label></div>';
      }).join('')+'</div></div></section>'+

      /* v1234 — a aba dele: preço, promoção, marcações, condições de varejo
         e as vigentes de corporativo, nesta ordem. Preço primeiro porque é
         sobre ele que a entrada é calculada logo abaixo. */
      '<section class="vpx-panel lz-tab-panel" data-lz-panel="precos" role="tabpanel"><div class="vp-sec">'+
      lzPrecosHtml(d)+lzPromocaoHtml(V)+lzMarcacoesHtml(d)+lzEstoqueHtml(d)+lzCondHtml(d)+lzCorpHtml(d)+lzDiretaHtml(d)+
      '</div></section>'+
      '<section class="vpx-panel lz-tab-panel" data-lz-panel="fotos" role="tabpanel"><div class="vp-sec">'+
      '<h4>Fotos por cor</h4><p class="cad-help">Cada cor tem a sua <b>capa da cor</b> (a 1ª foto quando o cliente escolhe aquela cor). A estrela dourada é a <b>capa da versão</b> (card do modelo, vitrine, WhatsApp, a prévia do link e o topo da tela "Escolha a cor"; e a galeria de uma cor que não tenha foto nenhuma). Ao definir uma capa você pode arrastar a foto pra centralizar o carro. Setas mudam a ordem dentro da cor. Lixeira marca pra apagar ao salvar.</p>'+
      '<div class="lz-grupos" id="lzFotos"></div>'+
      '<div class="lz-add"><div class="lz-cor-upload"><span>Cor das fotos novas</span><b>'+esc((corAtual&&corAtual.nome)||'Fotos internas e detalhes')+'</b></div><input type="hidden" id="lzAddCor" value="'+_lzA(_lz.cor||'')+'">'+
        '<label class="cad-lbl">Tipo<select class="cad-in" id="lzAddTipo">'+LZ_TIPOS.map(function(t){ return '<option>'+t+'</option>'; }).join('')+'</select></label>'+
        '<button type="button" class="est-addfoto lz-arq" id="lzAddFoto" aria-controls="lzArq"><span aria-hidden="true">+</span><span>Adicionar fotos</span></button><input id="lzArq" type="file" accept="image/*" multiple hidden><span class="cad-help" id="lzAddSt" role="status" aria-live="polite"></span></div></div></section>'+

      '<section class="vpx-panel lz-tab-panel" data-lz-panel="marketing" role="tabpanel"><div class="vp-sec">'+
      '<h4>Textos</h4>'+
      '<label class="cad-lbl" for="lzSub">Frase de destaque (abaixo do título)</label><input class="cad-in" id="lzSub" maxlength="200" value="'+_lzA(V.subtitulo)+'">'+
      '<label class="cad-lbl" for="lzSobre">Sobre o veículo'+(!V.sobre&&AU.sobre?' <small class="lz-auto">texto automático — mude à vontade</small>':'')+'</label><textarea class="cad-in" id="lzSobre" rows="5">'+esc(V.sobre||AU.sobre||'')+'</textarea>'+
      lzMarketingVantagens(V)+'<div class="lz-post-wrap"><div class="lz-post-head"><h4>Gerador de post</h4><p class="cad-help">A prévia usa esta cor, o preço, as vantagens e os itens marcados na ficha. Não usa IA.</p></div><div id="lzPostOut"></div></div></div></section>'+

      '<section class="vpx-panel lz-tab-panel" data-lz-panel="ficha" role="tabpanel"><div class="vp-sec">'+
      '<h4>Ficha técnica</h4><div class="lz-ficha">'+LZ_FICHA.map(function(r){
        var val=(V.ficha||{})[r[0]]||'';
        return '<div><label class="cad-lbl">'+esc(r[1])+'</label><input class="cad-in" data-ficha="'+r[0]+'" value="'+_lzA(val)+'"></div>';
      }).join('')+'</div><div class="lz-fi-blocos">'+LZ_FICHA_LISTAS.map(function(r){ return lzFichaListaHtml(V,r[0],r[1]); }).join('')+'</div>'+

      '<h4>Opcionais de fábrica</h4><p class="cad-help">Sem código = acessório (não aparece na página). "Obrigat" na descrição = entra no preço como incluso. Desmarcado = não aparece em lugar nenhum.</p>'+
      '<div class="lz-lista">'+(d.opcionais||[]).map(function(o){
        return '<div class="lz-item'+(o.ativo?'':' off')+'" data-opc="'+esc(o.id)+'">'+
          '<div class="lz-linha"><span class="lz-cod">'+esc(o.codigo||'—')+'</span>'+
            '<input class="cad-in" data-k="nome" value="'+_lzA(o.nome)+'" placeholder="nome">'+
            '<input class="cad-in lz-num" data-k="preco" inputmode="numeric" value="'+_lzA(o.preco?_rsF(o.preco):'')+'" placeholder="R$">'+
            '<label class="vd-ck'+(o.ativo?' on':'')+'"><input type="checkbox" data-k="ativo"'+(o.ativo?' checked':'')+'><span>ativo</span></label></div>'+
          '<textarea class="cad-in" data-k="descricao" rows="2" placeholder="o que vem no pacote">'+esc(o.descricao)+'</textarea></div>';
      }).join('')+'</div></div></section>'+

      /* v1103 — SEO da página da versão (os mesmos campos da aba SEO da ficha; vazio = automático) */
      (function(){ var so=V.seo||{}; var fotos=(d.fotos||[]).map(function(f){ return f.url; }).filter(Boolean);
        /* v1107: campo vazio abre com o automático da página; igual ao automático = continua automático */
        var au=function(k){ return so[k]||AU[k]||''; }, tag=function(k){ return (!so[k]&&AU[k])?' <small class="lz-auto">automático</small>':''; };
        return '<section class="vpx-panel lz-tab-panel" data-lz-panel="seo" role="tabpanel"><div class="vp-sec"><h4>SEO da página</h4><p class="cad-help">Os campos já vêm preenchidos com o melhor texto automático disponível para esta versão. Ajuste somente quando quiser personalizar. Título até 70 letras e descrição até 160.</p>'+
        '<div class="lz-ficha">'+
        '<div class="lz-longo"><label class="cad-lbl">Título da página (Google e aba do navegador)'+tag('titulo')+'</label><input class="cad-in" id="lzSeoTit" maxlength="70" value="'+_lzA(au('titulo'))+'"></div>'+
        '<div class="lz-longo"><label class="cad-lbl">Descrição do Google (até 160)'+tag('descricao')+'</label><textarea class="cad-in" id="lzSeoDesc" rows="2" maxlength="160">'+esc(au('descricao'))+'</textarea></div>'+
        '<input type="hidden" id="lzSeoPal" value="'+_lzA(au('palavras'))+'">'+
        '<div class="lz-longo"><p class="cad-help seo-keywords-info">O Google ignora a tag <code>keywords</code>. O SEO desta página prioriza título, descrição e conteúdo específico da versão.</p></div>'+
        '<div class="lz-longo"><label class="cad-lbl">Texto extra na página (bloco "Mais sobre…")</label><textarea class="cad-in" id="lzSeoTexto" rows="4" maxlength="2000">'+esc(so.texto||'')+'</textarea></div>'+
        '<div><label class="cad-lbl">Título da prévia do WhatsApp'+tag('og_titulo')+'</label><input class="cad-in" id="lzSeoOgT" maxlength="90" value="'+_lzA(au('og_titulo'))+'"></div>'+
        '<div><label class="cad-lbl">Descrição da prévia'+tag('og_desc')+'</label><input class="cad-in" id="lzSeoOgD" maxlength="200" value="'+_lzA(au('og_desc'))+'"></div>'+
        '<div><label class="cad-lbl">Foto da prévia</label><select class="cad-in" id="lzSeoOgF"><option value=""'+(!so.og_foto?' selected':'')+'>capa (automático)</option>'+fotos.map(function(u,i){ return '<option value="'+_lzA(u)+'"'+(so.og_foto===u?' selected':'')+'>Foto '+(i+1)+'</option>'; }).join('')+'</select></div>'+
        '<div><label class="vd-ck'+(so.indexar===false?'':' on')+'"><input type="checkbox" id="lzSeoIdx"'+(so.indexar===false?'':' checked')+'><span>Deixar o Google indexar</span></label></div>'+
        '</div></div></section>'; })()+
      '</div></div>'+
      '<div class="lz-rodape"><button type="button" class="cad-btn lz-salvar" id="lzSalvar2">Salvar e publicar</button></div>'+
    '</div>';
    lzPintaFotos();
    $('lzSalvar').onclick=lzSalvar; $('lzSalvar2').onclick=lzSalvar;
    $('lzAddFoto').onclick=function(){ $('lzArq').click(); };
    $('lzArq').onchange=function(){ var fs=Array.prototype.slice.call(this.files||[]); this.value=''; lzSubirFotos(fs); };
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-num'),function(i){ if(typeof estMaskRS==='function') i.oninput=estMaskRS; });
    Array.prototype.forEach.call(ed.querySelectorAll('.vd-ck input'),function(i){
      i.onchange=function(){ var lab=i.parentElement; lab.classList.toggle('on',i.checked); var it=lab.closest('.lz-item'); if(it) it.classList.toggle('off',!i.checked); };
    });
    lzFichaListaWire(ed);
    lzMarketingListaWire(ed);
    lzEstoqueWire(ed);
    lzCondWire(ed);
    lzReagirWire(ed);
    lzPostPinta();
    Array.prototype.forEach.call(ed.querySelectorAll('[data-lz-tab]'),function(b){ b.onclick=function(){ lzTabAbrir(b.getAttribute('data-lz-tab')); }; });
    lzTabAbrir(_lz.tab||'veiculo');
    /* v1233 — a rede: a foto do estado RECÉM-CARREGADO vira a referência, e
       daí em diante toda digitação é guardada se, e só se, diferir dela. */
    _lz.rascBase=JSON.stringify(lzRascTira()||{});
    ed.addEventListener('input', lzRascAgenda);
    ed.addEventListener('change', lzRascAgenda);
    lzRascBarra();
  }
  /* ---------- v1107: a galeria AGRUPADA POR COR ---------- */
  function lzTodosGrupos(){
    var cores=((_lz.dados||{}).cores||[]), gs=cores.map(function(c){ return { cod:c.codigo, nome:c.nome, hex:c.hex, ativa:c.ativa!==false }; });
    gs.push({ cod:'', nome:'Sem cor (internas e detalhes)', hex:'', ativa:true, semCor:true });
    /* foto com código de cor que não existe mais na versão: vai pro fim, num grupo próprio */
    _lz.fotos.forEach(function(f){ if(f.c && !gs.some(function(g){ return g.cod===f.c; })) gs.push({ cod:f.c, nome:'Cor '+f.c+' (não cadastrada)', hex:'', ativa:false }); });
    return gs;
  }
  function lzGrupos(){
    var gs=lzTodosGrupos();
    return _lz.cor===null?gs:gs.filter(function(g){ return String(g.cod)===String(_lz.cor); });
  }
  /* a ordem no banco = a ordem dos grupos (cores na ordem da Cotação, depois as sem cor), e dentro do grupo a ordem das setas */
  function lzOrdena(){
    var gs=lzTodosGrupos(), rank={}; gs.forEach(function(g,i){ rank[g.cod]=i; });
    _lz.fotos=_lz.fotos.map(function(f,i){ return { f:f, i:i }; }).sort(function(a,b){ return (rank[a.f.c]-rank[b.f.c]) || (a.i-b.i); }).map(function(x){ return x.f; });
  }
  function lzPintaFotos(){
    var g=$('lzFotos'); if(!g) return;
    lzOrdena();
    var gs=lzGrupos();
    if(!_lz.fotos.length){ g.innerHTML='<p class="cad-help">Sem fotos ainda. Adicione abaixo.</p>'; return; }
    g.innerHTML=gs.map(function(gr){
      var fs=_lz.fotos.map(function(f,i){ return { f:f, i:i }; }).filter(function(x){ return x.f.c===gr.cod; });
      if(!fs.length && gr.semCor) return '';
      var capaCor=gr.cod?(_lz.capas[gr.cod]||''):'';
      var capaViva=capaCor && !_lz.fotos.some(function(f){ return f.apagar && f.u===capaCor; });
      return '<section class="lz-grupo'+(gr.ativa?'':' off')+'" data-g="'+_lzA(gr.cod)+'">'+
        /* ⚠️ <div>, não <header>: o app esconde todo <header> (body.app-on header{display:none}) */
        '<div class="lz-gh">'+(gr.semCor?'<span class="lz-sw lz-sw-x"></span>':('<span class="lz-sw" style="background:'+_lzA(/^#[0-9a-f]{3,8}$/i.test(gr.hex)?gr.hex:'#cbd5e1')+'"></span>'))+
          '<b>'+esc(gr.nome)+'</b>'+(gr.cod?('<span class="lz-cod">'+esc(gr.cod)+'</span>'):'')+'<span class="lz-gn">'+fs.length+' foto'+(fs.length===1?'':'s')+(gr.ativa?'':' · cor inativa')+'</span>'+
          (gr.cod?('<span class="lz-gcapa'+(capaViva?' on':'')+'">'+(capaViva?('<img src="'+esc(capaCor)+'" alt=""><span>capa da cor</span>'):'<span>sem capa própria — usa a capa da versão</span>')+'</span>'):'')+
        '</div>'+
        (fs.length?('<div class="lz-fotos">'+fs.map(function(x){
          var f=x.f, i=x.i, capa=_lz.capa && _lz.capa===f.u, ehCapaCor=gr.cod && capaCor===f.u;
          return '<div class="lz-f'+(f.apagar?' apagar':'')+(capa?' capa':'')+(ehCapaCor?' capacor':'')+'" data-i="'+i+'">'+
            '<button type="button" class="lz-fvisual" data-a="menu" aria-label="Abrir ações desta foto" title="Abrir ações desta foto"'+(f.apagar?' disabled':'')+'><img src="'+esc(f.u)+'" loading="lazy" alt=""></button>'+
            '<div class="lz-fb">'+(gr.cod?'<button type="button" data-a="capacor" title="Capa desta cor (1ª foto quando o cliente escolhe a cor)">&#9733; cor</button>':'')+
              '<button type="button" data-a="capa" title="Capa da versão (card do modelo e WhatsApp)">&#9733;'+(gr.cod?'':' capa')+'</button>'+
              '<button type="button" data-a="esq" title="Mover pra esquerda">&#9664;</button><button type="button" data-a="dir" title="Mover pra direita">&#9654;</button><button type="button" data-a="del" title="Apagar">&#128465;</button></div>'+
            '<div class="lz-fm"><select data-a="cor"><option value=""'+(!f.c?' selected':'')+'>sem cor</option>'+((_lz.dados||{}).cores||[]).map(function(c){ return '<option value="'+_lzA(c.codigo)+'"'+(c.codigo===f.c?' selected':'')+'>'+esc(c.codigo||c.nome)+'</option>'; }).join('')+'</select>'+
            '<select data-a="tipo">'+LZ_TIPOS.map(function(t){ return '<option'+(t===f.t?' selected':'')+'>'+t+'</option>'; }).join('')+'</select></div>'+
            (capa?'<span class="lz-capa">CAPA DA VERSÃO</span>':'')+(ehCapaCor?'<span class="lz-capa lz-capa-cor">CAPA '+esc(gr.cod)+'</span>':'')+'</div>';
        }).join('')+'</div>'):'<p class="cad-help lz-gvazio">Nenhuma foto desta cor. Escolha a cor em "Cor das fotos novas" e adicione.</p>')+
      '</section>';
    }).join('');
    Array.prototype.forEach.call(g.querySelectorAll('button[data-a]'),function(b){
      b.onclick=function(){
        var card=b.closest?b.closest('.lz-f'):b.parentNode.parentNode;
        var i=Number(card&&card.getAttribute('data-i')), a=b.getAttribute('data-a'), f=_lz.fotos[i];
        if(a==='menu'){ lzFotoIaAbrir(i,b); return; }
        if(a==='capa'){ if(_lz.capa===f.u){ _lz.capa=''; lzPintaFotos(); } else lzEnquadrar(f,{ tipo:'versao' }); return; }
        if(a==='capacor'){ if(_lz.capas[f.c]===f.u){ delete _lz.capas[f.c]; lzPintaFotos(); } else lzEnquadrar(f,{ tipo:'cor', cod:f.c }); return; }
        if(a==='del') f.apagar=!f.apagar;
        /* setas: troca com a vizinha DO MESMO GRUPO (a lista já está ordenada por grupo) */
        if(a==='esq' && i>0 && _lz.fotos[i-1].c===f.c){ _lz.fotos.splice(i,1); _lz.fotos.splice(i-1,0,f); }
        if(a==='dir' && i<_lz.fotos.length-1 && _lz.fotos[i+1].c===f.c){ _lz.fotos.splice(i,1); _lz.fotos.splice(i+1,0,f); }
        lzPintaFotos();
      };
    });
    Array.prototype.forEach.call(g.querySelectorAll('select[data-a]'),function(s){
      s.onchange=function(){ var i=Number(s.parentNode.parentNode.getAttribute('data-i')); if(s.getAttribute('data-a')==='cor'){ _lz.fotos[i].c=s.value; lzPintaFotos(); } else _lz.fotos[i].t=s.value; };
    });
  }

  /* ---------- AÇÕES DA FOTO + IA: o mesmo menu do Estoque ----------
     A foto gerada entra no bucket 0 km pela porta já autenticada, ocupa a
     mesma posição/cor/tipo e substitui somente a linha original. Textos,
     preços, opcionais e qualquer edição ainda não salva ficam intocados. */
  function lzBlobDataUrl(blob){
    return new Promise(function(resolve,reject){
      var fr=new FileReader(); fr.onload=function(){ resolve(String(fr.result||'')); };
      fr.onerror=function(){ reject(new Error('Não consegui preparar a imagem.')); };
      fr.readAsDataURL(blob);
    });
  }
  function lzFotoIaDados(){
    var d=_lz.dados||{}, V=d.versao||{}, P=d.precos||{};
    var ano=lzAnoModelo(V.model_year);
    return { modelo:lzTitulo(d), ano:ano, km:0, categoria:'0 KM',
      precoAnuncio:Number(P.varejo)||0, precoDe:Number(P.tabela)||0,
      precoPor:Number(P.varejo)||0, fipe:Number(P.tabela)||0,
      cambio:String((V.ficha||{}).cambio||''), combustivel:'',
      fatos:['0 km','Garantia de fábrica'].concat(Array.isArray(V.vantagens)?V.vantagens:[]) };
  }
  function lzFotoIaAbrir(i,anchorEl){
    i=Math.max(0,Math.min(Number(i)||0,_lz.fotos.length-1));
    var foto=_lz.fotos[i], d=_lz.dados;
    if(!foto||!foto.u||!d||foto.apagar) return;
    var origem=foto.u, galeria=_lz.fotos.filter(function(f){ return !f.apagar; }).map(function(f){ return f.u; });
    fotoIaEditarUrl(origem,'zero_km',async function(blob,meta){
      var dataUrl=await lzBlobDataUrl(blob);
      var up=await apiTimeout('/api/novo-admin',{ acao:'foto', versao_id:d.versao.id,
        modelo_slug:d.modelo.slug, versao_slug:d.versao.slug,
        cor_codigo:foto.c, tipo:foto.t, dataUrl:dataUrl },60000);
      if(!up||!up.ok||!up.id||!up.url) throw new Error((up&&up.erro)||'Não consegui guardar a imagem.');

      var eraCapa=_lz.capa===origem, cores=[];
      (d.cores||[]).forEach(function(c){
        if(_lz.capas[c.codigo]===origem) cores.push({ id:c.id, capa_url:up.url });
      });
      var ordem=isFinite(Number(foto.o))?Number(foto.o):i;
      var troca={ acao:'salvar', versao_id:d.versao.id,
        fotos:[{ id:up.id, ordem:ordem, tipo:foto.t, cor_codigo:foto.c }],
        apagar_fotos:[foto.id] };
      if(eraCapa) troca.versao={ capa_url:up.url };
      if(cores.length) troca.cores=cores;
      var salvo=await apiTimeout('/api/novo-admin',troca,30000);
      if(!salvo||!salvo.ok){
        /* A foto nova já foi enviada; se a troca falhar, removemos a órfã. */
        try{ await apiTimeout('/api/novo-admin',{ acao:'salvar', versao_id:d.versao.id, apagar_fotos:[up.id] },20000); }catch(_){ }
        throw new Error((salvo&&salvo.erros&&salvo.erros.join(', '))||'Não consegui substituir a foto.');
      }
      var atual=_lz.fotos.indexOf(foto);
      if(atual<0) throw new Error('A foto mudou durante a edição.');
      _lz.fotos[atual]={ id:up.id, u:up.url, c:foto.c, t:foto.t, o:ordem, apagar:false };
      if(eraCapa) _lz.capa=up.url;
      cores.forEach(function(c){
        var cor=(d.cores||[]).filter(function(x){ return String(x.id)===String(c.id); })[0];
        if(cor) _lz.capas[cor.codigo]=up.url;
      });
      lzPintaFotos();
      return true;
    },anchorEl,lzFotoIaDados(),galeria);
  }

  /* ---------- v1107: ENQUADRAR — arrasta a foto pra centralizar o carro ----------
     Moldura 4:3 (a proporção dos cards). O que aparece dentro da moldura é o
     que vira a capa: recorte no aparelho (canvas 1600×1200, jpeg) → ação
     `capa` do servidor → URL própria (capa-…). "Usar a foto inteira" mantém o
     comportamento antigo (a própria foto da galeria é a capa). Se o navegador
     não deixar ler a imagem (CORS), cai na foto inteira e avisa. */
  function lzEnquadrar(f, alvo){
    var old=$('lzEnq'); if(old) old.parentNode.removeChild(old);
    var d=_lz.dados; if(!d) return;
    var rot=alvo.tipo==='cor'?('Capa da cor '+alvo.cod):'Capa da versão';
    var m=document.createElement('div'); m.className='lz-enq'; m.id='lzEnq';
    m.innerHTML='<div class="lz-enq-box" role="dialog" aria-label="Enquadrar a capa">'+
      '<div class="lz-enq-topo"><b>'+esc(rot)+'</b><button type="button" class="lz-enq-x" id="lzEnqX" aria-label="Fechar">×</button></div>'+
      '<p class="cad-help">Arraste a foto pra centralizar o carro. O que está dentro da moldura vira a capa.</p>'+
      '<div class="lz-enq-frame" id="lzEnqFrame"><img id="lzEnqImg" alt="" draggable="false"></div>'+
      '<label class="lz-enq-zoom">Zoom <input type="range" id="lzEnqZoom" min="100" max="300" value="100"></label>'+
      '<div class="lz-enq-acoes"><button type="button" class="cad-btn lz-enq-sec" id="lzEnqInteira">Usar a foto inteira</button><button type="button" class="cad-btn lz-salvar" id="lzEnqOk">Usar enquadrada</button></div>'+
      '<div class="cad-help" id="lzEnqSt"></div></div>';
    document.body.appendChild(m);
    var fr=$('lzEnqFrame'), im=$('lzEnqImg'), zoom=$('lzEnqZoom'), st=$('lzEnqSt');
    var iw=0, ih=0, s0=1, z=1, ox=0, oy=0, FW=0, FH=0;
    function aplica(alvoU){
      if(alvo.tipo==='cor'){
        _lz.capas[alvo.cod]=alvoU;
        ((_lz.dados||{}).cores||[]).forEach(function(c){ if(String(c.codigo)===String(alvo.cod)) c.capa_url=alvoU; });
      } else {
        _lz.capa=alvoU;
        if(_lz.dados&&_lz.dados.versao) _lz.dados.versao.capa_url=alvoU;
      }
      fecha(); lzPintaFotos();
    }
    function fecha(){ try{ m.parentNode.removeChild(m); }catch(_){} }
    function clamp(){
      var dw=iw*s0*z, dh=ih*s0*z;
      ox=Math.min(0, Math.max(FW-dw, ox)); oy=Math.min(0, Math.max(FH-dh, oy));
      im.style.width=dw+'px'; im.style.height=dh+'px'; im.style.left=ox+'px'; im.style.top=oy+'px';
    }
    function mede(){ FW=fr.clientWidth; FH=fr.clientHeight; s0=Math.max(FW/iw, FH/ih); }
    im.onload=function(){
      iw=im.naturalWidth; ih=im.naturalHeight; if(!iw||!ih) return;
      mede(); var dw=iw*s0, dh=ih*s0; ox=(FW-dw)/2; oy=(FH-dh)/2; clamp();
    };
    im.src=f.u;
    zoom.oninput=function(){
      var nz=Number(zoom.value)/100, cx=(FW/2-ox)/(s0*z), cy=(FH/2-oy)/(s0*z);   /* mantém o centro */
      z=nz; ox=FW/2-cx*s0*z; oy=FH/2-cy*s0*z; clamp();
    };
    var drag=null;
    fr.onpointerdown=function(e){ drag={ x:e.clientX, y:e.clientY, ox:ox, oy:oy }; try{ fr.setPointerCapture(e.pointerId); }catch(_){} e.preventDefault(); };
    fr.onpointermove=function(e){ if(!drag) return; ox=drag.ox+(e.clientX-drag.x); oy=drag.oy+(e.clientY-drag.y); clamp(); };
    fr.onpointerup=fr.onpointercancel=function(){ drag=null; };
    window.addEventListener('resize', function r(){ if(!document.body.contains(m)) return window.removeEventListener('resize', r); if(iw){ var cx=(FW/2-ox)/(s0*z), cy=(FH/2-oy)/(s0*z); mede(); ox=FW/2-cx*s0*z; oy=FH/2-cy*s0*z; clamp(); } });
    $('lzEnqX').onclick=fecha; m.onclick=function(e){ if(e.target===m) fecha(); };
    $('lzEnqInteira').onclick=function(){ aplica(f.u); };
    $('lzEnqOk').onclick=function(){
      if(!iw){ aplica(f.u); return; }
      var ok=$('lzEnqOk'); ok.disabled=true; ok.textContent='Recortando…';
      lzRecorta(f.u, { sx:-ox/(s0*z), sy:-oy/(s0*z), sw:FW/(s0*z), sh:FH/(s0*z) }).then(function(du){
        if(!du){ st.textContent='Não consegui recortar esta foto no navegador — usei a foto inteira.'; try{ toast('Usei a foto inteira como capa.'); }catch(_){} aplica(f.u); return; }
        st.textContent='Enviando a capa…';
        return apiTimeout('/api/novo-admin',{ acao:'capa', versao_id:d.versao.id, modelo_slug:d.modelo.slug, versao_slug:d.versao.slug, cor_codigo:(alvo.tipo==='cor'?alvo.cod:''), dataUrl:du },60000)
          .then(function(r){
            if(!r || !r.ok || !r.url){ st.textContent=(r&&r.erro)||'Não consegui enviar a capa.'; ok.disabled=false; ok.textContent='Usar enquadrada'; return; }
            aplica(r.url); try{ toast('Enquadramento salvo e publicado.'); }catch(_){}
          });
      }).catch(function(){ st.textContent='Falhou. Tente de novo.'; ok.disabled=false; ok.textContent='Usar enquadrada'; });
    };
  }
  /* o recorte: pede a imagem de novo com crossOrigin (o bucket público responde
     com CORS *), desenha só o retângulo escolhido num canvas 4:3 e devolve jpeg */
  function lzRecorta(url, r){
    return new Promise(function(ok){
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){
        try{
          var W=1600, H=1200, cv=document.createElement('canvas'); cv.width=W; cv.height=H;
          cv.getContext('2d').drawImage(im, r.sx, r.sy, r.sw, r.sh, 0, 0, W, H);
          ok(cv.toDataURL('image/jpeg',0.88));
        }catch(_){ ok(''); }
      };
      im.onerror=function(){ ok(''); };
      /* http(s): pede com um sufixo pra não pegar do cache uma cópia sem os cabeçalhos de CORS; data: vai como está */
      im.src=/^https?:/i.test(url)?(url+(url.indexOf('?')<0?'?':'&')+'enq=1'):url;
    });
  }
  /* a foto encolhe pra 1600 px no aparelho — regra do egress, e do 4G no pátio */
  function lzReduz(file){
    return new Promise(function(ok){
      var im=new Image(), url=URL.createObjectURL(file);
      im.onload=function(){
        var MAX=1600, w=im.naturalWidth, h=im.naturalHeight, k=Math.min(1, MAX/Math.max(w,h));
        var cv=document.createElement('canvas'); cv.width=Math.round(w*k); cv.height=Math.round(h*k);
        cv.getContext('2d').drawImage(im,0,0,cv.width,cv.height);
        URL.revokeObjectURL(url); ok(cv.toDataURL('image/jpeg',0.86));
      };
      im.onerror=function(){ URL.revokeObjectURL(url); ok(''); };
      im.src=url;
    });
  }
  function lzSubirFotos(files){
    var lista=Array.prototype.slice.call(files||[]), st=$('lzAddSt'), bt=$('lzAddFoto'), d=_lz.dados; if(!lista.length || !d) return;
    var cor=($('lzAddCor')||{}).value||'', tipo=($('lzAddTipo')||{}).value||'externa', total=lista.length, ok=0, falhas=[];
    if(bt) bt.disabled=true;
    (async function(){
      for(var i=0;i<lista.length;i++){
        var f=lista[i]; st.textContent='Preparando foto '+(i+1)+' de '+total+'…';
        try{
          var du=await lzReduz(f); if(!du) throw new Error('Não consegui ler o arquivo.');
          st.textContent='Enviando foto '+(i+1)+' de '+total+'…';
          var r=await apiTimeout('/api/novo-admin',{ acao:'foto', versao_id:d.versao.id, modelo_slug:d.modelo.slug, versao_slug:d.versao.slug, cor_codigo:cor, tipo:tipo, dataUrl:du },60000);
          if(!r||!r.ok) throw new Error((r&&r.erro)||'Falha no envio.');
          ok++; _lz.fotos.push({ id:r.id, u:r.url, c:cor, t:tipo, o:r.ordem, apagar:false }); lzPintaFotos();
        }catch(e){ falhas.push((f&&f.name?f.name+': ':'')+String((e&&e.message)||'Falha no envio.')); }
      }
      if(bt) bt.disabled=false;
      st.textContent=ok+' de '+total+' foto'+(total===1?'':'s')+' adicionada'+(ok===1?'':'s')+'.'+(falhas.length?' '+falhas.join(' '):'');
    })();
  }

  /* ==========================================================================
     🔴🔴🔴 v1233 — O EDITOR JOGAVA FORA O QUE VOCÊ DIGITOU, EM SILÊNCIO
     --------------------------------------------------------------------------
     26/09, o Angelo: "ajustei os itens de marketing e ficha tecnica e preco
     promocional, mas nao salvou no banco".

     Fui medir antes de consertar, e o que eu achei não foi o que eu tinha
     palpitado. Palpitei que os FABs azuis cobriam o "Salvar e publicar" —
     medi no app, em dois tamanhos de tela: o botão fica em 600–644 px e os
     FABs em 776–824. ZERO por cento coberto. O palpite estava errado.

     🔑 O DEFEITO É A FALTA DE UMA REDE. Esta tela não tinha NADA que
     protegesse o que foi digitado: nem `beforeunload`, nem marca de
     alteração pendente, nem pergunta. E o `lzAbrirVersao` RECONSTRÓI a tela
     inteira a partir do banco. Então trocar de cor, voltar e entrar de novo,
     ou reabrir a versão apagava tudo que não tinha sido salvo — sem um
     aviso, sem um pedido de confirmação, sem deixar rastro.

     Provado à parte, com as duas pontas do caminho do preço promocional:
     com valor no campo ele grava certo; com o campo VAZIO ele APAGA o que já
     estava gravado (a tela omite a chave e o servidor troca o `ficha`
     inteiro). Ou seja: a tela se reconstruía vazia e o save seguinte
     enterrava o dado. Duas coisas certas, uma em cima da outra, dando errado.

     ⚠️ POR QUE RASCUNHO E NÃO UM "TEM CERTEZA?".
     Interceptar a saída seria pedir pra quebrar caminho que hoje funciona —
     são vários (o Voltar do app, a lista, a troca de cor, o menu) e o
     primeiro que eu esquecesse continuaria perdendo dado. Além disso
     `confirm()` é diálogo nativo, que esta casa não usa. O rascunho não
     intercepta nada: ele deixa acontecer e devolve depois.

     ⚠️ MORA NO APARELHO (localStorage), não na memória: assim ele sobrevive
     a fechar o app, que é justamente quando doeria mais perder.
     ⚠️ É POR VERSÃO **E POR COR** — o preço promocional é por cor, então um
     rascunho só por versão devolveria o valor na cor errada.
     ⚠️ A CHAVE DE CADA CAMPO É ESTÁVEL (id, data-ficha, data-lz-publico, ou
     a linha data-opc/data-cor + o data-k), NUNCA a posição na lista. Com
     posição, uma linha a mais embaralharia tudo — devolveria o texto de um
     campo dentro de outro, que é pior do que perder.
     ⚠️ LIMITE CONHECIDO, escrito pra não virar surpresa: item ADICIONADO à
     mão numa lista (uma vantagem nova, por exemplo) não tem par na tela
     reconstruída e não volta. O que existia volta; o que foi criado e não
     salvo, não. A faixa diz quantos campos voltaram.
     ========================================================================== */
  var LZ_RASC_PRE='mev_lz_rasc:', LZ_RASC_DIAS=7, _lzRascTimer=null;
  function lzRascChave(){
    var v=(_lz.versao&&_lz.versao.id)||''; if(!v) return '';
    return LZ_RASC_PRE+v+':'+(String(_lz.cor||'').toUpperCase()||'_geral');
  }
  function lzCampoChave(el){
    if(!el) return '';
    if(el.id) return 'id:'+el.id;
    if(el.hasAttribute('data-ficha')) return 'ficha:'+el.getAttribute('data-ficha');
    if(el.hasAttribute('data-lz-publico')) return 'publico:'+el.getAttribute('data-lz-publico');
    if(el.hasAttribute('data-un-opc')){
      var cxu=el.closest?el.closest('[data-un]'):null;
      if(cxu) return 'un:'+cxu.getAttribute('data-un')+'/opc:'+el.getAttribute('data-un-opc');
    }
    var linha=el.closest?el.closest('[data-opc],[data-cor],[data-un]'):null;
    if(linha && el.hasAttribute('data-k')){
      var base=linha.hasAttribute('data-opc')?('opc:'+linha.getAttribute('data-opc'))
             : linha.hasAttribute('data-un')?('un:'+linha.getAttribute('data-un'))
             : ('cor:'+linha.getAttribute('data-cor'));
      return base+'/'+el.getAttribute('data-k');
    }
    /* linhas de lista (vantagens, itens da ficha): grupo + posição + papel.
       A posição só vale DENTRO do grupo, e some sozinha se o grupo mudar de
       tamanho — o que é exatamente o comportamento seguro. */
    /* ======================================================================
       🔴🔴🔴 v1239 — QUATRO LINHAS DIFERENTES, UMA CHAVE SÓ
       ----------------------------------------------------------------------
       Angelo, 27/09: "por que vantagens do veiculo puxou 8 vezes a mesma
       coisa". No banco estavam as 8 vantagens CERTAS e diferentes; na tela,
       oito cópias de "Garantia VW 3 anos" — a última delas.

       A culpa é minha, da v1233. Esta função procurava o grupo da linha em
       `[data-ficha-grupo]`. Só que a lista de vantagens usa outro atributo:
       `data-marketing-grupo`. Com o grupo NULO, o `g` virava '?' e os
       "irmãos" viravam `[item]` — uma lista de um elemento só, onde
       `indexOf(item)` é SEMPRE 0. Resultado medido no navegador:

           "Top de linha com ADAS"  →  lista:?#0/texto
           "Bancos em couro"        →  lista:?#0/texto
           "Painel digital"         →  lista:?#0/texto
           "Garantia VW 3 anos"     →  lista:?#0/texto

       Ao guardar, as oito escreviam na mesma chave e a última vencia. Ao
       restaurar, a mesma chave era devolvida às oito. O rascunho que eu fiz
       pra NÃO perder dado estava pronto pra apagar sete vantagens de uma vez.

       🔑 DUAS CORREÇÕES, e a segunda importa mais que a primeira:
       1) a chave conhece os dois atributos de grupo;
       2) SEM grupo, a posição passa a ser contada dentro do EDITOR inteiro,
          nunca dentro de uma lista de um elemento. Assim a chave pode ficar
          esquisita, mas NUNCA colapsa — e colapsar é o que destrói dado.
       ⚠️ E ainda existe a rede do item 3 (lzRascTira): se duas linhas ainda
       assim caírem na mesma chave, o rascunho inteiro é descartado. Rascunho
       corrompido é pior que rascunho nenhum. */
    var item=el.closest?el.closest('[data-ficha-item]'):null;
    if(item){
      var grupo=item.closest('[data-ficha-grupo],[data-marketing-grupo]');
      var g=grupo?(grupo.getAttribute('data-ficha-grupo')||grupo.getAttribute('data-marketing-grupo')||'?'):'?';
      var raiz=grupo||(el.closest?el.closest('#lzEditor'):null)||document;
      var irmaos=[].slice.call(raiz.querySelectorAll('[data-ficha-item]'));
      var papel=el.classList.contains('lz-fi-on')?'on':'texto';
      return 'lista:'+g+'#'+irmaos.indexOf(item)+'/'+papel;
    }
    return '';
  }
  function lzRascTira(){
    var ed=$('lzEditor'); if(!ed) return null;
    var campos={}, colidiu=false;
    Array.prototype.forEach.call(ed.querySelectorAll('input,textarea,select'),function(el){
      if(el.type==='file') return;
      var k=lzCampoChave(el); if(!k) return;
      /* 🔴 v1239 — A REDE QUE FALTAVA. Duas telas dividindo uma chave não é
         um detalhe: é o rascunho devolvendo o valor de um campo dentro de
         outro. Foi assim que oito vantagens viraram oito cópias da última.
         Na dúvida, rascunho NENHUM — perder o que não foi salvo dói; gravar
         por cima do que estava certo dói muito mais. */
      if(Object.prototype.hasOwnProperty.call(campos,k)) colidiu=true;
      campos[k]=(el.type==='checkbox'||el.type==='radio')?(el.checked?1:0):String(el.value==null?'':el.value);
    });
    if(colidiu){ try{ if(window.console&&console.warn) console.warn('[MEV] rascunho descartado: chaves repetidas na tela'); }catch(_){} return null; }
    return campos;
  }
  function lzRascGuarda(){
    try{
      var ch=lzRascChave(); if(!ch) return;
      var agora=lzRascTira(); if(!agora) return;
      var txtAgora=JSON.stringify(agora);
      /* nada mudou desde que a tela abriu → não existe rascunho a guardar.
         Sem esta comparação, abrir a tela já criaria rascunho e a faixa
         apareceria sempre — e faixa que aparece sempre ninguém lê. */
      if(txtAgora===_lz.rascBase){ try{ localStorage.removeItem(ch); }catch(_){} return; }
      localStorage.setItem(ch, JSON.stringify({ em:Date.now(), campos:agora }));
    }catch(_){}
  }
  function lzRascAgenda(){ clearTimeout(_lzRascTimer); _lzRascTimer=setTimeout(lzRascGuarda,400); }
  function lzRascLimpa(){ try{ var ch=lzRascChave(); if(ch) localStorage.removeItem(ch); }catch(_){} }
  function lzRascLer(){
    try{
      var ch=lzRascChave(); if(!ch) return null;
      var r=JSON.parse(localStorage.getItem(ch)||'null');
      if(!r||!r.campos||typeof r.campos!=='object') return null;
      if(!r.em || (Date.now()-r.em) > LZ_RASC_DIAS*864e5){ localStorage.removeItem(ch); return null; }
      return r;
    }catch(_){ return null; }
  }
  function lzRascPoe(r){
    var ed=$('lzEditor'); if(!ed||!r||!r.campos) return { voltaram:0, faltaram:0 };
    var voltaram=0, vistos={};
    Array.prototype.forEach.call(ed.querySelectorAll('input,textarea,select'),function(el){
      if(el.type==='file') return;
      var k=lzCampoChave(el); if(!k || !(k in r.campos)) return;
      vistos[k]=1;
      var v=r.campos[k];
      if(el.type==='checkbox'||el.type==='radio'){ if(el.checked!==!!v){ el.checked=!!v; try{ el.dispatchEvent(new Event('change',{bubbles:true})); }catch(_){} } }
      else if(String(el.value||'')!==String(v)){ el.value=v; try{ el.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){} }
      voltaram++;
    });
    var faltaram=Object.keys(r.campos).filter(function(k){ return !vistos[k]; }).length;
    return { voltaram:voltaram, faltaram:faltaram };
  }
  function lzRascHora(ts){
    try{ var d=new Date(ts); return ('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2); }catch(_){ return ''; }
  }
  function lzRascBarra(){
    var ed=$('lzEditor'), r=lzRascLer(); if(!ed) return;
    var velha=ed.querySelector('.lz-rasc'); if(velha) velha.parentNode.removeChild(velha);
    if(!r) return;
    var cx=document.createElement('div'); cx.className='lz-rasc'; cx.setAttribute('role','status');
    cx.innerHTML='<div class="lz-rasc-txt"><b>Alterações não salvas desta página</b>'+
      '<span>Guardadas às '+esc(lzRascHora(r.em))+' e não publicadas. Restaurar devolve o que você tinha digitado.</span></div>'+
      '<div class="lz-rasc-bts"><button type="button" class="cad-btn lz-rasc-ok" id="lzRascRestaura">Restaurar</button>'+
      '<button type="button" class="cad-btn lz-rasc-nao" id="lzRascDescarta">Descartar</button></div>';
    ed.insertBefore(cx, ed.firstChild);
    cx.querySelector('#lzRascRestaura').onclick=function(){
      var res=lzRascPoe(r);
      try{ lzPostPinta(); }catch(_){}
      try{ toast(res.voltaram+' campo'+(res.voltaram===1?'':'s')+' restaurado'+(res.voltaram===1?'':'s')+
        (res.faltaram?(' · '+res.faltaram+' não coube'+(res.faltaram===1?'':'ram')+' nesta tela'):'')+
        ' — confira e toque em Salvar e publicar.'); }catch(_){}
      cx.parentNode.removeChild(cx);
    };
    cx.querySelector('#lzRascDescarta').onclick=function(){
      lzRascLimpa(); _lz.rascBase=JSON.stringify(lzRascTira()||{});
      try{ toast('Rascunho descartado.'); }catch(_){}
      cx.parentNode.removeChild(cx);
    };
  }

  /* ==========================================================================
     🔴 v1234 — A ABA "PREÇO E CONDIÇÕES DE NEGOCIAÇÃO"
     --------------------------------------------------------------------------
     Angelo, 26/09: "Mostre as condições de varejo do veículo e condições
     vigentes de corporativo, crie uma aba só para preço e condições de
     negociação. Quando eu selecionar uma condição tipo varejo entrada 40% +
     48x taxa de juros 0,99 ela aparece nos post com a entrada calculada e a
     taxa e o número de parcelas."

     🔑 QUASE NADA AQUI É NOVO NO BANCO. Antes de desenhar eu fui conferir: a
     `vw_condicoes` já tinha 61 linhas, por versão, com entrada_pct, prazo,
     taxa_mensal e o rótulo pronto. O que faltava era a PORTA. Criar uma
     tabela de condições teria sido construir em cima do que já existia.

     ⚠️ A TELA NÃO INVENTA NÚMERO. Ela mostra o que está cadastrado e calcula
     UMA coisa: a entrada em reais, que é percentual vezes preço. Nada de
     parcela estimada — foi decisão dele, e é a decisão certa: parcela
     publicada é promessa, e o motor de PMT (com IOF e tarifa) mora no outro
     repositório.
     ⚠️ O PREÇO DE REFERÊNCIA É O QUE ESTÁ VALENDO: promocional desta cor se
     houver, senão o de varejo. Entrada calculada sobre o preço errado é pior
     que entrada nenhuma, porque o cliente faz a conta e não fecha.
     ========================================================================== */
  function lzCondSel(){
    var el=document.querySelector('input[name="lzCond"]:checked');
    return el?el.value:'';
  }
  function lzCondDa(id){
    var d=_lz.dados||{}, L=d.condicoes||[];
    for(var i=0;i<L.length;i++){ if(String(L[i].id)===String(id)) return L[i]; }
    return null;
  }
  function lzTaxaTxt(t){
    var n=Number(t)||0; if(!n) return 'sem juros';
    var pct=n*100, txt=(Math.round(pct*100)/100).toString().replace('.',',');
    return 'taxa '+txt+'% a.m.';
  }
  /* 🔴🔴🔴 v1237 — EU PUBLIQUEI UM BOTÃO QUE NÃO ACENDIA.
     Angelo, 27/09: "ele nao está deixando eu selecionar a condicao".
     O rádio ESTAVA marcando — o que não acontecia era a marca aparecer. Toda
     a aparência dependia da classe `.on`, e eu só a escrevia na HORA DE
     DESENHAR. Nunca liguei nada que a atualizasse no clique. Pra quem olha,
     "não deixa selecionar"; por dentro, selecionava e ficava calado.

     🔑 É A LIÇÃO DA v567 OUTRA VEZ, e eu caí nela: meu teste chamava
     `lzCondSel()` e marcava `.checked` na mão — mediu a REGRA, não o DEDO.
     Um clique de verdade teria pegado na primeira tentativa. A régua da v1237
     CLICA.
     ⚠️ E a aparência deixou de depender só de JS: o CSS agora acende pelo
     `input:checked`, que é o próprio estado do rádio. O JS continua, para
     repintar o post — mas se ele falhar, o botão ainda acende. */
  /* 🔴🔴 v1237 — A REAÇÃO DA TELA VIROU UMA FUNÇÃO COM NOME, e isso não é
     arrumação: é o que permite a RÉGUA usar a MESMA ligação que o app usa.
     O mutante "a lista não recalcula quando o preço muda" sobreviveu na
     primeira rodada porque o meu teste chamava `lzCondRepinta()` na mão
     depois de digitar — o harness fazia o trabalho que o app deveria fazer,
     e mediu a si mesmo. É a MESMA falha que deixou passar o botão que não
     acendia. Com a ligação num lugar só, o teste liga o que o app liga. */
  function lzReagirWire(ed){
    if(!ed) return;
    function reagiu(ev){
      if(!(ev.target&&ev.target.closest&&ev.target.closest('[data-lz-panel="marketing"], [data-lz-panel="precos"], [data-ficha-grupo], .lz-promo'))) return;
      try{ lzPostPinta(); }catch(_){}
      try{ lzCondRepinta(); }catch(_){}
    }
    ed.addEventListener('input', reagiu);
    ed.addEventListener('change', reagiu);
  }
  function lzCondWire(ed){
    if(!ed) return;
    function pinta(){
      Array.prototype.forEach.call(ed.querySelectorAll('.lz-cond-it'), function(l){
        l.classList.toggle('on', !!l.querySelector('input[name="lzCond"]:checked'));
      });
    }
    Array.prototype.forEach.call(ed.querySelectorAll('input[name="lzCond"]'), function(r){
      r.addEventListener('change', function(){ pinta(); try{ lzPostPinta(); }catch(_){} });
    });
    /* v1246 — os rádios e os públicos da venda direta repintam o post igual */
    Array.prototype.forEach.call(ed.querySelectorAll('input[name="lzDireta"],[data-lz-pub]'), function(r){
      r.addEventListener('change', function(){
        try{ var l=r.closest('.lz-direta-esc,.vd-ck'); if(l){
          if(r.type==='radio'){ Array.prototype.forEach.call(ed.querySelectorAll('.lz-direta-esc'), function(x){ x.classList.remove('on'); }); l.classList.add('on'); }
          else l.classList.toggle('on', r.checked);
        } }catch(_){}
        try{ lzPostPinta(); }catch(_){}
      });
    });
    pinta();
  }
  /* v1237 — quando o preço de referência muda (digitar o preço da unidade),
     a lista de condições tem que recalcular a entrada NA HORA. Sem isto ele
     digita 139.900 e continua lendo "entrada sobre 144.100". */
  function lzCondRepinta(){
    var ed=document.getElementById('lzEditor'); if(!ed) return;
    var d=_lz.dados||{}, L=d.condicoes||[], preco=lzPostPreco();
    var cab=ed.querySelector('.lz-cond-cab');
    if(cab) cab.innerHTML='Escolha a que vai no post. A entrada é calculada sobre '+(preco?('<b>'+esc(_rsF(preco))+'</b>'+(lzPrecoDaUnidade()?' <span class="lz-cond-fonte">(preço desta unidade em pátio)</span>':'')):'o preço desta cor')+'.';
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-cond-it input[name="lzCond"]'), function(r){
      var c=null, id=r.value; for(var i=0;i<L.length;i++){ if(String(L[i].id)===String(id)) c=L[i]; }
      if(!c) return;
      var sm=r.closest('.lz-cond-it').querySelector('.lz-cond-txt small'); if(!sm) return;
      var ent=preco?Math.round(preco*(Number(c.entrada_pct)||0)/100*100)/100:0;
      sm.textContent=(ent?('Entrada de '+_rsF(ent)+' · '):'')+String(c.prazo||0)+'x · '+lzTaxaTxt(c.taxa_mensal);
    });
  }
  function lzCondHtml(d){
    var L=(d.condicoes||[]).slice(), sel=String((d.versao||{}).cond_destaque||'');
    if(!L.length) return '<h4>Condições de varejo</h4><p class="cad-help">Nenhuma condição cadastrada para esta versão. Elas vêm da tabela de condições (vw_condicoes) — cadastre lá e ela aparece aqui.</p>';
    var preco=lzPostPreco();
    return '<h4>Condições de varejo</h4><p class="cad-help lz-cond-cab">Escolha a que vai no post. A entrada é calculada sobre '+(preco?('<b>'+esc(_rsF(preco))+'</b>'+(lzPrecoDaUnidade()?' <span class="lz-cond-fonte">(preço desta unidade em pátio)</span>':'')):'o preço desta cor')+'.</p>'+
      '<div class="lz-cond">'+L.map(function(c){
        var ent=preco?Math.round(preco*(Number(c.entrada_pct)||0)/100*100)/100:0;
        var on=String(c.id)===sel;
        return '<label class="lz-cond-it'+(on?' on':'')+'">'+
          '<input type="radio" name="lzCond" value="'+esc(c.id)+'"'+(on?' checked':'')+'>'+
          '<span class="lz-cond-cx" aria-hidden="true"></span>'+
          '<span class="lz-cond-txt"><b>'+esc(c.rotulo||'')+'</b>'+
            '<small>'+(ent?('Entrada de '+esc(_rsF(ent))+' · '):'')+esc(String(c.prazo||0))+'x · '+esc(lzTaxaTxt(c.taxa_mensal))+'</small></span>'+
          (c.go40?'<span class="lz-cond-selo">GO40</span>':'')+
        '</label>';
      }).join('')+
      '<label class="lz-cond-it lz-cond-nenhuma'+(sel?'':' on')+'"><input type="radio" name="lzCond" value=""'+(sel?'':' checked')+'>'+
        '<span class="lz-cond-cx" aria-hidden="true"></span><span class="lz-cond-txt"><b>Nenhuma no post</b>'+
        '<small>O post sai sem linha de condição.</small></span></label>'+
      '</div>';
  }
  function lzCorpHtml(d){
    var A=d.acoes_corp||[];
    if(!A.length) return '<h4>Condições vigentes de corporativo</h4><p class="cad-help">Nenhuma ação corporativa vigente cadastrada para este modelo.</p>';
    var hoje=new Date(); hoje.setHours(0,0,0,0);
    return '<h4>Condições vigentes de corporativo</h4><p class="cad-help">Só leitura — quem cadastra ação corporativa é a Cotação. Aqui é pra você conferir antes de negociar.</p>'+
      '<div class="lz-corp">'+A.map(function(a){
        var venc=false, quando='';
        try{ if(a.validade){ var dt=new Date(a.validade+'T00:00:00'); venc=dt<hoje; quando=('0'+dt.getDate()).slice(-2)+'/'+('0'+(dt.getMonth()+1)).slice(-2)+'/'+dt.getFullYear(); } }catch(_){}
        return '<div class="lz-corp-it'+(venc?' venc':'')+'"><div class="lz-corp-nm"><b>'+esc(a.nome||'(sem nome)')+'</b>'+
          (a.pct!=null?('<span class="lz-corp-pct">'+esc(String(a.pct).replace('.',','))+'%</span>'):'')+'</div>'+
          '<div class="lz-corp-val">'+(quando?((venc?'⚠️ Venceu em ':'Vale até ')+esc(quando)):'sem validade cadastrada')+'</div></div>';
      }).join('')+'</div>';
  }
  /* ══════════════════════════════════════════════════════════════════════
     🔴 v1245 — AS CONDIÇÕES DE VENDA DIRETA
     ──────────────────────────────────────────────────────────────────────
     Angelo, 28/09: "Saveiro Robust tem condições próprias de financiamento na
     venda direta, tá no banco e serve pra todos os veículos de venda direta" —
     e, quando eu disse que não achava, ele completou: "condições pra venda
     direta na pasta do mevtools".

     Estava certo nas duas. Elas viviam HARDCODED no MEV Tools (a constante
     CORP_CONDS de cada página *-vw-cotacao-corporativo), iguais nos cinco
     modelos que conferi. A v1245 trouxe pro banco, numa tabela global.

     🔴🔴🔴 A CONTA AQUI NÃO É A DO VAREJO, E CONFUNDIR AS DUAS CUSTA CARO.
     No varejo a entrada sai do preço público. Na venda direta ela sai da
     **NF DA FÁBRICA** — o `preco_corp`. Medido no print dele:

         NF R$ 86.317,50 · entrada mínima 30% = R$ 25.895   ← certo
         preço público R$ 115.090 · 30%       = R$ 34.527   ← o que sairia
                                                              reaproveitando
                                                              a conta do varejo

     Oito mil e seiscentos reais de diferença, num número que o cliente usa
     pra decidir se tem o dinheiro. Por isso este bloco tem a própria base e
     avisa, na tela, qual base está usando.

     ⚠️ E É SÓ LEITURA, de propósito. Estas condições são de PJ, frotista e
     taxi — público diferente do post de Instagram. Deixá-las selecionáveis
     pro post, hoje, seria abrir a porta pra uma condição de CNPJ sair num
     anúncio de pessoa física. Se ele quiser isso, é decisão dele e vira
     versão própria, com o post dizendo "venda direta" em letra grande.
     ══════════════════════════════════════════════════════════════════════ */
  /* Os públicos da venda direta. "Produtor rural" NÃO está na
     vw_politicas_corp (que tem PJ, frotista, táxi e kamikaze) — entrou aqui
     porque ele pediu pelo nome, e é categoria real de venda direta da VW.
     Ficam no código e não no banco de propósito: são rótulos do POST, não
     política de preço. Política de preço mora na tabela. */
  var LZ_DIRETA_PUBLICOS=[
    { id:'cnpj',     nome:'CNPJ' },
    { id:'produtor', nome:'Produtor rural' },
    { id:'frotista', nome:'Frotista' },
    { id:'taxi',     nome:'Táxi' }
  ];
  function lzDiretaSel(){
    var el=document.querySelector('input[name="lzDireta"]:checked');
    if(el) return el.value;
    var f=((_lz.dados||{}).versao||{}).ficha||{};
    return String(f.venda_direta_condicao||'');
  }
  function lzDiretaDa(id){
    var L=((_lz.dados||{}).condicoes_direta)||[];
    for(var i=0;i<L.length;i++){ if(String(L[i].id)===String(id)) return L[i]; }
    return null;
  }
  function lzDiretaPublicos(){
    var out=[], ed=document.getElementById('lzEditor');
    if(ed) Array.prototype.forEach.call(ed.querySelectorAll('[data-lz-pub]'), function(c){
      if(c.checked) out.push(c.getAttribute('data-lz-pub'));
    });
    if(out.length || (ed&&ed.querySelector('[data-lz-pub]'))) return out;
    var f=((_lz.dados||{}).versao||{}).ficha||{};
    return String(f.venda_direta_publicos||'').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  }
  function lzDiretaPublicoTxt(){
    var ids=lzDiretaPublicos();
    var nomes=LZ_DIRETA_PUBLICOS.filter(function(p){ return ids.indexOf(p.id)>=0; }).map(function(p){ return p.nome; });
    if(!nomes.length) return '';
    if(nomes.length===1) return nomes[0];
    return nomes.slice(0,-1).join(', ')+' e '+nomes[nomes.length-1];
  }
  function lzPrecoCorp(){
    try{
      var P=(_lz.dados||{}).precos||{}, pc=(P.por_cor||[]);
      var daCor=pc.filter(function(c){ return _lz.cor!==null && String(c.codigo)===String(_lz.cor); })[0];
      var alvo=daCor||pc[0]||{};
      return Number(alvo.corp)||Number(alvo.corp_sem_opc)||0;
    }catch(_){ return 0; }
  }
  function lzDiretaHtml(d){
    var C=(d.condicoes_direta||[]).slice();
    if(!C.length) return '';
    var nf=lzPrecoCorp(), cor=lzCorAtual();
    var base = nf
      ? ('A entrada é calculada sobre a <b>NF da venda direta</b> ('+_rsF(nf)+
         (cor&&cor.nome&&!cor.semCor?(' · '+esc(cor.nome)):'')+'), não sobre o preço público.')
      : '<b>Sem NF de venda direta cadastrada para esta cor</b> — por isso a entrada não aparece em reais aqui.';
    /* ⚠️ v1246 — DEIXOU DE SER SÓ LEITURA, E FOI DECISÃO DELE.
       Na v1245 eu travei este bloco de propósito: venda direta é PJ e
       frotista, e uma condição de CNPJ saindo num post de pessoa física é
       promessa que a loja não honra. Escrevi que só mudaria se ele mandasse.
       Ele mandou: "coloca nos post venda direta com o que foi selecionado
       CNPJ e produtor rural".

       🔑 O QUE EU FIZ PRA QUE ISSO NÃO VIRE O PROBLEMA QUE EU TEMIA:
       o público é OBRIGATÓRIO. Sem marcar pra quem vale, a condição não vai
       pro post — e o post escreve o público em letra própria, na frente da
       condição. O risco nunca foi a condição sair; era ela sair SEM DIZER
       pra quem vale. */
    var pubSel=lzDiretaPublicos(), escolhida=lzDiretaSel();
    return '<h4>Condições de venda direta</h4>'+
      '<p class="cad-help">São as mesmas para todos os veículos — vêm da política da VW, não deste cadastro. '+base+'</p>'+
      '<div class="lz-direta">'+C.map(function(c){
        var pct=Number(c.entrada_pct)||0;
        var ent=nf?Math.round(nf*pct/100):0;
        var on=String(escolhida)===String(c.id);
        return '<label class="lz-direta-it lz-direta-esc'+(on?' on':'')+'">'+
          '<input type="radio" name="lzDireta" value="'+esc(c.id)+'"'+(on?' checked':'')+'>'+
          '<span class="lz-direta-cx" aria-hidden="true"></span>'+
          '<span class="lz-direta-tx"><span class="lz-direta-nm"><b>'+esc(c.rotulo||'')+'</b></span>'+
          '<span class="lz-direta-val">'+(ent?('Entrada mínima '+_rsF(ent)):('Entrada mínima '+pct+'%'))+
          ' &middot; '+(Number(c.prazo)||0)+'x &middot; '+lzTaxaTxt(c.taxa_mensal)+'</span></span></label>';
      }).join('')+
      '<label class="lz-direta-it lz-direta-esc'+(!escolhida?' on':'')+'">'+
        '<input type="radio" name="lzDireta" value=""'+(!escolhida?' checked':'')+'>'+
        '<span class="lz-direta-cx" aria-hidden="true"></span>'+
        '<span class="lz-direta-tx"><span class="lz-direta-nm"><b>Nenhuma no post</b></span>'+
        '<span class="lz-direta-val">O post sai sem linha de venda direta.</span></span></label>'+
      '</div>'+
      '<h4 class="lz-direta-h">Para quem vale</h4>'+
      '<p class="cad-help">Obrigatório pra a condição entrar no post. Sem isso, quem lê não sabe se a condição é pra ele.</p>'+
      '<div class="lz-direta-pub">'+LZ_DIRETA_PUBLICOS.map(function(pb){
        var on=pubSel.indexOf(pb.id)>=0;
        return '<label class="vd-ck'+(on?' on':'')+'"><input type="checkbox" data-lz-pub="'+esc(pb.id)+'"'+(on?' checked':'')+'><span>'+esc(pb.nome)+'</span></label>';
      }).join('')+'</div>';
  }
  function lzMarcacoesHtml(d){
    var V=d.versao||{}, cor=lzCorAtual();
    var fb=true; try{ var c=(d.cores||[]).filter(function(x){ return String(x.codigo)===String(_lz.cor); })[0]; if(c) fb=c.no_facebook!==false; }catch(_){}
    return '<h4>Marcações deste veículo</h4><p class="cad-help">O que estiver marcado aqui aparece no post e manda no catálogo.</p>'+
      '<div class="lz-marca">'+
        '<label class="vd-ck'+(V.varejo?' on':'')+'"><input type="checkbox" id="lzVarejo"'+(V.varejo?' checked':'')+'><span>É de varejo</span></label>'+
        '<label class="vd-ck'+(lzVendaDiretaMarcada(V)?' on':'')+'"><input type="checkbox" id="lzVendaDireta"'+(lzVendaDiretaMarcada(V)?' checked':'')+'><span>Venda direta</span></label>'+
        '<label class="vd-ck'+(fb?' on':'')+'"><input type="checkbox" id="lzFacebook"'+(fb?' checked':'')+'><span>Aparece no catálogo do Facebook'+((cor&&cor.nome&&!cor.semCor)?(' · '+esc(cor.nome)):'')+'</span></label>'+
      '</div>';
  }

  /* ==========================================================================
     🔴🔴 v1235 — O ESTOQUE DE PRONTA ENTREGA, NA TELA
     --------------------------------------------------------------------------
     "posso cadastrar um nivus highline com adas e outro sem, um cinza outfit
     e outro sem pacote outfit" (Angelo, 26/09).

     Cada CARTÃO é UM CARRO no pátio. Dois cartões com a mesma cor e opcionais
     diferentes são dois carros — e é exatamente isso que ele descreveu.

     ⚠️ OS OPCIONAIS SÃO CHIPS, não um <select multiple>. No celular um select
     múltiplo é quase intocável, e a escolha aqui é justamente a que ele vai
     fazer mais: ADAS sim / ADAS não.
     ⚠️ "TIRAR DO PÁTIO" NÃO APAGA — desliga. Some da tela na hora, e o
     histórico fica no banco. Carro que ficou 90 dias parado é uma pergunta
     que ele vai querer responder um dia.
     ⚠️ PREÇO VAZIO = calculado pela cor + opcionais, como no resto da casa.
     Campo em branco não é zero; é "usa a regra".
     ========================================================================== */
  var _lzUnSeq=0;
  function lzUnCorOpts(d, sel){
    return (d.cores||[]).filter(function(c){ return c.ativa!==false; }).map(function(c){
      return '<option value="'+esc(c.codigo)+'"'+(String(c.codigo)===String(sel||'')?' selected':'')+'>'+esc(c.nome||c.codigo)+'</option>';
    }).join('');
  }
  function lzUnOpcChips(d, marcados){
    var M={}; (marcados||[]).forEach(function(x){ M[String(x)]=1; });
    var L=(d.opcionais||[]).filter(function(o){ return o.ativo!==false && String(o.codigo||'').trim(); });
    if(!L.length) return '<p class="cad-help">Esta versão não tem opcionais com código cadastrados.</p>';
    return '<div class="lz-un-chips">'+L.map(function(o){
      var on=!!M[String(o.codigo)];
      return '<label class="lz-chip'+(on?' on':'')+'"><input type="checkbox" data-un-opc="'+esc(o.codigo)+'"'+(on?' checked':'')+'>'+
        '<span>'+esc(o.nome||o.codigo)+(Number(o.preco)>0?(' <b>+'+esc(_rsF(Number(o.preco)))+'</b>'):'')+'</span></label>';
    }).join('')+'</div>';
  }
  function lzUnCartao(d, u){
    u=u||{};
    var id=u.id?String(u.id):('novo-'+(++_lzUnSeq));
    return '<div class="lz-un" data-un="'+esc(id)+'"'+(u.id?'':' data-un-novo="1"')+'>'+
      '<div class="lz-un-linha">'+
        '<label class="lz-un-c"><span class="cad-lbl">Cor</span><select class="cad-in" data-k="cor_codigo">'+lzUnCorOpts(d,u.cor_codigo)+'</select></label>'+
        '<label class="lz-un-c"><span class="cad-lbl">Chassi (opcional)</span><input class="cad-in" data-k="chassi" maxlength="24" placeholder="últimos dígitos" value="'+_lzA(u.chassi||'')+'"></label>'+
      '</div>'+
      '<label class="lz-un-c"><span class="cad-lbl">Preço desta unidade</span><input class="cad-in lz-num" data-k="preco" inputmode="numeric" placeholder="vazio = calculado pela cor e opcionais" value="'+_lzA(u.preco?_rsF(u.preco):'')+'"></label>'+
      '<div class="lz-un-c"><span class="cad-lbl">Opcionais deste carro</span>'+lzUnOpcChips(d,u.opcionais)+'</div>'+
      '<div class="lz-un-pe">'+
        '<label class="vd-ck'+(u.no_facebook===false?'':' on')+'"><input type="checkbox" data-k="no_facebook"'+(u.no_facebook===false?'':' checked')+'><span>No catálogo do Facebook</span></label>'+
        '<button type="button" class="lz-un-x" data-un-tirar="'+esc(id)+'">Tirar do pátio</button>'+
      '</div>'+
    '</div>';
  }
  function lzEstoqueHtml(d){
    var E=d.estoque||[];
    return '<h4>Estoque — pronta entrega</h4>'+
      '<p class="cad-help">Cada cartão é <b>um carro no pátio</b>. O mesmo modelo e cor podem aparecer duas vezes, com opcionais diferentes — são dois carros. Ter pelo menos um aqui é o que faz o post dizer "pronta entrega".</p>'+
      '<div id="lzUnLista" class="lz-un-lista">'+(E.length?E.map(function(u){ return lzUnCartao(d,u); }).join(''):'<p class="cad-help lz-un-vazio">Nenhuma unidade em pátio para esta versão.</p>')+'</div>'+
      '<button type="button" class="cad-btn lz-un-add" id="lzUnAdd">+ Adicionar unidade</button>';
  }
  function lzEstoqueWire(ed){
    var add=$('lzUnAdd');
    if(add) add.onclick=function(){
      var lista=$('lzUnLista'); if(!lista) return;
      var vazio=lista.querySelector('.lz-un-vazio'); if(vazio) vazio.remove();
      lista.insertAdjacentHTML('beforeend', lzUnCartao(_lz.dados||{}, { cor_codigo:_lz.cor||'' }));
      lzEstoqueChips(lista.lastElementChild);
      try{ lzPostPinta(); lzCondRepinta(); }catch(_){}
    };
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-un'), lzEstoqueChips);
    ed.addEventListener('click', function(ev){
      var bt=ev.target&&ev.target.closest?ev.target.closest('[data-un-tirar]'):null; if(!bt) return;
      var cx=bt.closest('.lz-un'); if(!cx) return;
      /* v1235 — some da tela AGORA e marca pra desligar no salvar. A unidade
         nova (ainda sem id) simplesmente sai: nunca existiu no banco. */
      if(cx.getAttribute('data-un-novo')==='1'){ cx.remove(); }
      else { cx.setAttribute('data-un-tirada','1'); cx.style.display='none'; }
      try{ lzPostPinta(); lzCondRepinta(); }catch(_){}
    });
  }
  function lzEstoqueChips(cx){
    if(!cx||cx.__chips) return; cx.__chips=1;
    Array.prototype.forEach.call(cx.querySelectorAll('[data-un-opc]'), function(i){
      i.onchange=function(){ var l=i.closest('.lz-chip'); if(l) l.classList.toggle('on', i.checked); try{ lzPostPinta(); }catch(_){} };
    });
  }
  function lzEstoqueColeta(ed){
    var out=[];
    Array.prototype.forEach.call(ed.querySelectorAll('.lz-un'), function(cx){
      var id=cx.getAttribute('data-un')||'', novo=cx.getAttribute('data-un-novo')==='1';
      if(cx.getAttribute('data-un-tirada')==='1'){ if(!novo) out.push({ id:id, tirar:true }); return; }
      var g=function(k){ return cx.querySelector('[data-k="'+k+'"]'); };
      var ops=[]; Array.prototype.forEach.call(cx.querySelectorAll('[data-un-opc]:checked'), function(i){ ops.push(i.getAttribute('data-un-opc')); });
      out.push({ id: novo?'':id, cor_codigo:(g('cor_codigo')||{}).value||'', chassi:(g('chassi')||{}).value||'',
                 preco:(g('preco')||{}).value||'', opcionais:ops, no_facebook:!!((g('no_facebook')||{}).checked) });
    });
    return out;
  }
  /* v1235 — pronta entrega DA COR ABERTA: é o que o post desta página afirma */
  function lzTemProntaEntrega(ed){
    var achou=false;
    Array.prototype.forEach.call((ed||document).querySelectorAll('.lz-un'), function(cx){
      if(cx.getAttribute('data-un-tirada')==='1') return;
      var sel=cx.querySelector('[data-k="cor_codigo"]');
      if(sel && String(sel.value||'')===String(_lz.cor||'')) achou=true;
    });
    return achou;
  }

  /* ==========================================================================
     🔴🔴🔴 v1236 — "CAMPO QUE NÃO ESTÁ NA TELA" NÃO É "CAMPO VAZIO"
     --------------------------------------------------------------------------
     Achei isto ao me perguntar se dava pra publicar, e é EXATAMENTE a mesma
     armadilha que eu tinha acabado de diagnosticar no preço promocional —
     desta vez em código que eu escrevi HOJE, nas v1233/v1234.

     O que a tela mandava:

         model_year:   (($('lzAno')||{}).value) || ''
         varejo:       !!(($('lzVarejo')||{}).checked)
         cond_destaque: lzCondSel()

     Os três têm uma queda silenciosa pra "vazio" quando o controle NÃO EXISTE
     no documento. E o servidor, corretamente, lê vazio como "a pessoa
     limpou": grava null, null e false. Ou seja, um controle ausente APAGARIA
     o ano do modelo, a condição escolhida e a marcação de varejo — sem erro,
     sem aviso, sem ninguém pedir.

     E "ausente" não é hipótese de laboratório. O `carregar` do servidor faz
     `try{ condicoes = await pega(...) }catch(_){ condicoes = [] }`: um soluço
     de rede devolve lista vazia, a tela desenha o bloco SEM nenhum rádio, e o
     próximo "Salvar e publicar" enterra a condição que estava escolhida.

     🔑 A REGRA, agora explícita: a chave só entra no que é enviado quando o
     CONTROLE EXISTE. Chave ausente = "não mexi nisso" (o servidor já trata
     assim, com `'x' in V`). Chave presente e vazia = "eu limpei de
     propósito". São duas intenções diferentes e elas não podem mais ser
     escritas do mesmo jeito.
     ========================================================================== */
  function _lzVersaoPayload(ed, base){
    var out = base || {};
    if($('lzAno'))    out.model_year   = $('lzAno').value;
    if($('lzVarejo')) out.varejo       = !!$('lzVarejo').checked;
    /* só manda a condição se o grupo de rádios estiver mesmo desenhado */
    if(ed && ed.querySelector('input[name="lzCond"]')) out.cond_destaque = lzCondSel();
    return out;
  }
  function lzColeta(){
    var ed=$('lzEditor'), d=_lz.dados;
    var ficha={}; Array.prototype.forEach.call(ed.querySelectorAll('[data-ficha]'),function(el){ ficha[el.getAttribute('data-ficha')]=el.value.trim(); });
    Array.prototype.forEach.call(ed.querySelectorAll('[data-ficha-grupo]'),function(grupo){
      var chave=grupo.getAttribute('data-ficha-grupo'), ativos=[], inativos=[];
      Array.prototype.forEach.call(grupo.querySelectorAll('[data-ficha-item]'),function(linha){
        var texto=((linha.querySelector('.lz-fi-texto')||{}).value||'').trim(); if(!texto) return;
        ((linha.querySelector('.lz-fi-on')||{}).checked?ativos:inativos).push(texto);
      });
      ficha[chave]=ativos.join(' · '); ficha[chave+'_inativos']=inativos.join(' · ');
    });
    if($('lzVendaDireta')&&$('lzVendaDireta').checked){
      ficha.venda_direta='sim';
      var _dir=lzDiretaSel(), _pub=lzDiretaPublicos();
      if(_dir) ficha.venda_direta_condicao=_dir;
      if(_pub.length) ficha.venda_direta_publicos=_pub.join(',');
    }
    var marketing=lzMarketingColeta(ed); ficha.marketing_vantagens_inativas=marketing.inativos.join(' · ');
    var promos=lzPromocoes(d.versao||{}), pk=lzPromoChave(), pv=lzNumeroMoeda(($('lzPrecoPromo')||{}).value), pp=[];
    Array.prototype.forEach.call(ed.querySelectorAll('[data-lz-publico]:checked'),function(x){ pp.push(x.getAttribute('data-lz-publico')); });
    if(pv) promos[pk]={ valor:pv, publicos:pp }; else delete promos[pk];
    if(Object.keys(promos).length) ficha.precos_promocionais=JSON.stringify(promos);
    var g=function(el,k){ return el.querySelector('[data-k="'+k+'"]'); };
    var opcs=Array.prototype.map.call(ed.querySelectorAll('[data-opc]'),function(el){
      return { id:el.getAttribute('data-opc'), nome:g(el,'nome').value, preco:g(el,'preco').value, descricao:g(el,'descricao').value, ativo:g(el,'ativo').checked };
    });
    var apagada=function(u){ return !!u && _lz.fotos.some(function(f){ return f.apagar && f.u===u; }); };
    var cores=Array.prototype.map.call(ed.querySelectorAll('[data-cor]'),function(el){
      var cod=((d.cores||[]).filter(function(c){ return String(c.id)===el.getAttribute('data-cor'); })[0]||{}).codigo||'';
      var cc=_lz.capas[cod]||''; if(apagada(cc)) cc='';   /* v1107: capa da cor (foto apagada não pode ser capa) */
      return { id:el.getAttribute('data-cor'), nome:g(el,'nome').value, preco_adicional:g(el,'preco_adicional').value, hex:g(el,'hex').value, ativa:g(el,'ativa').checked, capa_url:cc };
    });
    /* v1234 — a marcação do Facebook é POR COR e mora na aba nova, fora da
       linha [data-cor]. Ela é costurada aqui, na cor que está aberta — e só
       nela: mandar a marcação pra todas seria decidir por cores que a pessoa
       nem viu. */
    try{
      var _fb=$('lzFacebook');
      if(_fb){
        var _atual=(d.cores||[]).filter(function(x){ return String(x.codigo)===String(_lz.cor); })[0];
        if(_atual) cores.forEach(function(x){ if(String(x.id)===String(_atual.id)) x.no_facebook=_fb.checked; });
      }
    }catch(_){}
    lzOrdena();
    var vivas=_lz.fotos.filter(function(f){ return !f.apagar; });
    var capa=(_lz.capa && !apagada(_lz.capa))?_lz.capa:'';
    /* v1107: texto igual ao automático = vazio (a página segue calculando sozinha) */
    var AU=_lz.auto||{}, norm=function(x){ return String(x||'').replace(/\s+/g,' ').trim(); };
    var semAuto=function(id,k){ var v=$(id).value; return (norm(v)===norm(AU[k]))?'':v; };
    return { acao:'salvar', versao_id:d.versao.id,
      versao:_lzVersaoPayload(ed, { subtitulo:$('lzSub').value, sobre:semAuto('lzSobre','sobre'), capa_url:capa,
               vantagens:marketing.ativos, ficha:ficha,
               /* v1103 — SEO da página (o servidor limpa e grava só o preenchido) */
               seo:{ titulo:semAuto('lzSeoTit','titulo'), descricao:semAuto('lzSeoDesc','descricao'), palavras:semAuto('lzSeoPal','palavras'), texto:$('lzSeoTexto').value,
                     og_titulo:semAuto('lzSeoOgT','og_titulo'), og_desc:semAuto('lzSeoOgD','og_desc'), og_foto:$('lzSeoOgF').value, indexar:$('lzSeoIdx').checked } }),
      opcionais:opcs, cores:cores, estoque:lzEstoqueColeta(ed),
      fotos:vivas.map(function(f,i){ return { id:f.id, ordem:i, tipo:f.t, cor_codigo:f.c }; }),
      apagar_fotos:_lz.fotos.filter(function(f){ return f.apagar; }).map(function(f){ return f.id; }) };
  }
  async function lzSalvar(){
    var d=_lz.dados; if(!d) return;
    var bts=[$('lzSalvar'),$('lzSalvar2')].filter(Boolean), err=$('lzErr');
    bts.forEach(function(b){ b.disabled=true; b.textContent='Salvando…'; }); if(err) err.hidden=true;
    var r=null;
    try{ r=await apiTimeout('/api/novo-admin', lzColeta(), 30000); }catch(_){ r=null; }
    if(!r || !r.ok){
      if(err){ err.hidden=false; err.textContent=(r&&r.erros&&r.erros.length)?('Salvou parcialmente: '+r.erros.join(', ')):((r&&r.erro)||'Sem conexão.'); }
      bts.forEach(function(b){ b.disabled=false; b.textContent='Salvar e publicar'; });
      return;
    }
    /* v1233 — salvou: o rascunho cumpriu o papel e sai de cena. Deixá-lo
       faria a faixa reaparecer oferecendo restaurar o que já está gravado. */
    lzRascLimpa();
    try{ toast('Salvo — já está no site.'); }catch(_){}
    /* reabre do banco: o que a tela mostra é o que ficou gravado, não o que ela acha que gravou */
    var v=_lz.versao, cor=_lz.cor; if(v) lzAbrirVersao(v,cor);
  }

/* ╔═══ src/app/14p-seo-da-pagina.js ══════════════════════════════════════ */
  /* ==========================================================================
     🔴🔴 v1103 — A ABA "SEO" DA FICHA DO VEÍCULO (só admin)
     --------------------------------------------------------------------------
     Pedido do Angelo (20/09): "crie uma aba dentro do cadastro de estoque onde
     eu consiga fazer alterações de SEO da página… tudo que for possível, tava
     pensando em até tags de página pra ranquear pesquisa" — só ele edita.

     🔑 NENHUMA COLUNA NOVA. Tudo mora em `extras.seo` (a gaveta jsonb que já
     guarda o 0 km, o preço de tabela etc.) e a porta pública `mp_get_veiculo`
     já entrega o `extras` inteiro pra página do carro (veiculo.js). A página
     só SUBSTITUI o que foi preenchido; vazio = automático, como sempre foi.

     AS CHAVES (fechadas — ver netlify/functions/_seo.js, que é quem manda):
       titulo · descricao · palavras · texto · og_titulo · og_desc · og_foto ·
       slug · indexar

     🔑 O ENDEREÇO AMIGÁVEL (slug). /santaluziaveiculos/veiculo/polo-track-2024
     em vez do uuid. A página resolve o apelido no banco
     (mp_veiculo_id_por_slug); o link antigo pelo uuid faz 301 pro novo, então
     nada que já foi mandado no WhatsApp quebra. Repetido dentro da loja é
     avisado AQUI (a lista `_estoque` já está na memória — zero consulta).

     🔑 POR QUE UM ARQUIVO NOVO. O 14-estoque passa de 200 KB; aqui entram só
     ganchos de uma linha: a aba na barra (seoTabDef), o painel (seoPainelHtml),
     o wire, a pintura da prévia ao entrar na aba e a coleta (seoColeta).

     ⚠️ ESCONDER NÃO PODE APAGAR DADO (lição da v1052): quem não é admin não
     vê a aba, mas o autosave dele remonta o `extras` do zero a cada tecla. Por
     isso `seoColeta` devolve o `seo` que JÁ ESTÁ gravado quando a aba não
     existe na tela — senão o vendedor apagaria o SEO do Angelo sem saber.
     ========================================================================== */
  var SEO_LIM={ titulo:70, descricao:160, palavras:200, texto:2000, og_titulo:90, og_desc:200, slug:80 };
  var SEO_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/><path d="M8 11h6"/><path d="M11 8v6"/></svg>';

  function seoPodeUsar(){ try{ return typeof _ehAdmin==='function' && !!_ehAdmin(); }catch(_){ return false; } }
  /* a aba na barra da ficha — [chave, rótulo, ícone]; vazio pra quem não é admin */
  function seoTabDef(){ return seoPodeUsar() ? [['seo','SEO da página',SEO_ICO]] : []; }
  function _seoA(s){ return esc(s).replace(/"/g,'&quot;'); }
  function _seoV(id){ try{ return String((($(id)||{}).value||'')).trim(); }catch(_){ return ''; } }
  /* "Polo Track 2024 Branco!" → "polo-track-2024-branco" (a mesma regra do servidor) */
  function seoSlugify(s){
    var t=String(s==null?'':s).toLowerCase();
    try{ t=t.normalize('NFD').replace(/[̀-ͯ]/g,''); }catch(_){}
    t=t.replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,SEO_LIM.slug).replace(/-+$/,'');
    if(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(t)) return '';
    return t;
  }
  function _seoFotoUrl(f){ return typeof f==='string' ? f : String((f&&(f.url||f.u||f.src))||''); }
  function _seoCorta(s,n){
    s=String(s||'').replace(/\s+/g,' ').trim(); if(s.length<=n) return s;
    var t=s.slice(0,n+1).replace(/\s+\S*$/,'').replace(/[\s,;:.-]+$/,'');
    return t||s.slice(0,n).trim();
  }
  function _seoPadrao(v,ex){
    v=v||{}; ex=ex||{};
    var marca=String(v.marca||'').trim(), modelo=String(v.modelo||'').trim();
    var nome=(marca+' '+modelo).replace(/\s+/g,' ').trim()||'Veículo';
    if(marca&&modelo.toLowerCase().indexOf(marca.toLowerCase())===0) nome=modelo;
    var af=String(v.ano||'').trim(), am=String(v.ano_modelo||'').trim();
    var ano=(af&&am&&af!==am)?(af+'/'+am):(am||af);
    var cor=String(v.cor||'').trim(), cambio=String(ex.cambio||v.cambio||'').trim();
    var km=String(v.km==null?'':v.km).replace(/\D/g,'');
    var kmTxt=km?(Number(km).toLocaleString('pt-BR')+' km'):'';
    var preco=Number(v.preco_anuncio)||0, precoTxt=preco?('R$ '+Math.round(preco).toLocaleString('pt-BR')):'';
    var loja='', cidade='', uf='', ap='';
    try{
      loja=String((_lojaRec&&(_lojaRec.nome_fantasia||_lojaRec.razao_social))||'').trim();
      cidade=String((_lojaRec&&_lojaRec.cidade)||'').trim(); uf=String((_lojaRec&&_lojaRec.uf)||'').trim(); ap=String((_lojaRec&&_lojaRec.slug)||'').trim();
    }catch(_){}
    var local=[cidade,uf].filter(Boolean).join(' / ')||String(ex.localizacao_veiculo||'').trim(), nomeAno=[nome,ano].filter(Boolean).join(' ');
    var titulo=_seoCorta(nomeAno+' à venda'+(local?(' em '+local):(loja?(' | '+loja):'')),SEO_LIM.titulo);
    var detalhes=[cor,kmTxt,cambio,precoTxt].filter(Boolean);
    var desc=_seoCorta(nomeAno+(detalhes.length?(', '+detalhes.join(', ')):'')+'. Veja fotos, opcionais e condições'+(loja?(' na '+loja):'')+(local?(' em '+local):'')+'.',SEO_LIM.descricao);
    var texto='Confira o '+nomeAno+(cor?(' na cor '+cor):'')+(kmTxt?(', com '+kmTxt):'')+(cambio?(' e câmbio '+cambio):'')+'. Nesta página você encontra fotos, equipamentos, preço e as informações confirmadas no cadastro do veículo.';
    if(loja||local) texto+=' Fale com '+(loja||'nossa equipe')+(local?(' em '+local):'')+' para consultar disponibilidade e condições.';
    var ogTitulo=_seoCorta(nomeAno+(precoTxt?(' · '+precoTxt):''),SEO_LIM.og_titulo);
    var ogDesc=_seoCorta([cor,kmTxt,cambio,'Veja fotos e fale pelo WhatsApp'].filter(Boolean).join(' · '),SEO_LIM.og_desc);
    return { titulo:titulo, descricao:desc, texto:_seoCorta(texto,SEO_LIM.texto), slug:seoSlugify(nomeAno+(cor?(' '+cor):'')), og_titulo:ogTitulo, og_desc:ogDesc,
      nomeAno:nomeAno, precoTxt:precoTxt||'Consulte', urlBase:location.origin+'/'+(ap||'catalogo')+'/veiculo/' };
  }

  function seoPainelHtml(v, ex){
    v=v||{}; ex=ex||{}; var s=(ex.seo&&typeof ex.seo==='object')?ex.seo:{}, a=_seoPadrao(v,ex);
    var fotos=(_estFotos||[]).map(_seoFotoUrl).filter(function(u){ return /^https?:\/\//.test(u); });
    var fotoOpts='<option value=""'+(!s.og_foto?' selected':'')+'>1ª foto do carro (automático)</option>'+
      fotos.map(function(u,i){ return '<option value="'+_seoA(u)+'"'+(s.og_foto===u?' selected':'')+'>Foto '+(i+1)+'</option>'; }).join('');
    function auto(k){ return s[k]?'':' data-seo-auto="1"'; }
    function val(k){ return s[k]||a[k]||''; }
    function campo(id,rot,dica,inner){ return '<div class="seo-campo"><label class="cad-lbl" for="'+id+'">'+rot+(dica?(' <span class="ec-hint">'+dica+'</span>'):'')+'</label>'+inner+'</div>'; }
    return '<div class="seo-pn">'+
      '<div class="ec-tit">SEO da página do veículo</div>'+
      '<p class="cad-help">Os campos já vêm preenchidos com informações reais deste veículo. Você pode editar; título, descrição, endereço e prévia permanecem sincronizados enquanto não forem personalizados.</p>'+
      '<div class="seo-previa" id="seoPrevia"></div>'+
      '<h4 class="seo-h">Google</h4>'+
      campo('seoTit','Título da página','(até 70 letras)','<input class="cad-in" id="seoTit" maxlength="70"'+auto('titulo')+' value="'+_seoA(val('titulo'))+'"><div class="seo-cont" data-for="seoTit" data-max="70"></div>')+
      campo('seoDesc','Descrição do Google','(até 160)','<textarea class="cad-in" id="seoDesc" rows="3" maxlength="160"'+auto('descricao')+'>'+esc(val('descricao'))+'</textarea><div class="seo-cont" data-for="seoDesc" data-max="160"></div>')+
      '<input type="hidden" id="seoPal" value="'+_seoA(s.palavras||'')+'">'+
      '<p class="cad-help seo-keywords-info">O Google ignora a tag <code>keywords</code>; por isso ela não é solicitada aqui. O foco fica no título, na descrição e no conteúdo específico do veículo.</p>'+
      campo('seoTexto','Texto da página','(bloco “Mais sobre este veículo”)','<textarea class="cad-in" id="seoTexto" rows="5" maxlength="2000"'+auto('texto')+'>'+esc(val('texto'))+'</textarea><div class="seo-cont" data-for="seoTexto" data-max="2000"></div>')+
      '<h4 class="seo-h">Endereço da página</h4>'+
      campo('seoSlug','Apelido na URL','(só letras, números e hífen)','<div class="seo-url"><span class="seo-url-base" id="seoUrlBase"></span><input class="cad-in" id="seoSlug" maxlength="80"'+auto('slug')+' value="'+_seoA(val('slug'))+'"></div><div class="cad-help seo-slug-msg" id="seoSlugMsg"></div>')+
      '<label class="vd-ck'+(s.indexar===false?'':' on')+'"><input type="checkbox" id="seoIdx"'+(s.indexar===false?'':' checked')+'><span>Deixar o Google indexar esta página</span></label>'+
      '<p class="cad-help">Desmarcado = a página ganha <code>noindex</code> e sai do sitemap (o link continua abrindo).</p>'+
      '<h4 class="seo-h">Prévia no WhatsApp e redes</h4>'+
      campo('seoOgT','Título da prévia','(até 90)','<input class="cad-in" id="seoOgT" maxlength="90"'+auto('og_titulo')+' value="'+_seoA(val('og_titulo'))+'">')+
      campo('seoOgD','Descrição da prévia','(até 200)','<input class="cad-in" id="seoOgD" maxlength="200"'+auto('og_desc')+' value="'+_seoA(val('og_desc'))+'">')+
      campo('seoOgF','Foto da prévia','','<select class="cad-in" id="seoOgF">'+fotoOpts+'</select>')+
    '</div>';
  }

  /* ---------- a prévia (Google + WhatsApp), calculada na tela ---------- */
  function _seoBase(){
    var preco=0; try{ preco=estRS('efAnuncio'); }catch(_){}
    var a=_seoPadrao({ marca:_seoV('efMarca'), modelo:_seoV('efModelo'), ano:_seoV('efAno'), ano_modelo:_seoV('efAnoMod'), cor:_seoV('efCor'), km:_seoV('efKm'), preco_anuncio:preco },
      { cambio:_seoV('efCambio'), localizacao_veiculo:_seoV('efLocalizacao') });
    return { titulo:a.nomeAno, precoTxt:a.precoTxt, tituloAuto:a.titulo, descAuto:a.descricao, ogTAuto:a.og_titulo, ogDAuto:a.og_desc, urlBase:a.urlBase, auto:a };
  }
  function seoAutoAtualiza(){
    var b=_seoBase(), a=b.auto||{}, mapa={seoTit:'titulo',seoDesc:'descricao',seoTexto:'texto',seoSlug:'slug',seoOgT:'og_titulo',seoOgD:'og_desc'};
    Object.keys(mapa).forEach(function(id){ var el=$(id); if(el&&el.getAttribute('data-seo-auto')==='1') el.value=a[mapa[id]]||''; });
  }
  function seoPinta(){
    var pv=$('seoPrevia'); if(!pv) return;
    var b=_seoBase(), id=_estEditId||'';
    var slug=seoSlugify(_seoV('seoSlug'));
    var tit=_seoV('seoTit')||b.tituloAuto, desc=_seoV('seoDesc')||b.descAuto;
    var ogT=_seoV('seoOgT')||b.ogTAuto, ogD=_seoV('seoOgD')||b.ogDAuto;
    var foto=_seoV('seoOgF')||_seoFotoUrl((_estFotos||[])[0])||'';
    var url=b.urlBase+(slug||id||'…');
    var corta=function(s,n){ s=String(s||''); return s.length>n?(s.slice(0,n-1)+'…'):s; };
    pv.innerHTML='<div class="seo-g"><div class="seo-g-url">'+esc(url)+'</div><div class="seo-g-tit">'+esc(corta(tit,62))+'</div><div class="seo-g-desc">'+esc(corta(desc,158))+'</div></div>'+
      '<div class="seo-w">'+(foto?('<img src="'+_seoA(foto)+'" alt="">'):'<div class="seo-w-semfoto">sem foto</div>')+'<div class="seo-w-tx"><b>'+esc(corta(ogT,70))+'</b><span>'+esc(corta(ogD,100))+'</span><i>'+esc(location.host)+'</i></div></div>';
    var ub=$('seoUrlBase'); if(ub) ub.textContent=b.urlBase;
    /* contadores */
    Array.prototype.forEach.call(document.querySelectorAll('.seo-cont'),function(c){
      var el=$(c.getAttribute('data-for')); if(!el) return; var n=String(el.value||'').length, mx=Number(c.getAttribute('data-max'))||0;
      c.textContent=n+' / '+mx; c.classList.toggle('alto', mx && n>mx*0.92);
    });
    /* apelido repetido dentro da loja? (a lista já está na memória) */
    var msg=$('seoSlugMsg'); if(msg){
      if(!slug){ msg.textContent=_seoV('seoSlug')?'Só letras, números e hífen — vou gravar assim: (vazio = usa o código do carro).':''; msg.className='cad-help seo-slug-msg'; }
      else{
        var dup=(_estoque||[]).filter(function(x){ return String(x.id)!==String(id) && x.extras && x.extras.seo && String(x.extras.seo.slug||'').toLowerCase()===slug; })[0];
        if(dup){ msg.textContent='Já usado por '+((dup.marca||'')+' '+(dup.modelo||'')).trim()+(dup.placa?(' ('+dup.placa+')'):'')+' — escolha outro, senão os dois disputam o mesmo endereço.'; msg.className='cad-help seo-slug-msg seo-erro'; }
        else{ msg.textContent='Vai ficar: '+b.urlBase+slug+(_seoV('seoSlug')!==slug?('  (ajustei: "'+_seoV('seoSlug')+'" → "'+slug+'")'):''); msg.className='cad-help seo-slug-msg seo-ok'; }
      }
    }
  }
  function seoWire(){
    try{
      if(!$('seoPrevia')) return;
      ['seoTit','seoDesc','seoTexto','seoSlug','seoOgT','seoOgD','seoOgF','seoIdx'].forEach(function(id){
        var el=$(id); if(!el || el._seoLigado) return; el._seoLigado=true;
        el.addEventListener('input', function(){ if(el.hasAttribute('data-seo-auto')) el.setAttribute('data-seo-auto','0'); seoPinta(); }, false);
        el.addEventListener('change', seoPinta, false);
      });
      var sl=$('seoSlug'); if(sl) sl.addEventListener('blur', function(){ var s=seoSlugify(sl.value); if(sl.value!==s){ sl.value=s; seoPinta(); try{ estAgendaSalvar(); }catch(_){} } }, false);
      var ix=$('seoIdx'); if(ix) ix.addEventListener('change', function(){ ix.parentElement.classList.toggle('on', ix.checked); }, false);
      /* os campos do cadastro que mudam a prévia automática */
      ['efMarca','efModelo','efAno','efAnoMod','efCor','efKm','efAnuncio','efCambio','efLocalizacao'].forEach(function(id){
        var el=$(id); if(!el || el._seoOuve) return; el._seoOuve=true; el.addEventListener('input', function(){ if($('seoPrevia')){ seoAutoAtualiza(); seoPinta(); } }, false);
      });
      seoAutoAtualiza();
      seoPinta();
    }catch(_){}
  }

  /* ---------- o que vai pro extras ---------- */
  function seoColeta(){
    /* a aba não está na tela (não é admin, ou ficha antiga): preserva o que já existe */
    if(!$('seoPrevia')){
      try{ var _a=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
        var _s=_a&&_a.extras&&_a.extras.seo; return (_s&&typeof _s==='object'&&Object.keys(_s).length)?{ seo:_s }:{}; }catch(_){ return {}; }
    }
    var o={};
    var t=_seoV('seoTit').slice(0,SEO_LIM.titulo); if(t) o.titulo=t;
    var d=_seoV('seoDesc').slice(0,SEO_LIM.descricao); if(d) o.descricao=d;
    var p=_seoV('seoPal').slice(0,SEO_LIM.palavras); if(p) o.palavras=p;
    var x=String((($('seoTexto')||{}).value||'')).replace(/\r/g,'').trim().slice(0,SEO_LIM.texto); if(x) o.texto=x;
    var ot=_seoV('seoOgT').slice(0,SEO_LIM.og_titulo); if(ot) o.og_titulo=ot;
    var od=_seoV('seoOgD').slice(0,SEO_LIM.og_desc); if(od) o.og_desc=od;
    var of=_seoV('seoOgF'); if(/^https:\/\//.test(of)) o.og_foto=of;
    var sl=seoSlugify(_seoV('seoSlug')); if(sl) o.slug=sl;
    if(!(($('seoIdx')||{}).checked)) o.indexar=false;
    return Object.keys(o).length ? { seo:o } : {};
  }

/* ╔═══ src/app/14q-opcionais-estoque.js ══════════════════════════════════ */
  /* ==========================================================================
     14q — OPCIONAIS MANUAIS NA FICHA DO ESTOQUE (v1204)
     --------------------------------------------------------------------------
     Usa a MESMA fonte de verdade da avaliação (`AV_OPCIONAIS`). A seleção é
     gravada no campo `extras.opcionais`, que já alimenta catálogo, marketing
     e salvamento na nuvem. Itens livres antigos são preservados em silêncio.
     ========================================================================== */

  function _estOpcFichaNorm(s){
    var t=String(s||'').toLowerCase();
    try{ t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){}
    return t.replace(/[^a-z0-9]+/g,' ').trim();
  }
  function _estOpcFichaLista(){
    return (typeof AV_OPCIONAIS!=='undefined'&&Array.isArray(AV_OPCIONAIS)) ? AV_OPCIONAIS : [];
  }
  var _EST_OPC_EDIT_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var _EST_OPC_X_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  function _estOpcFichaLimpa(s){
    return String(s==null?'':s).replace(/[\r\n\t]+/g,' ').replace(/\s{2,}/g,' ').trim().slice(0,40);
  }
  function _estOpcFichaEdicoes(ref){
    var bruto='';
    try{
      var campo=$('efOpcEdicoes');
      if(campo&&String(campo.getAttribute('data-ref')||'')===String(ref||'')) bruto=campo.value;
      if(!bruto){
        var atual=(_estoque||[]).filter(function(v){ return String(v.id)===String(_estEditId||''); })[0]||{};
        bruto=JSON.stringify(((atual.extras||{}).opcionais_edicoes)||{});
      }
    }catch(_){ bruto=''; }
    var lidas={}; try{ lidas=JSON.parse(bruto||'{}')||{}; }catch(_){ lidas={}; }
    var validas={}, chaves={}; _estOpcFichaLista().forEach(function(p){ chaves[p[0]]=1; });
    Object.keys(lidas).forEach(function(k){ var nome=_estOpcFichaLimpa(lidas[k]); if(chaves[k]&&nome) validas[k]=nome; });
    return validas;
  }
  function _estOpcFichaRotulo(p, edicoes){ return _estOpcFichaLimpa((edicoes||{})[p[0]])||p[1]; }
  function _estOpcFichaEdicoesGravar(ref, edicoes){
    var campo=$('efOpcEdicoes');
    if(campo){ campo.setAttribute('data-ref',String(ref||'')); campo.value=JSON.stringify(edicoes||{}); }
  }
  function _estOpcFichaTokens(){
    var campo=$('exOpc'), texto=String((campo&&campo.value)||'').trim();
    return texto ? texto.split(/[,;·\n]+/).map(function(s){ return String(s||'').trim(); }).filter(Boolean) : [];
  }
  function _estOpcFichaEstado(ref){
    var lista=_estOpcFichaLista(), edicoes=_estOpcFichaEdicoes(ref), porNome={};
    lista.forEach(function(p){ porNome[_estOpcFichaNorm(p[1])]=p; porNome[_estOpcFichaNorm(_estOpcFichaRotulo(p,edicoes))]=p; });
    var marcados={}, extras=[];
    _estOpcFichaTokens().forEach(function(nome){
      var p=porNome[_estOpcFichaNorm(nome)];
      if(p) marcados[p[0]]=1;
      else extras.push(nome);
    });
    /* Migração suave: se o campo ainda está vazio, aproveita marcações antigas
       da ficha gerada sem transformar itens desconhecidos em promessa pública. */
    if(!Object.keys(marcados).length&&!extras.length&&ref){
      try{
        var antigo=fichaResumoLer(ref)||{};
        (antigo.marcados||[]).forEach(function(nome){
          var p=porNome[_estOpcFichaNorm(nome)]; if(p) marcados[p[0]]=1;
        });
      }catch(_){}
    }
    return { marcados:marcados, extras:extras, edicoes:edicoes };
  }
  function estOpcFichaHtml(ref){
    var lista=_estOpcFichaLista(), estado=_estOpcFichaEstado(ref);
    var n=Object.keys(estado.marcados).length+estado.extras.length;
    return '<div class="est-opc-manual">'+
      '<input type="hidden" id="efOpcEdicoes" data-ref="'+esc(String(ref||''))+'" value="'+esc(JSON.stringify(estado.edicoes||{}))+'">'+
      '<div class="av-opc-head"><h3>Opcionais do veículo</h3><output id="efOpcConta" class="av-opc-conta" aria-live="polite">'+
        (n===0?'nenhum':(n+(n===1?' item':' itens')))+'</output></div>'+
      '<p class="av-opc-sub">Marque somente o que este veículo tem. Use o lápis para corrigir um nome ou adicione um opcional que não esteja na lista.</p>'+
      '<div class="av-opc-grade" id="efOpcGrade">'+lista.map(function(p){
        var on=!!estado.marcados[p[0]], nome=_estOpcFichaRotulo(p,estado.edicoes);
        return '<div class="est-opc-linha"><label class="av-opc-it'+(on?' on':'')+'"><input type="checkbox" data-est-opc="'+esc(p[0])+'"'+(on?' checked':'')+'><span>'+esc(nome)+'</span></label>'+
          '<button type="button" class="est-opc-editar" data-est-opc-edit="'+esc(p[0])+'" aria-label="Editar '+esc(nome)+'" title="Editar nome">'+_EST_OPC_EDIT_SVG+'</button></div>';
      }).join('')+'</div>'+
      '<div class="av-opc-extra"><label class="avt-col" for="efOpcNovo">Adicionar opcional'+
        '<input class="avt-in" id="efOpcNovo" type="text" maxlength="40" autocomplete="off" placeholder="Ex.: Engate para reboque"></label>'+
        '<button type="button" class="av-opc-add" id="efOpcAdd">Adicionar</button></div>'+
      '<div class="av-opc-meus" id="efOpcMeus">'+estado.extras.map(function(nome,i){
        return '<span class="av-opc-chip"><span>'+esc(nome)+'</span><button type="button" data-est-extra-edit="'+i+'" aria-label="Editar '+esc(nome)+'" title="Editar">'+_EST_OPC_EDIT_SVG+'</button><button type="button" data-est-extra-rm="'+i+'" aria-label="Remover '+esc(nome)+'" title="Remover">'+_EST_OPC_X_SVG+'</button></span>';
      }).join('')+'</div>'+
    '</div>';
  }
  function _estOpcFichaAplicar(estado, ref){
    var lista=_estOpcFichaLista(), edicoes=estado.edicoes||{};
    var nomes=lista.filter(function(p){ return estado.marcados[p[0]]; }).map(function(p){ return _estOpcFichaRotulo(p,edicoes); });
    var todos=nomes.concat(estado.extras||[]), campo=$('exOpc');
    _estOpcFichaEdicoesGravar(ref,edicoes);
    if(campo){ campo.value=todos.join(', '); campo.dispatchEvent(new Event('input',{bubbles:true})); }
    if(ref){
      try{
        var resumo=fichaResumoLer(ref)||{};
        resumo.opcionais=lista.map(function(p){ return _estOpcFichaRotulo(p,edicoes); });
        resumo.marcados=todos.slice(0);
        fichaResumoSalvar(ref,resumo); fichaRepasseAtualiza(ref);
      }catch(_){}
    }
    try{ estAgendaSalvar(); }catch(_){}
    if($('efFichaBox')) estFichaBox(ref);
  }
  function _estOpcFichaDuplicado(nome, estado, ignorarChave, ignorarExtra){
    var alvo=_estOpcFichaNorm(nome), achou=false;
    _estOpcFichaLista().forEach(function(p){ if(p[0]!==ignorarChave&&_estOpcFichaNorm(_estOpcFichaRotulo(p,estado.edicoes))===alvo) achou=true; });
    (estado.extras||[]).forEach(function(n,i){ if(i!==ignorarExtra&&_estOpcFichaNorm(n)===alvo) achou=true; });
    return achou;
  }
  function estOpcFichaWire(box, ref){
    if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('[data-est-opc]'),function(chk){
      chk.onchange=function(){
        var lista=_estOpcFichaLista(), estado=_estOpcFichaEstado(ref), chave=chk.getAttribute('data-est-opc');
        if(chk.checked){
          /* Direção elétrica e hidráulica são mutuamente exclusivas, igual à avaliação. */
          var par=(typeof _AV_OPC_EXCLUI!=='undefined'&&_AV_OPC_EXCLUI[chave])||'';
          if(par) delete estado.marcados[par];
          estado.marcados[chave]=1;
        }else delete estado.marcados[chave];
        _estOpcFichaAplicar(estado,ref);
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-est-opc-edit]'),function(bt){
      bt.onclick=function(){
        var chave=bt.getAttribute('data-est-opc-edit'), lista=_estOpcFichaLista();
        var p=lista.filter(function(x){ return x[0]===chave; })[0]; if(!p) return;
        var estado=_estOpcFichaEstado(ref), atual=_estOpcFichaRotulo(p,estado.edicoes);
        var novo=prompt('Edite o nome do opcional. Apague para restaurar o original:',atual);
        if(novo===null) return; novo=_estOpcFichaLimpa(novo);
        if(!novo||_estOpcFichaNorm(novo)===_estOpcFichaNorm(p[1])) delete estado.edicoes[chave];
        else {
          if(_estOpcFichaDuplicado(novo,estado,chave,-1)){ toast('Esse opcional já está na lista.'); return; }
          estado.edicoes[chave]=novo;
        }
        _estOpcFichaAplicar(estado,ref);
      };
    });
    var add=$('efOpcAdd'), novoCampo=$('efOpcNovo');
    if(add&&novoCampo){
      var adicionar=function(){
        var nome=_estOpcFichaLimpa(novoCampo.value), estado=_estOpcFichaEstado(ref);
        if(!nome){ novoCampo.focus(); return; }
        if(_estOpcFichaDuplicado(nome,estado,'',-1)){ toast('Esse opcional já está na lista.'); novoCampo.value=''; return; }
        if(estado.extras.length>=12){ toast('Você já adicionou 12 opcionais fora da lista.'); return; }
        estado.extras.push(nome); _estOpcFichaAplicar(estado,ref);
      };
      add.onclick=adicionar;
      novoCampo.onkeydown=function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); adicionar(); } };
    }
    Array.prototype.forEach.call(box.querySelectorAll('[data-est-extra-edit]'),function(bt){
      bt.onclick=function(){
        var i=Number(bt.getAttribute('data-est-extra-edit')), estado=_estOpcFichaEstado(ref), atual=estado.extras[i];
        if(!atual) return; var novo=prompt('Edite o nome do opcional:',atual); if(novo===null) return;
        novo=_estOpcFichaLimpa(novo); if(!novo){ toast('O nome não pode ficar vazio.'); return; }
        if(_estOpcFichaDuplicado(novo,estado,'',i)){ toast('Esse opcional já está na lista.'); return; }
        estado.extras[i]=novo; _estOpcFichaAplicar(estado,ref);
      };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-est-extra-rm]'),function(bt){
      bt.onclick=function(){ var estado=_estOpcFichaEstado(ref); estado.extras.splice(Number(bt.getAttribute('data-est-extra-rm')),1); _estOpcFichaAplicar(estado,ref); };
    });
  }

  /* Compatibilidade interna do importador de anúncio. Não é exibido nem
     acionável na aba Ficha técnica; fica separado para não inchar o 14. */
  async function estFichaGerarIA(ref,opts){
    opts=opts||{};
    var box=$('efFichaBox'); if(!box) return;
    var v=null; try{ v=_estFichaVeic(); }catch(_){ v=null; } v=v||{};
    var veic={ marca:String(v.marca||'').trim(), modelo:String(v.modelo||'').trim(), versao:String(v.versao||'').trim(), ano:String(v.ano||'').trim(), ano_modelo:String(v.ano_modelo||v.ano||'').trim(), cor:String(v.cor||'').trim(), combustivel:String(v.combustivel||'').trim(), cambio:String(v.cambio||'').trim() };
    if(!(veic.marca||veic.modelo)||!(veic.ano||veic.ano_modelo)){ box.innerHTML='<div class="cad-msg err">Preencha marca/modelo e o ano na aba Cadastro antes de importar a ficha.</div>'; setTimeout(estFichaBox,3200); return {ok:false}; }
    var frases=['Abrindo o catálogo oficial da montadora…','Levantando motor, câmbio e desempenho…','Medindo dimensões e capacidades…','Listando os equipamentos de série…','Organizando os dados…'];
    box.innerHTML=ccLoaderHtml('Importando a ficha do modelo…',frases);
    var timer=ccLoaderStart(frases);
    try{
      var placaReal=limpa(String((($('efPlaca')||{}).value)||'')); if(!valida(placaReal)) placaReal='';
      var d=await _iaJobRodar({ job:true, cobrar:true, placa:placaReal, veiculo:veic });
      if(d&&d.sem_saldo){ if(d.saldo!=null) setSaldo(d.saldo); box.innerHTML='<div class="cad-msg err">Saldo insuficiente para concluir a importação.</div>'; setTimeout(estFichaBox,2600); return {ok:false,sem_saldo:true}; }
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(!d||!d.ok){ box.innerHTML='<div class="cad-msg err">'+esc((d&&d.erro)||'Não consegui importar agora.')+(d&&d.estornado?' Valor devolvido ao saldo.':'')+'</div>'; setTimeout(estFichaBox,3200); return {ok:false,estornado:!!(d&&d.estornado)}; }
      var refGerado=ref||_ftRefAtual();
      if(!fichaTecTemConteudoUtil(d.resultado)){
        box.innerHTML='<div class="cad-msg err">A importação não trouxe dados técnicos utilizáveis.</div>';
        setTimeout(function(){ estFichaBox(refGerado); },3600);
        return {ok:false,ficha_invalida:true};
      }
      fichaTecGuardar(refGerado,d.resultado);
      if(opts.salvar!==false){ try{ estAgendaSalvar(); }catch(_){} }
      estFichaBox(refGerado);
      return {ok:true,ref:refGerado};
    }catch(e){ box.innerHTML='<div class="cad-msg err">Falha ao importar a ficha.</div>'; setTimeout(estFichaBox,3200); return {ok:false}; }
    finally{ try{ clearInterval(timer); }catch(_){} }
  }

/* ╔═══ src/app/15-marketing.js ═══════════════════════════════════════════ */
  /* ================= MARKETING (divulgação do estoque) =================
     O usuário escolhe um veículo do estoque e monta o post automático e o card
     de venda — os mesmos geradores que antes ficavam na ficha do estoque. */
  var _mktV=null;
  var _ICO_MKT='<svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="#c7d2e5" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>';
  function _mktPanelPh(){ return '<div class="est-panel-ph">'+_ICO_MKT+'<div style="font-weight:800;color:#64748b">Escolha um veículo</div><div style="font-size:12.5px;line-height:1.5">Toque num carro à esquerda pra gerar<br>o post pra redes sociais.</div></div>'; }
  async function telaMarketing(){
    mevTabSet('');
    _mktV=null;
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg est-wrap">'+
      '<div class="est-main">'+
        '<div class="est-head"><h2 style="margin:0">Marketing</h2></div>'+
        '<p style="font-size:12.5px;color:#64748b;margin:2px 0 12px">Escolha um veículo do estoque para gerar o <b>post para redes sociais</b>.</p>'+
        '<div class="cli-top"><div class="cli-search" style="flex:1">'+_icoBusca+'<input id="mkBusca" placeholder="Buscar placa ou modelo" autocomplete="off"></div></div>'+
        '<div id="mkLista"><div class="cli-empty">Carregando...</div></div>'+
      '</div>'+
      '<div class="est-panel" id="mkPanel">'+_mktPanelPh()+'</div>'+
      '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); document.body.classList.add('est-2col'); document.body.classList.remove('est-panel-on'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    mevEstNovo(false);
    $('mkBusca').oninput=function(){ mktPinta(this.value); };
    if(!_estoque.length) await estCarregar();
    mktPinta('');
  }
  function mktPinta(termo){
    var el=$('mkLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    if(!_estoque.length){ el.innerHTML='<div class="cli-empty"><b>Nenhum veículo no estoque</b>Cadastre os carros no Estoque — depois é só voltar aqui pra divulgar.</div>'; return; }
    var lista=_estoque.filter(function(v){
      if((v.status||'disponivel')==='vendido') return false;
      if(!termo) return true;
      return (String(v.placa||'').toLowerCase().indexOf(termo)>=0) || (((v.marca||'')+' '+(v.modelo||'')).toLowerCase().indexOf(termo)>=0);
    });
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado.</div>'; return; }
    el.innerHTML=lista.map(function(v){
      var foto=(v.fotos&&v.fotos.length)?('<div class="est-thumb"><img loading="lazy" src="'+esc(v.fotos[0])+'"></div>'):('<div class="est-thumb no">'+ICO_EST+'</div>');
      var preco=v.preco_anuncio?estMoney(v.preco_anuncio):(v.preco_minimo?('mín. '+estMoney(v.preco_minimo)):'');
      return '<div class="est-card" data-id="'+esc(v.id)+'">'+foto+
        '<div class="est-tx"><div class="est-nm">'+esc(((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo')+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.ano?' · '+esc(v.ano):'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':'')+'</div>'+
        '<div class="est-row"><span class="est-preco">'+esc(preco||'—')+'</span></div></div>'+
        '<div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){ card.onclick=function(){ mktAbrir(card.getAttribute('data-id')); }; });
  }
  function mktAbrir(id){
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!v) return;
    _mktV=v;
    var panel=$('mkPanel'); if(!panel) return;
    var foto=(v.fotos&&v.fotos.length)?('<img loading="lazy" decoding="async" class="card-prev" src="'+esc(imgCdn(v.fotos[0],800))+'" style="margin:0 0 10px">'):'';
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
    var preco=v.preco_anuncio?estMoney(v.preco_anuncio):(v.preco_minimo?estMoney(v.preco_minimo):'');
    panel.innerHTML='<div class="est-phead"><span class="est-pav">'+mkIco('megafone',19)+'</span><span class="est-pt">'+esc(nome)+'</span><button type="button" class="est-px" id="mkClose" aria-label="Fechar">&#10005;</button></div>'+
      '<div class="est-pbody">'+foto+
      '<div style="font-size:13px;color:#64748b;margin:0 0 12px"><b>'+esc(v.placa||'')+'</b>'+(v.ano?' · '+esc(v.ano):'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':'')+(preco?' · <b style="color:#0f172a">'+esc(preco)+'</b>':'')+'</div>'+
      '<div class="mk-gerar-ajuda">O post abaixo é montado automaticamente com os dados confirmados no estoque.</div>'+
      /* v602 — Post pro Marketplace: montagem local, sem IA, custo zero */
      '<button class="cad-btn ico" type="button" id="mktMpBt" style="margin-top:8px">'+mkIco('marketplace')+'Post pro Marketplace</button>'+
      '<div id="mktMpBox" data-on="0"></div>'+
      /* v656 — GERAR ARTE: a peça de impacto pro story e pro status. Custo
         zero (o cenário é desenhado no aparelho) e não grava nada. */
      /* v835: o botão só nasce com a arte ligada (00-edicoes) */
      ((typeof arteDisponivel!=='function'||arteDisponivel())
        ? '<button class="cad-btn ico" type="button" id="artBt" style="margin-top:8px">'+mkIco('post')+'Gerar arte</button>' : '')+
      '<div id="mkOut"></div>'+
      '</div>';
    document.body.classList.add('est-panel-on'); try{ panel.scrollTop=0; }catch(_){}
    _mktDireto=false;
    var _mpb=$('mktMpBt'); if(_mpb) _mpb.onclick=function(){ mktMarketplaceAbrir(); };   /* v602 */
    var _art=$('artBt'); if(_art) _art.onclick=function(){ arteAbrir(_mktV,'estoque'); };  /* v656 */
    try{ mktPostSalvoPinta(v); }catch(_){}
    $('mkClose').onclick=function(){ _mktV=null; panel.innerHTML=_mktPanelPh(); document.body.classList.remove('est-panel-on'); mktMarcaAtivo(null); };
    mktMarcaAtivo(id);
  }
  function mktMarcaAtivo(id){ try{ Array.prototype.forEach.call(document.querySelectorAll('#mkLista .est-card'),function(c){ c.classList.toggle('ativo', id!=null && String(c.getAttribute('data-id'))===String(id)); }); }catch(_){} }
  /* ===== v602 — POST PRO MARKETPLACE ====================================
     (PROJETO-2026-08-24-post-no-marketplace)
     Pedido do Angelo, 24/08, com print da tela "Novo classificado de
     veículo" do Facebook Marketplace:
       "crie dentro do marketing uma secao pra post no marketplace, com
        essas informacoes — as que nao tiver, coloque como nao informado"

     A ORDEM É O PRODUTO. O Facebook pede oito campos, de cima pra baixo;
     esta tela entrega os oito NA MESMA ORDEM, com o botão de copiar do
     lado. Preencher vira um movimento só, sem caçar dado em outra tela.

     🔴 O ACHADO: os chips da aba Diferenciais (as chaves de `extras` que o
     14-estoque grava pelo _POST_DE) respondem SOZINHOS três campos que o
     Facebook pede — número de proprietários, garantia e histórico de
     acidentes. Quem preencheu o carro uma vez não preenche de novo.

     Custo ZERO: montagem local, sem IA, sem ida ao servidor. Não grava
     nada; só lê o que já está no estoque e na loja. */
  var MP_FALTA='Não informado';
  function _mpTxt(x){ return String(x==null?'':x).trim(); }
  /* rótulo do "Tipo de veículo" igual ao da lista fechada do Facebook */
  function mktMpTipo(v){ try{ return ehMoto(v)?'Motocicleta':'Carro/Caminhonete'; }catch(_){ return 'Carro/Caminhonete'; } }
  function mktMpDescricao(v){
    var ex=(v&&v.extras)||{};
    var L=[];
    var cab=[_mpTxt(v.marca), _mpTxt(v.modelo), _mpTxt(v.versao)].filter(Boolean).join(' ');
    var anos=_mpTxt(v.ano_modelo)&&_mpTxt(v.ano)&&_mpTxt(v.ano)!==_mpTxt(v.ano_modelo)
      ? (_mpTxt(v.ano)+'/'+_mpTxt(v.ano_modelo)) : (_mpTxt(v.ano_modelo)||_mpTxt(v.ano));
    if(cab||anos) L.push((cab+' '+anos).trim());
    var km=Number(v.km)||0;
    L.push('Quilometragem: '+(km?(km.toLocaleString('pt-BR')+' km'):MP_FALTA));
    L.push('Cor: '+(_mpTxt(ex.cor||v.cor)||MP_FALTA));
    L.push('Câmbio: '+(_mpTxt(ex.cambio||v.cambio)||MP_FALTA));
    L.push('Combustível: '+(_mpTxt(ex.combustivel||v.combustivel)||MP_FALTA));
    L.push('Opcionais: '+(_mpTxt(ex.opcionais)||MP_FALTA));
    /* Destaques: os chips que NÃO viraram linha própria abaixo */
    var jaUsados={unico_dono:1,dono2:1,garantia_fab:1,garantia_90_dias:1,sem_sinistro:1,sem_leilao:1};
    var dest=[];
    try{ Object.keys(_POST_DE).forEach(function(ch){ var k=_POST_DE[ch];
      if(!jaUsados[k] && ex[k] && _POST_MAP[ch]) dest.push(_POST_MAP[ch]); }); }catch(_){}
    if(dest.length) L.push('Destaques: '+dest.join(' · '));
    /* as três últimas linhas são exatamente as que o Facebook pede na dica
       do campo Descrição ("danos, histórico de acidentes e garantia") */
    L.push('Danos: '+MP_FALTA);
    var hist=[]; if(ex.sem_sinistro) hist.push('sem sinistro'); if(ex.sem_leilao) hist.push('sem passagem por leilão');
    L.push('Histórico de acidentes: '+(hist.length?hist.join(', '):MP_FALTA));
    var gar=[]; if(ex.garantia_fab) gar.push('ainda na garantia de fábrica'); if(ex.garantia_90_dias) gar.push('garantia de 90 dias da loja');
    L.push('Garantia: '+(gar.length?gar.join(', '):MP_FALTA));
    /* 🔴 AQUI O PROJETO PEDIA `v.obs` E ELE **NÃO** ENTRA — é a LIÇÃO DA
       v265. O v.obs é a ANOTAÇÃO INTERNA do estoque ("recebido na troca do
       Fulano", "lataria R$ 900"); isto aqui é texto pra PUBLICAR. O campo
       feito pra publicar é o extras.destaques, e ele ainda passa pelo
       obsPublica() (que apaga valor em dinheiro) antes de sair. */
    var livre=_mpTxt(ex.destaques);
    try{ if(livre && typeof obsPublica==='function') livre=_mpTxt(obsPublica(livre)); }catch(_){}
    var txt=L.join('\n');
    if(livre) txt+='\n\n'+livre;
    return txt;
  }
  function mktMpCampos(v){
    var ex=(v&&v.extras)||{};
    var lj=(typeof _lojaRec!=='undefined' && _lojaRec)?_lojaRec:{};
    var ano=_mpTxt(v.ano_modelo)||_mpTxt(v.ano);
    var modelo=[_mpTxt(v.modelo), _mpTxt(v.versao)].filter(Boolean).join(' ');
    var donos=ex.unico_dono?'1':(ex.dono2?'2':'');
    var local=[_mpTxt(lj.cidade), _mpTxt(lj.uf)].filter(Boolean).join(', ');
    /* 🔴 O campo Preço do Facebook come SÓ NÚMERO. A tela MOSTRA
       "R$ 98.900" e COPIA "98900" — um erro de digitação a menos. */
    var precoNum=Number(v.preco_anuncio)||Number(v.preco_minimo)||0;
    return [
      { rot:'Tipo de veículo',        val:mktMpTipo(v) },
      { rot:'Ano',                    val:ano },
      { rot:'Fabricante',             val:_mpTxt(v.marca) },
      { rot:'Modelo',                 val:modelo },
      { rot:'Número de proprietários',val:donos },
      { rot:'Localização',            val:local },
      { rot:'Preço',                  val:(precoNum?('R$ '+precoNum.toLocaleString('pt-BR')):''), copia:(precoNum?String(precoNum):'') },
      { rot:'Descrição',              val:mktMpDescricao(v), longo:true }
    ].map(function(c){
      c.falta=!_mpTxt(c.val);
      if(c.falta) c.val=MP_FALTA;
      if(c.copia==null) c.copia=(c.falta?'':c.val);
      return c;
    });
  }
  function mktMpHtml(v){
    var cs=mktMpCampos(v);
    return '<div class="mp-cx">'+cs.map(function(c,i){
      return '<div class="mp-l'+(c.longo?' longo':'')+'">'
        +'<div class="mp-r">'+esc(c.rot)+'</div>'
        +'<div class="mp-v'+(c.falta?' falta':'')+'">'+esc(c.val).replace(/\n/g,'<br>')+'</div>'
        +(c.copia?('<button type="button" class="mp-c" data-mp="'+i+'" aria-label="Copiar '+esc(c.rot)+'">'+mkIco('copiar',15)+'</button>'):'')
      +'</div>';
    }).join('')
    +'<button type="button" class="mp-tudo" id="mktMpTudo">Copiar tudo</button></div>';
  }
  function mktMpCopiar(txt, bt){
    if(!txt) return;
    function feito(){ if(bt){ bt.classList.add('ok'); setTimeout(function(){ bt.classList.remove('ok'); },1200); } toast('Copiado ✓'); }
    try{ if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(feito, function(){ toast(txt); }); return; } }catch(_){}
    toast(txt);
  }
  /* abre/fecha a lista. Tocou de novo, fecha — como o projeto pediu. */
  function mktMarketplaceAbrir(){
    var box=$('mktMpBox'), v=_mktV; if(!box||!v) return;
    if(box.getAttribute('data-on')==='1'){ box.innerHTML=''; box.setAttribute('data-on','0'); return; }
    box.innerHTML=mktMpHtml(v);
    box.setAttribute('data-on','1');
    var cs=mktMpCampos(v);
    Array.prototype.forEach.call(box.querySelectorAll('.mp-c'),function(b){
      b.onclick=function(){ var c=cs[Number(b.getAttribute('data-mp'))]; mktMpCopiar(c&&c.copia, b); };
    });
    var t=$('mktMpTudo'); if(t) t.onclick=function(){
      mktMpCopiar(cs.map(function(c){ return c.rot+': '+(c.falta?MP_FALTA:c.val); }).join('\n'), t);
    };
  }
  async function lojaCardPreview(){
    var out=$('ljCardPrevOut'); if(!out) return;
    var cfg=_lojaCardLerForm();
    out.innerHTML='<div class="post-load"><span class="spin" style="width:20px;height:20px;border-width:3px"></span> Gerando exemplo...</div>';
    var loja={ nome_fantasia:((($('ljFant')||{}).value)||(_lojaRec&&_lojaRec.nome_fantasia)||'Sua Loja'), logo_url:(_lojaLogoUrl||(_lojaRec&&_lojaRec.logo_url)||''), whatsapp:((($('ljWa')||{}).value)||'') };
    var veic={ marca:'VW', modelo:'Nivus Highline', ano:'2022', km:'28000', placa:'ABC1D23', cor:'Branco', precoNum:98900 };
    try{ var cv=await mevCardCanvas(veic,cfg,loja,null); var url=cv.toDataURL('image/jpeg',0.9); out.innerHTML='<img loading="lazy" decoding="async" class="card-prev" src="'+esc(imgCdn(url,800))+'">'; }catch(e){ out.innerHTML='<div class="cad-msg err">Não consegui gerar o exemplo.</div>'; }
  }
  /* ---- REENQUADRAR FOTOS — deixa todas no mesmo formato (4:3, 1200x900).
     A foto principal entra inteira e centralizada. Quando a proporção não
     fecha em 4:3, uma segunda cópia ampliada e desfocada completa a moldura.
     Assim o cadastro fica alinhado sem cortar roda, teto ou para-choque. ---- */
  var FOTO_W=1200, FOTO_H=900;
  /* v174 (H) — como o interruptor saiu da tela, o reenquadramento 4:3 passa a
     ser SEMPRE ligado. Se alguem tivesse desligado ele um dia, ficaria preso
     desligado pra sempre (sem botao pra religar) — por isso ele volta fixo. */
  /* ⚠️ v838 — ACHADO NA CONFERÊNCIA, E FICA REGISTRADO: este `true` é
     CRAVADO. Ele ignora o `mev_foto_enq` que o `_fotoEnqSet` logo abaixo
     grava — ou seja, existe uma preferência que ninguém lê, e o
     reenquadramento é obrigatório pra todo mundo.
     Não é defeito acidental: em algum momento a leitura virou `true` de
     propósito (foto sem enquadrar quebra a grade do catálogo). Mas o
     `_fotoEnqSet` ficou órfão — não tem UM chamador em todo o app.
     Deixei os dois como estão porque o Angelo pediu o CORTE, não o
     interruptor. Se um dia o interruptor voltar, é aqui: trocar o `true`
     por `localStorage.getItem('mev_foto_enq')!=='0'` e pôr o botão na tela
     de fotos. Escrito pra próxima sessão não gastar a tarde achando isto de
     novo. */
  function _fotoEnqLigado(){ return true; }
  function _fotoEnqSet(v){ try{ localStorage.setItem('mev_foto_enq', v?'1':'0'); }catch(_){} }
  function reenquadrarFoto(file){
    return new Promise(function(resolve){
      try{
        var url=URL.createObjectURL(file); var im=new Image();
        im.onload=function(){
          try{
            var cv=document.createElement('canvas'); cv.width=FOTO_W; cv.height=FOTO_H;
            var g=cv.getContext('2d'); g.fillStyle='#0f172a'; g.fillRect(0,0,FOTO_W,FOTO_H);
            /* Algumas fotos antigas já foram gravadas em 4:3 com faixas
               brancas laterais. Recuperamos a área útil antes de reaplicar
               o novo enquadramento, sem tocar em fotos que não têm ambas as
               bordas praticamente brancas. */
            var sx=0, sw=im.width;
            try{
              var scan=document.createElement('canvas'); scan.width=im.width; scan.height=im.height;
              var sg=scan.getContext('2d'); sg.drawImage(im,0,0);
              function faixaBranca(dir){
                var max=Math.floor(im.width*.38), achou=0;
                for(var x=dir>0?0:im.width-1, n=0;n<max;x+=dir*4,n+=4){
                  var clara=true;
                  for(var y=Math.floor(im.height*.12);y<im.height*.89;y+=Math.max(1,Math.floor(im.height/10))){
                    var p=sg.getImageData(x,y,1,1).data;
                    if(!(p[0]>245&&p[1]>245&&p[2]>245&&Math.abs(p[0]-p[1])<8&&Math.abs(p[1]-p[2])<8)){ clara=false; break; }
                  }
                  if(!clara) break; achou=n+4;
                }
                return Math.min(max,achou);
              }
              var esquerda=faixaBranca(1), direita=faixaBranca(-1);
              if(esquerda>im.width*.15 && direita>im.width*.15 && im.width-esquerda-direita>im.height*.35){ sx=esquerda; sw=im.width-esquerda-direita; }
            }catch(_){ /* leitura de pixels indisponível: mantém a imagem inteira */ }
            /* v1509 — enquadramento realmente automático. `cover` parecia
               alinhado, mas escondia partes diferentes conforme a proporção
               do arquivo. A camada de fundo continua preenchendo o quadro;
               a camada principal usa `contain`, preserva a foto completa e
               fica sempre centralizada. O arquivo final segue 1200 × 900,
               portanto os cards continuam perfeitamente alinhados. */
            var fundo=Math.max(FOTO_W/sw,FOTO_H/im.height)*1.08;
            var fw=sw*fundo, fh=im.height*fundo;
            g.save();
            try{ g.filter='blur(28px) brightness(0.72) saturate(0.88)'; }catch(_){}
            g.drawImage(im,sx,0,sw,im.height,(FOTO_W-fw)/2,(FOTO_H-fh)/2,fw,fh);
            g.restore();
            g.fillStyle='rgba(15,23,42,.12)'; g.fillRect(0,0,FOTO_W,FOTO_H);
            var principal=Math.min(FOTO_W/sw,FOTO_H/im.height);
            var pw=sw*principal, ph=im.height*principal;
            g.drawImage(im,sx,0,sw,im.height,(FOTO_W-pw)/2,(FOTO_H-ph)/2,pw,ph);
            URL.revokeObjectURL(url);
            if(cv.toBlob) cv.toBlob(function(b){ resolve(b||null); }, 'image/jpeg', 0.88);
            else resolve(null);
          }catch(e){ try{ URL.revokeObjectURL(url); }catch(_){} resolve(null); }
        };
        im.onerror=function(){ try{ URL.revokeObjectURL(url); }catch(_){} resolve(null); };
        im.src=url;
      }catch(e){ resolve(null); }
    });
  }
  try{ if(/^(localhost|127\.)/.test(location.hostname)) window.__t_reenq=reenquadrarFoto; }catch(_){}
  async function estFotosReenquadrar(){
    if(!_estFotos.length){ toast('Nao ha fotos pra reenquadrar.'); return; }
    var b=$('efEnqTodas'); if(b){ b.disabled=true; b.textContent='Reenquadrando...'; }
    var n=0;
    /* ===== v808 (§5.2) — O LOTE TAMBÉM PASSA PELA PROTEÇÃO ================
       🔴 Este era o caminho mais fácil de esquecer: ele reenquadra TODAS as
       fotos já enviadas de uma vez e as regrava. Sem passar pela proteção,
       um toque em "Reenquadrar as fotos já enviadas" desfaria a máscara de
       todas elas de uma vez — e ninguém veria, porque o botão só diz
       "Pronto: 8 foto(s) no mesmo formato ✓".
       Agora as fotos cortadas vão TODAS pro editor, de uma vez, e a pessoa
       revisa antes de qualquer coisa ser regravada. */
    var cortadas=[], indices=[];
    for(var i=0;i<_estFotos.length;i++){
      try{
        var r=await fetch(_estFotos[i]); var bl=await r.blob();
        var nb=await reenquadrarFoto(bl); if(!nb) continue;
        cortadas.push(nb); indices.push(i);
      }catch(e){}
    }
    var prontas=[];
    if(cortadas.length){
      try{ prontas=await fotoVeiculoPreparar(cortadas, { origem:'estoque' }); }catch(_){ prontas=[]; }
    }
    for(var j=0;j<prontas.length;j++){
      try{
        var u=await avUpload(prontas[j].blob, { tipo:'veiculo', protegida:prontas[j] });
        if(u){ _estFotos[indices[j]]=u; n++; estFotosPinta(); }
      }catch(e){}
    }
    if(b){ b.disabled=false; b.innerHTML=mkIco('recorte')+'Reenquadrar as fotos já enviadas'; b.classList.add('ico'); }
    toast(n?('Pronto: '+n+' foto(s) no mesmo formato ✓'):'Nao consegui reenquadrar as fotos.');
    try{ estAgendaSalvar(); }catch(_){}
  }
  /* ==========================================================================
     🔴 v903 — AS FOTOS DA AVALIAÇÃO APARECEM NO ESTOQUE
     --------------------------------------------------------------------------
     PEDIDO (05/09): "quando adiciono ao estoque um veículo que já tem fotos na
     avaliação, não está trazendo as fotos da galeria."

     Ele está certo, e é o MESMO vão que a v815 consertou — só que na direção
     contrária. Avaliação e estoque guardam a lista de fotos em lugares
     diferentes (`doc_consulta/aval_fotos` × `mp_estoque.fotos`), porque o carro
     avaliado pode nunca entrar no estoque. Quando ele entra, é o mesmo carro e
     a mesma placa, e quem cadastra espera achar as fotos já tiradas.

     🔴 OS TRÊS CUIDADOS SÃO OS DA v815, e o segundo vale MAIS aqui:
     1. ESPELHO, NÃO CÓPIA. `_estFotosAv` é lista à parte; nada entra em
        `_estFotos` sem o toque no botão.
     2. ⚠️ E AQUI O DESTINO É PÚBLICO. Na v815 o espelho ia pra avaliação, que
        é tela interna. Aqui as fotos do estoque saem no catálogo, na vitrine e
        na miniatura do WhatsApp. Foto de avaliação costuma ter close de avaria,
        odômetro e documento — adotar em silêncio publicaria no site do Angelo
        uma foto que ele nunca mandou publicar. Por isso é UM TOQUE, não
        automático. (Se você preferir automático, é uma linha: chamar
        `estFotosAdotarAv()` no fim do `estFotosDaAvaliacao`. Eu não faço isso
        sozinho — publicar foto é decisão sua.)
     3. A régua do dono: `.eq('user_id', meuId)`. A placa sozinha não basta.

     E só aparece quando o estoque está SEM foto nenhuma: tendo foto própria,
     ela manda. */
  var _estFotosAv=[];        /* v903 — o espelho da avaliação */
  var _estFotosAvPlaca='';   /* de qual placa ele é (a ficha troca de carro) */
  function _estPlacaFicha(){
    var el=$('efPlaca');
    var p=String((el&&el.value)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(p) return p;
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
    return String((v&&v.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
  }
  function estFotosDaAvaliacao(){
    try{
      var placa=_estPlacaFicha(), dono=String(meuId||'');
      if(!placa || placa.length<7 || !(window.supa&&dono)) return;
      if(_estFotosAvPlaca===placa) return;          /* já buscada */
      _estFotosAvPlaca=placa; _estFotosAv=[];
      supa.from('doc_consulta').select('resultado')
        .eq('user_id',dono).eq('tipo','aval_fotos').eq('chave',placa).limit(1)
        .then(function(r){
          if(_estPlacaFicha()!==placa || String(meuId||'')!==dono) return;   /* trocou de carro no meio */
          if(r&&r.error) return;
          var reg=(r&&r.data&&r.data[0])||null; if(!reg) return;
          var dados=reg.resultado||{};
          if(typeof dados==='string'){ try{ dados=JSON.parse(dados); }catch(_){ dados={}; } }
          var fs=[];
          try{ fs=avFotosNormaliza(dados.fotos); }catch(_){ fs=[]; }
          if(!fs.length) return;
          _estFotosAv=fs.slice(0,20);
          if(!_estFotos.length) estFotosPinta();
        }, function(){});
    }catch(_){ }
  }
  function estFotosAvLimpar(){ _estFotosAv=[]; _estFotosAvPlaca=''; }
  function estFotosAdotarAv(){
    if(!_estFotosAv.length) return;
    _estFotos=_estFotosAv.slice(0,20);
    _estFotosAv=[];
    estFotosPinta();
    try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){ }
    try{ toast(_estFotos.length+' foto(s) da avaliação usadas neste veículo.'); }catch(_){ }
  }
  function estFotosPinta(){
    var el=$('estFotos'); if(!el) return;
    try{ estFotosDaAvaliacao(); }catch(_){ }   /* v903 — busca uma vez por placa */
    el.innerHTML=_estFotos.map(function(f,i){ return '<div class="est-thumb-e">'+
      '<img class="clic" data-i="'+i+'" role="button" tabindex="0" '+(i?'loading="lazy" ':'')+'decoding="async" src="'+esc(f)+'" alt="Foto '+(i+1)+' do veículo" aria-label="Abrir ações da foto '+(i+1)+'">'+
      (i===0?'<span class="est-capa">capa</span>':'')+
      '<button type="button" class="est-thumb-ia" data-i="'+i+'" aria-label="Editar a foto '+(i+1)+' com IA" title="Editar com IA">'+_fotoIaIco('completa')+'</button>'+
      '<button type="button" class="est-thumb-del" data-i="'+i+'" aria-label="Remover a foto '+(i+1)+'">&times;</button>'+
      '<button type="button" class="est-thumb-enq" data-i="'+i+'" aria-label="Enquadrar a foto '+(i+1)+'">'+mkIco('recorte',17)+'<span>Enquadrar</span></button></div>'; }).join('')+
      '<button type="button" class="est-addfoto" id="estAddFoto" aria-label="Adicionar fotos" aria-controls="estFotoInput"><span aria-hidden="true">+</span><span>Adicionar fotos</span></button><input type="file" id="estFotoInput" accept="image/*" multiple style="display:none">'+
      /* v903 — o espelho da avaliação: só quando não há foto própria */
      ((!_estFotos.length && _estFotosAv.length) ? (
        '<div class="est-avfotos" id="estAvFotos">'+
          '<div class="est-avfotos-cab">'+
            '<b>Fotos da avaliação deste carro</b>'+
            '<span>'+_estFotosAv.length+' foto'+(_estFotosAv.length===1?'':'s')+' · ainda não estão no estoque</span>'+
          '</div>'+
          '<div class="est-avfotos-tira">'+
            _estFotosAv.slice(0,8).map(function(f,i){
              return '<img loading="lazy" decoding="async" src="'+esc(imgCdn(f,240))+'" alt="Foto '+(i+1)+' da avaliação">';
            }).join('')+
            (_estFotosAv.length>8?('<span class="est-avfotos-mais">+'+(_estFotosAv.length-8)+'</span>'):'')+
          '</div>'+
          '<button type="button" class="cad-btn sec" id="estAvFotosUsar">Usar estas fotos no estoque</button>'+
          '<div class="est-avfotos-nota">Elas vão pro catálogo e pra vitrine — confira antes se alguma é de avaria, odômetro ou documento.</div>'+
        '</div>'
      ) : '');
    /* v345 (pedido): sem foto nenhuma, o botão SOME. Antes ele só ficava
       apagado, e um botão apagado no topo de uma tela vazia parece defeito —
       o lojista toca, não acontece nada, e ele fica achando que travou. */
    /* v893 — a galeria de marketing também no estoque, logo abaixo da grade
       de fotos. Mesma função, mesma chave (a placa), mesma linha no banco. */
    try{
      if(typeof window.avmAoAbrirEstoque==='function'){
        var _vm=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
        window.avmAoAbrirEstoque((_vm&&_vm.placa)||'');
      }
    }catch(_){ }
    var dl=$('estFotosBaixar'); if(dl){ dl.style.display=_estFotos.length?'':'none'; dl.disabled=!_estFotos.length; dl.innerHTML=mkIco('download',17)+'Baixar '+(_estFotos.length||'')+' foto'+(_estFotos.length===1?'':'s'); }
    $('estAddFoto').onclick=function(){ $('estFotoInput').click(); };
    var bav=$('estAvFotosUsar'); if(bav) bav.onclick=estFotosAdotarAv;   /* v903 */
    $('estFotoInput').onchange=function(){ var fs=Array.prototype.slice.call(this.files); this.value=''; estAddFotos(fs); };
    Array.prototype.forEach.call(el.querySelectorAll('.est-thumb-del'),function(b){ b.onclick=function(){ _estFotos.splice(parseInt(b.getAttribute('data-i'),10)||0,1); estFotosPinta(); try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){} }; });
    Array.prototype.forEach.call(el.querySelectorAll('.est-thumb-ia'),function(b){ b.onclick=function(e){
      e.preventDefault(); e.stopPropagation();
      estFotoIaAbrir(parseInt(b.getAttribute('data-i'),10)||0,b);
    }; });
    Array.prototype.forEach.call(el.querySelectorAll('.est-thumb-enq'),function(b){ b.onclick=function(e){
      e.preventDefault(); e.stopPropagation();
      estFotoEnquadrar(parseInt(b.getAttribute('data-i'),10)||0,null,b);
    }; });
    /* A foto inteira é o alvo das ações. O botão azul da IA continua separado,
       porque tocar no carro deve abrir o menu curto e previsível da captura:
       visualizar, compartilhar ou enquadrar. Enter e Espaço repetem o toque. */
    Array.prototype.forEach.call(el.querySelectorAll('.est-thumb-e img.clic'),function(im){
      function abrir(){ estFotoAcoesAbrir(parseInt(im.getAttribute('data-i'),10)||0,im); }
      im.onclick=abrir;
      im.onkeydown=function(e){
        if(e.key!=='Enter'&&e.key!==' ') return;
        e.preventDefault(); abrir();
      };
    });
  }
  /* ---- v813: PROTEGER UMA FOTO QUE JA ESTA NO ESTOQUE -------------------
     A v808 fechou a porta do upload novo, mas uma foto antiga/importada ainda
     precisava sair do estoque, voltar pro aparelho e ser enviada outra vez.
     Esta acao reaproveita o MESMO editor e a MESMA porta de upload protegida.

     A URL anterior nao e sobrescrita: o Supabase recomenda um caminho novo
     para evitar cache antigo nos pontos de borda. A lista troca apenas a URL
     daquela posicao; por isso capa, ordem e quantidade ficam intactas. */
  var _estFotoProtecaoEmCurso=false;
  function estFotoIaAbrir(i,anchorEl,aoAtualizar){
    i=Math.max(0,Math.min(parseInt(i,10)||0,_estFotos.length-1));
    var origem=_estFotos[i]; if(!origem) return;
    var veicIa={}, veicSalvo={};
    try{
      veicSalvo=((_estoque||[]).filter(function(x){return String(x.id)===String(_estEditId);})[0])||{};
      veicIa=(typeof _estFichaVeic==='function'?_estFichaVeic():null)||veicSalvo||{};
    }catch(_){ veicIa={}; veicSalvo={}; }
    var exIa=veicIa.extras||{};
    /* v865 — a divulgação pública usa SÓ o preço de anúncio. O formulário
       aberto é a primeira fonte; o registro salvo é o fallback. Preço mínimo
       nunca entra como preço de venda. */
    var precoAnuncioIa=Number(veicIa.preco_anuncio)||Number(veicSalvo.preco_anuncio)||0;
    var dadosRepasse={
      placa:String(veicIa.placa||veicSalvo.placa||''),
      modelo:((veicIa.marca||'')+' '+(veicIa.modelo||'')).trim(),
      ano:(veicIa.ano&&veicIa.ano_modelo&&String(veicIa.ano)!==String(veicIa.ano_modelo))?(veicIa.ano+'/'+veicIa.ano_modelo):(veicIa.ano_modelo||veicIa.ano||''),
      precoDe:precoAnuncioIa, precoPor:Number(exIa.preco_repasse)||0,
      /* 🔴 v878 (pedido do Angelo: "o preço de vai ser sempre a fipe") — o
         valor da tabela viaja separado do preço de anúncio. São coisas
         diferentes: `precoDe` é o que a arte de repasse 9:16 (a que passa
         pela IA) usa; `fipe` é o riscado das artes clean. */
      fipe:Number(exIa.fipe&&exIa.fipe.valor)||0,
      precoAnuncio:precoAnuncioIa,
      km:Number(veicIa.km)||0, cambio:exIa.cambio||'', combustivel:exIa.combustivel||'',
      categoria:((exIa.fipe&&exIa.fipe.zero_km===true)||(veicIa.km!=null&&String(veicIa.km)!==''&&Number(veicIa.km)===0))?'0 KM':'SEMINOVO',
      /* 🔴 v876 (pedido do Angelo: "quando for repasse traga as observações do
         repasse pra IA considerar no post") — as observações do veículo entram
         como DESTAQUES da arte, depois dos selos de garantia.
         ⚠️ E PASSAM PELO `obsPublica()` (v265) ANTES, sem exceção: é a função
         que apaga valores em dinheiro de texto livre. "Troquei os pneus, gastei
         R$ 2.500" vira "Troquei os pneus" — porque custo de reparo numa arte
         pública é o piso da negociação entregue de graça no Instagram.
         ⚠️ Quem corta em três e encurta é a arte (`_fotoIaFatosTxt`), não aqui:
         o pacote leva tudo, e a tela de conferência deixa você escolher o que
         fica antes de gastar o token. */
      fatos:(function(){
        var f=[];
        if(exIa.garantia_fab)f.push('Garantia de fábrica');
        if(exIa.garantia_90_dias)f.push('Garantia de 90 dias');
        if(exIa.pronta_entrega)f.push('Pronta entrega');
        var _obs='';
        try{ _obs=obsPublica(String(veicIa.obs||veicSalvo.obs||'')); }catch(_){ _obs=''; }
        String(_obs||'').split(/[\n;·]+|,\s*/).forEach(function(t){
          t=String(t||'').replace(/\s+/g,' ').trim();
          if(t) f.push(t);
        });
        return f;
      })()
    };
    fotoIaEditarUrl(origem,'estoque',async function(blob,meta){
      var url=await avUpload(blob,{tipo:'veiculo',protegida:{
        protecao:'ia', acao:meta&&meta.acao||'', mascaras:[],
        semPlacaConfirmado:true, confirmadoPor:meuId||'',
        confirmadoEm:new Date().toISOString(), versaoProtecao:2
      }});
      if(!url) throw new Error('upload sem URL');
      var atual=(_estFotos[i]===origem)?i:_estFotos.indexOf(origem);
      if(atual<0) throw new Error('foto removida durante a edição');
      _estFotos[atual]=url; estFotosPinta();
      try{ if(typeof aoAtualizar==='function') aoAtualizar(url,atual); }catch(_){ }
      try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){ }
      return true;
    /* v877 — a galeria do estoque vai junto (as miniaturas da montagem) */
    },anchorEl,dadosRepasse,_estFotos);
  }
  function estFotoProtecaoMenu(i, anchorEl){
    i=Math.max(0,Math.min(parseInt(i,10)||0,_estFotos.length-1));
    if(!_estFotos[i]) return;
    var head='<div class="act-head"><div class="ah-nm">Proteger a placa</div><div class="ah-pl">Foto '+(i+1)+' de '+_estFotos.length+'</div></div>';
    /* 🔴 v834 (pedido do Angelo, 01/09): "remova o borrar placa do jeito que
       tá, tá horrível de fazer".
       Ele tem razão e o problema não é a ideia — é o TRABALHO. Borrar exige
       marcar a região certa, no tamanho certo, girada no ângulo certo (a v820
       ainda pôs rotação e oito alças pra isso); a placa preta MEV resolve com
       um toque e ainda sai com a marca dele na foto. Duas portas pro mesmo
       destino, uma delas cara, é escolha ruim disfarçada de opção.
       ⚠️ O DESENHO DO DESFOQUE NÃO FOI APAGADO — ele continua no
       13c-protecao-placa.js (`_ppAplicaMascara`, ramo 'desfoque'). Some a
       OFERTA, não a capacidade: se um dia voltar com um jeito melhor de
       marcar a região, o borrão já está pronto pra ser chamado. */
    /* ⛳ v845 — com a proteção desligada este menu não tem o que oferecer.
       Sair calado seria pior: a pessoa tocou em alguma coisa e nada aconteceu.
       Então ele avisa em uma linha e não abre. */
    if(typeof window.edProtegePlaca==='function' && !window.edProtegePlaca()){
      try{ toast('A proteção da placa está desligada nesta versão.'); }catch(_){}
      return;
    }
    _popAbrir(head,[
      ['mev',mkIco('placa',19),'Colocar placa preta MEV','']
    ],anchorEl,function(k){ actSheetFechar(); estFotoProtecaoAplicar(i,k); });
  }
  async function estFotoProtecaoAplicar(i, variante, aoAtualizar){
    if(_estFotoProtecaoEmCurso){ toast('Já estou protegendo uma foto.'); return false; }
    i=Math.max(0,Math.min(parseInt(i,10)||0,_estFotos.length-1));
    var origem=_estFotos[i]; if(!origem) return false;
    variante=variante==='desfoque'?'desfoque':'mev';
    _estFotoProtecaoEmCurso=true;
    try{
      toast('Abrindo a foto…');
      var r=await fetch(origem,{credentials:'omit'});
      if(!r.ok) throw new Error('foto indisponível');
      var bl=await r.blob();
      if(!bl || (bl.type && !/^image\//i.test(bl.type))) throw new Error('arquivo inválido');
      var prontas=await fotoPlacaAbrir([bl],{
        origem:'estoque-existente', variante:variante, adicionarMascara:true
      });
      if(!prontas.length) return false;                 /* fechou sem salvar */
      toast('Salvando a foto protegida…');
      var url=await avUpload(prontas[0].blob,{tipo:'veiculo',protegida:prontas[0]});
      if(!url) throw new Error('upload sem URL');
      /* A pessoa pode ter mudado a capa enquanto o editor estava aberto.
         Procurar pela URL original evita substituir outra foto por engano. */
      var atual=(_estFotos[i]===origem)?i:_estFotos.indexOf(origem);
      if(atual<0) throw new Error('foto removida durante a edição');
      _estFotos[atual]=url;
      estFotosPinta();
      try{ if(typeof aoAtualizar==='function') aoAtualizar(url,atual); }catch(_){}
      try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
      toast(variante==='desfoque'?'Placa borrada ✓':'Placa MEV aplicada ✓');
      return true;
    }catch(e){
      try{ window.mevErro&&mevErro(e,'estFotoProtecaoAplicar'); }catch(_){}
      toast('Não consegui proteger essa foto. Tente baixá-la e enviar novamente.');
      return false;
    }finally{ _estFotoProtecaoEmCurso=false; }
  }
  var _zipCrcTabela=null;
  function _zipCrc32(bytes){
    if(!_zipCrcTabela){ _zipCrcTabela=[]; for(var n=0;n<256;n++){ var c=n; for(var k=0;k<8;k++) c=(c&1)?(0xedb88320^(c>>>1)):(c>>>1); _zipCrcTabela[n]=c>>>0; } }
    var crc=0xffffffff; for(var i=0;i<bytes.length;i++) crc=_zipCrcTabela[(crc^bytes[i])&255]^(crc>>>8); return (crc^0xffffffff)>>>0;
  }
  function _zipCab(tam){
    var b=new Uint8Array(tam), v=new DataView(b.buffer);
    return {b:b,u16:function(p,n){v.setUint16(p,n,true);},u32:function(p,n){v.setUint32(p,n>>>0,true);}};
  }
  function _fotoExt(url,tipo){
    var m=String(url||'').split('?')[0].match(/\.([a-z0-9]{2,5})$/i), e=m?m[1].toLowerCase():'';
    if(/^(jpg|jpeg|png|webp|gif|avif)$/.test(e)) return e==='jpeg'?'jpg':e;
    var mp={'image/png':'png','image/webp':'webp','image/gif':'gif','image/avif':'avif'}; return mp[String(tipo||'').split(';')[0]]||'jpg';
  }
  function _estFotosNomeBase(){
    return limpa(String((($('efPlaca')||{}).value)||''))||_mkNorm(String((($('efModelo')||{}).value)||'veiculo')).replace(/\s+/g,'-')||'veiculo';
  }
  async function _estFotosArquivos(msg){
    var arquivos=[];
    for(var i=0;i<_estFotos.length;i++){
      if(msg) msg.textContent='Preparando foto '+(i+1)+' de '+_estFotos.length+'…';
      var r=await fetch(_estFotos[i]); if(!r.ok) throw new Error('Não consegui baixar a foto '+(i+1)+'.');
      var tipo=String(r.headers.get('content-type')||'').split(';')[0].toLowerCase();
      var ext=_fotoExt(_estFotos[i],tipo);
      if(!/^image\//.test(tipo)){
        tipo={jpg:'image/jpeg',png:'image/png',webp:'image/webp',gif:'image/gif',avif:'image/avif'}[ext]||'image/jpeg';
      }
      arquivos.push({nome:'foto-'+String(i+1).padStart(2,'0')+'.'+ext,tipo:tipo,data:new Uint8Array(await r.arrayBuffer())});
    }
    return arquivos;
  }
  /* v207 — o botão não decide mais sozinho o formato. Usa o mesmo menu de
     ações do restante do app para escolher entre a galeria do celular e ZIP. */
  function estFotosBaixar(){
    if(!_estFotos.length){ toast('Adicione fotos antes de baixar.'); return; }
    var n=_estFotos.length, ancora=$('estFotosBaixar');
    _popAbrir(
      '<div class="act-head"><div class="ah-nm">Como deseja baixar?</div><div class="ah-pl">'+n+' foto'+(n===1?'':'s')+'</div></div>',
      [
        ['galeria',mkIco('card',19),'Salvar na galeria',''],
        ['zip',mkIco('download',19),'Baixar em ZIP','']
      ],
      ancora,
      function(escolha){
        actSheetFechar();
        if(escolha==='galeria') estFotosSalvarGaleria();
        if(escolha==='zip') estFotosBaixarZip();
      }
    );
  }
  function _estFotosBaixarSeparado(arquivos){
    var base=_estFotosNomeBase();
    arquivos.forEach(function(arq,i){
      var blob=new Blob([arq.data],{type:arq.tipo}), u=URL.createObjectURL(blob), a=document.createElement('a');
      a.href=u; a.download='fotos-'+base+'-'+String(i+1).padStart(2,'0')+'.'+_fotoExt(arq.nome,arq.tipo);
      document.body.appendChild(a); a.click();
      setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },2500);
    });
  }
  async function _estFotosSalvarNaPasta(pasta,arquivos,msg){
    for(var i=0;i<arquivos.length;i++){
      if(msg) msg.textContent='Salvando foto '+(i+1)+' de '+arquivos.length+'…';
      var arq=arquivos[i], h=await pasta.getFileHandle(arq.nome,{create:true}), w=await h.createWritable();
      try{ await w.write(new Blob([arq.data],{type:arq.tipo})); }
      finally{ await w.close(); }
    }
  }
  function _estFotosZipBlob(arquivos){
    var enc=new TextEncoder(), partes=[], centrais=[], offset=0, centralTam=0;
    arquivos.forEach(function(a){
      var nome=enc.encode(a.nome), crc=_zipCrc32(a.data);
      var lh=_zipCab(30+nome.length); lh.u32(0,0x04034b50); lh.u16(4,20); lh.u16(6,0x0800); lh.u16(8,0); lh.u16(10,0); lh.u16(12,33); lh.u32(14,crc); lh.u32(18,a.data.length); lh.u32(22,a.data.length); lh.u16(26,nome.length); lh.u16(28,0); lh.b.set(nome,30);
      partes.push(lh.b,a.data);
      var ch=_zipCab(46+nome.length); ch.u32(0,0x02014b50); ch.u16(4,20); ch.u16(6,20); ch.u16(8,0x0800); ch.u16(10,0); ch.u16(12,0); ch.u16(14,33); ch.u32(16,crc); ch.u32(20,a.data.length); ch.u32(24,a.data.length); ch.u16(28,nome.length); ch.u16(30,0); ch.u16(32,0); ch.u16(34,0); ch.u16(36,0); ch.u32(38,0); ch.u32(42,offset); ch.b.set(nome,46);
      centrais.push(ch.b); centralTam+=ch.b.length; offset+=lh.b.length+a.data.length;
    });
    var fim=_zipCab(22); fim.u32(0,0x06054b50); fim.u16(4,0); fim.u16(6,0); fim.u16(8,arquivos.length); fim.u16(10,arquivos.length); fim.u32(12,centralTam); fim.u32(16,offset); fim.u16(20,0);
    return new Blob(partes.concat(centrais).concat([fim.b]),{type:'application/zip'});
  }
  function _estFotosBaixarZipPronto(arquivos){
    var blob=_estFotosZipBlob(arquivos), nomeBase=_estFotosNomeBase();
    var u=URL.createObjectURL(blob), a=document.createElement('a'); a.href=u; a.download='fotos-'+nomeBase+'.zip'; document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(u); a.remove(); },1000);
  }
  async function estFotosSalvarGaleria(){
    var btn=$('estFotosBaixar'), msg=$('estFotosBaixarMsg'), antigo=btn?btn.innerHTML:'';
    if(btn){ btn.disabled=true; btn.innerHTML='<span class="spin"></span>Preparando…'; }
    try{
      /* v986 — no computador, cinco <a download> seguidos são tratados como
         downloads automáticos e o navegador costuma liberar só o primeiro.
         A escolha de pasta acontece ainda dentro do gesto do clique e depois
         cada arquivo é gravado explicitamente nessa pasta. */
      var mobile=/Android|iPhone|iPad|iPod/i.test(navigator.userAgent||''), pasta=null;
      if(!mobile && typeof window.showDirectoryPicker==='function'){
        if(msg) msg.textContent='Escolha a pasta onde deseja salvar as fotos.';
        try{ pasta=await window.showDirectoryPicker({mode:'readwrite'}); }
        catch(pastaErro){
          if(pastaErro&&pastaErro.name==='AbortError'){ if(msg) msg.textContent='Salvamento cancelado.'; return; }
        }
      }
      var arquivos=await _estFotosArquivos(msg), files=[];
      if(pasta){
        await _estFotosSalvarNaPasta(pasta,arquivos,msg);
        if(msg) msg.textContent=arquivos.length+' fotos salvas na pasta escolhida.';
        toast(arquivos.length+' fotos salvas ✓');
        return;
      }
      if(typeof File==='function'){
        files=arquivos.map(function(arq){ return new File([arq.data],arq.nome,{type:arq.tipo,lastModified:Date.now()}); });
      }
      var dados={files:files,title:'Fotos do veículo'}, podeCompartilhar=false;
      try{ podeCompartilhar=!!(files.length&&navigator.share&&navigator.canShare&&navigator.canShare(dados)); }catch(_){}
      if(podeCompartilhar){
        try{
          if(btn) btn.innerHTML=mkIco('share',17)+'Escolha onde salvar';
          if(msg) msg.textContent='No menu do celular, escolha “Salvar imagens”.';
          await navigator.share(dados);
          if(msg) msg.textContent='Fotos enviadas para o menu do celular.';
          toast('Escolha “Salvar imagens” para colocar na galeria.');
          return;
        }catch(compartilharErro){
          if(compartilharErro&&compartilharErro.name==='AbortError'){
            if(msg) msg.textContent='Salvamento cancelado.';
            return;
          }
        }
      }
      /* Sem folha nativa nem escolha de pasta, um download por foto perde as
         demais no bloqueio do navegador. Um ZIP único preserva todas. */
      _estFotosBaixarZipPronto(arquivos);
      if(msg) msg.textContent='Seu navegador não permite salvar várias imagens direto. Baixei as '+arquivos.length+' fotos em um ZIP.';
      toast(arquivos.length+' fotos baixadas em ZIP.');
    }catch(e){
      if(msg) msg.textContent=(e&&e.message)||'Não consegui preparar as fotos.';
      toast('Não consegui baixar todas as fotos.');
    }finally{
      if(btn){ btn.disabled=false; btn.innerHTML=antigo||mkIco('download',17)+'Baixar fotos'; }
    }
  }
  /* ZIP sem compressão: mantém a qualidade original e gera um único download,
     evitando o bloqueio de vários arquivos automáticos no celular. */
  async function estFotosBaixarZip(){
    var btn=$('estFotosBaixar'), msg=$('estFotosBaixarMsg'), antigo=btn?btn.innerHTML:'';
    if(btn){ btn.disabled=true; btn.innerHTML='<span class="spin"></span>Preparando…'; }
    try{
      var arquivos=await _estFotosArquivos(msg);
      _estFotosBaixarZipPronto(arquivos);
      if(msg) msg.textContent='Arquivo com '+arquivos.length+' foto(s) pronto.';
      toast('Fotos baixadas em um arquivo ZIP.');
    }catch(e){
      if(msg) msg.textContent=(e&&e.message)||'Não consegui preparar as fotos.';
      toast('Não consegui baixar todas as fotos.');
    }finally{
      if(btn){ btn.disabled=false; btn.innerHTML=antigo||mkIco('download',17)+'Baixar fotos'; }
    }
  }
  /* Ações gratuitas da própria foto no MEV Estoque. A edição por IA conserva
     o botão independente na miniatura; assim o toque na foto não mistura uma
     operação paga com visualizar, compartilhar e enquadrar. */
  function estFotoAcoesAbrir(i,anchorEl){
    i=Math.max(0,Math.min(parseInt(i,10)||0,_estFotos.length-1));
    var url=_estFotos[i]; if(!url) return;
    var head='<div class="act-head"><div class="ah-nm">Ações da foto</div><div class="ah-pl">Foto '+(i+1)+' de '+_estFotos.length+'</div></div>';
    _popAbrir(head,[
      ['visualizar',_fotoIaIco('visualizar_foto'),'Visualizar',''],
      ['compartilhar',_fotoIaIco('compartilhar_foto'),'Compartilhar',''],
      ['enquadrar',mkIco('recorte',19),'Enquadrar foto','']
    ],anchorEl,function(acao){
      actSheetFechar();
      if(acao==='visualizar'){ estFotoAbrir(i,anchorEl); return; }
      if(acao==='compartilhar'){ _fotoIaCompartilharAtual(url); return; }
      if(acao==='enquadrar') estFotoEnquadrar(i,null,anchorEl);
    });
  }

  async function estFotoEnquadrar(i,aoAtualizar,anchorEl){
    i=Math.max(0,Math.min(parseInt(i,10)||0,_estFotos.length-1));
    var origem=_estFotos[i]; if(!origem) return false;
    if(anchorEl){ anchorEl.setAttribute('aria-busy','true'); }
    var bl=null;
    try{
      var r=await fetch(origem,{credentials:'omit'});
      if(!r.ok) throw new Error('foto_indisponivel');
      bl=await r.blob();
      if(!bl||!bl.size||!/^image\//i.test(bl.type||'')) throw new Error('arquivo_invalido');
    }catch(e){ bl=null; }
    if(anchorEl){ anchorEl.removeAttribute('aria-busy'); }
    if(!bl){ toast('Não consegui abrir essa foto pra enquadrar.'); return false; }
    fotoCropAbrir(bl,async function(nb){
      if(!nb) return;
      /* O corte gera um arquivo novo. Ele volta pelo mesmo preparo protegido
         do upload comum antes de substituir a URL que estava nesta posição. */
      var pr=[];
      try{ pr=await fotoVeiculoPreparar([nb],{origem:'estoque'}); }catch(_){ pr=[]; }
      if(!pr.length){ toast('O enquadramento não foi salvo.'); return; }
      toast('Salvando o enquadramento...');
      try{
        var u=await avUpload(pr[0].blob,{tipo:'veiculo',protegida:pr[0]});
        var atual=(_estFotos[i]===origem)?i:_estFotos.indexOf(origem);
        if(!u||atual<0) throw new Error('foto_nao_encontrada');
        _estFotos[atual]=u;
        estFotosPinta();
        try{ if(typeof aoAtualizar==='function') aoAtualizar(u,atual); }catch(_){ }
        try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){ }
        toast('Foto enquadrada ✓');
      }catch(e){ toast('Não consegui salvar o enquadramento.'); }
    },{ar:FOTO_W/FOTO_H,out:FOTO_W,redondo:false,blob:true,titulo:'Enquadrar a foto',
       sub:'Arraste pra posicionar · pinça (2 dedos), rodinha do mouse ou a barra pra dar zoom'});
    return true;
  }

  /* ---- v170: VISOR DE FOTOS -------------------------------------------------
     Abre a foto em tela cheia. Da' pra passar de uma pra outra (setas ou
     arrastando o dedo), recortar/enquadrar de novo e escolher qual e' a CAPA
     (a primeira foto, a que aparece no anuncio e no catalogo). ---- */
  /* v171 — a MESMA tela cheia de foto serve pra dois lugares:
       FICHA do veiculo .. com "Recortar" e "Definir como capa"
       tela de VENDA ..... so' olhar, passar pro lado e fechar (pro cliente)
     Por isso a funcao virou generica: recebe a LISTA de fotos e diz se pode
     editar. estFotoAbrir(i) continua existindo e so' chama esta aqui. */
  function estFotoAbrir(i,devolverFoco){ fotosVerAbrir(_estFotos, i, {editar:true,devolverFoco:devolverFoco}); }
  function fotosVerAbrir(_estFotos, i, opts){
    opts=opts||{}; var _editar=(opts.editar!==false);
    if(!_estFotos||!_estFotos.length) return;
    var idx=Math.max(0, Math.min(parseInt(i,10)||0, _estFotos.length-1));
    var ov=document.createElement('div'); ov.className='fotov';
    ov.innerHTML='<button type="button" class="fotov-x" id="fvX">&times;</button>'+
      '<div class="fotov-mid" id="fvMid">'+
        '<button type="button" class="fotov-nav pv" id="fvPrev">‹</button>'+
        '<img id="fvImg" alt="">'+
        '<button type="button" class="fotov-nav nx" id="fvProx">›</button>'+
      '</div>'+
      '<div class="fotov-bar"><span class="fotov-n" id="fvN"></span>'+
        (_editar?('<div class="fotov-acts">'+
          '<button type="button" class="fv-b protege" id="fvIa">'+_fotoIaIco('completa')+'Editar com IA</button>'+
          /* v834: o "Borrar placa" saiu daqui — ver o motivo no
             estFotoProtecaoMenu, logo acima. Ficou só a placa MEV. */
          /* v306 (pedido): "ao inves de recortar ... so enquadrar novamente".
             O botao faz o mesmo de sempre, mas RECORTAR soa em cortar fora
             pedaco da foto. O que ele faz e reposicionar dentro do quadro. */
          '<button type="button" class="fv-b" id="fvCrop">Enquadrar</button>'+
          '<button type="button" class="fv-b cap" id="fvCapa">Definir como capa</button>'+
        '</div>'):'')+
      '</div>';
    document.body.appendChild(ov);
    function pinta(){
      if(!_estFotos.length){ fechar(); return; }
      if(idx>=_estFotos.length) idx=_estFotos.length-1;
      var img=ov.querySelector('#fvImg'); if(img) img.src=_estFotos[idx]||'';
      var n=ov.querySelector('#fvN'); if(n) n.textContent=(idx+1)+' de '+_estFotos.length+((_editar&&idx===0)?' · capa':'');
      var cp=ov.querySelector('#fvCapa'); if(cp) cp.style.display=(idx===0)?'none':'';
      var mais=_estFotos.length>1;
      ov.querySelector('#fvPrev').style.visibility=mais?'visible':'hidden';
      ov.querySelector('#fvProx').style.visibility=mais?'visible':'hidden';
    }
    function vai(d){ if(!_estFotos.length) return; idx=(idx+d+_estFotos.length)%_estFotos.length; pinta(); }
    function fechar(){
      try{ document.removeEventListener('keydown',tecla); }catch(_){}
      try{ ov.remove(); }catch(_){}
      try{ var f=opts.devolverFoco; if(f&&f.focus) f.focus(); }catch(_){}
    }
    function tecla(e){ if(e.key==='Escape') fechar(); else if(e.key==='ArrowLeft') vai(-1); else if(e.key==='ArrowRight') vai(1); }
    document.addEventListener('keydown',tecla);
    ov.querySelector('#fvX').onclick=fechar;
    ov.onclick=function(e){ if(e.target===ov) fechar(); };
    ov.querySelector('#fvPrev').onclick=function(){ vai(-1); };
    ov.querySelector('#fvProx').onclick=function(){ vai(1); };
    /* arrastar o dedo pro lado passa a foto */
    var tx=0, ty=0;
    var mid=ov.querySelector('#fvMid');
    mid.addEventListener('touchstart',function(e){ var t=e.touches&&e.touches[0]; if(t){ tx=t.clientX; ty=t.clientY; } },{passive:true});
    mid.addEventListener('touchend',function(e){ var t=e.changedTouches&&e.changedTouches[0]; if(!t) return;
      var dx=t.clientX-tx, dy=t.clientY-ty;
      if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) vai(dx<0?1:-1);
    },{passive:true});
    if(_editar) ov.querySelector('#fvCapa').onclick=function(){
      if(idx===0) return;
      var antes=_estFotos.slice(), idCapa=String(_estEditId||'');
      var f=_estFotos.splice(idx,1)[0]; _estFotos.unshift(f); idx=0;
      var ordemCapa=_estFotos.slice(), seqCapa=++_estCapaSeq;
      /* v1202/v1209 — o card vivo obedece imediatamente, mas o sucesso só é
         anunciado depois que o banco devolver a MESMA ordem de fotos. */
      try{
        var _vc=(_estoque||[]).filter(function(x){ return String(x.id)===String(_estEditId); })[0];
        if(_vc) _vc.fotos=_estFotos.slice();
      }catch(_){}
      estFotosPinta(); pinta();
      var ind=$('efAutosave');
      if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando a capa…'; }
      toast('Salvando a nova capa…');
      estCapaSalvar(idCapa,ordemCapa).then(function(){
        if(seqCapa!==_estCapaSeq) return;
        var i2=$('efAutosave'); if(i2){ i2.className='cad-autosave ok'; i2.textContent='✓ Capa salva'; }
        toast('Capa salva no estoque ✓');
      }).catch(function(e){
        if(seqCapa!==_estCapaSeq) return;
        _estFotos=antes.slice();
        try{
          var vAnt=(_estoque||[]).filter(function(x){ return String(x.id)===String(idCapa); })[0];
          if(vAnt) vAnt.fotos=antes.slice();
        }catch(_){}
        idx=0; estFotosPinta(); pinta();
        var i3=$('efAutosave'); if(i3){ i3.className='cad-autosave err'; i3.textContent='Não foi possível salvar a capa.'; }
        try{ window.mevErro&&window.mevErro(e,'estCapaSalvar'); }catch(_){}
        toast('Não consegui salvar a capa. Tente novamente.');
      });
    };
    var _btIa=ov.querySelector('#fvIa');
    if(_editar&&_btIa) _btIa.onclick=function(){ estFotoIaAbrir(idx,this,function(){ pinta(); }); };
    if(_editar) ov.querySelector('#fvCrop').onclick=function(){
      var bt=this; bt.disabled=true; var tx=bt.textContent; bt.textContent='Abrindo...';
      estFotoEnquadrar(idx,function(_u,atual){ idx=atual; pinta(); },bt).finally(function(){
        if(bt&&bt.isConnected){ bt.disabled=false; bt.textContent=tx; }
      });
    };
    pinta();
  }
  async function estAddFotos(files){
    if(!files||!files.length) return;
    /* ===== v808 (§6.1 do PROJETO-placa-mev-veiculos-nas-fotos) ============
       🔴 A ORDEM IMPORTA, e o §3.1 diz por quê: reenquadrar PRIMEIRO,
       proteger DEPOIS. Se a máscara fosse aplicada antes do corte, o corte
       mudaria as coordenadas dela — e a placa reapareceria pela borda.
       ⚠️ Só o `blob` mascarado é enviado. A original fica no aparelho e
       morre quando a aba fecha. */
    var enq=_fotoEnqLigado();
    var cortadas=[];
    for(var i=0;i<files.length;i++){
      var f=files[i];
      if(enq){ try{ var nb=await reenquadrarFoto(f); if(nb) f=nb; }catch(_){} }
      cortadas.push(f);
    }
    var prontas=[];
    try{ prontas=await fotoVeiculoPreparar(cortadas, { origem:'estoque' }); }
    catch(_){ prontas=[]; }
    if(!prontas.length){ toast('Nenhuma foto foi enviada.'); return; }
    toast('Enviando foto(s)...');
    /* ======================================================================
       🔴🔴🔴 v1081 — O AVISO DO FIM TEM QUE SABER O QUE ACONTECEU
       ----------------------------------------------------------------------
       Angelo: "anexei fotos mas nao apareceram". Este laço dizia
       "Foto(s) prontas." SEMPRE — mesmo com zero fotos na lista. A frase não
       olhava pra nada: ela vinha depois do laço, sem contar ninguém.

       Agora o laço CONTA quantas entraram de verdade e o aviso do fim diz
       isso, com o motivo da primeira falha quando houve alguma. Três casos,
       três frases diferentes:
         · entraram todas          → "N foto(s) prontas."
         · entraram algumas        → "N de M — <motivo>"
         · não entrou nenhuma      → "Nenhuma foto entrou: <motivo>"
       ⚠️ E o motivo vai pro console também. Quando o Angelo disser de novo
          "não apareceram", a próxima pergunta tem resposta na tela dele.
       ====================================================================== */
    var _entraram=0, _falhas=[];
    for(var k=0;k<prontas.length;k++){
      try{
        var url=await avUpload(prontas[k].blob, { tipo:'veiculo', protegida:prontas[k] });
        if(url){ _estFotos.push(url); _entraram++; estFotosPinta(); }
        else _falhas.push('o envio terminou sem endereço');
      }catch(e){ _falhas.push((e&&e.message)||'erro desconhecido no envio'); }
    }
    try{ if(_falhas.length) console.error('[MEV] fotos do estoque — falhas:', _falhas); }catch(_){}
    if(!_entraram){
      toast('Nenhuma foto entrou: '+(_falhas[0]||'motivo não informado'));
      return;
    }
    if(_entraram<prontas.length) toast(_entraram+' de '+prontas.length+' foto(s) entraram — '+(_falhas[0]||''));
    else toast(_entraram+' foto(s) prontas.');
    try{ if(typeof estAgendaSalvar==='function') estAgendaSalvar(); }catch(_){}
  }
  async function estSalvar(id){
    var m=$('efMsg'); if(m) m.className='cad-msg';
    var placa=String(($('efPlaca').value||'')).trim();
    var modelo=String(($('efModelo').value||'')).trim();
    if(!placa && !modelo){ if(m){ m.className='cad-msg err'; m.textContent='Informe ao menos a placa ou o modelo.'; } return; }
    var reg={ placa:placa, marca:String(($('efMarca').value||'')).trim(), modelo:modelo, ano:String(($('efAno').value||'')).trim(), ano_modelo:String(((($('efAnoMod')||{}).value)||'')).trim(), cor:String(($('efCor').value||'')).trim(),
      km:estNum('efKm')||null, preco_minimo:estRS('efMin')||null, preco_anuncio:estRS('efAnuncio')||null, preco_compra:estRS('efCompra')||null, data_entrada:((($('efEntrada')||{}).value)||estHoje()),
      origem:(($('efOrigem')||{}).value||'proprio'), consig_nome:String((($('efConsigNome')||{}).value||'')).trim()||null, consig_fone:String((($('efConsigFone')||{}).value||'')).trim()||null, consig_pct:(parseFloat(String((($('efConsigPct')||{}).value)||'').replace(',','.'))||null),
      custos:{ com_pct:parseFloat(String((($('ecComPct')||{}).value)||'').replace(',','.'))||0, nf_pct:parseFloat(String((($('ecNfPct')||{}).value)||'').replace(',','.'))||0, nf_base:String((($('ecNfBase')||{}).value)||'margem'), hig:estRS('ecHig')||0, pol:estRS('ecPol')||0, fun:estRS('ecFun')||0, pneus:estRS('ecPneus')||0, mec:estRS('ecMec')||0, doc:estRS('ecDoc')||0, outros:_ecOutrosLer(), outro_nome:((_ecOutrosLer()[0]||{}).nome||''), outro_val:((_ecOutrosLer()[0]||{}).val||0) },
      status:($('efStatus').value||'disponivel'), obs:String(($('efObs').value||'')).trim(), fotos:_estFotos };
    var btn=$('efSalvar'); if(btn){ btn.disabled=true; btn.classList.add('loading'); }
    try{
      if(id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('estoque').update(reg).eq('id',id); if(r&&r.error) throw r.error; }
      else { reg.user_id=meuId; var r2=await supa.from('estoque').insert(reg); if(r2&&r2.error) throw r2.error; }
      cliModalFechar(); await estCarregar(); estPinta((($('estBusca')||{}).value)||''); toast('Veículo salvo no estoque.');
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } if(btn){ btn.disabled=false; btn.classList.remove('loading'); } }
  }
  async function estApagar(id){
    if(!id) return; if(!confirm('Apagar este veículo do estoque?')) return;
    try{
      /* v976 — DELETE pode voltar sem erro e sem apagar linha quando a RLS
         recusa o registro. Confirma a linha removida antes de anunciar sucesso,
         e prende a operação à conta autenticada como os demais atalhos. */
      var r=await supa.from('estoque').delete().eq('id',id).eq('user_id',meuId).select('id');
      estConfereGravou(r,'estApagar',1);
      estFecharFicha(); await estCarregar(); estPinta((($('estBusca')||{}).value)||''); toast('Veículo apagado.');
    }
    catch(e){ toast('Não consegui apagar.'); }
  }
  async function estFromConsulta(){
    var v=veiculoAtual; if(!v){ toast('Faça uma consulta primeiro.'); return; }
    if(!_estoque.length){ await estCarregar(); }
    var ja=_estoque.filter(function(x){ return v.placa && String(x.placa||'').toUpperCase()===String(v.placa||'').toUpperCase(); })[0];
    await telaEstoque();
    if(ja){ estAbrirFicha(ja.id); toast('Este veículo já está no estoque.'); return; }
    estAbrirFicha(null, {placa:v.placa,marca:v.marca,modelo:v.modelo,ano:v.ano,cor:_dadoUtil(v.cor),preco_minimo:v.fipe});
  }

/* ╔═══ src/app/15b-post-estudio.js ═══════════════════════════════════════ */
  /* ============ O ESTÚDIO DO POST (v353) ====================================
     Três pedidos do mesmo dia, que são a mesma jornada — escrever o anúncio:

     1) ANIMAÇÃO. O "Gerar post (IA)" mostrava uma bolinha girando de 22px,
        igual à de qualquer botão. A consulta de placa tem o anel do MEV Tools
        e frases que vão trocando — e a espera parece menor porque você lê
        alguma coisa. Agora o post tem o MESMO anel, com um megafone no lugar
        do carrinho: aqui não se está consultando veículo, se está anunciando.

     2) EMOJIS ESCOLHIDOS ANTES DE GERAR. O post sempre saía com ✅ e ➡️.
        Serve pra maioria, mas não pra todo mundo: concessionária de marca
        premium não quer 🔥 na frente do preço, e quem vende popular vende
        mais com ele. Agora são 5 estilos, escolhidos antes de gerar.

     3) EDITAR NO APP. O texto vinha pronto e só dava pra copiar. Trocar uma
        palavra exigia copiar, colar no bloco de notas, editar, copiar de
        novo. Agora tem lápis: edita ali, salva, e o texto salvo é o que sai
        no Copiar, no card do estoque e no anúncio.

     Nada disso gasta token: os emojis são trocados no texto já gerado, aqui
     no aparelho, e a edição é sua.
     ========================================================================= */

  /* ---- 1) A ANIMAÇÃO -----------------------------------------------------
     Usa a mesma barra horizontal das consultas. A mensagem descreve a etapa
     atual e a barra avança até a zona de espera sem prometer conclusão. */
  var _MK_SVG_MEGAFONE='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3.2 10.2v3.6c0 .8.6 1.4 1.4 1.4h1.1l1 4.1c.1.5.6.9 1.1.9h1.1c.7 0 1.2-.7 1-1.4l-.9-3.6h1.3l7.5 3.4c.7.3 1.5-.2 1.5-1V6.4c0-.8-.8-1.3-1.5-1L11.2 8.8H4.6c-.8 0-1.4.6-1.4 1.4zm17.1.2c.6.3 1 .9 1 1.6s-.4 1.3-1 1.6v-3.2z"/></svg>';
  var _MK_FRASES=[
    '✍️ Escrevendo a chamada do anúncio…',
    '🏷️ Encaixando preço e condições…',
    '⭐ Destacando o que este carro tem de melhor…',
    '🔎 Escolhendo as hashtags que buscam esse modelo…',
    '💡 Post pronto é post publicado — e carro parado não vende…',
    '✅ Quase lá — dando o acabamento…'
  ];
  function mkLoaderHtml(titulo, frases){
    frases=frases||_MK_FRASES;
    titulo=titulo||'Gerando o post…';
    return '<div class="cc-load mev-process-page" role="status" aria-live="polite">'+
      mevProcessoMarcaHtml()+
      '<div class="cc-load-head"><div class="cc-load-t">'+titulo+'</div><span class="cc-load-pct" id="mkLoadPct">6% estimado</span></div>'+
      '<div class="cc-load-track" id="mkLoadTrack" role="progressbar" aria-label="'+titulo+'" aria-valuemin="0" aria-valuemax="100" aria-valuenow="6"><i id="mkLoadFill" style="width:6%"></i></div>'+
      '<div class="cc-load-s" id="mkLoadS">'+frases[0]+'</div></div>';
  }
  function mkLoaderStart(frases){
    frases=frases||_MK_FRASES; var i=0, t0=Date.now(), total=45000, tick=0;
    /* se auto-encerra quando o texto sai da tela: quem chama não precisa
       lembrar de parar o relógio em cada saída da função. */
    var t=setInterval(function(){
      var e=document.getElementById('mkLoadS');
      if(!e){ clearInterval(t); return; }
      var pg=Math.max(6,Math.min(92,(Date.now()-t0)/total*100));
      var fill=document.getElementById('mkLoadFill'), pct=document.getElementById('mkLoadPct'), track=document.getElementById('mkLoadTrack');
      if(fill) fill.style.width=pg.toFixed(1)+'%';
      if(pct) pct.textContent=Math.round(pg)+'% estimado';
      if(track) track.setAttribute('aria-valuenow',Math.round(pg));
      tick++; if(tick%13) return;
      i=(i+1)%frases.length;
      e.style.opacity='0';
      setTimeout(function(){ var e2=document.getElementById('mkLoadS'); if(e2){ e2.textContent=frases[i]; e2.style.opacity='1'; } },200);
    },200);
    return t;
  }

  /* ---- 2) OS ESTILOS DE EMOJI -------------------------------------------
     'item'  = o marcador das linhas de lista (o ✅ e o ➡️ de hoje)
     'preco' = a linha do valor
     'zerar' = tira QUALQUER emoji do começo das linhas (estilo limpo/sóbrio)
     A escolha fica no aparelho (localStorage), então vale pra todos os carros
     e você escolhe uma vez só. */
  var MK_EMOJI_ESTILOS=[
    { id:'classico', nome:'Clássico',  item:'',     preco:'',    zerar:false, amostra:'✅ ➡️ 💰' },
    { id:'vendedor', nome:'Vendedor',  item:'🔥',   preco:'💵',  zerar:false, amostra:'🔥 ⭐ 💵' },
    { id:'estrela',  nome:'Estrela',   item:'⭐',   preco:'💰',  zerar:false, amostra:'⭐ ⭐ 💰' },
    { id:'sobrio',   nome:'Sóbrio',    item:'•',    preco:'',    zerar:true,  amostra:'•  •  R$' },
    { id:'limpo',    nome:'Sem emoji', item:'',     preco:'',    zerar:true,  amostra:'sem emoji' }
  ];
  var _MK_EMOJI_KEY='mev_post_emoji_estilo';
  function mkEmojiEstiloLer(){
    try{ var v=localStorage.getItem(_MK_EMOJI_KEY)||'classico';
      return MK_EMOJI_ESTILOS.filter(function(e){ return e.id===v; })[0]||MK_EMOJI_ESTILOS[0];
    }catch(_){ return MK_EMOJI_ESTILOS[0]; }
  }
  function mkEmojiEstiloGravar(id){ try{ localStorage.setItem(_MK_EMOJI_KEY, String(id||'classico')); }catch(_){} }

  /* os emojis que o post usa hoje no começo das linhas de lista */
  /* ALTERNANCIA, nao classe de caracteres: o fogo e um par substituto e,
     dentro de [ ], os dois pedacos valeriam separados — o primeiro casaria
     TODO emoji daquele bloco, e a linha da quilometragem viraria item. */
  var _MK_ITEM_RE=/^((?:\u2705|\u27A1|\u2B50|\uD83D\uDD25|\u25AA|\u25CF|\u2022|\u25C6|\u2726)\uFE0F?\s*)/;
  /* qualquer emoji/símbolo no início da linha (pro estilo limpo e sóbrio).
     Cobre setas, dingbats, os dois blocos altos de emoji (pares substitutos)
     e o seletor de variação. Letra e número NUNCA entram aqui — senão o
     "VW Virtus" viraria "W Virtus". */
  var _MK_QUALQUER_RE=/^((?:[\u2190-\u2BFF\u00A9\u00AE\u2122]|[\uD83C-\uD83E][\uDC00-\uDFFF])\uFE0F?\s*)+/;

  function mkEmojiAplicar(texto, estilo){
    texto=String(texto||''); if(!texto) return texto;
    var e=estilo||mkEmojiEstiloLer();
    if(e.id==='classico') return texto;              /* nada a fazer */
    return texto.split('\n').map(function(l){
      var t=l;
      var ehItem=_MK_ITEM_RE.test(t);
      if(e.zerar){
        /* tira o emoji da frente e, se o estilo pede marcador, põe o dele */
        t=t.replace(_MK_QUALQUER_RE,'');
        if(e.item && ehItem) t=e.item+' '+t;
        return t;
      }
      if(ehItem && e.item) return t.replace(_MK_ITEM_RE, e.item+' ');
      /* a linha do preço tem cara própria */
      if(e.preco && /R\$\s*[\d.]/.test(t)) return t.replace(_MK_QUALQUER_RE, e.preco+' ');
      return t;
    }).join('\n');
  }

  /* o seletor que aparece antes do botão "Gerar post (IA)" */
  function mkEmojiSeletorHtml(){
    var atual=mkEmojiEstiloLer().id;
    return '<div class="mk-emo"><div class="mk-emo-t">Estilo dos emojis do post</div>'+
      '<div class="mk-emo-row">'+
      MK_EMOJI_ESTILOS.map(function(e){
        return '<button type="button" class="mk-emo-b'+(e.id===atual?' on':'')+'" data-emo="'+e.id+'">'+
          '<span class="mk-emo-a">'+e.amostra+'</span><span class="mk-emo-n">'+esc(e.nome)+'</span></button>';
      }).join('')+
      '</div><div class="mk-emo-h">Escolha antes de gerar. Dá pra trocar depois e gerar de novo.</div></div>';
  }
  /* clique nos estilos — por delegação, então vale em qualquer tela que use
     o seletor, sem religar nada. */
  try{
    if(typeof document!=='undefined' && !window.__mkEmoWired){
      window.__mkEmoWired=true;
      document.addEventListener('click',function(ev){
        var b=(ev.target&&ev.target.closest)?ev.target.closest('.mk-emo-b'):null;
        if(!b) return;
        ev.preventDefault();
        mkEmojiEstiloGravar(b.getAttribute('data-emo'));
        var box=b.closest('.mk-emo');
        if(box) Array.prototype.forEach.call(box.querySelectorAll('.mk-emo-b'),function(x){ x.classList.toggle('on', x===b); });
      });
    }
  }catch(_){}

  /* ---- 3) EDITAR O POST NA TELA -----------------------------------------
     O lápis troca o texto por uma caixa de edição. Salvar grava no mesmo
     lugar de sempre (mktPostSalvar → extras.post_ia), então o texto editado é
     o que sai no Copiar, no "Copiar post" do card e no anúncio. */
  function _mkEditAbrir(box){
    if(!box || box.querySelector('.mk-edit-ta')) return;
    var txt=box.querySelector('.post-txt'); if(!txt) return;
    var atual=txt.textContent||'';
    var ta=document.createElement('textarea');
    ta.className='mk-edit-ta'; ta.value=atual; ta.rows=14;
    ta.style.cssText='width:100%;box-sizing:border-box;border:1.5px solid #93b4e6;border-radius:12px;padding:11px 12px;font-size:13.5px;line-height:1.55;font-family:inherit;color:#0f172a;background:#fff;resize:vertical;min-height:220px';
    var acts=document.createElement('div');
    acts.className='mk-edit-acts';
    acts.style.cssText='display:flex;gap:8px;margin-top:9px';
    acts.innerHTML='<button type="button" class="mk-edit-ok" style="flex:1;border:0;border-radius:11px;padding:11px;font-weight:800;font-size:14px;background:#16a34a;color:#fff;cursor:pointer">Salvar texto</button>'+
      '<button type="button" class="mk-edit-x" style="flex:0 0 auto;border:0;border-radius:11px;padding:11px 16px;font-weight:700;font-size:14px;background:#f1f5f9;color:#334155;cursor:pointer">Cancelar</button>';
    txt.style.display='none';
    txt.parentNode.insertBefore(ta, txt.nextSibling);
    ta.parentNode.insertBefore(acts, ta.nextSibling);
    try{ ta.focus(); }catch(_){}

    function fechar(){ try{ acts.remove(); ta.remove(); }catch(_){} txt.style.display=''; }
    acts.querySelector('.mk-edit-x').onclick=function(e){ e.preventDefault(); e.stopPropagation(); fechar(); };
    acts.querySelector('.mk-edit-ok').onclick=async function(e){
      e.preventDefault(); e.stopPropagation();
      var novo=String(ta.value||'').trim();
      if(!novo){ toast('O post não pode ficar vazio.'); return; }
      txt.textContent=novo; fechar();
      var v=null; try{ v=(typeof _mktV!=='undefined')?_mktV:null; }catch(_){}
      if(!v){ toast('Texto atualizado só aqui na tela.'); return; }
      try{ await mktPostSalvar(v, novo, 'rede_social'); toast('Post salvo ✓'); }
      catch(_){ toast('Não consegui salvar — o texto ficou na tela.'); }
    };
  }
  try{
    if(typeof document!=='undefined' && !window.__mkEditWired){
      window.__mkEditWired=true;
      document.addEventListener('click',function(ev){
        var b=(ev.target&&ev.target.closest)?ev.target.closest('.mk-edit-btn'):null;
        if(!b) return;
        ev.preventDefault(); ev.stopPropagation();
        _mkEditAbrir(b.closest('.post-box'));
      });
    }
  }catch(_){}

  /* CSS do seletor de emojis — injetado, sem tocar no styles.css */
  try{
    if(typeof document!=='undefined' && !document.getElementById('mkEstudioCss')){
      var _mkCss=document.createElement('style'); _mkCss.id='mkEstudioCss';
      _mkCss.textContent=[
        '.mk-emo{margin-top:14px}',
        '.mk-emo-t{font-size:11.5px;font-weight:800;color:#0a4da6;text-transform:uppercase;letter-spacing:.4px;margin:0 2px 6px}',
        '.mk-emo-row{display:flex;gap:7px;overflow-x:auto;padding:2px;-webkit-overflow-scrolling:touch}',
        '.mk-emo-b{flex:0 0 auto;border:1.5px solid #dbe7fa;background:#fff;border-radius:12px;padding:8px 11px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:3px;min-width:76px}',
        '.mk-emo-b.on{border-color:#0a4da6;background:#eff6ff;box-shadow:0 0 0 3px rgba(10,77,166,.10)}',
        '.mk-emo-a{font-size:14px;line-height:1.1;letter-spacing:1px}',
        '.mk-emo-n{font-size:11px;font-weight:700;color:#475569}',
        '.mk-emo-b.on .mk-emo-n{color:#0a4da6}',
        '.mk-emo-h{font-size:11.5px;color:#94a3b8;font-weight:600;margin:6px 2px 0}'
      ].join('\n');
      (document.head||document.documentElement).appendChild(_mkCss);
    }
  }catch(_){}

/* ╔═══ src/app/15c-arte-do-veiculo.js ════════════════════════════════════ */
  /* ==========================================================================
     🎨 v656 — ARTE DO VEÍCULO (anunciar · vendido · chegando)
     --------------------------------------------------------------------------
     Executa o PROJETO-2026-08-26-gerar-arte-do-veiculo.txt, fase 1.

     O QUE É: a peça de IMPACTO pro story e pro status — cenário de galpão
     desenhado no canvas, o carro em destaque, tipografia grande.
     🔑 ELA NÃO SUBSTITUI O CARD DE VENDA. São duas coisas e as duas ficam: o
     card (mevCardCanvas, 1080×1350) é o anúncio limpo e informativo; a arte é
     a peça de chamar atenção. O desenhador é novo, mas a SAÍDA é a mesma —
     `cardCompartilhar()` continua sendo a única dona do compartilhar.

     🔴 CUSTO ZERO POR ARTE: o cenário é desenhado, não é arquivo. Nenhuma ida
     ao servidor, nenhuma IA paga, nenhum egress novo (lembrar da faxina da
     v592). A única imagem baixada é a foto que o app já baixa pro card.
     🔴 NÃO GRAVA NADA NO BANCO. A arte é peça descartável.

     ⚠️ TUDO AQUI COMEÇA COM `arte`. A v599 perdeu tempo porque um nome curto
     colidiu dentro do IIFE compartilhado e matou o parser sem erro no console.
     ========================================================================== */

  /* ---- a fonte ------------------------------------------------------------
     A tipografia da referência é uma condensada pesada (Anton, licença SIL
     Open Font — pode ser embutida e redistribuída; a licença vai junto em
     fonts/Anton-OFL.txt).
     ⚠️ ELA NÃO VAI DENTRO DO app.js. São 130 KB que só interessam a quem abre
     a arte — enfiar no pacote principal faria TODO mundo pagar o download e o
     parse por uma tela que talvez nunca abra. Ela é carregada sob demanda, na
     primeira arte, e o Service Worker guarda daí em diante.
     🔴 E SE ELA NÃO CARREGAR, A ARTE NÃO SAI. Desenhar com a fonte do sistema
     entregaria uma peça DIFERENTE da que o lojista viu na prévia — e "saiu
     diferente" é pior que "não saiu", porque ninguém confere o que deu certo. */
  var ARTE_FONTE='ArteMev';
  var ARTE_FT="ArteMev, Impact, 'Arial Narrow', sans-serif";
  var _arteFontePromessa=null;
  function arteFonteCarregar(){
    if(_arteFontePromessa) return _arteFontePromessa;
    _arteFontePromessa=(async function(){
      try{
        if(!window.FontFace||!document.fonts) return false;
        var f=new FontFace(ARTE_FONTE, "url('fonts/Anton.ttf') format('truetype')",
                           { weight:'400', style:'normal', display:'block' });
        await f.load();
        document.fonts.add(f);
        /* ⚠️ o `load()` resolve com a fonte pronta, mas o canvas só enxerga
           depois que ela entra no documento — por isso o `check` no fim. */
        try{ await document.fonts.load('40px '+ARTE_FONTE); }catch(_){ }
        return !!document.fonts.check('40px '+ARTE_FONTE);
      }catch(_){ _arteFontePromessa=null; return false; }
    })();
    return _arteFontePromessa;
  }

  /* ---- as três paletas do cenário ---------------------------------------- */
  var ARTE_PAL=[
    { nome:'Galpão vermelho', neon:'#ff2530', tijolo:'#4a2326', chao:'#150e10' },
    { nome:'Galpão azul',     neon:'#2f8dff', tijolo:'#1c3350', chao:'#0a1018' },
    { nome:'Estúdio escuro',  neon:'#9aa3ae', tijolo:'#2a2e34', chao:'#101215' }
  ];
  var ARTE_MODOS=[['anunciar','Anunciar'],['vendido','Vendido'],['chegando','Chegando']];

  /* aleatório ESTÁVEL: o mesmo cenário sai idêntico toda vez. Sem isso a arte
     mudaria de faísca a cada toque num chip e pareceria instável. */
  function arteRnd(s){ var x=Math.sin(s)*10000; return x-Math.floor(x); }
  function arteHexA(h,a){ var n=parseInt(String(h).slice(1),16);
    return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')'; }
  function arteNum(v){
    if(typeof v==='number') return isFinite(v)&&v>0?v:0;
    var s=String(v==null?'':v).replace(/[^0-9,.-]/g,'');
    if(!s) return 0;
    if(s.indexOf(',')>=0&&s.indexOf('.')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if(s.indexOf(',')>=0) s=s.replace(',','.');
    var n=Number(s); return isFinite(n)&&n>0?n:0;
  }
  function arteDinheiro(n){
    n=arteNum(n); if(!n) return '';
    try{ return n.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    catch(_){ return String(Math.round(n)); }
  }

  /* ======================= O CENÁRIO, DESENHADO ========================== */
  function arteCenario(c,W,H,v){
    var P=ARTE_PAL[v]||ARTE_PAL[0];
    var hor=H*0.545, i, k, q, r;

    c.fillStyle='#07060a'; c.fillRect(0,0,W,H);

    /* teto corrugado em perspectiva */
    c.save(); c.beginPath(); c.rect(0,0,W,hor); c.clip();
    var tg=c.createLinearGradient(0,0,0,hor);
    tg.addColorStop(0,'#0a0708'); tg.addColorStop(1,'#241417');
    c.fillStyle=tg; c.fillRect(0,0,W,hor);
    for(i=-16;i<=16;i++){
      var x0=W/2+i*(W*0.145), x1=W/2+i*11;
      c.beginPath(); c.moveTo(x0,-40); c.lineTo(x0+W*0.072,-40);
      c.lineTo(x1+5.5,hor); c.lineTo(x1-5.5,hor); c.closePath();
      c.fillStyle=(i%2)?'rgba(255,255,255,.030)':'rgba(0,0,0,.30)'; c.fill();
    }
    for(k=1;k<=8;k++){
      var t=Math.pow(k/8,2.4), yt=-30+(hor+30)*t;
      c.fillStyle='rgba(10,7,8,'+(0.55*(1-t)+0.12)+')';
      c.fillRect(0,yt,W,Math.max(2,16*(1-t)));
      c.fillStyle='rgba(255,255,255,'+(0.05*(1-t))+')';
      c.fillRect(0,yt,W,Math.max(1,3*(1-t)));
    }
    c.restore();

    /* parede de tijolo no fundo */
    var py0=hor-H*0.175, py1=hor;
    c.save(); c.beginPath(); c.rect(0,py0,W,py1-py0); c.clip();
    c.fillStyle=P.tijolo; c.fillRect(0,py0,W,py1-py0);
    var th=13, tw=42;
    for(r=0;r*th<py1-py0;r++){
      var off=(r%2)*tw/2;
      for(q=-1;q*tw<W+tw;q++){
        var bx=q*tw+off, by=py0+r*th, tt=arteRnd(r*31.7+q*7.3);
        c.fillStyle='rgba(0,0,0,'+(0.10+tt*0.30)+')';
        c.fillRect(bx+1,by+1,tw-2,th-2);
      }
    }
    var pg=c.createLinearGradient(0,py0,0,py1);
    pg.addColorStop(0,'rgba(0,0,0,.80)'); pg.addColorStop(.5,'rgba(0,0,0,.25)'); pg.addColorStop(1,'rgba(0,0,0,.72)');
    c.fillStyle=pg; c.fillRect(0,py0,W,py1-py0);
    c.restore();

    /* luminárias */
    [[.27,.115,.30,-.17],[.73,.185,.25,.14],[.14,.255,.19,.11],
     [.60,.315,.155,-.09],[.88,.075,.21,.21],[.40,.385,.12,.07]].forEach(function(L){
      var x=W*L[0], y=H*L[1], w=W*L[2];
      c.save(); c.translate(x,y); c.rotate(L[3]);
      var gg=c.createRadialGradient(0,0,0,0,0,w);
      gg.addColorStop(0,'rgba(255,251,232,.50)'); gg.addColorStop(.5,'rgba(255,251,232,.10)');
      gg.addColorStop(1,'rgba(255,251,232,0)');
      c.fillStyle=gg; c.beginPath(); c.ellipse(0,0,w,w*.30,0,0,7); c.fill();
      c.fillStyle='#fffdf4'; c.shadowColor='#fff6d8'; c.shadowBlur=45;
      c.beginPath();
      if(c.roundRect) c.roundRect(-w/2,-w*.020,w,w*.040,w*.020);
      else c.rect(-w/2,-w*.020,w,w*.040);
      c.fill(); c.restore();
    });

    /* neon */
    function neon(ax,ay,bx2,by2,esp,al){
      c.save(); c.globalAlpha=al; c.strokeStyle=P.neon; c.lineWidth=esp; c.lineCap='round';
      c.shadowColor=P.neon; c.shadowBlur=55;
      c.beginPath(); c.moveTo(ax,ay); c.lineTo(bx2,by2); c.stroke();
      c.strokeStyle='#fff'; c.lineWidth=esp*0.32; c.shadowBlur=18;
      c.beginPath(); c.moveTo(ax,ay); c.lineTo(bx2,by2); c.stroke(); c.restore();
    }
    neon(W*0.035,hor-H*0.165,W*0.035,hor-H*0.010,7,.95);
    neon(W*0.965,hor-H*0.165,W*0.965,hor-H*0.010,7,.95);
    neon(W*0.03,hor-H*0.006,W*0.97,hor-H*0.006,5,.85);
    neon(W*0.10,H*0.30,W*0.42,H*0.255,4,.55);
    neon(W*0.62,H*0.235,W*0.94,H*0.285,4,.55);

    /* chão polido */
    c.save(); c.beginPath(); c.rect(0,hor,W,H-hor); c.clip();
    var fg=c.createLinearGradient(0,hor,0,H);
    fg.addColorStop(0,'#1d1013'); fg.addColorStop(.30,P.chao); fg.addColorStop(1,'#050405');
    c.fillStyle=fg; c.fillRect(0,hor,W,H-hor);
    c.strokeStyle='rgba(255,255,255,.035)'; c.lineWidth=2;
    for(i=-10;i<=10;i++){ c.beginPath(); c.moveTo(W/2+i*13,hor); c.lineTo(W/2+i*(W*0.50),H*1.15); c.stroke(); }
    for(k=1;k<=7;k++){ var t2=Math.pow(k/7,2.0), y2=hor+(H-hor)*t2;
      c.strokeStyle='rgba(255,255,255,'+(0.045*t2+0.012)+')';
      c.beginPath(); c.moveTo(0,y2); c.lineTo(W,y2); c.stroke(); }
    var rg=c.createRadialGradient(W/2,hor,0,W/2,hor,W*0.95);
    rg.addColorStop(0,arteHexA(P.neon,.34)); rg.addColorStop(.35,arteHexA(P.neon,.10));
    rg.addColorStop(1,'rgba(0,0,0,0)');
    c.fillStyle=rg; c.fillRect(0,hor,W,H-hor);
    for(i=0;i<26;i++){
      var xr=arteRnd(i*3.1)*W, wr=6+arteRnd(i*5.7)*26, hr=(H-hor)*(0.18+arteRnd(i*2.3)*0.55);
      c.fillStyle=arteHexA(P.neon,0.030+arteRnd(i*9.1)*0.055);
      c.fillRect(xr,hor,wr,hr);
    }
    c.restore();

    /* silhuetas do galpão: prateleira, pneus, carrinho */
    c.save();
    var rim=arteHexA(P.neon,.55);
    (function(){
      var x=W*-0.01, w=W*0.185, y0=hor-H*0.150, h=H*0.150;
      c.fillStyle='rgba(4,3,4,.92)';
      c.fillRect(x,y0,W*0.016,h); c.fillRect(x+w-W*0.016,y0,W*0.016,h);
      for(var kk=0;kk<4;kk++){ var yy=y0+h*(kk/4)+6;
        c.fillRect(x,yy,w,H*0.009);
        c.fillStyle=rim; c.fillRect(x,yy,w,2); c.fillStyle='rgba(4,3,4,.92)';
        for(var qq=0;qq<3;qq++){ var bw=w*0.26, bx2=x+w*0.06+qq*w*0.31, bh=H*0.020*(0.6+arteRnd(kk*3+qq)*0.8);
          c.fillRect(bx2,yy-bh,bw,bh); }
      }
    })();
    (function(){
      var cx=W*0.935, base=hor-H*0.004;
      for(var kk=0;kk<5;kk++){ var yy=base-kk*H*0.0235, rx=W*0.085, ry=H*0.0145;
        c.fillStyle='rgba(3,3,4,.94)';
        c.beginPath(); c.ellipse(cx,yy,rx,ry,0,0,7); c.fill();
        c.strokeStyle=arteHexA(P.neon,.30); c.lineWidth=2;
        c.beginPath(); c.ellipse(cx,yy-ry*0.55,rx*0.97,ry*0.92,0,Math.PI,Math.PI*2); c.stroke();
      }
    })();
    (function(){
      var x=W*0.215, w=W*0.115, y0=hor-H*0.055, h=H*0.055;
      c.fillStyle='rgba(3,3,4,.9)'; c.fillRect(x,y0,w,h);
      c.fillStyle=arteHexA(P.neon,.35); c.fillRect(x,y0,w,2);
      for(var kk=1;kk<4;kk++){ c.fillStyle='rgba(255,255,255,.05)'; c.fillRect(x+4,y0+h*kk/4,w-8,2); }
    })();
    c.restore();

    var bg=c.createRadialGradient(W/2,hor-H*0.02,0,W/2,hor-H*0.02,W*0.62);
    bg.addColorStop(0,arteHexA(P.neon,.26)); bg.addColorStop(.55,arteHexA(P.neon,.06));
    bg.addColorStop(1,'rgba(0,0,0,0)');
    c.fillStyle=bg; c.fillRect(0,0,W,H);

    for(i=0;i<38;i++){
      var xf=arteRnd(i*1.7)*W, yf=arteRnd(i*4.9)*H*0.62, rf=0.8+arteRnd(i*8.3)*2.4;
      c.save(); c.globalAlpha=.20+arteRnd(i*6.1)*.55;
      c.fillStyle=(i%3)?'#ffd9b0':P.neon;
      c.shadowColor=c.fillStyle; c.shadowBlur=12;
      c.beginPath(); c.arc(xf,yf,rf,0,7); c.fill(); c.restore();
    }
    var vg=c.createRadialGradient(W/2,H*0.48,W*0.22,W/2,H*0.48,W*1.02);
    vg.addColorStop(0,'rgba(0,0,0,0)'); vg.addColorStop(1,'rgba(0,0,0,.80)');
    c.fillStyle=vg; c.fillRect(0,0,W,H);
  }

  /* ======================= TEXTO ========================================= */
  function arteFaixa(c,x,y,texto,tam,alinha){
    c.save(); c.font=tam+'px '+ARTE_FT;
    var l=c.measureText(texto).width, px=tam*.26, py=tam*.20;
    var bx=(alinha==='right')?(x-l-px*2):x;
    c.fillStyle='#d31f26'; c.shadowColor='rgba(0,0,0,.6)'; c.shadowBlur=18; c.shadowOffsetY=4;
    c.beginPath();
    if(c.roundRect) c.roundRect(bx,y-tam*.80,l+px*2,tam*1.06,tam*.07);
    else c.rect(bx,y-tam*.80,l+px*2,tam*1.06);
    c.fill();
    c.shadowColor='transparent';
    c.fillStyle='#fff'; c.textAlign='left'; c.textBaseline='alphabetic';
    c.fillText(texto,bx+px,y+py*.05); c.restore();
  }
  /* 🔴🔴 O TEXTO TEM QUE CABER NA PEÇA. Sem esta função, "FIAT CRONOS 1.3
     FIREFLY FLEX DRIVE GSR" saía CORTADO nas duas pontas — a peça mostrava
     "DELO: FIAT CRONOS 1.3 FIRE" e ninguém programou isso: o canvas
     simplesmente desenha pra fora e o que passa da borda some.
     ⚠️ Achado com a foto de verdade, não no teste — é o tipo de defeito que
     só aparece quando alguém OLHA a imagem. Por isso a versão sai com quatro
     artes de exemplo geradas e conferidas a olho.
     ✅ A regra: encolhe a letra até caber (no máximo até 55% do tamanho); se
     ainda assim não couber, corta com reticências. Modelo de nome comprido
     fica menor, nunca picado no meio. */
  function arteTamQueCabe(c,s,tam,maxL){
    c.save(); var t=tam;
    for(var i=0;i<26;i++){
      c.font=t+'px '+ARTE_FT;
      if(c.measureText(s).width<=maxL) break;
      t=Math.round(t*0.94);
      if(t<tam*0.55){ t=Math.round(tam*0.55); break; }
    }
    c.restore(); return t;
  }
  function arteCorta(c,s,tam,maxL){
    c.save(); c.font=tam+'px '+ARTE_FT;
    if(c.measureText(s).width<=maxL){ c.restore(); return s; }
    var t=String(s);
    while(t.length>4 && c.measureText(t+'…').width>maxL) t=t.slice(0,-1);
    c.restore(); return t+'…';
  }
  function arteTxtCabe(c,s,x,y,tam,cor,al,contorno,maxL){
    var t=arteTamQueCabe(c,s,tam,maxL);
    arteTxt(c, arteCorta(c,s,t,maxL), x,y,t,cor,al,contorno);
    return t;
  }
  function arteTxt(c,s,x,y,tam,cor,al,contorno){
    c.save(); c.font=tam+'px '+ARTE_FT; c.textAlign=al||'center'; c.textBaseline='alphabetic';
    if(contorno){ c.lineWidth=tam*.075; c.strokeStyle='rgba(0,0,0,.55)'; c.strokeText(s,x,y); }
    c.shadowColor='rgba(0,0,0,.9)'; c.shadowBlur=tam*.28; c.shadowOffsetY=tam*.06;
    c.fillStyle=cor||'#fff'; c.fillText(s,x,y); c.restore();
  }
  /* desenha um bloco e joga o espelho dele logo abaixo (o "VENDIDO" da
     referência) */
  function arteReflexo(c,W,yTopo,altura,pintar){
    var off=document.createElement('canvas');
    off.width=W; off.height=Math.max(1,Math.ceil(altura));
    var o=off.getContext('2d');
    o.translate(0,-yTopo); pintar(o);
    c.drawImage(off,0,yTopo);
    var m=document.createElement('canvas'); m.width=W; m.height=off.height;
    var mo=m.getContext('2d');
    mo.translate(0,off.height); mo.scale(1,-1); mo.drawImage(off,0,0);
    var fade=mo.createLinearGradient(0,0,0,off.height);
    fade.addColorStop(0,'rgba(0,0,0,0)'); fade.addColorStop(.55,'rgba(0,0,0,.45)'); fade.addColorStop(1,'rgba(0,0,0,1)');
    mo.globalCompositeOperation='destination-in'; mo.fillStyle=fade; mo.fillRect(0,0,W,off.height);
    c.save(); c.globalAlpha=.30; c.drawImage(m,0,yTopo+altura+6); c.restore();
  }

  /* ==========================================================================
     A MONTAGEM — e ela DEVOLVE O QUE PINTOU
     --------------------------------------------------------------------------
     🔑 `arteMontar` não devolve só a imagem: devolve também o objeto dos
     CAMPOS QUE ENTRARAM na peça. É por ele que o teste confere que o custo, o
     preço mínimo e a observação interna NÃO vazaram — comparar pixel a pixel
     provaria pouco e quebraria a cada ajuste de layout. A lição é da v265 e
     da v449, e o jeito honesto de medir é este.
     ========================================================================== */
  function arteMontar(cv, d){
    d=d||{};
    var story=(d.formato!=='feed');
    var W=1080, H=story?1920:1080;
    if(cv.width!==W) cv.width=W;
    if(cv.height!==H) cv.height=H;
    var c=cv.getContext('2d');
    var campos={ selo:d.modo||'anunciar', formato:story?'story':'feed' };
    c.clearRect(0,0,W,H);
    arteCenario(c,W,H,Number(d.cenario)||0);
    var P=ARTE_PAL[Number(d.cenario)||0]||ARTE_PAL[0];

    /* --- o carro --- */
    var base=story?H*0.715:H*0.775, faixaFoto=null;
    if(d.foto){
      var img=d.foto;
      var maxL=W*(story?0.98:0.92), maxA=H*(story?0.40:0.50);
      var e=Math.min(maxL/img.width, maxA/img.height);
      var cw=img.width*e, ch=img.height*e, cx=(W-cw)/2, cy=base-ch;

      c.save();
      var hg=c.createRadialGradient(W/2,cy+ch*.55,cw*.10,W/2,cy+ch*.55,cw*.72);
      hg.addColorStop(0,arteHexA(P.neon,.30)); hg.addColorStop(1,'rgba(0,0,0,0)');
      c.fillStyle=hg; c.fillRect(0,cy-60,W,ch+160); c.restore();

      c.save();
      var sg=c.createRadialGradient(W/2,base-6,0,W/2,base-6,cw*.52);
      sg.addColorStop(0,'rgba(0,0,0,.85)'); sg.addColorStop(.55,'rgba(0,0,0,.35)'); sg.addColorStop(1,'rgba(0,0,0,0)');
      c.fillStyle=sg; c.beginPath(); c.ellipse(W/2,base-6,cw*.52,ch*.10,0,0,7); c.fill(); c.restore();

      /* a foto entra inteira: preenche uma faixa larga e apaga as bordas.
         (o recorte automático do carro é a fase 2 do projeto — ver o
         changelog: o recorte por IA trouxe junto a placa da loja do fundo) */
      var bw=W*.94, bh=H*(story?.34:.42), bx=(W-bw)/2, by=base-bh;
      faixaFoto={ x:bx, y:by, w:bw, h:bh };
      var kk=Math.max(bw/img.width,bh/img.height);
      var sw=bw/kk, sh=bh/kk;
      var sx=(img.width-sw)/2, sy=(img.height-sh)*.58;
      var off=document.createElement('canvas');
      off.width=Math.max(1,Math.round(bw)); off.height=Math.max(1,Math.round(bh));
      var o=off.getContext('2d');
      o.drawImage(img,sx,sy,sw,sh,0,0,bw,bh);
      var fx=o.createRadialGradient(bw/2,bh/2,Math.min(bw,bh)*.26,bw/2,bh/2,Math.max(bw,bh)*.60);
      fx.addColorStop(0,'rgba(0,0,0,1)'); fx.addColorStop(.62,'rgba(0,0,0,.75)'); fx.addColorStop(1,'rgba(0,0,0,0)');
      o.globalCompositeOperation='destination-in'; o.fillStyle=fx; o.fillRect(0,0,bw,bh);
      c.save(); c.drawImage(off,bx,by);
      c.globalCompositeOperation='overlay'; c.globalAlpha=.42;
      c.fillStyle=arteHexA(P.neon,.55); c.drawImage(off,bx,by);
      c.restore();
      campos.foto=true;

      /* 🔴🔴 A PLACA NASCE BORRADA (decidido pelo Angelo em 26/08).
         A foto vai pra rede social, e a placa vai junto. O botão da tela é
         "Mostrar placa", não "Borrar placa": o caminho fácil é o seguro, e o
         trabalho fica com quem quer EXPOR.
         ⚠️ O borrão NÃO adivinha onde a placa está — ele nasce na faixa onde
         a placa dianteira quase sempre cai (o miolo baixo do carro) e o
         lojista ARRASTA se estiver fora. Prometer que acha sozinho seria o
         pior dos mundos: nasceria ligado borrando o lugar errado, sujando o
         carro E deixando a placa à mostra. */
      if(d.borrar!==false){
        var pl=d.placa||{ x:W/2, y:by+bh*0.80 };
        var rw=bw*.135, rh=bw*.050;
        var t=document.createElement('canvas');
        t.width=Math.max(2,Math.round(rw*2)); t.height=Math.max(2,Math.round(rh*2));
        try{
          t.getContext('2d').drawImage(cv,pl.x-rw,pl.y-rh,rw*2,rh*2,0,0,t.width,t.height);
          c.save(); c.beginPath(); c.ellipse(pl.x,pl.y,rw,rh,0,0,7); c.clip();
          c.filter='blur(11px)'; c.drawImage(t,pl.x-rw,pl.y-rh,rw*2,rh*2);
          c.filter='none'; c.restore();
          /* quando o navegador não tem `filter` no canvas (Safari antigo), o
             borrão sairia igual à foto. Aí a tarja opaca é o certo: proteger
             feio é melhor que não proteger. */
          if(!('filter' in c)){
            c.save(); c.fillStyle='rgba(12,12,14,.92)';
            c.beginPath(); c.ellipse(pl.x,pl.y,rw,rh,0,0,7); c.fill(); c.restore();
          }
        }catch(_){ }
        campos.placa_borrada=true;
      }
    } else {
      arteTxt(c,'sem foto',W/2,H*.55,46,'rgba(255,255,255,.30)');
    }

    /* --- topo: as faixas vermelhas --- */
    var t0=story?H*0.062:H*0.085;
    var tSel=story?60:46;
    c.save(); c.translate(W*.048,t0); c.rotate(-.038);
    arteFaixa(c,0,0,'NOVIDADES',tSel);
    arteFaixa(c,0,tSel*1.30,'A CAMINHO!',tSel);
    c.restore();
    campos.faixa_esquerda='NOVIDADES A CAMINHO!';

    var dir=W*.952;
    if(d.modo==='vendido'||d.modo==='chegando'){
      var A=(d.modo==='vendido')?['OUTRA VENDA','CONFIRMADA!']:['CHEGANDO','NA LOJA!'];
      c.save(); c.translate(0,t0); c.rotate(.024);
      arteFaixa(c,dir,0,A[0],tSel,'right');
      arteFaixa(c,dir,tSel*1.30,A[1],tSel,'right');
      c.restore();
      campos.faixa_direita=A.join(' ');
    }

    if(d.ano){
      arteTxt(c,'ANO: '+d.ano,dir,t0+((d.modo==='anunciar')?38:tSel*3.05),story?44:36,'#fff','right',true);
      campos.ano=String(d.ano);
    }

    /* --- logo / nome da loja --- */
    var ly=t0+(story?tSel*3.2:tSel*3.0);
    if(d.logo){
      var el=Math.min((W*.42)/d.logo.width,(H*.10)/d.logo.height);
      c.save(); c.shadowColor='rgba(0,0,0,.85)'; c.shadowBlur=26;
      c.drawImage(d.logo,W*.048,ly,d.logo.width*el,d.logo.height*el); c.restore();
      campos.logo=true;
    } else if(d.lojaNome){
      arteTxtCabe(c,String(d.lojaNome).toUpperCase(),W*.048,ly+56,story?58:46,'#f0f0f0','left',true,W*0.90);
      campos.loja=String(d.lojaNome);
    }

    /* --- o pé --- */
    if(d.modo==='vendido'){
      /* 🔴 A ARTE DE VENDIDO NÃO MOSTRA PREÇO (decidido em 26/08). A peça de
         vendido é prova de movimento, não tabela. Sem botão e sem opção
         escondida: no modo Vendido a linha de valor nem é montada. */
      var tam=story?184:134, yv=story?H*.858:H*.850;
      arteReflexo(c,W,yv-tam,tam*1.22,function(oo){
        arteTxtCabe(oo,'VENDIDO',W/2,yv,tam,'#fff','center',true,W*0.90);
      });
      campos.vendido=true;
    } else {
      var y0=story?H*.800:H*.845;
      var t1=story?78:60, t2=story?42:34, t3=story?54:42;
      var l2=y0+(story?76:58), l3=l2+(story?60:48);
      var mod=String(d.modelo||'').toUpperCase();
      var fipe=arteDinheiro(d.fipe), valor=arteDinheiro(d.valor);
      arteReflexo(c,W,y0-t1,(l3-y0)+t1+18,function(oo){
        if(mod) arteTxtCabe(oo,'MODELO: '+mod,W/2,y0,t1,'#fff','center',true,W*0.90);
        if(fipe){ arteTxt(oo,'TABELA FIPE:',W*.055,l2,t2,'#d8dde3','left');
                  arteTxt(oo,'R$ '+fipe,W*.055,l3,t3,'#fff','left',true); }
        /* 🔴 valor VAZIO não vira "a combinar", nem "consulte", nem nada: a
           linha simplesmente não é desenhada. */
        if(valor){ arteTxt(oo,'VALOR:',W*.945,l2,t2,'#d8dde3','right');
                   arteTxt(oo,'R$ '+valor,W*.945,l3,t3,'#fff','right',true); }
      });
      if(mod) campos.modelo=mod;
      if(fipe) campos.fipe=fipe;
      if(valor) campos.valor=valor;
    }
    campos.faixa_foto=faixaFoto;
    return campos;
  }

  /* ==========================================================================
     DE ONDE SAI CADA CAMPO — e o que NUNCA sai
     --------------------------------------------------------------------------
     🔴 NUNCA ENTRAM NA ARTE, em nenhuma origem: custo, preço mínimo, margem,
     comissão, observação interna (v.obs), nome de cliente, dado de proposta.
     É o vazamento que a v265 consertou e a v449 consertou de novo. Repare que
     este mapa é uma LISTA DO QUE ENTRA, não uma lista do que sai — a diferença
     é que campo novo no veículo nasce FORA da arte por padrão.

     🔴 E O "PREÇO MÍNIMO" NÃO ENTRA NEM COMO RESERVA. O projeto sugeria
     "preco_anuncio, senão preco_minimo" (é o que o card de venda faz hoje),
     mas o próprio projeto proíbe piso interno na peça, duas linhas adiante. O
     preço mínimo É o piso interno: é com ele que a ficha calcula a margem.
     Publicá-lo entrega ao comprador exatamente o número que o lojista não quer
     mostrar. Sem preço de anúncio, aparece o campo vazio pro lojista digitar.
     ⚠️ O card de venda (mevCardCanvas) continua com a regra antiga — mexer
     nele é outra versão, e está anotado no changelog.
     ========================================================================== */
  function arteFipeDe(v){
    try{
      var ex=(v&&v.extras)||{};
      var n=arteNum((ex.fipe&&(ex.fipe.valor||ex.fipe.preco))||v.fipe||0);
      return n;
    }catch(_){ return 0; }
  }
  function arteValorDe(v, origem){
    /* 🔴 AVALIAÇÃO: o carro ainda não tem preço de venda. O que existe é o
       valor AVALIADO — o que a loja PAGA. Isso não pode virar preço de
       anúncio, nem por descuido. Nasce vazio, e o lojista digita. */
    if(origem==='avaliacao') return 0;
    /* 🔴 REPASSE: a arte obedece a MESMA regra que a tela do repasse já
       obedece (v288/v453). Se a tela não mostra preço, a arte não mostra. */
    if(origem==='repasse'){
      try{ if(typeof estPrecoRepasse==='function') return arteNum(estPrecoRepasse(v)); }catch(_){ }
      return arteNum(v&&v.preco_repasse);
    }
    return arteNum(v&&v.preco_anuncio);
  }
  function arteModeloDe(v){
    v=v||{};
    return [String(v.marca||'').trim(), String(v.modelo||'').trim()]
      .filter(Boolean).join(' ').replace(/\s+/g,' ').trim();
  }
  function arteAnoDe(v){ v=v||{}; return String(v.ano_modelo||v.ano||'').trim(); }
  function arteLojaNome(){
    try{
      var l=(typeof _lojaRec!=='undefined'&&_lojaRec)?_lojaRec:{};
      return String(l.nome_fantasia||l.razao_social||'').trim();
    }catch(_){ return ''; }
  }

  /* ==========================================================================
     A TELA
     --------------------------------------------------------------------------
     ⚠️ DESVIO CONSCIENTE DO PROJETO: ele pedia "um bloco que abre embaixo do
     botão, igual ao Marketplace da v602". Aqui a arte abre no MODAL que o app
     já tem, e o motivo é o próprio projeto: são CINCO telas diferentes
     chamando a mesma peça. Cinco blocos embutidos em cinco layouts seriam
     cinco donos do mesmo desenho, e o dia em que um deles mudasse de largura
     a arte sairia diferente ali e só ali. Um modal é um lugar só.
     ========================================================================== */
  var _arte=null;

  async function arteAbrir(v, origem){
    v=v||{}; origem=origem||'estoque';
    var modelo=arteModeloDe(v);
    if(!modelo){ toast('Esse veículo está sem marca e modelo — complete a ficha antes de gerar a arte.'); return; }
    var fotos=(v.fotos&&v.fotos.slice)?v.fotos.slice(0,20):[];
    if(!fotos.length){ toast('Esse veículo ainda não tem foto — a arte precisa de uma.'); return; }

    if(typeof _lojaRec!=='undefined' && !_lojaRec){
      try{ var lr=await supa.from('loja').select('*'); var arr=(lr&&lr.data)||[];
        _lojaRec=arr.filter(function(l){ return String(l.user_id)===String(meuId); })[0]||arr[0]||null; }catch(_){ }
    }

    var valorOrigem=arteValorDe(v, origem);
    _arte={
      v:v, origem:origem, fotos:fotos, fotoIdx:0,
      /* 🔴 O APP NUNCA ESCOLHE "CHEGANDO" SOZINHO. Marcar um carro como
         chegando é afirmar que a loja COMPROU aquele carro, e nem uma
         avaliação salva nem um repasse provam compra. Quem afirma posse é o
         lojista, no dedo — a mesma regra de "Em negociação" e "No meu
         estoque". O chip fica ali do lado, a um toque; só não vem marcado. */
      modo:(String(v.status||'')==='vendido'||v.vendido===true)?'vendido':'anunciar',
      formato:'story', cenario:0,
      valorOrigem:valorOrigem, valorManual:'',
      borrar:true, placa:null, img:null, logo:null, campos:null, trocando:false
    };

    var bg=cliModalEl(); bg.classList.add('on'); cliModalDel(null);
    var av=$('cliMav'); if(av) av.innerHTML=mkIco('post',20);
    var tt=$('cliMt'); if(tt) tt.textContent='Arte do veículo';
    var body=$('cliMbody'); if(!body) return;
    body.innerHTML='<div class="art-cx"><div class="cad-msg load" id="artMsg">Preparando a arte…</div></div>';

    var okFonte=await arteFonteCarregar();
    if(!okFonte){
      body.innerHTML='<div class="cad-msg err">Não consegui carregar a letra da arte. Abra o app conectado uma vez e tente de novo — depois disso ela funciona até sem internet.</div>';
      return;
    }
    _arte.img=await arteFoto(_arte.fotos[0], origem);
    try{ var lu=(_lojaRec&&_lojaRec.logo_url)||''; if(lu) _arte.logo=await _cardImg(imgCdn(lu,600)); }catch(_){ }
    if(!_arte.img){
      body.innerHTML='<div class="cad-msg err">Não consegui abrir a foto do veículo pra montar a arte.</div>';
      return;
    }
    artePinta();
  }

  /* ⚠️ A FOTO PRECISA CHEGAR "LIMPA" NO CANVAS. O `_cardImg` já pede
     crossOrigin='anonymous' — sem isso o navegador aceita desenhar mas
     RECUSA o `toDataURL` depois, e a arte apareceria na tela e não baixaria.
     ⚠️ E a foto da AVALIAÇÃO não passa pelo redimensionador público: ela é do
     bucket do lojista. Se o caminho leve falhar, cai no endereço original em
     vez de deixar a arte sem foto. */
  async function arteFoto(url, origem){
    var u=String(url||''); if(!u) return null;
    var alvo=(origem==='avaliacao')?u:imgCdn(u,1400);
    var im=null;
    try{ im=await _cardImg(alvo); }catch(_){ im=null; }
    if(!im && alvo!==u){ try{ im=await _cardImg(u); }catch(_){ im=null; } }
    return im;
  }

  function arteChipsHtml(id, itens, atual){
    return '<div class="art-chips" id="'+id+'">'+itens.map(function(it){
      return '<button type="button" class="art-chip'+(String(it[0])===String(atual)?' on':'')+'" data-v="'+esc(String(it[0]))+'">'+esc(it[1])+'</button>';
    }).join('')+'</div>';
  }

  function artePinta(){
    var a=_arte; if(!a) return;
    var body=$('cliMbody'); if(!body) return;
    var pedeValor=(!a.valorOrigem && a.modo!=='vendido');
    body.innerHTML=
      '<div class="art-cx">'+
        arteChipsHtml('artModo', ARTE_MODOS, a.modo)+
        arteChipsHtml('artFmt', [['story','Story'],['feed','Feed']], a.formato)+
        arteChipsHtml('artCen', ARTE_PAL.map(function(p,i){ return [i,p.nome]; }), a.cenario)+
        (pedeValor
          ? '<label class="cad-lbl" for="artValor">Valor</label>'+
            '<input class="cad-in" id="artValor" inputmode="numeric" placeholder="R$ 0" value="'+esc(a.valorManual||'')+'">'
          : '')+
        '<div class="art-prev"><canvas id="artCv" width="1080" height="1920"></canvas></div>'+
        '<div class="art-acts">'+
          '<button type="button" class="b1" id="artDl">Baixar</button>'+
          '<button type="button" class="b2" id="artSh">Compartilhar</button>'+
        '</div>'+
        '<div class="art-acts">'+
          '<button type="button" class="b3" id="artFoto">Trocar foto</button>'+
          /* 🔴 v835 — O BOTÃO DE MOSTRAR/BORRAR A PLACA SAIU.
             O Angelo pediu junto com a saída do "Gerar arte" do app: nada de
             botão vivo num lugar que ninguém mais abre.
             ⚠️ O `a.borrar` continua nascendo TRUE, e é de propósito. Se um
             dia a arte voltar (MEV_ARTE_VEICULO no 00-edicoes), ela volta
             PROTEGENDO a placa por padrão. Tirar o botão nunca pode virar
             tirar a proteção — quem some é a escolha, não o borrão. */
        '</div>'+
        '<div id="artFotos"></div>'+
        /* 🔴 UMA LINHA, E ELA GANHA O LUGAR DELA. O projeto pedia a tela sem
           texto explicativo — mas o borrão nasce num lugar PROVÁVEL, não no
           certo, e sem esta frase o lojista publica achando que protegeu.
           Uma linha aqui vale menos que uma placa exposta lá fora. */
        (a.borrar?'<div class="art-dica">O borrão nasce onde a placa costuma ficar. Se estiver fora, <b>toque na foto</b> em cima da placa.</div>':'')+
        '<div class="cad-msg" id="artMsg"></div>'+
      '</div>';

    arteChipsWire('artModo', function(v){ a.modo=v; });
    arteChipsWire('artFmt',  function(v){ a.formato=v; });
    arteChipsWire('artCen',  function(v){ a.cenario=Number(v)||0; });
    var iv=$('artValor'); if(iv) iv.oninput=function(){ a.valorManual=iv.value; arteRedesenhar(); };
    var cv=$('artCv');
    if(cv) cv.onclick=function(ev){
      /* toque em cima da prévia move o borrão pra onde a placa está de
         verdade — a razão width/rect leva a coordenada da tela pro canvas */
      if(!a.borrar) return;
      var r=cv.getBoundingClientRect();
      a.placa={ x:(ev.clientX-r.left)*(cv.width/r.width), y:(ev.clientY-r.top)*(cv.height/r.height) };
      arteRedesenhar();
    };
    var bp=$('artPlaca'); if(bp) bp.onclick=function(){
      a.borrar=!a.borrar; if(a.borrar) a.placa=null;
      bp.textContent=a.borrar?'Mostrar placa':'Borrar placa';
      arteRedesenhar();
    };
    var bf=$('artFoto'); if(bf) bf.onclick=arteTrocarFoto;
    var bd=$('artDl'); if(bd) bd.onclick=arteBaixar;
    var bs=$('artSh'); if(bs) bs.onclick=arteCompartilhar;
    if(a.trocando) arteFotosPinta();
    arteRedesenhar();
  }

  function arteChipsWire(id, aplica){
    var box=$(id); if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('.art-chip'), function(b){
      b.onclick=function(){
        Array.prototype.forEach.call(box.querySelectorAll('.art-chip'), function(o){ o.classList.remove('on'); });
        b.classList.add('on');
        aplica(b.getAttribute('data-v'));
        /* o campo de valor aparece e some conforme o modo, então a tela é
           repintada — o canvas é redesenhado do zero de qualquer jeito */
        artePinta();
      };
    });
  }

  function arteRedesenhar(){
    var a=_arte; if(!a) return null;
    var cv=$('artCv'); if(!cv) return null;
    a.campos=arteMontar(cv, {
      modo:a.modo, formato:a.formato, cenario:a.cenario,
      modelo:arteModeloDe(a.v), ano:arteAnoDe(a.v),
      fipe:arteFipeDe(a.v),
      valor:a.valorOrigem||arteNum(a.valorManual),
      lojaNome:arteLojaNome(), logo:a.logo,
      foto:a.img, placa:a.placa, borrar:a.borrar
    });
    return a.campos;
  }

  function arteFotosPinta(){
    var a=_arte, box=$('artFotos'); if(!a||!box) return;
    box.innerHTML=a.trocando
      ? '<div class="art-fotos">'+a.fotos.map(function(u,i){
          return '<button type="button" class="art-fot'+(i===a.fotoIdx?' on':'')+'" data-i="'+i+'">'+
                 '<img loading="lazy" decoding="async" src="'+esc(imgCdn(u,240))+'" alt=""></button>';
        }).join('')+'</div>'
      : '';
    Array.prototype.forEach.call(box.querySelectorAll('.art-fot'), function(b){
      b.onclick=async function(){
        var i=Number(b.getAttribute('data-i'))||0;
        if(i===a.fotoIdx){ a.trocando=false; arteFotosPinta(); return; }
        arteMsg('Trocando a foto…','load');
        var im=await arteFoto(a.fotos[i], a.origem);
        if(!im){ arteMsg('Não consegui abrir essa foto.','err'); return; }
        a.fotoIdx=i; a.img=im; a.placa=null; a.trocando=false;
        arteMsg('',''); artePinta();
      };
    });
  }
  function arteTrocarFoto(){
    var a=_arte; if(!a) return;
    a.trocando=!a.trocando; arteFotosPinta();
  }
  function arteMsg(txt,tipo){
    var el=$('artMsg'); if(!el) return;
    el.className='cad-msg'+(tipo?(' '+tipo):''); el.textContent=txt||'';
  }
  function arteNomeArquivo(){
    var a=_arte||{};
    var base=(arteModeloDe(a.v)||'veiculo').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    return 'arte-'+base+'-'+(a.modo||'anunciar')+'-'+(a.formato||'story')+'.png';
  }
  function arteDataUrl(){
    var cv=$('artCv'); if(!cv) return '';
    /* PNG de propósito: o cenário é quase todo preto com neon, e o JPEG suja
       os degradês escuros com blocos. */
    try{ return cv.toDataURL('image/png'); }catch(_){ return ''; }
  }
  function arteBaixar(){
    var url=arteDataUrl();
    if(!url){ arteMsg('Não consegui gerar a imagem.','err'); return; }
    try{
      var el=document.createElement('a'); el.href=url; el.download=arteNomeArquivo();
      document.body.appendChild(el); el.click();
      setTimeout(function(){ try{ el.remove(); }catch(_){ } },400);
      arteMsg('Arte baixada.','ok');
    }catch(_){ arteMsg('Não consegui baixar.','err'); }
  }
  async function arteCompartilhar(){
    var url=arteDataUrl();
    if(!url){ arteMsg('Não consegui gerar a imagem.','err'); return; }
    /* 🔑 quem compartilha continua sendo a MESMA função do card de venda —
       o "Salvar Imagens" do iPhone mora lá, e duplicar isso aqui seria criar
       o segundo dono de um comportamento que já é chato o suficiente com um */
    try{ await cardCompartilhar(url); }catch(_){ arteMsg('Não consegui compartilhar.','err'); }
  }

/* ╔═══ src/app/16-minha-loja.js ══════════════════════════════════════════ */
  /* ================= MINHA LOJA (Cadastro da loja / CNPJ) ================= */
  var _lojaRec=null, _lojaLogoUrl='', _ljCnhUrl='', _ljCnhDados=null, _ljCnhLendo=false, _docLoja=null, _docRep=null, _docClienteId=null;
  function _dlUrl(u){ u=String(u||''); if(!u) return u; return u+(/\?/.test(u)?'&':'?')+'download'; }
  /* ---- pdf.js sob demanda: só carrega quando precisa desenhar a miniatura de um PDF ---- */
  var _pdfjsProm=null, _pdfThumbCache={};
  function _pdfjsLoad(){
    if(window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if(_pdfjsProm) return _pdfjsProm;
    _pdfjsProm=new Promise(function(res,rej){
      var s=document.createElement('script');
      s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      s.onload=function(){ try{ window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'; res(window.pdfjsLib); }catch(e){ rej(e); } };
      s.onerror=function(){ _pdfjsProm=null; rej(new Error('pdfjs')); };
      document.head.appendChild(s);
    });
    return _pdfjsProm;
  }
  /* desenha a 1ª página do PDF numa imagem (miniatura de verdade, em vez do ícone 📄) */
  function _pdfMiniatura(url){
    if(_pdfThumbCache[url]) return Promise.resolve(_pdfThumbCache[url]);
    return _pdfjsLoad()
      .then(function(lib){ return lib.getDocument({url:url}).promise; })
      .then(function(doc){ return doc.getPage(1); })
      .then(function(pg){
        var vp=pg.getViewport({scale:1}); var sc=Math.min(2, 220/vp.width); vp=pg.getViewport({scale:sc});
        var cv=document.createElement('canvas'); cv.width=Math.round(vp.width); cv.height=Math.round(vp.height);
        return pg.render({canvasContext:cv.getContext('2d'),viewport:vp}).promise.then(function(){
          var u=cv.toDataURL('image/jpeg',0.82); _pdfThumbCache[url]=u; return u;
        });
      });
  }
  /* visor embutido: resolve a URL temporária e abre o documento dentro do app */
  async function _ljVerDoc(ref,nome){
    var url='';
    try{ url=await _arqPrivadoUrl(ref); }catch(_){ toast('Não consegui abrir o documento.'); return; }
    if(!url) return;
    var ehPdf=/\.pdf($|\?|#)/i.test(String(ref||''))||/pdf/i.test(String(nome||''));
    var ov=document.createElement('div'); ov.className='docview-bg';
    ov.innerHTML='<div class="docview"><div class="docview-top"><span>Documento anexado</span><div>'+
      '<button type="button" class="docview-b" id="dvBaixar">Baixar</button>'+
      '<button type="button" class="docview-b x" id="dvX">Fechar</button></div></div>'+
      (ehPdf?('<iframe class="docview-fr" src="'+esc(url)+'#toolbar=0" title="Documento"></iframe>')
            :('<div class="docview-imgwrap"><img class="docview-img" src="'+esc(url)+'" alt="Documento"></div>'))+
      '</div>';
    document.body.appendChild(ov);
    ov.querySelector('#dvX').onclick=function(){ ov.remove(); };
    ov.querySelector('#dvBaixar').onclick=function(){ _arqPrivadoBaixar(ref,nome||'documento'); };
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
  function ljCnhRender(){
    var w=$('ljCnhWrap'); if(!w) return;
    if(_ljCnhUrl){
      var ehPdf=/\.pdf($|\?|#)/i.test(_ljCnhUrl);
      var privado=_arqPrivadoEh(_ljCnhUrl);
      var icoDoc='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h6"/></svg>';
      var _thumb=(ehPdf||privado)
        ? '<span class="lj-cnh-ic" id="ljCnhDocTh" title="Ver documento">'+icoDoc+'</span>'
        : ('<img class="lj-cnh-thumb" id="ljCnhImgTh" src="'+esc(_ljCnhUrl)+'" alt="CNH" title="Ver documento">');
      /* miniatura da CNH com nome / CPF / RG lidos pela IA (Claude) */
      var d=_ljCnhDados||{};
      var linhas = _ljCnhLendo
        ? '<div class="lj-cnh-ocr lendo"><span class="mini-spin"></span> Lendo a CNH com IA…</div>'
        : ((d.nome||d.cpf||d.rg) ? ('<div class="lj-cnh-ocr">'+
            (d.nome?'<div><span>Nome</span><b>'+esc(d.nome)+'</b></div>':'')+
            (d.cpf?'<div><span>CPF</span><b>'+esc(d.cpf)+(d.suspeito?' <span style="color:#dc2626;font-weight:800">⚠ confira</span>':'')+'</b></div>':'')+
            (d.rg?'<div><span>RG</span><b>'+esc(d.rg)+'</b></div>':'')+
          '</div>') : '');
      w.innerHTML='<div class="lj-cnh-card">'+_thumb+'<div class="lj-cnh-mid"><span class="lj-cnh-nm">CNH anexada</span>'+
        '<div class="lj-cnh-acts"><button type="button" class="lj-cnh-b ver" id="ljCnhVer">Ver</button>'+
        '<button type="button" class="lj-cnh-b" id="ljCnhBaixar">Baixar</button>'+
        '<button type="button" class="lj-cnh-b rm" id="ljCnhRm">Remover</button></div></div></div>'+
        linhas+
        '<button type="button" class="cad-btn sec" id="ljCnhTrocar" style="margin-top:8px">Trocar CNH</button>';
      var rm=$('ljCnhRm'); if(rm) rm.onclick=async function(){
        var antiga=_ljCnhUrl, dadosAntigos=_ljCnhDados;
        _ljCnhUrl=''; _ljCnhDados=null; ljCnhRender();
        var salvou=false;
        try{ salvou=await lojaSalvarAuto(); }catch(_){ salvou=false; }
        if(!salvou){
          _ljCnhUrl=antiga; _ljCnhDados=dadosAntigos; ljCnhRender();
          toast('Não consegui salvar a remoção da CNH. O documento foi mantido.');
          return;
        }
        try{ await _arqPrivadoApagar(antiga); }catch(_){}
        toast('CNH removida.');
      };
      var tr=$('ljCnhTrocar'); if(tr) tr.onclick=function(){ var i=$('ljCnhInput'); if(i) i.click(); };
      var vv=$('ljCnhVer'); if(vv) vv.onclick=function(){ _ljVerDoc(_ljCnhUrl,'CNH'+(ehPdf?'.pdf':'.jpg')); };
      var db=$('ljCnhBaixar'); if(db) db.onclick=function(){ _arqPrivadoBaixar(_ljCnhUrl,'CNH'+(ehPdf?'.pdf':'.jpg')); };
      var it=$('ljCnhImgTh'); if(it) it.onclick=function(){ _ljVerDoc(_ljCnhUrl,'CNH.jpg'); };
      var docTh=$('ljCnhDocTh'); if(docTh) docTh.onclick=function(){ _ljVerDoc(_ljCnhUrl,'CNH'+(ehPdf?'.pdf':'.jpg')); };
      /* A miniatura privada só recebe um endereço assinado temporário. */
      if(ehPdf||privado){ (function(ref,pdf){
        _arqPrivadoUrl(ref).then(function(url){
          return pdf?_pdfMiniatura(url):url;
        }).then(function(u){
          var ph=$('ljCnhDocTh'); if(!ph || _ljCnhUrl!==ref) return;
          var img=document.createElement('img'); img.className='lj-cnh-thumb'; img.src=u; img.alt='CNH'; img.title='Ver documento';
          img.onclick=function(){ _ljVerDoc(ref,'CNH'+(pdf?'.pdf':'.jpg')); };
          ph.parentNode.replaceChild(img,ph);
        })['catch'](function(){});
      })(_ljCnhUrl,ehPdf); }
    } else {
      w.innerHTML='<button type="button" class="cad-btn sec" id="ljCnhBtn" style="margin:0">📎 Anexar</button>';
      var b=$('ljCnhBtn'); if(b) b.onclick=function(){ var i=$('ljCnhInput'); if(i) i.click(); };
    }
  }
  /* prepara a imagem/pdf pra IA (reduz imagem grande; pdf vai como está) */
  function _ljPrepArq(file){
    return new Promise(function(resolve,reject){
      var isImg=/^image\//.test(file.type||'');
      if(!isImg){ var fr=new FileReader(); fr.onload=function(){ var s=String(fr.result||''); resolve({ base64:(s.split(',')[1]||''), mimeType:(file.type||'application/pdf') }); }; fr.onerror=reject; fr.readAsDataURL(file); return; }
      var img=new Image(), url=URL.createObjectURL(file);
      /* resolução MAIOR + qualidade maior = a IA enxerga os dígitos pequenos da CNH */
      img.onload=function(){ try{ var max=2200, w=img.width, h=img.height, sc=Math.min(1,max/Math.max(w,h)); var cw=Math.max(1,Math.round(w*sc)), ch=Math.max(1,Math.round(h*sc)); var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch; cv.getContext('2d').drawImage(img,0,0,cw,ch); var durl=cv.toDataURL('image/jpeg',0.85); URL.revokeObjectURL(url); resolve({ base64:(durl.split(',')[1]||''), mimeType:'image/jpeg' }); }catch(e){ URL.revokeObjectURL(url); reject(e); } };
      img.onerror=function(){ URL.revokeObjectURL(url); reject(new Error('img')); };
      img.src=url;
    });
  }
  /* lê a CNH com IA (Claude) — mesmo endpoint da tela de documentos */
  async function _ljCnhOcr(file){
    try{
      var prep=await _ljPrepArq(file);
      var r=await fetch('/api/ia-extrair-proposta',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ token:token, imagemBase64:prep.base64, mimeType:prep.mimeType, tipo:'cnh' }) });
      var d=null; try{ d=await r.json(); }catch(_){}
      if(d&&d.saldo!=null) setSaldo(d.saldo);
      if(r.ok && d && d.ok && d.dados) return d.dados;
    }catch(_){}
    return null;
  }
  async function ljCnhUp(file){
    if(!file) return; toast('Enviando CNH...');
    var antiga=_ljCnhUrl, dadosAntigos=_ljCnhDados;
    try{
      var url=await arqUpload(file,'cnh');
      /* v368: antes, arquivo recusado saía em silêncio (o `if(url)` sem `else`).
         Agora avisa. */
      if(!url){ toast('Não recebi o arquivo de volta. Tente de novo.'); return; }
      if(url){
        _ljCnhUrl=url; _ljCnhDados=null; ljCnhRender();
        var salvou=false;
        try{ salvou=await lojaSalvarAuto(); }catch(_){ salvou=false; }
        if(!salvou){
          _ljCnhUrl=antiga; _ljCnhDados=dadosAntigos; ljCnhRender();
          try{ await _arqPrivadoApagar(url); }catch(_){}
          toast('Não consegui salvar a nova CNH. O documento anterior foi mantido.');
          return;
        }
        if(antiga&&antiga!==url){ try{ await _arqPrivadoApagar(antiga); }catch(_){} }
        toast('CNH anexada e salva.');
      }
    }
    /* v368: mostra o MOTIVO em vez de "Falha ao enviar a CNH.". A mensagem de
       verdade já existia (vem do preparo do arquivo ou do servidor: formato
       recusado, arquivo acima de 4 MB, sessão vencida...) e estava sendo
       jogada fora aqui — quem usava só via "falha" e não sabia o que corrigir. */
    catch(e){ toast(String((e&&e.message)||'').trim() || 'Falha ao enviar a CNH.'); return; }
    /* leitura por IA (Claude) — preenche CPF/RG vazios e mostra o resumo */
    _ljCnhLendo=true; ljCnhRender();
    var dados=await _ljCnhOcr(file);
    _ljCnhLendo=false;
    if(dados){
      _ljCnhDados={ nome:String(dados.nome||'').toUpperCase().trim(), cpf:(typeof _fmtCpf==='function'?_fmtCpf(String(dados.cpf||'')):String(dados.cpf||'')).trim(), rg:[dados.rg,dados.rg_orgao_emissor].filter(Boolean).join(' ').trim(), suspeito:!!dados.cpf_suspeito };
      var pc=$('ljProcCpf'); if(pc && !pc.value && _ljCnhDados.cpf) pc.value=_ljCnhDados.cpf;
      var pr=$('ljProcRg'); if(pr && !pr.value && _ljCnhDados.rg) pr.value=_ljCnhDados.rg;
      toast(_ljCnhDados.suspeito?'CNH lida — mas CONFIRA o CPF (a leitura pode ter falhado).':'CNH lida pela IA ✓ confira os dados.');
      try{ if(typeof ljAgendaSalvar==='function') ljAgendaSalvar(); }catch(_){}
    } else { toast('Não consegui ler a CNH automaticamente — preencha à mão.'); }
    try{ if(typeof ljAgendaSalvar==='function') ljAgendaSalvar(); }catch(_){}
    ljCnhRender();
  }
  var LJ_CEP_IDS={cep:'ljCep',rua:'ljRua',bairro:'ljBairro',cidade:'ljCidade',uf:'ljUf',num:'ljNum'};
  function cnpjFmt(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,14); var o=d;
    if(d.length>2)o=d.slice(0,2)+'.'+d.slice(2);
    if(d.length>5)o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5);
    if(d.length>8)o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5,8)+'/'+d.slice(8);
    if(d.length>12)o=d.slice(0,2)+'.'+d.slice(2,5)+'.'+d.slice(5,8)+'/'+d.slice(8,12)+'-'+d.slice(12);
    return o; }
  function codConvite(){ var s='ABCDEFGHJKLMNPQRSTUVWXYZ23456789', o=''; for(var i=0;i<6;i++) o+=s.charAt(Math.floor(Math.random()*s.length)); return o; }
  async function telaLoja(aba){
    /* Compatibilidade com atalhos antigos que ainda abrem Minha loja na aba
       "estoque": direciona para a nova tela principal sem duplicar o menu. */
    if(String(aba||'')==='estoque') return await telaEstoque();
    /* v336: os quatro destinos de gestão de vendas mudaram de endereço —
       agora são abas da página Vendas. Link antigo não morre: desvia. */
    if({cotacoes:1,fechadas:1,resultado:1,comissoes:1}[String(aba||'')]) return await telaVendas(String(aba));
    mevTabSet(''); _lojaLogoUrl='';
    /* v211 — "Histórico" deixou de ser uma aba. Links antigos que ainda
       apontarem para ela voltam para Catálogo, imediatamente acima dos quatro
       destinos de gestão que agora vivem no próprio menu de Minha loja. */
    _ljTab=String(aba||'dados');
    if(_ljTab==='historico') _ljTab='catalogo';
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg cad-float lj-pagina"><h2>Minha loja</h2><p class="cad-conta-sub">Gerencie os dados e a equipe</p><div id="ljWrap">'+pgLoad('Abrindo a sua loja…')+'</div></div>';   /* v424: anel da abertura */
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    document.body.classList.add('loja-on');   /* v756: dock compacto + padding inferior (mevTabSet/voltarHome tiram) */
    try{ consultaUiDockMedir(); }catch(_){}
    var lojas=null; try{ var r=await withTimeout(supa.from('loja').select('*'),10000); lojas=(r&&r.data)||[]; }catch(e){ lojas=null; }
    if(lojas===null){ var w=$('ljWrap'); if(w){ w.innerHTML='<div class="cli-empty" style="padding:16px"><b>Não consegui carregar agora</b>Verifique a internet e tente de novo.</div><button type="button" class="cad-btn sec" id="ljRetry" style="margin-top:10px">Tentar de novo</button>'; var rb=$('ljRetry'); if(rb) rb.onclick=telaLoja; } return; }
    var minha=lojas.filter(function(l){return String(l.user_id)===String(meuId);})[0]||null;
    var membro=lojas.filter(function(l){return String(l.user_id)!==String(meuId);})[0]||null;
    if(minha){ _lojaRec=minha; ljRenderDono(minha); mevSalvarLoja(false); }
    else if(membro){ _lojaRec=membro; ljRenderMembro(membro); mevSalvarLoja(false); }
    else { _lojaRec=null; ljRenderCriar(); mevSalvarLoja(false); }
  }
  var _ljTab='dados';
  /* ===== v756 — MINHA LOJA, FASE 1 (base visual e dock) ====================
     docs/PROJETO-2026-08-29-redesign-minha-loja.txt
     A MESMA tela (IDs, autosave, equipe, procurador, prova social), com:
     body.loja-on (dock compacto + padding), abas reais (tablist/tab/tabpanel,
     setas/Home/End, anúncio), cabeçalho padrão de cada área (cad-area-head)
     com status de salvamento (cad-save-status) e abertura por rota
     telaLoja('usuarios'). Dono: Dados · Procurador · Usuários · Sobre nós.
     Membro: Loja · Catálogo. O Catálogo do dono continua como painel
     escondido (links antigos), não como aba. */
  var LJ_ABAS={ dados:['Dados','Informações usadas nos documentos e nas páginas da loja.'],
                procurador:['Procurador','Defina quem representa a loja e assina as procurações.'],
                usuarios:['Usuários','Gerencie equipe, acessos, convites e indicadores.'],
                sobre:['Sobre nós','Apresente a loja e escolha o que aparece no catálogo público.'],
                catalogo:['Catálogo','Link, compartilhamento e o que a loja mostra ao público.'],
                loja:['Sua loja','O vínculo da sua conta com a equipe desta loja.'] };
  function ljAreaHead(k){
    var a=LJ_ABAS[k]||[k,''];
    return '<div class="cad-area-head lj-area-head"><div class="cad-area-tx"><h3 class="cad-area-t" id="ljPanelT-'+k+'">'+esc(a[0])+'</h3>'+(a[1]?('<p class="cad-area-d">'+esc(a[1])+'</p>'):'')+'</div>'
      +'<div class="cad-save-status" id="ljStatus-'+k+'" role="status" aria-live="polite"></div></div>';
  }
  function ljPainelAbre(k, extra){ return '<div class="vpx-panel" data-panel="'+k+'" id="ljPanel-'+k+'" role="tabpanel" aria-labelledby="ljTab-'+k+'"'+(extra||'')+' hidden>'+ljAreaHead(k); }
  function ljTabHtml(k, nome, ico){ return '<button type="button" class="vpx-st" role="tab" id="ljTab-'+k+'" aria-controls="ljPanel-'+k+'" aria-selected="false" tabindex="-1" data-step="'+k+'"><span class="vpx-ico" aria-hidden="true">'+ico+'</span><span class="vpx-nm">'+esc(nome)+'</span></button>'; }
  function ljTabAplica(anunciar){
    Array.prototype.forEach.call(document.querySelectorAll('#ljBody .vpx-panel'),function(pn){
      var on=pn.getAttribute('data-panel')===_ljTab; pn.classList.toggle('on', on);
      if(on){ pn.removeAttribute('hidden'); pn.classList.remove('lj-panel-entra'); void pn.offsetWidth; pn.classList.add('lj-panel-entra'); } else pn.setAttribute('hidden','');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#ljTabs .vpx-st'),function(b){
      var on=b.getAttribute('data-step')===_ljTab; b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on?'true':'false'); b.setAttribute('tabindex', on?'0':'-1');
      if(on){ try{ _tabCentra(b.parentNode, b); }catch(_){} }
    });
    if(anunciar){ try{ var lv=$('ljTabLive'); var a=LJ_ABAS[_ljTab]; if(lv&&a){ lv.textContent=''; setTimeout(function(){ lv.textContent=a[0]; },30); } }catch(_){} }
  }
  function ljAbaIr(k, foco){
    if(ljGestaoAbrir(k)) return;
    _ljTab=k; ljTabAplica(true); mevSalvarLoja(false);
    if(foco){ try{ var b=document.querySelector('#ljTabs .vpx-st[data-step="'+k+'"]'); if(b) b.focus(); }catch(_){} }
  }
  function ljTabsTeclado(e){
    var keys=['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End']; if(keys.indexOf(e.key)<0) return;
    var bts=Array.prototype.slice.call(document.querySelectorAll('#ljTabs .vpx-st')); if(!bts.length) return;
    var i=bts.indexOf(document.activeElement); if(i<0) i=bts.findIndex(function(b){ return b.classList.contains('on'); }); if(i<0) i=0;
    var n=bts.length, j=i;
    if(e.key==='ArrowRight'||e.key==='ArrowDown') j=(i+1)%n; else if(e.key==='ArrowLeft'||e.key==='ArrowUp') j=(i-1+n)%n;
    else if(e.key==='Home') j=0; else if(e.key==='End') j=n-1;
    e.preventDefault(); ljAbaIr(bts[j].getAttribute('data-step'), true);
  }
  function ljTabsLigar(){
    Array.prototype.forEach.call(document.querySelectorAll('#ljTabs .vpx-st'),function(b){ b.onclick=function(){ ljAbaIr(b.getAttribute('data-step'), false); }; });
    var tl=$('ljTabs'); if(tl) tl.addEventListener('keydown', ljTabsTeclado);
  }
  /* status de salvamento da linha da loja: um só por vez, na área do campo que mudou */
  var _ljStatusAba='dados', _ljTentado='';
  function _ljAbaDoCampo(el){ try{ var p=el&&el.closest?el.closest('.vpx-panel'):null; return p?p.getAttribute('data-panel'):''; }catch(_){ return ''; } }
  function ljStatusSet(estado, texto, tentar){
    Object.keys(LJ_ABAS).forEach(function(k){ if(k!==_ljStatusAba){ var o=$('ljStatus-'+k); if(o&&o.className.indexOf('is-')>0) cadStatusPinta(o,'neutro'); } });
    cadStatusPinta($('ljStatus-'+_ljStatusAba), estado, texto, tentar);
  }
  function ljRenderDono(l){
    var _LJ_ICO={
      dados:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h1"/><path d="M14 9h1"/><path d="M9 13h1"/><path d="M14 13h1"/><path d="M10 21v-4h4v4"/></svg>',
      procurador:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="8.5" cy="11" r="2.5"/><path d="M4.7 18a4 4 0 0 1 7.6 0"/><line x1="14.5" y1="9.5" x2="19.5" y2="9.5"/><line x1="14.5" y1="13.5" x2="19.5" y2="13.5"/></svg>',
      usuarios:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      catalogo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>',
      cotacoes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 2h9a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"/><line x1="4" y1="6" x2="4" y2="18"/><line x1="11" y1="7" x2="16" y2="7"/><line x1="11" y1="11" x2="16" y2="11"/><line x1="11" y1="15" x2="14" y2="15"/></svg>',
      fechadas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
      resultado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="3" y1="20" x2="21" y2="20"/></svg>',
      comissoes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
    };
    _LJ_ICO.sobre=PS_ICO;   /* v352 — ícone vem do 16c-prova-social.js */
    var _tabs=[
      ['dados','Dados'],
      ['procurador','Procurador'],
      ['usuarios','Usuários'],
      /* v352 (pedido) — "Sobre nós": texto da loja, fotos da loja, fotos de
         entrega e prints de depoimento. É o que sai no catálogo público, no
         bloco de prova social. O painel é montado pelo 16c-prova-social.js. */
      ['sobre','Sobre nós'],
      /* v301 (pedido) — o Catálogo saiu do menu da Minha loja. O painel
         continua existindo (ljPanelCatHtml), então nada foi apagado: quem
         chegar por link direto ou por um botão antigo ainda cai nele. Só o
         atalho no menu deixou de aparecer. */
      /* v336 (pedido) — "Cotações salvas", "Vendas fechadas", "Resultado" e
         "Comissões" SAÍRAM daqui. Elas agora são as abas da página VENDAS,
         que está no menu principal logo abaixo do Estoque. Minha loja voltou
         a falar só de cadastro (dados, procurador e usuários).
         Nada foi apagado: as telas continuam as mesmas e quem chegar por um
         link antigo (telaLoja('cotacoes')) é levado direto pra aba certa da
         página Vendas — veja o desvio no começo da telaLoja. */
    ];
    var _nav=_tabs.map(function(t){ return ljTabHtml(t[0], t[1], _LJ_ICO[t[0]]); }).join('');
    document.body.classList.add('venda-cot');
    if(!LJ_ABAS[_ljTab]||_ljTab==='loja') _ljTab='dados';
    /* v756: abas reais (tablist "Seções da Minha loja") e cabeçalho padrão em cada painel;
       as dicas .lj-hint viraram a descrição do cabeçalho (sem repetir) */
    $('ljWrap').innerHTML='<div class="vpx"><div class="vpx-steps vpx-mdr" id="ljTabs" role="tablist" aria-label="Seções da Minha loja">'+_nav+'</div><div class="vpx-body cad-float" id="ljBody"><div id="ljTabLive" class="sr-only" aria-live="polite"></div>'+
      ljPainelAbre('dados')+'<p class="lj-hint">Informe o CNPJ que eu busco o resto pra você.</p>'+ljPanelDadosHtml(l)+'</div>'+
      ljPainelAbre('procurador')+ljPanelProcHtml(l)+'</div>'+
      ljPainelAbre('usuarios')+ljEquipeHtml(l)+'</div>'+
      ljPainelAbre('catalogo')+ljPanelCatHtml(l)+'</div>'+
      ljPainelAbre('sobre')+'<div id="ljPsBox">'+psPainelHtml('lj','loja',l&&l.prova_social)+'</div></div>'+
      '<div class="cad-msg" id="ljMsg"></div><div class="cad-autosave vazio" id="ljAutosave"></div>'+
      '</div></div>';
    ljTabAplica(false);
    ljTabsLigar();
    lojaWireForm();
    var cop=$('ljCopCod'); if(cop) cop.onclick=function(){ try{ navigator.clipboard.writeText((l.codigo_convite||'')); toast('Código copiado.'); }catch(_){ prompt('Código:',l.codigo_convite||''); } };
    var nc=$('ljNovoCod'); if(nc) nc.onclick=function(){ ljRegenerarCod(l); };
    var ci=$('ljCopInd'); if(ci) ci.onclick=function(){ if(!l.codigo_indicador){ toast('Gere o código de indicador primeiro.'); return; } try{ navigator.clipboard.writeText(l.codigo_indicador||''); toast('Código de indicador copiado.'); }catch(_){ prompt('Código:',l.codigo_indicador||''); } };
    var ni=$('ljNovoInd'); if(ni) ni.onclick=function(){ ljRegenerarInd(l); };
    /* v457 — convidar indicador pelo e-mail (RPC acha a conta; o convite
       aparece no sino de notificacoes da pessoa com o botao Aceitar) */
    var cv=$('ljIndConvidar'); if(cv) cv.onclick=async function(){
      var em=($('ljIndMail')&&$('ljIndMail').value||'').trim().toLowerCase();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)){ toast('Digite o e-mail de quem vai divulgar.'); return; }
      cv.disabled=true;
      try{
        var r=await supa.rpc('indicador_convidar',{p_email:em});
        var d=(r&&r.data)||{}; if(typeof d==='string'){ try{ d=JSON.parse(d); }catch(_){ d={}; } }
        if(d.ok){ toast(d.repetido?'O convite já está lá, esperando a resposta.':'Convite enviado — aparece no sino de notificações de '+em+'.'); if($('ljIndMail')) $('ljIndMail').value=''; }
        else if(d.erro==='nao_encontrado') toast('Não achei conta com esse e-mail. A pessoa precisa criar a conta grátis primeiro.');
        else if(d.erro==='ja_indicador') toast('Essa pessoa já divulga a sua loja.');
        else if(d.erro==='e_voce') toast('Esse e-mail é o seu.');
        else toast('Não consegui enviar o convite agora.');
        /* o codigo pode ter sido gerado pela RPC — repinta o campo */
        if(d.ok && !l.codigo_indicador){ try{ var rl=await supa.from('loja').select('codigo_indicador').eq('id',l.id).single(); if(rl&&rl.data&&rl.data.codigo_indicador){ l.codigo_indicador=rl.data.codigo_indicador; if(_lojaRec) _lojaRec.codigo_indicador=l.codigo_indicador; var c=$('ljCodInd'); if(c) c.textContent=l.codigo_indicador; var nb=$('ljNovoInd'); if(nb) nb.textContent='gerar novo'; } }catch(_){} }
      }catch(_){ toast('Não consegui enviar o convite agora.'); }
      cv.disabled=false;
    };
    ljIndicPinta(l);
    ljMembrosPinta(l);
    ljPedidosPinta(l);
    ljProcuradorPinta(l);
    ljCatWire(l);
    psWire('lj','loja',ljAgendaSalvar);   /* v352 — aba "Sobre nós" */
  }
  function ljGestaoAbrir(id){
    var mapa={ cotacoes:telaCotacoes, fechadas:telaVendasFechadas, resultado:telaResultado, comissoes:telaComissoes };
    if(!mapa[id]) return false;
    /* v243: o conteudo abre AO LADO do menu (num painel, igual as outras
       abas) em vez de trocar de tela. Se o painel nao existir, cria. */
    var body=$('ljBody');
    if(body){
      var pn=body.querySelector('.vpx-panel[data-panel="'+id+'"]');
      if(!pn){ pn=document.createElement('div'); pn.className='vpx-panel'; pn.setAttribute('data-panel',id); body.insertBefore(pn, body.firstChild); }
      _ljTab=id; ljTabAplica();
      try{ mapa[id](pn); return true; }catch(_){ }
    }
    mapa[id]();   /* plano B: tela cheia, como era antes */
    return true;
  }
  function ljVoltarDaGestao(){
    var aba={dados:1,procurador:1,usuarios:1,catalogo:1}[_ljTab]?_ljTab:'catalogo';
    telaLoja(aba);
  }
  /* ===================== v187 — LINK CURTO POR NOME FANTASIA =================
     ANTES o link do catálogo era:   mevveiculos.com.br/catalogo/1b0ce2c8-9597-...
     AGORA também funciona:          mevveiculos.com.br/santaluziaveiculos

     O QUE TEM POR TRÁS: aquele pedacinho ("santaluziaveiculos") é o APELIDO da
     loja. Ele é criado sozinho a partir do NOME FANTASIA — o banco tira os
     acentos, os espaços e a pontuação e deixa tudo em minúsculo. O apelido
     fica guardado na loja (coluna slug) e o site troca apelido -> loja quando
     alguém abre o endereço.
     Os links ANTIGOS continuam funcionando pra sempre: nada do que você já
     mandou pros clientes deixa de abrir. ==================================== */
  function ljApelido(l){ return String(((l&&l.slug)||(_lojaRec&&_lojaRec.slug)||'')).trim(); }
  function ljLinks(l){
    var uid=(l&&l.user_id)||meuId||'', ap=ljApelido(l);
    if(ap) return { cat:location.origin+'/'+ap, rep:location.origin+'/'+ap+'/repasses', curto:true };
    return { cat:location.origin+'/catalogo/'+uid, rep:location.origin+'/repasses/'+uid, curto:false };
  }
  /* Cria (ou troca) o apelido no banco.
     Por padrão SÓ cria quando ainda não existe: se já existe, o link já foi
     compartilhado e mudar quebraria o que está na rua. Pra trocar de propósito
     existe o botão "alterar" ali na aba Catálogo (forcar = true).
     Se o apelido escolhido já for de outra loja, o banco devolve com um número
     no fim (santaluziaveiculos2) — ninguém fica sem link. */
  async function ljSlugGarante(l, texto, forcar){
    if(!l||!l.id) return '';
    if(l.slug && !forcar) return l.slug;
    var base=String(texto||l.nome_fantasia||l.razao_social||'').trim();
    if(!base) return '';
    try{
      var r=await supa.rpc('mp_loja_slug_livre',{p_txt:base, p_loja_id:l.id});
      if(r&&r.error) throw r.error;
      var novo=(r&&r.data)?String(r.data):'';
      if(!novo) return '';
      if(novo!==l.slug){
        var u=await supa.from('loja').update({slug:novo}).eq('id',l.id).select('id');
        if(u&&u.error) throw u.error;
        /* v483: UPDATE barrado pela RLS NÃO é erro no supabase-js — volta
           "sucesso" com ZERO linhas. Sem esta conferência o app gravava o
           apelido novo só na TELA, o vendedor copiava o link novo e mandava
           pro cliente — e o link não existia (o banco ficou com o antigo). */
        if(!u||!u.data||!u.data.length) throw new Error('Só o dono da loja pode alterar o endereço do site.');
      }
      l.slug=novo; if(_lojaRec) _lojaRec.slug=novo;
      return novo;
    }catch(e){
      try{ if(e&&e.message&&String(e.message).indexOf('dono')>=0) toast(e.message); }catch(_){}
      return '';
    }
  }
  /* redesenha só o painel do Catálogo (usado depois de criar/trocar o apelido) */
  function ljCatRepinta(l){
    var p=document.querySelector('#ljBody .vpx-panel[data-panel="catalogo"]');
    if(!p) return;
    p.innerHTML=ljPanelCatHtml(l);
    ljCatWire(l);
  }
  /* Aba CATÁLOGO da Minha Loja: a mesma página que vai ao cliente aparece
     dentro do app. Assim estoque, preço, busca e ordenação têm uma fonte só. */
  /* ===== v469 — MEU SITE (painel que junta as pontas do site do lojista) =
     O endereço da vitrine pra pôr no Instagram/Google/cartão, com Copiar e
     Abrir; se a loja tem DOMÍNIO PRÓPRIO registrado (v468), mostra que o
     site também responde lá; se não tem, o convite pro upgrade cai no
     WhatsApp do MEV com a mensagem pronta. */
  /* ===== v482 — UM CARTÃO SÓ (pedido: "1 sim vira um só") =====
     Até a v481 esta aba tinha DOIS cartões — "Meu site" e "Catálogo da
     loja" — e os dois mostravam o MESMO L.cat, com quatro botões
     espalhados entre eles. Quem lia saía achando que tinha um site e um
     catálogo separados. Agora é um cartão: o endereço numa linha só, a
     fileira de ações embaixo e o preview logo abaixo, sem título próprio.
     O "Alterar endereço" voltou pra perto do endereço que ele altera.
     Os IDs são os MESMOS de antes, então nenhum handler mudou.
     (v480 preservado: o "Saiba mais" continua, agora como link no pé.) */
  function ljMeuSiteHtml(l, dono){
    var L=ljLinks(l);
    var end=String(L.cat||'').replace(/^https?:\/\//,'');
    var dom=String((l&&l.dominio_custom)||'').trim();
    /* v483: o VENDEDOR vê o cartão (precisa do link pra trabalhar), mas não
       vê o que o banco vai recusar — "Alterar endereço" e "Quero no meu
       domínio" ficam ESCONDIDOS (nunca removidos: display:none, regra da
       casa) e no lugar entra uma linha dizendo o porquê. Copiar, Abrir e
       Compartilhar FICAM — é o que ele manda pro cliente o dia inteiro. */
    var soDono=(dono===false)?' style="display:none"':'';
    return '<div class="lj-meusite">'+
      '<div class="lj-ms-hd"><b>Meu site</b><span class="lj-ms-n" id="ljCatN">—</span></div>'+
      /* v482: o endereço ocupa a linha inteira. Antes ele dividia a linha
         com o "Copiar" e sobrava 180px pra ele — por isso aparecia
         "mevveiculos.com.br/santalu…". É o dado mais importante da tela. */
      '<div class="lj-ms-end"><span id="ljMsEnd">'+esc(end)+'</span></div>'+
      '<div class="lj-ms-acoes">'+
        '<button type="button" class="cad-btn" id="ljCatShare">Compartilhar</button>'+
        '<button type="button" class="cad-btn sec" id="ljMsCopiar">Copiar</button>'+
        '<button type="button" class="cad-btn sec" id="ljMsAbrir">Abrir</button>'+
        '<button type="button" class="cad-btn sec" id="ljApelEd"'+soDono+'>Alterar endereço</button>'+
      '</div>'+
      ((dono===false)?'<div class="lj-ms-aviso">Só o dono da loja altera o endereço do site.</div>':'')+
      (dom
        ?('<div class="lj-ms-dom ok">Também responde em <b>'+esc(dom)+'</b></div>')
        :('<div class="lj-ms-doms">'+
          '<button type="button" class="lj-ms-domlink" id="ljMsDom"'+soDono+'>Quero no meu domínio ›</button>'+
          '<button type="button" class="lj-ms-domlink" id="ljMsSaiba">Saiba mais ›</button></div>'))+
      '</div>';
  }
  function ljMeuSiteWire(l){
    var L=ljLinks(l), b;
    if(b=$('ljMsCopiar')) b.onclick=function(){ try{ navigator.clipboard.writeText(L.cat); toast('Endereço copiado ✓'); }catch(_){ try{ prompt('Copie:',L.cat); }catch(__){} } };
    if(b=$('ljMsAbrir')) b.onclick=function(){ try{ window.open(L.cat,'_blank'); }catch(_){ location.href=L.cat; } };
    if(b=$('ljMsDom')) b.onclick=function(){
      /* v480: a mensagem já chega no MEV Atendimento com os dados que o
         fluxo de ativação pede — a IA só completa o que faltar. */
      var nome=(l&&(l.nome_fantasia||l.razao_social))||'minha loja';
      var msg='Olá! Sou lojista do MEV Veículos e quero ativar o site da minha loja no meu próprio domínio.\n'+
        'Loja: '+nome+'\n'+
        'Site atual no MEV: '+L.cat+'\n'+
        'Domínio que quero usar: (escreva aqui — ex.: minhaloja.com.br)\n'+
        'Pode me explicar como funciona a ativação?';
      var u='https://wa.me/5551996417433?text='+encodeURIComponent(msg);
      try{ window.open(u,'_blank'); }catch(_){ location.href=u; }
    };
    if(b=$('ljMsSaiba')) b.onclick=function(){
      /* v480: landing do site da loja (benefícios, plano, domínio próprio) */
      try{ window.open('/site-lojista.html','_blank'); }catch(_){ location.href='/site-lojista.html'; }
    };
  }
  function ljPanelCatHtml(l, dono){
    var L=ljLinks(l);
    /* v482: o preview perdeu o cabeçalho próprio ("Catálogo da loja" +
       Alterar/Compartilhar) e a frase explicativa — os botões subiram pro
       cartão de cima e o título era o mesmo assunto dito duas vezes.
       v483: `dono===false` esconde o que a RLS recusaria (ver ljMeuSiteHtml). */
    return ljMeuSiteHtml(l, dono)+
      '<div class="lj-cat-preview">'+
        '<div class="lj-cat-frame"><iframe id="ljCatFrame" src="'+esc(L.cat)+'" title="Catálogo da loja" loading="lazy"></iframe></div>'+
      '</div>';
  }
  function ljCatWire(l){
    try{ ljMeuSiteWire(l); }catch(_){}   /* v469 */
    var nomeLoja=(l&&(l.nome_fantasia||l.razao_social))||'nossa loja';
    var L=ljLinks(l);
    var urlCat=L.cat;
    function copia(u){ try{ navigator.clipboard.writeText(u); toast('Link copiado.'); }catch(_){ try{ prompt('Copie o link:',u); }catch(__){} } }
    function share(tit,txt,u){ if(navigator.share){ navigator.share({title:tit,text:txt,url:u})['catch'](function(err){ if(!(err&&err.name==='AbortError')) copia(u); }); } else copia(u); }
    var b;
    if(b=$('ljCatShare')) b.onclick=function(){ share('Catálogo — '+nomeLoja,'Confira os veículos disponíveis na '+nomeLoja+':',urlCat); };
    /* Contagem dos veículos que o cliente vê no catálogo. */
    (function(){
      try{ supa.from('estoque').select('id,status').then(function(r){ var n=(((r&&r.data)||[]).filter(function(x){ return x.status==='disponivel'; })).length; var e=$('ljCatN'); if(e) e.textContent=n?(n+' veículo'+(n>1?'s':'')+' no ar'):'Nenhum veículo disponível ainda'; },function(){}); }catch(_){}
    })();
    /* v187 — trocar o apelido de propósito */
    if(b=$('ljApelEd')) b.onclick=function(){
      var atual=ljApelido(l);
      var novo=prompt('Endereço curto da loja (só letras e números, sem espaço):\n\n'+location.host+'/', atual||'');
      if(novo==null) return;
      novo=String(novo).trim();
      if(!novo){ toast('Digite um nome pro endereço.'); return; }
      toast('Alterando o endereço…');
      ljSlugGarante(l, novo, true).then(function(sg){
        if(!sg){ toast('Não consegui alterar o endereço.'); return; }
        toast('Pronto: '+location.host+'/'+sg);
        ljCatRepinta(l);
      });
    };
    /* v187 — loja que ainda não tem apelido ganha um agora, a partir do nome
       fantasia. Acontece uma vez só e sem você precisar fazer nada. */
    if(!ljApelido(l)){ ljSlugGarante(l).then(function(sg){ if(sg) ljCatRepinta(l); }); }
  }
  /* preenche o seletor de procurador com os usuários da empresa (loja_membros) */
  async function ljProcuradorPinta(l){
    var sel=$('ljProcurador'); if(!sel||!l||!l.id) return;
    var membros=[]; try{ var r=await supa.from('loja_membros').select('*').eq('loja_id',l.id).order('criado_em',{ascending:true}); membros=(r&&r.data)||[]; }catch(e){}
    if(!membros.length){ sel.innerHTML='<option value="">Só você por enquanto</option>'; return; }
    sel.innerHTML='<option value="">— escolher —</option>'+membros.map(function(mb){
      var nome=mb.nome||mb.email||'Vendedor';
      var selAttr=(String(l.procurador_id||'')===String(mb.user_id))?' selected':'';
      var _fn=ljFuncaoNome(mb.funcao);
      return '<option value="'+esc(mb.user_id)+'" data-nome="'+esc(nome)+'"'+selAttr+'>'+esc(nome)+(_fn?(' — '+esc(_fn)):(mb.papel==='dono'?' (dono)':''))+'</option>';
    }).join('');
  }
  /* ==================== v187 — FUNÇÃO (CARGO) DO USUÁRIO ====================
     São DUAS coisas diferentes, e a gente não mistura:

       PAPEL  = o que a pessoa PODE FAZER no sistema. Só existem três:
                dono, gerente e vendedor. É isso que o banco usa pra liberar
                ou bloquear cada tela (é a "permissão").

       FUNÇÃO = o CARGO dela na loja: diretor, gerente comercial, procurador,
                administrativo... É informação, não é permissão. Serve pra
                você saber quem é quem e pra usar nos documentos.

     Por que separar? Porque se a gente enfiasse "diretor" dentro do papel, o
     banco não saberia mais o que essa pessoa pode abrir. Guardando em uma
     coluna própria (funcao), tudo que já funciona continua funcionando. ==== */
  var _LJ_FUNCOES=[
    ['administrativo','Administrativo'],
    ['diretor','Diretor'],
    ['gerente_comercial','Gerente comercial'],
    ['gerente_marketing','Gerente de marketing'],
    ['procurador','Procurador'],
    ['proprietario','Proprietário'],
    ['vendedor','Vendedor']
  ];
  function ljFuncaoNome(v){
    var k=String(v||'');
    for(var i=0;i<_LJ_FUNCOES.length;i++){ if(_LJ_FUNCOES[i][0]===k) return _LJ_FUNCOES[i][1]; }
    return '';
  }
  var _ljMembros=[];
  function ljEquipeHtml(l){
    return '<div class="cad-sec"><h3>Equipe da loja</h3>'+
      '<div class="lj-conv-hint">Compartilhe o código com seus vendedores. Eles entram em <b>Minha loja → Entrar numa loja</b> e passam a ver o mesmo estoque, clientes e vendas.</div>'+
      '<div class="lj-conv"><span>Código de convite</span><b id="ljCodigo">'+esc(l.codigo_convite||'—')+'</b><button type="button" id="ljCopCod">copiar</button><button type="button" id="ljNovoCod">gerar novo</button></div>'+
      '<div id="ljPedidos"></div>'+
      '<div id="ljMembros"><div class="cli-empty" style="padding:10px">Carregando equipe...</div></div></div>'+
      /* v324 — INDICADORES: parceiros que divulgam a loja por comissão. É OUTRO
         código (não o da equipe) e dá acesso só ao PÚBLICO — nunca ao interno
         (custo, repasse, preço mínimo). Vínculo na tabela mp_vendedor_loja. */
      '<div class="cad-sec"><h3>Indicadores (parceiros)</h3>'+
      '<div class="lj-conv-hint">Vendedores que <b>divulgam sua loja por comissão</b>, montando o catálogo deles com os seus carros. Eles enxergam só o que já é público — <b>nunca</b> custo, repasse ou preço mínimo. Passe o código abaixo (é diferente do código da equipe).</div>'+
      '<div class="lj-conv"><span>Código de indicador</span><b id="ljCodInd">'+esc(l.codigo_indicador||'—')+'</b><button type="button" id="ljCopInd">copiar</button><button type="button" id="ljNovoInd">'+(l.codigo_indicador?'gerar novo':'gerar código')+'</button></div>'+
      /* v457 — convite direto: cai no SINO da pessoa com o botao Aceitar */
      '<div class="lj-conv lj-conv-conv"><span>Convidar pelo e-mail</span><input class="cad-in" id="ljIndMail" placeholder="email@dequemvende.com" inputmode="email" autocapitalize="none"><button type="button" id="ljIndConvidar">convidar</button></div>'+
      '<div id="ljIndic"><div class="cli-empty" style="padding:10px">Carregando indicadores...</div></div></div>';
  }
  /* ================= v282 — PEDIDOS ESPERANDO O DONO =================
     Quem digita o CNPJ não entra: fica um pedido. Sem esta lista o pedido
     morreria no banco sem ninguém ver, e a pessoa esperaria pra sempre.
     Só o dono enxerga (a RLS da mp_loja_pedido já garante isso; aqui é só
     a tela). */
  async function ljPedidosPinta(l){
    var el=$('ljPedidos'); if(!el||!l||!l.id) return;
    var peds=[];
    try{ var r=await supa.from('loja_pedido').select('*').eq('loja_id',l.id).eq('situacao','pendente').order('criado_em',{ascending:true}); peds=(r&&r.data)||[]; }
    catch(e){ peds=[]; }
    if(!peds.length){ el.innerHTML=''; return; }
    el.innerHTML='<div class="lj-ped-tit">'+peds.length+' pedido'+(peds.length>1?'s':'')+' pra entrar na sua loja</div>'+
      '<div class="lj-ped-hint">Digitaram o CNPJ da loja. O CNPJ é público — por isso ninguém entra sem você deixar.</div>'+
      peds.map(function(p){ var nome=p.nome||p.email||'Sem nome';
        return '<div class="lj-ped" data-id="'+esc(p.id)+'">'+
          '<div class="lj-membro-av">'+esc(cliIni(nome))+'</div>'+
          '<div class="lj-membro-tx"><div class="lj-membro-nm">'+esc(nome)+'</div>'+
          (p.email?('<div class="lj-membro-sb">'+esc(p.email)+'</div>'):'')+'</div>'+
          '<button type="button" class="lj-ped-no" data-no="'+esc(p.id)+'">Recusar</button>'+
          '<button type="button" class="lj-ped-ok" data-ok="'+esc(p.id)+'">Aprovar</button>'+
          '</div>';
      }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('[data-ok]'),function(b){ b.onclick=function(){ ljPedidoDecidir(l, b.getAttribute('data-ok'), true, b); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-no]'),function(b){ b.onclick=function(){ ljPedidoDecidir(l, b.getAttribute('data-no'), false, b); }; });
  }
  async function ljPedidoDecidir(l, id, aprovar, btn){
    if(!aprovar && !confirm('Recusar este pedido? A pessoa não entra na loja.')) return;
    var linha=btn&&btn.parentNode;
    /* Trava os DOIS botões da linha: sem isso, um toque duplo mandaria duas
       decisões e a segunda encontraria o pedido já decidido. */
    if(linha){ Array.prototype.forEach.call(linha.querySelectorAll('button'),function(b){ b.disabled=true; }); }
    if(btn) btn.textContent=aprovar?'Aprovando...':'Recusando...';
    try{
      var r=await supa.rpc('pedido_decidir',{p_pedido:id, p_aprovar:!!aprovar});
      if(r&&r.error) throw r.error;
      var d=(r&&r.data)||{};
      if(!d.ok){
        var _m={ sem_sessao:'Entre na sua conta e tente de novo.', nao_encontrado:'Esse pedido não existe mais.', nao_e_dono:'Só o dono da loja pode decidir isso.' };
        toast(_m[d.erro]||'Não consegui decidir agora.');
        if(linha){ Array.prototype.forEach.call(linha.querySelectorAll('button'),function(b){ b.disabled=false; }); }
        if(btn) btn.textContent=aprovar?'Aprovar':'Recusar';
        return;
      }
      toast(aprovar?'Aprovado — já faz parte da equipe.':'Pedido recusado.');
      ljPedidosPinta(l); ljMembrosPinta(l);
    }catch(e){
      toast('Não consegui decidir agora.');
      if(linha){ Array.prototype.forEach.call(linha.querySelectorAll('button'),function(b){ b.disabled=false; }); }
      if(btn) btn.textContent=aprovar?'Aprovar':'Recusar';
    }
  }
  async function ljMembrosPinta(l){
    var el=$('ljMembros'); if(!el) return;
    var membros=[]; try{ var r=await supa.from('loja_membros').select('*').eq('loja_id',l.id).order('criado_em',{ascending:true}); membros=(r&&r.data)||[]; }catch(e){}
    if(!membros.length){ el.innerHTML='<div class="cli-empty" style="padding:10px;color:#94a3b8">Só você por enquanto. Passe o código pra sua equipe.</div>'; return; }
    /* AUTO-CONSERTO: se a MINHA linha está sem nome/e-mail (ou com o padrão "Vendedor"),
       preenche com o nome do meu cadastro — era por isso que aparecia "Vendedor" errado. */
    for(var i=0;i<membros.length;i++){ var m0=membros[i];
      if(String(m0.user_id)===String(meuId) && meuNome && (!m0.nome || m0.nome==='Vendedor' || !m0.email)){
        var fix={}; if(!m0.nome || m0.nome==='Vendedor') fix.nome=meuNome; if(!m0.email && meuEmail) fix.email=meuEmail;
        if(Object.keys(fix).length){ m0.nome=fix.nome||m0.nome; m0.email=fix.email||m0.email;
          try{ supa.from('loja_membros').update(fix).eq('id',m0.id).then(function(){},function(){}); }catch(_){}
        }
      }
    }
    /* v187: o cartão ficou limpo — foto, nome, e-mail e a FUNÇÃO. Tudo que
       era botão solto (lápis pra renomear, seletor de acesso, "remover")
       mudou pra dentro da janelinha que abre ao tocar no usuário. */
    _ljMembros=membros;
    el.innerHTML=membros.map(function(mb){ var dono=mb.papel==='dono'; var ger=mb.papel==='gerente'; var nome=mb.nome||mb.email||'Vendedor';
      var souEu=String(mb.user_id)===String(meuId);
      var fn=ljFuncaoNome(mb.funcao);
      var right=(dono?'<span class="lj-membro-badge dono">Dono</span>':(ger?'<span class="lj-membro-badge">Gerente</span>':''))+'<span class="lj-membro-go">&#8250;</span>';
      return '<div class="lj-membro lj-membro-click" data-id="'+esc(mb.id)+'" title="Tocar pra definir nome, função e acesso">'+
        '<div class="lj-membro-av'+(ger?' ger':'')+'">'+esc(cliIni(nome))+'</div>'+
        '<div class="lj-membro-tx">'+
          '<div class="lj-membro-nm">'+esc(nome)+(souEu?' <span class="lj-membro-eu">você</span>':'')+'</div>'+
          ((mb.telefone||mb.email)?('<div class="lj-membro-sb">'+esc([mb.telefone?foneFmt(mb.telefone):'',mb.email||''].filter(Boolean).join(' · '))+'</div>'):'')+
          '<div class="lj-membro-fn'+(fn?'':' vazio')+'">'+esc(fn||'definir função')+'</div>'+
        '</div>'+right+'</div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.lj-membro-click'),function(card){
      card.onclick=function(){ ljMembroAbrir(l, card.getAttribute('data-id')); };
    });
  }
  /* ---------- v200: usuário, remuneração e produção ----------
     Reaproveita o mesmo modal que já usamos na ficha do cliente, então o visual
     e o "fechar" já vêm prontos — não precisamos inventar nada novo. */
  function ljMembroAbrir(l, id){
    var mb=null;
    for(var i=0;i<_ljMembros.length;i++){ if(String(_ljMembros[i].id)===String(id)) mb=_ljMembros[i]; }
    if(!mb) return;
    var dono=(mb.papel==='dono');
    var souEu=String(mb.user_id)===String(meuId);
    var nome=mb.nome||mb.email||'Vendedor';
    var bg=cliModalEl(); bg.classList.add('on');
    var av=$('cliMav'); if(av) av.textContent=cliIni(nome);
    var tt=$('cliMt');  if(tt) tt.textContent=nome;
    var chips=_LJ_FUNCOES.map(function(f){
      return '<button type="button" class="lj-fn-chip'+((String(mb.funcao||'')===f[0])?' on':'')+'" data-fn="'+f[0]+'">'+esc(f[1])+'</button>';
    }).join('');
    $('cliMbody').innerHTML=
      '<div class="lj-usr-grid"><div><label class="cad-lbl">Nome</label>'+
      '<input class="cad-in" id="ljMbNome" value="'+esc(mb.nome||'')+'" placeholder="Nome do usuário"></div>'+
      '<div><label class="cad-lbl">Telefone / WhatsApp</label>'+
      '<input class="cad-in" id="ljMbTel" inputmode="tel" autocomplete="tel" value="'+esc(foneFmt(mb.telefone||''))+'" placeholder="(00) 00000-0000"></div></div>'+
      '<label class="cad-lbl lj-usr-top">Função na loja</label>'+
      '<div class="lj-fn-chips" id="ljMbFn">'+chips+'</div>'+
      '<div class="lj-fn-hint">A função é o cargo da pessoa. Ela aparece na lista da equipe e serve pros documentos — não muda o que ela consegue abrir no sistema. Tocar de novo na mesma função tira a marcação.</div>'+
      '<div class="lj-rem-box"><div class="cad-sec-tit">Remuneração</div>'+
        '<label class="cad-lbl">Salário fixo (mensal)</label>'+
        '<input class="cad-in" id="ljMbSal" inputmode="decimal" value="'+esc(mb.salario_fixo==null?'':String(mb.salario_fixo).replace('.',','))+'" placeholder="R$ 0,00">'+
        '<label class="cad-lbl lj-usr-top">Comissão deste usuário</label>'+
        '<div class="lj-fn-chips" id="ljMbCom">'+_COM_TIPOS.map(function(t){
          return '<button type="button" class="lj-fn-chip'+((String(mb.com_tipo||'')===t[0])?' on':'')+'" data-ct="'+t[0]+'">'+esc(t[1])+'</button>';
        }).join('')+'</div>'+
        '<div id="ljMbComVal"'+(mb.com_tipo?'':' style="display:none"')+'>'+
          '<div class="ec-row"><label id="ljMbComLb">'+esc(_comRotulo(mb.com_tipo))+'</label>'+
          '<input class="cad-in" id="ljMbComN" inputmode="decimal" value="'+esc(mb.com_valor==null?'':String(mb.com_valor).replace('.',','))+'" placeholder="0"></div>'+
        '</div>'+
        '<div class="lj-fn-hint">A comissão é calculada por carro: percentual do lucro, percentual da venda ou valor fixo.</div>'+
        '<div class="lj-rem-grid"><div><label class="cad-lbl">Ativa ao atingir (vendas)</label>'+
          '<input class="cad-in" id="ljMbGatQtd" inputmode="numeric" value="'+esc(mb.gatilho_qtd==null?'':mb.gatilho_qtd)+'" placeholder="Ex.: 10"></div>'+
          '<div><label class="cad-lbl">Bônus por carro (R$)</label>'+
          '<input class="cad-in" id="ljMbGatVal" inputmode="decimal" value="'+esc(mb.gatilho_valor==null?'':String(mb.gatilho_valor).replace('.',','))+'" placeholder="R$ 0,00"></div></div>'+
        '<div class="lj-fn-hint">Ao atingir a quantidade no período, o bônus é somado a cada carro vendido naquele período.</div>'+
      '</div>'+
      (dono?'':(
        '<label class="cad-lbl lj-usr-top">Acesso no sistema</label>'+
        '<div class="lj-fn-chips" id="ljMbPapel">'+
          '<button type="button" class="lj-fn-chip'+(mb.papel==='gerente'?'':' on')+'" data-pp="vendedor">Vendedor</button>'+
          '<button type="button" class="lj-fn-chip'+(mb.papel==='gerente'?' on':'')+'" data-pp="gerente">Gerente</button>'+
        '</div>'+
        '<div class="lj-fn-hint">Gerente ajuda a administrar a loja. Vendedor usa o dia a dia.</div>'))+
      '<div class="lj-usr-hist" id="ljMbHist" data-uid="'+esc(mb.user_id||'')+'"><div class="cli-empty">Carregando histórico...</div></div>'+
      '<div class="lj-fn-acoes">'+
        '<button type="button" class="cad-btn" id="ljMbOk">Salvar</button>'+
        (souEu?'<button type="button" class="cad-btn sec" id="ljMbCad">Meu cadastro</button>':'')+
      '</div>'+
      ((dono||souEu)?'':'<button type="button" class="lj-fn-del" id="ljMbDel">Remover da loja</button>');
    var novaFn=String(mb.funcao||''), novoPp=(mb.papel==='gerente'?'gerente':'vendedor');
    var novoCt=String(mb.com_tipo||'');
    Array.prototype.forEach.call(bg.querySelectorAll('#ljMbCom .lj-fn-chip'),function(b){
      b.onclick=function(){
        var jaEra=(novoCt===b.getAttribute('data-ct'));
        Array.prototype.forEach.call(bg.querySelectorAll('#ljMbCom .lj-fn-chip'),function(o){ o.classList.remove('on'); });
        if(jaEra){ novoCt=''; } else { novoCt=b.getAttribute('data-ct'); b.classList.add('on'); }
        var w=$('ljMbComVal'); if(w) w.style.display=novoCt?'':'none';
        var lb=$('ljMbComLb'); if(lb) lb.textContent=_comRotulo(novoCt);
      };
    });
    Array.prototype.forEach.call(bg.querySelectorAll('#ljMbFn .lj-fn-chip'),function(b){
      b.onclick=function(){
        var jaEra=(novaFn===b.getAttribute('data-fn'));
        Array.prototype.forEach.call(bg.querySelectorAll('#ljMbFn .lj-fn-chip'),function(o){ o.classList.remove('on'); });
        if(jaEra){ novaFn=''; } else { novaFn=b.getAttribute('data-fn'); b.classList.add('on'); }
      };
    });
    Array.prototype.forEach.call(bg.querySelectorAll('#ljMbPapel .lj-fn-chip'),function(b){
      b.onclick=function(){
        Array.prototype.forEach.call(bg.querySelectorAll('#ljMbPapel .lj-fn-chip'),function(o){ o.classList.remove('on'); });
        b.classList.add('on'); novoPp=b.getAttribute('data-pp');
      };
    });
    var bc=$('ljMbCad'); if(bc) bc.onclick=function(){ cliModalFechar(); telaCadastro(telaLoja); };
    var bd=$('ljMbDel'); if(bd) bd.onclick=function(){ cliModalFechar(); ljRemoverMembro(l, mb.id); };
    var bo=$('ljMbOk');
    if(bo) bo.onclick=async function(){
      var nv={};
      var nn=(($('ljMbNome')||{}).value||'').trim();
      if(nn && nn!==(mb.nome||'')) nv.nome=nn;
      var tel=foneFmt((($('ljMbTel')||{}).value||'').trim());
      if(tel!==foneFmt(mb.telefone||'')) nv.telefone=tel||null;
      if(novaFn!==String(mb.funcao||'')) nv.funcao=novaFn||null;
      if(!dono && novoPp!==(mb.papel==='gerente'?'gerente':'vendedor')) nv.papel=novoPp;
      /* v193 — comissao: tipo + numero andam juntos */
      var cn=parseFloat(String((($('ljMbComN')||{}).value)||'').replace(',','.'));
      if(!novoCt){ if(mb.com_tipo){ nv.com_tipo=null; nv.com_valor=null; } }
      else if(novoCt!==String(mb.com_tipo||'') || (isNaN(cn)?null:cn)!==(mb.com_valor==null?null:Number(mb.com_valor))){
        nv.com_tipo=novoCt; nv.com_valor=isNaN(cn)?null:cn;
      }
      var sal=_ljNumCampo((($('ljMbSal')||{}).value||''),false);
      var gq=_ljNumCampo((($('ljMbGatQtd')||{}).value||''),true);
      var gv=_ljNumCampo((($('ljMbGatVal')||{}).value||''),false);
      if((gq>0)!==(gv>0)){ toast('Preencha a quantidade de vendas e o bônus por carro.'); return; }
      if(sal!==(mb.salario_fixo==null?null:Number(mb.salario_fixo))) nv.salario_fixo=sal;
      if(gq!==(mb.gatilho_qtd==null?null:Number(mb.gatilho_qtd))) nv.gatilho_qtd=gq;
      if(gv!==(mb.gatilho_valor==null?null:Number(mb.gatilho_valor))) nv.gatilho_valor=gv;
      if(!Object.keys(nv).length){ cliModalFechar(); return; }
      bo.disabled=true; bo.textContent='Salvando…';
      try{
        var r=await supa.from('loja_membros').update(nv).eq('id',mb.id);
        if(r&&r.error) throw r.error;
        for(var k in nv){ if(Object.prototype.hasOwnProperty.call(nv,k)) mb[k]=nv[k]; }
        _comMbr=null;   /* v193 — a tela de Comissoes precisa reler a regra */
        cliModalFechar(); toast('Usuário atualizado ✓');
        ljMembrosPinta(l); try{ ljProcuradorPinta(l); }catch(_){}
      }catch(e){
        bo.disabled=false; bo.textContent='Salvar';
        toast('Não consegui salvar. '+((e&&e.message)||''));
      }
    };
    var mt=$('ljMbTel'); if(mt) mt.oninput=function(){ this.value=foneFmt(this.value); };
    ljMembroHistoricoPinta(mb);
  }
  function _ljNumCampo(v, inteiro){
    var s=String(v==null?'':v).trim().replace(/[^\d,.-]/g,'');
    if(!s) return null;
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if(/^\d{1,3}(\.\d{3})+$/.test(s)) s=s.replace(/\./g,'');
    var n=parseFloat(s); if(isNaN(n)||n<0) return null;
    return inteiro?Math.round(n):_r2(n);
  }
  function _ljVendaFechada(v){
    return !!(v&&v.fechada) || ['vendido','entrega','entregue','posvenda'].indexOf(String((v&&v.etapa)||''))>=0;
  }
  function _ljVendaBruto(v){
    return Number(v&&v.valor_venda)||Number(v&&v.proposta&&v.proposta.precoVenda)||0;
  }
  async function ljMembroHistoricoPinta(mb){
    var uid=String((mb&&mb.user_id)||'');
    try{
      await vendaCarregar();
      await estCarregar();
      await comMembrosCarregar();
    }catch(_){}
    var el=$('ljMbHist');
    if(!el || String(el.getAttribute('data-uid')||'')!==uid) return;
    var vendas=(_vendas||[]).filter(function(v){ return _ljVendaFechada(v) && _comQuem(v)===uid; });
    vendas.sort(function(a,b){ return _comData(b)>_comData(a)?1:-1; });
    var bruto=0, comissao=0;
    vendas.forEach(function(v){
      bruto+=_ljVendaBruto(v);
      if(v.comissao&&v.comissao.pago) comissao+=Number(v.comissao.valor)||0;
      else { var c=_comCalc(v,true); if(c&&!c.semRegra) comissao+=Number(c.valor)||0; }
    });
    var hoje=new Date(), meses=[];
    for(var i=5;i>=0;i--){
      var d=new Date(hoje.getFullYear(),hoje.getMonth()-i,1);
      var y=d.getFullYear(), m=d.getMonth(), q=0, vl=0;
      vendas.forEach(function(v){
        var ds=_comData(v); if(!ds) return;
        var dv=new Date(ds+'T12:00:00');
        if(dv.getFullYear()===y&&dv.getMonth()===m){ q++; vl+=_ljVendaBruto(v); }
      });
      meses.push({ q:q, valor:vl, nome:d.toLocaleDateString('pt-BR',{month:'short'}).replace('.','') });
    }
    var max=1; meses.forEach(function(x){ if(x.q>max) max=x.q; });
    var atual=meses[meses.length-1].q, anterior=meses[meses.length-2].q;
    var analise='';
    if(!atual && !anterior) analise='Ainda não há vendas concluídas nos dois últimos meses.';
    else if(atual===anterior) analise='A produção está estável em relação ao mês anterior.';
    else if(atual>anterior) analise='A produção subiu '+(atual-anterior)+' '+((atual-anterior)===1?'venda':'vendas')+' em relação ao mês anterior.';
    else analise='A produção está '+(anterior-atual)+' '+((anterior-atual)===1?'venda':'vendas')+' abaixo do mês anterior.';
    var sal=Number(mb.salario_fixo)||0, gq=Number(mb.gatilho_qtd)||0, gv=Number(mb.gatilho_valor)||0;
    el.innerHTML='<div class="cad-sec-tit">Histórico do usuário</div>'+
      '<div class="lj-usr-kpis">'+
        '<div><b>'+esc(_dataBr(mb.criado_em)||'—')+'</b><span>cadastro</span></div>'+
        '<div><b>'+vendas.length+'</b><span>vendas</span></div>'+
        '<div><b>'+esc(estMoney(comissao)||'R$ 0')+'</b><span>comissões</span></div>'+
        '<div><b>'+esc(estMoney(bruto)||'R$ 0')+'</b><span>volume bruto</span></div>'+
      '</div>'+
      ((sal||gq)?('<div class="lj-rem-resumo">'+
        (sal?('<span>Salário mensal <b>'+esc(estMoney(sal))+'</b></span>'):'')+
        (gq?('<span>Gatilho <b>'+gq+' vendas + '+esc(estMoney(gv))+' por carro</b></span>'):'')+
      '</div>'):'')+
      '<div class="lj-prod"><div class="lj-prod-h"><b>Produção — últimos 6 meses</b><span>'+esc(analise)+'</span></div>'+
        '<div class="lj-prod-chart">'+meses.map(function(x){
          return '<div class="lj-prod-col" title="'+x.q+' vendas · '+esc(estMoney(x.valor)||'R$ 0')+'"><b>'+x.q+'</b><i style="height:'+Math.max(4,Math.round(x.q/max*76))+'px"></i><span>'+esc(x.nome)+'</span></div>';
        }).join('')+'</div>'+
      '</div>'+
      (vendas.length?('<div class="lj-usr-recentes"><b>Vendas recentes</b>'+vendas.slice(0,5).map(function(v){
        return '<div><span>'+esc(v.veiculo||v.placa||'Veículo')+'<small>'+esc([v.placa||'',_dataBr(_comData(v))].filter(Boolean).join(' · '))+'</small></span><strong>'+esc(estMoney(_ljVendaBruto(v))||'—')+'</strong></div>';
      }).join('')+'</div>'):'');
  }
  /* renomear um usuário da equipe (o dono renomeia qualquer um; cada um pode se renomear) */
  async function ljRenomearMembro(l, id, atual){
    if(!id) return;
    var novo=prompt('Nome do usuário:', atual||''); if(novo==null) return;
    novo=String(novo).trim(); if(!novo){ toast('O nome não pode ficar vazio.'); return; }
    try{ var r=await supa.from('loja_membros').update({nome:novo}).eq('id',id); if(r&&r.error) throw r.error;
      toast('Nome atualizado ✓'); ljMembrosPinta(l); try{ ljProcuradorPinta(l); }catch(_){}
    }catch(e){ toast('Não consegui renomear. '+((e&&e.message)||'')); }
  }
  async function ljMudarPapel(l, id, papel){
    if(!id) return;
    try{ var r=await supa.from('loja_membros').update({papel:papel}).eq('id',id); if(r&&r.error) throw r.error; toast(papel==='gerente'?'Agora é gerente — pode ajudar a administrar.':'Definido como vendedor.'); }
    catch(e){ toast('Não consegui mudar a função. '+((e&&e.message)||'')); ljMembrosPinta(l); }
  }
  async function ljRegenerarCod(l){
    if(!confirm('Gerar um novo código? O código antigo deixa de funcionar.')) return;
    var novo=codConvite();
    try{ var r=await supa.from('loja').update({codigo_convite:novo}).eq('id',l.id).select('id'); if(r&&r.error) throw r.error; if(!r||!r.data||!r.data.length) throw new Error('Só o dono da loja pode alterar isto.'); l.codigo_convite=novo; if(_lojaRec) _lojaRec.codigo_convite=novo; var c=$('ljCodigo'); if(c) c.textContent=novo; toast('Novo código gerado.'); }
    catch(e){ toast('Não consegui gerar o código.'); }
  }
  /* ===== v324 — INDICADORES (dono da loja) ================================= */
  async function ljRegenerarInd(l){
    var tinha=!!l.codigo_indicador;
    if(tinha && !confirm('Gerar um novo código de indicador? O antigo deixa de funcionar (quem já é indicador continua).')) return;
    var novo=codConvite();
    try{ var r=await supa.from('loja').update({codigo_indicador:novo}).eq('id',l.id).select('id'); if(r&&r.error) throw r.error; if(!r||!r.data||!r.data.length) throw new Error('Só o dono da loja pode alterar isto.'); l.codigo_indicador=novo; if(_lojaRec) _lojaRec.codigo_indicador=novo; var c=$('ljCodInd'); if(c) c.textContent=novo; var nb=$('ljNovoInd'); if(nb) nb.textContent='gerar novo'; toast(tinha?'Novo código de indicador gerado.':'Código de indicador criado.'); }
    catch(e){ toast('Não consegui gerar o código.'); }
  }
  async function ljIndicPinta(l){
    var el=$('ljIndic'); if(!el) return;
    var lista=[]; try{ var r=await supa.from('vendedor_loja').select('*').eq('loja_id',l.id).order('criado_em',{ascending:true}); lista=(r&&r.data)||[]; }catch(_){ lista=[]; }
    if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:10px;color:#94a3b8">Nenhum indicador ainda. Passe o código acima pra quem vende indicando a sua loja.</div>'; return; }
    el.innerHTML=lista.map(function(m){
      var nome=m.vendedor_nome||m.vendedor_email||'Indicador';
      return '<div class="lj-membro"><div class="lj-membro-av">'+esc(cliIni(nome))+'</div>'+
        '<div class="lj-membro-tx"><div class="lj-membro-nm">'+esc(nome)+'</div>'+(m.vendedor_email?('<div class="lj-membro-sb">'+esc(m.vendedor_email)+'</div>'):'')+'</div>'+
        '<button type="button" class="ind-rm" data-id="'+esc(m.id)+'" data-nome="'+esc(nome)+'">Remover</button></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.ind-rm'),function(b){ b.onclick=function(){ ljIndicRemover(l, b.getAttribute('data-id'), b.getAttribute('data-nome'), b); }; });
  }
  async function ljIndicRemover(l, id, nome, btn){
    if(!id) return; if(!confirm('Remover '+(nome||'este indicador')+'? Os seus carros saem do catálogo dele.')) return;
    if(btn){ btn.disabled=true; btn.textContent='Removendo...'; }
    try{ var r=await supa.from('vendedor_loja').delete().eq('id',id); if(r&&r.error) throw r.error; toast('Indicador removido.'); ljIndicPinta(l); }
    catch(e){ if(btn){ btn.disabled=false; btn.textContent='Remover'; } toast('Não consegui remover.'); }
  }
  /* ===== v324 — LOJAS QUE EU DIVULGO (vendedor / indicador) ================
     Tela do menu inicial. A pessoa cola o código de indicador de uma loja
     parceira e passa a divulgar os carros dela. Só leitura do público; o
     WhatsApp de cada carro (na Etapa 2) aponta pro vendedor. */
  async function telaIndicador(){
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg cad-float"><h2>Lojas que eu divulgo</h2>'+
      '<p style="font-size:12.5px;color:#64748b;margin:2px 0 12px">Pegue o <b>código de indicador</b> com a loja parceira e cole aqui. Os carros dela entram no seu catálogo, e quem chamar no WhatsApp fala com <b>você</b>.</p>'+
      '<div class="cad-sec">'+
        '<label class="cad-lbl">Código de indicador da loja</label>'+
        '<div class="ind-entrar-row"><input class="cad-in" id="indCod" placeholder="Ex: AB12CD" autocomplete="off" maxlength="18"><button type="button" class="cad-btn" id="indEntrarBtn">Entrar</button></div>'+
        '<div class="cad-msg" id="indMsg"></div>'+
      '</div>'+
      '<div id="indLista"><div class="cli-empty" style="padding:12px">Carregando...</div></div>'+
      '</div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    var inp=$('indCod'); if(inp){ inp.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,18); }; inp.onkeydown=function(e){ if(e&&e.key==='Enter'){ e.preventDefault(); indEntrar(); } }; }
    var b=$('indEntrarBtn'); if(b) b.onclick=indEntrar;
    await indListaCarregar();
  }
  async function indEntrar(){
    var m=$('indMsg'), inp=$('indCod'); if(m){ m.className='cad-msg'; m.textContent=''; }
    var cod=String((inp&&inp.value)||'').trim(); if(!cod){ if(m){ m.className='cad-msg err'; m.textContent='Digite o código que a loja te passou.'; } return; }
    var b=$('indEntrarBtn'); if(b){ b.disabled=true; b.textContent='Entrando...'; }
    try{
      var nome=''; try{ var u=await supa.auth.getUser(); nome=(u&&u.data&&u.data.user&&u.data.user.user_metadata&&u.data.user.user_metadata.nome)||''; }catch(_){}
      var r=await supa.rpc('indicador_entrar',{p_codigo:cod, p_nome:nome||meuNome||''});
      if(r&&r.error) throw r.error;
      var d=(r&&r.data)||{};
      if(d.ok && d.entrou){ if(inp) inp.value=''; toast('Você agora divulga a '+(d.loja||'loja')+'!'); await indListaCarregar(); return; }
      var _msg={ vazio:'Digite o código.', sem_sessao:'Entre na sua conta e tente de novo.', ja_e_dono:'Essa loja é sua — você já é o dono dela.', nao_encontrada:'Não achei loja com esse código. Confira com a loja e tente de novo.' };
      if(m){ m.className='cad-msg err'; m.textContent=_msg[d.erro]||'Não consegui entrar agora.'; }
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui entrar agora. Tente de novo.'; } }
    finally{ var bb=$('indEntrarBtn'); if(bb){ bb.disabled=false; bb.textContent='Entrar'; } }
  }
  async function indListaCarregar(){
    var el=$('indLista'); if(!el) return;
    var lojas=[]; try{ var r=await supa.rpc('indicador_minhas_lojas'); var d=(r&&r.data); lojas=Array.isArray(d)?d:(typeof d==='string'?JSON.parse(d||'[]'):(d||[])); }catch(_){ lojas=[]; }
    if(!lojas.length){ el.innerHTML='<div class="cli-empty" style="padding:14px"><b>Você ainda não divulga nenhuma loja</b>Peça o código de indicador pra uma loja parceira e cole acima.</div>'; return; }
    el.innerHTML='<div class="lj-conv-hint" style="margin:6px 0 8px">Você divulga '+lojas.length+' loja'+(lojas.length>1?'s':'')+'. Toque em <b>Sair</b> pra parar de divulgar uma delas.</div>'+
      lojas.map(function(l){
        var logo=l.logo_url?('<img loading="lazy" decoding="async" class="ind-logo" src="'+esc(imgCdn(l.logo_url,200))+'" alt="">'):('<div class="ind-logo no">'+esc(String(l.nome||'?').slice(0,1).toUpperCase())+'</div>');
        var loc=[l.cidade,l.uf].filter(Boolean).join('/');
        return '<div class="ind-loja">'+logo+
          '<div class="ind-loja-tx"><div class="ind-loja-nm">'+esc(l.nome||'Loja')+'</div>'+(loc?('<div class="ind-loja-sb">'+esc(loc)+'</div>'):'')+'</div>'+
          '<button type="button" class="ind-sair" data-loja="'+esc(l.loja_id)+'" data-nome="'+esc(l.nome||'')+'">Sair</button></div>';
      }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.ind-sair'),function(b){ b.onclick=function(){ indSair(b.getAttribute('data-loja'), b.getAttribute('data-nome'), b); }; });
  }
  async function indSair(lojaId, nome, btn){
    if(!lojaId) return;
    if(!confirm('Parar de divulgar '+(nome||'esta loja')+'? Os carros dela saem do seu catálogo.')) return;
    if(btn){ btn.disabled=true; btn.textContent='Saindo...'; }
    try{ var r=await supa.from('vendedor_loja').delete().eq('loja_id',lojaId).eq('vendedor_id',meuId); if(r&&r.error) throw r.error; toast('Você parou de divulgar '+(nome||'a loja')+'.'); await indListaCarregar(); }
    catch(e){ if(btn){ btn.disabled=false; btn.textContent='Sair'; } toast('Não consegui sair agora.'); }
  }
  async function ljRemoverMembro(l, id){
    if(!id||!confirm('Remover este vendedor da loja?')) return;
    try{ var r=await supa.from('loja_membros').delete().eq('id',id); if(r&&r.error) throw r.error; ljMembrosPinta(l); toast('Vendedor removido.'); }
    catch(e){ toast('Não consegui remover.'); }
  }
  function ljRenderMembro(l){
    var nome=l.nome_fantasia||l.razao_social||'sua loja';
    var icLoja='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h1"/><path d="M14 9h1"/><path d="M10 21v-4h4v4"/></svg>';
    /* v482: era o ícone de compartilhar. O Catálogo é LIVRO no app
       inteiro (tela inicial, menu) — mesmo lugar, mesmo desenho. */
    var icCat='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>';
    if(['loja','catalogo'].indexOf(_ljTab)<0) _ljTab='loja';
    var tabs=[['loja','Loja',icLoja],['catalogo','Catálogo',icCat]];
    var nav=tabs.map(function(t){ return ljTabHtml(t[0], t[1], t[2]); }).join('');
    document.body.classList.add('venda-cot');
    /* v756: abas reais; o ícone do card do membro é SVG (sem emoji funcional) */
    $('ljWrap').innerHTML='<div class="vpx"><div class="vpx-steps vpx-mdr" id="ljTabs" role="tablist" aria-label="Seções da Minha loja">'+nav+'</div><div class="vpx-body cad-float" id="ljBody"><div id="ljTabLive" class="sr-only" aria-live="polite"></div>'+
      ljPainelAbre('loja')+'<div class="lj-membro-card"><div class="lj-mc-ic" aria-hidden="true">'+icLoja+'</div><div class="lj-mc-t">Você faz parte da loja</div><div class="lj-mc-nm">'+esc(nome)+'</div><div class="lj-mc-sb">'+esc([l.cidade,l.uf].filter(Boolean).join('/'))+'</div><div class="lj-mc-tag">Vendedor</div>'+
      '<div class="lj-conv-hint" style="margin-top:14px">Você compartilha o estoque, os clientes, as vendas e as avaliações com a equipe desta loja.</div>'+
      '<button class="cad-btn sair" id="ljSair" style="margin-top:14px">Sair da equipe</button></div></div>'+
      ljPainelAbre('catalogo')+ljPanelCatHtml(l, false)+'</div>'+   /* v483: membro NÃO é dono */
      '</div></div>';
    ljTabAplica(false);
    ljTabsLigar();
    $('ljSair').onclick=ljSair;
    ljCatWire(l);
  }
  function ljRenderCriar(){
    $('ljWrap').innerHTML='<p class="lj-hint">Cadastre a sua loja (você vira o dono) ou entre na loja de outra pessoa com um código de convite.</p>'+lojaFormHtml(null)+
      '<div class="cad-sec"><h3>Entrar numa loja</h3>'+mevLojaEntrarHtml('lj')+'</div>';
    lojaWireForm();
    var sp=$('ljProcurador'); if(sp) sp.innerHTML='<option value="">Salve a loja primeiro</option>';
    mevLojaEntrarWire('lj');
  }
  /* ================= v282 — ENTRAR NUMA LOJA: UMA PEÇA, DOIS LUGARES =================
     O mesmo campo precisa existir em "Minha loja" E dentro de "Minha conta"
     (foi o pedido: o código/CNPJ dentro do meu cadastro). Escrever duas vezes
     significaria consertar duas vezes toda vez que algo mudar — e esquecer uma
     delas. Então a peça é uma só e recebe um PREFIXO de id: 'lj' aqui, 'cadLj'
     no cadastro. */
  function mevLojaEntrarHtml(px){
    return '<div class="lj-conv-hint">É vendedor de uma loja que já usa o MEV? Cole o <b>código de convite</b> (entra na hora) ou o <b>CNPJ da loja</b> (o dono aprova).</div>'+
      '<input class="cad-in" id="'+px+'EntrarCod" placeholder="Código de convite ou CNPJ" style="text-transform:uppercase;margin-top:8px" autocapitalize="characters" autocomplete="off">'+
      '<button class="cad-btn sec" id="'+px+'EntrarBtn" style="margin-top:8px">Entrar na loja</button><div class="cad-msg" id="'+px+'EntrarMsg"></div>';
  }
  function mevLojaEntrarWire(px, aoEntrar){
    /* v282: o campo aceitava só 6 letras — CNPJ (14 dígitos) não cabia.
       Agora deixa passar código E CNPJ; quem decide o que é cada um é o banco. */
    var ec=$(px+'EntrarCod'); if(ec){
      ec.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9./-]/g,'').slice(0,18); };
      ec.onkeydown=function(ev){ if(ev&&ev.key==='Enter'){ ev.preventDefault(); mevLojaEntrar(px, aoEntrar); } };
    }
    var eb=$(px+'EntrarBtn'); if(eb) eb.onclick=function(){ mevLojaEntrar(px, aoEntrar); };
  }
  async function mevLojaEntrar(px, aoEntrar){
    var m=$(px+'EntrarMsg'); if(m){ m.className='cad-msg'; m.textContent=''; }
    var cod=(($(px+'EntrarCod')||{}).value||'').trim();
    if(!cod){ if(m){ m.className='cad-msg err'; m.textContent='Digite o código de convite ou o CNPJ da loja.'; } return; }
    var btn=$(px+'EntrarBtn'); if(btn){ btn.disabled=true; btn.textContent='Entrando...'; }
    function _solta(){ var b=$(px+'EntrarBtn'); if(b){ b.disabled=false; b.textContent='Entrar na loja'; } }
    try{
      var nome=''; try{ var u=await supa.auth.getUser(); nome=(u&&u.data&&u.data.user&&u.data.user.user_metadata&&u.data.user.user_metadata.nome)||''; }catch(_){}
      var r=await supa.rpc('entrar_na_loja',{p_codigo:cod, p_nome:nome||meuNome||''});
      if(r&&r.error) throw r.error;
      var d=(r&&r.data)||{};
      /* ===== v282 — DUAS PORTAS, DUAS RESPOSTAS =====
         código de convite → entrou; CNPJ → pedido esperando o dono.
         O aviso precisa deixar claro qual dos dois aconteceu, senão a pessoa
         acha que entrou e fica esperando ver dados que ainda não vai ver. */
      if(d.entrou){
        toast(d.ja_era?('Você já faz parte da '+(d.loja||'loja')+'.'):('Você entrou na loja'+(d.loja?(' '+d.loja):'')+'!'));
        if(typeof aoEntrar==='function') aoEntrar(d);
        else if(px==='cadLj') cadLojaPinta();   /* fica no cadastro, só se repinta */
        else telaLoja();
        return;
      }
      if(d.pedido){
        if(m){ m.className='cad-msg ok'; m.innerHTML='Pedido enviado para <b>'+esc(d.loja||'a loja')+'</b>. '+
          'Assim que o dono aprovar, os dados aparecem aqui.<br><span style="color:#64748b">Pelo CNPJ é sempre assim — o código de convite entra na hora.</span>'; }
        _solta();
        /* No cadastro o quadro se repinta e passa a mostrar "esperando o dono"
           com o botão de cancelar. Levo o NOME junto: se a leitura falhar, o
           aviso continua na tela em vez de sumir e parecer que não foi. */
        if(px==='cadLj'){ try{ cadLojaPinta(d.loja||'a loja'); }catch(_){} }
        return;
      }
      var _msg={ vazio:'Digite o código ou o CNPJ.',
                 ja_e_dono:'Esta loja é sua — você já é o dono dela.',
                 sem_sessao:'Entre na sua conta e tente de novo.',
                 nao_encontrada:'Não achei loja com esse código nem com esse CNPJ. Confira e tente de novo.' };
      if(m){ m.className='cad-msg err'; m.textContent=_msg[d.erro]||'Não consegui entrar na loja agora.'; }
      _solta();
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui entrar na loja agora. Confira e tente de novo.'; } _solta(); }
  }
  /* ============ v282 — O MESMO CAMPO DENTRO DE "MINHA CONTA" ============
     Pedido do Angelo: "permita colocar o código da loja que trabalha ou o CNPJ
     dentro do meu cadastro". O quadro se adapta a QUEM está olhando: dono,
     vendedor da equipe, quem já pediu e está esperando, ou quem ainda não tem
     loja nenhuma. Quem já está resolvido não vê campo nenhum — vê onde está. */
  async function cadLojaPinta(avisoPedido){
    var el=$('cadLojaBox'); if(!el) return;
    function _tit(){ return '<h3>Minha loja</h3>'; }
    /* O aviso "pedido enviado" é uma VERDADE que o servidor já confirmou.
       Ele não pode sumir só porque a leitura seguinte não achou a linha (ou
       caiu a internet) — senão a pessoa acha que o pedido não foi. */
    function _avisoHtml(nome){ return '<div class="cad-msg ok">Pedido enviado para <b>'+esc(nome||'a loja')+'</b>. Esperando o dono aprovar.</div>'; }
    el.className='cad-sec';
    el.innerHTML=_tit()+'<div class="cli-empty" style="padding:10px">Carregando...</div>';
    var lojas=null, peds=[];
    try{ var r=await withTimeout(supa.from('loja').select('*'),10000); lojas=(r&&r.data)||[]; }catch(e){ lojas=null; }
    if(lojas===null){
      el.innerHTML=_tit()+(avisoPedido?_avisoHtml(avisoPedido):'')+
        '<div class="cli-empty" style="padding:10px">Não consegui carregar agora — verifique a internet.</div>'+
        '<button type="button" class="cad-btn sec" id="cadLjRetry" style="margin-top:8px">Tentar de novo</button>';
      var rb=$('cadLjRetry'); if(rb) rb.onclick=function(){ cadLojaPinta(avisoPedido); };
      return;
    }
    var minha=lojas.filter(function(l){ return String(l.user_id)===String(meuId); })[0]||null;
    var membro=lojas.filter(function(l){ return String(l.user_id)!==String(meuId); })[0]||null;

    /* ---- É O DONO ---- */
    if(minha){
      var nPend=0;
      try{ var rp=await supa.from('loja_pedido').select('id').eq('loja_id',minha.id).eq('situacao','pendente'); nPend=((rp&&rp.data)||[]).length; }catch(_){}
      el.innerHTML=_tit()+
        '<div class="lj-conv-hint">Você é o <b>dono</b> da <b>'+esc(minha.nome_fantasia||minha.razao_social||'sua loja')+'</b>.</div>'+
        '<div class="lj-conv"><span>Código de convite</span><b>'+esc(minha.codigo_convite||'—')+'</b><button type="button" id="cadLjCop">copiar</button></div>'+
        (nPend?('<div class="cad-msg ok" style="cursor:pointer" id="cadLjPend"><b>'+nPend+' pedido'+(nPend>1?'s':'')+'</b> esperando você aprovar &#8250;</div>'):'')+
        '<button type="button" class="cad-btn sec" id="cadLjAbrir" style="margin-top:8px">Ir para a loja</button>';
      var cp=$('cadLjCop'); if(cp) cp.onclick=function(){ try{ navigator.clipboard.writeText(minha.codigo_convite||''); toast('Código copiado.'); }catch(_){ prompt('Código:',minha.codigo_convite||''); } };
      var pd=$('cadLjPend'); if(pd) pd.onclick=function(){ telaLoja('usuarios'); };
      var ab=$('cadLjAbrir'); if(ab) ab.onclick=function(){ telaLoja(); };
      return;
    }

    /* ---- JÁ ESTÁ NA EQUIPE DE ALGUÉM ---- */
    if(membro){
      el.innerHTML=_tit()+
        '<div class="lj-conv-hint">Você trabalha na <b>'+esc(membro.nome_fantasia||membro.razao_social||'loja')+'</b>'+
        (membro.cidade?(' — '+esc([membro.cidade,membro.uf].filter(Boolean).join('/'))):'')+'. '+
        'Vocês compartilham estoque, clientes, vendas e avaliações.</div>'+
        '<button type="button" class="cad-btn sec" id="cadLjAbrir" style="margin-top:8px">Ir para a loja</button>';
      var ab2=$('cadLjAbrir'); if(ab2) ab2.onclick=function(){ telaLoja(); };
      return;
    }

    /* ---- PEDIU PELO CNPJ E ESTÁ ESPERANDO ---- */
    try{ var rq=await supa.from('loja_pedido').select('*').eq('user_id',meuId).eq('situacao','pendente').order('criado_em',{ascending:false}); peds=(rq&&rq.data)||[]; }catch(_){ peds=[]; }
    var p=peds[0]||null;
    if(p || avisoPedido){
      el.innerHTML=_tit()+
        _avisoHtml((p&&p.loja_nome)||avisoPedido)+
        '<div class="lj-conv-hint">Pelo CNPJ é sempre assim — o CNPJ é público, então ninguém entra sem o dono deixar. '+
        'Se você tiver o <b>código de convite</b>, ele entra na hora.</div>'+
        (p?'<button type="button" class="cad-btn sec" id="cadLjCancel" style="margin-top:8px">Cancelar o pedido</button>':'')+
        '<div style="margin-top:12px">'+mevLojaEntrarHtml('cadLj')+'</div>';
      mevLojaEntrarWire('cadLj');
      var cc=$('cadLjCancel'); if(cc) cc.onclick=async function(){
        if(!confirm('Cancelar o pedido pra entrar nesta loja?')) return;
        this.disabled=true; this.textContent='Cancelando...';
        try{ var d=await supa.from('loja_pedido').delete().eq('id',p.id); if(d&&d.error) throw d.error; toast('Pedido cancelado.'); }
        catch(e){ toast('Não consegui cancelar agora.'); }
        cadLojaPinta();
      };
      return;
    }

    /* ---- AINDA NÃO TEM LOJA ---- */
    el.innerHTML=_tit()+mevLojaEntrarHtml('cadLj')+
      '<div class="lj-conv-hint" style="margin-top:10px">A loja é sua? <b id="cadLjCriar" style="color:#2563eb;cursor:pointer">Cadastre ela aqui</b> e você vira o dono.</div>';
    mevLojaEntrarWire('cadLj');
    var cr=$('cadLjCriar'); if(cr) cr.onclick=function(){ telaLoja(); };
  }
  async function ljSair(){
    if(!confirm('Sair da equipe desta loja? Você deixa de ver os dados compartilhados.')) return;
    try{ var r=await supa.rpc('sair_da_loja'); if(r&&r.error) throw r.error; toast('Você saiu da equipe.'); telaLoja(); }
    catch(e){ toast('Não consegui sair.'); }
  }
  function lojaFormHtml(l){
    return ljPanelDadosHtml(l)+ljPanelProcHtml(l)+'<div class="cad-msg" id="ljMsg"></div><div class="cad-autosave" id="ljAutosave">As alterações salvam sozinhas ✓</div>';
  }
  /* ===== v759 — MINHA LOJA, FASE 2: a aba Dados em quatro cards ==========
     (PROJETO-2026-08-29-redesign-minha-loja.txt §9) A Logo · B Identificação ·
     C Contato · D Endereço. Os IDs dos campos NÃO mudaram (autosave, CNPJ,
     CEP, máscaras e o PDF-resumo continuam). O que mudou: a logo virou card
     com ação escrita e ajuda; o CNPJ tem só a máscara no placeholder (a
     explicação está fora) e um status próprio (#ljCnpjMsg); e-mail é
     type=email; Complemento ganhou lugar na ordem canônica; Número 35% +
     Bairro 65% e Cidade 75% + UF 25% (empilham abaixo de 360px); CEP com
     status próprio (#ljCepMsg); site avisa antes de descartar (#ljSiteMsg). */
  function ljPanelDadosHtml(l){ l=l||{};
    var temLogo=!!l.logo_url;
    return '<div class="cad-card lj-card-logo"><div class="cad-card-t">Logo da loja</div>'
      +'<div class="lj-logo-row"><div class="lj-logo'+(temLogo?'':' vazia')+'" id="ljLogoBox" aria-hidden="true">'+(temLogo?'<img loading="lazy" decoding="async" src="'+esc(imgCdn(l.logo_url,200))+'" alt="">':'<span class="lj-logo-plus">+</span><span>logo</span>')+'</div>'
        +'<div class="lj-logo-tx"><button type="button" class="cad-state-bt" id="ljLogoBtn">'+(temLogo?'Trocar logo':'Adicionar logo')+'</button><p class="cad-help">Aparece no catálogo e nas páginas públicas da loja. Quadrada, 512×512.</p><div class="cad-msg" id="ljLogoMsg" aria-live="polite"></div></div></div>'
        +'<input type="file" id="ljLogoInput" accept="image/*" style="display:none"></div>'
      +'<div class="cad-card"><div class="cad-card-t">Identificação</div>'
        +'<label class="cad-lbl" for="ljCnpj">CNPJ</label><input class="cad-in" id="ljCnpj" inputmode="numeric" autocomplete="off" value="'+esc(l.cnpj||'')+'" placeholder="00.000.000/0000-00">'
        +'<p class="cad-help">Com o CNPJ completo eu busco a razão social, o endereço e o telefone pra você conferir.</p><div class="cad-msg" id="ljCnpjMsg" aria-live="polite"></div>'
        +'<label class="cad-lbl" for="ljRazao">Razão social</label><input class="cad-in" id="ljRazao" value="'+esc(l.razao_social||'')+'" placeholder="Razão social da empresa">'
        +'<label class="cad-lbl" for="ljFant">Nome fantasia</label><input class="cad-in" id="ljFant" value="'+esc(l.nome_fantasia||'')+'" placeholder="Nome fantasia"></div>'
      +'<div class="cad-card"><div class="cad-card-t">Contato</div>'
        +'<div class="cli-2col lj-grid-tel"><div><label class="cad-lbl" for="ljTel">Telefone</label><input class="cad-in" id="ljTel" inputmode="tel" autocomplete="tel" value="'+esc(l.telefone||'')+'" placeholder="(00) 0000-0000"></div><div><label class="cad-lbl" for="ljWa">WhatsApp</label><input class="cad-in" id="ljWa" inputmode="tel" value="'+esc(l.whatsapp||'')+'" placeholder="(00) 00000-0000"></div></div>'
        +'<label class="cad-lbl" for="ljEmail">E-mail</label><input class="cad-in" id="ljEmail" type="email" autocomplete="email" autocapitalize="none" value="'+esc(l.email||'')+'" placeholder="contato@loja.com">'
        +'<label class="cad-lbl" for="ljInsta">Instagram da loja</label><input class="cad-in" id="ljInsta" value="'+esc(l.instagram||'')+'" placeholder="@sualoja" autocapitalize="none">'
        /* v455 — site-vitrine Fase 1: quem JA TEM site cadastra aqui */
        +'<label class="cad-lbl" for="ljSite">Site da loja (se tiver)</label><input class="cad-in" id="ljSite" value="'+esc(l.site_url||'')+'" placeholder="www.sualoja.com.br" autocapitalize="none" inputmode="url"><div class="cad-msg" id="ljSiteMsg" aria-live="polite"></div></div>'
      +'<div class="cad-card"><div class="cad-card-t">Endereço</div>'
        +'<label class="cad-lbl" for="ljCep">CEP</label><input class="cad-in" id="ljCep" inputmode="numeric" autocomplete="postal-code" value="'+esc(l.cep||'')+'" placeholder="00000-000"><div class="cad-msg" id="ljCepMsg" aria-live="polite"></div>'
        +'<label class="cad-lbl" for="ljRua">Rua</label><input class="cad-in" id="ljRua" value="'+esc(l.rua||'')+'" placeholder="Logradouro">'
        +'<div class="cli-2col nb lj-grid-nb"><div><label class="cad-lbl" for="ljNum">Número</label><input class="cad-in" id="ljNum" value="'+esc(l.numero||'')+'" placeholder="Nº"></div><div><label class="cad-lbl" for="ljBairro">Bairro</label><input class="cad-in" id="ljBairro" value="'+esc(l.bairro||'')+'" placeholder="Bairro"></div></div>'
        +'<label class="cad-lbl" for="ljComp">Complemento</label><input class="cad-in" id="ljComp" value="'+esc(l.complemento||'')+'" placeholder="Sala, galpão, ponto de referência">'
        +'<div class="cli-2col cid lj-grid-cid"><div><label class="cad-lbl" for="ljCidade">Cidade</label><input class="cad-in" id="ljCidade" value="'+esc(l.cidade||'')+'" placeholder="Cidade"></div><div><label class="cad-lbl" for="ljUf">UF</label><input class="cad-in" id="ljUf" maxlength="2" value="'+esc(l.uf||'')+'" placeholder="UF" autocapitalize="characters"></div></div></div>';
  }
  function ljPanelProcHtml(l){ l=l||{};
    return '<div class="cad-grid2">'+
      '<div>'+
        '<div class="cad-sec-tit">Procurador</div>'+
        '<label class="cad-lbl">Procurador (assina as procurações)</label><select class="cad-in" id="ljProcurador"><option value="">Carregando equipe…</option></select>'+
        '<div style="font-size:11px;color:#94a3b8;margin:4px 0 8px">Quem representa a loja nas procurações. Escolha entre os usuários cadastrados na empresa.</div>'+
        '<div class="cli-2col"><div><label class="cad-lbl">CPF do procurador</label><input class="cad-in" id="ljProcCpf" inputmode="numeric" value="'+esc(l.procurador_cpf||'')+'" placeholder="000.000.000-00"></div><div><label class="cad-lbl">RG do procurador</label><input class="cad-in" id="ljProcRg" value="'+esc(l.procurador_rg||'')+'" placeholder="RG"></div></div>'+
      '</div>'+
      '<div>'+
        '<div class="cad-sec-tit">CNH do procurador</div>'+
        '<div class="cad-lbl solta">Foto ou PDF da CNH</div><div class="lj-cnh" id="ljCnhWrap"></div><input type="file" id="ljCnhInput" accept="image/*,application/pdf" style="display:none">'+
      '</div>'+
      '</div>'+
      lojaCardCfgHtml(l);
  }
  /* Seção "Modelo do card de venda" removida a pedido. A função retorna vazio
     (o card_config salvo é preservado no banco; o wiring/save já são guardados). */
  function lojaCardCfgHtml(l){ return ''; }
  function lojaWireForm(){
    var cnpj=$('ljCnpj'); if(cnpj){ cnpj.oninput=function(){ this.value=cnpjFmt(this.value); if(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length===14) cnpjBusca(this.value); }; cnpj.addEventListener('blur',function(){ cnpjBusca(this.value); }); }
    /* v759: CEP — uma requisição por valor, resposta antiga não sobrescreve CEP novo, Número/Complemento intactos, status próprio */
    var cep=$('ljCep'); if(cep){ var ljCep=function(){ var m=$('ljCepMsg')||$('ljMsg'); var dg=String((($('ljCep')||{}).value)||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(dg.length!==8) return;
        if(ljCep._ult===dg) return; ljCep._ult=dg; var seq=(ljCep._seq=(ljCep._seq||0)+1);
        if(m){ m.className='cad-msg'; m.textContent='Buscando endereço…'; }
        cepBusca(dg,LJ_CEP_IDS).then(function(ok){ var agora=String((($('ljCep')||{}).value)||'').replace(/\D/g,''); if(seq!==ljCep._seq || agora!==dg) return;   /* resposta velha: ignora */
          if(m){ if(ok&&ok.rua){ m.className='cad-msg ok'; m.textContent='Endereço encontrado — confira o número.'; } else if(ok){ m.className='cad-msg ok'; m.textContent='CEP geral de '+(ok.cidade||'da cidade')+' — digite a rua e o bairro.'; } else { m.className='cad-msg'; m.textContent='CEP não encontrado. Pode preencher à mão.'; ljCep._ult=''; } }
          try{ ljAgendaSalvar(); }catch(_){} }); };
      cep.oninput=function(){ this.value=cepFmt(this.value); if(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length===8) ljCep(); }; cep.addEventListener('blur',ljCep); }
    /* v759: site — avisa ANTES de descartar um endereço inválido */
    var site=$('ljSite'); if(site){ site.addEventListener('blur',function(){ var m=$('ljSiteMsg'); var v=String(this.value||'').trim(); if(!m) return; if(v && !ljSiteNorm(v)){ m.className='cad-msg err'; m.textContent='Esse endereço não parece válido — use algo como www.sualoja.com.br. Ele não será salvo assim.'; } else { m.className='cad-msg'; m.textContent=''; } }); }
    var uf=$('ljUf'); if(uf){ uf.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); }; }
    var tel=$('ljTel'); if(tel){ if(tel.value) tel.value=foneFmt(tel.value); tel.oninput=function(){ this.value=foneFmt(this.value); }; }
    var wa=$('ljWa'); if(wa){ if(wa.value) wa.value=foneFmt(wa.value); wa.oninput=function(){ this.value=foneFmt(this.value); }; }
    var lb=$('ljLogoBox'); if(lb) lb.onclick=function(){ $('ljLogoInput').click(); };
    var lbt=$('ljLogoBtn'); if(lbt) lbt.onclick=function(){ $('ljLogoInput').click(); };   /* v759: a ação escrita do card da logo */
    var li=$('ljLogoInput'); if(li) li.onchange=function(){ var f=this.files&&this.files[0]; this.value=''; if(!f) return;
      /* v170: antes de enviar, abre o recorte pra voce escolher o enquadramento */
      fotoCropAbrir(f, function(bl){ if(bl) lojaLogoUp(bl); }, {ar:1, out:512, redondo:false, blob:true, titulo:'Ajustar a logo', sub:'Arraste pra posicionar · use a barra pra dar zoom'});
    };
    var sw=$('ljCardSw'); if(sw){ Array.prototype.forEach.call(sw.querySelectorAll('.lj-sw'),function(b){ b.onclick=function(){ var c=b.getAttribute('data-cor'); if($('ljCardCor')) $('ljCardCor').value=c; Array.prototype.forEach.call(sw.querySelectorAll('.lj-sw'),function(x){ x.classList.remove('on'); }); b.classList.add('on'); }; }); }
    var cc=$('ljCardCor'); if(cc) cc.oninput=function(){ var s=$('ljCardSw'); if(s) Array.prototype.forEach.call(s.querySelectorAll('.lj-sw'),function(x){ x.classList.remove('on'); }); };
    ['ljCardKm','ljCardEnt','ljCardPlaca'].forEach(function(id){ var e=$(id); if(e) e.onchange=function(){ var lbx=e.closest('.vd-ck'); if(lbx) lbx.classList.toggle('on',e.checked); }; });
    var pv=$('ljCardPrev'); if(pv) pv.onclick=lojaCardPreview;
    _ljCnhUrl=(_lojaRec&&_lojaRec.procurador_cnh_url)||''; _ljCnhDados=(_lojaRec&&_lojaRec.procurador_cnh_dados)||null; _ljCnhLendo=false; ljCnhRender();
    var cnhI=$('ljCnhInput'); if(cnhI) cnhI.onchange=function(){ ljCnhUp(this.files&&this.files[0]); this.value=''; };
    /* PDF resumo da loja */
    /* SALVAR AUTOMÁTICO */
    lojaAutosaveWire();
  }
  /* v455 — o site do lojista entra no banco já normalizado: tira espaço,
     prefixa https:// quando falta e recusa o que não parece endereço
     (a função do banco ainda filtra de novo na saída — cinto e suspensório). */
  function ljSiteNorm(u){
    u=String(u||'').trim();
    if(!u) return '';
    if(!/^https?:\/\//i.test(u)) u='https://'+u.replace(/^\/+/,'');
    return (/^https?:\/\/[^\s]+\.[^\s]{2,}$/i.test(u) && u.indexOf(' ')<0) ? u : '';
  }
  /* ---------- SALVAR AUTOMÁTICO da loja (sem botão) ---------- */
  var _ljSaveTimer=null, _ljSaveLast='';
  function lojaColeta(){
    function gv(id){ var e=$(id); return e?(e.value||'').trim():''; }
    var reg={ cnpj:gv('ljCnpj'), razao_social:gv('ljRazao'), nome_fantasia:gv('ljFant'), cep:gv('ljCep'), rua:gv('ljRua'), numero:gv('ljNum'), bairro:gv('ljBairro'), complemento:gv('ljComp'), cidade:gv('ljCidade'), uf:gv('ljUf'), telefone:gv('ljTel'), whatsapp:gv('ljWa'), email:gv('ljEmail'), instagram:gv('ljInsta'), site_url:ljSiteNorm(gv('ljSite')) };
    var _ps=$('ljProcurador'); if(_ps){ reg.procurador_id=_ps.value||null; var _po=_ps.options[_ps.selectedIndex]; reg.procurador_nome=(_po&&_po.getAttribute('data-nome'))||''; }
    reg.procurador_cpf=gv('ljProcCpf'); reg.procurador_rg=gv('ljProcRg');
    if($('ljCnhWrap')){ reg.procurador_cnh_url=_ljCnhUrl||null; reg.procurador_cnh_dados=_ljCnhDados||null; }
    if($('ljCardCor')) reg.card_config=_lojaCardLerForm();
    /* v352 — a aba "Sobre nós" entra no MESMO update do autosave da loja.
       Um salvamento só na linha: dois updates paralelos se atropelariam. */
    if($('ljPsSobre')) reg.prova_social=psLer('lj');
    if(_lojaLogoUrl) reg.logo_url=_lojaLogoUrl; else if(_lojaRec&&_lojaRec.logo_url) reg.logo_url=_lojaRec.logo_url;
    return reg;
  }
  function ljAgendaSalvar(){ var ind=$('ljAutosave'); if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; }
    /* v756: o status vive no cabeçalho da área do campo que mudou; um erro à vista só sai quando os dados mudam */
    try{ var ab=_ljAbaDoCampo(document.activeElement); if(ab&&LJ_ABAS[ab]) _ljStatusAba=ab;
      var st=$('ljStatus-'+_ljStatusAba); var erroVivo=!!(st && /is-erro/.test(st.className));
      if(!(erroVivo && JSON.stringify(lojaColeta())===_ljTentado)) ljStatusSet('pendente'); }catch(_){}
    clearTimeout(_ljSaveTimer); _ljSaveTimer=setTimeout(lojaSalvarAuto, 1100); }
  /* v759 — SINGLE-FLIGHT: uma gravação por vez. Se chega outra enquanto uma
     está no ar, ela só marca "tem coisa nova" e a que está rodando repete no
     fim com os dados mais recentes — rede lenta nunca sobrescreve valor novo. */
  var _ljSalvando=false, _ljPendente=false;
  async function lojaSalvarAuto(){
    if(!$('ljCnpj') && !$('ljRazao')) return false;   /* saiu da tela da loja */
    if(_ljSalvando){ _ljPendente=true; return false; }
    _ljSalvando=true;
    try{ return await _lojaSalvarAgora(); }
    finally{ _ljSalvando=false; if(_ljPendente){ _ljPendente=false; setTimeout(function(){ lojaSalvarAuto(); },0); } }
  }
  async function _lojaSalvarAgora(){
    var reg=lojaColeta(); var ind=$('ljAutosave');
    /* loja NOVA só é criada quando já tem algo que valha (CNPJ, razão ou fantasia) */
    var temAlgo = reg.cnpj || reg.razao_social || reg.nome_fantasia;
    if(!(_lojaRec&&_lojaRec.id) && !temAlgo){ if(ind){ ind.className='cad-autosave'; ind.textContent='Preencha o CNPJ ou o nome da loja.'; } ljStatusSet('pendente','Preencha o CNPJ ou o nome da loja.'); return false; }
    var js=JSON.stringify(reg);
    if(js===_ljSaveLast){ if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; } ljStatusSet('neutro'); return true; }
    _ljTentado=js; ljStatusSet('salvando');
    /* v385 — loja NOVA com CNPJ que já é de alguém: não cria cópia. Confiro
       aqui de novo (e não só no cnpjBusca) porque dá pra colar o CNPJ e sair
       da tela sem passar por lá. */
    if(!(_lojaRec&&_lojaRec.id)){
      var _d=String(reg.cnpj||'').replace(/\D/g,'');
      if(_d.length===14){
        if(_ljCnpjBloq===_d){ if(ind){ ind.className='cad-autosave err'; ind.textContent='Essa loja já está cadastrada — entre nela pelo código de convite.'; } ljStatusSet('erro','Essa loja já está cadastrada — entre nela pelo código de convite.'); return false; }
        var _dono=await ljCnpjDono(_d);
        if(_dono){ _ljCnpjBloq=_d; ljCnpjOcupadoMsg(_dono);
          if(ind){ ind.className='cad-autosave err'; ind.textContent='Essa loja já está cadastrada — entre nela pelo código de convite.'; }
          ljStatusSet('erro','Essa loja já está cadastrada — entre nela pelo código de convite.');
          return false; }
      }
    }
    try{
      if(_lojaRec&&_lojaRec.id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('loja').update(reg).eq('id',_lojaRec.id).select('id'); if(r&&r.error) throw r.error; if(!r||!r.data||!r.data.length) throw new Error('Só o dono da loja pode alterar estes dados.'); _lojaRec=Object.assign({}, _lojaRec, reg); }
      else { reg.user_id=meuId; reg.codigo_convite=codConvite(); var r2=await supa.from('loja').insert(reg).select().single(); if(r2&&r2.error) throw r2.error; _lojaRec=(r2&&r2.data)||Object.assign({id:null}, reg);
        if(_lojaRec&&_lojaRec.id){ var nome=''; try{ var u=await supa.auth.getUser(); nome=(u&&u.data&&u.data.user&&u.data.user.user_metadata&&u.data.user.user_metadata.nome)||''; }catch(_){} try{ await supa.from('loja_membros').insert({loja_id:_lojaRec.id, user_id:meuId, papel:'dono', nome:nome, email:meuEmail||''}); }catch(_){} }
      }
      _ljSaveLast=js;
      if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; }
      ljStatusSet('sucesso'); (function(ab){ setTimeout(function(){ var st=$('ljStatus-'+ab); if(st&&st.classList.contains('is-sucesso')) cadStatusPinta(st,'neutro'); },2200); })(_ljStatusAba);
      return true;
    }catch(e){
      var _em=String((e&&e.message)||'');
      /* v385 — o índice único do banco falando. Traduzo pra gente, e NÃO fico
         tentando de novo: repetir não vai mudar o resultado. */
      if(/duplicate key|mp_loja_cnpj_unico|23505/i.test(_em)){
        if(ind){ ind.className='cad-autosave err'; ind.textContent='Essa loja já está cadastrada — entre nela pelo código de convite.'; }
        ljStatusSet('erro','Essa loja já está cadastrada — entre nela pelo código de convite.');
        var _d2=String(reg.cnpj||'').replace(/\D/g,''); if(_d2.length===14) _ljCnpjBloq=_d2;
        try{ var _o=await ljCnpjDono(_d2); if(_o) ljCnpjOcupadoMsg(_o); }catch(_){ }
        clearTimeout(_ljSaveTimer);
        return false;
      }
      var _rede=!_em || /fetch|network|conex|timeout|load failed/i.test(_em);
      if(ind){ ind.className='cad-autosave err'; ind.textContent=_rede?'Sem conexão — tentando de novo…':('Não consegui salvar: '+_em.slice(0,120)); }
      if(_rede) ljStatusSet('erro-recuperavel'); else ljStatusSet('erro','Não consegui salvar: '+_em.slice(0,120), function(){ clearTimeout(_ljSaveTimer); lojaSalvarAuto(); });
      clearTimeout(_ljSaveTimer); _ljSaveTimer=setTimeout(lojaSalvarAuto, _rede?3000:15000);
      return false;
    }
  }
  function lojaAutosaveWire(){
    var wrap=$('ljWrap'); if(!wrap) return;
    _ljSaveLast=JSON.stringify(lojaColeta());
    Array.prototype.forEach.call(wrap.querySelectorAll('input,select,textarea'),function(e){ if(e.id==='ljEntrarCod') return; e.addEventListener('input',ljAgendaSalvar); e.addEventListener('change',ljAgendaSalvar); });
  }
  /* ---------- PDF resumo da loja (mesmo padrão das outras páginas) ---------- */
  function lojaResumoPdf(acao){
    if(!_mevPdfPronto(function(){ lojaResumoPdf(acao); },false)) return;
    var reg=lojaColeta();
    var nomeLoja=reg.nome_fantasia||reg.razao_social||'Minha loja';
    try{
      var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'pt',format:'a4'});
      var pw=pdf.internal.pageSize.getWidth(), m=48, y=118;
      pdf.setFillColor(0,30,80); pdf.rect(0,0,pw,92,'F');
      pdf.setFillColor(10,77,166); pdf.rect(0,88,pw,4,'F');
      pdf.setTextColor(255,255,255); pdf.setFont('helvetica','bold'); pdf.setFontSize(20); pdf.text(String(nomeLoja).slice(0,46), m, 50);
      pdf.setFont('helvetica','normal'); pdf.setFontSize(11); pdf.setTextColor(200,220,255); pdf.text('Resumo cadastral da loja', m, 72);
      function sec(t){ y+=8; pdf.setTextColor(10,77,166); pdf.setFont('helvetica','bold'); pdf.setFontSize(11); pdf.text(String(t).toUpperCase(), m, y); y+=7; pdf.setDrawColor(219,230,245); pdf.setLineWidth(1); pdf.line(m,y,pw-m,y); y+=17; }
      function kv(k,v){ if(!v) return; pdf.setTextColor(100,116,139); pdf.setFont('helvetica','normal'); pdf.setFontSize(10); pdf.text(String(k), m, y); pdf.setTextColor(15,23,42); pdf.setFont('helvetica','bold'); pdf.setFontSize(11); var lines=pdf.splitTextToSize(String(v), pw-m-170); pdf.text(lines, m+150, y); y+=Math.max(19, lines.length*14); }
      /* endereço sem duplicar o bairro (antes o bairro saía no logradouro E na linha de baixo) */
      var end=[reg.rua, reg.numero].filter(Boolean).join(', ');
      var cid=[reg.cidade, reg.uf].filter(Boolean).join('/');
      sec('Empresa'); kv('Razão social', reg.razao_social); kv('Nome fantasia', reg.nome_fantasia); kv('CNPJ', reg.cnpj);
      sec('Endereço'); kv('Logradouro', end); kv('Bairro/Compl.', [reg.bairro,reg.complemento].filter(Boolean).join(' · ')); kv('Cidade/UF', cid); kv('CEP', reg.cep);
      sec('Contato'); kv('Telefone', reg.telefone); kv('WhatsApp', reg.whatsapp); kv('E-mail', reg.email); kv('Instagram', reg.instagram); kv('Site', reg.site_url);
      var d=_ljCnhDados||{};
      if(reg.procurador_nome||reg.procurador_cpf||reg.procurador_rg||d.nome){ sec('Procurador'); kv('Nome', reg.procurador_nome||d.nome); kv('CPF', reg.procurador_cpf||d.cpf); kv('RG', reg.procurador_rg||d.rg); }
      y+=14; pdf.setTextColor(148,163,184); pdf.setFont('helvetica','normal'); pdf.setFontSize(9); pdf.text('Gerado pelo MEV Veículos · dados informados pela loja.', m, y);
      var arq='Loja-'+String(nomeLoja).replace(/[^A-Za-z0-9]+/g,'-').slice(0,24)+'.pdf';
      var blob=pdf.output('blob');
      if(acao==='ver'){ var u=URL.createObjectURL(blob); window.open(u,'_blank'); setTimeout(function(){ URL.revokeObjectURL(u); },4000); return; }
      if(acao==='share' && navigator.canShare){ try{ var file=new File([blob],arq,{type:'application/pdf'}); if(navigator.canShare({files:[file]})){ navigator.share({files:[file], title:'Resumo da loja'})['catch'](function(){}); return; } }catch(_){} }
      var u2=URL.createObjectURL(blob), a=document.createElement('a'); a.href=u2; a.download=arq; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(u2); a.remove(); },800); toast('PDF baixado.');
    }catch(e){ toast('Não consegui gerar o PDF.'); }
  }
  async function cnpjFetch(d){
    d=String(d||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length!==14) return null;
    var j=null;
    try{ var r=await fetch('https://brasilapi.com.br/api/cnpj/v1/'+d); if(r.ok){ var b=await r.json();
      /* a Receita separa o TIPO do logradouro ("RUA","AV") do nome — juntamos pra rua não sair "capenga" (ex.: "Central Silveira" -> "Rua Central Silveira") */
      var tipoLog=String(b.descricao_tipo_de_logradouro||b.descricao_tipo_logradouro||'').trim();
      var nomeLog=String(b.logradouro||'').trim();
      var ruaFull=(tipoLog && nomeLog.toUpperCase().indexOf(tipoLog.toUpperCase())!==0) ? (tipoLog+' '+nomeLog) : nomeLog;
      j={razao:b.razao_social, fant:b.nome_fantasia, cep:b.cep, rua:ruaFull, num:b.numero, comp:b.complemento, bairro:b.bairro, cidade:b.municipio, uf:b.uf, tel:b.ddd_telefone_1, email:b.email}; } }catch(_){}
    if(!j){ try{ var r2=await fetch('https://open.cnpja.com/office/'+d); if(r2.ok){ var c=await r2.json(); var e=c.address||{}; var ph=(c.phones&&c.phones[0])||null; var em=(c.emails&&c.emails[0]&&c.emails[0].address)||''; j={razao:(c.company&&c.company.name)||'', fant:c.alias||'', cep:e.zip||'', rua:e.street||'', num:e.number||'', comp:e.details||'', bairro:e.district||'', cidade:e.city||'', uf:e.state||'', tel:ph?((ph.area||'')+(ph.number||'')):'', email:em}; } }catch(_){} }
    return j;
  }
  /* ===== v385 — UM CNPJ, UMA LOJA ===========================================
     Aconteceu de verdade: duas contas cadastraram a MESMA loja (mesmo CNPJ) e
     cada uma ficou com um catálogo público, um estoque e um código de convite
     diferentes — sem enxergar uma à outra. Quem chega depois tem que ENTRAR na
     loja que já existe, não criar uma cópia.
     A trava de verdade está no banco (índice único sobre os dígitos do CNPJ).
     O que vem aqui é só a parte gentil: avisar antes de deixar digitar tudo,
     e mostrar o caminho de entrar na loja.
     Chamo a função com o nome mp_ inteiro de propósito: o tradutor do
     01-nucleo.js só prefixa o que está na lista dele, e assim não preciso
     mexer naquele arquivo. */
  var _ljCnpjBloq=null;
  async function ljCnpjDono(cnpj){
    var d=String(cnpj||'').replace(/\D/g,'');
    if(d.length!==14) return null;
    try{
      var r=await withTimeout(supa.rpc('mp_loja_cnpj_ocupado',{p_cnpj:d}), 8000);
      if(r&&r.error) return null;
      var o=r&&r.data; if(!o||!o.ocupado) return null;
      if(o.minha===true || o.sou_da_equipe===true) return null;   /* é a minha loja */
      return o;
    }catch(_){ return null; }   /* sem rede, deixa passar: o banco ainda barra */
  }
  function ljCnpjOcupadoMsg(o){
    var onde=[o.cidade,o.uf].filter(Boolean).join('/');
    var m=$('ljMsg');
    if(m){ m.className='cad-msg err';
      m.textContent='A '+(o.nome||'loja')+(onde?(' ('+onde+')'):'')+' já está cadastrada no MEV por outra pessoa. Peça o código de convite ao dono, ou envie um pedido pelo CNPJ — ele aprova pelo app.'; }
    var ec=$('cadLjEntrarCod')||$('ljEntrarCod');
    if(ec){ try{ ec.scrollIntoView({behavior:'smooth',block:'center'}); ec.focus(); }catch(_){ } }
  }
  async function cnpjBusca(v){ var d=String(v||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length!==14) return;
    var m=$('ljCnpjMsg')||$('ljMsg'); function st(cls,txt){ if(m){ m.className='cad-msg'+(cls?(' '+cls):''); m.textContent=txt; } }
    /* v759: uma busca por valor, nunca duas ao mesmo tempo, e resposta de CNPJ antigo é ignorada */
    if(cnpjBusca._ult===d && (cnpjBusca._ok || cnpjBusca._voando)) return; cnpjBusca._ult=d; cnpjBusca._voando=true;
    var _vivo=function(){ var agora=String((($('ljCnpj')||{}).value)||'').replace(/\D/g,''); return agora===d; };
    /* antes de buscar na Receita: esse CNPJ já é de alguém aqui dentro? */
    if(!(_lojaRec&&_lojaRec.id)){
      st('','Conferindo o CNPJ...');
      var dono=await ljCnpjDono(d);
      if(!_vivo()){ cnpjBusca._voando=false; return; }
      if(dono){ _ljCnpjBloq=d; cnpjBusca._ok=false; cnpjBusca._voando=false; ljCnpjOcupadoMsg(dono); return; }
    }
    _ljCnpjBloq=null;
    st('','Buscando dados do CNPJ…');
    var j=await cnpjFetch(d);
    cnpjBusca._voando=false;
    if(!_vivo()) return;
    if(!j){ cnpjBusca._ok=false; st('err','Não consegui buscar o CNPJ agora (sem internet ou serviço fora). Pode preencher à mão.'); return; }
    cnpjBusca._ok=true;
    function set(id,val){ var el=$(id); if(el && val) el.value=val; }
    set('ljRazao',j.razao); set('ljFant',j.fant||j.razao);
    if($('ljCep')&&j.cep) $('ljCep').value=cepFmt(String(j.cep)); set('ljRua',j.rua); set('ljNum',j.num); set('ljComp',j.comp); set('ljBairro',j.bairro); set('ljCidade',j.cidade); if($('ljUf')&&j.uf) $('ljUf').value=j.uf;
    if($('ljTel')&&j.tel) $('ljTel').value=foneFmt(String(j.tel));
    var _em=$('ljEmail'); if(_em && !_em.value && j.email) _em.value=String(j.email).toLowerCase();
    st('ok','Dados encontrados — confira antes de seguir.');
    try{ ljAgendaSalvar(); }catch(_){}
  }
  /* v759: a logo SALVA na hora (antes dependia de editar outro campo); status no card; falha explica */
  async function lojaLogoUp(file){ if(!file) return; var m=$('ljLogoMsg'); var bt=$('ljLogoBtn');
    if(m){ m.className='cad-msg'; m.textContent='Enviando a logo…'; } if(bt) bt.disabled=true;
    try{ var url=await avUpload(file); if(url){ var box=$('ljLogoBox'); if(box){ box.classList.remove('vazia'); box.innerHTML='<img loading="lazy" decoding="async" src="'+esc(imgCdn(url,800))+'" alt="">'; } _lojaLogoUrl=url; if(bt) bt.textContent='Trocar logo'; if(m){ m.className='cad-msg ok'; m.textContent='Logo pronta — salvando…'; }
        _ljStatusAba='dados'; ljAgendaSalvar(); clearTimeout(_ljSaveTimer); var okSalvo=await lojaSalvarAuto();
        if(m){ if(okSalvo){ m.className='cad-msg ok'; m.textContent='Logo salva.'; } else { m.className='cad-msg err'; m.textContent='A logo subiu, mas não consegui salvar agora — vou tentar de novo sozinho.'; } }
      } else { if(m){ m.className='cad-msg err'; m.textContent='Não recebi a logo de volta. Tente de novo.'; } }
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Falha ao enviar a logo. Tente outra imagem.'; } }
    finally{ if(bt) bt.disabled=false; } }
  async function lojaSalvar(){
    var m=$('ljMsg'); if(m) m.className='cad-msg';
    function gv(id){ var e=$(id); return e?(e.value||'').trim():''; }
    var reg={ cnpj:gv('ljCnpj'), razao_social:gv('ljRazao'), nome_fantasia:gv('ljFant'), cep:gv('ljCep'), rua:gv('ljRua'), numero:gv('ljNum'), bairro:gv('ljBairro'), complemento:gv('ljComp'), cidade:gv('ljCidade'), uf:gv('ljUf'), telefone:gv('ljTel'), whatsapp:gv('ljWa'), email:gv('ljEmail'), instagram:gv('ljInsta'), site_url:ljSiteNorm(gv('ljSite')) };
    var _ps=$('ljProcurador'); if(_ps){ reg.procurador_id=_ps.value||null; var _po=_ps.options[_ps.selectedIndex]; reg.procurador_nome=(_po&&_po.getAttribute('data-nome'))||''; }
    reg.procurador_cpf=gv('ljProcCpf'); reg.procurador_rg=gv('ljProcRg');
    if($('ljCnhWrap')) reg.procurador_cnh_url=_ljCnhUrl||null;
    if($('ljCardCor')) reg.card_config=_lojaCardLerForm();
    if(_lojaLogoUrl) reg.logo_url=_lojaLogoUrl; else if(_lojaRec&&_lojaRec.logo_url) reg.logo_url=_lojaRec.logo_url;
    var btn=$('tabCtx'); if(btn) btn.disabled=true; if(m){ m.className='cad-msg'; m.textContent='Salvando...'; }
    try{
      var novaLoja=false;
      if(_lojaRec&&_lojaRec.id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('loja').update(reg).eq('id',_lojaRec.id).select('id'); if(r&&r.error) throw r.error; if(!r||!r.data||!r.data.length) throw new Error('Só o dono da loja pode alterar estes dados.'); if(reg.card_config) _lojaRec.card_config=reg.card_config; }
      else { reg.user_id=meuId; reg.codigo_convite=codConvite(); var r2=await supa.from('loja').insert(reg).select().single(); if(r2&&r2.error) throw r2.error; _lojaRec=(r2&&r2.data)||reg; novaLoja=true; }
      if(novaLoja && _lojaRec && _lojaRec.id){
        var nome=''; try{ var u=await supa.auth.getUser(); nome=(u&&u.data&&u.data.user&&u.data.user.user_metadata&&u.data.user.user_metadata.nome)||''; }catch(_){}
        try{ await supa.from('loja_membros').insert({loja_id:_lojaRec.id, user_id:meuId, papel:'dono', nome:nome, email:meuEmail||''}); }catch(_){}
      }
      if(_lojaRec){ _lojaRec.procurador_cnh_url=reg.procurador_cnh_url||null; }
      if(m){ m.className='cad-msg ok'; m.textContent='Dados da loja salvos.'; } toast('Loja salva.');
      voltarHome();
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } }
    if(btn) btn.disabled=false;
  }


/* ╔═══ src/app/16b-vitrine-vendedor.js ═══════════════════════════════════ */
  /* ============================================================================
   * ETAPA 2 — VITRINE PÚBLICA DO VENDEDOR (indicador) — 06/08/2026
   *
   * O vendedor que divulga várias lojas (Etapa 1) monta a vitrine DELE:
   * marca própria, WhatsApp próprio, e CADA CARRO escolhido a dedo dentre os
   * estoques das lojas que o convidaram. Página pública: /vitrine/<apelido>.
   *
   * ESTE ARQUIVO É AUTOSSUFICIENTE de propósito (não edita o 01 nem o 16):
   *  - A whitelist mp_ (MP_TAB/MP_RPC do 01-nucleo) é ESTENDIDA aqui embaixo —
   *    mesmo escopo do IIFE, o 16b roda depois do 01, então funciona.
   *  - A tela "Lojas que eu divulgo" (telaIndicador do 16) é EMBRULHADA: a
   *    original roda igualzinha e a gente só acrescenta o cartão "Minha
   *    vitrine" por cima. Se o 16 mudar, nada aqui quebra.
   * ========================================================================== */

  /* ---- whitelist mp_: tabelas e RPCs novas desta etapa ---- */
  try{
    MP_TAB.vendedor_perfil = 1;
    MP_TAB.vendedor_veiculo = 1;
    MP_RPC.vendedor_perfil_salvar = 1;
    MP_RPC.indicador_carros_elegiveis = 1;
    MP_RPC.indicador_selecionar = 1;
    MP_RPC.vitrine_vendedor = 1;
  }catch(_){ }

  var _vvPerfil = null;      /* perfil carregado {slug,nome,logo_url,whatsapp} */
  var _vvLogoUrl = '';

  /* ---- o cartão "Minha vitrine" dentro de "Lojas que eu divulgo" ---- */
  try{
    if(typeof telaIndicador === 'function'){
      var _vvTelaIndOrig = telaIndicador;
      telaIndicador = function(){
        _vvTelaIndOrig();
        setTimeout(vvBotaoNaTela, 80);
        setTimeout(vvBotaoNaTela, 600);   /* a tela carrega a lista async */
      };
    }
  }catch(_){ }
  async function vvBotaoNaTela(){
    try{
      if(document.getElementById('vvAtalho')) return;
      var pg = document.querySelector('#secoes .info-pg'); if(!pg) return;
      var h2 = pg.querySelector('h2'); if(!h2) return;
      var d = document.createElement('div');
      d.id = 'vvAtalho';
      d.style.cssText = 'background:linear-gradient(135deg,#0a4da6,#1d6fd0);color:#fff;border-radius:14px;padding:14px 16px;margin:10px 0 14px;display:flex;align-items:center;gap:12px;cursor:pointer';
      d.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M8 13h8"/></svg>'+
        '<div style="flex:1"><b style="font-size:15px">Minha vitrine pública</b><br><span style="font-size:12.5px;opacity:.85">Escolha carros das lojas e compartilhe o SEU link — o cliente chama no SEU WhatsApp.</span></div>'+
        '<span style="font-size:20px;opacity:.8">›</span>';
      d.onclick = telaVitrineVendedor;
      h2.parentNode.insertBefore(d, h2.nextSibling);
      /* 06/08 (pedido): a PRÓPRIA loja do usuário já aparece aqui — ela não
         precisa de código de indicador (o banco também já a considera na
         curadoria e na vitrine, via mp__donos_do_vendedor). */
      try{
        var rl = await supa.from('loja').select('nome_fantasia,cidade,uf').limit(1);
        var minha = rl && rl.data && rl.data[0];
        if(minha && minha.nome_fantasia && !document.getElementById('vvMinhaLoja')){
          var m = document.createElement('div');
          m.id = 'vvMinhaLoja';
          m.style.cssText = 'background:#e7f6ed;border:1px solid #b7e4c7;border-radius:12px;padding:11px 14px;margin:0 0 12px;display:flex;align-items:center;gap:10px';
          m.innerHTML = '<span style="font-size:18px">🏪</span><div style="flex:1;min-width:0">'+
            '<b style="font-size:13.5px;color:#0f5132">'+esc(minha.nome_fantasia)+'</b>'+
            '<span style="font-size:12px;color:#2d6a4f"> · sua loja — os carros dela já entram na sua vitrine, sem código</span></div>';
          d.parentNode.insertBefore(m, d.nextSibling);
        }
      }catch(_){ }
    }catch(_){ }
  }

  /* ============================ A TELA ============================ */
  async function telaVitrineVendedor(){
    mevTabSet('');
    $('secoes').innerHTML = _cadBack()+
      '<div class="info-pg"><h2>Minha vitrine</h2>'+
      '<div id="vvWrap"><div class="cli-empty">Carregando...</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna');
    window.scrollTo(0,0); try{ fabFoto(false); }catch(_){ }
    _cadWireBack(); try{ voltarTab(telaIndicador); }catch(_){ }
    await vvCarregarTudo();
  }

  async function vvCarregarTudo(){
    var wrap = $('vvWrap'); if(!wrap) return;
    var perfil = null, carros = [];
    try{
      var rp = await supa.from('vendedor_perfil').select('slug,nome,logo_url,whatsapp').limit(1);
      perfil = (rp && rp.data && rp.data[0]) || null;
    }catch(_){ }
    try{
      var rc = await supa.rpc('indicador_carros_elegiveis');
      carros = (rc && rc.data) || [];
    }catch(_){ }
    _vvPerfil = perfil; _vvLogoUrl = (perfil && perfil.logo_url) || '';
    vvPinta(perfil, carros);
  }

  function vvLink(slug){ return location.origin + '/vitrine/' + encodeURIComponent(slug||''); }

  function vvPinta(perfil, carros){
    var wrap = $('vvWrap'); if(!wrap) return;
    var slug = (perfil && perfil.slug) || '';
    var sel = carros.filter(function(c){ return c.selecionado; }).length;

    /* ---- bloco do link (só quando o perfil existe) ---- */
    var linkHtml = slug
      ? ('<div class="card" style="padding:14px 16px;margin-bottom:14px">'+
          '<div style="font-weight:800;font-size:13px;color:#64748b;margin-bottom:6px">SUA VITRINE ('+sel+' carro'+(sel===1?'':'s')+')</div>'+
          '<div style="font-size:14px;font-weight:800;color:#0a4da6;word-break:break-all">'+esc(vvLink(slug))+'</div>'+
          '<div style="display:flex;gap:8px;margin-top:11px;flex-wrap:wrap">'+
            '<button type="button" class="btn btn-azul" id="vvVer" style="flex:1;min-width:110px">Abrir</button>'+
            '<button type="button" class="btn btn-azul" id="vvShare" style="flex:1;min-width:110px">Compartilhar</button>'+
          '</div></div>')
      : '<div class="cli-empty" style="margin-bottom:14px"><b>Monte sua vitrine em 2 passos</b>1) Preencha sua marca abaixo e salve. 2) Escolha os carros.</div>';

    /* ---- perfil ---- */
    var perfilHtml =
      '<div class="card" style="padding:14px 16px;margin-bottom:14px">'+
        '<div style="font-weight:800;font-size:13px;color:#64748b;margin-bottom:8px">SUA MARCA</div>'+
        '<label class="crm-lb" style="display:block;font-size:11px;font-weight:800;color:#94a3b8;margin:6px 0 3px">NOME (aparece no topo da vitrine)</label>'+
        '<input class="cad-in" id="vvNome" placeholder="Ex.: João Seminovos" value="'+esc((perfil&&perfil.nome)||'')+'">'+
        '<label class="crm-lb" style="display:block;font-size:11px;font-weight:800;color:#94a3b8;margin:10px 0 3px">SEU WHATSAPP (recebe os clientes)</label>'+
        '<input class="cad-in" id="vvZap" inputmode="tel" placeholder="(51) 99999-9999" value="'+esc((perfil&&perfil.whatsapp)||'')+'">'+
        '<label class="crm-lb" style="display:block;font-size:11px;font-weight:800;color:#94a3b8;margin:10px 0 3px">APELIDO DO LINK (letras, números e traço)</label>'+
        '<input class="cad-in" id="vvSlug" autocapitalize="none" placeholder="joao-seminovos" value="'+esc(slug)+'">'+
        '<div style="display:flex;align-items:center;gap:10px;margin-top:12px">'+
          '<div id="vvLogoBox" style="width:52px;height:52px;border-radius:12px;background:#eef2f7;overflow:hidden;flex:none;display:flex;align-items:center;justify-content:center;color:#94a3b8;font-size:11px">'+
            (_vvLogoUrl?('<img src="'+esc(imgCdn(_vvLogoUrl,200))+'" style="width:100%;height:100%;object-fit:cover">'):'logo')+'</div>'+
          '<button type="button" class="btn" id="vvLogoBtn" style="flex:1">'+(_vvLogoUrl?'Trocar logo':'Enviar logo (opcional)')+'</button>'+
          '<input type="file" id="vvLogoFile" accept="image/*" style="display:none">'+
        '</div>'+
        '<div class="msg" id="vvMsg" style="min-height:16px;margin-top:6px"></div>'+
        '<button type="button" class="btn btn-azul" id="vvSalvar" style="width:100%;margin-top:6px">Salvar minha vitrine</button>'+
      '</div>';

    /* ---- curadoria (agrupada por loja) ---- */
    var curHtml = '';
    if(!carros.length){
      curHtml = '<div class="cli-empty"><b>Nenhum carro disponível ainda</b>Peça o código de indicador pra uma loja em "Lojas que eu divulgo" — os carros dela aparecem aqui pra você escolher.</div>';
    } else {
      var porLoja = {};
      carros.forEach(function(c){ var k=c.loja_nome||'Loja'; (porLoja[k]=porLoja[k]||[]).push(c); });
      curHtml = '<div style="font-weight:800;font-size:13px;color:#64748b;margin:4px 0 8px">ESCOLHA OS CARROS ('+sel+' na vitrine)</div>';
      Object.keys(porLoja).sort().forEach(function(lj){
        curHtml += '<div style="font-size:11px;font-weight:900;letter-spacing:.4px;color:#94a3b8;text-transform:uppercase;margin:12px 2px 6px">'+esc(lj)+'</div>';
        porLoja[lj].forEach(function(c){
          var nome=[c.marca,c.modelo].filter(Boolean).join(' ');
          var ano=(c.ano&&c.ano_modelo&&String(c.ano)!==String(c.ano_modelo))?(c.ano+'/'+c.ano_modelo):(c.ano_modelo||c.ano||'');
          var preco=Number(c.preco_anuncio)?('R$ '+Number(c.preco_anuncio).toLocaleString('pt-BR',{maximumFractionDigits:0})):'';
          curHtml += '<div class="card" style="padding:10px 12px;margin-bottom:8px;display:flex;align-items:center;gap:10px">'+
            (c.foto?('<img src="'+esc(c.foto)+'" style="width:56px;height:44px;border-radius:9px;object-fit:cover;flex:none" loading="lazy">'):'<div style="width:56px;height:44px;border-radius:9px;background:#eef2f7;flex:none"></div>')+
            '<div style="flex:1;min-width:0"><div style="font-weight:800;font-size:13.5px;line-height:1.25">'+esc(nome)+(ano?(' '+esc(ano)):'')+'</div>'+
            '<div style="font-size:12px;color:#64748b">'+esc(preco)+'</div></div>'+
            '<button type="button" data-vv="'+esc(c.estoque_id)+'" data-on="'+(c.selecionado?'1':'0')+'" style="flex:none;border-radius:10px;padding:8px 12px;font-size:12px;font-weight:800;font-family:inherit;cursor:pointer;border:1.5px solid '+(c.selecionado?'#0f9d58;background:#e7f6ed;color:#0f9d58':'#e4ebf5;background:#fff;color:#0a4da6')+'">'+
              (c.selecionado?'✓ Na vitrine':'+ Adicionar')+'</button>'+
          '</div>';
        });
      });
    }

    wrap.innerHTML = linkHtml + perfilHtml + curHtml;

    /* ---- fios ---- */
    var bt;
    if((bt=$('vvVer'))) bt.onclick=function(){ try{ window.open(vvLink((_vvPerfil||{}).slug),'_blank'); }catch(_){ location.href=vvLink((_vvPerfil||{}).slug); } };
    if((bt=$('vvShare'))) bt.onclick=function(){
      var u=vvLink((_vvPerfil||{}).slug), t='Minha vitrine de veículos';
      if(navigator.share){ navigator.share({title:t,text:t,url:u})['catch'](function(){}); }
      else { try{ navigator.clipboard.writeText(u); toast('Link copiado.'); }catch(_){ prompt('Copie o link:',u); } }
    };
    if((bt=$('vvLogoBtn'))) bt.onclick=function(){ var f=$('vvLogoFile'); if(f) f.click(); };
    var ff=$('vvLogoFile');
    if(ff) ff.onchange=async function(){
      var file=this.files&&this.files[0]; if(!file) return;
      toast('Enviando logo...');
      try{ var url=await avUpload(file); if(url){ _vvLogoUrl=url; var box=$('vvLogoBox'); if(box) box.innerHTML='<img loading="lazy" decoding="async" src="'+esc(imgCdn(url,800))+'" style="width:100%;height:100%;object-fit:cover">'; var b2=$('vvLogoBtn'); if(b2) b2.textContent='Trocar logo'; toast('Logo pronta. Toque em Salvar.'); } }
      catch(_){ toast('Falha ao enviar a logo.'); }
    };
    if((bt=$('vvSalvar'))) bt.onclick=vvSalvarPerfil;
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-vv]'),function(b){
      b.onclick=async function(){
        var id=b.getAttribute('data-vv'), liga=b.getAttribute('data-on')!=='1';
        b.disabled=true;
        try{
          var r=await supa.rpc('indicador_selecionar',{p_estoque_id:id,p_on:liga});
          var d=r&&r.data;
          if(d&&d.ok){ await vvCarregarTudo(); return; }
          toast(d&&d.erro==='nao_elegivel'?'Este carro não está mais disponível pra você.':'Não consegui. Tente de novo.');
        }catch(_){ toast('Sem conexão. Tente de novo.'); }
        b.disabled=false;
      };
    });
  }

  async function vvSalvarPerfil(){
    var msg=$('vvMsg'), b=$('vvSalvar'); if(b) b.disabled=true; if(msg) msg.textContent='';
    var nome=String((($('vvNome')||{}).value)||'').trim();
    var zap=String((($('vvZap')||{}).value)||'').trim();
    var slug=String((($('vvSlug')||{}).value)||'').trim();
    if(!nome){ if(msg) msg.textContent='Dê um nome pra sua vitrine.'; if(b) b.disabled=false; return; }
    if(!zap.replace(/\D/g,'')){ if(msg) msg.textContent='Informe seu WhatsApp — é ele que recebe os clientes.'; if(b) b.disabled=false; return; }
    try{
      var r=await supa.rpc('vendedor_perfil_salvar',{p_slug:slug,p_nome:nome,p_logo_url:_vvLogoUrl,p_whatsapp:zap});
      var d=r&&r.data;
      if(d&&d.ok){ toast('Vitrine salva!'); await vvCarregarTudo(); return; }
      var e=(d&&d.erro)||'';
      if(msg) msg.textContent =
        e==='slug_ocupado' ? 'Esse apelido já está em uso. Tente outro (ex.: acrescente sua cidade).' :
        e==='slug_curto'   ? 'O apelido precisa de pelo menos 3 letras.' :
        e==='slug_invalido'? 'Use só letras, números e traço no apelido.' :
        'Não consegui salvar. Tente de novo.';
    }catch(_){ if(msg) msg.textContent='Sem conexão. Tente de novo.'; }
    if(b) b.disabled=false;
  }

/* ╔═══ src/app/16c-prova-social.js ═══════════════════════════════════════ */
  /* ============================================================================
   * 16c — PROVA SOCIAL: "Sobre mim" (vendedor) e "Sobre nós" (loja) — 10/08/2026
   *
   * UM componente só, usado em DOIS lugares:
   *   - Minha conta → aba "Sobre mim"  → grava em mp_perfil.prova_social
   *   - Minha loja  → aba "Sobre nós"  → grava em mp_loja.prova_social
   *
   * Formato guardado (igual nos dois):
   *   { sobre:'texto', desde:'2008',
   *     fotos:[{u,l}],      // fotos da loja (só no modo loja)
   *     entregas:[{u,l}],   // fotos de entrega de carro
   *     depos:[{u}],        // prints de conversa (depoimento em imagem)
   *     on:true }           // aparece no catálogo público
   *
   * As imagens sobem pelo MESMO caminho das fotos de veículo (avUpload → bucket
   * público). Quem tiver o endereço da imagem vê ela, publicada ou não — por
   * isso a tela pede pra cobrir o telefone do cliente antes de enviar o print.
   *
   * Este arquivo é NOVO de propósito: não disputa linha nenhuma com o 11 e o 16,
   * que só ganham a aba e a chamada. Como todos os pedaços de src/app viram um
   * IIFE só, as funções daqui são enxergadas pelos módulos anteriores.
   * ========================================================================== */

  var PS_MAX = 12;            /* fotos por mural */
  var _psDados = { cad:null, lj:null };
  var _psAlvo  = { cad:'entregas', lj:'entregas' };
  var _psTimer = { cad:null, lj:null };

  /* Ícone das abas (mesmo traço dos outros menus) */
  var PS_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/><path d="m12 8 1.1 2.3 2.4.3-1.8 1.7.5 2.4-2.2-1.2-2.2 1.2.5-2.4-1.8-1.7 2.4-.3z"/></svg>';

  function psNorm(o){
    o = o || {};
    function lista(a){
      return (Array.isArray(a)?a:[])
        .filter(function(x){ return x && x.u; })
        .slice(0, PS_MAX)
        .map(function(x){ return { u:String(x.u), l:String(x.l||'').slice(0,80) }; });
    }
    return {
      sobre: String(o.sobre||'').slice(0,900),
      desde: String(o.desde||'').replace(/\D/g,'').slice(0,4),
      fotos: lista(o.fotos), entregas: lista(o.entregas), depos: lista(o.depos),
      on: o.on !== false
    };
  }
  function psLer(px){ return psNorm(_psDados[px]); }

  /* ---------------- o mural de fotos (grade + botão de adicionar) ---------- */
  function psMuralHtml(px, chave, itens, comLegenda){
    var t = (itens||[]).map(function(it,i){
      return '<div class="ps-thumb">'+
        '<img src="'+esc(it.u)+'" alt="" loading="lazy">'+
        '<button type="button" class="ps-del" data-ps="'+chave+'" data-i="'+i+'" aria-label="Remover foto">&#10005;</button>'+
        (comLegenda ? ('<input class="ps-leg" data-ps="'+chave+'" data-i="'+i+'" value="'+esc(it.l||'')+'" placeholder="Legenda (opcional)" maxlength="80">') : '')+
        '</div>';
    }).join('');
    var cheio = (itens||[]).length >= PS_MAX;
    /* print de conversa é vertical: no quadrado, mostra o começo da conversa */
    return '<div class="ps-mural'+(comLegenda?'':' alto')+'" id="'+px+'PsM_'+chave+'">'+t+
      (cheio ? '' : '<button type="button" class="ps-add" data-ps="'+chave+'" aria-label="Adicionar foto"><span>+</span></button>')+
      '</div>';
  }

  /* ---------------- o painel, em dois pedaços -------------------------------
     v389: a Minha conta separou "Sobre mim" (aba Dados pessoais) dos murais
     (aba Fotos). Por isso o painel virou DUAS metades — texto e fotos — e o
     psPainelHtml de sempre (usado inteiro pela Minha loja) só cola as duas. */
  function psTextoHtml(px, modo, d){
    var loja = (modo === 'loja');
    return '<div class="cad-grid2">'+
        '<div>'+
          '<label class="cad-lbl" for="'+px+'PsSobre">'+(loja?'Sobre nós':'Sobre mim')+'</label>'+
          '<textarea class="cad-in ps-ta" id="'+px+'PsSobre" rows="5" maxlength="900" placeholder="'+
            (loja ? 'Quem é a loja, há quanto tempo está na cidade e como vocês atendem.'
                  : 'Há quanto tempo você vende, o que você resolve pro cliente e como gosta de atender.')+'">'+esc(d.sobre)+'</textarea>'+
        '</div>'+
        '<div>'+
          '<label class="cad-lbl" for="'+px+'PsDesde">'+(loja?'Loja aberta desde':'Vendendo desde')+'</label>'+
          '<input class="cad-in" id="'+px+'PsDesde" inputmode="numeric" maxlength="4" value="'+esc(d.desde)+'" placeholder="2008">'+
          '<label class="vd-ck ps-ck'+(d.on?' on':'')+'"><input type="checkbox" id="'+px+'PsOn"'+(d.on?' checked':'')+'><span>Mostrar no catálogo</span></label>'+
        '</div>'+
      '</div>';
  }
  /* 🔴 v794 (§6.3 do PROJETO-2026-08-31-top-bar-e-dock-fixo-nas-paginas)
     "não deixar três uploads empilhados somente na coluna esquerda com a
     direita vazia".
     Os três murais eram irmãos soltos — título, mural, título, mural — e
     empilhavam numa coluna só, deixando metade do computador em branco.
     Agora cada um vai dentro de um `.ps-bloco`, e os blocos moram num
     `.ps-murais`. O CSS faz o resto: três colunas no computador largo, duas
     no tablet, uma no celular.
     ⚠️ O embrulho é de propósito, e não um grid direto no .ps-wrap: o
     psMuraisPinta() repinta o mural trocando o `outerHTML` DELE. Se o mural
     fosse o próprio item da grade, cada repintura destruiria e recriaria o
     item — e com ele o lugar na grade. Com o embrulho, quem é trocado é o
     filho; a coluna fica de pé. */
  function _psBloco(tit, aviso, mural){
    return '<div class="ps-bloco">'+
      '<div class="cad-sec-tit">'+tit+'</div>'+
      (aviso ? '<div class="ps-aviso">'+aviso+'</div>' : '')+
      mural+'</div>';
  }
  function psFotosHtml(px, modo, d){
    var loja = (modo === 'loja');
    return '<div class="ps-murais'+(loja?' tres':' dois')+'">'+
      (loja ? _psBloco('Fotos da loja','',psMuralHtml(px,'fotos',d.fotos,true)) : '')+
      _psBloco('Entregas','',psMuralHtml(px,'entregas',d.entregas,true))+
      _psBloco('Depoimentos',
        'Print da conversa. Cubra o telefone do cliente antes de enviar.',
        psMuralHtml(px,'depos',d.depos,false))+
      '</div>'+
      '<input type="file" id="'+px+'PsFile" accept="image/*" multiple style="display:none">';
  }
  function psPainelHtml(px, modo, dados){
    var d = psNorm(dados); _psDados[px] = d;
    var loja = (modo === 'loja');
    return '<div class="ps-wrap">'+
      psTextoHtml(px, modo, d)+
      psFotosHtml(px, modo, d)+
      (loja ? '' : '<div class="cad-autosave vazio" id="'+px+'PsSave"></div>')+
      '</div>';
  }

  /* repinta só os murais (mantém foco do texto e a rolagem) */
  function psMuraisPinta(px, modo){
    var d = psLer(px), loja = (modo === 'loja');
    var mapa = loja ? [['fotos',true],['entregas',true],['depos',false]]
                    : [['entregas',true],['depos',false]];
    mapa.forEach(function(c){
      var el = $(px+'PsM_'+c[0]); if(!el) return;
      el.outerHTML = psMuralHtml(px, c[0], d[c[0]], c[1]);
    });
  }

  /* ---------------- ligação (um ouvinte só, por delegação) ----------------- */
  function psWire(px, modo, agendarSalvar){
    var box = $(px+'PsBox'); if(!box) return;
    var salvar = (typeof agendarSalvar === 'function') ? agendarSalvar
               : function(){ psAgendaSalvar(px, modo); };

    var ta = $(px+'PsSobre');
    if(ta){ ta.addEventListener('input', function(){ _psDados[px].sobre = this.value; salvar(); }); try{ avTaGrow(ta); }catch(_){ } }
    var de = $(px+'PsDesde');
    if(de) de.addEventListener('input', function(){ this.value = String(this.value||'').replace(/\D/g,'').slice(0,4); _psDados[px].desde = this.value; salvar(); });
    var on = $(px+'PsOn');
    if(on) on.addEventListener('change', function(){
      _psDados[px].on = this.checked;
      var lb = this.closest('.vd-ck'); if(lb) lb.classList.toggle('on', this.checked);
      salvar();
    });

    /* Os dois ouvintes abaixo são por DELEGAÇÃO e vivem na CAIXA, que sobrevive
       ao repinte dos murais. Sem esta trava eles seriam registrados de novo a
       cada repinte e um clique de apagar apagaria duas fotos. */
    if(box.getAttribute('data-ps-lig')!=='1'){
      box.setAttribute('data-ps-lig','1');
      box.addEventListener('click', function(ev){
        var add = ev.target.closest && ev.target.closest('.ps-add');
        if(add){ _psAlvo[px] = add.getAttribute('data-ps')||'entregas'; var f=$(px+'PsFile'); if(f){ f.value=''; f.click(); } return; }
        var del = ev.target.closest && ev.target.closest('.ps-del');
        if(del){
          var k = del.getAttribute('data-ps'), i = parseInt(del.getAttribute('data-i'),10)||0;
          var arr = _psDados[px] && _psDados[px][k]; if(!arr) return;
          arr.splice(i,1); psMuraisPinta(px, modo); salvar();
        }
      });
      box.addEventListener('input', function(ev){
        var leg = ev.target.closest && ev.target.closest('.ps-leg'); if(!leg) return;
        var k = leg.getAttribute('data-ps'), i = parseInt(leg.getAttribute('data-i'),10)||0;
        var arr = _psDados[px] && _psDados[px][k]; if(!arr || !arr[i]) return;
        arr[i].l = String(leg.value||'').slice(0,80); salvar();
      });
    }

    var file = $(px+'PsFile');
    if(file) file.onchange = function(){
      var fs = this.files; this.value = '';
      psSubirFotos(px, modo, _psAlvo[px], fs, salvar);
    };
  }

  async function psSubirFotos(px, modo, chave, files, salvar){
    if(!files || !files.length) return;
    var arr = _psDados[px] && _psDados[px][chave]; if(!arr) return;
    var cabe = PS_MAX - arr.length;
    if(cabe <= 0){ toast('Limite de '+PS_MAX+' fotos neste mural.'); return; }
    var lista = Array.prototype.slice.call(files, 0, cabe);
    if(files.length > cabe) toast('Só cabem mais '+cabe+' foto(s) aqui.');
    toast(lista.length>1 ? 'Enviando fotos...' : 'Enviando foto...');
    for(var i=0;i<lista.length;i++){
      try{
        var url = await avUpload(lista[i]);
        if(url){ arr.push({ u:url, l:'' }); psMuraisPinta(px, modo); if(salvar) salvar(); }
      }catch(e){ toast('Falha ao enviar uma foto.'); }
    }
    toast('Pronto.');
  }

  /* ---------------- salvar (só o modo vendedor tem salvamento próprio) -----
     No modo loja quem grava é o autosave que já existe na Minha loja: o
     lojaColeta() leva o prova_social junto, num UPDATE só. Dois salvamentos
     na mesma linha correriam um por cima do outro. */
  function psAgendaSalvar(px, modo){
    if(modo === 'loja'){ try{ ljAgendaSalvar(); }catch(_){ } return; }
    var ind = $(px+'PsSave');
    if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; }
    clearTimeout(_psTimer[px]);
    _psTimer[px] = setTimeout(function(){ psSalvarPerfil(px); }, 1100);
  }
  async function psSalvarPerfil(px){
    var ind = $(px+'PsSave'), d = psLer(px);
    if(!meuId){ if(ind){ ind.className='cad-autosave err'; ind.textContent='Entre na conta pra salvar.'; } return; }
    try{
      var up = await supa.from('perfil').upsert({ user_id:meuId, prova_social:d, atualizado_em:new Date().toISOString() }, { onConflict:'user_id' });
      if(up && up.error) throw up.error;
      if(ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo';
        setTimeout(function(){ var i2=$(px+'PsSave'); if(i2&&i2.classList.contains('ok')){ i2.className='cad-autosave vazio'; i2.textContent=''; } }, 2200); }
    }catch(e){
      if(ind){ ind.className='cad-autosave err'; ind.textContent='Sem conexão — tentando de novo…'; }
      clearTimeout(_psTimer[px]); _psTimer[px] = setTimeout(function(){ psSalvarPerfil(px); }, 3000);
    }
  }

  /* Minha conta abre NA HORA e o "Sobre mim" mora em outra tabela: o painel
     nasce vazio e se repinta quando o banco responde.
     v389: a Minha conta tem DUAS caixas — #cadPsTexto (aba Dados pessoais,
     com o "Sobre mim") e #cadPsBox (aba Fotos, com entregas/depoimentos).
     Se a caixa de texto não existir (layout antigo), o painel inteiro vai
     pro cadPsBox como antes. */
  async function psCarregarPerfil(opcoes){
    opcoes=opcoes||{};
    var comTexto=opcoes.texto!==false;
    if(!meuId) return;
    var box = $('cadPsBox'); if(!box) return;
    try{
      var r = await withTimeout(supa.from('perfil').select('prova_social').eq('user_id',meuId).limit(1), 9000);
      var d = (r && r.data && r.data[0] && r.data[0].prova_social) || null;
      var b2 = $('cadPsBox'); if(!b2) return;                 /* trocou de tela */
      if($('cadPsSobre') && document.activeElement === $('cadPsSobre')) return;  /* já está digitando */
      var tx = $('cadPsTexto');
      if(tx){
        var dn = psNorm(d); _psDados.cad = dn;
        tx.innerHTML = '<div class="ps-wrap">'+psTextoHtml('cad','vendedor',dn)+'<div class="cad-autosave vazio" id="cadPsSave"></div></div>';
        b2.innerHTML = '<div class="ps-wrap">'+psFotosHtml('cad','vendedor',dn)+'</div>';
      } else if(comTexto) {
        b2.innerHTML = psPainelHtml('cad','vendedor', d);
      } else {
        /* v1188 — módulos sem catálogo conservam os murais/fotos, mas não
           recriam por fallback os campos públicos escondidos da aba Dados. */
        var dn2=psNorm(d); _psDados.cad=dn2;
        b2.innerHTML = '<div class="ps-wrap">'+psFotosHtml('cad','vendedor',dn2)+'</div>';
      }
      psWire('cad','vendedor');
    }catch(_){ }
  }

/* ╔═══ src/app/17-vendas.js ══════════════════════════════════════════════ */
  /* ================= VENDAS (funil: negociação → entrega → pós-venda) ================= */
  var _vendas=[], _vendaFiltro='', _vendaEstFiltro='', _vendaEstOrdem='padrao', _vendaRec=null;
  var ICO_VENDA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
  var VENDA_ETAPAS=[{k:'negociacao',t:'Negociação',c:'#0a4da6'},{k:'vendido',t:'Vendido',c:'#7c3aed'},{k:'entrega',t:'Em entrega',c:'#b45309'},{k:'entregue',t:'Entregue',c:'#16a34a'},{k:'posvenda',t:'Pós-venda',c:'#0891b2'}];
  var VENDA_FORMAS=['À vista','Financiamento','Consórcio','Troca + volta','Cartão','Outro'];
  var ENTREGA_ITENS=['Contrato / recibo assinado','Vistoria feita','Documento (CRV / ATPV-e)','Comunicação de venda ao Detran','Chave reserva','Manual do veículo','Limpeza / estética','Tanque combinado'];
  function vendaEtapaInfo(k){ return VENDA_ETAPAS.filter(function(e){return e.k===k;})[0]||VENDA_ETAPAS[0]; }
  /* ================= v157: CAIXA QUE FILTRA ENQUANTO DIGITA (autocompletar) =================
     Um so widget usado no campo Cliente e no campo Placa do usado. A lista aparece
     embaixo do campo e vai filtrando conforme se digita (sem ligar acento/maiuscula). */
  function _acNorm(t){ t=String(t||'').toLowerCase(); try{ t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(_){} return t; }
  function _acCaixa(id,valor,ph,extra){
    return '<div class="mev-ac" id="'+id+'Box">'+
      '<input class="cad-in mev-ac-in" id="'+id+'" value="'+esc(valor||'')+'" placeholder="'+esc(ph)+'" autocomplete="off" spellcheck="false"'+(extra||'')+'>'+
      '<div class="mev-ac-list" id="'+id+'List" style="display:none"></div></div>';
  }
  /* fonte() devolve [{txt, sub, busca, ...}] · onPick(item) roda quando escolhem */
  function _acWire(id,fonte,onPick,semFiltro){
    var inp=$(id), lst=$(id+'List'); if(!inp||!lst) return;
    var atual=[];
    function fecha(){ lst.style.display='none'; }
    function pinta(){
      var q=_acNorm(inp.value); var itens=[];
      try{ itens=fonte()||[]; }catch(_){ itens=[]; }
      atual=itens.filter(function(o){ return (!q||semFiltro) ? true : (_acNorm(o.busca||o.txt).indexOf(q)>=0); }).slice(0,8);
      if(!atual.length){ fecha(); return; }
      lst.innerHTML=atual.map(function(o,i){ return '<button type="button" class="mev-ac-op" data-i="'+i+'"><span class="t">'+esc(o.txt)+'</span>'+(o.sub?('<span class="s">'+esc(o.sub)+'</span>'):'')+'</button>'; }).join('');
      Array.prototype.forEach.call(lst.querySelectorAll('.mev-ac-op'),function(b){
        b.onmousedown=function(e){ e.preventDefault(); };
        b.onclick=function(){ var it=atual[+b.getAttribute('data-i')]; fecha(); if(it) onPick(it); };
      });
      lst.style.display='block';
    }
    inp.addEventListener('focus',pinta);
    inp.addEventListener('input',pinta);
    inp.addEventListener('blur',function(){ setTimeout(fecha,200); });
    inp.addEventListener('keydown',function(e){ if(e.key==='Escape') fecha(); });
  }
  /* Lista de placas JA conhecidas: historico de consultas + estoque da loja.
     Serve pro campo da troca sugerir sem precisar gastar consulta nova. */
  function _vpPlacaBase(){
    var out=[], visto={};
    try{ (histLer()||[]).forEach(function(x){
      var p=String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); if(!p||visto[p]) return; visto[p]=1;
      var nm=String(x.modelo||'')||'Veículo';
      out.push({ placa:p, txt:p, sub:nm+((x.v&&x.v.fipe)?(' · FIPE '+brl(x.v.fipe)):''), busca:p+' '+nm, v:(x.v||null), modelo:nm, fonte:'histórico' });
    }); }catch(_){}
    try{ (_estoque||[]).forEach(function(e){
      var p=String(e.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,''); if(!p||visto[p]) return; visto[p]=1;
      var nm=((e.marca||'')+' '+(e.modelo||'')).trim()||'Veículo';
      var fp=Number(e.fipe||(e.extras&&e.extras.fipe)||0)||0;
      out.push({ placa:p, txt:p, sub:nm+(e.ano?(' · '+e.ano):''), busca:p+' '+nm, v:{marca:e.marca||'',modelo:e.modelo||'',ano:e.ano||'',fipe:fp}, modelo:nm, fonte:'estoque' });
    }); }catch(_){}
    return out;
  }
  function vendaClienteOptions(selId){ return (_clientes||[]).map(function(c){ return '<option value="'+esc(c.id)+'"'+(String(selId||'')===String(c.id)?' selected':'')+'>'+esc(c.nome||'Cliente')+'</option>'; }).join(''); }
  /* ================= COTAÇÕES SALVAS (v189) =================
     Toda cotação que você salva na tela de venda cai aqui. A lista é da LOJA
     TODA — a regra de segurança do banco já libera as vendas dos colegas — e
     cada card mostra quem fez. Tocar no card abre a cotação do jeito que ela
     foi salva, com todos os valores. */
  var _cotNomes=null, _cotFiltro='';
  async function cotNomesCarregar(){
    if(_cotNomes) return _cotNomes;
    _cotNomes={};
    try{
      var r=await withTimeout(supa.from('loja_membros').select('user_id,nome,email'),9000);
      ((r&&r.data)||[]).forEach(function(m){ _cotNomes[m.user_id]=m.nome||m.email||'Vendedor'; });
    }catch(_){ }
    return _cotNomes;
  }
  function _cotPor(v){
    var n=(_cotNomes&&_cotNomes[v.user_id])||'';
    if(!n && String(v.user_id||'')===String(meuId)) n=(meuNome||'Você');
    return n||'Vendedor';
  }
  function _cotData(v){
    var t=v.atualizado_em||v.criado_em; if(!t) return '';
    try{ var d=new Date(t); return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear(); }catch(_){ return ''; }
  }
  function _cotTemTroca(v){ var p=v&&v.proposta; return !!(p&&p.troca&&p.troca.tem&&(+p.troca.avaliacao||0)>0); }
  function _cotFinanciada(v){ var p=v&&v.proposta; return !!(p&&p.pag&&p.pag.tipo==='parcelado'); }
  function _cotMinha(v){ return String(v.user_id||'')===String(meuId); }
  /* só entra na lista o que TEM proposta salva (cotação de verdade) */
  /* v195 — quem foi marcado como VENDA FECHADA sai desta lista e passa a
     aparecer na pagina "Vendas fechadas". Nada e' apagado: e' a mesma linha do
     banco, so' muda a prateleira em que ela fica. */
  function _cotTodas(){ return (_vendas||[]).filter(function(v){ return !!(v&&v.proposta) && !v.fechada; }); }
  /* ============== v191 — SITUACAO E RETORNO DA COTACAO ==============
     A cotacao salva agora tem DONO DO PROXIMO PASSO: em que pe' esta e em que
     dia voce vai voltar a falar com o cliente. Nada disso mexe no banco: mora
     dentro do proprio jsonb `proposta`, num pedacinho chamado `crm`.
     E o mais importante — quando a cotacao esta ligada a um cliente, o retorno
     tambem e' escrito no HISTORICO do CRM que ja existe na pagina Clientes.
     Um lugar so' pra memoria do cliente, nao dois. */
  var COT_SIT=[['','Sem situacao','#94a3b8'],
               ['negociando','Negociando','#0a4da6'],
               ['aguardando','Aguardando resposta','#b45309'],
               ['sem_resposta','Parou de responder','#64748b'],
               ['perdida','Perdida','#dc2626'],
               ['fechada','Fechou negocio','#16a34a']];
  function cotSitInfo(k){
    k=String(k||'');
    for(var i=0;i<COT_SIT.length;i++){ if(COT_SIT[i][0]===k) return {k:COT_SIT[i][0],t:COT_SIT[i][1],c:COT_SIT[i][2]}; }
    return {k:'',t:COT_SIT[0][1],c:COT_SIT[0][2]};
  }
  function cotCrm(v){ var p=(v&&v.proposta)||{}; return p.crm||{}; }
  function _cotHoje(){ try{ var d=new Date(); return new Date(d.getTime()-d.getTimezoneOffset()*6e4).toISOString().slice(0,10); }catch(_){ return ''; } }
  function _cotMaisDias(n){ try{ var d=new Date(); d.setDate(d.getDate()+n); return new Date(d.getTime()-d.getTimezoneOffset()*6e4).toISOString().slice(0,10); }catch(_){ return ''; } }
  function cotRetStatus(v){
    var r=String(cotCrm(v).retorno||''); if(!r) return null;
    var h=_cotHoje();
    if(r<h)  return {k:'atrasado', t:'Retorno atrasado \u00b7 '+_dataBr(r), c:'#dc2626', bg:'#fee2e2'};
    if(r===h) return {k:'hoje',    t:'Retornar HOJE',                        c:'#0a4da6', bg:'#dbeafe'};
    return      {k:'futuro',       t:'Retornar '+_dataBr(r),                 c:'#475569', bg:'#f1f5f9'};
  }
  function _cotEhHoje(v){ var st=cotRetStatus(v); return !!(st&&st.k==='hoje'); }
  function _cotAtrasada(v){ var st=cotRetStatus(v); return !!(st&&st.k==='atrasado'); }
  function _cotSemRet(v){ var c=cotCrm(v); return !String(c.retorno||'') && String(c.situacao||'')!=='fechada' && String(c.situacao||'')!=='perdida'; }
  var ICO_AGENDA='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>';
  /* a faixa que aparece dentro do card */
  function cotRetLinha(v){
    var st=cotRetStatus(v), si=cotSitInfo(cotCrm(v).situacao);
    var out='<div class="cot-crm">';
    if(si.k) out+='<span class="cot-sit" style="color:'+si.c+';background:'+si.c+'14;border-color:'+si.c+'44">'+esc(si.t)+'</span>';
    if(st)   out+='<span class="cot-ret" style="color:'+st.c+';background:'+st.bg+'">'+esc(st.t)+'</span>';
    out+='<button type="button" class="cot-ret-btn" data-id="'+esc(v.id)+'">'+ICO_AGENDA+(st?'Mudar':'Marcar retorno')+'</button>';
    return out+'</div>';
  }
  /* grava o retorno na cotacao E espelha no historico do cliente (CRM) */
  async function cotRetSalvar(id, dados){
    var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v){ toast('Cotacao nao encontrada.'); return false; }
    var p={}; try{ p=JSON.parse(JSON.stringify(v.proposta||{})); }catch(_){ p=(v.proposta||{}); }
    p.crm={ retorno:String(dados.retorno||''), situacao:String(dados.situacao||''), obs:String(dados.obs||''),
            ts:new Date().toISOString(), por:(meuNome||'') };
    try{
      var r=await supa.from('vendas').update({ proposta:p, atualizado_em:new Date().toISOString() }).eq('id',id);
      if(r&&r.error) throw r.error;
      v.proposta=p; v.atualizado_em=new Date().toISOString();
    }catch(e){ toast('Nao consegui salvar. '+((e&&e.message)||'')); return false; }
    /* espelho no CRM da pagina Clientes */
    if(v.cliente_id){
      var si=cotSitInfo(p.crm.situacao);
      var txt='Cotacao '+((v.veiculo||'')||'veiculo')+(v.placa?(' ('+v.placa+')'):'')+' \u00b7 '+si.t+
              (p.crm.retorno?(' \u00b7 retorno em '+_dataBr(p.crm.retorno)):'')+
              (p.crm.obs?(' \u00b7 '+p.crm.obs):'');
      try{ await crmObsRegistrar(v.cliente_id, txt, true); }catch(_){ }
    }
    toast('Retorno marcado \u2713');
    return true;
  }
  function cotRetAbrir(id){
    var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0]; if(!v) return;
    var c=cotCrm(v);
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:340px">'+
      '<div class="crop-tit">Situacao e retorno</div>'+
      '<div class="crop-sub">'+esc((v.veiculo||'Veiculo'))+(v.cliente_nome?(' \u00b7 '+esc(v.cliente_nome)):'')+'</div>'+
      '<label class="cad-lbl" style="margin-top:10px">Em que pe esta</label>'+
      '<select class="cad-in" id="crtSit">'+COT_SIT.map(function(o){ return '<option value="'+o[0]+'"'+(String(c.situacao||'')===o[0]?' selected':'')+'>'+o[1]+'</option>'; }).join('')+'</select>'+
      '<label class="cad-lbl">Voltar a falar em</label>'+
      '<div class="crt-fast"><button type="button" data-d="1">Amanha</button><button type="button" data-d="3">3 dias</button><button type="button" data-d="7">1 semana</button><button type="button" data-d="-1">Sem data</button></div>'+
      '<input type="date" class="cad-in" id="crtData" value="'+esc(String(c.retorno||''))+'">'+
      '<label class="cad-lbl">Anotacao (opcional)</label>'+
      '<textarea class="cad-in" id="crtObs" rows="2" placeholder="Ex: vai falar com a esposa, quer 2 mil de desconto...">'+esc(String(c.obs||''))+'</textarea>'+
      '<button type="button" class="crop-ok" id="crtOk" style="margin-top:12px;width:100%">Salvar</button>'+
      '<button type="button" class="link" id="crtX" style="margin-top:8px;width:100%">Cancelar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.onclick=function(e){ if(e.target===ov) close(); };
    Array.prototype.forEach.call(ov.querySelectorAll('.crt-fast button'),function(b){
      b.onclick=function(){ var d=parseInt(b.getAttribute('data-d'),10);
        var el=ov.querySelector('#crtData'); if(el) el.value=(d<0?'':_cotMaisDias(d));
        Array.prototype.forEach.call(ov.querySelectorAll('.crt-fast button'),function(o){ o.classList.remove('on'); });
        b.classList.add('on');
      };
    });
    ov.querySelector('#crtX').onclick=close;
    ov.querySelector('#crtOk').onclick=async function(){
      var bt=this; bt.disabled=true; bt.textContent='Salvando...';
      var ok=await cotRetSalvar(id,{ situacao:(ov.querySelector('#crtSit')||{}).value,
                                     retorno:(ov.querySelector('#crtData')||{}).value,
                                     obs:(ov.querySelector('#crtObs')||{}).value });
      close();
      if(ok) cotPinta((($('cotBusca')||{}).value)||'');
    };
  }
  async function telaCotacoes(alvo){
    if(!alvo){ mevTabSet(''); _vdTab='cotacoes'; }
    (alvo||$('secoes')).innerHTML=(alvo?'':_cadBack())+'<div class="info-pg"><h2>Cotações salvas</h2>'+
      '<div class="vv-hint">Tudo que a loja já cotou. Toque pra abrir do jeito que foi salvo.</div>'+
      '<div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="cotBusca" placeholder="Buscar placa, modelo, cliente ou vendedor" autocomplete="off"></div></div>'+
      '<div class="est-chips" id="cotChips"></div>'+
      '<div id="cotResumo"></div>'+
      '<div id="cotLista"><div class="cli-empty">Carregando...</div></div></div>';
    if(!alvo){ $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vdVoltarDaGestao); }

    $('cotBusca').oninput=function(){ cotPinta(this.value); };
    await cotNomesCarregar();
    await vendaCarregar();
    cotPinta('');
  }
  function cotChipsHtml(){
    var box=$('cotChips'); if(!box) return;
    var t=_cotTodas();
    var chips=[['','Todas',t.length],
               ['hoje','Retornar hoje',t.filter(_cotEhHoje).length],
               ['atraso','Atrasadas',t.filter(_cotAtrasada).length],
               ['sem','Sem retorno',t.filter(_cotSemRet).length],
               ['minhas','Minhas',t.filter(_cotMinha).length],
               ['troca','Com troca',t.filter(_cotTemTroca).length],
               ['fin','Financiadas',t.filter(_cotFinanciada).length]];
    box.innerHTML=chips.map(function(c){ return '<button class="est-chip'+(_cotFiltro===c[0]?' on':'')+'" data-f="'+c[0]+'">'+esc(c[1])+' · '+c[2]+'</button>'; }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.est-chip'),function(b){
      b.onclick=function(){ _cotFiltro=b.getAttribute('data-f'); cotPinta((($('cotBusca')||{}).value)||''); };
    });
  }
  function cotPinta(termo){
    cotChipsHtml();
    var el=$('cotLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    var todas=_cotTodas();
    if(!todas.length){
      if($('cotResumo')) $('cotResumo').innerHTML='';
      el.innerHTML='<div class="cli-empty"><b>Nenhuma cotação salva ainda</b>Monte uma negociação em Vendas e toque em "Salvar cotação".</div>'; return;
    }
    var lista=todas.filter(function(v){
      if(_cotFiltro==='hoje' && !_cotEhHoje(v)) return false;
      if(_cotFiltro==='atraso' && !_cotAtrasada(v)) return false;
      if(_cotFiltro==='sem' && !_cotSemRet(v)) return false;
      if(_cotFiltro==='minhas' && !_cotMinha(v)) return false;
      if(_cotFiltro==='troca' && !_cotTemTroca(v)) return false;
      if(_cotFiltro==='fin' && !_cotFinanciada(v)) return false;
      if(!termo) return true;
      return ((v.placa||'')+' '+(v.veiculo||'')+' '+(v.cliente_nome||'')+' '+_cotPor(v)).toLowerCase().indexOf(termo)>=0;
    });
    if(_cotFiltro==='hoje'||_cotFiltro==='atraso'){
      lista=lista.slice().sort(function(a,b){ return String(cotCrm(a).retorno||'')<String(cotCrm(b).retorno||'')?-1:1; });
    }
    /* resumo em cima: quantas e quanto somam */
    var soma=0; lista.forEach(function(v){ try{ soma+=(vpCalc(v.proposta).precoFinal||0); }catch(_){ } });
    if($('cotResumo')) $('cotResumo').innerHTML='<div class="cot-res"><div><b>'+lista.length+'</b><i>'+(lista.length===1?'cotação':'cotações')+'</i></div><div><b>'+esc(brl(soma))+'</b><i>somando os veículos</i></div></div>';
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado com esse filtro.</div>'; return; }
    el.innerHTML=lista.map(function(v){
      var e=vendaEtapaInfo(v.etapa), c=null;
      try{ c=vpCalc(v.proposta); }catch(_){ c=null; }
      var cond='';
      if(c){
        if(c.parcelado) cond='Entrada '+brl(c.entrada)+' + '+c.n+'x de <b>'+brl(c.parcela)+'</b>';
        else if(c.saldo<0) cond='Volta pro cliente <b>'+brl(Math.abs(c.saldo))+'</b>';
        else cond='À vista <b>'+brl(c.saldo)+'</b>';
        if(c.aval>0) cond+=' · usado '+brl(c.trocaLiq)+(c.quit>0?(' (já abatida a quitação de '+brl(c.quit)+')'):'');
      }
      var preco=c?brl(c.precoFinal):(v.valor_venda?estMoney(v.valor_venda):'—');
      /* v460 (pedido): capa do veiculo no card — as fotos viajam DENTRO da
         proposta salva (proposta.veiculo.fotos); sem elas, tenta o registro
         vivo do estoque. Mesmo desenho do card do estoque (estThumb). */
      var cotF=(v.proposta&&v.proposta.veiculo&&Array.isArray(v.proposta.veiculo.fotos)&&v.proposta.veiculo.fotos.length)
        ? v.proposta.veiculo.fotos
        : (((v.estoque_id&&(_estoque||[]).filter(function(x){ return String(x.id)===String(v.estoque_id); })[0])||{}).fotos||[]);
      return '<div class="est-card" data-id="'+esc(v.id)+'">'+estThumbFotos(cotF, v.veiculo||'Veículo')+'<div class="est-tx">'+
        '<div class="est-nm">'+esc(v.veiculo||'Veículo')+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.cliente_nome?(' · '+esc(v.cliente_nome)):'')+'</div>'+
        (cond?('<div class="cot-cond">'+cond+'</div>'):'')+
        '<div class="est-row"><span class="est-preco">'+esc(preco)+'</span><span class="est-badge" style="color:'+e.c+';background:'+e.c+'14;border-color:'+e.c+'44">'+esc(e.t)+'</span></div>'+
        '<div class="cot-por">'+esc(_cotPor(v))+(_cotData(v)?(' · '+_cotData(v)):'')+'</div>'+
        cotRetLinha(v)+
        '</div><div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      card.onclick=function(){ vendaNovaAbrir(card.getAttribute('data-id')); };
    });
    Array.prototype.forEach.call(el.querySelectorAll('.cot-ret-btn'),function(b){
      b.onclick=function(ev){ try{ ev.stopPropagation(); }catch(_){} cotRetAbrir(b.getAttribute('data-id')); };
    });
    try{ estStripsWire(el); }catch(_){}   /* v460: tira de fotos + reserva, igual ao estoque */
  }
  /* ================== RESULTADO (v191) ==================
     Esta pagina NAO pede nada novo pra voce. Ela le o que a aba CUSTOS e a aba
     POS-VENDAS do estoque ja' guardam em cada veiculo e soma tudo por periodo.
     Ou seja: o dado ja' era seu, so' estava espalhado carro a carro. Aqui ele
     vira o numero que o dono da loja quer ver — quanto entrou, quanto custou,
     quanto SOBROU de verdade e quanto tempo o carro levou pra sair. */
  var _resPer='mes';
  var RES_PER=[['mes','Este mes'],['ant','Mes passado'],['90','90 dias'],['ano','Este ano'],['','Tudo']];
  function _resIso(d){ try{ return new Date(d.getTime()-d.getTimezoneOffset()*6e4).toISOString().slice(0,10); }catch(_){ return ''; } }
  /* custo de preparacao lido do que esta SALVO no veiculo (sem depender da tela
     aberta). E' a mesma conta da aba Custos: comissao + itens + imposto NF. */
  function resCustosPrep(v){
    v=v||{}; var cc=v.custos||{};
    /* v193 — no consignado o "min" que vale pra loja e' so' a comissao dela */
    var min=_ogRecV(v, Number(v.preco_minimo)||0), compra=_ogCompraV(v);
    var com=_r2(min*(Number(cc.com_pct)||0)/100);
    var base=_r2(com+(Number(cc.hig)||0)+(Number(cc.pol)||0)+(Number(cc.fun)||0)+(Number(cc.pneus)||0)+(Number(cc.mec)||0)+(Number(cc.doc)||0)+_ccOutrosSoma(cc));
    var nfBase=(String(cc.nf_base||'margem')==='venda')?_ogRecV(v,Number(v.preco_anuncio)||0):Math.max(0,_r2(min-compra-base));
    var nf=_r2(nfBase*(Number(cc.nf_pct)||0)/100);
    return _r2(base+nf);
  }
  /* os numeros de UM veiculo — mesma formula da aba Pos-vendas */
  function resNums(v){
    v=v||{}; var pv=v.pos_venda||{};
    var compra=_ogCompraV(v), prep=resCustosPrep(v);
    var gar=Number(pv.garantia)||0, nfv=Number(pv.nf_valor)||0;
    /* bruto = o que o cliente pagou · venda = o que ENTROU na loja.
       Nos carros proprios os dois sao iguais. No consignado, nao. */
    var bruto=Number(pv.valor_venda)||0, venda=_ogRecV(v,bruto);
    var custo=_r2(compra+prep+gar);
    var lucro=bruto?_r2(venda-custo-nfv):0;
    return { compra:compra, prep:prep, gar:gar, nf:nfv, venda:venda, bruto:bruto,
             consignante:_r2(bruto-venda), custo:custo, lucro:lucro,
             faltaCompra:(String(v.origem||'')!=='consignado' && !compra), faltaVenda:!bruto };
  }
  function resDataVenda(v){ var pv=(v&&v.pos_venda)||{}; return String(pv.data_venda||(v&&v.atualizado_em)||(v&&v.criado_em)||'').slice(0,10); }
  function resDiasAteVender(v){
    try{
      var e=String((v&&v.data_entrada)||'').slice(0,10), f=resDataVenda(v);
      if(!e||!f) return null;
      var d=Math.floor((new Date(f+'T12:00:00').getTime()-new Date(e+'T12:00:00').getTime())/864e5);
      return (d!=null && d>=0 && d<3650)?d:null;
    }catch(_){ return null; }
  }
  function resPeriodo(){
    var h=new Date(), ini, fim;
    if(_resPer==='mes'){ ini=new Date(h.getFullYear(),h.getMonth(),1); fim=h; }
    else if(_resPer==='ant'){ ini=new Date(h.getFullYear(),h.getMonth()-1,1); fim=new Date(h.getFullYear(),h.getMonth(),0); }
    else if(_resPer==='90'){ ini=new Date(h.getTime()-90*864e5); fim=h; }
    else if(_resPer==='ano'){ ini=new Date(h.getFullYear(),0,1); fim=h; }
    else return ['',''];
    return [_resIso(ini),_resIso(fim)];
  }
  function resVendidos(){
    var p=resPeriodo();
    return (_estoque||[]).filter(function(v){
      if(String(v.status||'')!=='vendido') return false;
      if(!p[0]) return true;
      var d=resDataVenda(v); if(!d) return false;
      return d>=p[0] && d<=p[1];
    }).sort(function(a,b){ return resDataVenda(b)>resDataVenda(a)?1:-1; });
  }
  function _resPct(n){ return (n>=0?'':'-')+Math.abs(n).toFixed(1).replace('.',',')+'%'; }
  function resKpi(n,l,cls){ return '<div class="res-k'+(cls?(' '+cls):'')+'"><b>'+esc(n)+'</b><i>'+esc(l)+'</i></div>'; }
  /* =====================================================================
     v193 — COMISSAO DOS VENDEDORES
     A regra de cada pessoa mora em loja_membros (com_tipo + com_valor).
     Aqui eu so' LEIO essa regra e aplico nas vendas do periodo. Quando
     voce marca "pago", eu CONGELO o valor dentro da propria venda
     (vendas.comissao) — assim, se um dia a regra da pessoa mudar, o que
     ja' foi pago continua com o numero que foi pago de verdade.
     ===================================================================== */
  var _COM_TIPOS=[['lucro','% do lucro'],['venda','% da venda'],['fixo','Valor fixo']];
  function _comRotulo(t){
    if(t==='fixo')  return 'Valor por carro (R$)';
    if(t==='venda') return '% sobre o valor da venda';
    if(t==='lucro') return '% sobre o lucro';
    return 'Valor';
  }
  var _comMbr=null, _comPer='mes';
  async function comMembrosCarregar(){
    if(_comMbr) return _comMbr;
    _comMbr={};
    try{
      var r=await withTimeout(supa.from('loja_membros').select('*'),9000);
      ((r&&r.data)||[]).forEach(function(m){
        if(!m||!m.user_id) return;
        _comMbr[m.user_id]={ id:m.user_id, nome:m.nome||m.email||'Vendedor',
          telefone:m.telefone||'', tipo:String(m.com_tipo||''), valor:(m.com_valor==null?null:Number(m.com_valor)),
          salario:(m.salario_fixo==null?null:Number(m.salario_fixo)),
          gatilhoQtd:(m.gatilho_qtd==null?null:Number(m.gatilho_qtd)),
          gatilhoValor:(m.gatilho_valor==null?null:Number(m.gatilho_valor)) };
      });
    }catch(_){ }
    if(meuId && !_comMbr[meuId]) _comMbr[meuId]={ id:meuId, nome:(meuNome||'Você'), tipo:'', valor:null, salario:null, gatilhoQtd:null, gatilhoValor:null };
    return _comMbr;
  }
  function _comVendedorOptions(sel){
    var m=_comMbr||{}, ks=Object.keys(m);
    if(!ks.length) return '<option value="'+esc(meuId||'')+'" selected>'+esc(meuNome||'Você')+'</option>';
    ks.sort(function(a,b){ return String(m[a].nome||'').localeCompare(String(m[b].nome||'')); });
    return ks.map(function(k){
      return '<option value="'+esc(k)+'"'+(String(k)===String(sel)?' selected':'')+'>'+esc(m[k].nome)+'</option>';
    }).join('');
  }
  function _comQuem(vd){ return String((vd&&(vd.vendedor_id||vd.user_id))||''); }
  function _comNome(vd){
    var q=_comQuem(vd), m=(_comMbr||{})[q];
    return (m&&m.nome)||(vd&&vd.vendedor_nome)||(String(q)===String(meuId)?(meuNome||'Você'):'Vendedor');
  }
  function _comPlaca(x){ return String((x&&x.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  /* acha no estoque o carro desta venda — o encaixe e' pela PLACA */
  function _comVeic(vd){
    var pl=_comPlaca(vd); if(!pl) return null;
    var achou=null;
    (_estoque||[]).forEach(function(v){ if(_comPlaca(v)===pl) achou=v; });
    return achou;
  }
  /* lucro real desta venda: o que ENTROU na loja menos compra, preparacao e NF.
     No consignado, "o que entrou" e' so' a comissao da loja (regra da v193). */
  function _comLucro(vd){
    var v=_comVeic(vd); if(!v) return { lucro:0, temBase:false };
    var pv=v.pos_venda||{};
    var bruto=Number(pv.valor_venda)||Number(vd&&vd.valor_venda)||0;
    var entra=_ogRecV(v,bruto);
    var custo=_r2(_ogCompraV(v)+resCustosPrep(v)+(Number(pv.garantia)||0));
    return { lucro:_r2(entra-custo-(Number(pv.nf_valor)||0)), temBase:true };
  }
  function _comNum(n){ return String(n).replace('.',','); }
  function _comGatilho(vd,m){
    var qtd=Number(m&&m.gatilhoQtd)||0, bonus=Number(m&&m.gatilhoValor)||0;
    if(!qtd||!bonus) return { valor:0, ativo:false, qtd:qtd };
    var uid=_comQuem(vd), n=0;
    comVendasDoPeriodo().forEach(function(v){ if(_comQuem(v)===uid) n++; });
    return { valor:(n>=qtd?_r2(bonus):0), ativo:n>=qtd, qtd:qtd, atual:n };
  }
  /* quanto ESTA venda gera de comissao, segundo a regra de quem vendeu */
  function _comCalc(vd, semGatilho){
    var m=(_comMbr||{})[_comQuem(vd)]||null;
    if(!m) return { semRegra:true, mbr:m };
    var gat=semGatilho?{valor:0,ativo:false,qtd:Number(m.gatilhoQtd)||0}:_comGatilho(vd,m);
    var temCom=!!m.tipo && m.valor!=null;
    if(!temCom && !gat.qtd) return { semRegra:true, mbr:m };
    var n=Number(m.valor)||0;
    var out={ mbr:m, tipo:m.tipo||'gatilho', n:n, valor:0, base:'', obs:'', bonus:gat.valor };
    if(!temCom){
      out.base=gat.ativo?('gatilho de '+gat.qtd+' vendas atingido'):('gatilho em '+gat.qtd+' vendas');
    } else if(m.tipo==='fixo'){
      out.valor=_r2(n); out.base='valor fixo por carro';
    }
    if(m.tipo==='venda'){
      var vv=Number(vd.valor_venda)||0;
      out.valor=_r2(vv*n/100); out.base=_comNum(n)+'% de '+(estMoney(vv)||'R$ 0'); out.obs=vv?'':'Falta o valor da venda.';
    }
    if(m.tipo==='lucro'){
      var L=_comLucro(vd);
      if(!L.temBase){ out.semVeiculo=true; out.obs='Este carro não está no estoque — sem os custos eu não sei o lucro.'; }
      else {
        out.valor=_r2(Math.max(0,L.lucro)*n/100);
        out.base=_comNum(n)+'% de '+(estMoney(L.lucro)||'R$ 0')+' de lucro';
        out.obs=L.lucro>0?'':'Este carro não deu lucro — comissão zero.';
      }
    }
    if(gat.valor){
      out.valor=_r2(out.valor+gat.valor);
      out.base+=(out.base?' + ':'')+'gatilho '+(estMoney(gat.valor)||'R$ 0')+' por carro';
    }
    return out;
  }
  function _comData(vd){ return String((vd&&(vd.data_entrega||vd.data_venda||vd.atualizado_em||vd.criado_em))||'').slice(0,10); }
  function _comPago(vd){ var c=(vd&&vd.comissao)||null; return !!(c&&c.pago); }
  /* uso a MESMA conta de periodo da tela Resultado — emprestada e devolvida */
  function _comPeriodo(){ var salvo=_resPer; _resPer=_comPer; var p=resPeriodo(); _resPer=salvo; return p; }
  var _COM_ETAPAS={ vendido:'previsto', entrega:'previsto', entregue:'pagar', posvenda:'pagar' };
  function comVendasDoPeriodo(){
    var p=_comPeriodo();
    return (_vendas||[]).filter(function(vd){
      if(!_COM_ETAPAS[String(vd.etapa||'')]) return false;
      if(!p[0]) return true;
      var d=_comData(vd); if(!d) return false;
      return d>=p[0] && d<=p[1];
    }).sort(function(a,b){ return _comData(b)>_comData(a)?1:-1; });
  }
  async function telaComissoes(alvo){
    if(!alvo){ mevTabSet(''); _vdTab='comissoes'; }
    (alvo||$('secoes')).innerHTML=(alvo?'':_cadBack())+'<div class="info-pg"><h2>Comissões</h2>'+
      '<div class="vv-hint">Quanto cada vendedor tem a receber. A regra de cada pessoa fica em <b>Minha loja &gt; Usuários</b> — toque no nome dela pra definir.</div>'+
      '<div class="est-chips" id="comChips"></div>'+
      '<div id="comCorpo"><div class="cli-empty">Carregando...</div></div></div>';
    if(!alvo){ $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vdVoltarDaGestao); }
    await estCarregar();
    await vendaCarregar();
    await comMembrosCarregar();
    comPinta();
  }
  function comPinta(){
    var box=$('comChips');
    if(box){
      box.innerHTML=RES_PER.map(function(p){ return '<button class="est-chip'+(_comPer===p[0]?' on':'')+'" data-p="'+p[0]+'">'+esc(p[1])+'</button>'; }).join('');
      Array.prototype.forEach.call(box.querySelectorAll('.est-chip'),function(b){
        b.onclick=function(){ _comPer=b.getAttribute('data-p'); comPinta(); };
      });
    }
    var el=$('comCorpo'); if(!el) return;
    var lista=comVendasDoPeriodo();
    var grupos={}, ordem=[], semRegra=0, totPagar=0, totPrev=0, totPago=0;
    lista.forEach(function(vd){
      var c=_comCalc(vd);
      if(c.semRegra){ semRegra++; return; }
      var q=_comQuem(vd);
      if(!grupos[q]){ grupos[q]={ nome:_comNome(vd), pagar:0, prev:0, pago:0, itens:[] }; ordem.push(q); }
      var g=grupos[q];
      var congelado=(vd.comissao&&vd.comissao.pago)?(Number(vd.comissao.valor)||0):null;
      var val=(congelado!=null)?congelado:c.valor;
      var faixa=_COM_ETAPAS[String(vd.etapa||'')];
      if(congelado!=null){ g.pago=_r2(g.pago+val); totPago=_r2(totPago+val); }
      else if(faixa==='pagar'){ g.pagar=_r2(g.pagar+val); totPagar=_r2(totPagar+val); }
      else { g.prev=_r2(g.prev+val); totPrev=_r2(totPrev+val); }
      g.itens.push({ vd:vd, c:c, val:val, pago:(congelado!=null), faixa:faixa });
    });
    ordem.sort(function(a,b){ return (grupos[b].pagar+grupos[b].prev)-(grupos[a].pagar+grupos[a].prev); });

    var html='';
    if(!lista.length){
      html+='<div class="cli-empty"><b>Nenhuma venda nesse período</b>A comissão nasce da venda. Abra <b>Vendas</b>, escolha o vendedor e mova a negociação pra <b>Vendido</b> ou <b>Entregue</b>.</div>';
    } else if(!ordem.length){
      html+='<div class="cli-empty"><b>Ninguém tem regra de comissão ainda</b>Vá em <b>Minha loja &gt; Usuários</b>, toque no nome da pessoa e escolha se ela ganha % do lucro, % da venda ou um valor fixo.</div>';
    } else {
      html+='<div class="res-kpis">'+
        resKpi(estMoney(totPagar)||'R$ 0','a pagar agora','')+
        resKpi(estMoney(totPrev)||'R$ 0','previsto','')+
        resKpi(estMoney(totPago)||'R$ 0','já pago','')+
      '</div>';
      html+='<div class="res-tit">Por vendedor</div>';
      html+=ordem.map(function(q){
        var g=grupos[q];
        return '<div class="com-card">'+
          '<div class="com-hd">'+
            '<div class="lj-membro-av">'+esc(cliIni(g.nome))+'</div>'+
            '<div class="com-hdt"><b>'+esc(g.nome)+'</b><i>'+g.itens.length+' '+(g.itens.length===1?'venda':'vendas')+'</i></div>'+
            '<div class="com-hdv"><b>'+(estMoney(g.pagar)||'R$ 0')+'</b><i>a pagar</i></div>'+
          '</div>'+
          ((g.prev||g.pago)?('<div class="com-sub">'+
            (g.prev?('previsto <b>'+(estMoney(g.prev)||'R$ 0')+'</b>'):'')+
            ((g.prev&&g.pago)?' · ':'')+
            (g.pago?('já pago <b>'+(estMoney(g.pago)||'R$ 0')+'</b>'):'')+'</div>'):'')+
          g.itens.map(function(it){
            var vd=it.vd, et=vendaEtapaInfo(vd.etapa)||{};
            return '<div class="com-it'+(it.pago?' pago':'')+'">'+
              '<div class="com-itx">'+
                '<b>'+esc(vd.veiculo||vd.placa||'Veículo')+'</b>'+
                '<i>'+esc([_comPlaca(vd), vd.cliente_nome||'', _dataBr(_comData(vd))].filter(Boolean).join(' · '))+'</i>'+
                '<u>'+esc(it.c.base||'')+(it.c.obs?(' — '+esc(it.c.obs)):'')+'</u>'+
              '</div>'+
              '<div class="com-itv">'+
                '<b>'+(estMoney(it.val)||'R$ 0')+'</b>'+
                '<span class="com-et" style="background:'+esc((et.c||'#64748b'))+'22;color:'+esc(et.c||'#64748b')+'">'+esc(et.t||vd.etapa||'')+'</span>'+
                '<button type="button" class="com-pg'+(it.pago?' on':'')+'" data-id="'+esc(vd.id)+'">'+(it.pago?'pago':'marcar pago')+'</button>'+
              '</div>'+
            '</div>';
          }).join('')+
        '</div>';
      }).join('');
      if(semRegra) html+='<div class="res-aviso">'+semRegra+' '+(semRegra===1?'venda ficou':'vendas ficaram')+' de fora: quem vendeu ainda não tem regra de comissão. Defina em <b>Minha loja &gt; Usuários</b>.</div>';
    }
    el.innerHTML=html;
    Array.prototype.forEach.call(el.querySelectorAll('.com-pg'),function(b){
      b.onclick=function(){ comMarcarPago(b.getAttribute('data-id'), b); };
    });
  }
  /* marcar/desmarcar pago — o valor fica CONGELADO dentro da venda */
  async function comMarcarPago(id, btn){
    var vd=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!vd) return;
    var jaPago=_comPago(vd), novo=null;
    if(!jaPago){
      var c=_comCalc(vd);
      if(c.semRegra){ toast('Esse vendedor ainda não tem regra de comissão.'); return; }
      novo={ tipo:c.tipo, regra:c.n, valor:c.valor, base:c.base, pago:true,
             pago_em:new Date().toISOString(), por:(meuNome||meuEmail||''), vendedor:_comNome(vd) };
    } else {
      if(!confirm('Desmarcar o pagamento desta comissão?')) return;
      novo=null;
    }
    if(btn){ btn.disabled=true; btn.textContent='...'; }
    try{
      var r=await supa.from('vendas').update({comissao:novo}).eq('id',id);
      if(r&&r.error) throw r.error;
      vd.comissao=novo;
      toast(novo?'Comissão marcada como paga ✓':'Pagamento desmarcado.');
      comPinta();
    }catch(e){
      if(btn){ btn.disabled=false; btn.textContent=jaPago?'pago':'marcar pago'; }
      toast('Não consegui salvar. '+((e&&e.message)||''));
    }
  }

  async function telaResultado(alvo){
    if(!alvo){ mevTabSet(''); _vdTab='resultado'; }
    (alvo||$('secoes')).innerHTML=(alvo?'':_cadBack())+'<div class="info-pg"><h2>Resultado</h2>'+
      '<div class="vv-hint">O que a loja ganhou de verdade. Vem do que voce ja preenche nas abas <b>Custos</b> e <b>Pos-vendas</b> de cada veiculo.</div>'+
      '<div class="est-chips" id="resChips"></div>'+
      '<div id="resCorpo"><div class="cli-empty">Carregando...</div></div></div>';
    if(!alvo){ $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vdVoltarDaGestao); }
    await estCarregar();
    resPinta();
  }
  function resPinta(){
    var box=$('resChips');
    if(box){
      box.innerHTML=RES_PER.map(function(p){ return '<button class="est-chip'+(_resPer===p[0]?' on':'')+'" data-p="'+p[0]+'">'+esc(p[1])+'</button>'; }).join('');
      Array.prototype.forEach.call(box.querySelectorAll('.est-chip'),function(b){
        b.onclick=function(){ _resPer=b.getAttribute('data-p'); resPinta(); };
      });
    }
    var el=$('resCorpo'); if(!el) return;
    var lista=resVendidos();
    var comDado=[], semDado=0;
    lista.forEach(function(v){ if(resNums(v).faltaVenda) semDado++; else comDado.push(v); });
    var fat=0, cst=0, luc=0, somaDias=0, nDias=0;
    comDado.forEach(function(v){
      var n=resNums(v);
      fat=_r2(fat+n.venda); cst=_r2(cst+n.custo+n.nf); luc=_r2(luc+n.lucro);
      var d=resDiasAteVender(v); if(d!=null){ somaDias+=d; nDias++; }
    });
    var q=comDado.length;
    var ticket=q?_r2(fat/q):0, lucroMed=q?_r2(luc/q):0;
    var diasMed=nDias?Math.round(somaDias/nDias):null;
    var margem=fat?(luc/fat*100):0;

    var html='';
    if(!lista.length){
      html+='<div class="cli-empty"><b>Nenhuma venda nesse periodo</b>Marque o veiculo como <b>Vendido</b> no estoque e preencha a aba Pos-vendas (valor da venda e data). Ele aparece aqui na hora.</div>';
    } else {
      html+='<div class="res-kpis">'+
        resKpi(String(lista.length), lista.length===1?'carro vendido':'carros vendidos','')+
        resKpi(estMoney(fat)||'R$ 0','faturamento','')+
        resKpi(estMoney(cst)||'R$ 0','custo total','')+
      '</div>';
      html+='<div class="res-lucro'+(luc>=0?'':' neg')+'"><span>Lucro real do periodo</span><b>'+((luc<0?'(-) ':'')+(estMoney(Math.abs(luc))||'R$ 0'))+'</b><i>'+_resPct(margem)+' sobre o faturamento</i></div>';
      html+='<div class="res-kpis">'+
        resKpi(estMoney(ticket)||'R$ 0','ticket medio','')+
        resKpi((lucroMed<0?'(-) ':'')+(estMoney(Math.abs(lucroMed))||'R$ 0'),'lucro por carro',(lucroMed<0?'neg':''))+
        resKpi(diasMed==null?'—':(diasMed+'d'),'dias ate vender',(diasMed!=null&&diasMed>=60?'warn':''))+
      '</div>';
      if(semDado) html+='<div class="res-aviso">'+semDado+' '+(semDado===1?'carro vendido esta':'carros vendidos estao')+' sem o <b>valor da venda</b> preenchido — ele ficou de fora das contas. Abra a ficha e complete a aba Pos-vendas.</div>';
      html+='<div class="res-tit">Vendas do periodo</div>';
      html+=lista.map(function(v){
        var n=resNums(v), d=resDiasAteVender(v);
        var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veiculo';
        var val=n.venda?(estMoney(n.venda)||''):'sem valor';
        var lu=n.venda?('<span class="res-lu" style="color:'+(n.lucro>=0?'#166534':'#b91c1c')+';background:'+(n.lucro>=0?'#dcfce7':'#fee2e2')+'">'+(n.lucro>=0?'':'(-) ')+estMoney(Math.abs(n.lucro))+'</span>'):'<span class="res-lu falta">faltam dados</span>';
        var dv=resDataVenda(v);
        return '<div class="est-card" data-id="'+esc(v.id)+'"><div class="est-tx">'+
          '<div class="est-nm">'+esc(nome)+'</div>'+
          '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(dv?(' \u00b7 vendido em '+esc(_dataBr(dv))):'')+(d!=null?(' \u00b7 '+d+' dia'+(d===1?'':'s')+' no patio'):'')+'</div>'+
          '<div class="est-row"><span class="est-preco">'+esc(val)+'</span>'+lu+'</div>'+
        '</div><div class="cli-chev">'+_icoChev+'</div></div>';
      }).join('');
    }

    /* ---- dinheiro parado hoje (nao depende do periodo) ---- */
    var ativos=(_estoque||[]).filter(function(v){ return String(v.status||'disponivel')!=='vendido'; });
    if(ativos.length){
      var inv=0; ativos.forEach(function(v){ inv=_r2(inv+(Number(v.preco_compra)||0)+resCustosPrep(v)); });
      var top=ativos.map(function(v){ return {v:v,d:estDias(v)}; })
                    .filter(function(x){ return x.d!=null; })
                    .sort(function(a,b){ return b.d-a.d; }).slice(0,4);
      html+='<div class="res-tit">Dinheiro parado hoje</div>';
      html+='<div class="res-parado"><div class="rp-top"><span>'+ativos.length+' '+(ativos.length===1?'veiculo':'veiculos')+' no patio</span><b>'+(estMoney(inv)||'R$ 0')+'</b></div>'+
        '<div class="rp-sub">Soma do que voce ja pagou por eles (compra + preparacao). Esse dinheiro so volta quando o carro sai.</div>'+
        (top.length?('<div class="rp-lista">'+top.map(function(x){
          var nm=((x.v.marca||'')+' '+(x.v.modelo||'')).trim()||'Veiculo';
          return '<div class="rp-it"><span>'+esc(nm)+' <i>'+esc(x.v.placa||'')+'</i></span><b class="'+(x.d>=60?'d60':(x.d>=30?'d30':''))+'">'+x.d+'d</b></div>';
        }).join('')+'</div>'):'')+
      '</div>';
    }
    el.innerHTML=html;
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      card.onclick=function(){ estAbrirFicha(card.getAttribute('data-id')); };
    });
  }
  /* data curta pt-BR a partir de um AAAA-MM-DD */
  function _dataBr(iso){ var p=String(iso||'').slice(0,10).split('-'); return p.length===3?(p[2]+'/'+p[1]+'/'+p[0]):''; }

  /* ===================== v336 — A PÁGINA "VENDAS" ===========================
     ANTES: "Cotações salvas", "Vendas fechadas", "Resultado" e "Comissões"
     moravam dentro do menu da MINHA LOJA — um lugar que fala de cadastro
     (CNPJ, procurador, usuários). Quem queria ver venda tinha que entrar em
     "Minha loja", que não é onde a cabeça procura.

     AGORA elas viraram as abas da própria página VENDAS, que voltou pro menu
     principal logo abaixo do Estoque. A primeira aba ("Iniciar venda") é a
     mesma lista de sempre pra escolher o carro — nada foi apagado, só mudou
     de endereço.

     COMO FUNCIONA POR DENTRO: cada aba é um painel (.vpx-panel) e as quatro
     telas de gestão já sabiam desenhar dentro de um painel (elas recebem um
     "alvo"). É o mesmo mecanismo que a Minha loja usava — só mudou quem é o
     dono do menu. ======================================================== */
  var _VD_ICO={
    iniciar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14"/><path d="M6 17V9.5L7.8 5h8.4L18 9.5V17"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/><path d="M6 10h12"/></svg>',
    cotacoes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 2h9a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"/><line x1="4" y1="6" x2="4" y2="18"/><line x1="11" y1="7" x2="16" y2="7"/><line x1="11" y1="11" x2="16" y2="11"/><line x1="11" y1="15" x2="14" y2="15"/></svg>',
    fechadas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    resultado:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="3" y1="20" x2="21" y2="20"/></svg>',
    comissoes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    testes:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 2h6"/><path d="M10 2v6.5L5 18a2 2 0 0 0 1.7 3h10.6A2 2 0 0 0 19 18l-5-9.5V2"/><path d="M7.5 14h9"/></svg>'
  };
  /* ===== v443 (pedido) — A ABA "TESTES" ================================
     "Crie uma seção de testes que fica oculta pra todos. Só pra mim
      visualizar."

     O terceiro item da linha é a marca de SÓ ADMIN. A aba não é montada pra
     mais ninguém: quem não é o dono não vê o botão, e o vdAbrir barra a aba
     mesmo se alguém chamar pelo nome.

     ⚠️ SEGURANÇA, com todas as letras: isto é OCULTAÇÃO DE INTERFACE, não
     trava de servidor. Serve pra guardar coisa MEIO PRONTA da vista dos
     outros lojistas — que é o pedido. Não serve pra guardar segredo. O que
     protege o dado continua sendo o RLS do Supabase: cada loja só enxerga o
     próprio estoque, com ou sem esta aba. */
  var _VD_TABS=[
    ['iniciar','Iniciar venda'],
    ['cotacoes','Cotações salvas'],
    ['fechadas','Vendas fechadas'],
    ['resultado','Resultado'],
    ['comissoes','Comissões'],
    ['testes','Testes', 1]          /* 1 = só o admin */
  ];
  /* as abas que ESTE usuário pode ver */
  function _vdTabsVis(){ return _VD_TABS.filter(function(t){ return !t[2] || _ehAdmin(); }); }
  var _vdTab='iniciar';
  function _vdTabValida(a){ a=String(a||''); var v=_vdTabsVis();
    for(var i=0;i<v.length;i++){ if(v[i][0]===a) return a; } return ''; }
  function vdTabAplica(){
    Array.prototype.forEach.call(document.querySelectorAll('#vdBody .vpx-panel'),function(pn){ pn.classList.toggle('on', pn.getAttribute('data-panel')===_vdTab); });
    Array.prototype.forEach.call(document.querySelectorAll('#vdTabs .vpx-st'),function(b){ var on=b.getAttribute('data-step')===_vdTab; b.classList.toggle('on', on); if(on){ try{ _tabCentra(b.parentNode, b); }catch(_){} } });
  }
  /* abre uma aba DENTRO da página (sem trocar de tela) */
  async function vdAbrir(id){
    var mapa={ iniciar:vendasPainelEscolher, cotacoes:telaCotacoes, fechadas:telaVendasFechadas, resultado:telaResultado, comissoes:telaComissoes,
               testes:vtTestes };   /* v443; v592: ganhou o cartão da faxina */
    if(!mapa[id]) return false;
    /* v443: a porta dos fundos. Esconder o botão não basta — quem chamar a
       aba pelo nome (link salvo, telaVendas('testes')) também tem que bater
       na trava. */
    if(!_vdTabValida(id)) return false;
    var body=$('vdBody'); if(!body){ try{ await mapa[id](); }catch(_){} return true; }
    var pn=body.querySelector('.vpx-panel[data-panel="'+id+'"]');
    if(!pn){ pn=document.createElement('div'); pn.className='vpx-panel'; pn.setAttribute('data-panel',id); body.appendChild(pn); }
    pn.innerHTML='<div class="cli-empty">Carregando...</div>';
    _vdTab=id; vdTabAplica();
    try{ await mapa[id](pn); }catch(e){ pn.innerHTML='<div class="cli-empty"><b>Não consegui abrir agora</b>Verifique a internet e toque na aba de novo.</div>'; }
    return true;
  }
  /* o "Voltar" de quem abriu uma dessas telas em TELA CHEIA volta pra página
     Vendas já na aba certa (antes voltava pra Minha loja). */
  function vdVoltarDaGestao(){ return telaVendas(_vdTab); }

  /* ===== v592 — A FAXINA DO EGRESS (aba Testes, só o dono) =================
     O botão chama /api/faxina-egress em LAÇO, um punhado por vez, até zerar.
     Nada roda sozinho: começa no dedo, para no dedo (regra do projeto). */
  var _vtFaxLiga=false;
  async function vtTestes(pn){
    await telaPreRenave(pn);
    var alvo=pn||document.querySelector('#vdBody .vpx-panel[data-panel="testes"]');
    if(!alvo || alvo.querySelector('#vtFaxBt')) return;
    var box=document.createElement('div');
    box.className='cli-empty';
    box.innerHTML='<b>Faxina do egress (Supabase)</b>Recomprime as fotos antigas e tira as imagens de dentro das vendas.'+
      '<button type="button" id="vtFaxBt" class="lista-retry" style="margin-top:12px;background:#0a4da6;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">Começar a faxina</button>'+
      '<div id="vtFaxSt" style="margin-top:8px;font-size:12px;color:#456"></div>';
    alvo.appendChild(box);
    $('vtFaxBt').onclick=vtFaxinaRodar;
    /* ===== v681 — A FAXINA DOS VÍDEOS VENCIDOS (30 dias) =================
       Mora AQUI, ao lado da faxina do egress, de propósito (o projeto do
       vídeo mandou). Mesma regra v592: começa no dedo, para no dedo. As
       FOTOS extraídas nunca são tocadas — só o arquivo de vídeo vencido. */
    var boxV=document.createElement('div');
    boxV.className='cli-empty';
    boxV.innerHTML='<b>Faxina dos vídeos vencidos</b>Apaga os vídeos de avaliação com mais de 30 dias. As fotos extraídas ficam.'+
      '<button type="button" id="vtVidBt" class="lista-retry" style="margin-top:12px;background:#0a4da6;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit">Apagar vídeos vencidos</button>'+
      '<div id="vtVidSt" style="margin-top:8px;font-size:12px;color:#456"></div>';
    alvo.appendChild(boxV);
    $('vtVidBt').onclick=vtVideosFaxina;
  }
  async function vtVideosFaxina(){
    var bt=$('vtVidBt'), st=$('vtVidSt'); if(!bt||!st) return;
    bt.disabled=true;
    var total=0;
    while(true){
      var r=null;
      try{ r=await apiComTimeout('/api/video-url',{ acao:'faxina' },25000); }catch(_){ r=null; }
      if(!r || !r.ok){ st.textContent=(r&&r.erro)||'Falhou agora — toque de novo pra retomar.'; break; }
      total+=Number(r.apagados)||0;
      st.textContent=total+' vídeo(s) vencido(s) apagado(s) · '+r.restantes+' na fila · '+r.total_videos+' guardado(s)';
      if(!r.restantes){ st.textContent+=' · ✅ terminou'; break; }
    }
    bt.disabled=false;
  }
  async function vtFaxinaRodar(){
    var bt=$('vtFaxBt'), st=$('vtFaxSt'); if(!bt||!st) return;
    if(_vtFaxLiga){ _vtFaxLiga=false; bt.textContent='Continuar a faxina'; return; }
    _vtFaxLiga=true; bt.textContent='Parar';
    var eco=0;
    while(_vtFaxLiga){
      var r=null;
      try{ r=await apiComTimeout('/api/faxina-egress',{ modo:'rodar' },25000); }catch(_){ r=null; }
      if(!r || !r.ok){ st.textContent=(r&&r.erro)||'Falhou agora — toque em Continuar pra retomar de onde parou.'; break; }
      eco+=Number(r.economia_kb)||0;
      st.textContent='Fotos: '+r.fotos_total_feitas+' faxinadas · '+r.fotos_restantes+' na fila · vendas aliviadas: '+r.docs_migrados+' (faltam '+r.docs_restantes+') · economizou ~'+Math.round(eco/102.4)/10+' MB';
      if(!r.restantes){ st.textContent+=' · ✅ terminou'; break; }
    }
    _vtFaxLiga=false; bt.textContent='Continuar a faxina';
  }

  async function telaVendas(aba){
    mevTabSet('');
    document.body.classList.add('venda-cot');
    _vdTab=_vdTabValida(aba)||'iniciar';
    /* v443: _vdTabsVis, não _VD_TABS — a aba Testes só é DESENHADA pro dono */
    var nav=_vdTabsVis().map(function(t){ return '<button type="button" class="vpx-st'+(t[2]?' vpx-teste':'')+'" data-step="'+t[0]+'"><span class="vpx-ico">'+_VD_ICO[t[0]]+'</span><span class="vpx-nm">'+t[1]+'</span></button>'; }).join('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg cad-float"><h2>Vendas</h2>'+
      /* ===== v444 (PLANO das abas, Parte A) — O DESLIZE ===================
         O #vdBody nascia VAZIO e os painéis só eram criados quando você
         tocava na aba. O motor do deslize (07-avaliacao.js, v240/v245)
         procura o painel VIZINHO no DOM pra arrastar os dois juntos:

             AR.body.querySelector('.vpx-panel[data-panel="'+k2+'"]')

         Não achando, ele não tem o que arrastar: a barra não acompanha o
         dedo, dá o efeito de borracha e o gesto volta pro lugar. Não era o
         gesto que estava quebrado — era o vizinho que não estava lá.

         Agora os painéis nascem TODOS, vazios, com o mesmo anel de
         "Carregando…" do resto do app. O conteúdo continua vindo só quando a
         aba abre (vdAbrir), então nada de rede a mais.

         Escolhi a saída (a) do plano — esqueleto no painel — e não a (b)
         (pré-carregar os vizinhos): (a) não gasta rede nenhuma, e o vizinho
         só fica visível durante o próprio arrasto. */
      '<div class="vpx"><div class="vpx-steps vpx-mdr" id="vdTabs">'+nav+'</div>'+
      '<div class="vpx-body cad-float" id="vdBody">'+
        _vdTabsVis().map(function(t){
          return '<div class="vpx-panel" data-panel="'+t[0]+'">'+pgLoad('Carregando…')+'</div>';
        }).join('')+
      '</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    /* 🔴 v795 — A MARCA VEM AQUI, DEPOIS DE A TELA ESTAR MONTADA, e não no
       começo da função. O mevTabSet() e o irTela() rodam no meio do caminho e
       LIMPAM as classes de página (é o trabalho deles: sair de uma tela apaga
       a marca da anterior). Marcar antes deles era marcar e perder — medido:
       as cinco telas ficavam sem `oper-on` e sem dock, com o código todo
       "certo". Ver o changelog da v795. */
    document.body.classList.add('oper-on');
    try{ consultaUiDockMedir(); }catch(_){ }
    Array.prototype.forEach.call(document.querySelectorAll('#vdTabs .vpx-st'),function(b){
      b.onclick=function(){ vdAbrir(b.getAttribute('data-step')); };
    });
    await vdAbrir(_vdTab);
  }

  /* A LISTA DE ESCOLHER O CARRO (era o corpo da antiga telaVendas).
     Recebe "alvo" = o painel da aba. Sem alvo, desenha a tela inteira — assim
     qualquer atalho antigo que chamava esta lista direto continua abrindo. */
  async function vendasPainelEscolher(alvo){
    if(!alvo) mevTabSet('');
    _vendaEstFiltro='';
    _vendaEstOrdem='padrao';
    (alvo||$('secoes')).innerHTML=(alvo?'':_cadBack())+'<div class="info-pg vv-pg">'+
      /* v396 (pedido): saiu o "+ Veículo fora do estoque" — a venda parte
         sempre de um carro do estoque. vendaNovaAbrir(null) continua
         existindo; pra voltar, é recolocar o botão aqui. */
      '<div class="vv-top"><div><h2>Iniciar venda</h2><p>Escolha um veículo para iniciar a negociação.</p></div></div>'+
      '<div class="vv-tools"><div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="vendaBusca" placeholder="Buscar placa ou modelo do estoque" autocomplete="off"></div></div><div class="vv-ord"><label for="vendaOrdem">Ordenar por</label><select id="vendaOrdem"><option value="padrao">Ordem do estoque</option><option value="preco-menor">Menor preço</option><option value="preco-maior">Maior preço</option><option value="km-menor">Menor quilometragem</option><option value="km-maior">Maior quilometragem</option></select></div></div>'+
      '<div class="vv-filtros" id="vendaEstoqueFiltros"></div>'+
      '<div class="vv-hint">Veículos do estoque</div>'+
      '<div id="vendaEstoque"><div class="cli-empty">Carregando...</div></div>'+   /* v396: sem .vv-grid — os cards agora são os do estoque */
      '</div>';
    if(!alvo){ $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome); }
    $('vendaBusca').oninput=function(){ vendaPintaEstoque(this.value); };
    $('vendaOrdem').onchange=function(){ _vendaEstOrdem=this.value||'padrao'; vendaPintaEstoque((($('vendaBusca')||{}).value)||''); };
    if(!_estoque.length){ await estCarregar(); }
    else { try{ estRepasseCarregar().then(function(){ vendaPintaEstoque((($('vendaBusca')||{}).value)||''); }); }catch(_){ } }  /* v183 */
    vendaPintaEstoque('');
    /* v192 — a lista de negociacoes em andamento SAIU daqui. Ela agora mora
       dentro da propria venda, na primeira aba ("Andamento"), mostrando so'
       as negociacoes DAQUELE carro. Continuo carregando as vendas aqui porque
       e' essa lista (_vendas) que a aba vai usar. */
    vendaCarregar();
  }

  function vendaEstoqueFiltrosHtml(){
    var box=$('vendaEstoqueFiltros'); if(!box) return;
    var ativos=(_estoque||[]).filter(function(v){ return (v.status||'disponivel')!=='vendido'; });
    var chips=[
      ['', 'Todos', ativos.length],
      ['disponivel', 'Disponíveis', ativos.filter(function(v){ return (v.status||'disponivel')==='disponivel'; }).length],
      ['reservado', 'Reservados', ativos.filter(function(v){ return v.status==='reservado'; }).length],
      ['repasse', 'Repasse', ativos.filter(estEhRepasse).length]
    ];
    box.innerHTML=chips.map(function(c){ return '<button type="button" class="vv-filtro'+(_vendaEstFiltro===c[0]?' on':'')+'" data-f="'+esc(c[0])+'">'+esc(c[1])+' <b>'+c[2]+'</b></button>'; }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.vv-filtro'),function(b){ b.onclick=function(){ _vendaEstFiltro=b.getAttribute('data-f')||''; vendaPintaEstoque((($('vendaBusca')||{}).value)||''); }; });
  }
  function vendaPintaEstoque(termo){
    var el=$('vendaEstoque'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    vendaEstoqueFiltrosHtml();
    var disp=(_estoque||[]).filter(function(v){
      if((v.status||'disponivel')==='vendido') return false;
      if(_vendaEstFiltro==='repasse') return estEhRepasse(v);
      return !_vendaEstFiltro || (v.status||'disponivel')===_vendaEstFiltro;
    });
    if(termo) disp=disp.filter(function(v){ return ((v.placa||'')+' '+(v.marca||'')+' '+(v.modelo||'')).toLowerCase().indexOf(termo)>=0; });
    var ordem=_vendaEstOrdem;
    if(ordem!=='padrao') disp.sort(function(a,b){
      var campo=ordem.indexOf('preco')===0?'preco':'km';
      var av=Number(campo==='preco'?(a.preco_anuncio||a.preco_minimo):a.km)||0;
      var bv=Number(campo==='preco'?(b.preco_anuncio||b.preco_minimo):b.km)||0;
      if(!av&&!bv) return 0;
      if(!av) return 1;
      if(!bv) return -1;
      return (av-bv)*(ordem.slice(-6)==='menor'?1:-1);
    });
    if(!disp.length){ el.innerHTML='<div class="cli-empty"><b>Nenhum veículo disponível</b>Cadastre veículos no Estoque para iniciar uma venda.</div>'; return; }
    /* ===== v396 (pedido) — O MESMO CARD DO ESTOQUE ========================
       A lista de escolher o carro usava um card próprio (vv-card, foto à
       esquerda). Agora usa o card do estoque (estThumb com a tira de fotos
       deslizável, nome, placa, chips, preço). A diferença é a ação: aqui o
       toque INICIA A VENDA, então no lugar dos ícones entra o "Iniciar
       venda →". O visual vem do styles: o seletor do #estLista também vale
       pro #vendaEstoque. */
    el.innerHTML=disp.map(function(v){
      var nomeVeic=_vpVeicNome(v);
      var foto=estThumb(v);
      var repBadge=estRepBadge(v);
      var preco=v.preco_anuncio?estMoney(v.preco_anuncio):(v.preco_minimo?('mín. '+estMoney(v.preco_minimo)):'—');
      var st=EST_STATUS[v.status]||EST_STATUS.disponivel;
      var dados=[]; var ano=_efAnoTxt(v);
      if(ano) dados.push('<span>'+_ICO_CAL+esc(ano)+'</span>');
      if(v.km) dados.push('<span>'+_EST_ICO_KM+Number(v.km).toLocaleString('pt-BR')+' km</span>');
      if(v.cor) dados.push('<span>'+_EST_ICO_COR+esc(v.cor)+'</span>');
      return '<div class="est-card est-vv-card" data-id="'+esc(v.id)+'" role="button" tabindex="0" aria-label="Iniciar venda de '+esc(nomeVeic)+'">'+foto+
        '<div class="est-tx"><div class="est-nm">'+esc(nomeVeic)+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.ano?' · '+esc(v.ano):'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':'')+'</div>'+
        '<div class="est-card-placa">'+esc(v.placa||'Sem placa')+'</div>'+
        (dados.length?('<div class="est-card-dados">'+dados.join('')+'</div>'):'')+
        '<div class="est-row"><span class="est-preco">'+esc(preco)+'</span><span class="est-badge" style="color:'+st.c+';background:'+st.bg+';border-color:'+st.bd+'">'+esc(st.t)+'</span><span class="vv-ir">Iniciar venda <i>→</i></span></div>'+
        (repBadge?('<div class="est-meta">'+repBadge+'</div>'):'')+'</div>'+
        '<div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      card.onclick=function(){ vendaIniciarComVeiculo(card.getAttribute('data-id')); };
      card.onkeydown=function(e){ if(e.target!==card||(e.key!=='Enter'&&e.key!==' ')) return; e.preventDefault(); vendaIniciarComVeiculo(card.getAttribute('data-id')); };
    });
    estStripsWire(el);   /* v396: tira de fotos + foto reserva, igual ao estoque */
  }
  async function vendaIniciarComVeiculo(estId){
    var v=(_estoque||[]).filter(function(x){ return String(x.id)===String(estId); })[0]; if(!v) return;
    await vendaNovaAbrir(null);
    _vp.veiculo={ estoque_id:v.id, marca:v.marca, modelo:v.modelo, placa:v.placa, ano:v.ano, cor:v.cor, km:v.km, fotos:(v.fotos||[]).slice(), preco_anuncio:v.preco_anuncio||0, preco_minimo:v.preco_minimo||0, obs:v.obs||'', extras:v.extras||{} };
    /* A proposta começa no mínimo definido pela loja. O preço do anúncio
       continua visível como referência, mas nunca aumenta a oferta inicial
       por acidente. */
    _vp.precoVenda=Number(v.preco_minimo)||Number(v.preco_anuncio)||0;
    _vpRenderTudo();
  }
  async function vendaCarregar(){ try{ var r=await withTimeout(supa.from('vendas').select('*').order('criado_em',{ascending:false}),9000); _vendas=(r&&r.data)||[]; }catch(e){ _vendas=[]; } }
  function vendaFiltrosHtml(){
    var box=$('vendaFiltros'); if(!box) return;
    var chips=[['','Todas',_vendas.length]].concat(VENDA_ETAPAS.map(function(e){ return [e.k,e.t,_vendas.filter(function(v){return v.etapa===e.k;}).length]; }));
    box.innerHTML=chips.map(function(c){ return '<button class="est-chip'+(_vendaFiltro===c[0]?' on':'')+'" data-f="'+c[0]+'">'+esc(c[1])+' · '+c[2]+'</button>'; }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.est-chip'),function(b){ b.onclick=function(){ _vendaFiltro=b.getAttribute('data-f'); vendaPinta((($('vendaBusca')||{}).value)||''); }; });
  }
  function vendaPinta(termo){
    vendaFiltrosHtml();
    var el=$('vendaLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    if(!_vendas.length){ el.innerHTML='<div class="cli-empty"><b>Nenhuma venda ainda</b>Toque em "+ Novo" ou gere uma venda a partir de uma consulta.</div>'; return; }
    var lista=_vendas.filter(function(v){ if(_vendaFiltro && v.etapa!==_vendaFiltro) return false; if(!termo) return true; return ((v.placa||'')+' '+(v.veiculo||'')+' '+(v.cliente_nome||'')).toLowerCase().indexOf(termo)>=0; });
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado.</div>'; return; }
    el.innerHTML=lista.map(function(v){ var e=vendaEtapaInfo(v.etapa);
      return '<div class="est-card" data-id="'+esc(v.id)+'"><div class="est-tx"><div class="est-nm">'+esc(v.veiculo||'Veículo')+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.cliente_nome?(' · '+esc(v.cliente_nome)):'')+'</div>'+
        '<div class="est-row"><span class="est-preco">'+(v.valor_venda?estMoney(v.valor_venda):'—')+'</span><span class="est-badge" style="color:'+e.c+';background:'+e.c+'14;border-color:'+e.c+'44">'+esc(e.t)+'</span></div></div><div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){ card.onclick=function(){ var id=card.getAttribute('data-id'); var vv=(_vendas||[]).filter(function(x){return String(x.id)===String(id);})[0]; if(vv&&vv.proposta) vendaNovaAbrir(id); else vendaAbrir(id); }; });
  }
  function vendaStepperHtml(etapa){
    var idx=VENDA_ETAPAS.map(function(e){return e.k;}).indexOf(etapa); if(idx<0) idx=0;
    return '<div class="vd-stepper" id="vdStepper">'+VENDA_ETAPAS.map(function(e,i){
      var cls=i<idx?'done':(i===idx?'now':'');
      return '<button type="button" class="vd-step '+cls+'" data-etapa="'+e.k+'"><span class="vd-dot"></span><span class="vd-lb">'+esc(e.t)+'</span></button>';
    }).join('')+'</div>';
  }
  function vendaChecklistHtml(v){ var saved={}; ((v&&v.entrega_checklist)||[]).forEach(function(c){ if(c&&c.item) saved[c.item]=!!c.ok; });
    return ENTREGA_ITENS.map(function(it){ var ok=!!saved[it]; return '<label class="vd-ck'+(ok?' on':'')+'"><input type="checkbox" data-item="'+esc(it)+'"'+(ok?' checked':'')+'><span>'+esc(it)+'</span></label>'; }).join('');
  }
  function vendaFormHtml(v){ v=v||{};
    var clienteSel='<select class="cad-in" id="vdCliente"><option value="">— sem cliente —</option>'+vendaClienteOptions(v.cliente_id)+'</select>';
    var formaSel='<select class="cad-in" id="vdForma"><option value="">—</option>'+VENDA_FORMAS.map(function(f){return '<option'+(v.forma_pagamento===f?' selected':'')+'>'+esc(f)+'</option>';}).join('')+'</select>';
    return '<input type="hidden" id="vdEtapa" value="'+esc(v.etapa||'negociacao')+'"><div id="vdStepWrap">'+vendaStepperHtml(v.etapa||'negociacao')+'</div>'+
      '<label class="cad-lbl">Placa</label><input class="cad-in" id="vdPlaca" value="'+esc(v.placa||'')+'" placeholder="ABC1D23" style="text-transform:uppercase">'+
      '<label class="cad-lbl">Veículo</label><input class="cad-in" id="vdVeiculo" value="'+esc(v.veiculo||'')+'" placeholder="Marca e modelo">'+
      '<div class="cli-2col"><div><label class="cad-lbl">Ano</label><input class="cad-in" id="vdAno" inputmode="numeric" value="'+esc(v.ano||'')+'" placeholder="2020"></div><div><label class="cad-lbl">Cor</label><input class="cad-in" id="vdCor" value="'+esc(v.cor||'')+'" placeholder="Cor"></div></div>'+
      '<label class="cad-lbl">Cliente</label>'+clienteSel+'<button type="button" class="vd-wa" id="vdWa">WhatsApp do cliente</button>'+
      '<label class="cad-lbl">Vendedor <span class="ec-hint">(quem fica com a comissão)</span></label>'+
      '<select class="cad-in" id="vdVendedor">'+_comVendedorOptions(String(v.vendedor_id||v.user_id||meuId||''))+'</select>'+
      '<div class="cli-2col"><div><label class="cad-lbl">Valor da venda</label><input class="cad-in" id="vdValor" inputmode="numeric" value="'+(v.valor_venda?('R$ '+Number(v.valor_venda).toLocaleString('pt-BR')):'')+'" placeholder="R$ 0"></div><div><label class="cad-lbl">Forma de pagamento</label>'+formaSel+'</div></div>'+
      '<div class="cli-2col"><div><label class="cad-lbl">Data da venda</label><input class="cad-in" id="vdDataV" type="date" value="'+esc(v.data_venda||'')+'"></div><div><label class="cad-lbl">Data da entrega</label><input class="cad-in" id="vdDataE" type="date" value="'+esc(v.data_entrega||'')+'"></div></div>'+
      '<div class="cad-sec"><h3>Checklist de entrega</h3><div class="vd-check" id="vdCheck">'+vendaChecklistHtml(v)+'</div></div>'+
      '<label class="cad-lbl">Observações</label><textarea class="cad-in" id="vdObs" rows="2" placeholder="Detalhes da negociação, condições...">'+esc(v.obs||'')+'</textarea>'+
      '<label class="cad-lbl">Pós-venda (retorno ao cliente)</label><textarea class="cad-in" id="vdPos" rows="2" placeholder="Agendamento de retorno, satisfação, revisão...">'+esc(v.posvenda_obs||'')+'</textarea>'+
      '<button class="cad-btn" id="vdSalvar" style="margin-top:14px">Salvar venda</button><div class="cad-msg" id="vdMsg"></div>'+
      (v.id?'<button class="cad-btn sair" id="vdDel" style="margin-top:10px">Apagar venda</button>':'');
  }
  function vendaBindStepper(){
    Array.prototype.forEach.call(document.querySelectorAll('#vdStepper .vd-step'),function(b){ b.onclick=function(){ var et=b.getAttribute('data-etapa'); var h=$('vdEtapa'); if(h) h.value=et; var wrap=$('vdStepWrap'); if(wrap) wrap.innerHTML=vendaStepperHtml(et); vendaBindStepper(); }; });
  }
  function vendaWire(v){
    var pl=$('vdPlaca'); if(pl) pl.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); };
    var val=$('vdValor'); if(val) val.oninput=estMaskRSint;
    vendaBindStepper();
    Array.prototype.forEach.call(document.querySelectorAll('#vdCheck input[type=checkbox]'),function(cb){ cb.onchange=function(){ var lb=cb.closest('.vd-ck'); if(lb) lb.classList.toggle('on',cb.checked); }; });
    var wa=$('vdWa'); if(wa) wa.onclick=function(){ var cliId=($('vdCliente')||{}).value; var c=(_clientes||[]).filter(function(x){return String(x.id)===String(cliId);})[0]; var u=c&&cliWhatsUrl(c.telefone); if(u){ try{window.open(u,'_blank');}catch(_){location.href=u;} } else toast('Selecione um cliente com telefone.'); };
    $('vdSalvar').onclick=function(){ vendaSalvar(_vendaRec?_vendaRec.id:null); };
    var d=$('vdDel'); if(d) d.onclick=function(){ vendaApagar(_vendaRec&&_vendaRec.id); };
  }
  /* ===== v305 (pedido) — "quando clicar em voltar agora, volta pro estoque" =
     O Voltar da venda caia na telaVendas() — a lista "escolha um veiculo pra
     iniciar a negociacao". Ela SAIU DO MENU na v301, quando o Iniciar venda
     passou pro card do Estoque; so que os botoes continuaram apontando pra
     ela. Resultado: voce fechava a venda e caia numa tela orfa, que nao
     existe mais em lugar nenhum do app.

     Sao OITO pontos apontando pra la (Voltar da venda, Voltar da cotacao,
     salvar venda, apagar venda, reabrir venda, documentos do usado, salvar
     cotacao). Conferi um por um: todos levam a pessoa PRA FORA da venda, e o
     lugar certo pra sair hoje e o Estoque — e de la que a venda nasce.

     Um nome so pra todos: se um dia o destino mudar de novo, muda aqui. */
  function vendaSair(){ try{ return telaEstoque(); }catch(_){ return telaVendas(); } }

  async function vendaAbrir(id, prefill){
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>'+(id?'Venda':'Nova venda')+'</h2><div id="vdForm"><div class="cli-empty">Carregando...</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vendaSair);   /* v305 */
    await cliCarregar();
    try{ await comMembrosCarregar(); }catch(_){}   /* v193 — lista de vendedores */
    if(id && !_vendas.length){ await vendaCarregar(); }
    var v = id ? (_vendas.filter(function(x){return String(x.id)===String(id);})[0]||{}) : (prefill||{});
    _vendaRec = id ? v : null;
    $('vdForm').innerHTML=vendaFormHtml(v);
    vendaWire(v);
  }
  async function vendaSalvar(id){
    var m=$('vdMsg'); if(m) m.className='cad-msg';
    function gv(x){ var e=$(x); return e?(e.value||'').trim():''; }
    var cliId=gv('vdCliente'); var cliNome=''; if(cliId){ var c=(_clientes||[]).filter(function(x){return String(x.id)===String(cliId);})[0]; cliNome=(c&&c.nome)||''; }
    var checklist=[]; Array.prototype.forEach.call(document.querySelectorAll('#vdCheck input[type=checkbox]'),function(cb){ checklist.push({item:cb.getAttribute('data-item'),ok:cb.checked}); });
    var reg={ cliente_id:cliId||null, cliente_nome:cliNome||null, placa:gv('vdPlaca'), veiculo:gv('vdVeiculo'), ano:gv('vdAno'), cor:gv('vdCor'),
      valor_venda:(parseInt(gv('vdValor').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||null), forma_pagamento:gv('vdForma')||null, etapa:gv('vdEtapa')||'negociacao',
      entrega_checklist:checklist, data_venda:gv('vdDataV')||null, data_entrega:gv('vdDataE')||null, obs:gv('vdObs'), posvenda_obs:gv('vdPos') };
    /* v193 — de quem e' esta venda (pra comissao). Se ninguem escolher, sou eu. */
    reg.vendedor_id=gv('vdVendedor')||meuId||null;
    reg.vendedor_nome=(_comMbr&&_comMbr[reg.vendedor_id]&&_comMbr[reg.vendedor_id].nome)||(String(reg.vendedor_id)===String(meuId)?(meuNome||null):null);
    if(!reg.placa && !reg.veiculo){ if(m){ m.className='cad-msg err'; m.textContent='Informe ao menos a placa ou o veículo.'; } return; }
    var btn=$('vdSalvar'); btn.disabled=true; btn.textContent='Salvando...';
    try{
      if(id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('vendas').update(reg).eq('id',id); if(r&&r.error) throw r.error; }
      else { reg.user_id=meuId; var r2=await supa.from('vendas').insert(reg).select().single(); if(r2&&r2.error) throw r2.error; _vendaRec=r2&&r2.data; }
      toast('Venda salva.'); vendaSair();
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } btn.disabled=false; btn.textContent='Salvar venda'; }
  }
  async function vendaApagar(id){ if(!id) return; if(!confirm('Apagar esta venda?')) return; try{ var r=await supa.from('vendas').delete().eq('id',id); if(r&&r.error) throw r.error; toast('Venda apagada.'); vendaSair(); }catch(e){ toast('Não consegui apagar.'); } }
  async function vendaFromConsulta(){
    var v=veiculoAtual; if(!v){ toast('Faça uma consulta primeiro.'); return; }
    var cliId=null;
    try{ if(v.placa){ var rc=await supa.from('cliente_consulta').select('cliente_id').eq('placa',v.placa).limit(1); if(rc&&rc.data&&rc.data[0]) cliId=rc.data[0].cliente_id; } }catch(_){}
    vendaAbrir(null,{ placa:v.placa, veiculo:((v.marca||'')+' '+(v.modelo||'')).trim(), ano:v.ano, cor:_dadoUtil(v.cor), valor_venda:v.fipe, cliente_id:cliId });
  }

  /* ================= NOVA VENDA — calculadora do seminovo ================= */
  var _vp=null, _vpEditId=null, _vpPost='', _ultAssin=null, _vpStep='cliente';
  /* Compatibilidade com links antigos que ainda pedem a antiga aba de fechamento. */
  var _vpStepIni='', _vpFechadaGestao=false;
  function _vpNovo(){ return { cliente_id:'', cliente_nome:'', cliente_tel:'', veiculo:null, precoVenda:0, desconto:0, acrescimo:0, cortesias:0, cortesia_desc:'', transf_inclui:false, transf_valor:700, apresentacao:{}, comparacao:null,
    renda:0, cpf:'', cpf_res:null, credito:null,
    troca:{tem:true,placa:'',modelo:'',ano:'',km:0,fipe:0,avaliacao:0,quitacao:0,dados:null},
    pag:{tipo:'avista',pessoa:'PF',entrada:0,parcelas:48,juros:_vpJurosPadrao(48),ret:0} }; }
  /* ===== v371 (pedido) — TAXA PADRÃO POR PRAZO ==============================
     Até 48x: 2,09% a.m.   ·   de 49x a 60x: 2,19% a.m.
     A taxa troca sozinha quando você muda o número de parcelas — MAS só
     enquanto você não tiver digitado uma taxa à mão. No instante em que o
     vendedor digita no campo Juros, o app marca `juros_manual` e nunca mais
     mexe ali: a taxa que o banco passou naquele caso vale mais que a tabela. */
  function _vpJurosPadrao(n){ n=parseInt(n,10)||48; return (n>48)?2.19:2.09; }
  /* toda a matemática da proposta num único lugar */
  function vpCalc(p){
    p=p||{}; var precoVenda=+p.precoVenda||0, desc=+p.desconto||0, acr=+p.acrescimo||0;
    var transf=(p.transf_inclui?(+p.transf_valor||0):0);   /* v157: entra no preço do cliente, mas NÃO mexe na margem (é repasse) */
    var cort=(+p.cortesias||0);                            /* v157: cortesia SOMA no valor ao cliente (também é repasse) */
    var vendaLiq=Math.max(0, precoVenda-desc+acr);          /* o que fica pra loja (base da margem e do imposto) */
    var precoFinal=Math.max(0, vendaLiq+transf+cort);       /* o que o cliente paga */
    var tem=!!(p.troca&&p.troca.tem);
    var aval=tem?(+p.troca.avaliacao||0):0, quit=tem?(+p.troca.quitacao||0):0;
    var trocaLiq=aval-quit, saldo=precoFinal-aval+quit;
    var pag=p.pag||{}, entrada=+pag.entrada||0;
    var base=Math.max(0, saldo-entrada);
    var TAC=(pag.pessoa==='PJ')?2500:1500;                       /* TAC: R$1.500 CPF · R$2.500 CNPJ */
    var IOF=0.04*base;                                            /* IOF 4% sobre o financiado */
    var RET=(Math.min(6,+pag.ret||0)/100)*base;                   /* retorno da loja: até 6% */
    var financiado=base+TAC+IOF+RET;                              /* juros incidem sobre financiado+TAC+IOF+retorno */
    var i=(+pag.juros||0)/100, n=Math.min(60,Math.max(1,parseInt(pag.parcelas,10)||1)), parcela=0;
    var parcelado=(pag.tipo==='parcelado' && base>0);
    if(parcelado){ parcela = i>0 ? financiado*i/(1-Math.pow(1+i,-n)) : financiado/n; }
    return { precoVenda:precoVenda, precoFinal:precoFinal, vendaLiq:vendaLiq, aval:aval, quit:quit, trocaLiq:trocaLiq, saldo:saldo,
      entrada:entrada, base:base, TAC:TAC, IOF:IOF, SPF:0, RET:RET, financiado:financiado, parcela:parcela, n:n, cort:cort, transf:transf,
      parcelado:parcelado, totalParc: entrada+parcela*n };
  }
  /* custo interno do veículo (compra + preparação + comissão + NF) — padrão da cotação */
  function _vpCustoCalc(c){
    var v=_vp&&_vp.veiculo; var est=_vpEstAtual(v); if(!est) return null;
    var compra=+est.preco_compra||0; var cc=est.custos||{};
    var min=estRS('vpMin')||(+((v&&v.preco_minimo)||0));
    var com=Math.round(min*((+cc.com_pct||0))/100);
    /* v157: cada custo aparece com o MESMO nome que foi digitado na aba Custos do veículo */
    var LBL={hig:'Higienização',pol:'Polimento',fun:'Funilaria',pneus:'Pneus',mec:'Mecânica',doc:'Documentação'};
    var itens=[]; var fixos=0;
    ['hig','pol','fun','pneus','mec','doc'].forEach(function(k){ var val=+cc[k]||0; if(val){ fixos+=val; itens.push({nome:LBL[k],val:val}); } });
    _ccOutros(cc).forEach(function(o){ var val=Number(o.val)||0; if(val){ fixos+=val; itens.push({nome:(String(o.nome||'').trim()||'Outro custo'),val:val}); } });
    var invest0=compra+com+fixos;
    var venda=(c&&(c.vendaLiq!=null?c.vendaLiq:c.precoFinal))||0;   /* v157: sem transferência e sem cortesia (são repasse) */
    var nfBase=(cc.nf_base==='venda')?venda:Math.max(0,venda-invest0);
    var nf=Math.round(nfBase*((+cc.nf_pct||0))/100);
    var total=invest0+nf;
    if(!compra&&!fixos&&!com) return null;
    return { compra:compra, com:com, com_pct:(+cc.com_pct||0), nf_pct:(+cc.nf_pct||0), itens:itens, fixos:fixos, nf:nf, total:total, margem:venda-total, pct:(total>0?Math.round((venda-total)/total*100):0) };
  }
  async function vendaNovaAbrir(id){
    mevTabSet('');
    if(_vpStepIni==='fechada'){ _vpStepIni=''; return telaVendaFechada(id); }
    _vpFechadaGestao=false;
    _vpStep=_vpStepIni||'cliente'; _vpStepIni=''; document.body.classList.add('venda-cot');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>'+(id?'Venda':'Nova venda')+'</h2><div id="vpForm"><div class="cli-empty">Carregando...</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vendaSair);   /* v305 */
    await cliCarregar(); if(!_estoque.length){ await estCarregar(); }
    if(!_vendas.length) await vendaCarregar();   /* v192: a aba Andamento precisa da lista */
    var v=null; if(id){ v=_vendas.filter(function(x){return String(x.id)===String(id);})[0]||null; }
    _vpPrepararRegistro(v,id);
    _vpRenderTudo();
  }
  function _vpPrepararRegistro(v,id){
    _vpEditId=id||null; _vpPost='';
    _vp = (v&&v.proposta) ? v.proposta : _vpNovo();
    if(v&&!v.proposta){ _vp.cliente_id=v.cliente_id||''; _vp.cliente_nome=v.cliente_nome||''; }
    if(!_vp.pag) _vp.pag=_vpNovo().pag; if(!_vp.troca) _vp.troca=_vpNovo().troca;
    if(!_vp.apresentacao || typeof _vp.apresentacao!=='object') _vp.apresentacao={};
    if(_vp.troca.km==null) _vp.troca.km=0;
    _vp.troca.tem=true; _vpTrocaAuto=String(_vp.troca.placa||'');
    if(!_vp.pag.juros_manual) _vp.pag.juros=_vpJurosPadrao(_vp.pag.parcelas);
    if(_vp.transf_inclui==null) _vp.transf_inclui=!!_vp.transf_cortesia;
    if(!_vp.transf_valor) _vp.transf_valor=700;
    if(_vp.veiculo && !(Number(_vp.precoVenda)>0)) _vp.precoVenda=Number(_vp.veiculo.preco_minimo)||Number(_vp.veiculo.preco_anuncio)||0;
  }
  function _vpVeicNome(x){ return ((x.marca||'')+' '+(x.modelo||'')).trim()||'Veículo'; }
  /* itens da FICHA TÉCNICA do veículo (se já gerada) — mostrados na aba Veículo */
  function _vpFichaHtml(v){
    if(!v||!v.placa) return '';
    var pl=limpa(String(v.placa));
    var ft=null; try{ ft=fichaTecObter(pl); }catch(_){}
    if(!ft) return '<div style="font-size:11.5px;color:#94a3b8;font-weight:600;margin-top:12px">Ficha técnica: gere no cadastro do veículo (Estoque) pra mostrar os itens aqui.</div>';
    var p=null; try{ p=fichaTecParse(ft); }catch(_){}
    if(!p||!p.conhecido) return '';
    var rows=[];
    function pick(arr,ks){ (arr||[]).forEach(function(r){ if(ks.indexOf(r[0])>=0 && r[1]) rows.push(r); }); }
    pick(p.motor,['Motor','Câmbio','Direção','Combustível']);
    pick(p.desemp,['Potência','Torque','0–100 km/h','Consumo cidade','Consumo estrada']);
    var f=null; try{ f=fichaParaRepasse(pl); }catch(_){}
    if(!f) f={ serie:(p.equip||[]).filter(function(e){ return !/OPCION|INDISPON/.test(e.disp); }).map(function(e){ return e.nome; }).slice(0,20), opcionais:[] };
    var eq=(f.serie||[]).concat(f.opcionais||[]);
    return '<div class="vpf"><div class="vpf-tit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>Ficha técnica</div>'+
      (rows.length?('<div class="vpf-kv">'+rows.map(function(r){ return '<div><span>'+esc(r[0])+'</span><b>'+esc(r[1])+'</b></div>'; }).join('')+'</div>'):'')+
      (eq.length?('<div class="vpf-eq-t">Equipamentos ('+eq.length+')</div><div class="vpf-eq">'+eq.map(function(n){ return '<span>'+esc(n)+'</span>'; }).join('')+'</div>'):'')+
    '</div>';
  }
  /* fotos/extras sempre ATUAIS: busca o registro vivo do estoque (vendas salvas
     antigas guardavam só a foto da época) */
  function _vpEstAtual(v){
    if(!v) return null;
    var arr=_estoque||[];
    var e=v.estoque_id?arr.filter(function(x){ return String(x.id)===String(v.estoque_id); })[0]:null;
    if(!e&&v.placa){ var pl=String(v.placa).toUpperCase(); e=arr.filter(function(x){ return String(x.placa||'').toUpperCase()===pl; })[0]; }
    return e||null;
  }
  /* v171 — a lista de fotos que esta' na tela de venda agora fica guardada
     aqui, pra quando o vendedor tocar numa foto eu saber quais sao todas. */
  var _vpGalFotos=[];
  /* galeria GRANDE das fotos do veículo (slide pra mostrar ao cliente) */
  function _vpGalHtml(v){
    var est=_vpEstAtual(v);
    var fotos=(est&&est.fotos&&est.fotos.length)?est.fotos:((v&&v.fotos)||[]);
    if(!fotos.length) return '';
    _vpGalFotos=fotos.slice();
    return '<div class="vpg"><div class="vpg-tr" id="vpgTr">'+fotos.map(function(f,i){ return fotosGaleriaImg(f,i,'foto '+(i+1)); }).join('')+'</div>'+
      '<span class="vpg-zoom">'+mkIco('ampliar',13)+'toque pra ampliar</span>'+
      (fotos.length>1?('<div class="vpg-dots">'+fotos.map(function(_,i){ return '<i'+(i?'':' class="on"')+'></i>'; }).join('')+'</div><div class="vpg-cnt" id="vpgCnt">1/'+fotos.length+'</div>'):'')+
    '</div>';
  }
  /* v180 -> v188 -> v192, a historia desta parte:
     v180: a aba Veiculo tinha um botao "Ver a pagina do veiculo" que jogava
           voce PRA FORA da venda.
     v188: no lugar dele entrou uma <iframe> — a pagina do cliente aparecia
           EMBUTIDA aqui dentro.
     v192: a janelinha SAIU. Ela ocupava quase a tela inteira do celular,
           empurrava a ficha tecnica e os detalhes pra baixo e ainda carregava
           uma pagina inteira dentro da venda. Agora e' mais simples: o CARD
           do veiculo virou o botao — tocou nele, abre a pagina do carro numa
           aba nova; a palavrinha "trocar" dentro do card continua trocando o
           veiculo. (O CSS .vp-pagv ficou no arquivo, sem uso, caso um dia
           voce queira a janelinha de volta.) */
  /* chips com km + diferenciais (único dono, IPVA pago, revisões) e opcionais do estoque */
  function _vpVeicDetalhes(v){
    var est=_vpEstAtual(v);
    var ex=(est&&est.extras)||(v&&v.extras)||{}; var chips=[];
    /* v174: os 5 diferenciais novos tambem aparecem aqui, na mesma lista _EX_DIF */
    _EX_DIF.forEach(function(d){ if(ex[d.k]) chips.push(d.e+' '+d.t); });
    var opc=String(ex.opcionais||'').trim();
    if(!chips.length && !opc) return '';
    return '<div class="vp-veic-det">'+
      (chips.length?('<div class="vpd-chips">'+chips.map(function(c){ return '<span>'+esc(c)+'</span>'; }).join('')+'</div>'):'')+
      (opc?('<div class="vpd-opc"><b>Opcionais:</b> '+esc(opc)+'</div>'):'')+
    '</div>';
  }
  /* ============== v192 — ABA "ANDAMENTO" DENTRO DA VENDA ==============
     ANTES: a tela inicial de Vendas mostrava TODAS as negociacoes abertas
     numa lista so'. Isso nao ajudava na hora certa — voce so' descobria que
     outro vendedor ja' estava com aquele carro depois de montar a proposta.
     AGORA: a informacao aparece DENTRO da venda, na PRIMEIRA aba, filtrada
     pelo carro que voce escolheu. Voce abre a venda do Polo e a primeira
     coisa que ve' e': "atencao, tem mais 2 pessoas negociando este Polo".

     O QUE TEM POR TRAS: nao busquei nada novo no banco. A lista _vendas ja'
     estava carregada; eu so' peneiro ela pela PLACA (ou pelo id do estoque)
     do veiculo da venda aberta, e tiro da lista a propria cotacao que voce
     esta' editando (senao ela apareceria como "concorrente" de si mesma). */
  function _vpNegocsDoVeiculo(){
    var v=(_vp&&_vp.veiculo)||null; if(!v) return [];
    var lim=function(x){ return String(x||'').toUpperCase().replace(/[^A-Z0-9]/g,''); };
    var pl=lim(v.placa), eid=String(v.estoque_id||'');
    return (_vendas||[]).filter(function(x){
      if(_vpEditId && String(x.id)===String(_vpEditId)) return false;      /* a que voce esta' editando */
      if(String(x.etapa||'')==='entregue') return false;                    /* ja' terminou */
      var xe=String((x.proposta&&x.proposta.veiculo&&x.proposta.veiculo.estoque_id)||'');
      if(eid && xe && xe===eid) return true;
      return !!(pl && lim(x.placa)===pl);
    });
  }
  function _vpAndPinta(){
    var el=$('vpNegLista'); if(!el) return;
    var v=(_vp&&_vp.veiculo)||null;
    if(!v){ el.innerHTML='<div class="cli-empty"><b>Escolha o veículo primeiro</b>Assim que você escolher o carro, eu mostro aqui quem mais está negociando ele.</div>'; return; }
    var l=_vpNegocsDoVeiculo();
    if(!l.length){ el.innerHTML='<div class="cli-empty"><b>Nenhuma outra negociação</b>Este veículo não tem outra negociação aberta. Caminho livre.</div>'; return; }
    el.innerHTML='<div class="vp-and-al">Atenção: este carro já está sendo negociado por '+(l.length===1?'mais 1 pessoa':('mais '+l.length+' pessoas'))+'. Confirme antes de fechar.</div>'+
      l.map(function(x){ var e=vendaEtapaInfo(x.etapa);
        return '<div class="est-card va" data-id="'+esc(x.id)+'"><div class="est-tx"><div class="est-nm">'+esc(x.cliente_nome||'Cliente sem nome')+'</div>'+
          '<div class="est-sb"><b>'+esc(x.placa||'-')+'</b>'+(x.veiculo?(' · '+esc(x.veiculo)):'')+'</div>'+
          '<div class="est-row"><span class="est-preco">'+(x.valor_venda?estMoney(x.valor_venda):'—')+'</span><span class="est-badge" style="color:'+e.c+';background:'+e.c+'14;border-color:'+e.c+'44">'+esc(e.t)+'</span></div></div><div class="cli-chev">'+_icoChev+'</div></div>';
      }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      card.onclick=function(){ var id=card.getAttribute('data-id');
        var vv=(_vendas||[]).filter(function(x){return String(x.id)===String(id);})[0];
        if(vv&&vv.proposta) vendaNovaAbrir(id); else vendaAbrir(id); };
    });
  }
  function _vpRenderTudo(){
    var p=_vp, v=p.veiculo, c=vpCalc(p);
    var pagPF=(p.pag.pessoa!=='PJ');
    var _trPl=limpa(String((p.troca&&p.troca.placa)||'')), _trHist=null, _trFicha=null;
    try{ _trHist=_trPl?histLerUm(_trPl):null; }catch(_){ _trHist=null; }
    try{ _trFicha=_trPl?fichaTecObter(_trPl):null; }catch(_){ _trFicha=null; }
    var _trCmpPronta=_vpComparacaoValida(p.comparacao);
    var _trCmpIco='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3l4 4-4 4"/><path d="M3 7h18"/><path d="M7 21l-4-4 4-4"/><path d="M21 17H3"/></svg>';
    var _trConsultas=
      /* v283 — a etiqueta dizia "3 tokens" e mentia. Aquele preço era da base
         oficial paga, que saiu de cena na v241: hoje o botão leva pra MESMA
         ficha por IA da avaliação e do estoque, que custa 1 token. Quem lia
         "3 tokens" simplesmente não abria — cobrando o triplo do que custa. */
      menuCard('vp_troca_ficha',ICO.motor,(_trFicha?'green':'gold'),'Ficha técnica do usado','Motor, câmbio e equipamentos · por IA',_trFicha?'':precoReal(1),!!_trFicha)+
      /* ===== v444 (PLANO das abas, Parte B) ==============================
         "Multas e restrições" (5 tokens) e "Leilão e sinistro" (20 tokens)
         SAÍRAM daqui. Foram pra aba "Conferir o usado" da VENDA FECHADA.

         Por quê: antes de fechar, o trabalho é fazer o cliente DECIDIR —
         e quem ajuda nisso é a ficha técnica e o comparativo, 1 token cada.
         Multas e leilão são a conferência do carro que VAI ENTRAR na loja:
         informação de COMPRA, 25 tokens juntos. Gastar isso num negócio que
         pode não sair é jogar dinheiro fora.

         A função que abre as duas (_vpTrocaConsultaAbrir) NÃO foi tocada —
         é ela mesma que a aba nova chama. Nada foi reimplementado, e
         consulta já feita continua valendo (é guardada por PLACA). */
      menuCard('vp_troca_comparar',_trCmpIco,(_trCmpPronta?'green':'blue'),'Comparar os dois veículos','Economia, motor, mercado, espaço, conforto e km',_trCmpPronta?'':precoReal(1),_trCmpPronta);
    var html=
      '<div class="vpx-panel" data-panel="andamento"><div class="vp-sec"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>Negociações deste veículo</h3>'+
        '<div id="vpNegLista"></div></div></div>'+
      '<div class="vpx-panel" data-panel="cliente"><div class="vp-sec"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>Cliente</h3>'+
        '<label class="cad-lbl">Cliente</label>'+
        _acCaixa('vpCliAc',(function(){ var c=(_clientes||[]).filter(function(x){return String(x.id)===String(p.cliente_id||'');})[0]; return c?(c.nome||''):''; })(),'Digite o nome do cliente…')+
        '<input type="hidden" id="vpCliente" value="'+esc(p.cliente_id||'')+'">'+
        '<div class="cli-2col"><div><label class="cad-lbl">Nome do cliente</label><input class="cad-in" id="vpCliNome" value="'+esc(p.cliente_nome||'')+'" placeholder="Ex: João Silva"></div><div><label class="cad-lbl">Telefone</label><input class="cad-in" id="vpCliTel" inputmode="tel" value="'+esc(p.cliente_tel||'')+'" placeholder="(51) 99999-9999"></div></div>'+
        '<button type="button" class="cad-btn sec" id="vpNovoCli" style="margin:8px 0 0">+ Novo cliente</button></div></div>'+
      '<div class="vpx-panel" data-panel="veiculo"><div class="vp-sec"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.4-3.6c-.4-.5-1-.9-1.6-.9H10c-.6 0-1.2.4-1.6.9L6 10l-2.5 1.1C2.7 12.3 2 13.1 2 14v2c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>Veículo do estoque</h3>'+
        (v ? ('<button type="button" class="vp-pick" id="vpVerVeic">'+((v.fotos&&v.fotos[0])?'<img loading="lazy" decoding="async" class="thumb" src="'+esc(imgCdn(v.fotos[0],400))+'">':'<span class="thumb"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.4-3.6c-.4-.5-1-.9-1.6-.9H10c-.6 0-1.2.4-1.6.9L6 10l-2.5 1.1C2.7 12.3 2 13.1 2 14v2c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg></span>')+'<div class="tx"><div class="nm">'+esc(_vpVeicNome(v))+'</div><div class="sb">'+esc(v.placa||'')+(v.ano?' · '+esc(v.ano):'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':'')+'</div><div class="pr">'+estMoney(v.preco_anuncio||0)+'</div>'+(_vpEstAtual(v)?'<div class="vp-abrir">ver a página do carro</div>':'')+'</div><span class="vp-troca-bt" id="vpTrocarVeic">trocar</span></button>'
          /* v194 — SO O CARD. Antes vinham aqui embaixo os chips de
             diferenciais (Pneus novos, Na garantia de fabrica...) e a FICHA
             TECNICA inteira. No celular isso empurrava as abas Troca /
             Negociacao pra muito longe e obrigava o vendedor a rolar meia
             tela pra continuar a venda. Toda essa informacao continua na
             PAGINA DO CARRO — e so tocar no card, que ja e o botao.
             (As funcoes _vpVeicDetalhes e _vpFichaHtml continuam no arquivo,
             sem uso, caso um dia voce queira elas de volta aqui.) */
          )
        : '<button type="button" class="vp-pick" id="vpEscolher"><span class="thumb">＋</span><div class="tx"><div class="nm">Escolher veículo</div><div class="sb">Toque para ver o estoque disponível</div></div></button>')+
      '</div></div>'+
      '<div class="vpx-panel" data-panel="troca"><div class="vp-sec">'+
        '<label class="cad-lbl">Placa do usado</label>'+
        _acCaixa('vpTrocaPlaca',p.troca.placa||'','ABC1D23',' style="text-transform:uppercase"')+
        '<div class="cad-msg" id="vpTrocaMsg"></div>'+
        /* v370 — o que JÁ existe desta placa (avaliação, ficha, consultas) */
        '<div id="vpTrocaAvalBox"></div>'+
        '<label class="cad-lbl">Modelo e ano</label><input class="cad-in" id="vpTrocaModelo" value="'+esc((function(){ var t=String(p.troca.modelo||''); var a=String(p.troca.ano||''); if(a && t.indexOf(a)<0) t=(t+' '+a).trim(); return t; })())+'" placeholder="Ex: VW Gol 1.0 2018">'+
        '<div class="vpt-valores"><div><label class="cad-lbl">Quilometragem do usado</label><input class="cad-in" id="vpTrocaKm" inputmode="numeric" value="'+esc((+p.troca.km||0).toLocaleString('pt-BR'))+'" placeholder="Ex: 96.000 km"></div><div><label class="cad-lbl">Valor FIPE</label><input class="cad-in" id="vpFipe" inputmode="numeric" value="'+_rs(p.troca.fipe)+'"></div><div><label class="cad-lbl">Avaliação</label><input class="cad-in" id="vpAval" inputmode="numeric" value="'+_rs(p.troca.avaliacao)+'"></div></div>'+
        '<label class="cad-lbl">Quitação ou devolução ao cliente</label><input class="cad-in" id="vpQuit" inputmode="numeric" value="'+_rs(p.troca.quitacao)+'" placeholder="R$ 0">'+
        '<div class="vpt-consultas"><div class="vpt-cons-tit">Consultas do usado</div><div class="menu-lista">'+_trConsultas+'</div></div>'+
        '<div id="vpComparacaoBox">'+(_trCmpPronta?_vpComparacaoHtml(p.comparacao):'')+'</div>'+
        '<button type="button" class="btn-sec-lb" id="vpTrocaEst"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="17" height="17" style="vertical-align:-3px;margin-right:6px"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4"/><line x1="12" y1="11" x2="12" y2="21"/></svg>Cadastrar o usado no estoque</button>'+
        '<div class="cad-msg" id="vpTrocaEstMsg" style="margin:6px 0 0">O usado só entra no estoque quando você tocar no botão.</div>'+
      '</div></div>'+
      '<div class="vpx-panel" data-panel="negociacao"><div class="vp-sec vp-quote"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>Negociação</h3>'+
        /* CUSTO DO VEÍCULO — minimizado (interno) */
        /* v370 (pedido) — a barra "Custo do veículo" saiu da tela. Ela mostrava
           compra + preparação + comissão + NF em cima da negociação, e isso é
           informação interna que não precisa ficar aberta na frente do
           cliente. Os elementos continuam existindo (escondidos) porque a
           MARGEM verde é calculada a partir deles — apagar quebraria o cálculo. */
        '<button type="button" class="vp-custo-bar" id="vpCustoBar" style="display:none"><span class="vcb-seta" id="vpCustoSeta">▸</span> Custo do veículo <b class="vcb-val" id="vpCustoTotal">—</b></button>'+
        '<div class="vp-custo-det" id="vpCustoDet" style="display:none"></div>'+
        (v?('<label class="cad-lbl">Preço mínimo <span class="ec-hint">(interno — o cliente não vê)</span></label><input class="cad-in" id="vpMin" inputmode="numeric" value="'+_rs(v.preco_minimo)+'">'):'')+
        /* MARGEM (verde) */
        '<div class="vp-margem" id="vpMargemBox" style="display:none"><span>MARGEM</span><b id="vpMargemVal"></b><i id="vpMargemPct"></i></div>'+
        /* preços */
        '<div class="vp-rows">'+
          /* ===== v485 — O PREÇO DE TABELA VIROU CAMPO (plano 15/08) =======
             Era texto fixo lendo o estoque, e o campo que editava o mesmo
             conceito (vpApresTabInput) só aparecia em venda COM troca. As
             duas pontas agora editam o MESMO _vp.apresentacao.tabela —
             fonte única, e vale SÓ NESTA cotação (o estoque, o catálogo e
             os posts continuam com o preço deles). */
          '<div class="vp-row dest"><span>Preço de tabela (anúncio) '+mkIco('lapis',12)+'</span><input class="vp-row-in" id="vpTabela" inputmode="numeric" value="'+_rs(((p.apresentacao||{}).tabela)||(v&&v.preco_anuncio)||0)+'" placeholder="R$ 0"></div>'+
          '<div class="vp-tab-extra"><button type="button" class="vp-tab-volta" id="vpTabVolta" style="display:none"></button><span class="vp-tab-aviso" id="vpTabAviso" style="display:none">a tabela está abaixo do preço de venda</span></div>'+
          '<div class="vp-row dest"><span>Preço de venda '+mkIco('lapis',12)+'</span><input class="vp-row-in" id="vpPreco" inputmode="numeric" value="'+_rs(p.precoVenda||(v&&v.preco_minimo)||(v&&v.preco_anuncio))+'" placeholder="R$ 0"></div>'+
          /* v370 (pedido): enquanto a Transferência não estiver marcada, o valor
             fica com a cor apagada — deixa claro num relance que ele NÃO está
             entrando na conta. */
          '<div class="vp-row vp-row-transf'+(p.transf_inclui?'':' off')+'" id="vpTransfRow"><label class="vp-row-ck"><input type="checkbox" id="vpTransfChk"'+(p.transf_inclui?' checked':'')+'><span>Transferência</span></label><input class="vp-row-in" id="vpTransfVal" inputmode="numeric" value="'+_rs(p.transf_valor||700)+'" placeholder="R$ 700"></div>'+
          /* v157: valor total logo abaixo da transferência (já com desconto, acréscimo e cortesia) */
          '<div class="vp-row vp-row-tot"><span>Valor total <i id="vpTotSub"></i></span><b id="vpTotVal">—</b></div>'+
          /* v180: os números REAIS da negociação, logo abaixo do valor total */
          '<div class="vp-row vp-row-usado" id="vpUsadoRow" style="display:none"><span>Valor do usado na negociação<i id="vpUsadoSub"></i></span><b id="vpUsadoVal">—</b></div>'+
          /* v370 (pedido): o SALDO A PAGAR virou campo. Digitando o saldo que você
             fechou com o cliente, o app faz a conta ao contrário e ajusta o
             PREÇO DE VENDA sozinho — é o número que o vendedor tem na cabeça
             no fim da conversa. */
          '<div class="vp-row vp-row-saldo dest" id="vpSaldoRow" style="display:none"><span>Saldo a pagar '+mkIco('lapis',12)+'</span><input class="vp-row-in" id="vpSaldoVal" inputmode="numeric" placeholder="R$ 0"></div>'+
        '</div>'+
        '<div class="vp-minwarn" id="vpMinWarn" style="display:none"></div>'+
        '<div class="cli-2col"><div><label class="cad-lbl">Desconto</label><input class="cad-in" id="vpDesc" inputmode="numeric" value="'+_rs(p.desconto)+'" placeholder="R$ 0"></div><div><label class="cad-lbl">Acréscimo</label><input class="cad-in" id="vpAcr" inputmode="numeric" value="'+_rs(p.acrescimo)+'" placeholder="R$ 0"></div></div>'+
        '<label class="cad-lbl">Cortesias <span class="ec-hint">(soma no valor ao cliente)</span></label><input class="cad-in" id="vpCort" inputmode="numeric" value="'+_rs(p.cortesias)+'" placeholder="R$ 0">'+
        '<div id="vpCortDescBox"'+((+p.cortesias||0)?'':' style="display:none"')+'><input class="cad-in" id="vpCortDesc" value="'+esc(p.cortesia_desc||'')+'" placeholder="Qual cortesia está inclusa? (ex.: tapete, película, 1ª revisão)" style="margin-top:6px"></div>'+

        /* VALOR PRO CLIENTE (com base no preço de venda do anúncio) */
        /* v180: o que vai ser APRESENTADO ao cliente (o saldo é o mesmo;
           muda só a forma de mostrar: tabela cheia e avaliação "esticada") */
        '<div class="vp-apres" id="vpApresBox" style="display:none">'+
          '<div class="vpa-tit">Valores apresentados ao cliente <i>edite sem alterar o controle interno</i></div>'+
          '<label class="vpa-edit"><span>Preço de tabela (anúncio)</span><input class="cad-in" id="vpApresTabInput" inputmode="numeric" value="'+_rs((p.apresentacao||{}).tabela||0)+'"></label>'+
          '<label class="vpa-edit"><span>Avaliação do usado</span><input class="cad-in" id="vpApresAvalInput" inputmode="numeric" value="'+_rs((p.apresentacao||{}).avaliacao||0)+'"></label>'+
          '<div class="vpa-row tot"><span>Saldo a pagar</span><b id="vpApresSaldo">—</b></div>'+
          /* v370 (pedido) — O SALDO APRESENTADO É SEMPRE O SALDO REAL.
             Antes a avaliação apresentada ficava guardada num campo próprio e,
             quando ela era gravada num momento em que a troca ainda estava
             zerada, congelava num número errado — e o saldo mostrado ao
             cliente passava a não bater com o saldo da negociação.
             Agora a conta é: avaliação apresentada = preço de tabela − saldo
             real. Aumentar a tabela não muda o que o cliente paga: a diferença
             inteira aparece como VALORIZAÇÃO DO USADO. */
          '<div class="vpa-nota">O saldo a pagar aqui é sempre igual ao saldo real da negociação. Se você subir o preço de tabela, a diferença entra como <b>valorização do usado</b> — o cliente paga o mesmo.</div>'+
        '</div>'+
      '</div>'+
      /* PAGAMENTO — seminovos: à vista OU entrada + até 60x */
      '<div class="vp-sec"><h3><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>Condições de pagamento</h3>'+
        '<div class="vp-toggle"><button type="button" id="vpAvista" class="'+(p.pag.tipo!=='parcelado'?'on':'')+'">À vista</button><button type="button" id="vpParcel" class="'+(p.pag.tipo==='parcelado'?'on':'')+'">Financiamento</button></div>'+
        '<label class="cad-lbl">Entrada (dinheiro)</label><input class="cad-in" id="vpEntrada" inputmode="numeric" value="'+_rs(p.pag.entrada)+'" placeholder="R$ 0">'+
        (p.pag.tipo==='parcelado' ? ('<div class="vp-toggle" style="margin-top:10px"><button type="button" id="vpPF" class="'+(pagPF?'on':'')+'">CPF <small>(TAC R$ 1.500)</small></button><button type="button" id="vpPJ" class="'+(!pagPF?'on':'')+'">CNPJ <small>(TAC R$ 2.500)</small></button></div>'+
          '<div class="cli-2col"><div><label class="cad-lbl">Nº de parcelas <span class="ec-hint">(até 60)</span></label><input class="cad-in" id="vpParcelas" inputmode="numeric" value="'+esc(p.pag.parcelas||48)+'"></div><div><label class="cad-lbl">Juros (% ao mês) <span class="ec-hint">(até 48x 2,09% · 60x 2,19%)</span></label><input class="cad-in" id="vpJuros" inputmode="decimal" value="'+esc(String(p.pag.juros==null?'':p.pag.juros).replace('.',','))+'" placeholder="2,09"></div></div>'+
          '<label class="cad-lbl">Retorno da loja <span class="ec-hint">(% até 6 · interno)</span></label><input class="cad-in" id="vpRet" inputmode="decimal" value="'+esc(String(p.pag.ret==null?'':p.pag.ret).replace('.',','))+'" placeholder="0 a 6">'+
          '<div class="vp-finbox" id="vpParcPrev" style="display:none"></div>'+
          '<div class="vp-cred">'+
            /* v476 (item 3): barra que abre/fecha (mecanismo do vpCustoBar,
               v370) com o ESTADO à direita — CPF ok / chance alta·média·baixa.
               O conteúdo fica no DOM mesmo fechado (display:none): o semáforo
               e o refresh escrevem dentro dele. */
            '<button type="button" class="vp-custo-bar vpc-bar" id="vpCredBar"><span class="vcb-seta" id="vpCredSeta">▸</span> Análise de crédito <b class="vcb-val" id="vpCredEstado">—</b></button>'+
            '<div id="vpCredDet" style="display:none">'+
            '<label class="cad-lbl">CPF do cliente</label>'+
            '<div class="vpc-cpf"><input class="cad-in" id="vpCpfNum" inputmode="numeric" maxlength="14" value="'+esc(_fmtCpf(p.cpf||''))+'" placeholder="000.000.000-00"><button type="button" id="vpCpf">Consultar <i>'+precoReal(2.50)+'</i></button></div>'+
            '<label class="vpc-lgpd" id="vpLgpdBox"'+(_lgpdCpfAceito()?' style="display:none"':'')+'><input type="checkbox" id="vpLgpd"><span>Li e aceito o termo de proteção de dados (LGPD). O cliente autorizou esta consulta.</span></label>'+
            '<div class="cad-msg" id="vpCpfMsg"></div>'+
            '<div class="vpc-rel" id="vpCpfRel" style="display:none"></div>'+
            '<label class="cad-lbl">Renda mensal do cliente</label>'+
            '<input class="cad-in" id="vpRenda" inputmode="numeric" value="'+_rs(p.renda)+'" placeholder="R$ 0">'+
            '<div class="vpc-sem" id="vpSemaforo" style="display:none"></div>'+
            /* v441 (pedido): o "Analisar aprovação com a IA" saiu da tela.
               Regra da casa: esconder, nunca remover — o botão continua inteiro
               aqui, só com display:none, e o handler do 18 segue no lugar. Pra
               voltar, apaga o style="display:none" daqui e o !VP_IA_ON de lá.
               O SEMÁFORO de renda logo acima continua aparecendo: ele é conta
               local (parcela ÷ renda), de graça, não chama IA nem gasta token. */
            '<button type="button" class="btn-sec-lb" id="vpParecer" style="display:none"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.6L18.5 9.5 13.9 11.4 12 16l-1.9-4.6L5.5 9.5l4.6-1.9z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/></svg>Analisar aprovação com a IA · '+precoReal(1)+'</button>'+
            '<div class="vpc-ia" id="vpIaBox" style="display:none"></div>'+
          '</div>'+
          '</div>') : '')+
      '</div></div>'+
      '<div class="vpx-panel" data-panel="resumo"><div id="vpTotais"></div>'+
      '<div class="vp-acts">'+
        '<button type="button" id="vpResSimples" class="wa"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.5 8.5 0 0 1-3.9-.9L3 21l2-4.9A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/></svg><span>Resumo do cliente<i>manda no WhatsApp dele</i></span></button>'+
        '<button type="button" id="vpPdfProp"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M12 18v-6"/><polyline points="9 15 12 18 15 15"/></svg><span>PDF da proposta<i>pra imprimir ou mandar</i></span></button>'+
        '<button type="button" class="pri" id="vpFecharVenda">'+_VF_ICO.chave+'<span>'+((_vp.fechada&&_vp.fechada.on)?'Abrir venda fechada':'Fechar venda')+'<i>documentos e pagamentos</i></span></button>'+
        /* v656 — GERAR ARTE do carro da cotação. 🔴 Da proposta vai pra arte
           SÓ o veículo: entrada, parcela, taxa, troca e o nome do cliente não
           encostam na peça. E o preço é o de ANÚNCIO — o `precoVenda` desta
           negociação é o número desta conversa, não o do story. */
        /* v835: a arte saiu do app (interruptor no 00-edicoes) */
        ((typeof arteDisponivel!=='function'||arteDisponivel()) ? '<button type="button" id="vpArte"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15l-1.9-4.1L5.5 9l4.6-1.4z"/><path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z"/></svg><span>Gerar arte<i>story e feed do veículo</i></span></button>' : '')+
        '<button type="button" class="pri" id="vpSalvar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>Salvar cotação</button>'+
      '</div><div class="cad-msg" id="vpMsg"></div>'+
      (_vpEditId?'<button class="cad-btn sair" id="vpDel" style="margin-top:10px">Apagar</button>':'')+
      '</div>';
    /* v192 — o bloco azul com nome/preco do carro que ficava ACIMA das abas
       saiu: ele repetia o que o card do veiculo ja' mostra e empurrava as
       abas pra baixo. */
    var _topo='';
    var _VPX_ICO={
      andamento:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>',
      cliente:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
      veiculo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.4-3.6c-.4-.5-1-.9-1.6-.9H10c-.6 0-1.2.4-1.6.9L6 10l-2.5 1.1C2.7 12.3 2 13.1 2 14v2c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>',
      troca:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
      negociacao:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>',
      resumo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>'
    };
    var _nAnd=_vpNegocsDoVeiculo().length;
    var _stepsDef=[['andamento','Andamento'+(_nAnd?(' · '+_nAnd):'')],['cliente','Cliente'],['veiculo','Veículo'],['troca','Troca'],['negociacao','Negociação'],['resumo','Resumo']];
    var _nav=_stepsDef.map(function(s){ return '<button type="button" class="vpx-st" data-step="'+s[0]+'"><span class="vpx-ico">'+_VPX_ICO[s[0]]+'</span><span class="vpx-nm">'+s[1]+'</span></button>'; }).join('');
    $('vpForm').innerHTML=_topo+'<div class="vpx"><div class="vpx-steps" id="vpSteps">'+_nav+'</div><div class="vpx-body cad-float">'+html+'</div></div>';
    _vpStepAplica(); vpWire(); vpAtualiza(); _vpNegocRefresh(); _vpAndPinta();
  }
  /* ================== v195 — VENDA FECHADA ==================
     Ate' agora tudo que era salvo em Vendas era "cotacao": uma conversa que
     pode dar em nada. Faltava o momento em que o negocio FECHA.

     Esta página e' esse momento. Ela faz tres coisas, nesta ordem:
       1. CHAVE  — voce marca "venda fechada". A cotacao sai da lista de
                   "Cotacoes salvas" e passa a viver na pagina "Vendas
                   fechadas". Nada e' apagado: e' a MESMA linha do banco, so'
                   muda a prateleira.
       2. PAPEIS — o contrato de compra e venda sempre; e, quando tem carro na
                   troca, tambem o TRV, o PCP e a procuracao, reaproveitando a
                   tela "Gerar documentos" que ja' existe.
       3. CONTA  — voce anexa os comprovantes (Pix do sinal, TED, boleto...) e
                   a IA le valor, data, quem pagou e o ID da transacao. O app
                   soma tudo e diz se JA' FECHOU o valor ou quanto falta.

     CUIDADO COM AS PALAVRAS (o MEV tem tres "fechada" diferentes):
       . venda.fechada        -> ESTA aqui. O negocio foi fechado.
       . venda.etapa          -> o funil de entrega (negociacao > vendido >
                                 em entrega > entregue > pos-venda).
       . proposta.crm.situacao='fechada' -> o chip da v191 na cotacao salva.
     Sao tres campos distintos. Nao troque um pelo outro.

     ONDE MORA O DADO: os pagamentos ficam DENTRO do proprio `proposta` (jsonb),
     num pedaco chamado `fechada`. Nao criei tabela nova. As imagens vao pro
     Storage que a avaliacao ja' usa. Menos peca nova = menos coisa pra quebrar.

     CUSTO: cada leitura de documento pela IA custa 1 token. Se a leitura
     falhar, o servidor estorna o token automaticamente. */

  var _VF_FORMAS=['PIX','TED','DOC','Transferência','Boleto','Dinheiro','Cartão','Financiamento','Consórcio','Outro'];
  var _VF_MAPA={PIX:'PIX',TED:'TED',DOC:'DOC',BOLETO:'Boleto',CARTAO:'Cartão',FINANCIAMENTO:'Financiamento',CONSORCIO:'Consórcio',DINHEIRO:'Dinheiro',TRANSFERENCIA:'Transferência',OUTRO:'Outro'};
  /* a IA devolve o tipo em MAIUSCULA e sem acento; aqui vira o rotulo bonito */
  function _vfForma(t){
    var k=String(t||'').toUpperCase();
    k=k.replace(/[ÃÂÁÀÄ]/g,'A').replace(/[ÉÊÈË]/g,'E').replace(/[ÍÎÌÏ]/g,'I').replace(/[ÓÔÕÒÖ]/g,'O').replace(/[ÚÛÙÜ]/g,'U').replace(/Ç/g,'C').replace(/[^A-Z]/g,'');
    return _VF_MAPA[k]||'Outro';
  }
  var _VF_ICO={
    chave:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    papel:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
    dinheiro:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><line x1="6" y1="12" x2="6.01" y2="12"/><line x1="18" y1="12" x2="18.01" y2="12"/></svg>',
    entrega:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h11v13H3z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/><path d="M14 18H9M16 11h5"/></svg>',
    clipe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.4 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.2 9.19a1.5 1.5 0 0 1-2.12-2.12l8.49-8.48"/></svg>',
    mao:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    /* v444: o escudo da aba "Conferir o usado" — mesmo desenho do ICO.multa */
    escudo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    troca:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>'
  };

  /* --- o pedacinho de dado, criado na hora em que precisa existir --- */
  function _vfDados(){
    if(!_vp) return {on:false,em:'',pagamentos:[]};
    if(!_vp.fechada || typeof _vp.fechada!=='object') _vp.fechada={on:false,em:'',pagamentos:[]};
    if(!Array.isArray(_vp.fechada.pagamentos)) _vp.fechada.pagamentos=[];
    return _vp.fechada;
  }
  /* Checklist operacional da entrega. Fica no fechamento (jsonb já salvo em
     vendas), sem cópia de documento, bucket ou endpoint adicional. */
  function _vfEntregaDados(){
    var f=_vfDados();
    if(!f.entrega || typeof f.entrega!=='object') f.entrega={};
    return f.entrega;
  }
  function _vfSomaPagos(lista){ var s=0; (lista||[]).forEach(function(p){ s+=(Number(p&&p.valor)||0); }); return _r2(s); }
  /* A CONTA DA VENDA — a mesma logica do seu checklist:
       total do negocio  = o que o cliente paga (vpCalc.precoFinal)
       (-) usado         = avaliacao menos a quitacao (vpCalc.trocaLiq)
       = a receber       = o que tem que entrar em DINHEIRO (vpCalc.saldo)
       (-) ja' recebido  = soma dos comprovantes anexados
       = falta           = o buraco que ainda existe */
  function _vfConta(p){
    p=p||_vp||{};
    var c; try{ c=vpCalc(p); }catch(_){ c={precoFinal:0,trocaLiq:0,saldo:0,base:0,parcelado:false}; }
    var f=(p.fechada&&Array.isArray(p.fechada.pagamentos))?p.fechada.pagamentos:[];
    var alvo=Math.max(0, _r2(c.saldo)), pago=_vfSomaPagos(f);
    return { c:c, total:_r2(c.precoFinal), troca:_r2(c.trocaLiq), alvo:alvo, pago:pago,
             falta:_r2(alvo-pago), n:f.length,
             pct:(alvo>0?Math.max(0,Math.min(100,Math.round(pago/alvo*100))):100) };
  }
  function _vfLinha(){
    if(!_vpEditId) return null;
    var a=(_vendas||[]).filter(function(x){ return String(x.id)===String(_vpEditId); });
    return a[0]||null;
  }
  /* Marcar como fechada tambem adianta o funil pra "Vendido" — MAS so' se ele
     ainda estiver no comeco. Uma venda que ja' esta "Entregue" nao volta pra
     tras. E' por isso que aqui devolvo null: null = nao encoste na etapa. */
  function _vfEtapaNova(on){
    if(!on) return null;
    var r=_vfLinha(); var at=String((r&&r.etapa)||'');
    return (!at || at==='negociacao') ? 'vendido' : null;
  }

  var _vfTab='fechamento';
  /* v444: aba pedida pra PRÓXIMA abertura da venda fechada. Usada só pelo
     Voltar das consultas do usado; é limpa assim que é consumida. */
  var _vfTabIni='';
  /* ===== v305 (pedido) — A ABA "DOCUMENTOS" VIROU TRES ====================
     Uma aba so juntava quatro assuntos diferentes: o que anexar, a
     conferencia, o contrato de venda, e os papeis do carro usado. Quem
     entrava ali tinha que garimpar.

     Agora cada coisa tem o seu lugar, na ordem em que acontece:
        Anexar documentos → o que voce fotografa e a IA le
        Contrato          → confere os dados e gera o contrato de venda
        TRV, PCP e procuracao → os papeis do carro usado da troca */
  var _VF_TABS=[
    ['fechamento','Fechamento','chave'],
    ['anexos','Anexar documentos','clipe'],
    ['contrato','Contrato','papel'],
    ['usado','TRV, PCP e procuração','troca'],
    /* ===== v444 (PLANO das abas, Parte B) ===============================
       "Multas e restrições" e "Leilão e sinistro" SAÍRAM da aba Troca da
       negociação e vieram parar aqui.

       O motivo, pra ficar registrado: antes de fechar, o trabalho é fazer o
       cliente DECIDIR — e quem ajuda nisso é a ficha técnica e o
       comparativo, que custam 1 token cada. Multas e leilão são outra
       coisa: são a conferência do carro que VAI ENTRAR na loja. É
         informação de COMPRA, não de venda, e custa 25 tokens juntos. Rodar
         isso antes de fechar é gastar 25 tokens num negócio que pode não
       sair. Depois que fecha, o carro é seu e você precisa saber o que veio
       junto com ele.

       Fica logo depois do "TRV, PCP e procuração" porque é o mesmo assunto:
       o carro que entrou na troca.

       ⚠️ A aba só existe quando a venda TEM troca (_vfTabsVis). Aba que
       abre vazia é pior que aba que não existe. */
    ['usadoconsultas','Conferir o usado','escudo', 'troca'],
    ['pagamentos','Pagamentos','dinheiro'],
    ['entrega','Entrega','entrega'],
    ['posvenda','Pós-vendas','chave']
  ];
  /* v444: as abas que ESTA venda mostra. O 4º item da linha ('troca') marca
     a aba que só aparece quando existe carro na troca. */
  function _vfTabsVis(){
    return _VF_TABS.filter(function(t){ return t[3]!=='troca' || _vfTemTroca(); });
  }
  /* A venda fechada usa a mesma navegação por etapas da página de Venda:
     menu lateral no desktop e fita rolável no celular. */
  function _vfConteudoHtml(){
    var nav=_vfTabsVis().map(function(t){ return '<button type="button" class="vpx-st" data-step="'+t[0]+'"><span class="vpx-ico">'+_VF_ICO[t[2]]+'</span><span class="vpx-nm">'+t[1]+'</span></button>'; }).join('');
    return '<div class="vpx vf-vpx"><div class="vpx-steps" id="vfTabs">'+nav+'</div><div class="vpx-body cad-float">'+
      '<div class="vpx-panel" data-panel="fechamento"><section class="vf-page-sec"><h3>'+_VF_ICO.chave+'Fechamento do negócio</h3><div id="vfFlag"></div></section></div>'+
      '<div class="vpx-panel" data-panel="anexos"><section class="vf-page-sec"><h3>'+_VF_ICO.clipe+'Anexar documentos</h3><div id="vfAnexos"></div></section></div>'+
      '<div class="vpx-panel" data-panel="contrato"><section class="vf-page-sec"><h3>'+_VF_ICO.papel+'Contrato de compra e venda</h3><div id="vfContratoBox"></div></section></div>'+
      '<div class="vpx-panel" data-panel="usado"><section class="vf-page-sec"><h3>'+_VF_ICO.troca+'TRV, PCP e procuração</h3><div id="vfUsado"></div></section></div>'+
      /* v444: o painel só é montado quando a aba existe — senão fica um
         painel órfão no DOM que o deslize acharia e abriria em branco. */
      (_vfTemTroca()
        ? '<div class="vpx-panel" data-panel="usadoconsultas"><section class="vf-page-sec"><h3>'+_VF_ICO.escudo+'Conferir o usado</h3><div id="vfUsadoCons"></div></section></div>'
        : '')+
      '<div class="vpx-panel" data-panel="pagamentos"><section class="vf-page-sec"><h3>'+_VF_ICO.dinheiro+'Controle de pagamentos</h3>'+
          '<div id="vfRes"></div>'+
          '<button type="button" class="btn-buscar" id="vfIa">'+_VF_ICO.clipe+'Anexar comprovante <i class="vf-gratis">leitura por IA · '+precoReal(1)+'</i></button>'+
          '<button type="button" class="btn-sec-lb" id="vfMao">'+_VF_ICO.mao+'Lançar à mão</button>'+
          '<div id="vfMaoBox"></div><div id="vfLista"></div>'+
      '</section></div>'+
      '<div class="vpx-panel" data-panel="entrega"><section class="vf-page-sec"><h3>'+_VF_ICO.entrega+'Entrega</h3><div id="vfEntrega"></div></section></div>'+
      '<div class="vpx-panel" data-panel="posvenda"><section class="vf-page-sec"><h3>'+_VF_ICO.chave+'Pós-vendas</h3><div id="vfPos"></div></section></div>'+
    '</div></div>';
  }
  function _vfFlagHtml(){
    var f=_vfDados(), on=!!f.on;
    return '<button type="button" class="vf-chave'+(on?' on':'')+'" id="vfChave">'+
      '<span class="vf-sw"><i></i></span>'+
      '<span class="vf-tx"><b>'+(on?'Venda fechada':'Marcar como venda fechada')+'</b>'+
      '<i>'+(on
        ? ('Fechada em '+(_dataBr(f.em)||_dataBr(_cotHoje()))+' · esta venda saiu de "Cotações salvas" e está em "Vendas fechadas".')
        : 'Ao marcar, ela sai de "Cotações salvas" e vai pra página "Vendas fechadas". Dá pra desmarcar depois.')+'</i></span></button>';
  }
  function _vfTemTroca(){
    var t=(_vp&&_vp.troca)||{};
    if(!t.tem) return false;
    return (String(t.placa||'').replace(/[^A-Za-z0-9]/g,'').length>5) || ((Number(t.avaliacao)||0)>0);
  }
  function _vfCliente(){
    var id=(_vp&&_vp.cliente_id)||'';
    return (_clientes||[]).filter(function(c){ return String(c&&c.id)===String(id); })[0]||null;
  }
  function _vfDocItemHtml(titulo,descricao,pronto){
    return '<div class="vf-doc-item'+(pronto?' ok':'')+'"><span class="vf-doc-mark">'+(pronto?_VF_ICO.chave:_VF_ICO.papel)+'</span><span><b>'+esc(titulo)+'</b><i>'+esc(descricao)+'</i></span></div>';
  }
  /* ===== v305 — OS TRES PAINEIS =========================================
     Era uma funcao so (_vfDocsHtml) que empilhava tudo. Agora sao tres, uma
     por aba. Nenhuma REGRA mudou: a conferencia e a geracao continuam sendo
     as mesmas de sempre; o que mudou foi onde cada coisa mora. */

  /* ABA 1 — ANEXAR: so o que voce fotografa. */
  function _vfAnexosPainelHtml(){
    return _vfAnexosHtml();
  }

  /* ABA 2 — CONTRATO: a situacao dos dados e o botao que gera. */
  function _vfContratoHtml(){
    var cli=_vfCliente()||{}, c;
    try{ c=vpCalc(_vp||{}); }catch(_){ c={precoFinal:0}; }
    var temCli=!!(cli&&cli.id), temEnd=!!(cli&&(cli.rua||cli.cep||cli.cidade));
    var st=_vfDocsIA();
    var temCnh=!!st.cnh, temCrlv=!!st.crlv;
    return '<div class="vf-doc-grid">'+
      _vfDocItemHtml('Dados do cliente',temCli?'Cadastro vinculado à venda.':'Vincule o cliente na negociação.',temCli)+
      _vfDocItemHtml('Endereço',temEnd?'Endereço informado no cadastro.':'Confira o endereço antes de gerar.',temEnd)+
      _vfDocItemHtml('Dados da negociação',(c.precoFinal>0?'Valor e condição disponíveis.':'Revise o valor e a condição.'),c.precoFinal>0)+
      _vfDocItemHtml('CNH e CRLV lidos',(temCnh&&temCrlv)?'CPF, placa, Renavam e chassi disponíveis.':'Anexe em "Anexar documentos" — ou digite na conferência.',(temCnh&&temCrlv))+
    '</div>'+
    '<button type="button" class="btn-buscar" id="vfContrato">'+_VF_ICO.papel+'Conferir os dados e gerar o contrato</button>'+
    '<div class="vf-nota">Abre a conferência de CPF, nome, placa, Renavam e chassi. O que a IA leu começa sem carimbo; o que você digitou já vem carimbado.</div>';
  }

  /* ABA 3 — O CARRO USADO DA TROCA.
     QUANDO NAO HA TROCA a aba CONTINUA aparecendo, explicando. Uma aba que
     some deixa a duvida "cade?" — e TRV, PCP e procuracao sao justamente os
     papeis que a pessoa vem procurar quando ha um usado na jogada. */
  function _vfUsadoHtml(){
    var t=(_vp&&_vp.troca)||{}, temTroca=_vfTemTroca();
    if(!temTroca){
      return '<div class="vf-doc-grid">'+
        _vfDocItemHtml('Sem veículo na troca','TRV, PCP e procuração são documentos do usado que o cliente entrega.',false)+
      '</div>'+
      '<div class="vf-nota">Informe o veículo da troca na aba <b>Troca</b> da negociação e estes documentos ficam disponíveis aqui.</div>';
    }
    var st=_vfDocsIA(), d=st.crlv_troca;
    var placa=String(t.placa||'').toUpperCase();
    return '<div class="vf-doc-grid">'+
      _vfDocItemHtml('Veículo da troca',[placa,String(t.modelo||''),String(t.ano||'')].filter(Boolean).join(' · ')||'Usado informado.',!!placa)+
      _vfDocItemHtml('CRLV do usado',d?(_vfDocResumo('crlv_troca',d)||'Documento lido.'):'Anexe em "Anexar documentos" pra preencher sozinho.',!!d)+
    '</div>'+
    '<button type="button" class="btn-buscar" id="vfDocTroca">'+_VF_ICO.troca+'Conferir os dados e gerar TRV, PCP e procuração</button>'+
    '<div class="vf-nota">Os três saem do mesmo cadastro: TRV, PCP e a procuração do veículo usado.</div>';
  }

  /* A conferência do usado usa uma única Consulta Plus. Consultas antigas
     continuam guardadas no histórico, mas só resultados da Plus recebem o
     selo de completa nesta tela. */
  function _vfUsadoConsHtml(){
    var t=(_vp&&_vp.troca)||{};
    var placa=String(t.placa||'').toUpperCase();
    var pl=limpa(placa), h=null;
    try{ h=histLerUm(pl); }catch(_){ h=null; }
    var temPlus=!!(h&&h.consultaPlus); void temPlus;   /* v761: fica pro dia em que o card voltar */
    var linha=[placa,String(t.modelo||''),String(t.ano||'')].filter(Boolean).join(' · ');
    return '<div class="vf-doc-grid">'+
      _vfDocItemHtml('Veículo da troca', linha||'Usado informado.', !!placa)+
    '</div>';
    /* v761: o card "Consulta Plus" do usado da troca SAIU (a Plus foi
       eliminada do app — pedido do Angelo, 30/08). O _vpTrocaConsultaAbrir
       e o clique em [data-tela="vf_usado_plus"] ficam no código pra volta. */
  }

  /* ==================================================================
     v284 — ANEXAR CNH / COMPROVANTE / CRLV E CONFERIR ANTES DE GERAR
     ==================================================================
     Pedido: "Permita anexar os documentos CNH, comprovante de residência pra
     fazer leitura e CRLV, mostre o modal de conferência dos dados extraídos
     pra gerar os documentos, peça confirmação número cpf, nome, placa,
     Renavam e chassi."

     A leitura por IA já existia — só morava na tela solta de Documentos do
     usado. Aqui ela passa a viver DENTRO da venda, e o que ela lê fica
     guardado na própria cotação.

     A parte que interessa de verdade é a CONFERÊNCIA. Renavam e chassi são
     onde o erro de leitura dói: um dígito trocado no Renavam e a ATPV sai
     errada; um caractere no chassi e o contrato não bate com o documento.
     Por isso o que a IA leu nasce PENDENTE DE CONFERÊNCIA, e o que veio do
     seu próprio cadastro (você digitou) já nasce conferido. Você só carimba
     o que uma máquina adivinhou. */
  /* v305: o CRLV DA TROCA e o quarto documento, e ele so aparece quando ha
     troca — pedir o documento de um carro que nao existe seria pedir por
     pedir. Chave SEPARADA (crlv_troca) de proposito: se os dois CRLVs
     caissem na mesma gaveta, o contrato sairia com a placa do carro errado.
     Isso virou conferencia. */
  var _VF_DOCS_BASE=[
    ['cnh','CNH do cliente','Nome, CPF e RG'],
    ['res','Comprovante de residência','Endereço do cliente'],
    ['crlv','CRLV do veículo da venda','Placa, Renavam e chassi']
  ];
  function _vfDocsLista(){
    var l=_VF_DOCS_BASE.slice();
    if(_vfTemTroca()) l.push(['crlv_troca','CRLV do veículo da troca','Placa, Renavam e chassi do usado']);
    return l;
  }
  function _vfDocsIA(){
    if(!_vp) return {};
    if(!_vp.docs_ia || typeof _vp.docs_ia!=='object') _vp.docs_ia={};
    return _vp.docs_ia;
  }
  function _vfDocResumo(k,d){
    if(!d) return '';
    if(k==='cnh')  return [d.nome, d.cpf].filter(Boolean).join(' · ');
    if(k==='res')  { var e=d.endereco||{}; return [e.logradouro, e.cidade, e.uf].filter(Boolean).join(', '); }
    if(k==='crlv' || k==='crlv_troca') return [d.placa, (d.renavam?('Renavam '+d.renavam):''), (d.chassi?('Chassi '+d.chassi):'')].filter(Boolean).join(' · ');
    return '';
  }
  function _vfAnexosHtml(){
    var st=_vfDocsIA();
    return '<div class="vf-anx"><div class="vf-anx-tit">Ler documentos por IA</div>'+
      '<div class="vf-anx-sub">Fotografe ou anexe o documento. A IA lê e preenche — você confere antes de gerar.</div>'+
      _vfDocsLista().map(function(x){
        var d=st[x[0]], res=_vfDocResumo(x[0],d);
        return '<button type="button" class="vf-anx-bt'+(d?' ok':'')+'" data-anx="'+x[0]+'">'+
          '<span class="vf-anx-ic">'+(d?'✓':'+')+'</span>'+
          '<span class="vf-anx-tx"><b>'+esc(x[1])+'</b><i>'+esc(res||x[2])+'</i></span>'+
          '<span class="vf-anx-go">'+(d?'trocar':'anexar')+'</span></button>';
      }).join('')+'</div>';
  }
  function _vfAnexosWire(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-anx]'),function(b){
      b.onclick=function(){ _vfAnexarDoc(b.getAttribute('data-anx')); };
    });
  }
  function _vfAnexarDoc(k){
    if(!window.MEV_IA){ _iaAcao(function(){ _vfAnexarDoc(k); }); return; }
    /* v305: 'crlv' e 'crlv_troca' usam o MESMO leitor (e o mesmo documento,
       um CRLV) — o que muda e so a gaveta onde o resultado e guardado. */
    var fn = (k==='cnh')  ? window.MEV_IA.importarCNH
           : (k==='res')  ? window.MEV_IA.importarResidencia
                          : window.MEV_IA.importarCRLV;
    if(typeof fn!=='function'){ toast('Esta leitura não está disponível nesta versão.'); return; }
    fn(function(dados){
      if(!dados) return;
      if(dados.erro){ toast(String(dados.erro)); return; }
      /* ===== v592 — A FOTO NÃO MORA MAIS DENTRO DA VENDA ==================
         O leitor devolve os DADOS + a foto inteira em dados._anexo (~370 KB).
         Guardar isso no docs_ia fazia a foto entrar no jsonb da venda — e o
         vendaCarregar() baixa TODAS as vendas em toda abertura do app
         (medido: 3 vendas assim = 1,1 MB por abertura, pra todo mundo).
         Agora: os DADOS ficam na venda; a FOTO vai pro cofre privado (o
         MESMO caminho do comprovante de pagamento, logo abaixo) e só a
         referência fica. A faxina-egress migra as antigas. */
      var _anx=dados._anexo||null; try{ delete dados._anexo; }catch(_){ dados._anexo=null; }
      var st=_vfDocsIA(); st[k]=dados; st[k+'_em']=new Date().toISOString();
      if(_anx && _anx.base64){
        (async function(){
          try{
            var file=_vfB64File(_anx.base64, _anx.mimeType||'image/jpeg', k+'-documento.jpg');
            var ref=await arqUpload(file,'documento');
            var st2=_vfDocsIA();
            if(ref && st2[k]){ st2[k].arquivo=ref; _vfPersistir(''); }
          }catch(_){ /* a foto não subiu: os dados lidos ficam do mesmo jeito */ }
        })();
      }
      /* o que a IA leu vale como sugestão: derruba a conferência anterior,
         senão um dado NOVO entraria já carimbado por causa do documento velho */
      if(_vp) _vp.conferido=null;
      if(k==='res') _vfEnderecoDoComprovante(dados);
      /* v305: anexar um documento muda TRES paineis — a lista de anexos, a
         situacao do contrato e a do usado. Repinto os tres, senao o que voce
         acabou de anexar aparece num lugar e nao no outro. */
      _vfDocsPinta();
      var nomes={cnh:'CNH lida',res:'Comprovante lido',crlv:'CRLV lido'};
      toast((nomes[k]||'Documento lido')+' — confira antes de gerar.');
      _vfPersistir('');
    });
  }
  /* O comprovante de residência não entra na conferência dos cinco — ele serve
     pro ENDEREÇO, que vai no contrato. Preenche só o que está VAZIO no cadastro:
     endereço que você digitou vale mais que endereço que uma máquina leu de uma
     conta de luz (que às vezes está no nome do pai, do locador, do antigo dono). */
  async function _vfEnderecoDoComprovante(dados){
    var cli=_vfCliente(); if(!cli||!cli.id) return;
    var e=(dados&&dados.endereco)||{}; if(!e || !(e.logradouro||e.cep||e.cidade)) return;
    var mapa={ cep:e.cep, rua:e.logradouro, numero:e.numero, bairro:e.bairro, cidade:e.cidade, uf:e.uf };
    var mud={}, postos=[];
    Object.keys(mapa).forEach(function(campo){
      var novo=String(mapa[campo]==null?'':mapa[campo]).trim();
      if(!novo) return;
      if(String(cli[campo]||'').trim()) return;      /* já tinha: não encosta */
      if(campo!=='cep'&&campo!=='numero') novo=novo.toUpperCase();
      mud[campo]=novo; cli[campo]=novo; postos.push(campo);
    });
    if(!postos.length){ toast('Comprovante lido — o endereço do cadastro já estava preenchido, não mexi nele.'); return; }
    try{ await supa.from('clientes').update(mud).eq('id',cli.id); toast('Endereço preenchido pelo comprovante ('+postos.length+' campo(s)).'); }
    catch(_){ toast('Li o comprovante, mas não consegui salvar o endereço.'); }
  }
  /* ---------- conferências: cada validador diz SIM, NÃO ou "não sei" ---------- */
  function _vfCpfOk(s){
    var d=String(s||'').replace(/\D/g,'');
    if(d.length!==11) return false;
    if(/^(\d)\1{10}$/.test(d)) return false;
    function dig(n){ var s=0; for(var i=0;i<n;i++) s+=parseInt(d.charAt(i),10)*(n+1-i); var r=(s*10)%11; return (r===10||r===11)?0:r; }
    return dig(9)===parseInt(d.charAt(9),10) && dig(10)===parseInt(d.charAt(10),10);
  }
  function _vfPlacaOk(s){
    /* v882 — a regex estava copiada aqui. Ela era IGUAL à do 01-nucleo, o que
       é o pior caso: passa despercebida até o dia em que uma das duas muda.
       Agora chama a `valida()`, com o `limpa()` da casa antes dela. */
    return valida(limpa(s));
  }
  /* Renavam: 11 dígitos, o último é conferência (mesma conta do Detran) */
  function _vfRenavamOk(s){
    var d=String(s||'').replace(/\D/g,'');
    if(d.length!==11) return false;
    if(/^(\d)\1{10}$/.test(d)) return false;
    var base=d.slice(0,10), soma=0, pesos=[3,2,9,8,7,6,5,4,3,2];
    for(var i=0;i<10;i++) soma+=parseInt(base.charAt(i),10)*pesos[i];
    var resto=soma%11, dv=11-resto; if(dv>=10) dv=0;
    return dv===parseInt(d.charAt(10),10);
  }
  /* Chassi: 17 caracteres e NUNCA I, O ou Q (não existem em chassi de verdade —
     quem escreve isso está trocando por 1 e 0) */
  function _vfChassiOk(s){
    var c=String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    return c.length===17 && !/[IOQ]/.test(c);
  }
  function _vfNomeOk(s){
    var n=String(s||'').trim();
    return n.length>=5 && n.indexOf(' ')>0;
  }
  var _VF_CONF=[
    ['nome',   'Nome completo', 'texto',   _vfNomeOk,    'Nome e sobrenome.'],
    ['cpf',    'CPF',           'numero',  _vfCpfOk,     'CPF de 11 dígitos — os dígitos verificadores têm que fechar.'],
    ['placa',  'Placa',         'placa',   _vfPlacaOk,   'Placa no formato ABC1D23 ou ABC1234.'],
    ['renavam','Renavam',       'numero',  _vfRenavamOk, 'Renavam de 11 dígitos — o último é o dígito de conferência.'],
    ['chassi', 'Chassi',        'texto',   _vfChassiOk,  '17 caracteres. Chassi não tem letra I, O nem Q.']
  ];
  /* de onde veio cada valor — e, por isso, se precisa ou não do seu carimbo */
  function _vfConfBase(){
    var st=_vfDocsIA(), cli=_vfCliente()||{}, v=(_vp&&_vp.veiculo)||{};
    var cnh=st.cnh||{}, crlv=st.crlv||{};
    function esc1(val,origem,ia){ return { valor:String(val==null?'':val).trim(), origem:origem||'', ia:!!ia }; }
    var o={};
    o.nome    = cnh.nome      ? esc1(String(cnh.nome).toUpperCase(),'lido da CNH',true)
              : cli.nome      ? esc1(cli.nome,'do cadastro do cliente',false)
                              : esc1('','',false);
    o.cpf     = cnh.cpf       ? esc1(cnh.cpf,'lido da CNH',true)
              : cli.cpf       ? esc1(cli.cpf,'do cadastro do cliente',false)
                              : esc1('','',false);
    o.placa   = crlv.placa    ? esc1(String(crlv.placa).toUpperCase(),'lido do CRLV',true)
              : v.placa       ? esc1(String(v.placa).toUpperCase(),'do cadastro do veículo',false)
                              : esc1('','',false);
    o.renavam = crlv.renavam  ? esc1(crlv.renavam,'lido do CRLV',true)  : esc1('','',false);
    o.chassi  = crlv.chassi   ? esc1(String(crlv.chassi).toUpperCase(),'lido do CRLV',true) : esc1('','',false);
    /* se você já conferiu nesta cotação, o que foi conferido manda */
    var cf=(_vp&&_vp.conferido)||null;
    if(cf&&typeof cf==='object'){
      _VF_CONF.forEach(function(c){ var k=c[0];
        if(cf[k]!=null && String(cf[k]).trim()){ o[k]={ valor:String(cf[k]).trim(), origem:'você já conferiu', ia:false }; }
      });
    }
    return o;
  }
  function _vfConfLinha(c, dado){
    var k=c[0], ok=c[3](dado.valor), temValor=!!dado.valor;
    /* nasce carimbado quando NÃO veio de leitura de máquina e já está válido */
    var jaOk = ok && !dado.ia;
    return '<div class="vf-cf'+(jaOk?' ok':'')+'" data-cf="'+k+'">'+
      '<div class="vf-cf-hd"><b>'+esc(c[1])+'</b>'+
        (dado.origem?('<i class="vf-cf-org'+(dado.ia?' ia':'')+'">'+esc(dado.origem)+'</i>'):'<i class="vf-cf-org vazio">preencha</i>')+
      '</div>'+
      '<input class="cad-in vf-cf-in" id="vfCf_'+k+'" value="'+esc(dado.valor)+'"'+
        (c[2]==='numero'?' inputmode="numeric"':'')+
        (c[2]==='placa'?' style="text-transform:uppercase"':'')+
        ' placeholder="'+esc(c[4])+'">'+
      '<label class="vf-cf-ck"><input type="checkbox" id="vfCk_'+k+'"'+(jaOk?' checked':'')+(temValor&&ok?'':' disabled')+'><span>Confere</span></label>'+
      '<div class="vf-cf-msg" id="vfCm_'+k+'"></div>'+
      '</div>';
  }
  function vfConferirAbrir(){
    if(!_vp || !_vp.veiculo){ toast('Escolha um veículo primeiro.'); return; }
    if($('vpForm')) vpLe();
    var base=_vfConfBase();
    var bg=cliModalEl(); bg.classList.add('on');
    $('cliMav').innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>';
    $('cliMt').textContent='Conferência antes de gerar';
    $('cliMbody').innerHTML=
      '<div class="doc-hint">Cinco dados entram em todo documento e são os que mais custam caro quando saem errados. '+
      'O que a <b>IA leu</b> começa sem carimbo — confira contra o documento e marque. O que <b>você já tinha digitado</b> já vem carimbado.</div>'+
      _VF_CONF.map(function(c){ return _vfConfLinha(c, base[c[0]]||{valor:'',origem:'',ia:false}); }).join('')+
      '<div class="cad-msg" id="vfCfMsg"></div>'+
      '<button class="cad-btn" id="vfCfOk" style="margin-top:6px" disabled>Confirmar e preparar o contrato</button>'+
      '<button type="button" class="link" id="vfCfPular" style="margin-top:10px;width:100%">Preencher depois, abrir o contrato assim mesmo</button>';
    _VF_CONF.forEach(function(c){
      var k=c[0], inp=$('vfCf_'+k), ck=$('vfCk_'+k);
      if(inp) inp.oninput=function(){
        if(c[2]==='placa') this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);
        if(k==='chassi')   this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,17);
        if(c[2]==='numero'&&k!=='cpf') this.value=String(this.value||'').replace(/\D/g,'').slice(0,11);
        if(k==='cpf' && typeof _fmtCpf==='function') this.value=_fmtCpf(this.value);
        /* mexeu no campo = está olhando pra ele: o carimbo passa a ser seu */
        var v=c[3](this.value);
        if(ck){ ck.disabled=!v; if(v) ck.checked=true; else ck.checked=false; }
        _vfConfRevisa();
      };
      if(ck) ck.onchange=_vfConfRevisa;
    });
    var bo=$('vfCfOk'); if(bo) bo.onclick=_vfConfConfirmar;
    var bp=$('vfCfPular'); if(bp) bp.onclick=function(){ vpPropostaAbrir(); };
    _vfConfRevisa();
  }
  function _vfConfRevisa(){
    var faltam=[], todos=true;
    _VF_CONF.forEach(function(c){
      var k=c[0], inp=$('vfCf_'+k), ck=$('vfCk_'+k), msg=$('vfCm_'+k), box=document.querySelector('[data-cf="'+k+'"]');
      if(!inp) return;
      var val=String(inp.value||'').trim(), ok=c[3](val), carimbado=!!(ck&&ck.checked);
      if(msg){
        /* v374 — quando o valor veio de LEITURA e não fecha, o problema quase
           sempre é um dígito que a IA trocou (um 6 que virou 0). A mensagem
           antiga só dizia a regra e o vendedor achava que estava travado. */
        var _daIa=!!(box&&box.querySelector('.vf-cf-org.ia'));
        if(!val){ msg.textContent=''; msg.className='vf-cf-msg'; }
        else if(!ok){ msg.textContent=c[4]+(_daIa?' A IA pode ter trocado um dígito — corrija aqui no campo, olhando o documento.':''); msg.className='vf-cf-msg err'; }
        else if(!carimbado){ msg.textContent='Confira contra o documento e marque "Confere".'; msg.className='vf-cf-msg avisa'; }
        else { msg.textContent=''; msg.className='vf-cf-msg'; }
      }
      if(box) box.classList.toggle('ok', ok&&carimbado);
      if(!(ok&&carimbado)){ todos=false; faltam.push(c[1]); }
    });
    var m=$('vfCfMsg');
    if(m){
      if(todos){ m.className='cad-msg ok'; m.textContent='Os cinco dados conferidos ✓'; }
      else { m.className='cad-msg'; m.textContent='Falta conferir: '+faltam.join(', ')+'.'; }
    }
    var bo=$('vfCfOk'); if(bo) bo.disabled=!todos;
    return todos;
  }
  async function _vfConfConfirmar(){
    if(!_vfConfRevisa()) return;
    var out={};
    _VF_CONF.forEach(function(c){ var e=$('vfCf_'+c[0]); out[c[0]]=e?String(e.value||'').trim():''; });
    if(_vp) _vp.conferido=out;
    /* leva o que foi conferido pro cadastro do cliente e pro veículo, senão o
       trabalho de conferir morre aqui e some na próxima tela */
    try{
      var cli=_vfCliente();
      if(cli && cli.id){
        var mud={};
        if(out.nome && String(cli.nome||'')!==out.nome) mud.nome=out.nome;
        if(out.cpf  && String(cli.cpf||'')!==out.cpf)   mud.cpf=out.cpf;
        if(Object.keys(mud).length){
          cli.nome=mud.nome||cli.nome; cli.cpf=mud.cpf||cli.cpf;
          await supa.from('clientes').update(mud).eq('id',cli.id);
        }
      }
    }catch(_){}
    if(_vp && _vp.veiculo && out.placa) _vp.veiculo.placa=out.placa;
    try{ await _vfPersistir(''); }catch(_){}
    toast('Dados conferidos ✓');
    vpPropostaAbrir();
  }
  /* v284: religa só o bloco de documentos. Existe separado porque anexar um
     documento repinta ESSE pedaço da tela — e o botão de conferir tem que
     voltar a funcionar depois da repintura. */
  function _vfDocsWire(){
    var ct=$('vfContrato'); if(ct) ct.onclick=function(){ if($('vpForm')) vpLe(); vfConferirAbrir(); };
    var dt=$('vfDocTroca'); if(dt) dt.onclick=_vfDocsTroca;
    var up=document.querySelector('[data-tela="vf_usado_plus"]');
    if(up) up.onclick=function(){ _vpTrocaConsultaAbrir('plus'); };
    _vfAnexosWire();
  }
  function _vfEntregaHtml(){
    var e=_vfEntregaDados();
    var itens=[
      ['transferencia_ok','Transferência conferida'],
      ['atpv_preenchida','ATPV preenchida'],
      ['chave_reserva','Chave reserva entregue'],
      ['veiculo_revisado','Veículo revisado'],
      ['procuracao_publica','Procuração pública conferida']
    ];
    var feitos=itens.filter(function(x){ return !!e[x[0]]; }).length;
    return '<p class="vf-entrega-intro">Conferência operacional antes de concluir a entrega. '+feitos+' de '+itens.length+' itens marcados.</p><div class="vf-entrega-list">'+itens.map(function(x){
      return '<label class="vf-entrega-item'+(e[x[0]]?' on':'')+'"><input type="checkbox" data-vf-entrega="'+x[0]+'"'+(e[x[0]]?' checked':'')+'><span class="vf-entrega-box">'+_VF_ICO.chave+'</span><span>'+x[1]+'</span></label>';
    }).join('')+'</div>';
  }
  /* v219 — o acompanhamento depois da venda é do NEGÓCIO fechado, não da
     ficha de estoque. O espelho em estoque.pos_venda permanece porque a página
     Resultado já o usa; propostas antigas são lidas como compatibilidade. */
  function _vfPosVeiculo(){
    var veic=(_vp&&_vp.veiculo)||{}, id=veic.estoque_id, placa=String(veic.placa||'').toUpperCase();
    var achou=null;
    (_estoque||[]).forEach(function(v){
      if(achou||!v) return;
      if(id!=null && String(v.id)===String(id)) achou=v;
      else if(!id && placa && String(v.placa||'').toUpperCase()===placa) achou=v;
    });
    return achou;
  }
  function _vfPosDados(){
    var proposta=(_vp&&_vp.pos_venda&&typeof _vp.pos_venda==='object')?_vp.pos_venda:{};
    var legado=(_vfPosVeiculo()||{}).pos_venda||{};
    function tem(k){ return Object.prototype.hasOwnProperty.call(proposta,k) && proposta[k]!==null && proposta[k]!==''; }
    function dado(k,alternativa){ return tem(k)?proposta[k]:alternativa; }
    var valor=Number(dado('valor_venda',legado.valor_venda))||Number((_vp&&_vp.precoVenda)||0)||0;
    return {
      cliente_nome:String(dado('cliente_nome',legado.cliente_nome)||((_vp&&_vp.cliente_nome)||'')).trim(),
      valor_venda:valor,
      garantia:Number(dado('garantia',legado.garantia))||0,
      nf_valor:Number(dado('nf_valor',legado.nf_valor))||0,
      alienado:!!dado('alienado',legado.alienado),
      financeira:String(dado('financeira',legado.financeira)||'').trim(),
      data_venda:String(dado('data_venda',legado.data_venda)||'').slice(0,10)
    };
  }
  function _vfPosConta(pv){
    pv=pv||_vfPosDados(); var veic=_vfPosVeiculo();
    if(!veic) return {tem:false,custo:0,lucro:0,receita:0};
    var compra=_ogCompraV(veic), prep=resCustosPrep(veic), bruto=Number(pv.valor_venda)||0;
    var receita=_ogRecV(veic,bruto), custo=_r2(compra+prep+(Number(pv.garantia)||0));
    return {tem:true,custo:custo,lucro:bruto?_r2(receita-custo-(Number(pv.nf_valor)||0)):0,receita:receita};
  }
  function _vfPosResumoHtml(pv){
    var conta=_vfPosConta(pv);
    if(!conta.tem) return '<div class="vf-nota">O veículo desta venda não está no estoque. Salve os valores aqui; o custo e a margem serão calculados quando a ficha do veículo estiver disponível.</div>';
    var lucro=conta.lucro, cor=lucro>=0?'ok':'neg';
    return '<div class="vp-rows vf-pos-resumo">'+
      '<div class="vp-row"><span>Custo final <i>(compra + preparação + garantia)</i></span><b>'+esc(brl(conta.custo))+'</b></div>'+
      '<div class="vp-row dest '+cor+'"><span>Margem de lucro real <i>(já considera a NF)</i></span><b>'+(pv.valor_venda?(lucro<0?'−':'')+esc(brl(Math.abs(lucro))):'—')+'</b></div>'+
    '</div>';
  }
  function _vfPosHtml(){
    var pv=_vfPosDados();
    return '<div class="vf-pos-form">'+
      '<div class="cli-2col"><div><label class="cad-lbl">Cliente que comprou</label>'+_acCaixa('vfPvCliente',pv.cliente_nome,'Nome do cliente')+'</div><div><label class="cad-lbl">Valor da venda</label><input class="cad-in" id="vfPvVenda" inputmode="numeric" value="'+_rs(pv.valor_venda)+'" placeholder="R$ 0,00"></div></div>'+
      '<div class="cli-2col"><div><label class="cad-lbl">Custos de garantia</label><input class="cad-in" id="vfPvGarantia" inputmode="numeric" value="'+_rs(pv.garantia)+'" placeholder="R$ 0,00"></div><div><label class="cad-lbl">Valor da emissão da NF</label><input class="cad-in" id="vfPvNf" inputmode="numeric" value="'+_rs(pv.nf_valor)+'" placeholder="R$ 0,00"></div></div>'+
      '<div class="cli-2col"><div><label class="cad-lbl">Data da venda <span class="ec-hint">(entra no Resultado)</span></label><input class="cad-in" type="date" id="vfPvData" value="'+esc(pv.data_venda||'')+'"></div><div></div></div>'+
      '<label class="vd-ck'+(pv.alienado?' on':'')+'"><input type="checkbox" id="vfPvAlienado"'+(pv.alienado?' checked':'')+'><span>Alienado (financiado)</span></label>'+
      '<div id="vfPvFinWrap"'+(pv.alienado?'':' style="display:none"')+'><label class="cad-lbl">Qual financeira</label><input class="cad-in" id="vfPvFin" value="'+esc(pv.financeira||'')+'" placeholder="Ex.: Banco Santander, BV, Bradesco"></div>'+
      '<div id="vfPvResumo">'+_vfPosResumoHtml(pv)+'</div><div class="cad-autosave vazio" id="vfPvAutosave"></div>'+
    '</div>';
  }
  function _vfPosLer(){
    return {
      cliente_nome:String((($('vfPvCliente')||{}).value)||'').trim(), valor_venda:estRS('vfPvVenda')||0,
      garantia:estRS('vfPvGarantia')||0, nf_valor:estRS('vfPvNf')||0,
      alienado:!!(($('vfPvAlienado')||{}).checked), financeira:String((($('vfPvFin')||{}).value)||'').trim(),
      data_venda:String((($('vfPvData')||{}).value)||'').slice(0,10)
    };
  }
  function _vfPosAplicar(){
    if(!_vp) return null;
    var pv=_vfPosLer(); _vp.pos_venda=pv;
    _vp.cliente_nome=pv.cliente_nome||_vp.cliente_nome||'';
    if(pv.valor_venda>0) _vp.precoVenda=pv.valor_venda;
    var resumo=$('vfPvResumo'); if(resumo) resumo.innerHTML=_vfPosResumoHtml(pv);
    var conta=$('vfRes'); if(conta) conta.innerHTML=_vfResHtml();
    return pv;
  }
  var _vfPosSalvarTimer=null;
  function _vfPosAgendaSalvar(){
    var pv=_vfPosAplicar(); if(!pv) return;
    var ind=$('vfPvAutosave'); if(ind){ ind.className='cad-autosave saving'; ind.textContent='Salvando…'; }
    clearTimeout(_vfPosSalvarTimer);
    _vfPosSalvarTimer=setTimeout(function(){ _vfPosPersistir(pv); },700);
  }
  async function _vfPosPersistir(pv){
    pv=pv||_vfPosDados(); var ind=$('vfPvAutosave'), veic=_vfPosVeiculo(), ok=true;
    try{
      if(veic&&veic.id){
        var upd={pos_venda:pv,atualizado_em:new Date().toISOString()};
        var r=await supa.from('estoque').update(upd).eq('id',veic.id); if(r&&r.error) throw r.error;
        veic.pos_venda=pv; veic.atualizado_em=upd.atualizado_em;
      }
      if(!(await _vfPersistir(''))) ok=false;
      if(ok&&ind){ ind.className='cad-autosave ok'; ind.textContent='✓ Salvo'; setTimeout(function(){ var e=$('vfPvAutosave'); if(e&&e.classList.contains('ok')){ e.className='cad-autosave vazio'; e.textContent=''; } },2200); }
    }catch(e){ ok=false; if(ind){ ind.className='cad-autosave err'; ind.textContent='Sem conexão — tente novamente.'; } }
    return ok;
  }
  function _vfPosWire(){
    ['vfPvVenda','vfPvGarantia','vfPvNf'].forEach(function(id){ var e=$(id); if(e) e.oninput=function(){ estMaskRS.call(this); _vfPosAgendaSalvar(); }; });
    ['vfPvCliente','vfPvFin'].forEach(function(id){ var e=$(id); if(e) e.oninput=_vfPosAgendaSalvar; });
    var data=$('vfPvData'); if(data) data.onchange=_vfPosAgendaSalvar;
    var al=$('vfPvAlienado'); if(al) al.onchange=function(){ var w=$('vfPvFinWrap'); if(w) w.style.display=al.checked?'block':'none'; var lb=al.closest('.vd-ck'); if(lb) lb.classList.toggle('on',al.checked); _vfPosAgendaSalvar(); };
    try{
      if(!(_clientes||[]).length) cliCarregar();
      _acWire('vfPvCliente',function(){ return (_clientes||[]).map(function(c){ return {txt:(c.nome||'Cliente'),sub:[foneFmt(c.telefone||''),c.cpf||''].filter(Boolean).join(' · '),busca:(c.nome||'')+' '+(c.telefone||'')+' '+(c.cpf||''),rec:c}; }); },function(it){
        var e=$('vfPvCliente'); if(e) e.value=it.txt||'';
        if(_vp){ _vp.cliente_id=(it.rec&&it.rec.id)||_vp.cliente_id||''; _vp.cliente_nome=it.txt||''; }
        _vfPosAgendaSalvar();
      });
    }catch(_){}
  }
  function _vfResHtml(){
    var q=_vfConta();
    var cor=(q.falta>0.5)?'#dc2626':((q.falta<-0.5)?'#b45309':'#16a34a');
    var rot=(q.falta>0.5)?'Ainda falta receber':((q.falta<-0.5)?'Recebeu a mais':'Conta fechada');
    var h='<div class="vf-conta">'+
      '<div class="vf-l"><span>Total do negócio</span><b>'+esc(brl(q.total))+'</b></div>';
    if(q.troca>0) h+='<div class="vf-l"><span>Usado na troca</span><b style="color:#0a4da6">(-) '+esc(brl(q.troca))+'</b></div>';
    h+='<div class="vf-l tot"><span>A receber em dinheiro</span><b>'+esc(brl(q.alvo))+'</b></div>'+
       '<div class="vf-l"><span>Já recebido ('+q.n+')</span><b style="color:#16a34a">'+esc(brl(q.pago))+'</b></div>'+
       '<div class="vf-l tot"><span>'+esc(rot)+'</span><b style="color:'+cor+'">'+esc(brl(Math.abs(q.falta)))+'</b></div>'+
       '<div class="vf-bar"><i style="width:'+q.pct+'%;background:'+cor+'"></i></div>';
    if(q.c.parcelado && q.c.base>0) h+='<div class="vf-nota">Deste valor, <b>'+esc(brl(q.c.base))+'</b> deve vir do financiamento. O banco costuma pingar depois da entrega — anexe o comprovante quando cair.</div>';
    return h+'</div>';
  }
  function _vfCardHtml(p,i){
    p=p||{};
    var ehPdf=/\.pdf(\?|$)/i.test(String(p.arquivo||''))||/pdf/i.test(String(p.arquivo_nome||''));
    var privado=_arqPrivadoEh(p.arquivo);
    var th = p.arquivo
      ? (ehPdf ? '<div class="vf-th pdf">PDF</div>' : (privado
          ? '<img loading="lazy" decoding="async" class="vf-th" data-vf-private-thumb="'+esc(p.arquivo)+'" alt="Comprovante">'
          : '<img loading="lazy" decoding="async" class="vf-th" src="'+esc(p.arquivo)+'" alt="Comprovante">'))
      : '<div class="vf-th vazio">'+_VF_ICO.clipe+'</div>';
    var l2=[];
    if(p.data) l2.push(_dataBr(p.data)+(p.hora?(' '+esc(p.hora)):''));
    if(p.pagador) l2.push(String(p.pagador).slice(0,28));
    if(p.banco) l2.push(String(p.banco).slice(0,22));
    var l3=[];
    if(p.id_transacao) l3.push('ID '+String(p.id_transacao).slice(0,42));
    if(p.obs) l3.push(String(p.obs).slice(0,60));
    var sel=p.ia?('<span class="vf-ia">lido pela IA'+(p.confianca?(' · '+Math.round(p.confianca*100)+'% de certeza'):'')+'</span>'):'';
    /* v374 (pedido) — o NOME do arquivo aparece no card. E quando o arquivo
       não ficou guardado (upload caiu no meio), em vez de um clipe mudo o
       card diz o que houve e oferece anexar — sem gastar token de novo,
       porque os dados lidos já estão salvos. */
    var _nomeArq=String(p.arquivo_nome||'').trim();
    var _semArq=!p.arquivo;
    var arq = _nomeArq
      ? ('<div class="vf-sb min vf-arq">'+_VF_ICO.clipe+' '+esc(_nomeArq.length>44?(_nomeArq.slice(0,41)+'…'):_nomeArq)+(_semArq?' <b style="color:#b45309">— imagem não guardada</b>':'')+'</div>')
      : (_semArq&&p.ia ? '<div class="vf-sb min vf-arq"><b style="color:#b45309">Imagem não guardada</b> — anexe pra deixar junto do pagamento</div>' : '');
    return '<div class="vf-card">'+th+
      '<div class="vf-ct">'+
        '<div class="vf-vl">'+esc(brl(Number(p.valor)||0))+'<span class="vf-tag">'+esc(p.forma||'Outro')+'</span></div>'+
        (l2.length?('<div class="vf-sb">'+esc(l2.join(' · '))+'</div>'):'')+
        (l3.length?('<div class="vf-sb min">'+esc(l3.join(' · '))+'</div>'):'')+
        arq+
        sel+
      '</div>'+
      '<div class="vf-bt">'+
        (p.arquivo?('<button type="button" data-ver="'+i+'" title="Ver"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg></button>'+
                    '<button type="button" data-baixar="'+i+'" title="Baixar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg></button>')
                  :('<button type="button" data-anexar="'+i+'" title="Anexar o comprovante"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg></button>'))+
        '<button type="button" class="del" data-del="'+i+'" title="Remover"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg></button>'+
      '</div></div>';
  }
  function _vfPrivadoThumbs(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-vf-private-thumb]'),function(img){
      var ref=img.getAttribute('data-vf-private-thumb')||'';
      _arqPrivadoUrl(ref).then(function(url){
        if(img&&img.getAttribute('data-vf-private-thumb')===ref) img.src=url;
      })['catch'](function(){});
    });
  }
  function _vfListaHtml(){
    var f=_vfDados();
    if(!f.pagamentos.length) return '<div class="cli-empty" style="padding:22px 12px"><b>Nenhum comprovante ainda</b>Anexe o Pix do sinal: a IA preenche valor, data, quem pagou e o ID da transação.</div>';
    return f.pagamentos.map(_vfCardHtml).join('');
  }
  function _vfMaoHtml(){
    return '<div class="vf-mao">'+
      '<div class="cli-2col"><div><label class="cad-lbl">Valor recebido</label><input class="cad-in" id="vfMValor" inputmode="numeric" placeholder="R$ 0,00"></div>'+
      '<div><label class="cad-lbl">Data</label><input class="cad-in" id="vfMData" type="date" value="'+esc(_cotHoje())+'"></div></div>'+
      '<label class="cad-lbl">Forma</label><select class="cad-in" id="vfMForma">'+_VF_FORMAS.map(function(x){ return '<option>'+esc(x)+'</option>'; }).join('')+'</select>'+
      '<label class="cad-lbl">Observação <span class="ec-hint">(ex.: sinal do negócio)</span></label><input class="cad-in" id="vfMObs" placeholder="opcional">'+
      '<div class="vp-acts" style="margin-top:10px"><button type="button" id="vfMX">Cancelar</button><button type="button" class="pri" id="vfMOk">Lançar pagamento</button></div>'+
      '</div>';
  }

  function _vfTabAplica(){
    /* v444: _vfTabsVis, não _VF_TABS — numa venda SEM troca a aba
       "Conferir o usado" não existe, e cair nela deixaria a tela em branco */
    var existe=_vfTabsVis().some(function(t){ return t[0]===_vfTab; });
    if(!existe) _vfTab='fechamento';
    Array.prototype.forEach.call(document.querySelectorAll('#vfPagina .vpx-panel'),function(pn){ pn.classList.toggle('on',pn.getAttribute('data-panel')===_vfTab); });
    Array.prototype.forEach.call(document.querySelectorAll('#vfTabs .vpx-st'),function(b){ var on=b.getAttribute('data-step')===_vfTab; b.classList.toggle('on',on); if(on){ _tabCentra(b.parentNode,b); } });
  }
  function _vfTabsWire(){
    Array.prototype.forEach.call(document.querySelectorAll('#vfTabs .vpx-st'),function(b){ b.onclick=function(){ _vfTab=b.getAttribute('data-step')||'fechamento'; _vfTabAplica(); try{ $('vfPagina').scrollIntoView({block:'start'}); }catch(_){} }; });
  }
  /* Repinta somente os blocos da página de fechamento. */
  function _vfPinta(){
    if(!$('vfFlag')) return;
    $('vfFlag').innerHTML=_vfFlagHtml();
    var pos=$('vfPos'), res=$('vfRes'), lista=$('vfLista'), entrega=$('vfEntrega');
    _vfDocsPinta();
    if(pos) pos.innerHTML=_vfPosHtml();
    if(res) res.innerHTML=_vfResHtml();
    if(lista) lista.innerHTML=_vfListaHtml();
    if(entrega) entrega.innerHTML=_vfEntregaHtml();
    _vfWire(); _vfPosWire(); _vfPrivadoThumbs();
  }
  /* v305: os tres paineis de documento nascem e renascem juntos. */
  function _vfDocsPinta(){
    var a=$('vfAnexos'), ct=$('vfContratoBox'), us=$('vfUsado');
    var uc=$('vfUsadoCons');   /* v444 */
    if(a)  a.innerHTML  = _vfAnexosPainelHtml();
    if(ct) ct.innerHTML = _vfContratoHtml();
    if(us) us.innerHTML = _vfUsadoHtml();
    if(uc) uc.innerHTML = _vfUsadoConsHtml();
    if(a||ct||us||uc) _vfDocsWire();
  }
  function _vfWire(){
    var ch=$('vfChave'); if(ch) ch.onclick=_vfToggle;
    _vfDocsWire();
    var dt=$('vfDocTroca'); if(dt) dt.onclick=_vfDocsTroca;
    var ia=$('vfIa'); if(ia) ia.onclick=_vfIaAnexar;
    var mo=$('vfMao'); if(mo) mo.onclick=function(){
      var b=$('vfMaoBox'); if(!b) return;
      if(b.innerHTML){ b.innerHTML=''; return; }
      b.innerHTML=_vfMaoHtml(); _vfMaoWire();
    };
    var lst=$('vfLista');
    if(lst){
      Array.prototype.forEach.call(lst.querySelectorAll('[data-ver]'),function(b){
        b.onclick=function(){ var p=_vfDados().pagamentos[+b.getAttribute('data-ver')]; if(p&&p.arquivo) _ljVerDoc(p.arquivo,p.arquivo_nome||'comprovante'); };
      });
      /* v374 — anexar a imagem de um comprovante que ficou sem arquivo. Não
         relê nada: os dados já estão salvos, isto só guarda o documento. */
      Array.prototype.forEach.call(lst.querySelectorAll('[data-anexar]'),function(b){
        b.onclick=function(){
          var idx=+b.getAttribute('data-anexar');
          var inp=document.createElement('input');
          inp.type='file'; inp.accept='image/*,application/pdf'; inp.style.display='none';
          document.body.appendChild(inp);
          inp.onchange=async function(){
            var f=this.files&&this.files[0]; try{ inp.remove(); }catch(_){}
            if(!f) return;
            var p=_vfDados().pagamentos[idx]; if(!p) return;
            toast('Guardando o comprovante…');
            try{
              p.arquivo=await arqUpload(f,'pagamento');
              p.arquivo_nome=String(f.name||p.arquivo_nome||'comprovante');
              _vfPinta();
              await _vfPersistir('Comprovante guardado.');
            }catch(e){ toast('Não consegui guardar o arquivo. Tente de novo.'); }
          };
          inp.click();
        };
      });
      Array.prototype.forEach.call(lst.querySelectorAll('[data-baixar]'),function(b){
        b.onclick=function(){ var p=_vfDados().pagamentos[+b.getAttribute('data-baixar')]; if(p) _vfBaixarArq(p.arquivo, p.arquivo_nome||('comprovante-'+(p.data||'')+'.jpg')); };
      });
      Array.prototype.forEach.call(lst.querySelectorAll('[data-del]'),function(b){
        b.onclick=async function(){
          var i=+b.getAttribute('data-del'); var f=_vfDados();
          if(i<0||i>=f.pagamentos.length) return;
          var removido=f.pagamentos.splice(i,1)[0]; _vfPinta();
          var ok=await _vfPersistir('Comprovante removido.');
          if(ok){ try{ await _arqPrivadoApagar(removido&&removido.arquivo); }catch(_){} }
          else{ f.pagamentos.splice(i,0,removido); _vfPinta(); }
        };
      });
    }
    var entrega=$('vfEntrega');
    if(entrega){
      Array.prototype.forEach.call(entrega.querySelectorAll('[data-vf-entrega]'),function(campo){ campo.onchange=async function(){
        var chave=campo.getAttribute('data-vf-entrega'); if(!chave) return;
        _vfEntregaDados()[chave]=!!campo.checked;
        _vfPinta();
        await _vfPersistir('Checklist de entrega atualizado.');
      }; });
    }
  }
  function _vfMaoWire(){
    var iv=$('vfMValor'); if(iv) iv.oninput=estMaskRS;
    var x=$('vfMX'); if(x) x.onclick=function(){ var b=$('vfMaoBox'); if(b) b.innerHTML=''; };
    var ok=$('vfMOk'); if(ok) ok.onclick=async function(){
      var val=estRS('vfMValor');
      if(!(val>0)){ toast('Coloque o valor que entrou.'); return; }
      _vfDados().pagamentos.push({
        valor:val, data:String((($('vfMData')||{}).value)||_cotHoje()).slice(0,10), hora:'',
        forma:String((($('vfMForma')||{}).value)||'Outro'), pagador:'', banco:'', favorecido:'',
        id_transacao:'', obs:String((($('vfMObs')||{}).value)||''), ia:false, confianca:0,
        arquivo:'', arquivo_nome:'', em:new Date().toISOString()
      });
      var b=$('vfMaoBox'); if(b) b.innerHTML='';
      _vfPinta();
      await _vfPersistir('Pagamento lançado.');
    };
  }

  /* ---------------- acoes ---------------- */
  async function _vfToggle(){
    var f=_vfDados(), antesOn=!!f.on, antesEm=f.em||'';
    f.on=!antesOn; f.em=f.on?new Date().toISOString():'';
    _vfPinta();
    var ok=await _vfPersistir(f.on?'Venda fechada! Ela já está em "Vendas fechadas".':'Voltou pra "Cotações salvas".');
    if(!ok){ f.on=antesOn; f.em=antesEm; _vfPinta(); return; }
    if(!f.on) vendaSair();
  }
  /* leva pra tela "Gerar documentos" ja' com o CARRO DA TROCA e o cliente
     preenchidos — e com um caminho de volta pra dentro desta venda */
  async function _vfDocsTroca(){
    if($('vpForm')) vpLe();
    var t=(_vp&&_vp.troca)||{};
    var ok=await _vfPersistir('');
    if(!ok && !_vpEditId) return;
    var id=_vpEditId;
    docsAbrir({
      placa:String(t.placa||'').toUpperCase(),
      marca:String(t.modelo||''),
      ano:String(t.ano||''),
      valor:(Number(t.avaliacao)||0),
      cliente_id:(_vp&&_vp.cliente_id)||null
    }, function(){ if(id){ telaVendaFechada(id); } else vendaSair(); });
  }
  /* base64 -> File, pro upload usar o MESMO caminho das fotos da avaliacao */
  function _vfB64File(b64, mime, nome){
    var bin=atob(String(b64||'')); var arr=new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    try{ return new File([arr], nome||'comprovante.jpg', {type:mime||'image/jpeg'}); }
    catch(_){ var b=new Blob([arr],{type:mime||'image/jpeg'}); try{ b.name=nome||'comprovante.jpg'; }catch(__){} return b; }
  }
  /* baixar SEM doc.save() — no iPhone/PWA so' o <a download> funciona */
  async function _vfBaixarArq(url, nome){
    if(!url){ toast('Este lançamento não tem arquivo anexado.'); return; }
    await _arqPrivadoBaixar(url,nome||'comprovante');
  }
  /* a IA lê o comprovante (1 token) e já devolve valor, data, quem pagou... */
  function _vfIaAnexar(){
    if(!window.MEV_IA){ _iaAcao(_vfIaAnexar); return; }
    window.MEV_IA.importarComprovantePagamento(async function(d){
      if(!d) return;
      if(d.erro){ toast(String(d.erro)); return; }
      var f=_vfDados();
      var p={
        valor:(Number(d.valor)||0),
        data:String(d.data_pagamento||'').slice(0,10),
        hora:String(d.hora_pagamento||''),
        forma:_vfForma(d.tipo_pagamento),
        pagador:String(d.pagador_nome||''),
        banco:String(d.banco_origem||''),
        favorecido:String(d.favorecido_nome||''),
        id_transacao:String(d.id_transacao||''),
        obs:String(d.descricao||d.observacoes||''),
        ia:true, confianca:(Number(d.confianca)||0),
        arquivo:'', arquivo_nome:String((d._anexo&&d._anexo.nomeArquivo)||''),
        em:new Date().toISOString()
      };
      f.pagamentos.push(p);
      _vfPinta();                                  /* mostra na hora, sem esperar o upload */
      if(d._anexo && d._anexo.base64){
        try{
          var file=_vfB64File(d._anexo.base64, d._anexo.mimeType||'image/jpeg', p.arquivo_nome||'comprovante.jpg');
          p.arquivo=await arqUpload(file,'pagamento');
          _vfPinta();
        }catch(e){ toast('Li o comprovante, mas não consegui guardar a imagem.'); }
      }
      await _vfPersistir(p.valor>0?('Comprovante de '+brl(p.valor)+' salvo.'):'Comprovante salvo.');
    });
  }
  /* grava no banco. Se a cotacao ainda nao existe la', cria antes (calado). */
  async function _vfPersistir(msg){
    /* le' o formulario antes de gravar: se o vendedor mexeu no preco ou na troca
       e so' depois anexou o comprovante, esses valores vao junto. vpLe altera o
       _vp POR DENTRO (nao troca o objeto), entao o "f" abaixo continua valendo. */
    try{ if($('vpForm')) vpLe(); }catch(_){}
    var f=_vfDados();
    if(!_vpEditId){
      var criou=await vpSalvar(true);
      if(!criou || !_vpEditId){ toast('Salve a cotação primeiro (aba Resumo).'); return false; }
    }
    var conta=_vfConta(_vp);
    var reg={ proposta:_vp, fechada:!!f.on,
              fechada_em:(f.on?(f.em||new Date().toISOString()):null),
              cliente_id:_vp.cliente_id||null, cliente_nome:_vp.cliente_nome||null,
              valor_venda:Math.round(conta.total)||null, atualizado_em:new Date().toISOString() };
    var et=_vfEtapaNova(!!f.on); if(et) reg.etapa=et;
    try{
      var r=await supa.from('vendas').update(reg).eq('id',_vpEditId);
      if(r&&r.error) throw r.error;
      var lin=_vfLinha();                       /* espelha na memoria: as listas ja' saem certas */
      if(lin){ lin.proposta=_vp; lin.fechada=reg.fechada; lin.fechada_em=reg.fechada_em; lin.cliente_id=reg.cliente_id; lin.cliente_nome=reg.cliente_nome; lin.valor_venda=reg.valor_venda; lin.atualizado_em=reg.atualizado_em; if(et) lin.etapa=et; }
      if(msg) toast(msg);
      return true;
    }catch(e){ toast('Não consegui salvar. '+((e&&e.message)||'')); return false; }
  }

  /* ============ v195 — PAGINA "VENDAS FECHADAS" ============
     Mesma cara de "Cotacoes salvas", mas so' com o que ja' fechou — e com a
     barrinha de quanto do dinheiro ja' entrou. Tocar no card abre a página
     própria da venda fechada. */
  var _vfPagFiltro='';
  function _vfPagTodas(){ return (_vendas||[]).filter(function(v){ return !!(v&&v.proposta) && !!v.fechada; }); }
  function _vfPagConta(v){ return _vfConta((v&&v.proposta)||{}); }
  function _vfPagQuitada(v){ return _vfPagConta(v).falta<=0.5; }
  function _vfPagDevendo(v){ return _vfPagConta(v).falta>0.5; }
  async function telaVendasFechadas(alvo){
    if(!alvo){ mevTabSet(''); _vdTab='fechadas'; }
    (alvo||$('secoes')).innerHTML=(alvo?'':_cadBack())+'<div class="info-pg"><h2>Vendas fechadas</h2>'+
      '<div class="vv-hint">Negócio fechado com o cliente. Aqui você acompanha os documentos e se o dinheiro já entrou todo.</div>'+
      '<div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="vfBusca" placeholder="Buscar placa, modelo, cliente ou vendedor" autocomplete="off"></div></div>'+
      '<div class="est-chips" id="vfChips"></div>'+
      '<div id="vfResumo"></div>'+
      '<div id="vfPagLista"><div class="cli-empty">Carregando...</div></div></div>';
    if(!alvo){ $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(vdVoltarDaGestao); }
    $('vfBusca').oninput=function(){ vfPagPinta(this.value); };
    await cotNomesCarregar();
    await vendaCarregar();
    vfPagPinta('');
  }
  async function telaVendaFechada(id){
    if(!id){ telaVendasFechadas(); return; }
    mevTabSet(''); _vpFechadaGestao=true;
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg vf-page"><div class="vf-page-head"><div><div class="vf-page-kicker">'+_VF_ICO.chave+'Venda fechada</div><h2 id="vfTitulo">Carregando venda...</h2><p id="vfSubtitulo"></p></div><button type="button" class="cad-btn sec" id="vfEditarNeg">Voltar à negociação</button></div><div id="vfPagina"><div class="cli-empty">Carregando...</div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(telaVendasFechadas);
    await cliCarregar(); if(!_estoque.length) await estCarregar();
    if(!_vendas.length) await vendaCarregar();
    var v=(_vendas||[]).filter(function(x){ return String(x.id)===String(id); })[0]||null;
    if(!v){ toast('Não encontrei esta venda.'); telaVendasFechadas(); return; }
    _vpPrepararRegistro(v,id);
    var f=_vfDados();
    /* Compatibilidade com vendas fechadas antes de o detalhe ter página própria. */
    if(v.fechada && !f.on){ f.on=true; f.em=f.em||v.fechada_em||''; }
    var titulo=$('vfTitulo'), subtitulo=$('vfSubtitulo');
    if(titulo) titulo.textContent=_vpVeicNome(_vp.veiculo||{marca:'',modelo:v.veiculo||'Veículo'});
    if(subtitulo) subtitulo.textContent=[v.placa||(_vp.veiculo&&_vp.veiculo.placa)||'',v.cliente_nome||_vp.cliente_nome||'',f.on?('fechada em '+(_dataBr(f.em||v.fechada_em)||'hoje')):'pronta para fechar'].filter(Boolean).join(' · ');
    /* v444: normalmente a venda fechada abre no Fechamento. A exceção é
       quem está VOLTANDO de uma consulta do usado — esse tem que cair de
       volta na aba de onde saiu, não no começo da página. Quem pede isso é
       o _vpConsultaVoltar, pondo o _vfTabIni antes de chamar. */
    _vfTab=_vfTabIni||'fechamento'; _vfTabIni='';
    var pagina=$('vfPagina'); if(pagina) pagina.innerHTML=_vfConteudoHtml();
    _vfTabsWire(); _vfTabAplica(); _vfPinta();
    var editar=$('vfEditarNeg'); if(editar) editar.onclick=function(){ vendaNovaAbrir(id); };
  }
  function vfPagChips(){
    var box=$('vfChips'); if(!box) return;
    var t=_vfPagTodas();
    var chips=[['','Todas',t.length],
               ['falta','Falta receber',t.filter(_vfPagDevendo).length],
               ['quit','Conta fechada',t.filter(_vfPagQuitada).length],
               ['minhas','Minhas',t.filter(_cotMinha).length],
               ['troca','Com troca',t.filter(_cotTemTroca).length]];
    box.innerHTML=chips.map(function(c){ return '<button class="est-chip'+(_vfPagFiltro===c[0]?' on':'')+'" data-f="'+c[0]+'">'+esc(c[1])+' · '+c[2]+'</button>'; }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('.est-chip'),function(b){
      b.onclick=function(){ _vfPagFiltro=b.getAttribute('data-f'); vfPagPinta((($('vfBusca')||{}).value)||''); };
    });
  }
  function vfPagPinta(termo){
    vfPagChips();
    var el=$('vfPagLista'); if(!el) return; termo=(termo||'').toLowerCase().trim();
    var todas=_vfPagTodas();
    if(!todas.length){
      if($('vfResumo')) $('vfResumo').innerHTML='';
      el.innerHTML='<div class="cli-empty"><b>Nenhuma venda fechada ainda</b>Abra uma venda, toque em Fechar venda no Resumo e confirme o fechamento.</div>'; return;
    }
    var lista=todas.filter(function(v){
      if(_vfPagFiltro==='falta' && !_vfPagDevendo(v)) return false;
      if(_vfPagFiltro==='quit'  && !_vfPagQuitada(v)) return false;
      if(_vfPagFiltro==='minhas'&& !_cotMinha(v)) return false;
      if(_vfPagFiltro==='troca' && !_cotTemTroca(v)) return false;
      if(!termo) return true;
      return ((v.placa||'')+' '+(v.veiculo||'')+' '+(v.cliente_nome||'')+' '+_cotPor(v)).toLowerCase().indexOf(termo)>=0;
    });
    var soma=0, falta=0;
    lista.forEach(function(v){ var q=_vfPagConta(v); soma+=q.total; falta+=Math.max(0,q.falta); });
    if($('vfResumo')) $('vfResumo').innerHTML='<div class="cot-res">'+
      '<div><b>'+lista.length+'</b><i>'+(lista.length===1?'venda':'vendas')+'</i></div>'+
      '<div><b>'+esc(brl(soma))+'</b><i>somando os negócios</i></div>'+
      '<div><b style="color:'+(falta>0.5?'#dc2626':'#16a34a')+'">'+esc(brl(falta))+'</b><i>ainda falta receber</i></div></div>';
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado com esse filtro.</div>'; return; }
    el.innerHTML=lista.map(function(v){
      var e=vendaEtapaInfo(v.etapa), q=_vfPagConta(v);
      var cor=(q.falta>0.5)?'#dc2626':'#16a34a';
      var txt=(q.falta>0.5)?('Falta <b>'+brl(q.falta)+'</b> de '+brl(q.alvo)):('Conta fechada · <b>'+brl(q.pago)+'</b> recebidos');
      return '<div class="est-card" data-id="'+esc(v.id)+'"><div class="est-tx">'+
        '<div class="est-nm">'+esc(v.veiculo||'Veículo')+'</div>'+
        '<div class="est-sb"><b>'+esc(v.placa||'-')+'</b>'+(v.cliente_nome?(' · '+esc(v.cliente_nome)):'')+'</div>'+
        '<div class="cot-cond" style="color:'+cor+'">'+txt+(q.n?(' · '+q.n+(q.n===1?' comprovante':' comprovantes')):' · sem comprovante')+'</div>'+
        '<div class="vf-bar mini"><i style="width:'+q.pct+'%;background:'+cor+'"></i></div>'+
        '<div class="est-row"><span class="est-preco">'+esc(brl(q.total))+'</span><span class="est-badge" style="color:'+e.c+';background:'+e.c+'14;border-color:'+e.c+'44">'+esc(e.t)+'</span></div>'+
        '<div class="cot-por">'+esc(_cotPor(v))+(v.fechada_em?(' · fechada em '+_dataBr(v.fechada_em)):(_cotData(v)?(' · '+_cotData(v)):''))+'</div>'+
        '</div><div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.est-card'),function(card){
      card.onclick=function(){ telaVendaFechada(card.getAttribute('data-id')); };
    });
  }

  /* mostra só a etapa ativa (menu lateral no PC / barra no celular) */
  function _vpStepAplica(){
    Array.prototype.forEach.call(document.querySelectorAll('#vpForm .vpx-panel'),function(pn){ pn.classList.toggle('on', pn.getAttribute('data-panel')===_vpStep); });
    Array.prototype.forEach.call(document.querySelectorAll('#vpSteps .vpx-st'),function(b){ var on=b.getAttribute('data-step')===_vpStep; b.classList.toggle('on', on); if(on){ _tabCentra(b.parentNode, b); } });
  }
  function vpLe(){
    if(!_vp) return; var g=function(id){ return estRS(id); };
    if(_vp.veiculo){ _vp.precoVenda=g('vpPreco')||_vp.precoVenda; _vp.veiculo.preco_minimo=g('vpMin')||_vp.veiculo.preco_minimo; }
    if(!_vp.apresentacao || typeof _vp.apresentacao!=='object') _vp.apresentacao={};
    /* v370: só a TABELA é um valor digitado. A avaliação apresentada é
       sempre calculada (tabela − saldo real) no _vpNegocRefresh — ler ela aqui
       era o que congelava o número errado e desalinhava o saldo do cliente. */
    var apTab=$('vpApresTabInput');
    if(apTab && document.activeElement===apTab) _vp.apresentacao.tabela=g('vpApresTabInput');
    _vp.desconto=g('vpDesc'); _vp.acrescimo=g('vpAcr'); _vp.cortesias=g('vpCort');
    var cdi=$('vpCortDesc'); if(cdi) _vp.cortesia_desc=String(cdi.value||'').trim();
    if(_vp.troca && _vp.troca.tem){ _vp.troca.avaliacao=g('vpAval'); _vp.troca.quitacao=g('vpQuit'); _vp.troca.fipe=g('vpFipe');
      _vp.troca.km=estNum('vpTrocaKm');
      var tp=$('vpTrocaPlaca'); if(tp) _vp.troca.placa=String(tp.value||'').toUpperCase(); var tm=$('vpTrocaModelo'); if(tm) _vp.troca.modelo=tm.value; var ta=$('vpTrocaAno'); if(ta) _vp.troca.ano=ta.value; }
    _vp.pag.entrada=g('vpEntrada');
    _vp.renda=g('vpRenda')||_vp.renda||0;
    var cpn=$('vpCpfNum'); if(cpn) _vp.cpf=String(cpn.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    var tc=$('vpTransfChk'); if(tc) _vp.transf_inclui=!!tc.checked;
    var tv=$('vpTransfVal'); if(tv) _vp.transf_valor=g('vpTransfVal')||700;
    var pj=$('vpParcelas'); if(pj) _vp.pag.parcelas=Math.min(60, parseInt(pj.value,10)||_vp.pag.parcelas||48);
    var jr=$('vpJuros'); if(jr) _vp.pag.juros=parseFloat(String(jr.value).replace(',','.'))||0;
    var rt=$('vpRet'); if(rt) _vp.pag.ret=Math.min(6, parseFloat(String(rt.value).replace(',','.'))||0);
    var cs=$('vpCliente'); if(cs){ _vp.cliente_id=cs.value||''; }
    var cn=$('vpCliNome'); if(cn) _vp.cliente_nome=String(cn.value||'').trim();
    var ct=$('vpCliTel'); if(ct) _vp.cliente_tel=String(ct.value||'').trim();
  }

/* ╔═══ src/app/18-credito-e-troca.js ═════════════════════════════════════ */
  /* ================= v189 · ANÁLISE DE CRÉDITO DENTRO DA VENDA =================
     O botão "Consultar" faz EXATAMENTE a mesma consulta da página Consulta CPF
     (produto "restricao", 5 tokens) e desenha o MESMO relatório. O resultado
     fica guardado dentro da proposta (_vp.cpf_res), então quando você salvar a
     cotação ele vai junto — não precisa consultar de novo. */
  /* v441 (pedido): a chave que liga/desliga o parecer da IA na tela da venda.
     Com false: o botão "Analisar aprovação com a IA" fica escondido (o
     style="display:none" está no 17-vendas.js) e o card do parecer não é
     pintado. Nada foi apagado — pra voltar, põe true aqui e tira o
     style="display:none" do botão lá. */
  var VP_IA_ON = false;
  function _vpRelRender(res){
    var rel=$('vpCpfRel'); if(!rel||!res) return;
    rel.style.display='block';
    rel.innerHTML=restricaoPanelHtml(res);
    var pb=rel.querySelector('#restPdf');
    if(pb) pb.onclick=function(){ _restState=res; restricaoBaixarPDF(); };
  }
  async function vpCpfConsultar(btn){
    if(!_vp) return; vpLe();
    var inp=$('vpCpfNum'), msg=$('vpCpfMsg');
    var doc=inp?String(inp.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''):'';
    var lg=$('vpLgpd');
    function _m(t,cor){ if(msg){ msg.textContent=t||''; msg.style.color=cor||'#b91c1c'; } }
    if(lg && !lg.checked && !_lgpdCpfAceito()){ _m('Marque o aceite do termo de proteção de dados (LGPD) pra consultar.'); try{ lg.focus(); }catch(_){} return; }
    if(doc.length!==11){ _m('Digite um CPF válido (11 números).'); return; }
    _vp.cpf=doc;
    var _rot=btn.innerHTML;
    btn.disabled=true; btn.textContent='Consultando…';
    _m('Consultando o CPF na base de crédito…','#64748b');
    var _sAntes=saldo;
    var d=await consultarComRetry({produto:'restricao',documento:doc},1);
    btn.disabled=false; btn.innerHTML=_rot;
    if(d&&d.sem_saldo){ setSaldo(d.saldo); _m('Saldo insuficiente para esta consulta.'); abrirPacotes(); return; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(!d||!d.ok){ _m(((d&&d.erro)||'Não consegui consultar agora. Tente de novo em instantes.')+(d&&d.estornado?' ✓ O valor foi devolvido ao seu saldo.':'')); return; }
    _m('');
    _vp.cpf_res=d.resultado; _restState=d.resultado;
    _vpRelRender(d.resultado);
    try{ restHistSalvar({ doc:doc, tipo_doc:(d.resultado&&d.resultado.tipo_doc)||'CPF', ts:Date.now(), resultado:d.resultado, tok:_tokCalc(_sAntes,d.saldo) }); restHistRender(); }catch(_){}
    toast('Relatório do CPF pronto.');
  }
  /* semáforo do comprometimento de renda — a conta que o banco faz primeiro:
     parcela ÷ renda. Até 25% é a faixa tranquila, até 35% ainda passa, acima
     disso o banco costuma pedir entrada maior, prazo maior ou avalista. */
  function _vpSemaforo(){
    var el=$('vpSemaforo'); if(!el||!_vp) return;
    var c=vpCalc(_vp), renda=+_vp.renda||0;
    if(!(c.parcelado&&c.parcela>0&&renda>0)){ el.style.display='none'; return; }
    var pct=c.parcela/renda*100;
    var nv = pct<=25 ? 'ok' : (pct<=35 ? 'mid' : 'bad');
    var tit = nv==='ok' ? 'Alta chance de aprovação' : (nv==='mid' ? 'Aprovação possível' : 'Difícil aprovar');
    var txt = nv==='ok' ? 'A parcela cabe folgada na renda — é a faixa que os bancos mais aprovam.'
        : (nv==='mid' ? 'A parcela está no limite do que o banco costuma aceitar. Uma entrada maior ajuda.'
        : 'A parcela passa de 35% da renda. Aumente a entrada, alongue o prazo ou inclua um avalista.');
    el.style.display='block'; el.className='vpc-sem '+nv;
    el.innerHTML='<div class="vps-top"><i></i><b>'+tit+'</b><em>'+String(Math.round(pct*10)/10).replace('.',',')+'% da renda</em></div>'+
      '<div class="vps-bar"><span style="width:'+Math.min(100,Math.round(pct))+'%"></span></div>'+
      '<div class="vps-txt">Parcela de '+brl(c.parcela)+' sobre renda de '+brl(renda)+'. '+txt+'</div>';
  }
  function _vpIaRender(r){
    var box=$('vpIaBox'); if(!box||!r) return;
    var nv=String(r.nivel||'media').toLowerCase();
    var cl = (nv==='alta') ? 'ok' : ((nv==='baixa') ? 'bad' : 'mid');
    var tit = (nv==='alta') ? 'Alta chance de aprovação' : ((nv==='baixa') ? 'Chance baixa de aprovação' : 'Chance média de aprovação');
    function lista(arr,cls,tt){
      arr=arr||[]; if(!arr.length) return '';
      return '<div class="vpi-bl '+cls+'"><b>'+tt+'</b><ul>'+arr.map(function(x){ return '<li>'+esc(String(x))+'</li>'; }).join('')+'</ul></div>';
    }
    box.style.display='block';
    box.innerHTML='<div class="vpi-hd '+cl+'"><b>'+tit+'</b><i>parecer da IA</i></div>'+
      (r.resumo?('<div class="vpi-res">'+esc(String(r.resumo))+'</div>'):'')+
      lista(r.favoravel,'ok','A favor')+
      lista(r.atencao,'bad','Pontos de atenção')+
      lista(r.sugestoes,'mid','O que fazer pra melhorar')+
      '<div class="vpi-pe">Parecer gerado por IA pra te orientar na conversa. A palavra final é sempre do banco.</div>';
  }
  /* ===== v476 (item 4 do PLANO-analise-de-credito) — A FOTO INTEIRA DA
     ENTRADA. A IA recebia só a entrada EM DINHEIRO (c.entrada): proposta
     com troca e zero de bolso chegava como "sem entrada" — e o parecer
     desaconselhava negócio BOM (43% de entrada no caso real). O erro não
     era da IA — era do dado. Esta função monta os MESMOS números da
     simulação (v371): o usado É entrada. O campo antigo `entrada` segue
     indo junto — app velho e função velha continuam se entendendo. */
  function _vpFotoEntrada(c){
    var temUsado=!!(_vp && _vp.troca && _vp.troca.tem && c.aval>0);
    var apre=(_vp && _vp.apresentacao && typeof _vp.apresentacao==='object')?_vp.apresentacao:{};
    var tab=Number(apre.tabela)||(+(((_vp||{}).veiculo||{}).preco_anuncio)||0);
    var saldo=Math.max(0,c.saldo);
    var avalApr=Math.max(0,Math.round((tab-saldo)*100)/100);
    var temApres=temUsado&&tab>0&&avalApr>0;
    var valor=temApres?tab:c.precoFinal;
    var usado=temApres?avalApr:(temUsado?Math.max(0,c.trocaLiq):0);
    var total=usado+(+c.entrada||0);
    return {
      valor_veiculo: Math.round(valor||0),
      entrada_usado: Math.round(usado||0),
      entrada_dinheiro: Math.round(+c.entrada||0),
      entrada_total: Math.round(total||0),
      entrada_pct: (valor>0)?Math.round(total/valor*1000)/10:0,
      troca_veiculo: temUsado?String(((_vp.troca||{}).modelo||(_vp.troca||{}).placa||'')).slice(0,60):''
    };
  }
  async function vpParecerIA(btn){
    if(!_vp) return; vpLe();
    var c=vpCalc(_vp), box=$('vpIaBox');
    if(!(c.parcelado&&c.parcela>0)){ toast('Escolha "Entrada + até 60x" e preencha as parcelas primeiro.'); return; }
    var _rot=btn.innerHTML;
    /* v476 (item 2): o rótulo muda SEM apagar o ícone (textContent apagava a
       estrelinha) e a espera usa o MESMO anel do app (ccLoader, padrão v370
       do comparativo) — 20-30s de tela parada parecia travamento. */
    btn.disabled=true; btn.innerHTML=_rot.replace('Analisar aprovação com a IA · '+precoReal(1),'Analisando…');
    var _iaTimer=null;
    var _iaFrases=['🔎 Lendo a proposta: valor, entrada e prazo…','📊 Medindo o peso da parcela na renda…','🛡️ Conferindo o que veio da consulta de CPF…','🏦 Comparando com o que os bancos costumam aprovar…','✅ Escrevendo o parecer pro vendedor…'];
    if(box){ box.style.display='block';
      try{ box.innerHTML=ccLoaderHtml('Analisando a aprovação…', _iaFrases); _iaTimer=ccLoaderStart(_iaFrases); }
      catch(_){ box.innerHTML='<div class="vpi-load">A IA está analisando o perfil do cliente…</div>'; }
    }
    var d=null;
    try{
      d=await apiComTimeout('/api/venda-ia',{ tipo:'credito', dados: Object.assign({
        parcela:Math.round(c.parcela), renda:Math.round(+_vp.renda||0), entrada:Math.round(c.entrada),
        prazo:c.n, financiado:Math.round(c.financiado), saldo:Math.round(Math.max(0,c.saldo)),
        veiculo:(_vp.veiculo?_vpVeicNome(_vp.veiculo):''), cpf_relatorio:(_vp.cpf_res||null) },
        _vpFotoEntrada(c)) }, 32000);   /* v476 (item 4): a entrada INTEIRA vai junto */
    }catch(_){ d=null; }
    /* o timer das frases PARA aqui — deu certo, deu erro ou faltou saldo,
       todos os caminhos passam por este ponto (lição da v370). */
    if(_iaTimer){ try{ clearInterval(_iaTimer); }catch(_){} _iaTimer=null; }
    btn.disabled=false; btn.innerHTML=_rot;
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(d&&d.sem_saldo){ if(box) box.innerHTML='<div class="vpi-load" style="color:#b91c1c">'+esc(d.erro||'Saldo insuficiente.')+'</div>'; abrirPacotes(); return; }
    if(!d||!d.ok){ if(box) box.innerHTML='<div class="vpi-load" style="color:#b91c1c">'+esc((d&&d.erro)||'Não consegui gerar o parecer agora. Tente de novo em instantes.')+'</div>'; return; }
    _vp.credito=d; _vpIaRender(d);
    try{ _vpCredEstado(); }catch(_){}
  }
  function vpAtualiza(){ vpLe(); var el=$('vpTotais'); if(el) el.innerHTML=vpTotaisHtml(); _vpNegocRefresh(); }
  var _vpCustoAberto=false;
  var _vpCredAberto=null;   /* v476: null = decidir no primeiro desenho */
  /* v476 (item 3) — o resumo na barra: dá pra saber se precisa abrir sem abrir */
  function _vpCredEstado(){
    var el=$('vpCredEstado'); if(!el||!_vp) return;
    var t='—';
    if(_vp.credito&&_vp.credito.nivel){
      var nv=String(_vp.credito.nivel).toLowerCase();
      t=(nv==='alta')?'chance alta':((nv==='baixa')?'chance baixa':'chance média');
    } else if(_vp.cpf_res){ t='CPF consultado'; }
    el.textContent=t;
  }
  function _vpNegocRefresh(){
    if(!_vp) return; var c=vpCalc(_vp);
    /* v157: valor total embaixo da transferência */
    var tvb=$('vpTotVal'); if(tvb) tvb.textContent=c.precoFinal?brl(c.precoFinal):'—';
    var tsb=$('vpTotSub'); if(tsb){
      var pd=[]; if(+_vp.desconto>0) pd.push('− desconto '+brl(+_vp.desconto)); if(+_vp.acrescimo>0) pd.push('+ acréscimo '+brl(+_vp.acrescimo));
      if(c.cort>0) pd.push('+ cortesia '+brl(c.cort)+(_vp.cortesia_desc?(' ('+_vp.cortesia_desc+')'):''));
      tsb.textContent=pd.length?pd.join(' · '):'';
    }
    /* v180: valores REAIS da negociação (usado + saldo) e o bloco do cliente */
    var _temUsado=!!(_vp.troca&&_vp.troca.tem&&c.aval>0);
    var _saldo=Math.max(0,c.saldo);
    var _ur=$('vpUsadoRow'); if(_ur){ _ur.style.display=_temUsado?'flex':'none';
      var _uv=$('vpUsadoVal'); if(_uv) _uv.textContent=brl(c.trocaLiq);          /* v189: já com a quitação abatida */
      var _us=$('vpUsadoSub'); if(_us) _us.textContent=(c.quit>0)?('avaliação '+brl(c.aval)+' − quitação '+brl(c.quit)):'';
    }
    /* v370: o saldo virou CAMPO — só repinto quando não é ele que está sendo
       digitado, senão o texto pularia embaixo do dedo. */
    var _sr=$('vpSaldoRow'); if(_sr){ _sr.style.display=_temUsado?'flex':'none';
      var _sv=$('vpSaldoVal');
      if(_sv){ if(_sv.tagName==='INPUT'){ if(document.activeElement!==_sv) _sv.value=_rs(Math.round(_saldo)); } else _sv.textContent=brl(_saldo); } }
    if(!_vp.apresentacao || typeof _vp.apresentacao!=='object') _vp.apresentacao={};
    var _tabPadrao=+((_vp.veiculo&&_vp.veiculo.preco_anuncio)||0);
    var _tab=Number(_vp.apresentacao.tabela)||_tabPadrao;
    /* ===== v370 (pedido) — O SALDO APRESENTADO É O SALDO REAL =================
       O cliente pode ver um preço de tabela cheio e uma avaliação "esticada",
       mas o que ele PAGA tem que ser exatamente o mesmo dos dois lados. Então
       a conta aqui tem uma única direção:

           avaliação apresentada = preço de tabela − saldo real
           saldo apresentado     = saldo real   (por definição)

       Antes a avaliação era um valor GUARDADO. Quando ela era gravada num
       momento em que a troca ainda estava zerada (avaliação = 0), congelava em
       "tabela − preço de venda" e o saldo do cliente passava a não bater com o
       da negociação — foi o que apareceu na tela: real R$ 83.611 e apresentado
       R$ 128.610,96. Agora ela é sempre recalculada e não tem como desandar.

       A tabela nunca pode ficar ABAIXO do saldo real, senão a avaliação
       apresentada ficaria negativa. ====================================== */
    if(_tab<_saldo) _tab=_saldo;
    /* ===== v485 — o campo da linha repinta junto (nunca embaixo do dedo) ===
       e ganha o "voltar ao preço do anúncio" quando o digitado divergiu do
       estoque, mais o aviso cinza quando a tabela ficou abaixo do preço de
       venda (quase sempre é engano de digitação — avisa, não bloqueia). */
    var _tbEl=$('vpTabela'); if(_tbEl && document.activeElement!==_tbEl) _tbEl.value=_tab?_rs(Math.round(_tab)):'';
    var _tbVolta=$('vpTabVolta');
    if(_tbVolta){
      var _dif=(_tabPadrao>0) && Number(_vp.apresentacao.tabela) && Math.round(_tab)!==Math.round(_tabPadrao);
      _tbVolta.style.display=_dif?'inline':'none';
      if(_dif) _tbVolta.textContent='voltar ao preço do anúncio ('+brl(_tabPadrao)+')';
    }
    var _tbAv=$('vpTabAviso');
    if(_tbAv){ var _pvd=estRS('vpPreco')||0; _tbAv.style.display=(_tab>0 && _pvd>0 && _tab<_pvd)?'inline':'none'; }
    var _avalApr=Math.max(0,Math.round((_tab-_saldo)*100)/100);
    var _saldoApr=_saldo;
    _vp.apresentacao.avaliacao=_avalApr;   /* guardado só pro resumo/PDF */
    var _ab=$('vpApresBox');
    if(_ab){
      var _mostra=_temUsado&&_tab>0&&_avalApr>0;
      _ab.style.display=_mostra?'block':'none';
      if(_mostra){
        var _e1=$('vpApresTabInput'); if(_e1&&document.activeElement!==_e1) _e1.value=_rs(_tab);
        var _e2=$('vpApresAvalInput'); if(_e2&&document.activeElement!==_e2) _e2.value=_rs(_avalApr);
        var _e3=$('vpApresSaldo'); if(_e3) _e3.textContent=brl(_saldoApr);
      }
    }
    /* v370 (pedido): valor da transferência apagado enquanto não estiver marcada */
    var _tr=$('vpTransfRow'); if(_tr) _tr.classList.toggle('off', !_vp.transf_inclui);
    var cdb=$('vpCortDescBox'); if(cdb) cdb.style.display=(c.cort>0)?'block':'none';
    try{ _vpSemaforo(); }catch(_){}
    try{ _vpCredEstado(); }catch(_){}   /* v476 */
    /* v371 — números que vão pra simulação, na visão do cliente */
    var _temApres=_temUsado&&_tab>0&&_avalApr>0;
    var _fValor=_temApres?_tab:c.precoFinal;
    var _fUsado=_temApres?_avalApr:0;
    var _fEntrada=_fUsado+c.entrada;
    var pv=$('vpParcPrev'); if(pv){
      if(c.parcelado&&c.parcela>0){
        pv.style.display='block';
        pv.innerHTML=
          /* ===== v371 (pedido) — A SIMULAÇÃO FALA A LÍNGUA DO CLIENTE ========
             O banco enxerga assim: valor do veículo, entrada, e o que sobra
             pra financiar. E, pro cliente, O USADO É ENTRADA.

             Então aqui o financiamento é montado sobre os VALORES
             APRESENTADOS: preço de tabela apresentado, e entrada = avaliação
             apresentada do usado + entrada em dinheiro.

             A conta NÃO muda: por construção a avaliação apresentada é
             "tabela − saldo real", então tabela − (avaliação + dinheiro) dá
             exatamente a mesma base a financiar de antes. O que muda é o que
             está escrito na tela — e é isso que o vendedor mostra. */
          '<div class="vpf-hd"><span>Simulação do financiamento</span><i>'+c.n+'x</i></div>'+
          '<div class="vpf-parc"><span>Parcela</span><b>'+brl(c.parcela)+'</b></div>'+
          '<div class="vpf-g">'+
            '<div class="vpf-i"><span>Valor do veículo</span><b>'+brl(_fValor)+'</b></div>'+
            '<div class="vpf-i"><span>Entrada'+(_fUsado>0?'<i class="vpf-sub">usado '+brl(_fUsado)+(c.entrada>0?(' + dinheiro '+brl(c.entrada)):'')+'</i>':'')+'</span><b>'+brl(_fEntrada)+'</b></div>'+
            '<div class="vpf-i"><span>Base a financiar</span><b>'+brl(c.base)+'</b></div>'+
            '<div class="vpf-i hi"><span>Saldo financiado</span><b>'+brl(c.financiado)+'</b></div>'+
          '</div>'+
          '<div class="vpf-det">TAC '+brl(c.TAC)+' &middot; IOF '+brl(c.IOF)+' &middot; Retorno '+brl(c.RET)+' &middot; Juros '+String(+_vp.pag.juros||0).replace('.',',')+'% a.m.</div>'+
          '<div class="vpf-tot"><span>Total pago (entrada + '+c.n+' parcelas)</span><b>'+brl(c.totalParc)+'</b></div>';
          /* v476 (item 1): a nota "montado sobre os valores apresentados…"
             saiu — o quadro se explica sozinho desde a v371. */
      } else pv.style.display='none';
    }
    var cu=_vpCustoCalc(c), ct=$('vpCustoTotal'), mb=$('vpMargemBox');
    if(ct) ct.textContent=cu?brl(cu.total):'—';
    var det=$('vpCustoDet');
    /* v157: mostra EXATAMENTE os custos digitados no cadastro do veículo, linha por linha */
    if(det&&cu){ det.innerHTML='<div class="r"><span>Compra (o que paguei)</span><b>'+brl(cu.compra)+'</b></div>'+
      (cu.com?('<div class="r"><span>Comissão'+(cu.com_pct?(' ('+String(cu.com_pct).replace('.',',')+'%)'):'')+'</span><b>'+brl(cu.com)+'</b></div>'):'')+
      (cu.itens||[]).map(function(it){ return '<div class="r"><span>'+esc(it.nome)+'</span><b>'+brl(it.val)+'</b></div>'; }).join('')+
      (cu.nf?('<div class="r"><span>Imposto NF'+(cu.nf_pct?(' ('+String(cu.nf_pct).replace('.',',')+'%)'):'')+'</span><b>'+brl(cu.nf)+'</b></div>'):'')+
      '<div class="r tot"><span>Custo total</span><b>'+brl(cu.total)+'</b></div>'+
      '<div class="vcd-nota">Mesmos valores da aba <b>Custos</b> do veículo. Transferência e cortesia não entram aqui (são repasse).</div>'; }
    if(mb){ if(cu&&c.precoFinal){ mb.style.display='flex'; mb.classList.toggle('neg',cu.margem<0); var mv=$('vpMargemVal'); if(mv) mv.textContent=(cu.margem<0?'−':'')+'R$ '+Math.abs(Math.round(cu.margem)).toLocaleString('pt-BR'); var mp=$('vpMargemPct'); if(mp) mp.textContent=(cu.pct>=0?'+':'')+cu.pct+'%'; } else mb.style.display='none'; }
  }
  function vpTotaisHtml(){
    var c=vpCalc(_vp), p=_vp; var linhas='';
    linhas+='<div class="row"><span>Preço do veículo</span><b>'+brl(c.precoFinal)+'</b></div>';
    if(p.troca && p.troca.tem && c.aval>0){
      if(c.quit>0){
        linhas+='<div class="row"><span>Avaliação do seu usado</span><b>'+brl(c.aval)+'</b></div>';
        linhas+='<div class="row quit"><span>(−) Quitação do financiamento</span><b>'+brl(c.quit)+'</b></div>';
        linhas+='<div class="row neg"><span>− Seu usado na negociação</span><b>'+brl(c.trocaLiq)+'</b></div>';
      } else {
        linhas+='<div class="row neg"><span>− Avaliação do usado</span><b>'+brl(c.aval)+'</b></div>';
      }
    }
    var bloco;
    if(c.saldo<0){ bloco='<div class="row big volta"><span>Volta pro cliente</span><b>'+brl(-c.saldo)+'</b></div>'; }
    else { bloco='<div class="row big"><span>Saldo a pagar</span><b>'+brl(c.saldo)+'</b></div>'; }
    var parc='';
    if(c.parcelado){ parc='<div class="vp-parc"><div class="row" style="border:none;padding:0"><span>Entrada</span><b>'+brl(c.entrada)+'</b></div><div class="row" style="border:none;padding:6px 0 0"><span>'+c.n+'x de</span><span class="p">'+brl(c.parcela)+'</span></div></div>'; }
    else if(c.saldo>0 && c.entrada>0){ parc='<div class="vp-parc"><div class="row" style="border:none;padding:0"><span>Entrada</span><b>'+brl(c.entrada)+'</b></div><div class="row" style="border:none;padding:6px 0 0"><span>Restante à vista</span><b>'+brl(Math.max(0,c.saldo-c.entrada))+'</b></div></div>'; }
    var det='';
    if(c.parcelado){
      det='<div class="vp-det"><div class="tit">Detalhe do vendedor (não mostrar pro cliente)</div>'+
        (_vp.veiculo&&_vp.veiculo.preco_minimo?'<div class="r"><span>Preço mínimo</span><b>'+brl(_vp.veiculo.preco_minimo)+'</b></div>':'')+
        '<div class="r"><span>Base a financiar</span><b>'+brl(c.base)+'</b></div>'+
        '<div class="r"><span>TAC ('+(p.pag.pessoa==='PJ'?'CNPJ':'CPF')+')</span><b>'+brl(c.TAC)+'</b></div>'+
        '<div class="r"><span>IOF (4%)</span><b>'+brl(c.IOF)+'</b></div>'+
        '<div class="r"><span>RET ('+(+p.pag.ret||0)+'%)</span><b>'+brl(c.RET)+'</b></div>'+
        '<div class="r"><span>Total financiado</span><b>'+brl(c.financiado)+'</b></div>'+
        (c.cort>0?'<div class="r"><span>Cortesias (repasse)</span><b>'+brl(c.cort)+'</b></div>':'')+
        '</div>';
    }
    return '<section class="vp-summary-card"><div class="vp-summary-head"><span>Resumo da proposta</span><i>valores da negociação</i></div><div class="vp-tot">'+linhas+bloco+parc+'</div></section>'+det;
  }
  function _vpPrecoMinGuard(){
    var pe=$('vpPreco'); if(!pe) return;
    var min=estRS('vpMin')||0, val=estRS('vpPreco')||0, w=$('vpMinWarn');
    if(min>0 && val>0 && val<min){
      pe.value=_rsF(min);
      if(w){ w.style.display='block'; w.textContent='O pre\u00e7o de venda n\u00e3o pode ficar abaixo do pre\u00e7o m\u00ednimo ('+brl(min)+'). Ajustei pro m\u00ednimo.'; }
      vpAtualiza();
      return;
    }
    if(w) w.style.display='none';
  }
  function vpWire(){
    var reRender=function(){ vpLe(); _vpRenderTudo(); };
    Array.prototype.forEach.call(document.querySelectorAll('#vpSteps .vpx-st'),function(b){ b.onclick=function(){ vpLe(); _vpStep=b.getAttribute('data-step'); _vpStepAplica(); vpAtualiza(); try{ $('vpForm').scrollIntoView({block:'start'}); }catch(_){} }; });
    var cn=$('vpNovoCli'); if(cn) cn.onclick=function(){ cliAbrirFicha(null); };
    var es=$('vpEscolher'); if(es) es.onclick=vpPickVeiculo;
    /* v192 — o card do veiculo virou o botao de ABRIR A PAGINA do carro
       (aquela que o cliente ve'). A palavrinha "trocar", dentro do card,
       continua trocando o veiculo: ela cancela o clique do card com
       stopPropagation pra que os dois nao disparem juntos.
       Se o carro nao estiver no estoque (venda de veiculo de fora), nao ha'
       pagina pra abrir — ai' o card volta a servir pra escolher o veiculo. */
    var vv=$('vpVerVeic');
    if(vv) vv.onclick=function(){
      var est=_vpEstAtual(_vp&&_vp.veiculo);
      if(est&&est.id){ _publicoAbrir(_publicoVeiculoUrl(est)); }
      else vpPickVeiculo();
    };
    var tv=$('vpTrocarVeic'); if(tv) tv.onclick=function(ev){ try{ ev.stopPropagation(); ev.preventDefault(); }catch(_){} vpPickVeiculo(); };
    var vpp=$('vpVerPag'); if(vpp) vpp.onclick=function(){
      var est=_vpEstAtual(_vp&&_vp.veiculo);
      if(!est||!est.id){ toast('Esse ve\u00edculo ainda n\u00e3o est\u00e1 no estoque \u2014 salve a ficha primeiro.'); return; }
      _publicoAbrir(_publicoVeiculoUrl(est));
    };
    ['vpPreco','vpMin','vpDesc','vpAcr','vpCort','vpFipe','vpAval','vpQuit','vpEntrada','vpRenda','vpApresTabInput'].forEach(function(id){ var e=$(id); if(e) e.oninput=function(){ estMaskRS.call(this); vpAtualiza(); if(id==='vpAval'||id==='vpFipe'||id==='vpQuit') _vpTrocaBtnEstado(); }; });
    /* ===== v370 — SALDO A PAGAR EDITÁVEL ====================================
       A conta normal é: saldo = preço de venda − desconto + acréscimo +
       transferência + cortesia − avaliação + quitação. Aqui ela roda AO
       CONTRÁRIO: você diz o saldo e eu descubro qual preço de venda produz
       exatamente esse saldo. Mexe só no preço de venda — nunca no desconto,
       na avaliação nem na quitação, que são números que o vendedor digitou. */
    var _sve=$('vpSaldoVal');
    if(_sve && _sve.tagName==='INPUT') _sve.oninput=function(){
      estMaskRS.call(this); vpLe();
      var novo=estRS('vpSaldoVal')||0, p=_vp;
      var transf=(p.transf_inclui?(+p.transf_valor||0):0), cort=(+p.cortesias||0);
      var tem=!!(p.troca&&p.troca.tem);
      var aval=tem?(+p.troca.avaliacao||0):0, quit=tem?(+p.troca.quitacao||0):0;
      var pv=novo+aval-quit-transf-cort+(+p.desconto||0)-(+p.acrescimo||0);
      p.precoVenda=Math.max(0,Math.round(pv));
      var pe=$('vpPreco'); if(pe && document.activeElement!==pe) pe.value=_rs(p.precoVenda);
      _vpNegocRefresh(); try{ _vpPrecoMinGuard(); }catch(_){}
    };
    /* v370 — editar a AVALIAÇÃO APRESENTADA move o PREÇO DE TABELA apresentado
       (e não o saldo): tabela = avaliação apresentada + saldo real. */
    /* ===== v485 — o fio do campo do preço de tabela =======================
       Fio PRÓPRIO (padrão do vpApresAvalInput/v370) em vez da lista
       genérica da linha 322: aquela chama vpAtualiza(), e o vpLe() só lê
       o campo quando ele é o ativo — aqui a gravação é direta na fonte. */
    var _tbi=$('vpTabela');
    if(_tbi) _tbi.oninput=function(){
      estMaskRS.call(this);
      if(!_vp.apresentacao || typeof _vp.apresentacao!=='object') _vp.apresentacao={};
      _vp.apresentacao.tabela=estRS('vpTabela')||0;
      _vpNegocRefresh();
    };
    var _tbv=$('vpTabVolta');
    if(_tbv) _tbv.onclick=function(){
      if(_vp.apresentacao) _vp.apresentacao.tabela=0;   /* zera = volta a seguir o estoque */
      var e0=$('vpTabela'); if(e0) e0.value='';
      _vpNegocRefresh();
      toast('De volta ao preço do anúncio.');
    };
    var _apa=$('vpApresAvalInput');
    if(_apa) _apa.oninput=function(){
      estMaskRS.call(this); vpLe();
      var c2=vpCalc(_vp), sd=Math.max(0,c2.saldo);
      var av=estRS('vpApresAvalInput')||0;
      if(!_vp.apresentacao || typeof _vp.apresentacao!=='object') _vp.apresentacao={};
      _vp.apresentacao.tabela=Math.round(av+sd);
      _vpNegocRefresh();
    };
    /* v180: o pre\u00e7o de venda n\u00e3o pode ficar abaixo do pre\u00e7o m\u00ednimo.
       A confer\u00eancia s\u00f3 acontece quando o vendedor SAI do campo \u2014 se fosse a
       cada tecla, ela brigaria com a digita\u00e7\u00e3o (R$ 1 j\u00e1 seria "abaixo"). */
    ['vpPreco','vpMin'].forEach(function(id){ var e=$(id); if(e){ e.onblur=_vpPrecoMinGuard; e.onchange=_vpPrecoMinGuard; } });
    ['vpParcelas','vpJuros','vpRet'].forEach(function(id){ var e=$(id); if(e) e.oninput=function(){
      if(id==='vpParcelas') this.value=this.value.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,3);
      else this.value=this.value.replace(/[^0-9.,]/g,'').slice(0,6);
      /* v371: digitou no campo Juros = taxa da mão do vendedor. A partir daqui
         o app não escreve mais nada ali. */
      if(id==='vpJuros' && _vp && _vp.pag) _vp.pag.juros_manual=true;
      /* v371: mudou o prazo e a taxa ainda é a da tabela? troca sozinha
         (até 48x 2,09% · de 49x a 60x 2,19%) ANTES de recalcular. */
      if(id==='vpParcelas' && _vp && _vp.pag && !_vp.pag.juros_manual){
        var _n=Math.min(60, parseInt(this.value,10)||48);
        var _j=_vpJurosPadrao(_n);
        _vp.pag.juros=_j;
        var _je=$('vpJuros'); if(_je && document.activeElement!==_je) _je.value=String(_j).replace('.',',');
      }
      vpAtualiza(); }; });
    /* v157: CLIENTE — vai digitando e ele filtra os já cadastrados.
       ===== v484 (Parte B do plano da carteira) ============================
       - campo VAZIO → os ÚLTIMOS ATENDIDOS (atualizado_em, 5) — a lista
         abria no alfabeto e mostrava os 8 com MENOS chance de serem o
         cliente da venda de agora;
       - digitou → filtra nome/telefone/CPF no conjunto inteiro (até 7);
       - "+ Cadastrar novo" SEMPRE no fim da lista; com texto digitado vira
         "+ Cadastrar «MARIA»" e leva o nome pro campo — não se digita duas
         vezes. (Com a carteira nova, cadastrar vira o caminho NORMAL do
         vendedor — a lista dele começa vazia.)
       ⚠️ O filtro mora AQUI NA FONTE (com semFiltro ligado): o _acWire é
       compartilhado com o combo de placas e NÃO mudou uma linha. */
    _acWire('vpCliAc',function(){
      var dig=String((($('vpCliAc')||{}).value)||'').trim();
      var q=_acNorm(dig);
      var todos=(_clientes||[]).map(function(c){
        var tel=foneFmt(c.telefone||'');
        return { id:c.id, txt:(c.nome||'Cliente'), sub:[tel,(c.cpf||'')].filter(Boolean).join(' · '), busca:(c.nome||'')+' '+(c.telefone||'')+' '+(c.cpf||''), rec:c,
                 _ts:(Date.parse(c.atualizado_em||c.criado_em||'')||0) };
      });
      var itens = q
        ? todos.filter(function(o){ return _acNorm(o.busca).indexOf(q)>=0; }).slice(0,7)
        : todos.slice().sort(function(a,b){ return b._ts-a._ts; }).slice(0,5);
      itens.push({ novo:true, txt:(dig?('+ Cadastrar «'+dig+'»'):'+ Cadastrar novo'), sub:'', busca:'' });
      return itens;
    },function(it){
      if(it && it.novo){
        /* cliente novo sem sair da tela: o nome digitado vai pro campo */
        var dig2=String((($('vpCliAc')||{}).value)||'').trim();
        var h1=$('vpCliente'); if(h1) h1.value='';
        var cn1=$('vpCliNome'); if(cn1){ cn1.value=dig2; try{ cn1.focus(); }catch(_){} }
        var ct1=$('vpCliTel'); if(ct1 && !dig2) try{ ct1.value=''; }catch(_){}
        vpAtualiza();
        return;
      }
      var h=$('vpCliente'); if(h) h.value=it.id||'';
      var ac=$('vpCliAc'); if(ac) ac.value=it.txt||'';
      var cn0=$('vpCliNome'); if(cn0) cn0.value=(it.rec&&it.rec.nome)||'';
      var ct0=$('vpCliTel'); if(ct0) ct0.value=foneFmt((it.rec&&it.rec.telefone)||'');
      vpAtualiza();
    }, true);
    var acc=$('vpCliAc'); if(acc) acc.addEventListener('input',function(){
      /* mudou o texto à mão: solta o cliente escolhido até tocar num da lista */
      var h=$('vpCliente'); if(!h||!h.value) return;
      var c0=(_clientes||[]).filter(function(x){return String(x.id)===String(h.value);})[0];
      if(!c0 || _acNorm(c0.nome||'')!==_acNorm(acc.value)){ h.value=''; vpAtualiza(); }
    });
    var gtr=$('vpgTr'); if(gtr){
      fotosGaleriaPreparar(gtr,0);
      /* v171 — tocar na foto abre em tela cheia, com as setas pra passar.
         Guardo onde o dedo comecou: se o vendedor ARRASTOU (pra trocar de
         foto no carrossel), isso nao conta como toque e a tela nao abre. */
      (function(){
        var x0=0,y0=0,arrastou=false;
        gtr.addEventListener('touchstart',function(e){ var t=e.touches&&e.touches[0]; if(t){x0=t.clientX;y0=t.clientY;arrastou=false;} },{passive:true});
        gtr.addEventListener('touchmove',function(e){ var t=e.touches&&e.touches[0]; if(t&&(Math.abs(t.clientX-x0)>8||Math.abs(t.clientY-y0)>8)) arrastou=true; },{passive:true});
        Array.prototype.forEach.call(gtr.querySelectorAll('img.clic'),function(im){
          im.onclick=function(){ if(arrastou){ arrastou=false; return; }
            var i=parseInt(im.getAttribute('data-i'),10)||0;
            fotosVerAbrir(_vpGalFotos, i, {editar:false});
          };
        });
      })();
      gtr.addEventListener('scroll',function(){ requestAnimationFrame(function(){ var i=Math.round(gtr.scrollLeft/Math.max(1,gtr.clientWidth)); fotosGaleriaPreparar(gtr,i); var ds=gtr.parentNode.querySelectorAll('.vpg-dots i'); Array.prototype.forEach.call(ds,function(d,j){ d.classList.toggle('on',j===i); }); var cgt=$('vpgCnt'); if(cgt&&ds.length) cgt.textContent=(i+1)+'/'+ds.length; }); }); }
    var cn=$('vpCliNome'); if(cn) cn.oninput=vpAtualiza;
    var ctel=$('vpCliTel'); if(ctel){ if(ctel.value) ctel.value=foneFmt(ctel.value); ctel.oninput=function(){ this.value=foneFmt(this.value); vpAtualiza(); clearTimeout(_vpTelTimer); _vpTelTimer=setTimeout(_vpTelSync,1400); }; }
    var tmod=$('vpTrocaModelo'); if(tmod) tmod.oninput=function(){ _vpComparacaoLimpar(); vpAtualiza(); _vpTrocaBtnEstado(); };
    var tkm=$('vpTrocaKm'); if(tkm) tkm.oninput=function(){
      var d=String(this.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').slice(0,8);
      this.value=d?Number(d).toLocaleString('pt-BR'):'';
      _vpComparacaoLimpar(); vpAtualiza();
    };
    var tcf=document.querySelector('[data-tela="vp_troca_ficha"]'); if(tcf) tcf.onclick=function(){ _vpTrocaConsultaAbrir('ficha'); };
    /* v444: as ligações de vp_troca_multa e vp_troca_leilao saíram daqui —
       os dois cartões não existem mais na aba Troca. Quem liga os
       equivalentes na venda fechada é o _vfDocsWire (17-vendas.js), e
       chamando exatamente esta mesma _vpTrocaConsultaAbrir. */
    var tcc=document.querySelector('[data-tela="vp_troca_comparar"]'); if(tcc) tcc.onclick=function(){ _vpComparar(this); };
    _vpComparacaoWire();
    /* v190: o usado da troca SÓ entra no estoque quando o vendedor clicar aqui. */
    var tbe=$('vpTrocaEst'); if(tbe) tbe.onclick=function(){ _vpTrocaSync(true); };
    _vpTrocaBtnEstado();
    /* v370 — abrindo uma venda que já tem placa do usado, mostro na hora o que
       já existe dessa placa (e carrego o mapa de valores avaliados da nuvem). */
    try{ if(typeof avValoresCarregar==='function') avValoresCarregar(); }catch(_){}
    try{ _vpTrocaAproveitar(); }catch(_){}
    /* 🔴 v882 — a trava da placa também aqui. É a MESMA `placaLigar()` do
       01-nucleo que roda no campo da home, na confirmação da foto, na
       avaliação, no funil e no pós-venda. Seis telas, uma regra.
       ⚠️ Ela vem ANTES do `_acWire` de propósito: o autocompletar escreve no
       campo com `el.value=`, sem disparar 'input' — e a trava tem um ouvinte
       de foco que se re-sincroniza justamente por causa disso. */
    try{ placaLigar($('vpTrocaPlaca')); }catch(_){}
    /* v157: PLACA DA TROCA — sugere as placas que já estão na base; só consulta se for nova */
    _acWire('vpTrocaPlaca',_vpPlacaBase,function(it){
      var el=$('vpTrocaPlaca'); if(el) el.value=it.placa;
      _vpTrocaAuto=it.placa;                       /* já preenchido: não dispara consulta */
      var vv=it.v||{};
      _vp.troca.dados=vv;
      if(vv.km){ _vp.troca.km=Number(vv.km)||0; var ki=$('vpTrocaKm'); if(ki) ki.value=Number(vv.km).toLocaleString('pt-BR'); }
      _vpComparacaoLimpar();
      var tm=$('vpTrocaModelo'); if(tm) tm.value=_vpModeloAno(vv.marca||'', it.modelo||vv.modelo||'', vv.ano||'', vv.ano_modelo||'');
      var fp=$('vpFipe'); if(fp&&vv.fipe) fp.value=_rs(vv.fipe);
      /* v160: sem o avisinho "Peguei do seu histórico" — o campo já preenche sozinho */
      var m=$('vpTrocaMsg'); if(m){ m.className='cad-msg'; m.textContent=''; }
      vpAtualiza(); try{ _vpTrocaBtnEstado(); }catch(_){}
      try{ _vpTrocaAproveitar(it.placa); }catch(_){}   /* v370 */
    });
    var tp=$('vpTrocaPlaca'); if(tp){ tp.oninput=function(){
      var antes=limpa(String((_vp.troca&&_vp.troca.placa)||''));
      this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);
      var agora=limpa(this.value);
      if(agora!==antes){ _vp.troca.dados=null; _vpComparacaoLimpar(); }
      vpAtualiza();
      var pl=agora;
      if(valida(pl) && pl!==_vpTrocaAuto){ _vpTrocaAuto=pl; vpTrocaBuscar(); }
      else if(!valida(pl)){ _vpTrocaAuto=''; try{ _vpAvalBoxPinta(null); }catch(_){} }
    }; }
    var cb=$('vpCustoBar'); if(cb) cb.onclick=function(){ _vpCustoAberto=!_vpCustoAberto; var d=$('vpCustoDet'); if(d) d.style.display=_vpCustoAberto?'block':'none'; var st=$('vpCustoSeta'); if(st) st.textContent=_vpCustoAberto?'▾':'▸'; };
    /* v476 (item 3) — a análise de crédito virou card recolhido (o mesmo
       mecanismo do vpCustoBar da v370). Abre sozinha quando JÁ está em uso
       (CPF consultado ou parecer gerado); o conteúdo continua no DOM mesmo
       fechado — _vpSemaforo e _vpNegocRefresh escrevem dentro dele. */
    var crb=$('vpCredBar');
    if(crb){
      if(_vpCredAberto==null) _vpCredAberto=!!(_vp&&(_vp.cpf_res||_vp.credito));
      var _cdd=$('vpCredDet'); if(_cdd) _cdd.style.display=_vpCredAberto?'block':'none';
      var _cds=$('vpCredSeta'); if(_cds) _cds.textContent=_vpCredAberto?'▾':'▸';
      crb.onclick=function(){ _vpCredAberto=!_vpCredAberto; var d2=$('vpCredDet'); if(d2) d2.style.display=_vpCredAberto?'block':'none'; var st2=$('vpCredSeta'); if(st2) st2.textContent=_vpCredAberto?'▾':'▸'; };
      try{ _vpCredEstado(); }catch(_){}
    }
    var tch=$('vpTransfChk'); if(tch) tch.onchange=vpAtualiza;
    var tvl=$('vpTransfVal'); if(tvl) tvl.oninput=function(){ estMaskRS.call(this); vpAtualiza(); };
    var cds=$('vpCortDesc'); if(cds) cds.oninput=function(){ vpAtualiza(); };
    var av=$('vpAvista'); if(av) av.onclick=function(){ vpLe(); _vp.pag.tipo='avista'; _vpRenderTudo(); };
    var pc=$('vpParcel'); if(pc) pc.onclick=function(){ vpLe(); _vp.pag.tipo='parcelado'; _vpRenderTudo(); };
    var pf=$('vpPF'); if(pf) pf.onclick=function(){ vpLe(); _vp.pag.pessoa='PF'; _vpRenderTudo(); };
    var pjb=$('vpPJ'); if(pjb) pjb.onclick=function(){ vpLe(); _vp.pag.pessoa='PJ'; _vpRenderTudo(); };
    /* v189: o CPF agora e' consultado DENTRO da venda, com o mesmo relatorio da pagina Consulta CPF */
    var cpfI=$('vpCpfNum');
    if(cpfI){
      cpfI.oninput=function(){ this.value=_fmtCpf(this.value); };
      if(!String(cpfI.value||'').trim()){
        var _cli=(_clientes||[]).filter(function(x){ return String(x.id)===String(_vp.cliente_id); })[0];
        if(_cli&&_cli.cpf) cpfI.value=_fmtCpf(_cli.cpf);
      }
    }
    var cpfB=$('vpCpf'); if(cpfB) cpfB.onclick=function(){ vpCpfConsultar(this); };
    var lgb=$('vpLgpd'); if(lgb) lgb.onchange=function(){ try{ localStorage.setItem('mev_lgpd_cpf', this.checked?'1':'0'); }catch(_){} };
    var pcb=$('vpParecer'); if(pcb) pcb.onclick=function(){ vpParecerIA(this); };
    /* se a cotacao ja tinha relatorio/parecer salvos, redesenha ao abrir */
    if(_vp.cpf_res) try{ _vpRelRender(_vp.cpf_res); }catch(_){}
    /* v441 (pedido): com o botão escondido, o parecer da IA também não volta
       a aparecer em cotação antiga que já tinha um salvo — senão sobraria um
       card de um recurso que não existe mais na tela. O dado continua salvo
       no banco; é só a pintura que está desligada. Pra voltar: VP_IA_ON=true. */
    if(VP_IA_ON && _vp.credito) try{ _vpIaRender(_vp.credito); }catch(_){}
    var rs=$('vpResSimples'); if(rs) rs.onclick=function(){ vpLe(); vpCompartilhar(vpResumo(false)); };
    var pp=$('vpPdfProp'); if(pp) pp.onclick=function(){ vpPdf(false); };
    var fv=$('vpFecharVenda'); if(fv) fv.onclick=async function(){
      vpLe();
      var ok=await vpSalvar(true);
      if(ok&&_vpEditId) telaVendaFechada(_vpEditId);
    };
    /* v656 — GERAR ARTE do carro desta cotação. O botão é montado no 17
       (a tela) e ligado aqui (onde mora o resto da fiação do painel). */
    var art=$('vpArte'); if(art) art.onclick=function(){
      var _v=(_vp&&_vp.veiculo)||null;
      if(!_v){ toast('Escolha o veículo da negociação antes de gerar a arte.'); return; }
      arteAbrir({
        marca:_v.marca||'', modelo:_v.modelo||'', ano:_v.ano||'', ano_modelo:_v.ano_modelo||_v.ano||'',
        fotos:(_v.fotos||[]).slice(), extras:_v.extras||{}, preco_anuncio:Number(_v.preco_anuncio)||0
      }, 'estoque');
    };
    var sv=$('vpSalvar'); if(sv) sv.onclick=function(){ vpSalvar(); };   /* v195 — sem passar o evento do clique */
    var dl=$('vpDel'); if(dl) dl.onclick=function(){ vendaApagar(_vpEditId); };
  }
  /* Digitou o telefone com um cliente CADASTRADO escolhido -> atualiza o cadastro dele sozinho. */
  var _vpTelTimer=null, _vpTelAvisou=false;
  function _vpTelSync(){
    if(!_vp||!_vp.cliente_id) return;
    var tel=String((($('vpCliTel')||{}).value)||'').trim(); var dig=tel.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(dig.length<10) return;   /* só telefone completo (DDD + número) */
    var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(_vp.cliente_id); })[0]; if(!c) return;
    if(String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'')===dig) return;   /* já é o mesmo */
    try{
      supa.from('clientes').update({telefone:tel, atualizado_em:new Date().toISOString()}).eq('id',c.id).then(function(r){
        if(r&&r.error) return;
        c.telefone=tel;
        try{ if(typeof mtEspelhar==='function') mtEspelhar(c); }catch(_){}
        if(!_vpTelAvisou){ _vpTelAvisou=true; }
        toast('Telefone atualizado no cadastro do cliente ✓');
      }, function(){});
    }catch(_){}
  }
  function vpPickVeiculo(){
    var disp=(_estoque||[]).filter(function(v){ return v.status!=='vendido'; });
    var ov=document.createElement('div'); ov.className='cropmask';
    var itens = disp.length ? disp.map(function(v){ var foto=(v.fotos&&v.fotos[0])?('<img loading="lazy" decoding="async" src="'+esc(imgCdn(v.fotos[0],800))+'">'):'<div style="width:52px;height:52px;border-radius:9px;background:#e2e8f0;display:flex;align-items:center;justify-content:center;flex-shrink:0">🚗</div>';
      return '<button type="button" class="vp-pk-item" data-id="'+esc(v.id)+'">'+foto+'<div style="flex:1"><div class="nm">'+esc(_vpVeicNome(v))+'</div><div style="font-size:11.5px;color:#64748b;font-weight:600">'+esc(v.placa||'')+(v.ano?' · '+esc(v.ano):'')+'</div></div><span class="pr">'+estMoney(v.preco_anuncio||0)+'</span></button>';
    }).join('') : '<div class="cli-empty" style="padding:20px">Nenhum veículo disponível no estoque.</div>';
    ov.innerHTML='<div class="cropbox" style="max-width:380px;max-height:82vh;overflow:auto"><div class="crop-tit">Escolher veículo</div><div class="crop-sub">Toque no veículo que vai vender.</div><div style="margin-top:8px">'+itens+'</div><button type="button" class="link" id="vpPkFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.querySelector('#vpPkFechar').onclick=close;
    Array.prototype.forEach.call(ov.querySelectorAll('.vp-pk-item'),function(b){ b.onclick=function(){ var v=disp.filter(function(x){return String(x.id)===String(b.getAttribute('data-id'));})[0]; if(!v) return;
      vpLe(); _vp.veiculo={ estoque_id:v.id, marca:v.marca, modelo:v.modelo, placa:v.placa, ano:v.ano, cor:v.cor, km:v.km, fotos:(v.fotos||[]).slice(), preco_anuncio:v.preco_anuncio||0, preco_minimo:v.preco_minimo||0, obs:v.obs||'', extras:v.extras||{} };
      _vp.precoVenda=v.preco_anuncio||0; _vp.comparacao=null; close(); _vpRenderTudo(); }; });
  }
  var _vpTrocaAuto='';
  /* Preencheu a troca (placa + avaliação) -> o usado entra/atualiza no CADASTRO
     do estoque (preço de compra = avaliação) e fica VINCULADO ao cliente da
     venda (obs no veículo + anotação na ficha do cliente, espelhada no CRM). */
  var _vpTrocaSyncUlt='';
  /* v190: nada de cadastro automático. Esta função só acende/apaga o botão e
     avisa o que ainda falta preencher (placa válida + valor da avaliação). */
  function _vpTrocaBtnEstado(){
    var b=$('vpTrocaEst'), m=$('vpTrocaEstMsg'); if(!b) return;
    var t=(_vp&&_vp.troca)||{};
    var pl=limpa(String(t.placa||'')); var aval=+t.avaliacao||0;
    var ok=valida(pl)&&aval>0;
    b.disabled=!ok; b.style.opacity=ok?'':'.55';
    var ja=ok&&(_estoque||[]).filter(function(x){ return String(x.placa||'').toUpperCase()===pl; })[0];
    if(m){
      m.className='cad-msg';
      if(!valida(pl)) m.textContent='Informe a placa do usado pra poder cadastrar.';
      else if(!aval) m.textContent='Informe o valor da avaliação pra poder cadastrar.';
      else if(ja) m.textContent='Essa placa já está no seu estoque — o botão atualiza os valores.';
      else m.textContent='O usado só entra no estoque quando você tocar no botão.';
    }
    if(ja) b.innerHTML=b.innerHTML.replace('Cadastrar o usado no estoque','Atualizar o usado no estoque');
  }
  async function _vpTrocaSync(manual){
    var m=$('vpTrocaEstMsg');
    if(!_vp||!_vp.troca){ if(manual&&m){ m.className='cad-msg err'; m.textContent='Marque "tem troca" antes.'; } return; }
    var t=_vp.troca; var pl=limpa(String(t.placa||''));
    if(!valida(pl)){ if(manual&&m){ m.className='cad-msg err'; m.textContent='Placa do usado inválida.'; } return; }
    var aval=+t.avaliacao||0;
    if(!aval){ if(manual&&m){ m.className='cad-msg err'; m.textContent='Preencha o valor da avaliação.'; } return; }
    var modeloTxt=String(t.modelo||'').trim();
    var cliNome=String(_vp.cliente_nome||'').trim();
    var km=Number(t.km)||0;
    var chave=pl+'|'+aval+'|'+km+'|'+modeloTxt+'|'+String(_vp.cliente_id||cliNome);
    if(_vpTrocaSyncUlt===chave){ if(manual&&m){ m.className='cad-msg ok'; m.textContent='Já está no estoque com esses valores ✓'; } return; }
    var _bt=$('vpTrocaEst'); if(_bt){ _bt.disabled=true; }
    if(m){ m.className='cad-msg'; m.textContent='Cadastrando no estoque…'; }
    var anoM=modeloTxt.match(/(19|20)\d{2}\s*$/); var ano=anoM?anoM[0].trim():'';
    var resto=ano?modeloTxt.slice(0,modeloTxt.length-ano.length).trim():modeloTxt;
    var marca=(resto.split(/\s+/)[0]||''); var modelo=resto.slice(marca.length).trim()||resto;
    var ex=(_estoque||[]).filter(function(x){ return String(x.placa||'').toUpperCase()===pl; })[0];
    try{
      if(ex){
        var upd={ preco_compra:aval, atualizado_em:new Date().toISOString() };
        if(km>0) upd.km=km;
        if(modeloTxt && !(((ex.marca||'')+' '+(ex.modelo||'')).trim())){ upd.marca=marca; upd.modelo=modelo; if(ano) upd.ano=ano; }
        if(+t.fipe && !ex.preco_minimo) upd.preco_minimo=+t.fipe;
        if(cliNome){ var ob=String(ex.obs||''); if(ob.indexOf('troca de ')<0){ upd.obs=(ob?(ob+' · '):'')+'Recebido na troca de '+cliNome+'.'; } }
        var r=await supa.from('estoque').update(upd).eq('id',ex.id); if(r&&r.error) throw r.error;
        Object.assign(ex,upd);
      } else {
        var reg={ user_id:meuId, placa:pl, marca:marca, modelo:modelo, ano:ano, km:(km||null), preco_compra:aval, preco_minimo:(+t.fipe||null), status:'disponivel', data_entrada:estHoje(), criado_em:new Date().toISOString(), fotos:[], obs:(cliNome?('Recebido na troca de '+cliNome+'.'):'Recebido na troca.') };
        var r2=await supa.from('estoque').insert(reg).select('id'); if(r2&&r2.error) throw r2.error;
        var nid=(r2&&r2.data&&r2.data[0]&&r2.data[0].id); if(nid!=null){ reg.id=nid; _estoque.unshift(reg); }
      }
      /* vínculo na ficha do CLIENTE (anotação; espelha pro CRM do MEVTOOLS) */
      if(_vp.cliente_id){
        var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(_vp.cliente_id); })[0];
        if(c){
          var an=Array.isArray(c.anotacoes)?c.anotacoes.slice():[];
          var ja=an.some(function(a){ return String((a&&a.t)||'').indexOf('placa '+pl)>=0; });
          if(!ja){
            an.push({ t:'🔄 Troca: '+(modeloTxt||pl)+' · placa '+pl+' · avaliação '+brl(aval), ts:new Date().toISOString() });
            var r3=await supa.from('clientes').update({anotacoes:an, atualizado_em:new Date().toISOString()}).eq('id',c.id);
            if(!(r3&&r3.error)){ c.anotacoes=an; try{ if(typeof mtEspelhar==='function') mtEspelhar(c); }catch(_){} }
          }
        }
      }
      _vpTrocaSyncUlt=chave;
      if(m){ m.className='cad-msg ok'; m.textContent=(ex?'Usado atualizado no estoque ✓':'Usado cadastrado no estoque ✓')+' e vinculado ao cliente.'; }
      toast(ex?'Usado atualizado no estoque e vinculado ao cliente ✓':'Usado cadastrado no estoque e vinculado ao cliente ✓');
    }catch(e){
      if(m){ m.className='cad-msg err'; m.textContent='Não consegui cadastrar agora. '+((e&&e.message)||'Tente de novo.'); }
    }
    var _bt2=$('vpTrocaEst'); if(_bt2){ _bt2.disabled=false; }
  }
  /* v160: monta o "Modelo e ano" da troca com a marca CURTA. A FIPE manda
     "VW - VolksWagen"; no celular isso come metade do campo. Vira só "VW". */
  /* v370 (pedido) — o campo "Modelo e ano" passa a mostrar ANO DE FABRICAÇÃO
     E ANO MODELO, no formato 2015/2016, que é como o documento e a FIPE falam.
     Quando os dois são iguais (ou só um é conhecido), escreve um só. */
  function _vpAnoTxt(ano, anoMod){
    var a=String(ano||'').trim().slice(0,4), b=String(anoMod||'').trim().slice(0,4);
    if(a && b && a!==b) return a+'/'+b;
    return a||b;
  }
  function _vpModeloAno(marca, modelo, ano, anoMod){
    var mc=String(marca||'').split(/[\s\-]+/)[0]||'';
    var md=String(modelo||'').trim();
    if(mc && md.toUpperCase().indexOf(mc.toUpperCase())===0) mc='';
    var t=(mc+' '+md).trim();
    /* tira um ano que já venha grudado no fim do nome, pra não duplicar */
    t=t.replace(/\s*(19|20)\d{2}(\s*\/\s*(19|20)?\d{2})?\s*$/,'').trim();
    var a=_vpAnoTxt(ano, anoMod);
    if(a && t.indexOf(a)<0) t=(t+' '+a).trim();
    return t;
  }

  /* ===================== v370 — APROVEITAR O QUE JÁ EXISTE ==================
     Se a placa do usado JÁ passou pela avaliação (ou já está no estoque, ou já
     tem consulta salva), não faz sentido o vendedor digitar tudo de novo. Esta
     função junta, nesta ordem de confiança, o que der pra reaproveitar:

       1. o "bilhete" do espelho avaliação <-> estoque (km e valor de compra)
       2. o rascunho completo da avaliação daquela placa (mev_aval:PLACA)
       3. o mapa de valores avaliados que veio da nuvem (_avValores)
       4. o cadastro do carro no estoque (km, preço de compra, anos)
       5. o histórico da consulta de placa (anos e FIPE)

     E ainda anota o que já foi gerado para essa placa, inclusive a Consulta
     Plus — isso não custa token de novo, e o vendedor precisa saber. */
  function _vpAvalDaPlaca(placa){
    var pl=limpa(String(placa||'')); if(!valida(pl)) return null;
    var o={ km:0, avaliacao:0, repasse:0, fipe:0, ano:'', ano_modelo:'', obs:'', fontes:[], prontos:[] };
    function fonte(f){ if(o.fontes.indexOf(f)<0) o.fontes.push(f); }
    function inteiro(v){ return parseInt(String(v==null?'':v).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; }
    try{ var e=espelhoLer(pl)||{};
      if(inteiro(e.km)>0){ o.km=inteiro(e.km); fonte('avaliação'); }
      if(inteiro(e.compra)>0){ o.avaliacao=inteiro(e.compra); fonte('avaliação'); }
      if(inteiro(e.repasse)>0) o.repasse=inteiro(e.repasse);
      if(String(e.obs||'').trim()) o.obs=String(e.obs).trim();
    }catch(_){}
    try{ var r=JSON.parse(localStorage.getItem('mev_aval:'+pl)||'null');
      if(r){
        if(!o.km && inteiro(r.avKm)>0){ o.km=inteiro(r.avKm); }
        if(!o.avaliacao && inteiro(r.avValor)>0){ o.avaliacao=inteiro(r.avValor); }
        if(!o.repasse && inteiro(r.avRepPreco)>0) o.repasse=inteiro(r.avRepPreco);
        if(!o.obs && String(r.avObs||'').trim()) o.obs=String(r.avObs).trim();
        if(o.km||o.avaliacao) fonte('avaliação');
      }
    }catch(_){}
    try{ if(!o.avaliacao && typeof _avValores!=='undefined' && _avValores){
      var av=_avValores[_avPlacaKey(pl)]||0; if(av>0){ o.avaliacao=av; fonte('avaliação'); } } }catch(_){}
    try{ var v=(_estoque||[]).filter(function(x){ return limpa(String(x.placa||''))===pl; })[0];
      if(v){
        if(!o.km && Number(v.km)>0) o.km=Number(v.km);
        if(!o.avaliacao && Number(v.preco_compra)>0) o.avaliacao=Number(v.preco_compra);
        if(!o.repasse && Number(v.preco_anuncio)>0) o.repasse=Number(v.preco_anuncio);
        if(v.ano) o.ano=String(v.ano);
        if(v.ano_modelo) o.ano_modelo=String(v.ano_modelo);
        fonte('estoque');
      } }catch(_){}
    try{ var h=histLerUm(pl), hv=(h&&h.v)||null;
      if(hv){
        if(!o.ano && hv.ano) o.ano=String(hv.ano);
        if(!o.ano_modelo && hv.ano_modelo) o.ano_modelo=String(hv.ano_modelo);
        if(!o.fipe && Number(hv.fipe)>0) o.fipe=Number(hv.fipe);
        if(!o.km && Number(hv.km)>0) o.km=Number(hv.km);
      }
      if(h&&h.consultaPlus) o.prontos.push('Consulta Plus');
    }catch(_){}
    try{ if(fichaTecObter(pl)) o.prontos.push('ficha técnica'); }catch(_){}
    o.tem=!!(o.km||o.avaliacao||o.ano||o.prontos.length);
    return o;
  }
  /* pinta a faixa verde "já tenho isto aqui" logo abaixo da placa */
  function _vpAvalBoxPinta(a, usou){
    var box=$('vpTrocaAvalBox'); if(!box) return;
    if(!a||!a.tem){ box.innerHTML=''; return; }
    var chips=[];
    if(a.km>0) chips.push(Number(a.km).toLocaleString('pt-BR')+' km');
    if(a.avaliacao>0) chips.push('avaliação '+brl(a.avaliacao));
    if(a.repasse>0) chips.push('repasse '+brl(a.repasse));
    var anos=_vpAnoTxt(a.ano,a.ano_modelo); if(anos) chips.push('ano '+anos);
    (a.prontos||[]).forEach(function(x){ chips.push(x+' pronta'); });
    if(!chips.length){ box.innerHTML=''; return; }
    var tit=(usou&&usou.length)?('Preenchi '+usou.join(', ')+' pra você'):'Este carro já passou por aqui';
    box.innerHTML='<div class="vpt-aval"><div class="vpt-aval-h"><span>✓</span><b>'+esc(tit)+'</b></div>'+
      '<div class="vpt-aval-ch">'+chips.map(function(c){ return '<i>'+esc(c)+'</i>'; }).join('')+'</div>'+
      ((a.prontos&&a.prontos.length)?('<div class="vpt-aval-pe">'+esc(a.prontos.join(' e '))+' já '+(a.prontos.length>1?'estão salvas':'está salva')+' pra esta placa — abrir de novo não gera cobrança.</div>'):'')+
      '</div>';
  }
  /* aproveita de verdade: preenche só o que estiver EM BRANCO (nunca por cima
     do que o vendedor digitou) e conta na faixa verde o que foi preenchido. */
  function _vpTrocaAproveitar(placa){
    if(!_vp||!_vp.troca) return null;
    var pl=limpa(String(placa||(($('vpTrocaPlaca')||{}).value)||''));
    var a=_vpAvalDaPlaca(pl);
    if(!a||!a.tem){ _vpAvalBoxPinta(null); return null; }
    var usou=[];
    function vazio(id){ var e=$(id); if(!e) return false; return !(parseInt(String(e.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)>0); }
    if(a.km>0 && vazio('vpTrocaKm')){ var ki=$('vpTrocaKm'); if(ki){ ki.value=Number(a.km).toLocaleString('pt-BR'); _vp.troca.km=a.km; usou.push('quilometragem'); } }
    if(a.avaliacao>0 && vazio('vpAval')){ var ai=$('vpAval'); if(ai){ ai.value=_rs(a.avaliacao); _vp.troca.avaliacao=a.avaliacao; usou.push('avaliação'); } }
    if(a.fipe>0 && vazio('vpFipe')){ var fi=$('vpFipe'); if(fi){ fi.value=_rs(a.fipe); _vp.troca.fipe=a.fipe; usou.push('FIPE'); } }
    var anos=_vpAnoTxt(a.ano,a.ano_modelo), tm=$('vpTrocaModelo');
    if(anos && tm){
      var txt=String(tm.value||'').trim();
      if(txt && txt.indexOf(anos)<0){
        txt=txt.replace(/\s*(19|20)\d{2}(\s*\/\s*(19|20)?\d{2})?\s*$/,'').trim();
        tm.value=(txt+' '+anos).trim(); _vp.troca.modelo=tm.value; usou.push('ano fab./modelo');
      }
    }
    _vpAvalBoxPinta(a, usou);
    if(usou.length){ try{ vpAtualiza(); }catch(_){} try{ _vpTrocaBtnEstado(); }catch(_){} }
    return a;
  }

  /* ================= v196 · CONSULTAS E COMPARADOR DA TROCA =============== */
  function _vpComparacaoLimpar(){
    if(_vp) _vp.comparacao=null;
    var b=$('vpComparacaoBox'); if(b) b.innerHTML='';
  }
  function _vpTrocaVeicDados(){
    var t=(_vp&&_vp.troca)||{}, pl=limpa(String(t.placa||'')), h=null;
    try{ h=pl?histLerUm(pl):null; }catch(_){ h=null; }
    var d={}; try{ Object.assign(d,(h&&h.v)||{},t.dados||{}); }catch(_){}
    var txt=String(t.modelo||'').trim(), anoM=txt.match(/(19|20)\d{2}(?:\/(19|20)?\d{2})?\s*$/);
    var ano=String(d.ano_modelo||d.ano||(anoM?anoM[0].trim():''));
    var semAno=anoM?txt.slice(0,txt.length-anoM[0].length).trim():txt;
    if(!d.marca && semAno) d.marca=semAno.split(/\s+/)[0]||'';
    if(!d.modelo && semAno) d.modelo=semAno.slice(String(d.marca||'').length).trim()||semAno;
    d.placa=pl; d.ano=d.ano||ano; d.ano_modelo=d.ano_modelo||ano;
    d.km=Number(t.km)||Number(d.km)||0; d.fipe=Number(t.fipe)||Number(d.fipe)||0;
    return d;
  }
  function _vpComparacaoChave(){
    var n=(_vp&&_vp.veiculo)||{}, u=(_vp&&_vp.troca)||{};
    return [String(n.estoque_id||n.placa||''),String(n.modelo||''),Number(n.km)||0,
            limpa(String(u.placa||'')),String(u.modelo||''),Number(u.km)||0].join('|');
  }
  function _vpComparacaoValida(r){
    return !!(r&&Array.isArray(r.vantagens)&&r.vantagens.length&&String(r._chave||'')===_vpComparacaoChave());
  }
  function _vpFichaComparacao(placa){
    var ft=null, p=null;
    try{ ft=fichaTecObter(placa); p=ft?fichaTecParse(ft):null; }catch(_){ p=null; }
    if(!p||!p.conhecido) return null;
    function mapa(rows){ var o={}; (rows||[]).forEach(function(x){ if(x&&x[0]&&x[1]) o[x[0]]=x[1]; }); return o; }
    return {
      identificacao:mapa(p.ident), motor:mapa(p.motor), desempenho:mapa(p.desemp),
      dimensoes:mapa(p.dim), chassi:mapa(p.chassi),
      equipamentos:(p.equip||[]).filter(function(e){ return e&&e.nome&&!/INDISPON/.test(e.disp||''); }).map(function(e){ return e.nome; }).slice(0,40)
    };
  }
  function _vpVeicComparacao(v, destino){
    v=v||{};
    var placa=limpa(String(v.placa||''));
    var ex=(v.extras||{}), dif=[];
    try{ _EX_DIF.forEach(function(d){ if(ex[d.k]) dif.push(d.t); }); }catch(_){}
    if(String(ex.opcionais||'').trim()) dif.push(String(ex.opcionais).trim());
    return {
      papel:destino?'veículo que o cliente vai comprar':'usado que entra na troca',
      nome:((v.marca||'')+' '+(v.modelo||'')).replace(/\s+/g,' ').trim(),
      placa:placa, ano_modelo:v.ano_modelo||v.ano||'', km:Number(v.km)||0,
      combustivel:v.combustivel||'', cor:v.cor||'',
      valor:destino?(Number(v.preco_anuncio)||Number((_vp&&_vp.precoVenda))||0):(Number(v.fipe)||0),
      diferenciais:dif.slice(0,20), ficha:_vpFichaComparacao(placa),
      identificacao_exata:[v.marca||'',v.modelo||'',v.versao||'',v.ano_modelo||v.ano||''].filter(Boolean).join(' ')
    };
  }
  function _vpComparacaoHtml(r){
    if(!r||!Array.isArray(r.vantagens)||!r.vantagens.length) return '';
    /* v370 (pedido) — cada vantagem ganhou EDITAR e EXCLUIR. A IA acerta a
       maior parte, mas quem conhece o carro é o vendedor: se um dado veio
       errado, ou se um argumento não serve pra este cliente, dá pra corrigir
       na hora em vez de gastar outro token gerando tudo de novo. */
    var itens=r.vantagens.map(function(x,i){
      x=x||{}; var dados=[];
      if(x.dado_novo) dados.push('<span><b>Novo:</b> '+esc(x.dado_novo)+'</span>');
      if(x.dado_usado) dados.push('<span><b>Usado:</b> '+esc(x.dado_usado)+'</span>');
      return '<div class="vpt-cmp-i" data-i="'+i+'"><span class="vpt-cmp-ok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>'+
        '<div><em>'+esc(x.categoria||'Vantagem')+'</em><b>'+esc(x.titulo||'Vantagem na troca')+'</b><p>'+esc(x.explicacao||'')+'</p>'+
        (dados.length?('<div class="vpt-cmp-dados">'+dados.join('')+'</div>'):'')+
        '<div class="vpt-cmp-acts"><button type="button" class="vca" data-ed="'+i+'">editar</button><button type="button" class="vca ex" data-ex="'+i+'">excluir</button></div>'+
        '</div></div>';
    }).join('');
    var at=(r.atencao||[]).filter(Boolean);
    var confianca=String(r.confianca||'media').toLowerCase();
    var aviso=r.alerta_validacao ? '<div class="vpt-cmp-valid '+(confianca==='baixa'?'bad':'')+'"><b>Validação da versão: '+esc(confianca)+'</b><span>'+esc(r.alerta_validacao)+'</span></div>' : '';
    return '<div class="vpt-cmp"><div class="vpt-cmp-h"><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3l4 4-4 4"/><path d="M3 7h18"/><path d="M7 21l-4-4 4-4"/><path d="M21 17H3"/></svg></span><div><b>Vantagens desta troca</b><i>argumentos para apresentar ao cliente</i></div></div>'+
      '<div class="vpt-cmp-ia">Comparativo gerado por <b>inteligência artificial</b>. Confira as informações antes de apresentar ao cliente — podem existir erros.</div>'+
      (r.resumo?('<div class="vpt-cmp-res">'+esc(r.resumo)+'</div>'):'')+
      aviso+
      '<div class="vpt-cmp-lista">'+itens+'</div>'+
      (at.length?('<div class="vpt-cmp-at"><b>Pontos para explicar com transparência</b>'+at.map(function(x){return '<span>'+esc(x)+'</span>';}).join('')+'</div>'):'')+
      '<div class="vpt-cmp-pe">Comparação baseada nas fichas técnicas e em pesquisa de mercado. Confirme versão e equipamentos antes de prometer ao cliente.</div></div>';
  }
  function _vpComparacaoTexto(r){
    var novo=_vpVeicNome((_vp&&_vp.veiculo)||{}), L=['🚗 Por que vale a pena trocar pelo '+novo,''];
    if(r&&r.resumo) L.push(r.resumo,'');
    (r&&r.vantagens||[]).forEach(function(x){ if(!x) return; L.push('✓ '+(x.titulo||x.categoria||'Vantagem')+(x.explicacao?(': '+x.explicacao):'')); });
    if(r&&r.atencao&&r.atencao.length){ L.push('','Pontos importantes:'); r.atencao.forEach(function(x){ L.push('• '+x); }); }
    return L.join('\n');
  }
  function _vpComparacaoRedesenha(){
    var box=$('vpComparacaoBox'); if(!box) return;
    var r=_vp&&_vp.comparacao;
    box.innerHTML=(r&&r.vantagens&&r.vantagens.length)?_vpComparacaoHtml(r):'';
    _vpComparacaoWire();
    try{ vpAtualiza(); }catch(_){}
  }
  /* formulário de edição de UMA vantagem, no lugar do próprio item */
  function _vpCmpEditar(i){
    var box=$('vpComparacaoBox'); if(!box) return;
    var r=_vp&&_vp.comparacao, x=r&&r.vantagens&&r.vantagens[i]; if(!x) return;
    var el=box.querySelector('.vpt-cmp-i[data-i="'+i+'"]'); if(!el) return;
    el.classList.add('editando');
    el.innerHTML='<div class="vpt-cmp-ed">'+
      '<label class="cad-lbl">Categoria</label><input class="cad-in" id="vcEcat" value="'+esc(x.categoria||'')+'" placeholder="Ex: Economia">'+
      '<label class="cad-lbl">Título</label><input class="cad-in" id="vcEtit" value="'+esc(x.titulo||'')+'" placeholder="Ex: Consumo melhor na estrada">'+
      '<label class="cad-lbl">Explicação</label><textarea class="cad-in" id="vcEexp" rows="4">'+esc(x.explicacao||'')+'</textarea>'+
      '<div class="cli-2col"><div><label class="cad-lbl">Dado do novo</label><input class="cad-in" id="vcEdn" value="'+esc(x.dado_novo||'')+'"></div>'+
      '<div><label class="cad-lbl">Dado do usado</label><input class="cad-in" id="vcEdu" value="'+esc(x.dado_usado||'')+'"></div></div>'+
      '<div class="vpt-cmp-edbt"><button type="button" class="cad-btn" id="vcEok">Salvar</button>'+
      '<button type="button" class="cad-btn sec" id="vcEno">Cancelar</button></div></div>';
    var ok=$('vcEok'); if(ok) ok.onclick=function(){
      x.categoria=String((($('vcEcat')||{}).value)||'').trim();
      x.titulo=String((($('vcEtit')||{}).value)||'').trim();
      x.explicacao=String((($('vcEexp')||{}).value)||'').trim();
      x.dado_novo=String((($('vcEdn')||{}).value)||'').trim();
      x.dado_usado=String((($('vcEdu')||{}).value)||'').trim();
      r.editado=true; _vpComparacaoRedesenha(); toast('Vantagem atualizada ✓');
    };
    var no=$('vcEno'); if(no) no.onclick=_vpComparacaoRedesenha;
  }
  /* Editar / excluir cada vantagem. O excluir pede confirmação NO PRÓPRIO
     botão (um toque vira "confirmar?", o segundo apaga) — sem janela do
     navegador, que trava o app enquanto está aberta. */
  function _vpComparacaoWire(){
    var box=$('vpComparacaoBox'); if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('[data-ed]'),function(b){
      b.onclick=function(){ _vpCmpEditar(parseInt(b.getAttribute('data-ed'),10)||0); };
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-ex]'),function(b){
      b.onclick=function(){
        var i=parseInt(b.getAttribute('data-ex'),10)||0;
        if(b.getAttribute('data-ok')!=='1'){
          b.setAttribute('data-ok','1'); b.classList.add('conf'); b.textContent='confirmar?';
          setTimeout(function(){ if(b&&b.getAttribute('data-ok')==='1'){ b.removeAttribute('data-ok'); b.classList.remove('conf'); b.textContent='excluir'; } },4000);
          return;
        }
        var r=_vp&&_vp.comparacao; if(!r||!Array.isArray(r.vantagens)) return;
        r.vantagens.splice(i,1); r.editado=true;
        _vpComparacaoRedesenha(); toast('Vantagem excluída.');
      };
    });
  }
  async function _vpComparar(btn){
    if(!_vp) return; vpLe();
    var novo=_vp.veiculo||{}, usado=_vpTrocaVeicDados(), box=$('vpComparacaoBox');
    if(!(novo.marca||novo.modelo)){ toast('Escolha o veículo que será vendido primeiro.'); return; }
    if(!valida(usado.placa)||!(usado.marca||usado.modelo)){ toast('Informe a placa e o modelo do usado.'); return; }
    if(!(Number(usado.km)>0)){ toast('Informe a quilometragem do usado para comparar corretamente.'); var km=$('vpTrocaKm'); if(km) try{ km.focus(); }catch(_){} return; }
    var rot=btn?btn.innerHTML:'';
    if(btn){ btn.disabled=true; var t=btn.querySelector('.mc-t'); if(t) t.textContent='Comparando os veículos…'; }
    /* v370 (pedido) — MESMA ANIMAÇÃO DA CONSULTA DE PLACA: o anel com o
       carrinho e as frases que trocam (ccLoaderHtml/ccLoaderStart), em vez de
       uma linha de texto parada. As frases contam o que está sendo comparado
       de verdade — nada de barra de progresso inventada. */
    var _cmpTimer=null;
    var _cmpFrases=['🔧 Lendo a ficha técnica dos dois carros…','⛽ Comparando motor, câmbio e consumo…','🛡️ Conferindo airbags, freios e equipamentos…','📦 Medindo porta-malas e espaço interno…','📈 Olhando mercado, ano e quilometragem…','✅ Montando os argumentos pro cliente…'];
    if(box){
      try{ box.innerHTML=ccLoaderHtml('Comparando os dois veículos…', _cmpFrases); _cmpTimer=ccLoaderStart(_cmpFrases); }
      catch(_){ box.innerHTML='<div class="vpi-load">A IA está comparando motor, consumo, espaço, conforto, mercado e quilometragem…</div>'; }
    }
    var d=null;
    try{
      d=await apiComTimeout('/api/venda-ia',{ tipo:'comparacao', dados:{
        destino:_vpVeicComparacao(novo,true), usado:_vpVeicComparacao(usado,false)
      } },36000);
    }catch(_){ d=null; }
    /* o timer das frases PRECISA parar aqui: deu certo, deu erro ou faltou
       saldo, todos os caminhos passam por este ponto. */
    if(_cmpTimer){ try{ clearInterval(_cmpTimer); }catch(_){} _cmpTimer=null; }
    if(btn){ btn.disabled=false; btn.innerHTML=rot; }
    if(d&&d.saldo!=null) setSaldo(d.saldo);
    if(d&&d.sem_saldo){ if(box) box.innerHTML='<div class="cad-msg err">'+esc(d.erro||'Saldo insuficiente.')+'</div>'; abrirPacotes(); return; }
    if(!d||!d.ok||!Array.isArray(d.vantagens)||!d.vantagens.length){
      if(box) box.innerHTML='<div class="cad-msg err">'+esc((d&&d.erro)||'Não consegui comparar agora. Confira os modelos e tente novamente.')+'</div>';
      return;
    }
    d._chave=_vpComparacaoChave(); d.em=new Date().toISOString(); _vp.comparacao=d;
    if(box){ box.innerHTML=_vpComparacaoHtml(d); _vpComparacaoWire(); try{ box.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(_){} }
    if(btn){
      var ic=btn.querySelector('.ico'); if(ic){ ic.classList.remove('blue','gold'); ic.classList.add('green'); }
      var cr=btn.querySelector('.mc-cr'); if(cr){ cr.textContent='✓ pronto'; cr.classList.add('done'); }
    }
  }

  /* Os três atalhos abaixo abrem as consultas já existentes para a placa do
     usado. A proposta permanece em memória e o botão voltar retorna exatamente
     para a aba Troca, inclusive quando a venda ainda não foi salva. */
  var _vpConsultaAnt=null;
  function _vpConsultaVoltar(){
    var a=_vpConsultaAnt; _vpConsultaAnt=null;
    if(a){ veiculoAtual=a.veiculoAtual; fichaTecState=a.fichaTecState; leilaoState=a.leilaoState; debitosState=a.debitosState; histFonteTs=a.histFonteTs; }
    /* ===== v444 (PLANO das abas, Parte B) — O VOLTAR ====================
       Este era o ponto delicado do plano, e por um motivo bom: esta função
       sempre remontou a tela de NEGOCIAÇÃO e caiu na aba Troca. Agora as
     a Consulta Plus também pode ter sido aberta de dentro da
       VENDA FECHADA — e voltar pra tela de negociação ali seria jogar a
       pessoa pra trás no fluxo, num lugar que ela não pediu.

       Quem sabe de onde a pessoa veio é o _vpFechadaGestao, que já existia
       (17-vendas.js: false em vendaNovaAbrir, true em telaVendaFechada).
       Se veio da venda fechada, volta pra ELA, já na aba "Conferir o usado". */
    if(_vpFechadaGestao && _vpEditId){
      _vfTabIni='usadoconsultas';
      telaVendaFechada(_vpEditId);
      return;
    }
    mevTabSet(''); _vpStep='troca'; document.body.classList.add('venda-cot');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>'+(_vpEditId?'Venda':'Nova venda')+'</h2><div id="vpForm"></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block';
    window.scrollTo(0,0); fabFoto(false); mevAcoes(false); _cadWireBack(); voltarTab(_vpFechadaGestao?telaVendasFechadas:telaVendas);
    _vpRenderTudo();
  }
  function _vpConsultaPrenderVolta(){
    var b=document.querySelector('#secoes [data-back]'); if(b) b.onclick=_vpConsultaVoltar;
    voltarTab(_vpConsultaVoltar);
  }
  function _vpTrocaConsultaAbrir(tipo){
    if(!_vp) return; vpLe();
    var v=_vpTrocaVeicDados(), pl=limpa(String(v.placa||'')), h=null;
    if(!valida(pl)){ toast('Informe uma placa válida para abrir a consulta.'); return; }
    if(!(v.marca||v.modelo)){ toast('Aguarde a busca da placa ou preencha o modelo do usado.'); return; }
    try{ h=histLerUm(pl); }catch(_){ h=null; }
    if(!_vpConsultaAnt) _vpConsultaAnt={ veiculoAtual:veiculoAtual, fichaTecState:fichaTecState, leilaoState:leilaoState, debitosState:debitosState, histFonteTs:histFonteTs };
    veiculoAtual=v; histFonteTs=null;
    try{ fichaTecState=fichaTecObter(pl); }catch(_){ fichaTecState=null; }
    leilaoState=(h&&h.leilao)||null; debitosState=null;
    if(tipo==='ficha') abrirFicha();
    else abrirConsultaPlus();
    _vpConsultaPrenderVolta();
  }

  async function vpTrocaBuscar(){
    var pl=limpa((($('vpTrocaPlaca')||{}).value)||''); if(!valida(pl)) return;
    var m=$('vpTrocaMsg');
    var it=histLerUm(pl); if(it&&it.v){ var vv=it.v; _vp.troca.dados=vv; if($('vpTrocaModelo'))$('vpTrocaModelo').value=_vpModeloAno(vv.marca,vv.modelo,vv.ano,vv.ano_modelo); if($('vpFipe')&&vv.fipe)$('vpFipe').value=_rs(vv.fipe); if($('vpTrocaKm')&&vv.km){ $('vpTrocaKm').value=Number(vv.km).toLocaleString('pt-BR'); } vpAtualiza(); if(m){ m.className='cad-msg'; m.textContent=''; } try{ _vpTrocaAproveitar(pl); }catch(_){} return; }
    if(m){ m.className='cad-msg'; m.textContent='Consultando a placa…'; }
    try{ var d=await api('/api/consultar',{produto:'fipe',placa:pl});
      if(d&&d.sem_saldo){ if(m){ m.className='cad-msg err'; m.textContent='Sem saldo para buscar a placa.'; } return; }
      if(d&&d.ok&&d.resultado){ var r=d.resultado; _vp.troca.dados=r; if($('vpTrocaModelo'))$('vpTrocaModelo').value=_vpModeloAno(r.marca,r.modelo,r.ano,r.ano_modelo); if($('vpFipe')&&r.fipe)$('vpFipe').value=_rs(r.fipe); if($('vpTrocaKm')&&r.km){ $('vpTrocaKm').value=Number(r.km).toLocaleString('pt-BR'); } try{ histSalvar(pl,((r.marca||'')+' '+(r.modelo||'')).trim(),r,null); }catch(_){} vpAtualiza(); if(m){ m.className='cad-msg ok'; m.textContent='Dados da placa preenchidos ✓'; } if(d.saldo!=null) setSaldo(d.saldo); try{ _vpTrocaAproveitar(pl); }catch(_){} }
      else { if(m){ m.className='cad-msg err'; m.textContent=(d&&d.erro)||'Não encontrei a placa.'; } } }
    catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Falha ao buscar a placa.'; } }
  }
  function vpResumo(det){
    vpLe(); var c=vpCalc(_vp), v=_vp.veiculo||{}, L=[];
    L.push('🚗 '+_vpVeicNome(v)+(v.ano?' '+v.ano:'')+(v.cor?' · '+v.cor:'')+(v.km?' · '+Number(v.km).toLocaleString('pt-BR')+' km':''));
    var _ex=(v&&v.extras)||{}; var _difs=[]; _EX_DIF.forEach(function(d){ if(_ex[d.k]) _difs.push(d.t); }); if(String(_ex.opcionais||'').trim())_difs.push(String(_ex.opcionais).trim());
    if(_difs.length) L.push('✨ '+_difs.join(' · '));
    if(_vp.cliente_nome) L.push('Cliente: '+_vp.cliente_nome+(_vp.cliente_tel?(' · '+_vp.cliente_tel):''));
    L.push('');
    L.push('💰 Valor do veículo: '+brl(c.precoFinal));
    if(_vp.troca&&_vp.troca.tem&&c.aval>0){
      var _tu=_vp.troca, _tn=String(_tu.modelo||'').trim();
      if(_tn||_tu.km) L.push('🚙 Usado: '+(_tn||String(_tu.placa||'').toUpperCase())+(_tu.km?(' · '+Number(_tu.km).toLocaleString('pt-BR')+' km'):''));
      if(c.quit>0){ L.push('🔄 Avaliação do seu usado: '+brl(c.aval)); L.push('   (−) Quitação do financiamento: '+brl(c.quit)); L.push('🔄 Seu usado na negociação: -'+brl(c.trocaLiq)); }
      else L.push('🔄 Seu usado (avaliação): -'+brl(c.aval));
    }
    if(c.saldo<0) L.push('↩️ Volta pra você: '+brl(-c.saldo));
    else L.push('➡️ Saldo a pagar: '+brl(c.saldo));
    if(c.parcelado){ L.push('💳 Entrada '+brl(c.entrada)+' + '+c.n+'x de '+brl(c.parcela)); }
    else if(c.saldo>0 && c.entrada>0){ L.push('💳 Entrada '+brl(c.entrada)+' + '+brl(Math.max(0,c.saldo-c.entrada))+' à vista'); }
    if(_vp.transf_inclui) L.push('✔ Transferência inclusa ('+brl(+_vp.transf_valor||700)+')');
    if(c.cort>0) L.push('🎁 Cortesia inclusa'+(_vp.cortesia_desc?(': '+_vp.cortesia_desc):'')+' ('+brl(c.cort)+')');
    if(det){
      L.push(''); L.push('— DETALHE DO VENDEDOR —');
      if(v.preco_minimo) L.push('Preço mínimo: '+brl(v.preco_minimo));
      if(c.parcelado){ L.push('Base financiada: '+brl(c.base)); L.push('TAC '+brl(c.TAC)+' · IOF '+brl(c.IOF)+' · Retorno '+brl(c.RET)); L.push('Total financiado: '+brl(c.financiado)); }
      if(c.cort>0) L.push('Cortesias (repasse, fora da margem): '+brl(c.cort));
    }
    var loja=_lojaRec; if(loja) L.push('\n'+ (loja.nome_fantasia||loja.razao_social||'') + (loja.whatsapp?(' · '+loja.whatsapp):''));
    return L.join('\n');
  }
  /* v189: abre o WhatsApp JÁ NO NÚMERO do cliente. Se a cotação ainda não tem
     telefone, cai no WhatsApp normal e você escolhe o contato na mão. */
  function vpCompartilhar(txt){
    var fone='';
    try{
      var cli=(_clientes||[]).filter(function(x){ return String(x.id)===String(_vp&&_vp.cliente_id); })[0];
      var raw=(cli&&cli.telefone)||(_vp&&_vp.cliente_tel)||'';
      fone=String(raw||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
      if(fone && fone.length<=11) fone='55'+fone;
      if(fone.length<12) fone='';
    }catch(_){ fone=''; }
    var u='https://wa.me/'+fone+'?text='+encodeURIComponent(txt);
    try{ var w=window.open(u,'_blank'); if(!w) location.href=u; }catch(_){ location.href=u; }
  }
  function _imgToDataUrl(url){ return new Promise(function(res){ try{ fetch(url).then(function(r){return r.blob();}).then(function(b){ var fr=new FileReader(); fr.onload=function(){ res(fr.result); }; fr.onerror=function(){ res(null); }; fr.readAsDataURL(b); }).catch(function(){ res(null); }); }catch(_){ res(null); } }); }
  /* Recorta uma imagem no centro, no estilo object-fit:cover, sem deformar.
     O resultado já sai na proporção do quadro usado no PDF do cliente. */
  function _imgCoverDataUrl(dataUrl,w,h){
    return new Promise(function(res){
      if(!dataUrl){ res(null); return; }
      try{
        var im=new Image();
        im.onload=function(){
          try{
            var iw=im.naturalWidth||im.width, ih=im.naturalHeight||im.height;
            if(!iw||!ih){ res(dataUrl); return; }
            var alvo=w/h, origem=iw/ih, sx=0, sy=0, sw=iw, sh=ih;
            if(origem>alvo){ sw=ih*alvo; sx=(iw-sw)/2; }
            else if(origem<alvo){ sh=iw/alvo; sy=(ih-sh)/2; }
            var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
            var ctx=cv.getContext('2d'); ctx.drawImage(im,sx,sy,sw,sh,0,0,w,h);
            var mime=String(dataUrl).indexOf('image/png')>=0?'image/png':'image/jpeg';
            res(cv.toDataURL(mime,mime==='image/jpeg'?0.92:undefined));
          }catch(_){ res(dataUrl); }
        };
        im.onerror=function(){ res(dataUrl); };
        im.src=dataUrl;
      }catch(_){ res(dataUrl); }
    });
  }
  /* ===================== v372 — A PROPOSTA EM PDF DO CLIENTE ================
     O papel que o cliente leva pra casa. O que mudou nesta versão:

     1. NADA MAIS SAI DA PÁGINA. O nome do carro era escrito numa linha só e
        sumia pela direita ("...VIRTUS Highline 200 TSI 1.0 Flex 12V A"). Agora
        todo texto passa por splitTextToSize, o cartão do veículo cresce com o
        conteúdo e existe uma quebra de página automática: quando não cabe, o
        bloco INTEIRO vai pra folha seguinte em vez de montar em cima do
        rodapé.
     2. EQUIPAMENTOS DE SÉRIE E OPCIONAIS entram na proposta — exatamente os
        que estão cadastrados na ficha do veículo (série conferida pelo
        lojista, menos o que ele desmarcou; opcionais só os que ele marcou).
     3. AS VANTAGENS DA TROCA (o comparativo por IA), quando já foi gerado.
     4. USADO É PEÇA ÚNICA: quando o carro tem quilometragem, entra uma faixa
        de EXCLUSIVIDADE — não existe outro igual nessa configuração.
     5. Os números são os APRESENTADOS AO CLIENTE (v370): preço de tabela
        cheio e avaliação esticada. O SALDO É O MESMO da tela — por
        construção, avaliação apresentada = tabela − saldo real. O cliente vê
        no papel exatamente o que viu na tela.
     ======================================================================= */
  async function vpPdf(completo){
    if(!_mevPdfPronto(function(){ vpPdf(completo); },false)) return;
    if(!_vp.veiculo){ toast('Escolha um veículo primeiro.'); return; }
    vpLe(); var c=vpCalc(_vp), v=_vp.veiculo; var loja=_lojaRec||await lojaGet()||{};
    toast('Gerando PDF…');
    var _logo=null; if(loja&&loja.logo){ try{ _logo=await _imgToDataUrl(loja.logo); }catch(_){} }
    var _foto=null; if(v.fotos&&v.fotos[0]){ try{ _foto=await _imgToDataUrl(v.fotos[0]); }catch(_){} }
    if(_foto){ try{ _foto=await _imgCoverDataUrl(_foto,800,520); }catch(_){} }
    var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'pt',format:'a4'});
    var pw=pdf.internal.pageSize.getWidth(), phg=pdf.internal.pageSize.getHeight(), m=40, cw=pw-2*m, y=0;
    var AZ=[0,30,80], AZ2=[10,77,166], TX=[15,23,42], CZ=[100,116,139], LN=[226,232,240], VD=[21,128,61], AM=[180,83,9], BR=[255,255,255];
    var FIM=phg-92;                     /* onde o conteúdo tem que parar (rodapé) */
    function fil(k){ pdf.setFillColor(k[0],k[1],k[2]); }
    function tex(k){ pdf.setTextColor(k[0],k[1],k[2]); }
    function fnt(sz,b){ pdf.setFont('helvetica',b?'bold':'normal'); pdf.setFontSize(sz); }
    function T(t,x,yy,al){ pdf.text(String(t==null?'':t),x,yy,al?{align:al}:undefined); }
    function tipo(du){ return (String(du||'').indexOf('image/png')>=0)?'PNG':'JPEG'; }
    function bordaLN(){ pdf.setDrawColor(LN[0],LN[1],LN[2]); }
    /* quebra de página: chame ANTES de desenhar um bloco, dizendo a altura
       dele. Se não couber, começa uma folha nova — nunca escreve por cima. */
    function precisa(h){ if(y+h>FIM){ pdf.addPage(); y=56; return true; } return false; }
    function linhas(txt,larg,sz,b){ fnt(sz,b); return pdf.splitTextToSize(String(txt||''), larg); }

    /* ---------------- cabeçalho azul da loja ---------------- */
    fil(AZ); pdf.rect(0,0,pw,96,'F');
    fil(AZ2); pdf.rect(0,96,pw,4,'F');
    if(_logo){ try{ fil(BR); pdf.roundedRect(pw-m-56,20,56,56,10,10,'F'); pdf.addImage(_logo,tipo(_logo),pw-m-52,24,48,48); }catch(_){} }
    var _nomeLoja=loja.nome_fantasia||loja.razao_social||'Proposta de venda';
    fnt(17,true); tex(BR);
    /* o nome da loja não pode invadir o espaço do logo */
    var _lnl=pdf.splitTextToSize(_nomeLoja, cw-(_logo?76:0));
    T(_lnl[0], m, 44);
    fnt(9.5,false); tex([185,205,235]);
    T([[loja.cidade,loja.uf].filter(Boolean).join('/'), loja.whatsapp||''].filter(Boolean).join('   ·   '), m, 62);
    fnt(8.5,true); tex(BR); T('PROPOSTA COMERCIAL', m, 81);

    /* ---------------- pra quem é e quando ---------------- */
    y=128;
    fnt(10,false); tex(CZ); T('Proposta preparada para', m, y);
    var _d=new Date(), _ds=('0'+_d.getDate()).slice(-2)+'/'+('0'+(_d.getMonth()+1)).slice(-2)+'/'+_d.getFullYear();
    T('Data: '+_ds, pw-m, y, 'right'); y+=18;
    fnt(15,true); tex(TX);
    T(pdf.splitTextToSize(_vp.cliente_nome||'—', cw-120)[0], m, y); y+=24;

    /* ---------------- cartão do veículo (altura acompanha o texto) --------- */
    var fW=160, fH=104;
    var tx0=_foto?(m+12+fW+16):(m+16), txW=pw-m-tx0-14;
    var _tit=_vpVeicNome(v)+(v.ano?(' '+v.ano):'');
    var tsz=13.5, tl=linhas(_tit,txW,tsz,true);
    if(tl.length>2){ tsz=11.5; tl=linhas(_tit,txW,tsz,true); }        /* nome comprido: diminui a letra */
    if(tl.length>3) tl=tl.slice(0,3);
    var _sub=[v.cor||'', v.km?(Number(v.km).toLocaleString('pt-BR')+' km'):'', v.placa||''].filter(Boolean).join('   ·   ');
    var _ex=(v&&v.extras)||{}, _difs=[];
    try{ _EX_DIF.forEach(function(dd){ if(_ex[dd.k]) _difs.push(dd.t); }); }catch(_){}
    if(String(_ex.opcionais||'').trim()) _difs.push(String(_ex.opcionais).trim());
    var dl=_difs.length?linhas(_difs.join('  ·  '),txW,9,false).slice(0,3):[];
    var _txtH=tl.length*(tsz+3.5)+16+(dl.length?dl.length*11+4:0);
    var ch=Math.max(_foto?(fH+24):56, _txtH+26);
    precisa(ch+16);
    fil([248,250,252]); bordaLN(); pdf.roundedRect(m,y,cw,ch,10,10,'FD');
    if(_foto){ try{ pdf.addImage(_foto,tipo(_foto),m+12,y+(ch-fH)/2,fW,fH); }catch(_){} }
    var vy=y+(ch-_txtH)/2+tsz;
    fnt(tsz,true); tex(TX); pdf.text(tl, tx0, vy); vy+=tl.length*(tsz+3.5)+1;
    fnt(10,false); tex(CZ); T(_sub, tx0, vy); vy+=15;
    if(dl.length){ fnt(9,false); tex(AZ2); pdf.text(dl, tx0, vy); }
    y+=ch+18;

    /* -------- USADO É PEÇA ÚNICA (só quando o carro tem quilometragem) ------ */
    var _usado=(Number(v.km)||0)>0;
    if(_usado){
      var exTxt='Cor, versão, opcionais, quilometragem e histórico deste veículo não se repetem: é uma unidade única nesta configuração. Vendido o carro, esta oportunidade não volta.';
      var exL=linhas(exTxt,cw-32,9,false);
      var exH=exL.length*11.5+34;
      precisa(exH+10);
      fil([255,251,235]); pdf.setDrawColor(253,230,138); pdf.roundedRect(m,y,cw,exH,10,10,'FD');
      fnt(9,true); tex(AM); T('EXCLUSIVIDADE  ·  UNIDADE ÚNICA', m+16, y+19);
      fnt(9,false); tex([120,53,15]); pdf.text(exL, m+16, y+33);
      y+=exH+18;
    }

    /* ---------------- os números ---------------- */
    function sec(t,h){ precisa((h||0)+34); fnt(9,true); tex(AZ2); T(String(t).toUpperCase(), m, y); y+=7; bordaLN(); pdf.line(m,y,pw-m,y); y+=18; }
    function row(lb,val,o){ o=o||{};
      var lw=cw-130;
      var ll=linhas(lb,lw,o.sz||11,!!o.b);
      precisa(ll.length*(o.gap||19));
      fnt(o.sz||11,!!o.b); tex(o.cl||TX); pdf.text(ll, m+(o.ind?14:2), y);
      fnt(o.sz||11,true); tex(o.clv||o.cl||TX); T(val, pw-m-2, y, 'right');
      y+=(ll.length-1)*((o.sz||11)+3)+(o.gap||19); }

    /* v372 — os VALORES APRESENTADOS AO CLIENTE (v370). O saldo é o mesmo da
       tela: avaliação apresentada = preço de tabela − saldo real. */
    var _saldoReal=Math.max(0,c.saldo);
    var _temUsadoNeg=!!(_vp.troca&&_vp.troca.tem&&c.aval>0);
    var _tabPad=+((v&&v.preco_anuncio)||0);
    var _tabApr=Number((_vp.apresentacao||{}).tabela)||_tabPad;
    if(_tabApr<_saldoReal) _tabApr=_saldoReal;
    var _avalApr=Math.max(0,Math.round((_tabApr-_saldoReal)*100)/100);
    var _apres=_temUsadoNeg&&_tabApr>0&&_avalApr>0;

    sec('Resumo da negociação');
    row('Valor do veículo', brl(_apres?_tabApr:c.precoFinal), {b:true});
    if(_temUsadoNeg){
      if(_apres){
        row('(-) Avaliação do seu usado'+(_vp.troca.modelo?(' — '+_vp.troca.modelo):''), '- '+brl(_avalApr), {clv:VD});
      } else if(c.quit>0){
        row('Avaliação do seu usado', brl(c.aval));
        row('(-) Quitação do financiamento', '- '+brl(c.quit), {ind:true, sz:10, cl:CZ, clv:AM, gap:17});
        row('(=) Seu usado na negociação', '- '+brl(c.trocaLiq), {b:true, clv:VD});
      } else row('(-) Avaliação do seu usado', '- '+brl(c.aval), {clv:VD});
    }
    if(_vp.transf_inclui) row('Transferência inclusa', brl(+_vp.transf_valor||700), {sz:10, cl:CZ});
    if(c.cort>0) row('Cortesia inclusa'+(_vp.cortesia_desc?(': '+_vp.cortesia_desc):''), brl(c.cort), {sz:10, cl:CZ});
    y+=6;

    /* faixa de destaque: o número que o cliente quer ver */
    var neg=(c.saldo<0);
    precisa(64);
    fil(neg?[240,253,244]:[239,246,255]);
    if(neg) pdf.setDrawColor(187,247,208); else pdf.setDrawColor(191,214,245);
    pdf.roundedRect(m,y,cw,54,10,10,'FD');
    fnt(10.5,false); tex(CZ); T(neg?'Volta pra você':'Saldo a pagar', m+16, y+32);
    fnt(20,true); tex(neg?VD:AZ); T(brl(Math.abs(c.saldo)), pw-m-16, y+36, 'right');
    y+=54+22;

    /* ---------------- financiamento ---------------- */
    if(c.parcelado){
      /* v372: o usado entra como ENTRADA, que é como o cliente e o banco leem */
      var _entUsado=_apres?_avalApr:0, _entTot=_entUsado+c.entrada;
      var bh=_entUsado>0?104:90;
      sec('Condições de financiamento', bh);
      fil(BR); bordaLN(); pdf.roundedRect(m,y,cw,bh,10,10,'FD');
      fnt(9.5,false); tex(CZ); T('Entrada', m+16, y+24);
      fnt(13,true); tex(TX); T(brl(_entTot), m+16, y+43);
      fnt(9.5,false); tex(CZ); T('Parcelas', m+16+cw*0.34, y+24);
      fnt(13,true); tex(TX); T(c.n+'x', m+16+cw*0.34, y+43);
      fnt(9.5,false); tex(CZ); T('Valor da parcela', pw-m-16, y+24, 'right');
      fnt(18,true); tex(AZ); T(brl(c.parcela), pw-m-16, y+45, 'right');
      var _ly=y+58;
      if(_entUsado>0){ fnt(8.5,false); tex(CZ); T('Entrada = seu usado '+brl(_entUsado)+(c.entrada>0?('  +  dinheiro '+brl(c.entrada)):''), m+16, y+58); _ly=y+72; }
      bordaLN(); pdf.line(m+14,_ly,pw-m-14,_ly);
      fnt(8.5,false); tex(CZ);
      T('Valor financiado '+brl(c.financiado)+'   ·   juros '+String(_vp.pag.juros).replace('.',',')+'% ao mês   ·   total pago '+brl(c.totalParc), m+16, _ly+18);
      y+=bh+20;
    } else if(c.saldo>0 && c.entrada>0){
      sec('Forma de pagamento', 40);
      row('Entrada', brl(c.entrada));
      row('Restante à vista', brl(Math.max(0,c.saldo-c.entrada)), {b:true});
      y+=10;
    }

    /* ============ v372 — EQUIPAMENTOS DE SÉRIE E OPCIONAIS ==================
       Vem da ficha do veículo, do jeito que o lojista deixou cadastrado:
         · série    = a lista de fábrica MENOS o que ele desmarcou
         · opcional = só o que ele marcou como "este carro tem"
       Sem ficha cadastrada, a seção simplesmente não aparece — nada de lista
       inventada numa proposta que o cliente leva pra casa. */
    var _serie=[], _opc=[];
    try{
      var _pl=limpa(String(v.placa||''));
      var _rz=(typeof fichaResumoLer==='function')?fichaResumoLer(_pl):null;
      if(!_rz){
        var _ft=fichaTecObter(_pl), _pp=_ft?fichaTecParse(_ft):null;
        if(_pp&&_pp.conhecido){
          _rz={ serie:(_pp.equip||[]).filter(function(e){ return !/OPCION|INDISPON/.test(e.disp); }).map(function(e){ return e.nome; }),
                opcionais:[], marcados:[], desmarcados:[] };
        }
      }
      if(_rz){
        var _dm=_rz.desmarcados||[];
        _serie=(_rz.serie||[]).filter(function(n){ return _dm.indexOf(n)<0; });
        _opc=(_rz.marcados||[]).slice();
      }
    }catch(_){ _serie=[]; _opc=[]; }
    if(String(_ex.opcionais||'').trim()){
      String(_ex.opcionais).split(/[,;·\n]+/).forEach(function(t){ t=String(t||'').trim(); if(t && _opc.indexOf(t)<0) _opc.push(t); });
    }
    /* Lista em DUAS COLUNAS. A altura é medida ANTES de escrever o título:
       assim o título nunca fica sozinho no pé de uma página com a lista na
       seguinte (foi o que aconteceu no primeiro teste). Se o bloco inteiro
       não couber no que sobrou da folha, ele começa na próxima. */
    function listaMedir(itens){
      var colW=(cw-18)/2, lh=12.6, ls=[];
      itens.forEach(function(it){ linhas('\u2022 '+it, colW-8, 9.2, false).forEach(function(l){ ls.push(l); }); });
      var meta=Math.ceil(ls.length/2);
      return { ls:ls, meta:meta, colW:colW, lh:lh, alt:(meta?((meta-1)*lh+12):0) };
    }
    function listaDesenhar(md, cor){
      fnt(9.2,false); tex(cor||TX);
      pdf.text(md.ls.slice(0,md.meta), m+2, y);
      if(md.ls.length>md.meta) pdf.text(md.ls.slice(md.meta), m+md.colW+16, y);
      y+=md.alt;
    }
    if(_serie.length){
      var mdS=listaMedir(_serie);
      sec('Equipamentos de série ('+_serie.length+')', mdS.alt);
      listaDesenhar(mdS, [30,64,90]);
      y+=14;
    }
    if(_opc.length){
      var mdO=listaMedir(_opc);
      sec('Opcionais deste veículo ('+_opc.length+')', mdO.alt);
      listaDesenhar(mdO, [146,64,14]);
      y+=14;
    }

    /* ============ v372 — AS VANTAGENS DA TROCA (comparativo por IA) ========= */
    var _cmp=(_vp&&_vp.comparacao)||null;
    if(_cmp && Array.isArray(_cmp.vantagens) && _cmp.vantagens.length){
      sec('Por que vale a pena trocar por este carro', 40);
      if(_cmp.resumo){
        var rl=linhas(_cmp.resumo, cw-4, 10, false);
        precisa(rl.length*13+8);
        tex(TX); pdf.text(rl, m+2, y); y+=rl.length*13+10;
      }
      _cmp.vantagens.forEach(function(x){
        x=x||{};
        var tt=String(x.titulo||x.categoria||'Vantagem').trim();
        var ex=String(x.explicacao||'').trim();
        var dd=[x.dado_novo?('Este carro: '+x.dado_novo):'', x.dado_usado?('Seu atual: '+x.dado_usado):''].filter(Boolean).join('     ·     ');
        var tL=linhas(tt, cw-26, 10.5, true);
        var eL=ex?linhas(ex, cw-26, 9.3, false):[];
        var dL=dd?linhas(dd, cw-26, 8.6, false):[];
        var h=tL.length*13+eL.length*11.5+(dL.length?dL.length*10+3:0)+12;
        precisa(h);
        fil([22,163,74]); pdf.circle(m+5, y-3.5, 3, 'F');           /* bolinha verde */
        fnt(10.5,true); tex(TX); pdf.text(tL, m+16, y); y+=tL.length*13;
        if(eL.length){ fnt(9.3,false); tex([71,85,105]); pdf.text(eL, m+16, y); y+=eL.length*11.5; }
        if(dL.length){ fnt(8.6,false); tex(CZ); pdf.text(dL, m+16, y+2); y+=dL.length*10+3; }
        y+=9;
      });
      var _pe=linhas('Comparação feita com apoio de inteligência artificial a partir das fichas técnicas dos dois veículos. Confirme versão e equipamentos antes de fechar.', cw-4, 8, false);
      precisa(_pe.length*10+6);
      fnt(8,false); tex(CZ); pdf.text(_pe, m+2, y); y+=_pe.length*10+4;
    }

    /* ---------------- rodapé em TODAS as páginas ---------------- */
    var _np=pdf.internal.getNumberOfPages();
    for(var _p=1;_p<=_np;_p++){
      pdf.setPage(_p);
      var fy=phg-76;
      bordaLN(); pdf.line(m,fy,pw-m,fy);
      fnt(8.5,false); tex(CZ);
      pdf.text(pdf.splitTextToSize('Proposta sujeita a análise e aprovação de crédito. Valores válidos por 3 dias ou enquanto o veículo estiver disponível em estoque. Este documento não é contrato de compra e venda.', cw-70), m, fy+17);
      fnt(9,true); tex(AZ);
      T(pdf.splitTextToSize([loja.nome_fantasia||loja.razao_social||'', loja.whatsapp||''].filter(Boolean).join('   ·   '), cw-70)[0], m, phg-28);
      if(_np>1){ fnt(8,false); tex(CZ); T(_p+'/'+_np, pw-m, phg-28, 'right'); }
    }

    var nome=(_vpVeicNome(v)+'-'+(v.placa||'proposta')).replace(/[^a-zA-Z0-9-]/g,'_');
    var url=URL.createObjectURL(pdf.output('blob')), a=document.createElement('a'); a.href=url; a.download='Proposta-'+nome+'.pdf'; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(url); a.remove(); },800);
    toast('PDF gerado.');
  }

  /* v195 — vpSalvar(true) = "salva calado": nao mostra recado, nao troca de
     tela e devolve true/false. E' o que a aba Venda fechada usa quando precisa
     CRIAR a linha no banco antes de guardar um comprovante.
     ATENCAO: quem chama pelo botao passa a chamar vpSalvar() sem argumento —
     antes o proprio evento do clique chegava aqui como parametro. */
  async function vpSalvar(silencioso){
    silencioso=(silencioso===true);
    var m=$('vpMsg'); if(m) m.className='cad-msg'; vpLe();
    if(!_vp.veiculo){ if(m){ m.className='cad-msg err'; m.textContent='Escolha um veículo primeiro.'; } return false; }
    var c=vpCalc(_vp), v=_vp.veiculo;
    /* ESPELHO da cotação (igual ao modelo da cotação do Polo): guarda os resumos
       exatamente como estão, pra reexibir no cadastro do cliente sem recalcular. */
    _vp.espelho = { simples:vpResumo(false), detalhado:vpResumo(true), valor:Math.round(c.precoFinal), veiculo:_vpVeicNome(v) };
    var reg={ cliente_id:_vp.cliente_id||null, cliente_nome:_vp.cliente_nome||null, estoque_id:v.estoque_id||null,
      placa:v.placa||'', veiculo:_vpVeicNome(v), ano:v.ano||'', cor:v.cor||'',
      valor_venda:Math.round(c.precoFinal)||null, forma_pagamento:(_vp.pag.tipo==='parcelado'?'Parcelado':'À vista'), proposta:_vp };
    /* v195 — BUG ANTIGO CORRIGIDO: a etapa vinha fixa em 'negociacao' em TODA
       salvada. Uma venda que ja' estava em "Entregue" voltava pro comeco do
       funil so' porque o vendedor reabriu a cotacao e salvou de novo. Agora a
       etapa so' e' escrita quando a linha e' CRIADA. */
    var btn=$('vpSalvar'); if(btn){ btn.disabled=true; btn.textContent='Salvando…'; }
    try{
      if(_vpEditId){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('vendas').update(reg).eq('id',_vpEditId); if(r&&r.error) throw r.error; }
      else { reg.user_id=meuId; reg.etapa='negociacao'; var r2=await supa.from('vendas').insert(reg).select().single(); if(r2&&r2.error) throw r2.error; _vpEditId=r2&&r2.data&&r2.data.id;
        try{ if(r2&&r2.data) (_vendas=_vendas||[]).unshift(r2.data); }catch(_){}
      }
      if(silencioso){ if(btn){ btn.disabled=false; btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>Salvar cotação'; } return true; }
      toast('Cotação salva.'); vendaSair(); return true;   /* v305: sai pro Estoque */
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } if(btn){ btn.disabled=false; btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>Salvar cotação'; } return false; }
  }

  /* ---- Contrato de compra e venda (documento para assinatura) ---- */
  function _numExtenso(n){
    n=Math.floor(Math.abs(+n||0)); if(n===0) return 'zero reais';
    var u=['','um','dois','três','quatro','cinco','seis','sete','oito','nove','dez','onze','doze','treze','quatorze','quinze','dezesseis','dezessete','dezoito','dezenove'];
    var d=['','','vinte','trinta','quarenta','cinquenta','sessenta','setenta','oitenta','noventa'];
    var c=['','cento','duzentos','trezentos','quatrocentos','quinhentos','seiscentos','setecentos','oitocentos','novecentos'];
    function tres(x){ if(x===0) return ''; if(x===100) return 'cem'; var o=[]; var ce=Math.floor(x/100), rs=x%100; if(ce) o.push(c[ce]); if(rs){ if(rs<20) o.push(u[rs]); else { var dz=Math.floor(rs/10), un=rs%10; o.push(d[dz]+(un?' e '+u[un]:'')); } } return o.join(' e '); }
    var p=[], mi=Math.floor(n/1000000), ml=Math.floor((n%1000000)/1000), rs=n%1000;
    if(mi) p.push(tres(mi)+(mi===1?' milhão':' milhões'));
    if(ml) p.push(ml===1?'mil':tres(ml)+' mil');
    if(rs) p.push(tres(rs));
    return p.join(' e ')+' reais';
  }
  async function vpPropostaAbrir(){
    if(!_vp || !_vp.veiculo){ toast('Escolha um veículo primeiro.'); return; }
    if($('vpForm')) vpLe(); var c=vpCalc(_vp), v=_vp.veiculo;
    var cli=(_clientes||[]).filter(function(x){return String(x.id)===String(_vp.cliente_id);})[0]||{};
    var loja=_lojaRec||await lojaGet()||{};
    var vend={nome:'',fone:''}; try{ var u=await supa.auth.getUser(); var md=(u&&u.data&&u.data.user&&u.data.user.user_metadata)||{}; vend.nome=md.nome||''; vend.fone=md.telefone||''; }catch(_){}
    var arras=c.entrada>0?c.entrada:Math.round((c.precoFinal||0)*0.10);
    /* v284 — o que passou pela tela de conferência entra na frente do resto.
       Sem isto você conferia CPF, placa, Renavam e chassi e o contrato abria
       com os campos velhos (ou vazios) do mesmo jeito: a conferência viraria
       teatro. Também puxo o que a IA leu do CRLV quando você ainda não
       conferiu — é sugestão, e o campo continua editável. */
    var _cf=(_vp&&_vp.conferido&&typeof _vp.conferido==='object')?_vp.conferido:{};
    var _crlv=(_vp&&_vp.docs_ia&&_vp.docs_ia.crlv)||{};
    function _pref(a,b,c2){ return String(a||b||c2||'').trim(); }
    var bg=cliModalEl(); bg.classList.add('on'); $('cliMav').innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/><path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/></svg>'; $('cliMt').textContent='Contrato de compra e venda';
    function I(id,lb,val,ph){ return '<label class="cad-lbl">'+lb+'</label><input class="cad-in" id="'+id+'" value="'+esc(val==null?'':val)+'" placeholder="'+esc(ph||'')+'">'; }
    function M(id,lb,val){ return '<label class="cad-lbl">'+lb+'</label><input class="cad-in" id="'+id+'" inputmode="numeric" value="'+(val?('R$ '+Number(val).toLocaleString('pt-BR')):'')+'" placeholder="R$ 0">'; }
    function C2(a,b){ return '<div class="cli-2col"><div>'+a+'</div><div>'+b+'</div></div>'; }
    $('cliMbody').innerHTML=
      '<div class="doc-hint">Os valores vêm da negociação. Revise dados das partes, veículo e condições antes de gerar ou assinar o contrato.</div>'+
      '<div class="cad-sec"><h3>Comprador</h3>'+I('prNome','Nome completo',_pref(_cf.nome,cli.nome))+C2(I('prCpf','CPF',_pref(_cf.cpf,cli.cpf)),I('prRg','RG',cli.rg))+C2(I('prFone','Fone',cli.telefone),I('prNasc','Nascimento',cli.nascimento))+I('prRua','Rua / nº',[cli.rua,cli.numero].filter(Boolean).join(', '))+C2(I('prBairro','Bairro',cli.bairro),I('prCep','CEP',cli.cep))+C2(I('prCidade','Cidade',cli.cidade),I('prProf','Profissão',''))+I('prOrigem','Como conheceu a loja','')+'</div>'+
      '<div class="cad-sec"><h3>Veículo</h3>'+C2(I('prMarca','Marca',v.marca),I('prModelo','Modelo',v.modelo))+C2(I('prAno','Ano',v.ano),I('prCor','Cor',v.cor))+C2(I('prPlaca','Placa',_pref(_cf.placa,v.placa,_crlv.placa)),I('prRenavam','Renavam',_pref(_cf.renavam,_crlv.renavam)))+I('prChassi','Chassi',_pref(_cf.chassi,_crlv.chassi))+'</div>'+
      '<div class="cad-sec"><h3>Valores</h3>'+C2(M('prArras','Sinal / arras',arras),M('prValor','Valor da compra',Math.round(c.precoFinal)))+I('prFormaObs','Forma de pagamento (obs)',(c.parcelado?'Financiado':'À vista'))+C2(M('prFinanciado','Valor financiado',c.parcelado?Math.round(c.financiado):0),I('prParcelasN','Nº parcelas',c.parcelado?c.n:''))+C2(M('prParcela','Valor cada parcela',c.parcelado?Math.round(c.parcela):0),I('prBanco','Banco',''))+M('prTransf','Transferência por conta do cliente',0)+'</div>'+
      '<div class="cad-sec"><h3>Garantia e revisões</h3>'+C2(I('prGarantia','Garantia (dias)','90'),I('prKm','KM atual',v.km?Number(v.km).toLocaleString('pt-BR'):''))+C2(I('prEntrega','Entrega (data)',''),I('prOleo','Óleo (tipo)','','deixe em branco se não souber'))+'<button type="button" class="btn-sec-lb" id="prOleoIA"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 4.6L18.5 9.5 13.9 11.4 12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z"/></svg>Descobrir o óleo certo com a IA</button><div class="cad-msg" id="prOleoMsg"></div>'+'</div>'+
      '<div class="cad-sec"><h3>Benefícios inclusos (pág. 2)</h3>'+C2(M('prBenOleo','Troca de óleo e filtro',100),M('prBenDesp','Serviço de despachante',200))+C2(M('prBenTanque','Tanque cheio',20),M('prBenRev','Revisão geral',550))+'</div>'+
      '<div class="cad-sec"><h3>Obrigações do comprador (pág. 2)</h3>'+C2(M('prPlacaRS','Troca de placa RS',350),M('prPlacaSC','Troca de placa SC',350))+C2(M('prTab','Tabelionato',60),M('prProc','Procuração (troca)',90))+'</div>'+
      '<div class="cad-sec"><h3>Local e data</h3>'+C2(I('prLocal','Cidade',loja.cidade||''),I('prData','Data',''))+'</div>'+
      '<button class="cad-btn" id="prGerar" style="margin-top:6px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M12 18v-6"/><polyline points="9 15 12 18 15 15"/></svg>Gerar PDF do contrato</button>'+
      '<div class="cad-sec"><h3>Assinatura</h3>'+
        '<div class="vp-acts"><button type="button" id="prAssinar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg><span>Enviar p/ assinatura</span></button><button type="button" id="prGov"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7 12 2"/></svg><span>Assinar no gov.br</span></button></div>'+
        '<div id="prAssResult"></div></div>'+
      '<div class="cad-msg" id="prMsg" style="text-align:center">2 páginas: contrato de compra e venda + termo de negociação.</div>';
    ['prArras','prValor','prFinanciado','prParcela','prTransf','prBenOleo','prBenDesp','prBenTanque','prBenRev','prPlacaRS','prPlacaSC','prTab','prProc'].forEach(function(id){ var e=$(id); if(e) e.oninput=estMaskRSint; });
    var pd=$('prData'); if(pd){ var t=new Date(); pd.value=('0'+t.getDate()).slice(-2)+'/'+('0'+(t.getMonth()+1)).slice(-2)+'/'+t.getFullYear(); }
    var poi=$('prOleoIA'); if(poi) poi.onclick=function(){ _prOleoIA(this); };
    $('prGerar').onclick=function(){ propostaPdf(_propColeta(loja,vend)); };
    var pa=$('prAssinar'); if(pa) pa.onclick=function(){ propostaEnviarAssinatura(_propColeta(loja,vend), cli); };
    var pg=$('prGov'); if(pg) pg.onclick=function(){ propostaGovBr(_propColeta(loja,vend)); };
  }
  async function _sha256(str){ try{ var enc=new TextEncoder().encode(str); var buf=await crypto.subtle.digest('SHA-256',enc); return Array.prototype.map.call(new Uint8Array(buf),function(b){return ('0'+b.toString(16)).slice(-2);}).join(''); }catch(_){ return ''; } }
  async function propostaEnviarAssinatura(D, cli){
    var out=$('prAssResult'); var hash=''; try{ hash=await _sha256(JSON.stringify(D)); }catch(_){}
    try{
      var reg={ user_id:meuId, cliente_nome:D.nome||null, cliente_cpf:D.cpf||null, titulo:'Contrato de compra e venda - '+(D.placa||D.marca||''), doc:D, doc_hash:hash, status:'pendente' };
      var r=await supa.from('assinaturas').insert(reg).select('id').single(); if(r&&r.error) throw r.error;
      var idc=r.data.id, url=location.origin+'/assinar/'+idc; _ultAssin={id:idc, D:D};
      var fone=(cli&&cli.telefone)?String(cli.telefone).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''):''; if(fone && fone.length<=11) fone='55'+fone;
      var msg='Segue o contrato de compra e venda para você conferir e assinar pelo celular:\n'+url;
      var wa=fone?('https://wa.me/'+fone+'?text='+encodeURIComponent(msg)):('https://wa.me/?text='+encodeURIComponent(msg));
      if(out) out.innerHTML='<div class="post-box" style="margin-top:8px"><div class="post-txt" style="font-size:11.5px;word-break:break-all">'+esc(url)+'</div><div class="post-acts"><button type="button" class="b1" id="prCopy">Copiar link</button><button type="button" class="b2" id="prWa">WhatsApp</button><button type="button" class="b3" id="prBaixarAss">Baixar assinado</button></div></div>';
      $('prCopy').onclick=function(){ try{ navigator.clipboard.writeText(url); toast('Link copiado.'); }catch(_){ prompt('Copie:',url); } };
      $('prWa').onclick=function(){ try{ window.open(wa,'_blank'); }catch(_){ location.href=wa; } };
      $('prBaixarAss').onclick=propostaBaixarAssinado;
      toast('Link de assinatura criado.');
    }catch(e){ toast('Não consegui criar o link. '+((e&&e.message)||'')); }
  }
  async function propostaBaixarAssinado(){
    if(!_ultAssin){ toast('Envie para assinatura primeiro.'); return; }
    try{
      var r=await supa.from('assinaturas').select('*').eq('id',_ultAssin.id).single(); var row=r&&r.data;
      if(!row){ toast('Documento não encontrado.'); return; }
      if(row.status!=='assinado'){ toast('O cliente ainda não assinou.'); return; }
      var D=row.doc||_ultAssin.D; D.assinatura={ img:row.assinatura_img, nome:row.signer_nome, cpf:row.signer_cpf, ip:row.ip, ua:row.user_agent, ts:row.assinado_em, hash:row.doc_hash };
      propostaPdf(D); toast('Documento assinado gerado.');
    }catch(e){ toast('Falha ao baixar. '+((e&&e.message)||'')); }
  }
  function propostaGovBr(D){
    propostaPdf(D);
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:344px"><div class="crop-tit">Assinar pelo gov.br</div><div class="crop-sub" style="text-align:left;line-height:1.6">Baixei o PDF pra você agora. Depois:<br>1) Abra o assinador do gov.br.<br>2) Envie o PDF baixado.<br>3) Faça login gov.br e assine.<br>4) Baixe o arquivo já assinado.</div><div class="vp-acts" style="margin-top:12px"><button type="button" class="pri" id="govOpen">Abrir assinador gov.br</button></div><button type="button" class="link" id="govFechar" style="margin-top:10px;width:100%">Fechar</button></div>';
    document.body.appendChild(ov);
    ov.querySelector('#govOpen').onclick=function(){ try{ window.open('https://assinador.iti.gov.br/','_blank'); }catch(_){ location.href='https://assinador.iti.gov.br/'; } };
    ov.querySelector('#govFechar').onclick=function(){ try{ ov.remove(); }catch(_){} };
  }
  /* v189: a IA pesquisa na web qual o óleo recomendado PRA ESSE MODELO.
     Se ela não tiver certeza, deixa o campo VAZIO de propósito — o recibo sai
     escrito "conforme a especificação do fabricante" em vez de um óleo errado. */
  async function _prOleoIA(btn){
    var msg=$('prOleoMsg'), inp=$('prOleo');
    function g(id){ var e=$(id); return e?(e.value||'').trim():''; }
    function _m(t,cor){ if(msg){ msg.textContent=t||''; msg.style.color=cor||'#64748b'; } }
    var mk=g('prMarca'), md=g('prModelo');
    if(!mk && !md){ _m('Preencha a marca e o modelo do veículo primeiro.','#b91c1c'); return; }
    var _rot=btn.innerHTML;
    btn.disabled=true; btn.textContent='Pesquisando…';
    _m('A IA está pesquisando o óleo recomendado pra esse modelo…','#64748b');
    var d=null;
    try{ d=await apiComTimeout('/api/venda-ia',{ tipo:'oleo', veiculo:{ marca:mk, modelo:md, versao:'', ano:g('prAno'), km:g('prKm') } },32000); }catch(_){ d=null; }
    btn.disabled=false; btn.innerHTML=_rot;
    if(!d||!d.ok){ _m(((d&&d.erro)||'Não consegui pesquisar agora.')+' Você pode digitar o óleo na mão.','#b91c1c'); return; }
    var ol=String(d.oleo||'').trim();
    if(!ol || d.confianca==='baixa'){
      if(inp) inp.value='';
      _m('A IA não teve certeza do óleo desse modelo. O contrato vai sair como "conforme a especificação do fabricante" — se você souber, digite acima.','#b45309');
      return;
    }
    if(inp) inp.value=ol;
    _m('Óleo sugerido pela IA'+(d.confianca?(' (confiança '+d.confianca+')'):'')+'. '+(d.obs||'')+' Confira no manual do veículo antes de assinar.','#15803d');
  }
  function _propColeta(loja,vend){
    function g(id){ var e=$(id); return e?(e.value||'').trim():''; }
    function n(id){ var e=$(id); return e?(parseInt(String(e.value||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0):0; }
    var ben={oleo:n('prBenOleo'),desp:n('prBenDesp'),tanque:n('prBenTanque'),rev:n('prBenRev')};
    return { loja:loja||{}, vendedor:vend||{},
      nome:g('prNome'), cpf:g('prCpf'), rg:g('prRg'), fone:g('prFone'), nasc:g('prNasc'),
      rua:g('prRua'), bairro:g('prBairro'), cep:g('prCep'), cidade:g('prCidade'), prof:g('prProf'), origem:g('prOrigem'),
      marca:g('prMarca'), modelo:g('prModelo'), ano:g('prAno'), cor:g('prCor'), placa:g('prPlaca'), renavam:g('prRenavam'), chassi:g('prChassi'),
      arras:n('prArras'), valor:n('prValor'), formaObs:g('prFormaObs'), financiado:n('prFinanciado'), parcelasN:g('prParcelasN'), parcela:n('prParcela'), banco:g('prBanco'), transf:n('prTransf'),
      garantia:g('prGarantia')||'90', oleo:g('prOleo'), km:g('prKm'), entrega:g('prEntrega'),
      ben:ben, benTotal:(ben.oleo+ben.desp+ben.tanque+ben.rev),
      obrig:{placaRS:n('prPlacaRS'),placaSC:n('prPlacaSC'),tab:n('prTab'),proc:n('prProc')},
      local:g('prLocal'), data:g('prData') };
  }
  async function propostaPdf(D){
    if(!_mevPdfPronto(function(){ propostaPdf(D); },false)) return;
    toast('Gerando contrato…');
    var jsPDF=window.jspdf.jsPDF, pdf=new jsPDF({unit:'mm',format:'a4'});
    var W=210,Rm=15,L=15,cw=W-L-Rm,y=15;
    var _logo=null; if(D.loja&&D.loja.logo){ try{ _logo=await _imgToDataUrl(D.loja.logo); }catch(_){} }
    function F(sz,b){ pdf.setFont('helvetica',b?'bold':'normal'); pdf.setFontSize(sz); }
    function col(r,g,b){ pdf.setTextColor(r,g,b); }
    function para(t,sz,gap){ F(sz||8); col(30,30,30); var ls=pdf.splitTextToSize(t,cw); pdf.text(ls,L,y); y+=ls.length*(sz||8)*0.42+(gap==null?1.6:gap); }
    function head(t){ F(9,true); col(10,42,102); pdf.text(t,L,y); y+=4.5; }
    function cells(arr,hh){ hh=hh||10; var x=L; arr.forEach(function(c){ pdf.setDrawColor(150,160,175); pdf.setLineWidth(0.2); pdf.rect(x,y,c.w,hh); F(5.5); col(110,110,110); pdf.text(c.l,x+1.4,y+2.9); F(8.5,c.b); col(15,15,15); var v=pdf.splitTextToSize(String(c.v||''),c.w-2.8); pdf.text(v.slice(0,2),x+1.4,y+6.6); x+=c.w; }); y+=hh; }
    function money(v){ return 'R$ '+Number(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    var LN=D.loja.nome_fantasia||D.loja.razao_social||'VENDEDOR';
    if(_logo){ try{ pdf.addImage(_logo, (_logo.indexOf('image/png')>=0?'PNG':'JPEG'), W/2-11, y, 22, 22); y+=25; }catch(_){} }
    F(15,true); col(10,42,102); pdf.text(LN, W/2, y, {align:'center'}); y+=6;
    F(8); col(90,90,90); pdf.text([D.loja.cnpj?('CNPJ '+D.loja.cnpj):'',[D.loja.cidade,D.loja.uf].filter(Boolean).join('/'),D.loja.whatsapp?D.loja.whatsapp:''].filter(Boolean).join('  ·  '), W/2, y, {align:'center'}); y+=5;
    F(11,true); col(20,20,20); pdf.text('CONTRATO DE COMPRA E VENDA DE VEÍCULO', W/2, y, {align:'center'}); y+=6;
    F(8); col(40,40,40); pdf.text('COMPRADOR:', L, y); y+=3.5;
    cells([{l:'Nome',v:D.nome,w:cw*0.46,b:true},{l:'RG',v:D.rg,w:cw*0.18},{l:'CPF',v:D.cpf,w:cw*0.18},{l:'Fone',v:D.fone,w:cw*0.18}]);
    cells([{l:'Endereço',v:D.rua,w:cw*0.46},{l:'Bairro',v:D.bairro,w:cw*0.2},{l:'CEP',v:D.cep,w:cw*0.16},{l:'Cidade',v:D.cidade,w:cw*0.18}]);
    cells([{l:'Profissão',v:D.prof,w:cw*0.4},{l:'Como conheceu',v:D.origem,w:cw*0.38},{l:'Nascimento',v:D.nasc,w:cw*0.22}]);
    cells([{l:'Entrada / sinal',v:money(D.arras)+'   ('+_numExtenso(D.arras)+')',w:cw,b:true}]); y+=1.5;
    para('Pelo presente contrato, o VENDEDOR identificado acima obriga-se a transferir ao COMPRADOR o veículo descrito abaixo, e o COMPRADOR obriga-se a pagar o preço e as condições definidos neste instrumento. O veículo permanece disponível, em horário comercial, para avaliação técnica do comprador e de profissional de sua confiança.',7.5);
    head('Descrição do veículo');
    cells([{l:'Marca',v:D.marca,w:cw*0.18},{l:'Modelo',v:D.modelo,w:cw*0.28},{l:'Ano',v:D.ano,w:cw*0.12},{l:'Cor',v:D.cor,w:cw*0.14},{l:'Placa',v:D.placa,w:cw*0.14},{l:'Renavam',v:D.renavam,w:cw*0.14}]);
    /* v284 — o chassi passou a sair impresso. É ele que identifica o carro em
       cartório e no Detran; sem ele o contrato descreve um veículo que pode
       ser qualquer um com aquela placa. */
    if(D.chassi) cells([{l:'Chassi',v:D.chassi,w:cw,b:true}]);
    cells([{l:'Valor da compra',v:money(D.valor)+'   ('+_numExtenso(D.valor)+')',w:cw,b:true}]);
    head('Forma de pagamento');
    cells([{l:'Condição',v:D.formaObs+(D.transf?(' · transf. p/ conta do cliente '+money(D.transf)):''),w:cw*0.4},{l:'Valor financiado',v:D.financiado?money(D.financiado):'—',w:cw*0.2},{l:'Nº parcelas',v:D.parcelasN||'—',w:cw*0.15},{l:'Valor cada',v:D.parcela?money(D.parcela):'—',w:cw*0.13},{l:'Banco',v:D.banco||'—',w:cw*0.12}],14); y+=3.5;
    para('Importante: A garantia legal NÃO inclui guincho ou reboque em caso de problemas mecânicos ou pane (não previsto no CDC); o guincho é de responsabilidade do consumidor. O veículo terá garantia de até '+(D.garantia||'90')+' dias conforme o CDC, a contar da data da compra, cobrindo motor e câmbio. Todo e qualquer reparo em garantia deve ser feito EXCLUSIVAMENTE em oficina/mecânico AUTORIZADO PELA LOJA VENDEDORA, com autorização prévia da loja antes do início do serviço; serviço feito sem essa autorização não será reembolsado e cancela a garantia. Perde-se também a garantia em caso de alteração das características originais do veículo, uso em competição ou reboque/carga acima do previsto pelo fabricante, e falta das revisões obrigatórias. Itens de desgaste natural — pintura e funilaria, pneus, palhetas, pastilhas e discos de freio, disco de embreagem, amortecedores, buchas e demais peças de suspensão, bateria, lâmpadas, correias, filtros, fluidos e lubrificantes, além de componentes elétricos e eletrônicos em geral — não são cobertos, ficando o comprador ciente de que fará tais reparos por sua conta e risco.',6.8,1.2);
    para('Em caso de inadimplemento das condições de pagamento aqui definidas, as partes deverão observar as condições expressas neste contrato e a legislação aplicável. As partes elegem o Foro de '+(D.local||D.cidade||'')+' para dirimir dúvidas. O comprador declara ser responsável pela transferência da propriedade para o seu nome, no prazo máximo de 30 dias a contar da compra.',6.8,1.2);
    var _ol=String(D.oleo||'').trim();
    F(6.8,true); col(190,30,30); var ob=pdf.splitTextToSize('OBS: Para valer a garantia, o comprador deve procurar a loja a cada 1.000 km ou 30 dias (o que ocorrer primeiro) para as revisões periódicas obrigatórias, sempre em oficina autorizada pela loja vendedora. A troca de óleo e filtro '+(_ol?('('+_ol+')'):'(conforme a especificação do manual do fabricante do veículo)')+' será paga pelo comprador.',cw); pdf.text(ob,L,y); y+=ob.length*6.8*0.42+2; col(20,20,20);
    head('Revisões');
    cells([{l:'1ª revisão (entrega) · KM',v:D.km||'',w:cw/3},{l:'2ª revisão · 30 dias ou 1.000 km',v:'',w:cw/3},{l:'3ª revisão · 60 dias ou 2.000 km',v:'',w:cw/3}]);
    cells([{l:'Data de entrega',v:D.entrega||'',w:cw}]); y+=3;
    F(8); col(20,20,20); pdf.text((D.local||'')+', '+(D.data||''), L, y); y+=13;
    var sx1=L+cw*0.24, sx2=L+cw*0.76;
    if(D.assinatura && D.assinatura.img){ try{ pdf.addImage(D.assinatura.img,'PNG',sx2-24,y-15,48,14); }catch(_){}
    }
    pdf.setDrawColor(30,30,30); pdf.line(sx1-26,y,sx1+26,y); pdf.line(sx2-26,y,sx2+26,y); y+=4;
    F(8); col(20,20,20); pdf.text('VENDEDOR',sx1,y,{align:'center'}); pdf.text('COMPRADOR',sx2,y,{align:'center'});
    if(D.assinatura && D.assinatura.nome){ y+=6; F(5.6); col(90,90,90);
      var au='Assinado eletronicamente por '+(D.assinatura.nome||'')+(D.assinatura.cpf?(' · CPF '+D.assinatura.cpf):'')+(D.assinatura.ts?(' · '+new Date(D.assinatura.ts).toLocaleString('pt-BR')):'')+(D.assinatura.ip?(' · IP '+D.assinatura.ip):'')+(D.assinatura.hash?(' · verificação '+String(D.assinatura.hash).slice(0,16)):'');
      var al=pdf.splitTextToSize(au, cw); pdf.text(al, W/2, y, {align:'center'}); col(20,20,20); }
    /* ===== Página 2 ===== */
    pdf.addPage(); y=18;
    F(13,true); col(10,42,102); pdf.text('TERMO ADICIONAL DE NEGOCIAÇÃO E RESPONSABILIDADES', W/2, y, {align:'center', maxWidth:cw}); y+=10;
    F(9,true); col(20,20,20); pdf.text('1. DOCUMENTAÇÃO PARA TRANSFERÊNCIA', L, y); y+=5;
    para('O comprador declara ciência de que é responsável por providenciar: Identidade ou CNH (digital ou física) · Comprovante de endereço atualizado ou declaração de residência autenticada · Autorização de CRVA para vistoria junto ao Detran · Outros.',8);
    y+=2; F(9,true); col(20,20,20); pdf.text('2. BENEFÍCIOS INCLUSOS NA COMPRA (valores de referência)', L, y); y+=5; F(8); col(30,30,30);
    [['Troca de óleo e filtro',D.ben.oleo],['Serviço de despachante',D.ben.desp],['Tanque cheio (combustível)',D.ben.tanque],['Revisão geral',D.ben.rev]].forEach(function(b){ pdf.text('•  '+b[0],L+3,y); pdf.text(money(b[1]),W-Rm,y,{align:'right'}); y+=5; });
    F(8,true); col(20,20,20); pdf.text('Total em benefícios',L+3,y); pdf.text(money(D.benTotal),W-Rm,y,{align:'right'}); y+=8;
    F(9,true); pdf.text('3. DETALHES DA NEGOCIAÇÃO', L, y); y+=5;
    F(8,true); pdf.text('3.1 Obrigações do Comprador:',L+2,y); y+=4.5; col(30,30,30);
    para('•  Custo de troca de placa (se aplicável): '+money(D.obrig.placaRS)+' no RS ou '+money(D.obrig.placaSC)+' em SC.',8,0.8);
    para('•  Despesas com tabelionato (assinatura de documentos): '+money(D.obrig.tab)+'.',8,0.8);
    para('•  Procuração para transferência (em caso de trocas): '+money(D.obrig.proc)+'.',8,1.5);
    F(8,true); col(20,20,20); pdf.text('3.2 Obrigações da Loja (Vendedor):',L+2,y); y+=4.5; col(30,30,30);
    para('•  Entrega do veículo revisado e em dia para rodar.',8,0.8);
    para('•  Isenção de débitos anteriores à data da venda.',8,1.8);
    F(9,true); col(20,20,20); pdf.text('4. DECLARAÇÕES FINAIS', L, y); y+=5; col(30,30,30);
    para('4.1 O comprador assume toda a responsabilidade por débitos identificados após a transferência, exceto se previamente declarados pela loja.',8,0.8);
    para('4.2 Em caso de troca de veículo, eventuais débitos do bem entregue serão descontados do valor da negociação.',8,0.8);
    para('4.3 A loja se reserva o direito de reter documentos até a quitação de valores pendentes.',8,2);
    F(9,true); col(20,20,20); pdf.text('5. CIÊNCIA E ACEITE', L, y); y+=5; col(30,30,30);
    para('Eu, '+(D.nome||'____________________')+' (Comprador), declaro ter lido e concordado com todos os termos acima.',8,2);
    F(8); pdf.text('Data: '+(D.data||''), L, y); y+=16;
    pdf.setDrawColor(30,30,30); pdf.line(L,y,L+70,y); pdf.line(W-Rm-70,y,W-Rm,y); y+=4;
    F(8); pdf.text('VENDEDOR(A)',L+35,y,{align:'center'}); pdf.text('COMPRADOR(A)',W-Rm-35,y,{align:'center'});
    var nm=(D.placa||D.nome||'contrato').replace(/[^a-zA-Z0-9]/g,'_');
    var url=URL.createObjectURL(pdf.output('blob')), a=document.createElement('a'); a.href=url; a.download='Contrato-compra-venda-'+nm+'.pdf'; document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(url); a.remove(); },800);
    var m=$('prMsg'); if(m){ m.className='cad-msg ok'; m.textContent='PDF gerado ✓'; } toast('Contrato gerado.');
  }

/* ╔═══ src/app/18b-deslizar-consultas.js ═════════════════════════════════ */
/* ============================================================================
   18b — DESLIZAR O DEDO PARA TROCAR DE CONSULTA (peça independente, v260)

   PEDIDO: na tela inicial, deslizar da DIREITA PRA ESQUERDA passa para a
   próxima consulta do menu — e de novo, e de novo:

        Consulta placa  →  Busca por veículo  →  Consulta Plus  →  CPF  →  CNPJ

   Deslizar de volta (esquerda pra direita) retorna à consulta anterior.
   Na tela inicial o gesto pra direita continua sendo o do MENU (v259) — este
   arquivo não encosta nele.

   POR QUE ESTÁ SEPARADO: não altera nenhum arquivo existente. Se atrapalhar,
   basta apagar este arquivo e rodar o montar.js.

   COMO ELE SABE ONDE ESTÁ: pergunta pra própria tela, não guarda contagem.
   Assim, se a pessoa chegar pelo menu, pelo "Voltar" ou por qualquer outro
   caminho, o deslize continua certo.
   ========================================================================= */
(function(){
  /* v1219 — navegação entre páginas somente pelos controles visíveis. */
  var trocarPaginaPorArraste=false;
  if(!trocarPaginaPorArraste) return;

  /* v401 (pedido): a sequência agora é O MENU INTEIRO, na ordem — depois da
     última consulta o deslize segue pra próxima página (Meu cadastro, Minha
     loja, Estoque...). Catálogo e Painel ficam de fora (abrem fora do app). */
  /* ⚠️ v437 — ITEM ESCONDIDO DO MENU NÃO ENTRA NA ROTA DO DESLIZE.
     Sem isto, esconder um item não adiantava nada: o gesto continuava
     passando por ele. Vale pro Funil (v437) e pro Chat, que nasce escondido
     pra quem não tem Atendente IA (v433) — quem não tinha chegava lá
     deslizando.

     ⚠️ NÃO dá pra usar offsetParent/display calculado: o submenu "Loja"
     (.mdr-sub) fica display:none enquanto está FECHADO, e aí Estoque,
     Vendas, Pós-vendas e Minha loja sairiam da rota — que é justamente o
     caminho que o Angelo mais usa. A diferença é a MECÂNICA:
        · submenu fechado  → esconde por CLASSE  (.mdr-sub / .mdr-sub.on)
        · item desativado  → esconde por STYLE INLINE (display:none)
     Então olhamos só o style inline, subindo até a .mdr-nav. */
  function _menuOculto(b){
    var n = b;
    while(n && !(n.classList && n.classList.contains('mdr-nav'))){
      if(!(n.classList && n.classList.contains('mdr-sub'))
         && n.style && n.style.display === 'none') return true;
      n = n.parentElement;
    }
    return false;
  }
  function sequencia(){
    var nav = document.querySelector('#mevDrawer .mdr-nav');
    if(!nav) return [];
    var fora = [];
    Array.prototype.forEach.call(nav.querySelectorAll('button[data-acao]'), function(b){
      var a = b.getAttribute('data-acao');
      if(a==='catalogo' || a==='painel') return;
      if(_menuOculto(b)) return;
      /* v486 — EDIÇÕES: item fora da edição some por CLASSE no body (não é
         style inline), então sai da rota aqui, pelo mapa do 00-edicoes. */
      try{ if(typeof window.edicaoPermite==='function' && !window.edicaoPermite(a)) return; }catch(_){}
      fora.push(a);
    });
    /* Sem destino permitido, o gesto não navega. Nunca restaurar excluídos. */
    return fora;
  }

  /* Em qual das telas estamos? -1 = nenhuma delas (não é comigo).
     v387: a posição vem da PRÓPRIA sequência do menu (nada de número fixo) e
     a tela é reconhecida DENTRO do #secoes — no computador os mesmos blocos
     (restWrap etc.) também existem como colunas da tela inicial, e esses não
     contam. */
  function _pagina(id){ return !!document.querySelector('#secoes #'+id); }
  function ondeEstou(){
    if(!document.body.classList.contains('tela-interna')) return 0;   /* tela inicial */
    var seq=sequencia();
    function p(a){ var i=seq.indexOf(a); return i<0?-1:i; }
    if(_pagina('fmWrap'))    return p('buscaveiculo');                /* Buscar por veículo (v406, no lugar do Histórico) */
    if(_pagina('mrWrap'))    return p('plus');                        /* Consulta Plus */
    if(_pagina('restWrap'))  return p('restricao');                   /* Consulta CPF */
    if(_pagina('cnpjWrap'))  return p('cnpj');                        /* Consulta CNPJ */
    if(_pagina('cadTabs'))     return p('cadastro');       /* Meu cadastro (v401) */
    if(_pagina('vdTabs'))      return p('vendas');
    if(_pagina('ljTabs')||_pagina('ljWrap')) return p('loja');
    if(_pagina('estLista'))    return p('estoque');
    if(_pagina('repMeuLista')) return p('repasse_meu');
    if(_pagina('avlLista'))    return p('avaliacoes');
    if(_pagina('crmLista')||_pagina('cliLista')) return p('clientes');
    if(_pagina('parHubTabs'))  return p('parceiros');
    if(_pagina('pagPacotes'))  return p('pagamentos');
    return -1;
  }

  /* 🔴🔴 v1050 — O PORTÃO DO GESTO (pedido do Angelo, 16/09)
     --------------------------------------------------------------------------
     "quando eu arrasto pra direita dentro do mev consulta na pagina do
      resultado da consulta, ta indo pra pagina de avaliacoes, nao permita o
      slide pra trocar de pagina, nem acessar o mev avaliacoes de dentro da
      consulta no mev consultas"

     ⚠️ NADA DE PERGUNTAR "é o MEV Consultas?" AQUI. Quem responde é o mapa
     das edições (00-edicoes), pela mesma razão que o `edPode` foi criado na
     v918. E, como lá, a falha cai pro lado de DEIXAR funcionar: sem a função
     (módulo fora de ordem, boot pela metade) o gesto continua como sempre —
     portão que trava por acidente tira um gesto que se usa todo dia. */
  function _podeTrocarDePagina(){
    try{ return (typeof window.edicaoDeslizaEntrePaginas!=='function')
                || !!window.edicaoDeslizaEntrePaginas(); }
    catch(_){ return true; }
  }
  function irPara(indice){
    var seq = sequencia();
    if(indice < 0 || indice >= seq.length) return false;
    if(seq[indice] === 'inicio'){
      if(typeof voltarHome === 'function'){ voltarHome(); return true; }
    }
    var botao = document.querySelector('#mevDrawer [data-acao="'+seq[indice]+'"]');
    if(!botao) return false;
    try{ if(typeof drawerFechar === 'function') drawerFechar(false); }catch(_){}
    botao.click();
    return true;
  }

  /* ===== v263 — DESLIZAR ENTRE A CONSULTA E A AVALIAÇÃO LOJISTA (pedido) =====
     Na tela do carro consultado: ← (direita pra esquerda) abre a Avaliação
     lojista; dentro dela, → (esquerda pra direita) volta pra consulta. Vale em
     qualquer ponto da tela — menos dentro de um campo, de um modal ou de algo
     que já role de lado (as abas e o carrossel de fotos continuam funcionando
     como antes).
     Sair da avaliação pelo deslize SALVA sozinho, igual ao "Salvar e fechar". */
  function naConsultaPlaca(){
    if(!document.body.classList.contains('tela-interna')) return false;
    if(!document.body.classList.contains('md-veiculo')) return false;
    return !!document.querySelector('#secoes .plc-placa');
  }
  function naAvaliacaoLojista(){
    var b = document.getElementById('avBody');
    return !!(b && b.offsetParent !== null);   /* está no DOM E visível */
  }
  /* a aba aberta é a primeira da barra? */
  function naPrimeiraAba(){
    var barra=document.querySelector('#avTabs');
    if(!barra) return true;                        /* sem abas: o gesto é meu */
    var abas=barra.querySelectorAll('.vpx-st');
    if(!abas.length) return true;
    return abas[0].classList.contains('on');
  }
  /* ===== v275 (pedido) — → NA TELA DA PLACA VOLTA =====
     Faltava a volta. Deslizar ← já abria a Avaliação lojista desde a v263, mas
     o gesto contrário não fazia nada: pra sair da placa, só tocando na setinha.

     NÃO invento o caminho de volta: CLICO NA PRÓPRIA SETINHA (#btnBackFab).
     Assim o deslize e o toque vão exatamente pro mesmo lugar, sempre — e o
     destino MUDA conforme de onde você veio (quem abriu pelo histórico volta
     pro histórico; quem veio da busca volta pra tela inicial). Clicando no
     botão, o deslize herda essa escolha sozinho, sem eu ter que repetir a
     regra aqui e sem risco de as duas se desencontrarem no futuro.

     Se a setinha estiver escondida (tela sem volta definida), caio no
     voltarHome() — o gesto nunca fica sem resposta. */
  function voltarDaPlaca(){
    try{
      var bf = document.getElementById('btnBackFab');
      if(bf && bf.offsetParent !== null){ bf.click(); return true; }   /* visível = tem pra onde voltar */
    }catch(_){}
    try{ if(typeof voltarHome === 'function'){ voltarHome(); return true; } }catch(_){}
    return false;
  }

  function modalAberto(){
    /* o modal de serviços da avaliação não tem role="dialog" — reconheço pela lista */
    return !!(document.getElementById('avSvLista') || document.querySelector('.pv-bg, .modal-bg.on'));
  }

  /* sobe a árvore procurando algo que já rola de lado (carrossel, abas) */
  function rolaDeLado(el){
    for(; el && el !== document.body; el = el.parentElement){
      try{
        if(el.scrollWidth > el.clientWidth + 4){
          var ov = getComputedStyle(el).overflowX;
          if(ov === 'auto' || ov === 'scroll') return true;
        }
      }catch(_){}
    }
    return false;
  }

  function podeComecar(alvo){
    if(!document.body.classList.contains('app-on')) return false;          /* ainda no login */
    var d = document.getElementById('mevDrawer');
    if(d && d.classList.contains('on')) return false;                      /* menu aberto: é do menu */
    if(!alvo || !alvo.closest) return false;
    if(alvo.closest('input,textarea,select,[contenteditable="true"]')) return false;
    if(alvo.closest('.cropmask,.cli-mbg,[role="dialog"],#mevPublicoViewer,.mev-publico,#legalGate,.legal-mask')) return false;
    if(modalAberto()) return false;
    if(rolaDeLado(alvo)) return false;
    if(naConsultaPlaca() || naAvaliacaoLojista()) return true;   /* v263 */
    return ondeEstou() >= 0;
  }

  var x0 = 0, y0 = 0, valendo = false;

  document.addEventListener('touchstart', function(e){
    valendo = false;
    if(!e.touches || e.touches.length !== 1) return;
    if(!podeComecar(e.target)) return;
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
    valendo = true;
  }, { passive:true });

  document.addEventListener('touchmove', function(e){
    if(!valendo) return;
    if(!e.touches || e.touches.length !== 1){ valendo = false; }
  }, { passive:true });

  document.addEventListener('touchend', function(e){
    if(!valendo) return;
    valendo = false;
    var t = (e.changedTouches && e.changedTouches[0]); if(!t) return;
    var dx = t.clientX - x0, dy = t.clientY - y0;

    /* precisa ser claramente horizontal e ter tamanho de gesto, não de toque */
    if(Math.abs(dx) < 60) return;
    if(Math.abs(dx) < Math.abs(dy) * 1.4) return;
    if(edicaoAtual()==='avalia') return;

    /* v263: consulta da placa  <->  avaliação lojista */
    if(naAvaliacaoLojista()){
      if(typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia') return;
      /* ===== v265 (BUG QUE EU MESMO CRIEI NA v263) =====
         Dentro da avaliação JÁ existia um deslize, desde a v240: ele troca de
         aba (→ aba anterior, ← próxima). Eu registrei o meu por cima, e os
         dois respondiam ao mesmo gesto: a aba trocava E a tela era fechada
         junto. Pior, dependia de onde o dedo encostava.
         Regra nova: sair da avaliação pelo deslize só quando a pessoa já está
         na PRIMEIRA aba — aí o "voltar uma aba" não tem pra onde ir e o gesto
         sobra pra mim. É o mesmo hábito de um livro: continua voltando página,
         e na última você fecha. Nas outras abas eu não faço nada e deixo a
         troca de aba acontecer sozinha. */
      if(dx > 0 && naPrimeiraAba()){               /* → volta pra consulta */
        try{ if(typeof avFormSalvar === 'function') avFormSalvar(); }catch(_){}
        try{ if(typeof avEspelhoGravar === 'function') avEspelhoGravar(); }catch(_){}
        try{ abrirMenu(); }catch(_){}
      }
      return;
    }
    if(naConsultaPlaca()){
      if(dx < 0){                                  /* ← abre a avaliação lojista */
        /* 🔴 v1050: nas edições que só voltam, este gesto NÃO abre nada.
           (O 13-abrir-avaliacao também barra na porta dele — duas travas de
           propósito: esta cala o GESTO, a de lá fecha a PORTA pra qualquer
           chamador. Uma sozinha deixaria meio caminho aberto.) */
        if(!_podeTrocarDePagina()) return;
        try{ abrirAvaliacaoLojista(); }catch(_){}
      } else {                                     /* → v275: volta (mesma setinha) */
        voltarDaPlaca();                           /* ⛳ voltar CONTINUA em toda edição */
      }
      return;
    }

    var aqui = ondeEstou();
    if(aqui < 0) return;

    /* ===== v401 (pedido) — página com ABAS PRÓPRIAS (Meu cadastro, Vendas,
       Minha loja...): o deslize troca as ABAS (quem faz é o deslize da v240);
       eu só assumo quando a pessoa está na ÚLTIMA aba (indo) ou na PRIMEIRA
       (voltando) — aí muda de página do menu, como num livro. As .cons-tabs
       ficam de fora: nas consultas cada "aba" já É uma página. */
    try{
      var _barra=document.querySelector('#secoes .vpx-steps:not(.cons-tabs)');
      if(_barra && (_barra.offsetParent!==null || _barra.offsetWidth>0)){
        var _abas=_barra.querySelectorAll('.vpx-st'), _i=-1;
        Array.prototype.forEach.call(_abas,function(b,k){ if(b.classList.contains('on')) _i=k; });
        if(_i>=0){
          if(dx<0 && _i<_abas.length-1) return;   /* ainda tem próxima aba */
          if(dx>0 && _i>0) return;                /* ainda tem aba anterior */
        }
      }
    }catch(_){}

    /* 🔴 v1050: nas edições que só voltam, o gesto para AQUI — ele nunca
       pula pra outra página do menu, nem pra frente nem pra trás. */
    if(!_podeTrocarDePagina()) return;
    if(dx < 0){                       /* ← da direita pra esquerda: próxima página */
      irPara(aqui + 1);
    } else if(aqui > 0){              /* → de volta: página anterior (na inicial, quem manda é o menu) */
      irPara(aqui - 1);
    }
  }, { passive:true });

  document.addEventListener('touchcancel', function(){ valendo = false; }, { passive:true });

})();

/* ╔═══ src/app/18c-salvar-fab.js ═════════════════════════════════════════ */
/* ============================================================================
   18c — "SALVAR E FECHAR" COMO FAB + BOTÕES DE AÇÃO NA MESMA LINHA (v263)

   Estes dois ajustes já tinham sido feitos antes e se PERDERAM: a ligação do
   FAB sumiu do 19-documentos-e-init.js e as regras de estilo sumiram do
   styles.css. Para não se perderem de novo, agora vivem aqui — num arquivo
   só deles, que não depende de nenhum outro. Se quiser desfazer, apague este
   arquivo e rode o montar.js.

   O que faz:
   1) O botão "Salvar e fechar", que ficava no meio da página, vira o FAB azul
      da barra de baixo.
   2) "Ver página", "WhatsApp" e "Lista repasse" ficam lado a lado, com o
      ícone em cima e o rótulo embaixo.

   ===== v263 (pedido) — O FAB APARECIA ONDE NÃO DEVIA =====
   Ele estava aparecendo até na tela inicial. Motivo: ao voltar pra home o app
   NÃO apaga o conteúdo da tela anterior (só esconde) — então o #avBtnFechar
   continuava existindo no HTML e a regra antiga ("existe o botão? mostra o
   FAB") dava certo pelo motivo errado. Além disso, dentro da avaliação todas
   as abas ficam montadas ao mesmo tempo, então o FAB aparecia em todas.

   Agora são três condições, todas juntas:
     1. a avaliação está aberta E VISÍVEL (não basta existir no HTML);
     2. a aba aberta é justamente a que tem o "Salvar e fechar" (Avaliação,
        desde a v1448);
     3. o botão existe.

   E, saindo da avaliação sem tocar no FAB, o rascunho é salvo sozinho — em
   dois momentos: no toque que leva pra fora (aí os campos ainda estão na tela)
   e quando o app vai pro segundo plano. Nunca salvo DEPOIS que os campos
   saíram do HTML: o rascunho iria vazio e apagaria o que estava guardado.
   ========================================================================= */
(function(){
  var CSS =
    '#avBody #avBtnFechar{display:none!important}'+
    '#btnSalvarFab{background:linear-gradient(135deg,#0a4da6,#1769d3);color:#fff}'+
    '#avBody .av-actbar,#avBody .av-actbar3{display:grid!important;grid-template-columns:repeat(3,1fr);gap:8px;align-items:stretch}'+
    '#avBody .av-actbar>*,#avBody .av-actbar3>*{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;'+
      'padding:11px 6px;min-width:0;text-align:center;font-size:12.5px;font-weight:800;line-height:1.2}'+
    '#avBody .av-actbar>* svg,#avBody .av-actbar3>* svg{width:20px;height:20px;flex:none;margin:0}'+
    /* v623 — QUATRO BOTÕES NO MESMO BLOCO (o "Gerar PDF" entrou ao lado do
       "Avisar lojistas", a pedido). Quatro numa linha só em 390px daria uns
       85px por botão, com o rótulo quebrando em três — então no celular a
       grade vira 2x2, e só do tablet pra cima os quatro ficam lado a lado. */
    '#avBody .av-actbar4{grid-template-columns:repeat(2,1fr)!important}'+
    '@media(min-width:700px){#avBody .av-actbar4{grid-template-columns:repeat(4,1fr)!important}}';

  function estilo(){
    if(document.getElementById('mevSalvarFabCss')) return;
    var st=document.createElement('style'); st.id='mevSalvarFabCss'; st.textContent=CSS;
    (document.head||document.documentElement).appendChild(st);
  }

  /* A avaliação está REALMENTE na tela? offsetParent é null quando o elemento
     existe no HTML mas está escondido (é o caso depois de voltar pra home). */
  function avaliacaoVisivel(){
    var corpo=document.getElementById('avBody');
    return !!(corpo && corpo.offsetParent!==null);
  }

  /* A aba aberta é a que tem o "Salvar e fechar"? */
  function abaDoBotao(){
    var b=document.getElementById('avBtnFechar'); if(!b) return false;
    var pn=b.closest?b.closest('.vpx-panel'):null;
    if(!pn) return true;                      /* sem abas: o botão manda */
    return pn.classList.contains('on');
  }

  /* salva o rascunho SEM fechar nada. Só roda com os campos ainda na tela —
     avFormObj() lê o HTML, e num HTML já desmontado salvaria tudo vazio. */
  function salvarSilencioso(){
    if(!document.getElementById('avObs')) return;
    /* v1481: sair sem anexar foto também cria/atualiza a avaliação privada.
       O caminho completo aceita `fotos: []`; o bloco antigo fica de reserva
       para builds parciais em que o módulo da avaliação ainda não carregou. */
    try{ if(typeof avAvaliacaoSalvarCompleta==='function'){ avAvaliacaoSalvarCompleta(); return; } }catch(_){}
    try{ if(typeof avFormSalvar==='function') avFormSalvar(); }catch(_){}
    try{ if(typeof avEspelhoGravar==='function') avEspelhoGravar(); }catch(_){}
  }

  function atualiza(){
    var fab=document.getElementById('btnSalvarFab'); if(!fab) return;
    /* v1485: a avaliação ganhou a ação final dentro da própria navegação de
       etapas. Quando ela existe, não duplicamos o mesmo salvar na barra. */
    var temNavegacaoFinal=!!document.getElementById('avEtapaProximo');
    var alvo = (avaliacaoVisivel() && abaDoBotao() && !temNavegacaoFinal) ? 'flex' : 'none';
    /* só escrevo quando MUDA: mexer no style é, ele mesmo, uma alteração que o
       vigia enxerga — escrever sempre viraria um vai-e-vem sem fim. */
    if(fab.style.display !== alvo) fab.style.display = alvo;
  }
  /* o 07-avaliacao.js chama isto toda vez que troca de aba */
  try{ window._salvarFabSync=atualiza; }catch(_){}

  function ligar(){
    estilo();
    var fab=document.getElementById('btnSalvarFab');
    if(fab && !fab._mevLigado){
      fab._mevLigado=true;
      fab.addEventListener('click', function(e){
        e.preventDefault();
        var alvo=document.getElementById('avBtnFechar');
        if(alvo) alvo.click();
      });
    }
    atualiza();
  }

  /* SALVAR AO SAIR: pego o toque na fase de CAPTURA, ou seja, antes de quem
     vai trocar de tela. Assim os campos ainda estão montados. Toque dentro do
     próprio formulário não conta — não é saída. */
  document.addEventListener('click', function(e){
    if(!avaliacaoVisivel()) return;
    var t=e.target; if(!t||!t.closest) return;
    if(t.closest('#avBody')) return;
    if(!t.closest('button,a,[data-acao],[data-back],.tela-back-lb,.menu-fab,.mdr-nav')) return;
    salvarSilencioso();
  }, true);
  /* app indo pro segundo plano (trocou de aba, bloqueou o celular) */
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState==='hidden' && avaliacaoVisivel()) salvarSilencioso();
  });
  window.addEventListener('pagehide', function(){ if(avaliacaoVisivel()) salvarSilencioso(); });

  /* a tela muda sem recarregar a página: observo o corpo e reavalio se o FAB
     deve aparecer. Uma vez por quadro, no máximo — nada de trabalho repetido. */
  function vigiar(){
    try{
      var pedido=null;
      var obs=new MutationObserver(function(){
        if(pedido) return;
        pedido=requestAnimationFrame(function(){ pedido=null; atualiza(); });
      });
      obs.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
    }catch(_){}
  }

  /* roda já e de novo quando a página terminar de montar — as duas chamadas
     são inofensivas, porque ligar() não repete o que já fez. */
  ligar(); vigiar();
  document.addEventListener('DOMContentLoaded', ligar);
  window.addEventListener('load', ligar);
})();

/* ╔═══ src/app/18d-deslizar-desktop.js ═══════════════════════════════════ */
/* ============================================================================
   18d — DESLIZAR NO COMPUTADOR (v359 · abas na v361 · páginas e menu na v366)

   O MAPA DO GESTO (dois dedos no trackpad), decidido com o Angelo:

     ←  DIREITA PRA ESQUERDA (avançar)
        1. tela com abas, e há próxima  ....... vai pra próxima aba
        2. tela com abas, já na ÚLTIMA  ....... ABRE O MENU (fim da linha)
        3. tela sem abas, dentro da sequência
           de consultas do menu ............... vai pra próxima consulta
           (Buscar placa → CPF → CNPJ → Leilão)
        4. já na ÚLTIMA consulta (leilão) ..... ABRE O MENU

     →  ESQUERDA PRA DIREITA (voltar)
        1. tela com abas, e há anterior ....... volta uma aba
        2. dentro da sequência de consultas ... volta pra consulta anterior
        3. o resto ............................ faz o que o botão Voltar faz
           (e, sem Voltar na tela, vai pra página inicial)

   NO CELULAR nada disso vale: lá o dedo já faz tudo (v240/v245 nas abas, 18b
   nas consultas, v259 no menu). Aqui é só o equivalente pra quem usa trackpad.

   COMO ELE SABE ONDE ESTÁ: pergunta pra própria tela, nunca guarda contagem.
     · abas → a barra `.vpx-steps` visível e o botão `.vpx-st` com classe `on`;
     · consultas → a ordem sai do PRÓPRIO MENU (os botões antes da primeira
       divisória), e a tela atual é reconhecida pelo bloco que ela monta
       (#restWrap, #cnpjWrap, #lhWrap).
   Se o menu mudar de ordem um dia, o gesto acompanha sozinho.

   POR QUE ESTÁ SEPARADO: não altera nenhum arquivo existente. Se atrapalhar,
   basta apagar este arquivo e rodar o montar.js.
   ========================================================================= */
(function(){
  /* v1219 — o gesto horizontal do trackpad não troca páginas nem abas. */
  var trocarPaginaPorArraste=false;
  if(!trocarPaginaPorArraste) return;
  var LIMITE = 240;     /* quanto o gesto precisa somar pra valer */
  var PAUSA  = 700;     /* ms de descanso depois de agir */
  var JANELA = 320;     /* ms parado = gesto novo (zera o acumulado) */
  var soma = 0, ultimo = 0, travado = false;

  function podeAgir(alvo){
    if(window.innerWidth < 900) return false;                          /* celular tem o gesto do dedo */
    if(!document.body.classList.contains('app-on')) return false;      /* ainda no login/abertura */
    try{
      var d = document.getElementById('mevDrawer');
      if(d && d.classList.contains('on')) return false;                /* menu aberto: o gesto não é nosso */
      if(document.querySelector('.crop-bg.on,.fsrc-bg.on,#cropBg.on,#plcConfBg.on')) return false;
      /* v403 (bug): o modal de pacotes mora SEMPRE no app.html com
         role="dialog" — checar só a existência bloqueava o deslize do
         trackpad EM TODA PARTE. Agora só bloqueia dialog VISÍVEL. */
      var _dl=document.querySelectorAll('[role="dialog"]');
      for(var _i=0;_i<_dl.length;_i++){ if(_dl[_i].offsetParent!==null) return false; }
      if(document.querySelector('.modal-bg.on,.instal-overlay')) return false;
    }catch(_){}
    if(alvo && alvo.closest){
      if(alvo.closest('input,textarea,select,[contenteditable="true"]')) return false;
      if(rolaDeLado(alvo)) return false;
    }
    return true;
  }

  /* sobe a árvore procurando algo que já rola na horizontal.
     A BARRA DE ABAS é exceção: ela rola de lado, mas o gesto em cima dela
     também é de trocar de aba. */
  function rolaDeLado(el){
    for(; el && el !== document.body; el = el.parentElement){
      try{
        if(el.classList && (el.classList.contains('vpx-steps') || el.classList.contains('vpx-st'))) return false;
        if(el.scrollWidth > el.clientWidth + 4){
          var ov = getComputedStyle(el).overflowX;
          if(ov === 'auto' || ov === 'scroll') return true;
        }
      }catch(_){}
    }
    return false;
  }

  /* ---- ABAS ---- */
  function abasDaTela(){
    try{
      var barras = document.querySelectorAll('.vpx-steps');
      for(var k = 0; k < barras.length; k++){
        var barra = barras[k];
        if(!barra.offsetParent && barra.offsetWidth === 0) continue;   /* escondida */
        var abas = Array.prototype.slice.call(barra.querySelectorAll('.vpx-st'));
        if(abas.length < 2) continue;
        var i = -1;
        abas.forEach(function(b, n){ if(b.classList.contains('on')) i = n; });
        if(i < 0) continue;
        return { abas: abas, i: i };
      }
    }catch(_){}
    return null;
  }

  /* ---- CONSULTAS DO MENU ---- */
  /* v401 (pedido): a sequência agora é O MENU INTEIRO, na ordem — depois da
     última consulta o deslize segue pra próxima página (Meu cadastro, Minha
     loja, Estoque...). Catálogo e Painel ficam de fora (abrem fora do app). */
  /* ⚠️ v437 — ITEM ESCONDIDO DO MENU NÃO ENTRA NA ROTA DO DESLIZE.
     Sem isto, esconder um item não adiantava nada: o gesto continuava
     passando por ele. Vale pro Funil (v437) e pro Chat, que nasce escondido
     pra quem não tem Atendente IA (v433) — quem não tinha chegava lá
     deslizando.

     ⚠️ NÃO dá pra usar offsetParent/display calculado: o submenu "Loja"
     (.mdr-sub) fica display:none enquanto está FECHADO, e aí Estoque,
     Vendas, Pós-vendas e Minha loja sairiam da rota — que é justamente o
     caminho que o Angelo mais usa. A diferença é a MECÂNICA:
        · submenu fechado  → esconde por CLASSE  (.mdr-sub / .mdr-sub.on)
        · item desativado  → esconde por STYLE INLINE (display:none)
     Então olhamos só o style inline, subindo até a .mdr-nav. */
  function _menuOculto(b){
    var n = b;
    while(n && !(n.classList && n.classList.contains('mdr-nav'))){
      if(!(n.classList && n.classList.contains('mdr-sub'))
         && n.style && n.style.display === 'none') return true;
      n = n.parentElement;
    }
    return false;
  }
  function sequencia(){
    var nav = document.querySelector('#mevDrawer .mdr-nav');
    if(!nav) return [];
    var fora = [], todos = [];
    Array.prototype.forEach.call(nav.querySelectorAll('button[data-acao]'), function(b){
      var a = b.getAttribute('data-acao');
      if(a==='catalogo' || a==='painel') return;
      todos.push(a);
      if(_menuOculto(b)) return;
      /* v486 — EDIÇÕES: item fora da edição sai da rota (mapa do 00-edicoes). */
      try{ if(typeof window.edicaoPermite==='function' && !window.edicaoPermite(a)) return; }catch(_){}
      fora.push(a);
    });
    /* SALVAGUARDA: se um dia todos ficarem de fora, volta ao comportamento
       antigo em vez de matar o deslize. */
    return fora.length ? fora : todos;
  }
  /* em qual consulta estamos? -1 = nenhuma (não é comigo)
     v387: posição vem da sequência do menu; a tela é reconhecida DENTRO do
     #secoes (as colunas da inicial usam os mesmos blocos e não contam). */
  function _pagina(id){ return !!document.querySelector('#secoes #'+id); }
  function ondeEstou(){
    if(!document.body.classList.contains('tela-interna')) return 0;    /* página inicial */
    var seq = sequencia();
    function p(a){ var i = seq.indexOf(a); return i < 0 ? -1 : i; }
    if(_pagina('fmWrap'))    return p('buscaveiculo');   /* Buscar por veículo (v406, no lugar do Histórico) */
    if(_pagina('mrWrap'))    return p('plus');
    if(_pagina('restWrap'))  return p('restricao');
    if(_pagina('cnpjWrap'))  return p('cnpj');
    if(_pagina('cadTabs'))     return p('cadastro');       /* Meu cadastro (v401) */
    if(_pagina('vdTabs'))      return p('vendas');
    if(_pagina('ljTabs')||_pagina('ljWrap')) return p('loja');
    if(_pagina('estLista'))    return p('estoque');
    if(_pagina('repMeuLista')) return p('repasse_meu');
    if(_pagina('avlLista'))    return p('avaliacoes');
    if(_pagina('crmLista')||_pagina('cliLista')) return p('clientes');
    if(_pagina('parHubTabs'))  return p('parceiros');
    if(_pagina('pagPacotes'))  return p('pagamentos');
    return -1;
  }
  function irPagina(i){
    var seq = sequencia(); var acao = seq[i];
    if(!acao) return false;
    var b = document.querySelector('#mevDrawer [data-acao="'+acao+'"]');
    if(!b) return false;
    try{ b.click(); }catch(_){ return false; }
    try{ window.scrollTo(0,0); }catch(_){}
    return true;
  }

  function abrirMenu(){
    var mf = document.getElementById('btnMenuFab');
    if(mf && mf.offsetParent !== null){ mf.click(); return true; }
    return false;
  }
  function voltar(){
    var bf = document.getElementById('btnBackFab');
    if(bf && bf.style.display !== 'none' && bf.offsetParent !== null){ bf.click(); return; }
    if(document.body.classList.contains('tela-interna')){
      var hf = document.getElementById('btnHomeFab');
      if(hf) hf.click();
    }
    /* na página inicial o gesto pra direita não faz nada: quem abre o menu é
       o gesto pra esquerda no fim da linha. */
  }

  /* 🔴🔴 v1050 — O PORTÃO DO GESTO (pedido do Angelo, 16/09)
     --------------------------------------------------------------------------
     "quando eu arrasto pra direita dentro do mev consulta na pagina do
      resultado da consulta, ta indo pra pagina de avaliacoes, nao permita o
      slide pra trocar de pagina, nem acessar o mev avaliacoes de dentro da
      consulta no mev consultas"

     ⚠️ NADA DE PERGUNTAR "é o MEV Consultas?" AQUI. Quem responde é o mapa
     das edições (00-edicoes), pela mesma razão que o `edPode` foi criado na
     v918. E, como lá, a falha cai pro lado de DEIXAR funcionar: sem a função
     (módulo fora de ordem, boot pela metade) o gesto continua como sempre —
     portão que trava por acidente tira um gesto que se usa todo dia. */
  function _podeTrocarDePagina(){
    try{ return (typeof window.edicaoDeslizaEntrePaginas!=='function')
                || !!window.edicaoDeslizaEntrePaginas(); }
    catch(_){ return true; }
  }
  /* dir: +1 = avançar (deslizou pra esquerda) · -1 = voltar (pra direita) */
  function agir(dir){
    var t = abasDaTela();
    if(document.getElementById('avBody') && typeof window.edicaoAtual==='function' && window.edicaoAtual()==='avalia'){
      if(t && t.abas[t.i+dir]) t.abas[t.i+dir].click();
      return;
    }
    if(edicaoAtual()==='avalia') return;
    var seq = sequencia();
    var p = ondeEstou();

    /* 🔴 v1050: nas edições que só voltam, a roda não pula de página.
       ⛳ As ABAS de dentro de uma página continuam trocando: elas são
       navegação DENTRO da mesma tela, não troca de página — e o Angelo reclamou
       de cair em OUTRO app, não de trocar de aba. */
    var _troca=_podeTrocarDePagina();

    if(dir > 0){
      if(t){
        if(t.abas[t.i + 1]){ try{ t.abas[t.i+1].click(); }catch(_){} try{ window.scrollTo(0,0); }catch(_){} return; }
        /* v401: passou da ÚLTIMA aba → próxima página do menu */
        if(!_troca) return;
        if(p >= 0 && p + 1 < seq.length){ irPagina(p + 1); return; }
        abrirMenu(); return;
      }
      if(!_troca) return;
      if(p >= 0 && seq.length){
        if(p + 1 < seq.length){ irPagina(p + 1); return; }
        abrirMenu(); return;                                  /* fim do menu */
      }
      return;
    }

    if(t && t.abas[t.i - 1]){ try{ t.abas[t.i-1].click(); }catch(_){} try{ window.scrollTo(0,0); }catch(_){} return; }
    /* v401: na PRIMEIRA aba, voltar = página anterior do menu */
    if(_troca && p > 0 && seq.length){ irPagina(p - 1); return; }
    voltar();                                     /* ⛳ voltar CONTINUA em toda edição */
  }

  window.addEventListener('wheel', function(e){
    if(travado) return;
    if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   /* gesto vertical: é rolagem */
    var agora = Date.now();
    if(agora - ultimo > JANELA) soma = 0;                  /* parou: começa de novo */
    ultimo = agora;
    soma += e.deltaX;
    if(Math.abs(soma) < LIMITE) return;
    var dir = (soma > 0) ? 1 : -1;                         /* soma>0 = deslizou pra ESQUERDA */
    if(!podeAgir(e.target)){ soma = 0; return; }
    travado = true; soma = 0;
    agir(dir);
    setTimeout(function(){ travado = false; }, PAUSA);
  }, { passive: true });
})();

/* ╔═══ src/app/18e-painel-admin.js ═══════════════════════════════════════ */
  /* ============================================================================
     18e — O PAINEL DO DONO, DENTRO DO APP (v513 · ampliado na v567)

     PEDIDO da v513: "o painel de admin parece estar abrindo um app separado,
     não é melhor abrir dentro do app?" — e não parecia: ELE ERA. O
     admin-painel.js devolve uma PÁGINA HTML inteira, com CSS e JS próprios,
     escrita como um ARRAY DE STRINGS com aspas escapadas à mão.

     PEDIDO da v567 (com print): *"melhore as informações, clica no card,
     mostra histórico do usuário, tempo de acesso liberado, último login… se
     achar necessário mais alguma informação, inclui"* e *"quero visualizar no
     MEV Veículos apenas os do MEV Veículos — lojas, usuários"*.

     🔴 O QUE SALVOU O PROJETO DA v513: a função JÁ É UMA API. Ela já responde
     JSON pro `acao:'dados'` e já tem as sete ações de escrita. Então isto aqui
     não reescreve painel nenhum — joga fora a casca de HTML e desenha os
     MESMOS números com o CSS que o app já tem.

     🟢 E O QUE FEZ A v567 CABER NUMA VERSÃO SÓ: **o servidor já mandava e a
     tela jogava fora.** `ultimo_login`, `ultima_consulta`, `consultas_7d`,
     `consultas_hoje`, `ilimitado`, `ia_gratis`, `whatsapp` e o `user_id` de
     cada cobrança já vinham no mesmo pacote. A ficha inteira desta versão não
     custa UMA linha de servidor nem UMA consulta a mais.

     🔴 A SEGURANÇA NÃO AFROUXOU, E ESSA É A LINHA QUE NÃO PODE SER CRUZADA:
     o painel enxerga TODAS as contas, e a RLS impede isso no navegador. A
     função continua sendo a ÚNICA porta — Service Role no servidor,
     conferindo ADMIN_EMAILS. O app manda o token e recebe JSON.
     ⚠️ Se um dia alguém "simplificar" trocando isto por um supa.from(...)
     direto, ou a RLS barra (e a tela fica vazia) ou é vazamento geral.
     NÃO FAÇA. A porta é a função.

     🔴🔴 DADO DE TERCEIRO NÃO ENTRA NESTA TELA (decisão do Angelo, v567).
     As consultas são de placas e CPFs de clientes DO LOJISTA — gente que
     nunca ouviu falar do MEV. A ficha mostra QUANTAS e QUANDO; nunca a placa
     e nunca o CPF. É a única decisão desta versão com cara de LGPD, e ela é
     de propósito.

     ⚠️ O /admin VELHO CONTINUA NO AR, de propósito. Se esta tela der
     problema, aquele ainda abre — e é lá que moram creditar token, dar dias,
     bloquear e exigir código. **Esta tela é SÓ LEITURA** (decisão do Angelo).
     Se um dia ganhar ação de escrita, vale a regra da v483: todo update pede
     a linha de volta e confere, senão a tela diz "✓ salvo" e o banco fica
     como estava.

     ⚠️ REAPROVEITA O MENU DO APP: as seções usam a mesma .vpx-steps das
     outras telas, que no computador já vira coluna à esquerda e no celular
     vira tira rolável. Um menu lateral novo do zero é como o painel de hoje
     nasceu.
     ========================================================================= */
  var _pnDados=null, _pnSec='geral', _pnBusca='', _pnSoPlacas=true, _pnAberto=null;

  function _pnEhAdmin(){ try{ return (typeof _ehAdmin==='function') && _ehAdmin(); }catch(_){ return false; } }
  function _pnN(n){ return Number(n||0).toLocaleString('pt-BR'); }
  function _pnData(iso){
    if(!iso) return '—';
    try{ var d=new Date(iso);
      return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+String(d.getFullYear()).slice(-2);
    }catch(_){ return '—'; }
  }
  function _pnDias(iso){
    if(!iso) return null;
    try{ var ms=Date.now()-new Date(iso).getTime(); if(!(ms>=0)) return null;
      return Math.floor(ms/86400000);
    }catch(_){ return null; }
  }
  /* "há 2 h", "há 9 dias" — a DISTÂNCIA diz mais que a data quando a pergunta
     é "esse cliente sumiu?". A data crua fica junto, entre parênteses. */
  function _pnHa(iso){
    if(!iso) return 'nunca';
    try{
      var ms=Date.now()-new Date(iso).getTime();
      if(!(ms>=0)) return _pnData(iso);
      var h=Math.floor(ms/3600000), d=Math.floor(h/24);
      if(h<1) return 'agora há pouco';
      if(h<24) return 'há '+h+' h';
      if(d<60) return 'há '+d+' dia'+(d===1?'':'s');
      return _pnData(iso);
    }catch(_){ return _pnData(iso); }
  }
  /* nome de máquina não vai pra tela: "SEM_PLANO" vira "Sem plano" */
  function _pnRotulo(s){
    var v=String(s||'').trim(); if(!v) return '';
    return v.replace(/_/g,' ').toLowerCase().replace(/^./,function(c){ return c.toUpperCase(); });
  }
  var _PN_SECOES=[
    ['geral','Visão geral'], ['lojas','Lojas'], ['usuarios','Usuários'],
    ['mudancas','Atualizações'], ['cobrancas','Cobranças']
  ];

  /* ==========================================================================
     🆕 AS ABAS PESSOAIS (refactor do projeto da Inspeção, passo 0)

     As cinco seções acima são de ADMIN: elas nascem do pacote que a função
     /api/admin-painel devolve com Service Role, e vivem em `_pnDados`.

     Uma aba PESSOAL é outra coisa: fala direto com `supa.from(...)` sob RLS,
     mostra só o que é do próprio usuário, e NÃO tem `_pnDados` nenhum.

     🔴 O DETALHE QUE MATAVA A IDEIA: o `_pnPinta()` começava com
            var el=$('pnBody'); if(!el || !_pnDados) return;
     — ou seja, a aba pessoal morria nesse `return` antes de desenhar. O
     conserto é despachar as pessoais ANTES desse guard, e só chamar o
     `_pnCarregar()` (o fetch de admin) quando a aba atual for de admin.

     Feito UMA vez aqui, serve as três abas pessoais que estão na fila:
     Inspeção, Rotina do dia e Prospecção. Cada uma registra a sua e cuida do
     próprio dado — este arquivo não precisa saber o que elas fazem.

     Como registrar, de outro módulo (ex.: 18g-inspecao.js):
         _pnRegistraPessoal('inspecao','Inspeção', function(el){ ... });
     O `abrir(el)` recebe o #pnBody e é dono dele enquanto a aba estiver ativa.
     ========================================================================== */
  var _PN_PESSOAL={};
  function _pnRegistraPessoal(chave, titulo, abrir){
    if(!chave || typeof abrir!=='function') return;
    _PN_PESSOAL[chave]={ titulo:titulo||chave, abrir:abrir };
    var ja=false;
    for(var i=0;i<_PN_SECOES.length;i++){ if(_PN_SECOES[i][0]===chave){ ja=true; break; } }
    if(!ja) _PN_SECOES.push([chave, titulo||chave]);
  }
  function _pnEhPessoal(sec){ return !!_PN_PESSOAL[sec]; }
  /* o interruptor "Só MEV Veículos" é de admin; numa aba pessoal ele não quer
     dizer nada. Escondo por `style.display` de propósito, e não por [hidden]:
     a lição da v736 é que `[hidden]` perde pro `display` que o autor do CSS
     já escreveu na classe. */
  function _pnTopoAplica(){
    try{
      var t=document.querySelector('.pn-topo');
      if(t) t.style.display = _pnEhPessoal(_pnSec) ? 'none' : '';
    }catch(_){ }
  }

  /* ==========================================================================
     🔴 "É DO MEV VEÍCULOS?" — E POR QUE A REGRA É LARGA
     A marca `user_metadata.app='placas'` (v446) só existe pra quem se
     cadastrou DEPOIS dela. Quem entrou antes não tem marca nenhuma — e com um
     filtro estreito sumiria da tela, possivelmente os PRIMEIROS lojistas.
     **Filtro que esconde cliente pagante é pior que filtro nenhum.**
     Então vale o RASTRO: tem loja, é assinante, ou já consultou.
     · lojas: o servidor já manda `mev_placas` pronto (ele soma a marca +
       carteira + ficha + loja + consulta). Usa ele, não reinventa.
     · usuários: o servidor NÃO manda a marca hoje — aqui a conta é feita pelo
       rastro que chega. Uma conta recém-criada e sem NENHUM rastro é o único
       caso que escapa; por isso a tela CONTA quantas escondeu, em vez de
       simplesmente mostrar menos (ver `_pnFiltra`).
     ⚠️ Mandar a marca também em `out.usuarios` é uma linha no servidor e está
     anotada pra próxima versão.
     ========================================================================== */
  function _pnEhPlacas(x, tipo){
    if(!x) return false;
    if(tipo==='loja') return !!x.mev_placas;
    if(tipo==='usuario') return !!(String(x.loja||'').trim() || x.assinante || Number(x.consultas_total||0)>0);
    return true;   /* cobrança nasce de plano do MEV Veículos */
  }
  /* devolve {lista, fora} — o "fora" é o que faz a tela poder DIZER que
     escondeu alguém, em vez de mostrar menos calada. */
  function _pnFiltra(itens, tipo){
    var todos=(itens||[]);
    if(!_pnSoPlacas) return { lista:todos, fora:0 };
    var l=todos.filter(function(x){ return _pnEhPlacas(x,tipo); });
    return { lista:l, fora: todos.length - l.length };
  }

  /* 🔴 a busca varre CAMPO A CAMPO, nunca o JSON inteiro. Buscando "199" no
     JSON, aparecia quem tem 199 tokens, 199 consultas e quem mora no número
     199 — e a pessoa não tem como saber por que aquele card veio. */
  function _pnCampos(x, tipo){
    if(tipo==='loja')    return [x.nome, x.email, x.cidade, _pnRotulo(x.situacao), (x.plano&&x.plano.nome)||x.plano_nome];
    if(tipo==='usuario') return [x.loja, x.email, x.whatsapp];
    return [x.loja, x.email, x.tipo, _pnRotulo(x.status), x.descricao,
      x.dados_fiscais&&x.dados_fiscais.nome, x.dados_fiscais&&x.dados_fiscais.cpf];
  }
  function _pnCasa(x, q, tipo){
    if(!q) return true;
    var c=_pnCampos(x,tipo);
    for(var i=0;i<c.length;i++){ if(String(c[i]||'').toLowerCase().indexOf(q)>=0) return true; }
    return false;
  }

  /* a bolinha: a conta inteira num relance, sem ler número nenhum */
  function _pnSinal(x, tipo){
    if(tipo==='loja'){
      if(x.situacao==='vencida'||x.situacao==='bloqueada') return ['ruim','vencida ou bloqueada'];
      if(x.situacao==='vencendo') return ['aten','vencendo'];
      if(x.situacao==='sem_plano') return ['neutro','sem plano'];
      return ['bom','ativa'];
    }
    var ult=x.ultimo_login||x.ultima_consulta||null;
    if(!ult) return ['neutro','nunca entrou'];
    var d=_pnDias(ult);
    if(d===null) return ['neutro','—'];
    if(d>=15) return ['aten','parado há '+d+' dias'];
    if(d<=7)  return ['bom','ativo'];
    return ['neutro','pouco movimento'];
  }

  async function telaPainelAdmin(){
    if(!_pnEhAdmin()){ toast('Área do administrador.'); return; }
    mevTabSet('');
    _pnAberto=null;
    var nav=_PN_SECOES.map(function(s){
      return '<button type="button" class="vpx-st'+(s[0]===_pnSec?' on':'')+'" data-pn="'+s[0]+'">'+
        '<span class="vpx-nm">'+esc(s[1])+'</span></button>';
    }).join('');
    irTela(panelHead(_PN_ICO,'blue','Painel','Só você vê esta tela')+
      '<div class="pn-topo"><label class="pn-sw"><input type="checkbox" id="pnSoPlacas"'+(_pnSoPlacas?' checked':'')+'>'+
        '<span>Só MEV Veículos</span></label></div>'+
      '<div class="vpx"><div class="vpx-steps vpx-mdr" id="pnTabs">'+nav+'</div>'+
      '<div class="vpx-body" id="pnBody">'+pgLoad('Carregando o painel…')+'</div></div>'+
      '<div class="cad-sec" style="margin-top:14px">'+
        '<button type="button" class="link" id="pnVelho" style="color:#64748b;font-size:12.5px">Abrir o painel antigo (/admin)</button></div>',
      'home');
    document.body.classList.remove('md-veiculo');
    Array.prototype.forEach.call(document.querySelectorAll('#pnTabs [data-pn]'),function(b){
      b.onclick=function(){ _pnSec=b.getAttribute('data-pn'); _pnAberto=null; _pnBusca='';
        Array.prototype.forEach.call(document.querySelectorAll('#pnTabs [data-pn]'),function(x){
          x.classList.toggle('on', x.getAttribute('data-pn')===_pnSec); });
        /* voltando pra uma aba de admin sem o pacote na mão (o primeiro clique
           depois de abrir numa aba pessoal), o _pnPinta sozinho não pintaria
           nada: quem busca é o _pnCarregar, que repinta se já tiver. */
        if(_pnEhPessoal(_pnSec)) _pnPinta();
        else _pnCarregar(); };
    });
    var sw=$('pnSoPlacas');
    if(sw) sw.onchange=function(){ _pnSoPlacas=!!this.checked; _pnAberto=null; _pnPinta(); };
    var bv=$('pnVelho'); if(bv) bv.onclick=function(){
      try{ window.open('/admin','_blank','noopener'); }catch(_){ location.href='/admin'; } };
    /* aba pessoal não usa o pacote de admin — não gasta a chamada de 25 s */
    if(_pnEhPessoal(_pnSec)) _pnPinta();
    else await _pnCarregar();
  }

  async function _pnCarregar(force){
    if(_pnDados && !force){ _pnPinta(); return; }
    var d=null;
    try{ d=await apiTimeout('/api/admin-painel',{acao:'dados'},25000); }catch(_){ d=null; }
    if(!d || d.ok===false){
      var el=$('pnBody');
      if(el) el.innerHTML='<div class="ui-state error"><b>Não consegui abrir o painel</b><small>'+
        esc((d&&d.erro)||'Tente de novo em instantes.')+'</small></div>';
      return;
    }
    _pnDados=d; _pnPinta();
  }

  function _pnPinta(){
    var el=$('pnBody'); if(!el) return;
    _pnTopoAplica();
    /* 🔴 as abas PESSOAIS despacham AQUI, antes do guard de `_pnDados` — elas
       não têm pacote de admin nenhum e morriam no return de baixo. */
    var pess=_PN_PESSOAL[_pnSec];
    if(pess){
      _pnAberto=null;
      try{ pess.abrir(el); }
      catch(e){
        el.innerHTML='<div class="ui-state error"><b>Não consegui abrir esta aba</b>'+
          '<small>'+esc((e&&e.message)||'Tente de novo.')+'</small></div>';
        try{ window.mevErro && window.mevErro(e,'_pnPinta/'+_pnSec); }catch(_){ }
      }
      return;
    }
    if(!_pnDados) return;
    var d=_pnDados;
    if(_pnAberto){ el.innerHTML=_pnFicha(_pnAberto.tipo, _pnAberto.id); _pnFichaWire(); return; }
    if(_pnSec==='geral')      el.innerHTML=_pnGeral(d);
    else if(_pnSec==='lojas') el.innerHTML=_pnLista(d.lojas||[], 'loja');
    else if(_pnSec==='usuarios') el.innerHTML=_pnLista(d.usuarios||[], 'usuario');
    else if(_pnSec==='mudancas') el.innerHTML=_pnMudancas(d.mudancas||[]);
    else el.innerHTML=_pnLista(d.cobrancas||[], 'cobranca');
    var bs=$('pnBusca');
    if(bs){ bs.value=_pnBusca; bs.oninput=function(){ _pnBusca=this.value; _pnPinta();
      var b2=$('pnBusca'); if(b2){ try{ b2.focus(); }catch(_){ } } }; }
    _pnCardsWire();
  }

  /* ---- Visão geral: os mesmos números do /admin, nos cartões do app ---- */
  function _pnGeral(d){
    var t=d.tot||{};
    function cel(n,l,cls){ return '<div class="er-cell"><span class="er-n'+(cls?(' '+cls):'')+'">'+
      esc(_pnN(n))+'</span><span class="er-l">'+esc(l)+'</span></div>'; }
    return '<div class="est-resumo" style="flex-wrap:wrap">'+
        cel(t.cadastros,'contas')+cel(t.novos_7d,'novas em 7 dias')+cel(t.lojas,'lojas')+
      '</div>'+
      '<div class="est-resumo" style="flex-wrap:wrap;margin-top:10px">'+
        cel(t.consultas_hoje,'consultas hoje')+cel(t.consultas_7d,'consultas em 7 dias')+
        cel(t.ativas,'lojas ativas')+
      '</div>'+
      '<div class="est-resumo" style="flex-wrap:wrap;margin-top:10px">'+
        cel(t.nunca,'nunca consultaram','warn')+cel(t.parados_48h,'parados 48h','warn')+
        cel(t.vencidas,'vencidas','warn')+
      '</div>'+
      '<div class="doc-hint" style="margin-top:14px">Estes números vêm da mesma fonte do painel antigo '+
      '(<b>/api/admin-painel</b>, ação <b>dados</b>). Se algum divergir, é bug desta tela — o servidor é o mesmo.</div>';
  }

  /* ==========================================================================
     AS LISTAS. Uma função só pros três tipos: a diferença é o que cada linha
     mostra, não como a lista se comporta.

     🔴 A ABA "LOJAS" DEIXOU DE LISTAR QUEM NÃO TEM LOJA (decisão do Angelo).
     No print, 7 dos 10 cards eram um e-mail com "— · SEM_PLANO": conta, não
     loja. Quem não tem loja já aparece em Usuários, que é o que o nome da aba
     promete. A tela diz quantas saíram, pra ninguém achar que sumiram.
     ========================================================================== */
  function _pnLista(itens, tipo){
    var q=String(_pnBusca||'').trim().toLowerCase();
    var f=_pnFiltra(itens, tipo);
    var base=f.lista, semLoja=0;
    if(tipo==='loja'){
      var comLoja=base.filter(function(x){ return !!String(x.nome||'').trim(); });
      semLoja=base.length-comLoja.length;
      base=comLoja;
    }
    var lista=base.filter(function(x){ return _pnCasa(x,q,tipo); });

    var busca='<div class="hh-search" style="margin-bottom:10px">'+_icoBusca+
      '<input id="pnBusca" class="hh-busca" type="search" aria-label="Buscar por nome, e-mail ou situação" placeholder="Buscar por nome, e-mail ou situação…" autocomplete="off"></div>';
    var avisos='';
    if(f.fora)  avisos+='<div class="doc-hint">'+_pnN(f.fora)+' fora do MEV Veículos — desligue "Só MEV Veículos" pra ver.</div>';
    if(semLoja) avisos+='<div class="doc-hint">'+_pnN(semLoja)+' conta(s) sem loja cadastrada aparecem em <b>Usuários</b>.</div>';

    if(!lista.length) return busca+avisos+'<div class="cli-empty"><b>Nada aqui</b>'+
      (q?'Nenhum resultado para “'+esc(_pnBusca)+'”.':'Ainda não há registros.')+'</div>';

    var linhas=lista.slice(0,300).map(function(x){
      var s=_pnSinal(x,tipo), t1,t2,t3;
      if(tipo==='loja'){
        t1=x.nome||x.email||'Loja';
        t2=[_pnRotulo(x.plano_nome||(x.plano&&x.plano.nome)||'sem plano'),
            (x.dias!=null? (x.dias>=0?('vence em '+x.dias+' dias'):('venceu há '+Math.abs(x.dias)+' dias')) : ''),
            (x.saldo!=null? precoReal(x.saldo) : '')].filter(Boolean).join(' · ');
        t3=[(x.equipe? (x.equipe+' na equipe'):''), _pnN(x.consultas_7d)+' consultas em 7 dias',
            'última '+_pnHa(x.ultima_consulta)].filter(Boolean).join(' · ');
      } else if(tipo==='usuario'){
        t1=x.loja||x.email||'Conta';
        t2=[(x.loja? x.email : ''), (x.ilimitado?'ilimitado':(x.saldo!=null?precoReal(x.saldo):'')),
            (x.assinante?'assinante':'')].filter(Boolean).join(' · ');
        t3=['último acesso '+_pnHa(x.ultimo_login), _pnN(x.consultas_total)+' consultas',
            'entrou '+_pnData(x.criado)].filter(Boolean).join(' · ');
      } else {
        t1=(x.loja||x.email||'Cobrança');
        t2=[_pnRotulo(x.tipo), _pnRotulo(x.status), x.valor!=null?('R$ '+_pnN(x.valor)):''].filter(Boolean).join(' · ');
        t3=['criada '+_pnData(x.criado_em),
            (x.pago_em?('paga '+_pnData(x.pago_em)):(x.vence_em?('vence '+_pnData(x.vence_em)):''))].filter(Boolean).join(' · ');
      }
      return '<button type="button" class="pn-card" data-pn-abre="'+esc(String(x.id||''))+'" data-pn-tipo="'+tipo+'">'+
        '<span class="pn-bola '+s[0]+'" title="'+esc(s[1])+'"></span>'+
        '<span class="pn-tx"><span class="pn-nm">'+esc(String(t1))+'</span>'+
        '<span class="pn-l2">'+esc(String(t2))+'</span>'+
        '<span class="pn-l3">'+esc(String(t3))+'</span></span></button>';
    }).join('');
    var demais=lista.length>300?('<div class="doc-hint">Mostrando 300 de '+_pnN(lista.length)+'. Use a busca pra afinar.</div>'):'';
    return busca+avisos+'<div class="doc-hint" style="margin-bottom:8px">'+_pnN(lista.length)+' registro(s)</div>'+linhas+demais;
  }

  function _pnCardsWire(){
    Array.prototype.forEach.call(document.querySelectorAll('#pnBody [data-pn-abre]'),function(b){
      b.onclick=function(){
        _pnAberto={ tipo:b.getAttribute('data-pn-tipo'), id:b.getAttribute('data-pn-abre') };
        _pnPinta();
        try{ window.scrollTo(0,0); }catch(_){}
      };
    });
  }

  /* ==========================================================================
     A FICHA — a conta inteira em pé, em blocos.
     ⚠️ Tudo aqui sai do MESMO pacote que a lista já tinha na mão. Zero
     consulta nova: buscar o histórico de todo mundo pra ver o de um seria
     carregar dez vezes mais pra mostrar o mesmo.
     ⚠️ O que NÃO está aqui e o projeto pediu: "quanto essa conta te custou"
     (unidades internas consumidas × custo). O pacote traz o saldo que SOBRA, não o que
     foi gasto — o gasto mora em `mp_creditos_movimento` e pede uma ação nova
     no servidor. Preferi não mostrar do que mostrar um número que parece
     esse e não é.
     ========================================================================== */
  function _pnAcha(tipo,id){
    var d=_pnDados||{}, l=(tipo==='loja'?d.lojas:(tipo==='usuario'?d.usuarios:d.cobrancas))||[];
    for(var i=0;i<l.length;i++){ if(String(l[i].id||'')===String(id)) return l[i]; }
    return null;
  }
  function _pnBloco(tit, linhas){
    var corpo=linhas.filter(Boolean).map(function(p){
      return '<div class="pn-li"><span class="pn-k">'+esc(p[0])+'</span><span class="pn-v'+(p[2]?(' '+p[2]):'')+'">'+esc(String(p[1]))+'</span></div>';
    }).join('');
    if(!corpo) return '';
    return '<div class="pn-bl"><div class="pn-bl-t">'+esc(tit)+'</div>'+corpo+'</div>';
  }
  function _pnFicha(tipo, id){
    var x=_pnAcha(tipo,id);
    var cobrancaAberta=(tipo==='cobranca'&&x)?x:null;
    var topo='<button type="button" class="link pn-volta" id="pnVolta">‹ voltar</button>';
    if(!x) return topo+'<div class="cli-empty"><b>Não achei esta conta</b>Ela pode ter saído da lista. Volte e abra de novo.</div>';

    var uid=String(x.id||'');
    if(tipo==='cobranca'){
      /* a cobrança abre a ficha DA CONTA — é ela que responde as perguntas */
      var dono=_pnAcha('usuario', x.user_id||'');
      if(dono){ x=dono; tipo='usuario'; uid=String(dono.id||''); }
    }
    var s=_pnSinal(x,tipo);
    var nome=(tipo==='loja'? (x.nome||x.email||'Loja') : (x.loja||x.email||'Conta'));
    var cab='<div class="pn-cab"><span class="pn-bola '+s[0]+'"></span><div><b>'+esc(nome)+'</b>'+
      '<small>'+esc(x.email||'')+(s[1]?(' · '+esc(s[1])):'')+'</small></div></div>';

    var dias=_pnDias(x.ultimo_login||x.ultima_consulta);
    var acesso=_pnBloco('Acesso',[
      ['Último login', _pnHa(x.ultimo_login)+(x.ultimo_login?(' ('+_pnData(x.ultimo_login)+')'):'')],
      (dias!=null && dias>=15) ? ['Parado há', dias+' dias', 'ruim'] : null,
      (x.dias!=null) ? ['Acesso liberado', (x.dias>=0? ('vence em '+x.dias+' dias'):('venceu há '+Math.abs(x.dias)+' dias'))+(x.validade?(' ('+_pnData(x.validade)+')'):''), (x.dias<0?'ruim':'')] : null,
      (x.situacao) ? ['Situação', _pnRotulo(x.situacao), (x.situacao==='vencida'||x.situacao==='bloqueada')?'ruim':''] : null,
      ['Entrou em', _pnData(x.criado)]
    ]);

    var carteira=_pnBloco('Plano e carteira',[
      ['Plano', _pnRotulo(x.plano_nome||(x.plano&&x.plano.nome)||'sem plano')],
      (x.valor!=null) ? ['Valor', 'R$ '+_pnN(x.valor)+(x.ciclo_dias?(' / '+x.ciclo_dias+' dias'):'')] : null,
      (x.auto_renova!=null) ? ['Renova sozinho', x.auto_renova?'sim':'não'] : null,
      ['Saldo', x.ilimitado?'ilimitado':(x.saldo!=null?precoReal(x.saldo):'—')],
      (x.ia_gratis!=null) ? ['IA de cortesia', _pnN(x.ia_gratis)] : null,
      (x.equipe!=null) ? ['Equipe', _pnN(x.equipe)+' pessoa(s)'] : null,
      (x.assinante!=null) ? ['Assinante', x.assinante?'sim':'não'] : null
    ]);

    var uso=_pnBloco('Uso',[
      ['Consultas hoje', _pnN(x.consultas_hoje||0)],
      ['Em 7 dias', _pnN(x.consultas_7d||0)],
      ['Total', _pnN(x.consultas_total||0)],
      ['Última consulta', _pnHa(x.ultima_consulta)+(x.ultima_consulta?(' ('+_pnData(x.ultima_consulta)+')'):'')]
    ]);

    /* as cobranças DESTA conta, filtradas aqui no navegador — o pacote já traz
       `user_id` em cada linha, então não custa ida ao servidor */
    var cobs=((_pnDados&&_pnDados.cobrancas)||[]).filter(function(c){ return String(c.user_id||'')===uid; });
    var pago=cobs.filter(function(c){ return c.status==='paga'; }).reduce(function(a,c){ return a+(Number(c.valor)||0); },0);
    var dinheiro=cobs.length ? _pnBloco('Dinheiro',[
      ['Cobranças', _pnN(cobs.length)],
      ['Pagas', _pnN(cobs.filter(function(c){ return c.status==='paga'; }).length)],
      ['Em aberto', _pnN(cobs.filter(function(c){ return c.status==='aberta'; }).length)],
      ['Total já pago', 'R$ '+_pnN(pago)]
    ]) : _pnBloco('Dinheiro',[['Cobranças','nenhuma']]);

    var nf=(cobrancaAberta&&cobrancaAberta.dados_fiscais) ? _pnBloco('Dados para nota fiscal',[
      ['Nome completo',cobrancaAberta.dados_fiscais.nome||'—'],
      ['CPF',cobrancaAberta.dados_fiscais.cpf||'—'],
      ['Telefone',cobrancaAberta.dados_fiscais.telefone||'—'],
      ['Valor da recarga','R$ '+_pnN(cobrancaAberta.valor||0)],
      ['Recebido em',_pnData(cobrancaAberta.dados_fiscais.enviado_em)]
    ]) : '';

    var zap=String(x.whatsapp||'').replace(/\D/g,'');
    var acoes=zap ? '<div class="pn-acoes"><button type="button" class="btn btn-azul" id="pnZap">Falar no WhatsApp</button></div>' : '';

    return topo+cab+acesso+carteira+uso+dinheiro+nf+acoes+
      '<div class="doc-hint" style="margin-top:12px">Esta tela é só leitura. Adicionar saldo, dar dias, bloquear e '+
      'exigir código continuam no painel antigo.</div>'+
      '<div class="doc-hint">As consultas aparecem em quantidade e data — a placa e o CPF do cliente do lojista não entram aqui.</div>';
  }
  function _pnFichaWire(){
    var v=$('pnVolta'); if(v) v.onclick=function(){ _pnAberto=null; _pnPinta(); };
    var z=$('pnZap');
    if(z) z.onclick=function(){
      var x=_pnAcha(_pnAberto&&_pnAberto.tipo, _pnAberto&&_pnAberto.id); if(!x) return;
      var d=String(x.whatsapp||'').replace(/\D/g,''); if(!d) return;
      if(d.length<=11) d='55'+d;      /* a mesma regra de DDI do resto do app */
      try{ window.open('https://wa.me/'+d,'_blank','noopener'); }catch(_){}
    };
  }

  /* ---- Atualizações: por enquanto SÓ LEITURA (o excluir/arquivar e o envio
         por e-mail são a Fase 2 — ações de escrita merecem confirmação
         própria). ⚠️ O teste-v513 cobra a palavra "Fase 2" aqui e no texto de
         baixo: foi o combinado da v513 pra tela não prometer o que não faz. */
  function _pnMudancas(ms){
    if(!ms.length) return '<div class="cli-empty"><b>Nenhuma atualização</b>Elas nascem no painel antigo, na aba Mudanças.</div>';
    return ms.slice(0,40).map(function(m){
      var n=(m.itens&&m.itens.length)||0;
      var selo=m.enviado_em
        ? '<span class="est-dias">enviada '+_pnData(m.enviado_em)+(m.enviado_para?(' · '+m.enviado_para+' pessoa(s)'):'')+'</span>'
        : '<span class="est-dias d30">rascunho</span>';
      return '<div class="pc-card" style="cursor:default;display:block"><div class="pc-nm">'+
        esc(_pnData(m.dia))+' — '+n+' item(ns) '+selo+'</div>'+
        '<div class="pc-tp" style="white-space:normal">'+esc(String(m.resumo||'(sem resumo)').slice(0,260))+'</div></div>';
    }).join('')+
    '<div class="doc-hint">Excluir, arquivar e enviar por e-mail são a Fase 2 — hoje isso continua no painel antigo.</div>';
  }

  var _PN_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>';

/* ╔═══ src/app/18f-avisar-lojistas.js ════════════════════════════════════ */
  /* ==========================================================================
     18f — AVISAR LOJISTAS: A FOLHA (v514)
     (PROJETO-avisar-lojistas-chat-email-notificacao — Partes 1, 3 e 4)

     PEDIDO (Angelo, 16/08): "depois de cadastrar um veículo de repasse
     poderia enviar ele via chat interno para o lojista. O lojista receber
     também o email, além do chat interno, e também aparecer nas
     notificações do aplicativo."

     🔴 UMA PEÇA, TRÊS PORTAS. O seletor de destinatários NÃO se escreve
     três vezes. Este mesmo componente atende:
       PORTA A — carro publicado no repasse (09-portal-repasse.js);
       PORTA B — carro do estoque, pelo menu de ações (14-estoque.js);
       PORTA C — as novidades do dia (mp_mudancas) — ainda não ligada; o
                 motor dela é o `mudancas_enviar` do /api/admin-painel, que
                 já existe. Quando ligar, é só chamar avisarLojistasAbrir()
                 com o texto do dia. NADA aqui precisa mudar.

     COMO CHAMAR:
        avisarLojistasAbrir(texto, titulo, { link:'https://…' })
     · `texto`  = a mensagem que vai (nas portas A e B é o estVeicMsg, o
                  MESMO texto do compartilhar do catálogo — v508);
     · `titulo` = o assunto do e-mail e a manchete do sino;
     · `link`   = a página pública do carro, que vira o botão do e-mail.

     O QUE A TELA FAZ (e por que):
     · lista os lojistas do mp_chat_diretorio() (v508 — só contas do MEV
       Placas), com caixinha, busca e "marcar todos";
     · MOSTRA A PRÉVIA da mensagem: ninguém dispara pra 7 lojas sem ver o
       que vai;
     · canais: chat (sempre) · e-mail · notificação. O chat é o canal-base
       porque é o único que fica GRAVADO numa conversa que dá pra responder;
     · confirma com a CONTAGEM antes ("Vai para 7 lojistas. Enviar?");
     · mostra o progresso ("3 de 7") — o envio é uma FILA no servidor e
       pode precisar de mais de uma chamada. Ver /api/avisar-lojistas.

     ⛳ O INTERRUPTOR DO MODO DE TESTE — MEV_AVISO_TESTE (logo abaixo).
     Ele NÃO tranca nada: só decide se a caixinha "mandar só pra mim
     (teste)" nasce MARCADA. A caixinha é sempre a palavra final, então o
     Angelo ensaia e manda pra valer sem precisar de ninguém mexer no
     código. Mesmo padrão do MEV_PREVIA (v497) e do MEV_FAIXA (v502): uma
     linha, comentada, fácil de achar e de desligar.
     ⚠️ Modo de teste troca o DESTINO, nunca o CAMINHO — quem substitui é
     o servidor, com as MESMAS funções do envio de verdade. Um modo de
     teste que usa outro código não prova nada.

     ⚠️ ONDE ESTE ARQUIVO VIVE: dentro do IIFE grande (abre no 01-nucleo,
     fecha no 19). Precisa ordenar ANTES do 19 — daí o "18f". O 09 e o 14
     chamam avisarLojistasAbrir com typeof-guard: sem este arquivo o app
     continua inteiro, só sem o botão.
     ========================================================================= */

  /* ⛳ true = a caixinha "mandar só pra mim (teste)" nasce MARCADA. */
  var MEV_AVISO_TESTE = true;

  var _aljTexto='', _aljTitulo='', _aljLink='', _aljDir=[], _aljMarcados={}, _aljEnviando=false;
  /* v560: a foto de CAPA do carro, que vai junto no card do chat do lojista.
     ⛳ CAPA_AVISO = false e nenhuma capa sai daqui. */
  var CAPA_AVISO = true;
  var _aljFoto='';
  /* v563: quem é o carro deste aviso — é dela que sai o lote do dia. */
  var _aljChave='';

  var ALJ_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';

  /* ===== v563 — O LOTE DO DIA (a trava do "não recebe duas vezes") ========
   * O servidor já sabia não repetir: o índice único (lote, para_user, canal)
   * da `mp_aviso_envio` pula quem já recebeu. Só que o app SORTEAVA um lote
   * novo a cada envio — então a trava só valia dentro do mesmo envio (a fila
   * retomável), nunca entre dois envios do mesmo carro.
   *
   * Agora o lote é CALCULADO a partir de quem é o carro + o dia de hoje.
   * Mesmo carro, mesmo dia, mesmo lojista → o banco entrega UMA vez, não
   * importa por qual botão nem quantas vezes você tocar.
   *
   * ⚠️ POR QUE O DIA ENTRA NA CONTA: sem ele o carro ficaria travado pra
   * sempre — e reavisar a rede uma semana depois, com preço novo, é uso
   * legítimo. O dia é a fronteira entre "toquei duas vezes" e "resolvi
   * avisar de novo".
   * ⚠️ O MODO DE TESTE continua sorteando: ele manda só pra você, e gastar o
   * lote do dia num teste bloquearia o envio de verdade logo depois.
   * ⛳ LOTE_DO_DIA = false volta ao lote sorteado da v562.
   * ========================================================================= */
  var LOTE_DO_DIA = true;
  function _aljDiaHoje(){
    try{ var d=new Date(); return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    catch(_){ return 'sem-dia'; }
  }
  /* uuid DETERMINÍSTICO (FNV-1a em 4 trilhos). Não é criptografia — é só um
     jeito de a mesma chave dar sempre o mesmo uuid, no formato que o
     servidor valida. */
  function _aljLoteDoDia(chave){
    var s=String(chave||'').trim(); if(!s) return '';
    s = s+'|'+_aljDiaHoje();
    var h=[0x811c9dc5,0x01000193,0xdeadbeef,0x9e3779b9];
    for(var i=0;i<s.length;i++){
      var c=s.charCodeAt(i);
      for(var k=0;k<4;k++){ h[k]=(((h[k]^(c+k+1))>>>0)*16777619)>>>0; }
    }
    var hex=h.map(function(x){ return ('00000000'+(x>>>0).toString(16)).slice(-8); }).join('');
    if(hex.length<32) return '';
    return hex.slice(0,8)+'-'+hex.slice(8,12)+'-4'+hex.slice(13,16)+'-'+
      ((parseInt(hex[16],16)&0x3|0x8).toString(16))+hex.slice(17,20)+'-'+hex.slice(20,32);
  }
  function aljUuid(){
    try{ if(window.crypto && crypto.randomUUID) return crypto.randomUUID(); }catch(_){}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
      var r=Math.random()*16|0; return (c==='x'?r:((r&0x3)|0x8)).toString(16);
    });
  }

  /* A prévia mostra o texto COMO ELE VAI CHEGAR. A mensagem é escrita pro
     WhatsApp, onde *asterisco* é negrito — e o chat do app (v508) e o
     e-mail (a function) já convertem. Se só a prévia mostrasse o asterisco
     cru, a tela estaria mentindo sobre o que sai daqui. */
  function aljPrevia(t){
    return esc(String(t||'')).replace(/\*([^*\n]+)\*/g,'<b>$1</b>');
  }

  function avisarLojistasAbrir(texto, titulo, opts){
    opts=opts||{};
    _aljTexto=String(texto||'').trim();
    if(!_aljTexto){ toast('Não há mensagem pra enviar.'); return; }
    _aljTitulo=String(titulo||'').trim();
    _aljLink=String(opts.link||'').trim();
    /* v560: a capa é OPCIONAL — porta que não tem foto manda '' e o card sai
       como sempre saiu. Ninguém precisa mudar pra continuar funcionando. */
    _aljFoto=CAPA_AVISO ? String(opts.foto||'').trim() : '';
    _aljChave=String(opts.chave||'').trim();   /* v563 */
    _aljMarcados={}; _aljEnviando=false;
    aljMontar();
    var f=$('aljFolha'); if(f) f.classList.add('on');
    aljPintaCorpo();
    aljCarregarDiretorio();
  }
  function aljFechar(){
    if(_aljEnviando) return;                 /* fechar no meio do envio confunde */
    var f=$('aljFolha'); if(f) f.classList.remove('on');
  }
  function aljMontar(){
    if($('aljFolha')) return;
    var d=document.createElement('div'); d.id='aljFolha';
    d.innerHTML='<div class="alj-bg" id="aljBg"></div>'+
      '<div class="alj-box" role="dialog" aria-label="Avisar lojistas" aria-modal="true">'+
        '<div class="alj-hd"><b>Avisar lojistas</b>'+
          '<button type="button" class="alj-x" id="aljX" aria-label="Fechar">&times;</button></div>'+
        '<div class="alj-body" id="aljBody"></div>'+
        '<div class="alj-ft" id="aljFt"></div>'+
      '</div>';
    document.body.appendChild(d);
    $('aljX').onclick=aljFechar;
    $('aljBg').onclick=aljFechar;
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && $('aljFolha') && $('aljFolha').classList.contains('on')) aljFechar();
    });
  }

  function aljPintaCorpo(){
    var b=$('aljBody'); if(!b) return;
    b.innerHTML=
      (MEV_AVISO_TESTE?('<div class="alj-teste-av" id="aljAviso">MODO DE TESTE — tudo vai só pra você.</div>'):'')+
      '<div class="alj-sec">A MENSAGEM QUE VAI</div>'+
      '<div class="alj-prev">'+aljPrevia(_aljTexto)+'</div>'+
      '<div class="alj-sec">POR ONDE</div>'+
      '<div class="alj-canais">'+
        '<label class="alj-cn on fixo"><input type="checkbox" id="aljCanChat" checked disabled><span>Chat</span></label>'+
        '<label class="alj-cn on"><input type="checkbox" id="aljCanSino" checked><span>Notificação</span></label>'+
        '<label class="alj-cn on"><input type="checkbox" id="aljCanMail" checked><span>E-mail</span></label>'+
      '</div>'+
      '<div class="alj-sec">PRA QUEM<button type="button" class="alj-todos" id="aljTodos">Marcar todos</button></div>'+
      '<div class="cli-search busca-lupa alj-busca">'+_icoBusca+'<input type="search" class="cad-in" id="aljBusca" aria-label="Buscar loja ou cidade" placeholder="Buscar loja ou cidade" autocomplete="off"></div>'+
      '<div class="alj-lista" id="aljLista">'+skelHtml(3)+'</div>';
    Array.prototype.forEach.call(b.querySelectorAll('.alj-cn input'),function(i){
      i.onchange=function(){ i.closest('.alj-cn').classList.toggle('on', i.checked); };
    });
    var bt=$('aljTodos'); if(bt) bt.onclick=aljMarcarTodos;
    var bq=$('aljBusca'); if(bq) bq.oninput=aljPintaLista;
    aljPintaRodape();
  }

  function aljPintaRodape(){
    var f=$('aljFt'); if(!f) return;
    f.innerHTML=
      '<label class="alj-so-eu"><input type="checkbox" id="aljSoEu"'+(MEV_AVISO_TESTE?' checked':'')+'>'+
        '<span>Mandar só pra mim (teste)</span></label>'+
      '<button type="button" class="cad-btn alj-go" id="aljGo">'+ALJ_ICO+'<span id="aljGoTx">Enviar</span></button>'+
      '<div class="alj-prog" id="aljProg"></div>';
    var se=$('aljSoEu');
    if(se) se.onchange=function(){
      var av=$('aljAviso');
      /* o aviso amarelo acompanha a caixinha: interruptor silencioso é o
         que faz alguém achar que mandou e não mandou */
      if(se.checked && !av){
        var d=document.createElement('div'); d.id='aljAviso'; d.className='alj-teste-av';
        d.textContent='MODO DE TESTE — tudo vai só pra você.';
        var bd=$('aljBody'); if(bd) bd.insertBefore(d, bd.firstChild);
      } else if(!se.checked && av){ try{ av.remove(); }catch(_){} }
    };
    var g=$('aljGo'); if(g) g.onclick=aljEnviar;
    aljContagem();
  }

  async function aljCarregarDiretorio(){
    try{
      var r=await supa.rpc('mp_chat_diretorio');
      var d=(r&&!r.error)?r.data:[];
      if(typeof d==='string'){ try{ d=JSON.parse(d||'[]'); }catch(_){ d=[]; } }
      _aljDir=(Array.isArray(d)?d:[]).filter(function(m){ return m && m.user_id && String(m.user_id)!==String(meuId); });
    }catch(_){ _aljDir=[]; }
    aljPintaLista();
  }

  function aljPintaLista(){
    var el=$('aljLista'); if(!el) return;
    var q=String((($('aljBusca')||{}).value)||'').toLowerCase().trim();
    var lista=_aljDir.filter(function(m){
      if(!q) return true;
      return ((m.loja_nome||'')+' '+(m.cidade||'')+' '+(m.uf||'')).toLowerCase().indexOf(q)>=0;
    });
    if(!_aljDir.length){
      el.innerHTML='<div class="cli-empty" style="padding:14px"><b>Nenhum outro lojista ainda</b>Quando mais contas entrarem no MEV, elas aparecem aqui.</div>';
      aljContagem(); return;
    }
    if(!lista.length){ el.innerHTML='<div class="cli-empty" style="padding:14px"><b>Nada com esse termo</b>Tente outro nome ou cidade.</div>'; return; }
    el.innerHTML=lista.map(function(m){
      var onde=[m.cidade,m.uf].filter(Boolean).join('/');
      return '<label class="alj-it'+(_aljMarcados[m.user_id]?' on':'')+'" data-alj="'+esc(m.user_id)+'">'+
        '<input type="checkbox"'+(_aljMarcados[m.user_id]?' checked':'')+'>'+
        '<span class="alj-it-tx"><b>'+esc(m.loja_nome||'Loja')+'</b>'+(onde?('<i>'+esc(onde)+'</i>'):'')+'</span>'+
      '</label>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.alj-it'),function(l){
      var inp=l.querySelector('input');
      inp.onchange=function(){
        var id=l.getAttribute('data-alj');
        if(inp.checked) _aljMarcados[id]=1; else delete _aljMarcados[id];
        l.classList.toggle('on', inp.checked);
        aljContagem();
      };
    });
    aljContagem();
  }

  function aljMarcarTodos(){
    /* alterna: se já está tudo marcado, desmarca tudo. Um botão que só
       marca deixa o lojista desmarcando sete caixinhas na mão. */
    var todos=_aljDir.length && _aljDir.every(function(m){ return _aljMarcados[m.user_id]; });
    _aljMarcados={};
    if(!todos) _aljDir.forEach(function(m){ _aljMarcados[m.user_id]=1; });
    var b=$('aljTodos'); if(b) b.textContent=todos?'Marcar todos':'Desmarcar todos';
    aljPintaLista();
  }

  function aljEscolhidos(){ return Object.keys(_aljMarcados); }
  function aljContagem(){
    var n=aljEscolhidos().length, tx=$('aljGoTx'), g=$('aljGo');
    if(tx) tx.textContent = n ? ('Enviar para '+n+(n===1?' lojista':' lojistas')) : 'Enviar';
    /* quem não marcou ninguém não consegue enviar — o botão diz isso antes
       de a pessoa tocar e levar um toast na cara */
    if(g){ g.disabled = (!n || _aljEnviando); g.classList.toggle('off', !n); }
  }

  async function aljEnviar(){
    if(_aljEnviando) return;
    var alvos=aljEscolhidos();
    if(!alvos.length){ toast('Marque pelo menos um lojista.'); return; }
    var teste=!!(($('aljSoEu')||{}).checked);
    var pergunta = teste
      ? ('MODO DE TESTE\n\nAs '+alvos.length+' mensagens vão só pra VOCÊ — nenhum lojista recebe.\n\nEnviar?')
      : ('Vai para '+alvos.length+(alvos.length===1?' lojista':' lojistas')+'. Enviar?');
    if(!confirm(pergunta)) return;

    _aljEnviando=true; aljContagem();
    var pr=$('aljProg');
    /* v563: lote CALCULADO (mesmo carro + mesmo dia = mesmo lote). No modo
       de teste continua sorteado — ver o aviso em _aljLoteDoDia. */
    var lote=(LOTE_DO_DIA && _aljChave && !teste) ? (_aljLoteDoDia(_aljChave)||aljUuid()) : aljUuid();
    var canais={ chat:true, sino:!!(($('aljCanSino')||{}).checked), push:!!(($('aljCanSino')||{}).checked),
                 email:!!(($('aljCanMail')||{}).checked) };
    var feito=0, semPush=0, erros=[], voltas=0, ultimo=null;

    /* A FILA. O servidor entrega o que couber no tempo dele e diz quanto
       falta; a gente chama de novo com o MESMO lote. O que já foi entregue
       é pulado lá — reenviar nunca duplica. O teto de voltas existe pra
       nunca girar pra sempre se o servidor parar de progredir. */
    while(voltas<15){
      voltas++;
      if(pr) pr.textContent='Enviando… '+feito+' de '+alvos.length;
      var d=await apiComTimeout('/api/avisar-lojistas',{
        token:token, lote:lote, para:alvos, texto:_aljTexto, titulo:_aljTitulo,
        link:_aljLink, foto:_aljFoto, canais:canais, teste:teste }, 24000);
      if(!d || !d.ok){
        if(pr) pr.innerHTML='<span class="alj-err">'+esc((d&&d.erro)||'Não consegui enviar agora.')+'</span>';
        _aljEnviando=false; aljContagem(); return;
      }
      semPush=Number(d.sem_push)||semPush;
      (d.erros||[]).forEach(function(e){ if(erros.indexOf(e)<0) erros.push(e); });
      var antes=feito; feito=Number(d.feito)||0; ultimo=d;
      if(d.acabou || !Number(d.restam)) break;
      if(feito<=antes) break;              /* não andou: para em vez de girar */
    }

    _aljEnviando=false;
    var completo = ultimo && (ultimo.acabou || feito>=alvos.length);
    var linhas=[];
    linhas.push(completo
      ? ('<b>'+(teste?'Teste enviado ✓':'Enviado ✓')+'</b> '+feito+' de '+alvos.length)
      : ('<b>Enviei '+feito+' de '+alvos.length+'.</b> Toque em enviar de novo — o que já foi não repete.'));
    if(teste) linhas.push('Chegou tudo em você: chat, sino e e-mail.');
    /* 🔴 push sem inscrição não pode fingir que foi. A mp_push está vazia
       (16/08) — enquanto ninguém aceitar as notificações no app, esta
       linha aparece, e ela é a verdade, não um erro do envio. */
    if(semPush) linhas.push('<span class="alj-warn">'+semPush+' sem push ativo</span> — o aviso aparece no sino ao abrir o app; o push só chega depois de aceitar as notificações.');
    erros.slice(0,2).forEach(function(e){ linhas.push('<span class="alj-err">'+esc(e)+'</span>'); });
    if(pr) pr.innerHTML=linhas.join('<br>');
    aljContagem();
    if(completo){ try{ chatBadgeAtualiza(); }catch(_){} }
  }

  /* ===== v519 — AVISAR **UM** LOJISTA, SEM ABRIR FOLHA ====================
     (PROJETO-oferta-aceita-negocio-fechado — PARTE 3B)

     A folha acima existe porque lá você ESCOLHE pra quem vai. Quando o
     destinatário é UM e já é conhecido — o lojista cuja oferta foi aceita —,
     abrir uma tela pra confirmar quem é seria pedir informação que o app já
     tem. Então esta é a mesma peça sem a tela: mesmo corpo, mesma function,
     mesmos canais.

     🔴 `teste:false`, SEMPRE. O `MEV_AVISO_TESTE` NÃO vale aqui. Lá ele
     existe pra ensaiar um disparo pra 7 lojas; aqui um aviso que
     silenciosamente fosse só pra você seria o app dizendo "avisei" sem ter
     avisado — exatamente o que a v514 se deu ao trabalho de evitar.
     Pra ensaiar isto: ofertar de uma conta na outra e aceitar.

     🔑 O TRUQUE DO `lote` — IDEMPOTÊNCIA DE GRAÇA, SEM SQL.
     Quem chama passa um uuid estável (o id da oferta, pro ganhador; o
     repasse_id, pros perdedores). Aí o índice único
     (lote, para_user, canal) da mp_aviso_envio garante: aceitar de novo,
     tocar "avisar" duas vezes, dois cliques no mesmo botão — **o lojista
     recebe UMA vez**. Nenhuma coluna `avisado_em` precisou existir.

     Devolve {ok:true} / {ok:false, erro}. NUNCA dá toast por conta própria:
     quem chama é que sabe o que mostrar. */
  async function avisarUmLojista(userId, texto, titulo, opts){
    opts=opts||{};
    if(!userId || !String(texto||'').trim()) return { ok:false, erro:'sem destinatário ou sem texto' };
    var lote=String(opts.lote||'')||aljUuid();
    var corpo={ token:token, lote:lote, para:[userId], texto:String(texto).slice(0,2000),
      titulo:String(opts.titulo||titulo||'').slice(0,90), link:String(opts.link||''),
      foto:(CAPA_AVISO?String(opts.foto||''):''),
      canais:{ chat:true, sino:true, push:true, email:opts.email!==false }, teste:false };
    /* um destinatário nunca estoura o PRAZO_MS de 7,6 s do servidor — mas se
       voltar `restam`, insiste. Três voltas é teto de segurança, não de uso. */
    for(var i=0;i<3;i++){
      var d=null;
      try{ d=await apiComTimeout('/api/avisar-lojistas', corpo, 20000); }catch(e){ d=null; }
      if(!d || !d.ok) return { ok:false, erro:(d&&d.erro)||'não consegui avisar' };
      if(d.acabou || !Number(d.restam)) return { ok:true, sem_push:Number(d.sem_push)||0 };
    }
    return { ok:false, erro:'o envio não terminou' };
  }

  /* ===== O CONVITE (porta A) ===============================================
     Depois de publicar no repasse o carro JÁ ESTÁ no ar — avisar é opcional.
     Então não abre folha na cara de ninguém: aparece esta tirinha embaixo,
     que some sozinha. Quem quer, toca. Quem não quer, ignora. */
  var _aljPillT=null;
  /* ===== v563 — O CONVITE FLUTUANTE SAIU =================================
     Pedido do Angelo (18/08, com print): *"remova o toast, já tem o botão de
     enviar para os lojistas, se certifique de que não recebam duas vezes"*.

     🔴 ELE NÃO ERA SÓ BARULHO — ERA A PORTA DO ENVIO DUPLO. Depois de
     publicar no repasse apareciam DUAS portas pro mesmo aviso: esta tirinha
     e o botão "Avisar lojistas" logo acima, na própria página. Cada uma
     abria a folha e cada envio inventava um LOTE novo — e é o lote que o
     banco usa pra saber quem já recebeu. Dois lotes = o lojista recebe o
     mesmo carro duas vezes.
     Com a tirinha fora sobra uma porta só; e o lote deixou de ser sorteado
     (ver `_aljLoteDoDia` abaixo), que é a trava de verdade.
     ⛳ CONVITE_PILL = true traz a tirinha de volta numa linha. */
  var CONVITE_PILL = false;
  function avisarLojistasConvite(texto, titulo, opts){
    if(!CONVITE_PILL) return;
    if(!String(texto||'').trim()) return;
    try{ var v=$('aljPill'); if(v) v.remove(); }catch(_){}
    clearTimeout(_aljPillT);
    var d=document.createElement('div'); d.id='aljPill'; d.className='alj-pill';
    d.innerHTML='<span>Avisar os lojistas deste carro?</span>'+
      '<button type="button" class="alj-pill-go" id="aljPillGo">Avisar</button>'+
      '<button type="button" class="alj-pill-no" id="aljPillNo" aria-label="Agora não">&times;</button>';
    document.body.appendChild(d);
    function fecha(){ clearTimeout(_aljPillT); try{ d.remove(); }catch(_){} }
    $('aljPillGo').onclick=function(){ fecha(); avisarLojistasAbrir(texto, titulo, opts); };
    $('aljPillNo').onclick=fecha;
    _aljPillT=setTimeout(fecha, 14000);
  }

  /* ===== O TEXTO DO CARRO, NUM LUGAR SÓ ===================================
     As duas portas chamam estVeicMsg (14-estoque.js) — a MESMA mensagem do
     compartilhar do estoque e do catálogo. A v508 existiu pra acabar com as
     duas mensagens de carro que havia no app; não nasce uma terceira aqui. */

  /* PORTA B — carro do estoque. Vai com preço: ele já é público no catálogo. */
  function avisarLojistasDoVeiculo(v){
    if(!v || !v.id) return null;
    var texto=''; try{ texto=estVeicMsg(v)||''; }catch(_){}
    if(!texto) return null;
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'um veículo';
    var link=''; try{ link=_publicoVeiculoUrl(v)||''; }catch(_){}
    /* v560: a capa é a PRIMEIRA foto do carro — a mesma que o catálogo e o
       anexo do chat usam. URL original, não a do redimensionador. */
    var foto=''; try{ foto=(Array.isArray(v.fotos)&&v.fotos[0])?String(v.fotos[0]):''; }catch(_){}
    return { texto:texto, titulo:nome, link:link, foto:foto, chave:'veic:'+String(v.id) };
  }

  /* PORTA A — anúncio do Portal do Repasse.
     🔴 VAI SEM PREÇO, DE PROPÓSITO. Desde a v288 o repasse não expõe valor
     pros outros lojistas ("Faça sua oferta" — só o dono vê o preço). Se a
     mensagem do chat levasse o número, ela furaria essa regra pela porta
     dos fundos e acabaria com a oferta. O link /r/<id> leva o lojista pra
     página onde ele oferta. Se um dia o Angelo decidir o contrário, é aqui
     — e é uma decisão de produto, não um esquecimento. */
  function avisarLojistasDoRepasse(x){
    if(!x || !x.id) return null;
    var vv=x.veiculo||{}, fic=vv.ficha||{};
    var opc=(Array.isArray(fic.opcionais)?fic.opcionais:[]).filter(Boolean).join(', ');
    var v={
      /* v560: a placa vai junto pro estVeicMsg achar a FICHA TÉCNICA já
         gerada (motor, câmbio, itens de série). Sem ficha, nada muda. */
      placa:vv.placa||'',
      marca:vv.marca||'', modelo:vv.modelo||'',
      ano:vv.ano_fab||vv.ano||'', ano_modelo:vv.ano_modelo||vv.ano||'',
      km:vv.km||'', cor:vv.cor||'', combustivel:vv.combustivel||'',
      preco_anuncio:0,                                   /* ver o aviso acima */
      extras:{ opcionais:opc, destaques:'' },
      url_publica:MEV_SITE+'/r/'+encodeURIComponent(String(x.id))
    };
    var texto=''; try{ texto=estVeicMsg(v)||''; }catch(_){}
    if(!texto) return null;
    var nome=((vv.marca||'')+' '+(vv.modelo||'')).trim()||'um veículo';
    var foto=''; try{ foto=(Array.isArray(vv.fotos)&&vv.fotos[0])?String(vv.fotos[0]):''; }catch(_){}
    return { texto:texto, titulo:nome+' (repasse)', link:v.url_publica, foto:foto, chave:'rep:'+String(x.id) };
  }

  /* PORTA C — A AVALIAÇÃO (v558).
     Nasceu quando o botão "Lista repasse" da tela de Avaliação virou
     "Avisar lojistas" (pedido do Angelo, 18/08). O botão antigo abria o
     WhatsApp de UM lojista por vez, na mão; agora a mesma avaliação vai
     pelos três canais, com seleção.

     🔴 VAI SEM PREÇO, pelo MESMO motivo da porta A: o que se manda pro
     outro lojista é o convite pra ele OFERTAR (v288). O link é a página da
     avaliação — a mesma que o botão antigo mandava, e a mesma que o "Ver
     página" abre. Nada de link novo.
     ⚠️ A mensagem sai do estVeicMsg, como as outras duas portas: a v508
     existiu pra acabar com as mensagens de carro duplicadas; não nasce uma
     quarta aqui. */
  function avisarLojistasDaAvaliacao(v, url){
    if(!v) return null;
    var fic=v.ficha||{};
    var opc=(Array.isArray(fic.opcionais)?fic.opcionais:[]).filter(Boolean).join(', ');
    var carro={
      /* v560: idem porta A — a placa é o que liga a ficha técnica. */
      placa:v.placa||'',
      marca:v.marca||'', modelo:v.modelo||'',
      ano:v.ano_fab||v.ano||'', ano_modelo:v.ano_modelo||v.ano||'',
      km:v.km||'', cor:v.cor||'', combustivel:v.combustivel||'',
      preco_anuncio:0,                                   /* ver o 🔴 acima */
      extras:{ opcionais:opc, destaques:'' },
      url_publica:String(url||'')
    };
    var texto=''; try{ texto=estVeicMsg(carro)||''; }catch(_){}
    if(!texto) return null;
    var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'um veículo';
    var foto=''; try{ foto=(Array.isArray(v.fotos)&&v.fotos[0])?String(v.fotos[0]):''; }catch(_){}
    return { texto:texto, titulo:nome+' (avaliação)', link:String(url||''), foto:foto,
             chave:'aval:'+String(v.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'') };
  }

  try{ window.MEV_AVISO_TESTE=MEV_AVISO_TESTE; }catch(_){}

/* ╔═══ src/app/18g-inspecao.js ═══════════════════════════════════════════ */
  /* ============================================================================
     18g — INSPEÇÃO DE REPASSE (aba PESSOAL do painel)

     PROJETO: mudancas/PROJETO20260901inspecaonopainel.txt

     POR QUE ISTO EXISTE: a inspeção do carro no pátio era de cabeça. É onde o
     iniciante perde dinheiro — um sinistro, um leilão ou um gravame que passou
     batido come a comissão de dez repasses. Aqui vira processo repetível, com
     histórico e com o texto de oferta pronto no fim.

     🔴 ONDE ELA MORA NA VIDA DO CARRO: a inspeção é o passo ANTERIOR à entrada
     de estoque. O carro ainda NÃO é da loja — por isso ela não cabe em
     `extras.prerenave` (que é do veículo já cadastrado, no 12f-pre-renave.js)
     e precisou de tabela própria. Quando o carro entrar no estoque, a inspeção
     ENTREGA placa, km, cor e ano pro pré-RENAVE: é ponte, não duplicata.

     🔴 ESTA É UMA ABA PESSOAL: fala direto com `supa.from` sob RLS e mostra só
     o que é do próprio usuário. NÃO passa pela função de admin (Service Role)
     que alimenta as outras cinco abas. O despacho que torna isso possível está
     no 18e (`_pnRegistraPessoal`).

     🔴 OFFLINE PRIMEIRO, E ISSO NÃO É ENFEITE: ele usa no pátio, na rua, de
     moto, com sinal ruim. Então o localStorage é a FONTE de trabalho: toda
     marcação grava ali na hora, sem rede. O Supabase é o destino, alcançado
     quando dá. Uma inspeção com `_pend:true` é uma que ainda não subiu — ela
     aparece na lista igual às outras, com o aviso de "no aparelho".
     ⚠️ O contrário (gravar no banco e cair pro local quando falha) parece a
     mesma coisa e não é: no pátio o `await` fica pendurado no timeout e a
     marcação some da tela. Local primeiro, sempre.

     ⚠️ ESTILO: as classes desta tela são injetadas por este módulo, não pelo
     styles.css. Não é preguiça — o styles.css é arquivo compartilhado por
     todas as conversas do repositório, e no dia em que isto foi escrito havia
     outra conversa fechando versões. Quando a poeira baixar, migrar o bloco
     `#insCss` pro styles.css e apagar daqui.
     ========================================================================= */

  /* ---------------------------------------------------------------- o modelo
     O checklist padrão. Veio do protótipo (artifact "Inspeção de Repasse"),
     item por item. `k:true` é ELIMINATÓRIO: um só reprovado condena o carro,
     por mais que todo o resto esteja bom. */
  var _INS_MODELO_PADRAO=[
    { id:'doc', t:'Documentação e pendências', itens:[
      { t:'Vendedor é o proprietário no documento (ou tem procuração)', k:true },
      { t:'CRLV / licenciamento em dia' },
      { t:'Sem restrição financeira / gravame em aberto', k:true },
      { t:'Sem restrição judicial ou bloqueio (RENAJUD)', k:true },
      { t:'IPVA e multas: levantados e quem paga está definido' },
      { t:'Recall aberto verificado' },
      { t:'Não está em estoque RENAVE de outra loja' },
      { t:'Comunicação de venda anterior sem pendência' }
    ]},
    { id:'hist', t:'Origem e histórico', itens:[
      { t:'Sem registro de sinistro / perda total', k:true },
      { t:'Sem passagem por leilão', k:true },
      { t:'Sem registro de roubo ou furto', k:true },
      { t:'Sem sinal de alagamento (lama nos cantos, oxidação sob o carpete, cheiro)', k:true },
      { t:'Laudo cautelar contratado' },
      { t:'KM coerente com histórico de revisões' }
    ]},
    { id:'ident', t:'Identificação veicular', itens:[
      { t:'Chassi bate com o documento e sem sinal de adulteração', k:true },
      { t:'Número do motor confere', k:true },
      { t:'Gravações em vidros e peças conferem' },
      { t:'Plaqueta / etiqueta do fabricante intacta' }
    ]},
    { id:'estrut', t:'Estrutura e lataria', itens:[
      { t:'Longarinas sem amassado, solda ou massa' },
      { t:'Assoalho e caçamba do estepe íntegros' },
      { t:'Colunas e torres do amortecedor sem reparo' },
      { t:'Frestas alinhadas (portas, capô, tampa)' },
      { t:'Pintura: medidor sem repintura fora do padrão' },
      { t:'Vidros da mesma marca e data' },
      { t:'Sem ferrugem ou bolha' }
    ]},
    { id:'mec', t:'Mecânica', itens:[
      { t:'Partida a frio limpa, sem ruído estranho' },
      { t:'Sem fumaça anormal no escapamento' },
      { t:'Sem vazamento de óleo, água ou câmbio' },
      { t:'Nível e aspecto do óleo e da água OK' },
      { t:'Câmbio engata sem tranco (e kickdown, se automático)' },
      { t:'Embreagem com curso normal' },
      { t:'Correia dentada / kit com histórico conhecido' },
      { t:'Suspensão sem barulho ou folga' },
      { t:'Freios firmes, sem ruído' },
      { t:'Direção sem folga nem puxada' },
      { t:'Ar-condicionado gelando' },
      { t:'Nenhuma luz de painel acesa (injeção, ABS, airbag)' },
      { t:'Scanner sem erro relevante' }
    ]},
    { id:'int', t:'Interior e itens', itens:[
      { t:'Bancos, forro e teto em bom estado' },
      { t:'Vidros, travas e retrovisores elétricos funcionando' },
      { t:'Cintos e costuras de airbag intactos' },
      { t:'Multimídia e som funcionando' },
      { t:'Segunda chave presente' },
      { t:'Estepe, macaco, chave de roda e triângulo' },
      { t:'Manual e chave reserva' }
    ]},
    { id:'pneu', t:'Pneus e rodas', itens:[
      { t:'Pneus com vida útil aceitável' },
      { t:'Sem desgaste irregular (indica suspensão/alinhamento)' },
      { t:'Idade dos pneus (DOT) aceitável' },
      { t:'Rodas sem empeno ou trinca' }
    ]},
    { id:'drive', t:'Test-drive', itens:[
      { t:'Aceleração e retomada normais' },
      { t:'Freada em linha reta' },
      { t:'Sem ruído em lombada ou irregularidade' },
      { t:'Temperatura estável após rodar' },
      { t:'Nenhuma luz acendeu depois de rodar' }
    ]},
    { id:'reg', t:'Registro para anunciar', itens:[
      { t:'Fotos: 4 ângulos externos, interior, painel com KM' },
      { t:'Fotos: motor, chassi, pneus e documento' },
      { t:'Vídeo de 60 a 90s com partida a frio' },
      { t:'Valor pedido e margem anotados' }
    ]}
  ];

  var _INS_KEY='mev_inspecao_v1';
  var _insTudo=null;        /* {id: inspecao} — o que está no aparelho */
  var _insAtual=null;       /* a inspeção aberta */
  var _insBusca='';
  var _insAbertas={};       /* quais seções estão abertas na ficha */
  var _insSincronizando=false;

  /* ---------------------------------------------------------------- utilidade */
  function _insId(){
    try{ if(window.crypto && crypto.randomUUID) return crypto.randomUUID(); }catch(_){ }
    return 'ins-'+Date.now()+'-'+Math.random().toString(36).slice(2,10);
  }
  function _insAgora(){ return new Date().toISOString(); }
  function _insTxt(v){ return String(v==null?'':v).trim(); }

  /* o aparelho é a fonte de trabalho; tudo passa por aqui */
  function _insLer(){
    if(_insTudo) return _insTudo;
    try{ _insTudo=JSON.parse(localStorage.getItem(_INS_KEY)||'{}')||{}; }
    catch(_){ _insTudo={}; }
    return _insTudo;
  }
  function _insGravaLocal(insp){
    var t=_insLer();
    insp.updated_at=_insAgora();
    t[insp.id]=insp;
    try{ localStorage.setItem(_INS_KEY, JSON.stringify(t)); }
    catch(e){ try{ window.mevErro && window.mevErro(e,'_insGravaLocal'); }catch(_){ } }
    return insp;
  }

  /* ------------------------------------------------------------- o veredito
     A regra do projeto, na ordem — e a ordem é o que importa:
       eliminatório reprovado  -> REPROVADO   (um só condena)
       algum reprovado         -> RISCO ALTO
       algum em atenção        -> ATENÇÃO
       tudo respondido         -> APROVADO
       resto                   -> EM ANDAMENTO */
  function _insVeredito(insp){
    var secoes=(insp && insp.secoes_snap) || [];
    var resp=(insp && insp.respostas) || {};
    var total=0, feitos=0, temReprova=false, temElim=false, atencao=0;
    secoes.forEach(function(sec){
      (sec.itens||[]).forEach(function(it, i){
        total++;
        var k=sec.id+'-'+i, r=resp[k];
        if(!r || !r.estado) return;
        feitos++;
        if(r.estado==='reprova'){ temReprova=true; if(it.k) temElim=true; }
        else if(r.estado==='atencao') atencao++;
      });
    });
    var v;
    if(temElim)            v='reprovado';
    else if(temReprova)    v='risco_alto';
    else if(atencao)       v='atencao';
    else if(total && feitos===total) v='aprovado';
    else                   v='andamento';
    return { veredito:v, total:total, feitos:feitos, atencao:atencao };
  }
  var _INS_VER={
    aprovado:  ['bom',   'Aprovado'],
    atencao:   ['aten',  'Atenção'],
    risco_alto:['ruim',  'Risco alto'],
    reprovado: ['ruim',  'Reprovado'],
    andamento: ['neutro','Em andamento']
  };
  function _insVerRotulo(insp){
    var c=_insVeredito(insp), r=_INS_VER[c.veredito]||_INS_VER.andamento;
    var txt=r[1];
    if(c.veredito==='atencao')   txt+=' · '+c.atencao+' ponto'+(c.atencao===1?'':'s');
    if(c.veredito==='andamento') txt+=' · '+c.feitos+'/'+c.total;
    return { cor:r[0], texto:txt, conta:c };
  }

  /* ------------------------------------------------------------------ o SVG
     Ícones de linha, currentColor, aria-hidden — padroes/ICONES-SVG.md. */
  function _insIco(nome, tam){
    var t=tam||17, d='';
    if(nome==='mais')   d='<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
    if(nome==='volta')  d='<polyline points="15 18 9 12 15 6"/>';
    if(nome==='lupa')   d='<circle cx="11" cy="11" r="7"/><line x1="20" y1="20" x2="16.65" y2="16.65"/>';
    if(nome==='copiar') d='<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>';
    if(nome==='nuvem')  d='<path d="M17 18a4 4 0 0 0 0-8 6 6 0 0 0-11.5 2A3.5 3.5 0 0 0 6 18z"/>';
    if(nome==='check')  d='<polyline points="20 6 9 17 4 12"/>';
    return '<svg viewBox="0 0 24 24" width="'+t+'" height="'+t+'" fill="none" stroke="currentColor" '+
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>';
  }

  /* ------------------------------------------------------------------- CSS */
  function _insCss(){
    if(document.getElementById('insCss')) return;
    var s=document.createElement('style');
    s.id='insCss';
    s.textContent=[
      '.ins-topo{display:flex;gap:8px;align-items:center;margin-bottom:10px;flex-wrap:wrap}',
      '.ins-sec{border:1px solid var(--linha,#e2e8f0);border-radius:12px;margin-bottom:10px;overflow:hidden;background:#fff}',
      '.ins-sec-cab{display:flex;align-items:center;gap:10px;width:100%;min-height:48px;padding:10px 12px;',
        'background:transparent;border:0;font-family:inherit;font-size:15px;font-weight:600;color:inherit;text-align:left;cursor:pointer}',
      '.ins-sec-cab .ins-cnt{margin-left:auto;font-weight:500;font-size:12.5px;color:#64748b;font-variant-numeric:tabular-nums}',
      '.ins-itens{border-top:1px solid var(--linha,#e2e8f0);padding:4px 12px 12px}',
      '.ins-it{padding:10px 0;border-bottom:1px solid #f1f5f9}',
      '.ins-it:last-child{border-bottom:0}',
      '.ins-it-t{font-size:14.5px;line-height:1.45;margin-bottom:8px;display:block}',
      '.ins-it-t .ins-k{display:inline-block;margin-left:6px;font-size:10.5px;letter-spacing:.06em;',
        'text-transform:uppercase;color:#a32c21;border:1px solid currentColor;border-radius:4px;padding:1px 5px;vertical-align:middle}',
      '.ins-op{display:flex;gap:6px;flex-wrap:wrap}',
      '.ins-op button{min-height:44px;min-width:88px;flex:1 1 88px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);',
        'background:#fff;font-family:inherit;font-size:13.5px;font-weight:600;color:#475569;cursor:pointer}',
      '.ins-op button:focus-visible{outline:2px solid #0a4da6;outline-offset:2px}',
      '.ins-op button.on.ok{background:#dcefe3;border-color:#1b7a46;color:#155f36}',
      '.ins-op button.on.aten{background:#f7e9d2;border-color:#9a6410;color:#7a4f0c}',
      '.ins-op button.on.rep{background:#f7dfdc;border-color:#a32c21;color:#8a251b}',
      '.ins-nota{width:100%;margin-top:8px;min-height:44px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);',
        'padding:10px;font-family:inherit;font-size:14px;resize:vertical}',
      '.ins-ver{display:flex;align-items:center;gap:10px;padding:12px;border-radius:12px;margin-bottom:12px;font-weight:600}',
      '.ins-ver.bom{background:#dcefe3;color:#155f36}',
      '.ins-ver.aten{background:#f7e9d2;color:#7a4f0c}',
      '.ins-ver.ruim{background:#f7dfdc;color:#8a251b}',
      '.ins-ver.neutro{background:#eef2f5;color:#475569}',
      '.ins-campos{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin-bottom:12px}',
      '.ins-campos label{display:flex;flex-direction:column;gap:4px;font-size:12.5px;color:#64748b;font-weight:600}',
      '.ins-campos input{min-height:44px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);padding:0 10px;',
        'font-family:inherit;font-size:15px;color:#0f172a}',
      '.ins-acoes{display:flex;gap:8px;flex-wrap:wrap;margin-top:14px}',
      '.ins-acoes button{min-height:44px}',
      '.ins-pend{font-size:11.5px;color:#9a6410;font-weight:600}',
      '@media (prefers-color-scheme:dark){',
        '.ins-sec{background:#161f24;border-color:#26343a}',
        '.ins-op button{background:#1d272d;border-color:#26343a;color:#cbd5e1}',
        '.ins-campos input,.ins-nota{background:#1d272d;border-color:#26343a;color:#e2eaec}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* =========================================================== a fila de sync
     Sobe o que está pendente. Nunca trava a tela: se a rede não estiver lá, a
     inspeção continua marcada como pendente e sobe na próxima vez.

     🔴 A REGRA DA v483 VALE AQUI: todo gravar pede a linha de volta e confere
     `data.length`. Sem isso, um insert barrado pela RLS volta "sucesso" com
     zero linhas — e a inspeção sumiria do aparelho achando que subiu. */
  async function _insSincronizar(silencioso){
    if(_insSincronizando) return;
    if(typeof supa==='undefined' || !supa || !meuId) return;
    var t=_insLer(), ids=Object.keys(t).filter(function(k){ return t[k] && t[k]._pend; });
    if(!ids.length) return;
    _insSincronizando=true;
    var subiram=0;
    for(var i=0;i<ids.length;i++){
      var insp=t[ids[i]];
      try{
        var linha={
          id: insp.id, user_id: meuId, modelo_id: insp.modelo_id||null,
          secoes_snap: insp.secoes_snap||[], veiculo: insp.veiculo||{},
          respostas: insp.respostas||{}, veredito: _insVeredito(insp).veredito,
          obs: insp.obs||null, status: insp.status||'rascunho',
          updated_at: insp.updated_at||_insAgora(), synced_at: _insAgora()
        };
        var r=await supa.from('inspecao').upsert(linha).select('id');
        if(r && r.error) throw r.error;
        if(!r || !r.data || !r.data.length){
          throw new Error('O banco aceitou sem gravar nenhuma linha.');
        }
        insp._pend=false; insp.synced_at=linha.synced_at;
        _insGravaLocal(insp);
        subiram++;
      }catch(e){
        try{ window.mevErro && window.mevErro(e,'_insSincronizar'); }catch(_){ }
        break;   /* sem rede/permissão: para aqui e tenta de novo depois */
      }
    }
    _insSincronizando=false;
    if(subiram && !silencioso) toast(subiram+' inspeção(ões) sincronizada(s).');
    return subiram;
  }

  /* traz do banco o que este aparelho ainda não tem (aparelho novo, ou o
     celular depois de ter usado o computador) */
  async function _insPuxar(){
    if(typeof supa==='undefined' || !supa || !meuId) return;
    try{
      var r=await supa.from('inspecao')
        .select('id,modelo_id,secoes_snap,veiculo,respostas,veredito,obs,status,created_at,updated_at,synced_at')
        .order('created_at',{ascending:false}).limit(200);
      if(r && r.error) throw r.error;
      var t=_insLer(), mudou=false;
      ((r&&r.data)||[]).forEach(function(x){
        var local=t[x.id];
        /* o que está pendente no aparelho é mais novo que o banco por
           definição — não deixar o banco sobrescrever trabalho não sincronizado */
        if(local && local._pend) return;
        if(local && String(local.updated_at||'') >= String(x.updated_at||'')) return;
        x._pend=false; t[x.id]=x; mudou=true;
      });
      if(mudou){ try{ localStorage.setItem(_INS_KEY, JSON.stringify(t)); }catch(_){ } }
    }catch(e){
      try{ window.mevErro && window.mevErro(e,'_insPuxar'); }catch(_){ }
    }
  }

  /* ================================================================= a lista */
  function _insListaHtml(){
    var t=_insLer();
    var todas=Object.keys(t).map(function(k){ return t[k]; })
      .filter(Boolean)
      .filter(function(x){ return x.status!=='descartada'; })
      .sort(function(a,b){ return String(b.created_at||'').localeCompare(String(a.created_at||'')); });

    var q=String(_insBusca||'').trim().toLowerCase();
    var lista=!q ? todas : todas.filter(function(x){
      var v=x.veiculo||{};
      return [v.modelo,v.placa,v.vendedor,v.cidade].join(' ').toLowerCase().indexOf(q)>=0;
    });

    var pend=todas.filter(function(x){ return x._pend; }).length;

    var topo='<div class="ins-topo">'+
      '<button type="button" class="btn btn-azul" id="insNova">'+_insIco('mais',17)+' Nova inspeção</button>'+
      (pend?('<button type="button" class="link" id="insSync">'+_insIco('nuvem',16)+' '+pend+' pra sincronizar</button>'):'')+
      '</div>'+
      '<div class="hh-search" style="margin-bottom:10px">'+
        _icoBusca+'<input id="insBusca" class="hh-busca" type="search" aria-label="Buscar por modelo, placa, vendedor ou cidade" placeholder="Buscar por modelo, placa, vendedor ou cidade…" autocomplete="off"></div>';

    if(!lista.length){
      return topo+'<div class="cli-empty"><b>Nenhuma inspeção ainda</b>'+
        (q?('Nada encontrado para “'+esc(_insBusca)+'”.')
          :'Toque em <b>Nova inspeção</b> quando estiver na frente do carro. Funciona sem internet.')+
        '</div>';
    }

    var linhas=lista.slice(0,200).map(function(x){
      var v=x.veiculo||{}, r=_insVerRotulo(x);
      var t1=[_insTxt(v.modelo)||'Veículo', _insTxt(v.ano)].filter(Boolean).join(' ');
      if(_insTxt(v.placa)) t1+=' · '+_insTxt(v.placa).toUpperCase();
      var t2=[r.texto, _insTxt(v.km)?(_insTxt(v.km)+' km'):'', _insTxt(v.cidade)].filter(Boolean).join(' · ');
      var t3=[(x.status==='concluida'?'Concluída':'Rascunho'),
              _insTxt(v.vendedor), (x._pend?'no aparelho, ainda não sincronizada':'')].filter(Boolean).join(' · ');
      return '<button type="button" class="pn-card" data-ins-abre="'+esc(String(x.id))+'">'+
        '<span class="pn-bola '+r.cor+'" title="'+esc(r.texto)+'"></span>'+
        '<span class="pn-tx"><span class="pn-nm">'+esc(t1)+'</span>'+
        '<span class="pn-l2">'+esc(t2)+'</span>'+
        '<span class="pn-l3'+(x._pend?' ins-pend':'')+'">'+esc(t3)+'</span></span></button>';
    }).join('');

    return topo+'<div class="doc-hint" style="margin-bottom:8px">'+lista.length+' inspeção(ões)</div>'+linhas;
  }

  /* ================================================================== a ficha */
  function _insFichaHtml(insp){
    var v=insp.veiculo||{}, resp=insp.respostas||{}, r=_insVerRotulo(insp);

    function campo(id,rot,val,tipo){
      return '<label for="ins_'+id+'">'+esc(rot)+
        '<input id="ins_'+id+'" type="'+(tipo||'text')+'" value="'+esc(_insTxt(val))+'" autocomplete="off"></label>';
    }

    var cabeca='<button type="button" class="link pn-volta" id="insVolta">'+_insIco('volta',16)+' Voltar</button>'+
      '<div class="ins-ver '+r.cor+'">'+_insIco('check',18)+'<span>'+esc(r.texto)+'</span></div>'+
      '<div class="ins-campos">'+
        campo('modelo','Modelo',v.modelo)+
        campo('ano','Ano',v.ano)+
        campo('placa','Placa',v.placa)+
        campo('km','Quilometragem',v.km)+
        campo('cor','Cor',v.cor)+
        campo('valor_pedido','Valor pedido',v.valor_pedido)+
        campo('vendedor','Vendedor',v.vendedor)+
        campo('telefone','Telefone',v.telefone,'tel')+
        campo('cidade','Cidade',v.cidade)+
      '</div>';

    var secoes=(insp.secoes_snap||[]).map(function(sec){
      var feitos=0;
      var itens=(sec.itens||[]).map(function(it,i){
        var k=sec.id+'-'+i, e=(resp[k]&&resp[k].estado)||'', nota=(resp[k]&&resp[k].nota)||'';
        if(e) feitos++;
        function op(val,cls,rot){
          return '<button type="button" class="'+cls+(e===val?' on':'')+'" data-ins-it="'+esc(k)+'" data-ins-v="'+val+'" '+
            'aria-pressed="'+(e===val?'true':'false')+'">'+esc(rot)+'</button>';
        }
        return '<div class="ins-it">'+
          '<span class="ins-it-t">'+esc(it.t)+(it.k?'<span class="ins-k">eliminatório</span>':'')+'</span>'+
          '<div class="ins-op">'+op('ok','ok','OK')+op('atencao','aten','Atenção')+op('reprova','rep','Reprova')+'</div>'+
          ((e==='atencao'||e==='reprova')
            ? '<textarea class="ins-nota" data-ins-nota="'+esc(k)+'" placeholder="O que você viu? (vai no resumo da oferta)">'+esc(nota)+'</textarea>'
            : '')+
        '</div>';
      }).join('');
      var aberta=_insAbertas[sec.id]!==false;
      return '<section class="ins-sec">'+
        '<button type="button" class="ins-sec-cab" data-ins-sec="'+esc(sec.id)+'" aria-expanded="'+(aberta?'true':'false')+'">'+
          '<span>'+esc(sec.t)+'</span><span class="ins-cnt">'+feitos+'/'+(sec.itens||[]).length+'</span></button>'+
        (aberta?('<div class="ins-itens">'+itens+'</div>'):'')+
      '</section>';
    }).join('');

    var rodape='<div class="cad-sec" style="margin-top:12px">'+
        '<label for="insObs" style="display:block;font-size:12.5px;color:#64748b;font-weight:600;margin-bottom:4px">Observações</label>'+
        '<textarea id="insObs" class="ins-nota" placeholder="O que mais importa saber sobre este carro">'+esc(insp.obs||'')+'</textarea>'+
      '</div>'+
      '<div class="ins-acoes">'+
        '<button type="button" class="btn btn-azul" id="insResumo">'+_insIco('copiar',17)+' Resumo pra oferta</button>'+
        (insp.status!=='concluida'
          ? '<button type="button" class="btn" id="insConcluir">'+_insIco('check',17)+' Concluir</button>'
          : '<button type="button" class="btn" id="insReabrir">Reabrir</button>')+
      '</div>'+
      '<div class="doc-hint" style="margin-top:10px">'+
        (insp._pend?'Guardada neste aparelho. Sobe sozinha quando houver internet.'
                   :'Sincronizada.')+'</div>';

    return cabeca+secoes+rodape;
  }

  /* ---------------------------------------------------------------- o resumo
     O texto que ele manda pro comprador. Só entra o que ajuda a decidir:
     o carro, o veredito, e os pontos que NÃO estão OK com a nota de cada um. */
  function _insResumo(insp){
    var v=insp.veiculo||{}, resp=insp.respostas||{}, r=_insVerRotulo(insp), L=[];
    var l1=[_insTxt(v.modelo), _insTxt(v.ano)].filter(Boolean).join(' ');
    if(_insTxt(v.placa)) l1+=' · '+_insTxt(v.placa).toUpperCase();
    if(l1) L.push(l1);
    var l2=[_insTxt(v.km)?(_insTxt(v.km)+' km'):'', _insTxt(v.cor), _insTxt(v.cidade)].filter(Boolean).join(' · ');
    if(l2) L.push(l2);
    if(_insTxt(v.valor_pedido)) L.push('Pedido: '+_insTxt(v.valor_pedido));
    L.push('');
    L.push('VEREDITO: '+r.texto.toUpperCase());

    var pontos=[];
    (insp.secoes_snap||[]).forEach(function(sec){
      (sec.itens||[]).forEach(function(it,i){
        var k=sec.id+'-'+i, e=resp[k]&&resp[k].estado;
        if(e!=='atencao' && e!=='reprova') return;
        var marca=(e==='reprova'?'[REPROVA]':'[ATENÇÃO]');
        var nota=_insTxt(resp[k].nota);
        pontos.push('- '+marca+' '+it.t+(nota?(' — '+nota):''));
      });
    });
    if(pontos.length){ L.push(''); L.push('PONTOS:'); L=L.concat(pontos); }
    if(_insTxt(insp.obs)){ L.push(''); L.push('OBS: '+_insTxt(insp.obs)); }
    L.push('');
    L.push('Inspeção feita no MEV Veículos.');
    return L.join('\n');
  }

  /* ================================================================= o desenho */
  function _insPinta(el){
    el.innerHTML = _insAtual ? _insFichaHtml(_insAtual) : _insListaHtml();
    _insWire(el);
  }

  function _insWire(el){
    /* ---- lista ---- */
    var bn=$('insNova');
    if(bn) bn.onclick=function(){
      _insAtual={
        id:_insId(), modelo_id:null,
        secoes_snap: JSON.parse(JSON.stringify(_INS_MODELO_PADRAO)),
        veiculo:{}, respostas:{}, obs:'', status:'rascunho',
        created_at:_insAgora(), updated_at:_insAgora(), _pend:true
      };
      _insAbertas={};
      _insGravaLocal(_insAtual);
      _insPinta(el);
      try{ window.scrollTo(0,0); }catch(_){ }
    };
    var bs=$('insSync');
    if(bs) bs.onclick=async function(){
      toast('Sincronizando…');
      await _insSincronizar(false);
      _insPinta(el);
    };
    var bb=$('insBusca');
    if(bb){ bb.value=_insBusca; bb.oninput=function(){
      _insBusca=this.value; _insPinta(el);
      var b2=$('insBusca'); if(b2){ try{ b2.focus(); }catch(_){ } }
    }; }
    Array.prototype.forEach.call(el.querySelectorAll('[data-ins-abre]'), function(b){
      b.onclick=function(){
        var t=_insLer(); _insAtual=t[b.getAttribute('data-ins-abre')]||null;
        _insAbertas={};
        _insPinta(el); try{ window.scrollTo(0,0); }catch(_){ }
      };
    });

    if(!_insAtual) return;

    /* ---- ficha ---- */
    var bv=$('insVolta');
    if(bv) bv.onclick=function(){
      _insAtual=null; _insPinta(el);
      _insSincronizar(true);
    };

    /* campos do veículo: gravam ao sair do campo, não a cada tecla */
    ['modelo','ano','placa','km','cor','valor_pedido','vendedor','telefone','cidade'].forEach(function(c){
      var i=$('ins_'+c);
      if(!i) return;
      i.onchange=function(){
        _insAtual.veiculo=_insAtual.veiculo||{};
        _insAtual.veiculo[c]=this.value;
        _insAtual._pend=true; _insGravaLocal(_insAtual);
      };
    });

    Array.prototype.forEach.call(el.querySelectorAll('[data-ins-sec]'), function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-ins-sec');
        _insAbertas[id] = (_insAbertas[id]===false);
        _insPinta(el);
      };
    });

    Array.prototype.forEach.call(el.querySelectorAll('[data-ins-it]'), function(b){
      b.onclick=function(){
        var k=b.getAttribute('data-ins-it'), v=b.getAttribute('data-ins-v');
        _insAtual.respostas=_insAtual.respostas||{};
        var atual=_insAtual.respostas[k]||{};
        /* tocar de novo no mesmo botão desmarca — dá pra corrigir sem recarregar */
        if(atual.estado===v) delete _insAtual.respostas[k];
        else _insAtual.respostas[k]={ estado:v, nota:atual.nota||'' };
        _insAtual._pend=true; _insGravaLocal(_insAtual);
        _insPinta(el);
      };
    });

    Array.prototype.forEach.call(el.querySelectorAll('[data-ins-nota]'), function(t){
      t.onchange=function(){
        var k=t.getAttribute('data-ins-nota');
        if(!_insAtual.respostas[k]) return;
        _insAtual.respostas[k].nota=this.value;
        _insAtual._pend=true; _insGravaLocal(_insAtual);
      };
    });

    var ob=$('insObs');
    if(ob) ob.onchange=function(){
      _insAtual.obs=this.value; _insAtual._pend=true; _insGravaLocal(_insAtual);
    };

    var br=$('insResumo');
    if(br) br.onclick=function(){
      var txt=_insResumo(_insAtual);
      try{
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(txt);
          toast('Resumo copiado.');
          return;
        }
      }catch(_){ }
      try{ window.prompt('Resumo da inspeção (copie):', txt); }catch(_){ toast('Não consegui copiar.'); }
    };

    var bc=$('insConcluir');
    if(bc) bc.onclick=async function(){
      _insAtual.status='concluida'; _insAtual._pend=true;
      _insGravaLocal(_insAtual);
      _insPinta(el);
      await _insSincronizar(true);
      toast('Inspeção concluída.');
    };
    var brb=$('insReabrir');
    if(brb) brb.onclick=function(){
      _insAtual.status='rascunho'; _insAtual._pend=true;
      _insGravaLocal(_insAtual); _insPinta(el);
    };
  }

  /* ============================================================ a porta da aba */
  async function _insAbrir(el){
    _insCss();
    _insLer();
    _insPinta(el);                 /* o aparelho pinta NA HORA, sem esperar rede */
    await _insSincronizar(true);   /* e o resto acontece por trás */
    await _insPuxar();
    if(document.getElementById('pnBody')===el) _insPinta(el);
  }

  /* registra a aba pessoal no painel (o despacho mora no 18e) */
  try{ _pnRegistraPessoal('inspecao','Inspeção', function(el){ _insAbrir(el); }); }
  catch(_){ }

/* ╔═══ src/app/18h-arte-anuncio.js ═══════════════════════════════════════ */
  /* ==========================================================================
     18h — ARTE DE ANÚNCIO (v823 · PROJETO-2026-09-01-arte-de-anuncio)
     --------------------------------------------------------------------------
     Gera a arte 1080×1920 do anúncio do veículo, dentro do app, e o texto
     pronto pro WhatsApp. Aba PESSOAL do painel — v1 é só pro dono.

     🔴 O QUE FOI ADAPTADO DO PROJETO, E POR QUÊ (leia antes de "completar"):

     · §8.1 (refactor do despacho das abas pessoais) JÁ ESTAVA FEITO. O 18e
       tem `_PN_PESSOAL` / `_pnRegistraPessoal` e o `_pnPinta` despacha as
       abas pessoais ANTES do guard do `_pnDados`, exatamente como o projeto
       pedia — o 18g (Inspeção) já entra por essa porta. Esta aba só se
       registra; nada foi refeito.

     · §8.2, §8.4 e §8.7 (bucket, tabela mp_foto, RLS, fila de sync e o
       `extras.arte`) FICARAM DE FORA desta versão, de propósito. São
       mudança de BANCO e de POLÍTICA DE ACESSO, e a regra da casa é que
       isso anda em versão própria, com a conferência do
       PRIORIDADES-SEGURANCA-E-CONFORMIDADE. Misturar bucket novo + RLS nova
       com 700 linhas de canvas é o jeito de nenhum dos dois ser revisado
       direito.
       E o próprio projeto autoriza: §8.3 diz "sem banco ainda, tudo em
       memória >> JÁ DÁ PRA USAR DE VERDADE NESSE PONTO". É esse ponto.
       ⚠️ CONSEQUÊNCIA HONESTA: a arte NÃO fica guardada. Fechou a aba,
       perdeu. A tela DIZ isso, em vez de deixar a pessoa descobrir.

     · §5 pede a fonte POPPINS. Não entrou, e a recusa tem motivo: fonte
       baixada pode não ter chegado no instante do `toBlob` — e aí o JPG sai
       com a letra errada, calado, sem segunda chance. É a mesma lição do
       `mev-pdf-vetorial` e da assinatura da placa na v820. A arte usa a
       pilha do sistema, que está sempre lá.

     🔴 TUDO É CANVAS, NÃO FOTO DE TELA (§2.2). Nada de html2canvas: o
     desenho é feito em 1080×1920 de verdade e sai por `toBlob`. Foto da
     tela sairia na resolução do celular, borrada e cortada.
     🔴 E O DOWNLOAD É POR BLOB + <a download> — nunca `save()`: a lição da
     v821, que descobriu o contrato que não baixava no iPhone.
     ========================================================================== */

  var ART_W=1080, ART_H=1920;
  var ART_CAB=140, ART_PE=400;          /* cabeçalho e rodapé, em px da arte */
  var ART_FUNDO='#070E1C', ART_AZUL='#2563EB', ART_AZUL2='#60A5FA';
  var ART_APAGADO='#94B0D6', ART_VERDE='#4ADE80', ART_VERDE_BG='#103426',
      ART_VERDE_BD='#22C55E', ART_AMARELO='#FACC15';
  /* §5 pede Poppins; ver a nota do cabeçalho — aqui é a pilha do sistema */
  var ART_FONTE='-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

  var _art=null, _artRaf=0;

  function _artNovo(){
    return { layout:1, i:0, slots:[null,null,null],
             titulo:'', sub:'', preco:0, fipe:0, chips:[], obs:'',
             borroes:[], modoBorrar:false, repasse:true };
  }

  /* ---------------------------------------------------------------------
     o gancho de produto (§6): a placa JÁ foi consultada — a tela abre cheia
     --------------------------------------------------------------------- */
  function _artDoVeiculo(){
    var v=null; try{ v=(typeof veiculoAtual!=='undefined')?veiculoAtual:null; }catch(_){ v=null; }
    if(!v) return null;
    var nome=[v.marca,v.modelo||v.versao].filter(Boolean).join(' ').trim();
    var anos=(v.ano&&v.ano_modelo&&String(v.ano)!==String(v.ano_modelo))
      ? (v.ano+'/'+v.ano_modelo) : String(v.ano_modelo||v.ano||'');
    var ficha=[anos, v.cor, v.combustivel].filter(Boolean).join(' · ');
    return { titulo:nome, sub:ficha, fipe:Number(v.fipe)||0, placa:String(v.placa||'') };
  }

  function _artNum(x){ return Math.max(0, Number(String(x).replace(/\D/g,''))||0); }
  function _artBrl(n){
    n=Number(n)||0;
    try{ return 'R$ '+n.toLocaleString('pt-BR',{minimumFractionDigits:0,maximumFractionDigits:0}); }
    catch(_){ return 'R$ '+n; }
  }
  /* quanto o preço está abaixo da FIPE — o número que o projeto chama de
     diferencial (§6): "nenhum app de arte sabe o FIPE do carro" */
  function _artAbaixo(){
    if(!(_art.fipe>0) || !(_art.preco>0) || _art.preco>=_art.fipe) return 0;
    return Math.round(((_art.fipe-_art.preco)/_art.fipe)*1000)/10;
  }

  /* ---------------------------------------------------------------------
     🔴 A DETECÇÃO DE ALPHA (§2.1)
     O recorte é feito pela pessoa, no iPhone ("Copiar assunto"). O app não
     tenta adivinhar: ele OLHA o canal alpha. Se a imagem tem transparência,
     desenha o showroom atrás; se não tem, usa a foto como está.
     ⚠️ Só olho uma amostra reduzida (120px): varrer 4000×3000 pixels no
     celular trava a tela por segundos, e pra saber se EXISTE transparência
     a amostra basta.
     --------------------------------------------------------------------- */
  function _artTemAlpha(img){
    try{
      var m=120, r=Math.min(m/img.width, m/img.height, 1);
      var c=document.createElement('canvas');
      c.width=Math.max(1,Math.round(img.width*r)); c.height=Math.max(1,Math.round(img.height*r));
      var x=c.getContext('2d', { willReadFrequently:true });
      x.drawImage(img,0,0,c.width,c.height);
      var d=x.getImageData(0,0,c.width,c.height).data, n=0;
      for(var i=3;i<d.length;i+=4){ if(d[i]<200){ n++; if(n>c.width*c.height*0.04) return true; } }
      return false;
    }catch(_){ return false; }
  }

  /* ---------------------------------------------------------------------
     o fundo de showroom (§5), tudo em gradiente — nenhuma imagem pra baixar
     --------------------------------------------------------------------- */
  function _artShowroom(ctx, x, y, w, h){
    var horiz=y+h*0.74;
    var g=ctx.createLinearGradient(0,y,0,horiz);
    g.addColorStop(0,'#060C1A'); g.addColorStop(1,'#16304F');
    ctx.fillStyle=g; ctx.fillRect(x,y,w,horiz-y);
    /* glow atrás do carro */
    var gl=ctx.createRadialGradient(x+w/2, horiz-h*0.16, 10, x+w/2, horiz-h*0.16, w*0.62);
    gl.addColorStop(0,'rgba(37,99,235,.42)'); gl.addColorStop(1,'rgba(37,99,235,0)');
    ctx.fillStyle=gl; ctx.fillRect(x,y,w,horiz-y);
    /* piso */
    var p=ctx.createLinearGradient(0,horiz,0,y+h);
    p.addColorStop(0,'#0B1526'); p.addColorStop(1,'#05090F');
    ctx.fillStyle=p; ctx.fillRect(x,horiz,w,y+h-horiz);
    /* brilho elíptico no piso */
    ctx.save();
    ctx.translate(x+w/2, horiz+h*0.06); ctx.scale(1,0.22);
    var pg=ctx.createRadialGradient(0,0,10,0,0,w*0.52);
    pg.addColorStop(0,'rgba(96,165,250,.30)'); pg.addColorStop(1,'rgba(96,165,250,0)');
    ctx.fillStyle=pg; ctx.beginPath(); ctx.arc(0,0,w*0.52,0,Math.PI*2); ctx.fill();
    ctx.restore();
  }

  /* o carro espelhado no piso — só quando há recorte */
  function _artReflexo(ctx, img, dx, dy, dw, dh, base){
    try{
      ctx.save();
      ctx.globalAlpha=0.32;
      ctx.translate(0, base*2);
      ctx.scale(1,-1);
      if(ctx.filter!==undefined){ try{ ctx.filter='blur(6px)'; }catch(_){} }
      ctx.drawImage(img, dx, dy, dw, dh);
      ctx.restore();
    }catch(_){ try{ ctx.restore(); }catch(__){} }
  }

  /* ---------------------------------------------------------------------
     o painel de foto: enquadramento com clamp (§5) — arrastar NUNCA deixa
     buraco na borda, senão a arte sai com tarja preta e ninguém entende
     --------------------------------------------------------------------- */
  function _artClamp(s, pw, ph){
    var esc=Math.max(pw/s.iw, ph/s.ih)*(s.zoom/100);
    var w=s.iw*esc, h=s.ih*esc;
    var maxX=Math.max(0,(w-pw)/2), maxY=Math.max(0,(h-ph)/2);
    s.dx=Math.max(-maxX, Math.min(maxX, s.dx||0));
    s.dy=Math.max(-maxY, Math.min(maxY, s.dy||0));
    return { w:w, h:h };
  }

  function _artPainel(ctx, s, x, y, w, h){
    ctx.save();
    ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
    if(!s){
      ctx.fillStyle='#0B1526'; ctx.fillRect(x,y,w,h);
      ctx.fillStyle=ART_APAGADO; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.font='500 34px '+ART_FONTE;
      ctx.fillText('toque para escolher a foto', x+w/2, y+h/2);
      ctx.restore(); return;
    }
    if(s.alpha) _artShowroom(ctx,x,y,w,h);
    else { ctx.fillStyle='#0B1526'; ctx.fillRect(x,y,w,h); }
    var m=_artClamp(s,w,h);
    var dx=x+(w-m.w)/2+(s.dx||0), dy=y+(h-m.h)/2+(s.dy||0);
    if(s.alpha) _artReflexo(ctx, s.img, dx, dy, m.w, m.h, dy+m.h);
    ctx.drawImage(s.img, dx, dy, m.w, m.h);
    if(s.alpha){
      /* sombra de contato */
      ctx.save();
      ctx.translate(x+w/2, dy+m.h*0.94); ctx.scale(1,0.10);
      var sg=ctx.createRadialGradient(0,0,4,0,0,w*0.34);
      sg.addColorStop(0,'rgba(0,0,0,.62)'); sg.addColorStop(1,'rgba(0,0,0,0)');
      ctx.fillStyle=sg; ctx.beginPath(); ctx.arc(0,0,w*0.34,0,Math.PI*2); ctx.fill();
      ctx.restore();
    }
    ctx.restore();
  }

  /* ---------------------------------------------------------------------
     🔴 O BORRÃO DA PLACA — PIXELIZAÇÃO, NÃO `filter:blur`
     Mesma régua do 13c: reduzir e reampliar JOGA A INFORMAÇÃO FORA. Um blur
     leve pode ser parcialmente revertido por software, e numa placa isso
     basta. Aqui o borrão vira pixel no arquivo, não camada.
     --------------------------------------------------------------------- */
  function _artBorra(ctx, cv, b){
    var r=b.r, x=Math.round(b.x-r), y=Math.round(b.y-r), d=Math.round(r*2);
    if(d<4) return;
    var p=document.createElement('canvas');
    var pw=Math.max(3,Math.round(d/8)), ph=Math.max(3,Math.round(d/8));
    p.width=pw; p.height=ph;
    try{ p.getContext('2d').drawImage(cv, x, y, d, d, 0, 0, pw, ph); }catch(_){ return; }
    ctx.save();
    ctx.beginPath(); ctx.arc(b.x,b.y,r,0,Math.PI*2); ctx.clip();
    ctx.imageSmoothingEnabled=false;
    ctx.drawImage(p, 0, 0, pw, ph, x, y, d, d);
    ctx.restore();
  }

  function _artPill(ctx, tx, x, y, cor, fundo, borda, tam){
    tam=tam||30;
    ctx.font='700 '+tam+'px '+ART_FONTE;
    var w=ctx.measureText(tx).width+34, h=tam+24, r=h/2;
    ctx.beginPath();
    ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r);
    ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath();
    if(fundo){ ctx.fillStyle=fundo; ctx.fill(); }
    if(borda){ ctx.strokeStyle=borda; ctx.lineWidth=2; ctx.stroke(); }
    ctx.fillStyle=cor; ctx.textAlign='left'; ctx.textBaseline='middle';
    ctx.fillText(tx, x+17, y+h/2+1);
    return w;
  }

  /* ---------------------------------------------------------------------
     O DESENHO — a arte inteira, 1080×1920
     --------------------------------------------------------------------- */
  function artDesenhar(cv){
    cv.width=ART_W; cv.height=ART_H;
    var ctx=cv.getContext('2d');
    ctx.fillStyle=ART_FUNDO; ctx.fillRect(0,0,ART_W,ART_H);

    /* ---- cabeçalho ---- */
    ctx.fillStyle='#fff'; ctx.textAlign='left'; ctx.textBaseline='middle';
    ctx.font='700 46px '+ART_FONTE;
    ctx.fillText('MEV', 48, ART_CAB/2);
    var lw=ctx.measureText('MEV').width;
    ctx.fillStyle=ART_AZUL2; ctx.font='500 46px '+ART_FONTE;
    ctx.fillText(' Veículos', 48+lw, ART_CAB/2);
    if(_art.repasse){
      ctx.textAlign='left';
      var pw=ctx.measureText('REPASSE').width;
      _artPill(ctx,'REPASSE', ART_W-48-(pw+34), ART_CAB/2-27, '#fff', ART_AZUL, '', 30);
    }

    /* ---- fotos ---- */
    var y0=ART_CAB, alt=ART_H-ART_CAB-ART_PE;
    if(_art.layout===1){
      _artPainel(ctx, _art.slots[0], 0, y0, ART_W, alt);
    }else{
      var each=Math.floor((alt-8)/3);
      for(var i=0;i<3;i++){
        _artPainel(ctx, _art.slots[i], 0, y0+i*(each+4), ART_W, each);
        if(i<2){ ctx.fillStyle=ART_AZUL; ctx.fillRect(0, y0+i*(each+4)+each, ART_W, 4); }
      }
    }
    /* os borrões vão POR CIMA da foto e ANTES do rodapé */
    for(var b=0;b<_art.borroes.length;b++) _artBorra(ctx, cv, _art.borroes[b]);

    /* ---- rodapé ---- */
    var py=ART_H-ART_PE;
    ctx.fillStyle=ART_FUNDO; ctx.fillRect(0,py,ART_W,ART_PE);
    ctx.fillStyle=ART_AZUL; ctx.fillRect(0,py,ART_W,4);
    var y=py+58;
    ctx.textAlign='left'; ctx.textBaseline='alphabetic';
    ctx.fillStyle='#fff'; ctx.font='700 54px '+ART_FONTE;
    var tit=String(_art.titulo||'').toUpperCase();
    while(tit && ctx.measureText(tit).width>ART_W-96) tit=tit.slice(0,-1);
    ctx.fillText(tit, 48, y);
    y+=46;
    ctx.fillStyle=ART_APAGADO; ctx.font='400 32px '+ART_FONTE;
    var sub=String(_art.sub||'');
    while(sub && ctx.measureText(sub).width>ART_W-96) sub=sub.slice(0,-1);
    ctx.fillText(sub, 48, y);
    y+=76;
    ctx.fillStyle='#fff'; ctx.font='700 80px '+ART_FONTE;
    ctx.fillText(_art.preco>0?_artBrl(_art.preco):'consulte', 48, y);
    /* FIPE e o % abaixo, do lado */
    if(_art.fipe>0){
      var fx=48+ctx.measureText(_art.preco>0?_artBrl(_art.preco):'consulte').width+30;
      _artPill(ctx,'FIPE '+_artBrl(_art.fipe), fx, y-52, ART_VERDE, ART_VERDE_BG, ART_VERDE_BD, 28);
      var ab=_artAbaixo();
      if(ab>0){
        ctx.fillStyle=ART_VERDE; ctx.font='700 30px '+ART_FONTE;
        ctx.fillText(String(ab).replace('.',',')+'% abaixo da FIPE', fx+4, y+2);
      }
    }
    y+=52;
    /* chips */
    if(_art.chips.length){
      var cx=48;
      for(var c=0;c<_art.chips.length && cx<ART_W-160;c++){
        cx+=_artPill(ctx,String(_art.chips[c]), cx, y, ART_AZUL2, 'rgba(37,99,235,.16)', 'rgba(96,165,250,.5)', 26)+12;
      }
      y+=64;
    }
    if(String(_art.obs||'').trim()){
      ctx.fillStyle=ART_AMARELO; ctx.font='500 30px '+ART_FONTE;
      var ob=String(_art.obs).trim();
      while(ob && ctx.measureText(ob).width>ART_W-96) ob=ob.slice(0,-1);
      ctx.fillText(ob, 48, y+6);
    }
    return cv;
  }

  /* o texto do anúncio, pra colar no WhatsApp (§1) */
  function artTexto(){
    var l=[];
    if(_art.titulo) l.push('*'+String(_art.titulo).toUpperCase()+'*');
    if(_art.sub) l.push(_art.sub);
    if(_art.preco>0) l.push('Valor: *'+_artBrl(_art.preco)+'*');
    if(_art.fipe>0){
      var ab=_artAbaixo();
      l.push('FIPE: '+_artBrl(_art.fipe)+(ab>0?('  ('+String(ab).replace('.',',')+'% abaixo)'):''));
    }
    if(_art.chips.length) l.push(_art.chips.join(' · '));
    if(String(_art.obs||'').trim()) l.push('A fazer: '+String(_art.obs).trim());
    return l.join('\n');
  }

  /* ---------------------------------------------------------------------
     A TELA — dentro do #pnBody da aba pessoal
     --------------------------------------------------------------------- */
  function _artHtml(){
    var d=_artDoVeiculo();
    var t=_art.titulo || (d&&d.titulo) || '';
    var s=_art.sub || (d&&d.sub) || '';
    var f=_art.fipe || (d&&d.fipe) || 0;
    return ''+
    '<div class="art-wrap">'+
      /* §2.1 — o aviso do PNG tem que estar NA TELA, não só na doc */
      '<div class="art-nota">'+
        '<b>Fundo de showroom automático</b>'+
        'No iPhone: segure o dedo no carro na foto → <b>Copiar assunto</b> → salve como PNG. '+
        'O app percebe a transparência e desenha o showroom atrás sozinho.<br>'+
        '⚠️ Traga o PNG pela <b>galeria, Arquivos ou AirDrop</b>. PNG que passa pelo WhatsApp vira JPG e '+
        'perde a transparência — aí a foto entra como está.'+
      '</div>'+
      '<div class="art-nota art-nota-av">'+
        '<b>Esta versão não guarda a arte.</b>'+
        'Ela é gerada e baixada na hora. Fechou a aba, os dados se perdem — baixe antes de sair.'+
      '</div>'+
      '<div class="art-palco"><canvas id="artCv"></canvas>'+
        '<div class="art-toque" id="artToque"></div></div>'+
      '<div class="art-linha">'+
        '<button type="button" class="art-bt'+(_art.layout===1?' on':'')+'" data-art-lay="1">1 foto</button>'+
        '<button type="button" class="art-bt'+(_art.layout===3?' on':'')+'" data-art-lay="3">3 fotos</button>'+
        '<button type="button" class="art-bt" id="artTrocar">Trocar a foto</button>'+
        '<button type="button" class="art-bt'+(_art.modoBorrar?' on':'')+'" id="artBorrar">Borrar placa</button>'+
        '<button type="button" class="art-bt" id="artLimpaBorr">Tirar borrões</button>'+
      '</div>'+
      '<label class="art-zoom"><span>Zoom</span>'+
        '<input type="range" id="artZoom" min="100" max="260" step="1" value="100">'+
        '<output id="artZoomN">100%</output></label>'+
      '<div class="cad-sec"><h3>O anúncio</h3>'+
        '<label class="cad-lbl" for="artTit">Título</label>'+
        '<input class="cad-in" id="artTit" value="'+esc(t)+'" placeholder="Marca, modelo e versão">'+
        '<label class="cad-lbl" for="artSub">Ficha</label>'+
        '<input class="cad-in" id="artSub" value="'+esc(s)+'" placeholder="Ano · cor · combustível">'+
        '<div class="cli-2col">'+
          '<div><label class="cad-lbl" for="artPreco">Preço</label>'+
            '<input class="cad-in" id="artPreco" inputmode="numeric" value="'+(_art.preco?_artBrl(_art.preco):'')+'" placeholder="R$ 0"></div>'+
          '<div><label class="cad-lbl" for="artFipe">FIPE</label>'+
            '<input class="cad-in" id="artFipe" inputmode="numeric" value="'+(f?_artBrl(f):'')+'" placeholder="R$ 0"></div>'+
        '</div>'+
        '<label class="cad-lbl" for="artChips">Destaques (separe por vírgula)</label>'+
        '<input class="cad-in" id="artChips" value="'+esc(_art.chips.join(', '))+'" placeholder="Único dono, IPVA pago, Pneus novos">'+
        '<label class="cad-lbl" for="artObs">A fazer (sai em amarelo)</label>'+
        '<input class="cad-in" id="artObs" value="'+esc(_art.obs)+'" placeholder="Ex.: revisar embreagem">'+
        '<label class="cpr-check"><input type="checkbox" id="artRep"'+(_art.repasse?' checked':'')+'>'+
          '<span><b>Selo REPASSE</b><i>A pílula azul no alto da arte.</i></span></label>'+
      '</div>'+
      '<div class="art-linha art-linha-fim">'+
        '<button type="button" class="cad-btn" id="artBaixar">Baixar a arte</button>'+
        '<button type="button" class="art-bt" id="artCopiar">Copiar o texto</button>'+
      '</div>'+
      '<input type="file" id="artFile" accept="image/*" style="display:none">'+
    '</div>';
  }

  /* o preview: o MESMO desenho da arte final, só reduzido pela tela.
     🔴 desenhar o preview por outro caminho seria aprovar uma coisa e
     baixar outra — a lição do 13c ("o palco mostra a mesma composição"). */
  function artPinta(){
    var cv=document.getElementById('artCv'); if(!cv) return;
    try{ if(_artRaf) cancelAnimationFrame(_artRaf); }catch(_){}
    _artRaf=requestAnimationFrame(function(){
      try{ artDesenhar(cv); }catch(e){ try{ window.mevErro&&mevErro(e,'artPinta'); }catch(_){} }
    });
  }

  function _artSlot(){ return _art.slots[_art.layout===1?0:_art.i]; }

  /* converte um toque na tela pra coordenada DA ARTE (1080×1920) */
  function _artPonto(ev, cv){
    var r=cv.getBoundingClientRect();
    return { x:(ev.clientX-r.left)*(ART_W/r.width), y:(ev.clientY-r.top)*(ART_H/r.height) };
  }
  /* de qual painel é aquele Y */
  function _artQualPainel(y){
    if(_art.layout===1) return 0;
    var y0=ART_CAB, each=Math.floor((ART_H-ART_CAB-ART_PE-8)/3);
    var i=Math.floor((y-y0)/(each+4));
    return Math.max(0, Math.min(2, i));
  }

  function _artAbrirGaleria(i){
    _art.i=i;
    var f=document.getElementById('artFile'); if(!f) return;
    try{ f.value=''; }catch(_){}
    f.click();
  }

  function _artCarregar(file){
    if(!file) return;
    var u=URL.createObjectURL(file), im=new Image();
    im.onload=function(){
      var alpha=/png/i.test(file.type||'') ? _artTemAlpha(im) : false;
      _art.slots[_art.i]={ img:im, iw:im.width, ih:im.height, dx:0, dy:0, zoom:100, alpha:alpha, url:u };
      var z=document.getElementById('artZoom'); if(z) z.value=100;
      var zn=document.getElementById('artZoomN'); if(zn) zn.textContent='100%';
      artPinta();
      try{ toast(alpha?'Recorte com transparência — fundo de showroom aplicado ✓':'Foto carregada ✓'); }catch(_){}
    };
    im.onerror=function(){
      try{ URL.revokeObjectURL(u); }catch(_){}
      try{ toast('Não consegui abrir essa foto. Tente outra.'); }catch(_){}
    };
    im.src=u;
  }

  function _artLerCampos(){
    function g(id){ var e=document.getElementById(id); return e?String(e.value||'').trim():''; }
    _art.titulo=g('artTit'); _art.sub=g('artSub');
    _art.preco=_artNum(g('artPreco')); _art.fipe=_artNum(g('artFipe'));
    _art.chips=g('artChips').split(',').map(function(x){ return x.trim(); }).filter(Boolean).slice(0,4);
    _art.obs=g('artObs');
    var r=document.getElementById('artRep'); _art.repasse=r?!!r.checked:true;
  }

  async function artBaixar(){
    var cv=document.createElement('canvas');
    try{ artDesenhar(cv); }catch(e){ try{ toast('Não consegui gerar a arte.'); }catch(_){} return; }
    var blob=await new Promise(function(r){ cv.toBlob(r,'image/jpeg',0.94); });
    if(!blob){ try{ toast('Não consegui gerar a arte.'); }catch(_){} return; }
    /* 🔴 blob + <a download>: o caminho que funciona no iPhone e no PWA.
       A v821 descobriu, no contrato, que o save() falha calado por aqui. */
    var nome='arte-'+(String(_art.titulo||'anuncio').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-')
      .replace(/^-|-$/g,'').slice(0,40) || 'anuncio')+'.jpg';
    try{
      var u=URL.createObjectURL(blob), a=document.createElement('a');
      a.href=u; a.download=nome; document.body.appendChild(a); a.click();
      setTimeout(function(){ try{ URL.revokeObjectURL(u); a.remove(); }catch(_){} },800);
      try{ toast('Arte baixada ✓'); }catch(_){}
    }catch(_){
      try{ window.open(URL.createObjectURL(blob),'_blank'); }catch(__){ try{ toast('Não consegui baixar.'); }catch(___){} }
    }
  }

  function _artLigar(el){
    var cv=document.getElementById('artCv'); if(!cv) return;
    var f=document.getElementById('artFile');
    if(f) f.onchange=function(){ var a=this.files&&this.files[0]; this.value=''; _artCarregar(a); };

    /* toque no palco: escolhe foto, arrasta ou borra */
    var arrastando=false, x0=0, y0=0, s0=null;
    cv.style.touchAction='none';
    cv.onpointerdown=function(ev){
      var p=_artPonto(ev,cv);
      if(p.y<ART_CAB || p.y>ART_H-ART_PE) return;      /* cabeçalho e rodapé não são tela de foto */
      var i=_artQualPainel(p.y);
      if(_art.modoBorrar){
        _art.borroes.push({ x:p.x, y:p.y, r:58 });
        _art.modoBorrar=false;
        var bb=document.getElementById('artBorrar'); if(bb) bb.classList.remove('on');
        artPinta(); return;
      }
      _art.i=i;
      var s=_art.slots[i];
      if(!s){ _artAbrirGaleria(i); return; }
      arrastando=true; x0=ev.clientX; y0=ev.clientY; s0={ dx:s.dx, dy:s.dy };
      var z=document.getElementById('artZoom'); if(z) z.value=s.zoom;
      var zn=document.getElementById('artZoomN'); if(zn) zn.textContent=s.zoom+'%';
      try{ cv.setPointerCapture(ev.pointerId); }catch(_){}
      ev.preventDefault();
    };
    cv.onpointermove=function(ev){
      if(!arrastando) return;
      var s=_art.slots[_art.i]; if(!s) return;
      var r=cv.getBoundingClientRect(), k=ART_W/r.width;
      s.dx=s0.dx+(ev.clientX-x0)*k;
      s.dy=s0.dy+(ev.clientY-y0)*k;
      artPinta();
    };
    cv.onpointerup=cv.onpointercancel=function(){ arrastando=false; };

    var z=document.getElementById('artZoom');
    if(z) z.oninput=function(){
      var s=_artSlot(); var zn=document.getElementById('artZoomN');
      if(zn) zn.textContent=this.value+'%';
      if(!s) return; s.zoom=Number(this.value)||100; artPinta();
    };

    Array.prototype.forEach.call(el.querySelectorAll('[data-art-lay]'),function(b){
      b.onclick=function(){
        _art.layout=Number(b.getAttribute('data-art-lay'))||1;
        _art.borroes=[];   /* §5: trocar de layout zera os borrões — a placa muda de lugar */
        _art.i=0;
        Array.prototype.forEach.call(el.querySelectorAll('[data-art-lay]'),function(x){
          x.classList.toggle('on', x.getAttribute('data-art-lay')===String(_art.layout)); });
        artPinta();
      };
    });
    var tr=document.getElementById('artTrocar');
    if(tr) tr.onclick=function(){ _artAbrirGaleria(_art.layout===1?0:_art.i); };
    var bo=document.getElementById('artBorrar');
    if(bo) bo.onclick=function(){
      _art.modoBorrar=!_art.modoBorrar;
      bo.classList.toggle('on', _art.modoBorrar);
      try{ if(_art.modoBorrar) toast('Toque em cima da placa.'); }catch(_){}
    };
    var lb=document.getElementById('artLimpaBorr');
    if(lb) lb.onclick=function(){ _art.borroes=[]; artPinta(); };

    ['artTit','artSub','artPreco','artFipe','artChips','artObs','artRep'].forEach(function(id){
      var e=document.getElementById(id); if(!e) return;
      e.addEventListener('input', function(){ _artLerCampos(); artPinta(); });
      e.addEventListener('change', function(){ _artLerCampos(); artPinta(); });
    });
    ['artPreco','artFipe'].forEach(function(id){
      var e=document.getElementById(id); if(e && typeof _avlMaskRs==='function') _avlMaskRs(e);
    });

    var bx=document.getElementById('artBaixar'); if(bx) bx.onclick=function(){ _artLerCampos(); artBaixar(); };
    var cp=document.getElementById('artCopiar');
    if(cp) cp.onclick=async function(){
      _artLerCampos();
      var t=artTexto();
      if(!t){ try{ toast('Preencha o anúncio primeiro.'); }catch(_){} return; }
      try{ await navigator.clipboard.writeText(t); toast('Texto copiado ✓'); }
      catch(_){
        /* iOS antigo sem clipboard: mostra o texto pra copiar na mão, em vez
           de dizer "copiado" sem ter copiado nada */
        try{ var ta=document.createElement('textarea'); ta.value=t;
          ta.style.cssText='position:fixed;left:8px;right:8px;bottom:8px;height:34vh;z-index:999;font-size:15px';
          document.body.appendChild(ta); ta.focus(); ta.select();
          toast('Copie o texto e toque fora para fechar.');
          ta.onblur=function(){ ta.remove(); };
        }catch(__){ try{ toast('Não consegui copiar.'); }catch(___){} }
      }
    };
  }

  function _artAbrir(el){
    if(!_art) _art=_artNovo();
    var d=_artDoVeiculo();
    if(d){
      if(!_art.titulo) _art.titulo=d.titulo;
      if(!_art.sub)    _art.sub=d.sub;
      if(!_art.fipe)   _art.fipe=d.fipe;
    }
    el.innerHTML=_artHtml();
    _artLerCampos();
    _artLigar(el);
    artPinta();
  }

  /* ---------------------------------------------------------------------
     🔴 A PORTA DE FORA: "Gerar arte" no menu do card do estoque (v823)
     -------------------------------------------------------------------------
     O menu do carro chama isto. A tela abre já com o carro dentro — título,
     ficha, preço e FIPE — e com as fotos do estoque, quando dá.

     ⚠️ "QUANDO DÁ" NÃO É DESLEIXO. A foto do estoque mora noutro domínio
     (o Storage). Desenhar uma imagem de outro domínio num canvas o CONTAMINA,
     e canvas contaminado ESTOURA no `toBlob` — ou seja: a arte apareceria na
     tela e não baixaria, sem explicação. Por isso a foto vem por `fetch` e
     vira blob local antes de encostar no canvas. Se o fetch não passar, o
     painel fica vazio e a pessoa escolhe da galeria; nunca uma arte que não
     baixa.
     --------------------------------------------------------------------- */
  async function _artFotoDaUrl(url){
    try{
      var r=await fetch(url, { mode:'cors', credentials:'omit' });
      if(!r || !r.ok) return null;
      var b=await r.blob();
      var u=URL.createObjectURL(b);
      return await new Promise(function(res){
        var im=new Image();
        im.onload=function(){ res({ img:im, iw:im.width, ih:im.height, dx:0, dy:0, zoom:100,
                                    alpha:/png/i.test(b.type||'')?_artTemAlpha(im):false, url:u }); };
        im.onerror=function(){ try{ URL.revokeObjectURL(u); }catch(_){} res(null); };
        im.src=u;
      });
    }catch(_){ return null; }
  }

  async function arteAnuncioAbrir(v, origem){
    v=v||{};
    _art=_artNovo();
    var anos=(v.ano&&v.ano_modelo&&String(v.ano)!==String(v.ano_modelo))
      ? (v.ano+'/'+v.ano_modelo) : String(v.ano_modelo||v.ano||'');
    _art.titulo=[v.marca,v.modelo].filter(Boolean).join(' ').trim();
    _art.sub=[anos, v.cor, v.combustivel].filter(Boolean).join(' · ');
    _art.preco=Number(v.preco_anuncio)||Number(v.preco_minimo)||0;
    _art.fipe=Number(v.fipe)||0;
    _art.repasse=(origem==='estoque');

    /* abre o painel na aba da arte — o despacho das abas pessoais é do 18e */
    try{ _pnSec='arte'; }catch(_){}
    try{ await telaPainelAdmin(); }
    catch(e){ try{ toast('Não consegui abrir a arte.'); }catch(_){} return; }

    var fs=(v.fotos||[]).filter(Boolean).slice(0,3);
    if(!fs.length){ artPinta(); return; }
    try{ toast('Trazendo as fotos do estoque…'); }catch(_){}
    for(var i=0;i<fs.length;i++){
      var s=await _artFotoDaUrl(typeof imgCdn==='function'?imgCdn(fs[i],1600):fs[i]);
      if(s) _art.slots[i]=s;
      if(i===0 && !s){ try{ toast('Não consegui trazer a foto do estoque — escolha da galeria.'); }catch(_){} }
    }
    if(_art.slots[1]) _art.layout=3;
    /* os campos já estão na tela: repinto os valores e a arte */
    try{
      var m={ artTit:_art.titulo, artSub:_art.sub,
              artPreco:_art.preco?_artBrl(_art.preco):'',
              artFipe:_art.fipe?_artBrl(_art.fipe):'' };
      Object.keys(m).forEach(function(id){ var e=document.getElementById(id); if(e) e.value=m[id]; });
      var lay=document.querySelectorAll('[data-art-lay]');
      Array.prototype.forEach.call(lay,function(x){
        x.classList.toggle('on', x.getAttribute('data-art-lay')===String(_art.layout)); });
    }catch(_){}
    artPinta();
  }

  /* registra a aba pessoal no painel — o despacho já existe no 18e desde o
     refactor da Inspeção (§8.1 do projeto: já estava feito) */
  /* v835: a aba só se registra com a arte ligada (00-edicoes) */
  try{ if(typeof arteDisponivel==='function' && !arteDisponivel()){ /* desligada */ } else
       _pnRegistraPessoal('arte','Arte de anúncio', function(el){ _artAbrir(el); }); }
  catch(_){ }

/* ╔═══ src/app/18i-fecho-do-dia.js ═══════════════════════════════════════ */
  /* ==========================================================================
     18i — FECHO DO DIA (v901)
     --------------------------------------------------------------------------
     Executa o PROJETO20260905fechododianopainel.txt.

     O PROBLEMA, na frase do projeto: desde 01/09 o dinheiro não vem mais em
     folha no dia 5. Vem em pedaços, de fontes diferentes, com prazos
     diferentes — comissão de repasse (dias), de banco (depois da liberação),
     consórcio (diluído em parcelas), indicação de moto (fixo). Isso morava na
     cabeça e no WhatsApp, e o efeito é o pior possível pra quem está
     começando: no dia 20 ele NÃO SABE se o mês fecha, e quando não fecha não
     sabe dizer se faltou avaliação, faltou preço, ou o dinheiro só atrasou.

     ⚠️ ISTO NÃO É CONTABILIDADE. Não substitui o contador, não emite nota,
        não controla imposto. É placar de vendedor.

     🔑 A RAZÃO É O CORAÇÃO DA TELA, não um enfeite. A conta de trabalho dele é
        ~4 avaliações → 1 negócio. O que ele CONTROLA é avaliação; negócio é
        consequência. Quando o mês não fechar, é essa razão que diz se o
        problema foi volume ou preço.

     🔴 OFFLINE-FIRST, E A ORDEM NÃO É DETALHE: o localStorage é a FONTE de
        trabalho, o Supabase é o destino. O contrário (gravar no banco e cair
        pro local quando falha) PARECE a mesma coisa e não é — sem sinal o
        await fica pendurado no timeout e o lançamento some da tela na frente
        dele, na porta da loja. Local primeiro, sempre.

     📌 O TRABALHO PESADO NÃO ESTÁ AQUI: a aba é UMA CHAMADA no fim deste
        arquivo (`_pnRegistraPessoal`), graças ao refactor da v810. E a
        estrutura (ler / gravar local / sincronizar / puxar) é a mesma do
        18g-inspecao.js de propósito — dois padrões de fila offline no mesmo
        app seria um a mais.

     ⚠️ A PALAVRA `fecho:1` NO MP_TAB DO 01-nucleo.js É PARTE DESTE MÓDULO.
        Sem ela o `supa.from('fecho')` vai pra uma tabela que não existe e o
        404 é SILENCIOSO (v508 e v407 — semanas de dado perdido).
     ========================================================================== */

  var _FD_KEY='mev_fecho_v1';
  var _FD_KEY_METAS='mev_fecho_metas_v1';

  /* Os tipos, com a dica de cada um. As dicas são VERDADES DO NEGÓCIO DELE,
     escritas no projeto — não texto de enfeite. É o que faz o lançamento de 20
     segundos sair certo sem ele ter que lembrar da regra. */
  var _FD_TIPOS=[
    ['repasse','Repasse','Comissão de intermediação. O dinheiro do carro NÃO passa na sua conta — você fatura só a comissão, pelo CNPJ.'],
    ['seminovo','Seminovo','Venda de seminovo. Se veio de anúncio de estoque de lojista, anote a loja em “com quem”.'],
    ['financiamento','Financiamento','Comissão do banco/promotora. Costuma cair DEPOIS da liberação — deixe como “a receber” até o dinheiro entrar.'],
    ['consorcio','Consórcio','Comissão diluída nas primeiras parcelas. Lance o total previsto e só marque “já recebi” quando cair tudo.'],
    ['moto','Indicação moto','O parceiro atual paga R$ 500 fixos por indicação fechada.'],
    ['avaliacao','Avaliação','Não é venda, é o combustível: pela sua conta, cada 4 avaliações viram 1 negócio.']
  ];
  var _FD_VALOR_PADRAO={ moto:500 };

  var _fdTudo=null;         /* {id: lancamento} — o que está no aparelho */
  var _fdMes=null;          /* 'AAAA-MM' */
  var _fdSoHoje=false;
  var _fdEdit=null;         /* o lançamento aberto no modal, ou null */
  var _fdModal=null;        /* 'negocio' | 'avaliacao' | null */
  var _fdSincronizando=false;

  /* ---------------------------------------------------------------- utilidade */
  function _fdId(){
    try{ if(window.crypto && crypto.randomUUID) return crypto.randomUUID(); }catch(_){ }
    return 'fd-'+Date.now()+'-'+Math.random().toString(36).slice(2,10);
  }
  function _fdAgora(){ return new Date().toISOString(); }
  function _fdTxt(v){ return String(v==null?'':v).trim(); }
  /* o dia LOCAL, não o UTC: `toISOString()` cru vira ontem depois das 21h no
     Brasil, e um lançamento da noite cairia no dia errado do placar */
  function _fdHoje(){
    var d=new Date();
    return new Date(d.getTime()-d.getTimezoneOffset()*60000).toISOString().slice(0,10);
  }
  function _fdMesAtual(){ return _fdHoje().slice(0,7); }
  function _fdBrl(n){
    try{ return 'R$ '+Math.round(Number(n)||0).toLocaleString('pt-BR'); }
    catch(_){ return 'R$ '+Math.round(Number(n)||0); }
  }
  /* aceita "1.180", "1180,50", "R$ 1.180" — o dedo dele digita de tudo */
  function _fdNum(v){
    if(v==null) return 0;
    var s=String(v).trim().replace(/[^\d,.-]/g,'');
    if(!s) return 0;
    if(s.indexOf(',')>=0) s=s.replace(/\./g,'').replace(',','.');
    else if((s.match(/\./g)||[]).length>1) s=s.replace(/\./g,'');
    else if(/\.\d{3}$/.test(s)) s=s.replace(/\./g,'');
    var n=parseFloat(s);
    return isNaN(n)?0:n;
  }
  function _fdTipo(id){
    for(var i=0;i<_FD_TIPOS.length;i++) if(_FD_TIPOS[i][0]===id) return _FD_TIPOS[i];
    return _FD_TIPOS[0];
  }
  /* 🔴 A CONTA, e ela é uma linha só: comissão × a parte dele.
     `a_definir` devolve ZERO de propósito — combinado que ainda não fechou não
     pode inflar nem esvaziar a régua do mês; ele aparece como "a combinar". */
  function _fdLiquido(x){
    if(!x || x.a_definir) return 0;
    var p=(x.pct==null?100:Number(x.pct));
    if(!(p>=0)) p=100;
    return (Number(x.comissao)||0) * p/100;
  }
  function _fdDataLonga(iso){
    var p=String(iso||'').split('-');
    if(p.length<3) return iso||'';
    var d=new Date(+p[0], +p[1]-1, +p[2]);
    var dias=['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];
    var meses=['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    return (iso===_fdHoje()?'Hoje · ':'')+dias[d.getDay()]+', '+p[2]+' '+meses[d.getMonth()];
  }

  /* ----------------------------------------------------- o aparelho é a fonte */
  function _fdLer(){
    if(_fdTudo) return _fdTudo;
    try{ _fdTudo=JSON.parse(localStorage.getItem(_FD_KEY)||'{}')||{}; }
    catch(_){ _fdTudo={}; }
    return _fdTudo;
  }
  function _fdGravaLocal(x){
    var t=_fdLer();
    x.updated_at=_fdAgora();
    t[x.id]=x;
    try{ localStorage.setItem(_FD_KEY, JSON.stringify(t)); }
    catch(e){ try{ window.mevErro && window.mevErro(e,'_fdGravaLocal'); }catch(_){ } }
    return x;
  }
  function _fdApagaLocal(id){
    var t=_fdLer();
    if(t[id]){ t[id]._apagado=true; t[id]._pend=true; t[id].updated_at=_fdAgora(); }
    try{ localStorage.setItem(_FD_KEY, JSON.stringify(t)); }catch(_){ }
  }
  /* As metas são do APARELHO — o projeto foi explícito: dois números, sem
     tabela. Se um dia precisarem seguir entre celular e computador, vão pro
     jsonb do perfil, não pra uma tabela nova. */
  function _fdMetas(){
    var m={ sobrevivencia:6500, meta:10000 };
    try{
      var o=JSON.parse(localStorage.getItem(_FD_KEY_METAS)||'null');
      if(o && Number(o.sobrevivencia)>0) m.sobrevivencia=Number(o.sobrevivencia);
      if(o && Number(o.meta)>0) m.meta=Number(o.meta);
    }catch(_){ }
    return m;
  }
  function _fdGravaMetas(m){
    try{ localStorage.setItem(_FD_KEY_METAS, JSON.stringify(m)); }catch(_){ }
  }

  /* =========================================================== a fila de sync
     🔴 A REGRA DA v483: todo gravar pede a linha de volta e confere
     `data.length`. Sem isso, um insert barrado pela RLS volta "sucesso" com
     zero linhas — e o lançamento sumiria do aparelho achando que subiu. */
  async function _fdSincronizar(silencioso){
    if(_fdSincronizando) return 0;
    if(typeof supa==='undefined' || !supa || !meuId) return 0;
    var t=_fdLer(), ids=Object.keys(t).filter(function(k){ return t[k] && t[k]._pend; });
    if(!ids.length) return 0;
    _fdSincronizando=true;
    var subiram=0;
    for(var i=0;i<ids.length;i++){
      var x=t[ids[i]];
      try{
        if(x._apagado){
          var d=await supa.from('fecho').delete().eq('id',x.id).select('id');
          if(d && d.error) throw d.error;
          /* apagar linha que nunca subiu devolve zero — e isso é sucesso,
             não erro: o que importa é que ela não existe mais lá */
          delete t[x.id];
          try{ localStorage.setItem(_FD_KEY, JSON.stringify(t)); }catch(_){ }
          subiram++;
          continue;
        }
        var linha={
          id:x.id, user_id:meuId, tipo:x.tipo, data:x.data,
          descricao:_fdTxt(x.descricao)||null, quem:_fdTxt(x.quem)||null,
          valor:(x.valor==null?null:Number(x.valor)),
          comissao:Number(x.comissao)||0,
          a_definir:!!x.a_definir,
          pct:(x.pct==null?100:Number(x.pct)),
          parceiro:_fdTxt(x.parceiro)||null,
          status:x.status||'aberto',
          qtd:Number(x.qtd)||1,
          obs:_fdTxt(x.obs)||null,
          lojista_id:x.lojista_id||null,
          inspecao_id:x.inspecao_id||null,
          updated_at:x.updated_at||_fdAgora(),
          synced_at:_fdAgora()
        };
        var r=await supa.from('fecho').upsert(linha).select('id');
        if(r && r.error) throw r.error;
        if(!r || !r.data || !r.data.length){
          throw new Error('O banco aceitou sem gravar nenhuma linha.');
        }
        x._pend=false; x.synced_at=linha.synced_at;
        _fdGravaLocal(x);
        subiram++;
      }catch(e){
        try{ window.mevErro && window.mevErro(e,'_fdSincronizar'); }catch(_){ }
        break;   /* sem rede ou sem tabela: para aqui e tenta na próxima */
      }
    }
    _fdSincronizando=false;
    if(subiram && !silencioso) toast(subiram+' lançamento(s) sincronizado(s).');
    return subiram;
  }

  /* traz do banco o que este aparelho ainda não tem (celular novo, ou o
     computador depois de ele ter lançado na rua) */
  async function _fdPuxar(){
    if(typeof supa==='undefined' || !supa || !meuId) return;
    try{
      var r=await supa.from('fecho')
        .select('id,tipo,data,descricao,quem,valor,comissao,a_definir,pct,parceiro,status,qtd,obs,lojista_id,inspecao_id,created_at,updated_at,synced_at')
        .order('data',{ascending:false}).limit(500);
      if(r && r.error) throw r.error;
      var t=_fdLer(), mudou=false;
      ((r&&r.data)||[]).forEach(function(x){
        var local=t[x.id];
        /* o que está pendente no aparelho é mais novo que o banco por
           definição — o banco não pode sobrescrever trabalho não sincronizado */
        if(local && local._pend) return;
        if(local && String(local.updated_at||'') >= String(x.updated_at||'')) return;
        x._pend=false; t[x.id]=x; mudou=true;
      });
      if(mudou){ try{ localStorage.setItem(_FD_KEY, JSON.stringify(t)); }catch(_){ } }
    }catch(e){
      try{ window.mevErro && window.mevErro(e,'_fdPuxar'); }catch(_){ }
    }
  }

  /* ------------------------------------------------------------------- CSS */
  function _fdCss(){
    if(document.getElementById('fdCss')) return;
    var s=document.createElement('style');
    s.id='fdCss';
    s.textContent=[
      '.fd-topo{display:flex;gap:8px;align-items:center;justify-content:space-between;flex-wrap:wrap;margin-bottom:12px}',
      '.fd-mes{display:flex;align-items:center;gap:8px}',
      '.fd-mes input{min-height:44px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);padding:0 10px;font-family:inherit;font-size:15px;color:inherit;background:#fff}',
      '.fd-tiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:1px;background:var(--linha,#e2e8f0);border:1px solid var(--linha,#e2e8f0);border-radius:12px;overflow:hidden;margin-bottom:12px}',
      '.fd-tile{background:#fff;padding:12px 14px;display:flex;flex-direction:column;gap:2px}',
      '.fd-tile .fd-lab{font-size:11px;letter-spacing:.09em;text-transform:uppercase;color:#64748b}',
      '.fd-tile .fd-val{font-size:22px;font-weight:800;letter-spacing:-.3px;font-variant-numeric:tabular-nums}',
      '.fd-tile .fd-sub{font-size:12px;color:#64748b}',
      '.fd-tile.pago .fd-val{color:#155f36}',
      '.fd-tile.aberto .fd-val{color:#7a4f0c}',
      /* a régua: barra com dois marcadores. O `overflow:hidden` do trilho é o
         que impede a barra de vazar quando o mês passa da escala. */
      '.fd-regua{margin-bottom:14px}',
      '.fd-regua-topo{display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap;margin-bottom:7px}',
      '.fd-regua-topo .fd-t{font-size:11px;letter-spacing:.09em;text-transform:uppercase;color:#64748b}',
      '.fd-falta{font-size:13.5px;color:#475569}',
      '.fd-falta b{font-variant-numeric:tabular-nums;color:#0f172a}',
      '.fd-trilho{position:relative;height:28px;background:#eef2f6;border-radius:8px;overflow:hidden}',
      '.fd-fill{position:absolute;left:0;top:0;bottom:0;background:#1b7a46;opacity:.88;border-radius:8px 0 0 8px;transition:width .3s ease}',
      '.fd-tick{position:absolute;top:0;bottom:0;width:2px;background:#94a3b8}',
      '.fd-tick.meta{background:#334155}',
      '.fd-legenda{display:flex;justify-content:space-between;font-size:11.5px;color:#64748b;margin-top:6px}',
      '.fd-legenda b{font-variant-numeric:tabular-nums}',
      '.fd-portipo{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:12px}',
      '.fd-pt{display:flex;align-items:baseline;gap:6px;border:1px solid var(--linha,#e2e8f0);border-radius:9px;padding:7px 10px;font-size:13px;background:#fff}',
      '.fd-pt .fd-n{font-weight:800;font-variant-numeric:tabular-nums}',
      '.fd-pt .fd-t{color:#64748b;font-size:11px;letter-spacing:.07em;text-transform:uppercase}',
      '.fd-acoes{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px}',
      '.fd-acoes button{min-height:44px}',
      '.fd-dia{margin-bottom:14px}',
      '.fd-dia-cab{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin-bottom:6px;padding:0 2px}',
      '.fd-dia-cab h4{margin:0;font-size:12.5px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#475569}',
      '.fd-dia-cab .fd-soma{font-size:13px;font-weight:700;color:#475569;font-variant-numeric:tabular-nums}',
      '.fd-it{display:grid;grid-template-columns:auto 1fr auto;gap:10px;align-items:center;border:1px solid var(--linha,#e2e8f0);border-radius:11px;padding:10px 12px;margin-bottom:7px;background:#fff}',
      '.fd-it.aval{background:#f6f8fa;border-left:3px solid #94a3b8}',
      '.fd-chip{font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;padding:5px 8px;border-radius:6px;background:#eef2f6;color:#475569;white-space:nowrap}',
      '.fd-chip.repasse,.fd-chip.seminovo{background:#dcefe3;color:#155f36}',
      '.fd-chip.financiamento{background:#f7e9d2;color:#7a4f0c}',
      '.fd-desc{min-width:0}',
      '.fd-l1{font-weight:700;font-size:14.5px;overflow-wrap:anywhere}',
      '.fd-l2{font-size:12.5px;color:#64748b;overflow-wrap:anywhere}',
      '.fd-dir{display:flex;align-items:center;gap:8px;flex-wrap:wrap;justify-content:flex-end}',
      '.fd-valor{font-weight:800;font-size:15.5px;font-variant-numeric:tabular-nums;white-space:nowrap}',
      '.fd-valor.combinar{font-size:11.5px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#7a4f0c}',
      '.fd-st{min-height:36px;border:1px solid var(--linha,#e2e8f0);background:#fff;font-family:inherit;font-size:11px;font-weight:800;',
        'letter-spacing:.06em;text-transform:uppercase;padding:0 10px;border-radius:20px;color:#7a4f0c;cursor:pointer;white-space:nowrap}',
      '.fd-st.pago{color:#155f36;border-color:#1b7a46;background:#dcefe3}',
      '.fd-ico{min-height:36px;background:transparent;border:1px solid transparent;color:#64748b;font-family:inherit;font-size:12.5px;padding:0 7px;border-radius:8px;cursor:pointer}',
      '.fd-ico:hover{color:#0f172a;border-color:var(--linha,#e2e8f0)}',
      '.fd-metas{display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;border-top:1px solid var(--linha,#e2e8f0);padding-top:12px;margin-top:6px}',
      '.fd-metas label{display:flex;flex-direction:column;gap:4px;font-size:11.5px;color:#64748b;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
      '.fd-metas input{min-height:44px;width:150px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);padding:0 10px;font-family:inherit;font-size:15px;font-variant-numeric:tabular-nums;color:inherit;background:#fff}',
      '.fd-estado{font-size:12px;color:#64748b;margin-left:auto}',
      '.fd-estado b{color:#7a4f0c}',
      /* o modal: mesma linguagem da folha do card (v725) — no celular sobe de
         baixo, no computador fica no meio */
      '.fd-bg{position:fixed;inset:0;z-index:70;background:rgba(3,15,40,.5);display:flex;align-items:flex-end;justify-content:center}',
      '@media(min-width:700px){.fd-bg{align-items:center;padding:24px}}',
      '.fd-modal{background:#fff;width:100%;max-width:560px;max-height:92vh;overflow-y:auto;border-radius:16px 16px 0 0;',
        'padding:16px 14px calc(20px + env(safe-area-inset-bottom,0px));display:flex;flex-direction:column;gap:12px}',
      '@media(min-width:700px){.fd-modal{border-radius:16px}}',
      '.fd-modal h3{margin:0;font-size:18px}',
      '.fd-campo{display:flex;flex-direction:column;gap:5px}',
      '.fd-campo>span{font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:#64748b;font-weight:700}',
      /* 🔴 16px no input NÃO é gosto: abaixo disso o iPhone dá zoom sozinho ao
         focar o campo e a tela salta na cara dele */
      '.fd-campo input,.fd-campo textarea{min-height:44px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);',
        'padding:10px;font-family:inherit;font-size:16px;color:inherit;background:#fff;width:100%;box-sizing:border-box}',
      '.fd-campo textarea{min-height:56px;resize:vertical}',
      '.fd-duplo{display:grid;grid-template-columns:1fr 1fr;gap:10px}',
      '.fd-chips{display:flex;flex-wrap:wrap;gap:6px}',
      '.fd-chips button{min-height:44px;border-radius:10px;border:1px solid var(--linha,#e2e8f0);background:#fff;',
        'font-family:inherit;font-size:13.5px;font-weight:600;color:#475569;padding:0 12px;cursor:pointer}',
      '.fd-chips button[aria-pressed="true"]{background:#0a4da6;border-color:#0a4da6;color:#fff;font-weight:800}',
      '.fd-dica{font-size:12.5px;color:#475569;background:#eef4ff;border-radius:9px;padding:9px 11px}',
      '.fd-check{display:flex;gap:8px;align-items:center;font-size:13.5px;color:#475569;min-height:44px}',
      '.fd-check input{width:auto;min-height:0;margin:0}',
      '.fd-liq{display:flex;justify-content:space-between;align-items:baseline;gap:10px;border-top:1px solid var(--linha,#e2e8f0);padding-top:11px}',
      '.fd-liq .fd-lab{font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:#64748b;font-weight:700}',
      '.fd-liq .fd-v{font-size:23px;font-weight:800;color:#155f36;font-variant-numeric:tabular-nums}',
      '.fd-modal-acoes{display:flex;gap:8px}',
      '.fd-modal-acoes button{min-height:48px;flex:1}',
      '@media (prefers-color-scheme:dark){',
        '.fd-tile,.fd-it,.fd-pt,.fd-modal,.fd-campo input,.fd-campo textarea,.fd-chips button,.fd-metas input,.fd-mes input,.fd-st{background:#161f24;border-color:#26343a;color:#e2eaec}',
        '.fd-trilho{background:#1d272d}',
        '.fd-it.aval{background:#1a2429}',
        '.fd-dica{background:#12212f;color:#c8d6e5}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ============================================================== as contas
     Uma função só, porque a tela inteira depende dos mesmos números e ter duas
     contas parecidas em lugares diferentes é como um total passa a divergir do
     outro sem ninguém ver. */
  function _fdResumo(mes){
    var t=_fdLer();
    var doMes=Object.keys(t).map(function(k){ return t[k]; })
      .filter(function(x){ return x && !x._apagado && String(x.data||'').slice(0,7)===mes; });

    var negocios=doMes.filter(function(x){ return x.tipo!=='avaliacao'; });
    var avaliacoes=doMes.filter(function(x){ return x.tipo==='avaliacao'; });

    var total=0, pago=0, aberto=0, nPago=0, nAberto=0, nCombinar=0;
    negocios.forEach(function(x){
      if(x.a_definir){ nCombinar++; return; }   /* não soma em lugar nenhum */
      var l=_fdLiquido(x);
      total+=l;
      if(x.status==='pago'){ pago+=l; nPago++; } else { aberto+=l; nAberto++; }
    });
    var qtdAval=avaliacoes.reduce(function(a,b){ return a+(Number(b.qtd)||0); },0);

    return {
      itens:doMes, negocios:negocios, avaliacoes:avaliacoes,
      total:total, pago:pago, aberto:aberto,
      nPago:nPago, nAberto:nAberto, nCombinar:nCombinar,
      qtdAval:qtdAval,
      /* a razão: avaliações ÷ negócios fechados. Sem negócio ainda, a divisão
         não existe — e mostrar "∞" ou "0" nos dois casos seria mentira. */
      razao: negocios.length ? (qtdAval/negocios.length) : null,
      pendentes: Object.keys(t).filter(function(k){ return t[k] && t[k]._pend; }).length
    };
  }

  /* ================================================================= a lista */
  function _fdListaHtml(){
    var mes=_fdMes||_fdMesAtual();
    var R=_fdResumo(mes), M=_fdMetas();

    var sub1 = R.negocios.length ? (R.negocios.length+(R.negocios.length===1?' negócio fechado':' negócios fechados')) : 'nenhum negócio lançado';
    var sub4 = R.qtdAval ? (R.razao!=null ? (R.razao.toFixed(1).replace('.',',')+' por negócio') : 'nenhuma virou negócio ainda')
                         : 'nenhuma ainda';

    var h='<div class="fd-topo">'+
      '<div class="fd-mes"><label for="fdMes" style="font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:#64748b;font-weight:700">Mês</label>'+
      '<input type="month" id="fdMes" value="'+esc(mes)+'"></div>'+
      (R.pendentes?('<button type="button" class="link" id="fdSync">'+R.pendentes+' pra sincronizar</button>'):'')+
      '</div>';

    h+='<div class="fd-tiles">'+
      '<div class="fd-tile"><span class="fd-lab">Comissão do mês</span><span class="fd-val" id="fdVTotal">'+_fdBrl(R.total)+'</span><span class="fd-sub">'+esc(sub1)+'</span></div>'+
      '<div class="fd-tile pago"><span class="fd-lab">Já no bolso</span><span class="fd-val" id="fdVPago">'+_fdBrl(R.pago)+'</span><span class="fd-sub">'+R.nPago+(R.nPago===1?' negócio pago':' negócios pagos')+'</span></div>'+
      '<div class="fd-tile aberto"><span class="fd-lab">A receber</span><span class="fd-val" id="fdVAberto">'+_fdBrl(R.aberto)+'</span><span class="fd-sub">'+R.nAberto+(R.nAberto===1?' em aberto':' em aberto')+(R.nCombinar?(' · '+R.nCombinar+' a combinar'):'')+'</span></div>'+
      '<div class="fd-tile"><span class="fd-lab">Avaliações</span><span class="fd-val" id="fdVAval">'+R.qtdAval+'</span><span class="fd-sub">'+esc(sub4)+'</span></div>'+
      '</div>';

    /* a régua. A escala pega o maior entre a meta, o total com folga e a
       sobrevivência com folga — assim a barra nunca encosta na ponta nem fica
       ridícula quando o mês estoura a meta. */
    var escala=Math.max(M.meta, R.total*1.08, M.sobrevivencia*1.2, 1);
    var falta;
    if(R.total < M.sobrevivencia) falta='Falta <b>'+_fdBrl(M.sobrevivencia-R.total)+'</b> para a sobrevivência do mês.';
    else if(R.total < M.meta)     falta='Sobrevivência garantida. Falta <b>'+_fdBrl(M.meta-R.total)+'</b> para a meta.';
    else                          falta='Meta batida — <b>'+_fdBrl(R.total-M.meta)+'</b> acima dela.';

    h+='<div class="fd-regua">'+
      '<div class="fd-regua-topo"><span class="fd-t">Régua do mês</span><span class="fd-falta" id="fdFalta">'+falta+'</span></div>'+
      '<div class="fd-trilho"><div class="fd-fill" style="width:'+Math.min(100,(R.total/escala)*100).toFixed(1)+'%"></div>'+
      '<div class="fd-tick" style="left:'+((M.sobrevivencia/escala)*100).toFixed(1)+'%"></div>'+
      '<div class="fd-tick meta" style="left:'+((M.meta/escala)*100).toFixed(1)+'%"></div></div>'+
      '<div class="fd-legenda"><span>Sobrevivência <b>'+_fdBrl(M.sobrevivencia)+'</b></span>'+
      '<span>Meta <b>'+_fdBrl(M.meta)+'</b></span></div></div>';

    /* resumo por tipo — só dos tipos que tiveram lançamento no mês */
    var pt='';
    _FD_TIPOS.forEach(function(T){
      if(T[0]==='avaliacao') return;
      var s=0,n=0;
      R.negocios.forEach(function(x){ if(x.tipo===T[0]){ s+=_fdLiquido(x); n++; } });
      if(!n) return;
      pt+='<div class="fd-pt"><span class="fd-t">'+esc(T[1])+'</span><span class="fd-n">'+_fdBrl(s)+'</span><span class="fd-t">'+n+'x</span></div>';
    });
    if(pt) h+='<div class="fd-portipo">'+pt+'</div>';

    h+='<div class="fd-acoes">'+
      '<button type="button" class="btn btn-azul" id="fdNovo">+ Lançar negócio fechado</button>'+
      '<button type="button" class="btn" id="fdNovaAval">+ Avaliação</button>'+
      '<button type="button" class="btn" id="fdHoje">'+(_fdSoHoje?'Ver o mês inteiro':'Ver só hoje')+'</button>'+
      '</div>';

    /* a lista, agrupada por dia, dia mais novo em cima */
    var mostra=R.itens.slice();
    if(_fdSoHoje) mostra=mostra.filter(function(x){ return x.data===_fdHoje(); });

    if(!mostra.length){
      h+='<div class="cli-empty"><b>'+(_fdSoHoje?'Nada lançado hoje ainda.':'Nenhum lançamento neste mês.')+'</b>'+
         'Toque em <b>Lançar negócio fechado</b> assim que bater o martelo — leva 20 segundos. Funciona sem internet.</div>';
    }else{
      var porDia={};
      mostra.forEach(function(x){ (porDia[x.data]=porDia[x.data]||[]).push(x); });
      Object.keys(porDia).sort().reverse().forEach(function(dia){
        var doDia=porDia[dia];
        var soma=doDia.reduce(function(a,b){ return a+(b.tipo==='avaliacao'?0:_fdLiquido(b)); },0);
        h+='<section class="fd-dia"><div class="fd-dia-cab"><h4>'+esc(_fdDataLonga(dia))+'</h4>'+
           '<span class="fd-soma">'+_fdBrl(soma)+'</span></div>';
        doDia.forEach(function(x){
          var T=_fdTipo(x.tipo);
          if(x.tipo==='avaliacao'){
            var qa=Number(x.qtd)||0;
            h+='<article class="fd-it aval" data-fd-id="'+esc(String(x.id))+'">'+
               '<span class="fd-chip">Avaliação</span>'+
               '<span class="fd-desc"><span class="fd-l1">'+qa+(qa===1?' avaliação':' avaliações')+
               (_fdTxt(x.quem)?(' · '+esc(_fdTxt(x.quem))):'')+'</span>'+
               '<span class="fd-l2">'+esc(_fdTxt(x.obs)||'sem negócio fechado ainda')+
               (x._pend?' · no aparelho, ainda não sincronizada':'')+'</span></span>'+
               '<span class="fd-dir">'+
               '<button type="button" class="fd-ico" data-fd-edita="'+esc(String(x.id))+'">editar</button>'+
               '<button type="button" class="fd-ico" data-fd-apaga="'+esc(String(x.id))+'">apagar</button>'+
               '</span></article>';
            return;
          }
          var l2=[];
          if(_fdTxt(x.quem)) l2.push(_fdTxt(x.quem));
          if(x.pct!=null && Number(x.pct)!==100) l2.push(Number(x.pct)+'% meu'+(_fdTxt(x.parceiro)?(' · '+_fdTxt(x.parceiro)):''));
          if(x.valor) l2.push('negócio de '+_fdBrl(x.valor));
          if(_fdTxt(x.obs)) l2.push(_fdTxt(x.obs));
          if(x._pend) l2.push('no aparelho, ainda não sincronizado');
          h+='<article class="fd-it" data-fd-id="'+esc(String(x.id))+'">'+
             '<span class="fd-chip '+esc(x.tipo)+'">'+esc(T[1])+'</span>'+
             '<span class="fd-desc"><span class="fd-l1">'+esc(_fdTxt(x.descricao)||T[1])+'</span>'+
             '<span class="fd-l2">'+esc(l2.join(' · '))+'</span></span>'+
             '<span class="fd-dir">'+
             (x.a_definir
               ? '<span class="fd-valor combinar">a combinar</span>'
               : '<span class="fd-valor">'+_fdBrl(_fdLiquido(x))+'</span>')+
             '<button type="button" class="fd-st'+(x.status==='pago'?' pago':'')+'" data-fd-st="'+esc(String(x.id))+'">'+
               (x.status==='pago'?'Recebido':'A receber')+'</button>'+
             '<button type="button" class="fd-ico" data-fd-edita="'+esc(String(x.id))+'">editar</button>'+
             '<button type="button" class="fd-ico" data-fd-apaga="'+esc(String(x.id))+'">apagar</button>'+
             '</span></article>';
        });
        h+='</section>';
      });
    }

    h+='<div class="fd-metas">'+
      '<label>Sobrevivência (R$/mês)<input id="fdMetaSob" inputmode="decimal" value="'+M.sobrevivencia+'"></label>'+
      '<label>Meta (R$/mês)<input id="fdMetaMeta" inputmode="decimal" value="'+M.meta+'"></label>'+
      '<span class="fd-estado" id="fdEstado">'+
        (R.pendentes?('<b>'+R.pendentes+' lançamento(s) só neste aparelho</b> — sobem sozinhos quando houver sinal.')
                    :'Tudo sincronizado.')+
      '</span></div>';

    if(_fdModal) h+=_fdModalHtml();
    return h;
  }

  /* ============================================================== o modal */
  function _fdModalHtml(){
    var x=_fdEdit||{};
    var novo=!x.id;
    if(_fdModal==='avaliacao'){
      return '<div class="fd-bg" id="fdBg"><form class="fd-modal" id="fdForm">'+
        '<h3>'+(novo?'Avaliações do dia':'Editar avaliações')+'</h3>'+
        '<div class="fd-dica">Avaliação é o combustível: pela sua conta, cada 4 avaliações viram 1 negócio fechado. Lançar aqui mostra se o mês travou por preço ou por falta de carro na mão.</div>'+
        '<div class="fd-duplo">'+
          '<label class="fd-campo"><span>Data</span><input type="date" id="fdData" value="'+esc(x.data||_fdDataPadrao())+'" required></label>'+
          '<label class="fd-campo"><span>Quantas</span><input id="fdQtd" inputmode="numeric" value="'+(x.qtd||1)+'"></label>'+
        '</div>'+
        '<label class="fd-campo"><span>Para quem / de quem</span><input id="fdQuem" value="'+esc(x.quem||'')+'" placeholder="ex.: Léo Repasses"></label>'+
        '<label class="fd-campo"><span>Observação (opcional)</span><textarea id="fdObs" placeholder="ex.: 2 Gol e 2 Onix, esperando o preço dele">'+esc(x.obs||'')+'</textarea></label>'+
        '<div class="fd-modal-acoes">'+
          '<button type="submit" class="btn btn-azul">Salvar avaliações</button>'+
          '<button type="button" class="btn" id="fdCancela">Cancelar</button>'+
        '</div></form></div>';
    }

    var tipo=x.tipo||'repasse';
    var pct=(x.pct==null?100:Number(x.pct));
    var modo=(pct===100?'100':(pct===50?'50':'outro'));
    var chipsTipo=_FD_TIPOS.filter(function(T){ return T[0]!=='avaliacao'; }).map(function(T){
      return '<button type="button" data-fd-tipo="'+T[0]+'" aria-pressed="'+(T[0]===tipo?'true':'false')+'">'+esc(T[1])+'</button>';
    }).join('');

    return '<div class="fd-bg" id="fdBg"><form class="fd-modal" id="fdForm">'+
      '<h3>'+(novo?'Novo negócio fechado':'Editar negócio')+'</h3>'+
      '<div class="fd-campo"><span>Tipo de negócio</span><div class="fd-chips" id="fdChipsTipo">'+chipsTipo+'</div></div>'+
      '<div class="fd-dica" id="fdDica">'+esc(_fdTipo(tipo)[2])+'</div>'+
      '<div class="fd-duplo">'+
        '<label class="fd-campo"><span>Data</span><input type="date" id="fdData" value="'+esc(x.data||_fdDataPadrao())+'" required></label>'+
        '<label class="fd-campo"><span>Valor do negócio (opcional)</span><input id="fdValor" inputmode="decimal" value="'+(x.valor||'')+'" placeholder="ex.: 78.000"></label>'+
      '</div>'+
      '<label class="fd-campo"><span>O que foi</span><input id="fdDesc" value="'+esc(x.descricao||'')+'" placeholder="ex.: Polo Track 2023 prata" required></label>'+
      '<label class="fd-campo"><span>Com quem (comprador, lojista, cliente)</span><input id="fdQuem" value="'+esc(x.quem||'')+'" placeholder="ex.: Loja do Marcelo — Capão da Canoa"></label>'+
      '<label class="fd-campo"><span>Minha comissão bruta (R$)</span>'+
        '<input id="fdCom" inputmode="decimal" value="'+(x.a_definir?'':(x.comissao||''))+'" placeholder="0"'+(x.a_definir?' disabled':'')+'></label>'+
      '<label class="fd-check"><input type="checkbox" id="fdCombinar"'+(x.a_definir?' checked':'')+'> Ainda não definiu a comissão</label>'+
      '<div class="fd-campo"><span>Divisão</span><div class="fd-chips" id="fdChipsDiv">'+
        '<button type="button" data-fd-div="100" aria-pressed="'+(modo==='100'?'true':'false')+'">Tudo meu</button>'+
        '<button type="button" data-fd-div="50" aria-pressed="'+(modo==='50'?'true':'false')+'">50/50 com parceiro</button>'+
        '<button type="button" data-fd-div="outro" aria-pressed="'+(modo==='outro'?'true':'false')+'">Outro %</button>'+
      '</div></div>'+
      '<div class="fd-duplo" id="fdLinhaParc"'+(modo==='100'?' hidden':'')+'>'+
        '<label class="fd-campo"><span>Minha parte (%)</span><input id="fdPct" inputmode="decimal" value="'+pct+'"></label>'+
        '<label class="fd-campo"><span>Parceiro</span><input id="fdParceiro" value="'+esc(x.parceiro||'')+'" placeholder="ex.: lojista de Caxias"></label>'+
      '</div>'+
      '<div class="fd-campo"><span>Status</span><div class="fd-chips" id="fdChipsSt">'+
        '<button type="button" data-fd-st2="aberto" aria-pressed="'+((x.status||'aberto')==='aberto'?'true':'false')+'">A receber</button>'+
        '<button type="button" data-fd-st2="pago" aria-pressed="'+(x.status==='pago'?'true':'false')+'">Já recebi</button>'+
      '</div></div>'+
      '<label class="fd-campo"><span>Observação (opcional)</span><textarea id="fdObs" placeholder="ex.: combinado receber na entrega do carro">'+esc(x.obs||'')+'</textarea></label>'+
      '<div class="fd-liq"><span class="fd-lab">Fica pra mim</span><span class="fd-v" id="fdLiq">'+
        (x.a_definir?'a combinar':_fdBrl((Number(x.comissao)||0)*pct/100))+'</span></div>'+
      '<div class="fd-modal-acoes">'+
        '<button type="submit" class="btn btn-azul">Salvar negócio</button>'+
        '<button type="button" class="btn" id="fdCancela">Cancelar</button>'+
      '</div></form></div>';
  }
  /* lançar num mês que não é o atual não pode cair em "hoje" — cairia fora do
     mês que ele está olhando e o lançamento sumiria da tela ao salvar */
  function _fdDataPadrao(){
    var mes=_fdMes||_fdMesAtual();
    return (mes===_fdMesAtual()) ? _fdHoje() : (mes+'-01');
  }

  /* ================================================================ o desenho */
  function _fdPinta(el){
    el.innerHTML=_fdListaHtml();
    _fdWire(el);
  }

  function _fdModalLiquido(){
    var comb=$('fdCombinar'), com=$('fdCom'), pctI=$('fdPct'), liq=$('fdLiq');
    if(!liq) return;
    if(comb && comb.checked){
      liq.textContent='a combinar';
      if(com) com.disabled=true;
      return;
    }
    if(com) com.disabled=false;
    var p=100;
    var pressed=document.querySelector('#fdChipsDiv button[aria-pressed="true"]');
    var modo=pressed?pressed.getAttribute('data-fd-div'):'100';
    if(modo!=='100'){ p=_fdNum(pctI?pctI.value:50); if(!(p>0&&p<=100)) p=50; }
    liq.textContent=_fdBrl(_fdNum(com?com.value:0)*p/100);
  }

  function _fdWire(el){
    var mi=$('fdMes');
    if(mi) mi.onchange=function(){ _fdMes=this.value||_fdMesAtual(); _fdSoHoje=false; _fdPinta(el); };

    var bs=$('fdSync');
    if(bs) bs.onclick=async function(){ toast('Sincronizando…'); await _fdSincronizar(false); _fdPinta(el); };

    var bh=$('fdHoje');
    if(bh) bh.onclick=function(){ _fdSoHoje=!_fdSoHoje; _fdPinta(el); };

    var bn=$('fdNovo');
    if(bn) bn.onclick=function(){ _fdEdit=null; _fdModal='negocio'; _fdPinta(el); };
    var ba=$('fdNovaAval');
    if(ba) ba.onclick=function(){ _fdEdit=null; _fdModal='avaliacao'; _fdPinta(el); };

    /* 🔴 O TOQUE NA ETIQUETA TROCA O STATUS NA MESMA TELA, sem recarregar. É o
       gesto mais usado da aba: o dinheiro caiu, ele abre e toca. */
    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-st]'), function(b){
      b.onclick=function(){
        var t=_fdLer(), x=t[b.getAttribute('data-fd-st')];
        if(!x) return;
        x.status=(x.status==='pago')?'aberto':'pago';
        x._pend=true;
        _fdGravaLocal(x);
        _fdPinta(el);
        _fdSincronizar(true);
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-edita]'), function(b){
      b.onclick=function(){
        var t=_fdLer(), x=t[b.getAttribute('data-fd-edita')];
        if(!x) return;
        _fdEdit=x; _fdModal=(x.tipo==='avaliacao')?'avaliacao':'negocio';
        _fdPinta(el);
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-apaga]'), function(b){
      b.onclick=function(){
        var id=b.getAttribute('data-fd-apaga');
        var t=_fdLer(), x=t[id];
        if(!x) return;
        if(!confirm('Apagar “'+(_fdTxt(x.descricao)||'este lançamento')+'”? Não dá para desfazer.')) return;
        _fdApagaLocal(id);
        _fdPinta(el);
        _fdSincronizar(true);
      };
    });

    var metaS=$('fdMetaSob'), metaM=$('fdMetaMeta');
    function gravaMetas(){
      var m=_fdMetas();
      if(metaS) m.sobrevivencia=_fdNum(metaS.value)||m.sobrevivencia;
      if(metaM) m.meta=_fdNum(metaM.value)||m.meta;
      _fdGravaMetas(m);
      _fdPinta(el);
    }
    if(metaS) metaS.onchange=gravaMetas;
    if(metaM) metaM.onchange=gravaMetas;

    if(!_fdModal) return;

    /* ---- o modal ---- */
    var bg=$('fdBg');
    function fecha(){ _fdModal=null; _fdEdit=null; _fdPinta(el); }
    if(bg) bg.onclick=function(e){ if(e.target===bg) fecha(); };
    var bc=$('fdCancela');
    if(bc) bc.onclick=fecha;

    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-tipo]'), function(b){
      b.onclick=function(){
        Array.prototype.forEach.call(el.querySelectorAll('[data-fd-tipo]'), function(o){
          o.setAttribute('aria-pressed', o===b?'true':'false');
        });
        var T=_fdTipo(b.getAttribute('data-fd-tipo'));
        var d=$('fdDica'); if(d) d.textContent=T[2];
        /* o valor padrão só ENTRA em campo vazio — nunca por cima do que ele
           já digitou */
        var vp=_FD_VALOR_PADRAO[T[0]], com=$('fdCom');
        if(vp && com && !_fdTxt(com.value)) com.value=vp;
        _fdModalLiquido();
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-div]'), function(b){
      b.onclick=function(){
        Array.prototype.forEach.call(el.querySelectorAll('[data-fd-div]'), function(o){
          o.setAttribute('aria-pressed', o===b?'true':'false');
        });
        var modo=b.getAttribute('data-fd-div');
        var linha=$('fdLinhaParc'), pctI=$('fdPct');
        if(linha) linha.hidden=(modo==='100');
        if(pctI && modo==='50') pctI.value=50;
        if(pctI && modo==='100') pctI.value=100;
        _fdModalLiquido();
      };
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-fd-st2]'), function(b){
      b.onclick=function(){
        Array.prototype.forEach.call(el.querySelectorAll('[data-fd-st2]'), function(o){
          o.setAttribute('aria-pressed', o===b?'true':'false');
        });
      };
    });
    var com=$('fdCom'); if(com) com.oninput=_fdModalLiquido;
    var pctI=$('fdPct'); if(pctI) pctI.oninput=_fdModalLiquido;
    var comb=$('fdCombinar'); if(comb) comb.onchange=_fdModalLiquido;

    var form=$('fdForm');
    if(form) form.onsubmit=function(e){
      e.preventDefault();
      var ehAval=(_fdModal==='avaliacao');
      var base=_fdEdit || { id:_fdId(), created_at:_fdAgora() };
      var x={
        id:base.id, created_at:base.created_at||_fdAgora(),
        tipo: ehAval ? 'avaliacao' : (function(){
          var p=el.querySelector('#fdChipsTipo button[aria-pressed="true"]');
          return p?p.getAttribute('data-fd-tipo'):'repasse';
        })(),
        data: ($('fdData')&&$('fdData').value) || _fdHoje(),
        quem: _fdTxt($('fdQuem')&&$('fdQuem').value),
        obs:  _fdTxt($('fdObs')&&$('fdObs').value),
        lojista_id: base.lojista_id||null,
        inspecao_id: base.inspecao_id||null
      };

      if(ehAval){
        var q=Math.round(_fdNum($('fdQtd')&&$('fdQtd').value));
        if(!(q>0)){ if($('fdQtd')) $('fdQtd').focus(); return; }
        x.qtd=q; x.comissao=0; x.pct=100; x.a_definir=false;
        x.status='pago'; x.valor=null; x.descricao=null; x.parceiro=null;
      }else{
        var aDef=!!($('fdCombinar')&&$('fdCombinar').checked);
        var comissao=aDef?0:_fdNum($('fdCom')&&$('fdCom').value);
        if(!aDef && !(comissao>0)){ if($('fdCom')) $('fdCom').focus(); return; }
        var pressed=el.querySelector('#fdChipsDiv button[aria-pressed="true"]');
        var modo=pressed?pressed.getAttribute('data-fd-div'):'100';
        var p=100;
        if(modo!=='100'){ p=_fdNum($('fdPct')&&$('fdPct').value); if(!(p>0&&p<=100)) p=50; }
        var st=el.querySelector('#fdChipsSt button[aria-pressed="true"]');
        x.descricao=_fdTxt($('fdDesc')&&$('fdDesc').value);
        x.valor=_fdNum($('fdValor')&&$('fdValor').value)||null;
        x.comissao=comissao;
        x.a_definir=aDef;
        x.pct=p;
        x.parceiro=(p===100)?'':_fdTxt($('fdParceiro')&&$('fdParceiro').value);
        x.status=st?st.getAttribute('data-fd-st2'):'aberto';
        x.qtd=1;
      }

      x._pend=true;
      _fdGravaLocal(x);
      /* o mês da tela segue o lançamento: salvar em outro mês e não ver a
         linha aparecer parece que não salvou */
      _fdMes=String(x.data).slice(0,7);
      _fdModal=null; _fdEdit=null;
      _fdPinta(el);
      _fdSincronizar(true);
    };
  }

  /* ============================================================ a porta da aba */
  async function _fdAbrir(el){
    _fdCss();
    _fdLer();
    if(!_fdMes) _fdMes=_fdMesAtual();
    _fdPinta(el);                  /* o aparelho pinta NA HORA, sem esperar rede */
    await _fdSincronizar(true);    /* e o resto acontece por trás */
    await _fdPuxar();
    if(document.getElementById('pnBody')===el) _fdPinta(el);
  }

  /* registra a aba pessoal no painel (o despacho mora no 18e, desde a v810) */
  try{ _pnRegistraPessoal('fecho','Fecho do Dia', function(el){ _fdAbrir(el); }); }
  catch(_){ }

/* ╔═══ src/app/18v-tools-aparencia.js ════════════════════════════════════ */
/* Presentation only: original controllers, permissions and saves remain unchanged. */
var mevToolsAparenciaPronta=Promise.resolve(true);
(function(){
 'use strict';
 if(location.pathname!=='/tools-app'||window.parent===window)return;
 var q=new URLSearchParams(location.search),pages={estoque:'loja',mercado:'loja',catalogo:'loja',avaliacoes:'avalia',clientes:'leads',posvendas:'leads'},page=q.get('toolsPage');
 if(!Object.prototype.hasOwnProperty.call(pages,page)||q.get('app')!==pages[page])return;
 var nonce='',mode=q.get('toolsTheme')==='light'?'light':'dark';
 function apply(value){mode=value;syncCatalogo();document.body.dataset.toolsTheme=mode;temaConsultasPintar(mode==='dark'?'escuro':'claro');}
 function syncCatalogo(){document.querySelectorAll('#mevPublicoViewer iframe').forEach(function(fr){try{if(fr.contentDocument)fr.contentDocument.documentElement.dataset.toolsTheme=mode;}catch(_){}});}
 function catalogo(fr){if(fr.dataset.toolsCatalogo)return;fr.dataset.toolsCatalogo='1';function paint(){try{var d=fr.contentDocument;if(!d||!d.querySelector('#grade, #carros'))return;d.documentElement.dataset.toolsTheme=mode;if(!d.getElementById('tools-catalogo-css')){var link=d.createElement('link');link.id='tools-catalogo-css';link.rel='stylesheet';link.href='/mev-tools-catalogo.css?v=1521';d.head.appendChild(link);}}catch(_){}}fr.addEventListener('load',paint);paint();}
 function watchCatalogo(){document.querySelectorAll('#mevPublicoViewer iframe').forEach(catalogo);}
 function start(){new MutationObserver(watchCatalogo).observe(document.body,{childList:true,subtree:true});watchCatalogo();document.body.classList.add('mev-tools-embedded');var css=document.createElement('link');css.rel='stylesheet';css.href='/mev-tools-embedded.css?v=1539';mevToolsAparenciaPronta=new Promise(function(resolve){css.onload=function(){resolve(true);};css.onerror=function(){resolve(false);};});document.head.append(css);apply(mode);}
 window.addEventListener('message',function(e){
  if(e.origin!=='https://mevtools.netlify.app'||e.source!==window.parent||!e.data)return;
  var d=e.data;if(d.type==='mev-tools-consultas-init'&&typeof d.nonce==='string'&&d.nonce.length<=100){nonce=d.nonce;return;}
  if(!nonce||d.nonce!==nonce)return;
  if(d.type==='mev-tools-appearance'&&(d.theme==='dark'||d.theme==='light'))apply(d.theme);
  if(d.type==='mev-tools-navigate'&&d.action==='back'){var back=document.getElementById('btnVoltar');if(back&&typeof back.onclick==='function')back.click();}
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* ╔═══ src/app/18w-tools-paginas.js ══════════════════════════════════════ */
/* Direct entry goes through the canonical menu gate, without painting Home first. */
var mevToolsPaginaAbrir=null;
(function(){
 'use strict';
 if(location.pathname!=='/tools-app'||!/[?&]tools=1(?:&|$)/.test(location.search))return;
 var q=new URLSearchParams(location.search),page=q.get('toolsPage');
 var pages={estoque:'loja',mercado:'loja',catalogo:'loja',avaliacoes:'avalia',clientes:'leads',posvendas:'leads'};
 if(!Object.prototype.hasOwnProperty.call(pages,page)||q.get('app')!==pages[page])return;
 var done=false,ready=false,failed=false,nonce='';
 function notify(){if(!nonce||window.parent===window)return;window.parent.postMessage({type:failed?'mev-tools-page-error':'mev-tools-page-ready',page:page,nonce:nonce},'https://mevtools.netlify.app');}
 window.addEventListener('message',function(e){if(e.origin!=='https://mevtools.netlify.app'||e.source!==window.parent||!e.data||e.data.type!=='mev-tools-consultas-init'||typeof e.data.nonce!=='string'||e.data.nonce.length>100)return;nonce=e.data.nonce;if(ready||failed)notify();});
 document.addEventListener('mev-mercado-shell-ready',async function(){
  if(page!=='mercado'||!done||!document.getElementById('mkdTabs')||!document.getElementById('mkdQ'))return;
  if(typeof mevToolsAparenciaPronta!=='undefined'&&!await mevToolsAparenciaPronta){failed=true;notify();return;}
  ready=true;notify();
 });
 mevToolsPaginaAbrir=async function(){
  if(done||!meuId||!document.body.classList.contains('app-on'))return;
  done=true;
  try{await drawerIr(page);if(typeof mevToolsAparenciaPronta!=='undefined'&&!await mevToolsAparenciaPronta)throw Error('appearance');ready=true;notify();}catch(_){failed=true;notify();}
 };
})();

/* ╔═══ src/app/18x-tools-estoque.js ══════════════════════════════════════ */
/* Explicit links from MEV Tools. Opens existing UI only; never imports or saves automatically. */
(function(){
 'use strict';
 var q;try{q=new URLSearchParams(location.search);}catch(_){return;}
 var action=q.get('stockAction'),id=q.get('stockId')||'';
 var allowed=['lista','novo','novoFotos','importar','importarPrint','cadastro','fotos','precos','marketing','ficha','acao','mercado','mercadoLojas'];
 if(allowed.indexOf(action)<0)return;
 var needsId=['cadastro','fotos','precos','marketing','ficha','acao'].indexOf(action)>=0;
 if(needsId&&!/^[a-f0-9-]{36}$/i.test(id))return;
 var menuAction=q.get('stockMenuAction')||'',menuLabels={venda:'Iniciar venda',aval:'Editar na avaliação',catalogo:'Ver no catálogo',post:'Copiar post',fotos:'Baixar fotos',fipe:'Atualizar FIPE',reservado:'Marcar reservado',vendido:'Marcar vendido',disponivel:'Marcar disponível',excluir:'Excluir'};if(action==='acao'&&!Object.prototype.hasOwnProperty.call(menuLabels,menuAction))return;
 var started=false,timer;
 async function run(){
  if(started||!document.body.classList.contains('app-on')||!meuId)return;
  started=true;if(observer)observer.disconnect();
  if(typeof edicaoPermite==='function'&&!edicaoPermite('estoque')){toast('Abra o MEV Veículos para acessar o estoque.');return;}
  try{
   if(action==='mercado'||action==='mercadoLojas'){await telaMercado();if(action==='mercadoLojas'){_mkdAba='sites';mkdTabAplica(true);}}else await telaEstoque();
   if(action==='novo'||action==='novoFotos'){estAbrirFicha(null);if(action==='novoFotos'&&$('efTabs')){_estFichaTab='fotos';estFichaTabAplica();}}
   else if(action==='importar')estImportModalAbrir();
   else if(action==='importarPrint')estImportarPrint();
   else if(needsId){
    var row=(_estoque||[]).find(function(v){return String(v.id)===id;});
    if(!row){toast('Veículo não encontrado ou sem acesso nesta conta.');return;}
    if(action==='acao'){_popAbrir('<div class="act-head"><div class="ah-nm">'+esc(estNomeComercial(row))+'</div><div class="ah-pl">Confirme a ação escolhida no MEV Tools</div></div>',[[menuAction,ICO_EST,menuLabels[menuAction],menuAction==='excluir'?'danger':'']],$('estAddCta'),function(k){estAcaoExec(id,k);});}else{estAbrirFicha(id);_estFichaTab=action==='precos'?'cadastro':(['fotos','marketing','ficha'].indexOf(action)>=0?action:'cadastro');estFichaTabAplica();if(action==='precos'&&$('efAnuncio'))$('efAnuncio').focus();}
   }
   var clean=new URL(location.href);clean.searchParams.delete('stockAction');clean.searchParams.delete('stockId');clean.searchParams.delete('stockMenuAction');history.replaceState(null,'',clean.pathname+clean.search+clean.hash);
  }catch(_){toast('Não foi possível abrir esta função. Use Adicionar veículo ou abra o cadastro no estoque.');}
 }
 var observer=new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(run,200);});
 function start(){observer.observe(document.body,{attributes:true,attributeFilter:['class']});timer=setTimeout(run,200);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* ╔═══ src/app/18y-tools-retorno.js ══════════════════════════════════════ */
/* Retorno explícito para o Tools, inclusive quando Consultas abre em outra aba. */
(function(){
 'use strict';
 if(!/[?&]tools=1(?:&|$)/.test(location.search))return;
 var destino='https://mevtools.netlify.app/';
 var icon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3 10 9-7 9 7v11h-6v-7H9v7H3Z"/></svg>';
 function add(){
  document.body.classList.add('mev-tools-context');
  var auth=document.getElementById('scAuth');if(auth&&!auth.querySelector('.mev-tools-auth-return')){var back=document.createElement('a');back.href=destino;back.target='_top';back.className='mev-tools-menu-return mev-tools-auth-return';back.innerHTML=icon+'<span>Voltar ao MEV Tools</span>';auth.prepend(back);}
  var toolbar=document.querySelector('#mevConsultasNav .tb-in');
  if(toolbar&&!toolbar.querySelector('.mev-tools-return')){var a=document.createElement('a');a.className='tb-ib mev-tools-return';a.href=destino;a.target='_top';a.setAttribute('aria-label','Voltar ao MEV Tools');a.title='Voltar ao MEV Tools';a.innerHTML=icon+'<span>Tools</span>';var menu=toolbar.querySelector('.tb-nav-menu');toolbar.insertBefore(a,menu);}
  var nav=document.querySelector('#mevDrawer .mdr-nav');
  if(nav&&!nav.querySelector('.mev-tools-menu-return')){var link=document.createElement('a');link.href=destino;link.target='_top';link.className='mev-tools-menu-return';link.innerHTML=icon+'<span>Voltar ao MEV Tools</span>';nav.prepend(link);}
 }
 var timer;function schedule(){if(timer)return;timer=setTimeout(function(){timer=0;add();},50);}
 function start(){schedule();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* ╔═══ src/app/18z-tools-consultas.js ════════════════════════════════════ */
/* MEV Tools: a tela original fornece só o veículo escolhido, após ação explícita.
   Apenas o código de acesso de uso único atravessa a ponte de autenticação. */
(function(){
  'use strict';
  if(!/[?&]tools=1(?:&|$)/.test(location.search)||window.parent===window)return;
  var origemTools='https://mevtools.netlify.app',ativo=false,nonceTools='',autenticando=false,authConcluido=false;
  var checagemSessao=null;
  function sessaoExistente(){
    if(checagemSessao)return checagemSessao;
    checagemSessao=(async function(){var timer;try{
      var result=await Promise.race([supa.auth.getSession(),new Promise(function(_,reject){timer=setTimeout(function(){reject(Error('tempo'));},8000);})]);
      var session=result&&result.data&&result.data.session;if(result.error||!session||!session.access_token||!session.user||!session.user.id)return false;
      if(session.expires_at&&session.expires_at*1000<=Date.now())return false;
      _aplicaSessao(session);
      if(!document.body.classList.contains('app-on'))Promise.resolve(entrar()).catch(function(){});
      authConcluido=true;return true;
    }catch(_){return false;}finally{clearTimeout(timer);}})();return checagemSessao;
  }
  function enviar(type,veiculo){window.parent.postMessage({type:type,veiculo:veiculo},origemTools);}
  function numero(v){if(typeof v==='number')return Number.isFinite(v)&&v>0?v:0;return Number(String(v||'').replace(/R\$|\s|\./g,'').replace(',','.'))||0;}
  function selecionado(){
    var v=veiculoAtual;if(!v)return null;
    var placa=String(v.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');if(!/^[A-Z]{3}\d[A-Z0-9]\d{2}$/.test(placa))return null;
    var aval=0;
    // Valor da loja salvo pelo avaliador, nunca o preço sugerido ou a FIPE.
    try{var r=JSON.parse(localStorage.getItem('mev_aval:'+placa)||'null');if(r)aval=numero(r.avValor);}catch(_){}
    return {placa:placa,modelo:[v.marca,v.modelo].filter(Boolean).join(' '),ano:String(v.ano||v.ano_modelo||''),cor:String(v.cor||''),combustivel:String(v.combustivel||''),fipe:numero(v.fipe),avaliacao:aval};
  }
  function pintar(){
    if(!ativo)return;
    var resultado=document.querySelector('.consulta-resultado[data-resultado-chave="placa"]');
    if(!resultado||!selecionado()||resultado.querySelector('[data-tools-cotacao]'))return;
    var b=document.createElement('button');b.type='button';b.className='consulta-resultado-acao is-primary';b.dataset.toolsCotacao='1';b.style.minHeight='44px';
    b.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>Usar na cotação</span>';
    b.onclick=function(){
      var v=selecionado();if(!v||b.disabled)return;
      b.disabled=true;b.querySelector('span').textContent='Preparando cotação…';
      var terminou=false;
      function concluir(r){if(terminou)return;terminou=true;clearTimeout(timer);
        if(r&&r.avValor!=null)v.avaliacao=numero(r.avValor);
        enviar('mev-consultas-usar-cotacao',v);
        b.disabled=false;b.querySelector('span').textContent='Usar na cotação';
      }
      var timer=setTimeout(function(){concluir(null);},6000);
      // Reutiliza o leitor autenticado existente, restrito à conta atual.
      if(typeof docHistCloudLoadOne==='function')docHistCloudLoadOne('aval_rascunho',v.placa,concluir);else concluir(null);
    };
    var a=resultado.querySelector('.consulta-resultado-acoes');(a||resultado).appendChild(b);
  }
  window.addEventListener('message',async function(e){
    if(e.origin!==origemTools||e.source!==window.parent||!e.data)return;
    if(e.data.type==='mev-tools-consultas-init'){
      nonceTools=typeof e.data.nonce==='string'?e.data.nonce:'';
      ativo=true;var authenticated=await sessaoExistente();window.parent.postMessage({type:'mev-consultas-ready',authSupported:true,authenticated:authenticated,nonce:nonceTools},origemTools);pintar();return;
    }
    if(e.data.type!=='mev-tools-auth'||!ativo||autenticando||authConcluido||!nonceTools||e.data.nonce!==nonceTools)return;
    var d=e.data;
    if(typeof d.token_hash!=='string'||d.token_hash.length>256||typeof d.user_id!=='string'||typeof d.expires_at!=='number'||d.expires_at<Date.now()||d.expires_at>Date.now()+60000)return;
    autenticando=true;
    try{
      if(await sessaoExistente()){window.parent.postMessage({type:'mev-consultas-auth-ok',nonce:nonceTools},origemTools);return;}
      var result=await supa.auth.verifyOtp({token_hash:d.token_hash,type:'email'});
      if(result.error||!result.data.session)throw Error('acesso');
      if(!result.data.user||result.data.user.id!==d.user_id){await supa.auth.signOut({scope:'local'});throw Error('conta');}
      authConcluido=true;
      _aplicaSessao(result.data.session);
      await entrar();
      window.parent.postMessage({type:'mev-consultas-auth-ok',nonce:nonceTools},origemTools);
    }catch(_){window.parent.postMessage({type:'mev-consultas-auth-error',nonce:nonceTools},origemTools);}
    finally{autenticando=false;}
  });
  function observar(){new MutationObserver(pintar).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observar);else observar();
})();

/* ╔═══ src/app/20-mercado.js ═════════════════════════════════════════════ */
  /* ==========================================================================
     🏁 v659 — O MERCADO DA REGIÃO
     --------------------------------------------------------------------------
     "diga o que o cliente quer; o app procura em todas as lojas."

     O TRABALHO QUE ISTO MATA É REAL: pra achar um carro pro cliente hoje você
     abre oito abas, filtra em oito telas diferentes, anota num papel e ainda
     esquece uma loja. Meia hora de garimpo, toda vez, sem garantia de ter
     visto tudo.

     COMO FUNCIONA, e é só isto:
        1. você cadastra as lojas (o endereço do site, nada mais)
        2. aperta "Atualizar" numa loja → o app lê o estoque dela e guarda
        3. escreve o que o cliente quer → ele procura no que guardou

     🔴 O QUE ELE **NÃO** É:
      · não é vitrine — é tela sua, pesquisa de mercado, a mesma coisa que
        você faz com oito abas abertas, só que sem perder meia hora;
      · não republica foto de ninguém: o índice guarda o LINK da foto;
      · não promete "tempo real" — promete "visto em <data>", que é verdade;
      · não dispara consulta paga sozinha (regra v585): nada aqui custa token;
      · não varre sozinho de madrugada. Quem aperta o botão é você.

     🔑 E NOME DE LOJA NÃO MORA NO CÓDIGO. As lojas ficam numa tabela sua, com
     um interruptor por loja — é o que deixa acrescentar a nona sem tocar em
     código e tirar uma do ar no mesmo dia em que alguém pedir.
     ========================================================================== */
  var _mkdLojas=null, _mkdVeics=[], _mkdFiltro=null, _mkdSemTabela=false, _mkdBusy=false;
  var _mkdUrlsAtivas={}, _mkdIndiceCompleto=false;
  /* v974 — O anúncio que já foi trazido não pode oferecer uma segunda entrada.
     A identidade mais segura disponível nesta tela é o endereço de origem que
     o importador guarda em `extras.importacao_anuncio.url`. Modelo, ano e preço
     podem se repetir; por isso eles nunca são usados para declarar igualdade.

     A chave preserva parâmetros próprios da ficha, mas descarta rastreadores
     publicitários e o fragmento. Assim, o mesmo anúncio não deixa de ser
     reconhecido só porque voltou com `utm_source` ou `fbclid`. */
  function mkdUrlEstoqueChave(raw){
    var s=String(raw||'').trim(); if(!s) return '';
    try{
      var u=new URL(s, window.location.href), apagar=[];
      u.hash='';
      u.searchParams.forEach(function(_,k){
        if(/^utm_/i.test(k)||/^(fbclid|gclid|dclid|msclkid)$/i.test(k)) apagar.push(k);
      });
      apagar.forEach(function(k){ u.searchParams.delete(k); });
      try{ u.searchParams.sort(); }catch(_){ }
      var p=u.pathname.replace(/\/+$/,'')||'/';
      return u.protocol.toLowerCase()+'//'+u.host.toLowerCase()+p+(u.search||'');
    }catch(_){ return s.replace(/#.*$/,'').replace(/\/+$/,''); }
  }
  function mkdEstoqueDeMercado(v){
    var alvo=mkdUrlEstoqueChave(v&&v.url); if(!alvo) return null;
    var estoque=(typeof _estoque!=='undefined'&&Array.isArray(_estoque))?_estoque:[];
    for(var i=0;i<estoque.length;i++){
      var ex=estoque[i]&&estoque[i].extras;
      if(typeof ex==='string'){ try{ ex=JSON.parse(ex); }catch(_){ ex=null; } }
      var origem=ex&&ex.importacao_anuncio&&ex.importacao_anuncio.url;
      if(origem&&mkdUrlEstoqueChave(origem)===alvo) return estoque[i];
    }
    return null;
  }
  function mkdHost(raw){
    try{ return new URL(String(raw||''),window.location.href).hostname.toLowerCase().replace(/^www\./,''); }
    catch(_){ return ''; }
  }
  /* v975 — a análise inversa só trabalha com uma fotografia COMPLETA do
     índice ativo. Cada página tem ordem estável por id e o intervalo do
     Supabase é inclusivo; qualquer falha deixa `_mkdIndiceCompleto=false` e
     suprime as sugestões, porque ausência parcial não prova retirada. */
  async function mkdUrlsAtivasCarregar(){
    var mapa={}, inicio=0, lote=1000, paginas=0;
    _mkdIndiceCompleto=false; _mkdUrlsAtivas={};
    try{
      while(paginas<50){
        var r=await supa.from('mp_mercado_veiculos').select('id,url')
          .is('saiu_em',null).order('id',{ascending:true}).range(inicio,inicio+lote-1);
        if(r&&r.error) throw r.error;
        var linhas=(r&&r.data)||[];
        linhas.forEach(function(v){ var k=mkdUrlEstoqueChave(v&&v.url); if(k) mapa[k]=1; });
        paginas++;
        if(linhas.length<lote){ _mkdIndiceCompleto=true; break; }
        inicio+=lote;
      }
      if(!_mkdIndiceCompleto) throw new Error('índice acima do limite seguro');
      _mkdUrlsAtivas=mapa;
    }catch(_){ _mkdUrlsAtivas={}; _mkdIndiceCompleto=false; }
  }
  function mkdEstoqueParaRevisar(){
    if(!_mkdIndiceCompleto) return [];
    /* Só uma loja lida com sucesso pode provar que o anúncio saiu. Cadastro
       manual, site ainda não lido e loja com erro ficam fora da sugestão. */
    var hostsOk={};
    (_mkdLojas||[]).forEach(function(l){
      var h=mkdHost(l&&l.site);
      if(h&&l.visto_em&&!l.ultimo_erro) hostsOk[h]=1;
    });
    var estoque=(typeof _estoque!=='undefined'&&Array.isArray(_estoque))?_estoque:[];
    return estoque.filter(function(v){
      if(String(v&&v.status||'')==='vendido') return false;
      var ex=v&&v.extras;
      if(typeof ex==='string'){ try{ ex=JSON.parse(ex); }catch(_){ ex=null; } }
      var url=ex&&ex.importacao_anuncio&&ex.importacao_anuncio.url;
      var chave=mkdUrlEstoqueChave(url);
      return !!(chave&&hostsOk[mkdHost(url)]&&!_mkdUrlsAtivas[chave]);
    });
  }
  function mkdRevisarPinta(){
    var el=$('mkdRevisar'); if(!el) return;
    var lista=mkdEstoqueParaRevisar();
    if(!lista.length){ el.innerHTML=''; return; }
    el.innerHTML='<section class="mkd-revisar" aria-labelledby="mkdRevisarTitulo">'+
      '<div class="mkd-revisar-head"><div><b id="mkdRevisarTitulo">Revisar estoque</b>'+
      '<span>'+lista.length+' veículo(s) para conferir</span></div></div>'+
      '<p>Estes veículos vieram de lojas acompanhadas, mas o anúncio não aparece mais em nenhuma delas. Confira antes de excluir.</p>'+
      '<div class="mkd-revisar-lista">'+lista.map(function(v){
        var nome=((v.marca||'')+' '+(v.modelo||'')).trim()||'Veículo';
        return '<div class="mkd-revisar-item"><div><b>'+esc(nome)+'</b>'+
          (v.placa?'<span>'+esc(v.placa)+'</span>':'')+
          '<small>Sugestão de exclusão</small></div>'+
          '<button type="button" data-mkd-revisar="'+esc(String(v.id))+'">Revisar</button></div>';
      }).join('')+'</div></section>';
    Array.prototype.forEach.call(el.querySelectorAll('[data-mkd-revisar]'),function(bt){
      bt.onclick=function(){ var id=bt.getAttribute('data-mkd-revisar'); if(id&&typeof estAbrirFicha==='function') estAbrirFicha(id); };
    });
  }
  /* v662 — o que os botõezinhos escolheram. Fica FORA da frase de propósito:
     a frase é do cliente ("um SUV automatico ate 120"), os botões são seus. */
  /* ==========================================================================
     \U0001f534 v663 (pedido do Angelo, 26/08) — "ja deixa o filtro só com foto
     real ativo"
     --------------------------------------------------------------------------
     Na v662 este filtro nascia DESLIGADO, e eu escrevi o porquê: esconder
     carro por conta própria é decidir pela pessoa. O Angelo usou e disse o que
     quer. Quem manda no padrão é quem usa a tela todo dia — não a minha regra.

     \U0001f511 MAS O PRINCÍPIO NÃO FOI JOGADO FORA, SÓ MUDOU DE FORMA: o filtro
     liga sozinho E A TELA DIZ, em cima da lista, quantos carros ficaram
     escondidos por causa dele — com um botão que mostra todos num toque. Nada
     some calado. O que mudou foi qual dos dois lados começa ligado.
     ========================================================================== */
  /* ==========================================================================
     \u26f3 v670 (pedido do Angelo) — "remove o filtro, só com foto real"
     --------------------------------------------------------------------------
     Ele mandou o print com o filtro LIGADO e dois carros da Comauto na lista,
     os dois com o desenho de "Veículo em preparação". O filtro estava aceso e
     não estava filtrando.

     \U0001f534 POR QUE OS DOIS SINAIS FALHARAM NAQUELA PLATAFORMA:
       · o do NOME não achou nada — o endereço da imagem não diz "preparacao",
         "sem-foto" nem nenhuma das palavras que eu conhecia;
       · o da REPETIÇÃO não achou nada — a plataforma entrega um endereço
         DIFERENTE pra cada carro, mesmo sendo o mesmo desenho. Foto de verdade
         é única, mas o contrário não vale: endereço único não prova foto real.

     ⛳ E EU NÃO VOU CHUTAR UM TERCEIRO SINAL. Um filtro que às vezes esconde
     carro de verdade e às vezes deixa passar o desenho é pior que filtro
     nenhum: ele dá uma confiança que não existe. O botão sai.

     ⚠️ O CÓDIGO FICA, DESLIGADO E MOSTRANDO O CAMINHO (regra v568). Os dois
     sinais continuam vivos e continuam marcando o card com "foto ilustrativa"
     onde ACERTAM — informação sem promessa. No dia em que existir um sinal que
     valha pra qualquer plataforma (comparar as imagens em si, por exemplo),
     o botão volta com uma linha.
     ========================================================================== */
  var MKD_CHIPS_PADRAO={ cambio:'', carroceria:'', tipo:'', marca:'', foto:'real', loja:'', estoque:'', precoMin:'', precoMax:'' };   /* v1158: + faixa de preço */
  var _mkdChips=JSON.parse(JSON.stringify(MKD_CHIPS_PADRAO)), _mkdMarcas=[];
  /* ==========================================================================
     \U0001f534 v663 (pedido do Angelo) — "adicione um botao de ordenar, preco, km,
     adicionados recentemente"
     --------------------------------------------------------------------------
     \U0001f511 A ORDEM É FEITA AQUI, NA TELA, E NÃO NO BANCO. O banco já devolve
     por preço, mas entre o banco e a tela passam cinco filtros (câmbio,
     carroceria, marca, foto, texto) — e ordenar antes de filtrar é ordenar a
     lista errada. Ordenando no fim, a ordem vale sempre pro que está à vista.

     \u26a0\ufe0f CARRO SEM O DADO VAI PRO FIM, NUNCA PRO COMEÇO. Um carro sem preço
     tratado como "preço zero" lidera a lista de "menor preço" e empurra pra
     baixo o carro barato de verdade. Sem dado não é o menor de todos — é
     desconhecido, e desconhecido espera no fim da fila.
     ========================================================================== */
  var MKD_ORDENS=[
    ['preco_asc','Menor preço'], ['preco_desc','Maior preço'],
    ['km_asc','Menor km'],       ['novos','Mais recentes']
  ];
  var _mkdOrdem='preco_asc';
  function mkdOrdenar(lista, ordem){
    var l=(lista||[]).slice();
    function n(x){ var v=Number(x); return (isFinite(v)&&v>0)?v:null; }
    function cmp(a,b,campo,cresc){
      var va=n(a[campo]), vb=n(b[campo]);
      if(va==null && vb==null) return 0;
      if(va==null) return 1;          /* sem dado: fim da fila */
      if(vb==null) return -1;
      return cresc?(va-vb):(vb-va);
    }
    if(ordem==='preco_desc') l.sort(function(a,b){ return cmp(a,b,'preco',false); });
    else if(ordem==='km_asc') l.sort(function(a,b){ return cmp(a,b,'km',true); });
    else if(ordem==='novos') l.sort(function(a,b){
      var ta=Date.parse(a.entrou_em||a.visto_em||'')||0;
      var tb=Date.parse(b.entrou_em||b.visto_em||'')||0;
      if(ta===tb) return cmp(a,b,'preco',true);
      return tb-ta;
    });
    else l.sort(function(a,b){ return cmp(a,b,'preco',true); });
    return l;
  }
  var _mkdFotoRepetida={};   /* v662 — fotos que aparecem em mais de um carro */

  var ICO_MERCADO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9"/><circle cx="11" cy="14" r="3"/><path d="M16 19l-2.2-2.2"/></svg>';

  /* ==========================================================================
     🔴 v869 — AS DUAS ABAS DO MERCADO (pedido do Angelo, 03/09)
     --------------------------------------------------------------------------
     "na pagina de mercado crie uma aba na pagina pra lancar os sites e loja
      que atualiza"

     O QUE ESTAVA ERRADO: o cadastro das lojas era uma caixinha no PÉ da
     página, DEPOIS dos resultados da busca. Com dez carros na tela ela já
     ficava abaixo da dobra; com cinquenta, ninguém achava. E é justamente
     ali que se cadastra o site novo e se vê qual loja falhou — a parte que
     mantém a página inteira funcionando estava escondida atrás do resultado
     que ela mesma alimenta.

     AGORA SÃO DUAS ABAS, no mesmo padrão `.vpx` da Minha loja e da Minha
     conta (tablist de verdade, setas do teclado, aria-selected, painel com
     aria-labelledby):
        Procurar ....... a busca e os resultados. Abre primeiro, porque é o
                         uso de todo dia.
        Sites e lojas .. cadastrar site, ligar/pausar, ver quando cada um foi
                         lido e atualizar.

     ⚠️ NADA FOI APAGADO. Os mesmos `#mkdAviso`, `#mkdLojas`, `#mkdRes`,
     `#mkdBandeja` e `#mkdChips` continuam existindo com os mesmos ids — só
     mudaram de lugar. É por isso que `mkdCarregar()` continua funcionando
     sem saber que existem abas: ele pinta dentro dos ids, não da página.
     ========================================================================== */
  var MKD_ABAS={
    procurar:['Buscar veículos','Encontre veículos nas lojas acompanhadas.'],
    sites:['Lojas acompanhadas','Gerencie os sites e atualize os estoques das lojas.']
  };
  var MKD_ABA_ICO={
    procurar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    sites:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="3" y1="12" x2="21" y2="12"/><path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18z"/></svg>'
  };
  var _mkdAba='procurar';
  function mkdTabHtml(k){
    var a=MKD_ABAS[k]||[k,''];
    return '<button type="button" class="vpx-st" role="tab" id="mkdTab-'+k+'" aria-controls="mkdPanel-'+k+'"'
      +' aria-selected="false" tabindex="-1" data-step="'+k+'">'
      +'<span class="vpx-ico" aria-hidden="true">'+MKD_ABA_ICO[k]+'</span>'
      +'<span class="vpx-nm">'+esc(a[0])+'</span>'
      +(k==='sites'?'<span class="mkd-tab-n" id="mkdTabN" hidden></span>':'')
      +'</button>';
  }
  function mkdPainelAbre(k){
    var a=MKD_ABAS[k]||[k,''];
    return '<div class="vpx-panel" data-panel="'+k+'" id="mkdPanel-'+k+'" role="tabpanel" aria-labelledby="mkdTab-'+k+'" hidden>'
      +'<div class="cad-area-head"><div class="cad-area-tx"><h3 class="cad-area-t">'+esc(a[0])+'</h3>'
      +'<p class="cad-area-d">'+esc(a[1])+'</p></div></div>';
  }
  function mkdTabAplica(anunciar){
    Array.prototype.forEach.call(document.querySelectorAll('#mkdBody .vpx-panel'),function(pn){
      var on=pn.getAttribute('data-panel')===_mkdAba;
      pn.classList.toggle('on', on);
      if(on) pn.removeAttribute('hidden'); else pn.setAttribute('hidden','');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#mkdTabs .vpx-st'),function(b){
      var on=b.getAttribute('data-step')===_mkdAba;
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on?'true':'false');
      b.setAttribute('tabindex', on?'0':'-1');
      if(on){ try{ _tabCentra(b.parentNode, b); }catch(_){ } }
    });
    if(anunciar){ try{ var lv=$('mkdTabLive'), a=MKD_ABAS[_mkdAba];
      if(lv&&a){ lv.textContent=''; setTimeout(function(){ lv.textContent=a[0]; },30); } }catch(_){ } }
  }
  function mkdAbaIr(k, foco){
    if(!MKD_ABAS[k]) return;
    _mkdAba=k; mkdTabAplica(true);
    if(foco){ try{ var b=document.querySelector('#mkdTabs .vpx-st[data-step="'+k+'"]'); if(b) b.focus(); }catch(_){ } }
  }
  /* setas, Home e End — a mesma navegação de teclado das outras abas da casa */
  function mkdTabsTeclado(e){
    var keys=['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'];
    if(keys.indexOf(e.key)<0) return;
    var bts=Array.prototype.slice.call(document.querySelectorAll('#mkdTabs .vpx-st'));
    if(!bts.length) return;
    var i=bts.indexOf(document.activeElement);
    if(i<0) i=bts.map(function(b){ return b.classList.contains('on'); }).indexOf(true);
    if(i<0) i=0;
    var n=bts.length, j=i;
    if(e.key==='ArrowRight'||e.key==='ArrowDown') j=(i+1)%n;
    else if(e.key==='ArrowLeft'||e.key==='ArrowUp') j=(i-1+n)%n;
    else if(e.key==='Home') j=0; else if(e.key==='End') j=n-1;
    e.preventDefault(); mkdAbaIr(bts[j].getAttribute('data-step'), true);
  }
  function mkdTabsLigar(){
    Array.prototype.forEach.call(document.querySelectorAll('#mkdTabs .vpx-st'),function(b){
      b.onclick=function(){ mkdAbaIr(b.getAttribute('data-step'), false); };
    });
    var tl=$('mkdTabs'); if(tl) tl.addEventListener('keydown', mkdTabsTeclado);
  }
  /* o contador na aba: quantas lojas ligadas de quantas cadastradas */
  function mkdTabNPinta(){
    var e=$('mkdTabN'); if(!e) return;
    var todas=(_mkdLojas||[]).length;
    if(_mkdSemTabela||!todas){ e.hidden=true; e.textContent=''; return; }
    var on=(_mkdLojas||[]).filter(function(l){ return l.ativo; }).length;
    e.hidden=false;
    e.textContent=(on===todas)?String(todas):(on+'/'+todas);
  }

  function mkdNomeExibicao(v){
    var parts=[v.marca,v.modelo,v.versao].filter(Boolean),out='';
    parts.forEach(function(part){part=String(part).trim();if(!part)return;if(out.toLowerCase().indexOf(part.toLowerCase())>=0)return;var words=part.split(/\s+/),existing=out.split(/\s+/);for(var n=Math.min(existing.length,words.length);n>0;n--){if(existing.slice(-n).join(' ').toLowerCase()===words.slice(0,n).join(' ').toLowerCase()){words=words.slice(n);break;}}out+=(out&&words.length?' ':'')+words.join(' ');});return out;
  }
  async function telaMercado(){
    mevTabSet('');
    /* v777 — o carimbo da última visita ao Mercado (bloco "Novo na rede" da
       home, 05j). Ver a lista zera a linha da home. */
    try{ redCarimboGravar('mercado'); }catch(_){ }
    var cab=panelHead(ICO_MERCADO,'blue','Seminovos',
      'Busque veículos nas lojas acompanhadas');
    irTela(cab+
      '<div class="mkd-wrap"><div class="vpx">'+
        '<div class="vpx-steps vpx-mdr" id="mkdTabs" role="tablist" aria-label="Seções do Mercado">'+
          mkdTabHtml('procurar')+mkdTabHtml('sites')+
        '</div>'+
        '<div class="vpx-body" id="mkdBody">'+
          '<div id="mkdTabLive" class="sr-only" aria-live="polite"></div>'+
          mkdPainelAbre('procurar')+
            '<div id="mkdAviso"></div>'+
            '<div class="card mkd-busca">'+
              '<label class="cad-lbl" for="mkdQ">O que o cliente procura?</label>'+
              '<div class="mkd-bar">'+
                '<input class="cad-in" id="mkdQ" placeholder="Ex.: SUV automático até R$ 120 mil" autocomplete="off">'+
                '<button type="button" class="cad-btn" id="mkdGo">Buscar veículos</button>'+
              '</div>'+
              '<div class="mkd-chips" id="mkdChips"></div>'+
              '<div class="mkd-lidos" id="mkdLidos"></div>'+
            '</div>'+
            '<div id="mkdBandeja" class="mkd-bandeja"></div>'+
            '<div id="mkdRevisar"></div>'+
            '<div id="mkdRes"></div>'+
          '</div>'+
          mkdPainelAbre('sites')+
            /* ⚠️ o andamento fica FORA do #mkdLojas de propósito: o
               `mkdLojasPinta()` regrava aquele bloco inteiro, e a linha de
               "loja 2 de 5" precisa sobreviver a isso. */
            '<div class="mkd-prog" id="mkdProg" role="status" aria-live="polite" hidden></div>'+
            '<div id="mkdLojas"></div>'+
          '</div>'+
        '</div>'+
      '</div></div>');
    /* 🔴 v795 — A MARCA VEM AQUI, DEPOIS DO irTela(), e não no começo da
       função: o irTela() e o mevTabSet() limpam as classes de página no meio
       do caminho (é o trabalho deles). Marcar antes era marcar e perder.
       Ver o changelog da v795. */
    document.body.classList.add('oper-on');
    /* 🔴 v870 (pedido do Angelo, 03/09): "remove, nao precisa na pagina do
       mercado".
       No computador, TODA tela interna mantém a coluna da esquerda com a
       caixa "Consulta placa" — é o layout `md-veiculo`, e no resultado de uma
       placa ele faz todo sentido (você consulta a próxima sem sair da tela).
       No MERCADO não faz: a página não fala de placa, tem duas abas próprias
       e uma lista larga, e aquela caixa só rouba 372 px do que interessa.
       ⚠️ A COLUNA NÃO FOI APAGADA DE LUGAR NENHUM. Esta classe é a única
       coisa que muda, e ela só existe enquanto o Mercado está aberto — sair
       da página a tira (`voltarHome` e `mevTabSet`), e todas as outras telas
       continuam com a coluna exatamente como estavam. */
    document.body.classList.add('mkd-on');
    try{ consultaUiDockMedir(); }catch(_){ }
    mkdTabAplica(false); mkdTabsLigar();
    var q=$('mkdQ'); if(q){ q.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); mkdProcurar(); } }); }
    var g=$('mkdGo'); if(g) g.onclick=mkdProcurar;
    document.dispatchEvent(new Event('mev-mercado-shell-ready'));
    /* v974 — sem a lista do estoque a tela não saberia trocar Trazer por Ver.
       Reaproveita a carga oficial do Estoque (com a mesma RLS da conta) e só
       busca quando a memória ainda está vazia. */
    try{
      if(typeof estCarregar==='function' &&
         !(typeof _estoque!=='undefined' && Array.isArray(_estoque) && _estoque.length)){
        Promise.resolve(estCarregar()).then(function(){if(document.body.classList.contains("mkd-on"))mkdRevisarPinta();}).catch(function(){});
      }
    }catch(_){ }
    await mkdCarregar();
  }

  /* ==========================================================================
     A CARGA — e o aviso que substitui a tela vazia
     --------------------------------------------------------------------------
     🔴 REGRA DA CASA (v568): desligar mostrando o caminho, nunca sumir. Se a
     tabela ainda não existe no banco, a página NÃO aparece vazia fingindo que
     não há carros: ela diz exatamente o que falta fazer.
     ========================================================================== */
  async function mkdCarregar(){
    _mkdReadCache=null;_mkdBuscaSeq++;
    _mkdSemTabela=false;
    try{
      var r=await supa.from('mp_mercado_lojas').select('*').order('nome',{ascending:true});
      if(r&&r.error) throw r.error;
      _mkdLojas=(r&&r.data)||[];
    }catch(e){
      /* tabela que não existe responde 404/42P01 — é o caso de "ainda não rodei o SQL" */
      _mkdSemTabela=true; _mkdLojas=[];
    }
    mkdBandejaLer();          /* v664 — o que ficou marcado da última vez */
    mkdAvisoPinta();
    mkdLojasPinta();
    mkdChipsPinta();          /* v662 — some sozinho quando a tabela não existe */
    mkdBandejaBarra();
    if(!_mkdSemTabela){
      await Promise.all([mkdUrlsAtivasCarregar(),mkdProcurar()]);
      mkdRevisarPinta();
    }else mkdRevisarPinta();
  }

  function mkdAvisoPinta(){
    var el=$('mkdAviso'); if(!el) return;
    if(_mkdSemTabela){
      el.innerHTML='<div class="cad-msg err" style="line-height:1.6">'+
        '<b>Falta uma coisa só, e é no banco.</b><br>'+
        'Abra o Supabase → SQL Editor, cole o arquivo <b>sql-v659-mercado-veiculos.sql</b> '+
        '(está na pasta do projeto) e rode. Ele cria as duas tabelas desta página — '+
        'as suas lojas e o índice dos carros. Depois é só voltar aqui.</div>';
      return;
    }
    if(!(_mkdLojas||[]).length){
      /* v869 — o cadastro saiu do pé desta página e virou aba. Um aviso que
         diz "aqui embaixo" quando não há mais nada embaixo é pior que aviso
         nenhum: ele manda a pessoa procurar o que não existe. Agora ele LEVA. */
      el.innerHTML='<div class="cad-msg" style="line-height:1.6">'+
        'Ainda não há nenhuma loja cadastrada. Vá em <b>Sites e lojas</b>, ponha o endereço '+
        'do site — nada mais — e aperte <b>Atualizar</b> que eu leio o estoque. '+
        '<button type="button" class="mkd-ir-sites" id="mkdIrSites">Cadastrar a primeira loja</button></div>';
      var ir=$('mkdIrSites'); if(ir) ir.onclick=function(){ mkdAbaIr('sites', true); };
      return;
    }
    el.innerHTML='';
  }

  /* ==========================================================================
     AS LOJAS
     ========================================================================== */
  var _mkdLojaAtual="";
  function mkdLojaAtualPinta(id){
    _mkdLojaAtual=String(id||"");
    document.querySelectorAll(".mkd-loja[data-id]").forEach(function(box){var on=box.getAttribute("data-id")===_mkdLojaAtual;box.classList.toggle("is-updating",on);box.setAttribute("aria-busy",String(on));});
  }
  function mkdLojasPinta(){
    var el=$('mkdLojas'); if(!el) return;
    mkdTabNPinta();
    if(_mkdSemTabela){ el.innerHTML=''; return; }
    var todas=(_mkdLojas||[]), ligadas=todas.filter(function(l){ return l.ativo; });
    var lista=todas.map(function(l){
      var quando=l.visto_em?('visto '+mkdQuando(l.visto_em)):'ainda não li esta loja';
      var aviso=String(l.ultimo_erro||'');var falhas=aviso.match(/^(\d+) ficha\(s\) não puderam ser lidas$/);
      var erro=aviso?('<details class="mkd-loja-aviso"><summary>'+esc(falhas?(falhas[1]+' anúncio(s) não atualizado(s)'):'Aviso na última atualização')+'</summary><p>'+esc(aviso)+'</p></details>'):'';
      return '<div class="mkd-loja'+(l.ativo?'':' off')+'" data-id="'+esc(l.id)+'">'+
        '<div class="mkd-loja-tx"><b>'+esc(l.nome||'Loja')+'</b>'+
          '<small>'+esc(mkdDominio(l.site))+' · '+esc(quando)+
          (l.achados!=null?(' · '+Number(l.achados)+' carro(s)'):'')+'</small>'+erro+'</div>'+
        '<div class="mkd-loja-bt">'+
          '<button type="button" class="b1" data-mkd="varrer">Atualizar</button>'+
          '<button type="button" class="b3" data-mkd="liga">'+(l.ativo?'Pausar':'Ligar')+'</button>'+
          '<button type="button" class="b3" data-mkd="tirar">Remover</button>'+
        '</div></div>';
    }).join('');
    /* 🔴 v869 — O FORMULÁRIO VEM PRIMEIRO. Esta aba existe pra "lançar os
       sites": o campo de cadastro é a ação dela, não o rodapé dela. Com dez
       lojas na lista, um formulário no fim seria a mesma coisa que a caixinha
       escondida que esta versão veio consertar. */
    var cadastro=el.querySelector('.mkd-cadastro');var cadastroAberto=cadastro&&cadastro.open;
    el.innerHTML=
      '<details class="mkd-cadastro"'+(cadastroAberto?' open':'')+'><summary>Adicionar loja</summary><div class="mkd-nova">'+
        '<label class="mkd-nova-campo" for="mkdNomeNova"><span>Nome da loja</span><input class="cad-in" id="mkdNomeNova" placeholder="Ex.: Santa Luzia"></label>'+
        '<label class="mkd-nova-campo" for="mkdSiteNova"><span>Site da loja</span><input class="cad-in" id="mkdSiteNova" placeholder="https://www.loja.com.br" inputmode="url"></label>'+
        '<button type="button" class="cad-btn" id="mkdAdd">Acrescentar</button>'+
      '</div>'+
      '<p class="mkd-nova-dica">Use o site principal da loja. Filtros e buscas do endereço são removidos automaticamente.</p></details>'+
      '<div class="cad-msg" id="mkdMsg" role="status" aria-live="polite"></div>'+
      (todas.length
        ? ('<div class="mkd-sites-bar">'+
             '<span class="mkd-sites-n">'+esc(mkdContagemTxt(todas.length, ligadas.length))+'</span>'+
             '<button type="button" class="cad-btn sec" id="mkdTodas">'+(_mkdBusy?(_mkdParar?'Parada solicitada':'Parar após esta loja'):'Atualizar todas')+'</button>'+
           '</div>')
        : '')+
      '<div class="mkd-lista'+(_mkdBusy?' varrendo':'')+'" id="mkdLista">'+lista+'</div>';
    Array.prototype.forEach.call(el.querySelectorAll('.mkd-loja'), function(box){
      var id=box.getAttribute('data-id');
      Array.prototype.forEach.call(box.querySelectorAll('[data-mkd]'), function(b){
        b.disabled=!!_mkdBusy; b.onclick=function(){ mkdLojaAcao(id, b.getAttribute('data-mkd')); };
      });
    });
    mkdLojaAtualPinta(_mkdLojaAtual);
    var add=$('mkdAdd'); if(add) add.onclick=mkdLojaNova;
    var td=$('mkdTodas'); if(td) td.onclick=function(){ if(_mkdBusy) mkdPararTodas(); else mkdVarrerTodas(); };
  }
  function mkdContagemTxt(todas, ligadas){
    if(todas===1) return ligadas?'1 loja, ligada':'1 loja, pausada';
    if(ligadas===todas) return todas+' lojas, todas ligadas';
    if(!ligadas) return todas+' lojas, todas pausadas';
    return todas+' lojas · '+ligadas+' ligada'+(ligadas>1?'s':'');
  }

  async function mkdLojaNova(){
    var nome=String((($('mkdNomeNova')||{}).value)||'').trim();
    var site=String((($('mkdSiteNova')||{}).value)||'').trim();
    if(!nome||!site){ mkdMsg('Escreva o nome e o endereço do site da loja.','err'); return; }
    if(!/^https?:\/\//i.test(site)) site='https://'+site;
    /* 🔴 O ENDEREÇO COLADO POR HUMANO PASSA POR LIMPEZA. O que a pessoa copia
       do navegador costuma vir com a busca DELA junto ("?gear=Automático&page=2")
       ou apontando pra uma ficha. O que a varredura quer é a RAIZ do site — é
       de lá que saem o robots.txt e o sitemap. */
    var raiz=''; try{ raiz=new URL(site).origin; }catch(_){ mkdMsg('Esse endereço não parece um site.','err'); return; }
    try{
      var r=await supa.from('mp_mercado_lojas').insert({ user_id:meuId, nome:nome, site:raiz, ativo:true }).select('id');
      if(r&&r.error) throw r.error;
      /* ⚠️ lição v483: pediu a linha de volta e confere se veio */
      if(!(r&&r.data&&r.data.length)){ mkdMsg('O banco não confirmou o cadastro.','err'); return; }
      mkdMsg('','');
      await mkdCarregar();
    }catch(e){ mkdMsg('Não consegui cadastrar. '+((e&&e.message)||''),'err'); }
  }

  async function mkdLojaAcao(id, acao){
    var l=(_mkdLojas||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!l) return;
    if(acao==='liga'){
      try{ await supa.from('mp_mercado_lojas').update({ ativo:!l.ativo }).eq('id',id); await mkdCarregar(); }
      catch(_){ mkdMsg('Não consegui salvar.','err'); }
      return;
    }
    if(acao==='tirar'){
      if(!confirm('Tirar "'+(l.nome||'esta loja')+'" da lista?\n\nOs carros dela saem do seu índice junto.')) return;
      try{ await supa.from('mp_mercado_lojas').delete().eq('id',id); await mkdCarregar(); }
      catch(_){ mkdMsg('Não consegui remover.','err'); }
      return;
    }
    if(acao==='varrer') return mkdVarrer(l);
  }

  /* ==========================================================================
     A LEITURA DE UMA LOJA
     --------------------------------------------------------------------------
     🔴 CUSTO ZERO EM TOKENS. Esta tela não dispara consulta paga nenhuma — ela
     lê páginas públicas, do mesmo jeito que você leria abrindo o site.
     ========================================================================== */
  /* A LEITURA DE UMA LOJA, sem tela e sem estado — só a rede e o relato.
     v869: separada de propósito, pra o "Atualizar todas" reaproveitar sem
     repetir a montagem da frase (e sem chamar `mkdCarregar()` a cada loja,
     que refaria a busca inteira N vezes à toa). */
  async function mkdVarrerUma(l){
    var r=await apiComTimeout('/api/mercado-varrer',{ loja_id:l.id }, 120000);
    var rel=(r&&r.relato)||{};
    if(r&&r.ok){
      var partes=[];
      partes.push(Number(rel.gravadas||0)+' carro(s) no índice');
      if(rel.urls!=null) partes.push('de '+Number(rel.urls)+' ficha(s) no sitemap');
      if(rel.semFoto)partes.push(Number(rel.semFoto)+' sem foto, ocultado(s)');
      if(rel.removidos)partes.push(Number(rel.removidos)+' anúncio(s) indisponível(is), removido(s) da lista');
      if(rel.falharam) partes.push(Number(rel.falharam)+' não deu pra ler');
      if(rel.sairam) partes.push(Number(rel.sairam)+' saíram do estoque da loja');
      var extra=(rel.motivos&&rel.motivos.length)?(' · '+rel.motivos[0]):'';
      return { ok:true, gravadas:Number(rel.gravadas||0), removidos:Number(rel.removidos||0), semFoto:Number(rel.semFoto||0), falharam:Number(rel.falharam||0), aviso:r.aviso||'',
               texto:partes.join(' · ')+extra };
    }
    return { ok:false, gravadas:0, texto:(r&&r.erro)||'Não consegui ler essa loja agora.' };
  }

  function mkdAtualizacaoAviso(txt,finalizado,erro){
    var box=$('mkdAtualizacaoToast');
    if(!box){
      box=document.createElement('section');box.id='mkdAtualizacaoToast';box.className='mkd-update-toast';
      box.setAttribute('aria-label','Atualização de lojas');
      box.innerHTML='<div class="mkd-update-icon" aria-hidden="true"></div><div class="mkd-update-content"><b id="mkdUpdateTitulo"></b><p id="mkdUpdateTexto" role="status" aria-live="polite"></p><button type="button" id="mkdUpdateFechar">Fechar e ver veículos</button></div>';
      document.body.appendChild(box);
      $('mkdUpdateFechar').onclick=function(){box.remove();mkdAbaIr('procurar',true);var q=$('mkdQ');if(q)q.focus();};
    }
    box.classList.toggle('is-loading',!finalizado);box.classList.toggle('is-error',!!erro);
    $('mkdUpdateTitulo').textContent=finalizado?(erro?'Atualização com avisos':'Atualização concluída'):'Atualizando estoque';
    $('mkdUpdateTexto').textContent=txt||'';
    $('mkdUpdateFechar').hidden=!finalizado;
  }

  async function mkdVarrer(l){
    if(_mkdBusy) return;
    _mkdBusy=true; _mkdLojaAtual=String(l.id); mkdLojasPinta();
    mkdAtualizacaoAviso('Preparando a leitura da '+(l.nome||'loja')+'…',false);
    mkdProgLimpa();mkdMsg('','');
    try{
      var d=await mkdVarrerUma(l);

      _mkdBusy=false;mkdLojaAtualPinta('');
      await mkdCarregar();
      mkdAtualizacaoAviso(d.texto+(d.aviso?' · '+d.aviso:''),true,!d.ok||!!d.aviso);
      return;
    }catch(e){ mkdMsg('',''); mkdAtualizacaoAviso('Não foi possível concluir. Tente atualizar a loja novamente.',true,true); }
    _mkdBusy=false;mkdLojaAtualPinta(''); mkdLojasPinta();
  }

  /* ==========================================================================
     🔴 v869 — ATUALIZAR TODAS (pedido do Angelo, 03/09)
     --------------------------------------------------------------------------
     Antes era uma loja por vez, no dedo. Com cinco lojas isso é cinco idas à
     página, e na prática ninguém atualiza — o índice envelhece e a busca
     passa a mostrar carro que já foi vendido.

     ⚠️ UMA DE CADA VEZ, EM SÉRIE, DE PROPÓSITO. Disparar as cinco juntas
     seria mais rápido e seria errado: são cinco varreduras batendo em cinco
     sites de terceiros ao mesmo tempo, saindo do MESMO servidor. Em série,
     cada site vê um leitor educado, um pedido por vez — do mesmo jeito que
     uma pessoa leria.

     ⚠️ E SÓ AS LOJAS LIGADAS. Quem pausou uma loja pausou por um motivo
     (site fora do ar, layout que ela não lê); "todas" incluir as pausadas
     desfaria a decisão dele sem avisar.

     ⚠️ O "Parar" PARA DEPOIS DA LOJA ATUAL. A leitura que já está viajando
     não tem como ser cancelada de verdade no servidor — prometer isso seria
     mentir. Ele para antes de COMEÇAR a próxima, e a tela diz exatamente
     isso enquanto espera.
     ========================================================================== */
  var _mkdParar=false;
  function mkdPararTodas(){
    if(!_mkdBusy) return;
    _mkdParar=true;
    var stop=$('mkdTodas');if(stop){stop.textContent='Parada solicitada';stop.disabled=true;}
    mkdProgPinta('Vou parar assim que esta loja terminar de ser lida.');
  }
  function mkdProgPinta(txt){
    if($('mkdAtualizacaoToast')){mkdAtualizacaoAviso(txt,false);mkdProgLimpa();return;}
    var e=$('mkdProg'); if(!e) return;
    e.hidden=false; e.textContent=txt||'';
  }
  function mkdProgLimpa(){ var e=$('mkdProg'); if(e){ e.hidden=true; e.textContent=''; } }

  async function mkdVarrerTodas(){
    if(_mkdBusy) return;
    var ligadas=(_mkdLojas||[]).filter(function(l){ return l.ativo; });
    if(!ligadas.length){
      mkdMsg((_mkdLojas||[]).length
        ? 'Todas as suas lojas estão pausadas. Ligue pelo menos uma pra eu poder atualizar.'
        : 'Cadastre uma loja primeiro — o endereço do site dela, ali em cima.','err');
      return;
    }
    _mkdBusy=true; _mkdParar=false;
    mkdAtualizacaoAviso('Preparando a leitura das lojas…',false);
    mkdMsg('','');
    mkdLojasPinta();                     /* o botão vira "Parar" e a lista trava */
    var okN=0, ruimN=0, carros=0, removidos=0, semFoto=0, falhas=0, i=0;
    for(i=0;i<ligadas.length;i++){
      if(_mkdParar) break;
      mkdLojaAtualPinta(ligadas[i].id);
      mkdProgPinta('Lendo '+(i+1)+' de '+ligadas.length+' · '+(ligadas[i].nome||'loja')+'…');
      try{
        var d=await mkdVarrerUma(ligadas[i]);
        removidos+=d.removidos||0;semFoto+=d.semFoto||0;falhas+=d.falharam||0;
        if(d.ok&&d.gravadas){ okN++; carros+=d.gravadas; } else ruimN++;
      }catch(_){ ruimN++; }
    }
    var feitas=okN+ruimN;
    _mkdBusy=false; _mkdParar=false;mkdLojaAtualPinta('');
    mkdProgLimpa();
    try{await mkdCarregar();}catch(e){mkdAtualizacaoAviso('A leitura terminou, mas não foi possível recarregar os veículos. Tente novamente.',true,true);return;} /* recarrega uma vez */
    var fim=[feitas+' de '+ligadas.length+' loja(s) lida(s)'];
    if(carros) fim.push(carros+' carro(s) no índice');
    if(removidos)fim.push(removidos+' anúncio(s) indisponível(is) removido(s)');
    if(semFoto)fim.push(semFoto+' sem foto, ocultado(s)');
    if(falhas)fim.push(falhas+' erro(s) temporário(s), preservado(s)');
    if(ruimN) fim.push(ruimN+' não deu pra ler');
    if(feitas<ligadas.length) fim.push('parei a seu pedido');
    mkdMsg('','');
    mkdAtualizacaoAviso(fim.join(' · '),true,!!ruimN||!!falhas);
  }

  /* ==========================================================================
     🔴 v662 (2ª parte, mesmo pedido) — A FOTO QUE NÃO É DO CARRO
     --------------------------------------------------------------------------
     "tem como vir apenas veiculos com imagens reais?, nao em preparacao"

     O Angelo mandou o print: três carros da Comauto com o mesmo desenho de
     carro coberto e a legenda "Veículo em preparação". Foto de catálogo não
     serve pra nada no dia a dia — não dá pra mandar pro cliente, não dá pra
     ver o estado do carro, e ainda enche a tela.

     🔑 DOIS SINAIS, E O SEGUNDO É O QUE REALMENTE PEGA:
       1. O NOME DO ARQUIVO diz ("em-preparacao", "sem-foto", "placeholder"…).
          Pega bastante, mas cada plataforma inventa um nome — sozinho, fura.
       2. A MESMA FOTO EM DOIS CARROS DIFERENTES. Foto de verdade é única: o
          carro foi fotografado no pátio daquela loja, naquele dia. Se o mesmo
          endereço de imagem aparece em dois anúncios diferentes, aquilo não é
          foto de carro — é desenho de catálogo. Este sinal não depende de
          nome, de plataforma nem de idioma, e é por isso que ele é o principal.

     🔴 E NADA SOME POR CONTA PRÓPRIA. O filtro nasce DESLIGADO: um carro
     sem foto continua sendo um carro de verdade, com preço de verdade, e
     serve pra saber o mercado. O que muda sem ligar filtro nenhum é que o
     card para de mostrar o desenho da outra loja e passa a dizer, com todas
     as letras, "foto ilustrativa" — a informação em vez do enfeite.
     ========================================================================== */
  var MKD_FOTO_FALSA=/(em[-_]?prepara|sem[-_]?foto|no[-_]?image|nophoto|no[-_]?photo|placeholder|indispon|aguarde|em[-_]?breve|default[-_]?(car|veic|image)|foto[-_]?padrao|generic)/i;
  function mkdFotoFake(u){
    if(!u) return true;
    try{ return MKD_FOTO_FALSA.test(String(u)); }catch(_){ return false; }
  }
  /* \u26a0\ufe0f a repetição é medida por CARRO, não por linha: o mesmo anúncio lido
     duas vezes não pode acusar a foto dele de falsa. Por isso a conta usa a
     url do anúncio como identidade. */
  function mkdMapaDeFotos(lista){
    var por={};
    (lista||[]).forEach(function(v){
      var f=String(v.foto_capa||''); if(!f) return;
      if(!por[f]) por[f]={};
      por[f][String(v.url||v.id||'')]=1;
    });
    var rep={};
    Object.keys(por).forEach(function(f){ if(Object.keys(por[f]).length>=2) rep[f]=1; });
    return rep;
  }
  function mkdSemFotoReal(v){
    var f=String((v&&v.foto_capa)||'');
    if(!f) return true;
    if(mkdFotoFake(f)) return true;
    return !!_mkdFotoRepetida[f];
  }

  /* ==========================================================================
     🔴 v662 — A CARROCERIA, QUE O BANCO NÃO GUARDA
     --------------------------------------------------------------------------
     Pedido do Angelo (26/08): "acrescentar filtros, automático, marca, tipo de
     carro, se é SUV ou não".

     ⚠️ O ÍNDICE NÃO TEM ESSE CAMPO. `tipo` só separa carro de moto e de
     caminhonete — quem diz "SUV", "hatch" ou "sedã" é o anúncio da loja, cada
     uma do seu jeito. Então a carroceria é LIDA aqui, na hora de filtrar, e
     não virou coluna nova no banco: coluna nova congela a leitura do dia em
     que foi gravada, e esta leitura vai melhorar com o tempo.

     🔑 A ORDEM DA LEITURA É O QUE A TORNA HONESTA:
       1º  se o ANÚNCIO escreve a palavra ("SUV", "sedã", "cabine dupla"), ela
           vale — quem vende o carro sabe mais que qualquer tabela minha;
       2º  senão, o modelo diz, por uma lista de modelos conhecidos;
       3º  se nenhum dos dois souber, fica VAZIO. Nunca chutado (regra v450).

     🔴 E VAZIO NÃO SOME DA TELA. Quando você liga "SUV", a contagem mostra
     também quantos carros ficaram de fora por eu não saber a carroceria deles.
     Sem essa linha, um filtro que não conhece um modelo esconde o carro e você
     nunca fica sabendo — que é o pior defeito que um filtro pode ter.
     ========================================================================== */
  var MKD_CARROCERIAS=[
    ['suv','SUV'], ['hatch','Hatch'], ['sedan','Sedã'], ['picape','Picape']
  ];
  /* a palavra escrita no próprio anúncio — tem preferência sobre a lista */
  var MKD_DIZ=[
    [/\bsuv\b|utilit[aá]rio esportivo/i,'suv'],
    [/\bsedan?\b/i,'sedan'],
    [/\bhatch(back)?\b/i,'hatch'],
    /* ⚠️ "CD" e "CS" (cabine dupla/simples) ficaram DE FORA de propósito: um
       carro com "CD player" nos opcionais viraria picape. Sigla curta demais
       não serve de prova. */
    [/\bpicape|pick-?up|cabine dupla|cabine simples/i,'picape']
  ];
  /* a lista de modelos. Do mais específico pro mais genérico: "hb20s" é sedã
     e "hb20" é hatch — se o genérico viesse antes, todo HB20S viraria hatch. */
  var MKD_MODELOS=[
    /* --- picapes --- */
    [/\b(saveiro|strada|montana|toro|oroch|hilux|ranger|s-?10|frontier|amarok|l-?200|triton|dakota|hoggar|maverick|gladiator|rampage|ram\s*(1500|2500|3500|rampage)|f-?(250|350|1000)|courier)\b/i,'picape'],
    /* --- SUVs --- */
    [/\b(t-?cross|nivus|taos|tiguan|touareg|tera)\b/i,'suv'],
    [/\b(creta|tucson|kona|santa\s*fe|hb20x|ix35|palisade)\b/i,'suv'],
    [/\b(renegade|compass|commander|wrangler)\b/i,'suv'],
    [/\b(kicks|duster|captur|stepway|koleos)\b/i,'suv'],
    [/\b(tracker|equinox|trailblazer|blazer|captiva)\b/i,'suv'],
    [/\b(ecosport|territory|bronco|edge)\b/i,'suv'],
    [/\b(corolla\s*cross|sw4|rav-?4|yaris\s*cross)\b/i,'suv'],
    [/\b(hr-?v|wr-?v|cr-?v|zr-?v|passport)\b/i,'suv'],
    [/\b(pulse|fastback|palio\s*weekend\s*adventure)\b/i,'suv'],
    [/\b(2008|3008|5008|c3\s*aircross|c4\s*cactus|basalt|aircross)\b/i,'suv'],
    [/\b(tiggo|haval|song|yuan|dolphin\s*mini|atto|seal\s*u|territory)\b/i,'suv'],
    [/\b(pajero|outlander|eclipse\s*cross|asx|forester|xv|crosstrek)\b/i,'suv'],
    [/\b(sportage|sorento|seltos|soul|creta)\b/i,'suv'],
    /* --- sedãs (antes dos hatches, por causa dos pares hb20/hb20s) --- */
    [/\b(virtus|jetta|passat|voyage|bora|santana)\b/i,'sedan'],
    [/\b(hb20s|elantra|accent|sonata|azera)\b/i,'sedan'],
    [/\b(onix\s*plus|prisma|cobalt|cruze\s*sedan|cruze|sonic\s*sedan|astra\s*sedan|vectra)\b/i,'sedan'],
    [/\b(cronos|siena|grand\s*siena|linea|marea)\b/i,'sedan'],
    [/\b(corolla|camry|etios\s*sedan|yaris\s*sedan)\b/i,'sedan'],
    [/\b(civic|city|accord)\b/i,'sedan'],
    [/\b(logan|fluence|megane\s*sedan|scenic)\b/i,'sedan'],
    [/\b(versa|sentra|altima)\b/i,'sedan'],
    [/\b(408|308\s*sedan|207\s*passion|c4\s*pallas|c4\s*lounge)\b/i,'sedan'],
    [/\b(lancer|seal|cerato|k3|forte|optima)\b/i,'sedan'],
    /* --- hatches --- */
    [/\b(gol|up|polo|fox|golf|crossfox|spacefox)\b/i,'hatch'],
    [/\b(hb20|i30|veloster)\b/i,'hatch'],
    [/\b(onix|celta|corsa|agile|sonic|astra|kadett)\b/i,'hatch'],
    [/\b(argo|mobi|uno|palio|punto|bravo|stilo)\b/i,'hatch'],
    [/\b(ka|fiesta|focus|escort)\b/i,'hatch'],
    [/\b(sandero|clio|kwid|twingo|megane)\b/i,'hatch'],
    [/\b(march|livina|tiida)\b/i,'hatch'],
    [/\b(208|207|206|307\s*hatch|c3|c4\s*vtr|c4\s*hatch)\b/i,'hatch'],
    [/\b(fit|city\s*hatch)\b/i,'hatch'],
    [/\b(etios|yaris|corolla\s*hatch)\b/i,'hatch'],
    [/\b(dolphin|picanto|rio)\b/i,'hatch']
  ];
  /* ⚠️ "city" está nos dois: em `sedan` pelo modelo e em `hatch` como
     "city hatch". A regra do 1º passo resolve — se o anúncio escrever
     "hatch", a palavra dele ganha da minha lista. */
  function mkdCarroceria(v){
    if(!v) return '';
    /* 🔴 v1048: quem decide se é moto é o mkdEhMoto, não o `tipo` gravado */
    if(mkdEhMoto(v)) return '';
    if(String(v.tipo||'')==='caminhonete') return 'picape';
    return mkdCarroceriaPeloNome(v);
  }
  /* 🔑 A LEITURA PELO NOME, SOZINHA — sem olhar o `tipo` gravado. Ela ficou
     separada na v1048 porque o mkdEhMoto precisa dela pra saber se o nome é de
     um CARRO conhecido, e o mkdCarroceria precisa do mkdEhMoto. Uma função
     chamando a outra em círculo não fecha; partida em duas, fecha. */
  function mkdCarroceriaPeloNome(v){
    if(!v) return '';
    /* ⚠️ OS OPCIONAIS FICAM DE FORA. Lá dentro cabe qualquer coisa ("teto
       solar, sensor, CD player") e uma palavra solta ali não é a loja
       dizendo qual é a carroceria — é ruído. Nome é nome. */
    var tudo=mkdSemAcento([v.marca,v.modelo,v.versao].filter(Boolean).join(' '));
    if(!tudo) return '';
    var i;
    for(i=0;i<MKD_DIZ.length;i++){ if(MKD_DIZ[i][0].test(tudo)) return MKD_DIZ[i][1]; }
    var nome=mkdSemAcento([v.modelo,v.versao].filter(Boolean).join(' '));
    /* 🔴 TIRA O ANO DE DENTRO DO NOME antes de comparar. "Gol 1.0 2008" tem o
       número 2008 no meio, e 2008 também é nome de um SUV da Peugeot — sem
       esta linha, todo carro 2008 da região virava SUV. Só sai o número que é
       o ano DESTE carro; um Peugeot 2008 ano 2020 continua sendo SUV. */
    var anos=[v.ano,v.ano_modelo].filter(Boolean).map(String);
    if(anos.length) nome=nome.replace(/\b(19|20)\d{2}\b/g,function(m){
      return anos.indexOf(m)>=0?' ':m; });
    for(i=0;i<MKD_MODELOS.length;i++){ if(MKD_MODELOS[i][0].test(nome)) return MKD_MODELOS[i][1]; }
    return '';
  }
  /* ==========================================================================
     🔴🔴 v1048 (pedido do Angelo) — O FILTRO DE CARROS E MOTOS
     --------------------------------------------------------------------------
     O pedido foi "adiciona um filtro pra carros e motos". Antes de escrever a
     tela eu fui OLHAR O ÍNDICE DE VERDADE (206 veículos, 16/09). Achei duas
     coisas, e só a primeira era a que o pedido dizia:

       1º  NÃO EXISTIA "Carros". Existia só "Motos", e ele era o QUINTO botão
           de uma fileira de cinco que rolava de lado — num celular de 390px
           ele ficava fora da tela. Botão que a pessoa não vê não existe: é a
           mesma lição que já está escrita neste arquivo, e eu a repeti.

       2º  🔴 O `tipo` GRAVADO NO BANCO ERRA DOS DOIS LADOS. Em 206 anúncios,
           7 estavam trocados:
             • 6 motos gravadas como carro — Honda CB 250, Suzuki GSX 650 F,
               Yamaha Lander 250, Yamaha NEO 115, Yamaha R3, Yamaha XT 225;
             • 1 CARRO gravado como moto — a Toyota COROLLA CROSS 2.0 XRE,
               porque a sigla "XRE" da versão dela caiu na regra que existe
               pra pegar a Honda XRE 190.
           Ou seja: um filtro certo em cima de dado errado continua errado. Se
           eu só tivesse posto o botão, ligar "Carros" faria uma Corolla Cross
           SUMIR da vitrine e deixaria seis motos no meio dos carros.

     🔑 ENTÃO A SEPARAÇÃO É LIDA AQUI, NA HORA — exatamente como a carroceria
     (lição da v662: coluna nova congela a leitura do dia em que foi gravada, e
     esta leitura vai melhorar com o tempo). Assim as linhas velhas do banco
     ficam certas HOJE, sem migração e sem eu encostar no dado do Angelo.

     🔑 E A ORDEM DA LEITURA É O QUE A TORNA HONESTA:
       1º  se a MARCA só faz moto (Yamaha, Kawasaki, Harley…) ou o MODELO é de
           uma moto conhecida, é moto — e isso ganha do `tipo` gravado;
       2º  senão, se o nome é de um CARRO que eu conheço (a mesma lista da
           carroceria, que sabe "corolla cross"), NÃO é moto — e é esta linha
           que devolve a Corolla Cross pra vitrine;
       3º  se nenhum dos dois souber, aí sim vale o que o banco gravou.

     ⚠️ OS OPCIONAIS FICAM DE FORA, igual na carroceria: "moto" solta no meio
     de um texto de acessórios não é a loja dizendo que aquilo é uma moto.

     🔴🔴 E O ERRO NÃO CUSTA O MESMO NOS DOIS SENTIDOS — é a regra que decide
     esta lista inteira. Moto que sobra na vitrine de carros é ruído: a pessoa
     vê e pula. CARRO QUE VIRA MOTO SOME de 189 anúncios em 206, e some calado.
     Então NA DÚVIDA, NÃO É MOTO: prefiro deixar uma moto passando por carro a
     esconder um carro. (Foi assim que a Chery Arrizo 6 "GSX 1.5" me pegou no
     teste da v662: `gsx` sozinho era prova fraca demais, e um carro sumiu.)

     ⚠️ E TODO PEDAÇO DA LISTA DE MODELOS PEDE O NÚMERO JUNTO onde a sigla é
     curta demais pra servir de prova: `xre\s*\d{3}` pega "XRE 190" e NÃO pega
     "FLEX XRE DIRECT SHIFT". Foi exatamente esse detalhe que derrubou a
     Corolla Cross no varredor. Sigla curta sem número não é prova.

     🔴 AS DUAS LINHAS ABAIXO SÃO GÊMEAS DAS DO `mercado-varrer.js`, e têm que
     continuar idênticas, letra por letra: uma lava a louça do dia (o que entra
     novo no índice), a outra lava a de ontem (o que já está gravado errado).
     Se uma mudar sem a outra, o filtro passa a discordar do próprio índice —
     e existe um teste que REPROVA se elas se separarem.
     ========================================================================== */
  var MKD_MARCA_SO_MOTO=/\b(yamaha|kawasaki|harley|davidson|ducati|triumph|royal\s*enfield|ktm|husqvarna|dafra|shineray|haojue|traxx|kasinski|sundown|bajaj|piaggio|vespa|aprilia|benelli|kymco|motorrad)\b/;
  var MKD_MODELO_MOTO=/\b(motos?|motocicleta|scooter|ciclomotor|biz|pop\s*\d{3}|cg\s*\d{2,3}|cb\s*\d{3}|cbr|crf|nxr|bros|pcx|xre\s*\d{3}|elite\s*\d{3}|sh\s*\d{3}|adv\s*\d{3}|ybr|xtz\s*\d{3}|xt\s*\d{3}|factor|fazer\s*\d{3}|lander|crosser|tenere|neo\s*\d{3}|mt-?\d{2}|yzf|gsx-?[rs]|gsx\s*\d{3}|v-?strom|burgman|intruder|bandit|marauder|ninja|versys|vulcan|hornet|meteor\s*\d{3}|himalayan|hness|g\s*310|r\s*1250)\b/;
  function mkdEhMoto(v){
    if(!v) return false;
    var nome=mkdSemAcento([v.marca,v.modelo,v.versao].filter(Boolean).join(' '));
    /* 1º o nome diz que é moto */
    if(nome && (MKD_MARCA_SO_MOTO.test(nome) || MKD_MODELO_MOTO.test(nome))) return true;
    /* 2º o nome diz que é carro */
    if(mkdCarroceriaPeloNome(v)) return false;
    if(String(v.tipo||'')==='caminhonete') return false;
    /* 3º ninguém soube pelo nome — vale o gravado */
    return String(v.tipo||'')==='moto';
  }
  function mkdCarroceriaNome(c){
    for(var i=0;i<MKD_CARROCERIAS.length;i++){ if(MKD_CARROCERIAS[i][0]===c) return MKD_CARROCERIAS[i][1]; }
    return c||'';
  }

  /* ==========================================================================
     OS BOTÕEZINHOS
     --------------------------------------------------------------------------
     🔑 CADA BOTÃO LIGA E DESLIGA SOZINHO, e só um de cada grupo por vez:
     "automático E manual" não é filtro, é a lista inteira. Tocar num já ligado
     desliga — é como se sai de um filtro sem procurar botão de limpar.

     ⚠️ E O BOTÃO GANHA DA FRASE, sempre. Se a frase diz "automático" e você
     aperta Manual, vale Manual: o último gesto é o que a pessoa quis. A linha
     "Entendi:" mostra o resultado da soma, então nunca fica escondido.
     ========================================================================== */
  function mkdChipsPinta(){
    var el=$('mkdChips'); if(!el) return;
    if(_mkdSemTabela){ el.innerHTML=''; return; }
    function bt(grupo,valor,rot){
      var on=_mkdChips[grupo]===valor;
      return '<button type="button" class="mkd-chip'+(on?' on':'')+'" data-g="'+grupo+'" '+
        'data-v="'+esc(valor)+'" aria-pressed="'+(on?'true':'false')+'">'+esc(rot)+'</button>';
    }
    /* \U0001f534 A ORDEM DAS FILEIRAS FOI DECIDIDA OLHANDO A TELA, NÃO NO PAPEL.
       Na primeira montagem os sete botões vinham numa fileira só que rolava de
       lado — e num iPhone de 390px o "Só com foto real", que era justamente o
       que o Angelo tinha acabado de pedir, ficava FORA da tela. Botão que a
       pessoa não vê não existe. Três fileiras curtas que cabem inteiras valem
       mais que uma fileira comprida que esconde metade. */
    /* \u26f3 v670: o botão "Só com foto real" saiu daqui — ver o bloco lá em cima.
       A linha continua escrita, comentada, pra quem vier depois saber que ele
       existiu e por que foi tirado:
           bt('foto','real','Só com foto real') */
    /* 🔴 v1048 — CARROS E MOTOS É A PRIMEIRA FILEIRA, e só tem dois botões.
       Antes "Motos" era o quinto botão da fileira das carrocerias: cinco não
       cabem em 390px, a fileira rolava de lado e o botão ficava fora da tela.
       É a separação mais grossa que existe aqui (moto não é carro pequeno),
       então ela vem antes de câmbio e de carroceria — e agora as carrocerias
       voltaram a ser quatro, que cabem inteiras. */
    var ativos=mkdFiltrosAtivos();
    var h='<div class="mkd-filtros-top"><div><b>Filtros</b><span>'+(ativos?(ativos+' ativo'+(ativos>1?'s':'')):'Refine os resultados')+'</span></div>'+
      (mkdTemFiltro()?'<button type="button" class="mkd-limpa" id="mkdLimpa">Limpar filtros</button>':'')+'</div>'+
    '<div class="mkd-filtro-grupo"><span class="mkd-filtro-rot">Tipo</span><div class="mkd-chip-linha mkd-chip-tipo" aria-label="Carros ou motos">'+
      bt('tipo','carro','Carros')+bt('tipo','moto','Motos')+
    '</div></div>'+
    '<div class="mkd-filtro-grupo"><span class="mkd-filtro-rot">Câmbio</span><div class="mkd-chip-linha">'+
      bt('cambio','automat','Automático')+bt('cambio','manual','Manual')+
    '</div></div>'+
    '<div class="mkd-filtro-grupo"><span class="mkd-filtro-rot">Carroceria</span><div class="mkd-chip-linha">'+
      MKD_CARROCERIAS.map(function(c){ return bt('carroceria',c[0],c[1]); }).join('')+
    '</div></div>'+
    '<div class="mkd-filtro-grupo"><span class="mkd-filtro-rot">Situação</span><div class="mkd-chip-linha mkd-chip-estoque" aria-label="Situação no estoque">'+
      bt('estoque','novidades','Novidades')+bt('estoque','estoque','No estoque')+
    '</div></div>'+
    '<fieldset class="mkd-preco-faixa"><legend>Faixa de preço</legend><div class="mkd-preco-campos">'+
      '<label for="mkdPrecoMin"><span>Preço mínimo</span><input id="mkdPrecoMin" inputmode="numeric" autocomplete="off" placeholder="R$ 0" value="'+esc(mkdPrecoMostra(_mkdChips.precoMin))+'"></label>'+
      '<span class="mkd-preco-ate" aria-hidden="true">até</span>'+
      '<label for="mkdPrecoMax"><span>Preço máximo</span><input id="mkdPrecoMax" inputmode="numeric" autocomplete="off" placeholder="Sem limite" value="'+esc(mkdPrecoMostra(_mkdChips.precoMax))+'"></label>'+
    '</div><button type="button" class="mkd-preco-aplicar" id="mkdPrecoAplicar">Aplicar faixa</button>'+
    '<div class="mkd-preco-erro" id="mkdPrecoErro" role="status"></div></fieldset>';
    h+='<div class="mkd-select-grid">'+
      /* v699 (pedido): filtrar POR LOJA. A lista vem do CADASTRO (_mkdLojas),
         não do resultado — escolher uma loja nunca apaga as outras do
         seletor (a mesma lição da lista de marcas, logo abaixo). */
      ((_mkdLojas||[]).length>1
        ? ('<select class="mkd-sel" id="mkdLoja" aria-label="Loja">'+
            '<option value="">Todas as lojas</option>'+
            _mkdLojas.slice().sort(function(a,b){ return String(a.nome||'').localeCompare(String(b.nome||''),'pt-BR'); })
              .map(function(l){
                return '<option value="'+esc(l.id)+'"'+(String(_mkdChips.loja)===String(l.id)?' selected':'')+'>'+esc(l.nome||'Loja')+'</option>';
              }).join('')+
          '</select>')
        : '')+
      ((_mkdMarcas||[]).length
        ? ('<select class="mkd-sel" id="mkdMarca" aria-label="Marca">'+
            '<option value="">Todas as marcas</option>'+
            _mkdMarcas.map(function(m){
              return '<option value="'+esc(m)+'"'+(_mkdChips.marca===m?' selected':'')+'>'+esc(m)+'</option>';
            }).join('')+
          '</select>')
        : '')+
      '<select class="mkd-sel" id="mkdOrd" aria-label="Ordenar">'+
        MKD_ORDENS.map(function(o){
          return '<option value="'+o[0]+'"'+(_mkdOrdem===o[0]?' selected':'')+'>'+esc(o[1])+'</option>';
        }).join('')+
      '</select>'+
    '</div>';
    var moreOpen=!!(el.querySelector('.mkd-more-filters')||{}).open;
    el.innerHTML=h;
    mkdFiltrosOrganizar(el,moreOpen);
    Array.prototype.forEach.call(el.querySelectorAll('.mkd-chip'), function(b){
      b.onclick=function(){
        var g=b.getAttribute('data-g'), v=b.getAttribute('data-v');
        var ligar=_mkdChips[g]!==v;
        _mkdChips[g]=ligar?v:'';   /* tocar no ligado desliga */
        /* 🔴 SÓ "Motos" BRIGA COM CARROCERIA. SUV, hatch, sedã e picape são
           desenhos de CARRO: com "Motos" ligado a lista ficaria vazia, e o
           último toque prevalece e limpa a escolha anterior. Já "Carros"
           CONVIVE com todas — "Carros + SUV" é um pedido legítimo, e desligar
           a carroceria ali seria o app desfazendo o que a pessoa acabou de
           pedir (v1048: antes o `tipo` derrubava a carroceria em qualquer
           caso, porque só existia "Motos"). */
        if(ligar&&g==='tipo'&&v==='moto') _mkdChips.carroceria='';
        if(ligar&&g==='carroceria'&&_mkdChips.tipo==='moto') _mkdChips.tipo='';
        mkdProcurar();
      };
    });
    var sel=$('mkdMarca');
    if(sel) sel.onchange=function(){ _mkdChips.marca=sel.value||''; mkdProcurar(); };
    var sl=$('mkdLoja');
    if(sl) sl.onchange=function(){ _mkdChips.loja=sl.value||''; mkdProcurar(); };   /* v699 */
    var so=$('mkdOrd');
    if(so) so.onchange=function(){ _mkdOrdem=so.value||'preco_asc'; mkdProcurar(); };
    var pMin=$('mkdPrecoMin'), pMax=$('mkdPrecoMax'), pAplicar=$('mkdPrecoAplicar');
    function faixaAplicar(){
      var min=mkdPrecoLer(pMin&&pMin.value), max=mkdPrecoLer(pMax&&pMax.value), er=$('mkdPrecoErro');
      if(min&&max&&min>max){
        if(er) er.textContent='O preço mínimo deve ser menor que o máximo.';
        if(pMin) pMin.setAttribute('aria-invalid','true');
        if(pMax) pMax.setAttribute('aria-invalid','true');
        return;
      }
      if(er) er.textContent='';
      if(pMin) pMin.removeAttribute('aria-invalid');
      if(pMax) pMax.removeAttribute('aria-invalid');
      _mkdChips.precoMin=min||''; _mkdChips.precoMax=max||''; mkdProcurar();
    }
    if(pAplicar) pAplicar.onclick=faixaAplicar;
    [pMin,pMax].forEach(function(inp){ if(!inp) return;
      inp.onkeydown=function(e){ if(e.key==='Enter'){ e.preventDefault(); faixaAplicar(); } };
    });
    var lp=$('mkdLimpa');
    /* \u26a0\ufe0f "Limpar filtros" limpa TUDO, inclusive o de foto — inclusive o que
       vem ligado de fábrica. Botão que diz "limpar" e deixa um filtro de pé
       mente, e o carro que continuasse escondido depois do limpar seria o mais
       difícil de achar de todos. */
    if(lp) lp.onclick=function(){ _mkdChips=JSON.parse(JSON.stringify(MKD_CHIPS_PADRAO)); mkdProcurar(); };
  }
  function mkdFiltrosOrganizar(el,moreOpen){
    var more=document.createElement('details');more.className='mkd-more-filters';more.open=moreOpen;
    var summary=document.createElement('summary');summary.textContent='Mais filtros';more.appendChild(summary);
    Array.prototype.forEach.call(el.querySelectorAll('.mkd-filtro-grupo'),function(group){
      if(!group.querySelector('[data-g="cambio"]'))more.appendChild(group);
    });
    var marca=el.querySelector('#mkdMarca');if(marca)more.appendChild(marca);
    el.appendChild(more);
    var applied=document.createElement('div');applied.className='mkd-applied';applied.setAttribute('aria-label','Filtros aplicados');
    function tag(key,label,query){var b=document.createElement('button');b.type='button';b.className='mkd-applied-tag';b.textContent=label+' ×';b.setAttribute('aria-label','Remover filtro: '+label);b.onclick=function(){if(query){var q=$('mkdQ');if(q)q.value='';}else _mkdChips[key]='';mkdProcurar();};applied.appendChild(b);}
    var labels={tipo:{carro:'Carros',moto:'Motos'},cambio:{automat:'Automático',manual:'Manual'},estoque:{novidades:'Novidades',estoque:'No estoque'},foto:{real:'Só com foto real'}};
    ['tipo','cambio','carroceria','marca','foto','loja','estoque','precoMin','precoMax'].forEach(function(key){var v=_mkdChips[key];if(!v)return;var label=labels[key]&&labels[key][v]||String(v);if(key==='carroceria')label=mkdCarroceriaNome(v);if(key==='loja'){var shop=(_mkdLojas||[]).find(function(l){return String(l.id)===String(v);});label=shop?shop.nome:'Loja selecionada';}if(key==='precoMin')label='A partir de '+mkdPrecoMostra(v);if(key==='precoMax')label='Até '+mkdPrecoMostra(v);tag(key,label,false);});
    var q=$('mkdQ'),query=q&&q.value.trim();if(query)tag('query','Busca: '+query,true);
    if(applied.childNodes.length){var clear=document.createElement('button');clear.type='button';clear.className='mkd-applied-clear';clear.textContent='Limpar todos';clear.onclick=function(){_mkdChips=JSON.parse(JSON.stringify(MKD_CHIPS_PADRAO));var q=$('mkdQ');if(q)q.value='';mkdProcurar();};applied.appendChild(clear);el.insertBefore(applied,el.firstChild);}
    if(document.body.classList.contains('mev-tools-embedded')){
      var fold=document.createElement('details');fold.className='mkd-main-filters';fold.open=el.dataset.filtersClosed!=='1';
      var title=document.createElement('summary');title.textContent='Filtros'+(mkdFiltrosAtivos()?' · '+mkdFiltrosAtivos()+' ativo(s)':'');fold.appendChild(title);
      var grid=document.createElement('div');grid.className='mkd-main-filters-grid';
      Array.prototype.slice.call(el.children).forEach(function(n){if(!n.classList.contains('mkd-applied'))grid.appendChild(n);});fold.appendChild(grid);
      el.appendChild(fold);
      fold.ontoggle=function(){el.dataset.filtersClosed=fold.open?'0':'1';};
    }
  }
  function mkdPrecoLer(v){ var n=Number(String(v||'').replace(/\D/g,''))||0; return n>0?Math.round(n):0; }
  function mkdPrecoMostra(v){ var n=Number(v)||0; return n?('R$ '+Math.round(n).toLocaleString('pt-BR')):''; }
  function mkdFiltrosAtivos(){
    return ['cambio','carroceria','tipo','marca','foto','loja','estoque','precoMin','precoMax']
      .filter(function(k){ return !!_mkdChips[k]; }).length;
  }
  function mkdTemFiltro(){ return mkdFiltrosAtivos()>0; }

  /* ==========================================================================
     A BUSCA — a frase vira filtro, e a tela MOSTRA o que entendeu
     --------------------------------------------------------------------------
     ⚠️ SEM IA NESTA VERSÃO, de propósito: a tradução é feita aqui mesmo, de
     graça, e é pequena. A frase não é a fonte da resposta — a lista vem do
     índice, por filtro, como toda busca honesta. Se a leitura da frase errar,
     os filtros aparecem escritos embaixo e você conserta na mão.
     ========================================================================== */
  function mkdLerFrase(txt){
    var t=' '+mkdSemAcento(txt)+' ';   /* v662 — sem acento dos dois lados */
    var f={ texto:'', precoMax:null, precoMin:null, kmMax:null, anoMin:null,
            cambio:'', combustivel:'', tipo:'', carroceria:'' };
    /* "até 120 mil" · "até 120.000" · "até 120k" */
    var m=t.match(/at[ée]\s*(?:r\$\s*)?([\d.,]+)\s*(mil|k)?/);
    if(m){ f.precoMax=mkdValor(m[1], m[2]); }
    var mi=t.match(/(?:acima de|a partir de|de)\s*(?:r\$\s*)?([\d.,]+)\s*(mil|k)?\s*(?:at[ée]|pra cima)/);
    if(mi) f.precoMin=mkdValor(mi[1], mi[2]);
    /* "menos de 60 mil km" · "até 60.000 km" */
    var mk=t.match(/(?:menos de|abaixo de|at[ée])\s*([\d.,]+)\s*(mil|k)?\s*km/);
    if(mk){ f.kmMax=mkdValor(mk[1], mk[2]); }
    /* "2020 pra cima" · "de 2020 em diante" */
    var ma=t.match(/((?:19|20)\d{2})\s*(?:pra cima|para cima|em diante|ou mais novo)/);
    if(ma) f.anoMin=Number(ma[1]);
    if(/automatic|cambio auto|\bcvt\b|tiptronic|\bat\d?\b/.test(t)) f.cambio='automat';
    else if(/manual/.test(t)) f.cambio='manual';
    if(/diesel/.test(t)) f.combustivel='diesel';
    else if(/\bflex\b/.test(t)) f.combustivel='flex';
    else if(/gasolina/.test(t)) f.combustivel='gasolina';
    /* 🔴 v1048: picape é CARRO, não um terceiro reino. O valor 'caminhonete'
       saíu daqui porque ele só servia pra ir ao banco — e o filtro de carro x
       moto não vai mais ao banco. A carroceria 'picape' continua fazendo o
       trabalho fino, e ela sabe ler Hilux e Strada pelo nome. */
    if(/caminhonete|picape|pick-?up/.test(t)){ f.tipo='carro'; f.carroceria='picape'; }
    else if(/\bmoto\b|motocicleta|scooter/.test(t)) f.tipo='moto';
    else if(/\bcarro\b|\bsuv\b|\bsedan?\b|hatch/.test(t)) f.tipo='carro';
    /* \U0001f534 v662 — SUV, HATCH E SEDÃ DEIXARAM DE VIRAR SÓ "carro".
       Antes as três palavras caíam todas em `tipo='carro'`: pedir SUV trazia
       hatch e sedã junto, e o filtro parecia quebrado sem estar. Agora cada
       uma vira CARROCERIA, que é o que a pessoa quis dizer. */
    if(/\bsuv\b/.test(t)) f.carroceria='suv';
    else if(/hatch/.test(t)) f.carroceria='hatch';
    else if(/\bsedan?\b/.test(t)) f.carroceria='sedan';   /* "sedã" já chegou sem til */
    /* o que sobra é nome de marca/modelo */
    f.texto=String(txt||'')
      .replace(/at[ée][^,;]*/gi,' ').replace(/menos de[^,;]*/gi,' ')
      .replace(/(?:19|20)\d{2}\s*(?:pra cima|para cima|em diante)/gi,' ')
      .replace(/autom[áa]tic\w*|manual|cvt|diesel|flex|gasolina|suv|sedan|hatch|carro|moto|caminhonete|picape/gi,' ')
      .replace(/[^\wÀ-ÿ .-]/g,' ').replace(/\s+/g,' ').trim();
    return f;
  }
  /* ==========================================================================
     \U0001f534\U0001f534 v662 — O ACENTO QUE ESCONDIA METADE DO MERCADO (defeito da v659)
     --------------------------------------------------------------------------
     Achado pelo teste-v662, não pelo olho: o filtro de câmbio nunca funcionou.

     A conta era `String(v.cambio).toLowerCase().indexOf('automat')`. E a loja
     escreve **Automático**, com acento: a-u-t-o-m-**á**-t-i-c-o. A palavra
     "automat" NÃO está lá dentro — depois do "m" vem "á", não "a". Resultado:
     pedir automático devolvia ZERO carro, sempre, desde a v659.

     O mesmo acento derrubava a frase: `\bsed[aã]n?\b` nunca casava com "sedã",
     porque pro JavaScript o "ã" não é letra e o `\b` não fecha depois dele.

     \U0001f511 A CURA É UMA SÓ, E VALE PRA SEMPRE: tirar o acento dos DOIS lados
     antes de comparar. Não é enfeite — é a mesma família de erro da v657 (o
     "à" do Mac que quebrava a publicação). Texto de gente tem acento; conta de
     computador, não. Quem compara os dois converte antes.
     ========================================================================== */
  function mkdSemAcento(x){
    try{ return String(x==null?'':x).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase(); }
    catch(_){ return String(x==null?'':x).toLowerCase(); }
  }

  function mkdValor(n, unidade){
    var v=Number(String(n).replace(/\./g,'').replace(',','.'))||0;
    if(!v) return null;
    if(unidade || v<=999) v=v*1000;      /* "120 mil" e "120" viram 120.000 */
    return Math.round(v);
  }

  /* Only in-memory reads: same account, same server filters, 15 seconds. */
  var _mkdBuscaSeq=0, _mkdReadCache=null, _mkdReadPending=Object.create(null);
  function mkdLerVeiculos(f){
    var key=JSON.stringify([meuId||'',f.precoMax||0,f.precoMin||0,f.kmMax||0,f.anoMin||0,f.loja||'']);
    if(_mkdReadCache&&_mkdReadCache.key===key&&Date.now()-_mkdReadCache.time<15000)return Promise.resolve(_mkdReadCache.data);
    if(_mkdReadPending[key])return _mkdReadPending[key];
    var controller=typeof AbortController==='function'?new AbortController():null,timer;
    var task=(async function(){try{
      await Promise.resolve(); /* install the shared promise before a synchronous failure */
      var q=supa.from('mp_mercado_veiculos').select('*').is('saiu_em',null);
      if(f.precoMax)q=q.lte('preco',f.precoMax);if(f.precoMin)q=q.gte('preco',f.precoMin);
      if(f.kmMax)q=q.lte('km',f.kmMax);if(f.anoMin)q=q.gte('ano_modelo',f.anoMin);if(f.loja)q=q.eq('loja_id',f.loja);
      q=q.order('preco',{ascending:true}).limit(300);
      if(controller&&typeof q.abortSignal==='function')q=q.abortSignal(controller.signal);
      var result=await Promise.race([q,new Promise(function(_,reject){timer=setTimeout(function(){if(controller)controller.abort();reject(Error('tempo'));},15000);})]);
      if(result&&result.error)throw result.error;
      var data=result&&result.data||[];_mkdReadCache={key:key,time:Date.now(),data:data};return data;
    }finally{clearTimeout(timer);delete _mkdReadPending[key];}})();
    _mkdReadPending[key]=task;return task;
  }
  async function mkdProcurar(){
    if(_mkdSemTabela) return;
    var seq=++_mkdBuscaSeq;
    var f=mkdLerFrase(((($('mkdQ')||{}).value)||''));
    /* \U0001f511 O BOTÃO GANHA DA FRASE (o último gesto é o que a pessoa quis) */
    if(_mkdChips.cambio) f.cambio=_mkdChips.cambio;
    if(_mkdChips.carroceria){
      f.carroceria=_mkdChips.carroceria;
      /* pedir SUV, hatch, sedã ou picape já é dizer que não é moto */
      f.tipo='carro';
    }
    if(_mkdChips.tipo) f.tipo=_mkdChips.tipo;
    f.marca=_mkdChips.marca||'';
    f.loja=_mkdChips.loja||'';   /* v699 */
    f.soFoto=(_mkdChips.foto==='real');
    f.estoque=_mkdChips.estoque||'';
    /* Campos explícitos ganham da frase, como os demais filtros manuais. */
    if(_mkdChips.precoMin) f.precoMin=Number(_mkdChips.precoMin)||null;
    if(_mkdChips.precoMax) f.precoMax=Number(_mkdChips.precoMax)||null;
    _mkdFiltro=f;
    var resultBox=$('mkdRes');if(resultBox)resultBox.setAttribute('aria-busy','true');
    try{
      var veics=await mkdLerVeiculos(f);if(seq!==_mkdBuscaSeq)return;_mkdVeics=veics;
    }catch(_){
      if(seq!==_mkdBuscaSeq)return;
      var status=$('mkdLidos');if(status){status.setAttribute('role','status');status.textContent='Não foi possível atualizar a busca. Os resultados anteriores foram mantidos. Tente buscar novamente.';}
      return;
    }finally{if(seq===_mkdBuscaSeq&&resultBox)resultBox.setAttribute('aria-busy','false');}
    /* o resto do filtro é sobre texto, e sai aqui pra não depender de índice
       de texto no banco */
    /* \U0001f534 A LISTA DE MARCAS SAI DAQUI, ANTES DO FILTRO DE MARCA.
       Se ela saísse depois, escolher "Volkswagen" apagaria todas as outras do
       seletor e você ficaria preso na marca que escolheu. */
    var m={}; _mkdVeics.forEach(function(v){ var x=String(v.marca||'').trim(); if(x) m[x]=1; });
    _mkdMarcas=Object.keys(m).sort(function(a,b){ return a.localeCompare(b,'pt-BR'); });
    /* \U0001f534 o mapa das fotos repetidas sai do MONTE INTEIRO, não do resultado
       filtrado: se saísse do resultado, filtrar "Fiat" deixaria uma foto de
       catálogo sozinha na lista e ela passaria por foto de verdade. */
    _mkdFotoRepetida=mkdMapaDeFotos(_mkdVeics);

    var alvo=mkdSemAcento(f.texto).split(/\s+/).filter(Boolean);
    function passaSemCarroceria(v){
      if(f.cambio && mkdSemAcento(v.cambio).indexOf(f.cambio)<0) return false;
      if(f.combustivel && mkdSemAcento(v.combustivel).indexOf(f.combustivel)<0) return false;
      if(f.marca && mkdSemAcento(v.marca).trim()!==mkdSemAcento(f.marca).trim()) return false;
      if(!alvo.length) return true;
      var texto=mkdSemAcento((v.marca||'')+' '+(v.modelo||'')+' '+(v.versao||'')+' '+(v.opcionais||''));
      return alvo.every(function(p){ return texto.indexOf(p)>=0; });
    }
    var quase=_mkdVeics.filter(passaSemCarroceria);
    var escondidosSemFoto=0;
    if(f.soFoto){
      var antes=quase.length;
      quase=quase.filter(function(v){ return !mkdSemFotoReal(v); });
      escondidosSemFoto=antes-quase.length;
    }
    /* 🔴 v1048 — E AQUI A ESCOLHA ENTRE CARRO E MOTO, pelo mkdEhMoto, que lê
       o nome e só recorre ao `tipo` gravado quando o nome não sabe. Vem ANTES
       da carroceria de propósito: a carroceria só faz sentido em carro, e a
       conta dos "não sei a carroceria" logo abaixo ficaria inflada de moto se
       as motos ainda estivessem no monte. */
    if(f.tipo==='moto') quase=quase.filter(function(v){ return mkdEhMoto(v); });
    else if(f.tipo==='carro') quase=quase.filter(function(v){ return !mkdEhMoto(v); });
    var lista=quase, semCarroceria=0;
    if(f.carroceria){
      lista=quase.filter(function(v){ return mkdCarroceria(v)===f.carroceria; });
      /* \U0001f534 quantos ficaram de fora por eu NÃO SABER a carroceria — filtro
         que esconde carro sem avisar é o pior tipo de filtro */
      semCarroceria=quase.filter(function(v){ return !mkdCarroceria(v); }).length;
    }
    if(f.estoque==='novidades') lista=lista.filter(function(v){ return !mkdEstoqueDeMercado(v); });
    else if(f.estoque==='estoque') lista=lista.filter(function(v){ return !!mkdEstoqueDeMercado(v); });
    var chips=$('mkdChips');if(chips&&document.body.classList.contains('mev-tools-embedded'))chips.dataset.filtersClosed='1';
    mkdChipsPinta();
    mkdResPinta(mkdOrdenar(lista, _mkdOrdem), f, semCarroceria, escondidosSemFoto);
    mkdRevisarPinta();
  }

  function mkdResPinta(lista, f, semCarroceria, escondidosSemFoto){
    lista=lista.filter(function(v){return !_mkdExclusoes[mkdExclusaoChave(v.id)];});
    var el=$('mkdRes'); if(!el) return;
    var lidos=$('mkdLidos');
    if(lidos){
      var quais=[];
      if(f.precoMax) quais.push('até '+_rs(f.precoMax));
      if(f.precoMin) quais.push('de '+_rs(f.precoMin));
      if(f.kmMax) quais.push('até '+Number(f.kmMax).toLocaleString('pt-BR')+' km');
      if(f.anoMin) quais.push(f.anoMin+' pra cima');
      if(f.cambio) quais.push(f.cambio==='automat'?'automático':'manual');
      if(f.combustivel) quais.push(f.combustivel);
      if(f.carroceria) quais.push(mkdCarroceriaNome(f.carroceria));
      else if(f.tipo==='moto') quais.push('motos');
      else if(f.tipo==='carro') quais.push('carros');
      if(f.marca) quais.push(f.marca);
      if(f.loja){ var _lj=((_mkdLojas||[]).filter(function(x){ return String(x.id)===String(f.loja); })[0]||{});
        quais.push('loja: '+(_lj.nome||'?')); }   /* v699 */
      if(f.soFoto) quais.push('só com foto real');
      if(f.estoque==='novidades') quais.push('novidades fora do estoque');
      else if(f.estoque==='estoque') quais.push('no estoque');
      if(f.texto) quais.push('"'+f.texto+'"');
      /* 🔑 a tela DIZ o que entendeu da frase — se errou, você vê na hora */
      lidos.innerHTML=quais.length?('Entendi: '+esc(quais.join(' · '))):'';
    }
    /* \U0001f534 O RECADO DOS QUE EU NÃO SEI. Some com o filtro de carroceria
       desligado, porque aí ninguém ficou de fora por causa dele. */
    var recado=(f.carroceria && semCarroceria)
      ? ('<div class="mkd-nota">+ '+semCarroceria+' carro(s) que batem no resto do filtro mas eu '+
         'não sei a carroceria — desligue "'+esc(mkdCarroceriaNome(f.carroceria))+'" pra ver.</div>')
      : '';
    /* \U0001f534 v663 — O RECADO DOS ESCONDIDOS PELA FOTO. Este filtro passou a vir
       ligado de fábrica, então ele PRECISA se anunciar: senão o app começa
       escondendo carro sem nunca ter pedido licença. E o recado não é só
       aviso — é botão: um toque mostra todos. */
    if(f.soFoto && escondidosSemFoto){
      recado+='<div class="mkd-nota">'+escondidosSemFoto+' carro(s) escondido(s) porque a foto é de '+
        'catálogo, não do carro. <button type="button" class="mkd-nota-bt" id="mkdVerTodos">Mostrar '+
        'esses também</button></div>';
    }
    /* \u26a0\ufe0f O GANCHO DO "MOSTRAR ESSES TAMBÉM" É LIGADO ANTES DO `return` DA
       LISTA VAZIA — senão, justamente quando o filtro escondeu TUDO, o botão
       que desfaz o filtro nasceria morto. É o caso em que ele mais importa. */
    setTimeout(function(){
      if(document.body.classList.contains('mev-tools-embedded')){var conta=document.querySelector('#mkdRes .mkd-conta'),ord=$('mkdOrd');if(conta&&ord)conta.appendChild(ord);}
      document.querySelectorAll('#mkdRes .mkd-foto img').forEach(function(im){function fail(){if(im.dataset.mkdFailed)return;im.dataset.mkdFailed='1';im.hidden=true;var box=im.parentElement;box.classList.add('mkd-foto-indisponivel');box.setAttribute('data-status','Foto indisponível');if(_mkdChips.foto==='real'){var card=im.closest('.mkd-card');if(card){card.style.setProperty('display','none','important');mkdExcluirContagem(-1);var note=$('mkdFotosOcultas');if(!note){note=document.createElement('div');note.id='mkdFotosOcultas';note.className='mkd-nota';note.setAttribute('role','status');var res=$('mkdRes');res.insertBefore(note,res.firstChild);}note.dataset.n=Number(note.dataset.n||0)+1;note.textContent=note.dataset.n+' veículo(s) ocultado(s) por falha na foto. As fotos serão tentadas novamente na próxima busca.';}}}im.addEventListener('error',fail,{once:true});if(im.complete&&!im.naturalWidth)fail();});
      var b=$('mkdVerTodos');
      if(b) b.onclick=function(){ _mkdChips.foto=''; mkdProcurar(); };
      /* v700 (pedido, 29/08): "quando clicar em trazer, nao coloque na
         bandeja, ja abre a pagina do estoque com o link pra importar".
         O Trazer virou porta DIRETA: abre a ficha nova do estoque com o
         link do anúncio já no campo de importar. 🔴 O import NÃO dispara
         sozinho — ele custa token (v665), e consulta paga nunca sai sem o
         dedo (v585): o "Importar" do estoque é o consentimento. */
      Array.prototype.forEach.call(document.querySelectorAll('#mkdRes [data-add]'), function(bt){
        bt.onclick=function(){ mkdTrazerDireto(bt.getAttribute('data-add')); };
      });
      Array.prototype.forEach.call(document.querySelectorAll('#mkdRes [data-est-ver]'), function(bt){
        bt.onclick=function(){
          var id=bt.getAttribute('data-est-ver');
          if(id&&typeof estAbrirFicha==='function') estAbrirFicha(id);
        };
      });
      Array.prototype.forEach.call(document.querySelectorAll('#mkdRes [data-mkd-excluir]'), function(bt){
        bt.onclick=function(){ mkdExcluirDoIndice(bt.getAttribute('data-mkd-excluir'),bt); };
      });
    },0);
    if(!lista.length){
      el.innerHTML='<div class="cli-empty"><b>Nenhum carro com esse filtro</b>'+
        ((_mkdLojas||[]).length?'Tente com menos condições, ou atualize as lojas aqui embaixo.':'Cadastre uma loja aqui embaixo pra começar.')+'</div>'+recado;
      return;
    }
    var porLoja={}; (_mkdLojas||[]).forEach(function(l){ porLoja[String(l.id)]=l; });
    el.innerHTML='<div class="mkd-conta">'+lista.length+' veículo(s)</div>'+recado+
      lista.map(function(v){
        var l=porLoja[String(v.loja_id)]||{};
        var noEstoque=mkdEstoqueDeMercado(v);
        var linha=[];
        if(v.ano_modelo||v.ano) linha.push(esc(String(v.ano||'')+(v.ano_modelo&&v.ano_modelo!==v.ano?('/'+v.ano_modelo):'')));
        if(v.km) linha.push(Number(v.km).toLocaleString('pt-BR')+' km'+(v.km_suspeita?' ⚠️':''));
        if(v.cambio) linha.push(esc(v.cambio));
        var baixou=(v.preco_anterior && v.preco && v.preco_anterior>v.preco)
          ? '<span class="mkd-baixou">baixou '+esc(_rs(v.preco_anterior-v.preco))+'</span>' : '';
        /* \U0001f534 FOTO DE CATÁLOGO NÃO ENTRA NA TELA. Duas razões, e as duas
           valem sozinhas: (1) o desenho vem com a marca da outra loja escrita
           dentro, e o app não republica peça de ninguém; (2) o desenho ocupa o
           lugar da informação. No lugar dele fica a caixa vazia e o aviso —
           que diz mais que a figura dizia. */
        var semFoto=mkdSemFotoReal(v);
        var foto=(!semFoto)
          ? ('<img loading="lazy" decoding="async" src="'+esc(v.foto_capa)+'" alt="">')
          : '<span class="mkd-foto-aviso">Foto do veículo não disponível</span>';
        var avisoFoto=semFoto?'<span class="mkd-tag">foto ilustrativa</span>':'';
        return '<div class="mkd-card'+(noEstoque?' no-estoque':'')+'">'+
          '<div class="mkd-foto">'+foto+'</div>'+
          '<div class="mkd-tx">'+
            '<b>'+esc(mkdNomeExibicao(v))+'</b>'+
            '<small>'+linha.join(' · ')+avisoFoto+'</small>'+
            '<div class="mkd-preco">'+(v.preco?esc(_rs(v.preco)):'Preço não informado')+baixou+'</div>'+
            '<div class="mkd-loja-nm">'+esc(l.nome||'Loja')+(l.cidade?(' · '+esc(l.cidade)):'')+
              (noEstoque?'<span class="mkd-tag estoque">No estoque</span>':'')+'</div>'+
            /* 🔴 O CARD NUNCA FINGE ESTAR AO VIVO. A data da última leitura sai
               em toda ficha, sem exceção — ligar pro cliente sobre um carro
               vendido semana passada queima você. */
            '<div class="mkd-visto">visto '+esc(mkdQuando(v.visto_em))+'</div>'+
            '<div class="mkd-acts">'+
              '<a class="b2" href="'+esc(v.url)+'" target="_blank" rel="noopener">Abrir no site da loja</a>'+
              (noEstoque
                ? '<button type="button" class="mkd-add" data-est-ver="'+esc(String(noEstoque.id))+'">Ver</button>'
                : '<button type="button" class="mkd-add" data-add="'+esc(String(v.id))+'">Trazer para estoque</button>'+
                  '<button type="button" class="mkd-excluir" data-mkd-excluir="'+esc(String(v.id))+'">Excluir</button>')+
            '</div>'+
          '</div></div>';
      }).join('');
  }

  /* ==========================================================================
     🔴🔴 v664 (pedido do Angelo, 26/08) — TRAZER DO MERCADO PRO ESTOQUE
     --------------------------------------------------------------------------
     "qual a possibilidade dele já importar esses veículos para o meu catálogo,
      para o meu estoque? De forma prévia, eu faço a conferência só dos dados e
      confirmo a entrada no estoque."
     E, sobre o carro que é de outra loja: "entra no estoque e vai pro catalogo,
     eu seleciono quais eu quero estoque e catalago."

     🔑 O DESENHO EM TRÊS TEMPOS: MARCAR → CONFERIR → TRAZER.
     A bandeja é o "de forma prévia" que ele pediu. Marcar não mexe em nada;
     conferir é uma tela de campos editáveis; trazer é o único momento em que
     alguma coisa entra no estoque. Antes disso, nenhum carro do Mercado tocou
     na loja dele.

     🔴🔴 A DECISÃO MAIS IMPORTANTE DESTA VERSÃO: AS FOTOS NÃO VÊM JUNTO.
     Não é limitação — é trava, e ela tem duas razões, cada uma bastando sozinha:

       1. A foto do anúncio é da OUTRA LOJA. Trazer a foto dela e publicar no
          site dele seria republicar peça de terceiro — a mesma regra do dia em
          que o Mercado nasceu ("não republica foto de ninguém: o índice guarda
          o LINK da foto").

       2. E é a foto que segura o carro fora do site. A vitrine pública só
          mostra carro que tem `fotos` E `preco_anuncio` — os dois. Chegando
          sem foto e sem preço de anúncio, o carro FISICAMENTE não consegue
          aparecer no site nem no catálogo antes de ele mexer. A conferência
          deixa de ser promessa e vira mecanismo: enquanto ele não fotografar
          o carro no pátio e pôr o preço DELE, ninguém de fora vê.

     🔴 E O PREÇO DA OUTRA LOJA NÃO VIRA O PREÇO DELE. Ele entra na tela como
     REFERÊNCIA, escrito do lado ("na Comauto está R$ 72.900"), e o campo do
     preço de anúncio nasce VAZIO. Preço de concorrente copiado pra dentro da
     própria loja é o tipo de dado que ninguém revisa depois.

     ⚠️ NADA DISSO CUSTA TOKEN (regra v585). Os dados já estão no índice do
     Mercado; trazer é copiar o que já foi lido. Quem quiser as fotos e a ficha
     completa usa o "Importar por link" que já existe no estoque, e lá o custo
     está escrito na tela.
     ========================================================================== */
  var MKD_BANDEJA_KEY='mev_mkd_bandeja';
  var MKD_BANDEJA_MAX=40;
  var _mkdBandeja={};
  /* \U0001f534 A BANDEJA GUARDA O CARRO INTEIRO, NÃO SÓ O NÚMERO DELE. Guardando só
     o id, marcar um carro e depois mudar o filtro faria o carro sumir da
     bandeja — ele deixaria de estar na lista carregada. O que foi escolhido
     não pode depender do que está à vista. */
  function mkdBandejaLer(){
    try{ var d=JSON.parse(localStorage.getItem(MKD_BANDEJA_KEY)||'{}'); _mkdBandeja=(d&&typeof d==='object')?d:{}; }
    catch(_){ _mkdBandeja={}; }
  }
  function mkdBandejaGravar(){
    try{ localStorage.setItem(MKD_BANDEJA_KEY, JSON.stringify(_mkdBandeja)); }catch(_){}
  }
  function mkdBandejaN(){ try{ return Object.keys(_mkdBandeja).length; }catch(_){ return 0; } }
  function mkdBandejaTem(id){ return !!_mkdBandeja[String(id)]; }
  function mkdBandejaCarros(){
    var l=[]; try{ Object.keys(_mkdBandeja).forEach(function(k){ l.push(_mkdBandeja[k]); }); }catch(_){}
    return l;
  }
  function mkdBandejaVira(id){
    id=String(id);
    if(_mkdBandeja[id]){ delete _mkdBandeja[id]; mkdBandejaGravar(); return true; }
    if(mkdBandejaN()>=MKD_BANDEJA_MAX){
      mkdMsg('A bandeja aguenta '+MKD_BANDEJA_MAX+' carros por vez. Traga esses primeiro.','err');
      return false;
    }
    var v=(_mkdVeics||[]).filter(function(x){ return String(x.id)===id; })[0];
    if(!v) return false;
    var l=((_mkdLojas||[]).filter(function(x){ return String(x.id)===String(v.loja_id); })[0])||{};
    _mkdBandeja[id]={ id:v.id, url:v.url||'', marca:v.marca||'', modelo:v.modelo||'', versao:v.versao||'',
      ano:v.ano||'', ano_modelo:v.ano_modelo||'', km:v.km||null, preco:v.preco||null,
      cambio:v.cambio||'', combustivel:v.combustivel||'', opcionais:v.opcionais||'',
      loja_nome:l.nome||'', loja_cidade:l.cidade||'' };
    mkdBandejaGravar(); return true;
  }
  function mkdBandejaTirar(id){ delete _mkdBandeja[String(id)]; mkdBandejaGravar(); }

  /* v700 — O TRAZER DIRETO. A BANDEJA NÃO MORREU (desligar mostrando o
     caminho, v568): quem ainda tem carros nela vê a barra e o "Conferir e
     trazer" funcionando até esvaziar — só a PORTA DE ENTRADA mudou: o botão
     do card não enche mais a bandeja, ele leva pro estoque com o link
     pronto. Pra voltar ao lote, é religar o onclick antigo do [data-add]. */
  function mkdTrazerDireto(id){
    var v=(_mkdVeics||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v || !v.url){ mkdMsg('Este carro está sem o link do anúncio.','err'); return; }
    try{ estAbrirFicha(null); }catch(_){ toast('Não consegui abrir o estoque.'); return; }
    var destino=$('efImportUrl'); if(destino){ destino.value=v.url; }
    var btn=$('efImportBtn'); if(btn){ try{ btn.focus(); }catch(_){} }
    toast('Link pronto no estoque — toque "Importar" pra trazer ficha e fotos ('+precoReal(1)+').');
  }

  var _mkdExclusoes=Object.create(null);
  function mkdExclusaoChave(id){return String(meuId)+':'+String(id);}
  function mkdExcluirContagem(delta){
    var conta=document.querySelector('#mkdRes .mkd-conta');if(!conta)return;
    var n=conta.firstChild;if(n&&n.nodeType===3){var atual=parseInt(n.textContent,10);if(!isNaN(atual))n.textContent=Math.max(0,atual+delta)+' veículo(s)';}
  }
  async function mkdExcluirDoIndice(id, bt){
    var chave=mkdExclusaoChave(id);if(_mkdExclusoes[chave])return;
    var v=(_mkdVeics||[]).filter(function(x){ return String(x.id)===String(id); })[0];
    if(!v) return;
    var nome=[v.marca,v.modelo,v.versao].filter(Boolean).join(' ')||'este veículo';
    if(!confirm('Excluir '+nome+' desta lista?\n\nSe o anúncio continuar ativo no site da loja, ele poderá aparecer novamente na próxima atualização.')) return;
    _mkdExclusoes[chave]='pending';
    var card=bt&&bt.closest('.mkd-card');
    if(bt){bt.disabled=true;bt.textContent='Excluindo…';}
    if(card){card.style.setProperty('display','none','important');mkdExcluirContagem(-1);}
    try{
      var r=await supa.from('mp_mercado_veiculos').delete()
        .eq('id',id).eq('user_id',meuId).select('id');
      if(r.error || !Array.isArray(r.data) || r.data.length!==1) throw (r.error||new Error('exclusão não confirmada'));
      _mkdVeics=(_mkdVeics||[]).filter(function(x){ return String(x.id)!==String(id); });
      _mkdExclusoes[chave]='done';
      _mkdReadCache=null;
      if(card)card.remove();
      toast('Veículo excluído da lista.');
    }catch(e){
      delete _mkdExclusoes[chave];
      if(card&&card.isConnected){card.style.removeProperty('display');mkdExcluirContagem(1);}
      else{mkdProcurar();}
      if(bt){ bt.disabled=false; bt.textContent='Excluir'; }
      toast('Não foi possível excluir. O veículo foi mantido na lista.');
    }
  }

  function mkdBandejaBarra(){
    var el=$('mkdBandeja'); if(!el) return;
    var n=mkdBandejaN();
    if(!n){ el.innerHTML=''; el.className='mkd-bandeja'; return; }
    el.className='mkd-bandeja on';
    el.innerHTML='<b>'+n+' carro'+(n===1?'':'s')+' pra trazer</b>'+
      '<button type="button" class="mkd-bd-ir" id="mkdBdIr">Conferir e trazer</button>'+
      '<button type="button" class="mkd-bd-x" id="mkdBdLimpa" aria-label="Esvaziar a bandeja">&#10005;</button>';
    var b=$('mkdBdIr'); if(b) b.onclick=mkdConferirAbrir;
    var x=$('mkdBdLimpa');
    if(x) x.onclick=function(){ _mkdBandeja={}; mkdBandejaGravar(); mkdBandejaBarra(); mkdProcurar(); };
  }

  /* ==========================================================================
     A CONFERÊNCIA — a tela do "de forma prévia"
     --------------------------------------------------------------------------
     🔑 TODO CAMPO É EDITÁVEL, e é esse o ponto: o índice leu o que a outra
     loja escreveu, e o que a outra loja escreve vem torto ("FIAT ARGO 1.8
     E.TORQ FLEX TREKKING AT6 1.8 E.TORQ FLEX TREKKING AT6"). Trazer sem deixar
     arrumar seria trocar digitação por faxina.

     🔴 E TEM CAMPO QUE NASCE VAZIO DE PROPÓSITO: a COR (o índice quase nunca
     traz) e o SEU PREÇO DE ANÚNCIO. Campo sem dado nasce vazio, nunca chutado
     (regra v450) — e preço de concorrente não é preço seu.
     ========================================================================== */
  var MKD_ORIGENS=[
    ['repasse','Repasse','Comprei de outro lojista.'],
    ['proprio','Próprio','A loja comprou o carro.'],
    ['consignado','Consignado','O carro é de outra pessoa.']
  ];
  var _mkdOrigem='repasse', _mkdTrazendo=false;
  /* ==========================================================================
     \U0001f534 v665 (pedido do Angelo, 26/08) — "ao clicar no trazer podia pegar o
     link e importar, ja tem isso pronto no estoque"
     --------------------------------------------------------------------------
     Ele está certo, e o "já tem isso pronto" é a parte importante: o
     `/api/importar-anuncio` existe desde a v199, foi endurecido na v653 e é
     ele que abre a página do anúncio, lê a ficha inteira e COPIA as fotos pra
     dentro do armazenamento DELE. O Mercado já tinha o link de cada carro na
     mão. Faltava só juntar as duas pontas.

     \U0001f511 REUSEI A FUNÇÃO DO SERVIDOR, NÃO A TELA. O `estImportarAnuncio` do
     estoque escreve direto nos campos da ficha aberta — ele é a cola de UMA
     tela, não o motor. O motor é o `/api/importar-anuncio`, e é ele que este
     lote chama. Uma porta só pra o mesmo trabalho (v390); duas telas, o mesmo
     servidor.

     \U0001f534\U0001f534 ISSO CUSTA TOKEN — 1 POR CARRO — E A REGRA v585 MANDA QUE CONSULTA
     PAGA NUNCA SAIA SOZINHA. Então: o botão diz o total ANTES ("Trazer 3 · 3
     tokens"), a linha de cima diz quanto ele tem, e existe um interruptor pra
     desligar e trazer só os dados de graça. Apertar o botão com o preço
     escrito nele é o consentimento — o mesmo desenho que a v654 usou no
     buscador de página.

     \u26a0\ufe0f A FICHA TÉCNICA POR IA (o SEGUNDO token) NÃO SAI AQUI. A conta
     prometida é 1 por carro, e promessa de tela tem que ser verdade. Quem
     quiser a ficha técnica gera pela aba dela, no carro.
     ========================================================================== */
  var MKD_IMPORT_MAX=10;      /* por vez: cada anúncio é uma página aberta de verdade */
  var _mkdComFotos=true;      /* o pedido dele: já vem ligado */

  function mkdConferirAbrir(){
    var lista=mkdBandejaCarros();
    if(!lista.length){ mkdMsg('A bandeja está vazia. Marque os carros com "+ Trazer".','err'); return; }
    var bg=cliModalEl();
    var t=$('cliMt'); if(t) t.textContent='Conferir e trazer';
    var av=$('cliMav'); if(av) av.textContent=String(lista.length);
    var body=$('cliMbody'); if(!body) return;
    body.innerHTML=mkdConferirHtml(lista);
    bg.classList.add('on');
    mkdConferirLigar();
  }

  function mkdConferirHtml(lista){
    return '<div class="mkd-cf-aviso">'+
        '<b>O carro entra sem o preço de anúncio.</b> Sem o <b>seu</b> preço ele não '+
        'aparece no seu site nem no catálogo — fica só no seu estoque, pra você conferir. '+
        'Botar o preço é o seu "pode publicar".'+
      '</div>'+
      '<label class="cad-lbl">Como esses carros entram na sua loja?</label>'+
      '<div class="ef-og" id="mkdOgChips">'+MKD_ORIGENS.map(function(o){
        return '<button type="button" class="ef-og-chip'+(_mkdOrigem===o[0]?' on':'')+'" '+
          'data-og="'+o[0]+'"><b>'+esc(o[1])+'</b><i>'+esc(o[2])+'</i></button>';
      }).join('')+'</div>'+
      '<div id="mkdCfLista">'+lista.map(mkdConferirCard).join('')+'</div>'+
      mkdCfImportHtml(lista.length)+
      '<div class="mkd-cf-msg" id="mkdCfMsg"></div>'+
      '<button type="button" class="cad-btn" id="mkdCfOk">'+mkdCfBotaoTxt(lista.length)+'</button>';
  }

  function mkdConferirCard(v){
    var i=String(v.id);
    var deOnde=[v.loja_nome||'Loja', v.loja_cidade||''].filter(Boolean).join(' · ');
    return '<div class="mkd-cf" data-id="'+esc(i)+'">'+
      '<div class="mkd-cf-hd">'+
        /* \U0001f534 DE ONDE VEIO FICA SEMPRE VISÍVEL, e não em letra miúda no fim:
           é ele quem decide o que vai pro site dele, e pra decidir precisa
           saber de quem é o carro. */
        '<span class="mkd-cf-de">veio de <b>'+esc(deOnde)+'</b></span>'+
        (v.url?('<a class="mkd-cf-ver" href="'+esc(v.url)+'" target="_blank" rel="noopener">ver anúncio</a>'):'')+
        '<button type="button" class="mkd-cf-x" data-tirar="'+esc(i)+'" aria-label="Tirar da lista">&#10005;</button>'+
      '</div>'+
      '<div class="cli-2col nb">'+
        '<div><label class="cad-lbl">Marca</label><input class="cad-in" data-c="marca" value="'+esc(v.marca||'')+'"></div>'+
        '<div><label class="cad-lbl">Modelo</label><input class="cad-in" data-c="modelo" value="'+esc(v.modelo||'')+'"></div>'+
      '</div>'+
      '<label class="cad-lbl">Versão</label><input class="cad-in" data-c="versao" value="'+esc(v.versao||'')+'">'+
      '<div class="cli-2col nb">'+
        '<div><label class="cad-lbl">Ano</label><input class="cad-in" data-c="ano" inputmode="numeric" value="'+esc(v.ano||'')+'"></div>'+
        '<div><label class="cad-lbl">Ano/modelo</label><input class="cad-in" data-c="ano_modelo" inputmode="numeric" value="'+esc(v.ano_modelo||'')+'"></div>'+
      '</div>'+
      '<div class="cli-2col nb">'+
        '<div><label class="cad-lbl">Km</label><input class="cad-in" data-c="km" inputmode="numeric" value="'+esc(v.km||'')+'"></div>'+
        '<div><label class="cad-lbl">Cor</label><input class="cad-in" data-c="cor" value="" placeholder="não veio no anúncio"></div>'+
      '</div>'+
      '<div class="cli-2col nb">'+
        '<div><label class="cad-lbl">Câmbio</label><input class="cad-in" data-c="cambio" value="'+esc(v.cambio||'')+'"></div>'+
        '<div><label class="cad-lbl">Combustível</label><input class="cad-in" data-c="combustivel" value="'+esc(v.combustivel||'')+'"></div>'+
      '</div>'+
      '<label class="cad-lbl">O <b>seu</b> preço de anúncio</label>'+
      '<input class="cad-in" data-c="preco_anuncio" inputmode="numeric" value="" placeholder="deixe vazio pra decidir depois">'+
      '<div class="mkd-cf-ref">'+(v.preco
        ? ('na '+esc(v.loja_nome||'loja de origem')+' está '+esc(_rs(v.preco))+' — isso é referência, não é o seu preço')
        : 'o anúncio não informa preço')+'</div>'+
    '</div>';
  }

  /* o interruptor da importação paga, com a conta na cara */
  function mkdCfImportHtml(n){
    var quantos=Math.min(n, MKD_IMPORT_MAX);
    var temSaldo=(typeof saldo!=='undefined')?Number(saldo||0):null;
    return '<div class="mkd-cf-imp'+(_mkdComFotos?' on':'')+'" id="mkdCfImp">'+
      '<label class="mkd-cf-sw">'+
        '<input type="checkbox" id="mkdCfFotos"'+(_mkdComFotos?' checked':'')+'>'+
        '<span><b>Trazer também as fotos e a ficha do anúncio</b>'+
        '<i>Abro o anúncio de cada carro, copio as fotos pro seu app e trago cor, '+
        'placa, opcionais e descrição. Custa <b>'+precoReal(1)+' por carro.</b></i></span>'+
      '</label>'+
      '<div class="mkd-cf-conta" id="mkdCfConta">'+
        /* 🔴 SALDO CURTO SE DIZ ANTES, NÃO NO MEIO. Descobrir que os tokens
           acabaram no sétimo carro é descobrir tarde: os seis primeiros já
           gastaram e o resto entrou torto sem ele saber por quê. */
        (!_mkdComFotos
          ? 'Sem custo: trago só o que já está no índice do Mercado — sem fotos.'
          : (temSaldo===0
            ? '<b>Você está sem saldo.</b> Os carros entram só com os dados, sem foto.'
            : ('Vai gastar <b>'+precoReal(quantos)+'</b>'+
               (temSaldo!=null?(' — você tem '+precoReal(temSaldo)+'.'):'.')+
               ((temSaldo!=null && temSaldo<quantos)
                 ? (' <b>Não dá pra todos:</b> o saldo cobre '+Math.floor(temSaldo)+' com foto; o restante entra só com os dados.')
                 : '')+
               (n>MKD_IMPORT_MAX?(' Trago '+MKD_IMPORT_MAX+' por vez; os outros ficam na bandeja.'):''))))+
      '</div>'+
    '</div>';
  }
  function mkdCfBotaoTxt(n){
    var quantos=Math.min(n, MKD_IMPORT_MAX);
    /* ⚠️ SEM SALDO, O BOTÃO NÃO PROMETE TOKEN. Ele não vai gastar nada — não
       tem o que gastar — e um botão que anuncia um preço que não será cobrado
       é tão ruim quanto um que esconde o preço que será. */
    var temSaldo=(typeof saldo!=='undefined')?Number(saldo||0):null;
    var vaiCobrar=_mkdComFotos && temSaldo!==0;
    return 'Trazer '+quantos+' pro meu estoque'+(vaiCobrar?(' · '+precoReal(quantos)):'');
  }
  function mkdCfImportPinta(){
    var n=document.querySelectorAll('#mkdCfLista .mkd-cf').length;
    var cx=$('mkdCfImp'); if(cx) cx.classList.toggle('on', _mkdComFotos);
    var c=$('mkdCfConta');
    if(c){
      var d=document.createElement('div'); d.innerHTML=mkdCfImportHtml(n);
      var novo=d.querySelector('#mkdCfConta'); if(novo) c.innerHTML=novo.innerHTML;
    }
    var b=$('mkdCfOk'); if(b) b.textContent=mkdCfBotaoTxt(n);
  }

  function mkdConferirLigar(){
    Array.prototype.forEach.call(document.querySelectorAll('#mkdOgChips .ef-og-chip'), function(b){
      b.onclick=function(){
        _mkdOrigem=b.getAttribute('data-og')||'repasse';
        Array.prototype.forEach.call(document.querySelectorAll('#mkdOgChips .ef-og-chip'), function(o){
          o.classList.toggle('on', o===b); });
      };
    });
    Array.prototype.forEach.call(document.querySelectorAll('#mkdCfLista [data-tirar]'), function(b){
      b.onclick=function(){
        mkdBandejaTirar(b.getAttribute('data-tirar'));
        mkdBandejaBarra();
        if(!mkdBandejaN()){ try{ cliModalFechar(); }catch(_){ } mkdProcurar(); return; }
        mkdConferirAbrir(); mkdProcurar();
      };
    });
    var sw=$('mkdCfFotos');
    if(sw) sw.onchange=function(){ _mkdComFotos=!!sw.checked; mkdCfImportPinta(); };
    var ok=$('mkdCfOk'); if(ok) ok.onclick=mkdTrazerConfirmar;
  }

  /* le de volta o que foi digitado na tela, carro por carro */
  function mkdConferirLer(){
    var out=[];
    Array.prototype.forEach.call(document.querySelectorAll('#mkdCfLista .mkd-cf'), function(c){
      var v=_mkdBandeja[String(c.getAttribute('data-id'))]; if(!v) return;
      var o=Object.assign({}, v);
      /* \U0001f511 GUARDO COMO O CAMPO CHEGOU. É isso que deixa saber, depois, se ele
         MEXEU no campo — e campo que ele mexeu ganha até do importador. */
      o._orig=Object.assign({}, v);
      Array.prototype.forEach.call(c.querySelectorAll('[data-c]'), function(i){
        o[i.getAttribute('data-c')]=String(i.value||'').trim(); });
      out.push(o);
    });
    return out;
  }

  /* ==========================================================================
     TRAZER — o único momento em que alguma coisa entra no estoque
     ========================================================================== */
  /* ==========================================================================
     A MESCLA — quem ganha quando o importador e o Angelo discordam
     --------------------------------------------------------------------------
     \U0001f511 QUEM MEXEU NO CAMPO GANHA. Se ele corrigiu "ARGO 1.8 E.TORQ FLEX
     TREKKING AT6 1.8 E.TORQ FLEX TREKKING AT6" pra "Argo", o importador não
     pode desfazer isso — ele leria a mesma página torta e escreveria o mesmo
     nome torto de volta.
     E onde ele NÃO mexeu, o importador manda: ele foi na página e viu coisa
     que o índice não tem (cor, opcionais, descrição, às vezes a placa).
     ========================================================================== */
  function mkdEscolhe(v, campo, doImport){
    var digitado=String(v[campo]==null?'':v[campo]).trim();
    var orig=String(((v._orig||{})[campo])==null?'':(v._orig||{})[campo]).trim();
    if(digitado && digitado!==orig) return digitado;          /* ele mexeu */
    var imp=String(doImport==null?'':doImport).trim();
    return imp || digitado;
  }

  /* abre UM anúncio pelo motor que o estoque já usa desde a v199 */
  async function mkdImportarUm(v){
    if(!v.url) return { ok:false, erro:'sem link do anúncio' };
    try{
      var r=await apiComTimeout('/api/importar-anuncio',{url:v.url},55000);
      if(r&&r.saldo!=null){ try{ setSaldo(r.saldo); }catch(_){ } }
      if(r&&r.sem_saldo) return { ok:false, semSaldo:true, erro:'sem saldo' };
      if(!r||!r.ok) return { ok:false, erro:((r&&r.erro)||'não consegui abrir o anúncio') };
      return { ok:true, r:r, d:(r.dados||{}) };
    }catch(e){ return { ok:false, erro:((e&&e.message)||'falhou') }; }
  }

  function mkdSoNumero(x){ var n=Number(String(x==null?'':x).replace(/[^0-9]/g,'')); return isFinite(n)&&n>0?n:null; }

  async function mkdTrazerConfirmar(){
    if(_mkdTrazendo) return;
    var lista=mkdConferirLer();
    if(!lista.length) return;
    /* \U0001f534 CARRO SEM MODELO NÃO ENTRA. O estoque exige placa OU modelo, e o
       Mercado nunca tem placa — sem modelo o carro viraria uma linha em branco
       no estoque de que ninguém lembraria a origem. */
    var semNome=lista.filter(function(v){ return !String(v.modelo||'').trim(); });
    if(semNome.length){
      mkdCfMsg('Tem '+semNome.length+' carro(s) sem modelo. Preencha o modelo ou tire da lista.','err');
      return;
    }
    _mkdTrazendo=true;
    var ok=$('mkdCfOk'); if(ok){ ok.disabled=true; ok.textContent='Trazendo…'; }
    mkdCfMsg('');
    try{
      /* \U0001f534 NÃO TRAZER O MESMO CARRO DUAS VEZES. A marca de origem que a v199
         já guardava (`extras.importacao_anuncio`) é a identidade: mesmo
         endereço de anúncio = mesmo carro. Sem isto, apertar duas vezes cria
         dois carros iguais no estoque e some com a confiança na tela. */
      var jaTem={};
      try{
        var r0=await supa.from('estoque').select('id, de:extras->importacao_anuncio->>url').limit(2000);
        if(r0 && !r0.error && r0.data) r0.data.forEach(function(x){ if(x&&x.de) jaTem[String(x.de)]=1; });
      }catch(_){ /* sem dedup: melhor trazer do que travar — o aviso sai abaixo */ }

      var repetidos=lista.filter(function(v){ return v.url && jaTem[String(v.url)]; });
      var novos=lista.filter(function(v){ return !(v.url && jaTem[String(v.url)]); });
      if(!novos.length){
        mkdCfMsg(repetidos.length===1
          ? 'Esse carro já está no seu estoque — veio do mesmo anúncio.'
          : 'Esses carros já estão no seu estoque — vieram dos mesmos anúncios.','err');
        _mkdTrazendo=false; if(ok){ ok.disabled=false; ok.textContent=mkdCfBotaoTxt(lista.length); }
        return;
      }

      var agora=new Date().toISOString();

      /* \u26a0\ufe0f COM FOTO, VAI DE POUCO EM POUCO. Cada anúncio é uma página aberta
         de verdade do outro lado — dez já são quase um minuto. O resto fica na
         bandeja, e a tela diz isso antes de começar. */
      var vaiAgora=_mkdComFotos ? novos.slice(0, MKD_IMPORT_MAX) : novos;
      var ficaPraDepois=novos.slice(vaiAgora.length);

      var regs=[], comFoto=0, falhas=[], semSaldo=false;
      for(var i=0;i<vaiAgora.length;i++){
        var v=vaiAgora[i];
        var imp=null;
        if(_mkdComFotos && !semSaldo){
          mkdCfMsg('Abrindo o anúncio '+(i+1)+' de '+vaiAgora.length+' — copiando as fotos…','load');
          var res=await mkdImportarUm(v);
          if(res.ok) imp=res;
          else {
            if(res.semSaldo){ semSaldo=true; }
            falhas.push(((v.modelo||'carro')+': '+(res.erro||'falhou')));
          }
        }
        var d=(imp&&imp.d)||{}, r1=(imp&&imp.r)||{};
        var fotos=(imp && Array.isArray(d.fotos)) ? d.fotos.slice(0,20) : [];
        if(fotos.length) comFoto++;
        regs.push({
          user_id:meuId, criado_em:agora, data_entrada:estHoje(),
          /* a placa só vem quando o servidor tem certeza dela (a regra da v653);
             sem certeza ele devolve vazio, e vazio é o que fica */
          placa:String(d.placa||''),
          marca:mkdEscolhe(v,'marca',d.marca), modelo:mkdEscolhe(v,'modelo',d.modelo),
          ano:String(mkdEscolhe(v,'ano',d.ano)||''), ano_modelo:String(mkdEscolhe(v,'ano_modelo',d.ano_modelo)||''),
          cor:String(mkdEscolhe(v,'cor',d.cor)||''),
          km:mkdSoNumero(mkdEscolhe(v,'km',d.km)),
          /* \U0001f534\U0001f534 O PREÇO DE ANÚNCIO **NUNCA** VEM DE FORA. Nem do índice, nem
             do importador — e o importador devolve um, tentador e pronto pra
             usar. Só entra o que o Angelo digitou. É o último cadeado: com as
             fotos vindo junto, o preço passou a ser a única coisa que segura o
             carro fora do site dele. Segurar é o serviço. */
          preco_anuncio:mkdSoNumero(v.preco_anuncio),
          preco_minimo:null, preco_compra:null,
          origem:_mkdOrigem, status:'disponivel',
          fotos:fotos,
          /* a descrição do anúncio vai pra observação, igual o importar por
             link já faz na ficha (v199) */
          obs:String(d.descricao||''),
          extras:{
            cambio:String(mkdEscolhe(v,'cambio',d.cambio)||''),
            combustivel:String(mkdEscolhe(v,'combustivel',d.combustivel)||''),
            opcionais:String(d.opcionais||v.opcionais||''),
            /* a mesma marca de origem que a v199 criou pro importar por link:
               um nome só pra cada coisa (v390) */
            importacao_anuncio:{ url:v.url||'', em:agora, via:'mercado',
              loja:v.loja_nome||'', preco_na_origem:v.preco||null,
              origem:String(r1.origem||''), fotos_importadas:Number(r1.fotos_importadas||0),
              custo_extracao:Number(r1.custo||(imp?1:0)),
              final_placa:String(d.final_placa||'') }
          }
        });
      }

      var r=await supa.from('estoque').insert(regs).select('id');
      if(r&&r.error) throw r.error;
      var n=(r&&r.data&&r.data.length)||regs.length;

      vaiAgora.forEach(function(v){ mkdBandejaTirar(v.id); });
      repetidos.forEach(function(v){ mkdBandejaTirar(v.id); });
      mkdBandejaBarra();

      var recado=n+' carro'+(n===1?'':'s')+' no seu estoque';
      recado+=comFoto?(', '+comFoto+' com foto'):', sem foto';
      recado+=' e sem preço de anúncio — confira e ponha o preço pra publicar.';
      if(repetidos.length) recado+=' ('+repetidos.length+' já estava'+(repetidos.length===1?'':'m')+' lá.)';
      if(ficaPraDepois.length) recado+=' '+ficaPraDepois.length+' ficaram na bandeja pra a próxima leva.';
      if(semSaldo) recado+=' O saldo acabou no meio — o restante entrou apenas com os dados.';
      else if(falhas.length) recado+=' '+falhas.length+' anúncio(s) não abriram; entraram só com os dados.';

      /* \U0001f511 SE SOBROU CARRO NA BANDEJA, A TELA CONTINUA ABERTA pra ele mandar a
         próxima leva sem ter que procurar tudo de novo. */
      if(ficaPraDepois.length){ mkdCfMsg(recado,'ok'); mkdConferirAbrir(); }
      else { try{ cliModalFechar(); }catch(_){} }
      toast(recado);
      mkdProcurar();
    }catch(e){
      mkdCfMsg('Não consegui trazer agora. '+((e&&e.message)||''),'err');
    }
    _mkdTrazendo=false;
    var ok2=$('mkdCfOk');
    if(ok2){ ok2.disabled=false; ok2.textContent=mkdCfBotaoTxt(document.querySelectorAll('#mkdCfLista .mkd-cf').length); }
  }
  function mkdCfMsg(t,tipo){ var e=$('mkdCfMsg'); if(!e) return; e.className='mkd-cf-msg'+(tipo?(' '+tipo):''); e.textContent=t||''; }

  /* ---- utilidades ---------------------------------------------------------- */
  function mkdMsg(t,tipo){ var e=$('mkdMsg'); if(!e) return; e.className='cad-msg'+(tipo?(' '+tipo):''); e.textContent=t||''; }
  function mkdDominio(u){ try{ return new URL(u).hostname.replace(/^www\./,''); }catch(_){ return String(u||''); } }
  function mkdQuando(iso){
    try{
      var d=new Date(iso); if(isNaN(d)) return '—';
      var hoje=new Date(); var mesmoDia=d.toDateString()===hoje.toDateString();
      var hh=String(d.getHours()).padStart(2,'0')+':'+String(d.getMinutes()).padStart(2,'0');
      if(mesmoDia) return 'hoje '+hh;
      return d.toLocaleDateString('pt-BR')+' '+hh;
    }catch(_){ return '—'; }
  }

/* ╔═══ src/app/19-documentos-e-init.js ═══════════════════════════════════ */
  /* ================= DOCUMENTOS (TRV / PCP / Procuração) ================= */
  var ICO_DOC='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>';
  async function lojaGet(){ if(_lojaRec) return _lojaRec; try{ var r=await supa.from('loja').select('*').limit(1); _lojaRec=(r&&r.data&&r.data[0])||null; }catch(_){} return _lojaRec; }
  function dataExtenso(cidade){ var meses=['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro']; var d=new Date(); return (cidade?cidade+', ':'')+d.getDate()+' de '+meses[d.getMonth()]+' de '+d.getFullYear(); }
  function docGet(id){ var e=$(id); return e?(e.value||'').trim():''; }
  function docsPaineisHtml(d){ d=d||{};
    function inp(id,lb,val,ph,extra){ return '<label class="cad-lbl">'+lb+'</label><input class="cad-in" id="'+id+'" value="'+esc(val||'')+'" placeholder="'+esc(ph||'')+'"'+(extra||'')+'>'; }
    function col2(a,b){ return '<div class="cli-2col"><div>'+a+'</div><div>'+b+'</div></div>'; }
    var cnh='<div class="vpx-panel" data-panel="cnh">'+
      '<div class="doc-hint">Anexe a CNH que eu leio os dados sozinho — ou preencha à mão. Confira tudo antes de gerar.</div>'+
      '<div class="doc-ia"><button type="button" class="doc-iabtn" id="docIaCnh">📷 Anexar CNH — leitura automática</button></div>'+
      inp('docNome','Nome',d.nome,'Nome completo')+
      col2(inp('docCpf','CPF',d.cpf,'000.000.000-00'),inp('docRg','RG',d.rg,'RG'))+
      inp('docCnh','CNH',d.cnh,'Nº de registro da CNH (opcional)')+
      col2(inp('docTel','Telefone *',d.tel,'(00) 00000-0000'),inp('docEmail','E-mail *',d.email,'email@exemplo.com',' inputmode="email"'))+
      '</div>';
    var ende='<div class="vpx-panel" data-panel="endereco">'+
      '<div class="doc-hint">Anexe o comprovante de residência que eu puxo o endereço do cliente.</div>'+
      '<div class="doc-ia"><button type="button" class="doc-iabtn" id="docIaRes">📷 Anexar comprovante — leitura automática</button></div>'+
      inp('docCep','CEP',d.cep,'00000-000')+
      inp('docRua','Rua',d.rua,'Logradouro')+
      col2(inp('docNr','Número',d.nr,'Nº'),inp('docBairro','Bairro',d.bairro,'Bairro'))+
      col2(inp('docCidade','Cidade',d.cidade,'Cidade'),inp('docUf','UF',d.uf,'UF',' maxlength="2"'))+
      '</div>';
    var veic='<div class="vpx-panel" data-panel="veiculo">'+
      '<div class="doc-hint">Anexe o CRLV que eu leio o veículo. A quilometragem e o valor entram nos documentos.</div>'+
      '<div class="doc-ia"><button type="button" class="doc-iabtn" id="docIaCrlv">📷 Anexar CRLV — leitura automática</button></div>'+
      inp('docMarca','Marca / modelo',d.marca,'Ex.: VW - VolksWagen Fox')+
      col2(inp('docModelo','Modelo',d.modelo,'Modelo'),inp('docEspecie','Espécie',d.especie,'Ex.: Passageiro'))+
      col2(inp('docPlaca','Placa',d.placa,'ABC1D23',' style="text-transform:uppercase"'),inp('docCor','Cor',d.cor,'Cor'))+
      inp('docChassi','Chassi',d.chassi,'Nº do chassi')+
      col2(inp('docRenavam','Renavam',d.renavam,'Renavam'),inp('docKm','Quilometragem *',d.km,'KM rodados'))+
      col2(inp('docAnoFab','Ano fabricação',d.ano_fab,'2020'),inp('docAnoMod','Ano modelo',d.ano_mod,'2021'))+
      col2(inp('docComb','Combustível',d.comb,'Flex'),inp('docDetran','Cidade DETRAN',d.detran_cid,'Cidade do emplacamento'))+
      inp('docValor','Valor que entrou na negociação *',d.valor,'R$ 0,00')+
      '</div>';
    var gerar='<div class="vpx-panel" data-panel="gerar">'+
      '<div id="docRepBadge"></div>'+
      inp('docCidadeData','Cidade (da data do documento)',d.cidadeData,'Torres')+
      '<div class="doc-btns">'+
        '<button type="button" class="doc-b" id="docTrv"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></svg><span class="db-t">TRV</span><span class="db-s">Termo de venda</span></button>'+
        '<button type="button" class="doc-b" id="docPcp"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h5M8 17h3"/></svg><span class="db-t">PCP</span><span class="db-s">Causa própria</span></button>'+
        '<button type="button" class="doc-b" id="docProc"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M12 18l6-6 2 2-6 6h-2z"/></svg><span class="db-t">Procuração</span><span class="db-s">Padrão</span></button>'+
      '</div>'+
      '<div class="cad-msg" id="docMsg" style="text-align:center">Gera um PDF pronto pra imprimir/assinar. Cada documento novo custa '+precoReal(1)+'; baixar novamente um documento salvo é grátis.</div>'+
      '</div>';
    var gerados='<div class="vpx-panel" data-panel="gerados">'+
      '<div class="doc-hint">Tudo o que você já gerou, guardado por cliente. Toque na miniatura pra baixar de novo — sem nova cobrança.</div>'+
      '<div class="cli-search" style="margin-bottom:12px">'+_icoBusca+'<input id="dcGerBusca" placeholder="Buscar cliente ou placa" autocomplete="off"></div>'+
      '<div id="dcGerados"></div>'+
      '</div>';
    return { cnh:cnh, endereco:ende, veiculo:veic, gerar:gerar, gerados:gerados };
  }
  /* aba GERADOS: histórico dos documentos por cliente (miniaturas) */
  var _docsGerados=[];
  async function docsGeradosPinta(){
    var el=$('dcGerados'); if(!el) return;
    el.innerHTML='<div class="cli-empty" style="padding:12px">Carregando…</div>';
    var rows=[]; try{ var r=await withTimeout(supa.from('cliente_documento').select('id,cliente_id,tipo,nome,dados,criado_em').order('criado_em',{ascending:false}).limit(400),9000); rows=(r&&r.data)||[]; }catch(_){}
    _docsGerados=rows;
    try{ if(!(_clientes&&_clientes.length)) await cliCarregar(); }catch(_){}
    docsGeradosLista((($('dcGerBusca')||{}).value)||'');
  }
  function docsGeradosLista(termo){
    var el=$('dcGerados'); if(!el) return;
    termo=String(termo||'').trim().toLowerCase();
    function nomeCli(cid, rc){ var c=(_clientes||[]).filter(function(x){ return String(x.id)===String(cid); })[0]; return (c&&c.nome)||((rc.dados&&rc.dados.nome)||'Cliente'); }
    var rows=(_docsGerados||[]);
    if(termo) rows=rows.filter(function(rc){ return (nomeCli(rc.cliente_id,rc)+' '+(rc.nome||'')+' '+((rc.dados&&rc.dados.placa)||'')).toLowerCase().indexOf(termo)>=0; });
    if(!rows.length){ el.innerHTML='<div class="cli-empty"><b>Nenhum documento '+(termo?'encontrado':'gerado ainda')+'</b>Os TRV, PCP e procurações que você gerar ficam guardados aqui, por cliente.</div>'; return; }
    var grupos={}, ordem=[];
    rows.forEach(function(rc){ var k=String(rc.cliente_id||'sem'); if(!grupos[k]){ grupos[k]=[]; ordem.push(k); } grupos[k].push(rc); });
    var TIP={trv:'TRV',pcp:'PCP',procuracao:'Procuração'};
    el.innerHTML=ordem.map(function(k){
      var g=grupos[k], nm=nomeCli(g[0].cliente_id,g[0]);
      return '<div class="dg-cli"><div class="dg-cli-h"><div class="dg-av">'+esc(cliIni(nm))+'</div><div class="dg-nm">'+esc(nm)+'</div></div><div class="dg-docs">'+
        g.map(function(rc){ var dt=''; try{ dt=new Date(rc.criado_em).toLocaleDateString('pt-BR'); }catch(_){}
          return '<div class="dg-doc" data-id="'+esc(rc.id)+'"><div class="dg-doc-ic">📄</div><div class="dg-doc-t">'+esc(TIP[rc.tipo]||rc.tipo||'Documento')+'</div><div class="dg-doc-s">'+esc(String((rc.dados&&rc.dados.placa)||'').toUpperCase())+(dt?((rc.dados&&rc.dados.placa)?' · ':'')+dt:'')+'</div><div class="dg-doc-dl">Baixar de novo ↓</div></div>'; }).join('')+
        '</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.dg-doc'),function(cardEl){ cardEl.onclick=function(){ var rc=(_docsGerados||[]).filter(function(x){ return String(x.id)===String(cardEl.getAttribute('data-id')); })[0]; if(rc) docRebaixar(rc); }; });
  }
  function docMontaD(){
    var marca=docGet('docMarca');
    return { nome:docGet('docNome'), cpf:docGet('docCpf'), rg:docGet('docRg'), cnh:docGet('docCnh'),
      rua:docGet('docRua'), nr:docGet('docNr'), bairro:docGet('docBairro'), cidade:docGet('docCidade'), cidade_simples:docGet('docCidade'), uf:docGet('docUf'), cep:docGet('docCep'), tel:docGet('docTel'), email:docGet('docEmail'),
      marca:marca, marca_curta:(marca.split(/[\s-]+/)[0]||marca), modelo:docGet('docModelo')||marca, especie:docGet('docEspecie'), placa:docGet('docPlaca'), cor:docGet('docCor'), chassi:docGet('docChassi'),
      ano_fab:docGet('docAnoFab'), ano_mod:docGet('docAnoMod')||docGet('docAnoFab'), comb:docGet('docComb'), renavam:docGet('docRenavam'), km:docGet('docKm'),
      valor:docGet('docValor'), detran_cid:docGet('docDetran'), data:dataExtenso(docGet('docCidadeData')),
      rep:_docRep, rodape:_docRodape() };
  }
  /* dados da parte que recebe (outorgado): a LOJA (PJ) */
  function _repFromLoja(l){ l=l||{}; return {
    artigo:'a empresa', docTipo:'CNPJ', doc:l.cnpj||'', nome:(l.razao_social||l.nome_fantasia||''),
    endereco:[l.rua,(l.numero?'Nº '+l.numero:''),l.bairro].filter(Boolean).join(', '),
    cidade:l.cidade||'', uf:l.uf||'',
    representada:(l.procurador_nome?('neste ato representada por '+l.procurador_nome+(l.procurador_cpf?', CPF '+l.procurador_cpf:'')):'') }; }
  /* ...ou o PROCURADOR (PF) */
  function _repFromProc(l){ l=l||{}; return {
    artigo:'o(a) Sr(a).', docTipo:'CPF', doc:l.procurador_cpf||'', rg:l.procurador_rg||'', nome:(l.procurador_nome||''),
    endereco:[l.rua,(l.numero?'Nº '+l.numero:''),l.bairro].filter(Boolean).join(', '),
    cidade:l.cidade||'', uf:l.uf||'', representada:'' }; }
  /* rodapé do PDF a partir da loja configurada (senão cai no padrão Santa Luzia) */
  function _docRodape(){ var l=_docLoja; if(!l) return null; return {
    nome:(l.nome_fantasia||l.razao_social||''),
    endereco:[l.rua,(l.numero?'Nº '+l.numero:''),l.bairro,l.cidade,l.uf].filter(Boolean).join(', '),
    site:(l.instagram?('@'+String(l.instagram).replace(/^@/,'')):''),
    tel:l.telefone||'', wa:(l.whatsapp?('WhatsApp '+l.whatsapp):''), email:l.email||'' }; }
  /* SEMPRE pergunta se o documento sai em nome de Pessoa JURÍDICA (a loja/CNPJ)
     ou Pessoa FÍSICA (o procurador/CPF cadastrado em Minha Loja). */
  function docEscolherRep(cb){
    var l=_docLoja||{};
    var temProc=!!(l.procurador_nome && (l.procurador_cpf||l.procurador_rg));
    var ov=document.createElement('div'); ov.className='cropmask';
    ov.innerHTML='<div class="cropbox" style="max-width:334px">'+
      '<div class="crop-tit">Gerar em nome de:</div>'+
      '<div class="crop-sub">O documento vai sair no nome de uma pessoa jurídica ou de uma pessoa física?</div>'+
      '<div style="display:flex;flex-direction:column;gap:10px;margin-top:6px">'+
        '<button type="button" class="crop-ok" id="drLoja" style="text-align:left;padding:14px 15px">🏢 Pessoa Jurídica<div style="font-size:11px;font-weight:600;opacity:.85;margin-top:2px">'+esc(l.razao_social||l.nome_fantasia||'Minha loja')+' · CNPJ '+esc(l.cnpj||'—')+'</div></button>'+
        '<button type="button" class="crop-c" id="drProc" style="text-align:left;padding:14px 15px">👤 Pessoa Física<div style="font-size:11px;font-weight:600;opacity:.7;margin-top:2px">'+(temProc?(esc(l.procurador_nome)+' · CPF '+esc(l.procurador_cpf||'—')):'Cadastre o procurador em Minha Loja')+'</div></button>'+
      '</div>'+
      '<button type="button" class="link" id="drCancel" style="margin-top:12px;width:100%">Cancelar</button>'+
      '</div>';
    document.body.appendChild(ov);
    function close(){ try{ ov.remove(); }catch(_){} }
    ov.querySelector('#drLoja').onclick=function(){ _docRep=_repFromLoja(l); close(); cb(); };
    ov.querySelector('#drProc').onclick=function(){ if(!temProc){ toast('Cadastre o procurador (nome + CPF) em Minha Loja para gerar em nome de pessoa física.'); return; } _docRep=_repFromProc(l); close(); cb(); };
    ov.querySelector('#drCancel').onclick=close;
  }
  /* Faixa no topo do formulário mostrando em nome de QUEM o documento vai sair (com "trocar") */
  function docsRepBadge(){
    var el=$('docRepBadge'); if(!el) return;
    if(_docRep){
      var pj=(_docRep.docTipo==='CNPJ');
      el.innerHTML='<div class="doc-rep">'+(pj?'🏢':'👤')+' Gerar em nome de: <b>'+esc(_docRep.nome||'—')+'</b> · '+esc(_docRep.docTipo||'')+' '+esc(_docRep.doc||'—')+' <button type="button" class="link" id="docRepTrocar">trocar</button></div>';
    } else {
      el.innerHTML='<div class="doc-rep pend">⚠ Falta escolher em nome de quem sai o documento. <button type="button" class="link" id="docRepTrocar">escolher</button></div>';
    }
    var b=$('docRepTrocar'); if(b) b.onclick=function(){ docEscolherRep(function(){ docsRepBadge(); }); };
  }
  /* valida os campos obrigatórios antes de gerar: telefone, e-mail, KM e valor */
  function docValida(){
    var reqs=[['docTel','Telefone'],['docEmail','E-mail'],['docKm','Quilometragem'],['docValor','Valor do veículo']];
    var faltando=[], primeiro=null;
    reqs.forEach(function(c){ var e=$(c[0]); var v=e?(e.value||'').trim():''; if(!v){ faltando.push(c[1]); if(e){ e.classList.add('doc-req-err'); if(!primeiro) primeiro=e; } } else if(e){ e.classList.remove('doc-req-err'); } });
    var em=docGet('docEmail');
    if(em && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)){ faltando.push('E-mail válido'); var ee=$('docEmail'); if(ee){ ee.classList.add('doc-req-err'); if(!primeiro) primeiro=ee; } }
    var m=$('docMsg');
    if(faltando.length){ if(m){ m.className='cad-msg err'; m.textContent='Preencha: '+faltando.join(', ')+'.'; } if(primeiro){ try{ var _pn=primeiro.closest('.vpx-panel'); if(_pn && !_pn.classList.contains('on')){ _docTab=_pn.getAttribute('data-panel'); docsTabAplica(); } }catch(_){} try{ primeiro.scrollIntoView({behavior:'smooth',block:'center'}); primeiro.focus(); }catch(_){} } return false; }
    if(m){ m.className='cad-msg'; m.textContent='Gera um PDF pronto pra imprimir/assinar.'; }
    return true;
  }
  /* Cada PDF novo custa 1 token. O histórico continua gratuito para que o
     usuário possa baixar novamente um documento já gerado. */
  async function docCobrar(){
    var d = await api('/api/creditos',{acao:'gastar', qtd:1});
    if(d && d.ok){ setSaldo(d.saldo); return true; }
    if(d && d.sem_saldo){ setSaldo(d.saldo); abrirPacotes(); return false; }
    return false;
  }
  async function docBaixar(tipo, nome){
    if(!_mevPdfPronto(function(){ docBaixar(tipo,nome); },true)) return;
    var m=$('docMsg'); if(m){ m.className='cad-msg'; m.textContent='Gerando PDF...'; }
    var _dados=docMontaD();
    try{
      var blob=await window.MEV_DOCPDF.gerar(tipo, _dados, nome);
      if(!blob){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui gerar o PDF.'; } return; }
      /* Só cobra quando o documento já está pronto. */
      var pago=await docCobrar();
      if(!pago){ if(m){ m.className='cad-msg err'; m.textContent='É necessário '+precoReal(1)+' de saldo para gerar este documento.'; } return; }
      var url=URL.createObjectURL(blob), a=document.createElement('a');
      a.href=url; a.download=nome+'.pdf'; document.body.appendChild(a); a.click();
      setTimeout(function(){ URL.revokeObjectURL(url); a.remove(); }, 800);
      /* guarda uma cópia no cadastro do cliente pra baixar de novo depois
         (se não houver cliente vinculado, cria o cadastro automaticamente) */
      docSalvarCopia(tipo, nome, _dados).then(function(cid){
        if(m){ m.className='cad-msg ok'; m.textContent='PDF gerado ✓'+(cid?' · cópia salva no cliente':''); }
        try{ if($('dcGerados')) docsGeradosPinta(); }catch(_){}
      });
      toast('PDF gerado.');
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Falha ao gerar. '+((e&&e.message)||''); } }
  }
  var _DOC_LABEL={ trv:'TRV — Termo de venda', pcp:'PCP — Causa própria', procuracao:'Procuração' };
  /* garante um cliente_id: usa o vinculado; senão cria o cadastro do cliente
     com os dados preenchidos no formulário (deduplica pelo CPF). */
  async function docEnsureCliente(){
    if(_docClienteId) return _docClienteId;
    if(!meuId || !window.supa) return null;
    var nome=docGet('docNome'); if(!nome) return null;   /* sem nome não dá pra cadastrar */
    var cpf=docGet('docCpf');
    try{ if(cpf){ var rf=await withTimeout(supa.from('clientes').select('id').eq('cpf',cpf).limit(1),8000); if(rf&&rf.data&&rf.data[0]){ _docClienteId=rf.data[0].id; return _docClienteId; } } }catch(_){}
    var reg={ user_id:meuId, nome:nome, telefone:docGet('docTel'), email:docGet('docEmail'), cpf:cpf, rg:docGet('docRg'),
      cep:docGet('docCep'), rua:docGet('docRua'), numero:docGet('docNr'), bairro:docGet('docBairro'), cidade:docGet('docCidade'), uf:docGet('docUf') };
    try{ var r=await withTimeout(supa.from('clientes').insert(reg).select('id').single(),9000); if(r&&r.data&&r.data.id){ _docClienteId=r.data.id; try{ await cliCarregar(); }catch(_){} toast('Cadastro do cliente criado automaticamente.'); return _docClienteId; } }catch(_){}
    return null;
  }
  /* salva os dados do documento gerado, ligado ao cliente, pra regerar/baixar depois */
  async function docSalvarCopia(tipo, nome, dados){
    if(!meuId || !window.supa) return null;
    var cid=await docEnsureCliente();
    if(!cid) return null;
    try{ await supa.from('cliente_documento').insert({ user_id:meuId, cliente_id:cid, tipo:tipo, nome:nome, dados:dados }); }catch(_){}
    return cid;
  }
  /* regera o PDF a partir dos dados salvos e baixa (não gasta token de novo) */
  function docRebaixar(rec){
    if(!_mevPdfPronto(function(){ docRebaixar(rec); },true)) return;
    var nome=rec.nome||('Documento-'+(rec.tipo||''));
    try{
      window.MEV_DOCPDF.gerar(rec.tipo, rec.dados||{}, nome).then(function(blob){
        if(!blob){ toast('Não consegui gerar o PDF.'); return; }
        var url=URL.createObjectURL(blob), a=document.createElement('a');
        a.href=url; a.download=nome+'.pdf'; document.body.appendChild(a); a.click();
        setTimeout(function(){ URL.revokeObjectURL(url); a.remove(); }, 800);
        toast('PDF gerado.');
      });
    }catch(e){ toast('Falha ao gerar. '+((e&&e.message)||'')); }
  }
  function _dset(id,val){ val=(val==null?'':String(val)).trim(); if(!val) return; var e=$(id); if(e){ e.value=val; e.classList.add('ia-ok'); } }
  function docsWire(){
    /* ==== Leitura de documentos por IA (OCR) ==== */
    var bCnh=$('docIaCnh'); if(bCnh) bCnh.onclick=function(){ if(!window.MEV_IA){ _iaAcao(function(){ bCnh.click(); }); return; } window.MEV_IA.importarCNH(function(dados){ if(!dados) return;
      _dset('docNome',(dados.nome||'').toUpperCase()); _dset('docCpf',dados.cpf); _dset('docRg',[dados.rg,dados.rg_orgao_emissor].filter(Boolean).join(' ')); _dset('docCnh',dados.numero_registro); toast('CNH lida — confira os dados.'); }); };
    var bRes=$('docIaRes'); if(bRes) bRes.onclick=function(){ if(!window.MEV_IA){ _iaAcao(function(){ bRes.click(); }); return; } window.MEV_IA.importarResidencia(function(dados){ if(!dados) return; var end=dados.endereco||{};
      if(!($('docNome')||{}).value && dados.titular_nome) _dset('docNome',(dados.titular_nome||'').toUpperCase());
      _dset('docCep',end.cep); _dset('docRua',(end.logradouro||'').toUpperCase()); _dset('docNr',end.numero); _dset('docBairro',(end.bairro||'').toUpperCase()); _dset('docCidade',(end.cidade||'').toUpperCase()); _dset('docUf',end.uf); toast('Endereço extraído.'); }); };
    var bCrlv=$('docIaCrlv'); if(bCrlv) bCrlv.onclick=function(){ if(!window.MEV_IA){ _iaAcao(function(){ bCrlv.click(); }); return; } window.MEV_IA.importarCRLV(function(dados){ if(!dados) return;
      _dset('docMarca',[dados.marca,dados.modelo].filter(Boolean).join(' ').toUpperCase()); _dset('docModelo',(dados.modelo||'').toUpperCase()); _dset('docPlaca',(dados.placa||'').toUpperCase()); _dset('docCor',(dados.cor||'').toUpperCase()); _dset('docComb',(dados.combustivel||'').toUpperCase()); _dset('docAnoFab',dados.ano_fabricacao); _dset('docAnoMod',dados.ano_modelo); _dset('docRenavam',dados.renavam); _dset('docChassi',(dados.chassi||'').toUpperCase()); _dset('docEspecie',(dados.tipo_veiculo||'AUTOMOVEL').toUpperCase());
      var pr=dados.proprietario||{}; if(pr.nome && !($('docNome')||{}).value){ _dset('docNome',(pr.nome||'').toUpperCase()); _dset('docCpf',pr.cpf_cnpj); } toast('CRLV lido — confira os dados.');
      _docValorAuto(dados.placa, _docClienteId); }); };
    var pl=$('docPlaca'); if(pl){ pl.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7); };
      pl.onblur=function(){ if(this.value.length===7) _docValorAuto(this.value, _docClienteId); }; }
    /* A pergunta PJ/PF já foi feita NA ABERTURA do modal — aqui só pergunta de novo se o usuário cancelou */
    function _comRep(fn){ if(_docRep){ fn(); } else docEscolherRep(function(){ docsRepBadge(); fn(); }); }
    var t=$('docTrv'); if(t) t.onclick=function(){ if(!docValida()) return; _comRep(function(){ docBaixar('trv','TRV-'+(docGet('docPlaca')||'veiculo')); }); };
    var p=$('docPcp'); if(p) p.onclick=function(){ if(!docValida()) return; _comRep(function(){ docBaixar('pcp','PCP-'+(docGet('docPlaca')||'veiculo')); }); };
    var pr=$('docProc'); if(pr) pr.onclick=function(){ if(!docValida()) return; _comRep(function(){ docBaixar('procuracao','Procuracao-'+(docGet('docPlaca')||'veiculo')); }); };
  }
  /* Valor com que o veículo ENTROU NA NEGOCIAÇÃO (venda salva) — senão, preço do anúncio no estoque */
  async function _docValorNegociacao(placa, clienteId){
    var pl=String(placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    try{
      if(!(_vendas&&_vendas.length)) await vendaCarregar();
      var vs=(_vendas||[]).filter(function(x){
        if(!x||!x.valor_venda) return false;
        if(pl) return String(x.placa||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===pl;
        return clienteId && String(x.cliente_id||'')===String(clienteId);
      });
      if(vs.length) return { valor:+vs[0].valor_venda||0, origem:'negociação' }; /* _vendas já vem da mais recente pra mais antiga */
    }catch(_){}
    try{
      if(pl){
        if(!(_estoque&&_estoque.length)) await estCarregar();
        var e=(_estoque||[]).filter(function(x){ return String((x&&x.placa)||'').toUpperCase().replace(/[^A-Z0-9]/g,'')===pl; })[0];
        if(e && +e.preco_anuncio) return { valor:+e.preco_anuncio, origem:'anúncio do estoque' };
      }
    }catch(_){}
    return null;
  }
  async function _docValorAuto(placa, clienteId){
    var el=$('docValor'); if(!el || (el.value||'').trim()) return;
    var r=await _docValorNegociacao(placa, clienteId);
    if(!r || !r.valor) return;
    var el2=$('docValor'); if(!el2 || (el2.value||'').trim()) return; /* re-checa: o modal pode ter mudado */
    el2.value=brl(r.valor); el2.classList.add('ia-ok');
    var m=$('docMsg'); if(m) m.textContent='Valor puxado da '+r.origem+' ('+brl(r.valor)+'). Ajuste se precisar.';
  }
  var _docVoltar=null, _docTab='cnh';
  function docsTabAplica(){
    Array.prototype.forEach.call(document.querySelectorAll('#dcBody .vpx-panel'),function(pn){ pn.classList.toggle('on', pn.getAttribute('data-panel')===_docTab); });
    Array.prototype.forEach.call(document.querySelectorAll('#dcTabs .vpx-st'),function(b){ var on=b.getAttribute('data-step')===_docTab; b.classList.toggle('on', on); if(on){ _tabCentra(b.parentNode, b); } });
  }
  function docsFechar(){ document.body.classList.remove('venda-cot'); var f=_docVoltar; _docVoltar=null; if(f){ f(); } else voltarHome(); }
  async function docsAbrir(pref, voltar){
    pref=pref||{};
    _docVoltar=(typeof voltar==='function')?voltar:null;
    _docTab='cnh';
    var _DC_ICO={
      cnh:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="8.5" cy="11" r="2.5"/><path d="M4.7 18a4 4 0 0 1 7.6 0"/><line x1="14.5" y1="9.5" x2="19.5" y2="9.5"/><line x1="14.5" y1="13.5" x2="19.5" y2="13.5"/></svg>',
      endereco:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
      veiculo:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2v-3.34a1 1 0 0 0-.84-.99L16 12l-2.36-3.15a2 2 0 0 0-1.6-.85H6.28a2 2 0 0 0-1.79 1.11L3 12l-1 .5V17h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>',
      gerar:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>',
      gerados:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>'
    };
    var _tabs=[['cnh','CNH'],['endereco','Endereço'],['veiculo','Veículo'],['gerar','Gerar'],['gerados','Gerados']];
    var _nav=_tabs.map(function(t){ return '<button type="button" class="vpx-st" data-step="'+t[0]+'"><span class="vpx-ico">'+_DC_ICO[t[0]]+'</span><span class="vpx-nm">'+t[1]+'</span></button>'; }).join('');
    mevTabSet(''); document.body.classList.add('venda-cot');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>Gerar documentos</h2>'+
      '<div class="vpx"><div class="vpx-steps" id="dcTabs">'+_nav+'</div><div class="vpx-body cad-float" id="dcBody"><div class="cli-empty" style="padding:16px">Carregando...</div></div></div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(docsFechar);
    Array.prototype.forEach.call(document.querySelectorAll('#dcTabs .vpx-st'),function(b){ b.onclick=function(){ _docTab=b.getAttribute('data-step'); docsTabAplica(); }; });
    var cli=null; if(pref.cliente_id){ if(!(_clientes&&_clientes.length)) await cliCarregar(); cli=(_clientes||[]).filter(function(x){return String(x.id)===String(pref.cliente_id);})[0]||null; }
    var loja=await lojaGet(); var v=veiculoAtual||{}; _docLoja=loja||null; _docRep=null; _docClienteId=pref.cliente_id||(cli&&cli.id)||null;
    var d={
      nome:(cli&&cli.nome)||'', cpf:(cli&&cli.cpf)||'', rg:(cli&&cli.rg)||'', cnh:'',
      rua:(cli&&cli.rua)||'', nr:(cli&&cli.numero)||'', bairro:(cli&&cli.bairro)||'', cidade:(cli&&cli.cidade)||'', uf:(cli&&cli.uf)||'', cep:(cli&&cli.cep)||'', tel:(cli&&cli.telefone)||'', email:(cli&&cli.email)||'',
      marca:pref.marca||'', modelo:pref.marca||'', placa:pref.placa||'', cor:pref.cor||'', chassi:pref.chassi||'', renavam:pref.renavam||'',
      ano_fab:pref.ano||'', ano_mod:pref.ano_mod||pref.ano||'', especie:pref.especie||'', comb:pref.comb||'',
      km:pref.km||'', valor:(pref.valor?brl(pref.valor):''), detran_cid:(cli&&cli.cidade)||(loja&&loja.cidade)||'', cidadeData:(loja&&loja.cidade)||(cli&&cli.cidade)||'Torres'
    };
    var body=$('dcBody'); if(!body) return;   /* usuário saiu da tela enquanto carregava */
    var pp=docsPaineisHtml(d);
    body.innerHTML=pp.cnh+pp.endereco+pp.veiculo+pp.gerar+pp.gerados;
    docsTabAplica();
    docsWire();
    docsRepBadge();
    docsGeradosPinta();
    var gb=$('dcGerBusca'); if(gb) gb.oninput=function(){ docsGeradosLista(this.value); };
    /* Pergunta "Gerar em nome de:" JÁ NA ABERTURA — antes de preencher os dados */
    docEscolherRep(function(){ docsRepBadge(); });
    /* Valor com que o veículo entrou na negociação (se o campo veio vazio) */
    if(!d.valor) _docValorAuto(pref.placa||d.placa, _docClienteId);
  }
  /* ================= LOJISTAS DE REPASSE (parceiros que compram) ================= */
  var _repasses=[], _repEditId=null;
  var ICO_REP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M18 8l2 2 3-3"/></svg>';
  async function telaRepasse(){
    mevTabSet('');
    $('secoes').innerHTML=_cadBack()+'<div class="info-pg"><h2>Lojistas de repasse</h2><p class="lj-hint">Sua agenda de lojistas parceiros que compram no repasse. Cadastre e mande as avaliações direto no WhatsApp deles.</p>'+
      '<div class="cli-top"><div class="cli-search">'+_icoBusca+'<input id="repBusca" placeholder="Buscar nome, cidade ou telefone" autocomplete="off"></div><button class="cli-novo" id="repNovoBtn">+ Novo</button></div>'+
      '<div id="repLista">'+skelHtml(4)+'</div></div>';
    $('telaHome').style.display='none'; document.body.classList.add('tela-interna'); document.body.classList.remove('md-veiculo'); $('cardVeiculo').style.display='block'; window.scrollTo(0,0); fabFoto(false); _cadWireBack(); voltarTab(voltarHome);
    $('repNovoBtn').onclick=function(){ repAbrirFicha(null); };
    $('repBusca').oninput=function(){ repPinta(this.value); };
    await repCarregar(); repPinta('');
  }
  var _repErro=false;
  async function repCarregar(){ _repErro=false; try{ var r=await withTimeout(supa.from('lojistas_repasse').select('*').order('nome',{ascending:true}),9000); _repasses=(r&&r.data)||[]; }catch(e){ _repasses=[]; _repErro=true; } }
  function repPinta(termo){
    var el=$('repLista'); if(!el) return; termo=(termo||'').toLowerCase().trim(); var td=termo.replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'');
    if(!_repasses.length && _repErro){ erroLista(el, async function(){ el.innerHTML=skelHtml(4); await repCarregar(); repPinta((($('repBusca')||{}).value)||''); }); return; }
    if(!_repasses.length){ el.innerHTML='<div class="cli-empty"><b>Nenhum lojista ainda</b>Toque em "+ Novo" para cadastrar o primeiro parceiro de repasse.</div>'; return; }
    var lista=_repasses.filter(function(c){ if(!termo) return true; var s=((c.nome||'')+' '+(c.cidade||'')).toLowerCase().indexOf(termo)>=0; var t=td&&String(c.telefone||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').indexOf(td)>=0; return s||t; });
    if(!lista.length){ el.innerHTML='<div class="cli-empty">Nada encontrado.</div>'; return; }
    el.innerHTML=lista.map(function(c){ var wa=cliWhatsUrl(c.telefone); var sub=[c.cidade,c.uf].filter(Boolean).join('/')||c.telefone||'-';
      return '<div class="cli-card" data-id="'+esc(c.id)+'"><div class="cli-av">'+esc(cliIni(c.nome))+'</div>'+
        '<div class="cli-tx"><div class="cli-nm">'+esc(c.nome||'Lojista')+'</div><div class="cli-sb">'+esc(sub)+'</div></div>'+
        (wa?'<button class="cli-wa" data-wa="'+esc(wa)+'" title="WhatsApp">'+_icoWa+'</button>':'')+
        '<div class="cli-chev">'+_icoChev+'</div></div>';
    }).join('');
    Array.prototype.forEach.call(el.querySelectorAll('.cli-card'),function(card){ card.onclick=function(e){ if(e.target.closest&&e.target.closest('[data-wa]')) return; repAbrirFicha(card.getAttribute('data-id')); }; });
    Array.prototype.forEach.call(el.querySelectorAll('[data-wa]'),function(bt){ bt.onclick=function(e){ e.stopPropagation(); var u=bt.getAttribute('data-wa'); if(u){ try{ window.open(u,'_blank'); }catch(_){ location.href=u; } } }; });
  }
  function repFormHtml(c){ c=c||{};
    return '<label class="cad-lbl">Nome da loja / comprador</label><input class="cad-in" id="rpNome" value="'+esc(c.nome||'')+'" placeholder="Ex.: Auto Center Sul">'+
      '<label class="cad-lbl">CNPJ (opcional — busca o nome)</label><input class="cad-in" id="rpCnpj" inputmode="numeric" value="'+esc(c.cnpj||'')+'" placeholder="00.000.000/0000-00">'+
      '<label class="cad-lbl">Telefone / WhatsApp</label><input class="cad-in" id="rpTel" inputmode="tel" value="'+esc(c.telefone||'')+'" placeholder="(00) 00000-0000">'+
      '<div class="cli-2col cid"><div><label class="cad-lbl">Cidade</label><input class="cad-in" id="rpCidade" value="'+esc(c.cidade||'')+'" placeholder="Cidade"></div><div><label class="cad-lbl">UF</label><input class="cad-in" id="rpUf" maxlength="2" value="'+esc(c.uf||'')+'" placeholder="UF"></div></div>'+
      '<label class="cad-lbl">Observações</label><textarea class="cad-in" id="rpObs" rows="3" placeholder="O que costuma comprar, região, faixa de preço...">'+esc(c.obs||'')+'</textarea>'+
      '<div class="cad-msg" id="rpMsg"></div><button class="cad-btn" id="rpSalvar" style="margin-top:6px">Salvar</button>';
  }
  function repWireForm(){
    var cnpj=$('rpCnpj'); if(cnpj){ cnpj.oninput=function(){ this.value=cnpjFmt(this.value); if(String(this.value).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'').length===14) repCnpjBusca(this.value); }; cnpj.addEventListener('blur',function(){ repCnpjBusca(this.value); }); }
    var tel=$('rpTel'); if(tel){ if(tel.value) tel.value=foneFmt(tel.value); tel.oninput=function(){ this.value=foneFmt(this.value); }; tel.addEventListener('paste',function(){ var el=this; setTimeout(function(){ el.value=foneFmt(el.value); },0); }); }
    var uf=$('rpUf'); if(uf){ uf.oninput=function(){ this.value=String(this.value||'').toUpperCase().replace(/[^A-Z]/g,'').slice(0,2); }; }
  }
  async function repCnpjBusca(v){ var d=String(v||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length!==14) return; var m=$('rpMsg'); if(m){ m.className='cad-msg'; m.textContent='Buscando dados do CNPJ...'; }
    var j=await cnpjFetch(d);
    if(!j){ if(m){ m.className='cad-msg'; m.textContent='Não achei o CNPJ. Pode preencher à mão.'; } return; }
    var nome=$('rpNome'); if(nome&&!nome.value&&(j.fant||j.razao)) nome.value=(j.fant||j.razao);
    if($('rpCidade')&&!$('rpCidade').value&&j.cidade) $('rpCidade').value=j.cidade;
    if($('rpUf')&&!$('rpUf').value&&j.uf) $('rpUf').value=j.uf;
    if($('rpTel')&&!$('rpTel').value&&j.tel) $('rpTel').value=foneFmt(String(j.tel));
    if(m){ m.className='cad-msg ok'; m.textContent='Dados encontrados ✓'; }
  }
  function repAbrirFicha(id){
    var bg=cliModalEl(); bg.classList.add('on');
    var c = id ? _repasses.filter(function(x){return String(x.id)===String(id);})[0] : null;
    _repEditId = c?c.id:null;
    $('cliMav').textContent=cliIni(c?c.nome:'+');
    $('cliMt').textContent = c ? (c.nome||'Lojista') : 'Novo lojista de repasse';
    $('cliMbody').innerHTML=repFormHtml(c)+(c?'<div id="rpExtra"></div>':'');
    repWireForm();
    $('rpSalvar').onclick=function(){ repSalvar(_repEditId); };
    if(c){
      var extra=$('rpExtra');
      extra.innerHTML=(cliWhatsUrl(c.telefone)?'<button class="cad-btn sec" id="rpWa" style="margin-top:10px">Abrir WhatsApp</button>':'')+
        '<button class="cad-btn sair" id="rpDel" style="margin-top:10px">Apagar lojista</button>';
      var wb=$('rpWa'); if(wb) wb.onclick=function(){ var u=cliWhatsUrl(c.telefone); if(u){ try{window.open(u,'_blank');}catch(_){location.href=u;} } };
      $('rpDel').onclick=function(){ repApagar(c.id); };
      cliModalDel(function(){ repApagar(c.id); });
    }
  }
  async function repSalvar(id){
    var m=$('rpMsg'); if(m) m.className='cad-msg';
    function gv(x){ var e=$(x); return e?(e.value||'').trim():''; }
    var nome=gv('rpNome'); if(!nome){ if(m){ m.className='cad-msg err'; m.textContent='Informe o nome do lojista.'; } return; }
    var reg={ nome:nome, cnpj:gv('rpCnpj'), telefone:gv('rpTel'), cidade:gv('rpCidade'), uf:gv('rpUf'), obs:gv('rpObs') };
    var btn=$('rpSalvar'); btn.disabled=true; btn.textContent='Salvando...';
    try{
      if(id){ reg.atualizado_em=new Date().toISOString(); var r=await supa.from('lojistas_repasse').update(reg).eq('id',id); if(r&&r.error) throw r.error; }
      else { reg.user_id=meuId; var r2=await supa.from('lojistas_repasse').insert(reg); if(r2&&r2.error) throw r2.error; }
      cliModalFechar(); await repCarregar(); repPinta((($('repBusca')||{}).value)||''); toast('Lojista salvo.');
    }catch(e){ if(m){ m.className='cad-msg err'; m.textContent='Não consegui salvar. '+((e&&e.message)||''); } btn.disabled=false; btn.textContent='Salvar'; }
  }
  async function repApagar(id){
    if(!id) return; if(!confirm('Apagar este lojista de repasse?')) return;
    try{ var r=await supa.from('lojistas_repasse').delete().eq('id',id); if(r&&r.error) throw r.error; cliModalFechar(); await repCarregar(); repPinta((($('repBusca')||{}).value)||''); toast('Lojista apagado.'); }
    catch(e){ toast('Não consegui apagar.'); }
  }

  var MEV_TEXTOS = {
    termos: { t:'Termos de Uso e Privacidade', h:
      '<section class="legal-info-doc"><h2>Termos de Uso</h2>'+legalTermosHtml()+'</section>'+
      '<section class="legal-info-doc"><h2>Política de Privacidade (LGPD)</h2>'+legalPrivacidadeHtml()+'</section>'+
      '<section class="legal-info-doc"><h2>Armazenamento e cookies</h2>'+legalCookiesHtml()+'</section>' },
    lgpd: { t:'Política de Privacidade (LGPD)', h:'<section class="legal-info-doc">'+legalPrivacidadeHtml()+'</section>' },
    suporte: { t:'Suporte', h:`
      <p>Precisa de ajuda, encontrou um erro ou quer sugerir algo? Fale com a gente pelo WhatsApp.</p>
      <div class="box sup-box">
        <a class="sup-wa" href="https://wa.me/5551996417433?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20o%20MEV%20Ve%C3%ADculos." target="_blank" rel="noopener" aria-label="Abrir o WhatsApp do suporte MEV">
          <span class="sup-ico sup-ico-wa"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.6a8.5 8.5 0 0 1-12.6 7.5L3 20.5l1.4-4.7a8.5 8.5 0 1 1 16.1-4.2Z"/><path d="M8.2 7.8c.3-.6.6-.6.9-.6h.3c.2 0 .4.1.5.4l1 2.1c.1.3.1.5-.1.7l-.7.8c-.2.2-.1.5 0 .7.7 1.2 1.7 2.2 3 2.8.3.1.5.1.7-.1l.8-1c.2-.2.4-.3.7-.2l2 .9c.3.1.4.3.4.6 0 .6-.3 1.5-.8 2-.5.6-1.4.9-2.2.9-1.2 0-3.2-.7-5.2-2.5-1.7-1.6-2.8-3.5-3-4.8-.2-1 .1-2 .7-2.7Z"/></svg></span>
          <span class="sup-tx"><b>WhatsApp do suporte</b><i>+55 51 99641-7433</i></span>
          <span class="sup-go" aria-hidden="true">›</span>
        </a>
        <p class="sup-horario"><b>Atendimento:</b> segunda a sexta, horário comercial.</p>
      </div>
      <!-- v321 (pedido): e-mail de atendimento ao lado do WhatsApp -->
      <div class="box sup-box">
        <a class="sup-wa" href="mailto:atendimento@mevplacas.com.br?subject=Ajuda%20com%20o%20MEV%20Ve%C3%ADculos" aria-label="Escrever para o e-mail de atendimento do MEV Veículos">
          <span class="sup-ico" style="background:#eef4fc;color:#0a4da6"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></span>
          <span class="sup-tx"><b>E-mail do atendimento</b><i>atendimento@mevplacas.com.br</i></span>
          <span class="sup-go" aria-hidden="true">›</span>
        </a>
        <p class="sup-horario">Respondemos em até 1 dia útil.</p>
      </div>
      <h3>Dúvidas comuns</h3>
      <div class="sup-faq-list">
        <details class="sup-faq">
          <summary>Meu saldo não entrou após o PIX</summary>
          <p>Aguarde até 1 minuto e atualize a tela. Se o saldo continuar igual, envie o comprovante e o e-mail da conta pelo WhatsApp do suporte.</p>
        </details>
        <details class="sup-faq">
          <summary>A placa ou consulta não foi encontrada</summary>
          <p>Confira os 7 caracteres da placa, sem espaços, e tente novamente. Uma base externa pode estar temporariamente indisponível; se persistir, mande a placa e uma captura da mensagem ao suporte.</p>
        </details>
        <details class="sup-faq">
          <summary>Não consegui importar um anúncio por link</summary>
          <p>Confirme se o anúncio ainda está ativo e abre normalmente sem login. Cole o endereço completo da página do veículo; se o site ainda não for compatível, envie o link ao suporte.</p>
        </details>
        <details class="sup-faq">
          <summary>Onde encontro uma consulta já feita?</summary>
          <p>Abra o histórico de consultas e use os filtros ou a busca por placa, CPF, CNPJ ou modelo. Reabrir um resultado salvo não gera uma nova cobrança.</p>
        </details>
        <details class="sup-faq">
          <summary>Como baixar as fotos do veículo?</summary>
          <p>Na ficha do veículo, abra <b>Fotos</b> e toque em <b>Baixar fotos</b>. Você pode salvar as imagens separadamente ou baixar tudo em um arquivo ZIP.</p>
        </details>
        <details class="sup-faq">
          <summary>Qual é a diferença entre plano e saldo?</summary>
          <p>O plano define a estrutura da loja, a quantidade de usuários e os veículos ativos. O saldo é usado separadamente nas consultas, leituras por IA e documentos.</p>
        </details>
        <details class="sup-faq">
          <summary>Como excluir minha conta e meus dados?</summary>
          <p>Abra <b>Meu cadastro › Acesso › Excluir minha conta</b>. Você confirma digitando EXCLUIR e pode cancelar por 24 horas. A execução respeita o período já pago; contratos e comprovantes financeiros podem ser conservados pelo prazo legal, com acesso restrito.</p>
        </details>
      </div>` },
    cadastro: { t:'Cadastro e conta', h:`
      <p>O aplicativo e gratuito. Voce cria a conta com e-mail e senha e so paga pelas consultas que usar.</p>
      <h3>Como criar</h3>
      <ul><li>Na tela inicial, toque em "Criar conta".</li><li>Informe um e-mail valido e uma senha de no minimo 6 caracteres.</li><li>Pronto: sua conta e seu historico ficam salvos e sincronizados nos seus aparelhos.</li></ul>
      <h3>Entrar em outro aparelho</h3>
      <p>Use o mesmo e-mail e senha. Seu saldo de creditos e seu historico aparecem automaticamente.</p>
      <h3>Esqueci a senha</h3>
      <p>Fale com o Suporte pelo WhatsApp para redefinir o acesso.</p>
      <h3>Encerrar a conta</h3>
      <p>Em <b>Meu cadastro › Acesso</b>, use <b>Excluir minha conta</b>. O pedido pode ser cancelado por 24 horas e também pode ser iniciado pelo site público mevveiculos.com.br/excluir-conta.</p>` },
    pagamentos: { t:'Uso e faturamento', h:`
      <section class="pag-hero">
        <div class="pag-hero-top">
          <span class="pag-hero-ico">${mkIco('grafico',20)}</span>
          <span class="pag-hero-tx"><small>Plano atual</small><b id="pagPlanoNome">Carregando…</b><i id="pagPlanoMeta">Consultando sua conta.</i></span>
          <span class="pag-status" id="pagPlanoStatus">—</span>
        </div>
        <div class="pag-saldo">
          <span><small>Saldo disponível</small><b><i id="pagSaldo">—</i></b></span>
          <button type="button" class="cad-fbtn" id="pagComprar">Adicionar saldo</button>
        </div>
      </section>

      <section class="pag-section">
        <div class="pag-section-head"><span>${mkIco('grafico',17)}<b>Uso atual</b></span><small>atualizado agora</small></div>
        <div class="pag-kpis" id="pagKpis"></div>
        <div class="pag-medidores" id="pagMedidores"></div>
        <button type="button" class="cad-btn sec pag-hist" id="pagHist">${mkIco('ficha',17)} Ver extrato de consultas</button>
      </section>

      <section class="pag-section pag-compra" id="pagPlanosSec">
        <div class="pag-section-head"><span>${mkIco('usuarios',17)}<b id="pagPlanosTitulo">Planos para a loja</b></span><small id="pagPlanosSub">estrutura e equipe</small></div>
        <p class="pag-intro" id="pagPlanosIntro">Usuários e estoque na mesma estrutura. Cada plano adiciona saldo mensal à carteira da loja. Consultas adicionais seguem no modelo pague pelo uso.</p>
        <div class="pag-planos" id="pagPlanos"></div>
        <button type="button" class="pag-ajuda" id="pagPlanoAjuda">Dúvidas sobre plano ou cobrança? Falar com o suporte</button>
      </section>

      <section class="pag-section pag-carteira" id="pagCarteiraSec" style="display:none">
        <div class="pag-section-head"><span>${mkIco('carteira',17)}<b>Carteira compartilhada da loja</b></span><small>controle de recarga</small></div>
        <div id="pagCarteiraBody"></div>
      </section>

      <section class="pag-section pag-compra">
        <div class="pag-section-head"><span>${mkIco('carteira',17)}<b>Recargas de saldo</b></span><small>pagamento seguro</small></div>
        <p class="pag-intro" id="pagPacotesIntro">As recargas entram na carteira da loja e são descontadas somente quando você usa um recurso pago.</p>
        <div class="pag-pacotes" id="pagPacotes"></div>
      </section>

      <section class="pag-section pag-consumo" id="pagConsumoSec">
        <div class="pag-section-head"><span>${mkIco('ficha',17)}<b>Consumo por recurso</b></span><small>antes de confirmar</small></div>
        <div class="pag-consumo-grid" id="pagConsumoLista">
          <div><span>Consulta FIPE</span><b>—</b></div>
          <div><span>Consulta Plus</span><b>—</b></div>
          <div><span>Consulta CPF</span><b>—</b></div>
          <div><span>Recurso IA</span><b>—</b></div>
        </div>
        <small class="pag-nota">O preço aparece na ação antes da cobrança. Se uma consulta paga falhar, o valor é devolvido ao saldo.</small>
      </section>` }
  };

  var ICO_PDF='<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>';
  function botaoPDF(){ return '<button type="button" data-acao="pdf" class="pdf-btn">'+ICO_PDF+' Baixar relatorio em PDF</button>'; }

  function relVeicMsgTxt(m){ if(!m) return ''; if(typeof m==='string') return m; return String(m.mensagem||m.descricao||m.texto||'').trim(); }
  /* extrai do relatorio completo os itens verificados + dados do veiculo (chassi mascarado) */
  /* LGPD: nome do proprietário só com iniciais + CPF/CNPJ parcial */
  function _maskNome(s){ s=String(s||'').trim(); if(!s) return ''; var p=s.split(/\s+/).filter(Boolean); if(p.length<2) return p[0]||''; return p[0]+' '+p.slice(1).map(function(w){ return (w[0]||'').toUpperCase()+'.'; }).join(' '); }
  function _maskDoc(s){ var d=String(s||'').replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''); if(d.length===11) return d.slice(0,3)+'.'+d.slice(3,4)+'**.***-**'; if(d.length===14) return '**.'+d.slice(2,5)+'.'+d.slice(5,8)+'/****-**'; return ''; }
  /* relatório completo como IMAGEM (bonito e sem expor dados pessoais crus) */
  function relInlineHtml(){ try{ var cv=relatorioCanvas(leilaoState, veiculoAtual||{}); return '<img src="'+cv.toDataURL('image/png')+'" alt="Relatório" style="width:100%;border-radius:14px;box-shadow:0 4px 16px rgba(2,20,60,.10);margin:4px 0">'; }catch(_){ return '<div class="plc-msg">Relatório gerado.</div>'; } }

  /* ==========================================================================
     🔴🔴 19/08 — NEGATIVA NÃO É ALERTA
     (PROJETO-consulta-plus, defeito 3 — e ele só apareceu porque o defeito 1
     caiu: até ontem o `valor` das informações avulsas vinha SEMPRE vazio, e
     campo vazio nunca acendia nada.)

     A regra antiga era: "tem valor e não contém NADA CONSTA → vermelho".
     Com o valor de volta, o DETRAN escreve coisas como
         "ALTERACAO DE CARACTERISTICA: NAO"
         "SITUACAO DO CHASSI: NORMAL"
     e as duas viravam alerta. **Alerta errado uma vez é pior que alerta
     nenhum**: o lojista para de acreditar justo na vez em que for verdade.

     COMO ELA LÊ: se o texto tem "RÓTULO: RESPOSTA", só a RESPOSTA decide.
     Depois compara com a lista de negativas — que é curta e explícita de
     propósito. ⚠️ Na dúvida, ela devolve "não é negativa" e o alerta acende:
     deixar de avisar é pior que avisar demais NESTE lado da conta (aqui o
     conteúdo veio escrito pelo DETRAN, não deduzido pelo app).
     ========================================================================== */
  var _AV_NEGATIVAS = ['nao','n','sem','nada','nada consta','nada a declarar','nada consta no momento',
    'inexistente','inexistentes','nenhum','nenhuma','negativo','nao consta','nao constam','nao ha',
    'nao possui','nao existe','isento','normal','regular','sem restricao','sem restricoes',
    'sem ocorrencia','sem ocorrencias','sem registro','sem registros','sem pendencia','sem pendencias',
    'sem debito','sem debitos','sem alteracao','sem alteracoes','0','00','false','-','--','n/a','na'];
  function _avSemAcento(s){
    return String(s==null?'':s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
  }
  function _avNegativa(val){
    var s = String(val==null?'':val).trim();
    if(!s) return true;
    /* "ALTERACAO DE CARACTERISTICA: NAO" → o que decide é o que vem DEPOIS
       dos dois-pontos. Sem isso, o rótulo (que sempre tem texto) fazia o
       campo parecer preenchido. */
    var i = s.lastIndexOf(':');
    if(i >= 0 && i < s.length-1) s = s.slice(i+1);
    s = _avSemAcento(s).replace(/[.\s]+$/,'').replace(/\s+/g,' ').trim();
    return _AV_NEGATIVAS.indexOf(s) >= 0;
  }

  /* ==========================================================================
     ⛳ 19/08 — INDÍCIO DE ALTERAÇÃO: COMBUSTÍVEL DE FÁBRICA × CADASTRO
     (PROJETO-consulta-plus, Fase 1 — o "encontra registro de alteração")

     ⚠️ SEJA HONESTO NA TELA: **o CSV não é consultável.** O Certificado de
     Segurança Veicular é emitido por ITL e fica com o proprietário e com o
     órgão; não existe base pública que devolva "tem CSV nº X". Prometer isso
     seria o jeito mais rápido de perder um lojista. O que dá pra fazer — e é
     muito — é achar o INDÍCIO cruzando o que já temos, e ENCAMINHAR.

     🔴 O RISCO Nº 1 AQUI É O FALSO POSITIVO POR VOCABULÁRIO. FIPE, DETRAN e
     ficha de fábrica escrevem a mesma coisa de três jeitos ("Flex",
     "Álcool/Gasolina", "Bicombustível", "Gasolina/Álcool"). Sem tabela de
     equivalência, o app grita "alteração!" em carro normal. Por isso a
     tabela abaixo É o coração deste bloco, não um detalhe.

     🔴🔴 E A REGRA É DE MÃO ÚNICA, DE PROPÓSITO: só acusa quando o CADASTRO
     tem um combustível que a FÁBRICA não tinha (GNV instalado, conversão
     para diesel). O contrário — fábrica flex, cadastro só "gasolina" — é
     abreviação de cartório, acontece o tempo todo, e acusar isso encheria a
     tela de alarme falso. Menos alarme e todos verdadeiros.

     ⚠️ O QUE NÃO ENTROU NESTA FASE, E POR QUÊ: potência e cilindradas. As
     duas comparações pedem tolerância numérica (cv × kW, arredondamento de
     cilindrada) e sem isso viram exatamente o falso positivo que este bloco
     existe pra evitar. Entram quando houver resposta real pra conferir.

     ⛳ ALT_COMBUSTIVEL = true — desligando, o bloco some inteiro e nada mais
     muda no relatório.
     ========================================================================== */
  var ALT_COMBUSTIVEL = true;
  /* cada combustível vira uma letra; um texto vira o CONJUNTO de letras.
     A = álcool/etanol · G = gasolina · D = diesel · V = GNV · E = elétrico */
  function _cbToken(p){
    p = _avSemAcento(p).replace(/[^a-z0-9]+/g,' ').trim();
    if(!p) return '';
    if(/^(flex|flexfuel|flex fuel|total flex|bi ?combustivel|bicombustivel|alcool gasolina|gasolina alcool|etanol gasolina|gasolina etanol)$/.test(p)) return 'AG';
    if(/^(gasolina|gas comum|gasolina comum|gasolina aditivada|gasol)$/.test(p)) return 'G';
    if(/^(alcool|etanol|alcool hidratado|etanol hidratado)$/.test(p)) return 'A';
    if(/^(diesel|oleo diesel|diesel s10|diesel s 10|diesel s500)$/.test(p)) return 'D';
    if(/^(gnv|gnc|gas natural|gas natural veicular|gas veicular|gas)$/.test(p)) return 'V';
    if(/^(eletrico|eletrica|ev|bev)$/.test(p)) return 'E';
    /* híbrido não diz QUAL combustível: não vira letra nenhuma, e por isso
       não gera nem acusação nem absolvição */
    return '';
  }
  function _cbSet(txt){
    var s = _avSemAcento(txt).trim();
    if(!s) return '';
    var set = {};
    s.split(/[\/,+&;·|]|\s+e\s+|\s+ou\s+/).forEach(function(p){
      var k = _cbToken(p);
      for(var i=0;i<k.length;i++) set[k[i]] = 1;
    });
    return Object.keys(set).sort().join('');
  }
  var _CB_NOME = { A:'álcool', G:'gasolina', D:'diesel', V:'GNV', E:'elétrico' };
  function _cbNomes(s){ return String(s||'').split('').map(function(c){ return _CB_NOME[c]||c; }).join(' + '); }
  /* o combustível DE FÁBRICA, tirado da ficha técnica que já está na memória */
  function _cbDeFabrica(){
    try{
      var ft = fichaTecState; if(!ft) return '';
      var b = (typeof _ftBloco==='function' ? _ftBloco(ft) : null) || ft;
      var mcs = Array.isArray(b.medicao_combustivel) ? b.medicao_combustivel : [];
      var txt = mcs.map(function(x){ return (x&&x.combustivel)||''; }).filter(Boolean).join('/');
      return _cbSet(txt || b.combustivel || '');
    }catch(_){ return ''; }
  }
  /* devolve o item pro relatório, ou null quando não dá pra afirmar nada */
  function _altCombustivel(cadastroTxt){
    if(!ALT_COMBUSTIVEL) return null;
    var fab = _cbDeFabrica();
    var cad = _cbSet(cadastroTxt);
    /* ⚠️ faltando qualquer um dos dois lados, NÃO inventa: sem ficha técnica
       não há com o que comparar, e um "nada consta" aqui seria mentira. */
    if(!fab || !cad) return null;
    var extras = cad.split('').filter(function(c){ return fab.indexOf(c) < 0; });
    if(!extras.length) return null;
    return { rot:'Indício de alteração no combustível',
             ruim:true,
             extra:'cadastro: '+_cbNomes(cad)+' · fábrica: '+_cbNomes(fab)+' — peça o CSV e o CRLV' };
  }
  function relVeicExtrai(rel){
    var raiz=(rel&&rel.data)||rel||{};
    var v=raiz.veicular||raiz||{};
    /* Compatibilidade: relatórios antigos podem ter a Base Nacional anexada.
       Novas Consultas Plus não usam essa fonte. */
    var nacRaw=(rel&&rel.__nacional)||{}, nacRaiz=(nacRaw&&nacRaw.data)||nacRaw||{};
    var nacV=nacRaiz.veicular||nacRaiz||{}, nacBin=nacV.bin_nacional||{};
    var temNacional=!!(nacV&&typeof nacV==='object'&&Object.keys(nacV).length);
    /* Consulta Estadual Consolidada (novo) ou BIN nacional (antigo) */
    var bin=v.bin_estadual||raiz.bin_estadual||v.bin_nacional||nacBin||{}; var restr=bin.restricoes||{}, nacRestr=nacBin.restricoes||{};
    /* dados técnicos da "Consulta e Análise Avançada" (agregados), quando juntada */
    var ag=raiz.agregados||v.agregados||(rel&&rel.agregados)||{};
    var n=function(x){ return parseInt(String(x==null?'':x).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,''),10)||0; };
    var sim=function(fl){ return n(fl)>0; };
    /* pendência de débito com valor (estrutura estadual: {existe_pendencia, valor_pendencia}) */
    function _brlp(s){ s=String(s==null?'':s).trim(); if(!s) return ''; return /^R\$/i.test(s)?s:('R$ '+s); }
    function pend(o){ o=o||{}; var tem=sim(o.existe_pendencia); return { tem:tem, val: tem?(_brlp(o.valor_pendencia)||'em aberto'):'' }; }
    var itens=[
      {rot:'Roubo / furto', ruim:sim(restr.existe_restricao_roubo_furto)||sim(nacRestr.existe_restricao_roubo_furto)},
      {rot:'Bloqueio judicial (RENAJUD)', ruim:sim(restr.existe_restricao_renajud)||sim(nacRestr.existe_restricao_renajud)||n((v.renajud||{}).quantidade_ocorrencias)>0||n((nacV.renajud||{}).quantidade_ocorrencias)>0},
      {rot:'Restricao geral', ruim:sim(restr.existe_restricao_geral)||sim(nacRestr.existe_restricao_geral)},
      {rot:'Financiamento / alienacao', ruim:sim(restr.existe_restricao_financiamento)},
      {rot:'Veiculo baixado', ruim:sim(restr.veiculo_baixado)||sim(nacRestr.veiculo_baixado)}
    ];
    if(restr.ipva||restr.licenciamento||restr.multas||restr.dpvat){
      /* ESTADUAL: débitos com valor */
      var ip=pend(restr.ipva), lic=pend(restr.licenciamento), mu=pend(restr.multas), dp=pend(restr.dpvat);
      itens.push({rot:'IPVA em aberto', ruim:ip.tem, extra:ip.val});
      itens.push({rot:'Licenciamento', ruim:lic.tem, extra:lic.val});
      itens.push({rot:'Multas', ruim:mu.tem, extra:mu.val});
      itens.push({rot:'DPVAT', ruim:dp.tem, extra:dp.val});
    } else {
      /* estrutura antiga (contagem) */
      var multas=n((v.renainf||{}).qtd_ocorrencias)||n((v.renainf||{}).quantidade_ocorrencia);
      var csv=n((v.csv||{}).quantidade_ocorrencia)||n((v.csv||{}).quantidade_ocorrencias);
      var recall=n((v.recall||{}).quantidade_ocorrencias)||n((v.recall||{}).quantidade_ocorrencia);
      itens.push({rot:'Multas / infracoes (RENAINF)', ruim:multas>0, extra:multas>0?(multas+' registro(s)'):''});
      itens.push({rot:'Certificado de Segurança Veicular (CSV)', ruim:csv>0, extra:csv>0?(csv+' registro(s)'):''});
      itens.push({rot:'Recall pendente', ruim:recall>0, extra:recall>0?(recall+' registro(s)'):''});
    }
    /* Mantém os indicadores nacionais só em relatórios históricos que já
       guardaram essa resposta. Sem fonte nacional, não mostra "nada consta". */
    if(temNacional){
      var nacMultas=n((nacV.renainf||{}).qtd_ocorrencias)||n((nacV.renainf||{}).quantidade_ocorrencia);
      var nacCsv=n((nacV.csv||{}).quantidade_ocorrencia)||n((nacV.csv||{}).quantidade_ocorrencias);
      var nacRecall=n((nacV.recall||{}).quantidade_ocorrencias)||n((nacV.recall||{}).quantidade_ocorrencia);
      var nacVenda=n((nacV.comunicado_venda||{}).quantidade_ocorrencias)||n((nacV.comunicado_venda||{}).quantidade_ocorrencia);
      itens.push({rot:'Multas / infracoes (RENAINF)', ruim:nacMultas>0, extra:nacMultas>0?(nacMultas+' registro(s)'):''});
      itens.push({rot:'Certificado de Segurança Veicular (CSV)', ruim:nacCsv>0, extra:nacCsv>0?(nacCsv+' registro(s)'):''});
      itens.push({rot:'Recall pendente', ruim:nacRecall>0, extra:nacRecall>0?(nacRecall+' registro(s)'):''});
      itens.push({rot:'Comunicado de venda', ruim:nacVenda>0, extra:nacVenda>0?(nacVenda+' registro(s)'):''});
    }
    (bin.informacoes_avulsas||[]).concat(nacBin.informacoes_avulsas||[]).forEach(function(a){
      var val=String(a.valor||'').trim(); var desc=String(a.descricao||'');
      if(/homolog|simulad/i.test(desc+' '+val)) return;   /* ignora ruído de homologação */
      if(/^https?:/i.test(val)) return;
      /* 🔴 19/08 — era `val!=='' && não contém NADA CONSTA`. Com o `valor` de
         volta (o corte do servidor deixou de apagá-lo), "ALTERACAO DE
         CARACTERISTICA: NAO" virava alerta vermelho. Ver o _avNegativa. */
      var ruim=!_avNegativa(val);
      var rot=desc.toLowerCase().replace(/(^|\s)\S/g,function(c){return c.toUpperCase();})||'Indicador';
      itens.push({rot:rot, ruim:ruim, extra:ruim?val:''});
    });
    /* ⛳ indício de alteração no combustível (fábrica × cadastro) */
    try{ var _alt=_altCombustivel(bin.combustivel||nacBin.combustivel||ag.combustivel||''); if(_alt) itens.push(_alt); }catch(_){}
    /* remove itens DUPLICADOS (ex.: "Licenciamento" vindo na lista fixa E nas infos
       avulsas da API). Se aparecer 2x, fica o que TEM pendência — nunca esconde problema. */
    (function(){
      var seen={}, dedup=[];
      itens.forEach(function(x){
        var k=String(x.rot||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]/g,'');
        if(seen[k]!=null){ var o=dedup[seen[k]]; if(x.ruim&&!o.ruim){ dedup[seen[k]]=x; } else if(x.extra&&!o.extra){ o.extra=x.extra; } return; }
        seen[k]=dedup.length; dedup.push(x);
      });
      itens=dedup;
    })();
    /* proprietário MASCARADO (LGPD): nome com iniciais e CPF/CNPJ parcial */
    var prop=v.proprietario||bin.proprietario||nacV.proprietario||nacBin.proprietario||{};
    var propNome=prop.nome||bin.nome_proprietario||nacBin.nome_proprietario||v.nome_proprietario||'';
    var propDoc=prop.documento||prop.cpf_cnpj||bin.documento_proprietario||nacBin.documento_proprietario||v.documento||'';
    var _anoFab=bin.ano_fabricacao||ag.ano_fabricacao||'', _anoMod=bin.ano_modelo||ag.ano_modelo||'';
    var _cilind=ag.cilindradas?((''+ag.cilindradas).replace(/,\d{1,2}\s*$/,'').replace(/\D/g,'')+' cc'):'';
    var dados=[
      ['Marca / modelo', bin.marca_modelo || [ag.marca,ag.modelo].filter(Boolean).join(' ')],
      ['Versao', ag.versao],
      ['Ano fab. / modelo', String(_anoFab)+(_anoMod?(' / '+_anoMod):'')],
      ['Motor', ag.motor_descricao], ['Cambio', ag.transmissao_descricao],
      ['Cor', bin.cor_veiculo||ag.cor], ['Combustivel', bin.combustivel||ag.combustivel],
      ['Cilindradas', _cilind], ['Portas', ag.quantidade_portas],
      ['Chassi', (bin.chassi||ag.chassi)?chassiMask(bin.chassi||ag.chassi):''], ['Renavam', bin.renavam||ag.renavam],
      ['Proprietario', prop.mascarado?propNome:_maskNome(propNome)], ['CPF/CNPJ', prop.mascarado?propDoc:_maskDoc(propDoc)],
      ['Municipio / UF', String(bin.municipio||ag.cidade||'')+((bin.uf||ag.uf_jurisdicao)?(' / '+(bin.uf||ag.uf_jurisdicao)):'')], ['Situacao', bin.situacao],
      ['Situacao chassi', bin.situacao_chassi], ['Procedencia', bin.procedencia||ag.nacionalidade],
      ['Potencia', bin.potencia_veiculo||ag.potencia], ['Passageiros', bin.quantidade_passageiros||ag.quantidade_lugares], ['Categoria', bin.categoria_veiculo]
    ];
    /* GRAVAME / financiamento (alienação fiduciária) — detalhes quando há restrição */
    var fin=restr.financiamento||{};
    var temGravame=sim(restr.existe_restricao_financiamento) || !!String(fin.nome_agente_financeiro||fin.numero_contrato||'').trim();
    var gravame=null;
    if(temGravame){
      function _g(x){ var s=String(x==null?'':x).trim(); return (s&&s!=='0'&&s.toLowerCase()!=='null')?s:''; }
      gravame=[
        ['Agente financeiro', _g(fin.nome_agente_financeiro)],
        ['Nº do contrato', _g(fin.numero_contrato)],
        ['Data de inclusão', _g(fin.data_inclusao)],
        ['Vigência do contrato', _g(fin.data_vigencia_contrato)],
        ['Tipo de restrição', _g(fin.tipo_restricao_financiamento)||_g(fin.tipo_transacao)],
        ['Financiado', _maskNome(_g(fin.nome_financiado))],
        ['CPF/CNPJ financiado', _maskDoc(_g(fin.cpf_cnpj_financiado))]
      ].filter(function(r){ return r[1]; });
    }
    return { temAlerta:itens.some(function(i){return i.ruim;}), itens:itens, dados:dados, msgs:(restr.mensagens_restricoes||[]).concat(nacRestr.mensagens_restricoes||[]).map(relVeicMsgTxt).filter(Boolean), temGravame:temGravame, gravame:gravame };
  }
  /* ======================================================================
     v595 — O PDF DO RELATÓRIO SAI DO KIT (Fase 1 do PDF Padrão MEV)
     ======================================================================
     O vetorial de 1 página (2 colunas, tudo espremido) foi APOSENTADO:
     agora o PDF são as MESMAS páginas do kit que a tela mostra — uma
     página A4 por canvas, quebra por bloco, rodapé com protocolo e
     pág. N de M. O código antigo morreu aqui de propósito (o desenho
     inteiro mora no relatorioPaginas do 05 + componentes do 06b). */
  function acaoGerarPDF(modo){
    modo=modo||'visualizar';
    if(!_mevPdfPronto(function(){ acaoGerarPDF(modo); },false)) return;
    toast('Gerando PDF...');
    try{
      var v=veiculoAtual||{}; var placa=String(v.placa||'consulta');
      var pags=relatorioPaginas(leilaoState, v);
      var _relBlob=kitPdfBlob(pags), _relNome='relatorio-'+placa.toLowerCase()+'.pdf';
      if(!_relBlob){ toast('O gerador de PDF não carregou. Tente de novo.'); return; }
      pdfArquivoAcao(_relBlob,_relNome,modo,function(){
        try{ relatorioVisor(kitPrevia(pags), _relBlob, _relNome); }
        catch(_){ pdfVisor(_relBlob, _relNome); }
      },'Consulta '+placa);
    }catch(e){ toast('Nao consegui gerar o PDF'); }
  }

  /* liga o menu lateral */
  (function(){
    try{
      var _drawer=$('mevDrawer'), _backdrop=$('mevDrawerBg');
      if(window.MEVAccessibility&&_drawer){
        _mevDrawerA11y=window.MEVAccessibility.criarMenu({
          drawer:_drawer,
          fundo:_backdrop,
          solicitarFechar:function(restaurarFoco){ drawerFechar(restaurarFoco); }
        });
      }
    }catch(_){}
    var mb=$('btnMenu'); if(mb) mb.onclick=drawerAbrir;
    /* v1104/v1146/v1147 — MEV Consultas e MEV Avaliações usam UM FAB de navegação. A v1104
       ainda abria três círculos lado a lado no primeiro toque; a v1146 leva
       Voltar, Início e Menu para a folha canônica de ações. Assim nenhum
       estado deixa vários FABs soltos sobre o conteúdo. */
    var _mfab=$('btnMenuFab'), _fabrow=$('fabRow');
    function _consultasDockPode(){
      /* v1146/v1147 — vale em TODA tela interna do MEV Consultas e do MEV
         Avaliações. `dock-barra`
         era uma whitelist visual do desktop, não uma regra do produto; usá-la
         aqui deixava páginas antigas voltarem aos FABs separados. */
      try{ return (document.body.classList.contains('ed-consultas') || document.body.classList.contains('ed-avalia') || document.body.classList.contains('conta-on')) && document.body.classList.contains('tela-interna'); }
      catch(_){ return false; }
    }
    function _consultasDockSet(aberto){
      try{
        document.body.classList.toggle('consultas-dock-aberto',!!aberto);
        if(_mfab){
          _mfab.setAttribute('aria-pressed','false');
          _mfab.setAttribute('aria-expanded','false');
          _mfab.setAttribute('aria-label','Abrir navegação');
          _mfab.setAttribute('aria-controls','mevDrawer');
          _mfab.setAttribute('aria-haspopup','menu');
          _mfab.setAttribute('title','Abrir navegação');
        }
        if(typeof consultaUiDockMedir==='function') consultaUiDockMedir();
      }catch(_){ }
    }
    function _consultasDockMenu(){
      if(!_mfab || typeof _popAbrir!=='function') return drawerAbrir();
      _consultasDockSet(false);
      var icoVoltar='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
      var icoInicio='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10M9 20v-6h6v6"/></svg>';
      var icoMenu='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>';
      var icoConsulta='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M8 11h6"/></svg>';
      var icoFoto='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h3l2-3h6l2 3h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"/><circle cx="12" cy="13" r="4"/></svg>';
      var icoHistorico='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/></svg>';
      var itens=[];
      var consultas=document.body.classList.contains('ed-consultas');
      if(consultas){
        itens.push(
          ['consulta',icoConsulta,'Consulta placa','consultas-nav-atalho','Atalhos','Dados do veículo e valor FIPE'],
          ['foto',icoFoto,'Ler placa por foto','consultas-nav-atalho','','Use a câmera ou a galeria'],
          ['historico',icoHistorico,'Histórico','consultas-nav-atalho','','Reabra resultados salvos']
        );
      }
      /* v1309 — a barra inferior do MEV Consultas já oferece Voltar e Menu.
         A folha mantém só os atalhos úteis, sem repetir a navegação. */
      if(!consultas){
        if(_voltarAlvo || document.body.classList.contains('tela-interna')) itens.push(['voltar',icoVoltar,'Voltar','','Navegação']);
        itens.push(['inicio',icoInicio,'Início',''],['menu',icoMenu,'Menu','']);
      }
      var produto=document.body.classList.contains('ed-avalia')?'MEV Avaliações':'MEV Consultas';
      if(document.body.classList.contains('conta-on')){
        produto='MEV Veículos';
        try{ var ei=(typeof window.edicaoInfo==='function')?window.edicaoInfo():null; if(ei&&ei.nome) produto=ei.nome; }catch(_){}
      }
      _popAbrir('<div class="act-head consultas-nav-head"><div class="ah-nm">'+(consultas?'Acesso rápido':'Navegação')+'</div><div class="ah-pl">'+produto+'</div></div>',itens,consultas?($('tbMenuBt')||_mfab):_mfab,function(k){
        try{ actSheetFechar(); }catch(_){}
        if(k==='consulta'){ drawerIr('buscaplaca'); return; }
        if(k==='foto'){
          try{ homeAtalhoClique('foto'); }catch(_){ var ff=$('btnFotoFab'); if(ff) ff.click(); }
          return;
        }
        if(k==='historico'){ drawerIr('historico'); return; }
        if(k==='voltar'){
          if(_voltarAlvo) _voltarAlvo();
          else voltarHome();
          return;
        }
        if(k==='inicio'){
          try{ if(typeof consultaResultadoTentarSair==='function' && consultaResultadoTentarSair(false)) return; }catch(_){}
          voltarHome(); return;
        }
        if(k==='menu') drawerAbrir();
      });
      try{ var cp=$('actPop'); if(cp&&consultas) cp.classList.add('consultas-nav-pop'); }catch(_){}
    }
    if(_mfab) _mfab.onclick=function(e){
      if(_consultasDockPode()){
        if(e){ e.preventDefault(); e.stopPropagation(); }
        _consultasDockMenu(); return;
      }
      drawerAbrir();
    };
    document.addEventListener('pointerdown',function(e){
      try{
        if(!document.body.classList.contains('consultas-dock-aberto')) return;
        if(_fabrow&&_fabrow.contains(e.target)) return;
        _consultasDockSet(false);
      }catch(_){ }
    },true);
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&document.body.classList.contains('consultas-dock-aberto')){
        _consultasDockSet(false);
      }
    },true);
    if(_fabrow) _fabrow.addEventListener('click',function(e){
      var b=e.target&&e.target.closest?e.target.closest('.menu-fab'):null;
      if(b&&b!==_mfab&&document.body.classList.contains('consultas-dock-aberto')) _consultasDockSet(false);
    });
    /* v754: na barra compacta o Voltar está sempre à vista — sem alvo, volta pra home */
    var _bkfab=$('btnBackFab'); if(_bkfab) _bkfab.onclick=function(){ if(_voltarAlvo) _voltarAlvo();
      /* v884 — o resultado da placa também tem a barra azul agora, e o Voltar
         dela precisava saber disso; sem esta linha o botão ficava mudo. */
      else if(document.body.classList.contains('consulta-ui-on')||document.body.classList.contains('resultado-veiculo-on')) voltarHome(); };
    var _acfab=$('btnAcaoFab'); if(_acfab) _acfab.onclick=function(){ if(_acfab._fn) _acfab._fn(); };
    /* v757: Estoque e Vendas na barra inferior das telas operacionais (02d) */
    var _esfab=$('btnEstoqueFab'); if(_esfab) _esfab.onclick=function(){ try{ telaEstoque(); }catch(_){} };
    var _vdfab=$('btnVendasFab'); if(_vdfab) _vdfab.onclick=function(){ try{ telaVendas(); }catch(_){} };
    /* v243: padrao R$ 0.000,00 — qualquer campo de dinheiro mostra os
       centavos quando voce sai dele; ao focar, eles somem pra digitar
       so os reais (preco de carro e' em reais inteiros). */
    document.addEventListener('focusin',function(e){ var t=e.target; if(t&&t.tagName==='INPUT'&&/^R\$\s?[\d.]+,\d{2}$/.test(t.value||'')) t.value=t.value.replace(/,\d{2}$/,''); },true);
    document.addEventListener('focusout',function(e){ var t=e.target; if(t&&t.tagName==='INPUT'&&/^R\$\s?[\d.]+$/.test(t.value||'')) t.value+=',00'; },true);
    /* v241: fab verde do print (consulta simples) na tela do veículo */
    var _prfab=$('btnPrintFab');
    if(_prfab) _prfab.onclick=function(){
      if(!veiculoAtual){ toast('Consulte a placa primeiro.'); return; }
      var it=null; try{ it=_histItem(veiculoAtual.placa); }catch(_){}
      if(!it) it={ placa:veiculoAtual.placa, modelo:((veiculoAtual.marca||'')+' '+(veiculoAtual.modelo||'')).trim(), v:veiculoAtual, ts:histFonteTs||0 };
      if(!it.v) it.v=veiculoAtual;
      histPrint(it);
    };
    /* FAB do PDF: aparece quando um resultado tem "Baixar em PDF" (o botão inline
       fica oculto por CSS). Clicar no FAB aciona o download daquele resultado. */
    (function(){
      var pf=$('btnPdfFab'), alvo=$('cardVeiculo'); if(!pf||!alvo) return;
      /* v184 — as telas com ABAS desenham TODOS os paineis de uma vez e escondem
         os que nao estao abertos. Entao "existe um botao de PDF na tela" nao
         basta: ele so' vale se estiver na aba ABERTA (.vpx-panel.on). */
      function _pdfOk(b){ var p=(b&&b.closest)?b.closest('.vpx-panel'):null; return !p || p.classList.contains('on'); }
      function _pdfAchar(){ var bs=alvo.querySelectorAll('.pdf-btn'); for(var i=0;i<bs.length;i++){ if(_pdfOk(bs[i])) return bs[i]; } return null; }
      pf.onclick=function(){ var b=_pdfAchar(); if(b) b.click(); };
      window._pdfFabSync=function(){ var vis=(alvo.style.display!=='none') && !!_pdfAchar(); pf.style.display=vis?'flex':'none'; };
      try{ new MutationObserver(window._pdfFabSync).observe(alvo,{childList:true,subtree:true}); }catch(_){}
      window._pdfFabSync();
    })();
    /* Dentro do MEVTOOLS (/placas): atalho no topo do menu pra voltar ao painel principal */
    try{
      if(/^\/placas(\/|$)/.test(location.pathname)){
        var _navV=document.querySelector('#mevDrawer .mdr-nav');
        if(_navV && !document.getElementById('mdrVoltaMev')){
          var aV=document.createElement('a');
          aV.id='mdrVoltaMev'; aV.href='/'; aV.className='mdr-volta';
          aV.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg> Voltar pro MEVTOOLS';
          _navV.insertBefore(aV, _navV.firstChild);
        }
      }
    }catch(_){}
    var mx=$('mevDrawerX'); if(mx) mx.onclick=drawerFechar;
    var mbg=$('mevDrawerBg'); if(mbg) mbg.onclick=drawerFechar;
    Array.prototype.forEach.call(document.querySelectorAll('#mevDrawer [data-acao]'),function(b){ b.onclick=function(){
      if(b.getAttribute('data-menu-destino')==='veiculares'){ homeConsultasVeicularesAbrir(); return; }
      drawerIr(b.getAttribute('data-acao'));
    }; });
    /* v1371 — atalhos do resumo móvel usam as mesmas rotas do drawer, mas
       ficam fora do inventário [data-acao] para não duplicar item ativo,
       contagem de grupo ou navegação por gesto. */
    Array.prototype.forEach.call(document.querySelectorAll('#mevDrawer [data-cons-atalho]'),function(b){ b.onclick=function(){
      drawerIr(b.getAttribute('data-cons-atalho'));
    }; });
    var _tb=$('mevTab');
    if(_tb){
      var _bh=_tb.querySelector('[data-tab="home"]'); if(_bh) _bh.onclick=function(){
        try{ if(typeof consultaResultadoTentarSair==='function' && consultaResultadoTentarSair(false)) return; }catch(_){}
        voltarHome(); };
      var _bc=_tb.querySelector('[data-tab="completa"]'); if(_bc) _bc.onclick=function(){ if(veiculoAtual){ abrirLeilao(); } else { voltarHome(); toast('Busque uma placa primeiro para a consulta de multa/restrições.'); var p=$('placa'); if(p){ try{ p.focus(); }catch(_){} } } };
      var _bhi=_tb.querySelector('[data-tab="hist"]'); if(_bhi) _bhi.onclick=function(){ abrirHistorico(); };
      var _bm=_tb.querySelector('[data-tab="menu"]'); if(_bm) _bm.onclick=function(){ drawerAbrir(); };
      var _bv=_tb.querySelector('[data-tab="voltar"]'); if(_bv) _bv.onclick=function(){ if(_voltarAlvo) _voltarAlvo(); };
      var _bctx=_tb.querySelector('[data-tab="ctx"]'); if(_bctx) _bctx.onclick=function(){ if(_bctx._fn) _bctx._fn(); };
    }
  })();

  /* ===== SEMPRE atualiza ao abrir ===== *
     Toda vez que o app abre (e ao voltar ao primeiro plano), ele confere no servidor
     se saiu versão nova e, se saiu, recarrega sozinho. Uma única constante MEV_BUILD
     é a fonte da verdade (basta trocá-la a cada versão). Evita o PWA do iPhone travar
     numa versão antiga. */
/* v259: este valor é CARIMBADO pelo montar.js com o ?v= do app.html — bumpe
   só o app.html (e o sw.js). Ficou em v256 por 3 versões e, como o app compara
   este número com o do servidor pra decidir se recarrega, ele nunca se
   atualizava sozinho. */
var MEV_BUILD='v1545';
  /* Contrato atual: atualização segura continua automática. O novo worker só
     assume depois de validar e gravar o shell completo. Cada aba decide quando
     recarregar pela régua abaixo; nenhuma outra aba consegue bloquear a
     ativação do pacote para sempre. */
  /* 🔴 v814 §8.7 — o rodapé recebe a versão vinda do MEV_BUILD
     (carimbado pelo montar.js com o ?v= do app.html), nunca um número escrito
     no HTML. */
  try{
    var _rp=document.querySelector('.mdr-rodape');
    if(_rp){
      var _rpVer='Versão '+String(MEV_BUILD).replace(/^v/i,'');
      /* v1409 — a assinatura institucional pertence ao fim do conteúdo
         rolável do menu. Ela não é uma barra fixa e, portanto, nunca cobre
         destinos nem permanece visível antes de a pessoa chegar ao fim. */
      if(typeof edicaoAtual==='function' && ['consultas','avalia'].indexOf(edicaoAtual())>=0){
        _rp.classList.add('mdr-rodape-info');
        _rp.hidden=false;
        _rp.removeAttribute('aria-hidden');
        _rp.innerHTML=(typeof mevConsultasRodapeHtml==='function'?mevConsultasRodapeHtml('menu'):'')+'<span class="mdr-rp-versao">'+_rpVer+'</span>';
        var _rpNav=document.querySelector('#mevDrawer .mdr-nav');
        if(_rpNav && _rp.parentNode!==_rpNav) _rpNav.appendChild(_rp);
      }else{
        _rp.textContent=_rpVer;
      }
    }
  }catch(_){}
  /* ===== 🔴 v640 — A ATUALIZAÇÃO VOLTA A SER AUTOMÁTICA, E CALADA =========
     Pedido do Angelo (25/08): "faca a atualizacao automatica sem avisar que
     tem atualizacao disponivel".

     A v594 tinha feito o contrário, também a pedido dele (22/08): barra azul
     "Atualização disponível" na tela, cartão nas Notificações, sino somando 1,
     e o recarregamento só no dedo. A v622 ainda gastou uma versão só pra
     achar um canto onde essa barra não cobrisse o conteúdo.

     🔴 POR QUE A DECISÃO VIROU, E POR QUE ISSO ESTÁ CERTO: o aviso oferecia
     uma escolha que não existe de verdade. Ficar na versão velha nunca é a
     opção boa — ela tem os defeitos que a nova consertou. Então o app
     perguntava, tomava a atenção de quem estava trabalhando, e a única
     resposta útil era "sim". Pergunta com uma resposta só não é escolha, é
     interrupção.

     ⚠️⚠️ MAS O MEDO DA v594 ERA LEGÍTIMO, E CONTINUA SENDO: recarregar no
     meio de um CPF digitado, de uma consulta paga em andamento ou de um
     cadastro pela metade **destrói trabalho de alguém**. Foi por isso que o
     recarregamento automático de antes tinha uma régua (o `_updSeguro`), e é
     por isso que ela VOLTA aqui — mais rigorosa que a original.

     A REGRA: a versão nova entra sozinha, mas só NUM MOMENTO SEGURO. Enquanto
     não houver momento seguro, ela espera — de 20 em 20 segundos, calada, o
     tempo que precisar. Ninguém perde nada, e ninguém é avisado de nada.

     O momento é seguro quando TUDO isto vale:
       1. nada digitado — nenhum campo da tela com texto dentro;
       2. nenhum campo com o cursor (o dedo não está no meio de uma frase);
       3. nenhum pedido na rede — consulta paga em andamento nunca é
          interrompida (é token do lojista indo embora);
       4. e ou a aba está OCULTA (o momento perfeito: ninguém vê nada), ou
          faz mais de 5 segundos que ninguém toca em nada.
     ======================================================================== */
  var _updPendente=null, _updIndo=false, _updRelogio=null;
  var _updRecarregou=false, _updRemoto=null, _updConsentiu=false;
  var _updAviso=null, _updAvisoAte=0, _updBotaoTimer=null;
  function _updDiagnostico(motivo,sw){
    // Buffer temporário só em memória: nenhuma query livre, conta ou formulário.
    var meta=document.querySelector('meta[name="mev-build"]');
    var ctl=navigator.serviceWorker && navigator.serviceWorker.controller;
    var ed=(typeof edicaoAtual==='function')?edicaoAtual():'completo';
    var item={html:meta?meta.content:null,js:MEV_BUILD,remoto:_updRemoto,
      cache:sw?sw.cache:null,controlador:ctl?new URL(ctl.scriptURL).pathname:null,
      estado:ctl?ctl.state:null,standalone:!!navigator.standalone||window.matchMedia('(display-mode: standalone)').matches,
      online:navigator.onLine,rota:'/app.html?app='+ed,motivo:motivo};
    var lista=window.mevVersaoDiagnostico||(window.mevVersaoDiagnostico=[]);
    lista.push(item);if(lista.length>30)lista.shift();
  }
  function _updSwEstado(){
    return new Promise(function(resolve){
      var ctl=navigator.serviceWorker && navigator.serviceWorker.controller;
      if(!ctl || typeof MessageChannel==='undefined'){resolve(null);return;}
      var ch=new MessageChannel(),fim=false;
      function done(v){if(fim)return;fim=true;ch.port1.close();resolve(v);}
      ch.port1.onmessage=function(e){done(e.data);};
      setTimeout(function(){done(null);},1500);
      ctl.postMessage({mev:'version'},[ch.port2]);
    });
  }
  function _updRecarregar(forcar){
    if(_updRecarregou || (!forcar&&!_updConsentiu&&!_updSeguro())) return;
    var alvo=String(_updPendente||'sw');
    /* O marcador antigo durava a sessão inteira: se uma única recarga caísse
       outra vez no shell velho, todas as tentativas seguintes eram recusadas.
       Agora ele só impede o laço imediato e libera nova tentativa após 15 s. */
    try{
      var marca=String(sessionStorage.getItem('mev_reload_build')||'').split('|');
      if(marca[0]===alvo && Date.now()-Number(marca[1]||0)<15000){_updDiagnostico('recarga-imediata-recusada');return;}
      sessionStorage.setItem('mev_reload_build',alvo+'|'+Date.now());
    }catch(_){}
    if(_updBotaoTimer){clearTimeout(_updBotaoTimer);_updBotaoTimer=null;}
    _updRecarregou=true;_updDiagnostico('troca-segura');
    location.reload();
  }

  /* ==========================================================================
     🔴🔴 v1046 — O AVISO SÓ APARECE ONDE ELE SERVE PRA ALGUMA COISA
     --------------------------------------------------------------------------
     Pedido do Angelo (16/09): "a mensagem de atualização só aparece quando o
     usuário estiver numa tela diferente da inicial. Na tela inicial, ou
     abrindo o app, ele já atualiza automaticamente sem o usuário perceber."

     E ele está certo sobre o porquê. O aviso existe por UM motivo só: **não
     interromper trabalho em andamento**. Na tela inicial não há trabalho em
     andamento — há um campo de placa vazio e uma lista de histórico. Avisar
     ali é tomar a atenção de alguém para uma decisão que não muda nada.

     A REGRA NOVA, em duas linhas:
       · FORA da inicial  → se não dá pra trocar em silêncio, AVISA;
       · NA inicial       → nunca avisa: troca calada assim que der, e espera
                            calada enquanto não der.

     ⚠️ "TROCA CALADA" NÃO VIROU "TROCA A QUALQUER CUSTO". Consulta paga na
     rede, aria-busy e formulários continuam barrando. Desde a v1311, somente
     a placa canônica da Home é descartável: depois de 3 segundos sem interação
     ela não prende uma versão antiga, mesmo preenchida ou com foco.

     ⚠️ A VÁLVULA DOS 10 MINUTOS continua como recuperação para outros estados
     inesperados que possam manter a Home ocupada. Versão velha em silêncio
     eterno é pior que um aviso.

     ⚠️ QUEM RESPONDE "ESTOU NA INICIAL" É A CLASSE `tela-interna` DO BODY.
     Ela é posta por toda tela interna e tirada pelo voltarHome — é o mesmo
     sinal que o dock e o CSS já usam. Não inventar um segundo marcador: dois
     marcadores para a mesma coisa é garantia de que um dia eles discordam.
     ⚠️ O resultado da placa (`md-veiculo`) TAMBÉM põe `tela-interna`, e isso
     é certo: um relatório na tela é trabalho, e ali o aviso vale.
     ========================================================================== */
  var _updEsperaDesde=0;
  var UPD_VALVULA_MS=10*60*1000;
  function _updNaInicial(){
    try{ return !document.body.classList.contains('tela-interna'); }
    catch(_){ return false; }   /* na dúvida, trata como tela interna (avisa) */
  }
  function _updPodeAvisar(){
    if(!_updNaInicial()) return true;
    if(!_updEsperaDesde) return false;
    return (Date.now()-_updEsperaDesde) > UPD_VALVULA_MS;
  }

  /* --- v1011: aviso somente quando não é seguro recarregar sozinho ------- */
  function _updAvisoFechar(adiar){
    if(adiar) _updAvisoAte=Date.now()+2*60*1000;
    if(_updBotaoTimer){clearTimeout(_updBotaoTimer);_updBotaoTimer=null;}
    if(!_updAviso) return;
    _updAviso.classList.remove('on');
    var el=_updAviso;_updAviso=null;
    setTimeout(function(){if(el.parentNode)el.parentNode.removeChild(el);},220);
  }
  function _updAvisar(forcar){
    if(!_updPendente || _updRecarregou || _updAviso || (!forcar&&Date.now()<_updAvisoAte)) return;
    var n=_updNumero(_updPendente), el=document.createElement('aside');
    el.id='mevUpdateAviso';el.className='mev-update-aviso';el.setAttribute('role','dialog');
    el.setAttribute('aria-labelledby','mevUpdateTitulo');
    el.innerHTML='<div class="mev-update-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6v5h-5"/><path d="M4 18v-5h5"/><path d="M18.5 9A7 7 0 0 0 6 6.5L4 9"/><path d="M5.5 15A7 7 0 0 0 18 17.5l2-2.5"/></svg></div><div class="mev-update-copy"><strong id="mevUpdateTitulo">Nova versão disponível</strong><span>'+(n?'Versão '+n+' pronta para instalar.':'Uma melhoria do app está pronta.')+'</span></div><div class="mev-update-acoes"><button type="button" class="mev-update-agora">Atualizar agora</button><button type="button" class="mev-update-depois">Depois</button></div>';
    document.body.appendChild(el);_updAviso=el;
    requestAnimationFrame(function(){if(_updAviso===el)el.classList.add('on');});
    el.querySelector('.mev-update-depois').onclick=function(){_updAvisoFechar(true);};
    el.querySelector('.mev-update-agora').onclick=function(){
      _updConsentiu=true;_updIndo=false;
      var b=el.querySelector('.mev-update-agora');b.disabled=true;b.textContent='Atualizando…';
      updAtualizarAgora(true);
      if(_updBotaoTimer) clearTimeout(_updBotaoTimer);
      _updBotaoTimer=setTimeout(function(){
        _updBotaoTimer=null;
        if(_updRecarregou || _updAviso!==el) return;
        _updIndo=false;
        b.disabled=false;b.textContent='Tentar novamente';
        var copy=el.querySelector('.mev-update-copy span');
        if(copy) copy.textContent='Não foi possível concluir. Verifique a internet e tente novamente.';
        _updDiagnostico('atualizacao-nao-concluida');
      },12000);
    };
  }

  /* --- 3. o contador de pedidos na rede -----------------------------------
     🔴 Envolver o `fetch` da janela é intrusivo, então é feito UMA vez, com
     rede de proteção em toda saída: se qualquer coisa der errado aqui, o
     `fetch` original é devolvido intacto. O contador só SOMA e SUBTRAI — ele
     nunca decide nada sozinho, nem atrasa nenhuma resposta. */
  var _updRede=0;
  (function(){
    try{
      var _f=window.fetch;
      if(typeof _f!=='function') return;
      window.fetch=function(){
        var p; _updRede++;
        try{ p=_f.apply(this, arguments); }
        catch(e){ _updRede--; throw e; }
        if(!p || typeof p.then!=='function'){ _updRede--; return p; }
        return p.then(function(r){ _updRede--; return r; },
                      function(e){ _updRede--; throw e; });
      };
    }catch(_){}
  })();

  /* --- 4. o último toque --------------------------------------------------
     Só marca a hora; nenhum trabalho no caminho do dedo. `passive` e
     `capture` pra pegar o evento antes de qualquer coisa parar ele. */
  var _updUltimoToque=0;
  try{
    ['pointerdown','keydown','wheel','touchstart'].forEach(function(ev){
      document.addEventListener(ev, function(){ _updUltimoToque=Date.now(); }, { passive:true, capture:true });
    });
  }catch(_){}

  /* --- a régua ------------------------------------------------------------ */
  /* ==========================================================================
     \U0001f534\U0001f534 v669 — "AJUSTE PRO APP ATUALIZAR SOZINHO" (pedido do Angelo)
     --------------------------------------------------------------------------
     MEDIDO ANTES DE MEXER, e o número não deixa dúvida: com a tela inicial
     aberta e nada digitado, `_updSeguro()` respondia **true**. Bastou UM campo
     preenchido dentro de uma tela ESCONDIDA pra virar **false** — e ficar
     false pra sempre.

     \U0001f511 POR QUE ISSO ACONTECE O DIA INTEIRO: as telas deste app não são
     apagadas quando fecham, elas ficam escondidas. A ficha do estoque, o
     cadastro do cliente, a conferência do Mercado — todas continuam no ar com
     os campos preenchidos do último uso. A regra 1 varria TODOS os campos da
     página, visíveis ou não, e qualquer um com texto dizia "não é hora".
     Resultado: depois de abrir uma ficha uma única vez no dia, o app parava de
     se atualizar até ser fechado e aberto na mão. Que é exatamente o que ele
     estava vendo.

     ✅ DUAS CORREÇÕES, E AS DUAS SÃO SOBRE A MESMA IDEIA — o que a regra queria
     proteger é TRABALHO EM ANDAMENTO, e trabalho em andamento está na tela:

       1. Campo que a pessoa NÃO ESTÁ VENDO não segura mais a atualização.
          Ninguém digita no que não vê, e o que estava escrito lá ou já foi
          salvo (a ficha do estoque salva sozinha) ou é rascunho de uma tela
          que ela mesma fechou.

       2. Aba escondida é hora segura, e a conta dos campos nem chega a rodar.
          Se o app está em segundo plano, não existe ninguém digitando —
          discutir campo ali era discutir o vento. Este é o momento em que a
          troca é INVISÍVEL, e era justamente o que a regra velha bloqueava.

     ⚠️ O QUE NÃO MUDOU, E É O QUE IMPORTA: pedido em andamento (consulta,
     pagamento, salvamento) continua barrando tudo; o cursor dentro de um campo
     continua barrando; campo VISÍVEL com texto continua barrando; e com a tela
     à vista ainda são exigidos 5 segundos sem toque. O app continua sem
     recarregar na cara de ninguém — ele só parou de esperar por uma tela que
     ninguém está olhando.
     ========================================================================== */
  /* um campo "à vista" é o que ocupa lugar na tela. `getClientRects` é usado no
     lugar de `offsetParent` de propósito: elemento com `position:fixed` tem
     offsetParent nulo mesmo estando bem na frente da pessoa. */
  function _updAVista(el){
    try{
      if(!el.getClientRects || el.getClientRects().length===0) return false;
      return getComputedStyle(el).visibility!=='hidden';
    }catch(_){ return true; }   /* na dúvida, trata como visível (mais cauteloso) */
  }
  function _updSeguro(){
    try{
      var naInicial=_updNaInicial();
      /* 3. consulta/pagamento/salvamento em andamento: nunca */
      if(_updRede>0) return false;
      /* 4. aba oculta é sempre bom momento — e nem precisa olhar campo */
      // Segundo plano não torna rascunhos, pagamentos ou uploads seguros.
      if(document.querySelector('[aria-busy="true"]')) return false;
      /* 2. o cursor está dentro de um campo */
      var a=document.activeElement;
      /* v1311 — a placa é o único rascunho descartável da Home. Ela não pode
         prender uma versão antiga para sempre, mas a pausa abaixo evita
         recarregar enquanto a pessoa ainda está digitando. Qualquer outro
         campo, inclusive login e cadastro, conserva a proteção integral. */
      if(a && (a.tagName==='INPUT' || a.tagName==='TEXTAREA' || a.isContentEditable) &&
         !(naInicial && a.id==='placa')) return false;
      /* 1. campo À VISTA com texto dentro — mesmo sem foco.
         ⚠️ caixinha de marcar e campo escondido não contam: eles não guardam
         trabalho de ninguém (e o app nasce com vários preenchidos). */
      var campos=document.querySelectorAll('input,textarea,select,[contenteditable="true"]');
      for(var i=0;i<campos.length;i++){
        var c=campos[i], t=(c.tagName||'').toUpperCase(), tp=String(c.type||'').toLowerCase();
        if(t==='SELECT'){
          var opts=Array.from(c.options),hasDefault=opts.some(function(o){return o.defaultSelected;});
          if(opts.some(function(o,i){return o.selected!==(hasDefault?o.defaultSelected:!c.multiple&&i===0);}))return false;
          continue;
        }
        if(tp==='file' && c.files && c.files.length) return false;
        if((tp==='checkbox'||tp==='radio') && c.checked!==c.defaultChecked) return false;
        if(t==='INPUT' && (tp==='hidden'||tp==='checkbox'||tp==='radio'||tp==='submit'||tp==='button'||tp==='file')) continue;
        /* Campo de uma tela escondida nunca é trabalho em andamento. A regra
           anterior só ignorava o invisível quando value===defaultValue; uma
           ficha aberta horas antes podia, portanto, travar versões para sempre. */
        if(!_updAVista(c)) continue;
        if(naInicial && c.id==='placa') continue;
        var v=(t==='INPUT'||t==='TEXTAREA') ? String(c.value||'') : String(c.textContent||'');
        if(v.replace(/\s/g,'').length>0) return false;
      }
      /* v1311 — na Home, espera só uma pausa curta. Assim uma versão pendente
         entra automaticamente mesmo com a placa preenchida, sem atualizar no
         meio da digitação. Telas internas conservam os 5 s originais. */
      if(naInicial) return (Date.now()-_updUltimoToque) > 3000;
      return (Date.now()-_updUltimoToque) > 5000;
    }catch(_){ return false; }   /* na dúvida, NÃO recarrega */
  }

  /* --- o recarregamento em si (o mesmo caminho que o botão da v594 usava) -- */
  function updAtualizarAgora(forcar){
    if(_updIndo || (!forcar&&!_updConsentiu&&!_updSeguro())) return;
    if(forcar) _updConsentiu=true;
    _updIndo=true;
    if(!navigator.serviceWorker){_updIndo=false;return;}
    navigator.serviceWorker.getRegistration('/').then(async function(reg){
      if(!reg){_updIndo=false;return;}
      await reg.update().catch(function(){});
      if(reg.waiting){
        reg.waiting.postMessage('skipWaiting');
        // Só controllerchange autoriza recarga, nunca um timer de instalação.
      }else{
        var state=await _updSwEstado();
        if(state && _updNumero(state.build)>_updNumero(MEV_BUILD)){
          _updPendente=state.build;_updRecarregar(!!forcar);
        }
      }
    }).catch(function(){}).then(function(){
      /* v1046 — o forçado dos 6 s também respeita a inicial: `true` aqui
         pulava a espera do _updAvisoAte, não a regra da tela. */
      setTimeout(function(){_updIndo=false;if(_updPendente&&!_updRecarregou&&_updPodeAvisar())_updAvisar(true);_updAplicar();},6000);
    });
  }

  /* --- a espera calada ---------------------------------------------------- */
  function _updAplicar(){
    if(!_updPendente || _updIndo) return;
    if(!_updEsperaDesde) _updEsperaDesde=Date.now();   /* v1046: começa a contar a válvula */
    if(_updConsentiu){ updAtualizarAgora(true); return; }
    if(_updSeguro()){ updAtualizarAgora(); return; }
    if(_updPodeAvisar()) _updAvisar(false);
    /* ainda não dá: tenta de novo daqui a pouco. O aviso explica a espera e
       o relógio preserva a atualização automática quando a tela ficar segura.
       ⚠️ UM relógio só — senão cada checagem de versão criaria mais um e o
       app acabaria com dezenas deles rodando juntos. */
    if(_updRelogio) return;
    _updRelogio=setInterval(function(){
      if(!_updPendente || _updIndo){ clearInterval(_updRelogio); _updRelogio=null; return; }
      if(_updSeguro()){ clearInterval(_updRelogio); _updRelogio=null; updAtualizarAgora(); return; }
      /* v1046 — é ESTE tique que faz o aviso nascer quando a pessoa sai da
         inicial com uma versão esperando, e que abre a válvula dos 10 min. */
      if(_updPodeAvisar()) _updAvisar(false);
    }, 5000);
  }
  /* v658 — o número de dentro de "v649". Devolve 0 quando não dá pra ler,
     e é esse 0 que faz a comparação sair de cena em vez de travar tudo. */
  function _updNumero(v){
    try{ var m=String(v||'').match(/v?(\d+)/); return m?Number(m[1]):0; }catch(_){ return 0; }
  }
  /* v715 — o SW que acabou de assumir é mais novo que ESTA página?
     O nome do cache dele é mevplacas-vNNN; compara com o MEV_BUILD daqui.
     Na dúvida (sem API, nome ilegível), responde SIM — recarregar à toa é
     chato, misturar app velho com cache novo é o splash em loop da v586. */
  function _updSwMaisNovo(){
    return _updSwEstado().then(function(state){
      _updDiagnostico('controlador',state);
      if(!state) return false;
      var meta=document.querySelector('meta[name="mev-build"]');
      if(meta && meta.content!==MEV_BUILD && _updNumero(state.build)>=_updNumero(MEV_BUILD)){
        _updDiagnostico('conflito-html-js',state);_updPendente=state.build;return true;
      }
      if(_updNumero(state.build)>_updNumero(MEV_BUILD)){_updPendente=state.build;return true;}
      return false;
    });
  }
  function _mevChecaVersao(){
    try{
      /* v265: pergunta pro versao.json (~30 bytes) em vez de baixar o app.js
         inteiro (280 KB) a cada 2 minutos. Ver o comentário no montar.js. */
      fetch('versao.json?_v='+Date.now(), { cache:'no-store' }).then(function(r){
        /* 🔴 v648 — O RELÓGIO DO SERVIDOR, DE GRAÇA. Celular com data errada
           acontece mais do que parece, e o selo "NOVO" (05d) compara datas: com
           o relógio torto a pessoa veria a novidade pra sempre ou nunca.
           Esta resposta já vem de dois em dois minutos e traz a hora certa no
           cabeçalho — então o app só guarda o DESVIO entre os dois relógios.
           ⚠️ Nenhum pedido a mais na rede por causa disto. */
        try{
          var _d=Date.parse(r.headers.get('date')||'');
          if(_d) window.mevDesvioHora=_d-Date.now();
        }catch(_){}
        return r.ok?r.json():null; }).then(function(j){
        var m=(j&&j.build)?[null,String(j.build)]:null;
        _updRemoto=j&&j.build?String(j.build):null;
        _updDiagnostico('versao-remota');
        if(!(m && m[1] && m[1]!==MEV_BUILD)) return;
        /* 🔴🔴 v658 — "DIFERENTE" NÃO É "MAIS NOVA". ESTA LINHA CUSTOU CARO.
           Em 26/08 o `versao.json` no ar estava congelado em **v631** (cache
           de borda, consertado no netlify.toml) enquanto o app do Angelo já
           era **v649**. O `!==` de cima achou uma diferença e concluiu
           "saiu versão nova" — pra uma versão DEZOITO NÚMEROS ATRÁS.
           Resultado: o app ficava tentando "atualizar" pra trás, recarregava,
           voltava a ser v649, perguntava de novo, recebia v631 de novo… um
           vai-e-vem que nunca termina e que, de fora, parece exatamente
           "o app não está atualizando".
           ✅ A régua só manda quando aponta pra FRENTE. Se o número do ar for
           menor ou igual, o app não faz nada — servidor com resposta velha
           não pode empurrar o aparelho pra trás.
           ⚠️ E o `!==` continua valendo quando NÃO dá pra ler número dos dois
           lados: um formato que eu não previ não pode travar a atualização
           pra sempre. Comparar quando dá; confiar na diferença quando não dá. */
        var _nAr=_updNumero(m[1]), _nAqui=_updNumero(MEV_BUILD);
        if(!_nAr || !_nAqui || _nAr<=_nAqui){_updDiagnostico('remota-antiga-ou-invalida');return;}
        _updPendente=m[1];
        _updAplicar();
      }).catch(function(){});
    }catch(_){}
  }
  _mevChecaVersao();
  try{ setTimeout(function(){ try{ notifBadgeAtualiza(); }catch(_){} }, 5000); }catch(_){}
  /* O badge é apenas informativo: evita consultas quando o app está oculto. */
  try{ setInterval(function(){ try{ if(!document.hidden) notifBadgeAtualiza(); }catch(_){} }, 120000); }catch(_){}
  setInterval(_mevChecaVersao, 2*60*1000);   /* confere de 2 em 2 minutos com o app aberto */
  /* 🔴 v640 — sair da aba e voltar são os dois melhores momentos: ao SAIR
     ninguém vê a troca acontecer, e ao VOLTAR o app já abre novo. */
  try{ document.addEventListener('visibilitychange', function(){
    if(document.hidden){ _updAplicar(); return; }
    _mevChecaVersao(); notifBadgeAtualiza();
  }); }catch(_){}
  /* no COMPUTADOR a janela raramente fica "oculta" — então confere também ao clicar/voltar pra janela */
  try{ window.addEventListener('focus', function(){ _mevChecaVersao(); }); }catch(_){}
  if('serviceWorker' in navigator){
    /* 🔴 v640: o SW novo volta a assumir sozinho (o skipWaiting voltou pro
       install do sw.js). Quando ele assume, o `controllerchange` dispara —
       e aí a página precisa recarregar, senão fica um app velho rodando em
       cima de um cache novo (a mistura que já deu splash em loop na v586).
       ⚠️ A PRIMEIRA INSTALAÇÃO passa direto: nunca houve controller antes,
       não há versão velha pra trocar, e recarregar ali seria um susto à toa
       na primeira vez que alguém abre o app. */
    var _swTinhaControle=!!navigator.serviceWorker.controller;
    /* ==========================================================================
       🔴 v715 (relato do Angelo, 29/08): "ATUALIZOU AO ABRIR E DEPOIS DE UNS
       20 A 30 SEGUNDOS TA ATUALIZANDO DE NOVO"
       --------------------------------------------------------------------------
       O filme do defeito: na abertura o versao.json aponta versão nova e o
       app recarrega NA HORA — e como app.html/app.js são rede-primeiro no
       sw.js, essa recarga JÁ ENTREGA o app novo. Só que o SW novo ainda está
       INSTALANDO (baixa os ASSETS todos — 20-30s no celular); quando termina
       e assume, o controllerchange disparava e recarregava DE NOVO uma página
       que já era a versão dele. A segunda atualização era à toa.
       ✅ Antes de recarregar, pergunta ao cache QUAL versão o SW carrega
       (o nome do cache é mevplacas-vNNN) e compara com esta página:
       só recarrega quando o SW é MAIS NOVO — a mistura perigosa (app velho
       sobre cache novo, o splash em loop da v586) continua coberta.
       (A função mora logo acima do bloco do SW, no nível do _updSeguro.) */
    navigator.serviceWorker.addEventListener('controllerchange', function(){
      _swTinhaControle=true;
      _updSwMaisNovo().then(function(maisNovo){
        if(!maisNovo) return;   /* v715: a página já é a versão do SW — nada a fazer */
        if(_updIndo){_updRecarregar(_updConsentiu);return;}
        _updAplicar();
      });
    });
    /* v742 — o sw.js agora entrega app.js/styles.css do cache e confere a rede
       POR TRÁS. Quando o arquivo mudou sob o mesmo ?v= (publicação sem bump),
       ele avisa {mev:'arquivo-novo'}: vira versão pendente e recarrega no
       momento calmo — o mesmo caminho do versao.json, nada de susto. */
    try{ navigator.serviceWorker.addEventListener('message', function(e){
      if(e.data && e.data.mev==='update-safe' && e.source){
        e.source.postMessage({mev:'update-safe-reply',id:e.data.id,safe:_updConsentiu||_updSeguro()});return;
      }
      try{ if(e && e.data && e.data.mev==='arquivo-novo'){ _updPendente=_updPendente||'sw-arquivo'; _updAplicar(); } }catch(_){}
    }); }catch(_){}
    /* v742 — reg.update() devolve uma promessa; quando a aba fecha no meio ela
       REJEITA ("InvalidStateError") e virava erro solto no console (e teste
       intermitente). Agora a rejeição é engolida — o try/catch só pegava o
       erro síncrono. */
    navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'}).then(function(reg){
      // Remove só registros legados reconhecidos do MEV, nunca workers alheios.
      navigator.serviceWorker.getRegistrations().then(function(regs){
        regs.forEach(function(other){
          var worker=other.active||other.waiting||other.installing;
          if(other.scope===reg.scope || !worker)return;
          if(/^\/(?:mev-avaliacoes\/|mev-consultas\/)?sw\.js$/.test(new URL(worker.scriptURL).pathname)){
            other.unregister().then(function(){_updDiagnostico('registro-legado-removido');}).catch(function(){_updDiagnostico('registro-legado-pendente');});
          }else _updDiagnostico('registro-extra-nao-removido');
        });
      }).catch(function(){});
      _updSwMaisNovo().then(function(newer){if(newer)_updAplicar();});
      try{ var _u=reg.update(); if(_u && _u.catch) _u.catch(function(){}); }catch(_){}
      try{ document.addEventListener('visibilitychange', function(){ if(!document.hidden){ try{ var _u=reg.update(); if(_u && _u.catch) _u.catch(function(){}); }catch(_){} } }); }catch(_){}
      try{ window.addEventListener('focus', function(){ try{ var _u=reg.update(); if(_u && _u.catch) _u.catch(function(){}); }catch(_){} }); }catch(_){}
      try{ setInterval(function(){ try{ var _u=reg.update(); if(_u && _u.catch) _u.catch(function(){}); }catch(_){} }, 5*60*1000); }catch(_){}
      /* SW novo instalado e esperando (celular que ainda vinha da v594):
         manda ele assumir e trata como versão pendente. */
      function _swEsperando(){ try{ if(reg.waiting && navigator.serviceWorker.controller){
        _updPendente=_updPendente||'sw'; _updAplicar(); } }catch(_){} }
      _swEsperando();   /* já tinha um esperando de antes? resolve na abertura */
      reg.addEventListener('updatefound', function(){
        var nw=reg.installing; if(!nw) return;
        nw.addEventListener('statechange', function(){ if(nw.state==='installed'){ _swEsperando(); } });
      });
    }).catch(function(){});
  }

  /* ===== v277 — RECEBER UMA PLACA POR LINK (vindo do MEVTOOLS) =====
     O MEVTOOLS tinha uma tela de avaliação própria, aposentada na prática desde
     31/07 (últimas 44 avaliações lá; de lá pra cá é tudo aqui). Ela continuava
     aberta e podia gerar, por engano, um link no domínio errado — com a oferta
     do lojista caindo numa tabela que não conversa com mais nada.

     Fechamos a porta: lá o botão passa a APONTAR PRA CÁ. Pra isso o app precisa
     saber receber a placa pelo endereço:

         .../app.html?placa=ABC1D23&ir=avaliacao

     REGRA DE OURO: NUNCA CONSULTAR SOZINHO. Consulta custa token do Angelo.
     Se a placa já está no histórico dele, abro na hora, de graça. Se não está,
     eu só DEIXO ESCRITA no campo de busca — quem decide gastar é ele. */
  (function(){
    var _jaFez=false;
    function _params(){
      try{ return new URLSearchParams(location.search||''); }catch(_){ return null; }
    }
    function _tentar(){
      if(_jaFez) return true;
      var q=_params(); if(!q) return true;                 /* navegador velho: desiste calado */
      /* v1487 — `?consulta=&p=` abre a página paga certa sem passar pelo
         `?placa=` histórico, que pertence à consulta FIPE. A lista fechada
         impede que o endereço invoque qualquer ação arbitrária. */
      var destinoConsulta=String(q.get('consulta')||'').toLowerCase();
      var querConsulta=['especialjud'].indexOf(destinoConsulta)>=0;
      var pl=String(querConsulta?q.get('p'):(q.get('placa')||'')).toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);
      if(pl.length<7) return true;                          /* não é pra mim */
      if(!document.body.classList.contains('app-on')) return false;  /* ainda no login: espera */
      _jaFez=true;
      if(querConsulta){
        try{ history.replaceState(null,'',urlSemParams('consulta','p','de')); }catch(_){}
        try{
          consIr(destinoConsulta,pl);
          setTimeout(function(){ try{ toast('Placa '+pl+' pronta — confira e toque em Consultar.'); }catch(_){} },180);
        }catch(_){}
        return true;
      }
      /* tira os parâmetros da barra de endereço: se ele recarregar a página,
         não quero repetir a ação nem deixar a placa exposta no endereço */
      /* 🔴 v881 — era `location.pathname`, e isso varria a query INTEIRA:
         junto com a placa ia embora o `?app=consultas`, e o app virava o MEV
         Placas completo em silêncio (ver a nota longa no `urlSemParams` do
         01-nucleo). Agora saem só os dois parâmetros que são desta função. */
      try{ history.replaceState(null,'',urlSemParams('placa','ir')); }catch(_){}
      var querAvaliacao = /avalia/i.test(String(q.get('ir')||''));
      var temNoHistorico = false;
      try{ var it=histLer().filter(function(x){ return x.placa===pl; })[0]; temNoHistorico=!!(it && it.v); }catch(_){}
      if(temNoHistorico){
        try{ abrirSalva(pl); }catch(_){ return true; }
        if(querAvaliacao){
          /* espera a tela da placa montar antes de pular pra avaliação */
          setTimeout(function(){ try{ abrirAvaliacaoLojista(); }catch(_){} }, 260);
        }
        return true;
      }
      /* não tenho essa placa: deixo pronta e explico. Não gasto o token dele. */
      try{ voltarHome(); }catch(_){}
      try{
        var campo=$('placa');
        if(campo){
          campo.value=pl;
          campo.scrollIntoView({behavior:'smooth',block:'center'});
          setTimeout(function(){ try{ campo.focus(); }catch(_){} }, 300);
        }
        if(typeof toast==='function') toast('Placa '+pl+' pronta — toque em Buscar para consultar.');
      }catch(_){}
      return true;
    }
    /* o login pode demorar; tenta por até ~30s e desiste */
    if(!_tentar()){
      var n=0, iv=setInterval(function(){
        n++;
        if(_tentar() || n>60) clearInterval(iv);
      }, 500);
    }
  })();

  /* ============= v283 — TOCOU NUM VALOR, JÁ VEM SELECIONADO =============
     Pedido: "quando clicar em algum valor pra editar, já deixe pré
     selecionado, só digitar pra editar". Antes era preciso apagar dígito por
     dígito um "R$ 145.900,00" pra trocar por outro número.

     Por que UM ouvinte só, no documento inteiro, em vez de ligar campo a
     campo: os campos de dinheiro nascem e morrem o tempo todo (cada tela
     remonta o HTML). Ligando um por um, todo campo novo que nascer amanhã
     viria sem isso — e ninguém ia lembrar. Assim vale pra todos, pra sempre.

     Como sei que é campo de dinheiro sem ter que marcar nada: o valor começa
     com "R$". Nenhum outro campo do app escreve assim. */
  (function(){
    if(!document || !document.addEventListener) return;
    document.addEventListener('focusin', function(ev){
      var e=ev&&ev.target;
      if(!e || e.tagName!=='INPUT') return;
      if(e.readOnly || e.disabled) return;
      if(!/^\s*R\$/.test(String(e.value||''))) return;   /* só dinheiro JÁ preenchido */
      /* O iPhone posiciona o cursor DEPOIS do focus. Sem esperar um instante
         ele desfaz a seleção, e a pessoa volta a apagar dígito por dígito. */
      setTimeout(function(){
        if(document.activeElement!==e) return;
        try{ e.setSelectionRange(0, String(e.value||'').length); }
        catch(_){ try{ e.select(); }catch(__){} }
      }, 0);
    }, true);
  })();

  /* ===== v586 — O SINAL DE VIDA DO app.js ==================================
     Última linha do último módulo, de propósito: só executa se o app.js
     INTEIRO carregou e rodou sem erro fatal. É este sinal que o vigia do
     splash (script inline no app.html) espera. Sem ele, o vigia conclui que
     o app.js morreu (arquivo não veio, cache estragado, CDN do supabase
     fora — o createClient do 01 estoura e derruba o IIFE inteiro) e troca a
     animação infinita por "Tentar de novo". Se este sinal mudar de nome,
     mude JUNTO no app.html. */
  try{ window.__mevBoot=1; }catch(_){}
  try{ _passo('js-executado'); }catch(_){}   /* v735: fim de ler+executar o app.js (FASE 5.0) */

})();
